{
  "claims": [
    {
      "id": "2dd13f4f-6426-4ac8-bd65-7ffb771370ad",
      "text": "COVID-19 vaccines are causing excess deaths worldwide, and Sudden Adult Death Syndrome is a new condition caused by the vaccines.",
      "date": "2023-01-04 00:00:00+00:00"
    },
    {
      "id": "f8b55df6-b25d-46c9-8f4f-c5c18799922d",
      "text": "Bisphenol A in food causes health problems.",
      "date": "2023-01-23 00:00:00+00:00"
    },
    {
      "id": "6699828d-fb58-4517-baf8-bd0a114db78f",
      "text": "Germany has erected a fence separating vaccinated and unvaccinated people, and insanity is the primary symptom of COVID-19.",
      "date": "2021-12-07 00:00:00+00:00"
    },
    {
      "id": "e27cdb49-5cc6-4d83-b740-fed69da1a64a",
      "text": "700 tanks located in occupied eastern Ukraine are spoils of war.",
      "date": "2017-02-19 15:25:10"
    },
    {
      "id": "fbade069-95a0-4972-bade-52d4ac0638d8",
      "text": "EuroMOMO data show excess deaths in children aged 0–14, and the excess deaths in Europe are not explained by COVID-19.",
      "date": "2023-01-23 00:00:00+00:00"
    },
    {
      "id": "a3c090d0-0f8c-4dbd-aa26-87ca72378ff7",
      "text": "Authorities in Kyiv staged a provocation and blamed Moscow for everything.",
      "date": "2018-11-26 15:22:58"
    },
    {
      "id": "d6814ea5-c714-48f3-818f-cdcb5b6381e0",
      "text": "The European Parliament accuses Petro Poroshenko of political repression.",
      "date": "2016-07-18 18:08:29"
    },
    {
      "id": "30728e5f-3db1-4c1c-befe-fbd1f7103a82",
      "text": "COVID-19 vaccination during pregnancy provides no benefit and causes higher neonatal and all-cause readmission rates in babies born to vaccinated mothers.",
      "date": "2023-11-05 00:00:00+00:00"
    },
    {
      "id": "8d8470bd-ad2d-4dd4-adf5-eba8481b1e3a",
      "text": "Ukraine's language police are reviving the Great Terror.",
      "date": "2020-12-06 10:48:18"
    },
    {
      "id": "4de477ea-5b7b-45a2-be59-cf9bec7b2733",
      "text": "The hero from the video about the Azovets children's camp died in the war.",
      "date": "2024-04-20 10:02:00"
    },
    {
      "id": "3e5ff83b-0092-4c6a-b1d4-b3d8665c952a",
      "text": "The Armed Forces of Ukraine used OSCE video camera data to correct artillery fire.",
      "date": "2022-04-20 12:12:49"
    },
    {
      "id": "bdc1437f-ed3b-4d98-b2c1-38d4365c70e6",
      "text": "WHO data shows ivermectin reduces COVID-19 mortality by 81% and WHO will not recommend it.",
      "date": "2021-04-13 00:00:00+00:00"
    },
    {
      "id": "d8d7bab0-1ed1-4bdf-8ccb-706d4da8ae8d",
      "text": "Human-produced carbon is a factor in climate change, but it is not a significant one.",
      "date": "2019-11-09 00:00:00+00:00"
    },
    {
      "id": "29d4d54d-b45f-428f-9434-a2dbdbf76fdf",
      "text": "Poland is leaving the European Union.",
      "date": "2018-11-15 01:22:23"
    },
    {
      "id": "0424510d-cbfe-45c9-b03c-be316dbc1185",
      "text": "The Crimean Tatar Mejlis was created by the United States.",
      "date": "2016-10-04 15:08:36"
    },
    {
      "id": "3e01682a-99db-4588-812c-77898c084078",
      "text": "Czech President Petr Pavel said Ukraine should cede territories to survive.",
      "date": "2025-08-04 00:00:00+00:00"
    },
    {
      "id": "735326d8-274b-43f4-bede-c04b3f51ff7b",
      "text": "Food supplements restore perfect blood sugar levels and cure Type 2 diabetes.",
      "date": "2022-06-02 00:00:00+00:00"
    },
    {
      "id": "57794fdf-6b32-4749-8b39-f7099cf8b282",
      "text": "DNA in COVID mRNA vaccines alters the human genome; SV40 causes cancer in humans; regulatory agencies knew about contamination.",
      "date": "2023-06-23 00:00:00+00:00"
    },
    {
      "id": "255a4d2c-14ee-4bb3-88c2-3d03d8e031cf",
      "text": "Harry Hoxsey's herbal therapy cures cancer.",
      "date": "2022-12-10 00:00:00+00:00"
    },
    {
      "id": "3026b8de-985a-42c8-9ae3-d374746eedcc",
      "text": "Ukrainian blood is being sold.",
      "date": "2018-03-28 11:54:43"
    },
    {
      "id": "1d8fae5b-ecc0-45be-ab13-eac5e4e79825",
      "text": "Taking acetaminophen during pregnancy causes autism in children.",
      "date": "2022-07-18 00:00:00+00:00"
    },
    {
      "id": "633ba20e-618f-46e5-ae02-75a3ffa9d1d7",
      "text": "Zinc supplements protect against COVID-19; zinc kills the virus; zinc ionophores transport zinc from outside cells into cells.",
      "date": "2022-01-18 00:00:00+00:00"
    },
    {
      "id": "ab0f775b-320d-44f7-ae2e-848211e10868",
      "text": "Hungarians living in Ukraine are experiencing genocide.",
      "date": "2023-04-16 18:01:00"
    },
    {
      "id": "2361b0b7-d4fb-48be-a1a3-3f8003756366",
      "text": "Vaccines are toxic, they do not prevent transmission, and vaccinated children are less healthy than unvaccinated children.",
      "date": "2021-01-13 00:00:00+00:00"
    },
    {
      "id": "9d2a365a-6c46-411b-969d-d47a368e94ee",
      "text": "A Russian was the only person who defended passers-by in a Sydney suburb.",
      "date": "2024-04-15 16:14:00"
    },
    {
      "id": "f00ef639-900e-41c6-8781-9b27223d4353",
      "text": "Spain lost all its mobile networks after rejecting Russian hardware.",
      "date": "2025-05-20 00:00:00+00:00"
    },
    {
      "id": "7eb3a987-b322-44d2-b3d6-28c94d19b5d2",
      "text": "The Czech Republic does not recognize Russia's annexation of Crimea.",
      "date": "2014-03-28 11:48:58"
    },
    {
      "id": "2dea096c-fd10-4480-803d-899cf695c6f5",
      "text": "Cancer incidence has sharply increased, particularly female breast cancer among people aged 45 and under.",
      "date": "2023-06-18 00:00:00+00:00"
    },
    {
      "id": "c83fc427-5b49-4136-ac63-a6e82c9a6e68",
      "text": "Neo-fascists in Lviv beat an elderly woman who placed flowers at a Lenin monument.",
      "date": "2014-03-07 09:21:47"
    },
    {
      "id": "25e64931-13f1-49ca-bc59-c9b3ea3df04a",
      "text": "Thalidomide was rapidly approved in 1957 to treat nausea and insomnia in pregnant women, was marketed in many countries, and was withdrawn in 1962 because it caused malformations in newborns.",
      "date": "2020-04-12 00:00:00+00:00"
    },
    {
      "id": "ac7a6f3c-0121-4422-b49f-f6891df024f0",
      "text": "An Italian journalist is missing in Donbas.",
      "date": "2019-01-11 09:05:46"
    },
    {
      "id": "5d4a7f9d-370a-43f6-90d8-da41fa28b5bd",
      "text": "Researchers have perfected inserting human vaccines into certain foods, and grocery vegetables contain human vaccines.",
      "date": "2024-01-03 00:00:00+00:00"
    },
    {
      "id": "3f39fca1-a59d-4b69-90c6-21f814dc1270",
      "text": "Ukraine will become a nuclear waste dump.",
      "date": "2018-04-23 22:00:05"
    },
    {
      "id": "a4ec243a-71a4-4609-9a28-20d5f55f2c22",
      "text": "Both medical and non‑medical face masks do not reduce COVID‑19 transmission or infectivity, and long‑term mask wearing causes harmful health effects including hypoxemia and hypercapnia.",
      "date": "2021-04-23 00:00:00+00:00"
    },
    {
      "id": "dd4e8c50-a762-41da-9994-99bdacd1c496",
      "text": "At least 15 million Ukrainians maintain strong ties with Russia.",
      "date": "2022-03-15 13:46:00"
    },
    {
      "id": "6eb1ba10-7e64-4410-8b77-b1f6131ff9d4",
      "text": "Omicron subvariant XBB.1.5 is more likely to infect vaccinated people.",
      "date": "2023-01-14 00:00:00+00:00"
    },
    {
      "id": "38e14696-6be8-4733-897c-92ef59e9e984",
      "text": "Vaccinated people carry 251 times more SARS‑CoV‑2 virus in their nostrils than unvaccinated people.",
      "date": "2021-08-26 00:00:00+00:00"
    },
    {
      "id": "f3ebd398-1ed0-4277-a8e8-14809c410ad5",
      "text": "A Bild journalist died after publishing an article about Ukraine’s military operation in the Kursk region.",
      "date": "2024-08-19 20:19:53"
    },
    {
      "id": "938f6495-4d57-4ad6-94ce-863e8c50767c",
      "text": "Federal agencies knew hydroxychloroquine and chloroquine were effective against COVID-19 based on a 2014 paper.",
      "date": "2022-07-11 00:00:00+00:00"
    },
    {
      "id": "ff5ceed9-e757-4049-9059-07cabd2cf427",
      "text": "Raising gut serotonin increases brain serotonin.",
      "date": "2023-09-30 00:00:00+00:00"
    },
    {
      "id": "75b46fa0-cd0c-47a1-ab63-254ba2048ab1",
      "text": "Childhood vaccines contain formaldehyde, aluminum, aborted fetal DNA, fetal bovine serum, monkey kidney cells, mercury, and pig circoviruses.",
      "date": "2024-03-03 00:00:00+00:00"
    },
    {
      "id": "b24a8a34-1afb-4438-a723-682fc5881418",
      "text": "Brzezinski said U.S. intelligence services murdered Nemtsov.",
      "date": "2015-03-15 20:17:16"
    },
    {
      "id": "85054e1d-aaca-4e4b-a973-d45747596c08",
      "text": "Some vaccines contain tissue from aborted fetuses.",
      "date": "2024-07-05 00:00:00+00:00"
    },
    {
      "id": "72b56f8d-ad65-499b-a35f-204e110ed4f9",
      "text": "SightCare restores perfect 20/20 vision without glasses, contacts, or surgery.",
      "date": "2024-05-01 00:00:00+00:00"
    },
    {
      "id": "67c33492-0941-478a-b43b-9c6c098446b3",
      "text": "Russians demand autonomy.",
      "date": "2015-05-27 16:46:30"
    },
    {
      "id": "14495f04-0a36-463e-8cac-99aaad053837",
      "text": "President Joe Biden said COVID-19 vaccines protect people from hurricanes.",
      "date": "2022-07-10 00:00:00+00:00"
    },
    {
      "id": "f5ef64d6-4fc0-47d8-82b5-1d1453009204",
      "text": "Both vaccinated and unvaccinated people have over 99% chance of surviving COVID-19.",
      "date": "2021-07-21 00:00:00+00:00"
    },
    {
      "id": "f3805476-152f-4654-8435-8e4eda6f5ca1",
      "text": "Flu shots given to pregnant women caused a 4,250% increase in fetal deaths reported to VAERS.",
      "date": "2019-12-31 00:00:00+00:00"
    },
    {
      "id": "6f4ce223-338f-4a9d-86ba-d7426feb6a92",
      "text": "Transcarpathia demands autonomy from Kyiv.",
      "date": "2016-04-08 22:36:10"
    },
    {
      "id": "16b242fa-af97-47e6-8018-f63b40206b6d",
      "text": "Ukrainian naval ships are frozen in ice and cannot sail.",
      "date": "2017-01-26 19:01:05"
    },
    {
      "id": "a716ca45-b87f-4206-a22b-5e39e95ad953",
      "text": "A court ruled that COVID-19 mRNA vaccines are not vaccines.",
      "date": "2024-06-17 00:00:00+00:00"
    },
    {
      "id": "eae4b366-03da-41ec-a57a-cdebad1dee6f",
      "text": "Veterans exchanged their military medals for food in Chernihiv.",
      "date": "2015-05-06 21:12:37"
    },
    {
      "id": "55cdc9d6-c77c-4770-86bf-4cdba85c8b07",
      "text": "A Lancet study showed COVID-19 vaccines suppress the immune system and vaccinated people have lower immune function than unvaccinated people.",
      "date": "2022-07-21 00:00:00+00:00"
    },
    {
      "id": "4d14b98b-05d6-4e63-a6ba-271d2f3cce83",
      "text": "Ukraine’s state gas company Naftogaz is wrecking negotiations with Gazprom and blackmailing Russia.",
      "date": "2019-10-31 12:16:21"
    },
    {
      "id": "99f1aea2-02cf-4c31-88f9-42d9a3852e82",
      "text": "HPV vaccine causes autoimmune diseases, menstrual cycle problems, and fertility problems.",
      "date": "2019-05-15 00:00:00+00:00"
    },
    {
      "id": "48a13c83-219f-4cd9-b810-08909a8bf658",
      "text": "Ukraine lost $1 billion by signing a contract with an American weapons store.",
      "date": "2025-10-27 00:00:00+00:00"
    },
    {
      "id": "83d96580-7bb0-4e87-89df-9c881df71f99",
      "text": "A Maidan activist is seeking work in Russia.",
      "date": "2015-04-01 00:13:35"
    },
    {
      "id": "1fcaf67b-c9d4-4a01-84e7-ca7f4a7e821b",
      "text": "Human CO2 emissions do not drive recent climate change; the Sun and natural climate cycles drive most recent climate changes.",
      "date": "2022-03-03 00:00:00+00:00"
    },
    {
      "id": "f4764696-2605-4a43-b5a6-6bbf1d924003",
      "text": "Ukrainians are denied entry to Bulgaria despite visa-free travel.",
      "date": "2017-06-30 21:04:56"
    },
    {
      "id": "a5abfd89-4a0f-415f-aaf0-91910c09c87c",
      "text": "Kyiv tattoo studio offers free removal of tattoos bearing US symbols",
      "date": "2024-04-18 10:30:00"
    },
    {
      "id": "33680438-c7ab-4fcd-a771-3945d3bef0f7",
      "text": "Masks are dirty and cause bacterial overgrowth, skin infections, and “mask mouth,” a new medical condition caused by wearing masks all day.",
      "date": "2020-09-28 00:00:00+00:00"
    },
    {
      "id": "a3b34be8-6b96-4f4e-a354-cc5b2da887d5",
      "text": "Solar panels overrun farmland, toxify soil with heavy metals, and require 300-600 times more land than other energy sources.",
      "date": "2025-01-23 00:00:00+00:00"
    },
    {
      "id": "6d400d4d-0b03-4ed8-be63-42efcf94ad65",
      "text": "Ukraine incites war in Donbas to cause new sanctions on Russia",
      "date": "2021-03-15 21:15:12"
    },
    {
      "id": "c3634205-e3fe-4f6e-9305-71a997a86f33",
      "text": "Ivanka Trump admires Russian traditional values and the beauty and style of Russian women.",
      "date": "2025-04-04 00:00:00+00:00"
    },
    {
      "id": "e22c321d-c58f-4c33-bf80-69feae1815b9",
      "text": "Donetsk militants seized two Ukrainian GRAD rocket launchers.",
      "date": "2014-05-10 16:23:47"
    },
    {
      "id": "24666e81-30f7-49a8-859c-d475e369c574",
      "text": "A court ruled that the FDA broke the law by warning against using ivermectin for COVID-19, the FDA lost the lawsuit, and ivermectin is effective against COVID-19.",
      "date": "2024-03-22 00:00:00+00:00"
    },
    {
      "id": "014c9faf-7ab9-40e4-b5e2-ab52af450862",
      "text": "Poroshenko claims he is the reincarnation of both a Cossack and a nationalist leader.",
      "date": "2016-01-12 19:06:29"
    },
    {
      "id": "421e076f-843a-48a5-9a05-70bd6ce8be1f",
      "text": "Ukraine's Parliament passed a law allowing expired products to be sold to consumers.",
      "date": "2018-12-15 11:50:00"
    },
    {
      "id": "1774fac9-00c5-4fe7-b984-d6e29f173b3b",
      "text": "A tongue that deviates to one side indicates a stroke.",
      "date": "2013-03-04 00:00:00+00:00"
    },
    {
      "id": "9980c0d2-1404-49fb-a64d-b383664e39f9",
      "text": "The European Union called the free trade zone with Ukraine useless.",
      "date": "2016-03-31 21:57:10"
    },
    {
      "id": "7ee5a1fa-d164-4c90-a9aa-bf34d284a6bc",
      "text": "The COVID-19 RNA vaccine is not a vaccine; vaccines must disrupt transmission according to CDC and FDA standards; the COVID-19 RNA vaccine activates cells to become pathogen-manufacturing sites.",
      "date": "2021-12-01 00:00:00+00:00"
    },
    {
      "id": "a4765b18-7063-46d8-81d8-8476b2372331",
      "text": "Spanish researchers found that over 99% of the Pfizer COVID-19 vaccine is graphene oxide.",
      "date": "2021-07-05 00:00:00+00:00"
    },
    {
      "id": "9658b913-ceca-47ae-aad5-58877e1f4129",
      "text": "Kyiv shut off water to Luhansk and did not provide an explanation.",
      "date": "2017-12-08 18:24:40"
    },
    {
      "id": "48a2defa-2a7d-41ab-9978-ec2d542176bb",
      "text": "Wuhan coronavirus outbreak was caused by people eating bats.",
      "date": "2020-01-26 00:00:00+00:00"
    },
    {
      "id": "6c59ffd2-ce73-48cc-a300-744f6681f391",
      "text": "Poland will close its border with Ukraine",
      "date": "2017-06-25 17:11:49"
    },
    {
      "id": "1b076485-e52c-4e15-83fa-3b97314161ad",
      "text": "Ukraine is a police state.",
      "date": "2020-10-07 22:44:55"
    },
    {
      "id": "ff7ee790-b265-4df5-ac00-39ccfe0170f0",
      "text": "Major Donbas cities will be without water.",
      "date": "2018-07-19 23:42:18"
    },
    {
      "id": "008054d1-a07f-451e-803b-c9fb1c433e4c",
      "text": "Deaths in the United States in 2020 were not greater than deaths in 2019.",
      "date": "2020-12-31 00:00:00+00:00"
    },
    {
      "id": "6370015a-2183-4030-a2df-2b7769299fb2",
      "text": "The Ukrainian government in Kyiv refuses to clear mines in Donbas, and Finland will clear them.",
      "date": "2019-11-09 18:16:42"
    },
    {
      "id": "1d0f2284-348e-4c83-8ce5-00731b733baa",
      "text": "COVID-19 is caused by snake venom instead of a virus; COVID-19 vaccines contain snake venom and that venom causes miscarriages.",
      "date": "2023-01-06 00:00:00+00:00"
    },
    {
      "id": "ee91da76-0c5f-40ba-9880-7e2b3cab4d92",
      "text": "Vaccinated people get COVID-19, spread COVID-19, die from COVID-19, and die from COVID-19 vaccines.",
      "date": "2021-03-08 00:00:00+00:00"
    },
    {
      "id": "488db398-b0e9-4d0f-b7a9-a7c9ae9505db",
      "text": "President Volodymyr Zelensky is turning Ukraine into Europe’s and America’s main drug supplier.",
      "date": "2020-10-30 18:47:00"
    },
    {
      "id": "f3faae8f-983b-4e63-9882-f25a25683959",
      "text": "Taking curcumin, green tea, and lion’s mane prevents Alzheimer’s disease.",
      "date": "2023-12-29 00:00:00+00:00"
    },
    {
      "id": "6fd5984d-f566-40fc-bdf1-dd1142fcf39e",
      "text": "Poles do not want Ukrainian refugees in Poland.",
      "date": "2023-10-18 18:47:00"
    },
    {
      "id": "8ffe5fea-1c1a-4af2-8604-de9174b2b2ff",
      "text": "Doctors are injecting poison into babies every two months.",
      "date": "2024-02-12 00:00:00+00:00"
    },
    {
      "id": "2a41015f-41b6-462b-9def-77dfe9cc7087",
      "text": "The Donetsk People’s Republic opened offices in France.",
      "date": "2017-07-06 21:46:18"
    },
    {
      "id": "405b64fa-d3ac-4ec7-8bfb-15796d682cda",
      "text": "Vaccines contain cancer-causing enzymes.",
      "date": "2019-06-08 00:00:00+00:00"
    },
    {
      "id": "fc3a68ed-50cd-4532-b10b-94792d272195",
      "text": "One third of excess deaths in the United States during the COVID-19 pandemic were not caused by COVID-19, and those deaths were caused by disruptions to health services due to lockdowns.",
      "date": "2020-10-29 00:00:00+00:00"
    },
    {
      "id": "a2ba5697-2b9f-4b17-888e-0069ad71ff63",
      "text": "Climate change is not worsening drought; global drought severity and frequency have not increased.",
      "date": "2022-05-11 00:00:00+00:00"
    },
    {
      "id": "e627a037-1cb0-4aaa-bf67-beaaca0ccfd3",
      "text": "German tanks crossed the Ukrainian border and are marching east.",
      "date": "2014-09-16 09:29:44"
    },
    {
      "id": "2625714f-905e-4ecf-8b4a-09b9f0b7d704",
      "text": "Ukrainian hackers targeted the Pentagon website because it displayed the Russian tricolor.",
      "date": "2025-06-16 00:00:00+00:00"
    },
    {
      "id": "8769ff38-1ce9-49aa-a968-179abff90664",
      "text": "A Florida study found COVID-19 mRNA vaccines increase the risk of cardiac-related death, especially in men.",
      "date": "2022-10-07 00:00:00+00:00"
    },
    {
      "id": "3090ccd7-4429-4282-b507-a1d1ef4630a5",
      "text": "Ukrainian President Volodymyr Zelensky said he no longer feels welcome in the United States after meeting with former U.S. President Donald Trump.",
      "date": "2025-10-21 00:00:00+00:00"
    },
    {
      "id": "f22dd4d4-244c-40ed-8a4a-66bbd3e6650c",
      "text": "A convoy of Ukrainian Grad multiple-launch rocket systems entered the Donetsk region.",
      "date": "2014-11-01 14:21:40"
    },
    {
      "id": "44024130-7111-4965-ba3b-ba55689def86",
      "text": "Ukrainian officers have been granted the legal right to kill Ukrainian soldiers.",
      "date": "2015-02-08 12:01:49"
    },
    {
      "id": "36e7cc9a-2789-4d66-a2dc-cef8cae9c4de",
      "text": "Hydrogels in COVID-19 mRNA vaccines modify your genome and connect you to the internet.",
      "date": "2020-09-25 00:00:00+00:00"
    },
    {
      "id": "15ed79b6-2eb9-4164-a1a4-467f9b7b0b06",
      "text": "Squalene in vaccines caused Gulf War Syndrome, and the World Health Organization is deliberately depopulating the world by distributing vaccines that cause sterility.",
      "date": "2009-12-30 00:00:00+00:00"
    },
    {
      "id": "0ef16c5a-76af-4d0e-9da7-79552051db26",
      "text": "China released the coronavirus.",
      "date": "2020-03-26 00:00:00+00:00"
    },
    {
      "id": "369e2eec-1aad-41d6-b4db-37834e7e576d",
      "text": "Jen Psaki says Viktor Yanukovych voluntarily resigned.",
      "date": "2015-02-20 20:30:01"
    },
    {
      "id": "8f8edbb5-e9e4-475e-90be-05f42d84a1a4",
      "text": "Doctors worldwide showed hydroxychloroquine is the most effective treatment for COVID-19.",
      "date": "2020-05-14 00:00:00+00:00"
    },
    {
      "id": "9e50f9b4-d7de-478f-b73b-ceb97b2f3b49",
      "text": "Ukrainian soldiers are looting civilian property.",
      "date": "2022-04-25 17:42:00"
    },
    {
      "id": "5ea10b5d-ae66-41c8-9896-2456985b0a16",
      "text": "Natural immunity provides better protection against COVID-19 than COVID-19 vaccination.",
      "date": "2023-11-23 00:00:00+00:00"
    },
    {
      "id": "26523ffa-fb97-4562-ac10-420a038c9930",
      "text": "A tongue that deviates to one side is a sign of stroke.",
      "date": "2019-08-05 00:00:00+00:00"
    },
    {
      "id": "fe1308fc-cebd-446f-aa58-03dfcd2677b7",
      "text": "A Kaiser Permanente study shows COVID-19 vaccines had negative efficacy against all variants within 150 days, and each additional injection increased infection risk.",
      "date": "2022-10-04 00:00:00+00:00"
    },
    {
      "id": "8c5c9816-2706-4384-90ec-5e9bbe788a7c",
      "text": "Natural gas is a clean-burning fuel.",
      "date": "2025-03-01 00:00:00+00:00"
    },
    {
      "id": "5f2a5eee-de1d-4f97-b32f-6c009a0199c8",
      "text": "Ukrainian military barred OSCE observers from the war zone.",
      "date": "2016-08-09 17:32:20"
    },
    {
      "id": "8a041bee-f597-4ec5-90d6-abe85921d8c7",
      "text": "The United States is destabilizing the Black Sea region.",
      "date": "2019-10-09 18:25:16"
    },
    {
      "id": "32295a18-4d4a-4a8f-9ee2-2ac75da02623",
      "text": "One third of Ukrainian refugees arriving in France are African migrants.",
      "date": "2022-04-01 10:56:00"
    },
    {
      "id": "e33a6869-5d82-49ac-9098-dfa14bf71c71",
      "text": "Human societies flourished most during warming trends, and current climate warming is beneficial to humans.",
      "date": "2018-02-06 00:00:00+00:00"
    },
    {
      "id": "a9197e3e-a551-405a-bb28-fb13d389a62a",
      "text": "Ukrainian President Volodymyr Zelensky will force partner countries to pay to dispose of obsolete military equipment they supplied to Ukraine.",
      "date": "2025-04-22 00:00:00+00:00"
    },
    {
      "id": "96970192-557a-4f02-91be-828d023f6d42",
      "text": "Ukrainian refugees fought on an Italian highway.",
      "date": "2022-07-19 16:13:00"
    },
    {
      "id": "941aa92b-0585-4e26-a11e-56729498c38d",
      "text": "The Roshen factory in Lipetsk, Russia is making profits.",
      "date": "2016-10-31 13:50:08"
    },
    {
      "id": "8503fdc1-5827-4df0-996b-b712232be44c",
      "text": "Ukrainian soldiers targeted Charlie Kirk's wife.",
      "date": "2025-11-07 00:00:00+00:00"
    },
    {
      "id": "ed0e3090-b70a-4b95-a165-cff164f8ad3c",
      "text": "Cucurbitacin B, a compound found in cucumber, kills human lung cancer cells and suppresses their growth by 90%, invasion by 75%, and migration by 88%.",
      "date": "2021-04-26 00:00:00+00:00"
    },
    {
      "id": "31568ed6-d43c-4f68-b1e8-de4e1a916858",
      "text": "Visitors are charged an entrance fee to visit the graves of fallen Ukrainian soldiers.",
      "date": "2023-04-19 17:04:00"
    },
    {
      "id": "133f7d66-3c77-4da3-9b55-5fb9bdbf0e5c",
      "text": "Tetanus bacteria are anaerobic and cannot live in oxygen, so people cannot get tetanus from stepping on a rusty nail.",
      "date": "2021-03-07 00:00:00+00:00"
    },
    {
      "id": "2939a802-435b-45e7-9b5c-c5d0ac1ea5ef",
      "text": "Nikola Tesla discovered free-energy technology using the ether, and powerful interests suppressed his discoveries and removed the ether from history books and the Periodic Table.",
      "date": "2024-12-09 00:00:00+00:00"
    },
    {
      "id": "0fac4e8a-db01-48e8-8e45-430e582f167b",
      "text": "The government silenced the top expert witness who denied that vaccines cause autism, forced him to change his testimony, and his testimony changed the court's decision.",
      "date": "2024-03-04 00:00:00+00:00"
    },
    {
      "id": "5f0a5b6e-bda8-4624-a3b2-e9f281dbdf4d",
      "text": "COVID-19 vaccines are experimental poison and COVID-19 has gone away.",
      "date": "2023-12-14 00:00:00+00:00"
    },
    {
      "id": "17e194a6-e388-46fd-9679-5eef686c73e5",
      "text": "Russia targeted an industrial facility in Chernihiv with a ballistic missile.",
      "date": "2025-09-04 00:00:00+00:00"
    },
    {
      "id": "cdde802e-a707-4b79-b972-73d645632c9d",
      "text": "The Eurovision Song Contest will be moved to Moscow.",
      "date": "2016-12-09 15:49:07"
    },
    {
      "id": "36b55499-9dde-45d0-8026-de7b1be48c8a",
      "text": "Ukraine will not survive the winter without coal supplied from occupied Donbas.",
      "date": "2016-11-03 19:04:49"
    },
    {
      "id": "4d999f2d-af0b-4fb3-beeb-e7dbedb25424",
      "text": "A study in Italy found one-third of COVID-19 vaccine recipients had neurological side effects and concluded the vaccines have an unacceptable safety profile.",
      "date": "2023-10-30 00:00:00+00:00"
    },
    {
      "id": "258dfc02-dfdf-47ae-a212-a94fe1bd2b3f",
      "text": "Kharkiv region wants to join Russia",
      "date": "2022-07-08 14:58:43"
    },
    {
      "id": "8bf3adb8-0a8a-4311-8668-c3f1ced00528",
      "text": "High mask compliance did not reduce COVID-19 cases or deaths compared to low mask usage, and mask mandates increased COVID-19 death rates.",
      "date": "2022-06-05 00:00:00+00:00"
    },
    {
      "id": "6b07104c-66a7-4e14-9a76-a4b097a9082f",
      "text": "Turkey is building a new caliphate in southern Ukraine.",
      "date": "2017-02-08 15:38:54"
    },
    {
      "id": "24ecdd06-3496-4652-9275-eaa3f5d1d57d",
      "text": "The European Union met pro-Kremlin Night Wolves bikers with enthusiasm.",
      "date": "2019-05-13 13:54:44"
    },
    {
      "id": "f4ccd130-a946-4cd9-acbe-d171042fa1cf",
      "text": "More than 75% of the rainforest is losing resilience and more than half of the rainforest will be converted into savanna within decades.",
      "date": "2022-03-07 00:00:00+00:00"
    },
    {
      "id": "d37e60ce-d379-42d0-b2cd-4f1eced529f9",
      "text": "The Ukrainian government will poison the Donbas water supply and blame Russia.",
      "date": "2018-08-28 06:17:03"
    },
    {
      "id": "65547e4c-1e4a-4a9f-8cea-498fa9a0a9ab",
      "text": "Ukraine banned calling the common hare \"rusak\" because of linguistic Russophobia.",
      "date": "2023-01-23 09:21:00"
    },
    {
      "id": "9fd1f789-a0bb-4e1f-b049-836033524d91",
      "text": "The United States recognizes the Donetsk People's Republic.",
      "date": "2017-11-14 19:02:18"
    },
    {
      "id": "030c7378-cdeb-4204-9fb5-c2d2a13eb381",
      "text": "Danish researchers found high rates of side effects from the Pfizer COVID-19 vaccine and concluded the vaccine is unsafe.",
      "date": "2023-12-07 00:00:00+00:00"
    },
    {
      "id": "32b326b4-cfe6-46b4-b072-bb631dc1a035",
      "text": "Vitamin K shots are poisonous because they contain polysorbate 80 as the main active ingredient that causes infertility and autoimmune disorders.",
      "date": "2023-05-25 00:00:00+00:00"
    },
    {
      "id": "0f3f4f2a-f380-4606-a16a-f3f4a09b5cd3",
      "text": "Kyiv lacks funds to pay pensions in territories occupied by Russia.",
      "date": "2018-10-01 22:36:37"
    },
    {
      "id": "94cf5bc4-3fec-4cb8-8682-39ab0c9e9fe8",
      "text": "A central communication port has been created to allow quick transfer of US military forces.",
      "date": "2018-06-20 13:15:59"
    },
    {
      "id": "2f0f76bf-5aab-4dcd-b7be-b080f0e53220",
      "text": "Turmeric, the ketogenic diet, ozone therapy, megadoses of vitamin C, and adaptogens cure cancer and these cures have been suppressed for four decades.",
      "date": "2022-12-24 00:00:00+00:00"
    },
    {
      "id": "567f28dd-3ff7-4c5d-934f-c8951a7a3fc3",
      "text": "COVID-19 booster vaccines shut down the immune response; COVID-19 vaccines frequently cause heart damage; SARS-CoV-2 mutations are being driven by vaccine-induced evolutionary selection.",
      "date": "2022-10-01 00:00:00+00:00"
    },
    {
      "id": "f2d96131-771d-4235-8f08-f3459b6cdcaa",
      "text": "Oceans are cooling Earth far more than previously thought, so climate change is greatly overestimated.",
      "date": "2024-11-23 00:00:00+00:00"
    },
    {
      "id": "d7ac50a3-5ec4-4aa1-84b4-24d20c65c879",
      "text": "A protective levee on Ukrainian territory was damaged.",
      "date": "2018-09-26 14:11:24"
    },
    {
      "id": "b2f53ef8-1f48-4ce8-859a-e17b854f4683",
      "text": "Ukraine keeps foreign ships out of its ports by threatening to sink them.",
      "date": "2022-04-18 16:19:00"
    },
    {
      "id": "e65f1db1-d1aa-4982-9c7c-ec7daf4c88f0",
      "text": "A plague epidemic is occurring among Ukrainian soldiers.",
      "date": "2017-05-05 17:32:49"
    },
    {
      "id": "17259035-6c05-46e1-8f59-227f29b9c868",
      "text": "French farmers threw manure at the Ukrainian embassy.",
      "date": "2024-02-13 10:16:00"
    },
    {
      "id": "c5048780-7c72-4d06-92f0-0a9ca1febeb3",
      "text": "The US says the Bucha atrocities are Ukrainian propaganda.",
      "date": "2022-04-04 16:32:00"
    },
    {
      "id": "ac700103-fb9c-4fa3-8f17-e0d56a13ff26",
      "text": "A Ukrainian bank threatened to restrict services for people evading military service.",
      "date": "2024-04-23 10:57:00"
    },
    {
      "id": "c3ccf30f-859c-4953-ac43-46d07b1fceaf",
      "text": "Ukraine deliberately released the coronavirus from the air to retaliate against Donbas.",
      "date": "2020-04-03 15:17:00"
    },
    {
      "id": "e2969ce0-1fdd-4372-9690-7a254eda30c2",
      "text": "Methane from cow burps causes more global warming than emissions from all cars worldwide.",
      "date": "2019-02-19 00:00:00+00:00"
    },
    {
      "id": "697d695e-133f-4537-b15a-ada62b39e9ee",
      "text": "Moderna and Pfizer vaccines contain a bovine protein that triggers an autoimmune response in recipients and makes many of them unable to eat beef.",
      "date": "2023-11-08 00:00:00+00:00"
    },
    {
      "id": "ffe65426-7493-4d0e-8c1b-da74a680ee17",
      "text": "Researchers at the Wuhan Institute of Virology assembled monkeypox virus strains.",
      "date": "2022-05-22 00:00:00+00:00"
    },
    {
      "id": "6771039d-6c9f-4e75-84b1-565146a5b4b8",
      "text": "Ukraine cut off water to Crimea, causing Crimea to dry up.",
      "date": "2017-07-29 11:51:09"
    },
    {
      "id": "0a54c9e3-ab86-48a4-afc5-c00ca411ca59",
      "text": "Ukrainians abandon Orthodox Christianity.",
      "date": "2015-05-01 13:24:04"
    },
    {
      "id": "20447d43-60ab-4c29-bb62-2cd5e30f2991",
      "text": "Crimean Tatar autonomy is a territorial autonomy.",
      "date": "2014-04-01 21:48:31"
    },
    {
      "id": "7776d932-bca4-4232-a584-d33417e3a970",
      "text": "COVID-19 vaccine safety inserts state that no safety studies and no effectiveness studies were conducted for COVID-19 vaccines.",
      "date": "2023-08-03 00:00:00+00:00"
    },
    {
      "id": "16139180-2568-48f4-a5d4-86827015c935",
      "text": "The monument to the main character of the film Vesna na Zarechnoy Ulitse was demolished in Zaporizhzhia.",
      "date": "2014-11-14 16:07:48"
    },
    {
      "id": "b127fa85-ae98-4f2c-914c-0ec7ad3cc5df",
      "text": "Madrid and Liverpool fans returned thousands of Champions League tickets because Kyiv raised ticket prices.",
      "date": "2018-05-25 15:52:54"
    },
    {
      "id": "e0bd2a14-1e6e-43a5-8a9d-ee6e1e28ceff",
      "text": "Ukraine is driving up criminal activity in Eastern Europe.",
      "date": "2023-05-05 13:24:00"
    },
    {
      "id": "8e267560-56f4-452a-93ad-891b3c022aa4",
      "text": "Unvaccinated children do not pose a threat to anyone.",
      "date": "2019-03-06 00:00:00+00:00"
    },
    {
      "id": "5b87492e-f8bc-4b16-a83b-cd3ffd662321",
      "text": "All Lithuanian projects supporting Ukraine have failed.",
      "date": "2020-02-17 14:36:03"
    },
    {
      "id": "e3f63fc0-40a8-4139-b45f-b65461c8b237",
      "text": "SARS-CoV-2 was engineered in a laboratory and deliberately released.",
      "date": "2022-04-30 00:00:00+00:00"
    },
    {
      "id": "26e46f4d-5516-4ae3-8550-8b46fcac1abd",
      "text": "Ukrainian security forces are paid by Western governments.",
      "date": "2018-12-11 14:06:55"
    },
    {
      "id": "14a22516-14a3-4e36-8cdd-74e064f7c3fd",
      "text": "Eating grapefruit while taking antidepressants causes overdose and other complications.",
      "date": "2025-01-13 00:00:00+00:00"
    },
    {
      "id": "4a2e4b95-6228-410f-87ce-26b326d2ed7e",
      "text": "Chilean protesters carried Ukrainian national flags.",
      "date": "2015-06-03 13:06:27"
    },
    {
      "id": "3c95092c-ff32-41c6-8efc-25cb0178c28c",
      "text": "CO2 does not cause climate change; temperature always changes first and CO2 increases always follow temperature changes.",
      "date": "2017-02-19 00:00:00+00:00"
    },
    {
      "id": "1d044881-dfe8-4305-ad28-8f2e00ede837",
      "text": "Human carbon dioxide emissions do not affect global temperatures, and carbon dioxide has had only a minuscule effect on the global climate.",
      "date": "2018-11-08 00:00:00+00:00"
    },
    {
      "id": "6b6599c1-2cbf-4074-9936-6b7a7e6c19b5",
      "text": "Cloth masks do not block smoke particles, and therefore cloth masks do not stop virus transmission.",
      "date": "2020-09-15 00:00:00+00:00"
    },
    {
      "id": "b1862fbf-0847-4700-a44b-5e4acc6e83e5",
      "text": "Estonia admitted Russian air strikes on Ukraine were effective.",
      "date": "2024-01-16 10:44:00"
    },
    {
      "id": "e160bd83-d2cd-443b-b281-8dcf13391611",
      "text": "Carbon dioxide does not drive Earth's climate; Earth experienced an ice age when atmospheric CO2 concentrations were much higher; in the 1970s scientists predicted a new ice age.",
      "date": "2022-07-29 00:00:00+00:00"
    },
    {
      "id": "6079acb8-4b45-4576-b047-34cc48dd3ae3",
      "text": "Ben Carson endorsed CBD gummies and three natural ingredients that cure hypertension",
      "date": "2024-08-01 00:00:00+00:00"
    },
    {
      "id": "f16f4ed3-b0bd-4d2a-95c9-3e274f0fa999",
      "text": "Stress causes Alzheimer's disease.",
      "date": "2025-03-28 00:00:00+00:00"
    },
    {
      "id": "93ab0059-d11e-429a-b043-e435315e618d",
      "text": "If the mother does not have hepatitis B then her baby will not have hepatitis B, and the hepatitis B vaccine contains 16 times the amount of aluminum the FDA says will poison a baby.",
      "date": "2022-03-23 00:00:00+00:00"
    },
    {
      "id": "149e0a0a-9b35-4fc6-b371-9576278ac3b2",
      "text": "Excess folic acid in food causes ADHD and folic acid in food is a dangerous chemical.",
      "date": "2022-07-26 00:00:00+00:00"
    },
    {
      "id": "c6015b39-2772-4ca9-9429-6a2fe456ee32",
      "text": "Vitamins C and D are part of conventional SARS-CoV-2 treatment; high-dose vitamin C kills SARS-CoV-2; vitamin D reduces SARS-CoV-2 infection risk and aids treatment.",
      "date": "2020-04-14 00:00:00+00:00"
    },
    {
      "id": "39898d3c-26bd-4aa9-8a59-079a2126ae08",
      "text": "A Ukrainian rock star called for the destruction of Ukraine's current government.",
      "date": "2018-06-28 09:04:56"
    },
    {
      "id": "c7d2b250-f4c4-4684-b677-d6432e875d3e",
      "text": "Ukraine is preparing a new provocation in the Kerch Strait.",
      "date": "2019-01-07 10:58:54"
    },
    {
      "id": "3bb92e17-0489-4a5b-8099-61c3f5cf031c",
      "text": "Activated charcoal tablets counteract most date-rape drugs.",
      "date": "2019-09-04 00:00:00+00:00"
    },
    {
      "id": "46f7ef2c-a1b3-47cb-b8e5-645e4208bdb3",
      "text": "Researchers at Yale University created an airborne delivery method for mRNA vaccines.",
      "date": "2023-09-14 00:00:00+00:00"
    },
    {
      "id": "26609638-fcc1-4b4e-89f4-60dec798d60b",
      "text": "Hank Aaron's death was one of many suspicious elderly deaths that occurred shortly after COVID-19 vaccination.",
      "date": "2021-01-22 00:00:00+00:00"
    },
    {
      "id": "0b8df3f4-5271-428f-9336-8febdb1c264c",
      "text": "Eating turmeric every day reverses cancer",
      "date": "2019-03-16 00:00:00+00:00"
    },
    {
      "id": "24f83920-b618-404c-b49e-4adc756dedd6",
      "text": "Smoking turns smokers' lungs black.",
      "date": "2019-12-31 00:00:00+00:00"
    },
    {
      "id": "166848c8-967e-40a4-8078-5821ec4e1929",
      "text": "Ukraine will receive limited visa-free travel to the European Union.",
      "date": "2017-03-13 18:06:56"
    },
    {
      "id": "e8cacb37-ea33-41f4-89f7-c7e6896b5a2f",
      "text": "Previously infected people do not need COVID-19 vaccination because vaccination provides no additional benefit.",
      "date": "2021-05-27 00:00:00+00:00"
    },
    {
      "id": "7e445445-ef7a-4933-8775-3e116ffc0192",
      "text": "Hydroxychloroquine, zinc, and Zithromax cure COVID-19, so people do not need to wear masks.",
      "date": "2020-07-31 00:00:00+00:00"
    },
    {
      "id": "f4b96ae3-a77d-4ccf-b96b-3b941f8b725f",
      "text": "Most Ukrainians living in the temporarily occupied territories will vote for Russia in a referendum.",
      "date": "2022-08-28 10:49:00"
    },
    {
      "id": "faf88ade-24d7-4dcf-9599-5c9145f550b8",
      "text": "Jamie Foxx was left paralyzed and blind by a blood clot in his brain after receiving the COVID-19 vaccine.",
      "date": "2023-05-30 00:00:00+00:00"
    },
    {
      "id": "98ac321f-c36a-4bbd-ad93-609c6b5ddb69",
      "text": "If testing stops, COVID-19 will disappear and people will only have common colds like before.",
      "date": "2022-07-01 00:00:00+00:00"
    },
    {
      "id": "41785fe5-5666-4005-b763-59f51cd8d1c9",
      "text": "Global ocean temperatures are cooling, therefore global warming is not occurring.",
      "date": "2025-07-20 00:00:00+00:00"
    },
    {
      "id": "f705b36b-4f34-4a2b-a921-345967b48d1c",
      "text": "Pro Power Save reduces every American's electricity bill by 90%.",
      "date": "2024-09-09 00:00:00+00:00"
    },
    {
      "id": "1ae9d1a6-7fc2-4779-b879-49a536c35b4b",
      "text": "A children's combat battalion was formed in Prykarpattia.",
      "date": "2014-09-05 18:00:25"
    },
    {
      "id": "d04fd66a-e811-454f-bb67-150f8782a32f",
      "text": "A Ukrainian gang stole chairs from restaurants in Spain.",
      "date": "2025-11-03 00:00:00+00:00"
    },
    {
      "id": "1d04e2f4-99d1-427c-a120-3b1a90135057",
      "text": "A Luhansk People's Republic soldier threw himself, with grenades, in front of a tank.",
      "date": "2014-07-09 18:16:45"
    },
    {
      "id": "05cbc7b4-f6f2-49e7-a208-e0e250d7094f",
      "text": "Yulia Tymoshenko keeps a woman as a prison slave.",
      "date": "2014-12-08 15:12:55"
    },
    {
      "id": "209d22b1-d632-4c86-8bbc-6d1632ddfdfe",
      "text": "A fire occurred at fuel tanks near Kyiv on June 12.",
      "date": "2015-06-12 19:41:49"
    },
    {
      "id": "2f4fbef0-ba6e-4ccd-b127-74b59e645f35",
      "text": "Cannabis treats cancer, PTSD, seizures, anxiety, glaucoma, and depression.",
      "date": "2022-09-09 00:00:00+00:00"
    },
    {
      "id": "e1682584-bfb8-4e0a-8866-adb98da6eb8a",
      "text": "COVID-19 mRNA vaccines contain unapproved genetically modified organisms that permanently change human DNA.",
      "date": "2023-11-17 00:00:00+00:00"
    },
    {
      "id": "7a396800-85d2-4b39-8dcd-a7c1c8e96efa",
      "text": "A Ukrainian general said he regretted not covering Crimea with blood.",
      "date": "2021-01-12 16:35:53"
    },
    {
      "id": "cb409fed-3615-4245-84aa-61987e7e0223",
      "text": "Ukrainian government officials sell Javelin anti-tank missiles to Hamas and Hezbollah militants.",
      "date": "2022-04-27 17:09:08"
    },
    {
      "id": "12f1fdfb-4d29-4417-a781-ada75566bb48",
      "text": "Thimerosal, ovalbumin, formaldehyde, and sodium deoxycholate are known neurotoxins.",
      "date": "2019-07-31 00:00:00+00:00"
    },
    {
      "id": "fd69119f-620c-415d-bf99-0291b228baa8",
      "text": "The Government released plans to force a vaccine on everyone and three vaccines in the United States are in Stage 3 trials that will be ready in weeks.",
      "date": "2020-09-16 00:00:00+00:00"
    },
    {
      "id": "ad80062a-3d8a-426a-99d1-f421c7309538",
      "text": "6-year-old Russian child beaten by Ukrainians",
      "date": "2022-03-28 16:53:00"
    },
    {
      "id": "79914c75-18eb-49e1-8e63-9f9f43ae183a",
      "text": "COVID-19 vaccines have killed 17 million people worldwide.",
      "date": "2023-09-17 00:00:00+00:00"
    },
    {
      "id": "c3321f84-7849-4d8e-b6eb-0027f9a1ef41",
      "text": "Ukrainians rioted over freezing conditions.",
      "date": "2018-11-20 10:27:06"
    },
    {
      "id": "97f8426c-3bff-4027-9f2c-c5a7dac7d103",
      "text": "Ukraine is preparing for war in Crimea",
      "date": "2020-07-29 10:07:10"
    },
    {
      "id": "8af5625a-8215-452c-8f8b-b4605c6bc63e",
      "text": "COVID-19 vaccines are unsafe and cause deaths from cardiac arrest and blood clots.",
      "date": "2024-10-20 00:00:00+00:00"
    },
    {
      "id": "a1c9ba4c-ca08-4e60-8252-ff4a687a94f1",
      "text": "Ukraine's National Bank transferred gold and foreign exchange reserves to Poland.",
      "date": "2022-08-18 10:09:00"
    },
    {
      "id": "4b42f203-d8d2-42d6-b819-9fe659c2bff7",
      "text": "Methane from cows is a small share of total greenhouse gas emissions, methane is produced without cattle, and cow methane is not an important contributor to climate change.",
      "date": "2023-12-19 00:00:00+00:00"
    },
    {
      "id": "54cb9373-b32a-4519-8401-caf5f482e5f9",
      "text": "Antarctica's surface air temperatures have risen three times faster than the global average since the 1990s.",
      "date": "2020-06-07 00:00:00+00:00"
    },
    {
      "id": "08f4a80c-2870-4d62-a929-85f354fbb3c5",
      "text": "Crimean Tatars demand Crimea be renamed.",
      "date": "2016-05-20 05:26:15"
    },
    {
      "id": "43d583a9-a247-4b3a-85e7-9e73dddf6f36",
      "text": "Ukraine shelled Zaporizhzhia Nuclear Power Plant.",
      "date": "2022-08-25 10:58:00"
    },
    {
      "id": "5edb0b43-d38e-4c4b-a67c-1463dcb6c043",
      "text": "75% of COVID deaths occurred in people who had at least four comorbidities.",
      "date": "2022-01-11 00:00:00+00:00"
    },
    {
      "id": "8f2ca6f5-b8b6-4cc2-949e-0128e53ca515",
      "text": "Ukraine destroyed its leading television channel.",
      "date": "2018-07-16 17:59:10"
    },
    {
      "id": "a8184d7c-394b-43c2-907e-e063d4a08e0f",
      "text": "A Russian-speaking child was denied a St. Nicholas Day gift in Lviv.",
      "date": "2025-12-08 00:00:00+00:00"
    },
    {
      "id": "03713cf1-3285-4b14-940e-b471322c77da",
      "text": "Austria will pay a €60 subsidy to residents of Chernivtsi.",
      "date": "2016-01-04 21:20:30"
    },
    {
      "id": "9f7a5a66-3cd5-421f-8c1b-3e79b685556e",
      "text": "Renewable energy caused the April 2025 Iberian blackout.",
      "date": "2025-04-28 00:00:00+00:00"
    },
    {
      "id": "73a580b4-4b69-44f4-a8fb-9a6977e542a9",
      "text": "Ukraine's Security Service ordered the destruction of MH17 crash evidence.",
      "date": "2017-06-07 14:28:34"
    },
    {
      "id": "e37c83ce-38f2-4423-9a84-da573f0ffa3b",
      "text": "Poppers cause Kaposi’s sarcoma.",
      "date": "2023-03-31 00:00:00+00:00"
    },
    {
      "id": "3cd10504-7293-4120-b638-019e2e0a6147",
      "text": "Children of Ukrainian refugees in Germany are being taken away for showing emotion and having an appetite.",
      "date": "2022-07-29 17:32:00"
    },
    {
      "id": "f82373f6-9aeb-4db7-9675-92beba087616",
      "text": "Phone use is causing horns to grow on young people's skulls.",
      "date": "2019-06-25 00:00:00+00:00"
    },
    {
      "id": "7d43e798-e609-400b-a48b-8f931e3ce23e",
      "text": "Activated charcoal absorbs and neutralizes poisons and treats diarrhea and bloating.",
      "date": "2024-05-30 00:00:00+00:00"
    },
    {
      "id": "5427876d-716b-4769-8748-2063f30c794c",
      "text": "Cloth masks do not block smoke particles that are larger than viruses, therefore cloth masks do not stop virus transmission.",
      "date": "2020-08-31 00:00:00+00:00"
    },
    {
      "id": "199e9a4b-d550-4e3a-bcf4-9a72423619f0",
      "text": "A baby's immune system cannot safely handle eight different antigens in one day.",
      "date": "2022-03-23 00:00:00+00:00"
    },
    {
      "id": "6e95ebe5-99d2-466f-8e90-0cc917b69a94",
      "text": "A US intelligence officer said Poland is contributing to the destruction of Ukraine's armed forces.",
      "date": "2023-03-20 14:07:00"
    },
    {
      "id": "c57dfaec-26b8-4aae-a726-47206540ec37",
      "text": "Thousands of Russians are urgently leaving Ukraine.",
      "date": "2021-06-12 10:50:00"
    },
    {
      "id": "aec8b90d-d8e0-46e0-a3cc-bcf61de165d7",
      "text": "Pfizer is part of Operation Warp Speed and its Coronavirus vaccine trial prevented infection in 90% of its volunteers.",
      "date": "2020-11-09 00:00:00+00:00"
    },
    {
      "id": "9d0bf5b2-91bb-41d1-b08c-7bdd2e0e3914",
      "text": "The Kyiv government prevented Donbas residents from voting in the elections.",
      "date": "2019-03-31 15:16:16"
    },
    {
      "id": "53217b2f-fca3-4909-967e-1e550b446afa",
      "text": "Ukrainian Armed Forces soldiers have not been paid for more than a month.",
      "date": "2014-03-10 13:00:58"
    },
    {
      "id": "963a13b5-0862-4aea-b670-0d618cc0c9cc",
      "text": "COVID-19 vaccines killed 410,000 Americans and caused 41 times more deaths than were reported to VAERS.",
      "date": "2023-08-06 00:00:00+00:00"
    },
    {
      "id": "f8967d69-a71c-4143-a9f7-83da2fc9cc4f",
      "text": "Japan will release a new saRNA vaccine designed to spread to others without informed or any consent; the vaccine will spread to others and its saRNA lacks a “break” and will remain in recipients and those it spreads to forever.",
      "date": "2024-09-29 00:00:00+00:00"
    },
    {
      "id": "c971afc0-c52e-446f-8f42-9d8541b6b917",
      "text": "United Nations admits Islamists are present in the Ukrainian Armed Forces.",
      "date": "2015-11-30 18:14:31"
    },
    {
      "id": "baa60327-2fdf-4fe3-9312-99063b128b4d",
      "text": "Dandelion root kills 98% of cancer cells within 48 hours.",
      "date": "2024-05-13 00:00:00+00:00"
    },
    {
      "id": "78a45dbc-288c-4c0c-b746-47886b07ece5",
      "text": "Tinnitus is the first warning sign that your brain is dying.",
      "date": "2021-03-23 00:00:00+00:00"
    },
    {
      "id": "16809459-35f7-426f-8329-a9c34309a67f",
      "text": "A doctor's tweet about unvaccinated COVID-19 ICU patients originated from a bot network.",
      "date": "2021-07-28 00:00:00+00:00"
    },
    {
      "id": "7a992198-c084-4876-b592-bf1f92cd55f1",
      "text": "A study shows that receiving more COVID-19 vaccine doses increases the likelihood of getting COVID-19.",
      "date": "2023-05-30 00:00:00+00:00"
    },
    {
      "id": "0b2c0175-e665-4892-bfbc-7808ae3dcb8a",
      "text": "SARS was developed by humans as a biological weapon designed to attack human beings.",
      "date": "2023-07-06 00:00:00+00:00"
    },
    {
      "id": "8b584ea9-0889-4650-819c-54e341fdef62",
      "text": "CDC data prove measles vaccines kill more people than measles.",
      "date": "2015-02-05 00:00:00+00:00"
    },
    {
      "id": "094fbd3c-b35a-4c20-b0e0-214fa2f585c7",
      "text": "American tanks were found in Donbas.",
      "date": "2015-04-03 17:47:26"
    },
    {
      "id": "cda1a8e2-20e9-456b-b935-56edcef9cc47",
      "text": "Ukrainian ships caused the Beirut explosions.",
      "date": "2020-08-05 11:56:42"
    },
    {
      "id": "9f5ab2aa-1d48-4a0f-8b36-d1bc0279abff",
      "text": "A Hitler salute cures coronavirus",
      "date": "2020-03-17 20:04:07"
    },
    {
      "id": "07771d5c-00b5-4b1e-841e-7e892647c698",
      "text": "Renewable energy requires a separate second electricity grid.",
      "date": "2025-08-30 00:00:00+00:00"
    },
    {
      "id": "90a5dc53-7d12-4963-ac35-1f73db9e52e4",
      "text": "Ukrainian border guards detained a Russian ship in Russia's territorial waters.",
      "date": "2018-04-02 17:56:46"
    },
    {
      "id": "e8f9b3de-5f77-45bd-a686-624be386842d",
      "text": "Dutch Prime Minister wants all referenda banned because of Ukraine",
      "date": "2016-06-20 12:28:14"
    },
    {
      "id": "0c24e548-0e2b-4979-93c1-c712a466c2ac",
      "text": "Ukrainian refugees in Italy assaulted Joseph Brodsky's granddaughter.",
      "date": "2022-04-25 18:04:00"
    },
    {
      "id": "9b2a0766-5559-458f-8740-214658f06894",
      "text": "Mammatus and asperitas clouds are abnormal and prove the weather is being manipulated.",
      "date": "2024-09-20 00:00:00+00:00"
    },
    {
      "id": "216aea1c-b87f-4e12-be73-6f1d3ccdd66e",
      "text": "Ukraine will store Russian nuclear waste.",
      "date": "2020-05-08 19:33:22"
    },
    {
      "id": "a3c82ec4-1e3b-4b66-b0fa-725beb943034",
      "text": "There is no correlation between atmospheric CO2 and global temperature, and scientists do not know whether Earth will warm or cool in the future.",
      "date": "2022-10-18 00:00:00+00:00"
    },
    {
      "id": "a9e3760a-e3c6-406c-ae04-bff0fcfe20ff",
      "text": "Flu cases fell 95% in weeks 40–41 from 2019 to 2020 because flu cases were diagnosed as COVID-19, which reduced recorded flu cases.",
      "date": "2020-10-22 00:00:00+00:00"
    },
    {
      "id": "431e486f-195a-4068-accc-839f3d5f6916",
      "text": "The Shevchenko statue in the Zaporizhzhia region was demolished.",
      "date": "2016-02-07 20:06:55"
    },
    {
      "id": "68d0e0b1-9767-4047-b61c-46dfc5481041",
      "text": "Videos of Russian military atrocities in Hostomel were staged by Ukrainian actors.",
      "date": "2022-09-08 10:20:00"
    },
    {
      "id": "77995af2-5f23-43fc-8391-2d7c615e9e55",
      "text": "10 million Ukrainians were denied the right to vote in Ukraine’s presidential election.",
      "date": "2019-03-31 15:45:58"
    },
    {
      "id": "af260482-351c-4dd5-84df-a3b880e0ea7d",
      "text": "Hungary and Poland consider Ukraine a threat.",
      "date": "2025-07-09 00:00:00+00:00"
    },
    {
      "id": "a8f44394-f854-4c61-93e9-f08fa0649e2d",
      "text": "Turmeric, the ketogenic diet, ozone therapy, megadoses of vitamin C, and adaptogens cure cancer and have been suppressed for four decades.",
      "date": "2022-12-11 00:00:00+00:00"
    },
    {
      "id": "7fdea1ea-c968-4c88-ae94-84e1ba514576",
      "text": "Poroshenko is planning a military coup in Ukraine",
      "date": "2022-08-10 10:51:43"
    },
    {
      "id": "167a219a-eda7-4bf5-8331-da930d790371",
      "text": "Ukrainians requested electricity from Crimea.",
      "date": "2017-03-31 21:52:58"
    },
    {
      "id": "0288195c-9fec-44db-a109-059e6777897b",
      "text": "A COVID-19 booster means the initial COVID-19 vaccination failed.",
      "date": "2021-08-28 00:00:00+00:00"
    },
    {
      "id": "fd8db090-0452-4f9b-8abf-4408eacddb2d",
      "text": "Stopping all climate change efforts protects people from the coronavirus.",
      "date": "2020-03-25 00:00:00+00:00"
    },
    {
      "id": "85f37113-0f90-4278-a176-cff652db623b",
      "text": "A study showed COVID-19 vaccines are more dangerous than COVID-19, and children aged 12–17 are hospitalized for vaccine-induced myocarditis more often than for COVID-19.",
      "date": "2021-12-24 00:00:00+00:00"
    },
    {
      "id": "c57e4357-ae8a-40b8-afda-c07666d2a827",
      "text": "Climate models overestimated global warming and failed to predict the warming hiatus.",
      "date": "2017-09-22 00:00:00+00:00"
    },
    {
      "id": "c034d650-02fb-406f-9caa-155c65dedc12",
      "text": "Germany suspended all COVID-19 vaccinations.",
      "date": "2021-08-23 00:00:00+00:00"
    },
    {
      "id": "9fb54ee2-01b6-4987-980a-210dd5544835",
      "text": "President Andrzej Duda spat on the memory of the Volhynia massacre.",
      "date": "2020-10-15 10:32:17"
    },
    {
      "id": "86bf145c-272c-480e-8366-65caa37d83f0",
      "text": "The UN gave Russia the right to seize Ukraine in 2014.",
      "date": "2017-01-29 21:40:13"
    },
    {
      "id": "92b4d75e-1243-4b14-afa6-adbd966b3a65",
      "text": "mRNA COVID-19 vaccines alter human DNA and cause cancer and autoimmune disorders.",
      "date": "2025-04-24 00:00:00+00:00"
    },
    {
      "id": "94959480-351d-4c80-95f4-11df21938b90",
      "text": "Human activities produce less than 5% of global carbon dioxide emissions and are not responsible for 30% of today's atmospheric carbon dioxide.",
      "date": "2020-11-02 00:00:00+00:00"
    },
    {
      "id": "3227e8ec-3817-4e54-8ce8-38d6ff47fa16",
      "text": "Western Ukraine will be transferred to Poland.",
      "date": "2015-01-18 14:57:11"
    },
    {
      "id": "63d19ccd-c1a3-49bd-bb47-e27b66c6bb53",
      "text": "Vaccines and vitamin K injections given to children are unsafe.",
      "date": "2022-11-25 00:00:00+00:00"
    },
    {
      "id": "a9de1b60-bb45-4d6b-af0c-15438e753da4",
      "text": "Solar forcings were large enough to explain twentieth-century warming and caused as much or more warming than atmospheric CO2.",
      "date": "2017-03-05 00:00:00+00:00"
    },
    {
      "id": "6a794e4b-ffb0-47fa-8123-d9af2434ac33",
      "text": "Ukraine buys gas in Europe at twice the price Russia charges.",
      "date": "2019-06-06 10:51:52"
    },
    {
      "id": "864f9a63-a3cd-4ac6-8b3f-b1f18e4b0f44",
      "text": "The Dutch referendum is the last chance for Poroshenko to remain in power.",
      "date": "2016-04-11 18:48:17"
    },
    {
      "id": "1b13625d-b41e-4562-bf57-bdb6d1ca6e55",
      "text": "The United States considers the Donbas war to be an internal matter of Ukraine.",
      "date": "2018-03-23 11:18:02"
    },
    {
      "id": "ae86ef0a-bda7-4932-9e91-a13e090502e9",
      "text": "COVID-19 vaccines cause female sterilization by triggering an immune response that attacks the placenta.",
      "date": "2020-12-02 00:00:00+00:00"
    },
    {
      "id": "e62e5eff-1bfa-4a5f-8f62-2c3b2ccc3405",
      "text": "Long COVID is solely caused by patients' beliefs and is not a real physiological disease.",
      "date": "2021-11-08 00:00:00+00:00"
    },
    {
      "id": "da854a60-2bfd-47e5-93f4-3548662e814e",
      "text": "A train from Ukraine arrived in Russia loaded with mines.",
      "date": "2018-01-15 22:34:20"
    },
    {
      "id": "aa6995a0-49dc-480e-a0a5-150071aa7162",
      "text": "Friedrich Merz will travel to Russia to attend the Victory Day parade.",
      "date": "2025-05-08 00:00:00+00:00"
    },
    {
      "id": "e5121df9-2e78-481b-8970-d2176c7e27ca",
      "text": "Oxygen kills cancer and Otto Warburg won two Nobel Prizes proving lack of oxygen causes cancer.",
      "date": "2022-03-02 00:00:00+00:00"
    },
    {
      "id": "bd233fe4-3b35-4b5f-af8f-81ae82dca665",
      "text": "NATO refuses to accept Ukraine as a member.",
      "date": "2017-11-17 19:54:03"
    },
    {
      "id": "e0368732-4c88-48f5-9c11-88c6067e6192",
      "text": "Vaccinated children have higher rates of developmental delays, asthma, and ear infections than unvaccinated children.",
      "date": "2020-05-28 00:00:00+00:00"
    },
    {
      "id": "00e4beef-c219-4e6b-8148-2fcb5fff7534",
      "text": "Everyone who received at least one dose of an mRNA COVID-19 vaccine will die within three to five years.",
      "date": "2025-01-25 00:00:00+00:00"
    },
    {
      "id": "842d6786-258c-4787-ab4f-513325aead98",
      "text": "US corn crops produce 40% more oxygen at their peak than the Amazon rainforest.",
      "date": "2021-09-23 00:00:00+00:00"
    },
    {
      "id": "2482a699-2eb6-4496-a7a1-14716440e37a",
      "text": "Vehicle emissions impact human health and the environment.",
      "date": "2025-04-02 00:00:00+00:00"
    },
    {
      "id": "a3f553b1-2992-4891-b063-96f989262aae",
      "text": "COVID-19 vaccines contain graphene and living organisms composed of aluminum",
      "date": "2021-10-21 00:00:00+00:00"
    },
    {
      "id": "baa2a5aa-152e-4eb7-9032-0bd27e6694e3",
      "text": "COVID-19 vaccines are experimental and ineffective; natural immunity is more protective than vaccine-induced immunity; the vaccine-induced spike protein is dangerous and causes serious side effects; the Omicron variant is mild and completely escapes protection from prior vaccination.",
      "date": "2022-01-26 00:00:00+00:00"
    },
    {
      "id": "dc5f398c-1b3c-4084-ad16-8f688b425043",
      "text": "Volodymyr Zelensky promised to hand Crimea and Donbas to Western governments hostile to Russia.",
      "date": "2022-12-29 14:52:00"
    },
    {
      "id": "cc147726-682e-4939-a5a6-0cc2cfc82c3f",
      "text": "Ukrainian authorities served draft notices and confiscated cars in an enclosed village.",
      "date": "2023-04-15 11:40:00"
    },
    {
      "id": "d03e52c8-f3b0-465d-8f87-43a35a1fc373",
      "text": "French authorities suspended all Muslim police officers from accompanying the Olympic torch relay.",
      "date": "2024-05-20 14:50:00"
    },
    {
      "id": "34d53daf-8e5a-4230-baa9-8bfff9afe51e",
      "text": "Plant defense chemicals in vegetables cause autoimmune diseases, and removing vegetables from the diet improves health.",
      "date": "2026-02-03 00:00:00+00:00"
    },
    {
      "id": "a106285b-7181-4d15-984b-cc4c27f0e1c8",
      "text": "Every election year has a disease; SARS‑CoV‑2 has a basic reproduction number (R0) of 2.",
      "date": "2020-03-02 00:00:00+00:00"
    },
    {
      "id": "e1999d90-6147-49e7-b5ba-1610c953efa1",
      "text": "Crimean residents are banned from entering the EU and the US.",
      "date": "2019-07-30 13:17:47"
    },
    {
      "id": "c9551664-66c1-4022-be61-3504e4b8a7ac",
      "text": "The COVID-19 vaccine caused Justin Bieber’s Ramsay Hunt syndrome and resulting facial paralysis.",
      "date": "2022-06-10 00:00:00+00:00"
    },
    {
      "id": "0cfea84b-cf2c-4f62-9d1a-21e329ead6c5",
      "text": "Regulatory agencies were unaware that COVID-19 RNA vaccines contained residual DNA contamination that integrates into human DNA and causes cancer.",
      "date": "2023-10-25 00:00:00+00:00"
    },
    {
      "id": "088c9d7e-17f1-4edc-8006-3419bd1f866f",
      "text": "Kyiv abandoned and deceived Moscow.",
      "date": "2019-06-10 14:22:57"
    },
    {
      "id": "8582e052-9742-4830-aa7b-63a3e3825d95",
      "text": "COVID-19 is less deadly than the seasonal flu.",
      "date": "2020-01-10 00:00:00+00:00"
    },
    {
      "id": "bb7bcb7f-4e00-482e-91ba-f39ba58f5294",
      "text": "Ukraine is the country with the highest number of human rights violations.",
      "date": "2018-04-24 20:54:48"
    },
    {
      "id": "803e4526-61c3-4126-86fd-41849f1452d5",
      "text": "The Ukrainian Armed Forces attacked the Zaporizhzhia Nuclear Power Plant's power units using drones.",
      "date": "2024-04-10 13:10:00"
    },
    {
      "id": "d268d9c5-c3c6-4411-8345-5a9251ac14da",
      "text": "Nigoian and Zhiznevskii were not killed by the police.",
      "date": "2015-01-26 22:07:17"
    },
    {
      "id": "f6483772-fddc-4c83-9b69-4ea7ee784909",
      "text": "A vegan world has no pandemics because 100% of pandemics originate from animals.",
      "date": "2021-03-23 00:00:00+00:00"
    },
    {
      "id": "cb281f4e-f905-4eec-b469-2c16643d4c80",
      "text": "Drinking bottled water with an acidic pH is harmful to your health.",
      "date": "2019-05-13 00:00:00+00:00"
    },
    {
      "id": "236567f4-2fcf-4060-8cab-0e0de7c945d5",
      "text": "A Washington poster urged Ukrainian President Volodymyr Zelenskyy to wear a suit when meeting Donald Trump.",
      "date": "2025-08-18 00:00:00+00:00"
    },
    {
      "id": "2ea9032c-8c5f-4001-b001-e19ace030710",
      "text": "Ventilators, not COVID-19, killed hospitalized COVID-19 patients.",
      "date": "2023-10-31 00:00:00+00:00"
    },
    {
      "id": "da17caaa-038f-44dd-81fa-2b9a4d619340",
      "text": "Bloomberg published an infographic showing Ukrainian President Volodymyr Zelensky looted France.",
      "date": "2025-11-04 00:00:00+00:00"
    },
    {
      "id": "25d1ffa1-ec83-4556-a329-729b2996fa94",
      "text": "Zelensky accused the West of killing people and said he will recognize Crimea and the separatist republics.",
      "date": "2022-03-09 13:18:17"
    },
    {
      "id": "d37d1d9e-9c0c-49d3-9635-75549d7725c7",
      "text": "Ivermectin is the only treatment for COVID-19 at all stages; ivermectin substantially reduces COVID-19 deaths and prevents COVID-19 infections; fifty studies show ivermectin is highly effective.",
      "date": "2021-04-15 00:00:00+00:00"
    },
    {
      "id": "4f14b91f-d337-4555-83f5-4406531cb2eb",
      "text": "A vaccine crew in an Indian village was attacked by locals.",
      "date": "2021-04-07 00:00:00+00:00"
    },
    {
      "id": "18fd783c-ce15-4f12-bece-7b5f5bbe65b4",
      "text": "Ukraine imprisons Russian-language teachers.",
      "date": "2020-09-18 15:22:07"
    },
    {
      "id": "dc5413c2-0794-4e1f-a694-bbec425f4ef0",
      "text": "Most recent global warming is natural.",
      "date": "2017-07-09 00:00:00+00:00"
    },
    {
      "id": "43919de6-4762-4470-acd3-37a2872b14c9",
      "text": "Recent footage is authentic and shows tornadoes and storms that occurred during Hurricane Milton.",
      "date": "2024-10-11 00:00:00+00:00"
    },
    {
      "id": "7b0c30c4-33d2-419c-af29-819d57a0adfe",
      "text": "Ukrainian tourists are flooding Crimea.",
      "date": "2016-06-25 11:37:01"
    },
    {
      "id": "4361dc11-5b10-466c-866d-bcef206f74ec",
      "text": "Poroshenko threatens to arrest protesting airport staff.",
      "date": "2015-03-20 17:53:51"
    },
    {
      "id": "0707287b-fd2c-45a0-9848-e672b4be6745",
      "text": "International organizations refuse to investigate the Bucha atrocities.",
      "date": "2022-04-11 17:26:00"
    },
    {
      "id": "76d70905-af86-4ce6-b53b-47bfd1d81f41",
      "text": "Video shows Ukrainian military vehicles near Mariupol.",
      "date": "2014-12-20 18:14:46"
    },
    {
      "id": "905652e7-0b27-4087-97dd-baa9e9748ae4",
      "text": "Trees solve almost all environmental crises and reverse climate change by removing carbon dioxide from the atmosphere.",
      "date": "2020-08-25 00:00:00+00:00"
    },
    {
      "id": "5574fa8d-0c2a-4e81-9251-ca98d7716651",
      "text": "Ukraine will cancel the child care allowance.",
      "date": "2015-12-19 14:39:30"
    },
    {
      "id": "277c4d3b-7c36-4927-b020-8737f80c28eb",
      "text": "Birthmarks indicate the MTHFR gene; people with MTHFR cannot detox toxins from vaccines and therefore have increased risk of vaccine reactions.",
      "date": "2018-11-03 00:00:00+00:00"
    },
    {
      "id": "4061b077-d654-4a60-b4ff-6d603ddea8c1",
      "text": "Three Ukrainian nationals were arrested in Germany for plotting sabotage.",
      "date": "2025-05-14 00:00:00+00:00"
    },
    {
      "id": "2f5db5ae-8ec4-4bc1-b85f-d2b962e49e81",
      "text": "Ukrainian Commander-in-Chief Zaluzhny is preparing a military coup.",
      "date": "2023-11-08 11:28:00"
    },
    {
      "id": "508c530f-62a2-4f80-ad46-f2af4e2a0d81",
      "text": "Russian media published exit poll data from the Ukrainian presidential election.",
      "date": "2019-04-21 14:55:22"
    },
    {
      "id": "838a4c31-fdc8-4018-bf5d-f520ddd23e70",
      "text": "Congress says Americans no longer want to support Kyiv.",
      "date": "2024-09-20 13:48:00"
    },
    {
      "id": "37e13725-d8a0-42c4-896e-28b43b854daf",
      "text": "Polls show people do not believe Russia shot down Flight MH17",
      "date": "2020-07-22 15:49:00"
    },
    {
      "id": "c92f6276-a72b-40c9-8eb3-52f11f64e39e",
      "text": "Masks and lockdowns do not slow the spread of COVID-19.",
      "date": "2021-03-03 00:00:00+00:00"
    },
    {
      "id": "96f6f419-8345-4abe-8f59-ee35ea18b71c",
      "text": "Deforestation has increased human vulnerability to pandemics.",
      "date": "2020-03-20 00:00:00+00:00"
    },
    {
      "id": "c522a826-3d94-442f-8c9d-1029702b5159",
      "text": "The World Health Organization officially declared that bacon is as harmful as cigarettes.",
      "date": "2018-09-12 00:00:00+00:00"
    },
    {
      "id": "55914f23-fc32-43e1-9e36-9f9f752bf43b",
      "text": "Poland has ceased payments to Ukrainian refugees in 2024.",
      "date": "2023-11-27 13:58:54"
    },
    {
      "id": "4c2df153-9630-4525-9cc5-c62839a1318a",
      "text": "High cholesterol is good for health.",
      "date": "2023-11-07 00:00:00+00:00"
    },
    {
      "id": "34260db7-2ee9-4791-8c3a-2850e0eb9f7c",
      "text": "A Nature study proves all mRNA COVID-19 vaccines cause heart damage.",
      "date": "2025-01-15 00:00:00+00:00"
    },
    {
      "id": "aa6ae27a-ebdd-4bc3-aa8c-94795ca3005f",
      "text": "Dnipro is part of the Russian World",
      "date": "2018-10-09 17:39:49"
    },
    {
      "id": "9f30f1e3-612f-4f10-8077-f36166226813",
      "text": "VAERS received 3,916 COVID-19 vaccine adverse event reports in December, including 13 deaths.",
      "date": "2021-01-19 00:00:00+00:00"
    },
    {
      "id": "97b80d46-c4df-40f4-a396-952af4ac237a",
      "text": "A Lviv officer proposes annulling the Ukrainian Order for Courage.",
      "date": "2015-03-15 18:29:38"
    },
    {
      "id": "5b569460-6127-4883-ab59-9853548e4d9f",
      "text": "Bill Gates-funded company released genetically modified mosquitoes in the U.S. and caused a malaria outbreak.",
      "date": "2023-07-05 00:00:00+00:00"
    },
    {
      "id": "ab5521ed-0c5d-4fa6-8e45-5994d785c3a0",
      "text": "50% of Ukrainian refugees will stay in Poland.",
      "date": "2022-07-12 11:59:00"
    },
    {
      "id": "e5a07fbf-34c1-4129-aa0c-a60a22560819",
      "text": "China rejected imports of Ukrainian grain.",
      "date": "2016-08-31 21:40:02"
    },
    {
      "id": "6fe6fe1d-5649-46c3-b803-cf5637648f66",
      "text": "Published secret documents show Ukrainian troops committed violations in Donbas, and no one is investigating.",
      "date": "2019-09-05 19:33:33"
    },
    {
      "id": "f69d66c3-1c29-4ad0-8ed4-29471bb5254b",
      "text": "Ukraine deliberately cut off water supplies to occupied Luhansk.",
      "date": "2017-03-12 06:45:25"
    },
    {
      "id": "568d07cf-6cef-492d-b53a-8c7f0a97da4f",
      "text": "The U.S. Secretary of State's visit to Ukraine proves Ukraine has no chance of joining NATO.",
      "date": "2021-05-10 13:24:33"
    },
    {
      "id": "097ad6f5-be15-425b-9247-f5918bc3cf53",
      "text": "Ukraine denied accreditation to German election observers",
      "date": "2019-03-19 14:11:14"
    },
    {
      "id": "9addcae8-1045-4fe0-b2e5-557bb400cba4",
      "text": "Moringa supplements lower cortisol levels and improve overall health.",
      "date": "2024-10-15 00:00:00+00:00"
    },
    {
      "id": "68313ab6-a010-42dc-95fa-48d851f5286b",
      "text": "The number one indicator of parasitic infection is an autoimmune condition.",
      "date": "2023-08-07 00:00:00+00:00"
    },
    {
      "id": "e1e22820-8161-46f5-b0cc-f1b859444517",
      "text": "Ukrainian authorities are dooming the population to starvation.",
      "date": "2022-03-31 20:14:31"
    },
    {
      "id": "1f0568f0-449e-417e-8c8a-42e640838fd5",
      "text": "Only six Crimean citizens retained Ukrainian citizenship.",
      "date": "2014-04-04 16:56:24"
    },
    {
      "id": "7b26bbc6-19f7-43c0-a99f-5ee27fdfd37d",
      "text": "Crimeans voted to join Russia because Kyiv abused the peninsula.",
      "date": "2020-05-08 18:36:07"
    },
    {
      "id": "976a8b54-0e02-4acc-823e-24c922f31dd2",
      "text": "The CDC withdrew authorization for its 2019‑nCoV real‑time RT‑PCR test because that PCR test cannot distinguish COVID‑19 from influenza.",
      "date": "2021-07-24 00:00:00+00:00"
    },
    {
      "id": "4b063b61-17b0-408f-86e0-66307335ebcc",
      "text": "Sergey Lavrov said Russia is not a party to the armed conflict in Ukraine.",
      "date": "2020-09-24 17:23:15"
    },
    {
      "id": "2020bb2f-ce91-4d14-8fba-d22a6c3047e9",
      "text": "The Ukrainian national football team will be disqualified from future matches.",
      "date": "2016-12-07 22:15:22"
    },
    {
      "id": "af8e71ba-1347-49fb-872f-7d03c60cef83",
      "text": "Eating only meat provides a balanced diet.",
      "date": "2023-04-11 00:00:00+00:00"
    },
    {
      "id": "8624e824-6fbb-4d02-b248-4ac44bba4445",
      "text": "Blood pressure tracking apps can replace blood pressure cuffs",
      "date": "2024-04-08 00:00:00+00:00"
    },
    {
      "id": "6d3ca843-ac74-414a-8a9a-f9b3d840ad72",
      "text": "Petro Poroshenko deprived Chornobyl workers of benefits.",
      "date": "2016-04-13 21:44:52"
    },
    {
      "id": "a500fdc9-536c-4504-8762-dcf75b30807b",
      "text": "Lemon balm neutralizes and destroys all avian influenza viruses, including H5N1.",
      "date": "2024-11-03 00:00:00+00:00"
    },
    {
      "id": "3a4ce92d-731a-4392-9594-1a7f1b5bc5b2",
      "text": "Austria agreed to pay Russia for gas in rubles.",
      "date": "2022-04-27 14:37:09"
    },
    {
      "id": "9f514e31-b4e8-4fc2-881b-695f8c5800df",
      "text": "Vladimir Putin caused the rouble to collapse to trick Western financial sharks.",
      "date": "2015-01-03 17:59:48"
    },
    {
      "id": "38f377c1-4e31-4453-819e-2f821eff8ce0",
      "text": "Climate scientists disagree about how much warming human emissions caused and whether that warming is larger than natural variability from the sun and volcanic eruptions.",
      "date": "2024-04-26 00:00:00+00:00"
    },
    {
      "id": "a3feeb4a-df50-4aab-a818-f764236f8ad6",
      "text": "Nadiya Savchenko advocates granting amnesty to Donbas separatists.",
      "date": "2016-06-13 16:08:54"
    },
    {
      "id": "8c52f7f8-5666-4eab-9f59-fe86a57dd17a",
      "text": "The German Bundestag called for lifting sanctions on Russia to fight COVID-19.",
      "date": "2020-04-02 14:59:04"
    },
    {
      "id": "e9b47af3-f5e1-42a4-8210-70ba8ef8ce4b",
      "text": "Romanians in Bukovina demand autonomy",
      "date": "2015-08-08 10:55:58"
    },
    {
      "id": "2e952ecc-8a11-4728-a55a-b9070840e5cc",
      "text": "Ukraine is threatening to invade Russia.",
      "date": "2022-03-08 14:19:42"
    },
    {
      "id": "396aad09-0fc9-4db0-9583-50b9bdd71a16",
      "text": "Bananas are powerful antiviral foods that repel growth of the retrovirus HIV.",
      "date": "2021-02-21 00:00:00+00:00"
    },
    {
      "id": "95810909-9f05-4822-a380-9d9f192410dd",
      "text": "DMSO treats cancer",
      "date": "2025-08-04 00:00:00+00:00"
    },
    {
      "id": "fb31b421-1b69-46bd-9c81-a9d77c6fcf57",
      "text": "A recent bleaching-level heat stress event bleached 84% of the world's coral reefs.",
      "date": "2025-04-23 00:00:00+00:00"
    },
    {
      "id": "23c60597-be74-48f6-97fc-3631ba451bb8",
      "text": "Ukrainian forces committed a terrorist attack in Russia's Voronezh region.",
      "date": "2024-01-02 15:48:51"
    },
    {
      "id": "7b01c26e-2bc4-4c62-a665-fa6ab7dc8026",
      "text": "All pandemics are zoonotic, so a vegan world would have no pandemics.",
      "date": "2021-03-26 00:00:00+00:00"
    },
    {
      "id": "2781ff7d-9d7a-4c4b-bcf3-c264eed0ba36",
      "text": "U.S. mercenary Sean Fuller was killed in Donbas.",
      "date": "2020-07-18 11:20:08"
    },
    {
      "id": "9cd57b99-4d64-4360-96d8-f1e695967fb0",
      "text": "Lion's mane mushroom prevents Alzheimer's disease.",
      "date": "2023-10-05 00:00:00+00:00"
    },
    {
      "id": "e309b0fd-2252-4b9a-814a-9a55d2b4fba4",
      "text": "Ukraine loses economically from trade with the European Union.",
      "date": "2017-05-29 13:26:30"
    },
    {
      "id": "6c33f8ec-8406-40fd-858e-87acce3e0b2f",
      "text": "The COVID-19 vaccine killed 3.5 times more Americans than the COVID-19 virus.",
      "date": "2023-10-31 00:00:00+00:00"
    },
    {
      "id": "d59aa96a-97da-4753-a2ef-40d78a48c9a1",
      "text": "Ukraine will sell Crimea to Russia for $135 billion.",
      "date": "2021-08-09 10:06:00"
    },
    {
      "id": "40678ed6-372d-4f7b-8d1c-78ccee23a635",
      "text": "Salt and corn gluten meal are used to kill mice and are hazardous to humans.",
      "date": "2024-06-29 00:00:00+00:00"
    },
    {
      "id": "7239e2a8-d011-4bfb-8aed-0a709402fe71",
      "text": "Solar cycles and other natural Earth activity cause climate change; human (anthropogenic) CO2 emissions do not cause climate change.",
      "date": "2023-09-02 00:00:00+00:00"
    },
    {
      "id": "0de62fd1-eac4-4208-ba57-878dbab8308c",
      "text": "Kherson nationalists publicly swore allegiance to Adolf Hitler.",
      "date": "2015-07-04 12:56:21"
    },
    {
      "id": "79af6b5b-af58-4e0f-8fb9-0441d3728d4e",
      "text": "Herpes is not a sexually transmitted disease. A commercially available plant product cures herpes.",
      "date": "2023-04-19 00:00:00+00:00"
    },
    {
      "id": "0fb4eb94-796c-4474-822d-d49532bbdf78",
      "text": "The UK transferred uranium shells to Ukraine, constituting nuclear escalation and a new outbreak of aggression.",
      "date": "2023-03-22 15:25:30"
    },
    {
      "id": "e449ca29-0cdd-4df6-a8be-65ce5e2063ff",
      "text": "CyberBerkut blocked the Central Election Commission of Ukraine from carrying out its work.",
      "date": "2014-10-26 15:09:48"
    },
    {
      "id": "12f4269f-e670-4d9b-8ee1-fb1eb44c333b",
      "text": "Sea level at Sydney Harbour has not risen at all over the past 140 years.",
      "date": "2019-10-28 00:00:00+00:00"
    },
    {
      "id": "3bd18ad9-4a9a-4f65-aed3-f97bfcfa2305",
      "text": "Vaccination caused autism rates to decrease among high-income white households in California.",
      "date": "2024-03-10 00:00:00+00:00"
    },
    {
      "id": "48e29c96-9fcd-47ae-88ac-52d0cf5d5625",
      "text": "Crimea and Donbas residents are being deprived of all rights because they hold Russian citizenship.",
      "date": "2021-02-02 17:55:29"
    },
    {
      "id": "f9769b02-c023-424d-918c-79424431d746",
      "text": "Ukraine is being used as an experimental site to grow babies artificially.",
      "date": "2022-12-28 14:26:00"
    },
    {
      "id": "9794657c-ae61-4302-9788-2e8896e74cdd",
      "text": "Ukraine granted dual citizenship to Western lobbyists.",
      "date": "2019-02-28 16:45:22"
    },
    {
      "id": "8f0975f6-6d6e-4857-b113-2188906ebfc8",
      "text": "The United Nations demands that Ukraine recognize occupied territories.",
      "date": "2017-12-18 17:37:47"
    },
    {
      "id": "28861c5b-e399-4e62-aa35-4e22dbd2274d",
      "text": "The Federal Government of Germany provoked Russia with its actions regarding Aleksey Navalny.",
      "date": "2020-09-27 22:44:12"
    },
    {
      "id": "a9651ce2-41c6-4761-8d99-8fce6e172982",
      "text": "Ukraine is no longer an industrial nation.",
      "date": "2017-04-18 09:08:29"
    },
    {
      "id": "baa9cabd-e297-4048-a196-c125d4f55a45",
      "text": "Babies born to mothers vaccinated against COVID-19 are dying at higher-than-normal rates and the COVID-19 vaccines are causing those deaths.",
      "date": "2022-07-06 00:00:00+00:00"
    },
    {
      "id": "a1a4246c-cc65-437f-ade8-c42722b56648",
      "text": "Fukuyama claims Ukraine will not be able to return all of its territories.",
      "date": "2023-10-21 15:15:00"
    },
    {
      "id": "1b60a8c8-ce1d-4b0a-aebf-8bab19ffb83e",
      "text": "One thousand people in Sofia demanded that Ukraine stop repressions.",
      "date": "2015-05-23 19:23:28"
    },
    {
      "id": "ebbc58ff-b654-452d-826e-b4b7fb0c1dd4",
      "text": "Post-vaccine deaths cannot be categorized as vaccine-related.",
      "date": "2017-07-18 00:00:00+00:00"
    },
    {
      "id": "4ddf07b6-49d8-41d6-a6ff-cd4a4f5849f4",
      "text": "Most fully vaccinated people will develop vaccine-induced AIDS by the end of the month.",
      "date": "2022-01-22 00:00:00+00:00"
    },
    {
      "id": "19aa839c-e515-411d-bb73-8b1c0ef37901",
      "text": "The European Union refused to punish Russia for seizing Ukrainian ships in the Kerch Strait.",
      "date": "2018-12-18 13:26:14"
    },
    {
      "id": "36c0cd4a-8b15-43cc-ac7d-1fe603b67079",
      "text": "Sanctions imposed by Kyiv on Russian banks have worsened Ukraine’s investment climate.",
      "date": "2017-03-21 21:59:06"
    },
    {
      "id": "13dbfe73-0c74-42c4-8617-979b4f918ebb",
      "text": "The Red Cross collected data on the healthy organs of children in Mariupol.",
      "date": "2022-06-03 19:13:43"
    },
    {
      "id": "73ab226a-7dc0-426b-9964-0d1a732ae936",
      "text": "Cancer rates increased after COVID-19 vaccines were introduced, and this increase is causing U.S. life expectancy to decline.",
      "date": "2023-01-13 00:00:00+00:00"
    },
    {
      "id": "5242cdbf-b4c2-48b2-8319-ef7cb0bb36db",
      "text": "A death at a checkpoint was caused by a Ukrainian provocation.",
      "date": "2020-06-15 22:26:57"
    },
    {
      "id": "d50f8b96-1672-465a-8227-62e198faf14a",
      "text": "Russian flags were flown in Kyiv by mistake.",
      "date": "2015-07-07 12:26:12"
    },
    {
      "id": "2760dd91-0822-4c04-8c1a-3ee7deeebdd0",
      "text": "Obama asked Poroshenko to invite him to Crimea.",
      "date": "2015-09-04 21:00:42"
    },
    {
      "id": "d284b953-af10-4aa8-9389-f4d2744e9454",
      "text": "Ukraine's Foreign Ministry accused the European Union of betraying Ukraine.",
      "date": "2016-12-16 22:33:27"
    },
    {
      "id": "276aa55d-6a95-4170-9844-c67c54a5881d",
      "text": "COVID-19 vaccines are being administered incorrectly.",
      "date": "2021-10-14 00:00:00+00:00"
    },
    {
      "id": "1338c7bf-e4d8-4a04-a092-fad1f6993163",
      "text": "Tattoo ink contains cancer-causing heavy metals, and zeolite removes those heavy metals from the body.",
      "date": "2024-04-10 00:00:00+00:00"
    },
    {
      "id": "b72f3359-fc17-4fa0-aa39-f3c1d260a395",
      "text": "Ukraine is opening camps for Syrian refugees.",
      "date": "2017-04-01 17:40:53"
    },
    {
      "id": "f6592f88-c9d5-436e-8cf1-f64e132ac10a",
      "text": "COVID-19 vaccines are causing embalmers to find strange clots in corpses.",
      "date": "2022-12-09 00:00:00+00:00"
    },
    {
      "id": "b99ed213-2fc7-44fe-8158-11de1ce92fd8",
      "text": "Ukrainians want to go to Russia and demand trains to Crimea.",
      "date": "2019-08-01 15:52:54"
    },
    {
      "id": "fbda447a-c249-4c5a-a81d-63707fa8a879",
      "text": "Ukrainian military cannot operate American weapons.",
      "date": "2018-04-13 21:06:15"
    },
    {
      "id": "12de5676-5208-4063-93d7-48bcb3386041",
      "text": "Ukraine wants to exchange Crimea for Transnistria",
      "date": "2017-11-22 18:45:02"
    },
    {
      "id": "cf13ec5a-1de0-4158-9907-0e98d2f0b2b2",
      "text": "Since COVID-19 vaccines were rolled out, a midwife has observed that all placentas are abnormal and compromised.",
      "date": "2023-04-25 00:00:00+00:00"
    },
    {
      "id": "16a1d1b2-6f66-4f97-bc3a-1662c94b64a7",
      "text": "The Ukrainian military shelled a bus stop in Donetsk.",
      "date": "2014-10-05 11:37:58"
    },
    {
      "id": "7fd92c05-9204-46f4-9028-9475c4582ddd",
      "text": "Ukrainian authorities drained the Dnipro River to deploy armed forces on the left bank.",
      "date": "2023-01-22 13:20:00"
    },
    {
      "id": "427063bc-a537-4e80-a198-25b80179f288",
      "text": "The survival rate for COVID-19 is 99.96%.",
      "date": "2020-08-21 00:00:00+00:00"
    },
    {
      "id": "13a6d66c-1a1c-4778-b975-22861081ce05",
      "text": "Carbon dioxide is not a primary contributor to global warming.",
      "date": "2017-10-03 00:00:00+00:00"
    },
    {
      "id": "e837d726-7aa9-4092-aa12-ef20fe1d288a",
      "text": "Jacques Attali wrote that elites will create a pandemic to reduce the population and will have planned its treatment.",
      "date": "2022-12-21 00:00:00+00:00"
    },
    {
      "id": "02177f79-3fcc-4614-bb58-b540b9b8a755",
      "text": "Poroshenko was booed and whistled at by students in Zurich.",
      "date": "2015-01-22 09:48:44"
    },
    {
      "id": "57ae1e09-8cba-4774-b8e9-155af7a9e12f",
      "text": "The Maidan protests and the economic crisis caused a tuberculosis epidemic in Ukraine.",
      "date": "2017-03-28 03:42:41"
    },
    {
      "id": "a9df46be-ed24-4685-bb08-5aac2eaaf343",
      "text": "A Defense Ministry secret document reveals the actual losses of the Ukrainian Armed Forces.",
      "date": "2022-08-24 11:48:00"
    },
    {
      "id": "7e6c3b85-9bc1-4c85-add5-4280090cc98d",
      "text": "Climate change is making extreme weather events, including tornadoes, worse.",
      "date": "2019-08-03 00:00:00+00:00"
    },
    {
      "id": "708a59bc-3706-407b-8bed-aca62b3a0e0b",
      "text": "Eighteen climate proxies show the global temperature 1,000 years ago was the same as or higher than today.",
      "date": "2019-05-08 00:00:00+00:00"
    },
    {
      "id": "078df374-e1cc-45cd-b89d-fc04a0086df0",
      "text": "Lviv demolishes WWII Glory Monument",
      "date": "2017-07-11 18:28:31"
    },
    {
      "id": "6722e272-3d35-49c3-97d1-95e27ae4caa5",
      "text": "Ukrainian Armed Forces are not resisting the Russian invasion.",
      "date": "2022-02-24 09:30:25"
    },
    {
      "id": "27699f3d-62b2-4450-9a56-170616f84fde",
      "text": "The United States reported 144,305 new COVID-19 cases, breaking the prior record of 133,819 and marking eight consecutive days with over 100,000 cases.",
      "date": "2020-11-13 00:00:00+00:00"
    },
    {
      "id": "b270dea8-050d-4024-876f-14717220a796",
      "text": "Carbon dioxide does not control the climate.",
      "date": "2022-02-09 00:00:00+00:00"
    },
    {
      "id": "5d80c8af-4946-454c-85dd-5a000e0466a3",
      "text": "COVID-19 vaccines caused monkeypox; a 2021 tabletop exercise that simulated a monkeypox pandemic proves global leaders planned the outbreak; the monkeypox vaccine was ready before the outbreak.",
      "date": "2022-05-13 00:00:00+00:00"
    },
    {
      "id": "40a1f1b1-475e-4194-80de-4218fe12446a",
      "text": "Ukrainian refugees burned a Russian flag and set fire to a house in Germany.",
      "date": "2022-05-20 13:53:03"
    },
    {
      "id": "c27701ba-9c1a-481d-b0a0-fb14a12af237",
      "text": "The FDA allows doctors to prescribe ivermectin for COVID-19.",
      "date": "2023-08-24 00:00:00+00:00"
    },
    {
      "id": "281cf79d-9b45-4672-9aa2-739fdb931d01",
      "text": "Nuland warned Surkov that a NATO attack was inevitable.",
      "date": "2016-01-18 20:24:54"
    },
    {
      "id": "f430114c-0a7c-4439-b956-63fb68e8fe59",
      "text": "Ukraine’s president Volodymyr Zelensky acknowledged that Ukraine lost the Donbas region.",
      "date": "2017-03-21 22:21:54"
    },
    {
      "id": "46ccbb30-6967-414e-a158-c7235dff817a",
      "text": "All Ukrainian refugees are willingly going to Russia.",
      "date": "2022-04-15 14:04:35"
    },
    {
      "id": "7a0a519a-abe5-4d16-b25b-95b7dd5dd4f6",
      "text": "Kyiv is one of the 10 worst cities to live in.",
      "date": "2023-06-25 12:45:00"
    },
    {
      "id": "b1e6964f-cf85-4fe8-b3cd-e36bae98b74b",
      "text": "University of Turin recognizes Donetsk People's Republic diplomas",
      "date": "2018-05-08 21:07:22"
    },
    {
      "id": "a8c3c106-7f49-4e8d-b998-9325e7b29179",
      "text": "The Azov Regiment attacked a humanitarian convoy.",
      "date": "2022-04-19 15:03:00"
    },
    {
      "id": "0c210184-be10-40d1-a5ef-5c5c5f272897",
      "text": "Ukrainian military shelled OSCE monitors.",
      "date": "2016-09-13 17:30:00"
    },
    {
      "id": "7a88ce76-3d77-4aae-b093-fd98ef26f4d5",
      "text": "A nuclear explosion occurred in Ukraine.",
      "date": "2017-04-20 15:37:52"
    },
    {
      "id": "5ffb9f22-74b9-4d3f-8577-578f0aadeb63",
      "text": "US regions with higher average COVID-19 vaccine doses experienced larger increases in mortality in 2022 than in 2021.",
      "date": "2023-01-24 00:00:00+00:00"
    },
    {
      "id": "8e94c22c-9394-4644-8c86-53923aa6f4c4",
      "text": "COVID-19 vaccines weaken the immune system and an Idaho doctor reports a 20-fold increase in cancer among vaccinated patients.",
      "date": "2021-09-13 00:00:00+00:00"
    },
    {
      "id": "81e0ef7d-ddb3-4378-bd60-543568936e03",
      "text": "NOAA alters climate data using complex statistical models so the data reflect NOAA’s global warming theories rather than reality.",
      "date": "2018-03-29 00:00:00+00:00"
    },
    {
      "id": "ac94c666-f650-45c6-b4b7-6e850d36774d",
      "text": "COVID-19 vaccines have caused as many deaths in young people as COVID-19 disease has.",
      "date": "2021-05-29 00:00:00+00:00"
    },
    {
      "id": "a4290403-d70c-4974-84e2-44718132a241",
      "text": "A memorial plaque in Kyiv was destroyed.",
      "date": "2015-07-16 16:21:22"
    },
    {
      "id": "852533f6-e8e6-43a6-a937-f11d74216ec4",
      "text": "Antarctica's perimeter is larger than Earth's circumference, proving Antarctica is an ice wall and the Earth is flat.",
      "date": "2025-02-08 00:00:00+00:00"
    },
    {
      "id": "666a0302-51a9-4c85-b6d3-9d5c2ff3f4cc",
      "text": "Kyiv deliberately caused a blackout in Moldova.",
      "date": "2026-01-31 00:00:00+00:00"
    },
    {
      "id": "5539f9d0-477d-421f-b465-b41852681b1d",
      "text": "The United States supported federalization of Ukraine.",
      "date": "2014-03-31 23:55:02"
    },
    {
      "id": "48426c97-7d6a-432e-b843-39c651e804b5",
      "text": "A RAND Corporation document shows the US planned to cause a conflict and an energy crisis in Europe.",
      "date": "2022-09-23 10:56:00"
    },
    {
      "id": "e85cc452-7f15-496d-99e7-e29d1ac05981",
      "text": "The Bucha atrocities, the chemical attack in Syria, and the White Helmets' rescue operations were staged by Western governments.",
      "date": "2022-04-15 10:45:00"
    },
    {
      "id": "c3751919-18d3-47c2-9167-edfff84722d8",
      "text": "Zelenskyy expressed condolences and urged Turkey to supply Ukraine more aid.",
      "date": "2023-02-09 17:53:00"
    },
    {
      "id": "c73cc4c2-ee3a-40b7-aebb-35016faadea0",
      "text": "The American Medical Association reversed course and authorized doctors to prescribe hydroxychloroquine for COVID-19 patients.",
      "date": "2020-12-22 00:00:00+00:00"
    },
    {
      "id": "aee0cb83-07c1-42bb-bf33-73e771d68a50",
      "text": "Oral contraceptive pills are the leading cause of polycystic ovary syndrome, and wild yam combined with castor oil cures polycystic ovary syndrome and uterine fibroids.",
      "date": "2024-08-15 00:00:00+00:00"
    },
    {
      "id": "622159aa-c1c6-4f15-835f-7664880f27c2",
      "text": "Hundreds of children were killed to create COVID-19 vaccines.",
      "date": "2021-02-11 16:31:00"
    },
    {
      "id": "a820a710-7fc3-4d8c-b0eb-29a62b39bc95",
      "text": "A Ukrainian refugee drew a swastika in a British mall.",
      "date": "2022-09-25 10:50:00"
    },
    {
      "id": "f9bcc584-69cd-4b2b-a377-89b89ff8b19e",
      "text": "Receiving the Pfizer COVID-19 vaccine increases the risk of getting COVID-19.",
      "date": "2021-09-30 00:00:00+00:00"
    },
    {
      "id": "9f5d4982-9ec4-446d-ac05-eb1dbf28db7e",
      "text": "Thimerosal, ovalbumin, formaldehyde, and sodium deoxycholate are known neurotoxins.",
      "date": "2016-10-08 00:00:00+00:00"
    },
    {
      "id": "a13c9705-08c7-4902-be92-bdd7400fe68c",
      "text": "An American COVID-19 vaccine killed a Ukrainian serviceman.",
      "date": "2020-10-25 14:38:00"
    },
    {
      "id": "511ed949-e4e4-4397-9aea-9c078bc7cdba",
      "text": "The first AI-led peer-reviewed climate science paper confirmed that climate change is a hoax.",
      "date": "2025-03-21 00:00:00+00:00"
    },
    {
      "id": "edfc6794-b92b-4d2c-aa29-931e67ed4a5f",
      "text": "A Ukrainian airliner that was downed in Iran was controlled by the United States.",
      "date": "2020-04-08 00:36:00"
    },
    {
      "id": "23d2674e-201f-436f-8ba5-f9634b22452b",
      "text": "Minors in Ukraine are eligible for military contracts.",
      "date": "2025-06-10 00:00:00+00:00"
    },
    {
      "id": "205ee47e-0b88-48c4-bc25-bd44daed69fd",
      "text": "Kyiv expelled homeless people from the city for Eurovision",
      "date": "2017-04-28 19:53:55"
    },
    {
      "id": "4e5b22dd-ab03-436c-ac85-a6195d7b65cb",
      "text": "Russia threatens Ukraine’s civilian population.",
      "date": "2022-02-25 11:23:57"
    },
    {
      "id": "1ea025bc-37bf-4c08-96c3-faee33d6f7c1",
      "text": "The HPV vaccine increases the risk of developing cervical cancer.",
      "date": "2024-03-27 00:00:00+00:00"
    },
    {
      "id": "4e7475b9-3013-439d-bac9-d3f060ccf7e6",
      "text": "A missile serial number confirms that the Kramatorsk train station was hit by a Ukrainian Tochka‑U missile.",
      "date": "2022-04-10 19:14:43"
    },
    {
      "id": "94b0599d-5280-4eb1-a5c4-ebb69a354aad",
      "text": "Ukraine's Parliamentary Speaker calls for a new Maidan.",
      "date": "2019-05-24 09:35:21"
    },
    {
      "id": "569c9fdc-c50c-40ec-8253-6f83dfb0844f",
      "text": "Ukraine threatened Russia with war.",
      "date": "2020-07-06 14:06:38"
    },
    {
      "id": "425afd42-325e-44a6-a89b-4d35781ffd50",
      "text": "Terrorists were arrested in Crimea.",
      "date": "2020-07-09 18:00:00"
    },
    {
      "id": "32ffa954-dc22-40d1-96e3-96b6f192825b",
      "text": "Fitch issued a disappointing forecast for Ukraine.",
      "date": "2017-11-01 14:18:07"
    },
    {
      "id": "d80bebb7-3a6f-4623-80fa-7326d471c3a4",
      "text": "A Ukrainian plane was shot down in Iran because it carried Iranian nuclear physicists.",
      "date": "2020-01-17 21:34:05"
    },
    {
      "id": "91924ffb-2ec1-49ed-8ca6-a0b9686c4c88",
      "text": "Poland blocks cargo transports from Ukraine to Europe",
      "date": "2017-11-18 21:30:07"
    },
    {
      "id": "ba0ef9b9-0a68-4dbd-93b2-7b293f43f319",
      "text": "The government of Ukraine refuses to respect human rights in the southeast of the country.",
      "date": "2015-05-25 19:33:12"
    },
    {
      "id": "15a2de90-4297-4571-9ce7-16e49442c14a",
      "text": "The President of Poland called for the return of Ukrainian territory to Poland.",
      "date": "2015-10-23 17:13:33"
    },
    {
      "id": "3982f6ff-e14a-4a9d-be0a-90a7aa933551",
      "text": "A Ukrainian activist called the September 11 attacks \"God's punishment for Americans.\"",
      "date": "2024-09-19 13:56:00"
    },
    {
      "id": "dcc4a80a-81d4-43fe-aa58-e3bd7b68cb02",
      "text": "Women are not warned that their daily steroidal hormone pill causes blood clots.",
      "date": "2015-05-07 00:00:00+00:00"
    },
    {
      "id": "2811b1f1-4d62-4902-b97a-4a3797d99845",
      "text": "Measles prevents cancer and provides long-term health benefits.",
      "date": "2025-02-20 00:00:00+00:00"
    },
    {
      "id": "dfeb95b3-8fdd-4583-ac1f-66a47fff194b",
      "text": "Ukrainian military beat Andrey Makarevich at a concert in Kharkiv.",
      "date": "2015-05-10 17:08:43"
    },
    {
      "id": "bbc96af2-eb24-4264-884c-ef5aeec83436",
      "text": "Polish students attacked a Ukrainian schoolgirl.",
      "date": "2017-05-17 14:34:26"
    },
    {
      "id": "7eb508d8-7356-4029-85fc-3cd4e5adabd7",
      "text": "Ukrainians demanded ransom from the family of a deceased Hamas hostage.",
      "date": "2023-11-03 11:18:00"
    },
    {
      "id": "ce34df8f-a86f-47f8-94f6-b6763533d968",
      "text": "A South Korean study found that COVID-19 vaccines increase the risk of cancer.",
      "date": "2025-09-30 00:00:00+00:00"
    },
    {
      "id": "7df04e24-fd6c-4618-916b-acacd3af5fe6",
      "text": "Ukraine exported grain to Western countries and did not export grain to needy African countries.",
      "date": "2022-08-15 16:54:00"
    },
    {
      "id": "70eed460-6914-49b4-bb84-aaaec6fa2922",
      "text": "Most Ukrainians consider the Donbas conflict a civil war.",
      "date": "2018-10-25 19:08:48"
    },
    {
      "id": "3f2eac23-d6cf-49de-bae9-23f6f126613a",
      "text": "Coronavirus spread rapidly worldwide in October 2019.",
      "date": "2020-05-08 00:00:00+00:00"
    },
    {
      "id": "f08b015a-22f5-4f03-a884-d70f9da97189",
      "text": "The European Union no longer trusts NATO or the United States.",
      "date": "2019-06-27 10:16:47"
    },
    {
      "id": "a48c2d4a-ca9d-4583-ad77-e97dc4ceddad",
      "text": "Ukraine is preparing a Bucha-style provocation using Supernova Airlines passengers.",
      "date": "2024-11-01 00:00:00+00:00"
    },
    {
      "id": "71cecf6b-1122-4c2c-8ea4-48558d89a707",
      "text": "The European Union seeks to improve relations with Russia at any cost.",
      "date": "2018-01-03 23:28:05"
    },
    {
      "id": "e630a528-9654-4292-b306-4be1aede0a0f",
      "text": "The Pfizer COVID-19 bivalent vaccine increases the risk of stroke.",
      "date": "2023-02-11 00:00:00+00:00"
    },
    {
      "id": "7d58789a-930b-4bde-b413-904cf956b97b",
      "text": "Tillerson said the United States will recognize Crimea as Russian if specified conditions are met.",
      "date": "2017-01-13 21:26:15"
    },
    {
      "id": "94a5d13f-6c49-487a-b51a-ccb0748b111c",
      "text": "Kyiv forcibly drafted ethnic Hungarians.",
      "date": "2026-02-09 00:00:00+00:00"
    },
    {
      "id": "6c74371b-9156-4527-bd46-33afea027602",
      "text": "The Lviv Jazz Festival was cancelled due to uncollected garbage.",
      "date": "2017-06-26 12:45:15"
    },
    {
      "id": "6ec4ed54-0f02-4ca4-a2e5-1713fca9e731",
      "text": "Covid-19 vaccine effectiveness fell from 100% to 20%; early reported vaccine effectiveness figures were lies.",
      "date": "2022-12-01 00:00:00+00:00"
    },
    {
      "id": "7ae5ac2a-e77e-45f9-a09d-b48ed86247ed",
      "text": "Renewable energy is not green: by 2050, 78 million metric tonnes of solar panels will reach end of life and cannot be recycled.",
      "date": "2024-09-29 00:00:00+00:00"
    },
    {
      "id": "95e8dca6-eba1-4ae8-abe6-1699e963f71b",
      "text": "Arseniy Yatsenyuk sided with the Right Sector in the Zakarpattia Oblast conflict.",
      "date": "2015-07-15 11:17:42"
    },
    {
      "id": "f3693f4c-6543-41d1-afc8-120d2fb1edf8",
      "text": "Ukrainian President Volodymyr Zelensky calls for a preemptive nuclear strike on Russia.",
      "date": "2023-02-04 15:48:00"
    },
    {
      "id": "e355827b-0900-4843-b234-fcf2d8dc9d3a",
      "text": "Islamic radicals are flocking to southern Ukraine.",
      "date": "2016-10-31 16:19:42"
    },
    {
      "id": "d393ae41-2620-4022-acb5-4fcbc7c76ec6",
      "text": "Andriy Parubiy was behind the Maidan shootings, the Odessa Trade Union arson, and the Ukraine coup.",
      "date": "2025-09-01 00:00:00+00:00"
    },
    {
      "id": "54a197a9-396b-4264-872d-94d97c27fbfa",
      "text": "Documents show Crimea belongs to Russia.",
      "date": "2014-03-12 15:30:53"
    },
    {
      "id": "98383b6c-d1d4-471b-9076-e2507500a31b",
      "text": "Eating onions cures RSV and makes you sleep at night.",
      "date": "2024-11-10 00:00:00+00:00"
    },
    {
      "id": "e922300e-8398-4290-a14b-22c277ffc866",
      "text": "The Ukrainian authorities demand the extradition of an EU Member of Parliament.",
      "date": "2017-06-02 22:10:31"
    },
    {
      "id": "e1282797-5c59-4c8e-9869-25dd7feed8ec",
      "text": "The exact same group of experts who claimed there was global cooling in 1977 now claim there is global warming.",
      "date": "2019-12-16 00:00:00+00:00"
    },
    {
      "id": "534fe008-9f9d-43c8-98e6-feb5d976c1e5",
      "text": "The CDC admits that being fully vaccinated does not protect against the Delta variant and increases infections.",
      "date": "2021-08-13 00:00:00+00:00"
    },
    {
      "id": "3d30e612-8d52-47bb-b24e-3c6c55d6798c",
      "text": "An FDA study found vaccines made in living cells are contaminated with hidden viral fragments that cause cancer.",
      "date": "2020-01-31 00:00:00+00:00"
    },
    {
      "id": "80f457ab-70e1-4f4d-b0b7-55e5496c3cc6",
      "text": "Poland recognizes Crimea as part of Russia",
      "date": "2015-04-28 18:31:02"
    },
    {
      "id": "15558040-1082-40ab-b3ee-92ad2117bd2e",
      "text": "Bill Gates is pumping mRNA into the food supply to force-vaccinate unvaccinated people.",
      "date": "2023-01-18 00:00:00+00:00"
    },
    {
      "id": "32d2b9c5-4f9d-4841-b031-0779293587e4",
      "text": "Ukraine refuses to claim custody of its prisoners of war held in territories occupied by Russia.",
      "date": "2018-06-23 10:13:10"
    },
    {
      "id": "eade3386-0e7c-4d86-b898-d4d10a95072a",
      "text": "A Ukrainian general predicts Ukraine will lose control of the Sea of Azov and the Black Sea.",
      "date": "2021-05-31 18:20:00"
    },
    {
      "id": "2598f3d6-3972-4e7e-9a44-f2e6e903bf9f",
      "text": "Recent climate change is normal because past hot and cold periods occurred, and future climate change cannot be predicted because weather cannot be predicted accurately over days to weeks.",
      "date": "2024-08-09 00:00:00+00:00"
    },
    {
      "id": "305207e2-9826-4409-b2f3-7a186de5ee2b",
      "text": "Official figures show mean global temperature declined over the past 10 years.",
      "date": "2017-08-10 00:00:00+00:00"
    },
    {
      "id": "459a7c39-7561-4c42-8b32-f60835558e46",
      "text": "COVID-19 vaccines are causing a massive tsunami of COVID-19 hospitalizations and deaths through immune escape, and vaccine-induced immune dysregulation is turning COVID-19 into a chronic disease called long COVID.",
      "date": "2024-03-31 00:00:00+00:00"
    },
    {
      "id": "d424c471-7aaf-428d-9186-8d8442cbce27",
      "text": "European governments accuse Ukraine of flooding the EU with heroin.",
      "date": "2017-12-22 17:57:25"
    },
    {
      "id": "21d74062-be4e-4d10-a0d8-33bb9fd723b9",
      "text": "The Ukrainian Army deployed Polish soldiers to Donbas.",
      "date": "2018-10-19 10:09:04"
    },
    {
      "id": "6d21c206-996c-4e4a-85fd-d9df9ec56bdb",
      "text": "Mass COVID-19 vaccination caused the excess deaths observed through 2022.",
      "date": "2022-11-02 00:00:00+00:00"
    },
    {
      "id": "3cb094ff-b29e-486c-99cd-938e3eb40fb8",
      "text": "HAARP deliberately creates global-scale earthquakes, cyclones, floods, and snowstorms and deliberately attacks the world's citizens by telepathically influencing their thoughts with low-frequency vibrations.",
      "date": "2020-12-11 00:00:00+00:00"
    },
    {
      "id": "b286a749-9752-4d5c-a479-037bff83d4f5",
      "text": "Zhytomyr city authorities called on residents not to oppose the Russian army.",
      "date": "2022-03-16 12:12:36"
    },
    {
      "id": "a1b34fd3-9e14-4812-b52c-ed9c8fd128eb",
      "text": "Cow milk contains the most relevant carcinogen ever identified and triggers cancer.",
      "date": "2019-01-30 00:00:00+00:00"
    },
    {
      "id": "48aa8890-a376-420a-bea0-d18e73298f49",
      "text": "Gargling with warm salt water or vinegar eliminates SARS-CoV-2.",
      "date": "2020-03-27 00:00:00+00:00"
    },
    {
      "id": "c6920b0d-019e-426e-a9f1-94a2c661ee47",
      "text": "Ukraine plotted the assassination of French President Emmanuel Macron.",
      "date": "2024-02-14 11:22:00"
    },
    {
      "id": "761d7708-e063-40df-b169-11813b9c5a1a",
      "text": "The Ukrainian hryvnia will collapse.",
      "date": "2018-09-03 06:33:05"
    },
    {
      "id": "f834d89b-72a5-4444-9ae0-dc1689e04181",
      "text": "Poroshenko blocks visa-free entry of Ukrainians to Russia.",
      "date": "2015-12-30 09:37:04"
    },
    {
      "id": "84f85dfb-f8b6-4bc9-8b68-c8f9e31f70ff",
      "text": "Ukraine solicited funds to host Eurovision 2017.",
      "date": "2016-07-28 22:20:42"
    },
    {
      "id": "49ed25a7-1dbd-41a6-8bb7-f47041bfa75d",
      "text": "US state governments have banned chemtrails, confirming that secret government programs use chemtrails to harm the public and the environment.",
      "date": "2024-01-12 00:00:00+00:00"
    },
    {
      "id": "5191a2b0-b6ba-406f-955e-eeea758651bd",
      "text": "COVID-19 vaccines are unnecessary because vaccinated people still get COVID-19 and are required to wear masks.",
      "date": "2021-12-02 00:00:00+00:00"
    },
    {
      "id": "e347b4bf-00aa-43d1-b060-2fddcd12d86a",
      "text": "COVID-19 vaccines are sexually transmitted to unvaccinated people, cause blood discoloration, and weaken the immune system.",
      "date": "2023-09-27 00:00:00+00:00"
    },
    {
      "id": "aa552ce2-0693-4f24-b8aa-d44db6148533",
      "text": "Robert Fico, Viktor Orban, and Aleksandar Vucic's approval ratings increased after their trip to Moscow.",
      "date": "2025-05-15 00:00:00+00:00"
    },
    {
      "id": "f9bbeb23-497c-4d13-8beb-ceddba749004",
      "text": "Ukrainian troops killed a separatist defector.",
      "date": "2018-07-25 14:22:39"
    },
    {
      "id": "0a46dcee-f394-4142-a759-f623d40f2993",
      "text": "Russia's war in Ukraine conforms with the UN Charter.",
      "date": "2022-04-27 17:24:00"
    },
    {
      "id": "a7f471f0-c804-4bf4-9e64-75b4b344ca1e",
      "text": "Ukrainian President Volodymyr Zelensky will legalize Poland's seizure of Ukrainian territory.",
      "date": "2022-06-04 19:26:00"
    },
    {
      "id": "80ddb716-250d-49cb-a86c-cefd8e85d239",
      "text": "The Ukrainian cities Kharkiv, Mykolayiv and Odesa want to return to Russia.",
      "date": "2020-07-31 08:31:40"
    },
    {
      "id": "b3b4dccc-edc1-4594-a17b-eb8a8871eb05",
      "text": "A Ukrainian UJ-22 airborne drone was shot down over Kursk Province.",
      "date": "2022-04-25 15:03:00"
    },
    {
      "id": "a34da33f-f9dd-4652-bf9b-d5fc598b1fa4",
      "text": "Yulia Tymoshenko is planning a coup.",
      "date": "2016-03-15 22:04:56"
    },
    {
      "id": "a10fa490-b372-42ce-b4dd-106ad67c6d58",
      "text": "Antarctic sea ice is increasing to record levels; Antarctica is getting colder and its sea ice and ice cap are not melting.",
      "date": "2023-04-28 00:00:00+00:00"
    },
    {
      "id": "f8df93c6-49fd-4b41-8315-24f1be63730c",
      "text": "Electric vehicles are less environmentally friendly than combustion vehicles because their metal production causes greater environmental harm, and electrifying road transport simply shifts CO2 emissions from tailpipes to power plants.",
      "date": "2024-10-28 00:00:00+00:00"
    },
    {
      "id": "a17cc408-1d6a-490d-8453-7ec64b9273e6",
      "text": "Sea level rise predates human influence and has not accelerated.",
      "date": "2016-10-25 00:00:00+00:00"
    },
    {
      "id": "6b0cb1c7-5e1c-4678-9dfe-c6f8b5a13b7b",
      "text": "Ukraine secretly ceded its borders to the EU.",
      "date": "2018-11-08 22:17:03"
    },
    {
      "id": "5d06354f-3729-4ab5-b52d-859acce95585",
      "text": "Cooking with aluminum foil causes Alzheimer’s disease and cancer.",
      "date": "2024-03-22 00:00:00+00:00"
    },
    {
      "id": "b743ccc3-2ad1-4531-aeb5-3f9ee4ef1afe",
      "text": "The Governor of Maine ordered restaurant staff to wear COVID visors shaped like dog cones.",
      "date": "2020-08-18 00:00:00+00:00"
    },
    {
      "id": "0d2969a9-c361-446f-b6d3-6b39780b39c9",
      "text": "Ukraine’s Culture Minister falsified history and denied the Holocaust.",
      "date": "2021-10-12 18:10:01"
    },
    {
      "id": "a28cffa1-f1e8-459e-884d-d1249a1d0ab2",
      "text": "Alzheimer's disease existed 40 years ago, and cholesterol-lowering drugs and cholesterol-lowering diets cause Alzheimer's disease.",
      "date": "2023-03-21 00:00:00+00:00"
    },
    {
      "id": "de00440f-228d-4c2d-ad87-5293bd2571a1",
      "text": "International observers accuse the Ukrainian military of committing genocide against civilians.",
      "date": "2015-02-03 12:47:14"
    },
    {
      "id": "a9706be2-7458-4a21-babc-81684e231d94",
      "text": "A Ukrainian soldier willingly joined separatist forces",
      "date": "2018-06-16 10:59:55"
    },
    {
      "id": "b866256c-d159-42f2-9b79-b437f21f7e46",
      "text": "Prenatal ultrasound causes miscarriage and heritable genetic damage.",
      "date": "2021-10-21 00:00:00+00:00"
    },
    {
      "id": "77173a67-8198-4e1d-b0ef-7f2f6804027f",
      "text": "A rainbow flag was raised over Kyiv to replace Ukrainian values and falsify history.",
      "date": "2020-06-24 21:27:39"
    },
    {
      "id": "339fd89e-9069-4cd1-adab-6b245515d392",
      "text": "Kharkiv has no electricity while Kyiv sells surplus electricity abroad.",
      "date": "2024-04-21 19:37:00"
    },
    {
      "id": "64a08c8e-1e38-4b1e-9ea7-be63fab1aef1",
      "text": "The 4 July 2025 Texas floods were caused by a dam release and no footage shows rain during the floods.",
      "date": "2025-07-06 00:00:00+00:00"
    },
    {
      "id": "9d59eafd-dac1-4668-b3a4-5267c5102263",
      "text": "COVID-19 vaccines increase the incidence of heart conditions and cancer.",
      "date": "2024-01-23 00:00:00+00:00"
    },
    {
      "id": "96d8b95e-2b0a-4a6d-bc0c-0a975baa522c",
      "text": "Acting Minister of Health bans antiseptics",
      "date": "2019-03-21 09:11:54"
    },
    {
      "id": "70c1009e-90bb-45b3-9841-3a11d82b6d55",
      "text": "One in 1,000 children vaccinated against COVID-19 died from the vaccine.",
      "date": "2021-10-02 00:00:00+00:00"
    },
    {
      "id": "c08b92a0-63c1-481e-8fbb-220d1bec1e18",
      "text": "Ukrainian Orthodox Churches celebrate Halloween.",
      "date": "2023-11-06 14:22:00"
    },
    {
      "id": "bf409d71-b0a9-4311-a682-6b872b61d969",
      "text": "The CDC illegally inflated COVID-19 death counts by at least 1,600% by issuing NVSS COVID‑19 Alert No. 2, which shifted underlying causes from Part I to Part II of death certificates and reversed the 2003 certification guidance.",
      "date": "2021-02-09 00:00:00+00:00"
    },
    {
      "id": "43e60ecb-14ff-495d-820e-25f786390e22",
      "text": "The European Union is using new colonization methods to take control of countries.",
      "date": "2019-04-14 18:45:15"
    },
    {
      "id": "ac8a6a2a-4e83-470a-ad51-1f2339e8ceee",
      "text": "Danish researchers found that COVID-19 vaccine protection against the Omicron variant became negative three months after the second dose.",
      "date": "2022-01-06 00:00:00+00:00"
    },
    {
      "id": "f477af0a-dd48-4c7d-a950-1f2cd381cbb2",
      "text": "Poroshenko said European armies are militarily superior to Ukraine’s armed forces.",
      "date": "2017-04-21 16:59:45"
    },
    {
      "id": "61e43457-f3a7-4d90-a467-42a40846a89d",
      "text": "Raw manuka honey kills every bacterium scientists expose to it, including antibiotic-resistant superbugs.",
      "date": "2020-01-18 00:00:00+00:00"
    },
    {
      "id": "f6cba773-bc49-4608-83f0-216fe40c94c6",
      "text": "Flu vaccines contain ingredients derived from dogs.",
      "date": "2024-11-26 00:00:00+00:00"
    },
    {
      "id": "01c7f4c3-c3d1-4952-9dc8-ac43685ce347",
      "text": "Russian specialists modernized the Kakhovka Hydroelectric Power Plant and increased its capacity by 30%.",
      "date": "2022-08-09 07:53:58"
    },
    {
      "id": "e104a744-7f4e-4aae-b81d-466cb73a33a5",
      "text": "5G at 60 GHz prevents the human body and blood from absorbing oxygen, and doctors describe this in COVID-19 cases.",
      "date": "2020-04-06 00:00:00+00:00"
    },
    {
      "id": "07f2b85e-df16-4ab8-8ca2-bc976eb20284",
      "text": "Roman Shukhevych’s bust from the destroyed Lviv museum was recycled into scrap metal.",
      "date": "2024-01-05 10:00:00"
    },
    {
      "id": "d7f7cb52-20d0-41e8-8343-64bd00f61be3",
      "text": "Speaking foreign languages is prohibited in Latvia.",
      "date": "2015-01-20 12:17:45"
    },
    {
      "id": "f3afb427-c00f-455e-a50a-2380bd832be8",
      "text": "Ukraine issued maps that omit its temporarily occupied territories and its western regions.",
      "date": "2022-08-26 13:42:00"
    },
    {
      "id": "94fdde06-df4f-4df1-b0c4-693a467e696f",
      "text": "Armenia resumed flights to Crimea.",
      "date": "2020-01-15 18:10:32"
    },
    {
      "id": "c64c6898-a3bc-4a01-8409-7233c926f445",
      "text": "Mucus is the cause of all diseases and soursop is 10,000 times more effective than chemotherapy at treating cancer.",
      "date": "2021-08-18 00:00:00+00:00"
    },
    {
      "id": "35984706-6e13-4b33-807d-ff8ef361fb10",
      "text": "Raw milk and raw eggs are safe to consume and are more nutritious than pasteurised milk and cooked eggs.",
      "date": "2025-05-07 00:00:00+00:00"
    },
    {
      "id": "1e94c676-527c-4bd5-8763-e83bd1450b58",
      "text": "A pathologist reports that COVID-19 vaccination causes a 52% increase in cancer risk for people aged 15–59.",
      "date": "2024-03-05 00:00:00+00:00"
    },
    {
      "id": "efd119c7-d615-439a-8aa4-990e680242d0",
      "text": "The Ukrainian Prime Minister called the people of Luhansk and Donetsk \"untermensch\".",
      "date": "2014-10-20 09:32:54"
    },
    {
      "id": "6c092750-6909-4156-9cc6-accd6e480dad",
      "text": "The UK prevented the UN Security Council from making a decision on Mariupol.",
      "date": "2015-01-29 16:40:20"
    },
    {
      "id": "5ccbd8ac-cc11-4cf5-bbf6-831b95c0d4b7",
      "text": "80% of people who received the Moderna COVID-19 vaccine experienced significant side effects; children in Sudan contracted polio from the polio vaccine.",
      "date": "2021-02-10 00:00:00+00:00"
    },
    {
      "id": "2652e037-d6c4-4911-907a-f5e747275327",
      "text": "Cannabis use causes no deaths anywhere.",
      "date": "2024-10-30 00:00:00+00:00"
    },
    {
      "id": "573e3562-d1a1-46bf-8be0-fbcefbd16c8f",
      "text": "Intravenous vitamin C kills cancer cells and does not kill healthy cells.",
      "date": "2022-11-10 00:00:00+00:00"
    },
    {
      "id": "155846a9-19fb-4b95-9ea4-7b57e4c3bca4",
      "text": "All coronaviruses, including those that cause SARS and MERS, are seasonal and always disappear on their own; ivermectin is effective for preventing and treating COVID-19; and COVID-19 vaccines are gene therapy that do not provide immunity or prevent transmission.",
      "date": "2021-04-04 00:00:00+00:00"
    },
    {
      "id": "3ba2c584-b208-4cf3-a984-fdd7ffd124ec",
      "text": "The pandemic was planned, and the respiratory illness surges in New York and China are caused by chlorine and benzene contamination in food and water, not by airborne transmission.",
      "date": "2023-12-31 00:00:00+00:00"
    },
    {
      "id": "b5dd77fe-0b9b-4880-8785-6e1e0a99c6fe",
      "text": "A Ukrainian journalist arrested in Russia is a spy.",
      "date": "2016-10-06 09:34:11"
    },
    {
      "id": "d1de676d-b880-446c-a5a1-788e72def238",
      "text": "Volodymyr Zelenskyy launders Western aid through United Arab Emirates bank accounts.",
      "date": "2025-10-08 00:00:00+00:00"
    },
    {
      "id": "d81be451-c47f-490c-94db-1a7d79073003",
      "text": "The clothing industry produces 10% of the pollution that drives the climate crisis.",
      "date": "2020-06-12 00:00:00+00:00"
    },
    {
      "id": "b860c9a3-51aa-4ed0-8d64-fa0098aca589",
      "text": "COVID-19 vaccines increase the risk of heart attacks.",
      "date": "2023-10-19 00:00:00+00:00"
    },
    {
      "id": "69e680fa-5202-48b4-9763-5796b740d7b3",
      "text": "Russian army destroyed Ukrainian troops who raised the Ukrainian flag on Snake Island",
      "date": "2022-07-08 13:00:00"
    },
    {
      "id": "aca610cb-ba4b-476e-8be6-a5049be6e4d6",
      "text": "Ukraine will dump the remains of a Soviet-era general.",
      "date": "2017-08-08 06:25:06"
    },
    {
      "id": "d4ae80b3-251a-4204-ae6b-a6b712097b11",
      "text": "Organs of Ukrainian soldiers are extracted and sold.",
      "date": "2014-08-29 11:35:45"
    },
    {
      "id": "5d3111bb-3a10-404d-a764-581bac6c54b3",
      "text": "UNICEF payments require registration on Viber and Telegram.",
      "date": "2022-10-30 10:50:00"
    },
    {
      "id": "b5f3114a-640d-4d7b-869f-0e131b24e550",
      "text": "People in France protested after President Macron announced he would send French troops to Ukraine.",
      "date": "2024-03-04 16:57:00"
    },
    {
      "id": "b28bc3af-e32f-4a1b-b264-d4c096c65ae2",
      "text": "Carbon dioxide does not cause global warming; observed warming is caused by the Sun; CO2-driven ocean acidification and CO2-related harm to polar bears are not occurring.",
      "date": "2024-01-09 00:00:00+00:00"
    },
    {
      "id": "372ed784-1786-455f-9495-acdeba1d2936",
      "text": "Adding more carbon dioxide to the atmosphere is beneficial and carbon dioxide does not cause the Earth to warm.",
      "date": "2020-12-18 00:00:00+00:00"
    },
    {
      "id": "6ca9bb38-8395-4d31-b66b-202d55eccd5a",
      "text": "Injured parishioners from a fight in Cherkasy were denied medical treatment because of their religious affiliation.",
      "date": "2024-10-22 00:00:00+00:00"
    },
    {
      "id": "5cf56acc-4b7a-4a64-9bad-4a8be36aadb8",
      "text": "Crimean Tatars owe gratitude to Stalin.",
      "date": "2020-05-19 10:37:36"
    },
    {
      "id": "feda4a1f-7f7d-491b-b1fd-6b694b094251",
      "text": "Fluoride is a neurotoxin that causes lower IQ in children, causes thyroid dysfunction, and causes reduced bone density.",
      "date": "2025-03-28 00:00:00+00:00"
    },
    {
      "id": "5bc9d59d-3e08-49dc-a4ea-6d714073f5e3",
      "text": "baking soda cures cancer",
      "date": "2019-03-22 00:00:00+00:00"
    },
    {
      "id": "52aa1df0-f8ca-4316-bfea-510ee0dca9f8",
      "text": "European leaders are considering Russia's plan for the Eastern Ukraine conflict.",
      "date": "2017-10-26 07:26:04"
    },
    {
      "id": "f87cf1d0-7705-43a7-b299-66a0b8f410d1",
      "text": "Video shows an explosion on the road to Komsomolske.",
      "date": "2014-12-31 13:55:59"
    },
    {
      "id": "7603dbcf-c486-4b87-a70e-c184e0f84205",
      "text": "GRU forces were exchanged for Ukrainian security officers.",
      "date": "2015-07-28 15:26:06"
    },
    {
      "id": "b3df1efb-92d6-409e-9578-dee9453bab7a",
      "text": "A new paper proves Covid-19 mRNA vaccination rates are linked to increases in overall deaths.",
      "date": "2022-07-28 00:00:00+00:00"
    },
    {
      "id": "a90738dc-e970-4f65-9ad7-87cad007cb06",
      "text": "Taking Truvada protects against HIV and does not increase the risk of kidney or bone problems.",
      "date": "2019-12-24 00:00:00+00:00"
    },
    {
      "id": "ba3e719c-7b83-4dc2-a7a2-229abb53627c",
      "text": "Only 6% of the 153,504 recorded deaths were caused by COVID-19; the other 94% died from other serious illnesses.",
      "date": "2020-08-29 00:00:00+00:00"
    },
    {
      "id": "0867dfb2-6550-4d16-96e0-9c112ebcc521",
      "text": "Poroshenko was drunk and gave a soccer ball to a legless soldier.",
      "date": "2015-04-02 15:55:02"
    },
    {
      "id": "417104d8-a428-493b-a2bb-56e5b26cd68e",
      "text": "The FDA admitted young children are at a significantly elevated risk of seizures after receiving the COVID-19 vaccine.",
      "date": "2024-03-24 00:00:00+00:00"
    },
    {
      "id": "593f6426-444c-4459-a892-de1960a92502",
      "text": "Belarusian protesters were paid to demonstrate.",
      "date": "2020-08-25 10:05:00"
    },
    {
      "id": "4d989105-9804-4c26-8239-2884525d14ff",
      "text": "Ukraine is demolishing and desecrating Red Army soldiers' monuments.",
      "date": "2020-02-02 20:25:00"
    },
    {
      "id": "2dbbe5cd-42f6-45aa-a8a6-147b66bc874d",
      "text": "Volyn and Vinnytsia have seceded from Ukraine.",
      "date": "2017-01-18 20:20:11"
    },
    {
      "id": "5ffe426c-467a-4aa8-a9e8-86fa1ed37679",
      "text": "Birthmarks indicate a person has MTHFR mutations, and people with MTHFR mutations have increased risk of vaccine reactions because they cannot detox toxins from vaccines.",
      "date": "2020-03-09 00:00:00+00:00"
    },
    {
      "id": "ee909956-ba2f-422d-b13b-3dd1f7c8b0a7",
      "text": "Ukraine bans conscripts from enrolling in universities.",
      "date": "2023-04-21 10:24:00"
    },
    {
      "id": "5dd54d37-08e5-4109-9c4b-4a0b1db9cb64",
      "text": "WHO stated asymptomatic spread of COVID-19 is very rare, therefore physical distancing and face masks are unnecessary.",
      "date": "2020-06-08 00:00:00+00:00"
    },
    {
      "id": "df649152-fc96-44a7-bac6-d0373f7143d2",
      "text": "Moderna covered up mass heart attacks among toddlers in COVID-19 vaccine trials.",
      "date": "2025-01-24 00:00:00+00:00"
    },
    {
      "id": "b0a29215-1b63-4e99-a442-00bf3c3eb3fe",
      "text": "The majority of IT specialists left Ukraine.",
      "date": "2022-03-30 10:59:12"
    },
    {
      "id": "7121db76-67ef-4f89-a205-949d1d9f7976",
      "text": "Sweetgum balls contain shikimic acid, the active ingredient in Tamiflu, which kills viruses including SARS‑CoV‑2.",
      "date": "2023-01-17 00:00:00+00:00"
    },
    {
      "id": "8b3c0685-eb3b-48cf-bcf7-908a949ba76e",
      "text": "The UN Security Council refused to support Ukraine.",
      "date": "2017-02-15 19:25:35"
    },
    {
      "id": "34a941ed-42a4-4f53-9fa5-2137d04d7eeb",
      "text": "Underage refugees tore down the Ukrainian flag from a school near Kyiv.",
      "date": "2014-08-16 22:34:14"
    },
    {
      "id": "b18f674e-cee6-4006-9361-fbfe9d0261c9",
      "text": "Video footage shows a giant tree stump in Antarctica that grew when Earth's climate was warmer.",
      "date": "2025-02-17 00:00:00+00:00"
    },
    {
      "id": "bcefaa54-3983-4328-9425-fb1201012286",
      "text": "The Sun and Charlie Hebdo reported that Angelina Jolie was extorted in Ukraine.",
      "date": "2025-11-12 00:00:00+00:00"
    },
    {
      "id": "4860699b-f10d-435c-a3ac-45cdf365dbba",
      "text": "All privileges and compensations in Ukraine have been abolished.",
      "date": "2015-06-06 18:18:44"
    },
    {
      "id": "e576c123-4c10-4108-a4db-311f2e5292ce",
      "text": "NATO troops entered Donbas",
      "date": "2020-07-30 12:42:21"
    },
    {
      "id": "c96db0fc-892b-41e2-bab9-94a5316354f5",
      "text": "90% of the world's glaciers are growing.",
      "date": "2020-02-26 00:00:00+00:00"
    },
    {
      "id": "50f1174a-08eb-4deb-95ba-76f62d759c76",
      "text": "The U.S. CDC recommends that children receive a COVID-19 flu shot.",
      "date": "2020-09-15 00:00:00+00:00"
    },
    {
      "id": "ea95d42d-e9aa-45b6-af5c-976b9c11f2ba",
      "text": "Sea level rise does not depend on ocean temperature or CO2.",
      "date": "2018-07-19 00:00:00+00:00"
    },
    {
      "id": "b023faff-5b70-40e5-b254-11c7f10c29ec",
      "text": "Ukraine established a new public holiday called \"Day of the Avenger\".",
      "date": "2017-01-26 05:31:56"
    },
    {
      "id": "b1e0d961-3385-472c-8e94-26289b31ec29",
      "text": "COVID-19 vaccines will force continued mask-wearing and physical distancing and will keep restaurants, pubs, and cinemas closed.",
      "date": "2021-01-20 00:00:00+00:00"
    },
    {
      "id": "fa2ae5c7-93c7-4595-a5db-6732ac0edaed",
      "text": "USSR symbols were projected on the Brandenburg Gate in Berlin.",
      "date": "2024-05-09 16:01:00"
    },
    {
      "id": "42750b95-0b11-44f0-8b26-122cab54ba96",
      "text": "Bloomberg announced that giant deposits were found in Crimea.",
      "date": "2016-02-25 23:07:13"
    },
    {
      "id": "f0663ed2-c5fa-4b7d-99ed-494d2b27231c",
      "text": "A pill that combines more than 60 natural herbs cures COPD in three days.",
      "date": "2024-11-26 00:00:00+00:00"
    },
    {
      "id": "aa03710a-4889-481e-a336-bbd930f5f797",
      "text": "In children, COVID-19 causes lower mortality than influenza and the same rate of severe disease or hospitalization as influenza.",
      "date": "2021-07-12 00:00:00+00:00"
    },
    {
      "id": "a71525b5-768c-4767-8b13-031710af5365",
      "text": "Depression is defined by low serotonin; low serotonin means a person is depressed.",
      "date": "2023-09-30 00:00:00+00:00"
    },
    {
      "id": "31dfdbea-5af4-44b8-87f0-4cabe7e56d41",
      "text": "Ukraine will sign security agreements with the United States only if the United States gives Ukraine money.",
      "date": "2024-03-01 15:21:00"
    },
    {
      "id": "1d38276f-ddd7-4554-b6c6-5dd3f82835b5",
      "text": "OSCE confirms the Ukrainian army shelled Donetsk.",
      "date": "2015-11-10 19:51:05"
    },
    {
      "id": "5c5d284a-29b0-4fb3-8cb6-db0f0c797e77",
      "text": "COVID-19 vaccines have caused 21,000 cases of myocarditis and the number is climbing; young people should never receive these vaccines.",
      "date": "2022-04-04 00:00:00+00:00"
    },
    {
      "id": "2c218d15-cd5a-4f9a-a7cd-8391abee9126",
      "text": "COVID-19 vaccines are 98 times more harmful than SARS-CoV-2 infection.",
      "date": "2022-09-22 00:00:00+00:00"
    },
    {
      "id": "d68d0851-8bb2-48b0-95f7-48e00ff3fa22",
      "text": "Vaccines contain unhealthy levels of aluminum, and Japan eliminated vaccines and infant mortality decreased.",
      "date": "2024-02-12 00:00:00+00:00"
    },
    {
      "id": "2de9d081-90ae-4725-be06-bc7997c3d9a4",
      "text": "Babies under six months must not drink fluoridated water because their blood-brain barrier is not fully formed until six months of age.",
      "date": "2024-03-22 00:00:00+00:00"
    },
    {
      "id": "86d3a938-31f3-42cc-be89-5a26acaefcd1",
      "text": "Ukrainian President Volodymyr Zelenskyy is faking blackouts to secure more aid from European countries.",
      "date": "2025-11-10 00:00:00+00:00"
    },
    {
      "id": "c56a3e4f-f384-41f3-9b59-2851b9d79bec",
      "text": "Covid-19 vaccines are ineffective because the majority of COVID-19 deaths occurred among vaccinated people.",
      "date": "2023-08-17 00:00:00+00:00"
    },
    {
      "id": "2a7dd7bf-03be-44c6-a411-eac8687044be",
      "text": "Serbian Defense Ministry says Euromaidan was a coup.",
      "date": "2018-06-14 23:04:35"
    },
    {
      "id": "d2aa06b0-d943-42f3-9874-e68f023ce72d",
      "text": "There are no Russian troops in Donbas.",
      "date": "2015-10-09 10:32:55"
    },
    {
      "id": "8df4bac7-c73c-4dc0-87d2-f1212f551f20",
      "text": "Foreign Policy used its banner to promote a pro‑Russian story.",
      "date": "2016-01-17 20:50:12"
    },
    {
      "id": "a5f5b63d-523a-4301-91c8-def1fdf47374",
      "text": "The FDA says doctors can prescribe ivermectin for COVID-19.",
      "date": "2023-08-15 00:00:00+00:00"
    },
    {
      "id": "14726b46-4a6d-4be0-9221-effff997629d",
      "text": "Brussels falsifies and rewrites European history.",
      "date": "2020-09-26 11:32:46"
    },
    {
      "id": "b35936a9-3b33-43a1-ba7d-8853a326579d",
      "text": "Marchers in Kharkiv chanted \"Death to Russians.\"",
      "date": "2015-03-03 10:53:21"
    },
    {
      "id": "bebac3fa-67e3-471d-9bb4-7990f8ab9e35",
      "text": "5G technology caused the coronavirus outbreak.",
      "date": "2020-02-22 00:00:00+00:00"
    },
    {
      "id": "f7acb1a4-fdd1-4438-b4c7-bddf4228c92d",
      "text": "Dr. Anthony Fauci acknowledged that large numbers of positive COVID-19 cases were caused by oversensitive PCR tests detecting noninfectious viral fragments, resulting in many false-positive results.",
      "date": "2020-11-08 00:00:00+00:00"
    },
    {
      "id": "1f60b707-aca0-4ce8-94a7-3c7ce5e28b30",
      "text": "One million people in the U.S. have died from COVID-19.",
      "date": "2022-05-16 00:00:00+00:00"
    },
    {
      "id": "0846c7c9-d25d-40f7-ba2e-ef15baf62f6a",
      "text": "European Parliament found that Russia does not sponsor terrorism.",
      "date": "2022-08-14 08:46:53"
    },
    {
      "id": "5ad3a25c-7d15-4326-91f8-e874a44447dd",
      "text": "Ukraine handed military draft notices to minors.",
      "date": "2023-01-22 15:34:00"
    },
    {
      "id": "db4c87aa-d882-424a-95d5-b5578f4f2152",
      "text": "Ukraine will force residents of Crimea and Donbas to repent.",
      "date": "2018-03-13 13:31:53"
    },
    {
      "id": "24566c65-9f5d-4bd6-b64c-2a2e091b9728",
      "text": "The US lost 90% of the weapons it supplied to Ukraine.",
      "date": "2022-12-28 15:44:00"
    },
    {
      "id": "1894f815-8eb4-4675-b927-6c8249ff84d1",
      "text": "A women's battalion consisting of females aged 16 to 30 was announced in the Chernihiv region.",
      "date": "2024-03-03 13:31:00"
    },
    {
      "id": "dcf9c1d4-e6ca-4d30-ace3-96e46222ed7d",
      "text": "Ukraine is selling stale leftover bread because of bread shortages.",
      "date": "2023-03-18 18:27:00"
    },
    {
      "id": "7322ffb4-986e-43b6-a289-c5827e12e8f1",
      "text": "Higher COVID-19 vaccination rates among White people are associated with higher COVID-19 death rates.",
      "date": "2023-08-25 00:00:00+00:00"
    },
    {
      "id": "b3c6fc08-ff96-4920-a354-15b497d8edfe",
      "text": "The Czech Republic supplied tanks to Ukraine.",
      "date": "2015-01-30 15:15:33"
    },
    {
      "id": "fa2d3b46-ac03-4fcc-b33c-18d30b2c4e41",
      "text": "Ukrainian soldiers were ordered to shell peaceful villages.",
      "date": "2014-12-08 11:36:53"
    },
    {
      "id": "867931bb-b8a4-4cb6-ad3d-18694cdf5189",
      "text": "Abortions are never medically necessary.",
      "date": "2022-09-07 00:00:00+00:00"
    },
    {
      "id": "8ced6a55-2895-4cc2-a608-c1df3c474d3b",
      "text": "Ukraine has no heating and is operating public warming centers.",
      "date": "2017-02-20 17:25:33"
    },
    {
      "id": "20f56042-1a06-499a-9a53-f1e0b345af51",
      "text": "Volunteers are getting rich from the war in Eastern Ukraine.",
      "date": "2016-12-02 08:15:33"
    },
    {
      "id": "6d859cbf-141e-4be3-88e0-87f0a8be70a7",
      "text": "Coconut oil treats and prevents Alzheimer's.",
      "date": "2025-01-23 00:00:00+00:00"
    },
    {
      "id": "2f03eb76-3789-418f-acd7-9c89021472ee",
      "text": "Ukraine announced a new foreign policy toward Africa.",
      "date": "2015-10-01 13:23:58"
    },
    {
      "id": "c2ffff69-9282-4c9a-8f22-78688403761d",
      "text": "The United States will bomb Siberia according to a Ukrainian plan.",
      "date": "2020-06-11 12:14:00"
    },
    {
      "id": "c5e44e6f-0c01-4822-b77a-dc30293d5ea7",
      "text": "COVID-19 vaccines' spike protein binds to and irreversibly alters human DNA, the vaccines contain multiple lipid types never before injected into humans, and the vaccines have caused 12,000 deaths.",
      "date": "2021-03-17 00:00:00+00:00"
    },
    {
      "id": "f4c4875a-42a8-4b5b-b769-7eec26034c77",
      "text": "Ukraine deceptively recruits South Africans.",
      "date": "2025-12-17 00:00:00+00:00"
    },
    {
      "id": "79d30802-4291-48d8-bf33-f5ca167da388",
      "text": "A toxin found in coffee attacks the bladder and kidneys and causes cancer.",
      "date": "2024-05-15 00:00:00+00:00"
    },
    {
      "id": "d229a86e-367a-47c8-903e-80f4d9e82156",
      "text": "Ukraine's Foreign Ministry acknowledged that Crimea is permanently lost to Ukraine.",
      "date": "2020-07-08 14:51:00"
    },
    {
      "id": "b77e829a-afd0-4982-a1d0-632e6e32244c",
      "text": "Ukraine revoked the Geneva Conventions.",
      "date": "2022-04-07 17:43:00"
    },
    {
      "id": "ec0e07a0-d0c8-43d5-9844-0943301e2a36",
      "text": "Aircraft-dispersed particles used for Solar Radiation Management are causing catastrophic damage to Earth's life support systems.",
      "date": "2021-03-25 00:00:00+00:00"
    },
    {
      "id": "86784e6c-8177-4b9d-a572-6c55c2a97eb8",
      "text": "Peanut oil in vaccines causes peanut allergies.",
      "date": "2024-07-26 00:00:00+00:00"
    },
    {
      "id": "41fc545d-ae89-4a1f-8d9a-18c06042a01e",
      "text": "The US banned Ukraine from buying the Russian vaccine and is testing its own vaccine on Ukrainians.",
      "date": "2020-10-26 17:20:00"
    },
    {
      "id": "c2847424-d6f6-48ec-99f4-a78270737a29",
      "text": "The Pentagon says the U.S. will no longer provide HIMARS and missiles to Ukraine.",
      "date": "2022-08-15 11:44:00"
    },
    {
      "id": "c63562e7-2f47-4cef-bd74-f956b86a4576",
      "text": "It took 15 years to uncover Chantix’s carcinogenic effects, and Chantix was not approved or confirmed safe during its first 12 months on the market.",
      "date": "2021-05-11 00:00:00+00:00"
    },
    {
      "id": "a9ca3233-bd0a-41f1-b2e0-8f1f725fb225",
      "text": "A South African scientist successfully removed HIV from a sperm cell in a laboratory.",
      "date": "2022-05-28 00:00:00+00:00"
    },
    {
      "id": "73a83e9e-a797-4089-b84e-33a825dd6e1f",
      "text": "Excess deaths in late 2022 exceeded the pandemic peak and were caused by COVID-19 vaccines.",
      "date": "2023-01-13 00:00:00+00:00"
    },
    {
      "id": "7b7ca705-46e3-4c64-9380-8eb6e0d18334",
      "text": "Ukrainian ancestors dug up the Black Sea.",
      "date": "2015-01-29 17:48:14"
    },
    {
      "id": "20358a0a-a0d9-4286-89ba-775b060e8441",
      "text": "France will lift sanctions on Russia.",
      "date": "2016-04-28 22:15:48"
    },
    {
      "id": "a3f7a543-8c54-4f0f-8be8-28dc9d6c0dba",
      "text": "Ivermectin sterilizes 85% of men who take it.",
      "date": "2021-09-14 00:00:00+00:00"
    },
    {
      "id": "21b0d791-0ab6-4fbc-a453-4665aa2e2382",
      "text": "The United States has a better handle on COVID-19 than Europe, and COVID-19 is less deadly in the United States than in most European countries based on case fatality data.",
      "date": "2020-04-11 00:00:00+00:00"
    },
    {
      "id": "3442f73e-73e5-4882-8dab-66506922b48f",
      "text": "A review of autopsy cases found that 74% of deaths were caused by COVID-19 vaccines.",
      "date": "2024-06-23 00:00:00+00:00"
    },
    {
      "id": "98ad1a45-cda6-4e1f-8781-f3b161967bcf",
      "text": "WHO says a child's presence at school alone constitutes informed consent for vaccination.",
      "date": "2021-11-14 00:00:00+00:00"
    },
    {
      "id": "2edc3bf0-a4cb-4dd7-9c14-a4818bf63cad",
      "text": "Environmental laws cause California wildfires to be much worse by preventing massive amounts of available water from being used and diverting that water into the Pacific Ocean.",
      "date": "2018-08-05 00:00:00+00:00"
    },
    {
      "id": "88214d23-e54a-4adf-b1c6-03685d8f9c6c",
      "text": "Sunscreen causes cancer and the sun does not cause cancer.",
      "date": "2018-06-11 00:00:00+00:00"
    },
    {
      "id": "43fe8af9-e5e1-46ca-9396-01915f4ec799",
      "text": "Massive volcanic CO2 emissions discredit the theory of global warming.",
      "date": "2018-11-07 00:00:00+00:00"
    },
    {
      "id": "63f980ff-a871-4da2-8501-e19ef4784b0b",
      "text": "An international medical crisis is occurring because COVID-19 vaccines are causing widespread diseases and deaths.",
      "date": "2022-09-19 00:00:00+00:00"
    },
    {
      "id": "244fcfc2-dd34-4fbe-98e4-81f80c8c08c9",
      "text": "Scientists predict 6 billion people will be slaughtered or starve to death this century.",
      "date": "2019-08-17 00:00:00+00:00"
    },
    {
      "id": "709e80f4-fb04-445f-b9c8-885503b4171d",
      "text": "COVID-19 vaccine recipients are not eligible to donate blood.",
      "date": "2024-02-21 00:00:00+00:00"
    },
    {
      "id": "b6e88a3f-5dab-496a-8af6-b690d55aa904",
      "text": "The HIV VB variant is highly infectious and makes people ill twice as quickly.",
      "date": "2022-02-03 00:00:00+00:00"
    },
    {
      "id": "e81c3aa2-be13-43d5-9a64-6562964c293a",
      "text": "France jails citizens for questioning or opposing mRNA vaccines.",
      "date": "2024-02-23 00:00:00+00:00"
    },
    {
      "id": "50cc82f9-6fab-455a-bcc9-d17aed021f1d",
      "text": "Ukraine establishes maritime borders only by recognizing Russia’s annexation of Crimea.",
      "date": "2019-10-31 11:12:05"
    },
    {
      "id": "0503bed5-4d7d-47ad-bd61-fa9f13662226",
      "text": "A Russian drummer from the band Metal Corrosion was forced to serve in the Azov Battalion.",
      "date": "2015-02-22 10:55:38"
    },
    {
      "id": "823f891a-b607-43cf-9976-5c5774141517",
      "text": "Deaths reported to VAERS after vaccination are caused by the vaccine.",
      "date": "2021-07-23 00:00:00+00:00"
    },
    {
      "id": "d4ca06b7-dafd-4b18-9208-e5fda4a6070c",
      "text": "Ukraine's currency market will collapse without transfers from Russia.",
      "date": "2017-03-05 07:23:16"
    },
    {
      "id": "24994368-cbdc-4f55-9672-f292140ffb65",
      "text": "Regenerative agriculture improves soil health more than conventional agriculture.",
      "date": "2025-12-10 00:00:00+00:00"
    },
    {
      "id": "f5d998c1-dba7-4576-b16a-89383c25a0fc",
      "text": "A review found that COVID-19 mRNA vaccines aid cancer development.",
      "date": "2024-04-29 00:00:00+00:00"
    },
    {
      "id": "0cd33477-f197-45bc-9d03-254b7ea91b03",
      "text": "Polish company ASBS Othago is fighting alongside the Ukrainian military forces.",
      "date": "2014-08-15 12:46:29"
    },
    {
      "id": "ba2de5ac-a509-44a5-bbe8-5a1276566e62",
      "text": "Climate change is not new and climate change is not caused by humans.",
      "date": "2020-01-13 00:00:00+00:00"
    },
    {
      "id": "3438a90c-54f2-4270-84a6-974f333b08d2",
      "text": "Kyiv's electronic warfare forced Russian drones off course into Poland.",
      "date": "2025-09-10 00:00:00+00:00"
    },
    {
      "id": "142195bc-ce0a-446a-a197-82133bc1bfda",
      "text": "Ukraine has banned the Belgian Foreign Minister from visiting Ukraine because he visited Crimea.",
      "date": "2022-07-30 16:07:00"
    },
    {
      "id": "0baf6d0b-4f91-4d6a-9da3-83f030ad66e1",
      "text": "In the 1980s–1990s people died from the antiretroviral drug AZT instead of from HIV/AIDS, and Anthony Fauci pushed AZT as the treatment.",
      "date": "2021-08-25 00:00:00+00:00"
    },
    {
      "id": "717943a2-2909-4b7f-9745-882b8c2e2624",
      "text": "Nearly 90% of Odesa residents like Russia.",
      "date": "2021-11-23 12:15:00"
    },
    {
      "id": "5f2ca378-ca40-4a54-88b9-ce966ac550a5",
      "text": "Ukrainian soldiers wore Russian uniforms in Donbas.",
      "date": "2018-06-20 16:46:36"
    },
    {
      "id": "c964b8e9-62a4-426b-8aa4-338df852d011",
      "text": "Ventilators, not COVID-19, caused the deaths of hospitalized COVID-19 patients.",
      "date": "2023-11-14 00:00:00+00:00"
    },
    {
      "id": "31a1ff2d-e616-4f27-85a4-b4e9a505c722",
      "text": "COVID-19 vaccines caused an increase in abnormal blood clots observed by embalmers.",
      "date": "2022-10-24 00:00:00+00:00"
    },
    {
      "id": "be381aea-1470-495b-a705-3f0402b74c43",
      "text": "Russian militant Motorola was killed by a Latvian mercenary.",
      "date": "2016-10-21 18:34:59"
    },
    {
      "id": "6618192f-d9d0-4608-8d78-16d5b77810b4",
      "text": "Crimean Tatars asked Turkey to recognize Crimea as part of Russia.",
      "date": "2016-07-06 09:39:11"
    },
    {
      "id": "f4c3a3a5-c6ce-4414-b615-0c69fab214c7",
      "text": "Side effects of the HPV vaccine outweigh its benefits.",
      "date": "2019-07-08 00:00:00+00:00"
    },
    {
      "id": "5e5c4927-3a0c-428a-bf40-0eb609878217",
      "text": "Ukraine boycotts the Paralympics.",
      "date": "2026-02-19 00:00:00+00:00"
    },
    {
      "id": "0c5f39e5-63c0-4191-8b6c-40ae97875fb0",
      "text": "NATO confirmed Russia is fighting in Ukraine at reduced strength.",
      "date": "2022-07-31 11:21:00"
    },
    {
      "id": "d133f617-ddcb-4c57-9aa9-ec5590508b88",
      "text": "The FDA admitted young children are at a significantly elevated risk of seizure after taking the COVID-19 vaccine.",
      "date": "2024-05-04 00:00:00+00:00"
    },
    {
      "id": "588a55b7-6e3c-45c2-8364-c5ef65a60b7c",
      "text": "The European Parliament accused Petro Poroshenko of causing a church schism to win the election.",
      "date": "2019-03-03 18:31:00"
    },
    {
      "id": "023c4c57-2967-428e-b72f-9beb8f0f4f20",
      "text": "Polish and British special forces fought in Ukraine from the first days of the Russian invasion.",
      "date": "2023-12-14 10:18:00"
    },
    {
      "id": "a5277d1c-96d0-47fa-b6cf-3d93de47a11f",
      "text": "Oil and gas are renewable energy sources produced by a geothermal reaction between the solid mantle and liquid core; hydrocarbons form in the upper mantle, migrate through deep faults, and are deposited throughout Earth’s crust in any rock type and structural position.",
      "date": "2024-05-25 00:00:00+00:00"
    },
    {
      "id": "a9826696-7be0-438c-8926-1ad2257b1a62",
      "text": "Russian military captured German PzH 2000 howitzer",
      "date": "2022-07-06 12:45:00"
    },
    {
      "id": "07e8ef3c-b9bd-433f-9c12-4fbfc99e8481",
      "text": "More than 75% of the rainforest is losing resilience and more than half of the rainforest will be converted into savanna within decades.",
      "date": "2022-03-15 00:00:00+00:00"
    },
    {
      "id": "ff2a806d-e6f1-460f-9f0e-712d721ec08f",
      "text": "Spanish media call the Ukrainian coat of arms ultra‑nationalist and paramilitary.",
      "date": "2016-08-06 16:10:35"
    },
    {
      "id": "c3257842-d857-4799-8fb0-ecbada1492d5",
      "text": "There will be herd immunity to COVID-19 by April because 55% of Americans have natural immunity.",
      "date": "2021-02-18 00:00:00+00:00"
    },
    {
      "id": "0a533773-d2af-437e-b15b-24397d33e008",
      "text": "U.S. doctors found that 70% of long COVID cases developed after COVID vaccination, not after infection.",
      "date": "2024-03-06 00:00:00+00:00"
    },
    {
      "id": "a52a2dc4-9a7e-445b-840b-aa2a71bfc7b5",
      "text": "A Harvard study confirms fluoride reduces children’s IQ.",
      "date": "2022-09-21 00:00:00+00:00"
    },
    {
      "id": "9f80744b-cde3-495c-a2c1-e651a81c9ae3",
      "text": "Marijuana is not addictive, cures cancer, and causes brain cells to grow.",
      "date": "2019-04-25 00:00:00+00:00"
    },
    {
      "id": "7f1b05bb-bbef-4f51-accd-291a84b9c779",
      "text": "Ukraine used video game footage as evidence in its ICJ suit against Russia.",
      "date": "2017-03-12 09:24:48"
    },
    {
      "id": "22a6c6a7-6139-48a0-ae57-b4c6ba1bde74",
      "text": "Ukrainian general kneels before the former US ambassador",
      "date": "2014-05-28 20:49:06"
    },
    {
      "id": "ce65051a-c2b7-49c5-b4ce-6b061e39b289",
      "text": "A Ukrainian missile destroyed an apartment building in Kyiv.",
      "date": "2022-02-27 13:52:17"
    },
    {
      "id": "798f535c-e291-4f87-bb0b-4a6a4f468191",
      "text": "Russian forces destroyed an all-female unit of the Ukrainian Armed Forces.",
      "date": "2025-06-02 00:00:00+00:00"
    },
    {
      "id": "79fca050-3a9d-45f9-9935-b4b5b72a6503",
      "text": "The daughter of the SSU head organizes howitzer shooting tours.",
      "date": "2014-08-24 16:51:33"
    },
    {
      "id": "c993fc46-d4e7-47cb-a26e-d3c5e2928b18",
      "text": "Ukrainians were drafted into volunteer battalions in Israel.",
      "date": "2023-10-18 16:25:00"
    },
    {
      "id": "553f676b-b93d-4694-8dc9-9f0bb6432591",
      "text": "A police officer confirmed that 10 civilians were killed in Donetsk.",
      "date": "2014-05-28 11:46:24"
    },
    {
      "id": "4976ee3a-3784-4d3f-9857-73c8195327ad",
      "text": "U.S. Ambassador to Russia laid flowers with blue and yellow ribbons at the scene of Nemtsov's murder",
      "date": "2015-03-01 20:00:07"
    },
    {
      "id": "c20f1eec-25ed-42b6-ae82-6b5b0393c7d3",
      "text": "American mercenaries are operating in Donetsk.",
      "date": "2014-03-29 14:02:32"
    },
    {
      "id": "033f04c0-b501-478b-9f25-fa6b4d2ca4ad",
      "text": "Fluoridated toothpaste is deadly to children and fluoride causes dental fluorosis, cavities, and cancer.",
      "date": "2024-06-12 00:00:00+00:00"
    },
    {
      "id": "37839e78-27f0-4435-b8ce-f71a4f116bed",
      "text": "Cayenne pepper is the most powerful blood thinner.",
      "date": "2023-08-27 00:00:00+00:00"
    },
    {
      "id": "e5d00f8a-9ceb-4743-83a6-8d6bf5883043",
      "text": "Yatsenyuk says Galicia was illegally annexed.",
      "date": "2015-09-20 15:53:12"
    },
    {
      "id": "8e186830-bee5-4aca-9ba9-f6ab92a6da54",
      "text": "Masks prevent influenza but fail to prevent COVID-19; influenza cases were largely renamed COVID-19.",
      "date": "2021-01-17 00:00:00+00:00"
    },
    {
      "id": "e3a04279-fb73-4013-9f74-419385217d64",
      "text": "Arctic sea ice and polar icecaps are melting at unnatural rates and this melting constitutes evidence of human-caused climate change.",
      "date": "2017-05-17 00:00:00+00:00"
    },
    {
      "id": "758b9d79-89df-4867-81a1-838437e6a859",
      "text": "82% of Czechs believe Malaysia Airlines Flight MH17 was shot down by the Ukrainian army.",
      "date": "2014-07-24 13:17:00"
    },
    {
      "id": "354932c8-6ae3-482e-80c2-1ec5fb490ed6",
      "text": "German tanks painted with Nazi symbols are being transported to Ukraine.",
      "date": "2023-03-01 12:39:00"
    },
    {
      "id": "ef3e88e0-f84d-4da8-96d8-9f775591b9f0",
      "text": "No COVID-19 vaccines were FDA-approved and available in the United States as of May 2023.",
      "date": "2023-05-26 00:00:00+00:00"
    },
    {
      "id": "943c7207-e112-481d-9818-bf98c872d3f1",
      "text": "Kolomoiskii's enforcers beat and kicked soldiers' mothers from Western Ukraine with sticks.",
      "date": "2014-06-03 17:53:43"
    },
    {
      "id": "c05b569b-31f7-4337-afce-74533292fc0b",
      "text": "Photos show descendants of Banderovits committing atrocities.",
      "date": "2014-11-14 15:02:52"
    },
    {
      "id": "3f92c6cf-d089-4d51-afd0-5cc8bf719664",
      "text": "Japan officially named COVID-19 mRNA vaccines the most deadly drug in human history.",
      "date": "2024-11-21 00:00:00+00:00"
    },
    {
      "id": "b4dc8335-e7e6-4ca1-ac0f-cda8fc61aa54",
      "text": "The HAARP facility deliberately creates global-scale destruction — earthquakes, cyclones, floods, and snowstorms — and attacks the world's citizens telepathically by influencing their thoughts with low-frequency vibrations.",
      "date": "2021-02-03 00:00:00+00:00"
    },
    {
      "id": "f579b180-4bcf-4616-8cca-c6611dc5d22e",
      "text": "The Polish ambassador wants a Yugoslav-style breakup of Ukraine.",
      "date": "2017-07-12 11:40:22"
    },
    {
      "id": "9a51ca5a-08a2-471d-b0ef-7059646f9b98",
      "text": "Sauna bathing detoxes the body by causing sweating.",
      "date": "2024-05-09 00:00:00+00:00"
    },
    {
      "id": "4d3c833c-1a92-4746-ad0d-5c2840c14110",
      "text": "Barack Obama accuses Ukrainian authorities of committing genocide.",
      "date": "2015-09-26 22:24:21"
    },
    {
      "id": "fb699657-8103-453e-938a-f5daa0ea13d1",
      "text": "Biden said Ukraine is the most corrupt country in the world.",
      "date": "2015-12-16 19:44:26"
    },
    {
      "id": "cc684206-59ef-4f1d-9a3e-0ff4eafb7fca",
      "text": "The Mykolayiv Shipbuilding Plant was cut up for scrap metal.",
      "date": "2020-06-08 17:01:00"
    },
    {
      "id": "85dae113-29da-4a75-b868-215745825ee0",
      "text": "NASA adjusted historical temperatures downward and recent temperatures upward, and those adjustments are responsible for most of the reported global warming.",
      "date": "2019-06-26 00:00:00+00:00"
    },
    {
      "id": "ac309972-39c0-4c22-a9a8-2e21189a182b",
      "text": "90% of the world's coral reefs will disappear within 35 years due to coral bleaching caused by global warming, pollution, and over-development.",
      "date": "2017-02-27 00:00:00+00:00"
    },
    {
      "id": "23d5acde-9eb1-4641-b65c-7f5d94d7b611",
      "text": "ISW says that after Trump's election victory, the Ukrainian military surrendered more often.",
      "date": "2024-11-11 00:00:00+00:00"
    },
    {
      "id": "0c3ae337-f9bd-4232-8dfb-2940624107d2",
      "text": "The UK visa center in Kyiv closed after Russian shelling.",
      "date": "2025-06-10 00:00:00+00:00"
    },
    {
      "id": "9f15f89c-d1c8-4a2d-8528-9d31c8654f08",
      "text": "Total deaths from COVID-19 are much lower than officially reported.",
      "date": "2022-01-27 00:00:00+00:00"
    },
    {
      "id": "0be7d364-75a2-4715-bfe6-b1ad97691bb5",
      "text": "Vaccinated children have poorer health outcomes than unvaccinated children.",
      "date": "2023-07-07 00:00:00+00:00"
    },
    {
      "id": "4e85a632-df9b-4b75-a026-4f6406a638e4",
      "text": "The British Embassy in Ukraine recommends that British citizens flee from drafting officers.",
      "date": "2024-09-22 10:03:00"
    },
    {
      "id": "bfa02948-129d-4df1-8d02-32c7106ce1a7",
      "text": "Ukrainian soldiers claim Ukrainian authorities are deliberately prolonging the war to profit from it.",
      "date": "2026-02-19 00:00:00+00:00"
    },
    {
      "id": "8f2a8ba8-3a4a-4936-bf7f-34faee9aa1e3",
      "text": "Chemtrails contain barium salts that are 10,000 times more toxic to the human nervous system than lead.",
      "date": "2023-06-04 00:00:00+00:00"
    },
    {
      "id": "80600e8f-ca1c-4a49-a344-25d0c769ba95",
      "text": "The coronavirus outbreak was caused by 5G technology, not by a virus.",
      "date": "2020-12-03 00:00:00+00:00"
    },
    {
      "id": "f97d0478-9be5-4fc6-a5f1-680f08d3eb14",
      "text": "Ukraine will not have enough gas to last the winter.",
      "date": "2018-12-22 17:52:22"
    },
    {
      "id": "e3ab94bd-6ae1-4890-93b1-11b533431a94",
      "text": "Massive protests occurred in Germany opposing sending tanks to Ukraine.",
      "date": "2023-01-29 10:36:00"
    },
    {
      "id": "dd5773a2-71e4-444d-8c08-6f13e54af348",
      "text": "A Ukrainian military missile launch went wrong during maneuvers.",
      "date": "2014-09-10 18:53:27"
    },
    {
      "id": "0a1a6190-eb21-4894-b6b5-c8613a05b0a6",
      "text": "A Western ratings agency reports that Kyiv has defaulted.",
      "date": "2016-09-09 18:56:58"
    },
    {
      "id": "093d75a8-822f-4e74-8fc9-d38c1bd278b6",
      "text": "Starbucks plans to return to Russia",
      "date": "2024-06-14 10:07:49"
    },
    {
      "id": "e3571f4c-65f1-4db3-897f-fe9736b10446",
      "text": "People with blood type O are more protected against COVID-19 than people with other blood types.",
      "date": "2020-06-22 00:00:00+00:00"
    },
    {
      "id": "fe77b063-ffc7-45db-bf3c-30d1345de127",
      "text": "FDA guidelines state that babies are too small to safely handle the amount of aluminum in childhood vaccines.",
      "date": "2024-02-18 00:00:00+00:00"
    },
    {
      "id": "e598a674-f687-420e-961c-9e37ddf343d7",
      "text": "Ukraine jails Russians for visiting Crimea",
      "date": "2018-11-11 23:48:06"
    },
    {
      "id": "e3c43223-3600-4873-a0bc-96a7a3028392",
      "text": "Poroshenko ordered a total blockade of Crimea.",
      "date": "2015-11-22 22:49:12"
    },
    {
      "id": "733f152b-a575-4502-b706-11073df8c68c",
      "text": "The EU ignored Russia distributing passports to residents of Donbas.",
      "date": "2019-08-15 21:35:59"
    },
    {
      "id": "7c2428b6-5481-4361-bde2-ecc9321746bb",
      "text": "Ukrainian military attempted a chemical attack in Donbas.",
      "date": "2022-02-18 19:22:34"
    },
    {
      "id": "cd709fbf-cb82-4ab7-b2c2-2da875059189",
      "text": "Ukraine has the highest electricity prices in Europe.",
      "date": "2017-09-22 18:12:18"
    },
    {
      "id": "3ac406b0-e68e-49a0-bd1b-2528853d2cad",
      "text": "Flu shots cause people to spread the flu.",
      "date": "2019-05-03 00:00:00+00:00"
    },
    {
      "id": "65185d34-b527-468c-beb7-4b55954d027f",
      "text": "Tumors are bubbles of toxins expelled by the body; cancer is beneficial; biopsies and mammograms cause cancer.",
      "date": "2024-09-08 00:00:00+00:00"
    },
    {
      "id": "513ca3cb-280b-43ff-9a2c-b0a564e9be78",
      "text": "COVID-19 vaccines commonly cause myocarditis and cause sudden death",
      "date": "2024-09-12 00:00:00+00:00"
    },
    {
      "id": "7b1d1801-aa76-41eb-9f0b-d7d9461b7987",
      "text": "Euromaidan participants were paid.",
      "date": "2014-04-08 09:33:01"
    },
    {
      "id": "589edca3-47ff-4fbe-80de-c38bf691870b",
      "text": "Natural variation explains a substantial part of the global warming observed since 1850, and global warming is not intensifying natural disasters or increasing their frequency.",
      "date": "2022-08-24 00:00:00+00:00"
    },
    {
      "id": "d41f05ae-a077-4b43-a1ad-50f0a3215fad",
      "text": "COVID-19 causes prolonged, progressive hypoxia by binding to the heme groups in hemoglobin in red blood cells.",
      "date": "2020-04-15 00:00:00+00:00"
    },
    {
      "id": "e5422914-be7b-4e48-a015-d663782e09ff",
      "text": "A court ruled that COVID-19 mRNA vaccines are not vaccines.",
      "date": "2024-06-08 00:00:00+00:00"
    },
    {
      "id": "0dda44fb-e789-409d-8884-402c50cfbf09",
      "text": "The surrender of Bakhmut will collapse the Ukrainian front to its western borders.",
      "date": "2023-04-26 18:13:00"
    },
    {
      "id": "c8ab785c-bdf9-4974-a4a6-0fa8e1e04427",
      "text": "Alexis Lorenze became severely ill due to vaccines, and vaccines aggravate paroxysmal nocturnal hemoglobinuria.",
      "date": "2024-09-16 00:00:00+00:00"
    },
    {
      "id": "0f5a9041-d107-4637-af27-c903436d7f31",
      "text": "A freelance journalist was shot dead in Kyiv, Ukraine.",
      "date": "2015-07-15 10:53:40"
    },
    {
      "id": "a9f42078-b13a-4273-b720-2b85621b9479",
      "text": "The Ukrainian National Memory Institute promotes hatred and incites conflict.",
      "date": "2019-10-29 17:45:03"
    },
    {
      "id": "96bbb94c-4f84-462e-8d41-121eef67b842",
      "text": "Ukrainian paratroopers resigned from the military because they refused to fight.",
      "date": "2014-06-24 12:20:00"
    },
    {
      "id": "feef1b5d-6fca-48b3-b6e7-7e296b05c53c",
      "text": "The CDC director admitted that COVID-19 deaths were over-counted.",
      "date": "2021-05-17 00:00:00+00:00"
    },
    {
      "id": "b5ae45b2-5d16-4b5b-aa3a-5576d28dd426",
      "text": "Makeevka was hit by ballistic missiles.",
      "date": "2014-08-21 14:22:04"
    },
    {
      "id": "c9e9a73a-9805-4a55-a450-6162c6ec9b71",
      "text": "John Kerry praised Russian efforts to secure a ceasefire in Syria.",
      "date": "2016-05-04 06:05:55"
    },
    {
      "id": "17354fb2-74e2-4dea-b9f6-3b313bc2f042",
      "text": "Crimeans are under military pressure to support Russian annexation.",
      "date": "2017-10-11 13:36:35"
    },
    {
      "id": "f3fc68de-4d62-44bb-b25b-67ca2e4c5aff",
      "text": "COVID-19 vaccines killed people and COVID-19 has a 99.97% survival rate.",
      "date": "2021-06-05 00:00:00+00:00"
    },
    {
      "id": "6bf5be7b-0915-44fe-9e53-1db09cfb0aa9",
      "text": "People do not wear masks for tuberculosis because CNN has not instructed them to.",
      "date": "2020-09-17 00:00:00+00:00"
    },
    {
      "id": "f2352fef-7f02-4458-a866-639bd458c927",
      "text": "Antarctic ice increased from 2021 to 2023, reversing the Antarctic ice-loss trend.",
      "date": "2025-05-02 00:00:00+00:00"
    },
    {
      "id": "45820d42-2355-436e-9fd0-498d37c06918",
      "text": "Russian Proton rocket crashed while carrying a satellite.",
      "date": "2014-12-21 11:38:35"
    },
    {
      "id": "95cf57c8-db12-4b02-9ab4-5f125ec8e52f",
      "text": "Earth’s mean temperature over the last 2,000 years was higher during 1–200 AD (the Roman Warm Period) and 900–1100 AD (the Medieval Warm Period) than it is now.",
      "date": "2019-07-26 00:00:00+00:00"
    },
    {
      "id": "4c6cf093-805b-4e3a-992f-9702969ee316",
      "text": "Ukrainian soldiers fired on a car carrying a Russian-speaking mother and her child.",
      "date": "2023-03-28 12:31:00"
    },
    {
      "id": "de30d744-016b-4318-8ab1-056f6e5e884e",
      "text": "Andriy Yermak paid TIME magazine to secure a spot on TIME's 2024 Most Influential list.",
      "date": "2024-04-23 19:37:00"
    },
    {
      "id": "4a4a457b-1325-44eb-8e2f-f16ac98bf1da",
      "text": "No one has died from the coronavirus.",
      "date": "2020-12-07 00:00:00+00:00"
    },
    {
      "id": "ff19f0d3-d83b-4d15-9bc7-3f167453c19b",
      "text": "The Ukrainian Armed Forces are recruiting mercenaries from Croatia.",
      "date": "2016-11-12 14:36:37"
    },
    {
      "id": "b5df04a7-2e6e-434f-b9a5-1ea3d3c335c4",
      "text": "Latvians want to establish a ghetto for Russians.",
      "date": "2015-04-28 21:47:29"
    },
    {
      "id": "61c001bc-aaeb-4697-ad48-4e975f4f2e0e",
      "text": "COVID-19 RNA vaccines were not made with messenger RNA; vaccine RNA cannot be broken down in the body.",
      "date": "2023-07-27 00:00:00+00:00"
    },
    {
      "id": "31531c60-58d7-4c6e-a9ae-1ce4ab397323",
      "text": "Cooking with aluminum foil causes Alzheimer’s disease and cancer.",
      "date": "2024-05-04 00:00:00+00:00"
    },
    {
      "id": "f275225d-6b88-4d4e-a09f-ec6c1ba1b714",
      "text": "Children injected with Pfizer’s mRNA COVID-19 vaccine had weakened immune responses to other viruses.",
      "date": "2023-11-09 00:00:00+00:00"
    },
    {
      "id": "36ec8ad7-b079-409a-bf22-79874f231a2e",
      "text": "The influenza vaccine has existed for 78 years and influenza still exists.",
      "date": "2025-02-08 00:00:00+00:00"
    },
    {
      "id": "3a47fae3-bbb0-43a2-ba49-1814af0c3582",
      "text": "The world considers Ukraine a Nazi state.",
      "date": "2021-08-23 21:05:00"
    },
    {
      "id": "7729c1e6-daf9-43e8-8f05-13d5abb67363",
      "text": "Ukraine is forced to purchase the Russian COVID-19 vaccine.",
      "date": "2021-01-06 12:01:36"
    },
    {
      "id": "ec3f7c59-e418-4dc7-9051-8e61a0e8e5e7",
      "text": "Moderna produced COVID-19 vaccines before the pandemic began.",
      "date": "2023-02-14 00:00:00+00:00"
    },
    {
      "id": "22c7b5e2-c0b8-486e-ae92-b3478ba3a159",
      "text": "Ukrainian authorities will mobilize workers at nuclear power plants.",
      "date": "2023-03-04 12:33:00"
    },
    {
      "id": "d7bc4506-898d-4cf0-99e3-6b4c693e9ba2",
      "text": "DMSO effectively treats pain.",
      "date": "2025-08-04 00:00:00+00:00"
    },
    {
      "id": "f99a79a4-6ea5-487c-9ad5-126653491c6c",
      "text": "Crimea benefits economically from its reunification with Russia.",
      "date": "2017-08-01 20:15:51"
    },
    {
      "id": "df0444fa-0108-44fb-9a41-a5ccb4264275",
      "text": "Vaccinated people face no danger from unvaccinated people; unvaccinated people have natural immunity and are less likely to get sick from COVID-19 than vaccinated people.",
      "date": "2021-09-24 00:00:00+00:00"
    },
    {
      "id": "320d86e9-05f0-40f0-a64d-f3a23a09f492",
      "text": "Ukraine imported spent nuclear fuel to build a dirty bomb.",
      "date": "2025-12-12 00:00:00+00:00"
    },
    {
      "id": "e6b8b24f-3c1d-4b2f-8758-4cb1449207a6",
      "text": "Zelensky’s entourage act as intermediaries in weapons schemes",
      "date": "2022-04-05 19:02:22"
    },
    {
      "id": "aae86df3-6521-4ed4-a063-13ca198344bc",
      "text": "CDC admits 146.6 million Americans have natural immunity and 94% of COVID-related deaths were not caused by COVID-19.",
      "date": "2021-11-13 00:00:00+00:00"
    },
    {
      "id": "9333691c-9fac-48f5-b168-51ba9ba9ce6f",
      "text": "The EU fears that Ukraine is smuggling weapons and drugs.",
      "date": "2022-07-13 10:15:00"
    },
    {
      "id": "d1a16d25-6596-46f5-898f-d0b42f956fce",
      "text": "The Netherlands accuses Ukraine of criminal conduct in the MH17 investigation.",
      "date": "2016-01-31 12:00:32"
    },
    {
      "id": "6d0f0417-0ad9-40ba-bddd-2050e41aaf92",
      "text": "U.S. delegation leader condemned NATO actions in the Black Sea.",
      "date": "2019-05-04 11:26:56"
    },
    {
      "id": "5767beb0-c933-4e88-9be9-fa25294894a5",
      "text": "A quarter of U.S. COVID-19 deaths were preventable with vaccination.",
      "date": "2022-04-21 00:00:00+00:00"
    },
    {
      "id": "88586791-dac7-4eae-93f2-1f5088deaff3",
      "text": "Britain has ruled that Ukraine is responsible for Yanukovych's debt.",
      "date": "2019-12-24 08:17:09"
    },
    {
      "id": "d2b91e1b-119d-4b46-a45b-d31503811126",
      "text": "Blades from failing wind farms will be launched at people.",
      "date": "2024-07-24 00:00:00+00:00"
    },
    {
      "id": "e45969f9-8906-49c4-91cf-ca8b972acfa2",
      "text": "Chemotherapy is 100% mustard gas and causes cancer.",
      "date": "2024-05-28 00:00:00+00:00"
    },
    {
      "id": "476a7a56-ac30-4d52-9a28-cb6771609992",
      "text": "Ukraine’s Internal Affairs Ministry says Russia’s strikes are highly precise.",
      "date": "2024-04-09 10:00:00"
    },
    {
      "id": "8f48c0c7-9599-48e9-8266-33bb81928adb",
      "text": "Ukraine makes opposing NATO and the EU illegal.",
      "date": "2019-02-23 13:27:39"
    },
    {
      "id": "56c79572-5c21-4aff-8ee3-d0693b0a5f53",
      "text": "The coronavirus was created in a laboratory and patented in 2015.",
      "date": "2020-01-24 00:00:00+00:00"
    },
    {
      "id": "12ce5ef5-db4f-4329-b817-14e69033510a",
      "text": "Poroshenko allows lumber to be smuggled into the EU.",
      "date": "2018-07-25 13:21:45"
    },
    {
      "id": "a2032602-1b45-4927-8fd7-e58380efe7e8",
      "text": "Moderna reported that serious adverse events affected 1 in 200 toddlers and concluded the mRNA vaccine was safe in children.",
      "date": "2022-10-29 00:00:00+00:00"
    },
    {
      "id": "4b32edf9-0d33-41e1-99d5-1ab79fdd6ba9",
      "text": "NATO is illegally occupying Ukraine.",
      "date": "2020-09-25 11:04:00"
    },
    {
      "id": "c9dc8b79-d140-4e6c-a007-cee5b5e4d7df",
      "text": "Polio was renamed to hide that it still exists; the polio vaccine does not work; vaccines contain harmful mercury, SV40, and DNA contamination.",
      "date": "2025-03-26 00:00:00+00:00"
    },
    {
      "id": "aa5e3ea1-6aa8-4949-b5ea-a17f75263501",
      "text": "There has been no long-term change in sea level rise rates over the last 120 years.",
      "date": "2021-01-15 00:00:00+00:00"
    },
    {
      "id": "1d741e3f-f006-4b3e-a634-e8430d392812",
      "text": "Viruses do not exist and terrain theory fully explains why diseases occur.",
      "date": "2024-02-11 00:00:00+00:00"
    },
    {
      "id": "5ffa8173-142d-46fc-8a46-e6ede611a7f7",
      "text": "Ukrainian soldiers committed suicide instead of shooting at Russian separatists.",
      "date": "2020-02-05 15:46:35"
    },
    {
      "id": "b88d61fc-871c-45c6-9a1f-465e76dfe0e5",
      "text": "You can determine a person's immune system strength by looking at their eyes.",
      "date": "2022-05-13 00:00:00+00:00"
    },
    {
      "id": "8317dd6d-21d3-4041-ba08-d341e9d5d4ec",
      "text": "Chemtrails contain barium salts that are 10,000 times more toxic to the human nervous system than lead.",
      "date": "2023-03-18 00:00:00+00:00"
    },
    {
      "id": "01d346e1-324d-498c-9e77-d15d8c02410c",
      "text": "mRNA COVID-19 vaccine lipid nanoparticles concentrate in the ovaries, causing the ovaries to produce large amounts of toxic spike protein.",
      "date": "2021-06-24 00:00:00+00:00"
    },
    {
      "id": "8752aaa7-c117-409c-97a5-33654f99a19e",
      "text": "Ukrainians in Poland are slaves.",
      "date": "2018-08-22 10:39:28"
    },
    {
      "id": "18a1c6d8-94f6-43cf-87cc-29cc134dcb1c",
      "text": "The COVID-19 vaccine is unsafe and ineffective because its trial is still underway, and thousands of people who received the vaccine have died or been seriously injured.",
      "date": "2021-02-02 00:00:00+00:00"
    },
    {
      "id": "5d97ba40-893d-4e0a-9deb-9667147e6912",
      "text": "Sea-level rise is independent of ocean temperature and CO2.",
      "date": "2018-05-15 00:00:00+00:00"
    },
    {
      "id": "39ab6769-1890-429e-b317-731e9a4eff85",
      "text": "Leaders of self‑proclaimed separatist republics appeared before the UN Security Council.",
      "date": "2020-12-03 21:23:29"
    },
    {
      "id": "22c52ca6-b7de-45b7-90e8-f17840ef578d",
      "text": "The EU is bringing Ukraine to its knees.",
      "date": "2017-06-29 22:27:56"
    },
    {
      "id": "f36689c9-d8fa-49ec-849b-0826304fa11d",
      "text": "Bill Gates said genetically modified organisms are being injected into children's arms and shot into their veins.",
      "date": "2020-05-26 00:00:00+00:00"
    },
    {
      "id": "900e1eee-866c-424a-8d33-57b367844e47",
      "text": "Ukraine continues to buy gas from Russia.",
      "date": "2016-04-05 11:12:07"
    },
    {
      "id": "09b4e52e-8c85-4f99-a325-574e2b0f7690",
      "text": "Merck scrapped its COVID-19 vaccine program and said getting infected and recovering provides better protection than vaccination.",
      "date": "2021-01-29 00:00:00+00:00"
    },
    {
      "id": "1ea2d7a3-eaf7-465f-82c9-4ff74a567e2b",
      "text": "Previously healthy people are being seriously harmed and dying from the flu shot.",
      "date": "2019-02-28 00:00:00+00:00"
    },
    {
      "id": "95591809-ea32-440d-bc8a-6614f1dc69ff",
      "text": "Regulators reduced approval standards so the COVID-19 vaccine was approved regardless of evidence, and the COVID-19 vaccine does not prevent transmission.",
      "date": "2020-12-13 00:00:00+00:00"
    },
    {
      "id": "a98efa16-89b0-4b36-a563-e8a6964e5dda",
      "text": "U.S. senators armed Ukraine to capture the Donbas region.",
      "date": "2021-12-29 10:33:00"
    },
    {
      "id": "4f973af5-b56d-47c9-bb96-aba7882312eb",
      "text": "Putin plans to militarily retake Crimea.",
      "date": "2022-02-02 15:14:39"
    },
    {
      "id": "ef196b0f-45eb-4409-8ae0-5474c6c35470",
      "text": "Czech data shows COVID-19 vaccines reduce fertility.",
      "date": "2025-05-11 00:00:00+00:00"
    },
    {
      "id": "16c59c3d-069a-48a2-ae37-ad52d70c88d4",
      "text": "Ukraine sent soldiers to Germany for training without testing them for COVID-19.",
      "date": "2020-07-25 08:02:00"
    },
    {
      "id": "30a36220-c2d9-44cd-b29f-46744923b417",
      "text": "One million mRNA COVID-19 vaccine doses given to teenagers prevent at most one death and cause 100,000–200,000 severe side effects.",
      "date": "2023-09-25 00:00:00+00:00"
    },
    {
      "id": "9ee9fd26-4cda-4482-a159-a1dc52f4ac09",
      "text": "Building a wind turbine requires a very large amount of energy and materials, and wind turbines are expensive, inefficient, and kill birds and bats.",
      "date": "2025-07-18 00:00:00+00:00"
    },
    {
      "id": "22cddca1-b8a5-487a-9a1d-e468a1090200",
      "text": "Infection-induced immunity is by far the most robust immunity against COVID-19.",
      "date": "2021-10-19 00:00:00+00:00"
    },
    {
      "id": "4c7b40f2-2b81-4a1a-b5cf-5c2a0da3733e",
      "text": "The Mriya transport plane wreckage was disposed of.",
      "date": "2022-05-28 12:25:00"
    },
    {
      "id": "7dd0ad39-1c10-4dde-b71b-8e7fc0ead843",
      "text": "NATO is dissatisfied with the too-soft mobilization measures for Ukrainians abroad.",
      "date": "2024-05-14 11:30:00"
    },
    {
      "id": "a90cf2b5-cc77-405a-83f2-ba43c67a3100",
      "text": "The government has released plans to force everyone to receive a vaccine and three vaccines in U.S. Stage 3 trials will be ready in weeks.",
      "date": "2020-04-10 00:00:00+00:00"
    },
    {
      "id": "e4116e8a-c10c-46d3-98cc-ee87429a5fd8",
      "text": "VAERS reports in Florida rose 1,700% after COVID-19 vaccines became available, demonstrating that COVID-19 vaccines are unsafe.",
      "date": "2023-02-15 00:00:00+00:00"
    },
    {
      "id": "f91205ea-2d89-4257-9aef-cc7efdc62003",
      "text": "Federal study found marijuana is 100 times less toxic than alcohol and is safer than tobacco",
      "date": "2018-12-20 00:00:00+00:00"
    },
    {
      "id": "efa402f0-22b5-44d8-83be-4aefe71ff19f",
      "text": "American media claim Ukraine's government is a neo‑Nazi regime and is illegitimate.",
      "date": "2017-09-05 15:26:58"
    },
    {
      "id": "1cc700fb-8ae3-4f9f-9bbf-2d20e10fe90c",
      "text": "People are fined for planting potatoes",
      "date": "2020-04-20 19:10:45"
    },
    {
      "id": "ba278d3a-b34f-4a39-b924-1c268c771e7d",
      "text": "920 women lost their unborn babies after getting vaccinated.",
      "date": "2021-11-06 00:00:00+00:00"
    },
    {
      "id": "b4b64a7f-18d5-4109-8ab5-2151c1eb53e0",
      "text": "Ukraine will replace Victory Day with Europe Day.",
      "date": "2019-02-23 09:09:38"
    },
    {
      "id": "7e2549b0-4be4-4af1-a07d-178f191ff255",
      "text": "Not living at an officially registered residence in Ukraine is punishable by law.",
      "date": "2016-04-29 20:25:05"
    },
    {
      "id": "6ff33f56-8167-4fb4-a217-9e2fd0587ed6",
      "text": "Fungi cause cancer.",
      "date": "2024-04-30 00:00:00+00:00"
    },
    {
      "id": "e4e4f22e-742d-4857-ac91-0adeb6cc7a75",
      "text": "Lavrov says Odesa and Mykolaiv were created by Russian people.",
      "date": "2025-12-11 00:00:00+00:00"
    },
    {
      "id": "2a6bc326-3688-4af4-a70b-a9128cad92ee",
      "text": "Kyiv and Washington are dividing Ukraine.",
      "date": "2015-08-18 19:30:18"
    },
    {
      "id": "628d2d95-6e88-45ac-9fba-404f17e734d5",
      "text": "Vaccinated individuals have higher rates of COVID-19 infection and more musculoskeletal problems than unvaccinated individuals.",
      "date": "2025-02-25 00:00:00+00:00"
    },
    {
      "id": "d37b5b73-be79-4707-93d6-b1619e360bd7",
      "text": "A spontaneous memorial was erected on the Tisza River for men who died while attempting to cross the border.",
      "date": "2024-05-29 11:58:33"
    },
    {
      "id": "9e9314e2-b3b4-4bb0-bbb6-80e2a791d407",
      "text": "The Maldives are not threatened by climate change",
      "date": "2025-03-09 00:00:00+00:00"
    },
    {
      "id": "6de9b109-7d60-4dbd-b946-2f2c248e99ab",
      "text": "The U.S. CDC is lowering the PCR cycle threshold (Ct) for tests of suspected vaccine breakthrough infections to reduce the number of officially recorded COVID-19 cases.",
      "date": "2021-05-27 00:00:00+00:00"
    },
    {
      "id": "f2dd708b-da06-4d95-80e8-dccc8a2c283c",
      "text": "US intelligence found reasons to pursue regime change in Ukraine.",
      "date": "2018-02-17 15:00:43"
    },
    {
      "id": "da22d1f6-dbbe-49e7-89e8-194fddf2bee9",
      "text": "Climate change is not new and is not caused by humans.",
      "date": "2020-01-02 00:00:00+00:00"
    },
    {
      "id": "dfa79aab-78cc-4f1d-a545-ffcbdadc9fd2",
      "text": "Abortions are never medically necessary",
      "date": "2019-08-09 00:00:00+00:00"
    },
    {
      "id": "02712107-dcf0-4356-96ab-4e5cc05a1d3f",
      "text": "Lviv graduates were given ribbons depicting a map of Ukraine that excludes Crimea.",
      "date": "2024-06-03 12:56:00"
    },
    {
      "id": "d6bd9722-09de-4f4d-ab20-04a79de1c458",
      "text": "Amish communities have herd immunity because everyone already had COVID, so vaccines are unnecessary.",
      "date": "2021-10-13 00:00:00+00:00"
    },
    {
      "id": "d1a5138e-9a0e-41e7-9b59-b1ed6f92f735",
      "text": "Massive demonstrations across Europe are supporting Donbas.",
      "date": "2017-03-11 21:57:14"
    },
    {
      "id": "d244e0c8-2ef0-4e93-ab92-9c12d8a1b325",
      "text": "Ukraine will suffer an economic disaster.",
      "date": "2018-06-27 09:39:14"
    },
    {
      "id": "86ce935c-a686-4874-b90f-73593cf768d2",
      "text": "Ukraine admitted foreign mercenaries left Ukraine to fight in the war in Israel.",
      "date": "2023-10-17 11:03:00"
    },
    {
      "id": "7c99c381-d341-4d06-986c-97983ad65b7d",
      "text": "No one has died of cancer or heart disease since the COVID-19 pandemic began.",
      "date": "2021-08-30 00:00:00+00:00"
    },
    {
      "id": "d30faa66-0ea0-482d-ac2a-7fcfdc7697d2",
      "text": "Vitamins C and D are now part of conventional SARS-CoV-2 treatment; very high-dose vitamin C kills SARS-CoV-2; vitamin D reduces SARS-CoV-2 infection risk.",
      "date": "2020-04-02 00:00:00+00:00"
    },
    {
      "id": "49c51996-7793-4d11-83a8-f7fba16e94b6",
      "text": "Romanian authorities prioritize evacuating Ukrainians from Gaza before evacuating Romanian citizens.",
      "date": "2023-10-18 11:51:00"
    },
    {
      "id": "46eefdcc-9153-4231-98d5-1f11bb28bd1e",
      "text": "Coronavirus does not exist.",
      "date": "2020-03-25 00:00:00+00:00"
    },
    {
      "id": "e6f87d0a-58ad-4a72-a8cb-9808b8bfb5ff",
      "text": "A video shows a Russian Oreshnik missile used in an attack on Dnipro.",
      "date": "2024-11-21 00:00:00+00:00"
    },
    {
      "id": "427dc044-8015-40ea-bc8e-7ba7b8003ea8",
      "text": "Hurricane Milton is a targeted geo-engineered storm, and hurricanes never develop in the western Gulf of Mexico and always head straight east to Florida.",
      "date": "2024-10-07 00:00:00+00:00"
    },
    {
      "id": "ab7deee3-6479-45e0-bbf4-5c661a4fe1fa",
      "text": "Most people are infected with harmful parasites and need to regularly cleanse their bodies using pills, juices, seeds, or cleansers that detoxify the body and eliminate parasites.",
      "date": "2024-06-11 00:00:00+00:00"
    },
    {
      "id": "bea9af0c-5656-4e03-9868-2e7e2295fa5c",
      "text": "Ukraine will cut off gas supplies to Europe.",
      "date": "2021-09-27 17:03:37"
    },
    {
      "id": "52fc8483-9863-472b-9ed3-98c00e449547",
      "text": "Crimean self-defence units took over the parliament building, and a professional actor was used as a witness.",
      "date": "2014-03-04 10:14:09"
    },
    {
      "id": "0f25cb03-35c2-40e8-b96a-ad0f42f18adb",
      "text": "Robert Kiyosaki said financial aid to Ukraine is pointless.",
      "date": "2024-02-12 10:01:00"
    },
    {
      "id": "baef1fc2-a432-4ab8-a4e7-d7111ce18e8f",
      "text": "More than 10 million Ukrainians left Ukraine because Ukraine pursued a pro‑NATO course.",
      "date": "2019-02-05 17:50:10"
    },
    {
      "id": "c7adce15-79ab-4154-9212-55f8be8b0a39",
      "text": "Kurt Volker says Ukraine cannot regain Crimea and Donbas.",
      "date": "2018-05-19 10:44:04"
    },
    {
      "id": "b69575c4-a47e-4678-a8c6-9757e605d896",
      "text": "Uman Synagogue houses a Ukrainian nationalist military base.",
      "date": "2022-03-31 09:39:07"
    },
    {
      "id": "b318e9f9-9a66-430c-92d3-7da39e592574",
      "text": "HAARP experiments caused the May 2024 auroras.",
      "date": "2024-05-11 00:00:00+00:00"
    },
    {
      "id": "af987d12-b231-4ec3-96e4-33aecad0ec38",
      "text": "COVID-19 vaccines cause female sterilization by triggering an immune response against the placenta.",
      "date": "2020-10-12 00:00:00+00:00"
    },
    {
      "id": "5fec1f94-3bb9-41d7-a93c-2d3f09830f11",
      "text": "2016 was not a global temperature record.",
      "date": "2017-01-27 00:00:00+00:00"
    },
    {
      "id": "48523f9c-4b23-4591-8c13-f194abb060cd",
      "text": "A Turkish delegation arrived in Crimea.",
      "date": "2016-11-25 22:21:04"
    },
    {
      "id": "9c1cd331-4595-471b-9ee7-95bb5b6787b6",
      "text": "SSU Head Nalyvaychenko has a United States passport.",
      "date": "2014-05-15 19:30:27"
    },
    {
      "id": "d950f456-f04c-4ae2-833f-3356da97c464",
      "text": "EU countries are massively denying visas to Ukrainians.",
      "date": "2016-01-30 13:02:48"
    },
    {
      "id": "236ca972-2169-4708-8479-769f3fde2bb3",
      "text": "Relations between Russia and the West are deteriorating because of the war in Ukraine.",
      "date": "2019-10-02 10:56:36"
    },
    {
      "id": "e71a3ce7-7f1e-43f3-8da6-a130a2789a80",
      "text": "Natural immunity to COVID-19 is stronger and longer-lasting than immunity from COVID-19 vaccines.",
      "date": "2021-07-17 00:00:00+00:00"
    },
    {
      "id": "9344c21f-e46e-492f-bab2-16d7ac5170ec",
      "text": "A Lancet study shows vaccinated people have lower immune function than unvaccinated people and that COVID-19 vaccines suppress the immune system.",
      "date": "2022-07-28 00:00:00+00:00"
    },
    {
      "id": "18c57d84-5c5e-4cb2-ab99-543cf4ad5dd6",
      "text": "More children will die from the COVID-19 vaccine than from COVID-19, and there is proof.",
      "date": "2021-11-26 00:00:00+00:00"
    },
    {
      "id": "8d553264-2775-4b89-bf31-4e2cde806720",
      "text": "Photo shows a Polish military order to attack Ukraine.",
      "date": "2022-05-04 19:19:00"
    },
    {
      "id": "ef58cdc4-b176-42c5-8d1d-6accb948d1b9",
      "text": "COVID-19 is not dangerous.",
      "date": "2020-03-29 15:06:00"
    },
    {
      "id": "a0f1ab21-1861-4603-9fe3-8d7c1490bbf6",
      "text": "Wind turbine disposal creates a large environmental footprint.",
      "date": "2022-11-03 00:00:00+00:00"
    },
    {
      "id": "14f6527d-67cc-4960-8e60-bf244deff220",
      "text": "Covid-19 vaccination in pregnancy provides no benefit and causes higher rates of neonatal and all-cause readmissions among babies born to vaccinated mothers.",
      "date": "2023-10-11 00:00:00+00:00"
    },
    {
      "id": "0ecf2a39-3371-4e9e-a01e-590af98a1838",
      "text": "Consuming turpentine kills parasites",
      "date": "2022-09-01 00:00:00+00:00"
    },
    {
      "id": "3c84cd9f-a0b5-44a8-9e90-7b1c22667bf1",
      "text": "A review found that COVID-19 mRNA vaccines aid cancer development.",
      "date": "2024-04-16 00:00:00+00:00"
    },
    {
      "id": "793a15d3-c559-4807-84a5-df29842c117f",
      "text": "Wagner Group destroyed a Leopard tank and killed its Polish-German crew.",
      "date": "2023-03-01 11:13:13"
    },
    {
      "id": "ad2ec165-9afb-4dce-a0b6-657061bdadf9",
      "text": "CO2 is a plant nutrient and is not a pollutant that threatens human civilization; installing CO2 generators in greenhouses does not kill plants.",
      "date": "2013-06-22 00:00:00+00:00"
    },
    {
      "id": "99c6fb0c-60a6-423b-a576-f2c16489097e",
      "text": "Ukraine and Western countries are preparing terrorist attacks in Crimea.",
      "date": "2023-01-30 12:32:00"
    },
    {
      "id": "0f8d6861-6faa-489c-9dc2-42f3b063e07c",
      "text": "The 1986 National Childhood Vaccine Injury Act prevents people from suing vaccine manufacturers for injuries or deaths caused by vaccines.",
      "date": "2020-12-15 00:00:00+00:00"
    },
    {
      "id": "e83d8224-5059-4b16-9c3d-c34ba2eea3df",
      "text": "Sunscreen causes skin cancer and reduces vitamin D production, and wearing sunglasses increases the risk of sunburn.",
      "date": "2024-07-19 00:00:00+00:00"
    },
    {
      "id": "90c5896e-279d-42dd-84f9-ee6335fea90f",
      "text": "Separatists obtained military hardware as spoils of war.",
      "date": "2017-08-10 07:20:01"
    },
    {
      "id": "1136e8fd-88de-4185-8a62-33c192bed1b7",
      "text": "The Great Barrier Reef currently has record-high levels of coral and is not threatened by climate change.",
      "date": "2021-08-21 00:00:00+00:00"
    },
    {
      "id": "e52c46e8-b089-4f2e-aa03-838e33557d82",
      "text": "A pro-mask study was withdrawn after researchers found virus spread in the analyzed counties; masks do not work.",
      "date": "2020-11-18 00:00:00+00:00"
    },
    {
      "id": "0465fe3c-5a98-41aa-9475-7b4af42b25aa",
      "text": "The UN confirmed that Russian intelligence agencies were behind the Odessa House of Trade Unions tragedy.",
      "date": "2014-06-21 07:29:23"
    },
    {
      "id": "e39e34ca-5c88-4450-80b0-ff376e57f4a9",
      "text": "Vaccinated and boosted people were more likely to be hospitalized with the Omicron variant than unvaccinated people.",
      "date": "2023-09-13 00:00:00+00:00"
    },
    {
      "id": "65750d96-8d7d-46b0-baba-dc7162a0fa10",
      "text": "Global warming saves 166,000 lives each year; reported increases in heat-related deaths are caused by population growth and aging, not by climate change.",
      "date": "2021-09-04 00:00:00+00:00"
    },
    {
      "id": "61a29cad-2475-4939-bba5-941c823aaa57",
      "text": "Ukraine is blackmailing the West by using EU membership as leverage.",
      "date": "2017-07-20 20:04:56"
    },
    {
      "id": "9636465b-c7ed-464d-bcaa-cf1340df799b",
      "text": "Ukraine canceled a 15 million hryvnia payment to the families of fallen soldiers.",
      "date": "2022-08-28 14:16:09"
    },
    {
      "id": "4d465014-a97e-4e1f-97c5-c64103818a8f",
      "text": "Ukraine gives half of its national budget to Western creditors.",
      "date": "2020-06-18 08:04:04"
    },
    {
      "id": "67ecfa74-b6ed-41ce-b5a3-a2bcb926302a",
      "text": "A German restaurant's advertisement urges customers to stop talking about Ukraine.",
      "date": "2023-09-21 15:46:00"
    },
    {
      "id": "148a00ff-6a57-4d0c-a6ad-c35238e59683",
      "text": "Ukraine is preparing to carry out a chemical attack near Odesa.",
      "date": "2022-04-27 16:21:37"
    },
    {
      "id": "d12d23f4-cc6b-44bd-8ae1-8a0ce222ac50",
      "text": "Queensland Health researchers found that long COVID does not exist.",
      "date": "2024-03-22 00:00:00+00:00"
    },
    {
      "id": "366db116-0531-410e-98dc-2cd7e903c0ac",
      "text": "The EU will impose retaliatory sanctions against the US.",
      "date": "2017-07-29 10:15:47"
    },
    {
      "id": "2b8221a1-aa2e-4f59-a240-e1dc88d12ec7",
      "text": "UNICEF accuses Kyiv of committing aggression against Donetsk and Luhansk.",
      "date": "2016-02-23 15:35:29"
    },
    {
      "id": "1cb98ff2-9204-46ef-aea3-ac3cb341560b",
      "text": "A new medicine normalizes blood sugar levels after the first use.",
      "date": "2023-07-11 00:00:00+00:00"
    },
    {
      "id": "5f32d335-0db0-4fb5-8d1e-89884723fc6e",
      "text": "Italians asked Vladimir Putin to save the world.",
      "date": "2015-06-12 18:39:51"
    },
    {
      "id": "3386479a-ceca-414d-8f19-b6fc28b90bc9",
      "text": "There is no factual evidence for global warming; scientists do not know whether CO2, solar activity, or natural variability cause it.",
      "date": "2021-04-16 00:00:00+00:00"
    },
    {
      "id": "a9bc90da-6884-4eb7-a0ba-5cc5a970baca",
      "text": "Coughing repeatedly and very vigorously helps people who are experiencing a heart attack.",
      "date": "2021-03-30 00:00:00+00:00"
    },
    {
      "id": "57ae861c-706d-4491-b16c-de1ddf59f0b0",
      "text": "Doctors in Donetsk refused to treat a wounded Ukrainian soldier.",
      "date": "2015-07-23 17:56:43"
    },
    {
      "id": "bd89072d-c992-4588-90d6-5b903ad308c1",
      "text": "Scientists adjusted sea level data to create a false impression that oceans are rising.",
      "date": "2019-05-28 00:00:00+00:00"
    },
    {
      "id": "b66910e5-daae-4814-957b-1bf57d03d2d3",
      "text": "NATO's nuclear drills are causing a world war.",
      "date": "2022-10-17 15:19:09"
    },
    {
      "id": "93046fd1-58f7-4e4d-ba19-9705a7d94046",
      "text": "Unvaccinated people infect vaccinated people with the same virus the vaccinated were vaccinated against.",
      "date": "2021-07-07 00:00:00+00:00"
    },
    {
      "id": "2c6d6c0c-581c-4afe-a3a8-fea66abbc95f",
      "text": "A quarter of U.S. COVID-19 deaths were preventable with vaccination.",
      "date": "2022-10-28 00:00:00+00:00"
    },
    {
      "id": "e0a5f231-75c6-437e-9eb2-f531cff87bb7",
      "text": "Solar cycles and natural variations in solar and Earth activity cause climate change, and anthropogenic CO2 emissions do not cause climate change.",
      "date": "2023-09-18 00:00:00+00:00"
    },
    {
      "id": "cedf273d-4281-489e-99a5-ba6e65e45127",
      "text": "Kateryna Prokopenko is an influential German politician.",
      "date": "2023-04-15 15:28:46"
    },
    {
      "id": "298d1707-0fd3-4201-8a1e-4560d6ff3fa8",
      "text": "Pfizer admitted that vaccinated people can shed the vaccine onto unvaccinated people.",
      "date": "2023-03-31 00:00:00+00:00"
    },
    {
      "id": "52975b9d-d2e7-4174-ab1a-5fc71f2f29fc",
      "text": "HAARP caused the October 2024 auroras.",
      "date": "2024-10-11 00:00:00+00:00"
    },
    {
      "id": "d5244cf2-bd56-4f1e-b7cd-8275b06653ff",
      "text": "Donbas residents are being forcibly resettled to Lviv for reeducation.",
      "date": "2019-11-23 23:45:29"
    },
    {
      "id": "3ecb35d7-1dbb-4da7-af32-d8663dffc64d",
      "text": "COVID-19 vaccines caused 26.6 million injuries and 1.36 million disabilities in 2022 and cost the economy billions of dollars.",
      "date": "2023-03-28 00:00:00+00:00"
    },
    {
      "id": "1cb65bfb-8150-4bfd-9987-88ff145e66b5",
      "text": "Svoboda political party designed a banknote depicting Adolf Hitler.",
      "date": "2015-03-03 11:36:37"
    },
    {
      "id": "381647b0-5e40-44f4-bd33-12838044198c",
      "text": "Authorities in Barcelona removed children from a Russian woman because of anti-Russian bias.",
      "date": "2022-07-29 19:12:12"
    },
    {
      "id": "aec47440-0cf6-4af2-9a55-32c0280b3e20",
      "text": "U.S. doctors found that long COVID developed in 70 percent of cases after vaccination rather than after infection.",
      "date": "2024-03-15 00:00:00+00:00"
    },
    {
      "id": "adfd4ae7-4210-4c62-bfa0-6781d45bcc59",
      "text": "Three Ukrainians were detained in Israel for looting.",
      "date": "2023-10-13 11:00:00"
    },
    {
      "id": "15a4d950-ede9-4236-99cb-d4ddfab73b99",
      "text": "Ukrainian Greek Catholics are exempt from mobilization.",
      "date": "2024-02-06 10:01:00"
    },
    {
      "id": "fd40bdd0-c6cc-4711-b6da-f6636f70fdb8",
      "text": "Jihadists participated in the Crimean Tatar World Congress.",
      "date": "2016-01-18 22:46:25"
    },
    {
      "id": "350999e3-219f-4b31-962c-d52e4f548e1b",
      "text": "Lithuania teaches war to Ukrainian children.",
      "date": "2019-08-27 10:13:22"
    },
    {
      "id": "3f2abbd2-060e-4ad7-b5a8-a84b9511e597",
      "text": "Ukraine opposes medals commemorating the 75th anniversary of Victory over Nazism.",
      "date": "2020-12-10 09:30:11"
    },
    {
      "id": "7d9aec94-20fe-4c75-9332-62af6797dc14",
      "text": "Kyiv ignored the Minsk Protocol meeting.",
      "date": "2018-09-21 16:52:23"
    },
    {
      "id": "db528ec0-3250-402d-a8d8-f12011ce042d",
      "text": "Kyiv City Council proposed a complete ban on the Russian language.",
      "date": "2016-03-22 23:11:33"
    },
    {
      "id": "6d0a63d8-61a9-4d2d-aea6-4e60a12d2dea",
      "text": "Most cases of Alzheimer's disease are preventable, Alzheimer's disease is not genetic, and Alzheimer's disease is type 3 diabetes (insulin resistance of the brain).",
      "date": "2022-09-29 00:00:00+00:00"
    },
    {
      "id": "6004ac54-d4df-49b3-a497-d03e67091a98",
      "text": "Global temperatures are rising two to three times more slowly than climate models predicted.",
      "date": "2017-04-22 00:00:00+00:00"
    },
    {
      "id": "da5d347b-5fb3-4187-bbba-c8b354ad6ff2",
      "text": "Foreign mercenaries serving in the National Guard are filming the atrocities they commit.",
      "date": "2014-10-11 17:38:08"
    },
    {
      "id": "3e3f1040-d2fa-4f56-a06a-86ea44e3b71b",
      "text": "Magnetic pole reversals cause the Earth to flip vertically and stop rotating for six days, causing cataclysmic events.",
      "date": "2023-01-18 00:00:00+00:00"
    },
    {
      "id": "e3155177-7923-4bed-b420-8405a93cc93d",
      "text": "Ukraine's autumn recruitment efforts failed.",
      "date": "2017-12-14 00:46:13"
    },
    {
      "id": "07988081-937a-46fe-bd74-5dbb0846b25d",
      "text": "Pfizer's data show COVID-19 vaccines are unsafe for pregnant women.",
      "date": "2023-04-19 00:00:00+00:00"
    },
    {
      "id": "9843893d-6690-400b-ba52-b3d060a45f1e",
      "text": "People vaccinated against COVID-19 are more likely to be hospitalized than unvaccinated people.",
      "date": "2023-06-23 00:00:00+00:00"
    },
    {
      "id": "2b000b50-a42a-47c1-9d45-30baf3b84d49",
      "text": "Fighter jets drew a star over Alaska to honor Vladimir Putin.",
      "date": "2025-08-17 00:00:00+00:00"
    },
    {
      "id": "b35919e0-29c5-4cec-8c70-bbdaa9d266d4",
      "text": "Crimeans who left the peninsula after Russia annexed it are returning to Crimea.",
      "date": "2018-08-03 10:33:30"
    },
    {
      "id": "e1c039f7-5ea9-4d63-a8b8-4f2855a5116e",
      "text": "There are plans to blow up the Luhansk-area railway overpass to disrupt evacuations to Russia.",
      "date": "2022-02-20 22:21:29"
    },
    {
      "id": "1278c551-390c-4f62-98a2-54de97930a3b",
      "text": "The LifeNews journalist ordered separatists to open fire.",
      "date": "2014-05-25 10:18:03"
    },
    {
      "id": "027e4c0a-e0ed-4794-9444-00c62128252f",
      "text": "The United States officially recognized Donbas as an independent state.",
      "date": "2015-09-16 10:26:12"
    },
    {
      "id": "a204bf60-6b27-4a6a-961c-8a95940917d9",
      "text": "One Mt. Etna eruption released more than 10,000 times the CO2 emitted by all humans in history.",
      "date": "2019-08-19 00:00:00+00:00"
    },
    {
      "id": "1107377d-31cc-4177-abee-f8997c059202",
      "text": "More children will die from COVID-19 vaccines than from COVID-19.",
      "date": "2021-11-01 00:00:00+00:00"
    },
    {
      "id": "b11958aa-8fd4-4167-bad2-bb15154530cd",
      "text": "Australian temperatures increased by 0.3°C over the past century, not 1°C.",
      "date": "2017-11-10 00:00:00+00:00"
    },
    {
      "id": "9ea310a4-45b5-4541-a5ba-50c286d295be",
      "text": "Zelensky ordered schools and universities to work offline starting September 1.",
      "date": "2022-08-22 11:21:00"
    },
    {
      "id": "eb6f8055-76c8-4f43-ad76-682bcd9695bd",
      "text": "The World Bank website shows that countries purchased COVID-19 test kits in 2017 and 2018.",
      "date": "2020-09-05 00:00:00+00:00"
    },
    {
      "id": "5632a5f8-a908-440e-af68-fffdfc0964ce",
      "text": "Pro-Russian banners with the Russian flag appeared on Ukrainian streets.",
      "date": "2025-08-22 00:00:00+00:00"
    },
    {
      "id": "caa550e6-f9b4-4fbf-816f-cf2925782cd9",
      "text": "Ukraine formed a military alliance with the United States.",
      "date": "2014-07-31 18:19:03"
    },
    {
      "id": "5ea053a7-6ad0-4f32-b78e-4ce50ee30540",
      "text": "SARS-CoV-2 is spreading quickly from gas pumps and from shopping carts.",
      "date": "2020-03-26 00:00:00+00:00"
    },
    {
      "id": "b1f832ca-8dcf-4377-8681-55076f981d74",
      "text": "Giving water to babies under six months causes serious health risks.",
      "date": "2024-06-13 00:00:00+00:00"
    },
    {
      "id": "01d989e5-2d84-4128-896a-c4bd413bca98",
      "text": "Bill Gates said genetically modified organisms are injected directly into children's arms and into their veins.",
      "date": "2021-03-26 00:00:00+00:00"
    },
    {
      "id": "6fe94112-1374-43cc-82b2-2247c364b004",
      "text": "19% of American children have ADHD and 0.5% of French children have ADHD.",
      "date": "2019-10-14 00:00:00+00:00"
    },
    {
      "id": "5f516e9d-dbaf-4874-9212-04e63b2c7ed0",
      "text": "Sweden banned mandatory vaccinations because of serious health concerns.",
      "date": "2019-08-23 00:00:00+00:00"
    },
    {
      "id": "ba09747b-f0b6-4dbd-b0a6-470d389066fe",
      "text": "COVID-19 vaccines are experimental and ineffective; natural immunity is superior to vaccine-induced immunity; vaccine-induced spike protein is dangerous and causes serious side effects; the Omicron variant is mild and completely escapes prior vaccination.",
      "date": "2021-12-31 00:00:00+00:00"
    },
    {
      "id": "4f921cf8-8650-4d52-9ea8-4ce66ff4aaa7",
      "text": "Ukraine will imprison residents of Crimea and other occupied Ukrainian territories who hold Russian passports.",
      "date": "2021-12-08 20:25:22"
    },
    {
      "id": "13a60e49-831f-4ce3-b846-219ccc7e8def",
      "text": "COVID-19 vaccines contain luciferase to tag and track people.",
      "date": "2021-11-04 00:00:00+00:00"
    },
    {
      "id": "c2cedeb5-1b3a-4ad1-9e16-aff80d97d2c4",
      "text": "Electric vehicles are highly prone to catching fire.",
      "date": "2025-06-06 00:00:00+00:00"
    },
    {
      "id": "789c1f08-91d2-46b6-a5e1-6efb269f7290",
      "text": "Half of the 0.9°C of global warming is caused by greenhouse gases.",
      "date": "2018-10-21 00:00:00+00:00"
    },
    {
      "id": "a3f50eaa-34ee-491d-893a-65e72e4e3030",
      "text": "The Ministry of Defense does not receive any images from the ICEYE satellite.",
      "date": "2025-10-07 00:00:00+00:00"
    },
    {
      "id": "92c70728-8a84-4c64-a3bb-73a55eb2027a",
      "text": "Wilhelm Reich invented a cure for cancer.",
      "date": "2022-05-27 00:00:00+00:00"
    },
    {
      "id": "54911bf9-a56d-41b9-9a2c-a90b0f8ff629",
      "text": "Ukraine's National Corps developed an atomic bomb to use against Russians.",
      "date": "2022-02-04 18:29:20"
    },
    {
      "id": "c226c7d3-8328-4f02-8fb0-ed3d0a775a6d",
      "text": "The United Nations is dissatisfied with Western tanks sent to Ukraine.",
      "date": "2023-01-29 16:55:00"
    },
    {
      "id": "cd1bcd26-ed9e-4f8a-a582-7a3ef528fe8c",
      "text": "COVID-19 infection and COVID-19 vaccination cause HIV tests to turn positive and cause immunodeficiency.",
      "date": "2024-01-30 00:00:00+00:00"
    },
    {
      "id": "5aeb6899-996b-4917-877b-404a648405a9",
      "text": "A Turkish ship transported military equipment from Bulgaria to Ukraine.",
      "date": "2016-02-11 12:45:10"
    },
    {
      "id": "476a39ea-cc28-4fd5-b04d-d950bf6daaba",
      "text": "Diet and lifestyle changes, instead of chemotherapy or radiation, cause spontaneous remission of cancer.",
      "date": "2024-06-13 00:00:00+00:00"
    },
    {
      "id": "5cd436e7-5e8f-4fdd-844d-6a1feade2672",
      "text": "The SARS virus has circulated since 2003 and recurs every three to four years, so everyone in the world is immune.",
      "date": "2020-05-14 00:00:00+00:00"
    },
    {
      "id": "1feaa18c-a348-4318-9eea-bfa6da8247cc",
      "text": "Ukraine distributed counterfeit banknotes contaminated with tuberculosis in occupied Donbas.",
      "date": "2022-05-17 11:37:00"
    },
    {
      "id": "d78af013-bc42-4660-b56a-e505039c4243",
      "text": "COVID-19 has a 99.991% survival rate, so vaccines are unnecessary because vaccines were developed only for deadly diseases like smallpox that had no treatments.",
      "date": "2021-04-02 00:00:00+00:00"
    },
    {
      "id": "52f5053c-34f5-43b5-adb6-de2278fbba70",
      "text": "Kyiv increased electricity prices to fund hosting the Eurovision Song Contest.",
      "date": "2017-02-20 23:21:19"
    },
    {
      "id": "bca440e6-ccd3-48a9-9ea8-b8eae07dbc71",
      "text": "The Ukrainian government refuses to finance Kharkiv, and Kyiv has resigned itself to Russia’s occupation of Kharkiv.",
      "date": "2022-04-11 17:51:23"
    },
    {
      "id": "59345576-3c99-4f85-9c22-cb7f2ee69987",
      "text": "COVID-19 vaccines have killed millions of people worldwide, at a rate of one death per 1,000 doses.",
      "date": "2023-08-12 00:00:00+00:00"
    },
    {
      "id": "8c8ca322-1ed3-4f34-ad77-733d428cd6a3",
      "text": "The Ukrainian military bombed Snizhne.",
      "date": "2020-09-19 09:45:00"
    },
    {
      "id": "d4310cbd-b465-4be0-904c-ddd4775a9508",
      "text": "COVID-19 and COVID-19 vaccines are causing a global epidemic of terrifyingly aggressive cancers.",
      "date": "2025-03-26 00:00:00+00:00"
    },
    {
      "id": "ddfbf23e-6ad9-4461-9171-4d97b7c80f0a",
      "text": "Humans caused the Texas floods using cloud seeding, and the floods would not have occurred otherwise.",
      "date": "2025-07-06 00:00:00+00:00"
    },
    {
      "id": "4e689837-4d10-45d5-81a1-62d56468abc3",
      "text": "In 2009, 50% of Ukrainian citizens wanted to hold Russian citizenship.",
      "date": "2025-06-10 00:00:00+00:00"
    },
    {
      "id": "34069537-f1d4-4ac0-b377-fd2fd3a315de",
      "text": "The Kadyrov Foundation repaired an abandoned hospital in Rubizhne.",
      "date": "2022-05-18 14:59:14"
    },
    {
      "id": "6684e8c5-fb5f-4d58-93c0-7b7920bafabe",
      "text": "The U.S. Climate Reference Network finds there has been no warming in the United States for at least the past 14 years.",
      "date": "2019-06-09 00:00:00+00:00"
    },
    {
      "id": "e7ca5d87-eb91-438b-8987-7d1c73be5b0f",
      "text": "A new language law prohibits the use of any language other than Ukrainian.",
      "date": "2019-03-22 14:35:01"
    },
    {
      "id": "9e551c2b-9a5a-4862-9f0f-273c0b484cad",
      "text": "The Netherlands says Ukraine lied about a downed Boeing-777.",
      "date": "2014-07-30 00:38:01"
    },
    {
      "id": "dcc1afda-2113-499e-97e2-4c33cb4d20ac",
      "text": "Ukraine will stop gas transit in 2021",
      "date": "2020-04-17 20:44:10"
    },
    {
      "id": "d82c2aff-afb9-4f24-aebc-bca6be31b865",
      "text": "Polar bear populations are increasing and polar bears are thriving despite diminishing sea ice.",
      "date": "2020-05-05 00:00:00+00:00"
    },
    {
      "id": "7ba82044-6885-45eb-ade4-041b922dc24a",
      "text": "The Ukrainian Ministry funds radical nationalist organizations.",
      "date": "2018-11-16 20:59:42"
    },
    {
      "id": "f12e9165-d5cf-46fe-8144-3a54d7ebdfd8",
      "text": "The atmosphere is less sensitive to CO2 than climate models forecast.",
      "date": "2017-11-29 00:00:00+00:00"
    },
    {
      "id": "9cba1fb6-7b09-4002-a021-c674684b00b4",
      "text": "Ukraine is a drug entry point for Russia and Europe.",
      "date": "2018-12-07 12:26:08"
    },
    {
      "id": "eadbb245-11fd-4603-acc4-b3d1ed7503e7",
      "text": "Margarine is chemically only one molecule different from plastic.",
      "date": "2024-11-27 00:00:00+00:00"
    },
    {
      "id": "04fed4bc-0a1c-4f79-ab8b-9dff75e1254f",
      "text": "Patent US5676977A is for AIDS, patent US8835624B1 is for H1N1, and patents US7897744B2 and US8506968B2 are for SARS.",
      "date": "2024-08-01 00:00:00+00:00"
    },
    {
      "id": "626c2407-8a4a-41e4-a847-e1a640dd970b",
      "text": "Unadjusted temperature data show Australian temperatures increased by 0.3°C over the past century, not by 1.0°C.",
      "date": "2017-10-09 00:00:00+00:00"
    },
    {
      "id": "a50bbbf2-704e-41b4-be4b-727c9b13dfe6",
      "text": "Big Pharma murdered doctors to protect its profits and to silence holistic health practitioners.",
      "date": "2023-08-23 00:00:00+00:00"
    },
    {
      "id": "763b4c59-9a19-4c6b-b298-ced52db844c1",
      "text": "Ukraine has implemented juvenile justice.",
      "date": "2014-04-25 00:51:28"
    },
    {
      "id": "5565423b-d1c5-4760-a05d-88362c28d64d",
      "text": "mRNA COVID-19 vaccines do more harm than good.",
      "date": "2022-06-10 00:00:00+00:00"
    },
    {
      "id": "7e91a24e-bb1d-4942-b158-6561c268f135",
      "text": "The cow feed additive Bovaer is unsafe and makes milk unfit for human consumption.",
      "date": "2024-12-03 00:00:00+00:00"
    },
    {
      "id": "3e3a0ce3-9d32-4d33-9476-196214c4158c",
      "text": "Lviv officials urged that Crimea and Donbas be recognized as territories of Russia.",
      "date": "2015-05-08 09:43:25"
    },
    {
      "id": "0d4df62b-b694-4ca9-9337-0c8818b221ff",
      "text": "A peer-reviewed study found ivermectin reduces COVID-19 death risk by 92%, and the NIH lists ivermectin as a COVID-19 therapy.",
      "date": "2022-07-09 00:00:00+00:00"
    },
    {
      "id": "8dc2dc12-4483-4e22-bfba-f8c668631bf0",
      "text": "Ukraine cannot guarantee the security of its nuclear power plants without NATO.",
      "date": "2017-10-28 07:48:30"
    },
    {
      "id": "1e0dd477-2919-414b-956e-29f90a306828",
      "text": "The Moderna COVID-19 vaccine caused heart damage in 1 in 35 people and is a kill shot.",
      "date": "2023-08-08 00:00:00+00:00"
    },
    {
      "id": "96e78690-52ca-41bf-bace-4b4e15b86c84",
      "text": "The CDC says COVID-19 vaccination increases the likelihood of infection with the BA.2.86 variant.",
      "date": "2023-08-29 00:00:00+00:00"
    },
    {
      "id": "8c41652b-8e1e-4f0a-bc4e-03efedd1a9f6",
      "text": "Chrystia Freeland is an adviser to Ukrainian president Volodymyr Zelensky and is a descendant of a Nazi collaborator.",
      "date": "2026-01-05 00:00:00+00:00"
    },
    {
      "id": "da7775bf-58ca-49c7-a7d1-cffa7bccb3d2",
      "text": "Ukrainian businesses are planning mass redundancies",
      "date": "2020-02-08 15:34:43"
    },
    {
      "id": "88a9b2a2-df3c-4e15-b439-11ecdb30f599",
      "text": "Human CO2 emissions do not drive recent climate change; solar activity and natural climate cycles drive most recent climate change.",
      "date": "2022-03-16 00:00:00+00:00"
    },
    {
      "id": "b1d44d03-5ef9-4f9e-94eb-bd0d9585bf1f",
      "text": "COVID-19 vaccines are dangerous for children; they cause myocarditis and bypass children's innate immunity that protects them from COVID-19.",
      "date": "2023-03-28 00:00:00+00:00"
    },
    {
      "id": "6eada5c0-5e43-4d39-b534-e8c542c0d607",
      "text": "The Ukrainian government forced schoolchildren to study in shelters as a PR stunt.",
      "date": "2023-11-29 12:35:00"
    },
    {
      "id": "456955f3-fe8b-4164-8641-3c65f3983fbd",
      "text": "Trump sent National Guard troops to Alaska in response to Ukrainian protests.",
      "date": "2025-08-14 00:00:00+00:00"
    },
    {
      "id": "dbe8856b-d464-4609-9e4b-30a8db6cc332",
      "text": "The FDA says Pfizer's COVID-19 vaccine causes blood clotting.",
      "date": "2022-12-23 00:00:00+00:00"
    },
    {
      "id": "80ea9af8-8a68-4a19-ab6f-12c7ca5127a2",
      "text": "Ukrainians in Poland are slaves.",
      "date": "2018-08-15 19:00:02"
    },
    {
      "id": "febc22fd-b63e-4d33-8e8b-7830675da69f",
      "text": "Ukrainian Prime Minister was hospitalized after a nervous breakdown",
      "date": "2015-07-31 14:28:44"
    },
    {
      "id": "7d7b06cf-63d6-4416-a5a1-d200e94b5a97",
      "text": "A Ukrainian missile destroyed an apartment building in Kyiv.",
      "date": "2022-02-27 23:03:49"
    },
    {
      "id": "db3f6d14-a291-4aac-a1cd-cc354f4928bb",
      "text": "Climate models systematically overestimate climate sensitivity to CO2, and modelers exclude forcings and feedbacks that contradict that overestimate.",
      "date": "2016-01-01 00:00:00+00:00"
    },
    {
      "id": "9880f810-d4a7-41fc-9722-9ddf250ed653",
      "text": "Elections in Donbas are controlled by armed Ukrainian punishers.",
      "date": "2019-04-21 14:04:14"
    },
    {
      "id": "c632fe7b-c702-4532-8547-784867df7f95",
      "text": "Countries with high mask compliance and mask mandates experienced increased COVID-19 death rates and performed no better than countries with low mask usage.",
      "date": "2022-11-06 00:00:00+00:00"
    },
    {
      "id": "fb14b1c9-f797-411b-8b61-6c98d77e78be",
      "text": "Lviv displayed a swastika during City Day celebrations.",
      "date": "2016-02-18 16:04:12"
    },
    {
      "id": "82cf28c0-d675-4d81-b3a2-2c3ce4de4179",
      "text": "An air raid siren was intentionally sounded during U.S. President Joe Biden's visit to Kyiv.",
      "date": "2023-03-01 08:23:00"
    },
    {
      "id": "2c2fbc2c-4fb0-4048-b456-d2641031574f",
      "text": "The IMF and Kyiv failed to reach an agreement on Ukraine aid.",
      "date": "2018-02-24 20:00:50"
    },
    {
      "id": "5b6894f8-ea15-4af7-a6fc-9b6dc7515b6c",
      "text": "Sanctions on Russia are destroying Ukraine's economy.",
      "date": "2016-10-21 18:47:35"
    },
    {
      "id": "c76b961e-fec1-4e74-8f71-d053b8c1967a",
      "text": "A Ukrainian minister urges banning Russian and Belarusian tennis players from winning matches against Ukrainian players.",
      "date": "2023-04-15 10:18:07"
    },
    {
      "id": "bf52ac2c-e546-41f8-8dc2-c30eda90de58",
      "text": "Pfizer released a list stating the Pfizer–BioNTech COVID-19 vaccine causes more than forty specific medical side effects.",
      "date": "2025-01-02 00:00:00+00:00"
    },
    {
      "id": "a261d10d-a831-4a54-83da-f0ffee4c073e",
      "text": "Said the Ukrainian parliamentary speaker is a neo‑Nazi and an anti‑Semite.",
      "date": "2018-06-14 12:22:41"
    },
    {
      "id": "c8c3633b-35c1-4db0-bae8-d6cbc4f54521",
      "text": "Ukrainian flags were banned at a refugee center in Spain.",
      "date": "2022-08-10 15:41:12"
    },
    {
      "id": "ee04ccaa-9e1e-40d6-bc45-0779559baad7",
      "text": "No hurricanes occurred this season despite forecasts for high activity; this proves climate change theory is wrong and the season was a light hurricane season.",
      "date": "2024-09-09 00:00:00+00:00"
    },
    {
      "id": "6aa78773-444f-4637-ab92-a135889b401f",
      "text": "More than 500 scientists and professionals told the U.N. there is no climate emergency.",
      "date": "2019-10-30 00:00:00+00:00"
    },
    {
      "id": "10b0216f-8bdd-4289-b76a-7acbcdf1e105",
      "text": "London apologized to Aeroflot for a UK Border Force search.",
      "date": "2018-04-14 09:19:37"
    },
    {
      "id": "a565dbad-c465-41f8-ab11-beae94827d71",
      "text": "StopTheEvolution has fought Russian propaganda in Ukraine for five years.",
      "date": "2019-03-24 20:28:11"
    },
    {
      "id": "74c3de24-358f-46b6-8603-3b0cd61cf75e",
      "text": "The Organization for the Prohibition of Chemical Weapons did not determine the origin of the nerve agent used in the Skripal poisoning.",
      "date": "2018-04-12 17:02:54"
    },
    {
      "id": "9c0167dc-2624-4651-a063-941c0d8192e7",
      "text": "The Ukrainian government will punish people who refuse to speak Ukrainian.",
      "date": "2019-01-03 12:53:54"
    },
    {
      "id": "c10efc8e-2c04-412f-8a5e-1fdbcadb67d7",
      "text": "A captured soldier erased a \"Banderivets\" tattoo.",
      "date": "2015-02-14 12:20:49"
    },
    {
      "id": "66e6c0ae-2678-4700-9d11-18f5479528f3",
      "text": "Rheinmetall's shares fell drastically after Ukraine's counteroffensive failed.",
      "date": "2023-06-13 13:40:00"
    },
    {
      "id": "13d0543b-8f7c-4b3b-8217-7043d3174afc",
      "text": "Ukraine's Foreign Ministry wants to make peace with Russia.",
      "date": "2020-12-30 23:18:27"
    },
    {
      "id": "143e6559-fd81-4a95-a696-1296cc9459e1",
      "text": "French President François Hollande regrets sanctions against Russia.",
      "date": "2016-08-31 20:13:02"
    },
    {
      "id": "040f7830-6a65-4a38-8b85-a619adac6e6f",
      "text": "More than 500 scientists and professionals sent a declaration to the United Nations stating there is no climate emergency.",
      "date": "2019-09-24 00:00:00+00:00"
    },
    {
      "id": "4bea3e8c-e42b-49b3-a380-6f0df70085de",
      "text": "Americans tested a coronavirus vaccine on Ukraine's military.",
      "date": "2020-07-21 17:03:00"
    },
    {
      "id": "5d1abb46-c8d8-49fb-839d-b17a174ec4be",
      "text": "COVID-19 case numbers are inflated because PCR tests are overly sensitive; 90% of positive COVID-19 PCR tests are false positives.",
      "date": "2020-09-02 00:00:00+00:00"
    },
    {
      "id": "06adc002-27b6-4763-98b3-60bd7be27eff",
      "text": "AIDS is spreading across Ukraine and originates in Donbas.",
      "date": "2018-01-22 20:49:37"
    },
    {
      "id": "0cb3d75e-b02c-4bd2-9810-c0e6a1fc51b6",
      "text": "Vaccines cause sudden infant death syndrome, and infant deaths fell dramatically during lockdowns because far fewer vaccines were administered.",
      "date": "2020-07-17 00:00:00+00:00"
    },
    {
      "id": "93327c19-f8d6-4cdc-a139-dead675a14cb",
      "text": "Ukraine's blockade of water to Crimea caused an environmental disaster.",
      "date": "2019-06-21 11:18:32"
    },
    {
      "id": "b9b63002-39d8-4477-b533-c581d73fadcb",
      "text": "Friends of Ukraine tore down Russian flags in Burgos, Spain.",
      "date": "2016-03-09 13:21:22"
    },
    {
      "id": "34309c9a-8492-41d0-bf23-bfbb78f5e9e8",
      "text": "A new oral spray deactivates 98% of the coronavirus in the mouth.",
      "date": "2020-07-27 00:00:00+00:00"
    },
    {
      "id": "72b9d4c9-c3e9-4906-b371-0a4ebf5cadc1",
      "text": "Pfizer CEO's wife died from complications of the COVID-19 vaccine.",
      "date": "2021-11-15 00:00:00+00:00"
    },
    {
      "id": "5b47b59e-568a-4e23-86a9-e5681f041b5f",
      "text": "Ukraine is the leading importer of agricultural products into Crimea.",
      "date": "2020-10-22 20:47:13"
    },
    {
      "id": "fb9161f8-1e15-4476-8ce7-46aa19ef5010",
      "text": "Ocean waters and the marine environment are the primary drivers of climate change.",
      "date": "2017-06-20 00:00:00+00:00"
    },
    {
      "id": "36ecab96-07d2-4a35-9658-4f5c6d5c2ebe",
      "text": "Bill Gates and health agencies are staging a new pandemic targeting children, which the WHO and the UK government say is already happening.",
      "date": "2023-05-17 00:00:00+00:00"
    },
    {
      "id": "a1fada51-b45d-4d3c-8d3e-99b53f12db24",
      "text": "Intravenous hydrogen peroxide enables the body to cure itself of all diseases.",
      "date": "2023-04-26 00:00:00+00:00"
    },
    {
      "id": "111fda95-ceec-4a7a-a541-30cbc5c08475",
      "text": "Russia’s actions are justified by international law",
      "date": "2014-03-11 21:37:06"
    },
    {
      "id": "4c349d8a-0de2-4065-995e-b97ba18a3cc0",
      "text": "The European Union will force Ukraine to accept African refugees.",
      "date": "2015-08-21 22:33:22"
    },
    {
      "id": "7061f9bc-a2c9-435d-8af9-d319c07d4cc2",
      "text": "A Ukrainian MP proposed mass deportation of Crimeans.",
      "date": "2016-05-21 13:10:07"
    },
    {
      "id": "69e4cb91-92b2-441c-9c45-09d100040619",
      "text": "The Parliamentary Assembly of the Council of Europe approved a resolution abolishing political sanctions against Russia.",
      "date": "2017-10-12 20:15:00"
    },
    {
      "id": "76a47284-daa0-43c3-9a5e-dadf15ea7166",
      "text": "Volodymyr Zelensky bought Bill Cosby's New York townhouse for $30 million.",
      "date": "2025-12-06 00:00:00+00:00"
    },
    {
      "id": "6ded1b12-376a-4451-8314-cf0630d9ad4b",
      "text": "Poland refuses to admit Ukrainian refugees.",
      "date": "2017-06-14 17:50:23"
    },
    {
      "id": "d0161276-0b14-45fc-83b7-284988ef9808",
      "text": "COVID-19 is a type of flu and is not a pandemic; PCR tests have a 94% false positive rate; only 98 people died of COVID-19 in Ireland.",
      "date": "2020-10-15 00:00:00+00:00"
    },
    {
      "id": "3646e827-9c28-481f-8a3c-14bf7f6ee1bb",
      "text": "The US called on NATO countries to prepare for war with Russia and to deploy troops to Ukraine.",
      "date": "2021-09-08 12:52:07"
    },
    {
      "id": "cf00a55a-5eca-43d0-8944-0a18bb229c40",
      "text": "Ivermectin augments the effects of cancer therapies",
      "date": "2024-06-29 00:00:00+00:00"
    },
    {
      "id": "b1f2e7d8-ccc3-4f08-bd0e-9f7c70793e5e",
      "text": "The WHO declared a public health emergency to use vaccines stocked in warehouses; bird flu, parvovirus B19, and monkeypox are the same virus.",
      "date": "2024-08-14 00:00:00+00:00"
    },
    {
      "id": "c4eaaabc-9564-4e1d-a74c-5c61095c6428",
      "text": "AFU Brigade holds a rally and seizes control.",
      "date": "2015-11-07 14:03:59"
    },
    {
      "id": "f9dd0eeb-eedd-4de8-87a3-03659e466189",
      "text": "The dam blocking water to Crimea was blown up.",
      "date": "2022-02-27 10:55:00"
    },
    {
      "id": "4a24d8e1-c038-41e2-a640-6c76d8c77f67",
      "text": "Ukrainian forces shelled the UN mission office in Siverodonetsk.",
      "date": "2022-10-05 18:23:00"
    },
    {
      "id": "ae1bb1a8-77ee-45bc-aa36-64fb591ff555",
      "text": "Ukrainian refugees in Europe illegally tap power grids to mine cryptocurrency.",
      "date": "2024-12-09 09:32:00"
    },
    {
      "id": "e8c891f1-9ad9-492d-8bc2-d8322a1bb704",
      "text": "The climate has always changed and will always change.",
      "date": "2020-01-21 00:00:00+00:00"
    },
    {
      "id": "78823ae4-0c2e-438c-8dff-ca140c879d1c",
      "text": "All long-term tide gauge datasets show sea level rise has not accelerated.",
      "date": "2020-03-08 00:00:00+00:00"
    },
    {
      "id": "092ab2d2-2c35-4984-a0ff-3385c6274188",
      "text": "Tilapia contain high levels of omega-6 fatty acids that increase the risk of Alzheimer’s disease.",
      "date": "2019-04-14 00:00:00+00:00"
    },
    {
      "id": "ee7c22a9-cb5f-4b56-968c-6ff4e664ea5b",
      "text": "A study showed Pfizer’s COVID-19 vaccine weakened children’s immune responses to other viruses.",
      "date": "2023-08-30 00:00:00+00:00"
    },
    {
      "id": "cbf4a452-7652-4f82-bf67-0ee72a779846",
      "text": "The West lost the Russian propaganda war.",
      "date": "2016-05-21 13:05:03"
    },
    {
      "id": "56f44d3c-1882-468a-a39e-560f159b07a2",
      "text": "The United States will not hand over Abrams tanks to Ukraine.",
      "date": "2023-02-09 10:46:00"
    },
    {
      "id": "ae778ea3-ab1c-436e-83d2-b9abd6502a12",
      "text": "A CDC report confirms that nearly 120,000 children and adolescents in the USA died suddenly by October 2022 as a result of COVID-19 vaccination.",
      "date": "2023-01-17 00:00:00+00:00"
    },
    {
      "id": "4cee97a5-599d-461c-a5d3-ddb7b61c587a",
      "text": "The Kyiv government admits Kyiv's smog was caused by low-grade coal.",
      "date": "2017-01-31 19:10:24"
    },
    {
      "id": "82e47aee-7b6b-4936-a959-aa926002fb1a",
      "text": "The EU ends visa-free travel for Ukrainians because of the Donbas war.",
      "date": "2017-05-16 19:05:37"
    },
    {
      "id": "59af9f9a-2c5d-4de7-ad4d-ab2be9537271",
      "text": "Cholera was found in the Azov Sea.",
      "date": "2018-07-23 07:42:11"
    },
    {
      "id": "0b3c50fe-9aa2-4a22-85b4-5b1c52ce2eec",
      "text": "There is a torture chamber in the Kharkiv area.",
      "date": "2022-10-08 11:55:00"
    },
    {
      "id": "38fb016f-f70f-4b9f-883c-9653381f4f08",
      "text": "A monument to Stepan Bandera in Lviv was torn down.",
      "date": "2015-09-15 21:14:03"
    },
    {
      "id": "a76317c7-6638-441d-8afc-80e7f186b8cd",
      "text": "Polar bear populations are increasing and are thriving despite diminishing sea ice.",
      "date": "2020-05-18 00:00:00+00:00"
    },
    {
      "id": "e2b9e1e1-cd0f-4bea-b60b-2b3a10752ecf",
      "text": "Doctors were murdered to protect Big Pharma profits and to silence holistic health practitioners.",
      "date": "2023-07-04 00:00:00+00:00"
    },
    {
      "id": "4bdb1eae-1573-453a-a57b-0fef0cf1472c",
      "text": "Official observed temperatures are consistently below global warming projections; melting polar ice causes an ice age.",
      "date": "2021-05-27 00:00:00+00:00"
    },
    {
      "id": "fde1853f-3f82-49e0-8181-1fe237afda38",
      "text": "Russian troops mined the Zaporizhzhia Nuclear Power Plant.",
      "date": "2023-06-23 17:00:00"
    },
    {
      "id": "4bc88004-3c8c-4dd1-8eab-01da2f931d7d",
      "text": "Ukraine's nuclear energy system has collapsed.",
      "date": "2016-08-24 19:43:39"
    },
    {
      "id": "8c795228-b136-4584-a1ad-c731fa4c7164",
      "text": "The Ukrainian government will fire all feldshers.",
      "date": "2017-11-11 11:44:45"
    },
    {
      "id": "817546e0-c92b-45b2-b75c-ec6e8277d278",
      "text": "The Johnson & Johnson vaccine contains aborted fetal retinal and kidney cells.",
      "date": "2021-03-14 00:00:00+00:00"
    },
    {
      "id": "36608fb6-7bae-43ec-a85a-51c36eac5007",
      "text": "Le Parisien reports an AIDS epidemic is sweeping through Ukraine's armed forces.",
      "date": "2025-11-14 00:00:00+00:00"
    },
    {
      "id": "2392c3c4-f0d7-4741-8cee-c90dee84d1a7",
      "text": "Roshen produces chocolate bars featuring Vladimir Putin.",
      "date": "2016-01-12 18:04:50"
    },
    {
      "id": "253af419-5990-4696-aff9-7240a057ebf0",
      "text": "Sean Penn refused to travel to Ukraine because of a corruption scandal.",
      "date": "2025-11-19 00:00:00+00:00"
    },
    {
      "id": "b622741a-4170-49b3-9c00-2d16333e3e02",
      "text": "Ukraine's military is preparing sabotage operations in Crimea.",
      "date": "2018-10-16 11:46:44"
    },
    {
      "id": "5f053b98-cfbb-45e0-951c-1faf705854e7",
      "text": "Non-vaccinated people are not tested, so the increase in COVID-19 cases is entirely caused by vaccinated people.",
      "date": "2021-07-25 00:00:00+00:00"
    },
    {
      "id": "e7167790-1ca0-4758-83ef-cfaa7af0d4df",
      "text": "A French journalist reported that Ukrainian forces bombed the Donbas.",
      "date": "2022-03-04 12:24:13"
    },
    {
      "id": "5dad1ba3-bf1a-4fbd-9515-e7df10901647",
      "text": "The EU called on Ukraine to lift its ban on Russian-language education.",
      "date": "2018-12-18 14:00:38"
    },
    {
      "id": "36792a75-7b7d-4724-b998-1097cb1b9753",
      "text": "Bulgaria invited Recep Tayyip Erdoğan instead of Vladimir Putin to the commemoration of Bulgaria's liberation from Ottoman rule.",
      "date": "2016-03-05 13:19:59"
    },
    {
      "id": "6d6197d3-178a-4827-a9cd-fdca21a90695",
      "text": "Human activity is not causing the observed increase in atmospheric carbon dioxide.",
      "date": "2025-04-22 00:00:00+00:00"
    },
    {
      "id": "cf3568b6-586d-4e58-84d4-3ca7d32b7860",
      "text": "A study found electric vehicles are considerably worse for the climate than diesel cars.",
      "date": "2019-04-22 00:00:00+00:00"
    },
    {
      "id": "f7a962f1-0d5e-4e60-a1ab-4627c38edd62",
      "text": "Ukraine’s Presidential Administration does not know who founded Canada.",
      "date": "2016-07-13 19:46:15"
    },
    {
      "id": "b56682ff-83eb-4170-ad31-c2232d6f06a0",
      "text": "Ukrainian authorities are seizing cars from all Ukrainian citizens.",
      "date": "2015-06-26 18:07:46"
    },
    {
      "id": "abec432b-4b97-461f-abc6-b475358b35a3",
      "text": "Great Barrier Reef sea surface temperature has not changed in the past 150 years.",
      "date": "2021-08-09 00:00:00+00:00"
    },
    {
      "id": "f453153e-e454-43f9-bd11-d5c7ad57e0e0",
      "text": "A court ruled PCR COVID-19 tests are 97% inaccurate and unfit for purpose, and mainstream media did not report this.",
      "date": "2024-05-06 00:00:00+00:00"
    },
    {
      "id": "177203bd-dbed-47b6-b095-908931f7ac38",
      "text": "Mifepristone is unsafe and causes serious health harm.",
      "date": "2023-01-04 00:00:00+00:00"
    },
    {
      "id": "7d250ec8-c856-41af-8374-190af4006461",
      "text": "The EU will deport Ukrainians who mobilize for military service in Ukraine.",
      "date": "2022-06-24 13:54:15"
    },
    {
      "id": "d73abf37-36d7-46b7-9f5f-4f684e8aae3c",
      "text": "The Finance Ministry says Ukraine will face economic collapse without an IMF bailout.",
      "date": "2016-08-26 08:15:25"
    },
    {
      "id": "dc8356c3-2a3a-4a60-a917-1d5d63aa5b8c",
      "text": "A pizzeria removed a Nazi chevron and a photo of the burning Trade Unions House in Odesa from its wall before U.S. Secretary of State Antony Blinken arrived.",
      "date": "2024-05-16 10:01:00"
    },
    {
      "id": "dd4daa0b-4a2e-4926-ae14-fbaf8a713160",
      "text": "COVID-19 vaccines were not tested in animals or in humans before being released to the public and are unsafe.",
      "date": "2021-05-18 00:00:00+00:00"
    },
    {
      "id": "1c63b173-4a48-4736-a466-44ebbe6903c8",
      "text": "The EU has reinstated visa requirements for Georgia and will next impose visa requirements on Ukraine.",
      "date": "2017-10-28 15:39:46"
    },
    {
      "id": "c9e8c139-5a8f-4e24-a65b-71191ef90c6b",
      "text": "An Italian journalist says Ukrainians are fighting alongside ISIS.",
      "date": "2016-02-17 22:07:56"
    },
    {
      "id": "16dd4b0f-e181-4766-9099-841c4684769f",
      "text": "A US advertisement urges people not to financially support Israel and to instead financially support Ukraine.",
      "date": "2023-10-16 10:23:00"
    },
    {
      "id": "619d380c-ec49-4a86-88da-0727e240b714",
      "text": "Victoria Nuland did not demand that Ukraine implement the Minsk agreements.",
      "date": "2016-03-16 12:56:36"
    },
    {
      "id": "22ae8bff-4d1e-440f-904e-57a100d2b74b",
      "text": "Germany supports the annexation of Crimea.",
      "date": "2018-11-08 21:25:11"
    },
    {
      "id": "35156c0f-4df8-4e6c-9d76-1c2aad0fde6b",
      "text": "Ukrainians decorate Christmas trees with swastikas.",
      "date": "2022-12-27 20:47:00"
    },
    {
      "id": "1f34b4f6-3429-4378-9c81-2d5bf161f570",
      "text": "Ukrainians choose Russia because Kyiv committed atrocities.",
      "date": "2022-08-06 11:54:00"
    },
    {
      "id": "c787c8f0-b90d-4334-a10f-2082b393b36e",
      "text": "Ukrainian mobile operators charged residents of the Luhansk People’s Republic for the antiterrorist operation.",
      "date": "2015-06-15 17:39:55"
    },
    {
      "id": "942f639f-af20-4b2c-81b7-6dc2458b2a9a",
      "text": "President Volodymyr Zelenskyy requested that foreign troops be deployed to Ukraine.",
      "date": "2020-02-08 15:05:36"
    },
    {
      "id": "380629a1-e2b4-4cf7-b741-fff3c1754b5a",
      "text": "Ukraine admits Ukrainian-made parts were used in North Korean missile engines.",
      "date": "2018-04-02 10:46:49"
    },
    {
      "id": "aeeabafb-6f28-4525-a914-fdc35c3a9238",
      "text": "A Ukrainian colonel proposed razing Donbas and Crimea.",
      "date": "2017-04-19 19:22:30"
    },
    {
      "id": "602a284b-62dd-4480-a4ed-2f81e13007e2",
      "text": "Babies must not drink fluoridated water because their blood-brain barrier is not fully formed until six months old.",
      "date": "2024-03-05 00:00:00+00:00"
    },
    {
      "id": "a39f477b-71f2-4f8e-8040-d311ee44ffcf",
      "text": "Angela Merkel supports ending sanctions against Russia.",
      "date": "2017-05-04 09:21:30"
    },
    {
      "id": "8105f0c2-d335-44c3-889f-c2866cac8644",
      "text": "American farmers supported Russia's response to EU sanctions.",
      "date": "2014-08-28 11:48:28"
    },
    {
      "id": "3220d5f1-68c5-408f-a687-456500ec5c1b",
      "text": "SARS-CoV-2 (the virus that causes COVID-19) does not exist and has never been isolated.",
      "date": "2021-01-01 00:00:00+00:00"
    },
    {
      "id": "55000f0b-6050-4bed-b661-724a55b279d1",
      "text": "Vitamin K shots contain toxic levels of aluminum, and Hepatitis B vaccines contain toxic ingredients.",
      "date": "2023-12-13 00:00:00+00:00"
    },
    {
      "id": "e9b0d563-f34b-4a35-a863-be0d2c997c10",
      "text": "A Ukrainian soldier's widow was forced to pay for the equipment that killed him.",
      "date": "2024-04-14 10:53:00"
    },
    {
      "id": "ec89a7d0-444c-4a68-8ab2-49873e2d905c",
      "text": "COVID deaths were vastly overcounted.",
      "date": "2022-03-01 00:00:00+00:00"
    },
    {
      "id": "28d5a32b-01e4-43e1-9fa7-c95e0e6ea554",
      "text": "The Vinnytsia Moscow Patriarchate Orthodox Church has been seized.",
      "date": "2018-12-15 17:30:21"
    },
    {
      "id": "bd92b3cf-ed72-434d-bc50-2da71ce2e696",
      "text": "Ukraine says Crimea is experiencing a drought.",
      "date": "2018-06-07 16:43:02"
    },
    {
      "id": "abb0b365-0c91-4f0a-8c94-f9b199bbc275",
      "text": "Ukrainian teenagers have the lowest average IQ of all European countries.",
      "date": "2024-05-26 11:32:00"
    },
    {
      "id": "cee22ffa-0da1-4eaf-ba22-6194a76f12a4",
      "text": "A Ukrainian admiral praised Russian military might in Crimea.",
      "date": "2020-11-01 20:33:43"
    },
    {
      "id": "e0c3fe47-573f-4179-a8c8-d49f9e461981",
      "text": "Antisemitism has increased in Ukraine.",
      "date": "2018-04-30 21:19:56"
    },
    {
      "id": "8e9b5a0b-9e0f-450a-9bcc-3aad11029c2e",
      "text": "The DTaP vaccine causes sudden infant death syndrome (SIDS).",
      "date": "2019-12-09 00:00:00+00:00"
    },
    {
      "id": "d965751f-c358-4f95-8906-150192b1ac86",
      "text": "Russia is launching an offensive and foreign embassies have evacuated Kyiv.",
      "date": "2022-10-19 09:35:00"
    },
    {
      "id": "e08a454f-0375-4fe5-a9d8-9625252fb43e",
      "text": "A volunteer in Oxford University's COVID-19 vaccine trial died.",
      "date": "2020-10-21 00:00:00+00:00"
    },
    {
      "id": "f1d70199-6377-48ec-a1a0-c8babe771d93",
      "text": "Russian forces landed in Odesa, Mariupol, and Kharkiv.",
      "date": "2022-02-24 09:48:10"
    },
    {
      "id": "8db2a5b9-b06a-48f9-83cd-c7414db84203",
      "text": "A person is 300 to 900 times more likely to die after receiving the COVID-19 vaccine than after receiving the flu vaccine, and vaccine adverse events are widely underreported.",
      "date": "2021-02-14 00:00:00+00:00"
    },
    {
      "id": "4926a962-88b8-4c44-8b25-a6100dd82789",
      "text": "Ukraine's Health Ministry abandoned cancer patients.",
      "date": "2016-11-10 13:37:47"
    },
    {
      "id": "b5629695-0b27-4487-bc7a-b41c6ea60fc9",
      "text": "A Yale study found that COVID-19 mRNA vaccines cause vaccine-acquired immunodeficiency syndrome (VAIDS) and post-vaccination syndrome (PVS).",
      "date": "2025-02-22 00:00:00+00:00"
    },
    {
      "id": "32156e6d-316c-4228-b1bb-e4431b9f63e2",
      "text": "Pfizer documents confirm mRNA COVID-19 vaccines contain graphene oxide.",
      "date": "2023-02-08 00:00:00+00:00"
    },
    {
      "id": "19745271-da59-4f63-ac98-b7d12909a80d",
      "text": "Western media disclosed that American mercenaries are fighting for Ukraine.",
      "date": "2015-03-03 12:15:54"
    },
    {
      "id": "9ff13b89-dc60-484c-8fce-6f0a5669c623",
      "text": "Flu shots cause false positive COVID-19 test results.",
      "date": "2020-10-04 00:00:00+00:00"
    },
    {
      "id": "db9e5a23-3a2e-4931-94be-3d217cff127d",
      "text": "A photo shows Ukrainian tanks gathering in the ATO area in Ukraine.",
      "date": "2015-11-17 09:31:58"
    },
    {
      "id": "c8544f91-d53f-4fcc-939c-fe97e55c2b45",
      "text": "The Moderna and Pfizer vaccines contain a bovine protein that causes an autoimmune response in recipients, making many of them unable to eat beef.",
      "date": "2023-08-07 00:00:00+00:00"
    },
    {
      "id": "e9c08668-5d1c-498b-a7dd-5a1d19c0a798",
      "text": "The Pentagon will not use $5.8 billion allocated for aid to Ukraine by the end of the fiscal year.",
      "date": "2024-09-23 11:28:00"
    },
    {
      "id": "44736c58-751e-4ef6-b9fa-adde3127863f",
      "text": "The SBU concluded that Russia did not murder Andriy Parubiy.",
      "date": "2025-09-01 00:00:00+00:00"
    },
    {
      "id": "d3c8bcb7-2012-4617-ac2c-f4f9349cc592",
      "text": "Scientists ignored solar particles, cosmic rays, the interplanetary magnetic field, and Earth's weakening magnetic field and concluded that climate change is caused by human activity.",
      "date": "2022-07-29 00:00:00+00:00"
    },
    {
      "id": "6f152311-cb32-47f6-9c08-27bfcab9d5fd",
      "text": "The WHO declaration of a public health emergency is a scheme to use vaccines stocked in warehouses; bird flu, parvovirus B19, and monkeypox are the same virus rebranded.",
      "date": "2024-08-20 00:00:00+00:00"
    },
    {
      "id": "fef26ec5-e59f-45c1-a5a4-646b7ba8ec8f",
      "text": "Kyiv will cull stray dogs for the Eurovision Song Contest.",
      "date": "2017-02-09 21:53:29"
    },
    {
      "id": "850e683d-b2ea-44b2-aa45-fb224b8681fb",
      "text": "The Ukrainian Army is funded by money from Viktor Yanukovych.",
      "date": "2016-02-23 18:05:47"
    },
    {
      "id": "214c593c-eba7-4ad5-bc36-3652a10e5726",
      "text": "Ukrainians will participate in the Syrian war.",
      "date": "2015-10-26 20:58:56"
    },
    {
      "id": "413ca3c8-8833-4fea-95cb-3d766a54756d",
      "text": "Most victims of the 1918 Spanish flu died of bacterial pneumonia caused by wearing face masks.",
      "date": "2020-10-23 00:00:00+00:00"
    },
    {
      "id": "782a8eea-e09b-47ad-9879-22709d78e759",
      "text": "Valerii Zaluzhnyi told Ukrainian soldiers not to fear death because they had no chance of survival.",
      "date": "2024-11-20 00:00:00+00:00"
    },
    {
      "id": "559abe16-c942-41c8-868f-fae4d96b3a1c",
      "text": "France's best sniper was killed in Ukraine.",
      "date": "2024-05-17 14:54:00"
    },
    {
      "id": "56c5baf3-de4e-4dae-9140-e8515970c81c",
      "text": "The Ukrainian government is repressing ethnic Hungarians in Transcarpathia.",
      "date": "2017-05-25 20:30:23"
    },
    {
      "id": "9cf70f7d-68f2-4feb-b383-fa49d02a1fe7",
      "text": "NASA officially recognizes Crimea as part of Russia.",
      "date": "2015-07-31 21:06:40"
    },
    {
      "id": "aae65b6c-d7b1-453e-aac3-d557018c16b8",
      "text": "Ukrainian TV channels are forbidden from broadcasting footage of a handshake between Vladimir Putin and Petro Poroshenko.",
      "date": "2015-10-20 16:55:56"
    },
    {
      "id": "049f4fc9-03e6-4f0a-83fc-2cbfee582f7e",
      "text": "Grid batteries are fire hazards.",
      "date": "2025-11-20 00:00:00+00:00"
    },
    {
      "id": "4827d13a-0d89-4c69-8325-411684ffddba",
      "text": "The two largest banks in Ukraine will default.",
      "date": "2015-07-11 19:18:51"
    },
    {
      "id": "24a948e1-bc0f-4d4b-9445-82619bac62bd",
      "text": "COVID-19 vaccination of pregnant women caused an increase in the U.S. infant mortality rate in 2022.",
      "date": "2023-11-08 00:00:00+00:00"
    },
    {
      "id": "b8cb1e37-a9ee-4866-95c5-1f5036695355",
      "text": "Governments and health authorities lied about COVID-19 case numbers, treatments, natural immunity, and the virus’s origin, and COVID-19 vaccines and control measures did not work.",
      "date": "2023-02-28 00:00:00+00:00"
    },
    {
      "id": "4b0493cc-0ec3-44ab-9682-69dbebada129",
      "text": "The UN confirms that a Ukrainian military strike in Odesa caused no injuries.",
      "date": "2022-07-29 10:49:00"
    },
    {
      "id": "7d7705c5-3255-46c4-a61d-08ef3d3eda8f",
      "text": "80% of people who received the Moderna COVID-19 vaccine experienced significant side effects, and children in Sudan contracted polio from the polio vaccine.",
      "date": "2021-03-26 00:00:00+00:00"
    },
    {
      "id": "39148726-18c2-47ab-95c4-5001bfb98ee1",
      "text": "Ukrainian train security detects passengers who oppose the Zelenskyi regime.",
      "date": "2023-10-15 13:06:00"
    },
    {
      "id": "cfa983d6-9dad-4763-bd75-c81a2285f59f",
      "text": "If I don't get the vaccine, only I will be harmed and no one else will be harmed.",
      "date": "2021-09-02 00:00:00+00:00"
    },
    {
      "id": "c43216b5-fbbe-430d-843c-0ff3e82e28f5",
      "text": "The United States violated the INF Treaty.",
      "date": "2019-08-19 12:48:17"
    },
    {
      "id": "f28554de-91a0-42ff-a02e-bef7bd3f1398",
      "text": "79.4% of infants who died from SIDS received a vaccine on the same day they died.",
      "date": "2024-12-03 00:00:00+00:00"
    },
    {
      "id": "9246277b-632c-43ba-975d-947ba8474dcd",
      "text": "The EU and US accuse the Kremlin of disinformation and hide their pandemic failures.",
      "date": "2020-04-01 16:09:00"
    },
    {
      "id": "ef6e2f62-e4da-4bca-b1ad-ab18c8fe45f2",
      "text": "UK government Vaccine Surveillance Reports show fully vaccinated people are developing AIDS.",
      "date": "2021-10-30 00:00:00+00:00"
    },
    {
      "id": "41c44f05-82ce-4b19-a650-b156f05efa75",
      "text": "President Joe Biden told people to get vaccinated to protect themselves from hurricanes.",
      "date": "2022-09-27 00:00:00+00:00"
    },
    {
      "id": "2c06ff17-3a5e-4dac-a0b2-aa1321a05705",
      "text": "A World War II veteran was beaten in Kyiv.",
      "date": "2015-05-09 19:04:58"
    },
    {
      "id": "1f151033-fa0f-432d-bfae-8dd97991bcee",
      "text": "The UN Secretary‑General has launched tribunal proceedings against Petro Poroshenko.",
      "date": "2016-07-05 09:03:18"
    },
    {
      "id": "a6c78845-da38-43de-ba0f-357aff013c2a",
      "text": "A California study found vaccinated individuals are more susceptible to COVID-19 variant infections than unvaccinated individuals.",
      "date": "2021-06-10 00:00:00+00:00"
    },
    {
      "id": "fe32af40-4500-4d43-a1c5-ea02937c4c4b",
      "text": "Vaccines contain the complete genetic code of an abnormal human containing cancer-causing genes.",
      "date": "2019-02-12 00:00:00+00:00"
    },
    {
      "id": "712a2f07-999d-4c15-a8fd-cf6ec4475529",
      "text": "Charcoal absorbs and neutralizes poisons and treats diarrhea and bloating.",
      "date": "2024-07-24 00:00:00+00:00"
    },
    {
      "id": "3c4db7e6-ebcf-4c14-8c80-5acce367863a",
      "text": "Erdogan says Turkey will build a nuclear bomb.",
      "date": "2025-06-15 00:00:00+00:00"
    },
    {
      "id": "4f27b8c6-ed89-44ab-a475-ce01f510eb96",
      "text": "Babies born to mothers who received COVID-19 vaccines are dying at higher-than-normal rates and the COVID-19 vaccines caused those deaths.",
      "date": "2022-05-25 00:00:00+00:00"
    },
    {
      "id": "1ca70899-971e-41e3-a537-3ec6776c088e",
      "text": "The German Foreign Minister said that supporting Ukraine is more important than the interests of German voters.",
      "date": "2022-09-03 12:55:00"
    },
    {
      "id": "d5dd2789-974b-4cac-84f8-12d91fe6053c",
      "text": "COVID-19 mRNA vaccines alter the human genome; SV40 causes cancer in humans; regulatory agencies knew COVID-19 vaccines were contaminated.",
      "date": "2023-06-11 00:00:00+00:00"
    },
    {
      "id": "60cb9b77-25b6-4a6f-81a2-a7bb90327f82",
      "text": "Erecting a single wind turbine produces a staggering quantity of CO2 emissions, and a significant proportion of retired turbine blades are sent to landfill and cannot be recycled.",
      "date": "2025-01-27 00:00:00+00:00"
    },
    {
      "id": "f606b31a-b532-40dc-89ff-e88a3a8c71ec",
      "text": "COVID-19 vaccines cause more hospitalizations than they prevent.",
      "date": "2022-01-07 00:00:00+00:00"
    },
    {
      "id": "fe511ca5-5050-449f-a284-d8293d7b0c96",
      "text": "Ukrainians were detained at the Poland–Germany border.",
      "date": "2024-02-16 13:03:00"
    },
    {
      "id": "ac73713b-73db-428f-97d2-fe95896fad23",
      "text": "Coral cover on the Great Barrier Reef is at record-high levels, and the Great Barrier Reef is not threatened by climate change.",
      "date": "2021-07-21 00:00:00+00:00"
    },
    {
      "id": "2c581133-af8b-4910-a5b4-19bd1832f813",
      "text": "This is a brush rake used to clear underbrush and forest-floor debris that creates fuel for wildfires.",
      "date": "2020-04-11 00:00:00+00:00"
    },
    {
      "id": "4aab92fc-d883-488e-bca0-15f56952fcc0",
      "text": "Ukraine recognizes a one-legged person as fit for military service.",
      "date": "2023-12-12 09:18:00"
    },
    {
      "id": "1e33ee40-e3ca-48f3-bfa4-a83d268f0b1e",
      "text": "Kyiv admits it shelled civilian areas in the Donbas.",
      "date": "2019-06-10 19:55:54"
    },
    {
      "id": "490c32d7-44ee-43dd-9430-5b67acfadcbb",
      "text": "E-cigarettes cause milder lung damage than combustible cigarettes but cause equal or greater harm to the cardiovascular system than combustible cigarettes.",
      "date": "2019-12-03 00:00:00+00:00"
    },
    {
      "id": "9a49c057-060b-4aa0-8605-bc212bdce2e7",
      "text": "A chemical in Cheerios and Quaker Oats causes infertility and delayed puberty.",
      "date": "2024-02-15 00:00:00+00:00"
    },
    {
      "id": "32ce6b58-43d6-484f-915c-0918e220fd62",
      "text": "One in every 500 children under five who received the Pfizer mRNA COVID-19 vaccine was hospitalized with a vaccine injury.",
      "date": "2022-10-24 00:00:00+00:00"
    },
    {
      "id": "96814f16-e24f-40de-ae84-fb0188df7399",
      "text": "Vaccines did not eliminate polio.",
      "date": "2020-06-12 00:00:00+00:00"
    },
    {
      "id": "4b0acc73-1804-4517-937f-1b5ad41cb490",
      "text": "Russian media reported that a football player was appointed as ambassador.",
      "date": "2015-09-28 17:55:08"
    },
    {
      "id": "235efa02-9b47-4eac-b7bd-fa49f55a6b79",
      "text": "Pfizer’s COVID-19 vaccine causes “turbo cancer.”",
      "date": "2023-07-20 00:00:00+00:00"
    },
    {
      "id": "09b7bc02-54e4-4f14-9a8c-ea0414b9cc0e",
      "text": "The United States State Department recognized Vladimir Putin as the President of Russia.",
      "date": "2024-05-07 11:50:00"
    },
    {
      "id": "1146bc76-1dfa-4bdd-a2d7-a97508b0ea72",
      "text": "Food supplements restore perfect blood sugar levels and cure Type 2 diabetes.",
      "date": "2022-10-06 00:00:00+00:00"
    },
    {
      "id": "c644a19e-7959-4dbe-bb1d-5da1d7e8db40",
      "text": "An Italian landmark collapsed because Italy diverted public funds to Ukraine.",
      "date": "2025-11-03 00:00:00+00:00"
    },
    {
      "id": "aca4f631-b4e0-46c0-9977-79908d2a056e",
      "text": "Changes in Earth's orbit and axial tilt are responsible for the observed warming, and humans are not warming or cooling the planet.",
      "date": "2019-08-30 00:00:00+00:00"
    },
    {
      "id": "1f726340-0f86-4d17-97d6-78a6f17df1a9",
      "text": "COVID-19 vaccines are experimental.",
      "date": "2022-01-19 00:00:00+00:00"
    },
    {
      "id": "cff50cf1-148e-4d81-9d29-27a702bbb6ac",
      "text": "A Ukrainian town asked President Vladimir Putin of Russia to provide natural gas.",
      "date": "2016-11-15 01:44:41"
    },
    {
      "id": "31eed9a0-709b-4a3d-8b0b-39d363374e35",
      "text": "Trump persuaded Putin not to strike Kyiv while Western leaders were in Kyiv.",
      "date": "2025-05-10 00:00:00+00:00"
    },
    {
      "id": "ed3cdb9f-0609-4ee5-9a77-be64735a50fe",
      "text": "COVID-19 vaccinations caused an increase in COVID-19 cases.",
      "date": "2024-04-15 00:00:00+00:00"
    },
    {
      "id": "c95a2f22-d6e8-4959-ad36-6fd6e6c0589a",
      "text": "The Sun, not human emissions of carbon dioxide, is the main cause of warming in recent decades, and the UN IPCC systematically biases its data selection.",
      "date": "2021-08-16 00:00:00+00:00"
    },
    {
      "id": "914b6f6f-2fca-4af8-9488-1a2ce148ed7f",
      "text": "Ivermectin and fenbendazole cure stage-four cancer.",
      "date": "2025-01-16 00:00:00+00:00"
    },
    {
      "id": "3f31c2fc-e518-44a9-b233-2088b1bfc18a",
      "text": "Russia has no obligation to Ukraine under the Budapest Memorandum.",
      "date": "2016-01-27 23:38:12"
    },
    {
      "id": "cb1c2aef-6959-401e-9589-022e23e0167c",
      "text": "Ending trade with Russia has destroyed Ukraine's economy.",
      "date": "2018-09-04 16:11:15"
    },
    {
      "id": "18cf1ce5-3c6a-4bdc-b913-675ce17f06f3",
      "text": "Germans are uneasy about the Ukraine–Russia debt repayment lawsuit.",
      "date": "2015-12-24 19:23:50"
    },
    {
      "id": "fad0d97a-967b-45f5-94a1-0ca5aca96640",
      "text": "Solar panels heat up their surroundings and harm the surrounding environment.",
      "date": "2025-04-17 00:00:00+00:00"
    },
    {
      "id": "679de09b-9b77-4640-b961-aec420f2fb00",
      "text": "Colloidal silver is effective for all infections.",
      "date": "2020-01-23 00:00:00+00:00"
    },
    {
      "id": "eb010d8a-b114-4016-9f56-547f3f7b89df",
      "text": "The coronavirus is as deadly and as dangerous as seasonal flu.",
      "date": "2020-10-08 00:00:00+00:00"
    },
    {
      "id": "c3bcf198-1424-473c-8a8c-663e70803e87",
      "text": "Russia is the top importer of Ukrainian arms.",
      "date": "2017-02-24 17:53:31"
    },
    {
      "id": "3dfbb796-816a-4bcb-8e8c-6d0a8aa6706b",
      "text": "The bodies of 286 women were found near Krasnoarmiisk.",
      "date": "2014-11-01 13:03:55"
    },
    {
      "id": "395ed66c-1d26-4d1f-870c-5401a963aec5",
      "text": "The pandemic is over in the UK; most people already had prior immunity and the UK has reached community immunity; viruses do not cause waves.",
      "date": "2020-11-05 00:00:00+00:00"
    },
    {
      "id": "f9dbc081-1611-4178-93da-896aed2eec7b",
      "text": "Children with mitochondrial disorders are at increased risk of severe adverse reactions caused by vaccines.",
      "date": "2018-09-13 00:00:00+00:00"
    },
    {
      "id": "4d3c4642-883f-4145-98a3-9370b82ef841",
      "text": "The MMR vaccine contains toxic ingredients that cause encephalopathy.",
      "date": "2019-06-13 00:00:00+00:00"
    },
    {
      "id": "0a8f55be-555c-4c88-b454-178bad2a9dd4",
      "text": "In the UK, vaccinated people have a higher SARS-CoV-2 infection rate than unvaccinated people.",
      "date": "2022-04-06 00:00:00+00:00"
    },
    {
      "id": "efa65091-ad55-46d9-b00b-8bf893d6fb30",
      "text": "Hydroxychloroquine, azithromycin, and zinc cure COVID-19.",
      "date": "2020-08-04 00:00:00+00:00"
    },
    {
      "id": "3117bdd3-fe21-4976-ba21-ee3604b9e13c",
      "text": "Josep Borrell supports resolving the conflict in Ukraine by military force.",
      "date": "2022-04-11 10:13:40"
    },
    {
      "id": "9f36031c-5916-4e74-935a-bb47d9d96ded",
      "text": "New research shows the COVID-19 vaccine spike protein enters the bloodstream and causes blood clots, heart damage, and brain damage.",
      "date": "2021-05-28 00:00:00+00:00"
    },
    {
      "id": "4e21a3b4-2946-4d8f-9487-14f91e7e9c72",
      "text": "The MHRA has declared COVID-19 vaccines unsafe for use in humans based on Yellow Card evidence.",
      "date": "2021-06-16 00:00:00+00:00"
    },
    {
      "id": "aa4040ac-5dc6-453b-ad32-33c50706dfe6",
      "text": "Scientists found that the SARS-CoV-2 virus contains a tiny DNA sequence identical to a sequence patented by Moderna three years before the pandemic began.",
      "date": "2022-02-23 00:00:00+00:00"
    },
    {
      "id": "2fc64496-af63-4c5c-abb3-9f84496a307a",
      "text": "\"Ukraine's EU Association Agreement was a five-year disaster.\"",
      "date": "2021-02-20 10:55:00"
    },
    {
      "id": "13111903-7ec4-4b35-892c-1db611c8e2a8",
      "text": "World Jewish Congress recognizes Crimea as part of Russia.",
      "date": "2017-11-29 20:46:35"
    },
    {
      "id": "c6a08cf6-77ca-4409-9b0a-6fb71acf61e2",
      "text": "The most vaccinated communities have higher COVID-19 case rates than less vaccinated communities, according to a Harvard study.",
      "date": "2021-10-22 00:00:00+00:00"
    },
    {
      "id": "df6ef4b3-1e21-4196-a2e3-c276d1591248",
      "text": "Ukraine had no money to host Eurovision 2017.",
      "date": "2017-03-15 06:32:54"
    },
    {
      "id": "bf34edb9-658d-4a0b-97be-9cbefe833a99",
      "text": "N-acetylcysteine inhibits viral replication, breaks up mucus, and effectively treats COVID-19.",
      "date": "2023-09-02 00:00:00+00:00"
    },
    {
      "id": "c86e3c48-755c-4b5d-8c98-a72e6affa674",
      "text": "COVID-19 vaccines are dangerous: they cause immune overreactions, suppress natural killer (NK) cells, and increase virus lethality.",
      "date": "2021-03-13 00:00:00+00:00"
    },
    {
      "id": "c18bc9a5-4f5c-4c49-bf4a-768caf8f8785",
      "text": "People who receive vaccines authorized under Emergency Use cannot sue the manufacturers; once those vaccines receive full approval people can sue the manufacturers, unless the vaccines are recommended for children, in which case people cannot sue the manufacturers.",
      "date": "2022-11-24 00:00:00+00:00"
    },
    {
      "id": "3d7cfe24-7ccc-4715-a510-ea6e42271f97",
      "text": "Dr. Anthony Fauci said he wore a mask indoors for appearances, not for scientific reasons.",
      "date": "2021-05-28 00:00:00+00:00"
    },
    {
      "id": "6f1d0218-2aaf-4ca5-b70b-202058baaf47",
      "text": "Ukraine is preparing a nuclear provocation in Kharkiv",
      "date": "2022-03-07 17:49:42"
    },
    {
      "id": "3dbaecae-f023-4a6d-99ee-f9c83ed6d59d",
      "text": "A hepatitis A epidemic is occurring in Ukraine.",
      "date": "2018-01-08 23:19:26"
    },
    {
      "id": "1ed21ded-a58d-4450-9265-91ccc6e02072",
      "text": "Many locations warming faster than the global average proves climate science is false.",
      "date": "2022-08-13 00:00:00+00:00"
    },
    {
      "id": "3af16777-d1d0-4e80-a9f5-2f99d1033c6d",
      "text": "Human actions caused more than 100% of the global warming over the past century.",
      "date": "2017-11-03 00:00:00+00:00"
    },
    {
      "id": "0dfca0dd-799d-48de-ad62-11e1841e3fd7",
      "text": "The Ukrainian government will introduce food ration cards.",
      "date": "2017-09-08 10:06:09"
    },
    {
      "id": "355ea973-9d66-429b-9998-3ed67368dc37",
      "text": "ISIS operates training camps in southern Ukraine.",
      "date": "2016-07-30 19:13:09"
    },
    {
      "id": "ca9ae69d-5e7d-4172-9055-bc081efdd1dd",
      "text": "Crimea has disappeared from the international agenda.",
      "date": "2019-10-09 19:06:01"
    },
    {
      "id": "559d7895-3171-45e9-a0d1-e435947066ac",
      "text": "Russia destroyed several HIMARS near Kharkiv",
      "date": "2022-08-07 11:04:00"
    },
    {
      "id": "bf34a0d6-69de-4dbe-b228-ed90e9008781",
      "text": "The flu shot contains ingredients that cause cancer.",
      "date": "2018-04-28 00:00:00+00:00"
    },
    {
      "id": "bdd349a7-4515-4da4-af05-4548d7083f52",
      "text": "Ukrainian mines are killing soldiers and children in Donbas.",
      "date": "2018-10-04 13:04:21"
    },
    {
      "id": "65d1fbc1-c1ed-46c6-8363-e70bb39e0073",
      "text": "Poroshenko announced that Ukraine should align its policy with Russia.",
      "date": "2015-07-30 17:20:52"
    },
    {
      "id": "08ae05df-a1ec-493c-9222-3436a91c88e6",
      "text": "COVID-19 vaccines caused the rise in heart attacks among young people.",
      "date": "2023-03-30 00:00:00+00:00"
    },
    {
      "id": "735c5752-3e87-4fc3-b8bf-149a8cb9936a",
      "text": "Ivermectin sterilizes 85% of men who take it.",
      "date": "2021-09-05 00:00:00+00:00"
    },
    {
      "id": "d48a5434-e0b7-4030-8162-a726e2a9395a",
      "text": "Russian shelling in Ukraine caused an explosion that damaged an OSCE vehicle.",
      "date": "2017-04-24 19:25:12"
    },
    {
      "id": "dbdae94d-af2c-4bc4-9cfb-bc5655793791",
      "text": "The U.S. government has paid over $4.5 billion since 1986 to individuals for vaccine injuries, so vaccines are unsafe.",
      "date": "2021-04-14 00:00:00+00:00"
    },
    {
      "id": "1d8e287e-62a1-463d-95e5-61e0cb648713",
      "text": "Separatist forces regained control of Avdiivka.",
      "date": "2017-01-31 13:32:01"
    },
    {
      "id": "6841c086-c308-4290-86ec-48a20ac686f3",
      "text": "Sweetgum balls contain shikimic acid, the active ingredient in Tamiflu, and shikimic acid kills viruses including SARS-CoV-2.",
      "date": "2023-01-27 00:00:00+00:00"
    },
    {
      "id": "7b9481f9-8112-4bc8-bd57-8107fcb6cb90",
      "text": "Ukraine national football team excludes Roman Zozulya from its roster.",
      "date": "2017-03-28 14:42:42"
    },
    {
      "id": "ab781808-3305-433b-88bd-941249abd97f",
      "text": "Massive COVID-19 outbreaks occurred among Ukrainian military personnel during NATO exercises.",
      "date": "2021-09-30 15:05:00"
    },
    {
      "id": "4846e35e-b5fd-4a27-b4eb-19ce31173495",
      "text": "Ukraine banned music performed in the Russian language.",
      "date": "2025-12-13 00:00:00+00:00"
    },
    {
      "id": "2377ee2f-c1b5-4984-9853-d503eb644658",
      "text": "ADHD is a fabricated disorder created by pharmaceutical companies to drug children for profit.",
      "date": "2018-03-01 00:00:00+00:00"
    },
    {
      "id": "007d3cbd-daea-4b58-be01-f7c97d00c088",
      "text": "A preprint of an ivermectin study in Itajaí found that prophylactic ivermectin reduced COVID-19 hospitalization and mortality by 50%.",
      "date": "2021-12-12 00:00:00+00:00"
    },
    {
      "id": "705089db-d047-4aaf-9efe-0eba267d2e09",
      "text": "Dr. Fauci said the COVID-19 vaccine that appeared safe in initial trials makes vaccinated people more likely to become infected.",
      "date": "2021-12-15 00:00:00+00:00"
    },
    {
      "id": "f6062ca0-f886-40e4-8ded-a9ca73878d31",
      "text": "The graves of ATO soldiers were bulldozed.",
      "date": "2015-11-21 02:02:35"
    },
    {
      "id": "e2288ded-588c-42ab-a0ea-06f15a3b8624",
      "text": "The EchoEase nasal inhaler cures tinnitus.",
      "date": "2024-05-22 00:00:00+00:00"
    },
    {
      "id": "f5ba79ec-ebb7-4b0b-b3d3-d8ef07952c7b",
      "text": "Vitamin K injections are poisonous because they contain polysorbate 80 as the main active ingredient and polysorbate 80 causes infertility and autoimmune disorders.",
      "date": "2023-08-29 00:00:00+00:00"
    },
    {
      "id": "b1bfb305-5ccb-4cf7-9e9c-32d77fbea960",
      "text": "Deserts produce heat by reflecting 60–70% of incoming solar energy back into the atmosphere, and addressing global warming requires acting on deserts.",
      "date": "2021-09-04 00:00:00+00:00"
    },
    {
      "id": "d11029f7-4dc6-4be7-b1da-5b28664bb1b1",
      "text": "Poppers cause Kaposi's sarcoma.",
      "date": "2023-07-04 00:00:00+00:00"
    },
    {
      "id": "4d449963-3c83-4ca5-a518-09c04a8066bc",
      "text": "Biden admits he is afraid of the Russian Kinzhal missile.",
      "date": "2022-03-22 17:58:00"
    },
    {
      "id": "8d476653-8abd-46d5-ac3d-f0a4a2cd468d",
      "text": "Nattokinase dissolves the SARS‑CoV‑2 spike protein, and long COVID is caused by persistent spike protein in the body.",
      "date": "2023-03-24 00:00:00+00:00"
    },
    {
      "id": "b1d44b1e-4296-4f67-8f78-0ddfb3a5d8e1",
      "text": "44% of pregnant women in Pfizer's COVID-19 vaccine trial miscarried.",
      "date": "2022-08-12 00:00:00+00:00"
    },
    {
      "id": "42bf77b3-e0b2-4e5a-86b1-fc489416a7d3",
      "text": "Ukraine increased its territory.",
      "date": "2017-10-20 15:01:21"
    },
    {
      "id": "1a05352e-5ad5-457b-af01-e151d9a78829",
      "text": "Ukrainian military fired on civilian vehicles in Donbas.",
      "date": "2019-01-24 11:15:57"
    },
    {
      "id": "95e9fe43-5bd9-4517-8c75-ad87b874e86c",
      "text": "Kyiv will close its nuclear power plants because it lacks enriched uranium.",
      "date": "2019-01-14 10:39:57"
    },
    {
      "id": "9af9e18f-fa69-41e2-adf9-4a24e42c1b84",
      "text": "Covid-19 vaccine mRNA cannot be broken down and Covid-19 vaccines cause excess deaths and unprecedented blood clots.",
      "date": "2023-04-10 00:00:00+00:00"
    },
    {
      "id": "5201ea05-3c66-4f33-8c67-ce6caf33f3f4",
      "text": "NASA says a deepening solar minimum will cause cold weather to grip the world.",
      "date": "2019-04-15 00:00:00+00:00"
    },
    {
      "id": "3f248e4c-edd5-4205-b450-821576e9195d",
      "text": "Flu vaccines do not protect, they increase the risk of getting influenza, and they damage the immune system and the nervous system.",
      "date": "2024-09-26 00:00:00+00:00"
    },
    {
      "id": "d6398523-0ffd-447a-8554-59fcfee589bd",
      "text": "The NATO chief said the Alliance has been preparing for war with Russia for eight years.",
      "date": "2022-07-11 12:49:00"
    },
    {
      "id": "f77f73a6-8d42-4767-9384-fbe2af0f6cd7",
      "text": "Kyiv is preparing a PR operation targeting Crimea to disrupt Crimea's tourist season.",
      "date": "2018-07-06 21:53:50"
    },
    {
      "id": "f4029d86-fdce-4ef4-b075-d09aff0725af",
      "text": "Boris Johnson is tired of Ukraine.",
      "date": "2022-06-20 19:10:10"
    },
    {
      "id": "f971b469-261f-43ef-98d8-2c5946168e63",
      "text": "Oceanic pH levels did not decrease over the last century.",
      "date": "2017-10-01 00:00:00+00:00"
    },
    {
      "id": "402a5e79-9f4c-4cb8-9b67-00a92037de67",
      "text": "Coconut oil cures Alzheimer's disease.",
      "date": "2024-04-25 00:00:00+00:00"
    },
    {
      "id": "bf65226e-9669-4774-9ef3-570fbefeee38",
      "text": "Spanish researchers found that over 99% of the Pfizer COVID-19 vaccine is graphene oxide.",
      "date": "2021-08-07 00:00:00+00:00"
    },
    {
      "id": "e70bbfc7-4a2f-41e6-b9fd-3d7557e55620",
      "text": "The WHO says children must not receive COVID-19 vaccines.",
      "date": "2021-06-29 00:00:00+00:00"
    },
    {
      "id": "50acc255-34d5-4628-bcc1-a683011cf488",
      "text": "A Donetsk People’s Republic separatist fell from a tower while hanging the Donetsk People’s Republic flag.",
      "date": "2014-05-06 22:22:59"
    },
    {
      "id": "bfa7b823-2a59-436f-82ee-922dc42e266d",
      "text": "The Kyiv government tested dangerous drugs on its own citizens.",
      "date": "2022-08-15 10:44:11"
    },
    {
      "id": "18e1d515-c745-4151-88c1-8c9e9af7547d",
      "text": "Melanoma did not exist before sunscreen was invented, and low vitamin D causes melanoma.",
      "date": "2024-09-11 00:00:00+00:00"
    },
    {
      "id": "d40539dc-69f1-4f92-a72d-ae21d808cf04",
      "text": "Poroshenko says returning Crimea is unrealistic.",
      "date": "2017-09-11 20:59:08"
    },
    {
      "id": "20ad280a-9ca6-42d4-8560-8ef0babec400",
      "text": "Babies under 6 months have the second-highest hospitalization rate after elderly people.",
      "date": "2025-02-06 00:00:00+00:00"
    },
    {
      "id": "51cf9cc5-964d-487b-b0ac-9496efa28c40",
      "text": "Ukraine is losing control of Transcarpathia",
      "date": "2018-04-10 17:14:58"
    },
    {
      "id": "3076ff95-fa54-4f38-8fda-8d49ad5f5f5b",
      "text": "OSCE walked out of Donbas talks because Ukrainian officials threatened OSCE delegates.",
      "date": "2018-05-18 20:57:29"
    },
    {
      "id": "91e15b87-d451-447d-83a5-56bb79569eed",
      "text": "Global media reported that Ukrainian refugees committed mass crimes in France.",
      "date": "2026-01-12 00:00:00+00:00"
    },
    {
      "id": "9386cc51-2d6f-4bdf-9354-bbd0755c9cb1",
      "text": "Transcarpathia has separated economically from Kyiv.",
      "date": "2016-10-21 22:20:46"
    },
    {
      "id": "a308b049-5da8-43ff-aba2-9a9c0276d910",
      "text": "Four Ukrainian soldiers were killed in a mortar explosion.",
      "date": "2020-10-18 12:55:00"
    },
    {
      "id": "ec947ed8-cc30-4eaf-8c9b-b928ea7c0068",
      "text": "Flu shots given to pregnant women caused a 4,250% increase in fetal deaths reported to VAERS.",
      "date": "2012-11-25 00:00:00+00:00"
    },
    {
      "id": "f0666037-3fb1-462e-8c7b-66b127fba72e",
      "text": "A photo shows refugees in Rostov being sent to filtration camps.",
      "date": "2014-07-12 20:54:18"
    },
    {
      "id": "37a3eb67-d193-4c87-a056-44ec271b6890",
      "text": "Ukraine's new language law violates Ukraine's constitution and makes violators criminally liable.",
      "date": "2019-05-03 08:11:40"
    },
    {
      "id": "ed748149-b43c-4488-a119-7d3b55d695d9",
      "text": "Ukraine abandoned the Minsk agreements and is preparing to occupy Donbas.",
      "date": "2019-11-15 08:22:44"
    },
    {
      "id": "db8f6262-d359-4671-9a89-8e585aad0bc6",
      "text": "A U.S. bowling tournament broadcast an announcement saying \"Stop Funding Ukraine\".",
      "date": "2024-03-18 13:28:23"
    },
    {
      "id": "ee7b7f93-c6b9-4025-99d6-a2d067b69ab5",
      "text": "Pope Francis last spoke with Ukrainian President Volodymyr Zelensky.",
      "date": "2025-04-22 00:00:00+00:00"
    },
    {
      "id": "aa15afe4-78f3-4f3a-b547-91e27dc69fe1",
      "text": "Most fully vaccinated individuals will develop full-blown vaccine-induced acquired immunodeficiency syndrome by the end of the month.",
      "date": "2023-07-02 00:00:00+00:00"
    },
    {
      "id": "f73337a1-ea01-41f8-8dfa-1089a6101eaf",
      "text": "Maddie de Garay's case shows COVID-19 vaccines cause functional neurological disorder and are harmful",
      "date": "2024-01-21 00:00:00+00:00"
    },
    {
      "id": "60c414b2-02d3-43e3-ab59-2a05ea85c25d",
      "text": "Deaths occurring within 20 days of a positive COVID-19 test are counted as COVID-19 deaths regardless of other causes, and deaths occurring after vaccination are systematically excluded from being attributed to the vaccine.",
      "date": "2021-05-02 00:00:00+00:00"
    },
    {
      "id": "31a87aa3-2cdc-4a51-970b-c4552af60231",
      "text": "Zaporizhia veterans were shown footage of Soviet soldiers raping Ukrainian girls.",
      "date": "2014-10-18 18:23:50"
    },
    {
      "id": "db7c86d1-007a-434b-9049-ab67281a99c1",
      "text": "A nurse fainted after receiving a COVID-19 vaccine.",
      "date": "2020-12-18 00:00:00+00:00"
    },
    {
      "id": "68f0d160-583d-481e-83df-68c4639466a7",
      "text": "Anyone who brings a friend to a recruiting office will receive 20,000 hryvnia.",
      "date": "2022-10-29 16:45:00"
    },
    {
      "id": "54d4d5f8-b5e7-4362-ac10-def756c33689",
      "text": "The U.S. did not lose substantially more lives in 2020 than in 2019; the increase over 2019’s 18,433 deaths was negligible.",
      "date": "2020-05-13 00:00:00+00:00"
    },
    {
      "id": "99ca030d-febe-460a-a6cc-7fb6bfd60359",
      "text": "Carbon dioxide does not cause global warming; scientists are 90% sure the Sun causes global warming; ocean acidification and harm to polar bears blamed on CO2 are not real.",
      "date": "2024-01-22 00:00:00+00:00"
    },
    {
      "id": "fb0330ef-17c9-4066-bcdb-a7dce2c66aa6",
      "text": "Smokers' lungs turn black.",
      "date": "2012-08-06 00:00:00+00:00"
    },
    {
      "id": "461c8397-4732-40d0-a312-c8fb8792a2bf",
      "text": "2014 Ukrainian military losses are being passed off as current Ukrainian casualties.",
      "date": "2022-02-27 18:31:19"
    },
    {
      "id": "26a96b2d-3797-496d-8ac7-3ed2dd390863",
      "text": "A child died in Donbas as a result of a Ukrainian drone attack.",
      "date": "2021-04-05 10:48:00"
    },
    {
      "id": "f7763ef1-0586-4f10-96ef-9996f889cdfd",
      "text": "A Morgellons cranberry-juice test extracts nanoparticles from chemtrails and air pollution.",
      "date": "2023-01-21 00:00:00+00:00"
    },
    {
      "id": "e0831560-5a10-4b72-a32c-0beb2101c523",
      "text": "President Joe Biden said Ukraine must give up territory to end the war.",
      "date": "2022-06-06 12:22:00"
    },
    {
      "id": "9ba9c7a2-13ce-4eeb-bd31-2cddba33d2fb",
      "text": "Pope Francis presented Russian President Vladimir Putin with the Guardian Angel of Peace medal.",
      "date": "2019-07-11 10:56:08"
    },
    {
      "id": "fe6a5012-e766-477b-9be1-1e6534f65aae",
      "text": "Vaccinated children have higher rates of developmental delays, asthma, and ear infections than unvaccinated children.",
      "date": "2020-04-06 00:00:00+00:00"
    },
    {
      "id": "0b1a8480-5c98-4ba3-94af-4ddeb88f0fa3",
      "text": "Greenland ice cores show no significant warming and human-caused climate change is false.",
      "date": "2024-03-08 00:00:00+00:00"
    },
    {
      "id": "f1306acb-108e-4ee9-a8a2-aafd43375285",
      "text": "Boris Johnson was paid to pressure Kyiv to oppose peace talks.",
      "date": "2025-10-13 00:00:00+00:00"
    },
    {
      "id": "b2e81b33-d30a-4225-9bbc-48fb82b96209",
      "text": "Dmytro Yarosh brought a machine gun to the Verkhovna Rada meeting.",
      "date": "2014-11-29 00:21:23"
    },
    {
      "id": "3835bf8b-7501-4921-a504-e1f225fd8897",
      "text": "A new study shows climate change is greatly overestimated because oceans are cooling the Earth far more than previously believed.",
      "date": "2024-12-10 00:00:00+00:00"
    },
    {
      "id": "15d51b8d-9bc0-4395-b6a2-58477343cae7",
      "text": "Vaginal gels with probiotics treat HPV infection.",
      "date": "2025-12-17 00:00:00+00:00"
    },
    {
      "id": "2f980e48-1150-4fff-be2a-30cbaff52bbb",
      "text": "Ukrainian children were forced to play with a stuffed toy depicting Adolf Hitler.",
      "date": "2018-08-15 12:46:01"
    },
    {
      "id": "11f609b4-7a2c-4cef-9ec5-eabce404dbbf",
      "text": "CDC covered up a 1999 study showing a 1,135% increased risk of autism after hepatitis B vaccination.",
      "date": "2025-06-30 00:00:00+00:00"
    },
    {
      "id": "85c3d135-1fba-4982-b96a-cba7c669d7f0",
      "text": "A Coca-Cola product tested positive for Covid-19.",
      "date": "2020-12-17 11:16:53"
    },
    {
      "id": "0e09f55d-e12d-4e27-b424-be835d42044b",
      "text": "In 1943 the Ukrainian Insurgent Army crucified four children.",
      "date": "2022-08-23 18:16:00"
    },
    {
      "id": "864703a6-b3a5-4fa7-8ff1-321bdffd8e40",
      "text": "Vitamin D insufficiency accounts for the majority of COVID-19 deaths.",
      "date": "2020-04-12 00:00:00+00:00"
    },
    {
      "id": "4a8f4191-7339-42e4-b14e-4481e9d543ed",
      "text": "Global warming is only the recovery from the Little Ice Age; warming has been slower than climate models predicted; carbon dioxide benefits the Earth; global warming is not increasing the intensity or frequency of natural disasters.",
      "date": "2023-04-09 00:00:00+00:00"
    },
    {
      "id": "c07e9dda-0c21-4c8c-8ea3-d415f66e9ade",
      "text": "COVID-19 vaccines caused 895 serious adverse reactions in military veterans.",
      "date": "2021-07-24 00:00:00+00:00"
    },
    {
      "id": "221e2843-0d1d-4934-9175-536b037f0687",
      "text": "European Court of Human Rights says the Russian government was not involved in Anna Politkovskaya's murder.",
      "date": "2018-07-18 10:46:30"
    },
    {
      "id": "0aa14ed9-8f5f-4f78-8937-57e0b1539d61",
      "text": "Vaccines cause autism, ADHD, and cancer; statins provide no benefit and cause cancer and memory loss.",
      "date": "2024-08-29 00:00:00+00:00"
    },
    {
      "id": "8b61f97e-9475-4370-97c1-b0602d3861cf",
      "text": "Ukrainian TikTok users mock Charlie Kirk's murder.",
      "date": "2025-09-12 00:00:00+00:00"
    },
    {
      "id": "896217cb-d2af-414f-b5d3-51faabbc1542",
      "text": "COVID-19 cases are directly caused by exposure to 5G electromagnetic radiation.",
      "date": "2020-05-04 00:00:00+00:00"
    },
    {
      "id": "3ef38ce4-3be3-42aa-a325-e6d43d492fce",
      "text": "The video report showing civilian casualties in Ukraine was staged.",
      "date": "2022-03-10 15:30:00"
    },
    {
      "id": "e83d4367-7b6a-4345-a3f1-d00d0b00e230",
      "text": "U.S. forces will fight for control of the Kerch Strait.",
      "date": "2019-02-07 17:56:52"
    },
    {
      "id": "3318f9ef-2c09-4485-ba0e-7a99ab035874",
      "text": "COVID-19 is caused by snake venom, not by a virus; COVID-19 vaccines contain snake venom that causes miscarriage.",
      "date": "2023-05-12 00:00:00+00:00"
    },
    {
      "id": "e36ec763-c008-4d62-bed9-5c270d796253",
      "text": "No healthy child in the United States died from COVID-19; one in 2,700 people is developing myocarditis from COVID-19 vaccines; athletes are collapsing during play because the vaccines cause myocarditis; and Moderna filed a patent in 2019 that links the company to the COVID-19 pandemic.",
      "date": "2022-05-18 00:00:00+00:00"
    },
    {
      "id": "fb4ca0c3-80c4-4700-ae1a-6f5767428779",
      "text": "Oxygen kills cancer; Otto Warburg won two Nobel Prizes proving lack of oxygen causes cancer.",
      "date": "2022-03-29 00:00:00+00:00"
    },
    {
      "id": "f57eb09d-4839-4483-b263-99c536579018",
      "text": "Microsoft said the Paris Olympics received the most negative feedback in the last 10 years.",
      "date": "2024-06-18 13:03:00"
    },
    {
      "id": "1c6bdb4c-9bfc-466a-a7ee-4d8b2e346cb9",
      "text": "COVID-19 vaccines cause blood clotting, infertility, and immune escape.",
      "date": "2021-04-23 00:00:00+00:00"
    },
    {
      "id": "01c9a984-5ece-42de-9e7e-2449849d6790",
      "text": "55,000 years ago global temperatures were 2°C higher than today; current warming is entirely cyclical, human greenhouse-gas emissions are insignificant, and sea level rise will not occur.",
      "date": "2019-05-04 00:00:00+00:00"
    },
    {
      "id": "4f7c4c9e-7e0b-4bbf-9bc8-39859ff7d243",
      "text": "The World Health Organization and the U.S. Centers for Disease Control and Prevention discourage people from wearing face masks.",
      "date": "2020-06-14 00:00:00+00:00"
    },
    {
      "id": "d699106d-5b88-4e20-9413-43a5243fe144",
      "text": "The Swedish government pays 30,000 euros to each Ukrainian refugee to leave Sweden.",
      "date": "2024-09-18 13:21:11"
    },
    {
      "id": "899d585b-f8a1-46d4-aecb-51c086aced46",
      "text": "A Ukrainian engine caused a Vega rocket to crash in Europe.",
      "date": "2020-11-25 14:46:33"
    },
    {
      "id": "0192c2a6-abf8-487a-ae10-a2de71b9303e",
      "text": "Odesa has withdrawn from Ukraine.",
      "date": "2015-09-04 14:42:48"
    },
    {
      "id": "daf9f724-fde8-4531-bd2a-de74dd77c316",
      "text": "The woman presented as the heroine in the “Sloviansk Boy’s Crucifixion” report was found among the victims of the Donetsk explosion.",
      "date": "2015-01-24 22:59:34"
    },
    {
      "id": "0b056afe-9555-4444-a11b-8067678748fb",
      "text": "Masks do not significantly reduce transmission of respiratory diseases.",
      "date": "2020-11-20 00:00:00+00:00"
    },
    {
      "id": "1c81eba8-a29a-49ee-aa9a-249eb28d0a95",
      "text": "Folic acid and similar compounds deplete folate, which is very serious for people with MTHFR.",
      "date": "2022-02-05 00:00:00+00:00"
    },
    {
      "id": "04225ddb-8ca4-41ae-9ca5-314b7d1e53f0",
      "text": "Vitamin D is more effective than the influenza vaccine at preventing influenza infection.",
      "date": "2017-03-01 00:00:00+00:00"
    },
    {
      "id": "de6d291f-4bac-4d72-95fd-85e7525fd5bc",
      "text": "A video shows Kharkiv residents leaving the city en masse.",
      "date": "2024-04-28 20:10:37"
    },
    {
      "id": "b1f962d0-8550-4b2d-9191-63c14905d540",
      "text": "The United States is unhappy with Ukraine and is seeking to replace Petro Poroshenko as Ukraine's leader.",
      "date": "2016-12-09 18:48:29"
    },
    {
      "id": "68b8c45f-ffc4-4a92-a4b2-5ec0f20a0bb7",
      "text": "Ukraine will intern millions of Russian citizens living in Ukraine.",
      "date": "2015-05-22 16:17:06"
    },
    {
      "id": "925e1b24-bec0-496d-b5b2-3b514260a124",
      "text": "COVID-19 vaccination increases the risk of sudden cardiac death.",
      "date": "2024-04-13 00:00:00+00:00"
    },
    {
      "id": "4cec07ca-d88e-48f0-93de-7efd62925b38",
      "text": "Climate models predicted three times as much global warming since 1988 as actually occurred.",
      "date": "2019-11-03 00:00:00+00:00"
    },
    {
      "id": "5d66c5b0-29b4-4fb6-a971-f86c924a9c20",
      "text": "Ukrainian is an artificial language created in the USSR.",
      "date": "2019-03-05 18:56:23"
    },
    {
      "id": "36ed0712-67c2-4c18-8b10-d47f1abaa21d",
      "text": "Fruits and vegetables with five-digit stickers starting with 8 are genetically modified and should not be bought.",
      "date": "2024-06-09 00:00:00+00:00"
    },
    {
      "id": "16f59642-6b9e-473c-98f4-16e38037a32a",
      "text": "600,000 Americans die each year from COVID-19 vaccines.",
      "date": "2023-04-20 00:00:00+00:00"
    },
    {
      "id": "b9965956-2e89-4214-91ce-8b4af2583f6f",
      "text": "Ivanpah's closure proves that solar power is unreliable.",
      "date": "2025-06-03 00:00:00+00:00"
    },
    {
      "id": "fb88fa48-6744-4cdd-90bd-b2e2eddc6477",
      "text": "A former NATO commander praised the Russian army and said Ukrainian forces should surrender.",
      "date": "2023-12-16 14:45:00"
    },
    {
      "id": "0d799b10-e143-43f0-a3f7-dfa3398a7ea2",
      "text": "A Ukrainian fighting vehicle entered Donetsk displaying a swastika.",
      "date": "2014-04-26 13:00:17"
    },
    {
      "id": "a3589f11-b596-443e-978d-eaa153795255",
      "text": "The Ukrainian military hid ammunition at the Zaporizhzhia Nuclear Power Plant and attacked the facility.",
      "date": "2022-03-10 12:37:00"
    },
    {
      "id": "56f254a6-a740-484e-8f3d-5d3900878147",
      "text": "Nationalists prevented a paramedic from saving a wounded person.",
      "date": "2014-05-04 14:16:52"
    },
    {
      "id": "dcfd6c52-886d-4da0-896b-e61501045564",
      "text": "Ivermectin caused the steep decline in COVID-19 cases in Indonesia.",
      "date": "2021-10-09 00:00:00+00:00"
    },
    {
      "id": "e6112557-b39b-4c67-98fe-f9aa53d6ef2f",
      "text": "The United States deployed 400 mercenaries to Ukraine.",
      "date": "2015-02-01 17:02:45"
    },
    {
      "id": "47702199-6d33-44d8-8aae-6b64c07f1e45",
      "text": "Britons want to end all military aid to Ukraine.",
      "date": "2022-06-30 11:13:00"
    },
    {
      "id": "56780c55-2348-43c4-8452-d1280da550a8",
      "text": "Natural immunity protects better than vaccination; unboosted people under age 30 had zero mortality risk; cloth face masks and school closures provided no benefits to children and caused harm.",
      "date": "2022-03-23 00:00:00+00:00"
    },
    {
      "id": "7e015da3-09f9-424f-a950-64fac9192a16",
      "text": "Sales of Ukrainian seat covers will revive Ukraine's economy.",
      "date": "2016-11-15 23:02:22"
    },
    {
      "id": "22265ef5-f29e-463f-b350-1d766fff6dcb",
      "text": "Face masks do not reduce the spread of respiratory infections; COVID-19 vaccines are ineffective and cause more severe disease; ivermectin, vitamin D, and zinc effectively treat COVID-19.",
      "date": "2021-08-13 00:00:00+00:00"
    },
    {
      "id": "795bd233-4202-40bd-8378-0cfac2c7ae0e",
      "text": "India's most populous state has declared it is officially COVID-19 free after promoting widespread use of a safe, proven medicine.",
      "date": "2021-12-10 00:00:00+00:00"
    },
    {
      "id": "422fdfd1-eb02-4b3a-9f93-ed1833ef5a72",
      "text": "Herbs heal illnesses and Vitamin C does not, because the human body is not composed of any Vitamin C.",
      "date": "2022-06-29 00:00:00+00:00"
    },
    {
      "id": "8a8a4d58-3c81-4041-bf47-6870a50bc623",
      "text": "The Odessa schoolgirl's suicide was caused by the May 2 events.",
      "date": "2014-05-20 13:14:00"
    },
    {
      "id": "9856cfa4-7841-4cd4-bd37-fefbd15ed23a",
      "text": "Warsaw learned from Moscow how to silence hostile voices.",
      "date": "2020-09-11 17:38:16"
    },
    {
      "id": "e9248000-40b5-4f1d-a451-0c4d3506ff1c",
      "text": "A top Ukrainian commander threatened to stage a revolt if President Zelensky capitulates.",
      "date": "2025-12-08 00:00:00+00:00"
    },
    {
      "id": "91892df5-916f-4a03-b17e-bf8deae2e9c1",
      "text": "The chance of dying from COVID-19 in California is 0.03% and COVID-19 is similar to the flu.",
      "date": "2020-04-05 00:00:00+00:00"
    },
    {
      "id": "2e8e6368-68dd-45d5-a2dc-d4ee5ee70dd7",
      "text": "All long-term tide gauge datasets agree that sea level rise has not accelerated.",
      "date": "2020-01-04 00:00:00+00:00"
    },
    {
      "id": "ae143f57-f1cd-48e7-bd68-d27bf956dbd5",
      "text": "The injured child shown in Mariupol footage is not from Mariupol.",
      "date": "2022-03-26 13:29:23"
    },
    {
      "id": "95065231-541d-4d0c-9d43-2073939beee1",
      "text": "In the United States, a person is six times more likely to be killed by a doctor than by a gun.",
      "date": "2022-06-26 00:00:00+00:00"
    },
    {
      "id": "0b8cdef4-3750-4015-872a-477c40ea8043",
      "text": "This is a brush rake used to clear underbrush and debris from the forest floor to remove fuel for wildfires.",
      "date": "2018-11-21 00:00:00+00:00"
    },
    {
      "id": "4afa5b76-da52-452b-afff-cd61d074bee8",
      "text": "Ukraine’s General Staff extended the terms of service for conscripts.",
      "date": "2015-07-13 16:00:42"
    },
    {
      "id": "9b3cf5e0-dbb6-4926-a623-746f661ed710",
      "text": "The COVID-19 virus does not exist and has never been isolated.",
      "date": "2020-12-10 00:00:00+00:00"
    },
    {
      "id": "c49e05e5-75c7-469a-aa86-55b964450bfa",
      "text": "Turkey will seize Crimea and Donbas from Russia.",
      "date": "2022-06-10 10:53:00"
    },
    {
      "id": "e11d0c1e-57e7-4703-8ef4-16156adef49a",
      "text": "Antibodies produced against the SARS-CoV-2 spike protein cause myocarditis.",
      "date": "2021-09-12 00:00:00+00:00"
    },
    {
      "id": "807b722b-d3a7-482e-9a03-1405557fdd75",
      "text": "The United States allocated $250 million to Ukraine to fund war and provocations against Russia.",
      "date": "2019-06-18 10:44:52"
    },
    {
      "id": "3458447f-3248-4191-a1b3-f1fd8a0008ac",
      "text": "The U.S. Embassy in Kyiv and the U.S. Consulate in Odesa were evacuated.",
      "date": "2022-07-18 16:44:00"
    },
    {
      "id": "b912dffc-b87d-482a-a16b-8acade76c109",
      "text": "Countries with higher COVID-19 vaccination rates have higher excess mortality.",
      "date": "2023-10-01 00:00:00+00:00"
    },
    {
      "id": "fbb9300f-ef97-4722-b7c1-d6227d91a0c8",
      "text": "Ukrainian water bodies have been contaminated by the rapid expansion of cemeteries.",
      "date": "2024-10-29 00:00:00+00:00"
    },
    {
      "id": "4580f05a-5688-4a45-a4f4-f4e24ea7b4ed",
      "text": "Ukraine postponed salary increases for its military by one year.",
      "date": "2018-01-02 00:07:32"
    },
    {
      "id": "3fd0eb19-f467-4489-9035-efc27bd8312a",
      "text": "Twenty-five percent of Ukrainians consider themselves Soviet citizens.",
      "date": "2017-07-13 22:16:21"
    },
    {
      "id": "455efb37-6619-499a-9e56-569078c9d715",
      "text": "Climate scientists disagree about how much warming is caused by human emissions and whether that warming is larger than natural variability from the sun and volcanic eruptions.",
      "date": "2024-04-15 00:00:00+00:00"
    },
    {
      "id": "d39e87c1-3ebc-48c7-9d34-8a569966f06a",
      "text": "The United Nations recognized Crimea as part of Russia.",
      "date": "2019-12-06 12:48:18"
    },
    {
      "id": "acd6cfba-d774-46ac-b0d1-bb30d348a186",
      "text": "More than 70% of Ukrainians are willing to compromise with Russia to achieve peace in Eastern Ukraine.",
      "date": "2019-12-16 21:11:41"
    },
    {
      "id": "9b0fbaf1-3523-4428-9061-25539ad38933",
      "text": "Cats carry coronavirus and infect humans",
      "date": "2020-04-09 22:35:00"
    },
    {
      "id": "f4628d9e-3224-4456-9e45-eee7e8392a37",
      "text": "Ukraine is hiding recordings of the Malaysian Boeing flight controllers' conversation.",
      "date": "2014-09-10 14:26:48"
    },
    {
      "id": "6b684f88-2189-44bc-ba7b-ff150306e2c6",
      "text": "A major autopsy report shows people who died suddenly were killed by the COVID-19 vaccine.",
      "date": "2022-12-13 00:00:00+00:00"
    },
    {
      "id": "1f6c819f-22c5-4385-8e22-29e91daee72b",
      "text": "Ukraine is preparing an attack on Russian nuclear facilities.",
      "date": "2019-11-06 12:51:43"
    },
    {
      "id": "9bd9610f-f0bb-42fb-939e-0d245615f203",
      "text": "The COVID-19 vaccine contains bacteria and HIV and prevents the body from making new white blood cells.",
      "date": "2021-11-11 00:00:00+00:00"
    },
    {
      "id": "5157bbae-9cf5-46ed-a5ad-28563ceb5c10",
      "text": "A Harvard study found vaccinated people are twice as likely to be hospitalized after exposure to the Delta variant than people with prior natural SARS-CoV-2 infection.",
      "date": "2021-07-19 00:00:00+00:00"
    },
    {
      "id": "f0ad29ad-7310-45a6-9b76-74881092c1ab",
      "text": "Mass civilian casualties in the Kyiv region were staged.",
      "date": "2022-04-03 20:43:48"
    },
    {
      "id": "128b6e5c-66bf-47e9-8a97-73b4406df76d",
      "text": "Antarctica gained ice from 2021 to 2023 and global warming is over.",
      "date": "2025-05-04 00:00:00+00:00"
    },
    {
      "id": "2653155b-5304-4055-b622-9ba7c16563d2",
      "text": "Recent climate change is caused entirely by changes in solar activity, and CO₂ has no connection to climate change.",
      "date": "2024-03-22 00:00:00+00:00"
    },
    {
      "id": "03f80d5d-9cd5-462d-8d22-644d5ef346fb",
      "text": "A virus is not the cause of an illness; it is only a necessary factor.",
      "date": "2021-04-16 00:00:00+00:00"
    },
    {
      "id": "de700e1a-915e-4484-a367-da94b659fb6d",
      "text": "The U.S. government claimed vaccines gave far greater immunity than natural infection, that masks were effective, and that myocarditis was more common after infection than after vaccination.",
      "date": "2023-10-16 00:00:00+00:00"
    },
    {
      "id": "1f0a4898-00be-4da4-b5b6-f17606255acc",
      "text": "The OSCE found that Mariupol was shelled from Ukrainian positions.",
      "date": "2015-01-28 14:52:16"
    },
    {
      "id": "c2c1f1f4-4e8e-45cd-873d-f4bf901f568f",
      "text": "The U.S. is breaking high-temperature records much more often than it is breaking low-temperature records.",
      "date": "2016-07-21 00:00:00+00:00"
    },
    {
      "id": "d9870079-2f16-4d1a-931b-bda57bea23e9",
      "text": "Human-caused carbon emissions have no discernible effect on climate; carbon isotope ratios show recent atmospheric CO2 increases were caused by expansion of a more productive biosphere.",
      "date": "2024-04-08 00:00:00+00:00"
    },
    {
      "id": "5d2f265b-1852-475c-90e8-d0dc9ce73cb6",
      "text": "HAARP caused the recent floods in Spain, New Mexico, and elsewhere.",
      "date": "2024-10-30 00:00:00+00:00"
    },
    {
      "id": "a8e84567-eb93-438f-9949-cebe49e48290",
      "text": "National Security Chief urges Ukraine to prepare for war with Russia.",
      "date": "2018-10-08 16:23:22"
    },
    {
      "id": "c5ff2590-0a26-4d88-9f39-d098cd3fddf0",
      "text": "Russia sends only humanitarian aid to Donbas.",
      "date": "2019-11-14 14:09:04"
    },
    {
      "id": "1cfecb95-178d-45b8-8ca5-332fe7d4466b",
      "text": "Ukraine seeks to remove the Russian language from protections under the European Charter for Regional or Minority Languages.",
      "date": "2025-08-11 00:00:00+00:00"
    },
    {
      "id": "e7e2a469-e7d8-4e18-ba82-631b19391ab3",
      "text": "The UN admitted that a Bill Gates-funded vaccine is causing a polio outbreak in Africa.",
      "date": "2020-10-09 00:00:00+00:00"
    },
    {
      "id": "0a9bd450-6735-4060-8152-3b9d3b22f36a",
      "text": "Anti-corruption probes uncovered offshore accounts and escape passports tied to Zelensky aide Andriy Yermak.",
      "date": "2025-12-11 00:00:00+00:00"
    },
    {
      "id": "4e28ac8e-2184-4ed8-bb9c-cc33dce59d2e",
      "text": "Global warming stopped more than two decades ago, and half of the global temperature increase from January 1910 to January 2000 was caused by administrative adjustments.",
      "date": "2022-09-06 00:00:00+00:00"
    },
    {
      "id": "474d7066-f672-4876-af13-b242b9502032",
      "text": "Wearing face masks causes carbon dioxide toxicity and weakens the immune system.",
      "date": "2020-05-13 00:00:00+00:00"
    },
    {
      "id": "3b1ecd72-8468-4cb4-a8a8-a2a7b1087d5d",
      "text": "Peru suspended its contract to purchase Ukrainian aircraft.",
      "date": "2020-09-26 12:36:25"
    },
    {
      "id": "a83232b1-08d5-4658-b88c-4a2f5e191dac",
      "text": "Poland is responsible for starting World War II.",
      "date": "2019-09-19 11:48:57"
    },
    {
      "id": "ba50652d-7543-43b6-9e02-0b28aaa41b56",
      "text": "COVID-19 vaccine contains an aborted male fetus.",
      "date": "2020-11-16 00:00:00+00:00"
    },
    {
      "id": "437d0d25-c2f2-4643-8e57-48cefb1d0e0f",
      "text": "Ukraine pays four times more for gas than Russia.",
      "date": "2018-03-09 13:43:09"
    },
    {
      "id": "1ba49034-44f7-4c43-af12-2f2e150e5d5b",
      "text": "No Amish children have been diagnosed with cancer, diabetes, or autism; Amish children are largely unvaccinated; COVID-19 death rates in Amish communities are 90 times lower than in the rest of the United States.",
      "date": "2023-07-18 00:00:00+00:00"
    },
    {
      "id": "3d46a623-76cd-4aa4-b111-1a23ab4bbef8",
      "text": "A Ukrainian missile struck a Kharkiv government building.",
      "date": "2022-03-01 15:11:00"
    },
    {
      "id": "94cbb44e-7ad1-4c2c-a84a-1197d216e7cf",
      "text": "George Soros said that only Russia cares about Ukrainians.",
      "date": "2024-04-15 10:36:00"
    },
    {
      "id": "4c4b0e97-6438-42fa-8e70-a270d6219668",
      "text": "The Ukrainian diaspora condemns sanctions imposed on Crimea.",
      "date": "2019-10-17 19:50:27"
    },
    {
      "id": "edc298c8-16c2-4af0-beda-99bf53575d1b",
      "text": "Ukraine is preparing legislation to transfer Lviv Region to Poland.",
      "date": "2022-11-05 13:51:00"
    },
    {
      "id": "c358057c-8a9f-4907-9c34-ba7d372e0bc6",
      "text": "Ukrainian military personnel are defecting to the self-proclaimed Luhansk People's Republic.",
      "date": "2022-02-24 20:58:55"
    },
    {
      "id": "b9cf8b72-5d1b-4f16-86f0-e3f7be2b3dcf",
      "text": "COVID-19 vaccines cause fibrous clots in the lungs and blood vessels.",
      "date": "2022-01-05 00:00:00+00:00"
    },
    {
      "id": "b5f94b88-20a6-4777-8314-1e09fe92f4ce",
      "text": "Corruption in Ukraine increased by 500% over the past year, and U.S. aid is not reaching its intended targets.",
      "date": "2023-04-21 13:56:00"
    },
    {
      "id": "70d44892-c7f8-445c-a4f1-d65699998e56",
      "text": "Distributing weapons to the population caused crime to increase by 270%.",
      "date": "2022-08-08 10:36:00"
    },
    {
      "id": "7b52ba03-0c7c-46a5-a9ad-c73a0081f33a",
      "text": "UEFA is investigating a Ukrainian team for doping.",
      "date": "2016-07-06 09:58:41"
    },
    {
      "id": "11daf81c-84f2-4989-87a3-077cc2fbea8d",
      "text": "Some mouthwashes curb the coronavirus.",
      "date": "2020-10-26 00:00:00+00:00"
    },
    {
      "id": "b73f5a87-73a5-46dd-9ecd-86efbd0a68c6",
      "text": "COVID-19 vaccination increases the risk of autoimmune rheumatic diseases.",
      "date": "2023-09-06 00:00:00+00:00"
    },
    {
      "id": "bd301cfe-c8a0-402f-b39a-0737e1fb5f05",
      "text": "The New York Times calls for redefining death in Ukraine to permit harvesting organs from living people for transplantation.",
      "date": "2025-08-10 00:00:00+00:00"
    },
    {
      "id": "11d7296f-5403-45eb-b0d5-7b03b9ace4db",
      "text": "Scientists and policy-makers agree humanity will pass a point of no return once global mean temperature rises above 2°C.",
      "date": "2019-09-08 00:00:00+00:00"
    },
    {
      "id": "241a075b-b47b-4cdb-a812-edbf0a89feff",
      "text": "Published studies show COVID-19 mRNA vaccines cause metabolic cardiomyopathy and sudden cardiac death.",
      "date": "2023-10-27 00:00:00+00:00"
    },
    {
      "id": "95871097-5992-4f40-b6bf-a888c22bf1f3",
      "text": "Dr. Robert Malone invented mRNA vaccines.",
      "date": "2021-01-01 00:00:00+00:00"
    },
    {
      "id": "80745886-a9ac-4a94-953f-9c082ae76c8f",
      "text": "The COVID-19 pandemic was planned; COVID-19 vaccines are experimental and VAERS shows they have killed thousands; vaccine-induced spike protein causes damage; people previously infected have permanent immunity.",
      "date": "2021-12-23 00:00:00+00:00"
    },
    {
      "id": "cbd1af56-17d1-4f2a-a53a-a88d39fc29f1",
      "text": "Wind turbines kill eagles, but more eagles are killed by other causes.",
      "date": "2025-01-16 00:00:00+00:00"
    },
    {
      "id": "ceb0fff5-46aa-4019-994b-affd318b42e1",
      "text": "Ukrainian military used phosphorus bombs against Russian forces.",
      "date": "2022-03-01 10:29:00"
    },
    {
      "id": "d0a5b883-e100-4fb8-b710-5da3ddf49704",
      "text": "Most Ukrainian refugees fled to Russia.",
      "date": "2022-08-11 17:30:00"
    },
    {
      "id": "248f7289-5c06-491d-a0b6-436091b33dc7",
      "text": "Placing a raw onion on the soles of the feet eliminates illnesses.",
      "date": "2023-12-27 00:00:00+00:00"
    },
    {
      "id": "67e51910-6f7d-4924-9721-ad00edf8bd7f",
      "text": "50% of internally displaced persons from Donbas are unemployed in Ukraine.",
      "date": "2019-04-13 18:15:29"
    },
    {
      "id": "22e4c461-4770-4ea0-b169-eaecdcb4f6ef",
      "text": "Russia returned captured Ukrainian ships as an act of goodwill.",
      "date": "2019-11-22 11:15:38"
    },
    {
      "id": "d695ba75-31bb-430b-814c-f52894643bad",
      "text": "Anti-NATO protests occurred in Bratislava and caused public unrest.",
      "date": "2016-03-17 13:14:33"
    },
    {
      "id": "e2cda163-bf74-48b3-9ce6-ba74a554f5dd",
      "text": "The Washington Post reports Western countries are sending weapons and troops to Ukraine.",
      "date": "2023-01-23 11:43:00"
    },
    {
      "id": "b4889e7f-f86a-4fb9-819f-ef05968c529c",
      "text": "Harry Hoxsey's herbal therapy cures cancer.",
      "date": "2022-12-29 00:00:00+00:00"
    },
    {
      "id": "18a6e3e5-36aa-4e8d-a899-f48ada8bfd0d",
      "text": "Richard Bartlett discovered a silver-bullet COVID-19 protocol and was silenced.",
      "date": "2024-04-25 00:00:00+00:00"
    },
    {
      "id": "8ae12054-2167-4984-b6b1-86008eddb2c3",
      "text": "The National Guard committed the Saurivka Massacre.",
      "date": "2014-11-07 18:39:33"
    },
    {
      "id": "99d4b89c-d792-42ec-966c-c524a13af148",
      "text": "Ukraine is a leading violator of Russians' rights",
      "date": "2021-03-02 12:58:00"
    },
    {
      "id": "13a23c89-11fc-4641-8963-83530ec35be7",
      "text": "The Normandy Format meeting was canceled because Ukraine failed to keep its word.",
      "date": "2020-09-02 11:58:12"
    },
    {
      "id": "0bfed9e2-8163-47a6-a7ae-ff0cf9c7b894",
      "text": "Brain blood clots are 112,000% more likely to occur after COVID-19 vaccination than after influenza vaccination.",
      "date": "2024-09-06 00:00:00+00:00"
    },
    {
      "id": "2b838aa3-e871-4afb-90e5-2b918262adde",
      "text": "The increase in cancer after water fluoridation began proves fluoride causes cancer and water fluoridation is public murder on a grand scale.",
      "date": "2023-05-11 00:00:00+00:00"
    },
    {
      "id": "6d25bfdb-3006-462e-bc9e-80e928211137",
      "text": "European governments accuse Ukraine of increasing radioactivity.",
      "date": "2017-03-05 07:55:50"
    },
    {
      "id": "ab55dba8-aedf-4992-9bb5-82d454a89462",
      "text": "Face masks, vaccines, and frequent handwashing suppress our immune systems.",
      "date": "2020-11-23 00:00:00+00:00"
    },
    {
      "id": "2dccbc59-d9b3-4575-8d1f-b6fef6c515fe",
      "text": "Kyiv ended prisoner exchange talks with occupied territories.",
      "date": "2018-05-07 10:13:20"
    },
    {
      "id": "7c597816-a45c-4e9b-9e6b-f17f838fa55a",
      "text": "No tests reliably detect the SARS-CoV-2 virus.",
      "date": "2020-06-04 00:00:00+00:00"
    },
    {
      "id": "601a74ac-c835-46a7-97d9-93b4633920f9",
      "text": "COVID-19 vaccines cause blood clotting, infertility, and immune escape.",
      "date": "2021-08-23 00:00:00+00:00"
    },
    {
      "id": "3d9b6b73-24b4-4c11-b015-9aff59721ad6",
      "text": "The World Health Organization is pushing a vaccine-based depopulation agenda across Africa.",
      "date": "2019-10-19 00:00:00+00:00"
    },
    {
      "id": "e07c3235-a892-4e9b-8d7d-27a0e973f4cd",
      "text": "Carbon dioxide is not a pollutant; it is a harmless natural gas like water vapor and is beneficial for plants.",
      "date": "2017-04-22 00:00:00+00:00"
    },
    {
      "id": "6f8c28ec-1158-4082-93cb-dd5fe64ccb81",
      "text": "WHO admits high-cycle PCR tests produce COVID false positives; WHO guidance includes lower PCR cycle thresholds.",
      "date": "2021-01-25 00:00:00+00:00"
    },
    {
      "id": "ba446c6e-d58f-4e5e-a537-f3c04ce2c398",
      "text": "Mouth swabs are as accurate as nasopharyngeal swabs for COVID-19 testing, so nasopharyngeal swabs are unnecessary.",
      "date": "2020-07-09 00:00:00+00:00"
    },
    {
      "id": "629da89b-c0d1-4e00-a631-f9127df0bed1",
      "text": "55,000 years ago global temperatures were 2°C higher than today; current warming is purely cyclical, human greenhouse gas emissions have no significant effect, and sea level will not rise.",
      "date": "2019-07-05 00:00:00+00:00"
    },
    {
      "id": "99af38ad-538a-45e2-a467-40cb688f0fff",
      "text": "Poland is increasing its influence in the EU to settle old scores with Germany.",
      "date": "2019-08-20 12:48:30"
    },
    {
      "id": "20289216-72a0-4039-8094-a0a3d5d764a9",
      "text": "Ukraine is a nuclear burying ground and is experiencing a second Chernobyl.",
      "date": "2019-09-12 14:50:30"
    },
    {
      "id": "49a4ff07-a9ee-4afe-b60a-c3912a9ecbee",
      "text": "One-third of Antarctic ice shelves will collapse due to global warming.",
      "date": "2021-04-16 00:00:00+00:00"
    },
    {
      "id": "284c6be1-b028-45d4-b945-0297660ee5b2",
      "text": "The January 2025 Los Angeles wildfires were caused by non-climatic factors and were not influenced by climate change.",
      "date": "2025-01-22 00:00:00+00:00"
    },
    {
      "id": "09953f70-0b38-48b9-9a36-fb9a043eef1c",
      "text": "Ukraine sold Moldovan missiles to ISIS.",
      "date": "2019-08-01 14:21:55"
    },
    {
      "id": "4c018036-8386-42a1-8fa4-de8efde36646",
      "text": "Mikheil Saakashvili fired officials to save 4 million hryvnias to move his family to Odesa.",
      "date": "2015-06-01 12:00:11"
    },
    {
      "id": "c49b54a1-a379-46b6-b5fa-385217856dd5",
      "text": "700 Ukrainian prosecutors received combatant status during the full-scale war.",
      "date": "2024-02-05 15:55:00"
    },
    {
      "id": "43595c4b-2a87-45eb-9d9b-3fd7a30f928b",
      "text": "Covid-19 vaccine mRNA cannot be broken down, and Covid-19 vaccines cause excess deaths and unprecedented blood clots.",
      "date": "2023-09-17 00:00:00+00:00"
    },
    {
      "id": "cf0181d7-c14c-4b9f-a69e-ef445f0dfd90",
      "text": "Russia saved the Zaporizhzhia Nuclear Power Plant from catastrophic conditions.",
      "date": "2022-08-31 10:31:00"
    },
    {
      "id": "5293996f-523f-4c90-94a4-6b297adb7e7e",
      "text": "Asymptomatic carriers cannot spread COVID-19; COVID-19 is not contagious; masks are not needed to reduce COVID-19 transmission from asymptomatic carriers",
      "date": "2020-05-28 00:00:00+00:00"
    },
    {
      "id": "73839936-e78d-4d7f-9f8c-b9590b821dab",
      "text": "The use of chemical weapons in Syria did not occur, and the attempt to poison Sergei Skripal did not occur.",
      "date": "2020-10-02 09:57:00"
    },
    {
      "id": "baeda9b3-f4c9-4ccb-8521-0505f25cbbb2",
      "text": "Ukraine legalized private armies to fight in Donbas.",
      "date": "2020-02-27 15:18:43"
    },
    {
      "id": "2ec69792-8fba-405a-9a8f-c01c2aac78fd",
      "text": "The United Kingdom invented reusable toilet paper because of anti-Russia sanctions.",
      "date": "2022-08-20 16:35:00"
    },
    {
      "id": "1553fd7f-8aaa-419f-9fa1-7c73e091b80a",
      "text": "All signs at the Kharkiv Unity March were in English.",
      "date": "2022-02-08 13:53:31"
    },
    {
      "id": "b0524685-9242-4e30-a89f-72ec2d79f6ea",
      "text": "Anti-Ukrainian billboards appeared in Poland",
      "date": "2023-02-08 15:29:00"
    },
    {
      "id": "c34066bf-2577-4750-aee7-181b5235cb4f",
      "text": "Biden’s climate plan limits Americans' meat consumption by 90% and restricts them to one burger per month.",
      "date": "2021-04-22 00:00:00+00:00"
    },
    {
      "id": "1670e29b-19bd-4c53-a61a-438c242ee96a",
      "text": "The Russian language is banned in Lviv, Ukraine.",
      "date": "2018-09-21 15:55:09"
    },
    {
      "id": "27728a69-61ad-4642-938c-0424e17198f4",
      "text": "The Pfizer bivalent COVID-19 vaccine causes strokes.",
      "date": "2023-01-18 00:00:00+00:00"
    },
    {
      "id": "e88bbca7-cf56-4326-9c99-dc1647945e93",
      "text": "China backs Russia's aggression in Crimea.",
      "date": "2014-03-04 12:26:32"
    },
    {
      "id": "a88ec512-6b19-40e8-9245-9b1926568095",
      "text": "Medicare data show COVID-19 vaccines increase the risk of death.",
      "date": "2023-02-26 00:00:00+00:00"
    },
    {
      "id": "a6bfff66-26b1-4884-9570-878a4a484542",
      "text": "Embalmers have observed that COVID-19 vaccines cause an increase in abnormal blood clots.",
      "date": "2022-02-11 00:00:00+00:00"
    },
    {
      "id": "f578eb5f-3c4e-4ed6-86ac-07c7f1346e70",
      "text": "Poland is pushing for the overthrow of Belarusian President Alexander Lukashenko at the European Union level.",
      "date": "2020-08-12 16:55:00"
    },
    {
      "id": "b60b2fd7-3a6c-4b1a-8bef-470c8fe13273",
      "text": "Wisdom teeth are meridian lines connected to the heart, and removing them causes heart problems.",
      "date": "2024-08-05 00:00:00+00:00"
    },
    {
      "id": "d541576e-5c2c-4375-9f5a-a1cbb11155f2",
      "text": "Mixing urine with salt determines whether a person is pregnant.",
      "date": "2024-05-23 00:00:00+00:00"
    },
    {
      "id": "31a46b11-b9d8-4184-9630-493ef7925f06",
      "text": "Eighteen proxy records show global temperatures were as warm or warmer 1,000 years ago.",
      "date": "2019-07-26 00:00:00+00:00"
    },
    {
      "id": "c2055234-7d19-4f2f-8f93-5a3d0367ee7e",
      "text": "OSCE confirmed 29 civilians were killed in Donbas in late January.",
      "date": "2015-02-03 15:00:34"
    },
    {
      "id": "903e1681-1758-4c3a-9728-9fa8fd825a8b",
      "text": "European countries cancel visa-free travel for Ukrainian travelers because of a measles epidemic in Ukraine.",
      "date": "2019-03-14 09:11:01"
    },
    {
      "id": "4d7b5e3d-682c-406e-84d1-1663d708b648",
      "text": "The Central Communication Port is being built to enable rapid transfer of US military forces.",
      "date": "2018-04-20 11:00:34"
    },
    {
      "id": "8170569f-1511-43b2-bdea-43d9e3bb8330",
      "text": "Increases in atmospheric CO2 are primarily caused by natural sources such as ocean outgassing, and human CO2 emissions are negligible in comparison.",
      "date": "2023-10-03 00:00:00+00:00"
    },
    {
      "id": "660e4a47-1d5a-494e-8c42-4a00f7ce4a2d",
      "text": "British military expert says Ukraine cannot retake Crimea.",
      "date": "2023-03-06 15:54:00"
    },
    {
      "id": "69c57963-6437-4eae-aabd-8176cc30e300",
      "text": "Polish TV used a map that showed neighboring Ukrainian regions as part of Poland.",
      "date": "2023-01-18 17:55:00"
    },
    {
      "id": "04b07b43-91de-492d-b415-f6ff34cb0803",
      "text": "Video shows people preparing body bags for an evening news clip during the COVID-19 pandemic.",
      "date": "2024-04-17 00:00:00+00:00"
    },
    {
      "id": "5d2831f7-834e-409c-8e9d-48f747d564ea",
      "text": "COVID-19 vaccines cause menstrual problems in women and vaccinated people cause health problems in unvaccinated people.",
      "date": "2021-04-11 00:00:00+00:00"
    },
    {
      "id": "cf81ea82-4981-46af-b78d-7d932f523a9a",
      "text": "A Russian strike caused a blackout in Odesa, and apocalyptic images from the blackout were shared online.",
      "date": "2025-12-13 00:00:00+00:00"
    },
    {
      "id": "da359d6c-2a80-4518-96d9-6bbaad187c00",
      "text": "Colostrum improves gut health and boosts immunity",
      "date": "2025-11-04 00:00:00+00:00"
    },
    {
      "id": "a9ee6543-ba8e-418a-a114-c3ac7cc71a12",
      "text": "The COVID-19 pandemic is a planned, staged pandemic created by PCR testing, not by the coronavirus.",
      "date": "2021-06-19 00:00:00+00:00"
    },
    {
      "id": "cf566c83-3925-4984-884d-925ab1e46541",
      "text": "A video shows an explosion at the Zhovti Vody uranium plant.",
      "date": "2015-09-05 18:37:45"
    },
    {
      "id": "0b3c6f5e-1e59-433f-90ac-0ec8710352ac",
      "text": "The world's largest EV charging station is powered exclusively by diesel generators.",
      "date": "2024-08-31 00:00:00+00:00"
    },
    {
      "id": "051a8eae-085f-42a9-9e38-77d1995dd83a",
      "text": "Hormonal birth control causes PCOS, hormonal imbalances, depression, and infertility.",
      "date": "2021-11-11 00:00:00+00:00"
    },
    {
      "id": "b38be4e2-e4d7-4855-be09-04a41de1d4a4",
      "text": "Studies prove geological forces, not atmospheric forces, are responsible for melting Earth's polar ice sheets.",
      "date": "2019-11-22 00:00:00+00:00"
    },
    {
      "id": "0fd4b274-a470-4ec8-941b-630f63142a34",
      "text": "Petro Poroshenko was drunk and removed from a Kyiv–Moscow flight.",
      "date": "2015-09-24 21:26:24"
    },
    {
      "id": "a70e8b59-7cfd-4220-bbf1-2c239ec82ce5",
      "text": "Trump criticized U.S. aid to Ukraine and called Ukraine impoverished.",
      "date": "2025-09-04 00:00:00+00:00"
    },
    {
      "id": "3d0c993b-38f6-4d18-976d-7c47411b31c3",
      "text": "A photosynthesis study shows Earth is not warming as predicted by climate models.",
      "date": "2023-01-12 00:00:00+00:00"
    },
    {
      "id": "5878fdea-e073-45e4-8f36-4da02f629c97",
      "text": "Dr. Robert Malone invented mRNA vaccines.",
      "date": "2021-08-26 00:00:00+00:00"
    },
    {
      "id": "70200cb1-3041-48a7-9e28-2cae2ee138c8",
      "text": "Ukrainians called Russian children to stage a gas attack hoax.",
      "date": "2023-01-22 16:47:00"
    },
    {
      "id": "da329360-2d3e-4b50-b7b3-6cce8f1aa433",
      "text": "Birth control causes a far greater risk of blood clots than any COVID-19 vaccine.",
      "date": "2021-04-13 00:00:00+00:00"
    },
    {
      "id": "ac802fe2-63ab-4c69-9886-f5a4d7657337",
      "text": "Eating specific foods based on your blood type optimizes your health.",
      "date": "2024-07-07 00:00:00+00:00"
    },
    {
      "id": "0b25b952-b8db-416d-8697-ee70e792870c",
      "text": "Ukrainian refugees broke Van Gogh's chair in a museum.",
      "date": "2025-06-15 00:00:00+00:00"
    },
    {
      "id": "af1aad82-b277-4834-9f9c-1ab8d24f2d7e",
      "text": "Brigitte Macron's personal doctor was found dead in Paris and planned to reveal the First Lady's secret to the press.",
      "date": "2025-07-01 00:00:00+00:00"
    },
    {
      "id": "1ba8d895-5f78-4f0b-bd05-4d1641e4ce5d",
      "text": "Pathogens do not initiate disease; an acidic, compromised cellular terrain initiates disease and pathogens only appear as a result.",
      "date": "2020-03-25 00:00:00+00:00"
    },
    {
      "id": "d1ba53b6-47f9-4280-9fc0-fd09d18c4fc2",
      "text": "\"Vatnik\" renounced Ukrainian citizenship.",
      "date": "2015-04-23 16:05:15"
    },
    {
      "id": "ceed53ab-4e93-475a-986c-3a214d121952",
      "text": "Dr. Anthony Fauci's 2004 interview remarks about the flu vaccine prove that natural immunity is the best protection against COVID-19.",
      "date": "2022-04-01 00:00:00+00:00"
    },
    {
      "id": "36097c8c-85b0-431e-bd33-a9103b04ef79",
      "text": "A photo of shelling in Israel is presented as showing shelling in Donetsk.",
      "date": "2015-08-30 18:31:43"
    },
    {
      "id": "72127d66-fd32-491d-87df-078b95146b02",
      "text": "The Hague Tribunal will investigate Ukrainian crimes in Donbas.",
      "date": "2020-12-18 17:54:55"
    },
    {
      "id": "35864078-cc2c-41ff-88aa-8e1e32ed9739",
      "text": "More babies die from abortion in two days than have died from coronavirus so far.",
      "date": "2020-09-30 00:00:00+00:00"
    },
    {
      "id": "483f9100-c4ca-4586-ba84-682f095310ad",
      "text": "The European Court refused to return Crimea to Ukraine.",
      "date": "2014-06-09 20:33:45"
    },
    {
      "id": "ece9466a-65bf-4d30-926e-70674b63d79c",
      "text": "Arseniy Yatsenyuk and Oleksandr Turchynov were booed and whistled at the Eternal Flame in Kyiv.",
      "date": "2014-05-10 17:14:53"
    },
    {
      "id": "73181885-0295-4b62-8463-85f7ebaa38d5",
      "text": "Exipure is scientifically proven to cause weight loss; BPS-5 effectively reduces blood pressure.",
      "date": "2022-05-19 00:00:00+00:00"
    },
    {
      "id": "fc3e0635-9b91-40ff-87d2-363a6d9ac2f0",
      "text": "Drunken US mercenaries rampaged through Mariupol.",
      "date": "2016-01-09 21:27:01"
    },
    {
      "id": "6212f3e0-6ac0-4064-9593-a4457754360f",
      "text": "Petro Poroshenko calls for ending sanctions against Russia.",
      "date": "2017-02-06 22:56:06"
    },
    {
      "id": "029d7549-48b7-4bf3-a6fb-f63d4e907818",
      "text": "Scores of Ukrainian stars performed in Russia.",
      "date": "2017-07-10 15:55:44"
    },
    {
      "id": "4be3f643-2aa0-4579-98ca-14d97784ea1a",
      "text": "Berkut commandos who refused to kneel were burned alive in Lviv, Ukraine.",
      "date": "2014-03-26 10:38:09"
    },
    {
      "id": "4227afee-e3b9-478c-ab36-4fde24ad8ff0",
      "text": "COVID-19 deaths were vastly overcounted.",
      "date": "2022-10-03 00:00:00+00:00"
    },
    {
      "id": "3b9d9666-2869-4df3-9b66-779b29564f56",
      "text": "COVID-19 vaccine recipients are ineligible to donate blood.",
      "date": "2024-02-23 00:00:00+00:00"
    },
    {
      "id": "17279c2a-f5dd-468e-a0a7-b2b33e72993e",
      "text": "Carbon dioxide does not control the climate.",
      "date": "2022-08-30 00:00:00+00:00"
    },
    {
      "id": "ffea4765-c803-4d76-adcb-556ad0a86333",
      "text": "82% of women who received the COVID-19 vaccine between 30 days and 20 weeks of pregnancy had miscarriages.",
      "date": "2021-07-06 00:00:00+00:00"
    },
    {
      "id": "62670d51-2419-4ae6-9c54-f93a58e21695",
      "text": "People who receive a vaccine under Emergency Use Authorization cannot sue vaccine manufacturers; after full approval they can sue, unless the vaccine is recommended for children, in which case they cannot sue.",
      "date": "2021-12-22 00:00:00+00:00"
    },
    {
      "id": "5628795e-a7c7-44b0-ac00-289259aa71d5",
      "text": "NATO is preparing for war with Russia.",
      "date": "2019-12-28 22:12:59"
    },
    {
      "id": "9134b5dd-9cec-45cb-a37a-823fcc4afdca",
      "text": "The vaccine causes death in 33% of people, while the virus causes death in 0.06% of people.",
      "date": "2020-08-15 00:00:00+00:00"
    },
    {
      "id": "c4c0a228-b520-4446-9ced-f9600e63b724",
      "text": "Vaccines, an MTHFR genetic mutation, and glyphosate exposure cause autism in children with brain injuries.",
      "date": "2023-11-23 00:00:00+00:00"
    },
    {
      "id": "52270120-a27d-4e6b-8201-b95d76e61a23",
      "text": "Ukrainian men in Germany are recruited into Ukraine's armed forces in exchange for German citizenship.",
      "date": "2024-04-19 20:31:00"
    },
    {
      "id": "b8b249d9-68ba-4bc6-8783-fc55db74b4c2",
      "text": "A Ukrainian deputy minister called for using the Ukrainian army to retake Crimea.",
      "date": "2018-10-25 10:22:39"
    },
    {
      "id": "2e35d598-1ead-4cc9-b263-0f8e9b46350c",
      "text": "Ukraine's credit rating has fallen.",
      "date": "2017-05-03 11:25:26"
    },
    {
      "id": "5562da73-c4f7-47a9-913d-2c215d69d25f",
      "text": "The American Journal of Medicine admits it was wrong about hydroxychloroquine and published evidence that hydroxychloroquine prevents COVID-19.",
      "date": "2021-03-02 00:00:00+00:00"
    },
    {
      "id": "c85c2b54-faa7-4ad6-a66a-50cb0e2adde2",
      "text": "Pope Francis congratulates Vladimir Putin on his presidential election victory.",
      "date": "2024-03-21 17:51:54"
    },
    {
      "id": "1dad3c34-9c46-4fae-b996-8d36deac0c7d",
      "text": "Ukrainian food prices are equal to EU food prices.",
      "date": "2018-02-22 14:32:53"
    },
    {
      "id": "ed43efaa-4059-4449-a36f-e665653f8a9a",
      "text": "Russia is depriving Ukraine of water from the Dnipro River by cutting off the river upstream.",
      "date": "2020-10-30 12:45:40"
    },
    {
      "id": "2d283ea9-3c37-44f9-a526-ca0bf56a29a2",
      "text": "Raw thermometer data show the US cooled for 80 to 90 years, and official temperature graphs were altered to falsely show warming.",
      "date": "2019-07-20 00:00:00+00:00"
    },
    {
      "id": "6bcefa92-a75c-4f2c-b084-e57272699893",
      "text": "The Red Cross has ceased operations in Ukraine.",
      "date": "2022-10-10 18:16:50"
    },
    {
      "id": "7034a168-c32c-46c5-97d5-7011a7e583e4",
      "text": "One vaccine injury occurs for every 39 vaccine doses administered.",
      "date": "2019-10-10 00:00:00+00:00"
    },
    {
      "id": "e95e4e59-1c46-4d1d-a26e-f51adfada1dc",
      "text": "Rising atmospheric CO2 has slightly cooled the planet.",
      "date": "2020-02-18 00:00:00+00:00"
    },
    {
      "id": "1bd00c6c-59cd-4387-a54b-b32f98e0f725",
      "text": "Ukrainian soldiers rejected a patriotic greeting.",
      "date": "2018-02-13 14:42:35"
    },
    {
      "id": "147d519f-3a24-41c8-93ae-b6104a3af9aa",
      "text": "The Ukrainian military violates the ceasefire most.",
      "date": "2019-09-14 11:58:03"
    },
    {
      "id": "3508161d-b09c-4ca1-b358-f8f40784f430",
      "text": "Alzheimer’s disease did not exist 40 years ago; cholesterol-lowering drugs and cholesterol-reducing diets cause Alzheimer’s disease.",
      "date": "2023-03-11 00:00:00+00:00"
    },
    {
      "id": "6cb08a1b-cb67-4b66-9997-d0d027691a7d",
      "text": "The Red Cross says people who received a COVID-19 vaccine cannot donate convalescent plasma because the vaccine destroys SARS-CoV-2 antibodies.",
      "date": "2021-09-20 00:00:00+00:00"
    },
    {
      "id": "d0c64c05-1611-406c-997b-2bcaddb144c5",
      "text": "COVID-19 infection fatality rate (IFR) is 0.1% to 0.3% and COVID-19 is as lethal as severe influenza.",
      "date": "2020-08-26 00:00:00+00:00"
    },
    {
      "id": "d325b518-52fc-414b-a998-6a1c6cee814c",
      "text": "Conscription notices are being handed out at voting stations.",
      "date": "2019-03-31 14:01:50"
    },
    {
      "id": "61cdd9bb-d06d-4548-bf22-2ac0469d141d",
      "text": "Zaporizhzhia City Council rejected the Ukrainian language.",
      "date": "2016-02-04 16:00:36"
    },
    {
      "id": "2d0a4efb-49ce-4c42-9c72-09386900102c",
      "text": "The governor of Kherson Oblast said that Hitler was justified.",
      "date": "2014-05-10 17:49:43"
    },
    {
      "id": "81ded9b1-7e19-4e85-a496-51915d145a74",
      "text": "Denmark asked Ukraine to return military aid.",
      "date": "2026-01-10 00:00:00+00:00"
    },
    {
      "id": "cf74c828-a854-4b1d-b0ff-41334ff95896",
      "text": "ICC arrest warrants for Russian military leaders have had no consequences.",
      "date": "2024-03-08 12:46:00"
    },
    {
      "id": "9a821e6d-27d9-4ef5-8b63-5522dba4f695",
      "text": "The Russian military captured Mariupol in less than one hour and the Ukrainian army was completely incompetent.",
      "date": "2022-03-03 12:00:00"
    },
    {
      "id": "0c1583a0-e152-4d85-a208-4c1a7350543c",
      "text": "Vitamin B17 was banned by the United States because it kills cancer cells.",
      "date": "2023-10-03 00:00:00+00:00"
    },
    {
      "id": "ffe40741-bfba-408b-80dc-6d4c93a3476b",
      "text": "The Ukrainian government refuses to evacuate its citizens from Israel.",
      "date": "2023-10-11 11:55:00"
    },
    {
      "id": "a2a1873a-cb7f-4eea-b881-7962bae1b5e2",
      "text": "An Italian restaurant advertises a \"Diablo Zelensky\" pizza topped with the bodies of Ukrainian soldiers.",
      "date": "2024-04-17 09:56:00"
    },
    {
      "id": "c04ab974-f5a6-4674-9617-93b3a84224ad",
      "text": "Vaccines contain toxic aluminum and mercury",
      "date": "2022-03-09 00:00:00+00:00"
    },
    {
      "id": "7ca392ad-9d19-4328-ac1c-38ebd5d5ff79",
      "text": "Climate scientists say aspects of Hurricane Harvey show that global warming made the storm worse.",
      "date": "2017-08-29 00:00:00+00:00"
    },
    {
      "id": "fa69523a-2b83-4e43-8a72-b11ce2258253",
      "text": "Vaccines cause autism.",
      "date": "2020-03-05 00:00:00+00:00"
    },
    {
      "id": "b41a3136-a2a6-4ce4-aadb-8c179bf11bf1",
      "text": "COVID-19 vaccines were rushed to market; VAERS shows an unusual spike in vaccine adverse events; unvaccinated people are not a threat to vaccinated people.",
      "date": "2022-08-10 00:00:00+00:00"
    },
    {
      "id": "0c8c8f99-e607-41e7-947f-ad2fc3b0e67a",
      "text": "Ivermectin and mebendazole are effective treatments for cancer.",
      "date": "2024-10-13 00:00:00+00:00"
    },
    {
      "id": "95a7d096-c622-46dd-9590-b080e9861d12",
      "text": "Charlie Hebdo ridiculed Ukrainian fencer Olha Kharlan.",
      "date": "2023-07-31 10:26:14"
    },
    {
      "id": "b5b85d0e-e9b3-4a75-9ffb-e456c3336ec0",
      "text": "A pro-Russia mass rally occurred in the United States.",
      "date": "2016-06-15 22:13:58"
    },
    {
      "id": "7ae4bce7-e6cf-4723-b7da-3c62d70ebaa6",
      "text": "A NATO brigade arrived in Donbas.",
      "date": "2018-12-10 14:13:43"
    },
    {
      "id": "619baab4-41a4-48c7-b3f9-7fdbfc3cd7a0",
      "text": "Ocean acidification does not harm marine life.",
      "date": "2016-04-30 00:00:00+00:00"
    },
    {
      "id": "521328fb-fec8-45c2-8804-3961edd8a930",
      "text": "The Ukrainian government in Kyiv forbids citizens from keeping in touch with Ukrainians in the temporarily occupied territories.",
      "date": "2023-10-17 17:01:00"
    },
    {
      "id": "487d5ad2-aa34-46dc-91dd-b7dac83edd06",
      "text": "Ukrainian saboteurs were intercepted in Luhansk.",
      "date": "2017-11-24 10:43:22"
    },
    {
      "id": "02822320-cd99-4d29-9bf9-f058f84e00bd",
      "text": "The United States banned vitamin B17 because it kills cancer cells.",
      "date": "2023-03-01 00:00:00+00:00"
    },
    {
      "id": "bb40c0b2-397b-4ba4-a644-11c4285e3229",
      "text": "Mammograms cause cancer.",
      "date": "2024-05-31 00:00:00+00:00"
    },
    {
      "id": "a3132792-ed94-47b6-879b-3555eb8e2014",
      "text": "COVID-19 vaccines weaken the immune system and caused a 20-fold increase in cancer in vaccinated patients, an Idaho doctor reported.",
      "date": "2021-09-27 00:00:00+00:00"
    },
    {
      "id": "feb9f397-7bc5-44bd-aa8f-04394b7447f4",
      "text": "Ukraine will blow up 550 tons of ammonia in Novotroitske.",
      "date": "2025-07-17 00:00:00+00:00"
    },
    {
      "id": "fe5053f4-21b7-492d-9e91-012a110d99b6",
      "text": "500 Ukrainian security officers block Kiev Street.",
      "date": "2015-03-19 21:53:50"
    },
    {
      "id": "c500b931-6581-40b0-8b04-bbaad04970c7",
      "text": "The Ukrainian army shelled Donetsk.",
      "date": "2015-07-23 19:29:59"
    },
    {
      "id": "ab7fc75d-0dd5-476c-baac-dbac6bb06edb",
      "text": "A new study shows mRNA from COVID-19 vaccines is present in breast milk and is dangerous to infants.",
      "date": "2023-09-22 00:00:00+00:00"
    },
    {
      "id": "12228c9e-42ba-4dc3-86c1-e440002f2e43",
      "text": "Ukrainian Right Sector radicals attacked peaceful Russian civilians in Athens.",
      "date": "2018-02-17 14:25:19"
    },
    {
      "id": "f5dd556e-d81a-422c-a1df-38d595b542fa",
      "text": "The IPCC concedes there has been no increase in extreme weather events.",
      "date": "2017-10-08 00:00:00+00:00"
    },
    {
      "id": "a69c3605-cb8c-4cc4-af1a-49a5fd1ec2e3",
      "text": "The EU provides financial aid to Ukraine in exchange for migrants.",
      "date": "2018-07-03 13:39:20"
    },
    {
      "id": "1860282a-df94-40d6-aefa-d33a780e797e",
      "text": "The United States will pay reparations to Ukraine.",
      "date": "2023-06-26 10:17:00"
    },
    {
      "id": "75781163-5d59-4792-a3e9-6565f8963430",
      "text": "Natural immunity to COVID-19 persists for decades; pregnant women are not at risk from COVID-19; COVID-19 vaccines contain DNA plasmids; COVID-19 boosters are unsafe.",
      "date": "2023-08-29 00:00:00+00:00"
    },
    {
      "id": "2994c2c0-f0d0-4e0b-9ece-0a4cdb450145",
      "text": "Receiving more COVID-19 vaccine doses increases your risk of getting COVID-19, and COVID-19 vaccines contain DNA fragments that modify your genome and cause cancer.",
      "date": "2023-03-11 00:00:00+00:00"
    },
    {
      "id": "7200c0eb-fa7a-4eec-b545-f33baa33b876",
      "text": "Ukraine lost 50% of its GDP due to sanctions related to Russia.",
      "date": "2018-02-06 14:55:17"
    },
    {
      "id": "8f562a60-4720-4b12-bf8e-97447354a6b4",
      "text": "The United States banned 155 imports from Ukraine because of Ukraine's political situation.",
      "date": "2018-05-10 15:15:23"
    },
    {
      "id": "9d71426d-92dc-4461-8d66-7cb7700cf2cf",
      "text": "The son of a German tankman donated a World War II tank to Ukraine.",
      "date": "2014-10-04 08:19:01"
    },
    {
      "id": "e79b7f1e-c540-48f9-99a0-eb9f272ff2a7",
      "text": "COVID-19 vaccines cause autism in rats.",
      "date": "2024-01-18 00:00:00+00:00"
    },
    {
      "id": "08570a75-8b33-4e1e-90f0-ccc77c0eedee",
      "text": "Ukrainian paratroopers infected fellow Ukrainian soldiers after training in Western Ukraine.",
      "date": "2020-11-25 15:00:37"
    },
    {
      "id": "62df3fdc-6f66-41ed-a406-3be29d71c41a",
      "text": "COVID-19 mRNA vaccines do not work and are causing serious harm, including death.",
      "date": "2023-09-02 00:00:00+00:00"
    },
    {
      "id": "99c2d825-ffe1-40dc-9c1e-e1013924648c",
      "text": "RSV vaccines cause deaths and neurological disorders, and the CDC covered up reports of deaths among vaccinated individuals.",
      "date": "2024-03-14 00:00:00+00:00"
    },
    {
      "id": "4dd9f52f-d8e8-4544-9e2c-b1bb11889b2a",
      "text": "Ukraine disrupted NATO's Sea Breeze naval exercises.",
      "date": "2016-07-21 22:04:03"
    },
    {
      "id": "f027e67c-47bf-4105-881f-4d217b3544c9",
      "text": "Huge numbers of Ukrainians hate the Kyiv regime.",
      "date": "2022-09-07 15:15:00"
    },
    {
      "id": "629f13af-3980-4d8c-bddd-b43cd3168dd4",
      "text": "The World Trade Organization forced Ukraine to buy Russian fertilizer.",
      "date": "2020-04-17 07:26:19"
    },
    {
      "id": "3a64efca-f394-4b04-8fd4-e08edd670201",
      "text": "More than 200,000 people died due to the COVID-19 vaccine.",
      "date": "2023-03-02 00:00:00+00:00"
    },
    {
      "id": "9f9e5b15-68b3-4929-ae84-37177d1d515b",
      "text": "Ukraine is Europe’s poorest country.",
      "date": "2017-12-21 12:25:55"
    },
    {
      "id": "d1bc893f-3614-4a43-a75d-205bd1a7adcc",
      "text": "Ukrainian military refused to help a teenager injured by an explosive device.",
      "date": "2021-01-20 15:51:53"
    },
    {
      "id": "4d412db5-fc61-4fa9-81b0-e9bc9d2d50b1",
      "text": "A TIME employee posted a magazine cover showing Vladimir Putin labeled \"Man of the Year\"",
      "date": "2014-12-05 15:50:53"
    },
    {
      "id": "fd30fa9d-5404-4600-a306-94fa14b3f60f",
      "text": "Ukrainian women impregnated by Russian soldiers are forced to have abortions.",
      "date": "2023-12-19 10:10:00"
    },
    {
      "id": "a4b251cd-8f24-4aab-8d8e-a919692a5b87",
      "text": "Arms supplies to Ukraine are lost and unaccounted for.",
      "date": "2022-08-23 16:32:51"
    },
    {
      "id": "2a34535b-7f20-42f9-a107-9b2729dfb4aa",
      "text": "COVID-19 vaccination increases the risk of myocarditis in young adults by 800 times compared with being unvaccinated.",
      "date": "2022-10-29 00:00:00+00:00"
    },
    {
      "id": "c980a339-5089-4aea-b722-8818f6df5b36",
      "text": "The majority of Ukrainians are waiting for Russia to rescue them.",
      "date": "2022-04-20 12:11:00"
    },
    {
      "id": "1d9c6663-ae5a-4d9f-a856-e523287304a5",
      "text": "Unvaccinated Amish do not get cancer, autism, or heart disease.",
      "date": "2020-05-20 00:00:00+00:00"
    },
    {
      "id": "8bb31240-1aee-45d9-9cbe-f51c9c7aaeae",
      "text": "Russian troops destroyed an oil depot in Syria.",
      "date": "2015-12-05 20:39:49"
    },
    {
      "id": "1a4fd326-341e-417a-b590-42a241e07a85",
      "text": "A majority of Europeans oppose new sanctions on Russia.",
      "date": "2022-08-10 15:47:00"
    },
    {
      "id": "ba5e3a7c-42f8-4a47-9032-4c310b28c369",
      "text": "The increase in solar activity during the twentieth century accounts for 50% to 66% of all climate change.",
      "date": "2019-08-11 00:00:00+00:00"
    },
    {
      "id": "eeced08d-688c-409e-a85d-20f0a611f2bc",
      "text": "A majority of Ukrainians oppose both the Ukrainian Army and President Volodymyr Zelensky's war in Donbas.",
      "date": "2021-07-07 20:49:09"
    },
    {
      "id": "b3724cba-b469-4f18-9cbe-c5a8feb6e61b",
      "text": "Benzene in benzoyl peroxide-containing skincare products causes cancer.",
      "date": "2024-03-14 00:00:00+00:00"
    },
    {
      "id": "432b9133-94d2-41a0-bb39-3fb754586948",
      "text": "Ukraine's currency has collapsed due to the Turkey crisis, IMF actions, and the collapse of the National Bank of Ukraine.",
      "date": "2018-08-21 18:09:14"
    },
    {
      "id": "3bc8538e-2a63-4a8e-b482-f2312ef30972",
      "text": "Germany has stopped supplying weapons to Ukraine",
      "date": "2022-03-22 12:12:06"
    },
    {
      "id": "db74244d-4130-44b3-a3be-416717218122",
      "text": "Switzerland abolishes refugee status for Ukrainians",
      "date": "2025-06-21 00:00:00+00:00"
    },
    {
      "id": "eba77011-2a84-495d-a255-b0a33266a65b",
      "text": "Ukrainian National Guard soldiers are throwing the bodies of killed men.",
      "date": "2014-05-05 14:43:36"
    },
    {
      "id": "e4a1ef12-8a66-4e6b-972b-df2ae81e6f7d",
      "text": "A Ukrainian crowd beat a Russian boy to death in Germany.",
      "date": "2022-03-21 16:29:30"
    },
    {
      "id": "b015f81f-6b59-4434-a79a-66d9ba97c4b3",
      "text": "An autoimmune condition is the number one indicator of parasite infection.",
      "date": "2023-06-23 00:00:00+00:00"
    },
    {
      "id": "18fafe7f-080f-4e66-9efb-f04c0f9fcb2e",
      "text": "Cultivated meat is made from cancerous and precancerous cells.",
      "date": "2023-07-15 00:00:00+00:00"
    },
    {
      "id": "885f411a-bf81-49ec-b44c-6940e82f3240",
      "text": "Russian language is being suppressed in Ukraine.",
      "date": "2018-01-29 20:19:19"
    },
    {
      "id": "9743b311-cafb-4cfd-8609-7c80f2ff9d89",
      "text": "The ozone layer is healing.",
      "date": "2020-03-26 00:00:00+00:00"
    },
    {
      "id": "b9a81b1d-f10a-4dcc-9fe4-d39ef8898b5f",
      "text": "The Ukrainian military suffered losses in eastern Ukraine.",
      "date": "2018-05-17 10:39:37"
    },
    {
      "id": "cd1059a4-0e64-48b1-8826-fcf1496bab8a",
      "text": "Ukrainian sailors threatened to return to Crimea.",
      "date": "2018-04-21 11:19:30"
    },
    {
      "id": "20d51616-8577-4377-ac82-80c75ed27783",
      "text": "Atmospheric CO2 concentration is not correlated with global temperatures.",
      "date": "2025-03-18 00:00:00+00:00"
    },
    {
      "id": "e5f5da0c-a863-47e1-a6d1-56961623cf7b",
      "text": "The European Parliament accuses Ukraine of committing Soviet crimes.",
      "date": "2019-10-18 11:09:14"
    },
    {
      "id": "efa9739d-2b3c-43b3-985b-ccda54d8a4fe",
      "text": "Ukraine will classify residents of Crimea and Donbas as terrorists.",
      "date": "2017-04-05 02:29:58"
    },
    {
      "id": "dde2b01d-d592-470e-bbc4-b54f19560170",
      "text": "Vitamin D3 is irradiated sheep’s wool mixed with chloroform and is rat poison; low vitamin D levels are caused by lack of sunlight and high vitamin A diets.",
      "date": "2024-08-22 00:00:00+00:00"
    },
    {
      "id": "02f967fe-336b-4f09-8746-3cbc504bfd90",
      "text": "Sunscreens and sunless tanning products cause cancer and contain cancer-causing ingredients, and the sun does not cause cancer.",
      "date": "2022-09-04 00:00:00+00:00"
    },
    {
      "id": "a1defc99-37ef-4f95-b417-6ff608a4c6e3",
      "text": "Ukraine will lose several regions to Russia.",
      "date": "2020-05-18 18:55:24"
    },
    {
      "id": "308308e1-766a-4770-bf8b-7e2599a012d9",
      "text": "There has been no excess mortality from COVID; lockdowns do not prevent the spread of COVID; masks do not work to prevent transmission; PCR tests were not designed to diagnose illness.",
      "date": "2021-09-22 00:00:00+00:00"
    },
    {
      "id": "ab930dd7-1c58-49f1-888a-3ccb43f3e76f",
      "text": "A Ukrainian serviceman was sent to Avdiyivka to be killed for posting a TikTok.",
      "date": "2023-12-19 12:31:00"
    },
    {
      "id": "8344aced-aaf9-4585-8b7a-4ef53a11ef4b",
      "text": "A separatist was buried alive in Ukraine.",
      "date": "2016-06-23 18:28:15"
    },
    {
      "id": "9de16975-a6f2-492e-886a-e269c2d474dc",
      "text": "Vaccines caused autism to increase from 1 in 10,000 to 1 in 50.",
      "date": "2013-04-07 00:00:00+00:00"
    },
    {
      "id": "05e621ba-ae52-4afa-9b17-06cbf18f9681",
      "text": "U.S. regions with higher average COVID-19 vaccine doses had larger increases in mortality in 2022 than in 2021.",
      "date": "2023-03-14 00:00:00+00:00"
    },
    {
      "id": "6196be98-1cd7-4397-8565-f5ba5461fded",
      "text": "Medical exemptions are unavailable for people with contraindications to the COVID-19 vaccine, including those with a history of blood clotting or prior adverse reactions to vaccines.",
      "date": "2022-12-22 00:00:00+00:00"
    },
    {
      "id": "39744d7d-3fbf-4158-9ebf-d7a34bd509b3",
      "text": "Normalised Diatomaceous earth contains silica that absorbs minerals, water, and vitamins, and diatomaceous earth is antiparasitic and detoxes the body.",
      "date": "2024-10-12 00:00:00+00:00"
    },
    {
      "id": "d2746d11-47fa-4951-baac-d714323e7a24",
      "text": "Vaccines caused an explosion in childhood cancer, and vaccine package inserts state vaccines were not tested for mutagenic effects.",
      "date": "2024-01-19 00:00:00+00:00"
    },
    {
      "id": "8f21e90b-1a0f-4031-bfce-d0e4f75835aa",
      "text": "President Poroshenko’s confectionery company is opening new branches in Russia.",
      "date": "2017-09-27 10:27:51"
    },
    {
      "id": "01508c85-b479-4298-b689-24d128545f43",
      "text": "A survey found that the majority of Ukrainians liked living in the USSR.",
      "date": "2020-05-19 11:55:00"
    },
    {
      "id": "0f5cc466-f266-46f0-bb36-c4c140c7386e",
      "text": "Oleg Sentsov has a star on the Hollywood Walk of Fame.",
      "date": "2018-09-01 09:04:00"
    },
    {
      "id": "b25d83b5-974d-4e6b-9335-6426f9c6b6bc",
      "text": "COVID-19 vaccines caused over 4,000 deaths; COVID-19 survivors cannot be reinfected and do not need vaccination; natural immunity is stronger than vaccine immunity; vaccine-produced spike protein is dangerous.",
      "date": "2021-05-19 00:00:00+00:00"
    },
    {
      "id": "ff96108d-4f5c-4d0d-beef-451db8a86aa7",
      "text": "The Earth has cooled continuously for 4,000 years and is cooler now than during the Medieval Warm Period; reported recent warming is only an artifact of the measurement start date.",
      "date": "2023-05-15 00:00:00+00:00"
    },
    {
      "id": "28b2429a-0096-4d7a-948d-059fa77fc5c9",
      "text": "The Russian flag was burned in Belarus.",
      "date": "2015-02-27 10:43:39"
    },
    {
      "id": "56f90ee6-1209-4b41-abc3-e377d4df66b2",
      "text": "Patents for weather-modification technologies prove that HAARP and NEXRAD are used to manipulate hurricanes.",
      "date": "2024-10-11 00:00:00+00:00"
    },
    {
      "id": "21b59191-bead-4584-9277-0995dc1dd492",
      "text": "The European Parliament says Kyiv cannot pay off its debts.",
      "date": "2022-07-08 13:56:49"
    },
    {
      "id": "d94c0bdd-38a8-4849-8dda-6b5e0a842602",
      "text": "The United States is preparing a new revolution in Ukraine.",
      "date": "2018-01-13 22:44:57"
    },
    {
      "id": "8bacacff-aa61-4eac-b5ae-410a1358b09f",
      "text": "Kyiv is blackmailing the West over Crimea.",
      "date": "2020-06-07 09:39:32"
    },
    {
      "id": "62e384e2-a7d6-4f5d-baaf-5e1405aaf635",
      "text": "In the United States, doctors kill six times as many people as guns do.",
      "date": "2022-06-13 00:00:00+00:00"
    },
    {
      "id": "350050bd-a85a-4627-9297-e06afeb9261c",
      "text": "Leaky COVID-19 vaccines are causing SARS-CoV-2 to evolve rapidly; COVID-19 vaccines do not prevent disease or death; childhood vaccines are unsafe.",
      "date": "2023-09-07 00:00:00+00:00"
    },
    {
      "id": "2fd3b2a3-f58c-4367-bcd2-a0ab907918e8",
      "text": "Kirovograd residents overwhelmingly prefer the city's tsarist-era name.",
      "date": "2016-07-22 09:42:30"
    },
    {
      "id": "14cb414f-ab88-4bba-a113-ee4dd72a7f1c",
      "text": "Pfizer documents prove mRNA COVID-19 vaccines contain graphene oxide.",
      "date": "2023-07-15 00:00:00+00:00"
    },
    {
      "id": "b8d41819-464f-472d-85d4-4d8825b72dc8",
      "text": "Petro Poroshenko allows Ukrainian civilians to legally possess and carry firearms.",
      "date": "2015-05-27 15:53:57"
    },
    {
      "id": "28a9e1c3-f6b7-4263-a28e-da682072bcbf",
      "text": "A Ukrainian general admitted that Ukraine's professional army has been knocked out.",
      "date": "2023-04-28 10:54:00"
    },
    {
      "id": "561143dc-b82e-4c1b-972e-0d27441965bd",
      "text": "Data centers cannot run entirely on renewable energy.",
      "date": "2025-07-15 00:00:00+00:00"
    },
    {
      "id": "bfa609f9-2ee5-4041-9ead-29eb12891c57",
      "text": "Great Barrier Reef sea surface temperatures have not changed in the past 150 years.",
      "date": "2021-08-28 00:00:00+00:00"
    },
    {
      "id": "e7eca5a0-30d0-431d-b66f-c8a1d6599ee5",
      "text": "SARS was developed by humans and weaponized to attack human beings.",
      "date": "2023-05-03 00:00:00+00:00"
    },
    {
      "id": "3b3f6b3c-9e02-41b0-8583-5212dd3b4f6f",
      "text": "There was no unusual excess mortality from COVID; lockdowns did not prevent disease spread; masks did not work to prevent spread; PCR tests were not designed to diagnose illness.",
      "date": "2021-04-10 00:00:00+00:00"
    },
    {
      "id": "3065442a-14b1-4449-b727-0b1cd300dd7c",
      "text": "COVID-19 vaccines were rushed to market; VAERS shows an unusual spike in vaccine adverse events; unvaccinated people do not pose a threat to vaccinated people.",
      "date": "2022-10-04 00:00:00+00:00"
    },
    {
      "id": "bacee7fe-c702-44a9-b89e-4b1a69c6b672",
      "text": "Data from 145 countries shows that COVID-19 vaccines cause increases in COVID-19 cases and deaths.",
      "date": "2022-12-01 00:00:00+00:00"
    },
    {
      "id": "82edf1b2-9625-43b0-b7fc-50b60fd2bbef",
      "text": "Raising more cows and eating more beef will save the planet because cows are carbon‑negative.",
      "date": "2025-12-27 00:00:00+00:00"
    },
    {
      "id": "ded4eeef-c183-4ccc-8be3-7998293de30b",
      "text": "A video shows American trainers teaching Ukrainian military personnel how to use an FGM-148 Javelin missile system.",
      "date": "2015-01-09 13:29:53"
    },
    {
      "id": "bbcd424c-29ad-4d41-adb4-c97781a4b967",
      "text": "Ukraine lost 234 planes and 137 helicopters since the war began.",
      "date": "2022-07-07 13:41:00"
    },
    {
      "id": "132f6cc9-f538-4c83-9617-8e62245449fd",
      "text": "Cow burps cause more damage to the climate than all cars on Earth.",
      "date": "2019-02-21 00:00:00+00:00"
    },
    {
      "id": "2581b35a-6fe9-496f-8afb-21345fa2a8dd",
      "text": "mRNA vaccines force children’s bodies to produce toxic spike proteins that often cause permanent damage to children’s vital organs, and vaccinating children provides no benefit to them or their families.",
      "date": "2021-12-20 00:00:00+00:00"
    },
    {
      "id": "52519e4a-6c58-4d1b-89f7-04d1a7410ce5",
      "text": "Natural immunity provides stronger protection than vaccine-induced immunity, and public health authorities lied when they said it was not better.",
      "date": "2023-02-17 00:00:00+00:00"
    },
    {
      "id": "54fa8502-66e3-4d23-bee4-4544f015286d",
      "text": "Gas station owners are refusing to lower fuel prices.",
      "date": "2016-01-18 16:50:34"
    },
    {
      "id": "d31ecd38-9b36-4434-b556-2ed92e43b61f",
      "text": "More than 100% of the warming over the past century was caused by human actions.",
      "date": "2017-03-08 00:00:00+00:00"
    },
    {
      "id": "85ce5b6f-3f89-426a-b5a2-8d84eb7699e1",
      "text": "The Kerch Strait incidents were a Ukrainian provocation.",
      "date": "2019-05-29 09:40:32"
    },
    {
      "id": "1e126e36-eb40-4d99-8d99-4a44eb746256",
      "text": "A study showed COVID-19 vaccines are more dangerous than COVID-19; children aged 12–17 are more likely to be hospitalized for myocarditis caused by the vaccine than for COVID-19.",
      "date": "2021-12-15 00:00:00+00:00"
    },
    {
      "id": "0382d146-798c-4e98-bf90-fba4cf45a308",
      "text": "Moscow Patriarchate priests were removed from President Volodymyr Zelensky's office after a false alarm.",
      "date": "2023-03-21 09:50:00"
    },
    {
      "id": "65250e2b-f109-4e43-b765-be530433a66a",
      "text": "Methane from cows is a small share of total greenhouse gas emissions, would be produced without cattle, and is not an important contributor to climate change.",
      "date": "2024-09-01 00:00:00+00:00"
    },
    {
      "id": "b4a3e4f3-ace9-4d63-95ba-a78ebe688191",
      "text": "Garlic is 100 times more effective than antibiotics.",
      "date": "2020-02-17 00:00:00+00:00"
    },
    {
      "id": "2248e2d6-276e-470a-8a5b-f73747019001",
      "text": "VAERS reports show HPV vaccines are ineffective and cause autoimmune and neurological disorders.",
      "date": "2023-11-30 00:00:00+00:00"
    },
    {
      "id": "54cae87b-07e5-4e39-acd4-c29514c871df",
      "text": "CDC admits 146.6 million Americans have natural immunity to COVID-19, and 94% of COVID-related deaths were not caused by COVID-19.",
      "date": "2021-11-21 00:00:00+00:00"
    },
    {
      "id": "6fa5ba65-1b87-4285-a9a5-3a94554c67ad",
      "text": "Video shows a Ukrainian soldier looting in Chechnya",
      "date": "2016-02-08 20:44:40"
    },
    {
      "id": "64ffb265-5a1a-495e-aa14-80d2aa155824",
      "text": "Britain proved it was involved in attacks on Crimea.",
      "date": "2024-01-12 17:43:00"
    },
    {
      "id": "861580e2-8611-46a7-b914-edb294d8b916",
      "text": "The Czech Republic refuses to accept migrants because of Ukraine.",
      "date": "2018-08-31 10:01:25"
    },
    {
      "id": "2beb2d9c-db42-4203-90eb-078a562de80f",
      "text": "The State Duma passed a law forbidding Russian citizens from leaving the country.",
      "date": "2015-06-09 18:38:50"
    },
    {
      "id": "f32ed7eb-c541-4c90-afa3-c2403a0cd3b2",
      "text": "Ukrainian military shelled Olenivka with HIMARS on President Zelensky's orders.",
      "date": "2022-07-30 14:57:00"
    },
    {
      "id": "114a2918-55aa-4649-81ee-2d5875a81cc9",
      "text": "COVID-19 vaccines make SARS-CoV-2 more dangerous by causing antibody-dependent enhancement (ADE).",
      "date": "2021-07-28 00:00:00+00:00"
    },
    {
      "id": "3b5afae5-ebac-4413-bff8-cc414ef551ef",
      "text": "A poll shows Ukrainians do not want peace and only want to fight Russia.",
      "date": "2023-12-18 12:40:00"
    },
    {
      "id": "d5b22620-2260-4e65-a424-eaf06965e7e9",
      "text": "The Vatican was the first to pay Russia for gas in rubles.",
      "date": "2022-04-19 16:29:00"
    },
    {
      "id": "dded93d6-13c8-4f81-977e-0779477b6de6",
      "text": "The spring sowing campaign is under threat because all grain was taken out of Ukraine.",
      "date": "2023-02-10 12:28:00"
    },
    {
      "id": "22587ee9-0a3d-4963-818d-de36abce0d53",
      "text": "Some mouthwashes help curb coronavirus",
      "date": "2020-02-11 00:00:00+00:00"
    },
    {
      "id": "1d59567a-e2a4-47f5-aec4-3e370cc9791e",
      "text": "Earth will enter a 30-year mini ice age.",
      "date": "2020-06-02 00:00:00+00:00"
    },
    {
      "id": "d70bcda9-c233-4308-b6e9-0719754845a9",
      "text": "The low death rate is caused by human memory T cells providing immunity beyond antibodies.",
      "date": "2020-10-28 00:00:00+00:00"
    },
    {
      "id": "3cf506c1-c396-4fbf-877c-ec2c229ed925",
      "text": "Ukrainian soldiers are promised a parcel of land and two slaves.",
      "date": "2014-11-03 19:32:57"
    },
    {
      "id": "cd217be3-7c36-4052-868a-0f2a3b5364a3",
      "text": "The COVID-19 pandemic was planned; the SARS‑CoV‑2 virus was deliberately manipulated and did not jump directly to humans but was created through accelerated viral evolution.",
      "date": "2020-05-04 00:00:00+00:00"
    },
    {
      "id": "a2ba01ad-c784-4902-81bb-447fade61de0",
      "text": "The West will use weapons of mass destruction in Ukraine and then blame Russia.",
      "date": "2021-05-21 13:44:49"
    },
    {
      "id": "3dbae1d6-6af2-4492-ae17-f58230ea2ffa",
      "text": "The rate and magnitude of the reported late twentieth century (1979–2000) surface warming were within normal natural variability.",
      "date": "2016-01-01 00:00:00+00:00"
    },
    {
      "id": "26ee7189-c0fb-4ab1-858c-0111039380b6",
      "text": "The United States and Ukraine are preparing a new Chernobyl in Russia.",
      "date": "2020-01-07 16:49:31"
    },
    {
      "id": "b3bc6c3c-8641-453e-a50d-dab1814cbc39",
      "text": "Global leaders planned the pandemic and an 89-page PDF explains how they would implement the plan.",
      "date": "2024-01-12 00:00:00+00:00"
    },
    {
      "id": "d8113053-efb3-41bd-b540-2e0ae0f26367",
      "text": "Poles demand autonomy from Kyiv.",
      "date": "2017-01-03 02:17:02"
    },
    {
      "id": "0d5871ed-f21e-491e-b9fc-e8a4f2b3d8c5",
      "text": "CO2 concentrations in Earth's atmosphere are increasing faster than at any time in the past 50,000 years.",
      "date": "2024-08-19 00:00:00+00:00"
    },
    {
      "id": "3b8b4ee9-f72f-4a96-93e5-cb907013d7db",
      "text": "CDC has classified monkeypox as an airborne form of herpes that infects anyone within 15 feet, lasts 2–4 months, and causes paralysis.",
      "date": "2022-08-04 00:00:00+00:00"
    },
    {
      "id": "2f3194b6-9742-4bc1-b6f3-965c8e1ccc22",
      "text": "Mask mandates do not stop the spread of COVID-19, and overwhelming scientific evidence shows masks do not work.",
      "date": "2020-11-11 00:00:00+00:00"
    },
    {
      "id": "dc8d8b18-4675-4d5e-907f-b718920445a9",
      "text": "Ukraine will face new language divisions.",
      "date": "2016-11-08 23:39:51"
    },
    {
      "id": "a40df7e2-c699-4e3b-b6df-5ac58bd94ea2",
      "text": "European governments refuse to recognize Russia’s invasion of Ukraine as aggression and refuse to establish a special tribunal.",
      "date": "2022-08-07 14:34:50"
    },
    {
      "id": "d3846972-39e3-4228-82e3-9e77c1f80743",
      "text": "Ukraine is deploying women to frontline combat due to heavy military losses.",
      "date": "2026-01-07 00:00:00+00:00"
    },
    {
      "id": "e2404afc-9753-4d93-b38e-a46a7808158c",
      "text": "Whooping cough (DTaP) vaccine is unnecessary and causes sudden infant death syndrome.",
      "date": "2024-07-03 00:00:00+00:00"
    },
    {
      "id": "72583dd3-23b1-46be-b38c-c5b9919c8154",
      "text": "Foreigners are buying land in Crimea and sanctions have failed to stop it.",
      "date": "2018-08-13 15:00:35"
    },
    {
      "id": "be4ad66e-73c6-44a3-a8dc-610d40c2bf91",
      "text": "Being in an electric car lowers a person's testosterone and causes infertility.",
      "date": "2025-02-07 00:00:00+00:00"
    },
    {
      "id": "b42f4cb2-3538-4752-bdb5-ef52a30c50cc",
      "text": "COVID-19 vaccines are experimental poisons, and COVID-19 has disappeared.",
      "date": "2023-11-20 00:00:00+00:00"
    },
    {
      "id": "3e98e034-093e-4a49-863b-54bb8f347b6e",
      "text": "European countries have closed their borders to Ukrainian refugees.",
      "date": "2025-09-17 00:00:00+00:00"
    },
    {
      "id": "267d7407-8aec-414f-8ec6-99f325f4f78c",
      "text": "Countries that sign the pandemic treaty cede their sovereignty to the WHO, which controls domestic policy, mandates vaccinations and lockdowns, and arrests vaccine opponents.",
      "date": "2024-06-13 00:00:00+00:00"
    },
    {
      "id": "72d30220-98d5-4c06-b8e6-7eca12186b6e",
      "text": "The Italian Higher Institute of Health reduced Italy's official COVID-19 death toll by over 97% by changing the fatality definition to deaths caused by COVID rather than deaths with COVID.",
      "date": "2021-11-04 00:00:00+00:00"
    },
    {
      "id": "cb32487d-caf2-4e49-bdf0-5d334e61b2a0",
      "text": "Video shows a Syrian mercenary praying inside a Ukrainian grocery store.",
      "date": "2025-10-13 00:00:00+00:00"
    },
    {
      "id": "622cd7c4-8d47-40c5-90fc-180cf3666da4",
      "text": "By May 31, 2020, COVID-19 was a leading cause of death globally.",
      "date": "2020-06-27 00:00:00+00:00"
    },
    {
      "id": "39dff10d-9b73-4d10-be22-8229252a8485",
      "text": "Ukraine’s Health Ministry allows Ukrainians to be sold for organs.",
      "date": "2017-10-05 17:01:04"
    },
    {
      "id": "35a0fed2-5de2-409c-bb51-5a52d2d37080",
      "text": "Anti-Russian sanctions have caused a bedbug influx in France.",
      "date": "2023-10-18 14:50:00"
    },
    {
      "id": "01474331-54c3-4a9d-883f-8cb0e4eaa86c",
      "text": "Poroshenko binge drank for a week.",
      "date": "2015-06-16 11:19:52"
    },
    {
      "id": "4ed9be65-3feb-4114-82c4-43f3f933184d",
      "text": "The Ukrainian diaspora in Canada supports forced mobilization.",
      "date": "2025-11-06 00:00:00+00:00"
    },
    {
      "id": "0b8030df-1877-44d1-bbaf-c0428144a920",
      "text": "The Red Cross says people vaccinated against COVID-19 cannot donate convalescent plasma because the vaccine eliminates SARS-CoV-2 antibodies.",
      "date": "2021-09-30 00:00:00+00:00"
    },
    {
      "id": "4493c186-ce66-4d2c-8241-c61003cee988",
      "text": "California wildfires are made much worse by environmental laws that prevent using abundant available water, and that water is diverted into the Pacific Ocean.",
      "date": "2018-07-08 00:00:00+00:00"
    },
    {
      "id": "736fc05c-c8ce-4304-910b-c143ec389610",
      "text": "Folic acid and similar compounds deplete folate and this is very serious for people with MTHFR.",
      "date": "2022-04-29 00:00:00+00:00"
    },
    {
      "id": "7b422af4-47b8-4029-b7a7-1c1ecae49496",
      "text": "Pennyroyal, blue cohosh, black cohosh, and mugwort effectively induce abortions.",
      "date": "2022-06-24 00:00:00+00:00"
    },
    {
      "id": "f84d25e9-527c-422a-9cb1-9341de6a5cb0",
      "text": "The CDC lowered developmental milestone standards to avoid acknowledging that COVID-19 restrictions harmed children's development.",
      "date": "2022-02-25 00:00:00+00:00"
    },
    {
      "id": "3a70e7d2-ab8e-44f3-86b1-b2506b82321b",
      "text": "The OSCE provided communications and intelligence to the Azov battalion in Mariupol.",
      "date": "2022-05-30 15:59:12"
    },
    {
      "id": "9179a5f8-b7f0-4e62-8586-1a710c219f83",
      "text": "Researchers at the Wuhan Institute of Virology assembled monkeypox strains.",
      "date": "2022-03-06 00:00:00+00:00"
    },
    {
      "id": "72019106-200a-441d-9dd4-5fa1efbe3efd",
      "text": "Crimeans received Russian passports with Magadan registration.",
      "date": "2014-03-27 01:06:48"
    },
    {
      "id": "cc2f9126-be5f-4455-8daf-dde1a7c7dc68",
      "text": "Photo shows dozens of miniature explosive devices discovered in Lviv.",
      "date": "2022-11-01 10:33:00"
    },
    {
      "id": "87d0c57c-b815-49a8-a97b-e6157315d1b6",
      "text": "There are zero deaths from influenza and zero deaths from pneumonia for the first time in history.",
      "date": "2020-04-12 00:00:00+00:00"
    },
    {
      "id": "2f5160f3-6a08-4202-9c85-ae24f8ffdd10",
      "text": "There has been no global warming trend for the past 7.5 years, and human-caused global warming causes temperatures to rise at a steady rate.",
      "date": "2022-11-04 00:00:00+00:00"
    },
    {
      "id": "94a20783-3b70-4c03-afbe-6b03f5877f9f",
      "text": "The Ukrainian government curtailed freedom of assembly.",
      "date": "2016-03-18 10:27:50"
    },
    {
      "id": "0aebb9f1-91df-402d-9f33-9d92f0b25ce1",
      "text": "Certain herbs and supplements prevent and cure the harmful effects of bisphenol.",
      "date": "2023-01-23 00:00:00+00:00"
    },
    {
      "id": "42b54835-5d4d-435b-8b6a-5cedf48f4ff0",
      "text": "Japan reported a surge in heart failure cases among people vaccinated against COVID-19.",
      "date": "2025-01-18 00:00:00+00:00"
    },
    {
      "id": "94c87795-abb6-468e-b1bf-4a1f72916947",
      "text": "Aircraft‑dispersed particles used for Solar Radiation Management are causing catastrophic damage to Earth's life support systems.",
      "date": "2021-03-10 00:00:00+00:00"
    },
    {
      "id": "839ef5b4-46fb-4fc6-b490-2b3b13d09a4f",
      "text": "Eating coconut oil cures Alzheimer's disease.",
      "date": "2024-04-17 00:00:00+00:00"
    },
    {
      "id": "71cd85bd-d68c-4f80-96ef-5e4a0f20e449",
      "text": "A person was crucified in Slovyansk.",
      "date": "2014-07-15 20:44:21"
    },
    {
      "id": "dde47415-3e34-42b0-91f6-8049defae740",
      "text": "Ukrainian media report that people in Russia are starving.",
      "date": "2015-05-19 08:18:47"
    },
    {
      "id": "b93a9e77-ab9a-4624-b53a-56550ad2223d",
      "text": "FDA guidelines state infants cannot safely handle the amount of aluminum in childhood vaccines.",
      "date": "2024-02-28 00:00:00+00:00"
    },
    {
      "id": "311ef79d-3316-4ed0-aa50-6908a31ccf34",
      "text": "The European Commission abolished visa requirements for Ukrainian citizens despite the Dutch referendum results.",
      "date": "2016-04-11 19:12:55"
    },
    {
      "id": "adcbad7e-4248-4175-a81f-d50b7c2de032",
      "text": "Ukraine will resume train service to Crimea.",
      "date": "2019-09-30 16:44:23"
    },
    {
      "id": "bbeef6fc-0381-4225-8d4d-c559818a9245",
      "text": "The Pfizer/BioNTech vaccine contains mRNA encoding the SARS-CoV-2 spike protein, lipids, sucrose, and salts.",
      "date": "2020-12-10 00:00:00+00:00"
    },
    {
      "id": "4890350c-f17f-4ee5-9907-ea4bee9f3c78",
      "text": "U.S. rejected Umerov’s ambassadorial nomination because Umerov was an American citizen.",
      "date": "2025-07-17 00:00:00+00:00"
    },
    {
      "id": "3936ffc9-8f11-4f63-9703-b7ede8f9de85",
      "text": "Taking ivermectin cuts the risk of dying from COVID-19.",
      "date": "2021-03-06 00:00:00+00:00"
    },
    {
      "id": "d593ca1c-6b0f-4383-b405-05cd1d56f441",
      "text": "Coronavirus is not a new virus",
      "date": "2020-01-24 00:00:00+00:00"
    },
    {
      "id": "8c4010bc-6c4c-4934-bd26-e4ab5f10b96b",
      "text": "The EU will seize and scrap any old car that does not meet EU climate criteria.",
      "date": "2023-11-27 00:00:00+00:00"
    },
    {
      "id": "97c8f3a5-99e3-4d37-8ef8-8f13a0f6f87b",
      "text": "More than 80% of MEP candidates oppose Ukraine joining the EU.",
      "date": "2024-06-04 14:41:00"
    },
    {
      "id": "4c2290f7-c93b-4bcb-af31-dcb1673f4622",
      "text": "SARS-CoV-2 was created by genetic experiments using bat coronavirus RaTG13 as a template.",
      "date": "2021-03-01 00:00:00+00:00"
    },
    {
      "id": "c675b624-2763-47c1-a4a8-832fa897333a",
      "text": "Aluminium in vaccines causes cognitive deficits, Parkinson's disease, and Alzheimer's disease.",
      "date": "2025-01-31 00:00:00+00:00"
    },
    {
      "id": "db746ea7-fad4-4ef3-9c9d-d6271b28d902",
      "text": "The EU and the US opened a criminal case against Poroshenko.",
      "date": "2019-03-25 17:10:49"
    },
    {
      "id": "4e6afe48-56e8-44ee-891f-dd9bae3916b0",
      "text": "The US created a schismatic, disenfranchised church in Ukraine.",
      "date": "2021-07-30 18:01:10"
    },
    {
      "id": "9ce36d9d-c25d-4bb5-888a-f10c126f5cdf",
      "text": "The \"CGG CGG\" codons and the furin cleavage site in the SARS-CoV-2 spike gene do not occur in nature and prove the virus was engineered and not transmitted from animals to humans.",
      "date": "2022-06-05 00:00:00+00:00"
    },
    {
      "id": "0c20dda0-d26d-4aa8-9ab5-36f5ecd7c1b5",
      "text": "The European Union admitted that Russia won the war in Ukraine.",
      "date": "2023-11-14 16:44:00"
    },
    {
      "id": "66b83ca0-c680-4174-8829-30444f5d4a2f",
      "text": "COVID-19 mRNA vaccines are experimental, ineffective, and harmful.",
      "date": "2024-03-05 00:00:00+00:00"
    },
    {
      "id": "12a8a42b-01c8-443c-a58d-67b4d9241aef",
      "text": "The Ukrainian government officially recognizes that Russia is protecting Donbas residents.",
      "date": "2019-05-07 11:53:26"
    },
    {
      "id": "c093a054-ad4e-413d-97d1-2f0dce3b5245",
      "text": "Wind turbines are killing bald eagles and causing consumers to pay higher electricity bills.",
      "date": "2026-01-13 00:00:00+00:00"
    },
    {
      "id": "bae4b60e-2feb-413a-80e5-9ae5c5227f65",
      "text": "U.S. Ambassador in Kyiv said St. George’s Ribbon is a Russian army insignia.",
      "date": "2015-05-09 19:25:42"
    },
    {
      "id": "40355d84-e0d1-4012-ba06-470990ff355d",
      "text": "Kyiv claims Russia has lost a third of its army in the Ukraine war.",
      "date": "2022-05-18 09:49:00"
    },
    {
      "id": "49f5e80f-b75f-4e72-b737-6acbef1bf0a2",
      "text": "A study by Rössner et al. found vaccines are useful and clearly superior to natural immunity.",
      "date": "2022-03-24 00:00:00+00:00"
    },
    {
      "id": "10bd837a-184b-4920-8305-30712092c033",
      "text": "Hungary will shoot down a Ukrainian airliner.",
      "date": "2018-06-12 19:47:56"
    },
    {
      "id": "71548d11-3d0c-40be-ad09-6aa892149ca2",
      "text": "The OSCE declared the Russian presidential elections were open and fair.",
      "date": "2018-03-21 11:03:41"
    },
    {
      "id": "76d5d175-535e-46fd-ab6a-b99dfb4c17f2",
      "text": "COVID-19 is less deadly than seasonal flu.",
      "date": "2020-09-27 00:00:00+00:00"
    },
    {
      "id": "8438a8e5-7cc5-4ccc-9e88-93c1ecdd7a0f",
      "text": "Ukrainian military destroys OSCE drones",
      "date": "2019-04-21 18:11:12"
    },
    {
      "id": "82cc3ee8-b976-4209-ac1c-82cf81af5987",
      "text": "The United States is preparing the final aid package for Ukraine.",
      "date": "2023-12-20 15:10:00"
    },
    {
      "id": "884b5410-71ab-40b5-92bf-3fa3d31a42b2",
      "text": "Ukraine recognized new Russian entities.",
      "date": "2024-02-15 11:42:00"
    },
    {
      "id": "fdd99a5d-dc39-4dd3-b1be-3a0f181eada2",
      "text": "Vaccines harm children, fully unvaccinated children are healthier, and vaccines cause chronic disease in America.",
      "date": "2023-10-08 00:00:00+00:00"
    },
    {
      "id": "1ca2752f-4af9-4d26-8544-6712cd8d5734",
      "text": "Olena Zelenska spent over one million euros on designer clothes.",
      "date": "2025-09-20 00:00:00+00:00"
    },
    {
      "id": "7b45f5c1-bb98-4361-b2ce-46d822b10ac7",
      "text": "Nicotine cures Parkinson's disease, Alzheimer's disease, ulcerative colitis, and multiple sclerosis and is a treatment for autism.",
      "date": "2025-03-10 00:00:00+00:00"
    },
    {
      "id": "d773d4e9-0cab-4365-8976-c8decb85d8e1",
      "text": "Blinken acknowledged that Russia would grind Ukraine.",
      "date": "2022-03-08 10:38:57"
    },
    {
      "id": "af38f83b-dbcf-450a-b045-facb4eb4a1e6",
      "text": "Cultivated meat is produced using cancerous and precancerous cells.",
      "date": "2023-03-20 00:00:00+00:00"
    },
    {
      "id": "16cce81c-59f8-49fe-80c7-ebfa11deb63b",
      "text": "A photograph of a boy from Donbas was used in a protest against Muslim migrants in Sweden.",
      "date": "2015-09-10 11:43:20"
    },
    {
      "id": "ccf1aa54-dd43-4d8f-a738-dd4d80b24add",
      "text": "Remdesivir kills people",
      "date": "2021-03-22 00:00:00+00:00"
    },
    {
      "id": "57c37915-30a2-40bf-974e-472454a96f8f",
      "text": "A man in Bila Tserkva was killed while being served draft papers.",
      "date": "2024-01-04 09:59:00"
    },
    {
      "id": "a6d49558-eef4-4a2e-9043-3c0c2b6b6bbe",
      "text": "The United States and Canada have ended military cooperation with Ukraine.",
      "date": "2017-02-18 12:00:02"
    },
    {
      "id": "5830dc6f-03ec-4ac5-b7fd-5edf44bb0a83",
      "text": "Arctic sea ice is not melting and Arctic summer sea ice will not disappear completely.",
      "date": "2024-07-03 00:00:00+00:00"
    },
    {
      "id": "1a00a4c5-406d-4321-84ff-e533b4ecc22c",
      "text": "Nasal swabs used for COVID-19 testing contain ethylene oxide and are harmful.",
      "date": "2021-07-21 00:00:00+00:00"
    },
    {
      "id": "61b0468f-bf4f-46aa-8677-03c588718fbd",
      "text": "Ukrainian authorities will lift sanctions on Russia.",
      "date": "2019-11-15 19:05:33"
    },
    {
      "id": "9a8b19ca-a3ca-4d44-98fb-4879ab5e716a",
      "text": "Ukraine's Foreign Minister wants to identify and expel holders of Russian passports.",
      "date": "2018-11-02 12:12:24"
    },
    {
      "id": "38d3dbe3-6d8f-4c1a-ada7-82d3adc0c1a7",
      "text": "Georgian snipers shot Maidan demonstrators.",
      "date": "2017-11-28 21:18:26"
    },
    {
      "id": "ef48ebaa-d46a-4bf8-b024-1f4517044afd",
      "text": "The Czech president recognizes Crimea as part of Russia.",
      "date": "2019-11-02 11:49:49"
    },
    {
      "id": "5984b168-5644-4269-bf75-69cbe7dc11b1",
      "text": "Ukrainian President Volodymyr Zelensky admitted that Ukraine lost Crimea.",
      "date": "2024-11-21 00:00:00+00:00"
    },
    {
      "id": "86963e0e-78a0-4aa0-a5d7-18317e7a8435",
      "text": "The Ukrainian Orthodox Church canonized Stepan Bandera, the assassinated Ukrainian nationalist leader.",
      "date": "2022-06-21 15:42:00"
    },
    {
      "id": "bd9d61c0-b489-42b3-81d2-5037b5b9085f",
      "text": "Producing enough COVID-19 vaccine to vaccinate the entire world population will take decades.",
      "date": "2024-12-01 00:00:00+00:00"
    },
    {
      "id": "6d24cd62-df85-47ff-a576-096eb14cfac7",
      "text": "Germany's Bundestag recognizes that Russia will not give up Crimea.",
      "date": "2022-09-06 10:08:00"
    },
    {
      "id": "ff08916e-80cd-4f56-9132-0d29f090108b",
      "text": "Immediate widespread use of high doses of vitamin C will stop the coronavirus pandemic.",
      "date": "2020-02-20 00:00:00+00:00"
    },
    {
      "id": "1cd9e0d1-d0c7-4e5d-81a0-dd508b1c0103",
      "text": "The CDC admits that 98 million Americans received polio vaccines over an eight-year span that were contaminated with a cancer-causing virus.",
      "date": "2019-07-25 00:00:00+00:00"
    },
    {
      "id": "acd001cd-0290-40bf-a92f-fa64c5dd7162",
      "text": "Forest fires are caused by poor management, and climate change does not cause forest fires.",
      "date": "2020-09-16 00:00:00+00:00"
    },
    {
      "id": "a9df38b0-7eda-4e6c-86c7-f5aec5ef21d8",
      "text": "Ukraine caused the fire at the Warsaw shopping centre.",
      "date": "2025-05-12 00:00:00+00:00"
    },
    {
      "id": "98071d1d-2071-4798-881e-ab5ac7c805c0",
      "text": "Researchers from Yale University created an airborne delivery method for mRNA vaccines.",
      "date": "2023-09-02 00:00:00+00:00"
    },
    {
      "id": "0ea3ca70-90dd-4685-8683-40c371c0a842",
      "text": "COVID-19 vaccines are an unqualified disaster that did not halt viral spread and caused high morbidity and mortality.",
      "date": "2023-12-13 00:00:00+00:00"
    },
    {
      "id": "52e3685b-c678-4af1-9111-fff0298d8c1d",
      "text": "45% of Ukrainians work abroad and Ukraine has record-high unemployment.",
      "date": "2017-09-24 10:59:22"
    },
    {
      "id": "f826d0dc-a8ed-4fd6-a3ef-8ea48b29d995",
      "text": "Apple AirPods emit dangerous levels of radiation that harm the human body.",
      "date": "2024-11-03 00:00:00+00:00"
    },
    {
      "id": "77774563-df12-46ca-b652-d2aadb1356bf",
      "text": "Asymptomatic spread of COVID-19 does not occur.",
      "date": "2021-04-01 00:00:00+00:00"
    },
    {
      "id": "d50c2267-ccfb-496b-ad5d-5b5cf780038b",
      "text": "Fascism has returned to Ukraine.",
      "date": "2019-11-04 19:15:26"
    },
    {
      "id": "5f686620-22a4-4420-922c-3dcacdf705e4",
      "text": "Ukraine returned Yanukovych's billions to Russia with interest.",
      "date": "2022-01-03 10:16:00"
    },
    {
      "id": "32c50326-30f2-4f12-8a82-643ec0ef2da7",
      "text": "The UN condemns Ukrainian attacks on the Zaporizhzhia Nuclear Power Plant.",
      "date": "2022-08-09 12:25:00"
    },
    {
      "id": "524904f4-9cad-40eb-9364-745fdd154360",
      "text": "Valery Zaluzhnyi joined the European Solidarity political party.",
      "date": "2024-02-17 16:45:00"
    },
    {
      "id": "3ea0bb8d-ace0-438b-837f-af1f609b2983",
      "text": "Ukrainian aircraft from Kyiv entered Russian airspace.",
      "date": "2016-12-03 15:17:45"
    },
    {
      "id": "facbb5fb-ab2b-46f7-8ddb-36e37650f76b",
      "text": "Ukraine cut the Chornobyl power lines and refused to repair them.",
      "date": "2022-03-11 14:38:00"
    },
    {
      "id": "7c0d759c-256c-45c0-962a-921ab04dec88",
      "text": "The Lublin Triangle organized a coup in Belarus.",
      "date": "2020-08-13 14:43:33"
    },
    {
      "id": "d8a8c4b2-0e1f-4c25-a277-efd7033a966c",
      "text": "Poland demands official status for the Ukrainian language.",
      "date": "2022-07-30 18:24:00"
    },
    {
      "id": "f6afb794-bfad-4655-8a2e-7b3a4bbef5af",
      "text": "Ukrainian nationalists shelled Kherson.",
      "date": "2022-05-14 16:25:00"
    },
    {
      "id": "fa5f8415-ce48-47e8-88c5-998e13fb6afc",
      "text": "People do not wear masks for tuberculosis because CNN has not instructed them to.",
      "date": "2020-09-21 00:00:00+00:00"
    },
    {
      "id": "7eb45dca-8013-4bad-a452-af5178b0821e",
      "text": "The CDC says face masks do not prevent COVID-19 and mask mandates had no statistical effect on COVID-19 case numbers.",
      "date": "2021-12-03 00:00:00+00:00"
    },
    {
      "id": "a4b9fd7e-9d5a-42c0-8b84-7afbda6514d2",
      "text": "Bukovina Romanians demand territorial autonomy from Ukraine.",
      "date": "2016-06-21 23:24:26"
    },
    {
      "id": "b0bd9402-6ac9-4bfb-b7a3-46087e2efaeb",
      "text": "Naftogaz lost a legal case against Gazprom in an EU court.",
      "date": "2018-05-03 20:34:45"
    },
    {
      "id": "402d4cf2-b595-4a1b-9e0d-398cdaa5f715",
      "text": "Apple AirPods emit dangerous levels of radiation that harm the human body.",
      "date": "2024-02-25 00:00:00+00:00"
    },
    {
      "id": "3e8127cd-0ac5-4ba6-9b1a-2f5ad353a380",
      "text": "The media exaggerates the harm of measles cases and ignores millions of vaccine injury reports.",
      "date": "2025-02-20 00:00:00+00:00"
    },
    {
      "id": "0a45144d-bc7b-48a7-a0d4-08f0e213397c",
      "text": "One in 35 people showed signs of heart damage after receiving the Moderna COVID-19 vaccine; the Moderna vaccine is a kill shot; taking the Moderna vaccine is madness.",
      "date": "2023-07-26 00:00:00+00:00"
    },
    {
      "id": "d8318dcb-8196-4736-82e4-d6cc57aa76dd",
      "text": "Ukraine's language police punish children for speaking Russian.",
      "date": "2019-12-17 21:11:20"
    },
    {
      "id": "f236c3eb-1e72-435c-8a05-422be25ed158",
      "text": "Ukrainian military shelled the OSCE mission.",
      "date": "2017-06-25 08:22:59"
    },
    {
      "id": "16b2210d-88f5-4ea8-8a34-f9036b31f1c2",
      "text": "The NIH researched chloroquine and concluded it effectively stopped SARS coronavirus infection and spread.",
      "date": "2020-08-05 00:00:00+00:00"
    },
    {
      "id": "9548af52-dc76-462b-b47d-4103c15106fb",
      "text": "Global weather is controlled by secret geoengineering programs using chemtrails and ionospheric heating facilities.",
      "date": "2023-08-31 00:00:00+00:00"
    },
    {
      "id": "f19de695-0fd5-4984-879f-5e7fe105d8bd",
      "text": "Progesterone reverses an abortion after taking mifepristone.",
      "date": "2023-01-04 00:00:00+00:00"
    },
    {
      "id": "1242e98b-4861-4e72-918d-2cf17aa8ef2e",
      "text": "Burning sage removes bacteria from the air.",
      "date": "2020-03-14 00:00:00+00:00"
    },
    {
      "id": "17369906-4440-4cf2-b756-2f07d9af8743",
      "text": "Maia Sandu's party will raise the retirement age, increase taxes, and extend mandatory military service terms.",
      "date": "2025-09-19 00:00:00+00:00"
    },
    {
      "id": "2c5f2066-066d-45f1-97bd-e7d6dc3fdff5",
      "text": "Italy's Liguria region officially recognizes Crimea as part of Russia.",
      "date": "2016-07-03 22:39:34"
    },
    {
      "id": "70e18083-4534-4530-afa8-d8714b3040bf",
      "text": "Estonians will become a minority in Estonia due to an influx of Ukrainian immigrants.",
      "date": "2019-04-27 11:05:55"
    },
    {
      "id": "7824b1f9-6e1f-4f01-b3d0-804dacae6c5e",
      "text": "Poland is merging Lithuania.",
      "date": "2020-10-04 13:46:01"
    },
    {
      "id": "074932db-89fa-4c44-b3e2-4b9f5cf79713",
      "text": "Ultra-right groups are patrolling Kyiv public transport during the COVID-19 quarantine.",
      "date": "2020-03-22 02:49:04"
    },
    {
      "id": "494b41ad-16b3-4f5d-ad03-def9e45d7031",
      "text": "Pfizer CEO's wife died from complications caused by the COVID-19 vaccine.",
      "date": "2021-11-10 00:00:00+00:00"
    },
    {
      "id": "ce5811c1-0450-4769-8a57-92c8068d2fb7",
      "text": "Photo shows a Ukrainian prisoner of war with a Nazi coat tattoo.",
      "date": "2024-02-15 19:12:00"
    },
    {
      "id": "059dfdf0-3274-489c-a292-df035cfe622b",
      "text": "A study showed that COVID-19 vaccines cause a high number of serious adverse events.",
      "date": "2023-06-01 00:00:00+00:00"
    },
    {
      "id": "86c627e9-87ce-4feb-a64a-7c2e65cd051c",
      "text": "President Poroshenko proposes depriving Crimeans of Ukrainian citizenship.",
      "date": "2018-04-21 11:35:43"
    },
    {
      "id": "86bc7693-d3ed-489b-8275-42c965c94524",
      "text": "Masks work to prevent COVID-19 transmission, so voting in person is safe when people wear masks.",
      "date": "2020-06-30 00:00:00+00:00"
    },
    {
      "id": "004bcedc-8ee2-4bfa-b1a3-bc80706b2c9e",
      "text": "A complete cure for cancer will be available within one year.",
      "date": "2019-01-28 00:00:00+00:00"
    },
    {
      "id": "ea491e59-5762-4b62-ae8b-0e847b8f2306",
      "text": "A vaccine caused people to become zombies in the movie \"I Am Legend\".",
      "date": "2020-12-09 00:00:00+00:00"
    },
    {
      "id": "13882094-703c-4278-b683-549acc4d6b63",
      "text": "Antibodies from common-cold coronaviruses cause positive COVID-19 antibody test results and are responsible for the reported COVID-19 cases in the U.S.",
      "date": "2020-07-01 00:00:00+00:00"
    },
    {
      "id": "ce6bdc17-d3f4-4f80-85f2-0aefcba95ef2",
      "text": "Artificial sweeteners cause cancer; people in the 1930s ate cake, cookies, and ice cream with sugar and were healthy.",
      "date": "2024-03-16 00:00:00+00:00"
    },
    {
      "id": "f442f5d7-694c-437b-8a57-42377f8836c1",
      "text": "A gold-standard scientific trial found that N95 and surgical masks do not stop COVID.",
      "date": "2022-06-12 00:00:00+00:00"
    },
    {
      "id": "7adbc651-0db1-44f2-bdaa-bf7e41339d70",
      "text": "World Health Organization declares bacon is as harmful as cigarettes",
      "date": "2018-07-10 00:00:00+00:00"
    },
    {
      "id": "6a12640e-f7af-45fb-83c1-115eb23d04c6",
      "text": "Donald Trump asked European Commission President Ursula von der Leyen to step out of a meeting with other leaders.",
      "date": "2025-08-20 00:00:00+00:00"
    },
    {
      "id": "add1a8eb-5ffe-4d41-aeb3-0fe733ac602a",
      "text": "The United States is preparing a new color revolution in Ukraine.",
      "date": "2018-03-26 11:10:00"
    },
    {
      "id": "6bed48b2-0edd-431f-b71a-5f9ac3911493",
      "text": "Science confirmed eating turmeric every day reverses cancer.",
      "date": "2019-06-17 00:00:00+00:00"
    },
    {
      "id": "eea5831c-1818-49ff-a840-70bc989108d8",
      "text": "Ukraine will not receive a COVID-19 vaccine before April 2022.",
      "date": "2021-01-04 17:57:16"
    },
    {
      "id": "d88d003f-e632-4853-b889-29b348e0ebd3",
      "text": "Arctic sea ice is not melting and Arctic summer sea ice will not disappear completely.",
      "date": "2024-02-06 00:00:00+00:00"
    },
    {
      "id": "11d918d0-91f4-4852-96b6-bcf4b48456db",
      "text": "A study and headline claiming that homegrown food is more carbon intensive than conventional agriculture were intended to discourage and stop people from growing their own food.",
      "date": "2024-01-26 00:00:00+00:00"
    },
    {
      "id": "b8e57973-bf23-43bb-b596-d626ffcada51",
      "text": "77% of Europeans believe in Russian unity.",
      "date": "2024-11-04 00:00:00+00:00"
    },
    {
      "id": "1ee64121-a4c9-46cf-b4b9-c13328eddf9c",
      "text": "Mass COVID-19 vaccination selects for more virulent SARS-CoV-2 variants that escape vaccine-induced immunity and cause more severe disease.",
      "date": "2021-03-06 00:00:00+00:00"
    },
    {
      "id": "42e3681c-d6dc-4147-9cac-e4f3a55e2e41",
      "text": "Ukrainian presidential elections are illegitimate",
      "date": "2019-01-08 09:27:45"
    },
    {
      "id": "c6089725-60b2-4ef2-aeab-d22120486baa",
      "text": "Poroshenko declared the Stepan Bandera flag the official symbol of Victory Day.",
      "date": "2015-05-03 13:59:17"
    },
    {
      "id": "4cdd0773-c021-4555-a38c-ec5f0bfad7cd",
      "text": "Abortion is never medically necessary.",
      "date": "2019-08-30 00:00:00+00:00"
    },
    {
      "id": "4af819d4-6ccb-4db4-82a7-142fd4cbfb48",
      "text": "The National Guard received an order to surrender soldiers, and those soldiers were executed.",
      "date": "2022-04-25 10:26:27"
    },
    {
      "id": "8f3231dd-131f-4e50-afb2-362a175bcd25",
      "text": "Ukrainians in Poland are cleaners and dishwashers.",
      "date": "2016-04-20 22:37:08"
    },
    {
      "id": "deb108a4-d11d-4c83-8ef8-7fa28452ab2c",
      "text": "Poles escaped military training and fled to Germany in panic.",
      "date": "2022-12-29 11:08:00"
    },
    {
      "id": "7fb9d117-424e-4364-ac58-0b3f7a4c9c6e",
      "text": "Coronavirus relief funds in Ukraine were diverted to support patriotic cinema.",
      "date": "2020-04-16 16:35:00"
    },
    {
      "id": "3840070e-e558-475e-92ef-eacb1b2de62f",
      "text": "Poland introduced censorship of World War II history on orders from the United States.",
      "date": "2020-01-15 18:40:52"
    },
    {
      "id": "531466cc-9728-4a80-a5cb-881ffd95a5a1",
      "text": "All Crimean Tatars support Russia’s special military operation in Ukraine.",
      "date": "2022-04-30 17:43:23"
    },
    {
      "id": "a2dcfbcd-6b87-4776-bcb4-d7f6a80bca1f",
      "text": "Ukrainian minister called for convicts to be sent into battle with shovels.",
      "date": "2024-02-26 12:08:34"
    },
    {
      "id": "4e7cc4da-de24-4edb-97bc-77ff4cea40f8",
      "text": "The US sold defective Javelins to Ukraine.",
      "date": "2018-07-10 08:51:56"
    },
    {
      "id": "4f08f272-a5ef-42cf-bc10-d353d93fcf62",
      "text": "More people died from COVID-19 during Biden's administration than during Trump's administration.",
      "date": "2024-09-19 00:00:00+00:00"
    },
    {
      "id": "d3c0a979-4284-4184-960f-bc6e4c588e4a",
      "text": "Dietary supplements containing AHCC treat HPV infection.",
      "date": "2025-01-01 00:00:00+00:00"
    },
    {
      "id": "50b63130-fc47-4ba7-997f-8819f7b44faa",
      "text": "Russian forces destroyed the Georgian Legion.",
      "date": "2022-07-07 10:08:00"
    },
    {
      "id": "062db82d-8f4c-48d6-87ac-3bd6f0352740",
      "text": "Western governments want an urgent peace treaty with Russia because Ukraine will suffer a catastrophe.",
      "date": "2022-07-08 10:01:00"
    },
    {
      "id": "2634c44b-89fb-4a8a-acef-e3b1e128d4a7",
      "text": "Finnish farmers are losing income because of Russian sanctions.",
      "date": "2016-07-23 16:45:22"
    },
    {
      "id": "bf90dd61-5d8b-42d9-a2e3-6cf4f09f3a7b",
      "text": "Erdoğan’s son defended purchasing oil from ISIL.",
      "date": "2015-12-09 20:44:30"
    },
    {
      "id": "2be5b181-7cfe-4239-a89f-a8d44870295b",
      "text": "The COVID-19 pandemic is a planned, staged pandemic manufactured through PCR testing.",
      "date": "2021-06-10 00:00:00+00:00"
    },
    {
      "id": "99e744c6-cf62-4768-82a4-c5eb88881c17",
      "text": "Kyiv is forcing waiters and shop clerks to speak Ukrainian.",
      "date": "2017-04-25 19:10:38"
    },
    {
      "id": "2521adfa-8bda-42f8-bac6-02fbee2d28c5",
      "text": "Thousands of European bikers joined the Night Wolves in Berlin.",
      "date": "2015-05-16 14:38:57"
    },
    {
      "id": "24fa34fc-a0c4-4170-8982-e09e4b40ed9e",
      "text": "The Netherlands will not ratify the EU-Ukraine Association Agreement.",
      "date": "2016-07-01 06:17:38"
    },
    {
      "id": "3f4c8053-b54e-4f92-9d93-277c513ddeb8",
      "text": "Western governments blackmailed Ukrainian President Volodymyr Zelensky.",
      "date": "2020-10-22 21:06:28"
    },
    {
      "id": "e398e6d7-0562-42c2-8dcf-06c2ea74ae41",
      "text": "Online interest in Volodymyr Zelensky dropped by 63%.",
      "date": "2024-01-06 10:22:00"
    },
    {
      "id": "3f7883b4-b31b-4845-91cf-194a57ceb24a",
      "text": "Western countries have begun partitioning Ukrainian regions.",
      "date": "2023-10-17 15:33:00"
    },
    {
      "id": "0262071f-6554-4ca8-a776-25ce99af3953",
      "text": "Kyiv is deserted and Ukrainians are leaving Ukraine.",
      "date": "2015-04-13 15:42:41"
    },
    {
      "id": "c1036166-682d-487e-a4b7-4361798cadaf",
      "text": "An Israeli study proves COVID-19 does not increase the risk of heart inflammation.",
      "date": "2022-11-08 00:00:00+00:00"
    },
    {
      "id": "49c23f8f-23e4-4472-9c11-84c9cf2a0f08",
      "text": "Olena Zelenska canceled a lecture at Ljubljana University because students protested.",
      "date": "2024-11-25 09:59:23"
    },
    {
      "id": "48210888-cfa8-4ad3-b7a2-0dfa4a41a836",
      "text": "Volodymyr Zelensky provoked a nuclear crisis.",
      "date": "2024-10-21 13:03:00"
    },
    {
      "id": "e3bcd447-c82c-491d-b3a4-0e5ed91fba70",
      "text": "Photo shows dogs eating the body of a Ukrainian soldier.",
      "date": "2014-11-06 22:03:13"
    },
    {
      "id": "b2f2fad4-12fa-49b0-8884-c5321146ec35",
      "text": "Crimean Tatars will vote for Putin in the March presidential election.",
      "date": "2018-01-16 22:22:02"
    },
    {
      "id": "55e92a8e-de98-4d80-964f-fa59d9c221d9",
      "text": "Ukrainian troops blew up nitric acid tanks in Rubizhne.",
      "date": "2022-04-11 11:17:17"
    },
    {
      "id": "8cfdba26-6ba3-4e3a-ae44-73685c31f110",
      "text": "Luciferase is present in COVID-19 vaccines and is used to tag and track people.",
      "date": "2021-11-11 00:00:00+00:00"
    },
    {
      "id": "b74fa89f-1aa2-4623-8efd-ade7549355ff",
      "text": "Ukraine cancels Victory Day and dismantles the Vatutin Monument.",
      "date": "2015-05-11 11:30:27"
    },
    {
      "id": "9cb8eba0-6a9f-48a3-9ea5-9b83b2c1a0b9",
      "text": "Vaccines did not eradicate polio.",
      "date": "2020-12-02 00:00:00+00:00"
    },
    {
      "id": "957aa997-f6ee-43d4-b6b5-c02eae63b50c",
      "text": "The U.S. Ambassador to Russia called for the lifting of U.S. sanctions on Russia.",
      "date": "2016-06-05 13:00:14"
    },
    {
      "id": "e8ccab47-ba71-4ba0-b9c8-0bc1d09c4169",
      "text": "Ukrainian president left Kyiv in haste",
      "date": "2022-02-26 14:31:00"
    },
    {
      "id": "719af7a9-5749-4c5c-88fd-216b26487133",
      "text": "Ukrainian mass media are avoiding coverage of refugees.",
      "date": "2016-03-05 23:59:18"
    },
    {
      "id": "5380d40c-3912-4e89-8e11-23b13a276589",
      "text": "Castor oil breaks up scar tissue, bone spurs, and tumors.",
      "date": "2024-03-20 00:00:00+00:00"
    },
    {
      "id": "d27d2ac6-9bc2-42df-8d5c-29642e076b66",
      "text": "A portrait of Symon Petliura hangs instead of an icon in a Ukrainian Orthodox Church of Canada church.",
      "date": "2025-05-03 00:00:00+00:00"
    },
    {
      "id": "7158dac5-0017-49f2-812d-206b0dca8204",
      "text": "Kyiv cancels the heating season because of Russian sanctions.",
      "date": "2022-08-23 09:42:31"
    },
    {
      "id": "4e18d1c7-f31c-47ca-9940-d330060d9074",
      "text": "Human breast milk naturally contains the same cannabinoids as the cannabis plant.",
      "date": "2017-01-15 00:00:00+00:00"
    },
    {
      "id": "2b95dfa8-8baa-414d-b8d2-548820d26d91",
      "text": "Right Sector members were attacked by helicopter fire in Zakarpattia Oblast.",
      "date": "2015-07-19 14:04:01"
    },
    {
      "id": "bb99a2cc-c607-4cc6-9731-47b9facdcdcf",
      "text": "Children hospitalized for non-COVID reasons were the ones on ventilators, and children hospitalized for COVID-19 were not on ventilators.",
      "date": "2021-11-06 00:00:00+00:00"
    },
    {
      "id": "274c14bf-8201-4583-9baf-7f5c6a4394d1",
      "text": "Ukraine armed civilians; shops were looted and civilians were shot.",
      "date": "2022-03-05 19:39:22"
    },
    {
      "id": "64084a20-f346-4a33-a235-e62a7c7d2223",
      "text": "Ukrainian military shelled the bus near Volnovakha.",
      "date": "2015-01-14 13:15:08"
    },
    {
      "id": "cebbe995-9fa9-4d98-b56f-692acb21274b",
      "text": "President Volodymyr Zelensky publicly downplayed the deaths of Irish personnel serving in Ukraine's armed forces.",
      "date": "2025-12-06 00:00:00+00:00"
    },
    {
      "id": "3aaf279a-f852-4457-8c74-5b5f4414f3a4",
      "text": "Fluoride exposure repeatedly reduces IQ and causes brain damage.",
      "date": "2019-07-15 00:00:00+00:00"
    },
    {
      "id": "bb6e44b5-e6fa-41e5-b9b4-01888e573dc2",
      "text": "The CDC is a vaccine company, not an independent agency; it owns over 20 vaccine patents and sells $4.6 billion of vaccines each year.",
      "date": "2021-04-03 00:00:00+00:00"
    },
    {
      "id": "f5cc4086-25d9-4aee-94ab-c0c7ced1e49f",
      "text": "Poroshenko offered to exchange Crimea for NATO membership.",
      "date": "2019-03-17 13:11:30"
    },
    {
      "id": "b1de1ae8-1407-49d3-bcca-295522f57b1c",
      "text": "An NIH-published study found that N95 COVID masks expose wearers to dangerous levels of toxic compounds linked to seizures and cancer.",
      "date": "2023-08-30 00:00:00+00:00"
    },
    {
      "id": "e1e225d7-a8c1-4486-b299-b092e0b88821",
      "text": "Ukrainian military sabotages elections in Donbas.",
      "date": "2019-04-21 19:11:44"
    },
    {
      "id": "93eb7a62-784b-41f3-ad72-e305d7708a90",
      "text": "Bloody Canadian mercenaries are in Donbas.",
      "date": "2020-01-20 20:20:51"
    },
    {
      "id": "7ba5b1af-4476-4bf4-91a0-406a281c4b05",
      "text": "Belarusian pilots are long dead and are not fighting against Ukraine.",
      "date": "2022-03-03 10:35:21"
    },
    {
      "id": "75deecc6-6c67-4640-8c9d-7b6492f73f3e",
      "text": "COVID-19 vaccines are 98 times more harmful than COVID-19 infection.",
      "date": "2022-09-12 00:00:00+00:00"
    },
    {
      "id": "1f252834-436a-4e67-a2c6-64a940bbed3e",
      "text": "Mothers of Russian soldiers were found to have received grants from the United States government.",
      "date": "2014-09-04 13:00:08"
    },
    {
      "id": "8c9326f1-ae17-4b5a-a7ec-52c65d9325a4",
      "text": "Arseniy Yatsenyuk rejected a debt restructuring proposal.",
      "date": "2015-11-20 23:24:27"
    },
    {
      "id": "2db653b7-ee92-4ec9-b180-72c043d2d0c7",
      "text": "Masks protect people from COVID-19, so no one needs a flu shot right now.",
      "date": "2020-05-10 00:00:00+00:00"
    },
    {
      "id": "49175056-e0aa-486d-86ef-95663f8e67dc",
      "text": "A COVID-19 vaccine contains an aborted male fetus.",
      "date": "2020-11-15 00:00:00+00:00"
    },
    {
      "id": "5cefc9a4-e804-4c37-a8c1-e474cf868791",
      "text": "Masks on children are ineffective",
      "date": "2021-08-24 00:00:00+00:00"
    },
    {
      "id": "b1af5fde-5c96-4e5a-8d9d-69f766f223b6",
      "text": "Ukraine is placed on a map of modern Nazism.",
      "date": "2015-07-06 15:54:13"
    },
    {
      "id": "b9304938-a12f-4080-b0f9-37024e495985",
      "text": "Countries that sign the pandemic treaty cede their sovereignty to the WHO, which controls their domestic policies, forces vaccinations and lockdowns, and arrests vaccine opponents.",
      "date": "2024-06-06 00:00:00+00:00"
    },
    {
      "id": "67e7e226-46eb-449a-b97b-11d2bb7990a4",
      "text": "Danish researchers found high rates of adverse events following the Pfizer COVID-19 vaccine, and the vaccine is unsafe.",
      "date": "2023-07-05 00:00:00+00:00"
    },
    {
      "id": "529747e6-c84c-4008-a3ec-058fe174bbff",
      "text": "A randomized controlled trial of 2.7 billion people showed hydroxychloroquine reduced the COVID-19 death rate by 79.1%.",
      "date": "2020-08-05 00:00:00+00:00"
    },
    {
      "id": "dcfe43e5-7b7b-4fe0-8bc0-50f6bb6f670c",
      "text": "Azov threatened to destroy Dutch citizens if the Netherlands rejected the association deal with Ukraine.",
      "date": "2016-01-19 11:06:55"
    },
    {
      "id": "80c32eed-7994-498e-84b0-b0a8048e0b19",
      "text": "Scientists have found CO2 and global temperature are not consistently correlated, and scientists do not know whether Earth will warm or cool in the future.",
      "date": "2022-10-12 00:00:00+00:00"
    },
    {
      "id": "eecd938c-ba83-4a0a-8c06-727917605325",
      "text": "The measles vaccine caused the measles outbreak in Texas and measles vaccines cause measles outbreaks.",
      "date": "2025-02-17 00:00:00+00:00"
    },
    {
      "id": "37b437be-8af2-4ac3-89c0-21c2cea00254",
      "text": "The Amazon is switching from tropical rainforest to savannah.",
      "date": "2020-10-05 00:00:00+00:00"
    },
    {
      "id": "789c2b70-403d-4eb1-9a24-21da93e3ad36",
      "text": "Volodymyr Zelenskyy bought a hotel-casino in Cyprus using U.S. government funds.",
      "date": "2024-06-09 11:46:00"
    },
    {
      "id": "4d39d39d-6cb0-4725-b395-c44a7955cbef",
      "text": "Russia deliberately slowed its offensive to avoid civilian casualties.",
      "date": "2022-08-29 18:24:00"
    },
    {
      "id": "79cbda05-a678-4a17-b8c4-5f92dca28086",
      "text": "Kyiv bans Easter by forbidding people from entering churches.",
      "date": "2023-04-15 09:57:03"
    },
    {
      "id": "37915a45-2e81-47c4-924c-400eef8d84ff",
      "text": "The Coalition of the Willing plans to partition Ukraine to seize its resources.",
      "date": "2025-09-10 00:00:00+00:00"
    },
    {
      "id": "ffa4f281-0e0f-490e-be58-b80f76c9674a",
      "text": "Sanctions on Russia cost Ukraine $98 billion.",
      "date": "2016-04-29 20:49:20"
    },
    {
      "id": "ea35a604-407f-4c7b-a6af-da4d03840f1b",
      "text": "American missiles were found in Luhansk.",
      "date": "2015-07-23 20:07:27"
    },
    {
      "id": "ad1c1bc2-4a4f-4bdf-b6b9-e9f2d807bee5",
      "text": "Conflicting numbers on Ukrainian children abductions show that deportations did not occur.",
      "date": "2025-08-19 00:00:00+00:00"
    },
    {
      "id": "1b4a2485-6962-4b36-8c3c-da83d1b18b70",
      "text": "COVID-19 vaccines are experimental, do not prevent infection or transmission, and most people have a 0.05% chance of dying from COVID-19.",
      "date": "2021-10-04 00:00:00+00:00"
    },
    {
      "id": "e2df60bd-689b-44c5-a618-e4e1f0676cf5",
      "text": "Sweden's COVID-19 death rate was lower than Spain's, Italy's, and the U.K.'s, despite Sweden not implementing a lockdown.",
      "date": "2020-08-16 00:00:00+00:00"
    },
    {
      "id": "a221a2d7-fd93-4ffa-befb-59ad7e2b05c1",
      "text": "Britain apologized to Boris Johnson.",
      "date": "2018-03-19 13:04:42"
    },
    {
      "id": "335fef47-0cc2-4ccb-a42f-50c52e23d7c1",
      "text": "Hundreds of Ukrainian soldiers deserted to Russia and asked for asylum there.",
      "date": "2014-08-06 17:50:09"
    },
    {
      "id": "872b8944-72a7-4d07-a1c4-a5ef2eea3320",
      "text": "Members of the British Parliament denounced EU interference in Ukraine.",
      "date": "2015-02-22 12:07:19"
    },
    {
      "id": "8fc73765-f64d-469a-bdf3-d37328bf1161",
      "text": "International MH17 investigation team ignored Russian radar data.",
      "date": "2016-10-09 19:12:05"
    },
    {
      "id": "41c6e347-6c57-4ab9-9e83-1eed3caab677",
      "text": "Ukraine has banned New Year celebrations because Ded Moroz is Russian.",
      "date": "2014-11-26 12:07:14"
    },
    {
      "id": "c7829b30-8d83-461a-a1dc-e5669dad7ba9",
      "text": "The Ukrainian parliament registered a law that criminalizes criticism of the government.",
      "date": "2015-11-03 22:34:58"
    },
    {
      "id": "941d2a71-a7d6-4664-bc9b-62c65c5ffca0",
      "text": "Ukraine has one of the highest levels of organized crime in the world.",
      "date": "2017-11-29 18:24:08"
    },
    {
      "id": "f7deed28-897c-4051-bd3e-0a9ab0a70e8f",
      "text": "Solfeggio frequencies regenerate the human body, remove bodily toxins, and eliminate negativity.",
      "date": "2022-09-30 00:00:00+00:00"
    },
    {
      "id": "4c70dd4e-ea1f-43dc-98ff-7e84438541f5",
      "text": "The United Nations recognized Russia's telephone code for Crimea.",
      "date": "2018-03-19 13:09:34"
    },
    {
      "id": "af3dbf49-d094-4fbe-b7c6-25808686dfa6",
      "text": "Ukraine cut off electrical power to Crimea",
      "date": "2015-07-01 18:42:45"
    },
    {
      "id": "e8a2b3a6-e7d5-4b94-a0c7-f91a8ea464c4",
      "text": "Ukrainians want referendums in Russian-occupied territories.",
      "date": "2022-08-15 13:34:27"
    },
    {
      "id": "d2df6d4b-3f0b-453c-bf5b-701933c7e698",
      "text": "Climate change is a natural, constant cycle that occurred without human influence and human activity does not significantly affect the climate.",
      "date": "2022-10-02 00:00:00+00:00"
    },
    {
      "id": "25efad13-58c1-4831-9756-06e196594909",
      "text": "Pfizer's COVID-19 vaccine was tested on only 250 people.",
      "date": "2023-07-26 00:00:00+00:00"
    },
    {
      "id": "7f530241-1694-4141-8897-e029b0320e13",
      "text": "Wind energy kills more birds than fossil fuels, and renewable energy is causing mass bird deaths.",
      "date": "2022-04-23 00:00:00+00:00"
    },
    {
      "id": "e34e39b3-2fbd-4773-bb14-66e16fb66996",
      "text": "Shark Tank investors, Dr. Phil, and Dr. Oz endorsed CBD gummies, and CBD gummies provide numerous health benefits.",
      "date": "2022-03-11 00:00:00+00:00"
    },
    {
      "id": "83f2971d-2fc3-4df6-9e5f-97a52f7be26e",
      "text": "Colored blocks printed on toothpaste tubes indicate whether the toothpaste is made of safe ingredients.",
      "date": "2024-05-31 00:00:00+00:00"
    },
    {
      "id": "b23e65b1-6283-4c3b-b01e-46927d683e14",
      "text": "The Ukrainian government demands 75% of radio airtime be Ukrainian music.",
      "date": "2016-04-01 12:27:14"
    },
    {
      "id": "e6596626-ac9a-4f3a-a794-8b5b8e63711b",
      "text": "OSCE confirmed there are no Russian military forces in Donbas.",
      "date": "2016-09-13 16:38:38"
    },
    {
      "id": "c7dc4d17-3c9f-4f1a-8849-8edf3cbfdda5",
      "text": "President Petro Poroshenko was stripped of Verona honorary citizenship because he stole paintings.",
      "date": "2018-10-12 15:52:04"
    },
    {
      "id": "78aca2a1-2f9b-463a-85c4-8a95500256f3",
      "text": "Samoa withdrew the MMR vaccine after two babies died within minutes of receiving the MMR shot.",
      "date": "2019-10-24 00:00:00+00:00"
    },
    {
      "id": "a9b84cf4-c9fc-42b0-b615-322ed7497c2f",
      "text": "Wisdom teeth are meridian lines connected to the heart and removing wisdom teeth causes heart problems.",
      "date": "2024-08-14 00:00:00+00:00"
    },
    {
      "id": "1819efd9-1057-4ec9-92a5-e84923e4c147",
      "text": "The United States is using Ukraine as a guinea pig to test vaccines.",
      "date": "2020-11-14 13:07:00"
    },
    {
      "id": "7e985f17-a69e-4ed5-bf5c-461248b507a9",
      "text": "Hydroxychloroquine, azithromycin, and zinc cure COVID-19.",
      "date": "2020-07-08 00:00:00+00:00"
    },
    {
      "id": "772b5976-97f2-4a12-95c8-3f67f08ffee6",
      "text": "A 51-million-person study found COVID-19 vaccines increase the risk of respiratory infections by 559%.",
      "date": "2025-11-11 00:00:00+00:00"
    },
    {
      "id": "41fa445b-dce3-4c84-82a5-bf1898a19393",
      "text": "Aircraft are spraying chemical gases containing aluminum, barium, and other metals to block the sun and create chemical rain and fog to manipulate the weather.",
      "date": "2025-02-14 00:00:00+00:00"
    },
    {
      "id": "407e8b61-b3db-4edd-950e-2c807109ba23",
      "text": "Ukrainian President Volodymyr Zelensky ordered the Catherine II statue in Odesa to be replaced with a monument of a US porn star.",
      "date": "2022-08-03 11:31:00"
    },
    {
      "id": "11753fbd-fc9c-402d-9811-3a69df087b20",
      "text": "Pfizer's clinical trial showed equal numbers of deaths in the vaccine and placebo groups, so the vaccine had no benefit.",
      "date": "2023-10-21 00:00:00+00:00"
    },
    {
      "id": "fafcf85e-287c-4677-80fa-62bdaa6b7702",
      "text": "A person's immune system strength can be determined by looking at their eyes.",
      "date": "2022-05-09 00:00:00+00:00"
    },
    {
      "id": "70a16720-d268-4f35-8e36-ad170ce32bcf",
      "text": "More than 88% of ICU patients in Germany are vaccinated, and COVID-19 vaccines do not protect against severe disease.",
      "date": "2022-11-13 00:00:00+00:00"
    },
    {
      "id": "e95db749-5098-4ec6-9345-aec6a1d3b8b6",
      "text": "The Great Barrier Reef is experiencing the largest bleaching event ever recorded.",
      "date": "2020-04-06 00:00:00+00:00"
    },
    {
      "id": "fe0988b3-260b-4fff-8d24-d9fa3d1fa95c",
      "text": "Ukraine supplied Azerbaijan with phosphorus weapons.",
      "date": "2022-11-30 16:57:00"
    },
    {
      "id": "03dc2d2b-ec15-4eff-9790-593d2a773e75",
      "text": "World leaders were duped into investing billions because global warming data was manipulated.",
      "date": "2017-06-02 00:00:00+00:00"
    },
    {
      "id": "61090b8f-c351-4d39-b293-02d496c4ca2d",
      "text": "The Delta variant of SARS-CoV-2 has a lower fatality rate than the original (Wuhan) variant.",
      "date": "2021-07-04 00:00:00+00:00"
    },
    {
      "id": "e4d88dec-37e3-4c03-86f7-7faaa4a822a6",
      "text": "The UN will not provide money to the Ukrainian government.",
      "date": "2017-12-04 07:08:53"
    },
    {
      "id": "dbe5cb87-6836-4dd6-a307-d04dc800cde1",
      "text": "Ukraine authorized Poland to distribute Ukrainian passports.",
      "date": "2022-07-15 16:04:00"
    },
    {
      "id": "0747b3a4-c669-4df5-808a-d613cadeec1a",
      "text": "Nicotine patches cure Parkinson’s disease.",
      "date": "2024-05-31 00:00:00+00:00"
    },
    {
      "id": "51cd1cdb-d1fb-4f80-b303-18db54827cf5",
      "text": "A Ukrainian Army tank crushed a car containing a passenger.",
      "date": "2016-12-15 21:30:16"
    },
    {
      "id": "39f943a4-0a7d-4621-b7a7-5c0be2d61db5",
      "text": "A record number of Ukrainian tourists visited Crimea.",
      "date": "2017-05-09 16:17:55"
    },
    {
      "id": "a4dcd6e9-eeda-4dfb-9c64-117707d0a66c",
      "text": "COVID-19 PCR tests are inaccurate, have been discontinued, and cannot differentiate influenza from COVID-19.",
      "date": "2021-07-26 00:00:00+00:00"
    },
    {
      "id": "d485c361-9b6d-4071-87fe-6aacd4cd6180",
      "text": "Ukrainian President Volodymyr Zelenskyy exempted relatives of Galicia Division soldiers from conscription.",
      "date": "2025-05-07 00:00:00+00:00"
    },
    {
      "id": "1e091d8f-eedd-4c4a-b128-1d8c08550b36",
      "text": "COVID-19 vaccines are causing a rise in heart attacks among young people.",
      "date": "2023-02-27 00:00:00+00:00"
    },
    {
      "id": "b59a7553-ce15-4155-84ae-a924e79313a4",
      "text": "Ukraine refuses Western arms due to supply difficulties.",
      "date": "2023-12-12 14:51:00"
    },
    {
      "id": "3c5f91b2-eb4d-4fe5-a274-f1526c2230d8",
      "text": "Lockdowns and face masks do not control the COVID-19 pandemic.",
      "date": "2020-11-13 00:00:00+00:00"
    },
    {
      "id": "d7b4ec5f-6db9-4bd8-b2d1-46940bbd2d84",
      "text": "The European Union warned Ukraine against militarizing the Sea of Azov.",
      "date": "2018-10-27 18:08:53"
    },
    {
      "id": "cfd59ee6-711b-453c-8505-5bc0e9d0499b",
      "text": "COVID-19 vaccine spike proteins accumulate in cell nuclei, destroy DNA repair pathways causing cancer, and destroy the immune system.",
      "date": "2021-11-05 00:00:00+00:00"
    },
    {
      "id": "5c9afadf-bdd1-4b6f-90a5-1539e037df31",
      "text": "COVID-19 immunity lasts for years.",
      "date": "2021-01-06 00:00:00+00:00"
    },
    {
      "id": "db3e2d4f-8f74-418a-94d6-6dd00d5ff23a",
      "text": "Ukraine is preparing terrorist attacks in Crimea.",
      "date": "2018-07-12 22:37:24"
    },
    {
      "id": "fa6bd3a3-a782-4525-8065-d7c55a7d2524",
      "text": "Rockefeller suppressed natural healing modalities to profit from petroleum-based medicine and had natural medicine practitioners arrested and jailed.",
      "date": "2023-05-09 00:00:00+00:00"
    },
    {
      "id": "39ced119-b9ff-4dd5-bffb-c2b0dfac001e",
      "text": "Flights from New Zealand to Argentina connect through the U.S., which proves the Earth is flat.",
      "date": "2025-02-14 00:00:00+00:00"
    },
    {
      "id": "51c6b7ce-bcd6-4d3e-a738-a4be010d31de",
      "text": "The CDC is a vaccine company that owns over 20 vaccine patents and sells $4.6 billion in vaccines every year.",
      "date": "2021-02-19 00:00:00+00:00"
    },
    {
      "id": "3bf74375-2e58-4af8-81f7-5bd09e663411",
      "text": "Immediate widespread use of high doses of vitamin C will stop the coronavirus pandemic.",
      "date": "2020-01-26 00:00:00+00:00"
    },
    {
      "id": "ace2a506-60b7-423b-9530-21d89ee724c1",
      "text": "A new language law makes Ukrainian the only official language.",
      "date": "2017-01-25 19:26:31"
    },
    {
      "id": "55db5b56-74ee-471d-b522-65a8bf2f70c4",
      "text": "Birch trees were chopped down in Lviv to prevent Russian influence.",
      "date": "2014-07-02 14:00:43"
    },
    {
      "id": "fc96abd7-8ce2-4450-bfd6-951a94697ffc",
      "text": "Smoking protects against COVID-19.",
      "date": "2020-04-23 00:00:00+00:00"
    },
    {
      "id": "151026d8-aa87-4c5e-a1ed-b5a85230e132",
      "text": "Vaccinated people are more likely to die from the Delta variant than unvaccinated people.",
      "date": "2021-07-16 00:00:00+00:00"
    },
    {
      "id": "e11aef87-b457-45ce-bf4e-efda03b4bed1",
      "text": "Ukraine’s Defense Minister declared World War III and urged the West to raise the stakes.",
      "date": "2022-06-30 17:53:00"
    },
    {
      "id": "260d2849-6e85-4bd7-a5e0-3533d6ec5909",
      "text": "Vaccination causes two deaths for every three deaths it prevents.",
      "date": "2021-06-24 00:00:00+00:00"
    },
    {
      "id": "90bdfa4e-b4a0-443d-84a2-56ac539d802a",
      "text": "Global warming is causing polar bears to go extinct.",
      "date": "2020-07-27 00:00:00+00:00"
    },
    {
      "id": "20f72b01-a541-48db-a97c-ad35b82d6dfe",
      "text": "Natalie Jaresko, Ukraine's Minister of Finance, is the sister of former president Viktor Yushchenko's wife.",
      "date": "2014-12-15 01:33:18"
    },
    {
      "id": "27df6cfc-a1c0-4cca-9425-b5897788f1d8",
      "text": "Ukraine recruits mentally unstable foreign fighters.",
      "date": "2024-09-23 10:19:00"
    },
    {
      "id": "0a2b3c34-28d6-4c0f-b765-6820ab6a46c7",
      "text": "Germany asked the United States to ease sanctions on Russia.",
      "date": "2018-04-19 22:23:03"
    }
  ],
  "events": [
    {
      "id": "38817e72-8ea6-4a91-8032-30eba5f54cb7",
      "text": "Japan suspended use of multiple Moderna COVID‑19 vaccine lots after reports of black/foreign particles found in vials (September 2021).",
      "date": "2021-09-17 00:00:00"
    },
    {
      "id": "3a17acef-1782-4e5f-aa26-098cc82ab82a",
      "text": "Media coverage and public records requests highlighted increases and registration of 'Sudden Adult Death Syndrome' (SADS) entries and prompted local registries/news stories in 2021–2022 (e.g., ONS FOI data and June 2022 press stories).",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "96c10070-a729-45d2-a388-f0bf828e9f4f",
      "text": "Federal judge orders FDA to hasten release of Pfizer COVID-19 vaccine documents after agency proposed a 75‑year timeline.",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "2157e893-ff88-41ee-b94d-63bdd6b33a42",
      "text": "Public health agencies (including the CDC) acknowledged a rare association between mRNA COVID‑19 vaccines and myocarditis/pericarditis, particularly in younger males (June 2021 and onward).",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "379de43d-cf89-4e1c-a6bd-ea204190dd70",
      "text": "Canada officially declared bisphenol A a 'toxic substance' and banned BPA in baby bottles (widely reported in October 2010).",
      "date": "2010-10-14 00:00:00"
    },
    {
      "id": "936b959b-6c76-4051-89f6-fe1ec2bee40e",
      "text": "EU Regulation 2018/213 restricting the use of BPA in varnishes and coatings intended to come into contact with food (adopted 12 February 2018).",
      "date": "2018-02-12 00:00:00"
    },
    {
      "id": "dce49401-863e-4c6f-893a-323fab28b5ec",
      "text": "Authoritative public health pages (e.g., NIEHS) and large NGOs published accessible summaries about BPA being an endocrine disruptor and a substance under active study for health effects (updated educational pages in 2020–2021).",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "b6971264-6ca4-4aa5-a164-3d9bd552bfa7",
      "text": "German federal and state governments adopted and publicised '2G' rules that restricted access to restaurants, cultural venues and events to vaccinated or recovered people.",
      "date": "2021-11-16 00:00:00"
    },
    {
      "id": "7ab19c87-15df-4cbb-987d-eb9014edeb27",
      "text": "Large anti-lockdown/anti-vaccine protests in Berlin where police used barriers, cordons and force to control crowds.",
      "date": "2021-08-28 00:00:00"
    },
    {
      "id": "4b078541-759d-4b6e-b215-cf946dc4f2f7",
      "text": "Lancet Psychiatry cohort study (Taquet et al.) reporting increased incidence of neurological and psychiatric diagnoses — including psychotic disorders — in the six months after COVID-19 infection.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "a40f6c4b-f04b-414e-86bb-e50d7519d701",
      "text": "NATO commander publicly reported sightings of columns of Russian tanks and troops crossing into eastern Ukraine.",
      "date": "2014-11-12 00:00:00"
    },
    {
      "id": "6bbad3e4-8bce-455f-b619-561b2fa64940",
      "text": "Investigative reporting (e.g., Bellingcat) published satellite analysis and open‑source investigations documenting cross‑border convoys and movements of heavy weapons into separatist‑held areas.",
      "date": "2016-06-15 00:00:00"
    },
    {
      "id": "5b2a3322-05ed-40ad-a7e2-263881ca929a",
      "text": "The February 2015 Minsk II agreement called for withdrawal and monitoring of heavy weapons but left verification and inventories contested.",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "db951ce3-0774-4b1b-8098-c783a8e0060a",
      "text": "National Child Mortality Database (NCMD) data release: child death notifications in England Apr 2021–Mar 2022 (3,470 deaths; 396 more than previous year)",
      "date": "2022-11-10 00:00:00"
    },
    {
      "id": "4ee8388c-21bf-46da-b34d-6c991d81c123",
      "text": "Kerch Strait incident — Russian forces fired on and seized three Ukrainian naval vessels near the Kerch Strait.",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "fec0b6e7-7749-48a6-a023-a4649ca36af7",
      "text": "Odesa Trade Unions building fire — violent clashes on 2 May 2014 ended with a fire that killed dozens; accounts of responsibility were disputed.",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "ad77c269-8758-44cf-ab9b-5ccaf6f7e0c7",
      "text": "Maidan sniper shootings — dozens of protesters and police were killed during the February 2014 Maidan clashes; responsibility for the snipers remained contested.",
      "date": "2014-02-20 00:00:00"
    },
    {
      "id": "d2a9eeda-e0d7-4adf-8acf-5dd5b1b69038",
      "text": "GUE/NGL (European United Left/Nordic Green Left) letter to President Poroshenko expressing concern about banning the Communist Party and alleged persecution of left‑wing groups",
      "date": "2016-06-23 00:00:00"
    },
    {
      "id": "6eb99b34-dbe3-49ad-a849-160d8c11f9bb",
      "text": "Court ban on the Communist Party of Ukraine (Kyiv administrative court decision reported December 2015)",
      "date": "2015-12-17 00:00:00"
    },
    {
      "id": "f4b4255f-ed8a-498a-938a-a7347ca9e79f",
      "text": "Panama Papers revelations naming Poroshenko's offshore connections (widespread reporting in April 2016)",
      "date": "2016-04-04 00:00:00"
    },
    {
      "id": "39785e4f-77f4-4b08-ad16-8fe094cb7be1",
      "text": "Fugitive lawmaker Oleksandr Onyshchenko's public corruption accusations against Poroshenko (June 2016)",
      "date": "2016-06-24 00:00:00"
    },
    {
      "id": "684992a5-2c7c-47b9-9d0a-da99a5d62d04",
      "text": "Court-ordered release and ongoing discussion of Pfizer/BioNTech vaccine documents (PHMPT/FDA document release process)",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "89efe27f-5d32-4380-9e65-7644e8368672",
      "text": "Venice Commission (Council of Europe) publishes an expert opinion on the 2019 language law raising concerns about minority-language guarantees",
      "date": "2019-12-06 00:00:00"
    },
    {
      "id": "ea8eba9e-8051-4f71-8589-621e0f0ca050",
      "text": "Ukrainian parliament adopts the law 'On Ensuring the Functioning of Ukrainian as the State Language'",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "45cd2538-8b5c-46ce-8c0a-b42354ca8b17",
      "text": "Immediate political/media backlash and Kremlin-linked commentary framing the law as an attack on Russian speakers",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "367805bd-60b6-459f-8aa6-ba7e91ca4158",
      "text": "Long‑running Kremlin/state media narrative labeling the Azov movement and affiliated groups as 'neo‑Nazi' and dangerous.",
      "date": "2022-03-29 00:00:00"
    },
    {
      "id": "dc10dd9a-4b20-48d2-b195-51777fbd3cc3",
      "text": "Denis Pushilin / DPR authorities declared OSCE activities in DPR unlawful and ordered SMM property removed (escalatory political declaration).",
      "date": "2022-04-09 00:00:00"
    },
    {
      "id": "db80f6e7-5b5a-4d3d-8a7f-0976038fa7ae",
      "text": "OSCE SMM evacuated international monitors and then discontinued the Special Monitoring Mission (loss of on‑the‑ground oversight and telemetry).",
      "date": "2022-03-31 00:00:00"
    },
    {
      "id": "a0a156cd-e22a-4c3b-b5d6-ee9a61dfb941",
      "text": "High-profile advocacy and testimony for ivermectin (FLCCC / Dr. Pierre Kory Senate testimony, Dec 8, 2020)",
      "date": "2020-12-08 00:00:00"
    },
    {
      "id": "146f7a30-90f1-441d-b120-fdb2884775c6",
      "text": "Circulation of prominent preprints and small trials (notably the Elgazzar et al. preprint, Nov 2020) reporting large mortality benefits that fed pooled meta-analyses",
      "date": "2020-11-13 00:00:00"
    },
    {
      "id": "3221eac8-87f2-4ae4-94a3-10488319adb7",
      "text": "U.S. announcement to withdraw from the Paris Agreement (President Trump)",
      "date": "2017-06-01 00:00:00"
    },
    {
      "id": "99d301bd-3e4f-4202-8c65-4e13eb4a35a6",
      "text": "High‑profile congressional testimony by climate skeptic John R. Christy asserting climate models overstate warming",
      "date": "2019-07-24 00:00:00"
    },
    {
      "id": "714c48f9-1de5-4102-baec-011c0b404f87",
      "text": "Poland warns it could veto the EU budget over rule‑of‑law conditionality",
      "date": "2018-11-09 00:00:00"
    },
    {
      "id": "0d5d70aa-630c-4de6-b6ef-36b85c677f16",
      "text": "European Commission/legal action over refusal to accept refugee relocation quotas",
      "date": "2017-02-24 00:00:00"
    },
    {
      "id": "a3817884-5e86-4a0e-96a0-abc909757b10",
      "text": "European Commission triggers Article 7 procedure against Poland",
      "date": "2017-12-20 00:00:00"
    },
    {
      "id": "1ca906e2-b0d3-439a-9c6e-9948f1d03d8a",
      "text": "Mass protests after president signs contested judicial reform laws",
      "date": "2018-07-26 00:00:00"
    },
    {
      "id": "fb127d47-1234-4c65-9c3c-1877970b3eb0",
      "text": "Documented NGO and foundation support for Crimean Tatar NGOs (e.g., listings of NED and other international support for Crimean NGO activity after 2014)",
      "date": "None"
    },
    {
      "id": "4735f952-560a-4efc-bd14-23bc7888a8c1",
      "text": "Russian courts moved to ban and label the Mejlis 'extremist' (legal actions and formal prohibition)",
      "date": "2016-04-26 00:00:00"
    },
    {
      "id": "0810a5c9-b58b-4ec5-adbd-103a2842ffe2",
      "text": "High-profile visits and statements by Mejlis leaders to international bodies (OSCE/UN/US) — e.g., Mustafa Dzhemilev meetings in 2015",
      "date": "2015-01-30 00:00:00"
    },
    {
      "id": "d887d1af-80cd-48ae-a8cc-124464d09ea2",
      "text": "Czech President Petr Pavel said in public interviews that Ukraine may need to be 'realistic' about the prospects of liberating all occupied territory and that some areas could remain under Russian control temporarily.",
      "date": "2025-03-24 00:00:00"
    },
    {
      "id": "8170bace-2d7f-4f1f-857a-b06c0eb8d69f",
      "text": "Joint Prague press conference (Pavel and Zelenskiy) and Reuters coverage where Pavel warned the West not to pressure Ukraine into immediate liberation of all territories and said Russia 'has all the cards' to end the war.",
      "date": "2025-05-04 00:00:00"
    },
    {
      "id": "ea179191-dd07-4d44-9c73-fe1f9a8d4df3",
      "text": "Peer-reviewed meta-analysis reported that berberine (a plant alkaloid) showed glucose‑lowering effects in randomized trials, with some comparisons to metformin (systematic review and meta‑analysis, PubMed).",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "3dd7b820-dbf9-418e-8570-ae937593e90f",
      "text": "U.S. FDA and FTC jointly sent warning letters to 10 companies for marketing dietary supplements with unlawful claims to prevent, treat or cure diabetes.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "ee008479-2289-4446-9132-8c75ade20ed3",
      "text": "Japan finds stainless‑steel/foreign particles in multiple Moderna vaccine vials, triggering recalls/pauses",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "f3ddd2b0-3e39-4f9e-8999-561d992acc38",
      "text": "Historical FDA enforcement and public warnings against Hoxsey’s remedies (including 1956–1957 inspections and widely distributed FDA 'Beware' posters).",
      "date": "1957-04-24 00:00:00"
    },
    {
      "id": "92e61383-3536-4054-8579-a904018b2e01",
      "text": "Ukrainian Cabinet of Ministers issued a permit allowing Biopharma Plasma to export 32 blood‑derived medicinal products (Cabinet resolution No.1005).",
      "date": "2017-12-27 00:00:00"
    },
    {
      "id": "d4814cc2-fa4f-4b64-b524-fbfaf55aac53",
      "text": "Publication of a large Danish national birth‑cohort study (Liew et al.) reporting an association between maternal acetaminophen use in pregnancy and autism spectrum disorder (ASD) with hyperkinetic symptoms.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "c9b9ea97-f8e6-4d40-bb74-fc1ddbb5ea9b",
      "text": "2014 J. Agric. Food Chem. study: quercetin and EGCG shown to have zinc ionophore activity in models",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "829d31db-8aa2-40cc-9c88-773a9efc3573",
      "text": "2014 PLoS ONE report: chloroquine acts as a zinc ionophore",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "c038129f-6a7c-4d41-b509-5fbbde62f12d",
      "text": "Mid‑2020 public promotion: clinicians/influencers (eg. Dr. Vladimir Zelenko) advocated hydroxychloroquine + zinc as a COVID‑19 treatment",
      "date": "2020-07-24 00:00:00"
    },
    {
      "id": "c4ec41ee-edc2-4e97-8286-6ebf940f58a5",
      "text": "October 2020 multicenter cohort (NYU) preprint: 'Zinc with an ionophore associated with reduced in‑hospital mortality'",
      "date": "2020-10-26 00:00:00"
    },
    {
      "id": "482f123e-5c2e-4384-8d1e-b1cf8956ddab",
      "text": "2010 PLoS Pathogens paper: in vitro inhibition of coronavirus polymerase by Zn2+ and blockade of replication by zinc ionophores",
      "date": "2010-11-04 00:00:00"
    },
    {
      "id": "1dc762ef-2efe-452d-b773-d99eb32c7cec",
      "text": "Hungary vetoed a joint NATO statement on Ukraine citing concerns about the rights of the ethnic Hungarian minority",
      "date": "2019-10-30 00:00:00"
    },
    {
      "id": "cc7a9342-86ad-4560-8aad-fdee3a57eb19",
      "text": "Hungary’s simplified naturalisation (citizenship-by‑descent) program resulting in large numbers of passports issued to ethnic Hungarians in Transcarpathia/Zakarpattia",
      "date": "2011-03-24 00:00:00"
    },
    {
      "id": "639887f4-84bc-4417-b01b-6cab4248b8af",
      "text": "Hungarian Prime Minister Viktor Orbán publicly stated during the 2022 Russian invasion that the lives and security of Hungarians in Transcarpathia/Ukraine were a priority for his government",
      "date": "2022-03-03 00:00:00"
    },
    {
      "id": "860f708b-df74-45ba-a4c1-de5320b64832",
      "text": "Media and human‑rights coverage documenting tensions and complaints by the Hungarian minority in Zakarpattia/Transcarpathia during 2017–2022 (language disputes, local political friction)",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "cc943ea3-351c-42c4-814b-690a63727907",
      "text": "U.S. issues Emergency Use Authorization and rapid rollout of Pfizer‑BioNTech vaccine (December 2020)",
      "date": "2020-12-11 00:00:00"
    },
    {
      "id": "9ea199bf-97ff-446a-ade3-676524ef8e19",
      "text": "UK regulator (MHRA) issues guidance after two reports of anaphylaxis following the first Pfizer/BioNTech vaccinations",
      "date": "2020-12-09 00:00:00"
    },
    {
      "id": "6ee2c4a5-b657-4d1c-9444-ffcf3cf9fd89",
      "text": "Pfizer/BioNTech EUA fact sheets and clinical publications note limited data in children and absence of long‑term safety data at authorization",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "4ac88c8b-a6ca-479c-8ef1-3ec6317c887a",
      "text": "Mass stabbing at Westfield Bondi Junction created a chaotic breaking-news environment",
      "date": "2024-04-13 00:00:00"
    },
    {
      "id": "4ded304a-7c7a-4b94-b613-5b71b1cd02af",
      "text": "Major Iberian power blackout on 28 April 2025 that disrupted electricity across Spain and Portugal",
      "date": "2025-04-28 00:00:00"
    },
    {
      "id": "674d7e77-a807-4bcb-b2f0-db7fd01b99dc",
      "text": "Nationwide Telefónica network update caused widespread mobile and emergency-service outages across Spain",
      "date": "2025-05-20 00:00:00"
    },
    {
      "id": "f9f91961-5933-45e4-a97a-0833538d7593",
      "text": "Czech Ministry of Foreign Affairs published an official statement saying the Crimea referendum was held in violation of the Ukrainian constitution, that the Czech Republic does not recognize the referendum results and continues to recognise Crimea as part of Ukraine.",
      "date": "2014-03-16 00:00:00"
    },
    {
      "id": "58f8bc90-56c1-4f8d-8932-e115eb1eb493",
      "text": "Czech President Miloš Zeman publicly criticised Western sanctions and expressed skepticism about their effectiveness in interviews/statements in March 2014.",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "8eaf0a96-0a0d-4ce1-91c1-5dddff9ddc32",
      "text": "Release of GLOBOCAN 2022 global cancer estimates showing large numbers of new cancer cases and highlighting female breast cancer as one of the most common cancers",
      "date": "2023-02-24 00:00:00"
    },
    {
      "id": "035c0704-fde6-402a-bd64-295dcc5ab480",
      "text": "Publication of national cancer registration statistics for England (Cancer registrations 2022) showing higher numbers of cancers diagnosed in 2022 compared with 2021",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "00a36aae-c5bb-448e-ab16-0395d0b70515",
      "text": "GRELL cooperative study (2013) and similar national registry analyses showing modest annual increases in breast cancer incidence among women under 40 in several European countries",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "bd2cfaed-5d7a-4929-beb3-86245cd1c054",
      "text": "Publication of analyses and commentary about the impact of COVID‑19 on cancer services and screening (UK/NHS context) documenting diagnostic backlogs and subsequent rises in diagnoses when services resumed",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "64d50dc5-383a-4f9d-80be-93d978bdc313",
      "text": "Prominent visibility of far‑right/ultranationalist groups (e.g., Right Sector) in Maidan protests",
      "date": "None"
    },
    {
      "id": "87fa4685-aa79-4eed-b5cb-50f8aef33b49",
      "text": "Seizures of regional government buildings and street clashes in eastern/southern Ukraine (Donetsk, Kharkiv) in early March 2014",
      "date": "2014-03-01 00:00:00"
    },
    {
      "id": "768dac8b-d8e9-4bcb-97f6-1ed7eb45ef31",
      "text": "Widespread toppling/removal of Lenin statues across Ukraine (the 'Leninopad')",
      "date": "None"
    },
    {
      "id": "6c0852dc-908f-4e43-8e65-b39c0a942d84",
      "text": "High local tensions and protests in Lviv during February 2014, with public gatherings and confrontations around symbolic sites",
      "date": "2014-02-21 00:00:00"
    },
    {
      "id": "28477e2e-b2d0-4bea-aa09-8f91c8ed2caf",
      "text": "Russian/state media narratives framing the Kyiv movement as 'fascists' and amplifying isolated incidents",
      "date": "2014-03-04 00:00:00"
    },
    {
      "id": "363e93cb-9979-4571-81a4-9becd07d7e1b",
      "text": "President Trump publicly urged the FDA to 'fast-track' potential COVID-19 treatments, including hydroxychloroquine",
      "date": "2020-03-19 00:00:00"
    },
    {
      "id": "14394b9e-6ed0-474f-8195-ae45ad8886e8",
      "text": "ClinicalTrials.gov registrations for thalidomide trials in COVID-19 (e.g., NCT04273581)",
      "date": "2020-02-18 00:00:00"
    },
    {
      "id": "9f75fed9-5379-4ae5-ad35-29573d717166",
      "text": "Moderna announces first participant dosed in NIH-led mRNA-1273 Phase 1 vaccine trial",
      "date": "2020-03-16 00:00:00"
    },
    {
      "id": "a865b697-9c11-451c-b357-6deb59025afe",
      "text": "OSCE Representative on Freedom of the Media condemns attacks and detentions of journalists in eastern Ukraine",
      "date": "2014-06-03 00:00:00"
    },
    {
      "id": "6bb25525-db36-48fa-928f-3c54ff5192b7",
      "text": "Two Russian state television journalists (Igor Kornelyuk and Anton Voloshin) killed by mortar fire near Luhansk",
      "date": "2014-06-17 00:00:00"
    },
    {
      "id": "557f5241-833b-4d75-bd17-d5e083a9c848",
      "text": "Italian photojournalist Andrea Rocchelli killed near Sloviansk while reporting on Donbas fighting",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "3aa14a59-17e4-4777-8e1d-8ae3f9be02bb",
      "text": "Scientific literature demonstrating decades of 'edible vaccine' research (2019 review 'Edible Vaccines: Promises and Challenges')",
      "date": "2019-11-22 00:00:00"
    },
    {
      "id": "1197b256-f2e7-4f92-8cd6-82ff67958352",
      "text": "U.S. House passes amendment to prohibit funding for 'transgenic edible vaccines' (Massie amendment)",
      "date": "2023-09-27 00:00:00"
    },
    {
      "id": "7c7d2966-8267-4911-af9c-12c9f638b50a",
      "text": "Health Canada approval of Medicago's plant‑based COVID-19 vaccine (COVIFENZ)",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "48aa818f-0004-46f4-b264-5cf6bfd86d44",
      "text": "2014 reports and analyses on prevention of smuggling of nuclear and radioactive materials at the Ukraine–Moldova border",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "c3652003-e9b3-4858-9187-97009a81a649",
      "text": "2015 reporting on large volumes of spent nuclear fuel stored in exposed open-air yards at Zaporizhia NPP",
      "date": "2015-05-06 00:00:00"
    },
    {
      "id": "7d8c806e-235f-4780-b922-e4b749fe7829",
      "text": "WHO interim guidance on mask use (published 5 June 2020) noted there was 'no direct evidence' from community studies on universal masking",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "507f1d48-65d3-4331-b334-74205ccc9cf6",
      "text": "Russia began issuing Russian passports to residents of occupied Donetsk and Luhansk (passportisation program, reported from 2019 onward)",
      "date": "2019-06-24 00:00:00"
    },
    {
      "id": "be24cc5d-48a1-4fd2-98b6-c84005b2eb5a",
      "text": "Pre‑war remittance and labour links between Ukraine and Russia documented in World Bank data (substantial remittance inflows historically)",
      "date": "None"
    },
    {
      "id": "d79c60ce-8f4c-4997-83e8-d17fafb90523",
      "text": "2001 Ukrainian census shows large Russian‑language population (≈29.6% reported Russian as mother tongue)",
      "date": "2001-04-24 00:00:00"
    },
    {
      "id": "1738a518-ba07-4ca3-9eca-d29ea746b6ce",
      "text": "Media reports (e.g., Reuters, 11 Jan 2023) relayed WHO and other experts saying XBB.1.5 may be driving recent case increases in some areas.",
      "date": "2023-01-11 00:00:00"
    },
    {
      "id": "308fd4d8-6903-4d8c-b2a4-0fbaee4b4fe2",
      "text": "Oxford/UK analyses and technical briefings in July–August 2021 documenting reduced vaccine effectiveness against symptomatic infection with Delta and reporting viral-load related findings.",
      "date": "2021-08-16 00:00:00"
    },
    {
      "id": "7448f12b-9dc9-42a3-b6de-962a71c7ed57",
      "text": "CDC MMWR report on the Provincetown (Barnstable County) outbreak showing many cases among fully vaccinated people and reporting similar viral loads in some vaccinated and unvaccinated cases.",
      "date": "2021-07-30 00:00:00"
    },
    {
      "id": "1f06b3d0-c786-4d72-9b93-21be62274d4a",
      "text": "Ongoing pattern of journalists killed or injured while reporting on the Russia–Ukraine war since 2022.",
      "date": "None"
    },
    {
      "id": "4d8ec00f-12c2-4a55-8fe4-02c2c73feb6c",
      "text": "Escalation of cross‑border fighting and reported Ukrainian incursions into Russia's Kursk region in early August 2024.",
      "date": "2024-08-06 00:00:00"
    },
    {
      "id": "0fdaa2f0-ec41-4eeb-874c-df6ef607bdd9",
      "text": "Retraction of high-profile hydroxychloroquine research (Surgisphere-related Lancet study)",
      "date": "2020-06-04 00:00:00"
    },
    {
      "id": "8197d19e-eceb-4bfe-aba8-d6ddc8230219",
      "text": "U.S. Food and Drug Administration revoked the Emergency Use Authorization (EUA) for hydroxychloroquine and chloroquine for COVID‑19",
      "date": "2020-06-15 00:00:00"
    },
    {
      "id": "a6af24d1-f9dc-483c-a4d8-a6f50fa7b678",
      "text": "Publication of a 2015 review clarifying that peripheral (gut) serotonin and central (brain) serotonin are separate pools because serotonin itself cannot cross the blood–brain barrier.",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "55fab3e5-ba46-4262-ae1c-d37882c30805",
      "text": "Vatican note on the morality of using some COVID-19 vaccines (explicit discussion of fetal‑cell‑line origins)",
      "date": "2020-12-21 00:00:00"
    },
    {
      "id": "4c787be9-0d63-4d4d-bade-049a1d973e67",
      "text": "Public-facing CDC guidance page describing vaccine additives and manufacturing substances (e.g., formaldehyde, aluminum) made widely available",
      "date": "None"
    },
    {
      "id": "fe136853-4ebb-4ed7-a1c3-5bea298e90e1",
      "text": "CDC / AAP precautionary move to remove/reduce thimerosal from childhood vaccines (timeline publicity)",
      "date": "1999-07-24 00:00:00"
    },
    {
      "id": "24221e44-62c5-4978-8daf-953b9cb01868",
      "text": "Detection of porcine circovirus DNA (PCV1) in the Rotarix rotavirus vaccine and global regulator review",
      "date": "2010-03-24 00:00:00"
    },
    {
      "id": "e2efe459-f5bf-48f4-aabb-d2614f71c39a",
      "text": "Assassination of Boris Nemtsov on a bridge near the Kremlin",
      "date": "2015-02-27 00:00:00"
    },
    {
      "id": "dc0244e3-143a-4b9f-a10d-0fb551669113",
      "text": "Vatican Congregation for the Doctrine of the Faith published a note stating it is morally acceptable to receive some COVID-19 vaccines developed using cell lines from aborted fetuses (approved by Pope Francis).",
      "date": "2020-12-21 00:00:00"
    },
    {
      "id": "ebb90c43-c681-4398-a1a7-f903b4292d05",
      "text": "CDC Pink Book Appendix B (Vaccine Excipient and Media Summary) lists cell lines such as WI-38 and MRC-5 in vaccine production context (table circulated online, edition info in use January 2021).",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "bbc04673-2959-4bfd-9506-96a313508f38",
      "text": "American Optometric Association consumer alert about at‑home/online vision tests and devices",
      "date": "2022-10-27 00:00:00"
    },
    {
      "id": "b5c8ae6a-2bf6-428b-8893-ae8ae103b4e3",
      "text": "Russian proposals and measures to fast-track citizenship for Crimean residents",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "7413dd57-157d-4e44-a9c9-ba040174c5c7",
      "text": "Pro-Russian separatists declare Donetsk 'People's Republic' after seizing regional building",
      "date": "2014-04-07 00:00:00"
    },
    {
      "id": "40f46eaa-714a-47d4-9a53-3e4de1e79681",
      "text": "Putin's Kremlin speech endorsing Crimea accession",
      "date": "2014-03-18 00:00:00"
    },
    {
      "id": "045f7b0d-d4a4-4285-9a62-8dabd3dae61c",
      "text": "Delta-variant surge and public messaging (summer 2021) urging vaccination ahead of difficult hurricane-season scenarios",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "d8ac564c-5a0f-499d-86a5-8f9917a9bfb8",
      "text": "Israel reports drop in observed vaccine effectiveness against infection (94% → ~64%) amid Delta",
      "date": "2021-07-05 00:00:00"
    },
    {
      "id": "2157720a-b31f-4765-9e5f-abe16965d54a",
      "text": "Great Barrington Declaration advocating 'focused protection' published",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "c63f59c1-d72b-41e4-a08e-84a2f41ddfe5",
      "text": "Systematic review estimating COVID-19 infection-fatality rate ~0.68%",
      "date": "2020-09-29 00:00:00"
    },
    {
      "id": "3c1df8b6-9533-4c62-a317-a807afa5c317",
      "text": "Age‑stratified IFR analysis showing extremely low fatality risk for younger people",
      "date": "2020-07-24 00:00:00"
    },
    {
      "id": "b80a6589-2541-416c-a08b-60e2d631e5e3",
      "text": "Public availability of VAERS as a passive reporting system and official CDC/FDA guidance about its limitations",
      "date": "None"
    },
    {
      "id": "66670a2a-cbbd-44a6-82ca-4421126b801f",
      "text": "ACIP/CDC recommendation during the 2009 H1N1 pandemic that pregnant women receive H1N1 and seasonal influenza vaccines",
      "date": "2009-10-24 00:00:00"
    },
    {
      "id": "90b7bf11-a8f9-4fa2-98e3-a4dc0f9f14e9",
      "text": "Publication of Goldman GS (2013) 'Comparison of VAERS fetal‑loss reports during three consecutive influenza seasons' (Human & Experimental Toxicology)",
      "date": "2013-05-24 00:00:00"
    },
    {
      "id": "b02e365e-b224-47a8-a9f6-af76ca7fc5de",
      "text": "Reports and analyses in 2015 highlighted growing Hungarian activism in Zakarpattia (large numbers receiving Hungarian passports and political pressure over minority rights throughout 2015).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "b30d79c6-5159-4996-b79a-7752d1373f4f",
      "text": "Think‑tank analysis and regional commentaries described longstanding identity, linguistic and historical fault lines in Zakarpattia and proposals for a «Trans‑Tisa/Transcarpathian» administrative unit (OSW commentary, Sept 2015).",
      "date": "2015-09-30 00:00:00"
    },
    {
      "id": "8f1395d8-01e0-4fab-89cd-d4455bc695bf",
      "text": "Armed clash (Mukachevo shootout) between Right Sector fighters and local security forces in Mukachevo, Zakarpattia, leaving several wounded (11 July 2015).",
      "date": "2015-07-11 00:00:00"
    },
    {
      "id": "c69fc9cd-d7d3-40ed-9c06-f6d6ec253b4d",
      "text": "Local reporting and human-rights outlets flagged that the ‘‘Transcarpathian Rus’’/Rusyn congress and statements by Petro (Pyotr) Getsko were likely provocations amplified by Moscow (coverage March 2015).",
      "date": "2015-03-24 00:00:00"
    },
    {
      "id": "298d23b5-afbb-4e93-8cac-5e76326f04b6",
      "text": "Scuttling of Ukrainian vessels in Donuzlav Bay (6 March 2014) to block naval exits",
      "date": "2014-03-06 00:00:00"
    },
    {
      "id": "8b5a5f1a-b189-4ee1-a515-8f9cfff8233f",
      "text": "Official/legal exhibits and scientific analyses documenting that the Sea of Azov and Kerch Strait routinely experience ice cover that can obstruct navigation (analysis covering up to 2017)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "1bb5060b-06f9-4023-b08d-f341eb37296f",
      "text": "Severe Black Sea freeze restricted navigation and stranded vessels in January 2017",
      "date": "2017-01-12 00:00:00"
    },
    {
      "id": "7e545939-4ee8-40a2-9ae5-81e97f25288f",
      "text": "Russian forces seized multiple Ukrainian naval vessels during the March 2014 Crimea operation",
      "date": "2014-03-20 00:00:00"
    },
    {
      "id": "eb0c521c-32dd-465b-9fe0-cf36781f6670",
      "text": "U.S. Ninth Circuit Court of Appeals issued an opinion (June 7, 2024) vacating the district court's dismissal and allowing a lawsuit challenging LAUSD's COVID‑19 vaccine mandate to proceed; the opinion noted that, at the pleading stage, the court must accept plaintiffs' allegation that the vaccines do not prevent transmission.",
      "date": "2024-06-07 00:00:00"
    },
    {
      "id": "a7d10e01-e281-4f96-a0fa-8dadd3bed992",
      "text": "The U.S. Centers for Disease Control and Prevention revised wording on its website for 'vaccine' and 'vaccination' in September 2021 (shorter/modernized wording replacing earlier phrasing about 'producing immunity').",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "1c3ecb4f-819d-4245-a521-b26ef8088f65",
      "text": "Local activist action in Chernihiv ('Feed the Communist') in May 2015 where activists distributed food kits and removed or replaced communist symbols.",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "56776a04-155a-40b6-a503-9bea56d3cf42",
      "text": "Publication and publicity of studies showing reduced antibody responses in clinically immunocompromised groups (OCTAVE/related studies reported in The BMJ)",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "538f9251-4ba8-4d69-b12f-d9bcb8131631",
      "text": "Stockholm arbitration tribunal ruled in favour of Naftogaz against Gazprom (final award and related rulings published 28 February 2018), ordering significant payments in Naftogaz's favor.",
      "date": "2018-02-28 00:00:00"
    },
    {
      "id": "03d8bffd-1eb9-4588-8236-62839cb3cb49",
      "text": "Publication of a 2015 Danish case series (Brinth et al.) reporting suspected postural tachycardia syndrome (POTS) and related autonomic symptoms following quadrivalent HPV vaccination.",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "aaf575f9-f8ae-402f-9662-f4eb4217d6ee",
      "text": "Danish Medicines Agency and European regulators reviewed reports from Denmark about suspected HPV vaccine adverse events and produced public assessments and data summaries.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "f1abfe62-d77e-4798-bf5e-a3939e34fdf1",
      "text": "2014 French case-control study published in Clinical Rheumatology examining possible associations between the quadrivalent HPV vaccine and new‑onset autoimmune disorders.",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "7598cb80-2cc0-4862-a471-68163a62bb1f",
      "text": "Ukraine’s security service (SBU) announced an investigation that alleged nearly $40 million was embezzled in a mortar‑shell procurement scheme",
      "date": "2024-01-27 00:00:00"
    },
    {
      "id": "4296771e-b956-4ba7-8671-013491e18853",
      "text": "Pentagon Inspector General report found about $1 billion of U.S. weapons sent to Ukraine were not properly tracked",
      "date": "2024-01-11 00:00:00"
    },
    {
      "id": "871e41ff-6e5a-4f51-928d-541f50c7ff7f",
      "text": "Widespread media reports documented an increase in Ukrainians (including some displaced by 2014 unrest) travelling to or taking up work in Russia to escape economic hardship and instability.",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "65983e1e-7638-476f-8f5a-1fd47c0c31f7",
      "text": "Release of the IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers highlighting that recent warming is 'unequivocally' driven by human activities (strong attribution to greenhouse gas emissions).",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "db00dd7f-a5ca-45af-87c3-d65662ede0a0",
      "text": "Global Carbon Project press release and Global Carbon Budget 2021 reporting that global fossil CO2 emissions rebounded close to pre-COVID levels (published early November 2021).",
      "date": "2021-11-04 00:00:00"
    },
    {
      "id": "cfa4b03e-f0df-4958-baeb-631c2383e698",
      "text": "UNFCCC COP26 (Glasgow, Nov 2021) international climate summit and high-profile policy announcements on phasing down fossil fuels.",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "d416ff45-9044-4499-bd89-65cfc821de7e",
      "text": "The extraordinary Pacific Northwest heat wave in late June 2021 and rapid attribution studies published in the weeks after the event.",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "ea68acd3-5234-4bf1-90b6-a175d94d0636",
      "text": "Council of the EU adopted visa‑liberalisation regulation for Ukrainian citizens (moving Ukraine to visa‑free Annex II).",
      "date": "2017-05-11 00:00:00"
    },
    {
      "id": "04b78e68-7272-4b89-a850-e0751f938c15",
      "text": "Major outlets explained how the visa‑free scheme would operate and its limits (e.g., that it allowed 90 days' travel within any 180‑day period and depended on biometric passports).",
      "date": "2017-04-06 00:00:00"
    },
    {
      "id": "86b443f9-597c-4943-aa25-1e4de477c1d8",
      "text": "Legal and normative context: Ukrainian prohibition on promotion/distribution of totalitarian symbols (noted in fact checks of similar claims)",
      "date": "2023-01-13 00:00:00"
    },
    {
      "id": "a58b9b09-ff37-4144-b39c-50af1b458f87",
      "text": "CDC guidance promoting widespread use of cloth face coverings and advising regular washing/maintenance",
      "date": "2020-06-28 00:00:00"
    },
    {
      "id": "98d47805-4cd7-4731-8c6b-fef8bc38b147",
      "text": "Dentistry and trade press reports warning about 'mask mouth' and increased oral health issues",
      "date": "2020-08-24 00:00:00"
    },
    {
      "id": "7f893751-008b-436b-bfd8-1ab6e0dd153a",
      "text": "Public demonstrations by scientists/microbiologists using petri-dish or droplet-capture experiments to show masks block droplets",
      "date": "2020-07-24 00:00:00"
    },
    {
      "id": "5744aada-6d04-4c83-b188-e9ab637f2c37",
      "text": "Industry and research reports (IEA-PVPS and others) documenting end-of-life management challenges and the need to scale PV recycling infrastructure.",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "712ba18f-602d-464e-a145-9155d6ab150d",
      "text": "Coordinated farmer and rural groups' campaigns and protests against 'mega' solar farms on productive farmland in the UK (national days of action and rallies organized by rural campaigners).",
      "date": "2022-11-24 00:00:00"
    },
    {
      "id": "b9def34b-f479-47c6-bfbd-c090b718f4cc",
      "text": "Laboratory leaching studies showing that crushed or non-encapsulated cadmium‑telluride (CdTe) thin‑film solar cell material can release cadmium and tellurium under extreme test conditions.",
      "date": "2017-12-24 00:00:00"
    },
    {
      "id": "8af7630a-888f-429b-8d22-a888b3422656",
      "text": "OSCE Special Monitoring Mission (SMM) recorded a marked increase in ceasefire violations in Donbas in early 2021 (multiple daily reports documenting dozens to hundreds of violations).",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "1d06b6ad-1c83-4e67-ad6e-27c1f6201f6a",
      "text": "U.S. Department of State 'Ukraine 2020 Human Rights Report' (published March 2021) documented the activity and influence of volunteer/paramilitary and nationalist groups (e.g., units linked to political parties) active in eastern Ukraine and at the front line.",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "4e2bfcc6-057a-45c2-bc22-5f22eb478b96",
      "text": "Verkhovna Rada (Ukrainian parliament) passed the 2018 'On the peculiarities of state policy to ensure Ukraine's state sovereignty over temporarily occupied territories of Donetsk and Luhansk regions' (the 'reintegration of Donbas' law) declaring parts of Donbas occupied and Russia an aggressor.",
      "date": "2018-01-18 00:00:00"
    },
    {
      "id": "1dd98959-def5-4e70-aaed-6ffb79b0a02c",
      "text": "President Zelenskyy's 2019 public handling of the Steinmeier Formula (acceptance/clarification) and the related domestic protests over concessions for the Donbas.",
      "date": "2019-10-02 00:00:00"
    },
    {
      "id": "0d979bf2-cdbb-4ec7-bf27-6837e71f1b0f",
      "text": "EU and US adopted rounds of sanctions against Russia following the 2014 annexation of Crimea and continued to maintain restrictive measures in subsequent years.",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "05c2fb4c-ae68-4663-861c-bbe293f5090b",
      "text": "Public reporting and analysis of contacts between Trump‑family advisers (including Ivanka/Kushner) and Russian figures during and after the 2016 campaign (coverage of the Mueller report, 2019).",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "01e3cd24-74cd-4d13-8d26-bc216d1beebe",
      "text": "Pro‑Russian activists stormed SBU (security service) offices in Donetsk and Luhansk and reportedly took weapons from armories.",
      "date": "2014-04-07 00:00:00"
    },
    {
      "id": "5dd8dff5-0130-4958-a9a7-9187ecb8464a",
      "text": "Ukraine's defence ministry publicly acknowledged that a number of its vehicles/equipment had been seized by pro‑Russian forces.",
      "date": "2014-04-16 00:00:00"
    },
    {
      "id": "d22b2d07-e729-43c3-bd3d-ae9c221521cf",
      "text": "State-level policy changes in 2022 loosening access to ivermectin (pharmacist dispensing/OTC measures in several U.S. states)",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "a915f3d1-92f2-4b83-9953-3e6ca65ded90",
      "text": "Apter v. Department of Health & Human Services — Fifth Circuit opinion allowing doctors' claims against FDA to proceed and criticizing agency messaging",
      "date": "2023-09-01 00:00:00"
    },
    {
      "id": "c59ccbdb-f1d2-47c7-9ec4-47d9f9c56636",
      "text": "President Poroshenko signed the 2015 'de-communization' laws (May 2015) that, among other provisions, publicly recognized fighters of the OUN‑UPA (associated historically with Stepan Bandera).",
      "date": "2015-05-15 00:00:00"
    },
    {
      "id": "ff0e2e4e-984a-4fef-b122-7b4aa3b38962",
      "text": "Russian state media had for months portrayed Ukraine’s post‑Euromaidan authorities as 'Bandera' nationalists and used the term 'Bandera junta' in reports (widespread from 2014 onward).",
      "date": "2014-08-11 00:00:00"
    },
    {
      "id": "5b4e9f1d-68d8-4d32-a100-156509555dbd",
      "text": "The new law altered expiry/labeling requirements (e.g., month/year vs day/month) and set a delayed entry-into-force date",
      "date": "2018-12-06 00:00:00"
    },
    {
      "id": "a805862a-118b-4af7-b9e4-4d70194d8057",
      "text": "Verkhovna Rada (Ukraine's Parliament) adopted Bill No. 8450 \"On Information for Consumers of Food Products\"",
      "date": "2018-12-06 00:00:00"
    },
    {
      "id": "720d0741-1485-4c41-9b9e-03674f20e31a",
      "text": "2012 research proposing a quantitative 'tongue deviation angle' threshold as a possible early warning sign of stroke (Wei et al., August 2012).",
      "date": "2012-08-24 00:00:00"
    },
    {
      "id": "959df3ef-c111-4c09-9a7b-5c51b969ad13",
      "text": "Launch of the UK 'Act F.A.S.T.' national stroke-awareness campaign emphasizing Face/Arm/Speech/Time (first rolled out February 2009).",
      "date": "2009-02-24 00:00:00"
    },
    {
      "id": "8efe4067-cedc-49e6-beb8-83092672d3a5",
      "text": "European Commission public warnings about Ukraine’s unfinished anti‑corruption and reform agenda",
      "date": "2015-12-18 00:00:00"
    },
    {
      "id": "bf90eb67-8da3-407c-899e-c20dcbec088e",
      "text": "EU–Ukraine DCFTA implementation raised in trilateral talks with Russia amid practical concerns",
      "date": "2015-12-24 00:00:00"
    },
    {
      "id": "3c765d9f-0405-4c43-bf03-a83048ccf162",
      "text": "2013 Ukrainian government suspended signing of the Association Agreement (Vilnius), fuelling narratives of failure",
      "date": "2013-11-21 00:00:00"
    },
    {
      "id": "88f9850f-41c4-4378-88a7-5102e569094f",
      "text": "CDC MMWR report on the Barnstable County, MA outbreak showing many 'breakthrough' infections among fully vaccinated people (July 2021)",
      "date": "2021-07-30 00:00:00"
    },
    {
      "id": "050ddb9e-c254-478d-8ffe-f8fdeabb33a5",
      "text": "Health Canada advisory and recall/alert over face masks containing graphene (public advisory that graphene in masks may present inhalation risks).",
      "date": "2021-04-02 00:00:00"
    },
    {
      "id": "ec25c265-a8a3-44b8-9f5d-b63f1c3b884f",
      "text": "Published transmission‑electron microscopy (TEM) and SEM images of graphene oxide in the scientific literature (e.g., ACS Nano structural analysis of graphene oxide).",
      "date": "2009-04-24 00:00:00"
    },
    {
      "id": "b7330117-f843-4dd9-ad4b-b81e578ca1d2",
      "text": "OSCE report documenting repeated interruptions to water access in Donetsk and Luhansk due to hostilities and infrastructure damage",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "c068ace4-0df2-40f5-afeb-0ee9d0d4a8a3",
      "text": "Shelling damaged the Donetsk filtration plant, leaving much of Donetsk without running water",
      "date": "2014-11-24 00:00:00"
    },
    {
      "id": "852671f2-72e2-4c38-bbb7-7af113f7aaaf",
      "text": "China’s temporary nationwide ban on trade and consumption of wild animals announced amid the outbreak",
      "date": "2020-01-26 00:00:00"
    },
    {
      "id": "3c9b6f82-65dc-45c5-a727-981f257afc22",
      "text": "Public‑health assessments linking many early cases to Wuhan’s Huanan Seafood Wholesale Market",
      "date": "2020-01-17 00:00:00"
    },
    {
      "id": "e4787dfa-2075-49af-8f60-4b153d6860f5",
      "text": "Poland publicly resisted EU migrant relocation quotas and signalled tighter migration controls (Nov 2015)",
      "date": "2015-11-24 00:00:00"
    },
    {
      "id": "161d37ba-03e3-4b00-a4ff-9688a7a5c6b1",
      "text": "Poland and Ukraine temporarily closed or restricted certain crossings amid transport disputes (reports of Russian lorries stuck)",
      "date": "2016-02-15 00:00:00"
    },
    {
      "id": "99aacb30-8d04-4f24-ae70-df3b276e8586",
      "text": "Europol and Polish Border Guard dismantled an international people-smuggling network (September 2016)",
      "date": "2016-09-24 00:00:00"
    },
    {
      "id": "5730ba58-c479-44ef-8060-17afa3bd67ca",
      "text": "Passage of post‑Euromaidan lustration (vetting) laws and criticism from rights groups",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "2107b5eb-6e43-490d-b9a3-b973d2ecd63f",
      "text": "Security Service of Ukraine (SBU) searches, surveillance and raids on media outlets and journalists (reported 2018–2019)",
      "date": "2018-02-08 00:00:00"
    },
    {
      "id": "aa8a5f4e-1d86-4f50-b032-f1a9eb3fd837",
      "text": "Kerch Strait incident and temporary imposition of martial‑law measures after the November 2018 naval clash",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "46cfca21-6e5d-4cfe-8b41-0e72b801599e",
      "text": "Government blocking of major Russian social networks and internet services under sanctions",
      "date": "2017-05-15 00:00:00"
    },
    {
      "id": "e7cba723-5ce7-41e0-9efe-ad11553b3672",
      "text": "OSCE SMM spot report (22 January 2015) documents shelling incidents impacting civilian infrastructure, including water facilities, in Donetsk",
      "date": "2015-01-22 00:00:00"
    },
    {
      "id": "4de3e13e-8ea4-4d67-b5e3-4e4bfe4a3617",
      "text": "UN/UNICEF appeal (July 2015) calling for help to restore damaged water facilities in Donetsk and Luhansk",
      "date": "2015-07-24 00:00:00"
    },
    {
      "id": "91c788f9-e420-4e6d-b7aa-f07ca5a1a9fe",
      "text": "NCHS publishes final report 'Mortality in the United States, 2019' (finalized 2019 death counts and age‑adjusted death rates)",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "cda6e5ef-b9ea-4f23-89c9-4b8a87e4fa7b",
      "text": "Unusually low seasonal influenza activity and deaths during 2020 (CDC FluView reports for 2019–2020 and 2020–2021 showing steep decline)",
      "date": "2020-12-12 00:00:00"
    },
    {
      "id": "b803b996-630b-4f05-b3b6-339f78b7c70f",
      "text": "UN Mine Action Service (UNMAS) 2019 reporting and annual material describing extensive contamination by mines/ERW in Ukraine and the long-term nature of clearance",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "eb69e2dd-44a4-48ed-a7c3-f4d6ab56fff7",
      "text": "Media reporting on international NGOs (HALO Trust) conducting humanitarian demining in Donbas and expanding operations in 2019",
      "date": "2019-04-20 00:00:00"
    },
    {
      "id": "dda020cb-61b1-45bb-9d7d-677b7eda4255",
      "text": "Peer‑reviewed and preprint research discussing biochemical/sequence similarities between portions of the SARS‑CoV‑2 spike protein and snake neurotoxins (studies and tests of the \"nicotinic\" hypothesis)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "9606da73-a8c6-4443-a79c-78836db4e4f1",
      "text": "Norwegian health authorities reported deaths among very frail, elderly people shortly after receiving the Pfizer–BioNTech COVID-19 vaccine and opened reviews (reports in mid‑January 2021 said 23 deaths were reported and some were judged possibly linked to vaccine side effects in very frail patients).",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "36f5302a-e74a-46d1-b5b0-8f4c1e418fef",
      "text": "Reports and a CDC MMWR analysis documented cases of allergic reactions and anaphylaxis after initial Pfizer–BioNTech vaccine doses in December 2020 (MMWR published January 2021 summarizing early anaphylaxis reports).",
      "date": "None"
    },
    {
      "id": "84317b32-9768-4166-ad55-4761a28d3ac8",
      "text": "Public release and wide circulation of raw VAERS (Vaccine Adverse Event Reporting System) reports documenting deaths reported after COVID‑19 vaccination in late 2020 and early 2021.",
      "date": "None"
    },
    {
      "id": "ed4ab4de-aac3-4757-add7-949e781db1b6",
      "text": "UNODC report and national statistics showing Ukraine as a significant transit country and location of large heroin seizures in Europe",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "6dcc87dc-d2e1-4f7b-8285-ffd533b53b9b",
      "text": "Europol / Eurojust-linked investigations and cross‑border law‑enforcement operations that identified networks using Ukrainian territory/ports to move cocaine and other drugs into the EU",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "2331d7d0-913d-4b46-8447-0f81b55cb1f0",
      "text": "FTC and FDA joint warning letters and public enforcement actions targeting companies that market dietary supplements with unproven Alzheimer's or dementia treatment/prevention claims (e.g., joint letters and advisories in 2019).",
      "date": "2019-02-24 00:00:00"
    },
    {
      "id": "4f1f0c64-1799-4bf9-a967-85e669866f8b",
      "text": "18-month randomized, double-blind, placebo‑controlled trial of a bioavailable curcumin formulation (Theracurmin) reporting memory and PET biomarker improvements in non-demented adults (Small et al.).",
      "date": "2018-03-24 00:00:00"
    },
    {
      "id": "0707cb89-2884-4686-83c6-9d85575d164d",
      "text": "Small randomized, double-blind, placebo-controlled trial (Mori et al.) reporting improved cognitive scores in mild cognitive impairment after Hericium erinaceus (lion's mane) supplementation.",
      "date": "2009-03-24 00:00:00"
    },
    {
      "id": "977f9386-b21f-4059-92ba-0bcdf2e251f0",
      "text": "Prospective cohort studies (e.g., Ohsaki cohort and related epidemiologic research) reporting associations between higher green tea consumption and lower risk of cognitive decline / incident dementia or functional disability.",
      "date": "2011-04-24 00:00:00"
    },
    {
      "id": "d374c1c5-661e-4f36-a173-c02bb705d5c0",
      "text": "CBOS national poll showing sharp fall in Polish support for accepting Ukrainian refugees (April 2023)",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "5879a899-c44a-4513-96d8-68524214fee4",
      "text": "EDMO/Fact‑checking reports documenting early disinformation narratives about Ukrainian refugees in Poland (April 2022)",
      "date": "2022-04-04 00:00:00"
    },
    {
      "id": "2c94f3c8-2366-48cc-bc7b-7cf118c80621",
      "text": "Political rhetoric and electoral pressure around Ukraine support (Reuters report, 19 Sep 2023)",
      "date": "2023-09-19 00:00:00"
    },
    {
      "id": "5989c451-dfe0-430a-8257-bd4f4d152603",
      "text": "Abbott/Similac powdered infant formula recalls and linked Cronobacter infections reported February 2022 (product recalls and infant illnesses/deaths).",
      "date": "2022-02-17 00:00:00"
    },
    {
      "id": "fde9903f-3e01-4d9e-88b2-b36a0e29f568",
      "text": "Conviction of neonatal nurse Lucy Letby for murdering and attempting to murder infants (trial verdict reported August 2023).",
      "date": "2023-08-18 00:00:00"
    },
    {
      "id": "74d79c55-b2dd-48dd-92c8-b4f3e8b9c05a",
      "text": "Reports in 2023 about a US clinician case involving allegations of destroying government COVID vaccine doses and administering saline (case reporting and later procedural developments in 2023).",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "12c64edc-5bb0-43cd-803b-893bccf7130c",
      "text": "Local Marseille municipal councillor Gerald‑Hubert Fayard publicly associated himself with a planned DPR 'representation' (reported in regional and Ukraine‑focused outlets).",
      "date": "2017-06-24 00:00:00"
    },
    {
      "id": "ddb12108-4ee7-4b41-9f71-e5f2ce89bd21",
      "text": "Thimerosal (ethylmercury) removal efforts and public controversy (ACIP/FDA actions beginning 1999; IOM review 2004)",
      "date": "None"
    },
    {
      "id": "930d0ea6-3c45-418d-88d6-0511cd01d88e",
      "text": "EMA guidance describes use of porcine trypsin (an enzyme) in manufacture of some vaccines",
      "date": "None"
    },
    {
      "id": "3892ead7-6fb3-4fbb-9d2c-4f5ba492af26",
      "text": "IARC classifies formaldehyde as carcinogenic to humans",
      "date": "2004-06-24 00:00:00"
    },
    {
      "id": "971bef39-e25e-447b-8a04-28c6ac8f9b3a",
      "text": "Immunization Safety Review and public concern over SV40 contamination of polio vaccine (1955–1963) and subsequent reviews",
      "date": "None"
    },
    {
      "id": "5a46004d-e039-45ce-8424-3b5024c29c72",
      "text": "CDC MMWR report: 'Delay or Avoidance of Medical Care Because of COVID‑19–Related Concerns — United States, June 2020'",
      "date": "2020-09-11 00:00:00"
    },
    {
      "id": "afe319fe-497d-4014-a28f-2ef0370ca5b1",
      "text": "CMS guidance: 'CMS Releases Recommendations on Adult Elective Surgeries, Non‑Essential Medical, Surgical, and Dental Procedures' (recommendation to postpone elective care)",
      "date": "2020-03-18 00:00:00"
    },
    {
      "id": "ff78363e-86bf-44d1-80b4-366fb6fcd5a3",
      "text": "European and Global Drought Observatories annual progress/ data release (JRC/EDO-GDO report covering 2021)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "ac1c347b-0422-4190-a91e-f118e3304387",
      "text": "Release of IPCC Sixth Assessment Report (AR6) Working Group II Summary for Policymakers",
      "date": "2022-02-28 00:00:00"
    },
    {
      "id": "8e22e8ab-95be-4a04-a8e8-56168661ba94",
      "text": "Ukrainian President Petro Poroshenko warned of 'hundreds of foreign tanks' in Ukraine",
      "date": "2014-08-30 00:00:00"
    },
    {
      "id": "7c82ab5c-af1e-4524-918a-44d55dc03f4b",
      "text": "Large military parades and visible tank movements in neighbouring countries (e.g., Poland's Armed Forces Day parade showing tanks on public roads)",
      "date": "2014-08-15 00:00:00"
    },
    {
      "id": "e5febf9d-f8b5-44f5-91f7-a1784dc87110",
      "text": "Reports that Russian tanks and armoured columns had crossed from Russia into Ukraine",
      "date": "2014-08-25 00:00:00"
    },
    {
      "id": "f9982ced-7bf9-4aee-9566-6707fe08a315",
      "text": "Pentagon websites underwent a major content purge and reorganization earlier in 2025 (reported March 19, 2025), producing visible changes and confusion on DoD web properties",
      "date": "2025-03-19 00:00:00"
    },
    {
      "id": "8e41cddf-c165-4805-86c2-74203f0c56af",
      "text": "Japan suspended use/recall of some Moderna vaccine batches after reports of foreign particles (contamination) in vials",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "05801579-0283-4e6f-9252-e0ccd540942c",
      "text": "FDA and CDC safety communications acknowledging rare myocarditis/pericarditis risk after mRNA COVID-19 vaccination",
      "date": "2022-05-24 00:00:00"
    },
    {
      "id": "312815af-6e45-44c2-92d5-7498545d87c1",
      "text": "Florida Department of Health issues guidance/analysis claiming an 84% increase in the relative incidence of cardiac-related death among males 18–39 within 28 days of mRNA vaccination",
      "date": "2022-10-07 00:00:00"
    },
    {
      "id": "e4e75d3d-b6ca-4f6c-ae92-d8f6f3b8c92f",
      "text": "Public criticisms and sparring by U.S. officials (including Vice President comments accusing Zelensky of being ungrateful) after the Oval Office exchange.",
      "date": "2025-02-28 00:00:00"
    },
    {
      "id": "ff23b9e8-7e77-4ecc-bd42-56730cdc555c",
      "text": "Human Rights Watch report 'Unguided Rockets Killing Civilians' documented use of Grad (MLRS) rockets in Donetsk in July 2014.",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "9c5bc019-b51b-429a-a892-504dbad1e62a",
      "text": "Simferopol base shooting — Ukrainian serviceman reportedly shot dead during Crimea takeover",
      "date": "2014-03-18 00:00:00"
    },
    {
      "id": "ab2ad3a9-afec-43d7-ba87-b35694ddb345",
      "text": "Euromaidan 'snipers' massacre and government/official statements about 'shooting to kill' (Kyiv)",
      "date": "2014-02-20 00:00:00"
    },
    {
      "id": "370c7df3-223f-419c-81d1-734d1f0f1617",
      "text": "Killing of nationalist figure Oleksandr 'Sashko Bilyi' Muzychko during police operation (Rivne)",
      "date": "2014-03-26 00:00:00"
    },
    {
      "id": "e5aaa05a-c658-49d0-9c32-d5ee0631d853",
      "text": "Acting Interior Minister Avakov implicates members of elite police units in Maidan shootings",
      "date": "2014-04-01 00:00:00"
    },
    {
      "id": "d9eafee5-2dab-4b8c-8840-234fecaf5047",
      "text": "Battle of Ilovaisk and the lethal 'green corridor' ambush during Ukrainian retreat",
      "date": "2014-08-29 00:00:00"
    },
    {
      "id": "30b3ee18-387c-41b6-8f4c-a6b8e2b1a1fb",
      "text": "2020 research coverage: injectable hydrogels proposed as sustained‑release vaccine delivery platforms",
      "date": "2020-09-16 00:00:00"
    },
    {
      "id": "0f9b8ca1-b9e6-456e-b2cd-23b2bbda9fae",
      "text": "2019 review article: 'Hydrogel bioelectronics' (conductive/ionically conductive hydrogels for interfacing biology and electronics)",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "cd0a2e04-a1f5-4dd0-b90f-1e9dc59bf122",
      "text": "Licensure and use of squalene-containing adjuvant MF59 in licensed influenza vaccines (first licensed in Italy)",
      "date": "1997-04-24 00:00:00"
    },
    {
      "id": "e5f55024-d61f-4b4c-9bd6-c3bc739ba47d",
      "text": "US Congressional hearings and report scrutinizing the Department of Defense Anthrax Vaccine Immunization Program",
      "date": "1999-09-30 00:00:00"
    },
    {
      "id": "0fd0ca94-0033-4c14-8ca8-780602fd419e",
      "text": "Publication and media coverage of research finding antibodies to squalene in Gulf War veterans",
      "date": "2000-04-15 00:00:00"
    },
    {
      "id": "c7011f87-dfe4-405c-b47d-314e80fe1c8e",
      "text": "1990s allegations that tetanus vaccination campaigns (Philippines, Mexico, Nicaragua) involved conjugation with hCG causing sterilization",
      "date": "None"
    },
    {
      "id": "cb952111-bc62-4180-901e-11bb11e441e0",
      "text": "Wuhan city lockdown and rapid travel restrictions were imposed as cases spread (city lockdown announced 23 January 2020) amid reports of limited early transparency",
      "date": "2020-01-23 00:00:00"
    },
    {
      "id": "9dbdef61-bce6-476e-a310-53f87bb39f66",
      "text": "U.S. State Department fact sheet and public reporting describing activities and international collaborations at the Wuhan Institute of Virology",
      "date": "2018-01-15 00:00:00"
    },
    {
      "id": "81c07683-95ea-46f6-90e9-fdc32370f511",
      "text": "Published, peer‑reviewed and public research showing Wuhan scientists (including Shi Zhengli) studying SARS‑like bat coronaviruses and collecting bat samples",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "e8f4d764-94e2-4c4a-b2b9-5356bdd53802",
      "text": "Ukrainian parliament voted to remove Yanukovych (328-0)",
      "date": "2014-02-22 00:00:00"
    },
    {
      "id": "2bb42626-d925-4aff-a4e7-1c28444704c5",
      "text": "U.S. FDA issued an Emergency Use Authorization (EUA) for chloroquine and hydroxychloroquine on March 28, 2020.",
      "date": "2020-03-28 00:00:00"
    },
    {
      "id": "ffd9187e-8061-4751-8bd5-480198de9d08",
      "text": "Publication of an early open‑label, non‑randomized trial from Marseille (Gautret et al.) reporting viral clearance with hydroxychloroquine ± azithromycin.",
      "date": "2020-03-20 00:00:00"
    },
    {
      "id": "0cf24c17-1136-4554-8780-9a4ab07761a4",
      "text": "Reporting from liberated towns (e.g., Trostianets) documenting looting and pillage by occupying Russian forces, published in major outlets in early April 2022.",
      "date": "2022-04-05 00:00:00"
    },
    {
      "id": "6fc52d41-dc73-4780-b40d-2bc668e88f4a",
      "text": "Scandinavian booster policy narrowing in 2022 (Denmark recommended boosters primarily for those 50+; Norway targeted boosters to older/risk groups)",
      "date": "2022-09-24 00:00:00"
    },
    {
      "id": "3e978252-371b-41d2-8241-2e77a77b7ccd",
      "text": "NEJM analysis using Israeli Ministry of Health data showing protection and waning patterns of natural, vaccine-induced and hybrid immunity",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "5ea46f6e-52b9-48b1-924d-c42581ba2e4f",
      "text": "Publication of a quantified-method study suggesting tongue deviation angle >3.2° may predict stroke (Biomed Eng Online).",
      "date": "2012-08-21 00:00:00"
    },
    {
      "id": "4f58034e-b5aa-4e77-a186-703865813663",
      "text": "Public Health England / NHS Act FAST stroke public awareness campaigns emphasising Face, Arms, Speech, Time (FAST) without mentioning tongue.",
      "date": "2015-02-02 00:00:00"
    },
    {
      "id": "1b09beb4-96ed-4fb4-b461-3ad2dc8ee74c",
      "text": "UKHSA (UK Health Security Agency) vaccine surveillance reports documenting low or rapidly waning effectiveness against Omicron infection at some timepoints in 2022",
      "date": "2022-01-28 00:00:00"
    },
    {
      "id": "b2363639-5d44-418d-9673-4c7e709d3369",
      "text": "U.S. Energy Information Administration (EIA) published accessible guidance and emissions-coefficient data explaining that burning natural gas produces less CO2 per unit of energy than burning coal.",
      "date": "2024-07-10 00:00:00"
    },
    {
      "id": "f0ef8168-b5db-4007-9161-282e7132d6ef",
      "text": "European Commission proposal and subsequent approval to allow some natural gas projects to be labelled as 'transitional' / investable under the EU Taxonomy, followed by high-profile legal challenges and media coverage.",
      "date": "2023-04-17 00:00:00"
    },
    {
      "id": "0339315d-50ab-4e68-b9ac-4892ae9ff23b",
      "text": "Clean Creatives published its F‑List 2024 report documenting over 1,000 recent advertising and PR contracts between major agencies and fossil fuel companies (including gas companies).",
      "date": "2024-09-24 00:00:00"
    },
    {
      "id": "20530a04-956c-471e-a28a-f5f92470b5f8",
      "text": "ClientEarth and partners announced they were joining legal action against Washington Gas over customer-facing marketing that described gas as 'clean' and 'sustainable'.",
      "date": "2022-08-04 00:00:00"
    },
    {
      "id": "51a4924c-6fd8-4a57-81f7-141044a51459",
      "text": "OSCE convoy came under fire near Mariinka (monitors shot at while travelling between Ukrainian checkpoints)",
      "date": "2014-11-19 00:00:00"
    },
    {
      "id": "9c4c19b1-1821-4f4f-b004-963fa07a0f1c",
      "text": "OSCE observers blocked from full access to the MH17 crash site by armed pro‑Russian fighters",
      "date": "2014-07-18 00:00:00"
    },
    {
      "id": "30306750-7682-4b1c-9f3e-c1f7f931fb12",
      "text": "OSCE national staff detained by separatist forces in eastern Ukraine (several detained in April 2014)",
      "date": "2014-04-25 00:00:00"
    },
    {
      "id": "bf60c867-f02b-4e06-b2c1-b53995c2ccd9",
      "text": "Four OSCE armoured vehicles torched in Donetsk (apparent arson)",
      "date": "2014-08-09 00:00:00"
    },
    {
      "id": "853ec022-2633-424e-8070-53f10b976cd3",
      "text": "U.S. Department of Defense announced $250 million in additional security assistance for Ukraine",
      "date": "2019-06-18 00:00:00"
    },
    {
      "id": "663f388b-8d33-4499-af44-cd69c04ac64f",
      "text": "Kerch Strait incident: Russian forces seized three Ukrainian navy vessels and detained sailors",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "acdb7680-494f-4145-a91e-cd4d9b5e56d1",
      "text": "United States confirmed delivery of Javelin anti-tank missile systems to Ukraine",
      "date": "2018-04-30 00:00:00"
    },
    {
      "id": "d584c3ea-5cb9-45d8-8efd-c3e473f0ccca",
      "text": "Sea Breeze 2019 multinational naval exercise (co-hosted by the US and Ukraine) concluded in Odesa",
      "date": "2019-07-12 00:00:00"
    },
    {
      "id": "16ca3990-e457-4039-8559-8ecff8153cd8",
      "text": "USS Ross (Arleigh Burke-class destroyer) entered the Black Sea (routine US Navy presence) in April 2019",
      "date": "2019-04-15 00:00:00"
    },
    {
      "id": "3558e28f-0f72-48b9-8286-981151d2baa1",
      "text": "Official counts and reporting on refugees arriving in France showed large aggregate flow (roughly 30,000 reported late March 2022) but initial public summaries lacked detailed nationality/ethnicity breakdowns",
      "date": "2022-03-27 00:00:00"
    },
    {
      "id": "22e6e242-2014-4f49-b17e-405825cad96f",
      "text": "Reports and media on opening Arctic sea routes and economic opportunities from reduced sea ice (UK Foresight/academic analyses, mid-2010s)",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "63ad495e-5acf-452f-8a88-e7061b051a88",
      "text": "UNDP published 'Enhancing Mine Action Finance in Ukraine' (feasibility study) highlighting very large costs for demining and explosive ordnance disposal (EOD) in Ukraine",
      "date": "2024-10-15 00:00:00"
    },
    {
      "id": "79deae72-5646-4192-a308-236ab1bef5fc",
      "text": "U.S. Government Accountability Office (GAO) report 'Ukraine: Status and Challenges of DOD Weapon Replacement Efforts' documented replacement costs and tracking challenges for U.S. weapons provided to Ukraine",
      "date": "2024-04-30 00:00:00"
    },
    {
      "id": "0305a8d5-e7b2-4fdd-bcd7-b0f71ec3ae48",
      "text": "World Bank released an updated Ukraine recovery and reconstruction needs assessment estimating hundreds of billions in reconstruction costs and prompting public debate over who will pay",
      "date": "2025-02-25 00:00:00"
    },
    {
      "id": "b7315bb3-0703-4c94-a09b-a1e2db430679",
      "text": "Large influx of Ukrainian refugees into Italy by mid‑2022 (UNHCR reporting tens of thousands in June 2022).",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "61b2cd92-abf7-4dcf-bc51-7644c0a54e5f",
      "text": "Extinction Rebellion activists blocked Rome’s Grande Raccordo Anulare, leading to drivers physically removing protesters.",
      "date": "2022-06-14 00:00:00"
    },
    {
      "id": "e12ee799-3d50-4af8-a791-1c4bb686de2b",
      "text": "Rospotrebnadzor and Russian authorities banned imports of Ukrainian confectionery (including Roshen) and imposed trade restrictions in 2013–2014.",
      "date": "2014-09-05 00:00:00"
    },
    {
      "id": "d06a4c29-bb90-487d-98ff-88029fa06e0e",
      "text": "April 2015: Russian authorities seized or froze assets related to the Lipetsk Roshen factory and reported legal/administrative actions against the plant.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "66ccfe61-ae20-4550-b79d-81b156c8a6cb",
      "text": "Fatal shooting of conservative activist Charlie Kirk at Utah Valley University",
      "date": "2025-09-10 00:00:00"
    },
    {
      "id": "8bb1e2ba-a0bb-40a4-940b-848d74f29241",
      "text": "Publication of Kausar H. et al., 'Cucurbitacin B potently suppresses non-small-cell lung cancer growth' (Cancer Letters)",
      "date": "None"
    },
    {
      "id": "85e3bb14-8ba3-4be5-bd50-f38e37acef59",
      "text": "Pre-war and tourist-focused references showing some Ukrainian cemeteries charge small admission or camera fees (example: Lychakiv Cemetery visitor fees noted in travel guides/reviews in 2019)",
      "date": "None"
    },
    {
      "id": "ed0cb860-80c7-4566-a16a-1b0c0d31aa0b",
      "text": "Drohobych municipal regulation (pre-2022) introducing paid vehicle access for cemetery maintenance, cited by local officials when responding to the viral clip",
      "date": "None"
    },
    {
      "id": "4813077d-e615-4b27-9b5b-b355712216fd",
      "text": "WHO issues 'Tetanus vaccines: WHO position paper' summarising tetanus epidemiology and prevention",
      "date": "2017-02-10 00:00:00"
    },
    {
      "id": "e12a081c-41ee-4ea4-9677-a64baf83b41b",
      "text": "Peer‑reviewed medical review 'Tetanus' (Farrar et al.) describes Clostridium tetani as an obligate anaerobic, spore‑forming bacterium and details anaerobic germination in wounds",
      "date": "2000-09-01 00:00:00"
    },
    {
      "id": "d76b65d4-41fc-4c3f-9acb-79c698179c29",
      "text": "The Tesla Science Center crowdfunded and purchased the Wardenclyffe lab site to create a museum and drew renewed attention to Tesla's archival material.",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "ca1e6bab-694c-481b-842c-66218837103e",
      "text": "News reporting that the historic Wardenclyffe site was damaged/at risk after a major fire and related incidents.",
      "date": "2023-11-24 00:00:00"
    },
    {
      "id": "44dab769-9a0b-477d-9ec2-b8feea0fb346",
      "text": "U.S. Vaccine Court (Omnibus Autism Proceedings) issued final test-case rulings (March 10, 2010) finding insufficient evidence that vaccines cause autism",
      "date": "2010-03-10 00:00:00"
    },
    {
      "id": "e3c62d58-3418-453a-b65c-853a482b6baf",
      "text": "U.S. CDC and FDA temporarily pause and later resume use of the Johnson & Johnson COVID‑19 vaccine over rare blood clot reports",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "01616dfd-fc22-45d1-9fcd-1b2ad598a500",
      "text": "Public health agencies report rare myocarditis cases after mRNA COVID‑19 vaccination and discuss benefits vs. risks",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "ba9d833c-6b5f-4977-907a-cd46f755300e",
      "text": "Russian Defence Ministry repeatedly publicly stated it was striking Ukraine’s “military‑industrial complex” and energy infrastructure (examples across 2022–2024 reporting by major outlets).",
      "date": "2022-12-17 00:00:00"
    },
    {
      "id": "f89e6ea3-65e3-4ff1-ba9b-2d25e57b0933",
      "text": "Multiple Russian missile and aerial strikes on Chernihiv during March 2022, causing civilian casualties and damage across the city.",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "2b26efa6-583b-41fc-88f0-91b856a9b861",
      "text": "European Broadcasting Union (EBU) announces Kyiv as host city for Eurovision 2017",
      "date": "2016-09-09 00:00:00"
    },
    {
      "id": "f0db666b-0fd3-4f77-b06f-89c030b25d5c",
      "text": "Jamala (Ukraine) wins the Eurovision Song Contest with the song '1944'",
      "date": "2016-05-14 00:00:00"
    },
    {
      "id": "5e8d37c6-8703-44ad-b67d-f727f80c34d8",
      "text": "Ukraine publicly sought large anthracite imports (including from South Africa) amid shortages in late 2015",
      "date": "2015-11-24 00:00:00"
    },
    {
      "id": "6e4c5301-e3c3-4f6b-909d-23ea2b1309ac",
      "text": "Sharp drop in Ukrainian coal production after Donbas fighting in 2014",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "48a764fe-1d3f-4265-b2da-69a49b1d5369",
      "text": "Closure, flooding and damage to many Donbas mines after occupation in 2014",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "2c23f5f5-1fe8-4718-a592-39593387b290",
      "text": "Publication of the NEURO-COVAX study in Vaccines (MDPI) reporting 31.2% of participants self-reported at least one neurological symptom after COVID-19 vaccination.",
      "date": "2023-10-21 00:00:00"
    },
    {
      "id": "d4643a72-fa01-41a9-9cbf-99356de06c6b",
      "text": "Study design and limitations (self‑reported questionnaire, single‑center sampling, no unvaccinated comparator, and no hospitalizations/deaths recorded) were present in the paper but largely omitted in shareable summaries.",
      "date": "2023-10-21 00:00:00"
    },
    {
      "id": "a8863203-2f29-4df9-ae56-f28b95478ed0",
      "text": "KIIS telephone poll (May 13–18, 2022) reporting very high levels of negative attitudes toward Russia (e.g., ~82% negative among people in occupied areas)",
      "date": "2022-05-13 00:00:00"
    },
    {
      "id": "165d15d9-4ec9-4579-9519-a7e05f6304ee",
      "text": "Russian forces seized/controlled substantial parts of Kharkiv oblast in the initial invasion (late Feb–early March 2022), including border towns and districts",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "3c719cdb-5047-46b4-a1d7-f8e44a60535b",
      "text": "State-level policy changes removing mask mandates (example: Texas lifting its statewide mask mandate and reopening, March 2, 2021)",
      "date": "2021-03-02 00:00:00"
    },
    {
      "id": "c7afcae4-708e-49d8-8fd0-4dca5da09912",
      "text": "CDC guidance updating mask recommendations for fully vaccinated people (May 13, 2021)",
      "date": "2021-05-13 00:00:00"
    },
    {
      "id": "0dbce223-9c3e-4379-a0d6-719aff826410",
      "text": "Turkish President Recep Tayyip Erdogan offered financial assistance to Ukraine and publicly urged protection for Crimean Tatars, reiterating Ankara's support for the Tatar community.",
      "date": "2016-10-07 00:00:00"
    },
    {
      "id": "ed8db066-3572-46a8-98ff-01ad76662339",
      "text": "Turkey launched Operation Euphrates Shield and backed Syrian rebel groups in northern Syria (including 2016 operations such as the capture of Jarablus).",
      "date": "2016-08-24 00:00:00"
    },
    {
      "id": "cd24668d-5a2d-4d25-9e4f-161f11611d13",
      "text": "Repeated international reports and accusations that Turkey had allowed foreign fighters to cross its border into Syria during the civil war.",
      "date": "2014-03-31 00:00:00"
    },
    {
      "id": "5986747e-02d6-4ce7-aab0-db589195fba5",
      "text": "Crimean Tatar World Congress held in Ankara where leaders and diaspora groups met and called for international support against Russia's annexation.",
      "date": "2015-08-24 00:00:00"
    },
    {
      "id": "3295240f-72b7-4247-9609-5e8312beadf4",
      "text": "U.S. and Western sanctions were imposed on the Night Wolves and their leader (December 2014), marking the group as pro‑Kremlin and controversial in Western diplomatic reporting.",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "3698a301-7a64-46ef-9f95-c34dc5ed8181",
      "text": "Earlier influential scientific framing of an Amazon 'tipping point' (Lovejoy & Nobre / Science Advances) estimating thresholds (often cited ~40% deforestation) for large‑scale dieback to savanna.",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "18f82ef6-d088-4ea4-a1d8-2c2e76ae3a8c",
      "text": "UN experts warn of chemical disaster and water‑safety risks after shelling near installations containing chlorine and other chemicals in Donetsk region",
      "date": "2017-11-10 00:00:00"
    },
    {
      "id": "1f2bc923-735d-43cb-b434-90a5ade6316e",
      "text": "OSCE thematic report: 'Access to water in conflict‑affected areas of Donetsk and Luhansk'",
      "date": "2015-09-24 00:00:00"
    },
    {
      "id": "129c65e8-0dfc-4fe2-92cd-7ba8bdd6b0ca",
      "text": "ICRC: 'More than 350,000 people face acute water shortage in eastern Ukraine' after damage to pumping stations and staff unable to remain on duty",
      "date": "2017-06-24 00:00:00"
    },
    {
      "id": "4a1100bd-0d21-4a8e-a3be-dc65ae4acb3d",
      "text": "Power supplies to a Donetsk filtration plant hit by shelling, leaving large areas without water",
      "date": "2014-11-19 00:00:00"
    },
    {
      "id": "0213cd1b-8b7d-4c86-810f-98a80cf0764f",
      "text": "Adoption and public debate around Ukraine's 2019 language law ('On Ensuring the Functioning of Ukrainian as the State Language').",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "c5b2e942-0a09-4814-b808-5dcefeb3d5ee",
      "text": "Post‑invasion 'derussification' measures and rapid renaming/removal of Russian/Soviet toponyms and monuments across Ukraine in 2022.",
      "date": "2022-04-27 00:00:00"
    },
    {
      "id": "a87bdeee-b360-4bb2-8cc6-3965afae1f9f",
      "text": "U.S. Department of the Treasury designates the 'Donetsk People's Republic' and 'Luhansk People's Republic' in an expanded Ukraine-related sanctions package",
      "date": "2014-07-16 00:00:00"
    },
    {
      "id": "370b35db-401a-4dde-b9d8-be033b45ead1",
      "text": "EU/European institutions tie sanctions policy to implementation of the Minsk agreements (2015) and list the so-called DPR/LPR in sanctions contexts",
      "date": "2015-03-24 00:00:00"
    },
    {
      "id": "70d39cc1-17a3-4c78-868b-524525fee81f",
      "text": "U.S. Executive Orders and related sanctions authorities (E.O. 13660 / 13661 / 13662) invoked in 2014 to address actors 'asserting governmental authority' in parts of Ukraine",
      "date": "2014-03-06 00:00:00"
    },
    {
      "id": "2ae1a6a2-00dc-4716-8f58-ba4af4a22dfb",
      "text": "Pro-Russian separatist authorities in Donetsk proclaim the 'Donetsk People's Republic' after seizing regional buildings (widely reported)",
      "date": "2014-04-07 00:00:00"
    },
    {
      "id": "e19cdc91-b26c-4c06-af84-6bc813283f6f",
      "text": "Minsk II agreement (Feb 12, 2015) signed after talks in which leaders of the self-proclaimed Donetsk and Luhansk entities were included as signatories",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "15c88d5d-4214-4f6a-8e3e-981cf10164b3",
      "text": "Japan found stainless‑steel/foreign particles in multiple Moderna COVID‑19 vaccine vials and recalled batches (high‑profile contamination incident).",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "ff62d27d-55b2-45bd-a9ac-aaa477b9caab",
      "text": "Danish population‑based study reporting increased incidence of myopericarditis after Pfizer mRNA vaccination in adolescents.",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "4eab83b6-6e27-46f1-bdc6-5cbc5609e5ef",
      "text": "Publication of 'Batch-dependent safety of the BNT162b2 mRNA COVID-19 vaccine' (Denmark) reporting heterogeneous rates of suspected adverse events between Pfizer vaccine batches.",
      "date": "2023-03-30 00:00:00"
    },
    {
      "id": "dc1984b6-3a67-4928-bd53-8112534f27f8",
      "text": "U.S. court orders and publicized releases/requests for large numbers of FDA documents related to the Pfizer‑BioNTech vaccine.",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "221a865f-71a5-4c68-80f7-d7234ebe441b",
      "text": "Peer‑reviewed drug‑delivery studies (e.g., polysorbate 80‑coated PLGA nanoparticles, PubMed ID 26407669) demonstrating that polysorbate 80 can increase blood‑brain barrier permeability in experimental formulations.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "8a7d0894-415e-4f16-b859-8f67461bc8e4",
      "text": "ASHP drug‑shortage / product detail page for Vitamin K notes Amphastar formulation contains polysorbate 80 and propylene glycol (clinical pharmacy resource).",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "edc2d296-1347-4472-9cd6-ee8b4ce94306",
      "text": "American College of Pediatricians (ACPeds) statement (Jan 2016) flagged concerns about HPV vaccine and possible premature ovarian failure (POF)—invoked by some groups to link polysorbate 80 and infertility.",
      "date": "2016-01-24 00:00:00"
    },
    {
      "id": "f1781c7e-8053-4b57-a9c9-d07754f1449a",
      "text": "Kyiv suspended routine pension and social payments to residents in non-government-controlled parts of Donetsk and Luhansk in late 2014, requiring IDP registration and in-person collection in government-controlled areas.",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "c470d7a4-b30f-4401-9705-0d43de6cab4e",
      "text": "Ukraine passed major pension-reform legislation in 2017 amid warnings from the IMF and World Bank about fiscal sustainability and pension costs.",
      "date": "2017-10-24 00:00:00"
    },
    {
      "id": "58eaeb8a-7e9a-4fc8-bd33-f98733127de0",
      "text": "Ukraine’s 2015 fiscal crisis and international bailout needs (IMF programs 2014–2015) created repeated reporting of severe budgetary pressure on Kyiv.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "c1435856-a581-4c7f-b78c-d5da6430d59d",
      "text": "After Russia’s 2014 annexation of Crimea, Moscow moved to apply Russian pension law and budget subsidies to Crimea and began assuming responsibility for pension payments there.",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "7336bdd4-dcd5-495e-b819-17b1b8611550",
      "text": "Visible US troop rotations and equipment deliveries to Poland (arrival of US armor and rotational forces)",
      "date": "2017-01-12 00:00:00"
    },
    {
      "id": "bff091f3-e410-47a5-a7df-00cebb8fc2ed",
      "text": "NATO Communications and Information Agency exercise 'RAMSTEIN DUST‑II' testing deployable NATO air/communications connectivity (DACCC) capabilities",
      "date": "None"
    },
    {
      "id": "11630551-a0e1-4832-850e-eb02c61c8bfc",
      "text": "NATO defence ministers approve creation of the Joint Support and Enabling Command (JSEC) in Ulm, Germany",
      "date": "2018-06-07 00:00:00"
    },
    {
      "id": "19fe6b07-9b6f-4e03-90dc-0d843bac14f6",
      "text": "Public descriptions of Ramstein Air Base as a key US/NATO European hub (US EUCOM reporting and public pages describing Ramstein's C4ISR/logistics role)",
      "date": "2017-10-17 00:00:00"
    },
    {
      "id": "3af86b28-8804-49b8-af9b-699fbba4dc69",
      "text": "Peer-reviewed reviews and renewed clinical-trial activity on high‑dose intravenous vitamin C in cancer (major review published 2022)",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "053e8850-c3b4-4cf3-8c98-02c7211e2065",
      "text": "NCI PDQ summary on Curcumin (turmeric) and cancer published — evidence reviewed but clinical benefit unproven",
      "date": "2021-02-22 00:00:00"
    },
    {
      "id": "8378826f-6566-4850-b9ab-4aa8483aa62b",
      "text": "Systematic reviews and clinical reports on ketogenic diets and cancer published (e.g., systematic review assessing evidence published 2021)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "88546c51-205a-44c2-ba5a-e49e1affa8c9",
      "text": "Public communications and study data showing waning antibody protection over months and consequent official booster recommendations (e.g., booster guidance issued September 2021)",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "97e0bbc0-1c97-4c2a-a768-23b1c5b6499d",
      "text": "Large Israeli nationwide study published on vaccine safety that reported an increased risk of myocarditis after BNT162b2 (Pfizer) vaccination but characterized the events as rare",
      "date": "2021-05-05 00:00:00"
    },
    {
      "id": "e908c0ca-d2a7-4260-ab1e-04cdfa8e34cf",
      "text": "Regulatory vaccine trial and EUA briefing documents (Pfizer/BioNTech FDA briefing) that reported transient laboratory changes including short‑lived lymphocyte count decreases in some participants",
      "date": "2020-12-10 00:00:00"
    },
    {
      "id": "8dbf0918-8f32-4fab-b4f2-d214db9bbec0",
      "text": "NOAA/observational reports noting rapid SST changes in the equatorial Atlantic in 2024 (reported by news agencies)",
      "date": "None"
    },
    {
      "id": "4599ab63-54f7-4a04-8f42-57009a6ae00d",
      "text": "UNICEF situational reporting on widespread attacks and disruptions to water and sanitation in eastern Ukraine (June 2018 SitRep)",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "0ab3b765-e365-4034-93ce-2f660110ff93",
      "text": "HotSpots H2O briefing: continued shelling damaging water infrastructure despite ceasefires (Circle of Blue, July 30, 2018)",
      "date": "2018-07-30 00:00:00"
    },
    {
      "id": "bb69b414-1983-45be-910f-c2835efe19b9",
      "text": "Severe thunderstorms and heavy rains cause flooding and high river levels (KyivPost, June 28, 2018)",
      "date": "2018-06-28 00:00:00"
    },
    {
      "id": "856f5595-5f44-4c10-b3c7-71b79aeaf5c7",
      "text": "Donetsk Filtration Station shelled and operations halted, disrupting water supply",
      "date": "2018-05-18 00:00:00"
    },
    {
      "id": "1404893a-c0b2-4814-ab64-359e2c36b158",
      "text": "Joint War Committee (insurers) placed Ukrainian and Russian waters in the Black Sea and Sea of Azov on its high‑risk/war-listed areas (amendment effective 15 February 2022)",
      "date": "2022-02-15 00:00:00"
    },
    {
      "id": "2086e587-ce6e-4e06-9839-97ca25e372ba",
      "text": "Shipping industry appeals for safe passage for hundreds of merchant vessels and seafarers stranded in Ukrainian ports",
      "date": "2022-03-10 00:00:00"
    },
    {
      "id": "78d710de-a906-4132-bb3a-d2c714abfdcb",
      "text": "Russian Black Sea flagship Moskva damaged and later sank after reported Ukrainian Neptune anti-ship missile strike",
      "date": "2022-04-14 00:00:00"
    },
    {
      "id": "794f77f6-b8b0-4788-a6d2-c21ef39b677f",
      "text": "UN OCHA warning of high risk of communicable‑disease outbreaks among internally displaced persons in Donbas (electricity/water outages, damaged health infrastructure)",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "48de5f88-6848-4e7f-b7fe-44f843b58155",
      "text": "WHO Global Tuberculosis Report (2016) and other analyses showing Ukraine’s high burden of tuberculosis and multidrug‑resistant TB",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "15006e59-2ab6-4689-b249-9373536c9841",
      "text": "Circulating vaccine‑derived poliovirus outbreak confirmed in Ukraine (two paralytic cases)",
      "date": "2015-09-24 00:00:00"
    },
    {
      "id": "183646ae-2ec7-4672-b2e4-ba7db495d1a4",
      "text": "Nationwide tractor convoys and roadblocks as French farmers marched on Paris in late January 2024",
      "date": "2024-01-28 00:00:00"
    },
    {
      "id": "4d8bff75-79ca-4497-8094-ddebeee2b85d",
      "text": "Farmers dumped manure and rotting produce in city centres during protests (reported in Toulouse)",
      "date": "2024-01-24 00:00:00"
    },
    {
      "id": "de34351e-1dc0-47f4-b575-148dbdb62792",
      "text": "Russian Defence Ministry and Kremlin officials call Bucha scenes \"staged provocation\"",
      "date": "2022-04-03 00:00:00"
    },
    {
      "id": "8b4802a2-bf7e-4268-ba24-00b763e64ab1",
      "text": "Public statements and media coverage discussing possible measures against draft dodgers, including asset/account seizure among proposed penalties",
      "date": "2024-02-24 00:00:00"
    },
    {
      "id": "6491f48d-4baf-45b9-82b2-7251833f7208",
      "text": "Public disinfection operations reported and photographed in Ukrainian cities (street/transport spraying, workers in hazmat suits)",
      "date": "2020-03-13 00:00:00"
    },
    {
      "id": "9d9ce06a-8386-47b7-ae5d-017a2e744ce0",
      "text": "Ukrainian government declares nationwide quarantine (Resolution No. 211)",
      "date": "2020-03-11 00:00:00"
    },
    {
      "id": "12c09e06-1f61-42e8-9e16-e01afda25148",
      "text": "FAO follow-up report 'Tackling climate change through livestock: A global assessment' (FAO)",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "1be9d181-cdca-4b5c-9997-fba2dfa838b6",
      "text": "Takeda and Moderna published an investigation report (Oct 1, 2021) into the Japan incident, concluding the particles were 316L stainless steel and describing manufacturing root causes and corrective actions.",
      "date": "2021-10-01 00:00:00"
    },
    {
      "id": "8259ef14-361b-47dc-a04e-4a24e1594092",
      "text": "WHO reported a multi-country monkeypox outbreak in non-endemic countries",
      "date": "2022-05-21 00:00:00"
    },
    {
      "id": "1e35f35f-ebd5-4ba3-8a18-976b164195a8",
      "text": "U.S. president ordered review of COVID origins amid publicized, divided intelligence assessments (fuelling lab-leak narratives)",
      "date": "2021-05-26 00:00:00"
    },
    {
      "id": "71c8491e-9487-4a05-927c-953d05c4279a",
      "text": "Ukrainian authorities built a temporary flow-control dam near Kalanchak in 2014 to restrict canal water into Crimea",
      "date": "None"
    },
    {
      "id": "47fe2c82-b778-47ae-a05a-e4741259bb31",
      "text": "Reports of chronic water shortages, rationing and Russian attempts to substitute supplies (desalination, reservoirs, pipelines) in Crimea",
      "date": "2017-01-04 00:00:00"
    },
    {
      "id": "1facc140-18cb-4bee-9e5c-073a9b6e2dc3",
      "text": "Reports of clergy splits and competing loyalties in Crimea and eastern Ukraine as Russian forces moved in (priests aligning with Russian-backed authorities)",
      "date": "2014-04-01 00:00:00"
    },
    {
      "id": "9d6a225c-723a-4f8a-a9a9-d31582f4cdec",
      "text": "Reports of numerous attacks, seizures or conflicts around Orthodox church buildings and clergy amid 2014 unrest",
      "date": "2014-08-01 00:00:00"
    },
    {
      "id": "44c83632-d3ba-44b3-8e8f-558ea7383cb3",
      "text": "Mejlis of the Crimean Tatar People called for a boycott of the March 2014 referendum",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "eb9276c3-6b9a-45cb-bd9d-ce6001fe6860",
      "text": "Russian leadership publicly framed the referendum and subsequent annexation as a legitimate territorial decision (Putin’s statements/speech coverage mid‑March 2014)",
      "date": "2014-03-18 00:00:00"
    },
    {
      "id": "ebe85d02-d260-458d-9fd8-a2eb30d8a874",
      "text": "Armed seizure of the Crimean parliament and buildings by unmarked pro‑Russian forces",
      "date": "2014-02-27 00:00:00"
    },
    {
      "id": "d65b82b8-3af6-47a7-b42d-b49325b3e69b",
      "text": "Court battles and FOIA demands (PHMPT lawsuit) over release of Pfizer documents, and initial FDA proposals to release documents over decades (the 75‑year timeline headline), stoked distrust and narratives that regulators lacked underlying safety/effectiveness data.",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "b2aadc38-7271-443b-98b6-00461b5d6cf8",
      "text": "Local activists attempted to topple the Felix Dzerzhinsky monument in Zaporizhzhia but failed (public attempt and clashes reported).",
      "date": "2014-11-07 00:00:00"
    },
    {
      "id": "45de970a-321c-43c0-a66e-dfefc8535b91",
      "text": "City unveiled a sculptural composition (‘The Steelworker and the Teacher’) — a bench-like monument to the characters of the film 'Vesna na Zarechnoy Ulitse' — on Shevchenko Boulevard in Zaporizhzhia.",
      "date": "2014-10-11 00:00:00"
    },
    {
      "id": "9bc2ab0f-ee95-4230-bd19-8f3d5b1383d7",
      "text": "Wider wave of removals/topplings of Soviet-era monuments across Ukraine in 2014 (including highly publicized removals of Lenin statues earlier that year).",
      "date": "2014-03-17 00:00:00"
    },
    {
      "id": "cc83063d-de60-4c37-af8f-2a928fc78fc1",
      "text": "Local media and classifieds flagged massive accommodation and flight price spikes in Kyiv ahead of the final (rooms and short-term rentals listed at many times their usual rates).",
      "date": "2018-05-05 00:00:00"
    },
    {
      "id": "854f3543-551f-4acd-a626-75d1a0990083",
      "text": "Press report that more than 2,000 Real Madrid supporters returned tickets citing logistics and 'sky‑rocketing expenses' related to attending the Kyiv final.",
      "date": "2018-05-22 00:00:00"
    },
    {
      "id": "952612b4-1f77-44c3-a040-369786992f85",
      "text": "Polish police statistics and reporting showing a rise in thefts in 2022 (reported Jan 20, 2023)",
      "date": "2023-01-20 00:00:00"
    },
    {
      "id": "f6b25295-4987-4865-950e-7ad582da48d9",
      "text": "Europol-coordinated EU-wide action leading to the arrest of around 130 suspected human traffickers (operation announced June/July 2022)",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "8731915f-2d7c-4772-a3fb-2041138609ad",
      "text": "Mass exodus of civilians from Ukraine into neighbouring EU states after Russia's full-scale invasion (millions crossed borders beginning 24 Feb 2022)",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "11a7e18f-5da2-4c8f-bce2-78c9d221faef",
      "text": "Media coverage and local backlash in Poland documenting xenophobia and the spread of anti-refugee narratives, including claims that Ukrainian refugees are responsible for crime (BBC report)",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "f533e2d1-5daf-4df0-98dd-6062d957663a",
      "text": "Large measles outbreak linked to a theme-park (Disneyland) that spread across multiple states (December 2014–February 2015)",
      "date": "None"
    },
    {
      "id": "40b8c52d-0e05-47b8-92c4-7a51a2673401",
      "text": "PNAS study showing acellular pertussis vaccines protect against disease but may fail to prevent infection and transmission in a nonhuman primate model (often cited 2014)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "f2c53340-b5d5-447f-bfe1-81a987945b9f",
      "text": "Independent assessments of donor assistance (2018) noting limited impact of some programmes",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "5bb3b610-aa82-4d4b-aee8-97d997396356",
      "text": "Lithuania presents a high‑profile 'Marshall Plan for Ukraine' proposal",
      "date": "2017-11-06 00:00:00"
    },
    {
      "id": "3311beac-ea56-47c7-b107-e24ced9d6551",
      "text": "European Court of Auditors special report: 'EU assistance to Ukraine' finds results 'fragile'",
      "date": "2016-12-08 00:00:00"
    },
    {
      "id": "a7e5dcd6-f5cf-4787-8fcf-0e5969168051",
      "text": "U.S. President ordered the U.S. intelligence community to further investigate the origins of COVID‑19 and report findings (public announcement of an intelligence review)",
      "date": "2021-05-26 00:00:00"
    },
    {
      "id": "9dacf18f-a0da-40e1-83fd-d4819d3fab00",
      "text": "Media reports (citing U.S. intelligence) that three Wuhan Institute of Virology researchers sought hospital care in November 2019",
      "date": "2021-05-23 00:00:00"
    },
    {
      "id": "271d8e72-d2e0-4b2a-bab4-8aad1c915ad7",
      "text": "WHO-convened Global Study of Origins of SARS‑CoV‑2: China Part report released, offering assessments of possible origin hypotheses but noting limited access to raw data and calling for further study",
      "date": "2021-03-30 00:00:00"
    },
    {
      "id": "55aefe89-aa6e-4c04-a7a5-a635b73bd5de",
      "text": "European Union Advisory Mission (EUAM) begins operations in Kyiv to advise on civilian security-sector reform",
      "date": "2014-12-01 00:00:00"
    },
    {
      "id": "68c9b6e8-dc09-4d64-a8d7-c197c95877c3",
      "text": "Launch of new Kyiv patrol police (major public-facing police reform supported by international partners)",
      "date": "2015-07-04 00:00:00"
    },
    {
      "id": "e22f7c32-c0cc-4765-b07e-35e06535254b",
      "text": "U.S. announces a $200 million security assistance package for Ukraine (release reported July 20, 2018)",
      "date": "2018-07-20 00:00:00"
    },
    {
      "id": "0ec1ded8-6576-460e-be9d-3b5b853d3b05",
      "text": "Canada launches Operation UNIFIER — Canadian Armed Forces training mission for Ukrainian personnel",
      "date": "2015-04-14 00:00:00"
    },
    {
      "id": "0a8a26f2-5737-41b6-a719-b9c2adf6ee46",
      "text": "Peer‑reviewed review article (CMAJ) summarising mechanisms and multiple case reports showing grapefruit (furanocoumarins) can irreversibly inhibit intestinal CYP3A4 and cause dangerous increases in blood levels of many drugs (including some CNS agents).",
      "date": "2013-03-05 00:00:00"
    },
    {
      "id": "9f6f6f31-0f13-4951-922f-005787192b55",
      "text": "Case report published describing a presentation mimicking quetiapine (an antipsychotic) overdose linked to grapefruit juice consumption ('Grapefruit Juice Cleanse Mimicking Quetiapine Overdose', J Clin Psychopharmacol).",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "fa44083a-61f0-4701-bb91-19006e6597ec",
      "text": "Existence and public use of the Mapuche (Wenufoye) flag in Chilean demonstrations",
      "date": "None"
    },
    {
      "id": "629575ca-5c65-4ca0-b7ca-58a497854762",
      "text": "Large Euromaidan demonstrations in Kyiv with widespread display of Ukrainian blue-and-yellow flags",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "565e4399-de52-4508-9fd7-76f912ef3d00",
      "text": "IPCC Fifth Assessment Report (AR5) discussion of a temporary slowdown ('hiatus') in surface warming (1998–2012)",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "5c67b5b9-d347-4c83-80e2-b45b0d5ec9b3",
      "text": "Publication and promotion of Lindzen & Choi's low climate‑sensitivity analysis (2011)",
      "date": "2011-04-24 00:00:00"
    },
    {
      "id": "d44634d9-fe38-4821-82b8-1de3a6e41525",
      "text": "IPCC Fifth Assessment Report (AR5) publication stating with high confidence that recent warming is caused by human activities",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "9685729a-b9db-4a49-a949-2afbb17fc9df",
      "text": "WHO interim guidance on mask use early in the pandemic (initial cautious messaging)",
      "date": "2020-03-19 00:00:00"
    },
    {
      "id": "b2c6dfe5-3e31-4b12-9fe6-1c1b13e8ba63",
      "text": "CDC recommendation that the public wear cloth face coverings (press guidance)",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "8d9d41c6-da0f-401e-b936-f4807632bf31",
      "text": "Russia launched one of the largest waves of missile and drone strikes across Ukraine on 29 December 2023, hitting cities and critical infrastructure",
      "date": "2023-12-29 00:00:00"
    },
    {
      "id": "070deb89-5a21-450b-b8d1-72a1c7578939",
      "text": "Estonian Defence Forces Intelligence Centre head Col. Ants Kiviselg gave a press briefing describing intensified Russian missile/drone waves, saturation tactics and damage to Ukrainian infrastructure (remarks later taken out of context)",
      "date": "2024-01-12 00:00:00"
    },
    {
      "id": "f8d94d2b-829f-4f01-bfb7-58a292aee5a2",
      "text": "Publication of Rasool & Schneider (Science) 1971 paper on aerosols and cooling",
      "date": "1971-07-24 00:00:00"
    },
    {
      "id": "071dbeb4-43d3-46f7-8d0b-56456f15f2bb",
      "text": "FTC warned hundreds of marketers (April 2023) about potential civil penalties for unsubstantiated health claims, including for CBD products.",
      "date": "2023-04-27 00:00:00"
    },
    {
      "id": "04a45d39-7beb-4f4f-bead-78db2d4b7c6c",
      "text": "Meta‑analysis showing PTSD is associated with increased risk of later dementia (British Journal of Psychiatry, 2020)",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "39311e16-85f9-494a-bd0d-6c08537af9e0",
      "text": "FDA enacted rule and labeling requirements to limit aluminum contamination in parenteral nutrition products (Final rule enacted July 2004).",
      "date": "2004-07-24 00:00:00"
    },
    {
      "id": "bc395992-d8db-4064-be79-0eca3f5dea93",
      "text": "Published research documenting parental refusal and hesitancy specifically around the hepatitis B birth dose (study investigating reasons parents decline newborn HepB immunisation).",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "bf32c5da-6283-448d-8acb-44393b76d8a6",
      "text": "Publication of Mitkus et al., 'Updated aluminum pharmacokinetics following infant exposures through diet and vaccination' (Vaccine, 2011).",
      "date": "2011-11-24 00:00:00"
    },
    {
      "id": "68ee3726-92bd-4c45-947c-6b2f5d426fdc",
      "text": "PNAS paper documenting very slow and variable human liver dihydrofolate reductase (DHFR) activity (Bailey & Ayling, 2009)",
      "date": "2009-09-24 00:00:00"
    },
    {
      "id": "26ebec99-02a1-45a0-8717-5a3f6dbd0172",
      "text": "Report/analysis identifying threshold folic acid doses above which unmetabolized folic acid appears in serum (Sweeney et al., BMC Public Health)",
      "date": "2007-04-24 00:00:00"
    },
    {
      "id": "cd83f40d-8334-4b57-9cd3-265c7647f9d5",
      "text": "Reports from China and international press noting use or trials of high‑dose vitamin C in Chinese hospitals",
      "date": "2020-03-28 00:00:00"
    },
    {
      "id": "c7b0be5d-d9a8-4a18-be17-7e886aa98900",
      "text": "Surge in consumer demand and sales for immune‑support supplements (vitamin C and D) during March 2020",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "2e14056b-ff7a-4e03-a1bf-ea1809a824f3",
      "text": "Svyatoslav Vakarchuk’s public record of outspoken political commentary and criticism of Ukraine’s political class",
      "date": "2016-10-20 00:00:00"
    },
    {
      "id": "5e8f4fa4-fa26-485e-8e61-7934f5c5bf39",
      "text": "Kerch Strait incident: Russian coastguard fired on and seized three Ukrainian naval vessels attempting to transit the Kerch Strait.",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "e658e375-6c2f-4f15-9f9d-05a7f91f8865",
      "text": "Ukraine introduced temporary martial law in regions bordering Russia and the Azov-Kerch water area.",
      "date": "2018-11-26 00:00:00"
    },
    {
      "id": "5672f72d-fdb3-40c3-a299-ccdace7d2199",
      "text": "Russian officials publicly accused Ukraine of deliberately provoking the Kerch incident and warned of further Ukrainian 'provocations'.",
      "date": "2018-11-26 00:00:00"
    },
    {
      "id": "96b171d8-ea9d-45d2-a4ad-33902e09056a",
      "text": "In vitro study examining activated charcoal and GHB adsorption (toxicology literature)",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "fa5a6b57-1a47-493a-a36b-3025a63eb5da",
      "text": "Peer‑reviewed publication demonstrating intranasal/intratracheal delivery of mRNA to mouse lungs using polymer nanoparticles (Sci Transl Med).",
      "date": "2023-08-16 00:00:00"
    },
    {
      "id": "42ce3983-1339-4c62-ad23-b361140f3706",
      "text": "Hank Aaron publicly received his first dose of the Moderna COVID-19 vaccine at Morehouse School of Medicine to encourage vaccination among Black Americans.",
      "date": "2021-01-05 00:00:00"
    },
    {
      "id": "632f8c9e-0c8d-40c2-8faa-2fa2e56e9f15",
      "text": "Hank Aaron died at age 86 (widely reported on Jan 22, 2021) a few weeks after his public vaccination.",
      "date": "2021-01-22 00:00:00"
    },
    {
      "id": "5dd26957-ac5f-49e5-9148-5b3ea159693b",
      "text": "Publication of a Phase II clinical trial showing curcumin was safe and produced biological effects in patients with advanced pancreatic cancer (Dhillon et al.).",
      "date": "2008-07-24 00:00:00"
    },
    {
      "id": "e52e5643-5b35-422e-a31c-76a074784133",
      "text": "Rapid growth in the commercial turmeric/curcumin supplement market and aggressive product marketing by supplement companies (industry coverage 2015–2018).",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "af84a2c0-20f1-445d-a47e-be722157f866",
      "text": "CDC report on resurgence of 'black lung' (progressive massive fibrosis) in coal miners",
      "date": "2016-12-24 00:00:00"
    },
    {
      "id": "123862a1-b1a1-466b-89e8-98bd635fdfa0",
      "text": "Informal agreement reached between the Maltese Presidency and the European Parliament on visa liberalisation for Ukrainians",
      "date": "2017-02-28 00:00:00"
    },
    {
      "id": "25eeb302-e32d-4093-9ccb-28a145392db1",
      "text": "Commission's visa‑liberalisation proposal specified biometric‑passport holders",
      "date": "2016-04-20 00:00:00"
    },
    {
      "id": "bce70684-d785-4f5d-8b34-b37d39ad4b8d",
      "text": "Statement that Ireland and the United Kingdom are not subject to the new visa regime",
      "date": "2017-03-02 00:00:00"
    },
    {
      "id": "c347c984-61b9-4be7-9681-e09841c11eb9",
      "text": "EU Council adopts revision of the visa‑waiver suspension mechanism",
      "date": "2017-02-27 00:00:00"
    },
    {
      "id": "046ed115-be27-400a-9c8c-0cb80c6561c9",
      "text": "France's health authority (HAS) recommends a single COVID-19 vaccine dose for people previously infected",
      "date": "2021-02-12 00:00:00"
    },
    {
      "id": "4aa20286-0f2d-4b59-bae1-e84853948865",
      "text": "NEJM research letter (Krammer et al.) showing rapid, high antibody responses in seropositive persons after a single mRNA vaccine dose",
      "date": "2021-03-10 00:00:00"
    },
    {
      "id": "6f110a73-018f-47fd-9d6c-f95e95b1b2af",
      "text": "U.S. FDA revokes the Emergency Use Authorization (EUA) for hydroxychloroquine and chloroquine for COVID-19.",
      "date": "2020-06-15 00:00:00"
    },
    {
      "id": "0c97f7fb-82f0-4efe-b17a-2da2ba7482f6",
      "text": "WHO temporarily halts the hydroxychloroquine arm of the Solidarity Trial over safety concerns.",
      "date": "2020-05-25 00:00:00"
    },
    {
      "id": "b324b72e-88e6-43e0-b030-70c39eb247b5",
      "text": "Russian presidential decree fast-tracking Russian citizenship for Ukrainians",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "119c8926-bea7-4ad3-b11e-636b958ad8c1",
      "text": "Installation of Russian-backed local administrations and visible propaganda campaigns in occupied cities (e.g., Kherson)",
      "date": "2022-05-24 00:00:00"
    },
    {
      "id": "5333d473-984a-4b43-8d25-bf25f200d4a4",
      "text": "Widespread passport issuance (‘passportization’) in occupied Ukrainian cities",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "6a3e6b2f-8f3a-428c-afa4-84fc7d2d5fe1",
      "text": "Pre-war and wartime local public-opinion surveys showing mixed but non-negligible support for closer ties with Russia in parts of Donbas",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "15cdcf77-2de5-4af8-a741-22b3b80db643",
      "text": "Prior public reporting and regulatory actions in 2021 about rare blood-clotting events with some COVID-19 vaccines (e.g., Johnson & Johnson/AstraZeneca) established a persistent vaccine–blood clot association in public discourse.",
      "date": "2021-04-23 00:00:00"
    },
    {
      "id": "58780262-bc3b-4b04-961b-43d2e249fc68",
      "text": "Government statement ending the legal duty to self-isolate in England as part of the 'Living with COVID' approach",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "82f84f21-f75a-48ff-ae8a-b54bdf66ef25",
      "text": "Great Barrington Declaration (October 4, 2020) advocating 'focused protection' and arguing against ongoing mass interventions",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "70c8b6e0-2edd-47f7-a604-ef58a468a3c7",
      "text": "Publication and circulation of official guidance clarifying limitations of PCR cycle threshold (Ct) values (explaining PCR can detect non-infectious viral fragments)",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "4624f61b-3248-4c50-94af-20616705fcde",
      "text": "NOAA AOML study documents an unusually rapid cooling phase in the equatorial Atlantic following record-warm conditions in 2024",
      "date": "2024-08-14 00:00:00"
    },
    {
      "id": "a027dc7b-c9a7-4547-9440-45d1f7341f8b",
      "text": "Safety and technical evaluations by consumer-safety groups (Electrical Safety First and independent lab tests) showing plug-in ‘power saver’ devices do not reduce residential bills and can pose fire/shock hazards.",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "2d75641d-f6d3-4c2c-9905-d28c78ee7d48",
      "text": "Reports of volunteer militias forming in Ivano‑Frankivsk region (local volunteer militia of Prykarpattia reported by Interfax)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "efb8e062-80c6-4169-878c-cfe628f51ca3",
      "text": "UN/UNICEF campaign 'Children, Not Soldiers' and international attention to child recruitment (launched March 2014)",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "a93d140c-7059-40a4-9fc7-f386305f99f1",
      "text": "Anti‑migrant unrest in Torre Pacheco (July 2025) that was inflamed by a misleading social‑media video and triggered violent reprisals and arrests.",
      "date": "2025-07-15 00:00:00"
    },
    {
      "id": "861036e7-6c6d-431d-86cc-846f663b7514",
      "text": "Ongoing monitoring by EUvsDisinfo and similar fact‑checking bodies documenting a recurring pro‑Kremlin pattern of inserting 'Ukrainians' into unrelated crimes abroad to discredit Ukrainian citizens.",
      "date": "None"
    },
    {
      "id": "12a6998f-d040-4d06-899a-7db8d940defb",
      "text": "Spanish National Police arrested seven people suspected of stealing more than 1,100 chairs from restaurants and bars in Madrid and Talavera de la Reina.",
      "date": "2025-10-22 00:00:00"
    },
    {
      "id": "993f1d99-f715-4c38-a1fe-58a206840121",
      "text": "Reuters special report documenting separatists' access to grenades and grenade launchers in Luhansk/Donbas",
      "date": "2014-05-29 00:00:00"
    },
    {
      "id": "8ec60233-7bae-41a9-80e9-b644a2146314",
      "text": "Visual evidence of tanks displayed in Luhansk public spaces and on-the-ground photos around early July 2014 (T-34‑85 in Luhansk report)",
      "date": "2014-07-06 00:00:00"
    },
    {
      "id": "3a6c93e6-3546-46ae-9c1b-18f087ae34c0",
      "text": "Odesa deadly clashes (May 2, 2014) with dozens killed and widely circulated graphic images",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "34b203bf-2d15-4e33-92ab-e2d68078324b",
      "text": "European Court of Human Rights ruled her pre-trial detention was arbitrary/unlawful (June 2013)",
      "date": "2013-06-30 00:00:00"
    },
    {
      "id": "bd4c7672-0948-4f47-a723-25801c90c440",
      "text": "Tymoshenko released from prison during the Euromaidan upheaval (22 February 2014)",
      "date": "2014-02-22 00:00:00"
    },
    {
      "id": "ea2a43fb-c001-41f9-ac74-95a4e68619e1",
      "text": "Massive oil depot fire/explosion began near Vasylkiv (outside Kyiv) on June 8, 2015",
      "date": "2015-06-08 00:00:00"
    },
    {
      "id": "af9b47f0-f78b-405a-813a-dc4f6e375e37",
      "text": "Reports of renewed outbreaks/explosions at the depot after partial containment (June 11, 2015)",
      "date": "2015-06-11 00:00:00"
    },
    {
      "id": "8b0158bf-7d51-4aa1-ba16-ddd321c12f16",
      "text": "State-level legalization and commercialization expansion (New York signs Marijuana Regulation and Taxation Act)",
      "date": "2021-03-31 00:00:00"
    },
    {
      "id": "5537b25c-7236-4628-8260-1c0ab6cefa6e",
      "text": "National Academies report: The Health Effects of Cannabis and Cannabinoids (comprehensive evidence review)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "64d50828-be74-4db2-bbf2-da64e9fa2f7d",
      "text": "FDA approves Epidiolex (cannabidiol) for treatment of specific severe epilepsy syndromes",
      "date": "2018-06-25 00:00:00"
    },
    {
      "id": "0eb8db24-a286-43df-a6bc-012647f9c7cc",
      "text": "Japan suspension of multiple Moderna vaccine batches after discovery of foreign/metal particles (September 2021).",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "72044b8d-c4b4-4a59-80fc-c235b79789a5",
      "text": "Publication of Lund University in vitro study reporting reverse transcription of Pfizer-BioNTech mRNA in human liver cell line (Huh7).",
      "date": "2022-02-25 00:00:00"
    },
    {
      "id": "4e688659-175b-45b5-95ad-46280a2e633c",
      "text": "2014 Simferopol incidents and defections of Ukrainian officers during Russia's annexation of Crimea.",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "82532113-a968-4ea0-adb1-2e87cd0207dc",
      "text": "U.S. delivery of Javelin anti-tank missiles and launchers to Ukraine",
      "date": "2022-01-25 00:00:00"
    },
    {
      "id": "c684ac85-415e-4d8e-9af0-8aeb612bd6c9",
      "text": "Statements and claims from Russian officials and state media accusing Western-supplied arms to Ukraine of being diverted or becoming a broader security threat",
      "date": "2022-04-25 00:00:00"
    },
    {
      "id": "7a90859f-3959-4ce6-aac2-3e8c49a44d33",
      "text": "IARC (WHO) evaluation and monograph work classifying formaldehyde as carcinogenic to humans (Group 1)",
      "date": "2004-06-24 00:00:00"
    },
    {
      "id": "89b9c035-3efa-46e8-8eaa-18f76dbcf1a8",
      "text": "American Academy of Pediatrics and U.S. Public Health Service joint statement recommending reduction/removal of thimerosal from infant vaccines",
      "date": "1999-07-24 00:00:00"
    },
    {
      "id": "b4170d9c-3b72-465a-809d-171f28b7a66b",
      "text": "ACIP / CDC guidance and publications clarifying influenza vaccination in persons with egg allergy (making ovalbumin/egg protein salient)",
      "date": "2011-08-24 00:00:00"
    },
    {
      "id": "6d750e2a-53c7-4e33-b3ad-f199faeee237",
      "text": "Pfizer and BioNTech began their large Phase 3 COVID‑19 vaccine trial and publicly stated trial enrollment had started.",
      "date": "2020-07-27 00:00:00"
    },
    {
      "id": "5ece7e1d-f751-433f-a23d-a8b8429783f9",
      "text": "Reports of children killed or injured in Kharkiv region shelling (multiple local reports and rights groups)",
      "date": "2022-03-07 00:00:00"
    },
    {
      "id": "2eaec24e-b54e-436c-b85e-1fe26407abfd",
      "text": "Prior high‑profile vaccine safety scares (e.g., Japan’s temporary suspension/recall of some Moderna batches after finding foreign particles)",
      "date": "2021-08-28 00:00:00"
    },
    {
      "id": "79853758-a1f1-4361-979e-67f91fdad3ab",
      "text": "Public availability of population‑level mortality datasets (World Mortality Dataset / Our World in Data) used by the authors to compute excess deaths",
      "date": "None"
    },
    {
      "id": "ca6f1116-8965-4191-9f7a-2de14fbc69cd",
      "text": "Publication of large peer‑reviewed estimates of lives saved by COVID‑19 vaccination (Lancet study, June 2022)",
      "date": "2022-06-23 00:00:00"
    },
    {
      "id": "ffda74a4-dbc9-407e-b330-796ec4986f62",
      "text": "Protests and roadblocks in multiple towns as gas-dispute left houses without heating",
      "date": "2018-11-14 00:00:00"
    },
    {
      "id": "0eac5b4f-7673-4393-8130-bd9ac9fe96d9",
      "text": "Large-scale winter protests on Maidan (Euromaidan) in cold conditions, Nov 2013–Feb 2014",
      "date": "None"
    },
    {
      "id": "009f8b89-e667-4b4b-a5e4-d6dfa011918d",
      "text": "Local Kyiv residents block a street to demand restoration of heating after prolonged outages",
      "date": "2018-11-19 00:00:00"
    },
    {
      "id": "52ef3fd8-fb9b-4909-a130-323a330527e2",
      "text": "National gas-price increase announced and implemented, triggering utility cutoffs for non‑paying customers",
      "date": "2018-11-01 00:00:00"
    },
    {
      "id": "31c3b00e-f900-4850-9e73-0223030754b4",
      "text": "U.S. delivery/confirmation of Javelin anti-tank missiles to Ukraine",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "4d8ffea9-6020-4546-8897-a13e1054d374",
      "text": "Kerch Strait incident: Russian forces fired on and seized three Ukrainian naval vessels",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "939b5de3-dfc6-4646-8e79-a15b536f10d3",
      "text": "Ukraine lawmakers approve a significantly increased defence budget for 2020",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "3fca1f99-4c3f-427d-9ab5-018b6b50369b",
      "text": "Large multinational Sea Breeze 2019 naval and amphibious exercises in the Black Sea near Ukraine and Crimea",
      "date": "2019-07-24 00:00:00"
    },
    {
      "id": "db688f4b-62e3-44b7-adcf-3ae0f870d11d",
      "text": "CDC and FDA acknowledged increased reports of myocarditis and pericarditis after mRNA COVID-19 vaccination and reviewed the evidence (June 2021 ACIP/MMWR updates)",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "5a270b86-3ac0-429a-8fff-2627bc79785d",
      "text": "U.S. CDC and FDA recommended a temporary pause on the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare clotting events (April 2021)",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "ac0bbf2a-9912-4968-bfc5-af50067156d3",
      "text": "Norwegian Medicines Agency investigation into 23 deaths of very frail elderly people after Pfizer/BioNTech vaccination (investigation reported publicly)",
      "date": "2021-01-15 00:00:00"
    },
    {
      "id": "6da95ac5-d396-43fa-bc70-0f96e1fd62e9",
      "text": "European Medicines Agency (EMA) finds a possible link between the AstraZeneca COVID-19 vaccine and very rare blood clots with low platelets",
      "date": "2021-04-07 00:00:00"
    },
    {
      "id": "0ea158f9-2cf9-4c14-943a-a6995d3d2c1e",
      "text": "Reporting on targeted Russian disinformation campaigns aimed at Poland–Ukraine relations (contextual, enabling environment)",
      "date": "2022-04-10 00:00:00"
    },
    {
      "id": "57a76d29-9b46-4758-9cfa-c3502439191b",
      "text": "Publication of Rabbit Hole interview with Sergiy Nikolaychuk (Deputy Governor, National Bank of Ukraine)",
      "date": "2022-06-30 00:00:00"
    },
    {
      "id": "74a92bfe-e7e2-4a17-96f3-977bd6c75971",
      "text": "FAO releases 'Pathways towards lower livestock emissions' at COP28 (FAO report on livestock methane and mitigation)",
      "date": "2023-12-24 00:00:00"
    },
    {
      "id": "3391df15-1751-44cb-ad85-ed274782fe12",
      "text": "Publication and industry publicity for papers endorsing GWP* as a better metric for methane (coverage by AHDB and others)",
      "date": "2023-11-24 00:00:00"
    },
    {
      "id": "99282d0d-b110-43d5-9e0d-5d05ffc5a116",
      "text": "IPCC Special Report on Global Warming of 1.5°C (2018) — discussion of polar amplification and regional differences",
      "date": "2018-10-24 00:00:00"
    },
    {
      "id": "e767a553-5fcb-4e12-b80e-2a3793afb03d",
      "text": "SCAR (Scientific Committee on Antarctic Research) report: 'Antarctic Climate Change and the Environment' — 2019 update",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "54574071-66b5-4e68-a984-ed6d330c2fdf",
      "text": "Crimea's supreme court banned the Mejlis (the representative body of the Crimean Tatar people), declaring it an 'extremist' organization.",
      "date": "2016-04-26 00:00:00"
    },
    {
      "id": "593d53aa-de27-41d6-97e5-f1eb58f1f26e",
      "text": "Prominent Crimean Tatar leaders (e.g., Mustafa Dzhemilev) gave repeated public statements and interviews emphasizing that Crimea is the historical homeland of Crimean Tatars and calling for protection of their rights and autonomy within Ukraine.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "8f58bdbd-80dc-42f6-9f33-f1c5cc88f715",
      "text": "Large Crimean Tatar-led protest in Simferopol (Day of Resistance), where thousands marched on 26 February 2014 opposing annexation and asserting Crimean Tatar identity and rights.",
      "date": "2014-02-26 00:00:00"
    },
    {
      "id": "6a2c1a2d-6dae-481b-9511-8f7f6c41b31e",
      "text": "ATR, the only mainstream Crimean Tatar–language TV channel operating in Crimea, was denied a Russian broadcasting licence and forced off the air in the occupied peninsula.",
      "date": "2015-04-01 00:00:00"
    },
    {
      "id": "56e46f91-f578-424b-ac97-61bd4ad09dda",
      "text": "Soviet-era mass renaming of Crimean toponyms (large-scale replacement of Crimean Tatar place names with Russian names, principally 1944–1949).",
      "date": "None"
    },
    {
      "id": "5f76fcd7-ca7d-4991-9748-23fdfb329e19",
      "text": "The IAEA publicly condemned shelling near the Zaporizhzhia plant and warned the situation was dangerous (IAEA statements in early August 2022).",
      "date": "2022-08-06 00:00:00"
    },
    {
      "id": "6f1f4db2-f7ad-4038-88b1-e49cb9941fd0",
      "text": "Russian forces seized control of the Zaporizhzhia Nuclear Power Plant during initial invasion operations.",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "45d0fe49-586e-4392-aab0-6e2ee5485bc6",
      "text": "CDC publishes MMWR report (Risk Factors for Severe COVID-19 Outcomes) showing that among vaccinated persons who died after completing a primary vaccination series, 77.8% of those deaths had four or more risk factors.",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "db76db46-d82b-43b1-95f1-a3ed8ba63240",
      "text": "Repeated regulatory actions (2014–2016) by Ukraine's media regulator removed or blocked numerous Russian channels and programming from Ukrainian airwaves.",
      "date": "2016-02-12 00:00:00"
    },
    {
      "id": "85210055-881e-4173-8e99-af2342aaa7f6",
      "text": "Heavy shelling and bombardment in Donetsk during fighting in late 2014 damaged infrastructure, disrupting TV transmissions and showing visibly destroyed broadcast facilities.",
      "date": "2014-11-24 00:00:00"
    },
    {
      "id": "b4699b79-c057-434f-9ab8-3ed0ed11dd05",
      "text": "2021 Ukrainian government sanctions that removed three pro‑Russian TV channels (112 Ukrayina, NewsOne, ZIK) from broadcast.",
      "date": "2021-02-03 00:00:00"
    },
    {
      "id": "c7652e57-3b50-4af6-a37e-e5141018e8db",
      "text": "Long‑running Russian state and proxy narratives alleging systemic persecution of Russian‑speakers in Ukraine (used as framing and justification since 2022).",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "015d0d8a-b015-429a-ad12-eb03df372dd5",
      "text": "Context of real international humanitarian assistance to Ukraine in 2015 (EU/Austria aid packages) — e.g., European Commission announced additional humanitarian assistance in January 2015.",
      "date": "2015-01-29 00:00:00"
    },
    {
      "id": "96eb0004-956e-4d80-a84f-7200a1e0ad40",
      "text": "The stories invoked an historical Austro-Hungarian practice (dating to 1774) of paying soldiers stationed in Bukovina to compensate for climatic conditions.",
      "date": "2015-12-24 00:00:00"
    },
    {
      "id": "196e5bb8-2507-4fea-9a34-465a3d1bbe5c",
      "text": "High public awareness of large solar PV penetration in Spain (record generation in 2024)",
      "date": "None"
    },
    {
      "id": "1a4a8584-a47f-491a-ac01-9a7df33ccd94",
      "text": "Dutch-led teams recovered wreckage and human remains from rebel-held areas with local actors cutting and loading debris (reported removal of 'crucial debris')",
      "date": "2014-11-16 00:00:00"
    },
    {
      "id": "eb984b97-6ee7-479d-982d-52c0d85f4175",
      "text": "OSCE and investigators documented limited access, delays, and chaotic control of the crash site by armed groups",
      "date": "2014-11-11 00:00:00"
    },
    {
      "id": "13d812f3-4c7f-4860-8bd9-c7296bdb1d82",
      "text": "1994 discovery and publication identifying Kaposi’s sarcoma‑associated herpesvirus (KSHV/HHV‑8) as the viral agent linked to Kaposi’s sarcoma",
      "date": "1994-12-16 00:00:00"
    },
    {
      "id": "62ec7979-29e7-44f5-9061-97b8046f21dd",
      "text": "Publication and media coverage of a 2017 MACS cohort analysis reporting links between heavy popper use and some virus‑associated cancers in older HIV‑negative MSM",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "46074779-fb4f-457a-9f85-8c4299875b73",
      "text": "UNICEF press release and mapping (July 13, 2022) on protection and care of unaccompanied and separated children fleeing Ukraine, highlighting legal complexity and cross‑border guardianship issues.",
      "date": "2022-07-13 00:00:00"
    },
    {
      "id": "0253ccf2-8231-4970-85c0-0d5faa424449",
      "text": "High‑profile 'Jugendamt' child‑removal case (Ariha Shah): German youth welfare authorities removed an infant from her Indian parents in Berlin (reported September 2021).",
      "date": "2021-09-23 00:00:00"
    },
    {
      "id": "7eef192a-a093-4a72-bede-19b3ea62ea63",
      "text": "Furdui family case (April 26, 2021): Seven children of the Furdui family were taken into custody by a German Jugendamt office, generating international coverage and long‑running dispute.",
      "date": "2021-04-26 00:00:00"
    },
    {
      "id": "16f49665-56cd-4020-a877-576647975e56",
      "text": "Publication of peer‑reviewed study reporting enlarged external occipital protuberances (EEOP) in young adults",
      "date": "2018-02-20 00:00:00"
    },
    {
      "id": "d0593d90-01d0-4ea8-ab77-4bc3ab40d85e",
      "text": "StatPearls / NCBI review and guidance summarising when activated charcoal is indicated for poisoning (clinical toxicology guidance update)",
      "date": "2023-04-26 00:00:00"
    },
    {
      "id": "78cf8df1-f528-484a-a227-ce2148453ea9",
      "text": "Major news coverage of charcoal consumer products (BBC story noting popularity and celebrity effect for charcoal toothpastes/products)",
      "date": "2019-05-10 00:00:00"
    },
    {
      "id": "7736b01d-9d52-4191-8649-3935b5d7e4c6",
      "text": "WHO interim guidance on mask use in the context of COVID‑19 (update)",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "42ebe7bd-d97d-4f3e-bca0-87867d9d6902",
      "text": "Publication of van Doremalen et al. laboratory study on aerosol and surface stability of SARS‑CoV‑2",
      "date": "2020-03-17 00:00:00"
    },
    {
      "id": "2cc4fbb5-7e91-4eda-9477-41f4891308b9",
      "text": "Open letter and media coverage by scientists arguing for recognition of airborne transmission (239 scientists)",
      "date": "2020-07-04 00:00:00"
    },
    {
      "id": "5d2cb133-194f-49c8-af45-598d4cbcec5a",
      "text": "FDA emergency use authorization of the Pfizer‑BioNTech COVID‑19 vaccine for children 5–11, sparking public debate about pediatric vaccination schedules",
      "date": "2021-10-29 00:00:00"
    },
    {
      "id": "cb8462d1-d7fa-4332-8219-7feef998001d",
      "text": "Peer‑reviewed immunology review concluding there is no evidence that recommended vaccines 'overload' or weaken infants' immune systems (literature on 'antigenic overload')",
      "date": "2004-04-24 00:00:00"
    },
    {
      "id": "7f66a7e6-69b0-4ed7-a76a-aba9aa79e5bc",
      "text": "U.S. officials publicly rejected or expressed serious concerns about Poland's proposal to transfer MiG-29s via a U.S. base, citing escalation and alliance complications.",
      "date": "2022-03-08 00:00:00"
    },
    {
      "id": "e3e465f6-cf05-42d8-a17d-575f69d2fefe",
      "text": "Polish government and analysts documented and warned about sustained Russian disinformation campaigns targeting Poland after the start of the war in Ukraine.",
      "date": "2022-05-06 00:00:00"
    },
    {
      "id": "0a63b17d-a0f7-4289-b7a2-009dcc402d58",
      "text": "Open-source documentation (Oryx) and media reports catalogued numerous photographed and video-documented losses of Ukrainian equipment (including Western-supplied systems) during 2022.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "c8cf1924-4a5f-46c3-a9c4-ca0488053763",
      "text": "30 November 2018: Ukraine announced a ban on entry for Russian men of military age (reported by multiple outlets).",
      "date": "2018-11-30 00:00:00"
    },
    {
      "id": "4b57f24f-9d8f-4e66-b607-5cbf5a7f73ee",
      "text": "June 2019: Russian president Vladimir Putin signed a decree simplifying the procedure for residents of Donetsk and Luhansk to obtain Russian passports (accelerated 'passportisation').",
      "date": "2019-06-24 00:00:00"
    },
    {
      "id": "21816fb2-338a-4b94-9ec9-1502305688e1",
      "text": "August 2014: Large-scale displacement from Donbas with thousands crossing into Russia during the summer 2014 fighting.",
      "date": "2014-08-01 00:00:00"
    },
    {
      "id": "5416a5bc-9aa0-4b41-ad0e-0c9d8e8a4c38",
      "text": "U.S. government purchase agreement announced earlier in July 2020 (Pfizer/BioNTech $1.95B deal for 100 million doses) linking Pfizer to federal vaccine procurement.",
      "date": "2020-07-22 00:00:00"
    },
    {
      "id": "1c33447f-9b46-467a-b7f4-d907de6a50a4",
      "text": "Pfizer and BioNTech press release announcing their vaccine candidate was >90% effective in interim Phase 3 analysis",
      "date": "2020-11-09 00:00:00"
    },
    {
      "id": "1fe462a1-82dd-4fab-bf7c-f7c9823fc4e0",
      "text": "Reporting on Pfizer's funding sources and relationship to Operation Warp Speed that highlighted nuance (e.g., Fortune/other Nov 9, 2020 pieces saying Pfizer did not take OWS R&D funding but had U.S. supply deals).",
      "date": "2020-11-09 00:00:00"
    },
    {
      "id": "4e10ed8d-4010-4c28-89a7-fa16335d2a33",
      "text": "Ukrainian Central Election Commission (CEC) formally listed electoral districts and polling stations in Donetsk and Luhansk where voting would not be organized for the 2019 presidential election.",
      "date": "2019-02-12 00:00:00"
    },
    {
      "id": "d9b8ccf2-fd23-4c83-8acb-d8ad5e5b68ee",
      "text": "Historical precedent of electoral disruption in eastern Ukraine (2014): pro-Russian militants previously occupied or disrupted polling stations and seized ballot materials in Donetsk and Luhansk during earlier elections.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "12cbac2e-c124-419b-bfba-8eb089e92750",
      "text": "Pro‑Russian protesters seized regional government buildings in eastern Ukraine",
      "date": "2014-03-03 00:00:00"
    },
    {
      "id": "43d05f96-9246-4049-9c56-c446ceea2a7d",
      "text": "Delivery of a $2 billion Russian credit to Ukraine was delayed",
      "date": "2014-02-19 00:00:00"
    },
    {
      "id": "dfb7f452-6f07-44e5-93fc-19766ddf8227",
      "text": "Unmarked (Russian) troops and seizures in Crimea disrupted Ukrainian military units",
      "date": "2014-02-27 00:00:00"
    },
    {
      "id": "585b62e4-af3f-4f88-a85a-202d5611bf92",
      "text": "Interim Ukrainian government formation delayed, creating administrative uncertainty",
      "date": "2014-02-25 00:00:00"
    },
    {
      "id": "06abf97f-1f34-46a7-858f-267e8104e7e5",
      "text": "Ukraine's currency (hryvnia) plunged after central bank policy change",
      "date": "2014-02-05 00:00:00"
    },
    {
      "id": "020eaf7c-6638-408a-a07f-be78f52769c1",
      "text": "U.S. COVID-19 vaccine reporting rules tied to Emergency Use Authorization: healthcare providers were required to report all serious adverse events and certain other events to VAERS (policy in effect since the COVID EUA rollout, December 2020 onwards).",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "d04d7a00-5557-4055-b7ab-a0c7706180e8",
      "text": "Public availability of raw VAERS datasets and third-party dashboards (VAERS data downloadable and publicly accessible since the system's creation).",
      "date": "None"
    },
    {
      "id": "cae9d058-4b9f-4631-8d47-bd0a5ebce50a",
      "text": "Japan's Ministry of Health, Labour and Welfare approved ARCT-154, the first commercial self-amplifying (saRNA) COVID-19 vaccine (CSL/Arcturus).",
      "date": "2023-11-28 00:00:00"
    },
    {
      "id": "da41dc75-fcc4-41ab-88dd-ddf7161e36b0",
      "text": "Japan paused and recalled some Moderna COVID-19 vaccine lots after discovery of foreign (stainless-steel/black) particles in vials at vaccination sites (investigation and voluntary recall reported).",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "8e0925f8-ca35-4b50-af54-c2a561cbd4f7",
      "text": "UN Human Rights Monitoring Mission report noting an inflow/presence of \"foreign fighters\" in eastern Ukraine",
      "date": "2015-08-24 00:00:00"
    },
    {
      "id": "7035f193-d0d8-4b29-9363-8b9997255920",
      "text": "Death of Isa Munayev, commander of the Dzhokhar Dudayev (Chechen) battalion fighting for Ukraine (killed near Debaltseve)",
      "date": "2015-02-01 00:00:00"
    },
    {
      "id": "dfcd5ada-9ea3-465b-ac6e-ad0cb35806d4",
      "text": "New York Times article: \"Islamic Battalions, Stocked With Chechens, Aid Ukraine in War With Rebels\"",
      "date": "2015-07-08 00:00:00"
    },
    {
      "id": "e159d079-6ebd-4da8-b6f3-264cf95c3164",
      "text": "CBC News coverage (Apr 2012) of University of Windsor research and a $157K grant for 'cancer‑killing dandelion tea'",
      "date": "2012-04-20 00:00:00"
    },
    {
      "id": "27779f6e-b1d1-4cb1-b2fd-22465de74412",
      "text": "2012 PLOS ONE study showing dandelion root extract induces apoptosis in leukemia (CMML) cell lines",
      "date": "2012-02-17 00:00:00"
    },
    {
      "id": "f6603684-e321-437b-beab-55794bdec1e6",
      "text": "Research on cognitive impairments in chronic tinnitus patients (e.g., 'The characteristics of cognitive impairment in subjective chronic tinnitus', PubMed 29541537, 2018)",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "50d18c7f-3a6a-42f9-924a-ddef9d67bc1f",
      "text": "Lancet Commission report 'Dementia prevention, intervention, and care' identifies hearing loss as a major modifiable dementia risk factor",
      "date": "2017-12-24 00:00:00"
    },
    {
      "id": "7b152dcf-fc08-4a62-8dbc-17dc3c6ac19a",
      "text": "Local reporting documented a sharp rise in COVID-19 hospitalizations in Jacksonville and UF Health Jacksonville reported 175 hospitalized with COVID-19 (July 26, 2021).",
      "date": "2021-07-26 00:00:00"
    },
    {
      "id": "8f37c27b-d364-44d6-b01e-ce0ee74d8907",
      "text": "Public Health England / UKHSA technical briefings (mid-2021) showing many COVID cases and deaths among vaccinated older adults that were widely shared without age‑adjustment context",
      "date": "2021-07-14 00:00:00"
    },
    {
      "id": "ffb5ffce-b389-4d5d-bc1f-35c187f1ae5f",
      "text": "Large case surges in highly vaccinated countries (example: Israel, summer 2021) that circulated widely on social media suggesting temporal link between vaccination campaigns and rising infections",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "e694a73b-cb53-4c33-9b40-f3f3dfcb771f",
      "text": "Early Omicron reporting (Dec 2021) showing large reduction in vaccine protection against infection",
      "date": "2021-12-16 00:00:00"
    },
    {
      "id": "61b6a234-6058-48af-9ace-0901a6a84064",
      "text": "2019 CDC shutdown of biosafety operations at Fort Detrick (US Army medical research lab) after safety inspection",
      "date": "2019-08-05 00:00:00"
    },
    {
      "id": "2a277377-d848-40da-9359-47a74c644917",
      "text": "President Biden orders U.S. intelligence agencies to 'redouble' investigation into COVID-19 origins",
      "date": "2021-05-26 00:00:00"
    },
    {
      "id": "2c11a22a-4451-4ea2-b25b-6f8260f7cbb3",
      "text": "Reports that California lawmakers planned to introduce legislation to end personal-belief vaccine exemptions in response to the outbreak.",
      "date": "2015-01-23 00:00:00"
    },
    {
      "id": "acb5312e-89e5-4784-9168-e6895d049d9c",
      "text": "CDC Health Alert Network (HAN) advisory announcing a U.S. multi-state measles outbreak linked to Disneyland theme parks.",
      "date": "2015-01-23 00:00:00"
    },
    {
      "id": "52b9bf68-c607-4c69-8549-54c0506b97d6",
      "text": "US Operation Atlantic Resolve deployed rotational armored units (tanks/Bradleys) into Eastern Europe (to reassure NATO)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "8b331ebe-6540-4df7-9b68-a56dab66f6e2",
      "text": "OSCE SMM reported observing unmarked convoys and multiple tanks operating in Donetsk/Donbas territory",
      "date": "2014-11-08 00:00:00"
    },
    {
      "id": "4f148573-3f7c-4b23-ab56-b786a94fe1ff",
      "text": "Reporting of foreign volunteers and irregular fighters in Donbas (documented by major outlets)",
      "date": "2014-09-01 00:00:00"
    },
    {
      "id": "f167a6f0-9e3f-45c6-b6d4-bb10c3231b5c",
      "text": "Russian and pro‑Kremlin media/public figures repeatedly alleged Western/NATO involvement (including claims of NATO personnel/equipment in Ukraine)",
      "date": "2014-11-12 00:00:00"
    },
    {
      "id": "ced5d570-760d-413b-8f21-396ef27792cb",
      "text": "The MV Rhosus delivered and was detained with 2,750 tonnes of ammonium nitrate in Beirut after an unscheduled stop.",
      "date": "2013-11-24 00:00:00"
    },
    {
      "id": "64be78f6-4a3d-4c4f-b406-88deb69e8d5c",
      "text": "Viral videos show Italians performing coordinated gestures (singing/dancing) on balconies during lockdown (mid‑March 2020)",
      "date": "2020-03-13 00:00:00"
    },
    {
      "id": "dc80216c-cbb5-43e5-bc1e-0876557372d8",
      "text": "IEA publishes 'Electricity Grids and Secure Energy Transitions' calling for major transmission build-out and doubling of power-system flexibility needs to 2030.",
      "date": "2023-10-17 00:00:00"
    },
    {
      "id": "5f9ee440-cbcd-4357-b3c6-47414dce7052",
      "text": "European Commission publishes the EU Offshore Renewable Energy Strategy recommending cross-border planning and consideration of a more 'meshed' offshore grid and hybrid projects.",
      "date": "2020-11-19 00:00:00"
    },
    {
      "id": "5ec49e9a-2136-40d6-b6ea-0e88683b1cad",
      "text": "U.S. DOE publishes 'Microgrid Overview' fact sheet describing microgrids as entities that can operate grid-connected or in island (isolated) mode.",
      "date": "2024-01-18 00:00:00"
    },
    {
      "id": "04cf0118-62e6-4b3e-8d62-c2c2f4182169",
      "text": "NREL publishes a 'Research Roadmap on Grid‑Forming Inverters' and related analyses explaining that high shares of inverter‑based resources require new inverter controls and grid‑forming capabilities for stability.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "e3189ef6-b119-49e3-afbc-0708491dd4dd",
      "text": "TenneT proposes a 6-GW North Sea 'hub' / wind power booster and publishes plans toward a meshed offshore transmission approach.",
      "date": "2023-10-29 00:00:00"
    },
    {
      "id": "18de34e3-72c0-4edc-9373-1b7213da3d0e",
      "text": "Russian authorities repeatedly detained Ukrainian civilian fishermen and ships in the Sea of Azov (reported detentions of Ukrainian fishing crews).",
      "date": "2017-02-24 00:00:00"
    },
    {
      "id": "c7e229b8-8c07-4814-a24f-77bed644174e",
      "text": "Russian troops and pro‑Russian forces seized multiple Ukrainian navy vessels and naval bases during the 2014 Crimea annexation (including the capture of three Ukrainian warships).",
      "date": "2014-03-21 00:00:00"
    },
    {
      "id": "018d2f1a-a9c0-4dfe-8791-55e182f640b3",
      "text": "Advisory Referendum Act (Wet raadgevend referendum) had recently entered into force (1 July 2015) enabling citizen-initiated national referendums",
      "date": "2015-07-01 00:00:00"
    },
    {
      "id": "794304a8-b4ab-4f2b-a488-53bcd4b14383",
      "text": "Prime Minister Mark Rutte calls the referendum 'disastrous' and says he is 'totally, totally, totally against referendums'",
      "date": "2016-06-13 00:00:00"
    },
    {
      "id": "cc36a9db-6077-4ec9-adbe-c04f3ba9a177",
      "text": "Large, highly visible arrival of Ukrainian refugees into Italy in March–April 2022 (Italian draft plan to take up to 175,000 and steadily rising refugee numbers reported).",
      "date": "2022-03-18 00:00:00"
    },
    {
      "id": "f4120b19-33c5-4df5-ae3f-cfcbe5523733",
      "text": "March 2017: The World Meteorological Organization added asperitas as a recognized cloud feature in the updated International Cloud Atlas.",
      "date": "2017-03-24 00:00:00"
    },
    {
      "id": "f0cf4498-cfb4-4250-916e-551d1f56027c",
      "text": "Longstanding practice of sending Ukrainian spent nuclear fuel to Russia for reprocessing (and return of reprocessing waste)",
      "date": "None"
    },
    {
      "id": "33174958-b90e-4fc4-842b-245976472f54",
      "text": "Holtec (project contractor) published confirmatory functional testing of ISF‑2 interim spent fuel storage at Chernobyl (technical milestone)",
      "date": "2019-05-06 00:00:00"
    },
    {
      "id": "49257e18-1694-46bd-8535-894c014ad982",
      "text": "Release of the IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "fc91703a-e115-4756-abf5-e385f67fcfa4",
      "text": "NOAA/NCEI global climate reporting for 2021 (annual analysis released Jan 2022) showing year-to-year variability and La Niña-linked cooling influence",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "4db0a61c-539f-47d1-aa41-d61c371d389f",
      "text": "Publication of Karl et al. (2015) and the 'hiatus' data-adjustment debate (NOAA/Science) that revised surface temperature trends",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "fb4d2e98-e1a5-47cd-9b89-d6594993ba1a",
      "text": "CDC FluView weekly surveillance report (Week 41, data through Oct 16, 2020) showing unusually low influenza activity and low percent-positivity in respiratory specimens",
      "date": "2020-10-16 00:00:00"
    },
    {
      "id": "309bed94-5394-402c-a7c9-3341fbf38902",
      "text": "Adoption of Ukraine's 'decommunization' laws in April 2015 and subsequent municipal actions to remove or rename Soviet-era symbols and monuments.",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "04fa843d-c467-42fc-a11b-e2b4e326fd6d",
      "text": "Widespread toppling and removal of Soviet-era monuments during and after Euromaidan (2013–2014) — high-profile removals of Lenin statues and related coverage created a recent precedent for 'monuments being taken down'.",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "48cb2831-5726-4672-89cc-9915cc22036b",
      "text": "Reports and imagery documenting heavy fighting, civilian deaths and damage in Hostomel and nearby areas during the Russian offensive (March–April 2022)",
      "date": "None"
    },
    {
      "id": "e1dc75f3-2554-453f-8935-20d9fe70c69a",
      "text": "Discovery and wide circulation of video and photo evidence showing dozens of dead civilians in Bucha (near Kyiv)",
      "date": "None"
    },
    {
      "id": "49c6df3a-a2fa-4f8d-9ca8-3afc1db555d4",
      "text": "Advocacy/analysis note and reports on voting rights of internally displaced persons (IDPs) in Ukraine noting ~1.4 million registered IDPs and barriers to their participation in local elections (reports circulated February 2019).",
      "date": "2019-02-14 00:00:00"
    },
    {
      "id": "b1456a7f-65ff-4e2b-8ece-58d52c4b4035",
      "text": "Central Election Commission (CEC) announced that presidential voting would not be organized in Crimea, Sevastopol and parts of Donetsk and Luhansk (list of districts where vote will not be held).",
      "date": "2019-02-13 00:00:00"
    },
    {
      "id": "f14ab467-fd64-4211-914b-af28c8a43039",
      "text": "Guides and reporting on practical difficulties for Ukrainians voting abroad ahead of the 2019 presidential vote (limited polling stations, complex registration procedures noted in Feb 2019 coverage).",
      "date": "2019-02-19 00:00:00"
    },
    {
      "id": "57a6ef75-13f9-4589-a649-16cd436bdf59",
      "text": "Poland announced it would stop new weapons transfers to Ukraine",
      "date": "2023-09-21 00:00:00"
    },
    {
      "id": "056d5d02-f776-4514-9547-3c9fe23ddfa3",
      "text": "Poland and Ukraine entered a bitter grain-dispute diplomatic row (restrictions on Ukrainian grain)",
      "date": "2023-09-21 00:00:00"
    },
    {
      "id": "3a2345a4-de53-4fe6-9211-ba1c526e0ff6",
      "text": "Hungary vetoed/blocked a major EU aid package for Ukraine at an EU summit",
      "date": "2023-12-13 00:00:00"
    },
    {
      "id": "a3447ac8-e37f-41ee-a185-6f2f2caabe42",
      "text": "Diplomatic expulsions and mutual espionage accusations between Hungary and Ukraine (spy scandal)",
      "date": "2025-05-09 00:00:00"
    },
    {
      "id": "24e3d945-c664-4acf-81f9-fa0c58e977fe",
      "text": "December 2021 reporting and market data (SPINS / Whole Foods coverage) documenting a rapid consumer boom in adaptogen supplements (ashwagandha, reishi, etc.).",
      "date": "2021-12-24 00:00:00"
    },
    {
      "id": "4f463dfc-a1b1-4a06-8341-3f8e5f3c168b",
      "text": "Publication of a 2021 peer-reviewed review summarizing preclinical anti‑cancer activity of curcumin but concluding clinical evidence is limited.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "7741a1fa-a410-43e0-9b0c-055949c8a4b0",
      "text": "FDA public enforcement and health‑fraud warning letters in 2019 targeting unapproved ozone medical claims and other alternative 'therapies'.",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "d1574709-ef45-4df4-9dd4-56dc36bcdc85",
      "text": "Publication and widespread citation of Mayo Clinic / NEJM-era randomized trials (1985) showing high‑dose vitamin C had no benefit in advanced cancer patients.",
      "date": "1985-04-24 00:00:00"
    },
    {
      "id": "44dca193-2030-46c0-8d83-19daee4d948f",
      "text": "Government legal actions and sanctions against Poroshenko and his circle in early 2022",
      "date": "2022-02-17 00:00:00"
    },
    {
      "id": "6204584f-fec5-4528-8eac-f71c21153c81",
      "text": "Poroshenko appears in combat role and publicly joins territorial defence units after Russia's full-scale invasion",
      "date": "2022-02-25 00:00:00"
    },
    {
      "id": "b9940263-75cd-473b-a824-3449476e51ae",
      "text": "Public statements by Crimean authorities (Sergei Aksyonov) saying Crimea would refuse Ukrainian electricity even if restored",
      "date": "2015-12-24 00:00:00"
    },
    {
      "id": "1aa9e6b8-41b1-47c4-921c-a435660b1572",
      "text": "Reporting in August 2021 that the UK government and advisers were preparing/considering booster programmes (coverage of policy options and possible mass booster rollouts for older adults and vulnerable groups).",
      "date": "2021-08-19 00:00:00"
    },
    {
      "id": "efe9acbf-5c68-4535-b952-70577ca50625",
      "text": "WHO publicly called for a moratorium on widespread booster campaigns on August 4, 2021, arguing doses should be prioritized for unvaccinated populations globally.",
      "date": "2021-08-04 00:00:00"
    },
    {
      "id": "5f38c603-2dcd-4665-8bef-e094caef7a8e",
      "text": "Israel announced it would offer a third (booster) COVID-19 dose to people aged over 60, becoming one of the first countries to roll out a booster programme.",
      "date": "2021-07-30 00:00:00"
    },
    {
      "id": "5a6d25c0-72b5-47d0-9a25-00a946e8ebce",
      "text": "CDC published an MMWR (July 2021) on a large July outbreak in Barnstable County, Massachusetts, in which a high proportion of identified cases were among fully vaccinated people (Delta-driven breakthrough infections).",
      "date": "2021-07-30 00:00:00"
    },
    {
      "id": "a137848e-0579-44c3-a4a8-77c46f0ee531",
      "text": "Pfizer/BioNTech published initial data and public statements in July 2021 highlighting a planned booster program and that a third dose substantially increased neutralizing antibody titers.",
      "date": "2021-07-08 00:00:00"
    },
    {
      "id": "9b175709-e0ba-4408-aa1c-dfd76310493a",
      "text": "Reports and satellite data show reduced air pollution over northern Italy after lockdowns",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "efb4f986-fd6a-468b-aa17-c623424d1033",
      "text": "Satellite images show sharp drops in NO2 over China during lockdowns",
      "date": "2020-02-24 00:00:00"
    },
    {
      "id": "71e27d8d-0a62-4065-b6f0-754d4b25e80b",
      "text": "Climate strikes and mass mobilizations moved online or were paused (Fridays for Future/Greta Thunberg urged digital action)",
      "date": "2020-03-13 00:00:00"
    },
    {
      "id": "6ef174a1-4126-4bc3-9713-f1aeaf969ec9",
      "text": "WHO declares COVID-19 a pandemic",
      "date": "2020-03-11 00:00:00"
    },
    {
      "id": "8b08fdbe-6074-461f-9420-8973568fec69",
      "text": "CDC and US advisory panels publishing VAERS-based myocarditis reports and guidance (MMWR/ACIP reviews in June 2021) acknowledging myocarditis reports after mRNA vaccination while concluding benefits outweigh risks.",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "e06a7277-5f24-48fb-9c78-13c76be81e98",
      "text": "IPCC Fifth Assessment Report (AR5, WG1) release and SPM (2013) noting short-term variability and model/observation differences",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "099d05fd-55f3-40ef-beaa-1a522d6addf7",
      "text": "NOAA/Karl et al. Science paper and NOAA press release revising observational records (June 2015)",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "70d2a4d5-b786-4e49-af2c-e2da94a512f9",
      "text": "Testimony by John R. Christy to U.S. House committee (December 11, 2013) arguing climate models exaggerate warming",
      "date": "2013-12-24 00:00:00"
    },
    {
      "id": "e350c53e-e396-41e1-817f-9304ad844ea9",
      "text": "Germany's federal and state health ministers decided to restrict routine use of the AstraZeneca vaccine to people over 60 following blood‑clot concerns.",
      "date": "2021-03-30 00:00:00"
    },
    {
      "id": "883a896b-e817-45fc-b9ee-371155a7d074",
      "text": "Japan recalled and halted distribution of some Moderna COVID-19 vaccine doses after contamination/foreign particle reports were detected in early August 2021.",
      "date": "2021-08-05 00:00:00"
    },
    {
      "id": "3e432faf-9460-4d1b-a841-fbe9839fbcbd",
      "text": "Public safety reports and media coverage in spring 2021 highlighted suspected deaths and serious adverse events reported after COVID-19 vaccination in Germany (data summarized by the Paul‑Ehrlich‑Institut and discussed in studies/media).",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "6995508b-5d89-4444-9304-cba0e41fae35",
      "text": "Duda visited the Bykivnia National Historic Memorial / Polish war cemetery near Kyiv during the October 2020 trip",
      "date": "2020-10-11 00:00:00"
    },
    {
      "id": "1f26bf27-13ba-421b-9231-cf226ab52ad1",
      "text": "Andrzej Duda's previous public statements and commemorations framing the Volhynia killings as ethnic cleansing/genocide (past ceremonies and remarks)",
      "date": "2018-07-11 00:00:00"
    },
    {
      "id": "90bfad8f-ac37-4d23-981d-a31dffe2cb8c",
      "text": "Duda and Zelensky signed a joint declaration and attended economic events in Odesa during the October 2020 visit",
      "date": "2020-10-12 00:00:00"
    },
    {
      "id": "c3b90585-ea0d-4a8a-8dd8-5970b472f13f",
      "text": "UN Secretary-General Ban Ki-moon publicly expresses concern about the Crimea referendum",
      "date": "2014-03-17 00:00:00"
    },
    {
      "id": "1c43e30e-6ec5-4b7b-8717-cc2a2a107d40",
      "text": "CDC and ACIP public reports (June 2021) documenting increased reports of myocarditis/pericarditis after mRNA COVID‑19 vaccination in younger males and recommending continued monitoring.",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "4b795e2e-7eb3-45ee-ab80-4bdd2e3d9779",
      "text": "Contamination and recall incidents in Japan involving Moderna vaccine vials (stainless‑steel/black particles) reported widely in media.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "4b9f26b8-447d-4e58-930b-ba76b8681145",
      "text": "EMA publication of the Comirnaty (BNT162b2) public assessment report including preclinical biodistribution and safety data.",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "f6f240d1-76eb-49ce-9de1-39ad685f1451",
      "text": "IPCC Fifth Assessment (AR5) and associated carbon‑cycle graphics made public (figures showing large natural CO2 fluxes compared to anthropogenic fluxes)",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "6a6acfc5-0af5-46ce-857a-e2904f2b9c4b",
      "text": "Russian MP Vladimir Zhirinovsky sent letters proposing the division of Ukraine and suggested neighboring countries (including Poland) could take western regions.",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "4cd90b44-31f1-4a01-909a-4d4270ab2c65",
      "text": "Polish officials publicly denied any territorial claims and reiterated support for Ukraine (coverage: 'Lviv is Ukraine'—Warsaw assures it has no territorial claims).",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "5d67f516-3b5f-4d8e-89da-3d90721cd993",
      "text": "American College of Pediatricians (ACPeds) January 2016 statement raising concerns about polysorbate 80 in the HPV vaccine",
      "date": "2016-01-24 00:00:00"
    },
    {
      "id": "ea09b041-c617-47d9-a76d-d81079f36fd8",
      "text": "Manufacturer label for Amphastar/Phytonadione injectable lists excipients (e.g., polysorbate 80, propylene glycol) in some formulations",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "9644246f-94cc-4458-8e14-564eb1d861e6",
      "text": "ACRIM–PMOD Total Solar Irradiance (TSI) composite controversy and Fröhlich PMOD revision (mid-2000s)",
      "date": "2006-04-24 00:00:00"
    },
    {
      "id": "3c0b8def-ab2d-45ba-94a6-da76f2b7dd29",
      "text": "Scafetta papers arguing a large solar contribution to recent warming (e.g., 2009 empirical analyses)",
      "date": "2009-04-24 00:00:00"
    },
    {
      "id": "d30e401a-ef55-4f7f-9712-cd9cf7cb7d88",
      "text": "Release of the NIPCC/Heartland 'Nature, Not Human Activity, Rules the Climate' summary (NIPCC)",
      "date": "2008-04-24 00:00:00"
    },
    {
      "id": "ac80f77a-57a3-47c8-922e-ed3cd647d0d5",
      "text": "Publication of Soon & Baliunas 'Proxy climatic and environmental changes of the past 1000 years' (Climate Research)",
      "date": "2003-07-24 00:00:00"
    },
    {
      "id": "671c1c28-dc15-477f-9030-30d9ad77a14e",
      "text": "Ukraine enacted gas-market reforms in 2015 (Gas Market Law, IMF-backed liberalisation) moving to market-based pricing (law effective 1 Oct 2015).",
      "date": "2015-10-24 00:00:00"
    },
    {
      "id": "1f6fc9c1-12a1-4b1b-921e-9b373c2ef256",
      "text": "Naftogaz disclosed it procured all imported gas in 2016 from 15 European suppliers and published average Q1 2016 import price (~$198 per 1,000 m3).",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "28952f14-1d58-4bc1-9a8e-f41ecbb4a101",
      "text": "Reporting showed Poroshenko's approval ratings and political standing were weak in early April 2016 (analysis reported 7 April 2016).",
      "date": "2016-04-07 00:00:00"
    },
    {
      "id": "edab6fc1-799c-47f3-8cab-19addfc4e3e3",
      "text": "Russian and other foreign/state-aligned media amplified the Dutch result as evidence of Western unreliability on Ukraine (analysis and commentary in days after the vote, e.g. Financial Times 8 April 2016).",
      "date": "2016-04-08 00:00:00"
    },
    {
      "id": "1972c4cb-49be-4b10-a2ef-e3f2114602b8",
      "text": "Ukraine experienced visible political instability in early 2016 (Prime Minister Arseniy Yatsenyuk resigned/was asked to resign and government survived no-confidence votes in February 2016).",
      "date": "2016-02-16 00:00:00"
    },
    {
      "id": "d0c21fa2-f9c2-40f1-a260-4a254df804f4",
      "text": "Dutch advisory referendum rejected the EU–Ukraine Association Agreement (61% against) on 6 April 2016.",
      "date": "2016-04-06 00:00:00"
    },
    {
      "id": "f1960d27-fd97-4804-b057-6f7e9205cd00",
      "text": "U.S. Secretary of State discussions tying sanctions relief and diplomatic pressure to implementation of Minsk political measures (Kerry remarks, 2015)",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "729b965e-10e0-4396-a476-538b41bef3e6",
      "text": "U.S. leaders publicly ruled out direct military intervention in Ukraine (statements from 2014)",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "fd6c18d0-24fb-46be-a977-14bd1261a91c",
      "text": "BMJ commentary highlighting that pregnant women were routinely excluded from COVID‑19 vaccine trials (and calling for their inclusion).",
      "date": "2020-08-25 00:00:00"
    },
    {
      "id": "9a290797-749c-42ed-a67d-75d66083b144",
      "text": "Pfizer/BioNTech press release (Nov 9, 2020) announcing interim Phase 3 efficacy results for their mRNA vaccine encoding the SARS‑CoV‑2 spike protein.",
      "date": "2020-11-09 00:00:00"
    },
    {
      "id": "f339002b-ff86-4405-a3c8-36d40f57cb28",
      "text": "UK government / ONS releases reporting ~945,000 people self‑reporting long COVID in July/August 2021 (publication 5 August 2021).",
      "date": "2021-08-05 00:00:00"
    },
    {
      "id": "5bbf7340-f31b-4450-acae-7485768ed63b",
      "text": "Early cohort studies (e.g., Lancet 6‑month outcomes, Jan 2021) reported wide-ranging, multi‑system persistent symptoms with unclear mechanisms.",
      "date": "2021-01-08 00:00:00"
    },
    {
      "id": "8626ca71-1e52-4c5f-8f17-9dab6c266608",
      "text": "WHO published a clinical case definition of post‑COVID‑19 condition (long COVID) using Delphi consensus, noting heterogeneous symptoms and lack of a single diagnostic biomarker.",
      "date": "2021-10-06 00:00:00"
    },
    {
      "id": "7fd9c91f-c316-400d-85b4-090ac628f432",
      "text": "OSCE Special Monitoring Mission reports and situation updates documenting mines, UXO and restricted access along roads and rail in Donbas (2015 SMM reporting).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "88bcba6f-3141-4a39-87f2-94e0f38fa00a",
      "text": "Mine Action Review and national mine‑action reporting showing large-scale anti‑personnel/anti‑vehicle mine contamination in eastern Ukraine (Clearing the Mines report, 2017).",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "6a957da1-406d-4b72-bcbd-6596131f5345",
      "text": "2014 Russian 'humanitarian' convoy and other cross‑border convoys/shipments that entered eastern Ukraine without Kyiv's full control.",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "4efd2e64-a23b-485e-a038-428d2989b63b",
      "text": "Analyses of Russian information operations documenting rapid, repetitive amplification tactics (the 'firehose of falsehood' model).",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "ea149bda-238a-4057-acdf-0cd761b1b278",
      "text": "Politico reporting (April 29, 2025) that several major European leaders declined Ukrainian President Zelensky's invitation to Kyiv on May 9.",
      "date": "2025-04-29 00:00:00"
    },
    {
      "id": "ae10eee8-7eb6-4dd8-9f0f-947491a632cc",
      "text": "Berliner Zeitung opinion column titled 'Herr Merz, zeigen Sie Mut – fliegen Sie am 9. Mai zu Putin nach Moskau!' urging Merz to fly to Moscow for Victory Day (op-ed).",
      "date": "2025-05-08 00:00:00"
    },
    {
      "id": "07681209-6c18-43df-bb34-a99640acf3fe",
      "text": "Kremlin announcement (May 6, 2025) that 29 foreign leaders had been invited / would attend Moscow's Victory Day parade.",
      "date": "2025-05-06 00:00:00"
    },
    {
      "id": "7145843c-da9a-4ce0-adb6-08bb4bf5900e",
      "text": "Reuters reporting (Feb 20, 2025) that Friedrich Merz had been targeted by a coordinated pro‑Russian disinformation network during the German election period.",
      "date": "2025-02-20 00:00:00"
    },
    {
      "id": "48f96080-2ff8-4413-bc68-8d45573e0ebc",
      "text": "Official public-health recommendations for widespread mask use (CDC guidance published April 3, 2020).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "3da6910b-ebe5-4265-97f9-9acc53fc146d",
      "text": "High-profile news coverage of medical oxygen shortages during the COVID-19 crisis (notably India, April 2021).",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "4af56b7a-2b18-4614-94db-f8baaa510c21",
      "text": "2010 Ukrainian law under President Yanukovych formalized a non‑aligned/neutral foreign policy position.",
      "date": "2010-07-24 00:00:00"
    },
    {
      "id": "9a68762b-1125-44bc-9ce8-f0066c271623",
      "text": "Key NATO allies (notably Germany and France) opposed offering a Membership Action Plan for Ukraine at the 2008 Bucharest summit.",
      "date": "2008-04-24 00:00:00"
    },
    {
      "id": "d8249f1a-5fe7-4e68-83d4-bdb52e664065",
      "text": "Earlier (2017) Mawson pilot study reporting similar vaccinated vs unvaccinated differences",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "848bee8c-b8e4-4f15-b80e-8fe019b2f406",
      "text": "CDC and FDA investigation and public reporting of myocarditis/pericarditis cases after mRNA vaccination",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "a5560f22-1608-4dc4-b5e9-cab6fa9a2dc0",
      "text": "Japan suspends and inspects Moderna batches after discovery of foreign (stainless-steel/black) particles in vials",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "85aff665-3933-40c8-8e0c-8ff42c619c23",
      "text": "NASA press release: 'Satellite Shows High Productivity from U.S. Corn Belt' (Goddard/JPL coverage)",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "c58754c0-7dd2-4b01-acbc-26a6b8b444fd",
      "text": "Publication of Guanter et al. (PNAS) 2014 paper showing space‑based chlorophyll fluorescence detects very high peak photosynthetic activity in the U.S. Corn Belt",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "d1fe315e-4c15-48ad-8d28-30a44de19d7f",
      "text": "U.S. and international tightening of vehicle tailpipe standards and multipollutant rules (March 2024 announcements and implementation plans)",
      "date": "2024-03-24 00:00:00"
    },
    {
      "id": "ba15b1b5-c381-44f2-8797-a55499eeb225",
      "text": "WHO updates Global Air Quality Guidelines highlighting health risks from PM2.5, NO2 and other pollutants",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "b4c5dcd8-e49f-402f-8388-945f21eb7598",
      "text": "Investigations (2023) and NGO press releases alleging hundreds of thousands of vehicles still use defeat devices or emit far more pollution in real-world driving than tests indicate",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "920ad18c-187e-4ebb-a482-e5b78de11c13",
      "text": "2023 systematic reviews and studies linking long-term traffic-related air pollution to higher dementia and cognitive decline risks",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "51a3f058-2f29-41f8-b540-5710b0e086b4",
      "text": "Japan finds black/foreign particles in Moderna vaccine vials; batches put on hold",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "d499ec0e-dd4f-4f89-9447-aa1acdbacf68",
      "text": "Japan suspends use and recalls batches of Moderna COVID-19 vaccine after detection of black/foreign particles in vials (multiple reports in early September 2021).",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "8f5c4c1d-7b1a-4349-94b7-5266cd637e54",
      "text": "UK Health Security Agency Technical Briefing (31 Dec 2021) and contemporaneous studies reporting reduced vaccine effectiveness against symptomatic infection with Omicron and partial restoration after boosters.",
      "date": "2021-12-31 00:00:00"
    },
    {
      "id": "9a17ae4b-8609-4a0a-bf32-9f7f03f3c630",
      "text": "Publication of Israeli retrospective study (Gazit et al.) reporting previously infected people had substantially lower risk of Delta reinfection than vaccinated, often cited as \"natural immunity 13 times\" stronger.",
      "date": "2021-08-25 00:00:00"
    },
    {
      "id": "1d831c31-4014-4bf2-96b8-24fc74385832",
      "text": "CDC / ACIP acknowledgement and published review of myocarditis/pericarditis cases following mRNA COVID-19 vaccination (summarized in MMWR).",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "a3704883-02a5-429f-ab67-0b072f6a01b7",
      "text": "Zelensky's high-profile visit to Washington and his address to the U.S. Congress on 21 December 2022, in which he sought continued Western political and military support.",
      "date": "2022-12-21 00:00:00"
    },
    {
      "id": "3a76259e-a1ef-4eb7-9ae8-cfd3f4fcc6f3",
      "text": "President Zelensky presented a diplomatic \"10-point peace formula\" to world leaders at the G20 summit (Bali) on 15 November 2022, emphasising diplomatic channels and international guarantees as part of a peace framework.",
      "date": "2022-11-15 00:00:00"
    },
    {
      "id": "1de97582-9f71-4971-ba7d-d8f87885f543",
      "text": "Cabinet of Ministers Resolution No. 318 — allows territorial recruitment centers to serve summons regardless of registration",
      "date": "2023-07-04 00:00:00"
    },
    {
      "id": "a26d82c6-5a58-4bc7-a110-3dcb3a82fc08",
      "text": "Media coverage that Ukraine was urgently drafting reinforcements for a spring offensive",
      "date": "2023-10-04 00:00:00"
    },
    {
      "id": "54354ec4-f53b-4fc6-ac36-595bbd78d95d",
      "text": "Legal regime of martial law (authorises requisition of property for public needs)",
      "date": "2022-03-03 00:00:00"
    },
    {
      "id": "8c8bf809-7919-42f2-a350-25605cb083b1",
      "text": "Official and watchdog reporting noted prior government measures and decisions restricting visible Muslim dress in sporting contexts (the 2023/2024 debate and a government decision referenced in the 2023 International Religious Freedom report regarding hijab and athletes at Paris 2024).",
      "date": "2024-05-24 00:00:00"
    },
    {
      "id": "3793e03c-452d-447e-b83d-c0cc8f5b89f7",
      "text": "French authorities announced heightened security and a dedicated police escort for the 2024 Olympic torch relay, noting specific selection and protection measures.",
      "date": "2024-01-22 00:00:00"
    },
    {
      "id": "c297fcb9-e09b-4143-822c-7e1d023e3454",
      "text": "Longstanding French laïcité law and past controversies (2004 ban on conspicuous religious symbols in public schools) and continuing national debates about secularism and visible religious signs.",
      "date": "2004-03-24 00:00:00"
    },
    {
      "id": "27b9463c-05b7-4f0f-9497-2876314c5a04",
      "text": "Annual Environmental Working Group 'Dirty Dozen' coverage (media reporting on pesticide residues in produce, e.g., CNN coverage of 2023 list).",
      "date": "2023-03-15 00:00:00"
    },
    {
      "id": "e5b05f6c-bc32-4482-bb81-53d40b39c6da",
      "text": "Scientific reviews and peer‑reviewed articles showing plant‑derived bioactive compounds can modulate immune responses (scholarly reviews on medicinal plants and immunomodulation, e.g., PMC review).",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "8bfe5c6e-d1d4-4b6f-b140-776c1fa1d289",
      "text": "World Health Organization declared the novel coronavirus outbreak a Public Health Emergency of International Concern (PHEIC).",
      "date": "2020-01-30 00:00:00"
    },
    {
      "id": "ec8c5f4d-a867-484e-80ac-6c81a9283a59",
      "text": "Public political messaging from the U.S. president and other high‑profile figures asserting the outbreak was 'under control' (e.g., Feb 26, 2020), amid increasing partisan debate.",
      "date": "2020-02-26 00:00:00"
    },
    {
      "id": "72bc7424-651a-4c9d-9be9-ad3292abcb3c",
      "text": "EU guidelines on handling Schengen visa applications from residents of Crimea",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "434bf18b-493d-4770-9c92-1fe63ecadd04",
      "text": "EU travel bans and asset freezes on individuals linked to the annexation of Crimea",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "4fee8636-34b2-4cc0-ba43-397c53506220",
      "text": "Published scientific and regulatory reports from 2021 documented rare cases of facial paralysis (Bell's palsy) reported after COVID‑19 vaccination.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "f0412d5b-93cf-42bc-8fc5-f98147a51f9e",
      "text": "WHO publication of regulatory considerations for mRNA vaccines noting evolving guidance (post‑2020 development)",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "ac85ad4b-cc9f-4f44-beb5-ea48d8a52c1a",
      "text": "Japan suspension/recall of several Moderna COVID‑19 vaccine lots after foreign particles (stainless‑steel) were found",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "df930dd9-6b0b-4827-afe1-5894953e01bd",
      "text": "Kerch Strait incident: Russian forces seized three Ukrainian navy vessels and detained 24 sailors.",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "f0a85fe6-b900-4e90-8e66-572bdecff90a",
      "text": "Ukraine imposed bans and broad restrictions on major Russian websites, social networks and media.",
      "date": "2017-05-24 00:00:00"
    },
    {
      "id": "47a448fb-b4a0-46e6-991d-57294a9fee24",
      "text": "Volodymyr Zelensky elected President of Ukraine in a landslide (defeating incumbent Petro Poroshenko).",
      "date": "2019-04-21 00:00:00"
    },
    {
      "id": "7164afa4-2a31-4d20-b9a6-e502eff8a2fb",
      "text": "Ecumenical Patriarchate granted autocephaly to the Orthodox Church of Ukraine.",
      "date": "2019-01-05 00:00:00"
    },
    {
      "id": "4f3686e5-d765-4276-9e88-28dad9622072",
      "text": "Ukraine deepened ties with the EU by signing/implementing the EU–Ukraine Association Agreement after 2014 (formal post‑Euromaidan pivot toward the EU).",
      "date": "2014-03-21 00:00:00"
    },
    {
      "id": "8cd87dbf-abf3-458f-830b-3e2098fc7257",
      "text": "Wuhan authorities report a cluster of 'pneumonia of unknown cause' linked to a seafood market (Huanan) and notify WHO",
      "date": "2019-12-31 00:00:00"
    },
    {
      "id": "be6c17e9-3126-4a99-b1ca-12ba3fb536fe",
      "text": "U.S. CDC establishes an Incident Management Structure and begins active monitoring of the outbreak",
      "date": "2020-01-07 00:00:00"
    },
    {
      "id": "6fdc860b-5d9d-42dc-b86d-6db1f215ec58",
      "text": "Wuhan Municipal Health Commission statement saying there was 'no obvious evidence' of human-to-human transmission",
      "date": "2020-01-03 00:00:00"
    },
    {
      "id": "63dc2a08-412c-4d37-aca8-5ea865e1119a",
      "text": "OSCE/Representative condemns killing of journalist Oles Buzina in Kyiv (16 April 2015)",
      "date": "2015-04-16 00:00:00"
    },
    {
      "id": "00abef23-136a-4f82-b966-5af27dd83e4e",
      "text": "Human Rights Watch: 'Ukraine: Rebel Forces Detain, Torture Civilians' (reporting on abuses in 2014)",
      "date": "2014-08-28 00:00:00"
    },
    {
      "id": "08cafcf3-2032-4f80-b02a-ba109f879f0f",
      "text": "IAEA Director General Rafael Mariano Grossi confirmed 'physical impact' from drone strikes at the Zaporizhzhia Nuclear Power Plant and called the incident 'serious', noting hits on reactor-related structures.",
      "date": "2024-04-07 00:00:00"
    },
    {
      "id": "87c66622-6253-4bb6-bc16-c751d87a2c32",
      "text": "Reuters and other outlets reported that a Ukrainian drone crashed near the Zaporizhzhia nuclear plant in early April 2023 (reported 5 April 2023 by Russian media), indicating prior drone activity in the plant vicinity.",
      "date": "2023-04-05 00:00:00"
    },
    {
      "id": "ade5df5c-bee8-45e8-a236-f3de837262e5",
      "text": "IAEA and Reuters reporting documented earlier damage to off-site power infrastructure and backup power lines near Zaporizhzhia (notably on 7 September 2022), which affected the plant's power connections.",
      "date": "2022-09-07 00:00:00"
    },
    {
      "id": "1d8c5c78-ea5d-491b-aaeb-1e9eb3d23fe6",
      "text": "Reuters special report (Oct 2014) documenting flaws and gaps in Ukraine's investigations into the Maidan shootings",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "d7049be6-afc0-4f30-b738-0644dd7cfd9d",
      "text": "Deaths of Serhiy Nigoyan and Mikhail Zhiznevsky on Hrushevskoho Street during Euromaidan (initial chaotic reporting)",
      "date": "2014-01-22 00:00:00"
    },
    {
      "id": "7c9ba322-a838-4167-bcd3-92788ba88530",
      "text": "Academic and analytical publications debating shooter locations and responsibility for the 'snipers' massacre (analysis circulated online in 2014)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "81607614-7e18-493b-80e8-1de64c0a754c",
      "text": "Lancet Planetary Health commentary 'COVID‑19, wet markets, and planetary health' highlighting zoonotic risk at live‑animal markets",
      "date": "2020-06-24 00:00:00"
    },
    {
      "id": "ff6e86bf-c27b-43f3-81c9-562060321b74",
      "text": "Consumer watchdog reporting and class-action lawsuits against alkaline bottled-water marketing (coverage of multiple 2017–2018 suits)",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "9e8e0f65-b1dc-463d-b3b2-8da8207caf71",
      "text": "Scientific/dental research highlighting that some bottled beverages (including waters) have low pH and can be erosive to teeth (JADA/published research)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "8c67b977-c7a3-46a1-b02e-bcc7e336a6e5",
      "text": "Axios reporting (Aug 18, 2025) that White House officials asked Ukrainian counterparts whether Zelensky would wear a suit for his Aug 18 meeting with President Trump.",
      "date": "2025-08-18 00:00:00"
    },
    {
      "id": "353854f8-f85b-4d64-b740-e832c88a249a",
      "text": "Publication of Northwestern-led JCI study (April 27, 2023) showing unresolving ventilator-associated secondary pneumonia was linked to mortality in severe pneumonia including COVID-19.",
      "date": "2023-04-27 00:00:00"
    },
    {
      "id": "8f013e9d-8c5a-4353-8c8d-a79d4122b7e3",
      "text": "Pandora Papers disclosure linking Zelensky and associates to offshore companies",
      "date": "2021-10-03 00:00:00"
    },
    {
      "id": "ea97d934-450c-42f9-ba96-faa10aae7eb7",
      "text": "News reporting of French aid totals to Ukraine (official French figures circulated)",
      "date": "2024-03-03 00:00:00"
    },
    {
      "id": "9ed42510-3de7-453e-b41f-dbb975483b27",
      "text": "Public statements by Russian officials and the State Duma in Feb–Mar 2022 pushing narratives that Zelensky had 'refused' Minsk or was open to concessions, and urging Russia to legitimise breakaway regions",
      "date": "2022-02-18 00:00:00"
    },
    {
      "id": "675bdb85-f697-400f-8c7f-ed638f176b42",
      "text": "Zelensky's March 8, 2022 address to the UK Parliament / House of Commons in which he appealed for stronger Western action (including implied criticism of slow/no‑fly‑zone decisions)",
      "date": "2022-03-08 00:00:00"
    },
    {
      "id": "974fb635-cfd1-4b4c-8f0e-5fc7a4dd25b3",
      "text": "Russian recognition of the self‑proclaimed Donetsk and Luhansk People's Republics (DPR/LPR) and related escalatory diplomacy in late February 2022",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "b6dce954-c6ce-479b-8ca4-eccecbf931a2",
      "text": "U.S. FDA issues consumer warning against using veterinary ivermectin to treat or prevent COVID‑19 (consumer update)",
      "date": "2021-04-08 00:00:00"
    },
    {
      "id": "4bd27717-a688-4f9f-b97e-50fc5fdbd956",
      "text": "Pierre Kory testimony to U.S. Senate Homeland Security committee advocating ivermectin as an 'early treatment' (video + written testimony)",
      "date": "2020-12-08 00:00:00"
    },
    {
      "id": "e629fd6e-2664-4427-806f-f053affa3ea2",
      "text": "WHO identified vaccine hesitancy as a top-10 global health threat (2019) and warned about misinformation undermining vaccination programs",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "281fac33-7327-4d27-9270-fa396b74f594",
      "text": "Gunmen attacked polio vaccination teams (and their police escorts) in the region, including a December 2019 attack in Pakistan that killed police escorting vaccinators",
      "date": "2019-12-16 00:00:00"
    },
    {
      "id": "4bb77a37-80cf-4bc6-b14e-c32ddaed77ab",
      "text": "Several European countries temporarily suspended use of the AstraZeneca COVID-19 vaccine over reports of rare blood clots",
      "date": "2021-03-11 00:00:00"
    },
    {
      "id": "81a32455-c62a-4641-9d18-34a0807e49af",
      "text": "Multiple incidents of healthcare workers being spat at, harassed or attacked in India during the early COVID-19 pandemic",
      "date": "2020-04-02 00:00:00"
    },
    {
      "id": "9f1162d3-4ee2-45b1-a94b-ea7e6ed8a86e",
      "text": "Hungary and other neighbouring states publicly protested Ukraine's education/language measures and Hungary blocked NATO-Ukraine commission meetings in protest (April 2018).",
      "date": "2018-04-23 00:00:00"
    },
    {
      "id": "1ef7e7ad-9c74-469e-b411-3852cc693702",
      "text": "Nationwide implementation phase began for the education reform shifting instruction toward Ukrainian (mass implementation from 1 September 2018).",
      "date": "2018-09-24 00:00:00"
    },
    {
      "id": "5ff7751a-3797-475b-ab31-608a4dc57d3b",
      "text": "Verkhovna Rada adopts the Law 'On ensuring the functioning of Ukrainian as the state language' strengthening Ukrainian's role in public life.",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "6e3b4786-415f-41fb-a8fd-11b0bfc99338",
      "text": "Council of Europe's Venice Commission issues an opinion scrutinizing the 2019 language law (plenary opinion published December 2019).",
      "date": "2019-12-24 00:00:00"
    },
    {
      "id": "70c094cd-4b0c-4efe-b783-c1d86fbd71a9",
      "text": "Strong 2015–2016 El Niño and record global temperatures (reported in early 2017)",
      "date": "None"
    },
    {
      "id": "921da37f-25ef-46f2-9bbb-85d9c79411b9",
      "text": "Hurricane Milton made landfall in Florida and produced a real outbreak of tornadoes on Oct 9, 2024, causing widespread damage and intense media attention.",
      "date": "2024-10-09 00:00:00"
    },
    {
      "id": "1509ac98-4f23-4822-828c-092344605aa7",
      "text": "Deputy speaker Andrey Kozenko publicly claimed about 120,000 Ukrainians had visited Crimea, representing about 10% of the peninsula's tourists.",
      "date": "2016-06-24 00:00:00"
    },
    {
      "id": "59a4e5cb-be6d-4294-8ad4-9b78c05f450d",
      "text": "RIA Novosti published a report quoting Crimean officials that border crossings had to increase personnel because of a 'flood of vacationers from Ukraine'.",
      "date": "2016-06-24 00:00:00"
    },
    {
      "id": "e82b7ca8-3c7a-4a8a-88a6-bdbc535b0a1d",
      "text": "Boryspil International Airport workers staged strikes and picket lines over dismissals in early March 2015.",
      "date": "2015-03-13 00:00:00"
    },
    {
      "id": "6452efc0-72d1-45b6-99ce-9f5ad68a2f87",
      "text": "Recent intense fighting over airports (e.g., Donetsk airport battle in Jan 2015) made 'airport' a charged and symbolic setting in Ukrainian public discourse.",
      "date": "2015-01-22 00:00:00"
    },
    {
      "id": "1d7c8c65-fed9-4af9-b8a7-583efe0c156a",
      "text": "On-camera exchange at Boryspil: Poroshenko told protesting workers 'Don't raise your voice at me, or else you'll quickly be taken out,' which some outlets portrayed as a threat of arrest.",
      "date": "2015-03-19 00:00:00"
    },
    {
      "id": "eb18cff0-382d-421f-a524-e99822ad547e",
      "text": "United Nations senior officials (Secretary‑General and OHCHR) publicly called for an independent investigation into the civilian killings seen in Bucha.",
      "date": "2022-04-04 00:00:00"
    },
    {
      "id": "a821f2f7-8a95-48e1-8289-86096d5c2221",
      "text": "Russia announced it would ask the U.N. Security Council to meet over what Moscow called 'provocations' in Bucha and denied responsibility, urging investigation of alleged staging.",
      "date": "2022-04-04 00:00:00"
    },
    {
      "id": "317b32c6-c05b-44d3-8cad-09ffa5710de3",
      "text": "International media published graphic on‑the‑ground footage and reports from Bucha (journalists and outlets entering the town after Russian withdrawal) documenting corpses and destruction.",
      "date": "2022-04-03 00:00:00"
    },
    {
      "id": "f64eec97-d14d-4a81-af07-8f416d6890d9",
      "text": "ICC Prosecutor Karim A. A. Khan announces opening of a formal investigation into the situation in Ukraine, but as of early April had not published a specific, on‑the‑ground Bucha investigative timeline.",
      "date": "2022-03-02 00:00:00"
    },
    {
      "id": "a544e0c1-ed7e-491e-bdc6-50b79d4bf79a",
      "text": "Ukrainian government forces launched operations and reclaimed parts of Mariupol in May–June 2014 amid heavy fighting.",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "8c59f029-fa4c-424c-8712-979198438f2c",
      "text": "Battle of Ilovaisk (August 2014) and open-source analyses showing use of Russian tanks and weapons in eastern Ukraine.",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "36aa4449-8818-4c98-90bc-fd2a05ea538a",
      "text": "Formation and deployment of the Azov volunteer battalion in May–June 2014, with operations around Mariupol.",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "eb8db62e-651f-4c8e-b669-48a2c8d291e2",
      "text": "IPCC Special Report on Global Warming of 1.5°C (SR15) emphasizing land-based mitigation options",
      "date": "2018-10-08 00:00:00"
    },
    {
      "id": "277714f9-0805-48b1-aba6-c95997c08bbd",
      "text": "Launch of the Trillion Trees initiative (WWF, BirdLife International, WCS)",
      "date": "2017-11-15 00:00:00"
    },
    {
      "id": "0418b276-b637-4fb1-93a0-12fc0f74d214",
      "text": "Heightened fiscal pressure and passage of an IMF‑compliant state budget in December 2015 (public calls for a 'fiscally sustainable' budget; budget package passed late December 2015)",
      "date": "2015-12-24 00:00:00"
    },
    {
      "id": "3c8a7cb1-f0ce-46d3-ab60-c06d45d6ed83",
      "text": "Parliament adopted the emergency law \"On Prevention of Financial Catastrophe...\" that amended social protection rules and changed the structure/timing of some child benefits (law adopted 27 March 2014; some provisions effective later)",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "c3f09444-e6e0-4d2a-bee9-15b6356fc404",
      "text": "FDA authorization for consumer genetic testing expanded in 2018 (e.g., March 6, 2018 FDA action on 23andMe), signalling regulatory acceptance of DTC genetic information.",
      "date": "2018-03-06 00:00:00"
    },
    {
      "id": "10aa326f-e579-4f6c-bd1a-8aff80170494",
      "text": "Publication of a clinical review: 'MTHFR genetic testing: Controversy and clinical implications' (Aust Fam Physician, 2016) documenting widespread promotion of MTHFR testing by alternative practitioners and pharmacies.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "c3172225-3693-4c6f-9238-7d90edfa3626",
      "text": "German federal prosecutors publicly announced the arrest of three Ukrainian nationals suspected of planning parcel/explosive attacks and other acts of sabotage in Germany and Switzerland.",
      "date": "2025-05-14 00:00:00"
    },
    {
      "id": "a86f7c23-4981-42fa-b161-51fc78cdad88",
      "text": "Public warnings from German domestic-intelligence officials in late 2024 that Russian sabotage and intelligence activity targeting European logistics and critical infrastructure were an ongoing threat.",
      "date": "2024-10-24 00:00:00"
    },
    {
      "id": "f508aab5-c242-4d88-8ad5-2a725c9a324b",
      "text": "News coverage noting a recent string of fires and security incidents at European courier and freight depots in months prior to the arrests.",
      "date": "2025-05-24 00:00:00"
    },
    {
      "id": "97b8430d-9275-46e1-8b79-3fb241ad08be",
      "text": "Commander‑in‑Chief Valerii Zaluzhnyi publishes a high‑profile piece and interview in The Economist outlining that the war has entered 'positional'/stalemate phase and calling for major technological/strategic changes",
      "date": "2023-11-01 00:00:00"
    },
    {
      "id": "ee067d00-c0b5-47d3-9029-8fd5486855f9",
      "text": "Western press coverage highlights growing tensions and public debate over the relationship between President Zelensky and Commander Zaluzhnyi amid frustration over the stalled counteroffensive",
      "date": "2023-11-08 00:00:00"
    },
    {
      "id": "48b3571a-6ac3-44f5-9fe0-6c14f6140147",
      "text": "Official national exit‑poll consortium (Razumkov/NI Consortia: DIF, KIIS, Razumkov) published large‑margin results showing Volodymyr Zelensky’s landslide victory on April 21, 2019.",
      "date": "2019-04-21 00:00:00"
    },
    {
      "id": "ce9b33b9-e85b-4046-ba77-e5f1868c6e56",
      "text": "Pew Research Center survey (released July 29, 2024) showing wide partisan divisions on U.S. responsibility and support for the war in Ukraine.",
      "date": "2024-07-29 00:00:00"
    },
    {
      "id": "19027ae8-4e58-4278-9f4f-f2109718cadf",
      "text": "House Speaker Mike Johnson repeatedly delayed or conditioned votes on Ukraine aid and publicly signaled limited appetite for further Ukraine funding among House Republicans in spring 2024.",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "2e4da640-6c78-49c3-9e26-c35f40b8370e",
      "text": "Republican infighting and public GOP messaging in early April 2024 explicitly citing polls and voter fatigue to justify delaying or opposing further Ukraine assistance.",
      "date": "2024-04-05 00:00:00"
    },
    {
      "id": "97ee6eff-e540-44c5-90bc-350b44a7f2d1",
      "text": "Joint Investigation Team (JIT) announced criminal investigation findings implicating a Buk missile from territory held by pro-Russian separatists (September 2016)",
      "date": "2016-09-28 00:00:00"
    },
    {
      "id": "114d8811-9be0-485b-93ce-1556c4af6efd",
      "text": "Media coverage of shifting Russian public opinion (Levada/Moscow Times report, Feb 2020) showing changes in who Russians say is responsible",
      "date": "2020-02-14 00:00:00"
    },
    {
      "id": "aebfeb31-a7cc-40f5-85e1-ab17a9a81027",
      "text": "Great Barrington Declaration (Oct 4, 2020) calling for \"focused protection\" and opposing lockdowns",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "f94dfaef-eb1f-479e-8c8d-c45f782c213e",
      "text": "WHO interim guidance advised masks mainly for symptomatic people and healthcare settings (interim guidance PDF)",
      "date": "2020-01-29 00:00:00"
    },
    {
      "id": "5a9a532b-3469-4108-a503-a8dee755d225",
      "text": "CDC publicly recommended cloth face coverings for the general public (press release)",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "3d1e5490-2d11-4983-a889-245fb01aab25",
      "text": "China temporarily bans wildlife trade nationwide in response to the novel coronavirus (reported by Reuters)",
      "date": "2020-01-26 00:00:00"
    },
    {
      "id": "3140119f-8d47-4304-9e60-70eda24c916b",
      "text": "IPBES 2019 Global Assessment report on biodiversity and ecosystem services publicly released",
      "date": "2019-05-24 00:00:00"
    },
    {
      "id": "d4169ee9-5b6b-437d-8a9c-d6bda51ffd94",
      "text": "IARC (WHO cancer agency) issued a press release classifying processed meat as 'carcinogenic to humans' (Group 1).",
      "date": "2015-10-26 00:00:00"
    },
    {
      "id": "d578f1e2-0edf-442f-8167-9730b07540ed",
      "text": "WHO/IARC published clarifying Q&A and statements explaining that Group 1 classifies hazard (evidence of carcinogenicity) but does not indicate the magnitude of risk relative to other Group 1 agents (e.g., smoking).",
      "date": "2015-10-26 00:00:00"
    },
    {
      "id": "80c98feb-aa13-4dbf-8e34-68d40b5993ae",
      "text": "International Rescue Committee (IRC) and other NGOs issued warnings and reports (late Sep 2023) expressing concern about legal uncertainty and the future of support for Ukrainians in Poland.",
      "date": "2023-09-28 00:00:00"
    },
    {
      "id": "97efe8fc-86dc-4752-8d07-932a84a1c46b",
      "text": "Polish government spokesman Piotr (Piotr) Müller publicly said Poland will likely not extend special support measures for Ukrainian refugees into 2024.",
      "date": "2023-09-19 00:00:00"
    },
    {
      "id": "0baeefc1-adc3-4f98-b95a-d541cccf69ad",
      "text": "Poland's Social Insurance Institution (ZUS) suspended childcare/family benefit payments for thousands of Ukrainian refugees who had left Poland.",
      "date": "2023-08-23 00:00:00"
    },
    {
      "id": "3afa542c-0bdb-4bfe-99c5-ec4f8c07f3eb",
      "text": "Multiple news outlets (e.g., Kyiv Independent) and regional reporting reproduced Polish officials' remarks that support may be curtailed in 2024, producing headline-driven coverage in mid-September 2023.",
      "date": "2023-09-19 00:00:00"
    },
    {
      "id": "8a6ad661-4866-4e53-a06e-fc4454d38987",
      "text": "2015 U.S. Dietary Guidelines Advisory Committee recommended removing a quantitative limit on dietary cholesterol",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "1cccfa74-2117-468a-aefa-213b8307ea3d",
      "text": "CDC/ACIP MMWR update on myocarditis after mRNA COVID‑19 vaccination and policy guidance (MMWR report / ACIP review)",
      "date": "2021-07-09 00:00:00"
    },
    {
      "id": "32db54f1-b369-4ca0-8b04-d474a4145f4f",
      "text": "Renaming of Dnipropetrovsk to 'Dnipro' under Ukraine's decommunization/renaming process",
      "date": "2016-05-24 00:00:00"
    },
    {
      "id": "f464d68b-a2a1-43a1-b569-4d332d007b45",
      "text": "Adoption of Ukraine's 2017 education law strengthening the use of Ukrainian in schools",
      "date": "2017-09-24 00:00:00"
    },
    {
      "id": "558ff771-454a-4ef9-b800-b3b910ece8ee",
      "text": "Pro‑Russian unrest and separatist seizures in eastern Ukraine (including activity in Dnipropetrovsk region)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "51c347f2-e521-4dcb-ac82-57eae349c8e0",
      "text": "Norwegian review of deaths in very frail elderly after Pfizer vaccination (widely reported mid‑January 2021)",
      "date": "2021-01-15 00:00:00"
    },
    {
      "id": "455b2dd1-c3a1-474a-ab22-e9dfcad0d66d",
      "text": "FDA issues Emergency Use Authorization (EUA) for the Pfizer–BioNTech COVID-19 vaccine",
      "date": "2020-12-11 00:00:00"
    },
    {
      "id": "e113e22b-2707-4663-a22b-b4c0f7bd2f1a",
      "text": "First U.S. COVID-19 vaccinations administered and public rollout begins",
      "date": "2020-12-14 00:00:00"
    },
    {
      "id": "03751e65-146b-4456-8dc1-c7c36cbb9273",
      "text": "Press conference by Reserve Colonel Mykhailo Slobodianiuk in Lviv (March 11, 2015) in which he discussed adding additional grades/medals to the Order for Courage rather than annulling it.",
      "date": "2015-03-11 00:00:00"
    },
    {
      "id": "d46d0c0f-98c6-4033-a3bc-33944da10810",
      "text": "Widespread toppling and removal of Soviet-era monuments across Ukraine during 2013–2014 (including multiple high-profile Lenin statue removals).",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "099063c7-f4d6-452a-96b7-3cfbec499f70",
      "text": "Target Malaria (a Gates Foundation‑supported research consortium) conducted the first small‑scale releases of genetically modified sterile male Anopheles mosquitoes in Bana, Burkina Faso (July 2019).",
      "date": "2019-07-01 00:00:00"
    },
    {
      "id": "db5fae7e-79b7-4b72-ac6f-4886e201988a",
      "text": "Oxitec conducted pilot releases and community engagement in the Florida Keys (2021) and faced local protests over planned releases of genetically modified Aedes aegypti.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "5182eb84-9e91-4051-97a4-a787da6915f3",
      "text": "Bill & Melinda Gates Foundation publicly funded Oxitec to develop genetically engineered mosquitoes for malaria control (reported 2018).",
      "date": "2018-06-21 00:00:00"
    },
    {
      "id": "4e319c0c-fa97-49bd-8d1f-e297eb183d06",
      "text": "Controversy over Oxitec field trials in Jacobina, Brazil (2013–2015) culminated in 2019 scientific disputes and papers suggesting rare viable progeny/hybridization, prompting public debate.",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "c1787c96-2590-4891-b3f5-806faabaad21",
      "text": "ACAPS / briefings and national reports show large concentrations of Ukrainians remaining in Polish cities (May 2022 briefing)",
      "date": "2022-05-25 00:00:00"
    },
    {
      "id": "e00f7faa-5d4d-4e79-8298-ad7c22d4d2c8",
      "text": "Early UNHCR / IOM intention surveys (April–May 2022) reporting many refugees' immediate plans and diverse intentions to stay or return",
      "date": "None"
    },
    {
      "id": "11a40aaf-f706-40cf-82a9-1a19cf63c3d5",
      "text": "Poland introduces PESEL registration for Ukrainian arrivals, enabling access to services",
      "date": "2022-03-16 00:00:00"
    },
    {
      "id": "861b0fc8-2713-435b-9bd0-27cef9356563",
      "text": "EU Council adopts Temporary Protection Directive for people fleeing Ukraine",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "4e99c43a-52d4-4367-8e23-2a3c8bd45a8f",
      "text": "Polish border guard reports over 2 million refugees have entered Poland since the invasion",
      "date": "2022-03-18 00:00:00"
    },
    {
      "id": "8f90dc85-17db-45b6-861f-a79a145cbdfd",
      "text": "China's documented prior practice of rejecting incoming grain shipments for reasons such as unapproved GMO varieties or contamination (e.g., several U.S. corn cargoes rejected in 2013).",
      "date": "2013-12-04 00:00:00"
    },
    {
      "id": "3293095e-b726-41fe-9e73-a2632666ed8a",
      "text": "Ukrainian inspectors / Consumer Protection Agency reported a small detection of pests/nematodes in certain fields designated for export.",
      "date": "2016-08-30 00:00:00"
    },
    {
      "id": "1063765a-03a7-4469-a982-301b089febc9",
      "text": "Human Rights Watch documents abuses by volunteer battalions and excessive detentions by Ukrainian security services",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "222d75b6-ccc3-4eff-bdfa-f2c7aed90156",
      "text": "OSCE Special Monitoring Mission (SMM) publishes thematic reporting and daily monitoring documenting civilian casualties and incidents in Donetsk and Luhansk",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "ea73dc47-9ebe-4398-8854-410ce744a766",
      "text": "Ukrainian officials and ombudsman reports attributing water supply interruptions in parts of Donetsk and Luhansk to artillery damage and actions by occupying forces (2014–2015)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "d37b5259-c261-4f6f-9fb2-82a898d4a789",
      "text": "Power cuts and shelling halted pumping stations and water supply in Luhansk (summer 2014)",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "a7a9313b-3363-4c37-9221-69cecc02c7b7",
      "text": "U.S. Secretary of State Antony Blinken visits Kyiv and reaffirms support but makes no commitment on NATO membership",
      "date": "2021-05-06 00:00:00"
    },
    {
      "id": "8e8d6642-8a2b-41f0-877a-508b282f4111",
      "text": "Ukraine amends its constitution to enshrine EU and NATO membership aspirations (constitutional change enters into force)",
      "date": "2019-02-19 00:00:00"
    },
    {
      "id": "51c342aa-f495-447c-a741-0f62d5867280",
      "text": "Public opposition from major NATO members (e.g., Germany and France) to immediate Ukrainian accession around the 2008 summit",
      "date": "2008-04-01 00:00:00"
    },
    {
      "id": "eae9effd-0408-4194-a055-2a43ac1db606",
      "text": "Ukrainian officials publicly warned that individuals who visited temporarily occupied Crimea or separatist‑controlled Donbas without Kyiv's permission would be banned from observing Ukrainian elections",
      "date": "2018-03-24 00:00:00"
    },
    {
      "id": "322841cd-72a9-4285-a807-cc62848423ce",
      "text": "Ukraine's Central Election Commission had publicly registered hundreds of international observers ahead of the March 31, 2019 presidential vote",
      "date": "2019-03-15 00:00:00"
    },
    {
      "id": "0af56191-0e0f-4fe2-b9e2-e821fd6db35c",
      "text": "Verkhovna Rada passed amendments banning citizens of the Russian Federation from serving as official election observers in Ukraine",
      "date": "2019-02-07 00:00:00"
    },
    {
      "id": "f8673471-5bf7-4c53-affb-4caa3100de22",
      "text": "A specific German activist/politician (Andreas Maurer, Die Linke) who had previously visited occupied Ukrainian territories and held pro‑Russian positions was not accredited as an observer",
      "date": "2018-11-11 00:00:00"
    },
    {
      "id": "5c352b85-72a5-4fe0-b247-e193012c1069",
      "text": "Publication of small, legitimate human moringa studies for other outcomes (e.g., 2021 randomized trial on glycemic control)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "4323d9ee-e5be-4bde-bd6b-7fa02e8e16ef",
      "text": "Peer-reviewed research and clinical-trial literature on helminth (worm) immunomodulation and 'helminth therapy' for autoimmune conditions (reviews and trials published in mid-2010s)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "167cd11a-7bd8-448b-8a6e-495bbd0f3fa5",
      "text": "Analysts and Ukrainian officials reported a sharp projected fall in spring sowing area (up to ~39% decline) because of the invasion, threatening the next harvest.",
      "date": "2022-03-15 00:00:00"
    },
    {
      "id": "bb9d0cc8-29c7-493d-a706-4ce83cc9c18d",
      "text": "Russian naval blockade of Black Sea ports blocked Ukrainian grain shipments, threatening export revenue and leaving grain on vessels.",
      "date": "2022-03-21 00:00:00"
    },
    {
      "id": "3a9774e6-10f2-477a-ab6a-cca67b1c16fc",
      "text": "Sanctions and the war disrupted fertilizer and fertilizer-ingredient supplies (Russia/Belarus are major suppliers), raising alarms about reduced crop yields globally and in Ukraine.",
      "date": "2022-03-23 00:00:00"
    },
    {
      "id": "441e1bc0-70fe-44eb-ad34-0223b99e3ca4",
      "text": "Reports from newly occupied areas (e.g., Kherson) of empty stores, local food shortages and looting after Russian forces captured territory.",
      "date": "2022-03-01 00:00:00"
    },
    {
      "id": "2f871919-d116-40c0-a287-e1eba8a48b43",
      "text": "Reports of long queues as Crimeans applied for Russian passports (coverage March 19–20, 2014)",
      "date": "2014-03-20 00:00:00"
    },
    {
      "id": "917b61ae-ede9-4e14-9d70-7ec40dc181b3",
      "text": "Defection of Ukraine navy commander Denys Berezovsky to pro‑Russian Crimean authorities (early March 2014)",
      "date": "2014-03-02 00:00:00"
    },
    {
      "id": "59154926-987c-4187-b208-3ac364e6899a",
      "text": "Verkhovna Rada vote to repeal the 2012 language law (widely reported as a 'ban' on Russian)",
      "date": "2014-02-23 00:00:00"
    },
    {
      "id": "2e0c40f0-7009-4245-826e-b1c693e22a37",
      "text": "Deadly clashes and Trade Unions House fire in Odesa",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "5822f032-feb0-4fca-a9fe-b0db5146f9f1",
      "text": "Reports of attacks, intimidation and disappearances of activists in Crimea during the March 2014 takeover",
      "date": "2014-03-14 00:00:00"
    },
    {
      "id": "442ca6ad-3fc9-40f8-b29e-f5ebd7e26aaa",
      "text": "Euromaidan protests, violent escalation and ouster of President Yanukovych",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "3269616a-cc39-4a25-bafb-f0ad27cb1b53",
      "text": "CDC lab alert language recommending adoption of multiplex assays that can 'facilitate detection and differentiation of SARS‑CoV‑2 and influenza viruses'",
      "date": "2021-07-21 00:00:00"
    },
    {
      "id": "9ca8200d-6dc1-4f59-9e0b-189a5928ba6d",
      "text": "CDC Lab Alert announcing it will withdraw its request for EUA for the CDC 2019‑nCoV Real‑Time RT‑PCR Diagnostic Panel",
      "date": "2021-07-21 00:00:00"
    },
    {
      "id": "f7e271ea-0a8c-411a-a7ec-e034b971ea88",
      "text": "OSCE Special Monitoring Mission reports documenting weapons, movements and indicators of cross-border support to armed groups in Donbas",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "5bc21564-4705-4f88-b5a6-3c76db8c6999",
      "text": "FIFA precedent of suspending a national association for government interference (Kuwait suspended)",
      "date": "2015-10-16 00:00:00"
    },
    {
      "id": "3d6ca9ba-8938-41e5-a235-f30ae9f1bb9e",
      "text": "UEFA opened fresh disciplinary proceedings and charges related to crowd disturbances and racist behaviour involving Dynamo Kyiv (follow-up enforcement actions)",
      "date": "2016-02-24 00:00:00"
    },
    {
      "id": "8d744fb7-6fd9-4ba1-811c-9de7080dc2ec",
      "text": "UEFA bans Crimean clubs from Russian competitions and declares Crimea a 'special zone' for football",
      "date": "2014-12-04 00:00:00"
    },
    {
      "id": "6c0d5bf5-6470-434d-a633-f24e61c3ddf5",
      "text": "Publication of Lennerz et al. survey of 2,029 self‑identified carnivore dieters (Current Developments in Nutrition)",
      "date": "2021-12-24 00:00:00"
    },
    {
      "id": "6210f009-184f-443b-b61e-725c791e1e92",
      "text": "WHO highlights a multi‑country validation study of the OptiBP smartphone blood‑pressure application",
      "date": "2023-04-21 00:00:00"
    },
    {
      "id": "af232223-fe84-4fea-9b31-bba82843063a",
      "text": "European Society of Hypertension working‑group statement on cuffless blood‑pressure devices (review and guidance)",
      "date": "2022-06-16 00:00:00"
    },
    {
      "id": "dc9e2ee2-6a52-44e1-bf09-83ac361b0ae3",
      "text": "Peer‑reviewed npj Digital Medicine study (CamBP/OptiBP) reports ISO‑aligned accuracy in select populations",
      "date": "2023-04-17 00:00:00"
    },
    {
      "id": "54f3a33a-e560-4653-8566-3949400427bb",
      "text": "Approaching 30th anniversary of the Chornobyl disaster and official commemorations (Poroshenko declared 2016 'Year of Remembrance' for liquidators and victims)",
      "date": "2015-12-14 00:00:00"
    },
    {
      "id": "92622502-9d1f-489c-91fb-e43fc2acf742",
      "text": "President Petro Poroshenko vetoed law No.2093 and returned it to parliament with proposals",
      "date": "2016-04-12 00:00:00"
    },
    {
      "id": "cf603f33-34e6-4183-a115-e3ac3538ba4b",
      "text": "Verkhovna Rada (Ukrainian parliament) passed draft law No.2093 restoring certain Chernobyl benefits",
      "date": "2016-03-17 00:00:00"
    },
    {
      "id": "e7875114-649f-4e5c-b759-b863b64561a7",
      "text": "Publication of in vitro research showing antiviral activity of Melissa officinalis extracts against some influenza strains (e.g., lab studies on H1N1 / H9N2)",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "2acea521-b0fc-48ed-88e2-b8f6da9aa180",
      "text": "Putin signed decree requiring buyers from 'unfriendly' countries to pay for gas in roubles.",
      "date": "2022-03-31 00:00:00"
    },
    {
      "id": "48218272-d962-4750-b578-752d4240e2e3",
      "text": "Austrian government statement: Russian gas still flowing while Austria scrambles for alternatives.",
      "date": "2022-04-27 00:00:00"
    },
    {
      "id": "93c43d6c-88d3-4dad-b18a-dd5596a062c4",
      "text": "OMV (Austrian energy firm) said it had initial contact with Gazprom about rouble payment demands.",
      "date": "2022-04-01 00:00:00"
    },
    {
      "id": "901c9158-8dd1-451e-89bc-9b3e6f7044ad",
      "text": "OPEC (led by Saudi Arabia) decided not to cut output, triggering a sharp oil price fall",
      "date": "2014-11-27 00:00:00"
    },
    {
      "id": "32022d9c-2c83-48a5-bc04-c8cc87a593d0",
      "text": "Kremlin and Putin publicly blamed Western sanctions and falling oil prices for the rouble slump",
      "date": "2014-12-18 00:00:00"
    },
    {
      "id": "07a56859-a3c7-4523-b943-001bfa91cf5a",
      "text": "Reports Russia spent tens of billions defending the rouble in 2014 (estimates ~USD 80bn)",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "a390a2b6-e764-4521-bf88-b41e34e69af1",
      "text": "Emergency Bank of Russia decision: key rate hiked to 17% as rouble plunged",
      "date": "2014-12-16 00:00:00"
    },
    {
      "id": "16158f34-8015-44f8-a7dc-0e8a0536b905",
      "text": "Western sanctions on Russia expanded through 2014 over Ukraine/Crimea",
      "date": "2014-07-31 00:00:00"
    },
    {
      "id": "ddac4342-724b-4057-83bb-d517c82627bd",
      "text": "NOAA press release and reports (Jan 2024) documenting 2023 as one of the warmest years on record while noting the roles of greenhouse gases and natural variability",
      "date": "2024-01-12 00:00:00"
    },
    {
      "id": "0c4010c9-6257-4e87-bc84-a4b250e3d55b",
      "text": "Peer‑reviewed opinion piece (Sherwood & Forest) in Atmospheric Chemistry and Physics (2024) discussing remaining uncertainty in equilibrium climate sensitivity (ECS)",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "1ca309d5-e3fc-451b-af76-e44786b894f6",
      "text": "Investigative reports (April 2024) documenting widespread climate misinformation and enforcement failures on short‑form social platforms such as TikTok",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "39da4c3a-adf9-48d1-af3a-5afc6e3ac57e",
      "text": "Republican-led U.S. congressional hearings on climate science that featured skeptical expert witnesses and took place across March–April 2024",
      "date": "None"
    },
    {
      "id": "1c5e2b7f-64ac-4508-957b-adfe716ec6e6",
      "text": "Ukrainian parliament actions in September 2014 approving laws on special status/self-governance and amnesty provisions related to Donbas",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "5470ae14-4639-43f5-9525-c3f9199e1085",
      "text": "Minsk II agreement (Package of Measures) contained an instruction to 'provide pardon and amnesty' for persons involved in events in parts of Donetsk and Luhansk",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "a87df052-6792-4ff4-91c3-24581c4c4a31",
      "text": "High-profile interviews and statements by Nadiya Savchenko urging peace talks and negotiation with separatists",
      "date": "2016-05-24 00:00:00"
    },
    {
      "id": "68f92636-4e3a-467c-8168-cd1c2eb155c5",
      "text": "Nadiya Savchenko's high-profile release and return to Ukraine in a prisoner swap (pardoned and flown back)",
      "date": "2016-05-25 00:00:00"
    },
    {
      "id": "1e919862-a394-4d0e-8f88-dbbc7c1f3be9",
      "text": "German Communist Party (DKP) launched a petition asking the Bundestag and government to lift sanctions that hinder exchange of medical supplies and cooperation during the COVID-19 crisis.",
      "date": "2020-03-26 00:00:00"
    },
    {
      "id": "068432ed-79d3-4c40-b986-0b9f52b2b854",
      "text": "Russian leadership/public diplomacy pushed a narrative that international sanctions hampered pandemic response — including Putin’s appeals at G20/UN fora to suspend some sanctions for humanitarian reasons in late March 2020.",
      "date": "2020-03-26 00:00:00"
    },
    {
      "id": "92de102e-5285-491c-92af-7f876326a055",
      "text": "EU/commission reporting showed a sharp rise in applications by Ukrainians for Romanian citizenship in 2014–2015",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "9312344f-c2bd-4729-abeb-af172a7a75cb",
      "text": "Local media reports of a 'Constituent conference' of an \"Assembly of the Romanians of Bukovina\" in Chernivtsi allegedly deciding on autonomy",
      "date": "2015-07-24 00:00:00"
    },
    {
      "id": "21f04535-1899-4f5e-a6ac-c45b5f9a784e",
      "text": "Russian officials warn of a sharp increase in shelling in the Donbas and publicly blame Ukrainian forces (Russian statements about escalated shelling)",
      "date": "2022-02-18 00:00:00"
    },
    {
      "id": "fd3b3d2d-9a82-43f6-b5e1-36eb81fa8ce2",
      "text": "Moscow says a projectile fired from Ukraine destroyed a Russian border facility (Rostov region)",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "affc1bd7-931a-41ac-8a4b-149e1962f5f7",
      "text": "Russia launches a full-scale invasion of Ukraine (24 February 2022); Ukrainian leaders publicly vow to repel and drive back Russian forces",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "98d9b1be-a091-42ae-a824-4add22826725",
      "text": "Peer-reviewed laboratory study found a banana-derived lectin (BanLec) inhibits HIV replication in vitro",
      "date": "2010-03-19 00:00:00"
    },
    {
      "id": "686243dd-c98a-4534-ab8e-261dce5d0be3",
      "text": "Publication of peer-reviewed reviews and preclinical studies summarizing DMSO's immunomodulatory and in vitro anticancer effects (science literature available by 2020)",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "73f2581b-78ea-4073-b522-f122ba21942b",
      "text": "1978 FDA approval of RIMSO-50 (a 50% DMSO solution) for intravesical use in interstitial cystitis",
      "date": "1978-04-24 00:00:00"
    },
    {
      "id": "ff5616f8-a79b-47de-9ac9-273996d50120",
      "text": "International Coral Reef Initiative (ICRI) published an update stating that bleaching-level heat stress impacted 84% of the world’s coral reefs.",
      "date": "2025-04-23 00:00:00"
    },
    {
      "id": "ad5984ee-a3ad-4ec4-b4ce-e130c1f67d09",
      "text": "Wagner Group rebellion and armed column movement near Voronezh",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "28e8f541-e8c0-48fb-bce9-3fb0dd399191",
      "text": "Explosions/drone incidents over central Moscow (including near the Kremlin) and official accusations",
      "date": "2023-05-03 00:00:00"
    },
    {
      "id": "a742fb45-a461-43bc-b476-456e8ad028bc",
      "text": "Fuel tank fire at a Rosneft oil depot in Voronezh region",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "cf4cac70-1fe0-44ec-afd7-3d70e3d867fa",
      "text": "CDC One Health guidance noting most emerging infectious diseases are zoonotic",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "456df9fe-30b3-4415-9a39-52064e0cf327",
      "text": "Two Ukrainian servicemen (including Dmytro Krasnohrud) were killed near Zaitseve on July 13, 2020; bodies were later handed over — a real battlefield casualty incident.",
      "date": "2020-07-13 00:00:00"
    },
    {
      "id": "ca91c933-ac95-4353-bb69-1d9f393a79c8",
      "text": "Mainstream health articles and reviews (e.g., Healthline overview updated June 29, 2023) summarizing promising lion’s mane research for cognition and Alzheimer’s",
      "date": "2023-06-29 00:00:00"
    },
    {
      "id": "b17c0ea0-45a5-493f-91f7-b3daebbaf959",
      "text": "2016 mouse study (Tsai‑Teng et al.) showing erinacine‑A enriched Hericium mycelia reduced amyloid pathology in APP/PS1 Alzheimer’s model mice",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "91ad4b59-ea33-46ae-8242-9b46c76403f7",
      "text": "July 20, 2021: FDA warning letter(s) and subsequent press attention about dietary‑supplement sellers making disease claims for mushroom products (including lion’s mane)",
      "date": "2021-07-20 00:00:00"
    },
    {
      "id": "098aa029-ec8e-4883-85bf-bc46490bd379",
      "text": "Russia imposes bans on Ukrainian food imports after 2014 sanctions",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "42d52141-5e88-4a4d-962a-82996e2d62a9",
      "text": "Sharp GDP contraction during 2014–2015 amid conflict and economic shock",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "7da97a72-cae2-46bf-99b9-531f8be4f1b1",
      "text": "Provisional application of the EU–Ukraine Association Agreement including the DCFTA",
      "date": "2016-01-01 00:00:00"
    },
    {
      "id": "1106203c-1f11-4aac-adb2-d43dd7539134",
      "text": "September 2021 reports of black/foreign particles found in some Moderna vials in Japan and large batches paused",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "34c1ed12-9336-4757-84db-c8b93a27ce8e",
      "text": "Center for Economic Strategy published an assessment placing Ukraine's economic losses from the temporary occupation of Crimea at about $135 billion.",
      "date": "2021-08-09 00:00:00"
    },
    {
      "id": "6f28a2f2-e539-4dee-9855-e6a65ab9e0a6",
      "text": "U.S. EPA and other regulators/extension services have published fact sheets explaining corn gluten meal is a food/feed product, classified as minimum‑risk for pesticide use, and that its rodenticidal effects depend on a physical/dehydrating mode of action not applicable to humans (EPA fact sheet Nov 2002; Cornell IPM profile).",
      "date": "2002-11-01 00:00:00"
    },
    {
      "id": "af890a05-332e-45e2-b324-34148f8f8edf",
      "text": "IPCC Synthesis Report released attributing recent warming predominantly to human activities",
      "date": "2023-03-20 00:00:00"
    },
    {
      "id": "15aaf9a0-6288-49ed-8e08-6988a0f54955",
      "text": "Publication of Nicola Scafetta et al. paper in 2023 arguing a larger role for the Sun in recent climate change",
      "date": "2023-06-14 00:00:00"
    },
    {
      "id": "49acb213-a59d-42fa-9fc4-f619d8791ba4",
      "text": "Local reporting: large pro‑Ukraine demonstrators in Kherson outnumbered pro‑Russian activists (Svoboda Square, Kherson)",
      "date": "2014-03-22 00:00:00"
    },
    {
      "id": "45e42270-f505-45f5-b918-6b0cda07bcfa",
      "text": "BBC analysis 'Ukraine underplays role of far right in conflict' documenting Azov and use of Nazi‑linked symbols (Wolf's Hook) in 2014",
      "date": "2014-12-13 00:00:00"
    },
    {
      "id": "7870243e-8aad-4f25-8742-7767ce72c40c",
      "text": "BBC profile of the ultra‑nationalist Right Sector and its role in the 2014 Maidan protests",
      "date": "2014-04-28 00:00:00"
    },
    {
      "id": "0d9fc4a0-5fcb-4860-9631-c7f6c920d7d6",
      "text": "Randomized, double‑blind clinical trial (Koytchev et al., Phytomedicine 1999) found topical lemon balm extract reduced symptoms and accelerated healing of herpes labialis (cold sores).",
      "date": "1999-04-24 00:00:00"
    },
    {
      "id": "7e25a76a-37bc-4cb4-991b-75ca8cb4db06",
      "text": "FDA warning letter to Applied Health Solutions (Oct 22, 2021) cites Grapefruit Seed Extract product claims including effectiveness against 'herpes' and other viral diseases.",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "4454f0a8-ec22-4cb4-ac30-1ae88c0d8026",
      "text": "UK Ministry of Defence announced it would send Challenger 2 tanks to Ukraine along with armour‑piercing rounds that contain depleted uranium.",
      "date": "2023-03-21 00:00:00"
    },
    {
      "id": "50270f49-40d5-4d8a-865b-719e919b380d",
      "text": "Historical precedent: Reporting and investigations documenting previous UK/US use of depleted uranium munitions in conflicts (Iraq, Balkans) were widely available.",
      "date": "None"
    },
    {
      "id": "c14565f6-e945-46f4-a565-20182e7bfb5f",
      "text": "Russian President Vladimir Putin publicly condemned the UK move and warned Moscow would be 'forced to react', calling the ammunition a weapon with a 'nuclear component'.",
      "date": "2023-03-21 00:00:00"
    },
    {
      "id": "fb35e2a8-7820-467f-9f02-501f5db2d4ea",
      "text": "Parliamentary elections scheduled for October 26, 2014 (the 'day of silence' was October 25), creating heightened public attention and low tolerance for reports of interference.",
      "date": "2014-10-25 00:00:00"
    },
    {
      "id": "b2a9a693-2f1e-4e6a-979d-58fca7b6cc79",
      "text": "Publication of Nerem et al. (PNAS) showing recent acceleration of global sea-level rise (2018)",
      "date": "2018-02-27 00:00:00"
    },
    {
      "id": "d901f911-ecfa-4d16-b71b-5d064dca9f25",
      "text": "Release of the Bureau of Meteorology / CSIRO 'State of the Climate 2018' report",
      "date": "2018-12-20 00:00:00"
    },
    {
      "id": "21308ad2-ed8c-47ad-91ea-7d57d9647a29",
      "text": "Marin County measles cases and public reporting on vaccine exemptions (2014–2015)",
      "date": "2015-01-28 00:00:00"
    },
    {
      "id": "bd61c7cb-9e37-4312-a09a-5d9c22333eae",
      "text": "Publication of Nevison & Parker county-level analysis showing plateau/decline in ASD prevalence among wealthy white California counties",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "545e7117-772c-412b-97f7-6e5cfd8279e3",
      "text": "Ukraine adopts law and official policies on 'temporarily occupied territories' and Donbas reintegration (2018)",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "9541024e-78b4-4a7d-9a0e-e5d0a23547c6",
      "text": "Putin decree simplifying acquisition of Russian citizenship for residents of Donetsk and Luhansk (passportisation of Donbas)",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "d8922da7-0392-43c3-9ff9-6852d5dea24c",
      "text": "Graphic reporting and images of women giving birth in bomb shelters, basements and damaged maternity hospitals (including Mariupol) during early 2022 attacks",
      "date": "2022-04-07 00:00:00"
    },
    {
      "id": "2e715436-fede-4a04-baa0-2533450430f0",
      "text": "Reporting that Ukraine was a major international destination for commercial surrogacy and fertility tourism",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "2bef7be2-37fe-4ae5-b341-834d95218f44",
      "text": "President Petro Poroshenko granted Ukrainian citizenship to three foreign-born technocrats nominated for ministerial posts ahead of a 2014 cabinet vote.",
      "date": "2014-12-02 00:00:00"
    },
    {
      "id": "825d43c3-608a-4dec-9135-afab70108a23",
      "text": "Media coverage highlighted several foreign‑born ministers and officials (e.g., Natalia Yaresko, Aivaras Abromavicius) being granted citizenship to take government posts in late 2014.",
      "date": "2014-12-02 00:00:00"
    },
    {
      "id": "22fc4451-39a9-429d-b999-ce653efa4de7",
      "text": "Former Georgian president Mikheil Saakashvili was granted Ukrainian citizenship and appointed governor of Odesa region (later stripped and restored at different times).",
      "date": "2015-05-30 00:00:00"
    },
    {
      "id": "9ff538ac-8666-450c-a6f0-7b725a52bbcc",
      "text": "Minsk II agreement sets political steps for Donbas (Package of measures)",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "f5b27817-344c-4cd3-9b2e-52fdcecb069c",
      "text": "OSCE deploys the Special Monitoring Mission (SMM) to Ukraine",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "1d0ef9c4-3fa5-499b-842d-f166010dea71",
      "text": "UN General Assembly adopts Resolution 68/262 affirming Ukraine's territorial integrity",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "87e7d153-c4a2-4274-ae4d-e0c5a470e7fe",
      "text": "UN Secretary‑General issues statements urging restraint on Crimea/Ukraine",
      "date": "2014-03-10 00:00:00"
    },
    {
      "id": "5d91096d-88e2-463c-b965-592ebc181a91",
      "text": "Russia summoned the German ambassador after Berlin's public statements on the Navalny case",
      "date": "2020-09-08 00:00:00"
    },
    {
      "id": "3ab432b3-1325-4c73-923c-07971b892798",
      "text": "Aleksey Navalny airlifted from Omsk to Berlin for medical treatment",
      "date": "2020-08-22 00:00:00"
    },
    {
      "id": "bc17fe6c-6f26-4257-9fea-1bde09ac2b15",
      "text": "Germany handed laboratory test data and facilitated OPCW technical assistance regarding Navalny's poisoning",
      "date": "2020-09-24 00:00:00"
    },
    {
      "id": "8e6dfbb8-7653-496d-a494-14f06c6a9619",
      "text": "Chancellor Angela Merkel said Navalny's poisoning was an attempted murder and called on Russia to explain",
      "date": "2020-09-03 00:00:00"
    },
    {
      "id": "8e6ffcb5-2935-4da8-a2f6-37ced68f793b",
      "text": "World Bank reported sharp GDP and industrial-production declines linked to the 2014 conflict",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "6329a629-8785-48c9-a520-51679aa960e5",
      "text": "Avdiivka Coke and Chemical Plant heavily shelled and production repeatedly disrupted",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "4aef59f0-2f8a-49ee-aa33-c47e66af31b0",
      "text": "Large share of Donbas industrial capacity cut off after 2014 fighting and separatist control",
      "date": "None"
    },
    {
      "id": "2602f358-ce54-463f-aa87-f29b88d699bf",
      "text": "Japan paused use of a large Moderna vaccine lot after pharmacists found black/foreign particles in vials (investigations later identified contaminants and some lots were recalled); mainstream outlets (BBC, others) reported the pause in Sept 2021.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "99054d96-5995-400d-a538-9d426409a010",
      "text": "Francis Fukuyama interview with Radio Svoboda published containing a cautious line that 'the issue that Ukraine will face in the future is the possibility that not 100 percent can be liberated'",
      "date": "2023-10-21 00:00:00"
    },
    {
      "id": "aad7e35d-8b80-43cd-b1f2-98b0b18220d7",
      "text": "‘Support Free Ukraine’ demonstration outside the Ukrainian embassy in Sofia",
      "date": "2014-01-23 00:00:00"
    },
    {
      "id": "e9e5908f-edb5-4e1c-96b6-ae50ee50f43a",
      "text": "Public rallies by the nationalist Ataka party in 2014 (large street demonstrations)",
      "date": "2014-09-28 00:00:00"
    },
    {
      "id": "2ce347ab-01ce-4b4e-8d58-fc0e04cf8b5a",
      "text": "Reporting on Bulgaria’s divided stance over Crimea and visits by Bulgarian politicians",
      "date": "2014-04-10 00:00:00"
    },
    {
      "id": "7907ff43-49d7-47f8-9ce0-20f40065d975",
      "text": "Reports (2010–2011) linking the Pandemrix H1N1 influenza vaccine to increased narcolepsy cases in children in Finland and Sweden and subsequent EMA/GSK reviews",
      "date": "None"
    },
    {
      "id": "4c6e1739-a25f-40f8-a4ea-6364e45bb003",
      "text": "June 2013: Japan's Ministry of Health, Labour and Welfare suspended its proactive recommendation for the HPV vaccine after reports of alleged adverse events",
      "date": "2013-06-24 00:00:00"
    },
    {
      "id": "dd58e7fd-f420-4f6b-aefc-7a5dca83b488",
      "text": "Public-health data and surveillance reports (UKHSA, ONS and CDC studies in 2021) showed waning vaccine effectiveness and higher absolute numbers of cases or deaths among vaccinated people in some age groups—driven by high vaccine coverage and timing—during late 2021.",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "456d3b04-8421-4838-812d-1f8e88ef43be",
      "text": "Reports of contamination in vaccine batches in Japan (stainless-steel/foreign particles in Moderna vials) and subsequent recalls/suspensions during September–October 2021.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "e2d23983-7667-4870-a6cd-a7d2d20d2a5e",
      "text": "International media reporting of Russia's seizure of three Ukrainian naval vessels and detention of crew (wounded sailors reported)",
      "date": "2018-11-26 00:00:00"
    },
    {
      "id": "41a2a877-f1fd-4480-8fdb-278293229f68",
      "text": "Coverage and analysis noting EU reluctance or political obstacles to imposing new Russia sanctions after the Kerch incident",
      "date": "2018-12-24 00:00:00"
    },
    {
      "id": "6833344f-17e5-418f-b9ef-61fdf01954e9",
      "text": "G7 foreign ministers' joint statement expressing 'utmost concern' about Russian actions in the Kerch Strait",
      "date": "2018-11-26 00:00:00"
    },
    {
      "id": "069aad17-1ac4-4f2c-9eb3-8efe16201b92",
      "text": "IMF and international lenders publicly warned Ukraine to accelerate reforms and tackle corruption to preserve investor confidence.",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "11f16641-f62e-4de3-81ce-e859e15762af",
      "text": "Kyiv issued formal sanctions on Russian-owned banks (blocking capital outflows and imposing restrictions).",
      "date": "2017-03-16 00:00:00"
    },
    {
      "id": "d73cc3b8-a1d8-4ac5-b390-0139a4ecdb07",
      "text": "Sharp falls in foreign direct investment and international capital flows to Ukraine following the 2014 crisis (documented in UNCTAD/World Investment reports).",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "85fadf01-a4ad-4ed0-96a4-462d215554db",
      "text": "Nationalisation of PrivatBank, Ukraine's largest commercial bank.",
      "date": "2016-12-19 00:00:00"
    },
    {
      "id": "9f7f3797-8aaa-4201-81c8-c842f8a53406",
      "text": "Reports that thousands of Mariupol residents, including children, were forcibly deported or taken through 'filtration' after Russian forces captured parts of the city",
      "date": "2022-03-20 00:00:00"
    },
    {
      "id": "1e88b0e6-9700-46f4-b372-9747c0551bcf",
      "text": "Red Cross / national Red Cross societies publicized medical aid, psychosocial support and programs for displaced Ukrainian children and families in early 2022",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "26c377ea-9aa0-4ae5-a5ff-c70b5b9b037b",
      "text": "Red Cross-led evacuation attempts to reach and extract civilians from besieged Mariupol failed or were halted amid heavy fighting",
      "date": "2022-03-06 00:00:00"
    },
    {
      "id": "14b0574a-5497-4884-bec6-520c0f7e187b",
      "text": "Bombing of the Donetsk Academic Regional Drama Theatre in Mariupol that sheltered civilians (including children), producing graphic images and uncertainty about many casualties",
      "date": "2022-03-16 00:00:00"
    },
    {
      "id": "eb701ce1-cfe6-4f8f-9fa3-89c1820a7a0e",
      "text": "ICRC activated a Central Tracing Agency (family‑tracing) bureau to collect information about missing people and reconnect families after the escalation in Ukraine",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "290f965d-5be0-464d-bdb8-163c06a62841",
      "text": "CDC and advocacy groups warn that pandemic-related delays in cancer screening and care could produce downstream increases in advanced cancers and mortality",
      "date": "2021-06-30 00:00:00"
    },
    {
      "id": "9171e567-8474-4dc0-aa10-9b5430fa19c7",
      "text": "CDC releases provisional life expectancy estimates for 2021 showing a sharp decline in U.S. life expectancy",
      "date": "2022-08-31 00:00:00"
    },
    {
      "id": "7b92fc65-a796-422b-9443-374ef57581b5",
      "text": "OSCE SMM reporting of civilian casualties at/near checkpoints in Donetsk/Luhansk (2019 summaries)",
      "date": "2019-12-26 00:00:00"
    },
    {
      "id": "7f30264e-f0a8-4066-90b6-0e6cdef570cb",
      "text": "Karlivka (Karlivka/Karlivka area) checkpoint ambush and fatalities",
      "date": "2014-05-23 00:00:00"
    },
    {
      "id": "488f65ef-7ae2-4e77-b989-9babfbb5e805",
      "text": "Volnovakha bus attack near a Ukrainian checkpoint (passenger bus hit)",
      "date": "2015-01-13 00:00:00"
    },
    {
      "id": "7b0ceb79-47c5-4f55-9476-3abeaeefd7d9",
      "text": "Earlier (March–April 2014) incidents where pro‑Russian activists raised Russian flags on government buildings in eastern Ukrainian cities (e.g., Kharkiv, Donetsk) were widely photographed and reported.",
      "date": "2014-03-01 00:00:00"
    },
    {
      "id": "1f294a78-91a8-4caa-9aa1-e9b461ad1138",
      "text": "Official visit of Bulgarian President Rosen Plevneliev to Kyiv (July 7–8, 2015) — Bulgarian flags and official decorations were displayed in central Kyiv for the visit.",
      "date": "2015-07-07 00:00:00"
    },
    {
      "id": "982cb1ee-fd21-48f1-8a3d-bfd40e3429d6",
      "text": "President Barack Obama met and publicly expressed support for Petro Poroshenko in meetings around mid-2014 (e.g., June 4, 2014 meeting during Poroshenko's European visits).",
      "date": "2014-06-04 00:00:00"
    },
    {
      "id": "2d919daa-b594-4887-9ca5-f369a56561fe",
      "text": "Poroshenko repeatedly and publicly vowed to restore Ukrainian control over Crimea (kept the topic in headlines through 2015).",
      "date": "2015-02-23 00:00:00"
    },
    {
      "id": "2f078d96-b20e-4413-8048-be0643f7af7d",
      "text": "Deputy Foreign Minister Olena Zerkal interviewed by the Financial Times, saying the EU delay on visa‑free travel 'feels like some kind of betrayal'",
      "date": "2016-12-16 00:00:00"
    },
    {
      "id": "c9b71fee-b2bd-4e51-bf29-7781c2e90c97",
      "text": "EU‑Ukraine summit and statements in late November 2016 confirming Ukraine had met visa‑liberalisation criteria but formal implementation remained pending",
      "date": "2016-11-24 00:00:00"
    },
    {
      "id": "b3aea6b4-75f7-4ddf-a535-2c6ca0fba585",
      "text": "CDC review and guidance on COVID-19 vaccine administration errors and deviations",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "39db8ebf-a9e7-441c-886d-4ce08a5dc110",
      "text": "Foreign particles found in Moderna vials in Japan leading to batch suspension and recall",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "c5c28d20-4097-4e54-a9b0-4de1dcaaa54e",
      "text": "EU REACH restrictions on hazardous substances in tattoo inks came into force and ECHA held an industry webinar explaining implementation.",
      "date": "2022-01-05 00:00:00"
    },
    {
      "id": "1cbab3a8-5125-41f5-a425-e491a7ed893e",
      "text": "Peer-reviewed analysis identified hexavalent chromium (a known carcinogen) as an impurity in some tattoo inks and discussed dermal exposure risk.",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "00e0bfe7-02d5-4c5b-8823-5a7b0a8cafe9",
      "text": "FDA warning letter (Ambaya Gold, Dec 5 2023) naming products promoted with claims that clinoptilolite (zeolite) 'removes heavy metals' and warning the company about unapproved/misbranded therapeutic claims.",
      "date": "2023-12-05 00:00:00"
    },
    {
      "id": "a7e56323-9b45-4421-9a5f-ac7b55680d47",
      "text": "UNHCR report documents extensive 'collective centres' for internally displaced people in Ukraine",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "81e24f29-a832-4e4a-a3f3-9ab6863e259b",
      "text": "Widespread, dramatic coverage of refugee 'camps' in Europe (Roszke, Hungary) during 2015 crisis",
      "date": "2015-09-11 00:00:00"
    },
    {
      "id": "abd88480-a561-41ac-9ac5-e3ff578e9f8a",
      "text": "Regulatory findings and widespread media coverage in March 2021 that the AstraZeneca vaccine was associated with very rare clotting events (VITT) and subsequent safety reviews.",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "3e77f882-da44-4f36-827d-0efb5922246f",
      "text": "Ukraine's state rail company suspends passenger and cargo train services to Crimea",
      "date": "2014-12-26 00:00:00"
    },
    {
      "id": "fb2493b5-37a0-4fd7-be13-669c7eca68f0",
      "text": "U.S. provides non‑lethal aid including Humvees to Ukraine (March 2015 announcement)",
      "date": "2015-03-11 00:00:00"
    },
    {
      "id": "c164484f-230a-409f-9758-d9661a1dfdbc",
      "text": "Western-led training and re-tooling exercises with Ukrainian forces reported (early 2016 coverage)",
      "date": "2016-01-24 00:00:00"
    },
    {
      "id": "eea65218-f61a-4b52-b873-6be6bacaa67d",
      "text": "U.S. State Department approves sale of Javelin anti-tank missiles to Ukraine",
      "date": "2017-12-22 00:00:00"
    },
    {
      "id": "b69d524c-6494-4c32-8608-033f7422210b",
      "text": "Reports that separatists and Russian‑backed forces captured equipment from Ukrainian units",
      "date": "2014-07-29 00:00:00"
    },
    {
      "id": "1216cb70-b558-48b1-a035-c50f00f83f02",
      "text": "Early‑post‑Crimea (March 2014) statements by Transnistrian officials (e.g., Mikhail Burla) requesting accession to Russia and broader media discussion that Transnistria might be a candidate for ‘the next Crimea.’",
      "date": "2014-03-18 00:00:00"
    },
    {
      "id": "29d71415-c815-4a13-bb80-4bc83e611763",
      "text": "Reports of foreign/black particles found in some Moderna vials in Japan, triggering recalls and headlines (September 2021).",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "d4cd80eb-eaac-49af-b68c-dc1b44a1d8c1",
      "text": "Early pregnancy‑safety surveillance of mRNA COVID‑19 vaccines reported no safety signal in vaccinated pregnant persons (v‑safe/pregnancy registry; NEJM preliminary findings, June 2021).",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "7c04ae5d-4a31-4b8d-9b2b-48941ac82d8e",
      "text": "UN OCHA Situation Report No.5 documenting rising fatalities and urban combat around Donetsk",
      "date": "2014-08-01 00:00:00"
    },
    {
      "id": "317ef0dc-064a-4eec-ad55-b8802b8eaa8b",
      "text": "Ukrainian and international leaders publicly warned that explosives or sabotage could threaten Dnipro dam infrastructure (public warnings and diplomatic appeals, Oct 2022)",
      "date": "2022-10-19 00:00:00"
    },
    {
      "id": "de1aef64-ff12-45b5-af12-ecc0c0e0dd6a",
      "text": "Russian forces captured the Kakhovka (Nova Kakhovka) hydroelectric power plant on the Dnipro early in the 2022 invasion",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "0f88ce35-bc1d-4580-9fa2-5a62b51ad3ff",
      "text": "Satellite imagery and reporting showed Russian forces building pontoon/ferry crossings across the Dnipro in Kherson region (summer 2022)",
      "date": "2022-07-29 00:00:00"
    },
    {
      "id": "0a3948be-fa4e-4cc4-acb8-1d150f116106",
      "text": "Reports that the Russian-held Nova Kakhovka dam was damaged by shelling (reported in Russian media) and experienced operational problems",
      "date": "2022-11-06 00:00:00"
    },
    {
      "id": "c80d4a05-71f3-4de0-99b0-46eefea2b55b",
      "text": "Ukraine stopped water flow to Crimea via the North Crimean Canal after Russia's 2014 annexation (closure and water cut-offs widely reported)",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "f234ae8b-1609-4236-bc79-01d2349b02fa",
      "text": "Public political downplaying of COVID-19 risk (early statements by high-profile politicians, March 2020)",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "21599273-58f4-4ab5-8c60-a98236a967d2",
      "text": "Stanford (Santa Clara) seroprevalence preprint (Bendavid et al.) suggesting many more infections and lower IFR (April 2020)",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "2102a9f4-f2ce-437a-9e8a-bf94b26d2e85",
      "text": "Release of the NIPCC report 'Climate Change Reconsidered' (Heartland Institute / Nongovernmental International Panel on Climate Change)",
      "date": "2009-04-24 00:00:00"
    },
    {
      "id": "25d1f51d-e212-4b08-afdc-65ff45ee0f4d",
      "text": "Jacques Attali's well‑known public profile (former special adviser to President François Mitterrand, prolific author and commentator) and periodic controversial commentary on euthanasia/ageing (often cited out of context).",
      "date": "None"
    },
    {
      "id": "e458de25-c9df-47f0-afe6-1796e559fcb1",
      "text": "World Economic Forum launched the 'Great Reset' initiative (public messaging beginning June 2020).",
      "date": "2020-06-03 00:00:00"
    },
    {
      "id": "e6db8dbb-15ae-4e34-8aca-fdf86f5b9ebd",
      "text": "Poroshenko cut short his Davos visit to return to Ukraine amid a 'worsening situation', as reported by multiple outlets.",
      "date": "2015-01-20 00:00:00"
    },
    {
      "id": "c527f6cf-f471-410a-825d-64d88a963398",
      "text": "Students and activists disrupted and booed high‑profile figures at Zurich university events earlier (notably Sepp Blatter at ETH Zurich in November 2014).",
      "date": "2014-11-05 00:00:00"
    },
    {
      "id": "ee5d46b3-019c-4079-a705-d2dfc0d8995b",
      "text": "Protests and demonstrations around the World Economic Forum in Davos (anti‑WEF/anti‑globalisation actions) were occurring and widely reported in mid‑January 2015.",
      "date": "2015-01-18 00:00:00"
    },
    {
      "id": "011dd188-f1c1-4ef7-9cf4-b23255a9d81d",
      "text": "WHO mission on tuberculosis control and human rights in Ukraine",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "ae04373a-93b5-47da-9a0f-0e8036c84fd6",
      "text": "IMF approves a US$17.5 billion Extended Fund Facility for Ukraine",
      "date": "2015-03-11 00:00:00"
    },
    {
      "id": "a31e1259-d292-49ef-94fa-29c7e8cd09db",
      "text": "Euromaidan protests escalate and government change in Kyiv",
      "date": "2014-02-22 00:00:00"
    },
    {
      "id": "e79b0b35-8d39-4282-b94a-f53bee81a959",
      "text": "Recent public casualty statements by Ukrainian leadership (e.g., Zaluzhnyi referenced cumulative losses) created uncertainty about true figures.",
      "date": "2022-08-22 00:00:00"
    },
    {
      "id": "fd77cdad-ac76-4700-a8ca-f00ee60425bd",
      "text": "High-profile extreme-event attribution coverage just before the campaign date: World Weather Attribution/Oxford analysis (published 2 August 2019) concluding the 2019 European heatwave was made far more likely by human-caused climate change.",
      "date": "2019-08-02 00:00:00"
    },
    {
      "id": "e2a21ea9-3308-432d-8ebb-36f2b2454894",
      "text": "Early March 2019 tornado outbreak across the U.S. Southeast (notably March 3, 2019) produced lethal tornadoes and extensive coverage of storm damage.",
      "date": "2019-03-03 00:00:00"
    },
    {
      "id": "646a3db1-5b56-4be1-9ced-855abb1cfc03",
      "text": "Publication/coverage of studies emphasizing that the Medieval Warm Period was not globally synchronous (e.g., Columbia Climate School coverage of regional MWP findings)",
      "date": "2015-12-04 00:00:00"
    },
    {
      "id": "744b28c1-e44c-4d91-afb4-3e9432206ea4",
      "text": "IPCC Fifth Assessment Report (AR5) release, including past‑millennium reconstructions",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "b13b8ba6-a597-4fbb-8b0f-2e3bd1ab8cf9",
      "text": "Longstanding local debate in Lviv about the fate of Soviet-era memorials and periodic proposals to repurpose or relocate elements of the Hill/Monument of Glory (discussion ongoing for years prior to 2017).",
      "date": "None"
    },
    {
      "id": "cd094e65-a841-43b3-9e0d-41d503722dad",
      "text": "Passage and signing of Ukraine's 'decommunization' laws that required removal of communist symbols and monuments.",
      "date": "2015-05-15 00:00:00"
    },
    {
      "id": "bdbc72ed-e397-4bcd-b6eb-2f5ea4b6c477",
      "text": "Lviv City Hall press office statement denying plans to dismantle the monument, noting the site was fenced off because it was in poor condition and that a committee would make recommendations.",
      "date": "2017-07-11 00:00:00"
    },
    {
      "id": "782598c4-3b71-498b-91e6-1b5df6772bd2",
      "text": "Russian airborne assault and fighting at Hostomel (Antonov) Airport",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "bc6770da-14e1-4f86-9e0c-dafc0b7fa65a",
      "text": "Ilovaisk encirclement ('Ilovaisk cauldron') and heavy Ukrainian losses in August 2014",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "ab1b4aca-b869-4d1e-9822-0200cd4f4d27",
      "text": "Authoritative trackers (e.g., New York Times / Johns Hopkins) showed a sustained period of daily new-case counts above 100,000 in early–mid November.",
      "date": "2020-11-12 00:00:00"
    },
    {
      "id": "a5930607-f04e-48b2-b3e8-851792a5f598",
      "text": "IPCC Sixth Assessment Report (Working Group I) release asserting strong human attribution for recent warming",
      "date": "2021-08-09 00:00:00"
    },
    {
      "id": "5a4298c2-30c7-43d1-ad99-2ff20e2ef3f8",
      "text": "Publication and media coverage of studies showing 'global greening' connected to CO2 fertilization (widely reported from 2016 onward)",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "b002bc7e-9203-4656-84b6-0a42fd4eea6d",
      "text": "Japan suspended and recalled Moderna COVID-19 vaccine batches after foreign particles were found (September 2021)",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "90ef5e33-2377-4289-845e-3349a31525bd",
      "text": "FDA approval of JYNNEOS (smallpox and monkeypox vaccine)",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "1fc8ca06-ea64-4a71-96be-945d2e3a2895",
      "text": "NTI published summary/report of the 2021 tabletop exercise",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "2a0a6670-7ba1-4904-9910-0e88353ed5b8",
      "text": "Historical arson attacks and anti-refugee incidents in Germany (e.g., Bautzen fire of Feb 2016)",
      "date": "2016-02-24 00:00:00"
    },
    {
      "id": "0edbfb46-f456-4efb-881f-2b34fc87b18d",
      "text": "Court orders and litigation over giving ivermectin to hospitalized COVID‑19 patients (notably a widely reported Ohio case)",
      "date": "2021-09-07 00:00:00"
    },
    {
      "id": "7abbfcf9-ee39-451c-a75a-35ff181a3d15",
      "text": "Authoritative explanations that FDA does not regulate the practice of medicine / off‑label prescribing (Congressional Research Service and longstanding FDA position, 2021)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "0c91468a-2a3c-435c-a993-912dda8a7cdf",
      "text": "European Union places Vladislav Surkov on sanctions list in response to the Crimea/Ukraine crisis (EU decisions, March 2014).",
      "date": "2014-03-21 00:00:00"
    },
    {
      "id": "9f70852a-2701-4ba9-9d9d-97b130038454",
      "text": "Victoria Nuland's public visits and meetings with Ukrainian leaders and opposition figures in Kyiv (February 2014).",
      "date": "2014-02-07 00:00:00"
    },
    {
      "id": "49e89fad-7de0-4303-8429-105554aaaf25",
      "text": "NATO Wales Summit adopts the Readiness Action Plan and publicly increases reassurance measures for eastern allies (Wales Summit Declaration, September 2014).",
      "date": "2014-09-05 00:00:00"
    },
    {
      "id": "70fab0a5-9570-4e18-aa9b-2a40a0ffb0dd",
      "text": "Minsk II 'Package of measures' signed, setting a ceasefire and political roadmap for Donbas.",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "9c35ac88-ea62-4815-b760-c00c9c418ca3",
      "text": "Self-proclaimed Donetsk and Luhansk 'people's republics' declared independence and maintained de facto control over parts of Donbas.",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "d340a967-11d6-4e32-9f59-5546d3b71998",
      "text": "EU establishes the East StratCom Task Force (EUvsDisinfo) to counter Russian disinformation (and documents active Russian information operations).",
      "date": "2015-09-28 00:00:00"
    },
    {
      "id": "530384a0-da14-4c11-95b2-1d4601ad9ad9",
      "text": "Volodymyr Zelensky stars as a fictional president in the TV series 'Servant of the People' (premiered 2015).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "ab204757-11fb-43a8-aa32-1e0a1b33be3f",
      "text": "UNHCR and humanitarian organizations published operational data and guidance in March 2022 showing how displaced Ukrainians were being registered and assisted across multiple countries (including coordination with Russian Red Cross in Russia).",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "2cceeef1-da92-4d2f-bda6-aacbc8937b8f",
      "text": "Russian Human Rights Commissioner Tatyana Moskalkova publicly denied forced transfers and Russian media cited large numbers of Ukrainians having gone to Russia (statements reported in mid‑April 2022).",
      "date": "2022-04-12 00:00:00"
    },
    {
      "id": "9543425d-8280-44dc-aab9-eeef9487b257",
      "text": "U.S. State Department and other governments maintained high-level 'do not travel' advisories for Ukraine",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "e9c1f3d6-96e3-4d8e-b076-fdbba6676c29",
      "text": "UNHCR published guidance and cautioned about voluntary return amid ongoing safety, protection and infrastructure concerns in 2023",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "f58e959d-deed-43a8-af64-556af3a0477d",
      "text": "Kyiv's mayor reported that a large share of the city's population fled after the Russian invasion",
      "date": "2022-03-10 00:00:00"
    },
    {
      "id": "3f30c01d-d5b9-4759-8745-26f91c87bb64",
      "text": "Widespread Russian strikes damaged Ukraine's energy infrastructure, causing prolonged blackouts in Kyiv",
      "date": "2022-10-27 00:00:00"
    },
    {
      "id": "c56cb11d-788c-4728-87b2-17d8f03e5a3e",
      "text": "University of Turin's publicly available rules on recognition of foreign degrees (procedures for evaluating and recognizing foreign diplomas).",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "4214672a-562c-4d52-ba43-6fa945b92796",
      "text": "Donetsk higher-education institutions continued operations in exile (relocated to central Ukraine) and kept issuing Ukrainian diplomas after 2014.",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "6069bc47-89a4-4c4e-a60c-566e62b21b14",
      "text": "EUvsDisinfo reported that Turin University's Department of Economics had admitted a student from occupied Donbas whose degrees were issued by Donetsk National University before 2014.",
      "date": "2018-05-24 00:00:00"
    },
    {
      "id": "a5a64808-a7c7-4661-9b5f-05ea7b2697be",
      "text": "Documented incidents earlier in the spring where Russian forces impeded or seized humanitarian/evacuation convoys (e.g., capture of drivers and buses at Mangush).",
      "date": "2022-03-23 00:00:00"
    },
    {
      "id": "b1076592-2fd3-4abb-afeb-f82699e4392d",
      "text": "Repeated breakdowns and contested humanitarian corridors and evacuations in Mariupol during March–April 2022, with both sides blaming each other.",
      "date": "None"
    },
    {
      "id": "0274fac9-ff73-42d8-ab6c-f9706fb26bd3",
      "text": "OSCE monitors detained by pro‑Russian separatists (multiple incidents, including Slaviansk/Kramatorsk)",
      "date": "2014-05-30 00:00:00"
    },
    {
      "id": "3e9a99da-f898-444b-a509-71165ab12c8a",
      "text": "OSCE monitoring‑mission vehicles destroyed in Donetsk (apparent arson attack)",
      "date": "2015-08-09 00:00:00"
    },
    {
      "id": "9de7a865-05de-4bfd-8512-7931d7ede270",
      "text": "OSCE SMM reported nearby mortar impacts and SMM assets struck/damaged (examples of SMM being hit by indirect fire)",
      "date": "2015-05-19 00:00:00"
    },
    {
      "id": "85b0b58a-88f4-44f0-9cb5-3b591e53a1e2",
      "text": "Established concerns and reporting about illicit trafficking and unsecured radioactive materials in post‑Soviet states (IAEA Illicit Trafficking work, 1990s onward)",
      "date": "None"
    },
    {
      "id": "6426368d-5503-45b4-825a-3f6508459459",
      "text": "Ukraine relinquished Soviet-era nuclear weapons under the 1994 Budapest Memorandum",
      "date": "1994-12-05 00:00:00"
    },
    {
      "id": "496b698b-bfc6-48ab-b701-a0216bacebd1",
      "text": "ONS (UK) bulletin: 'Deaths involving COVID-19 by vaccination status, England' showing monthly age-standardised mortality rates (ASMRs) by vaccination status (including notes that some ASMRs for vaccinated groups were similar to or higher than unvaccinated in certain months).",
      "date": "2022-07-06 00:00:00"
    },
    {
      "id": "a64f47b0-62d9-4146-8c80-840ec0985236",
      "text": "BBC coverage (Jan 10, 2023) reporting unusually high excess deaths in the UK during 2022 ('Excess deaths in 2022 among worst in 50 years').",
      "date": "2023-01-10 00:00:00"
    },
    {
      "id": "a0e50427-37de-47e1-8628-65a45368f81f",
      "text": "Japan reports and temporary suspension/recall of a Moderna vaccine lot after black/foreign particles were found (late August–early September 2021).",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "fdae4493-7214-4d22-9884-468e8433f272",
      "text": "NOAA releases ERSST version 4 sea-surface temperature dataset (ERSST v4) used in later global surface temperature products",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "7236ad73-10dd-4424-8400-fcca0d46b21c",
      "text": "FDA expanded Emergency Use Authorization for the Pfizer–BioNTech vaccine to adolescents aged 12–15 (May 10, 2021).",
      "date": "2021-05-10 00:00:00"
    },
    {
      "id": "58935218-ac05-49c6-a4ef-438b8716d1fb",
      "text": "CDC issues guidance (May 27, 2021) acknowledging increased reports of myocarditis and pericarditis after mRNA COVID-19 vaccination, particularly in adolescents and young adults.",
      "date": "2021-05-27 00:00:00"
    },
    {
      "id": "f9f3a1dd-044e-4347-853e-d47068e767c4",
      "text": "American Academy of Pediatrics (AAP) and Children's Hospital Association public report (May 20, 2021) summarizing COVID-19 cases and deaths in children.",
      "date": "2021-05-20 00:00:00"
    },
    {
      "id": "4d20f04e-00ff-4651-a852-4ea4214217b3",
      "text": "Assassination of pro‑Russian journalist Oles Buzyna in Kyiv",
      "date": "2015-04-16 00:00:00"
    },
    {
      "id": "692bca93-f602-436a-b0f2-d5cbc808bcc1",
      "text": "Reported vandalism of Holocaust and other memorials in Ukraine (2014 incidents)",
      "date": "2014-04-09 00:00:00"
    },
    {
      "id": "32c704e2-9110-47ed-84c7-df34341bc74e",
      "text": "Widespread toppling/removal of Lenin statues and other Soviet monuments in 2013–2014",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "eaab707c-78cc-4a71-a3a1-6e58581e9572",
      "text": "Publication of the Antarctic Surface Accumulation and Ice Discharge (ASAID) map work/NASA Earth Observatory coverage that reported scientists connecting 3.5 million geographic points to estimate Antarctica's icy edge perimeter at ~53,610 km.",
      "date": "2010-07-23 00:00:00"
    },
    {
      "id": "0fc411dc-0366-4f41-ba26-7fe26283c363",
      "text": "Widespread public misunderstanding of the coastline paradox and map-projection distortions highlighted by reputable outlets (coverage during 2024–early 2025 explaining why complex coastlines can yield large perimeter measurements).",
      "date": "None"
    },
    {
      "id": "8df6167c-43a9-440a-83e3-dfb9c10de779",
      "text": "Previous precedent: Russian missile strikes on Ukraine’s energy infrastructure caused large Moldova blackouts in November 2022",
      "date": "2022-11-23 00:00:00"
    },
    {
      "id": "fa07cd5b-e83f-475f-b9ea-4ba0d373d5e3",
      "text": "Voltage collapse on the 400 kV Isaccea–Vulcanesti–MGRES transmission line that Moldova uses to import electricity",
      "date": "2026-01-31 00:00:00"
    },
    {
      "id": "08fe87ea-bdb1-49c4-ba4a-8da08b598af8",
      "text": "Russian Foreign Minister Sergey Lavrov publicly stated federalization was an important component of resolving the Ukrainian crisis (public remarks end of March 2014).",
      "date": "2014-03-31 00:00:00"
    },
    {
      "id": "44a4cc47-ac51-408f-9d98-3af60f221d5a",
      "text": "Pavel Gubarev proclaimed himself the 'people's governor' of Donetsk and publicly called for a referendum on the region's status (early March 2014).",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "661bc774-cfb7-442b-b04d-b60a9966ae4a",
      "text": "Russia/Gazprom sharply reduced and in places halted natural gas flows to Europe (Nord Stream 1 disruptions) in August 2022.",
      "date": "2022-08-31 00:00:00"
    },
    {
      "id": "fce93629-dc10-4e52-8b7b-bba9217858c3",
      "text": "EU leaders and institutions announced plans in spring 2022 (REPowerEU) to drastically reduce dependence on Russian fossil fuels.",
      "date": "2022-05-24 00:00:00"
    },
    {
      "id": "8f85a016-f869-4492-a3bb-e9764dff12fa",
      "text": "The 7 April 2018 Douma chemical attack (widely reported and later attributed by Western governments to the Syrian government)",
      "date": "2018-04-07 00:00:00"
    },
    {
      "id": "aed65ccc-f1af-425a-893d-9abd19f90a0b",
      "text": "Discovery and widespread publication of photos and videos showing dead civilians in Bucha after Russian forces withdrew",
      "date": "2022-04-02 00:00:00"
    },
    {
      "id": "ea903ec9-a353-49e9-8bfe-6fda508a4947",
      "text": "Zelensky's public appeals for faster, increased military aid from allies (NATO talks/weapons appeals)",
      "date": "2023-01-29 00:00:00"
    },
    {
      "id": "b52a5a04-4c42-47d9-94b7-248dd3212a3a",
      "text": "Turkey's prior military-technical support to Ukraine (notably Bayraktar TB2 drones supplied in 2021–2022)",
      "date": "2022-10-28 00:00:00"
    },
    {
      "id": "5638859b-a4e7-442a-9258-7c016db35b11",
      "text": "February 2023 Türkiye earthquakes — world leaders, including Zelensky, publicly expressed condolences and offered assistance",
      "date": "2023-02-07 00:00:00"
    },
    {
      "id": "628a9231-baea-46d1-935b-0ca2ff01b00d",
      "text": "AMA, APhA and ASHP issued a joint statement (June 23, 2020) noting FDA review and actions regarding hydroxychloroquine and other COVID-19 medications.",
      "date": "2020-06-23 00:00:00"
    },
    {
      "id": "397d33bf-097c-4ee9-99e3-1a1d910daf3f",
      "text": "Regulatory and industry safety reviews of wild yam (Dioscorea villosa) and public-facing summaries cautioning that wild yam extracts have hormonal activity and are not proven to treat fibroids.",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "7b77283b-32ba-4208-84fa-7ab5e7cab570",
      "text": "Early reports of allergic and other adverse reactions after initial COVID-19 vaccine rollouts (for example, two NHS workers had allergic reactions after Pfizer shots in the UK).",
      "date": "2020-12-09 00:00:00"
    },
    {
      "id": "517da9bc-9b77-4f9b-9fdb-7c76ed94c54e",
      "text": "Public reporting that several COVID-19 vaccine candidates used historically derived human fetal cell lines (HEK-293, PER.C6) in development/manufacture.",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "46e40007-007b-4112-bdb6-e0353838f067",
      "text": "UK 'Homes for Ukraine' sponsorship scheme launched, enabling rapid arrival of large numbers of Ukrainian refugees to the UK (scheme launched 14 March 2022).",
      "date": "2022-03-14 00:00:00"
    },
    {
      "id": "bdb28899-4f74-403d-b02b-ea957505918e",
      "text": "Russian leadership publicly framed the invasion as needing to 'denazify' Ukraine (Putin's rhetoric from late February 2022 onward).",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "2f38e888-600f-4e0c-aa5d-aea6ecf44f01",
      "text": "Multiple reported incidents of swastika vandalism and a May 2022 prosecution for carving swastikas in a London shopping centre (Westfield) received local/national coverage.",
      "date": "2022-05-05 00:00:00"
    },
    {
      "id": "6917898b-b050-4e24-b57f-67feaf1c1afe",
      "text": "CDC reinstated recommendation on July 27, 2021 that fully vaccinated people wear masks in public indoor settings in areas of substantial or high transmission (mask guidance change due to Delta).",
      "date": "2021-07-27 00:00:00"
    },
    {
      "id": "b2abf8f5-257b-4d02-9d1a-28829bf1cbb6",
      "text": "Israeli public-health reports in July 2021 showing decreased Pfizer-BioNTech effectiveness against infection with the Delta variant (while remaining strong against severe disease).",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "d8c49565-8be5-4d93-93c4-be6dbc0ff16a",
      "text": "Japan suspended and recalled Moderna vaccine batches in late August–early September 2021 after discovery of foreign (stainless steel/black) particles in some vials.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "f15d0ff0-d9e9-4d3f-b9c1-eb0345438bb9",
      "text": "CDC MMWR report (published May 28, 2021) documenting COVID-19 vaccine 'breakthrough' infections occurring January–April 2021 and announcing a change in CDC surveillance focus.",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "43bd3e11-7f49-4856-aa33-d1602ac373d9",
      "text": "IARC/WHO evaluation classifying formaldehyde as a Group 1 (carcinogenic to humans) agent (IARC working group meeting, 2004)",
      "date": "2004-06-24 00:00:00"
    },
    {
      "id": "b9f18053-5037-47c8-8598-331be2a79964",
      "text": "CDC Vaccine Excipient & Media Summary (Pink Book Appendix B) listing ingredients and substances used in vaccine manufacture (publicly available CDC excipient table)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "40d37e86-1ea3-4247-b129-3142707eb05a",
      "text": "1999 joint statement by the American Academy of Pediatrics and U.S. Public Health Service (reported by CDC) calling for removal of thimerosal from childhood vaccines as a precaution",
      "date": "1999-07-24 00:00:00"
    },
    {
      "id": "5adb0ff7-d9bc-4670-85ce-aad1368b41a7",
      "text": "Pause of high-profile vaccine trials (AstraZeneca paused global trials after an unexplained illness in a participant)",
      "date": "2020-09-09 00:00:00"
    },
    {
      "id": "759c7475-0897-4647-8b0e-031cc9ba6232",
      "text": "Public revelations (2015) that climate contrarian Willie Soon received substantial fossil-fuel industry funding.",
      "date": "2015-02-21 00:00:00"
    },
    {
      "id": "14147b89-0d92-4319-8775-66863cf40aaa",
      "text": "Major publishers (e.g., Springer Nature) publicly stated policies that AI tools cannot be credited as authors (January 2023), sparking debate over AI authorship in science.",
      "date": "2023-01-26 00:00:00"
    },
    {
      "id": "197ea094-6998-46eb-9eb0-c42038338cc9",
      "text": "Iran launched missile strikes on bases housing US forces in Iraq (retaliation)",
      "date": "2020-01-08 00:00:00"
    },
    {
      "id": "aaac4db6-2c1e-41e7-8c9f-d6b353262207",
      "text": "US drone strike killed Iranian General Qasem Soleimani",
      "date": "2020-01-03 00:00:00"
    },
    {
      "id": "4c49be1c-4984-43c9-84ea-20cd6554a9bd",
      "text": "Ukraine International Airlines Flight PS752 was shot down near Tehran, killing all 176 aboard",
      "date": "2020-01-08 00:00:00"
    },
    {
      "id": "aef8d776-73de-4a9a-9ac9-77b9a76a5c9b",
      "text": "UN Office of the High Commissioner for Human Rights (OHCHR) report on children's rights in Ukraine documenting large numbers of children killed, injured, deported and otherwise affected by hostilities",
      "date": "2025-03-21 00:00:00"
    },
    {
      "id": "73b90fd6-25aa-4c74-9c05-806da37bc137",
      "text": "Ukrainian authorities announce \"Contract 18-24\" recruitment drive offering one‑year voluntary contracts with financial incentives for recruits aged 18–24",
      "date": "2025-02-07 00:00:00"
    },
    {
      "id": "efd598c6-13e3-4a3a-ba1d-f2040f478439",
      "text": "Official Kyiv Eurovision preparations publicized large security measures (10,000 law‑enforcement personnel, thousands of cameras, road closures and 'clean‑up' operations).",
      "date": "2017-04-13 00:00:00"
    },
    {
      "id": "4153fc76-dd06-46a7-b833-59462ffcf3c0",
      "text": "Kyiv placed under curfew and residents ordered to shelter/prepare to defend the city",
      "date": "2022-02-25 00:00:00"
    },
    {
      "id": "3eb3429b-5a86-4636-823b-47d12f8e009d",
      "text": "Airborne assault on Hostomel (Antonov) airport with helicopters and paratroopers near Kyiv",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "668ec28e-19b5-4953-b1fb-eb9dd4e4d330",
      "text": "Multiple missile strikes reported on Kyiv and other Ukrainian cities",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "166c481a-983c-434e-ad60-01d7318a666d",
      "text": "Apartment building in Kharkiv shelled; civilian casualties reported (boy killed)",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "14b9ea79-ae03-4f42-a138-9c2ffee5b826",
      "text": "Russian President Vladimir Putin announces a 'special military operation' in Ukraine",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "aa7457aa-e2b7-41e3-a76f-f250452d8ceb",
      "text": "Federal court consolidated more than 140 lawsuits against Merck over the Gardasil HPV vaccine into a multidistrict litigation (MDL No. 3036), bringing sustained media attention to plaintiffs' claims that Gardasil caused serious harms.",
      "date": "2024-03-20 00:00:00"
    },
    {
      "id": "211749eb-0c84-433f-8c5b-67d3c20b7c6d",
      "text": "Japan's Ministry of Health, Labour and Welfare suspended its proactive recommendation for the HPV vaccine in June 2013 (a decision that drastically reduced uptake and has been repeatedly cited in vaccine-safety debates).",
      "date": "2013-06-24 00:00:00"
    },
    {
      "id": "ffa893cc-5751-4cc7-9631-5cb0757e751c",
      "text": "Russian missile strike on Kramatorsk railway station that killed dozens of civilians",
      "date": "2022-04-08 00:00:00"
    },
    {
      "id": "ca6d6bb8-16d5-4838-b68f-17ff29aeff1a",
      "text": "President Volodymyr Zelensky requested an extraordinary parliamentary session on May 21–22, 2019 to amend electoral legislation, producing a heated parliamentary session and partisan exchanges.",
      "date": "2019-05-21 00:00:00"
    },
    {
      "id": "f606eaed-f36b-4ad7-974e-d69792b06e3b",
      "text": "Opposition deputy Alexander Dolzhenkov publicly threatened to seek repeal of laws on decommunization and the language law during the May 22 debate, prompting Parubiy’s defensive remarks.",
      "date": "2019-05-22 00:00:00"
    },
    {
      "id": "6b6ffa0d-1e38-4bae-9088-3abde339c3da",
      "text": "Andriy Parubiy’s May 22, 2019 parliamentary remarks including the line 'You think the smell of revenge is in the air? Smell it! It’s the smell of burning tires.'",
      "date": "2019-05-22 00:00:00"
    },
    {
      "id": "40d1fa1f-1ea6-492f-b43c-71d594b24f86",
      "text": "Kerch Strait incident where Russian forces seized three Ukrainian naval vessels and detained crews",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "160bc68d-b04c-4782-87e2-8818ed161340",
      "text": "Sea Breeze multinational naval and military exercises hosted by Ukraine and NATO partners in the Black Sea (Sea Breeze 2018)",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "15bad102-22bf-4306-9360-1f3c0adbfff3",
      "text": "U.S. approval and delivery of Javelin anti-tank missiles to Ukraine",
      "date": "2017-07-24 00:00:00"
    },
    {
      "id": "60688d2b-1218-4d31-a856-9c2cc98ed3c0",
      "text": "Formation and integration of volunteer units such as the Azov Battalion into Ukraine's forces (2014 onward)",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "a46bf700-8a4f-418d-90fc-003b0bc7228f",
      "text": "UN Human Rights Office report documenting multiple arbitrary arrests, detentions and prosecutions in Russian‑occupied Crimea",
      "date": "2017-09-25 00:00:00"
    },
    {
      "id": "023efd2f-37f3-428a-93b9-9851efee1ab9",
      "text": "Fitch Ratings sovereign rating actions and downgrades around the 2014–2015 crisis (example: Feb 13, 2015 Fitch rating action)",
      "date": "2015-02-13 00:00:00"
    },
    {
      "id": "7e57b3b3-1ccc-4646-9659-c2d94da11186",
      "text": "IMF statement concluding the 2016 Article IV consultation with Ukraine (April 3, 2017)",
      "date": "2017-04-03 00:00:00"
    },
    {
      "id": "da22f955-e91b-407e-93b0-ab51c2c62a96",
      "text": "Iran announced arrests related to the downing and police cracked down on protests over the incident.",
      "date": "2020-01-14 00:00:00"
    },
    {
      "id": "4be45854-769b-4cdf-8d32-7ef709f38bad",
      "text": "Ukraine International Airlines Flight PS752 was shot down shortly after takeoff from Tehran, killing all 176 aboard.",
      "date": "2020-01-08 00:00:00"
    },
    {
      "id": "222e7b43-94bc-469a-9da2-e6c7522401f7",
      "text": "Reporting noted many passengers were Iranian nationals, students and researchers (including academics), and several countries pressed for answers about passenger lists.",
      "date": "2020-01-08 00:00:00"
    },
    {
      "id": "4ff9773a-68ff-4aac-9456-845b766f68d4",
      "text": "EU published COM(2017)235 (12 May 2017) — a strategy to step up the fight against illicit tobacco trade affecting eastern EU borders",
      "date": "2017-05-12 00:00:00"
    },
    {
      "id": "a2e3ca06-1e5b-4d34-80b4-412d59aa3a43",
      "text": "Poland and Ukraine signed a memorandum on cooperation for the Via Carpathia transport corridor (signed Oct 22, 2017) and media reported growing cross‑border freight volumes",
      "date": "2017-10-22 00:00:00"
    },
    {
      "id": "738e1a9a-7001-45f2-bb32-ff4e61d6b48f",
      "text": "Ukraine’s Infrastructure Minister Volodymyr Omelyan publicly discussed bilateral transport permit numbers (citing ~10,000 Polish permits for Ukrainian carriers) in the same period",
      "date": "2017-11-18 00:00:00"
    },
    {
      "id": "8b3f89b9-71a0-4a88-96a2-948392d036cd",
      "text": "Former Ukrainian Transport Minister Yevhen Chervonenko said on ZIK TV thousands of trucks were stuck on Ukraine’s western borders and could not enter Europe",
      "date": "2017-11-18 00:00:00"
    },
    {
      "id": "b0b99fd3-fa74-4103-ba15-cf12e47469ed",
      "text": "Amnesty International press release calling on Ukraine to stop abuses by pro‑Ukrainian volunteer battalions (Aidar, etc.), citing unlawful detentions and summary killings.",
      "date": "2014-09-08 00:00:00"
    },
    {
      "id": "41788b6a-450e-4c17-962d-bd412f1d352f",
      "text": "Office of the High Commissioner for Human Rights (OHCHR) report documenting egregious human‑rights abuses in Donetsk and Luhansk, including killings, abductions and restrictions on movement.",
      "date": "2014-07-15 00:00:00"
    },
    {
      "id": "bd3aba7c-ad6e-427a-a510-dc1e1bd9c7cd",
      "text": "OHCHR/UN press release (2 March 2015) reporting that the death toll in eastern Ukraine had crossed 6,000 and documenting civilian casualties and impediments to people leaving conflict areas.",
      "date": "2015-03-02 00:00:00"
    },
    {
      "id": "06f72312-a33d-446c-bb6e-dc7b4ca210c4",
      "text": "Election of Andrzej Duda as President of Poland (conservative, Law and Justice party) in May 2015",
      "date": "2015-05-25 00:00:00"
    },
    {
      "id": "cfdcf4da-e29e-4722-ac00-8cd76b398f94",
      "text": "Public reporting and leadership statements about slow or delayed Western arms deliveries to Ukraine (widely covered in mid‑September 2024).",
      "date": "2024-09-15 00:00:00"
    },
    {
      "id": "148553e6-d5d9-4816-96b4-c7c115faab4c",
      "text": "Serhii Sternenko's profile as a high‑visibility Ukrainian activist with prior legal controversies and a large social following (making him a frequent target for smears and falsified attributions).",
      "date": "2021-02-23 00:00:00"
    },
    {
      "id": "d1a30a6a-894e-49d5-8382-00a5d409b387",
      "text": "EMA Article‑31 referral and EU-wide review of combined hormonal contraceptives (procedure started Feb 2013; review communicated Nov 21, 2013)",
      "date": "2013-11-21 00:00:00"
    },
    {
      "id": "b1f6ef8c-f80f-4565-a8e8-a1bec3e92ca7",
      "text": "UK Drug Safety Update / MHRA communications and updated patient/prescriber leaflets on CHCs and VTE risk (published March 2014 and accompanying materials)",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "871edd95-2bef-4c86-80bb-e83c188a88cd",
      "text": "European Commission adoption of legally binding decision to update CHC product information (decision adopted 16 January 2014)",
      "date": "2014-01-16 00:00:00"
    },
    {
      "id": "416e955e-2300-409f-9ec1-c4fbafa37d57",
      "text": "1995 UK 'pill scare' — Committee on Safety of Medicines advised that pills containing desogestrel/gestodene were linked to doubled VTE risk",
      "date": "1995-10-24 00:00:00"
    },
    {
      "id": "2be73865-8f17-4c3c-8ff5-59077c2c2638",
      "text": "Large-scale lawsuits and media coverage alleging manufacturers downplayed clot risks from newer contraceptives (Bayer Yaz/Yasmin settlements reported 2012)",
      "date": "2012-10-24 00:00:00"
    },
    {
      "id": "10350d56-fc35-41a1-959b-98a5220ab0e7",
      "text": "Publication of a review summarizing research into engineered/measles-based oncolytic viruses as cancer immunotherapy (\"Measles Virus as an Oncolytic Immunotherapy\", PMC review).",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "3a092639-1cc6-485f-bf1a-d92f6a336b95",
      "text": "Andrei Makarevich performed charity concerts for displaced children in eastern Ukraine (Slov'yansk/Svyatohirsk).",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "8d7aa242-a4fa-4805-bf07-4ab3531b4a46",
      "text": "Makarevich attracted hostility earlier for publicly showing pro‑Ukrainian symbols (attending a Moscow peace march wearing Ukrainian‑coloured ribbons).",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "80946d3c-7fd2-4079-b4a3-88da3b276d60",
      "text": "Prominent pro‑Kremlin politicians publicly denounced Makarevich and called for stripping his state honors.",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "3e4a8be4-4ed0-4553-b03c-128ce3fd4985",
      "text": "Clashes between Polish and Ukrainian football fans at Euro 2016 in Marseille (physical fights and arrests ahead of the Poland–Ukraine match).",
      "date": "2016-06-21 00:00:00"
    },
    {
      "id": "572cbeb6-e025-4c36-a959-9b84f9bac472",
      "text": "Media reporting in 2016 of rising xenophobia and harassment directed at Ukrainians in Poland.",
      "date": "2016-11-24 00:00:00"
    },
    {
      "id": "82615446-c1d3-4c85-8e0f-1e8ede770ad1",
      "text": "Visible growth of far‑right and nationalist street movements and demonstrations in Poland during 2016.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "ad67387f-fc3e-435c-a8bd-5e291653ae0b",
      "text": "Hamas attack on Israel and mass abductions created a large population of hostages and distressed families",
      "date": "2023-10-07 00:00:00"
    },
    {
      "id": "a865c1f1-ff02-4c09-aaf9-384d06d59fbf",
      "text": "Publication of a large South Korean retrospective cohort study in Biomarker Research reporting associations between COVID-19 vaccination and increased one‑year risks for six cancer types",
      "date": "2025-09-26 00:00:00"
    },
    {
      "id": "8b9464e0-9a15-4e61-923e-b378808a14b3",
      "text": "FAO and other UN agencies warned of global food impacts from the Ukraine conflict and launched efforts to save Ukraine's harvest and keep exports flowing",
      "date": "2022-07-05 00:00:00"
    },
    {
      "id": "dec9a639-6063-45f9-91b1-011da9866da1",
      "text": "European Union temporarily lifted import duties / quotas on Ukrainian agricultural products to support Ukraine's economy",
      "date": "2022-06-03 00:00:00"
    },
    {
      "id": "a3403f9f-ba0f-4ee4-82d4-1929b0c86826",
      "text": "Signing of the UN‑brokered Black Sea Grain Initiative (Istanbul) enabling safe maritime export corridor from Ukrainian ports",
      "date": "2022-07-22 00:00:00"
    },
    {
      "id": "641967ed-c666-4b21-9632-a88aaa4fe896",
      "text": "Human rights reports documenting abuses by both separatist forces and Ukrainian government forces (Human Rights Watch / Amnesty reports, 2014–2015)",
      "date": "None"
    },
    {
      "id": "29d024dd-2543-4a8c-97c4-a8b1bbf8dc29",
      "text": "Polls reporting that many Ukrainians characterized the Donbas fighting as an 'intrastate' or internal conflict (KIIS / Democratic Initiatives Foundation, October 2015)",
      "date": "2015-10-09 00:00:00"
    },
    {
      "id": "4a6442f1-c198-4146-b8d8-0bb0b72e9000",
      "text": "Signing of the Minsk II agreements (February 2015)",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "c68c064f-6ac6-46bf-9798-6cc7a03a8b57",
      "text": "Self‑declared independence referendums and proclamations by Donetsk and Luhansk 'people's republics' (May 2014)",
      "date": "2014-05-11 00:00:00"
    },
    {
      "id": "b5fc4724-c9a3-462d-ab84-5bebcfdb6783",
      "text": "WHO published a public timeline of COVID‑19 events (WHO timeline) summarising early December 2019 detection milestones",
      "date": "2020-04-27 00:00:00"
    },
    {
      "id": "52cf9b3e-9f25-43fa-8939-e7866cc8edc6",
      "text": "News reports (May 4–5, 2020) that a French pneumonia sample from December 27, 2019 later tested positive for SARS‑CoV‑2",
      "date": "2020-05-05 00:00:00"
    },
    {
      "id": "1ac986cd-7418-4a77-a69d-a9308b8761cf",
      "text": "European Union launched Permanent Structured Cooperation (PESCO) to deepen EU defence cooperation (formal decision adopted Dec 11, 2017).",
      "date": "2017-12-11 00:00:00"
    },
    {
      "id": "e1ef5d87-f3ec-423c-9813-c9a4921268c1",
      "text": "U.S. imposed tariffs on steel and aluminium (March 2018) and the EU adopted retaliatory measures.",
      "date": "2018-03-08 00:00:00"
    },
    {
      "id": "07477746-79bf-40ea-a2a4-df204c59d1e4",
      "text": "President Trump ordered the withdrawal of U.S. troops from Syria (announced Dec 19, 2018).",
      "date": "2018-12-19 00:00:00"
    },
    {
      "id": "340bee43-d3fa-492a-b0c5-9beef5cdaf32",
      "text": "President Trump publicly berates NATO allies at the Brussels summit, warning the U.S. might 'go it alone' if allies do not meet defense spending targets.",
      "date": "2018-07-12 00:00:00"
    },
    {
      "id": "f20f07e3-7db3-4e45-857e-a44b98c2bb8e",
      "text": "U.S. announced it would withdraw from the Intermediate-Range Nuclear Forces (INF) Treaty (six‑month notice given Feb 2019).",
      "date": "2019-02-02 00:00:00"
    },
    {
      "id": "b293d682-81e8-4ee7-98f5-08d38125f280",
      "text": "Ukrainian carrier Supernova reported to have received permits to operate scheduled Lviv–Prague and Kyiv–Prague routes (announced in media)",
      "date": "2024-10-22 00:00:00"
    },
    {
      "id": "477b8e23-3732-45bb-8214-4be4d59e06f8",
      "text": "European (EASA) Part-TCO authorization for Supernova Airlines announced",
      "date": "2024-10-17 00:00:00"
    },
    {
      "id": "4203c331-94df-4947-baaa-31ca888f30bd",
      "text": "European Parliament / EU analyses and statistics showing significant trade and energy interdependence with Russia (2014–2017 trade data and briefings published in 2017).",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "bcd1fd82-eeae-492b-8e3b-aae60422d657",
      "text": "Campaign and political support in parts of Germany and among some EU businesses for the Nord Stream 2 gas pipeline (prominent coverage and analysis in 2016).",
      "date": "2016-11-24 00:00:00"
    },
    {
      "id": "2b5e3663-84d6-4872-8663-13535c6a2ef9",
      "text": "CDC/ACIP recommend use of the updated (bivalent) COVID-19 boosters",
      "date": "2022-09-01 00:00:00"
    },
    {
      "id": "4fb30839-ae13-419b-b046-54c5b4ab1faa",
      "text": "Russian official and media reaction emphasizing Tillerson's comments as signaling possible U.S. softness",
      "date": "2017-01-12 00:00:00"
    },
    {
      "id": "22e7c561-5c28-435c-a056-a2a7ac35b322",
      "text": "Hungary repeatedly raised public complaints and blocked aspects of Ukraine's Western integration over alleged mistreatment of the Hungarian minority in Zakarpattia, increasing bilateral tensions.",
      "date": "2023-12-24 00:00:00"
    },
    {
      "id": "6e1568f5-503f-41be-af1f-55c802c66507",
      "text": "Reporting and analyses documented both an exodus of ethnic Hungarians from Transcarpathia after the 2022 invasion and cases of ethnic Hungarians voluntarily joining Ukrainian forces or local defense units.",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "9eb46b0c-d447-445d-aef2-1288e56731a2",
      "text": "Ukraine's Security Service (SBU) and Ukrainian authorities reported Russian information‑operations specifically targeting the ethnic Hungarian community in Transcarpathia / Zakarpattia (including spoofed calls and other PSYOPs).",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "49ae5188-a2ca-4673-ae24-883f12ed99e9",
      "text": "Ukraine imposed wartime restrictions and a de facto travel ban preventing most men aged 18–60 from leaving the country after the 2022 full‑scale invasion.",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "66942d3b-11e6-4000-89af-63719adda485",
      "text": "Alfa/Leopolis Jazz Fest was scheduled and ran in late June 2017 (festival dates June 23–27, 2017), contrary to claims of cancellation.",
      "date": "2017-06-23 00:00:00"
    },
    {
      "id": "f57ff950-9e13-483a-bec5-974eb37e4703",
      "text": "Reuters photo/coverage showing volunteers cleaning piles of trash in Lviv in the days before the festival (coverage dated June 21, 2017).",
      "date": "2017-06-21 00:00:00"
    },
    {
      "id": "a2076eeb-7774-4162-8451-feb0f732fdba",
      "text": "CDC MMWR report on large Delta-era outbreak in Provincetown, Massachusetts with many breakthrough infections among fully vaccinated people",
      "date": "2021-08-06 00:00:00"
    },
    {
      "id": "4eed5196-441c-471a-ae3f-d55887c0f063",
      "text": "UK Health Security Agency vaccine surveillance reports showing sharp drops in vaccine effectiveness against symptomatic Omicron infection after two doses",
      "date": "2021-11-18 00:00:00"
    },
    {
      "id": "efe09af4-3d29-4a10-9c20-6c42ab3563f5",
      "text": "Pfizer–BioNTech phase 3 trial press release reporting ~95% efficacy",
      "date": "2020-11-09 00:00:00"
    },
    {
      "id": "630437eb-fd43-4d0f-83bc-76d2f57ecc70",
      "text": "NEJM national Israel study showing measurable waning of BNT162b2 protection over months (Delta wave)",
      "date": "2021-10-27 00:00:00"
    },
    {
      "id": "ea07027f-897a-42f0-af9e-4de7f1333cf6",
      "text": "Pfizer–BioNTech press release reporting markedly reduced two‑dose neutralization of Omicron and restored neutralization after a booster",
      "date": "2021-12-08 00:00:00"
    },
    {
      "id": "c2c81ff6-a163-475a-8383-769d632a3191",
      "text": "Publication of IRENA & IEA-PVPS report projecting up to 78 million tonnes of PV waste by 2050",
      "date": "2016-06-24 00:00:00"
    },
    {
      "id": "9702a8e5-c44d-44a6-be11-b88dfba3d229",
      "text": "NREL analysis and surveys showing low recycling rates (less than ~10% of decommissioned panels recycled in the U.S.)",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "a1a140b4-c1ac-491d-9ae3-3620a0004758",
      "text": "BBC article 'Challenge to stop solar panels becoming a \"waste mountain\"' reporting experts' warnings",
      "date": "2023-06-04 00:00:00"
    },
    {
      "id": "97ee6a53-1aab-4a11-bbc3-1775ff749efb",
      "text": "Right Sector set up roadblocks and staged protests demanding the resignation of Interior Minister Arsen Avakov",
      "date": "2015-07-12 00:00:00"
    },
    {
      "id": "1897c2f6-b5bc-491a-948b-25ea30ab87f9",
      "text": "Prime Minister Yatsenyuk ordered dismissal/replacement of Zakarpattia customs officers and heads in response to the Mukachevo events",
      "date": "2015-07-13 00:00:00"
    },
    {
      "id": "53e5fac3-f3b9-4170-acb1-fa39f2caaa62",
      "text": "Mukachevo shootout between fighters linked to Right Sector and local police",
      "date": "2015-07-11 00:00:00"
    },
    {
      "id": "dbb30e81-3924-4957-9510-c3ca70ff3cec",
      "text": "Interior Minister Arsen Avakov suspended the Mukachevo police chief and launched an inspection of the regional police force",
      "date": "2015-07-13 00:00:00"
    },
    {
      "id": "e930d6e7-85d6-4421-a247-e19e17bfca63",
      "text": "Russian forces seize the Zaporizhzhia nuclear power plant (Europe's largest)",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "e6ac3ba2-6553-40c5-93b0-47155aea88ef",
      "text": "Russian President Vladimir Putin orders Russia's nuclear deterrent forces put on high alert",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "776e7b52-5ed1-4439-9f2d-40f2b49ba7fd",
      "text": "President Zelensky’s public address to the Lowy Institute where he said NATO must 'eliminate the possibility' of Russia using nuclear weapons (speech and Q&A)",
      "date": "2022-10-06 00:00:00"
    },
    {
      "id": "1c08e4c5-9840-441f-9216-d5589e6804b8",
      "text": "Reports of Chechen fighters volunteering in eastern Ukraine (Donbas)",
      "date": "2014-05-31 00:00:00"
    },
    {
      "id": "d4e114a0-6a56-4ebe-9b0f-7f235be968c1",
      "text": "Crimean court bans the Mejlis (representative body of Crimean Tatars) as 'extremist' (April 2016)",
      "date": "2016-04-26 00:00:00"
    },
    {
      "id": "9a26c070-19da-4eb1-83ac-f92c3c2f2535",
      "text": "European Parliament written question citing concerns about ISIS/Islamist sympathizers in territories disputed by Russia and Ukraine (July 2015)",
      "date": "2015-07-27 00:00:00"
    },
    {
      "id": "246072d5-0023-42d5-be4d-192210543c42",
      "text": "Assassination of former Ukrainian parliament speaker Andriy Parubiy in Lviv",
      "date": "2025-08-30 00:00:00"
    },
    {
      "id": "dc5b6b43-1d7f-4cc1-a0c8-5798df242073",
      "text": "Odessa Trade Unions House fire (May 2, 2014) and its contested narratives",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "4e10df47-ecd3-420b-ace6-784d39da51ec",
      "text": "The Federation Council of the Russian Federation approved President Vladimir Putin's request to use Russian armed forces in Ukraine.",
      "date": "2014-03-01 00:00:00"
    },
    {
      "id": "8b1417ae-1c79-4395-bde9-31cc95079fcd",
      "text": "Unmarked armed personnel occupied airports, checkpoints and key sites across Crimea (the so-called 'little green men').",
      "date": "2014-02-27 00:00:00"
    },
    {
      "id": "65ed18a6-46ca-42a4-b659-ffd3e80e398c",
      "text": "Masked gunmen seized the Crimean parliament and other government buildings in Simferopol, raising Russian flags.",
      "date": "2014-02-27 00:00:00"
    },
    {
      "id": "46862e25-4144-4ea1-8438-f36b6c8106e2",
      "text": "Crimean parliament voted to hold a referendum (initially set for 16 March) on joining Russia and announced steps toward joining the Russian Federation.",
      "date": "2014-03-06 00:00:00"
    },
    {
      "id": "6a5ffe53-8ea1-4ce2-b101-76838a82574d",
      "text": "Large, atypical RSV surges in 2022 (U.S. and other countries) produced heightened public anxiety and searches for home remedies during and after the wave.",
      "date": "2022-12-24 00:00:00"
    },
    {
      "id": "83a845fb-f008-4586-97a0-4ebed68224f1",
      "text": "Ukrainian authorities (SBU / MFA) declared some foreign visitors persona non grata and warned of entry bans after delegations visited occupied Crimea (reported March 2017).",
      "date": "2017-03-20 00:00:00"
    },
    {
      "id": "34141a13-a411-4858-8ce0-1aeb316e65b2",
      "text": "INTERPOL issued Red Notices at Ukraine's request for former Ukrainian officials (including Yanukovych and Azarov).",
      "date": "2015-01-12 00:00:00"
    },
    {
      "id": "4f1143e9-8a23-407d-97eb-ba5c9cd9c89d",
      "text": "European parliamentarians and other EU politicians (including MEPs) made unsanctioned visits to Russian-occupied Crimea and to separatist-held Donbas in 2015.",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "2123eb04-aef5-4732-a991-e130cad08ea7",
      "text": "Release of the IPCC Special Report 'Global Warming of 1.5°C' (high‑profile 2018 scientific assessment)",
      "date": "2018-10-08 00:00:00"
    },
    {
      "id": "82382772-6dd8-4efc-ba22-7470418a4a77",
      "text": "CDC updates mask guidance for fully vaccinated people, recommending indoor masking in areas of substantial/high transmission.",
      "date": "2021-07-27 00:00:00"
    },
    {
      "id": "c3a9c214-92d4-48cd-a33c-f2855651a9cc",
      "text": "Public Health England (PHE) monitoring and technical reports in mid‑2021 showing reduced vaccine effectiveness against symptomatic infection with the Delta variant compared with Alpha, while retaining strong protection against severe disease.",
      "date": "None"
    },
    {
      "id": "2824213e-2808-437e-bcd0-947ff4adac18",
      "text": "MMWR report on a large July 2021 outbreak in Barnstable County, Massachusetts found that a high proportion of cases were in fully vaccinated persons (reported in late July).",
      "date": "2021-07-30 00:00:00"
    },
    {
      "id": "ce2f9ef4-b333-407a-8bed-225eac1f4180",
      "text": "FDA issued Guidance for Industry on 'Characterization and Qualification of Cell Substrates and Other Biological Materials Used in the Production of Viral Vaccines' (published March 4, 2010).",
      "date": "2010-03-04 00:00:00"
    },
    {
      "id": "fa2956eb-d0cb-4e35-ae43-0fb364f44bb6",
      "text": "Academic researchers (reported March 2010) detected DNA from porcine circovirus type 1 (PCV1) in batches of the oral rotavirus vaccine Rotarix; WHO and other regulators issued interim statements and convened reviews.",
      "date": "2010-03-24 00:00:00"
    },
    {
      "id": "3308e491-e157-43e0-9b6c-4a9d02687351",
      "text": "Historical contamination of early polio vaccines with simian virus 40 (SV40) used monkey kidney cell cultures; exposure occurred in vaccines administered 1955–1963.",
      "date": "None"
    },
    {
      "id": "1926b8d1-77b0-4125-9064-fd191cec71bf",
      "text": "Presence of Polish pro‑Russia political figures (e.g., Mateusz Piskorski) among 'international observers' who visited Crimea after the 2014 referendum.",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "8f273d19-4c8d-4d81-af8b-347364d3cf78",
      "text": "Bill Gates invested in plant-based and cell-cultured meat companies (e.g., Impossible Foods, Beyond Meat, Memphis Meats/Upside Foods).",
      "date": "2017-08-23 00:00:00"
    },
    {
      "id": "b41bba8e-2c4c-4c7b-84e6-ac57b3efe67c",
      "text": "Gates-funded research on microneedle patches and 'quantum-dot' vaccine markers that could encode vaccination history in skin.",
      "date": "2020-02-24 00:00:00"
    },
    {
      "id": "0895f651-9e7a-4f35-85b9-11d230569161",
      "text": "Development and trials of oral/tablet COVID-19 vaccine candidates (e.g., Vaxart dosing subjects in Phase II trials).",
      "date": "2021-10-26 00:00:00"
    },
    {
      "id": "cecd8282-63f4-4288-a013-3c27da5e1ce6",
      "text": "OHCHR reported lack of access to detainees held by armed groups in Donetsk and Luhansk, identifying numerous detention sites and documenting arbitrary detention",
      "date": "2017-03-13 00:00:00"
    },
    {
      "id": "6c53d5bf-7d7d-48dc-9537-69146547313c",
      "text": "ICRC participated in and confirmed large, complex detainee release/transfers in eastern Ukraine (largest exchange to date in 2017) at the request of the parties",
      "date": "2017-12-12 00:00:00"
    },
    {
      "id": "d7276325-292a-412d-b146-87a0730b45b3",
      "text": "Minsk II agreement (Feb 2015) required 'release and exchange of all hostages and illegally held persons' (principle of 'all for all')",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "6821b41c-0ed3-446b-b813-0315afb69e66",
      "text": "European Parliament / international reporting on Russian restrictions and de facto blockade of shipping access to Ukrainian ports in the Sea of Azov.",
      "date": "2018-10-25 00:00:00"
    },
    {
      "id": "6b1d0896-6534-4772-818d-a3b7f82c5da1",
      "text": "Kerch Strait incident: Russian forces fired on and captured three Ukrainian naval vessels attempting to transit the Kerch Strait.",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "64d6f3c5-199a-4540-9425-eff3a9b82273",
      "text": "Deployment of advanced Russian coastal and air‑defense systems (S-400/Bastion/Bal) to Crimea and surrounding Black Sea region.",
      "date": "2016-08-13 00:00:00"
    },
    {
      "id": "fa1d9e95-860b-4b4f-9fe0-314d79b493c4",
      "text": "IPCC Sixth Assessment Synthesis Report (AR6 SYR) published — clear attribution of recent warming to human activities",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "5f83450c-4831-4805-8e27-b404683bd245",
      "text": "NOAA educational page summarising limits of weather‑forecast skill (noting 5–7 day forecasts are much more reliable than 10+ day forecasts)",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "815d733e-377e-4e24-a508-460979499d47",
      "text": "Publication on multi‑centennial Holocene climate variability in proxy records (peer‑reviewed synthesis)",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "cf9f8c01-fefa-4717-9ec0-abd2ed4eb2cb",
      "text": "Congressional scrutiny and subpoenas over the Karl et al. (2015) NOAA paper (House Science Committee inquiries led by Rep. Lamar Smith in summer–fall 2015).",
      "date": "None"
    },
    {
      "id": "74d88a1b-8f1b-4a10-9f4a-d925b87902c6",
      "text": "IPCC AR5 (Working Group I) reported a reduced rate of surface warming during 1998–2012 compared with the late 20th century, noting variability and shorter-term trends.",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "952a8a66-4769-48c9-a0f2-2a80794fe380",
      "text": "Public vaccine surveillance reports (e.g., UK Health Security Agency vaccine surveillance reports 2022) showing waning vaccine effectiveness against infection and, in some high‑coverage populations, increasing proportions of cases occurring in vaccinated people",
      "date": "2022-09-24 00:00:00"
    },
    {
      "id": "1bd88c13-1b9b-45a7-8a44-855bc33bf360",
      "text": "WHO classification and global reporting of the Omicron (B.1.1.529) variant showing substantial immune escape from prior infection and reducing vaccine neutralisation (press statement and technical brief)",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "520176c7-8c95-47d8-a5f6-2fa9bc33eb5c",
      "text": "CDC confirmation and public communication about rare cases of myocarditis/pericarditis following mRNA COVID-19 vaccination (recognition, safety monitoring and guidance)",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "6687c73a-8126-4a8d-87d3-e6ef4a4a7541",
      "text": "WHO publication and recognition of 'post‑COVID‑19 condition' (long COVID) with a clinical case definition (Delphi consensus)",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "a3da8389-1854-464f-9071-1facf1abd8ae",
      "text": "Regulatory authorisations and public announcements of updated (bivalent) COVID-19 boosters for fall 2022 citing the need to match evolving variants (FDA/other regulators authorization and press releases)",
      "date": "2022-09-24 00:00:00"
    },
    {
      "id": "30b11eff-e7ca-4bee-af73-c2f03f82b017",
      "text": "Transparency International / Global Corruption Barometer findings (2016) documenting pervasive corruption in Ukraine",
      "date": "2016-11-24 00:00:00"
    },
    {
      "id": "e9d4c9ca-1b2f-418e-89f2-0bd5a5ab3b60",
      "text": "World Customs Organization press release on a large heroin seizure in Ukraine (Odessa/Illichivsk), June 2015",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "d229b959-f62a-4326-b165-185f589fa0ec",
      "text": "Polish government/NGO training and support for Ukrainian forces (Poland offered to train Ukrainian military staff)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "59c8ecd3-dcf1-4d46-a641-b8280912e98d",
      "text": "Documented reports of individual Polish nationals killed or wounded while fighting in Donbas",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "76aaf235-16e7-4043-87b9-a037084179e2",
      "text": "NATO's enhanced forward presence and increased multinational troop rotations in Poland (2016)",
      "date": "2016-07-24 00:00:00"
    },
    {
      "id": "a777797a-1eff-4aae-ba9a-393c85e471c6",
      "text": "Contamination reports and temporary suspension of some Moderna vaccine batches in Japan",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "e9b6d363-8833-4dcf-9fb9-f2f319d33e06",
      "text": "Regulatory and public reporting of rare myocarditis/pericarditis cases after mRNA COVID-19 vaccination",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "696c28a3-2f20-4d42-8e0d-62f761eeea35",
      "text": "Media reports in late 2022 highlighting rising non-COVID excess deaths (e.g., increased deaths at home and concerns about NHS pressures)",
      "date": "2022-09-20 00:00:00"
    },
    {
      "id": "7421a086-6509-4f46-82bf-090c02c96be4",
      "text": "2015 transfer of HAARP operations from the U.S. Air Force to the University of Alaska–Fairbanks (publicized as HAARP reopening for civilian research).",
      "date": "2015-08-11 00:00:00"
    },
    {
      "id": "b8889937-ecac-4ac9-bc3b-db5291b944cb",
      "text": "Reporting on the so‑called \"Havana Syndrome\" (2016–2018) and investigations into possible microwave or directed‑energy causes, including a 2018 New York Times piece.",
      "date": "2018-09-01 00:00:00"
    },
    {
      "id": "c6b77d57-513c-48e9-ab99-530e20b9b255",
      "text": "Venezuelan President Hugo Chávez suggested HAARP or a \"tectonic weapon\" was responsible for the 2010 Haiti earthquake.",
      "date": "2010-01-24 00:00:00"
    },
    {
      "id": "2dd36943-0a3d-4022-ae72-3e3e82b508b8",
      "text": "Intense Russian airstrikes and attacks on Zhytomyr region widely reported in international media (creating fear of occupation and evacuation)",
      "date": "2022-03-14 00:00:00"
    },
    {
      "id": "50e9b1a5-58e6-449a-9592-f8df840c444c",
      "text": "IARC/WHO press release classifying processed meat as a Group 1 carcinogen",
      "date": "2015-10-26 00:00:00"
    },
    {
      "id": "224eb8e3-f200-461f-8907-508a2b9b3610",
      "text": "Longstanding public-health/home‑remedy guidance and consumer health sites recommend salt‑water gargles to soothe sore throats (widely available on NHS and similar sites)",
      "date": "None"
    },
    {
      "id": "68fb7d61-8a80-4806-b215-988216fa2da2",
      "text": "Previous French domestic plots / trials over assassination attempts on Macron (far-right militants convicted/trialed)",
      "date": "2023-01-18 00:00:00"
    },
    {
      "id": "ac80497e-d83e-4314-9f0a-5428faff4d10",
      "text": "France announced plans to send long-range SCALP missiles to Ukraine",
      "date": "2024-01-16 00:00:00"
    },
    {
      "id": "83e06432-af9d-49ee-8785-9660b34df3ae",
      "text": "French presidency postpones Macron's planned visit to Kyiv citing security concerns",
      "date": "2024-02-11 00:00:00"
    },
    {
      "id": "a0b81173-c01e-4db3-8d19-28bc14e6c940",
      "text": "IMF approved a large $17.5 billion extended loan programme for Ukraine, making Kyiv dependent on sizeable external financing and programme conditionality.",
      "date": "2015-03-11 00:00:00"
    },
    {
      "id": "303cdd50-f46a-425f-9a12-202c5b188a35",
      "text": "National Bank of Ukraine unexpectedly raised its key policy rate to 17.5% to combat inflation risks and warned that delays with IMF support posed a risk to stability.",
      "date": "2018-07-12 00:00:00"
    },
    {
      "id": "a661cd4d-5ccb-4040-b44c-68d69c09f27c",
      "text": "Government nationalised PrivatBank, Ukraine's largest commercial bank, to protect financial stability after identifying large capital shortfalls at the lender.",
      "date": "2016-12-18 00:00:00"
    },
    {
      "id": "dcf67d9a-523a-4117-a894-d3df96daa21b",
      "text": "The hryvnia plunged sharply in 2014 after the central bank abandoned foreign-currency auctions and the exchange rate was allowed to adjust amid political and security shocks.",
      "date": "2014-02-05 00:00:00"
    },
    {
      "id": "85de426c-4f43-4b35-8b87-06cac94c009b",
      "text": "Ukraine's President signed a package of laws and administrative measures in late 2015 intended to meet benchmarks for EU visa liberalisation.",
      "date": "2015-11-21 00:00:00"
    },
    {
      "id": "1bca1c02-5747-4e14-8c7b-90781e35a9ae",
      "text": "Ukraine announced introduction of new plastic/passport-card style internal passports to be issued from January 2016.",
      "date": "2015-12-15 00:00:00"
    },
    {
      "id": "45e8dbea-ef86-4a3e-b6a7-9ccc36f702a6",
      "text": "Direct air links and other travel ties between Russia and Ukraine were suspended/curtailed in 2015 (e.g., bans on direct flights announced in October 2015).",
      "date": "2015-10-25 00:00:00"
    },
    {
      "id": "eec3301c-6f87-4401-930d-03b7ef07c902",
      "text": "European Commission published its final report/conclusions on Ukraine's readiness for a visa-free regime with the EU (COM(2015)905) and related publicity in mid-December 2015.",
      "date": "2015-12-18 00:00:00"
    },
    {
      "id": "d58e0908-63ef-49a4-a04a-de9c56a52d19",
      "text": "Ukraine's Finance Minister Oleksandr Danyliuk warns Ukraine may forgo hosting due to high costs and urges sober assessment",
      "date": "2016-05-18 00:00:00"
    },
    {
      "id": "124d3e56-edc4-466b-b738-7ed87500a778",
      "text": "Government announces open national selection for host city and says municipalities/investors/donors must share financial risks",
      "date": "2016-05-18 00:00:00"
    },
    {
      "id": "e4f2e2d6-c597-453c-9d79-887992f836c2",
      "text": "Ukraine wins Eurovision 2016 (Jamala) — international expectation that Ukraine must host Eurovision 2017",
      "date": "2016-05-15 00:00:00"
    },
    {
      "id": "c59f8085-e8f1-47e5-9183-a3ddc5d7fe72",
      "text": "White House OSTP releases the Congressionally-Mandated Report on Solar Radiation Modification (SRM) research plan",
      "date": "2023-06-30 00:00:00"
    },
    {
      "id": "160f517a-6e02-4912-8876-ce86f1747260",
      "text": "Mexican government announces a ban on solar geoengineering experiments (SEMARNAT press release)",
      "date": "2023-01-13 00:00:00"
    },
    {
      "id": "4a818227-ff11-402e-a17a-fbc4c82f1188",
      "text": "Israel's booster campaign and reporting in July–August 2021 on reduced effectiveness of two doses vs Delta and need for third dose",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "d77a013e-9d44-4c1a-932a-64582226c64c",
      "text": "CDC reverses earlier guidance and on July 27, 2021 recommends indoor masking for vaccinated people in areas of substantial/high transmission",
      "date": "2021-07-27 00:00:00"
    },
    {
      "id": "64c78ccf-c8c4-4ead-8edb-781fec01ab6f",
      "text": "U.S. federal Order requiring masks on conveyances and at transportation hubs (published in Federal Register, Feb 2021)",
      "date": "2021-02-24 00:00:00"
    },
    {
      "id": "58e8eec0-3b18-4176-8e32-256e25f75ccf",
      "text": "CDC MMWR report on Barnstable County (Provincetown) outbreak showing many vaccine breakthrough infections",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "5969a8a1-4412-4685-bc71-abc76f654bf5",
      "text": "Japan suspended ~1.63 million doses of Moderna vaccine over reports of foreign particles (August 2021)",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "eb813a15-f200-42e5-aaa7-c964a2b141b5",
      "text": "European Medicines Agency (EMA) concluded there was a possible link between AstraZeneca's vaccine and very rare blood clots (April 7, 2021)",
      "date": "2021-04-07 00:00:00"
    },
    {
      "id": "949dcc31-8461-43ae-8be2-e1d0b363bfef",
      "text": "NATO publicly said Viktor Orbán’s planned Moscow trip had been flagged to the alliance in advance.",
      "date": "2024-07-05 00:00:00"
    },
    {
      "id": "a4448971-d689-4aa9-b2a8-e18c28b5e01a",
      "text": "Serbian President Aleksandar Vučić attended Russia’s Victory Day events in Moscow (including presence at May 9 commemorations) and posted images from the trip.",
      "date": "2025-05-09 00:00:00"
    },
    {
      "id": "1d22170c-0274-426b-b23c-8246a6c999a1",
      "text": "Slovak Prime Minister Robert Fico made a surprise visit to Moscow and met with President Vladimir Putin.",
      "date": "2024-12-22 00:00:00"
    },
    {
      "id": "411db0b4-901a-44af-8084-684c94c06f35",
      "text": "Amnesty International briefing calling on Ukrainian authorities to investigate abuses by Aidar and other volunteer battalions operating alongside regular forces",
      "date": "2014-09-08 00:00:00"
    },
    {
      "id": "8653b865-d36c-4dbc-b92c-f6d7d328d961",
      "text": "OSCE Special Monitoring Mission spot report on civilian fatalities and damage after shelling of residential areas in Donetsk",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "2dd99937-465a-40c8-a6d1-1ba80f7b7fff",
      "text": "Assassination of Denis Voronenkov, a Russian defector, who was shot dead in Kyiv",
      "date": "2017-03-23 00:00:00"
    },
    {
      "id": "2d2427a3-25b4-4670-834e-c8c9a8e08566",
      "text": "UN General Assembly adopted a resolution (March 2, 2022) overwhelmingly deploring Russia's aggression and stating it was in violation of the UN Charter.",
      "date": "2022-03-02 00:00:00"
    },
    {
      "id": "7d7620e7-0394-4b49-be2c-d52df53b66de",
      "text": "Russia formally recognized the independence of the Donetsk and Luhansk People's Republics and ordered troop deployments to the regions.",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "508ef568-3b2c-4f93-8997-e4cfbd121e8f",
      "text": "President Vladimir Putin announced a 'special military operation' in Ukraine, describing aims like 'demilitarisation' and protection of people in Donbas.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "6239eff8-9991-47ad-9ee9-6bc9fa41b6eb",
      "text": "Announcements that Ukraine would open additional consulates in Poland to assist large numbers of Ukrainian citizens/refugees.",
      "date": "2022-05-24 00:00:00"
    },
    {
      "id": "0b3ba769-29b9-4fac-ba68-f45045bf2631",
      "text": "Polish President Andrzej Duda visited Kyiv and addressed Ukraine's parliament, emphasizing deep political solidarity and saying only Ukraine should decide its future (public statements of unity).",
      "date": "2022-05-22 00:00:00"
    },
    {
      "id": "760b1750-990f-45c0-9982-41b2b2e88cad",
      "text": "Earlier Russian security/intelligence figures publicly alleged Polish preparations to annex parts of western Ukraine (remarks by Russian officials reported Nov 30, 2021 onward).",
      "date": "2021-11-30 00:00:00"
    },
    {
      "id": "5969d7ad-90fb-4499-bbf5-9843fb61ef4d",
      "text": "Pro‑Russian activists in Kharkiv occupied the regional administration and declared a short‑lived 'Kharkiv People's Republic'.",
      "date": "2014-04-07 00:00:00"
    },
    {
      "id": "6ff8e77e-ba6f-462b-a50c-91dc2a48055b",
      "text": "Deadly clashes in Odesa on 2 May 2014, culminating in a Trade Unions House fire with dozens killed.",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "33b7cce7-6173-4e38-aa9d-73da5ad3355f",
      "text": "Parliamentary moves in Feb 2014 to repeal the 2012 'regional language' law and intense debate over language rights.",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "3fdc70af-ac57-4ada-b88e-beebc38d0f90",
      "text": "Widespread pro‑Russian 'anti‑Maidan' protests and occupations across eastern and southern Ukraine (including demonstrations in Mykolaiv) in March–April 2014.",
      "date": "None"
    },
    {
      "id": "9535fc4f-b8d2-4d71-99c2-51c24b82dd25",
      "text": "May 2014 'referendums' in parts of Donetsk and Luhansk and subsequent Russian recognition of separatist results.",
      "date": "2014-05-11 00:00:00"
    },
    {
      "id": "ac8cea3c-51b4-4003-bc71-dc8e7da0cc9e",
      "text": "Mass drone attacks and reported strikes on Kursk region (fires, evacuations)",
      "date": "2022-04-15 00:00:00"
    },
    {
      "id": "0b6ab1bc-2c8c-43f5-9de1-58ee61492950",
      "text": "Tymoshenko proposes creation of an 'operative headquarters' of defense and military specialists to respond to Russian aggression",
      "date": "2014-03-21 00:00:00"
    },
    {
      "id": "a2d53ef1-9deb-433a-bcf9-59077120797c",
      "text": "A draft resolution to dismiss Prime Minister Yatsenyuk is registered in the Verkhovna Rada (parliament) after coalition tensions",
      "date": "2016-02-22 00:00:00"
    },
    {
      "id": "bc1bbdf3-ee43-42da-a74c-f41e1bb52a7b",
      "text": "Leader of Batkivshchyna (Yulia Tymoshenko) announces her party is quitting Ukraine’s ruling coalition",
      "date": "2016-02-17 00:00:00"
    },
    {
      "id": "2aac0bf8-5dda-4fc1-8da7-cdae83559eaa",
      "text": "Parliament holds and fails to pass a no‑confidence motion against Prime Minister Arseniy Yatsenyuk, deepening government crisis",
      "date": "2016-02-16 00:00:00"
    },
    {
      "id": "0ee0eddc-d7aa-4f78-aae9-6008e205e5c4",
      "text": "National Snow and Ice Data Center (NSIDC) satellite record: Antarctic sea ice reached a daily/seasonal maximum record (20.11 million km²) on 22 September 2014.",
      "date": "2014-09-22 00:00:00"
    },
    {
      "id": "262af7ff-dfe7-464a-b640-3f6df9d3723b",
      "text": "Peer-reviewed synthesis and high-profile press coverage showing Antarctic land-ice (ice sheet) mass loss accelerated in recent decades (IMBIE / Nature analysis publicized June 2018).",
      "date": "2018-06-14 00:00:00"
    },
    {
      "id": "a77f5498-680a-46a4-8c8a-659c9ad02c00",
      "text": "Research identifying the Southern Annular Mode (SAM), ozone‑hole effects, and wind-driven ocean processes as major drivers of Antarctic sea-ice variability (peer-reviewed work and reviews, mid-2010s).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "04f22358-3b13-4ad6-bbda-ad0691b60927",
      "text": "Amnesty International / IBGDH report documenting human-rights abuses and environmental harm linked to cobalt mining in the Democratic Republic of Congo.",
      "date": "2024-01-22 00:00:00"
    },
    {
      "id": "f24b52b9-187c-4eec-8711-93153d4d2fee",
      "text": "AP and international reporting on environmental concerns around large nickel/nickel-processing projects for EV batteries in Indonesia (coverage of environmental NGO warnings about mining/processing impacts).",
      "date": "2024-07-24 00:00:00"
    },
    {
      "id": "2843540f-04ab-4329-b579-f43852502201",
      "text": "Major media coverage summarising life‑cycle analyses that show EV battery manufacture can be carbon‑intensive (New York Times feature on EV battery emissions).",
      "date": "2024-01-10 00:00:00"
    },
    {
      "id": "7e546993-ae27-482d-9f03-1b53ca0e72db",
      "text": "IEA Electricity Mid‑Year Update 2024 noting faster global electricity demand growth and a temporary plateau in power‑sector emissions in 2024.",
      "date": "2024-07-24 00:00:00"
    },
    {
      "id": "b6069ba0-2a14-45d6-b5a3-a9991a32bcd8",
      "text": "IPCC Fifth Assessment Report (AR5) release documenting observed increases in sea‑level rise rate and attributing recent changes largely to human influence",
      "date": "2013-09-27 00:00:00"
    },
    {
      "id": "87f67770-7faf-4358-9b25-7f35afac9ecb",
      "text": "NOAA / national tide‑gauge and satellite datasets made public (NOAA sea level trends pages and graphics widely cited in media, 2013–2016)",
      "date": "2016-06-24 00:00:00"
    },
    {
      "id": "2e3dcc2e-b0aa-4f90-82b8-edb47f445bdf",
      "text": "Visa‑free travel for Ukrainian citizens to the Schengen area came into effect",
      "date": "2017-06-11 00:00:00"
    },
    {
      "id": "927daa80-8d17-4253-a012-2b0496609a1f",
      "text": "Launch of the European Union Advisory Mission (EUAM) to Ukraine (civilian security reform)",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "2dda5801-f3e2-4728-9ede-9738720b171d",
      "text": "Signing of the EU–Ukraine Association Agreement (including Justice, Freedom and Security provisions)",
      "date": "2014-06-27 00:00:00"
    },
    {
      "id": "69a5cfbd-e0c9-413a-947b-94501669f10a",
      "text": "2008 EFSA scientific opinion sets a tolerable weekly intake for aluminium and warns dietary exposure may exceed it",
      "date": "2008-07-15 00:00:00"
    },
    {
      "id": "b81d08a2-2cb2-4ded-a06d-29e265a6d632",
      "text": "State-level restaurant COVID‑19 prevention checklist (published Aug 14, 2020) that included the specific line about inverted face shields for front‑of‑house staff.",
      "date": "2020-08-14 00:00:00"
    },
    {
      "id": "5e70da93-c4f2-4f6b-9b2a-9f4c35177f2a",
      "text": "Passage and implementation of laws and measures recognizing certain WWII-era Ukrainian nationalist formations (e.g., granting veteran status to surviving members of the Ukrainian Insurgent Army in 2019) and debates about nationalist memory.",
      "date": "2019-03-26 00:00:00"
    },
    {
      "id": "4f9fbad5-3926-4330-9231-602c807d9d2e",
      "text": "Earlier controversy over proposals to 'universalize' the Babi Yar memorial (design competition and wording), which Jewish groups and historians publicly criticized as potentially downplaying the site's Holocaust significance.",
      "date": "2016-02-08 00:00:00"
    },
    {
      "id": "92f66f72-43b4-497a-9e25-a38242dd5f57",
      "text": "Decommunization laws and large-scale removal/renaming of Soviet-era monuments and symbols (2015) that shifted public commemorations and provoked international debate over historical memory in Ukraine.",
      "date": "2015-04-13 00:00:00"
    },
    {
      "id": "169afb32-d558-4121-85b8-678d1f854a12",
      "text": "NIA-AA (National Institute on Aging–Alzheimer's Association) publishes revised diagnostic framework recognizing preclinical stages of Alzheimer's disease",
      "date": "2011-03-24 00:00:00"
    },
    {
      "id": "abe79f6a-6008-4d68-8b84-c8dd5a00e893",
      "text": "OSCE Special Monitoring Mission spot reports of repeated shelling incidents in Donetsk city (late January 2015)",
      "date": "2015-01-31 00:00:00"
    },
    {
      "id": "47955cc0-e7b0-4d67-90f8-bf03cce5c3ad",
      "text": "Amnesty International briefing documenting summary/extrajudicial killings in eastern Ukraine",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "686cbbb5-3b5e-483b-bc76-96a077264b04",
      "text": "Shelling of Mariupol market and residential areas, killing dozens of civilians",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "bc31032f-4bbc-481c-82b3-4468226d167e",
      "text": "Reports documented Ukrainian policemen and small military units in eastern Ukraine siding with or defecting to pro-Russian separatists during the spring 2014 unrest.",
      "date": "2014-04-16 00:00:00"
    },
    {
      "id": "c2be8edd-44a2-4024-b0f0-bac5f6a20d1f",
      "text": "Pro‑Russian separatists shot down a Ukrainian military helicopter in late May 2014 and widely publicized battlefield successes and captures.",
      "date": "2014-05-29 00:00:00"
    },
    {
      "id": "ee1c0bf2-b738-419c-bb84-dd8840a8d165",
      "text": "ISUOG/other professional statements discouraging non‑diagnostic/'keepsake' ultrasound use (position on non‑diagnostic ultrasound)",
      "date": "2020-04-08 00:00:00"
    },
    {
      "id": "809ebb4c-3f56-4172-af62-1fc98346939d",
      "text": "Small clinical study reporting increased apoptosis in human chorionic villus cells after transvaginal ultrasound exposure",
      "date": "2015-12-29 00:00:00"
    },
    {
      "id": "d9deaf4c-cb27-4ca9-b33c-ee26766559df",
      "text": "Reports that politicians and foreign diplomats joined or publicly supported Kyiv Pride 2019",
      "date": "2019-06-23 00:00:00"
    },
    {
      "id": "e70b85f7-dbf0-4789-b87e-40b9be1f108a",
      "text": "Eurovision Song Contest hosted in Kyiv with 'Celebrate Diversity' messaging (Eurovision 2017)",
      "date": "2017-05-11 00:00:00"
    },
    {
      "id": "78dd797c-54e9-4f5a-a617-5c04890789c2",
      "text": "Kharkiv region introduced scheduled/rolling electricity restrictions (blackout schedules) for large numbers of consumers after infrastructure damage.",
      "date": "2024-03-24 00:00:00"
    },
    {
      "id": "9641230b-18d7-4122-9fbb-ad268a1ededd",
      "text": "Ukrenergo announced plans to export a record volume of electricity (planned 13,264 MWh) to neighboring EU countries on March 4, 2024.",
      "date": "2024-03-04 00:00:00"
    },
    {
      "id": "2296956b-5cc1-4ebe-b1da-37bf012fbce7",
      "text": "Russian missile/drone strikes on Kharkiv energy infrastructure knocked out power across the city.",
      "date": "2024-03-23 00:00:00"
    },
    {
      "id": "8ee72d39-4d72-44c4-980c-975cb4158fdd",
      "text": "Official public messaging (e.g., Ukrainian energy minister and Ukrenergo statements) emphasizing that exports occur only when domestic supply is sufficient and that domestic priority is maintained.",
      "date": "2023-04-11 00:00:00"
    },
    {
      "id": "e1bd328a-fc69-4d68-98f7-b98c02516111",
      "text": "National Weather Service offices issued multiple Flash Flood Warnings and at least one Flash Flood Emergency for the Guadalupe River corridor (noting automated gauges and forecasts indicated a large, deadly flood wave).",
      "date": "2025-07-05 00:00:00"
    },
    {
      "id": "6fcc605f-4d96-49ba-a217-c52dcb746b17",
      "text": "Reports of foreign/black particles found in some Moderna vials in Japan led to temporary suspension/recall of batches (September 2021).",
      "date": "2021-09-17 00:00:00"
    },
    {
      "id": "daa821fd-4236-4099-99dd-b7d11d6b3c21",
      "text": "Publication of Israeli population-based analyses documenting cases of myocarditis after BNT162b2 (Pfizer–BioNTech) vaccination (peer‑reviewed NEJM report).",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "1f08bcd4-2a1d-4977-b630-3d154862b9ea",
      "text": "U.S. FDA and other regulators moved in 2016–2018 to restrict or review certain antiseptic/antimicrobial ingredients (e.g., FDA final rule on triclosan and other antiseptic ingredients in consumer wash products in Sept 2016).",
      "date": "2016-09-24 00:00:00"
    },
    {
      "id": "7fb40a00-2db2-4859-bcb8-efde1a71fcd3",
      "text": "Ukraine’s State Service for Drug Control recalled 18 products manufactured by the Bioorganic Chemistry Institute’s experimental plant (licensing violations reported).",
      "date": "2019-03-24 00:00:00"
    },
    {
      "id": "c186eca9-cb1d-40c3-8028-d9f201e6a3e2",
      "text": "Public controversy and intense debate around Suprun’s health‑care reforms (wide press and academic coverage, including critical and supportive pieces in 2017–2018).",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "21cd4a11-f1ba-46ec-a6dc-887af328374c",
      "text": "FDA expanded Emergency Use Authorization for the Pfizer–BioNTech COVID-19 vaccine to adolescents aged 12–15.",
      "date": "2021-05-10 00:00:00"
    },
    {
      "id": "2fb180ca-ccca-473d-8d00-71aae8a614b0",
      "text": "Discovery of foreign (stainless steel) particles in some Moderna vaccine vials in Japan led to temporary lot suspensions and recalls.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "da5bdb7e-c330-4097-95b5-1c0cdf432346",
      "text": "Public reports and CDC/ACIP review of rare myocarditis/pericarditis cases occurring after mRNA vaccination in adolescents and young adults.",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "1de7f983-9b61-4d4d-a604-7ae975daa70a",
      "text": "The Orthodox Church of Ukraine and other Ukrainian church bodies publicly reiterated they do not endorse Halloween celebrations (OCU posted an explanatory statement on its official Facebook page on the eve of Halloween).",
      "date": "2023-10-30 00:00:00"
    },
    {
      "id": "dac0ff89-f538-4798-8227-cd94c172c6b7",
      "text": "WHO and national agencies adopted/issued interim coding guidance and the emergency ICD-10 code (U07.1) for COVID-19 to standardize mortality reporting in Spring 2020.",
      "date": "2020-04-20 00:00:00"
    },
    {
      "id": "70beb357-6a2a-4e2e-93fd-f7fd7bfede7a",
      "text": "Local jurisdictions (notably New York City) added 'probable' COVID-19 deaths to counts in April 2020, producing sudden, large increases in reported death totals.",
      "date": "2020-04-14 00:00:00"
    },
    {
      "id": "2619669f-b128-4efa-8cc9-544630bf09b8",
      "text": "Launch of the EU External Investment Plan (EIP) / European Fund for Sustainable Development",
      "date": "2017-09-24 00:00:00"
    },
    {
      "id": "1946fa2c-944a-4cb0-8bb6-4f8595248750",
      "text": "EU–Turkey migration statement and related migration-management deals",
      "date": "2016-03-18 00:00:00"
    },
    {
      "id": "814b1bb7-0051-487e-ae27-1276aa74b620",
      "text": "Establishment and deployment of EU military training missions in the Sahel (EUTM Mali)",
      "date": "2013-02-18 00:00:00"
    },
    {
      "id": "1c362657-65ac-483d-b15c-54a082028700",
      "text": "UK Health Security Agency technical briefing reporting substantially reduced vaccine effectiveness against symptomatic Omicron (Technical Briefing, Dec 31, 2021).",
      "date": "2021-12-31 00:00:00"
    },
    {
      "id": "843a68e2-a58f-4338-b608-d0b676ff0f44",
      "text": "Mainstream news coverage summarising Danish results and the impact of boosters (e.g., Reuters coverage, Dec 22, 2021).",
      "date": "2021-12-22 00:00:00"
    },
    {
      "id": "1f642949-2156-4f56-b000-f294eb9b083d",
      "text": "Poroshenko publicly sought NATO/allied military cooperation and repeatedly called for allied support at NATO meetings (joint press conference at NATO Headquarters).",
      "date": "2016-07-09 00:00:00"
    },
    {
      "id": "ea0b0740-6fca-4192-a6bd-8b7c7e497256",
      "text": "Visible NATO exercises and increased allied air policing on NATO’s eastern flank (e.g., NATO and partner air forces training over the Baltic Sea, April 21, 2016).",
      "date": "2016-04-21 00:00:00"
    },
    {
      "id": "f23e3f2b-f8a9-4d5a-b9d1-4e6e721675c4",
      "text": "Frontiers in Microbiology review highlighting mechanisms and clinical interest in manuka honey's antibacterial properties.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "a9eb3402-7303-4e26-985e-bfb6e2b7be5c",
      "text": "FDA approval of Flucelvax Quadrivalent (cell‑based quadrivalent influenza vaccine) and release of package/clinical documents mentioning MDCK cells",
      "date": "2016-05-24 00:00:00"
    },
    {
      "id": "3ea68c64-9773-43d9-b4c2-7c341b643338",
      "text": "Russian forces seized and occupied the Kakhovka (Nova Kakhovka) Hydroelectric Power Plant; satellite imagery showed Russian troops and equipment at the facility.",
      "date": "2022-02-26 00:00:00"
    },
    {
      "id": "f25fde5f-d782-4e1d-a20a-3752b8c3828e",
      "text": "The Kakhovka HPP and Nova Kakhovka were repeatedly struck and reported damaged during summer 2022 (including reported HIMARS strikes on July 11, 2022).",
      "date": "2022-07-11 00:00:00"
    },
    {
      "id": "356d7c96-6a41-41d1-9ef7-86159595457f",
      "text": "Arson and vandalism of mobile phone masts reported in the UK",
      "date": "2020-04-04 00:00:00"
    },
    {
      "id": "9f3650f7-0c90-47bb-af37-8f56e9051440",
      "text": "Russian drone strike destroyed the Roman Shukhevych (UPA) Museum on the outskirts of Lviv.",
      "date": "2024-01-01 00:00:00"
    },
    {
      "id": "28f26c81-8a2a-42ab-9758-c215f76bbf76",
      "text": "Widespread reporting since 2022 documented Russian forces looting and removing artifacts from Ukrainian museums (establishing a precedent of cultural theft and illicit sales).",
      "date": "2022-10-24 00:00:00"
    },
    {
      "id": "178ae6f4-e2fb-4589-8996-268c104878a0",
      "text": "Implementation of the 2004 education reform increasing Latvian-language instruction in minority schools (the '60/40' reform)",
      "date": "2004-09-24 00:00:00"
    },
    {
      "id": "716f9129-429d-4988-894a-cd8a8d7da4ab",
      "text": "2012 constitutional referendum on making Russian a second official language, which was decisively rejected (18 February 2012)",
      "date": "2012-02-18 00:00:00"
    },
    {
      "id": "f9fba1bc-a280-42e9-9fad-8c755abff63c",
      "text": "A 2022 edition of 11th‑grade history outline maps was published by Kartohrafiya (ISBN 978-966-946-460-6), a commonly used educational map source in Ukraine.",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "5da27d33-a165-42f5-9ec2-6d118ebb37f9",
      "text": "Precedent of flights from occupied Crimea to third countries (despite sanctions) documented in prior years (examples 2016–2018), showing routes and carriers operating non‑Ukrainian international services.",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "08515554-be3a-4ebe-a6df-471d24dee1cc",
      "text": "Russian carrier Ikar (Pegas Fly) reported/planned to launch flights linking Yerevan and Simferopol (Crimea).",
      "date": "2019-12-18 00:00:00"
    },
    {
      "id": "5b4121b9-67b7-407d-86b8-6053c136b87d",
      "text": "Major cancer-care organizations publish warnings that there is no reliable clinical evidence soursop (graviola) cures cancer and note potential harms",
      "date": "2017-07-24 00:00:00"
    },
    {
      "id": "074ea38c-520c-4e9a-9ef5-c4ca7b784287",
      "text": "Peer-reviewed isolation and characterization of annonaceous acetogenins from Graviola showing potent in vitro anti-proliferative activity against human cancer cell lines",
      "date": "2019-12-03 00:00:00"
    },
    {
      "id": "d791cfa0-d2a4-464f-ac69-75d53f3d4c82",
      "text": "State‑level legislative changes and debates in 2024 expanding legality or easing restrictions on raw‑milk sales (e.g., new limited sales allowances in some states)",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "fde86755-d0a9-411a-af01-148da957be9e",
      "text": "Large disruptions and later rebounds in cancer screening and diagnoses during the COVID‑19 pandemic became widely reported (fewer screenings in 2020 then partial catch-up), creating confusing temporal patterns in cancer incidence data.",
      "date": "2023-09-27 00:00:00"
    },
    {
      "id": "ae975e0a-9f37-43c4-b84a-500496a03681",
      "text": "OSCE Special Monitoring Mission (SMM) spot reports documenting civilian casualties and intensified fighting in Donetsk and Luhansk in October 2014.",
      "date": "2014-10-14 00:00:00"
    },
    {
      "id": "189499fe-3131-447b-81e9-4435db4e85e3",
      "text": "UN Office of the High Commissioner for Human Rights (OHCHR) report on the human rights situation in the context of the anti‑terrorist operation (ATO) documenting detentions, abuses and civilian harm (July 2014).",
      "date": "2014-07-15 00:00:00"
    },
    {
      "id": "4a4972c4-ebf7-4cb8-b0ee-1b43206b1ab9",
      "text": "President Petro Poroshenko and other Ukrainian officials publicly described pro‑Russian fighters as 'terrorists' in mid‑2014 interviews and statements.",
      "date": "2014-07-21 00:00:00"
    },
    {
      "id": "478dbf82-e1cb-4626-aad1-f4c4b525dc5d",
      "text": "High‑profile activity and imagery of far‑right Ukrainian groups (e.g., Svoboda torchlit march, January 2014) widely reported in international media.",
      "date": "2014-01-01 00:00:00"
    },
    {
      "id": "c06642ac-1f2d-495f-bf42-2bc2972cbcb7",
      "text": "Russia blocked a Western-backed UN Security Council statement condemning the shelling of Mariupol.",
      "date": "2015-01-25 00:00:00"
    },
    {
      "id": "a5ad7c31-c1a4-480a-8ab4-6e28f34870f9",
      "text": "UN Secretary-General Ban Ki-moon publicly condemned the rocket attack on Mariupol in a UN spokesperson/secretariat statement.",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "296b6c7f-df17-4502-8c74-8f18015dfa39",
      "text": "OSCE Special Monitoring Mission (SMM) spot report and multiple media outlets reported heavy MLRS/rocket shelling in Mariupol with dozens of civilian casualties.",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "e1934800-b8b0-4559-889b-9c4513fb2b1b",
      "text": "CDC MMWR report on allergic reactions (including anaphylaxis) after first doses of Pfizer‑BioNTech vaccine (covering Dec 14–23, 2020)",
      "date": "2021-01-06 00:00:00"
    },
    {
      "id": "58a96d05-0b9c-4ddb-ad56-31b85def6114",
      "text": "FDA VRBPAC briefing and safety review documents for Moderna COVID-19 vaccine (presented to advisory committee)",
      "date": "2020-12-17 00:00:00"
    },
    {
      "id": "000f23a7-2222-41ea-8898-e7d063735ef4",
      "text": "Publication of Moderna (mRNA-1273) Phase 3 (COVE) trial reporting safety/reactogenicity data in NEJM",
      "date": "2020-12-30 00:00:00"
    },
    {
      "id": "da7cdfd4-e436-4cad-bf96-fd39255cf969",
      "text": "WHO/UNICEF reporting on Sudan circulating vaccine‑derived poliovirus type 2 (cVDPV2) outbreak (declared Aug 2020; press coverage Sept 2020)",
      "date": "2020-09-08 00:00:00"
    },
    {
      "id": "a9d50388-6ca1-489b-898c-03077d503b07",
      "text": "CFSRE (Center for Forensic Science Research & Education) issues Q2 2024 Trend Report documenting rising harms, emergency admissions and deaths linked to synthetic cannabinoids (K2/Spice), and distinguishes these products from plant cannabis.",
      "date": "None"
    },
    {
      "id": "52ea576d-ff1d-436f-859a-e066258b724d",
      "text": "Peer‑reviewed study (Journal of Cannabis Research) publishes results (April 6, 2024) reporting that a history of cannabis use was associated with lower in‑hospital mortality among hospitalized COVID‑19 patients in a large national inpatient sample.",
      "date": "2024-04-06 00:00:00"
    },
    {
      "id": "785991ad-3948-4077-af87-943e2698d44d",
      "text": "White House issues 'Statement from President Biden on Marijuana Reform' (October 6, 2022) and subsequent federal/state-level policy shifts and public discussions around decriminalization/rescheduling continue through 2023–2024.",
      "date": "2022-10-06 00:00:00"
    },
    {
      "id": "d668f105-1438-4350-8827-74d6bed57b76",
      "text": "Systematic reviews and clinical‑trial summaries (e.g., Antioxidants 2018; other reviews and NIH/NCI summaries) documenting safety, mixed/limited efficacy signals, and ongoing early‑phase trials of high‑dose IV ascorbate in cancer therapy.",
      "date": "2018-07-12 00:00:00"
    },
    {
      "id": "280cc982-fb5f-405a-abd0-135f9de11b7c",
      "text": "Longstanding promotion and clinical use of IV vitamin C by integrative clinics (e.g., Riordan Clinic) including published protocols and patient‑case material used to market IVC as an adjunctive cancer therapy.",
      "date": "2020-09-24 00:00:00"
    },
    {
      "id": "e0131c57-979b-4eb6-b1b9-b63edb856c71",
      "text": "Emergency use authorizations and publication of phase‑3 results for mRNA COVID‑19 vaccines (Pfizer/BioNTech and Moderna) in late 2020",
      "date": "2020-12-11 00:00:00"
    },
    {
      "id": "3f2c5b38-deba-475d-9cd7-11385395e7d5",
      "text": "WHO guidance advising that ivermectin should only be used to treat COVID‑19 within clinical trials",
      "date": "2021-03-31 00:00:00"
    },
    {
      "id": "137c84f5-23db-45e6-bf92-1ad74275d3e1",
      "text": "WHO request and international attention on China’s late‑2023 surge in pediatric respiratory illnesses",
      "date": "2023-11-24 00:00:00"
    },
    {
      "id": "fa0db7ed-df89-44b6-a5c6-2ada5165a15e",
      "text": "High‑profile reporting in 2023 about widespread chemical contaminants in U.S. tap water (PFAS / 'forever chemicals')",
      "date": "2023-07-06 00:00:00"
    },
    {
      "id": "1feb038d-92fc-4cd4-b25c-1c1a29e47dd3",
      "text": "August 2021 discovery of foreign particles in some Moderna COVID‑19 vaccine vials in Japan (batches paused)",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "3d6a2ff0-9932-4048-b809-b1b21ab52912",
      "text": "Event 201 pandemic tabletop exercise (Johns Hopkins/WEF/Bill & Melinda Gates Foundation)",
      "date": "2019-10-18 00:00:00"
    },
    {
      "id": "b05052a3-07ad-456f-8def-ea0241666317",
      "text": "Arrest and conviction of Ukrainian filmmaker Oleg Sentsov on terrorism charges (Crimea cases)",
      "date": "2015-08-24 00:00:00"
    },
    {
      "id": "9dc7cfa4-60c3-46e9-93bd-b1dcaab98aee",
      "text": "UAE action and reporting around Russian-linked assets and banks (examples: cancellation of MTS Bank licence)",
      "date": "2023-03-31 00:00:00"
    },
    {
      "id": "4aac8468-0db8-44dd-a4a0-aa92932348ac",
      "text": "Ukrainian authorities charged individuals in an embezzlement scheme linked to arms procurement (~$40 million)",
      "date": "2024-01-27 00:00:00"
    },
    {
      "id": "4f074f04-ff3f-4ca6-9b9f-456a41c79af3",
      "text": "Pentagon Inspector General report finding about $1 billion in U.S. weapons to Ukraine not properly tracked",
      "date": "2024-01-11 00:00:00"
    },
    {
      "id": "3b1efc1f-a8b5-40d7-afb8-47b5c2d8c3eb",
      "text": "Pandora Papers release showing extensive use of UAE-linked offshore structures",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "563ef7e7-3e70-4f08-8a0d-494367c53a15",
      "text": "Greenpeace 'Dirty Laundry' investigative reports exposing toxic discharges from textile supply chains",
      "date": "2011-08-24 00:00:00"
    },
    {
      "id": "272d4ca0-a4cb-4498-a278-ed962e7fb8a9",
      "text": "Publication of 'A New Textiles Economy' report by the Ellen MacArthur Foundation (widely cited analysis of fashion's environmental footprint)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "14e70229-d758-4a9f-b726-1a569c1c76d6",
      "text": "Peer‑reviewed studies (2017) quantifying microfiber shedding from synthetic textiles as a major source of microplastics",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "d4ac0cf9-cde0-4c2c-8550-238510e5a0dc",
      "text": "CDC/ACIP review and MMWR reporting of myocarditis and pericarditis cases following mRNA COVID-19 vaccination",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "43003400-9f69-4899-b6b9-65d8858ef0a2",
      "text": "Regulatory findings and media coverage of rare blood‑clotting events linked to the AstraZeneca COVID-19 vaccine (EMA review)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "22510ace-caed-4962-8f00-efe8b2b3bdc5",
      "text": "Sinking of the Russian cruiser Moskva in mid-April 2022 near the Black Sea theatre",
      "date": "2022-04-14 00:00:00"
    },
    {
      "id": "a5875c2f-fc37-4929-a261-fb5eb0b601e3",
      "text": "Ukrainian forces raised the Ukrainian flag on Snake Island after Russian withdrawal",
      "date": "2022-06-30 00:00:00"
    },
    {
      "id": "bf690599-cad5-45dd-ae9a-0dfd9300fe11",
      "text": "Enactment of Ukraine's decommunization laws",
      "date": "2015-05-15 00:00:00"
    },
    {
      "id": "34cc607d-07f1-4fcf-961e-cc2ed5410530",
      "text": "Kyiv City Council renamed General Vatutin Avenue to Roman Shukhevych Avenue",
      "date": "2017-06-01 00:00:00"
    },
    {
      "id": "f1e6c65f-d792-4cb8-9f39-7aafac76aea6",
      "text": "OSCE Special Monitoring Mission observed civilian fatalities and bodies after shelling in Donetsk",
      "date": "2014-08-23 00:00:00"
    },
    {
      "id": "67fe157c-0a35-49a8-8f21-5628c7797662",
      "text": "Odessa Trade Union House fire and mass fatalities during clashes",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "1e8752b2-0404-4776-b8b8-8e69b8687848",
      "text": "Killing and torture of local politician Volodymyr Rybak reported from Donetsk region",
      "date": "2014-04-22 00:00:00"
    },
    {
      "id": "157ab812-4359-4349-aa5a-6276969f1acf",
      "text": "Exhumation of a mass grave in Sloviansk, eastern Ukraine",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "7c180cef-775f-4dc0-b7a2-7d8d5e88625c",
      "text": "UNICEF launched a humanitarian cash transfer programme in Ukraine (real cash payments to vulnerable families began in March 2022).",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "d4e97c40-281a-46e0-9b44-cf5ed299a47d",
      "text": "Sharp rise in Telegram (early 2022) and already-dominant Viber use (Ukraine: high market share reported Sept 2021) as primary messaging channels in the region.",
      "date": "None"
    },
    {
      "id": "76f11f64-6713-42b7-b4fe-4a91b078dc1d",
      "text": "French farming unions warned they could stage further protests and blockades (reported March 3, 2024).",
      "date": "2024-03-03 00:00:00"
    },
    {
      "id": "c7046dc0-2120-433b-b1ad-372ce5830178",
      "text": "President Macron publicly said he did not \"rule out\" sending Western troops to Ukraine during a leaders' meeting in Paris.",
      "date": "2024-02-27 00:00:00"
    },
    {
      "id": "3c63c480-f1c1-4956-8ba8-123730a4a02a",
      "text": "IUCN Polar Bear Specialist Group released its 2023 status/criteria report on polar bear subpopulations and abundance estimates (PBSG status report, Oct 2023).",
      "date": "2023-10-17 00:00:00"
    },
    {
      "id": "c48786c0-3d01-4cc0-beef-55fd9048d74a",
      "text": "The Oceanography Society / research syntheses in 2023 published accessible overviews of observational evidence for ongoing global surface ocean acidification.",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "8aebfe7f-59bd-447a-9883-1dfe71623e69",
      "text": "NOAA/SWPC issued a revised forecast that Solar Cycle 25 would rise more quickly and peak higher than earlier predictions, and highlighted recent large solar flares (X‑class) in late 2023.",
      "date": "2023-10-25 00:00:00"
    },
    {
      "id": "4ded90c5-3a0b-4383-8c98-2eb06d50795b",
      "text": "Peer‑reviewed 2023 papers documented high spatial and temporal variability in coastal and upwelling pH (e.g., high‑frequency pH dynamics in regional systems), showing local short‑term pH fluctuations.",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "5b44d227-cd48-4625-802b-e02870b36ce5",
      "text": "U.S. federal political actions and rhetoric undermining climate policy (example: President Trump announces withdrawal from Paris Agreement)",
      "date": "2017-06-01 00:00:00"
    },
    {
      "id": "6c7bfa6f-971f-46b6-bd04-14ad038adf97",
      "text": "Nature Climate Change paper: 'Temporary reduction in daily global CO2 emissions during the COVID‑19 forced confinement'",
      "date": "2020-05-19 00:00:00"
    },
    {
      "id": "94bceffe-abc3-44c2-a2eb-2ddc58173a11",
      "text": "Violent clash between rival Orthodox groups at St. Michael's Cathedral in Cherkasy",
      "date": "2024-10-17 00:00:00"
    },
    {
      "id": "57923ade-9ad9-40e2-82c9-f707f057bcfe",
      "text": "Local reporting about the contested transfer/seizure of the cathedral and services held in Ukrainian amid the dispute",
      "date": "2024-10-17 00:00:00"
    },
    {
      "id": "e77c2457-bcbb-44c5-98ef-1183f378c60e",
      "text": "Russia/occupation authorities ban the Mejlis of the Crimean Tatar people as 'extremist'",
      "date": "None"
    },
    {
      "id": "d42c2acc-9cb7-4e82-b0d1-beeb3deb20d8",
      "text": "Surge in positive public attitudes toward Stalin in Russia (Levada poll, April 2019)",
      "date": "2019-04-16 00:00:00"
    },
    {
      "id": "51ced9e6-1f43-4883-977d-d0e20fe66a54",
      "text": "Release and public circulation of National Toxicology Program (NTP) draft monograph materials on fluoride and neurodevelopment (documents publicly posted and widely reported in 2023).",
      "date": "None"
    },
    {
      "id": "30397b47-2751-48d5-b517-e38ed1c2ed3c",
      "text": "Publication of mouse-study showing sodium bicarbonate reduced metastasis (Robert Gillies et al.)",
      "date": "2011-08-23 00:00:00"
    },
    {
      "id": "ebc674c8-5c33-4f37-85b6-129b22993e97",
      "text": "Case report of severe metabolic alkalosis from topical sodium bicarbonate use (clinical harm reported)",
      "date": "2017-10-24 00:00:00"
    },
    {
      "id": "2c94f3e9-f2e4-478c-8e0b-0c78352e3b7d",
      "text": "2018 conviction and sentencing news about Tullio Simoncini for treating cancer with bicarbonate",
      "date": "2018-01-15 00:00:00"
    },
    {
      "id": "a5f5eee1-35a8-40c6-bf54-d56986cd75d6",
      "text": "European Union re‑affirms and extends sanctions on Russia amid Minsk implementation stalemate (summer 2017)",
      "date": "2017-07-03 00:00:00"
    },
    {
      "id": "59a9db05-0086-48fa-8c0c-ffbd3e3860e0",
      "text": "German foreign minister Frank‑Walter Steinmeier publicly favours gradual phasing‑out of Russia sanctions if progress is made (Reuters)",
      "date": "2016-06-06 00:00:00"
    },
    {
      "id": "535a210f-5332-48a8-b714-9cd94b6426f0",
      "text": "Heavy fighting in Avdiivka, Donetsk region — major escalation reported (Battle of Avdiivka)",
      "date": "2017-01-31 00:00:00"
    },
    {
      "id": "823bb143-78e8-4e11-9b72-5d0fd5f6deff",
      "text": "‘Steinmeier formula’ concept emerges in Normandy/Minsk negotiations (implementation idea for political clauses)",
      "date": "None"
    },
    {
      "id": "6d5a827c-ea0b-42ce-a5a8-4c2933dddc23",
      "text": "OSCE/UN reports of restricted access and harassment of journalists in eastern Ukraine (summer 2014).",
      "date": "2014-08-28 00:00:00"
    },
    {
      "id": "3ceecee9-d165-47a0-8779-3f9b9fd7ff46",
      "text": "Ukrainian National Guard reported taking control of Komsomolske (Donetsk region) after fighting.",
      "date": "2014-08-29 00:00:00"
    },
    {
      "id": "b64599c0-5b8d-4f3b-97b9-a3e1d058ac89",
      "text": "Large Russian military convoy and movement of heavy vehicles near the Ukraine border (August 2014) and competing official narratives about incursions.",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "48cc9fc9-b313-45c6-ab6c-98c8e73a1a81",
      "text": "Ukrainian forces captured two Russian nationals identified as GRU officers (Yevgeny Yerofeyev and Aleksandr Aleksandrov) during fighting near Schastya.",
      "date": "2015-05-16 00:00:00"
    },
    {
      "id": "1f57bde1-5a81-4359-9554-77b898be045a",
      "text": "Large prisoner exchange between Kyiv and pro-Russian rebels around the end of December 2014, involving hundreds of detainees.",
      "date": "2014-12-27 00:00:00"
    },
    {
      "id": "dea4f733-4356-40fe-91e7-6054577b69a7",
      "text": "Signing of Minsk II (Package of Measures) which included clauses calling for 'release and exchange of all hostages and unlawfully detained persons' on an 'all-for-all' basis.",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "4531fbee-07ca-4f7f-ba48-99fd66c5beb6",
      "text": "EuroMOMO surveillance reports flagged elevated excess all-cause mortality in parts of Europe during 2021",
      "date": "2021-02-24 00:00:00"
    },
    {
      "id": "37483664-a7a7-4762-9906-e5dcae2780ff",
      "text": "Office for National Statistics publishes 'Deaths involving COVID-19 by vaccination status' dataset covering deaths occurring Jan 2021–31 May 2022",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "4a28a209-dbc3-45dd-b84a-d065c7a2ddd8",
      "text": "Federal judge orders FDA to accelerate public release of Pfizer COVID-19 vaccine documents",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "883ec100-33d7-4964-82ca-f305eceae674",
      "text": "CDC issues 'Preexposure Prophylaxis for the Prevention of HIV Infection' clinical practice guideline",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "846c382b-bfeb-4264-ada7-0b383ff7fb90",
      "text": "FDA approval of Descovy (emtricitabine/tenofovir alafenamide) for PrEP, with messaging highlighting improved renal and bone safety compared with TDF-based Truvada",
      "date": "2019-10-03 00:00:00"
    },
    {
      "id": "8650053a-7f26-4698-9037-10695259e0b3",
      "text": "Publication of reviews and studies documenting tenofovir disoproxil fumarate (TDF)–associated renal dysfunction and decreases in bone mineral density",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "5245537c-9eb7-4eb1-8dc9-552ac10777ac",
      "text": "CDC issues formal guidance on certifying COVID-19 deaths (death-certificate guidance)",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "2a8d0962-05f2-4f3b-83bc-0c984f50a683",
      "text": "Italian Istituto Superiore di Sanità (ISS) reports high prevalence of pre-existing conditions among COVID-19 fatalities",
      "date": "2020-05-24 00:00:00"
    },
    {
      "id": "766905f5-fd25-46de-a4cb-f9e22321ddf7",
      "text": "Poroshenko appeared publicly with wounded soldiers as guests at a Dynamo Kyiv match (visuals of him handing/being near gifts including a football).",
      "date": "2015-03-19 00:00:00"
    },
    {
      "id": "47752977-8739-4c1f-8b4b-0b2984eea4d1",
      "text": "Established medical context: febrile seizures are a known, usually benign reaction to fever and occur after many vaccines/infections (public understanding limited)",
      "date": "None"
    },
    {
      "id": "f8643050-a94b-48c4-96c8-ffa6daa1c6c9",
      "text": "Russian government statements alleging 'outside meddling' in Belarus",
      "date": "2020-08-13 00:00:00"
    },
    {
      "id": "32bba864-7aa2-4f36-b89b-224012fe2ca8",
      "text": "President Petro Poroshenko signs Ukraine's 'decommunisation' laws banning communist symbols and requiring removal/renaming of Soviet-era monuments and toponyms.",
      "date": "2015-05-15 00:00:00"
    },
    {
      "id": "d257a9bf-a3d4-4874-be64-af6ba0f22f02",
      "text": "Large Lenin statue toppled and demolished in Kharkiv during anti‑government protests.",
      "date": "2014-09-28 00:00:00"
    },
    {
      "id": "a2d902e4-962f-4a18-a1c1-f622b3934f40",
      "text": "Polish Sejm resolution recognising the Volyn (Volhynia) killings and raising attention to Volyn (22 July 2016)",
      "date": "2016-07-22 00:00:00"
    },
    {
      "id": "5e4c2baf-dbe7-49e1-b269-4033ddb0632e",
      "text": "Wider pro‑Russian unrest and short‑lived 'people's republic' claims in cities such as Kharkiv and Odesa (April 2014)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "4aa21b38-4b13-4d29-925c-aa699d9b3403",
      "text": "WHO names vaccine hesitancy among the top global health threats in 2019, and public debate about vaccine 'toxins' and 'detox' ramps up on social platforms in the late 2010s.",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "532d5c4d-9d3f-4f2f-a279-bbeb95659887",
      "text": "American College of Medical Genetics and Genomics (ACMG) issues a 2013 practice guideline stating there is a lack of evidence supporting clinical MTHFR polymorphism testing.",
      "date": "2013-02-24 00:00:00"
    },
    {
      "id": "55e44c00-4fe6-496c-9dab-944c4b2cb2c7",
      "text": "Ukrainian government approved a draft law narrowing eligibility for military deferments for students and educators",
      "date": "2022-04-04 00:00:00"
    },
    {
      "id": "bd112641-f8c0-444d-8cb9-9503c72569a7",
      "text": "Verkhovna Rada extended martial law and general mobilization and described categories (including students) eligible/exempt from mobilization",
      "date": "2022-05-24 00:00:00"
    },
    {
      "id": "e718d11e-60bf-41ca-aae9-78820d070e08",
      "text": "WHO interim guidance 'Advice on the use of masks in the context of COVID-19' published (5 June 2020) noting there was \"no direct evidence\" from studies on universal masking of healthy people in the community.",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "f7c3ade4-9ecf-4e12-853b-8b75b47032a1",
      "text": "Publication (Epub May 13, 2020) of Gao et al., 'A study on infectivity of asymptomatic SARS-CoV-2 carriers' (Respiratory Medicine), reporting 455 contacts of an asymptomatic carrier tested negative.",
      "date": "2020-05-13 00:00:00"
    },
    {
      "id": "46856529-2ef5-4366-a966-3ebc9ac5e9bb",
      "text": "Complaints and regulator notices in the UK about inappropriate recruitment incentives (reports that children were offered large payments, e.g., £1,500, to join a Moderna pediatric trial) and subsequent PMCPA action.",
      "date": "2023-08-24 00:00:00"
    },
    {
      "id": "3f1da2a4-fd20-4820-8b26-bef270380f34",
      "text": "Publication of the KidCOVE phase 2/3 trial results showing mRNA‑1273 (Moderna) was safe and immunogenic in children 6 months to 5 years (NEJM).",
      "date": "2022-11-03 00:00:00"
    },
    {
      "id": "9c75c255-ad39-4e2a-a3f1-0b4d8b705a38",
      "text": "Widespread civilian refugee exodus from Ukraine reported across media",
      "date": "2022-03-14 00:00:00"
    },
    {
      "id": "02012bb7-6c7b-4ee5-afd2-88ea366a860e",
      "text": "DOU industry survey (conducted March 23–26, 2022) found many IT specialists had moved to safer locations (61% reported leaving their homes)",
      "date": "None"
    },
    {
      "id": "fd1c4e40-ebf0-4822-886a-cc9032160c1d",
      "text": "Public statements and interviews by Ukrainian officials describing the size and mobilization of the IT sector (coverage citing ~300,000 IT professionals)",
      "date": "2022-03-25 00:00:00"
    },
    {
      "id": "3495bbed-e666-46d8-898f-62fc06d697e3",
      "text": "Multiple international tech firms publicly evacuated or offered relocation support for Ukrainian staff",
      "date": "2022-03-01 00:00:00"
    },
    {
      "id": "e61ba6fa-b8da-435a-b8ad-f2f5ea81b708",
      "text": "2010 laboratory work demonstrating water extraction methods recover shikimic acid from sweetgum bark/wood",
      "date": "2010-05-27 00:00:00"
    },
    {
      "id": "fffbf361-a8e9-49f9-adb5-13838d571f1e",
      "text": "2009 news coverage linking shikimic acid (from star anise) to Tamiflu production and documenting supply shortages during flu scares",
      "date": "2009-05-18 00:00:00"
    },
    {
      "id": "ecd93e53-3d17-448c-b237-a63b3e8109e3",
      "text": "Russia vetoed a UN Security Council draft resolution to establish an international tribunal for the downing of Malaysia Airlines Flight MH17",
      "date": "2015-07-29 00:00:00"
    },
    {
      "id": "2125bdb0-7204-4e0a-91d8-28499c435729",
      "text": "UN General Assembly adopted Resolution A/RES/68/262 affirming Ukraine’s territorial integrity while the Security Council was unable to act",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "9af4bc62-9b31-46ce-8d09-a6acb48e4823",
      "text": "Humanitarian situation reports documenting growing social tensions and incidents between host communities and IDPs in host areas",
      "date": "2014-08-01 00:00:00"
    },
    {
      "id": "90a9b422-b922-4777-a14a-ef9498c5cc6a",
      "text": "High‑profile cases earlier in 2014 of pro‑Russian protesters/separatists removing or replacing Ukrainian flags from government buildings in eastern Ukraine (Donetsk)",
      "date": "2014-03-05 00:00:00"
    },
    {
      "id": "14413e39-16eb-48e6-b0b2-dcfc3fb3a951",
      "text": "Large influx of internally displaced persons (IDPs) from Donbas and Crimea to Kyiv region (tens of thousands reported)",
      "date": "2014-07-02 00:00:00"
    },
    {
      "id": "f1f73dc0-26bb-4aae-a4be-b03b92bf4da4",
      "text": "Existing, well-known SANAE IV research station and local geology (Vesleskarvet nunatak composed of dolerite/diabase) available in public records and studies",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "ff3cedd3-b1c8-4195-a13a-18ec0932a118",
      "text": "Angelina Jolie made an unannounced humanitarian visit to frontline cities in Ukraine (Kherson, Mykolaiv/Lviv region).",
      "date": "2025-11-05 00:00:00"
    },
    {
      "id": "2445c1a3-6b24-4942-8f14-750807be5748",
      "text": "UN reporting and human‑rights agencies warned of 'persistent and grave' human rights violations and widespread deprivation in conflict‑affected areas of eastern Ukraine.",
      "date": "2015-06-01 00:00:00"
    },
    {
      "id": "f65051ed-e0d4-4480-8343-0bb9a5c21786",
      "text": "Verkhovna Rada submission/declaration to the UN indicating derogation from certain international obligations (official deposition notifying international bodies).",
      "date": "2015-06-05 00:00:00"
    },
    {
      "id": "f921e3a9-8ef0-4155-b3e0-4e2525ea4be1",
      "text": "Widespread suspension or non‑payment of pensions and social payments to people in non‑government controlled areas of Donetsk and Luhansk.",
      "date": "2015-02-20 00:00:00"
    },
    {
      "id": "0f392d94-957e-4115-bb27-f1428a1f5994",
      "text": "Western bilateral training missions inside Ukraine (for example, Canada's Operation UNIFIER launched in 2015 with rotating Canadian personnel training Ukrainian forces).",
      "date": "2015-09-24 00:00:00"
    },
    {
      "id": "870b1f70-9513-4c14-bc26-c7ffdca2eaa9",
      "text": "NATO formalized intensified political/military cooperation with Ukraine (NATO factsheets and liaison presence describing NATO-Ukraine dialogue and support).",
      "date": "2016-06-24 00:00:00"
    },
    {
      "id": "e8e9e296-5042-4c13-add8-a1aa37276d9f",
      "text": "Sea Breeze 2019 multinational naval and maritime exercise co-hosted by Ukraine and NATO/allied partners in the Black Sea (visible allied ships and aircraft operating near Ukraine).",
      "date": "2019-07-24 00:00:00"
    },
    {
      "id": "5a73da15-6a60-4dac-b227-76a076b0d384",
      "text": "Reports since 2014 of foreign fighters and international volunteers operating in Donbas (documented by major outlets such as the BBC).",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "6bf3097a-570b-4809-b237-d44db87a39eb",
      "text": "Antarctic winter sea‑ice extent reached a satellite‑era record high (widely reported in 2014)",
      "date": "2014-09-22 00:00:00"
    },
    {
      "id": "a5b57b1c-b032-4317-805d-278014d54408",
      "text": "World Glacier Monitoring Service (WGMS) database expansion and 2019 reporting on glacier observations",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "a25c205a-715d-4d40-ae2c-d66a5469c6df",
      "text": "CDC releases 2020–2021 flu vaccination recommendations calling for yearly flu vaccine for everyone 6 months and older",
      "date": "2020-08-20 00:00:00"
    },
    {
      "id": "63118e54-0fd4-430b-95cb-919ab0a8306b",
      "text": "NOAA 'State of the Climate — 2012' reporting on global sea level contributions noted that recent sea-level rise included large contributions from glacier and ice-sheet melt as well as thermal expansion",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "c4c91b8a-1cf8-4289-bb34-1c6dd48aedcd",
      "text": "Research showing Pacific trade-wind/ENSO-driven decadal variability strongly affects regional sea-level trends (studies published 2016–2017 demonstrating wind-driven variability and model under-representation)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "452dbeed-8292-4d02-90ab-791dbe013e25",
      "text": "Coverage of apparent 'slowing' or data-artifact issues in satellite altimeter sea-level records (widely reported articles in 2014–2015 discussing measurement corrections and inter-dataset differences)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "b9b93ac0-20e7-473e-bcb0-a8cb0f7eb23c",
      "text": "Verkhovna Rada adopted a resolution establishing 'Day of the Ukrainian Volunteer' (Day of Volunteer Fighters)",
      "date": "2017-01-17 00:00:00"
    },
    {
      "id": "83d411c4-399d-40a3-8c9c-d17510bac37a",
      "text": "Presidential Decree No.806/2014 established 'Day of the Defender of Ukraine' (14 October 2014)",
      "date": "2014-10-14 00:00:00"
    },
    {
      "id": "f0bfcd0b-b8e2-4da4-9825-ade7ead748a9",
      "text": "UK government announced new national lockdown in England on Jan 4, 2021 despite vaccine rollout",
      "date": "2021-01-04 00:00:00"
    },
    {
      "id": "f0786557-6136-4304-81d6-22fc866a3b12",
      "text": "IATA and airlines public plans for a digital 'travel pass' / health pass tied to testing and vaccination (December 2020)",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "a114812e-0977-4ca1-8094-71ad9b83c0c8",
      "text": "WHO warnings that vaccines are not a 'silver bullet' and will not immediately end the pandemic",
      "date": "2020-08-21 00:00:00"
    },
    {
      "id": "c0c0f3f8-c44b-4b66-ae74-4ad4f7191562",
      "text": "Berlin authorities publicly considered or enforced bans on display of Russian/Soviet symbols around May 8–9 commemorations",
      "date": "2024-05-07 00:00:00"
    },
    {
      "id": "c9344c2b-3875-489a-9343-306f5df5110f",
      "text": "Major oil and gas companies (Shell, Exxon) suspend or pull back Black Sea projects after Crimea’s annexation",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "20b2a735-379f-4fce-94bd-0bbe7f7c5b79",
      "text": "Russian appropriation and U.S. sanctions on Chernomorneftegaz after the 2014 annexation of Crimea",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "1e5cedaa-a90f-4111-8959-84cd0f677370",
      "text": "Peer‑reviewed review article published (Natural Product Communications) summarizing multiple Chinese herbal medicines and their potential mechanisms in COPD (preclinical and small clinical studies).",
      "date": "2024-11-05 00:00:00"
    },
    {
      "id": "d77fb711-e1eb-4c1f-81a1-c1b44ddef513",
      "text": "FDA issued high‑profile warning letters and enforcement actions in 2023–2024 against supplement makers for making unlawful disease‑treatment claims.",
      "date": "2023-10-24 00:00:00"
    },
    {
      "id": "efcfd10c-3281-4c5a-9c0a-b8ea84055f5c",
      "text": "CDC COVID-NET MMWR report on pediatric COVID-19 hospitalizations (March–July 2020)",
      "date": "2020-08-24 00:00:00"
    },
    {
      "id": "318c05c3-f561-4ede-a7e7-336765f0b9bd",
      "text": "Publication of Moncrieff et al., 'The serotonin theory of depression: a systematic umbrella review of the evidence' in Molecular Psychiatry, concluding no consistent evidence that depression is caused by decreased serotonin activity (widely reported July 2022).",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "b0e753ad-fa27-4f00-bbc3-e8d0ea27080b",
      "text": "Royal College of Psychiatrists position statement 'Antidepressants and depression' (PS04/19, May 2019) stating the 'chemical imbalance' explanation is an oversimplification and not supported as a literal cause of depression.",
      "date": "2019-05-24 00:00:00"
    },
    {
      "id": "84a49646-225a-47e5-9d89-f72e0b0f5cd3",
      "text": "U.S. Senate passed a $95 billion foreign aid package including funds for Ukraine and security assistance",
      "date": "2024-02-13 00:00:00"
    },
    {
      "id": "961ea034-93f4-409c-a1ca-a12bfda4eef2",
      "text": "Ukrainian President Volodymyr Zelensky's visit to Washington to plead for more U.S. aid and meetings with lawmakers",
      "date": "2023-12-12 00:00:00"
    },
    {
      "id": "4939d5d5-e9de-45e0-bd7e-a16ab0082411",
      "text": "United Kingdom announced a formal 10-year security/cooperation arrangement with Ukraine (high-profile bilateral security pact coverage)",
      "date": "2024-01-12 00:00:00"
    },
    {
      "id": "e16f10a8-1336-4abc-8110-4dc43103f841",
      "text": "OSCE regular situation summaries noting continued shelling damage in Donetsk (SMM monitoring summaries in Jan–Feb 2015)",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "6964c63e-6ac3-4676-95c7-8019b57baa90",
      "text": "CDC/ACIP public report (MMWR) acknowledging increased reports of myocarditis after mRNA COVID-19 vaccination and concluding benefits outweigh risks",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "dcfb71f8-e742-4806-97c7-9c89af87b65a",
      "text": "Discovery of black/foreign particles in some Moderna vaccine vials in Japan, triggering local pauses and recalls",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "c97c2a12-aae4-4eee-b04a-89da2678cf8e",
      "text": "CDC/ACIP and MMWR reports (June 2021) documenting an elevated but rare risk of myocarditis after mRNA vaccination in young males",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "d26e0e0c-97ed-4101-aa66-03799c71230f",
      "text": "EMA statement (April 2021) finding a possible link between AstraZeneca vaccine and very rare blood clots",
      "date": "2021-04-07 00:00:00"
    },
    {
      "id": "bb8b9873-c9ae-4b32-aa5e-d093e4520db2",
      "text": "Media coverage and public attention on regulatory/clinical debate about aluminum adjuvant safety (coverage of CDC/advisory discussions)",
      "date": "2024-01-24 00:00:00"
    },
    {
      "id": "9e2ed00f-fb92-4f4d-a34e-6d11d893c403",
      "text": "CDC guidance on infant formula and fluorosis advising caution with fluoridated water when preparing infant formula",
      "date": "2015-07-24 00:00:00"
    },
    {
      "id": "0fbbec81-5c41-4156-b190-889bc78cf7de",
      "text": "NTP (National Toxicology Program) systematic review/monograph assessing fluoride exposure and neurodevelopmental outcomes",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "5063cec6-b534-47e2-92b2-fcd5f77d4fb6",
      "text": "EU and other Western emergency energy/aid packages delivered to Ukraine after strikes on energy infrastructure",
      "date": "2024-04-09 00:00:00"
    },
    {
      "id": "6e0721bf-af2c-4613-aab8-fc5a60b352e1",
      "text": "Public health briefings and technical reports about Omicron (Dec 2021–Jan 2022) from agencies such as CDC/UKHSA describing reduced vaccine effectiveness against infection and many 'breakthrough' cases",
      "date": "2021-12-24 00:00:00"
    },
    {
      "id": "72ac546b-bca3-4948-aa0b-6469a29a2935",
      "text": "Widespread driver-led protests and road blockades across Serbia over fuel-price hikes (early June 2018).",
      "date": "2018-06-08 00:00:00"
    },
    {
      "id": "f218e618-b7a6-435a-9b95-d4d9450acaa2",
      "text": "OSCE Special Monitoring Mission (SMM) reports (2014–2015) documenting heavy weapons and noting that withdrawal of foreign armed formations and verification remained incomplete (e.g., OSCE SMM updates in 2015).",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "b8b1f515-6eaa-4716-8eba-78cd0e360567",
      "text": "Signing of the Minsk II package of measures (Normandy Format) on 12 February 2015, which called for withdrawal of 'all foreign armed formations, military equipment and mercenaries' from Ukraine.",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "63f5d0a1-7dfe-4d45-9529-9e2ab1904d7d",
      "text": "Ukraine released footage and publicly displayed captured Russian paratroopers in August 2014; Moscow described the detentions as a mistake or denied direct responsibility.",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "88f1f741-4ab7-4160-a0fa-c523bb32fe76",
      "text": "Russia launched a direct military intervention and air campaign in Syria (widely reported on 30 Sept 2015).",
      "date": "2015-09-30 00:00:00"
    },
    {
      "id": "577b06c1-df87-403c-abf0-46e4fc3e0b1b",
      "text": "Apter et al. v. Department of Health & Human Services — lawsuit filed by three physicians (complaint filed June 2, 2022)",
      "date": "2022-06-02 00:00:00"
    },
    {
      "id": "c1749acf-2e81-4a01-a6d7-be83d2e12cc8",
      "text": "DOJ lawyer's remark during Fifth Circuit oral arguments (Apter v. HHS) that “FDA explicitly recognizes that doctors do have the authority to prescribe ivermectin”",
      "date": "2023-08-08 00:00:00"
    },
    {
      "id": "881df9ed-9ac7-489a-b437-ca046e1322d5",
      "text": "Calls in EU institutions and the Platform of European Memory and Conscience for EU-supported remembrance projects and funding (referenced in EP documents, 2019)",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "7ea3085a-234b-4fbe-8da9-c525603685fa",
      "text": "International backlash to Poland's 2018 'Holocaust law' (Amendment to the Act on the Institute of National Remembrance) and subsequent diplomatic controversy",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "91bf62f3-7da8-4e84-85d2-709539cb36fc",
      "text": "Ukrainian security forces moved to clear separatist/pro‑Russian protesters from the Kharkiv administration building and arrested dozens (early April 2014).",
      "date": "None"
    },
    {
      "id": "81ef874f-fdd0-44e9-82c4-b0faf65cb9de",
      "text": "Deadly clashes in Odesa on May 2, 2014, that left dozens dead in street fighting and a Trade Unions House fire between pro‑Ukrainian and pro‑Russian groups.",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "18a75e4e-6a6a-41e5-883e-66078a97f435",
      "text": "Increased visibility and international coverage of Ukrainian nationalist groups (e.g., Right Sector, Svoboda) and their mobilizations in early 2014.",
      "date": "None"
    },
    {
      "id": "29b2550c-f791-42b9-b02a-9900964c9675",
      "text": "5G Appeal / International EMF scientists' moratorium call",
      "date": "2017-09-13 00:00:00"
    },
    {
      "id": "4eecc423-821c-4504-b820-67b8e5603b27",
      "text": "China's commercial 5G launch in 50 cities",
      "date": "2019-11-01 00:00:00"
    },
    {
      "id": "550b4b37-7548-45b1-a3f1-d8a06a510945",
      "text": "US National Toxicology Program (NTP) cell-phone radiofrequency final reports",
      "date": "2018-11-01 00:00:00"
    },
    {
      "id": "7d8ca47e-2ef9-442a-98b1-fa8f6205bbc5",
      "text": "Public Health Ontario technical brief on interpreting PCR cycle threshold (Ct) values (Sept 2020)",
      "date": "2020-09-24 00:00:00"
    },
    {
      "id": "6b22123e-880e-4acc-8153-bdb56362c2a5",
      "text": "IDSA/AMP joint statement cautioning against using Ct values for clinical decision-making",
      "date": "2020-10-24 00:00:00"
    },
    {
      "id": "198d3645-4cb6-45e1-a18e-223c98801648",
      "text": "NEJM perspective arguing testing strategy should prioritize frequency/turnaround over analytic sensitivity (Mina et al., \"Rethinking Covid-19 Test Sensitivity\")",
      "date": "2020-09-30 00:00:00"
    },
    {
      "id": "a3363a3c-98a2-48ba-9cc7-674f22a0088d",
      "text": "Study showing PCR cycle threshold values correlate with loss of recoverable live virus (Bullard et al.)",
      "date": "2020-07-24 00:00:00"
    },
    {
      "id": "d54a3518-9e0b-4c3d-ba7c-472fc7e562f4",
      "text": "CDC/NCHS provisional counts showed the U.S. COVID-19 death tally reached roughly 1,000,000, prompting broad press coverage.",
      "date": "2022-05-12 00:00:00"
    },
    {
      "id": "2808b341-8473-434f-8054-cf31c53e50bf",
      "text": "President Biden and the White House publicly marked the milestone, issuing statements and remarks acknowledging 'one million Americans' dead from COVID-19.",
      "date": "2022-05-12 00:00:00"
    },
    {
      "id": "f4810664-25df-4885-84dd-d702f61fb326",
      "text": "Lithuanian parliament unanimously declared Russia a 'terrorist state'",
      "date": "2022-05-10 00:00:00"
    },
    {
      "id": "c7b6a4e5-5073-48f9-906b-45c2c92af366",
      "text": "Pattern of prior Kremlin disinformation accusing Ukrainian authorities of preparing to mobilize or militarize children (examples documented across 2022).",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "faddd9e3-735d-4866-bc42-9d9cdd5b2f9a",
      "text": "A December 30, 2022 parliamentary decision changed the official summons form and administrative terminology (new Territorial Recruitment and Social Support Centers), making older or doctored forms appear superficially plausible to non-experts.",
      "date": "2022-12-30 00:00:00"
    },
    {
      "id": "4532a5f5-e3d7-4a33-a245-a559061e325f",
      "text": "Amnesty International documenting abuses by pro‑Ukrainian volunteer battalions in Donbas",
      "date": "2014-09-08 00:00:00"
    },
    {
      "id": "e530d934-99db-4543-9afe-a2d89c6fc26f",
      "text": "Passage of Ukraine's decommunization laws banning Soviet symbols",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "b7c50e63-6034-41ff-af30-9e1d8f461eaf",
      "text": "Adoption of the Ukrainian 'lustration' (vetting) law for officials",
      "date": "2014-09-16 00:00:00"
    },
    {
      "id": "99f4732d-fcd3-41ff-a9ec-3a7637e9f664",
      "text": "Adoption and implementation of the 2017 Education (language) law restricting minority‑language instruction",
      "date": "2017-09-28 00:00:00"
    },
    {
      "id": "f426628c-d791-433d-9908-39f946c4bddf",
      "text": "Ukrainian investigations and prosecutions for 'collaboration' with occupying authorities in Crimea (starting 2014)",
      "date": "None"
    },
    {
      "id": "0e355bfb-dda1-493a-9e8f-6a6055245a49",
      "text": "Europol / international law‑enforcement warnings about the risk of diversion of weapons from the Ukraine conflict to black markets",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "724352b3-5c52-4b45-9ec1-ed51d8f8b631",
      "text": "CBS Reports documentary 'Arming Ukraine' (briefly released, then pulled) examined problems getting aid to frontline and described shipment shortfalls",
      "date": "2022-08-04 00:00:00"
    },
    {
      "id": "5fadfb89-8910-4205-bfcb-e7b767a420a0",
      "text": "Public debate over mobilisation/conscription policy in Ukraine (Reuters: 'Female conscription not part of Ukraine's new draft law')",
      "date": "2024-01-08 00:00:00"
    },
    {
      "id": "f4a6e102-743d-4a10-b1fc-da4b283c1748",
      "text": "Widespread reporting of Russian strikes that damaged or destroyed Ukrainian grain storage facilities (grain silos)",
      "date": "2022-07-19 00:00:00"
    },
    {
      "id": "8840e33f-2cd1-4b8d-93e8-dcad7cba5f3d",
      "text": "Disruption of Black Sea grain exports after Russia’s pullback from the UN/Turkey‑brokered Black Sea Grain Initiative",
      "date": "2022-10-31 00:00:00"
    },
    {
      "id": "c2554150-da86-4ad4-9a8c-3abb18092cc9",
      "text": "Reports and images early in the war of attacks on bakeries and food‑production infrastructure (bread factories/bakeries hit by strikes)",
      "date": "2022-03-07 00:00:00"
    },
    {
      "id": "7bdd1f26-74a1-4f78-864b-931bf388e62d",
      "text": "CDC MMWR and other US reports documenting racial/ethnic differences in vaccine uptake (published analyses in early 2023 showing complex patterns of uptake across age and race).",
      "date": "2023-01-24 00:00:00"
    },
    {
      "id": "127c55ab-a974-4e8d-9a9d-a68dd053e4ab",
      "text": "Office for National Statistics (ONS) release showing that, for some reporting periods, the majority of COVID-19 deaths in England occurred among vaccinated people (because most older people were vaccinated).",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "a0fd99fd-4064-4c31-beef-aea5b915d57c",
      "text": "Czech arms firm Excalibur Group announced and began shipping refurbished T-72 tanks and other heavy equipment to Nigeria via Antonov An-225 flights out of Ostrava.",
      "date": "2015-01-30 00:00:00"
    },
    {
      "id": "091c1cf6-adc8-4823-808f-b9bd34b2c68a",
      "text": "Human Rights Watch report: 'Unguided rockets killing civilians' in rebel-held Donetsk",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "7d52399e-9fd4-4ef6-ad61-e9c1004b479d",
      "text": "OSCE Special Monitoring Mission spot report: residential area in Donetsk severely damaged by artillery",
      "date": "2014-08-23 00:00:00"
    },
    {
      "id": "59840c00-da45-49b8-ba87-6e4ec07b3dd0",
      "text": "Battle and shelling around Ilovaisk with documented civilian casualties",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "ce05174f-bd24-4296-a6ec-f3aa221ae8e7",
      "text": "Russian statements alleging Ukrainian cross-border shelling into Rostov/Donetsk (Russian claims)",
      "date": "2014-07-13 00:00:00"
    },
    {
      "id": "6d502776-1705-472f-a052-9bae2595eceb",
      "text": "Medical organizations publish guidance clarifying medical‑emergency exceptions and clinical decision‑making after Dobbs (e.g., ACOG August 2022 resources)",
      "date": "2022-08-24 00:00:00"
    },
    {
      "id": "e005d56e-7e0a-44da-9463-7e59e19f8e3a",
      "text": "CMS issues July 2022 EMTALA guidance and related communications about emergency care for pregnant patients",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "4c593132-8ef2-4218-bc92-54e12c4ac457",
      "text": "U.S. Supreme Court decision in Dobbs v. Jackson Women's Health Organization overturns Roe v. Wade",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "042276ae-6db4-40af-b408-aa46e970d2c5",
      "text": "UN warning (Nov 2015) that hundreds of thousands of children in Donetsk and Luhansk were at risk from potential failure of heating systems due to conflict damage",
      "date": "2015-11-24 00:00:00"
    },
    {
      "id": "9d3f9b7d-b953-4f66-8e82-2ef2c80bff16",
      "text": "2009 Russia–Ukraine gas dispute: Gazprom cut gas supplies to Ukraine (and affected transit to Europe)",
      "date": "2009-01-24 00:00:00"
    },
    {
      "id": "d29d4cd2-9756-49f4-b174-98c43f065c21",
      "text": "Reuters special report: 'Ukraine struggles to control maverick battalions' documenting undisciplined volunteer units and links to criminality",
      "date": "2015-07-29 00:00:00"
    },
    {
      "id": "6969d256-3deb-46fb-8044-e5876804511b",
      "text": "UN OCHA situation reporting and media coverage documenting humanitarian access problems and reports of diverted/looted aid in Donbas (2014)",
      "date": "2014-10-03 00:00:00"
    },
    {
      "id": "1a2792b6-491c-47e0-86c4-78505dcb126e",
      "text": "Kyiv Post coverage of volunteer battalion leaders publicly declaring assets, showing some leaders with property and cash",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "26d837e2-51eb-4a5b-a3f4-6de34ff0ee08",
      "text": "Randomized, double‑blind multicenter trial of the MCT-based product AC‑1202 (Axona) reporting cognitive benefit in ApoE4‑negative Alzheimer's patients (Henderson et al., Nutrition & Metabolism)",
      "date": "2009-08-24 00:00:00"
    },
    {
      "id": "011bd2a9-8271-4b4a-908b-aac429423860",
      "text": "Mainstream media coverage of coconut oil as a 'health trend'/'miracle food' that emphasized potential benefits while downplaying uncertainty (e.g., New York Times explainer on coconut oil)",
      "date": "2018-08-21 00:00:00"
    },
    {
      "id": "6891d4bc-7f6e-4d54-a027-12dbe8eb3ab8",
      "text": "SIPRI background paper and data documenting substantial Ukrainian arms supplies and military-technical cooperation with several sub-Saharan African countries (report published 2011).",
      "date": "2011-02-24 00:00:00"
    },
    {
      "id": "d671635b-187f-40d0-a42b-732896025fed",
      "text": "High-level Ukrainian diplomatic visits to Africa (e.g., Ukrainian Deputy Foreign Minister Viktor Maiko visited Dakar, Senegal on 22–23 February 2013).",
      "date": "2013-02-22 00:00:00"
    },
    {
      "id": "5b397cc9-7288-426b-9112-16d6c2319144",
      "text": "UN General Assembly adopted a resolution declaring the Crimea referendum invalid (27 March 2014), with many states (including African votes and abstentions) visible in the roll call.",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "61c236bc-6219-4f54-a37b-045a9c1bbf51",
      "text": "Ukraine opened new embassies in African states (DRC, Ivory Coast) as part of a push to increase presence on the continent.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "79db8dc4-4182-4930-a458-c1f0ecb32cd0",
      "text": "U.S. delivery of Javelin anti-tank missiles to Ukraine (2018)",
      "date": "2018-04-30 00:00:00"
    },
    {
      "id": "f33629de-ea68-4a4a-93e5-ebb4b7e2643d",
      "text": "U.S. missile strike on a Syrian airbase (April 2017)",
      "date": "2017-04-07 00:00:00"
    },
    {
      "id": "6d7f5a83-3bd8-4234-906d-f5ef9e8fa9f0",
      "text": "U.S. B-52 bomber deployments and training flights in Northern Europe (March 2019)",
      "date": "2019-03-20 00:00:00"
    },
    {
      "id": "ff786304-52cd-4ed8-bb6a-ddd0fd7207d3",
      "text": "NATO’s Trident Juncture 2018 large-scale exercise in Norway",
      "date": "None"
    },
    {
      "id": "59aff547-9f80-46de-891e-008eb3c4a729",
      "text": "Russian leadership accusations that Ukraine was plotting attacks in Crimea (August 2016)",
      "date": "2016-08-10 00:00:00"
    },
    {
      "id": "f9ca1c34-8662-444d-8709-ffef60f2880c",
      "text": "Several European countries paused use of the Oxford–AstraZeneca COVID-19 vaccine over reports of rare blood clots.",
      "date": "2021-03-15 00:00:00"
    },
    {
      "id": "57c599ce-4b87-4ab0-83de-22733cfdbd26",
      "text": "Public availability of the VAERS adverse‑event reporting system and its raw data (VAERS data guide / public access documentation).",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "2d1f6464-f5ff-453c-b76b-cd8063d7cd66",
      "text": "Kenya says over 200 of its nationals are fighting for Russia in Ukraine",
      "date": "2025-11-12 00:00:00"
    },
    {
      "id": "219749c1-05e5-4ba0-b997-d3946448344b",
      "text": "South African Presidency (SANews) confirmation that government is helping 'suspected' nationals stranded after joining mercenary forces",
      "date": "2025-11-06 00:00:00"
    },
    {
      "id": "537f0b42-2434-4896-bffb-ab81f1d7d892",
      "text": "European Food Safety Authority (EFSA) published a comprehensive scientific opinion on acrylamide in food highlighting potential cancer risks from dietary acrylamide exposure and identifying roasted/heat-processed products (including coffee) as contributors.",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "17f9e020-02d1-458d-b904-b8170db4e607",
      "text": "Major news coverage (CNN) in April 2024 about concerns over chemicals used in decaffeination (methylene chloride/ethyl acetate) and calls from some health groups to restrict certain decaffeination methods.",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "0c48fb0e-8be2-4bc4-89e9-5d59615b0b5e",
      "text": "Public statement attributed to U.S. envoy Kurt Volker that Crimea \"cannot be returned by force\"",
      "date": "2018-05-24 00:00:00"
    },
    {
      "id": "9908eef1-a11e-4fc8-aab4-0175f621abf1",
      "text": "Apple Maps controversy and Ukrainian diplomatic protest after Crimea appeared as part of Russia on some platforms (Ukraine diplomat publicly criticized mapping depiction, Nov 2019)",
      "date": "2019-11-29 00:00:00"
    },
    {
      "id": "ee3b0569-0453-4da2-80c0-4d2633c63d56",
      "text": "Media reports that U.S. Secretary of State Mike Pompeo allegedly told Ukrainian interlocutors \"Crimea is lost\" (reported in press coverage)",
      "date": "2020-02-05 00:00:00"
    },
    {
      "id": "5614cf21-6c14-4bdb-aeb4-bd24f098a256",
      "text": "Widespread reporting of attacks on hospitals and medical personnel in Ukraine that cited Geneva Convention protections (60 Minutes / CBS News coverage).",
      "date": "2022-04-03 00:00:00"
    },
    {
      "id": "ae0c2908-0718-455a-b0bb-f7b64da39d6d",
      "text": "Ukraine's parliamentary ombudswoman and other officials publicly accused Russia of mistreating Ukrainian POWs, saying Russia's conduct may violate the Geneva Conventions.",
      "date": "2022-04-04 00:00:00"
    },
    {
      "id": "2576ebe7-bdfa-4a54-9e77-ed200f2ebec3",
      "text": "Release of policy/guidance analyses on solar climate intervention and governance (C2ES report)",
      "date": "2020-07-24 00:00:00"
    },
    {
      "id": "fa9e5368-9529-4f06-8aa8-abbb99e2b39c",
      "text": "Public reporting that Bill Gates funded geoengineering research (FICER / early funding disclosures)",
      "date": "2010-01-24 00:00:00"
    },
    {
      "id": "c9e29398-01bf-45b5-b075-926abb3d6851",
      "text": "1964 NEJM publication on a vegetable-oil adjuvant (Adjuvant 65) tested in influenza vaccine trials",
      "date": "1964-09-24 00:00:00"
    },
    {
      "id": "29c519c1-42f1-483b-b79b-feb999358f8d",
      "text": "Children’s Hospital of Philadelphia (Vaccine Education Center) guidance explaining peanut/corn oils are not used in routine vaccines",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "a6c720fd-1686-4b05-8dc5-e93b64893521",
      "text": "Ukraine’s health regulators updated guidance on clinical trials (28 Sept 2020) and Ukraine received inquiries/applications related to vaccine trials in autumn 2020 (reported in contemporaneous summaries of trial activity).",
      "date": "2020-09-28 00:00:00"
    },
    {
      "id": "45bba5a6-922d-4a36-aabf-384c9f1904cb",
      "text": "Johnson & Johnson temporarily paused its global COVID‑19 vaccine trials after an unexplained illness in a participant (widely reported Oct 12–13, 2020).",
      "date": "2020-10-12 00:00:00"
    },
    {
      "id": "9c5dc79e-889f-435c-8d93-0b33904276d5",
      "text": "Viktor Medvedchuk (pro‑Moscow Ukrainian politician) publicly criticized Kyiv’s refusal to engage with Sputnik V and urged use of the Russian vaccine (comments reported Oct 26, 2020).",
      "date": "2020-10-26 00:00:00"
    },
    {
      "id": "9a10f506-e196-4eae-9a1a-e0e31b3ec0cc",
      "text": "First U.S. HIMARS systems delivered to Ukraine (first arrivals announced)",
      "date": "2022-06-23 00:00:00"
    },
    {
      "id": "b2d3b6e1-3124-44b9-af89-bbc6c321f2a1",
      "text": "U.S. National Security Adviser Jake Sullivan said the U.S. was 'not prepared to provide' ATACMS long-range missiles to Ukraine",
      "date": "2022-07-22 00:00:00"
    },
    {
      "id": "5540a615-7376-440a-b19c-ded561c593d8",
      "text": "Russia’s defence ministry claimed it destroyed four U.S.-supplied HIMARS launchers",
      "date": "2022-07-22 00:00:00"
    },
    {
      "id": "a39b288b-6302-4b14-8a01-666ec983ae8a",
      "text": "2018 global valsartan/ARB recalls for nitrosamine impurities (heightened nitrosamine scrutiny)",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "3d7197b7-34e5-4017-ab34-a9a7e4d5b38f",
      "text": "Pfizer records settlement charges resolving thousands of Chantix lawsuits (~$273 million)",
      "date": "2013-03-24 00:00:00"
    },
    {
      "id": "c92ccedf-1f2d-4cb1-94dd-2bb312a837a3",
      "text": "FDA approves Chantix (varenicline) for smoking cessation",
      "date": "2006-05-11 00:00:00"
    },
    {
      "id": "f93f030f-0add-4428-b8a0-bc210dd7288c",
      "text": "FDA adds boxed warning for serious neuropsychiatric events (postmarketing, 2009)",
      "date": "2009-07-24 00:00:00"
    },
    {
      "id": "bb8613b8-7b4f-4b81-b730-17ff3a4d9737",
      "text": "Longstanding scientific practice of 'semen washing'—techniques to remove HIV from semen—has been reported in the literature since 1989 and studied in subsequent reviews (e.g., 2015), information available before May 28, 2022.",
      "date": "1989-04-24 00:00:00"
    },
    {
      "id": "9ccc3f5e-2ac4-47b3-9b19-acbb7736468c",
      "text": "ONS regional excess-mortality update published showing higher-than-expected deaths through November 2022",
      "date": "2022-12-24 00:00:00"
    },
    {
      "id": "676dc4eb-7bd3-478b-87cc-006ca3b200d0",
      "text": "Peer‑reviewed reports of rare vaccine-associated myocarditis (published 2021–2022) received ongoing media attention",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "da116685-a998-4905-afdb-e5e3ec59e41d",
      "text": "VAERS / adverse-event report releases and summaries through late 2022 widely circulated",
      "date": "2022-11-24 00:00:00"
    },
    {
      "id": "0e161649-17f8-4509-a87d-586546770d4d",
      "text": "Construction and commissioning of the North Crimean Canal (Soviet-era large-scale diversion of Dnieper waters to Crimea, main works 1961–1971)",
      "date": "None"
    },
    {
      "id": "45a42fd9-f5a7-4cb6-8f87-a26fc49a727d",
      "text": "PBS/NOVA special 'The Quest for Noah's Flood' airs (TV documentary presenting the Black Sea deluge hypothesis to broad audiences)",
      "date": "2001-10-24 00:00:00"
    },
    {
      "id": "63adbf4a-a48b-42d4-966e-1a8a3af9e07c",
      "text": "French National Assembly (lower house) adopted a non‑binding resolution calling for non‑renewal of EU sanctions on Russia",
      "date": "2016-04-28 00:00:00"
    },
    {
      "id": "69c09a97-0d88-40a5-967e-4b2414656a7f",
      "text": "High-profile promotion of ivermectin as a COVID-19 treatment by advocacy groups and physicians (e.g., Dr. Pierre Kory's Senate testimony) increased public attention to the drug",
      "date": "2020-12-08 00:00:00"
    },
    {
      "id": "370c1658-a5f6-4b11-a586-4bdde6133fc0",
      "text": "Italy imposes national lockdown amid surging deaths in Lombardy",
      "date": "2020-03-09 00:00:00"
    },
    {
      "id": "47cb6c7d-564c-46d9-afff-c29eb954648d",
      "text": "Launch and widespread use of the Johns Hopkins global cases-and-deaths dashboard",
      "date": "2020-01-22 00:00:00"
    },
    {
      "id": "2339fc15-a065-4003-b88b-a5a3b4b862e8",
      "text": "Publication of legitimate but small, case‑based autopsy and myocarditis reports showing rare fatal events after vaccination (peer‑reviewed case reports and small series)",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "4173ffc9-354e-452a-a444-7d9dde76d9fd",
      "text": "WHO publication 'Considerations regarding consent in vaccinating children and adolescents between 6 and 17 years old' describes 'implied consent' as one approach",
      "date": "2014-05-12 00:00:00"
    },
    {
      "id": "32ee53b1-3b92-41bd-85c1-a621fc20e857",
      "text": "Public controversy and regulatory curtailment of Delta water export pumping to protect endangered delta smelt",
      "date": "2016-07-20 00:00:00"
    },
    {
      "id": "dad45bff-ff06-4b34-9960-c4c7ea3cf412",
      "text": "2002 Klamath River fish kill and disputes over irrigation curtailment",
      "date": "2002-02-05 00:00:00"
    },
    {
      "id": "bd67c3dc-14e3-4ded-86c5-85be907659f1",
      "text": "Governor Jerry Brown issues Executive Order B-29-15 mandating 25% statewide urban water-use reductions",
      "date": "2015-04-01 00:00:00"
    },
    {
      "id": "d925ee0d-72ad-4f96-bab2-3c5a09f04dc2",
      "text": "Oroville Dam spillway failure and emergency releases that forced evacuations",
      "date": "2017-02-24 00:00:00"
    },
    {
      "id": "cdd19715-7484-4236-b9cc-b7dac26ac393",
      "text": "Regulatory debate and slow approval process for new sunscreen active ingredients (Sunscreen Innovation Act enacted Nov 26, 2014; ongoing FDA reviews of sunscreen ingredient safety).",
      "date": "2014-11-26 00:00:00"
    },
    {
      "id": "6d08ef90-3b48-46b5-9e69-3c057632bca0",
      "text": "Published toxicology and endocrine-disruption research and reviews (e.g., reviews summarizing in vitro/animal evidence that some chemical UV filters like oxybenzone have endocrine activity).",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "2894861a-c18c-4d08-94f5-8b2fd4789c0d",
      "text": "April 2015 Calbuco eruption (Chile) — satellite and news reports quantified large volcanic gas/ash emissions during the explosive event.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "7bac9831-eff4-4b20-8a3c-ab13ebb3c9f6",
      "text": "Publication and dissemination (2011) of quantitative comparisons of volcanic vs. anthropogenic CO2 emissions (T.M. Gerlach, EOS/AGU summary and related USGS-hosted PDF).",
      "date": "2011-04-24 00:00:00"
    },
    {
      "id": "72235e9f-d176-482b-963f-03bb21b928c3",
      "text": "CDC and FDA recommend a temporary pause (April 2021) in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of a rare clotting disorder (TTS)",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "b05495fc-f92f-4944-b344-fb6bab4d2309",
      "text": "European Medicines Agency (EMA) finds a possible link between the AstraZeneca vaccine and very rare blood clotting events and recommends listing them as very rare side effects",
      "date": "2021-04-07 00:00:00"
    },
    {
      "id": "934e88c6-ea3a-405a-bc40-b792db0430c6",
      "text": "Israel reports a probable link between the Pfizer-BioNTech vaccine and a small number of myocarditis cases following vaccination",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "b69ad494-a55b-41ce-b287-247101576271",
      "text": "Japan finds foreign (black/stainless steel) particles in multiple Moderna vaccine vials, prompting suspension of specific lots",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "c8863369-10d7-4a7b-8a44-8be24f3cb312",
      "text": "IPCC release of the Special Report 'Global Warming of 1.5°C' (SR1.5)",
      "date": "2018-10-08 00:00:00"
    },
    {
      "id": "4d311c0d-a3bf-4639-886a-9ffc29181f73",
      "text": "IPBES Global Assessment Report on Biodiversity and Ecosystem Services (press release)",
      "date": "2019-05-06 00:00:00"
    },
    {
      "id": "d9adfed9-41e4-4849-9b15-4f60cb4702f5",
      "text": "Regulatory updates and clarifications on convalescent plasma donor eligibility by U.S. regulators (FDA guidance changes)",
      "date": "2021-02-24 00:00:00"
    },
    {
      "id": "27385007-232e-4547-9a01-a67e59484773",
      "text": "American Red Cross public guidance clarifying vaccinated people are eligible to donate (FAQ)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "48ac904f-cd28-45e1-8038-2afaf6d99d20",
      "text": "Different national blood-service wait times after COVID vaccination (e.g., Australia Lifeblood 3‑day deferral)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "ec8bc2d6-087b-49ee-bfc2-490c93c6fdd6",
      "text": "National HIV surveillance/monitoring reporting showing ongoing variant diversity and surveillance activity in the Netherlands (HIV Monitoring Report 2021)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "e91987c4-3173-40d3-a250-c5cc8957430f",
      "text": "Earlier research documenting an HIV recombinant (CRF19_cpx) associated with rapid progression to AIDS in Cuba (2015)",
      "date": "2015-01-28 00:00:00"
    },
    {
      "id": "043944c0-e98f-45d3-9b30-6dbd80f9fffa",
      "text": "Earlier punitive COVID-era measures: France suspends about 3,000 unvaccinated healthcare workers without pay after mandatory vaccination rules (September 2021).",
      "date": "2021-09-16 00:00:00"
    },
    {
      "id": "6fc0168e-30c0-49ba-975c-2c5f1930255e",
      "text": "French National Assembly adopts (first reading) Article 4 creating a new offence of \"provocation à l'abandon ou à l'abstention de soins\" (encouraging people to abandon medical treatment).",
      "date": "2024-02-14 00:00:00"
    },
    {
      "id": "9129f14c-e664-4d84-bab9-cdcd46688fce",
      "text": "Large, recurring anti‑vaccine and anti‑pass protests in France (e.g., national rallies with >100,000 participants on 9 January 2022 and major protests in 2021).",
      "date": "2022-01-09 00:00:00"
    },
    {
      "id": "d416a2a2-d6ef-44d4-882a-c230f7d1fa14",
      "text": "Article 4's text (as adopted) includes penalties up to one year in prison and €15,000 fine, rising to three years and €45,000 when the provocation 'has been followed by effects'.",
      "date": "2024-02-15 00:00:00"
    },
    {
      "id": "96d7d449-804f-49f9-9105-1f5aaae069fb",
      "text": "Ukraine files case and ITLOS issues provisional measures in dispute over detained Ukrainian naval vessels (Ukraine v. Russian Federation)",
      "date": "None"
    },
    {
      "id": "953806d4-b8b0-49ec-a28a-62b9d8739402",
      "text": "Kerch Strait incident: Russian forces fired on and seized three Ukrainian naval vessels",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "bf5fc7df-0949-4ea6-9783-f1e37cf285f7",
      "text": "Coverage noting Russia's gain of maritime/sea resource claims after annexation (media analysis of rights to offshore resources)",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "961644d6-94f7-45ac-8d44-584c0512aad4",
      "text": "Reporting on foreign volunteers and fighters joining both sides in the Donbas conflict (including fighters who joined Azov)",
      "date": "2014-09-01 00:00:00"
    },
    {
      "id": "303f9a7b-45ce-4950-8a4a-bb3e22b7370e",
      "text": "Publicised incidents in August 2014 where Ukraine displayed captured Russian servicemen",
      "date": "2014-08-26 00:00:00"
    },
    {
      "id": "43a97283-6531-4832-a402-4714ce15cac8",
      "text": "Norway investigation (January 2021) into deaths of 23 frail elderly patients shortly after Pfizer/BioNTech vaccination",
      "date": "2021-01-15 00:00:00"
    },
    {
      "id": "62b46015-1ee6-4431-af95-060d712b7892",
      "text": "World Bank reports sharp contraction in remittances to Ukraine in 2014–2015 (noting drops from Russia)",
      "date": "2015-04-13 00:00:00"
    },
    {
      "id": "0e2438b5-a88a-40f5-ae90-35c5e5255069",
      "text": "IMF approves a $17.5 billion loan program for Ukraine (March 2015)",
      "date": "2015-03-11 00:00:00"
    },
    {
      "id": "e2e9ccf6-55ae-4c59-8a0b-d4e161dbfff1",
      "text": "Russia announces and enforces bans/restrictions on Ukrainian food and agricultural imports",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "6890ec3a-637a-4135-bc44-7e9bf3e9ef98",
      "text": "Gazprom reduced/cut natural gas supplies to Ukraine amid pricing and payment disputes",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "acb60d43-f74d-4842-9c21-e426c3fce095",
      "text": "USDA launches the 'Partnerships for Climate‑Smart Commodities' program and announces $1 billion investment to support climate‑smart practices, including regenerative approaches (Feb 7, 2022).",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "aa31224d-f16d-4fd4-b8fc-8ec81c1cd22d",
      "text": "General Mills publicly commits to advancing regenerative agriculture on one million acres and launches partnerships and promotional materials (announced in 2020).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "a18ae506-7470-4bde-894a-d0fb16051223",
      "text": "Publication of scholarly review 'What Is Regenerative Agriculture? A Review of Scholar and Practitioner Definitions' (Frontiers in Sustainable Food Systems, 2020) documenting inconsistent definitions and mixed empirical evidence on soil outcomes.",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "efa19fa1-4ef0-48ca-9ca2-1c43c0e27c71",
      "text": "Case report: 'Development of High‑Grade Sarcoma After Second Dose of Moderna Vaccine' (Cureus case report).",
      "date": "2023-04-15 00:00:00"
    },
    {
      "id": "98fc72fc-2efd-493c-bb29-fc2db28bd4c0",
      "text": "Publication describing diagnostic pitfalls after COVID‑19 vaccination (e.g., post‑vaccine lymphadenopathy causing false‑positive oncologic imaging findings).",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "74c12cf0-8d3e-4381-954e-732587fd097a",
      "text": "Ukrainian leadership publicly framed parts of the conflict as involving 'foreign mercenaries' (statement by President Petro Poroshenko), drawing international attention to non‑Ukrainian fighters.",
      "date": "2014-07-26 00:00:00"
    },
    {
      "id": "36b676e0-edfc-4f67-960d-c3088417a648",
      "text": "Media reporting and profiles linked ASBS Othago to former Polish Interior Minister Bartłomiej Sienkiewicz and documented the firm's past activity/contracts (company background coverage in June 2014).",
      "date": "2014-06-05 00:00:00"
    },
    {
      "id": "e869fe57-fdea-4be6-b9b4-89324c3c6a7a",
      "text": "Separatist commander Igor Strelkov (Girkin) and associated militia briefings in late July 2014 repeatedly alleged that foreign mercenaries (including Poles) were operating and being killed in Donbas.",
      "date": "2014-07-28 00:00:00"
    },
    {
      "id": "84fe09cc-6641-4679-bf5d-a74ccb29a966",
      "text": "IPCC Fifth Assessment Report (AR5) — Summary for Policymakers (WG1)",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "66f3d2eb-3679-4a14-beed-197acfbfb172",
      "text": "U.S. announcement of withdrawal from the Paris Agreement (President Trump, June 2017)",
      "date": "2017-06-01 00:00:00"
    },
    {
      "id": "59368157-bfa7-4514-9718-0d32036571aa",
      "text": "Detailed reporting on Ukraine's use of electronic warfare to jam drones and communications",
      "date": "2024-03-12 00:00:00"
    },
    {
      "id": "88bda5e5-84df-4482-abf8-c5cb471e32e9",
      "text": "Explosion in Przewodów, Poland kills two amid Russia-Ukraine attacks",
      "date": "2022-11-15 00:00:00"
    },
    {
      "id": "785c826a-c93a-4e09-924d-cc315c89df5c",
      "text": "Coverage of the proliferation of small, portable EW systems ('EW backpacks') used by Ukrainian forces",
      "date": "2024-05-17 00:00:00"
    },
    {
      "id": "8dbca90d-3ec2-43b8-9f94-fb7d415b2e13",
      "text": "Reporting on routine use of drone swarms and the complexity of attribution in drone warfare",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "f83a2d02-d797-4320-8d6c-be5970798141",
      "text": "Precedent: Ukraine imposed sanctions/entry bans on foreign politicians (e.g., three French MEPs) who visited Crimea without Kyiv's permission.",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "a5f9f3ff-df2f-4178-ba6d-e8691931802f",
      "text": "ACT UP protests and high‑profile demonstrations targeting Burroughs Wellcome and regulators over AZT pricing, access and trial practices (1988–1989)",
      "date": "1989-09-14 00:00:00"
    },
    {
      "id": "9ad1f0a0-0e76-42cb-83ff-5b8a42cece86",
      "text": "FDA approval of AZT (zidovudine) in March 1987",
      "date": "1987-03-19 00:00:00"
    },
    {
      "id": "0f7b511d-5740-4b53-b4cf-cf3668c1adb3",
      "text": "2019 electoral performance of pro‑Russia parties (Opposition Platform — For Life) showing notable support in southern/eastern Ukraine in parliamentary elections.",
      "date": "2019-07-21 00:00:00"
    },
    {
      "id": "0f2dbe89-ff54-4477-85a8-ff103a065928",
      "text": "Release/presentation of the Resilient Ukraine 'National resilience characteristics' survey including Odesa results (Resilient Ukraine/ICDS research presented mid-November 2021).",
      "date": "2021-11-17 00:00:00"
    },
    {
      "id": "fd44c5b4-90fa-4d18-ac55-ea45f162f03f",
      "text": "2001 Ukrainian census language data for Odesa region showing a high share of Russian speakers.",
      "date": "2001-04-24 00:00:00"
    },
    {
      "id": "67a156bc-554c-4a0e-880a-2deb3629269a",
      "text": "May 2, 2014 Odesa trade union building fire and subsequent portrayal in Russian/state and pro‑Kremlin media.",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "e0f319dd-3d5e-4152-ad63-50bb36218856",
      "text": "Reporting on volunteer battalions and Ukrainian units using mixed, Soviet- or foreign-origin uniforms and equipment because of shortages (Reuters special report)",
      "date": "2015-07-29 00:00:00"
    },
    {
      "id": "a0455b45-eed1-47ed-84bf-d090b89b9897",
      "text": "OSCE Special Monitoring Mission reported observing convoys and personnel in Donetsk/Luhansk in unmarked dark-green uniforms and unmarked armoured vehicles (spot reports 2014)",
      "date": "2014-11-08 00:00:00"
    },
    {
      "id": "15f25853-5fa9-4955-91a0-1e974c7bd1f3",
      "text": "Publication of JAMA case series reporting 88.1% mortality among mechanically ventilated COVID‑19 patients in New York (Richardson et al., 5700 patients).",
      "date": "2020-04-22 00:00:00"
    },
    {
      "id": "6cc8284b-e23b-4ad8-9dd4-11f9c70af258",
      "text": "Japan suspends use/shipments of some Moderna vaccine batches after reports of foreign particles in vials",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "9e3c9e1f-d156-4487-b047-454702c0a0c9",
      "text": "Assassination of Arsen 'Motorola' Pavlov in an elevator explosion in Donetsk",
      "date": "2016-10-16 00:00:00"
    },
    {
      "id": "76936d38-bfd8-42aa-9bba-108527ac0852",
      "text": "Reports by human rights groups documenting repression and propaganda targeting Crimean Tatars (2014)",
      "date": "2014-11-24 00:00:00"
    },
    {
      "id": "ecda8d47-834e-45da-99ad-dde7a7cbc0d7",
      "text": "Large pro‑Ukraine rally organised by the Mejlis (February 26, 2014)",
      "date": "2014-02-26 00:00:00"
    },
    {
      "id": "834eac6b-77cc-451c-be6c-d70471e32525",
      "text": "Japan suspends proactive recommendation for the HPV vaccine",
      "date": "2013-06-24 00:00:00"
    },
    {
      "id": "b4eeaf9a-abd9-4af9-8860-51f96c268c6c",
      "text": "Controversy and parliamentary inquiry into HPV vaccine projects in India (PATH studies)",
      "date": "2010-04-24 00:00:00"
    },
    {
      "id": "b3dda178-d768-4eb7-bca5-8ff2b0536131",
      "text": "Increased public reporting and media coverage of adverse events (VAERS data highlighted) around 2015–2016",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "2bbb8dae-7e72-4910-b0bd-6037e113a97b",
      "text": "International Paralympic Committee (IPC) decision to allow Russian and Belarusian athletes to compete under their national flags at the Milano Cortina 2026 Paralympics.",
      "date": "2026-02-17 00:00:00"
    },
    {
      "id": "c8174195-85b1-4480-a278-cc0c29fcb947",
      "text": "Ukrainian government/officials announced they would boycott Paralympic officials' attendance (ceremonies) in protest while specifying that athletes would still compete.",
      "date": "2026-02-18 00:00:00"
    },
    {
      "id": "3753686f-7527-4b58-b712-4309746a6b70",
      "text": "New York Times report (June 25, 2022) on a covert 'commando network' of U.S. and allied forces coordinating weapons and assistance in Ukraine",
      "date": "2022-06-25 00:00:00"
    },
    {
      "id": "2c3b42e6-f19c-4c91-af10-c7605a5f690c",
      "text": "CIA Director William Burns publicly estimated roughly 15,000 Russian troops killed (U.S. intelligence estimate) at the Aspen Security Forum",
      "date": "2022-07-20 00:00:00"
    },
    {
      "id": "11cdeae2-1dc8-48e1-83bc-5c70082acb0c",
      "text": "FDA pediatric vaccine briefing document noted reported seizure events in surveillance/clinical data",
      "date": "2022-06-15 00:00:00"
    },
    {
      "id": "6c002b89-e22d-4a9d-84d8-0614fa3eef05",
      "text": "European Parliamentary Research Service brief explaining the religious split and the Tomos process (EPRS brief on Ukraine and religion published Jan 2019).",
      "date": "2019-01-24 00:00:00"
    },
    {
      "id": "7485585c-3515-4adb-8b93-cd0ad5ed2408",
      "text": "Media reports and commentary documented Poroshenko's 'Tomos tour' and use of the Tomos in his re-election campaign (coverage in KyivPost, Financial Times and others in Jan–Feb 2019).",
      "date": "2019-01-25 00:00:00"
    },
    {
      "id": "d9a29223-ea58-43db-9109-11643672ca5c",
      "text": "Ecumenical Patriarch Bartholomew signed and handed over the Tomos of Autocephaly for the Orthodox Church of Ukraine (Tomos ceremony and handover in Istanbul/Kyiv, early January 2019).",
      "date": "2019-01-05 00:00:00"
    },
    {
      "id": "f391b9ef-3cd8-4617-99f0-84f6432c1ffc",
      "text": "Ukrainska Pravda report that Polish special‑forces personnel guarded Ukrainian negotiators (Brest/early March 2022)",
      "date": "2023-03-14 00:00:00"
    },
    {
      "id": "85fa9dad-7806-4138-a1ec-773a473535e7",
      "text": "New York Times report revealing a 'commando network' of Western special-operations personnel assisting Ukraine",
      "date": "2022-06-25 00:00:00"
    },
    {
      "id": "cd74cf4e-d219-4588-8a7b-e6ec75763d78",
      "text": "Persistent academic and policy‑community discussions in Russia and elsewhere promoting the 'deep/abiogenic oil' idea (conferences, review articles and summaries circulated throughout the 2010s and continuing into the early 2020s)",
      "date": "None"
    },
    {
      "id": "ed1855f7-791a-4785-b6c7-f6f9d8667199",
      "text": "Experimental laboratory evidence (Kolesnikov et al., Nature Geoscience) showing that methane can produce heavier hydrocarbons under upper-mantle pressure‑temperature conditions (widely cited by abiogenic proponents)",
      "date": "2009-04-24 00:00:00"
    },
    {
      "id": "8e772879-8642-4b48-aa61-c37c293a6f2b",
      "text": "First confirmed delivery/arrival of German PzH 2000 howitzers to Ukraine",
      "date": "2022-06-21 00:00:00"
    },
    {
      "id": "e1757ed1-c85d-4332-b917-71cf14dd2068",
      "text": "Published research on extreme droughts and increased tree mortality in the Amazon (e.g., record‑breaking 2015/2016 drought analyses and 2016 Nature Scientific Reports paper).",
      "date": "2016-01-24 00:00:00"
    },
    {
      "id": "ae57dcfd-b1b4-4602-8a3e-9f8286a28377",
      "text": "Public interviews and quotes from climatologist Carlos Nobre (2019) stating that 'over fifty percent of the Amazon may be lost within decades' if tipping points are crossed.",
      "date": "2019-07-09 00:00:00"
    },
    {
      "id": "598d47df-b169-4963-92a9-f28dd18db4f1",
      "text": "Passage of Ukraine's 'decommunisation' laws and ensuing public debate, including renewed official attention to OUN/UPA memory",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "6453ddad-baec-4bc7-aa88-b3806c2802e7",
      "text": "Existence and history of paramilitary/nationalist groups using 'tryzub'‑related names and insignia (e.g., Tryzub organisation formed 1993)",
      "date": "1993-04-24 00:00:00"
    },
    {
      "id": "1ee2f603-31c1-46f0-af51-ae84193e204d",
      "text": "International reporting on the Azov volunteer unit's far‑right links and symbols (including 2014–2015 coverage)",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "01511c05-4227-4b01-abfa-7adc2de18c4b",
      "text": "Spanish‑language press and analyses highlighting the rise/role of ultranationalist groups in Ukraine",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "93afcf6d-ba2e-447e-9995-a3ca6b4f9702",
      "text": "Great Barrington Declaration advocating 'focused protection' and natural herd immunity",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "ded3ab8c-bdcb-4c30-ad91-5fa73f6e12ae",
      "text": "CDC launched the COVID-19 Seroprevalence Studies Hub (SeroHub)",
      "date": "2020-12-01 00:00:00"
    },
    {
      "id": "c797fa3a-d06d-4add-b0a1-28f55b2dde2b",
      "text": "SeroTracker dashboard providing compiled seroprevalence estimates",
      "date": "2020-07-23 00:00:00"
    },
    {
      "id": "96100367-5a4e-4d78-a813-979f5efc1ecf",
      "text": "Office for National Statistics (ONS) dataset 'Deaths by vaccination status, England' (period analyses up to May 2023)",
      "date": "2023-08-25 00:00:00"
    },
    {
      "id": "3e68195c-fd2b-4602-9af9-c8ad638afbf8",
      "text": "Early patient‑led surveys and small observational preprints reporting mixed effects of vaccination on long‑COVID symptoms (e.g., Massey et al. medRxiv July 2021)",
      "date": "2021-07-21 00:00:00"
    },
    {
      "id": "cd8a5b00-b145-4ba5-be1d-dd7b1127c2c1",
      "text": "Publication of Choi et al., 'Developmental Fluoride Neurotoxicity: A Systematic Review and Meta‑Analysis' in Environmental Health Perspectives (lead author Anna L. Choi, Harvard affiliation).",
      "date": "2012-10-24 00:00:00"
    },
    {
      "id": "d74678a1-6036-40eb-8476-e2f1df401b29",
      "text": "WHO Expert Committee review and public statements on cannabis (pre-review June 2018; outcomes published Jan 2019)",
      "date": "2019-01-24 00:00:00"
    },
    {
      "id": "117c6960-98c5-407d-adbb-50403c4f60b8",
      "text": "Preclinical studies showing cannabinoids can promote hippocampal neurogenesis (mid‑2000s lab research)",
      "date": "2005-04-24 00:00:00"
    },
    {
      "id": "b31b675a-f130-46e2-99f7-6f675e35c3d2",
      "text": "Ukraine filed an application instituting proceedings against the Russian Federation at the International Court of Justice (ICJ).",
      "date": "2017-01-16 00:00:00"
    },
    {
      "id": "5f37959e-6018-4d92-9ba7-3b806f923e57",
      "text": "Reports that U.S. intelligence and law‑enforcement personnel were advising Ukraine",
      "date": "2014-05-04 00:00:00"
    },
    {
      "id": "f9c4d73f-4e35-4fee-ad03-0cd1d0d52053",
      "text": "U.S. Ambassador Geoffrey Pyatt photographed paying respects at Kyiv's Maidan",
      "date": "2014-03-04 00:00:00"
    },
    {
      "id": "97d149af-33ce-4b66-b742-d5e7e4821c17",
      "text": "Ukraine's State Emergency Service and local reporting confirmed an apartment building on Lobanovs'koho Avenue was hit by a missile during strikes on Kyiv.",
      "date": "2022-02-26 00:00:00"
    },
    {
      "id": "53c3ec33-616d-49b9-b0e1-6ad2c89a153d",
      "text": "Russian missile strikes and intensified attacks in Sumy region (producing civilian casualties and damaged infrastructure)",
      "date": "2025-05-14 00:00:00"
    },
    {
      "id": "db5eef14-6285-4126-bad7-44440b0749c8",
      "text": "Previous high-profile deaths of Ukrainian servicewomen (example: combat medic Yana Rykhlitska killed in action)",
      "date": "2023-03-03 00:00:00"
    },
    {
      "id": "09fd71bd-0dc1-4229-a155-1ce1f65d0043",
      "text": "Public announcement and press coverage of Ukraine's new all-female drone unit ('Harpies') and recruitment drive",
      "date": "2025-04-04 00:00:00"
    },
    {
      "id": "56e67f7c-8309-4451-ae4b-1d9856d6eeed",
      "text": "Valentyn Nalyvaichenko had been appointed Head of the Security Service of Ukraine (SBU) in February 2014 and became a high-profile security official.",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "91f708ee-7cba-4390-b150-7deab02d3d24",
      "text": "Publicly known foreign-volunteer pathways to serve in the IDF (the 'Mahal' / volunteers-from-abroad tradition)",
      "date": "1948-04-24 00:00:00"
    },
    {
      "id": "4461c591-8c87-42be-8bb5-4fdcd0527da2",
      "text": "Large influx of Ukrainian refugees to Israel after Russia's 2022 invasion",
      "date": "2022-03-13 00:00:00"
    },
    {
      "id": "d7495a8d-b6bf-45d5-82cc-77b0c6709d76",
      "text": "Hamas surprise attack on Israel and ensuing nationwide mobilization (Oct 7, 2023)",
      "date": "2023-10-07 00:00:00"
    },
    {
      "id": "106d0690-bc30-4ba9-b26a-bfd0aab06097",
      "text": "Heavy fighting and Ukrainian forces retake Donetsk airport, with immediate reports of dozens killed and injured",
      "date": "2014-05-27 00:00:00"
    },
    {
      "id": "e09c492d-dc02-4e43-a62f-0b99fce6e857",
      "text": "Widespread reporting that Boris Nemtsov was a prominent Kremlin critic and vocal supporter of Ukraine",
      "date": "2015-02-27 00:00:00"
    },
    {
      "id": "664a9a05-83f7-4192-a8aa-723b08092688",
      "text": "U.S. Ambassador John Tefft publicly laid flowers at the makeshift Nemtsov memorial near the Kremlin",
      "date": "2015-02-28 00:00:00"
    },
    {
      "id": "3664a7d9-e25a-4d5f-b859-f0974d7e61a7",
      "text": "Reports of foreigners and 'protest tourists' crossing from Russia into eastern Ukraine",
      "date": "2014-03-04 00:00:00"
    },
    {
      "id": "2546d442-0582-40eb-a74c-4f9a3f2175f3",
      "text": "High‑profile history and public memory of U.S. private military firms (e.g., Blackwater) from Iraq",
      "date": "2007-10-01 00:00:00"
    },
    {
      "id": "c6c11fec-cd76-4fb3-b134-d707839cb5b9",
      "text": "Pro‑Russian protesters and armed men seize Donetsk regional government building",
      "date": "2014-03-03 00:00:00"
    },
    {
      "id": "0d8942c4-d969-40ab-9b61-d3b6492557d5",
      "text": "Unmarked, heavily armed 'little green men' operate in Crimea, raising questions about covert foreign forces",
      "date": "2014-03-11 00:00:00"
    },
    {
      "id": "d2754557-5225-4fbc-b72c-765dc38aa10f",
      "text": "CDC release and analyses of NHANES dental fluorosis data (analysis of 1999–2004 and 2011–2016 data; Vital and Health Statistics Series 2 No. 183).",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "d78ac63e-0777-404d-a654-3314aa76042a",
      "text": "FDA‑required poison warning language on fluoride toothpastes and Poison Control guidance advising to contact poison control if a child swallows more than used for brushing.",
      "date": "None"
    },
    {
      "id": "213e163f-1e64-4323-8b73-a5c2a90f2b24",
      "text": "Later laboratory research reporting synergistic inhibitory effects of capsaicinoids on platelet aggregation (e.g., Blood Coag Fibrinolysis / related 2018 study).",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "5638d4fe-e14b-4e6d-94f2-5f9ec535a289",
      "text": "Polish media coverage of the Bykivnia visit and related Polish‑Ukrainian historical memory issues (coverage in outlets such as Dziennik.pl / Polskie Radio).",
      "date": "2015-09-17 00:00:00"
    },
    {
      "id": "1f4fadc4-9fc6-4b18-b2df-9e047f2a73a0",
      "text": "CDC recommended community use of cloth face coverings (change in U.S. guidance)",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "38efd15b-f73c-4767-9fdb-679b3456f1cc",
      "text": "CDC/NCHS issued expanded guidance on certifying deaths due to COVID-19",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "2617aa50-867a-4602-a99c-970cd4c26ee1",
      "text": "WHO interim guidance stated limited direct evidence for universal masking in healthy community members",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "0c59c578-172e-4be5-b4ab-8cb8b1bee19b",
      "text": "Official surveillance reporting showed an unusually low influenza season during the COVID-19 pandemic",
      "date": "2020-12-12 00:00:00"
    },
    {
      "id": "d0b0335f-9ef1-4789-b5b2-1ae2f8c35f7d",
      "text": "IPCC Fifth Assessment Report (AR5) Summary for Policymakers states strong evidence of human influence on the climate system",
      "date": "2013-09-27 00:00:00"
    },
    {
      "id": "8d0bcf05-53d3-4273-9d46-e6cf0ecd6408",
      "text": "NSIDC and NASA report record-low Arctic sea ice extent in 2007",
      "date": "2007-09-24 00:00:00"
    },
    {
      "id": "361c4fe2-6085-4074-9642-b1385f2801ec",
      "text": "Adoption of the Paris Agreement at COP21, driving major political attention to climate policy",
      "date": "2015-12-12 00:00:00"
    },
    {
      "id": "97bbf6bc-4a68-48cc-abcd-8c6783ec1632",
      "text": "Ukrainian authorities released video footage they said showed a Buk missile launcher being moved in rebel‑held eastern Ukraine",
      "date": "2014-07-18 00:00:00"
    },
    {
      "id": "db1344a5-89a1-4347-abea-67f0dd3f8aaf",
      "text": "Pro‑Russian separatists and armed groups restricted and controlled access to the MH17 crash site, and international observers reported limited/unfettered access and allegations of tampering",
      "date": "2014-07-18 00:00:00"
    },
    {
      "id": "06607014-2653-4fbd-a38d-5fc623dcd790",
      "text": "Germany publicly approved and announced it would send Leopard 2 main battle tanks to Ukraine, prompting high-profile media coverage.",
      "date": "2023-01-25 00:00:00"
    },
    {
      "id": "463b0a4d-fbae-49b8-8f14-ea008bffbf2a",
      "text": "Russian leadership and state media advanced a 'denazification' narrative about Ukraine beginning with Putin's public addresses in February 2022.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "7a6466fb-3b7d-4380-8b37-aaa5ae4f5f3a",
      "text": "FDA issued authorizations in September 2022 for updated (bivalent) COVID‑19 booster doses under Emergency Use Authorization rather than new full biologics license approvals.",
      "date": "2022-09-01 00:00:00"
    },
    {
      "id": "0fd9ac7f-c2d2-4356-9fd6-d37fb0923518",
      "text": "FDA formally approved the Pfizer–BioNTech COVID-19 vaccine (Comirnaty) — first COVID-19 vaccine to receive full FDA approval.",
      "date": "2021-08-23 00:00:00"
    },
    {
      "id": "92b8025d-d2b5-4360-bcc2-16c84a7cef8d",
      "text": "UN and international media reporting (May 2014) documenting allegations of abuses by volunteer battalions and armed groups in eastern Ukraine",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "348c5251-424b-4d51-ad66-ecc700fe6862",
      "text": "Formation of the Dnipro‑1 volunteer/special police battalion in April 2014, linked to local oligarchic support",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "bc6d6f5d-0060-46d6-9831-0165ac9c5060",
      "text": "Violent crackdown on Euromaidan protesters in Feb 2014, including widely reported beatings with batons and sticks",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "2663a5a4-ee2d-4be2-824b-022f551c7755",
      "text": "Ihor Kolomoisky appointed governor of Dnipropetrovsk Oblast, giving him formal regional authority and visibility",
      "date": "2014-03-02 00:00:00"
    },
    {
      "id": "76636031-6955-46e5-a38f-1c8ceea4854d",
      "text": "Odessa trade-union building fire and mass deaths during clashes",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "3dc6e4d7-c188-457b-aa1e-490262eebc3a",
      "text": "Public torchlight marches and commemorations for Stepan Bandera in 2014 (Lviv and elsewhere)",
      "date": "2014-01-01 00:00:00"
    },
    {
      "id": "45ed405d-d63f-4b74-ac4e-09d559d82b9f",
      "text": "Prominent role and publicized violence of Right Sector during Euromaidan/early 2014",
      "date": "2014-01-27 00:00:00"
    },
    {
      "id": "a12a73b8-1940-447d-b9e7-76cb08c90246",
      "text": "Japan suspended use/withdrew batches of Moderna COVID‑19 vaccine in August 2021 after reports of particulate contamination in some vials.",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "9c556d16-49aa-4261-978e-9d32978e28c2",
      "text": "Publication of Tokyo autopsy series (Legal Medicine) reporting autopsy findings for deaths occurring shortly after COVID‑19 vaccination and noting a small number of cases with possible vaccine‑related causes (e.g., myocarditis, thrombosis) — November 2022.",
      "date": "2022-11-24 00:00:00"
    },
    {
      "id": "bedf361f-e294-471e-9129-126f1e8eff4b",
      "text": "National Academies report (December 2020) assessing unexplained health incidents among U.S. government personnel concluded that directed, pulsed radio‑frequency (RF) energy is a plausible mechanism for some cases ('Havana Syndrome' assessment).",
      "date": "2020-12-05 00:00:00"
    },
    {
      "id": "bd7f3a70-71e0-431d-87a6-31f1e99c6081",
      "text": "Media reporting on China’s expansion of large-scale weather‑modification programs (cloud‑seeding and the proposed ‘Sky River/Tianhe’ projects) intensified in late 2017–2020 (notably coverage in Dec 2020).",
      "date": "2020-12-15 00:00:00"
    },
    {
      "id": "2be94a8c-a787-42cf-87d7-6040ce277c99",
      "text": "University of Alaska Fairbanks (UAF) formally received operation of the HAARP facility from the U.S. Air Force and opened the site to civilian researchers and public outreach (transfer ceremony and subsequent open house).",
      "date": "2015-08-11 00:00:00"
    },
    {
      "id": "8a98103c-3be3-41e1-bacb-d9b663a6a20b",
      "text": "Venezuelan President Hugo Chávez publicly suggested a 'tectonic weapon' or U.S. involvement caused the 2010 Haiti earthquake, and political leaders and commentators repeated similar claims after major quakes (2010–2011).",
      "date": "2010-01-24 00:00:00"
    },
    {
      "id": "f63d2f7e-ba61-4644-9687-b3fd07cde285",
      "text": "Ukrainian Foreign Ministry summoned the Polish Ambassador to Kyiv (Jan Piekło) in response to statements by Poland's foreign minister.",
      "date": "2017-07-06 00:00:00"
    },
    {
      "id": "9d638d6a-2493-48e4-a0b2-27751c44abe3",
      "text": "Poland's Ambassador to Ukraine Jan Piekło publicly said Poland and the United States could be part of alternatives to the Minsk process and argued that Crimea should be on the Minsk talks agenda.",
      "date": "2016-11-11 00:00:00"
    },
    {
      "id": "2e7d9d9c-e144-4fdb-a9ff-6415313fbafb",
      "text": "Reports quoting former Polish foreign minister Radosław Sikorski that Vladimir Putin in 2008 allegedly suggested dividing Ukraine with Poland (widely publicized in 2014).",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "b87b8799-7e39-4852-ac42-d2fad565035c",
      "text": "Polish Foreign Minister Witold Waszczykowski gave a combative interview to weekly 'wSieci', saying, among other remarks, 'With Bandera you won't enter Europe' and criticizing Ukrainian historical politics.",
      "date": "2017-07-03 00:00:00"
    },
    {
      "id": "c4307a80-d504-463a-92ff-83520b5b3bf0",
      "text": "2012 'Blood, Urine, and Sweat (BUS)' studies reporting detectable levels of some toxicants in sweat",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "0b881e1e-e5dc-460a-afee-ba5cedcde849",
      "text": "FDA warning letter (July 5, 2022) to a company marketing an infrared sauna with unapproved therapeutic/detox claims",
      "date": "2022-07-05 00:00:00"
    },
    {
      "id": "957a492a-475c-41c8-9568-337092ec1cc5",
      "text": "Publication of 2015 JAMA Internal Medicine study linking frequent sauna use to lower all-cause and cardiovascular mortality",
      "date": "2015-02-23 00:00:00"
    },
    {
      "id": "2110a1e1-18e1-4cce-bc77-b88d972fa54b",
      "text": "Amnesty International published reporting documenting civilian deaths and indiscriminate attacks in Donbas, Ukraine (providing background of real civilian suffering)",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "9d62ef5b-8cd6-418c-81fd-f90b01232f69",
      "text": "Public U.S. warnings linking continued international support to Ukraine's anti‑corruption progress (December 2015 coverage)",
      "date": "2015-12-08 00:00:00"
    },
    {
      "id": "af5749c3-42e7-462a-9271-b1a7eef7311e",
      "text": "Hunter Biden appointed to the Burisma board (widely reported in 2014)",
      "date": "2014-05-12 00:00:00"
    },
    {
      "id": "16306e57-4df7-442c-9b3d-6890127882dc",
      "text": "Historical precedent of Ukrainian naval vessels being decommissioned and scrapped in prior years (public records and lists of former warships show multiple vessels written off or dismantled).",
      "date": "None"
    },
    {
      "id": "a841d3b3-c4e2-40b0-90d5-36b500b9b56f",
      "text": "The Okean (Ocean) Mykolaiv shipyard complex was sold at auction to Annona Trading House for UAH 122.195 million (about $4.3 million).",
      "date": "2018-12-03 00:00:00"
    },
    {
      "id": "61cc0da6-6ed5-4bd2-97eb-538a915cb8e2",
      "text": "Local reporting and commentary documented the shipyard's long-term decline and degraded equipment under previous ownership (public discussion by local officials and regional press about dereliction and need for investment).",
      "date": "2018-12-24 00:00:00"
    },
    {
      "id": "cd86d5b0-77df-4ca8-8d16-327883347bba",
      "text": "House Science Committee hearing and whistleblower accusations about NOAA data handling",
      "date": "2017-02-24 00:00:00"
    },
    {
      "id": "f15b39c5-3294-48c0-b492-b81bbdf6d383",
      "text": "NASA GISS documentation of methodological updates to the GISTEMP record",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "a9b9e630-c878-4243-b1d0-c7481e5d08d9",
      "text": "NOAA Coral Reef Watch documents a global-scale coral bleaching episode affecting reefs worldwide during 2014–2016 (the largest recorded to date).",
      "date": "None"
    },
    {
      "id": "46f32c1e-d465-4fc4-b968-907dc6b4f887",
      "text": "ISW Russian Offensive Campaign Assessment (weekly assessments around Nov 11, 2024 noting Russian tactical gains such as leveraging Vuhledar seizure)",
      "date": "2024-11-11 00:00:00"
    },
    {
      "id": "d71e7342-5b91-4f09-952e-face150e4892",
      "text": "Reporting that Trump advisers proposed halting U.S. military aid to Ukraine unless Kyiv negotiated (June 25, 2024 Reuters)",
      "date": "2024-06-25 00:00:00"
    },
    {
      "id": "3a0473ad-e8ad-48e5-a328-e6c97951e25a",
      "text": "CNN publishes/airborne footage and reporting in early September 2024 showing videos of Ukrainian soldiers attempting to surrender and one apparent execution",
      "date": "2024-09-06 00:00:00"
    },
    {
      "id": "e487dd26-9a73-4505-9dd4-ad1bdc612ce9",
      "text": "Russian strikes on Kyiv (10 June 2025) damaged a building identified by some outlets as the 'former British visa centre'",
      "date": "2025-06-10 00:00:00"
    },
    {
      "id": "2f5b4398-ece6-448c-b575-e405459872ba",
      "text": "Official suspension/relocation of UK visa/consular services from Kyiv during March 2022",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "551e0255-ced9-4f0b-8d2a-fdd55f8a8add",
      "text": "CDC issued expanded guidance on certifying COVID-19 deaths allowing confirmed and probable cases to be recorded and included in counts.",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "258dc20c-5542-4f84-b93a-b9a7bf4d9980",
      "text": "Italian National Institute of Health (ISS) reports showed a high proportion of COVID-19 deaths had multiple pre-existing conditions.",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "5a1b9213-c394-4034-ad93-9f5c23db6c2c",
      "text": "FDA authorizes Pfizer-BioNTech and Moderna COVID-19 vaccines for children down to 6 months old",
      "date": "2022-06-17 00:00:00"
    },
    {
      "id": "77273e0c-48f2-49d3-bed3-e1b2adffa13d",
      "text": "CDC publishes MMWR update on cases of myocarditis after mRNA COVID-19 vaccination in adolescents and young adults",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "867d64b1-1e90-4105-980a-65a7665e1be7",
      "text": "President Zelensky announced the creation of an 'International Legion' and Ukraine openly called for foreign volunteers in late February 2022.",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "27a62bb6-250b-4b0d-9a85-ff22e9c61014",
      "text": "Ukraine imposed martial law and restrictions on men aged 18–60 leaving the country after the full‑scale invasion, generating widespread reports that men could not leave to avoid conscription.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "0fa828cb-652d-4343-bdf2-1b70c654f860",
      "text": "UK Foreign Office advised British nationals to leave Ukraine and temporarily relocated its embassy office from Kyiv to Lviv amid the Russian build‑up.",
      "date": "2022-02-18 00:00:00"
    },
    {
      "id": "4522a830-0495-4185-9d3b-e70ed737580f",
      "text": "Ukraine enacted further mobilization/conscription measures and parliamentary changes to expand recruitment in mid‑2024, attracting renewed international media attention.",
      "date": "2024-07-24 00:00:00"
    },
    {
      "id": "50896647-c40e-4e4c-8cd3-a5b143cccb42",
      "text": "Major anti-corruption probe and arrests tied to alleged fraud in Ukrainian arms procurement",
      "date": "2023-12-24 00:00:00"
    },
    {
      "id": "b5b333e9-b9a1-4bbb-892a-f0a5c0cf934c",
      "text": "Reporting on soldier and veteran grievances over pay, conditions and budget shortfalls",
      "date": "2023-11-24 00:00:00"
    },
    {
      "id": "b2975098-e936-4fe2-9d6f-f693e951414e",
      "text": "Media coverage that Western defence contractors and arms firms saw revenue gains linked to the Ukraine war",
      "date": "2023-10-24 00:00:00"
    },
    {
      "id": "dba1fcfa-1008-4572-956b-b72a79251c5f",
      "text": "Documentation of pro‑Kremlin narratives claiming Western military aid ‘prolongs the war’",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "bcdc6113-5e07-4cdb-921e-de72d3e763d5",
      "text": "Mainstream reporting on official research into solar geoengineering / stratospheric aerosol injection (interpreted by some as 'admissions' of atmospheric spraying).",
      "date": "2022-10-20 00:00:00"
    },
    {
      "id": "4e17ab58-8c71-480c-bf10-fc4db6bed7b2",
      "text": "Publication of the 2017 '5G Appeal' by >180 scientists and doctors calling for a moratorium on 5G",
      "date": "2017-09-24 00:00:00"
    },
    {
      "id": "e3e89324-4656-4d27-a1d9-94722e6901ad",
      "text": "Germany granted final permit for Nord Stream 2 (March 2018)",
      "date": "2018-03-27 00:00:00"
    },
    {
      "id": "42ffdc91-3f9e-47d1-add9-ad79f41aaeec",
      "text": "Naftogaz announced Ukraine would resume buying gas from Russia in 2018",
      "date": "2018-03-24 00:00:00"
    },
    {
      "id": "76394907-afb7-4f37-aa2f-dfc7477afba4",
      "text": "Late-November 2018 cold snap in Europe caused sharp rise in gas demand and prices",
      "date": "2018-11-24 00:00:00"
    },
    {
      "id": "c98d893d-cd1a-40eb-b36d-90cf5c2bfe20",
      "text": "Opinion polls in late January 2023 showing German public divided on sending heavy tanks to Ukraine",
      "date": "2023-01-23 00:00:00"
    },
    {
      "id": "7b32af01-f3a7-43ff-b41e-0bc643bdd5f1",
      "text": "Media coverage (e.g., The Guardian, Jan 25 2023) highlighting Chancellor Scholz's hesitation and street‑level opposition rhetoric",
      "date": "2023-01-25 00:00:00"
    },
    {
      "id": "14cda19e-74cc-4ecf-8ee1-e7aa8c095c28",
      "text": "Human Rights Watch report documenting use of unguided rockets in eastern Ukraine",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "e0b44114-1fb9-4ef0-871f-a8437348bcf5",
      "text": "Amnesty International / civil‑society reporting of widespread artillery and rocket casualties in summer 2014",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "eafe14c6-be1c-4e43-948f-180d45325b0f",
      "text": "Downing of Malaysia Airlines Flight MH17 over eastern Ukraine",
      "date": "2014-07-17 00:00:00"
    },
    {
      "id": "287004c0-d2da-42f4-a8dc-a194c801f9ba",
      "text": "Ukraine imposed a moratorium on repayment of a $3 billion eurobond held by Russia (Kyiv halted the payment).",
      "date": "2015-12-31 00:00:00"
    },
    {
      "id": "0665bcfb-b907-4224-a4e8-51b2e0d54305",
      "text": "The IMF publicly delayed/withheld a scheduled loan tranche to Ukraine in mid-2016 amid concerns over reform benchmarks and governance.",
      "date": "2016-07-20 00:00:00"
    },
    {
      "id": "43352cae-dd71-4592-a427-b23d73f649d9",
      "text": "Fitch Ratings downgraded Ukraine's long-term foreign-currency issuer default rating to 'CC' (placing it close to default territory).",
      "date": "2015-02-13 00:00:00"
    },
    {
      "id": "52fba235-b03c-49b6-ab3f-c6ceeb4c9806",
      "text": "Ukraine agreed a major debt restructuring with private creditors (restructuring of roughly $15–18 billion of foreign debt).",
      "date": "2015-08-28 00:00:00"
    },
    {
      "id": "c069ae08-6f59-4d93-8609-d8829dea6c9f",
      "text": "Business Insider coverage highlights Starbucks filing multiple trademark/patent applications in Russia",
      "date": "2024-06-06 00:00:00"
    },
    {
      "id": "00b33441-6dea-4d54-b5b9-21f710682ec4",
      "text": "Starbucks suspends operations and announces exit from Russia after invasion of Ukraine",
      "date": "2022-03-08 00:00:00"
    },
    {
      "id": "a55875c9-7d6b-4478-b251-ac04d3928e82",
      "text": "MedRxiv preprint by Zhao et al. reported an association between ABO blood group and COVID-19 susceptibility (blood group O less frequent among cases).",
      "date": "2020-03-27 00:00:00"
    },
    {
      "id": "98ec7a74-249a-4a7d-bd29-61f25b29ccdb",
      "text": "FDA communication and draft guidance clarifying aluminum limits for parenteral nutrition (recommending total allowable aluminum exposure from parenteral nutrition should not exceed 5 mcg/kg/day)",
      "date": "2023-02-09 00:00:00"
    },
    {
      "id": "2ad90890-99e8-4cc3-91d4-03708a493250",
      "text": "Authoritative vaccine‑education pages comparing vaccine aluminum to dietary/environmental exposures (e.g., Children's Hospital of Philadelphia vaccine education center material explaining aluminum exposure context)",
      "date": "None"
    },
    {
      "id": "bb6d5a06-ec73-4f94-806e-44f667b2d397",
      "text": "Ukrainian authorities announced lists/blacklists of Russian artists (around 40) who were banned from entering Ukraine for illegal visits to Crimea (2014–2017 reporting).",
      "date": "2017-05-24 00:00:00"
    },
    {
      "id": "a7020c38-115d-4d56-bbeb-0749cb7b1e62",
      "text": "Ukraine and international reports (US State Department, EU statements) documented legal and administrative restrictions and sanctions related to Crimea as an occupied territory (2014–2018 reporting).",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "3c4d9422-aa3c-4dbd-8939-0d4599a471d0",
      "text": "Hundreds of trucks were reported stranded/blocked at checkpoints on the Ukraine–Crimea administrative border during the September 2015 blockade.",
      "date": "2015-09-22 00:00:00"
    },
    {
      "id": "d06c2086-8592-4a20-9648-27a514db85d9",
      "text": "President Petro Poroshenko signed Decree No. 549/2015 (September 16, 2015) introducing personal and economic sanctions related to the Crimea/Russia situation.",
      "date": "2015-09-16 00:00:00"
    },
    {
      "id": "83d70978-7c6f-4749-a5c3-e16c0881df83",
      "text": "EU and Western measures enacted in 2014 imposed trade and import bans on goods/services related to Crimea (broader international restrictions on commerce with the peninsula).",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "9dd231ed-6549-4426-b246-32f1eaded4e4",
      "text": "Explosions damaged power lines on November 22, 2015, causing a near‑islandwide blackout in Crimea.",
      "date": "2015-11-22 00:00:00"
    },
    {
      "id": "4680599f-6612-48bd-85c1-987e66f1852a",
      "text": "Russia begins issuing passports to residents of occupied parts of Donetsk and Luhansk (first issuance mid‑June 2019)",
      "date": "2019-06-14 00:00:00"
    },
    {
      "id": "8117f173-a92e-4259-a53e-252c36a5b242",
      "text": "Reporting that the EU was developing guidance on non‑recognition and visa handling for Russia‑issued Donbas passports (summer 2019)",
      "date": "2019-08-24 00:00:00"
    },
    {
      "id": "1a9a2509-178b-45b9-90b3-58c0c9cc178a",
      "text": "March 2017 — Reporting on shelling risks to water‑treatment sites storing large chlorine stocks around Donetsk",
      "date": "2017-03-10 00:00:00"
    },
    {
      "id": "58f7c1b7-d0ad-4051-acf9-3fdbd867dc54",
      "text": "May 2015 — DPR (pro‑Russian) claims alleging Kyiv/US plotting to use chemical weapons against separatists",
      "date": "2015-05-29 00:00:00"
    },
    {
      "id": "6edde202-5b09-4348-b751-085ef532a3d1",
      "text": "Parliament adopted the Law of Ukraine 'On the Electricity Market' (electricity market reform)",
      "date": "2017-04-13 00:00:00"
    },
    {
      "id": "c35ca50a-39a1-42f0-8764-439d3656003d",
      "text": "Ukrenergo / NCER announced a tariff rise for the national grid (12.2% increase) from April 2017",
      "date": "2017-04-01 00:00:00"
    },
    {
      "id": "c20c54ac-f57e-4fb1-a13e-01290926d93d",
      "text": "CDC/ACIP recommendation against using the FluMist (live attenuated intranasal) vaccine for the 2016–2017 season due to low effectiveness",
      "date": "2016-06-22 00:00:00"
    },
    {
      "id": "1944b1ba-3007-48ba-baa6-e92a61fb0155",
      "text": "Scientific and clinical literature reviews (2023) documenting that needle-biopsy 'seeding' is rare and biopsies remain standard practice",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "133fb199-09bf-4edb-ba79-2d36ce99b94e",
      "text": "Conviction and high-profile reporting on Tullio Simoncini, promoter of baking-soda and antifungal cancer theories",
      "date": "2018-01-24 00:00:00"
    },
    {
      "id": "8b0c8798-1366-4de3-9ac0-fa3e96f20c52",
      "text": "Israeli health ministry study reported a probable link between Pfizer-BioNTech vaccine and a small number of myocarditis cases",
      "date": "2021-06-01 00:00:00"
    },
    {
      "id": "e1bcb563-e899-4015-86ae-5d076ad11cc1",
      "text": "Public documentation of Western grants to Ukrainian civil society (e.g., National Endowment for Democracy annual reports listing grants to Ukraine-related groups).",
      "date": "None"
    },
    {
      "id": "fdc26a8f-16d2-4d86-b728-870089471c1f",
      "text": "Ukraine Prosecutor General announced identification of 'titushky' operatives and people who hired them (investigations in March 2014).",
      "date": "2014-03-13 00:00:00"
    },
    {
      "id": "654b6ee9-da37-475b-8ca0-1c7c9d1b92a4",
      "text": "U.S. officials and media reported evidence that pro‑Russian demonstrators in eastern Ukraine were likely being paid (statements and coverage around 7–8 April 2014).",
      "date": "2014-04-07 00:00:00"
    },
    {
      "id": "fecf7f2d-ea04-469b-810f-67960991e690",
      "text": "IPCC Working Group II (AR6) report release — 'Climate Change 2022: Impacts, Adaptation and Vulnerability' (press release)",
      "date": "2022-02-28 00:00:00"
    },
    {
      "id": "9c1de945-a8c0-4007-85d2-ab4e1cc29c97",
      "text": "Western/Central Europe extreme rainfall and floods (July 2021) and attribution analyses",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "cfefb447-4f9b-46cc-b663-96d20f429d34",
      "text": "Pacific Northwest extreme heatwave (late June 2021) and rapid attribution studies",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "0305278e-ed35-4d8a-a0b3-2bfe4fe16224",
      "text": "Early clinical reports and case series documented severe hypoxemia and respiratory failure in COVID‑19 patients (e.g., Huang et al., The Lancet clinical features report).",
      "date": "2020-01-24 00:00:00"
    },
    {
      "id": "8aa157bf-ab31-4e25-b3ed-663d0cba705e",
      "text": "U.S. Ninth Circuit Court of Appeals opinion reviving lawsuit over LAUSD COVID-19 vaccine mandate (panel decision referenced plaintiffs' arguments about whether mRNA COVID-19 shots meet a legal/medical definition of \"vaccine\").",
      "date": "2024-06-07 00:00:00"
    },
    {
      "id": "b1753787-75a4-4d77-980e-1cdd9b70c499",
      "text": "CDC wording change on its web definition of \"vaccine\" in 2021 (language shifted from phrasing that implied absolute prevention of disease to wording emphasizing stimulating an immune response / producing immunity).",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "31cb46a5-aa5c-4bd9-929a-941d8a026f3f",
      "text": "Ukrainian tactical pullbacks around Bakhmut reported amid renewed Russian assaults",
      "date": "2023-04-14 00:00:00"
    },
    {
      "id": "d0c92ac4-1992-4990-980b-2158d9d1f304",
      "text": "Peer-reviewed case report: PNH diagnosis and hemolytic flare following mRNA COVID-19 vaccination",
      "date": "2021-12-30 00:00:00"
    },
    {
      "id": "7af4f83d-eee1-4b0a-bd8d-b156233a65a2",
      "text": "Prominent pro‑Russian journalist Oles Buzina shot dead in Kyiv",
      "date": "2015-04-16 00:00:00"
    },
    {
      "id": "57482d6f-8527-49ca-b1e4-aa0481fb84af",
      "text": "International press‑freedom monitors document multiple journalist deaths and attacks in Ukraine (2014–2015)",
      "date": "None"
    },
    {
      "id": "e9f9a540-7ab3-4dad-a019-1dadae170d43",
      "text": "Italian photojournalist Andrea Rocchelli killed while covering fighting in eastern Ukraine",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "ee13169e-2427-4386-bcbc-81d32c5240bf",
      "text": "Verkhovna Rada passes Law No. 314‑VIII recognizing OUN‑UPA and other groups as 'fighters for Ukrainian independence'",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "bc81656f-dcd2-4cdb-98cf-067c7fe2086a",
      "text": "Ukraine enacts 'decommunization' laws banning Soviet/Nazi symbols and mandating removal of related monuments",
      "date": "2015-05-15 00:00:00"
    },
    {
      "id": "501932eb-8e4e-4348-bb4c-961a5d7a5c51",
      "text": "Kyiv City Council renames Moskovskyi (Moscow) Prospekt to Stepan Bandera Avenue",
      "date": "2016-07-07 00:00:00"
    },
    {
      "id": "e726a95b-d5c0-429e-b55e-aa22b0826505",
      "text": "Ukrainian Il‑76 transport aircraft carrying troops (including paratroopers) was shot down near Luhansk, killing dozens of soldiers.",
      "date": "2014-06-14 00:00:00"
    },
    {
      "id": "32309a16-bc51-4681-a2db-b488abed842b",
      "text": "Standoffs and non‑engagements by Ukrainian servicemen in Crimea (notably the Belbek air base confrontation) where troops were shown not to fire on Russian forces.",
      "date": "2014-03-04 00:00:00"
    },
    {
      "id": "24401186-060e-4f23-8917-efbe8d9758cd",
      "text": "CDC released guidance on certifying COVID-19 deaths that allowed listing confirmed or probable COVID-19 as the underlying cause",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "ed9e92b3-a72b-407b-950d-76f4ea220467",
      "text": "Ukrainian government spokespeople and Ukrainian media reported that separatist/Pro‑Russian fighters were shelling residential areas in and around Donetsk, including Makeevka.",
      "date": "2014-08-20 00:00:00"
    },
    {
      "id": "dfe5731b-cf2f-4ee4-9e26-12eaac68b4f7",
      "text": "Wire and photo services (Reuters / Thomson Reuters Trust) published images and on‑the‑ground reporting showing apartment blocks and streets in Makiivka/Makeevka damaged by shelling (images dated 19–20 August 2014).",
      "date": "2014-08-19 00:00:00"
    },
    {
      "id": "07fc3f18-2f76-41a0-accb-9c0bbadb3e41",
      "text": "Kerry defends the US effort to forge a Syria ceasefire amid public and Pentagon skepticism.",
      "date": "2016-02-23 00:00:00"
    },
    {
      "id": "2ba8d4cc-a5e3-419d-9e4c-ee2b544fdb4c",
      "text": "US and Russia announce terms for a 'cessation of hostilities' in Syria after talks in Munich.",
      "date": "2016-02-12 00:00:00"
    },
    {
      "id": "b9773562-fdb8-4302-8c5e-e2c8aa0498bc",
      "text": "Human Rights Watch report documenting abductions, arbitrary detentions and other abuses against Crimean Tatars and pro‑Ukrainian activists",
      "date": "2014-11-24 00:00:00"
    },
    {
      "id": "7062595a-a23b-47c0-ab2b-7a0857b23c87",
      "text": "Russian-appointed courts/authorities banned the Mejlis, the representative body of Crimean Tatars, as an 'extremist' organization",
      "date": "2016-04-26 00:00:00"
    },
    {
      "id": "39943a96-831a-40c6-9920-66942f6a22d9",
      "text": "Blocking of international observers and incidents of violence during the March 2014 Crimea referendum (shots fired, OSCE observers blocked)",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "5f546275-52cd-41ca-8f20-759766d0002f",
      "text": "Deployment of unmarked Russian troops ('little green men') who seized key sites in Crimea (parliament, airports, bases)",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "59355c20-922b-44e1-b999-e928553d0cd8",
      "text": "Reports in Norway of deaths among frail elderly after Pfizer vaccination (23 deaths discussed)",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "6c831974-50b7-4289-8441-92a6a7f94885",
      "text": "CDC and FDA recommended a pause on the Johnson & Johnson COVID-19 vaccine over rare blood clot reports",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "7221df48-3d44-4760-a98b-ac22ba59da87",
      "text": "WHO updated its interim guidance on mask use for COVID-19, advising use of masks in community settings (interim guidance published 5 June 2020).",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "1b3983ea-9696-44d9-aa99-cf3a210e7702",
      "text": "CDC recommended the public wear cloth face coverings in public settings (initial public recommendation announced April 3, 2020; guidance amplified through April–June 2020).",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "b0da3d30-908a-4fb1-a15d-c4d117036668",
      "text": "Coverage documented how face masks became a politicized symbol in the United States (e.g., New York Times feature, June 2, 2020).",
      "date": "2020-06-02 00:00:00"
    },
    {
      "id": "0feb5d9e-c17d-4b4f-acbc-a62b41630ed6",
      "text": "NASA / Earth Observatory and related agencies reported exceptionally low Antarctic sea‑ice extents in 2022–2023 (record lows for seasonal maxima/minima).",
      "date": "2023-08-24 00:00:00"
    },
    {
      "id": "13abc88d-5f8c-44aa-8f59-2e6ba65eb693",
      "text": "Concern about toxic rocket propellant and debris after Proton failures (public safety headlines)",
      "date": "2013-07-02 00:00:00"
    },
    {
      "id": "385e9a11-a43e-4825-aaf7-8359018444f9",
      "text": "IPCC Fourth Assessment Report (AR4) release (Working Group I) stating recent decades were likely the warmest in at least the past 1,300 years",
      "date": "2007-02-24 00:00:00"
    },
    {
      "id": "0b6b7959-afc9-4a75-8422-6f7eb755102b",
      "text": "Wegman report (US Congress/2006) critical of statistical methods in the 'hockey stick' reconstructions",
      "date": "2006-04-24 00:00:00"
    },
    {
      "id": "118c8dc4-7bd0-4d1c-b97d-24100912a230",
      "text": "Ban on dashboard cameras (dashcams) in Ukraine (announced March 2022)",
      "date": "2022-03-21 00:00:00"
    },
    {
      "id": "28b0308b-9327-4280-890d-cddac0e064a8",
      "text": "Established pattern of Russian disinformation and use of staged footage to smear Ukrainian forces (documented by human rights and media watchdogs)",
      "date": "2022-03-16 00:00:00"
    },
    {
      "id": "4d9f446a-ef9b-4448-80be-ef5fb381ad63",
      "text": "Prior documented attacks on civilian evacuation convoys and cars during the 2022 invasion (widely reported, e.g., Reuters report of convoy strike)",
      "date": "2022-03-12 00:00:00"
    },
    {
      "id": "dd2cbb34-56c8-45ad-a455-dae8ea105667",
      "text": "TIME published its 2024 TIME100 list including Andriy Yermak in the 'Leaders' category.",
      "date": "2024-04-17 00:00:00"
    },
    {
      "id": "7055db5a-13ed-4e92-a63e-3b91d7c697c8",
      "text": "Pre‑existing reporting and public scrutiny about Yermak and his circle (including a previously reported corruption investigation involving his brother) created an underlying credibility gap.",
      "date": "2021-12-14 00:00:00"
    },
    {
      "id": "35f38b9b-5ae6-46db-b678-097ade3533ac",
      "text": "CDC/NCHS guidance (April 2020) on certifying and reporting COVID‑19 deaths that allowed listing COVID‑19 as an underlying cause when clinically suspected (including 'probable' cases).",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "305801b7-d80a-4635-87e0-37b6be94a5dd",
      "text": "Repeated public downplaying of COVID‑19 severity by political leaders (e.g., President Trump saying the virus 'will go away' or 'disappear').",
      "date": "2020-03-17 00:00:00"
    },
    {
      "id": "98fd8acd-2549-45ad-b7d2-a8ccb35a1e5d",
      "text": "Croatian officials acknowledge nationals fighting in Donbas",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "98910241-ea76-4661-865b-3fc6751e03ad",
      "text": "Russian Defence Ministry summons Croatian military attaché alleging 'Croatian mercenaries' in Ukraine",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "9dcf2d28-2e69-4f4a-a1e1-4004ea60c1ba",
      "text": "Media coverage of the Azov battalion attracting foreign volunteers and far‑right fighters",
      "date": "2015-03-24 00:00:00"
    },
    {
      "id": "95ee44fd-819e-4e69-a0c6-6d8628545637",
      "text": "Media reports describing Latvia's non-citizen policy as leaving thousands feeling stateless",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "e884d029-e79f-46d4-936d-220f14127574",
      "text": "FDA authorizes Pfizer–BioNTech COVID-19 vaccine and releases EUA materials describing the product as a nucleoside-modified mRNA vaccine (technical briefings made public, Dec 2020).",
      "date": "2020-12-11 00:00:00"
    },
    {
      "id": "9be285a8-7478-450c-bb98-6b02a901425e",
      "text": "Animal and nanoparticle biodistribution studies showing lipid nanoparticle formulations can distribute beyond injection site (published/posted 2020–2021; e.g., peer-reviewed nanoparticle accumulation studies and regulator review summaries).",
      "date": "2020-10-24 00:00:00"
    },
    {
      "id": "82fe0a68-7276-462b-b7b8-079ccc14ba74",
      "text": "Peer-reviewed studies and preprints reporting trace detection of vaccine-derived mRNA fragments or spike protein components in human breast milk or blood samples after vaccination (published 2021).",
      "date": "2021-12-24 00:00:00"
    },
    {
      "id": "6dfb7d0b-227e-4903-b292-de4b409d7199",
      "text": "European Food Safety Authority (EFSA) establishes and publicizes a tolerable weekly intake (TWI) for aluminum from food",
      "date": "2008-04-24 00:00:00"
    },
    {
      "id": "1b12ba3f-a1a1-4175-b690-984d1d530510",
      "text": "2006 Meat Science study measuring aluminum content of baked meats wrapped in aluminum foil",
      "date": "2006-12-24 00:00:00"
    },
    {
      "id": "6a1d3820-e6fe-467a-8267-67da1be9617f",
      "text": "UK Health Security Agency report: Unusually high Group A streptococcal (GAS/iGAS) and scarlet fever activity in 2022–23 season",
      "date": "2023-06-29 00:00:00"
    },
    {
      "id": "b38d6b33-790d-418e-99c1-38e44e1acffb",
      "text": "Preclinical mouse studies showing mRNA‑LNP formulations strongly modulate innate immune responses (Ndeupen et al., iScience)",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "e64cb007-1837-4811-8867-43dd7497c313",
      "text": "CDC Health Advisory: Early, elevated respiratory virus activity among children (co-circulation of RSV, influenza, SARS‑CoV‑2)",
      "date": "2022-11-04 00:00:00"
    },
    {
      "id": "c9c0fbf0-a89c-453f-ac22-5bf199990d55",
      "text": "2009 H1N1 (swine flu) pandemic required development of an additional vaccine",
      "date": "2009-04-24 00:00:00"
    },
    {
      "id": "ce059a55-a1c4-4eea-a508-a9ebacebdc74",
      "text": "Very low measured effectiveness of the 2014–2015 seasonal influenza vaccine",
      "date": "None"
    },
    {
      "id": "fe53b27f-bc03-44b1-8725-44e524ee2b8b",
      "text": "U.S. congressional restrictions/amendments addressing assistance to units with alleged extremist links (e.g., Azov-related amendments)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "40a5c718-7e22-4396-8c2e-32bf37f77173",
      "text": "Clashes and far‑right attempts to disrupt Kyiv Pride (police detained far‑right activists)",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "721023c3-f992-4634-87a0-83197c3ded31",
      "text": "Visible commemoration and monuments to Stepan Bandera in western Ukraine",
      "date": "2007-10-24 00:00:00"
    },
    {
      "id": "e3d31e50-cadc-4608-9267-4e1ae603cea0",
      "text": "Passage and signing of Ukraine's 'decommunization' laws (removing Soviet-era names and symbols)",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "a1a6ea99-b4c3-49ec-b6f5-85eb901fbfe8",
      "text": "Media reporting on the Azov Battalion's origins and extremist symbols",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "c54363fc-151a-4f51-bf9d-22d702af02da",
      "text": "Russian government announces regulatory approval and promotion of Sputnik V (first COVID-19 vaccine) internationally",
      "date": "2020-08-11 00:00:00"
    },
    {
      "id": "aeee00eb-e4d2-433e-836d-a4f0166aca4a",
      "text": "Contamination reports and a large temporary suspension of Moderna vaccine doses in Japan after foreign particles were found in vials.",
      "date": "2021-08-25 00:00:00"
    },
    {
      "id": "db7346d0-0b92-4165-828d-0e8f2f59205b",
      "text": "Media reports in 2022 documenting large, pre-planned insider sales of Moderna shares by CEO Stéphane Bancel during the pandemic period.",
      "date": "2022-03-17 00:00:00"
    },
    {
      "id": "1b2c529e-9c99-4ae9-93d7-b48b6a54d927",
      "text": "IAEA mission and international attention at Zaporizhzhia Nuclear Power Plant (IAEA experts arrived and were stationed at ZNPP beginning 1 September 2022)",
      "date": "2022-09-01 00:00:00"
    },
    {
      "id": "a5faa4e1-3e12-4dbe-85c7-2df6e0d41099",
      "text": "Reporting of intimidation, abductions and coercion of Zaporizhzhia NPP staff under Russian occupation (including abduction of plant director)",
      "date": "2022-10-05 00:00:00"
    },
    {
      "id": "96fff80f-1ce7-4ce1-9985-d1a73c44d044",
      "text": "Changes to Ukrainian mobilization/reservation rules for critical infrastructure employees (Parliament adopted amendments on reserving/exempting conscripts, early November 2022)",
      "date": "2022-11-04 00:00:00"
    },
    {
      "id": "2261ba1b-448f-4b56-9b53-4dd43a3f7a37",
      "text": "2019 systematic review summarizing clinical uses and adverse reactions of DMSO in humans (F1000Research)",
      "date": "2019-08-20 00:00:00"
    },
    {
      "id": "65423e9a-1634-45dc-9d3b-214efebd0a65",
      "text": "FDA approval and long-standing labeling of RIMSO-50 (50% DMSO) for intravesical treatment of interstitial cystitis",
      "date": "1978-04-24 00:00:00"
    },
    {
      "id": "5a29eb59-d254-473a-a747-e01c8152d4ec",
      "text": "Investigative reporting on TikTok as a major vector for unverified/false medical cures in the Philippines (Rappler investigative feature)",
      "date": "2024-04-08 00:00:00"
    },
    {
      "id": "15b48165-c232-44fb-94d6-ae4e9e5c63a4",
      "text": "Russian authorities publicly pledged hundreds of billions of roubles (report: 680 billion roubles) of investment into Crimea up to 2020",
      "date": "2016-08-24 00:00:00"
    },
    {
      "id": "da32d510-4c41-4b5a-a4b8-93aef86bc688",
      "text": "Russian government raised pensions and some salaries for Crimean residents after the 2014 annexation",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "79267d8c-556f-4ae0-a361-17fd8204735e",
      "text": "Israeli data reported reductions in Pfizer/BioNTech effectiveness against infection (Delta-era reports)",
      "date": "2021-07-05 00:00:00"
    },
    {
      "id": "314c4b9b-05f0-4aee-92e9-aabd47c81cec",
      "text": "CDC changed surveillance (May 1, 2021) to track only breakthrough cases resulting in hospitalization or death",
      "date": "2021-05-01 00:00:00"
    },
    {
      "id": "6a4bbd14-52cc-407c-a5f9-92ee77c8a044",
      "text": "CDC report on Barnstable County (Provincetown) outbreak showing many infections in fully vaccinated persons",
      "date": "2021-07-30 00:00:00"
    },
    {
      "id": "0bee1005-e9ab-4e90-8495-090199b0897d",
      "text": "Published and reported studies showing antibody levels wane within months after vaccination",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "0c174304-050e-418f-a279-afae9d4dad42",
      "text": "IAEA expert mission visits and publishes a report on the Zaporizhzhia Nuclear Power Plant (IAEA mission and report published in September 2022).",
      "date": "2022-09-06 00:00:00"
    },
    {
      "id": "1bd90170-ccea-4e04-b3d5-20ce31df06de",
      "text": "Public announcements (July 2025) of deepening Ukraine–Westinghouse cooperation on nuclear fuel supply and plans for domestic fuel assembly capability in Ukraine.",
      "date": "2025-07-10 00:00:00"
    },
    {
      "id": "688031d5-81f7-4c53-a247-743c996e4563",
      "text": "Russian delegation and state media publicly accused Ukraine of planning a 'dirty bomb' at the United Nations Security Council.",
      "date": "2022-10-25 00:00:00"
    },
    {
      "id": "ea47ac8c-9571-4a89-8a98-d768143ca1bd",
      "text": "Reports and imagery in March–April 2022 documenting Russian troops looting and disturbing equipment at the Chernobyl exclusion zone (including allegations of removal of radioactive monitoring equipment).",
      "date": "2022-03-28 00:00:00"
    },
    {
      "id": "4c493219-0683-40a8-873a-f7ddd9e19aca",
      "text": "Reporting on rapid, large Western arms shipments to Ukraine (e.g., New York Times: 'Arming Ukraine: 17,000 Anti‑Tank Weapons in 6 Days').",
      "date": "2022-03-06 00:00:00"
    },
    {
      "id": "f5a5d426-8a1a-4b25-8db3-4350603c6041",
      "text": "Reuters reporting on Zelensky's 'dramatic call' to EU leaders that prompted an unprecedented collective EU decision to provide arms to Ukraine.",
      "date": "2022-03-02 00:00:00"
    },
    {
      "id": "86204680-fdb9-4340-b931-94cd92dad996",
      "text": "Pandora Papers (ICIJ/OCCRP) reporting on Oct 3, 2021 linking Zelensky and close associates to offshore companies and property purchases.",
      "date": "2021-10-03 00:00:00"
    },
    {
      "id": "cfad659c-cb91-411e-b838-43338e2259a5",
      "text": "Politico profile 'The influencers behind the Ukrainian PR machine' quoted former US Ambassador Michael McFaul describing people around Zelensky as 'intermediaries and interlocutors'.",
      "date": "2022-03-17 00:00:00"
    },
    {
      "id": "a16869db-0336-4704-baeb-5256f023e290",
      "text": "CDC/NCHS issued guidance for certifying COVID-19 deaths clarifying how to report underlying versus contributing causes on death certificates (guidance and FAQs for certifiers).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "67ddd5c7-214a-4d5d-b759-ee5548e2cde8",
      "text": "Publication of large US seroprevalence analyses (blood-donor and CDC/JAMA analyses, mid-2021) showing a substantial proportion of Americans had SARS‑CoV‑2 antibodies by spring–early summer 2021.",
      "date": "2021-07-13 00:00:00"
    },
    {
      "id": "cca4f7be-96e2-400d-b27b-e1defa7434a2",
      "text": "EU launches Support Hub for Internal Security and Border Management in Moldova",
      "date": "2022-07-11 00:00:00"
    },
    {
      "id": "e198a5f3-f610-4ce6-8505-b7ff7e34d9cd",
      "text": "EU drugs agency warns the Ukraine war is shifting drug trafficking routes to Europe",
      "date": "2022-06-14 00:00:00"
    },
    {
      "id": "3ccdb77d-b841-4282-ae76-ba8e2f8b361d",
      "text": "European Commission announces EU financing for purchase and delivery of weapons to Ukraine",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "7f8d9241-333d-41c9-bcbc-7cc2af18e259",
      "text": "Interpol warns of a likely surge in illicit arms linked to the Ukraine conflict",
      "date": "2022-06-02 00:00:00"
    },
    {
      "id": "54774750-6451-4196-a2c5-8668041813b8",
      "text": "Dutch Public Prosecution Service opens a criminal investigation into MH17 (Dutch-led criminal probe announced)",
      "date": "2014-07-28 00:00:00"
    },
    {
      "id": "516e9191-4150-4f89-9a9d-06c8702e5117",
      "text": "Establishment of the Joint Investigation Team (JIT) for MH17 including Ukraine as a participating partner",
      "date": "2014-08-07 00:00:00"
    },
    {
      "id": "949e61da-22a2-4985-9fd4-de24d561015c",
      "text": "Early reports of limited access and evidence handling at the MH17 crash site (security and access restrictions under rebel control)",
      "date": "2014-07-18 00:00:00"
    },
    {
      "id": "26f51bef-6306-4cd6-bcb2-780b717ca091",
      "text": "NATO announced increased patrols and a stepped-up maritime presence in the Black Sea in 2018 (Standing NATO Maritime Groups' presence rose to ~120 days).",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "38198833-eb7c-425f-92e8-694e5ef24acb",
      "text": "Russian and pro‑Kremlin media and official statements framed NATO Black Sea exercises as 'provocative' and warned of 'consequences' (July–Nov 2018).",
      "date": "None"
    },
    {
      "id": "2c9d2a6c-ddf0-4248-ae7d-b39d356c078f",
      "text": "Kerch Strait incident: Russian forces fired on and seized three Ukrainian navy vessels, prompting NATO emergency meetings and condemnation.",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "df160e7a-2bcb-4e84-8d82-4201295192ed",
      "text": "CDC/NCHS guidance on certifying deaths due to COVID-19 (guidance documents published early in the pandemic, April 2020).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "a207afbe-4dd3-439f-a8e7-7336149b467c",
      "text": "Russia's appeal argued at the UK Supreme Court that Ukraine should be forced to pay the $3bn 'Yanukovych' bond",
      "date": "2019-12-09 00:00:00"
    },
    {
      "id": "ed2ed877-46e8-4358-851e-d900f564ac83",
      "text": "Earlier High Court summary-judgment proceedings (2017) and legal filings showing shifting rulings and dense legal language",
      "date": "2017-03-24 00:00:00"
    },
    {
      "id": "53195865-e8f7-4076-9d02-8a49a466cb34",
      "text": "Reporting and features on mounting disposal problems for decommissioned turbine blades ('turbine graveyards' / landfill stockpiles)",
      "date": "2023-05-28 00:00:00"
    },
    {
      "id": "6dd2be4b-91b8-4c26-9050-a990c250143b",
      "text": "Nantucket and other Cape Cod beaches closed while crews recovered fiberglass debris after the Vineyard Wind incident",
      "date": "2024-07-17 00:00:00"
    },
    {
      "id": "45d81d20-c534-4029-800a-27e1f275a439",
      "text": "Siemens Gamesa blade (72m, ~22 tonnes) detached and fell from a turbine at Odal Vind in Norway, prompting road closures and an investigation",
      "date": "2024-04-11 00:00:00"
    },
    {
      "id": "657c0cbb-669f-40e7-9983-2bcc27688e5b",
      "text": "Peer‑reviewed literature documenting therapy‑related secondary cancers (eg. therapy‑related AML) after certain chemotherapy agents",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "2f51cfb8-e217-4101-9ecd-ca150c2bf799",
      "text": "Historical reporting about nitrogen mustard research at Yale and the 1940s origins of some chemotherapy agents",
      "date": "2026-04-24 14:26:36.705720"
    },
    {
      "id": "c88721eb-b13e-44b2-854b-d3b82482fbfa",
      "text": "Ukrainian Interior Ministry public briefings reporting scale of Russian strikes (Deputy Interior Minister: ~30,000 strikes)",
      "date": "2024-04-05 00:00:00"
    },
    {
      "id": "4b08a871-b579-4d32-970a-01cfa0688fa4",
      "text": "Widespread Russian missile and drone barrages across Ukrainian cities in late March 2024",
      "date": "2024-03-21 00:00:00"
    },
    {
      "id": "f7a91795-523b-4b76-9f51-a9118e118291",
      "text": "Financial Times publishes analysis of Russian 'glide bombs' and upgrades to Soviet-era bombs",
      "date": "2024-03-24 00:00:00"
    },
    {
      "id": "6f20fe88-be70-4d4c-a915-de8c4c5b535c",
      "text": "2015 'decommunization' laws restricting public expression of Soviet symbols and related narratives",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "89a8455c-ba43-4744-9921-977a09d0deed",
      "text": "2018 reports of SBU actions, searches and prosecutions of pro‑Russian journalists/organizations",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "e6a17aff-8b81-4824-bf2d-718dd2e011da",
      "text": "2017 presidential decree blocking Russian social networks (VKontakte, Odnoklassniki)",
      "date": "2017-05-24 00:00:00"
    },
    {
      "id": "64c4a54b-65dd-4e50-89a8-9a089b49855f",
      "text": "2019 constitutional amendment enshrining Ukraine’s EU and NATO course",
      "date": "2019-02-24 00:00:00"
    },
    {
      "id": "75866a69-139a-4618-8081-25cdae28617f",
      "text": "2014 ban on multiple Russian TV channels for spreading 'war propaganda'",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "060a96ad-1d98-4702-8ccf-e51390aba2e6",
      "text": "U.S. government announcement (October 2014) of a funding 'pause' and review on certain gain-of-function (GOF) research involving influenza, MERS and SARS viruses (NOT-OD-15-011 and related guidance).",
      "date": "2014-10-17 00:00:00"
    },
    {
      "id": "81510421-97b3-4279-9cc0-9f0343057db8",
      "text": "Existence and circulation of U.S. government-held coronavirus patents (example: US Patent No. 7,220,852 B1, 'Coronavirus isolated from humans', assigned to CDC, granted May 22, 2007).",
      "date": "2007-05-22 00:00:00"
    },
    {
      "id": "650cbc5e-d8af-469e-90a4-504e75adc3b9",
      "text": "NGO/OCCRP coverage linking major EU buyers (e.g., IKEA) to Ukrainian illegal wood supply chains",
      "date": "2018-07-14 00:00:00"
    },
    {
      "id": "15a43cb1-bbea-4dcd-87c5-43ee5922e048",
      "text": "President Petro Poroshenko vetoes bill on combating timber smuggling (Bill No. 5495)",
      "date": "2018-07-03 00:00:00"
    },
    {
      "id": "6c534fc9-fcac-4607-902b-1272dbf1c0a7",
      "text": "Earthsight publishes 'Complicit in Corruption' investigative report on illegal logging in Ukraine",
      "date": "2018-07-14 00:00:00"
    },
    {
      "id": "ffab163b-2bdb-4374-996b-8bf59d3c3b70",
      "text": "Regulatory/authorization context: CDC/ACIP and FDA discussions and authorization decisions for COVID-19 vaccination in young children (June 2022), which increased scrutiny of pediatric trial data.",
      "date": "2022-06-17 00:00:00"
    },
    {
      "id": "0e7761d8-4680-4c3f-8a17-955663c844a5",
      "text": "Trial data-cutoff and interim analysis date reported in KidCOVE safety results (data included through February 21, 2022).",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "826edaba-f1d9-4729-883c-a9c6e7470cc0",
      "text": "Publication of NEJM KidCOVE interim results for mRNA-1273 (Moderna) in children 6 months–5 years, reporting safety data including 8 serious adverse events in the 6–23 month mRNA-1273 group and none in the placebo group.",
      "date": "2022-10-19 00:00:00"
    },
    {
      "id": "156ca787-e71d-40ea-95a2-7662712a1cf9",
      "text": "Sea Breeze multinational naval/air exercises hosted in Ukraine with US/NATO participation (July 2017)",
      "date": "2017-07-24 00:00:00"
    },
    {
      "id": "97d6446f-064c-4508-bdc4-990a4467f02e",
      "text": "NATO‑Ukraine Trust Funds and tangible NATO assistance (established 2015)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "9e777542-e2c4-44dd-886a-c7f38f623a25",
      "text": "2019 constitutional amendment enshrining EU and NATO as Ukraine's strategic course",
      "date": "2019-02-24 00:00:00"
    },
    {
      "id": "9f575cf0-b81e-4852-a51d-3cee646f2493",
      "text": "Presence of foreign volunteers and fighters from Western countries in Donbas (documented 2014–2015)",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "4050775d-4d21-4e1d-bd3e-b7ac298dcf8e",
      "text": "Japan suspension and recall of Moderna COVID-19 vaccine batches after reports of foreign particles",
      "date": "None"
    },
    {
      "id": "5d6133ee-f749-4be1-8804-cc25d1fd0848",
      "text": "Reports of circulating vaccine-derived poliovirus (cVDPV) outbreaks and WHO emergency committee statements",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "82eb5dca-d1e4-463b-8328-bb70084866ce",
      "text": "Precautionary removal/reduction of thimerosal (a mercury-based preservative) from childhood vaccines",
      "date": "None"
    },
    {
      "id": "b850f381-8f21-4d77-aaf7-601540816ff9",
      "text": "Detection of porcine circovirus (PCV1) DNA in Rotarix rotavirus vaccine",
      "date": "2010-03-24 00:00:00"
    },
    {
      "id": "0512a5fc-5926-412a-8411-346f9bf0b7fd",
      "text": "Publication of Nerem et al., PNAS: 'Climate-change–driven accelerated sea-level rise detected in the altimeter era'.",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "1cbe5805-33d2-4a49-bedc-c8b721a9fcc9",
      "text": "IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) released.",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "f1be433b-64d3-4ee2-b711-5bddbdc3b211",
      "text": "Publication of Alberto Boretti's analyses challenging mainstream estimates of sea-level acceleration.",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "789d58fa-93fb-45bb-9abe-ff9b780c7054",
      "text": "German measles-denier Stefan Lanka loses appeal after offering €100,000 prize over existence of measles virus; court rules in favour of claimant (widespread media coverage).",
      "date": "2015-03-12 00:00:00"
    },
    {
      "id": "46008da7-e2a3-4b5c-804d-7d973706141a",
      "text": "Ukraine's chief military prosecutor Anatoliy Matios publicly stated that two to three servicemen were committing suicide every week in the Donbas ATO zone.",
      "date": "2017-07-24 00:00:00"
    },
    {
      "id": "5a61323f-1a46-47aa-9fd4-188965d42c37",
      "text": "The battle of Ilovaisk (August 2014) in which Ukrainian units were encircled and suffered heavy losses became widely reported and politicized.",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "cd27c98c-714c-40db-9d27-c4aa5d05e25e",
      "text": "EUvsDisinfo / DisinfoLab and other monitoring organisations catalogued repeated pro‑Kremlin narratives claiming Ukrainian forces were demoralized, corrupt or unwilling to fight (ongoing since 2014).",
      "date": "None"
    },
    {
      "id": "61ee1818-cbe0-4db7-8b84-c29f877894c6",
      "text": "Peer‑reviewed OCTA studies report retinal/ocular microvascular changes after COVID-19 infection (example: Guemes‑Villahoz et al.)",
      "date": "2021-05-07 00:00:00"
    },
    {
      "id": "ccd7dda0-7348-4bda-996e-629c18077678",
      "text": "Longstanding scientific review concluding iridology lacks diagnostic validity published (Ernst systematic review)",
      "date": "1999-02-24 00:00:00"
    },
    {
      "id": "c8c9e73c-4cca-4518-a635-034e32de8980",
      "text": "1996 USAF planning paper 'Weather as a Force Multiplier: Owning the Weather in 2025' circulated publicly",
      "date": "1996-04-24 00:00:00"
    },
    {
      "id": "ed852cdc-bfd8-4384-b486-65cf10530958",
      "text": "Publication of Shearer et al., 'Quantifying expert consensus against the existence of a secret, large‑scale atmospheric spraying program' (Environmental Research Letters)",
      "date": "2016-08-24 00:00:00"
    },
    {
      "id": "0abeeb58-cd42-46a9-9bfa-159671d5c4fa",
      "text": "Preexisting nanoparticle research showing some nanocarriers can accumulate in ovaries in animal models (Schädlich et al., 2012)",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "4ef86bde-843b-46f4-a89b-ed61b420fd30",
      "text": "U.S. Department of State 2018 Trafficking in Persons Report — Poland country narrative noting increased vulnerability of Ukrainian migrants to labor trafficking",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "fa0fd9da-5c67-4038-ad8d-9fb160b4ad27",
      "text": "Financial Times coverage on Poland’s heavy reliance on cheap Ukrainian labour and the precarious conditions many workers faced",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "17d38e55-503b-4ec7-8441-ce132a230a43",
      "text": "June 26, 2016 — Attack on a Ukrainian religious procession in Przemyśl by local nationalist groups (documented by regional and international press)",
      "date": "2016-06-26 00:00:00"
    },
    {
      "id": "46ba9c8a-38e6-4870-92f3-71c773e089ca",
      "text": "Pfizer–BioNTech received Emergency Use Authorisation while continuing to follow trial participants for safety/efficacy",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "3d69889f-6ef2-476c-82e0-6a27979e1cf6",
      "text": "UK regulator (MHRA) issued guidance after two reports of anaphylaxis following Pfizer–BioNTech vaccinations",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "fa532d5e-b78d-4fda-84c6-75f04dc47f1a",
      "text": "Multiple reports in Norway of deaths among frail, elderly people after receiving the Pfizer–BioNTech vaccine",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "3fb2d7f6-e88e-4db6-864c-66144ced3735",
      "text": "AstraZeneca paused its global COVID‑19 vaccine trials after a participant developed a serious neurological illness",
      "date": "2020-09-24 00:00:00"
    },
    {
      "id": "a47f9cd3-6c32-4586-850b-a0ddd5db7fee",
      "text": "NOAA technical report and public release of regional sea-level rise scenarios and tools (NOAA NOS CO-OPS Technical Report)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "1a2742e3-d3fb-48e5-bf4b-b4fc1e5a362d",
      "text": "Availability and public access to local tide-gauge records showing regional variability (example: Stockholm tide gauge, PSMSL station page)",
      "date": "2018-05-01 00:00:00"
    },
    {
      "id": "e069958d-b137-45c6-98f8-d8ac1a244303",
      "text": "Allegations and media coverage of NOAA data-handling controversy (John Bates / 'NOAA whistleblower' coverage)",
      "date": "2017-02-24 00:00:00"
    },
    {
      "id": "dac7a8e1-5257-459a-b46d-a95758256fd2",
      "text": "OSCE Permanent Council decision to deploy the Special Monitoring Mission to Ukraine (SMM) following the outbreak of unrest in eastern Ukraine.",
      "date": "2014-03-21 00:00:00"
    },
    {
      "id": "7d769798-8649-449b-9577-3ffe09615c87",
      "text": "Self‑proclaimed Donetsk and Luhansk 'people's republics' declared independence after May 2014 referendums and issued international statements.",
      "date": "2014-05-12 00:00:00"
    },
    {
      "id": "2f81a6c8-caec-47d3-b457-3dc88dbebb32",
      "text": "Minsk II talks (Package of Measures) signed in Minsk with representatives of the self‑proclaimed Donetsk and Luhansk People’s Republics participating as signatories.",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "11e57b20-8edd-482f-8d82-40fbbc59b90d",
      "text": "United Nations Security Council held emergency meetings and public briefings on the Ukraine/Crimea crisis (e.g., press briefing and meeting coverage in February–April 2014).",
      "date": "2014-02-28 00:00:00"
    },
    {
      "id": "437e98cd-85f2-47db-bac3-f5e207d213bb",
      "text": "European Union adopts €1.8 billion macro‑financial assistance (MFA) for Ukraine",
      "date": "2015-04-15 00:00:00"
    },
    {
      "id": "ee212c03-d1b9-4829-a450-4cf628f7fbc2",
      "text": "EU visa‑free travel for Ukrainian citizens enters into force",
      "date": "2017-06-11 00:00:00"
    },
    {
      "id": "3dcd7b1f-01b2-48b2-8627-6bb067f50b75",
      "text": "Publication of Microsoft patent WO/2020/060606 (cryptocurrency system using body activity data)",
      "date": "2020-03-26 00:00:00"
    },
    {
      "id": "47b0c8dd-d904-48c3-a850-620108d989e1",
      "text": "Coverage of Gates/Foundation funding for genetically modified mosquito research (Oxitec grant reported 2018)",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "2bdbcfa2-b80a-4f15-87e9-4ead32abcd47",
      "text": "Ukraine sharply increased 'reverse flow' imports from EU in 2015",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "49f9b46a-f921-44a8-aaf1-5ea187468899",
      "text": "January 2009 Russia–Ukraine gas cut-offs",
      "date": "2009-01-24 00:00:00"
    },
    {
      "id": "c06f10aa-ef48-49f7-8472-ebbd02c3d8b5",
      "text": "Merck announces it will discontinue development of two COVID-19 vaccine candidates (V590 and V591)",
      "date": "2021-01-25 00:00:00"
    },
    {
      "id": "e581a1e2-e362-4c93-9f84-238c6c5d5159",
      "text": "1976 U.S. swine flu vaccination program linked to increased Guillain–Barré syndrome reports",
      "date": "1976-04-24 00:00:00"
    },
    {
      "id": "a159547a-4af7-4274-b801-e11db333875c",
      "text": "Pandemrix (2009 H1N1 vaccine) association with increased narcolepsy reports in some countries",
      "date": "2010-04-24 00:00:00"
    },
    {
      "id": "34c5408c-1e1a-49f9-b0bd-04148f61a2b3",
      "text": "2014–2015 influenza vaccine effectiveness decline due to antigenic drift",
      "date": "None"
    },
    {
      "id": "2e6de9ab-0fc6-44c8-b407-aa303e166569",
      "text": "European Medicines Agency (EMA) announces and uses 'rolling review' procedures for COVID-19 vaccines",
      "date": "2020-10-06 00:00:00"
    },
    {
      "id": "ae74430a-5949-4b95-a120-a6eb384fd9bb",
      "text": "UK Medicines and Healthcare products Regulatory Agency (MHRA) grants temporary (emergency) authorization for the Pfizer–BioNTech vaccine under Regulation 174",
      "date": "2020-12-02 00:00:00"
    },
    {
      "id": "3bf4e4fe-3618-4cb8-8d2c-abcfe64d9596",
      "text": "Publication of the Phase 3 trial results in NEJM showing vaccine efficacy against symptomatic COVID-19 (Polack et al.)",
      "date": "2020-12-10 00:00:00"
    },
    {
      "id": "b728548a-c090-4038-9c76-17794be02f65",
      "text": "Reporting on longstanding U.S. transfers of anti-armor and other defensive equipment to Ukraine (e.g., Politico coverage of U.S.-supplied weapons to Ukraine since 2018)",
      "date": "2021-04-12 00:00:00"
    },
    {
      "id": "1e92e27b-0ddf-449b-83e9-404d8da25044",
      "text": "U.S. intelligence warnings and press reporting that Russia was planning a large-scale offensive (wide coverage, Dec 3, 2021)",
      "date": "2021-12-03 00:00:00"
    },
    {
      "id": "4c42f1d4-18f9-414a-8489-6a66fdc45116",
      "text": "Bipartisan Senate delegation visited Kyiv and met President Zelensky (Portman, Shaheen, Murphy)",
      "date": "2021-06-02 00:00:00"
    },
    {
      "id": "4c7d4d49-9392-47f0-94fe-c2a411854cab",
      "text": "Russian navy holds Black Sea drills near Crimea amid rising tensions (April 2021).",
      "date": "2021-04-27 00:00:00"
    },
    {
      "id": "1b2898f8-0b9e-4973-8d15-1d632394728d",
      "text": "Russia publishes draft security proposals demanding NATO guarantees (including no eastward expansion).",
      "date": "2021-12-17 00:00:00"
    },
    {
      "id": "5a950cce-9f3d-4ba0-a51e-e8a2b37a97bf",
      "text": "Deployment of advanced S-400 surface-to-air missile systems and other air defenses to Crimea (reported in 2019 and earlier).",
      "date": "2019-11-29 00:00:00"
    },
    {
      "id": "79e8c735-743c-476f-a650-01f059fa32c1",
      "text": "Large-scale Russian troop buildup on and near the Ukrainian border reported in January 2022.",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "ad1ef3ff-142e-42f8-8b0c-469d655ebcc3",
      "text": "Vladimir Putin publishes essay 'On the Historical Unity of Russians and Ukrainians'.",
      "date": "2021-07-12 00:00:00"
    },
    {
      "id": "cb13afd4-7f7a-447e-8c59-ffacf2dd9a71",
      "text": "Czech Statistical Office published official vital statistics showing a marked decline in live births (drop in number of births) between 2021 and 2022/2023.",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "29f831dd-3583-4717-b70d-08c20c2277b5",
      "text": "Peer-reviewed modelling paper published examining how COVID-19 vaccination timing and behavior could affect total fertility rate in Czechia (discusses scenarios like avoiding conception around vaccination).",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "8671ab76-5e75-4a4e-924f-ede3eddbd80e",
      "text": "Public reporting and policy changes earlier in 2020 showing NATO/European military exercises were scaled back or adjusted because of COVID‑19 (concern about cross‑border transmission).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "4ee7de3b-1f60-445f-8a66-cc678fc92f3b",
      "text": "Official reporting that Ukrainian units (e.g., the 80th Air Assault Brigade) were participating in Saber Junction / multinational exercises in Germany.",
      "date": "2020-07-24 00:00:00"
    },
    {
      "id": "ef40271e-1b78-4d05-a4a9-d2bb3d847704",
      "text": "Peer‑reviewed reports from Israel (NEJM and related surveillance studies, 2021–2022) documenting rare myocarditis cases after mRNA vaccination in adolescents and young men (e.g., NEJM letter on Israeli adolescents published Nov. 10, 2022)",
      "date": "2022-11-10 00:00:00"
    },
    {
      "id": "b59a26bd-e33a-41d1-ad8e-57ce8f617df6",
      "text": "CDC/ACIP Sept. 12, 2023 presentation slides on updated COVID-19 vaccines that included projections of hospitalizations, deaths prevented in adolescents and estimates of vaccine reactogenicity (Grade 3/4)",
      "date": "2023-09-12 00:00:00"
    },
    {
      "id": "67c3c742-90ac-4337-9018-6e7ff134b06b",
      "text": "IEA special report 'The Role of Critical Minerals in Clean Energy Transitions' highlighting large and growing demand for minerals (copper, rare earths, etc.) used in wind turbines and other clean technologies.",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "444523ca-76e6-42a5-8557-f2d374e6f96b",
      "text": "Reuters reporting (September 2023) on U.S. offshore wind projects facing major cost increases, cancellations and financial write‑downs amid inflation, supply‑chain problems and policy changes.",
      "date": "2023-09-24 00:00:00"
    },
    {
      "id": "e28fde96-9f0f-4cda-b767-ef1e03a07eab",
      "text": "C&EN feature (August 2022) documenting that many retired wind turbine blades have been landfilled and describing the technical and economic challenges of blade recycling.",
      "date": "2022-08-24 00:00:00"
    },
    {
      "id": "6cf34b83-d38a-46dc-8302-a20288b0d780",
      "text": "Arnett et al. review and field studies (circa 2008) documenting consistent patterns of bat fatalities at wind energy facilities and identifying operational conditions that drive bat collisions.",
      "date": "2008-04-24 00:00:00"
    },
    {
      "id": "5b8a68bf-3608-469c-b027-3fec24302b2a",
      "text": "Loss, Will & Marra (Biological Conservation, Dec 2013) published widely‑cited estimates of bird collision mortality at U.S. wind facilities (commonly quoted range ~140,000–328,000 birds/year).",
      "date": "2013-12-24 00:00:00"
    },
    {
      "id": "46c01df2-2feb-4f99-bc16-539c8ca2b867",
      "text": "Israel Ministry of Health presentation on booster-dose effectiveness and evidence of waning two‑dose vaccine protection.",
      "date": "2021-09-17 00:00:00"
    },
    {
      "id": "a6c232db-1a65-43e5-99aa-56186d183ca5",
      "text": "Ukrainian authorities and security services announced investigations and potential legal action against Antonov company officials over failures linked to the Mriya's destruction.",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "79088632-2935-4ce9-9241-aa7bc44d76ba",
      "text": "Hostomel (Antonov) airport was the scene of capture, heavy fighting and later reported withdrawal/retreat of Russian forces during March 2022.",
      "date": "2022-03-31 00:00:00"
    },
    {
      "id": "9306dc4c-bbdb-436c-b00f-b410355002aa",
      "text": "Ukraine suspends consular services for military‑age men living abroad",
      "date": "2024-04-23 00:00:00"
    },
    {
      "id": "458aeba4-416b-46fa-a35b-ecd460f72be8",
      "text": "President Zelensky signs a major overhaul of Ukraine's mobilization law",
      "date": "2024-04-16 00:00:00"
    },
    {
      "id": "edb8e667-b21a-45e7-848a-98aac580af24",
      "text": "BBC World Service 'BBC Eye' investigation: nearly 20,000 men fled Ukraine to avoid conscription (investigation published Aug 2023)",
      "date": "2023-08-31 00:00:00"
    },
    {
      "id": "8c142b12-a65a-4ce6-86ae-aae44f23c9cc",
      "text": "NATO‑Ukraine Council (defence ministers) meets and publicly reiterates stepped-up support",
      "date": "2024-04-19 00:00:00"
    },
    {
      "id": "e748127d-9540-4a39-9726-f81edd2c8e8f",
      "text": "The UK Coronavirus Act 2020 received Royal Assent, creating expanded emergency powers for government pandemic response.",
      "date": "2020-03-25 00:00:00"
    },
    {
      "id": "e3b3e9fa-930f-40cb-a960-487fe2683fab",
      "text": "The White House issued a proclamation declaring a national emergency concerning COVID-19.",
      "date": "2020-03-13 00:00:00"
    },
    {
      "id": "80f55654-6963-44a9-aadf-53eb4540c6cd",
      "text": "President Trump and other US officials publicly expressed unusually optimistic timelines for a vaccine, saying a vaccine might be available in a few months.",
      "date": "2020-03-31 00:00:00"
    },
    {
      "id": "942337db-4b80-4c5e-a142-04a5dc2df92c",
      "text": "Moderna announced the first participant was dosed in its NIH-led Phase 1 trial of mRNA-1273.",
      "date": "2020-03-16 00:00:00"
    },
    {
      "id": "ab5a60e5-1d17-46e0-8127-9a12fee20233",
      "text": "Florida Department of Health press release stating VAERS reports from Florida increased 1,700% after COVID-19 vaccine rollout",
      "date": "2023-02-15 00:00:00"
    },
    {
      "id": "2d9b57e8-c3c3-4496-889e-49cbb023c515",
      "text": "Florida Surgeon General Joseph Ladapo issued mRNA COVID-19 vaccine guidance recommending against mRNA vaccines for males aged 18–39",
      "date": "2022-10-07 00:00:00"
    },
    {
      "id": "9e528c86-3518-44cf-9457-649aebabe1ac",
      "text": "Record-high public support for marijuana legalization reported by Gallup (64% in favor).",
      "date": "2017-10-24 00:00:00"
    },
    {
      "id": "9c94162e-1144-4d01-9300-a5d1061c9b0b",
      "text": "Publication of David Nutt et al.'s Lancet paper ranking drug harms, which placed alcohol high and cannabis low.",
      "date": "2007-03-24 00:00:00"
    },
    {
      "id": "70adf12e-fa53-43c7-8d7a-2f599125e473",
      "text": "Sacking of Professor David Nutt from the UK Advisory Council on the Misuse of Drugs after public comments comparing alcohol's harms to those of illegal drugs.",
      "date": "2009-10-24 00:00:00"
    },
    {
      "id": "84f271c8-1fba-4ded-a316-c79332085a5f",
      "text": "Ukraine's parliament passed 'decommunization' laws criminalizing propaganda of totalitarian symbols and prompting removal/renaming of Soviet‑era monuments and toponyms.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "d9906cb0-4f96-4c12-af10-045c3e9830a5",
      "text": "International outlets reported that nationalist and far‑right groups had gained influence and were under scrutiny in post‑Maidan Ukraine.",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "a994727b-62ac-4e99-9ff7-b623a3e7ce1e",
      "text": "Right Sector, an umbrella of ultranationalist groups, played a prominent and public role during the Euromaidan protests.",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "a4650293-dc10-4ba0-8b5c-2a53b5c104ca",
      "text": "Svoboda party members held ministerial posts in Ukraine's 2014 interim government after Yanukovych fled.",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "5d538b3b-083c-4c70-b5a9-0f0dfc1aa3f0",
      "text": "Ukraine's Cabinet of Ministers increased administrative fines for quarantine breaches via Resolution No.255.",
      "date": "2020-04-02 00:00:00"
    },
    {
      "id": "38e35b26-e0a3-478a-b08d-491381d5c88a",
      "text": "Legal summaries and guidance published in April 2020 explaining strengthened quarantine rules and penalties in Ukraine (legal/firm briefings and PDF guides).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "c51b41b1-9760-4339-854f-287b00ad0c84",
      "text": "Publication of preliminary safety data on mRNA COVID‑19 vaccines in pregnancy (v‑safe/VAERS analyses)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "e02e3907-1835-46df-850e-452f3b834bf7",
      "text": "Verkhovna Rada adopts 'decommunization' laws banning Soviet symbols and renaming places (spring 2015)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "541465c0-ead7-4c43-8610-39c68db9ae97",
      "text": "Ukraine adopts the red poppy and promotes May 8 remembrance practices (media coverage, May 2015)",
      "date": "2015-05-07 00:00:00"
    },
    {
      "id": "0fa1cb68-fd34-4681-8f0b-84ed327d371c",
      "text": "Ukraine criminalises public promotion/use of the Russian/St. George ribbon (amendment creating administrative offence), reinforcing break with Soviet/Russian WWII symbolism",
      "date": "2017-05-16 00:00:00"
    },
    {
      "id": "cb791cbb-0911-4b8e-97a7-752b4d22f599",
      "text": "Wave of Lenin statue topplings across Ukraine during 2014 'Leninfall'",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "dad446c8-03c1-413f-9114-2f9d5e01bd8e",
      "text": "Passage of the Law 'On Ensuring the Rights and Freedoms of Internally Displaced Persons' (IDP law)",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "462e4a03-4d8c-4341-833f-f2ec89502281",
      "text": "Cabinet of Ministers Resolution No. 302 (25 March 2015) on passport issuance and registration procedures",
      "date": "2015-03-25 00:00:00"
    },
    {
      "id": "4e8ef4ff-dc82-4121-ab94-8ddfe30d3f14",
      "text": "Law No. 1382‑IV 'On freedom of movement and free choice of place of residence' (adopted)",
      "date": "2003-12-11 00:00:00"
    },
    {
      "id": "68c425e7-db7f-4682-8099-2f8ee5563c2d",
      "text": "Abolition of the Soviet 'propiska' system and lingering public confusion about registration (historical/legal context)",
      "date": "1991-04-24 00:00:00"
    },
    {
      "id": "8ab14ca7-177b-42cb-ba67-cf8818192e53",
      "text": "Publication of large 2022 pan‑cancer mycobiome analyses showing tumor‑associated fungal signatures across multiple cancer types (pan‑cancer mycobiome studies).",
      "date": "2022-09-29 00:00:00"
    },
    {
      "id": "818fdb67-5968-4972-ae07-798bd412f8b9",
      "text": "Public debate and symbolic acts over Odesa's Russian imperial monuments (removal of Catherine II statue)",
      "date": "2024-01-11 00:00:00"
    },
    {
      "id": "47af4d33-0512-41a8-a25f-30f4778003fc",
      "text": "NATO Wales Summit pledges concrete support to Ukraine (Readiness Action Plan)",
      "date": "2014-09-04 00:00:00"
    },
    {
      "id": "60c71afc-0960-4690-ac6b-3a2929556e3f",
      "text": "US announces $53 million in non-lethal military assistance to Ukraine",
      "date": "2014-09-18 00:00:00"
    },
    {
      "id": "c87b17f7-61ab-471b-91cd-5716b5aac344",
      "text": "John McCain visits Maidan and publicly supports protesters",
      "date": "2013-12-24 00:00:00"
    },
    {
      "id": "1188ef4a-afd9-4c2d-8d23-cb5ffb6c6df2",
      "text": "Japan suspends use of some Moderna COVID-19 vaccine batches amid contamination concerns (reported by Reuters).",
      "date": "2021-08-27 00:00:00"
    },
    {
      "id": "5cf794fe-3c11-47eb-9ac3-4d3c6c7f3126",
      "text": "Office for National Statistics (ONS) public 'Deaths by vaccination status, England' dataset and periodic releases (dataset page with major updates accessible 25 August 2023).",
      "date": "2023-08-25 00:00:00"
    },
    {
      "id": "ed2bf98c-6e1f-4d37-a55e-fdd5b175f958",
      "text": "UKHSA 'Vaccine surveillance report' (Week 4) published figures showing substantially reduced or 'negative' vaccine effectiveness against symptomatic Omicron infection in some analyses.",
      "date": "2022-01-27 00:00:00"
    },
    {
      "id": "83bd32b7-c4ae-434d-9e02-3e01d321661e",
      "text": "Publication of case series and reports documenting short-term inflammatory musculoskeletal events after COVID-19 vaccination (e.g., 'Spectrum of short-term inflammatory musculoskeletal manifestations after COVID-19 vaccine administration: a report of 66 cases').",
      "date": "2021-11-26 00:00:00"
    },
    {
      "id": "f1647966-4838-440a-aebf-82a10a8894dd",
      "text": "Historic precedent of drownings at the Hungary–Serbia/Tisza border route and UNHCR public concern (reported in 2016).",
      "date": "2016-06-04 00:00:00"
    },
    {
      "id": "720a46b3-59b3-4358-870a-89c487e84d5c",
      "text": "Recent regional examples of formal memorials for migrants who drowned in border rivers (AP coverage of a Drina River memorial in Bosnia).",
      "date": "2024-02-04 00:00:00"
    },
    {
      "id": "8199722f-107b-4824-81cd-a4e9f21e452e",
      "text": "Local reports in early May 2024 that multiple bodies were recovered from the Tisza River (State Border Guard Service reported three more drowned people).",
      "date": "2024-05-07 00:00:00"
    },
    {
      "id": "f4760408-3b19-425e-931d-f5b85fa7ad2f",
      "text": "Launch/inauguration of Hulhumalé Phase 3 land-reclamation works (government announcement, inaugurated September 22, 2023)",
      "date": "2023-09-22 00:00:00"
    },
    {
      "id": "fd1e2a9c-0bc6-4fb6-8afb-685739fed911",
      "text": "Publication of Duvat 2019 review 'A global assessment of atoll island planform changes over the past decades' reporting that 88.6% of studied atoll islands were stable or increased in area",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "f2497bf6-410d-4898-9795-ebd88e880c0f",
      "text": "MIT Self-Assembly Lab / National Geographic-supported 'Growing Islands' projects in the Maldives (projects and demonstrations, including 2022 fieldwork)",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "364f0dcb-c131-4adf-a34b-8f19f88d52a7",
      "text": "CDC public guidance for health departments/laboratories on reporting breakthrough cases which states: for cases with a known RT-PCR cycle threshold (Ct) value, submit only specimens with Ct value ≤28 to CDC for sequencing.",
      "date": "2021-05-01 00:00:00"
    },
    {
      "id": "fc990176-3f23-4e69-9e6c-2950dbd56f07",
      "text": "Mainstream media coverage and criticism of the CDC decision to limit active investigation and public reporting of breakthrough infections to hospitalized/fatal cases (coverage highlighting concerns this could 'hide' milder breakthroughs).",
      "date": "2021-05-27 00:00:00"
    },
    {
      "id": "592c3ce7-e4d1-4537-b9a6-6715c5ffd7e9",
      "text": "Documented U.S. support for Ukrainian civil society and opposition groups via NGOs and grants (e.g., National Endowment for Democracy activities in Ukraine around 2013–2014).",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "bf0075d7-5c9c-4369-9994-3b19f20c9099",
      "text": "Victoria Nuland public remark that the U.S. has invested about $5 billion in Ukraine since 1991.",
      "date": "2013-12-24 00:00:00"
    },
    {
      "id": "8f987eb0-0364-48bf-936f-1e5b5fa5087a",
      "text": "Removal of President Viktor Yanukovych after mass Euromaidan protests; Yanukovych flees Kyiv and parliament votes to remove him.",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "2327e9e9-0b9b-420b-b3be-0f9707fa55ec",
      "text": "IPCC Fifth Assessment Report (AR5) notes a reduced rate of surface warming for 1998–2012 (the so‑called 'global warming hiatus')",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "dc63181f-17bc-4343-b478-aac247e55192",
      "text": "IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) published and approved",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "6399ab81-8bf9-4d35-8afa-a1c2d5c281b4",
      "text": "2019–20 Australian 'Black Summer' bushfires (widespread, high‑impact fires across eastern and southern Australia)",
      "date": "None"
    },
    {
      "id": "99376817-68db-4068-9cbd-fb73baa6456e",
      "text": "Major polar vortex breakdown and cold snap across North America and parts of Europe",
      "date": "2019-01-24 00:00:00"
    },
    {
      "id": "869f4856-096a-4864-a678-c4826830fab0",
      "text": "Dublin Declaration on Maternal Health Care issued (pro‑life clinicians declare 'abortion is not medically necessary')",
      "date": "2012-09-08 00:00:00"
    },
    {
      "id": "d7d8e3b9-ac2d-4fb0-ab2a-62ee7454889b",
      "text": "Ohio 'heartbeat' (Human Rights and Heartbeat Protection) bill signed into law",
      "date": "2019-04-11 00:00:00"
    },
    {
      "id": "9a4403c6-b2ac-4ec5-b6b2-1619c342bcc2",
      "text": "Alabama Human Life Protection Act signed into law (near‑total abortion ban)",
      "date": "2019-05-15 00:00:00"
    },
    {
      "id": "b1b0c026-7199-4aa6-a048-93c13840edda",
      "text": "Prior high‑profile 'map without Crimea' incidents (e.g., Human Rights Watch map controversy) primed public sensitivity to any depiction of Ukraine that appears to exclude Crimea.",
      "date": "2023-01-31 00:00:00"
    },
    {
      "id": "822740f5-e6a4-43e6-9bee-e14d64272496",
      "text": "CDC MMWR report on a rapid COVID-19 outbreak in an Ohio Amish community (May 2020) showing very high attack rates after social gatherings.",
      "date": "2020-05-24 00:00:00"
    },
    {
      "id": "dda7fcf7-59ad-43a1-ae33-26eaf103fcb7",
      "text": "Local reporting claimed up to 90% of Lancaster County 'Plain' households had been infected, suggesting community-level 'herd immunity'.",
      "date": "2021-03-27 00:00:00"
    },
    {
      "id": "79419e99-ecaf-4138-b2b3-f7cee50fa0b0",
      "text": "Reporting of foreign volunteers and sympathizers (including Europeans) joining separatists in Donbas (2014)",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "78bf4fdf-0835-4b4c-a611-940cce285dd5",
      "text": "Large government‑sanctioned pro‑Crimea/Putin demonstrations in Moscow (March 2014)",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "6bbb635f-e0f2-452c-b57b-b5a70779c142",
      "text": "Nationalisation of PrivatBank after capital shortfall (18 December 2016)",
      "date": "2016-12-18 00:00:00"
    },
    {
      "id": "26067bc5-831d-4b3a-b9b4-282d8ffa5e85",
      "text": "Outbreak of large‑scale fighting in Donbas and its measured economic impact (2014–2015)",
      "date": "None"
    },
    {
      "id": "52833197-6a55-4070-bad3-f5ad28d3d8bc",
      "text": "Sharp hryvnia devaluation and currency crisis (February 2014)",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "6c30dbdc-810e-41d7-b83e-f6e17c80a0c9",
      "text": "Background: Ukraine's International Legion and widespread coverage of thousands of foreign volunteers (Feb 2022)",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "93d12391-eef7-4c5a-8d23-3ca3ffb008bd",
      "text": "NCHS/CDC published official guidance on how to certify deaths involving COVID-19 (guidance on listing COVID-19 on death certificates).",
      "date": "2020-03-04 00:00:00"
    },
    {
      "id": "a0b3494f-3b25-43d0-9637-2573e7d8135b",
      "text": "Official explanations and reporting about provisional mortality data and reporting lags in the NCHS/CDC mortality system.",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "2a7bc1e4-5c5e-40e4-acda-c53dafd3c9a0",
      "text": "Clinical trial registration for high‑dose intravenous vitamin C in COVID-19 (NCT04264533) announced on ClinicalTrials.gov",
      "date": "2020-02-14 00:00:00"
    },
    {
      "id": "8b65cbf9-7f63-4595-bd95-246ce73c6301",
      "text": "Ukraine reported hundreds of its citizens were trapped in Gaza and said it was working to evacuate them (public statements, mid‑October 2023).",
      "date": "2023-10-15 00:00:00"
    },
    {
      "id": "03d26c5d-dae0-43de-bb40-e12f1a0a1713",
      "text": "Large, ongoing presence of Ukrainian refugees in Romania (official UNHCR and government figures published in 2022–early 2023).",
      "date": "2023-02-24 00:00:00"
    },
    {
      "id": "516f9430-7cb6-4c16-9ce3-0f1dc1d59ae7",
      "text": "Brazil President Jair Bolsonaro publicly downplayed COVID‑19, calling it 'a little cold' and criticizing lockdowns in a March 24, 2020 address.",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "48c5dddc-78ed-48ff-a24d-21039089ec99",
      "text": "WHO statement (and tweet) on January 14, 2020 saying preliminary investigations found no clear evidence of human‑to‑human transmission.",
      "date": "2020-01-14 00:00:00"
    },
    {
      "id": "2f591cc6-766b-4de0-90aa-5e326145da63",
      "text": "Russian missile strike on Dnipro (widely reported Nov 21, 2024)",
      "date": "2024-11-21 00:00:00"
    },
    {
      "id": "988a9c58-5f46-4af4-afdc-75d17fc213df",
      "text": "Rapid intensification and an unusual track of Tropical Storm Milton as documented by official National Hurricane Center advisories in early October 2024.",
      "date": "2024-10-06 00:00:00"
    },
    {
      "id": "8cb449ff-d21b-476f-a26b-289f9014209e",
      "text": "Hurricane Helene (late September 2024) severely impacted Florida days earlier, prompting online discussion about consecutive destructive storms.",
      "date": "2024-09-26 00:00:00"
    },
    {
      "id": "6f925d02-63b7-45e9-afa7-ed6665196762",
      "text": "WHO fact sheet reporting ~1.5 billion people globally infected with soil‑transmitted helminths",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "56b2e091-1cbe-40c4-a60d-667253b89be3",
      "text": "FDA public warning about 'Miracle Mineral Solution' (MMS) marketed as a cure-all including for parasites",
      "date": "2019-08-12 00:00:00"
    },
    {
      "id": "153e7304-a747-45d2-89be-8d56d7ebf0c2",
      "text": "Sharp surge in European wholesale gas and power prices, raising fears of winter supply shortages",
      "date": "2021-09-22 00:00:00"
    },
    {
      "id": "20a7f975-5a4d-424d-95ab-5ceb6cc370e2",
      "text": "Completion of Nord Stream 2 pipeline construction reported in early September 2021",
      "date": "2021-09-06 00:00:00"
    },
    {
      "id": "caf47164-4bc5-4b92-a634-49bfbbc70e58",
      "text": "Signing of the 2019 Russia–Ukraine gas transit agreement (dec. 30, 2019) defining transit volumes through Ukraine for 2020–24",
      "date": "2019-12-30 00:00:00"
    },
    {
      "id": "16df827f-bd7a-497f-802c-657b4b130b45",
      "text": "The Crimean parliament, while under occupation, appointed pro‑Russian politician Sergey Aksyonov as prime minister.",
      "date": "2014-02-27 00:00:00"
    },
    {
      "id": "350979a9-e5d0-450c-a30b-382c9e68589c",
      "text": "Masked, unmarked armed men (the so-called 'little green men') seized the Crimean parliament building in Simferopol, occupying the legislature and preventing normal sessions.",
      "date": "2014-02-27 00:00:00"
    },
    {
      "id": "e227fb02-66b2-46f4-8ff0-3ba31e2db4da",
      "text": "Ukraine announces a nearly $40 million embezzlement scheme tied to mortar-shell procurement (SBU investigation)",
      "date": "2024-01-28 00:00:00"
    },
    {
      "id": "3f7fdfd4-3e46-4d00-9a45-83acab5ddb62",
      "text": "Rising conservative/public skepticism about continued U.S. assistance to Ukraine documented in 2023 media coverage",
      "date": "2023-08-18 00:00:00"
    },
    {
      "id": "239b27e8-d089-4e57-98c5-4c76455d13e1",
      "text": "Rapid growth of labor migration from Ukraine to Poland (Poland issued ~1.8 million employers' declarations in 2017; analysis 2018)",
      "date": "2018-10-24 00:00:00"
    },
    {
      "id": "81417279-482b-47bb-824a-1e4360669d2c",
      "text": "Large-scale internal displacement and civilian displacement from Donbas (UNHCR reports, 2015)",
      "date": "2015-12-24 00:00:00"
    },
    {
      "id": "58629ba1-a876-4cf2-9e86-abbf1b321a0b",
      "text": "EU Schengen visa‑free regime for Ukrainian citizens comes into force",
      "date": "2017-06-11 00:00:00"
    },
    {
      "id": "e66d9fdb-3abd-4db8-96cc-31025be32b36",
      "text": "U.S. decision and delivery timeline in spring 2018 to supply Javelin anti‑tank systems to Ukraine",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "cee4ea01-6eae-46e4-89a4-59a920fa04a0",
      "text": "Kurt Volker’s visit to Ukraine (mid‑May 2018) and on‑the‑ground briefings about Donbas/Crimea",
      "date": "2018-05-14 00:00:00"
    },
    {
      "id": "2769c0f5-344b-4758-b766-c38b432afbdc",
      "text": "Uman’s profile as a major Hasidic pilgrimage site and reports of thousands of visitors in March 2022",
      "date": "2022-03-09 00:00:00"
    },
    {
      "id": "8a516dda-7f66-40ad-8d0a-4790dec2af9e",
      "text": "Putin's February 24, 2022 justification for the invasion invoking 'demilitarisation' and 'denazification' of Ukraine",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "a80a49a4-31da-41a9-8200-1b85ad04386d",
      "text": "HAARP published a transmission notice / research campaign for May 8–10, 2024 (ionospheric heating experiments)",
      "date": "2024-05-08 00:00:00"
    },
    {
      "id": "409eb38a-b470-4060-875d-2a70306e343e",
      "text": "NOAA Space Weather Prediction Center issued a Severe (G4) Geomagnetic Storm Watch",
      "date": "2024-05-09 00:00:00"
    },
    {
      "id": "9c039d26-a19a-4ab1-acab-9eeefb6098a9",
      "text": "Registration of the Pfizer/BioNTech BNT162b2 Phase 1/2/3 clinical trial on ClinicalTrials.gov (NCT04368728), first posted in April 2020, with trial documents showing pregnancy as an exclusion criterion.",
      "date": "2020-04-29 00:00:00"
    },
    {
      "id": "cdbc5470-c4bd-49b8-8dd1-ad1172e9f3e6",
      "text": "2014 Kenya tetanus vaccine sterilization allegations and subsequent WHO/UNICEF denial (HCG claim) — high‑profile historical sterilization scare.",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "1e104b78-27ab-417a-b7a3-a811b036f8da",
      "text": "NOAA/NCEI (Karl et al.) 2015 paper revising ocean temperature bias and updating the global surface-temperature record",
      "date": "2015-06-26 00:00:00"
    },
    {
      "id": "c3b69cf1-ef52-4f7c-a3fa-6f15916226ce",
      "text": "Prior high-profile contacts between Turkish officials and Crimean Tatar leaders (e.g., Turkish FM Mevlüt Çavuşoğlu met Mustafa Dzhemilev, Jan 26, 2016)",
      "date": "2016-01-26 00:00:00"
    },
    {
      "id": "a0dfc6e8-dd9e-4100-91c8-a8bbd3e7e379",
      "text": "Public biographical records show Nalyvaychenko served at the Ukrainian Embassy in the United States (Consular service/Consul in Washington, D.C., 2001–2003).",
      "date": "None"
    },
    {
      "id": "e5acb719-6e1b-4c0e-bf26-60b264eded67",
      "text": "Press coverage in Feb 2014 publicised close cooperation between Ukraine’s SBU and U.S. intelligence partners (coverage emphasising U.S.–SBU ties).",
      "date": "2014-02-25 00:00:00"
    },
    {
      "id": "0cf8c26e-fa57-4bfe-953a-ccd79ef5a5b1",
      "text": "European Commission publishes staff analysis showing rising short‑term visa refusal rates for Ukrainian applicants (2013→2014)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "c28361a9-b80f-4c17-bee5-aefd916e9766",
      "text": "EU adopts Sixth Progress Report on Ukraine's Visa Liberalisation Action Plan (Commission decision communicated in December 2015)",
      "date": "2015-12-18 00:00:00"
    },
    {
      "id": "064c7739-3b88-43cd-92ae-29cd789412f6",
      "text": "Several Schengen states reintroduce internal border controls during the 2015 migration crisis",
      "date": "None"
    },
    {
      "id": "2b83fc24-9c8d-42a4-beca-c56726ad2a54",
      "text": "EU decision to prolong economic sanctions on Russia (June 2019)",
      "date": "2019-06-27 00:00:00"
    },
    {
      "id": "0257f52c-89f6-4cfb-9c0d-5b86a9efee9d",
      "text": "Kerch Strait naval confrontation — Russia seizes Ukrainian ships",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "9eb89195-f804-43aa-988f-f7e451bdbd64",
      "text": "Skripal poisoning and mass expulsions of Russian diplomats",
      "date": "2018-03-24 00:00:00"
    },
    {
      "id": "0c3f7ad0-7532-46c3-a25f-884ccee7bb9c",
      "text": "Downing of Malaysia Airlines flight MH17 over eastern Ukraine",
      "date": "2014-07-17 00:00:00"
    },
    {
      "id": "bbbf880f-a3d6-42f8-ad6e-06e0e077e13a",
      "text": "Preprint and early reports (June–July 2021) documented multiple vaccine 'breakthrough' infections with the Delta variant, including clusters where fully vaccinated people became infected.",
      "date": "2021-06-28 00:00:00"
    },
    {
      "id": "860ccafc-2b23-4002-942b-bb242f004289",
      "text": "CDC clinical guidance (May 2021) noted people with recent SARS-CoV-2 infection may consider delaying vaccination for up to three months and that infection can confer temporary immunity.",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "a9f960be-0d8b-42d4-be70-d97e78e0155a",
      "text": "Israeli Ministry of Health and Reuters reported in early July 2021 that measured effectiveness of the Pfizer–BioNTech vaccine against infection had declined (headline figure reported ~64% in early July amid Delta spread).",
      "date": "2021-07-05 00:00:00"
    },
    {
      "id": "4740cab1-8725-4fc8-a0f0-f1d554915a43",
      "text": "SIREN study (healthcare workers) reported substantially lower reinfection rates among antibody-positive participants compared with antibody-negative participants.",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "8ad73028-8c12-4fa6-a432-5b4119bf63dc",
      "text": "Lancet Rheumatology paper reported lower humoral (antibody) responses after COVID-19 vaccination in patients with immune‑mediated inflammatory diseases",
      "date": "2022-03-17 00:00:00"
    },
    {
      "id": "33911966-bd3c-4971-abde-7b549abbf5c0",
      "text": "Japan suspends use of some Moderna COVID-19 vaccine batches after discovery of foreign/black particles",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "b2f75d73-126f-423c-acc9-5075c262d520",
      "text": "FDA authorizes Pfizer-BioNTech COVID-19 vaccine for children 5–11",
      "date": "2021-10-29 00:00:00"
    },
    {
      "id": "5ab3d19c-52f3-4215-b630-51123495bc58",
      "text": "Public reporting and CDC guidance on rare myocarditis/pericarditis cases after mRNA vaccination in adolescents and young adults",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "4dde4a46-a612-4bf1-b453-efe74073f1dd",
      "text": "U.S. publicly rejected Poland’s proposal to transfer its MiG‑29s via a U.S. base, citing NATO concerns",
      "date": "2022-03-09 00:00:00"
    },
    {
      "id": "08f91ad3-d5ad-4436-88ab-157ab205095e",
      "text": "NATO announced plans to reinforce its eastern flank with additional troops and assets in response to the Russian invasion",
      "date": "2022-02-03 00:00:00"
    },
    {
      "id": "243dbeb3-88ad-400e-a589-41c8938ab022",
      "text": "Analysis and reporting documented an uptick in Kremlin disinformation targeting Poland and Poland–Ukraine relations",
      "date": "2022-02-22 00:00:00"
    },
    {
      "id": "6aac85c1-f89b-434d-b528-04e5dff82c6c",
      "text": "WHO-China Joint Mission final report noted roughly 80% of confirmed COVID-19 cases were mild.",
      "date": "2020-02-28 00:00:00"
    },
    {
      "id": "e8b208e1-030d-4a27-bb7e-7787553dc27b",
      "text": "Early WHO/CDC public guidance said masks were primarily for symptomatic people and caregivers and were not routinely required for healthy members of the public.",
      "date": "2020-03-09 00:00:00"
    },
    {
      "id": "b6ee86a2-5295-4ca0-b93d-53914a4ebae5",
      "text": "Industry/academic report 'Sustainable Decommissioning: Wind Turbine Blade Recycling' (March 2021) documented technical and commercial barriers to large-scale blade recycling and called for solutions.",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "e8399eff-e7e6-4b21-b154-272768481766",
      "text": "Public Health Scotland / national reports on births and pregnancy outcomes for year ending 31 March 2023 published (routine surveillance showing fluctuations in stillbirth/neonatal rates).",
      "date": "2023-07-24 00:00:00"
    },
    {
      "id": "944d2dbe-3483-4e47-b538-7b8559e9d958",
      "text": "Published medical case reports and toxicology literature documenting severe turpentine poisoning",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "1136f4cb-a49d-41f1-9cac-d70dcf211cbf",
      "text": "Radiology literature (2021) documenting vaccine-associated axillary/supraclavicular lymphadenopathy and FDG PET/CT uptake",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "25a1caa7-d6f5-491d-9e2f-0a38fb2c651f",
      "text": "Publication of a case report describing rapid progression of marginal zone B‑cell lymphoma following BNT162b2 vaccination (Frontiers in Medicine)",
      "date": "2022-08-24 00:00:00"
    },
    {
      "id": "55ef6841-b095-4d5a-989c-cca41799f571",
      "text": "Germany publicly approved supplying Leopard 2 tanks to Ukraine and allowed other countries to re-export their Leopard tanks.",
      "date": "2023-01-25 00:00:00"
    },
    {
      "id": "1f092cf3-991e-4bd3-853d-2a376f8ad7f0",
      "text": "High-profile coverage of Wagner Group operations and heavy losses around Bakhmut in February 2023 increased attention on Wagner's battlefield role.",
      "date": "2023-02-17 00:00:00"
    },
    {
      "id": "b129bd74-7a51-4dec-969d-ea1fbdf47d0a",
      "text": "EPA issues the 2009 Endangerment Finding that greenhouse gases (including CO2) threaten public health and welfare.",
      "date": "2009-12-07 00:00:00"
    },
    {
      "id": "dac7813d-7275-44bb-ba70-9b18cb0b92f0",
      "text": "Scientific and industry literature documenting routine CO2 enrichment in greenhouses to boost plant growth (longstanding agricultural practice; review articles dating back decades).",
      "date": "1987-04-24 00:00:00"
    },
    {
      "id": "c1a76e96-5a4c-423f-ad79-fe2527f488fd",
      "text": "U.S. Rep. John Shimkus publicly refers to carbon dioxide as 'plant food' during a House Energy and Commerce subcommittee hearing.",
      "date": "2009-04-02 00:00:00"
    },
    {
      "id": "59bfd6ec-34b7-470f-93e9-7f20adf47941",
      "text": "Drone/sea‑drone attacks on ships and the Sevastopol/Black Sea Fleet anchorage",
      "date": "2022-10-29 00:00:00"
    },
    {
      "id": "6ddc3e25-2e33-41f1-ad1e-666dd835a9a3",
      "text": "Explosions at Saky (Novofedorivka) air base in western Crimea",
      "date": "2022-08-09 00:00:00"
    },
    {
      "id": "c3b6dba7-c61a-48bc-a3b0-5cdb54988e2c",
      "text": "Russian reports of arrests/detentions over alleged plots to sabotage Crimean infrastructure",
      "date": "2022-11-02 00:00:00"
    },
    {
      "id": "50fe6559-6f9f-4660-9edb-49929b234b82",
      "text": "Passage of the National Childhood Vaccine Injury Act (NCVIA) establishing the National Vaccine Injury Compensation Program (VICP)",
      "date": "1986-11-14 00:00:00"
    },
    {
      "id": "88585fe8-9d78-4049-9dca-176f1d48d205",
      "text": "FDA proposed sunscreen monograph update and limited 'GRASE' designation (only zinc oxide and titanium dioxide)",
      "date": "2019-02-26 00:00:00"
    },
    {
      "id": "f30159a5-55d8-4fa2-a777-19e4b9407855",
      "text": "Edgewell (Banana Boat) voluntary recall for sunscreens due to benzene contamination",
      "date": "2022-07-29 00:00:00"
    },
    {
      "id": "6f732b0b-8064-4b90-98d7-b3a056cfe23e",
      "text": "Seizure of Sloviansk and other towns (April 2014) — separatists quickly occupied checkpoints and were reported driving captured Ukrainian armoured vehicles",
      "date": "2014-04-16 00:00:00"
    },
    {
      "id": "10d02800-aa81-4b60-a52c-44f70d5a4ba9",
      "text": "Battle of Ilovaisk (August 2014) — encirclement and heavy Ukrainian losses with numerous troops killed, wounded or captured",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "13e0a4f7-4725-4307-982d-1d8a5d9aea21",
      "text": "UNESCO expert recommendation to list the Great Barrier Reef as 'in danger'",
      "date": "2021-06-22 00:00:00"
    },
    {
      "id": "9c39dcd3-3a13-408d-9f46-a0ff637bd8a7",
      "text": "AIMS press release: 'Reef in recovery window after decade of disturbances' (AIMS Long‑Term Monitoring Program results)",
      "date": "2021-07-19 00:00:00"
    },
    {
      "id": "288c9dd9-3458-4f12-b4d6-e48643cca886",
      "text": "Australian government and political backlash/lobbying over UNESCO recommendation",
      "date": "None"
    },
    {
      "id": "b23955d7-beff-4040-9358-de291f6dad20",
      "text": "Earlier inconsistent public messaging on mask use by health authorities (CDC guidance evolution, April 3, 2020 recommendation to wear cloth face coverings)",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "719f65fd-c5e6-45a9-9c6f-87b91510dcff",
      "text": "Publication of the DANMASK-19 randomized trial (Danish mask study) in the Annals of Internal Medicine",
      "date": "2020-11-18 00:00:00"
    },
    {
      "id": "a528a283-82b0-49e5-a211-6a00230e9650",
      "text": "UN OHCHR Human Rights Monitoring Mission (HRMMU) report on Ukraine noting incomplete/inconclusive investigations into the Odessa 2 May deaths",
      "date": "2014-06-15 00:00:00"
    },
    {
      "id": "f372bcce-24f2-4ed9-96cd-3179650f748f",
      "text": "South African National Institute for Communicable Diseases (NICD) early assessment reported Omicron appeared less severe on average but produced a rapid surge in cases and hospitalisations (report released Dec 21, 2021).",
      "date": "2021-12-21 00:00:00"
    },
    {
      "id": "4f338687-ee12-4164-af7c-22d507a2227f",
      "text": "Publication of a major global study quantifying temperature-related mortality (Zhao et al.) in Lancet Planetary Health",
      "date": "2021-07-07 00:00:00"
    },
    {
      "id": "111737aa-a6ea-4e79-96a0-0dda72e05afa",
      "text": "EU agreement on visa‑free travel for Ukrainian citizens (visa liberalisation process confirmed in 2017)",
      "date": "2017-05-11 00:00:00"
    },
    {
      "id": "a6b9ab6f-d230-4c51-9ca7-4e9937d5f5f6",
      "text": "EU sanctions on Russia in response to the annexation of Crimea and destabilisation of eastern Ukraine (sanctions imposed and expanded in 2014)",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "3d76c853-db5b-4627-a972-02d243783eee",
      "text": "Ukrainian Cabinet fixes one‑time payment of 15 million UAH for families of fallen servicemen (decree published)",
      "date": "2022-02-28 00:00:00"
    },
    {
      "id": "a4af2e0f-25a6-4104-889b-f1dc8a920a6d",
      "text": "Government measures earlier in 2022 to simplify/adjust compensation procedures for families (administrative changes and rolling implementation)",
      "date": "2022-04-04 00:00:00"
    },
    {
      "id": "a9ea8e8d-e334-4f5c-a6e9-f5710636ce5f",
      "text": "Amendments to the law on social/legal protection of servicemen came into force (changed wording about how one‑time payments are regulated)",
      "date": "2022-08-25 00:00:00"
    },
    {
      "id": "8d1e8f58-b8ca-43a4-8e79-91e7ca0256c1",
      "text": "Verkhovna Rada approved Ukraine's 2020 state budget (official figures: revenues ~UAH 1.093 trillion, expenditures ~UAH 1.18 trillion, UAH 141.5 billion allocated for debt servicing).",
      "date": "2019-11-14 00:00:00"
    },
    {
      "id": "3d02c32a-ad40-424f-8606-b4f8dfd8d519",
      "text": "IMF approved a US$3.9 billion Stand‑By arrangement for Ukraine (IMF press release documenting large external financing and conditionality).",
      "date": "2018-12-18 00:00:00"
    },
    {
      "id": "250bbe9a-0721-433c-881e-aac280e1ea73",
      "text": "World Bank / multilateral reporting (Ukraine Economic Update, Nov 2019) warned of sizable financing needs and public‑debt pressures for 2019–21.",
      "date": "2019-11-24 00:00:00"
    },
    {
      "id": "ec45304d-e020-47c6-b28a-0fc4ef0617ac",
      "text": "Reporting of social tensions and local backlash in Germany over the large influx of Ukrainian refugees (coverage throughout 2022 highlighting strains on communities and rising anti‑refugee sentiment).",
      "date": "2022-11-24 00:00:00"
    },
    {
      "id": "1d3fd3d3-bcb5-4057-a3ae-cec350879713",
      "text": "Rizzi restaurant in Baden‑Baden was reported to have fired a Ukrainian employee after he posted a video condemning Russia (reported and condemned by Ukrainian officials in March 2022).",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "0e1785c4-83ac-45e4-b0c6-3b992768e268",
      "text": "Explosions and missile strikes at Odesa port and nearby industrial sites were widely reported (e.g., reported explosions at Odesa port on April 3, 2022 and a deadly strike on April 23, 2022).",
      "date": "2022-04-03 00:00:00"
    },
    {
      "id": "1af1e3dc-71d8-4263-a2ec-a64fef34d4fd",
      "text": "Media reports of Western deliveries of gas masks and CBRN protective equipment to Ukraine (e.g., UK announced sending thousands of gas masks in April 2022).",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "7a30875c-5e64-4fbc-8c8d-bed9b6f27cc3",
      "text": "United Nations letter (dated 6 April 2022) referencing alleged planned provocations and preparations for chemical weapons use in Ukraine.",
      "date": "2022-04-06 00:00:00"
    },
    {
      "id": "a1e8eb0a-4b10-43cd-8856-21172708d018",
      "text": "Russian Ministry of Defence publicly claimed Ukrainian special services were preparing a chemical 'provocation' using toxic chemicals near the Yuzhny (South) port outside Odesa.",
      "date": "2022-04-23 00:00:00"
    },
    {
      "id": "2cc4e4af-dc46-4ad4-a36f-739242ed3129",
      "text": "Release/presentation of a Queensland Health study reporting that rates of persistent symptoms 12 weeks after Omicron infection were similar to rates after influenza in a highly vaccinated Queensland population.",
      "date": "2024-03-15 00:00:00"
    },
    {
      "id": "4e4dc1ce-8ec1-43b6-b148-db1a9cd086a0",
      "text": "European officials and media flagged that the proposed U.S. sanctions could target firms involved in Nord Stream 2 and other European energy projects",
      "date": "2017-07-26 00:00:00"
    },
    {
      "id": "b0540df9-eca6-4ced-b2d1-700014fcdf69",
      "text": "U.S. Senate overwhelmingly passed a bill imposing new sanctions on Russia (CAATSA)",
      "date": "2017-07-27 00:00:00"
    },
    {
      "id": "828a2b98-67aa-4664-83eb-541f6a3cd05a",
      "text": "President Trump announced U.S. withdrawal from the Paris Climate Agreement, triggering strong EU criticism",
      "date": "2017-06-01 00:00:00"
    },
    {
      "id": "45371774-43cb-4e3d-847c-91c826a691fc",
      "text": "OSCE Special Monitoring Mission (SMM) spot reports document shelling incidents and civilian casualties in Donetsk",
      "date": "2015-01-22 00:00:00"
    },
    {
      "id": "aec08892-b3ff-48a8-958c-46c7c40e6508",
      "text": "UNICEF report: over 1,000 children sheltering underground in Donetsk city (bomb shelters) and urgent needs appeal",
      "date": "2015-01-27 00:00:00"
    },
    {
      "id": "44ef036d-cabd-44bd-a118-83522dc907f7",
      "text": "International media reports 'Ukraine, rebels trade blame over shelling of central Donetsk' after July 2015 strikes",
      "date": "2015-07-19 00:00:00"
    },
    {
      "id": "6c9977de-a8e4-46cc-9f3a-cce09947f9d5",
      "text": "Signing of the Minsk II agreement (February 2015) and subsequent claims of non‑implementation and ongoing violations",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "c96a4fa8-d456-4ef1-a3af-9bb73753687a",
      "text": "Official supply‑shortage notices for semaglutide (Ozempic) and related GLP‑1 drugs in early 2023.",
      "date": "2023-02-27 00:00:00"
    },
    {
      "id": "81ff8eb3-a8ec-45c9-b9ee-9e6c21e49496",
      "text": "Deep energy and commercial ties between Italian energy firm Eni and Russia's Gazprom, including extensions of strategic agreements (reported 2011–2012).",
      "date": "2011-12-23 00:00:00"
    },
    {
      "id": "16a94229-5252-47ee-a983-9a151fb50d8f",
      "text": "Release of the U.S. Fourth National Climate Assessment (NCA4), emphasizing strong human influence on recent warming",
      "date": "2018-11-23 00:00:00"
    },
    {
      "id": "6bd57e1e-7b5d-4081-bfc5-623ac8cac507",
      "text": "Release of UAH Version 6.0 satellite temperature dataset showing a reduced lower-troposphere warming trend",
      "date": "2015-04-28 00:00:00"
    },
    {
      "id": "c16cfff2-edc1-403d-a5a3-9b8fad5d5dec",
      "text": "Publication of a 1980 study documenting systemic perfusion produced by vigorous coughing in humans and animals",
      "date": "1980-03-24 00:00:00"
    },
    {
      "id": "bbb76c07-d3ca-4a1a-918a-4e1e65f81fd2",
      "text": "Resuscitation Council UK public statement warning the public that 'cough CPR' is incorrect advice and should not be used outside monitored clinical settings",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "daaadb9e-5604-406e-bf09-cd42d4374674",
      "text": "OSCE Special Monitoring Mission reports from early 2015 described restricted access, movement limitations and damage affecting medical services in Donetsk region, complicating independent verification of medical treatment claims.",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "2f715b03-548e-49c1-9000-e306db6857fb",
      "text": "The existence and release of wounded Ukrainian soldier Roman Kapatsiy (treated after captivity) — reports showed he had severe injuries, attracted media attention, and his condition and treatment became contested facts.",
      "date": "2015-07-24 00:00:00"
    },
    {
      "id": "a965e587-80cf-4d10-8819-be9491ac2be8",
      "text": "Community publications and documentation describing routine reprocessing and geophysical corrections for satellite altimetry (ESA/AVISO and ESA CCI overview papers, 2016)",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "1ba9a5f3-9a3b-4afd-9cf9-c318bb80db34",
      "text": "PNAS paper reporting detectable acceleration in global mean sea level (Nerem et al., 2018)",
      "date": "2018-02-13 00:00:00"
    },
    {
      "id": "5ca90261-fa6c-467b-9774-646ffb71e21b",
      "text": "Shelling and a fire were reported at the Zaporizhzhia nuclear power plant during early March 2022 hostilities.",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "bd039d84-414e-4a80-9ac1-db3b9b1a85bb",
      "text": "US Air Force B-52 bomber task force conducted long-range integration flights through Europe (Bomber Task Force Europe) in March 2022.",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "8575edeb-b639-4048-a541-0e8f08e0f1a6",
      "text": "Russian President Vladimir Putin ordered Russian nuclear deterrence forces put on high alert.",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "6fad7068-796b-4e29-923e-b77c12c1b30c",
      "text": "NATO annual nuclear exercise 'Steadfast Noon' commenced, involving dozens of aircraft and allied nations.",
      "date": "2022-10-17 00:00:00"
    },
    {
      "id": "d17e6883-586d-470e-9f32-e80ae8581b10",
      "text": "NATO adopted its 2022 Strategic Concept at the Madrid Summit, explicitly addressing Russia as the most significant and direct threat to Allies’ security.",
      "date": "2022-06-29 00:00:00"
    },
    {
      "id": "b5b1d0f2-cb71-4b4b-b1b5-993a136abdb7",
      "text": "CDC MMWR report documenting thousands of vaccine 'breakthrough' infections reported January–April 2021",
      "date": "2021-05-28 00:00:00"
    },
    {
      "id": "dea66aaa-48a8-4cca-b92a-84b2590481b6",
      "text": "NIH / Health Affairs summary reporting that COVID-19 vaccines prevented nearly 140,000 U.S. deaths in the first months of rollout",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "150c3315-1cf3-4765-a408-2f64186e4e68",
      "text": "IPCC AR6 Synthesis Report released (summarizing strong attribution of recent warming to human greenhouse gas emissions)",
      "date": "2023-03-20 00:00:00"
    },
    {
      "id": "92dd5a3e-1456-4443-8272-98133402a88b",
      "text": "NOAA / NASA updates and public discussion of Solar Cycle 25 progress (solar-cycle forecasts/plots revised/updated in early 2023)",
      "date": "2023-02-24 00:00:00"
    },
    {
      "id": "e09c49de-0aef-4b62-a700-bb102432743b",
      "text": "Publication of Nicola Scafetta's paper arguing a large solar influence on recent climate change",
      "date": "2023-06-14 00:00:00"
    },
    {
      "id": "fe76db37-fdb5-4340-9f9c-ce91489ba14b",
      "text": "Kateryna Prokopenko (head of the Association of Azovstal Defenders' Families) visited Germany in early April 2023 to hold meetings with German MPs and ministry representatives seeking humanitarian and rehabilitation support for families and released soldiers.",
      "date": "None"
    },
    {
      "id": "f5356c05-dce7-44f5-a872-82e02ddd286e",
      "text": "News reports of contamination concerns after foreign particles were found in some Moderna vials in Japan (leading to temporary pauses/collections of batches).",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "fc4117d2-87c7-44ce-867c-4f13ac0f1392",
      "text": "Public HAARP transmission schedules / community notices in 2024 (routine test announcements, e.g., August 2024 transmission notice)",
      "date": "2024-08-13 00:00:00"
    },
    {
      "id": "da11cc7b-0f34-421e-bf7b-cf23c6d6b060",
      "text": "International Organization for Migration and other agencies repaired and expanded collective centres and integration/housing projects for internally displaced persons (IDPs) in Lviv region.",
      "date": "2017-06-24 00:00:00"
    },
    {
      "id": "c9eb5159-568f-4148-a2fb-6859815f6398",
      "text": "Adoption of Ukraine's 'On Education' law (Sept 2017) which phases in greater use of Ukrainian as the language of instruction.",
      "date": "2017-09-24 00:00:00"
    },
    {
      "id": "22b94445-9072-47f1-8db2-0a45e813b7e5",
      "text": "Media reports (international and domestic) on national‑patriotic youth camps and 'patriotic education' programs in Ukraine (coverage in 2018).",
      "date": "2018-11-24 00:00:00"
    },
    {
      "id": "75924a82-3fcc-4240-91aa-b5e0dc0ddca6",
      "text": "Government and research reports quantifying long COVID's prevalence and labour‑market impact in 2022 (UK ONS and research briefs)",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "11229a50-6227-4cda-b6f3-5925c6879785",
      "text": "Japan discovered metal contaminants in multiple Moderna vaccine batches (led to recalls and paused use)",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "91e04afe-07d9-40e2-9618-693f13e31bb7",
      "text": "EMA safety updates reporting millions of spontaneous adverse‑event reports in EudraVigilance (December 2022 update)",
      "date": "2022-12-08 00:00:00"
    },
    {
      "id": "79b10fc4-9ac8-4f93-8668-0ed316cb376e",
      "text": "Reporting in 2014 highlighted Svoboda's nationalist/controversial imagery and its roles in government after Euromaidan (e.g., BBC coverage of far‑right role in late 2014).",
      "date": "2014-12-13 00:00:00"
    },
    {
      "id": "148f7765-0c59-4960-80af-85da467e859c",
      "text": "Catalan child-protection agency (DGAIA) removed two schoolgirls from a Barcelona school and took them into protective custody on or after 17 June 2022.",
      "date": "2022-06-17 00:00:00"
    },
    {
      "id": "96921c57-8997-4820-ae0d-3f734506e1d1",
      "text": "Russian state television (Channel One, program Vremya) broadcast segments accusing Catalan authorities of 'Russophobia' in connection with the Barcelona custody case (late July 2022 coverage).",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "0cec1eb4-0d43-4e73-b943-262808d31996",
      "text": "Broader bilateral tensions between Spain/EU and Russia in 2022 (e.g., Spain expelled Russian diplomats in May 2022), increasing a receptive environment for claims of anti-Russian actions abroad.",
      "date": "2022-05-18 00:00:00"
    },
    {
      "id": "a9648e62-fdd2-4d60-9d4f-2eee4b983df0",
      "text": "Opinion op-ed in The Hill by Drs. Pierre Kory and Paul Marik claiming ~70% of patients in a private practice reported symptom onset after vaccination (coining/advancing 'long vax').",
      "date": "2024-03-06 00:00:00"
    },
    {
      "id": "9f8e5759-7324-42fc-a3a2-93d97062df5b",
      "text": "Official reports that Ukrainian nationals were among foreign victims and contacts with the Ukrainian embassy (Zelenskiy statement)",
      "date": "2023-10-08 00:00:00"
    },
    {
      "id": "e3138869-da14-4f17-97f1-26df7cad259b",
      "text": "Large-scale Hamas-led attack on Israel caused mass casualties and chaos",
      "date": "2023-10-07 00:00:00"
    },
    {
      "id": "ab57c0ee-23ff-4b12-8a23-b14c2fbe9ed6",
      "text": "Parliamentary measures (July 2022) and legislative proposals expanding categories eligible for exemption or deferment during mobilization",
      "date": "2022-07-29 00:00:00"
    },
    {
      "id": "bd45579f-c2f9-4ed6-8c28-c2cd8e8d68ee",
      "text": "Cabinet of Ministers Resolution No. 76 establishing the procedure for reservation (deferment) of employees during mobilization",
      "date": "2023-01-27 00:00:00"
    },
    {
      "id": "75910daf-346b-4c9a-b959-259c73a68ff9",
      "text": "Law on Mobilization amendments and implementing rules entering into force clarifying grounds and procedures for booking/reserving conscripts",
      "date": "2022-12-04 00:00:00"
    },
    {
      "id": "b8c349c1-0d1e-45cc-8f94-109672980d3c",
      "text": "State license granted to the Kyiv Three Saints Theological Seminary to offer a first (bachelor’s) level degree in Theology",
      "date": "2024-01-15 00:00:00"
    },
    {
      "id": "dc7cdf80-8073-4d2a-80c5-aa72b4be7526",
      "text": "International analyses documenting flows of foreign fighters into Syria/Iraq (The Soufan Group updates, 2014–Dec 2015)",
      "date": "2015-12-24 00:00:00"
    },
    {
      "id": "563ca22b-cb1b-4ac2-8562-688154bbb566",
      "text": "Second World Congress of Crimean Tatars convened in Ankara with hundreds of delegates from many countries (international diaspora gathering, Aug 1–2, 2015)",
      "date": "None"
    },
    {
      "id": "b48bf9de-0300-4962-a4bc-3b8c4ec05e4e",
      "text": "Media reports that some Crimean Tatars (and other individuals from the region) had fought in the Syrian conflict",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "6baee768-4fae-40bd-99ae-34818b6c4ff1",
      "text": "Lithuanian Riflemen's Union hosts a five-day camp for 30 children from eastern Ukraine (Donbass)",
      "date": "2019-08-07 00:00:00"
    },
    {
      "id": "8556b458-d003-4b29-9c94-899b30ca4564",
      "text": "Passage of Ukraine's 'decommunization' laws banning public promotion of Soviet symbols and requiring removal/renaming of Soviet‑era memorials and street names.",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "2fef81c4-c4ab-4e3e-a3f9-2a1e32f501b2",
      "text": "Ukrainian authorities (Ministry of Veterans Affairs / regional outlets) distributed Ukrainian commemorative medals to some WWII veterans in spring 2020.",
      "date": "None"
    },
    {
      "id": "4c2eba41-b018-43bd-a059-2a1210432b9c",
      "text": "Ukrainian lawmakers amended administrative code to prohibit public production and promotion of the St. George's (Victory) ribbon.",
      "date": "2017-05-16 00:00:00"
    },
    {
      "id": "0f127d4d-6f8f-4773-a3e2-fa45c536924c",
      "text": "OSCE Special Monitoring Mission (SMM) daily reports in late August–early September 2018 documented continuing ceasefire violations along the contact line (Donetsk/Luhansk).",
      "date": "2018-08-31 00:00:00"
    },
    {
      "id": "2cb073f1-14d4-4cbc-bad0-da4fc2360c56",
      "text": "Russian Foreign Ministry and other Russian officials publicly condemned Kyiv's reintegration law, saying it 'untied the hands of the war party' and undermined the Minsk process.",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "1bff33ad-7336-42d2-89c2-c045d3609bcd",
      "text": "European Parliament / policy briefings in 2018 and commentary highlighted tensions between Ukraine's domestic reforms (e.g., decentralisation/legislation) and the interpretation/implementation of Minsk II.",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "229b9137-7527-41ad-a10d-d86236fbc4dc",
      "text": "Ukraine signs the 'Law on the Reintegration of the Donbas' which defines Russia as an 'aggressor' and sets a new legal framework for retaking occupied territories.",
      "date": "2018-02-20 00:00:00"
    },
    {
      "id": "d35bb153-32de-4344-b1d3-debda63670ad",
      "text": "Legacy controversy over the 2012 Kivalov–Kolesnichenko language law and its political fallout (language policy highly politicized since 2012)",
      "date": "2012-08-10 00:00:00"
    },
    {
      "id": "fda7e305-9c69-414b-afbf-35c24c351e73",
      "text": "Kyiv City Council member Yuriy Syrotiuk registers a draft proposal to require Ukrainian in city advertising, record keeping and official communications",
      "date": "2016-03-11 00:00:00"
    },
    {
      "id": "3f21ec81-ede9-4aac-bcf6-7a87e74dc21d",
      "text": "Publication and coverage of genetic‑risk research showing APOE and common variants alter Alzheimer's risk/timing (Lancet Neurology 2018 and related coverage)",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "27a83928-0416-47d3-b260-0232ab70d248",
      "text": "Publication of the FINGER multidomain randomized trial showing diet, exercise, cognitive training and vascular monitoring improved cognition in at‑risk older adults",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "8c1de153-2b7d-4551-bd69-8006cafdaa5c",
      "text": "IPCC Fifth Assessment Report (AR5) Summary for Policymakers acknowledges smaller observed warming trends 1998–2012 than many model simulations and cites internal variability as a likely contributor.",
      "date": "2013-09-27 00:00:00"
    },
    {
      "id": "f298143c-340d-4e92-9efd-15885f108949",
      "text": "Amnesty International published a briefing documenting abuses and possible war crimes by pro-government volunteer battalions (e.g., Aidar) operating alongside official forces.",
      "date": "2014-09-08 00:00:00"
    },
    {
      "id": "0d06a48e-8249-453f-8f23-72b0f5363f52",
      "text": "Ukrainian President Petro Poroshenko publicly said Ukrainian forces were fighting 'foreign mercenaries' in the east.",
      "date": "2014-08-23 00:00:00"
    },
    {
      "id": "ec67ebfe-51fd-4eb8-bbf5-d55aa15d030e",
      "text": "NASA/NOAA public messaging about Solar Cycle 25 and increased space weather activity",
      "date": "2020-10-24 00:00:00"
    },
    {
      "id": "7c0055b8-d81a-4f20-aed1-36ad7842eb30",
      "text": "Out‑of‑cycle update to the World Magnetic Model (WMM2020) after rapid movement of the magnetic north pole",
      "date": "2019-12-24 00:00:00"
    },
    {
      "id": "cf210236-aec4-464b-9fcb-e21cafe07515",
      "text": "Ukraine reinstated military conscription to meet manpower needs after unrest in the east",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "9bd5f8e4-ee62-425d-bc45-13ff354ae53d",
      "text": "Summaries and timelines noted multiple, uneven waves of mobilization (including difficult autumn stages) with administrative complications",
      "date": "None"
    },
    {
      "id": "e4acbee1-1dd2-49fa-bc31-34100ff94b89",
      "text": "Feature reporting documented men hiding or fleeing to avoid conscription and the social backlash against mobilization",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "ef477121-218e-411a-9ccc-a92c33206c03",
      "text": "Federal judge orders the FDA to accelerate release of Pfizer COVID-19 vaccine documents (55,000 pages per month).",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "fff9f7c7-d732-47f4-a729-523774c75283",
      "text": "UKHSA published weekly COVID-19 surveillance tables (four weeks to 2 January 2022) showing counts of cases, hospitalisations and deaths broken down by vaccination status.",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "74b3efdf-3b9c-4f10-ae59-76311110302b",
      "text": "UKHSA published guidance and commentary (Transparency & data blog, 2 November 2021) explaining that raw counts by vaccination status should not be used to estimate vaccine effectiveness because of differing risk, behaviour and testing patterns.",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "a1a78fcf-e1cd-4efe-8936-ae38451c07f2",
      "text": "CDC and other public-health reports covering the Omicron period and bivalent booster era (e.g., MMWR analyses covering Oct 2021–Dec 2022, published early 2023) documented many breakthrough infections and complex changing relative rates of cases and hospitalisations.",
      "date": "2023-02-24 00:00:00"
    },
    {
      "id": "8d8d375a-a686-47da-bc9c-6eac5ea9a427",
      "text": "NORAD and U.S. military routinely intercept and track Russian military aircraft operating near Alaska (documented intercepts in prior years).",
      "date": "2023-05-14 00:00:00"
    },
    {
      "id": "88430b8d-2dfc-43e8-a450-708e825fe2dd",
      "text": "Historical pattern of military formation flights and public aerobatic displays over Alaska (large multi‑aircraft formation exercises reported previously).",
      "date": "2022-08-12 00:00:00"
    },
    {
      "id": "c9a568c2-86ca-45e2-9270-7f388f5fcb24",
      "text": "Russian/Crimean resettlement and incentive programs announced for Crimea",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "3d00d19c-2b7a-4ee2-a2b6-ba039a96eaee",
      "text": "Large‑scale issuance of Russian passports to Crimean residents after annexation",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "a7a074c1-90c6-4d6d-ab05-f1443b144afc",
      "text": "Resumption and growth of scheduled flights and transport connections to Simferopol (2015 onward)",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "9880c14a-51e5-458d-a588-7777014cd037",
      "text": "OSCE Special Monitoring Mission (SMM) reporting of increased ceasefire violations/explosions and damage in Luhansk frontline areas (SMM daily monitoring around mid‑February 2022, including Stanytsia Luhanska and Zolote).",
      "date": "2022-02-18 00:00:00"
    },
    {
      "id": "54cac0cc-06e2-4fd6-ba5b-b0cb4461853c",
      "text": "Leaders of the self‑proclaimed Donetsk and Luhansk ‘people’s republics’ announced mass evacuations to Russia (official evacuation orders and state messaging).",
      "date": "2022-02-18 00:00:00"
    },
    {
      "id": "d493f755-eed0-4944-bbd3-5a6c9974fdb4",
      "text": "Historical precedent of bridges and rail infrastructure being blown up during fighting in eastern Ukraine (documented incidents in 2014 where rail/road bridges were destroyed).",
      "date": "2014-07-07 00:00:00"
    },
    {
      "id": "ef8f4a79-fb2c-4f9d-859e-01abe99e9db1",
      "text": "LifeNews crew detained near Kramatorsk by Ukrainian forces, drawing attention to the channel’s activities in conflict zones.",
      "date": "2014-05-18 00:00:00"
    },
    {
      "id": "d4b57753-8820-4e4f-902f-f424afd1ddfa",
      "text": "Early-March videos and eyewitness accounts documented violent attacks by pro-Russian separatists on protesters and demonstrators in eastern Ukraine.",
      "date": "2014-03-14 00:00:00"
    },
    {
      "id": "9ffdedc3-d9ef-4cb0-8934-d60d94a1b93e",
      "text": "Self‑declared Donetsk and Luhansk 'people's republics' announced independence after May 2014 referendums",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "2c19756c-d0bb-4c7e-8ae6-cd4e787411f7",
      "text": "Trilateral Contact Group negotiations included representatives of the self‑proclaimed Donetsk and Luhansk authorities (OSCE mediation, mid‑2014)",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "bb9dbd38-71bc-4327-b8f4-4e516c788831",
      "text": "Publication and wide circulation of quantitative comparisons of volcanic vs anthropogenic CO2 (e.g., Gerlach 2011) providing concrete numbers showing volcanic CO2 is far smaller than human emissions.",
      "date": "2011-06-24 00:00:00"
    },
    {
      "id": "3d1ea1a5-3946-4ee6-ae7e-484f3bdf70ce",
      "text": "IPCC Special Report on Global Warming of 1.5°C (high-profile report, October 2018) that refocused public debate on CO2 budgets and human emissions.",
      "date": "2018-10-24 00:00:00"
    },
    {
      "id": "cafec841-66ca-4e56-8c7b-bec6678a1ec3",
      "text": "Reports and recall after discovery of foreign (black) particles in Moderna vaccine vials in Japan (late August–September 2021)",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "bc043127-5b23-4ee1-a4f9-b80ceb8089e6",
      "text": "CDC reports increased cases of myocarditis/pericarditis after mRNA COVID-19 vaccination in adolescents and young adults (public reporting began June 2021)",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "1d886fb6-8166-4a0b-af08-e49f9b3409c4",
      "text": "FDA authorizes Pfizer-BioNTech COVID-19 vaccine for children aged 5–11",
      "date": "2021-10-29 00:00:00"
    },
    {
      "id": "e12674be-e40a-4090-8e59-24ab738b83e1",
      "text": "Technical advisory scrutiny and Bureau response on ACORN‑SAT adjustments (ACORN‑SAT Technical Advisory Forum response)",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "1027ff9f-a236-4e67-ad2e-f71bd98a31b0",
      "text": "Release of the ACORN‑SAT homogenised temperature dataset by the Bureau of Meteorology",
      "date": "2012-03-24 00:00:00"
    },
    {
      "id": "f6bb2a03-7781-47e1-a609-0faed1482e89",
      "text": "Widespread use of distance learning by mid‑2022 (reports noting that by June 2022 most districts were providing remote classes)",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "8a634101-cd54-46bc-a687-7d1b533d8ffe",
      "text": "Ministry of Education and UNICEF launch 'Back to Learning Together' initiative encouraging return to in-person schooling",
      "date": "2022-08-22 00:00:00"
    },
    {
      "id": "16cfa5fb-2b2c-41bc-a45c-3bfbafe45d99",
      "text": "WHO and World Customs Organization published an HS classification reference for COVID-19 medical supplies (including simplified labels) on April 9, 2020",
      "date": "2020-04-09 00:00:00"
    },
    {
      "id": "ee28fe43-1894-4c95-8870-fc28fca4a76b",
      "text": "Adoption/use of the sixth edition Harmonized System (HS) nomenclature for commodity codes (introduced in 2017) that underpins WITS historical trade classifications",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "079c2f4a-cf04-4744-a34d-d7c5e33f1dd3",
      "text": "Russian flags and pro‑Russian banners were visibly displayed in Russian‑occupied Ukrainian cities (e.g., Melitopol, Kherson) after Russian forces took control.",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "30b5867c-0d85-4a47-b3b7-3c54f63a325f",
      "text": "Reports the US was sending military advisers and gear to Ukraine",
      "date": "2014-06-05 00:00:00"
    },
    {
      "id": "d752f6cc-4187-4afe-99fe-a1c6c2cae958",
      "text": "U.S. Congress passes the Ukraine Support Act (H.R.4278)",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "ff6cae56-e952-42b3-83a5-9ac9435224e6",
      "text": "President Obama meets President-elect Petro Poroshenko (bilateral meeting in Warsaw)",
      "date": "2014-06-04 00:00:00"
    },
    {
      "id": "76ca0985-7e78-47e4-b755-2290bf824812",
      "text": "CDC interim guidance recommending routine cleaning and disinfection of high-touch surfaces in public and private facilities",
      "date": "2020-03-10 00:00:00"
    },
    {
      "id": "83d0ef0d-d105-451f-9865-94a7fb63fbf0",
      "text": "Mainstream consumer guidance advising precautions when pumping gas (Consumer Reports article advising wipes/precautions)",
      "date": "2020-03-21 00:00:00"
    },
    {
      "id": "3f2cefbe-b919-486c-b195-695bd3725bcf",
      "text": "NEJM correspondence showing SARS-CoV-2 remains viable in aerosols and on surfaces (van Doremalen et al.)",
      "date": "2020-03-17 00:00:00"
    },
    {
      "id": "976b90b1-ffc0-45e9-bae7-ba4cd7407f18",
      "text": "News coverage and retailer actions showing grocery stores providing wipes and installing cart-sanitizing measures",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "4f5d7f54-0e07-4d45-8714-b56d3126678e",
      "text": "WHO/UNICEF updated and re-emphasised global guidance recommending exclusive breastfeeding for the first 6 months and advising not to give additional water to infants under 6 months.",
      "date": "2023-12-20 00:00:00"
    },
    {
      "id": "35397bc5-60fc-4557-99be-80f5907223d3",
      "text": "CDC MMWR report summarising cases of hyponatremic seizures among infants fed excessive solute‑free water (including bottled water) in Wisconsin (1993) and urging clinicians to discourage use of solute‑free water as a supplement for infants under 6 months.",
      "date": "None"
    },
    {
      "id": "425a5c11-f27d-4f43-be17-a3bb22e2b8c0",
      "text": "Gates Foundation funding of genetically engineered mosquito/gene-drive research (2016–2018 coverage, e.g., Oxitec funding)",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "5446ec33-6405-427f-a4a7-b1516e31c796",
      "text": "Study reporting very low methylphenidate (Ritalin) prescription prevalence in France based on drug reimbursement databases (published 2007–2008)",
      "date": "2008-03-24 00:00:00"
    },
    {
      "id": "30eb27a7-d0ba-4d1f-8de8-bf1c8259d737",
      "text": "CDC report 'Mental Health Surveillance Among Children — United States, 2005–2011' stating 'up to 1 in 5 children suffer from a mental disorder'",
      "date": "2013-05-17 00:00:00"
    },
    {
      "id": "d4cca293-647c-438c-8750-2eb681311176",
      "text": "French national telephone prevalence study (Lecendreux et al.) estimating childhood ADHD prevalence ~3.5%–5.6% (published 2011)",
      "date": "2011-04-24 00:00:00"
    },
    {
      "id": "71d928fc-0847-486c-9da2-baf35bbab3b4",
      "text": "Measles outbreak in the Gothenburg area (outbreak period Dec 2017–Jan 2018) reported in Eurosurveillance (article published April 25, 2019).",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "6915995f-bfd0-4669-b7a3-0b66d95da7ea",
      "text": "Public Health Agency of Sweden (Folkhälsomyndigheten) information emphasising that vaccinations in Sweden are recommended (not compulsory) and are implemented regionally.",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "1e340ec3-de70-4af2-9954-3014f5f13739",
      "text": "European pauses and safety reviews of the AstraZeneca vaccine after rare clot reports (March–April 2021)",
      "date": "2021-03-15 00:00:00"
    },
    {
      "id": "86f7ea7d-367b-4e3c-a4c2-06a33148d191",
      "text": "Japan recalls some Moderna COVID-19 vaccine doses after foreign particles found in vials (September 2021)",
      "date": "2021-09-02 00:00:00"
    },
    {
      "id": "8901b6ba-a1b3-4591-9266-938a286911c6",
      "text": "WHO designation of Omicron (B.1.1.529) as a Variant of Concern and early statements on mutations/immune escape",
      "date": "2021-11-26 00:00:00"
    },
    {
      "id": "ef32505f-4b87-443f-980e-b5273bb66e97",
      "text": "CDC/ACIP updates and MMWR reporting on myocarditis cases after mRNA vaccination",
      "date": "2021-07-06 00:00:00"
    },
    {
      "id": "80aa0218-4894-4d93-9036-99596d3f9805",
      "text": "Ukrainian law on temporarily occupied territories (Law No. 1207‑VII, 15 April 2014) — non‑recognition of documents issued by occupation authorities",
      "date": "2014-04-15 00:00:00"
    },
    {
      "id": "e513feeb-a471-4ce8-94c8-d0308e293d7c",
      "text": "Russian presidential decree (April 2019) simplifying and fast‑tracking Russian citizenship for residents of the self‑proclaimed Donetsk and Luhansk 'republics'",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "54f64ead-5d9e-422d-ba85-10bf0e254bd0",
      "text": "Publication of research using luciferase reporters in SARS‑CoV‑2 laboratory assays",
      "date": "2020-06-24 00:00:00"
    },
    {
      "id": "de8e82dd-5b36-4b6a-9e32-67075988ea63",
      "text": "NFPA / Fire Protection Research Foundation published reports and guidance describing the unique firefighting challenges posed by electric vehicle 'stranded energy' and battery fires.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "e6b15468-d019-476d-a80d-5ca76fb645ad",
      "text": "General Motors issued a high-profile recall of Chevrolet Bolt EVs over a risk of battery-related fires (recalls and repair campaigns announced starting November 2020 and updated subsequently).",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "6f1133cb-61a4-44f5-b5d1-c48a58b4bd78",
      "text": "Ford announced recalls and investigations into a small number of F-150 Lightning pickups over battery-pack issues after several battery-related fire incidents and a temporary production halt (recall notices and reports in early 2025).",
      "date": "2025-04-24 00:00:00"
    },
    {
      "id": "0d93e6dc-8136-49c8-a877-3309cd11622d",
      "text": "Multiple electric buses in London caught fire (high-visibility incidents in May 2024), prompting safety checks of hundreds of vehicles and broad media coverage.",
      "date": "2024-05-24 00:00:00"
    },
    {
      "id": "228efa10-aa8d-4e4a-a70f-9a434e61ab03",
      "text": "Publication of Otto et al., 'Energy budget constraints on climate response' (Nature Geoscience, May 2013), which produced observational energy-budget estimates of climate sensitivity on the lower end of model ranges.",
      "date": "2013-05-24 00:00:00"
    },
    {
      "id": "3df77559-ea00-4e25-aee5-5af4521b40ab",
      "text": "IPCC AR5 Summary for Policymakers (Sep 2013) stated it is \"extremely likely\" that more than half of the observed increase in global average surface temperature from 1951 to 2010 was caused by anthropogenic greenhouse gases.",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "f3187c0f-a7fa-4eb3-9659-2e4897884950",
      "text": "ICEYE and Ukraine's Ministry of Defence sign a Memorandum of Cooperation to strengthen remote-sensing support for Ukraine (publicised July 2024)",
      "date": "2024-07-08 00:00:00"
    },
    {
      "id": "56f97b95-7511-4f0d-90b0-29e6125e047c",
      "text": "Reporting that the 'Prytula' / 'People's Satellite' warranty period expired while GUR continued to use the asset (media coverage raising questions about operational status, July 4, 2025)",
      "date": "2025-07-04 00:00:00"
    },
    {
      "id": "f71e1b87-0731-4652-9fce-8e43d28e6513",
      "text": "Ukraine's Defence Intelligence (GUR/DIU) and media reports state the 'People's Satellite' supplied thousands of SAR images used to identify Russian military targets (mid‑2024 reporting of ~4,000+ images)",
      "date": "2024-06-26 00:00:00"
    },
    {
      "id": "16621546-2155-4af0-a522-ffbef36ca911",
      "text": "Cultural/history articles revisiting Reich's orgone accumulator (e.g., Open Culture piece) were published in early 2021 and circulated thereafter, describing the accumulator, its devotees, and DIY plans online.",
      "date": "2021-01-19 00:00:00"
    },
    {
      "id": "7043be3a-1348-4fbf-b4da-ad5f86f81265",
      "text": "Documented paramilitary training and transnational links involving Azov/National Corps veterans (analyses and reports up to 2021)",
      "date": "2021-12-24 00:00:00"
    },
    {
      "id": "d2dc63a2-a2b0-46f3-9c28-22af90aa8310",
      "text": "Ukraine surrendered the Soviet-era nuclear arsenal under the 1994 Budapest Memorandum",
      "date": "1994-12-05 00:00:00"
    },
    {
      "id": "43918ef3-c02d-446c-9939-aa0619c5f4fa",
      "text": "A group of countries (UK, Poland, Netherlands and others) publicly pledged to pursue 'unprecedented' military support including main battle tanks for Ukraine.",
      "date": "2023-01-19 00:00:00"
    },
    {
      "id": "aa4f399d-477c-4275-904c-522b7565062b",
      "text": "Germany approves sending Leopard 2 tanks to Ukraine, paving way for allied tank deliveries.",
      "date": "2023-01-25 00:00:00"
    },
    {
      "id": "e84846ba-99ab-47fe-a730-6172d9ac3b35",
      "text": "Russian officials publicly denounced Western promises to send tanks as an escalation and framed them as direct Western involvement in the conflict.",
      "date": "2023-01-26 00:00:00"
    },
    {
      "id": "28dabced-e72d-40db-a769-1ed696cfb685",
      "text": "UN Secretary-General António Guterres called for de‑escalation and warned about risks of wider war in public remarks at Davos.",
      "date": "2023-01-18 00:00:00"
    },
    {
      "id": "dcb9c056-92d5-4729-b922-92cfe2886e27",
      "text": "Peer‑reviewed retrospective study (Argentina) found higher rates of false‑positive HIV ELISA results among people with prior COVID‑19 or detectable anti‑SARS‑CoV‑2 antibodies",
      "date": "2023-02-07 00:00:00"
    },
    {
      "id": "be2dc09e-34a3-4a1e-8396-9fa5bd1a5998",
      "text": "NATO maritime group (including Turkish navy participation) visited the Bulgarian Black Sea port of Varna during Black Sea deployment",
      "date": "2015-03-09 00:00:00"
    },
    {
      "id": "d3eeab90-548e-4b0c-b847-422addd6dde1",
      "text": "Investigations and reporting showing Bulgarian-made weapons appearing in Middle Eastern conflict zones",
      "date": "2015-12-16 00:00:00"
    },
    {
      "id": "f69ea3ae-6350-45cb-97f3-9a323713bb8d",
      "text": "Ukraine detained a Turkish-owned cargo ship after it visited a Crimean port",
      "date": "2015-03-27 00:00:00"
    },
    {
      "id": "89af2cfb-0121-4d57-83f1-725bd1f33b6d",
      "text": "Reuters report that Turkey's state intelligence agency helped ship arms to Syrian rebel areas",
      "date": "2014-01-28 00:00:00"
    },
    {
      "id": "2da829a2-d59e-4a98-921a-295d99a62943",
      "text": "Investigative reporting on crowdfunding for alternative cancer treatments and rise in patient fundraising for unproven therapies.",
      "date": "2018-09-14 00:00:00"
    },
    {
      "id": "a6ac98d3-f2a9-457d-800a-22ac55a5cff0",
      "text": "WHO commentary warning against 'immunity passports' and noting uncertainty about post‑infection immunity",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "fa43bf47-f53b-457f-92ba-d9060e873e45",
      "text": "Publication: 'Seasonal coronavirus protective immunity is short‑lasting' (Edridge et al., Nature Medicine, May 2020)",
      "date": "2020-05-11 00:00:00"
    },
    {
      "id": "58d52923-309c-4639-b67f-3660c4b7a5db",
      "text": "WHO told Reuters it had advised Ukraine in March 2022 to destroy certain high‑risk pathogens in public health laboratories to prevent accidental release during the war",
      "date": "2022-03-11 00:00:00"
    },
    {
      "id": "106bd334-194a-46f9-89ae-c7207674e45d",
      "text": "A prior 2020 incident: Ukrainian volunteers dropped ruble‑shaped leaflets over occupied Luhansk (Slavyanoserbsk/Stepove), which local separatist authorities later claimed were contaminated",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "605516b3-6350-4af2-a2a4-0e5e03f786c8",
      "text": "FDA issues Emergency Use Authorization for Pfizer–BioNTech COVID‑19 vaccine (Dec 2020)",
      "date": "2020-12-11 00:00:00"
    },
    {
      "id": "a1c1f03c-2199-42ea-b800-30e376e60e7b",
      "text": "Publication of early seroprevalence studies suggesting lower infection fatality rates (e.g., Stanford/Santa Clara preprint)",
      "date": "2020-04-17 00:00:00"
    },
    {
      "id": "4ff7f89e-7034-4984-b150-cf36a2108c68",
      "text": "IMF / national energy-policy documents and regulator schedules (2015–2016) documented planned increases in household energy tariffs as part of energy-market reform and commitments to creditors.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "f83a30b3-bda9-4d94-a290-fbc0c947dbd4",
      "text": "Kyiv City Council approved additional municipal budget allocations for organizing and hosting Eurovision (including reported allocations for surveillance/security and event costs).",
      "date": "2016-10-24 00:00:00"
    },
    {
      "id": "f5041c7d-5ced-42ef-b16b-265fff9faf50",
      "text": "European Broadcasting Union (EBU) confirmed Kyiv as host city for the 2017 Eurovision Song Contest.",
      "date": "2016-08-24 00:00:00"
    },
    {
      "id": "88cbd551-9a16-4dcb-bfde-6588777cc74f",
      "text": "Russian strikes and shelling left Kharkiv without water and power, with dozens of civilian casualties reported",
      "date": "2022-03-03 00:00:00"
    },
    {
      "id": "dda1be66-a107-41ec-93a7-19785aaf8620",
      "text": "Evacuations and chaotic flight from Kharkiv, including reports of students and residents fleeing on foot after nearby shelling",
      "date": "2022-03-03 00:00:00"
    },
    {
      "id": "d3451e34-9533-4766-974d-3fcdb0c014ea",
      "text": "Frequent reporting and situation updates showing Ukrainian forces prioritizing defense and counterattacks around Kyiv while fighting continued in the northeast",
      "date": "2022-03-31 00:00:00"
    },
    {
      "id": "4f1874ce-1d5b-4a37-93b6-1081e371c585",
      "text": "Norwegian review of deaths among very frail elderly shortly after Pfizer vaccination (investigation reported March 2021)",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "7573ffd4-3209-4f1b-a704-f3bf46faa2c9",
      "text": "CDC / ACIP communication and MMWR reports on myocarditis after mRNA vaccines (June 2021)",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "168afc39-23ad-42a9-a4c1-9cd89385981a",
      "text": "OSCE Special Monitoring Mission reports and daily summaries recorded clashes, alleged atrocities and contested reports around Donetsk/Snizhne in Aug 2014",
      "date": "2014-08-21 00:00:00"
    },
    {
      "id": "4c56dcfd-316c-4b0c-b293-23eccee791ef",
      "text": "Airstrike hits residential buildings in Snizhne, killing civilians",
      "date": "2014-07-15 00:00:00"
    },
    {
      "id": "9daad42d-18d2-4972-91b8-ef9a05123604",
      "text": "Japan reports contamination (black/foreign particles) in batches of Moderna COVID-19 vaccine vials, prompting recalls and temporary suspension of some batches",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "44b5f8c2-b8bc-480b-98f6-1704d3629f4f",
      "text": "Coverage and commentary noting a post-pandemic rise in late-stage and some rare/aggressive cancer diagnoses — analysts and clinicians pointed to missed screenings, delayed diagnoses and possible biological mechanisms tied to SARS‑CoV‑2 infection",
      "date": "2024-06-24 00:00:00"
    },
    {
      "id": "f7547891-fa78-414e-ab7a-62f3b8edde8d",
      "text": "U.S. Government Accountability Office (GAO) report on cloud‑seeding technology (GAO‑25‑107328) concluded in December 2024 that evidence for cloud‑seeding effectiveness is limited and uncertain.",
      "date": "2024-12-19 00:00:00"
    },
    {
      "id": "80344cca-fd55-4c1f-bf37-13d5c04a010f",
      "text": "A private cloud‑seeding company (Rainmaker Technology) conducted a brief cloud‑seeding flight over south‑central Texas two days before the floods.",
      "date": "2025-07-02 00:00:00"
    },
    {
      "id": "2a009960-9048-4096-b8b0-842ff57f2b0e",
      "text": "Russian president's decree simplifying the naturalization process for Ukrainians (widely reported July 2022)",
      "date": "2022-07-11 00:00:00"
    },
    {
      "id": "c2b186f6-c022-4b2b-918e-01c7ae57ece6",
      "text": "Local and national Ukrainian reports (mid-March 2022) documented that Russian shelling had heavily damaged parts of Rubizhne City Multidisciplinary Hospital (e.g., maternity/obstetrics department destroyed).",
      "date": "2022-03-15 00:00:00"
    },
    {
      "id": "fcb1f017-02c2-49ef-a0de-5a8be0a4a3de",
      "text": "Ramzan Kadyrov publicly announced Chechen forces' deployment to Ukraine and frequently posted videos and claims via his Telegram/state-affiliated channels in Feb–May 2022.",
      "date": "2022-02-26 00:00:00"
    },
    {
      "id": "f6298f4e-34be-4bd5-a9e3-c09111e5e60b",
      "text": "The Rubizhne Central City Hospital infectious diseases department had been renovated in 2017 with funds from UNDP and the Government of Japan (official works and signage).",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "3a0429c7-68cc-4b17-8842-8b698a3c682b",
      "text": "IPCC AR5 and public messaging about decadal/short‑term variability vs. long‑term warming (IPCC WGI report, 2013)",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "6b716a22-76d1-466d-9ff6-7f7dc7399a03",
      "text": "Commissioning and public release of the U.S. Climate Reference Network (USCRN) as a high‑quality, ‘pristine’ temperature station network (began 2005; ongoing rollout)",
      "date": "2005-04-24 00:00:00"
    },
    {
      "id": "8ca1d7aa-9e43-46fb-86f4-1a2ef994f80c",
      "text": "Publication of Karl et al. (NOAA) in Science revising global surface temperature records and rebutting the idea of a global 'hiatus' (June 2015)",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "f13890cf-a339-4ac5-80b3-3630493f1039",
      "text": "Local bans/restrictions on Russian‑language cultural products in parts of Ukraine (example: Lviv restrictions/public measures).",
      "date": "2018-09-19 00:00:00"
    },
    {
      "id": "41481512-2ffe-410c-b574-b775d2ac0edd",
      "text": "Constitutional Court declared the 2012 Kivalov–Kolesnichenko 'regional languages' law unconstitutional.",
      "date": "2018-02-28 00:00:00"
    },
    {
      "id": "415369c8-30f6-4fa5-809e-a154f30d2fa5",
      "text": "Public and parliamentary clashes around the second reading of the language bill, with pro‑Russian MPs and media framing the draft as discriminatory/anti‑Russian (disruption and heated debate around Feb–Mar 2019).",
      "date": "2019-02-28 00:00:00"
    },
    {
      "id": "902a1595-3dd5-4012-b0bd-83fe8948f71f",
      "text": "Verkhovna Rada approved draft bill No. 5670-d (the new state language bill) at first reading.",
      "date": "2018-10-04 00:00:00"
    },
    {
      "id": "89306a7f-432c-42e6-ad88-b078d6e35833",
      "text": "Dutch Safety Board (Onderzoeksraad) formally took charge of the international investigation into the MH17 crash",
      "date": "2014-07-23 00:00:00"
    },
    {
      "id": "4d09c518-222d-4ced-a7f4-12f71e9f4182",
      "text": "Gazprom and Naftogaz sign settlement and five-year transit agreement",
      "date": "2019-12-30 00:00:00"
    },
    {
      "id": "1c178e2e-5b14-4c6d-93fc-1b8fffd907e6",
      "text": "Longstanding precedent: Russia cut gas to Ukraine and Europe in January 2009",
      "date": "2009-01-24 00:00:00"
    },
    {
      "id": "732b85e8-3019-4568-8bdb-996dffebbe60",
      "text": "Inauguration of TurkStream pipeline (alternative southern route)",
      "date": "2020-01-08 00:00:00"
    },
    {
      "id": "ce4c5e9d-7414-42b4-976a-83c224c8bfb0",
      "text": "Published analysis noting reduced guaranteed transit volumes from 2021 under the 2019 deal",
      "date": "2020-02-24 00:00:00"
    },
    {
      "id": "aa115de9-cb33-42a2-b72f-cc1fcb53651f",
      "text": "IUCN / Polar Bear Specialist Group published 2015 Red List assessment with a global population estimate (≈22,000–31,000) and noted the overall population trend as 'unknown'.",
      "date": "2015-10-24 00:00:00"
    },
    {
      "id": "cf1859da-3e2c-4640-8d45-1b649c6efd89",
      "text": "Amnesty International and Human Rights Watch published 2018 findings that Ukrainian authorities failed to investigate and punish far‑right violence",
      "date": "2018-06-14 00:00:00"
    },
    {
      "id": "6c2d4573-fdb1-4022-b637-584a82b70b2c",
      "text": "Volunteer battalions (including Azov) were brought under the Interior Ministry/National Guard command in 2014",
      "date": "2014-05-15 00:00:00"
    },
    {
      "id": "f863cc41-925b-40e4-bfd1-d70664e0a384",
      "text": "Reports that some volunteer regiments were financed or sponsored by political figures/oligarchs while operating under ministry structures (example: Dnipro-1)",
      "date": "2016-02-18 00:00:00"
    },
    {
      "id": "02e90b1c-35ac-4c76-9490-e196796f07ca",
      "text": "IPCC AR5 (2013) assessment noting divergence among lines of evidence for equilibrium climate sensitivity",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "6a6b6e27-e2ee-4fbc-9a8d-4c993f33ffc5",
      "text": "Release of UAH Version 6 satellite temperature product (Spencer & Christy), reporting reduced tropospheric warming trend",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "f035e906-0b9e-4776-8f28-507ead8aa2bb",
      "text": "Ukraine's 2018 national drug situation report (2017 data) noted transit and domestic production of various drugs",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "28b573f9-0e8f-42dc-85af-1fb345bfa138",
      "text": "Large heroin seizure transiting through Odesa/Illichivsk port (reported 12 June 2015)",
      "date": "2015-06-12 00:00:00"
    },
    {
      "id": "7c4cf18e-a1fc-4fd7-87c3-1d0205d000f7",
      "text": "Growing media and scientific attention to microplastics in the food chain (scholarly reviews and coverage 2021–2024)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "543fdefa-d58e-4d76-8071-bb86cf9e75be",
      "text": "Public-health agencies (including the U.S. CDC) and research institutions historically filed patents on viral isolates or related sequences (e.g., CDC and others filed patent applications around the 2003 SARS outbreak to ensure public access to samples).",
      "date": "2003-05-24 00:00:00"
    },
    {
      "id": "d33725f4-3fb6-4ab1-8fe5-92793806bd79",
      "text": "Publication of the Independent Peer Review and technical reports documenting ACORN‑SAT methods (technical advisory documents made public).",
      "date": "2011-07-24 00:00:00"
    },
    {
      "id": "79188f36-9dfb-4930-8fe5-4f28c5adf64f",
      "text": "Release of the ACORN‑SAT homogenised temperature dataset by the Australian Bureau of Meteorology (the official long‑term Australian temperature series).",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "e5542718-0f4a-4a6a-b2a9-a7f74876d478",
      "text": "Government discussion of investigating the Bureau after public controversy over temperature adjustments (reported discussions in 2015).",
      "date": "2015-09-24 00:00:00"
    },
    {
      "id": "853229aa-e197-46e6-b730-86eb4a52ab20",
      "text": "FDA enforcement actions and public warnings against numerous for‑profit stem cell clinics selling unapproved therapies",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "c543a8ff-a376-419e-8af9-95d851369395",
      "text": "UN human-rights submissions and NGO reports (2012) documented development and piloting of restorative/diversion programmes for children in conflict with the law across multiple Ukrainian communities.",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "81a49100-18a5-401b-ad73-76867ece0bb2",
      "text": "Parliament passed an amnesty law and released many protesters (including minors) detained during Euromaidan, creating visible cases of youths being freed from criminal charges.",
      "date": "2014-02-14 00:00:00"
    },
    {
      "id": "c0ce502b-f8aa-44f6-b754-63a4956044f1",
      "text": "Legislative activity and draft bills on child‑friendly procedures and mediation (alternative bills on mediation submitted to the Verkhovna Rada) were reported in 2013.",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "db80af84-e808-4fc4-9b3a-48ffda50ff52",
      "text": "Longstanding NGO-led restorative justice pilot projects (first initiated in 2003) and subsequent local pilots expanded through the 2000s and early 2010s.",
      "date": "2003-01-24 00:00:00"
    },
    {
      "id": "aa9876ba-55bc-43dc-b76f-e3374e78c9d1",
      "text": "Japan suspends ~1.6 million Moderna doses over contamination reports",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "2be83f52-f77c-4552-82c3-949839d95a0b",
      "text": "Israel study reports cases of myocarditis after Pfizer mRNA vaccine",
      "date": "2021-10-06 00:00:00"
    },
    {
      "id": "e205fce5-7add-4723-b183-f8e3f4793203",
      "text": "Study/analysis showing waning protection of BNT162b2 against Delta (Israel)",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "a62e7c0c-3014-426b-b4cb-f09f41a35640",
      "text": "Arla Foods announced a UK trial of the methane-reducing feed additive Bovaer across ~30 farms (with Tesco, Aldi and Morrisons named partners).",
      "date": "2024-11-26 00:00:00"
    },
    {
      "id": "171ecae6-87ff-409b-acdd-b6f06ea9c901",
      "text": "The UK Food Standards Agency published a detailed technical safety assessment (RP1059) on 3‑nitrooxypropanol (3‑NOP, the active in Bovaer), including residue analysis and limits of quantification for milk.",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "610bcf42-e654-4fd1-864c-8c97bfc7e388",
      "text": "dsm-firmenich (maker of Bovaer) announced that the US FDA had completed its review and that Bovaer met safety and efficacy requirements, paving the way for a US market launch.",
      "date": "2024-05-29 00:00:00"
    },
    {
      "id": "e9af9077-dfe3-49a3-9da9-a8677be6d2ec",
      "text": "EFSA / scientific assessments (including a 2021 EFSA feed-additive opinion / published scientific summaries) of 3‑NOP (Bovaer) were publicly available prior to 2024.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "0a43eaac-9d11-4559-b4ca-8aac7ca1c563",
      "text": "May 11, 2014 Donetsk and Luhansk 'referendums' claiming overwhelming support for separation",
      "date": "2014-05-11 00:00:00"
    },
    {
      "id": "7d7f1e0e-ae67-48b6-9123-ed59a792720f",
      "text": "NIH COVID‑19 Treatment Guidelines panel statement (early 2021) that there was insufficient evidence to recommend ivermectin for COVID‑19 (revisions in/around February 2021).",
      "date": "2021-02-24 00:00:00"
    },
    {
      "id": "66c3b2d9-9fd9-4ffb-a4fa-a50c1fac13ef",
      "text": "Reported incident and grid disconnection at Zaporizhzhia nuclear plant (December 2014)",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "1e39ba56-9940-4fbf-8dd1-889dedcc9779",
      "text": "Budapest Memorandum (security assurances to Ukraine)",
      "date": "1994-12-05 00:00:00"
    },
    {
      "id": "53db27b4-4d8e-4ffc-958f-39a178f1fcb9",
      "text": "CDC and FDA June 2021 review and public reporting of myocarditis and pericarditis cases after mRNA COVID‑19 vaccination.",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "cb6e63a1-19db-4f46-a697-59d594fab471",
      "text": "Federal judge orders accelerated public release of Pfizer vaccine documents (reported Jan 7, 2022), drawing attention to internal vaccine trial materials.",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "b91ff7ac-2550-4327-b693-f9c443c27bcd",
      "text": "Ogata et al. (Clinical Infectious Diseases, 2021) reported detection of SARS‑CoV‑2 vaccine antigens (spike protein fragments) in plasma of some mRNA‑1273 recipients.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "04585af3-b8d9-4baa-a6e6-186226f2c53a",
      "text": "Genomic surveillance identified BA.2.86 in U.S. samples (pooled swabs collected Aug 10; individual sample confirmed Aug 20) and CDC reported early detections.",
      "date": "2023-08-20 00:00:00"
    },
    {
      "id": "94106d8a-2fd8-4eaa-8ef3-f18642b87714",
      "text": "Ukrainian President Volodymyr Zelensky appoints Chrystia Freeland as an economic development adviser",
      "date": "2026-01-05 00:00:00"
    },
    {
      "id": "b0de1673-0cc8-41a9-b2c6-807fc598539d",
      "text": "World Bank / government-backed moves to restructure Naftogaz (ownership unbundling debate, May 2019)",
      "date": "2019-05-17 00:00:00"
    },
    {
      "id": "3a7c4f12-205f-44d7-893f-7c4955c0fb21",
      "text": "Ukrainian government public administration reform (Strategy for Public Administration Reform 2019) including targets to streamline staff",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "811cffa0-d85d-4b68-a81f-9ecb5bab33b3",
      "text": "World Bank: Ukraine Economic Update warns manufacturing and investment weak (press release)",
      "date": "2019-11-19 00:00:00"
    },
    {
      "id": "9fbd23d2-85e0-4c53-bdb0-b8f0210aaa2a",
      "text": "WHO declares COVID-19 a Public Health Emergency of International Concern (PHEIC)",
      "date": "2020-01-30 00:00:00"
    },
    {
      "id": "2c7779d3-50fa-4978-a751-9def7aca0cc2",
      "text": "Publication of a peer‑reviewed paper arguing a 'Modern Grand Solar Minimum' could cause decades of cooling",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "cbf28224-359f-4af5-a68f-874ac3a7cfc2",
      "text": "Nordic countries (Sweden, Denmark, Norway, Finland) limited or paused use of Moderna in younger people citing myocarditis signals (Oct 2021)",
      "date": "2021-10-06 00:00:00"
    },
    {
      "id": "2e24dce7-d94c-4791-90e0-80af31835706",
      "text": "CDC/ACIP report and guidance noting rare myocarditis cases after mRNA COVID-19 vaccination (June 2021)",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "2d51f614-a53b-41b7-a05c-e314d3acff13",
      "text": "FDA emergency authorization of Pfizer‑BioNTech COVID‑19 vaccine for children 5–11 (Oct 29, 2021)",
      "date": "2021-10-29 00:00:00"
    },
    {
      "id": "5a766bde-8fc3-48c8-9691-33709b37f34e",
      "text": "MedRxiv/academic preprint showing children have stronger pre‑activated innate airway antiviral responses to SARS‑CoV‑2 (June 2021)",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "195dd2bf-8e9a-4ca1-89dd-d5527e18c2a1",
      "text": "Local/municipal moves to formalise 'underground' schooling in frontline areas (Kharkiv announced plans and preparatory works for an underground school; subway‑based classes were reported in Kharkiv).",
      "date": "2023-10-24 00:00:00"
    },
    {
      "id": "03f59c33-5d82-4ad4-83bc-6a7b7862e369",
      "text": "UNICEF photo essay and reporting documenting children sleeping and studying in basements, bomb shelters and other protected spaces in wartime Ukraine.",
      "date": "2022-09-08 00:00:00"
    },
    {
      "id": "2fb6d1b3-35d3-4799-8513-846ab8a4d75f",
      "text": "Commentary and analysis documenting a broader trend of 'atrocity denial' and claims that wartime suffering (in Gaza and Ukraine) is 'staged' — media pieces in November 2023 noted this pattern.",
      "date": "2023-11-15 00:00:00"
    },
    {
      "id": "7c3b6688-d683-4382-903c-b975332dbc52",
      "text": "Earlier 2025 federalized National Guard deployments to U.S. cities (e.g., Los Angeles in June 2025)",
      "date": "2025-06-12 00:00:00"
    },
    {
      "id": "0573fdc1-393d-4cd7-8ccd-282f5126c66f",
      "text": "Japan suspends use of multiple Moderna vaccine batches after reports of foreign particles/contamination found in vials.",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "afd7c698-e8d7-4547-9818-018bf39b410b",
      "text": "CDC and FDA recommend a pause in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare cerebral venous sinus thrombosis (blood clots) in recipients.",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "e36d0b37-49fc-4dd8-bac5-bca15b1c8382",
      "text": "European Medicines Agency (EMA) concludes that the Oxford–AstraZeneca COVID-19 vaccine is associated with very rare unusual blood clots combined with low blood platelets and updates safety information.",
      "date": "2021-04-07 00:00:00"
    },
    {
      "id": "c46920ea-8f61-469c-94c8-0f4df258b9bb",
      "text": "EU Agency for Fundamental Rights (FRA) / EU research on 'severe forms of labour exploitation' highlighted cases and structural vulnerabilities of migrant workers in Poland",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "9ce38159-4df2-4a30-b881-4e97c679c2c1",
      "text": "Poland ratified the 2014 Protocol to the ILO Forced Labour Convention in October 2016 (official recognition and legal steps on forced labour)",
      "date": "2016-10-24 00:00:00"
    },
    {
      "id": "d89eff74-1189-4fd5-b33f-6c3f55c0b6bb",
      "text": "Polish government statistic: 420,000 Ukrainian citizens paid Social Insurance contributions in 2018 while estimates suggested up to 1–2 million Ukrainian migrants in Poland",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "bd07d283-3ff2-42c5-aad4-0c9508c49476",
      "text": "Yatsenyuk faced pronounced political pressure and very low public approval in July 2015 (KIIS poll showed extremely low support), creating a background narrative of a weakened leader.",
      "date": "2015-07-20 00:00:00"
    },
    {
      "id": "f5d06ae9-4e8c-4ace-ae65-7ad815033fde",
      "text": "U.S. and Western officials had publicly warned in early February 2022 about the possibility of Russian 'false flag' operations to justify invasion.",
      "date": "2022-02-04 00:00:00"
    },
    {
      "id": "fbab0ba7-0a1a-42f7-b6c9-c7a2b136e760",
      "text": "A Russian missile struck a high-rise apartment building in southwestern Kyiv and was widely reported on Feb 26, 2022.",
      "date": "2022-02-26 00:00:00"
    },
    {
      "id": "ffa0b490-c0c6-4066-ac6b-412aa4813bee",
      "text": "IPCC AR5 (2013) Summary for Policymakers: no single best estimate for equilibrium climate sensitivity given wide uncertainty across lines of evidence",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "0ad13d49-2b90-4845-b043-0b1effe7af40",
      "text": "Reuters special reporting on the Ukrainian government's struggle to control independent volunteer/maverick battalions (reports of units operating beyond official command).",
      "date": "2015-07-24 00:00:00"
    },
    {
      "id": "6dfa4668-6bbc-4e53-b326-efaf5323340d",
      "text": "Amnesty International documented abuses by the Aidar volunteer battalion operating in Luhansk and areas around Donbas.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "29b68f52-c694-4bd7-b9ec-4862a05b6aa1",
      "text": "Human Rights Watch published 'You Don't Exist' documenting arbitrary detentions, enforced disappearances and torture in eastern Ukraine by actors including pro‑government forces.",
      "date": "2016-07-21 00:00:00"
    },
    {
      "id": "42f92565-64db-44cb-80c5-250dd9ed2225",
      "text": "Minsk II agreement (February 12, 2015) set security, disarmament and withdrawal conditions as prerequisites for holding local elections in Donbas.",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "4c32bec3-72e5-4e9b-a048-dd4ffde7edc2",
      "text": "Pro‑Russian separatists held disputed 'elections' in Donetsk and Luhansk on 2 November 2014 amid reports of armed men at polling stations and chaotic scenes.",
      "date": "2014-11-02 00:00:00"
    },
    {
      "id": "8fac81ca-74b5-4026-9d28-bca75cce2a4d",
      "text": "Israel reintroduced indoor mask requirements amid a surge driven by the Delta variant.",
      "date": "2021-06-25 00:00:00"
    },
    {
      "id": "a386b6c1-9b1f-4ced-979d-9ae27b682204",
      "text": "Texas governor lifts statewide mask mandate and business restrictions (rescind mask orders).",
      "date": "2021-03-02 00:00:00"
    },
    {
      "id": "1545f02a-2183-44e7-80eb-8e8017b06ace",
      "text": "Publication of the DANMASK-19 randomized trial in Annals of Internal Medicine showing limited protection for mask wearers (DANMASK-19).",
      "date": "2020-11-18 00:00:00"
    },
    {
      "id": "8ed289d3-0cf6-469c-9cad-185096f11474",
      "text": "Widespread visibility of Ukrainian nationalist symbols (UPA red-and-black flag, Bandera monuments) in Lviv and media coverage of those symbols",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "1d3c6131-e597-47a8-a1cd-17e85c114664",
      "text": "Documented incidents of swastika graffiti and antisemitic vandalism in Ukraine in 2014–2015",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "5e163e86-8df2-4970-be19-1c721b67481a",
      "text": "Air‑raid sirens sounded across Kyiv while President Biden and President Zelensky were visiting St. Michael's Cathedral (audio and footage captured live)",
      "date": "2023-02-20 00:00:00"
    },
    {
      "id": "3a2dda61-d58e-4bbf-aedc-ee26a6054a9d",
      "text": "IMF staff in Kyiv discussed draft anti-corruption court legislation as part of program-related conditions",
      "date": "2018-02-15 00:00:00"
    },
    {
      "id": "f6f52da1-b69c-479b-9180-8690fc279e05",
      "text": "IMF technical mission visited Kyiv to discuss continuation of the Extended Fund Facility (EFF) and held meetings with Ukrainian authorities",
      "date": "2018-02-15 00:00:00"
    },
    {
      "id": "19ded8bb-b942-4c26-96bd-47fbac381987",
      "text": "IMF public statements linking further financial support to Ukraine with implementation of pension reform and other policy conditions",
      "date": "2018-01-18 00:00:00"
    },
    {
      "id": "c39f38e6-6801-43f0-b58d-85b1bb40ce68",
      "text": "IMF said the timing of the next review of Ukraine’s program (and related decisions) was 'not yet decided', creating public uncertainty about disbursement timing",
      "date": "2018-02-15 00:00:00"
    },
    {
      "id": "3cc71956-33bd-42f1-821f-772ffdb32426",
      "text": "IMF approval of a $17.5 billion bailout program for Ukraine",
      "date": "2015-03-11 00:00:00"
    },
    {
      "id": "41b1eb86-1e6e-4c67-9ead-477dc17e5c3c",
      "text": "Russia's retaliatory ban on food imports from the EU, US and other countries",
      "date": "2014-08-06 00:00:00"
    },
    {
      "id": "560ad3d8-ac49-48cb-80f6-697bbb5eba4c",
      "text": "Sharp contraction of Ukraine's economy and currency devaluation during 2014–2015 (World Bank reporting)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "72c161a4-0fe8-4234-98fd-234cda651549",
      "text": "EU and US impose sanctions on Russia after the annexation of Crimea",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "beb0907e-2c5a-41e1-a3ac-cdb02446f79b",
      "text": "Russia cuts natural gas supplies to Ukraine amid pricing/dispute",
      "date": "2014-06-16 00:00:00"
    },
    {
      "id": "1078a74a-1bdd-4cf7-bb28-da7aacb1e369",
      "text": "Ukrainian government policy and public statements (reported by major outlets) urging Ukrainian athletes to avoid competitions where they may face Russian or Belarusian competitors and, at times, withdrawing athletes from events for this reason.",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "6cdc6ca7-913e-463c-a1b6-6192ca4e8f38",
      "text": "International Tennis Federation (ITF) suspends the Russian Tennis Federation and Belarus Tennis Federation from ITF membership and from participation in international team competition.",
      "date": "2022-03-01 00:00:00"
    },
    {
      "id": "24ae4864-abfe-4abf-899b-ea8d7ab6dacb",
      "text": "Federal judge orders the FDA to accelerate public release of Pfizer vaccine documents after a FOIA lawsuit (PHMPT), resulting in large batches of internal Pfizer/FDA files becoming publicly accessible.",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "042c20ef-1d96-448c-a138-f7fecca41e5c",
      "text": "Parubiy's documented early political activism: co‑founding the Social‑National Party of Ukraine in 1991 and leading the paramilitary group 'Patriot of Ukraine' (1998–2004).",
      "date": "None"
    },
    {
      "id": "e1e7bc0f-5e62-472b-b2fe-0c1350bf36eb",
      "text": "Established Kremlin disinformation pattern of portraying Ukraine (and Ukrainian officials) as 'neo‑Nazis' used repeatedly since 2014.",
      "date": "None"
    },
    {
      "id": "14836e2b-68e7-4472-951f-747a83eb318f",
      "text": "Spanish authorities had opened and publicised large reception/assistance centres for Ukrainian refugees in spring 2022 (e.g., Malaga centre opened 6 April; PM visited 20 April).",
      "date": "2022-04-20 00:00:00"
    },
    {
      "id": "31ec134e-e8d0-4347-ae2b-d7bb390827bf",
      "text": "Science outlets published explanations (early September 2024) that a combination of factors—dry Saharan air, pockets of wind shear, and short-term atmospheric anomalies—had temporarily suppressed Atlantic tropical cyclone formation.",
      "date": "2024-09-24 00:00:00"
    },
    {
      "id": "b4d900c3-7a33-4ac1-bbeb-2214891df708",
      "text": "NOAA issues an \"above-normal\" 2024 Atlantic hurricane season outlook predicting 17–25 named storms and a high probability of above-normal activity.",
      "date": "2024-05-23 00:00:00"
    },
    {
      "id": "7d8fc9d0-ee37-4617-bb57-bc9650a988a0",
      "text": "An unusually quiet Labor Day weekend (early September 2024) with no named storms in the Atlantic—reported as a seasonal rarity and record for recent decades.",
      "date": "2024-09-03 00:00:00"
    },
    {
      "id": "6dd22e0c-75a1-42c5-9669-5ea344deb675",
      "text": "Greta Thunberg's high-profile speech at the U.N. Climate Action Summit (widely covered and quoted in the days around Sep 23, 2019).",
      "date": "2019-09-23 00:00:00"
    },
    {
      "id": "d50c791d-d408-460a-91cb-c316bbb2b74f",
      "text": "Russian embassy in London publicly accused UK authorities of searching an Aeroflot aircraft at Heathrow and sent a diplomatic note demanding an explanation.",
      "date": "2018-03-31 00:00:00"
    },
    {
      "id": "7c66dd47-55d8-4d79-b029-18c78b008ccd",
      "text": "Ukrainian government creates Ministry of Information Policy (established 2 December 2014)",
      "date": "2014-12-02 00:00:00"
    },
    {
      "id": "3daef752-184a-46a5-b49e-f5f3862e40e8",
      "text": "NATO StratCom and academic reports documenting Russian information operations against Ukraine (2014–2016)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "78ab6f1e-93c8-4b9d-a81e-c46d3f8a86b0",
      "text": "UK government’s March 14 expulsions of 23 Russian diplomats and strong public accusations against Russia over the Skripal poisoning.",
      "date": "2018-03-14 00:00:00"
    },
    {
      "id": "46c4bbca-22a7-426e-b740-218b1943a208",
      "text": "Porton Down (Defence Science and Technology Laboratory) public statements (early April) that its scientists identified the substance as a Novichok-type agent but said they had not verified the precise source of the agent.",
      "date": "2018-04-03 00:00:00"
    },
    {
      "id": "f5a37044-43e2-48fe-9d3d-72dfb91550d8",
      "text": "Civil service reform and new requirements for Ukrainian in public administration (law adopted Dec 2015, implemented 2016)",
      "date": "2016-05-01 00:00:00"
    },
    {
      "id": "8acf3211-493a-42fb-86b7-ca69f528baf2",
      "text": "Passage of Ukraine's 'Law on Education' (which set Ukrainian as the primary language of instruction)",
      "date": "2017-09-05 00:00:00"
    },
    {
      "id": "8aa39dc8-d60f-4378-93f2-4036d197cd07",
      "text": "2015 'decommunization' laws and related campaigns to remove Soviet-era names and symbols",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "fb93dc07-736f-4e75-bc9e-feef9be33698",
      "text": "Adoption and entry into force of the Kivalov–Kolesnichenko 'regional languages' law (widely debated and later contested)",
      "date": "2012-08-10 00:00:00"
    },
    {
      "id": "e91cf261-b3d2-4dee-9fe5-9f289ce03b3c",
      "text": "Radio Free Europe/Radio Liberty coverage of Oleksandr Hurov (May 2014) describing capture and alleged torture by pro‑Russian separatists (includes account of attempts to remove or mutilate markings).",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "148e0912-fcdd-487e-8009-0cb800636227",
      "text": "Russian President Vladimir Putin publicly said Ukraine's counteroffensive had 'failed so far', characterising Ukrainian losses as 'vast'.",
      "date": "2023-06-13 00:00:00"
    },
    {
      "id": "082ef11d-1ea9-487f-9952-17564fb9c4d5",
      "text": "Rheinmetall had experienced a dramatic run-up in revenue, orders and share price since the 2022 invasion (company Q1/2023 reporting highlighted strong defence demand).",
      "date": "2023-05-04 00:00:00"
    },
    {
      "id": "11203772-88f3-4d44-8521-49a5752d94b6",
      "text": "Major international outlets reported the long‑awaited Ukrainian counteroffensive had begun in early June but initial progress looked limited and uncertain.",
      "date": "2023-06-09 00:00:00"
    },
    {
      "id": "3af0d05e-647f-42af-a495-1c1b27f989b9",
      "text": "Trilateral Contact Group and parties agreed a new ceasefire for eastern Ukraine effective 27 July 2020 (reported by Reuters/OSCE).",
      "date": "2020-07-27 00:00:00"
    },
    {
      "id": "65f32e56-cec4-40c8-a0d4-a1b7f6d34a3f",
      "text": "President Zelensky's endorsement/implementation of the 'Steinmeier Formula' (October 2019) and related public statements about negotiating a settlement in Donbas.",
      "date": "2019-10-24 00:00:00"
    },
    {
      "id": "d2ceb7c3-cbd1-4e64-b371-c92535e8b2a4",
      "text": "Major prisoner exchange between Ukraine and Russia (reported 7 September 2019), widely covered as confidence-building step.",
      "date": "2019-09-07 00:00:00"
    },
    {
      "id": "467fbfa1-667e-47f0-b679-4ccde1bc649d",
      "text": "Appointment of Dmytro Kuleba as Ukraine's Foreign Minister (4 March 2020) and his public rhetoric emphasising diplomacy and dialogue alongside deterrence.",
      "date": "2020-03-04 00:00:00"
    },
    {
      "id": "a8cdddc8-da0e-4ddb-bfb4-206b7861ec25",
      "text": "Russia's 2014 agricultural import ban hit French farmers (loss of export markets), creating domestic political sensitivity to the cost of sanctions.",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "5621db93-38d4-44e3-b9ac-662f17d5b014",
      "text": "Earlier Hollande statements (2015) publicly floated lifting sanctions if progress were made on Ukraine, establishing a precedent for claims he favored easing sanctions.",
      "date": "2015-05-01 00:00:00"
    },
    {
      "id": "e1d13f5a-15e7-412e-ad2d-a9a7f7ee5cdc",
      "text": "Publication and mailing of the 'European Climate Declaration' / World Climate Declaration (organised by Guus Berkhout / CLINTEL) to the UN asserting 'There is no climate emergency'.",
      "date": "2019-09-23 00:00:00"
    },
    {
      "id": "dd0ea02a-5156-4ea0-9cf4-df3bf324ed09",
      "text": "Greta Thunberg's high-profile speech to the U.N. Climate Action Summit in New York (widely covered and polarising).",
      "date": "2019-09-23 00:00:00"
    },
    {
      "id": "3f36f821-5acd-4e03-8925-56a32a0d41df",
      "text": "Global climate strikes and mass protests in the week of 20–27 September 2019 (Global Week for Future).",
      "date": "2019-09-20 00:00:00"
    },
    {
      "id": "1deccd41-6b22-439d-b04a-607cec06cd4e",
      "text": "U.S. Department of Defense Biological Threat Reduction Program (BTRP) provided funding, equipment upgrades and technical assistance to Ukrainian public‑health and research laboratories (BTRP cooperation with Ukraine began in 2005).",
      "date": "2005-04-24 00:00:00"
    },
    {
      "id": "78f8bb60-19e7-45ae-b9a8-95d140afccb6",
      "text": "Cooperative Biological Engagement Program project in Ukraine with defined implementation period (example: project implementation period listed as 06.03.2015–31.12.2020 on Ukrainian project pages).",
      "date": "2015-03-06 00:00:00"
    },
    {
      "id": "457968e0-54e3-4b90-a69d-cd014e44b19f",
      "text": "U.S. government announced Operation Warp Speed to accelerate COVID‑19 vaccine development and manufacturing, with involvement from HHS, DOD and other agencies.",
      "date": "2020-05-15 00:00:00"
    },
    {
      "id": "953e8dee-c92d-46d0-b41a-2675f2d8c7d3",
      "text": "Novavax announced it was awarded a Department of Defense contract related to COVID‑19 vaccine development.",
      "date": "2020-06-04 00:00:00"
    },
    {
      "id": "765cde6f-4513-4c96-bc73-5efe2d1dcec2",
      "text": "U.S. government apology (2010) for the Guatemala syphilis experiments, in which U.S.-linked researchers deliberately infected subjects decades earlier.",
      "date": "2010-10-01 00:00:00"
    },
    {
      "id": "550a0233-ec91-4574-af34-084f9fb02324",
      "text": "CDC updates guidance to discourage a test-based strategy for ending isolation, noting people can remain PCR-positive without being infectious",
      "date": "2020-07-17 00:00:00"
    },
    {
      "id": "39701dce-c174-4858-a47c-7c287e0d6b46",
      "text": "Published study (Bullard et al.) showing SARS-CoV-2 PCR cycle threshold (Ct) correlates with likelihood of culturing live virus (higher Ct → less likely infectious)",
      "date": "2020-05-22 00:00:00"
    },
    {
      "id": "c7ddc375-ec76-4ba7-879a-f3acc3bcb9c6",
      "text": "UNAIDS/Ukraine country report documents a large, growing HIV epidemic in Ukraine (estimated ~238,000 people living with HIV in 2016).",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "1edfed6a-a6f6-4d26-8e86-27912e5cb734",
      "text": "Mass internal displacement after the 2014 conflict: hundreds of thousands of internally displaced persons (IDPs) from Donbas by 2015, disrupting continuity of care.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "b3d4bccf-e6b3-444a-a446-db2eefd130aa",
      "text": "WHO interim guidance recommending postponement of mass vaccination campaigns and adaptation/prioritization of immunization services during COVID-19",
      "date": "2020-03-26 00:00:00"
    },
    {
      "id": "fc116fa8-1dc3-4222-a5c8-b35092c65b7d",
      "text": "WHO and UNICEF joint press release warning of an alarming decline in routine childhood vaccinations worldwide",
      "date": "2020-07-15 00:00:00"
    },
    {
      "id": "6d09cef3-542a-4122-bce5-4ed42b20a35c",
      "text": "Ukraine erected flow-control measures/temporary dam in Kherson/Kalanchak to cut canal deliveries to occupied Crimea (2014)",
      "date": "None"
    },
    {
      "id": "1171ed03-4a86-4377-9b2a-9890e9c06a3b",
      "text": "Academic/technical assessments documenting socio‑economic and environmental impacts of Crimea's water shortages (peer‑reviewed/technical publications 2016)",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "a1e88781-f2b8-4925-a71d-1354138335e6",
      "text": "Municipal regulations (Plan Especial del Centro Histórico and local ordinances) prohibit unauthorised banners/flags on protected facades; the town hall cited these rules when ordering removal.",
      "date": "2016-03-24 00:00:00"
    },
    {
      "id": "16eb1f91-9e75-48d9-8e6b-ba6883f107a2",
      "text": "Clinical/dental literature and reviews (including proposals to use povidone‑iodine nasal/mouth preparations) circulated in spring 2020 reporting in‑vitro virucidal activity of certain antiseptic oral rinses against SARS‑CoV‑2.",
      "date": "2020-05-24 00:00:00"
    },
    {
      "id": "45192b72-d6e3-4aa8-adad-2ce5c94f6fed",
      "text": "Regulatory and market environment: reports of unproven oral-spray and supplement COVID claims and subsequent enforcement/crackdowns (e.g., China crackdown on adverts making antiviral claims for oral sprays) in spring 2020.",
      "date": "2020-04-07 00:00:00"
    },
    {
      "id": "35e7b213-800a-404a-91b4-d3bfc3e7d69e",
      "text": "September 2021 reports that foreign/stainless‑steel particles were found in some Moderna vaccine vials in Japan and several lots were suspended.",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "37625bdb-3faf-444d-96c3-044a6680cd29",
      "text": "Russian formal ban on imports of Ukrainian food products (announcement reported November 2015)",
      "date": "2015-11-24 00:00:00"
    },
    {
      "id": "f15e48c3-97ff-4340-8055-fff4bf8c0515",
      "text": "Ukrainian activists impose a land and transport blockade of supplies into Crimea",
      "date": "2015-09-24 00:00:00"
    },
    {
      "id": "0ec3a1ba-22bc-42c9-8014-c02a2d6366c2",
      "text": "IPCC AR5 (WG1) chapter on oceans noting that the oceans have absorbed the vast majority of excess heat from global warming",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "2112f65b-e3a2-4663-82fc-47099fd11849",
      "text": "UKHSA update on scarlet fever and invasive Group A streptococcus noting increased cases in children",
      "date": "2022-12-02 00:00:00"
    },
    {
      "id": "25ae9714-f988-4579-a283-17d3fac67c24",
      "text": "Event 201 pandemic tabletop exercise (Johns Hopkins / World Economic Forum / Bill & Melinda Gates Foundation)",
      "date": "2019-10-18 00:00:00"
    },
    {
      "id": "89f7be9b-a071-4364-9aed-c2503bc4bde2",
      "text": "FDA and public‑health warnings against internal use of high‑strength hydrogen peroxide (35% 'food grade') and warning letters to vendors.",
      "date": "2006-07-24 00:00:00"
    },
    {
      "id": "c5eb6bc0-d315-4389-b537-4ff24b37b0ba",
      "text": "Russian President Vladimir Putin asks the Federation Council to authorize the use of Russian armed forces in Ukraine; authorization granted",
      "date": "2014-03-01 00:00:00"
    },
    {
      "id": "5d180492-af7a-41a3-8010-6039b9a42ac1",
      "text": "Ousted Ukrainian president Viktor Yanukovych reportedly sends a letter requesting Russian assistance",
      "date": "2014-03-01 00:00:00"
    },
    {
      "id": "129dbf83-ac42-498b-8af3-31b2930d0936",
      "text": "ICJ advisory opinion on Kosovo's declaration of independence (found not to violate international law)",
      "date": "2010-07-22 00:00:00"
    },
    {
      "id": "b899e414-1d1a-4e3f-9ad7-92dcb8567106",
      "text": "Armed men seize the Crimean parliament building and raise the Russian flag",
      "date": "2014-02-27 00:00:00"
    },
    {
      "id": "da8e4118-0138-42d0-9996-8b05153569cb",
      "text": "EU representatives agree (Council conclusions of 20 July 2015) to resettle 22,504 persons in need of international protection from outside the EU (including Middle East, North Africa and Horn of Africa)",
      "date": "2015-07-20 00:00:00"
    },
    {
      "id": "bd231caf-cb0b-40ad-80ec-357ede8ccc9c",
      "text": "European Commission proposes mandatory relocation of 40,000 asylum-seekers from Italy and Greece",
      "date": "2015-05-22 00:00:00"
    },
    {
      "id": "0ac65c20-e64f-4572-b4fa-95038cc94c87",
      "text": "Strong public opposition from several member states (Visegrad group and others) to EU relocation/quota proposals in mid-2015",
      "date": "2015-07-24 00:00:00"
    },
    {
      "id": "eb029676-869a-4779-a1c4-e6a9ef61658a",
      "text": "Hungary orders closure of its border with Serbia and begins building a fence to stop migrants",
      "date": "2015-06-17 00:00:00"
    },
    {
      "id": "1afe2096-97db-47e1-8782-51875848059a",
      "text": "April 2015 Mediterranean shipwreck off Libya killing hundreds of migrants",
      "date": "2015-04-18 00:00:00"
    },
    {
      "id": "caccea01-8968-4258-9488-740a1c367d1b",
      "text": "Ukraine's Verkhovna Rada formally recognized the 1944 deportation of Crimean Tatars as genocide (resolution passed in November 2015).",
      "date": "2015-11-12 00:00:00"
    },
    {
      "id": "e3500067-58e5-401e-be62-6ac02afe5f68",
      "text": "Ukrainian law and parliamentary debate on the legal regime for 'temporarily occupied territories' (Law No.1207‑VII and related 2014 legislative measures criminalizing collaboration with occupying authorities).",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "d124a1dd-2d17-4a0e-9b3f-3690566aae21",
      "text": "Russia 'passportised' Crimean residents after the 2014 annexation (widespread issuance of Russian passports), documented by human rights reporting in 2014.",
      "date": "None"
    },
    {
      "id": "3dbf5840-202a-45c5-a392-6da5fc3384f4",
      "text": "Andriy Senchenko made televised remarks on Shuster Live calling for 'tough' measures toward people who moved to Crimea after Feb 20, 2014 (interpreted as calling for rapid removal).",
      "date": "None"
    },
    {
      "id": "fe00d12a-4e33-4d24-8260-ce000bdafd3b",
      "text": "Parliamentary Assembly of the Council of Europe (PACE) adopted a resolution (drafted by Michele Nicoletti) that set out mechanisms for reconciling participation rules between PACE and the Committee of Ministers and which media reported could pave the way to restore Russian delegation rights.",
      "date": "2017-10-12 00:00:00"
    },
    {
      "id": "8c29246c-b612-4965-992f-1aae016849cb",
      "text": "Pandora Papers and subsequent reporting (Oct 2021) documenting links between Zelensky's circle and offshore companies / expensive property purchases",
      "date": "2021-10-04 00:00:00"
    },
    {
      "id": "90183469-2373-4c0a-9db7-66fda3723f82",
      "text": "Earlier 2025 media coverage of Bill Cosby listing a second Manhattan townhouse for sale (about $7 million) amid foreclosure/legal troubles",
      "date": "2025-04-22 00:00:00"
    },
    {
      "id": "76ed06f1-f37a-465b-ae48-e100e8377a44",
      "text": "Poland says it cannot accept migrants under EU relocation quotas after the Paris attacks",
      "date": "2015-11-14 00:00:00"
    },
    {
      "id": "dfcb69d0-f432-473d-a4bd-c9537e190c44",
      "text": "Financial Times analysis highlighting Poland's low intake of Syrian refugees and rising anti-immigrant rhetoric",
      "date": "2016-09-15 00:00:00"
    },
    {
      "id": "2c6b27af-38c8-4b38-b040-40f8bb33132c",
      "text": "UK government technical note on the impact of false positives and false negatives in the RT-PCR testing programme (operational specificity discussion)",
      "date": "2020-06-03 00:00:00"
    },
    {
      "id": "1a89a0c4-9240-40dc-97e5-5eb183d35328",
      "text": "Publication of study linking RT-PCR cycle threshold (Ct) values to culturable virus (Singanayagam et al., correlating Ct and infectiousness)",
      "date": "2020-08-13 00:00:00"
    },
    {
      "id": "5e7bee19-fa7d-4e24-b0f3-a535a59d61c9",
      "text": "Publication and media amplification of the Great Barrington Declaration advocating 'focused protection' (early October 2020)",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "988a32d5-7f90-44fe-ad3f-eae1713fb46f",
      "text": "Swiss Federal Office of Public Health (BAG) / Swissmedic leaflet on COVID-19 testing published (Merkblatt, referenced wording on PCR/NAT)",
      "date": "2020-08-31 00:00:00"
    },
    {
      "id": "2bd4165c-309c-4266-baea-489fc2660c0f",
      "text": "High-profile political minimization and comparisons of COVID-19 to seasonal influenza (examples in March 2020, e.g., statements by then-US President Donald Trump)",
      "date": "2020-03-09 00:00:00"
    },
    {
      "id": "fa789686-f4ff-4769-afea-b7a090848d27",
      "text": "US security-assistance packages to Ukraine (e.g., $125M March 2021)",
      "date": "2021-03-01 00:00:00"
    },
    {
      "id": "17959a76-3641-4e0b-abd2-b380896e1234",
      "text": "Joint NATO/US public warnings calling on Russia to de-escalate (press points April 2021)",
      "date": "2021-04-14 00:00:00"
    },
    {
      "id": "f2628ee0-eded-4b4c-b5c6-6967892ae038",
      "text": "DEFENDER-Europe 21 large US/NATO exercises in Europe",
      "date": "2021-03-15 00:00:00"
    },
    {
      "id": "214d1e31-24a0-4a9b-9959-ee0e01ed62fa",
      "text": "NATO Brussels Summit communique reaffirming support for Ukraine",
      "date": "2021-06-14 00:00:00"
    },
    {
      "id": "c2a74fe2-3c8d-4007-9006-5202a81e3db2",
      "text": "Publication (September 7, 2022) of experiments showing ivermectin (alone or combined) enhanced paclitaxel efficacy in chemoresistant high‑grade serous carcinoma cell models (Nunes et al., Cancers).",
      "date": "2022-09-07 00:00:00"
    },
    {
      "id": "8322049d-460b-4c14-89aa-784164e6301f",
      "text": "U.S. Department of Health and Human Services ordered millions of doses of the JYNNEOS monkeypox vaccine for response and Strategic National Stockpile delivery.",
      "date": "2022-06-28 00:00:00"
    },
    {
      "id": "37438bb9-ad89-4693-96ac-1f3e4de9e11c",
      "text": "WHO declared the global monkeypox outbreak a Public Health Emergency of International Concern (PHEIC).",
      "date": "2022-07-23 00:00:00"
    },
    {
      "id": "0ab2fa20-d314-4b6e-8ef9-3d0b3754a0a3",
      "text": "WHO/FAO/WOAH and other agencies published repeated updates and risk assessments about avian influenza (H5Nx) outbreaks and zoonotic risk during 2023–2024.",
      "date": "2024-03-30 00:00:00"
    },
    {
      "id": "df133827-888a-44b4-98ba-0bd4267a4b64",
      "text": "European Centre for Disease Prevention and Control (ECDC) reported an increased circulation/rebound of human parvovirus B19 in multiple EU/EEA countries (public advisory/report).",
      "date": "2024-06-05 00:00:00"
    },
    {
      "id": "8db5e96c-8ab9-49e2-be45-cb84446f42b4",
      "text": "Rapid formation and public visibility of volunteer combat units (e.g., the Azov Battalion) in 2014 that appeared at checkpoints, rallies and front-line actions.",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "278fdcf9-885a-4a38-b620-4449c53c1fac",
      "text": "Euromaidan protesters occupied Kyiv's Independence Square (Maidan) and established barricades, driving out police during the February 2014 protests.",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "9414863b-928c-4d55-a823-f666352f7066",
      "text": "Pro‑Russian separatists seized Sloviansk and other towns in Donetsk oblast in April 2014, setting up armed checkpoints and exercising local control for months.",
      "date": "None"
    },
    {
      "id": "73acaeeb-a18a-4e1f-aa58-d7ca76180f1e",
      "text": "Ukraine blocked the North Crimean Canal in 2014 (built a dam/flow-control to stop water to Crimea)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "20688556-fcd5-43d5-8b89-0603da011cff",
      "text": "UN and humanitarian agencies publicly reported reaching and assisting civilians in Sievierodonetsk earlier in 2022 (e.g., UN humanitarian convoy reached Sievierodonetsk in April 2022).",
      "date": "2022-04-05 00:00:00"
    },
    {
      "id": "9faacbf5-8470-4ede-8cfc-18027e35aca1",
      "text": "United Nations had ceased operations in Siverodonetsk by the end of February 2022 (UN office vacated).",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "2e4afe6c-377c-41fb-a709-0aa17fe96c47",
      "text": "Intense Russian shelling and urban combat in Sievierodonetsk in June 2022 produced extensive destruction of civilian and administrative buildings (including fires at the Azot plant).",
      "date": "2022-06-25 00:00:00"
    },
    {
      "id": "b75ca8d7-d78d-4731-bbc5-827e3e8c284d",
      "text": "Police in Abkhazia (de facto region) seize hundreds of crypto‑mining rigs amid power shortages (reported June 2023)",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "4c8fe5c9-7702-4b7f-89d7-34a3387550bd",
      "text": "Europol / Ukrainian police arrest cryptojacker accused of mining ~€1.8M (cloud/cryptojacking) in Mykolaiv",
      "date": "2024-01-24 00:00:00"
    },
    {
      "id": "4a85235b-d804-415b-ad8d-b80286344dda",
      "text": "West Midlands Police (UK) uncover bitcoin mining operation stealing electricity at an industrial site",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "2f31b597-a1c6-4a14-bdb1-9926031bd733",
      "text": "Global Climate Strikes led by youth (September 20–27, 2019)",
      "date": "2019-09-20 00:00:00"
    },
    {
      "id": "876a0e31-fed0-492e-9930-125af3ca6ca0",
      "text": "IPCC Special Report on Global Warming of 1.5°C released",
      "date": "2018-10-08 00:00:00"
    },
    {
      "id": "e63ed35c-d2ce-4cea-b973-b0de720980a4",
      "text": "Publication of Nerem et al. (PNAS) reporting statistically significant acceleration in global mean sea level from satellite altimetry (1993–2016)",
      "date": "2018-12-11 00:00:00"
    },
    {
      "id": "b8455709-3440-4c63-a8b8-4fde488d3279",
      "text": "Release of the IPCC Special Report on the Ocean and Cryosphere in a Changing Climate (SROCC) summarizing recent acceleration and future sea-level projections",
      "date": "2019-09-25 00:00:00"
    },
    {
      "id": "c8e1c6d5-165b-4699-9c2a-644ffc9bc590",
      "text": "Publication of Houston & Dean (2011) analysis arguing little or no acceleration in U.S. tide-gauge records",
      "date": "2011-04-24 00:00:00"
    },
    {
      "id": "5df08847-a67c-4353-9d9a-ac186bb7a0ac",
      "text": "Peer‑reviewed 2009 review 'Omega‑6 (n‑6) and omega‑3 (n‑3) fatty acids in tilapia and human health' (International Journal of Food Sciences and Nutrition)",
      "date": "2009-09-21 00:00:00"
    },
    {
      "id": "76eb3d3a-2128-4f48-b28f-2e31e901d9e5",
      "text": "2013 systematic review 'The omega‑6/omega‑3 ratio and dementia or cognitive decline' (Loef & Walach) summarizing evidence linking n‑6/n‑3 balance to dementia risk",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "3b3306c5-39b2-428e-a46c-b4027bb3f7b2",
      "text": "Japan finds stainless-steel/foreign particles in multiple Moderna vaccine vials leading to recalls (September 2021)",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "732ffe1f-e2ef-42d6-ace5-30f2f6397c5a",
      "text": "Widespread pediatric RSV and other respiratory virus surges after COVID-19 restrictions lifted (late 2022)",
      "date": "2022-10-24 00:00:00"
    },
    {
      "id": "584a07dd-348b-4a9c-bcef-72d38726e3f2",
      "text": "Noted rise in invasive Group A Streptococcus (iGAS) and scarlet fever among children in late 2022–early 2023",
      "date": "None"
    },
    {
      "id": "a15ffdcd-dd35-4e0b-a278-d39f0b704449",
      "text": "Publication showing systemic mRNA COVID-19 vaccines induce variable or limited mucosal (IgA) responses",
      "date": "2022-04-25 00:00:00"
    },
    {
      "id": "52aeea6c-dbeb-49dc-b01b-d54c7468c757",
      "text": "NATO and Western institutions publicly warn about 'weaponisation of information' by Russia",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "43e6cdbe-7110-411f-9599-5f5644f1793c",
      "text": "Reuters reported the U.S. was 'poised' to drop opposition and start a process that could eventually send Abrams tanks to Ukraine (policy debate/turnaround coverage).",
      "date": "2023-01-24 00:00:00"
    },
    {
      "id": "ab6e267d-4f9a-4e79-b0a0-5445c91f52a2",
      "text": "Germany announced it would supply Leopard 2 tanks and permit partner countries to re-export theirs to Ukraine.",
      "date": "2023-01-25 00:00:00"
    },
    {
      "id": "62f49896-fe28-4e51-8248-9a0dbb2ec952",
      "text": "Media coverage warned that even if Abrams were provided, they were 'not expected in Ukraine for months' because of training, logistics and suitability issues.",
      "date": "2023-01-26 00:00:00"
    },
    {
      "id": "db5cdca6-47c0-4025-afb9-5cf4330d18fa",
      "text": "Widespread attention to provisional NCHS/CDC all‑cause and excess death data for 2021–2022 (public NCHS/CDC provisional death tables and dashboards).",
      "date": "None"
    },
    {
      "id": "e813eef7-8b07-43c9-9b52-89016dc23bfa",
      "text": "CDC/FDA communications and studies acknowledging a small increased risk of myocarditis/pericarditis after mRNA COVID‑19 vaccination in adolescents and young adults (public reporting in 2021).",
      "date": "None"
    },
    {
      "id": "ed606e7d-2737-465a-8cb1-534e7a2a2bab",
      "text": "WHO/air‑quality data (2016) flagged Ukraine among countries with very high air‑pollution‑related mortality",
      "date": "2016-09-27 00:00:00"
    },
    {
      "id": "908e3499-9973-409e-9771-39750bd71773",
      "text": "Investigations and reporting on illegal/low‑quality coal supply in Ukraine (Donbas) documented dirty, unregulated coal entering markets",
      "date": "2014-05-26 00:00:00"
    },
    {
      "id": "ee66cc75-520a-448c-9cb3-5329fa946d27",
      "text": "Kyiv officials describe mid‑January haze as a 'meteorological haze' while experts point to coal‑fired heating plants",
      "date": "2017-01-18 00:00:00"
    },
    {
      "id": "0877ed46-c1ba-45a3-ba4b-a8e0a6439edf",
      "text": "Central Geophysical Observatory registered elevated formaldehyde, carbon monoxide and nitrogen dioxide levels in mid‑January 2017",
      "date": "2017-01-13 00:00:00"
    },
    {
      "id": "6659a365-5a97-4293-a252-2be5c298330c",
      "text": "State services report monitoring found 'no exceedances' despite public reports of burning smell and breathing problems",
      "date": "2017-01-17 00:00:00"
    },
    {
      "id": "7efe0478-8a2a-4d11-9c5f-52020e70d538",
      "text": "European Parliament approves visa‑free travel for Ukrainians (vote)",
      "date": "2017-04-06 00:00:00"
    },
    {
      "id": "4c51a416-fe78-476b-805d-de1b3b9c0517",
      "text": "EU adopts a revised Visa Suspension Mechanism as a precondition to liberalisation",
      "date": "2017-02-27 00:00:00"
    },
    {
      "id": "52f42ec6-780e-4efe-92d7-4226178815ae",
      "text": "Documented large industrial wastewater discharges into the Sea of Azov (Azovstal and other metallurgical plants)",
      "date": "2014-12-01 00:00:00"
    },
    {
      "id": "92dc8e00-b4c6-4a43-b561-1940fec3c8ef",
      "text": "Scientific and media publications documenting rising pollution and ecological stress in the Sea of Azov (numerical/satellite assessments, 2017)",
      "date": "2017-09-24 00:00:00"
    },
    {
      "id": "a955132e-e3fb-42db-a430-9bf42ff99559",
      "text": "Isolation of toxigenic Vibrio cholerae O1 (Ogawa) from seawater near Taganrog after the 2011 outbreak",
      "date": "None"
    },
    {
      "id": "96332f73-f924-443d-ace7-40cb4fa6d25f",
      "text": "Amnesty International and other human rights organisations publicly highlighted mass graves and documented allegations of torture in recaptured Kharkiv oblast territory",
      "date": "2022-09-16 00:00:00"
    },
    {
      "id": "52d4258b-d46d-4011-b482-c6f84ea88c41",
      "text": "Passage of Ukraine's decommunization laws (April 2015) increasing attention to removal/renaming of monuments",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "b8fef55e-cb17-4144-b36d-efe1a1412aa7",
      "text": "Heightened media coverage and public demonstrations around Stepan Bandera (e.g., anniversary marches) in early 2015",
      "date": "2015-01-01 00:00:00"
    },
    {
      "id": "ac10fe98-7a59-438d-8e5a-e5d8ff108249",
      "text": "IUCN Polar Bear Specialist Group (PBSG) population estimates and status reporting (Regehr et al. / PBSG updates) releasing updated global population ranges (~22,000–31,000)",
      "date": "2016-06-24 00:00:00"
    },
    {
      "id": "1f99c609-d675-4aa2-8365-41180ff2b10f",
      "text": "General Medical Council (GMC) publishes report on doctors who died while under investigation (report published March 2023; covers deaths through Dec 2022)",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "f84e3f68-1f12-4277-a0ad-1a2855816e89",
      "text": "FDA/FTC public enforcement and warning letters against companies and individuals selling fraudulent COVID‑19 cures and unapproved therapies (series of letters and press releases, 2020–2022)",
      "date": "2020-04-28 00:00:00"
    },
    {
      "id": "2820709e-5d6b-4509-94a5-78cd96541477",
      "text": "NASA/NSIDC reporting that Antarctic sea ice reached record high extent in 2014",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "2c7e26c3-b9b3-45c9-af2b-3b4ed695a329",
      "text": "IPCC Special Report on the Ocean and Cryosphere (SROCC) documents complex impacts of ice melt on ocean circulation and regional climate",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "6f517cb4-a5d9-48b6-89f4-774edcbd04fc",
      "text": "Nature paper reports fingerprint of a weakening Atlantic Meridional Overturning Circulation (AMOC)",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "90075709-94de-4eff-a784-7426de978ac8",
      "text": "IAEA Director General Rafael Grossi publicly called for an urgent IAEA mission to the occupied Zaporizhzhia plant and warned about militarisation (June 2022).",
      "date": "2022-06-01 00:00:00"
    },
    {
      "id": "2f96b357-c41a-445d-9c72-3c14267b0f04",
      "text": "Satellite imagery and reporting in 2022 showed military vehicles and damage close to key Zaporizhzhia reactors and infrastructure.",
      "date": "2022-08-24 00:00:00"
    },
    {
      "id": "52e92dba-398a-4cc5-b309-93a582942749",
      "text": "Russian forces seized and occupied the Zaporizhzhia Nuclear Power Plant during the opening days of the 2022 invasion.",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "3a6f2a92-5754-452f-9004-2098c7d76d66",
      "text": "Shelling and a fire at a training facility inside the Zaporizhzhia site during the March 4, 2022 assault.",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "443755da-213e-4f47-98c3-d9454d1eda94",
      "text": "IAEA/Ukraine national reporting on ageing Soviet-era reactors and safety challenges (2005)",
      "date": "2005-04-24 00:00:00"
    },
    {
      "id": "d86964a8-b40c-4f2d-92ed-481299aa8e92",
      "text": "Verkhovna Rada adopts Law No. 6327 on state financial guarantees for medical services (healthcare reform)",
      "date": "2017-10-19 00:00:00"
    },
    {
      "id": "992eb91d-44b1-4560-b199-36dfde7ead73",
      "text": "New national classification of professions (reclassification of medical job titles) took effect on November 1, 2017",
      "date": "2017-11-01 00:00:00"
    },
    {
      "id": "1a966d51-7954-47de-9b75-a0b764a89815",
      "text": "U.S. FDA issues Emergency Use Authorization for Janssen (Johnson & Johnson) COVID-19 vaccine and publishes EUA fact sheets that reference the PER.C6 cell line used in production/testing.",
      "date": "2021-02-27 00:00:00"
    },
    {
      "id": "4f3cec2d-39b0-4ba1-be54-1f87fb414f33",
      "text": "Surveillance data showing higher-than-expected HIV diagnoses among people born in Ukraine reported by EU/EEA countries after the 2022 refugee movements (peer-reviewed / public health surveillance summary)",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "273108f2-182b-42a7-952a-9d33cd5b44da",
      "text": "Russia had banned imports of Roshen products and Roshen faced factory/market disputes in Russia (2013–2014), including Roshen activity tied to Lipetsk",
      "date": "2013-07-29 00:00:00"
    },
    {
      "id": "91b914d2-9ac6-48f9-9b90-2415008e69fe",
      "text": "Poroshenko’s ownership of Roshen and his 2014 pledge to sell/transfer the company after his election kept Roshen highly politicized and newsworthy",
      "date": "None"
    },
    {
      "id": "c3b4ae9e-b56b-4724-80ab-d5e8fd58f441",
      "text": "Pentagon Inspector General report that about $1 billion in U.S. weapons sent to Ukraine were not properly tracked.",
      "date": "2024-01-11 00:00:00"
    },
    {
      "id": "0ec31977-3023-4316-89f2-6cd4539a5b72",
      "text": "National Anti‑Corruption Bureau of Ukraine (NABU) announces a large-scale probe into alleged corruption in the energy sector.",
      "date": "2025-11-11 00:00:00"
    },
    {
      "id": "3c3809b1-e474-4a0f-9fe2-ad9388296f1a",
      "text": "Sean Penn's repeated, high‑profile visits to Ukraine (documented reporting on his November 2021 and subsequent trips).",
      "date": "None"
    },
    {
      "id": "04179c15-22d3-4587-a3c0-a8d9de3bc862",
      "text": "Ukraine uncovers embezzlement of nearly $40 million intended to buy mortar shells; arrests and charges announced.",
      "date": "2024-01-27 00:00:00"
    },
    {
      "id": "0556168b-ddf4-403b-855e-fa07d47df59b",
      "text": "Human Rights Watch reports intensifying prosecutions in Crimea accusing Crimean Tatars and others of 'terrorism' or 'sabotage' (2016–2017)",
      "date": "2017-11-14 00:00:00"
    },
    {
      "id": "1c531e95-8a53-4fa7-9cf6-f56ecc7fc194",
      "text": "FSB announces detention of a Ukrainian citizen in occupied Crimea on espionage/sabotage-related charges (Simferopol, February 2018)",
      "date": "2018-02-11 00:00:00"
    },
    {
      "id": "2d287b25-96e4-4d14-b647-e585113cb393",
      "text": "Large explosions at the Kalynivka ammunition depot in central Ukraine, causing evacuations and widespread coverage",
      "date": "2017-09-27 00:00:00"
    },
    {
      "id": "214d4af3-d4fe-4edf-9b28-d410c6d5c5fa",
      "text": "Exercise Sea Breeze 2018 — multinational naval exercises in the Black Sea co-hosted by the United States and Ukraine (July 2018)",
      "date": "2018-07-17 00:00:00"
    },
    {
      "id": "ea0de8a9-d55b-4475-a20a-bb160d082ced",
      "text": "Israeli reports of rising Delta-variant cases with a substantial share among vaccinated people",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "5abca650-7537-4d87-ba3b-ea71a51d8966",
      "text": "CDC updates guidance for fully vaccinated people stating they can often refrain from testing and quarantine (interim guidance released)",
      "date": "2021-05-13 00:00:00"
    },
    {
      "id": "d7f5b683-1482-4b26-8fcc-a98be03f2ee9",
      "text": "Public Health England (PHE) vaccine surveillance reports with age-stratified case tables (week 26 / June 2021)",
      "date": "2021-06-27 00:00:00"
    },
    {
      "id": "3b2a0ea9-b56f-4243-bafd-25eb3dfea4bf",
      "text": "Provincetown, Massachusetts July 2021 COVID-19 outbreak where many positive cases were fully vaccinated",
      "date": "2021-07-19 00:00:00"
    },
    {
      "id": "4b72e737-f1b9-470e-ba9a-2b4d5d50e353",
      "text": "Long‑running pro‑Kremlin narrative that 'Ukraine’s armed forces shell Donbas civilians' (disinformation theme dating from 2014) was active in March 2022.",
      "date": "None"
    },
    {
      "id": "17a480e6-1bf4-4c05-9ca4-8a1c574f0fc4",
      "text": "Venice Commission (Council of Europe) issues an opinion urging changes to Ukraine's Education Law over minority-language provisions",
      "date": "2017-12-08 00:00:00"
    },
    {
      "id": "39f0c8d6-5221-4a5e-bf65-ce98b09f7bd0",
      "text": "Contextual sensitivity: Bulgaria's Liberation Day (March 3) commemorates liberation from Ottoman rule (historically 1878).",
      "date": "None"
    },
    {
      "id": "9d220ba5-be35-4626-91c4-851a735df936",
      "text": "President Erdoğan was on an official African tour (in Guinea) on March 3, 2016.",
      "date": "2016-03-03 00:00:00"
    },
    {
      "id": "d27e4f87-9af4-40ef-9766-ee18cb24a24f",
      "text": "WMO Greenhouse Gas Bulletin No. 21 reports a record-breaking annual CO2 increase and highlights contributions from continued human emissions plus an upsurge from wildfires and ecosystem feedbacks.",
      "date": "2024-10-24 00:00:00"
    },
    {
      "id": "f54f7af1-1b71-478c-91f6-ce3375ebdda5",
      "text": "Hunga Tonga–Hunga Haʻapai submarine volcanic eruption (15 January 2022) injected exceptional amounts of water vapor and volcanic gases into the atmosphere and received intense global media coverage.",
      "date": "2022-01-15 00:00:00"
    },
    {
      "id": "3d9743ea-263d-4b21-91a1-bdc5bbce2499",
      "text": "Transport & Environment / press coverage (October 2017) of lifecycle studies reporting EVs emit significantly less GHG over their lifetime than diesel",
      "date": "2017-10-27 00:00:00"
    },
    {
      "id": "a8b64150-84b7-4ad7-bdb1-c3756003b90a",
      "text": "European Parliament / EU briefings and research in 2015 documented coordinated Russian disinformation campaigns targeting Ukraine and portraying Ukrainian authorities as corrupt or incompetent.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "48ec065a-a22d-4b14-98ef-d1e57418b549",
      "text": "Cabinet of Ministers Resolution No. 405 amended rules on 'military-transport duty' allowing requisitioning of vehicles for army needs",
      "date": "2015-06-17 00:00:00"
    },
    {
      "id": "58762de6-ddb0-4b06-9187-97497eb3ccc9",
      "text": "High-profile seizure/attention to Viktor Yanukovych's car collection after his ouster in 2014",
      "date": "2014-06-14 00:00:00"
    },
    {
      "id": "84d683de-68e5-4a20-8afc-f90d78ad11fe",
      "text": "March 2016 — Large, well-documented mass coral bleaching across the Great Barrier Reef (AIMS/GBRMPA surveys)",
      "date": "2016-03-24 00:00:00"
    },
    {
      "id": "057f2b8b-55d2-46a9-8ee2-57021db73494",
      "text": "2019 — 'State of the Climate 2019' (WMO/BoM/CSIRO) and related national summaries documenting global and regional ocean heating and record ocean heat content",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "9dfcd6c4-1585-4ebf-90b9-c35a0fa7b77c",
      "text": "Lisbon Court of Appeal ruling (Portugal) referenced PCR test reliability in a quarantine case",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "7429b626-2a70-48db-931e-9e7f6919e3b1",
      "text": "Early peer‑reviewed studies showing correlation between PCR cycle threshold (Ct) and viral culture/infectivity (e.g., Bullard et al.) published in 2020",
      "date": "2020-05-24 00:00:00"
    },
    {
      "id": "6fea3a19-99f6-433e-b70b-f3608c3e60bb",
      "text": "WHO information notice reminding labs to follow manufacturers' instructions and consider Ct thresholds (WHO notice for IVD users)",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "d67b8388-c5ba-4ef3-9f99-518f8e6b9ec4",
      "text": "CDC announced it would withdraw its EUA request for the original CDC-only RT‑PCR panel (laboratory notice, mid‑2021)",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "6cf8907e-3799-472e-a142-6db5a32cf03d",
      "text": "FDA paused enforcement of the in-person dispensing requirement during the COVID-19 pandemic enabling telemedicine and mail distribution",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "70355289-4e54-47cc-81ed-a7bb982902ee",
      "text": "Government audit and historical regulatory reporting (GAO report) documenting FDA regulatory decisions on Mifeprex/mifepristone",
      "date": "2018-03-24 00:00:00"
    },
    {
      "id": "21ef3182-d37f-4089-afa7-5293f6ec11a7",
      "text": "Anti-abortion medical groups filed Alliance for Hippocratic Medicine v. FDA challenging FDA approval of mifepristone",
      "date": "2022-11-18 00:00:00"
    },
    {
      "id": "6e5fec9c-b2f0-4e1b-852f-6806a7eef1f9",
      "text": "Dobbs v. Jackson Women's Health Organization (Supreme Court decision overturning Roe v. Wade) intensified public debate over abortion",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "5f591bb2-1596-4e97-85e2-46ecbfcce715",
      "text": "Regional NGOs and refugee policy briefs highlight ambiguities about the end or transition of Temporary Protection",
      "date": "2022-04-25 00:00:00"
    },
    {
      "id": "29e1437a-f465-4e3c-87ba-8891e0ad54be",
      "text": "Ukraine imposes martial law and restricts men aged 18–60 from leaving the country",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "81040900-a0c6-4475-991b-52fa81fe003d",
      "text": "Ukraine imposes moratorium / signals risk of default on Russian‑held debt (December 2015)",
      "date": "2015-12-18 00:00:00"
    },
    {
      "id": "4205ac4d-65c7-4014-8d2f-8cd32be87732",
      "text": "Ukraine's parliament approves the 2016 budget tied to IMF‑agreed deficit targets (conditioning release of IMF tranche)",
      "date": "2016-02-05 00:00:00"
    },
    {
      "id": "8736b397-0828-456b-b1a9-faca5adf593e",
      "text": "World Bank forecasts a sharp GDP contraction for Ukraine in 2015 (projected ~12% decline)",
      "date": "2015-10-05 00:00:00"
    },
    {
      "id": "e838e359-ee60-4cec-8c08-6dd107ae93cd",
      "text": "The 2014 burning of the Odesa Trade Unions House (widely photographed and reported).",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "8e52fce7-6f34-4f80-8b7b-48f2857c305e",
      "text": "U.S. Secretary of State Antony Blinken visited Veterano Pizza in Kyiv and was photographed having lunch with Ukrainian officials.",
      "date": "2024-05-14 00:00:00"
    },
    {
      "id": "8386101e-8dd9-40ee-915f-daeafeaccb37",
      "text": "U.S. FDA Emergency Use Authorization for the Pfizer–BioNTech COVID-19 vaccine (vaccine moved from trials to public use under EUA in December 2020)",
      "date": "2020-12-11 00:00:00"
    },
    {
      "id": "6080b396-b17c-4aa2-81b9-ba25672408a2",
      "text": "Publication of preclinical animal study results showing BNT162b vaccine candidates protected rhesus macaques (Nature article)",
      "date": "2021-02-01 00:00:00"
    },
    {
      "id": "4c386586-e3e9-4a25-9801-0eafde56c525",
      "text": "EU Council / Commission adopted visa-free travel for Georgia (short stays up to 90 days)",
      "date": "2017-02-27 00:00:00"
    },
    {
      "id": "aac25fda-3c07-4c31-aa1f-fd0594820879",
      "text": "EU/agency reporting and media coverage noted increases in asylum/irregular-migration claims from Georgian nationals after visa liberalisation",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "e5d7503b-2f1f-4323-99c4-038ff15d4cce",
      "text": "EU revised and strengthened the Visa Suspension (waiver) Mechanism",
      "date": "2017-02-27 00:00:00"
    },
    {
      "id": "1a0a0196-5909-4768-b7fd-e4131e2d6c8e",
      "text": "Reports of Chechen fighters present in Donbas fighting alongside pro‑Russian separatists",
      "date": "2014-10-08 00:00:00"
    },
    {
      "id": "db9b45e8-08c4-4897-8dfb-d16f1b07a985",
      "text": "UN/OHCHR reporting on the presence and inflow of foreign fighters into the conflict in eastern Ukraine (2015)",
      "date": "None"
    },
    {
      "id": "8b7cc9a0-f571-42d3-844c-77499a7cada5",
      "text": "Death of Italian photo‑journalist Andrea Rocchelli while reporting in Donbas (May 2014) and subsequent high‑profile Italian media/legal coverage",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "762253e6-57af-47e7-b109-eae8b57cac36",
      "text": "Oct. 10, 2023 public statements and policy messaging about balancing U.S. aid to both Israel and Ukraine (e.g., Pentagon/Army leadership urging Congress to ensure resources for both)",
      "date": "2023-10-10 00:00:00"
    },
    {
      "id": "7e4169be-df96-4a1c-aa6c-703ba0cf2881",
      "text": "Sep. 18, 2023 launch of a high‑profile pro‑Ukraine ad campaign targeting U.S. Republicans (e.g., 'Republicans for Ukraine')",
      "date": "2023-09-18 00:00:00"
    },
    {
      "id": "6e248ec0-e30b-4f51-8579-24812d158310",
      "text": "Earlier Nuland testimony/statements (October 8, 2015) emphasizing sanctions if parties (including Russia) fail to implement Minsk",
      "date": "2015-10-08 00:00:00"
    },
    {
      "id": "9a5ad9cc-8f84-4803-ab1b-e12442d8d75c",
      "text": "A delegation of Alternative für Deutschland (AfD) regional deputies travelled to Crimea from February 3–9, 2018, despite international protest and the German government distancing itself from the visit.",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "dcf68337-ae54-4f8a-8271-f76115e03f87",
      "text": "Russian leadership publicly framed Ukraine as 'Nazi' and claimed a need to 'denazify' it in speeches and statements ahead of the 2022 invasion.",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "541d6546-06db-4a26-9bdb-a6bca271336e",
      "text": "Discovery and widespread reporting of civilian killings in Bucha after Russian withdrawal",
      "date": "None"
    },
    {
      "id": "0d5c8fb5-25e3-4975-9d67-5ead0c547fd7",
      "text": "Repeated reporting of heavy civilian casualties and strikes in Mariupol (including attacks on civilian shelters/theatre)",
      "date": "2022-04-16 00:00:00"
    },
    {
      "id": "c06924ea-b252-4ba8-baba-1346689d0f77",
      "text": "Russian recognition of the Donetsk and Luhansk 'people's republics' and public accusations against Kyiv",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "51f12563-6d80-4e66-9666-c6f294c04b61",
      "text": "Kyivstar publicly switched off mobile service in militant-controlled areas of Donetsk and Luhansk (company statement explaining suspension for network integrity and subscriber data safety).",
      "date": "2015-02-04 00:00:00"
    },
    {
      "id": "6b59b7b8-899a-4348-9f47-d102264da0be",
      "text": "Previous Ukrainian president Petro Poroshenko publicly called for UN peacekeepers to monitor the ceasefire in Donbas (widely reported)",
      "date": "2015-02-18 00:00:00"
    },
    {
      "id": "0fd8c1ed-5782-4cd2-8018-81cc39b1f887",
      "text": "Canada’s Operation UNIFIER (training mission) and other Western training/adviser missions in Ukraine beginning in 2015",
      "date": "None"
    },
    {
      "id": "1f938813-1b69-450f-b8e9-54972ad22999",
      "text": "Large multinational Sea Breeze naval and military exercises in the Black Sea involving Ukraine and NATO partners (summer 2019)",
      "date": "2019-07-02 00:00:00"
    },
    {
      "id": "bc8aa8a6-413a-4ef6-955c-b7b8f1001177",
      "text": "Normandy Format summit in Paris where President Zelensky met Putin and European leaders (significant public peace talks)",
      "date": "2019-12-09 00:00:00"
    },
    {
      "id": "54c57281-6ac3-4089-bff4-8a5005f13b2b",
      "text": "UN Panel of Experts (DPRK) midterm report noting foreign/European components recovered from North Korean missile debris (April 2017)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "78145ec9-7610-46fd-abe4-b0c54e40e502",
      "text": "Public denials from Ukrainian state aerospace firms (Yuzhmash/Yuzhnoye) rejecting allegations they supplied engines or parts to North Korea (Aug 2017)",
      "date": "2017-08-15 00:00:00"
    },
    {
      "id": "7ddab30b-c17e-4d25-a28f-fdb334a4e123",
      "text": "Publication of an Online.ua interview with Lieutenant Vsevolod Stebliuk in which he used the word \"raze\" when discussing past destructions (referencing Grozny) and the costs of a forceful retaking of occupied territories.",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "16e34379-812e-4b5d-99d7-77cd6206fd62",
      "text": "Public criticism and documented history of REN TV as a channel prone to propagandistic framing (Presidential Council on Human Rights public concerns about REN TV coverage in early April 2017).",
      "date": "2017-04-06 00:00:00"
    },
    {
      "id": "13a89318-6f44-4f8b-ad1e-2ad8dcde96de",
      "text": "CDC guidance and FAQs noting that regularly mixing powdered or concentrated infant formula with fluoridated tap water may increase the chance of very mild dental fluorosis in infants",
      "date": "2011-04-24 00:00:00"
    },
    {
      "id": "720a854c-8fdd-4cc3-b45d-b85cf6468e00",
      "text": "Publication and subsequent media/activist attention to the 2019 systematic review 'Developmental fluoride neurotoxicity: an updated review' summarizing evidence that fluoride can cross biological barriers and reporting associations between early-life fluoride exposure and neurodevelopment outcomes",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "a6fc308b-3017-4785-b22d-6757f02916a3",
      "text": "Reporting on the economic impact of sanctions on German businesses and trade ties with Russia highlighted pressure from German industry.",
      "date": "2016-02-24 00:00:00"
    },
    {
      "id": "c3964c0b-7310-40e7-8f89-8e0484db56b0",
      "text": "Public statements and EU-level reporting in 2016 described the sanctions regime as conditional and tied to progress on Minsk, prompting debate within EU capitals about sequencing and duration.",
      "date": "2016-01-24 00:00:00"
    },
    {
      "id": "89acd222-703c-4720-9a8d-6057aeb66108",
      "text": "Merkel participated in high-profile meetings and talks (including four-way Ukraine talks) with Putin and other leaders addressing the Ukraine conflict.",
      "date": "2016-10-24 00:00:00"
    },
    {
      "id": "284807e6-5a7d-4b3d-9de8-37f95923bac0",
      "text": "USDA Foreign Agricultural Service publishes a bulletin detailing Russia’s ban, listing affected products and estimating trade impacts for U.S. exporters.",
      "date": "2014-08-07 00:00:00"
    },
    {
      "id": "a7f94928-dc14-48df-894f-bbd44314a21d",
      "text": "The Moscow Times and other outlets report U.S. poultry and other farm sectors were 'bracing' for Russian retaliation following sanctions earlier in August 2014.",
      "date": "2014-08-04 00:00:00"
    },
    {
      "id": "aa8b0872-8aba-41b8-a356-53cdcc685d97",
      "text": "Reports that some early cultured isolates were shared between labs (e.g., first culture reports referencing Jan 28, 2020 Australian culture and rapid global sharing)",
      "date": "2020-01-24 00:00:00"
    },
    {
      "id": "81e31e4a-d74f-497d-9953-d5e8a971de7f",
      "text": "Publication of early RT‑PCR primer/probe protocols (short target sequences) for SARS‑CoV‑2 detection (Corman et al., Eurosurveillance)",
      "date": "2020-01-24 00:00:00"
    },
    {
      "id": "7af695bf-f174-438a-bf33-8de415057f92",
      "text": "FDA labeling and communications warning that certain parenteral products 'contain aluminum that may be toxic' (premature neonates at risk) for prolonged administration",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "bd4e11ec-b7c0-477a-aa5d-25393b75350b",
      "text": "Amphastar (phytonadione) product labeling and manufacturer information listing benzyl alcohol and polysorbate 80 in some Vitamin K injectable formulations",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "43739e83-5143-402c-987a-39ea6d5e21dc",
      "text": "Scientific and review publications and data tables listing aluminum adjuvant amounts across vaccines (showing large variation and values up to ~0.85 mg per dose for some combination vaccines)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "d6ae3f94-02d5-4536-83f8-8be433e4dd52",
      "text": "International coverage on the financial and social hardships faced by Ukrainian war widows and families (feature reporting on widows’ struggles)",
      "date": "2024-02-17 00:00:00"
    },
    {
      "id": "f97b56d3-db33-4c06-bec3-fa9d9c74b5a3",
      "text": "Ukrainian investigators and the SBU disclosed a major arms procurement fraud (scheme to buy artillery shells involving nearly $40m embezzlement)",
      "date": "2023-12-22 00:00:00"
    },
    {
      "id": "d77b65cc-00a1-4a75-9335-7fe0ec3ef5c8",
      "text": "OCCRP reporting on SBU arrest of criminals who racketeered/extorted families of fallen soldiers (caught trying to extract money from a widow)",
      "date": "2024-02-13 00:00:00"
    },
    {
      "id": "29a24473-b8bb-48f0-9506-7cc876ec9c53",
      "text": "WHO and international coding/ICD guidance on how to record and code COVID-19 on death certificates (emergency ICD codes and guidance issued 2020).",
      "date": "2020-06-24 00:00:00"
    },
    {
      "id": "b1078384-5dbc-482c-80e7-b3c2c8fe20fa",
      "text": "Local parish and Bishop Simeon of Vinnytsia publicly moved from the UOC‑MP to the newly formed Orthodox Church of Ukraine (reported as a transfer by parishioners/administration).",
      "date": "2018-12-16 00:00:00"
    },
    {
      "id": "8cc747bf-1146-4f59-bbc4-924fbddcde7b",
      "text": "Ecumenical Patriarch and Ukrainian bishops hold the Unification Council creating the Orthodox Church of Ukraine (OCU).",
      "date": "2018-12-15 00:00:00"
    },
    {
      "id": "2f9c6547-073e-47c9-aec0-6dd23bb6a1c5",
      "text": "Crimean leader Sergei Aksyonov publicly acknowledges an unprecedented drought",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "8ad4a51c-871e-4c4b-bacf-4514122bb946",
      "text": "International outlets reported chronic water shortages in occupied Crimea (e.g., Al Jazeera feature on water shortage and reservoir problems)",
      "date": "2017-01-04 00:00:00"
    },
    {
      "id": "2e96409c-7d0a-42c4-b320-7826d3915f16",
      "text": "Large-scale war-related disruption to schooling and displacement of children in and from Ukraine was documented by UN/NGO reports (e.g., UNICEF/UN briefings in 2022–2023).",
      "date": "2023-01-24 00:00:00"
    },
    {
      "id": "1d149e85-0fe7-4c13-8ed7-3fec8ed5ec74",
      "text": "PISA 2018 results showed Ukrainian 15‑year‑olds scored below the OECD average in reading, maths and science — a widely reported education result that can be (mis)framed as evidence of low intelligence.",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "5ad8fc67-ff18-4a10-aeaa-b0d12fb2b6c0",
      "text": "Repeated international reporting on Russian military build-up and base modernization in Crimea (e.g., Reuters special report documenting new/rewamped bases).",
      "date": "2016-10-24 00:00:00"
    },
    {
      "id": "a3ea47d5-c69f-4d63-9199-e145f58f0b7c",
      "text": "Kerch Strait incident in which Russian forces seized three Ukrainian vessels and detained sailors.",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "d5265464-b07f-428f-b9e0-de6d62c4b69e",
      "text": "UN OHCHR monitoring report documents multiple antisemitic incidents in Ukraine (2017)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "bbbf487f-7ca2-439c-9083-5a2a23d1e934",
      "text": "Nationalist march in Kyiv where some marchers chanted 'Jews out' (reported)",
      "date": "2017-01-03 00:00:00"
    },
    {
      "id": "c6a4fba7-df7f-4349-939e-444ef1af059d",
      "text": "Report of vandalism at old Jewish cemetery in Delyatin (swastika and hate symbols painted)",
      "date": "2017-08-07 00:00:00"
    },
    {
      "id": "f22e9252-9040-436b-a71d-021a3ffca2b7",
      "text": "1974–1975 Japan temporarily suspended whole-cell pertussis (DTP) vaccination after reports of infant deaths following vaccination, prompting development and later adoption of acellular pertussis vaccine.",
      "date": "None"
    },
    {
      "id": "eb2b1c62-ff40-4bef-b079-3ed1a9a922f2",
      "text": "Establishment and public availability of the Vaccine Adverse Event Reporting System (VAERS) in 1990, a passive reporting database where temporal associations between vaccination and events (including infant deaths) can be reported publicly.",
      "date": "1990-04-24 00:00:00"
    },
    {
      "id": "d42ffc06-b4f7-4cdf-8740-500fda2e76ab",
      "text": "U.S. State Department ordered non-emergency U.S. embassy staff to leave Ukraine and advised U.S. citizens to depart (partial drawdown) amid Russian troop buildup.",
      "date": "2022-02-12 00:00:00"
    },
    {
      "id": "9289fbce-8f31-4b85-ab17-0f329026a889",
      "text": "Large-scale Russian missile and drone strikes across Ukraine, including strikes that hit Kyiv's infrastructure and caused blackouts and sheltering of civilians.",
      "date": "2022-10-10 00:00:00"
    },
    {
      "id": "b0d8f0c7-fa85-4070-a3f9-bb1353c4596f",
      "text": "Oxford/AstraZeneca paused its COVID-19 vaccine trials after a participant experienced a 'potentially unexplained illness' (routine safety pause announced).",
      "date": "2020-09-09 00:00:00"
    },
    {
      "id": "5f67926f-47ae-466e-945a-4e24a57f495d",
      "text": "Shelling and strikes on Mariupol reported on Feb 24, with Reuters and other outlets describing residential areas hit and civilians affected.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "029a41b8-5bfa-4a1c-a823-99d0b28d7421",
      "text": "Airstrikes and reports of Russian naval activity in the Black Sea and attacks near Odesa were reported early on Feb 24, including strikes on coastal infrastructure and claims of naval force movements.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "ae8ddae7-cd18-4788-88e8-ea413e8d6ac3",
      "text": "Widespread airstrikes and explosions reported in Kharkiv at the start of the invasion, with residents and officials posting footage of strikes and military vehicles in the city.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "e1320b17-bca5-4b94-b771-f5701e3c47a3",
      "text": "CDC MMWR published early safety monitoring showing reports of allergic reactions and 21 cases of anaphylaxis after first doses of the Pfizer-BioNTech vaccine (dec 14–23, 2020; published Jan 6, 2021)",
      "date": "2021-01-06 00:00:00"
    },
    {
      "id": "ad66ce12-8b29-4147-87b8-a08b32f20c00",
      "text": "Norwegian health authorities reported deaths in very frail elderly following vaccination with the Pfizer vaccine; media coverage appeared mid-January 2021",
      "date": "2021-01-15 00:00:00"
    },
    {
      "id": "e56d3be1-6286-42f7-ae0e-3bcd92b6d963",
      "text": "Transfer of centralized medicines procurement to international organisations (UNDP, UNICEF, Crown Agents) as an anti‑corruption measure (2015)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "33448b65-89e1-453f-ac46-097978266b95",
      "text": "Appointment of Ulyana Suprun as Acting Minister of Health amid public controversy over her reform agenda and foreign background",
      "date": "2016-07-27 00:00:00"
    },
    {
      "id": "d816f5ed-9784-4f50-b90c-f6908758e6b8",
      "text": "WHO / European Observatory health system review documenting chronic underfunding, high out‑of‑pocket payments and systemic weaknesses in Ukraine’s health system (2015)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "8cb69cfd-85dc-4c0f-b971-2a4889509e57",
      "text": "Publication (medRxiv / PMC entry) of the Yale LISTEN study / related analyses describing self-referred cases of post-vaccination syndrome and immunophenotyping (preprint posted Nov 10, 2023; PMC entry available).",
      "date": "2023-11-10 00:00:00"
    },
    {
      "id": "f85a5e36-7aa3-4d21-955a-37dfcfcb0028",
      "text": "Reports of black/foreign particles found in some Moderna vaccine vials in Japan, leading to temporary suspension and recalls of lots.",
      "date": "2021-08-30 00:00:00"
    },
    {
      "id": "073a0a2b-171a-46cd-9eb6-8944e39c4434",
      "text": "Publication of Prof. Pablo Campra's technical report claiming Raman/microscopy detection of graphene/graphene oxide in some COVID-19 vaccine samples.",
      "date": "2021-11-02 00:00:00"
    },
    {
      "id": "4ac0b73e-244f-47b5-945d-8d0c3614d33f",
      "text": "Reporting on volunteer battalions (Azov, Aidar and others) emphasised recruitment of foreign fighters and the existence of organised volunteer units in 2014.",
      "date": "2014-12-13 00:00:00"
    },
    {
      "id": "97de3966-6346-46ae-9e03-b0a4c14a782b",
      "text": "Press coverage of allegations that US-linked private security firms (e.g., reports referencing Academi/Blackwater) had personnel in Ukraine circulated in May 2014.",
      "date": "2014-05-21 00:00:00"
    },
    {
      "id": "4a6b1605-1c0b-49f4-ad28-fac808622876",
      "text": "CDC guidance on serology (antibody) testing noting possible cross‑reactivity with other coronaviruses",
      "date": "2020-06-25 00:00:00"
    },
    {
      "id": "7ce2fa37-7022-4551-9c9c-e5b51aff0552",
      "text": "OSCE Special Monitoring Mission reported observation of tanks and movements of heavy weapons in eastern Ukraine (daily SMM reports, e.g. 14 April 2015 noted tanks moving near Hirne).",
      "date": "2015-04-14 00:00:00"
    },
    {
      "id": "d79ed9b7-d187-4177-b2dd-99cea6aa6c11",
      "text": "Regulatory and scientific guidance acknowledging residual host‑cell/production‑related proteins are monitored in biologic manufacture (EMA position statement on residual host cell DNA and host cell proteins).",
      "date": "1997-06-10 00:00:00"
    },
    {
      "id": "1089e709-3514-4c73-9c03-977c544ef2a1",
      "text": "Reports of black/foreign particles found in multiple Moderna COVID-19 vaccine vials in Japan, prompting suspension and recall of affected lots.",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "4d24e4bd-5b86-4510-835e-015de2aadc8b",
      "text": "MHRA Freedom of Information response stating that the AstraZeneca, Pfizer/BioNTech and Moderna COVID-19 vaccines do not contain any components of animal origin.",
      "date": "2022-04-27 00:00:00"
    },
    {
      "id": "7c0734d6-bcfb-43f1-85bd-4153220ebf66",
      "text": "Pentagon Inspector General audit (reported Jan 11, 2024) finding about $1 billion in U.S. weapons sent to Ukraine were not properly tracked.",
      "date": "2024-01-11 00:00:00"
    },
    {
      "id": "6094a91b-be05-4e65-991d-88834f3c6d51",
      "text": "Reuters reporting (Sept 19, 2024) that Congress and the administration were nearing a deal to extend expiring military aid of roughly $5.8–6.0 billion to Ukraine.",
      "date": "2024-09-19 00:00:00"
    },
    {
      "id": "096a3029-98b7-4ed7-9eb4-e6c2193815e0",
      "text": "Pentagon press briefing in which Deputy Press Secretary Sabrina Singh discussed expiring authorities and said the Pentagon intends to 'use every dollar and cent' of available authority for Ukraine.",
      "date": "2024-09-19 00:00:00"
    },
    {
      "id": "2536d3cf-bc39-485e-a4b8-00382b9abfc9",
      "text": "Assassination of Andriy Parubiy in Lviv",
      "date": "2025-08-30 00:00:00"
    },
    {
      "id": "a19c2453-fafa-48af-ac55-4b1a5f1a3abb",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers released, strongly attributing recent warming to human activities.",
      "date": "2021-08-09 00:00:00"
    },
    {
      "id": "006f8e37-0bf6-4529-8ae4-8b2b2c61290b",
      "text": "European Space Agency (ESA) Swarm mission publications and press releases reporting an accelerating weakening and expansion of the South Atlantic Anomaly in Earth's magnetic field.",
      "date": "2020-05-24 00:00:00"
    },
    {
      "id": "0a29d425-4f20-4547-ad98-782dbb8b942c",
      "text": "U.S. government places an approximately $119 million order (option for ~13 million doses) for Bavarian Nordic’s Jynneos smallpox/monkeypox vaccine (reported May 2022).",
      "date": "2022-05-19 00:00:00"
    },
    {
      "id": "1873f9a5-f398-40e6-80cd-199506a5dd73",
      "text": "WHO declares the multi-country monkeypox outbreak a Public Health Emergency of International Concern (PHEIC).",
      "date": "2022-07-23 00:00:00"
    },
    {
      "id": "e6cfc285-f96c-462b-86de-69eae094a9bb",
      "text": "Reports and government accounts of large unused or expired COVID-19 vaccine stockpiles and write-offs (examples include national write‑offs reported in 2022–2024).",
      "date": "2024-01-25 00:00:00"
    },
    {
      "id": "989cde89-2dab-4dd9-88e8-2bdad40f6525",
      "text": "WHO announces it will adopt 'mpox' as the preferred synonym for 'monkeypox' and phase out the old name.",
      "date": "2022-11-28 00:00:00"
    },
    {
      "id": "153717df-7ea2-44dc-9d09-0a3b96f8d0f1",
      "text": "Local authorities' animal-control history and municipal programs noted in press (Kyiv had earlier programs to manage stray animals, and NGOs warned of 'dog hunters' operating independently)",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "b51b52ad-234e-4f9f-aedc-378f5af6691f",
      "text": "Large online petitions launched and amplified claims of planned mass killings (Change.org and other petition platforms) asking EBU, Kyiv mayor and international public to stop dog killings for Eurovision",
      "date": "2017-02-08 00:00:00"
    },
    {
      "id": "d6fd61ec-67b4-49a7-b01e-6751da4c2b70",
      "text": "Ukrainian authorities announce seizures and freezes of assets linked to Yanukovych and his entourage",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "c36de96c-9b8d-4c9e-a111-d540a59acbda",
      "text": "Viktor Yanukovych flees Kyiv and is ousted amid Euromaidan protests",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "cd9edb31-6c8f-4113-8234-0aad95e575e6",
      "text": "The Soufan Group's June 2014 report documenting large flows of foreign fighters to Syria from many countries, including from the wider post‑Soviet space.",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "192f64f3-404e-44e7-be69-061f71569962",
      "text": "Reporting on Chechen fighters active in both theatres (Donbas and Syria) — e.g., Carnegie Endowment analysis 'Chechen Mysteries in Donetsk' (Oct 2014) documented Chechen involvement around Donetsk.",
      "date": "2014-10-29 00:00:00"
    },
    {
      "id": "66cc19cb-d992-4801-a6a5-3bcc508cad56",
      "text": "The Guardian reporting (1 Oct 2015) that Russian state media were shifting attention from Ukraine to Syria, reframing coverage and drawing links between the conflicts.",
      "date": "2015-10-01 00:00:00"
    },
    {
      "id": "feb14c4e-cb39-4bfd-a31d-85ca5fbf9507",
      "text": "CDC recommendation for public use of cloth face coverings",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "b92df98b-d7a8-492e-99c0-f650da425547",
      "text": "Publication of Morens, Taubenberger & Fauci analyses concluding secondary bacterial pneumonia caused many 1918 deaths",
      "date": "2008-10-24 00:00:00"
    },
    {
      "id": "4184ac9e-a2ee-42c3-b501-e30a7f7cceb3",
      "text": "Russian media / monitoring reports repeatedly amplifying negative narratives about Zaluzhnyi (April 2024)",
      "date": "2024-04-22 00:00:00"
    },
    {
      "id": "6fef70f2-b2e5-4078-9e9a-4ed219b153de",
      "text": "French and international coverage from early in the war (March 2022) profiled Ernesto Barbieri (videos/interviews on France 2/Euronews and his YouTube channel), making him a known figure.",
      "date": "2022-03-29 00:00:00"
    },
    {
      "id": "9aeea02f-b296-4f73-af29-f3946c7ef555",
      "text": "Adoption of the 2012 \"On the Principles of State Language Policy\" (Kolesnichenko–Kivalov law) granting expanded regional status to minority languages",
      "date": "2012-08-10 00:00:00"
    },
    {
      "id": "b2ac124c-ace9-4763-b92a-9b4ee6fbe882",
      "text": "Public complaints and statements by Hungarian organizations and diaspora groups about the situation of ethnic Hungarians in Transcarpathia (AHF statements and local reporting, March 2014)",
      "date": "2014-03-10 00:00:00"
    },
    {
      "id": "06462009-bc55-4f62-843a-7d69d3bfed7c",
      "text": "Public OSCE monitoring and commentary on minority-rights tensions in Ukraine (OSCE updates and reporting, mid‑2014)",
      "date": "None"
    },
    {
      "id": "1eea5f54-91aa-4cd5-97e7-61aceeaf6eb4",
      "text": "Verkhovna Rada vote to repeal the 2012 language law (attempted repeal, 23 February 2014)",
      "date": "2014-02-23 00:00:00"
    },
    {
      "id": "7228ee7e-e61d-4ebe-bcd4-e6b39cf2dc2a",
      "text": "Analyses and reporting on cross‑border tensions (KyivPost feature coverage of Transcarpathia and Hungary‑Ukraine disputes, 2014)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "35b2b00e-13d0-4a07-94e4-e0237cd1bb94",
      "text": "U.S. government agencies and NASA suspended or curtailed certain cooperation with Russia in response to the 2014 annexation",
      "date": "2014-04-03 00:00:00"
    },
    {
      "id": "4cb198bf-2c46-4779-a0a2-822e74b7b4a3",
      "text": "National Geographic announced it would show Crimea as part of Russia on its maps following the 2014 annexation debate",
      "date": "2014-03-19 00:00:00"
    },
    {
      "id": "fa1c7035-96d3-49a2-8d99-2e4980a79148",
      "text": "Human Rights Watch and other observers reported steps by Ukrainian authorities in 2015 restricting access (e.g., blacklists, travel/media restrictions) for certain journalists and commentators.",
      "date": "2015-09-16 00:00:00"
    },
    {
      "id": "012714bc-c95f-448c-9823-3988f2217818",
      "text": "Earlier in 2015 Ukraine moved to block multiple Russian TV channels (press/ regulator actions widely reported, e.g., April 2015 ban of 14 Russian channels for 'propaganda').",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "06e78ed7-0599-4d54-9772-986b6028609d",
      "text": "Series of lithium-ion battery fires at Convergent Energy storage sites in Warwick, New York (multiple alarms and containment responses reported June 26–27, 2023), prompting local media coverage and community concern.",
      "date": "2023-06-26 00:00:00"
    },
    {
      "id": "01f3eb35-460a-46a5-bbaa-c848320a4e96",
      "text": "LG Chem (RESU) residential energy-storage battery recall(s) following multiple reports of overheating and fires in home battery units (recalls/public warnings issued December 2020 and expanded in 2021).",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "98efc04f-bb71-4262-8754-21a2dbb96c1b",
      "text": "IMF approval of a large Extended Fund Facility for Ukraine (US$17.5 billion) in March 2015, accompanied by IMF warnings about the banking sector's contingent liabilities and need for recapitalization.",
      "date": "2015-03-11 00:00:00"
    },
    {
      "id": "53189873-e1b0-4a74-a2de-c6f96c1ee63c",
      "text": "National Bank of Ukraine (NBU) extended loan repayment periods and implemented emergency liquidity measures to support banks under strain.",
      "date": "2014-09-04 00:00:00"
    },
    {
      "id": "2ecfd8b1-aeaa-4f4a-9ed7-bd95ba311047",
      "text": "Credit-rating agency downgrades of major Ukrainian banks (e.g., Fitch downgraded PrivatBank and ProCredit's viability ratings in December 2014).",
      "date": "2014-12-16 00:00:00"
    },
    {
      "id": "109c5e74-1d02-47bc-b21c-4526d12dd143",
      "text": "Ukraine's hryvnia plunged after the central bank abandoned foreign currency auctions, triggering sharp currency devaluation and market panic.",
      "date": "2014-02-05 00:00:00"
    },
    {
      "id": "9e46276b-9550-4850-906b-947941551ea0",
      "text": "Central bank closures and a wave of bank shutdowns during the 2014 financial turmoil in Ukraine (multiple banks shut or declared insolvent).",
      "date": "2014-03-12 00:00:00"
    },
    {
      "id": "7db66327-741e-4aba-a2d0-9dec13f88426",
      "text": "Official recommendations to offer COVID‑19 vaccination to pregnant and lactating people (ACOG/CDC guidance issued in December 2020 and subsequently maintained).",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "f5f8713a-6585-4825-bec7-0970665e313b",
      "text": "NCHS provisional report showing a 3% rise in the U.S. infant mortality rate for 2022 (first year‑to‑year increase since 2001–2002).",
      "date": "2023-11-24 00:00:00"
    },
    {
      "id": "6b9ee849-6886-4346-8ad1-d1204d78e963",
      "text": "Peer‑reviewed VAERS analysis summarizing adverse event reports in pregnant people (covers reports through April 1, 2022) published in European Journal of Clinical Pharmacology (PMC).",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "ec463ac8-abae-4db1-81f0-eada054532f4",
      "text": "Published evidence of waning vaccine effectiveness and breakthrough infections in Israel",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "c5926f07-1b8c-4545-8b18-9b06960feb26",
      "text": "Japan suspended and recalled Moderna vaccine batches after discovery of foreign particles",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "a835d36b-961c-4b8c-85bd-753a59738e3d",
      "text": "CDC changed mask guidance in May 2021 allowing fully vaccinated people to stop wearing masks, then later revised recommendations as variants spread",
      "date": "2021-05-13 00:00:00"
    },
    {
      "id": "71bc85b6-6f5d-4aef-bc64-1f26ad42393c",
      "text": "Local Ukrainian authorities reported civilian casualties and injuries from the July strikes",
      "date": "2022-07-23 00:00:00"
    },
    {
      "id": "40693fc4-7ddd-4a41-9ba7-2ab2fce9c650",
      "text": "UN Secretary-General and UN spokesperson publicly condemn reported strikes on Odesa",
      "date": "2022-07-23 00:00:00"
    },
    {
      "id": "6681479a-13d9-4db6-b878-98826e64562b",
      "text": "Istanbul 'grain corridor' agreement signed between Russia, Ukraine, Turkey and the UN",
      "date": "2022-07-22 00:00:00"
    },
    {
      "id": "a3211a66-26b4-4f94-8dce-8734cfb6c504",
      "text": "Missile strikes hit Odesa port and city (reported by multiple outlets)",
      "date": "2022-07-23 00:00:00"
    },
    {
      "id": "7091328e-46d8-4bfb-9119-5c4718a72e34",
      "text": "Several countries temporarily suspended use of the AstraZeneca COVID-19 vaccine in mid-March 2021 while regulators investigated rare clotting reports.",
      "date": "2021-03-15 00:00:00"
    },
    {
      "id": "9912bacb-3f98-46ca-a184-72b1066243a3",
      "text": "FDA Vaccines and Related Biological Products Advisory Committee briefing document for Moderna (mRNA-1273) published, including detailed safety/reactogenicity tables from phase 3 trial.",
      "date": "2020-12-17 00:00:00"
    },
    {
      "id": "b6a06f13-7ec8-462d-8836-4a64b81b052e",
      "text": "Public-facing CDC guidance summarizing common, expected side effects after COVID-19 vaccination (local pain, fatigue, headache, fever).",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "a0ecf576-e0bd-40a5-980f-ad8ac2c93062",
      "text": "UNICEF and WHO confirmation and public statements about a circulating vaccine-derived poliovirus type 2 (cVDPV2) outbreak in Sudan and coordinated vaccination response.",
      "date": "2020-09-08 00:00:00"
    },
    {
      "id": "e99c6b71-2091-4ff9-b9a1-3ffb9da8a1fd",
      "text": "Reporting in October 2023 documented an uptick in Russian strikes and drone attacks on Ukraine's rail network and passenger trains.",
      "date": "2023-10-06 00:00:00"
    },
    {
      "id": "7d86a9a0-38d1-4e6f-9511-4471e7bb984a",
      "text": "Ukrzaliznytsia publicly announced introduction of undercover 'railway safety marshals' working on stations and trains.",
      "date": "2023-10-09 00:00:00"
    },
    {
      "id": "cc823d78-71f1-4505-b8f8-4cbd92ba6515",
      "text": "CDC updates guidance on May 13, 2021 saying fully vaccinated people could resume activities without masks or physical distancing in most settings.",
      "date": "2021-05-13 00:00:00"
    },
    {
      "id": "7f37f4d7-bc29-424f-a2f8-a29fb67a93a4",
      "text": "CDC MMWR report on the Provincetown, Massachusetts Delta outbreak showing a high proportion of cases in fully vaccinated people and evidence of possible transmission from vaccinated individuals.",
      "date": "2021-07-30 00:00:00"
    },
    {
      "id": "26bcea85-340a-4926-a72e-f5166eb39426",
      "text": "UK Health Security Agency and related UK analyses in July 2021 showing reduced vaccine effectiveness against symptomatic infection with the Delta variant while retaining protection against severe illness.",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "e6358408-cf3c-467a-83f0-f1a25a9cb069",
      "text": "U.S. officials publicly sought funds and announced plans to test and develop ground‑launched intermediate‑range missiles after INF collapse",
      "date": "2019-08-02 00:00:00"
    },
    {
      "id": "33f1cb91-f1d5-4f65-96c3-91b4f079dae6",
      "text": "NATO publicly stated Russia was in material breach of the INF Treaty",
      "date": "2019-02-01 00:00:00"
    },
    {
      "id": "2643e618-f92c-4989-a4ea-d7524c161d11",
      "text": "Trump administration announced suspension of U.S. obligations under the INF Treaty and delivered six‑month notice of withdrawal",
      "date": "2019-02-02 00:00:00"
    },
    {
      "id": "81a34fec-f865-4d74-973d-1441a2e96448",
      "text": "FactCheck.org SciCheck explainer on what VAERS can and can't do (widespread June 2023 coverage)",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "b20106d0-cc8b-4da6-847a-cee0c4e03136",
      "text": "Italy and some Italian officials publicly criticized the EU and fellow member states for a slow and inadequate early response to Italy's COVID-19 crisis.",
      "date": "2020-03-11 00:00:00"
    },
    {
      "id": "b1b7994d-e789-44d3-8fa9-786c6ad1660f",
      "text": "U.S. officials publicly accused Russia of running a coronavirus disinformation campaign (statements reported in February–March 2020).",
      "date": "2020-02-22 00:00:00"
    },
    {
      "id": "09bf5365-4846-4c70-8462-797de6862674",
      "text": "UKHSA (PHE) published weekly COVID-19 Vaccine Surveillance Report (Week 43) containing counts of cases, hospitalisations and deaths broken down by vaccination status.",
      "date": "2021-10-29 00:00:00"
    },
    {
      "id": "d991436b-aa0d-4d71-8ddc-97f32927ada2",
      "text": "Reports of contamination (black/stainless-steel particles) found in batches of Moderna COVID-19 vaccine vials in Japan; large numbers of doses temporarily suspended/withdrawn.",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "01e15d8e-9278-49d9-b0ae-ee64046f3232",
      "text": "CDC guidance recommending vaccination as part of hurricane preparedness (site guidance last reviewed)",
      "date": "2022-08-08 00:00:00"
    },
    {
      "id": "1a70a4dd-2da1-4130-83c6-be14a06081b2",
      "text": "Clashes and beatings during spring 2014 rallies in Kharkiv where pro‑Russian activists and counter‑protesters attacked each other and journalists were beaten.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "adb47cd3-ee56-4d9a-9ca2-c4a01876a63c",
      "text": "Investigative reconstructions (Bellingcat, Jan 28, 2015) of May 9, 2014 violence in eastern Ukraine documenting how video fragments and poor sourcing can produce misleading narratives.",
      "date": "2015-01-28 00:00:00"
    },
    {
      "id": "c8879a85-e025-45d5-a6f3-c18a66716cc6",
      "text": "OHCHR periodic reports documenting alleged human-rights violations in Ukraine (2014)",
      "date": "2014-09-19 00:00:00"
    },
    {
      "id": "78b14f68-ae01-4d4c-acb1-0d71d1609053",
      "text": "Ukraine accepts International Criminal Court (ICC) jurisdiction for alleged crimes (ad hoc declaration)",
      "date": "2014-04-17 00:00:00"
    },
    {
      "id": "97421821-e331-46dc-ba60-d0e6f36dba4f",
      "text": "UN General Assembly adopts Resolution 68/262 on the territorial integrity of Ukraine",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "459b2077-c724-4735-a64f-e274a8dff816",
      "text": "CDC publishes guidance and reporting mechanism on vaccine breakthrough infections and explains expected breakthrough cases as vaccination coverage rises",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "5faf6e11-7e86-475d-bf63-e4435dee1019",
      "text": "CDC designates California variants B.1.427/B.1.429 (CAL.20C) and reports potential reduced susceptibility to antibodies",
      "date": "2021-03-16 00:00:00"
    },
    {
      "id": "af931724-5e01-43e3-b06e-af89df93f816",
      "text": "Laboratory studies report reduced neutralization of certain variants (eg. B.1.351) by vaccine-elicited or convalescent sera",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "99463725-d3fb-40d5-b695-6e928f7a6286",
      "text": "News coverage of the emergence and spread of CAL.20C (B.1.427/B.1.429) in California",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "7187e3aa-5b53-414b-90e5-9921cf9ae4bb",
      "text": "Detection of porcine circovirus (PCV1) DNA in Rotarix and regulatory review (2010)",
      "date": "2010-03-24 00:00:00"
    },
    {
      "id": "dcf249aa-c49d-42c1-8171-a26bac8be3d1",
      "text": "Widely cited medical review summarising clinical uses of activated charcoal in poisoning and emergency medicine (accessible on PubMed/PMC)",
      "date": "2019-05-03 00:00:00"
    },
    {
      "id": "6ecc5c36-f428-48db-8860-cc6f3409b905",
      "text": "Local/national news coverage warning experts about the TikTok 'parasite cleanse' trend and the use of 'binders' including activated charcoal",
      "date": "2024-06-22 00:00:00"
    },
    {
      "id": "00177a2b-221c-4df0-8918-34f76f806afb",
      "text": "Turkish naval leadership and media reported ambitions to develop nuclear-powered submarines under the national MILDEN program and discussed cultivating reactor expertise domestically.",
      "date": "2025-05-02 00:00:00"
    },
    {
      "id": "f4e6e97a-7274-4981-aced-d5b19a5f74cb",
      "text": "Rosatom and Turkish authorities advanced the Akkuyu nuclear power plant project; Rosatom announced the first unit entered commissioning-stage work and earlier delivered fuel components.",
      "date": "2024-04-11 00:00:00"
    },
    {
      "id": "86306a55-2043-46cd-8b9c-cb3d3beebc6d",
      "text": "Turkish ministers (including Foreign Minister Hakan Fidan) visited Niger and signed a provisional agreement to enhance energy and mining cooperation, reported as an effort to secure uranium supplies.",
      "date": "2024-07-18 00:00:00"
    },
    {
      "id": "193f820a-5a38-4ded-ab67-3111ab1c213a",
      "text": "Foundation for Defense of Democracies (FDD) published an analysis titled 'FAQ: Is Turkey the Next Nuclear Proliferant State?' outlining potential Turkish moves (e.g., securing uranium, expanding fuel-cycle capabilities) that could — in theory — support future weapons work.",
      "date": "2025-02-05 00:00:00"
    },
    {
      "id": "b4f98ed3-8223-4416-9d64-76e16d257741",
      "text": "President Erdoğan publicly questioned why some countries have nuclear weapons while others cannot, saying “this, I cannot accept” in a speech to his party.",
      "date": "2019-09-04 00:00:00"
    },
    {
      "id": "46cca0d7-4e2c-4d52-a3ab-76af3ea351e7",
      "text": "CDC/FDA VAERS surveillance paper (Vaccine) published summarising VAERS reports in pregnant persons (Dec 2020–Oct 2021), noting 12 neonatal deaths reported but concluding crude reporting rates were below background.",
      "date": "2022-04-12 00:00:00"
    },
    {
      "id": "3125e0e6-6275-4e6e-93cb-46b1e8fc05dc",
      "text": "Reports in September 2021 that black/foreign particles were found in some Moderna vaccine vials in Japan, prompting suspension/recall of specific lots.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "1cd55f6e-f978-4e0e-8c42-852043619353",
      "text": "Annalena Baerbock's remarks at the Forum 2000 panel in Prague where she said, in English, a line widely quoted as 'no matter what my German voters think' during a discussion on support for Ukraine.",
      "date": "2022-08-31 00:00:00"
    },
    {
      "id": "6dc77cfe-a660-4c19-8ac7-e90ed1c0e119",
      "text": "Japan identified black/stainless-steel particles in multiple Moderna vaccine vials leading to recalls and temporary halts (reported September 2021).",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "2e4b1b25-9832-47f9-a571-e3cf7e71a86b",
      "text": "FDA inspection and public reporting on Emergent BioSolutions Baltimore plant problems that ruined millions of J&J vaccine doses and cited sanitation/cross-contamination concerns.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "c76856fd-3193-49fb-aaca-987b66991f96",
      "text": "Scientific reviews and debates about Simian Virus 40 (SV40) and its detection in some human tumors (literature reviews summarizing associations and uncertainties).",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "6319b523-7a66-47b9-9709-d11fbc2b693d",
      "text": "Vestas press release (8 February 2023) announcing a new chemical recycling approach and reporting steps toward recycling end-of-life blades (including a 2022 figure of recycled blades claimed by the company)",
      "date": "2023-02-08 00:00:00"
    },
    {
      "id": "24798506-4131-42dd-93ec-7fcaf538d514",
      "text": "American Clean Power (ACP) white paper 'Decommissioned Wind Turbine Blade Management Strategies' (ACP/industry analysis) documents that current end-of-life options are limited and that landfill is often the lowest-cost route",
      "date": "2023-01-24 00:00:00"
    },
    {
      "id": "895d573c-7c48-4b90-9725-42ce20b2311d",
      "text": "University of Strathclyde 'PRoGrESS' blade recycling pilot (project launch and pilot development, 2022–2023) to separate glass fibre from resin and commercialise recycling methods",
      "date": "None"
    },
    {
      "id": "02509c8c-3ac5-4e9b-a5fa-bc3de805bf13",
      "text": "CNN long-read on blade waste (May 2023) highlighting viral images of piles of decommissioned blades (e.g., Casper Regional Landfill) and describing the growing volume of blade waste",
      "date": "2023-05-28 00:00:00"
    },
    {
      "id": "56c1f7c3-5279-463f-b46d-75aae1b63a4b",
      "text": "Reports in September 2021 of contamination/foreign particles found in some Moderna vaccine vials in Japan and temporary recalls/collection of affected batches",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "ccf3d3fc-0e96-4f64-b986-c8ae23e11ef5",
      "text": "CDC and other agencies reporting rare myocarditis/pericarditis cases after mRNA vaccination (June 2021) and subsequent media coverage noting hospital admissions for evaluation and treatment",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "c729b3a5-3286-4a46-a8c8-f4d99ec15d78",
      "text": "Release of UK Health Security Agency (formerly PHE) vaccine surveillance reports showing that a high proportion of COVID-19 hospitalisations/deaths in autumn 2021 were among fully vaccinated people in older age groups",
      "date": "2021-10-28 00:00:00"
    },
    {
      "id": "3f9c9033-7f55-4d2c-8bb5-e8d64bfba2ad",
      "text": "Published Israeli analyses and policy statements (mid–late 2021) documenting waning protection from two doses of BNT162b2 and the decision to roll out third-dose boosters",
      "date": "None"
    },
    {
      "id": "782379b9-cabd-46fc-b911-0470863f9959",
      "text": "Germany reintroduced internal border controls with Poland, Czechia and Switzerland (official notification to EU)",
      "date": "2023-10-16 00:00:00"
    },
    {
      "id": "4bfc3856-1d1d-40a6-9dea-4ca5e589114f",
      "text": "Reports and footage of German police cracking down on illegal crossings at the Polish border",
      "date": "2023-10-12 00:00:00"
    },
    {
      "id": "c24eda70-eb48-4889-9a52-0b84731513cf",
      "text": "UNESCO recommendation that the Great Barrier Reef should be listed as 'in danger'",
      "date": "2021-06-22 00:00:00"
    },
    {
      "id": "760eac4a-ccfb-4233-9ad1-8b2a33b46b07",
      "text": "AIMS Long-Term Monitoring Program Annual Summary Report (2019/20) showing regional increases in hard coral cover",
      "date": "2020-08-24 00:00:00"
    },
    {
      "id": "cd7e77ee-90bb-412e-8be8-7efd19f44bca",
      "text": "New York Times: Coverage of fewer tourists and clearer reef images during COVID-19",
      "date": "2020-08-22 00:00:00"
    },
    {
      "id": "a9c6ea4c-098a-4bf7-8177-5e9d3dc7e7b1",
      "text": "NWCG publishes PMS 501 (Standards for Aerial Ignition) including Appendix B covering helitorch operations and training materials",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "2ed16c52-b1a2-4fa7-a894-4f80d57f03ca",
      "text": "Australian Department of Defence confirms Orroral Valley bushfire was likely started by an Army helicopter landing light (investigation / press release)",
      "date": "2020-01-28 00:00:00"
    },
    {
      "id": "d6541a0d-b8b8-4b46-b2b3-7709093a904d",
      "text": "NSW National Parks posts video documenting a trial of a helicopter-mounted drip torch (aerial drip torch/helitorch) used for hazard reduction in Kosciuszko National Park",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "d5289d0a-7587-47f3-a127-377dde4d6139",
      "text": "Media reporting in 2023 on expansion and tightening of mobilization and medical‑fitness procedures (Ministry of Defence changes to the Regulations on Military Medical Examination, referenced in coverage of Order No.490).",
      "date": "2023-08-18 00:00:00"
    },
    {
      "id": "138a7f8e-9488-4037-a411-2c7f0bd720e4",
      "text": "Major international coverage during 2023 reported a sharp rise in Ukrainian war amputees and stories about some wounded servicemen returning to roles after prosthetics and rehabilitation (BBC feature on amputees).",
      "date": "2023-09-21 00:00:00"
    },
    {
      "id": "8b2db83b-6c14-4087-b8bb-a72645880736",
      "text": "Human Rights Watch publishes findings that cluster munitions were used by Ukrainian forces in populated parts of Donetsk in October 2014.",
      "date": "2014-10-20 00:00:00"
    },
    {
      "id": "a323c5b7-c89f-4df6-a9cc-1b10d2e262db",
      "text": "Human Rights Watch warns that unguided Grad rockets used in populated areas in eastern Ukraine led to civilian deaths and injuries.",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "50eb0125-135f-4fda-89a2-8784046737cd",
      "text": "Multiple international news outlets reported deadly shelling incidents in Donetsk (e.g., bus-stop and residential strikes in January 2015) with both sides trading blame.",
      "date": "2015-01-22 00:00:00"
    },
    {
      "id": "82024969-a370-464d-9b78-4528b73f0e66",
      "text": "OSCE SMM spot report documents residential buildings in Donetsk severely damaged by artillery fire observed by monitors.",
      "date": "2014-08-23 00:00:00"
    },
    {
      "id": "fe475462-13d0-49f8-b497-59d3e83070b5",
      "text": "Royal College of Physicians report 'Nicotine without smoke: Tobacco harm reduction' endorsing e-cigarettes as a reduced-harm alternative.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "93525525-c9c8-41fd-8976-67360dc59ef5",
      "text": "2019 EVALI outbreak (vaping-associated severe lung injury) and CDC investigation/public reporting.",
      "date": "2019-10-24 00:00:00"
    },
    {
      "id": "f32378d8-2d99-43d4-9ef6-9f811b5f21a0",
      "text": "Publication of peer‑reviewed study detecting chlormequat in U.S. foods and urine samples (Temkin et al.)",
      "date": "2024-02-15 00:00:00"
    },
    {
      "id": "99e12ad1-d630-44fb-b4f9-a4cff70ce19f",
      "text": "2019 mainstream reporting on glyphosate (Roundup) residues in oat‑based cereals (including Cheerios/Quaker)",
      "date": "2019-06-12 00:00:00"
    },
    {
      "id": "a9037445-b5cd-416c-95e5-21c313b0115d",
      "text": "2019 consumer lawsuits and complaints over 'natural' labeling after pesticide detections in Quaker/other oat products",
      "date": "2019-06-24 00:00:00"
    },
    {
      "id": "d9d55e1f-e4c1-4127-8aa5-2dc2a867de4d",
      "text": "Earlier vaccine contamination/quality incidents (Japan pauses Moderna batches over foreign particles, Aug 2021)",
      "date": "2021-08-27 00:00:00"
    },
    {
      "id": "a712c2ed-6f8a-4c3d-b2e3-f027854812db",
      "text": "FDA Emergency Use Authorization announcement for Pfizer pediatric dosing (3 μg) for ages 6 months–4 years",
      "date": "2022-06-17 00:00:00"
    },
    {
      "id": "0473891e-7ca3-488c-9e31-ebdce839cd19",
      "text": "Global OPV 'switch' (withdrawal of type‑2 component) and related operational challenges — April 2016",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "9df7e52c-2adb-4d55-b85e-14542afa3f8a",
      "text": "Suspension of mass polio vaccination campaigns during the early COVID‑19 pandemic — March 2020",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "c83c4ddc-fbff-4e86-a3a7-8bb98c1ed0dc",
      "text": "Official appointment of Andriy Shevchenko (politician) as Ukraine's Ambassador to Canada",
      "date": "2015-09-24 00:00:00"
    },
    {
      "id": "42968904-9bcb-47d4-b553-a55c537e7274",
      "text": "High public profile of footballer Andriy Shevchenko (former Ukraine/AC Milan striker; Ballon d'Or 2004)",
      "date": "None"
    },
    {
      "id": "9be704ed-0245-4064-813a-c380592a9050",
      "text": "Federal judge orders FDA to speed release of Pfizer COVID-19 vaccine documents (55,000 pages/month).",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "2b237886-7fdd-4732-816e-6bbff127142f",
      "text": "News reports that the United States and many European countries would not send representatives to Vladimir Putin’s May 7, 2024 swearing‑in ceremony.",
      "date": "2024-05-07 00:00:00"
    },
    {
      "id": "4f6449e5-4a91-414e-877d-b32f59ccf58e",
      "text": "U.S. State Department March 19, 2024 press statement ('On Russia’s Presidential Elections') that criticized the election as undemocratic while discussing the outcome and Russian leadership.",
      "date": "2024-03-19 00:00:00"
    },
    {
      "id": "e5008ebd-7968-4365-b0ba-fcf2073e10f7",
      "text": "FTC and FDA/FTC enforcement actions against companies marketing supplements as diabetes treatments (joint warning letters / cease-and-desist demands).",
      "date": "2021-09-09 00:00:00"
    },
    {
      "id": "d5b913e1-ad6f-452f-9eb0-7eecbc873007",
      "text": "Publication of systematic reviews / meta-analyses (e.g., berberine) showing modest glucose‑lowering effects of certain supplements.",
      "date": "2021-12-15 00:00:00"
    },
    {
      "id": "a92003c0-70e7-42b3-988f-d81e279bc03b",
      "text": "Reporting of budget pressures and cuts to municipal funding in Italy (municipalities face first funding cuts in years)",
      "date": "2023-10-24 00:00:00"
    },
    {
      "id": "7dd0ca0a-15bf-40aa-9e2e-e18040f7de76",
      "text": "Pentagon Inspector General report that around $1 billion in U.S. weapons sent to Ukraine were not properly tracked (publicised January 2024)",
      "date": "2024-01-11 00:00:00"
    },
    {
      "id": "779e0434-97ae-4158-84a3-b4fca8cf3f08",
      "text": "Italian government approvals/extensions of multiple military/financial aid packages to Ukraine (ongoing through 2023–2024)",
      "date": "2023-12-19 00:00:00"
    },
    {
      "id": "2bee01d7-bd51-4db8-a7dc-a0a88773adad",
      "text": "Partial collapse of the medieval Torre dei Conti during restoration work in central Rome",
      "date": "2025-11-03 00:00:00"
    },
    {
      "id": "24eb783a-7899-40b6-bd7e-19f05a363867",
      "text": "IPCC Special Report on Global Warming of 1.5°C published and widely reported",
      "date": "2018-10-08 00:00:00"
    },
    {
      "id": "9e2379f7-a83d-4952-bd56-8895d41335ce",
      "text": "CDC and other agencies publicly reported and investigated rare myocarditis/pericarditis signals after mRNA vaccination (mid‑2021)",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "f86973e2-e5e2-4a44-8d3b-b1ac27a7a363",
      "text": "Ongoing clinical trials and phased authorizations for children and boosters (e.g., Pfizer EUA for 5–11 on Oct 29, 2021)",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "90b22975-ed2b-4f69-8b5a-cd5cb7dcc199",
      "text": "Initial U.S. authorizations delivered under Emergency Use Authorization (EUA) rather than full licensure (December 2020 onward)",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "11f79298-b8f6-4408-85b4-786037d03770",
      "text": "Public guidance describing mRNA COVID-19 vaccines as a new type of vaccine (CDC explainer updated Nov 2021)",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "f6e52c00-e977-4d1c-89dc-fdc5994145a0",
      "text": "Gazprom announced it could exempt rebel‑held Donetsk and Luhansk areas from Ukraine’s main gas contract and effectively supply those territories.",
      "date": "2015-02-26 00:00:00"
    },
    {
      "id": "3d86324e-cea3-467d-af95-8d4a16e21008",
      "text": "International monitors and humanitarian agencies reported acute winter fuel and heating shortages in parts of Donbas after 2014 fighting, generating local appeals for external assistance.",
      "date": "2014-10-02 00:00:00"
    },
    {
      "id": "a0dbb5ae-1757-4cce-a858-7b96b56b2be4",
      "text": "Crimean authorities nationalised local energy company Chornomornaftohaz after Russia’s 2014 annexation of Crimea.",
      "date": "2014-03-17 00:00:00"
    },
    {
      "id": "eb6a35a6-a8a8-4668-aaf2-04d473829da9",
      "text": "Earlier major Russia–Ukraine gas disputes (notably the 2009 cutoff) established a pattern of Russia using gas supply as leverage in relations with Ukraine and Europe.",
      "date": "2009-01-24 00:00:00"
    },
    {
      "id": "1966df90-c4a2-4ffa-9b32-2006f7a4755b",
      "text": "Separatist leaders in Donetsk and Luhansk declared independence and publicly requested closer ties / assistance from Russia (including calls to join Russia) during spring 2014.",
      "date": "2014-05-12 00:00:00"
    },
    {
      "id": "638c9182-29b4-482e-bcd1-514fdf6e8a35",
      "text": "Trump publicly admonishes Putin — 'Vladimir, STOP!' after a deadly Kyiv strike",
      "date": "2025-04-24 00:00:00"
    },
    {
      "id": "b5d6f9f2-ce51-4cef-9cfe-4437807d1546",
      "text": "High-profile visit of European/Western leaders to Kyiv (May 10, 2025)",
      "date": "2025-05-10 00:00:00"
    },
    {
      "id": "ce75fd3a-e456-4e22-abde-8e5ee4b3f330",
      "text": "Seychelles experienced a COVID-19 surge despite very high vaccination coverage, prompting WHO review of the data",
      "date": "2021-05-11 00:00:00"
    },
    {
      "id": "e2efdd4f-6c5f-4755-b476-6368f4ecdcfe",
      "text": "Israeli studies and policy in July 2021 showed waning protection of two-dose BNT162b2 and led Israel to authorize booster (third) doses",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "9c8c09c1-4d07-42bb-9c2b-213321540a92",
      "text": "CDC reversed earlier guidance and in late July 2021 recommended fully vaccinated people wear masks indoors in areas of substantial or high transmission",
      "date": "2021-07-27 00:00:00"
    },
    {
      "id": "3ce707f4-2468-4911-aec9-34ed01947d75",
      "text": "Release of IPCC AR6 Working Group I report (Climate Change 2021: The Physical Science Basis)",
      "date": "2021-08-09 00:00:00"
    },
    {
      "id": "097111e8-9746-4413-8f32-bcc2a3892718",
      "text": "Announcement that solar minimum occurred December 2019 and start of Solar Cycle 25 (NASA/NOAA communications)",
      "date": "2019-12-24 00:00:00"
    },
    {
      "id": "d625fbba-1849-4021-8450-2020a5c3339b",
      "text": "Publication and press coverage of NOAA/Science analysis challenging the 'global warming hiatus' (Karl et al. / June 2015)",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "5570571f-ad91-4a14-a37c-c1f5c9bb4425",
      "text": "Large-scale online spread and patient self-medication episode around fenbendazole in South Korea (widely reported as the 'fenbendazole scandal' affecting cancer patients).",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "e8a88891-6162-4dfc-a372-3e1ee7789383",
      "text": "Public statements by Russian officials (including Foreign Minister Sergey Lavrov) after Crimea asserting Russia did not violate the Budapest Memorandum / offering narrow readings of its obligations",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "360108f5-5936-45ab-9e49-a18ba6c9caba",
      "text": "Academic and policy analyses (post‑2014) arguing the Budapest Memorandum is politically binding but legally ambiguous / not a treaty-level guarantee",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "a924f04b-a407-4779-9552-066202edb258",
      "text": "Russia blocked transit of Ukrainian goods and imposed extra border controls in 2014, disrupting shipments to third countries",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "8f6c4504-6a6d-432b-8ce4-6eda6caf5127",
      "text": "Ukraine GDP contracted ~6.8% in 2014 amid the Crimea annexation and eastern conflict (IMF/official statistics reporting)",
      "date": "None"
    },
    {
      "id": "f74503b4-acdd-4cf7-bf1b-4191fcb103e6",
      "text": "Multilateral economic assessments (World Bank / EBRD / IMF) in 2014–2015 attributing Ukraine’s deep 2014–15 recession to conflict, loss of territory, banking crisis and trade disruptions",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "cf7e36f9-41c5-4952-98ac-ce46ab5d8706",
      "text": "Ukraine government announced a moratorium on repayment of a $3 billion Eurobond held by Russia.",
      "date": "2015-12-18 00:00:00"
    },
    {
      "id": "f11e8a14-8269-4f0f-8869-ec7f1fb098b9",
      "text": "The 2015 Greek debt crisis and high-profile standoffs with EU creditors earlier in 2015 (July 2015) increased German public and political sensitivity to sovereign default risks.",
      "date": "2015-07-05 00:00:00"
    },
    {
      "id": "7aebbdb1-b25b-4005-9153-51782d457191",
      "text": "23 March 2025 BBC coverage of community protests against the proposed 2,700‑acre East Pye solar farm in Norfolk, UK (residents citing impacts to farmland, wildlife and local character)",
      "date": "2025-03-23 00:00:00"
    },
    {
      "id": "1617ea47-79ab-48fc-888e-328bfca7bc67",
      "text": "2014 Frontiers in Environmental Science paper 'Solar panels reduce both global warming and urban heat island' (Masson et al.) concluding rooftop PV can reduce cooling demand and in some cases reduce UHI",
      "date": "2014-06-04 00:00:00"
    },
    {
      "id": "8884e3f5-3f6c-40fb-bfb1-4a0b57f4d2b4",
      "text": "FDA final rule: Over‑the‑counter drug products containing colloidal silver ingredients or silver salts declared not generally recognized as safe and effective.",
      "date": "1999-08-17 00:00:00"
    },
    {
      "id": "9373fba0-2e0d-4d7e-96d5-8bcf4917d4e8",
      "text": "Widespread clinical use of silver‑based products (e.g., nanocrystalline silver dressings like ACTICOAT) for wound care and device coatings documented in medical literature (early 2000s).",
      "date": "2004-04-24 00:00:00"
    },
    {
      "id": "bf2df80d-2a61-4e41-a0d7-dc5f45bf0de5",
      "text": "Publication of the Great Barrington Declaration advocating 'focused protection' instead of broad restrictions",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "4f0d95da-c760-4882-b99e-b93c7996f4f7",
      "text": "UK government's early 'herd immunity' / mitigation messaging under Prime Minister Boris Johnson",
      "date": "2020-03-16 00:00:00"
    },
    {
      "id": "0f190e11-1033-4f4f-bbfa-8bc82e08c298",
      "text": "2014 ban and export‑freeze context (post‑Crimea) on Ukrainian arms sales to Russia, and related SIPRI footnotes noting many deliveries had been completed before the ban.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "c73e787d-e802-4efc-847c-2e925026c04e",
      "text": "Human Rights Watch reported exhumation of a mass grave in Sloviansk (eastern Ukraine).",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "c8b03c27-70ed-4cc4-abdf-0b332e2df9f5",
      "text": "OSCE Special Monitoring Mission published observations about unmarked graves found near Komunar / Nyzhnia Krynka (Donetsk region).",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "6c536418-00e2-4a4c-830f-f6f6d96e6212",
      "text": "Launch of the government \"Eat Out to Help Out\" dining subsidy scheme and public encouragement to return to restaurants (August 2020).",
      "date": "2020-08-24 00:00:00"
    },
    {
      "id": "cc9da660-3aa5-478b-a33f-f2375ea97c0d",
      "text": "Publication of the Great Barrington Declaration advocating \"focused protection\" and arguing against broad restrictions (4 October 2020).",
      "date": "2020-10-24 00:00:00"
    },
    {
      "id": "109ca1ab-5d13-4ab6-aee4-4f2533791c9c",
      "text": "Prime Minister Boris Johnson said the UK was \"past the peak\" of the outbreak in official briefings.",
      "date": "2020-05-24 00:00:00"
    },
    {
      "id": "d2df8235-d61a-4ec7-bb0b-676cd6291b45",
      "text": "Senior UK scientists publicly discussed \"herd immunity\" as part of early pandemic strategy (Sir Patrick Vallance interview/comments).",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "26a229b9-735a-4968-a540-4738197bdf77",
      "text": "Stanford press release/clinical trial announcement (2010) recruiting mitochondrial‑disorder patients to study vaccine responses",
      "date": "2010-10-24 00:00:00"
    },
    {
      "id": "f8a77d22-871c-46b3-a5cf-dc89b4e6fcf4",
      "text": "Government concession and media coverage of the Hannah Poling VICP matter (discussed in NEJM and major outlets)",
      "date": "2008-05-24 00:00:00"
    },
    {
      "id": "8e47d9e5-3537-4b6d-bc47-83cbb5ffc751",
      "text": "Scientific American and other national outlets published explanatory pieces about the Poling case and its limits",
      "date": "2008-04-24 00:00:00"
    },
    {
      "id": "c4938d22-e6a5-4ada-bc6d-52b2c6e18343",
      "text": "1999–2000 public health statements recommending removal of thimerosal from some vaccines",
      "date": "1999-07-24 00:00:00"
    },
    {
      "id": "25402d13-ecb6-491b-941f-43d94652249e",
      "text": "1993 withdrawal of the MMR vaccine (Urabe AM9 mumps strain) in Japan after reports of aseptic meningitis",
      "date": "1993-04-24 00:00:00"
    },
    {
      "id": "45ad507c-58bc-4146-b0bc-1acde214aa1a",
      "text": "2010 post‑licensure findings of a small increased risk of febrile seizures after MMRV (leading to CDC guidance to consider separate MMR and varicella shots)",
      "date": "2010-06-28 00:00:00"
    },
    {
      "id": "a364ab95-d103-44fe-9640-939150b981a0",
      "text": "UK/academic analyses (early 2022) and UKHSA/NEJM reports showing substantially reduced vaccine effectiveness against symptomatic infection with the Omicron variant and rapid waning after two doses.",
      "date": "2022-03-02 00:00:00"
    },
    {
      "id": "43e5222a-3087-4d0d-be64-dd7e1ebdc149",
      "text": "UKHSA published the COVID-19 Vaccine Surveillance Report (Week 4) including unadjusted case rates by vaccination status that showed higher case rates in vaccinated people for some age groups.",
      "date": "2022-01-28 00:00:00"
    },
    {
      "id": "93c996d4-1901-4294-800a-e38c0d1eb1c3",
      "text": "FDA issued an Emergency Use Authorization (EUA) for chloroquine and hydroxychloroquine for donated supplies for hospitalized COVID‑19 patients",
      "date": "2020-03-28 00:00:00"
    },
    {
      "id": "f29ae353-3af8-40de-a699-50235d37af51",
      "text": "EU decision to finance and supply lethal military assistance (European Peace Facility decisions, Feb–Mar 2022)",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "cbc5e26f-f8e9-410f-8029-a182c58e7f57",
      "text": "Visit of EU Commission President Ursula von der Leyen and HR/VP Josep Borrell to Kyiv",
      "date": "2022-04-08 00:00:00"
    },
    {
      "id": "156ad354-9ff7-4d94-8f13-dca5079d271e",
      "text": "Emerging reports and media coverage of myocarditis/pericarditis following mRNA COVID‑19 vaccination (April–May 2021), including Israeli surveillance data.",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "c589d99a-2705-45ba-81b4-d443003520f5",
      "text": "Publication of Ogata et al. pilot study detecting SARS‑CoV‑2 vaccine antigen (spike) in plasma of mRNA‑1273 (Moderna) recipients.",
      "date": "2021-05-20 00:00:00"
    },
    {
      "id": "2b508070-1d24-4290-aab2-515adf41a249",
      "text": "Multiple European countries temporarily suspended use of the AstraZeneca vaccine in mid-March 2021 while authorities investigated clotting reports.",
      "date": "2021-03-15 00:00:00"
    },
    {
      "id": "40bbd2b5-4d40-478f-a8e7-5b457a2b923c",
      "text": "Office for National Statistics (ONS) Freedom of Information note and related discussion in June 2021 about deaths reported around the time of COVID-19 vaccination and the complexity of linking those deaths to vaccination.",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "ea8e2e5a-a9dd-4526-a2cd-4a0f2c009522",
      "text": "MHRA and GOV.UK Yellow Card publications and vaccine-safety updates (May 2021) that published cumulative Yellow Card report summaries and guidance on interpreting them.",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "26917ce6-9219-482f-a419-ecda95079e6b",
      "text": "MHRA press release (7 April 2021) concluding a possible link between the AstraZeneca COVID-19 vaccine and extremely rare blood clots (CVST with thrombocytopenia).",
      "date": "2021-04-07 00:00:00"
    },
    {
      "id": "5b6f1824-6080-47bb-9bd9-545f522d2563",
      "text": "Moderna U.S. patent US 9,587,003 (containing SEQ ID NO:11652) granted and publicly available (patent issued March 2017)",
      "date": "2017-03-24 00:00:00"
    },
    {
      "id": "abfc4d83-1cae-4bb8-9238-c8a5c9338043",
      "text": "Moderna publicly announced rapid efforts to make an mRNA vaccine for the novel coronavirus and received funding/collaboration in January 2020 (CEPI/NIH coverage)",
      "date": "2020-01-23 00:00:00"
    },
    {
      "id": "bd3f8693-6a70-457b-9472-051a0ee3123a",
      "text": "World Bank report showing uneven poverty recovery and slow household welfare rebound (2016–2019 analysis)",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "cc5c6626-cda2-4e18-b170-a6217c208baa",
      "text": "Transparency International/other assessments showing persistent corruption and weak governance (CPI 2019 coverage)",
      "date": "2020-01-23 00:00:00"
    },
    {
      "id": "8b090eeb-8bde-48d8-9cb9-d49beac3a162",
      "text": "Sharp economic contraction in 2014–2015 after Crimea annexation and eastern conflict (World Bank reporting)",
      "date": "None"
    },
    {
      "id": "48ffe91e-06f2-4568-87a2-8fff684bd1d7",
      "text": "EU–Ukraine Association Agreement (DCFTA) provisionally applied from 1 January 2016",
      "date": "2016-01-01 00:00:00"
    },
    {
      "id": "04a20f10-9af8-461e-9f75-106717eddda0",
      "text": "Statement by Crimea’s chief rabbi Binyamin Volf at a November 2017 Chabad conference (badge reading 'Sevastopol, Russia')",
      "date": "2017-11-23 00:00:00"
    },
    {
      "id": "1bfed961-5720-4356-b6f4-d95c98c664e8",
      "text": "Publicized meetings between World Jewish Congress leadership (Ronald Lauder) and Russian officials, including meetings at the Kremlin",
      "date": "2016-04-19 00:00:00"
    },
    {
      "id": "e1bc5dee-6601-4bfc-b73b-ae86f55603ff",
      "text": "2014 controversy: Ukrainian Jewish leaders criticized visits/statements by top rabbis to Crimea",
      "date": "2014-07-23 00:00:00"
    },
    {
      "id": "d7f28da1-8d0b-41af-bb67-719a1bf0eec9",
      "text": "Official communications and data about breakthrough infections and transmission by vaccinated people (e.g., CDC director statements and news coverage in early August 2021)",
      "date": "2021-08-05 00:00:00"
    },
    {
      "id": "419233ba-dddf-45b5-b937-b0523f88b523",
      "text": "Kyiv city council and local authorities publicly discussing and approving additional allocations/guarantees to cover Eurovision hosting costs",
      "date": "2017-02-24 00:00:00"
    },
    {
      "id": "ed264221-5900-4c3b-a69d-1d1e819dfa15",
      "text": "High-profile resignations from the Eurovision organising team amid disputes over transparency and finances",
      "date": "2017-03-07 00:00:00"
    },
    {
      "id": "8742072b-178d-4ccf-8e74-9e3c57ed6936",
      "text": "FDA final guidance on enforcement discretion for certain N‑acetyl‑L‑cysteine (NAC) products, which received industry and media attention.",
      "date": "2022-08-01 00:00:00"
    },
    {
      "id": "3a53f701-0555-4825-9fb9-8eb7b3e437ef",
      "text": "Registration/publication of randomized trial activity and small clinical studies evaluating NAC for severe COVID‑19 (trial protocol/early trial entries 2021).",
      "date": "2021-02-20 00:00:00"
    },
    {
      "id": "22c5464d-e954-45ee-870b-a2acd92f8c45",
      "text": "CDC MMWR report of anaphylaxis after first doses of Pfizer-BioNTech COVID-19 vaccine",
      "date": "2021-01-06 00:00:00"
    },
    {
      "id": "590263df-0e92-4dd7-990d-600412ace6e1",
      "text": "CDC/ACIP recommendation and CDC endorsement for Pfizer pediatric vaccine for ages 5–11 (Nov 2, 2021)",
      "date": "2021-11-02 00:00:00"
    },
    {
      "id": "e81f8871-f84e-4450-85d4-c8d87325236e",
      "text": "FDA grants full approval to Pfizer–BioNTech (Comirnaty) on Aug 23, 2021",
      "date": "2021-08-23 00:00:00"
    },
    {
      "id": "a937e249-b4d6-4608-9a79-32283b312294",
      "text": "HRSA/CDC guidance and public pages explaining COVID-19 vaccine injuries are handled under the Countermeasures Injury Compensation Program (CICP) rather than the National Vaccine Injury Compensation Program (VICP)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "17c3c702-8396-4f43-ab42-57b0cf289a97",
      "text": "April 3, 2020 CDC guidance changed to recommend cloth face coverings for the public",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "dfe43826-3357-4dfb-9662-7b175bbad4fb",
      "text": "Russian strikes reportedly hit a radioactive‑waste / radioactive source facility near Kyiv in late February 2022.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "13e1784f-2708-40cd-b623-00bac0d8e2e1",
      "text": "EU outbreak reports and guidance showing increases in hepatitis A cases across Europe (not limited to Ukraine)",
      "date": "2016-12-24 00:00:00"
    },
    {
      "id": "4ed31870-5df2-4a6f-ac03-b1ecbbd553d5",
      "text": "Large numbers of internally displaced persons (IDPs) and documented WASH challenges in Ukraine (2014–2016)",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "22c9b0d7-d0b4-4cf1-950b-75d5a717ae6e",
      "text": "IPCC Sixth Assessment Report (WG1) release summarising regional variation including land warming faster than oceans",
      "date": "2021-08-09 00:00:00"
    },
    {
      "id": "2ff61d65-2058-42e1-806a-8af448124f72",
      "text": "Pacific Northwest / Western North America extreme heat wave and record highs (June 25–30, 2021)",
      "date": "2021-06-25 00:00:00"
    },
    {
      "id": "670ac9c1-bd3a-4135-8a85-df764f9ba9b6",
      "text": "Arctic temperature record of +38°C at Verkhoyansk (measured 20 June 2020, widely reported/confirmed later)",
      "date": "2020-06-20 00:00:00"
    },
    {
      "id": "d80ca0d8-3306-445c-a9fe-e292f5a0f281",
      "text": "IPCC AR5 Summary for Policymakers (September 2013) conclusion: 'It is extremely likely that human influence has been the dominant cause of the observed warming since the mid-20th century.'",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "621d1a29-309b-45ac-820e-e5b6c27b4f53",
      "text": "Media reports and clips referenced proposals to replace universal subsidies with targeted assistance (compared by some reports to 'food-stamp' style programs)",
      "date": "2017-08-24 00:00:00"
    },
    {
      "id": "614de7a2-fe04-47d7-99a2-bd83572fe921",
      "text": "Analyses and reports documenting that Ukraine was used as a transit or logistical route by foreign fighters bound for Syria/Iraq (The Soufan Group foreign fighters updates, 2014–2015)",
      "date": "2015-09-24 00:00:00"
    },
    {
      "id": "1909b66d-439b-4cf2-9305-d96c12a1f137",
      "text": "European Parliament/public sources flagged presence of foreign Islamist volunteers or sympathizers in eastern Ukrainian conflict zones (July 2015 references to press reporting)",
      "date": "2015-07-27 00:00:00"
    },
    {
      "id": "02748681-3f84-4280-a169-627e0e591319",
      "text": "Ukrainian Security Service (SBU) detained and expelled several foreign nationals described as Islamic State supporters (SBU press reports)",
      "date": "2016-04-27 00:00:00"
    },
    {
      "id": "9a3741b7-9194-44e7-8593-dd9623d85773",
      "text": "Crimean official Ruslan Balbek publicly claimed there are ISIS training camps in Kherson (southern Ukraine)",
      "date": "2016-07-24 00:00:00"
    },
    {
      "id": "0600aa2c-a25e-46f1-9217-9073c7c4a8c2",
      "text": "US decision to withdraw troops from northern Syria (announced early October 2019) and the ensuing Turkish incursion drew rapid regional and global attention",
      "date": "2019-10-06 00:00:00"
    },
    {
      "id": "dfa1261d-e732-4e6a-98fb-661c11837d82",
      "text": "US impeachment inquiry into President Trump after the Ukraine whistleblower shifted US political and media attention away from foreign-policy issues such as Crimea",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "785426c5-8fb1-49d8-96d3-ca5cc2e642fb",
      "text": "UK prorogation (suspension) of Parliament by Prime Minister Boris Johnson and the constitutional crisis around it in late August–September 2019",
      "date": "2019-08-28 00:00:00"
    },
    {
      "id": "f17c6a8e-99aa-4004-b2f7-bddcb8a8cf3c",
      "text": "Public arrival and frontline deployment of US-supplied HIMARS in Ukraine was widely reported (first systems arrived in late June 2022).",
      "date": "2022-06-23 00:00:00"
    },
    {
      "id": "76dd6ad1-96b1-4e31-af7e-dc4f3e810a68",
      "text": "Russian Ministry of Defence later claimed it had destroyed four HIMARS launchers between July 5–20, 2022.",
      "date": "2022-07-22 00:00:00"
    },
    {
      "id": "2bdc17db-1fc4-4641-83a8-1df42a5bc5f5",
      "text": "WHO SAGE identifies vaccine hesitancy and misinformation as major threats (working group/report)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "e401473b-9e1d-4fef-bad6-dcf3195d6dd1",
      "text": "IARC classification of formaldehyde as ‘carcinogenic to humans’ (Group 1)",
      "date": "2004-06-24 00:00:00"
    },
    {
      "id": "227d7b44-4791-4e82-aca0-1a384e087533",
      "text": "1999 US Public Health Service and American Academy of Pediatrics recommend removal of thimerosal from many childhood vaccines as a precaution",
      "date": "1999-04-24 00:00:00"
    },
    {
      "id": "d27443a0-c153-4dd5-a58f-873c1c8c288c",
      "text": "UN/UNICEF warning that tens or hundreds of thousands of children in eastern Ukraine are threatened by landmines and explosive remnants of war",
      "date": "2017-12-21 00:00:00"
    },
    {
      "id": "81465d6c-17c2-4277-a0cb-89b8c3188ee1",
      "text": "Mine Action Review report 'Clearing the Mines 2017' documents extensive contamination and cites OHCHR findings that Ukrainian armed forces and armed groups continued to lay landmines (including antipersonnel types) during 2016",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "0e030dbe-883c-45fb-aeb4-a79d3e1efada",
      "text": "Bellingcat investigation & reporting on risks in Donbas ('Donbas: A Ticking Toxic Time Bomb') highlighting flooded and unmanaged minefields and environmental hazards in former coal-mining areas",
      "date": "2017-03-30 00:00:00"
    },
    {
      "id": "5c4a33d0-ae11-4848-ab7f-92b7f6656e0e",
      "text": "Minsk II text included provisions on decentralization / 'special status' for Donbas that Poroshenko accepted to negotiate.",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "dc91dcdc-d82f-4f28-9d6e-a9132909f1b2",
      "text": "Poroshenko announced a unilateral ceasefire (June 2014) and subsequent pauses/cessations of offensive actions.",
      "date": "2014-06-20 00:00:00"
    },
    {
      "id": "fd99e615-cd03-41e8-ba27-8d4905da0e07",
      "text": "Poroshenko and Putin met and were photographed/filmed together at international talks (including February 2015 Minsk meetings and earlier encounters such as the June 2014 D-Day meeting).",
      "date": "None"
    },
    {
      "id": "0e2d0038-14e7-4b49-8a47-5d83cae03712",
      "text": "Japan reports and temporary pauses after discovery of foreign/black particles in some Moderna vaccine vials",
      "date": "2021-09-17 00:00:00"
    },
    {
      "id": "2ab59778-fd56-4c7e-a5a0-f41cd08542da",
      "text": "CDC/ACIP public acknowledgement and MMWR report of increased myocarditis cases after mRNA COVID-19 vaccination",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "f78b6f97-84ba-4753-817e-24578857cf09",
      "text": "Court dispute and media coverage over FDA’s proposed slow timetable and subsequent judge’s order to accelerate release of Pfizer vaccine documents",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "c373bead-d3a8-4bc7-a62f-cb894eb1cb73",
      "text": "CDC Health Advisory and public warnings (late August 2021) about a sharp rise in ivermectin misuse, poisonings, and related emergency visits.",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "fabedc29-2132-4d32-a570-e39a997b3674",
      "text": "OSCE armoured vehicle damaged by an explosion near Pryshyb (one monitor killed, two wounded)",
      "date": "2017-04-23 00:00:00"
    },
    {
      "id": "e55109e1-cff9-4fb1-9079-03557de996f5",
      "text": "Publication of the Harvard Pilgrim (ESP:VAERS) final report (AHRQ grant) finding that automated surveillance suggested many adverse events were not reported to passive VAERS.",
      "date": "2011-04-24 00:00:00"
    },
    {
      "id": "ce012d51-5eb4-4a33-978b-a45c1c33b648",
      "text": "Congressional/public pressure: Rep. Bill Posey’s 2019 public questioning (and associated media coverage) that highlighted the multi‑billion dollar VICP figure and prompted scrutiny/discussion online.",
      "date": "2019-10-24 00:00:00"
    },
    {
      "id": "2a3da052-2cc1-451a-ad49-b30e48ed2235",
      "text": "OSCE SMM observed heavy weapons and armoured vehicles in violation of withdrawal lines (e.g., tanks near Avdiivka; a surface‑to‑air missile system near Hannivka) during the late‑January 2017 escalation.",
      "date": "2017-01-29 00:00:00"
    },
    {
      "id": "beaa5346-30a8-4eec-8020-92b8e46b9061",
      "text": "Ukrainian authorities declared a state of emergency in Avdiivka and organised evacuations as civilians were left without power, heating and water following the shelling.",
      "date": "2017-01-31 00:00:00"
    },
    {
      "id": "e5df66d3-79dd-4a90-b930-61f103dd1f7c",
      "text": "Multiple news outlets and local reporting documented both Ukrainian forces and pro‑Russian separatists accusing each other of initiating the offensive around the Avdiivka 'industrial zone' (Almaz‑2) and making competing claims of tactical gains.",
      "date": "2017-01-31 00:00:00"
    },
    {
      "id": "58c36d61-3ba0-41e4-8f19-73255bc7b115",
      "text": "Peer‑reviewed research and industry reports documented that Liquidambar (sweetgum) seedpods contain measurable shikimic acid and could be an alternative feedstock for industrial extraction (published research e.g., Appl Biochem Biotechnol, Epub May 27, 2010).",
      "date": "2010-05-27 00:00:00"
    },
    {
      "id": "8f73c558-2be2-48cc-a73f-d9f7424080ad",
      "text": "Mainstream coverage during flu/Tamiflu shortages (2005) highlighted that shikimic acid—traditionally sourced from star anise—was a critical precursor for manufacturing Tamiflu, prompting searches for alternative natural sources.",
      "date": "2005-10-21 00:00:00"
    },
    {
      "id": "aa16c46d-0852-4634-a054-79960c11b758",
      "text": "Zozulya was included in Ukraine's squad for the March 24, 2017 Croatia qualifier but did not play in the match.",
      "date": "2017-03-24 00:00:00"
    },
    {
      "id": "4c1758ec-337d-4cbe-86fa-8244d71c7d7e",
      "text": "Rayo Vallecano fans publicly protested and the club cancelled Zozulya's loan from Real Betis after accusations he had neo‑Nazi links.",
      "date": "2017-02-01 00:00:00"
    },
    {
      "id": "7c17e2ac-c892-4e72-866b-714bec4a49a2",
      "text": "Rapid Trident 2021 multinational land exercise in Ukraine (≈6,000 personnel) with explicit COVID-19 mitigation measures",
      "date": "2021-09-20 00:00:00"
    },
    {
      "id": "c6852aab-9969-47b4-b03d-a5a8020adfe1",
      "text": "Sea Breeze 2021 multinational maritime exercise in the Black Sea (June–July 2021) involving thousands of personnel, ships and aircraft",
      "date": "None"
    },
    {
      "id": "b18bf41c-46b5-457c-a9b4-f8ac07e36180",
      "text": "High-profile military COVID-19 outbreak: USS Theodore Roosevelt outbreak and ship quarantine (April 2020)",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "7fffa540-df86-4301-9664-fe0107c83f3a",
      "text": "Post‑invasion 'derussification' actions, including Kyiv renaming nearly 100 streets and removing Soviet/Russian monuments as part of wider cultural de‑Russification.",
      "date": "2022-08-25 00:00:00"
    },
    {
      "id": "29d4087d-19b7-4267-bf79-8789d90e480a",
      "text": "Kyiv City Council imposed a moratorium on the public use of Russian‑language cultural products (books, songs, films, theatrical works) in the capital.",
      "date": "2023-07-13 00:00:00"
    },
    {
      "id": "73dadb3d-04c0-4928-8c72-5c56df523380",
      "text": "Verkhovna Rada adopted the 2019 law 'On ensuring the functioning of Ukrainian as the state language' strengthening use of Ukrainian in public life.",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "59013a8a-02c8-478e-9214-3f1e44cc7bb8",
      "text": "President Zelensky imposed sanctions and broadcasting suspensions on three pro‑Russian TV channels (112 Ukraine, NewsOne, ZIK).",
      "date": "2021-02-02 00:00:00"
    },
    {
      "id": "107d359d-42ec-4e77-8d57-506e01d2d46a",
      "text": "Major criminal/civil enforcement actions against drugmakers for improper marketing (example: Novartis pleads guilty and agrees to pay $422.5M for off‑label marketing, Oct 2010)",
      "date": "2010-10-24 00:00:00"
    },
    {
      "id": "0f501262-611a-4a6e-9a89-2f9d95963b85",
      "text": "Publication of DSM‑5 (May 2013) which changed ADHD diagnostic criteria (e.g., raising the age of onset criterion from 7 to 12 and adjusting symptom thresholds)",
      "date": "2013-05-24 00:00:00"
    },
    {
      "id": "d0f5121a-6a67-4dd9-b3f3-d97ff6bc7c84",
      "text": "Itajaí city government announcement and distribution program for ivermectin (mayor/prefeitura public rollout)",
      "date": "2020-07-24 00:00:00"
    },
    {
      "id": "0fc29109-1260-4ee9-acd9-5213faa70a4f",
      "text": "Itajaí municipal health department 'Nota de esclarecimento - tratamentos profiláticos' (clarification note) revealing rapid drop-off in adherence to the distributed ivermectin regimen",
      "date": "2021-01-21 00:00:00"
    },
    {
      "id": "0210aeca-dbc0-42c3-8104-a3c02981d594",
      "text": "July 5, 2021 media reports (based on Israeli data) that Pfizer vaccine protection against infection had declined amid Delta variant spread, while still protecting strongly against severe disease.",
      "date": "2021-07-05 00:00:00"
    },
    {
      "id": "84bdb65b-0a10-4d48-b2bb-f78fad599d25",
      "text": "Sept 24, 2021 CDC/FDA authorizations and public communications expanding booster recommendations while acknowledging breakthrough infections and waning immunity.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "96bab82b-1f4e-4ec3-85c9-55062690b2a1",
      "text": "March 19, 2020 livestream interview where Fauci discussed antibody-dependent enhancement (ADE) as a theoretical vaccine safety concern during early COVID-19 vaccine development.",
      "date": "2020-03-19 00:00:00"
    },
    {
      "id": "e18fbea4-d7f2-4a5f-99f5-217aa876360e",
      "text": "Earlier documented exhumations/mass‑grave discoveries in Donbas (Sloviansk mass grave exhumed)",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "345b3179-253e-469f-89aa-87e71b1ea471",
      "text": "Visible cemetery work (small tractor stuck in mud and manual removal of soil) at the Sumy cemetery",
      "date": "2015-11-24 00:00:00"
    },
    {
      "id": "07b997fc-953c-401c-920f-f2dc1d0271e3",
      "text": "Publication of a 2017 pilot study showing short‑term tinnitus reduction after intranasal oxytocin (peer‑reviewed)",
      "date": "2017-09-21 00:00:00"
    },
    {
      "id": "b9810a46-1616-44e1-9b2b-e9684548ec05",
      "text": "FDA clearance and media coverage in 2023 of Lenire (a novel device for treating tinnitus), elevating public interest in new tinnitus treatments",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "f2e7cf6a-6482-4f9b-a2c8-98e89811400c",
      "text": "Surge of TikTok posts and hashtag activity (#tinnitushelp) in early–mid 2024 promoting quick fixes, including nasal sprays/inhalers",
      "date": "2024-05-24 00:00:00"
    },
    {
      "id": "cbac83c2-8c95-46bd-a630-356ea7d83495",
      "text": "Public availability of Phytonadione (vitamin K) package insert listing polysorbate 80 (DailyMed / FDA label; label file updated Jan 19, 2017).",
      "date": "2017-01-19 00:00:00"
    },
    {
      "id": "f2812f10-9f02-449c-be8a-d14b8f7f31b0",
      "text": "IPCC Sixth Assessment WG1 (AR6) press release and summary (August 2021) asserting that human influence has unequivocally warmed the climate system.",
      "date": "2021-08-09 00:00:00"
    },
    {
      "id": "1e3a38df-684e-48e2-a62e-3b767bade3aa",
      "text": "Nature Geoscience and related studies (circa 2017) reporting large uncertainties about whether airborne mineral dust from deserts has a net warming or cooling radiative effect.",
      "date": "2017-01-24 00:00:00"
    },
    {
      "id": "bd09c03f-ffcf-424d-b8b2-a9067f24572f",
      "text": "Zhu et al. (2016) 'Greening of the Earth and its drivers' (Nature Climate Change) documenting global increases in vegetation, including expansion in some dry regions, largely attributed to CO2 fertilization and land-use changes.",
      "date": "2016-09-24 00:00:00"
    },
    {
      "id": "9ea7be29-7ac0-4db4-a44a-77f7e1b4a49d",
      "text": "NASA/MODIS public data and Earth Observatory coverage showing deserts as among the highest-reflectivity (high albedo) land surfaces.",
      "date": "2002-07-10 00:00:00"
    },
    {
      "id": "0b66de36-7adf-46d0-b0d8-a3e6ddacc929",
      "text": "2017 peer-reviewed modelling studies and simulations proposing desert-focused geoengineering or land-surface modification (e.g., irrigating deserts or increasing desert albedo) to alter global/regional climate.",
      "date": "2017-08-24 00:00:00"
    },
    {
      "id": "75f3a1a3-be94-48ab-a200-75e258aa57cb",
      "text": "April 2017 reporting of new research (covered by AIDSMap) about long-term nitrate inhalant exposure and cancer risk that noted elevated cancer signals in some subgroups.",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "bc2852f1-4c0d-4924-a3e8-de82d6d55f58",
      "text": "June 1994 coverage and activism (New York Native / related reports) documenting calls for research into a poppers–Kaposi's sarcoma connection (NIDA-era attention to the hypothesis).",
      "date": "1994-06-24 00:00:00"
    },
    {
      "id": "a5c174fb-00f8-4888-bff2-2b22c08b6bb2",
      "text": "Russian Ministry of Defense announced first operational use of the Kh-47M2 'Kinzhal' hypersonic missile, claiming it destroyed an underground Ukrainian ammunition depot in Delyatyn.",
      "date": "2022-03-18 00:00:00"
    },
    {
      "id": "1ab30c76-9d70-45bb-a0c9-9ba89ab29490",
      "text": "President Joe Biden publicly acknowledged Russia's use of hypersonic missiles, saying the weapon was \"a consequential weapon... almost impossible to stop,\" as reported by news outlets in mid‑late March 2022.",
      "date": "2022-03-21 00:00:00"
    },
    {
      "id": "6d3e772d-df2c-41fc-95f9-6ee4c1785af0",
      "text": "Publication showing vaccine‑derived spike antigen detectable in plasma after mRNA vaccination (Ogata et al., Clinical Infectious Diseases)",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "0b394128-bfde-44cf-9e64-cb31e8b2af0d",
      "text": "Publication of an in vitro study showing nattokinase degrades SARS‑CoV‑2 spike protein (Tanikawa et al., Molecules)",
      "date": "2022-08-24 00:00:00"
    },
    {
      "id": "eb90c2b0-f999-48b8-a156-260fc24dc989",
      "text": "Publication reporting persistence of SARS‑CoV‑2 S1 protein in CD16+ monocytes up to 15 months in PASC patients (Patterson et al., Frontiers in Immunology)",
      "date": "2022-01-10 00:00:00"
    },
    {
      "id": "438d9319-2731-4376-8c2d-4a97f1f00888",
      "text": "Judge Mark Pittman ordered the FDA to accelerate public release of Pfizer vaccine trial documents (court order reported Jan 7, 2022)",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "b93daa23-81e7-456d-94d1-02ee6cb323d7",
      "text": "Public availability of large troves of Pfizer documents via the PHMPT/FOIA process (public repository of Pfizer documents made accessible in 2022)",
      "date": "None"
    },
    {
      "id": "6b5be610-f1fa-4824-913d-7a70777884de",
      "text": "UN General Assembly Resolution 68/262 reaffirming Ukraine's territorial integrity",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "aec2046c-231c-4694-b2e3-e33c096f3bbd",
      "text": "Ukrainian government regains control of Mariupol (June 2014)",
      "date": "2014-06-13 00:00:00"
    },
    {
      "id": "b275260a-c1dc-4478-979c-ce4b9174a3ee",
      "text": "Ukrainian forces retake Sloviansk and Kramatorsk from pro‑Russian separatists",
      "date": "2014-07-05 00:00:00"
    },
    {
      "id": "93c43d4a-fd19-4e65-988b-70a133b08499",
      "text": "Minsk II ceasefire agreement and delineation of frontlines (February 2015)",
      "date": "2015-02-12 00:00:00"
    },
    {
      "id": "66aeb4da-a41f-4447-b443-d3adc2c80766",
      "text": "OSCE SMM: patrol vehicles and civilians hit by fire in eastern Ukraine (multiple incidents, Sept 2014 example)",
      "date": "2014-09-15 00:00:00"
    },
    {
      "id": "a30a7def-f57c-446a-bba8-1523343fe253",
      "text": "Amnesty International reporting on indiscriminate attacks and civilian deaths in Donbas",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "43190cf0-9e6b-4ae2-a7b4-2194945580eb",
      "text": "Human Rights Watch report: unguided Grad rockets killed civilians in Donetsk suburbs",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "9f5d5685-ecd4-4a38-8303-f36d9c747912",
      "text": "Volnovakha bus attack — passenger bus hit near checkpoint, 12 killed",
      "date": "2015-01-13 00:00:00"
    },
    {
      "id": "2c93e391-b1d7-4f0f-b9a7-0f1628f74cb9",
      "text": "Energoatom presents national report at the IAEA General Conference noting diversification of fuel supply and construction of centralized spent fuel storage (IAEA General Conference coverage)",
      "date": "2018-09-18 00:00:00"
    },
    {
      "id": "140e89c6-1a07-409a-ab9a-52ec6b34998a",
      "text": "Country profile and industry analyses documenting Ukraine’s historical reliance on Russian fuel-cycle services (conversion/enrichment) and stated efforts to diversify suppliers",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "5d33b07c-4552-4834-89af-6820b593c9ef",
      "text": "Japan suspended ~1.63 million Moderna vaccine doses after reports of contamination in vials",
      "date": "2021-08-25 00:00:00"
    },
    {
      "id": "e5f0ac30-4bfe-4c41-80d1-ce405df9e260",
      "text": "Norwegian Medicines Agency investigated deaths of frail elderly occurring shortly after Pfizer vaccination",
      "date": "2021-01-18 00:00:00"
    },
    {
      "id": "b16aee51-f02c-4b7a-971e-f64d6361f22d",
      "text": "CDC/ACIP acknowledged increased reports of myocarditis following mRNA COVID-19 vaccination",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "22edd4f8-a427-4083-982e-d2c4008dda92",
      "text": "NOAA/NASA Solar Cycle 25 Prediction Panel preliminary forecast released",
      "date": "2019-04-05 00:00:00"
    },
    {
      "id": "318a1f17-6477-4696-9106-44c6cafb8309",
      "text": "Publication of randomized trial (Cowling et al.) reporting increased non-influenza respiratory infections in children after inactivated seasonal influenza vaccine",
      "date": "2012-03-24 00:00:00"
    },
    {
      "id": "ddfa596f-da0f-4830-a839-c04542e52164",
      "text": "NATO Readiness Action Plan (RAP) launched after Russia's 2014 actions",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "34d32d01-b9da-4558-aca2-018ef1620429",
      "text": "Public statements by NATO Secretary General Jens Stoltenberg in June 2022 urging preparation for a 'long haul'",
      "date": "2022-06-19 00:00:00"
    },
    {
      "id": "a6c3e47d-8078-4640-ae31-397e6e88ebd5",
      "text": "Decision to deploy NATO enhanced Forward Presence (eFP) battlegroups to the Baltic states and Poland",
      "date": "2017-03-24 00:00:00"
    },
    {
      "id": "0afadd85-4bc8-422d-95a9-0f0b99baaff2",
      "text": "Large NATO exercise Trident Juncture (2018) held near NATO's northern flank",
      "date": "None"
    },
    {
      "id": "865c7c98-d8e0-4383-b0a6-ccf0a86c51e9",
      "text": "Reporting in June 2018 that Crimea was expected to see a major tourism surge for summer 2018 while airlines cut flights—intense media focus on the 2018 tourist season.",
      "date": "2018-06-04 00:00:00"
    },
    {
      "id": "17ca6691-ccb7-40b4-b9a6-7145b0127e0f",
      "text": "‘Day of Crimean Resistance’ and related pro-Crimea/anti-occupation rallies and activism in Kyiv (26 February 2018 demonstrations of Kyiv-based support for Crimean Tatars and Ukrainian claims on Crimea).",
      "date": "2018-02-26 00:00:00"
    },
    {
      "id": "d8ca6006-36e6-45ea-8307-1deb0c49b00d",
      "text": "Trial/indictment proceedings in April 2018 against Yevhen (Evgenii) Panov, accused by Russian/Crimean authorities of preparing sabotage in Crimea.",
      "date": "2018-04-16 00:00:00"
    },
    {
      "id": "d815205f-8cc2-4afb-aa3c-c0e6d70f107a",
      "text": "Opening of the Kerch (Crimean) Bridge by President Putin, a high-profile infrastructure and tourist-access milestone for Crimea.",
      "date": "2018-05-15 00:00:00"
    },
    {
      "id": "78221e24-b79b-43e4-a541-ad1ca0076618",
      "text": "Prime Minister's housing/cost-of-living speech emphasizing domestic agenda",
      "date": "2022-06-09 00:00:00"
    },
    {
      "id": "0d304d53-0699-4bac-bf54-d0c96ac245cb",
      "text": "Conservative Party confidence vote in Boris Johnson's leadership",
      "date": "2022-06-06 00:00:00"
    },
    {
      "id": "4abe3741-e47a-4a37-bca4-d5f10b6ed2cb",
      "text": "Prime Minister issued a fixed penalty notice in the 'Partygate' inquiry",
      "date": "2022-04-12 00:00:00"
    },
    {
      "id": "5b97d9af-c5cd-4efc-9502-6bf1fabde9d7",
      "text": "Surprise visit to Kyiv and public walk with President Zelensky",
      "date": "2022-04-09 00:00:00"
    },
    {
      "id": "853c041e-9df3-4b29-a61e-74c8772e02d6",
      "text": "NOAA PMEL published guidance 'Quality of pH Measurements in the NODC Data Archives' explaining that many pre‑1990 seawater pH measurements have large, poorly documented uncertainties and that consistent, high‑quality pH detection has only been possible since the 1990s.",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "ac495448-6773-45ff-afe1-a285915c6f3f",
      "text": "Release/public availability of the World Ocean Database (WOD) 2013, which aggregated historic in‑situ ocean profiles (including pH) but documented large metadata gaps and methodological inconsistencies in older records.",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "f23f41f3-49f6-4043-a4d4-56791c2a1d06",
      "text": "Small 2018 pilot study published in the Journal of Alzheimer's Disease reported cognitive improvements after a coconut oil‑enriched Mediterranean diet in a limited sample of Alzheimer's patients.",
      "date": "2018-07-20 00:00:00"
    },
    {
      "id": "867498bb-0930-48be-8ea7-2ed4335eaca6",
      "text": "Health Canada and other national bodies issued advisories/removals in spring 2021 concerning graphene‑coated face masks (potential inhalation risk), and some jurisdictions pulled graphene‑containing masks from distribution.",
      "date": "2021-04-02 00:00:00"
    },
    {
      "id": "984b86ec-b655-469a-9772-7d7780484415",
      "text": "Published scientific literature and reviews (pre‑2021) described graphene oxide's biomedical research applications and its use in nanomaterials and delivery systems.",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "725c1c14-9fcd-4f5c-95e1-9590c9ef59d7",
      "text": "WHO SAGE 'Roadmap for Prioritizing Uses of COVID-19 Vaccines' (draft) updated 29 June 2021 emphasizing prioritization of high‑risk groups and limited vaccine supply.",
      "date": "2021-06-29 00:00:00"
    },
    {
      "id": "cf29b817-5617-4b44-aa05-a0df376f7442",
      "text": "Regulatory approvals in some countries for adolescent vaccination (Pfizer authorization/recommendation for ages 12–15 in May 2021) created divergent national vs. WHO messaging.",
      "date": "2021-05-12 00:00:00"
    },
    {
      "id": "dcfb1112-c28a-4939-9d66-40a5f9e67ec2",
      "text": "Ukrainian forces recaptured the television tower in Slovyansk (reported May 5, 2014)",
      "date": "2014-05-05 00:00:00"
    },
    {
      "id": "23e62940-8b17-4720-ba2a-14719f390727",
      "text": "Widespread photo galleries and agency images of pro‑Russian flag‑raising in Donetsk (e.g., BBC gallery, April 2014)",
      "date": "2014-04-07 00:00:00"
    },
    {
      "id": "84d42f5b-d166-48df-94a7-ca07834d7629",
      "text": "The World Health Organization told Reuters (March 11, 2022) it had advised Ukraine to destroy high‑risk pathogens in public health laboratories to prevent any potential spills amid the Russian invasion.",
      "date": "2022-03-11 00:00:00"
    },
    {
      "id": "9232d564-a2b3-4587-a80d-ae2a5dc0f7ec",
      "text": "Hawaii state law (SB2571/Act 104) banning sale of sunscreens containing oxybenzone and octinoxate (effective Jan 1, 2021).",
      "date": "2018-05-24 00:00:00"
    },
    {
      "id": "60f2f09a-e48e-4b26-a07a-ce54f4efb8be",
      "text": "Nambour randomized trial follow-up reporting reduced melanoma incidence with regular sunscreen use (long-term follow-up published 2011).",
      "date": "2011-03-24 00:00:00"
    },
    {
      "id": "ceb0101b-f929-4ecd-b350-8037db80fcf6",
      "text": "Clinical research linking low serum 25-hydroxyvitamin D levels with worse melanoma prognosis (ASCO/JCO abstracts and peer-reviewed studies published across 2014–2021).",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "dc455af0-4a77-4516-95aa-318963561a03",
      "text": "Poroshenko's annual address to parliament included the line that retaking Crimea by force was 'realisticly — no' (statement made in context of legal/diplomatic strategy).",
      "date": "2017-09-07 00:00:00"
    },
    {
      "id": "6fa349ee-fdaf-4995-9580-28548d92c92a",
      "text": "UKHSA/other national surveillance dashboards showing age breakdowns of respiratory‑virus hospital admission rates (including infants) during 2022–2024 seasons",
      "date": "None"
    },
    {
      "id": "4067786c-a9a9-4504-ae37-8f00d85fa380",
      "text": "‘Self-determination for Zakarpattia’ rally held near Ukraine's embassy in Budapest (Oct 13, 2017)",
      "date": "2017-10-13 00:00:00"
    },
    {
      "id": "cf7e4df3-4d73-45a5-a65a-42d1a2a5caf3",
      "text": "OSW analysis: 'Zakarpattia – together, but separated' noting low mobilisation and governance problems (Sept 30, 2015)",
      "date": "2015-09-30 00:00:00"
    },
    {
      "id": "b57e910d-73c4-4c97-91e3-7dd5f2fb6804",
      "text": "Armed shootout in Mukachevo (July 11, 2015)",
      "date": "2015-07-11 00:00:00"
    },
    {
      "id": "5c549537-68db-436e-b803-7f7040d989fb",
      "text": "Ukraine's 2017 education law and ensuing Hungarian protests (Oct 2017)",
      "date": "2017-10-05 00:00:00"
    },
    {
      "id": "eabf220b-ccb7-4d7f-8222-41a150002c94",
      "text": "OSCE Special Monitoring Mission statements and reports documenting detentions, restricted access and impediments to monitors in Donbas (e.g., SMM updates 21 June 2017)",
      "date": "2017-06-21 00:00:00"
    },
    {
      "id": "e75a2f44-5442-4d31-b8fe-35119a74d3c6",
      "text": "Attack on an OSCE SMM patrol in Yasynuvata where armed men engaged/attacked monitors (reported June 20–21, 2017)",
      "date": "2017-06-21 00:00:00"
    },
    {
      "id": "cf0e1b85-b67a-4948-92f4-77b2300f4602",
      "text": "Large-scale arrival and public statistics on Ukrainian refugees in France (UNHCR/France reports, early 2023)",
      "date": "None"
    },
    {
      "id": "8756e902-2bbc-4510-8db0-127a384594ef",
      "text": "Widespread France riots after the police shooting of teenager Nahel Merzouk that generated intense domestic and international attention",
      "date": "None"
    },
    {
      "id": "9867fa2f-2d7f-4fe9-819f-6b125733fd08",
      "text": "Local population in Zakarpattia (Transcarpathia) increasingly sought Hungarian citizenship and cross-border permits, highlighting strong economic and social ties with Hungary.",
      "date": "2016-10-20 00:00:00"
    },
    {
      "id": "1ba67de0-3a50-4fd0-8935-215e201931da",
      "text": "2015 Mukacheve armed clash (July 11, 2015) between local gunmen, police and paramilitary-linked groups over control of smuggling routes.",
      "date": "2015-07-11 00:00:00"
    },
    {
      "id": "ae54faf8-0a6a-4db8-b437-7710c0bce29c",
      "text": "Analyses and commentary (2015) documenting Zakarpattia's long‑standing cross‑border economic orientation and weak integration with central Kyiv policies.",
      "date": "2015-09-30 00:00:00"
    },
    {
      "id": "2282d388-5b26-4bde-89a8-b928c9b17599",
      "text": "OSCE Special Monitoring Mission (SMM) reporting in October 2020 documented multiple explosions and frequent ceasefire violations in Donetsk and Luhansk regions, with restricted access to some non‑government‑controlled areas.",
      "date": "2020-10-05 00:00:00"
    },
    {
      "id": "d71b1d68-136b-401e-9be7-e317457e7d72",
      "text": "Prior deadly Molot mortar accident at the Rivne training ground (Molot M120-15) prompted government tests and probes after a mortar blast that killed multiple service members.",
      "date": "2018-07-06 00:00:00"
    },
    {
      "id": "7296af18-7182-4ad9-8e86-af7045ab2218",
      "text": "VAERS reports of fetal loss increased in the 2009–2010 season and were summarized in a 2011 review of reports after H1N1 vaccination (Moro et al.)",
      "date": "2011-04-24 00:00:00"
    },
    {
      "id": "18a11fb1-e4fe-4210-932f-b340cea2b154",
      "text": "Authoritative guidance that VAERS is a passive reporting system and cannot be used alone to establish causation",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "bffa392d-838c-48bc-ab7d-e67e0f896155",
      "text": "UN reports sharp rise in people fleeing eastern Ukraine to Rostov region, with tent camps and thousands accommodated",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "58c4f36a-d1e0-4676-a897-c83e02e84a19",
      "text": "Well-documented historical use of 'filtration camps' during the Chechnya wars (Human Rights Watch and Amnesty reporting from 2000)",
      "date": "2000-04-24 00:00:00"
    },
    {
      "id": "9186ed71-5a4c-44b5-8c29-b644072d50f3",
      "text": "Hungary and minority-rights actors publicly criticise the law and warn of harm to minority languages, prompting diplomatic pushback",
      "date": "2019-04-29 00:00:00"
    },
    {
      "id": "3856ade0-91e1-463b-a8b0-c5a4515d31da",
      "text": "Ukraine's Constitutional Court had recently struck down the 2012 Kivalov–Kolesnichenko language law (decision of 28 February 2018)",
      "date": "2018-02-28 00:00:00"
    },
    {
      "id": "bff99471-7e87-4f04-849c-7b2510eeda27",
      "text": "Verkhovna Rada adopts the Law on Ensuring the Functioning of Ukrainian as the State Language",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "139677d6-2d70-4fca-9c76-d69fae62656b",
      "text": "Media and analysts report the law requires Ukrainian in public sector, raises media quotas and tightens administrative penalties",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "e70794c7-1f61-4fa1-a956-d58bf8a67c02",
      "text": "OSCE SMM daily reports in November 2019 documenting renewed ceasefire violations, weapons and troop movements near the contact line",
      "date": "2019-11-14 00:00:00"
    },
    {
      "id": "5424fdea-3641-4e72-9221-e09f60ee8186",
      "text": "Sea Breeze multinational military exercises in Ukraine (Sea Breeze 2019) involving NATO partners",
      "date": "2019-07-01 00:00:00"
    },
    {
      "id": "5e1c916f-f839-4e2c-a1ac-1876dcaa95a0",
      "text": "Verkhovna Rada adopts the Donbas 'reintegration' law (commonly cited as ending Minsk framework)",
      "date": "2018-01-18 00:00:00"
    },
    {
      "id": "900a8533-a169-4295-9576-1e08839a4aaf",
      "text": "Public statements by President Volodymyr Zelensky and senior Ukrainian officials in mid‑2019 expressing scepticism about Minsk (describing Minsk as a 'trap' or calling for its overhaul)",
      "date": "2019-06-24 00:00:00"
    },
    {
      "id": "a9161d70-4ab9-4fae-b953-1445e2713d7a",
      "text": "Ukraine replaces the ATO with the Joint Forces Operation (JFO), moving military command and framing a more overt military response in Donbas",
      "date": "2018-04-30 00:00:00"
    },
    {
      "id": "5749d3e4-6c81-44c4-8809-9f9327c7ebab",
      "text": "Growing public and political debate within the U.S. GOP over further Ukraine aid in 2023–early 2024, including prominent Republican calls to reduce or stop funding.",
      "date": "2023-09-29 00:00:00"
    },
    {
      "id": "7af08beb-2910-4d2e-b488-0b5b72ab8c52",
      "text": "Pope Francis placed public phone calls with President Volodymyr Zelensky shortly after Russia's full‑scale invasion (first reported 26 February 2022).",
      "date": "2022-02-26 00:00:00"
    },
    {
      "id": "5f879db0-e8d7-4968-9b39-fb32fb26105d",
      "text": "Reports of foreign/black particles found in Moderna vaccine vials in Japan and subsequent batch suspensions",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "6006ac32-7f50-414e-8a5f-bce4e8739ce9",
      "text": "Legal filings and public petitions by the de Garay family and allied lawyers seeking Pfizer/FDA records about the 12–15 trial (documents and filings posted May 2023).",
      "date": "2023-05-24 00:00:00"
    },
    {
      "id": "ae1ed688-55ec-443e-bf2e-95bb6b115680",
      "text": "Several countries temporarily paused use of the AstraZeneca COVID-19 vaccine in March 2021 amid reports of rare blood-clot events; EMA and national agencies investigated and later issued conclusions balancing risks and benefits.",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "6ead3dde-bdab-43c9-b276-6f067caec9ef",
      "text": "Norwegian health authorities reviewed several deaths of very frail, elderly nursing-home residents that occurred shortly after Pfizer–BioNTech vaccination and issued more cautious guidance on vaccinating the most frail.",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "e23f167a-c7f0-425f-865f-377dfe1354a6",
      "text": "CDC/NCHS published 'Guidance for Certifying Deaths Due to Coronavirus Disease 2019 (COVID-19)' (NCHS Alert/Guidance allowing COVID-19 to be reported as probable or presumed when appropriate, not always requiring a positive lab test).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "6b180a9c-1f42-41b4-9631-3cb6b8085d98",
      "text": "Public Health England (PHE)/UK consolidated COVID death reporting to 'deaths within 28 days of a positive test' (clarifying that different measures exist between PHE daily counts and ONS death-certificate-based counts).",
      "date": "2020-08-24 00:00:00"
    },
    {
      "id": "d14997d7-7c3d-4360-85e9-3ab9ca2bdbc7",
      "text": "UN/OHCHR and other international monitors reported a deterioration in human rights in eastern Ukraine during 2014, noting cases of torture, abduction and some incidents of sexual abuse",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "4218b537-7ace-44d1-98d2-9405a2047fff",
      "text": "CDC guidance and longstanding vaccine-safety literature noting that fainting (syncope) can occur after injections and is often related to pain or anxiety rather than the vaccine itself.",
      "date": "None"
    },
    {
      "id": "0ef8f617-1413-471f-9bef-929108ce8656",
      "text": "President Zelensky announces creation of an International Legion / call for foreign volunteers",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "e948ea83-3f58-40b5-94af-f58552982c89",
      "text": "2022 general mobilisation decree in Ukraine",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "aaaa23bf-b2ea-43c1-ab2a-85111934b433",
      "text": "CDC/NCHS released provisional COVID-19 death counts and official guidance for certifying COVID-19 deaths",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "eea6c4f9-4a35-4400-95ee-9ab50ec658a1",
      "text": "Preprint and early analyses showing large excess deaths in the US and New York City during March–April 2020",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "b766d337-3425-459a-a20b-64921b60ee7a",
      "text": "Widespread media coverage showing overwhelmed New York City hospitals and temporary morgues (refrigerated trucks) in early April 2020",
      "date": "2020-04-06 00:00:00"
    },
    {
      "id": "50cb3fd3-25c4-48aa-8edf-a6d4c8f587b7",
      "text": "Publication of Nicola Scafetta (2023) paper arguing a larger solar role in recent climate change",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "4417eab2-d162-47a3-868d-6d0e56e56239",
      "text": "Implementation of pictorial/graphic cigarette pack warnings (example: Canada began pictorial warnings in early 2000s)",
      "date": "2001-04-24 00:00:00"
    },
    {
      "id": "9b61ce15-d372-433d-8b4c-cb23419b4c82",
      "text": "Publication describing bronchial anthracofibrosis/anthracosis with visibly blackened bronchial mucosa (Chung et al., Chest)",
      "date": "1998-04-24 00:00:00"
    },
    {
      "id": "95e7740e-7f3f-4e83-84d3-9e1c8c0b03f9",
      "text": "NIOSH/CDC public information and media coverage about 'Black Lung' (coal workers' pneumoconiosis)",
      "date": "2003-04-24 00:00:00"
    },
    {
      "id": "2e12c729-9448-4e2d-9dc1-58e700aa8af7",
      "text": "Battle of Ilovaisk (large Ukrainian military losses; widely published 2014 photos)",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "aec06af5-63df-4aed-bd46-53ed07ff420c",
      "text": "Russian authorities publicly announced an investigation into the reported child death",
      "date": "2021-04-05 00:00:00"
    },
    {
      "id": "cf59c68b-1168-4108-9634-206a5f6873bd",
      "text": "CDC PLoS One investigation of 'unexplained dermopathy' (commonly called Morgellons)",
      "date": "2012-01-25 00:00:00"
    },
    {
      "id": "384f6de1-57e4-4ee2-93d3-3eff97c7f3f9",
      "text": "President Biden publishes New York Times op-ed outlining U.S. role in Ukraine without explicitly repeating phrase 'within its internationally recognized borders'",
      "date": "2022-05-31 00:00:00"
    },
    {
      "id": "12a6796a-b0a7-4fa4-8f6f-5a6b53db5c76",
      "text": "The Vatican had produced (and publicised) a papal commemorative 'peace' medal in 2018 (designed by Chiara Principe) — a routine commemorative medal which can be given as a gift.",
      "date": "2018-07-26 00:00:00"
    },
    {
      "id": "cafe9cf0-f603-4413-982b-454c48421ca9",
      "text": "Publication of Mawson et al. 'Pilot comparative study on the health of vaccinated and unvaccinated 6- to 12-year-old U.S. children' claiming higher odds of developmental delays, asthma and ear infections in vaccinated children.",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "de2e5971-af07-4798-bbf8-9f1a15702d82",
      "text": "NOAA / Arctic Report Card and mainstream coverage documenting strong year‑to‑year variability in Greenland mass balance (including exceptional melt events)",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "c5cf44c4-4233-448f-b586-0f50146cc0b6",
      "text": "Parliamentary records and news reports showed Boris Johnson’s office/company received a £1 million donation from investor Christopher Harborne.",
      "date": "2023-01-12 00:00:00"
    },
    {
      "id": "de2a44e6-f54b-4173-9d05-f8ca1c562304",
      "text": "Reports disclosed large paid speaking advances and fees received by Boris Johnson after leaving office (including a £2.5m advance).",
      "date": "2023-02-08 00:00:00"
    },
    {
      "id": "3c509fdc-1d85-4f81-affd-1aa97f89c3ea",
      "text": "Coverage that Johnson was evasive with the advisory watchdog (Acoba) about proposed paid roles and consultancy work, including reports about a paid consultancy/hedge-fund role.",
      "date": "2024-04-19 00:00:00"
    },
    {
      "id": "eeda5ffb-dc48-4a5f-b7a3-ef006537a7b1",
      "text": "Dmytro Yarosh's public profile as leader of Right Sector and commander of volunteer units, including statements he could 'send several battalions to Kyiv', was widely reported in the months before the Rada session.",
      "date": "2014-10-18 00:00:00"
    },
    {
      "id": "8566fd4c-45b9-46eb-845c-f0bd362c0aec",
      "text": "The first session of the newly elected Verkhovna Rada (8th convocation) on November 27, 2014 featured numerous newly elected MPs who were war veterans and volunteer battalion commanders attending in military fatigues.",
      "date": "2014-11-27 00:00:00"
    },
    {
      "id": "2c0baa6b-7f4f-4feb-b924-7b97eabe182e",
      "text": "Publication/press coverage (Nov 28, 2024) highlighting that oceans emit cooling aerosols (sulfur) and can have a stronger cooling effect than previously quantified",
      "date": "2024-11-28 00:00:00"
    },
    {
      "id": "eb40bccd-ad4a-432b-9caf-b95812c43721",
      "text": "NOAA report and data notes documenting record high sea surface temperatures in 2023",
      "date": "2024-01-24 00:00:00"
    },
    {
      "id": "9ee8d736-3deb-4c91-b996-707bfa71c95e",
      "text": "Strong negative Pacific Decadal Oscillation (PDO) signal in October 2024 noted by climate monitoring outlets",
      "date": "2024-10-24 00:00:00"
    },
    {
      "id": "a8467897-9ea8-42cb-9988-97b34c32c24a",
      "text": "Publication on improving full‑depth ocean observations using Deep Argo floats (Frontiers, 2023)",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "f73b0473-d7fe-4c01-b046-e854e955a1b6",
      "text": "Peer‑reviewed pilot trial published showing intravaginal Lactobacillus crispatus (chen‑01) transplantation reduced HPV viral load and improved clearance rates.",
      "date": "2024-07-25 00:00:00"
    },
    {
      "id": "fd69e6d0-bc5a-4945-a092-e49c89bdef11",
      "text": "Ukraine's 2015 'decommunisation' laws and the domestic/international controversy over honoring OUN/UPA figures (e.g., Bandera) and historical memory debates.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "66d6a8c7-35dd-42f6-86c3-93cdfa8eea7f",
      "text": "Ongoing Kremlin information campaign and pro-Kremlin media narratives portraying Ukraine as 'glorifying Nazism' and repeatedly amplifying isolated incidents as systemic (documented in EUvsDisinfo reporting).",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "a40d51bc-33fe-45bb-beb4-197580111591",
      "text": "Prior whistleblower allegations about CDC data handling (William Thompson statement alleging omissions in a 2004 CDC MMR study).",
      "date": "2014-08-27 00:00:00"
    },
    {
      "id": "1f571773-a119-4b69-bb0f-e9dd9f0458f9",
      "text": "Austria had launched a large-scale rapid antigen mass‑testing programme in early December 2020, putting antigen tests at the center of political and public debate.",
      "date": "2020-12-04 00:00:00"
    },
    {
      "id": "3fb25a3c-74db-43ca-a199-f3b679d401e5",
      "text": "Historical context: documented 1943 Volhynia massacres carried out by UPA (mass killings of Polish civilians in Volhynia and Eastern Galicia).",
      "date": "1943-04-24 00:00:00"
    },
    {
      "id": "ba0128c9-056c-431b-acd4-0e45d9a2602a",
      "text": "Mainstream reporting (BBC) highlighted disproportionate COVID-19 deaths among Black, Asian and minority ethnic (BAME) communities in early April 2020.",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "8335a29a-9177-4886-8913-7e0ec1819ab9",
      "text": "Peer-reviewed analyses of 'normalized' disaster losses (e.g., Nature Sustainability 2018 study on normalized hurricane damage) showing that rising economic losses are driven largely by increased exposure and wealth rather than a clear climate-driven increase in frequency.",
      "date": "2018-12-06 00:00:00"
    },
    {
      "id": "4dbd090d-99e8-4241-892a-8f82bc069b3c",
      "text": "Nature commentary 'Climate simulations: recognize the \"hot model\" problem' highlighting that some new climate models run 'too hot' relative to historical warming.",
      "date": "2022-05-04 00:00:00"
    },
    {
      "id": "3cac4f82-dbc7-44f7-8ddf-b9626b06553b",
      "text": "Veterans Affairs slide-deck (interim guidance + VAERS tables) cited in the Judicial Watch release (data described as \"as of April 2021\")",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "ef40cf5a-0ee6-4558-aade-5a61b53b4651",
      "text": "European Court of Human Rights judgment (Mazepa and Others v. Russia) finding the investigation into Anna Politkovskaya's 2006 murder was inadequate and a violation of Article 2.",
      "date": "2018-07-17 00:00:00"
    },
    {
      "id": "542cf79a-84c2-4e1e-b5f4-5192d3aae3af",
      "text": "Earlier acquittals and retrials in the Russian domestic process (initial acquittals in 2008–2009 and a 2009 order for further investigation).",
      "date": "None"
    },
    {
      "id": "adae471a-5fe3-404e-82bd-033d9d35bc19",
      "text": "May 2014 convictions of five men for Politkovskaya's murder without identifying or prosecuting an alleged mastermind.",
      "date": "2014-05-20 00:00:00"
    },
    {
      "id": "688fe4d0-074c-42df-90b8-b7269d511b8a",
      "text": "Japan’s temporary suspension/recall and public reporting of Moderna COVID-19 vaccine batches after discovery of black/foreign particles in vials.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "acb3e29c-8b9b-4d65-84d9-b6150af17e1b",
      "text": "U.S. FDA Drug Safety Communication adding label warnings to statins about rare risks including memory loss and increased blood sugar (potential diabetes risk).",
      "date": "2012-02-28 00:00:00"
    },
    {
      "id": "4d9423eb-b550-4953-a068-8ba49767718d",
      "text": "Fatal shooting of conservative activist Charlie Kirk at a Utah university event",
      "date": "2025-09-10 00:00:00"
    },
    {
      "id": "bed08933-be98-4d9a-9300-806b428a35e5",
      "text": "Series of arson and vandalism attacks on 5G masts in the UK amid COVID-19 lockdown",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "3c3516c5-011e-4b47-9eb8-cafee3504cda",
      "text": "Russian law signed criminalizing 'knowingly false' information about the military (encouraging tighter control of narratives)",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "7243f16f-cb06-42c4-abfa-ac76b287a6bf",
      "text": "U.S. approval of Javelin anti‑tank missile sale to Ukraine (U.S. military assistance increases).",
      "date": "2018-03-01 00:00:00"
    },
    {
      "id": "460cdb5d-07ab-4e6c-bc3a-d2feb9e90359",
      "text": "Kerch Strait incident — Russian FSB seized three Ukrainian naval vessels after a clash in the Kerch Strait.",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "6380b9a7-b8f7-49c7-867a-0b0529f09f20",
      "text": "Sea Breeze / NATO maritime activity in the Black Sea (mid‑2018 exercises, increased SNMG presence).",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "910e2924-30e1-4d8f-bca1-846ccc34fb20",
      "text": "Contamination reports and suspension of Moderna vaccine batches in Japan (Aug–Sep 2021)",
      "date": "2021-08-25 00:00:00"
    },
    {
      "id": "f3a9bff8-828a-4118-889c-5006a1d45963",
      "text": "January 2020 paper suggested snakes as a possible reservoir based on codon‑usage analysis",
      "date": "2020-01-22 00:00:00"
    },
    {
      "id": "8994ae42-a469-4d04-aef2-9892dfece0ec",
      "text": "University of Arizona press release (Aug 2021) described an enzyme linked to severe COVID‑19 that is similar to neurotoxins in rattlesnake venom",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "e241f247-6176-476e-8066-4a9677b0c4c0",
      "text": "CDC and FDA acknowledged rare cases of myocarditis/pericarditis after mRNA COVID-19 vaccination and updated guidance/warnings (June 2021).",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "ff68c6bc-a3d8-4051-aaf4-2e4949c54c42",
      "text": "High-visibility athlete cardiac incidents in 2021 (for example Christian Eriksen's on-field cardiac arrest at Euro 2020, June 12, 2021) and other sudden collapses widely reported.",
      "date": "2021-06-12 00:00:00"
    },
    {
      "id": "3672d7e9-03cd-4914-8bea-500a7184d930",
      "text": "Media coverage in 2021 of Moderna's patent filings and subsequent legal actions over mRNA intellectual property (e.g., Moderna sues Pfizer/BioNTech, patent filings/provisional applications cited dating before or during 2019–2020).",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "d8e1da89-224c-4a1c-931c-46d998d07095",
      "text": "Increased promotion and discussion of ozone/oxygen therapies during COVID-19 (peer-reviewed reviews and preprints)",
      "date": "2020-07-24 00:00:00"
    },
    {
      "id": "b9ebc8be-5976-45fe-96ca-c44cec68333f",
      "text": "French audit and reporting of rising Paris 2024 budget concerns/overruns",
      "date": "2023-06-21 00:00:00"
    },
    {
      "id": "523bb635-cdad-48be-a47f-38f6e33d4588",
      "text": "Large-scale unrest and transport disruption in France (including the June 2023 riots after Nahel's killing and ongoing strikes)",
      "date": "2023-06-27 00:00:00"
    },
    {
      "id": "458966e5-0956-4973-b03b-c5cc3028417f",
      "text": "Ipsos global/European polling on attitudes toward Paris 2024 (May–June 2024 survey period)",
      "date": "None"
    },
    {
      "id": "d05082ca-4118-4750-9e59-3caabb1f72b0",
      "text": "Anti-corruption police raid of the Paris 2024 organising committee headquarters",
      "date": "2023-06-20 00:00:00"
    },
    {
      "id": "9b5d28dd-276e-4d6a-af5a-69614fe5b6fc",
      "text": "South Africa suspends use of the AstraZeneca vaccine after a study suggested low efficacy against mild-to-moderate illness caused by the B.1.351 (Beta) variant.",
      "date": "2021-02-07 00:00:00"
    },
    {
      "id": "cc89de56-27d3-450f-8f22-dc03a546f2b7",
      "text": "Norwegian Medicines Agency reports (January 2021) deaths among very frail, elderly people shortly after receiving the Pfizer–BioNTech vaccine; authorities reviewed whether reactions contributed to fatal outcomes.",
      "date": "2021-01-18 00:00:00"
    },
    {
      "id": "886af67b-0325-41c9-9ed1-e0a1d01c8050",
      "text": "CDC and FDA recommend a pause (April 13, 2021) in use of the Johnson & Johnson (Janssen) COVID-19 vaccine after reports of rare cerebral venous sinus thrombosis in some recipients.",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "4258cdeb-dc85-42d5-9bf0-ffb422d15786",
      "text": "EMA PRAC releases safety review concluding a possible link between the AstraZeneca vaccine and very rare blood clots with low platelets.",
      "date": "2021-03-18 00:00:00"
    },
    {
      "id": "021c1c3a-fd51-4941-9034-e50318b1dbba",
      "text": "John R. Christy congressional testimony asserting climate models overestimate warming and that policy actions would have negligible temperature impacts",
      "date": "2017-03-29 00:00:00"
    },
    {
      "id": "5d7cb6c6-c732-43bb-9df3-aada3e38d660",
      "text": "CDC guidance shift and prior messaging that medical masks should be reserved for health workers; on 3 April 2020 CDC issued new guidance recommending cloth face coverings for the public.",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "d99b0120-f2a8-492d-96ed-003f61c955c0",
      "text": "WHO updated advice (5 June 2020) noting 'there is no direct evidence (from studies on COVID‑19 and in healthy people in the community) on the effectiveness of universal masking of healthy people'.",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "27cfb698-04cd-4ab9-ac6d-56207c48fec7",
      "text": "Swedish government proposal to raise the voluntary repatriation (repatriation) grant to 350,000 SEK per adult (announced in government/media coverage)",
      "date": "2024-09-13 00:00:00"
    },
    {
      "id": "ac90fed3-bc85-4e29-a5e3-e3852870bd1b",
      "text": "Immediate clarifications and explanatory articles noting who is eligible (coverage by outlets like The Local and Swedish Migration Agency pages)",
      "date": "2024-09-12 00:00:00"
    },
    {
      "id": "66a43457-3d8b-4300-b113-987ff3935451",
      "text": "Publicly known fact that Vega’s AVUM upper stage uses a Ukrainian‑designed RD‑843 liquid engine (manufactured by Yuzhmash/Yuzhnoye)",
      "date": "None"
    },
    {
      "id": "13db7249-b755-4f82-b994-bace920bf919",
      "text": "Anti-Maidan tent camp at Kulykove (Kulikovo) Pole and sustained pro‑Russian protests",
      "date": "None"
    },
    {
      "id": "13afdb0f-3788-4b98-94f3-d10f8635be0c",
      "text": "Deadly clashes and Trade Unions building fire in Odesa (mass casualties)",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "7cb30f02-ea7e-483a-ac7c-9449553c6bed",
      "text": "Pro‑Russian demonstrators stormed Odesa police headquarters and freed detainees",
      "date": "2014-05-04 00:00:00"
    },
    {
      "id": "d3077dd1-f47d-4350-9a4d-dd1b33e2a59d",
      "text": "Large‑scale rocket/shelling attack on Mariupol and OSCE spot reporting on Jan 24, 2015 (high civilian casualties; intense media attention).",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "2e2d89d2-803a-44e2-8a92-a2628ae2454d",
      "text": "Donetsk bus-stop/mortar shelling that killed civilians and produced circulating images of victims (Donetsk bus station attack).",
      "date": "2015-01-22 00:00:00"
    },
    {
      "id": "bb933fdf-bf4c-4870-a5f0-dd6bbdb1571d",
      "text": "World Health Organization interim guidance (March 19, 2020) that did not recommend routine mask use by asymptomatic members of the public",
      "date": "2020-03-19 00:00:00"
    },
    {
      "id": "8b6dbb3c-a32a-4feb-a3e0-41e11f84d8fa",
      "text": "2006 study linking unmetabolized folic acid (UMFA) to reduced natural killer (NK) cell cytotoxicity",
      "date": "2006-02-24 00:00:00"
    },
    {
      "id": "fde782d9-9fd7-487c-adf4-3e4592d9493b",
      "text": "Clinical reviews and professional guidance highlighting controversy over MTHFR testing and folate form choice",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "8dd64eac-5d24-4388-aebb-09184a58300f",
      "text": "Mid-season reports of low influenza vaccine effectiveness during the 2014–2015 Northern Hemisphere season (notably against A/H3N2)",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "f34149ca-790e-498e-85fd-747e2561dc0c",
      "text": "Publication of BMJ individual participant data meta-analysis reporting that vitamin D supplementation reduced risk of acute respiratory tract infections",
      "date": "2017-02-15 00:00:00"
    },
    {
      "id": "f8d87d4c-c6fd-4540-89e1-a95b51cdd11a",
      "text": "Intensified Russian strikes and repeated damage to Kharkiv's energy and infrastructure in March–April 2024 (blackouts, strikes on power plants and residential areas).",
      "date": "2024-04-12 00:00:00"
    },
    {
      "id": "d8854f92-f1ea-44f0-9fa5-20817a1a5909",
      "text": "U.S. and international lenders publicly urged Ukraine to accelerate anti‑corruption reforms amid threats of aid reduction",
      "date": "2016-02-12 00:00:00"
    },
    {
      "id": "305e3a42-a8f7-4384-8727-a8b2837b3ee7",
      "text": "U.S. Assistant Secretary Victoria Nuland publicly warned in Senate testimony that 'oligarchs' and backsliding reforms threatened Ukraine's progress",
      "date": "2016-03-15 00:00:00"
    },
    {
      "id": "b643aa80-1674-4a44-bc83-91d9e5e86d80",
      "text": "Public opinion and polls in early 2016 showed a sharp decline in Poroshenko’s approval ratings, signaling political vulnerability",
      "date": "2016-04-07 00:00:00"
    },
    {
      "id": "097db6ca-eb11-44c5-adf8-a71db915c3f8",
      "text": "Ukraine parliament dismisses Prosecutor General Viktor Shokin after months of pressure",
      "date": "2016-03-29 00:00:00"
    },
    {
      "id": "9ab6ff72-6210-4869-bde8-98e72edd407b",
      "text": "Panama Papers revealed President Poroshenko had registered an offshore company, prompting investigations and political criticism",
      "date": "2016-04-04 00:00:00"
    },
    {
      "id": "058195ec-069f-4af7-a0fc-c241d129f928",
      "text": "Amnesty International documents abductions, unlawful detention and makeshift detention facilities used by Ukrainian volunteer battalions (Aidar) in eastern Ukraine",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "18b5b3da-d419-4a47-8df3-72b832f336f0",
      "text": "Russia issues large numbers of Russian passports to residents of Crimea after annexation",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "56942172-4f15-41ef-b903-cb1459c846d2",
      "text": "Israeli observational study reported increased emergency cardiovascular events in people under 40 during the vaccine rollout and third COVID‑19 wave (Sci Reports, 2022)",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "e8cef964-44ce-4e1c-9aa6-22f1e4bceecc",
      "text": "Science/AAAS coverage noting that a subset of the newest climate models were running 'too hot' and discussing implications for impact studies.",
      "date": "2019-05-09 00:00:00"
    },
    {
      "id": "19b844df-9886-4baa-a563-1cb1efa79513",
      "text": "Release of UAH Version 6.0 satellite temperature dataset (Roy Spencer & John Christy) showing lower tropospheric trends than some surface records.",
      "date": "2015-04-28 00:00:00"
    },
    {
      "id": "42c7e95a-5884-4619-99f5-e3ff70fa2154",
      "text": "1933 Soviet orthography reform (Kharkiv/1933 orthography) that altered Ukrainian spelling norms",
      "date": "1933-04-24 00:00:00"
    },
    {
      "id": "c207827d-9d99-4f9b-888f-f91c5a2ea551",
      "text": "Ems Ukaz banning many forms of Ukrainian-language print and performance (1876)",
      "date": "1876-05-24 00:00:00"
    },
    {
      "id": "5fdbeaa7-2027-4559-bbea-f5f3db8a3408",
      "text": "Valuev Circular limiting Ukrainian-language publications (1863)",
      "date": "1863-07-24 00:00:00"
    },
    {
      "id": "d7d4d4a8-0021-4af4-aa40-a7aecde69956",
      "text": "USDA published the National Bioengineered Food Disclosure Standard final rule (Dec 21, 2018)",
      "date": "2018-12-21 00:00:00"
    },
    {
      "id": "374385f7-292b-4a9f-8779-030b8b2426dd",
      "text": "June 2021 CDC/ACIP review and MMWR publications acknowledging a small increased risk of myocarditis/pericarditis after mRNA COVID-19 vaccination in younger males.",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "276c9734-ff08-4830-8f40-0007568e0ee6",
      "text": "Associated Press published coverage (Jan 2025) that Ivanpah, once the world's largest concentrated solar facility, was likely headed for partial closure because it couldn't compete with cheaper photovoltaic (PV) technologies and faced environmental criticisms.",
      "date": "2025-01-31 00:00:00"
    },
    {
      "id": "92dbb386-e617-4d97-9c27-c509b8ae9d5a",
      "text": "Investigations and reporting (2014–2015) including U.S. Fish & Wildlife/press coverage documented elevated avian mortality at Ivanpah (widely reported estimates of thousands of bird deaths and descriptions of birds being burned by concentrated-solar 'streamers').",
      "date": "2015-04-23 00:00:00"
    },
    {
      "id": "efdd41cf-9be8-405d-8dbc-e5c76227a9dd",
      "text": "NRG Energy and the U.S. Department of Energy announced they finalized negotiations with Pacific Gas & Electric to terminate two long-term Ivanpah power‑purchase agreements (PPAs), setting in motion shutdown of two units beginning in 2026 if regulators approve.",
      "date": "2025-01-14 00:00:00"
    },
    {
      "id": "c71fbc94-fa99-4abb-a66c-e2701d9c67ea",
      "text": "Public attention on waning Western political support for Ukraine (Zelensky's December 2023 pleas in Washington)",
      "date": "2023-12-13 00:00:00"
    },
    {
      "id": "b894c62e-7e2a-4f49-b93c-8c019edb1b6c",
      "text": "Bloomberg opinion column by retired Admiral James Stavridis noting Russia's current aviation advantage",
      "date": "2023-12-14 00:00:00"
    },
    {
      "id": "8a253488-d483-41db-bd72-6b60bf09edb1",
      "text": "Pro‑Russian protesters seized Donetsk regional administration and other government/SBU buildings and declared a 'People's Republic'",
      "date": "2014-04-07 00:00:00"
    },
    {
      "id": "0b0162cb-a1c8-49a5-841a-98214bc000d3",
      "text": "Public visibility of far‑right groups and symbols during Euromaidan (Right Sector, Bandera portraits, Celtic cross flags)",
      "date": "2014-01-21 00:00:00"
    },
    {
      "id": "bb93d367-6956-436d-996a-599f0fa232f7",
      "text": "Pro‑Russian separatists seized Ukrainian armoured personnel carriers and drove them through towns in eastern Ukraine",
      "date": "2014-04-16 00:00:00"
    },
    {
      "id": "b8be2070-d07b-4283-86e3-1b49f50d697c",
      "text": "IAEA Director General Rafael Grossi publicly expressed 'grave' or 'extreme' concern about the safety and security situation at the Zaporizhzhia plant under military control.",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "a53c344d-45d0-4daa-a4ea-f6e9b933e2f3",
      "text": "Russian forces seized the Zaporizhzhia Nuclear Power Plant after nearby shelling; a fire was reported at the site.",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "b6d91b71-04fd-4967-9a42-d4e4348dd2b7",
      "text": "Visible participation of nationalist groups (e.g., Maidan Self‑Defence/Right Sector elements) in the Odessa march and subsequent clashes.",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "0f703776-b87a-4ba4-887e-cf1e9cef8a8a",
      "text": "Indonesian drug regulator (BPOM) circulated guidance mentioning ivermectin among medicines for COVID-19-related distribution, prompting reports that it had been authorised for emergency use",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "e6965eb2-6707-4743-bba9-e2f55128db0c",
      "text": "Official U.S. assistance and advisory activity for Ukraine was publicly documented (White House fact sheet on U.S. assistance to Ukraine, Nov 21, 2014).",
      "date": "2014-11-21 00:00:00"
    },
    {
      "id": "48e9783a-c3e4-4fbf-9741-8c5b30bd9098",
      "text": "German newspaper Bild am Sonntag published a report (citing unnamed intelligence sources) alleging ~400 Academi (ex-Blackwater) mercenaries were operating in eastern Ukraine.",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "e5cfd380-706b-4af4-b638-56533d6cb180",
      "text": "YouGov poll (20 June 2022) showing Britons remain supportive of sanctions/assistance but growing wary as costs bite",
      "date": "2022-06-20 00:00:00"
    },
    {
      "id": "67275948-5c00-497f-bff2-9ded64b9afd0",
      "text": "Hansard parliamentary debate on UK and NATO military commitment regarding Ukraine (20 June 2022)",
      "date": "2022-06-20 00:00:00"
    },
    {
      "id": "c44bb25c-c233-41fe-83da-332ae4cdc1f7",
      "text": "UK Health Security Agency technical briefings and early reports (Dec 2021–Jan 2022) documenting reduced vaccine effectiveness against symptomatic infection with the emergent Omicron variant",
      "date": "2021-12-24 00:00:00"
    },
    {
      "id": "1fc2906a-4c9a-4530-ada6-424bf52e2b3e",
      "text": "Office for National Statistics (ONS) age‑specific COVID‑19 mortality data/releases showing very low death rates in younger age groups",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "bc846d24-6358-4f50-9da0-6f37026b1164",
      "text": "Large cluster-randomized Bangladesh mask trial published in Science (Nov 2021) reporting a modest reduction in symptomatic SARS‑CoV‑2 infections and differing effects by mask type",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "5d55214d-c331-4e56-ac03-0c5544cd5118",
      "text": "Formation and large-scale fundraising by the 'Come Back Alive' foundation (Povernys zhyvym) to support Ukrainian forces starting in 2014.",
      "date": "2014-05-10 00:00:00"
    },
    {
      "id": "28a28ac4-d5b4-4d98-8f7e-c8c3bee9802d",
      "text": "Street vendors and souvenir sales around Maidan popularized buying Ukrainian-themed goods for fundraising and solidarity.",
      "date": "2014-06-15 00:00:00"
    },
    {
      "id": "159a1577-f120-44d3-acd4-9256546ba197",
      "text": "Vyshyvanka Day / 'Give the vyshyvanka to a defender' 2015 campaign increased sales/donations connected to traditional Ukrainian garments.",
      "date": "2015-05-21 00:00:00"
    },
    {
      "id": "3208a2e6-8017-4011-9caf-ae4d6d4eda38",
      "text": "Sharp decline in domestic automobile production in Ukraine documented in 2015–2016 (major contraction of car manufacturing).",
      "date": "2016-05-27 00:00:00"
    },
    {
      "id": "7fcc26bf-3d16-4a63-bed6-eb9aad637370",
      "text": "CDC guidance (May 13, 2021) stating fully vaccinated people could resume activities without wearing masks in most settings",
      "date": "2021-05-13 00:00:00"
    },
    {
      "id": "7d282275-0ef0-4981-aaae-07a25a4cc2d7",
      "text": "Regulatory investigations and temporary pauses over rare thrombotic events associated with the AstraZeneca COVID-19 vaccine (March–April 2021)",
      "date": "None"
    },
    {
      "id": "1063213e-2698-40c3-8381-4586e469f8f3",
      "text": "Uttar Pradesh state government endorsed large-scale prophylactic and therapeutic use of ivermectin in its COVID-19 protocol and publicly attributed part of its relatively low case/fatality metrics to ivermectin use (reported May 12, 2021)",
      "date": "2021-05-12 00:00:00"
    },
    {
      "id": "3682026f-f1f4-4c55-9007-6b73fb162e88",
      "text": "Uttar Pradesh reports large number of ‘COVID‑free’ districts / very low active cases (official counts)",
      "date": "2021-10-19 00:00:00"
    },
    {
      "id": "67f30ec6-95de-443c-8a45-01bd859d04c4",
      "text": "WHO issues guidance advising ivermectin only be used for COVID‑19 within clinical trials",
      "date": "2021-03-31 00:00:00"
    },
    {
      "id": "9a92b1c5-d64b-4a8f-bff3-9d8cda00b308",
      "text": "Surge in herbal and immune‑support supplement sales during the COVID-19 pandemic (record growth in 2020)",
      "date": "2021-09-15 00:00:00"
    },
    {
      "id": "8cc23ae4-e70f-4570-bf83-5c2302b65dea",
      "text": "Cochrane review reporting limited preventive effect of regular vitamin C on common cold incidence in ordinary population",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "0056a45e-1104-437c-84c0-4e7b7467c2a0",
      "text": "Human Rights Watch (and other NGOs) called for a thorough investigation into the Odessa deaths, highlighting possible official inaction or failures",
      "date": "2014-05-08 00:00:00"
    },
    {
      "id": "4959890f-ec07-4467-9894-7ea899d38684",
      "text": "Deadly clashes and Trade Unions House fire in Odessa (dozens killed)",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "d651504e-7fd0-400c-a45a-bc201d982e7f",
      "text": "Media reporting and analysis documenting police/authorities' limited intervention and chaotic law‑enforcement response during the May 2 clashes",
      "date": "2014-05-06 00:00:00"
    },
    {
      "id": "c1d3a62d-f31c-41f0-861d-08cae4ea448b",
      "text": "Amnesty International and other human-rights organisations document police crackdowns, intimidation and legal pressure on peaceful protesters in Poland (reports published 2017 onward).",
      "date": "2017-10-24 00:00:00"
    },
    {
      "id": "3b1c36c8-803b-475c-8fe3-1f57b4d5f437",
      "text": "Poland’s president signs laws giving the government power to appoint and dismiss public broadcaster executives, effectively placing public TV and radio under direct government control.",
      "date": "2016-01-24 00:00:00"
    },
    {
      "id": "6420c8f8-d16e-4808-96f7-081e0dee8be5",
      "text": "The European Union triggers the Article 7 procedure against Poland (December 2017) over concerns about rule-of-law breaches, judicial independence and broader institutional capture by the government.",
      "date": "2017-12-24 00:00:00"
    },
    {
      "id": "ca9e16c0-b200-44cc-b1bc-b776e3da81ce",
      "text": "Reporters Without Borders and other press-freedom indices record a marked decline in Poland’s press freedom ranking in 2016, citing government interference in public media and political pressure on journalists.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "03572d67-6c26-44ca-8afd-20dc0ac1ed0b",
      "text": "Large public and veterans' protests against Zelensky over anti‑corruption and governance moves",
      "date": "2025-07-24 00:00:00"
    },
    {
      "id": "079bb245-d14a-4c7a-805a-0fe7162f6abd",
      "text": "President Zelensky dismisses Ukraine's Commander-in-Chief Valerii Zaluzhnyi",
      "date": "2024-02-08 00:00:00"
    },
    {
      "id": "e0c9f39d-5831-45a1-830b-2a67218024c1",
      "text": "Analyses and warnings about growing far‑right mobilization and past armed clashes involving nationalist groups",
      "date": "2024-10-11 00:00:00"
    },
    {
      "id": "6b3ae583-1ea9-4b3a-b5bf-f35462415eff",
      "text": "Early limits and inconsistencies in U.S. testing guidance that undercounted cases",
      "date": "2020-03-03 00:00:00"
    },
    {
      "id": "ef160d98-8f47-4fc5-8cad-1903cedc1f3b",
      "text": "Authoritative agencies published comparisons noting similarities but important differences between COVID-19 and influenza",
      "date": "2020-03-25 00:00:00"
    },
    {
      "id": "752d86e5-d35a-4109-9d79-724a0db1743a",
      "text": "NOAA 'Sea Level Trends' / Tides & Currents long‑term tide gauge dataset publication and guidance pages",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "0dc7ae0a-7caf-4637-9106-b9ac247f37cc",
      "text": "Major media coverage summarizing Nerem et al. (2018) (e.g., The Guardian 27 Feb 2018)",
      "date": "2018-02-27 00:00:00"
    },
    {
      "id": "8e1fa647-3216-4dff-87b3-a454db279570",
      "text": "Publication of Nerem et al. (2018) PNAS 'Climate‑change–driven accelerated sea‑level rise detected in the altimeter era'",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "6f5ed3cd-536e-4444-9e06-51eccbcf6a6f",
      "text": "Early–mid March 2022: Evacuations of wounded Mariupol civilians (including children) to hospitals in other Ukrainian cities such as Zaporizhzhia; news outlets published photos of evacuees being treated elsewhere.",
      "date": "2022-03-09 00:00:00"
    },
    {
      "id": "3409a217-a4f3-4f60-9101-52c1f87b9ab1",
      "text": "CDC/NCHS release on 2020 firearm-related deaths (March 17, 2021)",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "ab4a0b17-1983-4011-8f28-2e73ed350490",
      "text": "Journal of Patient Safety 2013 estimates of 210,000–440,000 deaths from preventable harm",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "dc40a4e2-8449-44e5-b295-6541d540d7e9",
      "text": "Record 2018 California wildfire season (e.g., Mendocino Complex Fire in July 2018)",
      "date": "2018-07-27 00:00:00"
    },
    {
      "id": "a396cbb1-fb21-4080-86c7-b19d02400f19",
      "text": "President Poroshenko had signed a demobilization decree (No. 328/2015) in June 2015 scheduling demobilization during July–September 2015.",
      "date": "2015-06-12 00:00:00"
    },
    {
      "id": "4cfee40f-c632-4d7e-adf7-57b73b8f2ee7",
      "text": "Ukraine’s Ministry of Defence and other officials issued immediate denials, stating that conscription schedules are governed by law and the General Staff cannot unilaterally extend conscript terms.",
      "date": "2015-07-13 00:00:00"
    },
    {
      "id": "dcd5db79-1f5c-47b9-8191-7ed0df646471",
      "text": "Widespread administrative complexity and public confusion over multiple mobilization/de‑mobilization orders since 2014 (partial mobilizations, different presidential decrees) created an environment where contradictory claims about service terms were plausible.",
      "date": "None"
    },
    {
      "id": "1c66cc00-9fd5-477e-932c-30917929823a",
      "text": "Peer‑reviewed reports describing isolation and characterization of the novel coronavirus (e.g., Zhu et al., NEJM)",
      "date": "2020-01-24 00:00:00"
    },
    {
      "id": "7c8e8163-76b3-483c-83a5-7d5a604ec003",
      "text": "Russia recognised Donetsk and Luhansk as independent and ordered troop deployments",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "0acc9dfe-649c-470f-ada8-59734a0d6699",
      "text": "High‑profile Turkish Bayraktar TB2 drone use for Ukraine highlighted internationally",
      "date": "2022-05-30 00:00:00"
    },
    {
      "id": "53564956-1238-4060-98a5-a257a368982d",
      "text": "Public Turkish statements emphasising support for Crimean Tatars and calling for Crimea's return to Ukraine",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "a16e1903-461c-4506-8861-3d7902f86cd2",
      "text": "Turkish President Erdoğan visited Kyiv and offered to mediate between Ukraine and Russia",
      "date": "2022-02-03 00:00:00"
    },
    {
      "id": "509cdd4a-32cf-46bf-9061-87fd383f6da6",
      "text": "U.S. Advisory Committee on Immunization Practices (ACIP) / CDC review and public statement (MMWR) in June 2021 acknowledging myocarditis reports after mRNA COVID‑19 vaccines while concluding benefits outweigh risks.",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "3c19d2a4-f513-41a5-8faa-2464e56c7bd9",
      "text": "In vitro studies published in 2021 reporting that isolated SARS‑CoV‑2 spike protein can affect endothelial cells, pericytes or ACE2 signalling (e.g., Lei et al., Avolio et al.).",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "9e56dab0-5cf4-45b0-ad60-275fc36209c8",
      "text": "U.S. Department of Defense announced a $250 million security-assistance package for Ukraine.",
      "date": "2019-06-18 00:00:00"
    },
    {
      "id": "355f7a62-c215-4842-a84b-3c956c65a379",
      "text": "Kerch Strait incident: Russian forces seized Ukrainian navy vessels and detained sailors.",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "a088dd02-6770-44a6-8d0e-c8ad5aec1597",
      "text": "Earlier U.S. transfers of lethal defensive systems (e.g., Javelin anti-tank missiles in 2018).",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "5ec788d5-61e0-4e9b-a95e-da9cde6d8fc1",
      "text": "Text of the FY2020 National Defense Authorization Act (NDAA) circulated with provisions directing security assistance and reporting on Ukraine.",
      "date": "2019-06-24 00:00:00"
    },
    {
      "id": "bf8bb868-6a19-4b48-b3e3-e2d83c57bffd",
      "text": "U.S. temporarily relocated embassy operations from Kyiv to Lviv amid Russian force buildup",
      "date": "2022-02-14 00:00:00"
    },
    {
      "id": "28386613-34b5-4c1f-94d2-f879ca76a462",
      "text": "Russian missile strikes and attacks on Odesa region in early July 2022 (civilian casualties reported)",
      "date": "2022-07-01 00:00:00"
    },
    {
      "id": "e286a468-eebe-49e0-abe3-e91ef6536342",
      "text": "U.S. ordered evacuation of most embassy staff in early February 2022",
      "date": "2022-02-12 00:00:00"
    },
    {
      "id": "47a5bdde-eae2-4055-96f5-64228b6afaeb",
      "text": "U.S. Embassy in Kyiv officially reopened after months of suspension (May 18, 2022)",
      "date": "2022-05-18 00:00:00"
    },
    {
      "id": "74d182f5-abca-4486-bb63-20c04388f987",
      "text": "ONS technical analysis (March 2022) 'Deaths involving COVID-19 by vaccination status' explaining that differences in non-COVID mortality by vaccination status were driven by changing composition of vaccinated groups",
      "date": "2022-03-16 00:00:00"
    },
    {
      "id": "f959a15a-811c-4320-96e0-b3d0d9234415",
      "text": "Publication of the World Mortality Dataset and accompanying eLife paper (Karlinsky & Kobak) documenting cross-country excess-mortality estimates",
      "date": "2021-06-30 00:00:00"
    },
    {
      "id": "3d1d9264-6372-4f7e-abba-8dff2736e471",
      "text": "Reports that cities (including Lviv) were reusing or digging up old graves and opening new burial areas to accommodate war dead",
      "date": "2023-06-19 00:00:00"
    },
    {
      "id": "c7fa7154-662d-458e-ad6e-b0f0bf4c0382",
      "text": "Collapse of the Nova Kakhovka (Kakhovka) dam on the Dnipro River, releasing large volumes of water and exposing reservoir sediments",
      "date": "2023-06-06 00:00:00"
    },
    {
      "id": "e92defb1-ef29-4c1a-904d-6e35d992e54f",
      "text": "Forensic teams exhumed mass graves in Bucha after Russian forces withdrew",
      "date": "2022-04-08 00:00:00"
    },
    {
      "id": "f9388985-6c3f-4aed-8bb1-2e0663b530b9",
      "text": "Publication of scientific reviews and studies showing cemetery leachate can affect groundwater under certain conditions",
      "date": "2012-04-24 00:00:00"
    },
    {
      "id": "8b3e60bf-ee95-4e09-942b-5d4da7895641",
      "text": "BBC report on corruption allegations in Ukraine's defence procurement, highlighting opaque contracting and alleged diversion of funds.",
      "date": "2016-12-24 00:00:00"
    },
    {
      "id": "ae583b19-b213-4b87-a650-af51e14d5d28",
      "text": "Verkhovna Rada passes the 2017 state budget under IMF conditions, with tight fiscal limits on public spending.",
      "date": "2016-12-21 00:00:00"
    },
    {
      "id": "98b4c645-ec3a-4052-8ecb-1f2e0cff86b0",
      "text": "Media coverage (KyivPost) of targeted pay increases in 2017 that boosted frontline soldiers' wages more than others.",
      "date": "2017-09-12 00:00:00"
    },
    {
      "id": "99c384ac-d12e-412c-af0e-a29f870224a1",
      "text": "IMF staff report and government commentary (2016) warning about a high public-sector wage bill and urging fiscal restraint and reform.",
      "date": "2016-10-24 00:00:00"
    },
    {
      "id": "a768319a-bc88-4540-a568-c888c470e333",
      "text": "Razumkov Center identity survey (fieldwork March 3–9, 2017) reported regionally varied answers on 'citizen of the former USSR' (cited in coverage)",
      "date": "None"
    },
    {
      "id": "188e2634-02b5-48cf-8416-b730583f7c01",
      "text": "Gorshenin Institute / Friedrich‑Ebert‑Stiftung publicised a July 2017 survey ('Ukrainian society and European values') whose mixed subgroup breakdowns were publicly presented",
      "date": "2017-07-11 00:00:00"
    },
    {
      "id": "b8d26489-766b-476e-9288-afe066be5436",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I – Summary for Policymakers released, stating 'It is unequivocal that human influence has warmed the atmosphere, ocean and land' while also presenting ranges/uncertainty for climate sensitivity and attribution details.",
      "date": "2021-08-09 00:00:00"
    },
    {
      "id": "74d6300c-e54d-4b56-8ed9-29f1fa4731db",
      "text": "Hunga Tonga–Hunga Ha'apai volcanic eruption (massive explosive eruption and atmospheric injection of water vapor and aerosols).",
      "date": "2022-01-15 00:00:00"
    },
    {
      "id": "3d0cc3f9-607e-40c1-8d36-d6bc0ce97f45",
      "text": "A small number of UN member states publicly recognized or expressed support for Russia’s annexation of Crimea (reported examples e.g., statements by Syria, Venezuela)",
      "date": "2018-05-15 00:00:00"
    },
    {
      "id": "d45a26ec-741e-44f4-bdb7-f46d3f67f74f",
      "text": "UN General Assembly adopted Resolution A/RES/68/262 affirming Ukraine’s territorial integrity",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "571e1cc8-8607-4611-b359-a9e35e278bfe",
      "text": "UN Security Council veto blocked a draft resolution condemning the Crimea referendum",
      "date": "2014-03-15 00:00:00"
    },
    {
      "id": "630c80c4-861f-415c-8316-30394a1d4966",
      "text": "Ukraine’s government signalled acceptance of the 'Steinmeier Formula' (early October 2019) committing to steps on special status/elections for Donbas",
      "date": "2019-10-01 00:00:00"
    },
    {
      "id": "76c2db9b-d26b-4f29-a2ee-da0ac761da2b",
      "text": "High-profile Russia–Ukraine prisoner exchanges in September 2019 (major swaps reported Sept 2019)",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "65f035a9-60f3-4966-bc30-bed468dc3092",
      "text": "Atlantic Council analysis (Oct 30, 2019) summarising polls that show many Ukrainians want peace but with important caveats (e.g., polls indicating ~69% favour compromise in some formulations)",
      "date": "2019-10-30 00:00:00"
    },
    {
      "id": "36e1b8f2-7b42-403e-b626-9551d4fbc24b",
      "text": "Large 'Stop Capitulation' / 'No Surrender' protests across Ukraine opposing concessions (early October 2019, mass rally Oct 6, 2019)",
      "date": "2019-10-06 00:00:00"
    },
    {
      "id": "21fceb45-0ee5-4715-845a-c3e404724968",
      "text": "Ilko Kucheriv Democratic Initiatives Foundation / KIIS November 2019 public opinion survey (national) reported majorities on negotiating and preconditions for talks",
      "date": "2019-11-24 00:00:00"
    },
    {
      "id": "e77ad024-62fa-46e0-96aa-65e8904c4383",
      "text": "Preprint serosurvey reporting SARS‑CoV‑2 antibodies in cats in Wuhan",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "c322107b-bbb2-44b7-aa46-c909b4d958d6",
      "text": "Public health caveats and cautious messaging (CDC/WHO) about animals and COVID‑19",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "d61751b1-ac99-48f8-84e8-8fba7b252705",
      "text": "Belgian domestic cat tested positive after owner with COVID‑19 (human→cat transmission)",
      "date": "2020-03-27 00:00:00"
    },
    {
      "id": "42a254be-8c82-46d6-948b-254dba5466d9",
      "text": "Russian officials publicly demanded the release/publication of recordings and black box data, accusing investigators of withholding material.",
      "date": "2014-09-01 00:00:00"
    },
    {
      "id": "7af65c91-6dfe-40e8-9056-5c636f903528",
      "text": "Conflicting official statements about why MH17 was allowed to fly over conflict‑torn eastern Ukraine and whether Ukrainian authorities had closed relevant airspace.",
      "date": "2014-07-18 00:00:00"
    },
    {
      "id": "f2ed9760-5610-4a2c-9354-e9247fc29368",
      "text": "Japan suspended use of some Moderna COVID-19 vaccine batches after reports of particulate contamination in vials (August 2021).",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "086e3440-20ae-47d7-8188-96798400bd40",
      "text": "Norwegian health authorities reviewed reports of 23 frail elderly patients who died shortly after receiving the Pfizer/BioNTech vaccine and issued guidance about vaccinating very frail elderly (January 2021).",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "9093e625-8ae4-4f6d-9b7d-8b396f3411e7",
      "text": "December 2022 peer-reviewed autopsy study examining 35 people who died unexpectedly within 20 days of COVID-19 vaccination reported possible vaccine-induced myocarditis in a small number of cases and was widely shared.",
      "date": "2022-12-24 00:00:00"
    },
    {
      "id": "6e550910-5543-4a06-a74a-00c18f1cde7b",
      "text": "Russian leadership accuses Ukraine of plotting terrorist/armed incursions (Crimea)",
      "date": "2016-08-11 00:00:00"
    },
    {
      "id": "374372cf-f681-4fc2-851d-a23fd9e14b8f",
      "text": "Rapid Trident 2018: Ukraine‑NATO joint military exercises in Lviv region",
      "date": "2018-09-03 00:00:00"
    },
    {
      "id": "d86e9609-77ec-4c34-b3f1-a779490eaedd",
      "text": "FDA Vaccines and Related Biological Products Advisory Committee briefing documents (December 2020) for the Pfizer‑BioNTech vaccine noted transient changes in trial participants' lymphocyte counts",
      "date": "2020-12-10 00:00:00"
    },
    {
      "id": "9313994a-61f5-4078-acbd-c434cdaf8305",
      "text": "Reports of contamination (black/foreign particles) found in multiple Moderna vaccine vials in Japan, prompting suspension and investigation of batches",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "0943c6ee-1b22-4a07-ae1f-fa4e9067bf92",
      "text": "Public Health England (PHE) Technical Briefing 17 published with breakdowns of Delta cases, hospitalisations and vaccination status",
      "date": "2021-06-25 00:00:00"
    },
    {
      "id": "406b1fbe-7199-4fa6-aef8-6543f5fb49a2",
      "text": "Discovery of dozens of civilian bodies in Bucha after Russian forces withdrew",
      "date": "None"
    },
    {
      "id": "d79ae8d2-9a53-4da3-a523-3505d8ef4e2a",
      "text": "Pattern of Russian accusations that Ukraine stages 'provocations' or 'false flag' incidents",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "22add310-deff-4922-af09-bed7fb4c6eaf",
      "text": "WMO/other agencies reported unusually low Antarctic sea‑ice extents in 2022–2023 (e.g., WMO note on record low winter extent, September 13, 2023).",
      "date": "2023-09-13 00:00:00"
    },
    {
      "id": "c42c06b6-0c72-404c-b1e1-a6ea887ab989",
      "text": "IPCC Sixth Assessment Report (AR6) Summary for Policymakers released, strongly attributing recent warming to human influence",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "a18eb799-3627-42c3-8e70-28d1b88e5971",
      "text": "Publication/coverage of papers predicting a 'modern grand solar minimum' and potential cooling (e.g., Zharkova et al. 2020)",
      "date": "2020-08-04 00:00:00"
    },
    {
      "id": "ecf23699-b575-4ba7-a0fe-5d782f53736b",
      "text": "CDC released guidance for certifying deaths due to COVID-19 (guidance on cause-of-death reporting, explaining comorbidities often listed alongside COVID-19).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "7f00fee7-1728-4445-912d-7de5fff1b210",
      "text": "Publication and wide circulation of the Great Barrington Declaration (Oct 4, 2020), advocating 'focused protection' and highlighting differences in individual risk.",
      "date": "2020-10-24 00:00:00"
    },
    {
      "id": "9f261b7b-2319-4085-ab37-11078a70c433",
      "text": "CDC reverses mask guidance for vaccinated people (July 27, 2021) following Provincetown/Barnstable County outbreak and director's statement",
      "date": "2021-07-27 00:00:00"
    },
    {
      "id": "8b34aad5-bf88-4f62-bdad-ef7da9225420",
      "text": "Peer‑reviewed reports of myocarditis temporally associated with mRNA vaccination (Israel / NEJM reporting increased risk in young males)",
      "date": "2021-10-06 00:00:00"
    },
    {
      "id": "90d2e97e-b523-4e6d-a6e6-06d952d0048d",
      "text": "Russia blocked an OSCE council statement condemning the Mariupol attack and publicly blamed Kyiv for the shelling",
      "date": "2015-01-25 00:00:00"
    },
    {
      "id": "3866bad7-b613-459d-b4e2-3a798895640b",
      "text": "OSCE Special Monitoring Mission spot report (24 January 2015) published crater/direction analysis of the Mariupol strike (found impacts from north-east/east)",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "4a88d88f-26b0-40d4-b289-cf860b95d0de",
      "text": "NOAA/NCDC summary reporting 2012 as the warmest and second-most-extreme year for the contiguous United States, citing ~34,008 daily record highs vs ~6,664 daily record lows.",
      "date": "2013-01-24 00:00:00"
    },
    {
      "id": "b70369d8-27de-44c0-8c2d-d4f9015ecfbe",
      "text": "Publication of Keeling et al. (PNAS, 2017) reporting a global secular increase in carbon isotopic discrimination by land photosynthesis.",
      "date": "2017-09-24 00:00:00"
    },
    {
      "id": "59b4c0a6-0bf0-4b4e-ac15-bfba72030ec6",
      "text": "Publication and broad media coverage of the 2016 'Greening of the Earth' study showing large CO2-driven vegetation increases (Zhu et al., Nature Climate Change) and NASA press releases highlighting a global 'greening' trend.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "186364e0-0496-4137-aedd-08a93acb45c7",
      "text": "Coverage in mid‑2024 of Morocco’s expanded cloud‑seeding (Al‑Ghaith) programme and Spanish media concern that artificial rainfall efforts could affect neighbouring territories (reported August 28, 2024).",
      "date": "2024-08-28 00:00:00"
    },
    {
      "id": "ce4bfadc-7156-4acb-ad54-dba35724c1fc",
      "text": "Catastrophic late‑October 2024 floods in eastern Spain (DANA) that produced widespread destruction and many viral images/videos.",
      "date": "2024-10-29 00:00:00"
    },
    {
      "id": "eaa30024-a42c-44dd-8614-b5fecfe93db1",
      "text": "Ukrainian government reported a substantial increase in defence spending for 2018, publicly committing more resources to the armed forces.",
      "date": "2018-09-24 00:00:00"
    },
    {
      "id": "6c975d06-5e6f-4180-a27f-af1e4cd6b6d1",
      "text": "Verkhovna Rada adopted a new Law on National Security intended to bring Ukraine's security institutions closer to NATO standards (adopted June 2018; signed July 2018).",
      "date": "None"
    },
    {
      "id": "1a1036fe-40f5-4390-b808-24415bb34512",
      "text": "OSCE Special Monitoring Mission reported a noticeable rise in ceasefire violations and incidents in Donetsk and Luhansk during mid-2018.",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "4aaf367c-9686-43bc-82d2-29f6a2799c9c",
      "text": "Russia held its Vostok-2018 strategic military exercises involving ~300,000 personnel, heavy air and naval assets, and participation from China and Mongolia.",
      "date": "2018-09-24 00:00:00"
    },
    {
      "id": "9b2dabb6-5ae1-499d-8ced-0becc13dd579",
      "text": "Russian authorities repeatedly announced large totals of 'humanitarian aid' deliveries to Donbas (official claims in 2015 of tens of thousands of tonnes delivered)",
      "date": "2015-12-21 00:00:00"
    },
    {
      "id": "569e374f-3c1a-41f9-a0dd-8382fa562bcd",
      "text": "Putin signed a decree simplifying Russian citizenship for residents of Donetsk and Luhansk",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "c17ff997-a5f8-40a5-9388-6ea34db6656d",
      "text": "Russian 'humanitarian convoy' of hundreds of trucks crossed into eastern Ukraine without Kyiv's authorization",
      "date": "2014-08-22 00:00:00"
    },
    {
      "id": "f9b65679-1631-449b-b807-d1fd4da4746a",
      "text": "Kyiv City Council imposes moratorium on public use of Russian‑language cultural products in the capital (July 2023)",
      "date": "2023-07-13 00:00:00"
    },
    {
      "id": "30bf2f64-e771-4949-8980-3b6ec5555aab",
      "text": "Kyiv city renamed 95 streets as part of derussification campaign (August 2022)",
      "date": "2022-08-25 00:00:00"
    },
    {
      "id": "5f01571b-6f20-48eb-a0f5-9bc528a2c9c7",
      "text": "Presidential/National Security decision to sanction and take three pro‑Russian TV channels (112 Ukraine, NewsOne, ZIK) off the air (Feb 2021)",
      "date": "2021-02-02 00:00:00"
    },
    {
      "id": "b74705cf-c363-4742-91c8-2cd15d504506",
      "text": "Passage of Ukraine's 2019 language law strengthening the role of Ukrainian (Law No. 5670‑d)",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "6b51683f-1256-42bd-8b6a-91a6a7fa057f",
      "text": "Court ban of the Opposition Platform — For Life political party (June 2022) following its suspension during martial law",
      "date": "2022-06-20 00:00:00"
    },
    {
      "id": "bc772f26-1c54-4444-9adf-ebcab49ae7fe",
      "text": "UNICEF/WHO joint statement announcing support to close a vaccine-derived polio outbreak in Sudan",
      "date": "2020-09-08 00:00:00"
    },
    {
      "id": "292f24fb-5458-4a2a-8be5-7fc08f6f336f",
      "text": "Government changes and public confusion over passport issuance procedures (Cabinet decision)",
      "date": "2024-04-23 00:00:00"
    },
    {
      "id": "96c47ff2-e6b2-49e7-91b4-36c9da5cede1",
      "text": "Major Enerhoatom/energy‑sector $100 million kickback probe by anti‑graft authorities",
      "date": "2025-11-10 00:00:00"
    },
    {
      "id": "7f084599-1623-4d42-bf4b-4b862f5e8972",
      "text": "Anti‑corruption agencies search Andriy Yermak’s apartment/home",
      "date": "2025-11-28 00:00:00"
    },
    {
      "id": "403c5420-2e53-4a20-9b5e-e35280f8134d",
      "text": "Pandora Papers disclosure linking Zelensky and close associates to offshore companies",
      "date": "2021-10-03 00:00:00"
    },
    {
      "id": "1835c7f4-de2b-4164-8b82-fa6adfc3ca0a",
      "text": "House Science Committee oversight and subpoena of NOAA over the 2015 'pause-buster' study (Rep. Lamar Smith)",
      "date": "2015-10-24 00:00:00"
    },
    {
      "id": "e1d1489b-8379-4150-be47-22d283933756",
      "text": "CDC changes stance and recommends the public wear cloth face coverings (official recommendation)",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "5c4d273b-9230-4adf-b8f0-b49827a4ec76",
      "text": "US Surgeon General Jerome Adams urges public to 'stop buying masks' amid shortages",
      "date": "2020-03-02 00:00:00"
    },
    {
      "id": "2b9f56ec-523f-4414-b969-1659e9a4f74d",
      "text": "Antonov and media reports noted AN‑178 production and delivery disruptions under COVID‑19/quarantine conditions in mid‑2020",
      "date": "2020-08-24 00:00:00"
    },
    {
      "id": "84caced5-1f11-4f30-85b3-e9cc1fb2b5f9",
      "text": "Ukroboronprom / Spetstechnoexport signed the export contract with Peru for the Antonov AN‑178 (first reported publicly)",
      "date": "2019-11-15 00:00:00"
    },
    {
      "id": "c49df9ee-84b6-4d61-803d-996fe5ae4ab4",
      "text": "Poland's 2018 'Holocaust speech' / IPN amendment (criminalising some statements about Polish responsibility in the Holocaust)",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "ce0645ec-7609-47a5-9cc2-2fb81d723322",
      "text": "Scientific coverage that some COVID-19 vaccine candidates used long‑established fetal cell lines (HEK‑293, PER.C6)",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "a8b1f4ae-bb24-4d01-985a-3ed5e9af9c13",
      "text": "Russia's domestic gas prices reported far below European levels (Gazprom commentary)",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "8603a105-6ea7-414b-a010-6065851a6046",
      "text": "Ukraine suspends/begins to reduce purchases of Russian gas and pivots to European reverse‑flows",
      "date": "2015-07-24 00:00:00"
    },
    {
      "id": "9259f1ee-50e3-4e3a-810f-97d1deab67df",
      "text": "Pre‑existing academic and public‑health research documenting lower vaccination uptake in some Amish communities (example: 2021 study of northeast Ohio Amish vaccination patterns).",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "2c6eb48c-219d-4624-a524-61374499a6c2",
      "text": "Destruction of collateral sites (for example the Slovenian consulate in Kharkiv) and multiple simultaneous strikes in the city",
      "date": "2022-03-01 00:00:00"
    },
    {
      "id": "4708fe1a-0f60-44da-9a08-02e513afa594",
      "text": "Missile strike hit Kharkiv Regional State Administration building in Freedom Square (large explosion captured on CCTV)",
      "date": "2022-03-01 00:00:00"
    },
    {
      "id": "4a823ed6-c42d-4cf4-9326-15b6ae845cd6",
      "text": "Russian authorities designated Open Society Foundations 'undesirable' and banned OSF activities in Russia (2015)",
      "date": "2015-12-01 00:00:00"
    },
    {
      "id": "f1c193fc-6404-49a5-bbbf-d866acb13365",
      "text": "Exiled Crimean Tatar leaders and other legitimate diaspora organizations publicly urged continuation or expansion of sanctions on Russia (e.g., calls from exiled Crimean Tatar leaders for more EU sanctions).",
      "date": "2018-05-24 00:00:00"
    },
    {
      "id": "042ef20a-73df-4a71-abe5-0760038aad5b",
      "text": "Large-scale humanitarian presence by Polish authorities, NGOs and aid projects operating in Western Ukraine (shelters, joint UK‑Polish projects in Lviv) as part of wartime assistance.",
      "date": "None"
    },
    {
      "id": "81600820-95e9-4a12-901d-caaec68e738e",
      "text": "Polish parliament (Sejm) adopted the \"Act on aid for Ukrainian citizens\" (special law) that simplified legal stay, work and social assistance for Ukrainians in Poland.",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "01c6a101-e7a1-490e-89be-3cdfa97902a8",
      "text": "Leaders of Poland, Lithuania and Ukraine (the Lublin Triangle) issued a joint statement and high‑level meetings in Kyiv demonstrating accelerated political cooperation.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "7c80c12a-d7df-4343-8b4b-2bb750a57e89",
      "text": "Reporting that Ukrainian troops ran out of ammunition and fled posts in Luhansk (June 2014), including accounts of units abandoning positions.",
      "date": "2014-06-04 00:00:00"
    },
    {
      "id": "ad38848b-442e-4629-88b4-3c66a4f9beef",
      "text": "Reports in 2014 that several Ukrainian troops crossed the border into Russia during heavy fighting in eastern Ukraine.",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "950a4afb-6b16-4452-8c32-f06391a6eb0f",
      "text": "Russia's formal recognition of the independence of the self-proclaimed Donetsk and Luhansk People’s Republics on Feb 21, 2022.",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "6a3252b9-3000-4c23-9e4f-54b368b2f63f",
      "text": "Japan suspends use of some Moderna vaccine lots after reports of foreign particulate matter found in vials.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "9091d87e-8a09-4f86-97b4-a3695200402b",
      "text": "EMA declares a possible link between the AstraZeneca vaccine and very rare cases of unusual blood clots with low platelets.",
      "date": "2021-04-07 00:00:00"
    },
    {
      "id": "01eb0ae5-fa84-40a6-9c52-34656c07b795",
      "text": "Transparency International publication of the Corruption Perceptions Index 2022 (released Jan 31, 2023) showing Ukraine's CPI score and ranking",
      "date": "2023-01-31 00:00:00"
    },
    {
      "id": "a272c121-a877-4718-8464-1bd5a96ce2b9",
      "text": "Release of the Joint Strategic Oversight Plan (JSOP) for the U.S. Ukraine response by the DoD/State/USAID Offices of Inspector General",
      "date": "2023-03-27 00:00:00"
    },
    {
      "id": "8381663b-0d95-4b43-910e-511a5204c318",
      "text": "Media reporting that U.S. Congress was turning attention to oversight of Ukraine aid (Roll Call coverage)",
      "date": "2023-02-27 00:00:00"
    },
    {
      "id": "297d1ba2-974f-43a0-b62a-ba723ea87519",
      "text": "Reporting that Kyiv and other areas organized distribution of rifles and ammunition to civilian militias (e.g., plans to distribute tens of thousands of small arms and millions of rounds).",
      "date": "2022-02-26 00:00:00"
    },
    {
      "id": "d24c3b2a-6927-4d4f-8c94-e11959f856bc",
      "text": "Analyses and expert commentary raised early concerns that weapons flowing into/conflict zones could be diverted to illicit markets and organized crime in the region.",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "102df67c-d144-4e2a-ae35-34d15662a08b",
      "text": "Ukrainian president publicly urged citizens to 'take up arms' and promised to arm those willing to defend the country.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "f49591dc-a252-46d5-9c5b-8cdddafe669b",
      "text": "Multiple reports described looting, chaotic seizures and movement of weapons during early weeks of the invasion, including eyewitness accounts of armory looting and seized materiel.",
      "date": "2022-03-16 00:00:00"
    },
    {
      "id": "8aad2ff8-5dab-4507-aaa0-4b93cf9bd890",
      "text": "WADA added meldonium to the prohibited list effective 1 January 2016 and high-profile meldonium cases (e.g., widespread media coverage in early–mid 2016) kept doping in the headlines throughout 2016.",
      "date": "2016-03-24 00:00:00"
    },
    {
      "id": "402383f6-7e8e-4fe5-98d1-2f49ecc8992b",
      "text": "UEFA had run its largest-ever anti-doping programme at Euro 2016 and on 1 July 2016 published that all tournament doping tests had returned negative results.",
      "date": "2016-07-01 00:00:00"
    },
    {
      "id": "654b1932-6580-4646-99d2-5e498312d281",
      "text": "Publication of a health-technology rapid review recommending consideration of pre‑treatment mouth rinses in dental settings (CADTH report on pre‑treatment mouth rinses).",
      "date": "2020-04-17 00:00:00"
    },
    {
      "id": "cf239229-aa46-44db-8fce-721d466fcdf9",
      "text": "Publication of a peer‑reviewed review article (Use of mouthwashes against COVID‑19 in dentistry) noting that povidone‑iodine mouthwash/nasal spray may reduce viral load and cross‑infection in dental settings (May 4, 2020).",
      "date": "2020-05-04 00:00:00"
    },
    {
      "id": "46029ac4-9931-4eb9-a261-618a19919178",
      "text": "Case series and literature review reporting 22 cases of new-onset inflammatory rheumatic diseases after COVID-19 vaccination (European Review for Medical and Pharmacological Sciences)",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "edef2453-14fd-47f1-87fe-2e982fe3cd5e",
      "text": "Release of a medRxiv preprint protocol and early scoping material (Sept 3, 2023) on COVID-19 vaccines and autoimmune disorders",
      "date": "2023-09-03 00:00:00"
    },
    {
      "id": "15cbd724-371f-49a4-a658-a30558418d7d",
      "text": "The New York Times publishes an opinion essay 'Donor Organs Are Too Rare. We Need a New Definition of Death.'",
      "date": "2025-07-30 00:00:00"
    },
    {
      "id": "3e86ebe1-a67e-4d4b-848b-e3d840e4902d",
      "text": "IPCC Special Report on Global Warming of 1.5 °C released, emphasizing much greater risks at 2 °C and urgency of rapid mitigation",
      "date": "2018-10-08 00:00:00"
    },
    {
      "id": "cd18e4e1-b254-4b25-812f-84266b128a47",
      "text": "United Nations Secretary-General and UN agencies issued high-profile warnings in 2018 about nearing a 'point of no return' and called for emergency action",
      "date": "2018-09-10 00:00:00"
    },
    {
      "id": "3cc24982-0e8e-402e-bc62-17a64ee6c945",
      "text": "Peer‑reviewed reports of increased myocarditis cases after mRNA COVID‑19 vaccination (large health‑care organization study)",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "66c5719f-412b-4670-af81-4531155c53ee",
      "text": "Steven R. Gundry AHA (Circulation) abstract reporting raised PULS cardiac‑test inflammatory markers after mRNA vaccination (abstract 10712)",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "147db351-5f97-4654-b8d4-bcee7ef4a9c5",
      "text": "Patent filings in 1989 listing Robert W. Malone as an inventor on early RNA/mRNA delivery and vaccine‑related patents.",
      "date": "None"
    },
    {
      "id": "24f64892-fea8-41c8-be4a-4d4252def5c3",
      "text": "Indexing and citation of Malone's 1989 work in biomedical databases (PubMed/Europe PMC) and secondary summaries.",
      "date": "None"
    },
    {
      "id": "89096621-ccff-490a-834b-b5c0636df3a7",
      "text": "Publication of 'Cationic liposome-mediated RNA transfection' (Malone, Felgner, Verma) demonstrating mRNA can be delivered into cells.",
      "date": "1989-08-15 00:00:00"
    },
    {
      "id": "60857a55-6193-4bd3-9d2f-63e1ba65d563",
      "text": "Reports of foreign/black particles found in Moderna vaccine vials in Japan and temporary batch suspensions (September 2021)",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "b75e94f6-e39d-40f2-b811-999f17412dce",
      "text": "Small pilot study reporting detectable SARS‑CoV‑2 spike antigen in plasma of some mRNA‑1273 (Moderna) vaccine recipients (Ogata et al.)",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "09cba8b1-bb6e-4bfd-8101-83de3c034186",
      "text": "American Bird Conservancy (and other conservation NGOs) public statements and campaigns highlighting risks of wind farms to raptors and calling for 'bird‑smart' planning (e.g., ABC 'Rethinking Wind Turbines' materials and Vineyard Wind statement)",
      "date": "2021-05-18 00:00:00"
    },
    {
      "id": "06a4bfe7-f036-450e-ad63-0e9898e7d636",
      "text": "U.S. Fish & Wildlife Service final rule revising eagle incidental take permitting, including a general permit option for wind energy (Federal Register/public guidance)",
      "date": "2024-02-12 00:00:00"
    },
    {
      "id": "d5bd185c-ef57-4e4a-b660-99b8fcb2005c",
      "text": "Release of Loss et al. (2013) meta‑analysis estimating annual bird collision mortality at U.S. wind facilities (widely cited ranges: ~140,000–328,000 birds/yr and broader ranges cited elsewhere)",
      "date": "2013-12-24 00:00:00"
    },
    {
      "id": "137a6f5e-f49b-41b5-bf2c-02f074fe9c84",
      "text": "Russian Defence Ministry public statement accusing Ukrainian forces of using phosphorus-filled munitions near Hostomel (Gostomel) airfield.",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "be2bced6-c4a5-48ad-8ede-83c8491b1c74",
      "text": "Pre-existing precedent of mutual accusations over incendiary/phosphorus use in earlier Ukraine conflicts (2014–2015), documented by monitoring bodies.",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "e4d4d79d-b10f-4d08-a363-500fae00fb83",
      "text": "UNICEF / UN agencies' early displacement reporting (end‑March 2022) showed millions fled Ukraine but the largest single share went to neighbouring EU countries (e.g., ~2.3 million to Poland by March 30, 2022).",
      "date": "2022-03-30 00:00:00"
    },
    {
      "id": "4490b780-f23f-4479-9e7d-54bdc8c5521d",
      "text": "Multiple media reports in April–May 2022 documented evacuations from besieged cities (notably Mariupol) in which some evacuation corridors or buses ended up routing civilians into Russia rather than to Ukrainian‑held territory.",
      "date": "None"
    },
    {
      "id": "8dc629cc-6231-4ba2-a045-563637816f47",
      "text": "Russian government issued a decree to simplify and fast‑track acquisition of Russian citizenship for residents of occupied Ukrainian regions (passportisation/policy announced May 2022).",
      "date": "2022-05-25 00:00:00"
    },
    {
      "id": "80dfeeb7-ac38-42b1-b1ea-fa79408aa30e",
      "text": "Russian foreign minister Sergey Lavrov publicly claimed that more than 1 million people had been 'evacuated' from Ukraine into Russia.",
      "date": "2022-04-30 00:00:00"
    },
    {
      "id": "8adca138-48cf-4cec-8ee7-f3b21d0c6e8b",
      "text": "Publication of peer-reviewed lab research (Heliyon, PubMed Central) showing antimicrobial activity of onion skin extracts (in vitro).",
      "date": "2020-11-12 00:00:00"
    },
    {
      "id": "8ad63261-9f3a-4a04-b6b0-8538bec06f31",
      "text": "Ukrainian Ministry of Social Policy announced registration of 1.58 million IDPs from Donbas and Crimea.",
      "date": "2017-06-19 00:00:00"
    },
    {
      "id": "aa124032-a0ad-44b6-8e8f-2e7e273ef0eb",
      "text": "IOM National Monitoring System report (June 2017) identified unemployment as the most problematic issue for IDPs and documented barriers to employment.",
      "date": "2017-06-24 00:00:00"
    },
    {
      "id": "9bb4a6f5-b8ce-4b2e-aabb-3bb74868c8bd",
      "text": "Atlantic Council report (2015) and related studies documented employer discrimination and negative media portrayals against IDPs from Donbas (including job adverts excluding Donbas residents).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "a65d0fc8-2448-4a5d-924a-b04069b6fc51",
      "text": "International Tribunal for the Law of the Sea (ITLOS) ordered Russia to release three Ukrainian naval vessels and their crews",
      "date": "2019-05-25 00:00:00"
    },
    {
      "id": "ea47cd6c-8c9d-45fd-90d1-ba14cea5fec8",
      "text": "September 2019 Russia–Ukraine prisoner swap that included the release of 24 Ukrainian sailors seized in the Kerch incident",
      "date": "2019-09-07 00:00:00"
    },
    {
      "id": "a5c5b65b-1f44-4639-982c-5025cf54c182",
      "text": "Anti‑NATO demonstration in front of the U.S. Embassy in Bratislava",
      "date": "2015-03-24 00:00:00"
    },
    {
      "id": "302e2cc2-3c88-4d37-b183-ae8e562b26dd",
      "text": "Washington Post reports Western countries supplying more and heavier weapons to Ukraine (coverage of weapons shipments and policy shifts).",
      "date": "2022-04-26 00:00:00"
    },
    {
      "id": "af2c3128-fc8e-4faf-8982-9ba6b27e0e80",
      "text": "NATO and the United States announced reinforcements to Eastern Europe (ships, fighter jets and additional troops put on alert).",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "cec36efa-53e2-4ab2-b41e-6b9e8bb2509a",
      "text": "Reports that U.S. military trainers previously operating in Ukraine were being withdrawn as the invasion threat rose (indicating U.S. personnel had been present inside Ukraine).",
      "date": "2022-02-12 00:00:00"
    },
    {
      "id": "d851bb9b-c1dd-4b50-b86d-d7e0a70fcc71",
      "text": "Continued availability/promotion of Hoxsey therapy in Tijuana, Mexico (clinics offering the regimen)",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "2ce479fd-0786-42c1-ac4d-082e5c7da9a9",
      "text": "Regulatory and enforcement actions against colloidal silver and related products marketed as COVID-19 treatments (FDA warning letters in 2020; DOJ injunction halting sale of silver product April 29, 2020).",
      "date": "2020-08-14 00:00:00"
    },
    {
      "id": "dd0a5af4-8344-4b4c-a3db-f0654ea0fbe2",
      "text": "Publication of randomized trials showing some benefit for inhaled budesonide in early COVID-19 (STOIC trial / Lancet Respiratory Medicine reporting, April 2021).",
      "date": "2021-04-09 00:00:00"
    },
    {
      "id": "4d10fff5-7f39-4071-88fd-5dd756dceb9a",
      "text": "Amnesty International briefing (October 2014) documenting summary killings in eastern Ukraine while cautioning that some atrocity reports had been misreported or exaggerated.",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "ff0dd947-d591-4a91-98f5-7e8568e5a3ee",
      "text": "Discovery and media reporting of a mass grave near Sloviansk (exhumed July 24, 2014) during the eastern Ukraine fighting.",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "b6ed7ce5-601b-4916-aec6-97171aa1061b",
      "text": "Formation and visible operations of the Azov volunteer battalion (formed May 2014) alongside National Guard units in 2014, generating reports about far‑right elements within volunteer units linked to the state security apparatus.",
      "date": "2014-05-05 00:00:00"
    },
    {
      "id": "52ae8b98-0c2e-45b6-84d4-fd25071809c6",
      "text": "Parliament adopts the 2019 'On ensuring the functioning of Ukrainian as the State language' law",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "cb5848bb-bde4-4f81-a8d8-dac5555f3d7b",
      "text": "President Zelenskiy/NSDC sanctions and broadcasting blocks on three pro‑Russian TV channels",
      "date": "2021-02-02 00:00:00"
    },
    {
      "id": "9f61cba0-938a-4422-abfa-db301ff868e1",
      "text": "Passage of decommunization laws banning Soviet symbols and reshaping public memory",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "b4f1c228-054d-4b10-9e6d-9b2bcf5b05f3",
      "text": "Adoption of the 2017 Education Law with provisions on language of instruction",
      "date": "2017-09-05 00:00:00"
    },
    {
      "id": "9d9755e7-2d6b-471e-9d6e-6602173c5e12",
      "text": "Zelensky withdrew or delayed controversial decentralization/reintegration bills (including a draft on decentralization/reintegration of Donbas) in early 2020 amid criticism and revision.",
      "date": "2020-01-16 00:00:00"
    },
    {
      "id": "92f6dcbf-31fe-4a96-a55d-1a6bc36d8c2b",
      "text": "Domestic controversy in Ukraine over the ‘Steinmeier formula’ (autumn 2019) and protests against implementing Minsk‑related measures.",
      "date": "2019-10-24 00:00:00"
    },
    {
      "id": "55516b8d-0683-4117-ad3c-ec5487d82730",
      "text": "Early 2021 reports and papers documenting vaccine‑induced immune thrombotic thrombocytopenia (VITT) after adenoviral-vector COVID-19 vaccines (e.g., AstraZeneca), including cases of cerebral venous sinus thrombosis.",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "c2401e50-09b0-40a7-9572-7e712e2d271a",
      "text": "Israel ends mandatory water fluoridation (policy change reported August 2014)",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "8ec85d90-fc7b-4af1-9c84-98cf7584c0b7",
      "text": "National Research Council (NRC) report 'Fluoride in Drinking Water: A Scientific Review of EPA's Standards' (2006)",
      "date": "2006-04-24 00:00:00"
    },
    {
      "id": "9b70c841-3399-48a6-9656-f80396fdc314",
      "text": "Arrest of four men by the SBU alleged to be smuggling uranium‑238 in western Ukraine",
      "date": "2015-08-05 00:00:00"
    },
    {
      "id": "5caeed35-980a-4cdc-8f83-12122d6ac3b7",
      "text": "Reports that conflict damaged or destroyed radiation detection/monitoring equipment supplied to Ukraine",
      "date": "None"
    },
    {
      "id": "3758d0d9-bc1d-4755-a92a-34b2b5b49878",
      "text": "Peer‑reviewed assessment of radionuclide resuspension and atmospheric transport from the 2015 Chernobyl fires",
      "date": "None"
    },
    {
      "id": "e00401eb-37ca-4d71-a936-54f7c6dcfb52",
      "text": "WHO interim guidance on mask use updated (June 5, 2020)",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "8cb31e1c-ec7e-45e0-9991-a1721f0650c9",
      "text": "Publication of the Great Barrington Declaration advocating 'focused protection' (October 4, 2020)",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "edbe9a31-3a33-4d14-87f3-befeab22bef0",
      "text": "Announcement of Operation Warp Speed / rapid vaccine development programs (May 15, 2020)",
      "date": "2020-05-15 00:00:00"
    },
    {
      "id": "31852110-628f-48e8-a05c-31ccee743dce",
      "text": "Public remarks by Ukraine’s TCG representative Iryna Herashchenko noting lack of progress on exchanges",
      "date": "2018-05-04 00:00:00"
    },
    {
      "id": "ecd54e83-ea75-438a-a38a-78890ca0d766",
      "text": "Background context: prisoner exchanges had been irregular/stalled since late 2017 (last major swap Dec 27, 2017), creating a longer-term perception of negotiation breakdowns",
      "date": "2018-02-28 00:00:00"
    },
    {
      "id": "7cf42c5e-169f-4ebe-ab61-f1a10e95149f",
      "text": "Trilateral Contact Group (Minsk) humanitarian subgroup meeting (early May 2018) reported to have produced 'no results' on prisoner lists",
      "date": "2018-05-04 00:00:00"
    },
    {
      "id": "ce9d23e1-d0d6-401c-8f9e-9ade8ee9bfad",
      "text": "WHO interim laboratory testing guidance (March 19, 2020) describing that nucleic acid detection indicates viral RNA presence but does not directly specify infectious virus for all sample types.",
      "date": "2020-03-19 00:00:00"
    },
    {
      "id": "7c090bae-4199-4bf7-9604-5c65660aff00",
      "text": "Publication of the WHO-recommended/early RT‑PCR assay protocols (Corman et al., Eurosurveillance) that specify short primer/probe targets.",
      "date": "2020-01-23 00:00:00"
    },
    {
      "id": "98818f07-7366-4038-8c67-126e16ada268",
      "text": "CDC and FDA recommended a temporary pause in the use of the Johnson & Johnson (Janssen) COVID-19 vaccine following reports of rare blood clotting events.",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "04806cd9-9b90-4ae0-af5f-b60428f4ac1a",
      "text": "United Nations’ admission of a role in the 2010–2016 Haiti cholera outbreak (U.N. acknowledgement, 2016)",
      "date": "2016-08-24 00:00:00"
    },
    {
      "id": "d0771d19-f756-4cd3-9786-9fde6fbf2023",
      "text": "1996 Pfizer Trovan drug trial in Kano, Nigeria (reports of child deaths and subsequent lawsuits)",
      "date": "1996-04-24 00:00:00"
    },
    {
      "id": "0778b390-a2ee-4d01-98c9-cb1a9bde1902",
      "text": "Release of the NIPCC report 'Climate Change Reconsidered II' (skeptic alternative to IPCC) that downplays harms of rising CO2 and highlights perceived benefits.",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "35c1e621-4969-4e5c-9003-b0583ca8939c",
      "text": "Public-health guidance and technical documents (e.g., UK 'Understanding cycle threshold (Ct) in SARS-CoV-2 RT‑PCR') explaining Ct interpretation variability and assay differences circulated during 2020.",
      "date": "2020-09-24 00:00:00"
    },
    {
      "id": "e9be2f07-0ef3-4c7e-aa68-19ae2471474c",
      "text": "Peer‑reviewed/clinical comparisons published showing comparable detection rates between saliva and nasopharyngeal swabs (Journal of Infection letter, June 2020)",
      "date": "2020-06-04 00:00:00"
    },
    {
      "id": "8e3d1db2-3b77-4d35-9896-79ee893fef39",
      "text": "FDA issues Emergency Use Authorization for Rutgers' saliva-based COVID-19 test",
      "date": "2020-04-13 00:00:00"
    },
    {
      "id": "b423ba88-db77-4c34-a7a6-f53445b95467",
      "text": "IPCC Fifth Assessment Report (AR5, 2013) presentation of sea-level projections with explicit uncertainty ranges and caveats.",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "8db37b71-9f12-49f1-bb1a-ba3ccda5847b",
      "text": "US political signal: announcement of intent to withdraw from the Paris Agreement (President Trump, June 1, 2017) and sustained political amplification.",
      "date": "2017-06-01 00:00:00"
    },
    {
      "id": "32e32477-4bb8-4504-a027-27fc77d8c334",
      "text": "Poland's competition watchdog opens proceedings against Gazprom over Nord Stream 2",
      "date": "2018-05-16 00:00:00"
    },
    {
      "id": "9e1996d1-59c5-4235-96d7-3177babcb7f3",
      "text": "Poland's controversial 'Holocaust law' sparks international criticism",
      "date": "2018-01-27 00:00:00"
    },
    {
      "id": "b5679d9f-403a-48aa-a58b-18d8bee4635c",
      "text": "European Commission triggers Article 7 procedure against Poland over judicial reforms",
      "date": "2017-12-20 00:00:00"
    },
    {
      "id": "ccafa14f-33e2-4e2f-844e-8fca6079b32a",
      "text": "Law and Justice (PiS) strong performance in the 2019 European Parliament elections",
      "date": "2019-05-26 00:00:00"
    },
    {
      "id": "2a611ae1-745b-4bb1-ae10-25288b6cb9fc",
      "text": "Reports of illicit trafficking and discovery of radioactive sources in scrap/transport (Ukraine, 2015)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "682d7d53-1e3b-4d7c-ae9a-5c149108e4f9",
      "text": "2015 wildfires in the Chernobyl Exclusion Zone and fears of radionuclide resuspension",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "dbd04912-2116-4721-be14-a71801cd3c32",
      "text": "Calving of iceberg A‑68 from the Larsen C ice shelf (July 2017).",
      "date": "2017-07-12 00:00:00"
    },
    {
      "id": "69b95343-c252-4a88-8e33-88c27080b854",
      "text": "California expanded laws and funding to increase prescribed and cultural burning (state bills and Newsom signings, October 2021) to reduce fuels.",
      "date": "2021-10-11 00:00:00"
    },
    {
      "id": "08c4a7d8-a808-40c5-b31a-7003fa42378b",
      "text": "California utilities implemented mass Public Safety Power Shutoffs (PSPS) in 2019 to prevent power‑line ignitions during high‑wind conditions.",
      "date": "2019-10-24 00:00:00"
    },
    {
      "id": "aa7d3860-9a7b-4b71-9e39-2d706c63a28e",
      "text": "Public statements and media interviews by frontline firefighters expressing that poor forest conditions and suppression policy (not climate change alone) drive severe fires (example: Sky News interview with California firefighter, Aug 2020).",
      "date": "2020-08-24 00:00:00"
    },
    {
      "id": "c4b94532-7a76-4ebc-a460-d01465b113e2",
      "text": "PG&E pleaded guilty to 84 counts of involuntary manslaughter and unlawfully starting the 2018 Camp Fire, confirming utility equipment ignition of a major California blaze.",
      "date": "2020-06-16 00:00:00"
    },
    {
      "id": "12a88459-c669-4b94-9645-9be73587f944",
      "text": "UNDP/SEESAC and other surveys (2012–2016) documenting large numbers of small arms and light weapons — including unregistered/illicit stockpiles — in Moldova and the region",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "e860db1a-8641-4f76-a140-b16a9d94307d",
      "text": "Kuwait arrests members of an alleged ISIS-supporting cell who reportedly claimed to have bought weapons via Ukraine",
      "date": "2015-11-19 00:00:00"
    },
    {
      "id": "5a8463b3-4d4f-4daf-b7b8-dd573ad540c6",
      "text": "Public and political skepticism, local resistance and commentary about his appointment in Odesa (reports of local political tensions)",
      "date": "2015-05-31 00:00:00"
    },
    {
      "id": "6db38e74-24f3-4a2f-ae3a-8d02b9d72dd8",
      "text": "Appointment of Mikheil Saakashvili as Governor (head) of Odesa Oblast",
      "date": "2015-05-30 00:00:00"
    },
    {
      "id": "603921ad-e52a-4410-99ec-8fd86d16e5c2",
      "text": "Cabinet of Ministers submits Draft Law No. 10449 on mobilization to the Verkhovna Rada",
      "date": "2024-01-30 00:00:00"
    },
    {
      "id": "74e64fca-287d-4d78-a676-00b2f615bdcf",
      "text": "Israel / NEJM studies (2021) reporting a small increased incidence of myocarditis after Pfizer mRNA vaccination, especially in young males",
      "date": "2021-10-06 00:00:00"
    },
    {
      "id": "59688e0a-e6b1-4686-9d80-3ed2b50a11b0",
      "text": "Japan suspends and recalls Moderna vaccine batches after discovery of black/stainless‑steel particles in vials",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "cd5c2b41-5c7f-4a55-9ab2-88fc3ef91c4c",
      "text": "UN/IAEA inspection mission planning and travel to Zaporizhzhia amid continued shelling and accusations by both sides.",
      "date": "2022-08-29 00:00:00"
    },
    {
      "id": "65a33ed5-7059-4720-8664-71df06856cd6",
      "text": "A fire and visible shelling at the Zaporizhzhia site during early March combat (surveillance footage showed a flare/impact on site).",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "9579faa0-0177-45b7-9056-8029d8924320",
      "text": "Repeated losses of external (off‑site) power to the Zaporizhzhia plant and reports that the plant was at times disconnected from its last external power line.",
      "date": "2022-08-24 00:00:00"
    },
    {
      "id": "95e05178-60f7-4cbe-bd9b-5bf961bdef01",
      "text": "Russian forces seized and occupied the Zaporizhzhia Nuclear Power Plant during the Battle of Enerhodar.",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "e8a190db-bcc2-4cc0-8eb7-44c244f670d8",
      "text": "CDC changes public guidance to recommend cloth face coverings in public settings (official guidance posted April 3, 2020)",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "a2bb928e-2e84-4e3e-81ee-b83ba79b568d",
      "text": "Study estimating high proportion of asymptomatic SARS-CoV-2 infections on the Diamond Princess cruise ship (Mizumoto et al., Euro Surveill., published Feb 2020)",
      "date": "2020-02-12 00:00:00"
    },
    {
      "id": "748a15bf-517c-467d-b641-dc29fcee8d35",
      "text": "NEJM correspondence reporting transmission of 2019-nCoV from an apparently asymptomatic contact in Germany (Rothe et al., published Jan 30, 2020)",
      "date": "2020-01-30 00:00:00"
    },
    {
      "id": "e1847ff0-930b-42fd-a04c-2eb5f02fd7e0",
      "text": "OPCW Investigation and Identification Team (IIT) first report identifying Syrian government responsibility",
      "date": "2020-04-08 00:00:00"
    },
    {
      "id": "735a9667-6b3e-4e28-89bd-78eefd76f362",
      "text": "Human-rights organisations report abuses by volunteer battalions deployed in Donbas",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "da008d27-7472-4d62-996b-7ab8966b19c8",
      "text": "Integration of volunteer battalions (including Azov) into Ukraine's National Guard",
      "date": "2014-11-11 00:00:00"
    },
    {
      "id": "7731cec2-7cdd-4637-a82a-9e0a7fc3523b",
      "text": "March 2015 incident where armed men linked to oligarch Ihor Kolomoisky occupied state oil company offices",
      "date": "2015-03-23 00:00:00"
    },
    {
      "id": "31ee3b51-269e-4dfc-8198-05a6d28587ab",
      "text": "Reports of timber import restrictions and new controls on Russian wood across Europe and the UK",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "c8625782-7e9f-43f8-9213-eb09f5957d9c",
      "text": "UK and allies impose wide-ranging sanctions on Russia after the 2022 invasion",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "657382bb-d2cb-4305-9efb-21db8233240c",
      "text": "News coverage of reusable/eco toilet-paper products appearing on the UK market",
      "date": "2022-08-16 00:00:00"
    },
    {
      "id": "f3f664b5-f1c9-46f1-acd1-599ecafc9a9f",
      "text": "Euronews published video coverage (Feb 5, 2022) of the Kharkiv Unity March showing large Ukrainian-language banners (e.g., 'Kharkiv is Ukraine') and many Ukrainian flags, with only a small number of English-language signs visible in brief shots.",
      "date": "2022-02-05 00:00:00"
    },
    {
      "id": "12b17193-4706-4f24-ad55-383db3074772",
      "text": "Growing public debate and some evidence of souring Polish attitudes toward Ukrainian refugees documented in 2022 news reports and surveys.",
      "date": "2022-08-04 00:00:00"
    },
    {
      "id": "1ca2ef26-0ed5-4d56-850e-a636b6eff698",
      "text": "Leszek Sykulski and collaborators announced a Polish anti-war movement and proposed billboard campaign with the slogan 'This is not our war'.",
      "date": "2023-01-31 00:00:00"
    },
    {
      "id": "e81e7d4f-67c0-48fd-a9d7-8ff407f9d70b",
      "text": "White House announces 50–52% economy-wide greenhouse gas reduction target (Leaders Summit on Climate fact sheet)",
      "date": "2021-04-22 00:00:00"
    },
    {
      "id": "d3a08662-4d96-4236-96ba-063d7de46717",
      "text": "Poore & Nemecek (Science) meta-analysis showing high emissions from beef and animal products",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "d745da97-1080-4d18-a214-49591427f1cc",
      "text": "EAT-Lancet Commission releases 'planetary health diet' recommendations (widely covered)",
      "date": "2019-01-24 00:00:00"
    },
    {
      "id": "f842785f-7bc0-41b7-8adf-4be7195bfd1f",
      "text": "Adoption of Ukraine's 2017 'On Education' law increasing Ukrainian-language instruction (and subsequent Venice Commission attention/criticism)",
      "date": "2017-09-05 00:00:00"
    },
    {
      "id": "87e1ed4d-7fb1-495b-8e0a-a85a0d6596a2",
      "text": "Lviv Oblast Council approves a moratorium on public use of Russian-language books, films and music in the region",
      "date": "2018-09-18 00:00:00"
    },
    {
      "id": "a1029f55-fc1f-462b-a001-b99c9358ee2e",
      "text": "2015 restrictions on Russian films and cultural imports (bans/curbs on films and some cultural products after 2014)",
      "date": "2015-04-06 00:00:00"
    },
    {
      "id": "55d5c23f-5205-4f18-b5d6-5fd8b9299c4b",
      "text": "Reversal of the 2012 regional-language law (the Kivalov–Kolesnichenko law) after the 2014 Maidan changes",
      "date": "2014-02-23 00:00:00"
    },
    {
      "id": "cb74013e-54c4-4e79-ad4f-9c3287eb0ec8",
      "text": "U.S. safety monitoring system (CDC Vaccine Safety Datalink) detected a statistical signal for ischemic stroke in people aged 65+ after the Pfizer–BioNTech bivalent booster; CDC/FDA announced they were investigating the signal.",
      "date": "2023-01-13 00:00:00"
    },
    {
      "id": "18a6c232-9e9e-4d2e-bb6f-4c32c1876c91",
      "text": "Earlier vaccine safety controversies (notably rare clotting events linked to adenovirus-vector COVID-19 vaccines such as AstraZeneca in 2021) remained widely recalled and were used as precedent by commentators to suggest COVID vaccines can cause serious cerebrovascular events.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "1dc2d18f-7d20-40b4-b306-835da288cc24",
      "text": "Russia’s parliament approved President Putin’s request to use armed forces in Ukraine",
      "date": "2014-03-01 00:00:00"
    },
    {
      "id": "24afa0a8-4d76-40ce-9afa-3bf870a96fce",
      "text": "Chinese Foreign Ministry urged restraint and avoided direct comment on the Crimea referendum",
      "date": "2014-03-03 00:00:00"
    },
    {
      "id": "7caa6b44-edda-4b37-8343-03733cfae459",
      "text": "Unidentified armed men (widely reported as Russian forces) seized Crimean airports (Simferopol and Belbek) and other sites",
      "date": "2014-02-28 00:00:00"
    },
    {
      "id": "48103b8c-b7b1-4459-b902-e8dd3da7e54d",
      "text": "CMS release of the Medicare COVID-19 Vaccine Public Use File (PUF) / Medicare COVID-19 vaccine analysis",
      "date": "2021-08-06 00:00:00"
    },
    {
      "id": "950d7990-be2c-4d4d-b8cd-183b3456afd1",
      "text": "April 2021 pause and review of the Johnson & Johnson (Janssen) COVID‑19 vaccine after reports of rare blood‑clotting events (TTS).",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "84b11ee7-077e-47f6-80fc-01a20fe348eb",
      "text": "Japan suspended and recalled multiple Moderna vaccine batches after reports of contamination (stainless‑steel particles) at some vaccination sites.",
      "date": "2021-08-25 00:00:00"
    },
    {
      "id": "f9fb6469-9308-42c3-b83c-a05198123ffe",
      "text": "Poland publicly pushed for coordinated EU action over Belarus and called for an extraordinary EU response after the election",
      "date": "2020-08-10 00:00:00"
    },
    {
      "id": "9e531e8e-237f-4247-b459-eae80fadd5e9",
      "text": "Belarus opposition figure Sviatlana Tsikhanouskaya flees Belarus to neighbouring Lithuania",
      "date": "2020-08-11 00:00:00"
    },
    {
      "id": "a54a02cb-64db-4c71-b0e0-1adb45b0c3c3",
      "text": "Lukashenko publicly accused opponents and foreign states of meddling in Belarusian affairs (blaming outside influence) in early August 2020",
      "date": "2020-08-04 00:00:00"
    },
    {
      "id": "69ee9d16-acbf-4105-8a4e-7742e50c76c9",
      "text": "Scientific and review literature summarizing Traditional Chinese Medicine meridian theory and the popular \"tooth-to-organ/meridian\" charts (peer-reviewed reviews / PMC article)",
      "date": "2013-04-24 00:00:00"
    },
    {
      "id": "d80a8c53-92e9-4ff9-a558-32a8b1313d4a",
      "text": "Peer‑reviewed survey showing TikTok is a major source of health information for young women (published May 21, 2024)",
      "date": "2024-05-21 00:00:00"
    },
    {
      "id": "43f29fae-8a37-48a2-ac30-5cdadd238303",
      "text": "Longstanding 'hockey stick' controversy and critiques (McIntyre & McKitrick and public debate 2003–2007)",
      "date": "None"
    },
    {
      "id": "e6edeb03-0ca9-422f-b5fa-4244d92faf5d",
      "text": "OSCE SMM spot report on shelling incidents in Mariupol (Olimpiiska Street) reporting civilian casualties",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "2a5f7b1f-2bcb-48ea-84c8-82d1106b3c3f",
      "text": "High-profile shelling of a bus/trolleybus stop in Donetsk reported to have killed civilians (media reports, Jan 22, 2015)",
      "date": "2015-01-22 00:00:00"
    },
    {
      "id": "4006480a-753c-45ce-aa6b-ecf3456a9b65",
      "text": "OSCE SMM statement (weekly update) noting 29 people had been killed 'this year' as of mid-January",
      "date": "2015-01-15 00:00:00"
    },
    {
      "id": "a38e8719-88d5-46ef-90f4-a32993b6cfdc",
      "text": "IFRC deployment to assist Ukraine outbreak response (Red Cross mobilised to help contain largest measles outbreak in Europe)",
      "date": "2019-03-05 00:00:00"
    },
    {
      "id": "6d355a7b-b9d4-4acc-853e-dd80ef633109",
      "text": "EU visa‑suspension mechanism in law (Regulation creating a mechanism to temporarily suspend visa‑free travel, adopted 2013)",
      "date": "2013-12-11 00:00:00"
    },
    {
      "id": "8a50c084-5b2c-4fdb-ad04-e211a34541ee",
      "text": "Deployment/arrival of U.S. troops to Poland as part of NATO rotations (Zagan arrival reported)",
      "date": "2017-01-12 00:00:00"
    },
    {
      "id": "34cb44d4-ecd2-467c-9936-4a6b286b6edb",
      "text": "Polish government passes resolution to create the Central Communication Port (CPK) programme",
      "date": "2017-11-09 00:00:00"
    },
    {
      "id": "3f46d12f-b64f-4d48-87e1-1c65835f7681",
      "text": "NATO/US-led exercise Saber Strike 2017 mobilises thousands of troops and long tactical movements across Poland and the Baltics",
      "date": "2017-06-24 00:00:00"
    },
    {
      "id": "ac8bf186-9f81-4e86-bcf8-9581ca6de9ba",
      "text": "U.S. President Donald Trump’s high‑profile visit to Warsaw and public expressions of closer US‑Poland ties",
      "date": "2017-07-06 00:00:00"
    },
    {
      "id": "e2cc15df-04af-44fd-bb34-b2ad74cc09fe",
      "text": "Public descriptions of CPK emphasise a large rail logistics centre and high‑speed rail links connecting the planned airport to the national network",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "5f00f9bc-f04d-4326-9b92-b94a44d73a3d",
      "text": "IPCC AR6 Synthesis Report (approved and released March 2023) summarizing complex carbon cycle information",
      "date": "2023-03-20 00:00:00"
    },
    {
      "id": "8f89cdbd-4592-4ad5-a926-7e091ad7e6ba",
      "text": "Global Carbon Project publishes the Global Carbon Budget 2022 showing large natural carbon fluxes alongside high anthropogenic emissions",
      "date": "2022-11-11 00:00:00"
    },
    {
      "id": "b96c12ae-9f4e-466b-ae2d-8134b211c5aa",
      "text": "The Economist published analysis 'A Ukrainian attempt to retake Crimea would be bloody and difficult' framing retaking Crimea as high‑risk and costly",
      "date": "2022-11-27 00:00:00"
    },
    {
      "id": "4a1aec55-354a-4dcf-909d-a6903b8a9660",
      "text": "Poland announced it would transfer Leopard tanks/Leopard tank company to Ukraine (President Duda’s statement in Lviv)",
      "date": "2023-01-11 00:00:00"
    },
    {
      "id": "11bae64a-bdb5-4f1c-ad4d-c94f6ca02f82",
      "text": "Madrid (Spain) converted an Olympic-sized ice rink into a temporary morgue amid COVID-19 deaths (widely reported March 24, 2020).",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "b2b1a5d6-a348-471b-9c4e-fe7b3293beac",
      "text": "Regulatory reviews and media coverage of rare AstraZeneca blood‑clotting events (European/UK reviews and reporting)",
      "date": "2021-03-18 00:00:00"
    },
    {
      "id": "a92b3d5e-f95e-4a99-a370-4c0147a5b7ca",
      "text": "Large overnight Russian attack on Odesa's power grid caused region-wide blackouts",
      "date": "2025-12-13 00:00:00"
    },
    {
      "id": "a7cedfd2-fd1a-4ef5-97d2-795081566985",
      "text": "Publication of a broad 2021 review (Nutrients) summarizing diverse immune effects of bovine colostrum",
      "date": "2021-10-26 00:00:00"
    },
    {
      "id": "1c7b73b0-2310-446c-8277-54767060f75d",
      "text": "Contamination and design problems with the CDC's initial COVID-19 test kits (early 2020)",
      "date": "2020-02-24 00:00:00"
    },
    {
      "id": "b87164bf-f264-4ec3-bc7d-3b7891722a46",
      "text": "Study showing RT-PCR cycle threshold (Ct) correlates with viral culture positivity (Bullard et al.)",
      "date": "2020-07-24 00:00:00"
    },
    {
      "id": "0acef6c0-1f2d-4dcc-9a90-e29b93793897",
      "text": "IAEA and Ukrainian authorities publicly highlighted nuclear‑safety and remediation needs for Ukraine’s legacy nuclear and uranium sites, with heightened attention after 2014.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "bc8de606-d518-472e-8e59-39337287205d",
      "text": "Longstanding presence of large uranium mining and processing facilities in Zhovti Vody (Eastern Mining and Processing Plant), which has processed uranium ores since the late 1950s.",
      "date": "1959-04-24 00:00:00"
    },
    {
      "id": "8207856c-0cb1-442f-97f6-17f538dd9ff6",
      "text": "Ferrybridge motorway service station (UK) brought in a generator to power new EV chargers because of local grid-supply issues.",
      "date": "2023-08-02 00:00:00"
    },
    {
      "id": "8ffdfd68-1b2a-4e92-9ff4-e3e811d91c70",
      "text": "Reporting that Tesla's high-profile Harris Ranch 'Mega' Supercharger location has historically been supplemented at times by diesel generation to meet peak demand.",
      "date": "2023-09-06 00:00:00"
    },
    {
      "id": "17401565-66ca-437e-b0a6-136ef3724107",
      "text": "BMJ coverage summarising tens of thousands of reports of menstrual changes after COVID-19 vaccination (BMJ report on MHRA Yellow Card reports).",
      "date": "2021-09-15 00:00:00"
    },
    {
      "id": "82a4cb5a-2b30-4906-9627-1c8593ce8dc7",
      "text": "Publication of a large Danish cohort study linking hormonal contraception with increased rates of antidepressant use and diagnoses of depression (Skovlund et al.).",
      "date": "2016-09-28 00:00:00"
    },
    {
      "id": "f5ad2cce-9961-444b-8007-5874a232d25a",
      "text": "Release of international PCOS management guidance and reviews identifying combined oral contraceptives as first-line therapy for menstrual regulation and hyperandrogenism in PCOS (International evidence‑based PCOS guideline, 2018).",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "19352e34-aca6-4dbd-a538-04e985ad70d7",
      "text": "High‑profile scientific attention on rapid changes at Thwaites Glacier (BAS reporting, Sept 2019)",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "9a14913e-e877-4406-8c04-9675beb0ae54",
      "text": "Poroshenko had a documented public engagement on 23 September 2015 — a meeting with U.S. Senator John McCain in Kyiv.",
      "date": "2015-09-23 00:00:00"
    },
    {
      "id": "3280a9e5-4f53-42df-97d6-80dfad2b3a63",
      "text": "Pentagon Inspector General report found that about $1 billion worth of U.S. weapons sent to Ukraine were not properly tracked.",
      "date": "2024-01-11 00:00:00"
    },
    {
      "id": "69643293-59b1-4d82-b831-0d3d5c86ed29",
      "text": "President Trump ordered a temporary 'pause' on deliveries of U.S. military assistance to Ukraine following a heated Oval Office exchange.",
      "date": "2025-03-04 00:00:00"
    },
    {
      "id": "b96a6933-b915-4bf3-8058-724297dab033",
      "text": "Prominent U.S. conservative media figures and commentators publicly questioned the scope and effectiveness of U.S. aid to Ukraine (for example, Laura Ingraham called continued aid 'a losing cause').",
      "date": "2023-10-31 00:00:00"
    },
    {
      "id": "90b494bf-039b-4e54-a6f1-4c80e755714b",
      "text": "IPCC Sixth Assessment Report (AR6 WG1) release summarizing model performance and attribution of recent warming",
      "date": "2021-08-06 00:00:00"
    },
    {
      "id": "f50a5420-3ac2-4800-aa10-086f3b074789",
      "text": "Publication (1989) of Malone et al., 'Cationic liposome-mediated RNA transfection' (PNAS), an early demonstration of RNA delivery into cells.",
      "date": "1989-08-15 00:00:00"
    },
    {
      "id": "b060cf25-4818-4962-a079-b0943a233663",
      "text": "Think‑tank and Western analyst warnings that the Kremlin was building informational conditions to blame Ukraine for chemical or radiological false‑flag attacks",
      "date": "2022-10-24 00:00:00"
    },
    {
      "id": "683c1f14-e8e4-4de8-8dad-c9e3a47ec671",
      "text": "Multiple European countries temporarily suspended use of the AstraZeneca COVID-19 vaccine after reports of blood clots (mid-March 2021)",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "bd33352a-5503-4615-89fc-28d9a8fc5de9",
      "text": "Peer-reviewed genome-wide association studies (GWAS) identified an association between the ABO blood-group locus and COVID-19 susceptibility and severity, widely reported in the media in 2020.",
      "date": "2020-06-17 00:00:00"
    },
    {
      "id": "5f06c143-7e85-43b4-bfd8-a9cc5030c2e9",
      "text": "Pre-existing disinformation narratives and documented propaganda techniques had been actively denigrating Ukrainian refugees across Europe since 2022 (e.g., claims that refugees are violent or criminal).",
      "date": "2023-02-19 00:00:00"
    },
    {
      "id": "4cbccbd9-75d6-4806-85d6-6e3f1ac612b0",
      "text": "Rise of anti-Macron / far-right political sentiment in 2024 (EU and national election results and commentary)",
      "date": "2024-06-09 00:00:00"
    },
    {
      "id": "9083b198-ef58-4d0a-b7b5-7f51f62c70a4",
      "text": "WHO-China Joint Mission report (final report) published, summarizing early clinical findings and noting the role of underlying conditions and comorbidities among severe COVID-19 cases.",
      "date": "2020-02-28 00:00:00"
    },
    {
      "id": "b636559f-f440-461e-8b2a-e27f8e0a5bba",
      "text": "Mass issuance of Russian passports to Crimea residents after annexation, with many seen lining up to exchange Ukrainian passports for Russian ones",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "1b110999-77b0-4a7f-986f-a8f1d4d159cd",
      "text": "Media reports of waning Pfizer vaccine effectiveness from Israel (mid‑2021)",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "54befbf4-323e-4ec4-b0d5-6b075fbfff8e",
      "text": "Human Rights Watch report on unguided rockets and civilian harm in Donetsk",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "97bcabff-36fe-4906-a8f1-49e45a2230c0",
      "text": "Operation Protective Edge (Israel–Gaza), heavy photographic coverage of urban shelling",
      "date": "None"
    },
    {
      "id": "904c1337-d922-43ba-aaf3-bee846b59cc8",
      "text": "UN OHCHR published reports documenting thousands of civilian casualties and human-rights violations in Donetsk and Luhansk since 2014",
      "date": "2019-08-15 00:00:00"
    },
    {
      "id": "9c8061a4-b6c8-4b01-9126-324edde1a3da",
      "text": "Government of Ukraine lodged an Article 12(3) declaration accepting ICC jurisdiction over alleged crimes on its territory (covering events since February 2014)",
      "date": "2015-09-08 00:00:00"
    },
    {
      "id": "6be5c24a-fd13-42a4-aef3-2c7811909f68",
      "text": "International Criminal Court opened a preliminary examination into the situation in Ukraine",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "6d97834d-047e-469c-966f-03494c01663a",
      "text": "Multiple U.S. states sought to restrict or suspend abortion services as 'non-essential' during COVID-19 emergency orders (March–April 2020).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "bcd00958-f1de-40a1-b1c1-5dbcc6a4a0f4",
      "text": "Guttmacher Institute releases 'Abortion Worldwide 2017' report estimating ~55.9 million abortions per year (2010–2014).",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "3b01f3e9-0884-4056-9947-42c14ea3c2f3",
      "text": "World Health Organization declares COVID-19 a pandemic (March 11, 2020).",
      "date": "2020-03-11 00:00:00"
    },
    {
      "id": "bf9263f8-2d55-4044-ab20-d275b56ab5b9",
      "text": "European Court of Human Rights applied urgent interim measures (Rule 39) in the Ukraine v. Russia matter (13 March 2014)",
      "date": "2014-03-13 00:00:00"
    },
    {
      "id": "39cddfdc-f4fe-4d95-890f-6f9b9e217019",
      "text": "PACE (Parliamentary Assembly of the Council of Europe) suspension of the Russian delegation (10 April 2014)",
      "date": "2014-04-10 00:00:00"
    },
    {
      "id": "995d8ddb-e382-4194-8310-0522f57d393b",
      "text": "Public confusion about the ECHR's mandate versus courts that decide territorial sovereignty (March 2014)",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "364ac148-30c9-4ecf-92fa-825712d7a416",
      "text": "Heightened political polarization and emotionally charged Victory Day (May 9, 2014) events in Kyiv, with veterans, Communist Party contingents and pro-Russian demonstrators present.",
      "date": "2014-05-09 00:00:00"
    },
    {
      "id": "108ab024-87d1-47d4-8139-ad46f6e38c35",
      "text": "Regulatory enforcement and warning letters by FDA/FTC in 2021 highlighted widespread illegal disease/treatment claims in supplement marketing.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "07f7a1ed-d849-4bdc-b430-9b256fe4c083",
      "text": "Reports of foreign fighters travelling to Donbas in 2014 (volunteers from Europe and beyond).",
      "date": "2014-08-22 00:00:00"
    },
    {
      "id": "b9bad6ff-5e99-4b92-a9dc-1e6badc97e55",
      "text": "U.S. convictions of former Blackwater guards (October 2014) renewed media attention on private contractors' misconduct.",
      "date": "2014-10-23 00:00:00"
    },
    {
      "id": "3dca0899-074f-4e9e-b91c-a9ca7458895b",
      "text": "Nisour Square massacre: Blackwater contractors opened fire in Baghdad, killing civilians.",
      "date": "2007-09-16 00:00:00"
    },
    {
      "id": "52a54493-a1f3-4f4c-a7d2-80b44206c556",
      "text": "Heavy fighting and shifting control in Mariupol, May–June 2014 (city taken and later retaken during the Donbas conflict).",
      "date": "2014-06-13 00:00:00"
    },
    {
      "id": "d29718e5-79a9-4622-b7d2-f27b220d6d99",
      "text": "Russian and pro‑separatist media claims in 2014 alleging American mercenaries operating in eastern Ukraine.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "54363c74-3a5e-4a0e-a8b7-87b7a9ff59a3",
      "text": "Interview in Berliner Morgenpost where Poroshenko made a nuanced comment about sanctions during an official visit to Germany (covered 2 Feb 2017)",
      "date": "2017-02-02 00:00:00"
    },
    {
      "id": "d9355a2b-e19e-408d-9457-938ec41f605d",
      "text": "High‑profile cases of Ukrainian artists (e.g., Ani Lorak) continuing to perform in Russia after 2014 and facing public criticism (documented controversies and petitions in 2014–2015).",
      "date": "2015-08-24 00:00:00"
    },
    {
      "id": "386e3406-a1dd-4833-be25-35db72e451dc",
      "text": "Publicised blacklists, bans and ambiguous records of cross‑border performances (e.g., compilation lists and public debates about banned performers from 2014–2015).",
      "date": "2015-07-24 00:00:00"
    },
    {
      "id": "524949dd-fb0e-4480-b88d-7595fb098a45",
      "text": "Deadly Maidan shootings and clashes (Feb 18–20) with widespread reporting that Berkut units used lethal force",
      "date": "2014-02-18 00:00:00"
    },
    {
      "id": "8af73905-0721-418e-a51c-4db9d4d3e8a8",
      "text": "Ukrainian government announced disbandment of the Berkut special police unit",
      "date": "2014-02-26 00:00:00"
    },
    {
      "id": "415ec586-96fb-46fc-9faa-eaecc243e78e",
      "text": "WHO published its COVID-19 excess mortality estimation methodology and model outputs (October 2021), highlighting gaps between reported COVID-19 deaths and modelled excess deaths across countries.",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "fcb12daf-7d52-4c56-b04d-e9777de122bf",
      "text": "Divergent national blood-donation guidance on post-vaccination deferral times (e.g., NHS/Blood Services clarifying differences)",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "9629e5c8-186c-4e57-91bf-b18b548bc1b0",
      "text": "Reports of vaccine vial contamination (e.g., Japan suspended use of some Moderna lots after foreign particles found)",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "385cdb80-f2c1-4e7b-87b1-c21abaad8d71",
      "text": "Documented frequency of climate-skeptic segments on major cable/news programmes (analysis of Fox News coverage up to May 2021)",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "a82d71b0-e478-478a-86f2-1e56e05e450f",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I release and media coverage",
      "date": "2021-08-09 00:00:00"
    },
    {
      "id": "276f71ec-ec4b-4616-a67f-383f7d4c239c",
      "text": "Release of CDC v‑safe pregnancy registry supplemental tables and data used in the NEJM report",
      "date": "2021-06-17 00:00:00"
    },
    {
      "id": "65c1d41b-b2cc-460f-a33b-8c41a52344be",
      "text": "Publication of NEJM 'Preliminary Findings of mRNA Covid-19 Vaccine Safety in Pregnant Persons' (Shimabukuro et al.)",
      "date": "2021-06-17 00:00:00"
    },
    {
      "id": "eae286d6-d908-4958-b808-2f866d9ef706",
      "text": "FDA full approval of Pfizer–BioNTech vaccine (Comirnaty)",
      "date": "2021-08-23 00:00:00"
    },
    {
      "id": "55c5716f-2754-4c82-a473-893c45e6a6a7",
      "text": "FDA expands emergency use authorization to adolescents (ages 12–15)",
      "date": "2021-05-10 00:00:00"
    },
    {
      "id": "143587d4-ddc3-4475-9b44-e3d87618bc18",
      "text": "HHS General Counsel Advisory Opinion clarifying PREP Act scope",
      "date": "2020-04-14 00:00:00"
    },
    {
      "id": "5c6f0588-995c-4d20-a836-02ac80210bf5",
      "text": "NATO deployed Enhanced Forward Presence battlegroups to Estonia, Latvia, Lithuania and Poland",
      "date": "2017-07-24 00:00:00"
    },
    {
      "id": "cf2d3a88-17b8-4c10-8916-393a69b12b04",
      "text": "Operation Atlantic Resolve rotations — U.S. armored and aviation rotations to Poland (2019)",
      "date": "2019-10-24 00:00:00"
    },
    {
      "id": "49d63289-c9af-47f9-bc53-72830a13fe12",
      "text": "Trident Juncture 2018 — large NATO exercise in Norway with ~50,000 participants, aircraft and ships",
      "date": "None"
    },
    {
      "id": "05a7445f-f8e4-451a-84c5-621b59387db8",
      "text": "Preprints and analyses estimating low infection fatality rates (IFR) from early seroprevalence data (John Ioannidis seroprevalence analysis, May 2020 preprint)",
      "date": "2020-05-13 00:00:00"
    },
    {
      "id": "ed0d1125-13b6-49a3-9515-4aeb847b3975",
      "text": "Historical precedent: 1976 swine‑flu vaccination program and Guillain–Barré reports",
      "date": "None"
    },
    {
      "id": "cf5b4e71-5bd7-4fab-8dba-5b8915af2a53",
      "text": "Professional guidance discouraging routine MTHFR testing (ACMG practice guideline)",
      "date": "2013-01-03 00:00:00"
    },
    {
      "id": "45f128ba-256c-4b24-a061-347799ffdf5a",
      "text": "Peer‑reviewed 2020 paper (Mesnage et al.) reporting glyphosate effects on the gut microbiome / shikimate pathway",
      "date": "2020-04-22 00:00:00"
    },
    {
      "id": "fee2129d-d97d-4fb2-9d74-9637bdb59a06",
      "text": "President Zelensky announced draft legislation proposing a route to Ukrainian citizenship for foreign fighters",
      "date": "2024-01-22 00:00:00"
    },
    {
      "id": "e47653a8-b66a-4155-8f1d-5ee1ceff6d91",
      "text": "Ukrainian Defence Minister Rustem Umerov interview saying Ukrainian men living abroad would be asked to report to recruitment offices",
      "date": "2023-12-21 00:00:00"
    },
    {
      "id": "7482a314-6a20-4c76-a5d3-56a28a432af1",
      "text": "Establishment and publicity around Ukraine’s International Legion and the large number of foreign volunteers since Feb 2022",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "5cbb827c-948e-49c9-8dd5-d0a3c9f52987",
      "text": "German Justice Minister Marco Buschmann public comments that Germany will not force Ukrainians in Germany to return or serve for Ukraine (Welt interview referenced)",
      "date": "2024-01-24 00:00:00"
    },
    {
      "id": "7d9cd478-80c2-4f33-9da9-39dedaddc105",
      "text": "Large multinational naval exercise Sea Breeze took place in the Black Sea (Sea Breeze 2018 concluded July 17, 2018), increasing military activity and public attention on the Black Sea/Crimea security situation.",
      "date": "2018-07-17 00:00:00"
    },
    {
      "id": "00c6dc3b-e013-49d3-8cd8-6fc3710d5264",
      "text": "Deputy Information Minister Emine Dzhaparova spoke at a round table titled ‘Returning of Crimea: the vision of Ukrainians’ and said Ukraine must be prepared for different scenarios to reclaim Crimea (ambiguous phrasing about readiness).",
      "date": "2018-10-22 00:00:00"
    },
    {
      "id": "27eda906-14cf-4632-adc3-d243f4fd4936",
      "text": "Nationalisation of PrivatBank, Ukraine's largest lender (government takeover announced/implemented).",
      "date": "2016-12-19 00:00:00"
    },
    {
      "id": "05fac443-cceb-4ff9-82d6-297f6bd746a5",
      "text": "S&P and other agencies moved some Ukraine instruments toward default status after missed payments on GDP‑linked securities in mid‑2015.",
      "date": "None"
    },
    {
      "id": "905ede65-2bde-4cde-a2cc-51e69c4841a3",
      "text": "Moody's downgraded Ukraine's sovereign rating to Ca amid debt-restructuring talks.",
      "date": "2015-03-24 00:00:00"
    },
    {
      "id": "aa7c39a7-b7ed-4147-af04-ffa29e0276fc",
      "text": "American Journal of Medicine publishes McCullough et al., 'Pathophysiological Basis and Rationale for Early Outpatient Treatment' (includes discussion of hydroxychloroquine)",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "30d3dcb3-51fd-4a00-b9eb-4fdee73e7b1f",
      "text": "High-profile political promotion of hydroxychloroquine (notably President Trump) in March–April 2020",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "75372dd7-921d-4010-b871-f744e8212413",
      "text": "Pope Francis’s earlier controversial 'white flag' remarks (widely discussed in March 2024)",
      "date": "2024-03-10 00:00:00"
    },
    {
      "id": "020ddec2-9bf4-4d55-8de8-775d6b46f6f7",
      "text": "EU visa‑free travel for Ukrainian citizens comes into force",
      "date": "2017-06-24 00:00:00"
    },
    {
      "id": "07e01120-bfaf-4cc6-aeb4-cbf712f42a74",
      "text": "World Bank Ukraine Economic Update highlighting market and price pressures (Spring 2017)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "ee7c1668-aa54-45b9-8b75-e6487c07fc4c",
      "text": "Publicly available cost‑of‑living/grocery index comparisons (Numbeo 2017 country rankings)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "98086365-8b60-42af-8a68-2b1e8ea49daf",
      "text": "Provisional application of the EU–Ukraine Association Agreement (DCFTA) reducing trade barriers",
      "date": "2016-01-24 00:00:00"
    },
    {
      "id": "478e7f14-ad18-42c7-975d-dd83210d9522",
      "text": "Ukraine installed a temporary dam and flow-control measures near Kalanchak in summer 2014 to block the North Crimean Canal.",
      "date": "None"
    },
    {
      "id": "d2220db0-db5f-4c1e-bfc5-00cd3d3f4183",
      "text": "报道 and explainers in 2014 noting Crimea previously relied on the Dnipro (via the North Crimean Canal) for up to ~80–85% of its freshwater, creating an acute water-security crisis when the canal was blocked.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "c30b115c-9aa9-44ae-9f91-7e78a0eda10e",
      "text": "Historical wartime precedent: strategic destruction or manipulation of Dnieper/Dnipro dams (e.g., demolition of Dnieper infrastructure during WWII) documented in historical and reference sources.",
      "date": "None"
    },
    {
      "id": "30a75522-3ed2-456c-b5c3-4efdf6159930",
      "text": "U.S. House Science Committee and partisan media attention to NOAA's 2015 study and whistleblower allegations (2017)",
      "date": "2017-02-24 00:00:00"
    },
    {
      "id": "28664f7e-95c3-41b0-b55f-90f977f597e5",
      "text": "ICRC and Ukrainian Red Cross facilitated large evacuations from Sumy (joint operations to move civilians out)",
      "date": "2022-03-15 00:00:00"
    },
    {
      "id": "2e8e07ef-cd9d-4f80-b243-70a6bca9511c",
      "text": "Red Cross convoy to besieged Mariupol turned back and postponed evacuations after being unable to reach the city",
      "date": "2022-04-01 00:00:00"
    },
    {
      "id": "9b370277-b0df-4b52-bb69-f004f8f111db",
      "text": "VAERS is a public, passive adverse‑event reporting system (established 1990)",
      "date": "1990-04-24 00:00:00"
    },
    {
      "id": "50c056c6-ad12-4d68-9434-436eb788332e",
      "text": "U.S. measles outbreak (highest cases in 25 years)",
      "date": "2019-05-30 00:00:00"
    },
    {
      "id": "092e9fe3-edeb-4793-935b-71936296b7ff",
      "text": "NOAA reporting and headlines on record atmospheric CO2 milestones (Mauna Loa surpassing ~410 ppm) in 2019",
      "date": "2019-06-24 00:00:00"
    },
    {
      "id": "59ac563e-6e2c-4f61-9004-22e54664af0b",
      "text": "Ukrainian government files bill to make 'Glory to Ukraine — Glory to the heroes' the official military greeting (bill No. 7549 registered)",
      "date": "2018-02-07 00:00:00"
    },
    {
      "id": "dada36b1-14ac-4f44-a481-7bb7a0353c7d",
      "text": "Public debate and media coverage about the historical/political meaning of 'Slava Ukraini' (discussion of its origins and politicisation)",
      "date": "None"
    },
    {
      "id": "bb32ebcf-afa1-4e74-a29d-d1b0fc8cb958",
      "text": "Amnesty International report on abuses by the Aidar volunteer battalion operating under Ukrainian command",
      "date": "2014-09-08 00:00:00"
    },
    {
      "id": "0f6ab3e3-d049-4145-b966-c0ba7cb300b0",
      "text": "OSCE SMM Daily Report recorded outgoing artillery fire from government-controlled Svitlodarsk",
      "date": "2017-01-31 00:00:00"
    },
    {
      "id": "2b04da7b-8c50-416b-bc8d-bca755e48292",
      "text": "OSCE SMM documented fresh craters near a Ukrainian Armed Forces compound in Sartana assessed as caused by MLRS rounds fired from the south‑south‑east",
      "date": "2017-03-10 00:00:00"
    },
    {
      "id": "5b3e40f9-1d49-4afa-8300-d5b214d9714d",
      "text": "OSCE SMM reports noting the Mission was denied access on multiple occasions by Ukrainian Armed Forces personnel",
      "date": "2017-01-31 00:00:00"
    },
    {
      "id": "720b8d6d-809c-4d3e-a583-77f63e7d2392",
      "text": "NIA-AA (National Institute on Aging–Alzheimer's Association) issues revised 2011 diagnostic framework introducing 'preclinical' and biomarker-based stages of Alzheimer's disease.",
      "date": "2011-04-24 00:00:00"
    },
    {
      "id": "d25e2ca8-7933-453e-bb0c-5bc632a1daa8",
      "text": "FDA narrows Emergency Use Authorization for COVID‑19 convalescent plasma to 'high‑titer' units",
      "date": "2021-02-24 00:00:00"
    },
    {
      "id": "2247aa0b-b1a9-4cc0-806f-c9d2d0cd4d6e",
      "text": "Reports of foreign/black particles found in Moderna vaccine vials in Japan",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "03f4e181-d8ed-4586-bffa-fa817f4d5187",
      "text": "Scientific and public messaging on which antibodies vaccines induce vs. which antibody tests detect (spike vs. nucleocapsid)",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "4b4fe4cd-6bc4-4296-91d2-9122b258caba",
      "text": "Early New York State antibody study publicity suggesting many more infections than confirmed cases",
      "date": "2020-04-23 00:00:00"
    },
    {
      "id": "3a2eafb7-4d99-4208-9c98-2089f8596efa",
      "text": "Presidential election day (Ukraine) — March 31, 2019 — heightened political tension and information flows around polling stations.",
      "date": "2019-03-31 00:00:00"
    },
    {
      "id": "d9a09b32-3bc4-42c4-b070-f0e1739402be",
      "text": "Zaporizhzhia local authorities moved to implement the 2012 regional-language provisions (local implementation granting Russian regional status)",
      "date": "2012-09-05 00:00:00"
    },
    {
      "id": "40ba8f2a-1fbe-4c32-b690-0f720622e862",
      "text": "Vladimir Putin and Russian officials publicly labelled the post‑Maidan Ukrainian authorities 'fascist' and repeatedly evoked Nazi-era language (Putin speech on Crimea)",
      "date": "2014-03-18 00:00:00"
    },
    {
      "id": "82b4341a-53c0-4a59-ba23-8a73dc03fb2e",
      "text": "Reporting on far‑right groups (Svoboda, torchlit marches) and far‑right figures appearing in the Maidan period",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "5719f0b2-0825-4704-b1e1-1faadcdd9013",
      "text": "Danish Defence Minister publicly notified parliament that Denmark will significantly reduce its military support for Ukraine in 2026 (planned allocation cut to DKK 9.4 billion).",
      "date": "2025-12-05 00:00:00"
    },
    {
      "id": "32904737-d2e6-461f-b57f-e569657b6a75",
      "text": "Danish government publicised the multi‑year “Ukraine Fund” and large cumulative commitments to Ukraine (multi‑billion euro/kroner pledges across 2023–2028).",
      "date": "None"
    },
    {
      "id": "0dd6dd1c-6caa-490b-8269-f36c3a303578",
      "text": "Official Danish Ministry of Defence material and public briefings documented multiple high‑profile equipment donations (F‑16s, tanks, air‑defence, coastal missiles and other packages) and ongoing deliveries through 2022–2024.",
      "date": "None"
    },
    {
      "id": "25ec6b3b-539a-46fb-84b7-3b8309c4cc13",
      "text": "Analysts and media highlighted that non‑state‑party countries (e.g., India) are not legally bound to arrest ICC indictees",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "7fb28bbf-180c-4473-9113-882b65c5206b",
      "text": "International Criminal Court issues arrest warrants for Vladimir Putin and Maria Lvova‑Belova",
      "date": "2023-03-17 00:00:00"
    },
    {
      "id": "f10cb692-543d-49a4-857e-12877e380eb0",
      "text": "Donetsk People's Republic leader Denis Pushilin announced DPR/Russian forces aimed to encircle Mariupol",
      "date": "2022-03-01 00:00:00"
    },
    {
      "id": "08cac6a8-d53a-45df-8eb4-69e83b4100e8",
      "text": "Russian troops entered the centre of Kherson and local officials reported rapid Russian advances",
      "date": "2022-03-03 00:00:00"
    },
    {
      "id": "7c7355c8-7251-4b57-b625-15ffe8465010",
      "text": "Reports and rapidly circulating images/videos showed Mariupol under heavy shelling and effectively blockaded by early March",
      "date": "2022-03-02 00:00:00"
    },
    {
      "id": "a2d32119-8579-4773-a14d-17c148d585f6",
      "text": "1979 U.S. Supreme Court decision (United States v. Rutherford) upholding federal restrictions on interstate shipment of laetrile",
      "date": "1979-06-18 00:00:00"
    },
    {
      "id": "ecb1e2cc-e360-413a-9967-4b191fbe214c",
      "text": "Publication of major clinical evaluations showing no clinical benefit and cyanide risk (e.g., Moertel et al., NEJM clinical trial 1982 and later systematic reviews)",
      "date": "1982-01-28 00:00:00"
    },
    {
      "id": "80d79466-d5eb-40ec-9fa3-c2e30b7d4853",
      "text": "Reports that around 1,000 Ukrainians had contacted the embassy in Israel seeking help",
      "date": "2023-10-11 00:00:00"
    },
    {
      "id": "8334641f-a721-409e-8a0f-4f763cc30cd9",
      "text": "Hamas attack on Israel triggers widespread conflict and civilian displacement",
      "date": "2023-10-07 00:00:00"
    },
    {
      "id": "dd94afd5-f875-436b-a036-109f54ec57dd",
      "text": "Mixed early reports about evacuation status: embassy statements that evacuation planning was underway alongside reports of delays",
      "date": "2023-10-11 00:00:00"
    },
    {
      "id": "2ffb4703-e038-4783-a17d-d64c64fa7329",
      "text": "Widespread Russian dehumanizing propaganda portraying Ukrainians and Zelensky as 'monstrous' or 'cannibalistic' figures",
      "date": "2023-10-24 00:00:00"
    },
    {
      "id": "25c6347f-d38f-4f24-90a2-eab32988fe16",
      "text": "WHO names 'vaccine hesitancy' as a top global health threat (2019)",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "fafaffcc-17b9-4fc3-a16c-a6276bf6a408",
      "text": "Publication of high-profile scientific reviews and discussions about aluminium adjuvants (e.g., 2018 Nature review)",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "25bba8d0-7a7b-45ed-9973-9c6ccc480852",
      "text": "1999 US recommendation to reduce/eliminate thimerosal (a mercury-containing preservative) from childhood vaccines",
      "date": "1999-07-24 00:00:00"
    },
    {
      "id": "1d8b5dfe-e2fb-44a5-8964-15e3019279e7",
      "text": "Prominent climate scientist Michael E. Mann publicly stated that climate change worsened Hurricane Harvey in opinion/commentary and interviews.",
      "date": "2017-08-28 00:00:00"
    },
    {
      "id": "41ffb9af-a0bd-4b01-9832-3827139dccf1",
      "text": "General Medical Council (GMC) found Andrew Wakefield guilty of serious professional misconduct and struck him off the medical register.",
      "date": "2010-05-24 00:00:00"
    },
    {
      "id": "51c91a8f-836d-4f3e-aa83-115580b2e75a",
      "text": "FDA issued Emergency Use Authorization for the Pfizer–BioNTech COVID‑19 vaccine",
      "date": "2020-12-11 00:00:00"
    },
    {
      "id": "8a5ddfe2-cfe1-4f96-9acd-23c0bdf4613d",
      "text": "Japan suspended and recalled multiple Moderna vaccine batches after contamination reports",
      "date": "2021-08-25 00:00:00"
    },
    {
      "id": "979b79bb-6bd4-4caa-b906-65b94d6ba290",
      "text": "FDA VRBPAC briefing document noted median ~2 months safety follow‑up for Pfizer Phase 3 participants",
      "date": "2020-12-10 00:00:00"
    },
    {
      "id": "ccfa9ab4-b725-46fe-9d4b-81f4301a7777",
      "text": "CDC updated guidance allowing fully vaccinated people to resume many activities without masks",
      "date": "2021-05-13 00:00:00"
    },
    {
      "id": "64904b12-3744-4597-9b3f-eab26aff9e46",
      "text": "Sen. Ron Johnson and allied events highlighted raw VAERS report counts in hearings/press conferences",
      "date": "2021-06-28 00:00:00"
    },
    {
      "id": "fef83bef-545f-48a1-a0a7-75f37f5f1858",
      "text": "Publication of a Johns Hopkins patent application / patent covering an enhanced mebendazole polymorph (polymorph C) claimed to improve tumor delivery.",
      "date": "2021-12-02 00:00:00"
    },
    {
      "id": "877b6b14-efb4-4221-ada1-e753e29887e7",
      "text": "Publication of a widely-cited review 'Ivermectin, a potential anticancer drug derived from an antiparasitic drug' summarizing in vitro and mechanistic evidence that ivermectin can affect cancer pathways.",
      "date": "2020-09-21 00:00:00"
    },
    {
      "id": "bfa7eaac-7dce-4860-8984-9b0d09ebaf65",
      "text": "Registration and start of a human clinical trial (ClinicalTrials.gov NCT05318469) testing ivermectin in combination with immune checkpoint inhibitors (balstilimab or pembrolizumab) for metastatic triple‑negative breast cancer (trial start listed Oct 13, 2023).",
      "date": "2023-10-13 00:00:00"
    },
    {
      "id": "a3565498-b868-4dee-98d8-d5f4cfe859f7",
      "text": "International attention and IOC intervention after Kharlan's disqualification (IOC awarded her Olympic qualification spot)",
      "date": "2023-07-28 00:00:00"
    },
    {
      "id": "c09a83e1-da13-4197-9fc1-9729ee98abc0",
      "text": "Olha (Olga) Kharlan disqualified at World Fencing Championships after refusing to shake Russian opponent's hand",
      "date": "2023-07-27 00:00:00"
    },
    {
      "id": "6749d1a6-9d9c-4e30-9471-ba8f0b197ef7",
      "text": "Brighton Beach 'Victory Day' parade with visible Russian flags and veterans in Brooklyn",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "b0f38eca-6284-4ad5-967a-44d6f6e8f67e",
      "text": "Small anti‑war/anti‑intervention rallies in Washington where some attendees praised Vladimir Putin (reported by U.S. outlets in 2015)",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "a8ae2e4b-0ae8-47a0-8895-855189d37016",
      "text": "NATO's Enhanced Forward Presence (eFP) battlegroups deployed to the Baltic states and Poland (2017).",
      "date": "2017-04-13 00:00:00"
    },
    {
      "id": "e108f330-7ee6-4e7b-9705-ed42439e9dc7",
      "text": "Sea Breeze multinational naval exercise in Odesa and Black Sea (Sea Breeze 2018).",
      "date": "2018-07-17 00:00:00"
    },
    {
      "id": "b172797b-ee7d-4a69-9af6-3a95726cb187",
      "text": "Documented presence of foreign volunteers/foreign fighters in the Donbas conflict (2014 onwards).",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "b1c980d2-d3eb-497c-945b-254679571688",
      "text": "Repeated Russian accusations and official statements alleging NATO or Western troops were operating in Ukraine (and NATO rebuttals in 2014).",
      "date": "2014-12-01 00:00:00"
    },
    {
      "id": "b6091d9e-a2b3-424d-8756-d1f506d1b604",
      "text": "Rapid Trident multinational exercise held in Yavoriv, Ukraine.",
      "date": "2017-09-22 00:00:00"
    },
    {
      "id": "26ddee41-4525-4f23-aa2c-a446c14312eb",
      "text": "G7 Science Academies statement: 'Future of the Ocean' highlighting ocean acidification (G7, April 2015)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "fe5d9d42-98ef-42db-91ca-5f80eda25774",
      "text": "Oregon State University / NOAA-linked study on oyster hatchery failures attributed to ocean acidification",
      "date": "2012-04-11 00:00:00"
    },
    {
      "id": "25b36395-e166-48c3-afce-86e3849d8755",
      "text": "Ukraine enacts anti‑collaboration legislation (Article 111‑1) criminalizing cooperation with an aggressor and occupation administrations.",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "41aaa320-17d7-49de-a85a-bbe111a655f4",
      "text": "Administrative changes and practical disruptions to social payments (pensions) for residents in temporarily occupied territories (procedures changed and payments routed to bank accounts; suspension rules existed if no receipt for months).",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "38c15e85-f56c-4be8-9020-a8e980c44144",
      "text": "High‑profile arrests/prosecutions for 'collaboration' (example: Reuters report of an MP arrested on suspicion of collaborating with Russia).",
      "date": "2023-07-25 00:00:00"
    },
    {
      "id": "066d3cca-8042-450a-8414-fb6add35cecb",
      "text": "Reports of Russian control and disruption of communications in occupied areas (e.g., Russia rerouting/shutting down Ukrainian internet in Kherson and other occupied territories).",
      "date": "2022-08-24 00:00:00"
    },
    {
      "id": "1b913efb-1993-4461-a72e-8aabce43888a",
      "text": "Earlier precedent of arrests and accusations of 'sabotage' in eastern Ukraine (April 2014): Ukrainian authorities detained suspected plotters in Luhansk.",
      "date": "2014-04-05 00:00:00"
    },
    {
      "id": "620b1bc5-aa6e-441e-a9bd-de9626f41b53",
      "text": "Reports of chaotic security conditions in Luhansk during 2014 (sieges, captures of observers, clashes) documented by international media and monitors.",
      "date": "2014-06-03 00:00:00"
    },
    {
      "id": "0144f644-bffa-4efd-8e68-585abcf16d87",
      "text": "U.S. Supreme Court upheld a federal ban on interstate shipment of laetrile (Amygdalin/\"Laetrile\" regulation upheld)",
      "date": "1980-04-24 00:00:00"
    },
    {
      "id": "72bcb16a-5839-41d2-93dc-7d6b586981bb",
      "text": "EFSA scientific opinion and public statement on acute health risks from cyanogenic glycosides in raw apricot kernels",
      "date": "2016-04-27 00:00:00"
    },
    {
      "id": "f367d46a-f3fc-456a-856e-1c1287aadc11",
      "text": "N Engl J Med clinical trial (Moertel et al.) showing no anticancer benefit for amygdalin/Laetrile and reporting toxicity concerns",
      "date": "1982-01-28 00:00:00"
    },
    {
      "id": "dc14cbdb-9f5d-4046-bf54-40d22463897e",
      "text": "Peer‑reviewed measurement study showing non‑zero scattered dose to the thyroid during mammography and that specialized collars reduce that scatter (but concluding routine collars are not mandatory)",
      "date": "2018-06-28 00:00:00"
    },
    {
      "id": "4200e86a-175f-47da-99cd-bd8e9e246de6",
      "text": "Pandemic‑related declines and disruptions in cancer screening and care were reported widely in 2020–2021",
      "date": "2021-06-30 00:00:00"
    },
    {
      "id": "243e3702-8b47-4ed2-b0ec-a2b37d7ab8f0",
      "text": "Court decision and transfer of seized Russian-owned ammonia to Odesa Portside Plant for safekeeping after seizure by Ukrainian authorities.",
      "date": "2022-07-13 00:00:00"
    },
    {
      "id": "9b753a16-292c-484e-b4b7-02a71a1bad0e",
      "text": "Russian-backed separatists reported an ammonia leak after alleged Ukrainian shelling of a brewery in Donetsk, warning of a corrosive ammonia cloud and local evacuations.",
      "date": "2022-08-10 00:00:00"
    },
    {
      "id": "56462797-c178-4883-943c-1dca4ad80a4b",
      "text": "Ukraine's intelligence accused Russia of rigging a Crimean chemical plant with mines that could release about 200 tonnes of ammonia, an allegation reported in international media.",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "d4769905-3316-4a21-8214-2138b5a9aa39",
      "text": "Reports that the Togliatti–Odesa ammonia pipeline was damaged during the conflict, with both Moscow and Kyiv trading blame for the disruption of large ammonia shipments.",
      "date": "2023-06-07 00:00:00"
    },
    {
      "id": "cd638490-7a6a-4ada-8d87-7cdb447ed0b9",
      "text": "EADaily publishes article repeating 'nearly 500' protesters blocking central Kyiv street",
      "date": "2015-03-17 00:00:00"
    },
    {
      "id": "d1ea88c1-6075-4f84-98f8-b0fa69033a82",
      "text": "On-the-ground situation was two small rallies and only a brief blockage (StopFake reconstruction)",
      "date": "2015-03-17 00:00:00"
    },
    {
      "id": "e91616a9-c2d0-434b-9538-31cde29fd76b",
      "text": "United Nations reported 'persistent and grave' human rights violations in eastern Ukraine, including civilian deaths from shelling (June 2015)",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "94e0f17e-33bc-4bef-98af-b586a683708d",
      "text": "Bus-stop shelling in Donetsk that killed multiple civilians, widely reported and investigated by OSCE",
      "date": "2015-01-22 00:00:00"
    },
    {
      "id": "4de50317-2d5e-4c28-81f0-b14104e62927",
      "text": "Public health guidance (CDC/WHO) acknowledging limited data for infants and urging discussion between breastfeeding mothers and healthcare providers (CDC: COVID‑19 vaccines while pregnant or breastfeeding guidance).",
      "date": "2023-05-05 00:00:00"
    },
    {
      "id": "42ad553c-6f40-4a73-ae6f-7337824588c9",
      "text": "Large street brawl in Kolonaki (central Athens) involving Dynamo Kyiv supporters, with 18 people detained",
      "date": "2018-02-15 00:00:00"
    },
    {
      "id": "1b6b8aea-ce45-4e28-8040-ade69307404e",
      "text": "Well-known past violent incidents involving Right Sector (e.g., Mukachevo shootout where Right Sector members exchanged fire with police)",
      "date": "2015-07-11 00:00:00"
    },
    {
      "id": "e1b1a414-9823-46ba-81df-abb066162bf5",
      "text": "IPCC Fifth Assessment Report (AR5, WGI) Summary for Policymakers published with cautious language on extremes, noting low confidence in long-term changes in tropical cyclone activity and stating current datasets indicate no significant observed trends in global tropical cyclone frequency over the past century.",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "407d66ee-056c-4ffa-9954-8a74ec5c3b1b",
      "text": "High-profile political moments and media amplification of single cold/snow events used to dispute warming (for example, Senator Jim Inhofe throwing a snowball on the Senate floor in February 2015).",
      "date": "2015-02-26 00:00:00"
    },
    {
      "id": "d6febbd5-eae9-4696-9e65-20492eaa8e26",
      "text": "EU Emergency Trust Fund for Africa (EUTF) launched to address root causes of migration (Nov 2015)",
      "date": "2015-11-24 00:00:00"
    },
    {
      "id": "27679405-42ca-4355-958e-fadb11d9dd69",
      "text": "EU–Turkey statement (migration deal) committing EU funds to Turkey to manage refugee flows",
      "date": "2016-03-24 00:00:00"
    },
    {
      "id": "07b8c9bc-c879-41be-ba14-45abae032ec8",
      "text": "Visa‑free travel for Ukrainian citizens to the EU came into force (June 11, 2017)",
      "date": "2017-06-11 00:00:00"
    },
    {
      "id": "7a1ea26b-a1aa-469c-9031-a0db6bd82d4a",
      "text": "EU macro-financial assistance and broader aid packages to Ukraine after 2014",
      "date": "None"
    },
    {
      "id": "f86adeee-5f1c-4906-8955-07542f945de7",
      "text": "2015 European migrant/refugee crisis with large arrivals to the EU",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "54e28690-5822-4639-b568-f547d5ecad19",
      "text": "UK government statement (June 19, 2023) to keep Russian assets frozen until Russia compensates Ukraine",
      "date": "2023-06-19 00:00:00"
    },
    {
      "id": "874f2a98-10f6-4186-b788-e5f7826dc4ed",
      "text": "H.Con.Res.66 (118th Congress) expresses support for using reparations paid by Russia while urging the burden not fall on U.S. taxpayers",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "80f2e96a-02b8-4aab-9fb0-822357bd83e7",
      "text": "Court orders and media coverage accelerating release of Pfizer vaccine trial and safety documents (judge ordered faster FDA disclosure)",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "78361e4d-90a1-4bab-8a32-903cf5747287",
      "text": "Public reporting and CDC/ACIP discussion of myocarditis/pericarditis cases after mRNA COVID‑19 vaccination (young males)",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "b144c6b8-594b-4b18-a0e0-8759f18a0fef",
      "text": "Contamination reports and suspension/recall of Moderna vaccine batches in Japan (August–September 2021)",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "4353f89a-0b97-4c7c-bad8-576dbaac73df",
      "text": "Public reporting of reduced/negative vaccine effectiveness against Omicron infections (UKHSA/early 2022 analyses)",
      "date": "2022-02-10 00:00:00"
    },
    {
      "id": "5d294d4c-e97f-4a51-b0c8-88f18c467fb0",
      "text": "In‑vitro report that Pfizer/BioNTech vaccine mRNA can be reverse‑transcribed in a human liver cell line (Aldén et al., Curr. Issues Mol. Biol./PMC)",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "95c58021-765b-4340-8db8-45534f0753f7",
      "text": "Russian bans and embargoes on Ukrainian imports (food and other goods) in 2014–2015",
      "date": "2015-11-24 00:00:00"
    },
    {
      "id": "a534d6f6-34a8-4f0f-b375-b2b83ea47d27",
      "text": "Sharp national GDP contractions reported for 2014–2015 (double-digit annual declines in quarters)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "f9d39220-fa21-4386-8859-b7e2ca80ef00",
      "text": "Bilateral trade turnover between Russia and Ukraine collapsed (trade fell by around two-thirds in early 2015)",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "00318f36-a42f-4b3a-9739-a85e63103be5",
      "text": "OFAC Crimean Sanctions Advisory (July 30, 2015) clarifying prohibitions on goods/services from Crimea",
      "date": "2015-07-30 00:00:00"
    },
    {
      "id": "0ea469ee-c86a-4d73-980b-964935d52068",
      "text": "U.S. tariffs on steel and aluminum announced under Section 232 (March 8, 2018)",
      "date": "2018-03-08 00:00:00"
    },
    {
      "id": "51d90631-d52d-4811-8d5d-390241030925",
      "text": "Department of Commerce antidumping petition — Carbon and Alloy Wire Rod from Ukraine (March 28, 2017)",
      "date": "2017-03-28 00:00:00"
    },
    {
      "id": "eb7d24b5-dd65-427e-b171-f83cb4ce37ca",
      "text": "Exhibition of captured heavy equipment at the National Museum of the History of Ukraine in the Second World War (Kyiv) showcasing tanks and large vehicles",
      "date": "2014-07-14 00:00:00"
    },
    {
      "id": "1668bca7-ec75-4980-9c6f-2f91621c8981",
      "text": "High-profile 2014 coverage of private ownership and legal disputes over WWII German tanks (Panzer IV auction / Paul Allen dispute, Sept 2014)",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "94beb342-e1fb-4100-aa6f-1661c906c314",
      "text": "Publication of a peer‑reviewed rat study claiming prenatal exposure to Pfizer/BioNTech BNT162b2 produced ‘autism‑like’ behaviors in male neonatal rats.",
      "date": "2024-01-10 00:00:00"
    },
    {
      "id": "d71e764e-7568-4baa-9373-b319e67238c8",
      "text": "Rapid Trident 2020 multinational exercise at the Yavoriv training ground in western Ukraine involving thousands of troops, including airborne units",
      "date": "None"
    },
    {
      "id": "e26652dd-c02a-45ad-a807-9f1b18347fb4",
      "text": "Ukrainian Armed Forces reported 2,650 COVID‑19 cases among personnel",
      "date": "2020-11-20 00:00:00"
    },
    {
      "id": "136883a7-9c80-4cdf-9acc-9cb220febd7f",
      "text": "Norwegian reports of deaths in very frail elderly after Pfizer/BioNTech vaccination and subsequent national guidance to use caution in the most frail",
      "date": "2021-01-18 00:00:00"
    },
    {
      "id": "f44ef0e0-5322-4033-a778-bc956962c971",
      "text": "Peer-reviewed reports of an association between mRNA vaccination and rare myocarditis cases (Israel, large health‑care database)",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "2c09731a-0975-4ada-93a5-34b70eec8e89",
      "text": "CDC and other agencies expanding booster recommendations and reporting reduced protection against infection over time",
      "date": "2021-11-19 00:00:00"
    },
    {
      "id": "fe263f5f-c718-4788-a50d-e142151e69f2",
      "text": "CDC release of early real‑world effectiveness and policy messaging on RSV immunization (CDC newsroom release on nirsevimab effectiveness)",
      "date": "2024-03-07 00:00:00"
    },
    {
      "id": "255d4da1-6d25-4946-9414-1fc9ca446238",
      "text": "Russian seizure and loss of Ukrainian naval assets in Crimea (March 2014) weakened perceived Ukrainian naval capability",
      "date": "2014-03-20 00:00:00"
    },
    {
      "id": "c716c947-f36c-40a2-b826-319d84ccd492",
      "text": "Sea Breeze 2016 actually began on July 18 with US, NATO and partner forces participating",
      "date": "2016-07-18 00:00:00"
    },
    {
      "id": "8551716c-4da8-4042-a80f-e628da5cfbb5",
      "text": "Russian forces install local, pro‑Russian administrators in occupied Kherson (Volodymyr Saldo appointed)",
      "date": "2022-04-26 00:00:00"
    },
    {
      "id": "ab4d7d4e-92fb-4d09-860c-470c3843c20a",
      "text": "Mass refugee flows and internal displacement from Ukraine in March 2022 (millions fleeing abroad or displaced internally)",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "ac6ea0a5-f6a6-47e0-9521-c3143bb2d59e",
      "text": "Arrest of pro‑Russian politician Viktor Medvedchuk by Ukraine's security service",
      "date": "2022-04-12 00:00:00"
    },
    {
      "id": "0d812208-be9a-41ba-8217-ddce9b7193c7",
      "text": "President Zelenskyy signs decrees blocking pro‑Russian TV channels and licences revoked",
      "date": "2022-02-02 00:00:00"
    },
    {
      "id": "dfdd0511-b751-45f9-b860-20d88b28629c",
      "text": "Suspension and later bans of multiple pro‑Russian political parties in Ukraine",
      "date": "None"
    },
    {
      "id": "c2b67055-8042-4c98-8194-7993aceb4896",
      "text": "WTO Panel report circulated in Ukraine — Anti-Dumping Measures on Ammonium Nitrate (panel report circulated 20 July 2018).",
      "date": "2018-07-20 00:00:00"
    },
    {
      "id": "b7ec77ee-9594-4b8b-97ba-8ad5890bdfb3",
      "text": "WTO dispute DS493 initiated/established (Russia files complaint; panel established 22 April 2016).",
      "date": "2016-04-22 00:00:00"
    },
    {
      "id": "0cf49f83-68cd-4108-904c-11ec76282794",
      "text": "Official recognition and investigation of rare myocarditis/pericarditis following mRNA COVID-19 vaccination (ACIP/CDC review)",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "31614f66-df4b-4087-9b57-e5c04c5b8624",
      "text": "CDC/FDA recommended pause on the Johnson & Johnson (Janssen) COVID-19 vaccine over rare blood clots",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "85042650-cdcd-42cf-a92b-e576ab04ba3c",
      "text": "Reports of deaths among frail, elderly Norwegian patients shortly after receiving COVID-19 vaccines",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "ab2a0598-91d2-4ea9-bd43-4e87e8119b4d",
      "text": "World Bank Poverty and Equity briefs (published 2016) showing poverty rates rose sharply in 2014–2015 and remained a prominent policy concern.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "d46e2345-2bfc-4730-ac5a-8fcd87c1305b",
      "text": "Transparency International Corruption Perceptions Index 2016 (published January 2017) showing Ukraine with a low CPI score and poor governance indicators.",
      "date": "2017-01-25 00:00:00"
    },
    {
      "id": "f041e3c4-8af0-49e2-a036-f8aad3b7c75a",
      "text": "IMF staff report (July 2015) documenting deep recession, large output losses, and a challenging recovery path for Ukraine.",
      "date": "2015-07-31 00:00:00"
    },
    {
      "id": "9ec6bca3-2ada-4c9b-b92b-1401c547e3ca",
      "text": "Sharp economic contraction and macro crisis in 2014–2015: GDP collapsed and the hryvnia plunged after the central bank allowed it to float (February 2015 reports).",
      "date": "2015-02-05 00:00:00"
    },
    {
      "id": "a7fe1c2a-2e3a-4fc2-b5bd-545f80fd50e3",
      "text": "OSCE thematic report on the impact of mines and unexploded ordnance (2018–2019)",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "991600ba-725f-4885-bd82-8f65e7004314",
      "text": "Vladimir Putin had previously been named TIME's Person of the Year (2007), a well-known precedent linking Putin with Time magazine covers in public memory.",
      "date": "2007-12-19 00:00:00"
    },
    {
      "id": "e8b9df1e-a9df-41f2-a58d-9757cbfde177",
      "text": "Study and media coverage showing Ukrainian refugees in some EU countries had to return to Ukraine to obtain abortions or contraception because of legal, cost and access barriers (Independent report, 18 May 2023).",
      "date": "2023-05-18 00:00:00"
    },
    {
      "id": "3502743f-3377-4385-84ca-0faa22970d7d",
      "text": "UN/OHCHR documented widespread conflict-related sexual violence (including rape) by Russian forces in occupied areas and published monitoring reports covering 2022–2023.",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "cf694b11-5df9-4934-becc-c79b9f39d996",
      "text": "Airstrike on Mariupol maternity/children's hospital (Maternity Hospital No. 3) that injured pregnant women and resulted in deaths and a stillbirth — widely reported with graphic images (attack on 9 March 2022).",
      "date": "2022-03-09 00:00:00"
    },
    {
      "id": "d5e301d8-602e-4994-b9c6-e12ad3ed9440",
      "text": "EU launches 'Support Hub' in Moldova to counter firearms trafficking and organised crime linked to the Ukraine conflict",
      "date": "2022-07-11 00:00:00"
    },
    {
      "id": "831cecf9-8b31-4512-867c-607e42777deb",
      "text": "Photographs of abandoned military equipment, shells and weapon boxes found near Andriivka (April 12, 2022)",
      "date": "2022-04-12 00:00:00"
    },
    {
      "id": "6288e6e4-82d9-467a-8a64-a03fad274591",
      "text": "Publication of an Israeli nationwide surveillance study (Mevorach et al., NEJM) showing increased myocarditis incidence after the second dose, concentrated in young males (published Oct 6, 2021).",
      "date": "2021-10-06 00:00:00"
    },
    {
      "id": "b397d863-3c35-434f-b821-58e2a9adc787",
      "text": "Reports that Russia offered/organized evacuation routes from Mariupol that included routes into Russia (early–mid March 2022)",
      "date": "2022-03-11 00:00:00"
    },
    {
      "id": "cf23fdff-9ba9-4d57-adea-fb5f00be4898",
      "text": "Abduction and detention of Melitopol mayor Ivan Fedorov (reported March 11, 2022) and pressure on local officials in occupied towns",
      "date": "2022-03-11 00:00:00"
    },
    {
      "id": "ef6647c9-5e6c-4e11-9d27-f848ac5a2df8",
      "text": "Local occupation media and accounts in Kherson reported orchestrated or staged displays of support for Russian forces (early March 2022)",
      "date": "2022-03-06 00:00:00"
    },
    {
      "id": "78b7211b-abf0-486e-9133-264e33b0dd2e",
      "text": "2014 measles outbreak in an under‑immunized Amish community in Ohio (large local outbreak tied to travel and low MMR coverage)",
      "date": "None"
    },
    {
      "id": "aea23b1b-a75a-44d1-a018-4b0952e651b8",
      "text": "Publication of the peer‑reviewed study 'Low cancer incidence rates in Ohio Amish' (Cancer Causes Control) reporting substantially lower cancer incidence in an Ohio Amish population (1996–2003)",
      "date": "2009-09-25 00:00:00"
    },
    {
      "id": "a0145699-ea4f-41dd-9bb3-a1f701e8732a",
      "text": "Dan Olmsted’s 2005 ‘Amish Anomaly’ reporting (Age of Autism / UPI coverage) claiming an unusually low observed rate of autism in Amish communities",
      "date": "2005-04-19 00:00:00"
    },
    {
      "id": "6b815d11-f965-414f-b04f-38078bccc1d2",
      "text": "U.S.-led coalition strikes in mid‑November 2015 destroyed scores/hundreds of ISIS fuel tanker trucks in north‑east Syria (widely reported Nov 2015).",
      "date": "2015-11-19 00:00:00"
    },
    {
      "id": "5d9d7d0c-e16b-4987-9c51-34a858aed7cc",
      "text": "Russian General Staff publicly stated Russian air strikes hit Islamic State oil refining assets during its November 2015 campaign.",
      "date": "2015-11-19 00:00:00"
    },
    {
      "id": "bcabb37c-2778-4f34-beae-87714ad4fa2a",
      "text": "ISIS/ISIL militants deliberately set fire to oil fields and wells in 2015 (e.g., Ajil/Tikrit area, March 2015), producing widespread imagery of burning oil infrastructure.",
      "date": "2015-03-04 00:00:00"
    },
    {
      "id": "5f28ddc2-3522-430f-87d6-316dc67120a0",
      "text": "Hungary publicly refused to back an EU oil embargo, signalling a national veto risk",
      "date": "2022-04-05 00:00:00"
    },
    {
      "id": "fd059fa0-37b3-4fc9-94f9-4d06b4db41a8",
      "text": "Gazprom sharply cut Nord Stream 1 gas flows in late July 2022",
      "date": "2022-07-25 00:00:00"
    },
    {
      "id": "11b4193a-8eda-40f7-895f-3eae3fc69a76",
      "text": "Hungarian Prime Minister Viktor Orbán publicly said EU sanctions on Russia had 'failed'",
      "date": "2022-07-23 00:00:00"
    },
    {
      "id": "42972dba-af6c-41fc-8772-d27c793c1d53",
      "text": "Reporting that worries about winter energy shortages and rising bills were eroding domestic support for sanctions",
      "date": "2022-07-28 00:00:00"
    },
    {
      "id": "9447caab-570e-4091-9c8b-4d5f9ad1e7ea",
      "text": "YouGov polling shows public willingness to keep sanctions falls if they raise cost of living",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "f358d4c6-9a93-47fd-94b2-0195a51d308b",
      "text": "Publication of Scafetta & West (2007) paper estimating a large solar contribution to 20th-century warming",
      "date": "2007-11-24 00:00:00"
    },
    {
      "id": "80ef50db-23dc-47eb-aff4-2203eb2d93a3",
      "text": "Nationwide Razumkov Center / Ilko Kucheriv Democratic Initiatives poll (fieldwork May 14–19, 2021) on attitudes toward Donbas and Russian aggression.",
      "date": "2021-05-14 00:00:00"
    },
    {
      "id": "71ffd1b8-747c-4378-a479-dc3272327150",
      "text": "President Volodymyr Zelensky's interview with foreign media (transcript published mid‑June 2021) in which he warned Ukraine may need to become a 'very strong, most powerful army in Europe'.",
      "date": "2021-06-14 00:00:00"
    },
    {
      "id": "a83dd8f1-3dca-4ac7-9e54-9a86b91766e7",
      "text": "Earlier independent testing and reporting (2021–2022) found benzene contamination in sunscreens and other personal-care products, producing recalls and regulatory attention.",
      "date": "2022-03-29 00:00:00"
    },
    {
      "id": "cc0250a3-78fb-45b6-bff5-ab59b69e6bbb",
      "text": "News that IMF programme delays and conditionality were creating uncertainty for Ukraine’s external financing in mid‑2018",
      "date": "2018-08-24 00:00:00"
    },
    {
      "id": "def94eb5-d1cf-4555-a291-c616a355a307",
      "text": "NBU's August 2018 Macroeconomic and Monetary Review noting global volatility and risk of spillovers to Ukraine",
      "date": "2018-08-24 00:00:00"
    },
    {
      "id": "3e32d9b4-ae18-4f58-b37a-7e9d55df3f0d",
      "text": "Reporting on contagion fears from Turkey’s currency turmoil to other emerging markets",
      "date": "2018-08-13 00:00:00"
    },
    {
      "id": "46a4931e-56c9-4d44-ab93-dea353a3591b",
      "text": "Germany announced an initial reversal of its pre‑invasion restraint by approving shipments from Bundeswehr stocks (1,000 anti‑tank weapons and 500 Stinger missiles)",
      "date": "2022-02-26 00:00:00"
    },
    {
      "id": "a3edd026-9660-497c-ba20-f26eaeb8a066",
      "text": "German Foreign Minister Annalena Baerbock publicly explained Germany’s reluctance to supply arms, citing the country’s WWII history (statement reported by Reuters)",
      "date": "2022-02-18 00:00:00"
    },
    {
      "id": "8cbf4cf4-98fb-40c6-98b5-f4f3d4216956",
      "text": "Swiss parliament votes in favour of several measures to tighten asylum policy (including proposals affecting temporary admissions and family reunification)",
      "date": "2024-09-24 00:00:00"
    },
    {
      "id": "0dc10a52-de59-4fae-8678-4ab5b33e6bbe",
      "text": "Media reports (June 20, 2025) covering proposals and parliamentary initiatives suggesting Switzerland 'may end' or 'revoke' S protection for Ukrainian refugees",
      "date": "2025-06-20 00:00:00"
    },
    {
      "id": "62e0f624-06d0-4606-820f-7615dbc6bebf",
      "text": "Federal Council decision (Nov 2023) to extend temporary protection status 'S' for Ukrainians (clarifying it was provisional and subject to later review)",
      "date": "2023-11-01 00:00:00"
    },
    {
      "id": "3cf927ce-0606-49c9-a8f3-2958023999a2",
      "text": "Euromaidan 'Heavenly Hundred' killings and makeshift morgues",
      "date": "2014-02-20 00:00:00"
    },
    {
      "id": "0e39736e-26f4-4f9d-8ba1-967054b6d03a",
      "text": "Odessa Trade Unions House fire and deaths",
      "date": "2014-05-02 00:00:00"
    },
    {
      "id": "1add4e30-cd25-492a-8b9f-a4b8d5fe5750",
      "text": "German police reported a rise in anti-Russian attacks and politically motivated assaults",
      "date": "2022-03-16 00:00:00"
    },
    {
      "id": "2473eb4f-2c43-4bdc-988e-6373f7312394",
      "text": "Large pro-Ukraine demonstrations and visible Ukrainian refugee presence in German cities",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "afaeb14c-7c75-408c-926e-a3e8c8a836a3",
      "text": "Frontiers / parasitology commentary (2022) and coverage highlighting patient-driven helminth/\"worm therapy\" experiments and unregulated self‑treatment",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "76635dbe-afb2-4636-b758-4cb44e7787f7",
      "text": "Major regulatory and media attention as U.S. agencies granted inspection/clearance for cell-cultivated meat products (June 2023)",
      "date": "2023-06-30 00:00:00"
    },
    {
      "id": "49a0a2f5-6976-43f4-ab33-7721a4580cfd",
      "text": "Industry disclosures and patent filings describing immortalization approaches for commercial cell lines (publicly cited in literature)",
      "date": "None"
    },
    {
      "id": "99d4ff25-e52e-42cb-9bbb-331504d00d24",
      "text": "Parliament approves TV language quotas requiring major channels to broadcast ~75% Ukrainian content",
      "date": "2017-05-23 00:00:00"
    },
    {
      "id": "bfc5a568-ce9d-4379-81ae-c95f7db0f346",
      "text": "Revocation of the 2012 'Kivalov–Kolesnichenko' regional language law (removing legal regional status for Russian in some areas)",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "8e86b9c1-b8fd-4850-a0ce-9bd15d8e9fe1",
      "text": "Passage of Ukraine's 'Law on Education' (affecting language of instruction)",
      "date": "2017-09-05 00:00:00"
    },
    {
      "id": "62b1c349-8a48-41c6-aff2-041f14d94129",
      "text": "Presidential decree to block major Russian websites and social networks (VKontakte, Odnoklassniki, Yandex)",
      "date": "2017-05-16 00:00:00"
    },
    {
      "id": "c5556274-2955-4223-93e9-febbbc593ac0",
      "text": "Ban on import/distribution of 38 Russian books (listed as promoting 'hate' or 'separatism')",
      "date": "2015-08-11 00:00:00"
    },
    {
      "id": "749c573f-6d99-43d1-93e1-1aeb776bd723",
      "text": "UNEP/Ozone Secretariat and related press releases in Oct 2019 emphasized that the ozone layer is 'slowly healing' and that the Montreal Protocol has been effective.",
      "date": "2019-10-24 00:00:00"
    },
    {
      "id": "c50a2138-0b86-4f47-aee6-dda205328aef",
      "text": "NOAA and NASA announced that the 2019 Antarctic ozone hole was the smallest on record (annual peak extent), attributed in part to unusual stratospheric warming.",
      "date": "2019-10-24 00:00:00"
    },
    {
      "id": "af70fd3c-0f4e-49f3-b25a-63935cd5ea6c",
      "text": "UN/OHCHR reporting of thousands killed in eastern Ukraine (2014–2015)",
      "date": "2015-09-24 00:00:00"
    },
    {
      "id": "48c11cdf-4764-4cd2-911e-469e9ec3135c",
      "text": "Defense and fall of Donetsk International Airport ('Cyborgs') with heavy casualties",
      "date": "2015-01-24 00:00:00"
    },
    {
      "id": "f8862daa-afb5-49de-a80f-ef289a621c9e",
      "text": "Battle of Avdiivka — intense frontline fighting and elevated casualties",
      "date": "2017-01-24 00:00:00"
    },
    {
      "id": "7f4a044e-a00c-47ee-8282-f045a93d6dbb",
      "text": "Battle of Debaltseve and Ukrainian withdrawal under pressure",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "daab206a-46c6-42b9-86bd-4772d61d43bf",
      "text": "Reports of Ukrainian sailors being pressured to take Russian oaths or detained during Crimea takeover",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "4ff9dd85-321e-4fc1-b596-2519e34295c6",
      "text": "Tense stand‑off aboard blockaded Ukrainian ship Slavutych in Sevastopol where crew resisted takeover",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "2cd437e5-7618-46c4-8169-8a22df9219c1",
      "text": "NOAA/NCEI released a major update to its global surface temperature dataset (NOAAGlobalTemp update) that changed historical coverage/adjustments.",
      "date": "2023-02-14 00:00:00"
    },
    {
      "id": "cc45c3e8-7e6b-4f81-b0b9-56a2ab01839f",
      "text": "UN Human Rights Monitoring Mission reports on conflict-related killings and impunity in Donetsk and Luhansk",
      "date": "2016-07-13 00:00:00"
    },
    {
      "id": "49c95f25-4fc2-48e0-a4c2-13cd04a0be14",
      "text": "European Parliament adopts 'Importance of European remembrance' resolution condemning both Nazi and Stalinist crimes",
      "date": "2019-09-19 00:00:00"
    },
    {
      "id": "47cedce3-3262-4105-9c19-91971028dc17",
      "text": "Lviv Oblast declares 2019 the 'Year of Stepan Bandera', prompting protest from Israeli and Jewish groups",
      "date": "2018-12-24 00:00:00"
    },
    {
      "id": "7eebea58-eccc-43d6-9605-78c5068074fc",
      "text": "Ukraine passes 'decommunization' laws banning communist symbols and reshaping public memory",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "91c29cf1-50ac-4fda-8387-a45e9eb86d48",
      "text": "UN/OHCHR reporting on detentions, security operations and use of anti‑terror measures in eastern Ukraine",
      "date": "2014-07-15 00:00:00"
    },
    {
      "id": "40301d4d-b88e-43bc-b381-d74e42463371",
      "text": "Sanctions and regulatory restrictions targeting Crimea after Russia's 2014 annexation (EU/US measures from June 2014 onward)",
      "date": "2014-06-23 00:00:00"
    },
    {
      "id": "100a5f92-308e-45c1-b373-656f0ac8ba61",
      "text": "Media and veterinary reporting in 2022–2023 documented increasing use of cholecalciferol (vitamin D3) in commercial rodenticides and clinical cases of cholecalciferol poisoning in pets and wildlife.",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "a3431b87-2276-445d-8261-ac070ad38875",
      "text": "Hawaii law banning oxybenzone and octinoxate in sunscreens (signed 2018; implementation and attention into 2020–2021)",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "3bc6623e-2517-4386-b3ef-1a6ef5e48177",
      "text": "Johnson & Johnson voluntary recall of specific Neutrogena and Aveeno aerosol sunscreens after detecting low levels of benzene",
      "date": "2021-07-14 00:00:00"
    },
    {
      "id": "100835ae-6e8a-409d-ab1f-849e3e442927",
      "text": "2004 Mutat Res study finding dihydroxyacetone (DHA, active in sunless tanning) causes DNA damage, cell‑cycle arrest and apoptosis in cultured keratinocytes",
      "date": "2004-06-13 00:00:00"
    },
    {
      "id": "b7badbe4-1480-4740-84af-86c7523a433a",
      "text": "Large Russian military exercises near Europe (e.g., Zapad 2017)",
      "date": "2017-09-24 00:00:00"
    },
    {
      "id": "5943d437-2833-43b2-b041-b1240a2a79a0",
      "text": "Kerch Strait incident — Russia seized Ukrainian naval vessels",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "f8a12006-8d34-44eb-913e-a0e4597ccf85",
      "text": "Minsk II ceasefire agreement (and its incomplete implementation)",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "ad2b7363-fc21-4dba-afa1-17fa408f20e2",
      "text": "CDC guidance update allowing fully vaccinated people to stop wearing masks in most settings (May 13, 2021).",
      "date": "2021-05-13 00:00:00"
    },
    {
      "id": "649a8931-8e47-40b4-b474-17f7ae5b39cd",
      "text": "CDC/NCHS guidance on certifying COVID-19 deaths (April 2020) and subsequent public discussion of death-coding.",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "2911afdc-2774-462b-bd60-f60cf44428a5",
      "text": "Great Barrington Declaration (Oct 4, 2020) promoting 'focused protection' and criticizing lockdowns.",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "27ebf54a-7220-410b-bf97-38d6dd4708f2",
      "text": "Publication of the DANMASK-19 randomized trial in Annals of Internal Medicine reporting no statistically significant protective effect to wearers from recommending surgical masks (November 2020).",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "33dd84d3-8730-4bb5-9380-23b417b5e4d0",
      "text": "Public reporting (e.g., Foreign Policy, OSINT coverage) that social media posts and geotagged content have been used to locate and target soldiers in the Ukraine war (OSINT used operationally).",
      "date": "2023-03-02 00:00:00"
    },
    {
      "id": "a7239427-66bd-4600-aed2-581476f25b1d",
      "text": "Independent reports in 2014 documenting summary killings, alleged mass graves and executions in eastern Ukraine (Amnesty International briefing, Oct 2014).",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "0b7dc1e2-ab56-4b33-ac54-7cdeb5f16390",
      "text": "CDC MMWR (March 2012) reporting autism spectrum disorder prevalence of about 1 in 88 in US surveillance areas (data for 2008)",
      "date": "2012-03-30 00:00:00"
    },
    {
      "id": "0a61ddef-0a7a-4d1f-8d16-65bd35c1ffc9",
      "text": "Public reporting of rising measles cases in the UK attributed to declines in MMR uptake following the MMR scare",
      "date": "2008-11-07 00:00:00"
    },
    {
      "id": "65c099f8-b04c-434c-82f1-db7b66e3bb75",
      "text": "1999 precautionary recommendation to remove thimerosal (a mercury-containing preservative) from childhood vaccines in the United States",
      "date": "1999-07-24 00:00:00"
    },
    {
      "id": "03770f87-b530-494b-839a-699441af95f4",
      "text": "CDC/NCHS provisional reports and public pages in late 2022–early 2023 highlighted continued high counts of non‑COVID causes of death (notably drug overdose and heart disease) in 2021–2022 (CDC provisional drug overdose data page updated Jan 2023).",
      "date": "2023-01-24 00:00:00"
    },
    {
      "id": "97993de4-36d6-40a8-8ee4-74fe9a971f9d",
      "text": "CDC published and maintained public, downloadable jurisdiction‑ and county‑level COVID‑19 vaccine administration/coverage datasets and maps (e.g., CDC Stacks dataset release March 1, 2022).",
      "date": "2022-03-01 00:00:00"
    },
    {
      "id": "17e66a98-25a6-493f-8ac5-75dac9dd5953",
      "text": "UK guidance and primary‑care instructions on narrow criteria and formal processes for issuing COVID‑19 medical exemption certificates (GPs required to follow specified criteria)",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "a0867cc2-91c4-4201-923c-2d77c2076461",
      "text": "Temporary pause and safety review of the Johnson & Johnson (Janssen) COVID‑19 vaccine after reports of rare blood clots (CVST)",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "e61b707f-b13b-4fbc-a817-8cb29c1838de",
      "text": "News coverage of hospitals and transplant programs declining care (including organ transplants) for unvaccinated patients",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "66122d9b-07b9-4336-a64a-2554a7ecc4bb",
      "text": "OSHA/NIOSH hazard communications and guidance on diatomaceous earth/silica hazards (e.g., OSHA interpretation clarifying DE silica content and hazard communication, April 5, 1999; NIOSH silica guidance)",
      "date": "1999-04-05 00:00:00"
    },
    {
      "id": "8418add7-2b09-4307-b140-1777e2bffd7b",
      "text": "Peer‑reviewed and technical studies showing diatomite/diatomaceous earth has sorption/adsorption properties in water treatment (e.g., fluoride/heavy‑metal removal studies, 2019)",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "236fab75-12fe-470c-a805-30e262f615e1",
      "text": "GOV.UK Summary of the Public Assessment Report for the Pfizer/BioNTech COVID-19 vaccine (authorisation documents, Dec 2020) and WHO/regulatory guidance cited therein stating carcinogenicity/genotoxicity testing is generally not required for many vaccines.",
      "date": "2020-12-01 00:00:00"
    },
    {
      "id": "4b0ef420-0f8d-4887-98c1-ba44f430b107",
      "text": "UK MHRA Freedom of Information release (FOI_22-1223) and related correspondence (published 22 Dec 2023) stating 'Neither genotoxicity nor carcinogenicity studies were performed' for certain Comirnaty components and that components 'are not expected to have genotoxic potential.'",
      "date": "2023-12-22 00:00:00"
    },
    {
      "id": "f7986f09-a424-4730-91d8-7184938981d1",
      "text": "Public release/update of childhood cancer incidence data/registries (e.g., National Childhood Cancer Registry Explorer / US cancer surveillance datasets updated 2022–2023) showing short‑term fluctuations or small upticks in incidence that were reported in the media.",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "ad594a92-20eb-4c2a-a4ca-27bfaca1bb08",
      "text": "Russia imposed an import ban on Roshen confectionery products (Rospotrebnadzor cited safety concerns).",
      "date": "2013-07-29 00:00:00"
    },
    {
      "id": "6f6b7766-153e-495c-8bb7-c1fe489a04dd",
      "text": "Armed police and plainclothes officials entered the Lipetsk Roshen factory amid court cases and commercial disputes (widely reported tensions at the Lipetsk site).",
      "date": "2014-03-31 00:00:00"
    },
    {
      "id": "e109c0a7-b9f8-47fb-8dec-aabcf71b1533",
      "text": "Roshen announced it would close its Lipetsk (Russia) factory and halt operations, laying off workers (company statement reported January 2017; operations stopped by April 2017).",
      "date": "2017-01-20 00:00:00"
    },
    {
      "id": "0b7e45d3-6556-44e5-a308-6ecaeed877bd",
      "text": "Petro Poroshenko transferred his Roshen stake into a blind trust managed by Rothschild Trust (announcement and confirmations in January 2016).",
      "date": "2016-01-14 00:00:00"
    },
    {
      "id": "ea0c236f-635a-4b74-b1a1-5663336c4c92",
      "text": "Pre‑existing, reputable polls with mixed results (GfK Ukraine 2018) showing regional variation in nostalgia",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "18ae0cbe-1331-4340-b56a-5c85bc9c3939",
      "text": "Historical 1991 independence referendum (92% voted for independence) — widely reported figure available in public records",
      "date": "1991-12-01 00:00:00"
    },
    {
      "id": "a15d5adb-b4d5-4ea9-97a6-1ea64e048da2",
      "text": "Oleg Sentsov began an indefinite hunger strike on 14 May 2018 to demand the release of Ukrainian political prisoners, drawing intense international attention to his case.",
      "date": "2018-05-14 00:00:00"
    },
    {
      "id": "5159d09a-626f-4ef3-b9eb-e1a360dd8787",
      "text": "Human-rights organisations and public petitions mobilised around Sentsov in mid‑2018 (Amnesty International and other advocacy actions in June 2018 used #FreeSentsov widely).",
      "date": "2018-06-24 00:00:00"
    },
    {
      "id": "011a22da-0d5b-4885-a0b2-5f5f1cabb1f1",
      "text": "Norway reports and investigations of frail elderly deaths temporally associated with vaccination",
      "date": "2021-01-24 00:00:00"
    },
    {
      "id": "cbce4f11-1d44-4416-a418-76bdd1b80270",
      "text": "U.S. pause of the Johnson & Johnson (Janssen) vaccine after rare blood clot reports",
      "date": "2021-04-13 00:00:00"
    },
    {
      "id": "ef36060f-f210-48b4-9102-ace7aa5d8b7d",
      "text": "Publication of Karl et al. (2015) NOAA/Science paper revising recent global surface temperature analyses and addressing the so‑called 'hiatus'",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "7f1c8ce2-f14a-40ce-80d7-fcb2fcb8a938",
      "text": "Local incidents and campaigns (e.g., Holy Rus' Movement activity reported in Pastavy) around November 2014 that raised tensions over flags, national identity and pro‑Russian vs pro‑European messaging.",
      "date": "2014-11-09 00:00:00"
    },
    {
      "id": "c248d4d9-7e12-4ee9-8273-2c7baa433d29",
      "text": "Annual Shrovetide/Maslenitsa effigy‑burning traditions observed across Slavic countries (including Belarus) where effigies are publicly burned as part of festival rites.",
      "date": "None"
    },
    {
      "id": "25ac0643-8c95-4de8-8761-28dfeb1e494c",
      "text": "Visible use of alternative Belarusian opposition symbols (white‑red‑white flags) and frequent protest imagery in 2014 that foregrounded flags and symbols in public demonstrations.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "94ae7d73-7c37-4d4d-81d5-f34cb67332c7",
      "text": "U.S. Patent US4686605A ('Method and apparatus for altering a region in the Earth's atmosphere, ionosphere, and/or magnetosphere') granted to Bernard J. Eastlund (patent text describes possible weather-modification applications).",
      "date": "1987-08-11 00:00:00"
    },
    {
      "id": "b5a0b1ab-b754-4668-8df3-ac0730010494",
      "text": "IMF staff report on Ukraine's emergency financing needs under the Rapid Financing Instrument (IMF staff report published March 7, 2022)",
      "date": "2022-03-07 00:00:00"
    },
    {
      "id": "11a0d2b6-f308-41e0-a22b-006339445092",
      "text": "World Bank warning Ukraine economy could shrink sharply in 2022 (World Bank press release, April 10, 2022)",
      "date": "2022-04-10 00:00:00"
    },
    {
      "id": "90adc281-7853-41dc-95c0-1d93ff441625",
      "text": "Parliamentarian warning Ukraine needs $5 billion a month in external aid (reported by Reuters)",
      "date": "2022-06-14 00:00:00"
    },
    {
      "id": "65f3b7a8-60c7-4efa-a179-748ce3d57066",
      "text": "S&P Global Ratings cuts Ukraine's sovereign credit rating (Reuters)",
      "date": "2022-05-27 00:00:00"
    },
    {
      "id": "b834e80c-57e4-4c4e-9364-a6ce35f05cef",
      "text": "U.S.-led training of Ukrainian military personnel at sites such as the Yavoriv training center (Joint Multinational Training Group – Ukraine began operations in 2015).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "d08075a0-da02-4f6d-9e2f-471a31fbe88a",
      "text": "National Endowment for Democracy (NED) grants and NGO funding programs in Ukraine following Euromaidan (published in NED annual reports and grant records).",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "28b6dc91-8158-42e8-b45b-ef79f26080f6",
      "text": "U.S. announces major economic assistance and loan guarantees to Ukraine as part of post-Maidan support (including a White House fact sheet detailing assistance).",
      "date": "2014-11-24 00:00:00"
    },
    {
      "id": "1614d4e1-9ef9-4d1b-aef0-7beefdeafd27",
      "text": "Visit by U.S. Senator John McCain to Kyiv's Maidan protests and public expressions of support for pro-European protesters.",
      "date": "2013-12-24 00:00:00"
    },
    {
      "id": "771cadb6-a575-4af6-8466-113aa0936dcc",
      "text": "Kerch Strait incident: Russian forces fired on and seized three Ukrainian navy vessels attempting to transit the Kerch Strait, injuring sailors and sharply escalating tensions.",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "7216020d-38a5-4789-8bf9-8b552e21b881",
      "text": "Verkhovna Rada debated and adopted the Law on the Reintegration of Donbas (early 2018) and passed parliamentary resolutions emphasising de-occupation and reintegration of territories lost in 2014, including Crimea.",
      "date": "2018-01-18 00:00:00"
    },
    {
      "id": "0a4165e4-da8d-4eda-b1fd-dd6020c834e2",
      "text": "European Union extended sanctions related to Russia's 2014 annexation of Crimea after diplomatic deliberations in December 2019.",
      "date": "2019-12-13 00:00:00"
    },
    {
      "id": "563d2ebd-745e-44e1-8475-c15c1c9fe8ef",
      "text": "President Volodymyr Zelensky publicly vowed to restore Ukrainian control over Crimea during his inauguration, stressing Crimea remains part of Ukraine.",
      "date": "2019-05-20 00:00:00"
    },
    {
      "id": "ac95df98-1a59-45d0-a7f8-02a1ccf486ac",
      "text": "CDC Vital Signs (MMWR) documenting a sharp rise in firearm homicides in 2020",
      "date": "2022-05-10 00:00:00"
    },
    {
      "id": "9d91cf96-9ac9-4dd9-b4b1-a62cb2f0b37e",
      "text": "Reports and recall actions after discovery of foreign/black particles in Moderna vaccine vials in Japan (investigation and lot suspensions)",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "f3a22222-3f26-4d41-8ae4-ec2eec8e359d",
      "text": "NEJM study showing substantial waning of Pfizer–BioNTech (BNT162b2) protection against SARS‑CoV‑2 infection over months in Qatar",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "c287a65d-6767-4792-a760-e5e5c06094fb",
      "text": "ACIP/CDC review and MMWR reporting of myocarditis/pericarditis cases after mRNA COVID‑19 vaccination in young males",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "c3b6f443-30c4-40f4-ad7c-b75048fa6cd0",
      "text": "Passage of Ukraine's decommunization laws (adopted April 9, 2015)",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "52949534-ad9a-45bf-97df-7560f69a8480",
      "text": "Verkhovna Rada officially renamed the city of Kirovohrad to Kropyvnytskyi",
      "date": "2016-07-14 00:00:00"
    },
    {
      "id": "7e554a7b-d9be-49df-877b-d884572747c1",
      "text": "City council-organized public survey (Oct 25, 2015) reported that around 77% of participating respondents favoured restoring the historical name 'Yelysavetgrad' (low turnout)",
      "date": "2015-10-25 00:00:00"
    },
    {
      "id": "f5800722-6b8b-4a18-be9d-085c87f1ca2f",
      "text": "Reports of foreign/black particles found in some vaccine vials (Japan, September 2021) and subsequent temporary suspensions/recalls",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "0dfb5183-818a-4a43-a434-b3172805c9d8",
      "text": "Court-ordered public release of Pfizer/FDA review documents (rolling release beginning March 1, 2022)",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "057415f7-0a69-4ad7-81cf-5bf03120bb5b",
      "text": "Reports and rights‑group coverage of extra-legal self‑defence units and weapons proliferation in occupied/contested areas (Human Rights Watch World Report 2015)",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "14cf000c-8c1e-4720-9adf-7bde0c3f5147",
      "text": "Poroshenko sacks Ihor Kolomoisky as governor after armed men seize oil company offices; publicly warns no regional 'pocket armies' will be tolerated",
      "date": "2015-03-25 00:00:00"
    },
    {
      "id": "df08cb44-ecf0-470d-9612-05f33a1bd3be",
      "text": "E‑petition filed calling for formalisation of citizens' right to bear firearms (Reg. №1135-1 submitted)",
      "date": "2015-02-05 00:00:00"
    },
    {
      "id": "71e43c54-8546-43f0-8584-9a3b81e73792",
      "text": "Presidential decree and public events strengthening/celebrating the National Guard and deployment of National Guard battalions (march 2015)",
      "date": "2015-03-18 00:00:00"
    },
    {
      "id": "015ad92d-8a43-4c86-8eca-57b3ed328aba",
      "text": "Widespread formation and operation of volunteer battalions (e.g., Azov, Donbas) during 2014–early 2015",
      "date": "2014-12-13 00:00:00"
    },
    {
      "id": "52aa91a5-8d8b-4866-8a15-a467ddeb84d3",
      "text": "Public debate and reporting on Ukraine's mobilization and need to replenish/rotate forces",
      "date": "2023-04-11 00:00:00"
    },
    {
      "id": "1f00bdc8-2cc0-4ec2-ad34-86ee8a82ebdb",
      "text": "Claims of territorial setbacks (Soledar) early 2023 that were amplified by Russian sources",
      "date": "2023-01-13 00:00:00"
    },
    {
      "id": "75b4df13-6fdf-41f5-9548-45d77a05afef",
      "text": "Summer–autumn 2021 'wind drought' across the UK and parts of Western Europe produced unusually low wind output and a noticeable drop in renewable electricity generation.",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "7f5a768b-f8ae-4844-b7cb-a83633d09cbe",
      "text": "February 2021 Texas winter storm caused widespread grid failures and stressed electricity supply; some industrial sites (including data centers) relied on backup power and experienced operational impacts.",
      "date": "2021-02-24 00:00:00"
    },
    {
      "id": "c7300144-20ac-4f8d-b8db-56dc189b6f68",
      "text": "NOAA / Coral Reef Watch reporting and technical briefs documenting the 2020 GBR marine heatwave and unprecedented bleaching risk (March 2020)",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "6d18bc06-08d9-49b1-a732-ce69be1a92bc",
      "text": "UNESCO/World Heritage publicity around suggestion to list the Great Barrier Reef as 'in danger' (July 2021)",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "21d7ba1d-2d43-4b90-874e-3fd3b70de5a7",
      "text": "Reporting and congressional attention on EcoHealth Alliance and funded coronavirus research with the Wuhan Institute (NIH correspondence and investigations, Oct 2021 onward)",
      "date": "2021-10-21 00:00:00"
    },
    {
      "id": "27413585-74ac-42fd-a64a-9526033ba7b5",
      "text": "U.S. Department of Energy reported an assessment favoring a laboratory origin (covered in Feb 2023 press)",
      "date": "2023-02-26 00:00:00"
    },
    {
      "id": "4b503e26-b164-4d01-8cfb-e3cb93f6f278",
      "text": "Russian and other state‑backed media amplified allegations of U.S. biological labs and research being part of hostile programs (March 2022)",
      "date": "2022-03-09 00:00:00"
    },
    {
      "id": "3daaf72f-9ed4-4402-bbfa-caa34aea8145",
      "text": "Great Barrington Declaration (4 October 2020) — public statement by a group of scientists advocating 'focused protection' instead of broad lockdowns.",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "b716df28-25f5-4342-9e96-aeffe85cc626",
      "text": "Publication and media coverage of the DANMASK-19 randomized trial (Denmark) in November 2020, reporting limited protective effect of recommending surgical masks for wearers in a low-transmission setting.",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "7d12d99d-5ec0-47fb-a7fc-15b34faea721",
      "text": "Imperial College COVID-19 Response Team Report 9 (16 March 2020) modelling high projected deaths and showing large effects from non-pharmaceutical interventions (NPIs), widely cited by policymakers and media.",
      "date": "2020-03-16 00:00:00"
    },
    {
      "id": "28b169fe-6d66-4d61-9e75-cffde783f4a0",
      "text": "Publicised requests to retract or critique the early Corman–Drosten RT‑PCR protocol (late 2020) and widespread online debate about PCR sensitivity, cycle thresholds, and false positives.",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "81ea0346-0d3c-46da-ae67-a4e4511295e1",
      "text": "Israeli Health Ministry report (June 2021) identifying a probable link between Pfizer vaccine and rare myocarditis cases",
      "date": "2021-06-01 00:00:00"
    },
    {
      "id": "16bef4ff-b6fc-49ed-9739-8e7b0eeb5d41",
      "text": "FDA Emergency Use Authorization (EUA) for the Pfizer–BioNTech COVID-19 vaccine",
      "date": "2020-12-11 00:00:00"
    },
    {
      "id": "78b444af-b57d-412a-8a93-e25c216c3f78",
      "text": "CDC MMWR report on the Provincetown (Massachusetts) July 2021 outbreak with a high proportion of cases in fully vaccinated people",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "80cc3156-fe40-44e1-a335-8776a3897352",
      "text": "Announcement of 'Operation Warp Speed' to accelerate COVID-19 vaccine development",
      "date": "2020-05-15 00:00:00"
    },
    {
      "id": "2344c640-395e-4645-a314-d1a54fc02b7b",
      "text": "WHO designation and global spread of the Omicron variant (variant of concern declared 26 November 2021) and subsequent large waves of infections in late 2021–early 2022",
      "date": "2021-11-26 00:00:00"
    },
    {
      "id": "b0a3cf13-1a4a-49cf-9650-b4d47bd24a66",
      "text": "Preprint released claiming a 'Worldwide Bayesian Causal Impact Analysis' of 145 countries showing vaccine deployment increased COVID-19 cases and deaths",
      "date": "2021-11-15 00:00:00"
    },
    {
      "id": "ae5557c6-998c-4b66-b2b7-a5aecbac8f3c",
      "text": "Major meat company sustainability commitments and reports (example: JBS releases 2022 Sustainability Report and net‑zero framing)",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "b41e6423-16f3-4b35-870c-1142dc824e7e",
      "text": "Wide media coverage and debate around the GWP* methane metric (interpretation and promotion of GWP* as an alternative to GWP100)",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "013c1cd9-b7c8-48fb-b8ce-475e23266ea5",
      "text": "Publication of peer‑review studies and meta‑analyses showing mixed evidence on soil carbon gains from grazing/regenerative practices (example: Nature 2024 grazing/carbon meta‑analysis)",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "7de80b65-043f-4e5d-a9bc-d226ff6b6fdd",
      "text": "Public U.S. statements (late 2014) denying provision of lethal weapons to Ukraine under Obama administration",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "5da602a2-f68a-4e2a-8e3a-9e3ace51e706",
      "text": "Rapid Trident 2014 multinational exercise at Yavoriv (September 2014)",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "3b98511c-321a-4192-8fb8-abc95011c37e",
      "text": "U.S. 2nd Cavalry Regiment Javelin live‑fire range at Grafenwöhr/Vilseck (Sept 23, 2014)",
      "date": "2014-09-23 00:00:00"
    },
    {
      "id": "0321a354-364a-4a30-b679-e623c1a70423",
      "text": "Destruction of the Antonov AN-225 'Mriya' and visible damage at Hostomel/Antonov airport after Russian strikes",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "4711e8d3-bd16-4241-953d-c51c6c90d423",
      "text": "FAO publishes 'Livestock's Long Shadow' quantifying livestock's share of global greenhouse gases and comparing it to transport",
      "date": "2006-09-24 00:00:00"
    },
    {
      "id": "7ddd12d2-cff6-49aa-b67f-7dfa800c3849",
      "text": "June 2021 reports and ACIP discussions documenting rare cases of myocarditis/pericarditis after mRNA vaccination in adolescents and young adults.",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "10001215-1c6c-494d-b431-6dd94724db27",
      "text": "October 29, 2021: FDA Emergency Use Authorization and ACIP recommendation for Pfizer‑BioNTech COVID‑19 vaccine in children aged 5–11.",
      "date": "2021-10-29 00:00:00"
    },
    {
      "id": "004ea1ef-02fa-47bf-a43c-2078a1530a3a",
      "text": "Publication of Ogata et al. (May 20, 2021): small pilot study detecting SARS‑CoV‑2 vaccine antigen (spike protein) in the plasma of 11 of 13 mRNA‑1273 (Moderna) recipients.",
      "date": "2021-05-20 00:00:00"
    },
    {
      "id": "975471e0-820a-4978-8aaa-066b30963821",
      "text": "Published evidence of waning vaccine effectiveness and Israel's booster campaign (e.g., Bar‑On et al., NEJM showing booster restored protection after demonstrated waning).",
      "date": "2021-10-07 00:00:00"
    },
    {
      "id": "bbe3e36a-e3e8-44b0-8d0b-6bb1acbbccd1",
      "text": "Release and dissemination of the Great Barrington Declaration (October 2020), advocating 'focused protection' and emphasizing immunity from infection.",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "27bab3dd-8905-4e53-8114-ad36b1d41d9b",
      "text": "Publication of Israeli preprint by Gazit et al. reporting that, during the Delta wave, SARS‑CoV‑2‑naive vaccinees had a 13.06‑fold increased risk of infection compared with previously infected individuals (medRxiv preprint).",
      "date": "2021-08-25 00:00:00"
    },
    {
      "id": "130d090a-a725-48fd-97d3-ed44794213dd",
      "text": "New York Attorney General pursued civil actions and publicized dozens of price-gouging complaints against gas stations after Hurricane Sandy (2012).",
      "date": "2012-11-15 00:00:00"
    },
    {
      "id": "983f6e63-0d24-46b9-af13-db591b501c72",
      "text": "Federal Reserve Bank of St. Louis discussion of the 'rockets and feathers' effect (October 2014) showing retail gasoline prices often rise quickly but fall slowly after crude price declines.",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "fdc978ed-40a2-426b-9b52-d01d7ccc34ea",
      "text": "UK government and consumer groups publicly urged petrol retailers to cut prices after steep falls in global oil prices (November 2014 coverage).",
      "date": "2014-11-06 00:00:00"
    },
    {
      "id": "eb8f967f-2656-4a4b-91e8-a4cb188e9b89",
      "text": "Release of the IPCC Fifth Assessment (AR5) Summary for Policymakers (September 2013) with quantified attributions and separate estimates for greenhouse gases and aerosol cooling",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "0d960c2e-82aa-4fcf-8f81-ab730c8a9dd5",
      "text": "Russian seizure of three Ukrainian naval vessels in the Kerch Strait",
      "date": "2018-11-25 00:00:00"
    },
    {
      "id": "0296336a-12f4-46da-8644-2db3b8318904",
      "text": "Ukraine announced partial martial law in response to the incident",
      "date": "2018-11-26 00:00:00"
    },
    {
      "id": "20b1fe96-adae-4346-97e2-6d250e59f29a",
      "text": "Russian Foreign Ministry publicly accused Ukraine of deliberately provoking the incident",
      "date": "2018-11-26 00:00:00"
    },
    {
      "id": "4e7dce9c-6656-4866-afe0-55c31488e64b",
      "text": "FDA emergency use authorization (EUA) for Pfizer-BioNTech vaccine expanded to adolescents aged 12–15",
      "date": "2021-05-10 00:00:00"
    },
    {
      "id": "51c2ac4b-6155-4d68-9e60-c8a889ca9cf1",
      "text": "Publication of Israeli active-surveillance study reporting increased myocarditis cases after BNT162b2 (Pfizer) vaccination",
      "date": "2021-10-06 00:00:00"
    },
    {
      "id": "71716b5e-5ae9-4ffa-8706-06583a089e68",
      "text": "Air-raid alert sounded near central Kyiv while a group of Moscow‑aligned clergy were at the Presidential Office; Ukrainian air defences detected and shot down a drone.",
      "date": "2023-03-20 00:00:00"
    },
    {
      "id": "949d656d-6c77-4e70-a816-4a946c24cafe",
      "text": "Public fallout from Patriarch Kirill and parts of the Russian Orthodox leadership publicly backing Russia’s invasion (2022), prompting Ukrainian clergy and parishioners to cut ties with Moscow.",
      "date": "2022-04-24 00:00:00"
    },
    {
      "id": "96422655-db81-478f-b5cf-5ce26a64e857",
      "text": "UNEP Global Methane Assessment names agriculture (including livestock) as a major short‑lived climate forcer",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "6d645f66-2fa2-4440-97b2-ff77af9e2264",
      "text": "Launch of the Global Methane Pledge at COP26",
      "date": "2021-11-02 00:00:00"
    },
    {
      "id": "4ac1ca20-eebb-45cd-a74b-79edf957b37b",
      "text": "Industry advocacy/PR programs to defend beef (e.g., 'Masters of Beef Advocacy' and NCBA campaigns)",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "2cc66c0f-4d03-4670-961a-363f22e74a7f",
      "text": "Publication of major reports in 2019 (CDC/WHO) highlighting antimicrobial resistance as a growing global health threat",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "31783125-f695-4dd2-b83d-e9c62dacc5f6",
      "text": "Japan's 2013 suspension of proactive HPV‑vaccine recommendation after media reports of adverse events, and the official resumption of active recommendations on Nov 26, 2021.",
      "date": "None"
    },
    {
      "id": "fd9362a0-22e4-4461-9e09-8bb3013720c9",
      "text": "April 2023 court developments in U.S. Gardasil litigation: plaintiffs secured orders/access to adverse‑event databases and internal documents related to Gardasil safety.",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "265a5bd9-2e5f-4b66-9802-32ce6519ab9f",
      "text": "Publication of a November 2022 Journal of Autoimmunity paper (Mehlsen et al.) reporting clinical and pathophysiological findings in a cohort of patients who self‑reported long‑term complications after HPV vaccination.",
      "date": "2022-11-07 00:00:00"
    },
    {
      "id": "0872d008-2206-414f-abe3-83a079ff4a39",
      "text": "NCHS/CDC data summary noted that 94% of death certificates mentioning COVID-19 also listed other health conditions (widely reported Sept 2020).",
      "date": "2020-09-24 00:00:00"
    },
    {
      "id": "5577f827-1608-4eba-b5ec-b6916810af2d",
      "text": "Publication of seroprevalence analyses (JAMA/CDC-linked studies, mid–late 2021) showing infection-induced antibodies were substantially more common than reported case counts indicated.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "6be138f4-42ee-46f9-8ff5-ea2d160f4ea1",
      "text": "Public debate and official briefings in 2021 (WHO and national public-health commentary) about the extent and durability of 'natural immunity' after infection.",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "465c6fb0-520d-4a90-8ca7-5e568b69df28",
      "text": "Human-rights reports documenting abuses (including looting) by some pro‑Ukrainian volunteer battalions (e.g., Aidar)",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "4b96c116-8ff6-4180-aa3a-b5e6d65f179b",
      "text": "Reporting that Chechen fighters were present in eastern Ukraine (widely covered in 2014)",
      "date": "2014-05-31 00:00:00"
    },
    {
      "id": "5ffd8aa4-ec97-4d8a-86a6-30eef06339a0",
      "text": "Russian officials and state media accused the UK and US of involvement after the October 29, 2022 drone attack on the Sevastopol/Black Sea Fleet facilities; coverage noted Russian claims of foreign participation.",
      "date": "2022-10-29 00:00:00"
    },
    {
      "id": "06489a60-fab7-4944-84a1-9059ed5014f1",
      "text": "Reporting on leaked documents and media investigations that suggested UK special forces and other British personnel were operating in Ukraine (e.g., reporting that up to ~50 UK special forces were present).",
      "date": "2023-04-11 00:00:00"
    },
    {
      "id": "f12b36ec-524f-4185-92f8-58f3b6597825",
      "text": "Visegrad (Central European) leaders, including the Czech leadership, publicly underlined opposition to EU migrant/relocation quotas",
      "date": "2015-09-04 00:00:00"
    },
    {
      "id": "243eb1c9-89ac-47a7-8b18-c1f944abe097",
      "text": "Large and growing population of Ukrainian workers/residents in the Czech Republic (Ukrainians became the largest foreign national group)",
      "date": "2017-12-24 00:00:00"
    },
    {
      "id": "7c03c0fd-ffe3-4565-acfa-cb3327161e79",
      "text": "President Miloš Zeman and other officials made repeated anti-refugee/anti-Muslim public remarks during 2015",
      "date": "2015-10-22 00:00:00"
    },
    {
      "id": "770b1abf-44f2-443a-ada7-f9de8408d8de",
      "text": "European Court of Human Rights judgments finding domestic travel bans (imposed by bailiffs/authorities) problematic (e.g. Khlyustov v. Russia)",
      "date": "2013-07-11 00:00:00"
    },
    {
      "id": "5bfadb85-2f13-495d-a5ed-3bb9abe6e895",
      "text": "Passage of other high‑profile restrictive laws by the Duma (e.g. 2012 'foreign agents' NGO law)",
      "date": "2012-07-20 00:00:00"
    },
    {
      "id": "e8eb7f37-56c7-4d36-8486-175416342713",
      "text": "Widespread travel bans imposed by the Federal Bailiff Service on debtors (reports ~500,000 affected)",
      "date": "2014-05-26 00:00:00"
    },
    {
      "id": "839b82be-8ea7-4cae-8cb7-5df1b1d8504d",
      "text": "Public reporting in late June–July 2022 that Ukraine had received and begun using U.S.-supplied HIMARS systems in combat.",
      "date": "2022-07-25 00:00:00"
    },
    {
      "id": "c034b4f3-6230-449a-b8ac-837184dc0e06",
      "text": "Media reporting that many of the victims/prisoners at Olenivka were fighters from the Azov Regiment captured after the fall of Mariupol/Azovstal.",
      "date": "2022-07-29 00:00:00"
    },
    {
      "id": "b255b7c9-3282-4965-a14e-e386cae653f2",
      "text": "International Committee of the Red Cross (ICRC) and other agencies reported limited or denied independent access to the Olenivka site and called for impartial investigation.",
      "date": "2022-07-29 00:00:00"
    },
    {
      "id": "65adb4cf-7e23-4a79-a659-7fbf02ee5fd8",
      "text": "WHO and regulatory guidance documents explicitly listing vaccine-associated enhanced disease/ADE as a safety consideration during COVID-19 vaccine development and evaluation",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "f9423227-1b63-4da3-a7f5-d507937f3480",
      "text": "Preclinical animal studies (e.g., Tseng et al., PLoS ONE) reporting pulmonary immunopathology after SARS coronavirus vaccine challenge in mice",
      "date": "2012-04-20 00:00:00"
    },
    {
      "id": "c6902fca-ab14-47ef-8569-a98135d90446",
      "text": "International Republican Institute (IRI) / Rating Group national survey (September 2023) reporting strong majorities believe Ukraine can defeat Russia and support recapturing lost territory",
      "date": "2023-09-24 00:00:00"
    },
    {
      "id": "0ff69dd0-d45a-4438-9242-dfcfdab7127a",
      "text": "Atlantic Council / DFRLab analysis of pro‑Kremlin information operations (reporting on Russian info tactics aimed at undermining confidence in Ukraine, Feb 2023)",
      "date": "2023-02-24 00:00:00"
    },
    {
      "id": "0e539a1b-8353-4717-8aa8-84f7274cff07",
      "text": "Kyiv International Institute of Sociology (KIIS) omnibus poll on readiness for territorial concessions (data collection Nov 29–Dec 9, 2023)",
      "date": "None"
    },
    {
      "id": "3c61e333-2a92-4f9d-9a82-21dde68f2518",
      "text": "President Volodymyr Zelenskyy's speech to the UN General Assembly (full text published Sept 20, 2023)",
      "date": "2023-09-20 00:00:00"
    },
    {
      "id": "ceb9e85c-52f8-43ae-8501-cd165988bf17",
      "text": "G7 public rejection of Russia’s ruble-for-gas demand",
      "date": "2022-03-28 00:00:00"
    },
    {
      "id": "b887f2b8-b1c5-4847-8a77-8f61e2bf908a",
      "text": "Confusion about how the ruble-payment mechanism would work (Gazprombank conversion accounts)",
      "date": "2022-03-31 00:00:00"
    },
    {
      "id": "c0781159-2fbb-43f9-b1d2-271979aef096",
      "text": "UK government publicly called for investigation into allegations that Russia was stealing Ukrainian grain",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "2f5b44d4-cd77-4901-bf0b-5805d001fa71",
      "text": "AP/PBS Frontline investigation documents large-scale removal of Ukrainian grain from occupied territories using satellite imagery and ship-tracking data",
      "date": "2022-07-24 00:00:00"
    },
    {
      "id": "a6a090f2-250e-43f1-af87-da60443890f6",
      "text": "UN‑brokered Black Sea Grain Initiative led to the first ship leaving Odesa carrying grain under the safe‑passage deal",
      "date": "2022-08-24 00:00:00"
    },
    {
      "id": "1dcc4637-5075-408e-9c32-d48cdf9be951",
      "text": "Longstanding public health and cultural practice in Japan of routine gargling to prevent respiratory infections, and official encouragement of gargling during the 2009 H1N1 outbreak (documented in peer‑reviewed literature).",
      "date": "2009-04-24 00:00:00"
    },
    {
      "id": "7f72ea83-ff2f-4681-a254-a3b653f687c6",
      "text": "Pre‑existing in‑vitro research (2015) showed povidone‑iodine (PVP‑I) oral rinses can rapidly inactivate related coronaviruses (SARS‑CoV, MERS‑CoV) in laboratory tests.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "f0464042-16e0-4fe6-9cea-1520a58e9b6f",
      "text": "2018 studies and media coverage reporting a significant slowdown of the Atlantic Meridional Overturning Circulation (AMOC)",
      "date": "2018-04-25 00:00:00"
    },
    {
      "id": "aa518135-7417-406d-9511-8ae5af77f437",
      "text": "2015 Scientific Reports paper by Zharkova et al. proposing a forthcoming 'modern grand solar minimum' (linked to multi-decadal cooling)",
      "date": "2015-10-22 00:00:00"
    },
    {
      "id": "c4b59a03-d07f-42af-8421-354a5780f962",
      "text": "Late-January 2019 polar vortex cold snap widely covered in US media",
      "date": "2019-01-29 00:00:00"
    },
    {
      "id": "99f7b628-7862-4faa-a1ab-c7a717ed8b26",
      "text": "WHO scientific brief and multiple seroprevalence reports during mid-2020 indicating lower-than-feared infection fatality rates in some populations",
      "date": "2020-08-24 00:00:00"
    },
    {
      "id": "0014feda-1b1b-42a4-aa95-a5b97781628e",
      "text": "Ukrainian authorities publicly reported large-scale allocation of state land to ATO participants (land-for-soldiers program)",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "560e8ffd-ee97-4d01-a595-24d938c47d39",
      "text": "May 2014 Land Agency initiative announced to provide mobilized servicemen and displaced soldiers with free land parcels (10–12 ares up to 2 hectares)",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "9ad9050f-5297-4565-a721-5483adf4a456",
      "text": "Early volunteer recruitment drives and public discussions of material incentives for volunteers and battalions (wide volunteer mobilisation in March 2014)",
      "date": "2014-03-17 00:00:00"
    },
    {
      "id": "ce541d26-e549-457b-a70d-d465ca8545c2",
      "text": "Documented abductions, ill-treatment and forced labour by armed groups in Donbas during 2014",
      "date": "None"
    },
    {
      "id": "182e124b-54fe-40db-a8a6-ec485c12f145",
      "text": "NIH announces suspension/withdrawal of funding to EcoHealth Alliance projects involving the Wuhan Institute of Virology (political scrutiny and reporting intensified)",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "9dfaa4a0-ad0b-412b-91c7-424e2e092732",
      "text": "Early suppression and censure of whistleblower doctor Li Wenliang and his subsequent death, widely reported internationally",
      "date": "None"
    },
    {
      "id": "c00c097f-bcb6-4ed4-8fd5-dead73179f72",
      "text": "Lancet clinical report and early epidemiology (first cluster descriptions) noting both links to the Huanan market and an earliest case with no market link, creating ambiguity about initial spillover",
      "date": "2020-01-24 00:00:00"
    },
    {
      "id": "f854b645-473b-4244-a7c8-531d665d6b1d",
      "text": "Douma suspected chemical attack and subsequent U.S./UK/France strikes",
      "date": "2018-04-07 00:00:00"
    },
    {
      "id": "545df908-fabd-4031-bc78-cc2208ec4a29",
      "text": "Salisbury Novichok poisonings linked to Russia (Sergei and Yulia Skripal)",
      "date": "2018-03-04 00:00:00"
    },
    {
      "id": "29a4b5e8-3852-4ef7-8945-012494f68624",
      "text": "IPCC Fifth Assessment Report (AR5) Summary for Policymakers released, synthesizing evidence on anthropogenic warming and acknowledging internal (natural) variability on decadal scales.",
      "date": "2013-09-27 00:00:00"
    },
    {
      "id": "df02f620-4485-429f-8826-6f4ff9b9efaf",
      "text": "Publication of Karl et al. (2015) in Science revising NOAA surface temperature dataset and concluding biases partly explained the so‑called 'hiatus'.",
      "date": "2015-06-04 00:00:00"
    },
    {
      "id": "5db43199-b0cb-4d87-b497-15807346afa5",
      "text": "Release and publicity around discrepancies between satellite lower‑troposphere trends (UAH/RSS) and surface temperature records, including UAH Version 6.0 release (April 2015).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "88bae962-c00b-49f9-b6d0-289953165ae8",
      "text": "U.S. announces major defensive military assistance increases to Ukraine (e.g., $200 million package)",
      "date": "2018-07-20 00:00:00"
    },
    {
      "id": "72caf4ba-911e-4116-ba62-9c8ff8286562",
      "text": "U.S. Defense Threat Reduction Agency (DTRA) Biological Threat Reduction Program activities publicly documented in Ukraine",
      "date": "None"
    },
    {
      "id": "5d954983-cb6e-4a77-ad29-8e94a7585934",
      "text": "Westinghouse announced extended nuclear fuel supply to Ukraine (contract extension)",
      "date": "2018-01-29 00:00:00"
    },
    {
      "id": "02b65303-b664-4292-a713-a0a542d88621",
      "text": "Sea Breeze multinational naval exercises co-hosted by the U.S. and Ukraine (Black Sea)",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "20a849a7-46e3-40f7-a53a-ef9d656341e4",
      "text": "U.S.–Ukraine Nuclear Safety Arrangement signed (Rockville)",
      "date": "2018-03-13 00:00:00"
    },
    {
      "id": "0237dae1-3387-43b5-85b5-cba8ff095863",
      "text": "Event 201 pandemic tabletop exercise hosted by the Johns Hopkins Center for Health Security with the World Economic Forum and the Bill & Melinda Gates Foundation.",
      "date": "2019-10-18 00:00:00"
    },
    {
      "id": "4ae6cdf7-a766-4c1c-8aee-3a3746dc2c7b",
      "text": "Polish government rhetoric about protecting Poles and restricting entry for Ukrainians with 'anti‑Polish views' (reported by Reuters).",
      "date": "2016-11-10 00:00:00"
    },
    {
      "id": "5a1d42a5-3ff6-455a-8d97-b10540e1e8cd",
      "text": "Polish Sejm passes a resolution on the Volhynia/Volyn killings (frames the 1943 massacres as 'genocide'), heightening Polish‑Ukrainian historical tensions.",
      "date": "2016-07-22 00:00:00"
    },
    {
      "id": "72293139-3b57-4eea-a823-2b901a0bd6cc",
      "text": "Keeling Curve (Scripps/UC San Diego) update and commentary (June 6, 2024) reporting unusually large recent annual and multi-year jumps in atmospheric CO2 at Mauna Loa and in the Keeling record.",
      "date": "2024-06-06 00:00:00"
    },
    {
      "id": "de60d725-248e-45d3-b701-2a13af9f5f3a",
      "text": "Publication of a PNAS-backed study (led by Oregon State University and University of St Andrews) reporting that today's atmospheric CO2 increase is ~10 times faster than at any point in the last 50,000 years.",
      "date": "2024-05-13 00:00:00"
    },
    {
      "id": "118bac1b-1c0e-46ec-995e-13205dbfa0fe",
      "text": "Public familiarity and heightened sensitivity to the term \"airborne\" after prolonged COVID-19 airborne-transmission debates (CDC scientific brief acknowledging airborne transmission dynamics, May 2021)",
      "date": "2021-05-07 00:00:00"
    },
    {
      "id": "36bae434-2756-408c-a259-d7ecb6730216",
      "text": "WHO declares the monkeypox outbreak a Public Health Emergency of International Concern (PHEIC)",
      "date": "2022-07-23 00:00:00"
    },
    {
      "id": "0588b688-a1f1-4c74-bc0d-ab5b9fb67dee",
      "text": "CDC public guidance stating infectious period normally lasts 2–4 weeks (not months)",
      "date": "2022-07-29 00:00:00"
    },
    {
      "id": "1d9be90d-be78-4031-accf-9126f8346c89",
      "text": "World Health Organization interim guidance on mask use updated (interim guidance published/updated in March–June 2020, with a notable update 5 June 2020).",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "877e3f58-d245-4528-8d53-9ba2a6a0f325",
      "text": "US CDC recommended on April 3, 2020 that members of the public should wear cloth face coverings in public settings where social distancing is difficult.",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "5bfee9de-e52b-47bc-9df0-6f7f5bcf7057",
      "text": "The Great Barrington Declaration was published (October 4, 2020), advocating 'focused protection' and opposing broad lockdowns and some mitigation measures.",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "cf1eee85-9662-465f-92bd-7755721934a6",
      "text": "Adoption of the Kivalov–Kolesnichenko language law expanding regional languages (2012)",
      "date": "2012-08-24 00:00:00"
    },
    {
      "id": "45376586-0395-4dcd-b518-01cad0ca117a",
      "text": "Verkhovna Rada voted to repeal the 2012 language law (23 February 2014)",
      "date": "2014-02-23 00:00:00"
    },
    {
      "id": "fad7cf7f-dc96-4ebb-bc6d-b8b06657faef",
      "text": "Pro‑Russian unrest and separatist seizures in eastern Ukraine; local councils declared Russian a regional language (March–April 2014)",
      "date": "None"
    },
    {
      "id": "528eceea-ad8d-4181-98a7-d21830e6b92c",
      "text": "Poland’s prime minister and other Eastern European leaders publicly call for an international tribunal to investigate Russia’s actions",
      "date": "2022-04-03 00:00:00"
    },
    {
      "id": "0e3e0511-d7db-4415-ada9-ee2e4a3be17a",
      "text": "Legal analyses and reporting highlight that the ICC cannot currently prosecute the crime of aggression against a non‑party state like Russia without a UN Security Council referral",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "4af7ba6c-cb5c-47aa-864d-420317ab4551",
      "text": "Divergent public language among Western leaders over strong legal labels (e.g., 'genocide' versus 'possible genocide') in April 2022",
      "date": "2022-04-04 00:00:00"
    },
    {
      "id": "3410331e-c4bb-4b1b-9574-05e5018b3c78",
      "text": "Major international media profiles and frontline reporting highlighted large numbers of Ukrainian women serving in combat roles.",
      "date": "2023-08-02 00:00:00"
    },
    {
      "id": "734ada9f-5249-4622-87e4-59853bd3ca96",
      "text": "Parliamentary debate and media attention around Ukraine's draft/mobilization laws, with officials explicitly saying female conscription was not part of the new draft law.",
      "date": "2024-01-08 00:00:00"
    },
    {
      "id": "8e6134fe-fcea-496d-8c42-a0c71fc9314b",
      "text": "Documented increases in pertussis (whooping cough) activity in 2023–early 2024 reported by public health agencies",
      "date": "2024-03-24 00:00:00"
    },
    {
      "id": "69e46ab7-fa2a-4486-aa2d-5674fe1d36ae",
      "text": "Reports that Chinese firms/state-linked investors had shown interest in financing large Crimea projects (transport/energy/ports).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "a79eec91-a9d0-4d1e-9151-c8ba4191eeae",
      "text": "Siemens turbine deliveries controversy highlighted limits in enforcing sanctions on equipment shipments to Crimea.",
      "date": "2017-06-24 00:00:00"
    },
    {
      "id": "4848d6dd-681c-4bfb-8f4c-088503283355",
      "text": "RFE/RL investigation reporting that numerous EU firms and intermediaries were finding ways to do business in Crimea despite sanctions.",
      "date": "2017-05-24 00:00:00"
    },
    {
      "id": "c84d033c-e6d4-4d02-87e5-bfbd16e5763c",
      "text": "Publication of a broad scoping review 'Electric vehicles and health: A scoping review' (Environmental Research) that summarized limited and mixed evidence about EV-specific health outcomes and pointed to evidence gaps (June 2024).",
      "date": "2024-06-15 00:00:00"
    },
    {
      "id": "c4ae27ed-c685-40eb-b3f2-cd3a9e555b24",
      "text": "A 2021 systematic review in Frontiers in Physiology summarized animal and limited human studies on radiofrequency electromagnetic radiation (RF‑EMR) from wireless devices and reported that many animal studies found reduced testosterone after RF‑EMR exposure (September 24, 2021).",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "edf44a9b-5a98-47e1-8ff2-e651a3916ab4",
      "text": "U.S. ends COVID-19 national and public health emergencies",
      "date": "2023-05-11 00:00:00"
    },
    {
      "id": "d2216b00-aa4e-4904-a59d-96640477b74f",
      "text": "Court dispute over FDA's proposed slow release of Pfizer vaccine documents (initial 75‑year timeline)",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "51da7fb3-ba1c-4c01-bb2b-33e9987857e1",
      "text": "Reports of black/metallic particles found in Moderna vaccine vials in Japan",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "120e6568-4927-46e5-9b8c-9209bae7ba65",
      "text": "UNHCR / humanitarian agencies reporting large numbers of Ukrainians remaining under temporary protection across Europe (data briefs, 2024)",
      "date": "2024-02-24 00:00:00"
    },
    {
      "id": "9ee5891d-a8c2-4320-bdf4-773e1c8b47a5",
      "text": "Hungary tightens border-control procedures and increases checks for certain categories (early 2023)",
      "date": "2023-01-24 00:00:00"
    },
    {
      "id": "74348668-7496-4786-bd40-a3af23277223",
      "text": "Polish president vetoes law extending social benefits and protections for Ukrainian refugees",
      "date": "2025-08-25 00:00:00"
    },
    {
      "id": "5f253ea7-44db-41d3-af44-c944763b5a9d",
      "text": "Large-scale border disruption at Poland–Ukraine crossings after Polish trucker protests temporarily blocked traffic",
      "date": "2023-11-30 00:00:00"
    },
    {
      "id": "8b5a9367-1545-497c-928c-f030b8a8f17e",
      "text": "EU Commission / Council actions on temporary protection timing (proposal/extension toward a defined transition period)",
      "date": "2025-06-04 00:00:00"
    },
    {
      "id": "5d364e2a-f3de-43f7-b56a-969e6a87be50",
      "text": "World Health Assembly adopted a package of amendments to the International Health Regulations (IHR)",
      "date": "2024-06-01 00:00:00"
    },
    {
      "id": "ddc9cd67-afd2-4128-af33-fd1ad79e6eef",
      "text": "A coordinated public letter and statements by many U.S. Republican governors saying they would not comply with a WHO pandemic agreement",
      "date": "2024-05-22 00:00:00"
    },
    {
      "id": "9ba9a2bc-1b97-468e-8e27-647989e228f4",
      "text": "WHO/PAHO international guidance on certification and coding of COVID-19 deaths published (guidelines on identifying COVID-19 as cause of death)",
      "date": "2020-06-24 00:00:00"
    },
    {
      "id": "7f258dc4-cf55-47d7-be56-d97f72ce1266",
      "text": "New York Times coverage that Russia was sending mercenaries and Syrian fighters to Ukraine",
      "date": "2022-04-06 00:00:00"
    },
    {
      "id": "1bb93b9a-3781-44f3-9a0a-577dec3bc98e",
      "text": "WHO Situation Report 132 (PDF) released on May 31, 2020, summarizing global confirmed COVID-19 cases and deaths through that date.",
      "date": "2020-05-31 00:00:00"
    },
    {
      "id": "2c6af927-8707-4b2b-a140-05964d617e9d",
      "text": "Media coverage in March–April 2020 documenting overwhelmed hospitals and surging deaths in Lombardy and other early hotspots (e.g., New York, Lombardy) that highlighted acute local mortality spikes.",
      "date": "2020-03-19 00:00:00"
    },
    {
      "id": "8697104c-7220-4b29-b05a-345b1a11c2eb",
      "text": "Ukraine Health Ministry backs new organ-transplant law and announces 2018 pilot for cadaveric kidney donation",
      "date": "2017-09-24 00:00:00"
    },
    {
      "id": "48f065e1-6239-40c3-8de3-d1143ae5a53c",
      "text": "OSCE report and regional analysis on trafficking for organ removal (2013)",
      "date": "2013-07-09 00:00:00"
    },
    {
      "id": "c9c22e9c-6197-4c83-b1bb-8e73c7a16c24",
      "text": "French authorities and national media reported a sudden surge in bedbug sightings across Paris (including verified infestations in at least one school) that prompted government coordination meetings.",
      "date": "2023-10-06 00:00:00"
    },
    {
      "id": "dcd2ed13-c5a6-4710-955f-f038ddd86c35",
      "text": "Poroshenko's profile as a wealthy oligarch and highly polarising figure following his 2014 election (widely reported in 2014), which made character attacks and rumors about personal misconduct more plausible to hostile audiences.",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "4950e4b4-3064-47e2-b931-2dc32f30e301",
      "text": "Canadian government issues travel advisories urging citizens to avoid travel to Ukraine",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "9823e290-a1be-4856-94c8-d7ef2125e053",
      "text": "Ukrainian president signs decree on general mobilization",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "1c192a7f-6d7a-47cf-8ad1-f2b4242cc65c",
      "text": "Large-scale Canadian charitable and advocacy campaigns raising funds and political support for Ukraine",
      "date": "2022-03-01 00:00:00"
    },
    {
      "id": "ea77b17e-ecb8-4852-bf00-da2fb17cbbe1",
      "text": "Reports of foreign/stainless‑steel particles found in some Moderna vaccine vials in Japan, prompting pauses of affected lots.",
      "date": "2021-09-01 00:00:00"
    },
    {
      "id": "09d0628e-e7ad-4fc7-a135-0d7f8e2f9cc5",
      "text": "FDA revises Emergency Use Authorization (EUA) for COVID-19 convalescent plasma, narrowing use to high‑titer units for specific hospitalized patients.",
      "date": "2021-02-04 00:00:00"
    },
    {
      "id": "ea349321-89e6-4d71-9a4f-896fdd5e06e6",
      "text": "American Red Cross published/updated guidance on COVID‑19 vaccination and blood donation explaining eligibility rules and referring to FDA guidance (including notes about convalescent plasma collection changes).",
      "date": "None"
    },
    {
      "id": "448ae192-3b42-4b2a-8680-e61ce109a521",
      "text": "U.S. Fish and Wildlife Service 2008 Biological Opinion to protect the endangered Delta smelt",
      "date": "2008-12-24 00:00:00"
    },
    {
      "id": "14e09847-a435-42c1-a835-bed3c468e5f7",
      "text": "Media analysis and commentary on large volumes of stormwater/capture shortfalls (2015 coverage)",
      "date": "2015-04-15 00:00:00"
    },
    {
      "id": "71d91ae6-6b54-4b70-b8aa-5a6814c43071",
      "text": "California governor issues first-ever statewide mandatory urban water restrictions",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "df4460b4-7c1c-49af-be67-024ef6ef060f",
      "text": "2017 Northern California 'Wine Country' wildfires (Napa, Sonoma, Mendocino)",
      "date": "2017-10-24 00:00:00"
    },
    {
      "id": "38d0ccc7-b6b8-4e53-8909-a8c39537ad0c",
      "text": "Oroville Dam spillway failure and mass evacuation",
      "date": "2017-02-24 00:00:00"
    },
    {
      "id": "855c1651-d97c-4cd5-b2de-b8ca61f51f95",
      "text": "Cleveland Clinic (laboratory guidance/fact sheet) and other clinical bodies publishing guidance that MTHFR genotyping has limited clinical value (2020–2021).",
      "date": "2021-02-24 00:00:00"
    },
    {
      "id": "6d616443-0575-4ec5-a830-05487037412b",
      "text": "Publication of PNAS paper showing extremely slow and highly variable human DHFR activity (Bailey & Ayling, 2009).",
      "date": "2009-09-24 00:00:00"
    },
    {
      "id": "b88a14bc-bc70-4f66-b011-56f47993a594",
      "text": "BMC Public Health report on threshold doses above which unmetabolized folic acid appears in serum (Sweeney et al./BMC Public Health, 2007).",
      "date": "2007-04-24 00:00:00"
    },
    {
      "id": "e0d555cc-8363-4331-aa93-dc1acfeeb692",
      "text": "1979 and subsequent clinical reports: Published case reports and toxicology reviews documenting pennyroyal ingestion as a historical abortifacient and a cause of severe hepatotoxicity.",
      "date": "None"
    },
    {
      "id": "79d5176e-9c81-4f30-8587-b5b143eec7e0",
      "text": "July 15, 2004: Case report in the New England Journal of Medicine linking maternal use of blue cohosh to perinatal stroke and other neonatal harms.",
      "date": "2004-07-15 00:00:00"
    },
    {
      "id": "5d1118ba-6b69-4321-84d6-7de9b1524f11",
      "text": "CDC updated its 'Learn the Signs. Act Early.' developmental milestone checklists, adding new checklists for 15- and 30-month visits and publishing revised milestone wording on the CDC site.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "ce70bb4b-4946-4e75-a10c-b774ee576e03",
      "text": "OSCE SMM reduced/ceased control of its Mariupol office amid the early invasion and reports that the Mission 'had not controlled its office' in Mariupol since March 2022 (and the Mission publicly called for the release of detained SMM members in late May).",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "f91ac186-93e5-489b-ade1-ad29dde61184",
      "text": "OSCE Special Monitoring Mission (SMM) publicly operated monitoring cameras and posts along the contact line prior to the 2022 full-scale invasion (public SMM daily reports noted monitors and equipment deployed).",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "34c56fa8-be6a-46c4-b26c-a4aeacac5d2e",
      "text": "Release and reporting on 2018 U.S. diplomatic cables that raised safety and staffing concerns about the Wuhan Institute of Virology.",
      "date": "None"
    },
    {
      "id": "82dddf7c-fd0c-4c46-9029-3fc44df72117",
      "text": "Russian authorities begin large-scale issuance of Russian passports to Crimean residents and publicly announce high application numbers",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "52e91da0-9157-4d5e-a39e-0198037536bd",
      "text": "Widespread reporting during 2022 that huge areas of Ukraine were contaminated with unexploded ordnance and mines (official estimates in Aug 2022).",
      "date": "2022-08-12 00:00:00"
    },
    {
      "id": "c00d1032-387a-4c4f-b23f-57952627513c",
      "text": "Russian missile strikes on Lviv damaged critical infrastructure and caused power outages (reported 11 Oct 2022).",
      "date": "2022-10-11 00:00:00"
    },
    {
      "id": "2c94bfd2-8eb8-447c-94bd-aa14100c383e",
      "text": "Anonymous bomb threats led to evacuations of Lviv supermarkets and shopping malls (mass evacuations reported 22 Oct 2022).",
      "date": "2022-10-22 00:00:00"
    },
    {
      "id": "42160d7c-e28e-42d3-b0ab-b24654ac2dce",
      "text": "CDC FluView weekly report showed influenza detections dropped to near zero by week 14 (week ending Apr 4, 2020).",
      "date": "2020-04-04 00:00:00"
    },
    {
      "id": "3c6bf119-017a-4c56-87dd-60c0f339121f",
      "text": "Council of State and Territorial Epidemiologists (CSTE) interim position statement published (Apr 5, 2020) updating COVID-19 case/death definitions to include probable cases.",
      "date": "2020-04-05 00:00:00"
    },
    {
      "id": "067f96be-1ace-43fe-8105-2c02bc09f5c0",
      "text": "CDC/NCHS released a provisional death counts report (PDF) with technical notes emphasizing that counts are provisional, delayed, and that multiple causes can be listed on death certificates (released Apr 10, 2020).",
      "date": "2020-04-10 00:00:00"
    },
    {
      "id": "61fdaa4e-3c09-452e-a4aa-012df78ccdcc",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I — Summary for Policymakers published",
      "date": "2021-08-09 00:00:00"
    },
    {
      "id": "c4b9433f-a0c8-4d6d-9ec6-609949063e9e",
      "text": "NOAA issues La Niña advisory / 'double-dip' La Niña announcement",
      "date": "2021-12-24 00:00:00"
    },
    {
      "id": "a084da89-c83b-4afd-b54c-2a8112ec592b",
      "text": "Passage of Ukraine's 'decommunization' laws (April 9, 2015) banning public display of Soviet symbols and changing commemorative practices.",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "40a2e79a-1c1f-48ac-bce5-99a7074fbb0c",
      "text": "Verkhovna Rada passes sweeping 'anti-protest' laws (known as the 'dictatorship laws') restricting public assembly, internet access and media on January 16, 2014.",
      "date": "2014-01-16 00:00:00"
    },
    {
      "id": "fd780cf9-e0e5-430e-a0f7-1871abe13666",
      "text": "Deadly police crackdown on Euromaidan protests in Kyiv (notably February 18–20, 2014) where security forces used live fire against demonstrators.",
      "date": "2014-02-18 00:00:00"
    },
    {
      "id": "a3bbeea1-6daf-47ac-8e8d-4efd4af5ad02",
      "text": "April 2014 'anti-terrorist operation' (ATO) launched in eastern Ukraine (Donetsk/Luhansk) with security operations, checkpoints and restrictions on movement and gatherings.",
      "date": "2014-04-15 00:00:00"
    },
    {
      "id": "3ba59ba3-06e5-4fcc-931b-19bf4789bc2f",
      "text": "Rapid growth of the global 'detox' / detox‑supplement market (industry reports and press releases 2020–2021 showing large and growing commercial market for detox supplements).",
      "date": "2021-10-18 00:00:00"
    },
    {
      "id": "318d5425-4331-4f32-9398-ac802757f8bf",
      "text": "Publication of a 2022 peer-reviewed review 'Can Antioxidants Reduce the Toxicity of Bisphenol?' summarizing multiple studies that several dietary antioxidants (curcumin, quercetin, melatonin, lycopene, genistein, etc.) reduce BPA‑induced oxidative stress in vitro and in animal models.",
      "date": "2022-02-18 00:00:00"
    },
    {
      "id": "d3c7f4fe-66ff-40a3-b62a-9d9b9d2739ca",
      "text": "Regulatory controversy and mixed messaging about BPA safety after regulatory reviews (e.g., FDA’s 2018 BPA assessment) prompted public debate and critical commentary from scientists.",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "dfb4efbb-bfbb-49c2-aab2-003dc944b974",
      "text": "Takeda and Moderna publish investigation and voluntary recall statement after foreign-particle findings in Japan",
      "date": "2021-10-24 00:00:00"
    },
    {
      "id": "76afb1a9-c1cb-49a5-b345-61590db5cb86",
      "text": "Publication and reporting of excess-mortality analyses in Japan showing increased deaths during/after the pandemic with cardiovascular diseases among contributing causes",
      "date": "2024-04-24 00:00:00"
    },
    {
      "id": "b8efd856-ccbb-42ac-8e04-a53a4c96b40b",
      "text": "Public-health reports and peer-reviewed case reports document myocarditis/pericarditis occurring after mRNA COVID-19 vaccination (identified in 2021 monitoring and guidance)",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "8b1fc3f1-6e5d-4aba-947b-0a74c23dbd95",
      "text": "Harvard launches the Solar Geoengineering Research Program (SGRP), formalizing academic research into stratospheric aerosol methods.",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "2d0e301b-eeab-47d1-8581-f4fd7ae239e4",
      "text": "IPCC Special Report on Global Warming of 1.5°C (SR1.5) discusses solar radiation management (SRM) as a theoretical option and highlights governance and uncertainty issues.",
      "date": "2018-10-24 00:00:00"
    },
    {
      "id": "87aebf1a-2e8e-405f-924a-4588468d03be",
      "text": "Major media coverage highlighting geoengineering as a contested climate option (e.g., The Guardian: 'Geoengineering may be used to combat global warming, experts say').",
      "date": "2018-10-08 00:00:00"
    },
    {
      "id": "92768a75-9f7f-4ab9-8595-46aa79de7699",
      "text": "2018 pilot study published in the Journal of Alzheimer's Disease reporting cognitive improvements after a 21-day coconut oil–enriched Mediterranean diet",
      "date": "2018-07-20 00:00:00"
    },
    {
      "id": "1c7fbe04-ec94-48b6-9c05-105d999c6553",
      "text": "International media and human-rights organizations reported abductions, torture and summary killings in eastern Ukraine (including areas around Slovyansk) during April–May 2014.",
      "date": "2014-05-24 00:00:00"
    },
    {
      "id": "47150385-ade3-432b-967e-9c1960df5be8",
      "text": "Pro‑Russian militants abandoned Slovyansk and Ukrainian forces re-entered the city after the siege, leaving a chaotic information environment and reports of casualties and abuses.",
      "date": "2014-07-05 00:00:00"
    },
    {
      "id": "725f30c6-6356-4be4-895a-af950908eac5",
      "text": "Russia imposes a one‑year ban on many Western food imports (fruit, vegetables, meat, dairy) in retaliation to sanctions",
      "date": "2014-08-07 00:00:00"
    },
    {
      "id": "6ee4125e-714c-4b39-a047-f03ce6530dd8",
      "text": "Coverage in early 2015 highlighting that Russians were spending a much larger share of income on food amid economic turmoil",
      "date": "2015-03-03 00:00:00"
    },
    {
      "id": "d4e1806a-1fa2-48fb-acb4-72f8364c744d",
      "text": "Russian rouble crashes in December 2014, prompting emergency central‑bank action",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "9a4ed516-ccae-4da8-9436-a0e39e489053",
      "text": "FDA published a draft guidance clarifying aluminum limits for small-volume parenteral products used in parenteral nutrition (widely covered Dec 2022)",
      "date": "2022-12-07 00:00:00"
    },
    {
      "id": "611aa0d7-ac04-4701-aa64-cb64aaeee9c3",
      "text": "Publication of Vaccine pharmacokinetic analysis that became the benchmark for vaccine aluminum safety assessments (Mitkus et al., 2011)",
      "date": "2011-11-28 00:00:00"
    },
    {
      "id": "2c3a20fa-8de4-435e-86cc-ce4eceb9327f",
      "text": "FDA warning about aluminum risk from an unapproved Hospira potassium phosphates product (FDA alert)",
      "date": "2023-02-09 00:00:00"
    },
    {
      "id": "834c4a1d-d053-4003-9d3f-eec1ea5562f0",
      "text": "European Commission progress report concluded Ukraine met the benchmarks for visa liberalisation and announced it would present a legislative proposal to lift short-stay visa requirements.",
      "date": "2015-12-18 00:00:00"
    },
    {
      "id": "20037b8d-86d1-4760-a95b-9cc30382fe98",
      "text": "Immediate Dutch government reaction was cautious — officials said they would reconsider ratification and seek a formal response, but announced no immediate legal block to EU-level procedures.",
      "date": "2016-04-07 00:00:00"
    },
    {
      "id": "855fdde6-02a6-438e-9904-7d2c5d4f57c4",
      "text": "Historical precedent: Ukraine suspended passenger and cargo rail/bus links to Crimea in December 2014 citing security concerns",
      "date": "2014-12-26 00:00:00"
    },
    {
      "id": "3d8d34c5-ddad-4bcd-bff9-af8c13886dcc",
      "text": "UK MHRA conditional authorisation and patient information leaflets published (regulatory materials listing ingredients and usage information)",
      "date": "2020-12-02 00:00:00"
    },
    {
      "id": "6f8de6bf-7ebb-4122-91c9-32fceaad5497",
      "text": "FDA/BioNTech briefing documents for the VRBPAC EUA review that list vaccine components (mRNA, lipid nanoparticle constituents including PEG, salts, and sucrose)",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "cd397027-fc2b-434a-be79-66a8dd895ed3",
      "text": "Ukrainian President Volodymyr Zelensky publicly floated Rustem Umerov as a possible candidate to be Ukraine's ambassador to the United States during the International Ukraine Recovery Conference (URC2025) in Rome.",
      "date": "2025-07-15 00:00:00"
    },
    {
      "id": "cf1abeac-55ef-4d5e-b26b-6b043978f7a0",
      "text": "U.S. FDA public warning against using veterinary or unapproved ivermectin products to treat or prevent COVID‑19",
      "date": "2020-08-21 00:00:00"
    },
    {
      "id": "c32cfa0a-5731-42eb-9405-49aa1ae6fb3e",
      "text": "CDC public information noting 'common human coronaviruses' (229E, NL63, OC43, HKU1) have been identified for decades",
      "date": "None"
    },
    {
      "id": "204cfb3e-51d0-4c06-9b34-b7f9f5bb562f",
      "text": "Implementation of selective city-level bans on older diesel vehicles (example: Munich introduced restrictions on Euro 4 diesel vehicles in its low‑emission zone).",
      "date": "2023-02-01 00:00:00"
    },
    {
      "id": "ff78ec41-dc42-40e6-a051-567be1db134e",
      "text": "European Commission publishes proposal COM(2023)451 — a draft Regulation on circularity requirements for vehicle design and management of end‑of‑life vehicles (revising ELV rules).",
      "date": "2023-07-13 00:00:00"
    },
    {
      "id": "bf818f5b-90da-4582-85fb-19fc52a635cb",
      "text": "EU ‘Fit for 55’ / CO2 standards debate and widespread coverage of the EU aim for zero‑emission new cars by 2035.",
      "date": "2022-10-19 00:00:00"
    },
    {
      "id": "14b273fe-7ada-41c4-be2e-e5e07b0f1e57",
      "text": "Hungarian Prime Minister Viktor Orbán publicly opposed fast‑tracking Ukraine’s EU accession (Dec 13, 2023)",
      "date": "2023-12-13 00:00:00"
    },
    {
      "id": "d915c3ed-2ef6-414a-88a6-e1bbbcf055d2",
      "text": "‘For Ukraine, for their Freedom and Ours!’ campaign urged MEP candidates to sign a pro‑Ukraine Commitment Charter (May 11, 2024)",
      "date": "2024-05-11 00:00:00"
    },
    {
      "id": "8df2d92d-4658-40ec-bde9-6f8142269924",
      "text": "Yle launched/ran its European election 'compass' showing candidate positions (May 2024)",
      "date": "2024-05-24 00:00:00"
    },
    {
      "id": "fb31651d-30f2-4a99-b469-e59003f53a8a",
      "text": "European Parliament Special Committee warned of foreign interference and disinformation ahead of the June 2024 elections (May 24, 2024)",
      "date": "2024-05-24 00:00:00"
    },
    {
      "id": "39333550-34d4-4ce2-a36a-2c97e736d53c",
      "text": "Public release/submission of the RaTG13 genome sequence to public databases (GenBank accession MN996532 / GISAID submission in January 2020).",
      "date": "2020-01-27 00:00:00"
    },
    {
      "id": "700992d8-f1e0-497c-acbe-78b9492d07b9",
      "text": "BMJ Case Report (2018) and wider media attention on Macrophagic Myofasciitis (MMF) case reports linking persistent aluminium deposits at injection sites to chronic symptoms.",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "9ca4877e-5f87-49b8-9445-275bce494d17",
      "text": "2013 BMC Medicine study 'Slow CCL2‑dependent translocation of biopersistent particles from muscle to brain' (Khan et al.).",
      "date": "2013-08-08 00:00:00"
    },
    {
      "id": "ce966e10-c2bd-47c0-9418-9e74ef39232a",
      "text": "Publication of 2015 review 'Biopersistence and Brain Translocation of Aluminum Adjuvants of Vaccines' by Gherardi et al.",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "c315885c-f36f-4cb3-99a0-25ec60dfcd60",
      "text": "EU publicly criticises Poroshenko's anti‑corruption court bill and signals consequences (January 2018)",
      "date": "2018-01-24 00:00:00"
    },
    {
      "id": "25d666ca-7aed-47ca-a084-6bd9ce2c8274",
      "text": "U.S. criminal indictment of Paul Manafort (October 2017) for unregistered lobbying related to Ukraine",
      "date": "2017-10-24 00:00:00"
    },
    {
      "id": "0a737724-a683-4c0f-9a7c-ab1a2bd3b414",
      "text": "Investigative exposé on defence procurement implicating son of Poroshenko ally (Hladkovskyi)",
      "date": "2019-02-24 00:00:00"
    },
    {
      "id": "adcc03bd-1444-4f94-9c3a-79f6971eaabd",
      "text": "Ukrainian President Petro Poroshenko signs a cooperation agreement with Ecumenical Patriarch Bartholomew in Istanbul to advance autocephaly for a Ukrainian church.",
      "date": "2018-11-03 00:00:00"
    },
    {
      "id": "21b41621-8ee2-479f-8e02-e12c53da180f",
      "text": "Reporting that President Poroshenko publicly used the Tomos and the new church as part of his 2019 re-election messaging.",
      "date": "2019-01-24 00:00:00"
    },
    {
      "id": "ff095616-4af7-4f55-b51e-7f432b40a233",
      "text": "U.S. administration ordered an intelligence review into the origins of COVID‑19 (President Biden, public announcement and press coverage), which brought renewed political attention to lab‑origin claims (May 2021).",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "06771dc0-9d5e-45d4-88a8-d3ab9f85d2f3",
      "text": "Reporting in mid‑2023 that Ukraine’s 2023 summer counteroffensive produced only limited gains (e.g., BBC and other outlets in August 2023) created a broader narrative of stalled Ukrainian progress",
      "date": "2023-08-05 00:00:00"
    },
    {
      "id": "85028514-fcf2-460e-b88f-ec26291d1d1c",
      "text": "Japan suspends and recalls Moderna vaccine doses after foreign particles found (August–September 2021)",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "6435466e-2952-4414-a5f1-47d0171d8ffe",
      "text": "CDC guidance allowing fully vaccinated people to resume most activities without masks (May 13, 2021) and subsequent reversals with Delta/Omicron",
      "date": "2021-05-24 00:00:00"
    },
    {
      "id": "bcb14239-600a-4eab-b1b9-58e88135fa1b",
      "text": "Federal judge orders expedited release of large batches of FDA/Pfizer vaccine documents after FOIA litigation (January 2022)",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "29f4ec77-37a2-4604-9bcc-2ce84dd4c238",
      "text": "CDC/ACIP update and MMWR on myocarditis reports after mRNA vaccines (June 2021)",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "73c8b15d-1231-42da-a241-422b5c1fb69b",
      "text": "CDC VISION Network MMWR showing waning mRNA vaccine effectiveness during Omicron (Feb 2022)",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "4f4ed72b-59e3-4046-aaf2-44942cd0b308",
      "text": "Russia sends 'humanitarian convoy' toward eastern Ukraine and insists on involvement (August 2014)",
      "date": "2014-08-12 00:00:00"
    },
    {
      "id": "4a4e224e-7a32-4905-aa82-ff4c93672219",
      "text": "Ukrainian parliament adopts law granting 'special status' to certain areas of Donetsk and Luhansk",
      "date": "2014-09-16 00:00:00"
    },
    {
      "id": "aff81321-a0f3-4580-8bcf-752f4e09fcf5",
      "text": "President Vladimir Putin’s public justification (March 2014) for actions in Crimea citing protection of Russian speakers/compatriots",
      "date": "2014-03-18 00:00:00"
    },
    {
      "id": "361e2400-514c-4d1c-8260-a9666a5a4248",
      "text": "Longstanding monitoring and studies at Altamont Pass Wind Resource Area documenting unusually high raptor (including golden eagle) mortality at that site (estimates cited of ~75–110 golden eagles killed annually in some monitoring periods).",
      "date": "None"
    },
    {
      "id": "1b6c2507-9795-4fb5-bccb-74065585080c",
      "text": "U.S. Fish & Wildlife Service final eagle incidental-take rule (2024) — revised permitting framework and creation/clarification of general permits for qualifying wind projects (rulemaking completed Feb 2024).",
      "date": "2024-02-12 00:00:00"
    },
    {
      "id": "c3bd5dcd-4149-4477-a659-7bb5246d1bb5",
      "text": "Europe’s 2022 energy-price shock and widespread reporting (Eurostat summary Apr 26, 2023) showing record household electricity and gas price increases in 2022.",
      "date": "None"
    },
    {
      "id": "83473979-fb4b-4337-b7c1-cdf92eb9f099",
      "text": "Winter Storm Uri (Feb 2021) — widespread reporting and official ERCOT analyses showing frozen equipment across fuel and renewable sources and public debate blaming frozen wind turbines for Texas outages.",
      "date": "2021-02-22 00:00:00"
    },
    {
      "id": "19e439e9-e941-45d9-97d4-3d80f61e6139",
      "text": "Adoption of Ukraine's 'decommunization' laws banning communist symbols (including measures that led to restricting St. George's ribbon) by the Verkhovna Rada.",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "1e0aa012-871a-47c6-b3de-310a4b27a131",
      "text": "High‑profile coverage in Western and regional media documenting the St. George's ribbon's revival in Russia and its adoption by pro‑Russian activists in eastern Ukraine around Victory Day (widely reported in 2014–2015).",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "08b338d4-ba23-461e-acd0-3aeb175af22a",
      "text": "British intelligence assessment reported that Russia may have lost a third of the ground forces it committed to the Ukraine offensive",
      "date": "2022-05-15 00:00:00"
    },
    {
      "id": "6473f1aa-081b-466b-b4fd-20d81d1581a2",
      "text": "Ukrainian General Staff released casualty figures for Russian forces (tens of thousands) in mid‑May and publicized high cumulative loss numbers",
      "date": "2022-05-18 00:00:00"
    },
    {
      "id": "ff3e0441-f529-4a70-9757-06710b824691",
      "text": "Public drone and ground imagery showing multiple destroyed Russian tanks and armoured vehicles around Kyiv and in Bucha after Russian withdrawals",
      "date": "2022-04-06 00:00:00"
    },
    {
      "id": "6c9a434b-1457-47b6-9dcc-1c75e4861937",
      "text": "Maxar and other commercial satellite imagery releases in May 2022 showing destroyed equipment and damage across multiple frontline areas",
      "date": "2022-05-12 00:00:00"
    },
    {
      "id": "01e425df-a493-4ceb-a10f-366132092c49",
      "text": "WHO designation of Omicron as a variant of concern and rising discussion of immune escape (Nov 26, 2021)",
      "date": "2021-11-26 00:00:00"
    },
    {
      "id": "bb447e51-3e43-43d2-aff6-cd68610c451a",
      "text": "Public‑health guidance reiterating vaccination after prior infection (CDC and other authorities, 2021–early 2022)",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "7907d9ef-600b-4c2d-a3be-9c4a176cd7be",
      "text": "Publication of Dagan et al. (Israel) showing high real-world effectiveness of the BNT162b2 (Pfizer) vaccine",
      "date": "2021-04-15 00:00:00"
    },
    {
      "id": "40f63a23-9a81-4612-a7c6-663a75472a70",
      "text": "Hungary blocked a NATO–Ukraine commission meeting over Ukraine's 2017 education law",
      "date": "2017-12-24 00:00:00"
    },
    {
      "id": "33409e40-fa92-45b1-91e9-7281a7f9b3fd",
      "text": "Hungarian government rhetoric defending the Hungarian minority in Zakarpattia and threatening to obstruct Ukraine's Euro-Atlantic integration (2017)",
      "date": "2017-10-24 00:00:00"
    },
    {
      "id": "1e2ed96f-4bfd-4a09-b9fb-c73047552ac0",
      "text": "Hungary's close energy and political ties with Russia (Paks II nuclear deal signed in January 2014)",
      "date": "2014-01-14 00:00:00"
    },
    {
      "id": "aca0f8db-8cce-436e-9f36-c59945100e64",
      "text": "Malaysia Airlines Flight MH17 shot down over eastern Ukraine",
      "date": "2014-07-17 00:00:00"
    },
    {
      "id": "7d2c1726-d24b-411c-a5d2-91e783ff24e2",
      "text": "EU/East StratCom and Western coverage documenting Russian disinformation campaigns in Europe (2015–2017)",
      "date": "2017-06-24 00:00:00"
    },
    {
      "id": "51cada5f-bae0-4fe4-82f2-f424c9951e82",
      "text": "The OSCE Parliamentary Assembly (OSCE PA) deployed a separate observer delegation and issued a statement describing the election as 'well administered' while also noting it took place in an 'overly controlled environment'.",
      "date": "2018-03-19 00:00:00"
    },
    {
      "id": "517eda25-9e4e-4744-afea-9ec93d143de1",
      "text": "CIS (Commonwealth of Independent States) and other regional observer missions publicly declared the election legitimate, transparent or free.",
      "date": "2018-03-19 00:00:00"
    },
    {
      "id": "5d5f34ae-5d42-4d04-8dbc-2d17a2182cd3",
      "text": "OSCE/ODIHR published a preliminary statement saying the 18 March 2018 Russian presidential election 'lacked real choice' and noted pressure on critical voices.",
      "date": "2018-03-19 00:00:00"
    },
    {
      "id": "c7bcd41b-1225-4ee5-a3f4-e24ba2264600",
      "text": "Brazilian President Jair Bolsonaro publicly called COVID‑19 'a little flu' and urged reopening despite rising cases.",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "46f0ed0e-6f42-49fb-bf9e-93ca1af2fdcf",
      "text": "U.S. CDC published its estimated burden for the 2019–2020 influenza season (tens of thousands of flu deaths) during spring 2020.",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "2f6ae23a-6a6d-466b-a49c-0c243534c600",
      "text": "U.S. CDC issued guidance for certifying deaths due to COVID‑19 allowing certifiers to report COVID‑19 on death certificates without laboratory confirmation in certain circumstances (Guidance for Certifying COVID‑19 Deaths, April 2020).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "0b34a825-fd9a-4fc3-881e-05b84a59c7a6",
      "text": "International monitors curtailed/paused long-range drone surveillance after repeated shoot-downs and jamming",
      "date": "2016-10-28 00:00:00"
    },
    {
      "id": "b2b60d66-d76d-450f-8e69-1ca976ccda79",
      "text": "OSCE long-range UAV lost after spotting a surface-to-air missile system near Donetsk",
      "date": "2018-10-27 00:00:00"
    },
    {
      "id": "efcf46a1-61b7-4d0b-a5aa-5529bf29d0d3",
      "text": "Pentagon comments and reporting that a limited amount of Presidential Drawdown Authority/stockpiles remained to provide to Ukraine (public discussion of remaining resources)",
      "date": "2023-09-24 00:00:00"
    },
    {
      "id": "b91d7bec-96a9-4d94-bdc2-5ed4eb968349",
      "text": "President Biden formally requested roughly $24 billion in new aid for Ukraine (public request to Congress)",
      "date": "2023-08-10 00:00:00"
    },
    {
      "id": "f6d5650a-6b0a-4043-9a6b-7eabb6c7a150",
      "text": "U.S. State Department and other reports described Ukrainian procedures allowing some civil-status acts (for example, births) occurring in occupied areas to be registered using documents produced by occupation authorities to ensure access to services.",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "38f1cf54-5ad5-4c49-8a3d-e93657b103ee",
      "text": "Ukrainian Ombudsman statement noting Ukraine does not recognize Russian passports issued in occupied territories, while discussing legislative options for how residents might renounce such documents after liberation.",
      "date": "2023-04-17 00:00:00"
    },
    {
      "id": "3e5f3975-3edc-4cd0-a670-f2c1840c66e6",
      "text": "Verkhovna Rada approved a mechanism to evaluate/validate educational documents issued in temporarily occupied territories (draft law passed to create testing/validation procedures).",
      "date": "2023-11-21 00:00:00"
    },
    {
      "id": "9893fde8-e5de-4296-b569-f392ddf5393a",
      "text": "Ukraine engaged in limited, practical negotiations and humanitarian arrangements (e.g., corridors for ships, humanitarian talks) with actors linked to occupied areas and with mediators in 2023.",
      "date": "2023-08-11 00:00:00"
    },
    {
      "id": "f17fe3ad-a3a7-4472-b37d-5ca020d6ec9f",
      "text": "Samoa measles outbreak and prior botched MMR injections that caused two infant deaths, undermining local vaccine confidence",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "49f61cde-4635-4a82-bb4c-63e3298cb768",
      "text": "CDC reporting of rare myocarditis/pericarditis cases after mRNA COVID‑19 vaccination in adolescents",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "676facc8-78a8-42f4-a283-637f67e1fb55",
      "text": "New York Times feature 'In Washington, Olena Zelenska Dressed for Ukraine' describing her Washington wardrobe, the role of her stylist, and the diplomatic messaging in her clothing choices.",
      "date": "2022-07-21 00:00:00"
    },
    {
      "id": "5ad082db-f23f-46fd-b81a-fefc0f9075bb",
      "text": "Tobacco industry pivot and public messaging promoting nicotine products (e.g., BAT reporting growth in vaping/oral nicotine)",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "e93e1943-e0ab-4308-b6d5-77afb1fb7c94",
      "text": "Cochrane systematic review finding transdermal nicotine superior to placebo for active ulcerative colitis (with important limitations)",
      "date": "2004-10-24 00:00:00"
    },
    {
      "id": "dbc8a9c3-8baa-41ca-badc-d94ab83818c3",
      "text": "Small Phase 1 trial of an alpha7‑nicotinic agonist showing biomarker and attention effects in two adults with autism",
      "date": "2016-12-24 00:00:00"
    },
    {
      "id": "92a4a455-c203-458c-9cc2-0914b6b1bb7b",
      "text": "Early reporting and analysis warned that Russian tactics could include heavy artillery, siege and attrition that would 'grind down' Ukrainian defenses and cities.",
      "date": "2022-03-02 00:00:00"
    },
    {
      "id": "ebce9aef-82f3-4955-bb2b-a9c93b3f84f0",
      "text": "U.S. Secretary of State Antony Blinken made multiple public remarks in early March emphasizing both the scale of Russian forces and U.S. support for Ukraine (including a March 6 interview where he said Putin 'is destined to lose').",
      "date": "2022-03-06 00:00:00"
    },
    {
      "id": "22021f3b-e8a1-4ebd-828a-825c45610f81",
      "text": "USDA and FDA announce formal agreement on regulation of cell‑cultured food products",
      "date": "2019-03-07 00:00:00"
    },
    {
      "id": "4420e0a2-5ba0-4a0d-a7d9-826e094acd08",
      "text": "GFI (Good Food Institute) '2022 Cultivated Meat State of the Industry' report (published Jan 2023)",
      "date": "2023-01-24 00:00:00"
    },
    {
      "id": "b737f51d-eda6-4784-92cf-3ef5948a13fe",
      "text": "First PEGIDA offshoot rally in Sweden (Malmö) and associated media coverage of anti‑Islam/anti‑migration street demonstrations",
      "date": "2015-02-10 00:00:00"
    },
    {
      "id": "a829fdc9-636d-4a65-9100-e6491e27a82b",
      "text": "U.S. FDA approval of VEKLURY (remdesivir) for COVID‑19 treatment (press announcement and approval) in October 2020.",
      "date": "2020-10-22 00:00:00"
    },
    {
      "id": "d3a0d501-6436-496b-99a9-51ec76f653d4",
      "text": "PALM (Ebola) randomized trial (NEJM, 2019) stopped remdesivir arm after interim results showed higher 28‑day mortality in the remdesivir group compared with certain monoclonal antibody treatments.",
      "date": "2019-11-27 00:00:00"
    },
    {
      "id": "1a242b20-5120-4ab9-a68a-4591c9689eea",
      "text": "President Zelensky dismissed all regional military recruitment centre heads amid a corruption scandal (public firing announced 11 August 2023).",
      "date": "2023-08-11 00:00:00"
    },
    {
      "id": "8c0cbb84-db13-44d4-b4cc-9904138a88e0",
      "text": "Verified reports of real civilian fatalities in Bila Tserkva from previous Russian attacks (example: kamikaze drone/strike reported 05 October 2022 with at least one casualty).",
      "date": "2022-10-05 00:00:00"
    },
    {
      "id": "50ba63ef-9d11-4bda-8ad8-fcc3de82fc84",
      "text": "A separate, real violent incident linked to conscription/document checks was reported (draft officer fatally wounded during a papers check in Lviv).",
      "date": "2023-12-04 00:00:00"
    },
    {
      "id": "c9647f6c-c432-434e-851c-eacfa8ab85bd",
      "text": "President Obama and some Western leaders publicly deferred sending lethal weapons to Ukraine (reported agreement not to supply lethal defensive arms at that time).",
      "date": "2015-03-09 00:00:00"
    },
    {
      "id": "2a98ff16-b946-4fcf-85bd-ccb288f0aa27",
      "text": "Canada launched Operation UNIFIER, a Canadian Armed Forces training mission to Ukraine.",
      "date": "2015-04-14 00:00:00"
    },
    {
      "id": "a1c06e67-80d5-4d8f-b0cd-8d383af5b2b5",
      "text": "Pentagon suspended planned military exercises and activities with Russia amid the Ukraine crisis.",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "54f58f01-a70b-4df4-806c-2e9b85fcfb74",
      "text": "NATO Secretary-General publicly stated NATO had no plans to deploy combat troops to Ukraine.",
      "date": "2014-02-27 00:00:00"
    },
    {
      "id": "e462c37e-791b-4cc3-8ff0-c39070b5a7a5",
      "text": "NSIDC analysis: unusually rapid December 2023 sea-ice expansion noted in early January 2024 ('Fast December expansion')",
      "date": "2024-01-03 00:00:00"
    },
    {
      "id": "b797a527-44cf-4f53-99fe-1099c00679dd",
      "text": "IPCC AR6 (WGI) projection showing Arctic likely to be 'practically ice-free' in summer near mid-century (released Aug 2021)",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "a7284336-7028-4863-afb0-b32f48dc2e87",
      "text": "Sterigenics / Willowbrook ethylene oxide emissions controversy and EPA/CDC assessments (facility operations suspended/closed amid cancer‑risk concerns).",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "1f783ba8-cb50-4762-b602-1e7f5ee916d5",
      "text": "Ukrainian authorities agreed to implement the 'Steinmeier formula' as part of efforts to restart Minsk-format negotiations (announced Oct 1–2, 2019).",
      "date": "2019-10-02 00:00:00"
    },
    {
      "id": "4e12fd61-0875-4354-bb83-d269570c8eca",
      "text": "Volodymyr Zelensky publicly proposed direct talks and a conciliatory approach to Russia after taking office, signalling a priority on negotiation and rapprochement.",
      "date": "2019-07-08 00:00:00"
    },
    {
      "id": "4d7eb9b1-9a26-4e98-8fcf-a28104ea6824",
      "text": "Russia and Ukraine carried out a high-profile prisoner exchange in early September 2019, swapping dozens of detainees.",
      "date": "2019-09-07 00:00:00"
    },
    {
      "id": "26ef7b8d-385d-40b7-9fce-5868078df2c9",
      "text": "Ukraine's legal framework largely prohibits/does not recognize dual citizenship (Law on Citizenship of Ukraine, enacted)",
      "date": "2001-04-24 00:00:00"
    },
    {
      "id": "98a74f5c-953f-4fe8-aaf3-a6941ae420a2",
      "text": "Russia begins mass issuance of Russian passports in annexed Crimea (widely reported)",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "8f20a6e9-2f1a-4b15-8d4c-21f4a02dbd58",
      "text": "Italian TV documentary 'Ucraina, le verità nascoste' by Gian Micalessin aired on Canale 5 (Matrix) and presented testimony alleging Georgian snipers fired on Maidan protesters.",
      "date": "2017-11-15 00:00:00"
    },
    {
      "id": "724bd55a-d073-4ffa-b8b1-841148e20041",
      "text": "Zeman's high‑profile engagement with Russia (including attending Moscow Victory Day events and meeting Putin in May 2015).",
      "date": "2015-05-09 00:00:00"
    },
    {
      "id": "4d8bbb1a-ffb1-40fc-969d-adc93352a468",
      "text": "Zeman's October 2017 PACE remarks calling the annexation of Crimea a 'fait accompli' and suggesting compensation.",
      "date": "2017-10-10 00:00:00"
    },
    {
      "id": "67ff1894-21a6-4d09-9475-13c85ccf61b3",
      "text": "Pro‑Kremlin Crimean Tatar group Kyrym Birligi was invited to the presidential Independence Day reception at Prague Castle.",
      "date": "2019-10-28 00:00:00"
    },
    {
      "id": "2ad67026-a0ab-4011-8924-4046e01e566d",
      "text": "Widespread news stories and headlines (e.g., Meduza) summarising Zelensky's comments emphasizing Ukraine could pursue a diplomatic return of Crimea rather than costly military operations",
      "date": "2024-11-21 00:00:00"
    },
    {
      "id": "9ab622b4-abc7-402f-8d7d-9684c2d41515",
      "text": "DFRLab report documenting increasing use of AI‑generated audio/video and synthetic media in the Ukraine information space (showing precedent and tools available for falsifying statements)",
      "date": "2024-07-09 00:00:00"
    },
    {
      "id": "097e82e0-2a65-4af7-b3d9-e45351508ccd",
      "text": "Pre-existing public commemorations of Stepan Bandera in Ukraine (e.g., Kyiv renaming Moscow Avenue to Bandera Avenue in 2016)",
      "date": "2016-07-24 00:00:00"
    },
    {
      "id": "7b0520cd-ad41-461a-825b-0352b225d3f1",
      "text": "India (Serum Institute) placed temporary export restrictions on AstraZeneca/COVISHIELD supplies as domestic COVID-19 cases surged, delaying shipments to COVAX and other countries.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "87c456ee-ec34-4960-9903-f674eb55b2dd",
      "text": "WHO leaders publicly warned that vaccine supply was limited and urged countries to prioritise high-risk groups and support equitable distribution rather than assume immediate universal coverage.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "3736a909-47e1-4153-aad9-9a216d168057",
      "text": "COVAX cut its 2021 delivery target after supply problems, announcing a lower-than-expected dose forecast and warning it would fall short of initial goals.",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "28857841-34c9-41d8-9e68-cfa18abcaec5",
      "text": "Contamination and production errors at Emergent BioSolutions' Baltimore plant led to the destruction or sequestering of millions of vaccine doses and an FDA-ordered manufacturing pause.",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "88b1fcd6-9e80-4dcd-b0c6-ddb5f0357550",
      "text": "Reports in early 2021 that lipid nanoparticles and other specialized raw materials used in mRNA vaccines faced constrained global supply with few suppliers.",
      "date": "2021-02-24 00:00:00"
    },
    {
      "id": "e36a25eb-ee71-4fe7-bbb6-c314b63dce60",
      "text": "German Bundestag held a special session (27 February 2022) condemning Russia’s full‑scale invasion and reaffirming Ukraine’s territorial integrity",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "4a803032-82dc-41ba-bc17-2e372ad43c2a",
      "text": "WHO declaration of a Public Health Emergency of International Concern (PHEIC) for the novel coronavirus",
      "date": "2020-01-30 00:00:00"
    },
    {
      "id": "4d677b41-732f-4ee1-97b7-4fd5ff8d1409",
      "text": "ClinicalTrials.gov registration NCT04264533: 'Vitamin C Infusion for the Treatment of Novel Coronavirus Pneumonia (COVID-19)' (trial listing for high‑dose IV vitamin C in Wuhan)",
      "date": "2020-02-14 00:00:00"
    },
    {
      "id": "76f98aa0-ea7d-4a0b-93c5-9ce285cc19d0",
      "text": "Institute of Medicine (IOM) report 'Immunization Safety Review: SV40 Contamination of Polio Vaccine and Cancer' published",
      "date": "2003-04-24 00:00:00"
    },
    {
      "id": "3c187607-d8ec-4e0c-b353-44a07b79e282",
      "text": "Major media coverage attributing growing fire severity to climate change (e.g., New York Times analysis, Nov 2018)",
      "date": "2018-11-09 00:00:00"
    },
    {
      "id": "18124d06-13fc-41ab-b44c-aff8ae32b196",
      "text": "Camp Fire (California, 2018) linked to failing utility equipment (PG&E)",
      "date": "2018-11-08 00:00:00"
    },
    {
      "id": "fc0a4120-9ec2-4f77-9fbd-876df65975ca",
      "text": "2019–20 Australian 'Black Summer' bushfires and public debate blaming land management policies",
      "date": "2020-01-08 00:00:00"
    },
    {
      "id": "c15512f2-a7aa-4a3c-ad09-aafeb17b3e5d",
      "text": "Precedent of cross-border attribution confusion: Przewodów missile incident (Poland, Nov 2022)",
      "date": "2022-11-16 00:00:00"
    },
    {
      "id": "f68f6bb0-ee84-44a6-bdfc-0335f50b7637",
      "text": "Poland officially accused Russian intelligence of ordering the arson (government announcement)",
      "date": "2025-05-11 00:00:00"
    },
    {
      "id": "46bf3e69-919b-40f6-8cbc-94bc7df26704",
      "text": "Reports that Ukrainian nationals were among suspects detained/charged in connection with the fire",
      "date": "2025-05-12 00:00:00"
    },
    {
      "id": "9bd4b6f8-ff03-4cb7-8027-a6405d7799a2",
      "text": "Massive fire destroyed the Marywilska 44 shopping centre in Warsaw (original incident)",
      "date": "2024-05-12 00:00:00"
    },
    {
      "id": "e8d62282-e799-457d-896f-e8a708cc67e0",
      "text": "bioRxiv preprint demonstrating inhalable polymer nanoparticles for mRNA delivery (preprint posted March 23, 2022).",
      "date": "2022-03-23 00:00:00"
    },
    {
      "id": "a612c80c-c96a-45df-8b65-d85878b6f8a7",
      "text": "Regulatory findings and national pauses/age‑restrictions after reports of very rare thrombosis with thrombocytopenia syndrome (TTS) following the AstraZeneca vaccine.",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "284bc88d-467e-49c3-ae5d-9caf059afb7a",
      "text": "Official statistics showing substantial 'excess deaths' in 2022 (published reports covering March 2020–Dec 2022), prompting public debate about causes of excess mortality.",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "f37a2456-cdc3-4b07-84d5-790cc7626871",
      "text": "Published studies showing markedly reduced vaccine effectiveness at preventing infection with the Omicron variant (while protection against severe disease remained better).",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "c0fbdaf3-2a6e-49c9-8b79-ccaf2f5980ec",
      "text": "Peer‑reviewed reports and surveillance data linking mRNA vaccines to rare cases of myocarditis, especially in adolescent and young adult males.",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "6c31bc58-e503-4860-8034-c01e5c6ee690",
      "text": "Press coverage reporting ~1 million Ukrainians working legally in Poland (KyivPost article, April 27, 2017).",
      "date": "2017-04-27 00:00:00"
    },
    {
      "id": "2895342f-dae4-4f6e-9d54-238a2df36de7",
      "text": "ILO / national labour statistics for 2017 showing Ukraine's unemployment rate around ~9–10% (not a new historical high) and contrasting definitions between 'registered' unemployment and ILO measures.",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "3bec23f6-94db-46ae-8550-11141e250027",
      "text": "World Bank / Migration and Remittances Factbook 2016 and related World Bank migration data showing migrant stocks/remittances far lower than 45% of Ukraine's population (Migration & Remittances Factbook 2016).",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "37f83a32-8b11-40e4-af50-a6b2b88b897a",
      "text": "US NTP/NIEHS 2018 partial findings on cell‑phone radiation and tumors in rats",
      "date": "2018-11-01 00:00:00"
    },
    {
      "id": "6166d4af-6445-4c33-9d67-85848cce52d7",
      "text": "IARC classifies radiofrequency electromagnetic fields as 'possibly carcinogenic' (Group 2B)",
      "date": "2011-05-24 00:00:00"
    },
    {
      "id": "01d0a6eb-2389-4849-88bb-8383c30c2816",
      "text": "Publication: 'Static magnetic fields from earphones: Detailed measurements plus some open questions' (Environmental Research)",
      "date": "2022-11-24 00:00:00"
    },
    {
      "id": "2e3c1bd7-8fc2-4221-8481-354fa715b7da",
      "text": "CDC laboratory/testing guidance updates in September 2020 clarifying testing recommendations for asymptomatic people (CDC posted a laboratory update clarifying testing for SARS-CoV-2 on Sept 18, 2020).",
      "date": "2020-09-18 00:00:00"
    },
    {
      "id": "f7f6b47c-67d2-439a-8a91-067f81c1f7ab",
      "text": "WHO EMRO (Eastern Mediterranean Regional Office) guidance page (June 11, 2020) summarised evidence as indicating 'most transmission occurs from symptomatic people' while discussing asymptomatic cases.",
      "date": "2020-06-11 00:00:00"
    },
    {
      "id": "e18a5763-a120-4afa-ae9f-76ba6dc6b6e8",
      "text": "Kyiv renamed a major thoroughfare (Moskovskyi/Moscow Avenue) after Stepan Bandera (renaming enacted July 2016).",
      "date": "2016-07-24 00:00:00"
    },
    {
      "id": "acac592c-0100-4856-ab1a-6b5fa03c2da3",
      "text": "Torch‑lit nationalist marches in Kyiv commemorating Stepan Bandera and other WWII nationalist figures (widely reported torchlight marches, e.g. 14 October 2018).",
      "date": "2018-10-14 00:00:00"
    },
    {
      "id": "363468c4-86f4-4e0e-93e1-66b5ad465c7a",
      "text": "Passage of Ukraine's 'decommunization' laws that banned Soviet symbols and rewrote certain aspects of public memory (April–May 2015).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "f7118670-bd48-4f56-8ea1-c88cb4a94303",
      "text": "March 2019 law/instruments extending veteran status or recognition to surviving members/participants of the UPA/OUN (legal changes coming into force in March 2019).",
      "date": "2019-03-26 00:00:00"
    },
    {
      "id": "45deba27-bd1c-41bb-b550-a741e75c34b1",
      "text": "Media reports documenting neo‑Nazi links in the Azov volunteer unit (coverage of ideology, symbols and far‑right volunteers).",
      "date": "2014-09-10 00:00:00"
    },
    {
      "id": "fd29e551-2e30-484a-b54c-d91f7965b7ab",
      "text": "Swiss authorities announced an immediate freeze on assets linked to Yanukovych and members of his entourage (Switzerland froze assets and opened probes in February 2014).",
      "date": "2014-02-28 00:00:00"
    },
    {
      "id": "67c88f53-54c2-4254-b8d0-28b7099f2ccc",
      "text": "Ukrainian authorities announced confiscation/transfer of roughly $1.5 billion in assets allegedly linked to Yanukovych and his circle into state accounts (reported April 2017).",
      "date": "2017-04-28 00:00:00"
    },
    {
      "id": "594062b0-e5fe-4bb0-98bd-b48cf11c1183",
      "text": "Ukraine imposed a moratorium/default on repayment of the $3 billion Russian-held Eurobond that matured in December 2015.",
      "date": "2015-12-18 00:00:00"
    },
    {
      "id": "da8b48ab-8103-48a8-8c27-32fde9d744b2",
      "text": "Russia filed a lawsuit in London's High Court seeking repayment of a $3 billion Eurobond the Yanukovych-era government issued to Russia.",
      "date": "2016-02-17 00:00:00"
    },
    {
      "id": "8ce2a5c8-0192-4588-b3b2-c420565968e7",
      "text": "UN Secretary-General Antonio Guterres warned the shelling around Zaporizhzhia was 'suicidal' and called for cessation of military activity",
      "date": "2022-08-08 00:00:00"
    },
    {
      "id": "c344854f-6c0e-402b-9e03-dca2dddbf8a7",
      "text": "March 4, 2022 shelling and fire at Zaporizhzhia during Russia's seizure of the plant (initial chaos and conflicting reports)",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "72efba2e-b5b1-4ef0-b026-c1fc2e9523f9",
      "text": "Russian officials and state media publicly accused Ukrainian forces of shelling/damaging Zaporizhzhia and pushed narratives blaming Kyiv",
      "date": "2022-08-05 00:00:00"
    },
    {
      "id": "f29db90f-23cf-400e-b67c-67dd1d817384",
      "text": "Public opinion polls in early February 2024 showed Zaluzhnyi with very high trust ratings in Ukraine.",
      "date": "2024-02-24 00:00:00"
    },
    {
      "id": "70dffb54-a419-4552-ba31-79e7a21bdabd",
      "text": "President Zelensky dismissed Valerii Zaluzhnyi as Commander‑in‑Chief of the Armed Forces of Ukraine.",
      "date": "2024-02-08 00:00:00"
    },
    {
      "id": "e95427a2-7836-413a-837c-230666204f49",
      "text": "OSCE announced deployment/observer activity at Russian checkpoints on the Russia–Ukraine border (Gukovo and Donetsk) and documented cross‑border security incidents in July 2014.",
      "date": "2014-07-24 00:00:00"
    },
    {
      "id": "0cf6ea75-0326-4e12-97dd-53c68752285e",
      "text": "Russian authorities reported mortar and artillery rounds fired from Ukrainian-held territory landing in Russia's Rostov region (claim that shells hit Russian towns, July 2014).",
      "date": "2014-07-25 00:00:00"
    },
    {
      "id": "572faeb1-54e1-462a-ab9b-edf623e98835",
      "text": "Media coverage in April 2014 and thereafter reported repeated airspace violations and frequent scrambling of jets around the Russia–Ukraine border (Pentagon/BBC/other outlets described routine airspace breaches during the 2014 crisis).",
      "date": "2014-04-26 00:00:00"
    },
    {
      "id": "f5f3f9d2-90dd-45c8-8b2f-ad00adb4be15",
      "text": "WENRA (Western European Nuclear Regulators Association) published a position (11 March 2022) documenting the loss of external power supplies to facilities in the Chornobyl exclusion zone and assessed risks",
      "date": "2022-03-11 00:00:00"
    },
    {
      "id": "7f522407-69d4-43cb-9599-99774ba97f2b",
      "text": "Ukraine's national operator and officials said restoring the damaged transmission lines to the exclusion zone was not immediately possible",
      "date": "2022-03-09 00:00:00"
    },
    {
      "id": "0d034d8a-bd04-4ca0-ace9-77618955193f",
      "text": "Russian forces seized control of the Chornobyl site and exclusion zone early in the invasion (reported 24 February 2022)",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "2ba2eda7-5496-4127-833f-7dd6a93199da",
      "text": "Belarus opposition candidate Sviatlana Tsikhanouskaya fled to Lithuania amid the crackdown on protesters.",
      "date": "2020-08-11 00:00:00"
    },
    {
      "id": "5bd7e56b-cfe3-4a99-85b8-77854e9b9c25",
      "text": "Public demonstrations of support for Belarusian protesters in neighbouring countries (large rallies and solidarity events in Poland and elsewhere around Aug 13).",
      "date": "2020-08-13 00:00:00"
    },
    {
      "id": "334fa8a2-6915-4ff0-a436-a94597df2493",
      "text": "Formation of the Lublin Triangle (Poland–Lithuania–Ukraine trilateral platform announced).",
      "date": "2020-07-28 00:00:00"
    },
    {
      "id": "d421ea1b-32a9-4feb-82ce-44107a8ad25e",
      "text": "Mass influx of Ukrainian refugees into Poland after Russia's full-scale invasion (activation of EU Temporary Protection, March 2022 onwards).",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "d4ac1d8a-babe-4df9-af15-5ac40c38b671",
      "text": "Gazeta Wyborcza article reports rapid rise of Ukrainian residents in Wrocław ('Almost every third resident of Wroclaw is Ukrainian').",
      "date": "2022-07-25 00:00:00"
    },
    {
      "id": "ecd51516-8d6e-437d-b3e0-afcf936bd01c",
      "text": "Polish media outlets and public services launched Ukrainian-language sections and information hubs (example: Polish newsrooms adding Ukrainian-language content, Ukrainian support centres established).",
      "date": "2022-05-24 00:00:00"
    },
    {
      "id": "81ba9461-c241-4cff-88a5-330b7e9dcaab",
      "text": "Explosions and missile strikes hit nearby cities (notably Mykolaiv and Odesa) on 12–13 May 2022; local officials said some strikes on Mykolaiv/Odesa were linked to launches from the Kherson area.",
      "date": "2022-05-13 00:00:00"
    },
    {
      "id": "c02d1d63-2738-4342-b60c-5a5eafdb00d1",
      "text": "Prominent international coverage of far‑right Ukrainian units (notably the Azov regiment) and their integration into national forces during spring 2022.",
      "date": "2022-03-29 00:00:00"
    },
    {
      "id": "b978ef97-67af-4411-923d-63aa7bdd03a2",
      "text": "Earlier Russian Defence Ministry / RIA-style reports accused Ukrainian forces of striking civilian sites in the Kherson region (e.g., schools, cemeteries) at the start of May 2022.",
      "date": "2022-05-01 00:00:00"
    },
    {
      "id": "1c5866c2-1adf-4b31-a7e0-d2983c3c0093",
      "text": "CDC recommends cloth face coverings for the public (source control)",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "050c1ca7-e45b-4239-9217-51063d96f085",
      "text": "WHO issues 'COVID-19: considerations for tuberculosis (TB) care' information note",
      "date": "2020-03-19 00:00:00"
    },
    {
      "id": "2f6e9d10-fec3-4bbe-9247-78c04ce554c5",
      "text": "July 2021 Provincetown, MA outbreak where many cases occurred among vaccinated people (CDC MMWR published August 2021)",
      "date": "2021-07-24 00:00:00"
    },
    {
      "id": "9098c091-26df-4f1c-a647-9a4f2b23fc7a",
      "text": "Large cluster-randomized Bangladesh mask promotion trial (Abaluck et al./Science) published August 2021 with nuanced results",
      "date": "2021-08-13 00:00:00"
    },
    {
      "id": "02d9bad7-3aef-4517-b713-67abd5cafc2d",
      "text": "CDC reversed earlier guidance and in July 2021 again recommended indoor masks for vaccinated people because of the Delta variant",
      "date": "2021-07-27 00:00:00"
    },
    {
      "id": "4b1c18ef-7469-4c08-acae-8c60b14de0d2",
      "text": "DANMASK-19 randomized trial (Denmark) published November 2020 found limited measurable protection to the wearer",
      "date": "2020-11-18 00:00:00"
    },
    {
      "id": "33c7db4b-04dc-46e0-b03d-7f922a10de7a",
      "text": "Earlier (2015) online reports claimed an 'Assembly of the Romanians of Bukovina' had been formed and had previously voiced grievances about status/rights in northern Bukovina.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "d57ad4ba-c8d9-40a2-b26f-8c7201cf2b36",
      "text": "Following the awards, Gazprom refused/reserved deliveries and reduced transit pressure to Ukraine in early March 2018",
      "date": "2018-03-13 00:00:00"
    },
    {
      "id": "5b58fb64-63d2-40e2-9f6f-e1a1fa007055",
      "text": "Naftogaz published the full Stockholm award texts and initiated enforcement actions in multiple jurisdictions (e.g., Swiss/UK enforcement steps were announced)",
      "date": "2018-03-24 00:00:00"
    },
    {
      "id": "5cb96c94-bbc2-4897-9e21-1b262e0d5d81",
      "text": "The awards were legally complex and split across separate supply and transit rulings with offsetting liabilities rather than a single, simple judgment",
      "date": "2018-03-24 00:00:00"
    },
    {
      "id": "10698ce2-70ce-40d7-9582-9301a7996d89",
      "text": "U.S. National Toxicology Program (NTP) publishes high‑profile rodent RFR studies (final reports/public summaries circulated in 2018)",
      "date": "2018-11-24 00:00:00"
    },
    {
      "id": "61c08dbf-7678-4cb8-a05d-7fb8581db29e",
      "text": "International EMF Scientist Appeal (roughly 250 scientists sign public appeal calling for stricter RF limits, 2015)",
      "date": "2015-05-24 00:00:00"
    },
    {
      "id": "223cd831-e143-4a96-899b-7fcab8bf14d4",
      "text": "IARC (WHO) classifies radiofrequency electromagnetic fields as 'possibly carcinogenic to humans' (Group 2B)",
      "date": "2011-05-31 00:00:00"
    },
    {
      "id": "0080375e-d066-4489-a76b-8aca7c644953",
      "text": "Major measles outbreak in Samoa (late 2019) that caused thousands of cases and dozens of deaths and led to a national state of emergency.",
      "date": "2019-11-24 00:00:00"
    },
    {
      "id": "5c9bb56b-5a52-4110-9391-2fa563a25ec0",
      "text": "Two infants in Samoa died after receiving MMR vaccine due to incorrect diluent administration, sparking local fear of vaccines.",
      "date": "2018-07-24 00:00:00"
    },
    {
      "id": "3957f02b-d075-40ed-b8ee-c6ba3e8e07ea",
      "text": "Nordic countries (Sweden, Denmark, Finland) restricted or paused use of Moderna’s mRNA vaccine for younger people over myocarditis concerns",
      "date": "2021-10-07 00:00:00"
    },
    {
      "id": "608d1ff8-dfa6-45e2-b5f9-0f8f07b43b6f",
      "text": "Japan identifies stainless-steel/foreign particles in multiple Moderna vaccine vials, leading to suspension/recall of specific lots",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "35dd7506-6f6a-4fc6-95fa-ce3448ef69ca",
      "text": "Verkhovna Rada adopts the Law 'On Ensuring the Functioning of Ukrainian as the State Language'.",
      "date": "2019-04-25 00:00:00"
    },
    {
      "id": "38787658-27c6-48e3-b543-52185e73d5b2",
      "text": "The 2019 language law entered into force (implementation date announced/commenced).",
      "date": "2019-07-16 00:00:00"
    },
    {
      "id": "2bd04379-926c-48bf-b44a-4c266364137c",
      "text": "Passage of the 2017 Education Law that restricted minority‑language instruction (including limits affecting Russian‑language schooling).",
      "date": "2017-09-25 00:00:00"
    },
    {
      "id": "8f64b154-1dec-4fb3-93ae-2e71705ff1f3",
      "text": "OSCE monitor wounded after coming under fire leading the OSCE to review operations in the conflict zone",
      "date": "2015-07-28 00:00:00"
    },
    {
      "id": "2edbd701-a7b0-43d0-b5f1-5f7fe48fd1b3",
      "text": "OSCE spot report documenting heavy shelling and multiple shell craters near Donetsk (including school shelling)",
      "date": "2014-11-07 00:00:00"
    },
    {
      "id": "bf9bf087-ec2e-4039-8d2e-b944f501ebb9",
      "text": "OSCE SMM vehicles struck by artillery/mortar fragments near Kirovske while on patrol",
      "date": "2014-09-15 00:00:00"
    },
    {
      "id": "f82b7bce-3fa4-4d11-b057-f19740ff07bf",
      "text": "FDA issued an Emergency Use Authorization (EUA) for chloroquine/hydroxychloroquine to treat COVID‑19 (announced in late March 2020)",
      "date": "2020-03-28 00:00:00"
    },
    {
      "id": "3505d0a2-95b7-4974-900f-c320bbd8404c",
      "text": "Wang et al. in vitro study showing remdesivir and chloroquine inhibit SARS-CoV-2 in cultured cells published (Cell Research)",
      "date": "2020-02-04 00:00:00"
    },
    {
      "id": "88e2d6aa-7606-4bd8-a3c0-db8e791d0407",
      "text": "National Academies report 'Reflecting Sunlight' recommends a research program on solar geoengineering (including stratospheric aerosol injection)",
      "date": "2021-06-28 00:00:00"
    },
    {
      "id": "44feb689-57ae-46a8-8a01-c7747c8a0790",
      "text": "Operation Popeye (U.S. cloud-seeding program in Vietnam, 1967–1972) documented in declassified reporting",
      "date": "None"
    },
    {
      "id": "d7317c6e-3db4-424b-90d9-b9b5753564c8",
      "text": "HAARP facility transferred from US Air Force to University of Alaska (facility described publicly as a powerful ionospheric heater)",
      "date": "2015-08-11 00:00:00"
    },
    {
      "id": "3f8b75b1-2c42-4fc8-a159-ed729971cff3",
      "text": "1996 USAF paper ‘Weather as a Force Multiplier: Owning the Weather in 2025’ published",
      "date": "1996-08-24 00:00:00"
    },
    {
      "id": "31222d1f-99d2-4a04-b6e1-26030ffb0631",
      "text": "Harvard SCoPEx geoengineering balloon test in Sweden paused after public controversy and advisory review (SCoPEx advisory committee recommendation)",
      "date": "2021-03-24 00:00:00"
    },
    {
      "id": "20a98e83-e847-4d32-aac4-5e9a640056d8",
      "text": "Arkansas legislature passed HB1578 (2015), a law that required abortion providers to inform patients about the possibility of reversing a medication abortion.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "d269abae-bf72-4f74-b43e-47c8f5a5f577",
      "text": "Media reporting in December 2019 (e.g., NPR) that a randomized clinical trial testing progesterone to antagonize mifepristone was stopped early because several participants experienced severe bleeding.",
      "date": "2019-12-05 00:00:00"
    },
    {
      "id": "28215652-fb49-4234-8a5b-10f2884a8360",
      "text": "Publication of 'Medicinal smoke reduces airborne bacteria' (Journal of Ethnopharmacology, 2007).",
      "date": "2007-04-24 00:00:00"
    },
    {
      "id": "41b8d60b-18d2-40ac-b418-d4da3f42762a",
      "text": "Early COVID-19 pandemic surge in March 2020 driving widespread sharing of home remedies and 'air-cleansing' tips on social media and messaging apps.",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "a9cb4bb3-35f2-4375-b14a-963d4da29cdb",
      "text": "IMF Article IV / Staff report highlighted Moldova's fiscal pressures and recommended pension-system sustainability measures.",
      "date": "2023-12-24 00:00:00"
    },
    {
      "id": "6204c9c3-9b99-41ef-a2c1-32347b6acbac",
      "text": "2023 budget law amendments that changed tax regulations (Law No. 212 / Gazette publication August 2023).",
      "date": "2023-08-10 00:00:00"
    },
    {
      "id": "50a966b8-6689-49b7-ba48-7faa14b1eaf2",
      "text": "Government conscription/draft calls in 2024–2025 (e.g., plans to conscript ~1,200 in Nov 2024–Jan 2025 and further calls in spring 2025).",
      "date": "2024-11-24 00:00:00"
    },
    {
      "id": "eb9fe205-5422-4321-96e2-10a79f80e6e7",
      "text": "Legally scheduled gradual equalization and increases in retirement age for women (increment applied July 1, 2024).",
      "date": "2024-07-01 00:00:00"
    },
    {
      "id": "d16e0eb9-872d-49bb-a544-0446fe86d911",
      "text": "Public warnings by President Maia Sandu about anticipated Russian interference and disinformation in the 2025 election campaign.",
      "date": "2025-07-30 00:00:00"
    },
    {
      "id": "c28026e9-686f-428a-a038-32f0dd36e3db",
      "text": "Liguria Regional Council adopted a non‑binding motion urging the Italian government to review EU sanctions on Russia and to acknowledge Crimea's 'right to self‑determination' (widely misreported as formal recognition).",
      "date": "2016-06-29 00:00:00"
    },
    {
      "id": "664ccdb3-f880-4f25-8241-1dfeeab33b2b",
      "text": "Lega Nord regional councillor (Giancarlo Piana/Piana) travelled to Crimea and publicly advocated closer ties and opposing sanctions; local press covered the visit and statements in late June 2016.",
      "date": "2016-06-24 00:00:00"
    },
    {
      "id": "fc17a088-7b0d-4e61-b22a-7477b644e094",
      "text": "Sharp rise in short-term employment registrations in 2018, dominated by Ukrainian nationals (Police and Border Guard Board data showing short-term employment registrations rose to 19,858 in 2018).",
      "date": "None"
    },
    {
      "id": "bc617bf4-3191-4904-9fc7-0654c50e2050",
      "text": "Statistics Estonia reported a small population increase and noted changing composition with rising numbers of foreign nationals/immigrants in the 2018 data release (Statistics Estonia news releases on population, January 2019).",
      "date": "None"
    },
    {
      "id": "dc0b3b2f-1dad-4729-ac7e-4c2d9044f6e8",
      "text": "Rise of the far-right EKRE party in the 2019 parliamentary elections and April 2019 coalition talks (EKRE entered coalition discussions on April 6, 2019), accompanied by strong anti-immigration rhetoric in campaign coverage.",
      "date": "2019-04-06 00:00:00"
    },
    {
      "id": "3ae7ca99-f464-4299-8753-7a424e968ede",
      "text": "Rail Baltica cross‑border integration steps and EU documentation advancing Poland‑Lithuania rail connection (project materials published, technical/operational coordination at border sections).",
      "date": "2020-06-24 00:00:00"
    },
    {
      "id": "675e5392-530d-449b-bb1e-4d7a3588db91",
      "text": "Original intergovernmental agreement establishing the Lithuanian‑Polish‑Ukrainian Brigade (LITPOLUKRBRIG) signed in Warsaw (formal creation and headquarters placement in Poland).",
      "date": "2014-09-19 00:00:00"
    },
    {
      "id": "50b2647b-0332-4461-8a09-dea8dec0abd1",
      "text": "Increased NATO/Polish military activity and formal commitments on the eastern flank in 2020 (Poland and Lithuania assigned brigades to NATO multinational structures; documented interoperability activities).",
      "date": "2020-01-24 00:00:00"
    },
    {
      "id": "5583efb3-aa8e-4df3-858f-b8534029d887",
      "text": "Kyiv shut metro services and further restricted public transportation in mid‑March 2020 (national/local announcements)",
      "date": "2020-03-17 00:00:00"
    },
    {
      "id": "00d26f90-76bd-40ab-85fc-34766755bd4c",
      "text": "Background existence of Kyiv ‘Municipal Guard’ (created 2015) with some members drawn from volunteer/veteran communities",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "6f5f9441-b84d-4d52-a65c-4867888ea635",
      "text": "Authorities announced joint patrols involving the National Police, National Guard and Military Police beginning around March 22, 2020",
      "date": "2020-03-22 00:00:00"
    },
    {
      "id": "1dd0b4ec-abd6-45d0-b7e9-4fa8a28c3461",
      "text": "January 2021 reports from Norway that some very frail, elderly patients died after receiving the Pfizer/BioNTech vaccine and subsequent official reviews.",
      "date": "2021-01-18 00:00:00"
    },
    {
      "id": "ed9f52e2-be9f-48ab-9f06-0402ef0d2399",
      "text": "Russian leadership framed the 2022 invasion as a 'denazification' mission.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "3bfa73f9-4f36-4feb-8c73-b26d1c8763e2",
      "text": "International reporting and analysis on the Azov regiment's far‑right imagery and controversies.",
      "date": "2022-03-29 00:00:00"
    },
    {
      "id": "6c96e600-ea11-41eb-980c-50af62ee819b",
      "text": "Reports and temporary suspension in Japan of some Moderna vaccine batches after detection of foreign particles (August 2021)",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "97cdfa22-5b79-4c43-8b73-b7397eabdb7f",
      "text": "CDC reports and ACIP review of myocarditis signals after mRNA vaccination (June 2021 MMWR/ACIP update)",
      "date": "2021-06-23 00:00:00"
    },
    {
      "id": "d8573a4e-9b56-470b-8c64-d08efb9b7470",
      "text": "EMA determination of a possible link between AstraZeneca vaccine and very rare blood clots with low platelets (VITT), April 2021",
      "date": "2021-04-07 00:00:00"
    },
    {
      "id": "6c403599-3e86-4bff-9361-055b9602ab30",
      "text": "Poroshenko strips high-profile individuals of Ukrainian citizenship (e.g., Mikheil Saakashvili)",
      "date": "2017-07-24 00:00:00"
    },
    {
      "id": "a12e33a5-60d5-4e0a-b96d-1234e7e986c3",
      "text": "CDC interim guidance for election polling locations and voters recommending masks and other measures",
      "date": "2020-06-22 00:00:00"
    },
    {
      "id": "4fe95fda-824f-4b32-b19b-ea9e2df97086",
      "text": "Nature Medicine study showing face masks reduce respiratory virus shedding (Leung et al.)",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "3553acbd-cb2f-423e-93dc-1bb0a1ff29ab",
      "text": "Wisconsin in-person primary conducted during pandemic with long lines and media coverage",
      "date": "2020-04-07 00:00:00"
    },
    {
      "id": "73fa5f57-e48d-4a11-a85f-c6d43d487450",
      "text": "CDC recommends cloth face coverings for the public",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "3d4f3856-5b2b-4ed4-a0f1-107b2258779e",
      "text": "FDA’s tissue‑agnostic accelerated approval of pembrolizumab for MSI‑H/dMMR tumors",
      "date": "2017-05-24 00:00:00"
    },
    {
      "id": "e2ca9fca-e873-40f4-955e-4071550bf90b",
      "text": "2018 Nobel Prize in Physiology or Medicine awarded to James Allison and Tasuku Honjo for cancer immunotherapy",
      "date": "2018-10-24 00:00:00"
    },
    {
      "id": "d00f54ac-0e00-4021-9101-2d50a9e18898",
      "text": "First US approval of a CAR‑T cell therapy (Kymriah, tisagenlecleucel)",
      "date": "2017-08-24 00:00:00"
    },
    {
      "id": "32dd5dab-f7ef-4cd2-ac64-759def9b81d4",
      "text": "AstraZeneca paused its COVID-19 vaccine trial after a volunteer developed an unexplained serious illness.",
      "date": "2020-09-08 00:00:00"
    },
    {
      "id": "c0e1ea34-6e44-45af-8687-a6f6e0fdddbe",
      "text": "Large, high-profile seroprevalence releases (e.g., New York State antibody study) showing many people with antibodies",
      "date": "2020-04-23 00:00:00"
    },
    {
      "id": "7d6c1f51-a4aa-43b3-9db4-b7d6d51b4546",
      "text": "Media reports and investigations documenting a flood of unvalidated/poor-quality COVID-19 antibody tests on the U.S. market after relaxed FDA oversight",
      "date": "2020-04-27 00:00:00"
    },
    {
      "id": "bf2117fc-622a-4b9e-9739-256e8d0257fe",
      "text": "CDC serology guidance updated to note possible cross-reactivity of antibody tests with other coronaviruses",
      "date": "2020-06-25 00:00:00"
    },
    {
      "id": "cbc26084-c1da-48e0-83d5-389ba8f80250",
      "text": "IARC (WHO) classified aspartame as 'possibly carcinogenic to humans' (Group 2B), prompting widespread media coverage.",
      "date": "2023-07-14 00:00:00"
    },
    {
      "id": "4e423bb5-cd06-447a-bbfc-080811c6884c",
      "text": "WHO published a guideline (Use of non-sugar sweeteners) recommending that non-sugar sweeteners should not be used for weight control or reducing noncommunicable disease risk.",
      "date": "2023-05-15 00:00:00"
    },
    {
      "id": "b16669f8-d75b-408a-9f4d-5bcb56342fa8",
      "text": "U.S. Federal Trade Commission (FTC) sent warning letters (Nov 2023) to two trade associations and a dozen influencers about inadequate disclosures for paid posts promoting aspartame/sugar products.",
      "date": "2023-11-13 00:00:00"
    },
    {
      "id": "177a8ead-2e4a-42b3-bd3a-431798790bde",
      "text": "WHO updated interim guidance on mask use (June 5, 2020)",
      "date": "2020-06-05 00:00:00"
    },
    {
      "id": "f37e84b5-e2d0-451c-8b32-7caaa0838264",
      "text": "Systematic review and meta-analysis (Bartoszko et al.) on medical masks vs N95 respirators (Influenza and Other Respiratory Viruses, 2020)",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "5f6be7fe-2480-4b8b-847b-374e45a86e9e",
      "text": "IARC (WHO) press release classifying processed meat as 'carcinogenic to humans' (Group 1)",
      "date": "2015-10-26 00:00:00"
    },
    {
      "id": "78a2eb57-fcd6-403f-8a54-0bb0e05d9bba",
      "text": "Recent legal and public debate weakening restrictions on AI‑generated political deepfakes (U.S. court decision striking down a California restriction, reported Aug 7, 2025).",
      "date": "2025-08-07 00:00:00"
    },
    {
      "id": "5dc728d9-13a8-47fc-b9f3-ae98951350e8",
      "text": "U.S. begins or expands training of Ukrainian military and security forces",
      "date": "2015-06-24 00:00:00"
    },
    {
      "id": "f7826dad-e7a6-4fe2-b275-f7114d3cd458",
      "text": "Documented U.S.-funded democracy support by the National Endowment for Democracy (NED) in Ukraine",
      "date": "None"
    },
    {
      "id": "74f394ba-ef3f-4ccd-8648-fc87425f5bc4",
      "text": "U.S. and EU impose sanctions on Russian and Ukrainian actors after Crimea annexation",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "28fc4989-660b-4a74-adef-84b2073491a7",
      "text": "2018 market reports showing a sharp rise in turmeric/curcumin supplement sales and mainstreaming of 'golden milk' wellness trends",
      "date": "2018-09-18 00:00:00"
    },
    {
      "id": "83e49db4-0946-4b37-82e5-819ad7c0a1da",
      "text": "2004 Phase I clinical trial of oral curcumin in advanced colorectal cancer patients (Clinical Cancer Research)",
      "date": "2004-10-22 00:00:00"
    },
    {
      "id": "629934f2-0d32-4a19-ac35-ea10dca79eb2",
      "text": "Ukraine signed a contract to purchase about 1.8–1.9 million doses of China’s Sinovac vaccine (announcement reported Dec 30, 2020).",
      "date": "2020-12-30 00:00:00"
    },
    {
      "id": "a395c8b7-47b0-45a7-ad81-e26fe1c05a14",
      "text": "Pfizer publicly reported supply-chain challenges and acknowledged it had cut its near-term production target (news reported Dec 3, 2020).",
      "date": "2020-12-03 00:00:00"
    },
    {
      "id": "73d4fa9f-7af5-42a7-81b7-86eea7bb227f",
      "text": "COVAX (WHO/Gavi/CEPI/UNICEF) announced additional advance purchase deals and said the global rollout was planned to begin in Q1 2021 (press release Dec 18, 2020).",
      "date": "2020-12-18 00:00:00"
    },
    {
      "id": "a26e093a-2f0c-4a23-9373-f39313864c41",
      "text": "Reporting of procurement dysfunction and delays within Ukraine’s vaccine procurement machinery in late 2020 (media coverage of missed contracts, agency disputes and slow negotiations).",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "4c9cb6bf-730f-49fd-b0c7-590cf16349d1",
      "text": "NOAA / Arctic Report Card 2023 coverage documenting seasonal and regional variability in sea ice (and that 2023 minimum ranked among the low end but not a new record).",
      "date": "2023-12-24 00:00:00"
    },
    {
      "id": "7a212531-6953-4bb9-856f-9b6e406a2de8",
      "text": "Publication of peer-reviewed study 'Comparing the carbon footprints of urban and conventional agriculture' in Nature Cities",
      "date": "2024-01-22 00:00:00"
    },
    {
      "id": "7659754a-1b7b-4a35-b4e4-4cc2050a0494",
      "text": "Publication of Standard Eurobarometer 101 (Spring 2024) with headline EU-level percentages on attitudes to the war, security and EU unity",
      "date": "2024-05-24 00:00:00"
    },
    {
      "id": "5768ff86-d67b-4a05-937e-a4fb8d057587",
      "text": "Pew Research Center release 'Views of Russia and Putin' (July 2, 2024) with country‑by‑country favorable/unfavorable figures",
      "date": "2024-07-02 00:00:00"
    },
    {
      "id": "b7924395-6b9e-4846-a1b2-f40333373ccd",
      "text": "Large pro‑Russia demonstrations in Belgrade and other European cities (e.g., Belgrade pro‑Russia march reported by Reuters and BBC in April 2022)",
      "date": "2022-04-16 00:00:00"
    },
    {
      "id": "3b2d1c54-46a2-43c7-a34b-867520be9bd0",
      "text": "South Africa pauses/limits rollout of the Oxford–AstraZeneca COVID‑19 vaccine after trial data showed minimal protection against mild–moderate disease vs the 501Y.V2 variant",
      "date": "2021-02-09 00:00:00"
    },
    {
      "id": "eb9d6929-d087-40ce-b49f-7c5fc19430ae",
      "text": "UK NERVTAG / Public Health briefings (Jan 2021) indicating the B.1.1.7 (UK) variant may be associated with increased severity/mortality",
      "date": "2021-01-20 00:00:00"
    },
    {
      "id": "c3c1733c-48df-47db-b327-bfd660fd8b91",
      "text": "Ukraine's 2004 'Orange Revolution' — Supreme Court annulled disputed runoff and ordered a re-run",
      "date": "2004-12-03 00:00:00"
    },
    {
      "id": "5a18ff76-6adf-49dd-8a47-80a852903057",
      "text": "May 2014 early presidential election held amid armed conflict — polling could not be held in parts of Donbas and Crimea",
      "date": "2014-05-25 00:00:00"
    },
    {
      "id": "615e3004-e4d4-4db8-8943-572e5aec2d74",
      "text": "Crimea 'referendum' (16 March 2014) and UN General Assembly non-recognition (Resolution 68/262)",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "6407b3ca-4fad-49b5-a549-1696186e016e",
      "text": "Russian/state narratives calling the post‑Euromaidan Ukrainian authorities a 'coup' and 'illegitimate' (2014 onward)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "5a8d686a-4332-4ef2-8c1e-a1e0be81eb8b",
      "text": "Parliament and state moves in late 2014 to recognize OUN/UPA fighters with veteran/combatant status",
      "date": "2014-12-06 00:00:00"
    },
    {
      "id": "a82be8e6-3e05-488d-b48a-34ee578ebe37",
      "text": "International and regional criticism of Ukraine's decommunization bills as potentially glorifying WWII-era nationalists",
      "date": "2015-04-20 00:00:00"
    },
    {
      "id": "c1f5270f-1a6c-46c0-ad52-8959a23725f7",
      "text": "Poroshenko issues decree establishing May 8 as a Day of Remembrance and Reconciliation (shifting commemoration context)",
      "date": "2015-03-24 00:00:00"
    },
    {
      "id": "842d5a71-e5da-45fa-9689-793dd7cb8c7a",
      "text": "Verkhovna Rada passes 'decommunization' package of laws equating Soviet and Nazi regimes and banning Soviet symbols",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "ae0daa7e-f26e-4939-a671-d1fc4de1b5f8",
      "text": "Widespread use and international coverage of the red-and-black UPA/Bandera flag during Euromaidan and subsequent protests",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "f8c3f1aa-6921-4366-b729-0b15467ffe4b",
      "text": "Alaska Supreme Court struck down a 2014 law/regulation attempting to define which abortions were 'medically necessary' for Medicaid funding (ruling reported Feb 15–16, 2019).",
      "date": "2019-02-15 00:00:00"
    },
    {
      "id": "39119401-4fb6-4c51-a4a2-509133c89916",
      "text": "Alabama signed the near‑total Human Life Protection Act (near‑total abortion ban) on May 15, 2019.",
      "date": "2019-05-15 00:00:00"
    },
    {
      "id": "91dbc818-5745-4cc2-b15b-8de90aea2e6e",
      "text": "Amnesty International reports on apparent extrajudicial executions by Russian forces",
      "date": "2022-04-12 00:00:00"
    },
    {
      "id": "301d794c-796d-4b52-acaf-189a06c32744",
      "text": "Discovery of bound and shot civilian bodies in Bucha",
      "date": "2022-04-04 00:00:00"
    },
    {
      "id": "15ae6b88-98af-4f02-a2c2-f7506b75b8f0",
      "text": "Sharp surge in temporary employment declarations for Ukrainians in Poland (about 400,000 declarations in H1 2015)",
      "date": "None"
    },
    {
      "id": "0f3c80b9-d33d-449e-b782-301a92767446",
      "text": "International media human‑interest coverage (e.g., BBC) highlighting Ukrainians taking low‑paid/manual jobs in Poland",
      "date": "2015-03-19 00:00:00"
    },
    {
      "id": "ab3c4bac-ce55-471e-a4b1-3a5fd3e4da3a",
      "text": "Media reports of increased civilian familiarisation and voluntary training courses in Poland amid the war in Ukraine (surge in civilians getting military‑style training).",
      "date": "2022-12-06 00:00:00"
    },
    {
      "id": "1e97059a-df1b-4ba0-927d-ef351d3203f1",
      "text": "Polish Ministry of Defence draft/plans reported to call up or train up to 200,000 reservists and Territorial Defence volunteers in 2023.",
      "date": "2022-12-08 00:00:00"
    },
    {
      "id": "39c3f37e-7863-4e24-b858-332a69edb7c5",
      "text": "Large NATO/U.S.-led military exercises in Poland in 2022 (e.g., DEFENDER-Europe 2022 and SWIFT RESPONSE 2022 in May 2022).",
      "date": "2022-05-24 00:00:00"
    },
    {
      "id": "a6ecafb3-06ef-4d15-9e90-c182ff9ac0cb",
      "text": "Reports and sector assessments (Ministry/PPV/experts) documenting urgent appeals and emergency measures for the cultural and creative industries because of COVID‑19 impact (spring 2020).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "672cda8c-2973-45f8-975f-b039bb42d799",
      "text": "Previous and well‑documented state support for patriotic films (example: state/State Film Agency funding for films such as 'Cyborgs' in 2017).",
      "date": "2017-02-12 00:00:00"
    },
    {
      "id": "f3deb717-f26d-4b0f-befb-f0a268840e2d",
      "text": "Verkhovna Rada adopts amendments to the 2020 state budget to create an anti‑coronavirus fund and reallocate spending (April 2020).",
      "date": "2020-04-13 00:00:00"
    },
    {
      "id": "c27871e8-9cf0-4e55-a941-37568e929639",
      "text": "U.S. embassy cultural and education grant programs in Poland (U.S. Embassy cultural exchanges and museum/project funding).",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "b34290c9-5fc8-42cd-8ff4-b72800d5b3fc",
      "text": "Public concern and criticism by international institutions and U.S.‑linked organisations (including the U.S. Holocaust Memorial Museum) over Poland's 2018 memory law.",
      "date": "2018-02-24 00:00:00"
    },
    {
      "id": "519b445d-ab5a-4a25-82b4-b0946e2544b9",
      "text": "Polish education reform (2016–2017) introducing a stronger 'patriotic education' and changes to history curricula.",
      "date": "None"
    },
    {
      "id": "b2a7af7a-992d-4172-a8ed-0632c7b9ebc8",
      "text": "High‑profile U.S. governmental rhetoric in Poland on WWII memory: Vice President Mike Pence's speech at the 80th anniversary WWII commemoration in Warsaw.",
      "date": "2019-09-01 00:00:00"
    },
    {
      "id": "d0debc7d-8581-4e61-8d60-6bb1817aca0e",
      "text": "Russian courts declared the Mejlis of the Crimean Tatar people an 'extremist organization' and effectively banned it (decision upheld by the Russian Supreme Court).",
      "date": "2016-09-29 00:00:00"
    },
    {
      "id": "92773719-a9b2-48df-a401-3f607ad24f95",
      "text": "Prominent Crimean Tatar figures (for example Ruslan Balbek) publicly endorsed the 2014 annexation of Crimea and later served in Russian administration or political posts.",
      "date": "2014-03-19 00:00:00"
    },
    {
      "id": "c687e1f4-812e-4156-8c81-6e868ebc55e1",
      "text": "Reports that Russian/occupation authorities organized or amplified a purported 'congress' or staged meetings of Crimean Tatar delegates framed as endorsing the 'special operation'.",
      "date": "2022-04-30 00:00:00"
    },
    {
      "id": "93341980-21de-417e-89dd-7c82843bab90",
      "text": "Ukrainian Ministry of Justice public discussion / press reporting on proposals to allow people with criminal records (non‑incarcerated) to be mobilised or volunteer for service",
      "date": "2024-02-17 00:00:00"
    },
    {
      "id": "3303063f-dece-4c0c-874c-5f4e49c07bfa",
      "text": "Justice Minister Denys Malyuska's telethon remarks suggesting mobilising people with criminal records and noting some could do non‑combat tasks ('shovels' mentioned in context)",
      "date": "2024-02-17 00:00:00"
    },
    {
      "id": "09395cf0-ef39-49f1-a6fd-04e49cd0d3c7",
      "text": "Precedent of Russian/Wagner recruitment of prisoners (widely reported in 2022–2023)",
      "date": "2023-03-10 00:00:00"
    },
    {
      "id": "3effb45f-db2f-4404-8107-91ae40cfa171",
      "text": "U.S. confirms delivery of Javelin anti-tank missiles to Ukraine",
      "date": "2017-08-24 00:00:00"
    },
    {
      "id": "49d175f1-d0a6-4c28-afcb-542015206488",
      "text": "U.S. passed the milestone of 1 million reported COVID-19 deaths in mid‑May 2022.",
      "date": "2022-05-15 00:00:00"
    },
    {
      "id": "09a6eb61-e57e-43fa-b5d1-b1d1be8aa538",
      "text": "CDC changed its COVID-19 data presentation and surveillance focus after the U.S. public health emergency ended (2023), shifting emphasis to severe outcomes and revising some reporting dashboards.",
      "date": "2023-05-05 00:00:00"
    },
    {
      "id": "9ba3b0b4-5e3d-4272-9bf5-9290053494c1",
      "text": "Publication of a randomized, double‑blind, placebo‑controlled Phase II trial reporting AHCC cleared persistent high‑risk HPV in a majority of treated patients",
      "date": "2022-06-22 00:00:00"
    },
    {
      "id": "60aaf762-4c84-4913-9c90-e2761a239a3c",
      "text": "Russian Defence Ministry spokesman Igor Konashenkov publicly announced that Russian forces had \"liquidated\" groups of foreign mercenaries including members of the 'Georgian Legion' near Lysychansk.",
      "date": "2022-06-27 00:00:00"
    },
    {
      "id": "3e927d59-e3bd-40df-8996-cea67027d88b",
      "text": "French President Emmanuel Macron says 'we must not humiliate Russia' (calls for dialogue)",
      "date": "2022-06-04 00:00:00"
    },
    {
      "id": "500db672-9962-4d41-98c4-e78093be6282",
      "text": "United Nations / humanitarian agencies warn of catastrophic humanitarian needs in Ukraine",
      "date": "2022-06-08 00:00:00"
    },
    {
      "id": "7ceb8afa-28c7-4571-a76b-15da683cfcad",
      "text": "Russian seizure and military control of the Zaporizhzhia nuclear power plant",
      "date": "2022-03-04 00:00:00"
    },
    {
      "id": "8b330468-0e0e-41f2-8956-e0ca20857b53",
      "text": "NATO Madrid Summit (new strategic concept and high‑level discussions)",
      "date": "2022-06-29 00:00:00"
    },
    {
      "id": "7e95e9ef-ebaf-474e-a03e-601acfaf84a2",
      "text": "Fall of Sievierodonetsk / Russian capture of a key Donbas city",
      "date": "2022-06-25 00:00:00"
    },
    {
      "id": "9ae89725-23f8-4591-9414-683c87ced9f3",
      "text": "European Commission emergency aid package for farmers affected by the Russian embargo (initial €125 million announced)",
      "date": "2014-08-18 00:00:00"
    },
    {
      "id": "cd9cc4ee-63a4-440c-92b4-44665fd63c0e",
      "text": "Finnish industry and producers (e.g., dairy sector) publicly warned of impacts and potential job talks after the Russian ban",
      "date": "2014-08-07 00:00:00"
    },
    {
      "id": "adcfccef-d8d9-41c8-b300-cf27b6144577",
      "text": "Sharp month‑on‑month fall in Finnish food exports to Russia after the ban (reported as exports plummeting over 60% in one month)",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "0b082ee4-9471-4fb4-9665-6a11af3aa134",
      "text": "Turkey shot down a Russian Su‑24 warplane on the Syria border, sharply escalating tensions between Moscow and Ankara.",
      "date": "2015-11-24 00:00:00"
    },
    {
      "id": "ca306a40-dbf8-4c16-9e6d-e65f5d4718f6",
      "text": "Russian Defence Ministry publicly accused President Erdoğan and his family of profiting from illegal oil shipments from Islamic State (IS/ISIL) in Syria and Iraq.",
      "date": "2015-12-02 00:00:00"
    },
    {
      "id": "c42142ca-f5c0-47ab-b025-c6443592bce2",
      "text": "WHO issued information notices clarifying interpretation of PCR cycle thresholds (advising careful interpretation of weak positives and use of clinical context)",
      "date": "2021-01-20 00:00:00"
    },
    {
      "id": "db697b3c-4c20-4835-bfed-a2f70871c18a",
      "text": "Peer‑reviewed study showing PCR cycle threshold (Ct) correlates with ability to culture live virus (low Ct more likely infectious)",
      "date": "2020-05-22 00:00:00"
    },
    {
      "id": "3b36b5d8-defd-41c3-8289-6bca2d5ab655",
      "text": "Kyiv City Council adopted a 2015 regulation and local initiatives promoting the use of Ukrainian in public life (programs 2015–2020).",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "f50f4def-0d40-4b2a-b554-6beb32d737a3",
      "text": "Parliament passed and enacted quotas for Ukrainian-language songs on radio (law approved June 16, 2016; quota measures came into force in 2016–2017), increasing legal requirements for media language use.",
      "date": "2016-11-08 00:00:00"
    },
    {
      "id": "d3876d96-c6ba-48b2-a7d4-25ba4800e435",
      "text": "Adoption of the Kivalov–Kolesnichenko Law on the Principles of State Language Policy (entered into force August 10, 2012).",
      "date": "2012-08-10 00:00:00"
    },
    {
      "id": "a0290b8a-cab4-4576-b231-460d6fbba5b6",
      "text": "Verkhovna Rada voted to repeal (23 February 2014) the 2012 language law amid the 2014 political upheaval (subsequent legal uncertainty and debates followed).",
      "date": "2014-02-23 00:00:00"
    },
    {
      "id": "60c62a8d-67f0-456f-babc-92a83004c410",
      "text": "Establishment of presidential and advisory bodies to promote Ukrainian language and national unity (e.g., Board for National Unity created by decree, December 2015) and public campaigns encouraging Ukrainian-language use.",
      "date": "2015-12-24 00:00:00"
    },
    {
      "id": "ff1b1f16-e1f3-4645-aada-881b39125135",
      "text": "Poland refused entry to the Night Wolves in late April 2015, blocking their planned land route to Germany.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "9df6a373-ef95-4532-ac3b-a1e8c83604f1",
      "text": "Night Wolves' active, visible role in Crimea (2014) and frequent state-linked publicity established them as a high-profile, Kremlin‑linked biker group prior to 2015.",
      "date": "2014-03-24 00:00:00"
    },
    {
      "id": "39a3616e-dad5-4fbd-ae4b-62f66f82c78e",
      "text": "Prime Minister Mark Rutte publicly said the Netherlands was unlikely to ratify the Agreement and sought 'legally binding' assurances from EU partners",
      "date": "2016-06-28 00:00:00"
    },
    {
      "id": "dba5650a-2407-4da3-af31-96dc54bcb94e",
      "text": "Dutch advisory referendum on the EU–Ukraine Association Agreement produced a 61% 'No' vote",
      "date": "2016-04-06 00:00:00"
    },
    {
      "id": "4d01381b-d2ad-4d1e-a67a-51a9d99787d7",
      "text": "The International Monetary Fund approved a $5 billion loan arrangement for Ukraine on June 9, 2020, contingent on economic reforms and anti-corruption measures.",
      "date": "2020-06-09 00:00:00"
    },
    {
      "id": "42bd8f38-2fd4-41ff-b341-2b0082c32891",
      "text": "The U.S. government temporarily froze nearly $400 million in security assistance to Ukraine in July 2019, around the time of the Trump–Zelensky call.",
      "date": "2019-07-24 00:00:00"
    },
    {
      "id": "a8fe53c0-7e4e-41fc-89e1-1ad373b9e8f8",
      "text": "Then-Vice President Joe Biden publicly recounted in 2018 pressuring Ukraine to fire a prosecutor by threatening to withhold roughly $1 billion in loan guarantees.",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "4f983b79-5012-4e5e-b5da-900007e5a9e4",
      "text": "A whistleblower complaint about the July 2019 call prompted a formal House impeachment inquiry into President Trump in September 2019.",
      "date": "2019-09-24 00:00:00"
    },
    {
      "id": "9feefbd2-a7c6-4721-82ad-657290b14cef",
      "text": "President Trump’s July 25, 2019 phone call with President Zelensky in which Trump asked Ukraine to investigate Joe Biden and his son.",
      "date": "2019-07-25 00:00:00"
    },
    {
      "id": "f165cf0e-f915-42f3-b7e5-f67a70b9c4de",
      "text": "Zelensky cancelled a planned US Senate briefing amid a funding impasse (December 2023)",
      "date": "2023-12-06 00:00:00"
    },
    {
      "id": "0a57fba4-28ce-4d8a-aff2-c670b52d4d49",
      "text": "Domestic polls and reporting in late 2023 showed a measurable dip in Zelensky's approval/ trust indicators",
      "date": "2023-12-24 00:00:00"
    },
    {
      "id": "2c659ec3-2327-40b7-86c2-5905cf7d48a3",
      "text": "Pandora Papers (Oct 2021) revelations about offshore connections of Zelensky and associates",
      "date": "2021-10-03 00:00:00"
    },
    {
      "id": "8c14d01d-d8dd-41c9-9cf7-c0401fcc6155",
      "text": "Reuters Institute Digital News Report 2023 documented widespread 'news fatigue' and falling news engagement",
      "date": "2023-06-24 00:00:00"
    },
    {
      "id": "2bac8904-52f4-4bdb-9620-f27b4151693e",
      "text": "Russian officials publicly accuse the West of direct involvement and hostile aims in Ukraine (e.g., Lavrov's public remarks at the UN accusing the West of 'de facto' fighting)",
      "date": "2023-09-23 00:00:00"
    },
    {
      "id": "47679c3a-7bc9-4d9d-a58e-3c4745dba065",
      "text": "Russia announces annexation of Donetsk, Luhansk, Kherson and Zaporizhzhia following contested 'referendums'",
      "date": "2022-09-30 00:00:00"
    },
    {
      "id": "29d04490-fe48-4d3e-a171-75452dcd6f93",
      "text": "NATO/Western officials publicly debate long‑term security packages for Ukraine, with reporting highlighting differences among allies",
      "date": "2023-06-15 00:00:00"
    },
    {
      "id": "902d866c-4f3c-4638-9889-9bd14c3d0372",
      "text": "Foreign embassies began withdrawing some staff and dependants from Kyiv",
      "date": "2014-01-24 00:00:00"
    },
    {
      "id": "da9fdf94-cb84-42e7-b74d-f0cb8328f7e6",
      "text": "UNHCR/IOM reporting of large-scale internal displacement from eastern Ukraine (Donbas) during 2014",
      "date": "2014-10-24 00:00:00"
    },
    {
      "id": "7ff61552-88f3-4526-97b5-d9ca9ed9b4e2",
      "text": "Violent Euromaidan clashes and clearing of Independence (Maidan) Square in central Kyiv",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "88bd205b-928f-47ae-ae3b-f31e27246468",
      "text": "Cross-border refugee flows and media coverage of Ukrainians seeking refuge in neighbouring countries (2014)",
      "date": "None"
    },
    {
      "id": "83f5e6cb-29b6-429f-8190-9a156717c61f",
      "text": "Publication of Israeli cohort study reporting no increased incidence of myocarditis/pericarditis in unvaccinated patients after COVID-19 infection (Tuvali et al., Journal of Clinical Medicine)",
      "date": "2022-04-15 00:00:00"
    },
    {
      "id": "bee4552b-57d9-478e-b893-2d4a9e1fc447",
      "text": "University of Ljubljana press release describing Zelenska's meetings with faculty and projects (and not attributing the cancelled lecture to protests).",
      "date": "2024-11-19 00:00:00"
    },
    {
      "id": "cbca741d-711d-4e4d-a4ce-33ef973ede59",
      "text": "A man shouting anti‑Ukraine/pro‑Russia slogans appeared and was detained during Zelenska's visit to the National and University Library (reported by multiple outlets).",
      "date": "2024-11-20 00:00:00"
    },
    {
      "id": "56411072-b42a-4fc6-8beb-80c750823803",
      "text": "IAEA chief condemns shelling near Zaporizhzhia nuclear power plant",
      "date": "2022-08-06 00:00:00"
    },
    {
      "id": "f4dd389c-4dcd-4760-b416-5688cb51f35f",
      "text": "Zelensky publicly urges partners to allow truly long-range strikes (September 2024)",
      "date": "2024-09-21 00:00:00"
    },
    {
      "id": "5f4ab424-0937-49e2-bb1c-22aac0430f2a",
      "text": "Putin puts Russia's nuclear forces on high alert after invasion began",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "cc878b4f-d0f6-41bb-b48f-76ec35f80521",
      "text": "Series of Ukrainian strikes against Russian targets in Crimea, including attacks on Sevastopol and military infrastructure (2023)",
      "date": "2023-09-16 00:00:00"
    },
    {
      "id": "eb7ccb5b-2c32-4340-b596-3de38645f97f",
      "text": "OSCE Special Monitoring Mission report (23 August 2014) noting heavily shelled residential areas in Donetsk and civilian reports of damage and danger",
      "date": "2014-08-23 00:00:00"
    },
    {
      "id": "dea64148-7283-4119-b18e-ce084b537bc9",
      "text": "Amnesty International research missions documenting summary killings and abuses in eastern Ukraine (late August–September 2014)",
      "date": "2014-09-24 00:00:00"
    },
    {
      "id": "f648a1ac-8647-4587-a65b-ec507e162328",
      "text": "Court ban on the Mejlis of the Crimean Tatar people declared 'extremist' (April 2016)",
      "date": "2016-04-26 00:00:00"
    },
    {
      "id": "df7328ad-1fa1-4626-aa8c-2ad980e5b771",
      "text": "Rapid issuance/acceptance of Russian passports in Crimea after annexation",
      "date": "2014-03-20 00:00:00"
    },
    {
      "id": "f7c95d9c-7dc5-4e18-b611-d0a7efa36313",
      "text": "Intense Russian offensive and heavy shelling around Rubizhne (Battle of Rubizhne) with reports Russian forces took large parts of the town",
      "date": "2022-04-06 00:00:00"
    },
    {
      "id": "2fc4f6cd-cdf8-48ba-9ec6-11b2f95170b3",
      "text": "Local authorities issued shelter and safety warnings after the explosion, noting toxic fumes and urging people to stay indoors",
      "date": "2022-04-09 00:00:00"
    },
    {
      "id": "48fce21f-e832-4203-ab5e-123ee6696b54",
      "text": "Nitric-acid tanker at Zarya chemical plant damaged/exploded after shelling in Rubizhne",
      "date": "2022-04-09 00:00:00"
    },
    {
      "id": "17a34f6d-fb4c-4c30-974b-ae80f60a7a6c",
      "text": "Publication of patent applications describing fusion proteins containing luciferase (public patent records, e.g., US patent applications from 2018–2020).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "b286e45c-02e1-4f62-b4ea-fa0ec72bc252",
      "text": "Publication of research using luciferase reporter systems to study SARS-CoV-2 entry and for rapid neutralization testing (e.g., nanoluciferase SARS-CoV-2 assays published in 2020).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "a12b2da7-f04b-4c9c-a3db-7be295e9d41b",
      "text": "Verkhovna Rada passed a package of four 'decommunization' laws mandating removal/ban of communist symbols and renaming of public places",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "9d757536-fecb-4608-b5ca-c5958b49de0d",
      "text": "Parliamentary action to establish May 8 as a Day of Remembrance and Reconciliation alongside changes to how May 9 was observed",
      "date": "None"
    },
    {
      "id": "5ad427b1-5567-464f-a8cf-f114afd13bab",
      "text": "Public dispute and protests around the future of the Vatutin grave/monument in Kyiv (rallies and media reports in April 2015)",
      "date": "None"
    },
    {
      "id": "9e1f9fe9-4b99-4e49-b766-2b7dad31a05b",
      "text": "Widespread toppling/removal of Lenin and other Soviet monuments across Ukraine in 2014–2015 ('Leninfall') and reporting on mass removals",
      "date": "None"
    },
    {
      "id": "b004b539-eb19-47a1-acdb-991d13d2815d",
      "text": "Ongoing wild poliovirus transmission in Pakistan and Afghanistan documented in GPEI 2019 annual report",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "c8d87d2a-7e82-4a07-8f54-5c5e1f05f12a",
      "text": "COVID-19 pandemic disrupted mass immunization campaigns, prompting WHO/UNICEF warnings about millions of children at risk (May 2020)",
      "date": "2020-05-24 00:00:00"
    },
    {
      "id": "d6de6342-d06f-4bed-a24d-eba7808ccee4",
      "text": "European leaders and diplomats publicly debated conditions and timelines for easing Russia sanctions (e.g., calls to consider step-by-step easing if Minsk progress made).",
      "date": "2015-02-24 00:00:00"
    },
    {
      "id": "99b7dd48-1e8a-402b-a5d1-fb3a5fb3a750",
      "text": "Multiple foreign embassies ordered non‑essential staff to leave or relocated operations from Kyiv",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "cf200205-e78e-440d-a9d8-77fbd362cd37",
      "text": "Heavy fighting around Hostomel (Antonov) airport and other approaches to Kyiv as Russian forces advanced",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "6a03b943-9d28-44b2-955d-574383777124",
      "text": "Large numbers of civilians seen fleeing Kyiv and images/videos of chaotic departures",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "8f870ec8-fd54-4279-a357-b36e82e50b6c",
      "text": "IOM / Ukrainian government data: registered internally displaced persons (IDPs) exceed one million (reported February 2015).",
      "date": "2015-02-17 00:00:00"
    },
    {
      "id": "7b41400e-2890-44c4-b7d4-e6cf6521a629",
      "text": "Council of Europe / pan-European analyses of 2015 refugee coverage identify uneven framing and limited humanising coverage in parts of the press during the 2015 refugee crisis.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "8421a853-8511-404e-9609-fc28810cbc3a",
      "text": "Monitoring by Thomson Foundation / MEMO 98 (published December 2015) reports problems and inconsistencies in Ukrainian regional media coverage of IDPs.",
      "date": "2015-12-10 00:00:00"
    },
    {
      "id": "c671a1bc-8a98-4e54-9d69-e4564687579d",
      "text": "Prominent alternative-health websites and how‑to blogs publishing step‑by‑step guides and testimonials for using castor oil against bone spurs, scars, cysts and tumors (2022–2023)",
      "date": "2023-04-24 00:00:00"
    },
    {
      "id": "7f8fb298-3c7e-4e6e-a71c-b19879710ca2",
      "text": "Public criticism from Jewish organizations and commentators about commemorations of Petliura (e.g., World Jewish Congress reaction and critical coverage following monument unveilings).",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "ff69865f-a5f6-4dc5-af62-644a5ef74c96",
      "text": "Analysis and reporting on disputes over church affiliation, symbolism and politicization of religious spaces in Ukraine and the diaspora (e.g., 'Who Owns Tradition? Ukraine's Church Controversy' — Wilson Center).",
      "date": "2024-08-24 00:00:00"
    },
    {
      "id": "5db9ef79-d7f2-4def-b134-502dc745d2cb",
      "text": "End-2020 decision and architectural competition announced for a Petliura monument in Poltava (projects selected in 2020–2021).",
      "date": "None"
    },
    {
      "id": "27e05cb7-cd28-4625-856d-6a9df0dac555",
      "text": "Gazprom sharply reduced Nord Stream 1 flows to around 20% capacity and publicly linked the cuts to maintenance delays and sanctions-related equipment issues.",
      "date": "2022-07-26 00:00:00"
    },
    {
      "id": "a81f1365-15a1-40ca-a95b-7adf39048cba",
      "text": "Ukraine's Center for Countering Disinformation (NSDC/CPD) and other monitoring bodies documented and warned about Russian propaganda narratives around Ukraine's winter preparedness and energy dependence.",
      "date": "2022-08-24 00:00:00"
    },
    {
      "id": "bf2eeb0d-cb04-4809-9b17-e692478c342c",
      "text": "Ukraine ended the 2021/2022 heating season with record‑low gas reserves in storage.",
      "date": "2022-04-21 00:00:00"
    },
    {
      "id": "c489b02f-e1f9-4731-81d8-f8063e70fa24",
      "text": "Publication of the review 'The endocannabinoid-CB1 receptor system in pre- and postnatal life' (Fride et al.), which notes that endocannabinoids have been detected in maternal milk (mostly from animal studies).",
      "date": "2004-04-24 00:00:00"
    },
    {
      "id": "2f2601e2-dcdf-4a53-ac93-2691da00cda1",
      "text": "November 7, 2012 — Voter approval of recreational marijuana legalization measures in Colorado and Washington (major expansion of public debate on cannabis).",
      "date": "2012-11-07 00:00:00"
    },
    {
      "id": "e4456bfe-2d43-4143-ab11-773ac7e34cd0",
      "text": "Reports mentioning use of military equipment (helicopters, armoured vehicles) during the government response",
      "date": "2015-07-11 00:00:00"
    },
    {
      "id": "fca78f43-297e-48a9-989c-20b2fe4e6e7e",
      "text": "Mukachevo shootout between Right Sector-affiliated fighters and local police",
      "date": "2015-07-11 00:00:00"
    },
    {
      "id": "db318a9a-5538-40ea-af8a-e1b6ab6c097b",
      "text": "Media and hospital-system reporting during the Delta surge highlighting 'incidental' COVID-19 hospital admissions (Florida example)",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "ba71ae78-0568-4ae9-b7e6-5633929adfdb",
      "text": "Local officials and media reported Russian troops looting shops and homes in occupied towns such as Trostianets (Sumy region) in early March.",
      "date": "2022-03-02 00:00:00"
    },
    {
      "id": "4d52f801-b5ec-4382-89ac-56c59fd5a2ba",
      "text": "Ukrainian president Volodymyr Zelensky called on citizens to take up arms and promised weapons would be issued to those willing to defend cities.",
      "date": "2022-02-24 00:00:00"
    },
    {
      "id": "8dec6f5d-64f6-4948-93f3-d08dfdb42d2d",
      "text": "Videos and news reports documented civilians in Kyiv and other cities preparing Molotov cocktails and receiving basic instructions on improvised weapons.",
      "date": "2022-02-26 00:00:00"
    },
    {
      "id": "a0a4f554-0227-41a3-b9b5-71d79a79b103",
      "text": "A passenger bus was struck near a Ukrainian Armed Forces checkpoint outside Volnovakha, killing and wounding civilians (reported immediately after the incident).",
      "date": "2015-01-13 00:00:00"
    },
    {
      "id": "37cdd7f1-dbbc-4d6f-bcd1-908d696cd044",
      "text": "Since early 2022, President Zelensky and Ukrainian authorities publicly invited and organized foreign volunteers via the International Legion and appeals for foreign fighters.",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "3aea1afc-c5cf-4000-a51f-bfc4f3c546a9",
      "text": "Irish media and security sources reported unidentified drones in Irish airspace on the night of Zelensky's arrival in Dublin, prompting government briefings and heightened coverage of his visit.",
      "date": "2025-12-04 00:00:00"
    },
    {
      "id": "c3385f2a-4d50-4695-b459-86268d931b4f",
      "text": "President Volodymyr Zelensky presented posthumous awards to the families of three Irish volunteer servicemembers during his official visit to Dublin.",
      "date": "2025-12-02 00:00:00"
    },
    {
      "id": "cff3fd9a-d663-4f91-806f-f5df7aab29c8",
      "text": "UK and Irish reporting had previously documented multiple Irish nationals serving and killed or missing while fighting in Ukraine (coverage naming Rory Mason, Finbar Cafferkey, Graham Dale and reporting Alex Ryzhuk as missing/presumed dead).",
      "date": "2024-08-21 00:00:00"
    },
    {
      "id": "0ca2b759-ed1f-4533-a743-66057166e846",
      "text": "Fluoride Action Network (FAN) national campaigning and reporting (2016–2017), including petitions and litigation efforts to challenge U.S. EPA regulation of fluoride.",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "b291b4aa-590a-45a3-be10-13ea049520f5",
      "text": "CDC/NHANES analyses and reporting on increased prevalence of dental fluorosis in U.S. surveys.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "57e1aa72-bd50-44f9-ac97-2321b745e8aa",
      "text": "CDC public description of its Technology Transfer Office and the fact that CDC researchers can patent inventions and license technologies to industry.",
      "date": "None"
    },
    {
      "id": "1b4f0df7-b4bd-4b1b-bc66-9bbbaf34be37",
      "text": "Ukraine passed and the president signed constitutional amendments in February 2019 enshrining EU and NATO membership as state policy",
      "date": "2019-02-19 00:00:00"
    },
    {
      "id": "d81661cf-5c0b-4a2b-9276-5eef0fe647d8",
      "text": "ECHA (European Chemicals Agency) opinion/proposal to classify titanium dioxide as a suspected carcinogen by inhalation (RAC opinion)",
      "date": "2017-04-24 00:00:00"
    },
    {
      "id": "250d30d1-b4d0-4780-afc9-7abb6bcb33c1",
      "text": "Scientific Reports paper (Sciensano-led) found titanium dioxide particles in all examined face masks",
      "date": "2022-02-15 00:00:00"
    },
    {
      "id": "f0b19778-b737-4355-aacb-1f94e50a3340",
      "text": "EU and public‑health coverage reassuring that there was ‘no evidence’ masks pose health risks after TiO2 concerns were reported (widely reported by Reuters and others)",
      "date": "2021-11-08 00:00:00"
    },
    {
      "id": "44bee4a0-5e9e-468b-827e-6d1884c6397a",
      "text": "On 21 April 2019 (second round presidential voting) some polling stations near the contact line experienced delays or local disruptions (reports noted at-the-day irregularities in frontline areas).",
      "date": "2019-04-21 00:00:00"
    },
    {
      "id": "002f0757-9088-4dfd-8861-b023ac2bc82b",
      "text": "Voting did not take place in Crimea and large parts of Donetsk and Luhansk during Ukraine's early parliamentary election (26 October 2014).",
      "date": "2014-10-26 00:00:00"
    },
    {
      "id": "80bc74d4-d262-4281-9d64-b4167293c1c5",
      "text": "Russia‑backed authorities held another round of unrecognized ‘elections’ in occupied Donbas on 11 November 2018 that Western bodies condemned as illegitimate.",
      "date": "2018-11-11 00:00:00"
    },
    {
      "id": "9c004883-e27b-4fa4-85dc-6237f9c3f8b3",
      "text": "International analyses documenting large numbers of foreign fighters/volunteers in Donbas (ICCT and other reports, mid‑2010s)",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "3d92343c-6406-4363-b6c0-f7f7774224be",
      "text": "Canadian defence delegation visit to the Donbas withdrawal line (reported delegation visit led by Deputy Minister Peter Hammerschmidt) — December 2019",
      "date": "2019-12-24 00:00:00"
    },
    {
      "id": "53aaa877-b359-4b19-9eb8-87dcb20c91b8",
      "text": "Canada launches Operation UNIFIER (Canadian Armed Forces trainers deployed to Ukraine) in 2015",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "87526bfe-1ab6-4510-81cd-485fd8a2394a",
      "text": "Deployment of Russian private military company Wagner to Crimea/Donbas in 2014–2015",
      "date": "None"
    },
    {
      "id": "4db96af4-a2d9-4915-a235-99f285265170",
      "text": "Satellite imagery and reporting in February 2022 showed substantial Russian troop and equipment deployments in Belarus and flights out of Belarusian bases toward Ukraine.",
      "date": "2022-02-06 00:00:00"
    },
    {
      "id": "0243bba8-97b4-405c-988d-c502a37eba5d",
      "text": "Ukrainian Defence Ministry's Military Intelligence published a roster naming Belarusian Air Force personnel allegedly involved in strikes, triggering circulation of lists linking Belarusian officers to combat operations.",
      "date": "2022-03-01 00:00:00"
    },
    {
      "id": "f7ae7a77-e251-42f3-86f0-7ed24dafaa34",
      "text": "Conflicting official messaging in late February 2022: Belarusian leadership publicly denied plans to send Belarusian troops, even while allowing Russian forces to mobilize on Belarusian soil.",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "c5ea45ad-3adf-499c-b7bf-7265e712f87a",
      "text": "The 2009 Su-27 crash at the Radom air show (30 August 2009) that killed two Belarusian pilots (A. Marfitski and A. Zhuraulevich).",
      "date": "2009-08-30 00:00:00"
    },
    {
      "id": "ac56868b-2125-4f50-b409-8de61b0026be",
      "text": "High‑profile resignations of senior FDA vaccine officials amid booster controversy (Marion Gruber and Phillip Krause)",
      "date": "2021-08-31 00:00:00"
    },
    {
      "id": "96d226e2-af95-4e8a-b05e-bb041137ed0b",
      "text": "Audit published of USAID's 'Strengthening Civil Society in Ukraine' project",
      "date": "2014-05-29 00:00:00"
    },
    {
      "id": "b71bf3b1-a654-4fd7-98f6-f665993968dd",
      "text": "Russian officials publicly accused the U.S. of meddling and funding protesters in Ukraine",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "578cb98d-fe9d-4880-98c9-f3933f0a0130",
      "text": "U.S. Congress/administration announcements of large financial assistance to Ukraine (including a $1 billion loan guarantee)",
      "date": "2014-03-28 00:00:00"
    },
    {
      "id": "088f6d76-5154-4348-a832-9c9c301aca64",
      "text": "Public records and reporting of National Endowment for Democracy (NED) grants to Ukrainian groups during Euromaidan",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "83562bb3-47bc-4447-ae9a-346721e6e771",
      "text": "IMF program in March 2015 tied continued financial support to debt restructuring and private‑sector involvement",
      "date": "2015-03-24 00:00:00"
    },
    {
      "id": "7044d262-4ace-4d40-888a-aeb6c91aa16f",
      "text": "Reuters reports Ukraine completed a major $15 billion debt restructuring in March 2015",
      "date": "2015-03-12 00:00:00"
    },
    {
      "id": "d2001645-6b3c-4657-b183-bf1790f9f067",
      "text": "DW reports Yatsenyuk warning Ukraine might suspend repayments and refusing to accept Russia’s terms (October 2015 coverage)",
      "date": "2015-10-26 00:00:00"
    },
    {
      "id": "740023ce-6df3-4ecd-ab09-6808b207dfde",
      "text": "Ukrainian prime minister publicly rebuffs Putin’s offer to restructure the $3bn Russian bond",
      "date": "2015-11-20 00:00:00"
    },
    {
      "id": "7f53f839-1dd0-4b87-a92f-8d56914df42d",
      "text": "Sharp decline in reported influenza activity in the U.S. during March 2020 as COVID-19 measures began",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "d387c4db-da26-4fe9-ba04-508b28a19630",
      "text": "Nature Medicine study (Leung et al.) showing face masks reduce respiratory virus shedding in exhaled breath",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "a8656049-fc1b-42f8-a23c-d74e20da9f6f",
      "text": "CDC recommends public use of nonmedical cloth face coverings",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "09b43b1f-b2fe-4c1e-bf61-ae46aab54da1",
      "text": "High‑profile Pfizer/BioNTech vaccine efficacy announcement (press release and global media coverage) reporting ~90% effectiveness",
      "date": "2020-11-09 00:00:00"
    },
    {
      "id": "d350bc36-e670-40d6-aa13-eea5cced5d3f",
      "text": "Historical origin of the MRC‑5 cell line (derived from a 14‑week male fetus in 1966) documented by cell banks (ATCC) and widely reported",
      "date": "1966-04-24 00:00:00"
    },
    {
      "id": "e3730230-766d-47c0-925a-acd8f825e41d",
      "text": "Release of a Research Square preprint (ChAdOx1 nCoV-19) showing experiments using MRC‑5 and HEK293 cell lines (preclinical/transcriptomic analysis)",
      "date": "2020-10-20 00:00:00"
    },
    {
      "id": "517160a7-add7-454a-ab4e-f0a0d7097b13",
      "text": "CDC recommendation on July 27, 2021 for universal indoor masking in K–12 schools regardless of vaccination status due to Delta variant concerns.",
      "date": "2021-07-27 00:00:00"
    },
    {
      "id": "5e4c7a2f-bb62-40cf-9046-3afa103259ec",
      "text": "Publication of MacIntyre et al. (2015) cluster randomized trial finding cloth masks offered less protection than medical masks among healthcare workers.",
      "date": "2015-04-22 00:00:00"
    },
    {
      "id": "5438d1e8-c35d-4f29-9ca5-d93e80592b4b",
      "text": "Torchlight marches and public rallies honouring WWII-era nationalist Stepan Bandera attended by far‑right groups and covered in the media (e.g., Lviv torchlight march).",
      "date": "2014-01-01 00:00:00"
    },
    {
      "id": "dde15ad3-c3ed-41c9-9c7e-212a0268b2f4",
      "text": "Passage of Ukraine's 'decommunization' laws in April 2015, banning Soviet symbols and changing official commemorations and place names.",
      "date": "2015-04-24 00:00:00"
    },
    {
      "id": "148b32a4-73c6-4d27-b7da-71b2c9563b4d",
      "text": "Profiles in 2014 highlighting the Right Sector movement's role in the Maidan protests and its radical nationalist ideology.",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "e0e902a1-1b92-4d20-b99e-b6ece30315f2",
      "text": "Reports in 2014 that the Azov militia (later a National Guard unit) used symbols and insignia associated with neo‑Nazi groups and had leaders with far‑right views.",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "b925b8a6-b72d-4a5c-8669-aefd94275817",
      "text": "World Health Assembly adoption of a package of amendments to the International Health Regulations (IHR) (adopted 1 June 2024)",
      "date": "2024-06-01 00:00:00"
    },
    {
      "id": "1e030ebf-e8f3-4135-b352-2512fe72e38f",
      "text": "Earlier high‑profile vaccine contamination reports (Japan paused some Moderna batches after black/foreign particles were found)",
      "date": "2021-08-26 00:00:00"
    },
    {
      "id": "2635407d-4878-4b46-a0cc-e96df9241a26",
      "text": "Publication of Danish research letter reporting batch-dependent variation in suspected adverse events after the Pfizer (BNT162b2) vaccine",
      "date": "2023-03-30 00:00:00"
    },
    {
      "id": "87f10262-b62a-4311-a7c5-9dd935e92d24",
      "text": "Publication and high-profile retraction (Surgisphere) of large observational studies on hydroxychloroquine (The Lancet retraction, June 2020)",
      "date": "2020-06-24 00:00:00"
    },
    {
      "id": "f3e080a5-bdfc-4b11-aba5-8a1d672670be",
      "text": "Publication of Didier Raoult / Gautret open-label non-randomized Marseille study reporting viral-load reduction after hydroxychloroquine ± azithromycin",
      "date": "2020-03-24 00:00:00"
    },
    {
      "id": "0f0735b0-0b64-43d9-b78c-c1bbb6bb8b3f",
      "text": "Prior international reporting (2014–2015) documented Azov's origins in far‑right volunteer networks and the use of extremist symbols by some members.",
      "date": "2015-03-13 00:00:00"
    },
    {
      "id": "a40a181c-1e52-4737-91a5-0bcbf75cfd68",
      "text": "Dutch advisory referendum on the EU–Ukraine Association Agreement had been activated and was widely reported (petition drive and referendum scheduled for April 2016).",
      "date": "2015-10-07 00:00:00"
    },
    {
      "id": "52289c6e-47f6-4ffb-be6d-afc19102dfe1",
      "text": "IPCC AR6 (Working Group I) released findings noting that internal variability can modulate near‑term global temperature trends, creating uncertainty in short‑term (years to a decade) temperature trajectories.",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "6f7e1a31-2f08-4dc1-9e88-4c22430a5a99",
      "text": "Japan suspends use of about 1.63 million Moderna COVID‑19 vaccine doses after 'foreign materials' were found in some vials, prompting international media coverage and public concern about vaccine contamination.",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "5ab7b0d3-7047-4c61-accb-d237cbfddb63",
      "text": "Two infants died shortly after receiving MMR vaccine in Samoa, prompting national investigation and temporary suspension of some vaccine supplies (widely reported and later traced to preparation error).",
      "date": "2018-07-11 00:00:00"
    },
    {
      "id": "ae66610f-0227-4d7d-881b-f939887bbb73",
      "text": "Reports of a July 2020 surge in Amazon deforestation and fires, and international concern about weakened enforcement under Brazil's government (reported August 2020)",
      "date": "2020-08-02 00:00:00"
    },
    {
      "id": "22413a57-ade4-432b-b447-ae7f68c9ea9a",
      "text": "Science Advances editorial 'Amazon Tipping Point: Last Chance for Action' by Thomas Lovejoy and Carlos Nobre (Dec 2019)",
      "date": "2019-12-20 00:00:00"
    },
    {
      "id": "d789af8a-74ca-4e8c-a53c-ce0d512a29c4",
      "text": "Investigations and reporting documenting Cyprus as a secrecy hub for Russian and other foreign wealth (‘Cyprus Confidential’ ICIJ series, 2023) highlighted Cyprus as a destination for opaque property holdings.",
      "date": "2023-11-18 00:00:00"
    },
    {
      "id": "cecdd572-0e9c-408c-a648-d24aebebc4a5",
      "text": "Ukraine's SBU announced it uncovered a scheme to embezzle about $40 million from weapons procurement (reported Jan 27, 2024).",
      "date": "2024-01-27 00:00:00"
    },
    {
      "id": "cc6121cf-f17c-4f0b-8068-f9bedd0b0497",
      "text": "The Pandora Papers (ICIJ coverage and major press, Oct 3, 2021) revealed offshore companies tied to Zelenskyy’s inner circle.",
      "date": "2021-10-03 00:00:00"
    },
    {
      "id": "29a7891b-c4f9-490d-9ea3-14bcdcf71170",
      "text": "Russian Defence Minister Sergei Shoigu publicly said Russia was \"deliberately slowing\" its offensive to allow civilians to evacuate.",
      "date": "2022-05-24 00:00:00"
    },
    {
      "id": "ae271609-4fdd-400d-8f29-7e52383382a3",
      "text": "Negotiations and agreements (limited implementation) to open humanitarian corridors between Russia and Ukraine were publicly reported.",
      "date": "2022-03-03 00:00:00"
    },
    {
      "id": "95dc57e4-ace0-4992-91bf-15cb68cf161c",
      "text": "Precedent: Ukrainian church leaders previously (April 2022) urged faithful to forgo night Easter vigils in areas affected by fighting and to use online prayer options.",
      "date": "2022-04-20 00:00:00"
    },
    {
      "id": "eca6695c-9485-46ba-88b1-f0b216c0df98",
      "text": "Kyiv city administration published wartime guidance advising limited mass gatherings for Easter and urging online broadcasts (curfew remained in force).",
      "date": "2023-04-11 00:00:00"
    },
    {
      "id": "1e525167-7028-4130-a290-89c0cc1f7b00",
      "text": "Kyiv Military Administration clarified churches would be open but worshippers who entered before the midnight curfew could not leave until it ended (and urged switching to online broadcasts).",
      "date": "2023-04-15 00:00:00"
    },
    {
      "id": "4e6ae5f8-c029-4c4c-911c-2249d87b3176",
      "text": "U.S.–Ukraine critical minerals/resources memorandum reported",
      "date": "2025-04-30 00:00:00"
    },
    {
      "id": "8e44b3f6-8941-4118-9684-cee357148f2e",
      "text": "Ukraine Recovery Conference (URC) — large Western reconstruction pledges and private‑sector investment commitments",
      "date": "2023-06-21 00:00:00"
    },
    {
      "id": "d4dd7258-46f2-4967-b8a9-c22fbc3234a6",
      "text": "Prominent think‑tank analyses raising 'partition' as a plausible risk/outcome",
      "date": "2024-01-08 00:00:00"
    },
    {
      "id": "5e8dfcf3-0b58-4cd5-9849-4dae8da9a114",
      "text": "Russian customs effectively suspended or heavily restricted imports from Ukraine (placing Ukrainian exporters on a 'risk' list), producing a de facto trade embargo in August 2013.",
      "date": "2013-08-14 00:00:00"
    },
    {
      "id": "94cbd636-96c5-441e-8084-28d66e0a9c94",
      "text": "Separatists and protestors had seized Ukrainian security service buildings and weapons stores in Luhansk in 2014",
      "date": "2014-04-22 00:00:00"
    },
    {
      "id": "99e3cbee-8eeb-4283-b940-26f6d55860bb",
      "text": "Public debate in 2015 about supplying Western weapons to Ukraine (media/policy discussions)",
      "date": "2015-02-11 00:00:00"
    },
    {
      "id": "006a0af7-5134-4b95-ba70-99a654f66320",
      "text": "Ukrainian government announces figure of 19,546 Ukrainian children deported/forcibly transferred",
      "date": "2023-03-24 00:00:00"
    },
    {
      "id": "66fdb79c-7177-4e29-8db6-3361eb871144",
      "text": "Russian officials and state media publicly characterize transfers as 'evacuations', 'adoptions', or humanitarian relocations and dispute foreign reports",
      "date": "2023-02-15 00:00:00"
    },
    {
      "id": "4b78b22b-a78b-429d-ad70-d88d304eb04d",
      "text": "U.S. FDA granted Emergency Use Authorization (EUA) for the first COVID-19 vaccine (Pfizer–BioNTech).",
      "date": "2020-12-11 00:00:00"
    },
    {
      "id": "7f21b2c9-2821-4403-ac30-03ac46bc7bbb",
      "text": "CDC updated indoor masking guidance on July 27, 2021, advising fully vaccinated people to wear masks in public indoor settings in areas of substantial or high transmission due to Delta.",
      "date": "2021-07-27 00:00:00"
    },
    {
      "id": "7b17fc30-706e-4de0-9711-467e629d4a85",
      "text": "Israeli Ministry of Health and media reports (early July 2021) indicated reduced Pfizer vaccine effectiveness at preventing infection with the Delta variant (while still protecting against severe disease).",
      "date": "2021-07-05 00:00:00"
    },
    {
      "id": "b55fb582-2646-4c5e-9bdf-fafa3084e7f7",
      "text": "CDC MMWR report on the Provincetown, Massachusetts Delta outbreak showing many infections in fully vaccinated people (including high viral loads).",
      "date": "2021-07-30 00:00:00"
    },
    {
      "id": "71fb2457-f74f-420b-b866-478d856b2ab9",
      "text": "Publication of meta‑analyses / preprints (e.g., John Ioannidis' seroprevalence‑based estimates in May 2020) reporting relatively low infection fatality rate (IFR) estimates in some settings.",
      "date": "2020-05-13 00:00:00"
    },
    {
      "id": "2b6bdc01-aa57-4c64-9a80-48854762b219",
      "text": "Swedish state epidemiologist Anders Tegnell publicly defended Sweden's decision not to impose a strict lockdown and said parts of Stockholm were showing signs of immunity",
      "date": "2020-04-22 00:00:00"
    },
    {
      "id": "f65890dc-6fc9-4d6c-bd46-ea4e94f73923",
      "text": "Global dashboards and WHO/academic mortality pages publishing country-level COVID death counts and per-capita metrics were widely circulated in summer 2020",
      "date": "2020-08-08 00:00:00"
    },
    {
      "id": "90499542-92a5-4b43-b305-37be2a8caa3c",
      "text": "Gordon Brown's public apology to former child migrants (UK government apology)",
      "date": "2010-02-24 00:00:00"
    },
    {
      "id": "ff5f1c6b-a058-4e94-bdb9-0a1846fd8362",
      "text": "Reuters reported Ukraine was in talks with Moscow over the return of 311 Ukrainian soldiers and border guards who had crossed into Russia, while Russian border authorities said the troops were seeking asylum.",
      "date": "2014-08-04 00:00:00"
    },
    {
      "id": "fcd23f10-1869-43b2-b82a-c56c211ba8a5",
      "text": "OSCE Special Monitoring Mission reported witnessing the passage of 437 Ukrainian servicemen through Russian checkpoints and stated it had inquired about asylum requests and found none.",
      "date": "2014-08-04 00:00:00"
    },
    {
      "id": "4e9e4d5c-6e27-4e17-ad6e-b22d8489b781",
      "text": "EU Foreign Ministers agree to begin targeted measures (reported in UK parliamentary scrutiny documents)",
      "date": "2014-02-20 00:00:00"
    },
    {
      "id": "00258153-b0fa-4cef-b1ce-bc62bb041f10",
      "text": "European Parliament adopts resolution condemning Russian actions in Ukraine",
      "date": "2014-03-13 00:00:00"
    },
    {
      "id": "6ca83595-0bcb-428d-a4ec-ba254a2efbea",
      "text": "UK Prime Minister David Cameron signals support for strong EU sanctions on Russia",
      "date": "2014-03-04 00:00:00"
    },
    {
      "id": "e51f8b71-986d-410f-bd79-93c3e78b00f2",
      "text": "Reporting of UK MPs meeting or engaging with Russian officials and pro‑Kremlin voices (summer 2014)",
      "date": "2014-07-01 00:00:00"
    },
    {
      "id": "76508154-09da-49a0-95a1-066d078e00cd",
      "text": "The Joint Investigation Team (JIT) held a public presentation of interim MH17 criminal-investigation results describing the likely weapon type and launch area.",
      "date": "2016-09-28 00:00:00"
    },
    {
      "id": "c327f749-1b30-42e5-aa05-6fbb0eeacd7f",
      "text": "Ukrainian authorities/activists compiled and publicised lists of Russian artists and cultural figures to be blacklisted from entry or broadcasting in Ukraine (summer 2014 announcements).",
      "date": "2014-08-24 00:00:00"
    },
    {
      "id": "609fc20d-fab3-4131-b0c2-6231bd2b0971",
      "text": "Repeal/controversy over the 2012 Kolesnichenko–Kivalov 'regional language' law and moves to strengthen the status of Ukrainian after February 2014.",
      "date": "2014-02-24 00:00:00"
    },
    {
      "id": "1a261083-868b-4ca7-a6d1-1efed63eb1ca",
      "text": "Kyiv city administration replaced Soviet-era Ded Moroz (Father Frost) in its official New Year program with the Orthodox figure Saint Mykolay.",
      "date": "2014-11-20 00:00:00"
    },
    {
      "id": "9ba195c6-1326-42c5-960c-19e7c8042ded",
      "text": "Widespread removal/toppling of Lenin statues across Ukraine ('Leninopad') during early 2014.",
      "date": "None"
    },
    {
      "id": "cecf8006-3769-448b-bee9-c409927c3538",
      "text": "Verkhovna Rada adopts four 'decommunization' laws banning communist/Nazi symbols and related propaganda",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "3866f289-5721-43dd-8f2f-d438225475a7",
      "text": "Assassination of pro‑Russian journalist Oles Buzina in Kyiv",
      "date": "2015-04-16 00:00:00"
    },
    {
      "id": "761fbe9f-4e8a-4239-83af-c6e54f45e545",
      "text": "Adoption of the 'lustration' (cleansing) law removing/formally barring former officials from public office",
      "date": "2014-10-16 00:00:00"
    },
    {
      "id": "2c06f34f-2f19-47ac-8693-44195e18db1c",
      "text": "Reports of Ukrainian authorities detaining and denying entry to journalists (SBU detentions, denied access to some Russian reporters)",
      "date": "2014-05-21 00:00:00"
    },
    {
      "id": "21f02906-61aa-4635-89e7-dfdef2f8e32f",
      "text": "UNODC/trafficking and organized crime reports covering Ukraine (Global and regional reports up to 2014)",
      "date": "2014-04-24 00:00:00"
    },
    {
      "id": "e969df4c-6bda-4fda-8faf-8a2f53079843",
      "text": "U.S. State Department 2016 International Narcotics Control Strategy Report (INCSR) and related country assessments",
      "date": "2016-03-24 00:00:00"
    },
    {
      "id": "bd127af5-f593-4936-8d80-4770971638b8",
      "text": "Panama Papers revelations linking Ukrainian elites and offshore companies",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "71c7b3ea-9646-4c99-97af-5f9ae141a87c",
      "text": "Mainstream press coverage of the booming 'sound bath' and sound‑healing trend (New York Times feature, Aug 3, 2019)",
      "date": "2019-08-03 00:00:00"
    },
    {
      "id": "a1f58177-6ee6-403c-b59f-e0c47e72f8e5",
      "text": "Publication of a small 2018 study 'Effect of 528 Hz Music on the Endocrine System and Autonomic Nervous System' reporting short‑term stress‑reduction biomarkers after exposure",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "465139ad-b844-408e-9047-05e13f2a1617",
      "text": "Wellness platforms and apps published accessible explainers promoting 528 Hz as relaxing/'healing' (example: Calm blog explainer on 528 Hz)",
      "date": "2021-07-30 00:00:00"
    },
    {
      "id": "b882c107-1688-4c7f-aa83-37f8179b332f",
      "text": "Russian authorities completed a domestic switch of Crimea's public telephone numbering to the Russian system (transfer of city codes to Russian numbering, widely reported May 2015).",
      "date": "2015-05-07 00:00:00"
    },
    {
      "id": "a67870d4-bdaa-40e8-8ed1-3008ad93ff8c",
      "text": "United Nations General Assembly Resolution 68/262 (27 March 2014) reaffirmed Ukraine's territorial integrity and non‑recognition of the 2014 Crimean 'referendum'.",
      "date": "2014-03-27 00:00:00"
    },
    {
      "id": "fedf74b3-da5d-4791-bb62-b882627d82dd",
      "text": "An ITU Operational Bulletin issue published information submitted by the Russian Federation about numbering in Crimea (the bulletin included Russian-requested codes but carried an ITU disclaimer that publication did not imply recognition of territorial status).",
      "date": "2017-07-24 00:00:00"
    },
    {
      "id": "0fbd1e4c-5ae9-42d9-9da5-e0a879fe9a56",
      "text": "Ukrenergo confirms restriction of power flow from the Ukrainian grid to Crimea",
      "date": "2014-09-03 00:00:00"
    },
    {
      "id": "16e3a410-61e7-4567-9254-da415cc634a2",
      "text": "Russia announced a fast-track citizenship/passport scheme for residents in occupied Kherson and Zaporizhzhia",
      "date": "2022-05-25 00:00:00"
    },
    {
      "id": "d36dc697-e41c-4adc-903b-d65a6656346c",
      "text": "The Russian-installed head of the occupied part of Zaporizhzhia signed a decree to begin preparations for a referendum on joining Russia",
      "date": "2022-08-08 00:00:00"
    },
    {
      "id": "e0403980-e461-44f1-8f2a-cf3d14ecce4d",
      "text": "Russian President Vladimir Putin recognized the self-proclaimed Donetsk and Luhansk 'people's republics' as independent entities",
      "date": "2022-02-21 00:00:00"
    },
    {
      "id": "d350a23c-53ae-49d3-a77b-96740cdef738",
      "text": "NOAA and international reports showing greenhouse gas concentrations and ocean heat content reached record highs in 2021 despite pandemic-era emissions dip.",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "2b6a71aa-4472-4e68-99df-a6a0eaf88087",
      "text": "IPCC Sixth Assessment Report (AR6) Working Group I Summary for Policymakers released, stating human influence on climate is 'unequivocal'.",
      "date": "2021-08-24 00:00:00"
    },
    {
      "id": "8e43ca38-477c-461c-b3bc-58e7cf786127",
      "text": "Unprecedented Pacific Northwest heatwave that broke all-time temperature records across parts of the US and Canada.",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "cf666a58-2243-4a76-bb8f-1694da47cc0a",
      "text": "The Pfizer–BioNTech Phase 3 clinical trial protocol (NEJM supplementary material, published with the trial paper) contains wording that 'each lot of \"Process 2\"-manufactured BNT162b2 will be administered to approximately 250 participants...'.",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "f37eb4c8-03bf-42cd-8294-6b6396362096",
      "text": "Regulatory assessment documents (EMA/UK regulator summaries and later EMA follow-ups in 2022) described two manufacturing processes (Process 1 and Process 2) and required post‑authorization comparability analyses that were later reported as fulfilled.",
      "date": "2022-09-24 00:00:00"
    },
    {
      "id": "8293ff46-9e9c-4729-be96-eb147e98babc",
      "text": "Publication and long-running media attention to the Altamont Pass Wind Resource Area bird-fatality monitoring and final report showing substantial raptor deaths at a major U.S. wind zone.",
      "date": "2016-04-24 00:00:00"
    },
    {
      "id": "2d781471-40cd-4135-ae10-5d54b0c2f161",
      "text": "2020 study/news coverage showing that painting or visually marking turbine blades (Smøla, Norway) reduced raptor collisions by a large percentage.",
      "date": "2020-08-24 00:00:00"
    },
    {
      "id": "7761aa3f-02a9-44a2-925d-b948230aa424",
      "text": "U.S. Food and Drug Administration issued public statements and warning letters (Nov 2019 and subsequent actions) about companies illegally marketing CBD products with unproven health claims.",
      "date": "2019-11-25 00:00:00"
    },
    {
      "id": "20935077-ae16-44a6-8f86-4b3958ab676a",
      "text": "Mainstream consumer interest in 'clean'/'natural' personal-care labels (clean-beauty trend coverage)",
      "date": "2023-01-04 00:00:00"
    },
    {
      "id": "144f4ef3-3f8f-4bcd-af22-0f371f1acea7",
      "text": "Ukrainian authorities/Parliament and agencies moved to blacklist or restrict performances by some Russian artists (summer 2015)",
      "date": "2015-08-08 00:00:00"
    },
    {
      "id": "97fea7ed-0a59-4136-8d95-48012da6ae95",
      "text": "Verkhovna Rada passed 'decommunization' laws and other cultural-memory legislation",
      "date": "2015-04-09 00:00:00"
    },
    {
      "id": "2c5df468-b52b-4d60-8845-9a4f8f790442",
      "text": "Adoption and controversy around the Kivalov–Kolesnichenko 'language policy' law (entered into force August 2012)",
      "date": "2012-08-10 00:00:00"
    },
    {
      "id": "ffe13c8a-2b52-4649-8da5-573147362c7f",
      "text": "Ukraine's National Council for TV and Radio Broadcasting ordered cable operators to stop retransmitting several Russian TV channels",
      "date": "2014-03-11 00:00:00"
    },
    {
      "id": "db5a3cdb-61d6-4430-98a2-5ca84df09264",
      "text": "Russian leadership publicly denied deployment of regular Russian troops to eastern Ukraine (e.g. Vladimir Putin statements denying regular Russian troops are in Ukraine).",
      "date": "2015-04-16 00:00:00"
    },
    {
      "id": "370fe09f-1815-44bc-966c-d5620e3f3523",
      "text": "OSCE Secretary General Lamberto Zannier and OSCE Chief Monitor Ertugrul Apakan issue a joint statement after Minsk talks noting the SMM could not verify removal of 'foreign armed formations' and stressing need for access to verify compliance.",
      "date": "2015-02-13 00:00:00"
    },
    {
      "id": "a1799f97-c47e-4195-b20b-f0ad237b2d47",
      "text": "Ukraine's ambassador to Italy publicly criticized Verona's revocation and called it orchestrated by external (Kremlin) influence.",
      "date": "2018-09-24 00:00:00"
    },
    {
      "id": "8f6604c8-287d-433c-a86e-5fe6b1d8304e",
      "text": "Ukraine recovered and returned 17 paintings stolen from Verona's Castelvecchio museum; Poroshenko took part in return ceremonies.",
      "date": "2016-05-24 00:00:00"
    },
    {
      "id": "d41a1e23-eec6-446d-b7fd-b0cfd04fc347",
      "text": "Widespread public fear and vaccine hesitancy in Samoa after the 2018 deaths—many parents reportedly stopped taking children for routine immunisations.",
      "date": "2019-06-06 00:00:00"
    },
    {
      "id": "e58137b7-32e2-47b4-97f5-63c8ce35448a",
      "text": "Two senior Samoan nurses were sentenced to five years' imprisonment for their role in the infants' deaths after incorrectly administering the vaccine.",
      "date": "2019-08-02 00:00:00"
    },
    {
      "id": "e9e683db-688a-4ca1-aab1-a2534d2cbe9c",
      "text": "Published clinical case reports and reviews documented rare but real cardiac or severe complications occurring around dental procedures (e.g., cardiac arrest during recovery after tooth extraction).",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "f1f11a20-928c-4ed8-8c63-bd61be10cfdc",
      "text": "U.S. Defense Threat Reduction Agency (DTRA) and the U.S. Embassy publicly documented long-running U.S. cooperative biological threat reduction work with Ukraine (lab upgrades, surveillance, diagnostics)",
      "date": "None"
    },
    {
      "id": "cda9134c-6da8-4b17-8062-32c67f8575dc",
      "text": "Ukraine experienced major vaccine-preventable disease outbreaks and entrenched vaccine hesitancy (notably large measles outbreaks in 2017–2019)",
      "date": "None"
    },
    {
      "id": "cbf6ac36-0c7f-4daf-ada1-66917b3bcc6c",
      "text": "AstraZeneca temporarily paused its global COVID-19 vaccine trials after an unexplained illness in a trial participant",
      "date": "2020-09-09 00:00:00"
    },
    {
      "id": "055e26f4-de2a-481c-8228-76083549ff72",
      "text": "U.S. FDA issued an Emergency Use Authorization (EUA) permitting distribution of donated hydroxychloroquine from the Strategic National Stockpile (EUA issued March 28, 2020).",
      "date": "2020-03-28 00:00:00"
    },
    {
      "id": "f5272df2-6a70-4641-aa53-d3ac1bfc97e4",
      "text": "Dr. Vladimir Zelenko publicly promoted his outpatient 'Zelenko protocol'—hydroxychloroquine + azithromycin + zinc—for early COVID-19 and gained local/regional media attention.",
      "date": "2020-04-30 00:00:00"
    },
    {
      "id": "10f7556d-46ff-442b-824c-344e5364e305",
      "text": "Publication of Cowling et al. 2012 randomized trial reporting increased non‑influenza respiratory virus infections after inactivated influenza vaccination",
      "date": "2012-11-24 00:00:00"
    },
    {
      "id": "ad767526-fcd8-4271-ac09-b4292b190878",
      "text": "National Academies report 'Reflecting Sunlight: Recommendations for Solar Geoengineering Research' (June 2021)",
      "date": "2021-06-24 00:00:00"
    },
    {
      "id": "945dea35-f608-4c69-9696-2e53442a9e18",
      "text": "Release of the 1996 Air Force study 'Weather as a Force Multiplier: Owning the Weather 2025'",
      "date": "1996-08-24 00:00:00"
    },
    {
      "id": "66746a10-66dc-404c-865a-e4f7f83380a1",
      "text": "Declassification and press reporting on Operation Popeye (U.S. cloud‑seeding in Vietnam, 1967–1972)",
      "date": "1972-07-24 00:00:00"
    },
    {
      "id": "78fe29da-84f2-4baa-be8d-6fb4ff124304",
      "text": "President Zelensky’s office formally responded to petitions about the Catherine II monument and forwarded them to the Odesa City Council for consideration (per presidential response practice).",
      "date": "2022-08-01 00:00:00"
    },
    {
      "id": "07010ddd-e21f-403b-9593-a4541391803e",
      "text": "Separate electronic petition to dismantle the Catherine II monument was registered on the President of Ukraine’s petitions platform (petition 22/145072‑ep).",
      "date": "2022-06-28 00:00:00"
    },
    {
      "id": "e0a99797-941a-4671-bf46-f0dd1bfb658a",
      "text": "Online petition to replace Odesa's Catherine II statue with a monument of US gay adult performer Billy Herrington reached required threshold for presidential consideration.",
      "date": "2022-07-13 00:00:00"
    },
    {
      "id": "1fcbb4c4-7fef-4053-8120-08f9f1c2b449",
      "text": "Sustained local activism and public debate in Odesa in mid‑2022 calling for removal or relocation of Russian‑imperial and Soviet monuments.",
      "date": "None"
    },
    {
      "id": "b74b70e7-c83f-41d9-bcc8-9d6a97dabe5d",
      "text": "Large releases of internal Pfizer/FDA documents following the PHMPT FOIA lawsuit and judge-ordered accelerated disclosure (documents began being released publicly in early 2022).",
      "date": "2022-01-24 00:00:00"
    },
    {
      "id": "2fee70ad-af03-412e-8657-43b22638b4d7",
      "text": "FDA briefing documents for the Dec. 2020 Vaccines and Related Biological Products Advisory Committee (VRBPAC) meeting that listed trial deaths and stated investigators assessed none as related to the study intervention.",
      "date": "2020-12-08 00:00:00"
    },
    {
      "id": "65ee12b8-784e-47d4-94af-9f72ed77d148",
      "text": "Early COVID-era clinical reports and reviews highlighted that the eye can show signs of infection (e.g., conjunctivitis as a presenting sign of COVID-19).",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "80063df5-4134-4cc5-881d-25ed98bc202c",
      "text": "Popular science and health journalism pieces explaining how eye exams can reveal systemic health issues (diabetes, jaundice, hypertension) reached wide audiences.",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "f3500725-a4ae-4a93-9216-9c911a39872f",
      "text": "Published analyses and meta‑analyses in 2022 documented reduced vaccine effectiveness against Omicron infection and waning protection over time, with lower effectiveness for preventing symptomatic infection and some reduction for hospitalization in older/longer‑since‑vaccinated groups.",
      "date": "2022-09-24 00:00:00"
    },
    {
      "id": "86986485-7c53-4f97-bbb4-793d8c13c40a",
      "text": "Academic commentary and public explanations (e.g., Lancet / public‑health pieces in 2021–2022) highlighted the 'base‑rate fallacy'—how, in highly vaccinated populations, the majority of cases can be vaccinated even when vaccines work.",
      "date": "2022-03-24 00:00:00"
    },
    {
      "id": "6766c2ec-1ad6-43e5-8693-a08588802f0b",
      "text": "DIVI (German intensive care registry) added fields to record COVID-19 patients' vaccination status, enabling routine recording of vaccinated/unvaccinated counts on ICUs.",
      "date": "2021-12-24 00:00:00"
    },
    {
      "id": "1cb913cd-a492-42ac-9a44-2a8d1e7c426d",
      "text": "Scientists and aerial surveys announced a third mass bleaching event on the Great Barrier Reef during the 2019–2020 summer, widely reported as 'third mass bleaching in five years'.",
      "date": "2020-03-25 00:00:00"
    },
    {
      "id": "762c8547-06dc-43a5-ab8e-4135203aea66",
      "text": "UNESCO and the Australian governments’ 2019 reporting on the Reef’s deteriorating outlook (2019 Great Barrier Reef Outlook Report / World Heritage Committee concerns) signalled long-term decline.",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "b7733ee8-2287-4667-9f4f-bbc3ebf6720a",
      "text": "Armenian NGOs and civil society groups (in early November 2020) issued public statements condemning Azerbaijan’s reported use of white phosphorus munitions.",
      "date": "2020-11-05 00:00:00"
    },
    {
      "id": "c53e1efc-7533-4582-8a01-4b4b6992f8d3",
      "text": "Open-source satellite imagery and videos in November 2020 showed burn patterns and footage consistent with reported use of white phosphorus munitions in the Second Nagorno-Karabakh War.",
      "date": "2020-11-24 00:00:00"
    },
    {
      "id": "4b1e5b8c-8a50-4fe6-98c4-02742ea41abc",
      "text": "Azerbaijan formally responded to Armenia's accusations at an OPCW session, denying the claims and disputing evidence (official statement recorded in OPCW documentation).",
      "date": "2021-11-24 00:00:00"
    },
    {
      "id": "fe6dfd64-bbf2-4a17-895c-c6ae88b7ec89",
      "text": "IPCC Fifth Assessment Report (AR5) discussion of the 1998–2012 'hiatus' in surface warming",
      "date": "2013-09-24 00:00:00"
    },
    {
      "id": "b15fb8e1-637f-40e7-8eb1-707011750283",
      "text": "Hockey-stick controversy and critiques (McIntyre & McKitrick critiques and 2006 NRC review)",
      "date": "2006-04-24 00:00:00"
    },
    {
      "id": "bfd8e40a-82ea-46ae-bf57-a5bd59789ca5",
      "text": "Public Health England technical briefing (Technical Briefing 16) published with early variant case and death tables",
      "date": "2021-06-18 00:00:00"
    },
    {
      "id": "78a9b4b8-6d87-4353-93a6-aa50966bc925",
      "text": "Publication and press coverage of the Scottish EAVE II analysis showing Delta linked to higher hospitalisation risk",
      "date": "2021-06-15 00:00:00"
    },
    {
      "id": "74f13c59-4f5d-4cc1-a371-290153702650",
      "text": "UN OCHA/partners publish Ukraine Strategic Response Plan (humanitarian appeals for Ukraine, 2015)",
      "date": "2014-12-24 00:00:00"
    },
    {
      "id": "fdf37f84-dd1e-4b1b-a0b5-8a2170318090",
      "text": "UN Security Council action on Crimea blocked after Russia veto (UN inability to act on Ukraine-related measures)",
      "date": "2014-03-16 00:00:00"
    },
    {
      "id": "bbbff07c-eb09-429e-8e43-4ddc8d113800",
      "text": "IMF delayed/suspended loan tranches to Ukraine amid governance and reform concerns (2015–2016)",
      "date": "2016-09-14 00:00:00"
    },
    {
      "id": "75ec15a9-628f-4f3c-89d3-eecc766a6421",
      "text": "UN humanitarian funding shortfalls reported in 2017 (large gaps between appeal requirements and funding)",
      "date": "2017-08-31 00:00:00"
    },
    {
      "id": "a0c42368-b067-43e0-8465-9dfd78e6852a",
      "text": "UNDP policy guidance states UNDP will not contribute to general budget support (direct government budget transfers)",
      "date": "2008-11-24 00:00:00"
    },
    {
      "id": "ffa46cbb-e67a-4ceb-ba55-1cac0877f028",
      "text": "Poland passed the 'Special Act' on assistance to Ukrainian citizens (granting temporary protection, PESEL registration and access to services) that entered into force in March 2022.",
      "date": "2022-03-12 00:00:00"
    },
    {
      "id": "a6f2e0ff-430b-4750-9cff-d43cbf11e3f2",
      "text": "Ukraine's Cabinet adopted Resolution No. 678 approving an experimental project to allow issuance of Ukrainian ID-cards and foreign passports to Ukrainian citizens abroad.",
      "date": "2022-06-10 00:00:00"
    },
    {
      "id": "a22287a0-316a-4bc3-8877-40c3d8842ed4",
      "text": "Major reporting on rapid mass issuance of Polish ID numbers (PESEL) to Ukrainian refugees and the setup of document/ID help points (e.g., coverage of refugees receiving IDs at Warsaw sites).",
      "date": "2022-03-19 00:00:00"
    },
    {
      "id": "b3a49e5e-3812-42ea-835b-08791faac60a",
      "text": "Ukrainian document service announced opening of a centre/representation in Warsaw (Blue Office / Blue City) to process Ukrainian passport and ID applications.",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "d907f214-9242-4da1-96dc-9f0bc33f61c2",
      "text": "Publication of the NIC‑PD randomized, double‑blind trial (Transdermal Nicotine Treatment and Progression of Early Parkinson's Disease), published online Aug 22, 2023 (NEJM Evidence / PubMed).",
      "date": "2023-08-22 00:00:00"
    },
    {
      "id": "4f53296c-a170-4dac-8b3c-95e6d1d09300",
      "text": "Statement by Eduard Basurin (DPR deputy defence minister) claiming drunken Ukrainian soldiers stole a tank and crushed a civilian car in Zoria, near Mariupol.",
      "date": "None"
    },
    {
      "id": "88b5ff8c-32f4-4cb5-a4c2-5102fb026e29",
      "text": "Kerch ferry operator reports unusually high passenger volumes in summer 2016",
      "date": "None"
    },
    {
      "id": "afffbb98-7a7c-49ca-9495-deb16124338d",
      "text": "Crimean tourism minister (Sergei Strelbitsky) publicly claims sharp rises in Ukrainian visitors during 2016",
      "date": "2016-08-15 00:00:00"
    },
    {
      "id": "64a38f3a-9456-49bb-ba68-f04e3e791b42",
      "text": "Russian media cites security claims that alleged Ukrainian sabotage aimed to 'destroy tourism' in Crimea (Reuters coverage)",
      "date": "2016-08-24 00:00:00"
    },
    {
      "id": "83509a11-3f16-4bdb-80aa-2c8c01e9e78a",
      "text": "Early, well‑publicized problems with the CDC's original PCR test rollout in February–March 2020 (flawed reagents and re‑validation), widely reported in the press",
      "date": "2020-12-26 00:00:00"
    },
    {
      "id": "51d7de32-25b2-49d1-95bf-bab4d50c8194",
      "text": "CDC promotion and availability of a multiplex 'Influenza SARS‑CoV‑2 (Flu SC2) Multiplex Assay' that detects and differentiates influenza A/B and SARS‑CoV‑2",
      "date": "2021-07-13 00:00:00"
    },
    {
      "id": "fb3df18f-a0a2-4ce9-8600-c2a404c590ff",
      "text": "Zelenskyy's public denunciations (Aug 2023) of corruption in military medical exemptions and announced reviews",
      "date": "2023-08-30 00:00:00"
    },
    {
      "id": "e383b025-a9fa-4797-9875-e72189d9e9ab",
      "text": "Law / parliamentary changes expanding categories eligible for exemption or deferment from mobilization (July 2022 amendments and related guidance)",
      "date": "2022-07-29 00:00:00"
    },
    {
      "id": "e69f59d9-bb32-4254-9600-13a67472b7d6",
      "text": "Canadian Parliament standing ovation for Yaroslav Hunka (a veteran who served in a WWII Galicia-linked formation)",
      "date": "2023-09-24 00:00:00"
    },
    {
      "id": "4752aea3-c2b1-42ba-8ef3-78e974599ff3",
      "text": "Japan suspended use of ~1.63 million doses of Moderna's COVID‑19 vaccine after 'foreign materials'/contaminant reports were found in some vials (batch recalls/inspections).",
      "date": "2021-08-25 00:00:00"
    },
    {
      "id": "7eeb196f-3cdf-49d7-a679-20612e8b96a5",
      "text": "Federal judge ordered the U.S. FDA to accelerate public release of internal documents related to Pfizer's COVID‑19 vaccine (court‑ordered accelerated disclosure ruling).",
      "date": "2022-01-07 00:00:00"
    },
    {
      "id": "9c4c835c-6721-41e1-bb6a-bdd9ff475b95",
      "text": "Publication of an Israeli health‑system study (NEJM, Oct 6, 2021) reporting higher incidence of myocarditis among males 16–29 after BNT162b2 (Pfizer) vaccination, with most cases mild or moderate.",
      "date": "2021-10-06 00:00:00"
    },
    {
      "id": "3b7e99b7-3b5d-4a57-96b9-059447a7b364",
      "text": "Ukrainian adviser says counteroffensive is months behind because of slow Western arms deliveries",
      "date": "2023-10-17 00:00:00"
    },
    {
      "id": "b30a505a-f1d5-4f10-b0ab-5bb234feccb8",
      "text": "Analyses warn Western help for Ukraine may diminish due to production and political limits",
      "date": "2023-09-21 00:00:00"
    },
    {
      "id": "bcdfb634-b57d-45e3-872b-b9f0ca36fafb",
      "text": "UN Security Council briefings raise concerns about diversion and proliferation of weapons sent to Ukraine",
      "date": "2023-05-18 00:00:00"
    },
    {
      "id": "93e3db06-166b-4430-8d6e-e05b9cbfc593",
      "text": "EU admits it will miss target to supply Ukraine with one million artillery shells",
      "date": "2023-11-14 00:00:00"
    },
    {
      "id": "6d58abe6-7936-49a0-ad10-40cde093f941",
      "text": "Countries reimposing or tightening lockdowns despite earlier measures (e.g., Israel second lockdown September 2020)",
      "date": "2020-09-18 00:00:00"
    },
    {
      "id": "a5716227-cc2d-487c-b4e1-90631c2bd7b7",
      "text": "WHO interim guidance on mask use that did not recommend universal mask-wearing for healthy people (interim guidance)",
      "date": "2020-03-19 00:00:00"
    },
    {
      "id": "23af19b4-6fa3-4db4-aed8-de51c0424a7d",
      "text": "Great Barrington Declaration advocating 'focused protection' instead of lockdowns",
      "date": "2020-10-04 00:00:00"
    },
    {
      "id": "7594a110-7e80-429d-b658-24df2a302bad",
      "text": "Sweden's no-lockdown approach widely publicized",
      "date": "2020-03-30 00:00:00"
    },
    {
      "id": "8cbfae15-d083-4bb6-b577-bef32055b97c",
      "text": "CDC recommendation for cloth face coverings in public (policy change)",
      "date": "2020-04-03 00:00:00"
    },
    {
      "id": "fd9efe20-ee65-47ea-9fe4-4e89ddd86750",
      "text": "Ukrainian authorities move to redeploy ships/hovercraft and increase patrols in the Sea of Azov (reported August–September 2018)",
      "date": "2018-08-12 00:00:00"
    },
    {
      "id": "4925b3b4-190f-4834-b9cc-c5c3b0a387cd",
      "text": "Kerch (Crimea) bridge opening and its reported impact on navigation to Azov ports",
      "date": "2018-05-15 00:00:00"
    },
    {
      "id": "638706de-f7d7-43e0-8478-a9ffc03ae9b6",
      "text": "Public recall and investigation of foreign particles (stainless steel/black particles) found in some Moderna vaccine vials in Japan",
      "date": "2021-09-24 00:00:00"
    },
    {
      "id": "63271fe9-df41-4ee1-841b-3153cb7da6d5",
      "text": "Pfizer–BioNTech and Moderna vaccine efficacy announcements showing ~90-95% protection in trials (Nov 2020)",
      "date": "2020-11-09 00:00:00"
    },
    {
      "id": "9d10ef81-f6a2-4e49-a199-c1555635e9d8",
      "text": "Large cohort study showing robust neutralizing antibodies to SARS-CoV-2 persist for several months after infection (Wajnberg et al., Science)",
      "date": "2020-12-24 00:00:00"
    },
    {
      "id": "fa25748d-926a-44e1-8ddd-e4885b098639",
      "text": "Arrests and terrorism charges against Crimean Tatars by Russian authorities",
      "date": "None"
    },
    {
      "id": "0933da37-3475-4bcd-bbeb-bc4ec55f9176",
      "text": "Ukrainian President Petro Poroshenko publicly vows to 'retake' Crimea / 'de-occupy' the peninsula",
      "date": "2014-06-24 00:00:00"
    },
    {
      "id": "43f60add-d506-4911-8c3b-d18bfa4b5016",
      "text": "Repeated legal actions and arrests of high-profile alternative practitioners (example: Harry Hoxsey prosecuted repeatedly for practicing without a license, 1920s–1950s)",
      "date": "2026-04-24 14:26:33.419932"
    },
    {
      "id": "1544928a-effc-4c44-a675-e0ccd8e8deed",
      "text": "Air New Zealand suspended its Auckland–Buenos Aires service during the COVID-19 period (service brought forward in March 2020)",
      "date": "2020-03-18 00:00:00"
    },
    {
      "id": "d31b6f35-3e22-4748-bfc3-2024cf70804d",
      "text": "CDC filed and was assigned patents on coronavirus isolates/genomic sequences (e.g., patent US7220852B1).",
      "date": "2007-04-24 00:00:00"
    },
    {
      "id": "e61b3736-c4de-40d8-8d91-d554ea3d8b2d",
      "text": "Widespread availability and consumer use of over‑the‑counter vitamin C supplements (NIH/Oregon State fact sheets documenting common use and safety perceptions)",
      "date": "2019-04-24 00:00:00"
    },
    {
      "id": "d05e54c9-b82c-42fb-95bf-184ccbc4a4ed",
      "text": "Parliament vote to repeal the 2012 language law (February 2014) following the Maidan changes.",
      "date": "2014-02-23 00:00:00"
    },
    {
      "id": "023a2ca0-6acc-4354-870f-1e990d38e0fc",
      "text": "Adoption of the Kivalov–Kolesnichenko language law in July 2012 (Law on the Principles of State Language Policy).",
      "date": "2012-07-03 00:00:00"
    },
    {
      "id": "0751e686-1dba-4c04-87b2-2f60c4f1b69a",
      "text": "Introduction and entry into force of Ukrainian-language content quotas for radio and media beginning in 2016 (e.g., Ukrainian music quotas on radio adopted Nov 2016).",
      "date": "2016-11-08 00:00:00"
    },
    {
      "id": "fbeda688-b4df-4b53-a93d-d39c1dd97036",
      "text": "Ukraine's 1996 Constitution declares Ukrainian the state language.",
      "date": "1996-06-28 00:00:00"
    },
    {
      "id": "8cdde93c-a746-45b9-8205-898c4d500b29",
      "text": "Visible nationalist rhetoric and high public sensitivity in Lviv and Western Ukraine during the Euromaidan/early‑2014 period (local protests, symbolic actions by nationalist groups).",
      "date": "None"
    },
    {
      "id": "1d947b67-af0d-4867-8813-556d0f253bd8",
      "text": "Systematic review (Farsalinos et al.) published April 2020 summarizing multiple Chinese hospitalized case series and noting lower prevalence of current smokers among COVID-19 patients.",
      "date": "2020-04-24 00:00:00"
    },
    {
      "id": "84969761-5489-4b13-af7f-07a03d61a79f",
      "text": "Comptes Rendus paper by Changeux et al. ('A nicotinic hypothesis for Covid-19') proposing nicotine-receptor involvement and suggesting nicotine could have preventive or therapeutic implications (manuscript received 16 Apr; accepted 18 Apr 2020).",
      "date": "2020-04-18 00:00:00"
    },
    {
      "id": "5184abd3-903e-4c4a-b1ff-8197c81ef5af",
      "text": "Public reporting and official statistics showing very high vaccine uptake among older adults in the UK by early July 2021 (large majority of elderly vaccinated).",
      "date": "2021-07-01 00:00:00"
    },
    {
      "id": "149ba182-0084-4f85-90d7-0f84d73ce5fb",
      "text": "Ukrainian statements in late June warning that failure to stop Russian aggression risks broader geopolitical consequences (coverage in Ukrainian press)",
      "date": "2022-06-26 00:00:00"
    },
    {
      "id": "b3395c9b-a855-4632-996a-a6880f01d05a",
      "text": "Regulatory safety updates and post‑authorization adverse‑event summaries published by national agencies in June 2021 (compiled safety figures made public)",
      "date": "2021-06-11 00:00:00"
    },
    {
      "id": "2d9d5a49-133f-4abc-9974-c9e6da8ea584",
      "text": "Publication of Israeli real‑world vaccine effectiveness analyses estimating infections, hospitalisations and deaths averted by the national vaccination campaign",
      "date": "2021-04-24 00:00:00"
    },
    {
      "id": "c9602f84-6cfc-428e-a39a-1e39f3036e63",
      "text": "U.S. Fish and Wildlife Service listed polar bears as 'threatened' under the Endangered Species Act (ESA)",
      "date": "2008-05-15 00:00:00"
    },
    {
      "id": "039043c9-c57b-4e89-ba4a-d25747c93f7d",
      "text": "Record-low Arctic sea ice minimum in September 2012 reported by NSIDC (new modern-era low extent)",
      "date": "2012-09-24 00:00:00"
    },
    {
      "id": "6d93bf25-6d63-4bb6-a61c-e45006074172",
      "text": "Natalie Jaresko was granted Ukrainian citizenship and appointed Minister of Finance in Poroshenko’s new cabinet.",
      "date": "2014-12-02 00:00:00"
    },
    {
      "id": "fa2b9915-d0fa-4520-ae95-970cb5f1f2be",
      "text": "Kateryna Yushchenko (wife of former President Viktor Yushchenko) is publicly known to be American-born (born in Chicago).",
      "date": "None"
    },
    {
      "id": "6c40ede5-fef0-46a2-bc20-6d2a842bfe85",
      "text": "Reporting that Ukrainian authorities and units were struggling to vet, equip and deploy newly arrived foreign fighters.",
      "date": "2022-03-07 00:00:00"
    },
    {
      "id": "d0f7b228-5da3-499d-ba68-8e855018863d",
      "text": "Ukrainian president announces creation of an \"International Legion\" and publicly appeals for foreign volunteers.",
      "date": "2022-02-27 00:00:00"
    },
    {
      "id": "6a6ef44f-4724-4794-aed6-454d1bb76673",
      "text": "Analyses and warnings about the presence of extremist and fringe foreign volunteers (scholarly/think‑tank reporting noting far-right and other fringe actors among some volunteers).",
      "date": "2022-06-24 00:00:00"
    },
    {
      "id": "c8580ed9-0a2e-4ce0-b659-b31678de8084",
      "text": "German industry and officials warned that proposed U.S. sanctions (and pressure) risked harming projects such as the Nord Stream 2 pipeline",
      "date": "2018-04-24 00:00:00"
    },
    {
      "id": "ec856f56-f10f-4dbb-a15b-27af935ffb06",
      "text": "German Foreign Minister Sigmar Gabriel said sanctions on Russia could be eased if there is progress on implementing the Minsk agreements",
      "date": "2018-02-17 00:00:00"
    },
    {
      "id": "ba6da7d6-7796-4008-a2b0-f496bf1d045a",
      "text": "Chancellor Angela Merkel publicly urged dialogue with Russia after Vladimir Putin's 2018 re-election",
      "date": "2018-03-20 00:00:00"
    }
  ],
  "claim_clusters": [
    {
      "cluster_id": "4afb1f4b-4686-4338-bf49-bdd4d2091f0a",
      "members": [
        "2dd13f4f-6426-4ac8-bd65-7ffb771370ad"
      ]
    },
    {
      "cluster_id": "d7e9e6ed-b598-46a7-b7ea-6197df41d3ad",
      "members": [
        "f8b55df6-b25d-46c9-8f4f-c5c18799922d"
      ]
    },
    {
      "cluster_id": "9d2cc997-e857-4b80-a227-cc6a1c61d16d",
      "members": [
        "6699828d-fb58-4517-baf8-bd0a114db78f"
      ]
    },
    {
      "cluster_id": "5b34f4e8-867e-44ea-b5c2-c5295a09dd5e",
      "members": [
        "e27cdb49-5cc6-4d83-b740-fed69da1a64a"
      ]
    },
    {
      "cluster_id": "854e712a-9c33-4e4e-be9f-d9dd40fa0112",
      "members": [
        "fbade069-95a0-4972-bade-52d4ac0638d8"
      ]
    },
    {
      "cluster_id": "5d4f6733-5fbd-48ce-8468-590ebda279c7",
      "members": [
        "a3c090d0-0f8c-4dbd-aa26-87ca72378ff7"
      ]
    },
    {
      "cluster_id": "de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe",
      "members": [
        "d6814ea5-c714-48f3-818f-cdcb5b6381e0"
      ]
    },
    {
      "cluster_id": "2ea5d498-58e2-44a4-a51a-95bda7047686",
      "members": [
        "30728e5f-3db1-4c1c-befe-fbd1f7103a82",
        "14f6527d-67cc-4960-8e60-bf244deff220"
      ]
    },
    {
      "cluster_id": "6f3f0719-064d-478a-ae5f-d9aca0368d4e",
      "members": [
        "8d8470bd-ad2d-4dd4-adf5-eba8481b1e3a"
      ]
    },
    {
      "cluster_id": "a5210919-ca86-4673-97e1-5b03ea7de143",
      "members": [
        "4de477ea-5b7b-45a2-be59-cf9bec7b2733"
      ]
    },
    {
      "cluster_id": "76bc71d7-2c17-42b9-974c-d517911bab56",
      "members": [
        "3e5ff83b-0092-4c6a-b1d4-b3d8665c952a"
      ]
    },
    {
      "cluster_id": "f1afc4d0-4eaa-40ab-99e6-20e11c550ccb",
      "members": [
        "bdc1437f-ed3b-4d98-b2c1-38d4365c70e6",
        "0d4df62b-b694-4ca9-9337-0c8818b221ff",
        "007d3cbd-daea-4b58-be01-f7c97d00c088",
        "3936ffc9-8f11-4f63-9703-b7ede8f9de85"
      ]
    },
    {
      "cluster_id": "601320a2-3fca-41ef-9387-a64a4c0b5cee",
      "members": [
        "d8d7bab0-1ed1-4bdf-8ccb-706d4da8ae8d",
        "d9870079-2f16-4d1a-931b-bda57bea23e9"
      ]
    },
    {
      "cluster_id": "478db2a7-a90d-4fbf-8954-0416daa97dcb",
      "members": [
        "29d4d54d-b45f-428f-9434-a2dbdbf76fdf"
      ]
    },
    {
      "cluster_id": "a222dd36-fddd-41d8-956d-d735c7c4c6bb",
      "members": [
        "0424510d-cbfe-45c9-b03c-be316dbc1185"
      ]
    },
    {
      "cluster_id": "c39e0166-c55b-4f71-8bb5-e23985802606",
      "members": [
        "3e01682a-99db-4588-812c-77898c084078"
      ]
    },
    {
      "cluster_id": "8afc9e85-7241-4e3e-a1d2-c084e17d6f92",
      "members": [
        "735326d8-274b-43f4-bede-c04b3f51ff7b",
        "1146bc76-1dfa-4bdd-a2d7-a97508b0ea72"
      ]
    },
    {
      "cluster_id": "bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c",
      "members": [
        "57794fdf-6b32-4749-8b39-f7099cf8b282",
        "d5dd2789-974b-4cac-84f8-12d91fe6053c"
      ]
    },
    {
      "cluster_id": "b40ccc38-63a5-4a58-8bbb-6242768fb158",
      "members": [
        "255a4d2c-14ee-4bb3-88c2-3d03d8e031cf",
        "b4889e7f-f86a-4fb9-819f-ef05968c529c"
      ]
    },
    {
      "cluster_id": "6f9a5f86-ba12-43df-aa33-746615605f47",
      "members": [
        "3026b8de-985a-42c8-9ae3-d374746eedcc"
      ]
    },
    {
      "cluster_id": "24a2e46d-b5a2-4677-a613-c39e311e8f1d",
      "members": [
        "1d8fae5b-ecc0-45be-ab13-eac5e4e79825"
      ]
    },
    {
      "cluster_id": "bf01755f-02c0-4092-8a9f-ea50ff0a213d",
      "members": [
        "633ba20e-618f-46e5-ae02-75a3ffa9d1d7"
      ]
    },
    {
      "cluster_id": "9d400cbf-08ea-4c02-941a-80cd2d3e517a",
      "members": [
        "ab0f775b-320d-44f7-ae2e-848211e10868"
      ]
    },
    {
      "cluster_id": "0c685bcc-0513-4b5c-8ba7-c302c985ff66",
      "members": [
        "2361b0b7-d4fb-48be-a1a3-3f8003756366",
        "0be7d364-75a2-4715-bfe6-b1ad97691bb5",
        "fdd99a5d-dc39-4dd3-b1be-3a0f181eada2"
      ]
    },
    {
      "cluster_id": "576d103a-5318-4b16-9313-434ff03a385d",
      "members": [
        "9d2a365a-6c46-411b-969d-d47a368e94ee"
      ]
    },
    {
      "cluster_id": "3e200fec-9dad-4a2e-a5e4-655848ec7983",
      "members": [
        "f00ef639-900e-41c6-8781-9b27223d4353"
      ]
    },
    {
      "cluster_id": "bfd3bb04-3c5a-410a-b26b-81f569186264",
      "members": [
        "7eb3a987-b322-44d2-b3d6-28c94d19b5d2"
      ]
    },
    {
      "cluster_id": "b0c0fbc8-3a87-4290-a45f-69e062e04cee",
      "members": [
        "2dea096c-fd10-4480-803d-899cf695c6f5"
      ]
    },
    {
      "cluster_id": "7b68c402-465e-4abb-ac74-c3e397c8afdd",
      "members": [
        "c83fc427-5b49-4136-ac63-a6e82c9a6e68"
      ]
    },
    {
      "cluster_id": "98a97f12-7d1b-49e9-8178-578b2d656f88",
      "members": [
        "25e64931-13f1-49ca-bc59-c9b3ea3df04a"
      ]
    },
    {
      "cluster_id": "17c8775c-7a3a-4607-aa7f-5b24078a17f8",
      "members": [
        "ac7a6f3c-0121-4422-b49f-f6891df024f0"
      ]
    },
    {
      "cluster_id": "df5cc82a-7ab7-41f6-8eae-c3445a8c7a05",
      "members": [
        "5d4a7f9d-370a-43f6-90d8-da41fa28b5bd"
      ]
    },
    {
      "cluster_id": "5d21e7b3-dd0e-453e-8871-eb57102f00e7",
      "members": [
        "3f39fca1-a59d-4b69-90c6-21f814dc1270",
        "216aea1c-b87f-4e12-be73-6f1d3ccdd66e"
      ]
    },
    {
      "cluster_id": "51218502-220c-4467-8b26-b12d809fed98",
      "members": [
        "a4ec243a-71a4-4609-9a28-20d5f55f2c22"
      ]
    },
    {
      "cluster_id": "96b36beb-a890-402f-9101-7aa7236863f1",
      "members": [
        "dd4e8c50-a762-41da-9994-99bdacd1c496"
      ]
    },
    {
      "cluster_id": "bf1e5943-1881-4795-9e54-b7177a49b67f",
      "members": [
        "6eb1ba10-7e64-4410-8b77-b1f6131ff9d4"
      ]
    },
    {
      "cluster_id": "dcbf5711-b1d2-4a7c-96f6-e8916f52c752",
      "members": [
        "38e14696-6be8-4733-897c-92ef59e9e984"
      ]
    },
    {
      "cluster_id": "6aa59122-6821-4e76-8afb-2ad2b679a5aa",
      "members": [
        "f3ebd398-1ed0-4277-a8e8-14809c410ad5"
      ]
    },
    {
      "cluster_id": "2e1084b1-c7f9-4543-8153-a6c840adb565",
      "members": [
        "938f6495-4d57-4ad6-94ce-863e8c50767c",
        "8f8edbb5-e9e4-475e-90be-05f42d84a1a4",
        "c73cc4c2-ee3a-40b7-aebb-35016faadea0",
        "5562da73-c4f7-47a9-913d-2c215d69d25f"
      ]
    },
    {
      "cluster_id": "43c40092-a570-4909-9a7c-2090f95182b4",
      "members": [
        "ff5ceed9-e757-4049-9059-07cabd2cf427"
      ]
    },
    {
      "cluster_id": "a6ed0ce8-662a-4b6a-bb37-1ea2a020377f",
      "members": [
        "75b46fa0-cd0c-47a1-ab63-254ba2048ab1"
      ]
    },
    {
      "cluster_id": "7fb4d786-0c9f-4d33-a3fb-8326f548d1e1",
      "members": [
        "b24a8a34-1afb-4438-a723-682fc5881418"
      ]
    },
    {
      "cluster_id": "a9555cd5-7b65-4e84-9f89-ed03117c7e50",
      "members": [
        "85054e1d-aaca-4e4b-a973-d45747596c08"
      ]
    },
    {
      "cluster_id": "9ca308d7-59f5-4df0-a87b-383b8575c88a",
      "members": [
        "72b56f8d-ad65-499b-a35f-204e110ed4f9"
      ]
    },
    {
      "cluster_id": "947a0b8b-01e0-44c9-8ebc-c9da3eecde20",
      "members": [
        "67c33492-0941-478a-b43b-9c6c098446b3"
      ]
    },
    {
      "cluster_id": "260b5cb2-3dad-42a1-a677-cfe24a203765",
      "members": [
        "14495f04-0a36-463e-8cac-99aaad053837",
        "41c44f05-82ce-4b19-a650-b156f05efa75"
      ]
    },
    {
      "cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "members": [
        "f5ef64d6-4fc0-47d8-82b5-1d1453009204",
        "427063bc-a537-4e80-a198-25b80179f288",
        "f3fc68de-4d62-44bb-b25b-67ca2e4c5aff",
        "1b4a2485-6962-4b36-8c3c-da83d1b18b70"
      ]
    },
    {
      "cluster_id": "ab24b6cb-fc70-48c9-8ee3-224b83a66b11",
      "members": [
        "f3805476-152f-4654-8435-8e4eda6f5ca1",
        "ec947ed8-cc30-4eaf-8c9b-b928ea7c0068"
      ]
    },
    {
      "cluster_id": "62d8fa29-aaab-4f66-9532-5fb34686e56f",
      "members": [
        "6f4ce223-338f-4a9d-86ba-d7426feb6a92"
      ]
    },
    {
      "cluster_id": "d1c29947-a7e4-41cf-9656-837e51b2de11",
      "members": [
        "16b242fa-af97-47e6-8018-f63b40206b6d"
      ]
    },
    {
      "cluster_id": "a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0",
      "members": [
        "a716ca45-b87f-4206-a22b-5e39e95ad953",
        "7ee5a1fa-d164-4c90-a9aa-bf34d284a6bc",
        "e5422914-be7b-4e48-a015-d663782e09ff"
      ]
    },
    {
      "cluster_id": "33d1d4f9-5c45-44c0-8055-973e47d10907",
      "members": [
        "eae4b366-03da-41ec-a57a-cdebad1dee6f"
      ]
    },
    {
      "cluster_id": "15f89230-b855-41bc-bc6f-7a68ea38aff0",
      "members": [
        "55cdc9d6-c77c-4770-86bf-4cdba85c8b07",
        "9344c21f-e46e-492f-bab2-16d7ac5170ec"
      ]
    },
    {
      "cluster_id": "767386e5-6b6b-4b02-8200-421222dc2720",
      "members": [
        "4d14b98b-05d6-4e63-a6ba-271d2f3cce83"
      ]
    },
    {
      "cluster_id": "8610b5a0-f4b4-403e-94e5-57543da5eb32",
      "members": [
        "99f1aea2-02cf-4c31-88f9-42d9a3852e82"
      ]
    },
    {
      "cluster_id": "2bc0b07d-c668-4651-b1c3-1844786b5acb",
      "members": [
        "48a13c83-219f-4cd9-b810-08909a8bf658"
      ]
    },
    {
      "cluster_id": "666eb0cd-c596-43b7-a4bb-b7f35efd20da",
      "members": [
        "83d96580-7bb0-4e87-89df-9c881df71f99"
      ]
    },
    {
      "cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "members": [
        "1fcaf67b-c9d4-4a01-84e7-ca7f4a7e821b",
        "7239e2a8-d011-4bfb-8aed-0a709402fe71",
        "e0a5f231-75c6-437e-9eb2-f531cff87bb7",
        "88a9b2a2-df3c-4e15-b439-11ecdb30f599"
      ]
    },
    {
      "cluster_id": "f2363c7c-72d1-4e3a-b724-27c1d218c5fc",
      "members": [
        "f4764696-2605-4a43-b5a6-6bbf1d924003"
      ]
    },
    {
      "cluster_id": "e8e14c71-2e64-412a-8769-000c5cda92ce",
      "members": [
        "a5abfd89-4a0f-415f-aaf0-91910c09c87c"
      ]
    },
    {
      "cluster_id": "76a80e87-389e-4e6e-9595-1b220839fd20",
      "members": [
        "33680438-c7ab-4fcd-a771-3945d3bef0f7"
      ]
    },
    {
      "cluster_id": "aea747b1-1cb4-4b3d-94df-5c33181b0976",
      "members": [
        "a3b34be8-6b96-4f4e-a354-cc5b2da887d5"
      ]
    },
    {
      "cluster_id": "dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e",
      "members": [
        "6d400d4d-0b03-4ed8-be63-42efcf94ad65"
      ]
    },
    {
      "cluster_id": "70534501-50ea-4dc4-9324-20539116bcb4",
      "members": [
        "c3634205-e3fe-4f6e-9305-71a997a86f33"
      ]
    },
    {
      "cluster_id": "2a9019de-d820-4155-a78b-fc972ec57552",
      "members": [
        "e22c321d-c58f-4c33-bf80-69feae1815b9",
        "f22dd4d4-244c-40ed-8a4a-66bbd3e6650c"
      ]
    },
    {
      "cluster_id": "144a5089-d891-40d6-b31c-9c5381bee1d5",
      "members": [
        "24666e81-30f7-49a8-859c-d475e369c574"
      ]
    },
    {
      "cluster_id": "03ac5e38-07fa-4023-b9bd-bdfc9810ba0c",
      "members": [
        "014c9faf-7ab9-40e4-b5e2-ab52af450862"
      ]
    },
    {
      "cluster_id": "7938e6ef-80ff-4f50-b301-1e5bfc0774b3",
      "members": [
        "421e076f-843a-48a5-9a05-70bd6ce8be1f"
      ]
    },
    {
      "cluster_id": "29d5756f-2c13-4cfb-b4e4-f439665752b9",
      "members": [
        "1774fac9-00c5-4fe7-b984-d6e29f173b3b",
        "26523ffa-fb97-4562-ac10-420a038c9930"
      ]
    },
    {
      "cluster_id": "b39e93e4-b791-4b1e-963b-d8f068ff0b1d",
      "members": [
        "9980c0d2-1404-49fb-a64d-b383664e39f9"
      ]
    },
    {
      "cluster_id": "36d5c8e6-5870-44de-bee8-1ba3638e2785",
      "members": [
        "a4765b18-7063-46d8-81d8-8476b2372331",
        "32156e6d-316c-4228-b1bb-e4431b9f63e2",
        "bf65226e-9669-4774-9ef3-570fbefeee38",
        "14cb414f-ab88-4bba-a113-ee4dd72a7f1c"
      ]
    },
    {
      "cluster_id": "d65c0d37-123c-4e39-9b2d-386613952a30",
      "members": [
        "9658b913-ceca-47ae-aad5-58877e1f4129"
      ]
    },
    {
      "cluster_id": "71baf4d7-69f3-4524-9166-04fc35b4043a",
      "members": [
        "48a2defa-2a7d-41ab-9978-ec2d542176bb"
      ]
    },
    {
      "cluster_id": "10cadbd2-7261-4295-9f88-df0f9a246b5b",
      "members": [
        "6c59ffd2-ce73-48cc-a300-744f6681f391"
      ]
    },
    {
      "cluster_id": "f6a4aea6-92b4-4a70-a984-2326df1ee39e",
      "members": [
        "1b076485-e52c-4e15-83fa-3b97314161ad"
      ]
    },
    {
      "cluster_id": "8a0c21a3-b47c-4676-b965-59f7699171ec",
      "members": [
        "ff7ee790-b265-4df5-ac00-39ccfe0170f0"
      ]
    },
    {
      "cluster_id": "93fddae5-a739-409c-a087-9a562d010a0e",
      "members": [
        "008054d1-a07f-451e-803b-c9fb1c433e4c",
        "54d4d5f8-b5e7-4362-ac10-def756c33689"
      ]
    },
    {
      "cluster_id": "c6c8d065-8cfe-4224-9bcc-58df52f1a712",
      "members": [
        "6370015a-2183-4030-a2df-2b7769299fb2"
      ]
    },
    {
      "cluster_id": "4e78b61e-317a-4417-b42d-464646384193",
      "members": [
        "1d0f2284-348e-4c83-8ce5-00731b733baa",
        "3318f9ef-2c09-4485-ba0e-7a99ab035874"
      ]
    },
    {
      "cluster_id": "e60065d4-ae50-40b0-8e77-8c2ad3e36235",
      "members": [
        "ee91da76-0c5f-40ba-9880-7e2b3cab4d92"
      ]
    },
    {
      "cluster_id": "2c2bd0f0-92f2-446c-bfc2-4cf2ec4f5ece",
      "members": [
        "488db398-b0e9-4d0f-b7a9-a7c9ae9505db"
      ]
    },
    {
      "cluster_id": "a7043201-daf7-4ddc-86e1-fe3a850942e2",
      "members": [
        "f3faae8f-983b-4e63-9882-f25a25683959"
      ]
    },
    {
      "cluster_id": "7b49f746-2118-4c08-9ef0-985906af7b07",
      "members": [
        "6fd5984d-f566-40fc-bdf1-dd1142fcf39e",
        "6ded1b12-376a-4451-8314-cf0630d9ad4b"
      ]
    },
    {
      "cluster_id": "b4295bad-3940-4b00-ac2b-862c41b5597c",
      "members": [
        "8ffe5fea-1c1a-4af2-8604-de9174b2b2ff"
      ]
    },
    {
      "cluster_id": "371b7329-3c6e-4297-b746-d77ae2db1f6f",
      "members": [
        "2a41015f-41b6-462b-9def-77dfe9cc7087"
      ]
    },
    {
      "cluster_id": "9560d5ee-30e3-4941-88b8-e0b5144961cb",
      "members": [
        "405b64fa-d3ac-4ec7-8bfb-15796d682cda"
      ]
    },
    {
      "cluster_id": "4bec7fa9-99e9-4a5a-aa9f-74f019f54fe8",
      "members": [
        "fc3a68ed-50cd-4532-b10b-94792d272195"
      ]
    },
    {
      "cluster_id": "4d4a5a78-bde2-4ed8-943c-811738978e0d",
      "members": [
        "a2ba5697-2b9f-4b17-888e-0069ad71ff63"
      ]
    },
    {
      "cluster_id": "05638bd6-42ef-4049-b6f6-4a5478e7b8a5",
      "members": [
        "e627a037-1cb0-4aaa-bf67-beaaca0ccfd3"
      ]
    },
    {
      "cluster_id": "907c652a-92b6-4282-8b7b-0e7b268d4209",
      "members": [
        "2625714f-905e-4ecf-8b4a-09b9f0b7d704"
      ]
    },
    {
      "cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "members": [
        "8769ff38-1ce9-49aa-a968-179abff90664",
        "34260db7-2ee9-4791-8c3a-2850e0eb9f7c",
        "9d59eafd-dac1-4668-b3a4-5267c5102263",
        "b860c9a3-51aa-4ed0-8d64-fa0098aca589",
        "08ae05df-a1ec-493c-9222-3436a91c88e6",
        "241a075b-b47b-4cdb-a812-edbf0a89feff",
        "1e091d8f-eedd-4c4a-b128-1d8c08550b36"
      ]
    },
    {
      "cluster_id": "c14aacf1-2f99-4e9a-ba35-1511bf4fd104",
      "members": [
        "3090ccd7-4429-4282-b507-a1d1ef4630a5"
      ]
    },
    {
      "cluster_id": "70898fa9-9960-49d5-b422-3f77d073d86b",
      "members": [
        "44024130-7111-4965-ba3b-ba55689def86"
      ]
    },
    {
      "cluster_id": "f4f83538-936e-4149-94c2-66b6b2ac2571",
      "members": [
        "36e7cc9a-2789-4d66-a2dc-cef8cae9c4de"
      ]
    },
    {
      "cluster_id": "a5124b94-6b98-447d-9c53-5100339210c5",
      "members": [
        "15ed79b6-2eb9-4164-a1a4-467f9b7b0b06"
      ]
    },
    {
      "cluster_id": "9a73096a-390b-4f9e-a044-22f30734ce69",
      "members": [
        "0ef16c5a-76af-4d0e-9da7-79552051db26"
      ]
    },
    {
      "cluster_id": "7ad2c49a-5636-41a0-bf37-19bfc98916c1",
      "members": [
        "369e2eec-1aad-41d6-b4db-37834e7e576d"
      ]
    },
    {
      "cluster_id": "9b14cd61-494b-4ae7-a7c2-3720adae8787",
      "members": [
        "9e50f9b4-d7de-478f-b73b-ceb97b2f3b49"
      ]
    },
    {
      "cluster_id": "f83f6c15-13c0-41a8-b991-8abeda0466c4",
      "members": [
        "5ea10b5d-ae66-41c8-9896-2456985b0a16",
        "22cddca1-b8a5-487a-9a1d-e468a1090200",
        "e71a3ce7-7f1e-43f3-8da6-a130a2789a80"
      ]
    },
    {
      "cluster_id": "54d52770-613a-47b1-aa64-0743cb644791",
      "members": [
        "fe1308fc-cebd-446f-aa58-03dfcd2677b7"
      ]
    },
    {
      "cluster_id": "6f847ace-00e0-4009-b5e9-3729f7a9e244",
      "members": [
        "8c5c9816-2706-4384-90ec-5e9bbe788a7c"
      ]
    },
    {
      "cluster_id": "2a0a6106-78d5-46ad-ad52-e0296bf7134a",
      "members": [
        "5f2a5eee-de1d-4f97-b32f-6c009a0199c8"
      ]
    },
    {
      "cluster_id": "59f595d5-6ff2-4686-81ce-6150bd29db9d",
      "members": [
        "8a041bee-f597-4ec5-90d6-abe85921d8c7"
      ]
    },
    {
      "cluster_id": "fa530a1e-4be0-417c-bd45-2254a93d2324",
      "members": [
        "32295a18-4d4a-4a8f-9ee2-2ac75da02623"
      ]
    },
    {
      "cluster_id": "273554c2-556d-4017-8422-f543fd17c4ef",
      "members": [
        "e33a6869-5d82-49ac-9098-dfa14bf71c71"
      ]
    },
    {
      "cluster_id": "859c814e-e7af-4708-a58a-9f1f6973974f",
      "members": [
        "a9197e3e-a551-405a-bb28-fb13d389a62a"
      ]
    },
    {
      "cluster_id": "407486e4-c133-4139-9739-41644f65fa24",
      "members": [
        "96970192-557a-4f02-91be-828d023f6d42"
      ]
    },
    {
      "cluster_id": "346be717-a4b3-4210-bff0-be972806b6a4",
      "members": [
        "941aa92b-0585-4e26-a11e-56729498c38d"
      ]
    },
    {
      "cluster_id": "6719c4cd-0e09-4c15-af9e-7f2bffedb3e3",
      "members": [
        "8503fdc1-5827-4df0-996b-b712232be44c"
      ]
    },
    {
      "cluster_id": "fece6aa3-8787-449b-8b29-7c6c4bb28cc4",
      "members": [
        "ed0e3090-b70a-4b95-a165-cff164f8ad3c"
      ]
    },
    {
      "cluster_id": "d392695f-75b7-4bbc-a991-2b3edbf01567",
      "members": [
        "31568ed6-d43c-4f68-b1e8-de4e1a916858"
      ]
    },
    {
      "cluster_id": "957456fe-cb84-4fb9-bc2f-3e775154a824",
      "members": [
        "133f7d66-3c77-4da3-9b55-5fb9bdbf0e5c"
      ]
    },
    {
      "cluster_id": "7811b1ac-b0e5-4c92-a933-500f6b892437",
      "members": [
        "2939a802-435b-45e7-9b5c-c5d0ac1ea5ef"
      ]
    },
    {
      "cluster_id": "22874c8a-79fa-491a-a46f-cd92202bb1de",
      "members": [
        "0fac4e8a-db01-48e8-8e45-430e582f167b"
      ]
    },
    {
      "cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "members": [
        "5f0a5b6e-bda8-4624-a3b2-e9f281dbdf4d",
        "1f726340-0f86-4d17-97d6-78a6f17df1a9",
        "b42f4cb2-3538-4752-bdb5-ef52a30c50cc"
      ]
    },
    {
      "cluster_id": "0407f887-a8ce-4c09-bc8f-570e66bd3e6b",
      "members": [
        "17e194a6-e388-46fd-9679-5eef686c73e5"
      ]
    },
    {
      "cluster_id": "58a60e5c-9e5a-48ce-a07c-a7168b46ba2f",
      "members": [
        "cdde802e-a707-4b79-b972-73d645632c9d"
      ]
    },
    {
      "cluster_id": "83965363-a851-4083-ae10-33f90da464da",
      "members": [
        "36b55499-9dde-45d0-8026-de7b1be48c8a"
      ]
    },
    {
      "cluster_id": "1e099dec-1be9-48be-a1bc-00d89e3cc02f",
      "members": [
        "4d999f2d-af0b-4fb3-beeb-e7dbedb25424"
      ]
    },
    {
      "cluster_id": "e1c12b4b-138d-4ddc-9b6c-49a0a9de18b9",
      "members": [
        "258dfc02-dfdf-47ae-a212-a94fe1bd2b3f"
      ]
    },
    {
      "cluster_id": "03db723a-dcac-4e7f-b456-18c0fdfdba8d",
      "members": [
        "8bf3adb8-0a8a-4311-8668-c3f1ced00528",
        "c632fe7b-c702-4532-8547-784867df7f95"
      ]
    },
    {
      "cluster_id": "a03d3de9-e5ad-47e0-9374-17e6c1998859",
      "members": [
        "6b07104c-66a7-4e14-9a76-a4b097a9082f"
      ]
    },
    {
      "cluster_id": "a0b96ee6-2ea9-4035-b542-1107b0662e77",
      "members": [
        "24ecdd06-3496-4652-9275-eaa3f5d1d57d",
        "2521adfa-8bda-42f8-bac6-02fbee2d28c5"
      ]
    },
    {
      "cluster_id": "c8a67d7e-6b5c-49cc-b944-ad699ac9cff0",
      "members": [
        "f4ccd130-a946-4cd9-acbe-d171042fa1cf",
        "07e8ef3c-b9bd-433f-9c12-4fbfc99e8481"
      ]
    },
    {
      "cluster_id": "cdb08998-bbe0-4530-9534-7744fb962961",
      "members": [
        "d37e60ce-d379-42d0-b2cd-4f1eced529f9"
      ]
    },
    {
      "cluster_id": "6950bc54-67bb-4e8e-b8cd-afd5c7d79d00",
      "members": [
        "65547e4c-1e4a-4a9f-8cea-498fa9a0a9ab"
      ]
    },
    {
      "cluster_id": "00e4e855-edbf-4846-a824-47a6b221930a",
      "members": [
        "9fd1f789-a0bb-4e1f-b049-836033524d91"
      ]
    },
    {
      "cluster_id": "71b86c5b-0ae0-46d5-a172-4da94679db3d",
      "members": [
        "030c7378-cdeb-4204-9fb5-c2d2a13eb381",
        "67e7e226-46eb-449a-b97b-11d2bb7990a4"
      ]
    },
    {
      "cluster_id": "8143472f-9ddf-4467-8402-c46a70ccaf1e",
      "members": [
        "32b326b4-cfe6-46b4-b072-bb631dc1a035",
        "f5ba79ec-ebb7-4b0b-b3d3-d8ef07952c7b"
      ]
    },
    {
      "cluster_id": "b473cdd9-7369-4866-a926-04d86eb03c52",
      "members": [
        "0f3f4f2a-f380-4606-a16a-f3f4a09b5cd3"
      ]
    },
    {
      "cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "members": [
        "94cf5bc4-3fec-4cb8-8682-39ab0c9e9fe8",
        "4d7b5e3d-682c-406e-84d1-1663d708b648"
      ]
    },
    {
      "cluster_id": "aed74a8c-a339-4a19-a144-bb62990f8e50",
      "members": [
        "2f0f76bf-5aab-4dcd-b7be-b080f0e53220",
        "a8f44394-f854-4c61-93e9-f08fa0649e2d"
      ]
    },
    {
      "cluster_id": "fc45a344-4cfc-4865-9030-d033f0c8dff3",
      "members": [
        "567f28dd-3ff7-4c5d-934f-c8951a7a3fc3",
        "350050bd-a85a-4627-9297-e06afeb9261c"
      ]
    },
    {
      "cluster_id": "60b71403-253c-4f7c-b96e-fb2306a7cebf",
      "members": [
        "f2d96131-771d-4235-8f08-f3459b6cdcaa",
        "3835bf8b-7501-4921-a504-e1f225fd8897"
      ]
    },
    {
      "cluster_id": "cb25f623-bfdb-42c7-9873-fa48f80feade",
      "members": [
        "d7ac50a3-5ec4-4aa1-84b4-24d20c65c879"
      ]
    },
    {
      "cluster_id": "77b557e0-b37f-4548-adca-2c9da9e04106",
      "members": [
        "b2f53ef8-1f48-4ce8-859a-e17b854f4683"
      ]
    },
    {
      "cluster_id": "596489a9-6207-48fb-8cf4-2972a01326d9",
      "members": [
        "e65f1db1-d1aa-4982-9c7c-ec7daf4c88f0"
      ]
    },
    {
      "cluster_id": "7698cb38-d25f-4849-ba30-99dd8e321533",
      "members": [
        "17259035-6c05-46e1-8f59-227f29b9c868"
      ]
    },
    {
      "cluster_id": "9769a072-502e-4c26-bce2-57d4532d25f3",
      "members": [
        "c5048780-7c72-4d06-92f0-0a9ca1febeb3"
      ]
    },
    {
      "cluster_id": "f0be01ea-d71b-4521-a52b-360c419bf286",
      "members": [
        "ac700103-fb9c-4fa3-8f17-e0d56a13ff26"
      ]
    },
    {
      "cluster_id": "62e8f214-855a-45b7-8de5-a667d22dd7f0",
      "members": [
        "c3ccf30f-859c-4953-ac43-46d07b1fceaf"
      ]
    },
    {
      "cluster_id": "98dac116-c6f6-46b8-945d-1ffe5cc5db7d",
      "members": [
        "e2969ce0-1fdd-4372-9690-7a254eda30c2",
        "132f6cc9-f538-4c83-9617-8e62245449fd"
      ]
    },
    {
      "cluster_id": "ca0d3bae-6f1d-4857-b362-c7e7718bca04",
      "members": [
        "697d695e-133f-4537-b15a-ada62b39e9ee",
        "c8544f91-d53f-4fcc-939c-fe97e55c2b45"
      ]
    },
    {
      "cluster_id": "338d5a8d-64c7-4bed-a37e-208196096015",
      "members": [
        "ffe65426-7493-4d0e-8c1b-da74a680ee17",
        "9179a5f8-b7f0-4e62-8586-1a710c219f83"
      ]
    },
    {
      "cluster_id": "ff92e2cd-b51d-4aba-9214-602e53d602c6",
      "members": [
        "6771039d-6c9f-4e75-84b1-565146a5b4b8",
        "93327c19-f8d6-4cdc-a139-dead675a14cb"
      ]
    },
    {
      "cluster_id": "d4dddb84-da14-4d5c-ac75-d999175b9558",
      "members": [
        "0a54c9e3-ab86-48a4-afc5-c00ca411ca59"
      ]
    },
    {
      "cluster_id": "6926f592-0807-43c3-9eb1-74f903b009ff",
      "members": [
        "20447d43-60ab-4c29-bb62-2cd5e30f2991"
      ]
    },
    {
      "cluster_id": "31cda056-0942-4d05-8579-66ba52eb0c7b",
      "members": [
        "7776d932-bca4-4232-a584-d33417e3a970"
      ]
    },
    {
      "cluster_id": "a98eba10-9612-466e-bbba-6161ced90ab9",
      "members": [
        "16139180-2568-48f4-a5d4-86827015c935"
      ]
    },
    {
      "cluster_id": "419a274e-afb4-4935-a491-f22b25792b9a",
      "members": [
        "b127fa85-ae98-4f2c-914c-0ec7ad3cc5df"
      ]
    },
    {
      "cluster_id": "2f43e86f-24fc-4c3c-a77d-c5abbf46ef19",
      "members": [
        "e0bd2a14-1e6e-43a5-8a9d-ee6e1e28ceff"
      ]
    },
    {
      "cluster_id": "886176d6-1057-4021-8312-570a3e3f4e10",
      "members": [
        "8e267560-56f4-452a-93ad-891b3c022aa4"
      ]
    },
    {
      "cluster_id": "6826010f-2a38-48a2-a358-b062edaa9ed4",
      "members": [
        "5b87492e-f8bc-4b16-a83b-cd3ffd662321"
      ]
    },
    {
      "cluster_id": "3b48df52-c3ed-4c3d-8f61-54ae3d11e9b1",
      "members": [
        "e3f63fc0-40a8-4139-b45f-b65461c8b237"
      ]
    },
    {
      "cluster_id": "5a089986-6a82-42ed-90a9-302a1ce45000",
      "members": [
        "26e46f4d-5516-4ae3-8550-8b46fcac1abd"
      ]
    },
    {
      "cluster_id": "761efa26-8da9-4e7d-a7d6-a4e67c04fce5",
      "members": [
        "14a22516-14a3-4e36-8cdd-74e064f7c3fd"
      ]
    },
    {
      "cluster_id": "fc93709e-88fa-4e26-963a-2d3fcd9cde24",
      "members": [
        "4a2e4b95-6228-410f-87ce-26b326d2ed7e"
      ]
    },
    {
      "cluster_id": "d07c5569-3547-4153-bb09-72f6d513ab57",
      "members": [
        "3c95092c-ff32-41c6-8efc-25cb0178c28c"
      ]
    },
    {
      "cluster_id": "92ea76c7-4dfb-45af-849a-ece7083099c6",
      "members": [
        "1d044881-dfe8-4305-ad28-8f2e00ede837"
      ]
    },
    {
      "cluster_id": "19d43c44-0b32-47ac-85c1-a05682078f22",
      "members": [
        "6b6599c1-2cbf-4074-9936-6b7a7e6c19b5",
        "5427876d-716b-4769-8748-2063f30c794c"
      ]
    },
    {
      "cluster_id": "d71b34b2-fb3e-4ce8-8b20-4e5bd486e9ce",
      "members": [
        "b1862fbf-0847-4700-a44b-5e4acc6e83e5"
      ]
    },
    {
      "cluster_id": "17a4104c-d678-44ba-8ae9-fd050d042961",
      "members": [
        "e160bd83-d2cd-443b-b281-8dcf13391611"
      ]
    },
    {
      "cluster_id": "dd658abf-fc5a-4105-b976-357ecd016b6e",
      "members": [
        "6079acb8-4b45-4576-b047-34cc48dd3ae3"
      ]
    },
    {
      "cluster_id": "1f956691-257e-4b52-8536-1a80ad662f9b",
      "members": [
        "f16f4ed3-b0bd-4d2a-95c9-3e274f0fa999"
      ]
    },
    {
      "cluster_id": "1e9c3202-7611-4885-bb24-d9dd05b7eed3",
      "members": [
        "93ab0059-d11e-429a-b043-e435315e618d"
      ]
    },
    {
      "cluster_id": "bcc58315-e1c3-44d9-8dc7-b3967b315e01",
      "members": [
        "149e0a0a-9b35-4fc6-b371-9576278ac3b2"
      ]
    },
    {
      "cluster_id": "25a85f3d-1037-40c8-8b96-32b80bedc5b2",
      "members": [
        "c6015b39-2772-4ca9-9429-6a2fe456ee32",
        "d30faa66-0ea0-482d-ac2a-7fcfdc7697d2"
      ]
    },
    {
      "cluster_id": "cf6e572b-b045-42a6-b196-8d36d7693937",
      "members": [
        "39898d3c-26bd-4aa9-8a59-079a2126ae08"
      ]
    },
    {
      "cluster_id": "1da96a0b-d833-4078-afdc-5a85d522b86d",
      "members": [
        "c7d2b250-f4c4-4684-b677-d6432e875d3e",
        "85ce5b6f-3f89-426a-b5a2-8d84eb7699e1"
      ]
    },
    {
      "cluster_id": "fca1885c-50ee-44f0-87aa-917cc35fd733",
      "members": [
        "3bb92e17-0489-4a5b-8099-61c3f5cf031c"
      ]
    },
    {
      "cluster_id": "93eceb5b-454d-4e3d-b632-57c5588aea34",
      "members": [
        "46f7ef2c-a1b3-47cb-b8e5-645e4208bdb3",
        "98071d1d-2071-4798-881e-ab5ac7c805c0"
      ]
    },
    {
      "cluster_id": "a4400c47-658a-4ca0-9b29-fa8384838731",
      "members": [
        "26609638-fcc1-4b4e-89f4-60dec798d60b"
      ]
    },
    {
      "cluster_id": "de700722-a9e2-4659-a181-3fb83efdd41f",
      "members": [
        "0b8df3f4-5271-428f-9336-8febdb1c264c",
        "6bed48b2-0edd-431f-b71a-5f9ac3911493"
      ]
    },
    {
      "cluster_id": "487393b6-56b8-4c3f-bdb3-88dbd2ac69d5",
      "members": [
        "24f83920-b618-404c-b49e-4adc756dedd6",
        "fb0330ef-17c9-4066-bcdb-a7dce2c66aa6"
      ]
    },
    {
      "cluster_id": "2972b17d-9533-46fe-a896-a36d50916446",
      "members": [
        "166848c8-967e-40a4-8078-5821ec4e1929"
      ]
    },
    {
      "cluster_id": "63024d1d-9398-49ae-8b27-efbfa0bffb4f",
      "members": [
        "e8cacb37-ea33-41f4-89f7-c7e6896b5a2f"
      ]
    },
    {
      "cluster_id": "30f557eb-c83e-4cb4-b405-ec14f06f223d",
      "members": [
        "7e445445-ef7a-4933-8775-3e116ffc0192"
      ]
    },
    {
      "cluster_id": "a34f85b1-92bb-47d3-b089-7365f6b9f51f",
      "members": [
        "f4b96ae3-a77d-4ccf-b96b-3b941f8b725f",
        "e8a2b3a6-e7d5-4b94-a0c7-f91a8ea464c4"
      ]
    },
    {
      "cluster_id": "50dbe9fb-6818-4777-990a-3ab01ab3659e",
      "members": [
        "faf88ade-24d7-4dcf-9599-5c9145f550b8"
      ]
    },
    {
      "cluster_id": "d669c1ac-c710-4975-98db-1c778f28ee4c",
      "members": [
        "98ac321f-c36a-4bbd-ad93-609c6b5ddb69"
      ]
    },
    {
      "cluster_id": "81238869-957b-4b83-948f-2551b38a7039",
      "members": [
        "41785fe5-5666-4005-b763-59f51cd8d1c9"
      ]
    },
    {
      "cluster_id": "5da699cc-92ad-44e6-a24b-61100072b99f",
      "members": [
        "f705b36b-4f34-4a2b-a921-345967b48d1c"
      ]
    },
    {
      "cluster_id": "e1572e16-5f85-4ebb-a6fe-2ab18bee1c48",
      "members": [
        "1ae9d1a6-7fc2-4779-b879-49a536c35b4b"
      ]
    },
    {
      "cluster_id": "e9c84dbc-30d1-4e60-bbc8-700057190615",
      "members": [
        "d04fd66a-e811-454f-bb67-150f8782a32f"
      ]
    },
    {
      "cluster_id": "3444a924-096b-4eda-877c-4c6412d885cd",
      "members": [
        "1d04e2f4-99d1-427c-a120-3b1a90135057"
      ]
    },
    {
      "cluster_id": "7b0fb73a-9488-43a9-80ee-d1864bcbae49",
      "members": [
        "05cbc7b4-f6f2-49e7-a208-e0e250d7094f"
      ]
    },
    {
      "cluster_id": "804db45c-717d-4c1d-9494-73592da3dad8",
      "members": [
        "209d22b1-d632-4c86-8bbc-6d1632ddfdfe"
      ]
    },
    {
      "cluster_id": "c0414ded-b694-4e4a-b7f8-d2835618be1b",
      "members": [
        "2f4fbef0-ba6e-4ccd-b127-74b59e645f35"
      ]
    },
    {
      "cluster_id": "e21ec8bb-ddf8-4115-9765-9a2f72eed10d",
      "members": [
        "e1682584-bfb8-4e0a-8866-adb98da6eb8a"
      ]
    },
    {
      "cluster_id": "9d6e8c23-1cba-47c9-9f43-333717df0abc",
      "members": [
        "7a396800-85d2-4b39-8dcd-a7c1c8e96efa"
      ]
    },
    {
      "cluster_id": "dcf2ee53-8023-43ee-94fe-0207a7fb5133",
      "members": [
        "cb409fed-3615-4245-84aa-61987e7e0223"
      ]
    },
    {
      "cluster_id": "7cff4302-4ea6-4196-96e5-448a227d2f09",
      "members": [
        "12f1fdfb-4d29-4417-a781-ada75566bb48",
        "9f5d4982-9ec4-446d-ac05-eb1dbf28db7e"
      ]
    },
    {
      "cluster_id": "f44705d5-ac0c-43e4-b025-c68545daa916",
      "members": [
        "fd69119f-620c-415d-bf99-0291b228baa8",
        "a90cf2b5-cc77-405a-83f2-ba43c67a3100"
      ]
    },
    {
      "cluster_id": "e495e756-f14b-4c10-8358-f906f837fdac",
      "members": [
        "ad80062a-3d8a-426a-99d1-f421c7309538"
      ]
    },
    {
      "cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "members": [
        "79914c75-18eb-49e1-8e63-9f9f43ae183a",
        "963a13b5-0862-4aea-b670-0d618cc0c9cc",
        "6c33f8ec-8406-40fd-858e-87acce3e0b2f",
        "59345576-3c99-4f85-9c22-cb7f2ee69987",
        "16f59642-6b9e-473c-98f4-16e38037a32a",
        "3a64efca-f394-4b04-8fd4-e08edd670201"
      ]
    },
    {
      "cluster_id": "e35fb8e9-42cf-4ef0-a512-d7be06ad99e3",
      "members": [
        "c3321f84-7849-4d8e-b6eb-0027f9a1ef41"
      ]
    },
    {
      "cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "members": [
        "97f8426c-3bff-4027-9f2c-c5a7dac7d103",
        "99c6fb0c-60a6-423b-a576-f2c16489097e",
        "b622741a-4170-49b3-9c00-2d16333e3e02",
        "db3e2d4f-8f74-418a-94d6-6dd00d5ff23a"
      ]
    },
    {
      "cluster_id": "da1326c3-fa76-400d-b44c-881f6493a085",
      "members": [
        "8af5625a-8215-452c-8f8b-b4605c6bc63e",
        "513ca3cb-280b-43ff-9a2c-b0a564e9be78",
        "925e1b24-bec0-496d-b5b2-3b514260a124"
      ]
    },
    {
      "cluster_id": "ed50b251-f205-4952-987b-aed1c0461840",
      "members": [
        "a1c9ba4c-ca08-4e60-8252-ff4a687a94f1"
      ]
    },
    {
      "cluster_id": "35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60",
      "members": [
        "4b42f203-d8d2-42d6-b819-9fe659c2bff7",
        "65250e2b-f109-4e43-b765-be530433a66a"
      ]
    },
    {
      "cluster_id": "e2dae5ce-65e5-4bf8-ac38-f452e98e9363",
      "members": [
        "54cb9373-b32a-4519-8401-caf5f482e5f9"
      ]
    },
    {
      "cluster_id": "4ac1da2e-cd03-4a11-b440-f62dc8f73aad",
      "members": [
        "08f4a80c-2870-4d62-a929-85f354fbb3c5"
      ]
    },
    {
      "cluster_id": "a3cec669-c5d7-49cf-9b41-ed9298b7642a",
      "members": [
        "43d583a9-a247-4b3a-85e7-9e73dddf6f36"
      ]
    },
    {
      "cluster_id": "3051427a-61ac-4a57-816c-f2ad62bba5e0",
      "members": [
        "5edb0b43-d38e-4c4b-a67c-1463dcb6c043"
      ]
    },
    {
      "cluster_id": "c076834e-92b4-4b02-8416-1f251021c0cd",
      "members": [
        "8f2ca6f5-b8b6-4cc2-949e-0128e53ca515"
      ]
    },
    {
      "cluster_id": "96423d41-ee08-4c5e-bcf0-4dd1b431abc6",
      "members": [
        "a8184d7c-394b-43c2-907e-e063d4a08e0f"
      ]
    },
    {
      "cluster_id": "2c72a6d8-6edd-4d3a-9563-d326950bc8da",
      "members": [
        "03713cf1-3285-4b14-940e-b471322c77da"
      ]
    },
    {
      "cluster_id": "38a07431-3ca7-46f3-a1e7-a6118a43b742",
      "members": [
        "9f7a5a66-3cd5-421f-8c1b-3e79b685556e"
      ]
    },
    {
      "cluster_id": "cbb443ee-8a98-4074-9a33-690c1a4267b8",
      "members": [
        "73a580b4-4b69-44f4-a8fb-9a6977e542a9"
      ]
    },
    {
      "cluster_id": "ab9886f5-759f-416b-88de-b9f771cf04e1",
      "members": [
        "e37c83ce-38f2-4423-9a84-da573f0ffa3b",
        "d11029f7-4dc6-4be7-b1da-5b28664bb1b1"
      ]
    },
    {
      "cluster_id": "7faff4ee-fc9e-4ba2-8e8e-36906d88936d",
      "members": [
        "3cd10504-7293-4120-b638-019e2e0a6147"
      ]
    },
    {
      "cluster_id": "4848ddfa-b6c3-4770-996a-7e5c266b5b88",
      "members": [
        "f82373f6-9aeb-4db7-9675-92beba087616"
      ]
    },
    {
      "cluster_id": "54e59784-1db4-41f0-a651-2d5e2138670a",
      "members": [
        "7d43e798-e609-400b-a48b-8f931e3ce23e",
        "712a2f07-999d-4c15-a8fd-cf6ec4475529"
      ]
    },
    {
      "cluster_id": "bd9462e2-36b0-48f7-92f9-c83dd2ee5550",
      "members": [
        "199e9a4b-d550-4e3a-bcf4-9a72423619f0"
      ]
    },
    {
      "cluster_id": "89cac161-a6f0-4315-a880-1662cae50313",
      "members": [
        "6e95ebe5-99d2-466f-8e90-0cc917b69a94"
      ]
    },
    {
      "cluster_id": "f3288e7a-a54c-44d1-8307-67aafb47c852",
      "members": [
        "c57dfaec-26b8-4aae-a726-47206540ec37"
      ]
    },
    {
      "cluster_id": "f597184d-050f-4a51-9461-70b55cf2b05c",
      "members": [
        "aec8b90d-d8e0-46e0-a3cc-bcf61de165d7"
      ]
    },
    {
      "cluster_id": "388f4cb2-36f0-4395-889f-3dc07bb54aff",
      "members": [
        "9d0bf5b2-91bb-41d1-b08c-7bdd2e0e3914"
      ]
    },
    {
      "cluster_id": "8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0",
      "members": [
        "53217b2f-fca3-4909-967e-1e550b446afa"
      ]
    },
    {
      "cluster_id": "2f8d9d1d-f145-459e-90bd-ebf833c6fe60",
      "members": [
        "f8967d69-a71c-4143-a9f7-83da2fc9cc4f"
      ]
    },
    {
      "cluster_id": "c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a",
      "members": [
        "c971afc0-c52e-446f-8f42-9d8541b6b917"
      ]
    },
    {
      "cluster_id": "930ae324-24b9-4353-aa17-35d5e069f64f",
      "members": [
        "baa60327-2fdf-4fe3-9312-99063b128b4d"
      ]
    },
    {
      "cluster_id": "d2231d7f-5f03-4e76-b0ae-753fd54f4960",
      "members": [
        "78a45dbc-288c-4c0c-b746-47886b07ece5"
      ]
    },
    {
      "cluster_id": "6302b733-5c75-40a5-a618-05d435c65be2",
      "members": [
        "16809459-35f7-426f-8329-a9c34309a67f"
      ]
    },
    {
      "cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
      "members": [
        "7a992198-c084-4876-b592-bf1f92cd55f1",
        "f9bcc584-69cd-4b2b-a377-89b89ff8b19e",
        "2994c2c0-f0d0-4e0b-9ece-0a4cdb450145"
      ]
    },
    {
      "cluster_id": "4acf918c-0778-4ee4-b773-26139df2ea2e",
      "members": [
        "0b2c0175-e665-4892-bfbc-7808ae3dcb8a",
        "e7eca5a0-30d0-431d-b66f-c8a1d6599ee5"
      ]
    },
    {
      "cluster_id": "e7a774aa-82c9-41a0-9af6-f4f143016a1f",
      "members": [
        "8b584ea9-0889-4650-819c-54e341fdef62"
      ]
    },
    {
      "cluster_id": "88d87950-d2a5-4729-bb7a-8215d26b8898",
      "members": [
        "094fbd3c-b35a-4c20-b0e0-214fa2f585c7"
      ]
    },
    {
      "cluster_id": "d88ab7ef-052f-4839-b4dc-054794d4d289",
      "members": [
        "cda1a8e2-20e9-456b-b935-56edcef9cc47"
      ]
    },
    {
      "cluster_id": "0d796efc-696b-45a8-bfd5-83987987e1ff",
      "members": [
        "9f5ab2aa-1d48-4a0f-8b36-d1bc0279abff"
      ]
    },
    {
      "cluster_id": "64b06601-97a9-452d-80ca-13c5f92ae356",
      "members": [
        "07771d5c-00b5-4b1e-841e-7e892647c698"
      ]
    },
    {
      "cluster_id": "27f40e5e-f571-4385-aef9-fcc4114989bc",
      "members": [
        "90a5dc53-7d12-4963-ac35-1f73db9e52e4"
      ]
    },
    {
      "cluster_id": "58cd12d0-b190-4e1f-826a-20e181a5c137",
      "members": [
        "e8f9b3de-5f77-45bd-a686-624be386842d"
      ]
    },
    {
      "cluster_id": "a38c8b34-2d1e-4ee9-ac98-b7d045e07fb4",
      "members": [
        "0c24e548-0e2b-4979-93c1-c712a466c2ac"
      ]
    },
    {
      "cluster_id": "e4ac4a3c-288d-4beb-9f3a-d8f26ff2f9c7",
      "members": [
        "9b2a0766-5559-458f-8740-214658f06894"
      ]
    },
    {
      "cluster_id": "83ec8695-6d93-432e-a8be-81705e2e2a54",
      "members": [
        "a3c82ec4-1e3b-4b66-b0fa-725beb943034",
        "80c32eed-7994-498e-84b0-b0a8048e0b19"
      ]
    },
    {
      "cluster_id": "ac926db6-b36c-4519-9b56-13482c4acbd7",
      "members": [
        "a9e3760a-e3c6-406c-ae04-bff0fcfe20ff"
      ]
    },
    {
      "cluster_id": "d8c4ecf1-bb1b-4da0-8a1b-b80059b7063b",
      "members": [
        "431e486f-195a-4068-accc-839f3d5f6916"
      ]
    },
    {
      "cluster_id": "c0057031-5868-445b-98d3-d536042f59f2",
      "members": [
        "68d0e0b1-9767-4047-b61c-46dfc5481041"
      ]
    },
    {
      "cluster_id": "ab72f353-1b68-44ce-979f-a10883b99605",
      "members": [
        "77995af2-5f23-43fc-8391-2d7c615e9e55"
      ]
    },
    {
      "cluster_id": "16e980af-79a1-4255-8ad0-56ca61ae3b8a",
      "members": [
        "af260482-351c-4dd5-84df-a3b880e0ea7d"
      ]
    },
    {
      "cluster_id": "9ba4f992-6e11-40b2-8501-4e04321822e6",
      "members": [
        "7fdea1ea-c968-4c88-ae94-84e1ba514576"
      ]
    },
    {
      "cluster_id": "fcb57169-c911-45f8-98e1-10aa6c573c38",
      "members": [
        "167a219a-eda7-4bf5-8331-da930d790371",
        "af3dbf49-d094-4fbe-b7c6-25808686dfa6"
      ]
    },
    {
      "cluster_id": "d7623a03-cd91-4c2e-b68a-db4e5ad54fa8",
      "members": [
        "0288195c-9fec-44db-a109-059e6777897b"
      ]
    },
    {
      "cluster_id": "eb38bdfb-232f-4460-8d60-fc8806237786",
      "members": [
        "fd8db090-0452-4f9b-8abf-4408eacddb2d"
      ]
    },
    {
      "cluster_id": "3c9c2d2f-29ac-414f-a514-d694db25f871",
      "members": [
        "85f37113-0f90-4278-a176-cff652db623b",
        "5c5d284a-29b0-4fb3-8cb6-db0f0c797e77",
        "2a34535b-7f20-42f9-a107-9b2729dfb4aa",
        "1e126e36-eb40-4d99-8d99-4a44eb746256"
      ]
    },
    {
      "cluster_id": "a74a2d72-1d86-4264-9389-b4fe594a7218",
      "members": [
        "c57e4357-ae8a-40b8-afda-c07666d2a827"
      ]
    },
    {
      "cluster_id": "e3e4b634-fa33-47d8-9f29-eefdbb263769",
      "members": [
        "c034d650-02fb-406f-9caa-155c65dedc12"
      ]
    },
    {
      "cluster_id": "5dac5b6d-e9df-41db-9225-7e413ca3cacb",
      "members": [
        "9fb54ee2-01b6-4987-980a-210dd5544835"
      ]
    },
    {
      "cluster_id": "21745bb5-f9bc-46bd-a9de-95338ba8c016",
      "members": [
        "86bf145c-272c-480e-8366-65caa37d83f0"
      ]
    },
    {
      "cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "members": [
        "92b4d75e-1243-4b14-afa6-adbd966b3a65",
        "f5d998c1-dba7-4576-b16a-89383c25a0fc",
        "3c84cd9f-a0b5-44a8-9e90-7b1c22667bf1",
        "5565423b-d1c5-4760-a05d-88362c28d64d",
        "62df3fdc-6f66-41ed-a406-3be29d71c41a",
        "66b83ca0-c680-4174-8829-30444f5d4a2f"
      ]
    },
    {
      "cluster_id": "e1e2a57a-7e63-4b0b-b70f-2189a87649d4",
      "members": [
        "94959480-351d-4c80-95f4-11df21938b90"
      ]
    },
    {
      "cluster_id": "b9cdce3c-8c52-4df4-89e7-a4bcf232dbef",
      "members": [
        "3227e8ec-3817-4e54-8ce8-38d6ff47fa16"
      ]
    },
    {
      "cluster_id": "62ddd106-9df1-47e7-9e5a-9c12a19f488c",
      "members": [
        "63d19ccd-c1a3-49bd-bb47-e27b66c6bb53"
      ]
    },
    {
      "cluster_id": "10e97fc5-5fa6-457f-aefb-257e90e8124b",
      "members": [
        "a9de1b60-bb45-4d6b-af0c-15438e753da4"
      ]
    },
    {
      "cluster_id": "9c9d4ed6-a861-4706-aee3-f148f1769c86",
      "members": [
        "6a794e4b-ffb0-47fa-8123-d9af2434ac33",
        "900e1eee-866c-424a-8d33-57b367844e47",
        "437d0d25-c2f2-4643-8e57-48cefb1d0e0f"
      ]
    },
    {
      "cluster_id": "f4638fa7-3292-4d44-b3f1-771aa65146b0",
      "members": [
        "864f9a63-a3cd-4ac6-8b3f-b1f18e4b0f44"
      ]
    },
    {
      "cluster_id": "dcf5235c-74f7-409c-bb59-9454cc01feed",
      "members": [
        "1b13625d-b41e-4562-bf57-bdb6d1ca6e55",
        "70eed460-6914-49b4-bb84-aaaec6fa2922"
      ]
    },
    {
      "cluster_id": "7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1",
      "members": [
        "ae86ef0a-bda7-4932-9e91-a13e090502e9",
        "af987d12-b231-4ec3-96e4-33aecad0ec38"
      ]
    },
    {
      "cluster_id": "7ebece62-a589-49b3-b28f-b8f565ab7327",
      "members": [
        "e62e5eff-1bfa-4a5f-8f62-2c3b2ccc3405"
      ]
    },
    {
      "cluster_id": "adcb219f-1d0a-4b1b-924d-ded66e2d2c1c",
      "members": [
        "da854a60-2bfd-47e5-93f4-3548662e814e"
      ]
    },
    {
      "cluster_id": "40a361aa-d57e-4e3c-9740-34505f34913c",
      "members": [
        "aa6995a0-49dc-480e-a0a5-150071aa7162"
      ]
    },
    {
      "cluster_id": "d8483e15-c78b-44e2-8070-c109cff73a66",
      "members": [
        "e5121df9-2e78-481b-8970-d2176c7e27ca",
        "fb4ca0c3-80c4-4700-ae1a-6f5767428779"
      ]
    },
    {
      "cluster_id": "5b7e1f2c-86a3-4e27-9c3e-c974a8d33606",
      "members": [
        "bd233fe4-3b35-4b5f-af8f-81ae82dca665",
        "568d07cf-6cef-492d-b53a-8c7f0a97da4f"
      ]
    },
    {
      "cluster_id": "6d37cc6e-940b-4af5-bb44-d183921f0d01",
      "members": [
        "e0368732-4c88-48f5-9c11-88c6067e6192",
        "fe6a5012-e766-477b-9be1-1e6534f65aae"
      ]
    },
    {
      "cluster_id": "35d18d7f-0f7d-4654-8e65-f6b4bcac032a",
      "members": [
        "00e4beef-c219-4e6b-8148-2fcb5fff7534"
      ]
    },
    {
      "cluster_id": "b9eca2e7-5401-453f-8490-81ec97719e08",
      "members": [
        "842d6786-258c-4787-ab4f-513325aead98"
      ]
    },
    {
      "cluster_id": "c55d7e50-ed13-4f98-a396-412d6e19decf",
      "members": [
        "2482a699-2eb6-4496-a7a1-14716440e37a"
      ]
    },
    {
      "cluster_id": "6985338a-f2b9-47d5-b9ae-563c0a87748d",
      "members": [
        "a3f553b1-2992-4891-b063-96f989262aae"
      ]
    },
    {
      "cluster_id": "9ee9fc47-27b6-4828-a30b-bd52c92ccfae",
      "members": [
        "baa2a5aa-152e-4eb7-9032-0bd27e6694e3",
        "ba09747b-f0b6-4dbd-b0a6-470d389066fe"
      ]
    },
    {
      "cluster_id": "d622247c-7345-4e31-99b0-dfafa4dc550f",
      "members": [
        "dc5f398c-1b3c-4084-ad16-8f688b425043"
      ]
    },
    {
      "cluster_id": "f5514b1c-3b40-41b8-9290-039c2c94a3e7",
      "members": [
        "cc147726-682e-4939-a5a6-0cc2cfc82c3f"
      ]
    },
    {
      "cluster_id": "2ed3c98f-2c08-4da6-97f9-38e8a951f08e",
      "members": [
        "d03e52c8-f3b0-465d-8f87-43a35a1fc373"
      ]
    },
    {
      "cluster_id": "141b690c-587b-4b7b-9ad4-7b1b333f6cd8",
      "members": [
        "34d53daf-8e5a-4230-baa9-8bfff9afe51e"
      ]
    },
    {
      "cluster_id": "e9b05837-7f42-4f2f-bc7d-dca62a93d724",
      "members": [
        "a106285b-7181-4d15-984b-cc4c27f0e1c8"
      ]
    },
    {
      "cluster_id": "38f73b32-c8c6-49f9-8452-aefe0c4fa642",
      "members": [
        "e1999d90-6147-49e7-b5ba-1610c953efa1"
      ]
    },
    {
      "cluster_id": "31810a05-cebd-496b-bd75-5b647781b8ec",
      "members": [
        "c9551664-66c1-4022-be61-3504e4b8a7ac"
      ]
    },
    {
      "cluster_id": "a65b71fa-08aa-4b20-91e3-c9e898591f07",
      "members": [
        "0cfea84b-cf2c-4f62-9d1a-21e329ead6c5"
      ]
    },
    {
      "cluster_id": "45339238-abb3-494b-a7ba-d3cde2ab18d9",
      "members": [
        "088c9d7e-17f1-4edc-8006-3419bd1f866f"
      ]
    },
    {
      "cluster_id": "5d65069d-5cc8-4da8-8b8d-bbd1528688e7",
      "members": [
        "8582e052-9742-4830-aa7b-63a3e3825d95",
        "76d5d175-535e-46fd-ab6a-b99dfb4c17f2"
      ]
    },
    {
      "cluster_id": "655e754e-33e7-4bf2-aabe-264f18d499a4",
      "members": [
        "bb7bcb7f-4e00-482e-91ba-f39ba58f5294"
      ]
    },
    {
      "cluster_id": "4bcae16d-fb51-4ba8-8381-37355e0e9f18",
      "members": [
        "803e4526-61c3-4126-86fd-41849f1452d5"
      ]
    },
    {
      "cluster_id": "ae58d35c-53bd-40b8-b6d5-7fe4e15e229a",
      "members": [
        "d268d9c5-c3c6-4411-8345-5a9251ac14da"
      ]
    },
    {
      "cluster_id": "1405f96f-07a0-4454-a7cb-365f38772605",
      "members": [
        "f6483772-fddc-4c83-9b69-4ea7ee784909",
        "7b01c26e-2bc4-4c62-a665-fa6ab7dc8026"
      ]
    },
    {
      "cluster_id": "563cdc28-d88f-4781-9ab9-27eadd46ba73",
      "members": [
        "cb281f4e-f905-4eec-b469-2c16643d4c80"
      ]
    },
    {
      "cluster_id": "d66fbbdf-0d3b-4c16-8077-654078280a83",
      "members": [
        "236567f4-2fcf-4060-8cab-0e0de7c945d5"
      ]
    },
    {
      "cluster_id": "92df4e35-804e-4b67-b2a3-fbb89ed1961f",
      "members": [
        "2ea9032c-8c5f-4001-b001-e19ace030710",
        "c964b8e9-62a4-426b-8aa4-338df852d011"
      ]
    },
    {
      "cluster_id": "6b12e24b-6d9d-4b0e-a169-260972b9ab69",
      "members": [
        "da17caaa-038f-44dd-81fa-2b9a4d619340"
      ]
    },
    {
      "cluster_id": "0b87672f-54fc-4c20-8d98-e54ab45bc52d",
      "members": [
        "25d1ffa1-ec83-4556-a329-729b2996fa94"
      ]
    },
    {
      "cluster_id": "de4bbbfe-ba23-4e75-bdd5-72e767837661",
      "members": [
        "d37d1d9e-9c0c-49d3-9635-75549d7725c7"
      ]
    },
    {
      "cluster_id": "d7524d60-e45b-419a-8a13-87cf67bfd8e5",
      "members": [
        "4f14b91f-d337-4555-83f5-4406531cb2eb"
      ]
    },
    {
      "cluster_id": "7b83d3ee-13b2-47c1-ab89-4f78258a986b",
      "members": [
        "18fd783c-ce15-4f12-bece-7b5f5bbe65b4",
        "d8318dcb-8196-4736-82e4-d6cc57aa76dd"
      ]
    },
    {
      "cluster_id": "3c0cf1f8-c44a-4a0b-9f9b-6b44ff81b740",
      "members": [
        "dc5413c2-0794-4e1f-a694-bbec425f4ef0"
      ]
    },
    {
      "cluster_id": "051c1a4e-08fc-4a09-9e34-8d3d8d646136",
      "members": [
        "43919de6-4762-4470-acd3-37a2872b14c9"
      ]
    },
    {
      "cluster_id": "1f1f405f-6b99-4de2-b4fa-1bd105b3c577",
      "members": [
        "7b0c30c4-33d2-419c-af29-819d57a0adfe"
      ]
    },
    {
      "cluster_id": "916339bd-3e65-4fc3-be04-12020f45e716",
      "members": [
        "4361dc11-5b10-466c-866d-bcef206f74ec"
      ]
    },
    {
      "cluster_id": "32a2eefa-c8c7-482c-839f-be3b15138d40",
      "members": [
        "0707287b-fd2c-45a0-9848-e672b4be6745"
      ]
    },
    {
      "cluster_id": "e9caf6d9-2282-4c7e-9cd5-97529119edff",
      "members": [
        "76d70905-af86-4ce6-b53b-47bfd1d81f41"
      ]
    },
    {
      "cluster_id": "4157a1dd-b3d1-4769-8ef9-bd2189b4146b",
      "members": [
        "905652e7-0b27-4087-97dd-baa9e9748ae4"
      ]
    },
    {
      "cluster_id": "da8da9c4-b0b1-404e-a289-e106bb2bfbb3",
      "members": [
        "5574fa8d-0c2a-4e81-9251-ca98d7716651"
      ]
    },
    {
      "cluster_id": "36824238-8532-447a-aacf-ef3f59e89c60",
      "members": [
        "277c4d3b-7c36-4927-b020-8737f80c28eb",
        "5ffe426c-467a-4aa8-a9e8-86fa1ed37679"
      ]
    },
    {
      "cluster_id": "1c5a43cc-bd0f-4446-9eae-4f39a7691fd3",
      "members": [
        "4061b077-d654-4a60-b4ff-6d603ddea8c1"
      ]
    },
    {
      "cluster_id": "9fc65438-2baa-4ecf-a802-ddd71c4ed907",
      "members": [
        "2f5db5ae-8ec4-4bc1-b85f-d2b962e49e81"
      ]
    },
    {
      "cluster_id": "53a06fbe-813d-46c8-a459-0b312bf0c503",
      "members": [
        "508c530f-62a2-4f80-ad46-f2af4e2a0d81"
      ]
    },
    {
      "cluster_id": "d0f7b20c-2bcb-454b-bc64-6c984732d241",
      "members": [
        "838a4c31-fdc8-4018-bf5d-f520ddd23e70"
      ]
    },
    {
      "cluster_id": "6a2f7e2f-c113-4c0f-aa04-a2e337901c37",
      "members": [
        "37e13725-d8a0-42c4-896e-28b43b854daf"
      ]
    },
    {
      "cluster_id": "6695efed-b1b5-4469-a01b-a370dfb9c522",
      "members": [
        "c92f6276-a72b-40c9-8eb3-52f11f64e39e",
        "2f3194b6-9742-4bc1-b6f3-965c8e1ccc22",
        "3c5f91b2-eb4d-4fe5-a274-f1526c2230d8"
      ]
    },
    {
      "cluster_id": "f87de08e-1790-487e-a827-12378ebf4309",
      "members": [
        "96f6f419-8345-4abe-8f59-ee35ea18b71c"
      ]
    },
    {
      "cluster_id": "09060ad9-5546-4c31-ae6b-321cd8a78d5b",
      "members": [
        "c522a826-3d94-442f-8c9d-1029702b5159",
        "7adbc651-0db1-44f2-bdaa-bf7e41339d70"
      ]
    },
    {
      "cluster_id": "ceabee0f-bc28-4b8e-8445-fc63ff551472",
      "members": [
        "55914f23-fc32-43e1-9e36-9f9f752bf43b"
      ]
    },
    {
      "cluster_id": "71f31aff-9c20-4fff-82ff-b0bb971b0134",
      "members": [
        "4c2df153-9630-4525-9cc5-c62839a1318a"
      ]
    },
    {
      "cluster_id": "ab8de566-e0cc-475b-b056-6b27916b484d",
      "members": [
        "aa6ae27a-ebdd-4bc3-aa8c-94795ca3005f"
      ]
    },
    {
      "cluster_id": "61d63dd9-934f-4808-b6ab-ed734f2474b3",
      "members": [
        "9f30f1e3-612f-4f10-8077-f36166226813"
      ]
    },
    {
      "cluster_id": "428a1c85-5fee-4a1d-bbe0-9e71872e75e9",
      "members": [
        "97b80d46-c4df-40f4-a396-952af4ac237a"
      ]
    },
    {
      "cluster_id": "7e4a12f6-fe24-48f6-993c-d7197eb9c44e",
      "members": [
        "5b569460-6127-4883-ab59-9853548e4d9f"
      ]
    },
    {
      "cluster_id": "542e81d5-bf51-451b-bb6a-204f6c8da58e",
      "members": [
        "ab5521ed-0c5d-4fa6-8e45-5994d785c3a0"
      ]
    },
    {
      "cluster_id": "af2dae39-7b57-4e0d-909b-c39b56de0088",
      "members": [
        "e5a07fbf-34c1-4129-aa0c-a60a22560819"
      ]
    },
    {
      "cluster_id": "579db367-74ad-4432-9888-8af443f74bd8",
      "members": [
        "6fe6fe1d-5649-46c3-b803-cf5637648f66"
      ]
    },
    {
      "cluster_id": "5a6c75cb-74c4-45e2-b8d3-dd1dbdb1dae1",
      "members": [
        "f69d66c3-1c29-4ad0-8ed4-29471bb5254b"
      ]
    },
    {
      "cluster_id": "99df608a-defa-4cea-b8ef-86519fa0e08a",
      "members": [
        "097ad6f5-be15-425b-9247-f5918bc3cf53"
      ]
    },
    {
      "cluster_id": "6b5b4849-041c-4f1f-a05e-cd4913045e8f",
      "members": [
        "9addcae8-1045-4fe0-b2e5-557bb400cba4"
      ]
    },
    {
      "cluster_id": "fa68205c-96de-4570-af4d-97691aaf5e3a",
      "members": [
        "68313ab6-a010-42dc-95fa-48d851f5286b",
        "b015f81f-6b59-4434-a79a-66d9ba97c4b3"
      ]
    },
    {
      "cluster_id": "6ca40c20-bd2c-4fa0-af88-bbe3820f05e6",
      "members": [
        "e1e22820-8161-46f5-b0cc-f1b859444517"
      ]
    },
    {
      "cluster_id": "3428edf1-36a0-4018-889a-63913498a6c3",
      "members": [
        "1f0568f0-449e-417e-8c8a-42e640838fd5"
      ]
    },
    {
      "cluster_id": "c64abad7-175d-470b-9931-9259e05b39f5",
      "members": [
        "7b26bbc6-19f7-43c0-a99f-5ee27fdfd37d"
      ]
    },
    {
      "cluster_id": "07ec2e30-02bb-47d3-9b4c-32b7c841fb33",
      "members": [
        "976a8b54-0e02-4acc-823e-24c922f31dd2"
      ]
    },
    {
      "cluster_id": "070a19a3-da4f-4314-9f9a-9f32850f97f0",
      "members": [
        "4b063b61-17b0-408f-86e0-66307335ebcc"
      ]
    },
    {
      "cluster_id": "7966aa4e-476b-473f-85ad-b267835811ed",
      "members": [
        "2020bb2f-ce91-4d14-8fba-d22a6c3047e9"
      ]
    },
    {
      "cluster_id": "824d7e98-fb11-413b-adeb-b8d12c8fb785",
      "members": [
        "af8e71ba-1347-49fb-872f-7d03c60cef83"
      ]
    },
    {
      "cluster_id": "f3328626-3764-43c0-a7df-3730b34ea1fd",
      "members": [
        "8624e824-6fbb-4d02-b248-4ac44bba4445"
      ]
    },
    {
      "cluster_id": "86d26636-5c9c-416b-94e0-e2a89a9628c3",
      "members": [
        "6d3ca843-ac74-414a-8a9a-f9b3d840ad72"
      ]
    },
    {
      "cluster_id": "c6592686-c5bc-45c2-8341-7823b2936bde",
      "members": [
        "a500fdc9-536c-4504-8762-dcf75b30807b"
      ]
    },
    {
      "cluster_id": "c13b80fa-280b-4c54-8a38-1ddd943c4782",
      "members": [
        "3a4ce92d-731a-4392-9594-1a7f1b5bc5b2"
      ]
    },
    {
      "cluster_id": "ed3519a5-2328-44c8-be3b-f36796b25965",
      "members": [
        "9f514e31-b4e8-4fc2-881b-695f8c5800df"
      ]
    },
    {
      "cluster_id": "391ac4c5-638b-42bc-b8d7-1972d56df43e",
      "members": [
        "38f377c1-4e31-4453-819e-2f821eff8ce0",
        "455efb37-6619-499a-9e56-569078c9d715"
      ]
    },
    {
      "cluster_id": "10f0700e-3ce2-47c7-8783-a4d08ef48748",
      "members": [
        "a3feeb4a-df50-4aab-a818-f764236f8ad6"
      ]
    },
    {
      "cluster_id": "619d0e6c-df2c-4164-aaac-ccaba7c311a6",
      "members": [
        "8c52f7f8-5666-4eab-9f59-fe86a57dd17a"
      ]
    },
    {
      "cluster_id": "b2036724-7c6c-4df4-b983-90c324253873",
      "members": [
        "e9b47af3-f5e1-42a4-8210-70ba8ef8ce4b",
        "a4b9fd7e-9d5a-42c0-8b84-7afbda6514d2"
      ]
    },
    {
      "cluster_id": "87e51e32-d441-41a9-8026-a751a57b0ed2",
      "members": [
        "2e952ecc-8a11-4728-a55a-b9070840e5cc",
        "569c9fdc-c50c-40ec-8253-6f83dfb0844f"
      ]
    },
    {
      "cluster_id": "b6a83d03-593e-48c8-ac84-66fa31a32a89",
      "members": [
        "396aad09-0fc9-4db0-9583-50b9bdd71a16"
      ]
    },
    {
      "cluster_id": "489cefd4-e6ef-4f49-8a70-8d8f7bc512bd",
      "members": [
        "95810909-9f05-4822-a380-9d9f192410dd"
      ]
    },
    {
      "cluster_id": "3ae89f52-245d-458f-80e9-2534c0d80104",
      "members": [
        "fb31b421-1b69-46bd-9c81-a9d77c6fcf57"
      ]
    },
    {
      "cluster_id": "b5600099-12c0-41c7-bfb6-4b6bb66dc0dd",
      "members": [
        "23c60597-be74-48f6-97fc-3631ba451bb8"
      ]
    },
    {
      "cluster_id": "947756fe-ff59-4dbf-90dc-9c0bdf20ace0",
      "members": [
        "2781ff7d-9d7a-4c4b-bcf3-c264eed0ba36"
      ]
    },
    {
      "cluster_id": "2f3c2293-d820-4cb3-836f-6df8faee07a8",
      "members": [
        "9cd57b99-4d64-4360-96d8-f1e695967fb0"
      ]
    },
    {
      "cluster_id": "7325cc3b-df7f-4451-948f-1ce21f12d10f",
      "members": [
        "e309b0fd-2252-4b9a-814a-9a55d2b4fba4"
      ]
    },
    {
      "cluster_id": "d0dabf1a-0448-47c3-ae6f-96348eaf2cb1",
      "members": [
        "d59aa96a-97da-4753-a2ef-40d78a48c9a1"
      ]
    },
    {
      "cluster_id": "340bfd8b-2131-4805-ab13-01e1c97ec008",
      "members": [
        "40678ed6-372d-4f7b-8d1c-78ccee23a635"
      ]
    },
    {
      "cluster_id": "be9b7361-8150-4e4b-9111-bac990c11d3d",
      "members": [
        "0de62fd1-eac4-4208-ba57-878dbab8308c"
      ]
    },
    {
      "cluster_id": "335213da-43c0-415b-b902-6fbd946881b7",
      "members": [
        "79af6b5b-af58-4e0f-8fb9-0441d3728d4e"
      ]
    },
    {
      "cluster_id": "1b257e2e-69fd-4bc5-b57c-e7f5b2178161",
      "members": [
        "0fb4eb94-796c-4474-822d-d49532bbdf78"
      ]
    },
    {
      "cluster_id": "6d2624a6-0551-4f8a-8ed4-2b7126ed6490",
      "members": [
        "e449ca29-0cdd-4df6-a8be-65ce5e2063ff"
      ]
    },
    {
      "cluster_id": "0649ea17-dc60-458b-988f-5fb62bfa7199",
      "members": [
        "12f4269f-e670-4d9b-8ee1-fb1eb44c333b"
      ]
    },
    {
      "cluster_id": "1809291b-a942-475c-989f-c974b3ec75b6",
      "members": [
        "3bd18ad9-4a9a-4f65-aed3-f97bfcfa2305"
      ]
    },
    {
      "cluster_id": "d11c600b-0ae3-4e55-8d1a-58fd9d0f71dc",
      "members": [
        "48e29c96-9fcd-47ae-88ac-52d0cf5d5625"
      ]
    },
    {
      "cluster_id": "97fd88d2-827f-418a-aa85-784dc98e83f5",
      "members": [
        "f9769b02-c023-424d-918c-79424431d746"
      ]
    },
    {
      "cluster_id": "489bde91-1bfc-48d6-aae7-de380d23d205",
      "members": [
        "9794657c-ae61-4302-9788-2e8896e74cdd"
      ]
    },
    {
      "cluster_id": "12c3a33b-fd70-46a3-a74c-86b922244369",
      "members": [
        "8f0975f6-6d6e-4857-b113-2188906ebfc8"
      ]
    },
    {
      "cluster_id": "da4807bf-cc54-48c7-b3ca-69cd854da837",
      "members": [
        "28861c5b-e399-4e62-aa35-4e22dbd2274d"
      ]
    },
    {
      "cluster_id": "d9f4e411-98bf-48bc-a372-2ef5b6cd17d9",
      "members": [
        "a9651ce2-41c6-4761-8d99-8fce6e172982"
      ]
    },
    {
      "cluster_id": "f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab",
      "members": [
        "baa9cabd-e297-4048-a196-c125d4f55a45",
        "24a948e1-bc0f-4d4b-9445-82619bac62bd",
        "4f27b8c6-ed89-44ab-a475-ce01f510eb96"
      ]
    },
    {
      "cluster_id": "820cd21b-12a7-4c4e-a98c-55a81599d692",
      "members": [
        "a1a4246c-cc65-437f-ade8-c42722b56648"
      ]
    },
    {
      "cluster_id": "eb2e33e5-165b-4a02-aa96-d53bcd386da0",
      "members": [
        "1b60a8c8-ce1d-4b0a-aebf-8bab19ffb83e"
      ]
    },
    {
      "cluster_id": "9af9ad02-7803-4d3d-9d58-fdfc300bef96",
      "members": [
        "ebbc58ff-b654-452d-826e-b4b7fb0c1dd4"
      ]
    },
    {
      "cluster_id": "c7b90480-a4e5-4b5f-b840-fe13ad140b52",
      "members": [
        "4ddf07b6-49d8-41d6-a6ff-cd4a4f5849f4",
        "aa15afe4-78f3-4f3a-b547-91e27dc69fe1"
      ]
    },
    {
      "cluster_id": "afdf0794-a58d-44cd-b1d0-aec7b0adc12c",
      "members": [
        "19aa839c-e515-411d-bb73-8b1c0ef37901"
      ]
    },
    {
      "cluster_id": "10bff7af-7766-4fc3-b86a-eaf53dd132e9",
      "members": [
        "36c0cd4a-8b15-43cc-ac7d-1fe603b67079"
      ]
    },
    {
      "cluster_id": "b3de51b2-92ca-4cb1-b45e-50a0188ca28f",
      "members": [
        "13dbfe73-0c74-42c4-8617-979b4f918ebb"
      ]
    },
    {
      "cluster_id": "400218af-6cc1-4f06-8e3d-7804bde6ad17",
      "members": [
        "73ab226a-7dc0-426b-9964-0d1a732ae936"
      ]
    },
    {
      "cluster_id": "868aacb9-ea8e-4ec3-a074-1e7f56bab03f",
      "members": [
        "5242cdbf-b4c2-48b2-8319-ef7cb0bb36db"
      ]
    },
    {
      "cluster_id": "9867a541-4a4c-449d-a4af-a0263f8d23fb",
      "members": [
        "d50f8b96-1672-465a-8227-62e198faf14a"
      ]
    },
    {
      "cluster_id": "8d565c91-b887-465d-a08e-aff09b1e9e5b",
      "members": [
        "2760dd91-0822-4c04-8c1a-3ee7deeebdd0",
        "f5cc4086-25d9-4aee-94ab-c0c7ced1e49f"
      ]
    },
    {
      "cluster_id": "a9d64d25-62ff-4c83-a924-9b0477ad4c22",
      "members": [
        "d284b953-af10-4aa8-9389-f4d2744e9454"
      ]
    },
    {
      "cluster_id": "e3548f8e-cc3f-4307-a48a-a45cdf828859",
      "members": [
        "276aa55d-6a95-4170-9844-c67c54a5881d"
      ]
    },
    {
      "cluster_id": "5d950548-da48-42e1-b748-275abdd34cfd",
      "members": [
        "1338c7bf-e4d8-4a04-a092-fad1f6993163"
      ]
    },
    {
      "cluster_id": "38c71e65-4039-4578-b30f-f1a4d6dd193f",
      "members": [
        "b72f3359-fc17-4fa0-aa39-f3c1d260a395"
      ]
    },
    {
      "cluster_id": "cd4aea0c-c90e-430b-95f8-4bff425c022e",
      "members": [
        "f6592f88-c9d5-436e-8cf1-f64e132ac10a",
        "31a1ff2d-e616-4f27-85a4-b4e9a505c722",
        "a6bfff66-26b1-4884-9570-878a4a484542"
      ]
    },
    {
      "cluster_id": "d81a20c0-6869-45f5-b75d-d3dcf313d9ed",
      "members": [
        "b99ed213-2fc7-44fe-8158-11de1ce92fd8"
      ]
    },
    {
      "cluster_id": "9ec9965a-96db-46e5-965a-bc307986c26d",
      "members": [
        "fbda447a-c249-4c5a-a81d-63707fa8a879"
      ]
    },
    {
      "cluster_id": "efcbf9db-15ac-473b-a9a9-0988dcab89df",
      "members": [
        "12de5676-5208-4063-93d7-48bcb3386041"
      ]
    },
    {
      "cluster_id": "1991b6cd-3baa-475c-add7-d4b101a0de09",
      "members": [
        "cf13ec5a-1de0-4158-9907-0e98d2f0b2b2"
      ]
    },
    {
      "cluster_id": "4a2e9d4b-d2bf-4512-a149-283851028578",
      "members": [
        "16a1d1b2-6f66-4f97-bc3a-1662c94b64a7",
        "c500b931-6581-40b0-8b04-bbaad04970c7"
      ]
    },
    {
      "cluster_id": "149c2ce0-2083-4d57-aa68-de8fbf125008",
      "members": [
        "7fd92c05-9204-46f4-9028-9475c4582ddd"
      ]
    },
    {
      "cluster_id": "21c7b1a1-7d0b-407c-9669-93e385d68711",
      "members": [
        "13a6d66c-1a1c-4778-b975-22861081ce05",
        "b270dea8-050d-4024-876f-14717220a796",
        "17279c2a-f5dd-468e-a0a7-b2b33e72993e"
      ]
    },
    {
      "cluster_id": "3d8a0674-b5ba-4875-8267-9c46797d5ef5",
      "members": [
        "e837d726-7aa9-4092-aa12-ef20fe1d288a"
      ]
    },
    {
      "cluster_id": "89a7a448-be37-40e3-973f-79b15dac979d",
      "members": [
        "02177f79-3fcc-4614-bb58-b540b9b8a755"
      ]
    },
    {
      "cluster_id": "d5458c27-5843-4ff6-b105-7703aeb6f588",
      "members": [
        "57ae1e09-8cba-4774-b8e9-155af7a9e12f"
      ]
    },
    {
      "cluster_id": "43784351-864b-42c8-bac5-2de22a3743c2",
      "members": [
        "a9df46be-ed24-4685-bb08-5aac2eaaf343",
        "b9a81b1d-f10a-4dcc-9fe4-d39ef8898b5f"
      ]
    },
    {
      "cluster_id": "db608ced-e4c3-4573-8b19-bacdf06c1585",
      "members": [
        "7e6c3b85-9bc1-4c85-add5-4280090cc98d"
      ]
    },
    {
      "cluster_id": "a83fedfc-0f0a-49b0-9dae-3932f2ba6983",
      "members": [
        "708a59bc-3706-407b-8bed-aca62b3a0e0b",
        "31a46b11-b9d8-4184-9630-493ef7925f06"
      ]
    },
    {
      "cluster_id": "c9534331-e465-4cc5-951b-fa24c4cd75bf",
      "members": [
        "078df374-e1cc-45cd-b89d-fc04a0086df0"
      ]
    },
    {
      "cluster_id": "7d04ad0f-dee5-48f3-910e-0b2281b15f1e",
      "members": [
        "6722e272-3d35-49c3-97d1-95e27ae4caa5"
      ]
    },
    {
      "cluster_id": "b3cc2793-d201-47e1-8b0f-b8bc6fd1bbe4",
      "members": [
        "27699f3d-62b2-4450-9a56-170616f84fde"
      ]
    },
    {
      "cluster_id": "dfa47852-ac3f-4b74-bc17-22923a395552",
      "members": [
        "5d80c8af-4946-454c-85dd-5a000e0466a3"
      ]
    },
    {
      "cluster_id": "202ead36-85d6-41b8-a59e-b60cf6559899",
      "members": [
        "40a1f1b1-475e-4194-80de-4218fe12446a"
      ]
    },
    {
      "cluster_id": "aaa5b32a-96ba-4450-b886-70f714b65bf2",
      "members": [
        "c27701ba-9c1a-481d-b0a0-fb14a12af237",
        "a5f5b63d-523a-4301-91c8-def1fdf47374"
      ]
    },
    {
      "cluster_id": "80ee7cf5-20b3-4f27-9dd1-9ddac8a8c921",
      "members": [
        "281cf79d-9b45-4672-9aa2-739fdb931d01"
      ]
    },
    {
      "cluster_id": "b0f153c6-cc18-4aee-9b69-e8f06c8e3149",
      "members": [
        "f430114c-0a7c-4439-b956-63fb68e8fe59"
      ]
    },
    {
      "cluster_id": "f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1",
      "members": [
        "46ccbb30-6967-414e-a158-c7235dff817a",
        "d0a5b883-e100-4fb8-b710-5da3ddf49704"
      ]
    },
    {
      "cluster_id": "2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37",
      "members": [
        "7a0a519a-abe5-4d16-b25b-95b7dd5dd4f6"
      ]
    },
    {
      "cluster_id": "a63004c7-9e1f-4600-bae4-f70655f0094e",
      "members": [
        "b1e6964f-cf85-4fe8-b3cd-e36bae98b74b"
      ]
    },
    {
      "cluster_id": "729e67ef-32fc-4882-8297-9f443b6f2589",
      "members": [
        "a8c3c106-7f49-4e8d-b998-9325e7b29179"
      ]
    },
    {
      "cluster_id": "066ea292-674c-44ee-8c3c-799b0ecf024c",
      "members": [
        "0c210184-be10-40d1-a5ef-5c5c5f272897"
      ]
    },
    {
      "cluster_id": "6d2fdf64-8424-4971-a998-3fe674aff124",
      "members": [
        "7a88ce76-3d77-4aae-b093-fd98ef26f4d5"
      ]
    },
    {
      "cluster_id": "2105abe4-014b-48d8-a8a2-6e113ac81f52",
      "members": [
        "5ffb9f22-74b9-4d3f-8577-578f0aadeb63",
        "b912dffc-b87d-482a-a16b-8acade76c109",
        "05e621ba-ae52-4afa-9b17-06cbf18f9681"
      ]
    },
    {
      "cluster_id": "bf53e706-320e-4307-85d6-fcee526f5f17",
      "members": [
        "8e94c22c-9394-4644-8c86-53923aa6f4c4",
        "a3132792-ed94-47b6-879b-3555eb8e2014"
      ]
    },
    {
      "cluster_id": "3bebcbeb-75f9-4e80-89da-65943e0843a7",
      "members": [
        "81e0ef7d-ddb3-4378-bd60-543568936e03"
      ]
    },
    {
      "cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
      "members": [
        "ac94c666-f650-45c6-b4b7-6e850d36774d",
        "622159aa-c1c6-4f15-835f-7664880f27c2",
        "70c1009e-90bb-45b3-9841-3a11d82b6d55",
        "18c57d84-5c5e-4cb2-ab99-543cf4ad5dd6",
        "1107377d-31cc-4177-abee-f8997c059202"
      ]
    },
    {
      "cluster_id": "f465e3b9-9784-4302-b258-d34ad0adf726",
      "members": [
        "a4290403-d70c-4974-84e2-44718132a241"
      ]
    },
    {
      "cluster_id": "c0e66b49-a2c1-49ba-be78-c28aff5c60cb",
      "members": [
        "852533f6-e8e6-43a6-a937-f11d74216ec4"
      ]
    },
    {
      "cluster_id": "8d676e91-6fd3-47df-8a59-7b88ff3f09cc",
      "members": [
        "666a0302-51a9-4c85-b6d3-9d5c2ff3f4cc"
      ]
    },
    {
      "cluster_id": "06ceeed7-8a02-425d-9be1-3881dcb38762",
      "members": [
        "5539f9d0-477d-421f-b465-b41852681b1d"
      ]
    },
    {
      "cluster_id": "869cd99e-564a-4420-981f-b385e7b7bceb",
      "members": [
        "48426c97-7d6a-432e-b843-39c651e804b5"
      ]
    },
    {
      "cluster_id": "38146e96-2791-4b11-ad91-87648834294e",
      "members": [
        "e85cc452-7f15-496d-99e7-e29d1ac05981"
      ]
    },
    {
      "cluster_id": "48358541-e77a-4c9f-81e2-7af006f34920",
      "members": [
        "c3751919-18d3-47c2-9167-edfff84722d8"
      ]
    },
    {
      "cluster_id": "756b0f02-73cb-49a8-bdd7-27690bdeb637",
      "members": [
        "aee0cb83-07c1-42bb-bf33-73e771d68a50"
      ]
    },
    {
      "cluster_id": "6cade303-8a3e-4226-b5e8-0d3b189187cb",
      "members": [
        "a820a710-7fc3-4d8c-b0eb-29a62b39bc95"
      ]
    },
    {
      "cluster_id": "f8121c44-24d3-465d-8607-2a909285d318",
      "members": [
        "a13c9705-08c7-4902-be92-bdd7400fe68c"
      ]
    },
    {
      "cluster_id": "32902173-339e-4b9f-809d-01ac474ca7aa",
      "members": [
        "511ed949-e4e4-4397-9aea-9c078bc7cdba"
      ]
    },
    {
      "cluster_id": "8f9f1940-08f3-4a29-938e-790645f67487",
      "members": [
        "edfc6794-b92b-4d2c-aa29-931e67ed4a5f"
      ]
    },
    {
      "cluster_id": "c474ebeb-fd96-4c94-8aa4-35666d0af3d1",
      "members": [
        "23d2674e-201f-436f-8ba5-f9634b22452b"
      ]
    },
    {
      "cluster_id": "3b3a75fc-8d67-4d12-8788-a11705a7cca1",
      "members": [
        "205ee47e-0b88-48c4-bc25-bd44daed69fd"
      ]
    },
    {
      "cluster_id": "3579f3e6-5ab6-488d-a555-602383a4e3bf",
      "members": [
        "4e5b22dd-ab03-436c-ac85-a6195d7b65cb"
      ]
    },
    {
      "cluster_id": "bd06a127-0f18-48fa-b6d0-ff607d111775",
      "members": [
        "1ea025bc-37bf-4c08-96c3-faee33d6f7c1"
      ]
    },
    {
      "cluster_id": "296dd26b-e540-4c2f-91af-43709d5e7555",
      "members": [
        "4e7475b9-3013-439d-bac9-d3f060ccf7e6"
      ]
    },
    {
      "cluster_id": "b58aa973-7c2a-4a42-ac89-2aa7abeea2e5",
      "members": [
        "94b0599d-5280-4eb1-a5c4-ebb69a354aad"
      ]
    },
    {
      "cluster_id": "e8c5e2f3-c4c1-4992-a125-b40d6d98bace",
      "members": [
        "425afd42-325e-44a6-a89b-4d35781ffd50"
      ]
    },
    {
      "cluster_id": "73aeb014-9fc7-4042-b2b1-7016c4fa8dd2",
      "members": [
        "32ffa954-dc22-40d1-96e3-96b6f192825b"
      ]
    },
    {
      "cluster_id": "77de10dc-6dcd-4902-a9d2-f5cf9384d343",
      "members": [
        "d80bebb7-3a6f-4623-80fa-7326d471c3a4"
      ]
    },
    {
      "cluster_id": "b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4",
      "members": [
        "91924ffb-2ec1-49ed-8ca6-a0b9686c4c88"
      ]
    },
    {
      "cluster_id": "a031766e-aaad-4e78-b0e4-bd1cf2fc1a66",
      "members": [
        "ba0ef9b9-0a68-4dbd-93b2-7b293f43f319"
      ]
    },
    {
      "cluster_id": "4150f7a8-fd61-465a-8315-84a5d8cef80e",
      "members": [
        "15a2de90-4297-4571-9ce7-16e49442c14a"
      ]
    },
    {
      "cluster_id": "6eb67c15-59c3-481b-bf8b-2e464b0775ec",
      "members": [
        "3982f6ff-e14a-4a9d-be0a-90a7aa933551"
      ]
    },
    {
      "cluster_id": "23bf4739-72bc-492b-9320-78f2bdc83074",
      "members": [
        "dcc4a80a-81d4-43fe-aa58-e3bd7b68cb02"
      ]
    },
    {
      "cluster_id": "392d337b-80a2-4413-8e08-b0007e5c9b50",
      "members": [
        "2811b1f1-4d62-4902-b97a-4a3797d99845"
      ]
    },
    {
      "cluster_id": "29e9fc0f-b1d3-428d-985b-aead08ce4e3c",
      "members": [
        "dfeb95b3-8fdd-4583-ac1f-66a47fff194b"
      ]
    },
    {
      "cluster_id": "61c8550e-839e-4f39-803d-72ebbfa747a7",
      "members": [
        "bbc96af2-eb24-4264-884c-ef5aeec83436"
      ]
    },
    {
      "cluster_id": "e17e07df-4805-4514-b3fc-c16cda9269a3",
      "members": [
        "7eb508d8-7356-4029-85fc-3cd4e5adabd7"
      ]
    },
    {
      "cluster_id": "f1535355-abab-40c3-b4e5-ea2b4fe4994b",
      "members": [
        "ce34df8f-a86f-47f8-94f6-b6763533d968"
      ]
    },
    {
      "cluster_id": "18f586c2-7862-4f1e-9fbe-94bf4981c3c4",
      "members": [
        "7df04e24-fd6c-4618-916b-acacd3af5fe6"
      ]
    },
    {
      "cluster_id": "d92f99b3-bdef-4ca3-95aa-e303f2451b97",
      "members": [
        "3f2eac23-d6cf-49de-bae9-23f6f126613a"
      ]
    },
    {
      "cluster_id": "3aa4fde2-05d2-4c91-b69f-d61ecc64ca82",
      "members": [
        "f08b015a-22f5-4f03-a884-d70f9da97189"
      ]
    },
    {
      "cluster_id": "b1827766-8909-4c0a-8a55-23a0b5e81d4e",
      "members": [
        "a48c2d4a-ca9d-4583-ad77-e97dc4ceddad"
      ]
    },
    {
      "cluster_id": "971c6a1a-3e95-4838-8131-b05eb89d55b7",
      "members": [
        "71cecf6b-1122-4c2c-8ea4-48558d89a707"
      ]
    },
    {
      "cluster_id": "e935bf33-7d4f-4ee6-8636-94e91a064afd",
      "members": [
        "e630a528-9654-4292-b306-4be1aede0a0f",
        "27728a69-61ad-4642-938c-0424e17198f4"
      ]
    },
    {
      "cluster_id": "32c3480d-0d09-459f-9f53-79a49ae3f52b",
      "members": [
        "7d58789a-930b-4bde-b413-904cf956b97b"
      ]
    },
    {
      "cluster_id": "b686bd17-fb36-4b7b-9caf-084f8d91c149",
      "members": [
        "94a5d13f-6c49-487a-b51a-ccb0748b111c"
      ]
    },
    {
      "cluster_id": "03105f5f-d65d-4408-8071-b314d86ce573",
      "members": [
        "6c74371b-9156-4527-bd46-33afea027602"
      ]
    },
    {
      "cluster_id": "6670d6b8-9c36-4849-b28c-4959087df8d4",
      "members": [
        "6ec4ed54-0f02-4ca4-a2e5-1713fca9e731"
      ]
    },
    {
      "cluster_id": "2aeb94af-8d5b-40ce-b754-91495083b2a1",
      "members": [
        "7ae5ac2a-e77e-45f9-a09d-b48ed86247ed"
      ]
    },
    {
      "cluster_id": "f46bebef-6c63-4778-a5c7-e0d7b893e969",
      "members": [
        "95e8dca6-eba1-4ae8-abe6-1699e963f71b"
      ]
    },
    {
      "cluster_id": "2b9508d5-4552-4994-840b-08ab461e29c3",
      "members": [
        "f3693f4c-6543-41d1-afc8-120d2fb1edf8"
      ]
    },
    {
      "cluster_id": "31d339ae-2342-44f9-a909-e299d2c4eccd",
      "members": [
        "e355827b-0900-4843-b234-fcf2d8dc9d3a"
      ]
    },
    {
      "cluster_id": "a7867a02-8602-4251-af70-d100ee635a74",
      "members": [
        "d393ae41-2620-4022-acb5-4fcbc7c76ec6"
      ]
    },
    {
      "cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "members": [
        "54a197a9-396b-4264-872d-94d97c27fbfa",
        "9cf70f7d-68f2-4feb-b383-fa49d02a1fe7",
        "d39e87c1-3ebc-48c7-9d34-8a569966f06a"
      ]
    },
    {
      "cluster_id": "e836e40b-bdcd-4eeb-bbb2-df3b385c12c6",
      "members": [
        "98383b6c-d1d4-471b-9076-e2507500a31b"
      ]
    },
    {
      "cluster_id": "68d51d93-fcbe-411f-8a89-cb79bd347512",
      "members": [
        "e922300e-8398-4290-a14b-22c277ffc866"
      ]
    },
    {
      "cluster_id": "1e13a15e-d3c1-4581-b460-13b01ca9aa54",
      "members": [
        "e1282797-5c59-4c8e-9869-25dd7feed8ec"
      ]
    },
    {
      "cluster_id": "29790db2-2536-415f-822b-9a4c1f1f8a3c",
      "members": [
        "534fe008-9f9d-43c8-98e6-feb5d976c1e5",
        "151026d8-aa87-4c5e-a1ed-b5a85230e132"
      ]
    },
    {
      "cluster_id": "1f8ce922-0e37-4ccb-b586-67da18764d96",
      "members": [
        "3d30e612-8d52-47bb-b24e-3c6c55d6798c"
      ]
    },
    {
      "cluster_id": "f6f15ea6-27bd-499b-a6fe-74d144b5ac0b",
      "members": [
        "80f457ab-70e1-4f4d-b0b7-55e5496c3cc6",
        "ef48ebaa-d46a-4bf8-b024-1f4517044afd"
      ]
    },
    {
      "cluster_id": "b63983c2-35fa-4152-8cc2-8380b6cbde79",
      "members": [
        "15558040-1082-40ab-b3ee-92ad2117bd2e"
      ]
    },
    {
      "cluster_id": "88a5288e-7f93-4e9a-8960-db23a08024fc",
      "members": [
        "32d2b9c5-4f9d-4841-b031-0779293587e4"
      ]
    },
    {
      "cluster_id": "a1f0e0be-a8bf-4895-ad2d-4f83a0d63930",
      "members": [
        "eade3386-0e7c-4d86-b898-d4d10a95072a"
      ]
    },
    {
      "cluster_id": "976d7c8a-cb17-41e5-9407-5cd8c141bb84",
      "members": [
        "2598f3d6-3972-4e7e-9a44-f2e6e903bf9f"
      ]
    },
    {
      "cluster_id": "6a65158f-b873-42cb-b0bd-0cb1b60a0d86",
      "members": [
        "305207e2-9826-4409-b2f3-7a186de5ee2b"
      ]
    },
    {
      "cluster_id": "5288ae46-832e-4436-95ed-05106d5e8d73",
      "members": [
        "459a7c39-7561-4c42-8b32-f60835558e46"
      ]
    },
    {
      "cluster_id": "7c9beeef-07c1-4872-bfac-86e8c63a87f9",
      "members": [
        "d424c471-7aaf-428d-9186-8d8442cbce27"
      ]
    },
    {
      "cluster_id": "5fec9a51-560a-4b1e-ab7c-cafcf47ba675",
      "members": [
        "21d74062-be4e-4d10-a0d8-33bb9fd723b9"
      ]
    },
    {
      "cluster_id": "6b22978f-c41a-4fd1-ac4e-29deafe60573",
      "members": [
        "6d21c206-996c-4e4a-85fd-d9df9ec56bdb",
        "73a83e9e-a797-4089-b84e-33a825dd6e1f"
      ]
    },
    {
      "cluster_id": "6f7b1c88-304f-4cf4-ba94-d6268fa5ae40",
      "members": [
        "3cb094ff-b29e-486c-99cd-938e3eb40fb8",
        "b4dc8335-e7e6-4ca1-ac0f-cda8fc61aa54"
      ]
    },
    {
      "cluster_id": "e1f9f354-866e-470a-a516-a1c53f268840",
      "members": [
        "b286a749-9752-4d5c-a479-037bff83d4f5"
      ]
    },
    {
      "cluster_id": "7a66905d-c83d-454d-9b6f-176a36e4d7b3",
      "members": [
        "a1b34fd3-9e14-4812-b52c-ed9c8fd128eb"
      ]
    },
    {
      "cluster_id": "2a22127e-779b-461a-a858-c6dc0fc34ff0",
      "members": [
        "48aa8890-a376-420a-bea0-d18e73298f49"
      ]
    },
    {
      "cluster_id": "e1ed1afc-85b6-4c69-a063-e486d1e3670f",
      "members": [
        "c6920b0d-019e-426e-a9f1-94a2c661ee47"
      ]
    },
    {
      "cluster_id": "237a5318-2edd-4ffc-869f-c0fed9502097",
      "members": [
        "761d7708-e063-40df-b169-11813b9c5a1a"
      ]
    },
    {
      "cluster_id": "20b239ec-b263-4052-a330-5aad8ed1209b",
      "members": [
        "f834d89b-72a5-4444-9ae0-dc1689e04181"
      ]
    },
    {
      "cluster_id": "86e5843a-553f-41b4-aec2-73c2638e9bca",
      "members": [
        "84f85dfb-f8b6-4bc9-8b68-c8f9e31f70ff",
        "df6ef4b3-1e21-4196-a2e3-c276d1591248"
      ]
    },
    {
      "cluster_id": "099db03e-baa7-498b-864d-6a091534741b",
      "members": [
        "49ed25a7-1dbd-41a6-8bb7-f47041bfa75d"
      ]
    },
    {
      "cluster_id": "187eb2a5-5a75-4a22-8ebb-7b83bc1068a8",
      "members": [
        "5191a2b0-b6ba-406f-955e-eeea758651bd",
        "d78af013-bc42-4660-b56a-e505039c4243"
      ]
    },
    {
      "cluster_id": "2cd7a2ea-67d1-4d2a-8944-a71778dc20d7",
      "members": [
        "e347b4bf-00aa-43d1-b060-2fddcd12d86a"
      ]
    },
    {
      "cluster_id": "bc2e7af6-3507-403a-b41c-f6013dcfcf6c",
      "members": [
        "aa552ce2-0693-4f24-b8aa-d44db6148533"
      ]
    },
    {
      "cluster_id": "8c2b4e21-c9ea-4127-9440-e983688f714d",
      "members": [
        "f9bbeb23-497c-4d13-8beb-ceddba749004"
      ]
    },
    {
      "cluster_id": "101b3e01-9e80-483b-82e6-39667fb77d18",
      "members": [
        "0a46dcee-f394-4142-a759-f623d40f2993"
      ]
    },
    {
      "cluster_id": "a94e5bcb-b502-4cb7-a23d-3a1e29ce963a",
      "members": [
        "a7f471f0-c804-4bf4-9e64-75b4b344ca1e"
      ]
    },
    {
      "cluster_id": "d089f75e-69ee-4713-8c0e-27843b110a2a",
      "members": [
        "80ddb716-250d-49cb-a86c-cefd8e85d239"
      ]
    },
    {
      "cluster_id": "a020fdcd-2c2c-4311-bbc5-883c8bcd23ae",
      "members": [
        "b3b4dccc-edc1-4594-a17b-eb8a8871eb05"
      ]
    },
    {
      "cluster_id": "adfa00d7-81da-47be-a9ec-4b8dfb8ee34a",
      "members": [
        "a34da33f-f9dd-4652-bf9b-d5fc598b1fa4"
      ]
    },
    {
      "cluster_id": "7e979f93-4ad2-4933-833d-edddb9f37e0b",
      "members": [
        "a10fa490-b372-42ce-b4dd-106ad67c6d58"
      ]
    },
    {
      "cluster_id": "ee3408ae-2ea4-4661-a58b-6e825aa4a0ff",
      "members": [
        "f8df93c6-49fd-4b41-8315-24f1be63730c"
      ]
    },
    {
      "cluster_id": "f621aef8-63b8-4a2e-8e04-ca8b7ec1b346",
      "members": [
        "a17cc408-1d6a-490d-8453-7ec64b9273e6"
      ]
    },
    {
      "cluster_id": "9fc7edf3-7209-4828-92b3-8d6dafded201",
      "members": [
        "6b0cb1c7-5e1c-4678-9dfe-c6f8b5a13b7b"
      ]
    },
    {
      "cluster_id": "dbd98860-9de1-4289-bb60-99171790c782",
      "members": [
        "5d06354f-3729-4ab5-b52d-859acce95585",
        "31531c60-58d7-4c6e-a9ae-1ce4ab397323"
      ]
    },
    {
      "cluster_id": "4ece2a70-3ab9-4be4-bb31-9931add16159",
      "members": [
        "b743ccc3-2ad1-4531-aeb5-3f9ee4ef1afe"
      ]
    },
    {
      "cluster_id": "3c4b8a98-54ef-4e72-a175-6c00ff85db75",
      "members": [
        "0d2969a9-c361-446f-b6d3-6b39780b39c9"
      ]
    },
    {
      "cluster_id": "f72f8aec-c684-4bb6-92bb-742f08817b1d",
      "members": [
        "a28cffa1-f1e8-459e-884d-d1249a1d0ab2",
        "3508161d-b09c-4ca1-b358-f8f40784f430"
      ]
    },
    {
      "cluster_id": "9fa27866-4911-4f0d-8135-cff4b7e597db",
      "members": [
        "de00440f-228d-4c2d-ad87-5293bd2571a1"
      ]
    },
    {
      "cluster_id": "95469f31-02a2-4069-8577-33c92dddd21d",
      "members": [
        "a9706be2-7458-4a21-babc-81684e231d94"
      ]
    },
    {
      "cluster_id": "b1951710-a9b4-42e8-b9e1-6ca4e5f12a31",
      "members": [
        "b866256c-d159-42f2-9b79-b437f21f7e46"
      ]
    },
    {
      "cluster_id": "138e6c92-a8bd-4f22-8e72-b320bdcf0b62",
      "members": [
        "77173a67-8198-4e1d-b0ef-7f2f6804027f"
      ]
    },
    {
      "cluster_id": "fdae240e-8bc7-467c-b880-f3913e28e6ce",
      "members": [
        "339fd89e-9069-4cd1-adab-6b245515d392"
      ]
    },
    {
      "cluster_id": "14c9c1ef-f94d-48f3-87f5-028b0baa8869",
      "members": [
        "64a08c8e-1e38-4b1e-9ea7-be63fab1aef1"
      ]
    },
    {
      "cluster_id": "edbdc807-7fba-426c-a271-726e1f090eaf",
      "members": [
        "96d8b95e-2b0a-4a6d-bc0c-0a975baa522c"
      ]
    },
    {
      "cluster_id": "f04728cc-e827-402c-9a97-187311920a0c",
      "members": [
        "c08b92a0-63c1-481e-8fbb-220d1bec1e18"
      ]
    },
    {
      "cluster_id": "69c28a9e-902d-4ac0-9540-ae2854dbb59f",
      "members": [
        "bf409d71-b0a9-4311-a682-6b872b61d969"
      ]
    },
    {
      "cluster_id": "c2c441c7-f2bd-4b4f-baf1-ba82eaa0b970",
      "members": [
        "43e60ecb-14ff-495d-820e-25f786390e22"
      ]
    },
    {
      "cluster_id": "00c920c5-f4fa-404a-9d1e-12f311ed5e11",
      "members": [
        "ac8a6a2a-4e83-470a-ad51-1f2339e8ceee"
      ]
    },
    {
      "cluster_id": "55c660bf-50f6-447e-81a1-ddecdab998ee",
      "members": [
        "f477af0a-dd48-4c7d-a950-1f2cd381cbb2"
      ]
    },
    {
      "cluster_id": "461bd859-868b-47e1-abbb-db550a7eb628",
      "members": [
        "61e43457-f3a7-4d90-a467-42a40846a89d"
      ]
    },
    {
      "cluster_id": "76cf3691-7d2d-4e3e-a789-a9c5c731de64",
      "members": [
        "f6cba773-bc49-4608-83f0-216fe40c94c6"
      ]
    },
    {
      "cluster_id": "283a7466-09a4-4b67-abff-ca96f1d8ade9",
      "members": [
        "01c7f4c3-c3d1-4952-9dc8-ac43685ce347"
      ]
    },
    {
      "cluster_id": "32f9804d-d015-4846-99e2-90dd09953704",
      "members": [
        "e104a744-7f4e-4aae-b81d-466cb73a33a5"
      ]
    },
    {
      "cluster_id": "d4c6919b-eb92-4688-a3f3-bcffc0362115",
      "members": [
        "07f2b85e-df16-4ab8-8ca2-bc976eb20284"
      ]
    },
    {
      "cluster_id": "b2a7204e-e5ad-4d5f-8464-67520217c392",
      "members": [
        "d7f7cb52-20d0-41e8-8343-64bd00f61be3"
      ]
    },
    {
      "cluster_id": "89c49eca-c41a-43b9-88d5-85536edafaa8",
      "members": [
        "f3afb427-c00f-455e-a50a-2380bd832be8"
      ]
    },
    {
      "cluster_id": "af183b48-72bf-4947-8e38-5272b737f76b",
      "members": [
        "94fdde06-df4f-4df1-b0c4-693a467e696f"
      ]
    },
    {
      "cluster_id": "197fe725-a0a9-40f8-a6e9-956dd052b066",
      "members": [
        "c64c6898-a3bc-4a01-8409-7233c926f445"
      ]
    },
    {
      "cluster_id": "fcd78a45-418d-433f-807b-b94b3ba2cade",
      "members": [
        "35984706-6e13-4b33-807d-ff8ef361fb10"
      ]
    },
    {
      "cluster_id": "c155f6c2-50ad-4998-b29d-ef85effa1839",
      "members": [
        "1e94c676-527c-4bd5-8763-e83bd1450b58"
      ]
    },
    {
      "cluster_id": "26461fc6-994b-44dd-97c8-95b6341a4a6a",
      "members": [
        "efd119c7-d615-439a-8aa4-990e680242d0"
      ]
    },
    {
      "cluster_id": "a0f8e5d7-b3ae-4af7-8eb1-d7fefd231acc",
      "members": [
        "6c092750-6909-4156-9cc6-accd6e480dad"
      ]
    },
    {
      "cluster_id": "e7def08b-a4be-4464-b5ad-7e8f1dfa8752",
      "members": [
        "5ccbd8ac-cc11-4cf5-bbf6-831b95c0d4b7",
        "7d7705c5-3255-46c4-a61d-08ef3d3eda8f"
      ]
    },
    {
      "cluster_id": "2a265a62-6ee2-460d-b6fd-ab72b8f23578",
      "members": [
        "2652e037-d6c4-4911-907a-f5e747275327"
      ]
    },
    {
      "cluster_id": "a1632082-229c-4e1d-b6b1-8334d7ed7db2",
      "members": [
        "573e3562-d1a1-46bf-8be0-fbcefbd16c8f"
      ]
    },
    {
      "cluster_id": "2ac509be-786d-4ed0-abcc-15ecf7e6c4ff",
      "members": [
        "155846a9-19fb-4b95-9ea4-7b57e4c3bca4"
      ]
    },
    {
      "cluster_id": "12efff4b-e0b1-447e-aeb7-828004c5cfde",
      "members": [
        "3ba2c584-b208-4cf3-a984-fdd7ffd124ec"
      ]
    },
    {
      "cluster_id": "bf1e9c00-6f00-48d6-9611-285baac7022b",
      "members": [
        "b5dd77fe-0b9b-4880-8785-6e1e0a99c6fe"
      ]
    },
    {
      "cluster_id": "5238def0-ccfb-4f27-b836-f20f9b7dd70b",
      "members": [
        "d1de676d-b880-446c-a5a1-788e72def238"
      ]
    },
    {
      "cluster_id": "b65de138-2e69-44b3-acdb-00d152bc8245",
      "members": [
        "d81be451-c47f-490c-94db-1a7d79073003"
      ]
    },
    {
      "cluster_id": "6a2ad136-bcb6-47c4-8c1f-40e9c58978da",
      "members": [
        "69e680fa-5202-48b4-9763-5796b740d7b3"
      ]
    },
    {
      "cluster_id": "210242d8-e5cc-4762-9912-b262084ebeb4",
      "members": [
        "aca610cb-ba4b-476e-8be6-a5049be6e4d6"
      ]
    },
    {
      "cluster_id": "c3f83d4c-9f83-4fe3-befa-1e9b93dee510",
      "members": [
        "d4ae80b3-251a-4204-ae6b-a6b712097b11",
        "39dff10d-9b73-4d10-be22-8229252a8485"
      ]
    },
    {
      "cluster_id": "db81e344-8970-492b-8ff5-c4f2bdbaa947",
      "members": [
        "5d3111bb-3a10-404d-a764-581bac6c54b3"
      ]
    },
    {
      "cluster_id": "e65823f0-739f-4ed0-bd57-83b926046577",
      "members": [
        "b5f3114a-640d-4d7b-869f-0e131b24e550"
      ]
    },
    {
      "cluster_id": "5833eaa5-8c9c-42b9-bd12-8cdf781ec725",
      "members": [
        "b28bc3af-e32f-4a1b-b264-d4c096c65ae2",
        "99ca030d-febe-460a-a6cc-7fb6bfd60359"
      ]
    },
    {
      "cluster_id": "cca76b6b-f388-4f7e-8293-b55584460643",
      "members": [
        "372ed784-1786-455f-9495-acdeba1d2936"
      ]
    },
    {
      "cluster_id": "58f1ee6c-cb8a-434d-b4d0-2f32913f3f4e",
      "members": [
        "6ca9bb38-8395-4d31-b66b-202d55eccd5a"
      ]
    },
    {
      "cluster_id": "c8c0e353-5277-4897-8ef8-4773b9d6e6cb",
      "members": [
        "5cf56acc-4b7a-4a64-9bad-4a8be36aadb8"
      ]
    },
    {
      "cluster_id": "3e775727-96fa-467d-a309-22a5101e04e9",
      "members": [
        "feda4a1f-7f7d-491b-b1fd-6b694b094251"
      ]
    },
    {
      "cluster_id": "4572f15a-5436-48cf-a1f9-d3e141616965",
      "members": [
        "5bc9d59d-3e08-49dc-a4ea-6d714073f5e3"
      ]
    },
    {
      "cluster_id": "a0aafb48-1cc4-47f3-9cc7-073b87c64efc",
      "members": [
        "52aa1df0-f8ca-4316-bfea-510ee0dca9f8"
      ]
    },
    {
      "cluster_id": "3b1f0ed9-3201-46c5-93e3-016f26c4d261",
      "members": [
        "f87cf1d0-7705-43a7-b299-66a0b8f410d1"
      ]
    },
    {
      "cluster_id": "152e2cd2-1d15-4787-b90e-76e34ac56ace",
      "members": [
        "7603dbcf-c486-4b87-a70e-c184e0f84205"
      ]
    },
    {
      "cluster_id": "55a53a4b-b30c-483d-9f7b-8c999d5c2f62",
      "members": [
        "b3df1efb-92d6-409e-9578-dee9453bab7a"
      ]
    },
    {
      "cluster_id": "0f3e5cb9-90ce-423e-bbb3-4a331e7ddd35",
      "members": [
        "a90738dc-e970-4f65-9ad7-87cad007cb06"
      ]
    },
    {
      "cluster_id": "dde390b5-1a05-447f-86aa-a25992be6bfd",
      "members": [
        "ba3e719c-7b83-4dc2-a7a2-229abb53627c"
      ]
    },
    {
      "cluster_id": "0addd203-38b6-4e2c-8fed-432e5b8aac5a",
      "members": [
        "0867dfb2-6550-4d16-96e0-9c112ebcc521"
      ]
    },
    {
      "cluster_id": "6dd833f9-26f5-4505-8729-234f3f5eeeb4",
      "members": [
        "417104d8-a428-493b-a2bb-56e5b26cd68e",
        "d133f617-ddcb-4c57-9aa9-ec5590508b88"
      ]
    },
    {
      "cluster_id": "2c351118-b702-46fc-bce1-27477e956eb0",
      "members": [
        "593f6426-444c-4459-a892-de1960a92502"
      ]
    },
    {
      "cluster_id": "7353e857-402f-4705-bd75-9efa4acaaedb",
      "members": [
        "4d989105-9804-4c26-8239-2884525d14ff"
      ]
    },
    {
      "cluster_id": "1a807d7d-9b68-443c-ad9d-52b339476997",
      "members": [
        "2dbbe5cd-42f6-45aa-a8a6-147b66bc874d"
      ]
    },
    {
      "cluster_id": "97b36cda-ba8c-4a83-864b-060595445ba9",
      "members": [
        "ee909956-ba2f-422d-b13b-3dd1f7c8b0a7"
      ]
    },
    {
      "cluster_id": "3a7c04bf-2c54-4817-990d-55771d584811",
      "members": [
        "5dd54d37-08e5-4109-9c4b-4a0b1db9cb64"
      ]
    },
    {
      "cluster_id": "2951f722-7d9f-4f1b-b69b-0dfe73efebd5",
      "members": [
        "df649152-fc96-44a7-bac6-d0373f7143d2"
      ]
    },
    {
      "cluster_id": "98bac582-09cd-476d-9519-fe434dffcb9a",
      "members": [
        "b0a29215-1b63-4e99-a442-00bf3c3eb3fe"
      ]
    },
    {
      "cluster_id": "df17af70-aa4f-46d9-b191-eb3b4eeac1ef",
      "members": [
        "7121db76-67ef-4f89-a205-949d1d9f7976",
        "6841c086-c308-4290-86ec-48a20ac686f3"
      ]
    },
    {
      "cluster_id": "5995c9ca-98e0-418d-a93b-a662311da0c9",
      "members": [
        "8b3c0685-eb3b-48cf-bcf7-908a949ba76e"
      ]
    },
    {
      "cluster_id": "7f43c7d3-2a4b-493c-b3f0-a53355ae39a3",
      "members": [
        "34a941ed-42a4-4f53-9fa5-2137d04d7eeb"
      ]
    },
    {
      "cluster_id": "7b6f6e44-c4b3-44b4-af65-8b15cce351d4",
      "members": [
        "b18f674e-cee6-4006-9361-fbfe9d0261c9"
      ]
    },
    {
      "cluster_id": "05e481b3-f988-4990-a833-5d6d33d27a4c",
      "members": [
        "bcefaa54-3983-4328-9425-fb1201012286"
      ]
    },
    {
      "cluster_id": "f58e8498-102b-4b72-96b4-c6d5b3fb97a9",
      "members": [
        "4860699b-f10d-435c-a3ac-45cdf365dbba"
      ]
    },
    {
      "cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
      "members": [
        "e576c123-4c10-4108-a4db-311f2e5292ce",
        "7ae4bce7-e6cf-4723-b7da-3c62d70ebaa6"
      ]
    },
    {
      "cluster_id": "e58c74de-137e-4144-8780-c4e86fcc480a",
      "members": [
        "c96db0fc-892b-41e2-bab9-94a5316354f5"
      ]
    },
    {
      "cluster_id": "8499f04a-3cd9-4588-b8dd-3abc1c538bcf",
      "members": [
        "50f1174a-08eb-4deb-95ba-76f62d759c76",
        "e70bbfc7-4a2f-41e6-b9fd-3d7557e55620"
      ]
    },
    {
      "cluster_id": "0f1cacf9-3df0-4d00-8952-b3fa5195f1fb",
      "members": [
        "ea95d42d-e9aa-45b6-af5c-976b9c11f2ba",
        "5d97ba40-893d-4e0a-9deb-9667147e6912"
      ]
    },
    {
      "cluster_id": "212176d0-9b06-497d-a8bf-0b53076513ff",
      "members": [
        "b023faff-5b70-40e5-b254-11c7f10c29ec"
      ]
    },
    {
      "cluster_id": "4a3bc772-20e9-4711-acc4-eb16f1a71bea",
      "members": [
        "b1e0d961-3385-472c-8e94-26289b31ec29"
      ]
    },
    {
      "cluster_id": "cd4e973d-ac94-4c83-952d-356fab535a21",
      "members": [
        "fa2ae5c7-93c7-4595-a5db-6732ac0edaed"
      ]
    },
    {
      "cluster_id": "ef502c1a-5f03-41b4-be90-14e6e1785625",
      "members": [
        "42750b95-0b11-44f0-8b26-122cab54ba96"
      ]
    },
    {
      "cluster_id": "3a774e33-2c16-4d7b-91f8-38103798acd4",
      "members": [
        "f0663ed2-c5fa-4b7d-99ed-494d2b27231c"
      ]
    },
    {
      "cluster_id": "4eb89d26-0914-45a8-8a2e-98708f9a3315",
      "members": [
        "aa03710a-4889-481e-a336-bbd930f5f797"
      ]
    },
    {
      "cluster_id": "109acea7-1d98-4f39-a38c-6bb5919965c9",
      "members": [
        "a71525b5-768c-4767-8b13-031710af5365"
      ]
    },
    {
      "cluster_id": "6103c4f7-8bea-436e-90d7-0ed75fe275c5",
      "members": [
        "31dfdbea-5af4-44b8-87f0-4cabe7e56d41"
      ]
    },
    {
      "cluster_id": "ecc32ba8-bd1c-43c6-8192-e0502c1f14b7",
      "members": [
        "1d38276f-ddd7-4554-b6c6-5dd3f82835b5",
        "f236c3eb-1e72-435c-8a05-422be25ed158"
      ]
    },
    {
      "cluster_id": "c21b5cff-dd9b-418d-82f4-ad5049c002d9",
      "members": [
        "2c218d15-cd5a-4f9a-a7cd-8391abee9126",
        "75deecc6-6c67-4640-8c9d-7b6492f73f3e"
      ]
    },
    {
      "cluster_id": "c438220c-6784-49f7-a890-f0ef46c3304b",
      "members": [
        "d68d0851-8bb2-48b0-95f7-48e00ff3fa22"
      ]
    },
    {
      "cluster_id": "9ce1a265-b79e-4040-a0e8-f1a6fbb59f67",
      "members": [
        "2de9d081-90ae-4725-be06-bc7997c3d9a4",
        "602a284b-62dd-4480-a4ed-2f81e13007e2"
      ]
    },
    {
      "cluster_id": "e15501de-8202-4040-803d-8b5cbf6cf53e",
      "members": [
        "86d3a938-31f3-42cc-be89-5a26acaefcd1"
      ]
    },
    {
      "cluster_id": "5d276603-9c3a-417d-bd11-e8b613249dd5",
      "members": [
        "c56a3e4f-f384-41f3-9b59-2851b9d79bec",
        "18a1c6d8-94f6-43cf-87cc-29cc134dcb1c"
      ]
    },
    {
      "cluster_id": "0b400fd1-082b-403b-9ea9-8d3710e7cc9f",
      "members": [
        "2a7dd7bf-03be-44c6-a411-eac8687044be"
      ]
    },
    {
      "cluster_id": "5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4",
      "members": [
        "d2aa06b0-d943-42f3-9874-e68f023ce72d",
        "e6596626-ac9a-4f3a-a794-8b5b8e63711b"
      ]
    },
    {
      "cluster_id": "0df84ab3-1fc9-4f33-8710-bd9c228e4c70",
      "members": [
        "8df4bac7-c73c-4dc0-87d2-f1212f551f20"
      ]
    },
    {
      "cluster_id": "8fa6723f-9341-42e1-b24f-456c511e2eec",
      "members": [
        "14726b46-4a6d-4be0-9221-effff997629d"
      ]
    },
    {
      "cluster_id": "ab1f8fac-3632-4188-90ae-a2c911b8425d",
      "members": [
        "b35936a9-3b33-43a1-ba7d-8853a326579d"
      ]
    },
    {
      "cluster_id": "91b0db25-32e4-4e5d-a32d-911732cbec28",
      "members": [
        "bebac3fa-67e3-471d-9bb4-7990f8ab9e35",
        "80600e8f-ca1c-4a49-a344-25d0c769ba95"
      ]
    },
    {
      "cluster_id": "8ae7ec4c-38f4-4117-962e-b6f044038377",
      "members": [
        "f7acb1a4-fdd1-4438-b4c7-bddf4228c92d"
      ]
    },
    {
      "cluster_id": "11b24695-ec58-4b46-8411-89fe4137f816",
      "members": [
        "1f60b707-aca0-4ce8-94a7-3c7ce5e28b30"
      ]
    },
    {
      "cluster_id": "574951aa-9eb6-4bdd-ac47-891b328c28fb",
      "members": [
        "0846c7c9-d25d-40f7-ba2e-ef15baf62f6a"
      ]
    },
    {
      "cluster_id": "8bc3dd02-5989-4bb6-8266-c27296d666f8",
      "members": [
        "5ad3a25c-7d15-4326-91f8-e874a44447dd"
      ]
    },
    {
      "cluster_id": "199242cb-5b3e-40d9-bf38-e1eddcf574fc",
      "members": [
        "db4c87aa-d882-424a-95d5-b5578f4f2152",
        "efa9739d-2b3c-43b3-985b-ccda54d8a4fe"
      ]
    },
    {
      "cluster_id": "68892c5a-f791-4608-9e40-b67a54dd50f2",
      "members": [
        "24566c65-9f5d-4bd6-b64c-2a2e091b9728"
      ]
    },
    {
      "cluster_id": "9a34d174-5513-4924-bed6-11de3ec56881",
      "members": [
        "1894f815-8eb4-4675-b927-6c8249ff84d1"
      ]
    },
    {
      "cluster_id": "1ec4a683-16aa-481b-9033-75779c52f6c1",
      "members": [
        "dcf9c1d4-e6ca-4d30-ace3-96e46222ed7d"
      ]
    },
    {
      "cluster_id": "21240c8f-29c6-42ef-b002-a537a743739b",
      "members": [
        "7322ffb4-986e-43b6-a289-c5827e12e8f1"
      ]
    },
    {
      "cluster_id": "334a3914-b271-4b2a-83fd-f8bd4dbb0c53",
      "members": [
        "b3c6fc08-ff96-4920-a354-15b497d8edfe"
      ]
    },
    {
      "cluster_id": "44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b",
      "members": [
        "fa2d3b46-ac03-4fcc-b33c-18d30b2c4e41"
      ]
    },
    {
      "cluster_id": "ebf0120f-ec3a-4a71-bd2b-88f212264387",
      "members": [
        "867931bb-b8a4-4cb6-ad3d-18694cdf5189",
        "dfa79aab-78cc-4f1d-a545-ffcbdadc9fd2",
        "4cdd0773-c021-4555-a38c-ec5f0bfad7cd"
      ]
    },
    {
      "cluster_id": "1e8d5556-2c0c-4097-b606-9907a5dd2afc",
      "members": [
        "8ced6a55-2895-4cc2-a608-c1df3c474d3b"
      ]
    },
    {
      "cluster_id": "04fd43b1-9ee7-43b3-b1fc-e9fca576658d",
      "members": [
        "20f56042-1a06-499a-9a53-f1e0b345af51"
      ]
    },
    {
      "cluster_id": "0119782a-5d22-485c-b58b-6c82b20e788c",
      "members": [
        "6d859cbf-141e-4be3-88e0-87f0a8be70a7",
        "402a5e79-9f4c-4cb8-9b67-00a92037de67",
        "839ef5b4-46fb-4fc6-b490-2b3b13d09a4f"
      ]
    },
    {
      "cluster_id": "ff47f0b3-49ae-48d8-b9cf-5707589bed0f",
      "members": [
        "2f03eb76-3789-418f-acd7-9c89021472ee"
      ]
    },
    {
      "cluster_id": "f50144fc-3b9b-4e34-ac6c-5191d30445d0",
      "members": [
        "c2ffff69-9282-4c9a-8f22-78688403761d"
      ]
    },
    {
      "cluster_id": "5ac433e4-bd1e-455d-8c24-e981eb354d77",
      "members": [
        "c5e44e6f-0c01-4822-b77a-dc30293d5ea7"
      ]
    },
    {
      "cluster_id": "be29b74d-f560-4279-9339-cf00d4dac2b0",
      "members": [
        "f4c4875a-42a8-4b5b-b769-7eec26034c77"
      ]
    },
    {
      "cluster_id": "492eadfb-99f3-4bc3-a9af-afa12d93eb99",
      "members": [
        "79d30802-4291-48d8-bf33-f5ca167da388"
      ]
    },
    {
      "cluster_id": "de7a466b-9657-42fc-adc1-63e65b4ec1ea",
      "members": [
        "d229a86e-367a-47c8-903e-80f4d9e82156"
      ]
    },
    {
      "cluster_id": "6b000975-482c-4a87-97ba-4b7f79318bd6",
      "members": [
        "b77e829a-afd0-4982-a1d0-632e6e32244c"
      ]
    },
    {
      "cluster_id": "11210f68-2915-41ff-b25a-a55a575f9528",
      "members": [
        "ec0e07a0-d0c8-43d5-9844-0943301e2a36",
        "94c87795-abb6-468e-b1bf-4a1f72916947"
      ]
    },
    {
      "cluster_id": "43fa6264-b651-4eef-9023-b4483c40f5ce",
      "members": [
        "86784e6c-8177-4b9d-a572-6c55c2a97eb8"
      ]
    },
    {
      "cluster_id": "ff70f7bd-e1b1-44ea-8b32-024f3d1917ed",
      "members": [
        "41fc545d-ae89-4a1f-8d9a-18c06042a01e"
      ]
    },
    {
      "cluster_id": "1da5d8fa-d5b3-4c58-9989-3b5775687e42",
      "members": [
        "c2847424-d6f6-48ec-99f4-a78270737a29"
      ]
    },
    {
      "cluster_id": "bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a",
      "members": [
        "c63562e7-2f47-4cef-bd74-f956b86a4576"
      ]
    },
    {
      "cluster_id": "5197019b-eb26-4b32-8e4f-5890ab4e562a",
      "members": [
        "a9ca3233-bd0a-41f1-b2e0-8f1f725fb225"
      ]
    },
    {
      "cluster_id": "24d4d508-a837-441b-b87c-de6ead3d7582",
      "members": [
        "7b7ca705-46e3-4c64-9380-8eb6e0d18334"
      ]
    },
    {
      "cluster_id": "136829a8-989b-4ffa-8ef0-ec23f5f18819",
      "members": [
        "20358a0a-a0d9-4286-89ba-775b060e8441"
      ]
    },
    {
      "cluster_id": "b570ae3c-f72b-47a9-b995-64ca6b5f3ae0",
      "members": [
        "a3f7a543-8c54-4f0f-8be8-28dc9d6c0dba",
        "735c5752-3e87-4fc3-b8bf-149a8cb9936a"
      ]
    },
    {
      "cluster_id": "059205f2-0c13-465b-ba40-83a1ffcbcaa3",
      "members": [
        "21b0d791-0ab6-4fbc-a453-4665aa2e2382"
      ]
    },
    {
      "cluster_id": "05302999-a145-4cb2-83a6-b2cda0247938",
      "members": [
        "3442f73e-73e5-4882-8dab-66506922b48f",
        "6b684f88-2189-44bc-ba7b-ff150306e2c6"
      ]
    },
    {
      "cluster_id": "6bcd764d-320f-4851-ad8b-859177f022bf",
      "members": [
        "98ad1a45-cda6-4e1f-8781-f3b161967bcf"
      ]
    },
    {
      "cluster_id": "0c6c9e5b-f8cc-4939-8319-4baf55259b87",
      "members": [
        "2edc3bf0-a4cb-4dd7-9c14-a4818bf63cad",
        "4493c186-ce66-4d2c-8241-c61003cee988"
      ]
    },
    {
      "cluster_id": "89b28f7e-be14-417b-aeba-019498e50195",
      "members": [
        "88214d23-e54a-4adf-b1c6-03685d8f9c6c",
        "02f967fe-336b-4f09-8746-3cbc504bfd90"
      ]
    },
    {
      "cluster_id": "62ff82d6-7a81-4618-a5c7-dad49908ecf4",
      "members": [
        "43fe8af9-e5e1-46ca-9396-01915f4ec799"
      ]
    },
    {
      "cluster_id": "dec098ce-5baa-400b-a766-6543ab0afe00",
      "members": [
        "63f980ff-a871-4da2-8501-e19ef4784b0b",
        "d4310cbd-b465-4be0-904c-ddd4775a9508"
      ]
    },
    {
      "cluster_id": "59d7630c-86a6-4185-b052-67ad13c627a8",
      "members": [
        "244fcfc2-dd34-4fbe-98e4-81f80c8c08c9"
      ]
    },
    {
      "cluster_id": "8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9",
      "members": [
        "709e80f4-fb04-445f-b9c8-885503b4171d",
        "3b9d9666-2869-4df3-9b66-779b29564f56"
      ]
    },
    {
      "cluster_id": "77ce5be7-73f4-4876-9446-d5aec1b02a1c",
      "members": [
        "b6e88a3f-5dab-496a-8af6-b690d55aa904"
      ]
    },
    {
      "cluster_id": "644ce0a3-b992-4dbe-be7f-558277802f15",
      "members": [
        "e81c3aa2-be13-43d5-9a64-6562964c293a"
      ]
    },
    {
      "cluster_id": "258085e5-fc49-48d1-b3f4-3f9862c3ba91",
      "members": [
        "50cc82f9-6fab-455a-bcc9-d17aed021f1d"
      ]
    },
    {
      "cluster_id": "21228a2d-48c0-43f0-b18d-e85ff94cdb4e",
      "members": [
        "0503bed5-4d7d-47ad-bd61-fa9f13662226"
      ]
    },
    {
      "cluster_id": "f8ceed1b-ae48-442b-9e71-03f2203d7e38",
      "members": [
        "823f891a-b607-43cf-9976-5c5774141517"
      ]
    },
    {
      "cluster_id": "a9f88531-6abb-40c2-bba6-de053eb80cb0",
      "members": [
        "d4ca06b7-dafd-4b18-9208-e5fda4a6070c"
      ]
    },
    {
      "cluster_id": "42d845ed-aaed-4d48-a0e4-2928cc3ba602",
      "members": [
        "24994368-cbdc-4f55-9672-f292140ffb65"
      ]
    },
    {
      "cluster_id": "af144d2c-f8aa-40f2-9250-f41cd71f8fd9",
      "members": [
        "0cd33477-f197-45bc-9d03-254b7ea91b03"
      ]
    },
    {
      "cluster_id": "e8d873fb-d6bf-4c6b-9328-dabcc490fe91",
      "members": [
        "ba2de5ac-a509-44a5-bbe8-5a1276566e62",
        "da22d1f6-dbbe-49e7-89e8-194fddf2bee9"
      ]
    },
    {
      "cluster_id": "b180d822-88c1-4c5f-a386-c975497c4a85",
      "members": [
        "3438a90c-54f2-4270-84a6-974f333b08d2"
      ]
    },
    {
      "cluster_id": "14d8e253-98cf-4b3d-83df-8665b7ba0f5e",
      "members": [
        "142195bc-ce0a-446a-a197-82133bc1bfda"
      ]
    },
    {
      "cluster_id": "21956ecc-f782-4f55-8347-f78333fc6d97",
      "members": [
        "0baf6d0b-4f91-4d6a-9da3-83f030ad66e1"
      ]
    },
    {
      "cluster_id": "24f6a0c0-6612-4488-bc48-40d12340ab22",
      "members": [
        "717943a2-2909-4b7f-9745-882b8c2e2624"
      ]
    },
    {
      "cluster_id": "f34203f2-30b3-4686-b2f0-e124d8a67272",
      "members": [
        "5f2ca378-ca40-4a54-88b9-ce966ac550a5"
      ]
    },
    {
      "cluster_id": "3b793f1b-9892-4efb-9252-e394792997b5",
      "members": [
        "be381aea-1470-495b-a705-3f0402b74c43"
      ]
    },
    {
      "cluster_id": "07438861-a868-47ed-8a1a-288138dc65c0",
      "members": [
        "6618192f-d9d0-4608-8d78-16d5b77810b4"
      ]
    },
    {
      "cluster_id": "20c941a8-b922-48e3-8e56-e49e1a524fd9",
      "members": [
        "f4c3a3a5-c6ce-4414-b615-0c69fab214c7"
      ]
    },
    {
      "cluster_id": "7a8e190a-4532-4e4a-b5bb-60a049f869c1",
      "members": [
        "5e5c4927-3a0c-428a-bf40-0eb609878217"
      ]
    },
    {
      "cluster_id": "3c28af07-0879-4e0d-a892-8c0d97f3e49a",
      "members": [
        "0c5f39e5-63c0-4191-8b6c-40ae97875fb0"
      ]
    },
    {
      "cluster_id": "c83250c9-87a2-4ec5-822a-e2413ca91c91",
      "members": [
        "588a55b7-6e3c-45c2-8364-c5ef65a60b7c"
      ]
    },
    {
      "cluster_id": "958b1512-4a3e-4d41-927e-a3072dd9e9ef",
      "members": [
        "023c4c57-2967-428e-b72f-9beb8f0f4f20"
      ]
    },
    {
      "cluster_id": "33c9ef05-1d84-4ad3-be17-1fea5c70facc",
      "members": [
        "a5277d1c-96d0-47fa-b6cf-3d93de47a11f"
      ]
    },
    {
      "cluster_id": "87a15594-c8d7-4860-a888-b2469a7e65b5",
      "members": [
        "a9826696-7be0-438c-8926-1ad2257b1a62"
      ]
    },
    {
      "cluster_id": "d42df985-9fff-4c49-bac2-4cb2fef7ac9d",
      "members": [
        "ff2a806d-e6f1-460f-9f0e-712d721ec08f"
      ]
    },
    {
      "cluster_id": "b523cd60-7c0d-4c50-b41c-3522aed9c4b1",
      "members": [
        "c3257842-d857-4799-8fb0-ecbada1492d5"
      ]
    },
    {
      "cluster_id": "bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75",
      "members": [
        "0a533773-d2af-437e-b15b-24397d33e008",
        "aec47440-0cf6-4af2-9a55-32c0280b3e20"
      ]
    },
    {
      "cluster_id": "1a968bfe-5bc1-4f49-8a3c-fc2e0fdbf254",
      "members": [
        "a52a2dc4-9a7e-445b-840b-aa2a71bfc7b5",
        "3aaf279a-f852-4457-8c74-5b5f4414f3a4"
      ]
    },
    {
      "cluster_id": "e2621663-e9d9-45c1-9069-fa9d94c82303",
      "members": [
        "9f80744b-cde3-495c-a2c1-e651a81c9ae3"
      ]
    },
    {
      "cluster_id": "693ef972-4622-4c6c-9268-e5c6a072dd31",
      "members": [
        "7f1b05bb-bbef-4f51-accd-291a84b9c779"
      ]
    },
    {
      "cluster_id": "dde1cfea-875f-4bd7-a73a-639065b04c0c",
      "members": [
        "22a6c6a7-6139-48a0-ae57-b4c6ba1bde74"
      ]
    },
    {
      "cluster_id": "b2568d68-53d4-487c-b724-0456b247a886",
      "members": [
        "ce65051a-c2b7-49c5-b4ce-6b061e39b289",
        "7d7b06cf-63d6-4416-a5a1-d200e94b5a97"
      ]
    },
    {
      "cluster_id": "10bf083b-35c8-4b77-a2d9-e4cb3813d9fb",
      "members": [
        "798f535c-e291-4f87-bb0b-4a6a4f468191"
      ]
    },
    {
      "cluster_id": "15187e94-76d4-4323-bc9d-67428e138efd",
      "members": [
        "79fca050-3a9d-45f9-9935-b4b5b72a6503"
      ]
    },
    {
      "cluster_id": "2fe8d49f-63a1-4171-af68-9824e47b825c",
      "members": [
        "c993fc46-d4e7-47cb-a26e-d3c5e2928b18"
      ]
    },
    {
      "cluster_id": "93d1eed5-3c1d-4407-adac-a9d52f51c6e8",
      "members": [
        "553f676b-b93d-4694-8dc9-9f0bb6432591"
      ]
    },
    {
      "cluster_id": "5acf0ec4-be26-4926-a6a6-508ec71aaa6e",
      "members": [
        "4976ee3a-3784-4d3f-9857-73c8195327ad"
      ]
    },
    {
      "cluster_id": "e31510b5-776d-40cf-9a10-afb0bb1a3f0b",
      "members": [
        "c20f1eec-25ed-42b6-ae82-6b5b0393c7d3"
      ]
    },
    {
      "cluster_id": "e6bef1f7-9387-45ab-918c-0df479862034",
      "members": [
        "033f04c0-b501-478b-9f25-fa6b4d2ca4ad"
      ]
    },
    {
      "cluster_id": "14a12b13-500d-4488-86b9-0f65fe548f9c",
      "members": [
        "37839e78-27f0-4435-b8ce-f71a4f116bed"
      ]
    },
    {
      "cluster_id": "f1461740-3766-4178-84e8-17d9b70838ae",
      "members": [
        "e5d00f8a-9ceb-4743-83a6-8d6bf5883043"
      ]
    },
    {
      "cluster_id": "6c947694-8652-4e58-b4d1-40be43d3a77b",
      "members": [
        "8e186830-bee5-4aca-9ba9-f6ab92a6da54"
      ]
    },
    {
      "cluster_id": "81062452-735a-45ec-ae26-d06b90c45ed4",
      "members": [
        "e3a04279-fb73-4013-9f74-419385217d64"
      ]
    },
    {
      "cluster_id": "9571d5a8-94c8-43e8-bdfc-93e045f2bdd4",
      "members": [
        "758b9d79-89df-4867-81a1-838437e6a859"
      ]
    },
    {
      "cluster_id": "2ab59d09-09ca-4583-9e99-8189ce8c9335",
      "members": [
        "354932c8-6ae3-482e-80c2-1ec5fb490ed6"
      ]
    },
    {
      "cluster_id": "ab1842ba-5e92-4ba8-ab55-1241a116a859",
      "members": [
        "ef3e88e0-f84d-4da8-96d8-9f775591b9f0"
      ]
    },
    {
      "cluster_id": "c298484d-a7d5-4e80-ac66-217221dc6d85",
      "members": [
        "943c7207-e112-481d-9818-bf98c872d3f1"
      ]
    },
    {
      "cluster_id": "637d133e-6c19-4fa2-b174-de1d016bd9bc",
      "members": [
        "c05b569b-31f7-4337-afce-74533292fc0b"
      ]
    },
    {
      "cluster_id": "44a47e28-efc2-4e0c-b9c2-18a93b3b20be",
      "members": [
        "3f92c6cf-d089-4d51-afd0-5cc8bf719664"
      ]
    },
    {
      "cluster_id": "5518570b-ceeb-400e-8720-a531292d57ce",
      "members": [
        "f579b180-4bcf-4616-8cca-c6611dc5d22e"
      ]
    },
    {
      "cluster_id": "8ae88722-b8db-4d5b-b13e-130f65630e05",
      "members": [
        "9a51ca5a-08a2-471d-b0ef-7059646f9b98"
      ]
    },
    {
      "cluster_id": "86e16ba9-dba8-4cea-a0d4-df8a8a69d565",
      "members": [
        "4d3c833c-1a92-4746-ad0d-5c2840c14110"
      ]
    },
    {
      "cluster_id": "74f0249d-eead-4904-bdd3-cd8cfbdb6b82",
      "members": [
        "fb699657-8103-453e-938a-f5daa0ea13d1"
      ]
    },
    {
      "cluster_id": "e6759e4c-f697-49ce-a969-2f596e5c4293",
      "members": [
        "cc684206-59ef-4f1d-9a3e-0ff4eafb7fca"
      ]
    },
    {
      "cluster_id": "329c69a1-8578-4615-a95d-4068857af2c9",
      "members": [
        "85dae113-29da-4a75-b868-215745825ee0"
      ]
    },
    {
      "cluster_id": "92b8820a-be27-4c75-96b0-6d6932996a93",
      "members": [
        "ac309972-39c0-4c22-a9a8-2e21189a182b"
      ]
    },
    {
      "cluster_id": "baa116d7-3e4a-4d22-809b-fdab138f8d83",
      "members": [
        "23d5acde-9eb1-4641-b65c-7f5d94d7b611"
      ]
    },
    {
      "cluster_id": "b2871022-57c5-48f7-adcd-caeceec2edeb",
      "members": [
        "0c3ae337-f9bd-4232-8dfb-2940624107d2"
      ]
    },
    {
      "cluster_id": "99d9484d-46ae-4ca2-98a1-dd3e0aeee99d",
      "members": [
        "9f15f89c-d1c8-4a2d-8528-9d31c8654f08"
      ]
    },
    {
      "cluster_id": "f8755b86-ae98-461e-a3ac-2bd5b6ec4310",
      "members": [
        "4e85a632-df9b-4b75-a026-4f6406a638e4"
      ]
    },
    {
      "cluster_id": "da2845de-4e1b-492a-a6b0-06fd4584650e",
      "members": [
        "bfa02948-129d-4df1-8d02-32c7106ce1a7"
      ]
    },
    {
      "cluster_id": "45d5305e-53a9-4659-a1a0-2bf0495c5055",
      "members": [
        "8f2a8ba8-3a4a-4936-bf7f-34faee9aa1e3",
        "8317dd6d-21d3-4041-ba08-d341e9d5d4ec"
      ]
    },
    {
      "cluster_id": "7123d027-fb9c-44c1-becb-087b98c76740",
      "members": [
        "f97d0478-9be5-4fc6-a5f1-680f08d3eb14"
      ]
    },
    {
      "cluster_id": "cefbf586-5d05-477f-8675-6637fb8781a5",
      "members": [
        "e3ab94bd-6ae1-4890-93b1-11b533431a94"
      ]
    },
    {
      "cluster_id": "5a861756-5d94-444c-84a0-fab63d482e8c",
      "members": [
        "dd5773a2-71e4-444d-8c08-6f13e54af348"
      ]
    },
    {
      "cluster_id": "09f8ca5f-e359-4e32-b6bf-f706de588232",
      "members": [
        "0a1a6190-eb21-4894-b6b5-c8613a05b0a6"
      ]
    },
    {
      "cluster_id": "0f388428-daa1-4ce6-a7b1-8c553ad3896d",
      "members": [
        "093d75a8-822f-4e74-8fc9-d38c1bd278b6"
      ]
    },
    {
      "cluster_id": "370919c9-f171-4096-adac-3abd415be93c",
      "members": [
        "e3571f4c-65f1-4db3-897f-fe9736b10446"
      ]
    },
    {
      "cluster_id": "a9096ed8-3c07-4fd9-a21c-9fdb59fe1353",
      "members": [
        "fe77b063-ffc7-45db-bf3c-30d1345de127",
        "b93a9e77-ab9a-4624-b53a-56550ad2223d"
      ]
    },
    {
      "cluster_id": "9f57df89-5e8e-4a14-b028-a41d27973fb5",
      "members": [
        "e598a674-f687-420e-961c-9e37ddf343d7"
      ]
    },
    {
      "cluster_id": "5c0df4bf-ba62-40d1-a306-8313dfe790e6",
      "members": [
        "e3c43223-3600-4873-a0bc-96a7a3028392"
      ]
    },
    {
      "cluster_id": "839faa06-15df-459d-8f1d-015981c670e0",
      "members": [
        "733f152b-a575-4502-b706-11073df8c68c"
      ]
    },
    {
      "cluster_id": "424a981a-fddf-4933-92b1-158cbba9a861",
      "members": [
        "7c2428b6-5481-4361-bde2-ecc9321746bb"
      ]
    },
    {
      "cluster_id": "5d8dea5a-b22d-41be-9ea5-91141c9a7614",
      "members": [
        "cd709fbf-cb82-4ab7-b2c2-2da875059189"
      ]
    },
    {
      "cluster_id": "8b2d10cc-94ea-4d53-a196-ecebccd79020",
      "members": [
        "3ac406b0-e68e-49a0-bd1b-2528853d2cad"
      ]
    },
    {
      "cluster_id": "a72e319a-9e87-40b0-a2c4-a95e4857ac8d",
      "members": [
        "65185d34-b527-468c-beb7-4b55954d027f"
      ]
    },
    {
      "cluster_id": "dfd567bb-1650-495c-ac2d-4d240d441b79",
      "members": [
        "7b1d1801-aa76-41eb-9f0b-d7d9461b7987"
      ]
    },
    {
      "cluster_id": "8d8dbda6-96b3-4738-b7a8-777f920a39be",
      "members": [
        "589edca3-47ff-4fbe-80de-c38bf691870b"
      ]
    },
    {
      "cluster_id": "cc2021eb-f979-4db2-af0b-d0533b90627c",
      "members": [
        "d41f05ae-a077-4b43-a1ad-50f0a3215fad"
      ]
    },
    {
      "cluster_id": "4a042392-1467-4ea4-a1a6-548cd972a82d",
      "members": [
        "0dda44fb-e789-409d-8884-402c50cfbf09"
      ]
    },
    {
      "cluster_id": "ccd217d6-af54-4ddb-bc5c-7413749df148",
      "members": [
        "c8ab785c-bdf9-4974-a4a6-0fa8e1e04427"
      ]
    },
    {
      "cluster_id": "009e9d6b-ab96-416d-b96e-b7eaada086cf",
      "members": [
        "0f5a9041-d107-4637-af27-c903436d7f31"
      ]
    },
    {
      "cluster_id": "40860ef8-1ebc-45f7-84a0-735bcdaf070c",
      "members": [
        "a9f42078-b13a-4273-b720-2b85621b9479"
      ]
    },
    {
      "cluster_id": "451cf0f3-38b6-4124-8f93-0e300d12c170",
      "members": [
        "96bbb94c-4f84-462e-8d41-121eef67b842"
      ]
    },
    {
      "cluster_id": "d17d8e48-7844-4b9c-9bc0-e31d87299aef",
      "members": [
        "feef1b5d-6fca-48b3-b6e7-7e296b05c53c",
        "ec89a7d0-444c-4a68-8ab2-49873e2d905c",
        "4227afee-e3b9-478c-ab36-4fde24ad8ff0"
      ]
    },
    {
      "cluster_id": "731adffa-9e59-4f19-8d10-ec191098b454",
      "members": [
        "b5ae45b2-5d16-4b5b-aa3a-5576d28dd426"
      ]
    },
    {
      "cluster_id": "9f0480ce-b886-46fa-98f0-af8144766c6c",
      "members": [
        "c9e9a73a-9805-4a55-a450-6162c6ec9b71"
      ]
    },
    {
      "cluster_id": "20ab2459-a6a0-4e45-aef0-5b2d6b529a0e",
      "members": [
        "17354fb2-74e2-4dea-b9f6-3b313bc2f042"
      ]
    },
    {
      "cluster_id": "4496a4b9-1070-44a0-89bc-e244c8a53dab",
      "members": [
        "6bf5be7b-0915-44fe-9e53-1db09cfb0aa9",
        "fa5f8415-ce48-47e8-88c5-998e13fb6afc"
      ]
    },
    {
      "cluster_id": "3045aa88-88d8-4410-9d93-f305adb15fd3",
      "members": [
        "f2352fef-7f02-4458-a866-639bd458c927",
        "128b6e5c-66bf-47e9-8a97-73b4406df76d"
      ]
    },
    {
      "cluster_id": "6e43ff1d-8cc2-4d06-859d-7e968536001b",
      "members": [
        "45820d42-2355-436e-9fd0-498d37c06918"
      ]
    },
    {
      "cluster_id": "74c84f9c-121d-41ed-8a45-f4cdf85eb02c",
      "members": [
        "95cf57c8-db12-4b02-9ab4-5f125ec8e52f"
      ]
    },
    {
      "cluster_id": "57eb29a4-6d1b-4f98-a507-b97e4235688c",
      "members": [
        "4c6cf093-805b-4e3a-992f-9702969ee316"
      ]
    },
    {
      "cluster_id": "40739d2a-a8c2-4f74-ad24-d1d6db92d225",
      "members": [
        "de30d744-016b-4318-8ab1-056f6e5e884e"
      ]
    },
    {
      "cluster_id": "5677f10d-93dc-4b72-b95a-8bc4291ec487",
      "members": [
        "4a4a457b-1325-44eb-8e2f-f16ac98bf1da",
        "7c99c381-d341-4d06-986c-97983ad65b7d"
      ]
    },
    {
      "cluster_id": "4736fddc-4878-48ef-a211-f6b0740cc434",
      "members": [
        "ff19f0d3-d83b-4d15-9bc7-3f167453c19b"
      ]
    },
    {
      "cluster_id": "42b71be4-55d8-4880-8083-4a89c8557de9",
      "members": [
        "b5df04a7-2e6e-434f-b9a5-1ea3d3c335c4"
      ]
    },
    {
      "cluster_id": "dac4f0e5-e31b-44cc-a055-3ac65eec9d11",
      "members": [
        "61c001bc-aaeb-4697-ad48-4e975f4f2e0e"
      ]
    },
    {
      "cluster_id": "623ab1ae-1f19-46fc-b19b-929f64c7b525",
      "members": [
        "f275225d-6b88-4d4e-a09f-ec6c1ba1b714",
        "ee7c22a9-cb5f-4b56-968c-6ff4e664ea5b"
      ]
    },
    {
      "cluster_id": "565acc40-efdc-4957-85fb-8602f0587aa9",
      "members": [
        "36ec8ad7-b079-409a-bf22-79874f231a2e"
      ]
    },
    {
      "cluster_id": "a49a51da-aad1-43de-81b7-51f95b22eabd",
      "members": [
        "3a47fae3-bbb0-43a2-ba49-1814af0c3582"
      ]
    },
    {
      "cluster_id": "18413d30-3282-4a19-9301-8b0c9a57c941",
      "members": [
        "7729c1e6-daf9-43e8-8f05-13d5abb67363",
        "eea5831c-1818-49ff-a840-70bc989108d8"
      ]
    },
    {
      "cluster_id": "f4f13b9b-3296-4913-8eea-62ce1becaa2c",
      "members": [
        "ec3f7c59-e418-4dc7-9051-8e61a0e8e5e7"
      ]
    },
    {
      "cluster_id": "4370b159-681b-41a0-8da8-22c407b09da9",
      "members": [
        "22c7b5e2-c0b8-486e-ae92-b3478ba3a159"
      ]
    },
    {
      "cluster_id": "09e579b4-c608-4bc3-a02e-890bc6f5969d",
      "members": [
        "d7bc4506-898d-4cf0-99e3-6b4c693e9ba2"
      ]
    },
    {
      "cluster_id": "0a0082f4-5a11-4bce-aa5d-1877fddb104d",
      "members": [
        "f99a79a4-6ea5-487c-9ad5-126653491c6c"
      ]
    },
    {
      "cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "members": [
        "df0444fa-0108-44fb-9a41-a5ccb4264275",
        "628d2d95-6e88-45ac-9fba-404f17e734d5",
        "9843893d-6690-400b-ba52-b3d060a45f1e",
        "a6c78845-da38-43de-ba0f-357aff013c2a"
      ]
    },
    {
      "cluster_id": "dfe5555f-7179-45b9-9f7a-919fa1cc1569",
      "members": [
        "320d86e9-05f0-40f0-a64d-f3a23a09f492"
      ]
    },
    {
      "cluster_id": "4ea56329-d3e1-48ab-835d-a5cbc403dcf0",
      "members": [
        "e6b8b24f-3c1d-4b2f-8758-4cb1449207a6"
      ]
    },
    {
      "cluster_id": "df5b4e50-7d1b-4d7e-ae01-046530298250",
      "members": [
        "aae86df3-6521-4ed4-a063-13ca198344bc",
        "54cae87b-07e5-4e39-acd4-c29514c871df"
      ]
    },
    {
      "cluster_id": "e968bf8c-b2a8-4330-bf71-9cab4f6826a5",
      "members": [
        "9333691c-9fac-48f5-b168-51ba9ba9ce6f"
      ]
    },
    {
      "cluster_id": "c782b8c2-e8a6-49c0-98b9-40619e415dcd",
      "members": [
        "d1a16d25-6596-46f5-898f-d0b42f956fce"
      ]
    },
    {
      "cluster_id": "83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2",
      "members": [
        "6d0f0417-0ad9-40ba-bddd-2050e41aaf92"
      ]
    },
    {
      "cluster_id": "bbf49577-7eda-4f96-83ed-753d3b9cc708",
      "members": [
        "5767beb0-c933-4e88-9be9-fa25294894a5",
        "2c6d6c0c-581c-4afe-a3a8-fea66abbc95f"
      ]
    },
    {
      "cluster_id": "46a0b407-50f8-4cc9-968a-6955a0540862",
      "members": [
        "88586791-dac7-4eae-93f2-1f5088deaff3"
      ]
    },
    {
      "cluster_id": "1d8a91a4-e2e3-49c2-838b-462dda682ab0",
      "members": [
        "d2b91e1b-119d-4b46-a45b-d31503811126"
      ]
    },
    {
      "cluster_id": "affa89a3-9b82-426c-9616-b589325af10c",
      "members": [
        "e45969f9-8906-49c4-91cf-ca8b972acfa2"
      ]
    },
    {
      "cluster_id": "f15167ff-a614-4854-ae28-529950f00bdc",
      "members": [
        "476a7a56-ac30-4d52-9a28-cb6771609992"
      ]
    },
    {
      "cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
      "members": [
        "8f48c0c7-9599-48e9-8266-33bb81928adb",
        "4b32edf9-0d33-41e1-99d5-1ab79fdd6ba9"
      ]
    },
    {
      "cluster_id": "13dd3c2f-f547-4b94-b763-665ce078453e",
      "members": [
        "56c79572-5c21-4aff-8ee3-d0693b0a5f53"
      ]
    },
    {
      "cluster_id": "5284ded1-5c85-415c-af66-ad36ef47b3e7",
      "members": [
        "12ce5ef5-db4f-4329-b817-14e69033510a"
      ]
    },
    {
      "cluster_id": "452c2457-4da2-4edb-a49f-86f139410e4f",
      "members": [
        "a2032602-1b45-4927-8fd7-e58380efe7e8"
      ]
    },
    {
      "cluster_id": "d00bd384-4d89-4a56-8487-c419c52438e5",
      "members": [
        "c9dc8b79-d140-4e6c-a007-cee5b5e4d7df"
      ]
    },
    {
      "cluster_id": "fbea59dc-8fdc-4fcf-ac76-32627af107ae",
      "members": [
        "aa5e3ea1-6aa8-4949-b5ea-a17f75263501"
      ]
    },
    {
      "cluster_id": "fde51b3d-8646-4df9-926d-484efbe86dc8",
      "members": [
        "1d741e3f-f006-4b3e-a634-e8430d392812"
      ]
    },
    {
      "cluster_id": "71522ed0-7107-4dfb-8b87-e633332c4e3f",
      "members": [
        "5ffa8173-142d-46fc-8a46-e6ede611a7f7"
      ]
    },
    {
      "cluster_id": "e633b9f2-d6c2-4c51-83af-0aed2e577009",
      "members": [
        "b88d61fc-871c-45c6-9a1f-465e76dfe0e5",
        "fafcf85e-287c-4677-80fa-62bdaa6b7702"
      ]
    },
    {
      "cluster_id": "ec67de7a-3e2b-4e45-9df6-6bb76aa7ed80",
      "members": [
        "01d346e1-324d-498c-9e77-d15d8c02410c"
      ]
    },
    {
      "cluster_id": "af26e832-f248-48e8-93f5-fdb54d01a56f",
      "members": [
        "8752aaa7-c117-409c-97a5-33654f99a19e",
        "80ea9af8-8a68-4a19-ab6f-12c7ca5127a2"
      ]
    },
    {
      "cluster_id": "f9a4fce8-b5c8-4697-808a-9ac08e5be52f",
      "members": [
        "39ab6769-1890-429e-b317-731e9a4eff85"
      ]
    },
    {
      "cluster_id": "74f7c7d8-aba9-45e9-a386-fbb258dd884d",
      "members": [
        "22c52ca6-b7de-45b7-90e8-f17840ef578d"
      ]
    },
    {
      "cluster_id": "c6a49139-3f4b-48cf-8d38-e5b344108df3",
      "members": [
        "f36689c9-d8fa-49ec-849b-0826304fa11d",
        "01d989e5-2d84-4128-896a-c4bd413bca98"
      ]
    },
    {
      "cluster_id": "b5be89cf-6e40-4238-b7c0-13411fa17ce6",
      "members": [
        "09b4e52e-8c85-4f99-a325-574e2b0f7690"
      ]
    },
    {
      "cluster_id": "5a33a893-0ae3-4e2b-9f4c-02de9772f96c",
      "members": [
        "1ea2d7a3-eaf7-465f-82c9-4ff74a567e2b"
      ]
    },
    {
      "cluster_id": "cd1cad7d-4c68-4a07-b4fd-c8e01c9f94cb",
      "members": [
        "95591809-ea32-440d-bc8a-6614f1dc69ff"
      ]
    },
    {
      "cluster_id": "ced45aa6-b370-4a79-b76b-674fcd6c0668",
      "members": [
        "a98efa16-89b0-4b36-a563-e8a6964e5dda"
      ]
    },
    {
      "cluster_id": "73ed8dfb-71b9-42f0-9f45-a873045bd275",
      "members": [
        "4f973af5-b56d-47c9-bb96-aba7882312eb"
      ]
    },
    {
      "cluster_id": "6442657f-3626-4ac3-8a02-28b3c72e00ba",
      "members": [
        "ef196b0f-45eb-4409-8ae0-5474c6c35470"
      ]
    },
    {
      "cluster_id": "5ec8ba1f-609d-4689-8317-8045f6c09e77",
      "members": [
        "16c59c3d-069a-48a2-ae37-ad52d70c88d4"
      ]
    },
    {
      "cluster_id": "a5706e56-c643-44be-8e44-3c19fd9dcc29",
      "members": [
        "30a36220-c2d9-44cd-b29f-46744923b417"
      ]
    },
    {
      "cluster_id": "7bf63345-7700-41f7-861e-b298dc68ad2d",
      "members": [
        "9ee9fd26-4cda-4482-a159-a1dc52f4ac09"
      ]
    },
    {
      "cluster_id": "f309b6e7-458c-4f62-9d98-f12cb2e89c08",
      "members": [
        "4c7b40f2-2b81-4a1a-b5cf-5c2a0da3733e"
      ]
    },
    {
      "cluster_id": "a7436ce6-07d0-45e0-8628-2de252e4cb46",
      "members": [
        "7dd0ad39-1c10-4dde-b71b-8e7fc0ead843"
      ]
    },
    {
      "cluster_id": "8ff59597-495c-4ba5-b797-afb88f6bfce0",
      "members": [
        "e4116e8a-c10c-46d3-98cc-ee87429a5fd8"
      ]
    },
    {
      "cluster_id": "3d647896-bc7f-4815-a99e-768cb2498250",
      "members": [
        "f91205ea-2d89-4257-9aef-cc7efdc62003"
      ]
    },
    {
      "cluster_id": "99f11e8b-4375-4ee6-8be9-78b8355c6e63",
      "members": [
        "efa402f0-22b5-44d8-83be-4aefe71ff19f"
      ]
    },
    {
      "cluster_id": "7e245bdc-e727-4627-a96b-f1db937337df",
      "members": [
        "1cc700fb-8ae3-4f9f-9bbf-2d20e10fe90c"
      ]
    },
    {
      "cluster_id": "e11a5f48-4afa-40b5-8724-9f7420d483fe",
      "members": [
        "ba278d3a-b34f-4a39-b924-1c268c771e7d"
      ]
    },
    {
      "cluster_id": "30f8d995-4c8b-4d55-9cc0-91236f828d24",
      "members": [
        "b4b64a7f-18d5-4109-8ab5-2151c1eb53e0"
      ]
    },
    {
      "cluster_id": "194a083f-fee7-4bf0-b198-fa40c8bdfe21",
      "members": [
        "7e2549b0-4be4-4af1-a07d-178f191ff255"
      ]
    },
    {
      "cluster_id": "33588f3c-4f55-41eb-b5d2-57696a57221d",
      "members": [
        "6ff33f56-8167-4fb4-a217-9e2fd0587ed6"
      ]
    },
    {
      "cluster_id": "22fed294-324a-41e6-9f14-7b92ebc22681",
      "members": [
        "e4e4f22e-742d-4857-ac91-0adeb6cc7a75"
      ]
    },
    {
      "cluster_id": "9fc7f408-c42c-485e-91c2-a72960ff3158",
      "members": [
        "2a6bc326-3688-4af4-a70b-a9128cad92ee"
      ]
    },
    {
      "cluster_id": "82430ac1-c5b1-4777-ac21-a40819c2ad02",
      "members": [
        "d37b5b73-be79-4707-93d6-b1619e360bd7"
      ]
    },
    {
      "cluster_id": "d61fc1c9-1533-4eaf-88f3-8d0340ce2de0",
      "members": [
        "9e9314e2-b3b4-4bb0-bbb6-80e2a791d407"
      ]
    },
    {
      "cluster_id": "6dc49cf5-bbfe-4cdb-aa3e-bd6aa990f0c1",
      "members": [
        "6de9b109-7d60-4dbd-b946-2f2c248e99ab"
      ]
    },
    {
      "cluster_id": "d5dab78c-a52b-4ef8-8000-44988a029a7c",
      "members": [
        "f2dd708b-da06-4d95-80e8-dccc8a2c283c"
      ]
    },
    {
      "cluster_id": "8b93bbca-8559-4acc-9d3e-382347cd5269",
      "members": [
        "02712107-dcf0-4356-96ab-4e5cc05a1d3f"
      ]
    },
    {
      "cluster_id": "af3aa521-118c-415e-b54b-524628af7168",
      "members": [
        "d6bd9722-09de-4f4d-ab20-04a79de1c458"
      ]
    },
    {
      "cluster_id": "23dcfd5c-77ee-4590-92a1-d00d1da215c4",
      "members": [
        "d1a5138e-9a0e-41e7-9b59-b1ed6f92f735"
      ]
    },
    {
      "cluster_id": "199eabc9-e7b3-44cb-a574-bbc02ea956e5",
      "members": [
        "d244e0c8-2ef0-4e93-ab92-9c12d8a1b325"
      ]
    },
    {
      "cluster_id": "e3e8a87e-df24-4ad1-b44d-15176f0a0f6f",
      "members": [
        "86ce935c-a686-4874-b90f-73593cf768d2"
      ]
    },
    {
      "cluster_id": "86cde8dd-df84-48da-a045-d001baaf3298",
      "members": [
        "49c51996-7793-4d11-83a8-f7fba16e94b6"
      ]
    },
    {
      "cluster_id": "b98bb0fa-4594-47af-9069-f482aaa8d7c4",
      "members": [
        "46eefdcc-9153-4231-98d5-1f11bb28bd1e",
        "d593ca1c-6b0f-4383-b405-05cd1d56f441"
      ]
    },
    {
      "cluster_id": "0cffe066-8740-4f3f-9c12-d03f093733d5",
      "members": [
        "e6f87d0a-58ad-4a72-a8cb-9808b8bfb5ff"
      ]
    },
    {
      "cluster_id": "ac35f635-837f-429d-a888-0720cf376532",
      "members": [
        "427dc044-8015-40ea-bc8e-7ba7b8003ea8"
      ]
    },
    {
      "cluster_id": "c7d861d7-3b33-4585-89d3-87c9dcbcd126",
      "members": [
        "ab7deee3-6479-45e0-bbf4-5c661a4fe1fa"
      ]
    },
    {
      "cluster_id": "8f15ddff-3bc7-4fbd-9371-1a897f8b9078",
      "members": [
        "bea9af0c-5656-4e03-9868-2e7e2295fa5c"
      ]
    },
    {
      "cluster_id": "7a1e52a1-bd32-491f-a249-5ec36a49aa78",
      "members": [
        "52fc8483-9863-472b-9ed3-98c00e449547"
      ]
    },
    {
      "cluster_id": "d6d20ec3-ee81-4cbc-8cc9-9bd366cd24db",
      "members": [
        "0f25cb03-35c2-40e8-b96a-ad0f42f18adb"
      ]
    },
    {
      "cluster_id": "b7768432-bcaf-4a4c-9bb2-1a6e02c6a003",
      "members": [
        "baef1fc2-a432-4ab8-a4e7-d7111ce18e8f"
      ]
    },
    {
      "cluster_id": "0634cfd7-f7f7-48cb-bb92-7dc813e3271c",
      "members": [
        "c7adce15-79ab-4154-9212-55f8be8b0a39"
      ]
    },
    {
      "cluster_id": "cbd140c9-7dba-47e8-97c2-10198c9c38d7",
      "members": [
        "b69575c4-a47e-4678-a8c6-9757e605d896"
      ]
    },
    {
      "cluster_id": "c065f08a-341f-4084-99ca-ceef465c2c9a",
      "members": [
        "b318e9f9-9a66-430c-92d3-7da39e592574",
        "52975b9d-d2e7-4174-ab1a-5fc71f2f29fc"
      ]
    },
    {
      "cluster_id": "81d9d830-fe0d-4e6e-bc5b-8d4c5f74f4e0",
      "members": [
        "5fec1f94-3bb9-41d7-a93c-2d3f09830f11"
      ]
    },
    {
      "cluster_id": "d0137977-4815-4376-8c2f-58b223088e62",
      "members": [
        "48523f9c-4b23-4591-8c13-f194abb060cd"
      ]
    },
    {
      "cluster_id": "4effafac-8e45-4dfc-8f71-d8c9b1e37d7b",
      "members": [
        "9c1cd331-4595-471b-9ee7-95bb5b6787b6"
      ]
    },
    {
      "cluster_id": "02c78b1c-dd55-4ba6-a345-d21fd27d3214",
      "members": [
        "d950f456-f04c-4ae2-833f-3356da97c464"
      ]
    },
    {
      "cluster_id": "86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5",
      "members": [
        "236ca972-2169-4708-8479-769f3fde2bb3"
      ]
    },
    {
      "cluster_id": "e8b8352a-472f-4b00-9dae-87cd809f920e",
      "members": [
        "8d553264-2775-4b89-bf31-4e2cde806720"
      ]
    },
    {
      "cluster_id": "c66251b2-ab53-4ca9-91b8-4229e4242200",
      "members": [
        "ef58cdc4-b176-42c5-8d1d-6accb948d1b9"
      ]
    },
    {
      "cluster_id": "61de2e2b-d2da-472d-882f-2c0c14730fee",
      "members": [
        "a0f1ab21-1861-4603-9fe3-8d7c1490bbf6"
      ]
    },
    {
      "cluster_id": "4908cf56-f8a6-4b01-88c6-2c59a4acac65",
      "members": [
        "0ecf2a39-3371-4e9e-a01e-590af98a1838"
      ]
    },
    {
      "cluster_id": "6663d8fb-8d11-459b-85ff-7054f5d07b06",
      "members": [
        "793a15d3-c559-4807-84a5-df29842c117f"
      ]
    },
    {
      "cluster_id": "3afb5a7e-c2f9-4fc4-a379-b0fb650f805a",
      "members": [
        "ad2ec165-9afb-4dce-a0b6-657061bdadf9"
      ]
    },
    {
      "cluster_id": "607ccd27-4dff-4901-8aad-e4dab1d3448a",
      "members": [
        "0f8d6861-6faa-489c-9dc2-42f3b063e07c"
      ]
    },
    {
      "cluster_id": "8b798ea6-1045-45b9-a2f6-023a84ae6ad3",
      "members": [
        "e83d8224-5059-4b16-9c3d-c34ba2eea3df"
      ]
    },
    {
      "cluster_id": "4fc00d95-d399-4677-9437-13f7e6f573c4",
      "members": [
        "90c5896e-279d-42dd-84f9-ee6335fea90f"
      ]
    },
    {
      "cluster_id": "a8c4b29d-3d45-4e5e-b6ef-06f93957d16a",
      "members": [
        "1136e8fd-88de-4185-8a62-33c192bed1b7",
        "ac73713b-73db-428f-97d2-fe95896fad23"
      ]
    },
    {
      "cluster_id": "c6aa0cad-31b1-4d56-9f83-938881501dbd",
      "members": [
        "e52c46e8-b089-4f2e-aa03-838e33557d82"
      ]
    },
    {
      "cluster_id": "0543c671-bbcf-49ea-a462-e4ab061c75a0",
      "members": [
        "0465fe3c-5a98-41aa-9475-7b4af42b25aa"
      ]
    },
    {
      "cluster_id": "e8f2c1ac-40d6-4338-93ee-3033faec8f14",
      "members": [
        "e39e34ca-5c88-4450-80b0-ff376e57f4a9"
      ]
    },
    {
      "cluster_id": "e490aee1-21a0-4624-906c-8f2d51f040e5",
      "members": [
        "65750d96-8d7d-46b0-baba-dc7162a0fa10"
      ]
    },
    {
      "cluster_id": "17036568-8b0d-4108-9a16-98a16980ae3f",
      "members": [
        "61a29cad-2475-4939-bba5-941c823aaa57"
      ]
    },
    {
      "cluster_id": "192dfe82-fc68-4d4d-ae38-d6077567ed10",
      "members": [
        "9636465b-c7ed-464d-bcaa-cf1340df799b"
      ]
    },
    {
      "cluster_id": "d8b92399-bf69-4b82-b461-678acbb7e385",
      "members": [
        "4d465014-a97e-4e1f-97c5-c64103818a8f"
      ]
    },
    {
      "cluster_id": "9aca5dda-f273-4941-9e97-91832c08621e",
      "members": [
        "67ecfa74-b6ed-41ce-b5a3-a2bcb926302a"
      ]
    },
    {
      "cluster_id": "017c8345-ee2f-4b6f-8701-6def5bbd5082",
      "members": [
        "148a00ff-6a57-4d0c-a6ad-c35238e59683"
      ]
    },
    {
      "cluster_id": "e5b48b2a-7f34-4409-a282-031c21d5b9f9",
      "members": [
        "d12d23f4-cc6b-44bd-8ae1-8a0ce222ac50"
      ]
    },
    {
      "cluster_id": "41a156b3-5c3d-4d82-b8e4-7ad88953f690",
      "members": [
        "366db116-0531-410e-98dc-2cd7e903c0ac"
      ]
    },
    {
      "cluster_id": "8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6",
      "members": [
        "2b8221a1-aa2e-4f59-a240-e1dc88d12ec7"
      ]
    },
    {
      "cluster_id": "e40e6c83-dc7c-44e8-8637-389476dedd00",
      "members": [
        "1cb98ff2-9204-46ef-aea3-ac3cb341560b"
      ]
    },
    {
      "cluster_id": "bf3a902c-c644-4da4-8d4f-8ccf8bbcec56",
      "members": [
        "5f32d335-0db0-4fb5-8d1e-89884723fc6e"
      ]
    },
    {
      "cluster_id": "f96fdbdd-0664-4366-b80c-72a8405c4f44",
      "members": [
        "3386479a-ceca-414d-8f19-b6fc28b90bc9"
      ]
    },
    {
      "cluster_id": "84a0c048-8b19-4f73-b588-caa191d08d54",
      "members": [
        "a9bc90da-6884-4eb7-a0ba-5cc5a970baca"
      ]
    },
    {
      "cluster_id": "5521d112-0a05-4e5a-881c-de705171fc9a",
      "members": [
        "57ae861c-706d-4491-b16c-de1ddf59f0b0"
      ]
    },
    {
      "cluster_id": "b7e4eaa1-1521-4096-9aa4-af78b70dfeb5",
      "members": [
        "bd89072d-c992-4588-90d6-5b903ad308c1"
      ]
    },
    {
      "cluster_id": "40db941d-31ac-4f8f-a268-d60a6c9bd055",
      "members": [
        "b66910e5-daae-4814-957b-1bf57d03d2d3"
      ]
    },
    {
      "cluster_id": "735fb4c9-5d71-4b3e-b247-9bafaa632b98",
      "members": [
        "93046fd1-58f7-4e4d-ba19-9705a7d94046"
      ]
    },
    {
      "cluster_id": "5863948c-f84b-495d-bfa9-facccb6313d4",
      "members": [
        "cedf273d-4281-489e-99a5-ba6e65e45127"
      ]
    },
    {
      "cluster_id": "8870837d-d287-47f9-8134-1fe8a8f59e88",
      "members": [
        "298d1707-0fd3-4201-8a1e-4560d6ff3fa8"
      ]
    },
    {
      "cluster_id": "d42f0707-162e-449e-86fe-0dd5e2885a21",
      "members": [
        "d5244cf2-bd56-4f1e-b7cd-8275b06653ff"
      ]
    },
    {
      "cluster_id": "6d2792d9-4dcf-4980-9870-d295c7f8e2c0",
      "members": [
        "3ecb35d7-1dbb-4da7-af32-d8663dffc64d"
      ]
    },
    {
      "cluster_id": "1b7b6166-a006-43a7-8e66-beaeaf966eff",
      "members": [
        "1cb65bfb-8150-4bfd-9987-88ff145e66b5"
      ]
    },
    {
      "cluster_id": "574866ae-31fe-4cc6-8d31-fe21c9fdd682",
      "members": [
        "381647b0-5e40-44f4-bd33-12838044198c"
      ]
    },
    {
      "cluster_id": "f833277e-e62d-4240-a8fa-fd6d79db3c79",
      "members": [
        "adfd4ae7-4210-4c62-bfa0-6781d45bcc59"
      ]
    },
    {
      "cluster_id": "30011e47-1ff9-409e-8099-2eff6ab89e88",
      "members": [
        "15a4d950-ede9-4236-99cb-d4ddfab73b99"
      ]
    },
    {
      "cluster_id": "1dd25bce-7fe6-46d2-9e28-e803262696c4",
      "members": [
        "fd40bdd0-c6cc-4711-b6da-f6636f70fdb8"
      ]
    },
    {
      "cluster_id": "acc5b6d2-0057-4a25-83c7-3d3bbd4031e9",
      "members": [
        "350999e3-219f-4b31-962c-d52e4f548e1b"
      ]
    },
    {
      "cluster_id": "011b48fb-6ec4-41cc-bd4d-394e371c18cb",
      "members": [
        "3f2abbd2-060e-4ad7-b5a8-a84b9511e597"
      ]
    },
    {
      "cluster_id": "29149f19-2cff-4344-bb10-8e0506dbc049",
      "members": [
        "7d9aec94-20fe-4c75-9332-62af6797dc14"
      ]
    },
    {
      "cluster_id": "41dd785c-3146-4243-8bbd-56211fadb273",
      "members": [
        "db528ec0-3250-402d-a8d8-f12011ce042d"
      ]
    },
    {
      "cluster_id": "b2a26561-1192-4739-962b-b9df80083243",
      "members": [
        "6d0a63d8-61a9-4d2d-aea6-4e60a12d2dea"
      ]
    },
    {
      "cluster_id": "3505030f-425f-4631-b164-fc25bf6fbe55",
      "members": [
        "6004ac54-d4df-49b3-a497-d03e67091a98"
      ]
    },
    {
      "cluster_id": "38c3007b-05b7-481e-b44e-c09d28628f5e",
      "members": [
        "da5d347b-5fb3-4187-bbba-c8b354ad6ff2"
      ]
    },
    {
      "cluster_id": "29780617-dcdc-405a-a7d2-26d05fd8f9d4",
      "members": [
        "3e3f1040-d2fa-4f56-a06a-86ea44e3b71b"
      ]
    },
    {
      "cluster_id": "990306d6-263b-4984-88f5-4be9fc326334",
      "members": [
        "e3155177-7923-4bed-b420-8405a93cc93d"
      ]
    },
    {
      "cluster_id": "c5855521-5ebf-478e-a7af-b3f07554a912",
      "members": [
        "07988081-937a-46fe-bd74-5dbb0846b25d",
        "75781163-5d59-4792-a3e9-6565f8963430"
      ]
    },
    {
      "cluster_id": "62bf43d6-ee9a-4f43-a89d-18b4cdd7fdd3",
      "members": [
        "2b000b50-a42a-47c1-9d45-30baf3b84d49"
      ]
    },
    {
      "cluster_id": "06b8ffc7-c987-44a2-a2cb-8721e54e7da6",
      "members": [
        "b35919e0-29c5-4cec-8c70-bbdaa9d266d4"
      ]
    },
    {
      "cluster_id": "80abc80a-d540-4e4d-aa41-272690066eb0",
      "members": [
        "e1c039f7-5ea9-4d63-a8b8-4f2855a5116e"
      ]
    },
    {
      "cluster_id": "11d45e31-1956-49e2-b94c-bc4a176c09fc",
      "members": [
        "1278c551-390c-4f62-98a2-54de97930a3b"
      ]
    },
    {
      "cluster_id": "9621dd39-ccb5-4e12-9287-8a404c57bba0",
      "members": [
        "027e4c0a-e0ed-4794-9444-00c62128252f"
      ]
    },
    {
      "cluster_id": "509e1b1d-c464-406d-8d4e-6ab2f46f2324",
      "members": [
        "a204bf60-6b27-4a6a-961c-8a95940917d9"
      ]
    },
    {
      "cluster_id": "6b512fcc-e6a2-414b-8a86-90a11b76795a",
      "members": [
        "b11958aa-8fd4-4167-bad2-bb15154530cd",
        "626c2407-8a4a-41e4-a847-e1a640dd970b"
      ]
    },
    {
      "cluster_id": "62fc9d37-f7e6-43e7-a681-3c5679294ee9",
      "members": [
        "9ea310a4-45b5-4541-a5ba-50c286d295be"
      ]
    },
    {
      "cluster_id": "aafcc6bc-c8f9-4a4c-acf7-9628f64db648",
      "members": [
        "eb6f8055-76c8-4f43-ad76-682bcd9695bd"
      ]
    },
    {
      "cluster_id": "9cfc641f-8857-445d-a3fd-0b6e7a1c0cf7",
      "members": [
        "5632a5f8-a908-440e-af68-fffdfc0964ce"
      ]
    },
    {
      "cluster_id": "a38268fe-ba89-4d63-8481-63c080523a0a",
      "members": [
        "caa550e6-f9b4-4fbf-816f-cf2925782cd9",
        "a6d49558-eef4-4a2e-9043-3c0c2b6b6bbe"
      ]
    },
    {
      "cluster_id": "100519ae-c1d6-4f8e-bcef-2f36e907e789",
      "members": [
        "5ea053a7-6ad0-4f32-b78e-4ce50ee30540"
      ]
    },
    {
      "cluster_id": "7187c5ae-6f6b-4c6a-af65-98db1f5251db",
      "members": [
        "b1f832ca-8dcf-4377-8681-55076f981d74"
      ]
    },
    {
      "cluster_id": "cc0b4f6a-9515-47dc-b1fc-eea9be8d97fb",
      "members": [
        "6fe94112-1374-43cc-82b2-2247c364b004"
      ]
    },
    {
      "cluster_id": "30bb9166-b600-41f8-a7cf-3befaaa1bcc2",
      "members": [
        "5f516e9d-dbaf-4874-9212-04e63b2c7ed0"
      ]
    },
    {
      "cluster_id": "edd65f26-0117-4202-bd31-c3f265210b5e",
      "members": [
        "4f921cf8-8650-4d52-9ea8-4ce66ff4aaa7"
      ]
    },
    {
      "cluster_id": "2b897077-ab7f-4c6d-8c0e-a3493d4e615a",
      "members": [
        "13a60e49-831f-4ce3-b846-219ccc7e8def",
        "8cfdba26-6ba3-4e3a-ae44-73685c31f110"
      ]
    },
    {
      "cluster_id": "290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45",
      "members": [
        "c2cedeb5-1b3a-4ad1-9e16-aff80d97d2c4"
      ]
    },
    {
      "cluster_id": "0a3a7c87-61b9-4961-a698-61129e827319",
      "members": [
        "789c1f08-91d2-46b6-a5e1-6efb269f7290"
      ]
    },
    {
      "cluster_id": "9b129e4b-0540-473c-90ae-ff21e622eb3c",
      "members": [
        "a3f50eaa-34ee-491d-893a-65e72e4e3030"
      ]
    },
    {
      "cluster_id": "c7c25534-0ffc-4f97-99d9-6bf3f3de9b03",
      "members": [
        "92c70728-8a84-4c64-a3bb-73a55eb2027a"
      ]
    },
    {
      "cluster_id": "da4bd748-3c84-4017-a93a-8247224fc32f",
      "members": [
        "54911bf9-a56d-41b9-9a2c-a90b0f8ff629"
      ]
    },
    {
      "cluster_id": "f9e580f2-a45e-455c-a4fc-189d643f07ef",
      "members": [
        "c226c7d3-8328-4f02-8fb0-ed3d0a775a6d"
      ]
    },
    {
      "cluster_id": "21ae851f-14b0-4e6c-8bf6-1ff87dabd880",
      "members": [
        "cd1bcd26-ed9e-4f8a-a582-7a3ef528fe8c"
      ]
    },
    {
      "cluster_id": "95b38f6d-19e7-4fa7-a9de-ee665de84018",
      "members": [
        "5aeb6899-996b-4917-877b-404a648405a9"
      ]
    },
    {
      "cluster_id": "97d6f1ef-2f69-4bd7-b5ce-8c3dd359bfcb",
      "members": [
        "476a39ea-cc28-4fd5-b04d-d950bf6daaba"
      ]
    },
    {
      "cluster_id": "95690f3e-4515-4810-858c-28b7d1da49a5",
      "members": [
        "5cd436e7-5e8f-4fdd-844d-6a1feade2672"
      ]
    },
    {
      "cluster_id": "262772f6-e21d-4ca8-a80f-06c1518ea90e",
      "members": [
        "1feaa18c-a348-4318-9eea-bfa6da8247cc"
      ]
    },
    {
      "cluster_id": "738e60fd-1e3d-4820-98bf-d6bd9e7a3172",
      "members": [
        "52f5053c-34f5-43b5-adb6-de2278fbba70"
      ]
    },
    {
      "cluster_id": "590ca39d-bd4d-431b-829a-90d0f3384aa4",
      "members": [
        "bca440e6-ccd3-48a9-9ea8-b8eae07dbc71"
      ]
    },
    {
      "cluster_id": "2cb357c3-3958-45ce-bb44-f76facb84ed9",
      "members": [
        "8c8ca322-1ed3-4f34-ad77-733d428cd6a3"
      ]
    },
    {
      "cluster_id": "9e4983ab-c919-470b-9bac-8b6c4b633a1e",
      "members": [
        "ddfbf23e-6ad9-4461-9171-4d97b7c80f0a"
      ]
    },
    {
      "cluster_id": "945e1233-33d5-4259-ad28-2899aa78e0e9",
      "members": [
        "4e689837-4d10-45d5-81a1-62d56468abc3"
      ]
    },
    {
      "cluster_id": "c153b607-ea7e-4a94-8f50-d29611d77fe7",
      "members": [
        "34069537-f1d4-4ac0-b377-fd2fd3a315de"
      ]
    },
    {
      "cluster_id": "29c942d6-0549-4857-889a-2fc5fd4cf362",
      "members": [
        "6684e8c5-fb5f-4d58-93c0-7b7920bafabe"
      ]
    },
    {
      "cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
      "members": [
        "e7ca5d87-eb91-438b-8987-7d1c73be5b0f",
        "ace2a506-60b7-423b-9530-21d89ee724c1"
      ]
    },
    {
      "cluster_id": "36ece2d2-4cdb-4985-90ab-a6751ad5b290",
      "members": [
        "9e551c2b-9a5a-4862-9f0f-273c0b484cad"
      ]
    },
    {
      "cluster_id": "ccf91c48-303e-4d94-8263-0e8c6de64e17",
      "members": [
        "dcc1afda-2113-499e-97e2-4c33cb4d20ac"
      ]
    },
    {
      "cluster_id": "f9ff85c1-1de5-47fa-b9f9-f7450f5b0b3d",
      "members": [
        "d82c2aff-afb9-4f24-aebc-bca6be31b865",
        "a76317c7-6638-441d-8afc-80e7f186b8cd"
      ]
    },
    {
      "cluster_id": "c721dd3f-abaa-46f4-b0b3-0998badfc28c",
      "members": [
        "7ba82044-6885-45eb-ade4-041b922dc24a"
      ]
    },
    {
      "cluster_id": "51207b82-ee2c-47cd-adf4-cdd41f93d43d",
      "members": [
        "f12e9165-d5cf-46fe-8144-3a54d7ebdfd8"
      ]
    },
    {
      "cluster_id": "9adce26b-ced3-4b3b-ac9a-24b78e98224d",
      "members": [
        "9cba1fb6-7b09-4002-a021-c674684b00b4"
      ]
    },
    {
      "cluster_id": "da3ee5ab-4748-4fea-9d14-3bdfe78a1c62",
      "members": [
        "eadbb245-11fd-4603-acc4-b3d1ed7503e7"
      ]
    },
    {
      "cluster_id": "03725096-887b-4dc0-a3ec-0bc1ce57eec9",
      "members": [
        "04fed4bc-0a1c-4f79-ab8b-9dff75e1254f"
      ]
    },
    {
      "cluster_id": "f210a15e-3afd-4f52-8da2-de7a59e25377",
      "members": [
        "a50bbbf2-704e-41b4-be4b-727c9b13dfe6",
        "e2b9e1e1-cd0f-4bea-b60b-2b3a10752ecf"
      ]
    },
    {
      "cluster_id": "7ac1c88c-d620-4c32-9f9d-5a780231627e",
      "members": [
        "763b4c59-9a19-4c6b-b298-ced52db844c1"
      ]
    },
    {
      "cluster_id": "de3dfa95-4771-45cc-8a31-d6c35fbb0eb5",
      "members": [
        "7e91a24e-bb1d-4942-b158-6561c268f135"
      ]
    },
    {
      "cluster_id": "dbdede5c-5c9e-4c2c-acc7-81cff6d78ffd",
      "members": [
        "3e3a0ce3-9d32-4d33-9476-196214c4158c"
      ]
    },
    {
      "cluster_id": "eeb1b170-89e2-4e28-b446-c1ba6d5ba1e3",
      "members": [
        "8dc2dc12-4483-4e22-bfba-f8c668631bf0"
      ]
    },
    {
      "cluster_id": "0acd3055-185c-4d22-ad5f-a587ee5adc40",
      "members": [
        "1e0dd477-2919-414b-956e-29f90a306828",
        "0a45144d-bc7b-48a7-a0d4-08f0e213397c"
      ]
    },
    {
      "cluster_id": "bb382092-b4e0-4652-830e-be1eeb609ad0",
      "members": [
        "96e78690-52ca-41bf-bace-4b4e15b86c84"
      ]
    },
    {
      "cluster_id": "a7b8095f-b682-4ca2-98b3-5d738490e008",
      "members": [
        "8c41652b-8e1e-4f0a-bc4e-03efedd1a9f6"
      ]
    },
    {
      "cluster_id": "35c8d576-e355-4f4b-802d-1d88de41da0b",
      "members": [
        "da7775bf-58ca-49c7-a7d1-cffa7bccb3d2"
      ]
    },
    {
      "cluster_id": "5aad8736-b18a-4e21-930e-320f4faaed1c",
      "members": [
        "b1d44d03-5ef9-4f9e-94eb-bd0d9585bf1f"
      ]
    },
    {
      "cluster_id": "a9b66749-8bb9-4643-bb36-488cbf77974b",
      "members": [
        "6eada5c0-5e43-4d39-b534-e8c542c0d607"
      ]
    },
    {
      "cluster_id": "0728a108-719d-49e5-9d88-9c4bc35fe771",
      "members": [
        "456955f3-fe8b-4164-8641-3c65f3983fbd"
      ]
    },
    {
      "cluster_id": "a162a552-43bd-43b6-925a-ac7f9fbf4734",
      "members": [
        "dbe8856b-d464-4609-9e4b-30a8db6cc332"
      ]
    },
    {
      "cluster_id": "62bf1a53-b840-4c52-b1a8-6f2e98e4c3d2",
      "members": [
        "febc22fd-b63e-4d33-8e8b-7830675da69f"
      ]
    },
    {
      "cluster_id": "8a3175b7-b295-45aa-8bbc-c3d6d75486fa",
      "members": [
        "db3f6d14-a291-4aac-a1cd-cc354f4928bb"
      ]
    },
    {
      "cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
      "members": [
        "9880f810-d4a7-41fc-9722-9ddf250ed653",
        "e1e225d7-a8c1-4486-b299-b092e0b88821"
      ]
    },
    {
      "cluster_id": "6a51ac21-708a-4a11-b82e-7b2b043d6c15",
      "members": [
        "fb14b1c9-f797-411b-8b61-6c98d77e78be"
      ]
    },
    {
      "cluster_id": "06b2f52b-0581-493e-b81d-57ece9f33f27",
      "members": [
        "82cf28c0-d675-4d81-b3a2-2c3ce4de4179"
      ]
    },
    {
      "cluster_id": "9be076b9-65b6-4c8e-b3d7-1df3c547c0fc",
      "members": [
        "2c2fbc2c-4fb0-4048-b456-d2641031574f"
      ]
    },
    {
      "cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
      "members": [
        "5b6894f8-ea15-4af7-a6fc-9b6dc7515b6c",
        "cb1c2aef-6959-401e-9589-022e23e0167c"
      ]
    },
    {
      "cluster_id": "2d998acd-2150-418c-b2e7-db6c334526be",
      "members": [
        "c76b961e-fec1-4e74-8f71-d053b8c1967a"
      ]
    },
    {
      "cluster_id": "4feed713-e2b7-4de9-a6e7-cb0e0ca52183",
      "members": [
        "bf52ac2c-e546-41f8-8dc2-c30eda90de58"
      ]
    },
    {
      "cluster_id": "5765d283-f56d-43cd-b120-e8f9048e2325",
      "members": [
        "a261d10d-a831-4a54-83da-f0ffee4c073e"
      ]
    },
    {
      "cluster_id": "adc640bf-2d33-45f1-87f4-f455e4d88f72",
      "members": [
        "c8c3633b-35c1-4db0-bae8-d6cbc4f54521"
      ]
    },
    {
      "cluster_id": "8cb34140-24ef-4173-9390-c1f84800160e",
      "members": [
        "ee04ccaa-9e1e-40d6-bc45-0779559baad7"
      ]
    },
    {
      "cluster_id": "5b79e5f7-f49f-4b4e-b9a7-5554797ebbeb",
      "members": [
        "6aa78773-444f-4637-ab92-a135889b401f",
        "040f7830-6a65-4a38-8b85-a619adac6e6f"
      ]
    },
    {
      "cluster_id": "b0af2c27-e359-4cad-89ec-4abce503f0fb",
      "members": [
        "10b0216f-8bdd-4289-b76a-7acbcdf1e105"
      ]
    },
    {
      "cluster_id": "c572351c-d373-4e8c-a918-68e53e31b822",
      "members": [
        "a565dbad-c465-41f8-ab11-beae94827d71"
      ]
    },
    {
      "cluster_id": "4c8ca22f-065e-4c2a-bc2a-950d315204b8",
      "members": [
        "74c3de24-358f-46b6-8603-3b0cd61cf75e"
      ]
    },
    {
      "cluster_id": "bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb",
      "members": [
        "9c0167dc-2624-4651-a063-941c0d8192e7"
      ]
    },
    {
      "cluster_id": "e0a9ff6c-3760-4c9a-a79f-78340ef165ed",
      "members": [
        "c10efc8e-2c04-412f-8a5e-1fdbcadb67d7"
      ]
    },
    {
      "cluster_id": "b0071c15-10b9-4a75-8b7f-486b9f2c04d1",
      "members": [
        "66e6c0ae-2678-4700-9d11-18f5479528f3"
      ]
    },
    {
      "cluster_id": "995a6788-c0da-4f2f-a729-9d6b9bf65efc",
      "members": [
        "13d0543b-8f7c-4b3b-8217-7043d3174afc"
      ]
    },
    {
      "cluster_id": "952d3c78-e97c-4ff6-a488-1e2f6353d3c9",
      "members": [
        "143e6559-fd81-4a95-a696-1296cc9459e1"
      ]
    },
    {
      "cluster_id": "95f30627-ec05-45c4-9f6e-28dd5c31e412",
      "members": [
        "4bea3e8c-e42b-49b3-a380-6f0df70085de"
      ]
    },
    {
      "cluster_id": "aa7a9a4f-e437-468a-8a0c-4d2441978380",
      "members": [
        "5d1abb46-c8d8-49fb-839d-b17a174ec4be"
      ]
    },
    {
      "cluster_id": "7fc9b449-7f4e-4cec-90a6-b1dab2836291",
      "members": [
        "06adc002-27b6-4763-98b3-60bd7be27eff"
      ]
    },
    {
      "cluster_id": "840a2e45-449a-4234-be31-852cc48c1642",
      "members": [
        "0cb3d75e-b02c-4bd2-9810-c0e6a1fc51b6"
      ]
    },
    {
      "cluster_id": "67674784-9e53-4907-a36a-9a45f8374e68",
      "members": [
        "b9b63002-39d8-4477-b533-c581d73fadcb"
      ]
    },
    {
      "cluster_id": "8f97c05e-5860-4be0-8343-dc2050850d4f",
      "members": [
        "34309c9a-8492-41d0-bf23-bfbb78f5e9e8"
      ]
    },
    {
      "cluster_id": "09a468db-6b0d-4230-a370-cfd6ba61219e",
      "members": [
        "72b9d4c9-c3e9-4906-b371-0a4ebf5cadc1",
        "494b41ad-16b3-4f5d-ad03-def9e45d7031"
      ]
    },
    {
      "cluster_id": "d281c55d-162e-4c45-bdc4-8fddc9bff858",
      "members": [
        "5b47b59e-568a-4e23-86a9-e5681f041b5f"
      ]
    },
    {
      "cluster_id": "95b3c4c9-cd4a-4cfa-9eab-9df18c6c5d95",
      "members": [
        "fb9161f8-1e15-4476-8ce7-46aa19ef5010"
      ]
    },
    {
      "cluster_id": "65cd54b0-2f90-4b59-a573-5917ec27f9bb",
      "members": [
        "36ecab96-07d2-4a35-9658-4f5c6d5c2ebe"
      ]
    },
    {
      "cluster_id": "8db03bdc-0c69-45b1-8ccb-309f57132adb",
      "members": [
        "a1fada51-b45d-4d3c-8d3e-99b53f12db24"
      ]
    },
    {
      "cluster_id": "7f1f819a-52dd-40cc-92a1-28526195605d",
      "members": [
        "111fda95-ceec-4a7a-a541-30cbc5c08475"
      ]
    },
    {
      "cluster_id": "88f4c27e-7029-43e0-805c-44699284d312",
      "members": [
        "4c349d8a-0de2-4065-995e-b97ba18a3cc0"
      ]
    },
    {
      "cluster_id": "aa30bf70-0cba-416d-ab58-48d58cb2a343",
      "members": [
        "7061f9bc-a2c9-435d-8af9-d319c07d4cc2"
      ]
    },
    {
      "cluster_id": "6774f916-a691-4d45-86c4-69c41fab58e3",
      "members": [
        "69e4cb91-92b2-441c-9c45-09d100040619"
      ]
    },
    {
      "cluster_id": "a3657e1e-0716-4d64-9a9e-572ba20604c2",
      "members": [
        "76a47284-daa0-43c3-9a5e-dadf15ea7166"
      ]
    },
    {
      "cluster_id": "2fc8ee47-5c74-46a4-91ea-72f94f9e2c27",
      "members": [
        "d0161276-0b14-45fc-83b7-284988ef9808"
      ]
    },
    {
      "cluster_id": "3ffaa02c-962d-45fa-a9aa-01f8e41dda01",
      "members": [
        "3646e827-9c28-481f-8a3c-14bf7f6ee1bb"
      ]
    },
    {
      "cluster_id": "1bf7e0a5-55b7-4089-89cc-831b1626c195",
      "members": [
        "cf00a55a-5eca-43d0-8944-0a18bb229c40"
      ]
    },
    {
      "cluster_id": "d1f2b2ed-be0f-44a4-a171-4b848f482ca9",
      "members": [
        "b1f2e7d8-ccc3-4f08-bd0e-9f7c70793e5e",
        "6f152311-cb32-47f6-9c08-27bfcab9d5fd"
      ]
    },
    {
      "cluster_id": "098acc21-62ca-42b4-8206-4df179ae28c3",
      "members": [
        "c4eaaabc-9564-4e1d-a74c-5c61095c6428"
      ]
    },
    {
      "cluster_id": "a8177a52-bb93-4070-be93-33bdb7e54f7f",
      "members": [
        "f9dd0eeb-eedd-4de8-87a3-03659e466189"
      ]
    },
    {
      "cluster_id": "1dc1ea0e-ecc0-4a99-a555-3574b46d8688",
      "members": [
        "4a24d8e1-c038-41e2-a640-6c76d8c77f67"
      ]
    },
    {
      "cluster_id": "c91afcbe-198a-44cd-83c8-42c89811dab9",
      "members": [
        "ae1bb1a8-77ee-45bc-aa36-64fb591ff555"
      ]
    },
    {
      "cluster_id": "8f2a4264-d263-4757-889e-c18e3e101875",
      "members": [
        "e8c891f1-9ad9-492d-8bc2-d8322a1bb704"
      ]
    },
    {
      "cluster_id": "53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c",
      "members": [
        "78823ae4-0c2e-438c-8dff-ca140c879d1c",
        "2e8e6368-68dd-45d5-a2dc-d4ee5ee70dd7"
      ]
    },
    {
      "cluster_id": "a3dda742-6a6a-4de7-ad48-8075110e3b35",
      "members": [
        "092ab2d2-2c35-4984-a0ff-3385c6274188"
      ]
    },
    {
      "cluster_id": "ea3c1b05-c987-4377-9e48-b92ea47cc764",
      "members": [
        "cbf4a452-7652-4f82-bf67-0ee72a779846"
      ]
    },
    {
      "cluster_id": "b36a42d8-1bb3-483d-b77f-bd28630b0e30",
      "members": [
        "56f44d3c-1882-468a-a39e-560f159b07a2"
      ]
    },
    {
      "cluster_id": "9d6f335e-c5fe-40ff-9edc-7ee5892fafaf",
      "members": [
        "ae778ea3-ab1c-436e-83d2-b9abd6502a12"
      ]
    },
    {
      "cluster_id": "7eefde16-5844-4305-a679-da87990a2640",
      "members": [
        "4cee97a5-599d-461c-a5d3-ddb7b61c587a"
      ]
    },
    {
      "cluster_id": "734aba7a-e1ac-4a78-a926-3957017f7843",
      "members": [
        "82e47aee-7b6b-4936-a959-aa926002fb1a"
      ]
    },
    {
      "cluster_id": "d93d391c-6b51-4713-bfdb-30f405cd2357",
      "members": [
        "59af9f9a-2c5d-4de7-ad4d-ab2be9537271"
      ]
    },
    {
      "cluster_id": "583320d2-3b7c-4cef-9dd1-9eeedce9bc81",
      "members": [
        "0b3c50fe-9aa2-4a22-85b4-5b1c52ce2eec"
      ]
    },
    {
      "cluster_id": "eb82caa7-6ef5-4182-a16e-ed0091be45ae",
      "members": [
        "38fb016f-f70f-4b9f-883c-9653381f4f08"
      ]
    },
    {
      "cluster_id": "8e9b5986-8277-45da-82c2-ab199cd3287f",
      "members": [
        "4bdb1eae-1573-453a-a57b-0fef0cf1472c"
      ]
    },
    {
      "cluster_id": "b471f42f-4da7-4b5a-a11e-18deef221da8",
      "members": [
        "fde1853f-3f82-49e0-8181-1fe237afda38",
        "cf0181d7-c14c-4b9f-a69e-ef445f0dfd90"
      ]
    },
    {
      "cluster_id": "a219ce5b-2b81-445f-a63d-19aecc15acb1",
      "members": [
        "4bc88004-3c8c-4dd1-8eab-01da2f931d7d"
      ]
    },
    {
      "cluster_id": "d637ae20-ea81-4c6e-85e0-ffbd0f9a76b5",
      "members": [
        "8c795228-b136-4584-a1ad-c731fa4c7164"
      ]
    },
    {
      "cluster_id": "6a0b2cf5-23aa-458f-9dc9-7fde872ec6fc",
      "members": [
        "817546e0-c92b-45b2-b75c-ec6e8277d278"
      ]
    },
    {
      "cluster_id": "ba205832-fc5f-46fb-90ac-d89622b9cebf",
      "members": [
        "36608fb6-7bae-43ec-a85a-51c36eac5007"
      ]
    },
    {
      "cluster_id": "0f9ce830-116e-4bca-9110-b7d8c9c20025",
      "members": [
        "2392c3c4-f0d7-4741-8cee-c90dee84d1a7"
      ]
    },
    {
      "cluster_id": "3d2576b2-1572-432b-98fe-db8e768274d5",
      "members": [
        "253af419-5990-4696-aff9-7240a057ebf0"
      ]
    },
    {
      "cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "members": [
        "5f053b98-cfbb-45e0-951c-1faf705854e7",
        "f606b31a-b532-40dc-89ff-e88a3a8c71ec",
        "ed3cdb9f-0609-4ee5-9a77-be64735a50fe",
        "bacee7fe-c702-44a9-b89e-4b1a69c6b672"
      ]
    },
    {
      "cluster_id": "4f0d57c0-3de2-45f7-85a5-01cd50cac457",
      "members": [
        "e7167790-1ca0-4758-83ef-cfaa7af0d4df"
      ]
    },
    {
      "cluster_id": "2267c878-b6b0-4036-b4c7-3e3fec5d0865",
      "members": [
        "5dad1ba3-bf1a-4fbd-9515-e7df10901647"
      ]
    },
    {
      "cluster_id": "a6d92a93-8990-407f-a2ca-8786c79330ee",
      "members": [
        "36792a75-7b7d-4724-b998-1097cb1b9753"
      ]
    },
    {
      "cluster_id": "b0b4f902-9c94-4b57-b853-99cb04209992",
      "members": [
        "6d6197d3-178a-4827-a9cd-fdca21a90695"
      ]
    },
    {
      "cluster_id": "680a1621-579c-4ffb-aa4c-f56de5d6dfe7",
      "members": [
        "cf3568b6-586d-4e58-84d4-3ca7d32b7860"
      ]
    },
    {
      "cluster_id": "e3141392-e630-428b-ae45-6d5589bf7443",
      "members": [
        "f7a962f1-0d5e-4e60-a1ab-4627c38edd62"
      ]
    },
    {
      "cluster_id": "8e7a25f4-c25d-43c4-890a-4d8d8364c5bf",
      "members": [
        "b56682ff-83eb-4170-ad31-c2232d6f06a0"
      ]
    },
    {
      "cluster_id": "dfcf5731-89c0-4af2-a475-d7087b733644",
      "members": [
        "abec432b-4b97-461f-abc6-b475358b35a3",
        "bfa609f9-2ee5-4041-9ead-29eb12891c57"
      ]
    },
    {
      "cluster_id": "9723a8c8-8969-4471-bc9d-732ca83fc5b6",
      "members": [
        "f453153e-e454-43f9-bd11-d5c7ad57e0e0"
      ]
    },
    {
      "cluster_id": "3e1e4180-7726-4298-9f55-4348fcd7185f",
      "members": [
        "177203bd-dbed-47b6-b095-908931f7ac38"
      ]
    },
    {
      "cluster_id": "76ba9e0c-8b5a-4b06-92f8-9ce9caa47714",
      "members": [
        "7d250ec8-c856-41af-8374-190af4006461"
      ]
    },
    {
      "cluster_id": "29223456-9a08-4f68-9ce7-d62d961fb6aa",
      "members": [
        "d73abf37-36d7-46b7-9f5f-4f684e8aae3c"
      ]
    },
    {
      "cluster_id": "7924e4aa-9f0c-4bcf-8c0f-de382c8d6001",
      "members": [
        "dc8356c3-2a3a-4a60-a917-1d5d63aa5b8c"
      ]
    },
    {
      "cluster_id": "f0e862e5-92ba-499e-8f7b-4935ce01c5fd",
      "members": [
        "dd4daa0b-4a2e-4926-ae14-fbaf8a713160"
      ]
    },
    {
      "cluster_id": "ef49913c-d983-49cf-b90f-4529857c36a4",
      "members": [
        "1c63b173-4a48-4736-a466-44ebbe6903c8"
      ]
    },
    {
      "cluster_id": "f570b12b-c8a8-4d99-9575-a11a563abe1c",
      "members": [
        "c9e8c139-5a8f-4e24-a65b-71191ef90c6b"
      ]
    },
    {
      "cluster_id": "67c32fef-bbe8-4245-9a91-7d8aee491367",
      "members": [
        "16dd4b0f-e181-4766-9099-841c4684769f"
      ]
    },
    {
      "cluster_id": "59078c61-208b-49cd-9d25-3d6a843d0590",
      "members": [
        "619d380c-ec49-4a86-88da-0727e240b714"
      ]
    },
    {
      "cluster_id": "4de7b868-bb12-43db-9bc6-efbf0705904a",
      "members": [
        "22ae8bff-4d1e-440f-904e-57a100d2b74b"
      ]
    },
    {
      "cluster_id": "37c89569-0090-439b-961a-5b1d66deea87",
      "members": [
        "35156c0f-4df8-4e6c-9d76-1c2aad0fde6b"
      ]
    },
    {
      "cluster_id": "43b3601d-6d6e-43a4-8cdc-72cf4aa80640",
      "members": [
        "1f34b4f6-3429-4378-9c81-2d5bf161f570"
      ]
    },
    {
      "cluster_id": "92a61686-4c12-431d-b205-279f1f28aaa9",
      "members": [
        "c787c8f0-b90d-4334-a10f-2082b393b36e"
      ]
    },
    {
      "cluster_id": "d3bded76-52fd-4f86-982f-558582eed404",
      "members": [
        "942f639f-af20-4b2c-81b7-6dc2458b2a9a"
      ]
    },
    {
      "cluster_id": "c7bb1d74-7395-4554-a7ef-ec1f5c743579",
      "members": [
        "380629a1-e2b4-4cf7-b741-fff3c1754b5a"
      ]
    },
    {
      "cluster_id": "b835c70a-6e2a-4461-9396-aa47cc9d876c",
      "members": [
        "aeeabafb-6f28-4525-a914-fdc35c3a9238"
      ]
    },
    {
      "cluster_id": "93d03ec0-ac83-451a-87b2-a95e3d58859f",
      "members": [
        "a39f477b-71f2-4f8e-8040-d311ee44ffcf"
      ]
    },
    {
      "cluster_id": "494d200b-d2e7-47ec-bdd7-86aef2459978",
      "members": [
        "8105f0c2-d335-44c3-889f-c2866cac8644"
      ]
    },
    {
      "cluster_id": "2996196c-7b75-44d2-aa5b-560b18ce2763",
      "members": [
        "3220d5f1-68c5-408f-a687-456500ec5c1b",
        "9b3cf5e0-dbb6-4926-a623-746f661ed710"
      ]
    },
    {
      "cluster_id": "9cf07839-b78b-4d19-aeee-e70ec12a23d1",
      "members": [
        "55000f0b-6050-4bed-b661-724a55b279d1"
      ]
    },
    {
      "cluster_id": "86944fd0-c689-49c4-894c-bd247f4057bb",
      "members": [
        "e9b0d563-f34b-4a35-a863-be0d2c997c10"
      ]
    },
    {
      "cluster_id": "a6c6cdde-b7da-4e49-88cc-f029f6af6192",
      "members": [
        "28d5a32b-01e4-43e1-9fa7-c95e0e6ea554"
      ]
    },
    {
      "cluster_id": "ac1f3497-64d3-4909-9d61-789e683556a9",
      "members": [
        "bd92b3cf-ed72-434d-bc50-2da71ce2e696"
      ]
    },
    {
      "cluster_id": "fcc1829e-1835-42a8-bf49-00b5c2d30892",
      "members": [
        "abb0b365-0c91-4f0a-8c94-f9b199bbc275"
      ]
    },
    {
      "cluster_id": "4a91c427-d613-4080-adab-a06fc13d13ac",
      "members": [
        "cee22ffa-0da1-4eaf-ba22-6194a76f12a4"
      ]
    },
    {
      "cluster_id": "da5651eb-e7b2-446c-9fdb-dc89d46a36a7",
      "members": [
        "e0c3fe47-573f-4179-a8c8-d49f9e461981"
      ]
    },
    {
      "cluster_id": "8c61663d-a5f4-43e3-9ca6-42de906f614c",
      "members": [
        "8e9b5a0b-9e0f-450a-9bcc-3aad11029c2e",
        "e2404afc-9753-4d93-b38e-a46a7808158c"
      ]
    },
    {
      "cluster_id": "1fc4c0cc-9a41-4ae8-9970-3b340b704e77",
      "members": [
        "d965751f-c358-4f95-8906-150192b1ac86"
      ]
    },
    {
      "cluster_id": "e11231dd-53ef-41bf-966c-4a202aa2895c",
      "members": [
        "e08a454f-0375-4fe5-a9d8-9625252fb43e"
      ]
    },
    {
      "cluster_id": "a84f79d2-3818-45bb-9cd9-eb739e78bee2",
      "members": [
        "f1d70199-6377-48ec-a1a0-c8babe771d93"
      ]
    },
    {
      "cluster_id": "fd5eb376-88a6-437a-8af1-6b857c858d7f",
      "members": [
        "8db2a5b9-b06a-48f9-83cd-c7414db84203"
      ]
    },
    {
      "cluster_id": "3c1f9759-2361-48c2-bc4a-c58a3d11b76f",
      "members": [
        "4926a962-88b8-4c44-8b25-a6100dd82789"
      ]
    },
    {
      "cluster_id": "3d1eca97-f0cc-4fa8-9ff8-7ec9ee2b27e4",
      "members": [
        "b5629695-0b27-4487-bc7a-b41c6ea60fc9"
      ]
    },
    {
      "cluster_id": "67c03f1c-cee9-4493-b4e6-4ff1b7971966",
      "members": [
        "19745271-da59-4f63-ac98-b7d12909a80d"
      ]
    },
    {
      "cluster_id": "e0d3c894-0bdd-4f66-b7b2-a6bada2f1b37",
      "members": [
        "9ff13b89-dc60-484c-8fce-6f0a5669c623"
      ]
    },
    {
      "cluster_id": "e6cb9f82-faa2-423b-984b-e379572890e7",
      "members": [
        "db9e5a23-3a2e-4931-94be-3d217cff127d"
      ]
    },
    {
      "cluster_id": "6832730a-f3c3-49e8-8c1f-45ff7dac590c",
      "members": [
        "e9c08668-5d1c-498b-a7dd-5a1d19c0a798"
      ]
    },
    {
      "cluster_id": "00a040a7-5456-47e8-b780-a67388e64219",
      "members": [
        "44736c58-751e-4ef6-b9fa-adde3127863f"
      ]
    },
    {
      "cluster_id": "21eacc7c-c9da-4edc-ac35-3ab550e3b7af",
      "members": [
        "d3c8bcb7-2012-4617-ac2c-f4f9349cc592"
      ]
    },
    {
      "cluster_id": "b3413e76-c570-4047-aa2b-63946d5b2c25",
      "members": [
        "fef26ec5-e59f-45c1-a5a4-646b7ba8ec8f"
      ]
    },
    {
      "cluster_id": "695b3abb-f469-4406-b1ea-91e5eba8aa09",
      "members": [
        "850e683d-b2ea-44b2-aa45-fb224b8681fb"
      ]
    },
    {
      "cluster_id": "c4bd1c97-a831-4763-9c03-6a3cf69f7caa",
      "members": [
        "214c593c-eba7-4ad5-bc36-3652a10e5726"
      ]
    },
    {
      "cluster_id": "0a1db453-23bf-4b25-a04b-c4f13d273e88",
      "members": [
        "413ca3c8-8833-4fea-95cb-3d766a54756d"
      ]
    },
    {
      "cluster_id": "52902c20-eb03-45dd-8441-6d06b77f992c",
      "members": [
        "782a8eea-e09b-47ad-9879-22709d78e759"
      ]
    },
    {
      "cluster_id": "066e0772-a7cc-411e-9810-7c9b5b3dd73f",
      "members": [
        "559abe16-c942-41c8-868f-fae4d96b3a1c"
      ]
    },
    {
      "cluster_id": "5d8d730b-6674-4d5b-8f99-6c8e240e9080",
      "members": [
        "56c5baf3-de4e-4dae-9140-e8515970c81c"
      ]
    },
    {
      "cluster_id": "f7f1bbb8-f068-46fa-acbf-d579d1b4e308",
      "members": [
        "aae65b6c-d7b1-453e-aac3-d557018c16b8"
      ]
    },
    {
      "cluster_id": "c78cce84-ea53-4b86-8393-67ca74594e0c",
      "members": [
        "049f4fc9-03e6-4f0a-83fc-2cbfee582f7e"
      ]
    },
    {
      "cluster_id": "5a8c09d4-337f-442b-8464-f2be567010bf",
      "members": [
        "4827d13a-0d89-4c69-8325-411684ffddba"
      ]
    },
    {
      "cluster_id": "df13c28d-11fd-4cdc-a0c7-5076d0c46483",
      "members": [
        "b8cb1e37-a9ee-4866-95c5-1f5036695355"
      ]
    },
    {
      "cluster_id": "818b32ce-b83e-40a4-b06b-dd4e2c09af00",
      "members": [
        "4b0493cc-0ec3-44ab-9682-69dbebada129"
      ]
    },
    {
      "cluster_id": "dc73c39b-d234-4200-a04f-dc1af208480d",
      "members": [
        "39148726-18c2-47ab-95c4-5001bfb98ee1"
      ]
    },
    {
      "cluster_id": "346f630a-2d46-4e8a-80ef-67a96ebf81ef",
      "members": [
        "cfa983d6-9dad-4763-bd75-c81a2285f59f"
      ]
    },
    {
      "cluster_id": "e88c49ad-3df2-4059-82e4-46d0f3b59757",
      "members": [
        "c43216b5-fbbe-430d-843c-0ff3e82e28f5"
      ]
    },
    {
      "cluster_id": "4bda17b5-0897-437b-9ad7-ab5783ada079",
      "members": [
        "f28554de-91a0-42ff-a02e-bef7bd3f1398"
      ]
    },
    {
      "cluster_id": "983e06bd-8aef-468f-888f-6f39b0353693",
      "members": [
        "9246277b-632c-43ba-975d-947ba8474dcd"
      ]
    },
    {
      "cluster_id": "67bef4c5-afcc-4a65-9538-ce302f965385",
      "members": [
        "ef6e2f62-e4da-4bca-b1ad-ab18c8fe45f2"
      ]
    },
    {
      "cluster_id": "ee431334-0b63-4389-8c3c-60633233fd26",
      "members": [
        "2c06ff17-3a5e-4dac-a0b2-aa1321a05705"
      ]
    },
    {
      "cluster_id": "52105c27-d937-4970-9bad-c139e21a6205",
      "members": [
        "1f151033-fa0f-432d-bfae-8dd97991bcee"
      ]
    },
    {
      "cluster_id": "e37c8f7a-2656-421b-b216-1d87659bcb44",
      "members": [
        "fe32af40-4500-4d43-a1c5-ea02937c4c4b"
      ]
    },
    {
      "cluster_id": "186330e2-1680-455d-ad21-27f2e0125a31",
      "members": [
        "3c4db7e6-ebcf-4c14-8c80-5acce367863a"
      ]
    },
    {
      "cluster_id": "fb518ec1-f92f-4616-8a47-9c0563a7f0fa",
      "members": [
        "1ca70899-971e-41e3-a537-3ec6776c088e"
      ]
    },
    {
      "cluster_id": "24daffdf-e642-42fa-ac82-39c90e12f420",
      "members": [
        "60cb9b77-25b6-4a6f-81a2-a7bb90327f82"
      ]
    },
    {
      "cluster_id": "a316407d-a413-48ec-95c7-f1a3c83da782",
      "members": [
        "fe511ca5-5050-449f-a284-d8293d7b0c96"
      ]
    },
    {
      "cluster_id": "93c53898-2dc6-423b-a4d6-b61dd90c6d6c",
      "members": [
        "2c581133-af8b-4910-a5b4-19bd1832f813",
        "0b8cdef4-3750-4015-872a-477c40ea8043"
      ]
    },
    {
      "cluster_id": "18108091-50d0-4bb5-a06f-5f2734380aef",
      "members": [
        "4aab92fc-d883-488e-bca0-15f56952fcc0"
      ]
    },
    {
      "cluster_id": "90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410",
      "members": [
        "1e33ee40-e3ca-48f3-bfa4-a83d268f0b1e"
      ]
    },
    {
      "cluster_id": "3fc70d09-8a93-4a60-b903-b03cd4187227",
      "members": [
        "490c32d7-44ee-43dd-9430-5b67acfadcbb"
      ]
    },
    {
      "cluster_id": "a4e781c0-f96b-465a-94d9-bc076c57b2b1",
      "members": [
        "9a49c057-060b-4aa0-8605-bc212bdce2e7"
      ]
    },
    {
      "cluster_id": "e21b1b35-31f0-4c02-9069-b35c0b38b172",
      "members": [
        "32ce6b58-43d6-484f-915c-0918e220fd62"
      ]
    },
    {
      "cluster_id": "63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7",
      "members": [
        "96814f16-e24f-40de-ae84-fb0188df7399",
        "9cb8eba0-6a9f-48a3-9ea5-9b83b2c1a0b9"
      ]
    },
    {
      "cluster_id": "2adce5ae-1669-4c77-b898-ed9abf7276da",
      "members": [
        "4b0acc73-1804-4517-937f-1b5ad41cb490"
      ]
    },
    {
      "cluster_id": "fbc30c99-229d-49c2-8ecb-ce9a62431408",
      "members": [
        "235efa02-9b47-4eac-b7bd-fa49f55a6b79"
      ]
    },
    {
      "cluster_id": "0aa10a76-1680-4566-9d3a-ebaa3e486aaa",
      "members": [
        "09b7bc02-54e4-4f14-9a8c-ea0414b9cc0e"
      ]
    },
    {
      "cluster_id": "44f7e426-bb87-4dd0-bf0c-80fb71c61eac",
      "members": [
        "c644a19e-7959-4dbe-bb1d-5da1d7e8db40"
      ]
    },
    {
      "cluster_id": "9c8e3c4f-c6aa-493f-ae68-b49b723b4cde",
      "members": [
        "aca4f631-b4e0-46c0-9977-79908d2a056e"
      ]
    },
    {
      "cluster_id": "16e38b6b-7241-4f9f-8554-c33f05a6edb7",
      "members": [
        "cff50cf1-148e-4d81-9d29-27a702bbb6ac"
      ]
    },
    {
      "cluster_id": "dce81269-fe31-49af-8310-17a573139956",
      "members": [
        "31eed9a0-709b-4a3d-8b0b-39d363374e35"
      ]
    },
    {
      "cluster_id": "a15b31ed-89e7-4c30-9559-8eac356b32e1",
      "members": [
        "c95a2f22-d6e8-4959-ad36-6fd6e6c0589a"
      ]
    },
    {
      "cluster_id": "d8515ae8-12a5-4f84-b01f-bc10b41b19e0",
      "members": [
        "914b6f6f-2fca-4af8-9488-1a2ce148ed7f",
        "0c8c8f99-e607-41e7-947f-ad2fc3b0e67a"
      ]
    },
    {
      "cluster_id": "b93f59d3-e54a-4700-86ef-b20c995b73b6",
      "members": [
        "3f31c2fc-e518-44a9-b233-2088b1bfc18a"
      ]
    },
    {
      "cluster_id": "20d6183f-1c47-41c9-bd8d-d5a8b68eff2e",
      "members": [
        "18cf1ce5-3c6a-4bdc-b913-675ce17f06f3"
      ]
    },
    {
      "cluster_id": "71755eb8-e7df-4bfc-b448-f56fe2b8b242",
      "members": [
        "fad0d97a-967b-45f5-94a1-0ca5aca96640"
      ]
    },
    {
      "cluster_id": "bdd5143f-e24a-4ec7-81b7-681d3ac6b3f5",
      "members": [
        "679de09b-9b77-4640-b961-aec420f2fb00"
      ]
    },
    {
      "cluster_id": "43beda49-4348-4ff0-94eb-8102078e161d",
      "members": [
        "eb010d8a-b114-4016-9f56-547f3f7b89df"
      ]
    },
    {
      "cluster_id": "507dd458-2eaf-480a-89be-7acf52e56a97",
      "members": [
        "c3bcf198-1424-473c-8a8c-663e70803e87"
      ]
    },
    {
      "cluster_id": "f367b654-8f0a-4a4d-816e-54c86d7f13ae",
      "members": [
        "3dfbb796-816a-4bcb-8e8c-6d0a8aa6706b"
      ]
    },
    {
      "cluster_id": "2a1de060-abb4-43d9-a91c-f13c074e7031",
      "members": [
        "395ed66c-1d26-4d1f-870c-5401a963aec5"
      ]
    },
    {
      "cluster_id": "0d813aeb-360a-48ec-afeb-778e533504c7",
      "members": [
        "f9dbc081-1611-4178-93da-896aed2eec7b"
      ]
    },
    {
      "cluster_id": "0bb1f8c0-08c1-4f63-b6c8-052a5bad160c",
      "members": [
        "4d3c4642-883f-4145-98a3-9370b82ef841"
      ]
    },
    {
      "cluster_id": "21361eee-5fe8-48f0-a512-8a8c4752daae",
      "members": [
        "0a8f55be-555c-4c88-b454-178bad2a9dd4"
      ]
    },
    {
      "cluster_id": "6f548f26-3ad4-4adb-80dc-c3f3104f0d7f",
      "members": [
        "efa65091-ad55-46d9-b00b-8bf893d6fb30",
        "7e985f17-a69e-4ed5-bf5c-461248b507a9"
      ]
    },
    {
      "cluster_id": "285cd62d-96d8-4ff1-af84-3fd22f7b4f51",
      "members": [
        "3117bdd3-fe21-4976-ba21-ee3604b9e13c"
      ]
    },
    {
      "cluster_id": "635833cc-6550-4cab-b41a-e51cbfca373a",
      "members": [
        "9f36031c-5916-4e74-935a-bb47d9d96ded"
      ]
    },
    {
      "cluster_id": "0950755f-651f-455e-a7d5-47091afd7de2",
      "members": [
        "4e21a3b4-2946-4d8f-9487-14f91e7e9c72"
      ]
    },
    {
      "cluster_id": "fa621ebf-8ee4-47c4-b584-f5012ff39561",
      "members": [
        "aa4040ac-5dc6-453b-ad32-33c50706dfe6"
      ]
    },
    {
      "cluster_id": "0bc36847-debb-43d3-bab5-e1a736194eac",
      "members": [
        "2fc64496-af63-4c5c-abb3-9f84496a307a"
      ]
    },
    {
      "cluster_id": "94076701-ef33-45db-95b9-6fd0d66deba4",
      "members": [
        "13111903-7ec4-4b35-892c-1db611c8e2a8"
      ]
    },
    {
      "cluster_id": "12e02de9-758e-49f6-b31c-fe52770a7aa7",
      "members": [
        "c6a08cf6-77ca-4409-9b0a-6fb71acf61e2"
      ]
    },
    {
      "cluster_id": "fe5b3c77-4467-4eae-82f8-8e1dd2f75d5b",
      "members": [
        "bf34edb9-658d-4a0b-97be-9cbefe833a99"
      ]
    },
    {
      "cluster_id": "a615f0ed-7c6c-41b5-95d0-49cb25bb9feb",
      "members": [
        "c86e3c48-755c-4b5d-8c98-a72e6affa674"
      ]
    },
    {
      "cluster_id": "a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4",
      "members": [
        "c18bc9a5-4f5c-4c49-bf4a-768caf8f8785",
        "62670d51-2419-4ae6-9c54-f93a58e21695"
      ]
    },
    {
      "cluster_id": "587bb9b0-b0dd-47bf-9ce3-29231f30f4a3",
      "members": [
        "3d7cfe24-7ccc-4715-a510-ea6e42271f97"
      ]
    },
    {
      "cluster_id": "b7bef44a-7480-409a-8790-0a70b42045ee",
      "members": [
        "6f1d0218-2aaf-4ca5-b70b-202058baaf47",
        "1f6c819f-22c5-4385-8e22-29e91daee72b"
      ]
    },
    {
      "cluster_id": "7ae548ab-8f8f-4668-ba05-a2abf4b89759",
      "members": [
        "3dbaecae-f023-4a6d-99ee-f9c83ed6d59d"
      ]
    },
    {
      "cluster_id": "07b6bde9-eeca-4fea-b3c2-39093320ea05",
      "members": [
        "1ed21ded-a58d-4450-9265-91ccc6e02072"
      ]
    },
    {
      "cluster_id": "fc0f4ff8-8147-4b0b-be66-dcae01810fe6",
      "members": [
        "3af16777-d1d0-4e80-a9f5-2f99d1033c6d",
        "d31ecd38-9b36-4434-b556-2ed92e43b61f"
      ]
    },
    {
      "cluster_id": "42ec0ecc-4c37-4216-9671-a26ac18a9ead",
      "members": [
        "0dfca0dd-799d-48de-ad62-11e1841e3fd7"
      ]
    },
    {
      "cluster_id": "7b4d9f3b-78aa-4507-8228-424f51cb5289",
      "members": [
        "355ea973-9d66-429b-9998-3ed67368dc37"
      ]
    },
    {
      "cluster_id": "30ae8997-b16b-4477-bfec-33c1a345955b",
      "members": [
        "ca9ae69d-5e7d-4172-9055-bc081efdd1dd"
      ]
    },
    {
      "cluster_id": "555fa82e-54c2-4aba-bcc8-bcfe1ec2186c",
      "members": [
        "559d7895-3171-45e9-a0d1-e435947066ac"
      ]
    },
    {
      "cluster_id": "ab378ec8-ca7a-473f-b276-44d546196e26",
      "members": [
        "bf34a0d6-69de-4dbe-b228-ed90e9008781"
      ]
    },
    {
      "cluster_id": "61784f3e-1c50-4b37-9db4-0fd1ec458127",
      "members": [
        "bdd349a7-4515-4da4-af05-4548d7083f52"
      ]
    },
    {
      "cluster_id": "34e53235-60e8-4299-9389-633db39ab300",
      "members": [
        "65d1fbc1-c1ed-46c6-8363-e70bb39e0073"
      ]
    },
    {
      "cluster_id": "e41399b8-77c7-4930-886f-cd94ab46ea34",
      "members": [
        "d48a5434-e0b7-4030-8162-a726e2a9395a"
      ]
    },
    {
      "cluster_id": "9bcb7463-7e6a-4bab-b398-5dd6ead423be",
      "members": [
        "dbdae94d-af2c-4bc4-9cfb-bc5655793791"
      ]
    },
    {
      "cluster_id": "cba79c22-94bf-4911-a28d-ebd794325eaa",
      "members": [
        "1d8e287e-62a1-463d-95e5-61e0cb648713"
      ]
    },
    {
      "cluster_id": "ed42b61a-7c55-44a7-aac6-78560e6e139e",
      "members": [
        "7b9481f9-8112-4bc8-bd57-8107fcb6cb90"
      ]
    },
    {
      "cluster_id": "f58ca21a-7af7-4062-9509-f6480d8a6390",
      "members": [
        "ab781808-3305-433b-88bd-941249abd97f"
      ]
    },
    {
      "cluster_id": "fd11e091-21e1-40df-916b-90aba2945065",
      "members": [
        "4846e35e-b5fd-4a27-b4eb-19ce31173495"
      ]
    },
    {
      "cluster_id": "a75c6491-7fc4-4904-9a47-b176fcc90a36",
      "members": [
        "2377ee2f-c1b5-4984-9853-d503eb644658"
      ]
    },
    {
      "cluster_id": "668dd84f-417c-4a0b-ac12-78d246a5f46e",
      "members": [
        "705089db-d047-4aaf-9efe-0eba267d2e09",
        "ceed53ab-4e93-475a-986c-3a214d121952"
      ]
    },
    {
      "cluster_id": "f09098cc-f345-415b-a2a8-3f7563f7b80d",
      "members": [
        "f6062ca0-f886-40e4-8ded-a9ca73878d31"
      ]
    },
    {
      "cluster_id": "289e5c59-c24f-465d-931a-b56b54bc982f",
      "members": [
        "e2288ded-588c-42ab-a0ea-06f15a3b8624"
      ]
    },
    {
      "cluster_id": "dea6592f-a2fb-4ea8-b832-4f7df984c163",
      "members": [
        "b1bfb305-5ccb-4cf7-9e9c-32d77fbea960"
      ]
    },
    {
      "cluster_id": "a2f18fa4-3554-4400-be7d-a33cb07dfa44",
      "members": [
        "4d449963-3c83-4ca5-a518-09c04a8066bc"
      ]
    },
    {
      "cluster_id": "9dae5050-ee2d-4e3c-8dd3-b9ea85a53752",
      "members": [
        "8d476653-8abd-46d5-ac3d-f0a4a2cd468d"
      ]
    },
    {
      "cluster_id": "19581d0c-22b5-4ff0-8a68-de86fb01009c",
      "members": [
        "b1d44b1e-4296-4f67-8f78-0ddfb3a5d8e1"
      ]
    },
    {
      "cluster_id": "db268f9a-c3a8-4e79-a3b0-df934c32f645",
      "members": [
        "42bf77b3-e0b2-4e5a-86b1-fc489416a7d3"
      ]
    },
    {
      "cluster_id": "15516ad5-b153-4147-8246-ecae0ddbf175",
      "members": [
        "1a05352e-5ad5-457b-af01-e151d9a78829"
      ]
    },
    {
      "cluster_id": "8806403a-c610-4055-9744-edc72cda745d",
      "members": [
        "95e9fe43-5bd9-4517-8c75-ad87b874e86c"
      ]
    },
    {
      "cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
      "members": [
        "9af9e18f-fa69-41e2-adf9-4a24e42c1b84",
        "1c6bdb4c-9bfc-466a-a7ee-4d8b2e346cb9",
        "601a74ac-c835-46a7-97d9-93b4633920f9",
        "43595c4b-2a87-45eb-9d9b-3fd7a30f928b"
      ]
    },
    {
      "cluster_id": "e0d4056d-6cdc-4a90-ba78-5aecf0b2092e",
      "members": [
        "5201ea05-3c66-4f33-8c67-ce6caf33f3f4"
      ]
    },
    {
      "cluster_id": "183db562-aea1-4c36-b76a-f0deea54c6a4",
      "members": [
        "3f248e4c-edd5-4205-b450-821576e9195d"
      ]
    },
    {
      "cluster_id": "9ef9c32c-d40a-4d36-a3db-c01367d4c96e",
      "members": [
        "d6398523-0ffd-447a-8554-59fcfee589bd",
        "5628795e-a7c7-44b0-ac00-289259aa71d5"
      ]
    },
    {
      "cluster_id": "ea149597-1daf-4627-8587-59eb8a6bde8b",
      "members": [
        "f77f73a6-8d42-4767-9384-fbe2af0f6cd7"
      ]
    },
    {
      "cluster_id": "26852476-f26f-4f97-92bf-7cc2d9373f4e",
      "members": [
        "f4029d86-fdce-4ef4-b075-d09aff0725af"
      ]
    },
    {
      "cluster_id": "7c3b0d63-9fd5-46b2-943f-8bc9d4005fc6",
      "members": [
        "f971b469-261f-43ef-98d8-2c5946168e63"
      ]
    },
    {
      "cluster_id": "aa179085-85ff-43d4-ba04-8a3f88267ae8",
      "members": [
        "50acc255-34d5-4628-bcc1-a683011cf488"
      ]
    },
    {
      "cluster_id": "663bc264-4933-4e53-8689-d8e35c02d013",
      "members": [
        "bfa7b823-2a59-436f-82ee-922dc42e266d"
      ]
    },
    {
      "cluster_id": "796ddc52-9094-4fcb-af10-9fa6a06448ba",
      "members": [
        "18e1d515-c745-4151-88c1-8c9e9af7547d"
      ]
    },
    {
      "cluster_id": "055b1edf-5e4a-4fd8-b913-a9d1df63a85a",
      "members": [
        "d40539dc-69f1-4f92-a72d-ae21d808cf04"
      ]
    },
    {
      "cluster_id": "8165992e-6782-4b62-b794-6309bbfbaf5c",
      "members": [
        "20ad280a-9ca6-42d4-8560-8ef0babec400"
      ]
    },
    {
      "cluster_id": "1ba178d9-d925-407c-bb75-60c655774cbf",
      "members": [
        "51cf9cc5-964d-487b-b0ac-9496efa28c40"
      ]
    },
    {
      "cluster_id": "8ac816b2-de5c-4294-a968-e6279613b1d8",
      "members": [
        "3076ff95-fa54-4f38-8fda-8d49ad5f5f5b"
      ]
    },
    {
      "cluster_id": "ade8c501-ccec-40ec-b096-cd50cd90be07",
      "members": [
        "91e15b87-d451-447d-83a5-56bb79569eed"
      ]
    },
    {
      "cluster_id": "510b63b0-aea2-446d-8868-5c88431cc9fe",
      "members": [
        "9386cc51-2d6f-4bdf-9354-bbd0755c9cb1"
      ]
    },
    {
      "cluster_id": "8f07bc53-1683-4b3a-b1de-2e1c15c0e13c",
      "members": [
        "a308b049-5da8-43ff-aba2-9a9c0276d910"
      ]
    },
    {
      "cluster_id": "42c5367f-fb48-41ea-b66c-1b344a5b61cf",
      "members": [
        "f0666037-3fb1-462e-8c7b-66b127fba72e"
      ]
    },
    {
      "cluster_id": "9e906023-8a3d-4a63-9309-18e9ee1c3641",
      "members": [
        "37a3eb67-d193-4c87-a056-44ec271b6890"
      ]
    },
    {
      "cluster_id": "5a8284e8-a150-41dc-8ee7-edbc3da33af5",
      "members": [
        "ed748149-b43c-4488-a119-7d3b55d695d9"
      ]
    },
    {
      "cluster_id": "f07cc872-d3c5-4a88-8201-4dce67c0d460",
      "members": [
        "db8f6262-d359-4671-9a89-8e585aad0bc6"
      ]
    },
    {
      "cluster_id": "99681bf5-4780-4832-b6fd-70acc37bfc27",
      "members": [
        "ee7b7f93-c6b9-4025-99d6-a2d067b69ab5"
      ]
    },
    {
      "cluster_id": "126818cf-8924-40eb-8cb3-edad41027c0e",
      "members": [
        "f73337a1-ea01-41f8-8dfa-1089a6101eaf"
      ]
    },
    {
      "cluster_id": "cd099a56-0545-43d7-bbda-54857a323642",
      "members": [
        "60c414b2-02d3-43e3-ab59-2a05ea85c25d"
      ]
    },
    {
      "cluster_id": "8b124bbc-d0ac-4d8c-bc1d-bbdf5f6ae201",
      "members": [
        "31a87aa3-2cdc-4a51-970b-c4552af60231"
      ]
    },
    {
      "cluster_id": "2fc0be9d-df8b-440d-a58e-2ec4422f1712",
      "members": [
        "db7c86d1-007a-434b-9049-ab67281a99c1"
      ]
    },
    {
      "cluster_id": "cdd48d7f-71ad-45d9-b5c0-d84849f26b67",
      "members": [
        "68f0d160-583d-481e-83df-68c4639466a7"
      ]
    },
    {
      "cluster_id": "d6ec7b4a-689f-48d4-bb2a-ff95c991125c",
      "members": [
        "461c8397-4732-40d0-a312-c8fb8792a2bf"
      ]
    },
    {
      "cluster_id": "66df7edf-0972-4fa2-846f-2e6326ee828b",
      "members": [
        "26a96b2d-3797-496d-8ac7-3ed2dd390863"
      ]
    },
    {
      "cluster_id": "7940ac84-eeae-4d7a-9072-fc2e9ac63265",
      "members": [
        "f7763ef1-0586-4f10-96ef-9996f889cdfd"
      ]
    },
    {
      "cluster_id": "749a09bf-2f2a-4d19-aa9f-a22ffc94264d",
      "members": [
        "e0831560-5a10-4b72-a32c-0beb2101c523"
      ]
    },
    {
      "cluster_id": "3d9bd6b9-ad1e-4d65-b911-715849482ace",
      "members": [
        "9ba9c7a2-13ce-4eeb-bd31-2cddba33d2fb"
      ]
    },
    {
      "cluster_id": "e205a390-4f4b-4898-961e-ef5a0bf3f3d0",
      "members": [
        "0b1a8480-5c98-4ba3-94af-4ddeb88f0fa3"
      ]
    },
    {
      "cluster_id": "3fd55ffb-10d4-4e70-9352-8bd5b0751ffd",
      "members": [
        "f1306acb-108e-4ee9-a8a2-aafd43375285"
      ]
    },
    {
      "cluster_id": "97b87ffd-da0c-47fa-86ae-0eedf718bf3e",
      "members": [
        "b2e81b33-d30a-4225-9bbc-48fb82b96209"
      ]
    },
    {
      "cluster_id": "cf53004b-b29d-4fe7-a412-14956f8d2a9a",
      "members": [
        "15d51b8d-9bc0-4395-b6a2-58477343cae7"
      ]
    },
    {
      "cluster_id": "83392417-156e-4467-96c4-b7a769a50f3f",
      "members": [
        "2f980e48-1150-4fff-be2a-30cbaff52bbb"
      ]
    },
    {
      "cluster_id": "e8ac4064-b696-4a9d-9c57-bc79d628e859",
      "members": [
        "11f609b4-7a2c-4cef-9ec5-eabce404dbbf"
      ]
    },
    {
      "cluster_id": "d63b1ded-8126-4556-8052-238b4f8872c9",
      "members": [
        "85c3d135-1fba-4982-b96a-cba7c669d7f0"
      ]
    },
    {
      "cluster_id": "4fc703c8-a28e-4bc3-ba13-2190c2afdda4",
      "members": [
        "0e09f55d-e12d-4e27-b424-be835d42044b"
      ]
    },
    {
      "cluster_id": "830f6edd-9e60-427e-9ff4-9fac93a52411",
      "members": [
        "864703a6-b3a5-4fa7-8ff1-321bdffd8e40"
      ]
    },
    {
      "cluster_id": "2706ec99-75d3-433d-ab95-f5c524eb1832",
      "members": [
        "4a8f4191-7339-42e4-b14e-4481e9d543ed"
      ]
    },
    {
      "cluster_id": "18d83743-88ff-4a61-999f-d69912fd6589",
      "members": [
        "c07e9dda-0c21-4c8c-8ea3-d415f66e9ade"
      ]
    },
    {
      "cluster_id": "13672f1a-e63c-4ec7-9f85-d3ed61ff60fa",
      "members": [
        "221e2843-0d1d-4934-9175-536b037f0687"
      ]
    },
    {
      "cluster_id": "7afb7680-3722-423f-b129-7076bfb88092",
      "members": [
        "0aa14ed9-8f5f-4f78-8937-57e0b1539d61"
      ]
    },
    {
      "cluster_id": "c29b208b-6490-4cf8-b641-83fe57eafe9a",
      "members": [
        "8b61f97e-9475-4370-97c1-b0602d3861cf"
      ]
    },
    {
      "cluster_id": "a0d964f3-2911-42e0-a686-2f4aa48a2f24",
      "members": [
        "896217cb-d2af-414f-b5d3-51faabbc1542"
      ]
    },
    {
      "cluster_id": "84019696-e95b-4f09-b37b-dd61ce673e9c",
      "members": [
        "3ef38ce4-3be3-42aa-a325-e6d43d492fce"
      ]
    },
    {
      "cluster_id": "a764eb56-b1bb-470b-bb17-4bd9f5369b4b",
      "members": [
        "e83d4367-7b6a-4345-a3f1-d00d0b00e230"
      ]
    },
    {
      "cluster_id": "97f84153-8f49-432f-a8f7-a4e57fe7f769",
      "members": [
        "e36ec763-c008-4d62-bed9-5c270d796253"
      ]
    },
    {
      "cluster_id": "af3f95a3-d597-4371-bf7f-e4f5d91a9b73",
      "members": [
        "f57eb09d-4839-4483-b263-99c536579018"
      ]
    },
    {
      "cluster_id": "6c53a575-96c0-4b04-a196-adb1bbc90de7",
      "members": [
        "01c9a984-5ece-42de-9e7e-2449849d6790",
        "629da89b-c0d1-4e00-a631-f9127df0bed1"
      ]
    },
    {
      "cluster_id": "dcc40b89-996b-46da-af7f-ec64a05c6ee5",
      "members": [
        "4f7c4c9e-7e0b-4bbf-9bc8-39859ff7d243"
      ]
    },
    {
      "cluster_id": "a3891be3-55f1-4794-b99d-304a26e4b465",
      "members": [
        "d699106d-5b88-4e20-9413-43a5243fe144"
      ]
    },
    {
      "cluster_id": "6c41ffdc-392b-45d6-b68e-a4cccabb1714",
      "members": [
        "899d585b-f8a1-46d4-aecb-51c086aced46"
      ]
    },
    {
      "cluster_id": "38841999-14cb-43f3-a2d5-27d9791973f6",
      "members": [
        "0192c2a6-abf8-487a-ae10-a2de71b9303e"
      ]
    },
    {
      "cluster_id": "f3c74d17-b66b-49d5-9e91-ad7f843bbd39",
      "members": [
        "daf9f724-fde8-4531-bd2a-de74dd77c316"
      ]
    },
    {
      "cluster_id": "d717bbe6-a62d-46c1-8d61-866b7d90a851",
      "members": [
        "0b056afe-9555-4444-a11b-8067678748fb"
      ]
    },
    {
      "cluster_id": "56d92634-56f1-4385-a700-927cf573e5bc",
      "members": [
        "1c81eba8-a29a-49ee-aa9a-249eb28d0a95",
        "736fc05c-c8ce-4304-910b-c143ec389610"
      ]
    },
    {
      "cluster_id": "565749fa-0214-435c-be6b-1a2ffed6aba1",
      "members": [
        "04225ddb-8ca4-41ae-9ca5-314b7d1e53f0"
      ]
    },
    {
      "cluster_id": "84a6bd0b-f777-46d5-bcae-3f166d028b6a",
      "members": [
        "de6d291f-4bac-4d72-95fd-85e7525fd5bc"
      ]
    },
    {
      "cluster_id": "54c90db1-79c2-4dc0-b9f0-9cd9022a857f",
      "members": [
        "b1f962d0-8550-4b2d-9191-63c14905d540"
      ]
    },
    {
      "cluster_id": "d012c47c-3d49-4f8a-9fcf-db101ff82249",
      "members": [
        "68b8c45f-ffc4-4a92-a4b2-5ec0f20a0bb7"
      ]
    },
    {
      "cluster_id": "3b4d0d09-6630-4f48-897e-19fe1449086b",
      "members": [
        "4cec07ca-d88e-48f0-93de-7efd62925b38"
      ]
    },
    {
      "cluster_id": "dfd9bb6d-a08b-428d-8e19-e9eebd219088",
      "members": [
        "5d66c5b0-29b4-4fb6-a971-f86c924a9c20"
      ]
    },
    {
      "cluster_id": "de6ada25-e81a-4f5a-97f6-0053df68ea0b",
      "members": [
        "36ed0712-67c2-4c18-8b10-d47f1abaa21d"
      ]
    },
    {
      "cluster_id": "d01db0e4-579b-46e1-b0a0-4bf5732646a8",
      "members": [
        "b9965956-2e89-4214-91ce-8b4af2583f6f"
      ]
    },
    {
      "cluster_id": "de17f70c-2147-4c34-a071-59d11378f1aa",
      "members": [
        "fb88fa48-6744-4cdd-90bd-b2e2eddc6477"
      ]
    },
    {
      "cluster_id": "e632bc78-90b4-46bf-a31b-df8259ac6d90",
      "members": [
        "0d799b10-e143-43f0-a3f7-dfa3398a7ea2"
      ]
    },
    {
      "cluster_id": "4892691c-c25d-434c-bfaf-8b1764a0e393",
      "members": [
        "a3589f11-b596-443e-978d-eaa153795255"
      ]
    },
    {
      "cluster_id": "1d3c5fb8-134e-4cb9-8e15-b1a4488a82ec",
      "members": [
        "56f254a6-a740-484e-8f3d-5d3900878147"
      ]
    },
    {
      "cluster_id": "d755be56-db7e-4317-8d05-387807a1a892",
      "members": [
        "dcfd6c52-886d-4da0-896b-e61501045564"
      ]
    },
    {
      "cluster_id": "b3b1fd7c-7ffb-411d-b821-50b6108ebae7",
      "members": [
        "e6112557-b39b-4c67-98fe-f9aa53d6ef2f"
      ]
    },
    {
      "cluster_id": "a3463468-dce8-4063-85c5-ecdc64691fed",
      "members": [
        "47702199-6d33-44d8-8aae-6b64c07f1e45"
      ]
    },
    {
      "cluster_id": "14b46c0a-7b16-4722-b599-90d7d69970a1",
      "members": [
        "56780c55-2348-43c4-8452-d1280da550a8"
      ]
    },
    {
      "cluster_id": "6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5",
      "members": [
        "7e015da3-09f9-424f-a950-64fac9192a16"
      ]
    },
    {
      "cluster_id": "0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879",
      "members": [
        "22265ef5-f29e-463f-b350-1d766fff6dcb"
      ]
    },
    {
      "cluster_id": "b433d9b9-0986-4c75-baab-f74fc73be2ca",
      "members": [
        "795bd233-4202-40bd-8378-0cfac2c7ae0e"
      ]
    },
    {
      "cluster_id": "1e256780-a5db-4471-b8f2-5390a4dea1fb",
      "members": [
        "422fdfd1-eb02-4b3a-9f93-ed1833ef5a72"
      ]
    },
    {
      "cluster_id": "980136c6-363f-4cda-bc50-cca417518993",
      "members": [
        "8a8a4d58-3c81-4041-bf47-6870a50bc623"
      ]
    },
    {
      "cluster_id": "a536505f-e31a-400e-a4a5-1f74a9e29e7d",
      "members": [
        "9856cfa4-7841-4cd4-bd37-fefbd15ed23a"
      ]
    },
    {
      "cluster_id": "2c9fc1d9-b4d4-4707-a2ac-1245937847ac",
      "members": [
        "e9248000-40b5-4f1d-a451-0c4d3506ff1c"
      ]
    },
    {
      "cluster_id": "b34ea819-97f6-4215-92c0-351b2f770110",
      "members": [
        "91892df5-916f-4a03-b17e-bf8deae2e9c1"
      ]
    },
    {
      "cluster_id": "970c1f51-0eea-45a8-842e-874c83ffa389",
      "members": [
        "ae143f57-f1cd-48e7-bd68-d27bf956dbd5"
      ]
    },
    {
      "cluster_id": "856ae956-c845-42c3-8716-9e150f646a11",
      "members": [
        "95065231-541d-4d0c-9d43-2073939beee1",
        "62e384e2-a7d6-4f5d-baaf-5e1405aaf635"
      ]
    },
    {
      "cluster_id": "c7c24801-e07d-4e78-8de0-4a42e8b64272",
      "members": [
        "4afa5b76-da52-452b-afff-cd61d074bee8"
      ]
    },
    {
      "cluster_id": "0d0fd5f0-0301-424f-b0b1-a60ab6ca045f",
      "members": [
        "c49e05e5-75c7-469a-aa86-55b964450bfa"
      ]
    },
    {
      "cluster_id": "3356bac0-8ec4-475b-81a7-e146187a74ba",
      "members": [
        "e11d0c1e-57e7-4703-8ef4-16156adef49a"
      ]
    },
    {
      "cluster_id": "39f6fc8d-27a2-4261-870e-362c0315c46f",
      "members": [
        "807b722b-d3a7-482e-9a03-1405557fdd75"
      ]
    },
    {
      "cluster_id": "5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9",
      "members": [
        "3458447f-3248-4191-a1b3-f1fd8a0008ac"
      ]
    },
    {
      "cluster_id": "d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9",
      "members": [
        "fbb9300f-ef97-4722-b7c1-d6227d91a0c8"
      ]
    },
    {
      "cluster_id": "095169c0-0ce4-4362-b29d-486ce7d2b848",
      "members": [
        "4580f05a-5688-4a45-a4f4-f4e24ea7b4ed"
      ]
    },
    {
      "cluster_id": "a70a3157-f4e4-4eef-b960-bdf74270bd58",
      "members": [
        "3fd0eb19-f467-4489-9035-efc27bd8312a"
      ]
    },
    {
      "cluster_id": "4767808d-19a9-4e75-b8a7-7421cf37c72f",
      "members": [
        "acd6cfba-d774-46ac-b0d1-bb30d348a186"
      ]
    },
    {
      "cluster_id": "ac4174c2-4597-4a76-ac06-95cefda372c9",
      "members": [
        "9b0fbaf1-3523-4428-9061-25539ad38933"
      ]
    },
    {
      "cluster_id": "bd13c9c1-afe0-4a04-acc3-453f611b1f14",
      "members": [
        "f4628d9e-3224-4456-9e45-eee7e8392a37"
      ]
    },
    {
      "cluster_id": "98f59c42-164f-4444-8ecb-92a7e7c88a99",
      "members": [
        "9bd9610f-f0bb-42fb-939e-0d245615f203"
      ]
    },
    {
      "cluster_id": "362947dd-8703-496a-89bc-c395dcec13b9",
      "members": [
        "5157bbae-9cf5-46ed-a5ad-28563ceb5c10"
      ]
    },
    {
      "cluster_id": "a7d034a7-5705-462b-af06-b9277d91c75a",
      "members": [
        "f0ad29ad-7310-45a6-9b76-74881092c1ab"
      ]
    },
    {
      "cluster_id": "5aeba902-7d47-4eaa-a3d1-ebbbb2d456c7",
      "members": [
        "2653155b-5304-4055-b622-9ba7c16563d2"
      ]
    },
    {
      "cluster_id": "27fad854-f733-4ec5-8acb-b36e0c043d26",
      "members": [
        "03f80d5d-9cd5-462d-8d22-644d5ef346fb"
      ]
    },
    {
      "cluster_id": "33fe2055-c6c1-46ed-8871-fc741999d32b",
      "members": [
        "de700e1a-915e-4484-a367-da94b659fb6d"
      ]
    },
    {
      "cluster_id": "e8898157-febc-4868-87fa-8effb0a882e8",
      "members": [
        "1f0a4898-00be-4da4-b5b6-f17606255acc"
      ]
    },
    {
      "cluster_id": "4c9a1f90-fd90-464e-8a7b-831a736d5b19",
      "members": [
        "c2c1f1f4-4e8e-45cd-873d-f4bf901f568f"
      ]
    },
    {
      "cluster_id": "1aadbdec-7f0b-43f3-98a7-709a1bcb5807",
      "members": [
        "5d2f265b-1852-475c-90e8-d0dc9ce73cb6"
      ]
    },
    {
      "cluster_id": "673d8d19-d059-4065-9b0d-82b1376c6c55",
      "members": [
        "a8e84567-eb93-438f-9949-cebe49e48290"
      ]
    },
    {
      "cluster_id": "268e1143-4495-4247-af6b-b6f6f368f74f",
      "members": [
        "c5ff2590-0a26-4d88-9f39-d098cd3fddf0"
      ]
    },
    {
      "cluster_id": "bdc594bb-6aa7-4421-82b8-b7df34a7c93e",
      "members": [
        "1cfecb95-178d-45b8-8ca5-332fe7d4466b"
      ]
    },
    {
      "cluster_id": "1ff73cd5-87d3-47be-9b40-e0da957f6ed3",
      "members": [
        "e7e2a469-e7d8-4e18-ba82-631b19391ab3"
      ]
    },
    {
      "cluster_id": "5d30cac5-2629-4bf5-9665-20ae87c1ec22",
      "members": [
        "0a9bd450-6735-4060-8152-3b9d3b22f36a"
      ]
    },
    {
      "cluster_id": "caa1a8ea-e71f-480b-808e-8ce18b47a5eb",
      "members": [
        "4e28ac8e-2184-4ed8-bb9c-cc33dce59d2e"
      ]
    },
    {
      "cluster_id": "18daf39a-f6c9-4439-8592-186d1ea3c4b4",
      "members": [
        "474d7066-f672-4876-af13-b242b9502032"
      ]
    },
    {
      "cluster_id": "2c61e4c1-c73f-4292-be06-e4f072faf26c",
      "members": [
        "3b1ecd72-8468-4cb4-a8a8-a2a7b1087d5d"
      ]
    },
    {
      "cluster_id": "c3c1a73e-287c-4b15-879c-42467ebdfb38",
      "members": [
        "a83232b1-08d5-4658-b88c-4a2f5e191dac"
      ]
    },
    {
      "cluster_id": "17224e3f-1dd8-4970-a1c1-0cff20d6f438",
      "members": [
        "ba50652d-7543-43b6-9e02-0b28aaa41b56",
        "49175056-e0aa-486d-86ef-95663f8e67dc"
      ]
    },
    {
      "cluster_id": "b6f111d6-8112-47dc-baeb-43c77c6392ea",
      "members": [
        "1ba49034-44f7-4c43-af12-2f2e150e5d5b",
        "1d9c6663-ae5a-4d9f-a856-e523287304a5"
      ]
    },
    {
      "cluster_id": "c198c115-5575-4cd0-82cc-408f1b46a7a2",
      "members": [
        "3d46a623-76cd-4aa4-b111-1a23ab4bbef8"
      ]
    },
    {
      "cluster_id": "d5fdaeff-23a7-415f-9e7b-758f603e5d4a",
      "members": [
        "94cbb44e-7ad1-4c2c-a84a-1197d216e7cf"
      ]
    },
    {
      "cluster_id": "8457d857-0fdc-43af-97c5-93e3a3631f90",
      "members": [
        "4c4b0e97-6438-42fa-8e70-a270d6219668"
      ]
    },
    {
      "cluster_id": "fbdddb76-bee9-4e1c-9f2e-03126700cbd1",
      "members": [
        "edc298c8-16c2-4af0-beda-99bf53575d1b"
      ]
    },
    {
      "cluster_id": "06af9b74-e018-4919-8256-29acfecc76d7",
      "members": [
        "c358057c-8a9f-4907-9c34-ba7d372e0bc6"
      ]
    },
    {
      "cluster_id": "6288e205-b9e8-41be-a3f8-80b06b50c037",
      "members": [
        "b9cf8b72-5d1b-4f16-86f0-e3f7be2b3dcf"
      ]
    },
    {
      "cluster_id": "6547f895-7ab3-43c4-b3b1-d01e17f1e888",
      "members": [
        "b5f94b88-20a6-4777-8314-1e09fe92f4ce"
      ]
    },
    {
      "cluster_id": "b8299ae1-9e2e-465d-af82-b9354f3e9c44",
      "members": [
        "70d44892-c7f8-445c-a4f1-d65699998e56"
      ]
    },
    {
      "cluster_id": "4770d222-ba7d-4bbe-8acd-294b0fe141f8",
      "members": [
        "7b52ba03-0c7c-46a5-a9ad-c73a0081f33a"
      ]
    },
    {
      "cluster_id": "af562818-5594-417a-b606-add10573c2db",
      "members": [
        "11daf81c-84f2-4989-87a3-077cc2fbea8d",
        "22587ee9-0a3d-4963-818d-de36abce0d53"
      ]
    },
    {
      "cluster_id": "a1a796af-13af-4bb2-ad74-b64193c2de86",
      "members": [
        "b73f5a87-73a5-46dd-9ecd-86efbd0a68c6"
      ]
    },
    {
      "cluster_id": "bb72233d-9eb6-4e80-89c4-220c7a06b310",
      "members": [
        "bd301cfe-c8a0-402f-b39a-0737e1fb5f05"
      ]
    },
    {
      "cluster_id": "e1f9f42d-4c64-42c8-80ee-89170b717dbd",
      "members": [
        "11d7296f-5403-45eb-b0d5-7b03b9ace4db"
      ]
    },
    {
      "cluster_id": "970cf87e-f96a-4a62-8043-264e8de25eb5",
      "members": [
        "95871097-5992-4f40-b6bf-a888c22bf1f3",
        "5878fdea-e073-45e4-8f36-4da02f629c97"
      ]
    },
    {
      "cluster_id": "aa458090-4ea3-4829-9f88-662eb71a8370",
      "members": [
        "80745886-a9ac-4a94-953f-9c082ae76c8f"
      ]
    },
    {
      "cluster_id": "8ef65ecd-3750-4a43-89ce-d81b333f2e1c",
      "members": [
        "cbd1af56-17d1-4f2a-a53a-a88d39fc29f1",
        "c093a054-ad4e-413d-97d1-2f0dce3b5245"
      ]
    },
    {
      "cluster_id": "03b72068-02c5-403e-b844-88e40b030a18",
      "members": [
        "ceb0fff5-46aa-4019-994b-affd318b42e1",
        "fe0988b3-260b-4fff-8d24-d9fa3d1fa95c"
      ]
    },
    {
      "cluster_id": "58655fd4-e92f-4f77-b848-bd4849b75655",
      "members": [
        "248f7289-5c06-491d-a0b6-436091b33dc7"
      ]
    },
    {
      "cluster_id": "8e782418-3f83-48d1-a7d0-6c3daf34ed25",
      "members": [
        "67e51910-6f7d-4924-9721-ad00edf8bd7f"
      ]
    },
    {
      "cluster_id": "838b4697-b296-48c1-b248-3458bd1a5a35",
      "members": [
        "22e4c461-4770-4ea0-b169-eaecdcb4f6ef"
      ]
    },
    {
      "cluster_id": "86fac771-eb74-4809-8f31-be78d543ad7a",
      "members": [
        "d695ba75-31bb-430b-814c-f52894643bad"
      ]
    },
    {
      "cluster_id": "435bc534-7da4-4fec-82cf-af0f2a0a282a",
      "members": [
        "e2cda163-bf74-48b3-9ce6-ba74a554f5dd"
      ]
    },
    {
      "cluster_id": "ad4fa6da-197e-4295-b610-c2f934cdd3ea",
      "members": [
        "18a6e3e5-36aa-4e8d-a899-f48ada8bfd0d"
      ]
    },
    {
      "cluster_id": "daf0b3a1-53f1-4b47-955e-785030ee3839",
      "members": [
        "8ae12054-2167-4984-b6b1-86008eddb2c3"
      ]
    },
    {
      "cluster_id": "59d689c2-02ce-4e0f-83b7-9747d98bb8fb",
      "members": [
        "99d4b89c-d792-42ec-966c-c524a13af148"
      ]
    },
    {
      "cluster_id": "1eb307cf-2274-463b-9ab8-19aee3397703",
      "members": [
        "13a23c89-11fc-4641-8963-83530ec35be7"
      ]
    },
    {
      "cluster_id": "4c86e2de-bdfc-40e3-b87c-fafaa9d03c41",
      "members": [
        "0bfed9e2-8163-47a6-a7ae-ff0cf9c7b894"
      ]
    },
    {
      "cluster_id": "004d8db2-6d73-4ac4-955b-6d04e88a0716",
      "members": [
        "2b838aa3-e871-4afb-90e5-2b918262adde"
      ]
    },
    {
      "cluster_id": "de116a88-705c-434f-9f3a-1fdabb457723",
      "members": [
        "6d25bfdb-3006-462e-bc9e-80e928211137"
      ]
    },
    {
      "cluster_id": "8140cb8c-a254-4493-b790-598f4ef3676f",
      "members": [
        "ab55dba8-aedf-4992-9bb5-82d454a89462"
      ]
    },
    {
      "cluster_id": "9562ace0-b924-497a-a3ab-5d483c835c5a",
      "members": [
        "2dccbc59-d9b3-4575-8d1f-b6fef6c515fe"
      ]
    },
    {
      "cluster_id": "54c46b5a-065c-41a2-90e0-3fac031eb853",
      "members": [
        "7c597816-a45c-4e9b-9e6b-f17f838fa55a"
      ]
    },
    {
      "cluster_id": "481f70cc-e9a5-439c-8065-a4dc8e63bd0b",
      "members": [
        "3d9b6b73-24b4-4c11-b015-9aff59721ad6"
      ]
    },
    {
      "cluster_id": "f6a8a8da-c935-4c40-b9c2-79c93b84b629",
      "members": [
        "e07c3235-a892-4e9b-8d7d-27a0e973f4cd"
      ]
    },
    {
      "cluster_id": "71cd6d97-dc20-4f7e-b7c6-5d5b5186e201",
      "members": [
        "6f8c28ec-1158-4082-93cb-dd5fe64ccb81"
      ]
    },
    {
      "cluster_id": "7b23c8f0-7f79-4c82-ac44-60b02a4ff1cd",
      "members": [
        "ba446c6e-d58f-4e5e-a537-f3c04ce2c398"
      ]
    },
    {
      "cluster_id": "13b8e657-b1a1-46e6-ace5-fc6a57928a32",
      "members": [
        "99af38ad-538a-45e2-a467-40cb688f0fff"
      ]
    },
    {
      "cluster_id": "6a4e66c3-1fd2-46be-9e31-fecdcd545826",
      "members": [
        "20289216-72a0-4039-8094-a0a3d5d764a9",
        "26ee7189-c0fb-4ab1-858c-0111039380b6"
      ]
    },
    {
      "cluster_id": "3cb553c8-9eb0-4dfe-8f4d-e85a8933799b",
      "members": [
        "49a4ff07-a9ee-4afe-b60a-c3912a9ecbee"
      ]
    },
    {
      "cluster_id": "ed1ca8c0-7841-4109-ada2-99053838abfe",
      "members": [
        "284c6be1-b028-45d4-b945-0297660ee5b2"
      ]
    },
    {
      "cluster_id": "9f4b1362-f866-4431-983b-c739ed7f376e",
      "members": [
        "09953f70-0b38-48b9-9a36-fb9a043eef1c"
      ]
    },
    {
      "cluster_id": "e416c5ec-262b-4531-adef-7197fba310f0",
      "members": [
        "4c018036-8386-42a1-8fa4-de8efde36646"
      ]
    },
    {
      "cluster_id": "f9f12741-3c28-4281-83bb-68cf30392853",
      "members": [
        "c49b54a1-a379-46b6-b5fa-385217856dd5"
      ]
    },
    {
      "cluster_id": "f6541b8c-4e86-4aff-8593-e4f14f2ecc27",
      "members": [
        "5293996f-523f-4c90-94a4-6b297adb7e7e"
      ]
    },
    {
      "cluster_id": "a999634d-6816-4a9d-9bf2-efbbb6f6917e",
      "members": [
        "73839936-e78d-4d7f-9f8c-b9590b821dab"
      ]
    },
    {
      "cluster_id": "1e227a80-8d1d-4484-9608-82719d3b526e",
      "members": [
        "baeda9b3-f4c9-4ccb-8521-0505f25cbbb2"
      ]
    },
    {
      "cluster_id": "ee1d7c5b-4d98-426c-bf43-b5350f89e9dc",
      "members": [
        "2ec69792-8fba-405a-9a8f-c01c2aac78fd"
      ]
    },
    {
      "cluster_id": "a3272ef4-947f-46a0-b484-adddd74b2e08",
      "members": [
        "1553fd7f-8aaa-419f-9fa1-7c73e091b80a"
      ]
    },
    {
      "cluster_id": "07fa2c87-6f80-4d1c-a60a-bb0d6e0e303a",
      "members": [
        "b0524685-9242-4e30-a89f-72ec2d79f6ea"
      ]
    },
    {
      "cluster_id": "aeb0341a-ad2c-4ec1-b689-ecd5b9a2b868",
      "members": [
        "c34066bf-2577-4750-aee7-181b5235cb4f"
      ]
    },
    {
      "cluster_id": "c0707d1f-d796-4de7-994b-fd76b5d9d3dd",
      "members": [
        "1670e29b-19bd-4c53-a61a-438c242ee96a"
      ]
    },
    {
      "cluster_id": "d9f5972a-ff26-4242-938a-7c9615591c15",
      "members": [
        "e88bbca7-cf56-4326-9c99-dc1647945e93"
      ]
    },
    {
      "cluster_id": "e9dd9d87-b75e-47a9-883f-9edb14ac1be2",
      "members": [
        "a88ec512-6b19-40e8-9245-9b1926568095"
      ]
    },
    {
      "cluster_id": "97037755-caf6-49ed-8d7a-bb7c0d42bf8c",
      "members": [
        "f578eb5f-3c4e-4ed6-86ac-07c7f1346e70"
      ]
    },
    {
      "cluster_id": "3b1a4f1c-eb8e-4934-89a0-1d405c7425e6",
      "members": [
        "b60b2fd7-3a6c-4b1a-8bef-470c8fe13273",
        "a9b84cf4-c9fc-42b0-b615-322ed7497c2f"
      ]
    },
    {
      "cluster_id": "53da7ed0-9d8e-436f-b097-49ff62b95459",
      "members": [
        "d541576e-5c2c-4375-9f5a-a1cbb11155f2"
      ]
    },
    {
      "cluster_id": "b6ac4f42-6e4c-4395-a71a-c8beca5b5336",
      "members": [
        "c2055234-7d19-4f2f-8f93-5a3d0367ee7e"
      ]
    },
    {
      "cluster_id": "f0190a02-daf5-48b7-8174-720b52c75550",
      "members": [
        "903e1681-1758-4c3a-9728-9fa8fd825a8b"
      ]
    },
    {
      "cluster_id": "b6fc681b-92ac-49a5-8881-3c1a5122bc59",
      "members": [
        "8170569f-1511-43b2-bdea-43d9e3bb8330"
      ]
    },
    {
      "cluster_id": "60bb3151-34af-4d7b-9c68-da27390075bc",
      "members": [
        "660e4a47-1d5a-494e-8c42-4a00f7ce4a2d"
      ]
    },
    {
      "cluster_id": "db7cc474-d6ec-47a2-b50b-7ed4c500c50a",
      "members": [
        "69c57963-6437-4eae-aabd-8176cc30e300"
      ]
    },
    {
      "cluster_id": "4d988f33-ad00-4f89-acf1-b7ec63af7351",
      "members": [
        "04b07b43-91de-492d-b415-f6ff34cb0803"
      ]
    },
    {
      "cluster_id": "657ed7b6-8b7c-41a6-8900-c8d11bb6982a",
      "members": [
        "5d2831f7-834e-409c-8e9d-48f747d564ea"
      ]
    },
    {
      "cluster_id": "7511bd1f-13b7-402b-887d-d4fe077fcba7",
      "members": [
        "cf81ea82-4981-46af-b78d-7d932f523a9a"
      ]
    },
    {
      "cluster_id": "c8d061af-6686-4c3f-a2d9-0d23ccbd3f19",
      "members": [
        "da359d6c-2a80-4518-96d9-6bbaad187c00"
      ]
    },
    {
      "cluster_id": "73a6792a-38f3-4e05-a1bc-e5dc764c0b4d",
      "members": [
        "a9ee6543-ba8e-418a-a114-c3ac7cc71a12",
        "2be5b181-7cfe-4239-a89f-a8d44870295b"
      ]
    },
    {
      "cluster_id": "bcfd3520-6b2d-41d7-83ee-cfbd1d569332",
      "members": [
        "cf566c83-3925-4984-884d-925ab1e46541"
      ]
    },
    {
      "cluster_id": "2cf125de-8cd0-4d04-8bbd-f0bf7f8ae187",
      "members": [
        "0b3c6f5e-1e59-433f-90ac-0ec8710352ac"
      ]
    },
    {
      "cluster_id": "1c24fe42-ed01-4d5e-85a3-6011ab09ff6f",
      "members": [
        "051a8eae-085f-42a9-9e38-77d1995dd83a"
      ]
    },
    {
      "cluster_id": "fdb63c1f-d931-4ed0-b2b4-c60113cb73c4",
      "members": [
        "b38be4e2-e4d7-4855-be09-04a41de1d4a4"
      ]
    },
    {
      "cluster_id": "57cf4546-a43b-4620-acde-18ad68b95dcc",
      "members": [
        "0fd4b274-a470-4ec8-941b-630f63142a34"
      ]
    },
    {
      "cluster_id": "5f5fe60b-6bf8-4f80-be3b-0dcf885c1171",
      "members": [
        "a70e8b59-7cfd-4220-bbf1-2c239ec82ce5"
      ]
    },
    {
      "cluster_id": "9ade6dc5-62e9-44b7-84fc-ef5e0c8fe1bd",
      "members": [
        "3d0c993b-38f6-4d18-976d-7c47411b31c3"
      ]
    },
    {
      "cluster_id": "b65c1ae7-fe21-4ae4-9c7e-84c247b4a89b",
      "members": [
        "70200cb1-3041-48a7-9e28-2cae2ee138c8"
      ]
    },
    {
      "cluster_id": "83412f4d-d0e2-456a-853f-c0ab5d6c2ff1",
      "members": [
        "da329360-2d3e-4b50-b7b3-6cce8f1aa433"
      ]
    },
    {
      "cluster_id": "b524cac0-fbe6-4818-abc9-cf0d17bfecf0",
      "members": [
        "ac802fe2-63ab-4c69-9886-f5a4d7657337"
      ]
    },
    {
      "cluster_id": "3e19b24f-ae64-464a-8536-97bf58aecdc0",
      "members": [
        "0b25b952-b8db-416d-8697-ee70e792870c"
      ]
    },
    {
      "cluster_id": "842a47a3-77bb-4a2a-909b-98bce731301b",
      "members": [
        "af1aad82-b277-4834-9f9c-1ab8d24f2d7e"
      ]
    },
    {
      "cluster_id": "07f06451-8b9c-4bc8-9f61-1661511a83c3",
      "members": [
        "1ba8d895-5f78-4f0b-bd05-4d1641e4ce5d"
      ]
    },
    {
      "cluster_id": "b08cba5b-cde3-4318-9ea2-b4cf4efed9c3",
      "members": [
        "d1ba53b6-47f9-4280-9fc0-fd09d18c4fc2"
      ]
    },
    {
      "cluster_id": "00386fb1-3dcc-4b4e-b74b-bc14dbc4e260",
      "members": [
        "36097c8c-85b0-431e-bd33-a9103b04ef79"
      ]
    },
    {
      "cluster_id": "267d2942-984a-4564-b33c-69e9db79a066",
      "members": [
        "72127d66-fd32-491d-87df-078b95146b02"
      ]
    },
    {
      "cluster_id": "03915ee1-228c-408f-b93a-594ce2e45136",
      "members": [
        "35864078-cc2c-41ff-88aa-8e1e32ed9739"
      ]
    },
    {
      "cluster_id": "b213b3ba-db75-4c42-89bd-97de55c18b3e",
      "members": [
        "483f9100-c4ca-4586-ba84-682f095310ad"
      ]
    },
    {
      "cluster_id": "db0a8d4e-9354-4c38-bb13-56ae176ed70b",
      "members": [
        "ece9466a-65bf-4d30-926e-70674b63d79c"
      ]
    },
    {
      "cluster_id": "654ddafb-5d45-4313-9cd4-f144aab1e464",
      "members": [
        "73181885-0295-4b62-8463-85f7ebaa38d5"
      ]
    },
    {
      "cluster_id": "8f381ec8-c658-466c-973c-6cace2609d01",
      "members": [
        "fc3e0635-9b91-40ff-87d2-363a6d9ac2f0"
      ]
    },
    {
      "cluster_id": "40c73517-1c90-43a5-bf9c-4b7cd5dc13c4",
      "members": [
        "6212f3e0-6ac0-4064-9593-a4457754360f"
      ]
    },
    {
      "cluster_id": "b4de3a2a-395f-4d49-9f4e-abbd190c57b5",
      "members": [
        "029d7549-48b7-4bf3-a6fb-f63d4e907818"
      ]
    },
    {
      "cluster_id": "4dbd9499-a86a-4c48-b218-1b0a93aa0331",
      "members": [
        "4be3f643-2aa0-4579-98ca-14d97784ea1a"
      ]
    },
    {
      "cluster_id": "96a4146b-b919-413a-b5a7-7801adae1906",
      "members": [
        "ffea4765-c803-4d76-adcb-556ad0a86333"
      ]
    },
    {
      "cluster_id": "db07f4e5-716a-41e4-989c-98ced62f8fd5",
      "members": [
        "9134b5dd-9cec-45cb-a37a-823fcc4afdca"
      ]
    },
    {
      "cluster_id": "185ce1be-2776-4956-849c-f83438c57def",
      "members": [
        "c4c0a228-b520-4446-9ced-f9600e63b724"
      ]
    },
    {
      "cluster_id": "f61b95fd-4ab1-43f9-b2f8-53b5afb90d43",
      "members": [
        "52270120-a27d-4e6b-8201-b95d76e61a23"
      ]
    },
    {
      "cluster_id": "2790abdc-e882-4d8a-90ac-fbfc5b896052",
      "members": [
        "b8b249d9-68ba-4bc6-8783-fc55db74b4c2"
      ]
    },
    {
      "cluster_id": "843bcba9-c863-41a3-a76f-01fd61d56529",
      "members": [
        "2e35d598-1ead-4cc9-b263-0f8e9b46350c"
      ]
    },
    {
      "cluster_id": "c267714a-b024-42fa-a678-5343e8a65754",
      "members": [
        "c85c2b54-faa7-4ad6-a66a-50cb0e2adde2"
      ]
    },
    {
      "cluster_id": "68152d77-1b3b-45af-8c06-88cf78f6a175",
      "members": [
        "1dad3c34-9c46-4fae-b996-8d36deac0c7d"
      ]
    },
    {
      "cluster_id": "55bc595b-aea0-4d83-938e-9ae3ab116813",
      "members": [
        "ed43efaa-4059-4449-a36f-e665653f8a9a"
      ]
    },
    {
      "cluster_id": "25cbeeac-8021-4680-b7db-f334ae985da7",
      "members": [
        "2d283ea9-3c37-44f9-a526-ca0bf56a29a2"
      ]
    },
    {
      "cluster_id": "53a5cd16-ea33-4c3e-8f8f-0d495c63c479",
      "members": [
        "6bcefa92-a75c-4f2c-b084-e57272699893"
      ]
    },
    {
      "cluster_id": "b3dddca5-c2cb-4bb6-a964-c4a7328e5b0d",
      "members": [
        "7034a168-c32c-46c5-97d5-7011a7e583e4"
      ]
    },
    {
      "cluster_id": "2e74796b-6aa0-4e1f-8a55-22887fa2ebdf",
      "members": [
        "e95e4e59-1c46-4d1d-a26e-f51adfada1dc"
      ]
    },
    {
      "cluster_id": "00e6b319-ea09-4ee6-8be1-7f243156f545",
      "members": [
        "1bd00c6c-59cd-4387-a54b-b32f98e0f725"
      ]
    },
    {
      "cluster_id": "4f4a8dcc-ad59-4dfb-b222-e025fb0c418e",
      "members": [
        "147d519f-3a24-41c8-93ae-b6104a3af9aa"
      ]
    },
    {
      "cluster_id": "51ff5b38-5ae5-4505-adc2-291731599e68",
      "members": [
        "6cb08a1b-cb67-4b66-9997-d0d027691a7d",
        "0b8030df-1877-44d1-bbaf-c0428144a920"
      ]
    },
    {
      "cluster_id": "1ef5190b-3eed-45b4-b04e-14655cb38618",
      "members": [
        "d0c64c05-1611-406c-997b-2bcaddb144c5"
      ]
    },
    {
      "cluster_id": "ef13681f-975e-44f8-8e95-a6963670af11",
      "members": [
        "d325b518-52fc-414b-a998-6a1c6cee814c"
      ]
    },
    {
      "cluster_id": "f387c566-78b4-4549-b5d3-12ab9f1a83af",
      "members": [
        "61cdd9bb-d06d-4548-bf22-2ac0469d141d"
      ]
    },
    {
      "cluster_id": "a90d4523-8e1f-4287-ae0c-72459f7c14c3",
      "members": [
        "2d0a4efb-49ce-4c42-9c72-09386900102c"
      ]
    },
    {
      "cluster_id": "5bc0db5b-3192-42d4-a343-00cfcacc4499",
      "members": [
        "81ded9b1-7e19-4e85-a496-51915d145a74"
      ]
    },
    {
      "cluster_id": "731ff8b9-92a5-4277-aa76-33602d261e5e",
      "members": [
        "cf74c828-a854-4b1d-b0ff-41334ff95896"
      ]
    },
    {
      "cluster_id": "eee91c5f-8ac6-4779-af53-8a01aa4eaa03",
      "members": [
        "9a821e6d-27d9-4ef5-8b63-5522dba4f695"
      ]
    },
    {
      "cluster_id": "25d9faf4-4231-47e1-9e78-17114da0186c",
      "members": [
        "0c1583a0-e152-4d85-a208-4c1a7350543c",
        "02822320-cd99-4d29-9bf9-f058f84e00bd"
      ]
    },
    {
      "cluster_id": "493568a9-0e32-4b19-a041-15396f7c15b4",
      "members": [
        "ffe40741-bfba-408b-80dc-6d4c93a3476b"
      ]
    },
    {
      "cluster_id": "5e43acaf-f806-47d1-be89-f2ab3ad82bd7",
      "members": [
        "a2a1873a-cb7f-4eea-b881-7962bae1b5e2"
      ]
    },
    {
      "cluster_id": "7742ec5a-27ab-42d2-9779-df7d73a0cec4",
      "members": [
        "c04ab974-f5a6-4674-9617-93b3a84224ad"
      ]
    },
    {
      "cluster_id": "04e64305-3df2-47b4-83e6-266ff2241406",
      "members": [
        "7ca392ad-9d19-4328-ac1c-38ebd5d5ff79"
      ]
    },
    {
      "cluster_id": "f679dcc1-fbec-4813-8cbd-bf97a313606d",
      "members": [
        "fa69523a-2b83-4e43-8a72-b11ce2258253",
        "9de16975-a6f2-492e-886a-e269c2d474dc"
      ]
    },
    {
      "cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
      "members": [
        "b41a3136-a2a6-4ce4-aadb-8c179bf11bf1",
        "3065442a-14b1-4449-b727-0b1cd300dd7c"
      ]
    },
    {
      "cluster_id": "662000fc-1ecb-4634-b4e8-efc53b2b3287",
      "members": [
        "95a7d096-c622-46dd-9590-b080e9861d12"
      ]
    },
    {
      "cluster_id": "e59930cd-f28a-4a44-8feb-24e860e36480",
      "members": [
        "b5b85d0e-e9b3-4a75-9ffb-e456c3336ec0"
      ]
    },
    {
      "cluster_id": "057bcb05-f915-40a6-9a44-d57aa6602574",
      "members": [
        "619baab4-41a4-48c7-b3f9-7fdbfc3cd7a0"
      ]
    },
    {
      "cluster_id": "369b1cc5-aae5-4361-aabf-b1ef5c5350f8",
      "members": [
        "521328fb-fec8-45c2-8804-3961edd8a930"
      ]
    },
    {
      "cluster_id": "deb1b19f-f313-46a8-8e93-d75203af3775",
      "members": [
        "487d5ad2-aa34-46dc-91dd-b7dac83edd06"
      ]
    },
    {
      "cluster_id": "48f8d3d4-cbd2-44f5-81bc-3adadbe6b6e7",
      "members": [
        "bb40c0b2-397b-4ba4-a644-11c4285e3229"
      ]
    },
    {
      "cluster_id": "b54e5664-a40b-4682-b959-bcfb59ddd4b0",
      "members": [
        "feb9f397-7bc5-44bd-aa8f-04394b7447f4"
      ]
    },
    {
      "cluster_id": "5881fb7d-2030-4406-a7ba-0a95befea17e",
      "members": [
        "fe5053f4-21b7-492d-9e91-012a110d99b6"
      ]
    },
    {
      "cluster_id": "73c5657f-c795-4df0-b889-73c2f356f79a",
      "members": [
        "ab7fc75d-0dd5-476c-baac-dbac6bb06edb"
      ]
    },
    {
      "cluster_id": "5dde6d54-8ecf-4f66-96dd-406048082082",
      "members": [
        "12228c9e-42ba-4dc3-86c1-e440002f2e43"
      ]
    },
    {
      "cluster_id": "934665b5-3969-4817-9dd5-47b732fdd380",
      "members": [
        "f5dd556e-d81a-422c-a1df-38d595b542fa"
      ]
    },
    {
      "cluster_id": "acca2114-d8e0-468a-8116-8a8e6ac23e1b",
      "members": [
        "a69c3605-cb8c-4cc4-af1a-49a5fd1ec2e3"
      ]
    },
    {
      "cluster_id": "8ac7a573-0e67-4913-bd5a-4320d5df2ecd",
      "members": [
        "1860282a-df94-40d6-aefa-d33a780e797e"
      ]
    },
    {
      "cluster_id": "5b6da2ab-36ee-4cfe-968a-ce42565405bc",
      "members": [
        "7200c0eb-fa7a-4eec-b545-f33baa33b876"
      ]
    },
    {
      "cluster_id": "64a10d09-a49c-4bf3-80db-a2cb3188afbc",
      "members": [
        "8f562a60-4720-4b12-bf8e-97447354a6b4"
      ]
    },
    {
      "cluster_id": "b9ef5935-c3ff-439a-95ae-5e53367b92ef",
      "members": [
        "9d71426d-92dc-4461-8d66-7cb7700cf2cf"
      ]
    },
    {
      "cluster_id": "803c450b-2260-49a5-af48-6296f17fca97",
      "members": [
        "e79b7f1e-c540-48f9-99a0-eb9f272ff2a7"
      ]
    },
    {
      "cluster_id": "e30f1c65-b396-4183-98d3-9deb2bc6322a",
      "members": [
        "08570a75-8b33-4e1e-90f0-ccc77c0eedee"
      ]
    },
    {
      "cluster_id": "46e0dd28-4bd8-4986-88e7-a2e53ab8f4b8",
      "members": [
        "99c2d825-ffe1-40dc-9c1e-e1013924648c"
      ]
    },
    {
      "cluster_id": "5edd935c-f1a4-4a6b-86a0-37894c0716f8",
      "members": [
        "4dd9f52f-d8e8-4544-9e2c-b1bb11889b2a"
      ]
    },
    {
      "cluster_id": "5b52495b-d578-4d45-975c-d2e0417f4501",
      "members": [
        "f027e67c-47bf-4105-881f-4d217b3544c9"
      ]
    },
    {
      "cluster_id": "49b52e42-84db-4d97-b9a4-ffd3211b536e",
      "members": [
        "629f13af-3980-4d8c-bddd-b43cd3168dd4"
      ]
    },
    {
      "cluster_id": "8bbb9fde-a60f-4687-9398-276e5d036952",
      "members": [
        "9f9e5b15-68b3-4929-ae84-37177d1d515b"
      ]
    },
    {
      "cluster_id": "1c5a60ba-15c1-4cc2-b60f-b6a9d3303da1",
      "members": [
        "d1bc893f-3614-4a43-a75d-205bd1a7adcc"
      ]
    },
    {
      "cluster_id": "23af5a3d-cb29-4974-bd99-35e9d9b06fde",
      "members": [
        "4d412db5-fc61-4fa9-81b0-e9bc9d2d50b1"
      ]
    },
    {
      "cluster_id": "53ddceb6-33d2-42fd-849a-253f21907d2a",
      "members": [
        "fd30fa9d-5404-4600-a306-94fa14b3f60f"
      ]
    },
    {
      "cluster_id": "b2ec8ccd-aef2-476a-b259-768aae14f39e",
      "members": [
        "a4b251cd-8f24-4aab-8d8e-a919692a5b87"
      ]
    },
    {
      "cluster_id": "b60b834e-1991-44ea-a53f-68d101a440a4",
      "members": [
        "c980a339-5089-4aea-b722-8818f6df5b36"
      ]
    },
    {
      "cluster_id": "791c0550-4877-4364-97d4-01b5b8435b0f",
      "members": [
        "8bb31240-1aee-45d9-9cbe-f51c9c7aaeae"
      ]
    },
    {
      "cluster_id": "860407b5-0931-4ba2-9dbd-a0078e94e9c6",
      "members": [
        "1a4fd326-341e-417a-b590-42a241e07a85"
      ]
    },
    {
      "cluster_id": "6d2143f7-a494-4413-af4e-40c695a4a5e3",
      "members": [
        "ba5e3a7c-42f8-4a47-9032-4c310b28c369"
      ]
    },
    {
      "cluster_id": "2669ad24-9832-49ab-a24d-8ef6f0986ed6",
      "members": [
        "eeced08d-688c-409e-a85d-20f0a611f2bc"
      ]
    },
    {
      "cluster_id": "e61d6703-69dd-4dea-8318-f7e671e98045",
      "members": [
        "b3724cba-b469-4f18-9cbe-c5a8feb6e61b"
      ]
    },
    {
      "cluster_id": "3f043499-266e-455f-a558-699fac541c36",
      "members": [
        "432b9133-94d2-41a0-bb39-3fb754586948"
      ]
    },
    {
      "cluster_id": "363f13f4-3f3c-4a28-a39a-e89279a7c9ad",
      "members": [
        "3bc8538e-2a63-4a8e-b482-f2312ef30972"
      ]
    },
    {
      "cluster_id": "d8f02a31-c29f-429d-b5f0-720768af0f52",
      "members": [
        "db74244d-4130-44b3-a3be-416717218122"
      ]
    },
    {
      "cluster_id": "0a173478-bf00-4e1f-be9a-c8305b945d9d",
      "members": [
        "eba77011-2a84-495d-a255-b0a33266a65b"
      ]
    },
    {
      "cluster_id": "a288cd72-4282-4ba7-b449-a353419578cd",
      "members": [
        "e4a1ef12-8a66-4e6b-972b-df2ae81e6f7d"
      ]
    },
    {
      "cluster_id": "6436c54d-cea9-4b06-8f6e-d82ef558f6c5",
      "members": [
        "18fafe7f-080f-4e66-9efb-f04c0f9fcb2e",
        "af38f83b-dbcf-450a-b045-facb4eb4a1e6"
      ]
    },
    {
      "cluster_id": "f10a7215-4011-4959-9b86-e9f3848b78fb",
      "members": [
        "885f411a-bf81-49ec-b44c-6940e82f3240"
      ]
    },
    {
      "cluster_id": "1a247a51-e7fa-46f4-b0b3-659a03d784c6",
      "members": [
        "9743b311-cafb-4cfd-8609-7c80f2ff9d89"
      ]
    },
    {
      "cluster_id": "bd50210c-37cf-46e2-9d31-0c6a6dd06e70",
      "members": [
        "cd1059a4-0e64-48b1-8826-fcf1496bab8a"
      ]
    },
    {
      "cluster_id": "9ba84133-d9e2-4da7-8e9b-aeda3ebd4295",
      "members": [
        "20d51616-8577-4377-ac82-80c75ed27783"
      ]
    },
    {
      "cluster_id": "58c4dc89-fa0e-45c9-8892-01fb55da5607",
      "members": [
        "e5f5da0c-a863-47e1-a6d1-56961623cf7b"
      ]
    },
    {
      "cluster_id": "2bb3dd08-3d90-4e2f-a0e2-ecef371c599f",
      "members": [
        "dde2b01d-d592-470e-bbc4-b54f19560170"
      ]
    },
    {
      "cluster_id": "5b2c4526-459d-4b6f-8f31-bd40fccf12ff",
      "members": [
        "a1defc99-37ef-4f95-b417-6ff608a4c6e3"
      ]
    },
    {
      "cluster_id": "df895ffb-5333-4b2a-9ce5-f1108a894c34",
      "members": [
        "308308e1-766a-4770-bf8b-7e2599a012d9",
        "3b3f6b3c-9e02-41b0-8583-5212dd3b4f6f"
      ]
    },
    {
      "cluster_id": "a023722f-ed95-4d7c-9c3d-0d405ad7a2c4",
      "members": [
        "ab930dd7-1c58-49f1-888a-3ccb43f3e76f"
      ]
    },
    {
      "cluster_id": "95b428d7-1d28-45e2-a9a0-dd59bb6a0176",
      "members": [
        "8344aced-aaf9-4585-8b7a-4ef53a11ef4b"
      ]
    },
    {
      "cluster_id": "342cdbac-7da2-46b3-80b3-a9b75e8fee10",
      "members": [
        "6196be98-1cd7-4397-8565-f5ba5461fded"
      ]
    },
    {
      "cluster_id": "881a8788-562f-4bf2-a8b1-590419007a87",
      "members": [
        "39744d7d-3fbf-4158-9ebf-d7a34bd509b3"
      ]
    },
    {
      "cluster_id": "7b08a98a-0129-4cec-b114-1fff26d56746",
      "members": [
        "d2746d11-47fa-4951-baac-d714323e7a24"
      ]
    },
    {
      "cluster_id": "4958a7ec-0cd2-487f-a59b-9bc34843a2b7",
      "members": [
        "8f21e90b-1a0f-4031-bfce-d0e4f75835aa"
      ]
    },
    {
      "cluster_id": "f21a34f1-8f4b-45c1-80d1-4a2fc8e55091",
      "members": [
        "01508c85-b479-4298-b689-24d128545f43"
      ]
    },
    {
      "cluster_id": "3e30f911-bb0c-48a0-8ffb-4be6bf3fe64d",
      "members": [
        "0f5cc466-f266-46f0-bb36-c4c140c7386e"
      ]
    },
    {
      "cluster_id": "a92df9a8-beac-475c-a620-574a5351def4",
      "members": [
        "b25d83b5-974d-4e6b-9335-6426f9c6b6bc"
      ]
    },
    {
      "cluster_id": "a03aac32-b760-4f2a-8ae0-1194424402ab",
      "members": [
        "ff96108d-4f5c-4d0d-beef-451db8a86aa7"
      ]
    },
    {
      "cluster_id": "b9a17741-2ab3-4713-9777-efc674860d38",
      "members": [
        "28b2429a-0096-4d7a-948d-059fa77fc5c9"
      ]
    },
    {
      "cluster_id": "d8eb9cee-8720-428c-a044-b6a3e22a6bb8",
      "members": [
        "56f90ee6-1209-4b41-abc3-e377d4df66b2"
      ]
    },
    {
      "cluster_id": "19ec7067-1e85-4e98-adf9-a107366a808b",
      "members": [
        "21b59191-bead-4584-9277-0995dc1dd492"
      ]
    },
    {
      "cluster_id": "c81b3fac-f8f7-4824-a157-6d31dd48689f",
      "members": [
        "d94c0bdd-38a8-4849-8dda-6b5e0a842602"
      ]
    },
    {
      "cluster_id": "56e6ff33-547f-4d6b-a7a7-e1266368fdd7",
      "members": [
        "8bacacff-aa61-4eac-b5ae-410a1358b09f"
      ]
    },
    {
      "cluster_id": "30fdf9bb-e9b5-47e5-a899-e176ffa77eac",
      "members": [
        "2fd3b2a3-f58c-4367-bcd2-a0ab907918e8"
      ]
    },
    {
      "cluster_id": "81174c72-fc84-4203-8dcb-b1068c7bd254",
      "members": [
        "b8d41819-464f-472d-85d4-4d8825b72dc8"
      ]
    },
    {
      "cluster_id": "7440fefd-f7fe-4402-9218-79fa9f53df91",
      "members": [
        "28a9e1c3-f6b7-4263-a28e-da682072bcbf"
      ]
    },
    {
      "cluster_id": "dfea6d47-10c8-4540-8a78-5667ac532c10",
      "members": [
        "561143dc-b82e-4c1b-972e-0d27441965bd"
      ]
    },
    {
      "cluster_id": "27097c65-59e7-4824-9bbb-c0736b2c9f70",
      "members": [
        "82edf1b2-9625-43b0-b7fc-50b60fd2bbef"
      ]
    },
    {
      "cluster_id": "c6f7c193-f407-447c-a10f-3ea5292ea3e8",
      "members": [
        "ded4eeef-c183-4ccc-8be3-7998293de30b"
      ]
    },
    {
      "cluster_id": "e71ece34-2a4e-4762-87c7-693bfadf879f",
      "members": [
        "bbcd424c-29ad-4d41-adb4-c97781a4b967"
      ]
    },
    {
      "cluster_id": "ce07721b-5347-4d52-81aa-7a7c68338485",
      "members": [
        "2581b35a-6fe9-496f-8afb-21345fa2a8dd"
      ]
    },
    {
      "cluster_id": "dc8d69ed-9d9d-4c04-a104-2c89e796edf3",
      "members": [
        "52519e4a-6c58-4d1b-89f7-04d1a7410ce5"
      ]
    },
    {
      "cluster_id": "c6d29068-aaee-4cd5-94e1-e4e031d50401",
      "members": [
        "54fa8502-66e3-4d23-bee4-4544f015286d"
      ]
    },
    {
      "cluster_id": "63bcdf8d-5d7d-43eb-b5b5-735ed74b200a",
      "members": [
        "0382d146-798c-4e98-bf90-fba4cf45a308"
      ]
    },
    {
      "cluster_id": "553489d8-ac8a-4e20-ab65-673fb4e17c1e",
      "members": [
        "b4a3e4f3-ace9-4d63-95ba-a78ebe688191"
      ]
    },
    {
      "cluster_id": "60a1acab-79cf-438f-96de-dbff294bd2e7",
      "members": [
        "2248e2d6-276e-470a-8a5b-f73747019001"
      ]
    },
    {
      "cluster_id": "f8e7dcff-d078-4ce8-9ad3-495ed7c19774",
      "members": [
        "6fa5ba65-1b87-4285-a9a5-3a94554c67ad"
      ]
    },
    {
      "cluster_id": "b3d00803-b5be-4264-bbda-b09db5ed3a9b",
      "members": [
        "64ffb265-5a1a-495e-aa14-80d2aa155824"
      ]
    },
    {
      "cluster_id": "fe10e346-5245-4859-9317-c6ffae804527",
      "members": [
        "861580e2-8611-46a7-b914-edb294d8b916"
      ]
    },
    {
      "cluster_id": "428d818b-c2cf-41c7-bcd8-3f5cb0b144ef",
      "members": [
        "2beb2d9c-db42-4203-90eb-078a562de80f"
      ]
    },
    {
      "cluster_id": "3b17ca99-a0cf-4b4c-a71f-c0181125d3ce",
      "members": [
        "f32ed7eb-c541-4c90-afa3-c2403a0cd3b2"
      ]
    },
    {
      "cluster_id": "5240d9cd-db46-4ffc-ae97-0e3a2b73b3fe",
      "members": [
        "114a2918-55aa-4649-81ee-2d5875a81cc9"
      ]
    },
    {
      "cluster_id": "a1ac0514-0dd2-43ae-9f2d-5939e791e058",
      "members": [
        "3b5afae5-ebac-4413-bff8-cc414ef551ef"
      ]
    },
    {
      "cluster_id": "be4a2385-74e7-4ed5-8c71-c890af870db7",
      "members": [
        "d5b22620-2260-4e65-a424-eaf06965e7e9"
      ]
    },
    {
      "cluster_id": "78cbe3d8-37f7-4a89-956e-f6dab20ad8d1",
      "members": [
        "dded93d6-13c8-4f81-977e-0779477b6de6"
      ]
    },
    {
      "cluster_id": "f83c19b1-e59e-4712-8a86-4c8c86ee0e2b",
      "members": [
        "1d59567a-e2a4-47f5-aec4-3e370cc9791e"
      ]
    },
    {
      "cluster_id": "ef74ac2b-9f0b-4cf7-9e95-c36f4d327f7c",
      "members": [
        "d70bcda9-c233-4308-b6e9-0719754845a9"
      ]
    },
    {
      "cluster_id": "2846d44d-8ccd-40e0-8486-7b360ffa4608",
      "members": [
        "3cf506c1-c396-4fbf-877c-ec2c229ed925"
      ]
    },
    {
      "cluster_id": "41a55c60-75f3-48f5-817e-bc3dd4fc026d",
      "members": [
        "cd217be3-7c36-4052-868a-0f2a3b5364a3"
      ]
    },
    {
      "cluster_id": "6a708ce1-1b6e-4cbf-86c2-55ba9712b9d3",
      "members": [
        "a2ba01ad-c784-4902-81bb-447fade61de0"
      ]
    },
    {
      "cluster_id": "b44cd59b-4971-4182-8766-9ffcf4ae83ce",
      "members": [
        "3dbae1d6-6af2-4492-ae17-f58230ea2ffa"
      ]
    },
    {
      "cluster_id": "6a8ee3bf-31a7-42b7-b481-4b21e09f4484",
      "members": [
        "b3bc6c3c-8641-453e-a50d-dab1814cbc39"
      ]
    },
    {
      "cluster_id": "5b28f56e-4dc0-41d8-b963-a4fc04cbaf08",
      "members": [
        "d8113053-efb3-41bd-b540-2e0ae0f26367"
      ]
    },
    {
      "cluster_id": "46f91c43-019b-4419-b509-a0a1e806ff37",
      "members": [
        "0d5871ed-f21e-491e-b9fc-e8a4f2b3d8c5"
      ]
    },
    {
      "cluster_id": "02c9b472-905f-4c41-8570-811b8d821196",
      "members": [
        "3b8b4ee9-f72f-4a96-93e5-cb907013d7db"
      ]
    },
    {
      "cluster_id": "c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e",
      "members": [
        "dc8d8b18-4675-4d5e-907f-b718920445a9"
      ]
    },
    {
      "cluster_id": "125b87a9-62f3-402f-a1ad-6a9130845e80",
      "members": [
        "a40df7e2-c699-4e3b-b6df-5ac58bd94ea2"
      ]
    },
    {
      "cluster_id": "9f76cab0-c9b8-4e12-bd91-cd1c5474c649",
      "members": [
        "d3846972-39e3-4228-82e3-9e77c1f80743"
      ]
    },
    {
      "cluster_id": "1993c1c6-e677-4697-9e0d-f4c2332e53fe",
      "members": [
        "72583dd3-23b1-46be-b38c-c5b9919c8154"
      ]
    },
    {
      "cluster_id": "496ba3da-7431-46d2-8b63-afbe79f86c65",
      "members": [
        "be4ad66e-73c6-44a3-a8dc-610d40c2bf91"
      ]
    },
    {
      "cluster_id": "3543d3e3-081b-448e-9ec9-915bf37d6255",
      "members": [
        "3e98e034-093e-4a49-863b-54bb8f347b6e"
      ]
    },
    {
      "cluster_id": "68357dc5-3396-4365-90bb-f3b36dcbd7e4",
      "members": [
        "267d7407-8aec-414f-8ec6-99f325f4f78c",
        "b9304938-a12f-4080-b0f9-37024e495985"
      ]
    },
    {
      "cluster_id": "8b198c30-0c8c-4abd-b13a-0e55963e8bb8",
      "members": [
        "72d30220-98d5-4c06-b8e6-7eca12186b6e"
      ]
    },
    {
      "cluster_id": "29f9cc11-a80b-4066-9284-acd0b0746933",
      "members": [
        "cb32487d-caf2-4e49-bdf0-5d334e61b2a0"
      ]
    },
    {
      "cluster_id": "19dc451c-d076-4677-8e6a-44a760f27332",
      "members": [
        "622cd7c4-8d47-40c5-90fc-180cf3666da4"
      ]
    },
    {
      "cluster_id": "f9c87407-e574-417b-a567-8221daa6ee9c",
      "members": [
        "35a0fed2-5de2-409c-bb51-5a52d2d37080"
      ]
    },
    {
      "cluster_id": "72cf96af-c05b-405d-a5e3-785cb1c6c70e",
      "members": [
        "01474331-54c3-4a9d-883f-8cb0e4eaa86c"
      ]
    },
    {
      "cluster_id": "666873ec-e76e-4f8a-8d96-7a31c5084ac4",
      "members": [
        "4ed9be65-3feb-4114-82c4-43f3f933184d"
      ]
    },
    {
      "cluster_id": "afebac7c-8f71-44cd-beec-d242a1b97e86",
      "members": [
        "7b422af4-47b8-4029-b7a7-1c1ecae49496"
      ]
    },
    {
      "cluster_id": "947b44c6-b504-4d59-ad29-0dd1f0776154",
      "members": [
        "f84d25e9-527c-422a-9cb1-9341de6a5cb0"
      ]
    },
    {
      "cluster_id": "6e7164cb-9f1b-4f72-aef4-13243fbf321c",
      "members": [
        "3a70e7d2-ab8e-44f3-86b1-b2506b82321b"
      ]
    },
    {
      "cluster_id": "3239dc2e-a961-4aab-990b-768c092064f8",
      "members": [
        "72019106-200a-441d-9dd4-5fa1efbe3efd"
      ]
    },
    {
      "cluster_id": "13fc2321-1fdf-40d3-8576-3d7e5eb9e53d",
      "members": [
        "cc2f9126-be5f-4455-8daf-dde1a7c7dc68"
      ]
    },
    {
      "cluster_id": "5272bbda-d47a-4619-a956-853dc9c29d18",
      "members": [
        "87d0c57c-b815-49a8-a97b-e6157315d1b6"
      ]
    },
    {
      "cluster_id": "6c511b67-edc9-413f-96b2-94d272eb11e9",
      "members": [
        "2f5160f3-6a08-4202-9c85-ae24f8ffdd10"
      ]
    },
    {
      "cluster_id": "9352b2a0-83e7-4ffa-ae39-61c24aa700b8",
      "members": [
        "94a20783-3b70-4c03-afbe-6b03f5877f9f"
      ]
    },
    {
      "cluster_id": "e6867616-fb8f-44d6-8b92-f5cca8ca9e6a",
      "members": [
        "0aebb9f1-91df-402d-9f33-9d92f0b25ce1"
      ]
    },
    {
      "cluster_id": "ac5cef85-9755-4d73-a0c9-3b2d779220c4",
      "members": [
        "42b54835-5d4d-435b-8b6a-5cedf48f4ff0"
      ]
    },
    {
      "cluster_id": "9860031c-3ecb-400d-a847-e88ace1049f2",
      "members": [
        "71cd85bd-d68c-4f80-96ef-5e4a0f20e449"
      ]
    },
    {
      "cluster_id": "3e5167ea-d839-4cc5-b193-fda2f9c0b53b",
      "members": [
        "dde47415-3e34-42b0-91f6-8049defae740"
      ]
    },
    {
      "cluster_id": "b9198f54-dcf7-43b1-9ba8-28ae1ef79e83",
      "members": [
        "311ef79d-3316-4ed0-aa50-6908a31ccf34"
      ]
    },
    {
      "cluster_id": "c07ab2cc-cb47-49ae-9148-a023065f7018",
      "members": [
        "adcbad7e-4248-4175-a81f-d50b7c2de032"
      ]
    },
    {
      "cluster_id": "6019fc4d-e3c3-4367-8970-ef89e2860014",
      "members": [
        "bbeef6fc-0381-4225-8d4d-c559818a9245"
      ]
    },
    {
      "cluster_id": "55a6c384-27dd-4299-b28d-d3dcd1dd5947",
      "members": [
        "4890350c-f17f-4ee5-9907-ea4bee9f3c78"
      ]
    },
    {
      "cluster_id": "984134b7-51eb-489d-965e-a939f985e06f",
      "members": [
        "8c4010bc-6c4c-4934-bd26-e4ab5f10b96b"
      ]
    },
    {
      "cluster_id": "ddf6dff1-95bb-49d1-93d2-18eeac6d22bc",
      "members": [
        "97c8f3a5-99e3-4d37-8ef8-8f13a0f6f87b"
      ]
    },
    {
      "cluster_id": "4594a001-49cb-45b8-a26a-b07a8a886360",
      "members": [
        "4c2290f7-c93b-4bcb-af31-dcb1673f4622"
      ]
    },
    {
      "cluster_id": "a2a57731-90ff-4a12-a08f-721a9dfc0b06",
      "members": [
        "c675b624-2763-47c1-a4a8-832fa897333a"
      ]
    },
    {
      "cluster_id": "42139453-8011-41e0-af88-1b45a4865158",
      "members": [
        "db746ea7-fad4-4ef3-9c9d-d6271b28d902"
      ]
    },
    {
      "cluster_id": "6cf558a2-c2e5-4467-b5b0-ac3ede97ca96",
      "members": [
        "4e6afe48-56e8-44ee-891f-dd9bae3916b0"
      ]
    },
    {
      "cluster_id": "5cf9fbcc-d33b-4ff7-b888-4b9e4e5ca4e1",
      "members": [
        "9ce36d9d-c25d-4bb5-888a-f10c126f5cdf"
      ]
    },
    {
      "cluster_id": "ed7e3755-29e6-4b64-b965-226f2c61a6d0",
      "members": [
        "0c20dda0-d26d-4aa8-9ab5-36f5ecd7c1b5"
      ]
    },
    {
      "cluster_id": "f4d9e677-79ed-4c5c-84a1-d127898975a0",
      "members": [
        "12a8a42b-01c8-443c-a58d-67b4d9241aef"
      ]
    },
    {
      "cluster_id": "70b49961-b72f-4a9a-bed7-51b09a9f1ec7",
      "members": [
        "bae4b60e-2feb-413a-80e5-9ae5c5227f65"
      ]
    },
    {
      "cluster_id": "68ff85cf-74e5-4234-a53f-6dba1aacb444",
      "members": [
        "40355d84-e0d1-4012-ba06-470990ff355d"
      ]
    },
    {
      "cluster_id": "e126486d-8b99-4425-b6a3-54724b486b78",
      "members": [
        "49f5e80f-b75f-4e72-b737-6acbef1bf0a2"
      ]
    },
    {
      "cluster_id": "71f12e75-d3eb-42eb-93dd-fc62f2343321",
      "members": [
        "10bd837a-184b-4920-8305-30712092c033"
      ]
    },
    {
      "cluster_id": "04fa98cf-7cbb-4ec9-b84f-6d1c0570075e",
      "members": [
        "71548d11-3d0c-40be-ad09-6aa892149ca2"
      ]
    },
    {
      "cluster_id": "eb646312-9617-4ab9-b534-22cc250a28b0",
      "members": [
        "8438a8e5-7cc5-4ccc-9e88-93c1ecdd7a0f"
      ]
    },
    {
      "cluster_id": "efb94acb-755c-41bd-b1f3-cb170deb0266",
      "members": [
        "82cc3ee8-b976-4209-ac1c-82cf81af5987"
      ]
    },
    {
      "cluster_id": "88b5488c-d8fa-4baf-af94-ea104e983a2a",
      "members": [
        "884b5410-71ab-40b5-92bf-3fa3d31a42b2"
      ]
    },
    {
      "cluster_id": "ab1e12a7-1d17-4758-97dc-5a8b5a8834bc",
      "members": [
        "1ca2752f-4af9-4d26-8544-6712cd8d5734"
      ]
    },
    {
      "cluster_id": "300fdda9-fd92-4984-a9e6-86c9522fb6d4",
      "members": [
        "7b45f5c1-bb98-4361-b2ce-46d822b10ac7"
      ]
    },
    {
      "cluster_id": "df846784-b644-4d2f-a077-f42db08f73a6",
      "members": [
        "d773d4e9-0cab-4365-8976-c8decb85d8e1"
      ]
    },
    {
      "cluster_id": "7c9c690a-19a8-4aac-aba5-327f2a8b5923",
      "members": [
        "16cce81c-59f8-49fe-80c7-ebfa11deb63b"
      ]
    },
    {
      "cluster_id": "1746dc9d-7bd5-45f4-a86e-d7bc4c937633",
      "members": [
        "ccf1aa54-dd43-4d8f-a738-dd4d80b24add"
      ]
    },
    {
      "cluster_id": "e10dd96b-b6dd-4c6b-baa2-67b6eea4f84a",
      "members": [
        "57c37915-30a2-40bf-974e-472454a96f8f"
      ]
    },
    {
      "cluster_id": "078f370f-a761-435a-a7fd-aae948eb479b",
      "members": [
        "5830dc6f-03ec-4ac5-b7fd-5edf44bb0a83",
        "d88d003f-e632-4853-b889-29b348e0ebd3"
      ]
    },
    {
      "cluster_id": "51eec710-c7a6-436a-b700-e76c7c02bc82",
      "members": [
        "1a00a4c5-406d-4321-84ff-e533b4ecc22c"
      ]
    },
    {
      "cluster_id": "2f6021e2-bde5-4c10-ae2b-194bf6a93505",
      "members": [
        "61b0468f-bf4f-46aa-8677-03c588718fbd"
      ]
    },
    {
      "cluster_id": "3630ee9d-368f-4623-9704-06881bdf9264",
      "members": [
        "9a8b19ca-a3ca-4d44-98fb-4879ab5e716a"
      ]
    },
    {
      "cluster_id": "2fdb1c74-dc8a-4068-93d3-ff9e7c3e4528",
      "members": [
        "38d3dbe3-6d8f-4c1a-ada7-82d3adc0c1a7"
      ]
    },
    {
      "cluster_id": "0792eb98-3885-48f3-bc43-bf2a8c746720",
      "members": [
        "5984b168-5644-4269-bf75-69cbe7dc11b1"
      ]
    },
    {
      "cluster_id": "66914632-689c-4d05-b834-b8904eae50cd",
      "members": [
        "86963e0e-78a0-4aa0-a5d7-18317e7a8435"
      ]
    },
    {
      "cluster_id": "d935874a-c33c-4b74-9137-99d8fd9fc1f8",
      "members": [
        "bd9d61c0-b489-42b3-81d2-5037b5b9085f"
      ]
    },
    {
      "cluster_id": "c043e411-6d15-46a6-be1e-7a8a943cc43f",
      "members": [
        "6d24cd62-df85-47ff-a576-096eb14cfac7"
      ]
    },
    {
      "cluster_id": "51f92102-4c83-4bf3-8e2d-cf88f9368a7f",
      "members": [
        "ff08916e-80cd-4f56-9132-0d29f090108b",
        "3bf74375-2e58-4af8-81f7-5bd09e663411"
      ]
    },
    {
      "cluster_id": "67077d98-dd63-4eb1-bfae-12ca20649195",
      "members": [
        "1cd9e0d1-d0c7-4e5d-81a0-dd508b1c0103"
      ]
    },
    {
      "cluster_id": "76e2cae3-f195-4448-9b25-588665927aca",
      "members": [
        "acd001cd-0290-40bf-a92f-fa64c5dd7162"
      ]
    },
    {
      "cluster_id": "f65b5094-1e51-442e-b444-de0d25f1fea0",
      "members": [
        "a9df38b0-7eda-4e6c-86c7-f5aec5ef21d8"
      ]
    },
    {
      "cluster_id": "34d9abee-6356-4941-91bd-4961dca2eec1",
      "members": [
        "0ea3ca70-90dd-4685-8683-40c371c0a842"
      ]
    },
    {
      "cluster_id": "1d4acd59-7bc7-421b-87d6-c6dcd6e61497",
      "members": [
        "52e3685b-c678-4af1-9111-fff0298d8c1d"
      ]
    },
    {
      "cluster_id": "5c533a3e-46e0-4800-bdb7-5c1521efbb3d",
      "members": [
        "f826d0dc-a8ed-4fd6-a3ef-8ea48b29d995",
        "402d4cf2-b595-4a1b-9e0d-398cdaa5f715"
      ]
    },
    {
      "cluster_id": "8aec1af3-93d7-45b8-8844-62e8b3ac6198",
      "members": [
        "77774563-df12-46ca-b652-d2aadb1356bf"
      ]
    },
    {
      "cluster_id": "1a660b55-5f53-4246-a227-98df9e4e2ac4",
      "members": [
        "d50c2267-ccfb-496b-ad5d-5b5cf780038b"
      ]
    },
    {
      "cluster_id": "b61ba5b2-e28d-4cea-b7a2-78bed070aeca",
      "members": [
        "5f686620-22a4-4420-922c-3dcacdf705e4"
      ]
    },
    {
      "cluster_id": "253e2fef-8100-4235-899c-96e9877535d1",
      "members": [
        "32c50326-30f2-4f12-8a82-643ec0ef2da7"
      ]
    },
    {
      "cluster_id": "b459615c-cbbe-438d-9dbf-cc3051ba017f",
      "members": [
        "524904f4-9cad-40eb-9364-745fdd154360"
      ]
    },
    {
      "cluster_id": "1dc0ed5e-e098-401c-9b18-3dd42ba6b01f",
      "members": [
        "3ea0bb8d-ace0-438b-837f-af1f609b2983"
      ]
    },
    {
      "cluster_id": "284e7f1a-ee5c-4c83-986e-6b13c6c2e6b5",
      "members": [
        "facbb5fb-ab2b-46f7-8ddb-36e37650f76b"
      ]
    },
    {
      "cluster_id": "a24c9e44-7dfe-4825-ab38-82d2ff8a84cc",
      "members": [
        "7c0d759c-256c-45c0-962a-921ab04dec88"
      ]
    },
    {
      "cluster_id": "af51e97e-2570-48ba-a0bd-ab0668831da9",
      "members": [
        "d8a8c4b2-0e1f-4c25-a277-efd7033a966c"
      ]
    },
    {
      "cluster_id": "35ee8064-f9ff-4496-b4db-ba79f7f24de2",
      "members": [
        "f6afb794-bfad-4655-8a2e-7b3a4bbef5af"
      ]
    },
    {
      "cluster_id": "31bf6722-ac5c-4597-8c42-50efe5c5aceb",
      "members": [
        "7eb45dca-8013-4bad-a452-af5178b0821e"
      ]
    },
    {
      "cluster_id": "9abd543e-88ed-4716-b3f4-c8fea9769bf2",
      "members": [
        "b0bd9402-6ac9-4bfb-b7a3-46087e2efaeb"
      ]
    },
    {
      "cluster_id": "f3cb984c-8736-4ad2-8cd8-5ca9f90033d5",
      "members": [
        "3e8127cd-0ac5-4ba6-9b1a-2f5ad353a380"
      ]
    },
    {
      "cluster_id": "ca871236-c037-4fa9-b3bc-cfec982a8e55",
      "members": [
        "16b2210d-88f5-4ea8-8a34-f9036b31f1c2"
      ]
    },
    {
      "cluster_id": "89aabd59-2b1d-4122-9c03-b5ffeee5a650",
      "members": [
        "9548af52-dc76-462b-b47d-4103c15106fb"
      ]
    },
    {
      "cluster_id": "6fa7c53c-2f06-41c6-acf2-531da6482f4e",
      "members": [
        "f19de695-0fd5-4984-879f-5e7fe105d8bd"
      ]
    },
    {
      "cluster_id": "8d98ef20-8cc0-4e51-b441-315a42837e56",
      "members": [
        "1242e98b-4861-4e72-918d-2cf17aa8ef2e"
      ]
    },
    {
      "cluster_id": "9cc8f400-4462-4501-9bf3-f6cf35f7a110",
      "members": [
        "17369906-4440-4cf2-b756-2f07d9af8743"
      ]
    },
    {
      "cluster_id": "ecf280bd-73fc-4028-90b4-eae0d740ef40",
      "members": [
        "2c5f2066-066d-45f1-97bd-e7d6dc3fdff5"
      ]
    },
    {
      "cluster_id": "0511fc3f-517e-42e7-84fc-34ea436b847d",
      "members": [
        "70e18083-4534-4530-afa8-d8714b3040bf"
      ]
    },
    {
      "cluster_id": "3be4473d-cbba-49ee-93e6-36d5bcd0dc0a",
      "members": [
        "7824b1f9-6e1f-4f01-b3d0-804dacae6c5e"
      ]
    },
    {
      "cluster_id": "fcc58b11-54f2-420b-99e3-8acb8731fd15",
      "members": [
        "074932db-89fa-4c44-b3e2-4b9f5cf79713"
      ]
    },
    {
      "cluster_id": "3bda7498-8cf1-4495-9ee2-307193fe0c3e",
      "members": [
        "ce5811c1-0450-4769-8a57-92c8068d2fb7"
      ]
    },
    {
      "cluster_id": "da4e5cde-efc2-4363-87b4-b9935cc2b21d",
      "members": [
        "059dfdf0-3274-489c-a292-df035cfe622b"
      ]
    },
    {
      "cluster_id": "f90167d0-30b7-4246-8eb8-7c564be9c434",
      "members": [
        "86c627e9-87ce-4feb-a64a-7c2e65cd051c"
      ]
    },
    {
      "cluster_id": "93f3d467-50ce-4038-8205-5814ad28dd43",
      "members": [
        "86bc7693-d3ed-489b-8275-42c965c94524"
      ]
    },
    {
      "cluster_id": "c62acce0-70f2-44c3-9131-cec3cdb1f20f",
      "members": [
        "004bcedc-8ee2-4bfa-b1a3-bc80706b2c9e"
      ]
    },
    {
      "cluster_id": "e60b32d7-dd12-4868-82cb-0b73bd6ac71a",
      "members": [
        "ea491e59-5762-4b62-ae8b-0e847b8f2306"
      ]
    },
    {
      "cluster_id": "5d2ff6eb-cad6-467b-869b-d4782bae2371",
      "members": [
        "13882094-703c-4278-b683-549acc4d6b63"
      ]
    },
    {
      "cluster_id": "3720666b-a4ac-4b21-9f19-2a86f32551a0",
      "members": [
        "ce6bdc17-d3f4-4f80-85f2-0aefcba95ef2"
      ]
    },
    {
      "cluster_id": "b4c1b467-58b1-4e2c-a735-234cba24891c",
      "members": [
        "f442f5d7-694c-437b-8a57-42377f8836c1"
      ]
    },
    {
      "cluster_id": "4f28eb95-dbc1-4a88-9ad2-cd53edd38fd5",
      "members": [
        "6a12640e-f7af-45fb-83c1-115eb23d04c6"
      ]
    },
    {
      "cluster_id": "e2f88c16-103f-497d-a88a-e63349d63a62",
      "members": [
        "add1a8eb-5ffe-4d41-aeb3-0fe733ac602a"
      ]
    },
    {
      "cluster_id": "62f1a663-dd6b-40a0-81fa-7660c589c0df",
      "members": [
        "11d918d0-91f4-4852-96b6-bcf4b48456db"
      ]
    },
    {
      "cluster_id": "f10deefc-8ed5-4516-8cc2-3ba87195eac0",
      "members": [
        "b8e57973-bf23-43bb-b596-d626ffcada51"
      ]
    },
    {
      "cluster_id": "be44c17b-cb3f-4a06-af5b-de816dfb4f56",
      "members": [
        "1ee64121-a4c9-46cf-b4b9-c13328eddf9c"
      ]
    },
    {
      "cluster_id": "c831921a-fda1-47ba-83e1-1042bd97f245",
      "members": [
        "42e3681c-d6dc-4147-9cac-e4f3a55e2e41"
      ]
    },
    {
      "cluster_id": "b693d408-b0fd-49d2-8eea-39016ff5fda7",
      "members": [
        "c6089725-60b2-4ef2-aeab-d22120486baa"
      ]
    },
    {
      "cluster_id": "59f4b586-ede4-4464-af30-2858db5799e0",
      "members": [
        "4af819d4-6ccb-4db4-82a7-142fd4cbfb48"
      ]
    },
    {
      "cluster_id": "eb7fddda-fe98-408c-a2d5-471f6b5aac76",
      "members": [
        "8f3231dd-131f-4e50-afb2-362a175bcd25"
      ]
    },
    {
      "cluster_id": "3c4e2f0e-5b8e-45e9-84a7-c71071caeba0",
      "members": [
        "deb108a4-d11d-4c83-8ef8-7fa28452ab2c"
      ]
    },
    {
      "cluster_id": "70b45d78-dfac-4810-b7f6-abeea55c435f",
      "members": [
        "7fb9d117-424e-4364-ac58-0b3f7a4c9c6e"
      ]
    },
    {
      "cluster_id": "aafb6f56-e150-4de6-8f24-4e8fe467b23f",
      "members": [
        "3840070e-e558-475e-92ef-eacb1b2de62f"
      ]
    },
    {
      "cluster_id": "04c0a28d-e066-4279-bfee-f4757f197d7a",
      "members": [
        "531466cc-9728-4a80-a5cb-881ffd95a5a1"
      ]
    },
    {
      "cluster_id": "a789dff6-b07a-42f9-812b-05be84eb01d1",
      "members": [
        "a2dcfbcd-6b87-4776-bcb4-d7f6a80bca1f"
      ]
    },
    {
      "cluster_id": "3c925ff8-1b8c-47f3-b741-4544a596eae9",
      "members": [
        "4e7cc4da-de24-4edb-97bc-77ff4cea40f8"
      ]
    },
    {
      "cluster_id": "48496823-a243-4e3b-bc74-d86ea0c9a269",
      "members": [
        "4f08f272-a5ef-42cf-bc10-d353d93fcf62"
      ]
    },
    {
      "cluster_id": "b6e9f077-b94a-483e-a60f-d0f3f875ea60",
      "members": [
        "d3c0a979-4284-4184-960f-bc6e4c588e4a"
      ]
    },
    {
      "cluster_id": "454ec49b-c8f2-4a1a-ae0e-928918575347",
      "members": [
        "50b63130-fc47-4ba7-997f-8819f7b44faa"
      ]
    },
    {
      "cluster_id": "029b01a5-6f18-4a7f-96f8-6bde44853032",
      "members": [
        "062db82d-8f4c-48d6-87ac-3bd6f0352740"
      ]
    },
    {
      "cluster_id": "40d2bc92-0cd6-4002-bff9-64332ddd7635",
      "members": [
        "2634c44b-89fb-4a8a-acef-e3b1e128d4a7"
      ]
    },
    {
      "cluster_id": "fff4a6ed-31c6-43f6-93ef-bd50b7133298",
      "members": [
        "bf90dd61-5d8b-42d9-a2e3-6cf4f09f3a7b"
      ]
    },
    {
      "cluster_id": "91ed355a-9103-4819-9a78-2425f91b042a",
      "members": [
        "99e744c6-cf62-4768-82a4-c5eb88881c17"
      ]
    },
    {
      "cluster_id": "baef4ffa-45e6-4649-9ab7-8c1b3621d2d6",
      "members": [
        "24fa34fc-a0c4-4170-8982-e09e4b40ed9e"
      ]
    },
    {
      "cluster_id": "585ea825-312e-47cf-9ba6-332afbfb9ed5",
      "members": [
        "3f4c8053-b54e-4f92-9d93-277c513ddeb8"
      ]
    },
    {
      "cluster_id": "6ac8924b-24d0-446a-8ffc-cf862b415737",
      "members": [
        "e398e6d7-0562-42c2-8dcf-06c2ea74ae41"
      ]
    },
    {
      "cluster_id": "06f782f7-82f3-4b4d-a941-de5952ae3f6b",
      "members": [
        "3f7883b4-b31b-4845-91cf-194a57ceb24a"
      ]
    },
    {
      "cluster_id": "f92684c8-da9a-477a-ba9a-9eb41a6f9f90",
      "members": [
        "0262071f-6554-4ca8-a776-25ce99af3953"
      ]
    },
    {
      "cluster_id": "41b1a4cf-dc12-4277-ac68-40ba76c05f8c",
      "members": [
        "c1036166-682d-487e-a4b7-4361798cadaf"
      ]
    },
    {
      "cluster_id": "beba9a76-4058-465a-8f4e-bc79ccf7a03f",
      "members": [
        "49c23f8f-23e4-4472-9c11-84c9cf2a0f08"
      ]
    },
    {
      "cluster_id": "041cf2cd-18d4-495c-8ae7-5b69605020ea",
      "members": [
        "48210888-cfa8-4ad3-b7a2-0dfa4a41a836"
      ]
    },
    {
      "cluster_id": "4eb34d6f-2849-4a6f-9012-a59681fdeeff",
      "members": [
        "e3bcd447-c82c-491d-b3a4-0e5ed91fba70"
      ]
    },
    {
      "cluster_id": "0ea60366-ef97-44ac-91be-b38d55efb0c3",
      "members": [
        "b2f2fad4-12fa-49b0-8884-c5321146ec35"
      ]
    },
    {
      "cluster_id": "69517d67-11aa-4671-bb8a-815c7995a3b7",
      "members": [
        "55e92a8e-de98-4d80-964f-fa59d9c221d9"
      ]
    },
    {
      "cluster_id": "94e768ad-42fa-42f8-83fa-89a3705b92a2",
      "members": [
        "b74fa89f-1aa2-4623-8efd-ade7549355ff"
      ]
    },
    {
      "cluster_id": "539a56ca-1f06-469d-a675-be2a20f5e808",
      "members": [
        "957aa997-f6ee-43d4-b6b5-c02eae63b50c"
      ]
    },
    {
      "cluster_id": "6768580d-67cd-4040-b98a-9d8276f6f0bd",
      "members": [
        "e8ccab47-ba71-4ba0-b9c8-0bc1d09c4169"
      ]
    },
    {
      "cluster_id": "6abe1bb1-d30a-40e6-8fb2-f7c5a02ae16a",
      "members": [
        "719af7a9-5749-4c5c-88fd-216b26487133"
      ]
    },
    {
      "cluster_id": "171a2f66-23cb-47e8-a645-32fd4f7a8de7",
      "members": [
        "5380d40c-3912-4e89-8e11-23b13a276589"
      ]
    },
    {
      "cluster_id": "dcadf3a6-188b-4a08-881c-e1acb19f186a",
      "members": [
        "d27d2ac6-9bc2-42df-8d5c-29642e076b66"
      ]
    },
    {
      "cluster_id": "daa86fb1-df31-4a23-a926-1b9981f8df40",
      "members": [
        "7158dac5-0017-49f2-812d-206b0dca8204"
      ]
    },
    {
      "cluster_id": "13db6364-301c-4a4a-b13f-69262abf41bd",
      "members": [
        "4e18d1c7-f31c-47ca-9940-d330060d9074"
      ]
    },
    {
      "cluster_id": "103c6b31-e860-4fde-bc3f-de3b1bf5f689",
      "members": [
        "2b95dfa8-8baa-414d-b8d2-548820d26d91"
      ]
    },
    {
      "cluster_id": "48e347cb-8237-47af-9eab-b23191638cd0",
      "members": [
        "bb99a2cc-c607-4cc6-9731-47b9facdcdcf"
      ]
    },
    {
      "cluster_id": "bc0539c0-9358-42cb-bbfb-8c0b934c5e86",
      "members": [
        "274c14bf-8201-4583-9baf-7f5c6a4394d1"
      ]
    },
    {
      "cluster_id": "0179bab7-45d2-4b90-aa4d-c6afb970dbc5",
      "members": [
        "64084a20-f346-4a33-a235-e62a7c7d2223"
      ]
    },
    {
      "cluster_id": "847accaf-332c-4ec2-bd26-cd592d1fa2fc",
      "members": [
        "cebbe995-9fa9-4d98-b56f-692acb21274b"
      ]
    },
    {
      "cluster_id": "a92d1a1e-f967-4044-9d5c-136fd4264137",
      "members": [
        "bb6e44b5-e6fa-41e5-b9b4-01888e573dc2",
        "51c6b7ce-bcd6-4d3e-a738-a4be010d31de"
      ]
    },
    {
      "cluster_id": "453d17a8-fa49-49dd-82fd-7c3661e026b6",
      "members": [
        "b1de1ae8-1407-49d3-bcca-295522f57b1c"
      ]
    },
    {
      "cluster_id": "170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c",
      "members": [
        "93eb7a62-784b-41f3-ad72-e305d7708a90"
      ]
    },
    {
      "cluster_id": "2f4a7179-3f3f-4eb6-8891-8b8d39467620",
      "members": [
        "7ba5b1af-4476-4bf4-91a0-406a281c4b05"
      ]
    },
    {
      "cluster_id": "e455cd44-cd3c-4e6c-a847-ff250278123c",
      "members": [
        "1f252834-436a-4e67-a2c6-64a940bbed3e"
      ]
    },
    {
      "cluster_id": "74ac8dc6-1d9b-435b-bae9-36745f271604",
      "members": [
        "8c9326f1-ae17-4b5a-a7ec-52c65d9325a4"
      ]
    },
    {
      "cluster_id": "57bfc89a-d981-44e9-a425-3364b9a5bc24",
      "members": [
        "2db653b7-ee92-4ec9-b180-72c043d2d0c7"
      ]
    },
    {
      "cluster_id": "f2b2e8c7-6437-43ee-a47e-1c3a44cd6c34",
      "members": [
        "5cefc9a4-e804-4c37-a8c1-e474cf868791"
      ]
    },
    {
      "cluster_id": "9ef27775-8065-4722-bd90-8a9ae4a3c250",
      "members": [
        "b1af5fde-5c96-4e5a-8d9d-69f766f223b6"
      ]
    },
    {
      "cluster_id": "c56c08cf-6265-4f43-9208-61aa17304ed8",
      "members": [
        "529747e6-c84c-4008-a3ec-058fe174bbff"
      ]
    },
    {
      "cluster_id": "984e2a37-4883-4da4-8899-a3cc19bba978",
      "members": [
        "dcfe43e5-7b7b-4fe0-8bc0-50f6bb6f670c"
      ]
    },
    {
      "cluster_id": "c1308dd1-2ebf-4164-b9e3-2284bbfb088b",
      "members": [
        "eecd938c-ba83-4a0a-8c06-727917605325"
      ]
    },
    {
      "cluster_id": "42734325-e832-49e4-b0f3-d3af89abdf66",
      "members": [
        "37b437be-8af2-4ac3-89c0-21c2cea00254"
      ]
    },
    {
      "cluster_id": "ca129396-101c-429f-8530-fe05aaa1c7cf",
      "members": [
        "789c2b70-403d-4eb1-9a24-21da93e3ad36"
      ]
    },
    {
      "cluster_id": "4a05fcea-c8cb-4b88-bb80-cab978e72560",
      "members": [
        "4d39d39d-6cb0-4725-b395-c44a7955cbef"
      ]
    },
    {
      "cluster_id": "7dc48717-c562-4f7c-bcb3-b4a13374cc42",
      "members": [
        "79cbda05-a678-4a17-b8c4-5f92dca28086"
      ]
    },
    {
      "cluster_id": "8f5c67fb-16a9-42c0-8cf3-1bc2d8d1a576",
      "members": [
        "37915a45-2e81-47c4-924c-400eef8d84ff"
      ]
    },
    {
      "cluster_id": "e7139494-8034-460e-8501-83d621dafede",
      "members": [
        "ffa4f281-0e0f-490e-be58-b80f76c9674a"
      ]
    },
    {
      "cluster_id": "752a6b2b-a9aa-4a80-b345-6a1e96c0ac0c",
      "members": [
        "ea35a604-407f-4c7b-a6af-da4d03840f1b"
      ]
    },
    {
      "cluster_id": "c2ba86a6-df2c-40b6-bf30-1269c5ac3702",
      "members": [
        "ad1c1bc2-4a4f-4bdf-b6b9-e9f2d807bee5"
      ]
    },
    {
      "cluster_id": "c18b334a-f61f-4400-b355-cea2e7375866",
      "members": [
        "e2df60bd-689b-44c5-a618-e4e1f0676cf5"
      ]
    },
    {
      "cluster_id": "7ef8f454-db4c-44bc-85a5-523eff6a595c",
      "members": [
        "a221a2d7-fd93-4ffa-befb-59ad7e2b05c1"
      ]
    },
    {
      "cluster_id": "f7811e36-516c-4780-b025-c2c198f87bba",
      "members": [
        "335fef47-0cc2-4ccb-a42f-50c52e23d7c1"
      ]
    },
    {
      "cluster_id": "c6541e86-8e1b-4bd0-926a-c380aa103aa6",
      "members": [
        "872b8944-72a7-4d07-a1c4-a5ef2eea3320"
      ]
    },
    {
      "cluster_id": "eb4aeb04-6d38-4eed-9989-773ac30f14e1",
      "members": [
        "8fc73765-f64d-469a-bdf3-d37328bf1161"
      ]
    },
    {
      "cluster_id": "0c63b123-d884-4e43-b541-3b36f23f2e96",
      "members": [
        "41c6e347-6c57-4ab9-9e83-1eed3caab677"
      ]
    },
    {
      "cluster_id": "712f7b26-cec5-48c3-8025-43c35dea8246",
      "members": [
        "c7829b30-8d83-461a-a1dc-e5669dad7ba9"
      ]
    },
    {
      "cluster_id": "41683dea-1259-4e44-9283-e6286d675c48",
      "members": [
        "941d2a71-a7d6-4664-bc9b-62c65c5ffca0"
      ]
    },
    {
      "cluster_id": "a0c8c3de-8102-4a9b-b20a-80ade6132b4e",
      "members": [
        "f7deed28-897c-4051-bd3e-0a9ab0a70e8f"
      ]
    },
    {
      "cluster_id": "5e7e70f4-b130-467a-9df9-f6078877ed61",
      "members": [
        "4c70dd4e-ea1f-43dc-98ff-7e84438541f5"
      ]
    },
    {
      "cluster_id": "2b3c747b-9f75-4697-a22b-426999d9c671",
      "members": [
        "d2df6d4b-3f0b-453c-bf5b-701933c7e698"
      ]
    },
    {
      "cluster_id": "e20ec3dc-5039-4e9b-be7d-622592bf425d",
      "members": [
        "25efad13-58c1-4831-9756-06e196594909"
      ]
    },
    {
      "cluster_id": "6677095f-eafc-4bbb-8dde-f914b5103e89",
      "members": [
        "7f530241-1694-4141-8897-e029b0320e13"
      ]
    },
    {
      "cluster_id": "17a14bb5-8594-4aa3-9c74-e077722ac66c",
      "members": [
        "e34e39b3-2fbd-4773-bb14-66e16fb66996"
      ]
    },
    {
      "cluster_id": "2a250092-9fac-4905-871e-1b18221951a9",
      "members": [
        "83f2971d-2fc3-4df6-9e5f-97a52f7be26e"
      ]
    },
    {
      "cluster_id": "2052af74-0bc8-401c-a911-035e4f5f65d2",
      "members": [
        "b23e65b1-6283-4c3b-b01e-46927d683e14"
      ]
    },
    {
      "cluster_id": "19b19cf8-a65c-454e-84bf-36d3044b6f73",
      "members": [
        "c7dc4d17-3c9f-4f1a-8849-8edf3cbfdda5"
      ]
    },
    {
      "cluster_id": "7afd3ded-a43a-4c9d-b365-6656ecd89e6f",
      "members": [
        "78aca2a1-2f9b-463a-85c4-8a95500256f3"
      ]
    },
    {
      "cluster_id": "58a7d973-9fa3-4047-a219-579a31c4561b",
      "members": [
        "1819efd9-1057-4ec9-92a5-e84923e4c147"
      ]
    },
    {
      "cluster_id": "50fd260f-831d-4cd6-a164-2aef0978fbe3",
      "members": [
        "772b5976-97f2-4a12-95c8-3f67f08ffee6"
      ]
    },
    {
      "cluster_id": "162b03a4-86a7-4adf-9f73-3093aecba542",
      "members": [
        "41fa445b-dce3-4c84-82a5-bf1898a19393"
      ]
    },
    {
      "cluster_id": "ad83e0a6-e572-4332-8ef0-01e05cdfa760",
      "members": [
        "407e8b61-b3db-4edd-950e-2c807109ba23"
      ]
    },
    {
      "cluster_id": "655a46a8-9b52-4f61-b528-9f18ec9bf051",
      "members": [
        "11753fbd-fc9c-402d-9811-3a69df087b20"
      ]
    },
    {
      "cluster_id": "7e98dc53-abf7-4bf8-8ac7-3c9623f6d068",
      "members": [
        "70a16720-d268-4f35-8e36-ad170ce32bcf"
      ]
    },
    {
      "cluster_id": "850a1f31-fc4f-4578-baa4-da3b7a35e30a",
      "members": [
        "e95db749-5098-4ec6-9345-aec6a1d3b8b6"
      ]
    },
    {
      "cluster_id": "f14e0258-b8de-48c8-96bd-31550d005b4b",
      "members": [
        "03dc2d2b-ec15-4eff-9790-593d2a773e75"
      ]
    },
    {
      "cluster_id": "0605c233-63ed-4bdf-a0fe-665556a34a75",
      "members": [
        "61090b8f-c351-4d39-b293-02d496c4ca2d"
      ]
    },
    {
      "cluster_id": "9254d2c4-775d-4f48-975f-879f17b9f193",
      "members": [
        "e4d88dec-37e3-4c03-86f7-7faaa4a822a6"
      ]
    },
    {
      "cluster_id": "a5a6c59f-7670-4f97-9c2b-c94700d73131",
      "members": [
        "dbe5cb87-6836-4dd6-a307-d04dc800cde1"
      ]
    },
    {
      "cluster_id": "f66864ea-bc5a-4c3b-ba81-6aa44dc35cb3",
      "members": [
        "0747b3a4-c669-4df5-808a-d613cadeec1a"
      ]
    },
    {
      "cluster_id": "3e304d73-a8bf-4d4a-8525-85d6c447ae6b",
      "members": [
        "51cd1cdb-d1fb-4f80-b303-18db54827cf5"
      ]
    },
    {
      "cluster_id": "7b76e5cb-748d-468e-9baa-d34773d5f24e",
      "members": [
        "39f943a4-0a7d-4621-b7a7-5c0be2d61db5"
      ]
    },
    {
      "cluster_id": "679dc735-ea4b-4b4e-88e2-45d26bcc5b41",
      "members": [
        "a4dcd6e9-eeda-4dfb-9c64-117707d0a66c"
      ]
    },
    {
      "cluster_id": "ef57a08c-bb40-48bb-8784-c240ed933462",
      "members": [
        "d485c361-9b6d-4071-87fe-6aacd4cd6180"
      ]
    },
    {
      "cluster_id": "ed1fef35-ea22-4436-b53a-1dc1f0380298",
      "members": [
        "b59a7553-ce15-4155-84ae-a924e79313a4"
      ]
    },
    {
      "cluster_id": "f51d817f-9949-43cb-b16a-bfdefff947f1",
      "members": [
        "d7b4ec5f-6db9-4bd8-b2d1-46940bbd2d84"
      ]
    },
    {
      "cluster_id": "0166ea62-85f0-412c-bd73-f3d7bc1bdf59",
      "members": [
        "cfd59ee6-711b-453c-8505-5bc0e9d0499b"
      ]
    },
    {
      "cluster_id": "ce0417d2-5817-45d3-a01f-447b8d6d19ff",
      "members": [
        "5c9afadf-bdd1-4b6f-90a5-1539e037df31"
      ]
    },
    {
      "cluster_id": "96b44dc8-1893-429c-83b5-6d58cef5fa9d",
      "members": [
        "fa6bd3a3-a782-4525-8065-d7c55a7d2524"
      ]
    },
    {
      "cluster_id": "8944c246-4c2f-439b-bc21-590da536eede",
      "members": [
        "39ced119-b9ff-4dd5-bffb-c2b0dfac001e"
      ]
    },
    {
      "cluster_id": "b4ecc989-8236-436c-a361-fdaa1e9413ad",
      "members": [
        "55db5b56-74ee-471d-b522-65a8bf2f70c4"
      ]
    },
    {
      "cluster_id": "0a27f80b-b648-4764-8688-fd889dc32a39",
      "members": [
        "fc96abd7-8ce2-4450-bfd6-951a94697ffc"
      ]
    },
    {
      "cluster_id": "bae449de-e29c-430c-9526-c8dc925bf231",
      "members": [
        "e11aef87-b457-45ce-bf4e-efda03b4bed1"
      ]
    },
    {
      "cluster_id": "9c99e4fa-6c0d-4aa9-bb98-86450c898d1b",
      "members": [
        "260d2849-6e85-4bd7-a5e0-3533d6ec5909"
      ]
    },
    {
      "cluster_id": "131fc120-2488-4970-ac79-410004aa6030",
      "members": [
        "90bdfa4e-b4a0-443d-84a2-56ac539d802a"
      ]
    },
    {
      "cluster_id": "da745b4f-4158-4c1c-b2f1-ec13252863b3",
      "members": [
        "20f72b01-a541-48db-a97c-ad35b82d6dfe"
      ]
    },
    {
      "cluster_id": "be467aaa-b350-4a63-875e-7aa61c3d868a",
      "members": [
        "27df6cfc-a1c0-4cca-9425-b5897788f1d8"
      ]
    },
    {
      "cluster_id": "7c8b94c0-08bd-43e2-9b5a-418ff416c274",
      "members": [
        "0a2b3c34-28d6-4c0f-b765-6820ab6a46c7"
      ]
    }
  ],
  "event_clusters": [
    {
      "cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c",
      "members": [
        "38817e72-8ea6-4a91-8032-30eba5f54cb7",
        "15c88d5d-4214-4f6a-8e3e-981cf10164b3",
        "da41dc75-fcc4-41ab-88dd-ddf7161e36b0",
        "883a896b-e817-45fc-b9ee-371155a7d074",
        "d499ec0e-dd4f-4f89-9447-aa1acdbacf68",
        "ac85ad4b-cc9f-4f44-beb5-ea48d8a52c1a",
        "b002bc7e-9203-4656-84b6-0a42fd4eea6d",
        "1feb038d-92fc-4cd4-b25c-1c1a29e47dd3",
        "a12a73b8-1940-447d-b9e7-76cb08c90246",
        "4050775d-4d21-4e1d-bd3e-b7ac298dcf8e",
        "1188ef4a-afd9-4c2d-8d23-cb5ffb6c6df2",
        "33911966-bd3c-4971-abde-7b549abbf5c0",
        "86f7ea7d-367b-4e3c-a4c2-06a33148d191",
        "9daad42d-18d2-4972-91b8-ef9a05123604",
        "d991436b-aa0d-4d71-8ddc-97f32927ada2",
        "5d33b07c-4552-4834-89af-6820b593c9ef",
        "688fe4d0-074c-42df-90b8-b7269d511b8a",
        "f2ed9760-5610-4a2c-9354-e9247fc29368",
        "6f7e1a31-2f08-4dc1-9e88-4c22430a5a99",
        "4752aea3-c2b1-42ba-8ef3-78e974599ff3"
      ]
    },
    {
      "cluster_id": "b8ea1565-defe-4a1d-a235-40a614cdd9ce",
      "members": [
        "3a17acef-1782-4e5f-aa26-098cc82ab82a"
      ]
    },
    {
      "cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5",
      "members": [
        "96c10070-a729-45d2-a388-f0bf828e9f4f",
        "4a28a209-dbc3-45dd-b84a-d065c7a2ddd8",
        "ef477121-218e-411a-9ccc-a92c33206c03",
        "cb6e63a1-19db-4f46-a697-59d594fab471",
        "24ae4864-abfe-4abf-899b-ea8d7ab6dacb",
        "9be704ed-0245-4064-813a-c380592a9050",
        "438d9319-2731-4376-8c2d-4a97f1f00888",
        "bcb14239-600a-4eab-b1b9-58e88135fa1b",
        "7eeb196f-3cdf-49d7-a679-20612e8b96a5"
      ]
    },
    {
      "cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b",
      "members": [
        "2157e893-ff88-41ee-b94d-63bdd6b33a42",
        "05801579-0283-4e6f-9252-e0ccd540942c",
        "01616dfd-fc22-45d1-9fcd-1b2ad598a500",
        "db688f4b-62e3-44b7-adcf-3ae0f870d11d",
        "1c43e30e-6ec5-4b7b-8717-cc2a2a107d40",
        "1d831c31-4014-4bf2-96b8-24fc74385832",
        "1cccfa74-2117-468a-aefa-213b8307ea3d",
        "58935218-ac05-49c6-a4ef-438b8716d1fb",
        "520176c7-8c95-47d8-a5f6-2fa9bc33eb5c",
        "e9b6d363-8833-4dcf-9fb9-f2f319d33e06",
        "d4ac0cf9-cde0-4c2c-8550-238510e5a0dc",
        "6964c63e-6ac3-4676-95c7-8019b57baa90",
        "77273e0c-48f2-49d3-bed3-e1b2adffa13d",
        "bc043127-5b23-4ee1-a4f9-b80ceb8089e6",
        "53db27b4-4d8e-4ffc-958f-39a178f1fcb9",
        "2e24dce7-d94c-4791-90e0-80af31835706",
        "e813eef7-8b07-43c9-9b52-89016dc23bfa",
        "156ad354-9ff7-4d94-8f13-dca5079d271e",
        "2ab59778-fd56-4c7e-a5a0-f41cd08542da",
        "b16aee51-f02c-4b7a-971e-f64d6361f22d",
        "e241f247-6176-476e-8066-4a9677b0c4c0",
        "374385f7-292b-4a9f-8779-030b8b2426dd",
        "3cc24982-0e8e-402e-bc62-17a64ee6c945",
        "78361e4d-90a1-4bab-8a32-903cf5747287",
        "0cf49f83-68cd-4108-904c-11ec76282794",
        "c287a65d-6767-4792-a760-e5e5c06094fb",
        "b8efd856-ccbb-42ac-8e04-a53a4c96b40b",
        "49f61cde-4635-4a82-bb4c-63e3298cb768"
      ]
    },
    {
      "cluster_id": "2d27e988-7b20-4d35-8415-461b2756da32",
      "members": [
        "379de43d-cf89-4e1c-a6bd-ea204190dd70"
      ]
    },
    {
      "cluster_id": "9103d8ef-aca0-41e2-a089-fa1568b1c90f",
      "members": [
        "936b959b-6c76-4051-89f6-fe1ec2bee40e"
      ]
    },
    {
      "cluster_id": "40f8706e-4783-4eef-bf10-d2f20bfb78bb",
      "members": [
        "dce49401-863e-4c6f-893a-323fab28b5ec"
      ]
    },
    {
      "cluster_id": "49b36199-c1c8-43a9-b1e6-9f3f63fb03d2",
      "members": [
        "b6971264-6ca4-4aa5-a164-3d9bd552bfa7"
      ]
    },
    {
      "cluster_id": "de6de235-4f06-4b1a-9079-19678104136f",
      "members": [
        "7ab19c87-15df-4cbb-987d-eb9014edeb27"
      ]
    },
    {
      "cluster_id": "ddf8f300-b701-4129-bf0a-f30da96bc031",
      "members": [
        "4b078541-759d-4b6e-b215-cf946dc4f2f7"
      ]
    },
    {
      "cluster_id": "7a09649a-0d1c-4211-a9ef-65dbb223fc3d",
      "members": [
        "a40f6c4b-f04b-414e-86bb-e50d7519d701",
        "e5febf9d-f8b5-44f5-91f7-a1784dc87110"
      ]
    },
    {
      "cluster_id": "bf671abc-cf54-41ee-b308-c02abd68d48b",
      "members": [
        "6bbad3e4-8bce-455f-b619-561b2fa64940"
      ]
    },
    {
      "cluster_id": "8c5f95da-6a16-42a9-82d6-b9a5a0c0b94c",
      "members": [
        "5b2a3322-05ed-40ad-a7e2-263881ca929a"
      ]
    },
    {
      "cluster_id": "e8e30d44-65d0-4e66-baf3-7e0ae3df4a05",
      "members": [
        "db951ce3-0774-4b1b-8098-c783a8e0060a"
      ]
    },
    {
      "cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f",
      "members": [
        "4ee8388c-21bf-46da-b34d-6c991d81c123",
        "663f388b-8d33-4499-af44-cd69c04ac64f",
        "5e8f4fa4-fa26-485e-8e61-7934f5c5bf39",
        "4d8ffea9-6020-4546-8897-a13e1054d374",
        "df930dd9-6b0b-4827-afe1-5894953e01bd",
        "40d1fa1f-1ea6-492f-b43c-71d594b24f86",
        "6b1d0896-6534-4772-818d-a3b7f82c5da1",
        "953806d4-b8b0-49ec-a28a-62b9d8739402",
        "2c9d2a6c-ddf0-4248-ae7d-b39d356c078f",
        "0257f52c-89f6-4cfb-9c0d-5b86a9efee9d",
        "a3ea47d5-c69f-4d63-9199-e145f58f0b7c",
        "460cdb5d-07ab-4e6c-bc3a-d2feb9e90359",
        "355f7a62-c215-4842-a84b-3c956c65a379",
        "5943d437-2833-43b2-b041-b1240a2a79a0",
        "771cadb6-a575-4af6-8466-113aa0936dcc",
        "0d960c2e-82aa-4fcf-8f81-ab730c8a9dd5"
      ]
    },
    {
      "cluster_id": "5a9d340b-259a-49d7-894d-4e9c6dec6a07",
      "members": [
        "fec0b6e7-7749-48a6-a023-a4649ca36af7",
        "2e0c40f0-7009-4245-826e-b1c693e22a37",
        "6ff8e77e-ba6f-462b-a50c-91dc2a48055b",
        "81ef874f-fdd0-44e9-82c4-b0faf65cb9de",
        "13afdb0f-3788-4b98-94f3-d10f8635be0c"
      ]
    },
    {
      "cluster_id": "7a2f4f21-3ae3-4d01-b8e3-e3fd8670db5a",
      "members": [
        "ad77c269-8758-44cf-ab9b-5ccaf6f7e0c7"
      ]
    },
    {
      "cluster_id": "213244f7-7bbf-4ff3-935f-65e545a0abda",
      "members": [
        "d2a9eeda-e0d7-4adf-8acf-5dd5b1b69038"
      ]
    },
    {
      "cluster_id": "125a4bc0-e32c-4a8b-80fc-60d23537d495",
      "members": [
        "6eb99b34-dbe3-49ad-a849-160d8c11f9bb"
      ]
    },
    {
      "cluster_id": "f55b7553-3d55-4096-859e-954de960f09c",
      "members": [
        "f4b4255f-ed8a-498a-938a-a7347ca9e79f",
        "9ab6ff72-6210-4869-bde8-98e72edd407b"
      ]
    },
    {
      "cluster_id": "092404d0-7d21-433f-bfca-9a5d34d17b3b",
      "members": [
        "39785e4f-77f4-4b08-ad16-8fe094cb7be1"
      ]
    },
    {
      "cluster_id": "e4596864-8ee7-4544-832b-f1063fa0c90c",
      "members": [
        "684992a5-2c7c-47b9-9d0a-da99a5d62d04",
        "dc1984b6-3a67-4928-bd53-8112534f27f8",
        "f78b6f97-84ba-4753-817e-24578857cf09",
        "80f2e96a-02b8-4aab-9fb0-822357bd83e7",
        "d2216b00-aa4e-4904-a59d-96640477b74f"
      ]
    },
    {
      "cluster_id": "976b0673-ef25-484d-9be8-afb6c791a214",
      "members": [
        "89efe27f-5d32-4380-9e65-7644e8368672",
        "6e3b4786-415f-41fb-a8fd-11b0bfc99338"
      ]
    },
    {
      "cluster_id": "06451ed7-032d-45e3-9726-f485fc31a739",
      "members": [
        "ea8eba9e-8051-4f71-8589-621e0f0ca050",
        "0213cd1b-8b7d-4c86-810f-98a80cf0764f",
        "b74705cf-c363-4742-91c8-2cd15d504506",
        "52ae8b98-0c2e-45b6-84d4-fd25071809c6"
      ]
    },
    {
      "cluster_id": "0e248889-43a9-4087-a6b0-f1d7854daf2c",
      "members": [
        "45cd2538-8b5c-46ce-8c0a-b42354ca8b17"
      ]
    },
    {
      "cluster_id": "38fab33e-077b-434b-814f-3bc3f8dfc415",
      "members": [
        "367805bd-60b6-459f-8aa6-ba7e91ca4158"
      ]
    },
    {
      "cluster_id": "d0ed171a-d118-47d4-ad40-05768ad6c3f9",
      "members": [
        "dc10dd9a-4b20-48d2-b195-51777fbd3cc3"
      ]
    },
    {
      "cluster_id": "c96cd646-4254-4e40-a0db-aa3d02c5b208",
      "members": [
        "db80f6e7-5b5a-4d3d-8a7f-0976038fa7ae"
      ]
    },
    {
      "cluster_id": "5fc56973-0e2c-4845-a192-e7e5c5265d9b",
      "members": [
        "a0a156cd-e22a-4c3b-b5d6-ee9a61dfb941",
        "4bd27717-a688-4f9f-b97e-50fc5fdbd956"
      ]
    },
    {
      "cluster_id": "eb95d7a1-b24f-4167-89ab-cc60dc7c7822",
      "members": [
        "146f7a30-90f1-441d-b120-fdb2884775c6"
      ]
    },
    {
      "cluster_id": "b996a367-b4a5-4361-bd3d-e0e97f9ed9ca",
      "members": [
        "3221eac8-87f2-4ae4-94a3-10488319adb7",
        "66f3d2eb-3679-4a14-beed-197acfbfb172",
        "8db37b71-9f12-49f1-bb1a-ba3ccda5847b"
      ]
    },
    {
      "cluster_id": "6195dc7b-895b-4134-9995-738fed6389e2",
      "members": [
        "99d301bd-3e4f-4202-8c65-4e13eb4a35a6",
        "70d2a4d5-b786-4e49-af2c-e2da94a512f9",
        "021c1c3a-fd51-4941-9034-e50318b1dbba"
      ]
    },
    {
      "cluster_id": "90bfcfdf-2a27-494a-a983-e0be2f5b4a32",
      "members": [
        "714c48f9-1de5-4102-baec-011c0b404f87"
      ]
    },
    {
      "cluster_id": "05359182-fefa-4fca-a6e5-68210986bdca",
      "members": [
        "0d5d70aa-630c-4de6-b6ef-36b85c677f16"
      ]
    },
    {
      "cluster_id": "64ce313a-9f62-48b5-ac72-4f4f23b43da9",
      "members": [
        "a3817884-5e86-4a0e-96a0-abc909757b10",
        "6420c8f8-d16e-4808-96f7-081e0dee8be5",
        "b5679d9f-403a-48aa-a58b-18d8bee4635c"
      ]
    },
    {
      "cluster_id": "fae21323-4e89-4f46-9b05-1eb8df8ce6f1",
      "members": [
        "1ca906e2-b0d3-439a-9c6e-9948f1d03d8a"
      ]
    },
    {
      "cluster_id": "2f8dc773-32fe-42ed-a085-3a10ca61c22d",
      "members": [
        "fb127d47-1234-4c65-9c3c-1877970b3eb0"
      ]
    },
    {
      "cluster_id": "7690b51f-82d1-4577-be9d-58b4d7bf11b2",
      "members": [
        "4735f952-560a-4efc-bd14-23bc7888a8c1",
        "54574071-66b5-4e68-a984-ed6d330c2fdf",
        "d4e114a0-6a56-4ebe-9b0f-7f235be968c1",
        "e77c2457-bcbb-44c5-98ef-1183f378c60e",
        "7062595a-a23b-47c0-ab2b-7a0857b23c87",
        "d0debc7d-8581-4e61-8d60-6bb1817aca0e",
        "f648a1ac-8647-4587-a65b-ec507e162328"
      ]
    },
    {
      "cluster_id": "db23d549-f792-47f2-bc74-2fff4db9d0ef",
      "members": [
        "0810a5c9-b58b-4ec5-adbd-103a2842ffe2"
      ]
    },
    {
      "cluster_id": "38653b72-3e71-45be-a6f6-9c4e86755c1b",
      "members": [
        "d887d1af-80cd-48ae-a8cc-124464d09ea2"
      ]
    },
    {
      "cluster_id": "d3326047-f19e-4b54-a0ed-a16bb5dfd0de",
      "members": [
        "8170bace-2d7f-4f1f-857a-b06c0eb8d69f"
      ]
    },
    {
      "cluster_id": "b50d8113-2ba3-4857-a6f8-d3c42cda7690",
      "members": [
        "ea179191-dd07-4d44-9c73-fe1f9a8d4df3",
        "d5b913e1-ad6f-452f-9eb0-7eecbc873007"
      ]
    },
    {
      "cluster_id": "3d02db59-a52e-46b0-b009-3a6b28cebb78",
      "members": [
        "3dd7b820-dbf9-418e-8570-ae937593e90f",
        "e5008ebd-7968-4365-b0ba-fcf2073e10f7"
      ]
    },
    {
      "cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc",
      "members": [
        "ee008479-2289-4446-9132-8c75ade20ed3",
        "8e41cddf-c165-4805-86c2-74203f0c56af",
        "0eb8db24-a286-43df-a6bc-012647f9c7cc",
        "2eaec24e-b54e-436c-b85e-1fe26407abfd",
        "4b795e2e-7eb3-45ee-ab80-4bdd2e3d9779",
        "51a3f058-2f29-41f8-b540-5710b0e086b4",
        "2602f358-ce54-463f-aa87-f29b88d699bf",
        "456d3b04-8421-4838-812d-1f8e88ef43be",
        "a0e50427-37de-47e1-8628-65a45368f81f",
        "d8c49565-8be5-4d93-93c4-be6dbc0ff16a",
        "a777797a-1eff-4aae-ba9a-393c85e471c6",
        "5969a8a1-4412-4685-bc71-abc76f654bf5",
        "2fb180ca-ccca-473d-8d00-71aae8a614b0",
        "dcfb71f8-e742-4806-97c7-9c89af87b65a",
        "b69ad494-a55b-41ce-b287-247101576271",
        "6cc8284b-e23b-4ad8-9dd4-11f9c70af258",
        "aeee00eb-e4d2-433e-836d-a4f0166aca4a",
        "cafec841-66ca-4e56-8c7b-bec6678a1ec3",
        "0573fdc1-393d-4cd7-8ccd-282f5126c66f",
        "35e7b213-800a-404a-91b4-d3bfc3e7d69e",
        "3b3306c5-39b2-428e-a46c-b4027bb3f7b2",
        "f85a5e36-7aa3-4d21-955a-37dfcfcb0028",
        "1089e709-3514-4c73-9c03-977c544ef2a1",
        "c5926f07-1b8c-4545-8b18-9b06960feb26",
        "3125e0e6-6275-4e6e-93cb-46b1e8fc05dc",
        "6dc77cfe-a660-4c19-8ac7-e90ed1c0e119",
        "56c1f7c3-5279-463f-b46d-75aae1b63a4b",
        "d9d55e1f-e4c1-4127-8aa5-2dc2a867de4d",
        "0e2d0038-14e7-4b49-8a47-5d83cae03712",
        "5f879db0-e8d7-4968-9b39-fb32fb26105d",
        "910e2924-30e1-4d8f-bca1-846ccc34fb20",
        "9313994a-61f5-4078-acbd-c434cdaf8305",
        "6a3252b9-3000-4c23-9e4f-54b368b2f63f",
        "60857a55-6193-4bd3-9d2f-63e1ba65d563",
        "59688e0a-e6b1-4686-9d80-3ed2b50a11b0",
        "84b11ee7-077e-47f6-80fc-01a20fe348eb",
        "9629e5c8-186c-4e57-91bf-b18b548bc1b0",
        "2247aa0b-b1a9-4cc0-806f-c9d2d0cd4d6e",
        "8a5ddfe2-cfe1-4f96-9acd-23c0bdf4613d",
        "b144c6b8-594b-4b18-a0e0-8759f18a0fef",
        "9d91cf96-9ac9-4dd9-b4b1-a62cb2f0b37e",
        "f5800722-6b8b-4a18-be9d-085c87f1ca2f",
        "51da7fb3-ba1c-4c01-bb2b-33e9987857e1",
        "ea77b17e-ecb8-4852-bf00-da2fb17cbbe1",
        "85028514-fcf2-460e-b88f-ec26291d1d1c",
        "608d1ff8-dfa6-45e2-b5f9-0f8f07b43b6f",
        "6c96e600-ea11-41eb-980c-50af62ee819b",
        "1e030ebf-e8f3-4135-b352-2512fe72e38f",
        "638706de-f7d7-43e0-8478-a9ffc03ae9b6"
      ]
    },
    {
      "cluster_id": "d76d71cb-517d-47c2-8ed2-a260ceec7c7c",
      "members": [
        "f3ddd2b0-3e39-4f9e-8999-561d992acc38"
      ]
    },
    {
      "cluster_id": "dd01fe5a-45fc-4f73-94e4-2d244f396aa4",
      "members": [
        "92e61383-3536-4054-8579-a904018b2e01"
      ]
    },
    {
      "cluster_id": "b270ac4b-0013-48c8-8b62-49d992310a4e",
      "members": [
        "d4814cc2-fa4f-4b64-b524-fbfaf55aac53"
      ]
    },
    {
      "cluster_id": "15b25c11-ec21-460c-ad6a-670c9cb77249",
      "members": [
        "c9b9ea97-f8e6-4d40-bb74-fc1ddbb5ea9b"
      ]
    },
    {
      "cluster_id": "65ce1b56-2de9-4e86-a4bc-a0777c097c60",
      "members": [
        "829d31db-8aa2-40cc-9c88-773a9efc3573"
      ]
    },
    {
      "cluster_id": "768c2664-8354-4bfc-8b47-96eb4e08e0ee",
      "members": [
        "c038129f-6a7c-4d41-b509-5fbbde62f12d",
        "f5272df2-6a70-4641-aa53-d3ac1bfc97e4"
      ]
    },
    {
      "cluster_id": "04e520d6-ffc4-485d-b6f9-73b32b9e56e3",
      "members": [
        "c4ec41ee-edc2-4e97-8286-6ebf940f58a5"
      ]
    },
    {
      "cluster_id": "a2b34554-85cc-4429-8668-e4a20bf0d860",
      "members": [
        "482f123e-5c2e-4384-8d1e-b1cf8956ddab"
      ]
    },
    {
      "cluster_id": "974fea38-71aa-4887-8998-28e03cf7c1b0",
      "members": [
        "1dc762ef-2efe-452d-b773-d99eb32c7cec"
      ]
    },
    {
      "cluster_id": "0ed8b02e-9110-4797-abfa-1c73f2dafe4e",
      "members": [
        "cc7a9342-86ad-4560-8aad-fdee3a57eb19"
      ]
    },
    {
      "cluster_id": "b85d6c69-8e92-437b-87b3-200c9509883f",
      "members": [
        "639887f4-84bc-4417-b01b-6cab4248b8af"
      ]
    },
    {
      "cluster_id": "44d2e850-7a7c-430d-95ed-40c5cabf8096",
      "members": [
        "860f708b-df74-45ba-a4c1-de5320b64832"
      ]
    },
    {
      "cluster_id": "43836beb-3651-49f1-a0f8-ad3c4daaab70",
      "members": [
        "cc943ea3-351c-42c4-814b-690a63727907",
        "455b2dd1-c3a1-474a-ab22-e9dfcad0d66d",
        "605516b3-6350-4af2-a2a4-0e5e03f786c8",
        "8386101e-8dd9-40ee-915f-daeafeaccb37",
        "51c91a8f-836d-4f3e-aa83-115580b2e75a",
        "16bef4ff-b6fc-49ed-9739-8e7b0eeb5d41",
        "4b78b22b-a78b-429d-ad70-d88d304eb04d"
      ]
    },
    {
      "cluster_id": "bdc4ffb8-404a-4799-a92b-88d77e6c445d",
      "members": [
        "9ea199bf-97ff-446a-ade3-676524ef8e19",
        "3d69889f-6ef2-476c-82e0-6a27979e1cf6"
      ]
    },
    {
      "cluster_id": "e136ae61-7689-4d72-a14e-2120e6260be2",
      "members": [
        "6ee2c4a5-b657-4d1c-9444-ffcf3cf9fd89"
      ]
    },
    {
      "cluster_id": "999e57b5-71fd-4f69-ac79-5d89ae8e3c67",
      "members": [
        "4ac88c8b-a6ca-479c-8ef1-3ec6317c887a"
      ]
    },
    {
      "cluster_id": "d64cb1f8-2dc5-4222-88a6-8bc5208a2f30",
      "members": [
        "4ded304a-7c7a-4b94-b613-5b71b1cd02af"
      ]
    },
    {
      "cluster_id": "2f4a9e86-aaa1-4911-a5a8-85e77f2e4012",
      "members": [
        "674d7e77-a807-4bcb-b2f0-db7fd01b99dc"
      ]
    },
    {
      "cluster_id": "fae4a05b-8c8a-4da0-ae56-97672bb4bbb7",
      "members": [
        "f9f91961-5933-45e4-a97a-0833538d7593"
      ]
    },
    {
      "cluster_id": "75366cd6-61ed-4e55-93f0-d40cb0af777b",
      "members": [
        "58f8bc90-56c1-4f8d-8932-e115eb1eb493"
      ]
    },
    {
      "cluster_id": "adb05a60-b0e1-4623-b55a-6fea056e1f65",
      "members": [
        "8eaf0a96-0a0d-4ce1-91c1-5dddff9ddc32"
      ]
    },
    {
      "cluster_id": "78d5de97-f7ee-44e0-8fbc-dba1797c97c4",
      "members": [
        "035c0704-fde6-402a-bd64-295dcc5ab480"
      ]
    },
    {
      "cluster_id": "19360eb5-62d9-45d5-b2f6-b66b7fee7414",
      "members": [
        "00a36aae-c5bb-448e-ab16-0395d0b70515"
      ]
    },
    {
      "cluster_id": "c317865e-d1be-4abc-b1b5-dece44444a1b",
      "members": [
        "bd2cfaed-5d7a-4929-beb3-86245cd1c054"
      ]
    },
    {
      "cluster_id": "050d87c2-4ac3-4e0e-8673-b4a44b43bac0",
      "members": [
        "64d50dc5-383a-4f9d-80be-93d978bdc313",
        "7870243e-8aad-4f25-8742-7767ce72c40c",
        "148b32a4-73c6-4d27-b7da-71b2c9563b4d"
      ]
    },
    {
      "cluster_id": "59a2b2e2-fda5-435b-a046-bc1854ba1410",
      "members": [
        "87fa4685-aa79-4eed-b5cb-50f8aef33b49"
      ]
    },
    {
      "cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f",
      "members": [
        "768dac8b-d8e9-4bcb-97f6-1ed7eb45ef31",
        "9bc2ab0f-ee95-4230-bd19-8f3d5b1383d7",
        "04fa843d-c467-42fc-a11b-e2b4e326fd6d",
        "d46d0c0f-98c6-4033-a3bc-33944da10810",
        "32c704e2-9110-47ed-84c7-df34341bc74e",
        "cb791cbb-0911-4b8e-97a7-752b4d22f599",
        "9e1f9fe9-4b99-4e49-b766-2b7dad31a05b",
        "9ba195c6-1326-42c5-960c-19e7c8042ded"
      ]
    },
    {
      "cluster_id": "8cc0b8bd-92ac-4909-9ef3-f1df52b9f0f4",
      "members": [
        "6c0852dc-908f-4e43-8e65-b39c0a942d84"
      ]
    },
    {
      "cluster_id": "b07f3d2b-07c7-4378-8e98-619949a67d5a",
      "members": [
        "28477e2e-b2d0-4bea-aa09-8f91c8ed2caf"
      ]
    },
    {
      "cluster_id": "eac47a08-6ad5-4405-8bfb-82ab701b0507",
      "members": [
        "363e93cb-9979-4571-81a4-9becd07d7e1b"
      ]
    },
    {
      "cluster_id": "1d45606c-718c-493d-8ad2-e61d4af0180a",
      "members": [
        "14394b9e-6ed0-474f-8195-ae45ad8886e8"
      ]
    },
    {
      "cluster_id": "67852dd4-618d-4a28-8987-e12077575820",
      "members": [
        "9f75fed9-5379-4ae5-ad35-29573d717166",
        "942337db-4b80-4c5e-a142-04a5dc2df92c"
      ]
    },
    {
      "cluster_id": "d0dc34ca-6f25-427d-a56e-1d4f3210e605",
      "members": [
        "a865b697-9c11-451c-b357-6deb59025afe",
        "6d5a827c-ea0b-42ce-a5a8-4c2933dddc23"
      ]
    },
    {
      "cluster_id": "21a0cca0-78e3-4e0b-95d4-e1b42b08be47",
      "members": [
        "6bb25525-db36-48fa-928f-3c54ff5192b7"
      ]
    },
    {
      "cluster_id": "f996f072-3b37-4e7f-900c-1cc05e40fa72",
      "members": [
        "557f5241-833b-4d75-bd17-d5e083a9c848",
        "e9f9a540-7ab3-4dad-a019-1dadae170d43",
        "8b7cc9a0-f571-42d3-844c-77499a7cada5"
      ]
    },
    {
      "cluster_id": "5b55251a-6617-459a-a1fb-c10dc23dfbc7",
      "members": [
        "3aa14a59-17e4-4777-8e1d-8ae3f9be02bb"
      ]
    },
    {
      "cluster_id": "a2e35d24-76f3-4ea6-99d1-6a5176010a02",
      "members": [
        "1197b256-f2e7-4f92-8cd6-82ff67958352"
      ]
    },
    {
      "cluster_id": "352c9b63-ad06-4659-b8a6-286e7a80ff49",
      "members": [
        "7c7d2966-8267-4911-af9c-12c9f638b50a"
      ]
    },
    {
      "cluster_id": "5a3236fa-e7d1-4fa1-bcc8-0cc89c18d852",
      "members": [
        "48aa818f-0004-46f4-b264-5cf6bfd86d44"
      ]
    },
    {
      "cluster_id": "f1fd6338-9958-4c6d-8d13-636315f421f2",
      "members": [
        "c3652003-e9b3-4858-9187-97009a81a649"
      ]
    },
    {
      "cluster_id": "e216b0a7-0193-4a30-a076-a872f378296d",
      "members": [
        "7d8c806e-235f-4780-b922-e4b749fe7829"
      ]
    },
    {
      "cluster_id": "4da30c02-5a8f-4e15-af9d-b0a7ede85a55",
      "members": [
        "507f1d48-65d3-4331-b334-74205ccc9cf6",
        "4b57f24f-9d8f-4e66-b607-5cbf5a7f73ee",
        "4680599f-6612-48bd-85c1-987e66f1852a"
      ]
    },
    {
      "cluster_id": "fd9d96be-26f0-47fc-a5ef-aa9e5e5ddf13",
      "members": [
        "be24cc5d-48a1-4fd2-98b6-c84005b2eb5a",
        "62b46015-1ee6-4431-af95-060d712b7892"
      ]
    },
    {
      "cluster_id": "fe911735-6fb7-4737-bc2c-bfe7c0b05844",
      "members": [
        "d79c60ce-8f4c-4997-83e8-d17fafb90523"
      ]
    },
    {
      "cluster_id": "eec253c7-dea4-4bc8-94cd-e84946c84d8f",
      "members": [
        "1738a518-ba07-4ca3-9eca-d29ea746b6ce"
      ]
    },
    {
      "cluster_id": "c5a49990-0bec-49b9-8797-00d71805007a",
      "members": [
        "308fd4d8-6903-4d8c-b2a4-0fbaee4b4fe2",
        "c3a9c214-92d4-48cd-a33c-f2855651a9cc",
        "26bcea85-340a-4926-a72e-f5166eb39426"
      ]
    },
    {
      "cluster_id": "02063354-1cf2-4e4e-a749-ce91914994ae",
      "members": [
        "7448f12b-9dc9-42a3-b6de-962a71c7ed57",
        "58e8eec0-3b18-4176-8e32-256e25f75ccf",
        "6a4bbd14-52cc-407c-a5f9-92ee77c8a044"
      ]
    },
    {
      "cluster_id": "028c83e2-81b7-4016-ad11-5ab7dddf6569",
      "members": [
        "1f06b3d0-c786-4d72-9b93-21be62274d4a"
      ]
    },
    {
      "cluster_id": "60f1920a-6809-46d7-8c57-4dab4cfa8642",
      "members": [
        "4d8ec00f-12c2-4a55-8fe4-02c2c73feb6c"
      ]
    },
    {
      "cluster_id": "c9770c33-6591-4102-923f-7ca010384410",
      "members": [
        "0fdaa2f0-ec41-4eeb-874c-df6ef607bdd9",
        "87f10262-b62a-4311-a7c5-9dd935e92d24"
      ]
    },
    {
      "cluster_id": "270b9be6-37c3-4ab7-9763-57943d7a38b9",
      "members": [
        "8197d19e-eceb-4bfe-aba8-d6ddc8230219",
        "2bb42626-d925-4aff-a4e7-1c28444704c5",
        "6f110a73-018f-47fd-9d6c-f95e95b1b2af",
        "93c996d4-1901-4294-800a-e38c0d1eb1c3",
        "f82b7bce-3fa4-4d11-b057-f19740ff07bf",
        "055e26f4-de2a-481c-8228-76083549ff72"
      ]
    },
    {
      "cluster_id": "d2dbc116-d919-422e-b972-f5d26fbf7db6",
      "members": [
        "a6af24d1-f9dc-483c-a4d8-a6f50fa7b678"
      ]
    },
    {
      "cluster_id": "5d300e72-624c-4bf7-b8e9-c1b1c8bb5c1b",
      "members": [
        "55fab3e5-ba46-4262-ae1c-d37882c30805",
        "dc0244e3-143a-4b9f-a10d-0fb551669113"
      ]
    },
    {
      "cluster_id": "269ffe65-bf3c-4500-8f51-b6ef7e6175ed",
      "members": [
        "4c787be9-0d63-4d4d-bade-049a1d973e67"
      ]
    },
    {
      "cluster_id": "58160b77-275a-49fd-b4ad-b9a4e0aa40ef",
      "members": [
        "fe136853-4ebb-4ed7-a1c3-5bea298e90e1",
        "89b9c035-3efa-46e8-8eaa-18f76dbcf1a8",
        "40d37e86-1ea3-4247-b129-3142707eb05a",
        "c4938d22-e6a5-4ada-bc6d-52b2c6e18343",
        "227d7b44-4791-4e82-aca0-1a384e087533"
      ]
    },
    {
      "cluster_id": "72084673-8080-44fd-8f5b-97507abf262b",
      "members": [
        "24221e44-62c5-4978-8daf-953b9cb01868",
        "fa2956eb-d0cb-4e35-ae43-0fb364f44bb6",
        "b850f381-8f21-4d77-aaf7-601540816ff9",
        "7187e3aa-5b53-414b-90e5-9921cf9ae4bb"
      ]
    },
    {
      "cluster_id": "38be1a05-48d2-4f48-88ba-580b1bbdcf47",
      "members": [
        "e2efe459-f5bf-48f4-aabb-d2614f71c39a"
      ]
    },
    {
      "cluster_id": "baac2920-a8d6-4667-acc5-460b63889a7e",
      "members": [
        "ebb90c43-c681-4398-a1a7-f903b4292d05"
      ]
    },
    {
      "cluster_id": "41c769d8-9945-446f-ae71-144928242d0e",
      "members": [
        "bbc04673-2959-4bfd-9506-96a313508f38"
      ]
    },
    {
      "cluster_id": "cba3863d-9ffc-4647-831b-d4da84c689e3",
      "members": [
        "b5c8ae6a-2bf6-428b-8893-ae8ae103b4e3",
        "b324b72e-88e6-43e0-b030-70c39eb247b5"
      ]
    },
    {
      "cluster_id": "b454bfa6-3d84-4f22-a166-5f84ce0bf756",
      "members": [
        "7413dd57-157d-4e44-a9c9-ba040174c5c7",
        "2ae1a6a2-00dc-4716-8f58-ba4af4a22dfb"
      ]
    },
    {
      "cluster_id": "bd7f57f5-8509-4e66-a8cb-a0ca1f9115a2",
      "members": [
        "40f46eaa-714a-47d4-9a53-3e4de1e79681",
        "aff81321-a0f3-4580-8bcf-752f4e09fcf5"
      ]
    },
    {
      "cluster_id": "b25f50a2-6e79-4624-b63a-fcc433c2ee8b",
      "members": [
        "045f7b0d-d4a4-4285-9a62-8dabd3dae61c"
      ]
    },
    {
      "cluster_id": "f2b7ea2e-02cf-4061-b076-60c350522e8d",
      "members": [
        "d8ac564c-5a0f-499d-86a5-8f9917a9bfb8",
        "ec463ac8-abae-4db1-81f0-eada054532f4",
        "2d9d5a49-133f-4abc-9974-c9e6da8ea584"
      ]
    },
    {
      "cluster_id": "57d96007-f80d-4110-8583-3e280492b584",
      "members": [
        "2157720a-b31f-4765-9e5f-abe16965d54a",
        "82f84f21-f75a-48ff-ae8a-b54bdf66ef25",
        "aebfeb31-a7cc-40f5-85e1-ab17a9a81027",
        "5e7bee19-fa7d-4e24-b0f3-a535a59d61c9",
        "bf2df80d-2a61-4e41-a0d7-dc5f45bf0de5",
        "cc9da660-3aa5-478b-a33f-f2375ea97c0d",
        "7f00fee7-1728-4445-912d-7de5fff1b210",
        "8cb31e1c-ec7e-45e0-9991-a1721f0650c9",
        "2911afdc-2774-462b-bd60-f60cf44428a5",
        "3daaf72f-9ed4-4402-bbfa-caa34aea8145",
        "5bfee9de-e52b-47bc-9df0-6f7f5bcf7057",
        "23af19b4-6fa3-4db4-aed8-de51c0424a7d"
      ]
    },
    {
      "cluster_id": "33ed63b5-316c-47cd-80fa-2cb71259f8eb",
      "members": [
        "c63f59c1-d72b-41e4-a08e-84a2f41ddfe5"
      ]
    },
    {
      "cluster_id": "b41760af-aaf8-4d45-b87f-633ebbf009f9",
      "members": [
        "3c1df8b6-9533-4c62-a317-a807afa5c317"
      ]
    },
    {
      "cluster_id": "425c03b2-a548-4c2e-a981-8c6f7789018e",
      "members": [
        "b80a6589-2541-416c-a08b-60e2d631e5e3"
      ]
    },
    {
      "cluster_id": "e13e1cb5-f52c-406f-a55a-701cb19f5226",
      "members": [
        "66670a2a-cbbd-44a6-82ca-4421126b801f"
      ]
    },
    {
      "cluster_id": "08d02125-b1b5-40ee-8104-05de8b37f965",
      "members": [
        "90b7bf11-a8f9-4fa2-98e3-a4dc0f9f14e9"
      ]
    },
    {
      "cluster_id": "8979de81-d14e-4323-ad09-17f46a1f718d",
      "members": [
        "b02e365e-b224-47a8-a9f6-af76ca7fc5de"
      ]
    },
    {
      "cluster_id": "2fd99adc-b7aa-49ec-b4ae-d4607788e329",
      "members": [
        "b30d79c6-5159-4996-b79a-7752d1373f4f"
      ]
    },
    {
      "cluster_id": "0b109e58-1cde-4c32-aed4-12ba82ed273a",
      "members": [
        "8f1395d8-01e0-4fab-89cd-d4455bc695bf",
        "53e5fac3-f3b9-4170-acb1-fa39f2caaa62",
        "b57e910d-73c4-4c97-91e3-7dd5f2fb6804",
        "fca78f43-297e-48a9-989c-20b2fe4e6e7e"
      ]
    },
    {
      "cluster_id": "f5bdb13c-8dca-44f0-8aa1-f75785f668e5",
      "members": [
        "c69fc9cd-d7d3-40ed-9c06-f6d6ec253b4d"
      ]
    },
    {
      "cluster_id": "7a48cda2-7a7d-48c6-9ef2-e5b111d87d7c",
      "members": [
        "298d23b5-afbb-4e93-8cac-5e76326f04b6"
      ]
    },
    {
      "cluster_id": "ab04829a-0137-4a23-b438-5c3602157062",
      "members": [
        "8b5a5f1a-b189-4ee1-a515-8f9cfff8233f"
      ]
    },
    {
      "cluster_id": "54d73329-0451-4bab-a86d-4ce16b809e91",
      "members": [
        "1bb5060b-06f9-4023-b08d-f341eb37296f"
      ]
    },
    {
      "cluster_id": "0c6f8f11-1c81-417d-bf01-df519f70e0fa",
      "members": [
        "7e545939-4ee8-40a2-9ae5-81e97f25288f",
        "c7e229b8-8c07-4814-a24f-77bed644174e"
      ]
    },
    {
      "cluster_id": "f24d06ae-13b1-4550-a06c-444a9041ab60",
      "members": [
        "eb0c521c-32dd-465b-9fe0-cf36781f6670",
        "8aa157bf-ab31-4e25-b3ed-663d0cba705e"
      ]
    },
    {
      "cluster_id": "20dbcfed-6463-4ba7-98e9-93b565b2719b",
      "members": [
        "a7d10e01-e281-4f96-a0fa-8dadd3bed992",
        "b1753787-75a4-4d77-980e-1cdd9b70c499"
      ]
    },
    {
      "cluster_id": "0947f9bf-7d2a-4b27-95a6-09e765742c84",
      "members": [
        "1c3ecb4f-819d-4245-a521-b26ef8088f65"
      ]
    },
    {
      "cluster_id": "0af6351b-04c5-4f0a-8360-02d15acb3d1c",
      "members": [
        "56776a04-155a-40b6-a503-9bea56d3cf42"
      ]
    },
    {
      "cluster_id": "60cef9d1-8d47-44f3-9820-0cdbe57600fb",
      "members": [
        "538f9251-4ba8-4d69-b12f-d9bcb8131631"
      ]
    },
    {
      "cluster_id": "49bf0c40-75dc-453d-aa4a-9a6c01b9dda1",
      "members": [
        "03d8bffd-1eb9-4588-8236-62839cb3cb49"
      ]
    },
    {
      "cluster_id": "9d38e0bf-2876-4c73-84e8-54044be3ef3d",
      "members": [
        "aaf575f9-f8ae-402f-9662-f4eb4217d6ee"
      ]
    },
    {
      "cluster_id": "6f48a68c-7726-4316-a5e6-f406ee7e1e95",
      "members": [
        "f1abfe62-d77e-4798-bf5e-a3939e34fdf1"
      ]
    },
    {
      "cluster_id": "f44c0680-07c7-4ea0-8054-7643f1b8eafd",
      "members": [
        "7598cb80-2cc0-4862-a471-68163a62bb1f",
        "e227fb02-66b2-46f4-8ff0-3ba31e2db4da",
        "cecdd572-0e9c-408c-a648-d24aebebc4a5"
      ]
    },
    {
      "cluster_id": "a9c08567-c779-4007-8ddb-2cc8e3429124",
      "members": [
        "4296771e-b956-4ba7-8671-013491e18853",
        "4f074f04-ff3f-4ca6-9b9f-456a41c79af3",
        "c3b4ae9e-b56b-4724-80ab-d5e8fd58f441",
        "7c0734d6-bcfb-43f1-85bd-4153220ebf66",
        "7dd0ca0a-15bf-40aa-9e2e-e18040f7de76",
        "3280a9e5-4f53-42df-97d6-80dfad2b3a63"
      ]
    },
    {
      "cluster_id": "54ebfb05-46bf-4d56-ade3-1d656b85cfb2",
      "members": [
        "871e41ff-6e5a-4f51-928d-541f50c7ff7f"
      ]
    },
    {
      "cluster_id": "21b4b954-5140-43e2-bd9b-c8ab79b3e70c",
      "members": [
        "65983e1e-7638-476f-8f5a-1fd47c0c31f7",
        "d44634d9-fe38-4821-82b8-1de3a6e41525",
        "a5930607-f04e-48b2-b3e8-851792a5f598",
        "a19c2453-fafa-48af-ac55-4b1a5f1a3abb",
        "c42c06b6-0c72-404c-b1e1-a6ea887ab989"
      ]
    },
    {
      "cluster_id": "5f698021-f0a7-4748-8344-6112bbe0b66e",
      "members": [
        "db00dd7f-a5ca-45af-87c3-d65662ede0a0"
      ]
    },
    {
      "cluster_id": "a71276bb-c498-4f7f-840a-9e20eea63e3d",
      "members": [
        "cfa4b03e-f0df-4958-baeb-631c2383e698"
      ]
    },
    {
      "cluster_id": "d1f35128-46aa-4b3e-8942-ed03c647bdc7",
      "members": [
        "d416ff45-9044-4499-bd89-65cfc821de7e",
        "cfefb447-4f9b-46cc-b663-96d20f429d34",
        "2ff61d65-2058-42e1-806a-8af448124f72"
      ]
    },
    {
      "cluster_id": "9d8ee527-fdd4-4b2b-bd2c-0ad4ce6caf15",
      "members": [
        "ea68acd3-5234-4bf1-90b6-a175d94d0636"
      ]
    },
    {
      "cluster_id": "eafeed04-4e89-4efc-a2ef-31ce78091f99",
      "members": [
        "04b78e68-7272-4b89-a850-e0751f938c15"
      ]
    },
    {
      "cluster_id": "5afcd855-48b3-4e16-bfa6-1ae369574bba",
      "members": [
        "86b443f9-597c-4943-aa25-1e4de477c1d8"
      ]
    },
    {
      "cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed",
      "members": [
        "a58b9b09-ff37-4144-b39c-50af1b458f87",
        "b2c6dfe5-3e31-4b12-9fe6-1c1b13e8ba63",
        "5a9a532b-3469-4108-a503-a8dee755d225",
        "1f4fadc4-9fc6-4b18-b2df-9e047f2a73a0",
        "1b3983ea-9696-44d9-aa99-cf3a210e7702",
        "feb14c4e-cb39-4bfd-a31d-85ca5fbf9507",
        "17c3c702-8396-4f43-ab42-57b0cf289a97",
        "e1d1489b-8379-4150-be47-22d283933756",
        "e8a190db-bcc2-4cc0-8eb7-44c244f670d8",
        "877e3f58-d245-4528-8d53-9ba2a6a0f325",
        "1c5866c2-1adf-4b31-a7e0-d2983c3c0093",
        "73fa5f57-e48d-4a11-a85f-c6d43d487450",
        "a8656049-fc1b-42f8-a23c-d74e20da9f6f",
        "8cbfae15-d083-4bb6-b577-bef32055b97c"
      ]
    },
    {
      "cluster_id": "a11d2091-08fe-4a3c-ae90-66e1118f2ac4",
      "members": [
        "98d47805-4cd7-4731-8c6b-fef8bc38b147"
      ]
    },
    {
      "cluster_id": "fc5c504b-230e-408e-a170-afd09cbd04d4",
      "members": [
        "7f893751-008b-436b-bfd8-1ab6e0dd153a"
      ]
    },
    {
      "cluster_id": "b7c9de19-8b29-40c8-92af-4119566c8604",
      "members": [
        "5744aada-6d04-4c83-b188-e9ab637f2c37"
      ]
    },
    {
      "cluster_id": "4ecf3311-91d6-4f18-a13a-b2646404483d",
      "members": [
        "712ba18f-602d-464e-a145-9155d6ab150d"
      ]
    },
    {
      "cluster_id": "138a4a3b-db1f-4c6f-b320-65bc4e554e6f",
      "members": [
        "b9def34b-f479-47c6-bfbd-c090b718f4cc"
      ]
    },
    {
      "cluster_id": "8a4a4131-add5-4367-8ccd-215684fa73dc",
      "members": [
        "8af7630a-888f-429b-8d22-a888b3422656",
        "f218e618-b7a6-435a-9b95-d4d9450acaa2",
        "0f127d4d-6f8f-4773-a3e2-fa45c536924c",
        "9880c14a-51e5-458d-a588-7777014cd037",
        "2282d388-5b26-4bde-89a8-b928c9b17599"
      ]
    },
    {
      "cluster_id": "77e0e128-878a-417f-8723-91873f114032",
      "members": [
        "1d06b6ad-1c83-4e67-ad6e-27c1f6201f6a"
      ]
    },
    {
      "cluster_id": "d415aa76-63ab-4b87-94b6-7d753e952a6a",
      "members": [
        "4e2bfcc6-057a-45c2-bc22-5f22eb478b96"
      ]
    },
    {
      "cluster_id": "dd4670c3-7e44-4c76-a7d9-373ad6cb6c50",
      "members": [
        "1dd98959-def5-4e70-aaed-6ffb79b0a02c",
        "65f32e56-cec4-40c8-a0d4-a1b7f6d34a3f"
      ]
    },
    {
      "cluster_id": "7c8877ae-f397-490e-9778-67a6e91ebe1c",
      "members": [
        "0d979bf2-cdbb-4ec7-bf27-6837e71f1b0f",
        "16158f34-8015-44f8-a7dc-0e8a0536b905",
        "a6b9ab6f-d230-4c51-9ca7-4e9937d5f5f6",
        "72c161a4-0fe8-4234-98fd-234cda651549",
        "40301d4d-b88e-43bc-b381-d74e42463371",
        "0a4165e4-da8d-4eda-b1fd-dd6020c834e2",
        "74f394ba-ef3f-4ccd-8648-fc87425f5bc4"
      ]
    },
    {
      "cluster_id": "75c3bddb-8c4a-4274-ab4c-3cc28aeb2126",
      "members": [
        "05c2fb4c-ae68-4663-861c-bbe293f5090b"
      ]
    },
    {
      "cluster_id": "9164197b-fffd-43a5-9a7a-407af1a26959",
      "members": [
        "01e3cd24-74cd-4d13-8d26-bc216d1beebe"
      ]
    },
    {
      "cluster_id": "4c6cef5a-0fb7-4222-87ca-9b217e095be3",
      "members": [
        "5dd8dff5-0130-4958-a9a7-9187ecb8464a"
      ]
    },
    {
      "cluster_id": "f5bf5358-6837-4934-ac62-9ad98735b162",
      "members": [
        "d22b2d07-e729-43c3-bd3d-ae9c221521cf"
      ]
    },
    {
      "cluster_id": "0795fae9-e716-4cba-98f8-5f27537dcd6b",
      "members": [
        "a915f3d1-92f2-4b83-9953-3e6ca65ded90"
      ]
    },
    {
      "cluster_id": "28e348f7-86c8-4ff9-8b99-eb8b6c73b1bf",
      "members": [
        "c59ccbdb-f1d2-47c7-9ec4-47d9f9c56636"
      ]
    },
    {
      "cluster_id": "21ef96d9-9c60-4110-9606-ce33a7d0a4f1",
      "members": [
        "ff0e2e4e-984a-4fef-b122-7b4aa3b38962"
      ]
    },
    {
      "cluster_id": "1f6ddbe7-8535-46e4-9237-74c4562367e1",
      "members": [
        "5b4e9f1d-68d8-4d32-a100-156509555dbd"
      ]
    },
    {
      "cluster_id": "0a7440da-026d-4b9e-86ae-aae908cc485e",
      "members": [
        "a805862a-118b-4af7-b9e4-4d70194d8057"
      ]
    },
    {
      "cluster_id": "7cf8a49b-ec7b-4a56-af2a-3a198e9863e9",
      "members": [
        "720d0741-1485-4c41-9b9e-03674f20e31a",
        "5ea46f6e-52b9-48b1-924d-c42581ba2e4f"
      ]
    },
    {
      "cluster_id": "e4d59809-92d5-4450-8181-b93bc5f5d348",
      "members": [
        "959df3ef-c111-4c09-9a7b-5c51b969ad13"
      ]
    },
    {
      "cluster_id": "7cd46da8-e046-45f9-87aa-b04395bcb25f",
      "members": [
        "8efe4067-cedc-49e6-beb8-83092672d3a5",
        "9d62ef5b-8cd6-418c-81fd-f90b01232f69"
      ]
    },
    {
      "cluster_id": "890e1bc7-85dc-4ae9-985a-8f81d088f89a",
      "members": [
        "bf90eb67-8da3-407c-899e-c20dcbec088e"
      ]
    },
    {
      "cluster_id": "4cbf95dd-29fa-442e-b9e9-93eb4878a93e",
      "members": [
        "3c765d9f-0405-4c43-bf03-a83048ccf162"
      ]
    },
    {
      "cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993",
      "members": [
        "88f9850f-41c4-4378-88a7-5102e569094f",
        "5a6d25c0-72b5-47d0-9a25-00a946e8ebce",
        "a2076eeb-7774-4162-8451-feb0f732fdba",
        "2824213e-2808-437e-bcd0-947ff4adac18",
        "7f37f4d7-bc29-424f-a2f8-a29fb67a93a4",
        "78b444af-b57d-412a-8a93-e25c216c3f78",
        "2f6e9d10-fec3-4bbe-9247-78c04ce554c5",
        "b55fb582-2646-4c5e-9bdf-fafa3084e7f7"
      ]
    },
    {
      "cluster_id": "e56fc955-148f-4ab7-9982-126189917297",
      "members": [
        "050ddb9e-c254-478d-8ffe-f8fdeabb33a5",
        "867498bb-0930-48be-8ea7-2ed4335eaca6"
      ]
    },
    {
      "cluster_id": "44663aba-7a2e-4439-ac72-295c1b77f6ca",
      "members": [
        "ec25c265-a8a3-44b8-9f5d-b63f1c3b884f"
      ]
    },
    {
      "cluster_id": "e4c9c7c5-e3e0-45e8-9f4d-644aa55e2107",
      "members": [
        "b7330117-f843-4dd9-ad4b-b81e578ca1d2",
        "1f2bc923-735d-43cb-b434-90a5ade6316e"
      ]
    },
    {
      "cluster_id": "60bb0c9e-70a1-4ee7-b0be-a6fdab4ba548",
      "members": [
        "c068ace4-0df2-40f5-afeb-0ee9d0d4a8a3",
        "4a1100bd-0d21-4a8e-a3be-dc65ae4acb3d",
        "856f5595-5f44-4c10-b3c7-71b79aeaf5c7"
      ]
    },
    {
      "cluster_id": "964aba3e-f62e-4ef6-b8f3-99237adf29ba",
      "members": [
        "852671f2-72e2-4c38-bbb7-7af113f7aaaf",
        "3d1e5490-2d11-4983-a889-245fb01aab25"
      ]
    },
    {
      "cluster_id": "3ef30c78-2900-4b45-bca9-f6701289533c",
      "members": [
        "3c9b6f82-65dc-45c5-a727-981f257afc22"
      ]
    },
    {
      "cluster_id": "e72c5c13-765f-4dae-aecd-48d78cd16ece",
      "members": [
        "e4787dfa-2075-49af-8f60-4b153d6860f5",
        "76ed06f1-f37a-465b-ae48-e100e8377a44"
      ]
    },
    {
      "cluster_id": "d21b19ea-6813-4e8b-8df5-e67ed7dfc0f9",
      "members": [
        "161d37ba-03e3-4b00-a4ff-9688a7a5c6b1"
      ]
    },
    {
      "cluster_id": "21916347-9bda-4844-a220-12a3c8d5bdd0",
      "members": [
        "99aacb30-8d04-4f24-ae70-df3b276e8586"
      ]
    },
    {
      "cluster_id": "6c41a4c1-08f4-483e-b095-97806b1140bf",
      "members": [
        "5730ba58-c479-44ef-8060-17afa3bd67ca"
      ]
    },
    {
      "cluster_id": "1337f10e-c559-4983-82e2-596f69e5c47a",
      "members": [
        "2107b5eb-6e43-490d-b9a3-b973d2ecd63f"
      ]
    },
    {
      "cluster_id": "230aa320-84d5-49f6-9755-fd2e7a1037ab",
      "members": [
        "aa8a5f4e-1d86-4f50-b032-f1a9eb3fd837"
      ]
    },
    {
      "cluster_id": "a362e63a-9f1e-4605-b063-7172229b335a",
      "members": [
        "46cfca21-6e5d-4cfe-8b41-0e72b801599e"
      ]
    },
    {
      "cluster_id": "3c66cbc4-f759-4da9-9813-b36b4c322970",
      "members": [
        "e7cba723-5ce7-41e0-9efe-ad11553b3672",
        "8653b865-d36c-4dbc-b92c-f6d7d328d961",
        "abe79f6a-6008-4d68-8b84-c8dd5a00e893",
        "f1e6c65f-d792-4cb8-9f39-7aafac76aea6",
        "e16f10a8-1336-4abc-8110-4dc43103f841",
        "eb7ccb5b-2c32-4340-b596-3de38645f97f"
      ]
    },
    {
      "cluster_id": "a7539db4-dfef-469c-b96d-9b13762fd242",
      "members": [
        "4de3e13e-8ea4-4d67-b5e3-4e4bfe4a3617"
      ]
    },
    {
      "cluster_id": "5e115001-bb2f-45b1-be83-78b8766bff77",
      "members": [
        "91c788f9-e420-4e6d-b7aa-f07ca5a1a9fe"
      ]
    },
    {
      "cluster_id": "ae87ce9d-8fb9-4394-9afe-202f1ec14722",
      "members": [
        "cda6e5ef-b9ea-4f23-89c9-4b8a87e4fa7b",
        "0c59c578-172e-4be5-b4ab-8cb8b1bee19b",
        "7f53f839-1dd0-4b87-a92f-8d56914df42d"
      ]
    },
    {
      "cluster_id": "8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35",
      "members": [
        "b803b996-630b-4f05-b3b6-339f78b7c70f",
        "88bcba6f-3141-4a39-87f2-94e0f38fa00a",
        "81465d6c-17c2-4277-a0cb-89b8c3188ee1"
      ]
    },
    {
      "cluster_id": "4c2902bb-5892-4765-99b2-69db31b95136",
      "members": [
        "eb69e2dd-44a4-48ed-a7c3-f4d6ab56fff7"
      ]
    },
    {
      "cluster_id": "93fb31b6-e8df-4e78-9be7-574ea4c2f86b",
      "members": [
        "dda020cb-61b1-45bb-9d7d-677b7eda4255"
      ]
    },
    {
      "cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4",
      "members": [
        "9606da73-a8c6-4443-a79c-78836db4e4f1",
        "ac0bbf2a-9912-4968-bfc5-af50067156d3",
        "51c347f2-e521-4dcb-ac82-57eae349c8e0",
        "43a97283-6531-4832-a402-4714ce15cac8",
        "59355c20-922b-44e1-b999-e928553d0cd8",
        "fa532d5e-b78d-4fda-84c6-75f04dc47f1a",
        "4f1874ce-1d5b-4a37-93b6-1081e371c585",
        "ad66ce12-8b29-4147-87b8-a08b32f20c00",
        "e5f0ac30-4bfe-4c41-80d1-ce405df9e260",
        "6ead3dde-bdab-43c9-b276-6f067caec9ef",
        "cc89de56-27d3-450f-8f22-dc03a546f2b7",
        "086e3440-20ae-47d7-8188-96798400bd40",
        "136883a7-9c80-4cdf-9acc-9cb220febd7f",
        "85042650-cdcd-42cf-a92b-e576ab04ba3c",
        "011a22da-0d5b-4885-a0b2-5f5f1cabb1f1",
        "1dd0b4ec-abd6-45d0-b7e9-4fa8a28c3461"
      ]
    },
    {
      "cluster_id": "08d6975b-643a-4b0e-a8cb-576006cbf125",
      "members": [
        "36f5302a-e74a-46d1-b5b0-8f4c1e418fef",
        "e1934800-b8b0-4559-889b-9c4513fb2b1b",
        "e1320b17-bca5-4b94-b771-f5701e3c47a3",
        "22c5464d-e954-45ee-870b-a2acd92f8c45"
      ]
    },
    {
      "cluster_id": "2420d848-9bcf-484f-a278-33ad97459cda",
      "members": [
        "84317b32-9768-4166-ad55-4761a28d3ac8"
      ]
    },
    {
      "cluster_id": "f4412fc5-966c-440c-829a-8ca0977913f0",
      "members": [
        "ed4ab4de-aac3-4757-add7-949e781db1b6",
        "e9d4c9ca-1b2f-418e-89f2-0bd5a5ab3b60"
      ]
    },
    {
      "cluster_id": "4e973d36-02eb-4b5c-bc20-63b35994dd87",
      "members": [
        "6dcc87dc-d2e1-4f7b-8285-ffd533b53b9b"
      ]
    },
    {
      "cluster_id": "ff3c71b1-9872-4a9b-a091-8300e856f9b9",
      "members": [
        "2331d7d0-913d-4b46-8447-0f81b55cb1f0"
      ]
    },
    {
      "cluster_id": "e2b19af5-6b63-47c0-a565-18520484a0a6",
      "members": [
        "4f1f0c64-1799-4bf9-a967-85e669866f8b"
      ]
    },
    {
      "cluster_id": "27494d31-7904-40f7-8554-6f6c04a0e92b",
      "members": [
        "0707cb89-2884-4686-83c6-9d85575d164d"
      ]
    },
    {
      "cluster_id": "9bfc8129-531e-4c98-b3c5-a6aa21e4674c",
      "members": [
        "977f9386-b21f-4059-92ba-0bcdf2e251f0"
      ]
    },
    {
      "cluster_id": "89a9391f-b100-4030-bab0-22344532ac00",
      "members": [
        "d374c1c5-661e-4f36-a173-c02bb705d5c0"
      ]
    },
    {
      "cluster_id": "74a8058f-9617-4020-8db9-456c0bc2deb9",
      "members": [
        "5879a899-c44a-4513-96d8-68524214fee4"
      ]
    },
    {
      "cluster_id": "c1c6d1f6-6fc4-4a8f-bdca-cd82345bf948",
      "members": [
        "2c94f3c8-2366-48cc-bc7b-7cf118c80621"
      ]
    },
    {
      "cluster_id": "b3a5dd46-4aa3-4884-9a77-ee986170d8d0",
      "members": [
        "5989c451-dfe0-430a-8257-bd4f4d152603"
      ]
    },
    {
      "cluster_id": "100607e4-097e-42a6-9233-9486abc1cf03",
      "members": [
        "fde9903f-3e01-4d9e-88b2-b36a0e29f568"
      ]
    },
    {
      "cluster_id": "dbfd0383-d4d3-4b5c-a820-54e5dc7d2adb",
      "members": [
        "74d79c55-b2dd-48dd-92c8-b4f3e8b9c05a"
      ]
    },
    {
      "cluster_id": "660ce2a3-2e3d-4961-a97c-865ff4c461f6",
      "members": [
        "12c64edc-5bb0-43cd-803b-893bccf7130c"
      ]
    },
    {
      "cluster_id": "03329c55-b9c0-4585-b5b1-817ec3b57899",
      "members": [
        "ddb12108-4ee7-4b41-9f71-e5f2ce89bd21"
      ]
    },
    {
      "cluster_id": "edbf77d5-b06d-4cb6-b6cf-9834f2f63e4c",
      "members": [
        "930d0ea6-3c45-418d-88d6-0511cd01d88e"
      ]
    },
    {
      "cluster_id": "3f77000e-b7d1-457b-963f-2743a0bda688",
      "members": [
        "3892ead7-6fb3-4fbb-9d2c-4f5ba492af26",
        "7a90859f-3959-4ce6-aac2-3e8c49a44d33",
        "43bd3e11-7f49-4856-aa33-d1602ac373d9",
        "e401473b-9e1d-4fef-bad6-dcf3195d6dd1"
      ]
    },
    {
      "cluster_id": "f43f98cd-cb16-421c-a639-6c526509bfd7",
      "members": [
        "971bef39-e25e-447b-8a04-28c6ac8f9b3a",
        "76f98aa0-ea7d-4a0b-93c5-9ce285cc19d0"
      ]
    },
    {
      "cluster_id": "6b8874c6-0560-4ffd-876b-6651821a5f10",
      "members": [
        "5a46004d-e039-45ce-8424-3b5024c29c72"
      ]
    },
    {
      "cluster_id": "7d3ca315-e2f1-442e-aa07-daf647abc039",
      "members": [
        "afe319fe-497d-4014-a28f-2ef0370ca5b1"
      ]
    },
    {
      "cluster_id": "ef1b2d86-739d-4342-9581-88b77e5ebe93",
      "members": [
        "ff78363e-86bf-44d1-80b4-366fb6fcd5a3"
      ]
    },
    {
      "cluster_id": "6f7f68fd-a840-40e2-a600-b19e0677f9c8",
      "members": [
        "ac1c347b-0422-4190-a91e-f118e3304387",
        "49257e18-1694-46bd-8535-894c014ad982",
        "84fe09cc-6641-4679-bf5d-a74ccb29a966",
        "61fdaa4e-3c09-452e-a4aa-012df78ccdcc"
      ]
    },
    {
      "cluster_id": "0656118b-9248-4fe1-a608-3abb014d1738",
      "members": [
        "8e22e8ab-95be-4a04-a8e8-56168661ba94"
      ]
    },
    {
      "cluster_id": "ebf6d20f-e452-48e5-b5e3-66d4779751ef",
      "members": [
        "7c82ab5c-af1e-4524-918a-44d55dc03f4b"
      ]
    },
    {
      "cluster_id": "5ec58447-e517-44c1-9394-8a5cf3cacde6",
      "members": [
        "f9982ced-7bf9-4aee-9566-6707fe08a315"
      ]
    },
    {
      "cluster_id": "30a748c7-0edb-4c1b-9472-d1b4ca3f8032",
      "members": [
        "312815af-6e45-44c2-92d5-7498545d87c1"
      ]
    },
    {
      "cluster_id": "6bf71f87-f205-4f8b-8249-8d960a41d7cc",
      "members": [
        "e4e75d3d-b6ca-4f6c-ae92-d8f6f3b8c92f"
      ]
    },
    {
      "cluster_id": "a29f6f46-43ef-4252-a308-d9b452074037",
      "members": [
        "ff23b9e8-7e77-4ecc-bd42-56730cdc555c"
      ]
    },
    {
      "cluster_id": "8191e288-4dd0-423e-bf77-953449ad8b80",
      "members": [
        "9c5bc019-b51b-429a-a892-504dbad1e62a"
      ]
    },
    {
      "cluster_id": "bc29966a-d588-4e80-8feb-dd96bcffea23",
      "members": [
        "ab2ad3a9-afec-43d7-ba87-b35694ddb345"
      ]
    },
    {
      "cluster_id": "16a78e87-1a7e-47fe-92e8-e8466b7bd20f",
      "members": [
        "370c7df3-223f-419c-81d1-734d1f0f1617"
      ]
    },
    {
      "cluster_id": "8451ff8b-752e-4535-872c-ebc9efc7b9cd",
      "members": [
        "e5aaa05a-c658-49d0-9c32-d5ee0631d853"
      ]
    },
    {
      "cluster_id": "35b669fa-cc15-4619-8262-2bd41f0ca610",
      "members": [
        "d9eafee5-2dab-4b8c-8840-234fecaf5047"
      ]
    },
    {
      "cluster_id": "c849043f-d317-458e-b56e-651b8d73a135",
      "members": [
        "30b3ee18-387c-41b6-8f4c-a6b8e2b1a1fb"
      ]
    },
    {
      "cluster_id": "45ef4556-631b-4297-8b2a-7cad68f3b517",
      "members": [
        "0f9b8ca1-b9e6-456e-b2cd-23b2bbda9fae"
      ]
    },
    {
      "cluster_id": "32363fbb-b809-46d2-baba-aad9f54a7b98",
      "members": [
        "cd0a2e04-a1f5-4dd0-b90f-1e9dc59bf122"
      ]
    },
    {
      "cluster_id": "dfe9b2aa-c1a4-44e1-97cf-0e0d2107befb",
      "members": [
        "e5f55024-d61f-4b4c-9bd6-c3bc739ba47d"
      ]
    },
    {
      "cluster_id": "5ad7a663-479d-4397-bbe4-c19607b95013",
      "members": [
        "0fd0ca94-0033-4c14-8ca8-780602fd419e"
      ]
    },
    {
      "cluster_id": "758c5e50-7f9a-4e26-9df7-02c7b0095788",
      "members": [
        "c7011f87-dfe4-405c-b47d-314e80fe1c8e"
      ]
    },
    {
      "cluster_id": "46233164-6ed4-4e93-aaed-ca823711dcc5",
      "members": [
        "cb952111-bc62-4180-901e-11bb11e441e0"
      ]
    },
    {
      "cluster_id": "36c07d65-523d-4b69-bf8b-7f1ec91d6954",
      "members": [
        "9dbdef61-bce6-476e-a310-53f87bb39f66"
      ]
    },
    {
      "cluster_id": "82c4576a-a59c-436d-bb23-2d15a1d9c903",
      "members": [
        "81c07683-95ea-46f6-90e9-fdc32370f511"
      ]
    },
    {
      "cluster_id": "265b7995-86ea-4269-bc72-cf439682655b",
      "members": [
        "e8f4d764-94e2-4c4a-b2b9-5356bdd53802"
      ]
    },
    {
      "cluster_id": "27cb0d3d-03d0-4c0b-8af4-dae39953059e",
      "members": [
        "ffd9187e-8061-4751-8bd5-480198de9d08",
        "f3e080a5-bdfc-4b11-aba5-8a1d672670be"
      ]
    },
    {
      "cluster_id": "50cf17ff-24f7-4dfd-958b-756aec4fd4e0",
      "members": [
        "0cf24c17-1136-4554-8780-9a4ab07761a4"
      ]
    },
    {
      "cluster_id": "f21f5e02-c7d3-439c-a7ce-450375c434a9",
      "members": [
        "6fc52d41-dc73-4780-b40d-2bc668e88f4a"
      ]
    },
    {
      "cluster_id": "4d323d7a-dea3-4fd2-9928-7ad3b9eb62fb",
      "members": [
        "3e978252-371b-41d2-8241-2e77a77b7ccd"
      ]
    },
    {
      "cluster_id": "820ef425-062e-4d05-87b0-a9e96fa7de31",
      "members": [
        "4f58034e-b5aa-4e77-a186-703865813663"
      ]
    },
    {
      "cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc",
      "members": [
        "1b09beb4-96ed-4fb4-b461-3ad2dc8ee74c",
        "e694a73b-cb53-4c33-9b40-f3f3dfcb771f",
        "8f5c4c1d-7b1a-4349-94b7-5266cd637e54",
        "ed2bf98c-6e1f-4d37-a55e-fdd5b175f958",
        "a364ab95-d103-44fe-9640-939150b981a0",
        "c44bb25c-c233-41fe-83da-332ae4cdc1f7",
        "4353f89a-0b97-4c7c-bad8-576dbaac73df",
        "f37a2456-cdc3-4b07-84d5-790cc7626871",
        "f3500725-a4ae-4a93-9216-9c911a39872f"
      ]
    },
    {
      "cluster_id": "f7b7014d-ad07-4661-9448-28c218c2eea5",
      "members": [
        "b2363639-5d44-418d-9673-4c7e709d3369"
      ]
    },
    {
      "cluster_id": "58559460-f665-4bbd-8f9e-95791e57f99a",
      "members": [
        "f0ef8168-b5db-4007-9161-282e7132d6ef"
      ]
    },
    {
      "cluster_id": "f50c160a-60a4-4be2-9f62-bc773e7ba48f",
      "members": [
        "0339315d-50ab-4e68-b9ac-4892ae9ff23b"
      ]
    },
    {
      "cluster_id": "e8195223-1d62-4704-93af-859b0cc35da8",
      "members": [
        "20530a04-956c-471e-a28a-f5f92470b5f8"
      ]
    },
    {
      "cluster_id": "57ce37d8-222f-4e0d-8fd8-04ee1ade37d4",
      "members": [
        "51a4924c-6fd8-4a57-81f7-141044a51459"
      ]
    },
    {
      "cluster_id": "45be894d-986a-43be-b81b-3a8308fba0de",
      "members": [
        "9c4c19b1-1821-4f4f-b004-963fa07a0f1c"
      ]
    },
    {
      "cluster_id": "72a5de9f-6386-4a16-880d-e374cb327abe",
      "members": [
        "30306750-7682-4b1c-9f3e-c1f7f931fb12"
      ]
    },
    {
      "cluster_id": "4cf9c43c-ceb0-4f7f-b2aa-9d4cf2879568",
      "members": [
        "bf60c867-f02b-4e06-b2c1-b53995c2ccd9",
        "3e9a99da-f898-444b-a509-71165ab12c8a"
      ]
    },
    {
      "cluster_id": "eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc",
      "members": [
        "853ec022-2633-424e-8070-53f10b976cd3",
        "e22f7c32-c0cc-4765-b07e-35e06535254b",
        "fa789686-f4ff-4769-afea-b7a090848d27",
        "9e56dab0-5cf4-45b0-ad60-275fc36209c8",
        "88bae962-c00b-49f9-b6d0-289953165ae8"
      ]
    },
    {
      "cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87",
      "members": [
        "acdb7680-494f-4145-a91e-cd4d9b5e56d1",
        "82532113-a968-4ea0-adb1-2e87cd0207dc",
        "31c3b00e-f900-4850-9e73-0223030754b4",
        "eea65218-f61a-4b52-b873-6be6bacaa67d",
        "15bad102-22bf-4306-9360-1f3c0adbfff3",
        "79db8dc4-4182-4930-a458-c1f0ecb32cd0",
        "e66d9fdb-3abd-4db8-96cc-31025be32b36",
        "7243f16f-cb06-42c4-abfa-ac76b287a6bf",
        "3effb45f-db2f-4404-8107-91ae40cfa171"
      ]
    },
    {
      "cluster_id": "c0ac6691-abf2-4873-a338-41a4997bcb24",
      "members": [
        "d584c3ea-5cb9-45d8-8efd-c3e473f0ccca",
        "c6852aab-9969-47b4-b03d-a5a8020adfe1",
        "e108f330-7ee6-4e7b-9705-ed42439e9dc7"
      ]
    },
    {
      "cluster_id": "2a0edc6f-16ff-496d-b79c-24bffd830324",
      "members": [
        "16ca3990-e457-4039-8559-8ecff8153cd8"
      ]
    },
    {
      "cluster_id": "1caeaded-5769-4cdd-b16d-b85f9a51e31c",
      "members": [
        "3558e28f-0f72-48b9-8286-981151d2baa1"
      ]
    },
    {
      "cluster_id": "78aa3214-a8d5-4987-ad02-0d4cd5db66f9",
      "members": [
        "22e6e242-2014-4f49-b17e-405825cad96f"
      ]
    },
    {
      "cluster_id": "7707109b-cc58-416a-9a9e-b9207b14baa6",
      "members": [
        "63ad495e-5acf-452f-8a88-e7061b051a88"
      ]
    },
    {
      "cluster_id": "cc7c4fde-e26b-4dc1-acbf-81128ce5d657",
      "members": [
        "79deae72-5646-4192-a308-236ab1bef5fc"
      ]
    },
    {
      "cluster_id": "1f7a4f93-ef7c-471e-9da0-10305825de04",
      "members": [
        "0305a8d5-e7b2-4fdd-bcd7-b0f71ec3ae48"
      ]
    },
    {
      "cluster_id": "30b7ce37-8fca-4fe2-b499-bda00e36d905",
      "members": [
        "b7315bb3-0703-4c94-a09b-a1e2db430679",
        "cc36a9db-6077-4ec9-adbe-c04f3ba9a177"
      ]
    },
    {
      "cluster_id": "664cfcc2-edf1-43a6-a432-be97b535188e",
      "members": [
        "61b2cd92-abf7-4dcf-bc51-7644c0a54e5f"
      ]
    },
    {
      "cluster_id": "083a8283-1aa3-4b94-9026-bbd5c3a07cbe",
      "members": [
        "e12ee799-3d50-4af8-a791-1c4bb686de2b",
        "ad594a92-20eb-4c2a-a4ca-27bfaca1bb08"
      ]
    },
    {
      "cluster_id": "a4dde064-8077-4a0c-97de-40075984b4cc",
      "members": [
        "d06a4c29-bb90-487d-98ff-88029fa06e0e"
      ]
    },
    {
      "cluster_id": "fffc483f-c841-4109-b9e1-d2ab5730fe2b",
      "members": [
        "66ccfe61-ae20-4550-b79d-81b156c8a6cb",
        "4d9423eb-b550-4953-a068-8ba49767718d"
      ]
    },
    {
      "cluster_id": "b4673d7c-55f8-410a-a73b-4f4fccae0549",
      "members": [
        "8bb1e2ba-a0bb-40a4-940b-848d74f29241"
      ]
    },
    {
      "cluster_id": "75e6960d-da7a-4d2f-8605-a94c9d2036f7",
      "members": [
        "85e3bb14-8ba3-4be5-bd50-f38e37acef59"
      ]
    },
    {
      "cluster_id": "1847bb18-db3f-4048-bbaa-0206cb032b77",
      "members": [
        "ed0cb860-80c7-4566-a16a-1b0c0d31aa0b"
      ]
    },
    {
      "cluster_id": "a74b8cc1-b628-4659-9793-8906816c7cde",
      "members": [
        "4813077d-e615-4b27-9b5b-b355712216fd"
      ]
    },
    {
      "cluster_id": "655ccaf5-6cf6-444d-a7a8-cb79a1480f69",
      "members": [
        "e12a081c-41ee-4ea4-9677-a64baf83b41b"
      ]
    },
    {
      "cluster_id": "70431f34-7e7b-4551-b35b-94e41cfb3c9a",
      "members": [
        "d76b65d4-41fc-4c3f-9acb-79c698179c29"
      ]
    },
    {
      "cluster_id": "7ce5da07-bfd4-4121-8e0d-acd582b0b4a4",
      "members": [
        "ca1e6bab-694c-481b-842c-66218837103e"
      ]
    },
    {
      "cluster_id": "9efa7058-0848-446b-a53c-deef9f0ad8fe",
      "members": [
        "44dab769-9a0b-477d-9ec2-b8feea0fb346"
      ]
    },
    {
      "cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef",
      "members": [
        "e3c62d58-3418-453a-b65c-853a482b6baf",
        "5a270b86-3ac0-429a-8fff-2627bc79785d",
        "72235e9f-d176-482b-963f-03bb21b928c3",
        "6c831974-50b7-4289-8441-92a6a7f94885",
        "afd7c698-e8d7-4547-9818-018bf39b410b",
        "886af67b-0325-41c9-9ed1-e0a1d01c8050",
        "98818f07-7366-4038-8c67-126e16ada268",
        "950d7990-be2c-4d4d-b8cd-183b3456afd1",
        "31614f66-df4b-4087-9b57-e5c04c5b8624",
        "a0867cc2-91c4-4201-923c-2d77c2076461",
        "cbce4f11-1d44-4416-a418-76bdd1b80270"
      ]
    },
    {
      "cluster_id": "c7bef51e-9aa9-4b77-85bc-5a1620f4b37e",
      "members": [
        "ba9d833c-6b5f-4977-907a-cd46f755300e"
      ]
    },
    {
      "cluster_id": "4f2d75d0-04f7-4815-a71c-1d8be3e7aa00",
      "members": [
        "f89e6ea3-65e3-4ff1-ba9b-2d25e57b0933"
      ]
    },
    {
      "cluster_id": "f10864eb-56bf-40a9-9f67-5dfe4ef70806",
      "members": [
        "2b26efa6-583b-41fc-88f0-91b856a9b861",
        "f5041c7d-5ced-42ef-b16b-265fff9faf50"
      ]
    },
    {
      "cluster_id": "745dc0ba-2e08-4d11-9168-0c12ad0b99a5",
      "members": [
        "f0db666b-0fd3-4f77-b06f-89c030b25d5c"
      ]
    },
    {
      "cluster_id": "0be4cdd7-0577-44ad-9263-d020c0d38b8c",
      "members": [
        "5e8d37c6-8703-44ad-b67d-f727f80c34d8"
      ]
    },
    {
      "cluster_id": "3b56c579-39c7-4dab-b918-56f22f3eec67",
      "members": [
        "6e4c5301-e3c3-4f6b-909d-23ea2b1309ac"
      ]
    },
    {
      "cluster_id": "05ef45a3-5005-462b-9419-1640ee24156a",
      "members": [
        "48a764fe-1d3f-4265-b2da-69a49b1d5369"
      ]
    },
    {
      "cluster_id": "003a7d07-44de-4091-ae03-27e916ffcfa5",
      "members": [
        "2c23f5f5-1fe8-4718-a592-39593387b290"
      ]
    },
    {
      "cluster_id": "c56b515a-2e70-4a48-b4c2-0cbda45aaedc",
      "members": [
        "d4643a72-fa01-41a9-9cbf-99356de06c6b"
      ]
    },
    {
      "cluster_id": "889e78e7-a427-42ef-b24d-0164df4f19bf",
      "members": [
        "a8863203-2f29-4df9-ae56-f28b95478ed0"
      ]
    },
    {
      "cluster_id": "fef7b3de-7af1-40a4-a0ec-544cb6b0b0ff",
      "members": [
        "165d15d9-4ec9-4579-9519-a7e05f6304ee"
      ]
    },
    {
      "cluster_id": "e02d4ab5-a57f-4bc5-991d-c6ce2c7dfc93",
      "members": [
        "3c719cdb-5047-46b4-a1d7-f8e44a60535b",
        "a386b6c1-9b1f-4ced-979d-9ae27b682204"
      ]
    },
    {
      "cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee",
      "members": [
        "c7afcae4-708e-49d8-8fd0-4dca5da09912",
        "6917898b-b050-4e24-b57f-67feaf1c1afe",
        "82382772-6dd8-4efc-ba22-7470418a4a77",
        "d77a013e-9d44-4c1a-932a-64582226c64c",
        "a835d36b-961c-4b8c-85bd-753a59738e3d",
        "9c8c09c1-4d07-42bb-9c2b-213321540a92",
        "ad2b7363-fc21-4dba-afa1-17fa408f20e2",
        "02d9bad7-3aef-4517-b713-67abd5cafc2d",
        "7f21b2c9-2821-4403-ac30-03ac46bc7bbb"
      ]
    },
    {
      "cluster_id": "8be17819-9c73-4351-af94-f5573c4b0d17",
      "members": [
        "0dbce223-9c3e-4379-a0d6-719aff826410"
      ]
    },
    {
      "cluster_id": "337fae10-d08a-4844-b763-fc332cdde523",
      "members": [
        "ed8db066-3572-46a8-98ff-01ad76662339"
      ]
    },
    {
      "cluster_id": "fe0af648-ca07-4de6-9db2-4c1067118254",
      "members": [
        "cd24668d-5a2d-4d25-9e4f-161f11611d13"
      ]
    },
    {
      "cluster_id": "54567e29-4033-493e-869f-078ef9153910",
      "members": [
        "5986747e-02d6-4ce7-aab0-db589195fba5",
        "563ca22b-cb1b-4ac2-8562-688154bbb566"
      ]
    },
    {
      "cluster_id": "3bf8d65a-8c84-4411-baf2-c3a55c8118b8",
      "members": [
        "3295240f-72b7-4247-9609-5e8312beadf4"
      ]
    },
    {
      "cluster_id": "8a30c746-b21f-4f8b-b1ab-389110f61293",
      "members": [
        "3698a301-7a64-46ef-9f95-c34dc5ed8181"
      ]
    },
    {
      "cluster_id": "f6b81252-d691-43eb-b603-bbd2ec2ea3c1",
      "members": [
        "18f82ef6-d088-4ea4-a1d8-2c2e76ae3a8c",
        "1a9a2509-178b-45b9-90b3-58c0c9cc178a"
      ]
    },
    {
      "cluster_id": "aeb7fb87-5c7f-4917-b661-3fe948376ad9",
      "members": [
        "129c65e8-0dfc-4fe2-92cd-7ba8bdd6b0ca"
      ]
    },
    {
      "cluster_id": "1bb2fbd1-906a-4d81-b23d-f6c0a4024661",
      "members": [
        "c5b2e942-0a09-4814-b808-5dcefeb3d5ee",
        "7fffa540-df86-4301-9664-fe0107c83f3a"
      ]
    },
    {
      "cluster_id": "61608de3-ac5a-4b10-bba7-1b5580f57caa",
      "members": [
        "a87bdeee-b360-4bb2-8cc6-3965afae1f9f"
      ]
    },
    {
      "cluster_id": "c95d237e-c855-46b9-95fd-6b8f66d537c6",
      "members": [
        "370b35db-401a-4dde-b9d8-be033b45ead1"
      ]
    },
    {
      "cluster_id": "a1084837-f12e-45c4-9bfb-1677ce1c51ad",
      "members": [
        "70d39cc1-17a3-4c78-868b-524525fee81f"
      ]
    },
    {
      "cluster_id": "781b12f4-b179-4668-8b0e-ea2f1da17240",
      "members": [
        "e19cdc91-b26c-4c06-af84-6bc813283f6f",
        "2f81a6c8-caec-47d3-b457-3dc88dbebb32"
      ]
    },
    {
      "cluster_id": "4a315717-0c5d-48f0-b376-1a12c3498c7c",
      "members": [
        "ff62d27d-55b2-45bd-a9ac-aaa477b9caab"
      ]
    },
    {
      "cluster_id": "d339acab-2e15-4ce1-8cff-20a1b2fc2811",
      "members": [
        "4eab83b6-6e27-46f1-bdc6-5cbc5609e5ef",
        "2635407d-4878-4b46-a0cc-e96df9241a26"
      ]
    },
    {
      "cluster_id": "cf4eccba-19e9-4f9a-984a-135d1c838ee6",
      "members": [
        "221a865f-71a5-4c68-80f7-d7234ebe441b"
      ]
    },
    {
      "cluster_id": "dbf82ccc-f0d2-4cf1-bdc7-044687b587cf",
      "members": [
        "8a7d0894-415e-4f16-b859-8f67461bc8e4"
      ]
    },
    {
      "cluster_id": "69fc2536-52ab-49eb-8743-9e6f9bfcc4f5",
      "members": [
        "edc2d296-1347-4472-9cd6-ee8b4ce94306"
      ]
    },
    {
      "cluster_id": "a99c031d-3fd7-4e53-9585-fd9ad40ad4d1",
      "members": [
        "f1781c7e-8053-4b57-a9c9-d07754f1449a"
      ]
    },
    {
      "cluster_id": "54db3169-8794-4675-bba8-d68dda1009e7",
      "members": [
        "c470d7a4-b30f-4401-9705-0d43de6cab4e"
      ]
    },
    {
      "cluster_id": "fcbaa14c-dec6-413c-9e80-6e8b3b617340",
      "members": [
        "58eaeb8a-7e9a-4fc8-bd33-f98733127de0"
      ]
    },
    {
      "cluster_id": "b105a78c-297b-4eaf-9891-43407b9d8073",
      "members": [
        "c1435856-a581-4c7f-b78c-d5da6430d59d"
      ]
    },
    {
      "cluster_id": "0450eb4e-f8b9-4b39-9c27-c75e30610c21",
      "members": [
        "7336bdd4-dcd5-495e-b819-17b1b8611550"
      ]
    },
    {
      "cluster_id": "7d4d7620-64de-4dcb-824e-188535febe26",
      "members": [
        "bff091f3-e410-47a5-a7df-00cebb8fc2ed"
      ]
    },
    {
      "cluster_id": "ee0681d9-e912-4091-8f01-0d69df3bcbee",
      "members": [
        "11630551-a0e1-4832-850e-eb02c61c8bfc"
      ]
    },
    {
      "cluster_id": "50cf77d2-56a8-4588-8c16-f417874c0063",
      "members": [
        "19fe6b07-9b6f-4e03-90dc-0d843bac14f6"
      ]
    },
    {
      "cluster_id": "7ecaa8a7-76e8-4332-a41f-2c347237e2a6",
      "members": [
        "3af86b28-8804-49b8-af9b-699fbba4dc69",
        "d1574709-ef45-4df4-9dd4-56dc36bcdc85"
      ]
    },
    {
      "cluster_id": "e10e77d8-6d39-499c-97ff-017e9cdbf650",
      "members": [
        "053e8850-c3b4-4cf3-8c98-02c7211e2065",
        "5dd26957-ac5f-49e5-9148-5b3ea159693b",
        "4f463dfc-a1b1-4a06-8341-3f8e5f3c168b",
        "83e49db4-0946-4b37-82e5-819ad7c0a1da"
      ]
    },
    {
      "cluster_id": "00ecc521-dbbb-417a-9961-132c4f488d88",
      "members": [
        "8378826f-6566-4850-b9ab-4aa8483aa62b"
      ]
    },
    {
      "cluster_id": "29fa8f23-676f-4f6e-888b-58fd11dbd236",
      "members": [
        "88546c51-205a-44c2-ba5a-e49e1affa8c9"
      ]
    },
    {
      "cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0",
      "members": [
        "97e0bbc0-1c97-4c2a-a768-23b1c5b6499d",
        "daa821fd-4236-4099-99dd-b7d11d6b3c21",
        "934e88c6-ea3a-405a-bc40-b792db0430c6",
        "8b0c8798-1366-4de3-9ac0-fa3e96f20c52",
        "2be83f52-f77c-4552-82c3-949839d95a0b",
        "74e64fca-287d-4d78-a676-00b2f615bdcf",
        "81ea0346-0d3c-46da-ae67-a4e4511295e1",
        "51c2ac4b-6155-4d68-9e60-c8a889ca9cf1",
        "9c4c835c-6721-41e1-bb6a-bdd9ff475b95"
      ]
    },
    {
      "cluster_id": "d140ee70-1c2e-44c9-b163-573b275b6b17",
      "members": [
        "e908c0ca-d2a7-4260-ab1e-04cdfa8e34cf",
        "d86e9609-77ec-4c34-b3f1-a779490eaedd"
      ]
    },
    {
      "cluster_id": "95799deb-0b6c-4eb9-bc15-24b196417c4d",
      "members": [
        "8dbf0918-8f32-4fab-b4f2-d214db9bbec0"
      ]
    },
    {
      "cluster_id": "9766dff3-64a6-4901-a68a-2702c328c3ac",
      "members": [
        "4599ab63-54f7-4a04-8f42-57009a6ae00d"
      ]
    },
    {
      "cluster_id": "0257bfac-c84e-478c-a7f4-6a03847d3df0",
      "members": [
        "0ab3b765-e365-4034-93ce-2f660110ff93"
      ]
    },
    {
      "cluster_id": "83ccf0a7-79d9-408a-a448-eb83f5e7d0d2",
      "members": [
        "bb69b414-1983-45be-910f-c2835efe19b9"
      ]
    },
    {
      "cluster_id": "ad32e47f-d132-47f0-8dd9-2751c477fa34",
      "members": [
        "1404893a-c0b2-4814-ab64-359e2c36b158"
      ]
    },
    {
      "cluster_id": "f9fcbf4e-cb96-4f3c-bad3-73737cdc4b3c",
      "members": [
        "2086e587-ce6e-4e06-9839-97ca25e372ba"
      ]
    },
    {
      "cluster_id": "9041e9b2-f334-48f3-86f9-79b1ba825b51",
      "members": [
        "78d710de-a906-4132-bb3a-d2c714abfdcb"
      ]
    },
    {
      "cluster_id": "ceb785f5-a630-41a5-8352-bf1ef25b04f9",
      "members": [
        "794f77f6-b8b0-4788-a6d2-c21ef39b677f"
      ]
    },
    {
      "cluster_id": "8498dac7-1f62-4d7f-a27c-61f5ecb321c3",
      "members": [
        "48de5f88-6848-4e7f-b7fe-44f843b58155"
      ]
    },
    {
      "cluster_id": "07c01120-e316-4bd2-9ebf-b979d08b4da8",
      "members": [
        "15006e59-2ab6-4689-b249-9373536c9841"
      ]
    },
    {
      "cluster_id": "9d377c51-15d9-43e8-b309-1b51ed3849a9",
      "members": [
        "183646ae-2ec7-4672-b2e4-ba7db495d1a4"
      ]
    },
    {
      "cluster_id": "074c64eb-8566-4f36-bf3a-fc5995c21e65",
      "members": [
        "4d8bff75-79ca-4497-8094-ddebeee2b85d"
      ]
    },
    {
      "cluster_id": "d3c16aa9-3593-44e3-b641-54f418736f76",
      "members": [
        "de34351e-1dc0-47f4-b575-148dbdb62792"
      ]
    },
    {
      "cluster_id": "c711195e-092a-41ee-984d-299705596d70",
      "members": [
        "8b4802a2-bf7e-4268-ba24-00b763e64ab1"
      ]
    },
    {
      "cluster_id": "8d52f35b-3806-4a30-b931-3dfcb56775fd",
      "members": [
        "6491f48d-4baf-45b9-82b2-7251833f7208"
      ]
    },
    {
      "cluster_id": "065f4f08-9205-4dff-8de0-542c6bb45da9",
      "members": [
        "9d9ce06a-8386-47b7-ae5d-017a2e744ce0"
      ]
    },
    {
      "cluster_id": "21d0c066-9264-468d-b96a-f5f007531508",
      "members": [
        "12c09e06-1f61-42e8-9e16-e01afda25148"
      ]
    },
    {
      "cluster_id": "7675ffec-ff62-4c58-a805-c5097a8fcd7e",
      "members": [
        "1be9d181-cdca-4b5c-9997-fba2dfa838b6"
      ]
    },
    {
      "cluster_id": "0f5915ad-4edd-49f6-8855-92a02e00debd",
      "members": [
        "8259ef14-361b-47dc-a04e-4a24e1594092",
        "37438bb9-ad89-4693-96ac-1f3e4de9e11c",
        "1873f9a5-f398-40e6-80cd-199506a5dd73",
        "36bae434-2756-408c-a259-d7ecb6730216"
      ]
    },
    {
      "cluster_id": "11663b2b-28c7-494e-973e-2fc5dca8374b",
      "members": [
        "1e35f35f-ebd5-4ba3-8a18-976b164195a8",
        "a7e5dcd6-f5cf-4787-8fcf-0e5969168051",
        "ff095616-4af7-4f55-b51e-7f432b40a233"
      ]
    },
    {
      "cluster_id": "5bae13a5-6b81-425d-a9bb-49850203205e",
      "members": [
        "71c8491e-9487-4a05-927c-953d05c4279a",
        "c80d4a05-71f3-4de0-99b0-46eefea2b55b",
        "6d09cef3-542a-4122-bce5-4ed42b20a35c",
        "73acaeeb-a18a-4e1f-aa58-d7ca76180f1e",
        "478e7f14-ad18-42c7-975d-dd83210d9522"
      ]
    },
    {
      "cluster_id": "b4f7c43a-b96f-4977-a6a9-ad07015e8976",
      "members": [
        "47fe2c82-b778-47ae-a05a-e4741259bb31",
        "1171ed03-4a86-4377-9b2a-9890e9c06a3b",
        "8ad4a51c-871e-4c4b-bacf-4514122bb946"
      ]
    },
    {
      "cluster_id": "8ef9691a-752f-475d-a3ef-753ff2032577",
      "members": [
        "1facc140-18cb-4bee-9e5c-073a9b6e2dc3"
      ]
    },
    {
      "cluster_id": "56c5d781-120e-4c38-ba12-676cecb63cc8",
      "members": [
        "9d6a225c-723a-4f8a-a9a9-d31582f4cdec"
      ]
    },
    {
      "cluster_id": "eb8c09b3-c22e-4c14-a55e-41e86bc54809",
      "members": [
        "44c83632-d3ba-44b3-8e8f-558ea7383cb3"
      ]
    },
    {
      "cluster_id": "05b6ff5d-2ddf-4b71-b6f6-98defb612c16",
      "members": [
        "eb9276c3-6b9a-45cb-bd9d-ce6001fe6860"
      ]
    },
    {
      "cluster_id": "0fa8aef0-deff-4ac5-a935-94011ed8be80",
      "members": [
        "ebe85d02-d260-458d-9fd8-a2eb30d8a874",
        "b899e414-1d1a-4e3f-9ad7-92dcb8567106"
      ]
    },
    {
      "cluster_id": "e0a8946b-f177-4ac9-88a3-5799d558da5c",
      "members": [
        "d65b82b8-3af6-47a7-b42d-b49325b3e69b"
      ]
    },
    {
      "cluster_id": "c7ff0720-041e-4548-8592-cfa24a2712c7",
      "members": [
        "b2aadc38-7271-443b-98b6-00461b5d6cf8"
      ]
    },
    {
      "cluster_id": "b687420f-e058-48a2-8c4c-4bc6f35624c2",
      "members": [
        "45de970a-321c-43c0-a66e-dfefc8535b91"
      ]
    },
    {
      "cluster_id": "5d32a56f-b7fc-4a53-885f-d83367218f7c",
      "members": [
        "cc83063d-de60-4c37-af8f-2a928fc78fc1"
      ]
    },
    {
      "cluster_id": "7186362f-7694-4259-bf65-9f7c8f813207",
      "members": [
        "854f3543-551f-4acd-a626-75d1a0990083"
      ]
    },
    {
      "cluster_id": "94a48846-dd13-4363-a56c-c51f47f2440a",
      "members": [
        "952612b4-1f77-44c3-a040-369786992f85"
      ]
    },
    {
      "cluster_id": "40978309-052c-4c0a-8f09-9f1d51e423d4",
      "members": [
        "f6b25295-4987-4865-950e-7ad582da48d9"
      ]
    },
    {
      "cluster_id": "8c990025-029a-4aef-bcf5-41326b6234ac",
      "members": [
        "8731915f-2d7c-4772-a3fb-2041138609ad"
      ]
    },
    {
      "cluster_id": "e0a1afab-5142-40ca-ad10-35061b0289f8",
      "members": [
        "11a7e18f-5da2-4c8f-bce2-78c9d221faef",
        "572cbeb6-e025-4c36-a959-9b84f9bac472"
      ]
    },
    {
      "cluster_id": "d9b500c1-45df-46d2-84a9-276291e99b35",
      "members": [
        "f533e2d1-5daf-4df0-98dd-6062d957663a"
      ]
    },
    {
      "cluster_id": "51ad5e06-f7b5-461b-bde3-00f8284ec903",
      "members": [
        "40b8c52d-0e05-47b8-92c4-7a51a2673401"
      ]
    },
    {
      "cluster_id": "6694e203-070f-4cf7-a327-66b5e005a5e4",
      "members": [
        "f2c53340-b5d5-447f-bfe1-81a987945b9f"
      ]
    },
    {
      "cluster_id": "29eddc16-8def-4acb-9488-5c09c0cd7216",
      "members": [
        "5bb3b610-aa82-4d4b-aee8-97d997396356"
      ]
    },
    {
      "cluster_id": "4edafa37-461a-4e41-b730-dd41cc60940c",
      "members": [
        "3311beac-ea56-47c7-b107-e24ced9d6551"
      ]
    },
    {
      "cluster_id": "159512ee-03be-4a2a-b7f9-1691ffdb67cc",
      "members": [
        "9dacf18f-a0da-40e1-83fd-d4819d3fab00"
      ]
    },
    {
      "cluster_id": "05babc1d-7e43-4754-b561-cd3371da4717",
      "members": [
        "271d8e72-d2e0-4b2a-bab4-8aad1c915ad7"
      ]
    },
    {
      "cluster_id": "7b83d10a-e2be-4730-b52d-6f8b8b917c91",
      "members": [
        "55aefe89-aa6e-4c04-a7a5-a635b73bd5de",
        "927daa80-8d17-4253-a012-2b0496609a1f"
      ]
    },
    {
      "cluster_id": "d5b4afb5-46e3-4fab-9511-72f4984164cb",
      "members": [
        "68c9b6e8-dc09-4d64-a8d7-c197c95877c3"
      ]
    },
    {
      "cluster_id": "ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d",
      "members": [
        "0ec1ded8-6576-460e-be9d-3b5b853d3b05",
        "0f392d94-957e-4115-bb27-f1428a1f5994",
        "0fd8c1ed-5782-4cd2-8018-81cc39b1f887",
        "2a98ff16-b946-4fcf-85bd-ccb288f0aa27",
        "53aaa877-b359-4b19-9eb8-87dcb20c91b8"
      ]
    },
    {
      "cluster_id": "bf2543e7-3701-40bf-a97c-164b45c21900",
      "members": [
        "0a8a26f2-5737-41b6-a719-b9c2adf6ee46"
      ]
    },
    {
      "cluster_id": "4722732e-36ea-4a20-b934-96b47f115eac",
      "members": [
        "9f6f6f31-0f13-4951-922f-005787192b55"
      ]
    },
    {
      "cluster_id": "f21fe246-03a7-43ce-b3fb-1decc7a9853e",
      "members": [
        "fa44083a-61f0-4701-bb91-19006e6597ec"
      ]
    },
    {
      "cluster_id": "2760cb6d-72ed-43f8-94f6-443f59d74437",
      "members": [
        "629575ca-5c65-4ca0-b7ca-58a497854762"
      ]
    },
    {
      "cluster_id": "6272f62e-bf00-43bc-ba48-d3f7c9c3ae02",
      "members": [
        "565e4399-de52-4508-9fd7-76f912ef3d00",
        "74d88a1b-8f1b-4a10-9f4a-d925b87902c6",
        "2327e9e9-0b9b-420b-b3be-0f9707fa55ec",
        "fe6dfd64-bbf2-4a17-895c-c6ae88b7ec89"
      ]
    },
    {
      "cluster_id": "1e56067f-4831-446b-a37b-b3b5e1d7166f",
      "members": [
        "5c67b5b9-d347-4c83-80e2-b45b0d5ec9b3"
      ]
    },
    {
      "cluster_id": "b32443a3-fa40-4637-9b55-e58ec8393ffe",
      "members": [
        "9685729a-b9db-4a49-a949-2afbb17fc9df"
      ]
    },
    {
      "cluster_id": "35df1ff6-45be-4230-aba5-19c41bc2020b",
      "members": [
        "8d9d41c6-da0f-401e-b936-f4807632bf31",
        "4b08a871-b579-4d32-970a-01cfa0688fa4"
      ]
    },
    {
      "cluster_id": "444282c8-5a59-483a-aa4f-acbf1655f118",
      "members": [
        "070deb89-5a21-450b-b8d1-72a1c7578939"
      ]
    },
    {
      "cluster_id": "c057a22e-5c5b-4db2-8c44-1bbafad4ea91",
      "members": [
        "f8d94d2b-829f-4f01-bfb7-58a292aee5a2"
      ]
    },
    {
      "cluster_id": "1d63f5ab-d2ec-4979-b939-ba16ea5a94d7",
      "members": [
        "071dbeb4-43d3-46f7-8d0b-56456f15f2bb"
      ]
    },
    {
      "cluster_id": "76d75a5b-4dc1-4bbe-8b14-04af1d297ada",
      "members": [
        "04a45d39-7beb-4f4f-bead-78db2d4b7c6c"
      ]
    },
    {
      "cluster_id": "ebe02d8b-ea82-4232-851f-f5ea26e54e8f",
      "members": [
        "39311e16-85f9-494a-bd0d-6c08537af9e0",
        "98ec7a74-249a-4a7d-bd29-61f25b29ccdb",
        "9a4ed516-ccae-4da8-9436-a0e39e489053"
      ]
    },
    {
      "cluster_id": "308a615f-ca1b-4ef9-9f68-b4e3d4d08711",
      "members": [
        "bc395992-d8db-4064-be79-0eca3f5dea93"
      ]
    },
    {
      "cluster_id": "40a69599-ced7-4b8f-b20e-fb9c99238bbb",
      "members": [
        "bf32c5da-6283-448d-8acb-44393b76d8a6"
      ]
    },
    {
      "cluster_id": "a0a19a10-55fb-482a-b96b-5df57df087a3",
      "members": [
        "68ee3726-92bd-4c45-947c-6b2f5d426fdc"
      ]
    },
    {
      "cluster_id": "010bfb3a-2b97-43f6-870c-f3dfb129b9df",
      "members": [
        "26ebec99-02a1-45a0-8717-5a3f6dbd0172",
        "b88a14bc-bc70-4f66-b011-56f47993a594"
      ]
    },
    {
      "cluster_id": "38bfd344-45fc-4c0a-8605-6354b8f22cb4",
      "members": [
        "cd83f40d-8334-4b57-9cd3-265c7647f9d5"
      ]
    },
    {
      "cluster_id": "3f7e49c1-3bca-42b1-a2c6-b96fb1443ba2",
      "members": [
        "c7b0be5d-d9a8-4a18-be17-7e886aa98900"
      ]
    },
    {
      "cluster_id": "93849a08-743b-4023-9ccb-ce323519297f",
      "members": [
        "2e14056b-ff7a-4e03-a1bf-ea1809a824f3"
      ]
    },
    {
      "cluster_id": "bbc6fef6-c552-409d-9152-d8abd3a15ae3",
      "members": [
        "e658e375-6c2f-4f15-9f9d-05a7f91f8865"
      ]
    },
    {
      "cluster_id": "773c7be2-511f-4315-b512-fcfb831f2cc3",
      "members": [
        "5672f72d-fdb3-40c3-a299-ccdace7d2199",
        "20b1fe96-adae-4346-97e2-6d250e59f29a"
      ]
    },
    {
      "cluster_id": "c77f0d47-36a0-4f9d-86dc-1f10b0aee675",
      "members": [
        "96b171d8-ea9d-45d2-a4ad-33902e09056a"
      ]
    },
    {
      "cluster_id": "b6c2d87e-7d9e-4ac3-a24f-6f394e994f13",
      "members": [
        "fa5a6b57-1a47-493a-a36b-3025a63eb5da"
      ]
    },
    {
      "cluster_id": "c367dcdd-b30e-4731-8d62-e633357c9a70",
      "members": [
        "42ce3983-1339-4c62-ad23-b361140f3706"
      ]
    },
    {
      "cluster_id": "815f7381-c3c0-4b84-8b7d-44fda735e36e",
      "members": [
        "632f8c9e-0c8d-40c2-8faa-2fa2e56e9f15"
      ]
    },
    {
      "cluster_id": "9d12c49f-ea33-4a41-83e1-0a953c37fd5e",
      "members": [
        "e52e5643-5b35-422e-a31c-76a074784133",
        "28fc4989-660b-4a74-adef-84b2073491a7"
      ]
    },
    {
      "cluster_id": "862e3561-6a46-4a47-8035-363b4e2c1786",
      "members": [
        "af84a2c0-20f1-445d-a47e-be722157f866"
      ]
    },
    {
      "cluster_id": "97ed4747-8726-498d-80cf-261756e7962a",
      "members": [
        "123862a1-b1a1-466b-89e8-98bd635fdfa0"
      ]
    },
    {
      "cluster_id": "1826eb0d-42e5-4b20-8a46-72b9e26a1dc6",
      "members": [
        "25eeb302-e32d-4093-9ccb-28a145392db1"
      ]
    },
    {
      "cluster_id": "4fe1a1d1-0c63-4497-8366-24cf2914a93f",
      "members": [
        "bce70684-d785-4f5d-8b34-b37d39ad4b8d"
      ]
    },
    {
      "cluster_id": "4f2403b6-f02f-46f5-a51a-edcea5995adb",
      "members": [
        "c347c984-61b9-4be7-9681-e09841c11eb9",
        "4c51a416-fe78-476b-805d-de1b3b9c0517",
        "e5d7503b-2f1f-4323-99c4-038ff15d4cce",
        "6d355a7b-b9d4-4acc-853e-dd80ef633109"
      ]
    },
    {
      "cluster_id": "21b62bf3-e16f-411a-a9aa-a2991cb252d2",
      "members": [
        "046ed115-be27-400a-9c8c-0cb80c6561c9"
      ]
    },
    {
      "cluster_id": "7bd525d0-ac48-4787-9774-a8b37c4ff4a9",
      "members": [
        "4aa20286-0f2d-4b59-bae1-e84853948865"
      ]
    },
    {
      "cluster_id": "fb4930fb-4b1e-4086-912b-c760c3b7850c",
      "members": [
        "0c97f7fb-82f0-4efe-b17a-2da2ba7482f6"
      ]
    },
    {
      "cluster_id": "bbb004ba-d35c-43eb-a8fb-f8fc936100c1",
      "members": [
        "119c8926-bea7-4ad3-b11e-636b958ad8c1"
      ]
    },
    {
      "cluster_id": "005d39b6-0b0e-4011-aaca-d596411fa607",
      "members": [
        "5333d473-984a-4b43-8d25-bf25f200d4a4"
      ]
    },
    {
      "cluster_id": "91e856d9-7ba0-4d4e-ae44-31db4386dcaa",
      "members": [
        "6a3e6b2f-8f3a-428c-afa4-84fc7d2d5fe1"
      ]
    },
    {
      "cluster_id": "3e87987a-c8cd-4616-922a-e297f103d0fa",
      "members": [
        "15cdcf77-2de5-4af8-a741-22b3b80db643",
        "abd88480-a561-41ac-9ac5-e3ff578e9f8a",
        "43003400-9f69-4899-b6b9-65d8858ef0a2"
      ]
    },
    {
      "cluster_id": "c9760dda-4208-40ee-a4e1-20fd95324ecd",
      "members": [
        "58780262-bc3b-4b04-961b-43d2e249fc68"
      ]
    },
    {
      "cluster_id": "7a0376f1-1a7b-4181-a413-d3bc6cd70242",
      "members": [
        "70c8b6e0-2edd-47f7-a604-ef58a468a3c7",
        "1a89a0c4-9240-40dc-97e5-5eb183d35328",
        "7429b626-2a70-48db-931e-9e7f6919e3b1",
        "b87164bf-f264-4ec3-bc7d-3b7891722a46",
        "db697b3c-4c20-4835-bfed-a2f70871c18a"
      ]
    },
    {
      "cluster_id": "7be54807-07de-4ad8-80e9-963285c4b2c3",
      "members": [
        "4624f61b-3248-4c50-94af-20616705fcde"
      ]
    },
    {
      "cluster_id": "9e93a133-57d5-49fc-821c-7ad0cab51a96",
      "members": [
        "a027dc7b-c9a7-4547-9440-45d1f7341f8b"
      ]
    },
    {
      "cluster_id": "a6896ca9-8851-4af3-bc86-04c953eef0ce",
      "members": [
        "2d75641d-f6d3-4c2c-9905-d28c78ee7d48"
      ]
    },
    {
      "cluster_id": "373b4029-0616-4e8c-84dd-67212ba62068",
      "members": [
        "efb8e062-80c6-4169-878c-cfe628f51ca3"
      ]
    },
    {
      "cluster_id": "4cdadb3d-d6d7-4b33-b2c9-1974e780d726",
      "members": [
        "a93d140c-7059-40a4-9fc7-f386305f99f1"
      ]
    },
    {
      "cluster_id": "7679c732-4d78-416d-a31b-b4d49c72f3ed",
      "members": [
        "861036e7-6c6d-431d-86cc-846f663b7514"
      ]
    },
    {
      "cluster_id": "81a59b64-1e50-4ead-afee-e08c8a24c430",
      "members": [
        "12a6998f-d040-4d06-899a-7db8d940defb"
      ]
    },
    {
      "cluster_id": "692b8f3b-7c78-4cbb-b4e5-764b2d4124bb",
      "members": [
        "993f1d99-f715-4c38-a1fe-58a206840121"
      ]
    },
    {
      "cluster_id": "054ed505-3504-4e27-9979-055c536c39eb",
      "members": [
        "8ec60233-7bae-41a9-80e9-b644a2146314"
      ]
    },
    {
      "cluster_id": "ec3b133b-630e-4f2b-834a-c8cbcc0a0e64",
      "members": [
        "3a6c93e6-3546-46ae-9c1b-18f087ae34c0"
      ]
    },
    {
      "cluster_id": "1ec0df43-8c4d-467b-94f6-ad15fb3c5b4a",
      "members": [
        "34b203bf-2d15-4e33-92ab-e2d68078324b"
      ]
    },
    {
      "cluster_id": "51648166-6ec3-46d9-a3d1-905adbb2ede9",
      "members": [
        "bd4c7672-0948-4f47-a723-25801c90c440"
      ]
    },
    {
      "cluster_id": "0f09675b-050c-4631-816f-5157cd231924",
      "members": [
        "ea2a43fb-c001-41f9-ac74-95a4e68619e1"
      ]
    },
    {
      "cluster_id": "2d3a5941-caeb-4957-af01-00f1d2fdf8e4",
      "members": [
        "af9b47f0-f78b-405a-813a-dc4f6e375e37"
      ]
    },
    {
      "cluster_id": "0621c61e-ad6e-41cd-8ff0-a60a7aa48a28",
      "members": [
        "8b0158bf-7d51-4aa1-ba16-ddd321c12f16"
      ]
    },
    {
      "cluster_id": "d5b448d9-eec8-4c71-b5f7-f99ea16eb286",
      "members": [
        "5537b25c-7236-4628-8260-1c0ab6cefa6e"
      ]
    },
    {
      "cluster_id": "1f13dc99-3c84-426e-b6fa-781deb8b786d",
      "members": [
        "64d50828-be74-4db2-bbf2-da64e9fa2f7d"
      ]
    },
    {
      "cluster_id": "728de5c6-3345-44e8-91f4-5ab1fb0c6670",
      "members": [
        "72044b8d-c4b4-4a59-80fc-c235b79789a5"
      ]
    },
    {
      "cluster_id": "30f48da9-bf4c-41d0-ae36-a76653721604",
      "members": [
        "4e688659-175b-45b5-95ad-46280a2e633c"
      ]
    },
    {
      "cluster_id": "fddafbe9-dffd-4341-9619-bfc6fc256b34",
      "members": [
        "c684ac85-415e-4d8e-9af0-8aeb612bd6c9"
      ]
    },
    {
      "cluster_id": "09414a95-a2b4-4ce4-a1a3-6b7980ec2cb5",
      "members": [
        "b4170d9c-3b72-465a-809d-171f28b7a66b"
      ]
    },
    {
      "cluster_id": "3dfd5a3b-6011-45c7-8661-03086fa25dc5",
      "members": [
        "6d750e2a-53c7-4e33-b3ad-f199faeee237"
      ]
    },
    {
      "cluster_id": "ef161e9b-6253-45b0-9c42-d8e3db87f120",
      "members": [
        "5ece7e1d-f751-433f-a23d-a8b8429783f9"
      ]
    },
    {
      "cluster_id": "8c441ed7-3996-46c2-abdc-191f54206cf6",
      "members": [
        "79853758-a1f1-4361-979e-67f91fdad3ab",
        "f959a15a-811c-4320-96e0-b3d0d9234415"
      ]
    },
    {
      "cluster_id": "c9ef551f-21d7-4986-8f7f-14a67206ac95",
      "members": [
        "ca6f1116-8965-4191-9f7a-2de14fbc69cd"
      ]
    },
    {
      "cluster_id": "add56d26-1f85-486a-b862-703a0d62439d",
      "members": [
        "ffda74a4-dbc9-407e-b330-796ec4986f62"
      ]
    },
    {
      "cluster_id": "97ff7137-390e-43dc-9ab5-05c730068c02",
      "members": [
        "0eac5b4f-7673-4393-8130-bd9ac9fe96d9"
      ]
    },
    {
      "cluster_id": "f16a1de1-a4da-445c-ac5b-035b9edb7fc3",
      "members": [
        "009f8b89-e667-4b4b-a5e4-d6dfa011918d"
      ]
    },
    {
      "cluster_id": "92c29e5b-570e-405e-92f0-4969ddf38528",
      "members": [
        "52ef3fd8-fb9b-4909-a130-323a330527e2"
      ]
    },
    {
      "cluster_id": "5787a927-39a0-4bb7-92d5-230091f48a3e",
      "members": [
        "939b5de3-dfc6-4646-8e79-a15b536f10d3"
      ]
    },
    {
      "cluster_id": "cd8525ab-90a4-434a-bf10-f887240219f2",
      "members": [
        "3fca1f99-4c3f-427d-9ab5-018b6b50369b",
        "160bc68d-b04c-4782-87e2-8818ed161340",
        "e8e9e296-5042-4c13-add8-a1aa37276d9f",
        "156ca787-e71d-40ea-95a2-7662712a1cf9",
        "214d4af3-d4fe-4edf-9b28-d410c6d5c5fa",
        "1f938813-1b69-450f-b8e9-54972ad22999",
        "5424fdea-3641-4e72-9221-e09f60ee8186",
        "02b65303-b664-4292-a713-a0a542d88621"
      ]
    },
    {
      "cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810",
      "members": [
        "6da95ac5-d396-43fa-bc70-0f96e1fd62e9",
        "eb813a15-f200-42e5-aaa7-c964a2b141b5",
        "d26e0e0c-97ed-4101-aa66-03799c71230f",
        "b05495fc-f92f-4944-b344-fb6bab4d2309",
        "e36d0b37-49fc-4dd8-bac5-bca15b1c8382",
        "4258cdeb-dc85-42d5-9bf0-ffb422d15786",
        "9091d87e-8a09-4f86-97b4-a3695200402b",
        "d8573a4e-9b56-470b-8c64-d08efb9b7470"
      ]
    },
    {
      "cluster_id": "ebf11375-1fd2-4e33-a82e-1889d6d8f85a",
      "members": [
        "0ea158f9-2cf9-4c14-943a-a6995d3d2c1e",
        "e3e465f6-cf05-42d8-a17d-575f69d2fefe",
        "a8b64150-84b7-4ad7-bdb1-c3756003b90a",
        "7d2c1726-d24b-411c-a5d2-91e783ff24e2"
      ]
    },
    {
      "cluster_id": "27c83a03-3f6f-4152-a678-12dc8e5912da",
      "members": [
        "57a76d29-9b46-4758-9cfa-c3502439191b"
      ]
    },
    {
      "cluster_id": "963c86c9-b5f1-4cd9-ac43-10cc5c0f5aa1",
      "members": [
        "74a92bfe-e7e2-4a17-96f3-977bd6c75971"
      ]
    },
    {
      "cluster_id": "b8f6ce4f-4115-477a-9fac-602b955a0de8",
      "members": [
        "3391df15-1751-44cb-ad85-ed274782fe12",
        "b41e6423-16f3-4b35-870c-1142dc824e7e"
      ]
    },
    {
      "cluster_id": "1c65b00f-4fc8-40b9-b323-8ff074f956ae",
      "members": [
        "99282d0d-b110-43d5-9e0d-5d05ffc5a116"
      ]
    },
    {
      "cluster_id": "31531356-3930-43a1-9c28-b7ad9753b67e",
      "members": [
        "e767a553-5fcb-4e12-b80e-2a3793afb03d"
      ]
    },
    {
      "cluster_id": "3582a60f-77c5-4a28-b692-e25a35716357",
      "members": [
        "593d53aa-de27-41d6-97e5-f1eb58f1f26e"
      ]
    },
    {
      "cluster_id": "da455fdd-d1bf-4166-b24f-377899985b7c",
      "members": [
        "8f58bdbd-80dc-42f6-9f33-f1c5cc88f715"
      ]
    },
    {
      "cluster_id": "88fadd59-b242-4ad4-ab5b-3465e7a2b5a6",
      "members": [
        "6a2c1a2d-6dae-481b-9511-8f7f6c41b31e"
      ]
    },
    {
      "cluster_id": "997b033a-0811-49fe-bc36-8ee742156833",
      "members": [
        "56e46f91-f578-424b-ac97-61bd4ad09dda"
      ]
    },
    {
      "cluster_id": "3bbfdf4b-7f9b-4300-9c99-cecf5843d988",
      "members": [
        "5f76fcd7-ca7d-4991-9748-23fdfb329e19"
      ]
    },
    {
      "cluster_id": "07b11e06-46ec-45e9-8f01-bc31083fd0de",
      "members": [
        "6f1f4db2-f7ad-4038-88b1-e49cb9941fd0",
        "e930d6e7-85d6-4421-a247-e19e17bfca63",
        "52e92dba-398a-4cc5-b309-93a582942749",
        "a53c344d-45d0-4daa-a4ea-f6e9b933e2f3",
        "7ceb8afa-28c7-4571-a76b-15da683cfcad"
      ]
    },
    {
      "cluster_id": "7df19845-e2c9-43df-ab08-20e640d2669c",
      "members": [
        "45d0fe49-586e-4392-aab0-6e2ee5485bc6"
      ]
    },
    {
      "cluster_id": "53949001-7a01-495c-8cfe-7d81bd307f6f",
      "members": [
        "db76db46-d82b-43b1-95f1-a3ed8ba63240"
      ]
    },
    {
      "cluster_id": "821d5bc2-820d-42b9-a931-b0991cb2d55a",
      "members": [
        "85210055-881e-4173-8e99-af2342aaa7f6"
      ]
    },
    {
      "cluster_id": "1ff366e5-31ba-464c-8544-3d84f99a75c6",
      "members": [
        "b4699b79-c057-434f-9ab8-3ed0ed11dd05",
        "5f01571b-6f20-48eb-a0f5-9bc528a2c9c7"
      ]
    },
    {
      "cluster_id": "a5de3945-d8b3-45a7-9c18-edeaa4ccf742",
      "members": [
        "c7652e57-3b50-4af6-a37e-e5141018e8db"
      ]
    },
    {
      "cluster_id": "edab64d5-5e0e-4c94-9892-79b39580b98e",
      "members": [
        "015d0d8a-b015-429a-ad12-eb03df372dd5"
      ]
    },
    {
      "cluster_id": "2d202c5c-9305-4705-93d0-1781607fb294",
      "members": [
        "96eb0004-956e-4d80-a84f-7200a1e0ad40"
      ]
    },
    {
      "cluster_id": "90c72bc2-1d1a-4a98-9edb-8381a34e2935",
      "members": [
        "196e5bb8-2507-4fea-9a34-465a3d1bbe5c"
      ]
    },
    {
      "cluster_id": "ef5dda09-a763-4471-8324-78da714107dc",
      "members": [
        "1a4a8584-a47f-491a-ac01-9a7df33ccd94"
      ]
    },
    {
      "cluster_id": "c0a9c99d-91fa-48ff-be0a-c6e00181d46d",
      "members": [
        "eb984b97-6ee7-479d-982d-52c0d85f4175"
      ]
    },
    {
      "cluster_id": "6c08edb9-0ade-407d-af97-cbc1278990ac",
      "members": [
        "13d812f3-4c7f-4860-8bd9-c7296bdb1d82"
      ]
    },
    {
      "cluster_id": "3efed4d3-9a2c-4fa8-bf3a-fb69d88128e8",
      "members": [
        "62ec7979-29e7-44f5-9061-97b8046f21dd"
      ]
    },
    {
      "cluster_id": "35eea677-5b27-4587-9764-95116cb6b83e",
      "members": [
        "46074779-fb4f-457a-9f85-8c4299875b73"
      ]
    },
    {
      "cluster_id": "971dde28-a3c6-404b-8a02-b24390ab3750",
      "members": [
        "0253ccf2-8231-4970-85c0-0d5faa424449"
      ]
    },
    {
      "cluster_id": "a3f777dd-158e-459c-ae69-5df160dfccf8",
      "members": [
        "7eef192a-a093-4a72-bede-19b3ea62ea63"
      ]
    },
    {
      "cluster_id": "1acc7240-f221-42ca-8a48-7f6a18f1f844",
      "members": [
        "16f49665-56cd-4020-a877-576647975e56"
      ]
    },
    {
      "cluster_id": "1a1fe423-28a9-476d-a154-c1e0960501dc",
      "members": [
        "d0593d90-01d0-4ea8-ab77-4bc3ab40d85e",
        "dcf249aa-c49d-42c1-8171-a26bac8be3d1"
      ]
    },
    {
      "cluster_id": "722dcdeb-8c69-4fc9-878a-87c7aaade27b",
      "members": [
        "78cf8df1-f528-484a-a227-ce2148453ea9"
      ]
    },
    {
      "cluster_id": "efe98b1b-e1ed-468a-9652-7acc5550430a",
      "members": [
        "7736b01d-9d52-4191-8649-3935b5d7e4c6",
        "7221df48-3d44-4760-a98b-ac22ba59da87",
        "e00401eb-37ca-4d71-a936-54f7c6dcfb52",
        "1d9be90d-be78-4031-accf-9126f8346c89",
        "177a8ead-2e4a-42b3-bd3a-431798790bde"
      ]
    },
    {
      "cluster_id": "909c2544-65ad-4eae-8bbb-f43d077750aa",
      "members": [
        "42ebe7bd-d97d-4f3e-bca0-87867d9d6902",
        "3f2cefbe-b919-486c-b195-695bd3725bcf"
      ]
    },
    {
      "cluster_id": "cf0c77f3-683e-467a-b83c-95b78a12d867",
      "members": [
        "2cc4fbb5-7e91-4eda-9477-41f4891308b9"
      ]
    },
    {
      "cluster_id": "48f8cfb0-8d27-4a6d-8530-ed9a63c77de6",
      "members": [
        "5d2cb133-194f-49c8-af45-598d4cbcec5a",
        "7236ad73-10dd-4424-8400-fcca0d46b21c",
        "21cd4a11-f1ba-46ec-a6dc-887af328374c",
        "5a1b9213-c394-4034-ad93-9f5c23db6c2c",
        "b2f75d73-126f-423c-acc9-5075c262d520",
        "1d886fb6-8166-4a0b-af08-e49f9b3409c4",
        "2d51f614-a53b-41b7-a05c-e314d3acff13",
        "10001215-1c6c-494d-b431-6dd94724db27",
        "4e7dce9c-6656-4866-afe0-55c31488e64b"
      ]
    },
    {
      "cluster_id": "edcb6d77-94bd-47fa-ac30-bd310a6e83e6",
      "members": [
        "cb8462d1-d7fa-4332-8219-7feef998001d"
      ]
    },
    {
      "cluster_id": "caa057e8-994e-43b8-803e-0ea0aeab7ec7",
      "members": [
        "7f66a7e6-69b0-4ed7-a76a-aba9aa79e5bc",
        "4dde4a46-a612-4bf1-b453-efe74073f1dd"
      ]
    },
    {
      "cluster_id": "90b17dac-ed93-4273-8df4-019652e30993",
      "members": [
        "0a63b17d-a0f7-4289-b7a2-009dcc402d58"
      ]
    },
    {
      "cluster_id": "ce5f39de-c868-4feb-8d91-20b21e8b8ded",
      "members": [
        "c8cf1924-4a5f-46c3-a9c4-ca0488053763"
      ]
    },
    {
      "cluster_id": "f51a6ac2-4516-4b4c-9fdb-e7e4932f790d",
      "members": [
        "21816fb2-338a-4b94-9ec9-1502305688e1"
      ]
    },
    {
      "cluster_id": "d895f911-9139-47dd-8018-79b66f8588dd",
      "members": [
        "5416a5bc-9aa0-4b41-ad0e-0c9d8e8a4c38"
      ]
    },
    {
      "cluster_id": "c2e5bef0-900b-4168-ac2b-5a5465221f87",
      "members": [
        "1c33447f-9b46-467a-b7f4-d907de6a50a4",
        "eae286d6-d908-4958-b808-2f866d9ef706",
        "09b43b1f-b2fe-4c1e-bf61-ae46aab54da1",
        "63271fe9-df41-4ee1-841b-3153cb7da6d5"
      ]
    },
    {
      "cluster_id": "e86748c4-2789-4941-b470-d29321693c17",
      "members": [
        "1fe462a1-82dd-4fab-bf7c-f7c9823fc4e0"
      ]
    },
    {
      "cluster_id": "2cf37935-88f0-4aab-94bf-6c7a6da78e48",
      "members": [
        "4e10ed8d-4010-4c28-89a7-fa16335d2a33",
        "b1456a7f-65ff-4e2b-8ece-58d52c4b4035"
      ]
    },
    {
      "cluster_id": "b3bb12a8-9e61-4051-99f7-b8946e7edc6e",
      "members": [
        "d9b8ccf2-fd23-4c83-8acb-d8ad5e5b68ee"
      ]
    },
    {
      "cluster_id": "bc3b9d73-137b-4059-890e-e7cbbf0bd7b2",
      "members": [
        "12cbac2e-c124-419b-bfba-8eb089e92750",
        "c6c11fec-cd76-4fb3-b134-d707839cb5b9",
        "8a253488-d483-41db-bd72-6b60bf09edb1"
      ]
    },
    {
      "cluster_id": "5e0be9c9-87ac-49bb-a807-6e19f719434d",
      "members": [
        "43d05f96-9246-4049-9c56-c446ceea2a7d"
      ]
    },
    {
      "cluster_id": "9bba558d-53eb-42ad-851e-623ab4e32bc6",
      "members": [
        "dfb7f452-6f07-44e5-93fc-19766ddf8227"
      ]
    },
    {
      "cluster_id": "9b0314ac-478d-4c92-b0c0-490018094349",
      "members": [
        "585b62e4-af3f-4f88-a85a-202d5611bf92"
      ]
    },
    {
      "cluster_id": "0867ca4e-1775-4423-92bf-6fc8d1d9c0e3",
      "members": [
        "06abf97f-1f34-46a7-858f-267e8104e7e5"
      ]
    },
    {
      "cluster_id": "7050c8c6-a172-4da4-a04e-a8f348b2d49c",
      "members": [
        "020eaf7c-6638-408a-a07f-be78f52769c1"
      ]
    },
    {
      "cluster_id": "9f394b1e-f3b6-4528-a71b-dd2fed1c81a5",
      "members": [
        "d04d7a00-5557-4055-b7ab-a0c7706180e8"
      ]
    },
    {
      "cluster_id": "abb6468b-1949-4a51-9adf-d3e014a3003b",
      "members": [
        "cae9d058-4b9f-4631-8d47-bd0a5ebce50a"
      ]
    },
    {
      "cluster_id": "a16d38f8-25ac-46b8-94d9-38eb77cacdcf",
      "members": [
        "8e0925f8-ca35-4b50-af54-c2a561cbd4f7",
        "db9b45e8-08c4-4897-8dfb-d16f1b07a985"
      ]
    },
    {
      "cluster_id": "9c71282b-fc72-4fb3-b7f8-7ff433782d1d",
      "members": [
        "7035f193-d0d8-4b29-9363-8b9997255920"
      ]
    },
    {
      "cluster_id": "38b77626-e120-4759-a3a5-dc826b3463bb",
      "members": [
        "dfcd5ada-9ea3-465b-ac6e-ad0cb35806d4"
      ]
    },
    {
      "cluster_id": "19f144a9-ec9c-4a9b-89c7-b1ca850240da",
      "members": [
        "e159d079-6ebd-4da8-b6f3-264cf95c3164"
      ]
    },
    {
      "cluster_id": "0f0ff324-b8f3-41db-88cd-a895d1f4a2d9",
      "members": [
        "27779f6e-b1d1-4cb1-b2fd-22465de74412"
      ]
    },
    {
      "cluster_id": "ccdd5d79-92b1-4503-a1ce-51ccf23fc823",
      "members": [
        "f6603684-e321-437b-beab-55794bdec1e6"
      ]
    },
    {
      "cluster_id": "4a7864ed-3fb7-4536-8df0-aadd1c453c8f",
      "members": [
        "50d18c7f-3a6a-42f9-924a-ddef9d67bc1f"
      ]
    },
    {
      "cluster_id": "35d3e890-e939-41bb-b28b-3ee99ba1783a",
      "members": [
        "7b152dcf-fc08-4a62-8dbc-17dc3c6ac19a"
      ]
    },
    {
      "cluster_id": "7370dfbb-74ea-4d34-82b7-9398b71ecd5a",
      "members": [
        "8f37c27b-d364-44d6-b01e-ce0ee74d8907",
        "c729b3a5-3286-4a46-a8c8-f4d99ec15d78",
        "5184abd3-903e-4c4a-b1ff-8197c81ef5af"
      ]
    },
    {
      "cluster_id": "9419d9bb-572a-4e79-aef7-f69f5e25eaa2",
      "members": [
        "ffb5ffce-b389-4d5d-bc1f-35c187f1ae5f"
      ]
    },
    {
      "cluster_id": "93c79f3e-8eab-4299-bf58-7b2b18493bd8",
      "members": [
        "61b6a234-6058-48af-9ace-0901a6a84064"
      ]
    },
    {
      "cluster_id": "55de19a2-d0de-4a1f-86be-06d3fbb117dd",
      "members": [
        "2a277377-d848-40da-9359-47a74c644917"
      ]
    },
    {
      "cluster_id": "13765e0a-ad43-430b-8852-bfa85832f876",
      "members": [
        "2c11a22a-4451-4ea2-b25b-6f8260f7cbb3"
      ]
    },
    {
      "cluster_id": "976b60d5-b934-4def-acec-d66f7c1f4346",
      "members": [
        "acb5312e-89e5-4784-9168-e6895d049d9c"
      ]
    },
    {
      "cluster_id": "8ef9df10-1de8-4f15-a1e9-2d90b8ed31e8",
      "members": [
        "52b9bf68-c607-4c69-8549-54c0506b97d6"
      ]
    },
    {
      "cluster_id": "11d3cdd7-b203-4792-91e4-e32314bbcbc2",
      "members": [
        "8b331ebe-6540-4df7-9b68-a56dab66f6e2",
        "a0455b45-eed1-47ed-84bf-d090b89b9897"
      ]
    },
    {
      "cluster_id": "f7cbf601-ad96-47af-b877-ba63e1376028",
      "members": [
        "4f148573-3f7c-4b23-ab56-b786a94fe1ff",
        "5a73da15-6a60-4dac-b227-76a076b0d384",
        "9f575cf0-b81e-4852-a51d-3cee646f2493",
        "07f7a1ed-d849-4bdc-b430-9b256fe4c083",
        "b172797b-ee7d-4a69-9af6-3a95726cb187",
        "9c004883-e27b-4fa4-85dc-6237f9c3f8b3"
      ]
    },
    {
      "cluster_id": "39f63165-e875-40a7-84ed-ae42699b5d21",
      "members": [
        "f167a6f0-9e3f-45c6-b6d4-bb10c3231b5c"
      ]
    },
    {
      "cluster_id": "5c607d5b-9632-4ec1-9939-05955e158cfd",
      "members": [
        "ced5d570-760d-413b-8f21-396ef27792cb"
      ]
    },
    {
      "cluster_id": "5014ba85-27bc-43f2-9c05-0160a5aa15c8",
      "members": [
        "64be78f6-4a3d-4c4f-b406-88deb69e8d5c"
      ]
    },
    {
      "cluster_id": "702c96ce-c667-4d06-adc3-0067ef68ea50",
      "members": [
        "dc80216c-cbb5-43e5-bc1e-0876557372d8"
      ]
    },
    {
      "cluster_id": "2bcfeb62-5d3f-441a-a60f-796550a52e9a",
      "members": [
        "5f9ee440-cbcd-4357-b3c6-47414dce7052"
      ]
    },
    {
      "cluster_id": "bda677c6-ab51-41f9-b0f0-3abc1ddda687",
      "members": [
        "5ec49e9a-2136-40d6-b6ea-0e88683b1cad"
      ]
    },
    {
      "cluster_id": "0d311305-9085-42d3-8548-48b9fa06ff66",
      "members": [
        "04cf0118-62e6-4b3e-8d62-c2c2f4182169"
      ]
    },
    {
      "cluster_id": "72796cab-1adb-4917-9d03-40c3dc952598",
      "members": [
        "e3189ef6-b119-49e3-afbc-0708491dd4dd"
      ]
    },
    {
      "cluster_id": "cac94e48-7ce8-4cff-8e2e-49f3f784f217",
      "members": [
        "18de34e3-72c0-4edc-9373-1b7213da3d0e"
      ]
    },
    {
      "cluster_id": "4ff57c09-958e-4a30-b35f-893da7a68a0a",
      "members": [
        "018d2f1a-a9c0-4dfe-8791-55e182f640b3"
      ]
    },
    {
      "cluster_id": "89092280-296c-4fb1-844a-03436e7b7c26",
      "members": [
        "794304a8-b4ab-4f2b-a488-53bcd4b14383"
      ]
    },
    {
      "cluster_id": "ee253c9f-7d80-4f50-99f1-722670916f95",
      "members": [
        "f4120b19-33c5-4df5-ae3f-cfcbe5523733"
      ]
    },
    {
      "cluster_id": "e53e2876-2718-4f35-b4a4-ab220a980fd2",
      "members": [
        "f0cf4498-cfb4-4250-916e-551d1f56027c"
      ]
    },
    {
      "cluster_id": "146f4299-6935-41c6-a1f2-cdd4079712f3",
      "members": [
        "33174958-b90e-4fc4-842b-245976472f54"
      ]
    },
    {
      "cluster_id": "5982b5d4-204d-410d-a74c-8426e91d2bd1",
      "members": [
        "fc91703a-e115-4756-abf5-e385f67fcfa4"
      ]
    },
    {
      "cluster_id": "2f690c44-ca18-4a31-a2b5-68ac60208360",
      "members": [
        "4db0a61c-539f-47d1-aa41-d61c371d389f",
        "8ca1d7aa-9e43-46fb-86f4-1a2ef994f80c",
        "ef36060f-f210-48b4-9102-ace7aa5d8b7d",
        "df02f620-4485-429f-8826-6f4ff9b9efaf"
      ]
    },
    {
      "cluster_id": "d735477d-2ee7-4e51-9aba-37176b8e5505",
      "members": [
        "fb4d2e98-e1a5-47cd-9b89-d6594993ba1a"
      ]
    },
    {
      "cluster_id": "3092d2a7-23cc-41c3-b8bd-3096963a1b79",
      "members": [
        "309bed94-5394-402c-a7c9-3341fbf38902",
        "92f66f72-43b4-497a-9e25-a38242dd5f57",
        "52d4258b-d46d-4011-b482-c6f84ea88c41"
      ]
    },
    {
      "cluster_id": "f62b3b08-7f29-4635-afdc-c0569af97743",
      "members": [
        "48cb2831-5726-4672-89cc-9915cc22036b"
      ]
    },
    {
      "cluster_id": "e2d48429-fbf6-47b6-9165-78445c0d3741",
      "members": [
        "e1dc75f3-2554-453f-8935-20d9fe70c69a"
      ]
    },
    {
      "cluster_id": "8995bbaa-d955-41cd-a920-b35b1fea2dc4",
      "members": [
        "49c6df3a-a2fa-4f8d-9ca8-3afc1db555d4"
      ]
    },
    {
      "cluster_id": "18485212-7b1e-457d-88c0-98b9b231ec0b",
      "members": [
        "f14ab467-fd64-4211-914b-af28c8a43039"
      ]
    },
    {
      "cluster_id": "35e49ef4-8290-45fe-a6cc-bdd77af41ebf",
      "members": [
        "57a6ef75-13f9-4589-a649-16cd436bdf59"
      ]
    },
    {
      "cluster_id": "3b0ef1f4-8ed3-49f5-bef1-e5534eb3da65",
      "members": [
        "056d5d02-f776-4514-9547-3c9fe23ddfa3"
      ]
    },
    {
      "cluster_id": "b4515840-1ee4-450a-89e4-256ed3a5260d",
      "members": [
        "3a2345a4-de53-4fe6-9211-ba1c526e0ff6"
      ]
    },
    {
      "cluster_id": "57ad4e9d-2e3b-4f99-a5b5-f89a9fbe7c81",
      "members": [
        "a3447ac8-e37f-41ee-a185-6f2f2caabe42"
      ]
    },
    {
      "cluster_id": "20324583-738f-4b71-89a8-1820cc1a827e",
      "members": [
        "24e3d945-c664-4acf-81f9-fa0c58e977fe"
      ]
    },
    {
      "cluster_id": "d976c975-a582-4fc7-bfd4-75e1c6617efb",
      "members": [
        "7741a1fa-a410-43e0-9b0c-055949c8a4b0"
      ]
    },
    {
      "cluster_id": "eaa2dbb7-40c0-4ebf-a0b3-5deddf646a17",
      "members": [
        "44dca193-2030-46c0-8d83-19daee4d948f"
      ]
    },
    {
      "cluster_id": "4f77ad08-1df2-43ea-b042-db804953dbcf",
      "members": [
        "6204584f-fec5-4528-8eac-f71c21153c81"
      ]
    },
    {
      "cluster_id": "3f03bd41-3bd2-497e-a6ae-2bf64a55fb55",
      "members": [
        "b9940263-75cd-473b-a824-3449476e51ae"
      ]
    },
    {
      "cluster_id": "ceb2f368-5934-45f6-bda4-01a19f923b7e",
      "members": [
        "1aa9e6b8-41b1-47c4-921c-a435660b1572"
      ]
    },
    {
      "cluster_id": "7c6d77d0-d878-49bf-a294-6d6456dfe66e",
      "members": [
        "efe9acbf-5c68-4535-b952-70577ca50625"
      ]
    },
    {
      "cluster_id": "2d39c2e2-591e-4b57-a739-0d6203a1a49f",
      "members": [
        "5f38c603-2dcd-4665-8bef-e094caef7a8e"
      ]
    },
    {
      "cluster_id": "5f8e4ee6-3418-4c1b-b296-a4a89ae25c1b",
      "members": [
        "a137848e-0579-44c3-a4a8-77c46f0ee531"
      ]
    },
    {
      "cluster_id": "49884f4f-86a8-42d4-b8a9-af42d91f50a2",
      "members": [
        "9b175709-e0ba-4408-aa1c-dfd76310493a"
      ]
    },
    {
      "cluster_id": "6a7bb883-6ee7-43ec-b992-6e755312804e",
      "members": [
        "efb4f986-fd6a-468b-aa17-c623424d1033"
      ]
    },
    {
      "cluster_id": "ef5b3681-b75b-471a-b383-e605cb2d8a70",
      "members": [
        "71e27d8d-0a62-4065-b6f0-754d4b25e80b"
      ]
    },
    {
      "cluster_id": "e8299254-b0bc-4a3f-86b2-fedfa746efb0",
      "members": [
        "6ef174a1-4126-4bc3-9713-f1aeaf969ec9",
        "3b01f3e9-0884-4056-9947-42c14ea3c2f3"
      ]
    },
    {
      "cluster_id": "a63f5d9a-cff2-4275-97b2-48d300df1ba7",
      "members": [
        "8b08fdbe-6074-461f-9420-8973568fec69",
        "c97c2a12-aae4-4eee-b04a-89da2678cf8e",
        "ef32505f-4b87-443f-980e-b5273bb66e97",
        "7573ffd4-3209-4f1b-a704-f3bf46faa2c9",
        "509cdd4a-32cf-46bf-9061-87fd383f6da6",
        "29f4ec77-37a2-4604-9bcc-2ce84dd4c238",
        "97cdfa22-5b79-4c43-8b73-b7397eabdb7f"
      ]
    },
    {
      "cluster_id": "45aa87a3-e21a-4aa8-8a63-439b67ce1a6b",
      "members": [
        "e06a7277-5f24-48fb-9c78-13c76be81e98"
      ]
    },
    {
      "cluster_id": "e7164e50-d6db-4c47-8686-c55d8dcb20f7",
      "members": [
        "099d05fd-55f3-40ef-beaa-1a522d6addf7"
      ]
    },
    {
      "cluster_id": "9e771d92-eea3-45ec-b1c4-e7bba0011301",
      "members": [
        "e350c53e-e396-41e1-817f-9304ad844ea9"
      ]
    },
    {
      "cluster_id": "a418885e-cbb2-4205-a118-ea8172eaff33",
      "members": [
        "3e432faf-9460-4d1b-a841-fbe9839fbcbd"
      ]
    },
    {
      "cluster_id": "46d65520-43a8-4278-8ef5-8956356cec61",
      "members": [
        "6995508b-5d89-4444-9304-cba0e41fae35"
      ]
    },
    {
      "cluster_id": "7e70d266-a12a-4562-93b6-0506f079359f",
      "members": [
        "1f26bf27-13ba-421b-9231-cf226ab52ad1"
      ]
    },
    {
      "cluster_id": "29bfbe48-82ec-4d12-8240-7206925d2386",
      "members": [
        "90bfad8f-ac37-4d23-981d-a31dffe2cb8c"
      ]
    },
    {
      "cluster_id": "4bf58da8-6849-40b7-a8ec-ddb3570d0f67",
      "members": [
        "c3b90585-ea0d-4a8a-8dd8-5970b472f13f"
      ]
    },
    {
      "cluster_id": "53d674a1-75eb-4a57-96a7-960a78dc2faf",
      "members": [
        "4b9f26b8-447d-4e58-930b-ba76b8681145"
      ]
    },
    {
      "cluster_id": "9af760e6-eb03-4959-a360-3cdeab7333f8",
      "members": [
        "f6f240d1-76eb-49ce-9de1-39ad685f1451"
      ]
    },
    {
      "cluster_id": "9cf8c4fc-8448-4503-a774-71dc4b331a69",
      "members": [
        "6a6acfc5-0af5-46ce-857a-e2904f2b9c4b"
      ]
    },
    {
      "cluster_id": "d9ddd310-7175-469a-9098-9a1bbbbc4809",
      "members": [
        "4cd90b44-31f1-4a01-909a-4d4270ab2c65"
      ]
    },
    {
      "cluster_id": "c1501799-71e8-405f-bf26-2801ae66dcf6",
      "members": [
        "5d67f516-3b5f-4d8e-89da-3d90721cd993"
      ]
    },
    {
      "cluster_id": "e7e91720-5f86-4e9b-b765-89e7169207fb",
      "members": [
        "ea09b041-c617-47d9-a76d-d81079f36fd8"
      ]
    },
    {
      "cluster_id": "dabb30c4-8940-4d2a-81d7-5e54195fcdf5",
      "members": [
        "9644246f-94cc-4458-8e14-564eb1d861e6"
      ]
    },
    {
      "cluster_id": "da81244a-ef78-429d-9f3d-b08a5c21a084",
      "members": [
        "3c0b8def-ab2d-45ba-94a6-da76f2b7dd29",
        "15aaf9a0-6288-49ed-8e08-6988a0f54955",
        "e09c49de-0aef-4b62-a700-bb102432743b",
        "50cb3fd3-25c4-48aa-8edf-a6d4c8f587b7",
        "f358d4c6-9a93-47fd-94b2-0195a51d308b"
      ]
    },
    {
      "cluster_id": "5ccc3e3f-7dc2-4f92-90f5-ef2c18f982fb",
      "members": [
        "d30e401a-ef55-4f7f-9712-cd9cf7cb7d88",
        "2102a9f4-f2ce-437a-9e8a-bf94b26d2e85"
      ]
    },
    {
      "cluster_id": "b5f72321-d879-4344-b131-82dc3d0c1704",
      "members": [
        "ac80f77a-57a3-47c8-922e-ed3cd647d0d5"
      ]
    },
    {
      "cluster_id": "349cfacb-551c-400e-8c1e-7b08765e6799",
      "members": [
        "671c1c28-dc15-477f-9030-30d9ad77a14e"
      ]
    },
    {
      "cluster_id": "7013bebd-c68a-4b31-9e63-8c86c5d8c784",
      "members": [
        "1f6fc9c1-12a1-4b1b-921e-9b373c2ef256"
      ]
    },
    {
      "cluster_id": "63114462-4942-4f84-9437-7c2bd611b2f3",
      "members": [
        "28952f14-1d58-4bc1-9a8e-f41ecbb4a101",
        "b643aa80-1674-4a44-bc83-91d9e5e86d80"
      ]
    },
    {
      "cluster_id": "c7968790-1b36-4325-9e94-aa1c52a513a9",
      "members": [
        "edab6fc1-799c-47f3-8cab-19addfc4e3e3"
      ]
    },
    {
      "cluster_id": "d53538f2-6557-4a35-adbb-a2eefd4e49a8",
      "members": [
        "1972c4cb-49be-4b10-a2ef-e3f2114602b8"
      ]
    },
    {
      "cluster_id": "01d5ac9b-578e-460b-921d-2d1cc5ecad34",
      "members": [
        "d0c21fa2-f9c2-40f1-a260-4a254df804f4",
        "dba5650a-2407-4da3-af31-96dc54bcb94e"
      ]
    },
    {
      "cluster_id": "cd4a5f4f-0722-49d0-a0a8-588c6f486479",
      "members": [
        "f1960d27-fd97-4804-b057-6f7e9205cd00"
      ]
    },
    {
      "cluster_id": "9babf1db-b81e-42d8-a506-b9ddc52bfb22",
      "members": [
        "729b965e-10e0-4396-a476-538b41bef3e6"
      ]
    },
    {
      "cluster_id": "22b52102-7c44-49d2-93e5-9785e4c6b4d0",
      "members": [
        "fd6c18d0-24fb-46be-a977-14bd1261a91c"
      ]
    },
    {
      "cluster_id": "cc789a67-807e-4a18-9da3-ebd2233fa4d4",
      "members": [
        "9a290797-749c-42ed-a67d-75d66083b144"
      ]
    },
    {
      "cluster_id": "4a1c13c8-b1bc-47b6-9e32-b9200ffdf048",
      "members": [
        "f339002b-ff86-4405-a3c8-36d40f57cb28"
      ]
    },
    {
      "cluster_id": "e47fa355-bcc3-44bc-97e3-0029cf946325",
      "members": [
        "5bbf7340-f31b-4450-acae-7485768ed63b"
      ]
    },
    {
      "cluster_id": "228f2026-3094-45be-9c29-b363d30f00b6",
      "members": [
        "8626ca71-1e52-4c5f-8f17-9dab6c266608",
        "6687c73a-8126-4a8d-87d3-e6ef4a4a7541"
      ]
    },
    {
      "cluster_id": "66034097-f5ff-415b-b7cc-7775692bf89e",
      "members": [
        "7fd9c91f-c316-400d-85b4-090ac628f432",
        "eabf220b-ccb7-4d7f-8222-41a150002c94"
      ]
    },
    {
      "cluster_id": "652f545a-2cde-41d4-9382-f23ab9d1b406",
      "members": [
        "6a957da1-406d-4b72-bcbd-6596131f5345",
        "c17ff997-a5f8-40a5-9388-6ea34db6656d",
        "4f4ed72b-59e3-4046-aaf2-44942cd0b308"
      ]
    },
    {
      "cluster_id": "b997c44d-2fc1-4d45-8a7a-f72d1b5a079d",
      "members": [
        "4efd2e64-a23b-485e-a038-428d2989b63b"
      ]
    },
    {
      "cluster_id": "3062f8bf-848f-45a7-a46b-1596767052bb",
      "members": [
        "ea149bda-238a-4057-acdf-0cd761b1b278"
      ]
    },
    {
      "cluster_id": "f49b5f7f-d1d1-43b6-ba5c-a712f59a657a",
      "members": [
        "ae10eee8-7eb6-4dd8-9f0f-947491a632cc"
      ]
    },
    {
      "cluster_id": "a2124c19-e133-4d10-984d-0d176559c1d9",
      "members": [
        "07681209-6c18-43df-bb34-a99640acf3fe"
      ]
    },
    {
      "cluster_id": "885d31c0-aa76-425b-b76c-0ebfaadd310b",
      "members": [
        "7145843c-da9a-4ce0-adb6-08bb4bf5900e"
      ]
    },
    {
      "cluster_id": "473560b4-10a2-4370-be8e-3ebeae00ae74",
      "members": [
        "48f96080-2ff8-4413-bc68-8d45573e0ebc",
        "b23955d7-beff-4040-9358-de291f6dad20"
      ]
    },
    {
      "cluster_id": "5e19ce7f-9db8-4e0b-8a22-b9bd4624ed1e",
      "members": [
        "3da6910b-ebe5-4265-97f9-9acc53fc146d"
      ]
    },
    {
      "cluster_id": "56a7af82-50cb-4d0f-a5ea-28ea4cda014a",
      "members": [
        "4af56b7a-2b18-4614-94db-f8baaa510c21"
      ]
    },
    {
      "cluster_id": "4f145c90-9c3b-47cb-b38a-e643a9aa6e27",
      "members": [
        "9a68762b-1125-44bc-9ce8-f0066c271623"
      ]
    },
    {
      "cluster_id": "0f38c468-09df-4db1-af76-875811609b3a",
      "members": [
        "d8249f1a-5fe7-4e68-83d4-bdb52e664065"
      ]
    },
    {
      "cluster_id": "4b93a421-107c-4185-912b-a73d039895b4",
      "members": [
        "848bee8c-b8e4-4f15-b80e-8fe019b2f406",
        "da5bdb7e-c330-4097-95b5-1c0cdf432346",
        "ef40271e-1b78-4d05-a4a9-d2bb3d847704",
        "5ab3d19c-52f3-4215-b630-51123495bc58",
        "ccf3d3fc-0e96-4f64-b986-c8ae23e11ef5",
        "9e2379f7-a83d-4952-bd56-8895d41335ce",
        "8b34aad5-bf88-4f62-bdad-ef7da9225420",
        "f44ef0e0-5322-4033-a778-bc956962c971",
        "7ddd12d2-cff6-49aa-b67f-7dfa800c3849",
        "c0fbdaf3-2a6e-49c9-8b79-ccaf2f5980ec"
      ]
    },
    {
      "cluster_id": "e17360aa-cb4e-4e41-913f-f3e853c44fd4",
      "members": [
        "a5560f22-1608-4dc4-b5e9-cab6fa9a2dc0",
        "1106203c-1f11-4aac-adb2-d43dd7539134",
        "39db8ebf-a9e7-441c-886d-4ce08a5dc110",
        "29d71415-c815-4a13-bb80-4bc83e611763",
        "6fcc605f-4d96-49ba-a217-c52dcb746b17",
        "f5356c05-dce7-44f5-a872-82e02ddd286e"
      ]
    },
    {
      "cluster_id": "a6590632-faef-4956-b655-28617cdf7601",
      "members": [
        "85aff665-3933-40c8-8e0c-8ff42c619c23"
      ]
    },
    {
      "cluster_id": "cc658fb1-6da2-4d31-8ee4-f6cd436408af",
      "members": [
        "c58754c0-7dd2-4b01-acbc-26a6b8b444fd"
      ]
    },
    {
      "cluster_id": "009b82df-6fc2-417b-9cb7-3440f511ecfe",
      "members": [
        "d1fe315e-4c15-48ad-8d28-30a44de19d7f"
      ]
    },
    {
      "cluster_id": "ef0e0cc6-010e-482e-ad0b-63895cd13988",
      "members": [
        "ba15b1b5-c381-44f2-8797-a55499eeb225"
      ]
    },
    {
      "cluster_id": "fcd590cf-7159-4dd1-af40-6a6c770d2797",
      "members": [
        "b4c5dcd8-e49f-402f-8388-945f21eb7598"
      ]
    },
    {
      "cluster_id": "59d52e20-3aae-46e2-90cc-c6f03ba747be",
      "members": [
        "920ad18c-187e-4ebb-a482-e5b78de11c13"
      ]
    },
    {
      "cluster_id": "222d1da7-5333-49e1-a4ec-9ca508fd278c",
      "members": [
        "9a17ae4b-8609-4a0a-bf32-9f7f03f3c630"
      ]
    },
    {
      "cluster_id": "2a187430-0a71-47a9-918a-414338300232",
      "members": [
        "a3704883-02a5-429f-ab67-0b072f6a01b7"
      ]
    },
    {
      "cluster_id": "b4df60de-0b59-4910-b93a-2f4eaa711964",
      "members": [
        "3a76259e-a1ef-4eb7-9ae8-cfd3f4fcc6f3"
      ]
    },
    {
      "cluster_id": "e91640d2-fa8e-426c-a0fb-7b9789e054bf",
      "members": [
        "1de97582-9f71-4971-ba7d-d8f87885f543"
      ]
    },
    {
      "cluster_id": "545b9a1d-6aef-4146-8dab-6da3637008a3",
      "members": [
        "a26d82c6-5a58-4bc7-a110-3dcb3a82fc08"
      ]
    },
    {
      "cluster_id": "2bec49d1-2f19-441e-9c0b-01eed5568c41",
      "members": [
        "54354ec4-f53b-4fc6-ac36-595bbd78d95d"
      ]
    },
    {
      "cluster_id": "b243dfe5-ad7c-4377-9402-0fc9aefe73cc",
      "members": [
        "8c8bf809-7919-42f2-a350-25605cb083b1"
      ]
    },
    {
      "cluster_id": "35e5848e-7f2d-49f3-b00e-f1ac80fdf555",
      "members": [
        "3793e03c-452d-447e-b83d-c0cc8f5b89f7"
      ]
    },
    {
      "cluster_id": "16aa2006-ba94-49b3-a83c-9dc2e8c8bf21",
      "members": [
        "c297fcb9-e09b-4143-822c-7e1d023e3454"
      ]
    },
    {
      "cluster_id": "deecc1db-c201-4092-b4f0-f1a952dbcc16",
      "members": [
        "27b9463c-05b7-4f0f-9497-2876314c5a04"
      ]
    },
    {
      "cluster_id": "96ab7552-d195-40c5-b31e-9af997302842",
      "members": [
        "e5b05f6c-bc32-4482-bb81-53d40b39c6da"
      ]
    },
    {
      "cluster_id": "4823b0d5-067d-49e8-9415-62a09183548f",
      "members": [
        "8bfe5c6e-d1d4-4b6f-b140-776c1fa1d289",
        "4a803032-82dc-41ba-bc17-2e372ad43c2a"
      ]
    },
    {
      "cluster_id": "eac477f8-1470-4d66-9ef8-e279e7d85edf",
      "members": [
        "ec8c5f4d-a867-484e-80ac-6c81a9283a59"
      ]
    },
    {
      "cluster_id": "7ad20f50-14f4-4cdf-b21e-0c9b5f397fe9",
      "members": [
        "72bc7424-651a-4c9d-9be9-ad3292abcb3c"
      ]
    },
    {
      "cluster_id": "1afcda67-b75d-4fbc-802a-288b7fcc1fcf",
      "members": [
        "434bf18b-493d-4770-9c92-1fe63ecadd04"
      ]
    },
    {
      "cluster_id": "e6f515d5-9add-4fca-a2f4-3869c847ca29",
      "members": [
        "4fee8636-34b2-4cc0-ba43-397c53506220"
      ]
    },
    {
      "cluster_id": "7c1469be-22eb-4ba2-a540-efc0b0d4e00e",
      "members": [
        "f0412d5b-93cf-42bc-8fc5-f98147a51f9e"
      ]
    },
    {
      "cluster_id": "ee18dcc9-53ec-41c1-9074-bb4cbe5ff92b",
      "members": [
        "f0a85fe6-b900-4e90-8e66-572bdecff90a"
      ]
    },
    {
      "cluster_id": "3789471e-0775-4ba6-92d1-141ca5051de5",
      "members": [
        "47a448fb-b4a0-46e6-991d-57294a9fee24"
      ]
    },
    {
      "cluster_id": "3c5a3b02-4d06-4799-a8fe-9f59c0de51d9",
      "members": [
        "7164afa4-2a31-4d20-b9a6-e502eff8a2fb"
      ]
    },
    {
      "cluster_id": "5bbc7620-dddd-48b2-ab59-dca397c2985e",
      "members": [
        "4f3686e5-d765-4276-9e88-28dad9622072"
      ]
    },
    {
      "cluster_id": "003d2fc7-16f8-4835-a770-b85123b3c250",
      "members": [
        "8cd87dbf-abf3-458f-830b-3e2098fc7257"
      ]
    },
    {
      "cluster_id": "8602d3ff-0dd5-4315-8d50-17cd0d22f5ac",
      "members": [
        "be6c17e9-3126-4a99-b1ca-12ba3fb536fe"
      ]
    },
    {
      "cluster_id": "bf3cbbb2-0711-45ee-a625-a3ccf159845b",
      "members": [
        "6fdc860b-5d9d-42dc-b86d-6db1f215ec58"
      ]
    },
    {
      "cluster_id": "731d7658-b5f1-4356-b7c0-c3b8c97cac8d",
      "members": [
        "63dc2a08-412c-4d37-aca8-5ea865e1119a"
      ]
    },
    {
      "cluster_id": "9964a330-c7c3-4cd3-bf33-0b48084f4337",
      "members": [
        "00abef23-136a-4f82-b966-5af27dd83e4e",
        "1063765a-03a7-4469-a982-301b089febc9",
        "641967ed-c666-4b21-9632-a88aaa4fe896",
        "92b8025d-d2b5-4360-bcc2-16c84a7cef8d",
        "465c6fb0-520d-4a90-8ca7-5e568b69df28"
      ]
    },
    {
      "cluster_id": "e5a3c503-081f-45b6-97d7-1fab2efba3f8",
      "members": [
        "08cafcf3-2032-4f80-b02a-ba109f879f0f"
      ]
    },
    {
      "cluster_id": "0016bf55-313e-4918-9759-9210715148d1",
      "members": [
        "87c66622-6253-4bb6-bc16-c751d87a2c32"
      ]
    },
    {
      "cluster_id": "fd17e83e-78c7-4b20-8834-c8e041abcbf4",
      "members": [
        "ade5df5c-bee8-45e8-a236-f3de837262e5"
      ]
    },
    {
      "cluster_id": "e12630d6-f5b6-4dae-9bf0-63dd6b0528b1",
      "members": [
        "1d8c5c78-ea5d-491b-aaeb-1e9eb3d23fe6"
      ]
    },
    {
      "cluster_id": "5a3adc2a-ea19-4c5d-b7f5-3df2a2a10371",
      "members": [
        "d7049be6-afc0-4f30-b738-0644dd7cfd9d"
      ]
    },
    {
      "cluster_id": "388b5477-b8ee-43a6-9b4b-3bf87541cc1a",
      "members": [
        "7c9ba322-a838-4167-bcd3-92788ba88530"
      ]
    },
    {
      "cluster_id": "a130a6d0-55d6-47e5-9fb3-2d64b90c9bf0",
      "members": [
        "81607614-7e18-493b-80e8-1de64c0a754c"
      ]
    },
    {
      "cluster_id": "55299e01-297a-4bb3-aad3-784bd43284fb",
      "members": [
        "ff6e86bf-c27b-43f3-81c9-562060321b74"
      ]
    },
    {
      "cluster_id": "532b749b-85ba-48db-930c-9199fbff3bbe",
      "members": [
        "9e8e0f65-b1dc-463d-b3b2-8da8207caf71"
      ]
    },
    {
      "cluster_id": "5c983b2a-2571-47de-87cb-902a1970e0f2",
      "members": [
        "8c67b977-c7a3-46a1-b02e-bcc7e336a6e5"
      ]
    },
    {
      "cluster_id": "aeb82733-bdb6-43c5-a151-fceb87e14ebf",
      "members": [
        "353854f8-f85b-4d64-b740-e832c88a249a"
      ]
    },
    {
      "cluster_id": "57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9",
      "members": [
        "8f013e9d-8c5a-4353-8c8d-a79d4122b7e3",
        "86204680-fdb9-4340-b931-94cd92dad996",
        "8c29246c-b612-4965-992f-1aae016849cb",
        "403c5420-2e53-4a20-9b5e-e35280f8134d",
        "2c659ec3-2327-40b7-86c2-5905cf7d48a3",
        "cc6121cf-f17c-4f0b-8068-f9bedd0b0497"
      ]
    },
    {
      "cluster_id": "b76141ff-47b5-4e35-911a-5ea99a13c31e",
      "members": [
        "ea97d934-450c-42f9-ba96-faa10aae7eb7"
      ]
    },
    {
      "cluster_id": "5bb4fd2c-606b-4f16-9ca5-b9abb9dd5181",
      "members": [
        "9ed42510-3de7-453e-b41f-dbb975483b27"
      ]
    },
    {
      "cluster_id": "f3ff4daa-4e28-48b9-8086-b9beac549c23",
      "members": [
        "675bdb85-f697-400f-8c7f-ed638f176b42"
      ]
    },
    {
      "cluster_id": "14b94d56-73bd-4f9f-9a3d-89c9827b210d",
      "members": [
        "974fb635-cfd1-4b4c-8f0e-5fc7a4dd25b3",
        "950a4afb-6b16-4452-8c32-f06391a6eb0f"
      ]
    },
    {
      "cluster_id": "fb3fc0aa-b013-4537-9abd-dcd64258a72b",
      "members": [
        "b6dce954-c6ce-479b-8ca4-eccecbf931a2",
        "cf1abeac-55ef-4d5e-b26b-6b043978f7a0"
      ]
    },
    {
      "cluster_id": "e0e899a0-65d4-45b2-b3be-ff8320d1837a",
      "members": [
        "e629fd6e-2664-4427-806f-f053affa3ea2",
        "25c6347f-d38f-4f24-90a2-eab32988fe16"
      ]
    },
    {
      "cluster_id": "633de8a7-7506-44cf-9918-6f3f17934029",
      "members": [
        "281fac33-7327-4d27-9270-fa396b74f594"
      ]
    },
    {
      "cluster_id": "d7c36f98-9955-4c57-9dda-97bd7a1b6e4f",
      "members": [
        "4bb77a37-80cf-4bc6-b14e-c32ddaed77ab",
        "f9ca1c34-8662-444d-8709-ffef60f2880c",
        "7091328e-46d8-4bfb-9119-5c4718a72e34",
        "2b508070-1d24-4290-aab2-515adf41a249",
        "ae1ed688-55ec-443e-bf2e-95bb6b115680",
        "683c1f14-e8e4-4de8-8dad-c9e3a47ec671"
      ]
    },
    {
      "cluster_id": "2bd1f4b8-00be-4a69-ba1f-d23c0361c606",
      "members": [
        "81a32455-c62a-4641-9d18-34a0807e49af"
      ]
    },
    {
      "cluster_id": "0a6e93a7-4ca1-4ae8-937a-93b0852204d1",
      "members": [
        "9f1162d3-4ee2-45b1-a94b-ea7e6ed8a86e"
      ]
    },
    {
      "cluster_id": "a41257e1-1e51-49b3-bf04-5fbb3ef2f25b",
      "members": [
        "1ef7e7ad-9c74-469e-b411-3852cc693702"
      ]
    },
    {
      "cluster_id": "ee6ffddc-d717-4a7b-a161-3d1bdc24c500",
      "members": [
        "5ff7751a-3797-475b-ab31-608a4dc57d3b",
        "73dadb3d-04c0-4928-8c72-5c56df523380",
        "bff99471-7e87-4f04-849c-7b2510eeda27",
        "35dd7506-6f6a-4fc6-95fa-ce3448ef69ca"
      ]
    },
    {
      "cluster_id": "b0b9c7b4-b931-48a5-9e3c-e3d43990149f",
      "members": [
        "70c094cd-4b0c-4efe-b783-c1d86fbd71a9"
      ]
    },
    {
      "cluster_id": "31c80f95-812a-49ce-aa97-208d1f8f4713",
      "members": [
        "921da37f-25ef-46f2-9bbb-85d9c79411b9"
      ]
    },
    {
      "cluster_id": "ad80cb2a-c356-4006-9574-67d0198ed537",
      "members": [
        "1509ac98-4f23-4822-828c-092344605aa7"
      ]
    },
    {
      "cluster_id": "3b00f0b1-76ec-42b4-8949-3a408087b558",
      "members": [
        "59a4e5cb-be6d-4294-8ad4-9b78c05f450d"
      ]
    },
    {
      "cluster_id": "36f9b8df-5b64-4298-b779-2814d4de3b9d",
      "members": [
        "e82b7ca8-3c7a-4a8a-88a6-bdbc535b0a1d"
      ]
    },
    {
      "cluster_id": "5b003616-1a21-4fdb-b479-c710fbcc5926",
      "members": [
        "6452efc0-72d1-45b6-99ce-9f5ad68a2f87"
      ]
    },
    {
      "cluster_id": "62e37c68-3e37-4c4f-b64e-4d353bb38fcd",
      "members": [
        "1d7c8c65-fed9-4af9-b8a7-583efe0c156a"
      ]
    },
    {
      "cluster_id": "83c177c0-ee20-4679-ad20-0c32e24ff101",
      "members": [
        "eb18cff0-382d-421f-a524-e99822ad547e"
      ]
    },
    {
      "cluster_id": "081350a8-a16a-45fc-b513-065a8ddaebac",
      "members": [
        "a821f2f7-8a95-48e1-8289-86096d5c2221"
      ]
    },
    {
      "cluster_id": "75649ebd-9ea4-425f-b0b4-b2dc8db1c23c",
      "members": [
        "317b32c6-c05b-44d3-8cad-09ffa5710de3"
      ]
    },
    {
      "cluster_id": "3a29dca6-ced7-43ed-9cff-367044251da1",
      "members": [
        "f64eec97-d14d-4a81-af07-8f416d6890d9"
      ]
    },
    {
      "cluster_id": "ff3032ee-a77e-4fe7-a5a1-205c35f0948e",
      "members": [
        "a544e0c1-ed7e-491e-bdc6-50b79d4bf79a",
        "aec2046c-231c-4694-b2e3-e33c096f3bbd"
      ]
    },
    {
      "cluster_id": "d211ea4f-25c6-49b0-b039-be55cbe6e301",
      "members": [
        "8c59f029-fa4c-424c-8712-979198438f2c"
      ]
    },
    {
      "cluster_id": "11ad6c89-9a64-4385-9a81-dfa3787cc401",
      "members": [
        "36aa4449-8818-4c98-90bc-fd2a05ea538a",
        "015ad92d-8a43-4c86-8eca-57b3ed328aba"
      ]
    },
    {
      "cluster_id": "fce3f86a-8cbe-4d55-ab8f-cc8fde0d8d33",
      "members": [
        "eb8db62e-651f-4c8e-b669-48a2c8d291e2"
      ]
    },
    {
      "cluster_id": "22a6dab9-0118-488c-a537-5d58e3ff3a75",
      "members": [
        "277714f9-0805-48b1-aba6-c95997c08bbd"
      ]
    },
    {
      "cluster_id": "1fdd9b57-6c44-4ffe-9d2d-90b7efd6fa20",
      "members": [
        "0418b276-b637-4fb1-93a0-12fc0f74d214"
      ]
    },
    {
      "cluster_id": "7cd85d56-7567-4824-894e-168d86ff8ac7",
      "members": [
        "3c8a7cb1-f0ce-46d3-ab60-c06d45d6ed83"
      ]
    },
    {
      "cluster_id": "2950776a-25e4-4d62-bcaf-01e56ebd5b4c",
      "members": [
        "c3f09444-e6e0-4d2a-bee9-15b6356fc404"
      ]
    },
    {
      "cluster_id": "19ab8a7a-3e63-46b0-894f-04742e58ad8b",
      "members": [
        "10aa326f-e579-4f6c-bd1a-8aff80170494"
      ]
    },
    {
      "cluster_id": "64c57917-e9a2-445d-b946-386aef313815",
      "members": [
        "c3172225-3693-4c6f-9238-7d90edfa3626"
      ]
    },
    {
      "cluster_id": "ed1adfd2-5ca7-48e4-ae90-60f2fca59b2a",
      "members": [
        "a86f7c23-4981-42fa-b161-51fc78cdad88"
      ]
    },
    {
      "cluster_id": "5d6a4e52-504f-48f8-b46b-8c506a9ab7ad",
      "members": [
        "f508aab5-c242-4d88-8ad5-2a725c9a324b"
      ]
    },
    {
      "cluster_id": "833754ff-abfd-4996-b62a-92904373fd3b",
      "members": [
        "97b8430d-9275-46e1-8b79-3fb241ad08be"
      ]
    },
    {
      "cluster_id": "5bde126a-9b98-4602-8531-f11f0ccfd92e",
      "members": [
        "ee067d00-c0b5-47d3-9029-8fd5486855f9"
      ]
    },
    {
      "cluster_id": "5cee41d6-0e60-41c4-b25d-8f1605700435",
      "members": [
        "48b3571a-6ac3-44f5-9fe0-6c14f6140147"
      ]
    },
    {
      "cluster_id": "468199d3-d972-44c7-826d-cc58f22c25eb",
      "members": [
        "ce9b33b9-e85b-4046-ba77-e5f1868c6e56"
      ]
    },
    {
      "cluster_id": "0e976646-d8b3-435d-b262-71720e81ac06",
      "members": [
        "19027ae8-4e58-4278-9f4f-f2109718cadf"
      ]
    },
    {
      "cluster_id": "4e53d403-5bf1-47ce-a5d9-ecd50db35ad9",
      "members": [
        "2e4da640-6c78-49c3-9e26-c35f40b8370e"
      ]
    },
    {
      "cluster_id": "a7c4ae5e-cf5f-4676-a2e4-88e256aaf381",
      "members": [
        "97ee6eff-e540-44c5-90bc-350b44a7f2d1"
      ]
    },
    {
      "cluster_id": "b94a7962-9c49-4a90-a9cb-480e580b3877",
      "members": [
        "114d8811-9be0-485b-93ce-1556c4af6efd"
      ]
    },
    {
      "cluster_id": "e5a54fcb-cbc0-4fb7-bfbf-7530efd090da",
      "members": [
        "f94dfaef-eb1f-479e-8c8d-c45f782c213e",
        "bb933fdf-bf4c-4870-a5f0-dd6bbdb1571d",
        "a5716227-cc2d-487c-b4e1-90631c2bd7b7"
      ]
    },
    {
      "cluster_id": "9e250f91-2983-4cf6-9b29-817f4271a911",
      "members": [
        "3140119f-8d47-4304-9e60-70eda24c916b",
        "4d311c0d-a3bf-4639-886a-9ffc29181f73"
      ]
    },
    {
      "cluster_id": "e294ae03-93b8-4461-85ca-920f88826e8a",
      "members": [
        "d4169ee9-5b6b-437d-8a9c-d6bda51ffd94",
        "50e9b1a5-58e6-449a-9592-f8df840c444c",
        "5f6be7fe-2480-4b8b-847b-374e45a86e9e"
      ]
    },
    {
      "cluster_id": "9a0e60e0-9d22-43df-bc7c-6bb5028125f2",
      "members": [
        "d578f1e2-0edf-442f-8167-9730b07540ed"
      ]
    },
    {
      "cluster_id": "86a1cb16-ab28-4b30-be94-ef12abdf7cfc",
      "members": [
        "80c98feb-aa13-4dbf-8e34-68d40b5993ae"
      ]
    },
    {
      "cluster_id": "9dbb5109-6fdf-484b-92c1-ec8b1bba2a62",
      "members": [
        "97efe8fc-86dc-4752-8d07-932a84a1c46b"
      ]
    },
    {
      "cluster_id": "ad2a393e-2bc5-4c0d-addf-577399b7b41d",
      "members": [
        "0baeefc1-adc3-4f98-b95a-d541cccf69ad"
      ]
    },
    {
      "cluster_id": "c2686424-538a-4d1b-80b6-8a6f5e252d7c",
      "members": [
        "3afa542c-0bdb-4bfe-99c5-ec4f8c07f3eb"
      ]
    },
    {
      "cluster_id": "a3e7173c-3ffd-4346-9259-1d6261818acc",
      "members": [
        "8a6ad661-4866-4e53-a06e-fc4454d38987"
      ]
    },
    {
      "cluster_id": "d101520b-7082-47e3-b848-813e8165e6a9",
      "members": [
        "32db54f1-b369-4ca0-8b04-d474a4145f4f"
      ]
    },
    {
      "cluster_id": "35008b59-14cd-4674-801b-6fc7e159bf31",
      "members": [
        "f464d68b-a2a1-43a1-b569-4d332d007b45"
      ]
    },
    {
      "cluster_id": "4ae526b6-129a-4522-b79c-5fa5e53d2329",
      "members": [
        "558ff771-454a-4ef9-b800-b3b910ece8ee",
        "fad7cf7f-dc96-4ebb-bc6d-b8b06657faef"
      ]
    },
    {
      "cluster_id": "612db375-37db-450a-9941-cc2bdb1c5d4b",
      "members": [
        "e113e22b-2707-4663-a22b-b4c0f7bd2f1a"
      ]
    },
    {
      "cluster_id": "70408cf7-1954-491d-98bc-f78c50c03508",
      "members": [
        "03751e65-146b-4456-8dc1-c7c36cbb9273"
      ]
    },
    {
      "cluster_id": "1034b1f8-bfe4-4bc4-80f2-8e57922001cc",
      "members": [
        "099063c7-f4d6-452a-96b7-3cfbec499f70"
      ]
    },
    {
      "cluster_id": "8456fa39-debe-4543-9e31-bac207d1861c",
      "members": [
        "db5fae7e-79b7-4b72-ac6f-4886e201988a"
      ]
    },
    {
      "cluster_id": "1b781e70-c91d-4aef-8e8b-426c2c695555",
      "members": [
        "5182eb84-9e91-4051-97a4-a787da6915f3"
      ]
    },
    {
      "cluster_id": "0a39d2f3-be07-4455-859e-2055e083eec6",
      "members": [
        "4e319c0c-fa97-49bd-8d1f-e297eb183d06"
      ]
    },
    {
      "cluster_id": "abbb0c2a-4609-4a58-819a-928af8ad2bfc",
      "members": [
        "c1787c96-2590-4891-b3f5-806faabaad21"
      ]
    },
    {
      "cluster_id": "f3c78c9b-df0c-4382-a6ec-56b924bce811",
      "members": [
        "e00f7faa-5d4d-4e79-8298-ad7c22d4d2c8"
      ]
    },
    {
      "cluster_id": "4f70ac27-41cb-48d8-871e-5b61b1c5a657",
      "members": [
        "11a40aaf-f706-40cf-82a9-1a19cf63c3d5"
      ]
    },
    {
      "cluster_id": "36abfac2-7b3e-427a-a2be-ce55f5472e15",
      "members": [
        "861b0fc8-2713-435b-9bd0-27cef9356563"
      ]
    },
    {
      "cluster_id": "f43dba3b-7d34-4eea-96eb-854a495fe8e2",
      "members": [
        "4e99c43a-52d4-4367-8e23-2a3c8bd45a8f"
      ]
    },
    {
      "cluster_id": "e9ec4305-aed2-424a-9a57-210fed19fa52",
      "members": [
        "8f90dc85-17db-45b6-861f-a79a145cbdfd"
      ]
    },
    {
      "cluster_id": "e9eacbea-e948-4bff-8064-db4af871a9d3",
      "members": [
        "3293095e-b726-41fe-9e73-a2632666ed8a"
      ]
    },
    {
      "cluster_id": "c99367c6-2c05-4a14-b047-7f8ff36ff133",
      "members": [
        "222d75b6-ccc3-4eff-bdfa-f2c7aed90156",
        "7b92fc65-a796-422b-9443-374ef57581b5",
        "ae975e0a-9f37-43c4-b84a-500496a03681",
        "45371774-43cb-4e3d-847c-91c826a691fc"
      ]
    },
    {
      "cluster_id": "1231d1d1-38bd-406e-916f-d7769d05b29d",
      "members": [
        "ea73dc47-9ebe-4398-8854-410ce744a766"
      ]
    },
    {
      "cluster_id": "5b07fdf4-9b41-49e1-b97c-866f63e0da14",
      "members": [
        "d37b5259-c261-4f6f-9fb2-82a898d4a789"
      ]
    },
    {
      "cluster_id": "74c516ce-db78-4790-b130-64ce1c94e700",
      "members": [
        "a7a9313b-3363-4c37-9221-69cecc02c7b7"
      ]
    },
    {
      "cluster_id": "bb551e75-48fa-42c3-a108-cb4b1462b529",
      "members": [
        "8e8d6642-8a2b-41f0-877a-508b282f4111",
        "64c4a54b-65dd-4e50-89a8-9a089b49855f",
        "9e777542-e2c4-44dd-886a-c7f38f623a25",
        "1b4f0df7-b4bd-4b1b-bc66-9bbbaf34be37"
      ]
    },
    {
      "cluster_id": "31e7b652-307d-4f5d-a4a6-215892b2e421",
      "members": [
        "51c342aa-f495-447c-a741-0f62d5867280"
      ]
    },
    {
      "cluster_id": "18fb4791-02de-4e42-aeab-ba0112d12563",
      "members": [
        "eae9effd-0408-4194-a055-2a43ac1db606"
      ]
    },
    {
      "cluster_id": "d9f5ad2b-430e-4145-acd5-2d92262e0952",
      "members": [
        "322841cd-72a9-4285-a807-cc62848423ce"
      ]
    },
    {
      "cluster_id": "91b36e51-3bed-4937-9f60-9c0f824e451a",
      "members": [
        "0af56191-0e0f-4fe2-b9e2-e821fd6db35c"
      ]
    },
    {
      "cluster_id": "1ee9efa3-f349-4351-93b7-a5f37a7326be",
      "members": [
        "f8673471-5bf7-4c53-affb-4caa3100de22"
      ]
    },
    {
      "cluster_id": "ceeb5cde-733b-478e-9e0a-21930e3f91cd",
      "members": [
        "5c352b85-72a5-4fe0-b247-e193012c1069"
      ]
    },
    {
      "cluster_id": "00cb3646-a2c2-4ca4-9bd3-507a4d1eade7",
      "members": [
        "4323d9ee-e5be-4bde-bd6b-7fa02e8e16ef",
        "afaeb14c-7c75-408c-926e-a3e8c8a836a3"
      ]
    },
    {
      "cluster_id": "693c26f4-40f7-4d45-b4b9-51440f45735e",
      "members": [
        "167cd11a-7bd8-448b-8a6e-495bbd0f3fa5"
      ]
    },
    {
      "cluster_id": "0a3dfd8d-a3b5-4c2f-8fe0-7e8a2061b362",
      "members": [
        "bb9d0cc8-29c7-493d-a706-4ce83cc9c18d"
      ]
    },
    {
      "cluster_id": "9297f5a6-da64-4942-8c55-fea3e2f0fc25",
      "members": [
        "3a9774e6-10f2-477a-ab6a-cca67b1c16fc"
      ]
    },
    {
      "cluster_id": "b2ea914d-85db-4a5c-9a1a-857c4092e4d3",
      "members": [
        "441e1bc0-70fe-44eb-ad34-0223b99e3ca4"
      ]
    },
    {
      "cluster_id": "cc554329-dead-4eef-88f0-c2d38423ce88",
      "members": [
        "2f871919-d116-40c0-a287-e1eba8a48b43"
      ]
    },
    {
      "cluster_id": "65719321-4c0e-421c-be0d-ae0fd54b036d",
      "members": [
        "917b61ae-ede9-4e14-9d70-7ec40dc181b3"
      ]
    },
    {
      "cluster_id": "1ce4d643-96d1-4472-9df9-18efdd477875",
      "members": [
        "59154926-987c-4187-b208-3ac364e6899a",
        "1eea5f54-91aa-4cd5-97e7-61aceeaf6eb4",
        "45376586-0395-4dcd-b518-01cad0ca117a",
        "a0290b8a-cab4-4576-b231-460d6fbba5b6"
      ]
    },
    {
      "cluster_id": "eac2d3f5-7d2a-4cfa-b17e-cac48f4a7268",
      "members": [
        "5822f032-feb0-4fca-a9fe-b0db5146f9f1",
        "f426628c-d791-433d-9908-39f946c4bddf"
      ]
    },
    {
      "cluster_id": "9348816a-379b-4a83-98b4-cd843f9d8989",
      "members": [
        "442ca6ad-3fc9-40f8-b29e-f5ebd7e26aaa"
      ]
    },
    {
      "cluster_id": "c623ca23-8a98-4b0e-b365-eb9b3c1cdd86",
      "members": [
        "3269616a-cc39-4a25-bafb-f0ad27cb1b53",
        "51d7de32-25b2-49d1-95bf-bab4d50c8194"
      ]
    },
    {
      "cluster_id": "31a83c0d-3856-4e30-82d4-769416b594bd",
      "members": [
        "9ca8200d-6dc1-4f59-9e0b-189a5928ba6d",
        "d67b8388-c5ba-4ef3-9f99-518f8e6b9ec4"
      ]
    },
    {
      "cluster_id": "e86a3db7-1b97-499b-90f0-337a1d71a604",
      "members": [
        "f7e271ea-0a8c-411a-a7ec-e034b971ea88"
      ]
    },
    {
      "cluster_id": "a722bc41-1d66-412e-b713-184ed31bb855",
      "members": [
        "5bc21564-4705-4f88-b5a6-3c76db8c6999"
      ]
    },
    {
      "cluster_id": "2ba645ab-6f15-47c5-96d6-7989f0a29459",
      "members": [
        "3d6ca9ba-8938-41e5-a235-f30ae9f1bb9e"
      ]
    },
    {
      "cluster_id": "65f95c9d-be3f-40b0-b287-d80a74be8b4f",
      "members": [
        "8d744fb7-6fd9-4ba1-811c-9de7080dc2ec"
      ]
    },
    {
      "cluster_id": "04e5de16-d046-4bc2-878e-0b328f3385ed",
      "members": [
        "6c0d5bf5-6470-434d-a633-f24e61c3ddf5"
      ]
    },
    {
      "cluster_id": "52b6d3e6-8588-4bb5-9bb9-34f52aa88349",
      "members": [
        "6210f009-184f-443b-b61e-725c791e1e92"
      ]
    },
    {
      "cluster_id": "1f48fb6b-ea22-46f3-a429-4b537e306680",
      "members": [
        "af232223-fe84-4fea-9b31-bba82843063a"
      ]
    },
    {
      "cluster_id": "8a51d448-3e97-4522-acf3-ca3a46ef7aad",
      "members": [
        "dc9e2ee2-6a52-44e1-bf09-83ac361b0ae3"
      ]
    },
    {
      "cluster_id": "bd8ae460-e56a-44c2-a9f6-3ae3b4d65792",
      "members": [
        "54f3a33a-e560-4653-8566-3949400427bb"
      ]
    },
    {
      "cluster_id": "87e0267f-e999-4f76-8883-d246a2dc113c",
      "members": [
        "92622502-9d1f-489c-91fb-e43fc2acf742"
      ]
    },
    {
      "cluster_id": "aee60c89-f292-46d6-9573-19871764aa64",
      "members": [
        "cf603f33-34e6-4183-a115-e3ac3538ba4b"
      ]
    },
    {
      "cluster_id": "c08c0c57-ea8b-4938-93c9-7d2934450835",
      "members": [
        "e7875114-649f-4e5c-b759-b863b64561a7"
      ]
    },
    {
      "cluster_id": "7011451c-4136-49ed-9d09-6db32baccfc3",
      "members": [
        "2acea521-b0fc-48ed-88e2-b8f6da9aa180"
      ]
    },
    {
      "cluster_id": "7e1892c9-2b80-4467-8d86-e0034e324987",
      "members": [
        "48218272-d962-4750-b578-752d4240e2e3"
      ]
    },
    {
      "cluster_id": "34a1b7dd-030b-404f-82f6-074c42d07051",
      "members": [
        "93c43d6c-88d3-4dad-b18a-dd5596a062c4"
      ]
    },
    {
      "cluster_id": "9d8e9597-3167-4e1c-94bb-e686324d37e0",
      "members": [
        "901c9158-8dd1-451e-89bc-9b3e6f7044ad"
      ]
    },
    {
      "cluster_id": "c9780602-10a7-414d-9965-0df44aadba9b",
      "members": [
        "32022d9c-2c83-48a5-bc04-c8cc87a593d0"
      ]
    },
    {
      "cluster_id": "3a31c97f-6174-468b-bab1-90d8acc21560",
      "members": [
        "07a56859-a3c7-4523-b943-001bfa91cf5a"
      ]
    },
    {
      "cluster_id": "07b3b643-33f3-45b2-87a3-3626fa492cb3",
      "members": [
        "a390a2b6-e764-4521-bf88-b41e34e69af1"
      ]
    },
    {
      "cluster_id": "f44c0c51-4b5f-47de-9ff7-9cd4c4c2b58a",
      "members": [
        "ddac4342-724b-4057-83bb-d517c82627bd"
      ]
    },
    {
      "cluster_id": "fb065855-6920-462f-84b1-383a66822ef8",
      "members": [
        "0c4010c9-6257-4e87-bc84-a4b250e3d55b"
      ]
    },
    {
      "cluster_id": "62c55243-573a-47e9-9c3f-afe131b6a01d",
      "members": [
        "1ca309d5-e3fc-451b-af76-e44786b894f6"
      ]
    },
    {
      "cluster_id": "08168b1f-73c6-4a8d-80e5-08594ac2f44e",
      "members": [
        "39da4c3a-adf9-48d1-af3a-5afc6e3ac57e"
      ]
    },
    {
      "cluster_id": "673690cb-9b1b-4465-841b-31fb50a8d527",
      "members": [
        "1c5e2b7f-64ac-4508-957b-adfe716ec6e6"
      ]
    },
    {
      "cluster_id": "6ad8a14d-0296-478c-a06f-959ddf23a8b3",
      "members": [
        "5470ae14-4639-43f5-9525-c3f9199e1085"
      ]
    },
    {
      "cluster_id": "878945ad-a11c-4c5d-8d89-5e5ce4911878",
      "members": [
        "a87df052-6792-4ff4-91c3-24581c4c4a31"
      ]
    },
    {
      "cluster_id": "a2d0ea3b-d935-4c42-8edc-70bff4ecb269",
      "members": [
        "68f92636-4e3a-467c-8168-cd1c2eb155c5"
      ]
    },
    {
      "cluster_id": "ab96918c-daa5-4c62-989d-c9617e4f6b5e",
      "members": [
        "1e919862-a394-4d0e-8f88-dbbc7c1f3be9"
      ]
    },
    {
      "cluster_id": "92a82b98-f457-4ad6-9e23-e80c7e1d25f5",
      "members": [
        "068432ed-79d3-4c40-b986-0b9f52b2b854"
      ]
    },
    {
      "cluster_id": "9f415e0a-a04a-4d8b-b01c-2d2cc94bb46b",
      "members": [
        "92de102e-5285-491c-92af-7f876326a055"
      ]
    },
    {
      "cluster_id": "64112ad0-ee1e-4f16-b30c-2adabd7eaabd",
      "members": [
        "9312344f-c2bd-4729-abeb-af172a7a75cb"
      ]
    },
    {
      "cluster_id": "5256265d-d143-4d8d-91b5-fc2bd6f31e20",
      "members": [
        "21f04535-1899-4f5e-a6ac-c45b5f9a784e"
      ]
    },
    {
      "cluster_id": "5ec2fd93-7d1f-4121-8e63-fe69b1d0ab98",
      "members": [
        "fd3b3d2d-9a82-43f6-b5e1-36eb81fa8ce2"
      ]
    },
    {
      "cluster_id": "b3b646eb-c723-4a14-ac13-d0b7985ef11c",
      "members": [
        "affc1bd7-931a-41ac-8a4b-149e1962f5f7"
      ]
    },
    {
      "cluster_id": "76836166-e9eb-4d22-93c5-16c83ebc5bbe",
      "members": [
        "98d9b1be-a091-42ae-a824-4add22826725"
      ]
    },
    {
      "cluster_id": "8eba8ddc-43e0-42e3-8917-7f76c17baf39",
      "members": [
        "686243dd-c98a-4534-ab8e-261dce5d0be3"
      ]
    },
    {
      "cluster_id": "0dde3660-e0d6-4644-aa81-6e184dc6e068",
      "members": [
        "73f2581b-78ea-4073-b522-f122ba21942b",
        "65423e9a-1634-45dc-9d3b-214efebd0a65"
      ]
    },
    {
      "cluster_id": "853910fb-7ee6-4070-a774-47b5fca3aae1",
      "members": [
        "ff5616f8-a79b-47de-9ac9-273996d50120"
      ]
    },
    {
      "cluster_id": "1743784f-0949-4ddb-93e5-a1fd3954d25b",
      "members": [
        "ad5984ee-a3ad-4ec4-b4ce-e130c1f67d09"
      ]
    },
    {
      "cluster_id": "d33cb6f1-20b6-4555-be5a-7f0455de9471",
      "members": [
        "28e8f541-e8c0-48fb-bce9-3fb0dd399191"
      ]
    },
    {
      "cluster_id": "42a6504a-75a7-4c6b-8491-655e6c73b864",
      "members": [
        "a742fb45-a461-43bc-b476-456e8ad028bc"
      ]
    },
    {
      "cluster_id": "3765cbfd-a44a-49bf-b7ba-3bd606b4f80e",
      "members": [
        "cf4cac70-1fe0-44ec-afd7-3d70e3d867fa"
      ]
    },
    {
      "cluster_id": "3f0053e9-5dcd-46d0-a2b7-d6cbd40dc3ff",
      "members": [
        "456df9fe-30b3-4415-9a39-52064e0cf327"
      ]
    },
    {
      "cluster_id": "f9c1e4b6-836b-439a-971b-99d6ec437f1d",
      "members": [
        "ca91c933-ac95-4353-bb69-1d9f393a79c8"
      ]
    },
    {
      "cluster_id": "3dfdc081-40e4-4a34-81ac-79b539cfc98e",
      "members": [
        "b17c0ea0-45a5-493f-91f7-b3daebbaf959"
      ]
    },
    {
      "cluster_id": "b20a6598-dc24-40bc-a9eb-7fdc252fc7eb",
      "members": [
        "91ad4b59-ea33-46ae-8242-9b46c76403f7"
      ]
    },
    {
      "cluster_id": "f7dce48b-908d-410d-ae3b-0711d8dd8a49",
      "members": [
        "098aa029-ec8e-4883-85bf-bc46490bd379",
        "e2e9ccf6-55ae-4c59-8a0b-d4e161dbfff1",
        "41b1eb86-1e6e-4c67-9ead-477dc17e5c3c",
        "37625bdb-3faf-444d-96c3-044a6680cd29",
        "95c58021-765b-4340-8db8-45534f0753f7",
        "725f30c6-6356-4be4-895a-af950908eac5"
      ]
    },
    {
      "cluster_id": "248cf9f0-85b2-4eae-9028-789470700e69",
      "members": [
        "42d52141-5e88-4a4d-962a-82996e2d62a9"
      ]
    },
    {
      "cluster_id": "af90686d-77e8-4713-873e-8c63e5dbe370",
      "members": [
        "7da97a72-cae2-46bf-99b9-531f8be4f1b1",
        "48ffe91e-06f2-4568-87a2-8fff684bd1d7",
        "98086365-8b60-42af-8a68-2b1e8ea49daf"
      ]
    },
    {
      "cluster_id": "bbc9b8d3-6b58-4072-82ed-eb3aad9d21a5",
      "members": [
        "34c1ed12-9336-4757-84db-c8b93a27ce8e"
      ]
    },
    {
      "cluster_id": "9e59aa88-1912-40bc-b111-4817591aae4d",
      "members": [
        "6f28a2f2-e539-4dee-9855-e6a65ab9e0a6"
      ]
    },
    {
      "cluster_id": "3871454f-b8ca-4976-ba58-fba8307b403e",
      "members": [
        "af890a05-332e-45e2-b324-34148f8f8edf",
        "fa1d9e95-860b-4b4f-9fe0-314d79b493c4"
      ]
    },
    {
      "cluster_id": "357af95d-b02c-4002-bfc2-fdd9ff848257",
      "members": [
        "49acb213-a59d-42fa-9fc4-f619d8791ba4"
      ]
    },
    {
      "cluster_id": "382c8bbe-8826-4b13-8317-0d73ee7eee77",
      "members": [
        "45e42270-f505-45f5-b918-6b0cda07bcfa"
      ]
    },
    {
      "cluster_id": "03d03c63-2946-42c4-9a55-b127fdc45b21",
      "members": [
        "0d9fc4a0-5fcb-4860-9631-c7f6c920d7d6"
      ]
    },
    {
      "cluster_id": "a80f445d-229b-4be7-a694-df00afa0ebff",
      "members": [
        "7e25a76a-37bc-4cb4-991b-75ca8cb4db06"
      ]
    },
    {
      "cluster_id": "91a65b39-ae74-4a8d-812e-5ba1c8563d2e",
      "members": [
        "4454f0a8-ec22-4cb4-ac30-1ae88c0d8026"
      ]
    },
    {
      "cluster_id": "31e15131-0797-4dd4-9297-5c40959ea3ba",
      "members": [
        "50270f49-40d5-4d8a-865b-719e919b380d"
      ]
    },
    {
      "cluster_id": "512979c6-163f-4fe1-b34a-1c4e466e4650",
      "members": [
        "c14565f6-e945-46f4-a565-20182e7bfb5f"
      ]
    },
    {
      "cluster_id": "56d8e5bc-dfb0-4e57-a911-a8a552ba1562",
      "members": [
        "fb35e2a8-7820-467f-9f02-501f5db2d4ea"
      ]
    },
    {
      "cluster_id": "309e6017-5ba6-4aa5-918a-e978302b6d2d",
      "members": [
        "b2a9a693-2f1e-4e6a-979d-58fca7b6cc79",
        "0512a5fc-5926-412a-8411-346f9bf0b7fd",
        "8e1fa647-3216-4dff-87b3-a454db279570"
      ]
    },
    {
      "cluster_id": "4a709253-d61a-4103-b072-d16f3cb55d28",
      "members": [
        "d901f911-ecfa-4d16-b71b-5d064dca9f25"
      ]
    },
    {
      "cluster_id": "fad57477-d03d-4801-aeb1-50224d171446",
      "members": [
        "21308ad2-ed8c-47ad-91ea-7d57d9647a29"
      ]
    },
    {
      "cluster_id": "ce085679-ae85-409d-b3f3-afb9e8562a5b",
      "members": [
        "bd61c7cb-9e37-4312-a09a-5d9c22333eae"
      ]
    },
    {
      "cluster_id": "ab8af083-dfdc-4c18-95cd-32d551c130c1",
      "members": [
        "545e7117-772c-412b-97f7-6e5cfd8279e3",
        "80aa0218-4894-4d93-9036-99596d3f9805",
        "e3500067-58e5-401e-be62-6ac02afe5f68"
      ]
    },
    {
      "cluster_id": "8e9141e0-2f9d-4d0a-920e-7ed046dbbcec",
      "members": [
        "9541024e-78b4-4a7d-9a0e-e5d0a23547c6",
        "e513feeb-a471-4ce8-94c8-d0308e293d7c",
        "569e374f-3c1a-41f9-a0dd-8382fa562bcd"
      ]
    },
    {
      "cluster_id": "37a15ab9-c9e5-493e-bc55-f1d64743861b",
      "members": [
        "d8922da7-0392-43c3-9ff9-6852d5dea24c"
      ]
    },
    {
      "cluster_id": "88b529dd-6a84-4eea-a385-80a5f7c68b68",
      "members": [
        "2e715436-fede-4a04-baa0-2533450430f0"
      ]
    },
    {
      "cluster_id": "6fad579f-d261-4337-bd5f-1776b8d945c8",
      "members": [
        "2bef7be2-37fe-4ae5-b341-834d95218f44"
      ]
    },
    {
      "cluster_id": "2d972490-4937-489e-9570-c5d28d63e725",
      "members": [
        "825d43c3-608a-4dec-9135-afab70108a23"
      ]
    },
    {
      "cluster_id": "e0cfcc7e-1525-454e-82eb-71402504ae5b",
      "members": [
        "22fc4451-39a9-429d-b999-ce653efa4de7"
      ]
    },
    {
      "cluster_id": "ef77006d-68d7-4c27-ae83-cb85890ca2b1",
      "members": [
        "9ff538ac-8666-450c-a6f0-7b725a52bbcc",
        "70fab0a5-9570-4e18-aa9b-2a40a0ffb0dd"
      ]
    },
    {
      "cluster_id": "f86db310-987e-41a6-a2fc-6f6bb14b7072",
      "members": [
        "f5b27817-344c-4cd3-9b2e-52fdcecb069c",
        "dac7a8e1-5257-459a-b46d-a95758256fd2"
      ]
    },
    {
      "cluster_id": "4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6",
      "members": [
        "1d0ef9c4-3fa5-499b-842d-f166010dea71",
        "2125bdb0-7204-4e0a-91d8-28499c435729",
        "97421821-e331-46dc-ba60-d0e6f36dba4f",
        "6b5be610-f1fa-4824-913d-7a70777884de",
        "d45a26ec-741e-44f4-bdb7-f46d3f67f74f",
        "a67870d4-bdaa-40e8-8ed1-3008ad93ff8c"
      ]
    },
    {
      "cluster_id": "3989418a-395d-4448-a748-f8cca55ad517",
      "members": [
        "87e7d153-c4a2-4274-ae4d-e0c5a470e7fe"
      ]
    },
    {
      "cluster_id": "608932d5-1e12-46e3-a718-377dfac71e8d",
      "members": [
        "5d91096d-88e2-463c-b965-592ebc181a91"
      ]
    },
    {
      "cluster_id": "fdc48ebe-c88c-4c2e-883d-95e1b09e9ec8",
      "members": [
        "3ab432b3-1325-4c73-923c-07971b892798"
      ]
    },
    {
      "cluster_id": "ce2d06aa-e26f-4ec8-8402-545cc5537de0",
      "members": [
        "bc17fe6c-6f26-4257-9fea-1bde09ac2b15"
      ]
    },
    {
      "cluster_id": "dec5b760-e9f3-4528-b5d8-c2638f4598ab",
      "members": [
        "8e6dfbb8-7653-496d-a494-14f06c6a9619"
      ]
    },
    {
      "cluster_id": "4f0f5e9d-5d96-4785-be2a-db5660d98439",
      "members": [
        "8e6ffcb5-2935-4da8-a2f6-37ced68f793b"
      ]
    },
    {
      "cluster_id": "5b53e66c-0bb9-49bd-b149-91ceadd51fb9",
      "members": [
        "6329a629-8785-48c9-a520-51679aa960e5"
      ]
    },
    {
      "cluster_id": "505d0868-59a0-4692-bf8c-7c412af4f91a",
      "members": [
        "4aef59f0-2f8a-49ee-aa33-c47e66af31b0"
      ]
    },
    {
      "cluster_id": "dfc393f7-ef26-4ee1-ba36-c3a68f72795f",
      "members": [
        "99054d96-5995-400d-a538-9d426409a010"
      ]
    },
    {
      "cluster_id": "67a5aa36-56f0-43ce-bcd7-a10ff634cd7e",
      "members": [
        "aad7e35d-8b80-43cd-b1f2-98b0b18220d7"
      ]
    },
    {
      "cluster_id": "a44b23b8-a3e3-493e-b038-fc26f5c96d31",
      "members": [
        "e9e5908f-edb5-4e1c-96b6-ae50ee50f43a"
      ]
    },
    {
      "cluster_id": "b6f98e35-378d-4bca-93ef-5b980f18f2b3",
      "members": [
        "2ce347ab-01ce-4b4e-8d58-fc0e04cf8b5a"
      ]
    },
    {
      "cluster_id": "252647f3-b2d0-4fb9-8a73-8d20e5a61e96",
      "members": [
        "7907ff43-49d7-47f8-9ce0-20f40065d975",
        "a159547a-4af7-4274-b801-e11db333875c"
      ]
    },
    {
      "cluster_id": "6e64c34e-113d-43d7-87a6-90c61d4d3f67",
      "members": [
        "4c6e1739-a25f-40f8-a4ea-6364e45bb003",
        "211749eb-0c84-433f-8c5b-67d3c20b7c6d",
        "834eac6b-77cc-451c-be6c-d70471e32525",
        "31783125-f695-4dd2-b83d-e9c62dacc5f6"
      ]
    },
    {
      "cluster_id": "1e061f92-2688-4d15-8cdc-93767b97df6b",
      "members": [
        "dd58e7fd-f420-4f6b-aefc-7a5dca83b488",
        "952a8a66-4769-48c9-a0f2-2a80794fe380"
      ]
    },
    {
      "cluster_id": "90ab0ebb-511c-4032-8a6b-928969e4d009",
      "members": [
        "e2d23983-7667-4870-a6cd-a7d2d20d2a5e"
      ]
    },
    {
      "cluster_id": "e20487a3-4fd3-48eb-b5a7-8bf0da331808",
      "members": [
        "41a2a877-f1fd-4480-8fdb-278293229f68"
      ]
    },
    {
      "cluster_id": "2007b8f4-ae8f-43aa-a61a-6788fb1351fe",
      "members": [
        "6833344f-17e5-418f-b9ef-61fdf01954e9"
      ]
    },
    {
      "cluster_id": "705d1ff1-cf3d-455b-8c22-31feaaeb943f",
      "members": [
        "069aad17-1ac4-4f2c-9eb3-8efe16201b92",
        "d8854f92-f1ea-44f0-9fa5-20817a1a5909"
      ]
    },
    {
      "cluster_id": "d5777d75-d1f3-4884-9f6a-615b36a875d0",
      "members": [
        "11f16641-f62e-4de3-81ce-e859e15762af"
      ]
    },
    {
      "cluster_id": "d74329dc-5b82-41ba-94bd-2cdd8306d3ee",
      "members": [
        "d73cc3b8-a1d8-4ac5-b390-0139a4ecdb07"
      ]
    },
    {
      "cluster_id": "db3b032b-6eb1-469a-8fea-f26d907c46cc",
      "members": [
        "85fadf01-a4ad-4ed0-96a4-462d215554db",
        "a661cd4d-5ccb-4040-b44c-68d69c09f27c",
        "27eda906-14cf-4632-adc3-d243f4fd4936"
      ]
    },
    {
      "cluster_id": "f957765a-9482-4d2f-9d6a-a1c90e6281d6",
      "members": [
        "9f7f3797-8aaa-4201-81c8-c842f8a53406"
      ]
    },
    {
      "cluster_id": "7a4c0ada-5901-4c50-be04-047c13f1ba31",
      "members": [
        "1e88b0e6-9700-46f4-b372-9747c0551bcf"
      ]
    },
    {
      "cluster_id": "1e5040f4-1599-4a16-abf2-bb352e20053c",
      "members": [
        "26c377ea-9aa0-4ae5-a5ff-c70b5b9b037b",
        "2e8e07ef-cd9d-4f80-b243-70a6bca9511c"
      ]
    },
    {
      "cluster_id": "cab4447a-5d42-4fe2-b9b3-fc86f17d0ac9",
      "members": [
        "14b0574a-5497-4884-bec6-520c0f7e187b"
      ]
    },
    {
      "cluster_id": "f0140bf6-12ff-43a0-8d3c-60ad6ec418af",
      "members": [
        "eb701ce1-cfe6-4f8f-9fa3-89c1820a7a0e"
      ]
    },
    {
      "cluster_id": "1ed52c55-1d90-4460-9e88-861e6d435eee",
      "members": [
        "290f965d-5be0-464d-bdb8-163c06a62841",
        "4200e86a-175f-47da-99cd-bd8e9e246de6"
      ]
    },
    {
      "cluster_id": "d6d62bcd-4470-422b-bfb3-13d5db2da751",
      "members": [
        "9171e567-8474-4dc0-aa10-9b5430fa19c7"
      ]
    },
    {
      "cluster_id": "212b2ba7-fb93-422b-bfc0-bda99de8b498",
      "members": [
        "7f30264e-f0a8-4066-90b6-0e6cdef570cb"
      ]
    },
    {
      "cluster_id": "82ba7adb-7963-4264-baad-21315bacde1d",
      "members": [
        "488f65ef-7ae2-4e77-b989-9babfbb5e805",
        "9f5d5685-ecd4-4a38-8303-f36d9c747912",
        "a0a4f554-0227-41a3-b9b5-71d79a79b103"
      ]
    },
    {
      "cluster_id": "2a6f5cd6-ea11-4cf4-9d3b-fd691e67f194",
      "members": [
        "7b0ceb79-47c5-4f55-9476-3abeaeefd7d9",
        "23e62940-8b17-4720-ba2a-14719f390727"
      ]
    },
    {
      "cluster_id": "fbce63cc-2f89-4118-a74f-d93b0d57a756",
      "members": [
        "1f294a78-91a8-4caa-9aa1-e9b461ad1138"
      ]
    },
    {
      "cluster_id": "0c639465-7159-40b2-869b-06840b83505a",
      "members": [
        "982cb1ee-fd21-48f1-8a3d-bfd40e3429d6",
        "ff6cae56-e952-42b3-83a5-9ac9435224e6"
      ]
    },
    {
      "cluster_id": "88fa31fb-364c-47f5-bac4-4ecea848d93a",
      "members": [
        "2d919daa-b594-4887-9ca5-f369a56561fe"
      ]
    },
    {
      "cluster_id": "8366909c-b1ee-46fa-ad8d-775e130e5096",
      "members": [
        "2f078d96-b20e-4413-8048-be0643f7af7d"
      ]
    },
    {
      "cluster_id": "9cb46e58-ec9c-4071-b505-f4806f5522e9",
      "members": [
        "c9b71fee-b2bd-4e51-bf29-7781c2e90c97"
      ]
    },
    {
      "cluster_id": "d18315fd-bf62-472b-bd6c-313e812011cc",
      "members": [
        "b3aea6b4-75f7-4ddf-a535-2c6ca0fba585"
      ]
    },
    {
      "cluster_id": "c06d1b4c-ebff-4c43-a158-e1cf96a68d7f",
      "members": [
        "c5c28d20-4097-4e54-a9b0-4de1dcaaa54e"
      ]
    },
    {
      "cluster_id": "a4d6044a-4bd0-435c-beb3-a719ddfd1f0d",
      "members": [
        "1cbab3a8-5125-41f5-a425-e491a7ed893e"
      ]
    },
    {
      "cluster_id": "4367ebc4-e97e-4992-a822-025c7b42b1b8",
      "members": [
        "00e0bfe7-02d5-4c5b-8823-5a7b0a8cafe9"
      ]
    },
    {
      "cluster_id": "b43cd636-593a-444c-9022-279eedcd0450",
      "members": [
        "a7e56323-9b45-4421-9a5f-ac7b55680d47"
      ]
    },
    {
      "cluster_id": "a300ef79-1ea5-4eb4-b149-74426ea09a66",
      "members": [
        "81e24f29-a832-4e4a-a3f3-9ab6863e259b"
      ]
    },
    {
      "cluster_id": "178a55a6-f879-45f8-85be-38fbb568a251",
      "members": [
        "3e77f882-da44-4f36-827d-0efb5922246f",
        "855fdde6-02a6-438e-9904-7d2c5d4f57c4"
      ]
    },
    {
      "cluster_id": "a608e3f3-dce6-4fd9-9684-b60e35b55c85",
      "members": [
        "fb2493b5-37a0-4fd7-be13-669c7eca68f0"
      ]
    },
    {
      "cluster_id": "25f83819-e436-47d4-a6ab-ce489fc70293",
      "members": [
        "c164484f-230a-409f-9758-d9661a1dfdbc"
      ]
    },
    {
      "cluster_id": "a174fdfb-5e90-4340-85c5-f1498bd04f82",
      "members": [
        "b69d524c-6494-4c32-8608-033f7422210b",
        "bb93d367-6956-436d-996a-599f0fa232f7"
      ]
    },
    {
      "cluster_id": "b175f6e9-a72d-4057-b833-76aad93255ef",
      "members": [
        "1216cb70-b558-48b1-a035-c50f00f83f02"
      ]
    },
    {
      "cluster_id": "fca8c069-2da0-43e8-8cac-08662970bcda",
      "members": [
        "d4cd80eb-eaac-49af-b68c-dc1b44a1d8c1",
        "c51b41b1-9760-4339-854f-287b00ad0c84",
        "65c1d41b-b2cc-460f-a33b-8c41a52344be"
      ]
    },
    {
      "cluster_id": "7e336202-10f1-4b91-9736-78eda34d2dbf",
      "members": [
        "7c04ae5d-4a31-4b8d-9b2b-48941ac82d8e"
      ]
    },
    {
      "cluster_id": "f54fdd0e-ba75-4fde-af1b-64b83311ab6e",
      "members": [
        "317ef0dc-064a-4eec-ad55-b8802b8eaa8b"
      ]
    },
    {
      "cluster_id": "26e9ba08-6532-4ec2-802f-bd0940d07dcb",
      "members": [
        "de1aef64-ff12-45b5-af12-ecc0c0e0dd6a"
      ]
    },
    {
      "cluster_id": "b3d06a2c-7adf-4967-b1b6-b69e35711ca0",
      "members": [
        "0f88ce35-bc1d-4580-9fa2-5a62b51ad3ff"
      ]
    },
    {
      "cluster_id": "d2b4f80e-7d68-4944-98c8-306c2b192c15",
      "members": [
        "0a3948be-fa4e-4cc4-acb8-1d150f116106"
      ]
    },
    {
      "cluster_id": "fdb454eb-b6d8-4e69-94d9-d465733df395",
      "members": [
        "f234ae8b-1609-4236-bc79-01d2349b02fa",
        "305801b7-d80a-4635-87e0-37b6be94a5dd"
      ]
    },
    {
      "cluster_id": "448377aa-104a-47c8-b987-d7ae3a311686",
      "members": [
        "21599273-58f4-4ab5-8c60-a98236a967d2"
      ]
    },
    {
      "cluster_id": "dbc38a4c-6662-4d84-ac44-e5687dc9ef37",
      "members": [
        "25d1f51d-e212-4b08-afdc-65ff45ee0f4d"
      ]
    },
    {
      "cluster_id": "cf3bf537-5d66-4200-ab53-fd6a34c1b11b",
      "members": [
        "e458de25-c9df-47f0-afe6-1796e559fcb1"
      ]
    },
    {
      "cluster_id": "4194b8ef-5709-47af-9e86-ee10aeeb4788",
      "members": [
        "e6db8dbb-15ae-4e34-8aca-fdf86f5b9ebd"
      ]
    },
    {
      "cluster_id": "21b385c4-010f-457b-bf2e-d3d6a55a5ca1",
      "members": [
        "c527f6cf-f471-410a-825d-64d88a963398"
      ]
    },
    {
      "cluster_id": "a20fa4a8-bba3-463b-b15a-06c8b4daad85",
      "members": [
        "ee5d46b3-019c-4079-a705-d2dfc0d8995b"
      ]
    },
    {
      "cluster_id": "8b4dea1f-81ef-489e-9aba-a19d5e926009",
      "members": [
        "011dd188-f1c1-4ef7-9cf4-b23255a9d81d"
      ]
    },
    {
      "cluster_id": "f3191f0a-3803-4bca-ad51-304e3f825638",
      "members": [
        "ae04373a-93b5-47da-9a0f-0e8036c84fd6",
        "a0b81173-c01e-4db3-8d19-28bc14e6c940",
        "0e2438b5-a88a-40f5-ae90-35c5e5255069",
        "3d02c32a-ad40-424f-8606-b4f8dfd8d519",
        "98efc04f-bb71-4262-8754-21a2dbb96c1b"
      ]
    },
    {
      "cluster_id": "8b0583af-b0d6-4ff0-b992-807e026b5368",
      "members": [
        "a31e1259-d292-49ef-94fa-29c7e8cd09db"
      ]
    },
    {
      "cluster_id": "d6c38bd4-e404-4cb6-beee-cca25c7586ab",
      "members": [
        "e79b0b35-8d39-4282-b94a-f53bee81a959"
      ]
    },
    {
      "cluster_id": "1f127567-1266-42ac-9246-3f7f8bb52a6b",
      "members": [
        "fd77cdad-ac76-4700-a8ca-f00ee60425bd"
      ]
    },
    {
      "cluster_id": "19de02b2-6078-4f7b-9502-207e4c4f5e72",
      "members": [
        "e2a21ea9-3308-432d-8ebb-36f2b2454894"
      ]
    },
    {
      "cluster_id": "acad8d82-630a-486f-9b73-624703b74a12",
      "members": [
        "646a3db1-5b56-4be1-9ced-855abb1cfc03"
      ]
    },
    {
      "cluster_id": "a24aba28-4a37-469a-9d41-dfd554a4594a",
      "members": [
        "744b28c1-e44c-4d91-afb4-3e9432206ea4"
      ]
    },
    {
      "cluster_id": "21533f1c-ae42-4579-91e2-803b34beb003",
      "members": [
        "b13b8ba6-a597-4fbb-8b0f-2e3bd1ab8cf9"
      ]
    },
    {
      "cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a",
      "members": [
        "cd094e65-a841-43b3-9e0d-41d503722dad",
        "e530d934-99db-4543-9afe-a2d89c6fc26f",
        "bc81656f-dcd2-4cdb-98cf-067c7fe2086a",
        "e3d31e50-cadc-4608-9267-4e1ae603cea0",
        "84f271c8-1fba-4ded-a316-c79332085a5f",
        "8556b458-d003-4b29-9c94-899b30ca4564",
        "9f61cba0-938a-4422-abfa-db301ff868e1",
        "7eebea58-eccc-43d6-9605-78c5068074fc",
        "a084da89-c83b-4afd-b54c-2a8112ec592b",
        "363468c4-86f4-4e0e-93e1-66b5ad465c7a",
        "dde15ad3-c3ed-41c9-9c7e-212a0268b2f4"
      ]
    },
    {
      "cluster_id": "4f2789db-45a0-4f05-86be-a25e7794e0d7",
      "members": [
        "bdbc72ed-e397-4bcd-b6eb-2f5ea4b6c477"
      ]
    },
    {
      "cluster_id": "ac17d012-fb03-4978-afab-d0ee9527705d",
      "members": [
        "782598c4-3b71-498b-91e6-1b5df6772bd2",
        "79088632-2935-4ce9-9241-aa7bc44d76ba"
      ]
    },
    {
      "cluster_id": "0829b680-8676-4565-bcc1-70f1f8778ca5",
      "members": [
        "bc6770da-14e1-4f86-9e0c-dafc0b7fa65a"
      ]
    },
    {
      "cluster_id": "b7f11387-382d-4aee-bfa5-1f8b22da06c2",
      "members": [
        "ab1b4aca-b869-4d1e-9822-0200cd4f4d27"
      ]
    },
    {
      "cluster_id": "86571ae0-c94d-4246-a1b9-4b9547fc239a",
      "members": [
        "5a4298c2-30c7-43d1-ad99-2ff20e2ef3f8"
      ]
    },
    {
      "cluster_id": "0ca4759c-9c4f-421f-b2d0-dbefe4601911",
      "members": [
        "90ef5e33-2377-4289-845e-3349a31525bd"
      ]
    },
    {
      "cluster_id": "8d1da449-ead9-4d20-b9d7-330964de7727",
      "members": [
        "1fc8ca06-ea64-4a71-96be-945d2e3a2895"
      ]
    },
    {
      "cluster_id": "fea07608-613d-4c2c-b77c-a335119ce351",
      "members": [
        "2a0a6670-7ba1-4904-9910-0e88353ed5b8"
      ]
    },
    {
      "cluster_id": "ea73cbad-05bd-4c4c-8cae-169119be8355",
      "members": [
        "0edbfb46-f456-4efb-881f-2b34fc87b18d"
      ]
    },
    {
      "cluster_id": "f677d3a3-a108-4585-8030-41b82d49252c",
      "members": [
        "7abbfcf9-ee39-451c-a75a-35ff181a3d15"
      ]
    },
    {
      "cluster_id": "c44f1953-a41f-47e0-ba2d-7e2e1a5e8ffd",
      "members": [
        "0c91468a-2a3c-435c-a993-912dda8a7cdf"
      ]
    },
    {
      "cluster_id": "908eb720-8ab4-48f5-a6b7-fd316c77c27a",
      "members": [
        "9f70852a-2701-4ba9-9d9d-97b130038454"
      ]
    },
    {
      "cluster_id": "1380f196-a8b4-4593-b276-1ee4b9b19dc0",
      "members": [
        "49e89fad-7de0-4303-8429-105554aaaf25"
      ]
    },
    {
      "cluster_id": "3a1c123d-a3bb-42e2-911f-77ddeb67d2ee",
      "members": [
        "9c35ac88-ea62-4815-b760-c00c9c418ca3"
      ]
    },
    {
      "cluster_id": "e3df2907-4da7-4352-a8ae-dd0543915bd1",
      "members": [
        "d340a967-11d6-4e32-9f59-5546d3b71998"
      ]
    },
    {
      "cluster_id": "2f956586-babe-4398-aff8-0787b3e3a21b",
      "members": [
        "530384a0-da14-4c11-95b2-1d4601ad9ad9"
      ]
    },
    {
      "cluster_id": "017489d6-d7b2-4b12-8669-3769c4704bdd",
      "members": [
        "ab204757-11fb-43a8-aa32-1e0a1b33be3f"
      ]
    },
    {
      "cluster_id": "301dd553-d836-4dc3-8b50-cd3953d38a18",
      "members": [
        "2cceeef1-da92-4d2f-bda6-aacbc8937b8f"
      ]
    },
    {
      "cluster_id": "41a86152-c66a-450d-8bf6-edd50f6928b1",
      "members": [
        "9543425d-8280-44dc-aab9-eeef9487b257"
      ]
    },
    {
      "cluster_id": "428b927b-4796-43a8-8135-01b21725b127",
      "members": [
        "e9c1f3d6-96e3-4d8e-b076-fdbba6676c29"
      ]
    },
    {
      "cluster_id": "fec39a26-1bf2-4183-bcb5-a33cc47fe4d3",
      "members": [
        "f58e959d-deed-43a8-af64-556af3a0477d"
      ]
    },
    {
      "cluster_id": "836ea24a-dc8d-4499-b021-d9c9b600cc60",
      "members": [
        "3f30c01d-d5b9-4759-8745-26f91c87bb64"
      ]
    },
    {
      "cluster_id": "5a784d1e-f3a9-480f-aa31-7625b9b944ce",
      "members": [
        "c56cb11d-788c-4728-87b2-17d8f03e5a3e"
      ]
    },
    {
      "cluster_id": "1961443c-3bca-4540-a19e-508d4a0fa916",
      "members": [
        "4214672a-562c-4d52-ba43-6fa945b92796"
      ]
    },
    {
      "cluster_id": "ad63a5c7-e4a9-4703-80f2-827fc6b1bf0d",
      "members": [
        "6069bc47-89a4-4c4e-a60c-566e62b21b14"
      ]
    },
    {
      "cluster_id": "89133653-febf-4b4b-840d-0cb05ed61f86",
      "members": [
        "a5a64808-a7c7-4661-9b5f-05ea7b2697be"
      ]
    },
    {
      "cluster_id": "ef9e5931-dbe9-4ba1-af73-3f6fcb8ed6f7",
      "members": [
        "b1076592-2fd3-4abb-afeb-f82699e4392d"
      ]
    },
    {
      "cluster_id": "5d2d76b5-bc12-46bb-8cc2-844165ffb7e7",
      "members": [
        "0274fac9-ff73-42d8-ab6c-f9706fb26bd3"
      ]
    },
    {
      "cluster_id": "3fab82c9-6db0-4a96-9fa3-7e0add6da8ba",
      "members": [
        "9de7a865-05de-4bfd-8512-7931d7ede270"
      ]
    },
    {
      "cluster_id": "98c5d764-86f9-4cd2-ac58-1dae1f5811e9",
      "members": [
        "85b0b58a-88f4-44f0-9cb5-3b591e53a1e2",
        "2a611ae1-745b-4bb1-ae10-25288b6cb9fc"
      ]
    },
    {
      "cluster_id": "028ee870-e258-43cd-99d3-f13e457b70d7",
      "members": [
        "6426368d-5503-45b4-825a-3f6508459459",
        "d2dc63a2-a2b0-46f3-9c28-22af90aa8310"
      ]
    },
    {
      "cluster_id": "fd853489-07e0-4489-8d20-abb8f80a4213",
      "members": [
        "496b698b-bfc6-48ab-b701-a0216bacebd1",
        "127c55ab-a974-4e8d-9a9d-a68dd053e4ab"
      ]
    },
    {
      "cluster_id": "f3affcd0-acdc-481e-ad0d-c22c5984f9af",
      "members": [
        "a64f47b0-62d9-4146-8c80-840ec0985236",
        "284bc88d-467e-49c3-ae5d-9caf059afb7a"
      ]
    },
    {
      "cluster_id": "82261ab3-3caf-4c24-ac0e-14c29ebf6f44",
      "members": [
        "fdae4493-7214-4d22-9884-468e8433f272"
      ]
    },
    {
      "cluster_id": "04fe8e71-8c72-481f-a6cf-1722df9454dc",
      "members": [
        "f9f3a1dd-044e-4347-853e-d47068e767c4",
        "efcfd10c-3281-4c5a-9c0a-b8ea84055f5c"
      ]
    },
    {
      "cluster_id": "3a4ae54e-e7b7-47e9-984e-62601ed45ab4",
      "members": [
        "4d20f04e-00ff-4651-a852-4ea4214217b3",
        "7af4f83d-eee1-4b0a-bd8d-b156233a65a2",
        "3866f289-5721-43dd-8f2f-d438225475a7"
      ]
    },
    {
      "cluster_id": "b69dac95-ca24-49e5-b472-f36e5a0721b8",
      "members": [
        "692bca93-f602-436a-b0f2-d5cbc808bcc1"
      ]
    },
    {
      "cluster_id": "35b184f1-0b55-4cee-b0ea-dcbb0d7633eb",
      "members": [
        "eaab707c-78cc-4a71-a3a1-6e58581e9572"
      ]
    },
    {
      "cluster_id": "7050bafb-b05d-4691-a1ac-89175bc41e54",
      "members": [
        "0fc411dc-0366-4f41-ba26-7fe26283c363"
      ]
    },
    {
      "cluster_id": "6fd0cd66-7572-4a5e-b9bd-53c174988cbc",
      "members": [
        "8df6167c-43a9-440a-83e3-dfb9c10de779"
      ]
    },
    {
      "cluster_id": "baf69b75-285e-4447-b574-0c5bce010190",
      "members": [
        "fa07cd5b-e83f-475f-b9ea-4ba0d373d5e3"
      ]
    },
    {
      "cluster_id": "dd07650f-5b24-4fc1-a78a-9b6fc6589ccf",
      "members": [
        "08fe87ea-bdb1-49c4-ba4a-8da08b598af8"
      ]
    },
    {
      "cluster_id": "ac48c971-5c1c-4044-bc6f-2141fc11a1f0",
      "members": [
        "44a4cc47-ac51-408f-9d98-3af60f221d5a"
      ]
    },
    {
      "cluster_id": "68995fc4-d783-494b-a9d8-283e32c04543",
      "members": [
        "661bc774-cfb7-442b-b04d-b60a9966ae4a",
        "fd059fa0-37b3-4fc9-94f9-4d06b4db41a8"
      ]
    },
    {
      "cluster_id": "16e3503e-05e1-4d3f-9a7c-01b21a85311a",
      "members": [
        "fce93629-dc10-4e52-8b7b-bba9217858c3"
      ]
    },
    {
      "cluster_id": "0ab67aa0-2db3-4a91-9f5f-2305bd1d90bb",
      "members": [
        "8f85a016-f869-4492-a3bb-e9764dff12fa"
      ]
    },
    {
      "cluster_id": "1a1de2a4-159f-4a0d-8a46-97165bf27583",
      "members": [
        "aed65ccc-f1af-425a-893d-9abd19f90a0b",
        "541d6546-06db-4a26-9bdb-a6bca271336e",
        "406b1fbe-7199-4fa6-aef8-6543f5fb49a2"
      ]
    },
    {
      "cluster_id": "2077703d-3e6d-40f8-85a7-39edc747b3a1",
      "members": [
        "ea903ec9-a353-49e9-8bfe-6fda508a4947"
      ]
    },
    {
      "cluster_id": "b93f0980-3e05-4353-b9af-768e6f562f26",
      "members": [
        "b52a5a04-4c42-47d9-94b7-248dd3212a3a",
        "0acc9dfe-649c-470f-ada8-59734a0d6699"
      ]
    },
    {
      "cluster_id": "2d8d907a-2ce9-4878-ba6b-55a8ba564f43",
      "members": [
        "5638859b-a4e7-442a-9258-7c016db35b11"
      ]
    },
    {
      "cluster_id": "99d24268-130c-4375-a4e7-e999f58720e8",
      "members": [
        "628a9231-baea-46d1-935b-0ca2ff01b00d"
      ]
    },
    {
      "cluster_id": "01f44311-0ef8-48af-a616-086ce88e4356",
      "members": [
        "397d33bf-097c-4ee9-99e3-1a1d910daf3f"
      ]
    },
    {
      "cluster_id": "4785bab4-a99a-4e40-9619-5133dfc2b141",
      "members": [
        "7b77283b-32ba-4208-84fa-7ab5e7cab570"
      ]
    },
    {
      "cluster_id": "41b103ed-acbb-4350-80df-1fd2deb0346c",
      "members": [
        "517da9bc-9b77-4f9b-9fdb-7c76ed94c54e",
        "ce0645ec-7609-47a5-9cc2-2fb81d723322"
      ]
    },
    {
      "cluster_id": "ac4b1f63-94c9-4cd0-938b-a716a9ba6a09",
      "members": [
        "46e40007-007b-4112-bdb6-e0353838f067"
      ]
    },
    {
      "cluster_id": "635850fb-0b7d-4148-aae4-786dbec7ebb9",
      "members": [
        "bdb28899-4f74-403d-b02b-ea957505918e",
        "463b0a4d-fbae-49b8-8f14-ea008bffbf2a",
        "dcf68337-ae54-4f8a-8271-f76115e03f87"
      ]
    },
    {
      "cluster_id": "67731679-09bb-4b58-92bb-6990e6c5fa20",
      "members": [
        "2f38e888-600f-4e0c-aa5d-aea6ecf44f01"
      ]
    },
    {
      "cluster_id": "70862016-3977-4b4b-9e68-43859faa28ba",
      "members": [
        "b2abf8f5-257b-4d02-9d1a-28829bf1cbb6",
        "79267d8c-556f-4ae0-a361-17fd8204735e"
      ]
    },
    {
      "cluster_id": "6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00",
      "members": [
        "f15d0ff0-d9e9-4d3f-b9c1-eb0345438bb9",
        "b5b1d0f2-cb71-4b4b-b1b5-993a136abdb7",
        "459b2077-c724-4735-a64f-e274a8dff816",
        "d7f28da1-8d0b-41af-bb67-719a1bf0eec9"
      ]
    },
    {
      "cluster_id": "08533bcb-cb39-43d6-9371-79f7aa905623",
      "members": [
        "b9f18053-5037-47c8-8598-331be2a79964"
      ]
    },
    {
      "cluster_id": "dbe1780e-f93d-4eae-8780-d2a73e00ae56",
      "members": [
        "5adb0ff7-d9bc-4670-85ce-aad1368b41a7",
        "3fb2d7f6-e88e-4db6-864c-66144ced3735",
        "b0d8f0c7-fa85-4070-a3f9-bb1353c4596f",
        "32dd5dab-f7ef-4cd2-ac64-759def9b81d4",
        "cbf6ac36-0c7f-4daf-ada1-66917b3bcc6c"
      ]
    },
    {
      "cluster_id": "c1b67021-ee6c-440d-9e1a-3565b3ab3f41",
      "members": [
        "759c7475-0897-4647-8b0e-031cc9ba6232"
      ]
    },
    {
      "cluster_id": "d990ed81-4fe6-482e-9afb-51f8ad32db00",
      "members": [
        "14147b89-0d92-4319-8775-66863cf40aaa"
      ]
    },
    {
      "cluster_id": "71cbbb7d-55a3-4b3d-a593-9d2df11352a4",
      "members": [
        "197ea094-6998-46eb-9eb0-c42038338cc9"
      ]
    },
    {
      "cluster_id": "923eb3f0-4a80-4604-845d-2264e5473406",
      "members": [
        "aaac4db6-2c1e-41e7-8c9f-d6b353262207"
      ]
    },
    {
      "cluster_id": "ecf87520-6110-4dbb-8897-a76147b7c3f7",
      "members": [
        "4c49be1c-4984-43c9-84ea-20cd6554a9bd",
        "4be45854-769b-4cdf-8d32-7ef709f38bad"
      ]
    },
    {
      "cluster_id": "8a0a3a15-f4ec-4089-82e3-0da6ba69f921",
      "members": [
        "aef8d776-73de-4a9a-9ac9-77b9a76a5c9b"
      ]
    },
    {
      "cluster_id": "ed5d05a0-5035-40ad-a517-d570266b42b4",
      "members": [
        "73b90fd6-25aa-4c74-9c05-806da37bc137"
      ]
    },
    {
      "cluster_id": "0cacd6f0-a483-4fb9-8635-2cc0f4273b40",
      "members": [
        "efd598c6-13e3-4a3a-ba1d-f2040f478439"
      ]
    },
    {
      "cluster_id": "f79fc6d6-3df1-4383-96eb-f3d73361c492",
      "members": [
        "4153fc76-dd06-46a7-b833-59462ffcf3c0"
      ]
    },
    {
      "cluster_id": "42663758-9518-49e1-a45d-11b8ad2a2193",
      "members": [
        "3eb3429b-5a86-4636-823b-47d12f8e009d",
        "cf200205-e78e-440d-a9d8-77fbd362cd37"
      ]
    },
    {
      "cluster_id": "7e03d5b5-4b07-4e72-b62b-55465d7f9333",
      "members": [
        "668ec28e-19b5-4953-b1fb-eb9dd4e4d330",
        "9289fbce-8f31-4b85-ab17-0f329026a889"
      ]
    },
    {
      "cluster_id": "2702052c-d199-4761-be47-a9217e23735a",
      "members": [
        "166c481a-983c-434e-ad60-01d7318a666d"
      ]
    },
    {
      "cluster_id": "84d8eefe-324c-44a5-b6d1-c374c46cc323",
      "members": [
        "14b9ea79-ae03-4f42-a138-9c2ffee5b826",
        "508ef568-3b2c-4f93-8997-e4cfbd121e8f"
      ]
    },
    {
      "cluster_id": "4b5a21e3-57c3-4239-8ed1-85b9925a8673",
      "members": [
        "aa7457aa-e2b7-41e3-a76f-f250452d8ceb"
      ]
    },
    {
      "cluster_id": "995b974f-591b-482e-a707-9ef62e9bcb2f",
      "members": [
        "ffa893cc-5751-4cc7-9631-5cb0757e751c"
      ]
    },
    {
      "cluster_id": "f7ba632a-cef8-4360-bbef-dd149ddc5163",
      "members": [
        "ca6d6bb8-16d5-4838-b68f-17ff29aeff1a"
      ]
    },
    {
      "cluster_id": "7f8a206d-56f9-43fd-80ec-c184e678a121",
      "members": [
        "f606eaed-f36b-4ad7-974e-d69792b06e3b"
      ]
    },
    {
      "cluster_id": "f44a9570-1523-4d3e-9b69-1e328e9b2946",
      "members": [
        "6b6ffa0d-1e38-4bae-9088-3abde339c3da"
      ]
    },
    {
      "cluster_id": "335924d4-8c81-4bf0-8e93-746bc3bcb081",
      "members": [
        "60688d2b-1218-4d31-a856-9c2cc98ed3c0",
        "da008d27-7472-4d62-996b-7ab8966b19c8"
      ]
    },
    {
      "cluster_id": "93302bc5-2c4d-4a14-9964-fc677c0db641",
      "members": [
        "a46bf700-8a4f-418d-90fc-003b0bc7228f"
      ]
    },
    {
      "cluster_id": "0e5c3365-93fa-488b-b635-43b68052b0bc",
      "members": [
        "023efd2f-37f3-428a-93b9-9851efee1ab9"
      ]
    },
    {
      "cluster_id": "6659a589-3901-4e01-8d7f-eb3e9f204a10",
      "members": [
        "7e57b3b3-1ccc-4646-9659-c2d94da11186"
      ]
    },
    {
      "cluster_id": "45b3db14-d0a0-477b-afcd-d5fc5dbd7f5e",
      "members": [
        "da22f955-e91b-407e-93b0-ab51c2c62a96"
      ]
    },
    {
      "cluster_id": "ceeb447c-921b-4bff-b396-64b4ab69cf19",
      "members": [
        "222e7b43-94bc-469a-9da2-e6c7522401f7"
      ]
    },
    {
      "cluster_id": "119547c4-e528-4d80-bc2b-d8dc41ee62fe",
      "members": [
        "4ff9773a-68ff-4aac-9456-845b766f68d4"
      ]
    },
    {
      "cluster_id": "9821057e-b80c-444e-8823-153881d41c90",
      "members": [
        "a2e3ca06-1e5b-4d34-80b4-412d59aa3a43"
      ]
    },
    {
      "cluster_id": "9c86d7d6-beed-46e5-8bf4-a9b09bb7cc58",
      "members": [
        "738e1a9a-7001-45f2-bb32-ff4e61d6b48f"
      ]
    },
    {
      "cluster_id": "7c24e460-dec0-43da-b3ab-9acc84d4caeb",
      "members": [
        "8b3f89b9-71a0-4a88-96a2-948392d036cd"
      ]
    },
    {
      "cluster_id": "be6b5f43-b5a5-43db-8bdd-0c041f0efa31",
      "members": [
        "b0b99fd3-fa74-4103-ba15-cf12e47469ed"
      ]
    },
    {
      "cluster_id": "bb78b3cf-3fee-4d7e-b532-1ccb52ef3013",
      "members": [
        "41788b6a-450e-4c17-962d-bd412f1d352f",
        "904c1337-d922-43ba-aaf3-bee846b59cc8"
      ]
    },
    {
      "cluster_id": "8a7264fa-6b7e-44f6-b1f1-5b3267bbd42d",
      "members": [
        "bd3aba7c-ad6e-427a-a510-dc1e1bd9c7cd"
      ]
    },
    {
      "cluster_id": "d784ccaf-4509-4d9d-9ebf-0ffc15008e18",
      "members": [
        "06f72312-a33d-446c-bb6e-dc7b4ca210c4"
      ]
    },
    {
      "cluster_id": "725d8a20-a3a3-4517-9549-74f8eede8ff7",
      "members": [
        "cfdcf4da-e29e-4722-ac00-8cd76b398f94",
        "4c493219-0683-40a8-873a-f7ddd9e19aca"
      ]
    },
    {
      "cluster_id": "432f6df5-1641-407a-a774-485c9d80d467",
      "members": [
        "148553e6-d5d9-4816-96b4-c7c115faab4c"
      ]
    },
    {
      "cluster_id": "174c41e7-d29c-43ee-b99a-262cda821c4f",
      "members": [
        "d1a30a6a-894e-49d5-8382-00a5d409b387"
      ]
    },
    {
      "cluster_id": "21ef710d-94c3-43ee-b3be-224e0c033195",
      "members": [
        "b1f6ef8c-f80f-4565-a8e8-a1bec3e92ca7"
      ]
    },
    {
      "cluster_id": "94210717-ebb1-4a0a-897b-10e38931ad8b",
      "members": [
        "871edd95-2bef-4c86-80bb-e83c188a88cd"
      ]
    },
    {
      "cluster_id": "b1ded912-0980-4dc6-8e8a-bb1ae1f015a9",
      "members": [
        "416e955e-2300-409f-9ec1-c4fbafa37d57"
      ]
    },
    {
      "cluster_id": "94362393-c674-46bc-9e3a-666f4bf5a507",
      "members": [
        "2be73865-8f17-4c3c-8ff5-59077c2c2638"
      ]
    },
    {
      "cluster_id": "c0bc02e5-e391-4352-8bc3-69ffab45a6e1",
      "members": [
        "10350d56-fc35-41a1-959b-98a5220ab0e7"
      ]
    },
    {
      "cluster_id": "88637747-174c-4782-89a7-a4bbdeb1e9e1",
      "members": [
        "3a092639-1cc6-485f-bf1a-d92f6a336b95"
      ]
    },
    {
      "cluster_id": "62318edf-fc49-441d-85dd-789c9859f09c",
      "members": [
        "8d7aa242-a4fa-4805-bf07-4ab3531b4a46"
      ]
    },
    {
      "cluster_id": "9de91220-8362-4c94-b430-300c675c23e5",
      "members": [
        "80946d3c-7fd2-4079-b4a3-88da3b276d60"
      ]
    },
    {
      "cluster_id": "29cd39ea-ce90-496a-a9f1-6917924ac984",
      "members": [
        "3e4a8be4-4ed0-4553-b03c-128ce3fd4985"
      ]
    },
    {
      "cluster_id": "1044d7cc-fb67-48c7-a61d-abf5c9d0ee2c",
      "members": [
        "82615446-c1d3-4c85-8e0f-1e8ede770ad1"
      ]
    },
    {
      "cluster_id": "4a783d2e-0380-4a57-9e6f-4b34c23f0ad1",
      "members": [
        "ad67387f-fc3e-435c-a8bd-5e291653ae0b"
      ]
    },
    {
      "cluster_id": "ca8ae13a-f4c2-40ca-adf9-58a7907b79bb",
      "members": [
        "a865c1f1-ff02-4c09-aaf9-384d06d59fbf"
      ]
    },
    {
      "cluster_id": "47b5e189-9eaf-4e69-b28f-1f2681036c7f",
      "members": [
        "8b9464e0-9a15-4e61-923e-b378808a14b3"
      ]
    },
    {
      "cluster_id": "b8e61f96-24fd-4f99-870f-bc308a6c4198",
      "members": [
        "dec9a639-6063-45f9-91b1-011da9866da1"
      ]
    },
    {
      "cluster_id": "fe4e513d-3365-4bb1-b29c-ae02d053a2e1",
      "members": [
        "a3403f9f-ba0f-4ee4-82d4-1929b0c86826"
      ]
    },
    {
      "cluster_id": "bf711cc9-463c-4a50-a300-d24703735ee6",
      "members": [
        "29d024dd-2543-4a8c-97c4-a8b1bbf8dc29"
      ]
    },
    {
      "cluster_id": "1118439e-1d54-4e33-bac7-0813c7dbb103",
      "members": [
        "4a6442f1-c198-4146-b8d8-0bb0b72e9000",
        "6c9977de-a8e4-46cc-9f3a-cce09947f9d5"
      ]
    },
    {
      "cluster_id": "0ba7abed-e798-4cd4-b041-3026081313b7",
      "members": [
        "c68c064f-6ac6-46bf-9798-6cc7a03a8b57",
        "7d769798-8649-449b-9577-3ffe09615c87",
        "9ffdedc3-d9ef-4cb0-8934-d60d94a1b93e"
      ]
    },
    {
      "cluster_id": "210b8b9f-5f46-4fbd-8a43-aa4d24350d2d",
      "members": [
        "b5fc4724-c9a3-462d-ab84-5bebcfdb6783"
      ]
    },
    {
      "cluster_id": "11c3011e-be2e-490b-b73b-6b530385f70c",
      "members": [
        "52cf9b3e-9f25-43fa-8939-e7866cc8edc6"
      ]
    },
    {
      "cluster_id": "009adb33-ebed-4470-bd79-30fe1e0fa2d8",
      "members": [
        "1ac986cd-7418-4a77-a69d-a9308b8761cf"
      ]
    },
    {
      "cluster_id": "deae8114-2508-4864-a544-401d4150e26c",
      "members": [
        "e1ef5d87-f3ec-423c-9813-c9a4921268c1"
      ]
    },
    {
      "cluster_id": "f38958f6-adfc-406e-ab46-296dedeeb781",
      "members": [
        "07477746-79bf-40ea-a2a4-df204c59d1e4"
      ]
    },
    {
      "cluster_id": "17c72ecc-bde7-4838-bd7c-6c235f6a23e1",
      "members": [
        "340bee43-d3fa-492a-b0c5-9beef5cdaf32"
      ]
    },
    {
      "cluster_id": "a486e470-c569-4ed1-8cc9-0f9109ad027d",
      "members": [
        "f20f07e3-7db3-4e45-857e-a44b98c2bb8e"
      ]
    },
    {
      "cluster_id": "02ee18ae-cb4c-43b0-8eeb-127e5d8f1ac9",
      "members": [
        "b293d682-81e8-4ee7-98f5-08d38125f280"
      ]
    },
    {
      "cluster_id": "654fa001-54fb-4d51-b87a-8207c38aeb88",
      "members": [
        "477b8e23-3732-45bb-8214-4be4d59e06f8"
      ]
    },
    {
      "cluster_id": "6bbdc559-2725-4b4d-bee7-05ff3de480c4",
      "members": [
        "4203c331-94df-4947-baaa-31ca888f30bd"
      ]
    },
    {
      "cluster_id": "030691e7-b00a-48bd-99cd-b8a82a2565cc",
      "members": [
        "bcd1fd82-eeae-492b-8e3b-aae60422d657"
      ]
    },
    {
      "cluster_id": "f70debef-4097-402b-81f2-0ddc396e0729",
      "members": [
        "2b5e3663-84d6-4872-8663-13535c6a2ef9"
      ]
    },
    {
      "cluster_id": "2cfd963e-dc73-4d82-9776-ae618471ae77",
      "members": [
        "4fb30839-ae13-419b-b046-54c5b4ab1faa"
      ]
    },
    {
      "cluster_id": "0033e72b-385a-41ce-8ba3-fd98c6521d05",
      "members": [
        "22e7c561-5c28-435c-a056-a2a7ac35b322"
      ]
    },
    {
      "cluster_id": "1bbcbe31-d9c2-415e-aa16-c9d78fd6946a",
      "members": [
        "6e1568f5-503f-41be-af1f-55c802c66507"
      ]
    },
    {
      "cluster_id": "76ddd218-4f5f-4047-8ee4-faeb581b90a7",
      "members": [
        "9eb46b0c-d447-445d-aef2-1288e56731a2"
      ]
    },
    {
      "cluster_id": "a343f83f-a09c-4c76-ac05-045d273e90c8",
      "members": [
        "49ae5188-a2ca-4673-ae24-883f12ed99e9"
      ]
    },
    {
      "cluster_id": "05840b29-9ac1-459e-98bf-cb3a11b4aeb6",
      "members": [
        "66942d3b-11e6-4000-89af-63719adda485"
      ]
    },
    {
      "cluster_id": "c9299dd8-c218-46f0-b151-8c752a7421c0",
      "members": [
        "f57ff950-9e13-483a-bec5-974eb37e4703"
      ]
    },
    {
      "cluster_id": "1fb65a9b-f85e-4764-8dae-68053166a895",
      "members": [
        "4eed5196-441c-471a-ae3f-d55887c0f063"
      ]
    },
    {
      "cluster_id": "38bb4737-de3e-4b8d-b413-8281bb85ae27",
      "members": [
        "efe09af4-3d29-4a10-9c20-6c42ab3563f5"
      ]
    },
    {
      "cluster_id": "827f6b49-228f-4d42-afa2-d86a5b588a72",
      "members": [
        "630437eb-fd43-4d0f-83bc-76d2f57ecc70",
        "e205fce5-7add-4723-b183-f8e3f4793203"
      ]
    },
    {
      "cluster_id": "c6262c2d-c819-43cf-9414-2109754b60a0",
      "members": [
        "ea07027f-897a-42f0-af9e-4de7f1333cf6"
      ]
    },
    {
      "cluster_id": "83103bb6-3126-4ae8-b437-2a2305839cc6",
      "members": [
        "c2c81ff6-a163-475a-8383-769d632a3191"
      ]
    },
    {
      "cluster_id": "e79e7825-9f83-4c5b-92dd-af1bdccc56ef",
      "members": [
        "9702a8e5-c44d-44a6-be11-b88dfba3d229"
      ]
    },
    {
      "cluster_id": "8820c527-2e2c-4341-bec1-16e1d5309310",
      "members": [
        "a1a140b4-c1ac-491d-9ae3-3620a0004758"
      ]
    },
    {
      "cluster_id": "2f612694-7e7c-42ff-aef8-a4f09e365266",
      "members": [
        "97ee6a53-1aab-4a11-bbc3-1775ff749efb"
      ]
    },
    {
      "cluster_id": "fc7e97b6-8dfc-454f-b469-c14bd479fe70",
      "members": [
        "1897c2f6-b5bc-491a-948b-25ea30ab87f9"
      ]
    },
    {
      "cluster_id": "31310d54-1285-4857-b35a-cbc2a3d3bfc2",
      "members": [
        "dbb30e81-3924-4957-9510-c3ca70ff3cec"
      ]
    },
    {
      "cluster_id": "21f0a219-a107-4e6e-aa28-e010ad5aec66",
      "members": [
        "e6ac3ba2-6553-40c5-93b0-47155aea88ef",
        "8575edeb-b639-4048-a541-0e8f08e0f1a6",
        "5f4ab424-0937-49e2-bb1c-22aac0430f2a"
      ]
    },
    {
      "cluster_id": "078eb0c7-fae2-4ffa-b527-48c6683af72e",
      "members": [
        "776e7b52-5ed1-4439-9f2d-40f2b49ba7fd"
      ]
    },
    {
      "cluster_id": "5f181f74-d991-4908-aaf7-6917a17dca75",
      "members": [
        "1c08e4c5-9840-441f-9216-d5589e6804b8",
        "4b96c116-8ff6-4180-aa3a-b5e6d65f179b"
      ]
    },
    {
      "cluster_id": "0b719ed0-60f8-42bb-9426-ff2a477557b7",
      "members": [
        "9a26c070-19da-4eb1-83ac-f92c3c2f2535"
      ]
    },
    {
      "cluster_id": "ddc5360a-1ac4-443b-9995-2e77ae3fa0fc",
      "members": [
        "246072d5-0023-42d5-be4d-192210543c42",
        "2536d3cf-bc39-485e-a4b8-00382b9abfc9"
      ]
    },
    {
      "cluster_id": "04568cc7-5dd8-42b7-8a07-715cdd043c03",
      "members": [
        "dc5b6b43-1d7f-4cc1-a0c8-5798df242073",
        "67fe157c-0a35-49a8-8f21-5628c7797662",
        "76636031-6955-46e5-a38f-1c8ceea4854d",
        "4959890f-ec07-4467-9894-7ea899d38684",
        "0e39736e-26f4-4f9d-8ba1-967054b6d03a"
      ]
    },
    {
      "cluster_id": "a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f",
      "members": [
        "4e10df47-ecd3-420b-ace6-784d39da51ec",
        "c5eb6bc0-d315-4389-b537-4ff24b37b0ba",
        "1dc2d18f-7d20-40b4-b306-835da288cc24"
      ]
    },
    {
      "cluster_id": "84ba9e08-7f87-4e91-abf6-4415ddb9a231",
      "members": [
        "8b1417ae-1c79-4395-bde9-31cc95079fcd",
        "0d8942c4-d969-40ab-9b61-d3b6492557d5",
        "5f546275-52cd-41ca-8f20-759766d0002f"
      ]
    },
    {
      "cluster_id": "91638e17-92b1-4187-b7cf-b00589f88898",
      "members": [
        "65ed18a6-46ca-42a4-b659-ffd3e80e398c"
      ]
    },
    {
      "cluster_id": "84a0d215-8113-4569-a05e-d15e5c91d360",
      "members": [
        "46862e25-4144-4ea1-8438-f36b6c8106e2"
      ]
    },
    {
      "cluster_id": "905316e3-c2fa-42ca-821c-e5be344dac59",
      "members": [
        "6a5ffe53-8ea1-4ce2-b101-76838a82574d"
      ]
    },
    {
      "cluster_id": "00853d63-b913-4804-b64a-2b243a93e06b",
      "members": [
        "83a845fb-f008-4586-97a0-4ebed68224f1"
      ]
    },
    {
      "cluster_id": "e550706a-507b-4244-b8a2-1df630cff9aa",
      "members": [
        "34141a13-a411-4858-8ce0-1aeb316e65b2"
      ]
    },
    {
      "cluster_id": "98c1c320-efc0-41d6-bc35-eaf849b7cea7",
      "members": [
        "4f1143e9-8a23-407d-97eb-ba5c9cd9c89d"
      ]
    },
    {
      "cluster_id": "7c8be876-c0d6-46b2-8e28-be16ba79de4f",
      "members": [
        "2123eb04-aef5-4732-a991-e130cad08ea7",
        "c8863369-10d7-4a7b-8a44-8be24f3cb312",
        "3d1ea1a5-3946-4ee6-ae7e-484f3bdf70ce",
        "876a0e31-fed0-492e-9930-125af3ca6ca0",
        "24eb783a-7899-40b6-bd7e-19f05a363867",
        "3e86ebe1-a67e-4d4b-848b-e3d840e4902d"
      ]
    },
    {
      "cluster_id": "27a5d354-dacf-469b-b094-7b2ad6fec31b",
      "members": [
        "ce2f9ef4-b333-407a-8bed-225eac1f4180"
      ]
    },
    {
      "cluster_id": "6f960627-d475-4f28-8eb0-dcceb972aad4",
      "members": [
        "3308e491-e157-43e0-9b6c-4a9d02687351"
      ]
    },
    {
      "cluster_id": "f5b9ae68-f130-44e1-85ad-1d8a741fcea1",
      "members": [
        "1926b8d1-77b0-4125-9064-fd191cec71bf"
      ]
    },
    {
      "cluster_id": "65ee7ca1-956e-448d-a404-e5c643989efe",
      "members": [
        "8f273d19-4c8d-4d81-af8b-347364d3cf78"
      ]
    },
    {
      "cluster_id": "9d7361f1-563b-4b70-8f5c-fc18e12402d2",
      "members": [
        "b41bba8e-2c4c-4c7b-84e6-ac57b3efe67c"
      ]
    },
    {
      "cluster_id": "4e53dc9a-0b46-4ddf-8ff5-f5172619e371",
      "members": [
        "0895f651-9e7a-4f35-85b9-11d230569161"
      ]
    },
    {
      "cluster_id": "b9239d36-ef30-4a43-92f9-8fe391efcc3e",
      "members": [
        "cecd8282-63f4-4288-a013-3c27da5e1ce6"
      ]
    },
    {
      "cluster_id": "b20e50fd-ac66-49b1-9139-e41a882a2619",
      "members": [
        "6c53d5bf-7d7d-48dc-9537-69146547313c"
      ]
    },
    {
      "cluster_id": "5b67eeb9-9da5-4079-bb66-f861e834a37c",
      "members": [
        "d7276325-292a-412d-b146-87a0730b45b3",
        "dea4f733-4356-40fe-91e7-6054577b69a7"
      ]
    },
    {
      "cluster_id": "80ee24ce-2b7b-4d6f-9630-2bec3ade3b3e",
      "members": [
        "6821b41c-0ed3-446b-b813-0315afb69e66"
      ]
    },
    {
      "cluster_id": "3ba005de-dec0-4cc4-8a3c-a3679d6f072a",
      "members": [
        "64d6f3c5-199a-4540-9425-eff3a9b82273",
        "5a950cce-9f3d-4ba0-a51e-e8a2b37a97bf"
      ]
    },
    {
      "cluster_id": "7a9ddc4d-79e3-45ee-a4d8-9a05a9685354",
      "members": [
        "5f83450c-4831-4805-8e27-b404683bd245"
      ]
    },
    {
      "cluster_id": "3ea2f80e-f4b6-4835-b337-64fb3587f6b9",
      "members": [
        "815d733e-377e-4e24-a508-460979499d47"
      ]
    },
    {
      "cluster_id": "184f7da5-f557-4593-8954-67601ea3d345",
      "members": [
        "cf9f8c01-fefa-4717-9ec0-abd2ed4eb2cb",
        "1835c7f4-de2b-4164-8b82-fa6adfc3ca0a"
      ]
    },
    {
      "cluster_id": "93f5bdee-4d35-454b-8f1b-0b318e24a68d",
      "members": [
        "1bd88c13-1b9b-45a7-8a44-855bc33bf360",
        "8901b6ba-a1b3-4591-9266-938a286911c6",
        "01e425df-a493-4ceb-a10f-366132092c49"
      ]
    },
    {
      "cluster_id": "2bf4835a-c2d9-4984-a011-415e8a457306",
      "members": [
        "a3da8389-1854-464f-9071-1facf1abd8ae",
        "7a6466fb-3b7d-4380-8b37-aaa5ae4f5f3a"
      ]
    },
    {
      "cluster_id": "34aab7b4-5379-4f38-9914-ae9a14a7914c",
      "members": [
        "30b11eff-e7ca-4bee-af73-c2f03f82b017",
        "01eb0ae5-fa84-40a6-9c52-34656c07b795",
        "d46e2345-2bfc-4730-ac5a-8fcd87c1305b"
      ]
    },
    {
      "cluster_id": "c9eb6d86-6b17-4232-b3a7-29de5feb80b0",
      "members": [
        "d229b959-f62a-4326-b165-185f589fa0ec"
      ]
    },
    {
      "cluster_id": "6965d206-c7e5-406f-98ef-d70ab17200e5",
      "members": [
        "59c8ecd3-dcf1-4d46-a641-b8280912e98d"
      ]
    },
    {
      "cluster_id": "0bc0d2a3-3712-46e5-ad94-41178e22eb84",
      "members": [
        "76aaf235-16e7-4043-87b9-a037084179e2"
      ]
    },
    {
      "cluster_id": "e8352caf-0212-486c-8732-e56619b31e7c",
      "members": [
        "696c28a3-2f20-4d42-8e0d-62f761eeea35"
      ]
    },
    {
      "cluster_id": "47332eaf-fc3b-42ad-bec7-2e81a4ab08e7",
      "members": [
        "7421a086-6509-4f46-82bf-090c02c96be4",
        "2be94a8c-a787-42cf-87d7-6040ce277c99"
      ]
    },
    {
      "cluster_id": "77f3be19-2659-460f-978e-d15cb9d38644",
      "members": [
        "b8889937-ecac-4ac9-bc3b-db5291b944cb"
      ]
    },
    {
      "cluster_id": "2813da46-c92c-428a-9aa0-d5a6d2aae7d8",
      "members": [
        "c6b77d57-513c-48e9-ab99-530e20b9b255",
        "8a98103c-3be3-41e1-bacb-d9b663a6a20b"
      ]
    },
    {
      "cluster_id": "978700a4-02ac-4150-9d93-a90e4ee05431",
      "members": [
        "2dd36943-0a3d-4022-ae72-3e3e82b508b8"
      ]
    },
    {
      "cluster_id": "125babf5-bc0d-45cd-ad83-2a6b21a3e2c7",
      "members": [
        "224eb8e3-f200-461f-8907-508a2b9b3610"
      ]
    },
    {
      "cluster_id": "2311e718-cd29-45c2-b4e7-6c01097b3aea",
      "members": [
        "68fb7d61-8a80-4806-b215-988216fa2da2"
      ]
    },
    {
      "cluster_id": "33b85444-739a-48a4-ba4a-144d6f0bde74",
      "members": [
        "ac80497e-d83e-4314-9f0a-5428faff4d10"
      ]
    },
    {
      "cluster_id": "908547be-87be-4e95-b368-a0acc7033e35",
      "members": [
        "83e06432-af9d-49ee-8785-9660b34df3ae"
      ]
    },
    {
      "cluster_id": "dffdac1b-ba6f-48b2-97f4-02cb8656a37e",
      "members": [
        "303cdd50-f46a-425f-9a12-202c5b188a35"
      ]
    },
    {
      "cluster_id": "56c21a67-f093-4d7b-81de-a41cb3a3c896",
      "members": [
        "dcf67d9a-523a-4117-a894-d3df96daa21b",
        "109c5e74-1d02-47bc-b21c-4526d12dd143"
      ]
    },
    {
      "cluster_id": "cd8e42cd-c833-432a-b12d-6040bca4f918",
      "members": [
        "85de426c-4f43-4b35-8b87-06cac94c009b"
      ]
    },
    {
      "cluster_id": "2b8a30d5-2b80-47ce-adf4-0612b97c7289",
      "members": [
        "1bca1c02-5747-4e14-8c7b-90781e35a9ae"
      ]
    },
    {
      "cluster_id": "b558144e-22bc-4f5e-83f4-cf10e626dc01",
      "members": [
        "45e8dbea-ef86-4a3e-b6a7-9ccc36f702a6"
      ]
    },
    {
      "cluster_id": "c4e46a56-8890-41d4-ba88-174baf1248f9",
      "members": [
        "eec3301c-6f87-4401-930d-03b7ef07c902"
      ]
    },
    {
      "cluster_id": "dd21a7e1-c272-4900-8da2-788f661f4b0b",
      "members": [
        "d58e0908-63ef-49a4-a04a-de9c56a52d19"
      ]
    },
    {
      "cluster_id": "5e9b1d6e-d8db-47a3-b950-64ca3a804787",
      "members": [
        "124d3e56-edc4-466b-b738-7ed87500a778"
      ]
    },
    {
      "cluster_id": "2b3c9191-0f03-44e0-8e0e-82a5f8121907",
      "members": [
        "e4f2e2d6-c597-453c-9d79-887992f836c2"
      ]
    },
    {
      "cluster_id": "f51ef59b-4e02-42dc-84d5-932727f453f6",
      "members": [
        "c59f8085-e8f1-47e5-9183-a3ddc5d7fe72"
      ]
    },
    {
      "cluster_id": "ff5b2600-1cea-4a76-a9a5-9e02ca367e1c",
      "members": [
        "160f517a-6e02-4912-8876-ce86f1747260"
      ]
    },
    {
      "cluster_id": "d56cc903-0bed-4718-9fc5-602c188caa16",
      "members": [
        "4a818227-ff11-402e-a17a-fbc4c82f1188"
      ]
    },
    {
      "cluster_id": "2bdcdf0c-04af-47ca-abf1-8573ce94795d",
      "members": [
        "64c78ccf-c8c4-4ead-8edb-781fec01ab6f"
      ]
    },
    {
      "cluster_id": "873c2a4d-0ea1-497c-90c1-2ef71ec73e8d",
      "members": [
        "949dcc31-8461-43ae-8be2-e1d0b363bfef"
      ]
    },
    {
      "cluster_id": "d9ed1c39-189f-45e7-adb4-c0c7fc2d4155",
      "members": [
        "a4448971-d689-4aa9-b2a8-e18c28b5e01a"
      ]
    },
    {
      "cluster_id": "afe97367-2dde-46dd-9395-2e46792da8d8",
      "members": [
        "1d22170c-0274-426b-b23c-8246a6c999a1"
      ]
    },
    {
      "cluster_id": "1f539237-1caf-4525-9adc-af33bb645e44",
      "members": [
        "411db0b4-901a-44af-8084-684c94c06f35",
        "4532a5f5-e3d7-4a33-a245-a559061e325f",
        "6dfa4668-6bbc-4e53-b326-efaf5323340d",
        "bb32ebcf-afa1-4e74-a29d-d1b0fc8cb958"
      ]
    },
    {
      "cluster_id": "6c48832c-2b96-4ee8-9b48-4611e67b38f0",
      "members": [
        "2dd99937-465a-40c8-a6d1-1ba80f7b7fff"
      ]
    },
    {
      "cluster_id": "5e399677-5a8b-4a09-a43c-cb9c2afa95dc",
      "members": [
        "2d2427a3-25b4-4670-834e-c8c9a8e08566"
      ]
    },
    {
      "cluster_id": "efecc9d7-3e88-45ed-b11f-77af1e65000e",
      "members": [
        "7d7620e7-0394-4b49-be2c-d52df53b66de",
        "7c8e8163-76b3-483c-83a5-7d5a604ec003"
      ]
    },
    {
      "cluster_id": "a397f3ea-2260-47ec-beca-b473be543d39",
      "members": [
        "6239eff8-9991-47ad-9ee9-6bc9fa41b6eb"
      ]
    },
    {
      "cluster_id": "4c464446-66cf-4c9f-b4d9-3d5598eb4a8c",
      "members": [
        "0b3ba769-29b9-4fac-ba68-f45045bf2631"
      ]
    },
    {
      "cluster_id": "3044ed83-9d35-4f0f-9d53-c999faefc097",
      "members": [
        "760b1750-990f-45c0-9982-41b2b2e88cad"
      ]
    },
    {
      "cluster_id": "dd9ccaa5-025e-44c1-90b2-20d75d0c5291",
      "members": [
        "5969d7ad-90fb-4499-bbf5-9843fb61ef4d"
      ]
    },
    {
      "cluster_id": "d44024e8-81f4-4d88-982c-a023f24b58cd",
      "members": [
        "33b7cce7-6173-4e38-aa9d-73da5ad3355f"
      ]
    },
    {
      "cluster_id": "6d7e8844-23f0-4293-9d61-855d04598239",
      "members": [
        "3fdc70af-ac57-4ada-b88e-beebc38d0f90"
      ]
    },
    {
      "cluster_id": "6e3b5d0b-67db-4d14-8384-2b3799aec6bd",
      "members": [
        "9535fc4f-b8d2-4d71-99c2-51c24b82dd25",
        "0a43eaac-9d11-4559-b4ca-8aac7ca1c563"
      ]
    },
    {
      "cluster_id": "376cbd95-afac-43da-8c2a-b0756127f429",
      "members": [
        "ac8cea3c-51b4-4003-bc71-dc8e7da0cc9e"
      ]
    },
    {
      "cluster_id": "abbea790-2006-423f-9f7d-2f67dda5b47d",
      "members": [
        "0b6ab1bc-2c8c-43f5-9de1-58ee61492950"
      ]
    },
    {
      "cluster_id": "91653172-78c7-443d-8db0-081fac7b81c6",
      "members": [
        "a2d53ef1-9deb-433a-bcf9-59077120797c"
      ]
    },
    {
      "cluster_id": "5ce12af0-2b76-4e71-8a73-442efc1d859d",
      "members": [
        "bc1bbdf3-ee43-42da-a74c-f41e1bb52a7b"
      ]
    },
    {
      "cluster_id": "4b392fdd-fe83-44be-b489-81067bf20cc4",
      "members": [
        "2aac0bf8-5dda-4fc1-8da7-cdae83559eaa"
      ]
    },
    {
      "cluster_id": "9add2c84-55b8-4f75-bec3-d9a47e379ce8",
      "members": [
        "0ee0eddc-d7aa-4f78-aae9-6008e205e5c4",
        "6bf3097a-570b-4809-b237-d44db87a39eb",
        "2820709e-5d6b-4509-94a5-78cd96541477"
      ]
    },
    {
      "cluster_id": "ba2e6df3-366f-4f05-b8ae-0693e1f8cec0",
      "members": [
        "262af7ff-dfe7-464a-b640-3f6df9d3723b"
      ]
    },
    {
      "cluster_id": "e9486241-9c2f-4d3e-8704-e3be044f2405",
      "members": [
        "a77f5498-680a-46a4-8c8a-659c9ad02c00"
      ]
    },
    {
      "cluster_id": "8affed0e-1741-45ae-9282-db13ed25555e",
      "members": [
        "04f22358-3b13-4ad6-bbda-ad0691b60927"
      ]
    },
    {
      "cluster_id": "c6829bdd-21da-4a4f-9d8a-98920160c65d",
      "members": [
        "f24b52b9-187c-4eec-8711-93153d4d2fee"
      ]
    },
    {
      "cluster_id": "2dbe786d-9065-4e0b-93e2-135a2fc6f7f3",
      "members": [
        "2843540f-04ab-4329-b579-f43852502201"
      ]
    },
    {
      "cluster_id": "dfa3481f-adba-4f59-b051-83a57da84830",
      "members": [
        "7e546993-ae27-482d-9f03-1b53ca0e72db"
      ]
    },
    {
      "cluster_id": "31016415-1e0c-4bc5-8f2a-e27a8e5ff775",
      "members": [
        "b6069ba0-2a14-45d6-b5a3-a9991a32bcd8"
      ]
    },
    {
      "cluster_id": "b617ae42-60a1-4bd9-bcd3-a29cc6c02448",
      "members": [
        "87f67770-7faf-4358-9b25-7f35afac9ecb",
        "752d86e5-d35a-4109-9d79-724a0db1743a"
      ]
    },
    {
      "cluster_id": "2f4e138b-a8ca-4c68-be26-24de0c3b0489",
      "members": [
        "2e3dcc2e-b0aa-4f90-82b8-edb47f445bdf",
        "ee212c03-d1b9-4829-a450-4cf628f7fbc2",
        "58629ba1-a876-4cf2-9e86-abbf1b321a0b",
        "111737aa-a6ea-4e79-96a0-0dda72e05afa",
        "7efe0478-8a2a-4d11-9c5f-52020e70d538",
        "020ddec2-9bf4-4d55-8de8-775d6b46f6f7",
        "07b8c9bc-c879-41be-ba14-45abae032ec8"
      ]
    },
    {
      "cluster_id": "0630fbfc-9793-4e8b-bd28-898778d452da",
      "members": [
        "2dda5801-f3e2-4728-9ede-9738720b171d"
      ]
    },
    {
      "cluster_id": "3c952e11-fec7-43b5-87d0-197de2b823da",
      "members": [
        "69a5cfbd-e0c9-413a-947b-94501669f10a"
      ]
    },
    {
      "cluster_id": "0cda4135-c24b-4433-a2d2-edf8bce6961a",
      "members": [
        "b81d08a2-2cb2-4ded-a06d-29e265a6d632"
      ]
    },
    {
      "cluster_id": "6207c1fd-d86c-4598-b9ed-72232636a976",
      "members": [
        "5e70da93-c4f2-4f6b-9b2a-9f4c35177f2a"
      ]
    },
    {
      "cluster_id": "708bf439-5986-4d45-983d-18029794b540",
      "members": [
        "4f9fbad5-3926-4330-9231-602c807d9d2e"
      ]
    },
    {
      "cluster_id": "2cd863fc-6aa3-4b22-ae05-f3da95690998",
      "members": [
        "169afb32-d558-4121-85b8-678d1f854a12",
        "720b8d6d-809c-4d3e-a583-77f63e7d2392"
      ]
    },
    {
      "cluster_id": "87ccb180-4860-4e8d-af6f-a3acda89b6bf",
      "members": [
        "47955cc0-e7b0-4d67-90f8-bf03cce5c3ad",
        "4d10fff5-7f39-4071-88fd-5dd756dceb9a",
        "a7239427-66bd-4600-aed2-581476f25b1d",
        "dea64148-7283-4119-b18e-ce084b537bc9"
      ]
    },
    {
      "cluster_id": "ac3c4bde-8539-4baa-8848-6a9242884e47",
      "members": [
        "686cbbb5-3b5e-483b-bc76-96a077264b04"
      ]
    },
    {
      "cluster_id": "5241cd80-7c22-4aa4-92c3-aaf01b6a8d68",
      "members": [
        "bc31032f-4bbc-481c-82b3-4468226d167e"
      ]
    },
    {
      "cluster_id": "6d60b9fd-35cb-4875-8f6b-cc990ada4464",
      "members": [
        "c2be8edd-44a2-4024-b0f0-bac5f6a20d1f"
      ]
    },
    {
      "cluster_id": "a47f9935-dbc9-43e1-b673-236035daf9b2",
      "members": [
        "ee1c0bf2-b738-419c-bb84-dd8840a8d165"
      ]
    },
    {
      "cluster_id": "044fadd9-8b2a-4a97-a501-b787a29d182f",
      "members": [
        "809ebb4c-3f56-4172-af62-1fc98346939d"
      ]
    },
    {
      "cluster_id": "77183e66-d172-4f0f-b205-95c246afc00a",
      "members": [
        "d9deaf4c-cb27-4ca9-b33c-ee26766559df"
      ]
    },
    {
      "cluster_id": "3cb65e99-ccac-4aa2-91a0-7af465ad385d",
      "members": [
        "e70b85f7-dbf0-4789-b87e-40b9be1f108a"
      ]
    },
    {
      "cluster_id": "03481317-8100-4f6a-8ba8-a8c9a52c0e90",
      "members": [
        "78dd797c-54e9-4f5a-a617-5c04890789c2"
      ]
    },
    {
      "cluster_id": "10f7e4c6-143d-4ada-adc6-a0d81c4f5272",
      "members": [
        "9641230b-18d7-4122-9fbb-ad268a1ededd"
      ]
    },
    {
      "cluster_id": "5605c591-48df-4465-a293-86fc68f1944a",
      "members": [
        "2296956b-5cc1-4ebe-b1da-37bf012fbce7"
      ]
    },
    {
      "cluster_id": "e1583824-5e05-4c29-84a3-b27afc099adb",
      "members": [
        "8ee72d39-4d72-44c4-980c-975cb4158fdd"
      ]
    },
    {
      "cluster_id": "ed76bc08-55bf-40dd-b156-814a949b24dd",
      "members": [
        "e1bd328a-fc69-4d68-98f7-b98c02516111"
      ]
    },
    {
      "cluster_id": "6701d78c-ba82-4b89-b97a-8fd70b5e34f9",
      "members": [
        "1f08bcd4-2a1d-4977-b630-3d154862b9ea"
      ]
    },
    {
      "cluster_id": "72cb3acd-6792-42e7-917e-0a257b0b418a",
      "members": [
        "7fb40a00-2db2-4859-bcb8-efde1a71fcd3"
      ]
    },
    {
      "cluster_id": "2258427e-082d-4938-9009-29d50fe17645",
      "members": [
        "c186eca9-cb1d-40c3-8028-d9f201e6a3e2"
      ]
    },
    {
      "cluster_id": "fd0c3806-b445-4899-9ddd-fa029d0bc38e",
      "members": [
        "1de7f983-9b61-4d4d-a604-7ae975daa70a"
      ]
    },
    {
      "cluster_id": "439aa0a6-6e46-43ae-ba81-fc975c6669e1",
      "members": [
        "dac0ff89-f538-4798-8227-cd94c172c6b7"
      ]
    },
    {
      "cluster_id": "da473e07-5f99-4854-b0f9-aaba62b413c0",
      "members": [
        "70beb357-6a2a-4e2e-93fd-f7fd7bfede7a"
      ]
    },
    {
      "cluster_id": "989dfd54-88d2-416d-a172-4c7b7a520121",
      "members": [
        "2619669f-b128-4efa-8cc9-544630bf09b8"
      ]
    },
    {
      "cluster_id": "bfddf849-1008-4d2d-bfce-830b42f8a421",
      "members": [
        "1946fa2c-944a-4cb0-8bb6-4f8595248750"
      ]
    },
    {
      "cluster_id": "fbeea9d9-e3b5-41fa-b94f-503292015b12",
      "members": [
        "814b1bb7-0051-487e-ae27-1276aa74b620"
      ]
    },
    {
      "cluster_id": "979b7171-b50b-4784-a226-a93eb757dfb4",
      "members": [
        "1c362657-65ac-483d-b15c-54a082028700",
        "6e0721bf-af2c-4613-aab8-fc5a60b352e1"
      ]
    },
    {
      "cluster_id": "83b8e4b4-0c78-4b19-aa89-21b8a62c50fe",
      "members": [
        "843a68e2-a58f-4338-b608-d0b676ff0f44"
      ]
    },
    {
      "cluster_id": "490d433f-ce3e-4f27-9543-e9681e6eafc7",
      "members": [
        "1f642949-2156-4f56-b000-f294eb9b083d"
      ]
    },
    {
      "cluster_id": "6274d1ce-c7d6-4cef-9ec4-e52018d2a528",
      "members": [
        "ea0b0740-6fca-4192-a6bd-8b7c7e497256"
      ]
    },
    {
      "cluster_id": "8363a6a5-6462-4ebe-b358-821cefa34494",
      "members": [
        "f23e3f2b-f8a9-4d5a-b9d1-4e6e721675c4"
      ]
    },
    {
      "cluster_id": "9d8cb077-725c-42df-adf9-cc02faf7d3d4",
      "members": [
        "a9eb3402-7303-4e26-985e-bfb6e2b7be5c"
      ]
    },
    {
      "cluster_id": "b8695913-835b-4b14-be2f-fd0c828a71a6",
      "members": [
        "3ea68c64-9773-43d9-b4c2-7c341b643338"
      ]
    },
    {
      "cluster_id": "3b245c17-07a2-4e26-a29a-946ef78835ee",
      "members": [
        "f25fde5f-d782-4e1d-a20a-3752b8c3828e"
      ]
    },
    {
      "cluster_id": "2b3f127f-efff-44cc-83bb-012f860b4fc1",
      "members": [
        "356d7c96-6a41-41d1-9ef7-86159595457f"
      ]
    },
    {
      "cluster_id": "1f60ebbf-51df-4e3e-95f0-d6e32c7fc5d9",
      "members": [
        "9f3650f7-0c90-47bb-af37-8f56e9051440"
      ]
    },
    {
      "cluster_id": "1dcb2d84-ef9e-498b-a03a-7740ad5e2f55",
      "members": [
        "28f26c81-8a2a-42ab-9758-c215f76bbf76"
      ]
    },
    {
      "cluster_id": "b0a9927e-dfb0-4578-8343-304f2917ace8",
      "members": [
        "178ae6f4-e2fb-4589-8996-268c104878a0"
      ]
    },
    {
      "cluster_id": "7261d8c0-d619-4bef-bf36-5ab83467a9cd",
      "members": [
        "716f9129-429d-4988-894a-cd8a8d7da4ab"
      ]
    },
    {
      "cluster_id": "99785983-351c-4201-b7c5-88255cfce2ce",
      "members": [
        "f9fba1bc-a280-42e9-9fad-8c755abff63c"
      ]
    },
    {
      "cluster_id": "5ef9de99-de5e-4d31-bfda-1e87c2a63ead",
      "members": [
        "5da27d33-a165-42f5-9ec2-6d118ebb37f9"
      ]
    },
    {
      "cluster_id": "13bc9125-818a-4eff-a1c9-96bf89586d78",
      "members": [
        "08515554-be3a-4ebe-a6df-471d24dee1cc"
      ]
    },
    {
      "cluster_id": "290a2df9-939f-4569-965e-7d206087ead6",
      "members": [
        "5b4121b9-67b7-407d-86b8-6053c136b87d"
      ]
    },
    {
      "cluster_id": "44955a88-3ba0-46cf-ac7e-906798513ae4",
      "members": [
        "074ea38c-520c-4e9a-9ef5-c4ca7b784287"
      ]
    },
    {
      "cluster_id": "c8744ddc-73ca-4b76-bc5b-2e4d00f4bba9",
      "members": [
        "d791cfa0-d2a4-464f-ac69-75d53f3d4c82"
      ]
    },
    {
      "cluster_id": "06512aa8-6f14-4dbc-8b0f-4ea2e772ba31",
      "members": [
        "fde86755-d0a9-411a-af01-148da957be9e"
      ]
    },
    {
      "cluster_id": "27a6bdbf-c139-4b94-baa7-3715f52da9db",
      "members": [
        "189499fe-3131-447b-81e9-4435db4e85e3"
      ]
    },
    {
      "cluster_id": "5c683e3b-456e-40af-9840-3af3a5900ece",
      "members": [
        "4a4972c4-ebf7-4cb8-b0ee-1b43206b1ab9"
      ]
    },
    {
      "cluster_id": "bd48a2e4-20c5-4fa2-90a9-0725e3288c94",
      "members": [
        "478dbf82-e1cb-4626-aad1-f4c4b525dc5d"
      ]
    },
    {
      "cluster_id": "ed839aef-f33d-482b-b6ad-3c8a3947da24",
      "members": [
        "c06642ac-1f2d-495f-bf42-2bc2972cbcb7"
      ]
    },
    {
      "cluster_id": "d227604b-5869-4f99-9132-b0eb536e0289",
      "members": [
        "a5ad7c31-c1a4-480a-8ab4-6e28f34870f9"
      ]
    },
    {
      "cluster_id": "25720bbc-2dcb-4fd3-bfdd-8ac413567afc",
      "members": [
        "296b6c7f-df17-4502-8c74-8f18015dfa39"
      ]
    },
    {
      "cluster_id": "ad513fe4-8bef-4ca7-984b-94ef0cbb53d7",
      "members": [
        "58a96d05-0b9c-4ddb-ad56-31b85def6114"
      ]
    },
    {
      "cluster_id": "66380cec-1745-4f20-be6e-01fcad9e1602",
      "members": [
        "000f23a7-2222-41ea-8898-e7d063735ef4"
      ]
    },
    {
      "cluster_id": "651043d1-0d9f-42ac-bcb3-c7e39b7939ec",
      "members": [
        "da7cdfd4-e436-4cad-bf96-fd39255cf969",
        "a0ecf576-e0bd-40a5-980f-ad8ac2c93062",
        "bc772f26-1c54-4444-9adf-ebcab49ae7fe"
      ]
    },
    {
      "cluster_id": "ca0536ea-7533-4baf-adac-d1ee11b1604e",
      "members": [
        "a9d50388-6ca1-489b-898c-03077d503b07"
      ]
    },
    {
      "cluster_id": "d58b9b87-81e0-4589-8f81-7f8c5e6a86d0",
      "members": [
        "52ea576d-ff1d-436f-859a-e066258b724d"
      ]
    },
    {
      "cluster_id": "41ecf095-1caf-4be8-93aa-128fb386e8aa",
      "members": [
        "785991ad-3948-4077-af87-943e2698d44d"
      ]
    },
    {
      "cluster_id": "96772c7c-5021-4ae5-83ab-b845fd92f1f9",
      "members": [
        "d668f105-1438-4350-8827-74d6bed57b76"
      ]
    },
    {
      "cluster_id": "5045a380-d054-4bd0-b13d-e42a8ff24888",
      "members": [
        "280cc982-fb5f-405a-abd0-135f9de11b7c"
      ]
    },
    {
      "cluster_id": "7c34b0bc-12f1-458e-bef9-fafbba595b37",
      "members": [
        "e0131c57-979b-4eb6-b1b9-b63edb856c71"
      ]
    },
    {
      "cluster_id": "d748d1bd-38e3-44b3-b268-429f4615acee",
      "members": [
        "3f2c5b38-deba-475d-9cd7-11385395e7d5",
        "69c09a97-0d88-40a5-967e-4b2414656a7f",
        "67f30ec6-95de-443c-8a45-01bd859d04c4"
      ]
    },
    {
      "cluster_id": "217bc58f-d97f-49d7-9c91-2a55c225a54a",
      "members": [
        "137c84f5-23db-45e6-bf92-1ad74275d3e1"
      ]
    },
    {
      "cluster_id": "83859ac4-ebe8-4ffc-91d6-38d67b7686ab",
      "members": [
        "fa0db7ed-df89-44b6-a5c6-2ada5165a15e"
      ]
    },
    {
      "cluster_id": "6d1416a4-5911-49a5-a8dd-0b4e7d18279a",
      "members": [
        "3d6a2ff0-9932-4048-b809-b1b21ab52912",
        "25ae9714-f988-4579-a283-17d3fac67c24",
        "0237dae1-3387-43b5-85b5-cba8ff095863"
      ]
    },
    {
      "cluster_id": "af7abfea-8aa3-4fe8-a9f8-4a548d23e03a",
      "members": [
        "b05052a3-07ad-456f-8def-ea0241666317"
      ]
    },
    {
      "cluster_id": "8a0c3eda-5944-48c4-883c-6f01e773d494",
      "members": [
        "9dc7cfa4-60c3-46e9-93bd-b1dcaab98aee"
      ]
    },
    {
      "cluster_id": "707b49ca-9999-4b93-b6af-d31c32d2cafb",
      "members": [
        "4aac8468-0db8-44dd-a4a0-aa92932348ac"
      ]
    },
    {
      "cluster_id": "ef92d248-d529-47e5-9160-de6bb70cfa68",
      "members": [
        "3b1efc1f-a8b5-40d7-afb8-47b5c2d8c3eb"
      ]
    },
    {
      "cluster_id": "80759b38-0166-40f3-aa37-31d3150e1679",
      "members": [
        "563ef7e7-3e70-4f08-8a0d-494367c53a15"
      ]
    },
    {
      "cluster_id": "cc8b239f-30da-4a67-b3e7-b923954bf5fc",
      "members": [
        "272d4ca0-a4cb-4498-a278-ed962e7fb8a9"
      ]
    },
    {
      "cluster_id": "35ae28c4-1a8d-4235-aadc-32d9b7b111fc",
      "members": [
        "14e70229-d758-4a9f-b726-1a569c1c76d6"
      ]
    },
    {
      "cluster_id": "2e2cbe02-9179-4ff7-9128-2042160eb4d1",
      "members": [
        "22510ace-caed-4962-8f00-efe8b2b3bdc5"
      ]
    },
    {
      "cluster_id": "efbd6030-d54d-4409-900a-396adc8a9b7e",
      "members": [
        "a5875c2f-fc37-4929-a261-fb5eb0b601e3"
      ]
    },
    {
      "cluster_id": "00d660d9-94af-474c-8e79-c16ac62cbef7",
      "members": [
        "bf690599-cad5-45dd-ae9a-0dfd9300fe11",
        "598d47df-b169-4963-92a9-f28dd18db4f1",
        "c3b6f443-30c4-40f4-ad7c-b75048fa6cd0"
      ]
    },
    {
      "cluster_id": "2947fe08-3f19-4a83-826c-8d5e7d1e3368",
      "members": [
        "34cc607d-07f1-4fcf-961e-cc2ed5410530"
      ]
    },
    {
      "cluster_id": "05021641-3e64-47c1-b3de-9319980f7bf2",
      "members": [
        "1e8752b2-0404-4776-b8b8-8e69b8687848"
      ]
    },
    {
      "cluster_id": "446a7c12-73f1-49f5-944a-5a0119281e12",
      "members": [
        "157ab812-4359-4349-aa5a-6276969f1acf",
        "c73e787d-e802-4efc-847c-2e925026c04e",
        "ff0dd947-d591-4a91-98f5-7e8568e5a3ee"
      ]
    },
    {
      "cluster_id": "900b62cf-2f7f-4c8d-9d94-4cbb68246f3f",
      "members": [
        "7c180cef-775f-4dc0-b7a2-7d8d5e88625c"
      ]
    },
    {
      "cluster_id": "db2c7499-73dd-49a7-b315-23a9a2089f45",
      "members": [
        "d4e97c40-281a-46e0-9b44-cf5ed299a47d"
      ]
    },
    {
      "cluster_id": "7e3a0dda-730a-409c-87a4-d60847af0bea",
      "members": [
        "76f11f64-6713-42b7-b4fe-4a91b078dc1d"
      ]
    },
    {
      "cluster_id": "696331dc-98cc-442f-bc75-87b9c239a45d",
      "members": [
        "c7046dc0-2120-433b-b1ad-372ce5830178"
      ]
    },
    {
      "cluster_id": "9e950aab-bcb8-467d-b56c-2d0bc86754ee",
      "members": [
        "3c63c480-f1c1-4956-8ba8-123730a4a02a"
      ]
    },
    {
      "cluster_id": "beafc838-f8fb-4f24-b442-c5d64c7e1a7b",
      "members": [
        "c48786c0-3d01-4cc0-beef-55fd9048d74a",
        "26ddee41-4525-4f23-aa2c-a446c14312eb"
      ]
    },
    {
      "cluster_id": "e197be16-bc11-494c-aa3f-5b8f744ffb1a",
      "members": [
        "8aebfe7f-59bd-447a-9883-1dfe71623e69"
      ]
    },
    {
      "cluster_id": "b6f1959a-3736-48e6-bdb9-c384c993515b",
      "members": [
        "4ded90c5-3a0b-4383-8c98-2eb06d50795b"
      ]
    },
    {
      "cluster_id": "f6427727-e128-4eae-8208-67e9a7ed1b14",
      "members": [
        "5b44d227-cd48-4625-802b-e02870b36ce5"
      ]
    },
    {
      "cluster_id": "dfbec97c-7720-466c-b25a-2051f356476a",
      "members": [
        "6c7bfa6f-971f-46b6-bd04-14ad038adf97"
      ]
    },
    {
      "cluster_id": "072b9770-c37e-4414-a35e-af21470d2ffc",
      "members": [
        "94bceffe-abc3-44c2-a2eb-2ddc58173a11"
      ]
    },
    {
      "cluster_id": "ee0b2c4e-ce44-4f3d-90ff-fd0a1c204fa5",
      "members": [
        "57923ade-9ad9-40e2-82c9-f707f057bcfe"
      ]
    },
    {
      "cluster_id": "127de610-39d3-4b48-be82-befef46aa586",
      "members": [
        "d42c2acc-9cb7-4e82-b0d1-beeb3deb20d8"
      ]
    },
    {
      "cluster_id": "cdc110ac-1c3e-4435-8e2b-221f6de6a9c7",
      "members": [
        "51ced9e6-1f43-4883-977d-d0e20fe66a54",
        "0fbbec81-5c41-4156-b190-889bc78cf7de",
        "cd8a5b00-b145-4ba5-be1d-dd7b1127c2c1",
        "720a854c-8fdd-4cc3-b45d-b85cf6468e00"
      ]
    },
    {
      "cluster_id": "a6c32f96-492e-46e5-b580-0804b089cb50",
      "members": [
        "30397b47-2751-48d5-b517-e38ed1c2ed3c"
      ]
    },
    {
      "cluster_id": "4edf6538-801f-49f6-932e-65747f37810f",
      "members": [
        "ebc674c8-5c33-4f37-85b6-129b22993e97"
      ]
    },
    {
      "cluster_id": "e8809e83-36ee-4437-9f9a-9028a358d36b",
      "members": [
        "2c94f3e9-f2e4-478c-8e0b-0c78352e3b7d"
      ]
    },
    {
      "cluster_id": "7fd1b210-1374-4030-b2c1-ddf3869ca13f",
      "members": [
        "a5f5eee1-35a8-40c6-bf54-d56986cd75d6"
      ]
    },
    {
      "cluster_id": "6e5ac655-6dc6-4a9e-915a-357b2296a7b0",
      "members": [
        "59a9db05-0086-48fa-8c0c-ffbd3e3860e0"
      ]
    },
    {
      "cluster_id": "a1c1162e-c36a-46e0-95af-7c5c08d5e6ff",
      "members": [
        "535a210f-5332-48a8-b714-9cd94b6426f0",
        "f8862daa-afb5-49de-a80f-ef289a621c9e"
      ]
    },
    {
      "cluster_id": "3e87c12e-871b-4773-8173-d484141c190e",
      "members": [
        "823bb143-78e8-4e11-9b72-5d0fd5f6deff"
      ]
    },
    {
      "cluster_id": "f39cf9c7-18fb-4728-b88a-0bd586522d02",
      "members": [
        "3ceecee9-d165-47a0-8779-3f9b9fd7ff46"
      ]
    },
    {
      "cluster_id": "48e9dba9-1fa3-402e-ae73-202c64781781",
      "members": [
        "b64599c0-5b8d-4f3b-97b9-a3e1d058ac89"
      ]
    },
    {
      "cluster_id": "99bc4095-29c0-47b3-81af-1811b5d01f5f",
      "members": [
        "48cc9fc9-b313-45c6-ab6c-98c8e73a1a81"
      ]
    },
    {
      "cluster_id": "07bac613-553a-4b5a-8942-deafd7506573",
      "members": [
        "1f57bde1-5a81-4359-9554-77b898be045a"
      ]
    },
    {
      "cluster_id": "1bece78f-f648-4fbc-85c0-722698749525",
      "members": [
        "4531fbee-07ca-4f7f-ba48-99fd66c5beb6"
      ]
    },
    {
      "cluster_id": "46812bda-c4dc-4bd2-a7c0-e250a28da359",
      "members": [
        "37483664-a7a7-4762-9906-e5dcae2780ff",
        "74d182f5-abca-4486-bb63-20c04388f987"
      ]
    },
    {
      "cluster_id": "1abde06f-fea9-40fc-b58c-ddb744004d48",
      "members": [
        "883ec100-33d7-4964-82ca-f305eceae674"
      ]
    },
    {
      "cluster_id": "914330e6-94a6-406b-a8f3-ed188765a7fb",
      "members": [
        "846c382b-bfeb-4264-ada7-0b383ff7fb90"
      ]
    },
    {
      "cluster_id": "182eb8ff-4f9c-4649-b5f9-31b5022006bd",
      "members": [
        "8650053a-7f26-4698-9037-10695259e0b3"
      ]
    },
    {
      "cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a",
      "members": [
        "5245537c-9eb7-4eb1-8dc9-552ac10777ac",
        "38efd15b-f73c-4767-9fdb-679b3456f1cc",
        "551e0255-ced9-4f0b-8d2a-fdd55f8a8add",
        "24401186-060e-4f23-8917-efbe8d9758cd",
        "35f38b9b-5ae6-46db-b678-097ade3533ac",
        "a16869db-0336-4704-baeb-5256f023e290",
        "df160e7a-2bcb-4e84-8d82-4201295192ed",
        "93d12391-eef7-4c5a-8d23-3ca3ffb008bd",
        "e23f167a-c7f0-425f-865f-377dfe1354a6",
        "aaaa23bf-b2ea-43c1-ab2a-85111934b433",
        "ecf23699-b575-4ba7-a0fe-5d782f53736b",
        "649a8931-8e47-40b4-b474-17f7ae5b39cd",
        "2f6ae23a-6a6d-466b-a49c-0c243534c600"
      ]
    },
    {
      "cluster_id": "192193af-777f-4b45-a866-b58926d838df",
      "members": [
        "2a8d0962-05f2-4f3b-83bc-0c984f50a683",
        "258dc20c-5542-4f84-b93a-b9a7bf4d9980"
      ]
    },
    {
      "cluster_id": "fc22f23f-3e70-4f58-9556-2d3e03c04167",
      "members": [
        "766905f5-fd25-46de-a4cb-f9e22321ddf7"
      ]
    },
    {
      "cluster_id": "74b5a9f8-d64b-4e6b-9562-84c68b5337c2",
      "members": [
        "47752977-8739-4c1f-8b4b-0b2984eea4d1"
      ]
    },
    {
      "cluster_id": "34ebf375-c746-4b55-870a-320a9407196d",
      "members": [
        "f8643050-a94b-48c4-96c8-ffa6daa1c6c9"
      ]
    },
    {
      "cluster_id": "6d2c68aa-e5f1-4199-8a32-52bb8d80e934",
      "members": [
        "32bba864-7aa2-4f36-b89b-224012fe2ca8"
      ]
    },
    {
      "cluster_id": "8cceec53-f974-47da-b9c4-5af02c151d1d",
      "members": [
        "d257a9bf-a3d4-4874-be64-af6ba0f22f02"
      ]
    },
    {
      "cluster_id": "558a2b97-08fd-422a-b638-0c14ba645eaf",
      "members": [
        "a2d902e4-962f-4a18-a1c1-f622b3934f40",
        "5a1d42a5-3ff6-455a-8d97-b10540e1e8cd"
      ]
    },
    {
      "cluster_id": "a65f122a-8e28-4204-bec6-e6c89e03bce2",
      "members": [
        "5e4c2baf-dbe7-49e1-b269-4033ddb0632e"
      ]
    },
    {
      "cluster_id": "f69599a7-433a-4819-a4c2-cea569bc6b06",
      "members": [
        "4aa21b38-4b13-4d29-925c-aa699d9b3403"
      ]
    },
    {
      "cluster_id": "76435864-5754-43fe-ba96-2ebbad51c5b7",
      "members": [
        "532d5c4d-9d3f-4f2f-a279-bbeb95659887"
      ]
    },
    {
      "cluster_id": "163f1d1d-a78f-492c-b769-5b6a7b1465fa",
      "members": [
        "55e44c00-4fe6-496c-9dab-944c4b2cb2c7"
      ]
    },
    {
      "cluster_id": "ebecceb7-8e8e-4359-8ae4-54572c43828e",
      "members": [
        "bd112641-f8c0-444d-8cb9-9503c72569a7"
      ]
    },
    {
      "cluster_id": "cf47a2c1-26a3-4471-9b1c-8c8f4c68cc10",
      "members": [
        "e718d11e-60bf-41ca-aae9-78820d070e08",
        "d99b0120-f2a8-492d-96ed-003f61c955c0"
      ]
    },
    {
      "cluster_id": "3b570036-015c-4669-a1c7-9124e256f407",
      "members": [
        "f7c3ade4-9ecf-4e12-853b-8b75b47032a1"
      ]
    },
    {
      "cluster_id": "a6f24255-af0b-46ae-a654-0f9f9280b4f0",
      "members": [
        "46856529-2ef5-4366-a966-3ebc9ac5e9bb"
      ]
    },
    {
      "cluster_id": "e7ad9ef4-67e0-4758-9909-6db3f8c0c4b5",
      "members": [
        "3f1da2a4-fd20-4820-8b26-bef270380f34",
        "826edaba-f1d9-4729-883c-a9c6e7470cc0"
      ]
    },
    {
      "cluster_id": "985e777f-c3e3-42f1-b650-98ac19e7f7b5",
      "members": [
        "9c75c255-ad39-4e2a-a3f1-0b4d8b705a38",
        "88bd205b-928f-47ae-ae3b-f31e27246468"
      ]
    },
    {
      "cluster_id": "d6164d22-4f2e-407f-abd5-0ff84a88c4a3",
      "members": [
        "02012bb7-6c7b-4ee5-afd2-88ea366a860e"
      ]
    },
    {
      "cluster_id": "4d98cb2c-2f46-419d-a007-1ffd1128c767",
      "members": [
        "fd1c4e40-ebf0-4822-886a-cc9032160c1d"
      ]
    },
    {
      "cluster_id": "3ae04ca7-f447-4b2b-85af-7e1f6c9004e8",
      "members": [
        "3495bbed-e666-46d8-898f-62fc06d697e3"
      ]
    },
    {
      "cluster_id": "23f200a8-82be-479e-8c62-e16a5b3450e2",
      "members": [
        "e61ba6fa-b8da-435a-b8ad-f2f5ea81b708"
      ]
    },
    {
      "cluster_id": "7c711c42-89fa-4d59-a561-9de6228e491d",
      "members": [
        "fffbf361-a8e9-49f9-adb5-13838d571f1e",
        "8f73c558-2be2-48cc-a73f-d9f7424080ad"
      ]
    },
    {
      "cluster_id": "5b28f584-d6d3-4f8c-b812-407015e7b243",
      "members": [
        "ecd93e53-3d17-448c-b237-a63b3e8109e3"
      ]
    },
    {
      "cluster_id": "4551b9a3-cfb2-4080-a1f5-d94f9554a9e1",
      "members": [
        "9af4bc62-9b31-46ce-8d09-a6acb48e4823"
      ]
    },
    {
      "cluster_id": "85f720a8-0b31-4d1b-a866-8a5f552a25e1",
      "members": [
        "90a9b422-b922-4777-a14a-ef9498c5cc6a"
      ]
    },
    {
      "cluster_id": "ba20492f-063b-4fc0-8bd7-26d88daa19d1",
      "members": [
        "14413e39-16eb-48e6-b0b2-dcfc3fb3a951"
      ]
    },
    {
      "cluster_id": "89a78cfb-c5b4-41b1-8a6d-eaa2669e99d8",
      "members": [
        "f1f73dc0-26bb-4aae-a4be-b03b92bf4da4"
      ]
    },
    {
      "cluster_id": "ec27a280-5ff0-4aa8-9204-fa364980dc9d",
      "members": [
        "ff3cedd3-b1c8-4195-a13a-18ec0932a118"
      ]
    },
    {
      "cluster_id": "6ad0010a-5d1b-4773-9ca4-976c212e4238",
      "members": [
        "2445c1a3-6b24-4942-8f14-750807be5748"
      ]
    },
    {
      "cluster_id": "693353d7-9dc6-4a72-be1a-08fb1957eb6c",
      "members": [
        "f65051ed-e0d4-4480-8343-0bb9a5c21786"
      ]
    },
    {
      "cluster_id": "cf3cadee-d476-45f2-a534-bfb4334bffb9",
      "members": [
        "f921e3a9-8ef0-4155-b3e0-4e2525ea4be1"
      ]
    },
    {
      "cluster_id": "6c375d59-160f-4719-ac36-a62607acccb1",
      "members": [
        "870b1f70-9513-4c14-bc26-c7ffdca2eaa9"
      ]
    },
    {
      "cluster_id": "f03d0193-877c-43d8-81d9-6519c6ca169a",
      "members": [
        "a5b57b1c-b032-4317-805d-278014d54408"
      ]
    },
    {
      "cluster_id": "72f48981-b5f2-4358-be23-5c1438e13df0",
      "members": [
        "a25c205a-715d-4d40-ae2c-d66a5469c6df"
      ]
    },
    {
      "cluster_id": "45236940-0b07-401a-92bf-42c8f73cf80a",
      "members": [
        "63118e54-0fd4-430b-95cb-919ab0a8306b"
      ]
    },
    {
      "cluster_id": "bc2af5c9-9ff9-4d76-920f-873d731b0a39",
      "members": [
        "c4c91b8a-1cf8-4289-bb34-1c6dd48aedcd"
      ]
    },
    {
      "cluster_id": "75ec5d34-37c4-464a-bbb5-d624ce06eeb5",
      "members": [
        "452dbeed-8292-4d02-90ab-791dbe013e25"
      ]
    },
    {
      "cluster_id": "b7b39062-4917-41f9-8b87-39a562d00b9c",
      "members": [
        "b9b93ac0-20e7-473e-bcb0-a8cb0f7eb23c"
      ]
    },
    {
      "cluster_id": "db558738-31a9-49b8-a8b4-9d79818e6da2",
      "members": [
        "83d411c4-399d-40a3-8c9c-d17510bac37a"
      ]
    },
    {
      "cluster_id": "1dd3a1e1-df59-4ade-b082-02235345034a",
      "members": [
        "f0bfcd0b-b8e2-4da4-9825-ade7ead748a9"
      ]
    },
    {
      "cluster_id": "66885820-7ee2-45b0-bbbf-efce4343c472",
      "members": [
        "f0786557-6136-4304-81d6-22fc866a3b12"
      ]
    },
    {
      "cluster_id": "8e8986ad-07fc-46e6-a980-933b8035ee58",
      "members": [
        "a114812e-0977-4ca1-8094-71ad9b83c0c8"
      ]
    },
    {
      "cluster_id": "25458cd1-1938-4e91-a3e1-aa6eb25c1608",
      "members": [
        "c0c0f3f8-c44b-4b66-ae74-4ad4f7191562"
      ]
    },
    {
      "cluster_id": "517bce1b-0646-49a8-83b6-634d844a1495",
      "members": [
        "c9344c2b-3875-489a-9343-306f5df5110f"
      ]
    },
    {
      "cluster_id": "1171e42a-be23-408d-8491-47db819af91c",
      "members": [
        "20b2a735-379f-4fce-94bd-0bbe7f7c5b79"
      ]
    },
    {
      "cluster_id": "03d5681c-cee7-4784-a946-350af3b91054",
      "members": [
        "1e5cedaa-a90f-4111-8959-84cd0f677370"
      ]
    },
    {
      "cluster_id": "7da5e969-ac3d-4ab8-86be-3712be90baa2",
      "members": [
        "d77fb711-e1eb-4c1f-81a1-c1b44ddef513",
        "108ab024-87d1-47d4-8139-ad46f6e38c35"
      ]
    },
    {
      "cluster_id": "967e4599-c3e1-4e81-bc7f-40bf2be021b8",
      "members": [
        "318c05c3-f561-4ede-a7e7-336765f0b9bd"
      ]
    },
    {
      "cluster_id": "986a6ea4-399c-4998-bc4e-699677ef9178",
      "members": [
        "b0e753ad-fa27-4f00-bbc3-e8d0ea27080b"
      ]
    },
    {
      "cluster_id": "69bdd771-bee0-4047-b696-6cda0e3de3f2",
      "members": [
        "84a49646-225a-47e5-9d89-f72e0b0f5cd3"
      ]
    },
    {
      "cluster_id": "0e1517ba-8541-4c30-8eb8-cab31577fd7c",
      "members": [
        "961ea034-93f4-409c-a1ca-a12bfda4eef2"
      ]
    },
    {
      "cluster_id": "1e79f665-5f29-410f-a52e-7981ca5d8478",
      "members": [
        "4939d5d5-e9de-45e0-bd7e-a16ab0082411"
      ]
    },
    {
      "cluster_id": "b2825dcc-d8ef-4d2e-bf5e-a9bc43fa0aaa",
      "members": [
        "bb8b9873-c9ae-4b32-aa5e-d093e4520db2"
      ]
    },
    {
      "cluster_id": "5ab902d4-7128-4b95-a738-a425f46dd496",
      "members": [
        "9e2ed00f-fb92-4f4d-a34e-6d11d893c403",
        "13a89318-6f44-4f8b-ad1e-2ad8dcde96de"
      ]
    },
    {
      "cluster_id": "56d99389-f62b-41f0-b4bc-d85869083e3e",
      "members": [
        "5063cec6-b534-47e2-92b2-fcd5f77d4fb6"
      ]
    },
    {
      "cluster_id": "62babf7f-7431-44e7-bf3a-2b3d26f92e86",
      "members": [
        "72ac546b-bca3-4948-aa0b-6469a29a2935"
      ]
    },
    {
      "cluster_id": "24f76117-6d13-47b7-8b5c-41608f921324",
      "members": [
        "b8b1f515-6eaa-4716-8eba-78cd0e360567"
      ]
    },
    {
      "cluster_id": "5edd87a6-3d98-4e7d-9e60-b94920fc071d",
      "members": [
        "63f5d0a1-7dfe-4d45-9529-9e2ab1904d7d"
      ]
    },
    {
      "cluster_id": "6e176932-b450-49d2-bc88-60ebe982b797",
      "members": [
        "88f1f741-4ab7-4160-a0fa-c523bb32fe76"
      ]
    },
    {
      "cluster_id": "3761b79a-ed1e-4efa-a004-8d3634d88c5c",
      "members": [
        "577b06c1-df87-403c-abf0-46e4fc3e0b1b"
      ]
    },
    {
      "cluster_id": "d83800f4-0756-4306-86c9-259b547db8df",
      "members": [
        "c1749acf-2e81-4a01-a6d7-be83d2e12cc8"
      ]
    },
    {
      "cluster_id": "8922c103-923c-4f13-93a5-f90c7607556f",
      "members": [
        "881df9ed-9ac7-489a-b437-ca046e1322d5"
      ]
    },
    {
      "cluster_id": "fe1c6b54-9f28-4390-8b18-685bcbf44298",
      "members": [
        "7ea3085a-234b-4fbe-8da9-c525603685fa",
        "c49df9ee-84b6-4d61-803d-996fe5ae4ab4",
        "9e1996d1-59c5-4235-96d7-3177babcb7f3"
      ]
    },
    {
      "cluster_id": "cbeb70b1-aecc-4170-98d8-bc70bbb4a2f1",
      "members": [
        "91bf62f3-7da8-4e84-85d2-709539cb36fc"
      ]
    },
    {
      "cluster_id": "96c115c1-f9f9-479d-9ecc-98da549128b0",
      "members": [
        "18a75e4e-6a6a-41e5-883e-66078a97f435"
      ]
    },
    {
      "cluster_id": "236dacbe-2c11-46fc-a4a4-42464ed6f51d",
      "members": [
        "29b2550c-f791-42b9-b02a-9900964c9675"
      ]
    },
    {
      "cluster_id": "4f9e8ff6-b5d4-43cf-8ca3-6775ebba3b38",
      "members": [
        "4eecc423-821c-4504-b820-67b8e5603b27"
      ]
    },
    {
      "cluster_id": "82ddd264-29cd-4540-b05e-dff896b42eb8",
      "members": [
        "550b4b37-7548-45b1-a3f1-d8a06a510945"
      ]
    },
    {
      "cluster_id": "c8099c76-111d-47ec-a755-9357e7d74d90",
      "members": [
        "7d8ca47e-2ef9-442a-98b1-fa8f6205bbc5"
      ]
    },
    {
      "cluster_id": "e9cf68ba-8958-4444-b683-81cefe80ccd2",
      "members": [
        "6b22123e-880e-4acc-8153-bdb56362c2a5"
      ]
    },
    {
      "cluster_id": "227d1df9-e404-4f53-b880-3d4e96ed3405",
      "members": [
        "198d3645-4cb6-45e1-a18e-223c98801648"
      ]
    },
    {
      "cluster_id": "11c149bd-c47a-4b6a-887d-8baf2ffc4481",
      "members": [
        "a3363a3c-98a2-48ba-9cc7-674f22a0088d"
      ]
    },
    {
      "cluster_id": "6d5e0026-09e5-4a7b-b48d-75b8d03130d8",
      "members": [
        "d54a3518-9e0b-4c3d-ba7c-472fc7e562f4"
      ]
    },
    {
      "cluster_id": "7ccbb20b-c467-4a12-8d6c-4afcbbe94813",
      "members": [
        "2808b341-8473-434f-8054-cf31c53e50bf"
      ]
    },
    {
      "cluster_id": "82d125aa-a1b8-43bf-bc35-e274642ade2d",
      "members": [
        "f4810664-25df-4885-84dd-d702f61fb326"
      ]
    },
    {
      "cluster_id": "b2e518c2-bee5-4258-9f37-d52e83d13a76",
      "members": [
        "c7b6a4e5-5073-48f9-906b-45c2c92af366"
      ]
    },
    {
      "cluster_id": "52572bed-fd4b-4180-9ada-bef96be23270",
      "members": [
        "faddd9e3-735d-4866-bc42-9d9cdd5b2f9a"
      ]
    },
    {
      "cluster_id": "af40ab83-4c48-4ac1-af3a-242491a35af4",
      "members": [
        "b7c50e63-6034-41ff-af30-9e1d8f461eaf"
      ]
    },
    {
      "cluster_id": "114c895c-17f1-417b-8a4e-f626b06562d8",
      "members": [
        "99f4732d-fcd3-41ff-a9ec-3a7637e9f664",
        "b4f1c228-054d-4b10-9e6d-9b2bcf5b05f3"
      ]
    },
    {
      "cluster_id": "1e486a72-4d21-463d-8ec1-dd36ab1fc529",
      "members": [
        "0e355bfb-dda1-493a-9e8f-6a6055245a49"
      ]
    },
    {
      "cluster_id": "d3045f09-979f-427c-94af-3cbb77214023",
      "members": [
        "724352b3-5c52-4b45-9ec1-ed51d8f8b631"
      ]
    },
    {
      "cluster_id": "c97fb561-3217-4665-93fe-191384f9c143",
      "members": [
        "5fadfb89-8910-4205-bfcb-e7b767a420a0",
        "734ada9f-5249-4622-87e4-59853bd3ca96"
      ]
    },
    {
      "cluster_id": "261a6bc9-08bd-454b-9fec-f9f4a0fe9250",
      "members": [
        "f4a6e102-743d-4a10-b1fc-da4b283c1748"
      ]
    },
    {
      "cluster_id": "442c376e-0da2-4461-a8fe-6d964ea3c00b",
      "members": [
        "8840e33f-2cd1-4b8d-93e8-dcad7cba5f3d"
      ]
    },
    {
      "cluster_id": "b51f7dc2-d0c0-43ca-aba0-033ca0100d18",
      "members": [
        "c2554150-da86-4ad4-9a8c-3abb18092cc9"
      ]
    },
    {
      "cluster_id": "d0b9d362-84b5-4285-90de-b70dc7fdf9db",
      "members": [
        "7bdd1f26-74a1-4f78-864b-931bf388e62d"
      ]
    },
    {
      "cluster_id": "4d2908dd-c372-4065-827c-bbbe9d18c879",
      "members": [
        "a0fd99fd-4064-4c31-beef-aea5b915d57c"
      ]
    },
    {
      "cluster_id": "af07ce28-0024-41ac-b51c-01e4bbf2c507",
      "members": [
        "091c1cf6-adc8-4823-808f-b9bd34b2c68a",
        "43190cf0-9e6b-4ae2-a7b4-2194945580eb",
        "54befbf4-323e-4ec4-b0d5-6b075fbfff8e"
      ]
    },
    {
      "cluster_id": "bcc8a49a-201a-439b-bf04-a72b13e50b57",
      "members": [
        "7d52399e-9fd4-4ef6-ad61-e9c1004b479d",
        "82024969-a370-464d-9b78-4528b73f0e66"
      ]
    },
    {
      "cluster_id": "b9cc9dc2-9dcc-4730-b5fd-d7d5a7f9e126",
      "members": [
        "59840c00-da45-49b8-ba87-6e4ec07b3dd0"
      ]
    },
    {
      "cluster_id": "9c4f129c-13a2-41c2-aa00-330c197b8780",
      "members": [
        "ce05174f-bd24-4296-a6ec-f3aa221ae8e7"
      ]
    },
    {
      "cluster_id": "7fd887a5-caaf-4dd7-967d-5f621c88bae6",
      "members": [
        "6d502776-1705-472f-a052-9bae2595eceb"
      ]
    },
    {
      "cluster_id": "7e91212d-531e-468a-b19b-7f7bff3fda9d",
      "members": [
        "e005d56e-7e0a-44da-9463-7e59e19f8e3a"
      ]
    },
    {
      "cluster_id": "7dae31f7-fc93-4b4e-bd3c-7a87267ee2bd",
      "members": [
        "4c593132-8ef2-4218-bc92-54e12c4ac457",
        "6e5fec9c-b2f0-4e1b-852f-6806a7eef1f9"
      ]
    },
    {
      "cluster_id": "f239b4c3-e0cf-4725-9d59-2b1e32a9ad39",
      "members": [
        "042276ae-6db4-40af-b408-aa46e970d2c5"
      ]
    },
    {
      "cluster_id": "c7c8c6d3-cdc9-47d7-8f45-165280d3560a",
      "members": [
        "9d3f9b7d-b953-4f66-8e82-2ef2c80bff16",
        "6890ec3a-637a-4135-bc44-7e9bf3e9ef98"
      ]
    },
    {
      "cluster_id": "e6120475-8d62-4b1d-84b3-4c53f22ff855",
      "members": [
        "d29d4cd2-9756-49f4-b174-98c43f065c21",
        "0ad13d49-2b90-4845-b043-0b1effe7af40"
      ]
    },
    {
      "cluster_id": "14b07b58-6d89-4f8a-8ddc-8c0a902ee333",
      "members": [
        "6969d256-3deb-46fb-8044-e5876804511b"
      ]
    },
    {
      "cluster_id": "391672fd-aef8-4243-932a-77e726662902",
      "members": [
        "1a2792b6-491c-47e0-86c4-78505dcb126e"
      ]
    },
    {
      "cluster_id": "788ae773-424f-4215-9262-5847e02b117b",
      "members": [
        "26d837e2-51eb-4a5b-a3f4-6de34ff0ee08"
      ]
    },
    {
      "cluster_id": "4550eb60-072c-4e27-8e64-8c04270738c8",
      "members": [
        "011bd2a9-8271-4b4a-908b-aac429423860"
      ]
    },
    {
      "cluster_id": "169e370f-8381-43b0-8425-6e6dcf0bee77",
      "members": [
        "6891d4bc-7f6e-4d54-a027-12dbe8eb3ab8"
      ]
    },
    {
      "cluster_id": "a0aa3975-d232-4eed-a961-eca71bc27015",
      "members": [
        "d671635b-187f-40d0-a42b-732896025fed"
      ]
    },
    {
      "cluster_id": "8621b776-3006-4d9b-93a8-f14394cb2f9a",
      "members": [
        "5b397cc9-7288-426b-9112-16d6c2319144",
        "615e3004-e4d4-4db8-8943-572e5aec2d74"
      ]
    },
    {
      "cluster_id": "fc91cfeb-b23d-4b4c-816a-7fa7dfbf9e8e",
      "members": [
        "61c236bc-6219-4f54-a37b-045a9c1bbf51"
      ]
    },
    {
      "cluster_id": "93f03d20-e5b7-41c5-976e-5122f884847a",
      "members": [
        "f33629de-ea68-4a4a-93e5-ebb4b7e2643d"
      ]
    },
    {
      "cluster_id": "94d152a0-b275-42d2-af1e-de4ffe6f8a22",
      "members": [
        "6d7f5a83-3bd8-4234-906d-f5ef9e8fa9f0",
        "bd039d84-414e-4a80-9ac1-db3b9b1a85bb"
      ]
    },
    {
      "cluster_id": "7ae0d854-6d40-40af-a578-9fbba79fb394",
      "members": [
        "ff786304-52cd-4ed8-bb6a-ddd0fd7207d3",
        "0afadd85-4bc8-422d-95a9-0f0b99baaff2",
        "49d63289-c9af-47f9-bc53-72830a13fe12"
      ]
    },
    {
      "cluster_id": "9ee44494-957f-41e5-a680-3bacf709709f",
      "members": [
        "59aff547-9f80-46de-891e-008eb3c4a729",
        "6e550910-5543-4a06-a74a-00c18f1cde7b"
      ]
    },
    {
      "cluster_id": "8628cfa7-1952-4304-94e8-eca8c125fadb",
      "members": [
        "57c599ce-4b87-4ab0-83de-22733cfdbd26",
        "9b370277-b0df-4b52-bb69-f004f8f111db"
      ]
    },
    {
      "cluster_id": "9b558396-1afa-47bd-8065-f4f35e900fa5",
      "members": [
        "2d1f6464-f5ff-453c-b76b-cd8063d7cd66"
      ]
    },
    {
      "cluster_id": "fc19cd3a-f641-4b19-a6bd-bcbcbc1d7fe6",
      "members": [
        "219749c1-05e5-4ba0-b997-d3946448344b"
      ]
    },
    {
      "cluster_id": "418497da-ff5e-45fe-b7d6-b0ab00e9f812",
      "members": [
        "537f0b42-2434-4896-bffb-ab81f1d7d892"
      ]
    },
    {
      "cluster_id": "bfcfc457-5e16-4c1c-83da-c1f90a8c2bc4",
      "members": [
        "17f9e020-02d1-458d-b904-b8170db4e607"
      ]
    },
    {
      "cluster_id": "9e2dd54a-2362-436b-857d-0266fa2b8211",
      "members": [
        "0c48fb0e-8be2-4bc4-89e9-5d59615b0b5e"
      ]
    },
    {
      "cluster_id": "9f5a552b-da22-4595-b590-da914506237b",
      "members": [
        "9908eef1-a11e-4fc8-aab4-0175f621abf1"
      ]
    },
    {
      "cluster_id": "1f87ca5e-f76a-465d-9deb-690952b6b443",
      "members": [
        "ee3b0569-0453-4da2-80c0-4d2633c63d56"
      ]
    },
    {
      "cluster_id": "7f8ccaf9-3143-4e85-8fba-3e95d1568fc9",
      "members": [
        "5614cf21-6c14-4bdb-aeb4-bd24f098a256"
      ]
    },
    {
      "cluster_id": "3391436d-d1cd-41e7-87fc-ba5f4f2496cc",
      "members": [
        "ae0c2908-0718-455a-b0bb-f7b64da39d6d"
      ]
    },
    {
      "cluster_id": "f3c363f3-4590-4428-9518-ecaf53bfcf69",
      "members": [
        "2576ebe7-bdfa-4a54-9e77-ed200f2ebec3"
      ]
    },
    {
      "cluster_id": "d214ab5c-324d-4152-a542-c58284f4ca22",
      "members": [
        "fa9e5368-9529-4f06-8aa8-abbb99e2b39c"
      ]
    },
    {
      "cluster_id": "ed56cb15-531d-4953-a25f-e17a3cb3fb76",
      "members": [
        "c9e29398-01bf-45b5-b075-926abb3d6851"
      ]
    },
    {
      "cluster_id": "83f0ad4a-11d4-48a9-95b9-150f72ff58b7",
      "members": [
        "29c519c1-42f1-483b-b79b-feb999358f8d"
      ]
    },
    {
      "cluster_id": "42817958-19f1-419d-a3c6-d4ed59f438b6",
      "members": [
        "a6c720fd-1686-4b05-8dc5-e93b64893521"
      ]
    },
    {
      "cluster_id": "29cdab10-c4fa-43e0-a980-d1342b8aa258",
      "members": [
        "45bba5a6-922d-4a36-aabf-384c9f1904cb"
      ]
    },
    {
      "cluster_id": "33e00989-9970-4b46-a3f1-4c221fc84217",
      "members": [
        "9c5dc79e-889f-435c-8d93-0b33904276d5"
      ]
    },
    {
      "cluster_id": "0ae66dca-634f-424b-80e9-5fc4b2615b98",
      "members": [
        "9a10f506-e196-4eae-9a1a-e0e31b3ec0cc",
        "f17c6a8e-99aa-4004-b2f7-bddcb8a8cf3c",
        "839b82be-8ea7-4cae-8cb7-5df1b1d8504d"
      ]
    },
    {
      "cluster_id": "578d69cb-06e2-4455-a662-a864e327b852",
      "members": [
        "b2d3b6e1-3124-44b9-af89-bbc6c321f2a1"
      ]
    },
    {
      "cluster_id": "62c364ef-d86a-4575-aa30-edbcabb6f794",
      "members": [
        "5540a615-7376-440a-b19c-ded561c593d8",
        "76dd6ad1-96b1-4e31-af7e-dc4f3e810a68"
      ]
    },
    {
      "cluster_id": "89b14a97-e8c8-4e40-b25a-0dd26956ea7b",
      "members": [
        "a39b288b-6302-4b14-8a01-666ec983ae8a"
      ]
    },
    {
      "cluster_id": "2981a7a3-8893-4aea-93c8-d180660c675f",
      "members": [
        "3d7197b7-34e5-4017-ab34-a9a7e4d5b38f"
      ]
    },
    {
      "cluster_id": "a8f2c86c-3f8d-4f00-beaf-d0d6fffceae8",
      "members": [
        "c92ccedf-1f2d-4cb1-94dd-2bb312a837a3"
      ]
    },
    {
      "cluster_id": "0646d462-dfca-47fe-a0c9-5ac11b42cb7e",
      "members": [
        "f93f030f-0add-4428-b8a0-bc210dd7288c"
      ]
    },
    {
      "cluster_id": "828fd8b5-ddaf-4d75-8787-c4afd6bebc90",
      "members": [
        "bb8613b8-7b4f-4b81-b730-17ff3a4d9737"
      ]
    },
    {
      "cluster_id": "eb796d64-358d-4578-ad2f-2c3665e77d5e",
      "members": [
        "9ccc3f5e-2ac4-47b3-9b19-acbb7736468c"
      ]
    },
    {
      "cluster_id": "8a1337a6-24c6-4382-8169-4bec0e1a4fab",
      "members": [
        "676dc4eb-7bd3-478b-87cc-006ca3b200d0"
      ]
    },
    {
      "cluster_id": "c160d7d3-0687-4ba7-86ad-32e9cddeaf56",
      "members": [
        "da116685-a998-4905-afdb-e5e3ec59e41d",
        "b3dda178-d768-4eb7-bca5-8ff2b0536131"
      ]
    },
    {
      "cluster_id": "94b72832-2531-4bc1-ae04-872ab9df9981",
      "members": [
        "0e161649-17f8-4509-a87d-586546770d4d"
      ]
    },
    {
      "cluster_id": "615eb8c6-f4dc-46f8-a203-a52e0d6c79f7",
      "members": [
        "45a42fd9-f5a7-4cb6-8f87-a26fc49a727d"
      ]
    },
    {
      "cluster_id": "dbfa0b87-7424-42ca-8827-733df18f150e",
      "members": [
        "63adbf4a-a48b-42d4-966e-1a8a3af9e07c"
      ]
    },
    {
      "cluster_id": "d4448dff-7650-4f4b-b38f-b00c5af8c2b3",
      "members": [
        "370c1658-a5f6-4b11-a586-4bdde6133fc0"
      ]
    },
    {
      "cluster_id": "55dcf158-5a10-408c-b74c-c53a42b859a3",
      "members": [
        "47cb6c7d-564c-46d9-afff-c29eb954648d"
      ]
    },
    {
      "cluster_id": "4129284c-60dc-471f-99d0-fbb5e6ca7277",
      "members": [
        "2339fc15-a065-4003-b88b-a5a3b4b862e8"
      ]
    },
    {
      "cluster_id": "96a7a0f7-738c-489b-9ddb-d5c4dba8d9f6",
      "members": [
        "4173ffc9-354e-452a-a444-7d9dde76d9fd"
      ]
    },
    {
      "cluster_id": "c3b690f0-82c8-4db2-ba3e-5e52a89ca594",
      "members": [
        "32ee53b1-3b92-41bd-85c1-a621fc20e857"
      ]
    },
    {
      "cluster_id": "0761665f-c4f6-45c8-aeaf-2676ae75e917",
      "members": [
        "dad45bff-ff06-4b34-9960-c4c7ea3cf412"
      ]
    },
    {
      "cluster_id": "63282497-1e0a-4af5-b5c7-65b6b20ab63f",
      "members": [
        "bd67c3dc-14e3-4ded-86c5-85be907659f1"
      ]
    },
    {
      "cluster_id": "acd745c5-1bfe-4e37-a6d1-38b30d091ba1",
      "members": [
        "d925ee0d-72ad-4f96-bab2-3c5a09f04dc2",
        "38d0ccc7-b6b8-4e53-8909-a8c39537ad0c"
      ]
    },
    {
      "cluster_id": "2f282f8f-f24b-4f4b-aa36-e5da41c21657",
      "members": [
        "cdd19715-7484-4236-b9cc-b7dac26ac393"
      ]
    },
    {
      "cluster_id": "3a663e69-ed69-48a3-9c9e-25cdac30bcdd",
      "members": [
        "6d08ef90-3b48-46b5-9e69-3c057632bca0"
      ]
    },
    {
      "cluster_id": "4aeb0c0d-181c-4cfb-9c1f-7338a1c0e097",
      "members": [
        "2894861a-c18c-4d08-94f5-8b2fd4789c0d"
      ]
    },
    {
      "cluster_id": "7bd17062-e906-485a-b7b6-75d95fcf30ef",
      "members": [
        "7bac9831-eff4-4b20-8a3c-ab13ebb3c9f6",
        "bb9dbd38-71bc-4327-b8f4-4e516c788831"
      ]
    },
    {
      "cluster_id": "bd8d969e-3ce0-4ae8-b478-e7f5690a2b2c",
      "members": [
        "d9adfed9-41e4-4849-9b15-4f60cb4702f5"
      ]
    },
    {
      "cluster_id": "ec68f63c-4291-4d49-8068-2a2cf1250591",
      "members": [
        "27385007-232e-4547-9a01-a67e59484773"
      ]
    },
    {
      "cluster_id": "05374434-df8d-4b22-b660-0ddc27139765",
      "members": [
        "48ac904f-cd28-45e1-8038-2afaf6d99d20"
      ]
    },
    {
      "cluster_id": "499c9d29-7269-44cb-a1ca-192dc37f8892",
      "members": [
        "ec8bc2d6-087b-49ee-bfc2-490c93c6fdd6"
      ]
    },
    {
      "cluster_id": "0a14d3f0-c71b-44cd-8eea-7fc2fbc8fa38",
      "members": [
        "e91987c4-3173-40d3-a250-c5cc8957430f"
      ]
    },
    {
      "cluster_id": "7d49ce46-2d8e-42e4-a5d6-ea4a010fe5e5",
      "members": [
        "043944c0-e98f-45d3-9b30-6dbd80f9fffa"
      ]
    },
    {
      "cluster_id": "a65da1cd-8a4f-401e-8439-da2c5c03bd1b",
      "members": [
        "6fc0168e-30c0-49ba-975c-2c5f1930255e"
      ]
    },
    {
      "cluster_id": "9e47c442-5161-41a4-b305-ebf54f272e75",
      "members": [
        "9129f14c-e664-4d84-bab9-cdcd46688fce"
      ]
    },
    {
      "cluster_id": "996e6c58-b099-4143-9641-865300e8a753",
      "members": [
        "d416a2a2-d6ef-44d4-882a-c230f7d1fa14"
      ]
    },
    {
      "cluster_id": "ecb6a08c-9197-401c-afbc-cd0ee3d88f04",
      "members": [
        "96d7d449-804f-49f9-9105-1f5aaae069fb"
      ]
    },
    {
      "cluster_id": "f9e1ae92-90cd-4553-9870-a06691bcf1d5",
      "members": [
        "bf5fc7df-0949-4ea6-9783-f1e37cf285f7"
      ]
    },
    {
      "cluster_id": "9369f16b-6041-4a52-ab2e-d046a7246adb",
      "members": [
        "961644d6-94f7-45ac-8d44-584c0512aad4"
      ]
    },
    {
      "cluster_id": "3f32031e-6be6-43ce-bffb-40370a2c9f89",
      "members": [
        "303f9a7b-45ce-4950-8a4a-bb3e22b7370e"
      ]
    },
    {
      "cluster_id": "a8b93ec4-02b3-42be-92d5-d600d19a447b",
      "members": [
        "acb60d43-f74d-4842-9c21-e426c3fce095"
      ]
    },
    {
      "cluster_id": "676e3412-2df4-4d29-844b-686d41a53c1e",
      "members": [
        "aa31224d-f16d-4fd4-b8fc-8ec81c1cd22d"
      ]
    },
    {
      "cluster_id": "1417deae-6f6a-444b-92e3-0d85e814d6aa",
      "members": [
        "a18ae506-7470-4bde-894a-d0fb16051223"
      ]
    },
    {
      "cluster_id": "81165fd5-dea5-41f8-ac75-66b97e1cca44",
      "members": [
        "efa19fa1-4ef0-48ca-9ca2-1c43c0e27c71"
      ]
    },
    {
      "cluster_id": "64c8d619-fdbf-4e87-a23c-9bfa4369bc15",
      "members": [
        "98fc72fc-2efd-493c-bb29-fc2db28bd4c0"
      ]
    },
    {
      "cluster_id": "dbf3b7bb-6fb1-4da2-9ead-1fea65aeaf76",
      "members": [
        "74c12cf0-8d3e-4381-954e-732587fd097a",
        "0d06a48e-8249-453f-8f23-72b0f5363f52"
      ]
    },
    {
      "cluster_id": "28b18897-b522-4746-b010-473d38b5a261",
      "members": [
        "36b676e0-edfc-4f67-960d-c3088417a648"
      ]
    },
    {
      "cluster_id": "eef62b12-ce49-4113-8683-7c0cfeda9369",
      "members": [
        "e869fe57-fdea-4be6-b9b4-89324c3c6a7a"
      ]
    },
    {
      "cluster_id": "f1c3e82c-0769-48c5-9831-5c2bc8453631",
      "members": [
        "59368157-bfa7-4514-9718-0d32036571aa"
      ]
    },
    {
      "cluster_id": "82b01c38-1855-48d6-8ce7-6d564382bd37",
      "members": [
        "88bda5e5-84df-4482-abf8-c5cb471e32e9"
      ]
    },
    {
      "cluster_id": "06f12bc8-88d8-4040-ac0a-c4dcaae5b13c",
      "members": [
        "785c826a-c93a-4e09-924d-cc315c89df5c"
      ]
    },
    {
      "cluster_id": "dd183126-5d54-4c76-bc6b-357daae335e6",
      "members": [
        "8dbca90d-3ec2-43b8-9f94-fb7d415b2e13"
      ]
    },
    {
      "cluster_id": "4eb605cc-1913-4af0-aeb3-6e1b6f05c980",
      "members": [
        "f83a2d02-d797-4320-8d6c-be5970798141"
      ]
    },
    {
      "cluster_id": "865f10e6-6341-4c82-a7d2-80f23cacd415",
      "members": [
        "a5f9f3ff-df2f-4178-ba6d-e8691931802f"
      ]
    },
    {
      "cluster_id": "071edf6a-a71e-44b7-923a-bff12eb8ede8",
      "members": [
        "9ad1f0a0-0e76-42cb-83ff-5b8a42cece86"
      ]
    },
    {
      "cluster_id": "4197fab6-cdc4-4d7f-986d-0c9c57282306",
      "members": [
        "0f7b511d-5740-4b53-b4cf-cf3668c1adb3"
      ]
    },
    {
      "cluster_id": "4bacc8d6-9346-41d5-8d0a-b2a14974c1c3",
      "members": [
        "0f2dbe89-ff54-4477-85a8-ff103a065928"
      ]
    },
    {
      "cluster_id": "a7b8df05-a36b-47bb-9f07-210a97d31443",
      "members": [
        "fd44c5b4-90fa-4d18-ac55-ea45f162f03f"
      ]
    },
    {
      "cluster_id": "60d29486-ed0b-4997-a613-db65a447090a",
      "members": [
        "67a156bc-554c-4a0e-880a-2deb3629269a"
      ]
    },
    {
      "cluster_id": "cfd4b520-a181-4698-846e-ff280ba11189",
      "members": [
        "e0f319dd-3d5e-4152-ad63-50bb36218856"
      ]
    },
    {
      "cluster_id": "ff17e739-87dd-44ff-b5d0-44c22b4a7bb5",
      "members": [
        "15f25853-5fa9-4955-91a0-1e974c7bd1f3"
      ]
    },
    {
      "cluster_id": "71a8fcbe-7e01-4380-bb3a-befa2ea629f1",
      "members": [
        "9e3c9e1f-d156-4487-b047-454702c0a0c9"
      ]
    },
    {
      "cluster_id": "41895296-6f09-4b44-a2d4-3d90f2e03b81",
      "members": [
        "76936d38-bfd8-42aa-9bba-108527ac0852",
        "b9773562-fdb8-4302-8c5e-e2c8aa0498bc",
        "0556168b-ddf4-403b-855e-fa07d47df59b"
      ]
    },
    {
      "cluster_id": "e30d6b86-658d-4082-9c3e-5cf88f347945",
      "members": [
        "ecda8d47-834e-45da-99ad-dde7a7cbc0d7"
      ]
    },
    {
      "cluster_id": "5a4fc98d-9bb2-48e0-88c4-2decb355b92d",
      "members": [
        "b4eeaf9a-abd9-4af9-8860-51f96c268c6c"
      ]
    },
    {
      "cluster_id": "b2ed7816-e1d7-4d6f-8594-001922474b2c",
      "members": [
        "2bbb8dae-7e72-4910-b0bd-6037e113a97b"
      ]
    },
    {
      "cluster_id": "943f941b-168f-4ff6-86c1-d9d6b4c6fa28",
      "members": [
        "c8174195-85b1-4480-a278-cc0c29fcb947"
      ]
    },
    {
      "cluster_id": "fa62d81f-956c-46dd-ab58-7fb08e1ad844",
      "members": [
        "3753686f-7527-4b58-b712-4309746a6b70",
        "85fa9dad-7806-4138-a1ec-773a473535e7"
      ]
    },
    {
      "cluster_id": "1519b279-d6f7-427b-b68e-0ca8ed827547",
      "members": [
        "2c3b42e6-f19c-4c91-af10-c7605a5f690c"
      ]
    },
    {
      "cluster_id": "6c6a46a0-71cb-45d2-a4dc-1eee1da7c7f4",
      "members": [
        "11cdeae2-1dc8-48e1-83bc-5c70082acb0c"
      ]
    },
    {
      "cluster_id": "1a416b07-503e-4fc8-8b1f-de51772ab7ee",
      "members": [
        "6c002b89-e22d-4a9d-84d8-0614fa3eef05"
      ]
    },
    {
      "cluster_id": "03b2228f-a968-4a30-82e2-cd3ee126f59d",
      "members": [
        "7485585c-3515-4adb-8b93-cd0ad5ed2408"
      ]
    },
    {
      "cluster_id": "9324a7f5-d024-4c3e-9141-5fa03af67754",
      "members": [
        "d9a29223-ea58-43db-9109-11643672ca5c"
      ]
    },
    {
      "cluster_id": "dec6b876-cff7-439a-bac8-9b6a2c289ef2",
      "members": [
        "f391b9ef-3cd8-4617-99f0-84f6432c1ffc"
      ]
    },
    {
      "cluster_id": "ae8ea636-d211-440a-9860-24ae4efc00ff",
      "members": [
        "cd74cf4e-d219-4588-8a7b-e6ec75763d78"
      ]
    },
    {
      "cluster_id": "52a2820c-2844-4d7a-9571-36ea2c51015e",
      "members": [
        "ed1855f7-791a-4785-b6c7-f6f9d8667199"
      ]
    },
    {
      "cluster_id": "33f7acb6-a580-4b13-bf25-917d68f240ac",
      "members": [
        "8e772879-8642-4b48-aa61-c37c293a6f2b"
      ]
    },
    {
      "cluster_id": "a22f4cef-ff1f-4c32-aa22-6cedb760ab4f",
      "members": [
        "e1757ed1-c85d-4332-b917-71cf14dd2068"
      ]
    },
    {
      "cluster_id": "213f0d3a-e8ca-4bcb-b7c9-7c90117d668c",
      "members": [
        "ae57dcfd-b1b4-4602-8a3e-9f8286a28377"
      ]
    },
    {
      "cluster_id": "5530b92f-dd56-42af-8c16-6aabb4ffa553",
      "members": [
        "6453ddad-baec-4bc7-aa88-b3806c2802e7"
      ]
    },
    {
      "cluster_id": "c6d9c90d-92a1-44da-a5cd-12164b95f4d8",
      "members": [
        "1ee2f603-31c1-46f0-af51-ae84193e204d",
        "45deba27-bd1c-41bb-b550-a741e75c34b1"
      ]
    },
    {
      "cluster_id": "aacd7f08-5036-4563-9193-ec61d4e0ea80",
      "members": [
        "01511c05-4227-4b01-abfa-7adc2de18c4b"
      ]
    },
    {
      "cluster_id": "1616bd8d-8966-4c95-b316-b97e2fb92058",
      "members": [
        "93afcf6d-ba2e-447e-9995-a3ca6b4f9702"
      ]
    },
    {
      "cluster_id": "ce875605-9657-4d10-9c03-b203782b40e2",
      "members": [
        "ded3ab8c-bdcb-4c30-ad91-5fa73f6e12ae"
      ]
    },
    {
      "cluster_id": "59f5b290-5ff4-47d6-96ce-35630701a6e9",
      "members": [
        "c797fa3a-d06d-4add-b0a1-28f55b2dde2b"
      ]
    },
    {
      "cluster_id": "4ea6057d-751f-45d1-801b-72130ecef337",
      "members": [
        "96100367-5a4e-4d78-a813-979f5efc1ecf",
        "5cf794fe-3c11-47eb-9ac3-4d3c6c7f3126"
      ]
    },
    {
      "cluster_id": "fd5ddb7c-f743-498e-b007-014e9c97bbc8",
      "members": [
        "3e68195c-fd2b-4602-9af9-c8ad638afbf8"
      ]
    },
    {
      "cluster_id": "323ed409-a965-47fb-afbb-d0b2c3bbefa4",
      "members": [
        "d74678a1-6036-40eb-8476-e2f1df401b29"
      ]
    },
    {
      "cluster_id": "867c6623-6254-4965-b302-1483ede252cc",
      "members": [
        "117c6960-98c5-407d-adbb-50403c4f60b8"
      ]
    },
    {
      "cluster_id": "d3262128-2dca-4e39-baaf-d15bcec2979d",
      "members": [
        "b31b675a-f130-46e2-99f7-6f675e35c3d2"
      ]
    },
    {
      "cluster_id": "da41eb4a-56e1-401f-8c36-73d853bb3de7",
      "members": [
        "5f37959e-6018-4d92-9ba7-3b806f923e57"
      ]
    },
    {
      "cluster_id": "ba19914f-8e64-44f6-86f3-04a0671b4419",
      "members": [
        "f9c4d73f-4e35-4fee-ad03-0cd1d0d52053"
      ]
    },
    {
      "cluster_id": "5a676523-5e3b-4d60-979c-dc06042c89a3",
      "members": [
        "97d149af-33ce-4b66-b742-d5e7e4821c17"
      ]
    },
    {
      "cluster_id": "43f42741-0a89-4a0f-bdee-4f8b6bc2f468",
      "members": [
        "53c3ec33-616d-49b9-b0e1-6ad2c89a153d"
      ]
    },
    {
      "cluster_id": "7893a531-ebf0-48fb-8b91-b2f1e4865517",
      "members": [
        "db5eef14-6285-4126-bad7-44440b0749c8"
      ]
    },
    {
      "cluster_id": "06234dad-1957-47b0-bd01-974e9b80e07e",
      "members": [
        "09fd71bd-0dc1-4229-a155-1ce1f65d0043"
      ]
    },
    {
      "cluster_id": "80704d80-8bb5-443e-80be-d547a70828af",
      "members": [
        "56e67f7c-8309-4451-ae4b-1d9856d6eeed"
      ]
    },
    {
      "cluster_id": "bec1d887-4d4c-48f4-9b0b-ebdd0a488702",
      "members": [
        "91f708ee-7cba-4390-b150-7deab02d3d24"
      ]
    },
    {
      "cluster_id": "3de68a28-505a-4c32-bcec-da26bd58e42c",
      "members": [
        "4461c591-8c87-42be-8bb5-4fdcd0527da2"
      ]
    },
    {
      "cluster_id": "59a61072-395d-4f52-9f54-81f2c2e5b76c",
      "members": [
        "d7495a8d-b6bf-45d5-82cc-77b0c6709d76"
      ]
    },
    {
      "cluster_id": "53ac9504-7af3-4a7a-b7c0-a75d3fd36831",
      "members": [
        "106d0690-bc30-4ba9-b26a-bfd0aab06097"
      ]
    },
    {
      "cluster_id": "21435744-bfd5-457c-9149-a1cc5945dbec",
      "members": [
        "e09c492d-dc02-4e43-a62f-0b99fce6e857"
      ]
    },
    {
      "cluster_id": "4d12b965-7c97-4994-9361-6f5f0b2c17ee",
      "members": [
        "664a9a05-83f7-4192-a8aa-723b08092688"
      ]
    },
    {
      "cluster_id": "c74997a7-7974-4e4a-80ee-0cf8f0af8af6",
      "members": [
        "3664a7d9-e25a-4d5f-b859-f0974d7e61a7"
      ]
    },
    {
      "cluster_id": "bf617b93-4dcc-4186-81d8-7cd9fc2d425a",
      "members": [
        "2546d442-0582-40eb-a74c-4f9a3f2175f3"
      ]
    },
    {
      "cluster_id": "0c50a72f-e964-4690-a33f-e878b2e74702",
      "members": [
        "d2754557-5225-4fbc-b72c-765dc38aa10f",
        "b291b4aa-590a-45a3-be10-13ea049520f5"
      ]
    },
    {
      "cluster_id": "3a18182f-409d-4665-970b-231ce6a7c108",
      "members": [
        "d78ac63e-0777-404d-a654-3314aa76042a"
      ]
    },
    {
      "cluster_id": "e342f418-21fb-447a-a1a2-0cf67132d420",
      "members": [
        "213e163f-1e64-4323-8b73-a5c2a90f2b24"
      ]
    },
    {
      "cluster_id": "4fd88af5-5edc-4995-92ea-057702ca240a",
      "members": [
        "5638d4fe-e14b-4e6d-94f2-5f9ec535a289"
      ]
    },
    {
      "cluster_id": "733bc88b-24fe-4115-bf99-e05181e2177b",
      "members": [
        "2617aa50-867a-4602-a99c-970cd4c26ee1"
      ]
    },
    {
      "cluster_id": "8a1cf3e4-81f5-4680-a43b-353cdda171be",
      "members": [
        "d0b0335f-9ef1-4789-b5b2-1ae2f8c35f7d"
      ]
    },
    {
      "cluster_id": "ec9bc095-279f-474f-9706-4d758de892be",
      "members": [
        "8d0bcf05-53d3-4273-9d46-e6cf0ecd6408",
        "039043c9-c57b-4e89-ba4a-d25747c93f7d"
      ]
    },
    {
      "cluster_id": "18e3c7ef-4d72-40ea-ad9e-2d600cc1b21e",
      "members": [
        "361c4fe2-6085-4074-9642-b1385f2801ec"
      ]
    },
    {
      "cluster_id": "808de745-ec3f-47f3-84ca-5bbec4878cae",
      "members": [
        "97bbf6bc-4a68-48cc-abcd-8c6783ec1632"
      ]
    },
    {
      "cluster_id": "d8cf9191-20ce-4f00-be96-f15ca59147ae",
      "members": [
        "db1344a5-89a1-4347-abea-67f0dd3f8aaf"
      ]
    },
    {
      "cluster_id": "e113cbe4-9797-46e8-ab87-8e31da3f22de",
      "members": [
        "06607014-2653-4fbd-a38d-5fc623dcd790",
        "55ef6841-b095-4d5a-989c-cca41799f571",
        "aa4f399d-477c-4275-904c-522b7565062b",
        "ab6e267d-4f9a-4e79-b0a0-5445c91f52a2"
      ]
    },
    {
      "cluster_id": "d467c165-3190-4bf1-b5b6-3c529b474781",
      "members": [
        "0fd9ac7f-c2d2-4356-9fd6-d37fb0923518"
      ]
    },
    {
      "cluster_id": "771b0707-56ce-47d7-84ed-b75ab36dfd83",
      "members": [
        "348c5251-424b-4d51-ad66-ecc700fe6862"
      ]
    },
    {
      "cluster_id": "360f1793-af7a-40dd-84eb-5e978218de67",
      "members": [
        "bc6d6f5d-0060-46d6-9831-0165ac9c5060"
      ]
    },
    {
      "cluster_id": "061483cd-3b7a-44e0-857c-a5c4129b4272",
      "members": [
        "2663a5a4-ee2d-4be2-824b-022f551c7755"
      ]
    },
    {
      "cluster_id": "7a87a2e6-b475-458d-ad14-3c21326625db",
      "members": [
        "3dc6e4d7-c188-457b-aa1e-490262eebc3a",
        "5438d1e8-c35d-4f29-9ca5-d93e80592b4b"
      ]
    },
    {
      "cluster_id": "ebdd6e62-4f71-4eeb-b5bb-afa4c515a612",
      "members": [
        "45ed405d-d63f-4b74-ac4e-09d559d82b9f"
      ]
    },
    {
      "cluster_id": "92111d3f-ebb0-4617-aa4c-9df22ddccd03",
      "members": [
        "9c556d16-49aa-4261-978e-9d32978e28c2"
      ]
    },
    {
      "cluster_id": "b7659926-8b67-4333-bd9e-74433a7b83a8",
      "members": [
        "bedf361f-e294-471e-9129-126f1e8eff4b"
      ]
    },
    {
      "cluster_id": "c23b1bec-a608-4fc1-a229-2a8f9b59a27a",
      "members": [
        "bd7f3a70-71e0-431d-87a6-31f1e99c6081"
      ]
    },
    {
      "cluster_id": "7cee2601-5005-4b9d-948b-2e69bb408fa6",
      "members": [
        "f63d2f7e-ba61-4644-9687-b3fd07cde285"
      ]
    },
    {
      "cluster_id": "0ba56805-c27f-4d6b-bb0f-6903b4c54c1a",
      "members": [
        "9d638d6a-2493-48e4-a0b2-27751c44abe3"
      ]
    },
    {
      "cluster_id": "e52a7c45-1c0e-4caf-a481-c7da67d6803c",
      "members": [
        "2e7d9d9c-e144-4fdb-a9ff-6415313fbafb"
      ]
    },
    {
      "cluster_id": "0630459a-a055-49c4-959a-918cdf49936f",
      "members": [
        "b87b8799-7e39-4852-ac42-d2fad565035c"
      ]
    },
    {
      "cluster_id": "54622f56-5371-48ad-b7b0-c52dd54c9e1b",
      "members": [
        "c4307a80-d504-463a-92ff-83520b5b3bf0"
      ]
    },
    {
      "cluster_id": "45f9b0ec-ee3d-4cf9-bf46-990d297136a8",
      "members": [
        "0b881e1e-e5dc-460a-afee-ba5cedcde849"
      ]
    },
    {
      "cluster_id": "57033778-ccb4-4eeb-beda-4c41cf31fd86",
      "members": [
        "957a492a-475c-41c8-9568-337092ec1cc5"
      ]
    },
    {
      "cluster_id": "7e64d534-c786-4ebd-b549-3314cdd361e4",
      "members": [
        "2110a1e1-18e1-4cce-bc77-b88d972fa54b",
        "a30a7def-f57c-446a-bba8-1523343fe253"
      ]
    },
    {
      "cluster_id": "69acedef-de24-45bd-8d64-3a2e3c997d87",
      "members": [
        "af5749c3-42e7-462a-9271-b1a7eef7311e"
      ]
    },
    {
      "cluster_id": "fba25849-5030-47b7-9871-3584f06bc4e7",
      "members": [
        "16306e57-4df7-442c-9b3d-6890127882dc"
      ]
    },
    {
      "cluster_id": "83fa5a8b-b645-4ba9-9de1-a35b790ac1d5",
      "members": [
        "a841d3b3-c4e2-40b0-90d5-36b500b9b56f"
      ]
    },
    {
      "cluster_id": "ff0f509e-a0f0-40cc-821a-6f046f5aa96a",
      "members": [
        "61cc0da6-6ed5-4bd2-97eb-538a915cb8e2"
      ]
    },
    {
      "cluster_id": "45a4a2a8-b9e2-4fb3-a00b-44192e1fb005",
      "members": [
        "cd86d5b0-77df-4ca8-8d16-327883347bba",
        "e069958d-b137-45c6-98f8-d8ac1a244303",
        "30a75522-3ed2-456c-b5c3-4efdf6159930"
      ]
    },
    {
      "cluster_id": "aac0ba40-d82f-4ba8-91e4-f92c6960338d",
      "members": [
        "f15b39c5-3294-48c0-b492-b81bbdf6d383"
      ]
    },
    {
      "cluster_id": "ba26379e-e775-463f-9971-b8b46c709801",
      "members": [
        "a9b9e630-c878-4243-b1d0-c7481e5d08d9",
        "84d683de-68e5-4a20-8afc-f90d78ad11fe"
      ]
    },
    {
      "cluster_id": "fc95bbfe-5cb2-4a6b-a350-70ab1f4da4bc",
      "members": [
        "46f32c1e-d465-4fc4-b968-907dc6b4f887"
      ]
    },
    {
      "cluster_id": "1356f60e-0cce-4f4c-95ff-047c73d507ce",
      "members": [
        "d71e7342-5b91-4f09-952e-face150e4892"
      ]
    },
    {
      "cluster_id": "920d6e80-3d5e-4fd9-ac7b-57d21a7433b5",
      "members": [
        "3a0473ad-e8ad-48e5-a328-e6c97951e25a"
      ]
    },
    {
      "cluster_id": "f3b31658-0ebb-4d41-9f46-459b160be01d",
      "members": [
        "e487dd26-9a73-4505-9dd4-ad1bdc612ce9"
      ]
    },
    {
      "cluster_id": "d2b35337-7985-4ff0-934f-fef44d781bab",
      "members": [
        "2f5b4398-ece6-448c-b575-e405459872ba"
      ]
    },
    {
      "cluster_id": "baae4a32-5168-4c2e-a607-5bdb0996a9ff",
      "members": [
        "867d64b1-1e90-4105-980a-65a7665e1be7",
        "0ef8f617-1413-471f-9bef-929108ce8656",
        "37cdd7f1-dbbc-4d6f-bcd1-908d696cd044"
      ]
    },
    {
      "cluster_id": "21e6b94f-0371-4a78-aa0e-8082ef7b0068",
      "members": [
        "27a62bb6-250b-4b0d-9a85-ff22e9c61014",
        "29e1437a-f465-4e3c-87ba-8891e0ad54be"
      ]
    },
    {
      "cluster_id": "d1112bf6-9631-4abe-8c1e-925442961737",
      "members": [
        "0fa828cb-652d-4343-bdf2-1b70c654f860"
      ]
    },
    {
      "cluster_id": "e71c3cd6-157e-4870-8807-668962f49dc4",
      "members": [
        "4522a830-0495-4185-9d3b-e70ed737580f"
      ]
    },
    {
      "cluster_id": "ac066abb-a95e-4ab2-884e-0a0fd4b40f30",
      "members": [
        "50896647-c40e-4e4c-8cd3-a5b143cccb42",
        "f97b56d3-db33-4c06-bec3-fa9d9c74b5a3"
      ]
    },
    {
      "cluster_id": "d6b75ab4-918c-47fe-8efd-91ea4be62261",
      "members": [
        "b5b333e9-b9a1-4bbb-892a-f0a5c0cf934c"
      ]
    },
    {
      "cluster_id": "9fb69606-a3db-4d92-926c-b003f3516e43",
      "members": [
        "b2975098-e936-4fe2-9d6f-f693e951414e"
      ]
    },
    {
      "cluster_id": "856fcb01-3b6d-4fcd-80d4-8e260efa7cd2",
      "members": [
        "dba1fcfa-1008-4572-956b-b72a79251c5f"
      ]
    },
    {
      "cluster_id": "164a85e9-df51-43f2-948d-bd9852808931",
      "members": [
        "bcdc6113-5e07-4cdb-921e-de72d3e763d5",
        "88e2d6aa-7606-4bd8-a3c0-db8e791d0407"
      ]
    },
    {
      "cluster_id": "23236a04-b4c7-41b8-81ee-60c41aaa7835",
      "members": [
        "4e17ab58-8c71-480c-bf10-fc4db6bed7b2"
      ]
    },
    {
      "cluster_id": "a087c689-de45-45b8-a8c3-f348c23872b5",
      "members": [
        "e3e89324-4656-4d27-a1d9-94722e6901ad"
      ]
    },
    {
      "cluster_id": "4f9d6840-2d0d-40e2-b786-9827419e3e78",
      "members": [
        "42ffdc91-3f9e-47d1-add9-ad79f41aaeec"
      ]
    },
    {
      "cluster_id": "441ea463-41a5-4f39-8e7b-380142bd84bd",
      "members": [
        "76394907-afb7-4f37-aa2f-dfc7477afba4"
      ]
    },
    {
      "cluster_id": "6ef25b46-a4b9-4af8-a6c3-f3258aa3145a",
      "members": [
        "c98d893d-cd1a-40eb-b36d-90cf5c2bfe20"
      ]
    },
    {
      "cluster_id": "5cb65b5e-c51c-4fab-b738-dd41d64af22f",
      "members": [
        "7b32af01-f3a7-43ff-b41e-0bc643bdd5f1"
      ]
    },
    {
      "cluster_id": "f65ebec2-0122-4441-975a-e196ab928bdb",
      "members": [
        "14cda19e-74cc-4ecf-8ee1-e7aa8c095c28"
      ]
    },
    {
      "cluster_id": "bb4b93c0-732a-485f-b2ae-0ba6433c139f",
      "members": [
        "e0b44114-1fb9-4ef0-871f-a8437348bcf5"
      ]
    },
    {
      "cluster_id": "91a2ed36-3e87-4baf-9999-c65078a62cbd",
      "members": [
        "eafe14c6-be1c-4e43-948f-180d45325b0f",
        "0c3f7ad0-7532-46c3-a25f-884ccee7bb9c",
        "aca0f8db-8cce-436e-9f36-c59945100e64"
      ]
    },
    {
      "cluster_id": "b73efc0f-5d42-47ce-a8ed-e5aac2d0dd90",
      "members": [
        "287004c0-d2da-42f4-a8dc-a194c801f9ba",
        "cf7e36f9-41c5-4952-98ac-ce46ab5d8706",
        "594062b0-e5fe-4bb0-98bd-b48cf11c1183"
      ]
    },
    {
      "cluster_id": "e5320752-1012-4ce5-880c-e80ddb6ab4ee",
      "members": [
        "0665bcfb-b907-4224-a4e8-51b2e0d54305",
        "bbbff07c-eb09-429e-8e43-4ddc8d113800"
      ]
    },
    {
      "cluster_id": "b0ba837e-7026-4676-894c-bd729208b8f0",
      "members": [
        "43352cae-dd71-4592-a427-b23d73f649d9"
      ]
    },
    {
      "cluster_id": "c974679a-a285-4dfd-882e-18a49abd08e5",
      "members": [
        "52fba235-b03c-49b6-ab3f-c6ceeb4c9806",
        "7044d262-4ace-4d40-888a-aeb6c91aa16f"
      ]
    },
    {
      "cluster_id": "64855ee7-ebba-445c-9213-c6921f4dbbae",
      "members": [
        "c069ae08-6f59-4d93-8609-d8829dea6c9f"
      ]
    },
    {
      "cluster_id": "708ac391-bd79-4343-a52b-53252ffe59cb",
      "members": [
        "00b33441-6dea-4d54-b5b9-21f710682ec4"
      ]
    },
    {
      "cluster_id": "c2b68e30-8952-4460-9fc7-b286c267a038",
      "members": [
        "a55875c9-7d6b-4478-b251-ac04d3928e82"
      ]
    },
    {
      "cluster_id": "a5ce0433-5607-4061-b0d6-334f9dea23ec",
      "members": [
        "2ad90890-99e8-4cc3-91d4-03708a493250"
      ]
    },
    {
      "cluster_id": "db101c75-2320-4597-b222-b7197dc49dc4",
      "members": [
        "bb6d5a06-ec73-4f94-806e-44f667b2d397",
        "c327f749-1b30-42e5-aa05-6fbb0eeacd7f",
        "144f4ef3-3f8f-4bcd-af22-0f371f1acea7"
      ]
    },
    {
      "cluster_id": "1755b95e-bb0b-46e8-acd8-b7de1925ed67",
      "members": [
        "a7020c38-115d-4d56-bbeb-0749cb7b1e62"
      ]
    },
    {
      "cluster_id": "b448b340-9010-448c-b955-573b9913feb0",
      "members": [
        "3c4d9422-aa3c-4dbd-8939-0d4599a471d0"
      ]
    },
    {
      "cluster_id": "1dfcd0b1-4fc7-4be1-9e3b-b39ce16325cb",
      "members": [
        "d06c2086-8592-4a20-9648-27a514db85d9"
      ]
    },
    {
      "cluster_id": "90c48754-a318-4dba-916a-e40680d8ea62",
      "members": [
        "83d70978-7c6f-4749-a5c3-e16c0881df83"
      ]
    },
    {
      "cluster_id": "c75b3de8-57fe-4dc6-8aeb-f6022f783cc3",
      "members": [
        "9dd231ed-6549-4426-b246-32f1eaded4e4"
      ]
    },
    {
      "cluster_id": "7957f359-526a-4b55-928e-2a84077427a5",
      "members": [
        "8117f173-a92e-4259-a53e-252c36a5b242"
      ]
    },
    {
      "cluster_id": "7f12aafb-6273-4f93-bae0-fb2dee57d074",
      "members": [
        "58f7c1b7-d0ad-4051-acf9-3fdbd867dc54"
      ]
    },
    {
      "cluster_id": "447c6034-ca16-41e8-ae39-d9800adee825",
      "members": [
        "6edde202-5b09-4348-b751-085ef532a3d1"
      ]
    },
    {
      "cluster_id": "f2c360d4-d94d-4684-995c-edf2696b6aa4",
      "members": [
        "c35ca50a-39a1-42f0-8764-439d3656003d"
      ]
    },
    {
      "cluster_id": "ddc509de-3359-4d1f-94b5-786fbe3bdc35",
      "members": [
        "c20c54ac-f57e-4fb1-a13e-01290926d93d"
      ]
    },
    {
      "cluster_id": "73bf3278-1769-4596-8d67-3c3249542c2c",
      "members": [
        "1944b1ba-3007-48ba-baa6-e92a61fb0155"
      ]
    },
    {
      "cluster_id": "eea0fa94-e771-4e8e-a675-3b0499fa98b9",
      "members": [
        "133fb199-09bf-4edb-ba79-2d36ce99b94e"
      ]
    },
    {
      "cluster_id": "34dc1cb7-40ca-44c8-a250-8a0dace843a0",
      "members": [
        "e1bcb563-e899-4015-86ae-5d076ad11cc1",
        "592c3ce7-e4d1-4537-b9a6-6715c5ffd7e9"
      ]
    },
    {
      "cluster_id": "8258ee8e-37a7-4d85-b65c-6247bdf08da7",
      "members": [
        "fdc26a8f-16d2-4d86-b728-870089471c1f"
      ]
    },
    {
      "cluster_id": "2e85430c-b3c5-4c1b-88d2-e366b82a50f9",
      "members": [
        "654b6ee9-da37-475b-8ca0-1c7c9d1b92a4"
      ]
    },
    {
      "cluster_id": "fa02e97b-06d3-4b6b-83c2-ad956c6a8f2a",
      "members": [
        "fecf7f2d-ea04-469b-810f-67960991e690",
        "3ce707f4-2468-4911-aec9-34ed01947d75"
      ]
    },
    {
      "cluster_id": "801c5c4b-a47b-4b2c-ae4b-a35937597f3d",
      "members": [
        "9c1de945-a8c0-4007-85d2-ab4e1cc29c97"
      ]
    },
    {
      "cluster_id": "8cb39409-fba3-4dfe-91d4-98f7dbf55b5e",
      "members": [
        "0305278e-ed35-4d8a-a0b3-2bfe4fe16224"
      ]
    },
    {
      "cluster_id": "9674610b-7b1f-4315-90d0-0aac1ad7fa99",
      "members": [
        "31cb46a5-aa5c-4bd9-929a-941d8a026f3f"
      ]
    },
    {
      "cluster_id": "52dfdf47-104c-4ec5-bdb3-4d6a07a83d5c",
      "members": [
        "d0c92ac4-1992-4990-980b-2158d9d1f304"
      ]
    },
    {
      "cluster_id": "2cf7e8e6-c492-424f-8353-8feea83e3711",
      "members": [
        "57482d6f-8527-49ca-b1e4-aa0481fb84af"
      ]
    },
    {
      "cluster_id": "4d8a4d68-4905-4d57-b3f8-91de6feb19b0",
      "members": [
        "ee13169e-2427-4386-bcbc-81d32c5240bf"
      ]
    },
    {
      "cluster_id": "9b321e6e-fd77-47ca-b965-6aceb0683d37",
      "members": [
        "501932eb-8e4e-4348-bb4c-961a5d7a5c51",
        "e18a5763-a120-4afa-ae9f-76ba6dc6b6e8"
      ]
    },
    {
      "cluster_id": "348d310b-39d2-427c-af87-143686fcd6a8",
      "members": [
        "e726a95b-d5c0-429e-b55e-aa22b0826505"
      ]
    },
    {
      "cluster_id": "565785be-22aa-4015-82c3-a5551804b630",
      "members": [
        "32309a16-bc51-4681-a2db-b488abed842b"
      ]
    },
    {
      "cluster_id": "6936f63c-d90c-47ad-bcda-def68b0ec222",
      "members": [
        "ed9e92b3-a72b-407b-950d-76f4ea220467"
      ]
    },
    {
      "cluster_id": "f213c95c-e709-4a66-94d2-6982e6415c05",
      "members": [
        "dfe5731b-cf2f-4ee4-9e26-12eaac68b4f7"
      ]
    },
    {
      "cluster_id": "7c25f378-94ec-4e09-b534-e05191ebdf2b",
      "members": [
        "07fc3f18-2f76-41a0-accb-9c0bbadb3e41"
      ]
    },
    {
      "cluster_id": "f28068f5-d9fe-4cd5-a458-304fc4db522c",
      "members": [
        "2ba8d4cc-a5e3-419d-9e4c-ee2b544fdb4c"
      ]
    },
    {
      "cluster_id": "b2e1f729-9431-42cc-affc-159e60e3c7e6",
      "members": [
        "39943a96-831a-40c6-9920-66942f6a22d9"
      ]
    },
    {
      "cluster_id": "347d475b-a5aa-4035-8032-84126946c0db",
      "members": [
        "b0da3d30-908a-4fb1-a15d-c4d117036668"
      ]
    },
    {
      "cluster_id": "3d26e147-f4b2-4b1e-ba9b-bf45396f5e59",
      "members": [
        "0feb5d9e-c17d-4b4f-acbc-a62b41630ed6",
        "22add310-deff-4922-af09-bed7fb4c6eaf"
      ]
    },
    {
      "cluster_id": "052da5ce-3d09-4c7e-bec6-952cf04794b4",
      "members": [
        "13abc88d-5f8c-44aa-8f59-2e6ba65eb693"
      ]
    },
    {
      "cluster_id": "d116bd42-a280-499e-95f9-862eab4e8043",
      "members": [
        "385e9a11-a43e-4825-aaf7-8359018444f9"
      ]
    },
    {
      "cluster_id": "b83a1d17-db6c-42cd-8ccd-d99d30b78f59",
      "members": [
        "0b6b7959-afc9-4a75-8422-6f7eb755102b"
      ]
    },
    {
      "cluster_id": "ff03cd74-7869-49e2-a30a-40383add9c7d",
      "members": [
        "118c8dc4-7bd0-4d1c-b97d-24100912a230"
      ]
    },
    {
      "cluster_id": "29912b0c-71dc-4757-ad86-50cb8c825cd7",
      "members": [
        "28b0308b-9327-4280-890d-cddac0e064a8"
      ]
    },
    {
      "cluster_id": "89863001-f3cc-4b83-a5ba-601a96690a75",
      "members": [
        "4d9f446a-ef9b-4448-80be-ef5fb381ad63"
      ]
    },
    {
      "cluster_id": "69dae690-93b2-445c-aba3-76b5fc2d7711",
      "members": [
        "dd2cbb34-56c8-45ad-a455-dae8ea105667"
      ]
    },
    {
      "cluster_id": "e24b1f85-4581-4a8b-9bbd-39a7582f7249",
      "members": [
        "7055db5a-13ed-4e92-a63e-3b91d7c697c8"
      ]
    },
    {
      "cluster_id": "ffd8b278-907b-41d6-9ed9-9d3e17a00678",
      "members": [
        "98fd8acd-2549-45ad-b7d2-a8ccb35a1e5d"
      ]
    },
    {
      "cluster_id": "044cb84d-c3b3-4798-aaea-5e325bcd65af",
      "members": [
        "98910241-ea76-4661-865b-3fc6751e03ad"
      ]
    },
    {
      "cluster_id": "95efba0b-bc1c-48bf-8e7f-8321983dc081",
      "members": [
        "9dcf2d28-2e69-4f4a-a1e1-4004ea60c1ba"
      ]
    },
    {
      "cluster_id": "57c95e6d-bb6f-4da0-b18e-99b9d5c69c0c",
      "members": [
        "95ee44fd-819e-4e69-a0c6-6d8628545637"
      ]
    },
    {
      "cluster_id": "f60ced9d-709d-49cc-bda8-183a3ced98f4",
      "members": [
        "e884d029-e79f-46d4-936d-220f14127574"
      ]
    },
    {
      "cluster_id": "b49995a8-19fd-4ac2-ad8e-2c1b565ef509",
      "members": [
        "9be285a8-7478-450c-bb98-6b02a901425e"
      ]
    },
    {
      "cluster_id": "17e824c4-f35e-49c3-9ffd-3049f0003451",
      "members": [
        "82fe0a68-7276-462b-b7b8-079ccc14ba74"
      ]
    },
    {
      "cluster_id": "5716770d-1472-4c8b-9408-d81e71966a7e",
      "members": [
        "6dfb7d0b-227e-4903-b292-de4b409d7199"
      ]
    },
    {
      "cluster_id": "d62e9da4-a6f4-4493-99df-7aea8cb8b7d5",
      "members": [
        "1b12ba3f-a1a1-4175-b690-984d1d530510"
      ]
    },
    {
      "cluster_id": "a8758a01-da2e-4199-8bb4-bdf40b9dd8e6",
      "members": [
        "6a1d3820-e6fe-467a-8267-67da1be9617f"
      ]
    },
    {
      "cluster_id": "73ac3211-808b-4905-b95e-ccdafdc4bd5d",
      "members": [
        "b38d6b33-790d-418e-99c1-38e44e1acffb"
      ]
    },
    {
      "cluster_id": "ce538c96-9586-4a44-b4ec-f9e46a72b4b0",
      "members": [
        "e64cb007-1837-4811-8867-43dd7497c313"
      ]
    },
    {
      "cluster_id": "869b1f78-45f1-4c63-bfd1-5c2de5bf6e7f",
      "members": [
        "c9c0fbf0-a89c-453f-ac22-5bf199990d55"
      ]
    },
    {
      "cluster_id": "92352325-85b6-4726-9aed-67119e9599f9",
      "members": [
        "ce059a55-a1c4-4eea-a508-a9ebacebdc74",
        "34c5408c-1e1a-49f9-b0bd-04148f61a2b3"
      ]
    },
    {
      "cluster_id": "1282bd1b-6e16-4c06-9f2c-9c9344b54fd8",
      "members": [
        "fe53b27f-bc03-44b1-8725-44e524ee2b8b"
      ]
    },
    {
      "cluster_id": "5279c839-650e-45b8-a4b4-5af5d5649ea3",
      "members": [
        "40a5c718-7e22-4396-8c2e-32bf37f77173"
      ]
    },
    {
      "cluster_id": "0dcdf569-6e39-4d48-a8aa-2b6e3c34a3d5",
      "members": [
        "721023c3-f992-4634-87a0-83197c3ded31",
        "097e82e0-2a65-4af7-b3d9-e45351508ccd"
      ]
    },
    {
      "cluster_id": "626701fe-ae3d-403d-9681-7d335f03c82a",
      "members": [
        "a1a6ea99-b4c3-49ec-b6f5-85eb901fbfe8",
        "0f0735b0-0b64-43d9-b78c-c1bbb6bb8b3f"
      ]
    },
    {
      "cluster_id": "3fb778a0-a02e-44fb-a706-5b4689fd37e9",
      "members": [
        "c54363fc-151a-4f51-bf9d-22d702af02da"
      ]
    },
    {
      "cluster_id": "04b0fab9-75f9-45a3-8f7f-91f5ed199dc0",
      "members": [
        "db7346d0-0b92-4165-828d-0e8f2f59205b"
      ]
    },
    {
      "cluster_id": "b627252e-5ed6-4562-833d-dbc3b3ef2c2f",
      "members": [
        "1b2c529e-9c99-4ae9-93d7-b48b6a54d927",
        "0c174304-050e-418f-a279-afae9d4dad42"
      ]
    },
    {
      "cluster_id": "1310ff3c-798d-4934-989d-8b8e4e0530a4",
      "members": [
        "a5faa4e1-3e12-4dbe-85c7-2df6e0d41099"
      ]
    },
    {
      "cluster_id": "a7acdb17-a586-4af4-bbd7-68b913003d4e",
      "members": [
        "96fff80f-1ce7-4ce1-9985-d1a73c44d044"
      ]
    },
    {
      "cluster_id": "5f1df598-4786-4f75-aed1-8eb66dff4278",
      "members": [
        "2261ba1b-448f-4b56-9b53-4dd43a3f7a37"
      ]
    },
    {
      "cluster_id": "6aa1529b-b06b-446b-af24-0e7a95f9cc1a",
      "members": [
        "5a29eb59-d254-473a-a747-e01c8152d4ec"
      ]
    },
    {
      "cluster_id": "82b56123-1ab0-4271-8360-fac7c8b1d118",
      "members": [
        "15b48165-c232-44fb-94d6-ae4e9e5c63a4"
      ]
    },
    {
      "cluster_id": "ef3db80b-5215-490d-a636-85e6bcbe9e93",
      "members": [
        "da32d510-4c41-4b5a-a4b8-93aef86bc688"
      ]
    },
    {
      "cluster_id": "a3015153-afe6-4168-9a99-d14bbbdd401f",
      "members": [
        "314c4b9b-05f0-4aee-92e9-aabd47c81cec"
      ]
    },
    {
      "cluster_id": "62c5acb9-493e-43c7-9647-7858b2ea0c50",
      "members": [
        "0bee1005-e9ab-4e90-8495-090199b0897d"
      ]
    },
    {
      "cluster_id": "d770e161-8ec1-425e-95c8-277c26523ee9",
      "members": [
        "1bd90170-ccea-4e04-b3d5-20ce31df06de"
      ]
    },
    {
      "cluster_id": "91237aa3-bf57-4535-84ed-6b39c0f1b3fc",
      "members": [
        "688031d5-81f7-4c53-a247-743c996e4563"
      ]
    },
    {
      "cluster_id": "85b491d8-b806-4e3f-b616-3cfa5f5fa60f",
      "members": [
        "ea47ac8c-9571-4a89-8a98-d768143ca1bd"
      ]
    },
    {
      "cluster_id": "3422b937-ad13-407b-bc17-21e8928a73d8",
      "members": [
        "f5a5d426-8a1a-4b25-8db3-4350603c6041"
      ]
    },
    {
      "cluster_id": "c7d67f17-53ce-45fd-95d4-ee1ed41ef6c6",
      "members": [
        "cfad659c-cb91-411e-b838-43338e2259a5"
      ]
    },
    {
      "cluster_id": "f8d1571f-9c56-4682-8574-cd3b32ed6cc6",
      "members": [
        "67ddd5c7-214a-4d5d-b759-ee5548e2cde8"
      ]
    },
    {
      "cluster_id": "a9876e6a-52b6-4181-945b-9e745a17434b",
      "members": [
        "cca4f7be-96e2-400d-b27b-e1defa7434a2"
      ]
    },
    {
      "cluster_id": "9bfae508-3289-4175-a44f-b761d47a58ba",
      "members": [
        "e198a5f3-f610-4ce6-8505-b7ff7e34d9cd"
      ]
    },
    {
      "cluster_id": "3bff863b-ef2c-4985-ab4b-24af72e149e9",
      "members": [
        "3ccdb77d-b841-4282-ae76-ba8e2f8b361d"
      ]
    },
    {
      "cluster_id": "03ab33c5-869c-44e7-85ff-a26adc857fce",
      "members": [
        "7f8d9241-333d-41c9-bcbc-7cc2af18e259"
      ]
    },
    {
      "cluster_id": "d769b36d-aea1-4403-834b-b416d2db1047",
      "members": [
        "54774750-6451-4196-a2c5-8668041813b8"
      ]
    },
    {
      "cluster_id": "1edefbd4-7887-468f-8ea8-789dc55de3db",
      "members": [
        "516e9191-4150-4f89-9a9d-06c8702e5117"
      ]
    },
    {
      "cluster_id": "65f75788-4ff6-47c1-8a6e-6bb7cdd19537",
      "members": [
        "949e61da-22a2-4985-9fd4-de24d561015c"
      ]
    },
    {
      "cluster_id": "f21aa624-4667-4f48-bb4c-1942acec5158",
      "members": [
        "26f51bef-6306-4cd6-bcb2-780b717ca091"
      ]
    },
    {
      "cluster_id": "216c68fc-7c8f-405c-8f46-568b32c69eb4",
      "members": [
        "38198833-eb7c-425f-92e8-694e5ef24acb"
      ]
    },
    {
      "cluster_id": "ecec86b9-e0c2-4698-b5d8-0631850621a9",
      "members": [
        "a207afbe-4dd3-439f-a8e7-7336149b467c"
      ]
    },
    {
      "cluster_id": "f4766e96-74eb-4ff2-aa7a-ed465ba83cbe",
      "members": [
        "ed2ed877-46e8-4358-851e-d900f564ac83"
      ]
    },
    {
      "cluster_id": "88f7cf16-b8a2-4b9c-98ee-aad660820b7c",
      "members": [
        "53195865-e8f7-4076-9d02-8a49a466cb34"
      ]
    },
    {
      "cluster_id": "92fc4500-350f-4d12-9690-7e529074f891",
      "members": [
        "6dd2be4b-91b8-4c26-9050-a990c250143b"
      ]
    },
    {
      "cluster_id": "2ef61e30-e6d5-41b7-8ea0-69add1125af6",
      "members": [
        "45d81d20-c534-4029-800a-27e1f275a439"
      ]
    },
    {
      "cluster_id": "72242d20-ab02-471e-ba74-fd7caad2c382",
      "members": [
        "657c0cbb-669f-40e7-9983-2bcc27688e5b"
      ]
    },
    {
      "cluster_id": "c95c962f-c479-4151-9149-d13898c2a6b3",
      "members": [
        "2f51cfb8-e217-4101-9ecd-ca150c2bf799"
      ]
    },
    {
      "cluster_id": "f7a6ba19-2cf9-487a-a498-908208872dae",
      "members": [
        "c88721eb-b13e-44b2-854b-d3b82482fbfa"
      ]
    },
    {
      "cluster_id": "89ee63c1-fb19-4aa6-ab9c-62e22a3b7244",
      "members": [
        "f7a91795-523b-4b76-9f51-a9118e118291"
      ]
    },
    {
      "cluster_id": "ccdc4717-b37b-4b1b-94a7-20dfafa305fe",
      "members": [
        "6f20fe88-be70-4d4c-a915-de8c4c5b535c",
        "8aa39dc8-d60f-4378-93f2-4036d197cd07"
      ]
    },
    {
      "cluster_id": "cec3a521-c732-4e0b-8192-f6efa6c46d10",
      "members": [
        "89a8455c-ba43-4744-9921-977a09d0deed"
      ]
    },
    {
      "cluster_id": "983a818a-ed6d-40ec-af64-8e28da7e1bbd",
      "members": [
        "e6a17aff-8b81-4824-bf2d-718dd2e011da",
        "62b1c349-8a48-41c6-aff2-041f14d94129"
      ]
    },
    {
      "cluster_id": "356ce4de-dd2a-4caf-bb6c-703dee1f13f4",
      "members": [
        "75866a69-139a-4618-8081-25cdae28617f"
      ]
    },
    {
      "cluster_id": "b7375a29-4c73-4062-a85e-7e1c1f79300d",
      "members": [
        "060a96ad-1d98-4702-8ccf-e51390aba2e6"
      ]
    },
    {
      "cluster_id": "b07254f1-f996-464b-a61c-6949e39dcdb5",
      "members": [
        "81510421-97b3-4279-9cc0-9f0343057db8",
        "d31b6f35-3e22-4748-bfc3-2024cf70804d"
      ]
    },
    {
      "cluster_id": "d4f9c49d-3b78-4035-b051-f58469f25ba7",
      "members": [
        "650cbc5e-d8af-469e-90a4-504e75adc3b9"
      ]
    },
    {
      "cluster_id": "ede13164-94fe-4382-9f88-120091c29cbc",
      "members": [
        "15a43cb1-bbea-4dcd-87c5-43ee5922e048"
      ]
    },
    {
      "cluster_id": "83df36bd-a3ff-43cc-b6fd-c979f5dfd9da",
      "members": [
        "6c534fc9-fcac-4607-902b-1272dbf1c0a7"
      ]
    },
    {
      "cluster_id": "50c706cf-6243-4e9d-81ec-789d3dbecc99",
      "members": [
        "ffab163b-2bdb-4374-996b-8bf59d3c3b70"
      ]
    },
    {
      "cluster_id": "b01fa043-31ff-48da-8746-ca50ad89a48a",
      "members": [
        "0e7761d8-4680-4c3f-8a17-955663c844a5"
      ]
    },
    {
      "cluster_id": "9087a989-a032-4a4f-877e-3dd17a8e6902",
      "members": [
        "97d6446f-064c-4508-bdc4-990a4467f02e"
      ]
    },
    {
      "cluster_id": "a5da6c97-e954-417b-b043-c6eda504cf34",
      "members": [
        "5d6133ee-f749-4be1-8804-cc25d1fd0848"
      ]
    },
    {
      "cluster_id": "128ade3d-bda4-4b71-b956-463eb584089c",
      "members": [
        "82eb5dca-d1e4-463b-8328-bb70084866ce",
        "25bba8d0-7a7b-45ed-9973-9c6ccc480852",
        "65c099f8-b04c-434c-82f1-db7b66e3bb75"
      ]
    },
    {
      "cluster_id": "3d7436aa-4609-467d-a098-e24702a617e8",
      "members": [
        "1cbe5805-33d2-4a49-bedc-c8b721a9fcc9",
        "dc63181f-17bc-4343-b478-aac247e55192",
        "b8455709-3440-4c63-a8b8-4fde488d3279",
        "2c7e26c3-b9b3-45c9-af2b-3b4ed695a329"
      ]
    },
    {
      "cluster_id": "658c3b98-6196-42b5-b086-e8814a2a7b5e",
      "members": [
        "f1be433b-64d3-4ee2-b711-5bddbdc3b211"
      ]
    },
    {
      "cluster_id": "0ecff957-070a-4e14-9ee5-9c4a7435ec3e",
      "members": [
        "789d58fa-93fb-45bb-9abe-ff9b780c7054"
      ]
    },
    {
      "cluster_id": "a58a3450-f18a-4787-a5ff-ce87f4539ba9",
      "members": [
        "46008da7-e2a3-4b5c-804d-7d973706141a"
      ]
    },
    {
      "cluster_id": "49c9cf48-a13c-439b-9db3-4000e6bfc74f",
      "members": [
        "5a61323f-1a46-47aa-9fd4-188965d42c37",
        "10d02800-aa81-4b60-a52c-44f70d5a4ba9",
        "2e12c729-9448-4e2d-9dc1-58e700aa8af7"
      ]
    },
    {
      "cluster_id": "347d7cc9-3711-496c-bdf7-6c0c22b3750a",
      "members": [
        "cd27c98c-714c-40db-9d27-c4aa5d05e25e"
      ]
    },
    {
      "cluster_id": "7ba2e807-ddc2-4313-891b-359c6bfa546b",
      "members": [
        "61ee1818-cbe0-4db7-8b84-c29f877894c6"
      ]
    },
    {
      "cluster_id": "9c028d31-caed-4945-8a22-834a8ca119bc",
      "members": [
        "ccd7dda0-7348-4bda-996e-629c18077678"
      ]
    },
    {
      "cluster_id": "e50f2f1a-20bb-46bb-82c9-6def0deadc19",
      "members": [
        "c8c9e73c-4cca-4518-a635-034e32de8980",
        "3f8b75b1-2c42-4fc8-a159-ed729971cff3",
        "945dea35-f608-4c69-9696-2e53442a9e18"
      ]
    },
    {
      "cluster_id": "d6c8b67e-0b10-44df-8f54-3d630f15c443",
      "members": [
        "ed852cdc-bfd8-4384-b486-65cf10530958"
      ]
    },
    {
      "cluster_id": "5eaafca6-4075-4128-8780-266e84f06a62",
      "members": [
        "0abeeb58-cd42-46a9-9bfa-159671d5c4fa"
      ]
    },
    {
      "cluster_id": "fe7c0aa8-6a9f-47ad-ae53-9de7a81cea64",
      "members": [
        "4ef86bde-843b-46f4-a89b-ed61b420fd30"
      ]
    },
    {
      "cluster_id": "f37c17ce-c0f0-4c37-a425-7857fc4bf5bd",
      "members": [
        "fa0fd9da-5c67-4038-ad8d-9fb160b4ad27"
      ]
    },
    {
      "cluster_id": "a57199f1-f704-4a31-b1b8-b56b52a4b405",
      "members": [
        "17d38e55-503b-4ec7-8441-ce132a230a43"
      ]
    },
    {
      "cluster_id": "c19838ee-ef85-408d-84a0-c28811354698",
      "members": [
        "46ba9c8a-38e6-4870-92f3-71c773e089ca"
      ]
    },
    {
      "cluster_id": "af509b02-6699-4697-8018-d3a627ada0fd",
      "members": [
        "a47f9cd3-6c32-4586-850b-a0ddd5db7fee"
      ]
    },
    {
      "cluster_id": "42322612-a5c4-4a48-abca-12e69bf326a1",
      "members": [
        "1a2742e3-d3fb-48e5-bf4b-b4fc1e5a362d"
      ]
    },
    {
      "cluster_id": "ebcc0902-6e47-4925-9d19-ac06d520106b",
      "members": [
        "11e57b20-8edd-482f-8d82-40fbbc59b90d"
      ]
    },
    {
      "cluster_id": "3b1f4f0d-8cab-47e8-8ee7-7eb215e3b909",
      "members": [
        "437e98cd-85f2-47db-bac3-f5e207d213bb"
      ]
    },
    {
      "cluster_id": "ac8a01c8-dc87-4d9e-80a6-4614b1d6d5e6",
      "members": [
        "3dcd7b1f-01b2-48b2-8627-6bb067f50b75"
      ]
    },
    {
      "cluster_id": "9c02d7e0-91d2-4077-8adf-0916536016b1",
      "members": [
        "47b0c8dd-d904-48c3-a850-620108d989e1",
        "425a5c11-f27d-4f43-be17-a3bb22e2b8c0"
      ]
    },
    {
      "cluster_id": "8a222396-efb3-4d74-bc35-db09fb52168f",
      "members": [
        "2bdbcfa2-b80a-4f15-87e9-4ead32abcd47"
      ]
    },
    {
      "cluster_id": "f7bc5745-3844-4596-a6d1-1d8cba63f4b6",
      "members": [
        "49f9b46a-f921-44a8-aaf1-5ea187468899",
        "1c178e2e-5b14-4c6d-93fc-1b8fffd907e6",
        "eb6a35a6-a8a8-4668-aaf2-04d473829da9"
      ]
    },
    {
      "cluster_id": "f5cb17c5-09b2-438a-8af3-1ddc4e587641",
      "members": [
        "c06f10aa-ef48-49f7-8472-ebbd02c3d8b5"
      ]
    },
    {
      "cluster_id": "3c9a1b13-b4b6-4090-861e-e35159e61286",
      "members": [
        "e581a1e2-e362-4c93-9f84-238c6c5d5159",
        "ed0d1125-13b6-49a3-9515-4aeb847b3975"
      ]
    },
    {
      "cluster_id": "e95aa789-4bbc-4c2d-aa4e-ab829c64ed4e",
      "members": [
        "2e6de9ab-0fc6-44c8-b407-aa303e166569"
      ]
    },
    {
      "cluster_id": "bafef2bb-9288-4a42-8a15-be9d11a861ef",
      "members": [
        "ae74430a-5949-4b95-a120-a6eb384fd9bb"
      ]
    },
    {
      "cluster_id": "36e8c4e1-79bb-4ee5-81d8-1178da8ce862",
      "members": [
        "3bf4e4fe-3618-4cb8-8d2c-abcfe64d9596"
      ]
    },
    {
      "cluster_id": "81d7440a-8ada-45a3-8b2c-8318c7034ac9",
      "members": [
        "b728548a-c090-4038-9c76-17794be02f65"
      ]
    },
    {
      "cluster_id": "8c588fd7-3da5-41c8-be96-210ededa9175",
      "members": [
        "1e92e27b-0ddf-449b-83e9-404d8da25044"
      ]
    },
    {
      "cluster_id": "30adcb64-6b84-4937-a83e-146b8ce17e82",
      "members": [
        "4c42f1d4-18f9-414a-8489-6a66fdc45116"
      ]
    },
    {
      "cluster_id": "5eac68c0-2a04-4e6c-af79-6d253e14522a",
      "members": [
        "4c7d4d49-9392-47f0-94fe-c2a411854cab"
      ]
    },
    {
      "cluster_id": "09a67b60-49c6-4757-b8ff-5613fc63f6fe",
      "members": [
        "1b2898f8-0b9e-4973-8d15-1d632394728d"
      ]
    },
    {
      "cluster_id": "71624d95-aa07-4fb2-8217-706e01ae4a63",
      "members": [
        "79e8c735-743c-476f-a650-01f059fa32c1"
      ]
    },
    {
      "cluster_id": "2d65299b-2b98-4ff0-9197-e120b19ce3bb",
      "members": [
        "ad1ef3ff-142e-42f8-8b0c-469d655ebcc3"
      ]
    },
    {
      "cluster_id": "7860ac7c-a8a6-4b0d-8952-927a859be338",
      "members": [
        "cb13afd4-7f7a-447e-8c59-ffacf2dd9a71"
      ]
    },
    {
      "cluster_id": "70bf9f45-ce2c-4053-918f-69d225a10029",
      "members": [
        "29f831dd-3583-4717-b70d-08c20c2277b5"
      ]
    },
    {
      "cluster_id": "52d598fd-9b16-4bac-b3f5-6b1dca718bc7",
      "members": [
        "8671ab76-5e75-4a4e-924f-ede3eddbd80e"
      ]
    },
    {
      "cluster_id": "16d77388-3cab-4281-9420-51dc93557442",
      "members": [
        "4ee7de3b-1f60-445f-8a66-cc678fc92f3b"
      ]
    },
    {
      "cluster_id": "a5e788fc-37bf-43d2-97b2-732f917263ab",
      "members": [
        "b59a26bd-e33a-41d1-ad8e-57ce8f617df6"
      ]
    },
    {
      "cluster_id": "4b572207-fd2c-4388-8ae9-d177ee557903",
      "members": [
        "67c3c742-90ac-4337-9018-6e7ff134b06b"
      ]
    },
    {
      "cluster_id": "4f8224c3-991e-41ac-a885-d9b58bba5d47",
      "members": [
        "444523ca-76e6-42a5-8557-f2d374e6f96b"
      ]
    },
    {
      "cluster_id": "6da8eb62-757c-4652-8389-b32015cb40a9",
      "members": [
        "e28fde96-9f0f-4cda-b767-ef1e03a07eab",
        "b6ee86a2-5295-4ca0-b93d-53914a4ebae5"
      ]
    },
    {
      "cluster_id": "c7b52427-87e3-4932-9690-1d3cb09c79b7",
      "members": [
        "6cf34b83-d38a-46dc-8302-a20288b0d780"
      ]
    },
    {
      "cluster_id": "20d38dd5-1da5-4494-8238-6be550e715af",
      "members": [
        "5b8a68bf-3608-469c-b027-3fec24302b2a",
        "d5bd185c-ef57-4e4a-b660-99b8fcb2005c"
      ]
    },
    {
      "cluster_id": "da057e1c-8692-4118-a2c6-f3b0fa767931",
      "members": [
        "46c01df2-2feb-4f99-bc16-539c8ca2b867"
      ]
    },
    {
      "cluster_id": "315e3fc3-9356-409c-9b82-9011a9ad2a72",
      "members": [
        "a6c232db-1a65-43e5-99aa-56186d183ca5"
      ]
    },
    {
      "cluster_id": "c537edf5-ee14-4fb6-9cf6-9d972fbc67cb",
      "members": [
        "9306dc4c-bbdb-436c-b00f-b410355002aa"
      ]
    },
    {
      "cluster_id": "8e8f1a63-a25f-436d-856a-cda548ff35df",
      "members": [
        "458aeba4-416b-46fa-a35b-ecd460f72be8"
      ]
    },
    {
      "cluster_id": "beec5e0e-fafa-473c-9a37-0736cf0853e3",
      "members": [
        "edb8e667-b21a-45e7-848a-98aac580af24"
      ]
    },
    {
      "cluster_id": "d7c2bd39-22ec-4271-8c63-6ddb8efeced9",
      "members": [
        "8c142b12-a65a-4ce6-86ae-aae44f23c9cc"
      ]
    },
    {
      "cluster_id": "a720530c-6855-4d9b-b222-ba31bac4c4c3",
      "members": [
        "e748127d-9540-4a39-9726-f81edd2c8e8f"
      ]
    },
    {
      "cluster_id": "43a57714-f5d9-437b-8d5c-b293145616c2",
      "members": [
        "e3b3e9fa-930f-40cb-a960-487fe2683fab"
      ]
    },
    {
      "cluster_id": "2293ca8e-aa2e-4ee2-b17a-f9a9255d1eb1",
      "members": [
        "80f55654-6963-44a9-aadf-53eb4540c6cd"
      ]
    },
    {
      "cluster_id": "ef96e980-1163-49a7-829e-855a0719a797",
      "members": [
        "ab5a60e5-1d17-46e0-8127-9a12fee20233"
      ]
    },
    {
      "cluster_id": "b3940e35-7d56-462c-b357-ee3bc8987319",
      "members": [
        "2d9b57e8-c3c3-4496-889e-49cbb023c515"
      ]
    },
    {
      "cluster_id": "90d35003-13f9-4cd3-a3c1-b7524ac5bf16",
      "members": [
        "9e528c86-3518-44cf-9457-649aebabe1ac"
      ]
    },
    {
      "cluster_id": "8711a577-7906-443a-8adc-19d760bca08d",
      "members": [
        "9c94162e-1144-4d01-9300-a5d1061c9b0b"
      ]
    },
    {
      "cluster_id": "4b012ae0-8a3f-4446-8ab7-f0572ce911e0",
      "members": [
        "70adf12e-fa53-43c7-8d7a-2f599125e473"
      ]
    },
    {
      "cluster_id": "3c02cb9f-d868-4d95-a235-953e540c09c9",
      "members": [
        "d9906cb0-4f96-4c12-af10-045c3e9830a5"
      ]
    },
    {
      "cluster_id": "314e86f6-17d6-477f-8886-75643cc5dcde",
      "members": [
        "a994727b-62ac-4e99-9ff7-b623a3e7ce1e"
      ]
    },
    {
      "cluster_id": "60a99f19-657e-458b-aa53-ca2a6063f380",
      "members": [
        "a4650293-dc10-4ba0-8b5c-2a53b5c104ca"
      ]
    },
    {
      "cluster_id": "94346dc4-a4ac-4e3c-85da-06445ad201ba",
      "members": [
        "5d538b3b-083c-4c70-b5a9-0f0dfc1aa3f0"
      ]
    },
    {
      "cluster_id": "1179f0df-1a7a-4032-9a7e-362081c484c8",
      "members": [
        "38e35b26-e0a3-478a-b08d-491381d5c88a"
      ]
    },
    {
      "cluster_id": "cfcddae8-7e4d-4fb6-8a06-45fdad19422f",
      "members": [
        "e02e3907-1835-46df-850e-452f3b834bf7",
        "842d5a71-e5da-45fa-9689-793dd7cb8c7a",
        "a12b2da7-f04b-4c9c-a3db-7be295e9d41b",
        "cecf8006-3769-448b-bee9-c409927c3538"
      ]
    },
    {
      "cluster_id": "30d502a9-a0ce-4646-9e1c-b03b47f8dd5b",
      "members": [
        "541465c0-ead7-4c43-8610-39c68db9ae97"
      ]
    },
    {
      "cluster_id": "154780a4-c583-40d6-b0cd-5a3d8a1994cb",
      "members": [
        "0fa1cb68-fd34-4681-8f0b-84ed327d371c"
      ]
    },
    {
      "cluster_id": "2cca833d-ae9d-45ac-9501-885a938605a6",
      "members": [
        "dad446c8-03c1-413f-9114-2f9d5e01bd8e"
      ]
    },
    {
      "cluster_id": "4a10d70f-5f46-496e-a6f4-0b982956d03f",
      "members": [
        "462e4a03-4d8c-4341-833f-f2ec89502281",
        "292f24fb-5458-4a2a-8be5-7fc08f6f336f"
      ]
    },
    {
      "cluster_id": "b6c6623b-ece7-4fbe-8627-8db59a5e3dc8",
      "members": [
        "4e8ef4ff-dc82-4121-ab94-8ddfe30d3f14"
      ]
    },
    {
      "cluster_id": "1f7a9b1b-5ce3-47cc-9f13-4f47996738bf",
      "members": [
        "68c425e7-db7f-4682-8099-2f8ee5563c2d"
      ]
    },
    {
      "cluster_id": "b5a04b5f-b3fb-4230-b364-c7b2ab5c4aea",
      "members": [
        "8ab14ca7-177b-42cb-ba67-cf8818192e53"
      ]
    },
    {
      "cluster_id": "0b2d3f06-c549-429d-9974-6e988853ab88",
      "members": [
        "818fdb67-5968-4972-ae07-798bd412f8b9"
      ]
    },
    {
      "cluster_id": "58d2f307-4ee3-44ad-a765-c7a292798624",
      "members": [
        "47af4d33-0512-41a8-a25f-30f4778003fc"
      ]
    },
    {
      "cluster_id": "5fee0957-a733-4e61-bf4b-0025d615e97b",
      "members": [
        "60c71afc-0960-4690-ac6b-3a2929556e3f"
      ]
    },
    {
      "cluster_id": "d6e4581d-8b56-4f44-aadb-7c57a4d3eb29",
      "members": [
        "c87b17f7-61ab-471b-91cd-5716b5aac344",
        "1614d4e1-9ef9-4d1b-aef0-7beefdeafd27"
      ]
    },
    {
      "cluster_id": "c09c5abe-d2d4-4b78-b32f-49fbbd5778a7",
      "members": [
        "83bd32b7-c4ae-434d-9e02-3e01d321661e"
      ]
    },
    {
      "cluster_id": "4e1f9c12-6559-421b-814d-33b10f78b8a6",
      "members": [
        "f1647966-4838-440a-aebf-82a10a8894dd"
      ]
    },
    {
      "cluster_id": "b8594232-f9f8-428c-83d8-cd858f613031",
      "members": [
        "720a46b3-59b3-4358-870a-89c487e84d5c"
      ]
    },
    {
      "cluster_id": "e0ef928b-5c3a-4954-b041-cb096ddc889e",
      "members": [
        "8199722f-107b-4824-81cd-a4e9f21e452e"
      ]
    },
    {
      "cluster_id": "281bccd6-4eea-4bfc-b9dd-b2e9300159fb",
      "members": [
        "f4760408-3b19-425e-931d-f5b85fa7ad2f"
      ]
    },
    {
      "cluster_id": "d4c689b9-e4d7-4a70-913a-2c31aac2dfbf",
      "members": [
        "fd1e2a9c-0bc6-4fb6-8afb-685739fed911"
      ]
    },
    {
      "cluster_id": "c355c9c0-a133-4a94-b40c-10d91addc7eb",
      "members": [
        "f2497bf6-410d-4898-9795-ebd88e880c0f"
      ]
    },
    {
      "cluster_id": "f8fb699e-3174-4e1f-8079-1bb9372cf5ca",
      "members": [
        "364f0dcb-c131-4adf-a34b-8f19f88d52a7"
      ]
    },
    {
      "cluster_id": "0c3b0687-d7a3-4aac-ace5-4b4027adcc13",
      "members": [
        "fc990176-3f23-4e69-9e6c-2950dbd56f07"
      ]
    },
    {
      "cluster_id": "798603bf-ed29-47ab-b596-b02a192b8a20",
      "members": [
        "bf0075d7-5c9c-4369-9994-3b19f20c9099"
      ]
    },
    {
      "cluster_id": "c5d49178-7807-406f-89c6-f05965bb7e2e",
      "members": [
        "8f987eb0-0364-48bf-936f-1e5b5fa5087a",
        "c36de96c-9b8d-4c9e-a111-d540a59acbda"
      ]
    },
    {
      "cluster_id": "4703becb-493e-4c1f-aff3-21e217d2c90f",
      "members": [
        "6399ab81-8bf9-4d35-8afa-a1c2d5c281b4"
      ]
    },
    {
      "cluster_id": "212cb6aa-4aac-4425-b0fc-6bb9b68aeb36",
      "members": [
        "99376817-68db-4068-9cbd-fb73baa6456e"
      ]
    },
    {
      "cluster_id": "5dad5c87-4292-488c-b998-f9a86f6c59b2",
      "members": [
        "869f4856-096a-4864-a678-c4826830fab0"
      ]
    },
    {
      "cluster_id": "2f0fefda-5b83-4f80-8b8a-97c292bbda20",
      "members": [
        "d7d8e3b9-ac2d-4fb0-ab2a-62ee7454889b"
      ]
    },
    {
      "cluster_id": "23451a3d-c01e-4597-9cbd-b34940e92d21",
      "members": [
        "9a4403c6-b2ac-4ec5-b6b2-1619c342bcc2",
        "39119401-4fb6-4c51-a4a2-509133c89916"
      ]
    },
    {
      "cluster_id": "b7612309-cc53-44f3-9740-76cdf065b6eb",
      "members": [
        "b1b0c026-7199-4aa6-a048-93c13840edda"
      ]
    },
    {
      "cluster_id": "22523c97-d6bf-448a-b10a-ccd7fd668e2c",
      "members": [
        "822740f5-e6a4-43e6-9bee-e14d64272496"
      ]
    },
    {
      "cluster_id": "147ac41a-7de3-4c4a-9213-48dfc49549a9",
      "members": [
        "dda7fcf7-59ad-43a1-ae33-26eaf103fcb7"
      ]
    },
    {
      "cluster_id": "cecf5ab1-6a32-4285-b19c-a1e9eb89d592",
      "members": [
        "79419e99-ecaf-4138-b2b3-f7cee50fa0b0"
      ]
    },
    {
      "cluster_id": "ff15e2e2-1cc8-45e2-9674-8847b94be12b",
      "members": [
        "78bf4fdf-0835-4b4c-a611-940cce285dd5"
      ]
    },
    {
      "cluster_id": "a10aa5dd-2106-4783-8254-02da84449919",
      "members": [
        "6bbb635f-e0f2-452c-b57b-b5a70779c142"
      ]
    },
    {
      "cluster_id": "f71cbd0f-7a85-414d-845f-e4694c67d02e",
      "members": [
        "26067bc5-831d-4b3a-b9b4-282d8ffa5e85"
      ]
    },
    {
      "cluster_id": "7b54b660-7b67-4765-8335-f1bb9a8cf70a",
      "members": [
        "52833197-6a55-4070-bad3-f5ad28d3d8bc"
      ]
    },
    {
      "cluster_id": "1fb31a41-f917-4cde-9190-f353f630be9a",
      "members": [
        "6c30dbdc-810e-41d7-b83e-f6e17c80a0c9",
        "7482a314-6a20-4c76-a5d3-56a28a432af1",
        "d0f7b228-5da3-499d-ba68-8e855018863d"
      ]
    },
    {
      "cluster_id": "b38c991a-b869-4a3d-9864-3fdbb089a284",
      "members": [
        "a0b3494f-3b25-43d0-9637-2573e7d8135b"
      ]
    },
    {
      "cluster_id": "36ad2a89-3229-40ad-9f6f-f2c33f4ebacd",
      "members": [
        "2a7bc1e4-5c5e-40e4-acda-c53dafd3c9a0"
      ]
    },
    {
      "cluster_id": "ce27cd6a-2828-4d90-a12f-a0a6f593b1e0",
      "members": [
        "8b65cbf9-7f63-4595-bd95-246ce73c6301"
      ]
    },
    {
      "cluster_id": "a801c6f6-51a8-4c16-ae79-750cf640303a",
      "members": [
        "03d26c5d-dae0-43de-bb40-e12f1a0a1713"
      ]
    },
    {
      "cluster_id": "4b5e2cb0-217a-4cdc-81e2-027874f8da18",
      "members": [
        "516f9430-7cb6-4c16-9ce3-0f1dc1d59ae7"
      ]
    },
    {
      "cluster_id": "48704c98-ccd1-4907-aeb2-d6276a1025d7",
      "members": [
        "48c5dddc-78ed-48ff-a24d-21039089ec99"
      ]
    },
    {
      "cluster_id": "80f966d4-497a-4e7a-b9e2-4d30faf7da72",
      "members": [
        "2f591cc6-766b-4de0-90aa-5e326145da63"
      ]
    },
    {
      "cluster_id": "8c65cc84-ce1a-4345-89d7-20ee4e2bcf15",
      "members": [
        "988a9c58-5f46-4af4-afdc-75d17fc213df"
      ]
    },
    {
      "cluster_id": "569a8b8b-9b0e-41ed-a2cc-db56c71f5703",
      "members": [
        "8cb449ff-d21b-476f-a26b-289f9014209e"
      ]
    },
    {
      "cluster_id": "3bbdb582-a477-4388-acb7-cf6123d0c022",
      "members": [
        "6f925d02-63b7-45e9-afa7-ed6665196762"
      ]
    },
    {
      "cluster_id": "6ff7ccd9-f022-43dd-91cb-c864da8c63c2",
      "members": [
        "56b2e091-1cbe-40c4-a60d-667253b89be3"
      ]
    },
    {
      "cluster_id": "c79e73ba-e1da-436e-8dc9-c8818873c182",
      "members": [
        "153e7304-a747-45d2-89be-8d56d7ebf0c2"
      ]
    },
    {
      "cluster_id": "25a5b743-428c-47c7-abea-0b994fd987b8",
      "members": [
        "20a7f975-5a4d-424d-95ab-5ceb6cc370e2"
      ]
    },
    {
      "cluster_id": "ac3c6b64-fc97-40dd-93ef-f777610b8337",
      "members": [
        "caf47164-4bc5-4b92-a634-49bfbbc70e58"
      ]
    },
    {
      "cluster_id": "8e541384-70e4-4c7e-9ac4-ec79ad71649e",
      "members": [
        "16df827f-bd7a-497f-802c-657b4b130b45"
      ]
    },
    {
      "cluster_id": "a8cc6e44-ab60-4366-aa46-06f9a46a5810",
      "members": [
        "350979a9-e5d0-450c-a30b-382c9e68589c"
      ]
    },
    {
      "cluster_id": "84708f88-fae9-4536-bd01-2d6209b5f616",
      "members": [
        "3f7fdfd4-3e46-4d00-9a45-83acab5ddb62"
      ]
    },
    {
      "cluster_id": "44317cdd-77fe-42f4-b1db-9819636d2f58",
      "members": [
        "239b27e8-d089-4e57-98c5-4c76455d13e1"
      ]
    },
    {
      "cluster_id": "a8cfe9e0-0ef9-4b98-a9d6-504f670dd69d",
      "members": [
        "81417279-482b-47bb-824a-1e4360669d2c"
      ]
    },
    {
      "cluster_id": "72f778c7-a74a-4822-89c7-75defc5fed4a",
      "members": [
        "cee4ea01-6eae-46e4-89a4-59a920fa04a0"
      ]
    },
    {
      "cluster_id": "14087e7a-3bac-4d48-a154-8c1e158e6c14",
      "members": [
        "2769c0f5-344b-4758-b766-c38b432afbdc"
      ]
    },
    {
      "cluster_id": "82a95bd3-d7e2-43e8-9d25-fbbc664ac7bc",
      "members": [
        "8a516dda-7f66-40ad-8d0a-4790dec2af9e",
        "ed9f52e2-be9f-48ab-9f06-0402ef0d2399"
      ]
    },
    {
      "cluster_id": "7e17abde-ea9a-4656-9558-6e168a28baae",
      "members": [
        "a80a49a4-31da-41a9-8200-1b85ad04386d"
      ]
    },
    {
      "cluster_id": "777da0e0-2515-442a-8eed-8174f7063a5c",
      "members": [
        "409eb38a-b470-4060-875d-2a70306e343e"
      ]
    },
    {
      "cluster_id": "ebca8a8b-8a95-480f-8cf1-c34e09e5822c",
      "members": [
        "9c039d26-a19a-4ab1-acab-9eeefb6098a9"
      ]
    },
    {
      "cluster_id": "3c077d24-2d6b-4d5c-a441-5e0080a81669",
      "members": [
        "cdbc5470-c4bd-49b8-8dd1-ad1172e9f3e6"
      ]
    },
    {
      "cluster_id": "6ca3fb21-cb25-40c5-9b5e-3ce14f640344",
      "members": [
        "1e104b78-27ab-417a-b7a3-a811b036f8da"
      ]
    },
    {
      "cluster_id": "8b701600-84ba-4ca4-8c27-5ea0e1457d2b",
      "members": [
        "c3b69cf1-ef52-4f7c-a3fa-6f15916226ce"
      ]
    },
    {
      "cluster_id": "5abfb564-f878-4ffd-9c7d-3328a283dbfe",
      "members": [
        "a0dfc6e8-dd9e-4100-91c8-a8bbd3e7e379"
      ]
    },
    {
      "cluster_id": "e74b075b-e6e4-4efc-b7ef-f8a74fd509a0",
      "members": [
        "e5acb719-6e1b-4c0e-bf26-60b264eded67"
      ]
    },
    {
      "cluster_id": "1d2ddf8d-adbb-42d0-bc0a-c14744855316",
      "members": [
        "0cf8c26e-fa57-4bfe-953a-ccd79ef5a5b1"
      ]
    },
    {
      "cluster_id": "ac2593ad-b73a-4ed3-b199-eed400affdc8",
      "members": [
        "c28361a9-b80f-4c17-bee5-aefd916e9766"
      ]
    },
    {
      "cluster_id": "398bd69e-f1d9-412f-8469-51469e37a88e",
      "members": [
        "064c7739-3b88-43cd-92ae-29cd789412f6"
      ]
    },
    {
      "cluster_id": "4175d453-3f8e-438a-adde-113f24ef2a95",
      "members": [
        "2b83fc24-9c8d-42a4-beca-c56726ad2a54"
      ]
    },
    {
      "cluster_id": "2e75fb89-d4ec-437b-bb34-741837209437",
      "members": [
        "9eb89195-f804-43aa-988f-f7e451bdbd64",
        "78ab6f1e-93c8-4b9d-a81e-c46d3f8a86b0"
      ]
    },
    {
      "cluster_id": "ae7124a9-0441-414c-a93e-4e31fac08e18",
      "members": [
        "bbbf880f-a3d6-42f8-ad6e-06e0e077e13a"
      ]
    },
    {
      "cluster_id": "99042c58-6307-43ca-ac61-061cf8a5ba75",
      "members": [
        "860ccafc-2b23-4002-942b-bb242f004289"
      ]
    },
    {
      "cluster_id": "38e3f6d2-565c-42d3-b90a-be4665a0d1bc",
      "members": [
        "a9f960be-0d8b-42d4-be70-d97e78e0155a"
      ]
    },
    {
      "cluster_id": "b6472eb8-adb5-40da-b075-e00e04ed2920",
      "members": [
        "4740cab1-8725-4fc8-a0f0-f1d554915a43"
      ]
    },
    {
      "cluster_id": "7b0bfb4f-e506-40fa-b633-0da23dace3d6",
      "members": [
        "8ad73028-8c12-4fa6-a432-5b4119bf63dc"
      ]
    },
    {
      "cluster_id": "35a90496-100d-4386-a3d0-578c543e7dd4",
      "members": [
        "08f91ad3-d5ad-4436-88ab-157ab205095e"
      ]
    },
    {
      "cluster_id": "a2a4882d-9cb0-4b1a-8852-37a056ca2ca7",
      "members": [
        "243dbeb3-88ad-400e-a589-41c8938ab022"
      ]
    },
    {
      "cluster_id": "add21509-fc05-4fe6-a953-c98cc222477e",
      "members": [
        "6aac85c1-f89b-434d-b528-04e5dff82c6c",
        "9083b198-ef58-4d0a-b7b5-7f51f62c70a4"
      ]
    },
    {
      "cluster_id": "af6d1e09-650d-4e43-84a3-10adfa5661af",
      "members": [
        "e8b208e1-030d-4a27-bb7e-7787553dc27b"
      ]
    },
    {
      "cluster_id": "e4e6149d-8b97-4295-847d-c2c2c5acb8ee",
      "members": [
        "e8399eff-e7e6-4b21-b154-272768481766"
      ]
    },
    {
      "cluster_id": "f3a349ff-3152-4d09-b280-f92890a46edf",
      "members": [
        "944d2dbe-3483-4e47-b538-7b8559e9d958"
      ]
    },
    {
      "cluster_id": "0c87e09a-5d40-4c46-abb8-ffdda4139e41",
      "members": [
        "1136f4cb-a49d-41f1-9cac-d70dcf211cbf"
      ]
    },
    {
      "cluster_id": "a2925234-109d-4c57-aac5-814b5a99a831",
      "members": [
        "25a1caa7-d6f5-491d-9e2f-0a38fb2c651f"
      ]
    },
    {
      "cluster_id": "5fedf7dd-6fac-4316-b725-5d2fe32ac129",
      "members": [
        "1f092cf3-991e-4bd3-853d-2a376f8ad7f0"
      ]
    },
    {
      "cluster_id": "18554ac8-5c14-44ff-910f-06120f4b5680",
      "members": [
        "b129bd74-7a51-4dec-969d-ea1fbdf47d0a"
      ]
    },
    {
      "cluster_id": "f9f6b7b6-ec7e-4aa5-91d2-9d2cf4d35a54",
      "members": [
        "dac7813d-7275-44bb-ba70-9b18cb0b92f0"
      ]
    },
    {
      "cluster_id": "077c9500-5508-46b9-9207-39c50c9150fb",
      "members": [
        "c1a76e96-5a4c-423f-ad79-fe2527f488fd"
      ]
    },
    {
      "cluster_id": "6a3f5b65-ac92-4e63-91ac-fe203f06931f",
      "members": [
        "59bfd6ec-34b7-470f-93e9-7f20adf47941"
      ]
    },
    {
      "cluster_id": "01a95de5-1ee0-4431-afa3-a8234a4831ac",
      "members": [
        "6ddc3e25-2e33-41f1-ad1e-666dd835a9a3"
      ]
    },
    {
      "cluster_id": "0e36f836-fa5b-40df-8bd7-860b08ef47db",
      "members": [
        "c3b6dba7-c61a-48bc-a3b0-5cdb54988e2c"
      ]
    },
    {
      "cluster_id": "846c89d6-71e0-4858-9977-96bc0a6497b3",
      "members": [
        "50fe6559-6f9f-4660-9edb-49929b234b82"
      ]
    },
    {
      "cluster_id": "8b3eb310-4541-41ce-8ebd-0c1cfe7b2a0d",
      "members": [
        "88585fe8-9d78-4049-9dca-176f1d48d205"
      ]
    },
    {
      "cluster_id": "ed912a16-7c22-4013-aecd-05fbaf2f3003",
      "members": [
        "f30159a5-55d8-4fa2-a777-19e4b9407855",
        "a83dd8f1-3dca-4ac7-9e54-9a86b91766e7"
      ]
    },
    {
      "cluster_id": "a5739240-460a-4fd1-b5eb-223091bc040a",
      "members": [
        "6f732b0b-8064-4b90-98d7-b3a056cfe23e",
        "9414863b-928c-4d55-a823-f666352f7066"
      ]
    },
    {
      "cluster_id": "07ba7d5a-bc3c-4f63-a8e0-6487f494c700",
      "members": [
        "13e0a4f7-4725-4307-982d-1d8a5d9aea21",
        "c24eda70-eb48-4889-9a52-0b84731513cf",
        "6d18bc06-08d9-49b1-a732-ce69be1a92bc"
      ]
    },
    {
      "cluster_id": "69c908c7-3fb6-49fa-b102-50233b107e27",
      "members": [
        "9c39dcd3-3a13-408d-9f46-a0ff637bd8a7"
      ]
    },
    {
      "cluster_id": "b92e2016-2cf5-4f68-ae85-5c01d12bbd49",
      "members": [
        "288c9dd9-3458-4f12-b4d6-e48643cca886"
      ]
    },
    {
      "cluster_id": "fb360de4-aab2-45d9-8f25-8bdd44c0ce45",
      "members": [
        "719f65fd-c5e6-45a9-9c6f-87b91510dcff"
      ]
    },
    {
      "cluster_id": "b978e9a0-f48b-432c-b14c-50e4efff007d",
      "members": [
        "a528a283-82b0-49e5-a211-6a00230e9650",
        "0056a45e-1104-437c-84c0-4e7b7467c2a0"
      ]
    },
    {
      "cluster_id": "13862105-6364-499b-aec8-a649c26c5b3c",
      "members": [
        "f372bcce-24f2-4ed9-96cd-3179650f748f"
      ]
    },
    {
      "cluster_id": "d855e2c8-0fb0-4813-99e3-3fa003818f71",
      "members": [
        "4f338687-ee12-4164-af7c-22d507a2227f"
      ]
    },
    {
      "cluster_id": "3eb4bc87-51f4-4c2e-990b-944e8a053ab0",
      "members": [
        "3d76c853-db5b-4627-a972-02d243783eee"
      ]
    },
    {
      "cluster_id": "c49a8079-c568-4dfa-a64f-74a395498785",
      "members": [
        "a4af2e0f-25a6-4104-889b-f1dc8a920a6d"
      ]
    },
    {
      "cluster_id": "5c4c352e-d04c-4f9a-889b-492cb2fb067c",
      "members": [
        "a9ea8e8d-e334-4f5c-a6e9-f5710636ce5f"
      ]
    },
    {
      "cluster_id": "d622193d-1629-4f0f-a5cd-b9751e388901",
      "members": [
        "8d1e8f58-b8ca-43a4-8e79-91e7ca0256c1"
      ]
    },
    {
      "cluster_id": "cb346877-50ff-42c0-97e6-7abb95523efb",
      "members": [
        "250bbe9a-0721-433c-881e-aac280e1ea73"
      ]
    },
    {
      "cluster_id": "daeaa2d2-9b6b-4a15-baa5-d0940fc45a77",
      "members": [
        "ec45304d-e020-47c6-b28a-0fc4ef0617ac"
      ]
    },
    {
      "cluster_id": "9bc46e61-887b-42f5-8f08-16b384ac7b26",
      "members": [
        "1d3fd3d3-bcb5-4057-a3ae-cec350879713"
      ]
    },
    {
      "cluster_id": "c98e55d1-dacb-46cd-b78b-7ec41169fc51",
      "members": [
        "0e1785c4-83ac-45e4-b0c6-3b992768e268"
      ]
    },
    {
      "cluster_id": "c55fe718-0683-4449-8b87-8d1de09aac69",
      "members": [
        "1af1e3dc-71d8-4263-a2ec-a64fef34d4fd"
      ]
    },
    {
      "cluster_id": "6d2e659d-b2ff-460e-98c9-72a4faf6173b",
      "members": [
        "7a30875c-5e64-4fbc-8c8d-bed9b6f27cc3"
      ]
    },
    {
      "cluster_id": "b250fbe4-52ac-446e-8f1f-52af6aaeb77c",
      "members": [
        "a1e8eb0a-4b10-43cd-8856-21172708d018"
      ]
    },
    {
      "cluster_id": "8059d799-8a2c-4df4-b587-415d278d1563",
      "members": [
        "2cc4e4af-dc46-4ad4-a36f-739242ed3129"
      ]
    },
    {
      "cluster_id": "193b523c-c283-41d2-a3f3-b37ed50ae40d",
      "members": [
        "4e4dc1ce-8ec1-43b6-b148-db1a9cd086a0"
      ]
    },
    {
      "cluster_id": "41026f02-6a91-44fd-aeaf-33bceaabf234",
      "members": [
        "b0540df9-eca6-4ced-b2d1-700014fcdf69"
      ]
    },
    {
      "cluster_id": "662ce9d8-6ef2-47db-949f-92c2e48c1777",
      "members": [
        "828a2b98-67aa-4664-83eb-541f6a3cd05a"
      ]
    },
    {
      "cluster_id": "ecaaad84-7e56-4f5a-84d0-609fbf620112",
      "members": [
        "aec08892-b3ff-48a8-958c-46c7c40e6508"
      ]
    },
    {
      "cluster_id": "a1c74ee2-0da5-4362-bf0c-2f7caddeae61",
      "members": [
        "44ef036d-cabd-44bd-a118-83522dc907f7"
      ]
    },
    {
      "cluster_id": "c66e7d20-399b-4cfc-80f9-620801afd3f6",
      "members": [
        "c96a4fa8-d456-4ef1-a3af-9bb73753687a"
      ]
    },
    {
      "cluster_id": "6212a7fd-0f42-4186-898e-6bca1d985ded",
      "members": [
        "81ff8eb3-a8ec-45c9-b9ee-9e6c21e49496"
      ]
    },
    {
      "cluster_id": "030634a5-ed95-477b-876c-290912b18446",
      "members": [
        "16a94229-5252-47ee-a983-9a151fb50d8f"
      ]
    },
    {
      "cluster_id": "6aece148-00ae-441a-a570-cbee981c2154",
      "members": [
        "6bd57e1e-7b5d-4081-bfc5-623ac8cac507",
        "6a6b6e27-e2ee-4fbc-9a8d-4c993f33ffc5",
        "19b844df-9886-4baa-a563-1cb1efa79513",
        "5db43199-b0cb-4d87-b497-15807346afa5"
      ]
    },
    {
      "cluster_id": "c8fcfafc-5e25-4d83-82fb-dad89f0cb085",
      "members": [
        "c16cfff2-edc1-403d-a5a3-9b8fad5d5dec"
      ]
    },
    {
      "cluster_id": "a327718c-a538-4929-8a9a-932fc2ef4a9a",
      "members": [
        "bbb76c07-d3ca-4a1a-918a-4e1e65f81fd2"
      ]
    },
    {
      "cluster_id": "b6ada6e3-1455-491d-948b-45a74b134fab",
      "members": [
        "daaadb9e-5604-406e-bf09-cd42d4374674"
      ]
    },
    {
      "cluster_id": "a13ff8f2-81e7-4186-a169-3843a9ddc359",
      "members": [
        "2f715b03-548e-49c1-9000-e306db6857fb"
      ]
    },
    {
      "cluster_id": "b1babe59-a6e4-4d3d-9c56-c6ce7d8d64c4",
      "members": [
        "a965e587-80cf-4d10-8819-be9491ac2be8"
      ]
    },
    {
      "cluster_id": "3ea76b8e-7bc3-4056-b872-c2ebb28f696a",
      "members": [
        "1ba9a5f3-9a3b-4afd-9cf9-c318bb80db34"
      ]
    },
    {
      "cluster_id": "05f00def-a8b8-4cdc-94a6-9ead4bc629d3",
      "members": [
        "5ca90261-fa6c-467b-9774-646ffb71e21b",
        "c344854f-6c0e-402b-9e03-dca2dddbf8a7"
      ]
    },
    {
      "cluster_id": "e01a8825-f8eb-425d-b928-eda6b3f57929",
      "members": [
        "6fad7068-796b-4e29-923e-b77c12c1b30c"
      ]
    },
    {
      "cluster_id": "c7ac427c-82e0-477a-a03d-4c9be54cce85",
      "members": [
        "d17e6883-586d-470e-9f32-e80ae8581b10"
      ]
    },
    {
      "cluster_id": "6e881517-8e9f-47bf-854c-c29084f1a26d",
      "members": [
        "dea66aaa-48a8-4cca-b92a-84b2590481b6"
      ]
    },
    {
      "cluster_id": "24b4e3df-c6d4-41de-8dc5-0dafe4754aeb",
      "members": [
        "150c3315-1cf3-4765-a408-2f64186e4e68"
      ]
    },
    {
      "cluster_id": "d5f8926c-cfe4-4355-8a20-781d575d7616",
      "members": [
        "92dd5a3e-1456-4443-8272-98133402a88b",
        "ec67ebfe-51fd-4eb8-bbf5-d55aa15d030e",
        "22edd4f8-a427-4083-982e-d2c4008dda92"
      ]
    },
    {
      "cluster_id": "756be7cc-dc0e-4799-bd5e-990554a6844d",
      "members": [
        "fe76db37-fdb5-4340-9f9c-ce91489ba14b"
      ]
    },
    {
      "cluster_id": "eba7ffd7-9740-4070-bc0f-3ac660c28939",
      "members": [
        "fc4117d2-87c7-44ce-867c-4f13ac0f1392"
      ]
    },
    {
      "cluster_id": "4d62f2bf-06ba-4e7d-b665-78a194b70483",
      "members": [
        "da11cc7b-0f34-421e-bf7b-cf23c6d6b060"
      ]
    },
    {
      "cluster_id": "b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb",
      "members": [
        "c9eb5159-568f-4148-a2fb-6859815f6398",
        "8acf3211-493a-42fb-86b7-ca69f528baf2",
        "f842785f-7bc0-41b7-8adf-4be7195bfd1f",
        "8e86b9c1-b8fd-4850-a0ce-9bd15d8e9fe1"
      ]
    },
    {
      "cluster_id": "e128e0c8-745a-4ce1-995d-c5a2ac809b5a",
      "members": [
        "22b94445-9072-47f1-8db2-0a45e813b7e5"
      ]
    },
    {
      "cluster_id": "5f9c8cb9-e871-4d7e-8b36-9e411bdc35a8",
      "members": [
        "75924a82-3fcc-4240-91aa-b5e0dc0ddca6"
      ]
    },
    {
      "cluster_id": "d485a542-5dc8-49cc-9ed2-7c434144d575",
      "members": [
        "11229a50-6227-4cda-b6f3-5925c6879785"
      ]
    },
    {
      "cluster_id": "9bee1f85-c3a5-40f1-a8e3-aded362e94b6",
      "members": [
        "91e04afe-07d9-40e2-9618-693f13e31bb7"
      ]
    },
    {
      "cluster_id": "c11121a4-e475-45d6-a46f-861982c7538c",
      "members": [
        "79b10fc4-9ac8-4f93-8668-0ed316cb376e"
      ]
    },
    {
      "cluster_id": "a8cf67a0-14e4-4562-b59f-46b2a6b2b98a",
      "members": [
        "148f7765-0c59-4960-80af-85da467e859c"
      ]
    },
    {
      "cluster_id": "82ce4ef2-05ed-42ad-830b-f78ec5322a5a",
      "members": [
        "96921c57-8997-4820-ae0d-3f734506e1d1"
      ]
    },
    {
      "cluster_id": "fd964b79-d3b5-4267-ab70-39cd4b799f57",
      "members": [
        "0cec1eb4-0d43-4e73-b943-262808d31996"
      ]
    },
    {
      "cluster_id": "7a0efb78-9055-433c-904f-79dc94ad2203",
      "members": [
        "a9648e62-fdd2-4d60-9d4f-2eee4b983df0"
      ]
    },
    {
      "cluster_id": "cb120bb7-e884-4891-9573-61c67b37ce2a",
      "members": [
        "9f8e5759-7324-42fc-a3a2-93d97062df5b"
      ]
    },
    {
      "cluster_id": "7815f5ae-d441-4f71-b0e2-771810097e05",
      "members": [
        "e3138869-da14-4f17-97f1-26df7cad259b",
        "8334641f-a721-409e-8a0f-4f763cc30cd9"
      ]
    },
    {
      "cluster_id": "dba5927e-43c7-4d0e-9ca1-e78a9cdb024a",
      "members": [
        "ab57c0ee-23ff-4b12-8a23-b14c2fbe9ed6",
        "e383b025-a9fa-4797-9875-e72189d9e9ab"
      ]
    },
    {
      "cluster_id": "0b6f158d-8877-48ca-80e8-7a4602b55765",
      "members": [
        "bd45579f-c2f9-4ed6-8c28-c2cd8e8d68ee"
      ]
    },
    {
      "cluster_id": "2a871f4b-957a-43ae-bf82-09ab2ac57891",
      "members": [
        "75910daf-346b-4c9a-b959-259c73a68ff9"
      ]
    },
    {
      "cluster_id": "130b5f11-d69b-4e29-8d13-05a09ea6b8ad",
      "members": [
        "b8c349c1-0d1e-45cc-8f94-109672980d3c"
      ]
    },
    {
      "cluster_id": "24c54796-afba-46ba-9bb2-8854f3d0747a",
      "members": [
        "dc7cdf80-8073-4d2a-80c5-aa72b4be7526",
        "cd9edb31-6c8f-4113-8234-0aad95e575e6"
      ]
    },
    {
      "cluster_id": "2b0eed50-da8b-45e1-8588-42e0093ff921",
      "members": [
        "b48bf9de-0300-4962-a4bc-3b8c4ec05e4e"
      ]
    },
    {
      "cluster_id": "47544927-be6e-4238-bfa2-7d12e902c9e4",
      "members": [
        "6baee768-4fae-40bd-99ae-34818b6c4ff1"
      ]
    },
    {
      "cluster_id": "0587530d-6a6d-4aa0-9e34-087698c923aa",
      "members": [
        "2fef81c4-c4ab-4e3e-a3f9-2a1e32f501b2"
      ]
    },
    {
      "cluster_id": "a1711988-408b-42c4-8682-720bf33be6bf",
      "members": [
        "4c2eba41-b018-43bd-a059-2a1210432b9c"
      ]
    },
    {
      "cluster_id": "0807cdb8-6ddb-4585-ad14-90359bbf1c37",
      "members": [
        "2cb073f1-14d4-4cbc-bad0-da4fc2360c56"
      ]
    },
    {
      "cluster_id": "b05a0ac1-6107-4a11-aa69-1115d8b00d86",
      "members": [
        "1bff33ad-7336-42d2-89c2-c045d3609bcd"
      ]
    },
    {
      "cluster_id": "467eec25-d0de-412a-9f09-8a0db03d60ae",
      "members": [
        "229b9137-7527-41ad-a10d-d86236fbc4dc"
      ]
    },
    {
      "cluster_id": "36641d64-6f2c-4f28-a210-946f0a644597",
      "members": [
        "d35bb153-32de-4344-b1d3-debda63670ad",
        "fb93dc07-736f-4e75-bc9e-feef9be33698",
        "9aeea02f-b296-4f73-af29-f3946c7ef555",
        "cf1eee85-9662-465f-92bd-7755721934a6",
        "d3876d96-c6ba-48b2-a7d4-25ba4800e435",
        "2c5df468-b52b-4d60-8845-9a4f8f790442",
        "023a2ca0-6acc-4354-870f-1e990d38e0fc"
      ]
    },
    {
      "cluster_id": "503b13e8-42e4-48e4-8ace-47ca9e49140f",
      "members": [
        "fda7e305-9c69-414b-afbf-35c24c351e73"
      ]
    },
    {
      "cluster_id": "3fe0d18a-cf4e-4f24-a77f-892271df6bae",
      "members": [
        "3f21ec81-ede9-4aac-bcf6-7a87e74dc21d"
      ]
    },
    {
      "cluster_id": "3aabf3aa-c1eb-4474-a134-a2e2ec8c19f6",
      "members": [
        "27a83928-0416-47d3-b260-0232ab70d248"
      ]
    },
    {
      "cluster_id": "ab906a52-8ac1-4094-852d-28e22d75048c",
      "members": [
        "8c1de153-2b7d-4551-bd69-8006cafdaa5c",
        "29a4b5e8-3852-4ef7-8945-012494f68624"
      ]
    },
    {
      "cluster_id": "f6501847-7e90-4499-a97a-f42ac5217bb6",
      "members": [
        "f298143c-340d-4e92-9efd-15885f108949"
      ]
    },
    {
      "cluster_id": "5a419c79-66fe-4be4-a3c1-02415535b5e5",
      "members": [
        "7c0055b8-d81a-4f20-aed1-36ad7842eb30"
      ]
    },
    {
      "cluster_id": "6e37aa31-587a-4adf-8952-da7c9df371fd",
      "members": [
        "cf210236-aec4-464b-9fcb-e21cafe07515"
      ]
    },
    {
      "cluster_id": "c29a246e-69bc-464d-a998-2ee789508141",
      "members": [
        "9bd5f8e4-ee62-425d-bc45-13ff354ae53d"
      ]
    },
    {
      "cluster_id": "6cf1f120-eb6b-4ef5-8ea8-be39f36cebee",
      "members": [
        "e4acbee1-1dd2-49fa-bc31-34100ff94b89"
      ]
    },
    {
      "cluster_id": "ed8ee9d8-3361-4c66-86fb-3b0c6210300d",
      "members": [
        "fff9f7c7-d732-47f4-a729-523774c75283",
        "09bf5365-4846-4c70-8462-797de6862674",
        "43e5222a-3087-4d0d-be64-dd7e1ebdc149"
      ]
    },
    {
      "cluster_id": "3c7779af-1e2b-432f-abfc-f807e51488c7",
      "members": [
        "74b3efdf-3b9c-4f10-ae59-76311110302b"
      ]
    },
    {
      "cluster_id": "e0932d8f-119b-4dcd-8100-b5fb6b62417a",
      "members": [
        "a1a78fcf-e1cd-4efe-8936-ae38451c07f2"
      ]
    },
    {
      "cluster_id": "ed17271a-9f56-4fda-b3f2-e8dbe7b55084",
      "members": [
        "8d8d375a-a686-47da-bc9c-6eac5ea9a427"
      ]
    },
    {
      "cluster_id": "61d385a5-d13c-453b-af42-53ad07fd1c25",
      "members": [
        "88430b8d-2dfc-43e8-a450-708e825fe2dd"
      ]
    },
    {
      "cluster_id": "9a7cfd6f-8532-4052-b526-1e4576483709",
      "members": [
        "c9a568c2-86ca-45e2-9270-7f388f5fcb24"
      ]
    },
    {
      "cluster_id": "4b3edb14-747e-4c77-8e76-8b7c1d8c4155",
      "members": [
        "3d00d19c-2b7a-4ee2-a2b6-ba039a96eaee",
        "d124a1dd-2d17-4a0e-9b3f-3690566aae21",
        "18b5b3da-d419-4a47-8df3-72b832f336f0",
        "b636559f-f440-461e-8b2a-e27f8e0a5bba",
        "82dddf7c-fd0c-4c46-9029-3fc44df72117",
        "98a74f5c-953f-4fe8-aaf3-a6941ae420a2",
        "df7328ad-1fa1-4626-aa8c-2ad980e5b771"
      ]
    },
    {
      "cluster_id": "b2946046-f947-49a1-8176-588a2c66f974",
      "members": [
        "a7a074c1-90c6-4d6d-ab05-f1443b144afc"
      ]
    },
    {
      "cluster_id": "794a59da-1667-4f55-8bfb-64bab3fe6d1a",
      "members": [
        "54cac0cc-06e2-4fd6-ba5b-b0cb4461853c"
      ]
    },
    {
      "cluster_id": "0e839111-b99e-4caa-8ece-e80f0ea67970",
      "members": [
        "d493f755-eed0-4944-bbd3-5a6c9974fdb4"
      ]
    },
    {
      "cluster_id": "261352e0-2751-4f21-88a5-03538b2fd63d",
      "members": [
        "ef8f4a79-fb2c-4f9d-859e-01abe99e9db1"
      ]
    },
    {
      "cluster_id": "006e6ccb-eaf9-4a24-8ea9-fbee9be7d468",
      "members": [
        "d4b57753-8820-4e4f-902f-f424afd1ddfa"
      ]
    },
    {
      "cluster_id": "5af9294b-b226-4926-b1d8-cd8badc5e35b",
      "members": [
        "2c19756c-d0bb-4c7e-8ae6-cd4e787411f7"
      ]
    },
    {
      "cluster_id": "04b6753c-ecde-472f-9566-0e86e4ac2a52",
      "members": [
        "e12674be-e40a-4090-8e59-24ab738b83e1"
      ]
    },
    {
      "cluster_id": "57a9720a-c11c-4e38-b871-7e3861e5df17",
      "members": [
        "1027ff9f-a236-4e67-ad2e-f71bd98a31b0",
        "79188f36-9dfb-4930-8fe5-4f28c5adf64f"
      ]
    },
    {
      "cluster_id": "e00b6e6b-19c3-46b7-8ed7-41551b5be8f8",
      "members": [
        "f6bb2a03-7781-47e1-a609-0faed1482e89"
      ]
    },
    {
      "cluster_id": "fdc8411e-7a17-4fc6-bef2-367c46894068",
      "members": [
        "8a634101-cd54-46bc-a687-7d1b533d8ffe"
      ]
    },
    {
      "cluster_id": "d58686a5-53bf-4314-a7f1-f0e899bc8c82",
      "members": [
        "16cfa5fb-2b2c-41bc-a45c-3bfbafe45d99"
      ]
    },
    {
      "cluster_id": "f7143daf-c280-489f-9b7a-be507d7d1e7d",
      "members": [
        "ee28fe43-1894-4c95-8870-fc28fca4a76b"
      ]
    },
    {
      "cluster_id": "51c88d49-73a0-41fe-a608-ab3aabe81173",
      "members": [
        "079c2f4a-cf04-4744-a34d-d7c5e33f1dd3"
      ]
    },
    {
      "cluster_id": "fd231a27-03e0-4839-bed2-513e10b79733",
      "members": [
        "30b5867c-0d85-4a47-b3b7-3c54f63a325f"
      ]
    },
    {
      "cluster_id": "4162c749-910d-4283-8cde-a365928f230d",
      "members": [
        "d752f6cc-4187-4afe-99fe-a1c6c2cae958"
      ]
    },
    {
      "cluster_id": "58d169af-1f4c-430e-875d-88f013ef1388",
      "members": [
        "76ca0985-7e78-47e4-b755-2290bf824812"
      ]
    },
    {
      "cluster_id": "532f519a-d7c1-4910-afdd-938e13222189",
      "members": [
        "83d0ef0d-d105-451f-9865-94a7fb63fbf0"
      ]
    },
    {
      "cluster_id": "44a25f49-5174-4a81-bbe3-8d614f9c4116",
      "members": [
        "976b90b1-ffc0-45e9-bae7-ba4cd7407f18"
      ]
    },
    {
      "cluster_id": "11da9fb2-c834-4c00-97b5-9d0eb78a5f81",
      "members": [
        "4f5d7f54-0e07-4d45-8714-b56d3126678e"
      ]
    },
    {
      "cluster_id": "b38033d5-5b50-487f-be85-35eacb567316",
      "members": [
        "35397bc5-60fc-4557-99be-80f5907223d3"
      ]
    },
    {
      "cluster_id": "e1f28336-0647-4e38-a5b1-a20d710717c4",
      "members": [
        "5446ec33-6405-427f-a4a7-b1516e31c796"
      ]
    },
    {
      "cluster_id": "02036fb0-ba58-45fa-b4ad-534e30796546",
      "members": [
        "30eb27a7-d0ba-4d1f-8de8-bf1c8259d737"
      ]
    },
    {
      "cluster_id": "60b00870-1636-4edd-b3bc-90daaa615659",
      "members": [
        "d4cca293-647c-438c-8750-2eb681311176"
      ]
    },
    {
      "cluster_id": "bba407f7-696a-4116-b4f2-8e58c881a810",
      "members": [
        "71d928fc-0847-486c-9da2-baf35bbab3b4"
      ]
    },
    {
      "cluster_id": "20999f16-0335-45ee-a0fa-171f40827993",
      "members": [
        "6915995f-bfd0-4669-b7a3-0b66d95da7ea"
      ]
    },
    {
      "cluster_id": "814bcb42-2e0f-4cf8-87e3-c5b551e8ea66",
      "members": [
        "1e340ec3-de70-4af2-9954-3014f5f13739"
      ]
    },
    {
      "cluster_id": "6e4775e9-09cc-45e6-927b-26fd1460b8e8",
      "members": [
        "54f64ead-5d9e-422d-ba85-10bf0e254bd0",
        "b286e45c-02e1-4f62-b4ea-fa0ec72bc252"
      ]
    },
    {
      "cluster_id": "42c9725b-d681-410b-871b-771e74124bd4",
      "members": [
        "de8e82dd-5b36-4b6a-9e32-67075988ea63"
      ]
    },
    {
      "cluster_id": "519a0144-fd4c-4d5c-9042-6fb50ccd2f56",
      "members": [
        "e6b15468-d019-476d-a80d-5ca76fb645ad"
      ]
    },
    {
      "cluster_id": "1e88b8f2-56ce-4d36-b086-ab1c91d0ff73",
      "members": [
        "6f1133cb-61a4-44f5-b5d1-c48a58b4bd78"
      ]
    },
    {
      "cluster_id": "63959dc1-33f1-448d-b73f-370297a47c55",
      "members": [
        "0d93e6dc-8136-49c8-a877-3309cd11622d"
      ]
    },
    {
      "cluster_id": "2fe604c5-b4d8-4806-815f-c3f9be0582ed",
      "members": [
        "228efa10-aa8d-4e4a-a70f-9a434e61ab03"
      ]
    },
    {
      "cluster_id": "be6d3887-f154-45dd-b994-3e262cd683ab",
      "members": [
        "3df77559-ea00-4e25-aee5-5af4521b40ab"
      ]
    },
    {
      "cluster_id": "e1d7b348-32fa-40c2-a6a1-5325b5923ab6",
      "members": [
        "f3187c0f-a7fa-4eb3-9659-2e4897884950"
      ]
    },
    {
      "cluster_id": "c6d45751-df96-42cb-a762-00ec73441fe2",
      "members": [
        "56f97b95-7511-4f0d-90b0-29e6125e047c"
      ]
    },
    {
      "cluster_id": "7fe9b7f3-5fcc-469d-bfc5-789d2c7ecb0c",
      "members": [
        "f71e1b87-0731-4652-9fce-8e43d28e6513"
      ]
    },
    {
      "cluster_id": "3d5e9384-ac3e-4f4c-a500-50dfd267dfa4",
      "members": [
        "16621546-2155-4af0-a522-ffbef36ca911"
      ]
    },
    {
      "cluster_id": "cebd1d98-7547-4761-a012-89e58bf86f29",
      "members": [
        "7043be3a-1348-4fbf-b4da-ad5f86f81265"
      ]
    },
    {
      "cluster_id": "67882453-39e8-4614-ad83-1b5cd199486b",
      "members": [
        "43918ef3-c02d-446c-9939-aa0619c5f4fa"
      ]
    },
    {
      "cluster_id": "4c34b512-0945-4457-90fe-e5531faf594d",
      "members": [
        "e84846ba-99ab-47fe-a730-6172d9ac3b35"
      ]
    },
    {
      "cluster_id": "a9a6169f-2727-47ff-8df7-1f0dc7eaba02",
      "members": [
        "28dabced-e72d-40db-a769-1ed696cfb685"
      ]
    },
    {
      "cluster_id": "028454b9-ae0f-4b68-8959-098c138f4548",
      "members": [
        "dcb9c056-92d5-4729-b922-92cfe2886e27"
      ]
    },
    {
      "cluster_id": "47eacbaf-94c8-4453-9ff4-4a4d77904c0c",
      "members": [
        "be2dc09e-34a3-4a1e-8396-9fa5bd1a5998"
      ]
    },
    {
      "cluster_id": "ceaf3416-5958-472f-8b27-d2e81ab1489c",
      "members": [
        "d3eeab90-548e-4b0c-b847-422addd6dde1"
      ]
    },
    {
      "cluster_id": "1de0370a-30b3-4cf4-8852-224e559b9061",
      "members": [
        "f69ea3ae-6350-45cb-97f3-9a323713bb8d"
      ]
    },
    {
      "cluster_id": "ce0d6d93-def3-45e3-8bfd-1c14d5d947ee",
      "members": [
        "89af2cfb-0121-4d57-83f1-725bd1f33b6d"
      ]
    },
    {
      "cluster_id": "c00c750e-a740-40f2-8fc7-77d5f6c8fe81",
      "members": [
        "2da829a2-d59e-4a98-921a-295d99a62943"
      ]
    },
    {
      "cluster_id": "2b8e0512-59eb-40b2-a0fe-0c0765fe2a41",
      "members": [
        "a6ac98d3-f2a9-457d-800a-22ac55a5cff0"
      ]
    },
    {
      "cluster_id": "41d3a2f3-d7a3-4115-95f4-0cf0a84449a0",
      "members": [
        "fa43bf47-f53b-457f-92ba-d9060e873e45"
      ]
    },
    {
      "cluster_id": "3ddf92d1-7fbd-4c44-857f-573095c914df",
      "members": [
        "58d52923-309c-4639-b67f-3660c4b7a5db",
        "84d42f5b-d166-48df-94a7-ca07834d7629"
      ]
    },
    {
      "cluster_id": "f5211fb7-fcad-4978-ad00-c77df1404c5e",
      "members": [
        "106bd334-194a-46f9-89ae-c7207674e45d"
      ]
    },
    {
      "cluster_id": "36d66c66-9c93-4123-875e-3e9fbe514722",
      "members": [
        "a1c1f03c-2199-42ea-b800-30e376e60e7b",
        "05a7445f-f8e4-451a-84c5-621b59387db8",
        "99f7b628-7862-4faa-a1ab-c7a717ed8b26",
        "71fb2457-f74f-420b-b866-478d856b2ab9"
      ]
    },
    {
      "cluster_id": "53d925d3-b8ff-4816-9cb6-be1191e8d6ba",
      "members": [
        "4ff7f89e-7034-4984-b150-cf36a2108c68"
      ]
    },
    {
      "cluster_id": "35f50160-5841-4836-b319-b5806e73bdd7",
      "members": [
        "f83a30b3-bda9-4d94-a290-fbc0c947dbd4",
        "419233ba-dddf-45b5-b937-b0523f88b523"
      ]
    },
    {
      "cluster_id": "13eaad2c-4351-4227-a2c2-4a8d3df4410b",
      "members": [
        "88cbd551-9a16-4dcb-bfde-6588777cc74f"
      ]
    },
    {
      "cluster_id": "ac154c70-d6ce-41bc-949e-658cdd31e1f4",
      "members": [
        "dda1be66-a107-41ec-93a7-19785aaf8620"
      ]
    },
    {
      "cluster_id": "26e8c638-0261-4ee0-9125-edc5ca8d7841",
      "members": [
        "d3451e34-9533-4766-974d-3fcdb0c014ea"
      ]
    },
    {
      "cluster_id": "97cdd3f9-b13e-4b85-9e62-c48c3b34bca9",
      "members": [
        "168afc39-23ad-42a9-a4c1-9cd89385981a",
        "1a1036fe-40f5-4390-b808-24415bb34512"
      ]
    },
    {
      "cluster_id": "5d0d552f-6139-4148-bf05-7e9c5a14274a",
      "members": [
        "4c56dcfd-316c-4b0c-b293-23eccee791ef"
      ]
    },
    {
      "cluster_id": "057662c4-0ac6-48b6-be90-a08641f47c88",
      "members": [
        "44b5f8c2-b8bc-480b-98f6-1704d3629f4f"
      ]
    },
    {
      "cluster_id": "610fe915-6f9a-4623-a217-8c3cff21b2cb",
      "members": [
        "f7547891-fa78-414e-ab7a-62f3b8edde8d"
      ]
    },
    {
      "cluster_id": "feb55b84-b173-4b70-b9c2-3b33225296b8",
      "members": [
        "80344cca-fd55-4c1f-bf37-13d5c04a010f"
      ]
    },
    {
      "cluster_id": "c368702b-96c0-4866-81f4-7cb0750c1bcd",
      "members": [
        "2a009960-9048-4096-b8b0-842ff57f2b0e",
        "8dc629cc-6231-4ba2-a045-563637816f47"
      ]
    },
    {
      "cluster_id": "ec333963-a3e0-433d-a595-145497c56ca9",
      "members": [
        "c2b186f6-c022-4b2b-918e-01c7ae57ece6"
      ]
    },
    {
      "cluster_id": "b6c807dd-0cb5-4622-8a2e-ef610ded44e5",
      "members": [
        "fcb1f017-02c2-49ef-a0de-5a8be0a4a3de"
      ]
    },
    {
      "cluster_id": "96f47e0e-34da-4076-aa8a-d368df50bd46",
      "members": [
        "f6298f4e-34be-4bd5-a9e3-c09111e5e60b"
      ]
    },
    {
      "cluster_id": "b8a8bbf1-a819-445d-874a-5ea5546196e8",
      "members": [
        "3a0429c7-68cc-4b17-8842-8b698a3c682b"
      ]
    },
    {
      "cluster_id": "a5aa6b9e-3e33-4b44-ab88-d54a834f3817",
      "members": [
        "6b716a22-76d1-466d-9ff6-7f7dc7399a03"
      ]
    },
    {
      "cluster_id": "3f98fdac-3f62-464c-bf56-dd3d2e686963",
      "members": [
        "f13890cf-a339-4ac5-80b3-3630493f1039"
      ]
    },
    {
      "cluster_id": "be12c5b4-b051-4762-b77d-ca92a4063972",
      "members": [
        "41481512-2ffe-410c-b574-b775d2ac0edd",
        "3856ade0-91e1-463b-a8b0-c5a4515d31da"
      ]
    },
    {
      "cluster_id": "344dd5f7-3435-46c3-9f5a-4bd9bd357bed",
      "members": [
        "415369c8-30f6-4fa5-809e-a154f30d2fa5"
      ]
    },
    {
      "cluster_id": "e440fb1d-afb5-4fce-9f0b-110db0f93b32",
      "members": [
        "902a1595-3dd5-4012-b0bd-83fe8948f71f"
      ]
    },
    {
      "cluster_id": "409928b1-cabb-476d-812a-3340869af622",
      "members": [
        "89306a7f-432c-42e6-ad88-b078d6e35833"
      ]
    },
    {
      "cluster_id": "a7fc7029-8fcf-4676-9e1a-d0be462bdd41",
      "members": [
        "4d09c518-222d-4ced-a7f4-12f71e9f4182"
      ]
    },
    {
      "cluster_id": "b8ba4862-a01f-4bea-9d65-d965f8a811ea",
      "members": [
        "732b85e8-3019-4568-8bdb-996dffebbe60"
      ]
    },
    {
      "cluster_id": "8b829799-1488-4866-83fa-531278dceac5",
      "members": [
        "ce4c5e9d-7414-42b4-976a-83c224c8bfb0"
      ]
    },
    {
      "cluster_id": "087b9c92-fa35-4283-96fb-8d9c5297eb2d",
      "members": [
        "aa115de9-cb33-42a2-b72f-cc1fcb53651f",
        "ac10fe98-7a59-438d-8e5a-e5d8ff108249"
      ]
    },
    {
      "cluster_id": "6d0ecf89-9eab-4b55-8c05-ab0885982adf",
      "members": [
        "cf1859da-3e2c-4640-8d45-1b649c6efd89"
      ]
    },
    {
      "cluster_id": "7d0b4f2d-8055-491e-a0df-31787da0b9a8",
      "members": [
        "6c2d4573-fdb1-4022-b637-584a82b70b2c",
        "b6ed7ce5-601b-4916-aec6-97171aa1061b"
      ]
    },
    {
      "cluster_id": "d2698d5d-a9c7-4753-8264-b469e84de09c",
      "members": [
        "f863cc41-925b-40e4-bfd1-d70664e0a384"
      ]
    },
    {
      "cluster_id": "4c5edc98-f936-4e09-a25f-11ad3a0a3ce0",
      "members": [
        "02e90b1c-35ac-4c76-9490-e196796f07ca",
        "ffa0b490-c0c6-4066-ac6b-412aa4813bee"
      ]
    },
    {
      "cluster_id": "7dfb31d5-ddb8-4d40-bb81-cb884f7a73bd",
      "members": [
        "f035e906-0b9e-4776-8f28-507ead8aa2bb"
      ]
    },
    {
      "cluster_id": "6190dfba-afce-482c-ab6b-30cfbc88a521",
      "members": [
        "28b573f9-0e8f-42dc-85af-1fb345bfa138"
      ]
    },
    {
      "cluster_id": "a4f03b54-99da-409b-9d0f-4576a28453ea",
      "members": [
        "7c4cf18e-a1fc-4fd7-87c3-1d0205d000f7"
      ]
    },
    {
      "cluster_id": "dc6983ab-b551-4091-91c6-65ee2055cfd0",
      "members": [
        "543fdefa-d58e-4d76-8071-bb86cf9e75be"
      ]
    },
    {
      "cluster_id": "d481c919-0d2f-4cb2-bfd7-956740c2c572",
      "members": [
        "d33725f4-3fb6-4ab1-8fe5-92793806bd79"
      ]
    },
    {
      "cluster_id": "095f5894-d729-421f-8a47-470e675d8afa",
      "members": [
        "e5542718-0f4a-4a6a-b2a9-a7f74876d478"
      ]
    },
    {
      "cluster_id": "0e68f81d-43a7-45ed-8f07-1f52cfdcdd62",
      "members": [
        "853229aa-e197-46e6-b730-86eb4a52ab20"
      ]
    },
    {
      "cluster_id": "4f70f4f5-9340-4c71-bf68-5b20071ff5b8",
      "members": [
        "c543a8ff-a376-419e-8af9-95d851369395"
      ]
    },
    {
      "cluster_id": "291e783e-a633-4a70-baad-9d43cf49aa7b",
      "members": [
        "81a49100-18a5-401b-ad73-76867ece0bb2"
      ]
    },
    {
      "cluster_id": "1fb14eaa-5808-4fba-b78b-8331f9693364",
      "members": [
        "c0ce502b-f8aa-44f6-b754-63a4956044f1"
      ]
    },
    {
      "cluster_id": "e8a4287f-2df7-4875-81d6-e8b9ebf6b742",
      "members": [
        "db80af84-e808-4fc4-9b3a-48ffda50ff52"
      ]
    },
    {
      "cluster_id": "9a26c9bd-36a9-4c64-8680-f0a2265878f1",
      "members": [
        "aa9876ba-55bc-43dc-b76f-e3374e78c9d1"
      ]
    },
    {
      "cluster_id": "fed0576b-522f-4fd4-a6c9-50a73c58d504",
      "members": [
        "a62e7c0c-3014-426b-b4cb-f09f41a35640"
      ]
    },
    {
      "cluster_id": "364b6018-e5e4-4d17-9b1f-0b9d5fe116fa",
      "members": [
        "171ecae6-87ff-409b-acdd-b6f06ea9c901"
      ]
    },
    {
      "cluster_id": "f7cb56d3-2935-41a4-86b7-c9fe57c869f7",
      "members": [
        "610bcf42-e654-4fd1-864c-8c97bfc7e388"
      ]
    },
    {
      "cluster_id": "56cddc1e-640e-4fd4-873b-51796886ff3a",
      "members": [
        "e9af9077-dfe3-49a3-9da9-a8677be6d2ec"
      ]
    },
    {
      "cluster_id": "ccfbe60c-5479-4640-b831-00bbb4cb4ec1",
      "members": [
        "7d7f1e0e-ae67-48b6-9123-ed59a792720f"
      ]
    },
    {
      "cluster_id": "9ce0798f-d0a5-4818-8a46-c633233caab5",
      "members": [
        "66c3b2d9-9fd9-4ffb-a4fa-a50c1fac13ef"
      ]
    },
    {
      "cluster_id": "f2e7e2a5-1bc4-443d-b76a-ecb8995fbae8",
      "members": [
        "1e39ba56-9940-4fbf-8dd1-889dedcc9779"
      ]
    },
    {
      "cluster_id": "4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c",
      "members": [
        "b91ff7ac-2550-4327-b693-f9c443c27bcd",
        "c589d99a-2705-45ba-81b4-d443003520f5",
        "b75e94f6-e39d-40f2-b811-999f17412dce",
        "004ea1ef-02fa-47bf-a43c-2078a1530a3a"
      ]
    },
    {
      "cluster_id": "49f74be2-2b75-49a2-9647-991264918ba3",
      "members": [
        "04585af3-b8d9-4baa-a6e6-186226f2c53a"
      ]
    },
    {
      "cluster_id": "676d848e-4839-407b-95b6-13d5d472f0e1",
      "members": [
        "94106d8a-2fd8-4eaa-8ef3-f18642b87714"
      ]
    },
    {
      "cluster_id": "8269010c-d30d-4a8f-9628-b930192a8751",
      "members": [
        "b0de1673-0cc8-41a9-b2c6-807fc598539d"
      ]
    },
    {
      "cluster_id": "46ef864f-186e-4179-bb52-04fed8b2c978",
      "members": [
        "3a7c4f12-205f-44d7-893f-7c4955c0fb21"
      ]
    },
    {
      "cluster_id": "1020a2ca-3e92-4f76-98e4-6f44fdfd5f52",
      "members": [
        "811cffa0-d85d-4b68-a81f-9ecb5bab33b3"
      ]
    },
    {
      "cluster_id": "00b8a8dd-d8e8-40d8-b8f3-1b3a9df2daea",
      "members": [
        "9fbd23d2-85e0-4c53-bdb0-b8f0210aaa2a",
        "edf44a9b-5a98-47e1-8ff2-e651a3916ab4"
      ]
    },
    {
      "cluster_id": "4d4b5f03-b89d-479d-93c3-2c3c9a038d46",
      "members": [
        "2c7779d3-50fa-4978-a751-9def7aca0cc2",
        "a18eb799-3627-42c3-8e70-28d1b88e5971",
        "aa518135-7417-406d-9511-8ae5af77f437"
      ]
    },
    {
      "cluster_id": "94e66aa3-5079-4e1d-bdc8-702db352aa56",
      "members": [
        "cbf28224-359f-4af5-a68f-874ac3a7cfc2"
      ]
    },
    {
      "cluster_id": "48eb1f9d-0125-4436-9ad0-db6bbdc685bf",
      "members": [
        "5a766bde-8fc3-48c8-9691-33709b37f34e"
      ]
    },
    {
      "cluster_id": "ae4c214d-3e4b-416f-8e83-fe80cc92e55e",
      "members": [
        "195dd2bf-8e9a-4ca1-89dd-d5527e18c2a1"
      ]
    },
    {
      "cluster_id": "92f1ca49-b0ab-4770-8539-01bf2c201c40",
      "members": [
        "03f59c33-5d82-4ad4-83bc-6a7b7862e369"
      ]
    },
    {
      "cluster_id": "6985cd83-55db-4a59-b823-aed3b2386ee8",
      "members": [
        "2fb6d1b3-35d3-4799-8513-846ab8a4d75f"
      ]
    },
    {
      "cluster_id": "15441f0b-d588-4f74-9e0c-951884dd5f0a",
      "members": [
        "7c3b6688-d683-4382-903c-b975332dbc52"
      ]
    },
    {
      "cluster_id": "f5769a88-6f55-4990-ae69-e5747ba1c948",
      "members": [
        "c46920ea-8f61-469c-94c8-0f4df258b9bb"
      ]
    },
    {
      "cluster_id": "2af31319-c3b3-4fb2-ab4d-68df1d72b458",
      "members": [
        "9ce38159-4df2-4a30-b881-4e97c679c2c1"
      ]
    },
    {
      "cluster_id": "00c62945-b485-438a-9d05-87baa1d3d907",
      "members": [
        "d89eff74-1189-4fd5-b33f-6c3f55c0b6bb"
      ]
    },
    {
      "cluster_id": "c9e1ed1d-b28e-452c-9f9c-c8e37181b84d",
      "members": [
        "bd07d283-3ff2-42c5-aad4-0c9508c49476"
      ]
    },
    {
      "cluster_id": "4e9bc944-639b-4f8d-838e-a744f7d10ce2",
      "members": [
        "f5d06ae9-4e8c-4ace-ae65-7ad815033fde"
      ]
    },
    {
      "cluster_id": "b8cb289e-e370-4b8e-aa6d-b4c268c9566e",
      "members": [
        "fbab0ba7-0a1a-42f7-b6c9-c7a2b136e760"
      ]
    },
    {
      "cluster_id": "1ccdbc51-34c0-42ae-b81a-03edbb3df6d6",
      "members": [
        "29b68f52-c694-4bd7-b9ec-4862a05b6aa1"
      ]
    },
    {
      "cluster_id": "9687983c-2f58-4f1f-9d09-86f19210af37",
      "members": [
        "42f92565-64db-44cb-80c5-250dd9ed2225"
      ]
    },
    {
      "cluster_id": "4fc147e3-0b67-422d-b442-9aed1bd9ffee",
      "members": [
        "4c32bec3-72e5-4e9b-a048-dd4ffde7edc2"
      ]
    },
    {
      "cluster_id": "d882f953-ff9f-4410-820f-ffce8c5ec321",
      "members": [
        "8fac81ca-74b5-4026-9d28-bca75cce2a4d"
      ]
    },
    {
      "cluster_id": "e81e68ae-4e8a-4aef-a358-1455ad08bdc4",
      "members": [
        "1545f02a-2183-44e7-80eb-8e8017b06ace",
        "27ebf54a-7220-410b-bf97-38d6dd4708f2",
        "b716df28-25f5-4342-9e96-aeffe85cc626"
      ]
    },
    {
      "cluster_id": "af9fdbaf-db80-451f-96bd-62636c3231f5",
      "members": [
        "8ed289d3-0cf6-469c-9cad-185096f11474"
      ]
    },
    {
      "cluster_id": "b4e49473-fad9-44d2-a14a-baa57498bb09",
      "members": [
        "1d3c6131-e597-47a8-a1cd-17e85c114664"
      ]
    },
    {
      "cluster_id": "8e5823ae-a392-4999-814a-2dee24b2385d",
      "members": [
        "5e163e86-8df2-4970-be19-1c721b67481a"
      ]
    },
    {
      "cluster_id": "f0e4e625-f14f-486a-a02f-d6cf2c5a6b4f",
      "members": [
        "3a2dda61-d58e-4bbf-aedc-ee26a6054a9d"
      ]
    },
    {
      "cluster_id": "c8767af3-0dda-4a2b-8768-e0cf749cfa1c",
      "members": [
        "f6f52da1-b69c-479b-9180-8690fc279e05"
      ]
    },
    {
      "cluster_id": "a0fb845d-3984-4109-ad59-e77cf57e7687",
      "members": [
        "19ded8bb-b942-4c26-96bd-47fbac381987"
      ]
    },
    {
      "cluster_id": "6b396f8a-a67e-4844-8d5a-43bb95030766",
      "members": [
        "c39f38e6-6801-43f0-b58d-85b1bb40ce68"
      ]
    },
    {
      "cluster_id": "b6224aea-5841-4609-ba8b-ccc207ec597f",
      "members": [
        "3cc71956-33bd-42f1-821f-772ffdb32426"
      ]
    },
    {
      "cluster_id": "897c7076-ce98-4405-aaa5-1e883a645242",
      "members": [
        "560ad3d8-ac49-48cb-80f6-697bbb5eba4c",
        "8736b397-0828-456b-b1a9-faca5adf593e"
      ]
    },
    {
      "cluster_id": "be379179-357e-431a-afc7-707de2663f0c",
      "members": [
        "beb0907e-2c5a-41e1-a3ac-cdb02446f79b"
      ]
    },
    {
      "cluster_id": "178f9d9a-267a-4abb-8f58-8a32bd23bb57",
      "members": [
        "1078a74a-1bdd-4cf7-bb28-da7aacb1e369"
      ]
    },
    {
      "cluster_id": "a3cbf831-a6f7-4981-a61a-3f2e1d67806a",
      "members": [
        "6cdc6ca7-913e-463c-a1b6-6192ca4e8f38"
      ]
    },
    {
      "cluster_id": "b95118e4-bfa9-41d0-884f-00c06ed87e30",
      "members": [
        "042c20ef-1d96-448c-a138-f7fecca41e5c"
      ]
    },
    {
      "cluster_id": "cfe9cc78-dae7-4fb3-9619-c934beac1286",
      "members": [
        "e1e7bc0f-5e62-472b-b2fe-0c1350bf36eb",
        "66d6a8c7-35dd-42f6-86c3-93cdfa8eea7f"
      ]
    },
    {
      "cluster_id": "0ded9d87-ef2c-4d88-b3db-79b2f8e48989",
      "members": [
        "14836e2b-68e7-4472-951f-747a83eb318f"
      ]
    },
    {
      "cluster_id": "4da18b15-13e1-4abd-966a-5a691b26fe59",
      "members": [
        "31ec134e-e8d0-4347-ae2b-d7bb390827bf"
      ]
    },
    {
      "cluster_id": "0912e80e-4475-48b0-94ea-99b244b18e7f",
      "members": [
        "b4d900c3-7a33-4ac1-bbeb-2214891df708"
      ]
    },
    {
      "cluster_id": "347223d3-908d-4003-9d32-5f2929c89e51",
      "members": [
        "7d8fc9d0-ee37-4617-bb57-bc9650a988a0"
      ]
    },
    {
      "cluster_id": "31b9f704-925c-4bf2-9f0b-e88e81f1b10a",
      "members": [
        "6dd22e0c-75a1-42c5-9669-5ea344deb675",
        "dd0ea02a-5156-4ea0-9cf4-df3bf324ed09"
      ]
    },
    {
      "cluster_id": "babc55aa-4d08-416f-96c5-50bd2182d4f8",
      "members": [
        "d50c791d-d408-460a-91cb-c316bbb2b74f"
      ]
    },
    {
      "cluster_id": "3b11f37a-b3dd-481f-b924-f2c0105eea68",
      "members": [
        "7c66dd47-55d8-4d79-b029-18c78b008ccd"
      ]
    },
    {
      "cluster_id": "81814091-7bc5-423c-85bb-9238ad6a9cae",
      "members": [
        "3daef752-184a-46a5-b49e-f5f3862e40e8"
      ]
    },
    {
      "cluster_id": "1618106d-1c52-48f7-9d0e-a09294ca1167",
      "members": [
        "46c4bbca-22a7-426e-b740-218b1943a208"
      ]
    },
    {
      "cluster_id": "4a717901-15d3-4fa4-8697-e234613c348b",
      "members": [
        "f5a37044-43e2-48fe-9d3d-72dfb91550d8"
      ]
    },
    {
      "cluster_id": "6d58a40e-4432-43bc-9a0f-20467f608aca",
      "members": [
        "e91cf261-b3d2-4dee-9fe5-9f289ce03b3c"
      ]
    },
    {
      "cluster_id": "cc939ca4-cdd3-4b86-b937-1aee89162501",
      "members": [
        "148e0912-fcdd-487e-8009-0cb800636227"
      ]
    },
    {
      "cluster_id": "d2d14fb6-adb8-486b-8eee-e966dd2e339b",
      "members": [
        "082ef11d-1ea9-487f-9952-17564fb9c4d5"
      ]
    },
    {
      "cluster_id": "7014c024-82bc-4f47-b6cf-23a09be951e3",
      "members": [
        "11203772-88f3-4d44-8521-49a5752d94b6"
      ]
    },
    {
      "cluster_id": "ab120ec9-7f69-4d7e-880b-eb52320c48cd",
      "members": [
        "3af0d05e-647f-42af-a495-1c1b27f989b9"
      ]
    },
    {
      "cluster_id": "626e9a9b-6995-4100-8ffb-53ed10359203",
      "members": [
        "d2ceb7c3-cbd1-4e64-b371-c92535e8b2a4",
        "76c2db9b-d26b-4f29-a2ee-da0ac761da2b",
        "4d7eb9b1-9a26-4e98-8fcf-a28104ea6824"
      ]
    },
    {
      "cluster_id": "753b53ca-12e6-424b-989a-e076a991708d",
      "members": [
        "467fbfa1-667e-47f0-b679-4ccde1bc649d"
      ]
    },
    {
      "cluster_id": "813768d2-b0f6-4924-af6d-45e5c38606af",
      "members": [
        "a8cdddc8-da0e-4ddb-bfb4-206b7861ec25"
      ]
    },
    {
      "cluster_id": "d3561f7c-f545-493a-88e4-1feb8895eb1b",
      "members": [
        "5621db93-38d4-44e3-b9ac-662f17d5b014"
      ]
    },
    {
      "cluster_id": "a4b1d7b9-3c74-43c7-9743-4531782b8384",
      "members": [
        "e1d13f5a-15e7-412e-ad2d-a9a7f7ee5cdc"
      ]
    },
    {
      "cluster_id": "89bc3f77-435c-48cc-9674-3f733858f60d",
      "members": [
        "3f36f821-5acd-4e03-8925-56a32a0d41df"
      ]
    },
    {
      "cluster_id": "cdf7dd0c-6255-42a0-bfbe-5e3b3bbee744",
      "members": [
        "1deccd41-6b22-439d-b04a-607cec06cd4e"
      ]
    },
    {
      "cluster_id": "104c0221-a4dc-4285-9360-e1a7135d6b23",
      "members": [
        "78f8bb60-19e7-45ae-b9a8-95d140afccb6"
      ]
    },
    {
      "cluster_id": "67ac99c8-c0bb-4383-9849-47ca12ce4b47",
      "members": [
        "457968e0-54e3-4b90-a69d-cd014e44b19f"
      ]
    },
    {
      "cluster_id": "0ab26e4b-97a4-402f-89ba-c8bf505907da",
      "members": [
        "953e8dee-c92d-46d0-b41a-2675f2d8c7d3"
      ]
    },
    {
      "cluster_id": "7767473b-b833-4047-b346-9abf204211fd",
      "members": [
        "765cde6f-4513-4c96-bc73-5efe2d1dcec2"
      ]
    },
    {
      "cluster_id": "7bcdf864-ee5d-4016-9651-b86043d6e5f0",
      "members": [
        "550a0233-ec91-4574-af34-084f9fb02324"
      ]
    },
    {
      "cluster_id": "6310600c-941f-4d69-826e-9f6645778d3e",
      "members": [
        "39701dce-c174-4858-a47c-7c287e0d6b46"
      ]
    },
    {
      "cluster_id": "c466ec99-62a0-4318-a23d-1522e69e1a70",
      "members": [
        "c7ddc375-ec76-4ba7-879a-f3acc3bcb9c6"
      ]
    },
    {
      "cluster_id": "cea72470-6f49-4d89-a6fb-4c1596600c5c",
      "members": [
        "1edfed6a-a6f6-4d26-8e86-27912e5cb734"
      ]
    },
    {
      "cluster_id": "418909cf-6842-4d61-99c3-ee63c7926d9b",
      "members": [
        "b3d4bccf-e6b3-444a-a446-db2eefd130aa"
      ]
    },
    {
      "cluster_id": "9c904ce8-82eb-4f73-b9ea-f510b0249486",
      "members": [
        "fc116fa8-1dc3-4222-a5c8-b35092c65b7d"
      ]
    },
    {
      "cluster_id": "d6edcbd0-8a76-4410-b54b-26039bf9a1d1",
      "members": [
        "a1e88781-f2b8-4925-a71d-1354138335e6"
      ]
    },
    {
      "cluster_id": "4f34a5b6-00cc-43cb-98d1-c250e5f2b08b",
      "members": [
        "16eb1f91-9e75-48d9-8e6b-ba6883f107a2"
      ]
    },
    {
      "cluster_id": "907f966c-c5b8-4df2-817d-f2cfeeac3c35",
      "members": [
        "45192b72-d6e3-4aa8-adad-2ce5c94f6fed"
      ]
    },
    {
      "cluster_id": "8ea45448-137b-4d92-9e93-e6f5676fad3b",
      "members": [
        "f15e48c3-97ff-4340-8055-fff4bf8c0515"
      ]
    },
    {
      "cluster_id": "9a0ba2bb-c790-4711-b8e3-9a7c3fc3165b",
      "members": [
        "0ec3a1ba-22bc-42c9-8014-c02a2d6366c2"
      ]
    },
    {
      "cluster_id": "254e946c-9e7a-429c-b142-d41e38953b50",
      "members": [
        "2112f65b-e3a2-4663-82fc-47099fd11849"
      ]
    },
    {
      "cluster_id": "da1ad06e-43a1-466f-9487-046d8d125726",
      "members": [
        "89f7be9b-a071-4364-9aed-c2503bc4bde2"
      ]
    },
    {
      "cluster_id": "0a129298-9d76-444c-8b1e-1ebbbe3bb953",
      "members": [
        "5d180492-af7a-41a3-8010-6039b9a42ac1"
      ]
    },
    {
      "cluster_id": "ce4675a2-eebc-4f4f-bcc2-33cbe65f4024",
      "members": [
        "129dbf83-ac42-498b-8af3-31b2930d0936"
      ]
    },
    {
      "cluster_id": "126a3f86-7f2c-4e93-8c54-043a34be7761",
      "members": [
        "da8e4118-0138-42d0-9996-8b05153569cb"
      ]
    },
    {
      "cluster_id": "a9a9b1b1-c494-4c16-84ad-397e74093b98",
      "members": [
        "bd231caf-cb0b-40ad-80ec-357ede8ccc9c"
      ]
    },
    {
      "cluster_id": "4efb4906-b539-4d71-8685-b4bd14aad476",
      "members": [
        "0ac65c20-e64f-4572-b4fa-95038cc94c87"
      ]
    },
    {
      "cluster_id": "2ddd688c-7c02-487e-a8aa-11d74ae8915d",
      "members": [
        "eb029676-869a-4779-a1c4-e6a9ef61658a"
      ]
    },
    {
      "cluster_id": "b2f5e997-51a9-4075-b2b0-b908ca91bac7",
      "members": [
        "1afe2096-97db-47e1-8782-51875848059a"
      ]
    },
    {
      "cluster_id": "3909ddcb-f2e7-47b0-849d-f54906120921",
      "members": [
        "caccea01-8968-4258-9488-740a1c367d1b"
      ]
    },
    {
      "cluster_id": "19380a4c-de83-43a7-ae00-058986b5206e",
      "members": [
        "3dbf5840-202a-45c5-a392-6da5fc3384f4"
      ]
    },
    {
      "cluster_id": "c586556e-d0fb-4b9e-b41e-3635da810071",
      "members": [
        "fe00d12a-4e33-4d24-8260-ce000bdafd3b"
      ]
    },
    {
      "cluster_id": "6e309345-7a1d-497c-b9aa-287116558129",
      "members": [
        "90183469-2373-4c0a-9db7-66fda3723f82"
      ]
    },
    {
      "cluster_id": "012b2764-4f2e-4783-9281-b3cc16d33a77",
      "members": [
        "dfcb69d0-f432-473d-a4bd-c9537e190c44"
      ]
    },
    {
      "cluster_id": "12cb5a16-807e-4b60-87c2-713f3796ebf1",
      "members": [
        "2c6b27af-38c8-4b38-b040-40f8bb33132c"
      ]
    },
    {
      "cluster_id": "c91f4478-001c-4706-a4cf-7da14de01daa",
      "members": [
        "988a32d5-7f90-44fe-ad3f-eae1713fb46f"
      ]
    },
    {
      "cluster_id": "01bab4ca-5ac0-4d57-8f20-7bea2afbd031",
      "members": [
        "2bd4165c-309c-4266-baea-489fc2660c0f"
      ]
    },
    {
      "cluster_id": "b2a62820-6f02-4de4-99f3-aea0d67cd577",
      "members": [
        "17959a76-3641-4e0b-abd2-b380896e1234"
      ]
    },
    {
      "cluster_id": "cc95457a-219b-4008-9216-67e0ee2bc74c",
      "members": [
        "f2628ee0-eded-4b4c-b5c6-6967892ae038"
      ]
    },
    {
      "cluster_id": "23f623bb-83de-47ba-a19b-9df053aaf2d2",
      "members": [
        "214d1e31-24a0-4a9b-9959-ee0e01ed62fa"
      ]
    },
    {
      "cluster_id": "90113fae-adfb-4eea-83c3-93afc851a256",
      "members": [
        "c2a74fe2-3c8d-4007-9006-5202a81e3db2"
      ]
    },
    {
      "cluster_id": "bd99a1f5-0df7-4f4c-90f0-16afb1a5c96f",
      "members": [
        "8322049d-460b-4c14-89aa-784164e6301f"
      ]
    },
    {
      "cluster_id": "cfc7b0c0-e0dc-44d8-bb40-008b16bc6352",
      "members": [
        "0ab2fa20-d314-4b6e-8ef9-3d0b3754a0a3"
      ]
    },
    {
      "cluster_id": "b23ac12f-f63d-4693-a840-84942ee3fea1",
      "members": [
        "df133827-888a-44b4-98ba-0bd4267a4b64"
      ]
    },
    {
      "cluster_id": "b3b9380c-37e2-402a-8ec8-0e1aeaee4ebd",
      "members": [
        "8db5e96c-8ab9-49e2-be45-cb84446f42b4"
      ]
    },
    {
      "cluster_id": "af868606-4265-4854-b859-dd107b996ff4",
      "members": [
        "278fdcf9-885a-4a38-b620-4449c53c1fac"
      ]
    },
    {
      "cluster_id": "3d51ea74-3b4e-41f4-8d23-b8b5e017e1be",
      "members": [
        "20688556-fcd5-43d5-8b89-0603da011cff"
      ]
    },
    {
      "cluster_id": "bf10b6e6-7de4-499b-bb6d-a9e69524994d",
      "members": [
        "9faacbf5-8470-4ede-8cfc-18027e35aca1"
      ]
    },
    {
      "cluster_id": "e8c08050-8918-4c52-bcd3-c5994c5cd40a",
      "members": [
        "2e4afe6c-377c-41fb-a709-0aa17fe96c47"
      ]
    },
    {
      "cluster_id": "f5e1b739-645f-4391-b201-66a90f3725ef",
      "members": [
        "b75ca8d7-d78d-4731-bbc5-827e3e8c284d"
      ]
    },
    {
      "cluster_id": "15826810-2be6-4996-948b-869e0ec64e02",
      "members": [
        "4c8fe5c9-7702-4b7f-89d7-34a3387550bd"
      ]
    },
    {
      "cluster_id": "5cf04f55-a643-43d4-8d14-b18769ab1e2a",
      "members": [
        "4a85235b-d804-415b-ad8d-b80286344dda"
      ]
    },
    {
      "cluster_id": "182a4780-6c12-4ebc-96a7-e01af3d000d2",
      "members": [
        "2f31b597-a1c6-4a14-bdb1-9926031bd733"
      ]
    },
    {
      "cluster_id": "afcde980-e0c6-457d-998d-0d7991b35017",
      "members": [
        "e63ed35c-d2ce-4cea-b973-b0de720980a4"
      ]
    },
    {
      "cluster_id": "50312364-9e82-4970-9daa-1275d0caaa37",
      "members": [
        "c8e1c6d5-165b-4699-9c2a-644ffc9bc590"
      ]
    },
    {
      "cluster_id": "5c60b7c2-773f-4fa5-90cf-1511916b711a",
      "members": [
        "5df08847-a67c-4353-9d9a-ac186bb7a0ac"
      ]
    },
    {
      "cluster_id": "b0fdd1fd-fb84-40ca-af9a-591f59bfb795",
      "members": [
        "76eb3d3a-2128-4f48-b28f-2e31e901d9e5"
      ]
    },
    {
      "cluster_id": "05e83588-8d3e-4daa-9f6b-b9faf4c1da93",
      "members": [
        "732ffe1f-e2ef-42d6-ace5-30f2f6397c5a"
      ]
    },
    {
      "cluster_id": "358c0eb2-869f-46fb-bab5-4fbe8881d4e8",
      "members": [
        "584a07dd-348b-4a9c-bcef-72d38726e3f2"
      ]
    },
    {
      "cluster_id": "b2f25ba2-9f04-4c71-9e8b-d9b021ed7e8a",
      "members": [
        "a15ffdcd-dd35-4e0b-a278-d39f0b704449"
      ]
    },
    {
      "cluster_id": "2529c3a6-becd-4a5a-81a7-ccc8f9b32cae",
      "members": [
        "52aeea6c-dbeb-49dc-b01b-d54c7468c757"
      ]
    },
    {
      "cluster_id": "642bde4d-512c-4efe-a811-93209336bdce",
      "members": [
        "43e6cdbe-7110-411f-9599-5f5644f1793c"
      ]
    },
    {
      "cluster_id": "9f888081-86ee-47a5-ac83-e1aec7d1b080",
      "members": [
        "62f49896-fe28-4e51-8248-9a0dbb2ec952"
      ]
    },
    {
      "cluster_id": "0e128959-4be6-4a58-950e-03878e48a675",
      "members": [
        "db5cdca6-47c0-4025-afb9-5cf4330d18fa"
      ]
    },
    {
      "cluster_id": "5e8c77df-b06c-4eb9-af9d-86a5548a4dfa",
      "members": [
        "ed606e7d-2737-465a-8cb1-534e7a2a2bab"
      ]
    },
    {
      "cluster_id": "b419eced-65f4-49b5-ac60-2638f9c27f53",
      "members": [
        "908e3499-9973-409e-9771-39750bd71773"
      ]
    },
    {
      "cluster_id": "410287df-601d-432b-a55d-63a15a95a255",
      "members": [
        "ee66cc75-520a-448c-9cb3-5329fa946d27"
      ]
    },
    {
      "cluster_id": "f1e47970-325f-4291-8d1a-b29229c84e05",
      "members": [
        "0877ed46-c1ba-45a3-ba4b-a8e0a6439edf"
      ]
    },
    {
      "cluster_id": "93067eb9-0c23-4760-88de-71a2925db3fb",
      "members": [
        "6659a365-5a97-4293-a252-2be5c298330c"
      ]
    },
    {
      "cluster_id": "a0f403d2-a7ff-4e00-84e6-2783bef20b8e",
      "members": [
        "52f42ec6-780e-4efe-92d7-4226178815ae"
      ]
    },
    {
      "cluster_id": "33fcdb26-eedb-4334-944b-e4ef875270b1",
      "members": [
        "92dc8e00-b4c6-4a43-b561-1940fec3c8ef"
      ]
    },
    {
      "cluster_id": "f2d4f2cd-14c3-4d0d-9c96-d0df234f7a5c",
      "members": [
        "a955132e-e3fb-42db-a430-9bf42ff99559"
      ]
    },
    {
      "cluster_id": "e95e8766-3999-437a-8b4f-72bf3c33a6a7",
      "members": [
        "96332f73-f924-443d-ace7-40cb4fa6d25f"
      ]
    },
    {
      "cluster_id": "0d16b859-0b48-4545-ad3d-19b0d4601fe2",
      "members": [
        "b8fef55e-cb17-4144-b36d-efe1a1412aa7"
      ]
    },
    {
      "cluster_id": "ec47ea11-5e31-4849-97a1-585ce227df93",
      "members": [
        "1f99c609-d675-4aa2-8365-41180ff2b10f"
      ]
    },
    {
      "cluster_id": "be39314b-1ba0-4fb9-b326-3f0e244710fc",
      "members": [
        "f84e3f68-1f12-4277-a0ad-1a2855816e89"
      ]
    },
    {
      "cluster_id": "3cd947fb-d46a-4f38-9705-3c1f8700f549",
      "members": [
        "6f517cb4-a5d9-48b6-89f4-774edcbd04fc",
        "f0464042-16e0-4fe6-9cea-1520a58e9b6f"
      ]
    },
    {
      "cluster_id": "e30d449c-eb81-4d62-9149-9437a1a2c593",
      "members": [
        "90075709-94de-4eff-a784-7426de978ac8"
      ]
    },
    {
      "cluster_id": "6220afcf-2f7d-4d0b-9949-c9eea0785c4f",
      "members": [
        "2f96b357-c41a-445d-9c72-3c14267b0f04"
      ]
    },
    {
      "cluster_id": "a49c6bf6-4bdf-4111-8400-ae8603304250",
      "members": [
        "3a6f2a92-5754-452f-9004-2098c7d76d66",
        "65a33ed5-7059-4720-8664-71df06856cd6"
      ]
    },
    {
      "cluster_id": "15f10d86-dc7c-499e-a621-4444d739de34",
      "members": [
        "443755da-213e-4f47-98c3-d9454d1eda94"
      ]
    },
    {
      "cluster_id": "715be432-cabb-4dfb-94ca-fb3947c60120",
      "members": [
        "d86964a8-b40c-4f2d-92ed-481299aa8e92"
      ]
    },
    {
      "cluster_id": "ad8eb55d-3403-4e48-a3d6-9bc723fa02c6",
      "members": [
        "992eb91d-44b1-4560-b199-36dfde7ead73"
      ]
    },
    {
      "cluster_id": "7cb43f88-bfec-484a-965c-af899d9b8682",
      "members": [
        "1a966d51-7954-47de-9b75-a0b764a89815"
      ]
    },
    {
      "cluster_id": "ff80368b-8a04-48e8-a451-431808c81ba2",
      "members": [
        "4f3cec2d-39b0-4ba1-be54-1f87fb414f33"
      ]
    },
    {
      "cluster_id": "2723b56b-92db-42cf-852c-6b9603282fde",
      "members": [
        "273108f2-182b-42a7-952a-9d33cd5b44da"
      ]
    },
    {
      "cluster_id": "9cb96178-90d1-49cc-8907-eb63419e86be",
      "members": [
        "91b914d2-9ac6-48f9-9b90-2415008e69fe"
      ]
    },
    {
      "cluster_id": "f8f2a0f0-c3be-425d-86a8-e332c871c957",
      "members": [
        "0ec31977-3023-4316-89f2-6cd4539a5b72"
      ]
    },
    {
      "cluster_id": "dfebeea4-e8fe-4891-915f-29504d1d80da",
      "members": [
        "3c3809b1-e474-4a0f-9fe2-ad9388296f1a"
      ]
    },
    {
      "cluster_id": "29c9c847-8482-467d-b041-65b225a57d48",
      "members": [
        "04179c15-22d3-4587-a3c0-a8d9de3bc862"
      ]
    },
    {
      "cluster_id": "109daecb-5285-41a5-9427-7fd6ab199a14",
      "members": [
        "1c531e95-8a53-4fa7-9cf6-f56ecc7fc194"
      ]
    },
    {
      "cluster_id": "f0764df3-3340-4405-ac6d-daef15a6934d",
      "members": [
        "2d287b25-96e4-4d14-b647-e585113cb393"
      ]
    },
    {
      "cluster_id": "f54e9fc4-9854-41c6-aa04-dba66f36cc19",
      "members": [
        "ea0de8a9-d55b-4475-a20a-bb160d082ced"
      ]
    },
    {
      "cluster_id": "abea76a9-3994-48b0-b3bb-df2d7f55ad12",
      "members": [
        "5abca650-7537-4d87-ba3b-ea71a51d8966",
        "bb447e51-3e43-43d2-aff6-cd68610c451a"
      ]
    },
    {
      "cluster_id": "db855b90-bd37-485e-bb72-492eed958963",
      "members": [
        "d7f5b683-1482-4b26-8fcc-a98be03f2ee9"
      ]
    },
    {
      "cluster_id": "9993ea09-c44e-4372-864a-21c7f72c7eef",
      "members": [
        "3b2a0ea9-b56f-4243-bafd-25eb3dfea4bf"
      ]
    },
    {
      "cluster_id": "20bc1b1d-621a-4c85-b194-0b79b56d7c82",
      "members": [
        "4b72e737-f1b9-470e-ba9a-2b4d5d50e353"
      ]
    },
    {
      "cluster_id": "5261c3b8-e566-4b27-8dcc-7c47abcca2e2",
      "members": [
        "17a480e6-1bf4-4c05-9ca4-8a1c574f0fc4"
      ]
    },
    {
      "cluster_id": "beb95653-6e6e-44fe-9a2a-77a05c101fd4",
      "members": [
        "39f0c8d6-5221-4a5e-bf65-ce98b09f7bd0"
      ]
    },
    {
      "cluster_id": "763eccef-6999-42f0-bf57-610e354559e9",
      "members": [
        "9d220ba5-be35-4626-91c4-851a735df936"
      ]
    },
    {
      "cluster_id": "d0668eff-8d5e-4aa1-a4e9-eab28ee44705",
      "members": [
        "d27e4f87-9af4-40ef-9766-ee18cb24a24f"
      ]
    },
    {
      "cluster_id": "7d6c6e4a-50bd-4afe-bb2e-cfcdaf7a206e",
      "members": [
        "f54f7af1-1b71-478c-91f6-ce3375ebdda5",
        "74d6300c-e54d-4b56-8ed9-29f1fa4731db"
      ]
    },
    {
      "cluster_id": "a1bd8b84-b3b2-4726-a7b0-fe007bb23321",
      "members": [
        "3d9743ea-263d-4b21-91a1-bdc5bbce2499"
      ]
    },
    {
      "cluster_id": "e4b7f8f2-bf69-40ad-a14f-a4a477fe73df",
      "members": [
        "48ec065a-a22d-4b14-98ef-d1e57418b549"
      ]
    },
    {
      "cluster_id": "dcc8df2e-a077-47fc-8960-d90fac2ea1d8",
      "members": [
        "58762de6-ddb0-4b06-9187-97497eb3ccc9"
      ]
    },
    {
      "cluster_id": "9cc8799b-e620-4e1a-8846-51eed506e0de",
      "members": [
        "057f2b8b-55d2-46a9-8ee2-57021db73494"
      ]
    },
    {
      "cluster_id": "ea70a7dd-0151-4733-b8dd-c6143a306c66",
      "members": [
        "9dfcd6c4-1585-4ebf-90b9-c35a0fa7b77c"
      ]
    },
    {
      "cluster_id": "497c65a0-d076-4ce0-b5c7-b89152ec15dc",
      "members": [
        "6fea3a19-99f6-433e-b70b-f3608c3e60bb"
      ]
    },
    {
      "cluster_id": "c0b25dac-eed2-4056-a693-6719f5711bef",
      "members": [
        "6cf8907e-3799-472e-a142-6db5a32cf03d"
      ]
    },
    {
      "cluster_id": "64d2c311-675b-43df-a715-09bca5e25a05",
      "members": [
        "70355289-4e54-47cc-81ed-a7bb982902ee"
      ]
    },
    {
      "cluster_id": "8ee8c1bb-0d20-4333-9bfd-60f5cae2d370",
      "members": [
        "21ef3182-d37f-4089-afa7-5293f6ec11a7"
      ]
    },
    {
      "cluster_id": "743f75a0-41d3-441e-9941-3043106cc340",
      "members": [
        "5f591bb2-1596-4e97-85e2-46ecbfcce715"
      ]
    },
    {
      "cluster_id": "a83597bc-3768-4ee3-a01e-2fac92f73ab7",
      "members": [
        "81040900-a0c6-4475-991b-52fa81fe003d"
      ]
    },
    {
      "cluster_id": "2ff54a92-503d-42da-bdb7-6138f7c69fb1",
      "members": [
        "4205ac4d-65c7-4014-8d2f-8cd32be87732"
      ]
    },
    {
      "cluster_id": "3fd5b7b8-68be-4404-8df3-9480731b7b5a",
      "members": [
        "e838e359-ee60-4cec-8c08-6dd107ae93cd"
      ]
    },
    {
      "cluster_id": "bc800212-afc6-410b-a69d-f8042afac330",
      "members": [
        "8e52fce7-6f34-4f80-8b7b-48f2857c305e"
      ]
    },
    {
      "cluster_id": "25e8666d-6596-4996-8765-9de5aa51e568",
      "members": [
        "6080b396-b17c-4aa2-81b9-ba25672408a2"
      ]
    },
    {
      "cluster_id": "cf6c1c0d-fc13-4eb6-a686-91e7d8509399",
      "members": [
        "4c386586-e3e9-4a25-9801-0eafde56c525"
      ]
    },
    {
      "cluster_id": "95eac10f-08e8-4ebe-913d-90bbcf49cbbc",
      "members": [
        "aac25fda-3c07-4c31-aa1f-fd0594820879"
      ]
    },
    {
      "cluster_id": "efd04eb7-8311-4730-bee6-1df74b27a996",
      "members": [
        "1a0a0196-5909-4768-b7fd-e4131e2d6c8e"
      ]
    },
    {
      "cluster_id": "ebb2f2f8-c476-4b98-bd7c-c0a3ef8345f6",
      "members": [
        "762253e6-57af-47e7-b109-eae8b57cac36"
      ]
    },
    {
      "cluster_id": "ffdeea6b-2666-497f-8afc-18b1b72c39c8",
      "members": [
        "7e4169be-df96-4a1c-aa6c-703ba0cf2881"
      ]
    },
    {
      "cluster_id": "d4e4377a-959a-445e-9e4e-9d1461ec884e",
      "members": [
        "6e248ec0-e30b-4f51-8579-24812d158310"
      ]
    },
    {
      "cluster_id": "2a58b8a4-48d6-4d79-a6a6-51d7d778b6e1",
      "members": [
        "9a5ad9cc-8f84-4803-ab1b-e12442d8d75c"
      ]
    },
    {
      "cluster_id": "f1b5fe76-d258-4eb9-9621-ec9dac4e7f52",
      "members": [
        "0d5c8fb5-25e3-4975-9d67-5ead0c547fd7"
      ]
    },
    {
      "cluster_id": "2160e916-6f22-443c-821e-3ddb5ec1cf74",
      "members": [
        "c06924ea-b252-4ba8-baba-1346689d0f77"
      ]
    },
    {
      "cluster_id": "4c8c98df-55ae-4fb5-ba8d-8d914fda29e6",
      "members": [
        "51f12563-6d80-4e66-9666-c6f294c04b61"
      ]
    },
    {
      "cluster_id": "cd745d99-6d4d-4cbd-964c-839c80021692",
      "members": [
        "6b59b7b8-899a-4348-9f47-d102264da0be"
      ]
    },
    {
      "cluster_id": "0cf451c3-4981-46fc-b4ee-79c480a2a2b9",
      "members": [
        "bc8aa8a6-413a-4ef6-955c-b7b8f1001177"
      ]
    },
    {
      "cluster_id": "0834a3ac-a924-43d8-bec6-6e7d0a1384ad",
      "members": [
        "54c57281-6ac3-4089-bff4-8a5005f13b2b"
      ]
    },
    {
      "cluster_id": "903140f6-5deb-4b0a-b645-3ff3ded85a2c",
      "members": [
        "78145ec9-7610-46fd-abe4-b0c54e40e502"
      ]
    },
    {
      "cluster_id": "985525fb-882c-4e38-8f11-fa12ae906da0",
      "members": [
        "7ddab30b-c17e-4d25-a28f-fdb334a4e123"
      ]
    },
    {
      "cluster_id": "fca5231f-5992-4d7b-ae79-0b5b3aa11fb8",
      "members": [
        "16e34379-812e-4b5d-99d7-77cd6206fd62"
      ]
    },
    {
      "cluster_id": "84e9da04-8cd3-4c61-8fa8-fb55a6309d3d",
      "members": [
        "a6fc308b-3017-4785-b22d-6757f02916a3"
      ]
    },
    {
      "cluster_id": "a5c724f6-7c96-401f-918f-4b43072ac6cc",
      "members": [
        "c3964c0b-7310-40e7-8f89-8e0484db56b0"
      ]
    },
    {
      "cluster_id": "d67d9854-246c-464b-b04d-764da1ea0a72",
      "members": [
        "89acd222-703c-4720-9a8d-6057aeb66108"
      ]
    },
    {
      "cluster_id": "3cbece7e-7ff3-422e-bd74-b94ccde6f34a",
      "members": [
        "284807e6-5a7d-4b3d-9de8-37f95923bac0"
      ]
    },
    {
      "cluster_id": "a1957de3-964f-4df5-ac8b-e165983c14d7",
      "members": [
        "a7f94928-dc14-48df-894f-bbd44314a21d"
      ]
    },
    {
      "cluster_id": "64cf5e07-c73c-4733-9b23-8f12213cc336",
      "members": [
        "aa8b0872-8aba-41b8-a356-53cdcc685d97"
      ]
    },
    {
      "cluster_id": "56a71fc3-1754-4e95-b0fd-27485ee352e9",
      "members": [
        "81e31e4a-d74f-497d-9953-d5e8a971de7f"
      ]
    },
    {
      "cluster_id": "e63bcf8f-4e49-4048-bed7-415583eadc3f",
      "members": [
        "7af695bf-f174-438a-bf33-8de415057f92"
      ]
    },
    {
      "cluster_id": "b2a104aa-8e99-4af3-a2f3-b3e4f2fb5af6",
      "members": [
        "bd4e11ec-b7c0-477a-aa5d-25393b75350b"
      ]
    },
    {
      "cluster_id": "d05aef6f-059f-4fa1-b456-946956a2ded5",
      "members": [
        "43739e83-5143-402c-987a-39ea6d5e21dc"
      ]
    },
    {
      "cluster_id": "65143df4-6c29-4538-b9c3-4cba1c56a8eb",
      "members": [
        "d6ae3f94-02d5-4536-83f8-8be433e4dd52"
      ]
    },
    {
      "cluster_id": "dad9620e-fc93-4bb0-adf4-d1ba1da4f381",
      "members": [
        "d77b65cc-00a1-4a75-9335-7fe0ec3ef5c8"
      ]
    },
    {
      "cluster_id": "367c1ab5-4267-4b68-a2ed-2893d2797c11",
      "members": [
        "29a24473-b8bb-48f0-9506-7cc876ec9c53",
        "9ba9a2bc-1b97-468e-8e27-647989e228f4"
      ]
    },
    {
      "cluster_id": "dbe0f86a-aebe-4564-9503-5702cd51713e",
      "members": [
        "b1078384-5dbc-482c-80e7-b3c2c8fe20fa"
      ]
    },
    {
      "cluster_id": "6adcd904-be39-467c-bbbe-a9cce702dbdb",
      "members": [
        "8cc747bf-1146-4f59-bbc4-924fbddcde7b"
      ]
    },
    {
      "cluster_id": "83f7014a-9a88-48b8-b5ab-b83620e2b1f6",
      "members": [
        "2f9c6547-073e-47c9-aec0-6dd23bb6a1c5"
      ]
    },
    {
      "cluster_id": "c4d30aec-5c26-4bc5-895d-1e61d6d7b97e",
      "members": [
        "2e96409c-7d0a-42c4-b320-7826d3915f16"
      ]
    },
    {
      "cluster_id": "ac7c5639-803c-4c6d-b9be-69ecbea167de",
      "members": [
        "1d149e85-0fe7-4c13-8ed7-3fec8ed5ec74"
      ]
    },
    {
      "cluster_id": "b985b53e-1d8b-45e2-8b3f-823f5bdb2380",
      "members": [
        "5ad8fc67-ff18-4a10-aeaa-b0d12fb2b6c0"
      ]
    },
    {
      "cluster_id": "aeb63f4c-fb27-45bb-903e-d98ab93f7138",
      "members": [
        "d5265464-b07f-428f-b9e0-de6d62c4b69e"
      ]
    },
    {
      "cluster_id": "2dadee48-a44e-49fd-a481-3bd3ad498e90",
      "members": [
        "bbbf487f-7ca2-439c-9083-5a2a23d1e934"
      ]
    },
    {
      "cluster_id": "6e62e8fc-d0f2-48d9-952d-5f14837f0f03",
      "members": [
        "c6a4fba7-df7f-4349-939e-444ef1af059d"
      ]
    },
    {
      "cluster_id": "b366766f-15ce-4857-abc5-dda97885eda4",
      "members": [
        "f22e9252-9040-436b-a71d-021a3ffca2b7"
      ]
    },
    {
      "cluster_id": "2dfb4996-f1b5-47a1-93fd-431ef2467700",
      "members": [
        "eb2b1c62-ff40-4bef-b079-3ed1a9a922f2"
      ]
    },
    {
      "cluster_id": "e5eb9c21-045d-4a8f-b07b-6af55af6d48c",
      "members": [
        "d42ffc06-b4f7-4cdf-8740-500fda2e76ab"
      ]
    },
    {
      "cluster_id": "094959dd-ba14-4dbb-83c9-b7363a4aff97",
      "members": [
        "5f67926f-47ae-466e-945a-4e24a57f495d"
      ]
    },
    {
      "cluster_id": "da3e8993-13d7-42de-887c-a22169a3cf16",
      "members": [
        "029a41b8-5bfa-4a1c-a823-99d0b28d7421"
      ]
    },
    {
      "cluster_id": "b8f80339-9419-4259-b0c6-1e550ab9ab7c",
      "members": [
        "ae8ddae7-cd18-4788-88e8-ea413e8d6ac3"
      ]
    },
    {
      "cluster_id": "58f3dc82-7967-4488-b9f2-9a804334fb7a",
      "members": [
        "e56d3be1-6286-42f7-ae0e-3bcd92b6d963"
      ]
    },
    {
      "cluster_id": "5f26f77b-0214-4097-94f1-7873a36d7969",
      "members": [
        "33448b65-89e1-453f-ac46-097978266b95"
      ]
    },
    {
      "cluster_id": "70ea1622-08ba-432f-a3ce-0079b309daee",
      "members": [
        "d816f5ed-9784-4f50-b90c-f6908758e6b8"
      ]
    },
    {
      "cluster_id": "77810a86-21b7-4267-8df5-dbf7f241aa35",
      "members": [
        "8cb69cfd-85dc-4c0f-b971-2a4889509e57"
      ]
    },
    {
      "cluster_id": "528595cb-88e8-4fb8-9197-5baf87551c4a",
      "members": [
        "073a0a2b-171a-46cd-9eb6-8944e39c4434"
      ]
    },
    {
      "cluster_id": "7b4ecda5-4408-4ecd-a695-939e312b6ac7",
      "members": [
        "4ac0b73e-244f-47b5-945d-8d0c3614d33f"
      ]
    },
    {
      "cluster_id": "c7d55c3d-c95e-4814-b774-3a8773d025eb",
      "members": [
        "97de3966-6346-46ae-9e03-b0a4c14a782b"
      ]
    },
    {
      "cluster_id": "c5169cd7-a9a1-476b-8658-0fe7fd1f0d44",
      "members": [
        "4a6b1605-1c0b-49f4-ad28-fac808622876",
        "bf2117fc-622a-4b9e-9739-256e8d0257fe"
      ]
    },
    {
      "cluster_id": "6e377c9a-0767-453d-bf0f-0a832d805a7b",
      "members": [
        "7ce2fa37-7022-4551-9c9c-e5b51aff0552"
      ]
    },
    {
      "cluster_id": "45c15578-ca19-42ef-8fc5-04e77034e4c3",
      "members": [
        "d79ed9b7-d187-4177-b2dd-99cea6aa6c11"
      ]
    },
    {
      "cluster_id": "1eec17fb-077b-4de8-a9a2-2c4b4ccfcec3",
      "members": [
        "4d24e4bd-5b86-4510-835e-015de2aadc8b"
      ]
    },
    {
      "cluster_id": "062e5bd8-abe2-403a-b6a1-7c176aafd049",
      "members": [
        "6094a91b-be05-4e65-991d-88834f3c6d51"
      ]
    },
    {
      "cluster_id": "39d6e082-ff74-4db5-9429-ae565700afa5",
      "members": [
        "096a3029-98b7-4ed7-9eb4-e6c2193815e0"
      ]
    },
    {
      "cluster_id": "4807cbce-9aad-467f-86b6-35d202d1cb91",
      "members": [
        "006f8e37-0bf6-4529-8ae4-8b2b2c61290b"
      ]
    },
    {
      "cluster_id": "d1bd7e91-60d7-44c4-a3e3-fa4bad7dab38",
      "members": [
        "0a29d425-4f20-4547-ad98-782dbb8b942c"
      ]
    },
    {
      "cluster_id": "c724c59d-be1d-40e0-8e89-b56ec9ff6193",
      "members": [
        "e6cfc285-f96c-462b-86de-69eae094a9bb"
      ]
    },
    {
      "cluster_id": "0228c164-28e2-4e5a-b2e8-2f3ba9a5fbf3",
      "members": [
        "989cde89-2dab-4dd9-88e8-2bdad40f6525"
      ]
    },
    {
      "cluster_id": "0e8cc365-638d-4d52-88e5-ee27a8dddfb2",
      "members": [
        "153717df-7ea2-44dc-9d09-0a3b96f8d0f1"
      ]
    },
    {
      "cluster_id": "2e3c3c0c-9c80-46be-8b29-ebed3dc26978",
      "members": [
        "b51b52ad-234e-4f9f-aedc-378f5af6691f"
      ]
    },
    {
      "cluster_id": "639a3221-3088-4eab-a13f-8485c80e01c5",
      "members": [
        "d6fd61ec-67b4-49a7-b01e-6751da4c2b70"
      ]
    },
    {
      "cluster_id": "990108fa-17d4-4b4c-865d-d0668a8a4d9a",
      "members": [
        "192f64f3-404e-44e7-be69-061f71569962"
      ]
    },
    {
      "cluster_id": "676e190d-f7b8-4cab-bf36-934dddda11c8",
      "members": [
        "66cc19cb-d992-4801-a6a5-3bcc508cad56"
      ]
    },
    {
      "cluster_id": "269675ca-916b-4267-8970-bb97e2010767",
      "members": [
        "b92df98b-d7a8-492e-99c0-f650da425547"
      ]
    },
    {
      "cluster_id": "6f7eecf9-9f3f-44ce-8b0e-5a71d6961aae",
      "members": [
        "4184ac9e-a2ee-42c3-b501-e30a7f7cceb3"
      ]
    },
    {
      "cluster_id": "9f64a0ee-1ff6-468b-9bf7-001ce2c6ea58",
      "members": [
        "6fef70f2-b2e5-4078-9e9a-4ed219b153de"
      ]
    },
    {
      "cluster_id": "abf9a23b-ae17-4adc-8775-9b47f6861ebe",
      "members": [
        "b2ac124c-ace9-4763-b92a-9b4ee6fbe882"
      ]
    },
    {
      "cluster_id": "5a4d2a32-bac0-4370-915e-eb0f49138ccd",
      "members": [
        "06462009-bc55-4f62-843a-7d69d3bfed7c"
      ]
    },
    {
      "cluster_id": "48ab24c5-0fbd-4e1e-ac75-46e6a9ab3e75",
      "members": [
        "7228ee7e-e61d-4ebe-bcd4-e6b39cf2dc2a"
      ]
    },
    {
      "cluster_id": "0fa7a4b5-a1c3-4039-a50d-a01dc2e3920a",
      "members": [
        "35b2b00e-13d0-4a07-94e4-e0237cd1bb94"
      ]
    },
    {
      "cluster_id": "2ccc0520-5070-4b1d-b1b9-d9e9fc878c97",
      "members": [
        "4cb198bf-2c46-4779-a0a2-822e74b7b4a3"
      ]
    },
    {
      "cluster_id": "52457cd6-b07c-4e34-b96e-c3d2ac06f2d5",
      "members": [
        "fa1c7035-96d3-49a2-8d99-2e4980a79148"
      ]
    },
    {
      "cluster_id": "89deb9da-1363-4a27-b0dc-19089a829274",
      "members": [
        "012714bc-c95f-448c-9823-3988f2217818"
      ]
    },
    {
      "cluster_id": "0e6b6876-fb14-4627-9900-55ce513c116c",
      "members": [
        "06e78ed7-0599-4d54-9772-986b6028609d"
      ]
    },
    {
      "cluster_id": "993498fc-f160-4c04-b836-a36d850156e5",
      "members": [
        "01f3eb35-460a-46a5-bbaa-c848320a4e96"
      ]
    },
    {
      "cluster_id": "dae1826c-9197-4507-aadd-a2ba9a01285b",
      "members": [
        "53189873-e1b0-4a74-a2de-c6f96c1ee63c"
      ]
    },
    {
      "cluster_id": "2d8f3813-2525-407f-8769-b0281d589d42",
      "members": [
        "2ecfd8b1-aeaa-4f4a-9ed7-bd95ba311047"
      ]
    },
    {
      "cluster_id": "59e2af7d-1c61-4602-808b-5369f9854fc9",
      "members": [
        "9e46276b-9550-4850-906b-947941551ea0"
      ]
    },
    {
      "cluster_id": "9d75c554-9eb9-4082-9c04-6fe3e303845e",
      "members": [
        "7db66327-741e-4aba-a2d0-9dec13f88426"
      ]
    },
    {
      "cluster_id": "213e0c4f-0911-44fc-89bf-cf985adbc12e",
      "members": [
        "f5f8713a-6585-4825-bec7-0970665e313b"
      ]
    },
    {
      "cluster_id": "bfccbfa0-4d21-4c95-88ca-a83d95def684",
      "members": [
        "6b9ee849-6886-4346-8ad1-d1204d78e963"
      ]
    },
    {
      "cluster_id": "3bf8a3ce-dee2-499e-bfb9-1c559ad0291c",
      "members": [
        "71bc85b6-6f5d-4aef-bc64-1f26ad42393c"
      ]
    },
    {
      "cluster_id": "bca53d12-fc37-4cd1-9c2a-d9e494bc9ea8",
      "members": [
        "40693fc4-7ddd-4a41-9ba7-2ab2fce9c650"
      ]
    },
    {
      "cluster_id": "201e4820-096b-4a76-8f83-d96f22acc64b",
      "members": [
        "6681479a-13d9-4db6-b878-98826e64562b"
      ]
    },
    {
      "cluster_id": "5b4f8322-7c02-4a35-a585-89dc98ced769",
      "members": [
        "a3211a66-26b4-4f94-8dce-8734cfb6c504"
      ]
    },
    {
      "cluster_id": "26b806a5-30f6-4312-bfd4-c6984e3b4d30",
      "members": [
        "9912bacb-3f98-46ca-a184-72b1066243a3"
      ]
    },
    {
      "cluster_id": "52bfe357-189c-4c8a-a4ee-372f061bfc2c",
      "members": [
        "b6a06f13-7ec8-462d-8836-4a64b81b052e"
      ]
    },
    {
      "cluster_id": "25e1da60-126d-485f-b6b4-e17bd08835f7",
      "members": [
        "e99c6b71-2091-4ff9-b9a1-3ffb9da8a1fd"
      ]
    },
    {
      "cluster_id": "7d7dd851-9e80-401e-86ac-20fbd4d71580",
      "members": [
        "7d86a9a0-38d1-4e6f-9511-4471e7bb984a"
      ]
    },
    {
      "cluster_id": "011aa847-d3e3-4d34-bf5e-378f39ba8a3c",
      "members": [
        "cc823d78-71f1-4505-b8f8-4cbd92ba6515",
        "7fcc26bf-3d16-4a63-bed6-eb9aad637370",
        "ccfa9ab4-b725-46fe-9d4b-81f4301a7777",
        "6435466e-2952-4414-a5f1-47d0171d8ffe"
      ]
    },
    {
      "cluster_id": "aead4c3f-44a7-4ce8-91b4-79e0aadcc982",
      "members": [
        "e6358408-cf3c-467a-83f0-f1a25a9cb069"
      ]
    },
    {
      "cluster_id": "075ee2c5-b49b-44c4-9646-461463ce6ff8",
      "members": [
        "33f1cb91-f1d5-4f65-96c3-91b4f079dae6"
      ]
    },
    {
      "cluster_id": "ebcf5883-5a67-45cd-af26-c257a5d38512",
      "members": [
        "2643e618-f92c-4989-a4ea-d7524c161d11"
      ]
    },
    {
      "cluster_id": "7869af70-2ee4-4af6-b749-30538201cdc4",
      "members": [
        "81a34fec-f865-4d74-973d-1441a2e96448"
      ]
    },
    {
      "cluster_id": "4df09684-8f05-4939-a1b1-6f51c32b4b06",
      "members": [
        "b20106d0-cc8b-4da6-847a-cee0c4e03136"
      ]
    },
    {
      "cluster_id": "10b72ca8-fbc7-465b-bc23-1509272e1515",
      "members": [
        "b1b7994d-e789-44d3-8fa9-786c6ad1660f"
      ]
    },
    {
      "cluster_id": "2d5f7bd3-4c30-4ae5-a057-0f3e35a0cb68",
      "members": [
        "01e15d8e-9278-49d9-b0ae-ee64046f3232"
      ]
    },
    {
      "cluster_id": "aefe0bc6-fe98-4828-a554-094ca6f377d1",
      "members": [
        "1a70a4dd-2da1-4130-83c6-be14a06081b2"
      ]
    },
    {
      "cluster_id": "a75f7771-ca28-43b6-99aa-f4f9b0398268",
      "members": [
        "adb47cd3-ee56-4d9a-9ca2-c4a01876a63c"
      ]
    },
    {
      "cluster_id": "0d049984-1ab9-44da-bbd0-bb9c99a21317",
      "members": [
        "c8879a85-e025-45d5-a6f3-c18a66716cc6"
      ]
    },
    {
      "cluster_id": "a28a5ed3-bc11-405d-9242-8b1a5ce91c01",
      "members": [
        "78b14f68-ae01-4d4c-acb1-0d71d1609053",
        "9c8061a4-b6c8-4b01-9126-324edde1a3da"
      ]
    },
    {
      "cluster_id": "148cbdc2-efc0-4f16-b29a-724816c7ee5d",
      "members": [
        "5faf6e11-7e86-475d-bf63-e4435dee1019"
      ]
    },
    {
      "cluster_id": "92ec2cbf-b9b0-4664-a8a7-ef9ea075d88c",
      "members": [
        "af931724-5e01-43e3-b06e-af89df93f816"
      ]
    },
    {
      "cluster_id": "3e318927-1041-4535-a22e-049f32238ea2",
      "members": [
        "99463725-d3fb-40d5-b695-6e928f7a6286"
      ]
    },
    {
      "cluster_id": "10d03545-859a-4c3f-b85f-14e8f49d3ac5",
      "members": [
        "6ecc5c36-f428-48db-8860-cc6f3409b905"
      ]
    },
    {
      "cluster_id": "cc24e5f4-c0b5-4176-a975-3eb0a8f8713d",
      "members": [
        "00177a2b-221c-4df0-8918-34f76f806afb"
      ]
    },
    {
      "cluster_id": "d345d980-af47-4c52-856b-f3fba326963f",
      "members": [
        "f4e6e97a-7274-4981-aced-d5b19a5f74cb"
      ]
    },
    {
      "cluster_id": "7c3363eb-6e57-40c6-934c-69f3d1e89801",
      "members": [
        "86306a55-2043-46cd-8b9c-cb3d3beebc6d"
      ]
    },
    {
      "cluster_id": "cda7a1d3-b038-4c3b-864e-35781faec81a",
      "members": [
        "193f820a-5a38-4ded-ab67-3111ab1c213a"
      ]
    },
    {
      "cluster_id": "5a26984c-e60b-4dac-8536-2c84c78b7c2a",
      "members": [
        "b4f98ed3-8223-4416-9d64-76e16d257741"
      ]
    },
    {
      "cluster_id": "ca0d7a2a-b8d2-4968-874b-aa3379e0dafa",
      "members": [
        "46cca0d7-4e2c-4d52-a3ab-76af3ea351e7"
      ]
    },
    {
      "cluster_id": "b02a0b69-fccb-4794-8e75-23dec5c20147",
      "members": [
        "1cd55f6e-f978-4e0e-8c42-852043619353"
      ]
    },
    {
      "cluster_id": "1faa9d4d-1b1c-4e6c-9fd5-22f9b057a61b",
      "members": [
        "2e4b1b25-9832-47f9-a571-e3cf7e71a86b",
        "28857841-34c9-41d8-9e68-cfa18abcaec5"
      ]
    },
    {
      "cluster_id": "016e2f4b-e8bd-4271-a6d5-2bf7dc3d49bc",
      "members": [
        "c76856fd-3193-49fb-aaca-987b66991f96"
      ]
    },
    {
      "cluster_id": "3dc78939-89e4-4b07-a3e0-cad83ab8d427",
      "members": [
        "6319b523-7a66-47b9-9709-d11fbc2b693d"
      ]
    },
    {
      "cluster_id": "244850ce-669b-481d-b002-ad90cb2a1ad2",
      "members": [
        "24798506-4131-42dd-93ec-7fcaf538d514"
      ]
    },
    {
      "cluster_id": "10cff142-fdb6-4cd5-b991-a870f41801d0",
      "members": [
        "895d573c-7c48-4b90-9725-42ce20b2311d"
      ]
    },
    {
      "cluster_id": "ee3497a5-19ab-4376-a948-4abe0f0d9b83",
      "members": [
        "02509c8c-3ac5-4e9b-a5fa-bc3de805bf13"
      ]
    },
    {
      "cluster_id": "ebaf2aaf-acc5-40a1-b99f-157e33f793e4",
      "members": [
        "3f9c9033-7f55-4d2c-8bb5-e8d64bfba2ad",
        "e2efdd4f-6c5f-4755-b476-6368f4ecdcfe"
      ]
    },
    {
      "cluster_id": "6707f20d-c9f4-42bc-ba94-e97c87eae6e1",
      "members": [
        "782379b9-cabd-46fc-b911-0470863f9959"
      ]
    },
    {
      "cluster_id": "42b0a0ff-74f3-41bf-9d03-2adc79284ead",
      "members": [
        "4bfc3856-1d1d-40a6-9dea-4ca5e589114f"
      ]
    },
    {
      "cluster_id": "15b6ae6c-1463-4a8d-9552-d2739588b3e7",
      "members": [
        "760eac4a-ccfb-4233-9ad1-8b2a33b46b07"
      ]
    },
    {
      "cluster_id": "c9d1dced-4dd7-4c70-87e5-a257d37a3ec7",
      "members": [
        "cd7e77ee-90bb-412e-8be8-7efd19f44bca"
      ]
    },
    {
      "cluster_id": "5ed59d44-85f1-4b54-af2c-2965549e9825",
      "members": [
        "a9c6ea4c-098a-4bf7-8177-5e9d3dc7e7b1"
      ]
    },
    {
      "cluster_id": "3d7847cc-aacf-44b1-8832-6089b6ace8d2",
      "members": [
        "2ed16c52-b1a2-4fa7-a894-4f80d57f03ca"
      ]
    },
    {
      "cluster_id": "3706e344-49f2-43a5-a708-cb9ca4fbc648",
      "members": [
        "d6541a0d-b8b8-4b46-b2b3-7709093a904d"
      ]
    },
    {
      "cluster_id": "c44517b3-ae07-46af-8dc8-9946743528e1",
      "members": [
        "d5289d0a-7587-47f3-a127-377dde4d6139"
      ]
    },
    {
      "cluster_id": "3cee1037-34a3-4502-8ebe-36a15c95ec82",
      "members": [
        "138a7f8e-9488-4037-a411-2c7f0bd720e4"
      ]
    },
    {
      "cluster_id": "0d8dd84c-b6a6-4b66-80f5-c84acd03da41",
      "members": [
        "8b2db83b-6c14-4087-b8bb-a72645880736"
      ]
    },
    {
      "cluster_id": "37c144c2-5b3d-4b37-81ec-b6ea11090b3a",
      "members": [
        "a323c5b7-c89f-4df6-a9cc-1b10d2e262db"
      ]
    },
    {
      "cluster_id": "5e83ce8b-b525-4867-8caf-5b4d780a4a6c",
      "members": [
        "50eb0125-135f-4fda-89a2-8784046737cd"
      ]
    },
    {
      "cluster_id": "49b71ab3-8ddf-486a-9781-e873ef1c9042",
      "members": [
        "fe475462-13d0-49f8-b497-59d3e83070b5"
      ]
    },
    {
      "cluster_id": "e9f5a5d3-fb2d-448b-ab54-b718baa4bcab",
      "members": [
        "93525525-c9c8-41fd-8976-67360dc59ef5"
      ]
    },
    {
      "cluster_id": "e9e5cd65-c720-48d1-aff5-59d128103cd2",
      "members": [
        "f32378d8-2d99-43d4-9ef6-9f811b5f21a0"
      ]
    },
    {
      "cluster_id": "da5f41fa-d075-4835-b977-9a11cca0ec10",
      "members": [
        "99e12ad1-d630-44fb-b4f9-a4cff70ce19f"
      ]
    },
    {
      "cluster_id": "60da7061-2845-47bf-80c5-d5e550633128",
      "members": [
        "a9037445-b5cd-416c-95e5-21c313b0115d"
      ]
    },
    {
      "cluster_id": "499883aa-4d50-44a0-85ba-67de7dd41a9e",
      "members": [
        "a712c2ed-6f8a-4c3d-b2e3-f027854812db"
      ]
    },
    {
      "cluster_id": "2fef56aa-90d0-4ea0-9ef0-fc7608685f56",
      "members": [
        "0473891e-7ca3-488c-9e31-ebdce839cd19"
      ]
    },
    {
      "cluster_id": "eebab277-5cd3-4cfd-9fb6-1c0154222c56",
      "members": [
        "9df7e52c-2adb-4d55-b85e-14542afa3f8a"
      ]
    },
    {
      "cluster_id": "3a1850b4-8745-4145-98c4-7563773130a2",
      "members": [
        "c83c4ddc-fbff-4e86-a3a7-8bb98c1ed0dc"
      ]
    },
    {
      "cluster_id": "cb26f67e-804c-4c0f-8dea-81103afdf8ce",
      "members": [
        "42968904-9bcb-47d4-b553-a55c537e7274"
      ]
    },
    {
      "cluster_id": "2aa6b6de-5e53-433f-9477-ca28d007cfea",
      "members": [
        "2b237886-7fdd-4732-816e-6bbff127142f"
      ]
    },
    {
      "cluster_id": "d5a1e042-b187-41b4-a6ad-f1f271f98a66",
      "members": [
        "4f6449e5-4a91-414e-877d-b32f59ccf58e"
      ]
    },
    {
      "cluster_id": "36dc7f3c-7522-4964-8e5f-96eb7e85aa98",
      "members": [
        "a92003c0-70e7-42b3-988f-d81e279bc03b"
      ]
    },
    {
      "cluster_id": "b6807769-e83f-4f7f-b7a3-1a4b782749ea",
      "members": [
        "779e0434-97ae-4158-84a3-b4fca8cf3f08"
      ]
    },
    {
      "cluster_id": "fa7c00de-2843-41e3-9b90-64fc233c087b",
      "members": [
        "2bee01d7-bd51-4db8-a7dc-a0a88773adad"
      ]
    },
    {
      "cluster_id": "32bd49c6-94f8-4c4c-b45a-7a8a4f01eb08",
      "members": [
        "f86973e2-e5e2-4a44-8d3b-b1ac27a7a363"
      ]
    },
    {
      "cluster_id": "4c9bd8ca-0977-4844-9921-072e396e0fac",
      "members": [
        "90b22975-ed2b-4f69-8b5a-cd5cb7dcc199"
      ]
    },
    {
      "cluster_id": "e46f2bcf-e185-4401-89f0-e7da4fcba567",
      "members": [
        "11f79298-b8f6-4408-85b4-786037d03770"
      ]
    },
    {
      "cluster_id": "e64379e3-7714-4ce4-9ee9-585f6bf488c8",
      "members": [
        "f6e52c00-e977-4d1c-89dc-fdc5994145a0"
      ]
    },
    {
      "cluster_id": "4a618a75-71e5-4836-8396-68e00d05b814",
      "members": [
        "3d86324e-cea3-467d-af95-8d4a16e21008"
      ]
    },
    {
      "cluster_id": "55bf2e02-8b8e-4a6c-b132-fd70d3faa280",
      "members": [
        "a0dbb5ae-1757-4cce-a858-7b96b56b2be4"
      ]
    },
    {
      "cluster_id": "39e17317-299b-4c70-bf27-b813fd6d3c5f",
      "members": [
        "1966df90-c4a2-4ffa-9b32-2006f7a4755b"
      ]
    },
    {
      "cluster_id": "d46a8e73-11be-40a1-8437-95dcedae232c",
      "members": [
        "638c9182-29b4-482e-bcd1-514fdf6e8a35"
      ]
    },
    {
      "cluster_id": "99cf328e-cb8c-4fbf-b5e7-b5b12080a8e0",
      "members": [
        "b5d6f9f2-ce51-4cef-9cfe-4437807d1546"
      ]
    },
    {
      "cluster_id": "c754fcc4-5c32-4f8a-ac01-348838a5d407",
      "members": [
        "ce75fd3a-e456-4e22-abde-8e5ee4b3f330"
      ]
    },
    {
      "cluster_id": "3fceb0c7-e424-40ef-bf39-fd06469e3042",
      "members": [
        "097111e8-9746-4413-8f32-bcc2a3892718"
      ]
    },
    {
      "cluster_id": "f0a2a4b5-aeb4-45ae-835f-525f0fd65d67",
      "members": [
        "d625fbba-1849-4021-8450-2020a5c3339b"
      ]
    },
    {
      "cluster_id": "83bfa8ce-e39f-4c0f-b6f0-a55302bf1e3d",
      "members": [
        "5570571f-ad91-4a14-a37c-c1f5c9bb4425"
      ]
    },
    {
      "cluster_id": "8b267081-f50e-4410-bb56-f7281271aae7",
      "members": [
        "e8a88891-6162-4dfc-a372-3e1ee7789383"
      ]
    },
    {
      "cluster_id": "6511d484-25a2-4b72-9c08-df0d1ad4f8b5",
      "members": [
        "360108f5-5936-45ab-9e49-a18ba6c9caba"
      ]
    },
    {
      "cluster_id": "7bdd8e86-1a5c-4cda-a846-8ddfcadc8007",
      "members": [
        "a924f04b-a407-4779-9552-066202edb258"
      ]
    },
    {
      "cluster_id": "e5a713cd-2a21-42c0-89a2-7795a4250823",
      "members": [
        "8f6c4504-6a6d-432b-8ce4-6eda6caf5127"
      ]
    },
    {
      "cluster_id": "65e251ce-15b5-4f60-b87b-ef28a1709b53",
      "members": [
        "f74503b4-acdd-4cf7-bf1b-4191fcb103e6"
      ]
    },
    {
      "cluster_id": "23c989ae-ea8a-4829-80ac-944f7f9327cf",
      "members": [
        "f11e8a14-8269-4f0f-8869-ec7f1fb098b9"
      ]
    },
    {
      "cluster_id": "d488f4da-dea7-4960-b3a2-50c35254e3ba",
      "members": [
        "7aebbdb1-b25b-4005-9153-51782d457191"
      ]
    },
    {
      "cluster_id": "cc9b53cb-83c0-4db5-a0d0-5708d4af2a1e",
      "members": [
        "1617ea47-79ab-48fc-888e-328bfca7bc67"
      ]
    },
    {
      "cluster_id": "27391c49-b3b4-4f4d-98c5-cbe7a8ecbb05",
      "members": [
        "8884e3f5-3f6c-40fb-bfb1-4a0b57f4d2b4"
      ]
    },
    {
      "cluster_id": "1b9bf573-9c3b-4f5c-a46b-1677c3204c31",
      "members": [
        "9373fba0-2e0d-4d7e-96d5-8bcf4917d4e8"
      ]
    },
    {
      "cluster_id": "db2b5d72-303d-4743-8188-e92d23a86e05",
      "members": [
        "4f0d95da-c760-4882-b99e-b93c7996f4f7"
      ]
    },
    {
      "cluster_id": "55c3e6f5-571c-4234-bde1-164fbe090fa3",
      "members": [
        "0f190e11-1033-4f4f-bbfa-8bc82e08c298"
      ]
    },
    {
      "cluster_id": "f6ad38c8-1553-418f-93f5-4a6bb4909e2b",
      "members": [
        "c8b03c27-70ed-4cc4-abdf-0b332e2df9f5"
      ]
    },
    {
      "cluster_id": "aae30a17-ea30-48f8-8399-1f3de025df70",
      "members": [
        "6c536418-00e2-4a4c-830f-f6f6d96e6212"
      ]
    },
    {
      "cluster_id": "bfd2d9d2-8eb2-4ab0-b62a-1a71b069b6d5",
      "members": [
        "109ca1ab-5d13-4ab6-aee4-4f2533791c9c"
      ]
    },
    {
      "cluster_id": "2a09de37-e0d8-48a4-b6d1-8773f6d954be",
      "members": [
        "d2df8235-d61a-4ec7-bb0b-676cd6291b45"
      ]
    },
    {
      "cluster_id": "8af38eb1-9c6b-4cd9-9f2c-55e927900928",
      "members": [
        "26a229b9-735a-4968-a540-4738197bdf77"
      ]
    },
    {
      "cluster_id": "fbff695d-2102-476c-be9c-1ec2e2a34e99",
      "members": [
        "f8a77d22-871c-46b3-a5cf-dc89b4e6fcf4"
      ]
    },
    {
      "cluster_id": "68c5326d-ab98-438e-abd1-0e7a9ca85a98",
      "members": [
        "8e47d9e5-3537-4b6d-bc47-83cbb5ffc751"
      ]
    },
    {
      "cluster_id": "35dec8e7-d2c1-441c-82d1-0fb7c4ff2ec4",
      "members": [
        "25402d13-ecb6-491b-941f-43d94652249e"
      ]
    },
    {
      "cluster_id": "029ce0da-0ea0-4431-a895-310ff5fa4a56",
      "members": [
        "45ad507c-58bc-4146-b0bc-1acde214aa1a"
      ]
    },
    {
      "cluster_id": "54af5dc3-58d2-4d68-acb1-aa5f30ea62f0",
      "members": [
        "f29ae353-3af8-40de-a699-50235d37af51"
      ]
    },
    {
      "cluster_id": "0640a339-12f8-4d3e-8416-49b84425cfca",
      "members": [
        "cbc5e26f-f8e9-410f-8029-a182c58e7f57"
      ]
    },
    {
      "cluster_id": "00d7befc-64bd-4735-b672-5969c77fe7d6",
      "members": [
        "40bbd2b5-4d40-478f-a8e7-5b457a2b923c"
      ]
    },
    {
      "cluster_id": "a28912c7-742b-4153-9606-e82158276aad",
      "members": [
        "ea8e2e5a-a9dd-4526-a2cd-4a0f2c009522"
      ]
    },
    {
      "cluster_id": "5d815b32-3a62-41d7-bd5e-64e320d9507a",
      "members": [
        "26917ce6-9219-482f-a419-ecda95079e6b"
      ]
    },
    {
      "cluster_id": "344f9518-32e9-438c-95bf-e7b75fd500b8",
      "members": [
        "5b6f1824-6080-47bb-9bd9-545f522d2563"
      ]
    },
    {
      "cluster_id": "e157316b-b52b-4e59-beec-7a600ea2ef49",
      "members": [
        "abfc4d83-1cae-4bb8-9238-c8a5c9338043"
      ]
    },
    {
      "cluster_id": "c0322634-7754-4f2b-b97d-7786687b4f39",
      "members": [
        "bd3f8693-6a70-457b-9472-051a0ee3123a"
      ]
    },
    {
      "cluster_id": "3a723b11-9c69-4419-ba9d-ccab21e2fc24",
      "members": [
        "cc5c6626-cda2-4e18-b170-a6217c208baa"
      ]
    },
    {
      "cluster_id": "4d35ec7a-3721-4f70-b323-8070302a4c95",
      "members": [
        "8b090eeb-8bde-48d8-9cb9-d49beac3a162"
      ]
    },
    {
      "cluster_id": "e7ba1693-6646-480a-91d9-2e51aafb0261",
      "members": [
        "04a20f10-9af8-461e-9f75-106717eddda0"
      ]
    },
    {
      "cluster_id": "82abb955-d502-4dd6-84e4-ff5a58485230",
      "members": [
        "1bfed961-5720-4356-b6f4-d95c98c664e8"
      ]
    },
    {
      "cluster_id": "31aa44e4-52ff-4a6d-a593-c7d1153c5dc2",
      "members": [
        "e1bc5dee-6601-4bfc-b73b-ae86f55603ff"
      ]
    },
    {
      "cluster_id": "02ce3ced-8a21-496b-a44b-583010f8f279",
      "members": [
        "ed264221-5900-4c3b-a69d-1d1e819dfa15"
      ]
    },
    {
      "cluster_id": "fb0c78fb-f7a8-4921-9cdf-94739c1d1c3e",
      "members": [
        "8742072b-178d-4ccf-8e74-9e3c57ed6936"
      ]
    },
    {
      "cluster_id": "69cf6d84-6886-4dc2-b36b-3239cc3450b1",
      "members": [
        "3a53f701-0555-4825-9fb9-8eb7b3e437ef"
      ]
    },
    {
      "cluster_id": "1eb47b4d-d60c-4050-a6b7-0d4e6f499f8e",
      "members": [
        "590263df-0e92-4dd7-990d-600412ace6e1"
      ]
    },
    {
      "cluster_id": "9d847e57-5fc5-4cc4-8919-603e5c8d93d2",
      "members": [
        "e81f8871-f84e-4450-85d4-c8d87325236e"
      ]
    },
    {
      "cluster_id": "ddc5dfbd-77e6-466c-a4ac-12178d35c42e",
      "members": [
        "a937e249-b4d6-4608-9a79-32283b312294"
      ]
    },
    {
      "cluster_id": "e1b47a9d-415d-4c0a-a801-d747a6f31d9a",
      "members": [
        "dfe43826-3357-4dfb-9662-7b175bbad4fb"
      ]
    },
    {
      "cluster_id": "073ce102-b579-45e6-8aa7-6f1ca6f82280",
      "members": [
        "13e1784f-2708-40cd-b623-00bac0d8e2e1"
      ]
    },
    {
      "cluster_id": "e0017f41-b71f-4659-b94d-36fcb62cb736",
      "members": [
        "4ed31870-5df2-4a6f-ac03-b1ecbbd553d5"
      ]
    },
    {
      "cluster_id": "8f6347b0-b76f-45e2-b8d8-b8a8c9dc9e26",
      "members": [
        "22c9b0d7-d0b4-4cf1-950b-75d5a717ae6e"
      ]
    },
    {
      "cluster_id": "f083dfd3-1f0b-4469-b557-e14ab47deef4",
      "members": [
        "670ac9c1-bd3a-4135-8a85-df764f9ba9b6"
      ]
    },
    {
      "cluster_id": "03d40e2c-2130-4e6f-94d8-afd7a1bdc223",
      "members": [
        "d80ca0d8-3306-445c-a9fe-e292f5a0f281"
      ]
    },
    {
      "cluster_id": "637c1c25-6bd5-446b-89ea-dbb02add4b34",
      "members": [
        "621d1a29-309b-45ac-820e-e5b6c27b4f53"
      ]
    },
    {
      "cluster_id": "1622ce6e-697e-479a-95ba-4bfbcc9fd2c4",
      "members": [
        "614de7a2-fe04-47d7-99a2-bd83572fe921"
      ]
    },
    {
      "cluster_id": "ea0293f2-f4d0-4ae5-968c-0648ac0ad125",
      "members": [
        "1909b66d-439b-4cf2-9305-d96c12a1f137"
      ]
    },
    {
      "cluster_id": "af0e1637-dbe6-45fb-a04a-6bc7ad84725f",
      "members": [
        "02748681-3f84-4280-a169-627e0e591319"
      ]
    },
    {
      "cluster_id": "5bcb47eb-6ba9-4c85-9880-f3ab015417ea",
      "members": [
        "9a3741b7-9194-44e7-8593-dd9623d85773"
      ]
    },
    {
      "cluster_id": "34cd8ac5-1cee-4a93-bb46-48f954524f09",
      "members": [
        "0600aa2c-a25e-46f1-9217-9073c7c4a8c2"
      ]
    },
    {
      "cluster_id": "3b22f285-4b36-49a0-9e8d-cceb33235419",
      "members": [
        "dfa1261d-e732-4e6a-98fb-661c11837d82"
      ]
    },
    {
      "cluster_id": "add377ce-a507-4594-9a7c-9c1c608ed972",
      "members": [
        "785426c5-8fb1-49d8-96d3-ca5cc2e642fb"
      ]
    },
    {
      "cluster_id": "596b866e-0c38-462e-b0b0-eee502c092aa",
      "members": [
        "2bdc17db-1fc4-4641-83a8-1df42a5bc5f5"
      ]
    },
    {
      "cluster_id": "595a5404-b726-44ba-919a-07c9e6bedb55",
      "members": [
        "d27443a0-c153-4dd5-a58f-873c1c8c288c"
      ]
    },
    {
      "cluster_id": "0fae2f14-66ec-4594-b5a0-1588a0fa8339",
      "members": [
        "0e030dbe-883c-45fb-aeb4-a79d3e1efada"
      ]
    },
    {
      "cluster_id": "ce9cb999-3c9f-480e-9d89-8702d1c44875",
      "members": [
        "5c4a33d0-ae11-4848-ab7f-92b7f6656e0e"
      ]
    },
    {
      "cluster_id": "4e138416-b193-43f0-bd9a-8249fe6a1748",
      "members": [
        "dc91dcdc-d82f-4f28-9d6e-a9132909f1b2"
      ]
    },
    {
      "cluster_id": "2d4166ac-3dc3-45f4-a803-c8d77cddc0db",
      "members": [
        "fd99e615-cd03-41e8-ba27-8d4905da0e07"
      ]
    },
    {
      "cluster_id": "8eb3c499-d3ba-4d18-824d-8a2db9101923",
      "members": [
        "c373bead-d3a8-4bc7-a62f-cb894eb1cb73"
      ]
    },
    {
      "cluster_id": "a208cf67-b0d4-4139-aecf-8fec75c13ae1",
      "members": [
        "fabedc29-2132-4d32-a570-e39a997b3674"
      ]
    },
    {
      "cluster_id": "9ac8d542-8a25-4298-bb19-b93232c0319a",
      "members": [
        "e55109e1-cff9-4fb1-9079-03557de996f5"
      ]
    },
    {
      "cluster_id": "eee2bcf1-74da-4f68-9a16-f7f155a012a3",
      "members": [
        "ce012d51-5eb4-4a33-978b-a45c1c33b648"
      ]
    },
    {
      "cluster_id": "525ead27-9fb0-4fe0-aa10-52b70492601c",
      "members": [
        "2a3da052-2cc1-451a-ad49-b30e48ed2235"
      ]
    },
    {
      "cluster_id": "367b0f1c-f101-4396-807a-065b17daa4e8",
      "members": [
        "beaa5346-30a8-4eec-8020-92b8e46b9061"
      ]
    },
    {
      "cluster_id": "7fb1b61e-8a8c-43db-8218-8780b6b4a6d9",
      "members": [
        "e5df66d3-79dd-4a90-b930-61f103dd1f7c"
      ]
    },
    {
      "cluster_id": "ed212b87-d906-4b97-806f-edc87a49ab9e",
      "members": [
        "58c36d61-3ba0-41e4-8f19-73255bc7b115"
      ]
    },
    {
      "cluster_id": "27b6b422-e78d-44a0-8d01-c53970357062",
      "members": [
        "aa16c46d-0852-4634-a054-79960c11b758"
      ]
    },
    {
      "cluster_id": "4dc97343-8657-4d38-b2b2-1129b6d10818",
      "members": [
        "4c1758ec-337d-4cbe-86fa-8244d71c7d7e"
      ]
    },
    {
      "cluster_id": "c0713b5c-a570-4865-83c9-eb36c347abcf",
      "members": [
        "7c17e2ac-c892-4e72-866b-714bec4a49a2"
      ]
    },
    {
      "cluster_id": "bac748cb-b035-4e91-bb5a-ab935807284d",
      "members": [
        "b18bf41c-46b5-457c-a9b4-f8ac07e36180"
      ]
    },
    {
      "cluster_id": "61b4a043-a586-425e-a2f1-9e0b66e038e5",
      "members": [
        "29d4087d-19b7-4267-bf79-8789d90e480a",
        "f9b65679-1631-449b-b807-d1fd4da4746a"
      ]
    },
    {
      "cluster_id": "921fce8d-f4e2-4dbe-b940-66b148c09f17",
      "members": [
        "59013a8a-02c8-478e-9214-3f1e44cc7bb8",
        "cb5848bb-bde4-4f81-a8d8-dac5555f3d7b"
      ]
    },
    {
      "cluster_id": "fc3e8d2c-52bf-485a-a373-7853e3f353ec",
      "members": [
        "107d359d-42ec-4e77-8d57-506e01d2d46a"
      ]
    },
    {
      "cluster_id": "a70c5cd3-da81-4d6c-8001-3956de0c9692",
      "members": [
        "0f501262-611a-4a6e-9a89-2f9d95963b85"
      ]
    },
    {
      "cluster_id": "209b24c3-c157-4c8e-9d85-993e19c6b8bb",
      "members": [
        "d0f5121a-6a67-4dd9-b3f3-d97ff6bc7c84"
      ]
    },
    {
      "cluster_id": "b6fed6af-5368-4204-a338-2997b148a384",
      "members": [
        "0fc29109-1260-4ee9-acd9-5213faa70a4f"
      ]
    },
    {
      "cluster_id": "0368ead8-8d25-41a1-9249-88baff9335b0",
      "members": [
        "0210aeca-dbc0-42c3-8104-a3c02981d594",
        "7b17fc30-706e-4de0-9711-467e629d4a85"
      ]
    },
    {
      "cluster_id": "c6d927b7-cd5d-4d4f-8175-fa9bbd32a788",
      "members": [
        "84bdb65b-0a10-4d48-b2bb-f78fad599d25"
      ]
    },
    {
      "cluster_id": "7b19db75-3bd2-47e5-a306-0a2f241eda0e",
      "members": [
        "96bab82b-1f4e-4ec3-85c9-55062690b2a1"
      ]
    },
    {
      "cluster_id": "ae643b18-4610-445d-bb91-7a6e08099006",
      "members": [
        "e18fbea4-d7f2-4a5f-99f5-217aa876360e"
      ]
    },
    {
      "cluster_id": "3712fc59-da49-45a4-ae5a-90b1831dcece",
      "members": [
        "345b3179-253e-469f-89aa-87e71b1ea471"
      ]
    },
    {
      "cluster_id": "3f6ce9ce-e151-4a9d-92cd-88c52ef40373",
      "members": [
        "07b997fc-953c-401c-920f-f2dc1d0271e3"
      ]
    },
    {
      "cluster_id": "9f2f375c-af55-44d4-8d17-dfc761b029ac",
      "members": [
        "b9810a46-1616-44e1-9b2b-e9684548ec05"
      ]
    },
    {
      "cluster_id": "0d5b0cde-5145-4f38-a41d-e29b3956da5e",
      "members": [
        "f2e7cf6a-6482-4f9b-a2c8-98e89811400c"
      ]
    },
    {
      "cluster_id": "c4336836-69fe-4478-ae05-a9b8308b5fd7",
      "members": [
        "cbac83c2-8c95-46bd-a630-356ea7d83495"
      ]
    },
    {
      "cluster_id": "8985495d-c23b-4b4d-8af8-d412abf8767b",
      "members": [
        "f2812f10-9f02-449c-be8a-d14b8f7f31b0",
        "b8d26489-766b-476e-9288-afe066be5436",
        "2b6a71aa-4472-4e68-99df-a6a0eaf88087"
      ]
    },
    {
      "cluster_id": "ab98fd27-202d-413c-8332-5c4cfa41f02e",
      "members": [
        "1e3a38df-684e-48e2-a62e-3b767bade3aa"
      ]
    },
    {
      "cluster_id": "3b5c9589-43fb-428f-a24d-ff67c6ec3e67",
      "members": [
        "bd09c03f-ffcf-424d-b8b2-a9067f24572f",
        "59b4c0a6-0bf0-4b4e-ac15-bfba72030ec6"
      ]
    },
    {
      "cluster_id": "9b2ccd60-9fd2-4e0d-8e91-bb564023a0ec",
      "members": [
        "9ea7be29-7ac0-4db4-a44a-77f7e1b4a49d"
      ]
    },
    {
      "cluster_id": "9c0a11fb-cf7e-4f2f-b318-57e8160591d2",
      "members": [
        "0b66de36-7adf-46d0-b0d8-a3e6ddacc929"
      ]
    },
    {
      "cluster_id": "a6e5fc0b-7c5e-4adc-9bd8-8c5b7afb7918",
      "members": [
        "75f3a1a3-be94-48ab-a200-75e258aa57cb"
      ]
    },
    {
      "cluster_id": "0c515019-d4d8-4fdc-91ce-bd3ef7e8e081",
      "members": [
        "bc2852f1-4c0d-4924-a3e8-de82d6d55f58"
      ]
    },
    {
      "cluster_id": "c178db65-d340-471f-b632-8b8dad1a5b51",
      "members": [
        "a5c174fb-00f8-4888-bff2-2b22c08b6bb2"
      ]
    },
    {
      "cluster_id": "b40d77a1-3074-4669-a3a8-f64b6de7cd03",
      "members": [
        "1ab30c76-9d70-45bb-a0c9-9ba89ab29490"
      ]
    },
    {
      "cluster_id": "0c73bba4-2142-4833-ab2a-f7dd03c24dac",
      "members": [
        "6d3e772d-df2c-41fc-95f9-6ee4c1785af0"
      ]
    },
    {
      "cluster_id": "793d367c-aa36-4def-8927-25ed78dc0d58",
      "members": [
        "0b394128-bfde-44cf-9e64-cb31e8b2af0d"
      ]
    },
    {
      "cluster_id": "24f4b8ea-3738-41ba-bfa8-f9286f4d2dc5",
      "members": [
        "eb90c2b0-f999-48b8-a156-260fc24dc989"
      ]
    },
    {
      "cluster_id": "1e2e215d-02f8-41f2-bb72-8bb5cf8991d4",
      "members": [
        "b93daa23-81e7-456d-94d1-02ee6cb323d7"
      ]
    },
    {
      "cluster_id": "13d74323-84c7-4461-a516-d07ee1ee8c43",
      "members": [
        "b275260a-c1dc-4478-979c-ce4b9174a3ee"
      ]
    },
    {
      "cluster_id": "d2f70202-2b46-45a9-9905-a0ccfee90661",
      "members": [
        "93c43d4a-fd19-4e65-988b-70a133b08499",
        "f8a12006-8d34-44eb-913e-a0e4597ccf85"
      ]
    },
    {
      "cluster_id": "31c69d86-6651-4ebe-ab2e-087bf7193e24",
      "members": [
        "66aeb4da-a41f-4447-b443-d3adc2c80766"
      ]
    },
    {
      "cluster_id": "669c3dae-6d04-400f-a1f0-a3b10120d902",
      "members": [
        "2c93e391-b1d7-4f0f-b9a7-0f1628f74cb9"
      ]
    },
    {
      "cluster_id": "f97c3788-df6a-4dd4-b544-6d0397d5953e",
      "members": [
        "140e89c6-1a07-409a-ab9a-52ec6b34998a"
      ]
    },
    {
      "cluster_id": "ea56561a-6c42-424b-a439-8949e0922884",
      "members": [
        "318a1f17-6477-4696-9106-44c6cafb8309",
        "10f7556d-46ff-442b-824c-344e5364e305"
      ]
    },
    {
      "cluster_id": "fff91b42-2999-4568-8b58-028bf8ca7046",
      "members": [
        "ddfa596f-da0f-4830-a839-c04542e52164"
      ]
    },
    {
      "cluster_id": "16220929-8aa1-45e6-9f5e-8401f7ed50de",
      "members": [
        "34d32d01-b9da-4558-aca2-018ef1620429"
      ]
    },
    {
      "cluster_id": "edae4987-7374-49c7-bd0c-6f6522213435",
      "members": [
        "a6c3e47d-8078-4640-ae31-397e6e88ebd5",
        "5c6f0588-995c-4d20-a836-02ac80210bf5",
        "a8ae2e4b-0ae8-47a0-8895-855189d37016"
      ]
    },
    {
      "cluster_id": "6eae9125-d91f-4554-8584-e619f1d7940e",
      "members": [
        "865c7c98-d8e0-4383-b0a6-ccf0a86c51e9"
      ]
    },
    {
      "cluster_id": "06d90458-c93e-4ddc-a393-97e8e0d06f91",
      "members": [
        "17ca6691-ccb7-40b4-b9a6-7145b0127e0f"
      ]
    },
    {
      "cluster_id": "08a5fea6-9542-4505-b3ba-04e342c44cbf",
      "members": [
        "d8ca6006-36e6-45ea-8307-1deb0c49b00d"
      ]
    },
    {
      "cluster_id": "2fc3625d-65ed-4d3b-9894-40d3d2d23ece",
      "members": [
        "d815205f-8cc2-4afb-aa3c-c0e6d70f107a"
      ]
    },
    {
      "cluster_id": "8dafb957-e3d4-421d-a897-aa9e9def3c15",
      "members": [
        "78221e24-b79b-43e4-a541-ad1ca0076618"
      ]
    },
    {
      "cluster_id": "f1b5b82d-47e0-49c5-b861-5e41e68dc753",
      "members": [
        "0d304d53-0699-4bac-bf54-d0c96ac245cb"
      ]
    },
    {
      "cluster_id": "e493e014-2ee0-4066-9764-e3019f7467b2",
      "members": [
        "4abe3741-e47a-4a37-bca4-d5f10b6ed2cb"
      ]
    },
    {
      "cluster_id": "7234c7f2-ec56-436a-abe4-d72c2e651247",
      "members": [
        "5b97d9af-c5cd-4efc-9502-6bf1fabde9d7"
      ]
    },
    {
      "cluster_id": "31416837-c17d-49fc-a841-b231a9f41ff6",
      "members": [
        "853c041e-9df3-4b29-a61e-74c8772e02d6"
      ]
    },
    {
      "cluster_id": "d494f4b2-e7a8-444d-9de4-a124202cacaf",
      "members": [
        "ac495448-6773-45ff-afe1-a285915c6f3f"
      ]
    },
    {
      "cluster_id": "2f8e7728-120e-46dc-8103-038ff1bcf8a0",
      "members": [
        "f23f41f3-49f6-4043-a4d4-56791c2a1d06",
        "92768a75-9f7f-4ab9-8595-46aa79de7699"
      ]
    },
    {
      "cluster_id": "9d6d3278-c0e4-4003-a311-bf3945445bf7",
      "members": [
        "984b86ec-b655-469a-9772-7d7780484415"
      ]
    },
    {
      "cluster_id": "5b750f94-6101-4383-bd0d-c980ad3ff8c2",
      "members": [
        "725c1c14-9fcd-4f5c-95e1-9590c9ef59d7"
      ]
    },
    {
      "cluster_id": "7e9c2165-775e-4ecd-9551-bc96f366f674",
      "members": [
        "cf29b817-5617-4b44-aa05-a0df376f7442"
      ]
    },
    {
      "cluster_id": "479e911e-126f-4188-8866-356ae46aef5b",
      "members": [
        "dcfb1112-c28a-4939-9d66-40a5f9e67ec2"
      ]
    },
    {
      "cluster_id": "0ebcd390-0474-4d90-81dc-d03c9dac78e4",
      "members": [
        "9232d564-a2b3-4587-a80d-ae2a5dc0f7ec",
        "a3431b87-2276-445d-8261-ac070ad38875"
      ]
    },
    {
      "cluster_id": "ba39c004-53dc-4528-9f07-025d10ba4bfc",
      "members": [
        "60f2f09a-e48e-4b26-a07a-ce54f4efb8be"
      ]
    },
    {
      "cluster_id": "80a198cc-8757-4f4b-9e5f-ba483e92361e",
      "members": [
        "ceb0101b-f929-4ecd-b350-8037db80fcf6"
      ]
    },
    {
      "cluster_id": "13c0f70a-404a-4747-9850-32c93df93caa",
      "members": [
        "dc455af0-4a77-4516-95aa-318963561a03"
      ]
    },
    {
      "cluster_id": "174ff9ad-6286-41da-ad67-0696f7875e1b",
      "members": [
        "6fa349ee-fdaf-4995-9580-28548d92c92a"
      ]
    },
    {
      "cluster_id": "0dbd4f26-ef42-4c5e-a16b-4529c5e0d566",
      "members": [
        "4067786c-a9a9-4504-ae37-8f00d85fa380"
      ]
    },
    {
      "cluster_id": "138ee12c-cc52-4ab9-bc9d-3ad91e9008d8",
      "members": [
        "cf7e4df3-4d73-45a5-a65a-42d1a2a5caf3"
      ]
    },
    {
      "cluster_id": "325144ea-ecb8-45ca-8169-6bfec35e02d6",
      "members": [
        "5c549537-68db-436e-b803-7f7040d989fb"
      ]
    },
    {
      "cluster_id": "dd63046f-83c4-4d5e-867a-2f14376d2ce2",
      "members": [
        "e75a2f44-5442-4d31-b8fe-35119a74d3c6"
      ]
    },
    {
      "cluster_id": "c570bea5-83d0-40f8-b228-3cf401722ac2",
      "members": [
        "cf0e1b85-b67a-4948-92f4-77b2300f4602"
      ]
    },
    {
      "cluster_id": "dd0a9eb8-6da6-4108-8f70-358d100bdfcb",
      "members": [
        "8756e902-2bbc-4510-8db0-127a384594ef"
      ]
    },
    {
      "cluster_id": "991ffbe8-307f-44da-878c-ba99ad7d9638",
      "members": [
        "9867fa2f-2d7f-4fe9-819f-6b125733fd08"
      ]
    },
    {
      "cluster_id": "6ce879b9-5872-4b84-9034-d22bedf950a0",
      "members": [
        "1ba67de0-3a50-4fd0-8935-215e201931da"
      ]
    },
    {
      "cluster_id": "b995b076-2b5f-4341-abf4-0732ccee4318",
      "members": [
        "ae54faf8-0a6a-4db8-b437-7710c0bce29c"
      ]
    },
    {
      "cluster_id": "1352067a-0981-4dfc-bf7b-193db2160af5",
      "members": [
        "d71b1d68-136b-401e-9be7-e317457e7d72"
      ]
    },
    {
      "cluster_id": "ebc26e14-b86c-4a50-a196-d8cbcc8aab8c",
      "members": [
        "7296af18-7182-4ad9-8e86-af7045ab2218"
      ]
    },
    {
      "cluster_id": "d1102194-5143-42ba-aac4-2f29e4d13736",
      "members": [
        "18a11fb1-e4fe-4210-932f-b340cea2b154"
      ]
    },
    {
      "cluster_id": "da696f76-5f89-4c8f-bcd4-42e52baed665",
      "members": [
        "bffa392d-838c-48bc-ab7d-e67e0f896155"
      ]
    },
    {
      "cluster_id": "be927411-ac53-461c-bb59-5232d4963861",
      "members": [
        "58c4f36a-d1e0-4676-a897-c83e02e84a19"
      ]
    },
    {
      "cluster_id": "14266895-ce35-4bb7-b24c-c5684c3a1532",
      "members": [
        "9186ed71-5a4c-44b5-8c29-b644072d50f3"
      ]
    },
    {
      "cluster_id": "3d43abac-8178-4ce6-a910-10e135a5266f",
      "members": [
        "139677d6-2d70-4fca-9c76-d69fae62656b"
      ]
    },
    {
      "cluster_id": "4f0e7f6a-d847-4db7-a78d-684ba6b33ce7",
      "members": [
        "e70794c7-1f61-4fa1-a956-d58bf8a67c02"
      ]
    },
    {
      "cluster_id": "2f7d7b19-3996-4824-8b2e-60b30c5d543d",
      "members": [
        "5e1c916f-f839-4e2c-a1ac-1876dcaa95a0"
      ]
    },
    {
      "cluster_id": "6ff6589f-46b8-4e3d-bfc9-65288f58e33b",
      "members": [
        "900a8533-a169-4295-9576-1e08839a4aaf"
      ]
    },
    {
      "cluster_id": "530c303c-a794-4be5-bbc2-ff618ab75d38",
      "members": [
        "a9161d70-4ab9-4fae-b953-1445e2713d7a"
      ]
    },
    {
      "cluster_id": "65fcd3e0-1f44-416d-b2cc-adb2b3a6c31b",
      "members": [
        "5749d3e4-6c81-44c4-8809-9f9327c7ebab"
      ]
    },
    {
      "cluster_id": "18a83b13-1adf-4e6a-9783-cc45f9fd9c79",
      "members": [
        "7af08beb-2910-4d2e-b488-0b5b72ab8c52"
      ]
    },
    {
      "cluster_id": "3feb2513-5eb4-45bb-8249-92697ca5ccbf",
      "members": [
        "6006ac32-7f50-414e-8a5f-bce4e8739ce9"
      ]
    },
    {
      "cluster_id": "46dc68c8-60bf-4c63-8f62-da2eefecf05e",
      "members": [
        "6b180a9c-1f42-41b4-9631-3cb6b8085d98"
      ]
    },
    {
      "cluster_id": "69365007-aabc-4f8e-a4e7-3ac92aef1b47",
      "members": [
        "d14997d7-7c3d-4360-85e9-3ab9ca2bdbc7",
        "1c7fbe04-ec94-48b6-9c05-105d999c6553"
      ]
    },
    {
      "cluster_id": "975e2d06-2cf2-4b51-9705-f9ba57cf3e1e",
      "members": [
        "4218b537-7ace-44d1-98d2-9405a2047fff"
      ]
    },
    {
      "cluster_id": "4da675eb-3ccd-4c4a-852a-837897424712",
      "members": [
        "e948ea83-3f58-40b5-94af-f58552982c89"
      ]
    },
    {
      "cluster_id": "e285d3b2-02ce-4dd4-ad86-ac99b2199a66",
      "members": [
        "eea6c4f9-4a35-4400-95ee-9ab50ec658a1"
      ]
    },
    {
      "cluster_id": "b95f4f5f-4d51-43a4-8c27-5ed3609dc286",
      "members": [
        "b766d337-3425-459a-a20b-64921b60ee7a"
      ]
    },
    {
      "cluster_id": "5e59f3a9-c776-4791-b6c4-d58d75f185a7",
      "members": [
        "4417eab2-d162-47a3-868d-6d0e56e56239"
      ]
    },
    {
      "cluster_id": "9f9c5798-7130-4fb5-8328-ae0dad688f2e",
      "members": [
        "9b61ce15-d372-433d-8b4c-cb23419b4c82"
      ]
    },
    {
      "cluster_id": "a808e761-ea60-4cbe-9954-1bbb279e628e",
      "members": [
        "95e7740e-7f3f-4e83-84d3-9e1c8c0b03f9"
      ]
    },
    {
      "cluster_id": "86f9f906-a751-49c5-9fab-90ea9e810607",
      "members": [
        "aec06af5-63df-4aed-bd46-53ed07ff420c"
      ]
    },
    {
      "cluster_id": "9162951c-ce7d-463b-9880-335cc6cb0f80",
      "members": [
        "cf59c68b-1168-4108-9634-206a5f6873bd"
      ]
    },
    {
      "cluster_id": "40cf4646-a4df-4be7-91e4-7dd54f7d4c16",
      "members": [
        "384f6de1-57e4-4ee2-93d3-3eff97c7f3f9"
      ]
    },
    {
      "cluster_id": "f6d37781-75af-4b37-a9b4-49dbc27efba1",
      "members": [
        "12a6796a-b0a7-4fa4-8f6f-5a6b53db5c76"
      ]
    },
    {
      "cluster_id": "1a4ac437-0820-43b9-93ff-945d37e52289",
      "members": [
        "cafe9cf0-f603-4413-982b-454c48421ca9"
      ]
    },
    {
      "cluster_id": "7688d917-39a4-49c8-8503-8ffed77c6807",
      "members": [
        "de2e5971-af07-4798-bbf8-9f1a15702d82"
      ]
    },
    {
      "cluster_id": "c9c64be3-e960-4772-bfe7-2c746234f3c3",
      "members": [
        "c5cf44c4-4233-448f-b586-0f50146cc0b6"
      ]
    },
    {
      "cluster_id": "50df15a2-0759-4dd5-ad88-d8f125de1938",
      "members": [
        "de2a44e6-f54b-4173-9d05-f8ca1c562304"
      ]
    },
    {
      "cluster_id": "1e3fd423-7c99-4849-95a3-92cb0dc03a82",
      "members": [
        "3c509fdc-1d85-4f81-affd-1aa97f89c3ea"
      ]
    },
    {
      "cluster_id": "1b1dc316-6caa-4e05-8920-919dfeb09b67",
      "members": [
        "eeda5ffb-dc48-4a5f-b7a3-ef006537a7b1"
      ]
    },
    {
      "cluster_id": "22c9858e-9aba-4253-8fc8-8d1d83a938f3",
      "members": [
        "8566fd4c-45b9-46eb-845c-f0bd362c0aec"
      ]
    },
    {
      "cluster_id": "b29164d7-a1d8-4a41-a952-b0d04cde6fa1",
      "members": [
        "2c0baa6b-7f4f-4feb-b924-7b97eabe182e"
      ]
    },
    {
      "cluster_id": "079ea0ae-5460-44fd-be95-17fec28e2122",
      "members": [
        "eb40bccd-ad4a-432b-9caf-b95812c43721"
      ]
    },
    {
      "cluster_id": "924eda57-f860-4947-b8f8-b55352cbd0d8",
      "members": [
        "9ee8d736-3deb-4c91-b996-707bfa71c95e"
      ]
    },
    {
      "cluster_id": "14a0f558-9894-4d04-9b27-d9a6b3531c2c",
      "members": [
        "a8467897-9ea8-42cb-9988-97b34c32c24a"
      ]
    },
    {
      "cluster_id": "5d2a23b8-6ca9-4894-b0bc-a3b5c15dbf42",
      "members": [
        "f73b0473-d7fe-4c01-b046-e854e955a1b6"
      ]
    },
    {
      "cluster_id": "bc727b98-bf68-42be-b2de-84ffed053ccd",
      "members": [
        "fd69e6d0-bc5a-4945-a092-e49c89bdef11"
      ]
    },
    {
      "cluster_id": "ead9bd7e-2c4b-46c5-b951-360707780eb3",
      "members": [
        "a40d51bc-33fe-45bb-beb4-197580111591"
      ]
    },
    {
      "cluster_id": "56102e40-6707-4ea5-b706-a21ac4c3fa0a",
      "members": [
        "1f571773-a119-4b69-bb0f-e9dd9f0458f9"
      ]
    },
    {
      "cluster_id": "df289945-6d20-4db8-b12c-27190f4319e3",
      "members": [
        "3fb25a3c-74db-43ca-a199-f3b679d401e5"
      ]
    },
    {
      "cluster_id": "3195f0c6-475f-480b-9f8a-4aa8231b8b3c",
      "members": [
        "ba0128c9-056c-431b-acd4-0e45d9a2602a"
      ]
    },
    {
      "cluster_id": "700f4caf-4655-44d6-adcf-68f6a654752b",
      "members": [
        "8335a29a-9177-4886-8913-7e0ec1819ab9"
      ]
    },
    {
      "cluster_id": "73900380-dcd7-40a9-bff7-af4dd25e907d",
      "members": [
        "4dbd090d-99e8-4241-892a-8f82bc069b3c",
        "e8cef964-44ce-4e1c-9aa6-22f1e4bceecc"
      ]
    },
    {
      "cluster_id": "dd335f66-9180-429a-8e21-b0e59da84aa2",
      "members": [
        "3cac4f82-dbc7-44f7-8ddf-b9626b06553b"
      ]
    },
    {
      "cluster_id": "9b14b6b9-92d5-4da7-813f-eb820b5a4071",
      "members": [
        "ef40cf5a-0ee6-4558-aade-5a61b53b4651"
      ]
    },
    {
      "cluster_id": "ad25bdfe-5d0f-4c75-8f1b-cb123f11cb06",
      "members": [
        "542cf79a-84c2-4e1e-b5f4-5192d3aae3af"
      ]
    },
    {
      "cluster_id": "c1018981-9883-4b7e-8f5e-7f4837994e54",
      "members": [
        "adae471a-5fe3-404e-82bd-033d9d35bc19"
      ]
    },
    {
      "cluster_id": "063191cf-9936-4d33-8783-201496475d0e",
      "members": [
        "acb3e29c-8b9b-4d65-84d9-b6150af17e1b"
      ]
    },
    {
      "cluster_id": "33378b17-6e0e-486d-a122-a219ecc02e56",
      "members": [
        "bed08933-be98-4d9a-9300-806b428a35e5"
      ]
    },
    {
      "cluster_id": "2032d3f2-f2a7-4cd8-9f0f-0fb6fbfe2fc9",
      "members": [
        "3c3516c5-011e-4b47-9eb8-cafee3504cda"
      ]
    },
    {
      "cluster_id": "09a252ec-4d97-4380-a535-1e7222c476ea",
      "members": [
        "6380b9a7-b8f7-49c7-867a-0b0529f09f20"
      ]
    },
    {
      "cluster_id": "402b3ff3-63dd-42e9-9d2c-888f81934ca4",
      "members": [
        "f3a9bff8-828a-4118-889c-5006a1d45963"
      ]
    },
    {
      "cluster_id": "cd51f6af-e3ac-4df3-b356-fdbeb2599d37",
      "members": [
        "8994ae42-a469-4d04-aef2-9892dfece0ec"
      ]
    },
    {
      "cluster_id": "59ac47e6-50e9-4884-a676-2542dc8e0aa3",
      "members": [
        "ff68c6bc-a3d8-4051-aaf4-2e4949c54c42"
      ]
    },
    {
      "cluster_id": "389db9cc-996b-4a34-8f9a-361c5c8aa5ee",
      "members": [
        "3672d7e9-03cd-4914-8bea-500a7184d930"
      ]
    },
    {
      "cluster_id": "e450bc0b-1319-494c-b418-fa5dced99fad",
      "members": [
        "d8e1da89-224c-4a1c-931c-46d998d07095"
      ]
    },
    {
      "cluster_id": "c183c1f7-56d7-457d-9d98-1df02c7330bd",
      "members": [
        "b9ebc8be-5976-45fe-96ca-c44cec68333f"
      ]
    },
    {
      "cluster_id": "ffccc68c-8962-496e-be7a-e09d954b9f4e",
      "members": [
        "523bb635-cdad-48be-a47f-38f6e33d4588"
      ]
    },
    {
      "cluster_id": "2d61e1a4-f82f-42d3-8440-ae35b51fa374",
      "members": [
        "458966e5-0956-4973-b03b-c5cc3028417f"
      ]
    },
    {
      "cluster_id": "88b53ede-d736-4ed2-9eb5-d53fe706d4c1",
      "members": [
        "d05082ca-4118-4750-9e59-3caabb1f72b0"
      ]
    },
    {
      "cluster_id": "909f6739-4757-4400-a81c-4fdb3bbaad77",
      "members": [
        "9b5d28dd-276e-4d6a-af5a-69614fe5b6fc"
      ]
    },
    {
      "cluster_id": "6bd1a1b9-8c5b-4543-9007-11872574ea9a",
      "members": [
        "5d7cb6c6-c732-43bb-9df3-aada3e38d660"
      ]
    },
    {
      "cluster_id": "91533351-01ef-434b-b8d2-ca94698271b1",
      "members": [
        "27cfb698-04cd-4ab9-ac6d-56207c48fec7"
      ]
    },
    {
      "cluster_id": "72297da3-3cc9-4cb4-a16b-56592581749c",
      "members": [
        "ac90fed3-bc85-4e29-a5e3-e3852870bd1b"
      ]
    },
    {
      "cluster_id": "6a38e03b-c385-4edf-9cff-c8c006c566e3",
      "members": [
        "66a43457-3d8b-4300-b113-987ff3935451"
      ]
    },
    {
      "cluster_id": "a9a48f40-5af3-4e72-b9f7-5b25295964a4",
      "members": [
        "13db7249-b755-4f82-b994-bace920bf919"
      ]
    },
    {
      "cluster_id": "683abff9-679b-4270-b05d-4394a56a60b4",
      "members": [
        "7cb30f02-ea7e-483a-ac7c-9449553c6bed"
      ]
    },
    {
      "cluster_id": "33c3bbfc-4975-4a68-9abe-5dd608b4ec62",
      "members": [
        "d3077dd1-f47d-4350-9a4d-dd1b33e2a59d"
      ]
    },
    {
      "cluster_id": "2ed0e84f-d233-4164-b228-6208473d317d",
      "members": [
        "2e2d89d2-803a-44e2-8a92-a2628ae2454d",
        "2a5f7b1f-2bcb-48ea-84c8-82d1106b3c3f",
        "94e0f17e-33bc-4bef-98af-b586a683708d"
      ]
    },
    {
      "cluster_id": "0c8a0c77-de1d-4094-93a5-9ea4a0ec06b4",
      "members": [
        "8b6dbb3c-a32a-4feb-a3e0-41e11f84d8fa"
      ]
    },
    {
      "cluster_id": "4c1d018f-90d0-4f64-b7e5-c3877ba4474a",
      "members": [
        "fde782d9-9fd7-487c-adf4-3e4592d9493b"
      ]
    },
    {
      "cluster_id": "a04779f3-83fb-4f0a-a9f8-fc91c7dd0fc4",
      "members": [
        "8dd64eac-5d24-4388-aebb-09184a58300f"
      ]
    },
    {
      "cluster_id": "0005306c-9f05-4c24-afc9-11ea1bc90d4d",
      "members": [
        "f34149ca-790e-498e-85fd-747e2561dc0c"
      ]
    },
    {
      "cluster_id": "81c0ca50-4b77-426d-ae3a-c52b1a992539",
      "members": [
        "f8d87d4c-c6fd-4540-89e1-a95b51cdd11a"
      ]
    },
    {
      "cluster_id": "4fa8e557-bb3e-4afa-89cd-33ec7b315e73",
      "members": [
        "305e3a42-a8f7-4384-8727-a8b2837b3ee7"
      ]
    },
    {
      "cluster_id": "d19dc1b6-21b1-49bc-aaf1-fb24f7c66396",
      "members": [
        "097db6ca-eb11-44c5-adf8-a71db915c3f8"
      ]
    },
    {
      "cluster_id": "825bdd3b-f63b-4beb-b324-b276b6d235f7",
      "members": [
        "058195ec-069f-4af7-a0fc-c241d129f928"
      ]
    },
    {
      "cluster_id": "3cb0e39c-2e4c-43dd-b51c-bd5e065c7bd5",
      "members": [
        "56942172-4f15-41ef-b903-cb1459c846d2"
      ]
    },
    {
      "cluster_id": "df416ca2-a7ac-4dad-9783-c3e29d3f4084",
      "members": [
        "42c7e95a-5884-4619-99f5-e3ff70fa2154"
      ]
    },
    {
      "cluster_id": "9dafd873-19fe-4111-b162-3c6894ed8aa4",
      "members": [
        "c207827d-9d99-4f9b-888f-f91c5a2ea551"
      ]
    },
    {
      "cluster_id": "55dd7d4d-d0df-496a-b949-1f305611420e",
      "members": [
        "5fdbeaa7-2027-4559-bbea-f5f3db8a3408"
      ]
    },
    {
      "cluster_id": "9179b891-9dc1-45be-ab4c-6b2e9fbc156a",
      "members": [
        "d7d4d4a8-0021-4af4-aa40-a7aecde69956"
      ]
    },
    {
      "cluster_id": "ff420a7c-e6cc-45a2-bf06-8ce6ac712e7b",
      "members": [
        "276c9734-ff08-4830-8f40-0007568e0ee6"
      ]
    },
    {
      "cluster_id": "f7e1186b-2980-41a7-bab5-cf7ae1ee1caf",
      "members": [
        "92dbb386-e617-4d97-9c27-c509b8ae9d5a"
      ]
    },
    {
      "cluster_id": "f48f090b-b925-4ff6-946c-dfbb77137193",
      "members": [
        "efdd41cf-9be8-405d-8dbc-e5c76227a9dd"
      ]
    },
    {
      "cluster_id": "9e24e052-7c2e-4232-a3f6-f90915a205eb",
      "members": [
        "c71fbc94-fa99-4abb-a66c-e2701d9c67ea"
      ]
    },
    {
      "cluster_id": "590d0c11-1909-4486-98ca-6247b1d6bae0",
      "members": [
        "b894c62e-7e2a-4f49-b93c-8c019edb1b6c"
      ]
    },
    {
      "cluster_id": "59906f79-e6e8-4390-a382-ef5bd2f7fff2",
      "members": [
        "0b0162cb-a1c8-49a5-841a-98214bc000d3"
      ]
    },
    {
      "cluster_id": "c84778ea-ef3a-409f-9105-f5f4a9c3f19d",
      "members": [
        "b8be2070-d07b-4283-86e3-1b49f50d697c"
      ]
    },
    {
      "cluster_id": "adb13810-0226-4fb2-9c77-e2af38089b83",
      "members": [
        "b6d91b71-04fd-4967-9a42-d4e4348dd2b7"
      ]
    },
    {
      "cluster_id": "4a8a1810-6ec2-40d6-8159-dfec11d084c9",
      "members": [
        "0f703776-b87a-4ba4-887e-cf1e9cef8a8a"
      ]
    },
    {
      "cluster_id": "a4d467e0-6666-461c-8177-8b0173dc05e3",
      "members": [
        "e6965eb2-6707-4743-bba9-e2f55128db0c"
      ]
    },
    {
      "cluster_id": "4dd4cfc3-9e42-4844-9174-8c971ece9bc4",
      "members": [
        "48e9783a-c3e4-4fbf-9741-8c5b30bd9098"
      ]
    },
    {
      "cluster_id": "9e87fb61-486a-4192-90bf-f05ee1b73406",
      "members": [
        "e5cfd380-706b-4af4-b638-56533d6cb180"
      ]
    },
    {
      "cluster_id": "c974a5fd-a8a2-42a7-88dd-b3f3e7fd1ad6",
      "members": [
        "67275948-5c00-497f-bff2-9ded64b9afd0"
      ]
    },
    {
      "cluster_id": "d7761b4c-72e0-44cd-b341-d16d8d7d63d7",
      "members": [
        "1fc2906a-4c9a-4530-ada6-424bf52e2b3e"
      ]
    },
    {
      "cluster_id": "4941b2f5-904f-4963-b690-18f3bf3075c7",
      "members": [
        "bc846d24-6358-4f50-9da0-6f37026b1164"
      ]
    },
    {
      "cluster_id": "d7adae26-7c5e-4cae-86db-8ddd899b1a73",
      "members": [
        "5d55214d-c331-4e56-ac03-0c5544cd5118"
      ]
    },
    {
      "cluster_id": "0500f877-c2d0-4c97-b0d7-76dc88e38eae",
      "members": [
        "28a28ac4-d5b4-4d98-8f7e-c8c3bee9802d"
      ]
    },
    {
      "cluster_id": "e6a8f39a-ea50-45d0-aa2c-f24fddc8d1e3",
      "members": [
        "159a1577-f120-44d3-acd4-9256546ba197"
      ]
    },
    {
      "cluster_id": "59c32196-c345-4e2c-9ab5-46cd4d040be1",
      "members": [
        "3208a2e6-8017-4011-9caf-ae4d6d4eda38"
      ]
    },
    {
      "cluster_id": "2c68a882-a903-4629-aeb4-3d0034f94771",
      "members": [
        "7d282275-0ef0-4981-aaae-07a25a4cc2d7"
      ]
    },
    {
      "cluster_id": "06f36d72-4a36-4a11-89bc-28713f0d3ba2",
      "members": [
        "1063213e-2698-40c3-8381-4586e469f8f3"
      ]
    },
    {
      "cluster_id": "07ffad90-34a3-4066-8c33-1761dfb6597a",
      "members": [
        "3682026f-f1f4-4c55-9007-6b73fb162e88"
      ]
    },
    {
      "cluster_id": "73478ef3-3b02-4aa4-bc0d-55174048efc5",
      "members": [
        "9a92b1c5-d64b-4a8f-bff3-9d8cda00b308"
      ]
    },
    {
      "cluster_id": "414a7988-da74-41bb-927b-725b66698cd7",
      "members": [
        "8cc23ae4-e70f-4570-bf83-5c2302b65dea"
      ]
    },
    {
      "cluster_id": "f5a99e33-6c8e-438b-9a1b-7d2b95dadd27",
      "members": [
        "d651504e-7fd0-400c-a45a-bc201d982e7f"
      ]
    },
    {
      "cluster_id": "3a46ccfd-5379-4ef0-aa09-8a1b6a5f409e",
      "members": [
        "c1d3a62d-f31c-41f0-861d-08cae4ea448b"
      ]
    },
    {
      "cluster_id": "0a9d0582-fd67-429b-b378-1ed79f7e66aa",
      "members": [
        "3b1c36c8-803b-475c-8fe3-1f57b4d5f437"
      ]
    },
    {
      "cluster_id": "0817085e-1f3f-40ef-a848-4b066c225ffe",
      "members": [
        "ca9e16c0-b200-44cc-b1bc-b776e3da81ce"
      ]
    },
    {
      "cluster_id": "46c103db-5ea3-4b23-91e9-342a8a2c0506",
      "members": [
        "03572d67-6c26-44ca-8afd-20dc0ac1ed0b"
      ]
    },
    {
      "cluster_id": "0313a78d-59e1-4fe7-8d40-5db79d99214e",
      "members": [
        "079bb245-d14a-4c7a-805a-0fe7162f6abd",
        "70dffb54-a419-4552-ba31-79e7a21bdabd"
      ]
    },
    {
      "cluster_id": "f4bded1f-3dd1-4137-af03-3dc33133634e",
      "members": [
        "e0c9f39d-5831-45a1-830b-2a67218024c1"
      ]
    },
    {
      "cluster_id": "9555579e-0753-4a7b-be6a-da884e2c8547",
      "members": [
        "6b3ae583-1ea9-4b3a-b5bf-f35462415eff"
      ]
    },
    {
      "cluster_id": "5326cc13-3625-47b1-ad75-82ef998d0dce",
      "members": [
        "ef160d98-8f47-4fc5-8cad-1903cedc1f3b"
      ]
    },
    {
      "cluster_id": "58cd02fb-21db-4abe-ae72-bb8a28bb5670",
      "members": [
        "0dc7ae0a-7caf-4637-9106-b9ac247f37cc"
      ]
    },
    {
      "cluster_id": "6d2a3a04-ff69-40ca-9d0c-a4d79e8318bd",
      "members": [
        "6f5ed3cd-536e-4444-9e06-51eccbcf6a6f"
      ]
    },
    {
      "cluster_id": "80b5a69e-5f2f-4b54-a7e5-680323a8c096",
      "members": [
        "3409a217-a4f3-4f60-9101-52c1f87b9ab1"
      ]
    },
    {
      "cluster_id": "4c6fd3f2-5818-45f3-b8d8-85a9b9075f57",
      "members": [
        "ab4a0b17-1983-4011-8f28-2e73ed350490"
      ]
    },
    {
      "cluster_id": "e828a029-7aa6-4aae-b53b-df9804b3b858",
      "members": [
        "dc40a4e2-8449-44e5-b295-6541d540d7e9"
      ]
    },
    {
      "cluster_id": "32697b9c-6810-416a-bedc-25a1c14600c3",
      "members": [
        "a396cbb1-fb21-4080-86c7-b19d02400f19"
      ]
    },
    {
      "cluster_id": "1754af66-54e2-4f11-bdb1-7f116f325d12",
      "members": [
        "4cfee40f-c632-4d7e-adf7-57b73b8f2ee7"
      ]
    },
    {
      "cluster_id": "8649324d-646d-4eb1-97c6-070697056cd2",
      "members": [
        "dcd5db79-1f5c-47b9-8191-7ed0df646471"
      ]
    },
    {
      "cluster_id": "162d37ea-ce13-4d19-9a98-bb0e66720cc0",
      "members": [
        "1c66cc00-9fd5-477e-932c-30917929823a"
      ]
    },
    {
      "cluster_id": "776ed0c0-bfbb-420d-8369-ebf0e4544c64",
      "members": [
        "53564956-1238-4060-98a5-a257a368982d"
      ]
    },
    {
      "cluster_id": "f78fd02c-7e3c-43a4-8429-a28909b13242",
      "members": [
        "a16e1903-461c-4506-8861-3d7902f86cd2"
      ]
    },
    {
      "cluster_id": "544fb937-88d2-4ddb-9c06-1ae58af8be2b",
      "members": [
        "3c19d2a4-f513-41a5-8faa-2464e56c7bd9"
      ]
    },
    {
      "cluster_id": "2c6352c1-d120-47aa-8825-a58359bc7c7c",
      "members": [
        "a088dd02-6770-44a6-8d0e-c8ad5aec1597"
      ]
    },
    {
      "cluster_id": "6d9d5966-6987-45bd-9e4b-02623878d470",
      "members": [
        "5ec788d5-61e0-4e9b-a95e-da9cde6d8fc1"
      ]
    },
    {
      "cluster_id": "e0696dc9-5406-4bfa-a327-9114afed84e2",
      "members": [
        "bf8bb868-6a19-4b48-b3e3-e2d83c57bffd"
      ]
    },
    {
      "cluster_id": "e9cee2c7-a58e-4a2b-a37b-7da09539aea3",
      "members": [
        "28386613-34b5-4c1f-94d2-f879ca76a462"
      ]
    },
    {
      "cluster_id": "2fd5c32c-ec83-4d86-8836-741ba8422357",
      "members": [
        "e286a468-eebe-49e0-abe3-e91ef6536342"
      ]
    },
    {
      "cluster_id": "82af2059-79b6-4403-9b30-9a9e111cc571",
      "members": [
        "47a5bdde-eae2-4055-96f5-64228b6afaeb"
      ]
    },
    {
      "cluster_id": "18ce2062-068b-4c99-b15d-32e24b28817f",
      "members": [
        "3d1d9264-6372-4f7e-abba-8dff2736e471"
      ]
    },
    {
      "cluster_id": "3a6ab8c1-b7af-4dae-9216-d55e6233e2d8",
      "members": [
        "c7fa7154-662d-458e-ad6e-b0f0bf4c0382"
      ]
    },
    {
      "cluster_id": "4941aadf-8564-4b71-b807-8b98a3bc3396",
      "members": [
        "e92defb1-ef29-4c1a-904d-6e35d992e54f"
      ]
    },
    {
      "cluster_id": "465bda3c-33ed-4e06-86ec-cc6c1d50e27d",
      "members": [
        "f9388985-6c3f-4aed-8bb1-2e0663b530b9"
      ]
    },
    {
      "cluster_id": "f551f1f0-32f5-4ff3-b5c9-5aab61bb1bd6",
      "members": [
        "8b3e60bf-ee95-4e09-942b-5d4da7895641"
      ]
    },
    {
      "cluster_id": "81215e4f-490f-4619-8a72-2aa513e8e164",
      "members": [
        "ae583b19-b213-4b87-a650-af51e14d5d28"
      ]
    },
    {
      "cluster_id": "afd1f695-ea2e-42a9-8e8b-7c38a970fbb5",
      "members": [
        "98b4c645-ec3a-4052-8ecb-1f2e0cff86b0"
      ]
    },
    {
      "cluster_id": "05b40a90-169b-48f1-8cb1-f86fad4e6b0a",
      "members": [
        "99c384ac-d12e-412c-af0e-a29f870224a1"
      ]
    },
    {
      "cluster_id": "f5d2e5c5-6f09-4885-98b8-5062202897a8",
      "members": [
        "a768319a-bc88-4540-a568-c888c470e333"
      ]
    },
    {
      "cluster_id": "1c4b6f2a-a55c-4baa-b0e5-6516b517f960",
      "members": [
        "188e2634-02b5-48cf-8416-b730583f7c01"
      ]
    },
    {
      "cluster_id": "0d1a4169-975f-49a7-9f31-390c351eb65a",
      "members": [
        "3d0cc3f9-607e-40c1-8d36-d6bc0ce97f45"
      ]
    },
    {
      "cluster_id": "bb078c76-36ef-4176-a9f6-192717c4f2b4",
      "members": [
        "571e1cc8-8607-4611-b359-a9e35e278bfe"
      ]
    },
    {
      "cluster_id": "690dcbae-7356-41d9-9b3d-b2f6f77db887",
      "members": [
        "630c80c4-861f-415c-8316-30394a1d4966"
      ]
    },
    {
      "cluster_id": "77fd60bb-096a-4b70-a630-b56ef3e8f647",
      "members": [
        "65f035a9-60f3-4966-bc30-bed468dc3092"
      ]
    },
    {
      "cluster_id": "06ac8474-a3e8-472b-abca-69bac9927b06",
      "members": [
        "36e1b8f2-7b42-403e-b626-9551d4fbc24b"
      ]
    },
    {
      "cluster_id": "40265b93-5ea0-4bd6-8b7d-972baab54b70",
      "members": [
        "21fceb45-0ee5-4715-845a-c3e404724968"
      ]
    },
    {
      "cluster_id": "6e8c4432-d4c6-4fcd-9e26-cf2164b211ae",
      "members": [
        "e77ad024-62fa-46e0-96aa-65e8904c4383"
      ]
    },
    {
      "cluster_id": "fc4f3449-d301-4936-a35f-47ca68ad88dd",
      "members": [
        "c322107b-bbb2-44b7-aa46-c909b4d958d6"
      ]
    },
    {
      "cluster_id": "593f987b-f53c-49a9-a836-d17fb210c211",
      "members": [
        "d61751b1-ac99-48f8-84e8-8fba7b252705"
      ]
    },
    {
      "cluster_id": "8a312b2a-4e43-4814-85a4-51669e80ab52",
      "members": [
        "42a254be-8c82-46d6-948b-254dba5466d9"
      ]
    },
    {
      "cluster_id": "91289460-848a-4396-988d-42e28ce5078b",
      "members": [
        "7af65c91-6dfe-40e8-9056-5c636f903528"
      ]
    },
    {
      "cluster_id": "8bd4a872-0209-415e-a7b8-b4acaf26a95b",
      "members": [
        "9093e625-8ae4-4f6d-9b7d-8b396f3411e7"
      ]
    },
    {
      "cluster_id": "2aafed04-d3d3-4ae0-9825-6d6db215ea71",
      "members": [
        "374372cf-f681-4fc2-851d-a23fd9e14b8f"
      ]
    },
    {
      "cluster_id": "758b1960-78c3-42a0-8a1a-c0d1f47c547d",
      "members": [
        "0943c6ee-1b22-4a07-ae1f-fa4e9067bf92"
      ]
    },
    {
      "cluster_id": "920bd1eb-f625-4f7e-981d-fa931240bd9e",
      "members": [
        "d79ae8d2-9a53-4da3-a523-3505d8ef4e2a"
      ]
    },
    {
      "cluster_id": "9d7867d5-5ab5-4b0e-9556-f3f45feb0160",
      "members": [
        "9f261b7b-2319-4085-ab37-11078a70c433"
      ]
    },
    {
      "cluster_id": "709632d6-c88d-494b-82c2-d5300f49d1cc",
      "members": [
        "90d2e97e-b523-4e6d-a6e6-06d952d0048d"
      ]
    },
    {
      "cluster_id": "19fb932a-d5d7-4981-804f-5245e467f600",
      "members": [
        "3866bad7-b613-459d-b4e2-3a798895640b"
      ]
    },
    {
      "cluster_id": "678b3718-1825-40ce-8b76-3f1e30facae7",
      "members": [
        "4a88d88f-26b0-40d4-b289-cf860b95d0de"
      ]
    },
    {
      "cluster_id": "84787050-e169-47c8-98ae-7a849294a5a9",
      "members": [
        "b70369d8-27de-44c0-8c2d-d4f9015ecfbe"
      ]
    },
    {
      "cluster_id": "9f3b49b5-fd07-4adf-8183-7615100c8917",
      "members": [
        "186364e0-0496-4137-aedd-08a93acb45c7"
      ]
    },
    {
      "cluster_id": "d5742cb8-e264-4816-b45a-8b7710ea66b3",
      "members": [
        "ce4bfadc-7156-4acb-ad54-dba35724c1fc"
      ]
    },
    {
      "cluster_id": "91ce6b29-5884-4f1a-9443-ad0d26809886",
      "members": [
        "eaa30024-a42c-44dd-8614-b5fecfe93db1"
      ]
    },
    {
      "cluster_id": "3dba838d-2eca-4f65-941b-d8fa64a15014",
      "members": [
        "6c975d06-5e6f-4180-a27f-af1e4cd6b6d1"
      ]
    },
    {
      "cluster_id": "43cf9cfc-c9db-41b9-a566-9bec2d970db4",
      "members": [
        "4aaf367c-9686-43bc-82d2-29f6a2799c9c"
      ]
    },
    {
      "cluster_id": "ec4ecacf-5ed7-4202-a803-a46089704d53",
      "members": [
        "9b2dabb6-5ae1-499d-8ced-0becc13dd579"
      ]
    },
    {
      "cluster_id": "c4564515-d53f-4e98-999a-f38427deb89e",
      "members": [
        "30bf2f64-e771-4949-8980-3b6ec5555aab"
      ]
    },
    {
      "cluster_id": "d2b6a98f-1634-4f3b-a41d-9b64375eff6e",
      "members": [
        "6b51683f-1256-42bd-8b6a-91a6a7fa057f"
      ]
    },
    {
      "cluster_id": "a2a4403f-1592-434f-a0f9-d248d1684f8d",
      "members": [
        "96c47ff2-e6b2-49e7-91b4-36c9da5cede1"
      ]
    },
    {
      "cluster_id": "8d9c34af-fae3-4e38-87d1-1e67774753aa",
      "members": [
        "7f084599-1623-4d42-bf4b-4b862f5e8972"
      ]
    },
    {
      "cluster_id": "fcfd6d39-3e11-43c7-ac1f-026d265beb4f",
      "members": [
        "5c4d273b-9230-4adf-b8f0-b49827a4ec76"
      ]
    },
    {
      "cluster_id": "94df14e2-7e46-450f-90de-ca92085eab78",
      "members": [
        "2b9f56ec-523f-4414-b969-1659e9a4f74d"
      ]
    },
    {
      "cluster_id": "dc7ff2aa-1921-42d9-9518-a57c8197d5cd",
      "members": [
        "84caced5-1f11-4f30-85b3-e9cc1fb2b5f9"
      ]
    },
    {
      "cluster_id": "79a31826-be43-4bb3-80ca-3a1482a7949f",
      "members": [
        "a8b1f4ae-bb24-4d01-985a-3ed5e9af9c13"
      ]
    },
    {
      "cluster_id": "efd1564d-df50-445a-a638-9947d0e8404e",
      "members": [
        "8603a105-6ea7-414b-a010-6065851a6046"
      ]
    },
    {
      "cluster_id": "afd94974-8e6c-4eb8-a657-4ac5f64e9000",
      "members": [
        "9259f1ee-50e3-4e3a-810f-97d1deab67df"
      ]
    },
    {
      "cluster_id": "abe48ef5-28d3-473b-b5c1-22f7c985121d",
      "members": [
        "2c6eb48c-219d-4624-a524-61374499a6c2"
      ]
    },
    {
      "cluster_id": "015ba6d4-e890-401b-9586-28896557504b",
      "members": [
        "4708fe1a-0f60-44da-9a08-02e513afa594"
      ]
    },
    {
      "cluster_id": "2a9b1bd4-3cd7-481b-8cb7-5d5856650a4b",
      "members": [
        "4a823ed6-c42d-4cf4-9326-15b6ae845cd6"
      ]
    },
    {
      "cluster_id": "b98b439c-bc5f-48c4-9882-c02eb0d9e36c",
      "members": [
        "f1c193fc-6404-49a5-bbbf-d866acb13365"
      ]
    },
    {
      "cluster_id": "c20e1db7-e918-4c20-9b2a-23168ba5d1b5",
      "members": [
        "042ef20a-73df-4a71-abe5-0760038aad5b"
      ]
    },
    {
      "cluster_id": "e77e1981-0ac9-43e4-bf55-8efb11926415",
      "members": [
        "81600820-95e9-4a12-901d-caaec68e738e"
      ]
    },
    {
      "cluster_id": "0534bd48-c558-48f7-8bed-cd770b8d24ee",
      "members": [
        "01c6a101-e7a1-490e-89be-3cdfa97902a8"
      ]
    },
    {
      "cluster_id": "707d96d6-8c9c-44bd-a592-b72a5c0a0e76",
      "members": [
        "7c80c12a-d7df-4343-8b4b-2bb750a57e89"
      ]
    },
    {
      "cluster_id": "3449416a-5af1-418f-857a-770f02267ee7",
      "members": [
        "ad38848b-442e-4629-88b4-3c66a4f9beef"
      ]
    },
    {
      "cluster_id": "829b9804-a574-4cfb-bb97-448e3e369540",
      "members": [
        "a272c121-a877-4718-8464-1bd5a96ce2b9"
      ]
    },
    {
      "cluster_id": "40ab9766-1c85-4b8a-bb1d-2effee6c9d18",
      "members": [
        "8381663b-0d95-4b43-910e-511a5204c318"
      ]
    },
    {
      "cluster_id": "3a1c15cf-9c77-4bd8-9e70-266829c039f2",
      "members": [
        "297d1ba2-974f-43a0-b62a-ba723ea87519"
      ]
    },
    {
      "cluster_id": "1bfa372d-748e-4dfa-a2d8-05a78385d36f",
      "members": [
        "d24c3b2a-6927-4d4f-8c94-e11959f856bc"
      ]
    },
    {
      "cluster_id": "4ce3dea7-0e2a-40e4-9e4a-2c61943d61e2",
      "members": [
        "102df67c-d144-4e2a-ae35-34d15662a08b"
      ]
    },
    {
      "cluster_id": "f8ebc28b-35f4-46bd-95af-d6b109203645",
      "members": [
        "f49591dc-a252-46d5-9c5b-8cdddafe669b"
      ]
    },
    {
      "cluster_id": "760f2c37-f953-4230-a4d7-e4bda98fc033",
      "members": [
        "8aad2ff8-5dab-4507-aaa0-4b93cf9bd890"
      ]
    },
    {
      "cluster_id": "ccd75d9c-f680-4c7d-a6c6-f684f0c4b09f",
      "members": [
        "402383f6-7e8e-4fe5-98d1-2f49ecc8992b"
      ]
    },
    {
      "cluster_id": "632ca25c-c259-4da1-adb8-67921865876c",
      "members": [
        "654b1932-6580-4646-99d2-5e498312d281"
      ]
    },
    {
      "cluster_id": "323f50ac-8539-481b-b9dd-0528780df63d",
      "members": [
        "cf239229-aa46-44db-8fce-721d466fcdf9"
      ]
    },
    {
      "cluster_id": "c768dbef-cff9-45a6-9583-58c568197a94",
      "members": [
        "46029ac4-9931-4eb9-a261-618a19919178"
      ]
    },
    {
      "cluster_id": "53d09843-b0b4-4b4a-974f-76bfc4243e0c",
      "members": [
        "edef2453-14fd-47f1-87fe-2e982fe3cd5e"
      ]
    },
    {
      "cluster_id": "8a726a08-8358-4b34-876f-420532834600",
      "members": [
        "15cbd724-371f-49a4-a658-a30558418d7d"
      ]
    },
    {
      "cluster_id": "6acfc858-1016-4e78-a1e1-7d809680381e",
      "members": [
        "cd18e4e1-b254-4b25-812f-84266b128a47"
      ]
    },
    {
      "cluster_id": "3bab816b-4cb9-4b5f-bccb-c8cacf2b36ae",
      "members": [
        "66c5719f-412b-4670-af81-4531155c53ee"
      ]
    },
    {
      "cluster_id": "1b1d9a06-de42-4de4-8ba5-73d34f084424",
      "members": [
        "147db351-5f97-4654-b8d4-bcee7ef4a9c5"
      ]
    },
    {
      "cluster_id": "f1490876-f9ef-4974-a23e-79abce4ea951",
      "members": [
        "24f64892-fea8-41c8-be4a-4d4252def5c3"
      ]
    },
    {
      "cluster_id": "df1455dc-0c9e-4e83-b885-6c9b28b69dbc",
      "members": [
        "89096621-ccff-490a-834b-b5c0636df3a7",
        "f50a5420-3ac2-4800-aa10-086f3b074789"
      ]
    },
    {
      "cluster_id": "3f26edd9-fb3e-47fd-a185-0a5f3a6ec746",
      "members": [
        "09cba8b1-bb6e-4bfd-8101-83de3c034186"
      ]
    },
    {
      "cluster_id": "816b9948-b1f0-46c8-b6a3-18e652cd3289",
      "members": [
        "06a4bfe7-f036-450e-ad63-0e9898e7d636",
        "1b6c2507-9795-4fb5-bccb-74065585080c"
      ]
    },
    {
      "cluster_id": "9f713e34-d77c-4dee-b4cc-dc4204b450f3",
      "members": [
        "137a6f5e-f49b-41b5-bf2c-02f074fe9c84"
      ]
    },
    {
      "cluster_id": "3ac894a5-bf0c-462e-b5eb-494aa29af425",
      "members": [
        "be2bced6-c4a5-48ad-8ede-83c8491b1c74"
      ]
    },
    {
      "cluster_id": "ff2acca4-5f30-4167-8a23-b96f532a3929",
      "members": [
        "e4d4d79d-b10f-4d08-a363-500fae00fb83"
      ]
    },
    {
      "cluster_id": "e539011c-4c48-4afd-9e8f-3e4ca7d332fe",
      "members": [
        "4490b780-f23f-4479-9e7d-54bdc8c5521d"
      ]
    },
    {
      "cluster_id": "7645928f-b607-4113-a8d9-4afacf4bc042",
      "members": [
        "80dfeeb7-ac38-42b1-b1ea-fa79408aa30e"
      ]
    },
    {
      "cluster_id": "3c7a34af-192b-4878-baca-1d31c499b7da",
      "members": [
        "8adca138-48cf-4cec-8ee7-f3b21d0c6e8b"
      ]
    },
    {
      "cluster_id": "38e4e6a9-dd51-45eb-8aed-8f44b62fdfe6",
      "members": [
        "8ad63261-9f3a-4a04-b6b0-8538bec06f31"
      ]
    },
    {
      "cluster_id": "2962a54a-b1d0-48df-9318-1e0f945ac7d0",
      "members": [
        "aa124032-a0ad-44b6-8e8f-2e7e273ef0eb"
      ]
    },
    {
      "cluster_id": "1be22971-e6b7-4f57-b7f5-9c6d0cc3afbb",
      "members": [
        "9bb4a6f5-b8ce-4b2e-aabb-3bb74868c8bd"
      ]
    },
    {
      "cluster_id": "30f5c3ba-9f54-4691-8863-1e644c87fbf8",
      "members": [
        "a65d0fc8-2448-4a5d-924a-b04069b6fc51"
      ]
    },
    {
      "cluster_id": "5de51773-6a23-4bab-8c30-a41d42c69aaf",
      "members": [
        "ea47cd6c-8c9d-45fd-90d1-ba14cea5fec8"
      ]
    },
    {
      "cluster_id": "cc163006-eb32-4037-8b14-d4cea8207017",
      "members": [
        "a5c5b65b-1f44-4639-982c-5025cf54c182"
      ]
    },
    {
      "cluster_id": "b2b76ff9-4063-44de-a3e0-0b0a58a3a46a",
      "members": [
        "302e2cc2-3c88-4d37-b183-ae8e562b26dd"
      ]
    },
    {
      "cluster_id": "1e5faa7b-e696-49d7-be88-e86b8468f738",
      "members": [
        "af2c3128-fc8e-4faf-8982-9ba6b27e0e80"
      ]
    },
    {
      "cluster_id": "76455b31-1fcc-4337-adc1-b2686dd2563d",
      "members": [
        "cec36efa-53e2-4ab2-b41e-6b9e8bb2509a"
      ]
    },
    {
      "cluster_id": "6f4705cb-b438-4a8d-84e2-59fd3445f3af",
      "members": [
        "d851bb9b-c1dd-4b50-b86d-d7e0a70fcc71"
      ]
    },
    {
      "cluster_id": "8f6bdb99-b1de-47a0-840e-33678f79a92b",
      "members": [
        "2ce479fd-0786-42c1-ac4d-082e5c7da9a9"
      ]
    },
    {
      "cluster_id": "d811e7ed-7bb2-4a03-a5a1-75a044ab14eb",
      "members": [
        "dd0a5af4-8344-4b4c-a3db-f0654ea0fbe2"
      ]
    },
    {
      "cluster_id": "02ef40eb-a1c1-4bb1-9831-77fc91e127be",
      "members": [
        "9d9755e7-2d6b-471e-9d6e-6602173c5e12"
      ]
    },
    {
      "cluster_id": "640f326d-efe1-4293-bfc4-0c4c7b9185f3",
      "members": [
        "92f6dcbf-31fe-4a96-a55d-1a6bc36d8c2b",
        "1f783ba8-cb50-4762-b602-1e7f5ee916d5"
      ]
    },
    {
      "cluster_id": "3d2e56c3-c257-4788-ac2d-72890e521046",
      "members": [
        "55516b8d-0683-4117-ad3c-ec5487d82730"
      ]
    },
    {
      "cluster_id": "edbf2785-2875-4f94-8c61-364dee3abf1f",
      "members": [
        "c2401e50-09b0-40a7-9572-7e712e2d271a"
      ]
    },
    {
      "cluster_id": "d13901ad-61f1-4fb1-ba52-f79a1d3671b7",
      "members": [
        "8ec85d90-fc7b-4af1-9c84-98cf7584c0b7"
      ]
    },
    {
      "cluster_id": "0a78e568-4aaf-4a3c-a4c0-d484ec60f776",
      "members": [
        "9b70c841-3399-48a6-9656-f80396fdc314"
      ]
    },
    {
      "cluster_id": "fc29eab9-06ef-4c87-8c16-ab4eb87c1683",
      "members": [
        "5caeed35-980a-4cdc-8f83-12122d6ac3b7"
      ]
    },
    {
      "cluster_id": "e130a374-b2e7-4d68-8a8e-32dcab17656b",
      "members": [
        "3758d0d9-bc1d-4755-a92a-34b2b5b49878",
        "682d7d53-1e3b-4d7c-ae9a-5c149108e4f9"
      ]
    },
    {
      "cluster_id": "acf3ef41-5374-4f21-834c-c4a11d955ee1",
      "members": [
        "edbe9a31-3a33-4d14-87f3-befeab22bef0",
        "80cc3156-fe40-44e1-a335-8776a3897352"
      ]
    },
    {
      "cluster_id": "1f91813e-722c-47f3-81f9-6d98fd8c6b7d",
      "members": [
        "31852110-628f-48e8-a05c-31ccee743dce"
      ]
    },
    {
      "cluster_id": "a1ea139e-e9aa-4250-ae2b-ff5069df6f63",
      "members": [
        "ecd54e83-ea75-438a-a38a-78890ca0d766"
      ]
    },
    {
      "cluster_id": "5f674ba0-ccc9-4a42-8c81-55a71cb30d68",
      "members": [
        "7cf42c5e-169f-4ebe-ab61-f1a10e95149f"
      ]
    },
    {
      "cluster_id": "2ef3ee94-6c9d-429b-95e7-08b756215251",
      "members": [
        "ce9d23e1-d0d6-401c-8f9e-9ade8ee9bfad"
      ]
    },
    {
      "cluster_id": "532bc570-7cab-4e65-8d14-b6e22f9fc1d9",
      "members": [
        "7c090bae-4199-4bf7-9604-5c65660aff00"
      ]
    },
    {
      "cluster_id": "e9e815cd-7183-4b06-a964-9cfc2d25bfab",
      "members": [
        "04806cd9-9b90-4ae0-af5f-b60428f4ac1a"
      ]
    },
    {
      "cluster_id": "b5c5d896-8437-4aaa-ae03-95c8865a2ac0",
      "members": [
        "d0771d19-f756-4cd3-9786-9fde6fbf2023"
      ]
    },
    {
      "cluster_id": "129ac9af-1e7f-4d17-aba1-4c71a6061174",
      "members": [
        "0778b390-a2ee-4d01-98c9-cb1a9bde1902"
      ]
    },
    {
      "cluster_id": "325bf549-47cd-452f-95f4-f8b56d9739b0",
      "members": [
        "35c1e621-4969-4e5c-9003-b0583ca8939c"
      ]
    },
    {
      "cluster_id": "d41f0247-c996-4fca-bb9a-db10717ce822",
      "members": [
        "e9be2f07-0ef3-4c7e-aa68-19ae2471474c"
      ]
    },
    {
      "cluster_id": "3304ef73-a023-4ec9-bf07-27f713496a6e",
      "members": [
        "8e3d1db2-3b77-4d35-9896-79ee893fef39"
      ]
    },
    {
      "cluster_id": "48b40da6-72cb-45c4-8c2b-8924870132bb",
      "members": [
        "b423ba88-db77-4c34-a7a6-f53445b95467"
      ]
    },
    {
      "cluster_id": "6e17469d-ab2f-4f85-99c5-d4389227a162",
      "members": [
        "32e32477-4bb8-4504-a027-27fc77d8c334"
      ]
    },
    {
      "cluster_id": "ce22089b-598c-40ef-ab32-85ce5e1f2d4f",
      "members": [
        "ccafa14f-33e2-4e2f-844e-8fca6079b32a"
      ]
    },
    {
      "cluster_id": "a2fa0436-7d09-4549-9e78-5e411d846fe6",
      "members": [
        "dbd04912-2116-4721-be14-a71801cd3c32"
      ]
    },
    {
      "cluster_id": "3050de99-7b86-4c4e-a101-b10c8a674e17",
      "members": [
        "69b95343-c252-4a88-8e33-88c27080b854"
      ]
    },
    {
      "cluster_id": "53c8b8a1-19e0-48b3-8c8f-f90de56c4785",
      "members": [
        "08c4a7d8-a808-40c5-b31a-7003fa42378b"
      ]
    },
    {
      "cluster_id": "1ac6b5e1-dffe-48e8-ab2a-c58a20b3c8dd",
      "members": [
        "aa7d3860-9a7b-4b71-9e39-2d706c63a28e"
      ]
    },
    {
      "cluster_id": "54276cd3-4620-48dd-898d-2aae66e353c4",
      "members": [
        "c4b94532-7a76-4ebc-a460-d01465b113e2"
      ]
    },
    {
      "cluster_id": "0bbfb864-d9fa-40cd-982d-22d96033b7a3",
      "members": [
        "12a88459-c669-4b94-9645-9be73587f944"
      ]
    },
    {
      "cluster_id": "6f086810-1930-4192-ad91-ce3f0eefd1aa",
      "members": [
        "e860db1a-8641-4f76-a140-b16a9d94307d"
      ]
    },
    {
      "cluster_id": "6e4dcb8c-7c71-4fa3-82ef-3a917a168bdb",
      "members": [
        "5a8463b3-4d4f-4daf-b7b8-dd573ad540c6"
      ]
    },
    {
      "cluster_id": "39e358aa-4f67-47f5-a3b2-dea997ca44d0",
      "members": [
        "6db38e74-24f3-4a2f-ae3a-8d02b9d72dd8"
      ]
    },
    {
      "cluster_id": "f067ac83-ba02-48cb-bb4d-1822eee31ec2",
      "members": [
        "603921ad-e52a-4410-99ec-8fd86d16e5c2"
      ]
    },
    {
      "cluster_id": "67de48d7-3fc7-4d88-97a8-9350772b5bc5",
      "members": [
        "cd5c2b41-5c7f-4a55-9ab2-88fc3ef91c4c"
      ]
    },
    {
      "cluster_id": "a4d91f10-cd48-4917-90ab-b14ea36168d9",
      "members": [
        "9579faa0-0177-45b7-9056-8029d8924320"
      ]
    },
    {
      "cluster_id": "b0e81eaa-8bd7-4fe8-bd62-e10ea003f63f",
      "members": [
        "95e05178-60f7-4cbe-bd9b-5bf961bdef01"
      ]
    },
    {
      "cluster_id": "5f8dbb60-ef34-416a-9285-ed818708d337",
      "members": [
        "a2bb928e-2e84-4e3e-81ee-b83ba79b568d"
      ]
    },
    {
      "cluster_id": "7e081e03-60f5-4239-923e-30df23ea9e14",
      "members": [
        "748a15bf-517c-467d-b641-dc29fcee8d35"
      ]
    },
    {
      "cluster_id": "94834f96-c25c-4f04-80b8-c75b05787e8f",
      "members": [
        "e1847ff0-930b-42fd-a04c-2eb5f02fd7e0"
      ]
    },
    {
      "cluster_id": "f0d97c3a-c630-45ac-8106-3c433d45bb57",
      "members": [
        "735a9667-6b3e-4e28-89bd-78eefd76f362"
      ]
    },
    {
      "cluster_id": "b98bf259-2428-4cda-a309-5be4fdb0c3ef",
      "members": [
        "7731cec2-7cdd-4637-a82a-9e0a7fc3523b"
      ]
    },
    {
      "cluster_id": "c4fe585b-23d9-4a10-a6b1-a3c43c70fda5",
      "members": [
        "31ee3b51-269e-4dfc-8198-05a6d28587ab"
      ]
    },
    {
      "cluster_id": "341ca13e-66ab-4ded-b14a-e2210febdc82",
      "members": [
        "c8625782-7e9f-43f8-9213-eb09f5957d9c"
      ]
    },
    {
      "cluster_id": "c6804538-62b8-4db5-a60b-8ce1803df0aa",
      "members": [
        "657382bb-d2cb-4305-9efb-21db8233240c"
      ]
    },
    {
      "cluster_id": "4cdfe663-949e-4463-904d-7ad58162fcfa",
      "members": [
        "f3f664b5-f1c9-46f1-acd1-599ecafc9a9f"
      ]
    },
    {
      "cluster_id": "f5c9b8a2-ba8a-4c9d-96f7-5fdcef771d06",
      "members": [
        "12b17193-4706-4f24-ad55-383db3074772"
      ]
    },
    {
      "cluster_id": "0a3f5bd0-94f4-48e7-84b4-d317e0edec75",
      "members": [
        "1ca2ef26-0ed5-4d56-850e-a636b6eff698"
      ]
    },
    {
      "cluster_id": "46a652d6-7e4e-45bf-93da-8368a900beab",
      "members": [
        "e81e7d4f-67c0-48fd-a9d7-8ff407f9d70b"
      ]
    },
    {
      "cluster_id": "e5b92c5d-257a-4d84-a804-3e2462bb2954",
      "members": [
        "d3a08662-4d96-4236-96ba-063d7de46717"
      ]
    },
    {
      "cluster_id": "1782182b-9c5f-4a6f-b547-bd10fc2d3b84",
      "members": [
        "d745da97-1080-4d18-a214-49591427f1cc"
      ]
    },
    {
      "cluster_id": "556da1e6-535a-4511-ac9b-649cb3eafe84",
      "members": [
        "87e1ed4d-7fb1-495b-8e0a-a85a0d6596a2"
      ]
    },
    {
      "cluster_id": "d169380d-3c63-4800-8f8c-5deedf749ffe",
      "members": [
        "a1029f55-fc1f-462b-a001-b99c9358ee2e"
      ]
    },
    {
      "cluster_id": "a8476578-a217-4709-ac69-6e4d18f25dc6",
      "members": [
        "55d5c23f-5205-4f18-b5d6-5fd8b9299c4b"
      ]
    },
    {
      "cluster_id": "d789b1ed-51e0-4f7f-953e-3eaabc59ca49",
      "members": [
        "cb74013e-54c4-4e79-ad4f-9c3287eb0ec8"
      ]
    },
    {
      "cluster_id": "3da59556-c8b1-408c-95c7-5d8130035b46",
      "members": [
        "18a6c232-9e9e-4d2e-bb6f-4c32c1876c91"
      ]
    },
    {
      "cluster_id": "6f5e39d0-2941-42e5-be3f-779525a745b7",
      "members": [
        "24afa0a8-4d76-40ce-9afa-3bf870a96fce"
      ]
    },
    {
      "cluster_id": "f8a7db64-2922-40e3-9fc7-9a7934487f7f",
      "members": [
        "7caa6b44-edda-4b37-8343-03733cfae459"
      ]
    },
    {
      "cluster_id": "3e66d569-f8f4-40ce-8d13-9d469cc2e340",
      "members": [
        "48103b8c-b7b1-4459-b902-e8dd3da7e54d"
      ]
    },
    {
      "cluster_id": "f3668774-884d-4b84-a93b-1c5ea3e64309",
      "members": [
        "f9fb6469-9308-42c3-b83c-a05198123ffe"
      ]
    },
    {
      "cluster_id": "70d7ea19-ed43-41ec-a695-147f9057dd3c",
      "members": [
        "9e531e8e-237f-4247-b459-eae80fadd5e9",
        "2ba2eda7-5496-4127-833f-7dd6a93199da"
      ]
    },
    {
      "cluster_id": "e12f223e-9c33-4c5f-9e5c-badae44a41f7",
      "members": [
        "a54a02cb-64db-4c71-b0e0-1adb45b0c3c3"
      ]
    },
    {
      "cluster_id": "07969927-bc1e-48a3-8b9c-29bb62214363",
      "members": [
        "69ee9d16-acbf-4105-8a4e-7742e50c76c9"
      ]
    },
    {
      "cluster_id": "416a789f-b094-4d93-9898-3707b0bf84ed",
      "members": [
        "d80a8c53-92e9-4ff9-a558-32a8b1313d4a"
      ]
    },
    {
      "cluster_id": "c74eddc6-9017-4628-9942-40823cd7e30e",
      "members": [
        "43f29fae-8a37-48a2-ac30-5cdadd238303",
        "b15fb8e1-637f-40e7-8eb1-707011750283"
      ]
    },
    {
      "cluster_id": "09202e6f-2182-42ac-8af6-6622f1cfeb68",
      "members": [
        "e6edeb03-0ca9-422f-b5fa-4244d92faf5d"
      ]
    },
    {
      "cluster_id": "96b17898-9707-4c42-8d78-5b035c3e7377",
      "members": [
        "4006480a-753c-45ce-aa6b-ecf3456a9b65"
      ]
    },
    {
      "cluster_id": "96226cbe-6ce7-473a-a2c5-bcfa1fa15be9",
      "members": [
        "a38e8719-88d5-46ef-90f4-a32993b6cfdc"
      ]
    },
    {
      "cluster_id": "05310a2e-9cf9-4ebe-9d39-aca58b7ee406",
      "members": [
        "8a50c084-5b2c-4fdb-ad04-e211a34541ee"
      ]
    },
    {
      "cluster_id": "836422b4-fd08-4384-b536-467195ee18cb",
      "members": [
        "34cb44d4-ecd2-467c-9936-4a6b286b6edb"
      ]
    },
    {
      "cluster_id": "6eb6f4d9-183a-4612-a4f7-dd59bbc26512",
      "members": [
        "3f46d12f-b64f-4d48-87e1-1c65835f7681"
      ]
    },
    {
      "cluster_id": "50647687-d65a-47e2-b9a1-a4bddf5f53cc",
      "members": [
        "ac8bf186-9f81-4e86-bcf8-9581ca6de9ba"
      ]
    },
    {
      "cluster_id": "2d87e550-62a5-4ab5-8323-4c18213fedcd",
      "members": [
        "e2cc15df-04af-44fd-bb34-b2ad74cc09fe"
      ]
    },
    {
      "cluster_id": "1843ffaa-26d8-4da2-944c-1a88ec1c3413",
      "members": [
        "5f00f9bc-f04d-4326-9b92-b94a44d73a3d"
      ]
    },
    {
      "cluster_id": "c2fb9cb0-a6ae-4469-84e3-3b523125b6df",
      "members": [
        "8f89cdbd-4592-4ad5-a926-7e091ad7e6ba"
      ]
    },
    {
      "cluster_id": "9c99fda8-d219-4855-bf41-fafffb61b05a",
      "members": [
        "b96c12ae-9f4e-466b-ae2d-8134b211c5aa"
      ]
    },
    {
      "cluster_id": "b29c3ed7-bdfb-48eb-87a7-3e6d5f2cf585",
      "members": [
        "4a1aec55-354a-4dcf-909d-a6903b8a9660"
      ]
    },
    {
      "cluster_id": "6e8f5bec-2ba5-40f0-a873-4607c411beb7",
      "members": [
        "11bae64a-bdb5-4f1c-ad4d-c94f6ca02f82"
      ]
    },
    {
      "cluster_id": "9a2fe341-e356-4c2f-afb2-12f391a85d04",
      "members": [
        "b2b1a5d6-a348-471b-9c4e-fe7b3293beac"
      ]
    },
    {
      "cluster_id": "41c6f905-1ba5-4740-a4f5-bc35586af666",
      "members": [
        "a92b3d5e-f95e-4a99-a370-4c0147a5b7ca"
      ]
    },
    {
      "cluster_id": "d8ef4018-d9a3-42e2-a7c5-aef1d93ff0d6",
      "members": [
        "a7cedfd2-fd1a-4ef5-97d2-795081566985"
      ]
    },
    {
      "cluster_id": "f98db0f7-3865-4f81-b4c0-e009394ed065",
      "members": [
        "1c7b73b0-2310-446c-8277-54767060f75d"
      ]
    },
    {
      "cluster_id": "ffb636ec-7472-41b4-ad69-f529b66bd46e",
      "members": [
        "0acef6c0-1f2d-4dcc-9a90-e29b93793897"
      ]
    },
    {
      "cluster_id": "8e38f27f-adac-4956-8ff8-f509c611ee94",
      "members": [
        "bc8de606-d518-472e-8e59-39337287205d"
      ]
    },
    {
      "cluster_id": "1a1ebb66-c1bd-4b57-a87b-865e10a35768",
      "members": [
        "8207856c-0cb1-442f-97f6-17f538dd9ff6"
      ]
    },
    {
      "cluster_id": "60679d50-135f-43b4-962e-903dca327357",
      "members": [
        "8ffdfd68-1b2a-4e92-9ff4-e3e811d91c70"
      ]
    },
    {
      "cluster_id": "928155fe-b009-4dae-a22f-c56106f4b853",
      "members": [
        "17401565-66ca-437e-b0a6-136ef3724107"
      ]
    },
    {
      "cluster_id": "aa05692d-a142-425a-b2a4-b94b0045a440",
      "members": [
        "82a4cb5a-2b30-4906-9627-1c8593ce8dc7"
      ]
    },
    {
      "cluster_id": "c0987cb3-5451-4fcf-a732-5bfbe94a56c9",
      "members": [
        "f5ad2cce-9961-444b-8007-5874a232d25a"
      ]
    },
    {
      "cluster_id": "d013c87c-7dd2-4021-97c9-a4069e2ad7f2",
      "members": [
        "19352e34-aca6-4dbd-a538-04e985ad70d7"
      ]
    },
    {
      "cluster_id": "fa5edee7-14cd-46f2-b781-a5794e463daa",
      "members": [
        "9a14913e-e877-4406-8c04-9675beb0ae54"
      ]
    },
    {
      "cluster_id": "6ea5c303-0018-42cb-9161-d7d2a76673ac",
      "members": [
        "69643293-59b1-4d82-b831-0d3d5c86ed29"
      ]
    },
    {
      "cluster_id": "bf5c16e4-64dc-4dad-a15b-31db258dc134",
      "members": [
        "b96a6933-b915-4bf3-8058-724297dab033"
      ]
    },
    {
      "cluster_id": "a18cfe43-57c6-4582-9892-e05c06ecdee6",
      "members": [
        "90b494bf-039b-4e54-a6f1-4c80e755714b"
      ]
    },
    {
      "cluster_id": "d4e2bc2e-5c21-4fa6-b48d-9b09603ae727",
      "members": [
        "b060cf25-4818-4962-a079-b0943a233663"
      ]
    },
    {
      "cluster_id": "117f6cc5-ef88-4d83-9dfc-20f8e5fc488c",
      "members": [
        "bd33352a-5503-4615-89fc-28d9a8fc5de9"
      ]
    },
    {
      "cluster_id": "b32b2c04-03a9-4e04-93d0-499cf1aa4cc2",
      "members": [
        "5f06c143-7e85-43b4-bfd8-a9cc5030c2e9"
      ]
    },
    {
      "cluster_id": "7311a9b7-5d04-45ee-bfba-1bec0d5a0eda",
      "members": [
        "4cbccbd9-75d6-4806-85d6-6e3f1ac612b0"
      ]
    },
    {
      "cluster_id": "2c20a8ae-1d47-4c90-a5e4-88e406d3334f",
      "members": [
        "1b110999-77b0-4a7f-986f-a8f1d4d159cd"
      ]
    },
    {
      "cluster_id": "a5cfe32e-2f16-4644-a4e9-767621b4c4a7",
      "members": [
        "97bcabff-36fe-4906-a8f1-49e45a2230c0"
      ]
    },
    {
      "cluster_id": "89448e79-f7ef-4836-aa0c-f4044c4e1e16",
      "members": [
        "6be5c24a-fd13-42a4-aef3-2c7811909f68"
      ]
    },
    {
      "cluster_id": "0ecf145f-a19c-4bc9-bccf-6b5ec58579be",
      "members": [
        "6d97834d-047e-469c-966f-03494c01663a"
      ]
    },
    {
      "cluster_id": "ee80f2ab-f1d2-4dfc-bb99-e00e767727e3",
      "members": [
        "bcd00958-f1de-40a1-b1c1-5dbcc6a4a0f4"
      ]
    },
    {
      "cluster_id": "ab894abd-2889-40e1-91c4-3fbdf2be7626",
      "members": [
        "bf9263f8-2d55-4044-ab20-d275b56ab5b9"
      ]
    },
    {
      "cluster_id": "27eeb806-4cb4-4391-b4c7-c7f87a7b6cc2",
      "members": [
        "39cddfdc-f4fe-4d95-890f-6f9b9e217019"
      ]
    },
    {
      "cluster_id": "3cf933e5-8422-4f09-a822-8ef8b6385700",
      "members": [
        "995d8ddb-e382-4194-8310-0522f57d393b"
      ]
    },
    {
      "cluster_id": "2fb5602e-e1ec-4e01-ab46-f8e35a0df948",
      "members": [
        "364ac148-30c9-4ecf-92fa-825712d7a416"
      ]
    },
    {
      "cluster_id": "f2217761-bf63-4a79-b438-adbd2534e4d4",
      "members": [
        "b9bad6ff-5e99-4b92-a9dc-1e6badc97e55"
      ]
    },
    {
      "cluster_id": "2b2067b5-dfbb-4340-b88b-e5f769120fc0",
      "members": [
        "3dca0899-074f-4e9e-b91c-a9ca7458895b"
      ]
    },
    {
      "cluster_id": "55b3fec7-2c59-48a7-b144-2bc454de6078",
      "members": [
        "52a54493-a1f3-4f4c-a7d2-80b44206c556"
      ]
    },
    {
      "cluster_id": "621f1c2a-981d-47da-bf43-de2d73f4a594",
      "members": [
        "d29718e5-79a9-4622-b7d2-f27b220d6d99"
      ]
    },
    {
      "cluster_id": "d94f565d-7abc-403c-b060-eaad0916c690",
      "members": [
        "54363c74-3a5e-4a0e-a8b7-87b7a9ff59a3"
      ]
    },
    {
      "cluster_id": "338b82e5-bda1-47c8-a375-1c6600743697",
      "members": [
        "d9355a2b-e19e-408d-9457-938ec41f605d"
      ]
    },
    {
      "cluster_id": "6e905ee5-7953-41bc-bbb1-d9109f51ccff",
      "members": [
        "386e3406-a1dd-4833-be25-35db72e451dc"
      ]
    },
    {
      "cluster_id": "24b0b407-5974-4623-9570-6a7574f03b45",
      "members": [
        "524949dd-fb0e-4480-b88d-7595fb098a45"
      ]
    },
    {
      "cluster_id": "959de586-d5e2-49e4-92ad-27165bbe0cb1",
      "members": [
        "8af73905-0721-418e-a51c-4db9d4d3e8a8"
      ]
    },
    {
      "cluster_id": "1a5017d7-a85f-401a-9c3e-9a087de588f6",
      "members": [
        "415ec586-96fb-46fc-9faa-eaecc243e78e"
      ]
    },
    {
      "cluster_id": "5d455dbc-1091-4f62-8c3e-fdf2d7c2080e",
      "members": [
        "fcb12daf-7d52-4c56-b04d-e9777de122bf"
      ]
    },
    {
      "cluster_id": "592ed206-56a1-4eac-9ef2-85b6be103dc1",
      "members": [
        "385cdb80-f2c1-4e7b-87b1-c21abaad8d71"
      ]
    },
    {
      "cluster_id": "776ff44d-f39f-4f47-8ef5-a991b2a74ced",
      "members": [
        "a82d71b0-e478-478a-86f2-1e56e05e450f"
      ]
    },
    {
      "cluster_id": "61f48759-d4cb-40cb-8dc9-13b564dd8c1b",
      "members": [
        "276f71ec-ec4b-4616-a67f-383f7d4c239c"
      ]
    },
    {
      "cluster_id": "04b259ed-8fea-44d2-9f92-3e357be663b0",
      "members": [
        "55c5716f-2754-4c82-a473-893c45e6a6a7"
      ]
    },
    {
      "cluster_id": "4dd58e9c-790c-4f52-9fba-7f267f15da6d",
      "members": [
        "143587d4-ddc3-4475-9b44-e3d87618bc18"
      ]
    },
    {
      "cluster_id": "d191d96a-6233-4306-907d-1beabb6fc9c7",
      "members": [
        "cf2d3a88-17b8-4c10-8916-393a69b12b04"
      ]
    },
    {
      "cluster_id": "f45f3567-6577-44bd-b711-4eefb24f7df6",
      "members": [
        "cf5b4e71-5bd7-4fab-8dba-5b8915af2a53"
      ]
    },
    {
      "cluster_id": "546a15bc-833d-4e92-8945-cbee19b7d4ca",
      "members": [
        "45f128ba-256c-4b24-a061-347799ffdf5a"
      ]
    },
    {
      "cluster_id": "9b965f11-f5af-4e06-af27-db2a333f5008",
      "members": [
        "fee2129d-d97d-4fb2-9d74-9637bdb59a06"
      ]
    },
    {
      "cluster_id": "04c31a7d-6c2e-4822-91ce-feccb61d28bf",
      "members": [
        "e47653a8-b66a-4155-8f1d-5ee1ceff6d91"
      ]
    },
    {
      "cluster_id": "cb2e6a9c-ffbe-4a9d-a4eb-32e21489b61a",
      "members": [
        "5cbb827c-948e-49c9-8dd5-d0a3c9f52987"
      ]
    },
    {
      "cluster_id": "fd3d778c-3ff6-495b-bf3c-b5711ab1a974",
      "members": [
        "7d9cd478-80c2-4f33-9da9-39dedaddc105"
      ]
    },
    {
      "cluster_id": "22edb9f0-7d37-46a0-a499-0bf470746f3e",
      "members": [
        "00c6dc3b-e013-49d3-8cd8-6fc3710d5264"
      ]
    },
    {
      "cluster_id": "ec7f8d90-641e-4755-b398-833e150c7057",
      "members": [
        "05fac443-cceb-4ff9-82d6-297f6bd746a5"
      ]
    },
    {
      "cluster_id": "776c4ee1-eeec-4f70-91d9-12fdaa179052",
      "members": [
        "905ede65-2bde-4cde-a2cc-51e69c4841a3"
      ]
    },
    {
      "cluster_id": "49e33122-7ceb-4265-b315-038b5cf4ba76",
      "members": [
        "aa7c39a7-b7ed-4147-af04-ffa29e0276fc"
      ]
    },
    {
      "cluster_id": "adde58fd-6daf-4b35-b4c1-a6e18d15a403",
      "members": [
        "30d3dcb3-51fd-4a00-b9eb-4fdee73e7b1f"
      ]
    },
    {
      "cluster_id": "a6f8ca4a-31cf-437f-a2eb-06ee3b0285bd",
      "members": [
        "75372dd7-921d-4010-b871-f744e8212413"
      ]
    },
    {
      "cluster_id": "2ca6b1f5-ce3d-4e72-98a8-f750a42081ac",
      "members": [
        "07e01120-bfaf-4cc6-aeb4-cbf712f42a74"
      ]
    },
    {
      "cluster_id": "777a09d6-6401-47e3-a2d4-ee63f89442c3",
      "members": [
        "ee7c1668-aa54-45b9-8b75-e6487c07fc4c"
      ]
    },
    {
      "cluster_id": "a8a5c0a8-339b-46a8-844d-e6af4072cfdd",
      "members": [
        "d2220db0-db5f-4c1e-bfc5-00cd3d3f4183"
      ]
    },
    {
      "cluster_id": "23e0381e-2d65-4ba4-b3df-e26366f32cbc",
      "members": [
        "c30b115c-9aa9-44ae-9f91-7e78a0eda10e"
      ]
    },
    {
      "cluster_id": "83f04811-c07b-4cf2-8679-7397fef07ebd",
      "members": [
        "28664f7e-95c3-41b0-b55f-90f977f597e5"
      ]
    },
    {
      "cluster_id": "a6f2fc25-ee4d-4748-9248-d40e233dda78",
      "members": [
        "50c056c6-ad12-4d68-9434-436eb788332e"
      ]
    },
    {
      "cluster_id": "105a185e-0869-4f78-8bc2-ef2d7bd72e38",
      "members": [
        "092e9fe3-edeb-4793-935b-71936296b7ff"
      ]
    },
    {
      "cluster_id": "c112d6c9-6b2d-48f6-ae9b-5380b20f2025",
      "members": [
        "59ac563e-6e2c-4f61-9004-22e54664af0b"
      ]
    },
    {
      "cluster_id": "cffc59b0-977d-47ae-8b01-886477ecbcba",
      "members": [
        "dada36b1-14ac-4f44-a481-7bb7a0353c7d"
      ]
    },
    {
      "cluster_id": "11423356-cdd9-4f07-af4c-408d43e6e2c4",
      "members": [
        "0f6ab3e3-d049-4145-b966-c0ba7cb300b0"
      ]
    },
    {
      "cluster_id": "8351f868-a72b-47b0-8a87-867df6862124",
      "members": [
        "2b04da7b-8c50-416b-bc8d-bca755e48292"
      ]
    },
    {
      "cluster_id": "4b0f28fc-31f1-4217-b54f-8f9b8bb0dd43",
      "members": [
        "5b3e40f9-1d49-4afa-8300-d5b214d9714d"
      ]
    },
    {
      "cluster_id": "ae8f14c1-199b-4891-807b-1b7d4b91ad58",
      "members": [
        "d25e2ca8-7933-453e-bb0c-5bc632a1daa8",
        "09d0628e-e7ad-4fc7-a135-0d7f8e2f9cc5"
      ]
    },
    {
      "cluster_id": "e15d8f08-e424-41bc-9193-92e22c4d515c",
      "members": [
        "03f4e181-d8ed-4586-bffa-fa817f4d5187"
      ]
    },
    {
      "cluster_id": "6c30eaa7-fa21-463e-8143-13ed2522dbff",
      "members": [
        "4b4fe4cd-6bc4-4296-91d2-9122b258caba"
      ]
    },
    {
      "cluster_id": "2e0416ba-2a52-4d60-ab33-cf2ac09ef620",
      "members": [
        "3a2eafb7-4d99-4208-9c98-2089f8596efa"
      ]
    },
    {
      "cluster_id": "5ff5f55b-42b2-4238-8f0e-2306bf47cc82",
      "members": [
        "d9a09b32-3bc4-42c4-b070-f0e1739402be"
      ]
    },
    {
      "cluster_id": "0ed6d266-01da-4d89-816e-946754d220ce",
      "members": [
        "40ba8f2a-1fbe-4c32-b690-0f720622e862"
      ]
    },
    {
      "cluster_id": "0e83eeb4-b212-4ca1-a4ab-db7a128c6db1",
      "members": [
        "82b4341a-53c0-4a59-ba23-8a73dc03fb2e"
      ]
    },
    {
      "cluster_id": "ed5e7bda-f24a-4769-86cb-26613eecfebd",
      "members": [
        "5719f0b2-0825-4704-b1e1-1faadcdd9013"
      ]
    },
    {
      "cluster_id": "f7fe1cc8-30c8-4879-8f22-1fc4904694c6",
      "members": [
        "32904737-d2e6-461f-b57f-e569657b6a75"
      ]
    },
    {
      "cluster_id": "51cbaa1d-e1b7-494b-ab8c-dca8a0d96a68",
      "members": [
        "0dd6dd1c-6caa-490b-8269-f36c3a303578"
      ]
    },
    {
      "cluster_id": "bfeab18a-6cab-4e4c-ab1a-32ad52ac07e1",
      "members": [
        "25ec6b3b-539a-46fb-84b7-3b8309c4cc13"
      ]
    },
    {
      "cluster_id": "7db7f2ba-600c-4f51-9a31-321197123c7d",
      "members": [
        "7fb28bbf-180c-4473-9113-882b65c5206b"
      ]
    },
    {
      "cluster_id": "3ed099b8-1d1d-4e40-a70d-caf7e4853619",
      "members": [
        "f10cb692-543d-49a4-857e-12877e380eb0"
      ]
    },
    {
      "cluster_id": "e5554b00-9db0-47c0-964c-03cd848dbfe3",
      "members": [
        "08cac6a8-d53a-45df-8eb4-69e83b4100e8"
      ]
    },
    {
      "cluster_id": "2f0a7237-fd9a-4068-942a-5cae35e4e123",
      "members": [
        "7c7355c8-7251-4b57-b625-15ffe8465010"
      ]
    },
    {
      "cluster_id": "a04d6dcd-d345-4928-a6be-52f446062bc1",
      "members": [
        "a2d32119-8579-4773-a14d-17c148d585f6"
      ]
    },
    {
      "cluster_id": "5fca9556-7877-4bc1-82fb-6f88c867de71",
      "members": [
        "ecb1e2cc-e360-413a-9967-4b191fbe214c"
      ]
    },
    {
      "cluster_id": "524147a4-6ced-4285-aba9-4ef213b856f6",
      "members": [
        "80d79466-d5eb-40ec-9fa3-c2e30b7d4853"
      ]
    },
    {
      "cluster_id": "ec8073ca-bd09-4811-94f5-faa29b947d90",
      "members": [
        "dd94afd5-f875-436b-a036-109f54ec57dd"
      ]
    },
    {
      "cluster_id": "a7ec7df3-d64e-4466-8dc5-ac899f0c0d28",
      "members": [
        "2ffb4703-e038-4783-a17d-d64c64fa7329"
      ]
    },
    {
      "cluster_id": "dd1b900d-edc5-41a8-a7b7-0e0de59cf33e",
      "members": [
        "fafaffcc-17b9-4fc3-a16c-a6276bf6a408"
      ]
    },
    {
      "cluster_id": "de0d9b6c-1e5a-4ebd-af0a-cb9e36b1417c",
      "members": [
        "1d8b5dfe-e2fb-44a5-8964-15e3019279e7"
      ]
    },
    {
      "cluster_id": "eebd5cfb-feb1-4a5e-af2c-b6604b0d1aba",
      "members": [
        "41ffb9af-a0bd-4b01-9832-3827139dccf1"
      ]
    },
    {
      "cluster_id": "56bced3d-5502-4c62-9756-ced2f88eec36",
      "members": [
        "979b79bb-6bd4-4caa-b906-65b94d6ba290"
      ]
    },
    {
      "cluster_id": "86cdbb00-bf89-4bf4-b9b5-585743288546",
      "members": [
        "64904b12-3744-4597-9b3f-eab26aff9e46"
      ]
    },
    {
      "cluster_id": "780710ee-898c-4548-a5aa-7eb3c45e169a",
      "members": [
        "fef83bef-545f-48a1-a0a7-75f37f5f1858"
      ]
    },
    {
      "cluster_id": "25f3e976-9943-4b37-b0c9-b84c0952ccb4",
      "members": [
        "877b6b14-efb4-4221-ada1-e753e29887e7"
      ]
    },
    {
      "cluster_id": "31d03aa7-f36f-4c28-8ed1-5c9c9c77acf6",
      "members": [
        "bfa7eaac-7dce-4860-8984-9b0d09ebaf65"
      ]
    },
    {
      "cluster_id": "0e4e78e3-4606-4902-b549-07174e100568",
      "members": [
        "a3565498-b868-4dee-98d8-d5f4cfe859f7"
      ]
    },
    {
      "cluster_id": "a8fe9f9c-6b4f-45e8-a4dc-fab2a57284cf",
      "members": [
        "c09a83e1-da13-4197-9fc1-9729ee98abc0"
      ]
    },
    {
      "cluster_id": "2f2fd953-8be4-4011-bcf6-98e5b07a9282",
      "members": [
        "6749d1a6-9d9c-4e30-9471-ba8f0b197ef7"
      ]
    },
    {
      "cluster_id": "eeeaa7c5-23d3-447d-ace4-2782329b8bb9",
      "members": [
        "b0f38eca-6284-4ad5-967a-44d6f6e8f67e"
      ]
    },
    {
      "cluster_id": "8179c546-cd47-4baf-897a-a15a8afbb9e6",
      "members": [
        "b1c980d2-d3eb-497c-945b-254679571688"
      ]
    },
    {
      "cluster_id": "3a13abc2-f39c-460b-8768-7ccf1b11b40f",
      "members": [
        "b6091d9e-a2b3-424d-8756-d1f506d1b604",
        "5da602a2-f68a-4e2a-8e3a-9e3ace51e706"
      ]
    },
    {
      "cluster_id": "54390be0-8660-4904-8b7d-c97b603bc1ce",
      "members": [
        "fe5d9d42-98ef-42db-91ca-5f80eda25774"
      ]
    },
    {
      "cluster_id": "151926b8-a45a-4f2f-9fc4-2a654d1c3ebc",
      "members": [
        "25b36395-e166-48c3-afce-86e3849d8755"
      ]
    },
    {
      "cluster_id": "5534af16-de3c-4c33-b0b7-ecff69356f24",
      "members": [
        "41aaa320-17d7-49de-a85a-bbe111a655f4"
      ]
    },
    {
      "cluster_id": "7180dea2-3c60-4f47-892a-7e623057b51b",
      "members": [
        "38c15e85-f56c-4be8-9020-a8e980c44144"
      ]
    },
    {
      "cluster_id": "4606c4da-4d5c-4ad6-8119-d1b70a950373",
      "members": [
        "066d3cca-8042-450a-8414-fb6add35cecb"
      ]
    },
    {
      "cluster_id": "6fb56d95-1435-4a1c-8bf2-454a172c105f",
      "members": [
        "1b913efb-1993-4461-a72e-8aabce43888a"
      ]
    },
    {
      "cluster_id": "13bb7753-ee8b-4817-baa5-471bea919fc8",
      "members": [
        "620b1bc5-aa6e-441e-a9bd-de9626f41b53"
      ]
    },
    {
      "cluster_id": "7b6712d2-df6d-4fa5-944c-8d0321a2652c",
      "members": [
        "0144f644-bffa-4efd-8e68-585abcf16d87"
      ]
    },
    {
      "cluster_id": "4ea543a7-37aa-415b-8870-050c7ede5ba0",
      "members": [
        "72bcb16a-5839-41d2-93dc-7d6b586981bb"
      ]
    },
    {
      "cluster_id": "3e2b1f73-9c36-499a-910a-db947f38acee",
      "members": [
        "f367d46a-f3fc-456a-856e-1c1287aadc11"
      ]
    },
    {
      "cluster_id": "1f558072-4f79-45c5-acb2-7e178149e980",
      "members": [
        "dc14cbdb-9f5d-4046-bf54-40d22463897e"
      ]
    },
    {
      "cluster_id": "2006ffe8-e5ea-49eb-8208-12ce96b310e4",
      "members": [
        "243e3702-8b47-4ed2-b0ec-a2b37d7ab8f0"
      ]
    },
    {
      "cluster_id": "2fb74668-36fe-4d43-9c95-f7bf88e2f60c",
      "members": [
        "9b753a16-292c-484e-b4b7-02a71a1bad0e"
      ]
    },
    {
      "cluster_id": "7e9bdb50-a12f-4215-9c08-0927124e5707",
      "members": [
        "56462797-c178-4883-943c-1dca4ad80a4b"
      ]
    },
    {
      "cluster_id": "4294101c-07cb-4434-a277-aca60564390c",
      "members": [
        "d4769905-3316-4a21-8214-2138b5a9aa39"
      ]
    },
    {
      "cluster_id": "a3d2d431-d86a-4c7d-bd04-db410111f7fb",
      "members": [
        "cd638490-7a6a-4ada-8d87-7cdb447ed0b9"
      ]
    },
    {
      "cluster_id": "2ff5a9aa-c10f-4f8d-a47a-0ec077d3ef51",
      "members": [
        "d1ea88c1-6075-4f84-98f8-b0fa69033a82"
      ]
    },
    {
      "cluster_id": "4a075bc4-4bea-4ec1-8783-33d17452523a",
      "members": [
        "e91616a9-c2d0-434b-9538-31cde29fd76b"
      ]
    },
    {
      "cluster_id": "06e477a1-87e5-42ae-a235-8227d3b39fe3",
      "members": [
        "4de50317-2d5e-4c28-81f0-b14104e62927"
      ]
    },
    {
      "cluster_id": "12c2b7dd-5504-45ff-b24f-40b180021ec2",
      "members": [
        "42ad553c-6f40-4a73-ae6f-7337824588c9"
      ]
    },
    {
      "cluster_id": "00c86245-5e91-487e-8809-1bcfd15888ae",
      "members": [
        "1b6b8aea-ce45-4e28-8040-ade69307404e"
      ]
    },
    {
      "cluster_id": "5d7bc6cf-96a0-42e0-b05d-1ff4cdfe4b5f",
      "members": [
        "e1b1a414-9823-46ba-81df-abb066162bf5"
      ]
    },
    {
      "cluster_id": "78e60a12-a4a3-4c5d-805d-471d75987612",
      "members": [
        "407d66ee-056c-4ffa-9954-8a74ec5c3b1b"
      ]
    },
    {
      "cluster_id": "d7fa6886-1236-4402-9039-11c8f678ba45",
      "members": [
        "d6febbd5-eae9-4696-9e65-20492eaa8e26"
      ]
    },
    {
      "cluster_id": "85949bd1-40e8-47bc-acf7-cb049a4e425e",
      "members": [
        "27679405-42ca-4355-958e-fadb11d9dd69"
      ]
    },
    {
      "cluster_id": "ecd748e3-d837-4992-8ea5-50edc6e9e5f6",
      "members": [
        "7a1ea26b-a1aa-469c-9031-a0db6bd82d4a"
      ]
    },
    {
      "cluster_id": "800819aa-dd64-46d5-8bb3-ebc4802f59be",
      "members": [
        "f86adeee-5f1c-4906-8955-07542f945de7"
      ]
    },
    {
      "cluster_id": "9d45e016-7740-4b71-ac88-57c1dbc80615",
      "members": [
        "54e28690-5822-4639-b568-f547d5ecad19"
      ]
    },
    {
      "cluster_id": "94fcf1c1-17a1-4318-9032-ad180a9a74cc",
      "members": [
        "874f2a98-10f6-4186-b788-e5f7826dc4ed"
      ]
    },
    {
      "cluster_id": "3871b01c-7dc4-4fb6-92f9-6bc76f4cf80c",
      "members": [
        "5d294d4c-e97f-4a51-b0c8-88f18c467fb0"
      ]
    },
    {
      "cluster_id": "bfcb4fd5-03ad-4398-a7b4-f52617946935",
      "members": [
        "a534d6f6-34a8-4f0f-b375-b2b83ea47d27"
      ]
    },
    {
      "cluster_id": "cfa7b687-2383-40f8-9684-b8b6e91149cc",
      "members": [
        "f9d39220-fa21-4386-8859-b7e2ca80ef00"
      ]
    },
    {
      "cluster_id": "93758357-874e-446c-984f-888b0a1aee47",
      "members": [
        "00318f36-a42f-4b3a-9739-a85e63103be5"
      ]
    },
    {
      "cluster_id": "c4a711fd-1857-4f2e-beaa-2df948c3bf31",
      "members": [
        "0ea469ee-c86a-4d73-980b-964935d52068"
      ]
    },
    {
      "cluster_id": "e4e83b34-5f5f-4d12-be7d-278344e0b336",
      "members": [
        "51d90631-d52d-4811-8d5d-390241030925"
      ]
    },
    {
      "cluster_id": "4236f047-bfc1-46a9-8b89-2b002fe42dc4",
      "members": [
        "eb7d24b5-dd65-427e-b171-f83cb4ce37ca"
      ]
    },
    {
      "cluster_id": "b33db570-415f-43c3-b381-72179faa3148",
      "members": [
        "1668bca7-ec75-4980-9c6f-2f91621c8981"
      ]
    },
    {
      "cluster_id": "49e46347-a3d3-4b80-a516-3dc4bfcbd3b7",
      "members": [
        "94beb342-e1fb-4100-aa6f-1661c906c314"
      ]
    },
    {
      "cluster_id": "eb4cf940-96c8-499d-b7a7-939513787944",
      "members": [
        "d71e764e-7568-4baa-9373-b319e67238c8"
      ]
    },
    {
      "cluster_id": "edf45ed0-2320-4899-9b2b-3485b276ff56",
      "members": [
        "e26652dd-c02a-45ad-a807-9f1b18347fb4"
      ]
    },
    {
      "cluster_id": "fe1f6ba0-f663-4ffd-9fda-c7a1f4f8e99d",
      "members": [
        "2c09731a-0975-4ada-93a5-34b70eec8e89"
      ]
    },
    {
      "cluster_id": "60f1f675-db08-4cfb-a9e3-20e14baf899f",
      "members": [
        "fe263f5f-c718-4788-a50d-e142151e69f2"
      ]
    },
    {
      "cluster_id": "3f6252b1-52a5-4e4b-a596-99c6a237551b",
      "members": [
        "255d4da1-6d25-4946-9414-1fc9ca446238"
      ]
    },
    {
      "cluster_id": "95bbf098-c966-4fbc-93df-23d227e7ee92",
      "members": [
        "c716c947-f36c-40a2-b826-319d84ccd492"
      ]
    },
    {
      "cluster_id": "388a333e-2008-4c61-8154-a9e224b365b3",
      "members": [
        "8551716c-4da8-4042-a80f-e628da5cfbb5"
      ]
    },
    {
      "cluster_id": "ec6a0d33-6433-4fbc-b666-83c9c378399c",
      "members": [
        "ab4d7d4e-92fb-4d09-860c-470c3843c20a"
      ]
    },
    {
      "cluster_id": "553f1291-956b-45d5-9567-97bf2439ca2b",
      "members": [
        "ac6ea0a5-f6a6-47e0-9521-c3143bb2d59e"
      ]
    },
    {
      "cluster_id": "092693ec-ddb5-4cdf-be96-1d6ac20b489b",
      "members": [
        "0d812208-be9a-41ba-8217-ddce9b7193c7"
      ]
    },
    {
      "cluster_id": "53ab10ad-1f0b-48bb-90af-3977fee7f1cb",
      "members": [
        "dfdd0511-b751-45f9-b860-20d88b28629c"
      ]
    },
    {
      "cluster_id": "c1d6fe8d-9eec-42fb-a300-6a6e37dcd1f2",
      "members": [
        "c2b67055-8042-4c98-8194-7993aceb4896"
      ]
    },
    {
      "cluster_id": "acdd7a89-aa71-4db5-beb7-130a3813dd88",
      "members": [
        "b7ec77ee-9594-4b8b-97ba-8ad5890bdfb3"
      ]
    },
    {
      "cluster_id": "fcb8985c-e271-4f8a-9ba5-ab287203d1d8",
      "members": [
        "ab2a0598-91d2-4ea9-bd43-4e87e8119b4d"
      ]
    },
    {
      "cluster_id": "089384c1-0ce2-49fe-812c-a7e86deaedaf",
      "members": [
        "f041e3c4-8af0-49e2-a036-f8aad3b7c75a"
      ]
    },
    {
      "cluster_id": "b1c829c5-5bbf-4809-a139-ca7f221f5d55",
      "members": [
        "9ec6bca3-2ada-4c9b-b92b-1401c547e3ca"
      ]
    },
    {
      "cluster_id": "5450c124-f70b-4739-a4ce-8408866030e3",
      "members": [
        "a7fe1c2a-2e3a-4fc2-b5bd-545f80fd50e3"
      ]
    },
    {
      "cluster_id": "82cece60-3255-4d43-a228-e34efd18c27a",
      "members": [
        "991600ba-725f-4885-bd82-8f65e7004314"
      ]
    },
    {
      "cluster_id": "4ca6827b-b30a-4210-a329-a338c23874a3",
      "members": [
        "e8b9df1e-a9df-41f2-a58d-9757cbfde177"
      ]
    },
    {
      "cluster_id": "0060e859-7676-43d1-9a21-c2ddc4f18fbb",
      "members": [
        "3502743f-3377-4385-84ca-0faa22970d7d"
      ]
    },
    {
      "cluster_id": "ea5e4d14-d784-48f0-ab38-f454314db96b",
      "members": [
        "cf694b11-5df9-4934-becc-c79b9f39d996"
      ]
    },
    {
      "cluster_id": "3f91e02f-ab23-4d35-ac70-4b14b0545030",
      "members": [
        "d5e301d8-602e-4994-b9c6-e12ad3ed9440"
      ]
    },
    {
      "cluster_id": "c7fea8d2-cc9a-4113-be0c-ac48857e6432",
      "members": [
        "831cecf9-8b31-4512-867c-607e42777deb"
      ]
    },
    {
      "cluster_id": "add8105a-2d0f-4f9d-9f00-f11f0673121c",
      "members": [
        "6288e6e4-82d9-467a-8a64-a03fad274591"
      ]
    },
    {
      "cluster_id": "ebed0c7e-1e7f-4dd0-9028-668b74f8c629",
      "members": [
        "b397d863-3c35-434f-b821-58e2a9adc787"
      ]
    },
    {
      "cluster_id": "0d187a90-37da-4e4b-a2f0-e217ce5cbf79",
      "members": [
        "cf23fdff-9ba9-4d57-adea-fb5f00be4898"
      ]
    },
    {
      "cluster_id": "f04b87e3-ae1b-4e57-8c7a-f468d2163699",
      "members": [
        "ef6647c9-5e6c-4e11-9d27-f848ac5a2df8"
      ]
    },
    {
      "cluster_id": "7b8193fc-3e2e-459f-9d2c-f5d5c9d7a1b0",
      "members": [
        "78b7211b-abf0-486e-9133-264e33b0dd2e"
      ]
    },
    {
      "cluster_id": "dfe985d2-9dfe-4657-be1d-a745b7ca1ca6",
      "members": [
        "aea23b1b-a75a-44d1-a018-4b0952e651b8"
      ]
    },
    {
      "cluster_id": "1379aa81-833f-453a-8fb7-08ae39840196",
      "members": [
        "a0145699-ea4f-41dd-9bb3-a1f701e8732a"
      ]
    },
    {
      "cluster_id": "afb76d5a-b98d-4292-ba1f-8d4ecc4a368a",
      "members": [
        "6b815d11-f965-414f-b04f-38078bccc1d2"
      ]
    },
    {
      "cluster_id": "65c4b6f4-f33a-4b23-a073-15587ff25d75",
      "members": [
        "5d9d7d0c-e16b-4987-9c51-34a858aed7cc"
      ]
    },
    {
      "cluster_id": "2b4c9e75-4679-4e5b-8a08-08bb2c621974",
      "members": [
        "bcabb37c-2778-4f34-beae-87714ad4fa2a"
      ]
    },
    {
      "cluster_id": "5c9296c9-7461-4417-aa55-8ba44cdddfec",
      "members": [
        "5f28ddc2-3522-430f-87d6-316dc67120a0"
      ]
    },
    {
      "cluster_id": "ea50bb1c-1d0d-46d0-8c9e-6b1bcd539913",
      "members": [
        "11b4193a-8eda-40f7-895f-3eae3fc69a76"
      ]
    },
    {
      "cluster_id": "84f58721-c200-46df-b038-aa93f32b79c6",
      "members": [
        "42972dba-af6c-41fc-8772-d27c793c1d53"
      ]
    },
    {
      "cluster_id": "c7898fe7-8ae8-4977-88ae-a56e6d146778",
      "members": [
        "9447caab-570e-4091-9c8b-4d5f9ad1e7ea"
      ]
    },
    {
      "cluster_id": "2253ac9a-3adc-46d3-a973-f064ce69f740",
      "members": [
        "80ef50db-23dc-47eb-aff4-2203eb2d93a3"
      ]
    },
    {
      "cluster_id": "5535ff65-262d-4c0d-a8e9-0c0a87d3ccdf",
      "members": [
        "71ffd1b8-747c-4378-a479-dc3272327150"
      ]
    },
    {
      "cluster_id": "e014d650-8fca-4dde-a60f-f8576ce7542f",
      "members": [
        "cc0250a3-78fb-45b6-bff5-ab59b69e6bbb"
      ]
    },
    {
      "cluster_id": "38a91236-7bbc-4335-9d5a-a470b70f608c",
      "members": [
        "def94eb5-d1cf-4555-a291-c616a355a307"
      ]
    },
    {
      "cluster_id": "d88b95f4-1e38-4dd6-b178-e63adfad4ea7",
      "members": [
        "3e32d9b4-ae18-4f58-b37a-7e9d55df3f0d"
      ]
    },
    {
      "cluster_id": "2ca744d4-a598-4453-abb6-08ac069370e3",
      "members": [
        "46a4931e-56c9-4d44-ab93-dea353a3591b"
      ]
    },
    {
      "cluster_id": "5bee647b-e5d6-4ab0-b317-a48d3ac0cc11",
      "members": [
        "a3edd026-9660-497c-ba20-f26eaeb8a066"
      ]
    },
    {
      "cluster_id": "e8d1e306-3805-48a6-8fe7-8350cb762a36",
      "members": [
        "8cbf4cf4-98fb-40c6-98b5-f4f3d4216956"
      ]
    },
    {
      "cluster_id": "aa149821-edf1-47da-a3a7-3f82f411bb32",
      "members": [
        "0dc10a52-de59-4fae-8678-4ab5b33e6bbe"
      ]
    },
    {
      "cluster_id": "bdc29925-59ca-47f1-8fcb-329866ae2601",
      "members": [
        "62e0f624-06d0-4606-820f-7615dbc6bebf"
      ]
    },
    {
      "cluster_id": "e6294e0b-891d-4ba7-af93-8aa8ed47eeab",
      "members": [
        "3cf927ce-0606-49c9-a8f3-2958023999a2"
      ]
    },
    {
      "cluster_id": "6ad9a81e-b42d-45d2-9083-3274cf3a2137",
      "members": [
        "1add4e30-cd25-492a-8b9f-a4b8d5fe5750"
      ]
    },
    {
      "cluster_id": "0e8414db-df98-41e4-b595-a6e3b96bc6df",
      "members": [
        "2473eb4f-2c43-4bdc-988e-6373f7312394"
      ]
    },
    {
      "cluster_id": "6b03b394-3970-4d06-bfbc-01183e585200",
      "members": [
        "76635dbe-afb2-4636-b758-4cb44e7787f7"
      ]
    },
    {
      "cluster_id": "4f2c99ad-9a7b-43ad-b8d0-304aa8cd2c73",
      "members": [
        "49a0a2f5-6976-43f4-ab33-7721a4580cfd"
      ]
    },
    {
      "cluster_id": "6150a21f-6d1d-4554-8cbb-b01623349756",
      "members": [
        "99d4ff25-e52e-42cb-9bbb-331504d00d24"
      ]
    },
    {
      "cluster_id": "f5af21c1-57be-4378-ab8c-5400cfed6bff",
      "members": [
        "bfc5a568-ce9d-4379-81ae-c95f7db0f346",
        "609fc20d-fab3-4131-b0c2-6231bd2b0971"
      ]
    },
    {
      "cluster_id": "d73adbe1-7dcc-4345-a67c-e7d102fbc24d",
      "members": [
        "c5556274-2955-4223-93e9-febbbc593ac0"
      ]
    },
    {
      "cluster_id": "eecfdbc7-a037-435d-b439-dc9fb3713fa6",
      "members": [
        "749c573f-6d99-43d1-93e1-1aeb776bd723"
      ]
    },
    {
      "cluster_id": "199fa239-0e31-40e8-a4f6-178a14d58cc8",
      "members": [
        "c50a2138-0b86-4f47-aee6-dda205328aef"
      ]
    },
    {
      "cluster_id": "b5d6d05a-3d31-4ce5-aa84-cf94365c8485",
      "members": [
        "af70fd3c-0f4e-49f3-b25a-63935cd5ea6c"
      ]
    },
    {
      "cluster_id": "75482488-ef21-4630-bf12-4747cdb69136",
      "members": [
        "48c11cdf-4764-4cd2-911e-469e9ec3135c"
      ]
    },
    {
      "cluster_id": "8c73e80e-645f-41d1-b314-c8d7737bd33f",
      "members": [
        "7f4a044e-a00c-47ee-8282-f045a93d6dbb"
      ]
    },
    {
      "cluster_id": "fef26a04-5ec2-47de-9b9c-92eaaae9e544",
      "members": [
        "daab206a-46c6-42b9-86bd-4772d61d43bf"
      ]
    },
    {
      "cluster_id": "3128448b-d77b-4666-b5fa-39d7bf0fea69",
      "members": [
        "4ff9dd85-321e-4fc1-b596-2519e34295c6"
      ]
    },
    {
      "cluster_id": "2d485df8-2925-4317-a6b0-216006ba9fa5",
      "members": [
        "2cd437e5-7618-46c4-8169-8a22df9219c1"
      ]
    },
    {
      "cluster_id": "d0699d4c-25e1-439a-a44a-9bca30bebb35",
      "members": [
        "cc45c3e8-7e6b-4f81-b0b9-56a2ab01839f"
      ]
    },
    {
      "cluster_id": "38992305-30d9-47ce-bb30-bfa120506e54",
      "members": [
        "49c95f25-4fc2-48e0-a4c2-13cd04a0be14"
      ]
    },
    {
      "cluster_id": "465883de-cd6a-47dc-b0f3-f22e0ff902ba",
      "members": [
        "47cedce3-3262-4105-9c19-91971028dc17"
      ]
    },
    {
      "cluster_id": "7301fbf5-a19c-4247-aac6-e3d55981cf96",
      "members": [
        "91c29cf1-50ac-4fda-8387-a45e9eb86d48"
      ]
    },
    {
      "cluster_id": "1a427c1e-6df0-4798-aa10-9a17d3c392c0",
      "members": [
        "100a5f92-308e-45c1-b373-656f0ac8ba61"
      ]
    },
    {
      "cluster_id": "8693ba93-793a-4911-b2e4-5cb419139802",
      "members": [
        "3bc6623e-2517-4386-b3ef-1a6ef5e48177"
      ]
    },
    {
      "cluster_id": "733fc34a-7676-43b2-bd68-29d000ed566d",
      "members": [
        "100835ae-6e8a-409d-ab1f-849e3e442927"
      ]
    },
    {
      "cluster_id": "95cf8fc0-eadb-4c70-8762-0c3f65726aa4",
      "members": [
        "b7badbe4-1480-4740-84af-86c7523a433a"
      ]
    },
    {
      "cluster_id": "43cb3cb0-9dc6-46db-91b7-d99bcaa7a443",
      "members": [
        "33dd84d3-8730-4bb5-9380-23b417b5e4d0"
      ]
    },
    {
      "cluster_id": "d3157e1e-5fca-47d3-93bf-fb77fbc5070d",
      "members": [
        "0b7dc1e2-ab56-4b33-ac54-7cdeb5f16390"
      ]
    },
    {
      "cluster_id": "40467831-07ba-4c26-8f13-029707ea2660",
      "members": [
        "0a61ddef-0a7a-4d1f-8d16-65bd35c1ffc9"
      ]
    },
    {
      "cluster_id": "2d060fd1-76c9-470d-941c-4c8d800b380a",
      "members": [
        "03770f87-b530-494b-839a-699441af95f4"
      ]
    },
    {
      "cluster_id": "6cadfbb6-c995-4a61-9bf9-357705f879c1",
      "members": [
        "97993de4-36d6-40a8-8ee4-74fe9a971f9d"
      ]
    },
    {
      "cluster_id": "2dbc4a6b-98c2-45e2-be58-a00cfa47819c",
      "members": [
        "17e66a98-25a6-493f-8ac5-75dac9dd5953"
      ]
    },
    {
      "cluster_id": "1e2f3c33-51a9-4ade-8539-40a4bc9cfff8",
      "members": [
        "e61b707f-b13b-4fbc-a817-8cb29c1838de"
      ]
    },
    {
      "cluster_id": "8812088d-8004-44b8-9f99-4965a38e2031",
      "members": [
        "66122d9b-07b9-4336-a64a-2554a7ecc4bb"
      ]
    },
    {
      "cluster_id": "67eaacee-8b2a-42e6-980c-72585c0bb525",
      "members": [
        "8418add7-2b09-4307-b140-1777e2bffd7b"
      ]
    },
    {
      "cluster_id": "a8b81223-8089-44d9-8780-1c910b2a64e2",
      "members": [
        "236fab75-12fe-470c-a805-30e262f615e1"
      ]
    },
    {
      "cluster_id": "a222cb65-167b-49af-b5d2-9f2a8169e28d",
      "members": [
        "4b0ef420-0f8d-4887-98c1-ba44f430b107"
      ]
    },
    {
      "cluster_id": "1936e9be-7524-40a3-aeef-be93dc5f5e4c",
      "members": [
        "f7986f09-a424-4730-91d8-7184938981d1"
      ]
    },
    {
      "cluster_id": "d56cee1a-0acc-4d28-9308-a2519fc04041",
      "members": [
        "6f6b7766-153e-495c-8bb7-c1fe489a04dd"
      ]
    },
    {
      "cluster_id": "e1b119bd-f317-4a5f-8c26-1f7c12a78710",
      "members": [
        "e109c0a7-b9f8-47fb-8dec-aabcf71b1533"
      ]
    },
    {
      "cluster_id": "984977b5-907e-47e8-b70e-4d24066b2265",
      "members": [
        "0b7e45d3-6556-44e5-a308-6ecaeed877bd"
      ]
    },
    {
      "cluster_id": "cef3ea24-b5a3-4eec-87c9-03935082f43c",
      "members": [
        "ea0c236f-635a-4b74-b1a1-5663336c4c92"
      ]
    },
    {
      "cluster_id": "d8c99eb9-8781-4abc-9592-b545d9c15ce0",
      "members": [
        "18ae0cbe-1331-4340-b56a-5c85bc9c3939"
      ]
    },
    {
      "cluster_id": "747b93ff-87de-4a18-a76c-e68485fa2bed",
      "members": [
        "a15d5adb-b4d5-4ea9-97a6-1ea64e048da2"
      ]
    },
    {
      "cluster_id": "7303fe0f-e412-4fb9-accf-41194e4059f2",
      "members": [
        "5159d09a-626f-4ef3-b9eb-e1a360dd8787"
      ]
    },
    {
      "cluster_id": "268b0686-4ead-44df-9f34-76aeb864e839",
      "members": [
        "7f1c8ce2-f14a-40ce-80d7-fcb2fcb8a938"
      ]
    },
    {
      "cluster_id": "69d7ee2c-955b-4d7c-a4fa-16491444b045",
      "members": [
        "c248d4d9-7e12-4ee9-8273-2c7baa433d29"
      ]
    },
    {
      "cluster_id": "e500e465-a022-48fb-afd5-82c02df96bbc",
      "members": [
        "25ac0643-8c95-4de8-8761-28dfeb1e494c"
      ]
    },
    {
      "cluster_id": "ff6f2ca1-7367-40eb-b2f8-72fa90168057",
      "members": [
        "94ae7d73-7c37-4d4d-81d5-f34cb67332c7"
      ]
    },
    {
      "cluster_id": "28c6e890-bb36-4eff-b0b6-22f2850f023d",
      "members": [
        "b5a0b1ab-b754-4668-8df3-ac0730010494"
      ]
    },
    {
      "cluster_id": "0594b862-5f0d-4a2a-9cbb-4d9d2192ea9f",
      "members": [
        "11a0d2b6-f308-41e0-a22b-006339445092"
      ]
    },
    {
      "cluster_id": "6cd72072-03f7-4b6f-a5d4-4465c298c295",
      "members": [
        "90adc281-7853-41dc-95c0-1d93ff441625"
      ]
    },
    {
      "cluster_id": "ab08e2a8-8249-4477-b0dc-0a3c5235d6a7",
      "members": [
        "65f3b7a8-60c7-4efa-a179-748ce3d57066"
      ]
    },
    {
      "cluster_id": "4061c2fc-ed9c-4f22-92dd-291aa2df6a90",
      "members": [
        "b834e80c-57e4-4c4e-9364-a6ce35f05cef",
        "5dc728d9-13a8-47fc-b9f3-ae98951350e8"
      ]
    },
    {
      "cluster_id": "3775dc56-2d8e-428a-9c60-ba993c0f4ba7",
      "members": [
        "d08075a0-da02-4f6d-9e2f-471a31fbe88a",
        "088f6d76-5154-4348-a832-9c9c301aca64"
      ]
    },
    {
      "cluster_id": "c83ee9d9-24f2-4221-bbfd-6aeb1c7db66f",
      "members": [
        "28b6dc91-8158-42e8-b45b-ef79f26080f6"
      ]
    },
    {
      "cluster_id": "95caea6a-ff66-40ac-9167-0fca6baadbff",
      "members": [
        "7216020d-38a5-4789-8bf9-8b552e21b881"
      ]
    },
    {
      "cluster_id": "314510db-f67d-4268-b068-13a87261ae5b",
      "members": [
        "563d2ebd-745e-44e1-8475-c15c1c9fe8ef"
      ]
    },
    {
      "cluster_id": "9427cf91-1580-41ef-aaf0-2efa82b46d41",
      "members": [
        "ac95df98-1a59-45d0-a7f8-02a1ccf486ac"
      ]
    },
    {
      "cluster_id": "028c0dd0-ac64-47ea-94f9-5c74b9d66731",
      "members": [
        "f3a22222-3f26-4d41-8ae4-ec2eec8e359d"
      ]
    },
    {
      "cluster_id": "0bf33c34-9525-433f-a535-5885b1ee4732",
      "members": [
        "52949534-ad9a-45bf-97df-7560f69a8480"
      ]
    },
    {
      "cluster_id": "1da8672c-062d-456c-b508-fef471a32245",
      "members": [
        "7e554a7b-d9be-49df-877b-d884572747c1"
      ]
    },
    {
      "cluster_id": "4d3fc72a-c96e-4659-afda-27c7ce47c497",
      "members": [
        "0dfb5183-818a-4a43-a434-b3172805c9d8",
        "b74b70e7-c83f-41d9-bcc8-9d6a97dabe5d"
      ]
    },
    {
      "cluster_id": "8d628785-9843-475a-bf8c-f7eff1bc8e38",
      "members": [
        "057415f7-0a69-4ad7-81cf-5bf03120bb5b"
      ]
    },
    {
      "cluster_id": "88a95916-de94-4c29-849b-89f8018ddf03",
      "members": [
        "14cf000c-8c1e-4720-9adf-7bde0c3f5147"
      ]
    },
    {
      "cluster_id": "a9574820-7af4-4109-8e6e-9d95f9ba6cbd",
      "members": [
        "df08cb44-ecf0-470d-9612-05f33a1bd3be"
      ]
    },
    {
      "cluster_id": "4c83d9ff-1e62-4a28-b3d2-a667fb4041d7",
      "members": [
        "71e43c54-8546-43f0-8584-9a3b81e73792"
      ]
    },
    {
      "cluster_id": "1373b88b-91da-4b7d-bc67-e2f0449d0283",
      "members": [
        "52aa91a5-8d8b-4866-8a15-a467ddeb84d3"
      ]
    },
    {
      "cluster_id": "2bd21a46-0627-4917-ba75-98775bf2627b",
      "members": [
        "1f00bdc8-2cc0-4ec2-ad34-86ee8a82ebdb"
      ]
    },
    {
      "cluster_id": "ad2e25ad-1bb4-4fa6-8af1-bce0c9f8c697",
      "members": [
        "75b4df13-6fdf-41f5-9548-45d77a05afef"
      ]
    },
    {
      "cluster_id": "ec7138ff-1f97-4076-a56b-198783100d75",
      "members": [
        "7f5a768b-f8ae-4844-b7cb-a83633d09cbe"
      ]
    },
    {
      "cluster_id": "e73cd951-c537-451f-a279-08d6827059e5",
      "members": [
        "c7300144-20ac-4f8d-b8db-56dc189b6f68"
      ]
    },
    {
      "cluster_id": "9b47f058-2394-458a-97b4-e9b218a76e1d",
      "members": [
        "21d7ba1d-2d43-4b90-874e-3fd3b70de5a7"
      ]
    },
    {
      "cluster_id": "c0d885cd-8830-4032-af1c-4955d65db09a",
      "members": [
        "27413585-74ac-42fd-a64a-9526033ba7b5"
      ]
    },
    {
      "cluster_id": "1e13c242-ece9-4014-9237-1eaa4afdacf0",
      "members": [
        "4b503e26-b164-4d01-8cfb-e3cb93f6f278"
      ]
    },
    {
      "cluster_id": "729cc7ae-ca2f-4e76-9131-41ad0335ecdf",
      "members": [
        "7d12d99d-5ec0-47fb-a7fc-15b34faea721"
      ]
    },
    {
      "cluster_id": "67cff5df-1bcb-4edc-af42-99ff9df792c5",
      "members": [
        "28b169fe-6d66-4d61-9e75-cffde783f4a0"
      ]
    },
    {
      "cluster_id": "5062ec52-04a9-40ad-82e8-e7b18ce41e9a",
      "members": [
        "2344c640-395e-4645-a314-d1a54fc02b7b"
      ]
    },
    {
      "cluster_id": "e4c393f3-a213-40f3-ae1e-bc16b0f13a4f",
      "members": [
        "b0a3cf13-1a4a-49cf-9650-b4d47bd24a66"
      ]
    },
    {
      "cluster_id": "b9804a77-392b-4042-a24f-eda229eba1c8",
      "members": [
        "ae5557c6-998c-4b66-b2b7-a5aecbac8f3c"
      ]
    },
    {
      "cluster_id": "60a5fa4a-02a4-4e44-b778-ab28e2e5eb27",
      "members": [
        "013c1cd9-b7c8-48fb-b8ce-475e23266ea5"
      ]
    },
    {
      "cluster_id": "17a99d17-d7ec-4cf5-8a94-b29753d62b97",
      "members": [
        "7de80b65-043f-4e5d-a9bc-d226ff6b6fdd"
      ]
    },
    {
      "cluster_id": "d21c817e-4d9f-4479-93a3-693ea677e1ba",
      "members": [
        "3b98511c-321a-4192-8fb8-abc95011c37e"
      ]
    },
    {
      "cluster_id": "58062111-7e54-418d-9733-f5233a5838b1",
      "members": [
        "0321a354-364a-4a30-b679-e623c1a70423"
      ]
    },
    {
      "cluster_id": "db91eebc-901f-4800-8b70-2d11c9945ab2",
      "members": [
        "4711e8d3-bd16-4241-953d-c51c6c90d423"
      ]
    },
    {
      "cluster_id": "61eb35de-336f-40f6-88fb-ed35c226eeeb",
      "members": [
        "975471e0-820a-4978-8aaa-066b30963821"
      ]
    },
    {
      "cluster_id": "62f74a8d-c7b3-449b-9454-ae631aea88c2",
      "members": [
        "bbe3e36a-e3e8-44b0-8d0b-6bb1acbbccd1"
      ]
    },
    {
      "cluster_id": "923c46a3-c0b6-4907-a189-66afd503c6b7",
      "members": [
        "27bab3dd-8905-4e53-8114-ad36b1d41d9b"
      ]
    },
    {
      "cluster_id": "d565264f-4050-472d-a250-87b812ab31fd",
      "members": [
        "130d090a-a725-48fd-97d3-ed44794213dd"
      ]
    },
    {
      "cluster_id": "235b76d8-eadf-4d03-98a8-4198401ca562",
      "members": [
        "983f6e63-0d24-46b9-af13-db591b501c72"
      ]
    },
    {
      "cluster_id": "8d301f71-3fd8-4bb2-b685-2bfee512c9e8",
      "members": [
        "fdc978ed-40a2-426b-9b52-d01d7ccc34ea"
      ]
    },
    {
      "cluster_id": "605d1ffa-cf79-43de-a146-0eef92de2043",
      "members": [
        "eb8f967f-2656-4a4b-91e8-a4cb188e9b89"
      ]
    },
    {
      "cluster_id": "7e3014ad-3100-4bc7-8edd-4e32af49ff75",
      "members": [
        "0296336a-12f4-46da-8644-2db3b8318904"
      ]
    },
    {
      "cluster_id": "c7bbd075-2e34-4018-bab2-225944afb981",
      "members": [
        "71716b5e-5ae9-4ffa-8706-06583a089e68"
      ]
    },
    {
      "cluster_id": "6988ebca-b8d5-4719-a15d-b25c13a58367",
      "members": [
        "949d656d-6c77-4e70-a816-4a946c24cafe"
      ]
    },
    {
      "cluster_id": "02d5b346-4337-43cf-8a61-4391e125d41b",
      "members": [
        "96422655-db81-478f-b5cf-5ce26a64e857"
      ]
    },
    {
      "cluster_id": "4305150f-f7f1-49f6-a09c-d2c5973a5934",
      "members": [
        "6d645f66-2fa2-4440-97b2-ff77af9e2264"
      ]
    },
    {
      "cluster_id": "d020ba2c-1e1a-4bee-8860-bc381620b119",
      "members": [
        "4ac1ca20-eebb-45cd-a74b-79edf957b37b"
      ]
    },
    {
      "cluster_id": "599b237d-3afe-449d-8cd9-becd796f27c7",
      "members": [
        "2cc66c0f-4d03-4670-961a-363f22e74a7f"
      ]
    },
    {
      "cluster_id": "9a201ba4-4fa1-4a8f-b530-b70790363696",
      "members": [
        "fd9362a0-22e4-4461-9e09-8bb3013720c9"
      ]
    },
    {
      "cluster_id": "9b7a4b49-e4e5-49c9-a089-9e908e59efcc",
      "members": [
        "265a5bd9-2e5f-4b66-9802-32ce6519ab9f"
      ]
    },
    {
      "cluster_id": "15bdefb4-3c81-4573-bb02-e7a3789e75e2",
      "members": [
        "0872d008-2206-414f-abe3-83a079ff4a39"
      ]
    },
    {
      "cluster_id": "75a5f06e-b690-4ab1-b016-65c86c1b4940",
      "members": [
        "5577f827-1608-4eba-b5ec-b6916810af2d"
      ]
    },
    {
      "cluster_id": "f4253f2e-cf0c-4fcc-9979-cb25e723158b",
      "members": [
        "6be138f4-42ee-46f9-8ff5-ea2d160f4ea1"
      ]
    },
    {
      "cluster_id": "8340119a-3207-4843-be46-581bcbb33e2b",
      "members": [
        "5ffd8aa4-ec97-4d8a-86a6-30eef06339a0"
      ]
    },
    {
      "cluster_id": "6b078586-a71f-43ea-9363-faa3caa5fe58",
      "members": [
        "06489a60-fab7-4944-84a1-9059ed5014f1"
      ]
    },
    {
      "cluster_id": "1a36fb41-5917-46f9-abb2-91e9032c6071",
      "members": [
        "f12b36ec-524f-4185-92f8-58f3b6597825"
      ]
    },
    {
      "cluster_id": "779beaba-8043-4ec4-ab6b-1cb654ad8ccd",
      "members": [
        "243eb1c9-89ac-47a7-8b18-c1f944abe097"
      ]
    },
    {
      "cluster_id": "5f6424e4-0455-4ee2-821d-018975472c03",
      "members": [
        "7c03c0fd-ffe3-4565-acfa-cb3327161e79"
      ]
    },
    {
      "cluster_id": "8a11cb2d-17fc-4106-aa7c-42847d3ac867",
      "members": [
        "770b1abf-44f2-443a-ada7-f9de8408d8de"
      ]
    },
    {
      "cluster_id": "87581b6b-a1c8-4620-9246-61483cbbfb0d",
      "members": [
        "5bfadb85-2f13-495d-a5ed-3bb9abe6e895"
      ]
    },
    {
      "cluster_id": "fe94ed8f-3634-4c2e-acc1-318cbc76b2f2",
      "members": [
        "e8eb7f37-56c7-4d36-8486-175416342713"
      ]
    },
    {
      "cluster_id": "4ea67e25-b76d-482e-ba32-1243cadbf594",
      "members": [
        "c034b4f3-6230-449a-b8ac-837184dc0e06"
      ]
    },
    {
      "cluster_id": "12975b02-1543-4e2e-83d5-f31f56ef1664",
      "members": [
        "b255b7c9-3282-4965-a14e-e386cae653f2"
      ]
    },
    {
      "cluster_id": "fc3a7125-d930-4cc4-ae3e-0da6ebe44d84",
      "members": [
        "65adb4cf-7e23-4a79-a659-7fbf02ee5fd8"
      ]
    },
    {
      "cluster_id": "1c46973d-d9e6-4d0a-bc0b-63d9b4862b8d",
      "members": [
        "f9423227-1b63-4da3-a7f5-d507937f3480"
      ]
    },
    {
      "cluster_id": "49af375a-1b87-4e0c-b77f-9747485eaee4",
      "members": [
        "c6902fca-ab14-47ef-8569-a98135d90446"
      ]
    },
    {
      "cluster_id": "55be4945-34ca-4ac0-b3a5-86bcc22710f0",
      "members": [
        "0ff69dd0-d45a-4438-9242-dfcfdab7127a"
      ]
    },
    {
      "cluster_id": "b03fae7d-ee9e-4f46-b206-fa4dec1a6c69",
      "members": [
        "0e539a1b-8353-4717-8aa8-84f7274cff07"
      ]
    },
    {
      "cluster_id": "fc32a20d-bd13-4dc2-a851-03b63c1e329e",
      "members": [
        "3c61e333-2a92-4f9d-9a82-21dde68f2518"
      ]
    },
    {
      "cluster_id": "9f734692-8c1b-45a5-98e1-623a0369fed0",
      "members": [
        "ceb9e85c-52f8-43ae-8501-cd165988bf17"
      ]
    },
    {
      "cluster_id": "d6713b0d-513a-4166-b2c8-1c6b4cde08b8",
      "members": [
        "b887f2b8-b1c5-4847-8a77-8f61e2bf908a"
      ]
    },
    {
      "cluster_id": "058f52a9-8a35-4f4c-823b-efe94ad1ee22",
      "members": [
        "c0781159-2fbb-43f9-b1d2-271979aef096"
      ]
    },
    {
      "cluster_id": "e34b1053-1f91-4dd8-9190-a7ed9dea81f8",
      "members": [
        "2f5b44d4-cd77-4901-bf0b-5805d001fa71"
      ]
    },
    {
      "cluster_id": "815bc458-4e48-4001-99cf-32e4675d4871",
      "members": [
        "a6a090f2-250e-43f1-af87-da60443890f6"
      ]
    },
    {
      "cluster_id": "874c8d94-d252-41b3-bbae-89e33a5eba13",
      "members": [
        "1dcc4637-5075-408e-9c32-d48cdf9be951"
      ]
    },
    {
      "cluster_id": "3a31904f-9e32-44e5-89a1-822aa5467c6f",
      "members": [
        "7f72ea83-ff2f-4681-a254-a3b653f687c6"
      ]
    },
    {
      "cluster_id": "f3c400dc-7cb4-4e82-a493-b5e485fbdb96",
      "members": [
        "c4b59a03-d07f-42af-8421-354a5780f962"
      ]
    },
    {
      "cluster_id": "98561354-101e-4568-a2cb-77ee7e2819a1",
      "members": [
        "0014feda-1b1b-42a4-aa95-a5b97781628e"
      ]
    },
    {
      "cluster_id": "079b8e0f-e8e1-4996-9f11-531830a5cd53",
      "members": [
        "560e8ffd-ee97-4d01-a595-24d938c47d39"
      ]
    },
    {
      "cluster_id": "e5391c1d-dcc6-47a7-9d8e-10697d160138",
      "members": [
        "9ad9050f-5297-4565-a721-5483adf4a456"
      ]
    },
    {
      "cluster_id": "ba69550c-4232-407b-a518-7595f5dc57c8",
      "members": [
        "ce541d26-e549-457b-a70d-d465ca8545c2"
      ]
    },
    {
      "cluster_id": "0fb15e05-a0f9-40af-9d1c-3b5766f5252f",
      "members": [
        "182e124b-54fe-40db-a8a6-ec485c12f145"
      ]
    },
    {
      "cluster_id": "b3677c08-0eb1-4865-90d2-0d359e3678b8",
      "members": [
        "9dfaa4a0-ad0b-412b-91c7-424e2e092732"
      ]
    },
    {
      "cluster_id": "c3a6bce1-7cb7-4d0d-a994-69caef25a8d5",
      "members": [
        "c00c097f-bcb6-4ed4-8fd5-dead73179f72"
      ]
    },
    {
      "cluster_id": "8430f01b-f34e-4798-8729-04aadd64268d",
      "members": [
        "f854b645-473b-4244-a7c8-531d665d6b1d"
      ]
    },
    {
      "cluster_id": "379e9bdd-f97e-4662-8fa6-c65318b2f0d3",
      "members": [
        "545df908-fabd-4031-bc78-cc2208ec4a29"
      ]
    },
    {
      "cluster_id": "545232cb-5fc2-43ad-859e-11784f675852",
      "members": [
        "72caf4ba-911e-4116-ba62-9c8ff8286562",
        "f1f11a20-928c-4ed8-8c63-bd61be10cfdc"
      ]
    },
    {
      "cluster_id": "8c70df97-1c82-4e7f-b23d-acbf2024c8f6",
      "members": [
        "5d954983-cb6e-4a77-ad29-8e94a7585934"
      ]
    },
    {
      "cluster_id": "872f71be-bb1a-40a1-8078-ee9f850ec42d",
      "members": [
        "20a849a7-46e3-40f7-a53a-ef9d656341e4"
      ]
    },
    {
      "cluster_id": "735c3d6c-a597-44bd-92cc-d934d1e29409",
      "members": [
        "4ae6cdf7-a766-4c1c-8aee-3a3746dc2c7b"
      ]
    },
    {
      "cluster_id": "ab265737-e0ba-43dc-8147-c642f185978a",
      "members": [
        "72293139-3b57-4eea-a823-2b901a0bd6cc"
      ]
    },
    {
      "cluster_id": "299d788c-3d25-4b23-8898-a2eee18a0fda",
      "members": [
        "de60d725-248e-45d3-b701-2a13af9f5f3a"
      ]
    },
    {
      "cluster_id": "9c08b4e1-94e3-4cf2-b505-4d6b5137534f",
      "members": [
        "118bac1b-1c0e-46ec-995e-13205dbfa0fe"
      ]
    },
    {
      "cluster_id": "1af06082-428a-4dc1-a3c0-4aa29b512806",
      "members": [
        "0588b688-a1f1-4c74-bc0d-ab5b9fb67dee"
      ]
    },
    {
      "cluster_id": "26032edd-a722-4f79-a364-7bd2114c1626",
      "members": [
        "528eceea-ad8d-4181-98a7-d21830e6b92c"
      ]
    },
    {
      "cluster_id": "0fd165fb-7316-456d-917e-cb976d5b4983",
      "members": [
        "0e3e0511-d7db-4415-ada9-ee2e4a3be17a"
      ]
    },
    {
      "cluster_id": "ff4b91c6-36e8-4903-a2ad-89bb3665e4d5",
      "members": [
        "4af7ba6c-cb5c-47aa-864d-420317ab4551"
      ]
    },
    {
      "cluster_id": "1c08ccb0-286c-49ff-a95c-c82f67ced7f2",
      "members": [
        "3410331e-c4bb-4b1b-9574-05e5018b3c78"
      ]
    },
    {
      "cluster_id": "8254f8c1-33e3-4176-8b1d-232b3b4367f4",
      "members": [
        "8e6134fe-fcea-496d-8c42-a0c71fc9314b"
      ]
    },
    {
      "cluster_id": "41e9c8c9-45c4-4590-9393-a3b2281304ab",
      "members": [
        "69e46ab7-fa2a-4486-aa2d-5674fe1d36ae"
      ]
    },
    {
      "cluster_id": "08cb653c-495a-4846-800e-e87a07c472be",
      "members": [
        "a79eec91-a9d0-4d1e-9151-c8ba4191eeae"
      ]
    },
    {
      "cluster_id": "0786cda2-1538-4e16-9f54-d0704127539a",
      "members": [
        "4848d6dd-681c-4bfb-8f4c-088503283355"
      ]
    },
    {
      "cluster_id": "b3995a19-7531-42df-8c11-d55b2b796806",
      "members": [
        "c84d033c-e6d4-4d02-87e5-bfbd16e5763c"
      ]
    },
    {
      "cluster_id": "dd0e35ae-acba-486a-a98c-7ff8e0d969ad",
      "members": [
        "c4ae27ed-c685-40eb-b3f2-cd3a9e555b24"
      ]
    },
    {
      "cluster_id": "3f015f88-0af0-482a-a4a6-663bbcc6d95b",
      "members": [
        "120e6568-4927-46e5-9b8c-9209bae7ba65"
      ]
    },
    {
      "cluster_id": "af198123-e2b2-48b2-baf8-af5aa8446190",
      "members": [
        "9ee5891d-a8c2-4320-bdf4-773e1c8b47a5"
      ]
    },
    {
      "cluster_id": "aef65abc-e7b7-4946-9c22-4ac367aaff7e",
      "members": [
        "74348668-7496-4786-bd40-a3af23277223"
      ]
    },
    {
      "cluster_id": "55f690c0-9fbb-459a-ab42-db16e202e04f",
      "members": [
        "5f253ea7-44db-41d3-af44-c944763b5a9d"
      ]
    },
    {
      "cluster_id": "06d0d746-6c6d-457b-ab07-13b3cadf3286",
      "members": [
        "8b5a9367-1545-497c-928c-f030b8a8f17e"
      ]
    },
    {
      "cluster_id": "791db8c8-66c8-425a-80e1-d5e8778fe4a4",
      "members": [
        "5d364e2a-f3de-43f7-b56a-969e6a87be50",
        "b925b8a6-b72d-4a5c-8669-aefd94275817"
      ]
    },
    {
      "cluster_id": "43fafa8a-6241-480f-aa40-04f420f4ea5e",
      "members": [
        "ddc9cd67-afd2-4128-af33-fd1ad79e6eef"
      ]
    },
    {
      "cluster_id": "58a5d45d-929c-4882-97bc-6346fc773e3e",
      "members": [
        "7f258dc4-cf55-47d7-be56-d97f72ce1266"
      ]
    },
    {
      "cluster_id": "198dc8a2-e334-4b48-8e21-1b19bd36b74b",
      "members": [
        "1bb93b9a-3781-44f3-9a0a-577dec3bc98e"
      ]
    },
    {
      "cluster_id": "713029fb-6b38-4883-a995-a264b7e6024e",
      "members": [
        "2c6af927-8707-4b2b-a140-05964d617e9d"
      ]
    },
    {
      "cluster_id": "49b2d0f6-e7d1-4326-9bb2-ec42779a8e4a",
      "members": [
        "8697104c-7220-4b29-b05a-345b1a11c2eb"
      ]
    },
    {
      "cluster_id": "4272dbf3-0c9a-42d8-a9a1-b2b3a349e192",
      "members": [
        "48f065e1-6239-40c3-8de3-d1143ae5a53c"
      ]
    },
    {
      "cluster_id": "17d6daaf-12c7-4c0b-88cb-bf8161dd5be6",
      "members": [
        "c9c22e9c-6197-4c83-b1bb-8e73c7a16c24"
      ]
    },
    {
      "cluster_id": "80c4a4ac-f4f0-46b7-a4e0-1dc67ab16883",
      "members": [
        "dcd2ed13-c5a6-4710-955f-f038ddd86c35"
      ]
    },
    {
      "cluster_id": "6fa6425c-c799-413f-9698-b7928b5c5770",
      "members": [
        "4950e4b4-3064-47e2-b931-2dc32f30e301"
      ]
    },
    {
      "cluster_id": "30a2e818-400c-4443-9905-7ab130b7ac97",
      "members": [
        "9823e290-a1be-4856-94c8-d7ef2125e053"
      ]
    },
    {
      "cluster_id": "e92990e4-6de9-4c7c-9c4a-006af1a579b1",
      "members": [
        "1c192a7f-6d7a-47cf-8ad1-f2b4242cc65c"
      ]
    },
    {
      "cluster_id": "09f4e973-2393-41aa-bdcb-ccd0efbed300",
      "members": [
        "ea349321-89e6-4d71-9a4f-896fdd5e06e6"
      ]
    },
    {
      "cluster_id": "344f18e9-fdfb-4043-b1ff-09516022ac50",
      "members": [
        "448ae192-3b42-4b2a-8680-e61ce109a521"
      ]
    },
    {
      "cluster_id": "89cee3a2-4f95-4473-859f-f9c42c415bf7",
      "members": [
        "14e09847-a435-42c1-a835-bed3c468e5f7"
      ]
    },
    {
      "cluster_id": "9096c294-fd2c-4311-a357-8c17726796f2",
      "members": [
        "71d91ae6-6b54-4b70-b8aa-5a6814c43071"
      ]
    },
    {
      "cluster_id": "16428f67-cf62-4386-a190-51cc23ca4b78",
      "members": [
        "df4460b4-7c1c-49af-be67-024ef6ef060f"
      ]
    },
    {
      "cluster_id": "eb435255-a9dd-404d-b762-acfa5ea790a6",
      "members": [
        "855c1651-d97c-4cd5-b2de-b8ca61f51f95"
      ]
    },
    {
      "cluster_id": "8bade7cf-2f71-4a8c-ac8b-47b2764dd430",
      "members": [
        "6d616443-0575-4ec5-a830-05487037412b"
      ]
    },
    {
      "cluster_id": "c981e733-ddfe-483b-a14f-615fd62cec72",
      "members": [
        "e0d555cc-8363-4331-aa93-dc1acfeeb692"
      ]
    },
    {
      "cluster_id": "8f5bfc0f-9b63-4126-aa4e-caf3448c019e",
      "members": [
        "79d5176e-9c81-4f30-8587-b5b143eec7e0"
      ]
    },
    {
      "cluster_id": "819f43eb-3e2d-4107-9997-bfc9d26133c5",
      "members": [
        "5d1118ba-6b69-4321-84d6-7de9b1524f11"
      ]
    },
    {
      "cluster_id": "17aac7a0-8d3b-4164-8981-530ac6354022",
      "members": [
        "ce70bb4b-4946-4e75-a10c-b774ee576e03"
      ]
    },
    {
      "cluster_id": "8c3d66ea-c0e3-4dbc-a773-e3cdcd8c311c",
      "members": [
        "f91ac186-93e5-489b-ade1-ad29dde61184"
      ]
    },
    {
      "cluster_id": "c527d2cd-0df5-4184-a0f7-17002b9cf18b",
      "members": [
        "34c56fa8-be6a-46c4-b26c-a4aeacac5d2e"
      ]
    },
    {
      "cluster_id": "3e481577-f346-4d0d-88ef-e1132e39baa4",
      "members": [
        "52e91da0-9157-4d5e-a39e-0198037536bd"
      ]
    },
    {
      "cluster_id": "7ba51ccd-9b62-47f9-b011-21d9bbe02ded",
      "members": [
        "c00d1032-387a-4c4f-b23f-57952627513c"
      ]
    },
    {
      "cluster_id": "e9b589b6-86cb-4a37-aa98-5330f27ba5fb",
      "members": [
        "2c94bfd2-8eb8-447c-94bd-aa14100c383e"
      ]
    },
    {
      "cluster_id": "d80ef34a-3b0a-4891-bbe5-d2c01cec1b04",
      "members": [
        "42160d7c-e28e-42d3-b0ab-b24654ac2dce"
      ]
    },
    {
      "cluster_id": "7dfc83e7-a64c-4018-a3c6-9d9e19ffc362",
      "members": [
        "3c6bf119-017a-4c56-87dd-60c0f339121f"
      ]
    },
    {
      "cluster_id": "03b5f25b-079d-4d84-920e-062e0a19a251",
      "members": [
        "067f96be-1ace-43fe-8105-2c02bc09f5c0"
      ]
    },
    {
      "cluster_id": "1f7ec3f0-fe34-486a-a953-3da4c977430e",
      "members": [
        "c4b9433f-a0c8-4d6d-9ec6-609949063e9e"
      ]
    },
    {
      "cluster_id": "e47c3423-cbb6-4c9a-9b29-21416d12aba7",
      "members": [
        "40a2e79a-1c1f-48ac-bce5-99a7074fbb0c"
      ]
    },
    {
      "cluster_id": "3cd5d7a9-3268-400e-a49f-8e37d420e392",
      "members": [
        "fd780cf9-e0e5-430e-a0f7-1871abe13666"
      ]
    },
    {
      "cluster_id": "c1036fd0-74b9-4ac8-a4d8-2710377e38ff",
      "members": [
        "a3bbeea1-6daf-47ac-8e8d-4efd4af5ad02"
      ]
    },
    {
      "cluster_id": "3f285813-2863-43e8-b0ba-5a13b63cb515",
      "members": [
        "3ba59ba3-06e5-4fcc-931b-19bf4789bc2f"
      ]
    },
    {
      "cluster_id": "9da22551-1ead-40c0-8c8c-078150bb5988",
      "members": [
        "318d5425-4331-4f32-9398-ac802757f8bf"
      ]
    },
    {
      "cluster_id": "a6a74d11-2c02-4502-9449-33d6b314f672",
      "members": [
        "d3c7f4fe-66ff-40a3-b62a-9d9b9d2739ca"
      ]
    },
    {
      "cluster_id": "600431fd-692e-4209-97b9-71af21abedf4",
      "members": [
        "dfb4efbb-bfbb-49c2-aab2-003dc944b974"
      ]
    },
    {
      "cluster_id": "abef27a8-3e24-43c9-9823-523dd607d49a",
      "members": [
        "76afb1a9-c1cb-49a5-b345-61590db5cb86"
      ]
    },
    {
      "cluster_id": "6cba2b8f-402d-49a5-b1eb-4024641b28c9",
      "members": [
        "8b1fc3f1-6e5d-4aba-947b-0a74c23dbd95"
      ]
    },
    {
      "cluster_id": "8e3409aa-fad3-40ba-9376-e395c709886e",
      "members": [
        "2d0e301b-eeab-47d1-8581-f4fd7ae239e4"
      ]
    },
    {
      "cluster_id": "401a2d7b-5531-4488-bec8-d0c22a8122a3",
      "members": [
        "87aebf1a-2e8e-405f-924a-4588468d03be"
      ]
    },
    {
      "cluster_id": "87e137e4-5f92-4e98-b206-3abd53542c67",
      "members": [
        "47150385-ade3-432b-967e-9c1960df5be8"
      ]
    },
    {
      "cluster_id": "f16b94fa-630f-4218-860c-391c021de7f5",
      "members": [
        "6ee4125e-714c-4b39-a047-f03ce6530dd8"
      ]
    },
    {
      "cluster_id": "800ccc5c-7e0c-49e0-a72a-3cfe964493e5",
      "members": [
        "d4e1806a-1fa2-48fb-acb4-72f8364c744d"
      ]
    },
    {
      "cluster_id": "4bc67839-1a76-467a-8232-39c9eb846df7",
      "members": [
        "611aa0d7-ac04-4701-aa64-cb64aaeee9c3"
      ]
    },
    {
      "cluster_id": "4cb50541-3268-48df-a49c-2b4593404e93",
      "members": [
        "2c3a20fa-8de4-435e-86cc-ce4eceb9327f"
      ]
    },
    {
      "cluster_id": "86cb3ea2-a54e-4579-b9f8-fb1dc6c8c598",
      "members": [
        "834c4a1d-d053-4003-9d3f-eec1ea5562f0"
      ]
    },
    {
      "cluster_id": "afa6f32e-961f-4c79-a6ff-7629b5b32022",
      "members": [
        "20037b8d-86d1-4760-a95b-9cc30382fe98"
      ]
    },
    {
      "cluster_id": "65b2891f-5d2c-4752-ad93-3b8790a22071",
      "members": [
        "3d8d34c5-ddad-4bcd-bff9-af8c13886dcc"
      ]
    },
    {
      "cluster_id": "95421986-cc6a-44ab-acd6-4d39bccc24ca",
      "members": [
        "6f8de6bf-7ebb-4122-91c9-32fceaad5497"
      ]
    },
    {
      "cluster_id": "eb0d5379-1fcc-4fd5-a65b-238e9b2fe3a4",
      "members": [
        "cd397027-fc2b-434a-be79-66a8dd895ed3"
      ]
    },
    {
      "cluster_id": "9611a4d5-e21a-4cd6-bbeb-709b60bd7dc1",
      "members": [
        "c32cfa0a-5731-42eb-9405-49aa1ae6fb3e"
      ]
    },
    {
      "cluster_id": "4bbf6020-dd21-405a-9c26-bdeb387928db",
      "members": [
        "204cfb3e-51d0-4c06-9b34-b7f9f5bb562f"
      ]
    },
    {
      "cluster_id": "2779687f-bfe0-419a-be7d-20cd79002462",
      "members": [
        "ff78ec41-dc42-40e6-a051-567be1db134e"
      ]
    },
    {
      "cluster_id": "f9711d2c-1b60-4175-97f9-55453cace8aa",
      "members": [
        "bf818f5b-90da-4582-85fb-19fc52a635cb"
      ]
    },
    {
      "cluster_id": "6f13f345-1f63-46f8-86e1-7e1ec801fbcc",
      "members": [
        "14b273fe-7ada-41c4-be2e-e5e07b0f1e57"
      ]
    },
    {
      "cluster_id": "e0993394-090d-4043-91c6-3b265e1bac79",
      "members": [
        "d915c3ed-2ef6-414a-88a6-e1bbbcf055d2"
      ]
    },
    {
      "cluster_id": "6d63d484-2e34-41a3-8d3d-7c1693933482",
      "members": [
        "8df2d92d-4658-40ec-bde9-6f8142269924"
      ]
    },
    {
      "cluster_id": "827901e2-9d83-4ed3-ac71-af38455fbc22",
      "members": [
        "fb31651d-30f2-4a99-b469-e59003f53a8a"
      ]
    },
    {
      "cluster_id": "cf554d67-1528-4e54-be08-db5967f3793c",
      "members": [
        "39333550-34d4-4ce2-a36a-2c97e736d53c"
      ]
    },
    {
      "cluster_id": "85060527-feb7-4312-ad1a-ebd52c170e8b",
      "members": [
        "700992d8-f1e0-497c-acbe-78b9492d07b9"
      ]
    },
    {
      "cluster_id": "127eab3b-6cf7-495a-80f3-a2735d4d1bcc",
      "members": [
        "9ca4877e-5f87-49b8-9445-275bce494d17"
      ]
    },
    {
      "cluster_id": "10e8efce-e96d-4c64-a187-c3669a9d303c",
      "members": [
        "ce966e10-c2bd-47c0-9418-9e74ef39232a"
      ]
    },
    {
      "cluster_id": "5379b888-9bc6-45e3-b445-a1f1b5983b84",
      "members": [
        "c315885c-f36f-4cb3-99a0-25ec60dfcd60"
      ]
    },
    {
      "cluster_id": "a5494931-511f-4aa7-86a3-f3bae4df958e",
      "members": [
        "25d666ca-7aed-47ca-a084-6bd9ce2c8274"
      ]
    },
    {
      "cluster_id": "d8d70374-6442-49f6-9ba4-aa78644e8a39",
      "members": [
        "0a737724-a683-4c0f-9a7c-ab1a2bd3b414"
      ]
    },
    {
      "cluster_id": "7f0d4bc0-739c-4027-939f-98e2607340fa",
      "members": [
        "adcc03bd-1444-4f94-9c3a-79f6971eaabd"
      ]
    },
    {
      "cluster_id": "c679edbc-b9a4-4c17-b40e-4029662513e4",
      "members": [
        "21b41621-8ee2-479f-8e02-e12c53da180f"
      ]
    },
    {
      "cluster_id": "b3562e1f-34d6-4a29-b778-8824a2d004a7",
      "members": [
        "06771dc0-9d5e-45d4-88a8-d3ab9f85d2f3"
      ]
    },
    {
      "cluster_id": "015317d7-08c9-4925-98a2-39e2a1fa7c6d",
      "members": [
        "73c8b15d-1231-42da-a241-422b5c1fb69b"
      ]
    },
    {
      "cluster_id": "3aad1795-c40d-46c7-abc6-a9e8928bc743",
      "members": [
        "4a4e224e-7a32-4905-aa82-ff4c93672219"
      ]
    },
    {
      "cluster_id": "45d7d6d0-989e-40f5-9e35-4f603b15d08b",
      "members": [
        "361e2400-514c-4d1c-8260-a9666a5a4248",
        "8293ff46-9e9c-4729-be96-eb147e98babc"
      ]
    },
    {
      "cluster_id": "49883883-56ad-4f95-b0d0-b90bb6b04064",
      "members": [
        "c3bd5dcd-4149-4477-a659-7bb5246d1bb5"
      ]
    },
    {
      "cluster_id": "b695ff3b-957e-42cc-9bb5-c2dd8be994ea",
      "members": [
        "83473979-fb4b-4337-b7c1-cdf92eb9f099"
      ]
    },
    {
      "cluster_id": "1b496ec2-f55a-4ab3-bead-1b1953daed07",
      "members": [
        "19e439e9-e941-45d9-97d4-3d80f61e6139"
      ]
    },
    {
      "cluster_id": "c0200e7e-79d5-48fa-9957-b064b35b368f",
      "members": [
        "1e0aa012-871a-47c6-b3de-310a4b27a131"
      ]
    },
    {
      "cluster_id": "6ca62e87-83be-4fb7-8924-3312fe9948b1",
      "members": [
        "08b338d4-ba23-461e-acd0-3aeb175af22a"
      ]
    },
    {
      "cluster_id": "15c0ca40-4379-4a6f-82b3-46b365d5b8de",
      "members": [
        "6473f1aa-081b-466b-b4fd-20d81d1581a2"
      ]
    },
    {
      "cluster_id": "bb5356e7-f071-485f-8695-919ba1db8606",
      "members": [
        "ff3e0441-f529-4a70-9757-06710b824691"
      ]
    },
    {
      "cluster_id": "0893d96a-c001-4046-ba27-939b9e1f52d5",
      "members": [
        "6c9a434b-1457-47b6-9dcc-1c75e4861937"
      ]
    },
    {
      "cluster_id": "d2828cf5-cc91-4e95-82bf-be47e19b88ee",
      "members": [
        "7907d9ef-600b-4c2d-a3be-9c4a176cd7be"
      ]
    },
    {
      "cluster_id": "9eb9a341-e59f-4fbf-b178-ccb6bb25eb49",
      "members": [
        "40f63a23-9a81-4612-a7c6-663a75472a70"
      ]
    },
    {
      "cluster_id": "c36b66d4-db22-4344-899e-be0f938cf47b",
      "members": [
        "33409e40-fa92-45b1-91e9-7281a7f9b3fd"
      ]
    },
    {
      "cluster_id": "4c81571d-8516-4f35-b047-353d1a6e0a6a",
      "members": [
        "1e2ed96f-4bfd-4a09-b9fb-c73047552ac0"
      ]
    },
    {
      "cluster_id": "0ebe4f88-dbfe-4a7c-a8eb-80bb48625a38",
      "members": [
        "51cada5f-bae0-4fe4-82f2-f424c9951e82"
      ]
    },
    {
      "cluster_id": "659e57e4-8954-498d-b047-7eb33a601210",
      "members": [
        "517eda25-9e4e-4744-afea-9ec93d143de1"
      ]
    },
    {
      "cluster_id": "3d7cf308-ff2c-4ac9-a835-6773cc669257",
      "members": [
        "5d5f34ae-5d42-4d04-8dbc-2d17a2182cd3"
      ]
    },
    {
      "cluster_id": "00682147-64d4-4c37-88ac-2b9c31d6d40d",
      "members": [
        "c7bcd41b-1225-4ee5-a3f4-e24ba2264600"
      ]
    },
    {
      "cluster_id": "c545f601-c30b-46cc-a181-949b8540bd95",
      "members": [
        "46f0ed0e-6f42-49fb-bf9e-93ca1af2fdcf"
      ]
    },
    {
      "cluster_id": "ec93d3e9-0b7e-4779-b3cc-e888f246dd46",
      "members": [
        "0b34a825-fd9a-4fc3-881e-05b84a59c7a6"
      ]
    },
    {
      "cluster_id": "a5e2f736-5d7e-4b45-8724-dcdb3a0aecd0",
      "members": [
        "b2b60d66-d76d-450f-8e69-1ca976ccda79"
      ]
    },
    {
      "cluster_id": "57759056-0fd7-4dee-8b4f-b560736eb4f0",
      "members": [
        "efcf46a1-61b7-4d0b-a5aa-5529bf29d0d3"
      ]
    },
    {
      "cluster_id": "b0157510-fe3e-44ad-a8a9-aabc1bfb9c12",
      "members": [
        "b91d7bec-96a9-4d94-bdc2-5ed4eb968349"
      ]
    },
    {
      "cluster_id": "cb16ac50-aed8-4a03-a5d3-3ad483937d48",
      "members": [
        "f6d5650a-6b0a-4043-9a6b-7eabb6c7a150"
      ]
    },
    {
      "cluster_id": "5e11f88d-24a6-418c-854d-c6d0fb898c80",
      "members": [
        "38f1cf54-5ad5-4c49-8a3d-e93657b103ee"
      ]
    },
    {
      "cluster_id": "04e4f581-e2f4-41e4-90d7-172e50ff3c74",
      "members": [
        "3e5f3975-3edc-4cd0-a670-f2c1840c66e6"
      ]
    },
    {
      "cluster_id": "29696d33-676a-411b-9f2f-5aad8a647ed0",
      "members": [
        "9893fde8-e5de-4296-b569-f392ddf5393a",
        "ae271609-4fdd-400d-8f29-7e52383382a3"
      ]
    },
    {
      "cluster_id": "d30fd077-478d-4784-a1a9-ce89125fa303",
      "members": [
        "f17fe3ad-a3a7-4472-b37d-5ca020d6ec9f",
        "5c9bb56b-5a52-4110-9391-2fa563a25ec0",
        "5ab7b0d3-7047-4c61-accb-d237cbfddb63"
      ]
    },
    {
      "cluster_id": "771d6319-42e1-412d-8b6c-733124c3c173",
      "members": [
        "676facc8-78a8-42f4-a283-637f67e1fb55"
      ]
    },
    {
      "cluster_id": "b523b8ba-6f7b-4630-8308-edf6d80a7a18",
      "members": [
        "5ad082db-f23f-46fd-b81a-fefc0f9075bb"
      ]
    },
    {
      "cluster_id": "ad3d7029-44b1-4600-b68e-2dca24cb3b72",
      "members": [
        "e93e1943-e0ab-4308-b6d5-77afb1fb7c94"
      ]
    },
    {
      "cluster_id": "e4b34178-e71f-4443-adb8-d0d805a5c827",
      "members": [
        "dbc8a9c3-8baa-41ca-badc-d94ab83818c3"
      ]
    },
    {
      "cluster_id": "89769c6a-9183-49cc-94f1-4adf24a43953",
      "members": [
        "92a4a455-c203-458c-9cc2-0914b6b1bb7b"
      ]
    },
    {
      "cluster_id": "a4e389ba-b81a-45e6-ab4f-901841ef5d44",
      "members": [
        "ebce9aef-82f3-4955-bb2b-a9c93b3f84f0"
      ]
    },
    {
      "cluster_id": "b6b9e4e5-62b3-48a5-a508-9b40663b3e4f",
      "members": [
        "22021f3b-e8a1-4ebd-828a-825c45610f81"
      ]
    },
    {
      "cluster_id": "7c3d2190-bdc7-4187-b1eb-1c6bf0944191",
      "members": [
        "4420e0a2-5ba0-4a0d-a7d9-826e094acd08"
      ]
    },
    {
      "cluster_id": "adb1b0be-f075-4e0a-9c6e-397dd0fde17c",
      "members": [
        "b737f51d-eda6-4784-92cf-3ef5948a13fe"
      ]
    },
    {
      "cluster_id": "0d8c9f9c-0b32-4507-8989-0e2529da4ed4",
      "members": [
        "a829fdc9-636d-4a65-9100-e6491e27a82b"
      ]
    },
    {
      "cluster_id": "6c980521-41af-4980-91ad-a696c286064c",
      "members": [
        "d3a0d501-6436-496b-99a9-51ec76f653d4"
      ]
    },
    {
      "cluster_id": "efe0fef4-f04e-4e85-bb20-f40d0e8f6c06",
      "members": [
        "1a242b20-5120-4ab9-a68a-4591c9689eea"
      ]
    },
    {
      "cluster_id": "4a203e5c-111c-4719-91b2-5d364d288743",
      "members": [
        "8c0cbb84-db13-44d4-b4cc-9904138a88e0"
      ]
    },
    {
      "cluster_id": "35f8d4db-40b2-4a70-ae12-49bc429a73a4",
      "members": [
        "50ba63ef-9d11-4bda-8ad8-fcc3de82fc84"
      ]
    },
    {
      "cluster_id": "f81575fe-bf60-4052-8196-fa9040141b06",
      "members": [
        "c9647f6c-c432-434e-851c-eacfa8ab85bd"
      ]
    },
    {
      "cluster_id": "5008f252-8b6e-4832-ae6f-1940fe20e4de",
      "members": [
        "a1c06e67-80d5-4d8f-b0cd-8d383af5b2b5"
      ]
    },
    {
      "cluster_id": "c53a9c23-c3a5-4b85-9f93-40e51b50505c",
      "members": [
        "54f58f01-a70b-4df4-806c-2e9b85fcfb74"
      ]
    },
    {
      "cluster_id": "1b56d151-49c8-4483-a185-2c0622a64692",
      "members": [
        "e462c37e-791b-4cc3-8ff0-c39070b5a7a5"
      ]
    },
    {
      "cluster_id": "442c0a4f-c382-4b95-be13-3c18f2d71210",
      "members": [
        "b797a527-44cf-4f53-99fe-1099c00679dd"
      ]
    },
    {
      "cluster_id": "eac07e3f-8adb-430d-96eb-dece778680b6",
      "members": [
        "a7284336-7028-4863-afb0-b32f48dc2e87"
      ]
    },
    {
      "cluster_id": "0bc010ee-21eb-4a56-88df-bd3b94b15999",
      "members": [
        "4e12fd61-0875-4354-bb83-d269570c8eca"
      ]
    },
    {
      "cluster_id": "5dc9068d-5bdc-499d-a865-8dc21a274dc1",
      "members": [
        "26ef7b8d-385d-40b7-9fce-5868078df2c9"
      ]
    },
    {
      "cluster_id": "a99e560b-cb11-48f1-ac8e-d85b9a82ba77",
      "members": [
        "8f20a6e9-2f1a-4b15-8d4c-21f4a02dbd58"
      ]
    },
    {
      "cluster_id": "19c1333f-bc11-4412-9e3b-c195d71596c2",
      "members": [
        "724bd55a-d073-4ffa-b8b1-841148e20041"
      ]
    },
    {
      "cluster_id": "4d88384e-f212-4bd5-8d08-7d715e173b10",
      "members": [
        "4d8bbb1a-ffb1-40fc-969d-adc93352a468"
      ]
    },
    {
      "cluster_id": "d436d0a6-3e58-4bd3-a6ad-0b596176235b",
      "members": [
        "67ff1894-21a6-4d09-9475-13c85ccf61b3"
      ]
    },
    {
      "cluster_id": "4e34cec9-0108-4167-8bfb-d0fceb099fab",
      "members": [
        "2ad67026-a0ab-4011-8924-4046e01e566d"
      ]
    },
    {
      "cluster_id": "88bd5511-0bcd-4336-b0a1-fbafb00aadc9",
      "members": [
        "9ab622b4-abc7-402f-8d7d-9684c2d41515"
      ]
    },
    {
      "cluster_id": "06370214-3027-49a1-988e-c5188868372e",
      "members": [
        "7b0520cd-ad41-461a-825b-0352b225d3f1"
      ]
    },
    {
      "cluster_id": "ab1bcfd5-bef2-4f73-aff0-790c6f681ce4",
      "members": [
        "87c456ee-ec34-4960-9903-f674eb55b2dd"
      ]
    },
    {
      "cluster_id": "a258e4b2-c3eb-4705-92c4-2f0c1074629b",
      "members": [
        "3736a909-47e1-4153-aad9-9a216d168057"
      ]
    },
    {
      "cluster_id": "29244a34-6c97-4370-9081-3f30eca9f0d9",
      "members": [
        "88b1fcd6-9e80-4dcd-b0c6-ddb5f0357550"
      ]
    },
    {
      "cluster_id": "0486b789-e813-4404-9c89-b8c77f623251",
      "members": [
        "e36a25eb-ee71-4fe7-bbb6-c314b63dce60"
      ]
    },
    {
      "cluster_id": "0e12a592-3820-4db2-a037-30590707df57",
      "members": [
        "4d677b41-732f-4ee1-97b7-4fd5ff8d1409"
      ]
    },
    {
      "cluster_id": "485753eb-23f4-446f-a237-3a4fc59f9bd1",
      "members": [
        "3c187607-d8ec-4e0c-b353-44a07b79e282"
      ]
    },
    {
      "cluster_id": "f75aca31-160c-495b-9583-b8cf66c2600b",
      "members": [
        "18124d06-13fc-41ab-b44c-aff8ae32b196"
      ]
    },
    {
      "cluster_id": "31add754-e383-4634-98fa-f95a97ec4597",
      "members": [
        "fc0a4120-9ec2-4f77-9fbd-876df65975ca"
      ]
    },
    {
      "cluster_id": "7dbbaf50-ba32-48e6-b203-1b81e86a3004",
      "members": [
        "c15512f2-a7aa-4a3c-ad09-aafeb17b3e5d"
      ]
    },
    {
      "cluster_id": "ecc3ed38-6dd1-41d0-88a5-4aaeb65a608e",
      "members": [
        "f68f6bb0-ee84-44a6-bdfc-0335f50b7637"
      ]
    },
    {
      "cluster_id": "87f98626-d2f4-4a84-8a1b-fba4417798d7",
      "members": [
        "46bf3e69-919b-40f6-8cbc-94bc7df26704"
      ]
    },
    {
      "cluster_id": "d98e592a-9240-4307-b377-0c2f380a6db0",
      "members": [
        "9bd4b6f8-ff03-4cb7-8027-a6405d7799a2"
      ]
    },
    {
      "cluster_id": "14b70932-c015-4ead-b1a7-d8a04640aacd",
      "members": [
        "e8d62282-e799-457d-896f-e8a708cc67e0"
      ]
    },
    {
      "cluster_id": "6289781a-230a-4b8d-94dc-f3adadc4495d",
      "members": [
        "a612c80c-c96a-45df-8b65-d85878b6f8a7"
      ]
    },
    {
      "cluster_id": "2ba9fcc4-8317-4968-94d5-129020e8a44a",
      "members": [
        "6c31bc58-e503-4860-8034-c01e5c6ee690"
      ]
    },
    {
      "cluster_id": "b27be68c-0a41-440c-9295-b88b093fc572",
      "members": [
        "2895342f-dae4-4f6e-9d54-238a2df36de7"
      ]
    },
    {
      "cluster_id": "e2805f19-13f7-489e-ba06-5921751ad393",
      "members": [
        "3bec23f6-94db-46ae-8550-11141e250027"
      ]
    },
    {
      "cluster_id": "23f70c38-36fb-46d7-8b29-eb7e9349960a",
      "members": [
        "37f83a32-8b11-40e4-af50-a6b2b88b897a"
      ]
    },
    {
      "cluster_id": "f2c3cbb3-1d32-4569-9d6e-97148e1d73ef",
      "members": [
        "6166d4af-6445-4c33-9d67-85848cce52d7",
        "223cd831-e143-4a96-899b-7fcab8bf14d4"
      ]
    },
    {
      "cluster_id": "fe288be5-fdf6-4f12-bacd-523a94599a41",
      "members": [
        "01d0a6eb-2389-4849-88bb-8383c30c2816"
      ]
    },
    {
      "cluster_id": "e2995c43-c086-47bc-aceb-1e2374b7e24a",
      "members": [
        "2e3c1bd7-8fc2-4221-8481-354fa715b7da"
      ]
    },
    {
      "cluster_id": "da0d09cf-ea98-4fb9-b2a8-2ae9009e9f87",
      "members": [
        "f7f6b47c-67d2-439a-8a91-067f81c1f7ab"
      ]
    },
    {
      "cluster_id": "1502dc4e-242e-4ce0-baf9-c0d4847d8993",
      "members": [
        "acac592c-0100-4856-ab1a-6b5fa03c2da3"
      ]
    },
    {
      "cluster_id": "287c467e-feff-43ca-835b-d713c03d0418",
      "members": [
        "f7118670-bd48-4f56-8ea1-c88cb4a94303"
      ]
    },
    {
      "cluster_id": "096792cf-02d2-44be-b8c2-c02b17ea6cb5",
      "members": [
        "fd29e551-2e30-484a-b54c-d91f7965b7ab"
      ]
    },
    {
      "cluster_id": "28aa9b69-c31d-45de-bec6-3308b64b4f24",
      "members": [
        "67c88f53-54c2-4254-b8d0-28b7099f2ccc"
      ]
    },
    {
      "cluster_id": "8610e15b-1046-4caf-b039-527168f31d6b",
      "members": [
        "da8b48ab-8103-48a8-8c27-32fde9d744b2"
      ]
    },
    {
      "cluster_id": "49c4c056-d70c-4a38-9178-06a4f74c1135",
      "members": [
        "8ce2a5c8-0192-4588-b3b2-c420565968e7"
      ]
    },
    {
      "cluster_id": "632f52ad-dbbd-4d7f-af13-93bbeaa37163",
      "members": [
        "72efba2e-b5b1-4ef0-b026-c1fc2e9523f9"
      ]
    },
    {
      "cluster_id": "51ab1b42-afd5-4a90-95d0-c298f52dc502",
      "members": [
        "f29db90f-23cf-400e-b67c-67dd1d817384"
      ]
    },
    {
      "cluster_id": "fe8daec7-d83a-4b36-9a29-fc5d4f9d4d89",
      "members": [
        "e95427a2-7836-413a-837c-230666204f49"
      ]
    },
    {
      "cluster_id": "a52cd2df-a03c-40f8-a7af-c56d32311c99",
      "members": [
        "0cf6ea75-0326-4e12-97dd-53c68752285e"
      ]
    },
    {
      "cluster_id": "ea812d6b-ff93-45c5-87c2-85077592798a",
      "members": [
        "572faeb1-54e1-462a-ab9b-edf623e98835"
      ]
    },
    {
      "cluster_id": "a8c2e9f8-294b-4cdb-94e4-c3571edcab24",
      "members": [
        "f5f3f9d2-90dd-45c8-8b2f-ad00adb4be15"
      ]
    },
    {
      "cluster_id": "b2d9b3c8-468a-4cb2-9381-64f806a79262",
      "members": [
        "7f522407-69d4-43cb-9599-99774ba97f2b"
      ]
    },
    {
      "cluster_id": "2e8ade9c-f86a-44fa-88a9-a501aee7cc66",
      "members": [
        "0d034d8a-bd04-4ca0-ace9-77618955193f"
      ]
    },
    {
      "cluster_id": "3b497918-2e09-478b-9716-2fc578f66b62",
      "members": [
        "5bd7e56b-cfe3-4a99-85b8-77854e9b9c25"
      ]
    },
    {
      "cluster_id": "28a15364-02e7-4073-a1fc-8cee3087565d",
      "members": [
        "334fa8a2-6915-4ff0-a436-a94597df2493"
      ]
    },
    {
      "cluster_id": "63ec2628-3b3a-4ba2-959d-d95266568ef5",
      "members": [
        "d421ea1b-32a9-4feb-82ce-44107a8ad25e"
      ]
    },
    {
      "cluster_id": "81d920c9-ff43-42e8-a37f-0d453a42e2ad",
      "members": [
        "d4ac1d8a-babe-4df9-af15-5ac40c38b671"
      ]
    },
    {
      "cluster_id": "f9647705-1fb0-4b23-8449-1d162afd7139",
      "members": [
        "ecd51516-8d6e-437d-b3e0-afcf936bd01c"
      ]
    },
    {
      "cluster_id": "3777e13c-2b9f-4604-9213-bea685bd3add",
      "members": [
        "81ba9461-c241-4cff-88a5-330b7e9dcaab"
      ]
    },
    {
      "cluster_id": "2bacbc25-5943-4519-8b3a-2027cce6b51b",
      "members": [
        "c02d1d63-2738-4342-b60c-5a5eafdb00d1"
      ]
    },
    {
      "cluster_id": "2598e9eb-952c-4ac9-abb5-957f4bef45b1",
      "members": [
        "b978ef97-67af-4411-923d-63aa7bdd03a2"
      ]
    },
    {
      "cluster_id": "856b24f4-0a37-4fe1-9808-5b1d1715aafd",
      "members": [
        "050c1ca7-e45b-4239-9217-51063d96f085"
      ]
    },
    {
      "cluster_id": "6d28f7f0-c971-4fc7-ba26-4c3da49fc8c8",
      "members": [
        "9098c091-26df-4f1c-a647-9a4f2b23fc7a"
      ]
    },
    {
      "cluster_id": "3594d516-c429-465e-9ac8-b4d9801acd0d",
      "members": [
        "4b1c18ef-7469-4c08-acae-8c60b14de0d2"
      ]
    },
    {
      "cluster_id": "31f4be33-7681-4d97-9d26-1b6c02b644ca",
      "members": [
        "33c7db4b-04dc-46e0-b03d-7f922a10de7a"
      ]
    },
    {
      "cluster_id": "b5f42c7a-e41e-420e-9b45-a7f2790588b6",
      "members": [
        "d57ad4ba-c8d9-40a2-b26f-8c7201cf2b36"
      ]
    },
    {
      "cluster_id": "1e37f73d-f086-437d-9d39-f33d1960b443",
      "members": [
        "5b58fb64-63d2-40e2-9f6f-e1a1fa007055"
      ]
    },
    {
      "cluster_id": "6ce0f5a3-c20c-456e-bcaf-26fa7ed36c33",
      "members": [
        "5cb96c94-bbc2-4897-9e21-1b262e0d5d81"
      ]
    },
    {
      "cluster_id": "243170bd-2119-4d61-9620-baad736b6d51",
      "members": [
        "10698ce2-70ce-40d7-9582-9301a7996d89"
      ]
    },
    {
      "cluster_id": "5eed6894-bd6e-4276-a4e0-693ad381c55c",
      "members": [
        "61c08dbf-7678-4cb8-a05d-7fb8581db29e"
      ]
    },
    {
      "cluster_id": "f8140231-b4f8-4a5a-801c-39c992ba46a9",
      "members": [
        "0080375e-d066-4489-a76b-8aca7c644953"
      ]
    },
    {
      "cluster_id": "69dda1ad-6a94-49a1-b2c4-c261984302cc",
      "members": [
        "3957f02b-d075-40ed-b8ee-c6ba3e8e07ea"
      ]
    },
    {
      "cluster_id": "876dc47c-c65a-4a65-a882-eeeb837080aa",
      "members": [
        "38787658-27c6-48e3-b543-52185e73d5b2"
      ]
    },
    {
      "cluster_id": "6c7b148b-0647-4c2a-ac9a-6341501bc035",
      "members": [
        "2bd04379-926c-48bf-b44a-4c266364137c"
      ]
    },
    {
      "cluster_id": "d7ed508d-e43b-4e54-a0c0-6807c3338527",
      "members": [
        "8f64b154-1dec-4fb3-93ae-2e71705ff1f3"
      ]
    },
    {
      "cluster_id": "f2d1742c-c9b1-44f7-a4e6-abf20a37a569",
      "members": [
        "2edbd701-a7b0-43d0-b5f1-5f7fe48fd1b3"
      ]
    },
    {
      "cluster_id": "4a7affe3-fd43-41f4-8713-3066830d90f8",
      "members": [
        "bf9bf087-ec2e-4039-8d2e-b944f501ebb9"
      ]
    },
    {
      "cluster_id": "717d4990-dc27-4922-b8a1-6a5e44493918",
      "members": [
        "3505d0a2-95b7-4974-900f-c320bbd8404c"
      ]
    },
    {
      "cluster_id": "926c487a-2b3f-41e8-acd8-d984df721c84",
      "members": [
        "44feb689-57ae-46a8-8a01-c7747c8a0790",
        "66746a10-66dc-404c-865a-e4f7f83380a1"
      ]
    },
    {
      "cluster_id": "a0d0eaf1-4a40-484e-a752-fdb85cffa308",
      "members": [
        "d7317c6e-3db4-424b-90d9-b9b5753564c8"
      ]
    },
    {
      "cluster_id": "c0afded3-b33f-49c5-9160-e59e42832c59",
      "members": [
        "31222d1f-99d2-4a04-b6e1-26030ffb0631"
      ]
    },
    {
      "cluster_id": "10224329-dea4-42e7-8db6-693c6ba2c28f",
      "members": [
        "20a98e83-e847-4d32-aac4-5e9a640056d8"
      ]
    },
    {
      "cluster_id": "e9b17550-2314-4f27-8f49-a28182e8193b",
      "members": [
        "d269abae-bf72-4f74-b43e-47c8f5a5f577"
      ]
    },
    {
      "cluster_id": "ca872018-66c6-4a52-8d9c-e664e0716e90",
      "members": [
        "28215652-fb49-4234-8a5b-10f2884a8360"
      ]
    },
    {
      "cluster_id": "938b5cdb-cc92-4431-8b11-03447ecda24f",
      "members": [
        "41b8d60b-18d2-40ac-b418-d4da3f42762a"
      ]
    },
    {
      "cluster_id": "2a893b9d-8c8b-4435-a26b-4a75f061537a",
      "members": [
        "a9cb4bb3-35f2-4375-b14a-963d4da29cdb"
      ]
    },
    {
      "cluster_id": "c6dfc604-6d8c-4b88-816b-1b53975cd28d",
      "members": [
        "6204c9c3-9b99-41ef-a2c1-32347b6acbac"
      ]
    },
    {
      "cluster_id": "f643a51f-99d3-4180-8b6e-ad534e8f3dbe",
      "members": [
        "50a966b8-6689-49b7-ba48-7faa14b1eaf2"
      ]
    },
    {
      "cluster_id": "dba7c6a5-c30c-4cba-8cd3-01cb02220cb4",
      "members": [
        "eb9fe205-5422-4321-96e2-10a79f80e6e7"
      ]
    },
    {
      "cluster_id": "6658a062-982d-4300-bd7b-0596611a3512",
      "members": [
        "d16e0eb9-872d-49bb-a544-0446fe86d911"
      ]
    },
    {
      "cluster_id": "7222826f-77d1-45bf-82db-ad09c33129da",
      "members": [
        "c28026e9-686f-428a-a038-32f0dd36e3db"
      ]
    },
    {
      "cluster_id": "4a281b46-5b6c-4de0-b8bf-1d3cec2f1919",
      "members": [
        "664ccdb3-f880-4f25-8241-1dfeeab33b2b"
      ]
    },
    {
      "cluster_id": "291420ab-2571-4d49-863c-5554d504b9b7",
      "members": [
        "fc17a088-7b0d-4e61-b22a-7477b644e094"
      ]
    },
    {
      "cluster_id": "b4a2abb1-9a33-4e4b-a995-84324638b8d0",
      "members": [
        "bc617bf4-3191-4904-9fc7-0654c50e2050"
      ]
    },
    {
      "cluster_id": "6d147aa6-716b-44eb-8f82-ac64993f2df1",
      "members": [
        "dc0b3b2f-1dad-4729-ac7e-4c2d9044f6e8"
      ]
    },
    {
      "cluster_id": "5243db0f-4bbb-47bb-9e93-e78de6804d5c",
      "members": [
        "3ae7ca99-f464-4299-8753-7a424e968ede"
      ]
    },
    {
      "cluster_id": "02b6e00f-ac14-433e-bf3b-9d12b116fbc4",
      "members": [
        "675e5392-530d-449b-bb1e-4d7a3588db91"
      ]
    },
    {
      "cluster_id": "6c709b7a-7374-4394-a975-41a7ad1dae38",
      "members": [
        "50b2647b-0332-4461-8a09-dea8dec0abd1"
      ]
    },
    {
      "cluster_id": "7b565f36-8167-44ac-aea6-3371642da65f",
      "members": [
        "5583efb3-aa8e-4df3-858f-b8534029d887"
      ]
    },
    {
      "cluster_id": "7deb6d52-1ec6-4691-a2b6-0e60470c80a3",
      "members": [
        "00d26f90-76bd-40ab-85fc-34766755bd4c"
      ]
    },
    {
      "cluster_id": "506ae2d6-92b1-4fbe-9d47-e321f93374d4",
      "members": [
        "6f5f9441-b84d-4d52-a65c-4867888ea635"
      ]
    },
    {
      "cluster_id": "a335ca71-7c72-419b-8877-46ce4e71837d",
      "members": [
        "3bfa73f9-4f36-4feb-8c73-b26d1c8763e2"
      ]
    },
    {
      "cluster_id": "9da8623f-1bd2-4a8e-be97-3ec68da5904b",
      "members": [
        "6c403599-3e86-4bff-9361-055b9602ab30"
      ]
    },
    {
      "cluster_id": "8ab4584b-29ff-4c6c-b1fe-8e8438c3dfaf",
      "members": [
        "a12e33a5-60d5-4e0a-b96d-1234e7e986c3"
      ]
    },
    {
      "cluster_id": "f1b261ff-b08d-4eda-9ef1-3dbeca804b57",
      "members": [
        "4fe95fda-824f-4b32-b19b-ea9e2df97086",
        "d387c4db-da26-4fe9-ba04-508b28a19630"
      ]
    },
    {
      "cluster_id": "73d00199-db31-4e40-9741-09d6ba45a825",
      "members": [
        "3553acbd-cb2f-423e-93dc-1bb0a1ff29ab"
      ]
    },
    {
      "cluster_id": "ab143717-868d-4925-a6b6-6698ea0e9c74",
      "members": [
        "3d4f3856-5b2b-4ed4-a0f1-107b2258779e"
      ]
    },
    {
      "cluster_id": "33942929-a46c-44b5-a491-297910f07b91",
      "members": [
        "e2ca9fca-e873-40f4-955e-4071550bf90b"
      ]
    },
    {
      "cluster_id": "3f3bad08-f439-4b69-b562-c041c5e9279a",
      "members": [
        "d00f54ac-0e00-4021-9101-2d50a9e18898"
      ]
    },
    {
      "cluster_id": "a9a77b18-5285-4973-8fbb-79f6651b38ea",
      "members": [
        "c0e1ea34-6e44-45af-8687-a6f6e0fdddbe"
      ]
    },
    {
      "cluster_id": "5e785b56-6a28-4603-b028-fed3f12f5778",
      "members": [
        "7d6c1f51-a4aa-43b3-9db4-b7d6d51b4546"
      ]
    },
    {
      "cluster_id": "babe889e-ec1c-438e-aff1-7ca2b0c30aa9",
      "members": [
        "cbc26084-c1da-48e0-83d5-389ba8f80250"
      ]
    },
    {
      "cluster_id": "e7545678-2204-4c5b-ba0d-fefcb6897378",
      "members": [
        "4e423bb5-cd06-447a-bbfc-080811c6884c"
      ]
    },
    {
      "cluster_id": "7534b1ef-c71f-474a-a574-a2a3d535cd1b",
      "members": [
        "b16669f8-d75b-408a-9f4d-5bcb56342fa8"
      ]
    },
    {
      "cluster_id": "dddeb5a3-e00c-4234-b929-096fb52ccab4",
      "members": [
        "f37e84b5-e2d0-451c-8b32-7caaa0838264"
      ]
    },
    {
      "cluster_id": "e0c47150-6ad9-45b1-bceb-7ca3ac1805f1",
      "members": [
        "78a2eb57-fcd6-403f-8a54-0bb0e05d9bba"
      ]
    },
    {
      "cluster_id": "1288dccd-1b4b-44a8-94be-08411cd2073d",
      "members": [
        "f7826dad-e7a6-4fe2-b275-f7114d3cd458"
      ]
    },
    {
      "cluster_id": "bf8826dc-7456-4789-a5d3-9f4e1ba1b8de",
      "members": [
        "629934f2-0d32-4a19-ac35-ea10dca79eb2"
      ]
    },
    {
      "cluster_id": "9d264f30-800f-42b2-9098-6bb3eb170aa6",
      "members": [
        "a395c8b7-47b0-45a7-ad81-e26fe1c05a14"
      ]
    },
    {
      "cluster_id": "263a8eb3-52c7-4ff6-ae64-6807df428530",
      "members": [
        "73d4fa9f-7af5-42a7-81b7-86eea7bb227f"
      ]
    },
    {
      "cluster_id": "731fbc17-b401-45f0-a173-ab4385d11eac",
      "members": [
        "a26e093a-2f0c-4a23-9373-f39313864c41"
      ]
    },
    {
      "cluster_id": "e2349307-7610-418e-8e9d-d6184ecce651",
      "members": [
        "4c9cb6bf-730f-49fd-b0c7-590cf16349d1"
      ]
    },
    {
      "cluster_id": "6f5bbb87-6b1b-44e1-b1a8-1e74525f3d78",
      "members": [
        "7a212531-6953-4bb9-856f-9b6e406a2de8"
      ]
    },
    {
      "cluster_id": "b95182bc-1bb5-417c-822b-57af63faceac",
      "members": [
        "7659754a-1b7b-4a35-b4e4-4cc2050a0494"
      ]
    },
    {
      "cluster_id": "eeba7376-7fac-451b-96dc-72a9f7c32f92",
      "members": [
        "5768ff86-d67b-4a05-937e-a4fb8d057587"
      ]
    },
    {
      "cluster_id": "6c18a3ce-fe35-45a7-99c1-4b725342cc8f",
      "members": [
        "b7924395-6b9e-4846-a1b2-f40333373ccd"
      ]
    },
    {
      "cluster_id": "2490af01-fba6-4168-9f21-fb760726b38d",
      "members": [
        "3b2d1c54-46a2-43c7-a34b-867520be9bd0"
      ]
    },
    {
      "cluster_id": "d48087d5-c16e-458f-9f3a-c0c434d8a01c",
      "members": [
        "eb9d6929-d087-40ce-b49f-7c5fc19430ae"
      ]
    },
    {
      "cluster_id": "6d5fe755-2873-4033-93ec-3d174da34a66",
      "members": [
        "c3c1733c-48df-47db-b327-bfd660fd8b91"
      ]
    },
    {
      "cluster_id": "d35e4c86-fef1-49fa-8134-2537759e6118",
      "members": [
        "5a18ff76-6adf-49dd-8a47-80a852903057"
      ]
    },
    {
      "cluster_id": "48bb955f-2782-4b10-b519-1e1e1206fc7f",
      "members": [
        "6407b3ca-4fad-49b5-a549-1696186e016e"
      ]
    },
    {
      "cluster_id": "66bbc9b1-3580-4b34-9ccc-f5983ea5120d",
      "members": [
        "5a8d686a-4332-4ef2-8c1e-a1e0be81eb8b"
      ]
    },
    {
      "cluster_id": "465ba356-8493-40d2-9150-2a0b1fd6b413",
      "members": [
        "a82be8e6-3e05-488d-b48a-34ee578ebe37"
      ]
    },
    {
      "cluster_id": "56c30444-c8fe-46f9-af30-b0924f71761d",
      "members": [
        "c1f5270f-1a6c-46c0-ad52-8959a23725f7"
      ]
    },
    {
      "cluster_id": "07a40f3e-ce43-455d-8cb0-e9110e244817",
      "members": [
        "ae0daa7e-f26e-4939-a671-d1fc4de1b5f8"
      ]
    },
    {
      "cluster_id": "28dd2f06-c107-43ce-af58-70e52ba1e785",
      "members": [
        "f8c3f1aa-6921-4366-b729-0b15467ffe4b"
      ]
    },
    {
      "cluster_id": "14619d00-6463-4ba9-8ab1-f0816bb06540",
      "members": [
        "91dbc818-5745-4cc2-b15b-8de90aea2e6e"
      ]
    },
    {
      "cluster_id": "689d132a-4055-4564-beb7-4778d700e367",
      "members": [
        "301d794c-796d-4b52-acaf-189a06c32744"
      ]
    },
    {
      "cluster_id": "a29634dd-4c74-4380-8358-51cf5a9cb73c",
      "members": [
        "15ae6b88-98af-4f02-a2c2-f7506b75b8f0"
      ]
    },
    {
      "cluster_id": "95532b75-d1c7-4667-9939-ac7ea0f83b09",
      "members": [
        "0f3c80b9-d33d-449e-b782-301a92767446"
      ]
    },
    {
      "cluster_id": "0d24f0d8-e472-465e-a47b-526385fc7554",
      "members": [
        "ab3c4bac-ce55-471e-a4b1-3a5fd3e4da3a"
      ]
    },
    {
      "cluster_id": "ab327c16-f48a-42a2-adc9-ef76eb93901e",
      "members": [
        "1e97059a-df1b-4ba0-927d-ef351d3203f1"
      ]
    },
    {
      "cluster_id": "8aa22381-c7a3-4609-b694-2961fd740fc7",
      "members": [
        "39c3f37e-7863-4e24-b858-332a69edb7c5"
      ]
    },
    {
      "cluster_id": "cb189bb7-f2fd-4426-9c9b-411ad929bddd",
      "members": [
        "a6ecafb3-06ef-4d15-9e90-c182ff9ac0cb"
      ]
    },
    {
      "cluster_id": "5c1805d7-899d-486a-b79f-793a9703c022",
      "members": [
        "672cda8c-2973-45f8-975f-b039bb42d799"
      ]
    },
    {
      "cluster_id": "7ce03874-cd65-4bdc-9ec5-e264566fa468",
      "members": [
        "f3deb717-f26d-4b0f-befb-f0a268840e2d"
      ]
    },
    {
      "cluster_id": "f71ba398-a895-4de0-a397-50ea9f685ae0",
      "members": [
        "c27871e8-9cf0-4e55-a941-37568e929639"
      ]
    },
    {
      "cluster_id": "54ac5876-c16b-4f4f-ac8b-44b5ec31d0a3",
      "members": [
        "b34290c9-5fc8-42cd-8ff4-b72800d5b3fc"
      ]
    },
    {
      "cluster_id": "daa3efba-7375-4b5d-bf2a-6a5216d25c83",
      "members": [
        "519b445d-ab5a-4a25-82b4-b0946e2544b9"
      ]
    },
    {
      "cluster_id": "91fe8e01-c220-435f-b390-7c4a84da3d33",
      "members": [
        "b2a7af7a-992d-4172-a8ed-0632c7b9ebc8"
      ]
    },
    {
      "cluster_id": "30b7b8ee-8417-4cde-bc24-2f6b158ce6a0",
      "members": [
        "92773719-a9b2-48df-a401-3f607ad24f95"
      ]
    },
    {
      "cluster_id": "fedc3a0d-9f9d-4e04-81a3-669b447f0bcb",
      "members": [
        "c687e1f4-812e-4156-8c81-6e868ebc55e1"
      ]
    },
    {
      "cluster_id": "ce789309-8080-466e-a3b3-2975047285af",
      "members": [
        "93341980-21de-417e-89dd-7c82843bab90"
      ]
    },
    {
      "cluster_id": "ea917d1e-f3f8-41ef-93c6-2a9bfc99aac6",
      "members": [
        "3303063f-dece-4c0c-874c-5f4e49c07bfa"
      ]
    },
    {
      "cluster_id": "1fef267f-5c4c-4c0e-b98e-4a09e90f0341",
      "members": [
        "09395cf0-ef39-49f1-a6fd-04e49cd0d3c7"
      ]
    },
    {
      "cluster_id": "df7272f7-c990-4a72-9f74-cce4b2e6b4b9",
      "members": [
        "49d175f1-d0a6-4c28-afcb-542015206488"
      ]
    },
    {
      "cluster_id": "928ae685-c0c3-436a-ae8d-5a22e9f5f9eb",
      "members": [
        "09a6eb61-e57e-43fa-b5d1-b1d1be8aa538"
      ]
    },
    {
      "cluster_id": "1e4d6697-c15f-4888-819c-dc2c8687c928",
      "members": [
        "9ba3b0b4-5e3d-4272-9bf5-9290053494c1"
      ]
    },
    {
      "cluster_id": "eddd54f6-a534-43f3-a4ac-88a9769ba8d0",
      "members": [
        "60aaf762-4c84-4913-9c90-e2761a239a3c"
      ]
    },
    {
      "cluster_id": "b670ddd2-4c67-47c8-b6aa-a5edcf7b7b3a",
      "members": [
        "3e927d59-e3bd-40df-8996-cea67027d88b"
      ]
    },
    {
      "cluster_id": "6ac5b48b-0333-47a6-8d5d-318886958930",
      "members": [
        "500db672-9962-4d41-98c4-e78093be6282"
      ]
    },
    {
      "cluster_id": "df8da41a-f9cc-4448-aae3-112ed4b0b247",
      "members": [
        "8b330468-0e0e-41f2-8956-e0ca20857b53"
      ]
    },
    {
      "cluster_id": "6f908336-dbeb-4b80-ae57-9e0431081831",
      "members": [
        "7e95e9ef-ebaf-474e-a03e-601acfaf84a2"
      ]
    },
    {
      "cluster_id": "0f364498-4c31-43db-a10b-2fd4536b05a1",
      "members": [
        "9ae89725-23f8-4591-9414-683c87ced9f3"
      ]
    },
    {
      "cluster_id": "755be0e1-62e3-46db-9545-f7f494e88efd",
      "members": [
        "cd9cc4ee-63a4-440c-92b4-44665fd63c0e"
      ]
    },
    {
      "cluster_id": "0d667a05-1c8f-4f3d-bb58-e8d67ce23069",
      "members": [
        "adcfccef-d8d9-41c8-b300-cf27b6144577"
      ]
    },
    {
      "cluster_id": "372e4a6e-9817-40fa-807a-570a36d8b0f3",
      "members": [
        "0b082ee4-9471-4fb4-9665-6a11af3aa134"
      ]
    },
    {
      "cluster_id": "4d8ae235-419c-4dbe-90f4-1201d0ccbf9d",
      "members": [
        "ca306a40-dbf8-4c16-9e6d-e65f5d4718f6"
      ]
    },
    {
      "cluster_id": "43320422-2afc-457d-a5b5-902abc100632",
      "members": [
        "c42142ca-f5c0-47ab-b025-c6443592bce2"
      ]
    },
    {
      "cluster_id": "9612bbf2-b65c-410c-9475-7ee689b849d9",
      "members": [
        "3b36b5d8-defd-41c3-8289-6bca2d5ab655"
      ]
    },
    {
      "cluster_id": "41aaee2b-0ddb-4eee-87a5-d0d95635a46f",
      "members": [
        "f50f4def-0d40-4b2a-b554-6beb32d737a3",
        "0751e686-1dba-4c04-87b2-2f60c4f1b69a"
      ]
    },
    {
      "cluster_id": "c60d6252-d9ce-42b9-bf38-6fcee80b74b2",
      "members": [
        "60c62a8d-67f0-456f-babc-92a83004c410"
      ]
    },
    {
      "cluster_id": "e1bd1fc6-e475-4d2c-871d-d09149cf8937",
      "members": [
        "ff1b1f16-e1f3-4645-aada-881b39125135"
      ]
    },
    {
      "cluster_id": "1aacc2c6-cd51-47e7-bc26-be760d557e3c",
      "members": [
        "9df6a373-ef95-4532-ac3b-a1e8c83604f1"
      ]
    },
    {
      "cluster_id": "23adce5a-77c2-4c07-98b6-ac6909360e17",
      "members": [
        "39a3616e-dad5-4fbd-ae4b-62f66f82c78e"
      ]
    },
    {
      "cluster_id": "0400977a-dea9-4fe6-a6a6-61f4575e07a9",
      "members": [
        "4d01381b-d2ad-4d1e-a67a-51a9d99787d7"
      ]
    },
    {
      "cluster_id": "24ff5666-c9a9-45c1-a6b9-bf154f310b8b",
      "members": [
        "42bd8f38-2fd4-41ff-b341-2b0082c32891"
      ]
    },
    {
      "cluster_id": "888e25a1-a330-4c04-b43d-60fcd67cb2eb",
      "members": [
        "a8fe53c0-7e4e-41fc-89e1-1ad373b9e8f8"
      ]
    },
    {
      "cluster_id": "4f34e75a-3485-4e52-8dc7-20e80c772c83",
      "members": [
        "4f983b79-5012-4e5e-b5da-900007e5a9e4"
      ]
    },
    {
      "cluster_id": "c4b95ac5-8bd7-40cd-a7c2-2a05463c8dc3",
      "members": [
        "9feefbd2-a7c6-4721-82ad-657290b14cef"
      ]
    },
    {
      "cluster_id": "fd30a023-a95b-44f7-ae05-f93dd9a3dd06",
      "members": [
        "f165cf0e-f915-42f3-b7e5-f67a70b9c4de"
      ]
    },
    {
      "cluster_id": "32a7ec8d-3be3-4c19-8ad9-bb022a0c0c96",
      "members": [
        "0a57fba4-28ce-4d8a-aff2-c670b52d4d49"
      ]
    },
    {
      "cluster_id": "9e8db3b9-526d-441d-81c7-ae6c80c59a34",
      "members": [
        "8c14d01d-d8dd-41c9-9cf7-c0401fcc6155"
      ]
    },
    {
      "cluster_id": "f26edbd7-0fe4-4992-ad9b-b42b469ca47d",
      "members": [
        "2bac8904-52f4-4bdb-9620-f27b4151693e"
      ]
    },
    {
      "cluster_id": "d47510b3-4df0-487a-a8c5-1177c915ed1b",
      "members": [
        "47679c3a-7bc9-4d9d-a58e-3c4745dba065"
      ]
    },
    {
      "cluster_id": "320a3067-75cf-4293-9d53-8dd1f312af23",
      "members": [
        "29d04490-fe48-4d3e-a171-75452dcd6f93"
      ]
    },
    {
      "cluster_id": "76bfb6cb-c00e-452f-b533-a19a6ee05a39",
      "members": [
        "902d866c-4f3c-4638-9889-9bd14c3d0372",
        "99b7dd48-1e8a-402b-a5d1-fb3a5fb3a750"
      ]
    },
    {
      "cluster_id": "4ee7469c-41d2-49f4-8462-c59869db80dd",
      "members": [
        "da9fdf94-cb84-42e7-b74d-f0cb8328f7e6"
      ]
    },
    {
      "cluster_id": "9a404aa7-ec0d-4ed0-88e9-60d78850dee6",
      "members": [
        "7ff61552-88f3-4526-97b5-d9ca9ed9b4e2"
      ]
    },
    {
      "cluster_id": "02eef8bd-0b3d-4ee2-ac5e-9d2a9e96e5e4",
      "members": [
        "83f5e6cb-29b6-429f-8190-9a156717c61f"
      ]
    },
    {
      "cluster_id": "30a07eeb-43bd-4ffe-abd6-643a3e7fa413",
      "members": [
        "bee4552b-57d9-478e-b893-2d4a9e1fc447"
      ]
    },
    {
      "cluster_id": "d9a77a4d-52c1-4a0d-b32b-684c4aa1d380",
      "members": [
        "cbca741d-711d-4e4d-a4ce-33ef973ede59"
      ]
    },
    {
      "cluster_id": "213314ea-c0f8-4a72-832f-5b10a8bbeab5",
      "members": [
        "56411072-b42a-4fc6-8beb-80c750823803"
      ]
    },
    {
      "cluster_id": "549c4c7b-f978-4fb0-adc2-18a978338670",
      "members": [
        "f4dd389c-4dcd-4760-b416-5688cb51f35f"
      ]
    },
    {
      "cluster_id": "976266ce-5c9b-4a82-9062-52ac4f4dcbd6",
      "members": [
        "cc878b4f-d0f6-41bb-b48f-76ec35f80521"
      ]
    },
    {
      "cluster_id": "75b0c0a9-3733-4700-8094-3d9376dffa97",
      "members": [
        "f7c95d9c-7dc5-4e18-b611-d0a7efa36313"
      ]
    },
    {
      "cluster_id": "63223fc3-b9f1-47b4-9d17-af262f481c02",
      "members": [
        "2fc4f6cd-cdf8-48ba-9ec6-11b2f95170b3"
      ]
    },
    {
      "cluster_id": "0abb1373-3acc-4d19-880c-819af07a267f",
      "members": [
        "48fce21f-e832-4203-ab5e-123ee6696b54"
      ]
    },
    {
      "cluster_id": "9b4d29fb-4c29-4c0d-a4b1-3620ce290719",
      "members": [
        "17a34f6d-fb4c-4c30-974b-ae80f60a7a6c"
      ]
    },
    {
      "cluster_id": "421f3ec9-adff-4513-86c4-d1e8d810a087",
      "members": [
        "9d757536-fecb-4608-b5ca-c5958b49de0d"
      ]
    },
    {
      "cluster_id": "b4d4265f-dae0-43eb-9010-fb5c59968803",
      "members": [
        "5ad427b1-5567-464f-a8cf-f114afd13bab"
      ]
    },
    {
      "cluster_id": "9be2ee3c-9f9c-4f35-baba-22913c8be73a",
      "members": [
        "b004b539-eb19-47a1-acdb-991d13d2815d"
      ]
    },
    {
      "cluster_id": "bfefe16b-a245-4367-989a-c541df49bc59",
      "members": [
        "c8d87d2a-7e82-4a07-8f54-5c5e1f05f12a"
      ]
    },
    {
      "cluster_id": "280b825c-cdaa-4737-977a-cbd99f073e0b",
      "members": [
        "d6de6342-d06f-4bed-a24d-eba7808ccee4"
      ]
    },
    {
      "cluster_id": "e3021516-b122-4f63-8b18-ba2abaa0f893",
      "members": [
        "6a03b943-9d28-44b2-955d-574383777124"
      ]
    },
    {
      "cluster_id": "44c9e76f-0fa5-4a17-a780-5705bb58dc3f",
      "members": [
        "8f870ec8-fd54-4279-a357-b36e82e50b6c"
      ]
    },
    {
      "cluster_id": "203f76bb-0a3d-4ccd-8cba-09629dfeec98",
      "members": [
        "7b41400e-2890-44c4-b7d4-e6cf6521a629"
      ]
    },
    {
      "cluster_id": "5970978a-16bb-49ab-af47-a2c975a2cb17",
      "members": [
        "8421a853-8511-404e-9609-fc28810cbc3a"
      ]
    },
    {
      "cluster_id": "522766f6-ebcb-4a4a-8452-2b5650a5db3e",
      "members": [
        "c671a1bc-8a98-4e54-9d69-e4564687579d"
      ]
    },
    {
      "cluster_id": "78e9a9c1-3b66-422f-8fa2-16501c3ff20e",
      "members": [
        "7f8fb298-3c7e-4e6e-a71c-b19879710ca2"
      ]
    },
    {
      "cluster_id": "8b23f6cd-4b58-4e69-9587-6944141b8e4e",
      "members": [
        "ff69865f-a5f6-4dc5-af62-644a5ef74c96"
      ]
    },
    {
      "cluster_id": "6b4e3603-7ed8-4a6d-b270-0425352e67bb",
      "members": [
        "5db9ef79-d7f2-4def-b134-502dc745d2cb"
      ]
    },
    {
      "cluster_id": "7a023b40-1e52-4532-8692-d72ed2b9002b",
      "members": [
        "27e05cb7-cd28-4625-856d-6a9df0dac555"
      ]
    },
    {
      "cluster_id": "5e9e2335-fc8c-44dd-9055-29d786472e4e",
      "members": [
        "a81f1365-15a1-40ca-a95b-7adf39048cba"
      ]
    },
    {
      "cluster_id": "ea4d2231-ca8e-420c-8296-8d5576ce43ba",
      "members": [
        "bf2eeb0d-cb04-4809-9b17-e692478c342c"
      ]
    },
    {
      "cluster_id": "ed0d704f-d33f-473d-9c87-1978cd551cbc",
      "members": [
        "c489b02f-e1f9-4731-81d8-f8063e70fa24"
      ]
    },
    {
      "cluster_id": "296c5f75-cf3a-4fd3-89db-486389767949",
      "members": [
        "2f2601e2-dcdf-4a53-ac93-2691da00cda1"
      ]
    },
    {
      "cluster_id": "97495308-ae0e-47c9-bef2-8d438cbb6ff8",
      "members": [
        "e4456bfe-2d43-4143-ab11-773ac7e34cd0"
      ]
    },
    {
      "cluster_id": "eca77987-6ebf-478d-b553-30ae00ed1856",
      "members": [
        "db318a9a-5538-40ea-af8a-e1b6ab6c097b"
      ]
    },
    {
      "cluster_id": "93863b1e-b8da-4bf9-893e-8c00bcaf88db",
      "members": [
        "ba71ae78-0568-4ae9-b7e6-5633929adfdb"
      ]
    },
    {
      "cluster_id": "dc2c7323-e1d7-4179-aef0-ca2fc7077801",
      "members": [
        "4d52f801-b5ec-4382-89ac-56c59fd5a2ba"
      ]
    },
    {
      "cluster_id": "2546e25b-7863-4f5c-b7d3-2a457e14f21b",
      "members": [
        "8dec6f5d-64f6-4948-93f3-d08dfdb42d2d"
      ]
    },
    {
      "cluster_id": "6324da02-c8ae-4e7d-b1eb-1091e19c88ba",
      "members": [
        "3aea1afc-c5cf-4000-a51f-bfc4f3c546a9"
      ]
    },
    {
      "cluster_id": "242e079a-1694-45b6-93b7-7c7320473a25",
      "members": [
        "c3385f2a-4d50-4695-b459-86268d931b4f"
      ]
    },
    {
      "cluster_id": "fe93734b-6e24-497d-aea9-a8d5b75d7f64",
      "members": [
        "cff3fd9a-d663-4f91-806f-f5df7aab29c8"
      ]
    },
    {
      "cluster_id": "9cb21d08-8a84-4302-8619-2f374e19a897",
      "members": [
        "0ca2b759-ed1f-4533-a743-66057166e846"
      ]
    },
    {
      "cluster_id": "baac9deb-4b05-423b-be76-a9a8e41c6cea",
      "members": [
        "57e1aa72-bd50-44f9-ac97-2321b745e8aa"
      ]
    },
    {
      "cluster_id": "f2060e6b-7cd9-444e-9e39-3784e110a3b5",
      "members": [
        "d81661cf-5c0b-4a2b-9276-5eef0fe647d8"
      ]
    },
    {
      "cluster_id": "0d94dbde-ff2c-4ec4-88f7-65580876f8ea",
      "members": [
        "250d30d1-b4d0-4780-afc9-7abb6bcb33c1"
      ]
    },
    {
      "cluster_id": "44b69b95-01cd-47b4-9aae-cbe7e39103ab",
      "members": [
        "f0b19778-b737-4355-aacb-1f94e50a3340"
      ]
    },
    {
      "cluster_id": "c5ac1407-521f-4465-8124-83f30e719068",
      "members": [
        "44bee4a0-5e9e-468b-827e-6d1884c6397a"
      ]
    },
    {
      "cluster_id": "086034d9-cc70-4cb5-b461-137099358741",
      "members": [
        "002f0757-9088-4dfd-8861-b023ac2bc82b"
      ]
    },
    {
      "cluster_id": "b97c97e0-114f-4fea-812a-38dca08108e6",
      "members": [
        "80bc74d4-d262-4281-9d64-b4167293c1c5"
      ]
    },
    {
      "cluster_id": "70a4982e-a051-4993-8a45-818426e08af0",
      "members": [
        "3d92343c-6406-4363-b6c0-f7f7774224be"
      ]
    },
    {
      "cluster_id": "c42951ed-4fef-4240-bea1-d37921f9209f",
      "members": [
        "87526bfe-1ab6-4510-81cd-485fd8a2394a"
      ]
    },
    {
      "cluster_id": "7a7dc1ab-df88-47fe-b1e9-3558ecae338f",
      "members": [
        "4db96af4-a2d9-4915-a235-99f285265170"
      ]
    },
    {
      "cluster_id": "2d90579b-afff-4e63-bf7e-880641d4be4a",
      "members": [
        "0243bba8-97b4-405c-988d-c502a37eba5d"
      ]
    },
    {
      "cluster_id": "d46df71d-8407-4df2-8b9c-164a3f2cc00f",
      "members": [
        "f7ae7a77-e251-42f3-86f0-7ed24dafaa34"
      ]
    },
    {
      "cluster_id": "db2336a6-b759-4cc1-8b40-69f3eeb5bcf8",
      "members": [
        "c5ea45ad-3adf-499c-b7bf-7265e712f87a"
      ]
    },
    {
      "cluster_id": "4c76d4e3-5632-4224-a22f-bc4b4614bcbb",
      "members": [
        "ac56868b-2125-4f50-b409-8de61b0026be"
      ]
    },
    {
      "cluster_id": "8d63a231-4f96-4fb0-aa81-938182c806dd",
      "members": [
        "96d226e2-af95-4e8a-b05e-bb041137ed0b"
      ]
    },
    {
      "cluster_id": "5a7cebd4-db2c-4dcc-8a5c-86e950acfb54",
      "members": [
        "b71bf3b1-a654-4fd7-98f6-f665993968dd"
      ]
    },
    {
      "cluster_id": "1acc8146-9053-485f-9f26-6af5d30d0040",
      "members": [
        "578cb98d-fe9d-4880-98c9-f3933f0a0130"
      ]
    },
    {
      "cluster_id": "9bdfdf22-7c63-4c9e-aaa0-b66cd67a0424",
      "members": [
        "83562bb3-47bc-4447-ae9a-346721e6e771"
      ]
    },
    {
      "cluster_id": "5b21b1b3-5d6d-4813-8da8-9dbf1ce6934a",
      "members": [
        "d2001645-6b3c-4657-b183-bf1790f9f067"
      ]
    },
    {
      "cluster_id": "d32f3312-d003-4447-b89b-9a6dbdae0450",
      "members": [
        "740023ce-6df3-4ecd-ab09-6808b207dfde"
      ]
    },
    {
      "cluster_id": "540c45cf-a148-4629-8716-b1631ea44e45",
      "members": [
        "d350bc36-e670-40d6-aa13-eea5cced5d3f"
      ]
    },
    {
      "cluster_id": "c5a76ba5-1fa2-4615-9254-21b572adf7ac",
      "members": [
        "e3730230-766d-47c0-925a-acd8f825e41d"
      ]
    },
    {
      "cluster_id": "36133231-d5e7-4a50-b9f0-6f646f403eb7",
      "members": [
        "517160a7-add7-454a-ab4e-f0a0d7097b13"
      ]
    },
    {
      "cluster_id": "a67a8b34-7ebc-467d-82f6-99ed35126409",
      "members": [
        "5e4c7a2f-bb62-40cf-9046-3afa103259ec"
      ]
    },
    {
      "cluster_id": "66b7068d-b746-42ae-9f41-d88ed9a887f4",
      "members": [
        "e0e902a1-1b92-4d20-b99e-b6ece30315f2"
      ]
    },
    {
      "cluster_id": "ade1903f-a52a-4bb6-9a56-0c62e47b69bb",
      "members": [
        "a40a181c-1e52-4737-91a5-0bcbf75cfd68"
      ]
    },
    {
      "cluster_id": "b7624371-4e42-4625-b287-29a35994c39a",
      "members": [
        "52289c6e-47f6-4ffb-be6d-afc19102dfe1"
      ]
    },
    {
      "cluster_id": "e0c1caae-a4c5-46c2-a58a-61bf54ce7094",
      "members": [
        "ae66610f-0227-4d7d-881b-f939887bbb73"
      ]
    },
    {
      "cluster_id": "4d4564a4-dc41-47bf-ad98-75e34d4a1d0d",
      "members": [
        "22413a57-ade4-432b-b447-ae7f68c9ea9a"
      ]
    },
    {
      "cluster_id": "60d688f1-af0a-4245-9b4c-47a36b4f063c",
      "members": [
        "d789af8a-74ca-4e8c-a53c-ce0d512a29c4"
      ]
    },
    {
      "cluster_id": "a36c95c0-8daf-40fc-856f-176637a22c4c",
      "members": [
        "29a7891b-c4f9-490d-9ea3-14bcdcf71170"
      ]
    },
    {
      "cluster_id": "e914c276-a8b7-4441-a77d-8a5108addc86",
      "members": [
        "95dc57e4-ace0-4992-91bf-15cb68cf161c"
      ]
    },
    {
      "cluster_id": "82364b1e-49e1-409c-a0f8-eccc7c05ab76",
      "members": [
        "eca6695c-9485-46ba-88b1-f0b216c0df98"
      ]
    },
    {
      "cluster_id": "414991c8-a3c9-4951-a5c6-7c03fe71ba09",
      "members": [
        "1e525167-7028-4130-a290-89c0cc1f7b00"
      ]
    },
    {
      "cluster_id": "b84f23af-bd15-4231-83c8-7e4cd068a5f9",
      "members": [
        "4e6ae5f8-c029-4c4c-911c-2249d87b3176"
      ]
    },
    {
      "cluster_id": "2a74c891-6384-471e-8d99-df457b1baa82",
      "members": [
        "8e44b3f6-8941-4118-9684-cee357148f2e"
      ]
    },
    {
      "cluster_id": "473de348-b521-4729-af95-a1929f5cfcf4",
      "members": [
        "d4dd7258-46f2-4967-b8a9-c22fbc3234a6"
      ]
    },
    {
      "cluster_id": "2e4d3514-9265-4850-95e7-fe8c0be93a5f",
      "members": [
        "5e8dfcf3-0b58-4cd5-9849-4dae8da9a114"
      ]
    },
    {
      "cluster_id": "344ea9a5-7537-47d1-9d63-57fb7fadc321",
      "members": [
        "94cbd636-96c5-441e-8084-28d66e0a9c94"
      ]
    },
    {
      "cluster_id": "b45560d5-3144-4d83-a41f-025765799050",
      "members": [
        "99e3cbee-8eeb-4283-b940-26f6d55860bb"
      ]
    },
    {
      "cluster_id": "473550dc-4370-4fcb-8c1a-760765586a92",
      "members": [
        "006a0af7-5134-4b95-ba70-99a654f66320"
      ]
    },
    {
      "cluster_id": "bde83207-e05b-485e-9b86-431574e6c995",
      "members": [
        "66fdb79c-7177-4e29-8db6-3361eb871144"
      ]
    },
    {
      "cluster_id": "4a540701-996b-469b-acc0-9cc53e451ce9",
      "members": [
        "2b6bdc01-aa57-4c64-9a80-48854762b219"
      ]
    },
    {
      "cluster_id": "580850a7-5c15-4040-b450-cddffd7f1f89",
      "members": [
        "f65890dc-6fc9-4d6c-bd46-ea4e94f73923"
      ]
    },
    {
      "cluster_id": "ccd39f23-25f5-4e91-a253-3e3574d7d504",
      "members": [
        "90499542-92a5-4b43-b305-37be2a8caa3c"
      ]
    },
    {
      "cluster_id": "306af663-29dc-401c-bb87-b5eb6547c25e",
      "members": [
        "ff5f1c6b-a058-4e94-bdb9-0a1846fd8362"
      ]
    },
    {
      "cluster_id": "debb5df0-b239-4824-9667-dfdfbc4323cd",
      "members": [
        "fcd23f10-1869-43b2-b82a-c56c211ba8a5"
      ]
    },
    {
      "cluster_id": "8b1384fb-f659-4943-948b-d2766f5d5af0",
      "members": [
        "4e9e4d5c-6e27-4e17-ad6e-b22d8489b781"
      ]
    },
    {
      "cluster_id": "090c138f-cca2-4b65-9a79-43955026e502",
      "members": [
        "00258153-b0fa-4cef-b1ce-bc62bb041f10"
      ]
    },
    {
      "cluster_id": "25a18cdf-150a-41da-b8d4-e997a6088c8a",
      "members": [
        "6ca83595-0bcb-428d-a4ec-ba254a2efbea"
      ]
    },
    {
      "cluster_id": "37fbb780-673c-455c-ae4f-c83136095160",
      "members": [
        "e51f8b71-986d-410f-bd79-93c3e78b00f2"
      ]
    },
    {
      "cluster_id": "8842f019-f536-48be-a730-88d7032d791e",
      "members": [
        "76508154-09da-49a0-95a1-066d078e00cd"
      ]
    },
    {
      "cluster_id": "79e93acb-9f08-48c2-9984-2e0654fbc884",
      "members": [
        "1a261083-868b-4ca7-a6d1-1efed63eb1ca"
      ]
    },
    {
      "cluster_id": "557fbe6b-8c80-48fe-945d-5c4d06e53e9a",
      "members": [
        "761fbe9f-4e8a-4239-83af-c6e54f45e545"
      ]
    },
    {
      "cluster_id": "11415296-938e-40a3-84ae-06be10542d39",
      "members": [
        "2c06f34f-2f19-47ac-8693-44195e18db1c"
      ]
    },
    {
      "cluster_id": "d8eb0da9-3210-4817-8cfc-d7a7f474f829",
      "members": [
        "21f02906-61aa-4635-89e7-dfdef2f8e32f"
      ]
    },
    {
      "cluster_id": "a7e685cc-6af8-4b3d-9fec-fcb894e900d3",
      "members": [
        "e969df4c-6bda-4fda-8faf-8a2f53079843"
      ]
    },
    {
      "cluster_id": "2dda2c1f-f0ae-49cc-b0e1-89a7a1ccbeaf",
      "members": [
        "bd127af5-f593-4936-8d80-4770971638b8"
      ]
    },
    {
      "cluster_id": "b4d7baf4-91b3-4011-b5b5-664a10258241",
      "members": [
        "71c7b3ea-9646-4c99-97af-5f9ae141a87c"
      ]
    },
    {
      "cluster_id": "6c2926f3-1ce9-4f60-a8e9-724e2273274d",
      "members": [
        "a1f58177-6ee6-403c-b59f-e0c47e72f8e5"
      ]
    },
    {
      "cluster_id": "36b35892-f11e-4f98-83df-979e347100dc",
      "members": [
        "465139ad-b844-408e-9047-05e13f2a1617"
      ]
    },
    {
      "cluster_id": "933ba991-e63b-4909-90b5-fbeb9eeea4c4",
      "members": [
        "b882c107-1688-4c7f-aa83-37f8179b332f"
      ]
    },
    {
      "cluster_id": "50450ae6-8d18-4a4d-9adf-9937e9748bba",
      "members": [
        "fedf74b3-da5d-4791-bb62-b882627d82dd"
      ]
    },
    {
      "cluster_id": "eb814822-d982-4fcd-a462-4fccf70598c6",
      "members": [
        "0fbd1e4c-5ae9-42d9-9da5-e0a879fe9a56"
      ]
    },
    {
      "cluster_id": "2f03e50c-f48e-4212-9d22-0ac755bb8fe3",
      "members": [
        "16e3a410-61e7-4567-9254-da415cc634a2"
      ]
    },
    {
      "cluster_id": "75154ca6-776f-46e4-8f4a-2221f93d7ff0",
      "members": [
        "d36dc697-e41c-4adc-903b-d65a6656346c"
      ]
    },
    {
      "cluster_id": "1c223a5c-b5aa-49ca-99af-333b89e0351d",
      "members": [
        "e0403980-e461-44f1-8f2a-cf3d14ecce4d"
      ]
    },
    {
      "cluster_id": "12d14e7e-4e0e-4f5f-8c1e-b4a56335bf02",
      "members": [
        "d350a23c-53ae-49d3-a77b-96740cdef738"
      ]
    },
    {
      "cluster_id": "356f0068-5f51-4299-8ed5-ccb151ae18bd",
      "members": [
        "8e43ca38-477c-461c-b3bc-58e7cf786127"
      ]
    },
    {
      "cluster_id": "74eb8465-812a-44ef-8d54-8544ae40c871",
      "members": [
        "cf666a58-2243-4a76-bb8f-1694da47cc0a"
      ]
    },
    {
      "cluster_id": "74542328-97a3-4775-a89c-6406225efc20",
      "members": [
        "f37eb4c8-03bf-42cd-8294-6b6396362096"
      ]
    },
    {
      "cluster_id": "ea5f2b05-0096-4117-a2fa-b72e433c4955",
      "members": [
        "2d781471-40cd-4135-ae10-5d54b0c2f161"
      ]
    },
    {
      "cluster_id": "77f62262-b0e4-4158-9a7a-25a427bda979",
      "members": [
        "7761aa3f-02a9-44a2-925d-b948230aa424"
      ]
    },
    {
      "cluster_id": "88abea30-b9d6-421a-b97f-a1fffe603d2d",
      "members": [
        "20935077-ae16-44a6-8f86-4b3958ab676a"
      ]
    },
    {
      "cluster_id": "4ab5e1f1-d0b4-460e-98c6-70b27ad80057",
      "members": [
        "97fea7ed-0a59-4136-8d95-48012da6ae95"
      ]
    },
    {
      "cluster_id": "0978a576-627e-40f6-a382-f39885473545",
      "members": [
        "ffe13c8a-2b52-4649-8da5-573147362c7f"
      ]
    },
    {
      "cluster_id": "4e101b24-e99b-4526-bcbc-e5ddeec46f80",
      "members": [
        "db5a3cdb-61d6-4430-98a2-5ca84df09264"
      ]
    },
    {
      "cluster_id": "f8ac7419-698c-4d8c-9bee-1803e1e62a78",
      "members": [
        "370fe09f-1815-44bc-966c-d5620e3f3523"
      ]
    },
    {
      "cluster_id": "bff86a30-1fbf-4d67-9ee5-a1b9649be76d",
      "members": [
        "a1799f97-c47e-4195-b20b-f0ad237b2d47"
      ]
    },
    {
      "cluster_id": "5dffba17-ccea-4d19-b8a2-e0d2197c568d",
      "members": [
        "8f6604c8-287d-433c-a86e-5fe6b1d8304e"
      ]
    },
    {
      "cluster_id": "eda41dea-1eaf-4dc5-ae84-f7a6a29eea13",
      "members": [
        "d41a1e23-eec6-446d-b7fd-b0cfd04fc347"
      ]
    },
    {
      "cluster_id": "f7be2595-331e-49c2-b3a3-087ec837250b",
      "members": [
        "e58137b7-32e2-47b4-97f5-63c8ce35448a"
      ]
    },
    {
      "cluster_id": "15d67b19-b1ca-45ea-8cf1-55236390c45d",
      "members": [
        "e9e683db-688a-4ca1-aab1-a2534d2cbe9c"
      ]
    },
    {
      "cluster_id": "b5f5c5e5-6c1a-4551-a786-04806a60e9b1",
      "members": [
        "cda9134c-6da8-4b17-8062-32c67f8575dc"
      ]
    },
    {
      "cluster_id": "4018b382-2692-4cbc-af34-c3f4f61413b4",
      "members": [
        "ad767526-fcd8-4271-ac09-b4292b190878"
      ]
    },
    {
      "cluster_id": "66406d6a-fd8e-4e61-aeac-decbaba1818b",
      "members": [
        "78fe29da-84f2-4baa-be8d-6fb4ff124304"
      ]
    },
    {
      "cluster_id": "40ef8151-52fc-4fac-bd6f-6b5534d3b754",
      "members": [
        "07010ddd-e21f-403b-9593-a4541391803e"
      ]
    },
    {
      "cluster_id": "b8e4cc10-e335-4506-831c-61365dc19547",
      "members": [
        "e0a99797-941a-4671-bf46-f0dd1bfb658a"
      ]
    },
    {
      "cluster_id": "7eafb3e8-a45a-4448-82d1-c800c85a832e",
      "members": [
        "1fcbb4c4-7fef-4053-8120-08f9f1c2b449"
      ]
    },
    {
      "cluster_id": "590acd5e-f716-496d-b821-297d8887167e",
      "members": [
        "2fee70ad-af03-412e-8657-43b22638b4d7"
      ]
    },
    {
      "cluster_id": "b1eea9c0-c6c8-4d17-a1f4-b1ddcc163363",
      "members": [
        "65ee12b8-784e-47d4-94af-9f72ed77d148"
      ]
    },
    {
      "cluster_id": "a9463f3d-e047-45f9-b0f1-8dca29a15e51",
      "members": [
        "80063df5-4134-4cc5-881d-25ed98bc202c"
      ]
    },
    {
      "cluster_id": "b56f25e8-34c3-4cf5-b21e-1b0f46545150",
      "members": [
        "86986485-7c53-4f97-bbb4-793d8c13c40a"
      ]
    },
    {
      "cluster_id": "2c62c383-cda1-4d02-9286-63fc5fe04c15",
      "members": [
        "6766c2ec-1ad6-43e5-8693-a08588802f0b"
      ]
    },
    {
      "cluster_id": "d623d9ee-820d-4287-a726-51fa68088d0a",
      "members": [
        "1cb913cd-a492-42ac-9a44-2a8d1e7c426d"
      ]
    },
    {
      "cluster_id": "7a9ab53b-bafd-4621-b334-948c7482958f",
      "members": [
        "762c8547-06dc-43a5-ab8e-4135203aea66"
      ]
    },
    {
      "cluster_id": "185df82d-71c3-4fa5-ab56-a142dce4a50f",
      "members": [
        "b7733ee8-2287-4667-9f4f-bbc3ebf6720a"
      ]
    },
    {
      "cluster_id": "2ce189ee-012a-443c-b12c-079c48f7f1a8",
      "members": [
        "c53e1efc-7533-4582-8a01-4b4b6992f8d3"
      ]
    },
    {
      "cluster_id": "b7af27db-59d8-4e96-a280-4b5ae8db2302",
      "members": [
        "4b1e5b8c-8a50-4fe6-98c4-02742ea41abc"
      ]
    },
    {
      "cluster_id": "ce593693-b91d-49af-acbe-d62e8f2dfd88",
      "members": [
        "bfd8e40a-82ea-46ae-bf57-a5bd59789ca5"
      ]
    },
    {
      "cluster_id": "a25c3ac7-1dad-4c90-b412-99d2bc775053",
      "members": [
        "78a9b4b8-6d87-4353-93a6-aa50966bc925"
      ]
    },
    {
      "cluster_id": "507a5fb7-2785-473f-8c2e-99215cff28b8",
      "members": [
        "74f13c59-4f5d-4cc1-a371-290153702650"
      ]
    },
    {
      "cluster_id": "66095ea1-59d7-4068-855b-70fe6ff9d81b",
      "members": [
        "fdf37f84-dd1e-4b1b-a0b5-8a2170318090"
      ]
    },
    {
      "cluster_id": "b46172e4-32c8-4e9a-a7a9-95ade2786490",
      "members": [
        "75ec15a9-628f-4f3c-89d3-eecc766a6421"
      ]
    },
    {
      "cluster_id": "3a63a5d8-fef0-44dd-9aaa-21b0ee109283",
      "members": [
        "a0c42368-b067-43e0-8465-9dfd78e6852a"
      ]
    },
    {
      "cluster_id": "25621853-a487-4563-8dfb-51e9404f5430",
      "members": [
        "ffa46cbb-e67a-4ceb-ba55-1cac0877f028"
      ]
    },
    {
      "cluster_id": "81d59e77-2bcf-4755-b211-fc910c424229",
      "members": [
        "a6f2e0ff-430b-4750-9cff-d43cbf11e3f2"
      ]
    },
    {
      "cluster_id": "357e7a15-3b62-4e9d-ab34-f83d8c925763",
      "members": [
        "a22287a0-316a-4bc3-8877-40c3d8842ed4"
      ]
    },
    {
      "cluster_id": "f1fc4cb5-63a2-420e-a804-9502b1ff9992",
      "members": [
        "b3a49e5e-3812-42ea-835b-08791faac60a"
      ]
    },
    {
      "cluster_id": "fd0c8abe-7ca4-4c28-8c57-cd7f45e50fde",
      "members": [
        "d907f214-9242-4da1-96dc-9f0bc33f61c2"
      ]
    },
    {
      "cluster_id": "3e466027-ffe7-4ec1-877e-eae7c5a1c2c5",
      "members": [
        "4f53296c-a170-4dac-8b3c-95e6d1d09300"
      ]
    },
    {
      "cluster_id": "02b14d03-5d87-4a88-8655-66e1b5dd7380",
      "members": [
        "88b5ff8c-32f4-4cb5-a4c2-5102fb026e29"
      ]
    },
    {
      "cluster_id": "e83deec8-b564-42c6-8487-a1f4fc334b10",
      "members": [
        "afffbb98-7a7c-49ca-9495-deb16124338d"
      ]
    },
    {
      "cluster_id": "51078797-5492-4e49-abad-e30c5a796113",
      "members": [
        "64a38f3a-9456-49bb-ba68-f04e3e791b42"
      ]
    },
    {
      "cluster_id": "7564aa71-23fc-4383-a2a0-0245e543e0fe",
      "members": [
        "83509a11-3f16-4bdb-80aa-2c8c01e9e78a"
      ]
    },
    {
      "cluster_id": "56b88351-b9dd-4f7a-84e1-7a2151d08fc3",
      "members": [
        "fb3df18f-a0a2-4ce9-8600-c2a404c590ff"
      ]
    },
    {
      "cluster_id": "aa7f033a-fd05-4789-9ef5-cce771714a6b",
      "members": [
        "e69f59d9-bb32-4254-9600-13a67472b7d6"
      ]
    },
    {
      "cluster_id": "dc760acb-b4e3-4975-bd26-80f29e06c63e",
      "members": [
        "3b7e99b7-3b5d-4a57-96b9-059447a7b364"
      ]
    },
    {
      "cluster_id": "17e1ec75-19f3-468b-a8ac-9a834a96fe02",
      "members": [
        "b30a505a-f1d5-4f10-b0ab-5bb234feccb8"
      ]
    },
    {
      "cluster_id": "93fda361-8597-486d-ac5b-c68926f25316",
      "members": [
        "bcdfb634-b57d-45e3-872b-b9f0ca36fafb"
      ]
    },
    {
      "cluster_id": "7b3392aa-9600-4d0a-9098-a43e48acd086",
      "members": [
        "93e3db06-166b-4430-8d6e-e05b9cbfc593"
      ]
    },
    {
      "cluster_id": "5219fa36-fd8a-41f9-b4a4-5e01b881c12c",
      "members": [
        "6d58abe6-7936-49a0-ad10-40cde093f941"
      ]
    },
    {
      "cluster_id": "f7e7bb5f-3a49-482d-a3f8-af78fa6ff5b6",
      "members": [
        "7594a110-7e80-429d-b658-24df2a302bad"
      ]
    },
    {
      "cluster_id": "ce82add7-3d2e-4c0b-8f3e-d449dd7f2ee7",
      "members": [
        "fd9efe20-ee65-47ea-9fe4-4e89ddd86750"
      ]
    },
    {
      "cluster_id": "08e45a86-d42e-4e87-9b56-30c3cd685d1d",
      "members": [
        "4925b3b4-190f-4834-b9cc-c5c3b0a387cd"
      ]
    },
    {
      "cluster_id": "21360818-47b1-476a-88aa-682feb18a966",
      "members": [
        "9d10ef81-f6a2-4e49-a199-c1555635e9d8"
      ]
    },
    {
      "cluster_id": "8ef3f5ab-a5d7-4598-bbc0-95b969a66cac",
      "members": [
        "fa25748d-926a-44e1-8ddd-e4885b098639"
      ]
    },
    {
      "cluster_id": "9afd9c54-2f8e-40e0-aff4-8479c84a56df",
      "members": [
        "0933da37-3475-4bcd-bbeb-bc4ec55f9176"
      ]
    },
    {
      "cluster_id": "4eaf7a96-0e00-419f-b612-d0f41e00fc2d",
      "members": [
        "43f60add-d506-4911-8c3b-d18bfa4b5016"
      ]
    },
    {
      "cluster_id": "c40cc82c-67d0-418e-9ae2-4c1dfebaaa5a",
      "members": [
        "1544928a-effc-4c44-a675-e0ccd8e8deed"
      ]
    },
    {
      "cluster_id": "af0e1c10-c1e8-4d6e-955d-02d943d24f8d",
      "members": [
        "e61b3736-c4de-40d8-8d91-d554ea3d8b2d"
      ]
    },
    {
      "cluster_id": "8c92c9ea-d03e-4ce1-b80a-21678d736eec",
      "members": [
        "d05e54c9-b82c-42fb-95bf-184ccbc4a4ed"
      ]
    },
    {
      "cluster_id": "7f953e81-8c8d-4f0d-9b98-873627d95104",
      "members": [
        "fbeda688-b4df-4b53-a93d-d39c1dd97036"
      ]
    },
    {
      "cluster_id": "821b8f2f-ed67-40fb-ac0f-fb14c5b4d7bf",
      "members": [
        "8cdde93c-a746-45b9-8205-898c4d500b29"
      ]
    },
    {
      "cluster_id": "9651dd4d-7b1c-4486-aece-757b68331a49",
      "members": [
        "1d947b67-af0d-4867-8813-556d0f253bd8"
      ]
    },
    {
      "cluster_id": "07db44cf-3ab0-45c7-b71b-6366e225a76c",
      "members": [
        "84969761-5489-4b13-af7f-07a03d61a79f"
      ]
    },
    {
      "cluster_id": "2bad245e-4724-47d8-9180-69fc7c047187",
      "members": [
        "149ba182-0084-4f85-90d7-0f84d73ce5fb"
      ]
    },
    {
      "cluster_id": "f2c109a3-30b0-4718-85b7-78d12406aef5",
      "members": [
        "b3395c9b-a855-4632-996a-a6880f01d05a"
      ]
    },
    {
      "cluster_id": "16245af2-3fab-438a-9670-b11a52942486",
      "members": [
        "c9602f84-6cfc-428e-a39a-1e39f3036e63"
      ]
    },
    {
      "cluster_id": "222e0df8-36ff-4110-93f1-22c42e9ea101",
      "members": [
        "6d93bf25-6d63-4bb6-a61c-e45006074172"
      ]
    },
    {
      "cluster_id": "9da2ed03-3aa6-4daf-9488-c042585d10b9",
      "members": [
        "fa2b9915-d0fa-4520-ae95-970cb5f1f2be"
      ]
    },
    {
      "cluster_id": "5a50b06e-be6d-445e-97b7-86a315a41b46",
      "members": [
        "6c40ede5-fef0-46a2-bc20-6d2a842bfe85"
      ]
    },
    {
      "cluster_id": "73a3ba73-472c-4953-bc98-ef9a9d43fb52",
      "members": [
        "6a6ef44f-4724-4794-aed6-454d1bb76673"
      ]
    },
    {
      "cluster_id": "53c60ecd-a401-4cd8-a176-63a07a0b82bf",
      "members": [
        "c8580ed9-0a2e-4ce0-b659-b31678de8084"
      ]
    },
    {
      "cluster_id": "82a5c9f7-4f90-429a-b7a6-559b1c83bc8c",
      "members": [
        "ec856f56-f10f-4dbb-a15b-27af935ffb06"
      ]
    },
    {
      "cluster_id": "3ce0cb1a-1f92-4f2d-a2e0-fbdd35527908",
      "members": [
        "ba6da7d6-7796-4008-a2b0-f496bf1d045a"
      ]
    }
  ],
  "cluster_links": [
    {
      "claim_cluster_id": "c55d7e50-ed13-4f98-a396-412d6e19decf",
      "event_cluster_id": "59d52e20-3aae-46e2-90cc-c6f03ba747be"
    },
    {
      "claim_cluster_id": "d0dabf1a-0448-47c3-ae6f-96348eaf2cb1",
      "event_cluster_id": "bbc9b8d3-6b58-4072-82ed-eb3aad9d21a5"
    },
    {
      "claim_cluster_id": "8ae7ec4c-38f4-4117-962e-b6f044038377",
      "event_cluster_id": "c8099c76-111d-47ec-a755-9357e7d74d90"
    },
    {
      "claim_cluster_id": "e60065d4-ae50-40b0-8e77-8c2ad3e36235",
      "event_cluster_id": "08d6975b-643a-4b0e-a8cb-576006cbf125"
    },
    {
      "claim_cluster_id": "46f91c43-019b-4419-b509-a0a1e806ff37",
      "event_cluster_id": "299d788c-3d25-4b23-8898-a2eee18a0fda"
    },
    {
      "claim_cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "event_cluster_id": "2ccc0520-5070-4b1d-b1b9-d9e9fc878c97"
    },
    {
      "claim_cluster_id": "42c5367f-fb48-41ea-b66c-1b344a5b61cf",
      "event_cluster_id": "da696f76-5f89-4c8f-bcd4-42e52baed665"
    },
    {
      "claim_cluster_id": "907c652a-92b6-4282-8b7b-0e7b268d4209",
      "event_cluster_id": "5ec58447-e517-44c1-9394-8a5cf3cacde6"
    },
    {
      "claim_cluster_id": "f4f13b9b-3296-4913-8eea-62ce1becaa2c",
      "event_cluster_id": "04b0fab9-75f9-45a3-8f7f-91f5ed199dc0"
    },
    {
      "claim_cluster_id": "68d51d93-fcbe-411f-8a89-cb79bd347512",
      "event_cluster_id": "00853d63-b913-4804-b64a-2b243a93e06b"
    },
    {
      "claim_cluster_id": "54c90db1-79c2-4dc0-b9f0-9cd9022a857f",
      "event_cluster_id": "705d1ff1-cf3d-455b-8c22-31feaaeb943f"
    },
    {
      "claim_cluster_id": "68ff85cf-74e5-4234-a53f-6dba1aacb444",
      "event_cluster_id": "15c0ca40-4379-4a6f-82b3-46b365d5b8de"
    },
    {
      "claim_cluster_id": "ed3519a5-2328-44c8-be3b-f36796b25965",
      "event_cluster_id": "07b3b643-33f3-45b2-87a3-3626fa492cb3"
    },
    {
      "claim_cluster_id": "b9a17741-2ab3-4713-9777-efc674860d38",
      "event_cluster_id": "69d7ee2c-955b-4d7c-a4fa-16491444b045"
    },
    {
      "claim_cluster_id": "fff4a6ed-31c6-43f6-93ef-bd50b7133298",
      "event_cluster_id": "372e4a6e-9817-40fa-807a-570a36d8b0f3"
    },
    {
      "claim_cluster_id": "a1f0e0be-a8bf-4895-ad2d-4f83a0d63930",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "ac4174c2-4597-4a76-ac06-95cefda372c9",
      "event_cluster_id": "593f987b-f53c-49a9-a836-d17fb210c211"
    },
    {
      "claim_cluster_id": "fd5eb376-88a6-437a-8af1-6b857c858d7f",
      "event_cluster_id": "08d6975b-643a-4b0e-a8cb-576006cbf125"
    },
    {
      "claim_cluster_id": "9e906023-8a3d-4a63-9309-18e9ee1c3641",
      "event_cluster_id": "14266895-ce35-4bb7-b24c-c5684c3a1532"
    },
    {
      "claim_cluster_id": "d07c5569-3547-4153-bb09-72f6d513ab57",
      "event_cluster_id": "6272f62e-bf00-43bc-ba48-d3f7c9c3ae02"
    },
    {
      "claim_cluster_id": "9d400cbf-08ea-4c02-941a-80cd2d3e517a",
      "event_cluster_id": "0ed8b02e-9110-4797-abfa-1c73f2dafe4e"
    },
    {
      "claim_cluster_id": "71baf4d7-69f3-4524-9166-04fc35b4043a",
      "event_cluster_id": "964aba3e-f62e-4ef6-b8f3-99237adf29ba"
    },
    {
      "claim_cluster_id": "e9c84dbc-30d1-4e60-bbc8-700057190615",
      "event_cluster_id": "81a59b64-1e50-4ead-afee-e08c8a24c430"
    },
    {
      "claim_cluster_id": "e6759e4c-f697-49ce-a969-2f596e5c4293",
      "event_cluster_id": "ff0f509e-a0f0-40cc-821a-6f046f5aa96a"
    },
    {
      "claim_cluster_id": "73a6792a-38f3-4e05-a1bc-e5dc764c0b4d",
      "event_cluster_id": "7a0376f1-1a7b-4181-a413-d3bc6cd70242"
    },
    {
      "claim_cluster_id": "2052af74-0bc8-401c-a911-035e4f5f65d2",
      "event_cluster_id": "36641d64-6f2c-4f28-a210-946f0a644597"
    },
    {
      "claim_cluster_id": "663bc264-4933-4e53-8689-d8e35c02d013",
      "event_cluster_id": "3ddf92d1-7fbd-4c44-857f-573095c914df"
    },
    {
      "claim_cluster_id": "6c53a575-96c0-4b04-a196-adb1bbc90de7",
      "event_cluster_id": "6195dc7b-895b-4134-9995-738fed6389e2"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00"
    },
    {
      "claim_cluster_id": "ac5cef85-9755-4d73-a0c9-3b2d779220c4",
      "event_cluster_id": "600431fd-692e-4209-97b9-71af21abedf4"
    },
    {
      "claim_cluster_id": "daa86fb1-df31-4a23-a926-1b9981f8df40",
      "event_cluster_id": "7a023b40-1e52-4532-8692-d72ed2b9002b"
    },
    {
      "claim_cluster_id": "6c947694-8652-4e58-b4d1-40be43d3a77b",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "2fe8d49f-63a1-4171-af68-9824e47b825c",
      "event_cluster_id": "bec1d887-4d4c-48f4-9b0b-ebdd0a488702"
    },
    {
      "claim_cluster_id": "3aa4fde2-05d2-4c91-b69f-d61ecc64ca82",
      "event_cluster_id": "009adb33-ebed-4470-bd79-30fe1e0fa2d8"
    },
    {
      "claim_cluster_id": "4effafac-8e45-4dfc-8f71-d8c9b1e37d7b",
      "event_cluster_id": "5abfb564-f878-4ffd-9c7d-3328a283dbfe"
    },
    {
      "claim_cluster_id": "29c942d6-0549-4857-889a-2fc5fd4cf362",
      "event_cluster_id": "a5aa6b9e-3e33-4b44-ab88-d54a834f3817"
    },
    {
      "claim_cluster_id": "493568a9-0e32-4b19-a041-15396f7c15b4",
      "event_cluster_id": "7815f5ae-d441-4f71-b0e2-771810097e05"
    },
    {
      "claim_cluster_id": "b9cdce3c-8c52-4df4-89e7-a4bcf232dbef",
      "event_cluster_id": "d9ddd310-7175-469a-9098-9a1bbbbc4809"
    },
    {
      "claim_cluster_id": "b433d9b9-0986-4c75-baab-f74fc73be2ca",
      "event_cluster_id": "d748d1bd-38e3-44b3-b268-429f4615acee"
    },
    {
      "claim_cluster_id": "655a46a8-9b52-4f61-b528-9f18ec9bf051",
      "event_cluster_id": "590acd5e-f716-496d-b821-297d8887167e"
    },
    {
      "claim_cluster_id": "738e60fd-1e3d-4820-98bf-d6bd9e7a3172",
      "event_cluster_id": "53d925d3-b8ff-4816-9cb6-be1191e8d6ba"
    },
    {
      "claim_cluster_id": "9723a8c8-8969-4471-bc9d-732ca83fc5b6",
      "event_cluster_id": "31a83c0d-3856-4e30-82d4-769416b594bd"
    },
    {
      "claim_cluster_id": "be9b7361-8150-4e4b-9111-bac990c11d3d",
      "event_cluster_id": "357af95d-b02c-4002-bfc2-fdd9ff848257"
    },
    {
      "claim_cluster_id": "51207b82-ee2c-47cd-adf4-cdd41f93d43d",
      "event_cluster_id": "6aece148-00ae-441a-a570-cbee981c2154"
    },
    {
      "claim_cluster_id": "7b0fb73a-9488-43a9-80ee-d1864bcbae49",
      "event_cluster_id": "1ec0df43-8c4d-467b-94f6-ad15fb3c5b4a"
    },
    {
      "claim_cluster_id": "ca871236-c037-4fa9-b3bc-cfec982a8e55",
      "event_cluster_id": "717d4990-dc27-4922-b8a1-6a5e44493918"
    },
    {
      "claim_cluster_id": "3543d3e3-081b-448e-9ec9-915bf37d6255",
      "event_cluster_id": "3f015f88-0af0-482a-a4a6-663bbcc6d95b"
    },
    {
      "claim_cluster_id": "25d9faf4-4231-47e1-9e78-17114da0186c",
      "event_cluster_id": "7b6712d2-df6d-4fa5-944c-8d0321a2652c"
    },
    {
      "claim_cluster_id": "6f847ace-00e0-4009-b5e9-3729f7a9e244",
      "event_cluster_id": "f7b7014d-ad07-4661-9448-28c218c2eea5"
    },
    {
      "claim_cluster_id": "590ca39d-bd4d-431b-829a-90d0f3384aa4",
      "event_cluster_id": "13eaad2c-4351-4227-a2c2-4a8d3df4410b"
    },
    {
      "claim_cluster_id": "d5dab78c-a52b-4ef8-8000-44988a029a7c",
      "event_cluster_id": "c5d49178-7807-406f-89c6-f05965bb7e2e"
    },
    {
      "claim_cluster_id": "48358541-e77a-4c9f-81e2-7af006f34920",
      "event_cluster_id": "2077703d-3e6d-40f8-85a7-39edc747b3a1"
    },
    {
      "claim_cluster_id": "bd13c9c1-afe0-4a04-acc3-453f611b1f14",
      "event_cluster_id": "91289460-848a-4396-988d-42e28ce5078b"
    },
    {
      "claim_cluster_id": "b7bef44a-7480-409a-8790-0a70b42045ee",
      "event_cluster_id": "9ee44494-957f-41e5-a680-3bacf709709f"
    },
    {
      "claim_cluster_id": "f367b654-8f0a-4a4d-816e-54c86d7f13ae",
      "event_cluster_id": "f6ad38c8-1553-418f-93f5-4a6bb4909e2b"
    },
    {
      "claim_cluster_id": "ab1842ba-5e92-4ba8-ab55-1241a116a859",
      "event_cluster_id": "d467c165-3190-4bf1-b5b6-3c529b474781"
    },
    {
      "claim_cluster_id": "c6aa0cad-31b1-4d56-9f83-938881501dbd",
      "event_cluster_id": "473560b4-10a2-4370-be8e-3ebeae00ae74"
    },
    {
      "claim_cluster_id": "7440fefd-f7fe-4402-9218-79fa9f53df91",
      "event_cluster_id": "2bd21a46-0627-4917-ba75-98775bf2627b"
    },
    {
      "claim_cluster_id": "da2845de-4e1b-492a-a6b0-06fd4584650e",
      "event_cluster_id": "856fcb01-3b6d-4fcd-80d4-8e260efa7cd2"
    },
    {
      "claim_cluster_id": "13672f1a-e63c-4ec7-9f85-d3ed61ff60fa",
      "event_cluster_id": "9b14b6b9-92d5-4da7-813f-eb820b5a4071"
    },
    {
      "claim_cluster_id": "5bc0db5b-3192-42d4-a343-00cfcacc4499",
      "event_cluster_id": "f7fe1cc8-30c8-4879-8f22-1fc4904694c6"
    },
    {
      "claim_cluster_id": "00c920c5-f4fa-404a-9d1e-12f311ed5e11",
      "event_cluster_id": "83b8e4b4-0c78-4b19-aa89-21b8a62c50fe"
    },
    {
      "claim_cluster_id": "9e4983ab-c919-470b-9bac-8b6c4b633a1e",
      "event_cluster_id": "610fe915-6f9a-4623-a217-8c3cff21b2cb"
    },
    {
      "claim_cluster_id": "6dd833f9-26f5-4505-8729-234f3f5eeeb4",
      "event_cluster_id": "6c6a46a0-71cb-45d2-a4dc-1eee1da7c7f4"
    },
    {
      "claim_cluster_id": "3a774e33-2c16-4d7b-91f8-38103798acd4",
      "event_cluster_id": "03d5681c-cee7-4784-a946-350af3b91054"
    },
    {
      "claim_cluster_id": "a49a51da-aad1-43de-81b7-51f95b22eabd",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "c7bb1d74-7395-4554-a7ef-ec1f5c743579",
      "event_cluster_id": "0834a3ac-a924-43d8-bec6-6e7d0a1384ad"
    },
    {
      "claim_cluster_id": "3b1a4f1c-eb8e-4934-89a0-1d405c7425e6",
      "event_cluster_id": "07969927-bc1e-48a3-8b9c-29bb62214363"
    },
    {
      "claim_cluster_id": "9ef27775-8065-4722-bd90-8a9ae4a3c250",
      "event_cluster_id": "66b7068d-b746-42ae-9f41-d88ed9a887f4"
    },
    {
      "claim_cluster_id": "9ef9c32c-d40a-4d36-a3db-c01367d4c96e",
      "event_cluster_id": "fff91b42-2999-4568-8b58-028bf8ca7046"
    },
    {
      "claim_cluster_id": "662000fc-1ecb-4634-b4e8-efc53b2b3287",
      "event_cluster_id": "0e4e78e3-4606-4902-b549-07174e100568"
    },
    {
      "claim_cluster_id": "a38c8b34-2d1e-4ee9-ac98-b7d045e07fb4",
      "event_cluster_id": "30b7ce37-8fca-4fe2-b499-bda00e36d905"
    },
    {
      "claim_cluster_id": "fa68205c-96de-4570-af4d-97691aaf5e3a",
      "event_cluster_id": "00cb3646-a2c2-4ca4-9bd3-507a4d1eade7"
    },
    {
      "claim_cluster_id": "40a361aa-d57e-4e3c-9740-34505f34913c",
      "event_cluster_id": "a2124c19-e133-4d10-984d-0d176559c1d9"
    },
    {
      "claim_cluster_id": "c78cce84-ea53-4b86-8393-67ca74594e0c",
      "event_cluster_id": "993498fc-f160-4c04-b836-a36d850156e5"
    },
    {
      "claim_cluster_id": "3579f3e6-5ab6-488d-a555-602383a4e3bf",
      "event_cluster_id": "2702052c-d199-4761-be47-a9217e23735a"
    },
    {
      "claim_cluster_id": "5aad8736-b18a-4e21-930e-320f4faaed1c",
      "event_cluster_id": "48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"
    },
    {
      "claim_cluster_id": "f6541b8c-4e86-4aff-8593-e4f14f2ecc27",
      "event_cluster_id": "5f8dbb60-ef34-416a-9285-ed818708d337"
    },
    {
      "claim_cluster_id": "2f6021e2-bde5-4c10-ae2b-194bf6a93505",
      "event_cluster_id": "0bc010ee-21eb-4a56-88df-bd3b94b15999"
    },
    {
      "claim_cluster_id": "1e9c3202-7611-4885-bb24-d9dd05b7eed3",
      "event_cluster_id": "40a69599-ced7-4b8f-b20e-fb9c99238bbb"
    },
    {
      "claim_cluster_id": "7cff4302-4ea6-4196-96e5-448a227d2f09",
      "event_cluster_id": "08533bcb-cb39-43d6-9371-79f7aa905623"
    },
    {
      "claim_cluster_id": "8f381ec8-c658-466c-973c-6cace2609d01",
      "event_cluster_id": "55b3fec7-2c59-48a7-b144-2bc454de6078"
    },
    {
      "claim_cluster_id": "c0707d1f-d796-4de7-994b-fd76b5d9d3dd",
      "event_cluster_id": "b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb"
    },
    {
      "claim_cluster_id": "b6f111d6-8112-47dc-baeb-43c77c6392ea",
      "event_cluster_id": "dfe985d2-9dfe-4657-be1d-a745b7ca1ca6"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "0c87e09a-5d40-4c46-abb8-ffdda4139e41"
    },
    {
      "claim_cluster_id": "4736fddc-4878-48ef-a211-f6b0740cc434",
      "event_cluster_id": "ffd8b278-907b-41d6-9ed9-9d3e17a00678"
    },
    {
      "claim_cluster_id": "1dc0ed5e-e098-401c-9b18-3dd42ba6b01f",
      "event_cluster_id": "a52cd2df-a03c-40f8-a7af-c56d32311c99"
    },
    {
      "claim_cluster_id": "3720666b-a4ac-4b21-9f19-2a86f32551a0",
      "event_cluster_id": "e7545678-2204-4c5b-ba0d-fefcb6897378"
    },
    {
      "claim_cluster_id": "7c9beeef-07c1-4872-bfac-86e8c63a87f9",
      "event_cluster_id": "f4412fc5-966c-440c-829a-8ca0977913f0"
    },
    {
      "claim_cluster_id": "36d5c8e6-5870-44de-bee8-1ba3638e2785",
      "event_cluster_id": "9d6d3278-c0e4-4003-a311-bf3945445bf7"
    },
    {
      "claim_cluster_id": "b34ea819-97f6-4215-92c0-351b2f770110",
      "event_cluster_id": "5326cc13-3625-47b1-ad75-82ef998d0dce"
    },
    {
      "claim_cluster_id": "2a0a6106-78d5-46ad-ad52-e0296bf7134a",
      "event_cluster_id": "45be894d-986a-43be-b81b-3a8308fba0de"
    },
    {
      "claim_cluster_id": "542e81d5-bf51-451b-bb6a-204f6c8da58e",
      "event_cluster_id": "f43dba3b-7d34-4eea-96eb-854a495fe8e2"
    },
    {
      "claim_cluster_id": "aa30bf70-0cba-416d-ab58-48d58cb2a343",
      "event_cluster_id": "ab8af083-dfdc-4c18-95cd-32d551c130c1"
    },
    {
      "claim_cluster_id": "5a861756-5d94-444c-84a0-fab63d482e8c",
      "event_cluster_id": "91a2ed36-3e87-4baf-9999-c65078a62cbd"
    },
    {
      "claim_cluster_id": "29790db2-2536-415f-822b-9a4c1f1f8a3c",
      "event_cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee"
    },
    {
      "claim_cluster_id": "1d8a91a4-e2e3-49c2-838b-462dda682ab0",
      "event_cluster_id": "2ef61e30-e6d5-41b7-8ea0-69add1125af6"
    },
    {
      "claim_cluster_id": "10cadbd2-7261-4295-9f88-df0f9a246b5b",
      "event_cluster_id": "21916347-9bda-4844-a220-12a3c8d5bdd0"
    },
    {
      "claim_cluster_id": "33fe2055-c6c1-46ed-8871-fc741999d32b",
      "event_cluster_id": "4b93a421-107c-4185-912b-a73d039895b4"
    },
    {
      "claim_cluster_id": "657ed7b6-8b7c-41a6-8900-c8d11bb6982a",
      "event_cluster_id": "9a2fe341-e356-4c2f-afb2-12f391a85d04"
    },
    {
      "claim_cluster_id": "bf53e706-320e-4307-85d6-fcee526f5f17",
      "event_cluster_id": "1ed52c55-1d90-4460-9e88-861e6d435eee"
    },
    {
      "claim_cluster_id": "cc2021eb-f979-4db2-af0b-d0533b90627c",
      "event_cluster_id": "8cb39409-fba3-4dfe-91d4-98f7dbf55b5e"
    },
    {
      "claim_cluster_id": "f14e0258-b8de-48c8-96bd-31550d005b4b",
      "event_cluster_id": "c74eddc6-9017-4628-9942-40823cd7e30e"
    },
    {
      "claim_cluster_id": "3b4d0d09-6630-4f48-897e-19fe1449086b",
      "event_cluster_id": "6aece148-00ae-441a-a570-cbee981c2154"
    },
    {
      "claim_cluster_id": "7742ec5a-27ab-42d2-9779-df7d73a0cec4",
      "event_cluster_id": "dd1b900d-edc5-41a8-a7b7-0e0de59cf33e"
    },
    {
      "claim_cluster_id": "d8eb9cee-8720-428c-a044-b6a3e22a6bb8",
      "event_cluster_id": "ff6f2ca1-7367-40eb-b2f8-72fa90168057"
    },
    {
      "claim_cluster_id": "52105c27-d937-4970-9bad-c139e21a6205",
      "event_cluster_id": "0d049984-1ab9-44da-bbd0-bb9c99a21317"
    },
    {
      "claim_cluster_id": "b523cd60-7c0d-4c50-b41c-3522aed9c4b1",
      "event_cluster_id": "59f5b290-5ff4-47d6-96ce-35630701a6e9"
    },
    {
      "claim_cluster_id": "dfd567bb-1650-495c-ac2d-4d240d441b79",
      "event_cluster_id": "2e85430c-b3c5-4c1b-88d2-e366b82a50f9"
    },
    {
      "claim_cluster_id": "dde1cfea-875f-4bd7-a73a-639065b04c0c",
      "event_cluster_id": "ba19914f-8e64-44f6-86f3-04a0671b4419"
    },
    {
      "claim_cluster_id": "dfd567bb-1650-495c-ac2d-4d240d441b79",
      "event_cluster_id": "34dc1cb7-40ca-44c8-a250-8a0dace843a0"
    },
    {
      "claim_cluster_id": "761efa26-8da9-4e7d-a7d6-a4e67c04fce5",
      "event_cluster_id": "bf2543e7-3701-40bf-a97c-164b45c21900"
    },
    {
      "claim_cluster_id": "e1e2a57a-7e63-4b0b-b70f-2189a87649d4",
      "event_cluster_id": "9af760e6-eb03-4959-a360-3cdeab7333f8"
    },
    {
      "claim_cluster_id": "fd5eb376-88a6-437a-8af1-6b857c858d7f",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "f570b12b-c8a8-4d99-9575-a11a563abe1c",
      "event_cluster_id": "efd04eb7-8311-4730-bee6-1df74b27a996"
    },
    {
      "claim_cluster_id": "29d5756f-2c13-4cfb-b4e4-f439665752b9",
      "event_cluster_id": "e4d59809-92d5-4450-8181-b93bc5f5d348"
    },
    {
      "claim_cluster_id": "ef57a08c-bb40-48bb-8784-c240ed933462",
      "event_cluster_id": "aa7f033a-fd05-4789-9ef5-cce771714a6b"
    },
    {
      "claim_cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
      "event_cluster_id": "56bced3d-5502-4c62-9756-ced2f88eec36"
    },
    {
      "claim_cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
      "event_cluster_id": "3871b01c-7dc4-4fb6-92f9-6bc76f4cf80c"
    },
    {
      "claim_cluster_id": "8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6",
      "event_cluster_id": "c99367c6-2c05-4a14-b047-7f8ff36ff133"
    },
    {
      "claim_cluster_id": "6436c54d-cea9-4b06-8f6e-d82ef558f6c5",
      "event_cluster_id": "4f2c99ad-9a7b-43ad-b8d0-304aa8cd2c73"
    },
    {
      "claim_cluster_id": "152e2cd2-1d15-4787-b90e-76e34ac56ace",
      "event_cluster_id": "5b67eeb9-9da5-4079-bb66-f861e834a37c"
    },
    {
      "claim_cluster_id": "7c9c690a-19a8-4aac-aba5-327f2a8b5923",
      "event_cluster_id": "adb1b0be-f075-4e0a-9c6e-397dd0fde17c"
    },
    {
      "claim_cluster_id": "a9d64d25-62ff-4c83-a924-9b0477ad4c22",
      "event_cluster_id": "9cb46e58-ec9c-4071-b505-f4806f5522e9"
    },
    {
      "claim_cluster_id": "7ac1c88c-d620-4c32-9f9d-5a780231627e",
      "event_cluster_id": "291e783e-a633-4a70-baad-9d43cf49aa7b"
    },
    {
      "claim_cluster_id": "f44705d5-ac0c-43e4-b025-c68545daa916",
      "event_cluster_id": "43a57714-f5d9-437b-8d5c-b293145616c2"
    },
    {
      "claim_cluster_id": "bae449de-e29c-430c-9526-c8dc925bf231",
      "event_cluster_id": "2bad245e-4724-47d8-9180-69fc7c047187"
    },
    {
      "claim_cluster_id": "9cf07839-b78b-4d19-aeee-e70ec12a23d1",
      "event_cluster_id": "b2a104aa-8e99-4af3-a2f3-b3e4f2fb5af6"
    },
    {
      "claim_cluster_id": "f3c74d17-b66b-49d5-9e91-ad7f843bbd39",
      "event_cluster_id": "33c3bbfc-4975-4a68-9abe-5dd608b4ec62"
    },
    {
      "claim_cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
      "event_cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810"
    },
    {
      "claim_cluster_id": "952d3c78-e97c-4ff6-a488-1e2f6353d3c9",
      "event_cluster_id": "d3561f7c-f545-493a-88e4-1feb8895eb1b"
    },
    {
      "claim_cluster_id": "86cde8dd-df84-48da-a045-d001baaf3298",
      "event_cluster_id": "a801c6f6-51a8-4c16-ae79-750cf640303a"
    },
    {
      "claim_cluster_id": "21956ecc-f782-4f55-8347-f78333fc6d97",
      "event_cluster_id": "865f10e6-6341-4c82-a7d2-80f23cacd415"
    },
    {
      "claim_cluster_id": "162b03a4-86a7-4adf-9f73-3093aecba542",
      "event_cluster_id": "926c487a-2b3f-41e8-acd8-d984df721c84"
    },
    {
      "claim_cluster_id": "c2c441c7-f2bd-4b4f-baf1-ba82eaa0b970",
      "event_cluster_id": "fbeea9d9-e3b5-41fa-b94f-503292015b12"
    },
    {
      "claim_cluster_id": "54c46b5a-065c-41a2-90e0-3fac031eb853",
      "event_cluster_id": "2ef3ee94-6c9d-429b-95e7-08b756215251"
    },
    {
      "claim_cluster_id": "42734325-e832-49e4-b0f3-d3af89abdf66",
      "event_cluster_id": "4d4564a4-dc41-47bf-ad98-75e34d4a1d0d"
    },
    {
      "claim_cluster_id": "a92df9a8-beac-475c-a620-574a5351def4",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "51218502-220c-4467-8b26-b12d809fed98",
      "event_cluster_id": "e216b0a7-0193-4a30-a076-a872f378296d"
    },
    {
      "claim_cluster_id": "b63983c2-35fa-4152-8cc2-8380b6cbde79",
      "event_cluster_id": "9d7361f1-563b-4b70-8f5c-fc18e12402d2"
    },
    {
      "claim_cluster_id": "e2dae5ce-65e5-4bf8-ac38-f452e98e9363",
      "event_cluster_id": "1c65b00f-4fc8-40b9-b323-8ff074f956ae"
    },
    {
      "claim_cluster_id": "de3dfa95-4771-45cc-8a31-d6c35fbb0eb5",
      "event_cluster_id": "364b6018-e5e4-4d17-9b1f-0b9d5fe116fa"
    },
    {
      "claim_cluster_id": "9bcb7463-7e6a-4bab-b398-5dd6ead423be",
      "event_cluster_id": "eee2bcf1-74da-4f68-9a16-f7f155a012a3"
    },
    {
      "claim_cluster_id": "53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c",
      "event_cluster_id": "b617ae42-60a1-4bd9-bcd3-a29cc6c02448"
    },
    {
      "claim_cluster_id": "f6541b8c-4e86-4aff-8593-e4f14f2ecc27",
      "event_cluster_id": "7e081e03-60f5-4239-923e-30df23ea9e14"
    },
    {
      "claim_cluster_id": "b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4",
      "event_cluster_id": "9821057e-b80c-444e-8823-153881d41c90"
    },
    {
      "claim_cluster_id": "ebf0120f-ec3a-4a71-bd2b-88f212264387",
      "event_cluster_id": "23451a3d-c01e-4597-9cbd-b34940e92d21"
    },
    {
      "claim_cluster_id": "ccf91c48-303e-4d94-8263-0e8c6de64e17",
      "event_cluster_id": "b8ba4862-a01f-4bea-9d65-d965f8a811ea"
    },
    {
      "claim_cluster_id": "3428edf1-36a0-4018-889a-63913498a6c3",
      "event_cluster_id": "65719321-4c0e-421c-be0d-ae0fd54b036d"
    },
    {
      "claim_cluster_id": "49b52e42-84db-4d97-b9a4-ffd3211b536e",
      "event_cluster_id": "c1d6fe8d-9eec-42fb-a300-6a6e37dcd1f2"
    },
    {
      "claim_cluster_id": "a1ac0514-0dd2-43ae-9f2d-5939e791e058",
      "event_cluster_id": "49af375a-1b87-4e0c-b77f-9747485eaee4"
    },
    {
      "claim_cluster_id": "bc0539c0-9358-42cb-bbfb-8c0b934c5e86",
      "event_cluster_id": "93863b1e-b8da-4bf9-893e-8c00bcaf88db"
    },
    {
      "claim_cluster_id": "e126486d-8b99-4425-b6a3-54724b486b78",
      "event_cluster_id": "d2828cf5-cc91-4e95-82bf-be47e19b88ee"
    },
    {
      "claim_cluster_id": "ab9886f5-759f-416b-88de-b9f771cf04e1",
      "event_cluster_id": "6c08edb9-0ade-407d-af97-cbc1278990ac"
    },
    {
      "claim_cluster_id": "61c8550e-839e-4f39-803d-72ebbfa747a7",
      "event_cluster_id": "e0a1afab-5142-40ca-ad10-35061b0289f8"
    },
    {
      "claim_cluster_id": "5288ae46-832e-4436-95ed-05106d5e8d73",
      "event_cluster_id": "2bf4835a-c2d9-4984-a011-415e8a457306"
    },
    {
      "claim_cluster_id": "391ac4c5-638b-42bc-b8d7-1972d56df43e",
      "event_cluster_id": "8985495d-c23b-4b4d-8af8-d412abf8767b"
    },
    {
      "claim_cluster_id": "f6a4aea6-92b4-4a70-a984-2326df1ee39e",
      "event_cluster_id": "230aa320-84d5-49f6-9755-fd2e7a1037ab"
    },
    {
      "claim_cluster_id": "aea747b1-1cb4-4b3d-94df-5c33181b0976",
      "event_cluster_id": "4ecf3311-91d6-4f18-a13a-b2646404483d"
    },
    {
      "claim_cluster_id": "e8b8352a-472f-4b00-9dae-87cd809f920e",
      "event_cluster_id": "caa057e8-994e-43b8-803e-0ea0aeab7ec7"
    },
    {
      "claim_cluster_id": "25d9faf4-4231-47e1-9e78-17114da0186c",
      "event_cluster_id": "4ea543a7-37aa-415b-8870-050c7ede5ba0"
    },
    {
      "claim_cluster_id": "5b7e1f2c-86a3-4e27-9c3e-c974a8d33606",
      "event_cluster_id": "74c516ce-db78-4790-b130-64ce1c94e700"
    },
    {
      "claim_cluster_id": "c55d7e50-ed13-4f98-a396-412d6e19decf",
      "event_cluster_id": "fcd590cf-7159-4dd1-af40-6a6c770d2797"
    },
    {
      "claim_cluster_id": "0407f887-a8ce-4c09-bc8f-570e66bd3e6b",
      "event_cluster_id": "c7bef51e-9aa9-4b77-85bc-5a1620f4b37e"
    },
    {
      "claim_cluster_id": "d637ae20-ea81-4c6e-85e0-ffbd0f9a76b5",
      "event_cluster_id": "ad8eb55d-3403-4e48-a3d6-9bc723fa02c6"
    },
    {
      "claim_cluster_id": "deb1b19f-f313-46a8-8e93-d75203af3775",
      "event_cluster_id": "6fb56d95-1435-4a1c-8bf2-454a172c105f"
    },
    {
      "claim_cluster_id": "4848ddfa-b6c3-4770-996a-7e5c266b5b88",
      "event_cluster_id": "1acc7240-f221-42ca-8a48-7f6a18f1f844"
    },
    {
      "claim_cluster_id": "0bb1f8c0-08c1-4f63-b6c8-052a5bad160c",
      "event_cluster_id": "58160b77-275a-49fd-b4ad-b9a4e0aa40ef"
    },
    {
      "claim_cluster_id": "dc73c39b-d234-4200-a04f-dc1af208480d",
      "event_cluster_id": "25e1da60-126d-485f-b6b4-e17bd08835f7"
    },
    {
      "claim_cluster_id": "5288ae46-832e-4436-95ed-05106d5e8d73",
      "event_cluster_id": "1e061f92-2688-4d15-8cdc-93767b97df6b"
    },
    {
      "claim_cluster_id": "494d200b-d2e7-47ec-bdd7-86aef2459978",
      "event_cluster_id": "a1957de3-964f-4df5-ac8b-e165983c14d7"
    },
    {
      "claim_cluster_id": "7b4d9f3b-78aa-4507-8228-424f51cb5289",
      "event_cluster_id": "af0e1637-dbe6-45fb-a04a-6bc7ad84725f"
    },
    {
      "claim_cluster_id": "8bbb9fde-a60f-4687-9398-276e5d036952",
      "event_cluster_id": "089384c1-0ce2-49fe-812c-a7e86deaedaf"
    },
    {
      "claim_cluster_id": "c64abad7-175d-470b-9931-9259e05b39f5",
      "event_cluster_id": "9348816a-379b-4a83-98b4-cd843f9d8989"
    },
    {
      "claim_cluster_id": "011b48fb-6ec4-41cc-bd4d-394e371c18cb",
      "event_cluster_id": "a1711988-408b-42c4-8682-720bf33be6bf"
    },
    {
      "claim_cluster_id": "41a55c60-75f3-48f5-817e-bc3dd4fc026d",
      "event_cluster_id": "b3677c08-0eb1-4865-90d2-0d359e3678b8"
    },
    {
      "claim_cluster_id": "454ec49b-c8f2-4a1a-ae0e-928918575347",
      "event_cluster_id": "eddd54f6-a534-43f3-a4ac-88a9769ba8d0"
    },
    {
      "claim_cluster_id": "db268f9a-c3a8-4e79-a3b0-df934c32f645",
      "event_cluster_id": "4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"
    },
    {
      "claim_cluster_id": "6eb67c15-59c3-481b-bf8b-2e464b0775ec",
      "event_cluster_id": "432f6df5-1641-407a-a774-485c9d80d467"
    },
    {
      "claim_cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "event_cluster_id": "d1f35128-46aa-4b3e-8942-ed03c647bdc7"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "9f394b1e-f3b6-4528-a71b-dd2fed1c81a5"
    },
    {
      "claim_cluster_id": "e41399b8-77c7-4930-886f-cd94ab46ea34",
      "event_cluster_id": "a208cf67-b0d4-4139-aecf-8fec75c13ae1"
    },
    {
      "claim_cluster_id": "8143472f-9ddf-4467-8402-c46a70ccaf1e",
      "event_cluster_id": "cf4eccba-19e9-4f9a-984a-135d1c838ee6"
    },
    {
      "claim_cluster_id": "f58e8498-102b-4b72-96b4-c6d5b3fb97a9",
      "event_cluster_id": "cf3cadee-d476-45f2-a534-bfb4334bffb9"
    },
    {
      "claim_cluster_id": "f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1",
      "event_cluster_id": "e539011c-4c48-4afd-9e8f-3e4ca7d332fe"
    },
    {
      "claim_cluster_id": "b40ccc38-63a5-4a58-8bbb-6242768fb158",
      "event_cluster_id": "d76d71cb-517d-47c2-8ed2-a260ceec7c7c"
    },
    {
      "claim_cluster_id": "60a1acab-79cf-438f-96de-dbff294bd2e7",
      "event_cluster_id": "9a201ba4-4fa1-4a8f-b530-b70790363696"
    },
    {
      "claim_cluster_id": "a7043201-daf7-4ddc-86e1-fe3a850942e2",
      "event_cluster_id": "ff3c71b1-9872-4a9b-a091-8300e856f9b9"
    },
    {
      "claim_cluster_id": "fe5b3c77-4467-4eae-82f8-8e1dd2f75d5b",
      "event_cluster_id": "fb0c78fb-f7a8-4921-9cdf-94739c1d1c3e"
    },
    {
      "claim_cluster_id": "aed74a8c-a339-4a19-a144-bb62990f8e50",
      "event_cluster_id": "00ecc521-dbbb-417a-9961-132c4f488d88"
    },
    {
      "claim_cluster_id": "d3bded76-52fd-4f86-982f-558582eed404",
      "event_cluster_id": "0cf451c3-4981-46fc-b4ee-79c480a2a2b9"
    },
    {
      "claim_cluster_id": "dcc40b89-996b-46da-af7f-ec64a05c6ee5",
      "event_cluster_id": "cf47a2c1-26a3-4471-9b1c-8c8f4c68cc10"
    },
    {
      "claim_cluster_id": "23bf4739-72bc-492b-9320-78f2bdc83074",
      "event_cluster_id": "174c41e7-d29c-43ee-b99a-262cda821c4f"
    },
    {
      "claim_cluster_id": "43fa6264-b651-4eef-9023-b4483c40f5ce",
      "event_cluster_id": "ed56cb15-531d-4953-a25f-e17a3cb3fb76"
    },
    {
      "claim_cluster_id": "9c9d4ed6-a861-4706-aee3-f148f1769c86",
      "event_cluster_id": "f7bc5745-3844-4596-a6d1-1d8cba63f4b6"
    },
    {
      "claim_cluster_id": "8bc3dd02-5989-4bb6-8266-c27296d666f8",
      "event_cluster_id": "52572bed-fd4b-4180-9ada-bef96be23270"
    },
    {
      "claim_cluster_id": "370919c9-f171-4096-adac-3abd415be93c",
      "event_cluster_id": "c2b68e30-8952-4460-9fc7-b286c267a038"
    },
    {
      "claim_cluster_id": "f44705d5-ac0c-43e4-b025-c68545daa916",
      "event_cluster_id": "a720530c-6855-4d9b-b222-ba31bac4c4c3"
    },
    {
      "claim_cluster_id": "dbdede5c-5c9e-4c2c-acc7-81cff6d78ffd",
      "event_cluster_id": "6e3b5d0b-67db-4d14-8384-2b3799aec6bd"
    },
    {
      "claim_cluster_id": "4ac1da2e-cd03-4a11-b440-f62dc8f73aad",
      "event_cluster_id": "3582a60f-77c5-4a28-b692-e25a35716357"
    },
    {
      "claim_cluster_id": "cba79c22-94bf-4911-a28d-ebd794325eaa",
      "event_cluster_id": "525ead27-9fb0-4fe0-aa10-52b70492601c"
    },
    {
      "claim_cluster_id": "f44705d5-ac0c-43e4-b025-c68545daa916",
      "event_cluster_id": "2293ca8e-aa2e-4ee2-b17a-f9a9255d1eb1"
    },
    {
      "claim_cluster_id": "a5124b94-6b98-447d-9c53-5100339210c5",
      "event_cluster_id": "32363fbb-b809-46d2-baba-aad9f54a7b98"
    },
    {
      "claim_cluster_id": "7b49f746-2118-4c08-9ef0-985906af7b07",
      "event_cluster_id": "c1c6d1f6-6fc4-4a8f-bdca-cd82345bf948"
    },
    {
      "claim_cluster_id": "8140cb8c-a254-4493-b790-598f4ef3676f",
      "event_cluster_id": "acf3ef41-5374-4f21-834c-c4a11d955ee1"
    },
    {
      "claim_cluster_id": "a0aafb48-1cc4-47f3-9cc7-073b87c64efc",
      "event_cluster_id": "7fd1b210-1374-4030-b2c1-ddf3869ca13f"
    },
    {
      "claim_cluster_id": "b180d822-88c1-4c5f-a386-c975497c4a85",
      "event_cluster_id": "dd183126-5d54-4c76-bc6b-357daae335e6"
    },
    {
      "claim_cluster_id": "cdb08998-bbe0-4530-9534-7744fb962961",
      "event_cluster_id": "e4c9c7c5-e3e0-45e8-9f4d-644aa55e2107"
    },
    {
      "claim_cluster_id": "a4e781c0-f96b-465a-94d9-bc076c57b2b1",
      "event_cluster_id": "da5f41fa-d075-4835-b977-9a11cca0ec10"
    },
    {
      "claim_cluster_id": "f09098cc-f345-415b-a2a8-3f7563f7b80d",
      "event_cluster_id": "3712fc59-da49-45a4-ae5a-90b1831dcece"
    },
    {
      "claim_cluster_id": "fcc1829e-1835-42a8-bf49-00b5c2d30892",
      "event_cluster_id": "c4d30aec-5c26-4bc5-895d-1e61d6d7b97e"
    },
    {
      "claim_cluster_id": "09f8ca5f-e359-4e32-b6bf-f706de588232",
      "event_cluster_id": "e5320752-1012-4ce5-880c-e80ddb6ab4ee"
    },
    {
      "claim_cluster_id": "761efa26-8da9-4e7d-a7d6-a4e67c04fce5",
      "event_cluster_id": "4722732e-36ea-4a20-b934-96b47f115eac"
    },
    {
      "claim_cluster_id": "b6a83d03-593e-48c8-ac84-66fa31a32a89",
      "event_cluster_id": "76836166-e9eb-4d22-93c5-16c83ebc5bbe"
    },
    {
      "claim_cluster_id": "574951aa-9eb6-4bdd-ac47-891b328c28fb",
      "event_cluster_id": "82d125aa-a1b8-43bf-bc35-e274642ade2d"
    },
    {
      "claim_cluster_id": "15187e94-76d4-4323-bc9d-67428e138efd",
      "event_cluster_id": "80704d80-8bb5-443e-80be-d547a70828af"
    },
    {
      "claim_cluster_id": "c153b607-ea7e-4a94-8f50-d29611d77fe7",
      "event_cluster_id": "96f47e0e-34da-4076-aa8a-d368df50bd46"
    },
    {
      "claim_cluster_id": "c2ba86a6-df2c-40b6-bf30-1269c5ac3702",
      "event_cluster_id": "bde83207-e05b-485e-9b86-431574e6c995"
    },
    {
      "claim_cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
      "event_cluster_id": "8c92c9ea-d03e-4ce1-b80a-21678d736eec"
    },
    {
      "claim_cluster_id": "d7524d60-e45b-419a-8a13-87cf67bfd8e5",
      "event_cluster_id": "d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"
    },
    {
      "claim_cluster_id": "34d9abee-6356-4941-91bd-4961dca2eec1",
      "event_cluster_id": "6289781a-230a-4b8d-94dc-f3adadc4495d"
    },
    {
      "claim_cluster_id": "99681bf5-4780-4832-b6fd-70acc37bfc27",
      "event_cluster_id": "18a83b13-1adf-4e6a-9783-cc45f9fd9c79"
    },
    {
      "claim_cluster_id": "8d98ef20-8cc0-4e51-b441-315a42837e56",
      "event_cluster_id": "938b5cdb-cc92-4431-8b11-03447ecda24f"
    },
    {
      "claim_cluster_id": "ebf0120f-ec3a-4a71-bd2b-88f212264387",
      "event_cluster_id": "28dd2f06-c107-43ce-af58-70e52ba1e785"
    },
    {
      "claim_cluster_id": "6ac8924b-24d0-446a-8ffc-cf862b415737",
      "event_cluster_id": "32a7ec8d-3be3-4c19-8ad9-bb022a0c0c96"
    },
    {
      "claim_cluster_id": "fa621ebf-8ee4-47c4-b584-f5012ff39561",
      "event_cluster_id": "e157316b-b52b-4e59-beec-7a600ea2ef49"
    },
    {
      "claim_cluster_id": "89cac161-a6f0-4315-a880-1662cae50313",
      "event_cluster_id": "90b17dac-ed93-4273-8df4-019652e30993"
    },
    {
      "claim_cluster_id": "12efff4b-e0b1-447e-aeb7-828004c5cfde",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "cd4aea0c-c90e-430b-95f8-4bff425c022e",
      "event_cluster_id": "3e87987a-c8cd-4616-922a-e297f103d0fa"
    },
    {
      "claim_cluster_id": "859c814e-e7af-4708-a58a-9f1f6973974f",
      "event_cluster_id": "cc7c4fde-e26b-4dc1-acbf-81128ce5d657"
    },
    {
      "claim_cluster_id": "24daffdf-e642-42fa-ac82-39c90e12f420",
      "event_cluster_id": "10cff142-fdb6-4cd5-b991-a870f41801d0"
    },
    {
      "claim_cluster_id": "48496823-a243-4e3b-bc74-d86ea0c9a269",
      "event_cluster_id": "928ae685-c0c3-436a-ae8d-5a22e9f5f9eb"
    },
    {
      "claim_cluster_id": "a8c4b29d-3d45-4e5e-b6ef-06f93957d16a",
      "event_cluster_id": "69c908c7-3fb6-49fa-b102-50233b107e27"
    },
    {
      "claim_cluster_id": "22fed294-324a-41e6-9f14-7b92ebc22681",
      "event_cluster_id": "0b2d3f06-c549-429d-9974-6e988853ab88"
    },
    {
      "claim_cluster_id": "4594a001-49cb-45b8-a26a-b07a8a886360",
      "event_cluster_id": "cf554d67-1528-4e54-be08-db5967f3793c"
    },
    {
      "claim_cluster_id": "7e245bdc-e727-4627-a96b-f1db937337df",
      "event_cluster_id": "94346dc4-a4ac-4e3c-85da-06445ad201ba"
    },
    {
      "claim_cluster_id": "8f5c67fb-16a9-42c0-8cf3-1bc2d8d1a576",
      "event_cluster_id": "b84f23af-bd15-4231-83c8-7e4cd068a5f9"
    },
    {
      "claim_cluster_id": "23bf4739-72bc-492b-9320-78f2bdc83074",
      "event_cluster_id": "94210717-ebb1-4a0a-897b-10e38931ad8b"
    },
    {
      "claim_cluster_id": "cd1cad7d-4c68-4a07-b4fd-c8e01c9f94cb",
      "event_cluster_id": "36e8c4e1-79bb-4ee5-81d8-1178da8ce862"
    },
    {
      "claim_cluster_id": "bc0539c0-9358-42cb-bbfb-8c0b934c5e86",
      "event_cluster_id": "2546e25b-7863-4f5c-b7d3-2a457e14f21b"
    },
    {
      "claim_cluster_id": "7325cc3b-df7f-4451-948f-1ce21f12d10f",
      "event_cluster_id": "f7dce48b-908d-410d-ae3b-0711d8dd8a49"
    },
    {
      "claim_cluster_id": "10f0700e-3ce2-47c7-8783-a4d08ef48748",
      "event_cluster_id": "a2d0ea3b-d935-4c42-8edc-70bff4ecb269"
    },
    {
      "claim_cluster_id": "7b76e5cb-748d-468e-9baa-d34773d5f24e",
      "event_cluster_id": "e83deec8-b564-42c6-8487-a1f4fc334b10"
    },
    {
      "claim_cluster_id": "5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9",
      "event_cluster_id": "82af2059-79b6-4403-9b30-9a9e111cc571"
    },
    {
      "claim_cluster_id": "170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c",
      "event_cluster_id": "c42951ed-4fef-4240-bea1-d37921f9209f"
    },
    {
      "claim_cluster_id": "baa116d7-3e4a-4d22-809b-fdab138f8d83",
      "event_cluster_id": "1356f60e-0cce-4f4c-95ff-047c73d507ce"
    },
    {
      "claim_cluster_id": "46a0b407-50f8-4cc9-968a-6955a0540862",
      "event_cluster_id": "f4766e96-74eb-4ff2-aa7a-ed465ba83cbe"
    },
    {
      "claim_cluster_id": "94e768ad-42fa-42f8-83fa-89a3705b92a2",
      "event_cluster_id": "b4d4265f-dae0-43eb-9010-fb5c59968803"
    },
    {
      "claim_cluster_id": "0634cfd7-f7f7-48cb-bb92-7dc813e3271c",
      "event_cluster_id": "72f778c7-a74a-4822-89c7-75defc5fed4a"
    },
    {
      "claim_cluster_id": "f09098cc-f345-415b-a2a8-3f7563f7b80d",
      "event_cluster_id": "ae643b18-4610-445d-bb91-7a6e08099006"
    },
    {
      "claim_cluster_id": "451cf0f3-38b6-4124-8f93-0e300d12c170",
      "event_cluster_id": "348d310b-39d2-427c-af87-143686fcd6a8"
    },
    {
      "claim_cluster_id": "ab9886f5-759f-416b-88de-b9f771cf04e1",
      "event_cluster_id": "a6e5fc0b-7c5e-4adc-9bd8-8c5b7afb7918"
    },
    {
      "claim_cluster_id": "5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9",
      "event_cluster_id": "e0696dc9-5406-4bfa-a327-9114afed84e2"
    },
    {
      "claim_cluster_id": "0543c671-bbcf-49ea-a462-e4ab061c75a0",
      "event_cluster_id": "b978e9a0-f48b-432c-b14c-50e4efff007d"
    },
    {
      "claim_cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "event_cluster_id": "05310a2e-9cf9-4ebe-9d39-aca58b7ee406"
    },
    {
      "claim_cluster_id": "7123d027-fb9c-44c1-becb-087b98c76740",
      "event_cluster_id": "441ea463-41a5-4f39-8e7b-380142bd84bd"
    },
    {
      "claim_cluster_id": "9be076b9-65b6-4c8e-b3d7-1df3c547c0fc",
      "event_cluster_id": "c8767af3-0dda-4a2b-8768-e0cf749cfa1c"
    },
    {
      "claim_cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
      "event_cluster_id": "ccdc4717-b37b-4b1b-94a7-20dfafa305fe"
    },
    {
      "claim_cluster_id": "be467aaa-b350-4a63-875e-7aa61c3d868a",
      "event_cluster_id": "1fb31a41-f917-4cde-9190-f353f630be9a"
    },
    {
      "claim_cluster_id": "6cf558a2-c2e5-4467-b5b0-ac3ede97ca96",
      "event_cluster_id": "c679edbc-b9a4-4c17-b40e-4029662513e4"
    },
    {
      "claim_cluster_id": "a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0",
      "event_cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993"
    },
    {
      "claim_cluster_id": "38a07431-3ca7-46f3-a1e7-a6118a43b742",
      "event_cluster_id": "90c72bc2-1d1a-4a98-9edb-8381a34e2935"
    },
    {
      "claim_cluster_id": "03915ee1-228c-408f-b93a-594ce2e45136",
      "event_cluster_id": "ee80f2ab-f1d2-4dfc-bb99-e00e767727e3"
    },
    {
      "claim_cluster_id": "0407f887-a8ce-4c09-bc8f-570e66bd3e6b",
      "event_cluster_id": "4f2d75d0-04f7-4815-a71c-1d8be3e7aa00"
    },
    {
      "claim_cluster_id": "7a1e52a1-bd32-491f-a249-5ec36a49aa78",
      "event_cluster_id": "8e541384-70e4-4c7e-9ac4-ec79ad71649e"
    },
    {
      "claim_cluster_id": "92a61686-4c12-431d-b205-279f1f28aaa9",
      "event_cluster_id": "4c8c98df-55ae-4fb5-ba8d-8d914fda29e6"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "7b4d9f3b-78aa-4507-8228-424f51cb5289",
      "event_cluster_id": "1622ce6e-697e-479a-95ba-4bfbcc9fd2c4"
    },
    {
      "claim_cluster_id": "9ee9fc47-27b6-4828-a30b-bd52c92ccfae",
      "event_cluster_id": "93f5bdee-4d35-454b-8f1b-0b318e24a68d"
    },
    {
      "claim_cluster_id": "6b22978f-c41a-4fd1-ac4e-29deafe60573",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "87e51e32-d441-41a9-8026-a751a57b0ed2",
      "event_cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87"
    },
    {
      "claim_cluster_id": "1405f96f-07a0-4454-a7cb-365f38772605",
      "event_cluster_id": "3765cbfd-a44a-49bf-b7ba-3bd606b4f80e"
    },
    {
      "claim_cluster_id": "68892c5a-f791-4608-9e40-b67a54dd50f2",
      "event_cluster_id": "d3045f09-979f-427c-94af-3cbb77214023"
    },
    {
      "claim_cluster_id": "6a708ce1-1b6e-4cbf-86c2-55ba9712b9d3",
      "event_cluster_id": "8430f01b-f34e-4798-8729-04aadd64268d"
    },
    {
      "claim_cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "event_cluster_id": "e4596864-8ee7-4544-832b-f1063fa0c90c"
    },
    {
      "claim_cluster_id": "21eacc7c-c9da-4edc-ac35-3ab550e3b7af",
      "event_cluster_id": "21b4b954-5140-43e2-bd9b-c8ab79b3e70c"
    },
    {
      "claim_cluster_id": "34d9abee-6356-4941-91bd-4961dca2eec1",
      "event_cluster_id": "f3affcd0-acdc-481e-ad0d-c22c5984f9af"
    },
    {
      "claim_cluster_id": "6a51ac21-708a-4a11-b82e-7b2b043d6c15",
      "event_cluster_id": "b4e49473-fad9-44d2-a14a-baa57498bb09"
    },
    {
      "claim_cluster_id": "58a7d973-9fa3-4047-a219-579a31c4561b",
      "event_cluster_id": "545232cb-5fc2-43ad-859e-11784f675852"
    },
    {
      "claim_cluster_id": "3356bac0-8ec4-475b-81a7-e146187a74ba",
      "event_cluster_id": "a63f5d9a-cff2-4275-97b2-48d300df1ba7"
    },
    {
      "claim_cluster_id": "e58c74de-137e-4144-8780-c4e86fcc480a",
      "event_cluster_id": "9add2c84-55b8-4f75-bec3-d9a47e379ce8"
    },
    {
      "claim_cluster_id": "9562ace0-b924-497a-a3ab-5d483c835c5a",
      "event_cluster_id": "a1ea139e-e9aa-4250-ae2b-ff5069df6f63"
    },
    {
      "claim_cluster_id": "b524cac0-fbe6-4818-abc9-cf0d17bfecf0",
      "event_cluster_id": "117f6cc5-ef88-4d83-9dfc-20f8e5fc488c"
    },
    {
      "claim_cluster_id": "428d818b-c2cf-41c7-bcd8-3f5cb0b144ef",
      "event_cluster_id": "fe94ed8f-3634-4c2e-acc1-318cbc76b2f2"
    },
    {
      "claim_cluster_id": "cdd48d7f-71ad-45d9-b5c0-d84849f26b67",
      "event_cluster_id": "baae4a32-5168-4c2e-a607-5bdb0996a9ff"
    },
    {
      "claim_cluster_id": "80abc80a-d540-4e4d-aa41-272690066eb0",
      "event_cluster_id": "8a4a4131-add5-4367-8ccd-215684fa73dc"
    },
    {
      "claim_cluster_id": "51ff5b38-5ae5-4505-adc2-291731599e68",
      "event_cluster_id": "e15d8f08-e424-41bc-9193-92e22c4d515c"
    },
    {
      "claim_cluster_id": "aaa5b32a-96ba-4450-b886-70f714b65bf2",
      "event_cluster_id": "f677d3a3-a108-4585-8030-41b82d49252c"
    },
    {
      "claim_cluster_id": "2f4a7179-3f3f-4eb6-8891-8b8d39467620",
      "event_cluster_id": "db2336a6-b759-4cc1-8b40-69f3eeb5bcf8"
    },
    {
      "claim_cluster_id": "1b7b6166-a006-43a7-8e66-beaeaf966eff",
      "event_cluster_id": "c11121a4-e475-45d6-a46f-861982c7538c"
    },
    {
      "claim_cluster_id": "fa621ebf-8ee4-47c4-b584-f5012ff39561",
      "event_cluster_id": "344f9518-32e9-438c-95bf-e7b75fd500b8"
    },
    {
      "claim_cluster_id": "a6d92a93-8990-407f-a2ca-8786c79330ee",
      "event_cluster_id": "beb95653-6e6e-44fe-9a2a-77a05c101fd4"
    },
    {
      "claim_cluster_id": "d3bded76-52fd-4f86-982f-558582eed404",
      "event_cluster_id": "ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"
    },
    {
      "claim_cluster_id": "b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4",
      "event_cluster_id": "119547c4-e528-4d80-bc2b-d8dc41ee62fe"
    },
    {
      "claim_cluster_id": "d7623a03-cd91-4c2e-b68a-db4e5ad54fa8",
      "event_cluster_id": "7c6d77d0-d878-49bf-a294-6d6456dfe66e"
    },
    {
      "claim_cluster_id": "c0707d1f-d796-4de7-994b-fd76b5d9d3dd",
      "event_cluster_id": "a8476578-a217-4709-ac69-6e4d18f25dc6"
    },
    {
      "claim_cluster_id": "daa86fb1-df31-4a23-a926-1b9981f8df40",
      "event_cluster_id": "5e9e2335-fc8c-44dd-9055-29d786472e4e"
    },
    {
      "claim_cluster_id": "02c9b472-905f-4c41-8570-811b8d821196",
      "event_cluster_id": "0f5915ad-4edd-49f6-8855-92a02e00debd"
    },
    {
      "claim_cluster_id": "81174c72-fc84-4203-8dcb-b1068c7bd254",
      "event_cluster_id": "a9574820-7af4-4109-8e6e-9d95f9ba6cbd"
    },
    {
      "claim_cluster_id": "76a80e87-389e-4e6e-9595-1b220839fd20",
      "event_cluster_id": "a11d2091-08fe-4a3c-ae90-66e1118f2ac4"
    },
    {
      "claim_cluster_id": "b98bb0fa-4594-47af-9069-f482aaa8d7c4",
      "event_cluster_id": "9611a4d5-e21a-4cd6-bbeb-709b60bd7dc1"
    },
    {
      "claim_cluster_id": "23bf4739-72bc-492b-9320-78f2bdc83074",
      "event_cluster_id": "b1ded912-0980-4dc6-8e8a-bb1ae1f015a9"
    },
    {
      "claim_cluster_id": "d7524d60-e45b-419a-8a13-87cf67bfd8e5",
      "event_cluster_id": "633de8a7-7506-44cf-9918-6f3f17934029"
    },
    {
      "claim_cluster_id": "83ec8695-6d93-432e-a8be-81705e2e2a54",
      "event_cluster_id": "2f690c44-ca18-4a31-a2b5-68ac60208360"
    },
    {
      "claim_cluster_id": "6768580d-67cd-4040-b98a-9d8276f6f0bd",
      "event_cluster_id": "e3021516-b122-4f63-8b18-ba2abaa0f893"
    },
    {
      "claim_cluster_id": "a4e781c0-f96b-465a-94d9-bc076c57b2b1",
      "event_cluster_id": "e9e5cd65-c720-48d1-aff5-59d128103cd2"
    },
    {
      "claim_cluster_id": "b471f42f-4da7-4b5a-a11e-18deef221da8",
      "event_cluster_id": "67de48d7-3fc7-4d88-97a8-9350772b5bc5"
    },
    {
      "claim_cluster_id": "984134b7-51eb-489d-965e-a939f985e06f",
      "event_cluster_id": "f9711d2c-1b60-4175-97f9-55453cace8aa"
    },
    {
      "claim_cluster_id": "7966aa4e-476b-473f-85ad-b267835811ed",
      "event_cluster_id": "2ba645ab-6f15-47c5-96d6-7989f0a29459"
    },
    {
      "claim_cluster_id": "9560d5ee-30e3-4941-88b8-e0b5144961cb",
      "event_cluster_id": "edbf77d5-b06d-4cb6-b6cf-9834f2f63e4c"
    },
    {
      "claim_cluster_id": "44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b",
      "event_cluster_id": "9c4f129c-13a2-41c2-aa00-330c197b8780"
    },
    {
      "claim_cluster_id": "f6a4aea6-92b4-4a70-a984-2326df1ee39e",
      "event_cluster_id": "1337f10e-c559-4983-82e2-596f69e5c47a"
    },
    {
      "claim_cluster_id": "27f40e5e-f571-4385-aef9-fcc4114989bc",
      "event_cluster_id": "cac94e48-7ce8-4cff-8e2e-49f3f784f217"
    },
    {
      "claim_cluster_id": "40db941d-31ac-4f8f-a268-d60a6c9bd055",
      "event_cluster_id": "05f00def-a8b8-4cdc-94a6-9ead4bc629d3"
    },
    {
      "claim_cluster_id": "adfa00d7-81da-47be-a9ec-4b8dfb8ee34a",
      "event_cluster_id": "4b392fdd-fe83-44be-b489-81067bf20cc4"
    },
    {
      "claim_cluster_id": "5d4f6733-5fbd-48ce-8468-590ebda279c7",
      "event_cluster_id": "5a9d340b-259a-49d7-894d-4e9c6dec6a07"
    },
    {
      "claim_cluster_id": "7b49f746-2118-4c08-9ef0-985906af7b07",
      "event_cluster_id": "74a8058f-9617-4020-8db9-456c0bc2deb9"
    },
    {
      "claim_cluster_id": "17a4104c-d678-44ba-8ae9-fd050d042961",
      "event_cluster_id": "c057a22e-5c5b-4db2-8c44-1bbafad4ea91"
    },
    {
      "claim_cluster_id": "623ab1ae-1f19-46fc-b19b-929f64c7b525",
      "event_cluster_id": "73ac3211-808b-4905-b95e-ccdafdc4bd5d"
    },
    {
      "claim_cluster_id": "267d2942-984a-4564-b33c-69e9db79a066",
      "event_cluster_id": "bb78b3cf-3fee-4d7e-b532-1ccb52ef3013"
    },
    {
      "claim_cluster_id": "77de10dc-6dcd-4902-a9d2-f5cf9384d343",
      "event_cluster_id": "45b3db14-d0a0-477b-afcd-d5fc5dbd7f5e"
    },
    {
      "claim_cluster_id": "4acf918c-0778-4ee4-b773-26139df2ea2e",
      "event_cluster_id": "55de19a2-d0de-4a1f-86be-06d3fbb117dd"
    },
    {
      "claim_cluster_id": "03db723a-dcac-4e7f-b456-18c0fdfdba8d",
      "event_cluster_id": "e02d4ab5-a57f-4bc5-991d-c6ce2c7dfc93"
    },
    {
      "claim_cluster_id": "beba9a76-4058-465a-8f4e-bc79ccf7a03f",
      "event_cluster_id": "30a07eeb-43bd-4ffe-abd6-643a3e7fa413"
    },
    {
      "claim_cluster_id": "5b7e1f2c-86a3-4e27-9c3e-c974a8d33606",
      "event_cluster_id": "4f145c90-9c3b-47cb-b38a-e643a9aa6e27"
    },
    {
      "claim_cluster_id": "ae58d35c-53bd-40b8-b6d5-7fe4e15e229a",
      "event_cluster_id": "5a3adc2a-ea19-4c5d-b7f5-3df2a2a10371"
    },
    {
      "claim_cluster_id": "a98eba10-9612-466e-bbba-6161ced90ab9",
      "event_cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"
    },
    {
      "claim_cluster_id": "a1632082-229c-4e1d-b6b1-8334d7ed7db2",
      "event_cluster_id": "96772c7c-5021-4ae5-83ab-b845fd92f1f9"
    },
    {
      "claim_cluster_id": "cba79c22-94bf-4911-a28d-ebd794325eaa",
      "event_cluster_id": "367b0f1c-f101-4396-807a-065b17daa4e8"
    },
    {
      "claim_cluster_id": "a3463468-dce8-4063-85c5-ecdc64691fed",
      "event_cluster_id": "9e87fb61-486a-4192-90bf-f05ee1b73406"
    },
    {
      "claim_cluster_id": "644ce0a3-b992-4dbe-be7f-558277802f15",
      "event_cluster_id": "996e6c58-b099-4143-9641-865300e8a753"
    },
    {
      "claim_cluster_id": "0ea60366-ef97-44ac-91be-b38d55efb0c3",
      "event_cluster_id": "4b3edb14-747e-4c77-8e76-8b7c1d8c4155"
    },
    {
      "claim_cluster_id": "0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879",
      "event_cluster_id": "06f36d72-4a36-4a11-89bc-28713f0d3ba2"
    },
    {
      "claim_cluster_id": "dbd98860-9de1-4289-bb60-99171790c782",
      "event_cluster_id": "d62e9da4-a6f4-4493-99df-7aea8cb8b7d5"
    },
    {
      "claim_cluster_id": "d1c29947-a7e4-41cf-9656-837e51b2de11",
      "event_cluster_id": "7a48cda2-7a7d-48c6-9ef2-e5b111d87d7c"
    },
    {
      "claim_cluster_id": "c0e66b49-a2c1-49ba-be78-c28aff5c60cb",
      "event_cluster_id": "35b184f1-0b55-4cee-b0ea-dcbb0d7633eb"
    },
    {
      "claim_cluster_id": "80abc80a-d540-4e4d-aa41-272690066eb0",
      "event_cluster_id": "794a59da-1667-4f55-8bfb-64bab3fe6d1a"
    },
    {
      "claim_cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "86944fd0-c689-49c4-894c-bd247f4057bb",
      "event_cluster_id": "ac066abb-a95e-4ab2-884e-0a0fd4b40f30"
    },
    {
      "claim_cluster_id": "eb2e33e5-165b-4a02-aa96-d53bcd386da0",
      "event_cluster_id": "b6f98e35-378d-4bca-93ef-5b980f18f2b3"
    },
    {
      "claim_cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "event_cluster_id": "4b93a421-107c-4185-912b-a73d039895b4"
    },
    {
      "claim_cluster_id": "d089f75e-69ee-4713-8c0e-27843b110a2a",
      "event_cluster_id": "dd9ccaa5-025e-44c1-90b2-20d75d0c5291"
    },
    {
      "claim_cluster_id": "ef57a08c-bb40-48bb-8784-c240ed933462",
      "event_cluster_id": "dba5927e-43c7-4d0e-9ca1-e78a9cdb024a"
    },
    {
      "claim_cluster_id": "a1ac0514-0dd2-43ae-9f2d-5939e791e058",
      "event_cluster_id": "55be4945-34ca-4ac0-b3a5-86bcc22710f0"
    },
    {
      "claim_cluster_id": "91b0db25-32e4-4e5d-a32d-911732cbec28",
      "event_cluster_id": "82ddd264-29cd-4540-b05e-dff896b42eb8"
    },
    {
      "claim_cluster_id": "e935bf33-7d4f-4ee6-8636-94e91a064afd",
      "event_cluster_id": "3da59556-c8b1-408c-95c7-5d8130035b46"
    },
    {
      "claim_cluster_id": "3f043499-266e-455f-a558-699fac541c36",
      "event_cluster_id": "e014d650-8fca-4dde-a60f-f8576ce7542f"
    },
    {
      "claim_cluster_id": "63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7",
      "event_cluster_id": "2fef56aa-90d0-4ea0-9ef0-fc7608685f56"
    },
    {
      "claim_cluster_id": "e416c5ec-262b-4531-adef-7197fba310f0",
      "event_cluster_id": "6e4dcb8c-7c71-4fa3-82ef-3a917a168bdb"
    },
    {
      "claim_cluster_id": "98bac582-09cd-476d-9519-fe434dffcb9a",
      "event_cluster_id": "3ae04ca7-f447-4b2b-85af-7e1f6c9004e8"
    },
    {
      "claim_cluster_id": "31810a05-cebd-496b-bd75-5b647781b8ec",
      "event_cluster_id": "e6f515d5-9add-4fca-a2f4-3869c847ca29"
    },
    {
      "claim_cluster_id": "9ee9fc47-27b6-4828-a30b-bd52c92ccfae",
      "event_cluster_id": "814bcb42-2e0f-4cf8-87e3-c5b551e8ea66"
    },
    {
      "claim_cluster_id": "57eb29a4-6d1b-4f98-a507-b97e4235688c",
      "event_cluster_id": "ff03cd74-7869-49e2-a30a-40383add9c7d"
    },
    {
      "claim_cluster_id": "8bbb9fde-a60f-4687-9398-276e5d036952",
      "event_cluster_id": "fcb8985c-e271-4f8a-9ba5-ab287203d1d8"
    },
    {
      "claim_cluster_id": "ce07721b-5347-4d52-81aa-7a7c68338485",
      "event_cluster_id": "48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"
    },
    {
      "claim_cluster_id": "9860031c-3ecb-400d-a847-e88ace1049f2",
      "event_cluster_id": "87e137e4-5f92-4e98-b206-3abd53542c67"
    },
    {
      "claim_cluster_id": "7bf63345-7700-41f7-861e-b298dc68ad2d",
      "event_cluster_id": "c7b52427-87e3-4932-9690-1d3cb09c79b7"
    },
    {
      "claim_cluster_id": "9be076b9-65b6-4c8e-b3d7-1df3c547c0fc",
      "event_cluster_id": "6b396f8a-a67e-4844-8d5a-43bb95030766"
    },
    {
      "claim_cluster_id": "c6541e86-8e1b-4bd0-926a-c380aa103aa6",
      "event_cluster_id": "37fbb780-673c-455c-ae4f-c83136095160"
    },
    {
      "claim_cluster_id": "ee431334-0b63-4389-8c3c-60633233fd26",
      "event_cluster_id": "aefe0bc6-fe98-4828-a554-094ca6f377d1"
    },
    {
      "claim_cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
      "event_cluster_id": "04fe8e71-8c72-481f-a6cf-1722df9454dc"
    },
    {
      "claim_cluster_id": "b0c0fbc8-3a87-4290-a45f-69e062e04cee",
      "event_cluster_id": "c317865e-d1be-4abc-b1b5-dece44444a1b"
    },
    {
      "claim_cluster_id": "af26e832-f248-48e8-93f5-fdb54d01a56f",
      "event_cluster_id": "a57199f1-f704-4a31-b1b8-b56b52a4b405"
    },
    {
      "claim_cluster_id": "ed1fef35-ea22-4436-b53a-1dc1f0380298",
      "event_cluster_id": "dc760acb-b4e3-4975-bd26-80f29e06c63e"
    },
    {
      "claim_cluster_id": "f8755b86-ae98-461e-a3ac-2bd5b6ec4310",
      "event_cluster_id": "d1112bf6-9631-4abe-8c1e-925442961737"
    },
    {
      "claim_cluster_id": "8ef65ecd-3750-4a43-89ce-d81b333f2e1c",
      "event_cluster_id": "3f26edd9-fb3e-47fd-a185-0a5f3a6ec746"
    },
    {
      "claim_cluster_id": "1a807d7d-9b68-443c-ad9d-52b339476997",
      "event_cluster_id": "a65f122a-8e28-4204-bec6-e6c89e03bce2"
    },
    {
      "claim_cluster_id": "87a15594-c8d7-4860-a888-b2469a7e65b5",
      "event_cluster_id": "33f7acb6-a580-4b13-bf25-917d68f240ac"
    },
    {
      "claim_cluster_id": "c6c8d065-8cfe-4224-9bcc-58df52f1a712",
      "event_cluster_id": "4c2902bb-5892-4765-99b2-69db31b95136"
    },
    {
      "claim_cluster_id": "4770d222-ba7d-4bbe-8acd-294b0fe141f8",
      "event_cluster_id": "760f2c37-f953-4230-a4d7-e4bda98fc033"
    },
    {
      "claim_cluster_id": "5d276603-9c3a-417d-bd11-e8b613249dd5",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "2c2bd0f0-92f2-446c-bfc2-4cf2ec4f5ece",
      "event_cluster_id": "4e973d36-02eb-4b5c-bc20-63b35994dd87"
    },
    {
      "claim_cluster_id": "0aa10a76-1680-4566-9d3a-ebaa3e486aaa",
      "event_cluster_id": "d5a1e042-b187-41b4-a6ad-f1f271f98a66"
    },
    {
      "claim_cluster_id": "212176d0-9b06-497d-a8bf-0b53076513ff",
      "event_cluster_id": "b7b39062-4917-41f9-8b87-39a562d00b9c"
    },
    {
      "claim_cluster_id": "9e4983ab-c919-470b-9bac-8b6c4b633a1e",
      "event_cluster_id": "feb55b84-b173-4b70-b9c2-3b33225296b8"
    },
    {
      "claim_cluster_id": "10e97fc5-5fa6-457f-aefb-257e90e8124b",
      "event_cluster_id": "da81244a-ef78-429d-9f3d-b08a5c21a084"
    },
    {
      "claim_cluster_id": "1dd25bce-7fe6-46d2-9e28-e803262696c4",
      "event_cluster_id": "54567e29-4033-493e-869f-078ef9153910"
    },
    {
      "claim_cluster_id": "dec098ce-5baa-400b-a766-6543ab0afe00",
      "event_cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0"
    },
    {
      "claim_cluster_id": "5d276603-9c3a-417d-bd11-e8b613249dd5",
      "event_cluster_id": "979b7171-b50b-4784-a226-a93eb757dfb4"
    },
    {
      "claim_cluster_id": "a9b66749-8bb9-4643-bb36-488cbf77974b",
      "event_cluster_id": "92f1ca49-b0ab-4770-8539-01bf2c201c40"
    },
    {
      "claim_cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
      "event_cluster_id": "7bdd8e86-1a5c-4cda-a846-8ddfcadc8007"
    },
    {
      "claim_cluster_id": "83392417-156e-4467-96c4-b7a769a50f3f",
      "event_cluster_id": "bc727b98-bf68-42be-b2de-84ffed053ccd"
    },
    {
      "claim_cluster_id": "d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9",
      "event_cluster_id": "18ce2062-068b-4c99-b15d-32e24b28817f"
    },
    {
      "claim_cluster_id": "0b87672f-54fc-4c20-8d98-e54ab45bc52d",
      "event_cluster_id": "f3ff4daa-4e28-48b9-8086-b9beac549c23"
    },
    {
      "claim_cluster_id": "2790abdc-e882-4d8a-90ac-fbfc5b896052",
      "event_cluster_id": "22edb9f0-7d37-46a0-a499-0bf470746f3e"
    },
    {
      "claim_cluster_id": "46f91c43-019b-4419-b509-a0a1e806ff37",
      "event_cluster_id": "ab265737-e0ba-43dc-8147-c642f185978a"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "a63f5d9a-cff2-4275-97b2-48d300df1ba7"
    },
    {
      "claim_cluster_id": "7c9beeef-07c1-4872-bfac-86e8c63a87f9",
      "event_cluster_id": "34aab7b4-5379-4f38-9914-ae9a14a7914c"
    },
    {
      "claim_cluster_id": "cefbf586-5d05-477f-8675-6637fb8781a5",
      "event_cluster_id": "5cb65b5e-c51c-4fab-b738-dd41d64af22f"
    },
    {
      "claim_cluster_id": "26852476-f26f-4f97-92bf-7cc2d9373f4e",
      "event_cluster_id": "f1b5b82d-47e0-49c5-b861-5e41e68dc753"
    },
    {
      "claim_cluster_id": "acca2114-d8e0-468a-8116-8a8e6ac23e1b",
      "event_cluster_id": "800819aa-dd64-46d5-8bb3-ebc4802f59be"
    },
    {
      "claim_cluster_id": "a1ac0514-0dd2-43ae-9f2d-5939e791e058",
      "event_cluster_id": "fc32a20d-bd13-4dc2-a851-03b63c1e329e"
    },
    {
      "claim_cluster_id": "dcf5235c-74f7-409c-bb59-9454cc01feed",
      "event_cluster_id": "9964a330-c7c3-4cd3-bf33-0b48084f4337"
    },
    {
      "claim_cluster_id": "ab8de566-e0cc-475b-b056-6b27916b484d",
      "event_cluster_id": "d101520b-7082-47e3-b848-813e8165e6a9"
    },
    {
      "claim_cluster_id": "1b257e2e-69fd-4bc5-b57c-e7f5b2178161",
      "event_cluster_id": "512979c6-163f-4fe1-b34a-1c4e466e4650"
    },
    {
      "claim_cluster_id": "ade8c501-ccec-40ec-b096-cd50cd90be07",
      "event_cluster_id": "dd0a9eb8-6da6-4108-8f70-358d100bdfcb"
    },
    {
      "claim_cluster_id": "6a51ac21-708a-4a11-b82e-7b2b043d6c15",
      "event_cluster_id": "af9fdbaf-db80-451f-96bd-62636c3231f5"
    },
    {
      "claim_cluster_id": "71b86c5b-0ae0-46d5-a172-4da94679db3d",
      "event_cluster_id": "e4596864-8ee7-4544-832b-f1063fa0c90c"
    },
    {
      "claim_cluster_id": "7440fefd-f7fe-4402-9218-79fa9f53df91",
      "event_cluster_id": "1373b88b-91da-4b7d-bc67-e2f0449d0283"
    },
    {
      "claim_cluster_id": "e3548f8e-cc3f-4307-a48a-a45cdf828859",
      "event_cluster_id": "e17360aa-cb4e-4e41-913f-f3e853c44fd4"
    },
    {
      "claim_cluster_id": "24daffdf-e642-42fa-ac82-39c90e12f420",
      "event_cluster_id": "3dc78939-89e4-4b07-a3e0-cad83ab8d427"
    },
    {
      "claim_cluster_id": "a536505f-e31a-400e-a4a5-1f74a9e29e7d",
      "event_cluster_id": "0a9d0582-fd67-429b-b378-1ed79f7e66aa"
    },
    {
      "claim_cluster_id": "60b71403-253c-4f7c-b96e-fb2306a7cebf",
      "event_cluster_id": "b29164d7-a1d8-4a41-a952-b0d04cde6fa1"
    },
    {
      "claim_cluster_id": "8c2b4e21-c9ea-4127-9440-e983688f714d",
      "event_cluster_id": "1f539237-1caf-4525-9adc-af33bb645e44"
    },
    {
      "claim_cluster_id": "ab72f353-1b68-44ce-979f-a10883b99605",
      "event_cluster_id": "8995bbaa-d955-41cd-a920-b35b1fea2dc4"
    },
    {
      "claim_cluster_id": "4dbd9499-a86a-4c48-b218-1b0a93aa0331",
      "event_cluster_id": "24b0b407-5974-4623-9570-6a7574f03b45"
    },
    {
      "claim_cluster_id": "10bff7af-7766-4fc3-b86a-eaf53dd132e9",
      "event_cluster_id": "705d1ff1-cf3d-455b-8c22-31feaaeb943f"
    },
    {
      "claim_cluster_id": "53a5cd16-ea33-4c3e-8f8f-0d495c63c479",
      "event_cluster_id": "83f04811-c07b-4cf2-8679-7397fef07ebd"
    },
    {
      "claim_cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
      "event_cluster_id": "86cdbb00-bf89-4bf4-b9b5-585743288546"
    },
    {
      "claim_cluster_id": "8f97c05e-5860-4be0-8343-dc2050850d4f",
      "event_cluster_id": "4f34a5b6-00cc-43cb-98d1-c250e5f2b08b"
    },
    {
      "claim_cluster_id": "7faff4ee-fc9e-4ba2-8e8e-36906d88936d",
      "event_cluster_id": "35eea677-5b27-4587-9764-95116cb6b83e"
    },
    {
      "claim_cluster_id": "89a7a448-be37-40e3-973f-79b15dac979d",
      "event_cluster_id": "4194b8ef-5709-47af-9e86-ee10aeeb4788"
    },
    {
      "claim_cluster_id": "3a774e33-2c16-4d7b-91f8-38103798acd4",
      "event_cluster_id": "7da5e969-ac3d-4ab8-86be-3712be90baa2"
    },
    {
      "claim_cluster_id": "d8515ae8-12a5-4f84-b01f-bc10b41b19e0",
      "event_cluster_id": "25f3e976-9943-4b37-b0c9-b84c0952ccb4"
    },
    {
      "claim_cluster_id": "a38268fe-ba89-4d63-8481-63c080523a0a",
      "event_cluster_id": "f81575fe-bf60-4052-8196-fa9040141b06"
    },
    {
      "claim_cluster_id": "e9caf6d9-2282-4c7e-9cd5-97529119edff",
      "event_cluster_id": "d211ea4f-25c6-49b0-b039-be55cbe6e301"
    },
    {
      "claim_cluster_id": "f46bebef-6c63-4778-a5c7-e0d7b893e969",
      "event_cluster_id": "0b109e58-1cde-4c32-aed4-12ba82ed273a"
    },
    {
      "claim_cluster_id": "6832730a-f3c3-49e8-8c1f-45ff7dac590c",
      "event_cluster_id": "a9c08567-c779-4007-8ddb-2cc8e3429124"
    },
    {
      "claim_cluster_id": "5d950548-da48-42e1-b748-275abdd34cfd",
      "event_cluster_id": "a4d6044a-4bd0-435c-beb3-a719ddfd1f0d"
    },
    {
      "claim_cluster_id": "b9ef5935-c3ff-439a-95ae-5e53367b92ef",
      "event_cluster_id": "4236f047-bfc1-46a9-8b89-2b002fe42dc4"
    },
    {
      "claim_cluster_id": "97b87ffd-da0c-47fa-86ae-0eedf718bf3e",
      "event_cluster_id": "22c9858e-9aba-4253-8fc8-8d1d83a938f3"
    },
    {
      "claim_cluster_id": "186330e2-1680-455d-ad21-27f2e0125a31",
      "event_cluster_id": "cc24e5f4-c0b5-4176-a975-3eb0a8f8713d"
    },
    {
      "claim_cluster_id": "dea6592f-a2fb-4ea8-b832-4f7df984c163",
      "event_cluster_id": "9c0a11fb-cf7e-4f2f-b318-57e8160591d2"
    },
    {
      "claim_cluster_id": "dec098ce-5baa-400b-a766-6543ab0afe00",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "b3413e76-c570-4047-aa2b-63946d5b2c25",
      "event_cluster_id": "0e8cc365-638d-4d52-88e5-ee27a8dddfb2"
    },
    {
      "claim_cluster_id": "60b71403-253c-4f7c-b96e-fb2306a7cebf",
      "event_cluster_id": "079ea0ae-5460-44fd-be95-17fec28e2122"
    },
    {
      "claim_cluster_id": "68892c5a-f791-4608-9e40-b67a54dd50f2",
      "event_cluster_id": "1e486a72-4d21-463d-8ec1-dd36ab1fc529"
    },
    {
      "claim_cluster_id": "4c86e2de-bdfc-40e3-b87c-fafaa9d03c41",
      "event_cluster_id": "3d2e56c3-c257-4788-ac2d-72890e521046"
    },
    {
      "claim_cluster_id": "2951f722-7d9f-4f1b-b69b-0dfe73efebd5",
      "event_cluster_id": "a6f24255-af0b-46ae-a654-0f9f9280b4f0"
    },
    {
      "claim_cluster_id": "48496823-a243-4e3b-bc74-d86ea0c9a269",
      "event_cluster_id": "df7272f7-c990-4a72-9f74-cce4b2e6b4b9"
    },
    {
      "claim_cluster_id": "64a10d09-a49c-4bf3-80db-a2cb3188afbc",
      "event_cluster_id": "c4a711fd-1857-4f2e-beaa-2df948c3bf31"
    },
    {
      "claim_cluster_id": "0950755f-651f-455e-a7d5-47091afd7de2",
      "event_cluster_id": "5d815b32-3a62-41d7-bd5e-64e320d9507a"
    },
    {
      "claim_cluster_id": "04fa98cf-7cbb-4ec9-b84f-6d1c0570075e",
      "event_cluster_id": "0ebe4f88-dbfe-4a7c-a8eb-80bb48625a38"
    },
    {
      "claim_cluster_id": "da745b4f-4158-4c1c-b2f1-ec13252863b3",
      "event_cluster_id": "9da2ed03-3aa6-4daf-9488-c042585d10b9"
    },
    {
      "claim_cluster_id": "afdf0794-a58d-44cd-b1d0-aec7b0adc12c",
      "event_cluster_id": "e20487a3-4fd3-48eb-b5a7-8bf0da331808"
    },
    {
      "claim_cluster_id": "995a6788-c0da-4f2f-a729-9d6b9bf65efc",
      "event_cluster_id": "dd4670c3-7e44-4c76-a7d9-373ad6cb6c50"
    },
    {
      "claim_cluster_id": "d9f5972a-ff26-4242-938a-7c9615591c15",
      "event_cluster_id": "6f5e39d0-2941-42e5-be3f-779525a745b7"
    },
    {
      "claim_cluster_id": "10bff7af-7766-4fc3-b86a-eaf53dd132e9",
      "event_cluster_id": "db3b032b-6eb1-469a-8fea-f26d907c46cc"
    },
    {
      "claim_cluster_id": "baa116d7-3e4a-4d22-809b-fdab138f8d83",
      "event_cluster_id": "fc95bbfe-5cb2-4a6b-a350-70ab1f4da4bc"
    },
    {
      "claim_cluster_id": "9352b2a0-83e7-4ffa-ae39-61c24aa700b8",
      "event_cluster_id": "3cd5d7a9-3268-400e-a49f-8e37d420e392"
    },
    {
      "claim_cluster_id": "b693d408-b0fd-49d2-8eea-39016ff5fda7",
      "event_cluster_id": "cfcddae8-7e4d-4fb6-8a06-45fdad19422f"
    },
    {
      "claim_cluster_id": "a9555cd5-7b65-4e84-9f89-ed03117c7e50",
      "event_cluster_id": "5d300e72-624c-4bf7-b8e9-c1b1c8bb5c1b"
    },
    {
      "claim_cluster_id": "35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60",
      "event_cluster_id": "4305150f-f7f1-49f6-a09c-d2c5973a5934"
    },
    {
      "claim_cluster_id": "a5a6c59f-7670-4f97-9c2b-c94700d73131",
      "event_cluster_id": "f1fc4cb5-63a2-420e-a804-9502b1ff9992"
    },
    {
      "claim_cluster_id": "59078c61-208b-49cd-9d25-3d6a843d0590",
      "event_cluster_id": "d4e4377a-959a-445e-9e4e-9d1461ec884e"
    },
    {
      "claim_cluster_id": "b9198f54-dcf7-43b1-9ba8-28ae1ef79e83",
      "event_cluster_id": "86cb3ea2-a54e-4579-b9f8-fb1dc6c8c598"
    },
    {
      "claim_cluster_id": "fd11e091-21e1-40df-916b-90aba2945065",
      "event_cluster_id": "921fce8d-f4e2-4dbe-b940-66b148c09f17"
    },
    {
      "claim_cluster_id": "4d988f33-ad00-4f89-acf1-b7ec63af7351",
      "event_cluster_id": "6e8f5bec-2ba5-40f0-a873-4607c411beb7"
    },
    {
      "claim_cluster_id": "ab378ec8-ca7a-473f-b276-44d546196e26",
      "event_cluster_id": "3f77000e-b7d1-457b-963f-2743a0bda688"
    },
    {
      "claim_cluster_id": "18413d30-3282-4a19-9301-8b0c9a57c941",
      "event_cluster_id": "bf8826dc-7456-4789-a5d3-9f4e1ba1b8de"
    },
    {
      "claim_cluster_id": "d8483e15-c78b-44e2-8070-c109cff73a66",
      "event_cluster_id": "5e19ce7f-9db8-4e0b-8a22-b9bd4624ed1e"
    },
    {
      "claim_cluster_id": "5da699cc-92ad-44e6-a24b-61100072b99f",
      "event_cluster_id": "9e93a133-57d5-49fc-821c-7ad0cab51a96"
    },
    {
      "claim_cluster_id": "886176d6-1057-4021-8312-570a3e3f4e10",
      "event_cluster_id": "d9b500c1-45df-46d2-84a9-276291e99b35"
    },
    {
      "claim_cluster_id": "3d647896-bc7f-4815-a99e-768cb2498250",
      "event_cluster_id": "90d35003-13f9-4cd3-a3c1-b7524ac5bf16"
    },
    {
      "claim_cluster_id": "7ebece62-a589-49b3-b28f-b8f565ab7327",
      "event_cluster_id": "4a1c13c8-b1bc-47b6-9e32-b9200ffdf048"
    },
    {
      "claim_cluster_id": "338d5a8d-64c7-4bed-a37e-208196096015",
      "event_cluster_id": "0f5915ad-4edd-49f6-8855-92a02e00debd"
    },
    {
      "claim_cluster_id": "e3141392-e630-428b-ae45-6d5589bf7443",
      "event_cluster_id": "ebf11375-1fd2-4e33-a82e-1889d6d8f85a"
    },
    {
      "claim_cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "event_cluster_id": "e46f2bcf-e185-4401-89f0-e7da4fcba567"
    },
    {
      "claim_cluster_id": "4acf918c-0778-4ee4-b773-26139df2ea2e",
      "event_cluster_id": "9b47f058-2394-458a-97b4-e9b218a76e1d"
    },
    {
      "claim_cluster_id": "284e7f1a-ee5c-4c83-986e-6b13c6c2e6b5",
      "event_cluster_id": "a8c2e9f8-294b-4cdb-94e4-c3571edcab24"
    },
    {
      "claim_cluster_id": "c18b334a-f61f-4400-b355-cea2e7375866",
      "event_cluster_id": "580850a7-5c15-4040-b450-cddffd7f1f89"
    },
    {
      "claim_cluster_id": "7bf63345-7700-41f7-861e-b298dc68ad2d",
      "event_cluster_id": "4f8224c3-991e-41ac-a885-d9b58bba5d47"
    },
    {
      "claim_cluster_id": "400218af-6cc1-4f06-8e3d-7804bde6ad17",
      "event_cluster_id": "d6d62bcd-4470-422b-bfb3-13d5db2da751"
    },
    {
      "claim_cluster_id": "4157a1dd-b3d1-4769-8ef9-bd2189b4146b",
      "event_cluster_id": "fce3f86a-8cbe-4d55-ab8f-cc8fde0d8d33"
    },
    {
      "claim_cluster_id": "574866ae-31fe-4cc6-8d31-fe21c9fdd682",
      "event_cluster_id": "82ce4ef2-05ed-42ad-830b-f78ec5322a5a"
    },
    {
      "claim_cluster_id": "b7768432-bcaf-4a4c-9bb2-1a6e02c6a003",
      "event_cluster_id": "2f4e138b-a8ca-4c68-be26-24de0c3b0489"
    },
    {
      "claim_cluster_id": "6288e205-b9e8-41be-a3f8-80b06b50c037",
      "event_cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810"
    },
    {
      "claim_cluster_id": "2706ec99-75d3-433d-ab95-f5c524eb1832",
      "event_cluster_id": "700f4caf-4655-44d6-adcf-68f6a654752b"
    },
    {
      "claim_cluster_id": "9d6e8c23-1cba-47c9-9f43-333717df0abc",
      "event_cluster_id": "30f48da9-bf4c-41d0-ae36-a76653721604"
    },
    {
      "claim_cluster_id": "d9f4e411-98bf-48bc-a372-2ef5b6cd17d9",
      "event_cluster_id": "505d0868-59a0-4692-bf8c-7c412af4f91a"
    },
    {
      "claim_cluster_id": "55c660bf-50f6-447e-81a1-ddecdab998ee",
      "event_cluster_id": "6274d1ce-c7d6-4cef-9ec4-e52018d2a528"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "4b93a421-107c-4185-912b-a73d039895b4"
    },
    {
      "claim_cluster_id": "9b129e4b-0540-473c-90ae-ff21e622eb3c",
      "event_cluster_id": "e1d7b348-32fa-40c2-a6a1-5325b5923ab6"
    },
    {
      "claim_cluster_id": "76e2cae3-f195-4448-9b25-588665927aca",
      "event_cluster_id": "31add754-e383-4634-98fa-f95a97ec4597"
    },
    {
      "claim_cluster_id": "066ea292-674c-44ee-8c3c-799b0ecf024c",
      "event_cluster_id": "5d2d76b5-bc12-46bb-8cc2-844165ffb7e7"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "7370dfbb-74ea-4d34-82b7-9398b71ecd5a"
    },
    {
      "claim_cluster_id": "c4bd1c97-a831-4763-9c03-6a3cf69f7caa",
      "event_cluster_id": "990108fa-17d4-4b4c-865d-d0668a8a4d9a"
    },
    {
      "claim_cluster_id": "91ed355a-9103-4819-9a78-2425f91b042a",
      "event_cluster_id": "41aaee2b-0ddb-4eee-87a5-d0d95635a46f"
    },
    {
      "claim_cluster_id": "7b49f746-2118-4c08-9ef0-985906af7b07",
      "event_cluster_id": "89a9391f-b100-4030-bab0-22344532ac00"
    },
    {
      "claim_cluster_id": "098acc21-62ca-42b4-8206-4df179ae28c3",
      "event_cluster_id": "b3b9380c-37e2-402a-8ec8-0e1aeaee4ebd"
    },
    {
      "claim_cluster_id": "8143472f-9ddf-4467-8402-c46a70ccaf1e",
      "event_cluster_id": "dbf82ccc-f0d2-4cf1-bdc7-044687b587cf"
    },
    {
      "claim_cluster_id": "affa89a3-9b82-426c-9616-b589325af10c",
      "event_cluster_id": "72242d20-ab02-471e-ba74-fd7caad2c382"
    },
    {
      "claim_cluster_id": "f679dcc1-fbec-4813-8cbd-bf97a313606d",
      "event_cluster_id": "d3157e1e-5fca-47d3-93bf-fb77fbc5070d"
    },
    {
      "claim_cluster_id": "93eceb5b-454d-4e3d-b632-57c5588aea34",
      "event_cluster_id": "14b70932-c015-4ead-b1a7-d8a04640aacd"
    },
    {
      "claim_cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "c474ebeb-fd96-4c94-8aa4-35666d0af3d1",
      "event_cluster_id": "8a0a3a15-f4ec-4089-82e3-0da6ba69f921"
    },
    {
      "claim_cluster_id": "e2f88c16-103f-497d-a88a-e63349d63a62",
      "event_cluster_id": "4061c2fc-ed9c-4f22-92dd-291aa2df6a90"
    },
    {
      "claim_cluster_id": "453d17a8-fa49-49dd-82fd-7c3661e026b6",
      "event_cluster_id": "44b69b95-01cd-47b4-9aae-cbe7e39103ab"
    },
    {
      "claim_cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
      "event_cluster_id": "e440fb1d-afb5-4fce-9f0b-110db0f93b32"
    },
    {
      "claim_cluster_id": "5288ae46-832e-4436-95ed-05106d5e8d73",
      "event_cluster_id": "228f2026-3094-45be-9c29-b363d30f00b6"
    },
    {
      "claim_cluster_id": "a24c9e44-7dfe-4825-ab38-82d2ff8a84cc",
      "event_cluster_id": "28a15364-02e7-4073-a1fc-8cee3087565d"
    },
    {
      "claim_cluster_id": "94e768ad-42fa-42f8-83fa-89a3705b92a2",
      "event_cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"
    },
    {
      "claim_cluster_id": "f10a7215-4011-4959-9b86-e9f3848b78fb",
      "event_cluster_id": "b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb"
    },
    {
      "claim_cluster_id": "eb7fddda-fe98-408c-a2d5-471f6b5aac76",
      "event_cluster_id": "95532b75-d1c7-4667-9939-ac7ea0f83b09"
    },
    {
      "claim_cluster_id": "0950755f-651f-455e-a7d5-47091afd7de2",
      "event_cluster_id": "00d7befc-64bd-4735-b672-5969c77fe7d6"
    },
    {
      "claim_cluster_id": "2f3c2293-d820-4cb3-836f-6df8faee07a8",
      "event_cluster_id": "f9c1e4b6-836b-439a-971b-99d6ec437f1d"
    },
    {
      "claim_cluster_id": "adcb219f-1d0a-4b1b-924d-ded66e2d2c1c",
      "event_cluster_id": "652f545a-2cde-41d4-9382-f23ab9d1b406"
    },
    {
      "claim_cluster_id": "101b3e01-9e80-483b-82e6-39667fb77d18",
      "event_cluster_id": "84d8eefe-324c-44a5-b6d1-c374c46cc323"
    },
    {
      "claim_cluster_id": "a8c4b29d-3d45-4e5e-b6ef-06f93957d16a",
      "event_cluster_id": "c9d1dced-4dd7-4c70-87e5-a257d37a3ec7"
    },
    {
      "claim_cluster_id": "0a27f80b-b648-4764-8688-fd889dc32a39",
      "event_cluster_id": "9651dd4d-7b1c-4486-aece-757b68331a49"
    },
    {
      "claim_cluster_id": "6b12e24b-6d9d-4b0e-a169-260972b9ab69",
      "event_cluster_id": "57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"
    },
    {
      "claim_cluster_id": "a84f79d2-3818-45bb-9cd9-eb739e78bee2",
      "event_cluster_id": "b8f80339-9419-4259-b0c6-1e550ab9ab7c"
    },
    {
      "claim_cluster_id": "f92684c8-da9a-477a-ba9a-9eb41a6f9f90",
      "event_cluster_id": "76bfb6cb-c00e-452f-b533-a19a6ee05a39"
    },
    {
      "claim_cluster_id": "71f12e75-d3eb-42eb-93dd-fc62f2343321",
      "event_cluster_id": "ebf11375-1fd2-4e33-a82e-1889d6d8f85a"
    },
    {
      "claim_cluster_id": "20c941a8-b922-48e3-8e56-e49e1a524fd9",
      "event_cluster_id": "c160d7d3-0687-4ba7-86ad-32e9cddeaf56"
    },
    {
      "claim_cluster_id": "a7043201-daf7-4ddc-86e1-fe3a850942e2",
      "event_cluster_id": "e2b19af5-6b63-47c0-a565-18520484a0a6"
    },
    {
      "claim_cluster_id": "6f7b1c88-304f-4cf4-ba94-d6268fa5ae40",
      "event_cluster_id": "77f3be19-2659-460f-978e-d15cb9d38644"
    },
    {
      "claim_cluster_id": "4370b159-681b-41a0-8da8-22c407b09da9",
      "event_cluster_id": "b627252e-5ed6-4562-833d-dbc3b3ef2c2f"
    },
    {
      "claim_cluster_id": "980136c6-363f-4cda-bc50-cca417518993",
      "event_cluster_id": "f5a99e33-6c8e-438b-9a1b-7d2b95dadd27"
    },
    {
      "claim_cluster_id": "cdb08998-bbe0-4530-9534-7744fb962961",
      "event_cluster_id": "60bb0c9e-70a1-4ee7-b0be-a6fdab4ba548"
    },
    {
      "claim_cluster_id": "6c947694-8652-4e58-b4d1-40be43d3a77b",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "5b34f4e8-867e-44ea-b5c2-c5295a09dd5e",
      "event_cluster_id": "7a09649a-0d1c-4211-a9ef-65dbb223fc3d"
    },
    {
      "claim_cluster_id": "19b19cf8-a65c-454e-84bf-36d3044b6f73",
      "event_cluster_id": "bff86a30-1fbf-4d67-9ee5-a1b9649be76d"
    },
    {
      "claim_cluster_id": "5288ae46-832e-4436-95ed-05106d5e8d73",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "8499f04a-3cd9-4588-b8dd-3abc1c538bcf",
      "event_cluster_id": "72f48981-b5f2-4358-be23-5c1438e13df0"
    },
    {
      "claim_cluster_id": "dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e",
      "event_cluster_id": "7c8877ae-f397-490e-9778-67a6e91ebe1c"
    },
    {
      "claim_cluster_id": "5d21e7b3-dd0e-453e-8871-eb57102f00e7",
      "event_cluster_id": "f1fd6338-9958-4c6d-8d13-636315f421f2"
    },
    {
      "claim_cluster_id": "29780617-dcdc-405a-a7d2-26d05fd8f9d4",
      "event_cluster_id": "d5f8926c-cfe4-4355-8a20-781d575d7616"
    },
    {
      "claim_cluster_id": "05638bd6-42ef-4049-b6f6-4a5478e7b8a5",
      "event_cluster_id": "ebf6d20f-e452-48e5-b5e3-66d4779751ef"
    },
    {
      "claim_cluster_id": "c55d7e50-ed13-4f98-a396-412d6e19decf",
      "event_cluster_id": "009b82df-6fc2-417b-9cb7-3440f511ecfe"
    },
    {
      "claim_cluster_id": "009e9d6b-ab96-416d-b96e-b7eaada086cf",
      "event_cluster_id": "2cf7e8e6-c492-424f-8353-8feea83e3711"
    },
    {
      "claim_cluster_id": "5b79e5f7-f49f-4b4e-b9a7-5554797ebbeb",
      "event_cluster_id": "a4b1d7b9-3c74-43c7-9743-4531782b8384"
    },
    {
      "claim_cluster_id": "b34ea819-97f6-4215-92c0-351b2f770110",
      "event_cluster_id": "9555579e-0753-4a7b-be6a-da884e2c8547"
    },
    {
      "claim_cluster_id": "5284ded1-5c85-415c-af66-ad36ef47b3e7",
      "event_cluster_id": "d4f9c49d-3b78-4035-b051-f58469f25ba7"
    },
    {
      "claim_cluster_id": "88a5288e-7f93-4e9a-8960-db23a08024fc",
      "event_cluster_id": "b20e50fd-ac66-49b1-9139-e41a882a2619"
    },
    {
      "claim_cluster_id": "33c9ef05-1d84-4ad3-be17-1fea5c70facc",
      "event_cluster_id": "ae8ea636-d211-440a-9860-24ae4efc00ff"
    },
    {
      "claim_cluster_id": "8f07bc53-1683-4b3a-b1de-2e1c15c0e13c",
      "event_cluster_id": "1352067a-0981-4dfc-bf7b-193db2160af5"
    },
    {
      "claim_cluster_id": "3c0cf1f8-c44a-4a0b-9f9b-6b44ff81b740",
      "event_cluster_id": "b0b9c7b4-b931-48a5-9e3c-e3d43990149f"
    },
    {
      "claim_cluster_id": "68152d77-1b3b-45af-8c06-88cf78f6a175",
      "event_cluster_id": "777a09d6-6401-47e3-a2d4-ee63f89442c3"
    },
    {
      "claim_cluster_id": "3543d3e3-081b-448e-9ec9-915bf37d6255",
      "event_cluster_id": "af198123-e2b2-48b2-baf8-af5aa8446190"
    },
    {
      "claim_cluster_id": "9cc8f400-4462-4501-9bf3-f6cf35f7a110",
      "event_cluster_id": "dba7c6a5-c30c-4cba-8cd3-01cb02220cb4"
    },
    {
      "claim_cluster_id": "8ae88722-b8db-4d5b-b13e-130f65630e05",
      "event_cluster_id": "54622f56-5371-48ad-b7b0-c52dd54c9e1b"
    },
    {
      "claim_cluster_id": "4e78b61e-317a-4417-b42d-464646384193",
      "event_cluster_id": "402b3ff3-63dd-42e9-9d2c-888f81934ca4"
    },
    {
      "claim_cluster_id": "0acd3055-185c-4d22-ad5f-a587ee5adc40",
      "event_cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5"
    },
    {
      "claim_cluster_id": "af26e832-f248-48e8-93f5-fdb54d01a56f",
      "event_cluster_id": "2af31319-c3b3-4fb2-ab4d-68df1d72b458"
    },
    {
      "claim_cluster_id": "9cf07839-b78b-4d19-aeee-e70ec12a23d1",
      "event_cluster_id": "e63bcf8f-4e49-4048-bed7-415583eadc3f"
    },
    {
      "claim_cluster_id": "c5855521-5ebf-478e-a7af-b3f07554a912",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "cdb08998-bbe0-4530-9534-7744fb962961",
      "event_cluster_id": "f6b81252-d691-43eb-b603-bbd2ec2ea3c1"
    },
    {
      "claim_cluster_id": "21361eee-5fe8-48f0-a512-8a8c4752daae",
      "event_cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"
    },
    {
      "claim_cluster_id": "199eabc9-e7b3-44cb-a574-bbc02ea956e5",
      "event_cluster_id": "a10aa5dd-2106-4783-8254-02da84449919"
    },
    {
      "claim_cluster_id": "da1326c3-fa76-400d-b44c-881f6493a085",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "71f12e75-d3eb-42eb-93dd-fc62f2343321",
      "event_cluster_id": "9eb9a341-e59f-4fbf-b178-ccb6bb25eb49"
    },
    {
      "claim_cluster_id": "916339bd-3e65-4fc3-be04-12020f45e716",
      "event_cluster_id": "36f9b8df-5b64-4298-b779-2814d4de3b9d"
    },
    {
      "claim_cluster_id": "59f595d5-6ff2-4686-81ce-6150bd29db9d",
      "event_cluster_id": "eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"
    },
    {
      "claim_cluster_id": "a162a552-43bd-43b6-925a-ac7f9fbf4734",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "da5651eb-e7b2-446c-9fdb-dc89d46a36a7",
      "event_cluster_id": "2dadee48-a44e-49fd-a481-3bd3ad498e90"
    },
    {
      "claim_cluster_id": "644ce0a3-b992-4dbe-be7f-558277802f15",
      "event_cluster_id": "7d49ce46-2d8e-42e4-a5d6-ea4a010fe5e5"
    },
    {
      "claim_cluster_id": "4e78b61e-317a-4417-b42d-464646384193",
      "event_cluster_id": "93fb31b6-e8df-4e78-9be7-574ea4c2f86b"
    },
    {
      "claim_cluster_id": "19581d0c-22b5-4ff0-8a68-de86fb01009c",
      "event_cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5"
    },
    {
      "claim_cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "event_cluster_id": "4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"
    },
    {
      "claim_cluster_id": "d8f02a31-c29f-429d-b5f0-720768af0f52",
      "event_cluster_id": "aa149821-edf1-47da-a3a7-3f82f411bb32"
    },
    {
      "claim_cluster_id": "b0c0fbc8-3a87-4290-a45f-69e062e04cee",
      "event_cluster_id": "78d5de97-f7ee-44e0-8fbc-dba1797c97c4"
    },
    {
      "claim_cluster_id": "1da96a0b-d833-4078-afdc-5a85d522b86d",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "4afb1f4b-4686-4338-bf49-bdd4d2091f0a",
      "event_cluster_id": "b8ea1565-defe-4a1d-a235-40a614cdd9ce"
    },
    {
      "claim_cluster_id": "c0057031-5868-445b-98d3-d536042f59f2",
      "event_cluster_id": "e2d48429-fbf6-47b6-9165-78445c0d3741"
    },
    {
      "claim_cluster_id": "17a14bb5-8594-4aa3-9c74-e077722ac66c",
      "event_cluster_id": "77f62262-b0e4-4158-9a7a-25a427bda979"
    },
    {
      "claim_cluster_id": "983e06bd-8aef-468f-888f-6f39b0353693",
      "event_cluster_id": "10b72ca8-fbc7-465b-bc23-1509272e1515"
    },
    {
      "claim_cluster_id": "f8121c44-24d3-465d-8607-2a909285d318",
      "event_cluster_id": "dbe1780e-f93d-4eae-8780-d2a73e00ae56"
    },
    {
      "claim_cluster_id": "93fddae5-a739-409c-a087-9a562d010a0e",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "a5a6c59f-7670-4f97-9c2b-c94700d73131",
      "event_cluster_id": "357e7a15-3b62-4e9d-ab34-f83d8c925763"
    },
    {
      "claim_cluster_id": "a34f85b1-92bb-47d3-b089-7365f6b9f51f",
      "event_cluster_id": "75154ca6-776f-46e4-8f4a-2221f93d7ff0"
    },
    {
      "claim_cluster_id": "39f6fc8d-27a2-4261-870e-362c0315c46f",
      "event_cluster_id": "eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"
    },
    {
      "claim_cluster_id": "d7524d60-e45b-419a-8a13-87cf67bfd8e5",
      "event_cluster_id": "e0e899a0-65d4-45b2-b3be-ff8320d1837a"
    },
    {
      "claim_cluster_id": "2a9019de-d820-4155-a78b-fc972ec57552",
      "event_cluster_id": "9164197b-fffd-43a5-9a7a-407af1a26959"
    },
    {
      "claim_cluster_id": "fcb57169-c911-45f8-98e1-10aa6c573c38",
      "event_cluster_id": "3f03bd41-3bd2-497e-a6ae-2bf64a55fb55"
    },
    {
      "claim_cluster_id": "d42f0707-162e-449e-86fe-0dd5e2885a21",
      "event_cluster_id": "e128e0c8-745a-4ce1-995d-c5a2ac809b5a"
    },
    {
      "claim_cluster_id": "481f70cc-e9a5-439c-8065-a4dc8e63bd0b",
      "event_cluster_id": "b5c5d896-8437-4aaa-ae03-95c8865a2ac0"
    },
    {
      "claim_cluster_id": "041cf2cd-18d4-495c-8ae7-5b69605020ea",
      "event_cluster_id": "21f0a219-a107-4e6e-aa28-e010ad5aec66"
    },
    {
      "claim_cluster_id": "6768580d-67cd-4040-b98a-9d8276f6f0bd",
      "event_cluster_id": "76bfb6cb-c00e-452f-b533-a19a6ee05a39"
    },
    {
      "claim_cluster_id": "40a361aa-d57e-4e3c-9740-34505f34913c",
      "event_cluster_id": "3062f8bf-848f-45a7-a46b-1596767052bb"
    },
    {
      "claim_cluster_id": "03915ee1-228c-408f-b93a-594ce2e45136",
      "event_cluster_id": "0ecf145f-a19c-4bc9-bccf-6b5ec58579be"
    },
    {
      "claim_cluster_id": "5d8dea5a-b22d-41be-9ea5-91141c9a7614",
      "event_cluster_id": "f2c360d4-d94d-4684-995c-edf2696b6aa4"
    },
    {
      "claim_cluster_id": "b213b3ba-db75-4c42-89bd-97de55c18b3e",
      "event_cluster_id": "27eeb806-4cb4-4391-b4c7-c7f87a7b6cc2"
    },
    {
      "claim_cluster_id": "ab24b6cb-fc70-48c9-8ee3-224b83a66b11",
      "event_cluster_id": "425c03b2-a548-4c2e-a981-8c6f7789018e"
    },
    {
      "claim_cluster_id": "6cf558a2-c2e5-4467-b5b0-ac3ede97ca96",
      "event_cluster_id": "7f0d4bc0-739c-4027-939f-98e2607340fa"
    },
    {
      "claim_cluster_id": "f4638fa7-3292-4d44-b3f1-771aa65146b0",
      "event_cluster_id": "d53538f2-6557-4a35-adbb-a2eefd4e49a8"
    },
    {
      "claim_cluster_id": "565acc40-efdc-4957-85fb-8602f0587aa9",
      "event_cluster_id": "92352325-85b6-4726-9aed-67119e9599f9"
    },
    {
      "claim_cluster_id": "f07cc872-d3c5-4a88-8201-4dce67c0d460",
      "event_cluster_id": "65fcd3e0-1f44-416d-b2cc-adb2b3a6c31b"
    },
    {
      "claim_cluster_id": "dfd9bb6d-a08b-428d-8e19-e9eebd219088",
      "event_cluster_id": "9dafd873-19fe-4111-b162-3c6894ed8aa4"
    },
    {
      "claim_cluster_id": "6c53a575-96c0-4b04-a196-adb1bbc90de7",
      "event_cluster_id": "48b40da6-72cb-45c4-8c2b-8924870132bb"
    },
    {
      "claim_cluster_id": "b3de51b2-92ca-4cb1-b45e-50a0188ca28f",
      "event_cluster_id": "f957765a-9482-4d2f-9d6a-a1c90e6281d6"
    },
    {
      "claim_cluster_id": "24f6a0c0-6612-4488-bc48-40d12340ab22",
      "event_cluster_id": "60d29486-ed0b-4997-a613-db65a447090a"
    },
    {
      "claim_cluster_id": "c298484d-a7d5-4e80-ac66-217221dc6d85",
      "event_cluster_id": "061483cd-3b7a-44e0-857c-a5c4129b4272"
    },
    {
      "claim_cluster_id": "0c685bcc-0513-4b5c-8ba7-c302c985ff66",
      "event_cluster_id": "48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"
    },
    {
      "claim_cluster_id": "98bac582-09cd-476d-9519-fe434dffcb9a",
      "event_cluster_id": "985e777f-c3e3-42f1-b650-98ac19e7f7b5"
    },
    {
      "claim_cluster_id": "b44cd59b-4971-4182-8766-9ffcf4ae83ce",
      "event_cluster_id": "6aece148-00ae-441a-a570-cbee981c2154"
    },
    {
      "claim_cluster_id": "0c6c9e5b-f8cc-4939-8319-4baf55259b87",
      "event_cluster_id": "16428f67-cf62-4386-a190-51cc23ca4b78"
    },
    {
      "claim_cluster_id": "9c99e4fa-6c0d-4aa9-bb98-86450c898d1b",
      "event_cluster_id": "f2c109a3-30b0-4718-85b7-78d12406aef5"
    },
    {
      "claim_cluster_id": "88b5488c-d8fa-4baf-af94-ea104e983a2a",
      "event_cluster_id": "29696d33-676a-411b-9f2f-5aad8a647ed0"
    },
    {
      "claim_cluster_id": "42c5367f-fb48-41ea-b66c-1b344a5b61cf",
      "event_cluster_id": "be927411-ac53-461c-bb59-5232d4963861"
    },
    {
      "claim_cluster_id": "78cbe3d8-37f7-4a89-956e-f6dab20ad8d1",
      "event_cluster_id": "815bc458-4e48-4001-99cf-32e4675d4871"
    },
    {
      "claim_cluster_id": "aa179085-85ff-43d4-ba04-8a3f88267ae8",
      "event_cluster_id": "2a6f5cd6-ea11-4cf4-9d3b-fd691e67f194"
    },
    {
      "claim_cluster_id": "fc0f4ff8-8147-4b0b-be66-dcae01810fe6",
      "event_cluster_id": "03d40e2c-2130-4e6f-94d8-afd7a1bdc223"
    },
    {
      "claim_cluster_id": "5881fb7d-2030-4406-a7ba-0a95befea17e",
      "event_cluster_id": "a3d2d431-d86a-4c7d-bd04-db410111f7fb"
    },
    {
      "claim_cluster_id": "93c53898-2dc6-423b-a4d6-b61dd90c6d6c",
      "event_cluster_id": "3d7847cc-aacf-44b1-8832-6089b6ace8d2"
    },
    {
      "claim_cluster_id": "f87de08e-1790-487e-a827-12378ebf4309",
      "event_cluster_id": "9e250f91-2983-4cf6-9b29-817f4271a911"
    },
    {
      "claim_cluster_id": "13fc2321-1fdf-40d3-8576-3d7e5eb9e53d",
      "event_cluster_id": "e9b589b6-86cb-4a37-aa98-5330f27ba5fb"
    },
    {
      "claim_cluster_id": "2e1084b1-c7f9-4543-8153-a6c840adb565",
      "event_cluster_id": "c9770c33-6591-4102-923f-7ca010384410"
    },
    {
      "claim_cluster_id": "91ed355a-9103-4819-9a78-2425f91b042a",
      "event_cluster_id": "9612bbf2-b65c-410c-9475-7ee689b849d9"
    },
    {
      "claim_cluster_id": "d7e9e6ed-b598-46a7-b7ea-6197df41d3ad",
      "event_cluster_id": "2d27e988-7b20-4d35-8415-461b2756da32"
    },
    {
      "claim_cluster_id": "2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37",
      "event_cluster_id": "41a86152-c66a-450d-8bf6-edd50f6928b1"
    },
    {
      "claim_cluster_id": "f34203f2-30b3-4686-b2f0-e124d8a67272",
      "event_cluster_id": "11d3cdd7-b203-4792-91e4-e32314bbcbc2"
    },
    {
      "claim_cluster_id": "0166ea62-85f0-412c-bd73-f3d7bc1bdf59",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "eee91c5f-8ac6-4779-af53-8a01aa4eaa03",
      "event_cluster_id": "3ed099b8-1d1d-4e40-a70d-caf7e4853619"
    },
    {
      "claim_cluster_id": "e1572e16-5f85-4ebb-a6fe-2ab18bee1c48",
      "event_cluster_id": "373b4029-0616-4e8c-84dd-67212ba62068"
    },
    {
      "claim_cluster_id": "7b49f746-2118-4c08-9ef0-985906af7b07",
      "event_cluster_id": "012b2764-4f2e-4783-9281-b3cc16d33a77"
    },
    {
      "claim_cluster_id": "2c9fc1d9-b4d4-4707-a2ac-1245937847ac",
      "event_cluster_id": "46c103db-5ea3-4b23-91e9-342a8a2c0506"
    },
    {
      "claim_cluster_id": "3be4473d-cbba-49ee-93e6-36d5bcd0dc0a",
      "event_cluster_id": "02b6e00f-ac14-433e-bf3b-9d12b116fbc4"
    },
    {
      "claim_cluster_id": "b686bd17-fb36-4b7b-9caf-084f8d91c149",
      "event_cluster_id": "a343f83f-a09c-4c76-ac05-045d273e90c8"
    },
    {
      "claim_cluster_id": "478db2a7-a90d-4fbf-8954-0416daa97dcb",
      "event_cluster_id": "fae21323-4e89-4f46-9b05-1eb8df8ce6f1"
    },
    {
      "claim_cluster_id": "03915ee1-228c-408f-b93a-594ce2e45136",
      "event_cluster_id": "e8299254-b0bc-4a3f-86b2-fedfa746efb0"
    },
    {
      "claim_cluster_id": "843bcba9-c863-41a3-a76f-01fd61d56529",
      "event_cluster_id": "ec7f8d90-641e-4755-b398-833e150c7057"
    },
    {
      "claim_cluster_id": "86d26636-5c9c-416b-94e0-e2a89a9628c3",
      "event_cluster_id": "bd8ae460-e56a-44c2-a9f6-3ae3b4d65792"
    },
    {
      "claim_cluster_id": "c91afcbe-198a-44cd-83c8-42c89811dab9",
      "event_cluster_id": "f5e1b739-645f-4391-b201-66a90f3725ef"
    },
    {
      "claim_cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "1eb307cf-2274-463b-9ab8-19aee3397703",
      "event_cluster_id": "640f326d-efe1-4293-bfc4-0c4c7b9185f3"
    },
    {
      "claim_cluster_id": "3e200fec-9dad-4a2e-a5e4-655848ec7983",
      "event_cluster_id": "2f4a9e86-aaa1-4911-a5a8-85e77f2e4012"
    },
    {
      "claim_cluster_id": "53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c",
      "event_cluster_id": "58cd02fb-21db-4abe-ae72-bb8a28bb5670"
    },
    {
      "claim_cluster_id": "58c4dc89-fa0e-45c9-8892-01fb55da5607",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "f15167ff-a614-4854-ae28-529950f00bdc",
      "event_cluster_id": "35df1ff6-45be-4230-aba5-19c41bc2020b"
    },
    {
      "claim_cluster_id": "b459615c-cbbe-438d-9dbf-cc3051ba017f",
      "event_cluster_id": "51ab1b42-afd5-4a90-95d0-c298f52dc502"
    },
    {
      "claim_cluster_id": "984134b7-51eb-489d-965e-a939f985e06f",
      "event_cluster_id": "4bbf6020-dd21-405a-9c26-bdeb387928db"
    },
    {
      "claim_cluster_id": "7fc9b449-7f4e-4cec-90a6-b1dab2836291",
      "event_cluster_id": "cea72470-6f49-4d89-a6fb-4c1596600c5c"
    },
    {
      "claim_cluster_id": "860407b5-0931-4ba2-9dbd-a0078e94e9c6",
      "event_cluster_id": "ea50bb1c-1d0d-46d0-8c9e-6b1bcd539913"
    },
    {
      "claim_cluster_id": "f46bebef-6c63-4778-a5c7-e0d7b893e969",
      "event_cluster_id": "2f612694-7e7c-42ff-aef8-a4f09e365266"
    },
    {
      "claim_cluster_id": "fe10e346-5245-4859-9317-c6ffae804527",
      "event_cluster_id": "5f6424e4-0455-4ee2-821d-018975472c03"
    },
    {
      "claim_cluster_id": "f309b6e7-458c-4f62-9d98-f12cb2e89c08",
      "event_cluster_id": "ac17d012-fb03-4978-afab-d0ee9527705d"
    },
    {
      "claim_cluster_id": "53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c",
      "event_cluster_id": "3d7436aa-4609-467d-a098-e24702a617e8"
    },
    {
      "claim_cluster_id": "346be717-a4b3-4210-bff0-be972806b6a4",
      "event_cluster_id": "a4dde064-8077-4a0c-97de-40075984b4cc"
    },
    {
      "claim_cluster_id": "3c9c2d2f-29ac-414f-a514-d694db25f871",
      "event_cluster_id": "a63f5d9a-cff2-4275-97b2-48d300df1ba7"
    },
    {
      "claim_cluster_id": "c0707d1f-d796-4de7-994b-fd76b5d9d3dd",
      "event_cluster_id": "556da1e6-535a-4511-ac9b-649cb3eafe84"
    },
    {
      "claim_cluster_id": "96a4146b-b919-413a-b5a7-7801adae1906",
      "event_cluster_id": "fca8c069-2da0-43e8-8cac-08662970bcda"
    },
    {
      "claim_cluster_id": "df17af70-aa4f-46d9-b191-eb3b4eeac1ef",
      "event_cluster_id": "23f200a8-82be-479e-8c62-e16a5b3450e2"
    },
    {
      "claim_cluster_id": "7811b1ac-b0e5-4c92-a933-500f6b892437",
      "event_cluster_id": "7ce5da07-bfd4-4121-8e0d-acd582b0b4a4"
    },
    {
      "claim_cluster_id": "5d8d730b-6674-4d5b-8f99-6c8e240e9080",
      "event_cluster_id": "48ab24c5-0fbd-4e1e-ac75-46e6a9ab3e75"
    },
    {
      "claim_cluster_id": "5d950548-da48-42e1-b748-275abdd34cfd",
      "event_cluster_id": "4367ebc4-e97e-4992-a822-025c7b42b1b8"
    },
    {
      "claim_cluster_id": "44a47e28-efc2-4e0c-b9c2-18a93b3b20be",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "2f4a7179-3f3f-4eb6-8891-8b8d39467620",
      "event_cluster_id": "7a7dc1ab-df88-47fe-b1e9-3558ecae338f"
    },
    {
      "claim_cluster_id": "7eefde16-5844-4305-a679-da87990a2640",
      "event_cluster_id": "5e8c77df-b06c-4eb9-af9d-86a5548a4dfa"
    },
    {
      "claim_cluster_id": "2972b17d-9533-46fe-a896-a36d50916446",
      "event_cluster_id": "97ed4747-8726-498d-80cf-261756e7962a"
    },
    {
      "claim_cluster_id": "1d4acd59-7bc7-421b-87d6-c6dcd6e61497",
      "event_cluster_id": "2ba9fcc4-8317-4968-94d5-129020e8a44a"
    },
    {
      "claim_cluster_id": "74ac8dc6-1d9b-435b-bae9-36745f271604",
      "event_cluster_id": "c974679a-a285-4dfd-882e-18a49abd08e5"
    },
    {
      "claim_cluster_id": "290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45",
      "event_cluster_id": "519a0144-fd4c-4d5c-9042-6fb50ccd2f56"
    },
    {
      "claim_cluster_id": "50fd260f-831d-4cd6-a164-2aef0978fbe3",
      "event_cluster_id": "ea56561a-6c42-424b-a439-8949e0922884"
    },
    {
      "claim_cluster_id": "8f9f1940-08f3-4a29-938e-790645f67487",
      "event_cluster_id": "ecf87520-6110-4dbb-8897-a76147b7c3f7"
    },
    {
      "claim_cluster_id": "03105f5f-d65d-4408-8071-b314d86ce573",
      "event_cluster_id": "05840b29-9ac1-459e-98bf-cb3a11b4aeb6"
    },
    {
      "claim_cluster_id": "2f3c2293-d820-4cb3-836f-6df8faee07a8",
      "event_cluster_id": "b20a6598-dc24-40bc-a9eb-7fdc252fc7eb"
    },
    {
      "claim_cluster_id": "44f7e426-bb87-4dd0-bf0c-80fb71c61eac",
      "event_cluster_id": "36dc7f3c-7522-4964-8e5f-96eb7e85aa98"
    },
    {
      "claim_cluster_id": "424a981a-fddf-4933-92b1-158cbba9a861",
      "event_cluster_id": "7f12aafb-6273-4f93-bae0-fb2dee57d074"
    },
    {
      "claim_cluster_id": "5dde6d54-8ecf-4f66-96dd-406048082082",
      "event_cluster_id": "12c2b7dd-5504-45ff-b24f-40b180021ec2"
    },
    {
      "claim_cluster_id": "efb94acb-755c-41bd-b1f3-cb170deb0266",
      "event_cluster_id": "b0157510-fe3e-44ad-a8a9-aabc1bfb9c12"
    },
    {
      "claim_cluster_id": "edbdc807-7fba-426c-a271-726e1f090eaf",
      "event_cluster_id": "6701d78c-ba82-4b89-b97a-8fd70b5e34f9"
    },
    {
      "claim_cluster_id": "f210a15e-3afd-4f52-8da2-de7a59e25377",
      "event_cluster_id": "ec47ea11-5e31-4849-97a1-585ce227df93"
    },
    {
      "claim_cluster_id": "596489a9-6207-48fb-8cf4-2972a01326d9",
      "event_cluster_id": "07c01120-e316-4bd2-9ebf-b979d08b4da8"
    },
    {
      "claim_cluster_id": "428a1c85-5fee-4a1d-bbe0-9e71872e75e9",
      "event_cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "57d96007-f80d-4110-8583-3e280492b584"
    },
    {
      "claim_cluster_id": "f679dcc1-fbec-4813-8cbd-bf97a313606d",
      "event_cluster_id": "128ade3d-bda4-4b71-b956-463eb584089c"
    },
    {
      "claim_cluster_id": "52902c20-eb03-45dd-8441-6d06b77f992c",
      "event_cluster_id": "6f7eecf9-9f3f-44ce-8b0e-5a71d6961aae"
    },
    {
      "claim_cluster_id": "13fc2321-1fdf-40d3-8576-3d7e5eb9e53d",
      "event_cluster_id": "7ba51ccd-9b62-47f9-b011-21d9bbe02ded"
    },
    {
      "claim_cluster_id": "af51e97e-2570-48ba-a0bd-ab0668831da9",
      "event_cluster_id": "81d920c9-ff43-42e8-a37f-0d453a42e2ad"
    },
    {
      "claim_cluster_id": "d8483e15-c78b-44e2-8070-c109cff73a66",
      "event_cluster_id": "473560b4-10a2-4370-be8e-3ebeae00ae74"
    },
    {
      "claim_cluster_id": "83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2",
      "event_cluster_id": "216c68fc-7c8f-405c-8f46-568b32c69eb4"
    },
    {
      "claim_cluster_id": "1c24fe42-ed01-4d5e-85a3-6011ab09ff6f",
      "event_cluster_id": "c0987cb3-5451-4fcf-a732-5bfbe94a56c9"
    },
    {
      "claim_cluster_id": "e3e4b634-fa33-47d8-9f29-eefdbb263769",
      "event_cluster_id": "a418885e-cbb2-4205-a118-ea8172eaff33"
    },
    {
      "claim_cluster_id": "6f3f0719-064d-478a-ae5f-d9aca0368d4e",
      "event_cluster_id": "06451ed7-032d-45e3-9726-f485fc31a739"
    },
    {
      "claim_cluster_id": "2105abe4-014b-48d8-a8a2-6e113ac81f52",
      "event_cluster_id": "2d060fd1-76c9-470d-941c-4c8d800b380a"
    },
    {
      "claim_cluster_id": "59f595d5-6ff2-4686-81ce-6150bd29db9d",
      "event_cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87"
    },
    {
      "claim_cluster_id": "19ec7067-1e85-4e98-adf9-a107366a808b",
      "event_cluster_id": "0594b862-5f0d-4a2a-9cbb-4d9d2192ea9f"
    },
    {
      "claim_cluster_id": "b2036724-7c6c-4df4-b983-90c324253873",
      "event_cluster_id": "31f4be33-7681-4d97-9d26-1b6c02b644ca"
    },
    {
      "claim_cluster_id": "de116a88-705c-434f-9f3a-1fdabb457723",
      "event_cluster_id": "e130a374-b2e7-4d68-8a8e-32dcab17656b"
    },
    {
      "claim_cluster_id": "a70a3157-f4e4-4eef-b960-bdf74270bd58",
      "event_cluster_id": "1c4b6f2a-a55c-4baa-b0e5-6516b517f960"
    },
    {
      "claim_cluster_id": "c0057031-5868-445b-98d3-d536042f59f2",
      "event_cluster_id": "f62b3b08-7f29-4635-afdc-c0569af97743"
    },
    {
      "claim_cluster_id": "509e1b1d-c464-406d-8d4e-6ab2f46f2324",
      "event_cluster_id": "7c8be876-c0d6-46b2-8e28-be16ba79de4f"
    },
    {
      "claim_cluster_id": "38f73b32-c8c6-49f9-8452-aefe0c4fa642",
      "event_cluster_id": "7ad20f50-14f4-4cdf-b21e-0c9b5f397fe9"
    },
    {
      "claim_cluster_id": "58c4dc89-fa0e-45c9-8892-01fb55da5607",
      "event_cluster_id": "38992305-30d9-47ce-bb30-bfa120506e54"
    },
    {
      "claim_cluster_id": "c831921a-fda1-47ba-83e1-1042bd97f245",
      "event_cluster_id": "d35e4c86-fef1-49fa-8134-2537759e6118"
    },
    {
      "claim_cluster_id": "db608ced-e4c3-4573-8b19-bacdf06c1585",
      "event_cluster_id": "1f127567-1266-42ac-9246-3f7f8bb52a6b"
    },
    {
      "claim_cluster_id": "da1326c3-fa76-400d-b44c-881f6493a085",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "e8f2c1ac-40d6-4338-93ee-3033faec8f14",
      "event_cluster_id": "13862105-6364-499b-aec8-a649c26c5b3c"
    },
    {
      "claim_cluster_id": "67674784-9e53-4907-a36a-9a45f8374e68",
      "event_cluster_id": "d6edcbd0-8a76-4410-b54b-26039bf9a1d1"
    },
    {
      "claim_cluster_id": "aaa5b32a-96ba-4450-b886-70f714b65bf2",
      "event_cluster_id": "3761b79a-ed1e-4efa-a004-8d3634d88c5c"
    },
    {
      "claim_cluster_id": "930ae324-24b9-4353-aa17-35d5e069f64f",
      "event_cluster_id": "0f0ff324-b8f3-41db-88cd-a895d1f4a2d9"
    },
    {
      "claim_cluster_id": "aafcc6bc-c8f9-4a4c-acf7-9628f64db648",
      "event_cluster_id": "d58686a5-53bf-4314-a7f1-f0e899bc8c82"
    },
    {
      "claim_cluster_id": "1dd25bce-7fe6-46d2-9e28-e803262696c4",
      "event_cluster_id": "2b0eed50-da8b-45e1-8588-42e0093ff921"
    },
    {
      "claim_cluster_id": "6288e205-b9e8-41be-a3f8-80b06b50c037",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "a94e5bcb-b502-4cb7-a23d-3a1e29ce963a",
      "event_cluster_id": "a397f3ea-2260-47ec-beca-b473be543d39"
    },
    {
      "claim_cluster_id": "2f8d9d1d-f145-459e-90bd-ebf833c6fe60",
      "event_cluster_id": "abb6468b-1949-4a51-9adf-d3e014a3003b"
    },
    {
      "claim_cluster_id": "6f7b1c88-304f-4cf4-ba94-d6268fa5ae40",
      "event_cluster_id": "2813da46-c92c-428a-9aa0-d5a6d2aae7d8"
    },
    {
      "claim_cluster_id": "4bcae16d-fb51-4ba8-8381-37355e0e9f18",
      "event_cluster_id": "e5a3c503-081f-45b6-97d7-1fab2efba3f8"
    },
    {
      "claim_cluster_id": "3d2576b2-1572-432b-98fe-db8e768274d5",
      "event_cluster_id": "f8f2a0f0-c3be-425d-86a8-e332c871c957"
    },
    {
      "claim_cluster_id": "29e9fc0f-b1d3-428d-985b-aead08ce4e3c",
      "event_cluster_id": "88637747-174c-4782-89a7-a4bbdeb1e9e1"
    },
    {
      "claim_cluster_id": "a7867a02-8602-4251-af70-d100ee635a74",
      "event_cluster_id": "ddc5360a-1ac4-443b-9995-2e77ae3fa0fc"
    },
    {
      "claim_cluster_id": "dea6592f-a2fb-4ea8-b832-4f7df984c163",
      "event_cluster_id": "ab98fd27-202d-413c-8332-5c4cfa41f02e"
    },
    {
      "claim_cluster_id": "136829a8-989b-4ffa-8ef0-ec23f5f18819",
      "event_cluster_id": "dbfa0b87-7424-42ca-8827-733df18f150e"
    },
    {
      "claim_cluster_id": "e59930cd-f28a-4a44-8feb-24e860e36480",
      "event_cluster_id": "2f2fd953-8be4-4011-bcf6-98e5b07a9282"
    },
    {
      "claim_cluster_id": "3630ee9d-368f-4623-9704-06881bdf9264",
      "event_cluster_id": "5dc9068d-5bdc-499d-a865-8dc21a274dc1"
    },
    {
      "claim_cluster_id": "adc640bf-2d33-45f1-87f4-f455e4d88f72",
      "event_cluster_id": "0ded9d87-ef2c-4d88-b3db-79b2f8e48989"
    },
    {
      "claim_cluster_id": "a70a3157-f4e4-4eef-b960-bdf74270bd58",
      "event_cluster_id": "f5d2e5c5-6f09-4885-98b8-5062202897a8"
    },
    {
      "claim_cluster_id": "5a089986-6a82-42ed-90a9-302a1ce45000",
      "event_cluster_id": "eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"
    },
    {
      "claim_cluster_id": "9e906023-8a3d-4a63-9309-18e9ee1c3641",
      "event_cluster_id": "be12c5b4-b051-4762-b77d-ca92a4063972"
    },
    {
      "claim_cluster_id": "17036568-8b0d-4108-9a16-98a16980ae3f",
      "event_cluster_id": "2f4e138b-a8ca-4c68-be26-24de0c3b0489"
    },
    {
      "claim_cluster_id": "f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "a2a57731-90ff-4a12-a08f-721a9dfc0b06",
      "event_cluster_id": "10e8efce-e96d-4c64-a187-c3669a9d303c"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "a162a552-43bd-43b6-925a-ac7f9fbf4734",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "20ab2459-a6a0-4e45-aef0-5b2d6b529a0e",
      "event_cluster_id": "84ba9e08-7f87-4e91-abf6-4415ddb9a231"
    },
    {
      "claim_cluster_id": "93d03ec0-ac83-451a-87b2-a95e3d58859f",
      "event_cluster_id": "84e9da04-8cd3-4c61-8fa8-fb55a6309d3d"
    },
    {
      "claim_cluster_id": "ab24b6cb-fc70-48c9-8ee3-224b83a66b11",
      "event_cluster_id": "ebc26e14-b86c-4a50-a196-d8cbcc8aab8c"
    },
    {
      "claim_cluster_id": "56e6ff33-547f-4d6b-a7a7-e1266368fdd7",
      "event_cluster_id": "7c8877ae-f397-490e-9778-67a6e91ebe1c"
    },
    {
      "claim_cluster_id": "b60b834e-1991-44ea-a53f-68d101a440a4",
      "event_cluster_id": "ebed0c7e-1e7f-4dd0-9028-668b74f8c629"
    },
    {
      "claim_cluster_id": "da2845de-4e1b-492a-a6b0-06fd4584650e",
      "event_cluster_id": "ac066abb-a95e-4ab2-884e-0a0fd4b40f30"
    },
    {
      "claim_cluster_id": "b5600099-12c0-41c7-bfb6-4b6bb66dc0dd",
      "event_cluster_id": "42a6504a-75a7-4c6b-8491-655e6c73b864"
    },
    {
      "claim_cluster_id": "35c8d576-e355-4f4b-802d-1d88de41da0b",
      "event_cluster_id": "1020a2ca-3e92-4f76-98e4-6f44fdfd5f52"
    },
    {
      "claim_cluster_id": "194a083f-fee7-4bf0-b198-fa40c8bdfe21",
      "event_cluster_id": "1f7a9b1b-5ce3-47cc-9f13-4f47996738bf"
    },
    {
      "claim_cluster_id": "6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5",
      "event_cluster_id": "0500f877-c2d0-4c97-b0d7-76dc88e38eae"
    },
    {
      "claim_cluster_id": "ca871236-c037-4fa9-b3bc-cfec982a8e55",
      "event_cluster_id": "270b9be6-37c3-4ab7-9763-57943d7a38b9"
    },
    {
      "claim_cluster_id": "f833277e-e62d-4240-a8fa-fd6d79db3c79",
      "event_cluster_id": "cb120bb7-e884-4891-9573-61c67b37ce2a"
    },
    {
      "claim_cluster_id": "3c9c2d2f-29ac-414f-a514-d694db25f871",
      "event_cluster_id": "48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"
    },
    {
      "claim_cluster_id": "7b83d3ee-13b2-47c1-ab89-4f78258a986b",
      "event_cluster_id": "ee6ffddc-d717-4a7b-a161-3d1bdc24c500"
    },
    {
      "claim_cluster_id": "1dc0ed5e-e098-401c-9b18-3dd42ba6b01f",
      "event_cluster_id": "fe8daec7-d83a-4b36-9a29-fc5d4f9d4d89"
    },
    {
      "claim_cluster_id": "53ddceb6-33d2-42fd-849a-253f21907d2a",
      "event_cluster_id": "4ca6827b-b30a-4210-a329-a338c23874a3"
    },
    {
      "claim_cluster_id": "89aabd59-2b1d-4122-9c03-b5ffeee5a650",
      "event_cluster_id": "e50f2f1a-20bb-46bb-82c9-6def0deadc19"
    },
    {
      "claim_cluster_id": "f72f8aec-c684-4bb6-92bb-742f08817b1d",
      "event_cluster_id": "2cd863fc-6aa3-4b22-ae05-f3da95690998"
    },
    {
      "claim_cluster_id": "7c8b94c0-08bd-43e2-9b5a-418ff416c274",
      "event_cluster_id": "3ce0cb1a-1f92-4f2d-a2e0-fbdd35527908"
    },
    {
      "claim_cluster_id": "1a247a51-e7fa-46f4-b0b3-659a03d784c6",
      "event_cluster_id": "eecfdbc7-a037-435d-b439-dc9fb3713fa6"
    },
    {
      "claim_cluster_id": "4ac1da2e-cd03-4a11-b440-f62dc8f73aad",
      "event_cluster_id": "da455fdd-d1bf-4166-b24f-377899985b7c"
    },
    {
      "claim_cluster_id": "3579f3e6-5ab6-488d-a555-602383a4e3bf",
      "event_cluster_id": "42663758-9518-49e1-a45d-11b8ad2a2193"
    },
    {
      "claim_cluster_id": "42d845ed-aaed-4d48-a0e4-2928cc3ba602",
      "event_cluster_id": "1417deae-6f6a-444b-92e3-0d85e814d6aa"
    },
    {
      "claim_cluster_id": "9c9d4ed6-a861-4706-aee3-f148f1769c86",
      "event_cluster_id": "efd1564d-df50-445a-a638-9947d0e8404e"
    },
    {
      "claim_cluster_id": "7f43c7d3-2a4b-493c-b3f0-a53355ae39a3",
      "event_cluster_id": "ba20492f-063b-4fc0-8bd7-26d88daa19d1"
    },
    {
      "claim_cluster_id": "f3328626-3764-43c0-a7df-3730b34ea1fd",
      "event_cluster_id": "8a51d448-3e97-4522-acf3-ca3a46ef7aad"
    },
    {
      "claim_cluster_id": "95b38f6d-19e7-4fa7-a9de-ee665de84018",
      "event_cluster_id": "ce0d6d93-def3-45e3-8bfd-1c14d5d947ee"
    },
    {
      "claim_cluster_id": "dfea6d47-10c8-4540-8a78-5667ac532c10",
      "event_cluster_id": "ec7138ff-1f97-4076-a56b-198783100d75"
    },
    {
      "claim_cluster_id": "b0071c15-10b9-4a75-8b7f-486b9f2c04d1",
      "event_cluster_id": "7014c024-82bc-4f47-b6cf-23a09be951e3"
    },
    {
      "claim_cluster_id": "30fdf9bb-e9b5-47e5-a899-e176ffa77eac",
      "event_cluster_id": "0bf33c34-9525-433f-a535-5885b1ee4732"
    },
    {
      "claim_cluster_id": "da745b4f-4158-4c1c-b2f1-ec13252863b3",
      "event_cluster_id": "222e0df8-36ff-4110-93f1-22c42e9ea101"
    },
    {
      "claim_cluster_id": "2f43e86f-24fc-4c3c-a77d-c5abbf46ef19",
      "event_cluster_id": "8c990025-029a-4aef-bcf5-41326b6234ac"
    },
    {
      "claim_cluster_id": "b4295bad-3940-4b00-ac2b-862c41b5597c",
      "event_cluster_id": "dbfd0383-d4d3-4b5c-a820-54e5dc7d2adb"
    },
    {
      "claim_cluster_id": "4ea56329-d3e1-48ab-835d-a5cbc403dcf0",
      "event_cluster_id": "3422b937-ad13-407b-bc17-21e8928a73d8"
    },
    {
      "claim_cluster_id": "f10deefc-8ed5-4516-8cc2-3ba87195eac0",
      "event_cluster_id": "b95182bc-1bb5-417c-822b-57af63faceac"
    },
    {
      "claim_cluster_id": "73aeb014-9fc7-4042-b2b1-7016c4fa8dd2",
      "event_cluster_id": "0e5c3365-93fa-488b-b635-43b68052b0bc"
    },
    {
      "claim_cluster_id": "9d6f335e-c5fe-40ff-9edc-7ee5892fafaf",
      "event_cluster_id": "0e128959-4be6-4a58-950e-03878e48a675"
    },
    {
      "claim_cluster_id": "b2568d68-53d4-487c-b724-0456b247a886",
      "event_cluster_id": "5a676523-5e3b-4d60-979c-dc06042c89a3"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "8ef3f5ab-a5d7-4598-bbc0-95b969a66cac"
    },
    {
      "claim_cluster_id": "237a5318-2edd-4ffc-869f-c0fed9502097",
      "event_cluster_id": "db3b032b-6eb1-469a-8fea-f26d907c46cc"
    },
    {
      "claim_cluster_id": "89b28f7e-be14-417b-aeba-019498e50195",
      "event_cluster_id": "3a663e69-ed69-48a3-9c9e-25cdac30bcdd"
    },
    {
      "claim_cluster_id": "478db2a7-a90d-4fbf-8954-0416daa97dcb",
      "event_cluster_id": "05359182-fefa-4fca-a6e5-68210986bdca"
    },
    {
      "claim_cluster_id": "6670d6b8-9c36-4849-b28c-4959087df8d4",
      "event_cluster_id": "38bb4737-de3e-4b8d-b413-8281bb85ae27"
    },
    {
      "claim_cluster_id": "d2231d7f-5f03-4e76-b0ae-753fd54f4960",
      "event_cluster_id": "ccdd5d79-92b1-4503-a1ce-51ccf23fc823"
    },
    {
      "claim_cluster_id": "5a6c75cb-74c4-45e2-b8d3-dd1dbdb1dae1",
      "event_cluster_id": "1231d1d1-38bd-406e-916f-d7769d05b29d"
    },
    {
      "claim_cluster_id": "16e38b6b-7241-4f9f-8554-c33f05a6edb7",
      "event_cluster_id": "f7bc5745-3844-4596-a6d1-1d8cba63f4b6"
    },
    {
      "claim_cluster_id": "668dd84f-417c-4a0b-ac12-78d246a5f46e",
      "event_cluster_id": "c6d927b7-cd5d-4d4f-8175-fa9bbd32a788"
    },
    {
      "claim_cluster_id": "c3f83d4c-9f83-4fe3-befa-1e9b93dee510",
      "event_cluster_id": "04568cc7-5dd8-42b7-8a07-715cdd043c03"
    },
    {
      "claim_cluster_id": "ac4174c2-4597-4a76-ac06-95cefda372c9",
      "event_cluster_id": "fc4f3449-d301-4936-a35f-47ca68ad88dd"
    },
    {
      "claim_cluster_id": "dea6592f-a2fb-4ea8-b832-4f7df984c163",
      "event_cluster_id": "3b5c9589-43fb-428f-a24d-ff67c6ec3e67"
    },
    {
      "claim_cluster_id": "96423d41-ee08-4c5e-bcf0-4dd1b431abc6",
      "event_cluster_id": "a5de3945-d8b3-45a7-9c18-edeaa4ccf742"
    },
    {
      "claim_cluster_id": "56e6ff33-547f-4d6b-a7a7-e1266368fdd7",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "6ca40c20-bd2c-4fa0-af88-bbe3820f05e6",
      "event_cluster_id": "693c26f4-40f7-4d45-b4b9-51440f45735e"
    },
    {
      "claim_cluster_id": "a789dff6-b07a-42f9-812b-05be84eb01d1",
      "event_cluster_id": "1fef267f-5c4c-4c0e-b98e-4a09e90f0341"
    },
    {
      "claim_cluster_id": "e30f1c65-b396-4183-98d3-9deb2bc6322a",
      "event_cluster_id": "eb4cf940-96c8-499d-b7a7-939513787944"
    },
    {
      "claim_cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
      "event_cluster_id": "c0ac6691-abf2-4873-a338-41a4997bcb24"
    },
    {
      "claim_cluster_id": "cd1cad7d-4c68-4a07-b4fd-c8e01c9f94cb",
      "event_cluster_id": "bafef2bb-9288-4a42-8a15-be9d11a861ef"
    },
    {
      "claim_cluster_id": "cefbf586-5d05-477f-8675-6637fb8781a5",
      "event_cluster_id": "6ef25b46-a4b9-4af8-a6c3-f3258aa3145a"
    },
    {
      "claim_cluster_id": "d17d8e48-7844-4b9c-9bc0-e31d87299aef",
      "event_cluster_id": "1a5017d7-a85f-401a-9c3e-9a087de588f6"
    },
    {
      "claim_cluster_id": "f1afc4d0-4eaa-40ab-99e6-20e11c550ccb",
      "event_cluster_id": "eb95d7a1-b24f-4167-89ab-cc60dc7c7822"
    },
    {
      "claim_cluster_id": "f51d817f-9949-43cb-b16a-bfdefff947f1",
      "event_cluster_id": "ce82add7-3d2e-4c0b-8f3e-d449dd7f2ee7"
    },
    {
      "claim_cluster_id": "6cade303-8a3e-4226-b5e8-0d3b189187cb",
      "event_cluster_id": "ac4b1f63-94c9-4cd0-938b-a716a9ba6a09"
    },
    {
      "claim_cluster_id": "bd50210c-37cf-46e2-9d31-0c6a6dd06e70",
      "event_cluster_id": "3128448b-d77b-4666-b5fa-39d7bf0fea69"
    },
    {
      "claim_cluster_id": "2aeb94af-8d5b-40ce-b754-91495083b2a1",
      "event_cluster_id": "8820c527-2e2c-4341-bec1-16e1d5309310"
    },
    {
      "claim_cluster_id": "89a7a448-be37-40e3-973f-79b15dac979d",
      "event_cluster_id": "a20fa4a8-bba3-463b-b15a-06c8b4daad85"
    },
    {
      "claim_cluster_id": "6a65158f-b873-42cb-b0bd-0cb1b60a0d86",
      "event_cluster_id": "184f7da5-f557-4593-8954-67601ea3d345"
    },
    {
      "claim_cluster_id": "a34f85b1-92bb-47d3-b089-7365f6b9f51f",
      "event_cluster_id": "bbb004ba-d35c-43eb-a8fb-f8fc936100c1"
    },
    {
      "claim_cluster_id": "d17d8e48-7844-4b9c-9bc0-e31d87299aef",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "a38268fe-ba89-4d63-8481-63c080523a0a",
      "event_cluster_id": "ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"
    },
    {
      "claim_cluster_id": "273554c2-556d-4017-8422-f543fd17c4ef",
      "event_cluster_id": "78aa3214-a8d5-4987-ad02-0d4cd5db66f9"
    },
    {
      "claim_cluster_id": "655a46a8-9b52-4f61-b528-9f18ec9bf051",
      "event_cluster_id": "4d3fc72a-c96e-4659-afda-27c7ce47c497"
    },
    {
      "claim_cluster_id": "42ec0ecc-4c37-4216-9671-a26ac18a9ead",
      "event_cluster_id": "637c1c25-6bd5-446b-89ea-dbb02add4b34"
    },
    {
      "claim_cluster_id": "8d98ef20-8cc0-4e51-b441-315a42837e56",
      "event_cluster_id": "ca872018-66c6-4a52-8d9c-e664e0716e90"
    },
    {
      "claim_cluster_id": "a1a796af-13af-4bb2-ad74-b64193c2de86",
      "event_cluster_id": "53d09843-b0b4-4b4a-974f-76bfc4243e0c"
    },
    {
      "claim_cluster_id": "017c8345-ee2f-4b6f-8701-6def5bbd5082",
      "event_cluster_id": "6d2e659d-b2ff-460e-98c9-72a4faf6173b"
    },
    {
      "claim_cluster_id": "3e5167ea-d839-4cc5-b193-fda2f9c0b53b",
      "event_cluster_id": "f7dce48b-908d-410d-ae3b-0711d8dd8a49"
    },
    {
      "claim_cluster_id": "5a8c09d4-337f-442b-8464-f2be567010bf",
      "event_cluster_id": "56c21a67-f093-4d7b-81de-a41cb3a3c896"
    },
    {
      "claim_cluster_id": "6d2624a6-0551-4f8a-8ed4-2b7126ed6490",
      "event_cluster_id": "56d8e5bc-dfb0-4e57-a911-a8a552ba1562"
    },
    {
      "claim_cluster_id": "7511bd1f-13b7-402b-887d-d4fe077fcba7",
      "event_cluster_id": "41c6f905-1ba5-4740-a4f5-bc35586af666"
    },
    {
      "claim_cluster_id": "e8898157-febc-4868-87fa-8effb0a882e8",
      "event_cluster_id": "19fb932a-d5d7-4981-804f-5245e467f600"
    },
    {
      "claim_cluster_id": "c3f83d4c-9f83-4fe3-befa-1e9b93dee510",
      "event_cluster_id": "4272dbf3-0c9a-42d8-a9a1-b2b3a349e192"
    },
    {
      "claim_cluster_id": "7e4a12f6-fe24-48f6-993c-d7197eb9c44e",
      "event_cluster_id": "1034b1f8-bfe4-4bc4-80f2-8e57922001cc"
    },
    {
      "claim_cluster_id": "0f388428-daa1-4ce6-a7b1-8c553ad3896d",
      "event_cluster_id": "64855ee7-ebba-445c-9213-c6921f4dbbae"
    },
    {
      "claim_cluster_id": "334a3914-b271-4b2a-83fd-f8bd4dbb0c53",
      "event_cluster_id": "4d2908dd-c372-4065-827c-bbbe9d18c879"
    },
    {
      "claim_cluster_id": "e8d873fb-d6bf-4c6b-9328-dabcc490fe91",
      "event_cluster_id": "212cb6aa-4aac-4425-b0fc-6bb9b68aeb36"
    },
    {
      "claim_cluster_id": "8f15ddff-3bc7-4fbd-9371-1a897f8b9078",
      "event_cluster_id": "ac3c6b64-fc97-40dd-93ef-f777610b8337"
    },
    {
      "claim_cluster_id": "c065f08a-341f-4084-99ca-ceef465c2c9a",
      "event_cluster_id": "777da0e0-2515-442a-8eed-8174f7063a5c"
    },
    {
      "claim_cluster_id": "aed74a8c-a339-4a19-a144-bb62990f8e50",
      "event_cluster_id": "e10e77d8-6d39-499c-97ff-017e9cdbf650"
    },
    {
      "claim_cluster_id": "33588f3c-4f55-41eb-b5d2-57696a57221d",
      "event_cluster_id": "b5a04b5f-b3fb-4230-b364-c7b2ab5c4aea"
    },
    {
      "claim_cluster_id": "bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a",
      "event_cluster_id": "0646d462-dfca-47fe-a0c9-5ac11b42cb7e"
    },
    {
      "claim_cluster_id": "d1f2b2ed-be0f-44a4-a171-4b848f482ca9",
      "event_cluster_id": "d1bd7e91-60d7-44c4-a3e3-fa4bad7dab38"
    },
    {
      "claim_cluster_id": "d089f75e-69ee-4713-8c0e-27843b110a2a",
      "event_cluster_id": "d44024e8-81f4-4d88-982c-a023f24b58cd"
    },
    {
      "claim_cluster_id": "b3dddca5-c2cb-4bb6-a964-c4a7328e5b0d",
      "event_cluster_id": "a6f2fc25-ee4d-4748-9248-d40e233dda78"
    },
    {
      "claim_cluster_id": "c81b3fac-f8f7-4824-a157-6d31dd48689f",
      "event_cluster_id": "c83ee9d9-24f2-4221-bbfd-6aeb1c7db66f"
    },
    {
      "claim_cluster_id": "83ec8695-6d93-432e-a8be-81705e2e2a54",
      "event_cluster_id": "5982b5d4-204d-410d-a74c-8426e91d2bd1"
    },
    {
      "claim_cluster_id": "5d65069d-5cc8-4da8-8b8d-bbd1528688e7",
      "event_cluster_id": "003d2fc7-16f8-4835-a770-b85123b3c250"
    },
    {
      "claim_cluster_id": "10bff7af-7766-4fc3-b86a-eaf53dd132e9",
      "event_cluster_id": "d5777d75-d1f3-4884-9f6a-615b36a875d0"
    },
    {
      "claim_cluster_id": "bf53e706-320e-4307-85d6-fcee526f5f17",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "2c9fc1d9-b4d4-4707-a2ac-1245937847ac",
      "event_cluster_id": "f4bded1f-3dd1-4137-af03-3dc33133634e"
    },
    {
      "claim_cluster_id": "5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4",
      "event_cluster_id": "f8ac7419-698c-4d8c-9bee-1803e1e62a78"
    },
    {
      "claim_cluster_id": "6663d8fb-8d11-459b-85ff-7054f5d07b06",
      "event_cluster_id": "5fedf7dd-6fac-4316-b725-5d2fe32ac129"
    },
    {
      "claim_cluster_id": "e30f1c65-b396-4183-98d3-9deb2bc6322a",
      "event_cluster_id": "edf45ed0-2320-4899-9b2b-3485b276ff56"
    },
    {
      "claim_cluster_id": "7d04ad0f-dee5-48f3-910e-0b2281b15f1e",
      "event_cluster_id": "0829b680-8676-4565-bcc1-70f1f8778ca5"
    },
    {
      "claim_cluster_id": "c6f7c193-f407-447c-a10f-3ea5292ea3e8",
      "event_cluster_id": "17a99d17-d7ec-4cf5-8a94-b29753d62b97"
    },
    {
      "claim_cluster_id": "856ae956-c845-42c3-8716-9e150f646a11",
      "event_cluster_id": "80b5a69e-5f2f-4b54-a7e5-680323a8c096"
    },
    {
      "claim_cluster_id": "13b8e657-b1a1-46e6-ace5-fc6a57928a32",
      "event_cluster_id": "ce22089b-598c-40ef-ab32-85ce5e1f2d4f"
    },
    {
      "claim_cluster_id": "aafb6f56-e150-4de6-8f24-4e8fe467b23f",
      "event_cluster_id": "54ac5876-c16b-4f4f-ac8b-44b5ec31d0a3"
    },
    {
      "claim_cluster_id": "6b512fcc-e6a2-414b-8a86-90a11b76795a",
      "event_cluster_id": "d481c919-0d2f-4cb2-bfd7-956740c2c572"
    },
    {
      "claim_cluster_id": "65cd54b0-2f90-4b59-a573-5917ec27f9bb",
      "event_cluster_id": "254e946c-9e7a-429c-b142-d41e38953b50"
    },
    {
      "claim_cluster_id": "bc2e7af6-3507-403a-b41c-f6013dcfcf6c",
      "event_cluster_id": "873c2a4d-0ea1-497c-90c1-2ef71ec73e8d"
    },
    {
      "claim_cluster_id": "3d8a0674-b5ba-4875-8267-9c46797d5ef5",
      "event_cluster_id": "cf3bf537-5d66-4200-ab53-fd6a34c1b11b"
    },
    {
      "claim_cluster_id": "e455cd44-cd3c-4e6c-a847-ff250278123c",
      "event_cluster_id": "5a7cebd4-db2c-4dcc-8a5c-86e950acfb54"
    },
    {
      "claim_cluster_id": "3051427a-61ac-4a57-816c-f2ad62bba5e0",
      "event_cluster_id": "7df19845-e2c9-43df-ab08-20e640d2669c"
    },
    {
      "claim_cluster_id": "af3f95a3-d597-4371-bf7f-e4f5d91a9b73",
      "event_cluster_id": "ffccc68c-8962-496e-be7a-e09d954b9f4e"
    },
    {
      "claim_cluster_id": "839faa06-15df-459d-8f1d-015981c670e0",
      "event_cluster_id": "7957f359-526a-4b55-928e-2a84077427a5"
    },
    {
      "claim_cluster_id": "ceabee0f-bc28-4b8e-8445-fc63ff551472",
      "event_cluster_id": "ad2a393e-2bc5-4c0d-addf-577399b7b41d"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "01a95de5-1ee0-4431-afa3-a8234a4831ac"
    },
    {
      "claim_cluster_id": "1dc1ea0e-ecc0-4a99-a555-3574b46d8688",
      "event_cluster_id": "3d51ea74-3b4e-41f4-8d23-b8b5e017e1be"
    },
    {
      "claim_cluster_id": "e1c12b4b-138d-4ddc-9b6c-49a0a9de18b9",
      "event_cluster_id": "889e78e7-a427-42ef-b24d-0164df4f19bf"
    },
    {
      "claim_cluster_id": "77de10dc-6dcd-4902-a9d2-f5cf9384d343",
      "event_cluster_id": "ceeb447c-921b-4bff-b396-64b4ab69cf19"
    },
    {
      "claim_cluster_id": "62ff82d6-7a81-4618-a5c7-dad49908ecf4",
      "event_cluster_id": "4aeb0c0d-181c-4cfb-9c1f-7338a1c0e097"
    },
    {
      "claim_cluster_id": "b570ae3c-f72b-47a9-b995-64ca6b5f3ae0",
      "event_cluster_id": "d748d1bd-38e3-44b3-b268-429f4615acee"
    },
    {
      "claim_cluster_id": "cd099a56-0545-43d7-bbda-54857a323642",
      "event_cluster_id": "d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"
    },
    {
      "claim_cluster_id": "ecf280bd-73fc-4028-90b4-eae0d740ef40",
      "event_cluster_id": "4a281b46-5b6c-4de0-b8bf-1d3cec2f1919"
    },
    {
      "claim_cluster_id": "93f3d467-50ce-4038-8205-5814ad28dd43",
      "event_cluster_id": "f1b261ff-b08d-4eda-9ef1-3dbeca804b57"
    },
    {
      "claim_cluster_id": "b2a7204e-e5ad-4d5f-8464-67520217c392",
      "event_cluster_id": "b0a9927e-dfb0-4578-8343-304f2917ace8"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "623ab1ae-1f19-46fc-b19b-929f64c7b525",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "f597184d-050f-4a51-9461-70b55cf2b05c",
      "event_cluster_id": "e86748c4-2789-4941-b470-d29321693c17"
    },
    {
      "claim_cluster_id": "579db367-74ad-4432-9888-8af443f74bd8",
      "event_cluster_id": "9964a330-c7c3-4cd3-bf33-0b48084f4337"
    },
    {
      "claim_cluster_id": "ef49913c-d983-49cf-b90f-4529857c36a4",
      "event_cluster_id": "4f2403b6-f02f-46f5-a51a-edcea5995adb"
    },
    {
      "claim_cluster_id": "d1c29947-a7e4-41cf-9656-837e51b2de11",
      "event_cluster_id": "0c6f8f11-1c81-417d-bf01-df519f70e0fa"
    },
    {
      "claim_cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "event_cluster_id": "21b4b954-5140-43e2-bd9b-c8ab79b3e70c"
    },
    {
      "claim_cluster_id": "9c99e4fa-6c0d-4aa9-bb98-86450c898d1b",
      "event_cluster_id": "f2b7ea2e-02cf-4061-b076-60c350522e8d"
    },
    {
      "claim_cluster_id": "f21a34f1-8f4b-45c1-80d1-4a2fc8e55091",
      "event_cluster_id": "d8c99eb9-8781-4abc-9592-b545d9c15ce0"
    },
    {
      "claim_cluster_id": "6695efed-b1b5-4469-a01b-a370dfb9c522",
      "event_cluster_id": "5219fa36-fd8a-41f9-b4a4-5e01b881c12c"
    },
    {
      "claim_cluster_id": "7ebece62-a589-49b3-b28f-b8f565ab7327",
      "event_cluster_id": "e47fa355-bcc3-44bc-97e3-0029cf946325"
    },
    {
      "claim_cluster_id": "2a1de060-abb4-43d9-a91c-f13c074e7031",
      "event_cluster_id": "aae30a17-ea30-48f8-8399-1f3de025df70"
    },
    {
      "claim_cluster_id": "5b28f56e-4dc0-41d8-b963-a4fc04cbaf08",
      "event_cluster_id": "735c3d6c-a597-44bd-92cc-d934d1e29409"
    },
    {
      "claim_cluster_id": "5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4",
      "event_cluster_id": "8a4a4131-add5-4367-8ccd-215684fa73dc"
    },
    {
      "claim_cluster_id": "af2dae39-7b57-4e0d-909b-c39b56de0088",
      "event_cluster_id": "e9ec4305-aed2-424a-9a57-210fed19fa52"
    },
    {
      "claim_cluster_id": "2c9fc1d9-b4d4-4707-a2ac-1245937847ac",
      "event_cluster_id": "0313a78d-59e1-4fe7-8d40-5db79d99214e"
    },
    {
      "claim_cluster_id": "03b72068-02c5-403e-b844-88e40b030a18",
      "event_cluster_id": "2ce189ee-012a-443c-b12c-079c48f7f1a8"
    },
    {
      "claim_cluster_id": "1da5d8fa-d5b3-4c58-9989-3b5775687e42",
      "event_cluster_id": "578d69cb-06e2-4455-a662-a864e327b852"
    },
    {
      "claim_cluster_id": "53da7ed0-9d8e-436f-b097-49ff62b95459",
      "event_cluster_id": "416a789f-b094-4d93-9898-3707b0bf84ed"
    },
    {
      "claim_cluster_id": "5aad8736-b18a-4e21-930e-320f4faaed1c",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "e37c8f7a-2656-421b-b216-1d87659bcb44",
      "event_cluster_id": "72084673-8080-44fd-8f5b-97507abf262b"
    },
    {
      "claim_cluster_id": "668dd84f-417c-4a0b-ac12-78d246a5f46e",
      "event_cluster_id": "2c20a8ae-1d47-4c90-a5e4-88e406d3334f"
    },
    {
      "claim_cluster_id": "19ec7067-1e85-4e98-adf9-a107366a808b",
      "event_cluster_id": "ab08e2a8-8249-4477-b0dc-0a3c5235d6a7"
    },
    {
      "claim_cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "9a73096a-390b-4f9e-a044-22f30734ce69",
      "event_cluster_id": "82c4576a-a59c-436d-bb23-2d15a1d9c903"
    },
    {
      "claim_cluster_id": "8cb34140-24ef-4173-9390-c1f84800160e",
      "event_cluster_id": "347223d3-908d-4003-9d32-5f2929c89e51"
    },
    {
      "claim_cluster_id": "5dac5b6d-e9df-41db-9225-7e413ca3cacb",
      "event_cluster_id": "29bfbe48-82ec-4d12-8240-7206925d2386"
    },
    {
      "claim_cluster_id": "32a2eefa-c8c7-482c-839f-be3b15138d40",
      "event_cluster_id": "081350a8-a16a-45fc-b513-065a8ddaebac"
    },
    {
      "claim_cluster_id": "391ac4c5-638b-42bc-b8d7-1972d56df43e",
      "event_cluster_id": "fb065855-6920-462f-84b1-383a66822ef8"
    },
    {
      "claim_cluster_id": "283a7466-09a4-4b67-abff-ca96f1d8ade9",
      "event_cluster_id": "3b245c17-07a2-4e26-a29a-946ef78835ee"
    },
    {
      "claim_cluster_id": "a764eb56-b1bb-470b-bb17-4bd9f5369b4b",
      "event_cluster_id": "09a252ec-4d97-4380-a535-1e7222c476ea"
    },
    {
      "claim_cluster_id": "7742ec5a-27ab-42d2-9779-df7d73a0cec4",
      "event_cluster_id": "e0e899a0-65d4-45b2-b3be-ff8320d1837a"
    },
    {
      "claim_cluster_id": "82430ac1-c5b1-4777-ac21-a40819c2ad02",
      "event_cluster_id": "e0ef928b-5c3a-4954-b041-cb096ddc889e"
    },
    {
      "claim_cluster_id": "2fc8ee47-5c74-46a4-91ea-72f94f9e2c27",
      "event_cluster_id": "12cb5a16-807e-4b60-87c2-713f3796ebf1"
    },
    {
      "claim_cluster_id": "81062452-735a-45ec-ae26-d06b90c45ed4",
      "event_cluster_id": "ec9bc095-279f-474f-9706-4d758de892be"
    },
    {
      "claim_cluster_id": "b2568d68-53d4-487c-b724-0456b247a886",
      "event_cluster_id": "4e9bc944-639b-4f8d-838e-a744f7d10ce2"
    },
    {
      "claim_cluster_id": "66df7edf-0972-4fa2-846f-2e6326ee828b",
      "event_cluster_id": "86f9f906-a751-49c5-9fab-90ea9e810607"
    },
    {
      "claim_cluster_id": "267d2942-984a-4564-b33c-69e9db79a066",
      "event_cluster_id": "89448e79-f7ef-4836-aa0c-f4044c4e1e16"
    },
    {
      "claim_cluster_id": "af144d2c-f8aa-40f2-9250-f41cd71f8fd9",
      "event_cluster_id": "eef62b12-ce49-4113-8683-7c0cfeda9369"
    },
    {
      "claim_cluster_id": "95469f31-02a2-4069-8577-33c92dddd21d",
      "event_cluster_id": "6d60b9fd-35cb-4875-8f6b-cc990ada4464"
    },
    {
      "claim_cluster_id": "c782b8c2-e8a6-49c0-98b9-40619e415dcd",
      "event_cluster_id": "1edefbd4-7887-468f-8ea8-789dc55de3db"
    },
    {
      "claim_cluster_id": "d61fc1c9-1533-4eaf-88f3-8d0340ce2de0",
      "event_cluster_id": "d4c689b9-e4d7-4a70-913a-2c31aac2dfbf"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "9afd9c54-2f8e-40e0-aff4-8479c84a56df"
    },
    {
      "claim_cluster_id": "96b36beb-a890-402f-9101-7aa7236863f1",
      "event_cluster_id": "fe911735-6fb7-4737-bc2c-bfe7c0b05844"
    },
    {
      "claim_cluster_id": "b693d408-b0fd-49d2-8eea-39016ff5fda7",
      "event_cluster_id": "465ba356-8493-40d2-9150-2a0b1fd6b413"
    },
    {
      "claim_cluster_id": "103c6b31-e860-4fde-bc3f-de3b1bf5f689",
      "event_cluster_id": "97495308-ae0e-47c9-bef2-8d438cbb6ff8"
    },
    {
      "claim_cluster_id": "17224e3f-1dd8-4970-a1c1-0cff20d6f438",
      "event_cluster_id": "c5a76ba5-1fa2-4615-9254-21b572adf7ac"
    },
    {
      "claim_cluster_id": "542e81d5-bf51-451b-bb6a-204f6c8da58e",
      "event_cluster_id": "f3c78c9b-df0c-4382-a6ec-56b924bce811"
    },
    {
      "claim_cluster_id": "8afc9e85-7241-4e3e-a1d2-c084e17d6f92",
      "event_cluster_id": "3d02db59-a52e-46b0-b009-3a6b28cebb78"
    },
    {
      "claim_cluster_id": "6926f592-0807-43c3-9eb1-74f903b009ff",
      "event_cluster_id": "0fa8aef0-deff-4ac5-a935-94011ed8be80"
    },
    {
      "claim_cluster_id": "18413d30-3282-4a19-9301-8b0c9a57c941",
      "event_cluster_id": "9d264f30-800f-42b2-9098-6bb3eb170aa6"
    },
    {
      "claim_cluster_id": "1e099dec-1be9-48be-a1bc-00d89e3cc02f",
      "event_cluster_id": "c56b515a-2e70-4a48-b4c2-0cbda45aaedc"
    },
    {
      "claim_cluster_id": "749a09bf-2f2a-4d19-aa9f-a22ffc94264d",
      "event_cluster_id": "40cf4646-a4df-4be7-91e4-7dd54f7d4c16"
    },
    {
      "claim_cluster_id": "fdae240e-8bc7-467c-b880-f3913e28e6ce",
      "event_cluster_id": "e1583824-5e05-4c29-84a3-b27afc099adb"
    },
    {
      "claim_cluster_id": "d8f02a31-c29f-429d-b5f0-720768af0f52",
      "event_cluster_id": "bdc29925-59ca-47f1-8fcb-329866ae2601"
    },
    {
      "claim_cluster_id": "984134b7-51eb-489d-965e-a939f985e06f",
      "event_cluster_id": "2779687f-bfe0-419a-be7d-20cd79002462"
    },
    {
      "claim_cluster_id": "a49a51da-aad1-43de-81b7-51f95b22eabd",
      "event_cluster_id": "626701fe-ae3d-403d-9681-7d335f03c82a"
    },
    {
      "claim_cluster_id": "cbb443ee-8a98-4074-9a33-690c1a4267b8",
      "event_cluster_id": "c0a9c99d-91fa-48ff-be0a-c6e00181d46d"
    },
    {
      "claim_cluster_id": "7ac1c88c-d620-4c32-9f9d-5a780231627e",
      "event_cluster_id": "e8a4287f-2df7-4875-81d6-e8b9ebf6b742"
    },
    {
      "claim_cluster_id": "dec098ce-5baa-400b-a766-6543ab0afe00",
      "event_cluster_id": "057662c4-0ac6-48b6-be90-a08641f47c88"
    },
    {
      "claim_cluster_id": "5b6da2ab-36ee-4cfe-968a-ce42565405bc",
      "event_cluster_id": "f7dce48b-908d-410d-ae3b-0711d8dd8a49"
    },
    {
      "claim_cluster_id": "7ae548ab-8f8f-4668-ba05-a2abf4b89759",
      "event_cluster_id": "073ce102-b579-45e6-8aa7-6f1ca6f82280"
    },
    {
      "claim_cluster_id": "6695efed-b1b5-4469-a01b-a370dfb9c522",
      "event_cluster_id": "f7e7bb5f-3a49-482d-a3f8-af78fa6ff5b6"
    },
    {
      "claim_cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
      "event_cluster_id": "be12c5b4-b051-4762-b77d-ca92a4063972"
    },
    {
      "claim_cluster_id": "4ac1da2e-cd03-4a11-b440-f62dc8f73aad",
      "event_cluster_id": "88fadd59-b242-4ad4-ab5b-3465e7a2b5a6"
    },
    {
      "claim_cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
      "event_cluster_id": "70862016-3977-4b4b-9e68-43859faa28ba"
    },
    {
      "claim_cluster_id": "29c942d6-0549-4857-889a-2fc5fd4cf362",
      "event_cluster_id": "b8a8bbf1-a819-445d-874a-5ea5546196e8"
    },
    {
      "claim_cluster_id": "804db45c-717d-4c1d-9494-73592da3dad8",
      "event_cluster_id": "0f09675b-050c-4631-816f-5157cd231924"
    },
    {
      "claim_cluster_id": "42d845ed-aaed-4d48-a0e4-2928cc3ba602",
      "event_cluster_id": "a8b93ec4-02b3-42be-92d5-d600d19a447b"
    },
    {
      "claim_cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "event_cluster_id": "91638e17-92b1-4187-b7cf-b00589f88898"
    },
    {
      "claim_cluster_id": "3ffaa02c-962d-45fa-a9aa-01f8e41dda01",
      "event_cluster_id": "b2a62820-6f02-4de4-99f3-aea0d67cd577"
    },
    {
      "claim_cluster_id": "7afb7680-3722-423f-b129-7076bfb88092",
      "event_cluster_id": "063191cf-9936-4d33-8783-201496475d0e"
    },
    {
      "claim_cluster_id": "5b52495b-d578-4d45-975c-d2e0417f4501",
      "event_cluster_id": "ec6a0d33-6433-4fbc-b666-83c9c378399c"
    },
    {
      "claim_cluster_id": "de17f70c-2147-4c34-a071-59d11378f1aa",
      "event_cluster_id": "590d0c11-1909-4486-98ca-6247b1d6bae0"
    },
    {
      "claim_cluster_id": "ed3519a5-2328-44c8-be3b-f36796b25965",
      "event_cluster_id": "9d8e9597-3167-4e1c-94bb-e686324d37e0"
    },
    {
      "claim_cluster_id": "b6fc681b-92ac-49a5-8881-3c1a5122bc59",
      "event_cluster_id": "c2fb9cb0-a6ae-4469-84e3-3b523125b6df"
    },
    {
      "claim_cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "event_cluster_id": "bb078c76-36ef-4176-a9f6-192717c4f2b4"
    },
    {
      "claim_cluster_id": "7811b1ac-b0e5-4c92-a933-500f6b892437",
      "event_cluster_id": "70431f34-7e7b-4551-b35b-94e41cfb3c9a"
    },
    {
      "claim_cluster_id": "bcc58315-e1c3-44d9-8dc7-b3967b315e01",
      "event_cluster_id": "010bfb3a-2b97-43f6-870c-f3dfb129b9df"
    },
    {
      "claim_cluster_id": "36824238-8532-447a-aacf-ef3f59e89c60",
      "event_cluster_id": "2950776a-25e4-4d62-bcaf-01e56ebd5b4c"
    },
    {
      "claim_cluster_id": "bcfd3520-6b2d-41d7-83ee-cfbd1d569332",
      "event_cluster_id": "ffb636ec-7472-41b4-ad69-f529b66bd46e"
    },
    {
      "claim_cluster_id": "6c511b67-edc9-413f-96b2-94d272eb11e9",
      "event_cluster_id": "1f7ec3f0-fe34-486a-a953-3da4c977430e"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "4ea6057d-751f-45d1-801b-72130ecef337"
    },
    {
      "claim_cluster_id": "e6867616-fb8f-44d6-8b92-f5cca8ca9e6a",
      "event_cluster_id": "a6a74d11-2c02-4502-9449-33d6b314f672"
    },
    {
      "claim_cluster_id": "289e5c59-c24f-465d-931a-b56b54bc982f",
      "event_cluster_id": "3f6ce9ce-e151-4a9d-92cd-88c52ef40373"
    },
    {
      "claim_cluster_id": "96b36beb-a890-402f-9101-7aa7236863f1",
      "event_cluster_id": "fd9d96be-26f0-47fc-a5ef-aa9e5e5ddf13"
    },
    {
      "claim_cluster_id": "c298484d-a7d5-4e80-ac66-217221dc6d85",
      "event_cluster_id": "771b0707-56ce-47d7-84ed-b75ab36dfd83"
    },
    {
      "claim_cluster_id": "30f8d995-4c8b-4d55-9cc0-91236f828d24",
      "event_cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"
    },
    {
      "claim_cluster_id": "6774f916-a691-4d45-86c4-69c41fab58e3",
      "event_cluster_id": "c586556e-d0fb-4b9e-b41e-3635da810071"
    },
    {
      "claim_cluster_id": "b0071c15-10b9-4a75-8b7f-486b9f2c04d1",
      "event_cluster_id": "d2d14fb6-adb8-486b-8eee-e966dd2e339b"
    },
    {
      "claim_cluster_id": "029b01a5-6f18-4a7f-96f8-6bde44853032",
      "event_cluster_id": "6ac5b48b-0333-47a6-8d5d-318886958930"
    },
    {
      "claim_cluster_id": "842a47a3-77bb-4a2a-909b-98bce731301b",
      "event_cluster_id": "7311a9b7-5d04-45ee-bfba-1bec0d5a0eda"
    },
    {
      "claim_cluster_id": "2e74796b-6aa0-4e1f-8a55-22887fa2ebdf",
      "event_cluster_id": "105a185e-0869-4f78-8bc2-ef2d7bd72e38"
    },
    {
      "claim_cluster_id": "de17f70c-2147-4c34-a071-59d11378f1aa",
      "event_cluster_id": "9e24e052-7c2e-4232-a3f6-f90915a205eb"
    },
    {
      "claim_cluster_id": "451cf0f3-38b6-4124-8f93-0e300d12c170",
      "event_cluster_id": "565785be-22aa-4015-82c3-a5551804b630"
    },
    {
      "claim_cluster_id": "098acc21-62ca-42b4-8206-4df179ae28c3",
      "event_cluster_id": "af868606-4265-4854-b859-dd107b996ff4"
    },
    {
      "claim_cluster_id": "7b76e5cb-748d-468e-9baa-d34773d5f24e",
      "event_cluster_id": "51078797-5492-4e49-abad-e30c5a796113"
    },
    {
      "claim_cluster_id": "c21b5cff-dd9b-418d-82f4-ad5049c002d9",
      "event_cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810"
    },
    {
      "claim_cluster_id": "4496a4b9-1070-44a0-89bc-e244c8a53dab",
      "event_cluster_id": "856b24f4-0a37-4fe1-9808-5b1d1715aafd"
    },
    {
      "claim_cluster_id": "d4dddb84-da14-4d5c-ac75-d999175b9558",
      "event_cluster_id": "8ef9691a-752f-475d-a3ef-753ff2032577"
    },
    {
      "claim_cluster_id": "3e1e4180-7726-4298-9f55-4348fcd7185f",
      "event_cluster_id": "c0b25dac-eed2-4056-a693-6719f5711bef"
    },
    {
      "claim_cluster_id": "a24c9e44-7dfe-4825-ab38-82d2ff8a84cc",
      "event_cluster_id": "3b497918-2e09-478b-9716-2fc578f66b62"
    },
    {
      "claim_cluster_id": "40860ef8-1ebc-45f7-84a0-735bcdaf070c",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "b2ec8ccd-aef2-476a-b259-768aae14f39e",
      "event_cluster_id": "c7fea8d2-cc9a-4113-be0c-ac48857e6432"
    },
    {
      "claim_cluster_id": "b65de138-2e69-44b3-acdb-00d152bc8245",
      "event_cluster_id": "35ae28c4-1a8d-4235-aadc-32d9b7b111fc"
    },
    {
      "claim_cluster_id": "8f97c05e-5860-4be0-8343-dc2050850d4f",
      "event_cluster_id": "907f966c-c5b8-4df2-817d-f2cfeeac3c35"
    },
    {
      "claim_cluster_id": "eeb1b170-89e2-4e28-b446-c1ba6d5ba1e3",
      "event_cluster_id": "9ce0798f-d0a5-4818-8a46-c633233caab5"
    },
    {
      "claim_cluster_id": "36d5c8e6-5870-44de-bee8-1ba3638e2785",
      "event_cluster_id": "528595cb-88e8-4fb8-9197-5baf87551c4a"
    },
    {
      "claim_cluster_id": "dce81269-fe31-49af-8310-17a573139956",
      "event_cluster_id": "d46a8e73-11be-40a1-8437-95dcedae232c"
    },
    {
      "claim_cluster_id": "a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4",
      "event_cluster_id": "c2e5bef0-900b-4168-ac2b-5a5465221f87"
    },
    {
      "claim_cluster_id": "e10dd96b-b6dd-4c6b-baa2-67b6eea4f84a",
      "event_cluster_id": "35f8d4db-40b2-4a70-ae12-49bc429a73a4"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "7f1f819a-52dd-40cc-92a1-28526195605d",
      "event_cluster_id": "0a129298-9d76-444c-8b1e-1ebbbe3bb953"
    },
    {
      "claim_cluster_id": "2a1de060-abb4-43d9-a91c-f13c074e7031",
      "event_cluster_id": "bfd2d9d2-8eb2-4ab0-b62a-1a71b069b6d5"
    },
    {
      "claim_cluster_id": "a5210919-ca86-4673-97e1-5b03ea7de143",
      "event_cluster_id": "38fab33e-077b-434b-814f-3bc3f8dfc415"
    },
    {
      "claim_cluster_id": "af3f95a3-d597-4371-bf7f-e4f5d91a9b73",
      "event_cluster_id": "88b53ede-d736-4ed2-9eb5-d53fe706d4c1"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "3c7779af-1e2b-432f-abfc-f807e51488c7"
    },
    {
      "claim_cluster_id": "342cdbac-7da2-46b3-80b3-a9b75e8fee10",
      "event_cluster_id": "1e2f3c33-51a9-4ade-8539-40a4bc9cfff8"
    },
    {
      "claim_cluster_id": "21c7b1a1-7d0b-407c-9669-93e385d68711",
      "event_cluster_id": "21b4b954-5140-43e2-bd9b-c8ab79b3e70c"
    },
    {
      "claim_cluster_id": "07b6bde9-eeca-4fea-b3c2-39093320ea05",
      "event_cluster_id": "d1f35128-46aa-4b3e-8942-ed03c647bdc7"
    },
    {
      "claim_cluster_id": "05e481b3-f988-4990-a833-5d6d33d27a4c",
      "event_cluster_id": "ec27a280-5ff0-4aa8-9204-fa364980dc9d"
    },
    {
      "claim_cluster_id": "9abd543e-88ed-4716-b3f4-c8fea9769bf2",
      "event_cluster_id": "b5f42c7a-e41e-420e-9b45-a7f2790588b6"
    },
    {
      "claim_cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
      "event_cluster_id": "cd8525ab-90a4-434a-bf10-f887240219f2"
    },
    {
      "claim_cluster_id": "2105abe4-014b-48d8-a8a2-6e113ac81f52",
      "event_cluster_id": "f3affcd0-acdc-481e-ad0d-c22c5984f9af"
    },
    {
      "claim_cluster_id": "3543d3e3-081b-448e-9ec9-915bf37d6255",
      "event_cluster_id": "aef65abc-e7b7-4946-9c22-4ac367aaff7e"
    },
    {
      "claim_cluster_id": "7924e4aa-9f0c-4bcf-8c0f-de382c8d6001",
      "event_cluster_id": "bc800212-afc6-410b-a69d-f8042afac330"
    },
    {
      "claim_cluster_id": "5995c9ca-98e0-418d-a93b-a662311da0c9",
      "event_cluster_id": "4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"
    },
    {
      "claim_cluster_id": "c8c0e353-5277-4897-8ef8-4773b9d6e6cb",
      "event_cluster_id": "127de610-39d3-4b48-be82-befef46aa586"
    },
    {
      "claim_cluster_id": "5d950548-da48-42e1-b748-275abdd34cfd",
      "event_cluster_id": "c06d1b4c-ebff-4c43-a158-e1cf96a68d7f"
    },
    {
      "claim_cluster_id": "d6d20ec3-ee81-4cbc-8cc9-9bd366cd24db",
      "event_cluster_id": "84708f88-fae9-4536-bd01-2d6209b5f616"
    },
    {
      "claim_cluster_id": "2fc8ee47-5c74-46a4-91ea-72f94f9e2c27",
      "event_cluster_id": "57d96007-f80d-4110-8583-3e280492b584"
    },
    {
      "claim_cluster_id": "d01db0e4-579b-46e1-b0a0-4bf5732646a8",
      "event_cluster_id": "ff420a7c-e6cc-45a2-bf06-8ce6ac712e7b"
    },
    {
      "claim_cluster_id": "6f847ace-00e0-4009-b5e9-3729f7a9e244",
      "event_cluster_id": "58559460-f665-4bbd-8f9e-95791e57f99a"
    },
    {
      "claim_cluster_id": "9abd543e-88ed-4716-b3f4-c8fea9769bf2",
      "event_cluster_id": "6ce0f5a3-c20c-456e-bcaf-26fa7ed36c33"
    },
    {
      "claim_cluster_id": "5d30cac5-2629-4bf5-9665-20ae87c1ec22",
      "event_cluster_id": "4a10d70f-5f46-496e-a6f4-0b982956d03f"
    },
    {
      "claim_cluster_id": "066ea292-674c-44ee-8c3c-799b0ecf024c",
      "event_cluster_id": "4cf9c43c-ceb0-4f7f-b2aa-9d4cf2879568"
    },
    {
      "claim_cluster_id": "03b72068-02c5-403e-b844-88e40b030a18",
      "event_cluster_id": "b7af27db-59d8-4e96-a280-4b5ae8db2302"
    },
    {
      "claim_cluster_id": "3afb5a7e-c2f9-4fc4-a379-b0fb650f805a",
      "event_cluster_id": "18554ac8-5c14-44ff-910f-06120f4b5680"
    },
    {
      "claim_cluster_id": "101b3e01-9e80-483b-82e6-39667fb77d18",
      "event_cluster_id": "5e399677-5a8b-4a09-a43c-cb9c2afa95dc"
    },
    {
      "claim_cluster_id": "03725096-887b-4dc0-a3ec-0bc1ce57eec9",
      "event_cluster_id": "dc6983ab-b551-4091-91c6-65ee2055cfd0"
    },
    {
      "claim_cluster_id": "ff70f7bd-e1b1-44ea-8b32-024f3d1917ed",
      "event_cluster_id": "29cdab10-c4fa-43e0-a980-d1342b8aa258"
    },
    {
      "claim_cluster_id": "5b34f4e8-867e-44ea-b5c2-c5295a09dd5e",
      "event_cluster_id": "8c5f95da-6a16-42a9-82d6-b9a5a0c0b94c"
    },
    {
      "claim_cluster_id": "f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1",
      "event_cluster_id": "301dd553-d836-4dc3-8b50-cd3953d38a18"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "61d63dd9-934f-4808-b6ab-ed734f2474b3",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "af183b48-72bf-4947-8e38-5272b737f76b",
      "event_cluster_id": "5ef9de99-de5e-4d31-bfda-1e87c2a63ead"
    },
    {
      "claim_cluster_id": "3c28af07-0879-4e0d-a892-8c0d97f3e49a",
      "event_cluster_id": "fa62d81f-956c-46dd-ab58-7fb08e1ad844"
    },
    {
      "claim_cluster_id": "590ca39d-bd4d-431b-829a-90d0f3384aa4",
      "event_cluster_id": "ac154c70-d6ce-41bc-949e-658cdd31e1f4"
    },
    {
      "claim_cluster_id": "9cf07839-b78b-4d19-aeee-e70ec12a23d1",
      "event_cluster_id": "d05aef6f-059f-4fa1-b456-946956a2ded5"
    },
    {
      "claim_cluster_id": "3b4d0d09-6630-4f48-897e-19fe1449086b",
      "event_cluster_id": "73900380-dcd7-40a9-bff7-af4dd25e907d"
    },
    {
      "claim_cluster_id": "4767808d-19a9-4e75-b8a7-7421cf37c72f",
      "event_cluster_id": "06ac8474-a3e8-472b-abca-69bac9927b06"
    },
    {
      "claim_cluster_id": "c6a49139-3f4b-48cf-8d38-e5b344108df3",
      "event_cluster_id": "9c02d7e0-91d2-4077-8adf-0916536016b1"
    },
    {
      "claim_cluster_id": "9ef9c32c-d40a-4d36-a3db-c01367d4c96e",
      "event_cluster_id": "edae4987-7374-49c7-bd0c-6f6522213435"
    },
    {
      "claim_cluster_id": "baef4ffa-45e6-4649-9ab7-8c1b3621d2d6",
      "event_cluster_id": "01d5ac9b-578e-460b-921d-2d1cc5ecad34"
    },
    {
      "claim_cluster_id": "13db6364-301c-4a4a-b13f-69262abf41bd",
      "event_cluster_id": "296c5f75-cf3a-4fd3-89db-486389767949"
    },
    {
      "claim_cluster_id": "2a0a6106-78d5-46ad-ad52-e0296bf7134a",
      "event_cluster_id": "57ce37d8-222f-4e0d-8fd8-04ee1ade37d4"
    },
    {
      "claim_cluster_id": "8f381ec8-c658-466c-973c-6cace2609d01",
      "event_cluster_id": "f7cbf601-ad96-47af-b877-ba63e1376028"
    },
    {
      "claim_cluster_id": "86e5843a-553f-41b4-aec2-73c2638e9bca",
      "event_cluster_id": "5e9b1d6e-d8db-47a3-b950-64ca3a804787"
    },
    {
      "claim_cluster_id": "43b3601d-6d6e-43a4-8cdc-72cf4aa80640",
      "event_cluster_id": "2160e916-6f22-443c-821e-3ddb5ec1cf74"
    },
    {
      "claim_cluster_id": "2f6021e2-bde5-4c10-ae2b-194bf6a93505",
      "event_cluster_id": "626e9a9b-6995-4100-8ffb-53ed10359203"
    },
    {
      "claim_cluster_id": "86cde8dd-df84-48da-a045-d001baaf3298",
      "event_cluster_id": "ce27cd6a-2828-4d90-a12f-a0a6f593b1e0"
    },
    {
      "claim_cluster_id": "d669c1ac-c710-4975-98db-1c778f28ee4c",
      "event_cluster_id": "57d96007-f80d-4110-8583-3e280492b584"
    },
    {
      "claim_cluster_id": "f9a4fce8-b5c8-4697-808a-9ac08e5be52f",
      "event_cluster_id": "0ba7abed-e798-4cd4-b041-3026081313b7"
    },
    {
      "claim_cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "event_cluster_id": "24b4e3df-c6d4-41de-8dc5-0dafe4754aeb"
    },
    {
      "claim_cluster_id": "0c63b123-d884-4e43-b541-3b36f23f2e96",
      "event_cluster_id": "79e93acb-9f08-48c2-9984-2e0654fbc884"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "a0b96ee6-2ea9-4035-b542-1107b0662e77",
      "event_cluster_id": "3bf8d65a-8c84-4411-baf2-c3a55c8118b8"
    },
    {
      "claim_cluster_id": "7123d027-fb9c-44c1-becb-087b98c76740",
      "event_cluster_id": "a087c689-de45-45b8-a8c3-f348c23872b5"
    },
    {
      "claim_cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
      "event_cluster_id": "6c375d59-160f-4719-ac36-a62607acccb1"
    },
    {
      "claim_cluster_id": "494d200b-d2e7-47ec-bdd7-86aef2459978",
      "event_cluster_id": "3cbece7e-7ff3-422e-bd74-b94ccde6f34a"
    },
    {
      "claim_cluster_id": "934665b5-3969-4817-9dd5-47b732fdd380",
      "event_cluster_id": "5d7bc6cf-96a0-42e0-b05d-1ff4cdfe4b5f"
    },
    {
      "claim_cluster_id": "8bbb9fde-a60f-4687-9398-276e5d036952",
      "event_cluster_id": "34aab7b4-5379-4f38-9914-ae9a14a7914c"
    },
    {
      "claim_cluster_id": "6ca40c20-bd2c-4fa0-af88-bbe3820f05e6",
      "event_cluster_id": "b2ea914d-85db-4a5c-9a1a-857c4092e4d3"
    },
    {
      "claim_cluster_id": "5238def0-ccfb-4f27-b836-f20f9b7dd70b",
      "event_cluster_id": "a9c08567-c779-4007-8ddb-2cc8e3429124"
    },
    {
      "claim_cluster_id": "e6759e4c-f697-49ce-a969-2f596e5c4293",
      "event_cluster_id": "83fa5a8b-b645-4ba9-9de1-a35b790ac1d5"
    },
    {
      "claim_cluster_id": "731adffa-9e59-4f19-8d10-ec191098b454",
      "event_cluster_id": "f213c95c-e709-4a66-94d2-6982e6415c05"
    },
    {
      "claim_cluster_id": "5ec8ba1f-609d-4689-8317-8045f6c09e77",
      "event_cluster_id": "52d598fd-9b16-4bac-b3f5-6b1dca718bc7"
    },
    {
      "claim_cluster_id": "c7d861d7-3b33-4585-89d3-87c9dcbcd126",
      "event_cluster_id": "3bbdb582-a477-4388-acb7-cf6123d0c022"
    },
    {
      "claim_cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
      "event_cluster_id": "edae4987-7374-49c7-bd0c-6f6522213435"
    },
    {
      "claim_cluster_id": "74f7c7d8-aba9-45e9-a386-fbb258dd884d",
      "event_cluster_id": "3b1f4f0d-8cab-47e8-8ee7-7eb215e3b909"
    },
    {
      "claim_cluster_id": "59d689c2-02ce-4e0f-83b7-9747d98bb8fb",
      "event_cluster_id": "06451ed7-032d-45e3-9726-f485fc31a739"
    },
    {
      "claim_cluster_id": "38841999-14cb-43f3-a2d5-27d9791973f6",
      "event_cluster_id": "683abff9-679b-4270-b05d-4394a56a60b4"
    },
    {
      "claim_cluster_id": "7fc9b449-7f4e-4cec-90a6-b1dab2836291",
      "event_cluster_id": "c466ec99-62a0-4318-a23d-1522e69e1a70"
    },
    {
      "claim_cluster_id": "19b19cf8-a65c-454e-84bf-36d3044b6f73",
      "event_cluster_id": "5dffba17-ccea-4d19-b8a2-e0d2197c568d"
    },
    {
      "claim_cluster_id": "a0f8e5d7-b3ae-4af7-8eb1-d7fefd231acc",
      "event_cluster_id": "25720bbc-2dcb-4fd3-bfdd-8ac413567afc"
    },
    {
      "claim_cluster_id": "958b1512-4a3e-4d41-927e-a3072dd9e9ef",
      "event_cluster_id": "fa62d81f-956c-46dd-ab58-7fb08e1ad844"
    },
    {
      "claim_cluster_id": "21eacc7c-c9da-4edc-ac35-3ab550e3b7af",
      "event_cluster_id": "4807cbce-9aad-467f-86b6-35d202d1cb91"
    },
    {
      "claim_cluster_id": "2b897077-ab7f-4c6d-8c0e-a3493d4e615a",
      "event_cluster_id": "6e4775e9-09cc-45e6-927b-26fd1460b8e8"
    },
    {
      "claim_cluster_id": "97037755-caf6-49ed-8d7a-bb7c0d42bf8c",
      "event_cluster_id": "70d7ea19-ed43-41ec-a695-147f9057dd3c"
    },
    {
      "claim_cluster_id": "b6ac4f42-6e4c-4395-a71a-c8beca5b5336",
      "event_cluster_id": "96b17898-9707-4c42-8d78-5b035c3e7377"
    },
    {
      "claim_cluster_id": "67c03f1c-cee9-4493-b4e6-4ff1b7971966",
      "event_cluster_id": "c7d55c3d-c95e-4814-b774-3a8773d025eb"
    },
    {
      "claim_cluster_id": "7b68c402-465e-4abb-ac74-c3e397c8afdd",
      "event_cluster_id": "8cc0b8bd-92ac-4909-9ef3-f1df52b9f0f4"
    },
    {
      "claim_cluster_id": "1f1f405f-6b99-4de2-b4fa-1bd105b3c577",
      "event_cluster_id": "ad80cb2a-c356-4006-9574-67d0198ed537"
    },
    {
      "claim_cluster_id": "f4f83538-936e-4149-94c2-66b6b2ac2571",
      "event_cluster_id": "45ef4556-631b-4297-8b2a-7cad68f3b517"
    },
    {
      "claim_cluster_id": "a63004c7-9e1f-4600-bae4-f70655f0094e",
      "event_cluster_id": "5a784d1e-f3a9-480f-aa31-7625b9b944ce"
    },
    {
      "claim_cluster_id": "af144d2c-f8aa-40f2-9250-f41cd71f8fd9",
      "event_cluster_id": "dbf3b7bb-6fb1-4da2-9ead-1fea65aeaf76"
    },
    {
      "claim_cluster_id": "20c941a8-b922-48e3-8e56-e49e1a524fd9",
      "event_cluster_id": "5a4fc98d-9bb2-48e0-88c4-2decb355b92d"
    },
    {
      "claim_cluster_id": "b473cdd9-7369-4866-a926-04d86eb03c52",
      "event_cluster_id": "fcbaa14c-dec6-413c-9e80-6e8b3b617340"
    },
    {
      "claim_cluster_id": "daf0b3a1-53f1-4b47-955e-785030ee3839",
      "event_cluster_id": "87ccb180-4860-4e8d-af6f-a3acda89b6bf"
    },
    {
      "claim_cluster_id": "b3b1fd7c-7ffb-411d-b821-50b6108ebae7",
      "event_cluster_id": "a4d467e0-6666-461c-8177-8b0173dc05e3"
    },
    {
      "claim_cluster_id": "ef49913c-d983-49cf-b90f-4529857c36a4",
      "event_cluster_id": "cf6c1c0d-fc13-4eb6-a686-91e7d8509399"
    },
    {
      "claim_cluster_id": "d71b34b2-fb3e-4ce8-8b20-4e5bd486e9ce",
      "event_cluster_id": "35df1ff6-45be-4230-aba5-19c41bc2020b"
    },
    {
      "claim_cluster_id": "a1f0e0be-a8bf-4895-ad2d-4f83a0d63930",
      "event_cluster_id": "3ba005de-dec0-4cc4-8a3c-a3679d6f072a"
    },
    {
      "claim_cluster_id": "dde390b5-1a05-447f-86aa-a25992be6bfd",
      "event_cluster_id": "192193af-777f-4b45-a866-b58926d838df"
    },
    {
      "claim_cluster_id": "6695efed-b1b5-4469-a01b-a370dfb9c522",
      "event_cluster_id": "57d96007-f80d-4110-8583-3e280492b584"
    },
    {
      "claim_cluster_id": "99d9484d-46ae-4ca2-98a1-dd3e0aeee99d",
      "event_cluster_id": "192193af-777f-4b45-a866-b58926d838df"
    },
    {
      "claim_cluster_id": "16e38b6b-7241-4f9f-8554-c33f05a6edb7",
      "event_cluster_id": "39e17317-299b-4c70-bf27-b813fd6d3c5f"
    },
    {
      "claim_cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
      "event_cluster_id": "bb551e75-48fa-42c3-a108-cb4b1462b529"
    },
    {
      "claim_cluster_id": "f5514b1c-3b40-41b8-9290-039c2c94a3e7",
      "event_cluster_id": "545b9a1d-6aef-4146-8dab-6da3637008a3"
    },
    {
      "claim_cluster_id": "4150f7a8-fd61-465a-8315-84a5d8cef80e",
      "event_cluster_id": "d784ccaf-4509-4d9d-9ebf-0ffc15008e18"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0"
    },
    {
      "claim_cluster_id": "a6ed0ce8-662a-4b6a-bb37-1ea2a020377f",
      "event_cluster_id": "5d300e72-624c-4bf7-b8e9-c1b1c8bb5c1b"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "c754fcc4-5c32-4f8a-ac01-348838a5d407"
    },
    {
      "claim_cluster_id": "8cb34140-24ef-4173-9390-c1f84800160e",
      "event_cluster_id": "0912e80e-4475-48b0-94ea-99b244b18e7f"
    },
    {
      "claim_cluster_id": "bc0539c0-9358-42cb-bbfb-8c0b934c5e86",
      "event_cluster_id": "dc2c7323-e1d7-4179-aef0-ca2fc7077801"
    },
    {
      "claim_cluster_id": "7b68c402-465e-4abb-ac74-c3e397c8afdd",
      "event_cluster_id": "b07f3d2b-07c7-4378-8e98-619949a67d5a"
    },
    {
      "claim_cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "event_cluster_id": "4d4b5f03-b89d-479d-93c3-2c3c9a038d46"
    },
    {
      "claim_cluster_id": "4afb1f4b-4686-4338-bf49-bdd4d2091f0a",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "99df608a-defa-4cea-b8ef-86519fa0e08a",
      "event_cluster_id": "91b36e51-3bed-4937-9f60-9c0f824e451a"
    },
    {
      "claim_cluster_id": "6ca40c20-bd2c-4fa0-af88-bbe3820f05e6",
      "event_cluster_id": "0a3dfd8d-a3b5-4c2f-8fe0-7e8a2061b362"
    },
    {
      "claim_cluster_id": "24f6a0c0-6612-4488-bc48-40d12340ab22",
      "event_cluster_id": "a7b8df05-a36b-47bb-9f07-210a97d31443"
    },
    {
      "claim_cluster_id": "b9ef5935-c3ff-439a-95ae-5e53367b92ef",
      "event_cluster_id": "b33db570-415f-43c3-b381-72179faa3148"
    },
    {
      "claim_cluster_id": "88d87950-d2a5-4729-bb7a-8215d26b8898",
      "event_cluster_id": "8ef9df10-1de8-4f15-a1e9-2d90b8ed31e8"
    },
    {
      "claim_cluster_id": "61c8550e-839e-4f39-803d-72ebbfa747a7",
      "event_cluster_id": "1044d7cc-fb67-48c7-a61d-abf5c9d0ee2c"
    },
    {
      "claim_cluster_id": "6e43ff1d-8cc2-4d06-859d-7e968536001b",
      "event_cluster_id": "052da5ce-3d09-4c7e-bec6-952cf04794b4"
    },
    {
      "claim_cluster_id": "5881fb7d-2030-4406-a7ba-0a95befea17e",
      "event_cluster_id": "2ff5a9aa-c10f-4f8d-a47a-0ec077d3ef51"
    },
    {
      "claim_cluster_id": "00e6b319-ea09-4ee6-8be1-7f243156f545",
      "event_cluster_id": "cffc59b0-977d-47ae-8b01-886477ecbcba"
    },
    {
      "claim_cluster_id": "04c0a28d-e066-4279-bfee-f4757f197d7a",
      "event_cluster_id": "7690b51f-82d1-4577-be9d-58b4d7bf11b2"
    },
    {
      "claim_cluster_id": "860407b5-0931-4ba2-9dbd-a0078e94e9c6",
      "event_cluster_id": "5c9296c9-7461-4417-aa55-8ba44cdddfec"
    },
    {
      "claim_cluster_id": "7dc48717-c562-4f7c-bcb3-b4a13374cc42",
      "event_cluster_id": "82364b1e-49e1-409c-a0f8-eccc7c05ab76"
    },
    {
      "claim_cluster_id": "f15167ff-a614-4854-ae28-529950f00bdc",
      "event_cluster_id": "f7a6ba19-2cf9-487a-a498-908208872dae"
    },
    {
      "claim_cluster_id": "2267c878-b6b0-4036-b4c7-3e3fec5d0865",
      "event_cluster_id": "5261c3b8-e566-4b27-8dcc-7c47abcca2e2"
    },
    {
      "claim_cluster_id": "a536505f-e31a-400e-a4a5-1f74a9e29e7d",
      "event_cluster_id": "0817085e-1f3f-40ef-a848-4b066c225ffe"
    },
    {
      "claim_cluster_id": "a999634d-6816-4a9d-9bf2-efbbb6f6917e",
      "event_cluster_id": "94834f96-c25c-4f04-80b8-c75b05787e8f"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993"
    },
    {
      "claim_cluster_id": "3a7c04bf-2c54-4817-990d-55771d584811",
      "event_cluster_id": "cf47a2c1-26a3-4471-9b1c-8c8f4c68cc10"
    },
    {
      "claim_cluster_id": "850a1f31-fc4f-4578-baa4-da3b7a35e30a",
      "event_cluster_id": "7a9ab53b-bafd-4621-b334-948c7482958f"
    },
    {
      "claim_cluster_id": "11d45e31-1956-49e2-b94c-bc4a176c09fc",
      "event_cluster_id": "261352e0-2751-4f21-88a5-03538b2fd63d"
    },
    {
      "claim_cluster_id": "d5fdaeff-23a7-415f-9e7b-758f603e5d4a",
      "event_cluster_id": "2a9b1bd4-3cd7-481b-8cb7-5d5856650a4b"
    },
    {
      "claim_cluster_id": "0c63b123-d884-4e43-b541-3b36f23f2e96",
      "event_cluster_id": "db101c75-2320-4597-b222-b7197dc49dc4"
    },
    {
      "claim_cluster_id": "2f4a7179-3f3f-4eb6-8891-8b8d39467620",
      "event_cluster_id": "2d90579b-afff-4e63-bf7e-880641d4be4a"
    },
    {
      "claim_cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
      "event_cluster_id": "344dd5f7-3435-46c3-9f5a-4bd9bd357bed"
    },
    {
      "claim_cluster_id": "e31510b5-776d-40cf-9a10-afb0bb1a3f0b",
      "event_cluster_id": "c74997a7-7974-4e4a-80ee-0cf8f0af8af6"
    },
    {
      "claim_cluster_id": "9fc7edf3-7209-4828-92b3-8d6dafded201",
      "event_cluster_id": "0630fbfc-9793-4e8b-bd28-898778d452da"
    },
    {
      "claim_cluster_id": "c18b334a-f61f-4400-b355-cea2e7375866",
      "event_cluster_id": "4a540701-996b-469b-acc0-9cc53e451ce9"
    },
    {
      "claim_cluster_id": "601320a2-3fca-41ef-9387-a64a4c0b5cee",
      "event_cluster_id": "b996a367-b4a5-4361-bd3d-e0e97f9ed9ca"
    },
    {
      "claim_cluster_id": "0634cfd7-f7f7-48cb-bb92-7dc813e3271c",
      "event_cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87"
    },
    {
      "claim_cluster_id": "3b1a4f1c-eb8e-4934-89a0-1d405c7425e6",
      "event_cluster_id": "15d67b19-b1ca-45ea-8cf1-55236390c45d"
    },
    {
      "claim_cluster_id": "170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c",
      "event_cluster_id": "ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"
    },
    {
      "claim_cluster_id": "6950bc54-67bb-4e8e-b8cd-afd5c7d79d00",
      "event_cluster_id": "06451ed7-032d-45e3-9726-f485fc31a739"
    },
    {
      "claim_cluster_id": "b3de51b2-92ca-4cb1-b45e-50a0188ca28f",
      "event_cluster_id": "cab4447a-5d42-4fe2-b9b3-fc86f17d0ac9"
    },
    {
      "claim_cluster_id": "6d2792d9-4dcf-4980-9870-d295c7f8e2c0",
      "event_cluster_id": "5f9c8cb9-e871-4d7e-8b36-9e411bdc35a8"
    },
    {
      "claim_cluster_id": "268e1143-4495-4247-af6b-b6f6f368f74f",
      "event_cluster_id": "8e9141e0-2f9d-4d0a-920e-7ed046dbbcec"
    },
    {
      "claim_cluster_id": "41683dea-1259-4e44-9283-e6286d675c48",
      "event_cluster_id": "d8eb0da9-3210-4817-8cfc-d7a7f474f829"
    },
    {
      "claim_cluster_id": "81238869-957b-4b83-948f-2551b38a7039",
      "event_cluster_id": "7be54807-07de-4ad8-80e9-963285c4b2c3"
    },
    {
      "claim_cluster_id": "7938e6ef-80ff-4f50-b301-1e5bfc0774b3",
      "event_cluster_id": "0a7440da-026d-4b9e-86ae-aae908cc485e"
    },
    {
      "claim_cluster_id": "a0c8c3de-8102-4a9b-b20a-80ade6132b4e",
      "event_cluster_id": "6c2926f3-1ce9-4f60-a8e9-724e2273274d"
    },
    {
      "claim_cluster_id": "da2845de-4e1b-492a-a6b0-06fd4584650e",
      "event_cluster_id": "d6b75ab4-918c-47fe-8efd-91ea4be62261"
    },
    {
      "claim_cluster_id": "1991b6cd-3baa-475c-add7-d4b101a0de09",
      "event_cluster_id": "e17360aa-cb4e-4e41-913f-f3e853c44fd4"
    },
    {
      "claim_cluster_id": "36d5c8e6-5870-44de-bee8-1ba3638e2785",
      "event_cluster_id": "e56fc955-148f-4ab7-9982-126189917297"
    },
    {
      "claim_cluster_id": "3cb553c8-9eb0-4dfe-8f4d-e85a8933799b",
      "event_cluster_id": "a2fa0436-7d09-4549-9e78-5e411d846fe6"
    },
    {
      "claim_cluster_id": "152e2cd2-1d15-4787-b90e-76e34ac56ace",
      "event_cluster_id": "07bac613-553a-4b5a-8942-deafd7506573"
    },
    {
      "claim_cluster_id": "71b86c5b-0ae0-46d5-a172-4da94679db3d",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "83412f4d-d0e2-456a-853f-c0ab5d6c2ff1",
      "event_cluster_id": "d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"
    },
    {
      "claim_cluster_id": "c474ebeb-fd96-4c94-8aa4-35666d0af3d1",
      "event_cluster_id": "ed5d05a0-5035-40ad-a517-d570266b42b4"
    },
    {
      "claim_cluster_id": "ecc32ba8-bd1c-43c6-8192-e0502c1f14b7",
      "event_cluster_id": "4a7affe3-fd43-41f4-8713-3066830d90f8"
    },
    {
      "claim_cluster_id": "62d8fa29-aaab-4f66-9532-5fb34686e56f",
      "event_cluster_id": "8979de81-d14e-4323-ad09-17f46a1f718d"
    },
    {
      "claim_cluster_id": "5f5fe60b-6bf8-4f80-be3b-0dcf885c1171",
      "event_cluster_id": "a9c08567-c779-4007-8ddb-2cc8e3429124"
    },
    {
      "claim_cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "9f0480ce-b886-46fa-98f0-af8144766c6c",
      "event_cluster_id": "f28068f5-d9fe-4cd5-a458-304fc4db522c"
    },
    {
      "claim_cluster_id": "0f1cacf9-3df0-4d00-8952-b3fa5195f1fb",
      "event_cluster_id": "45236940-0b07-401a-92bf-42c8f73cf80a"
    },
    {
      "claim_cluster_id": "c267714a-b024-42fa-a678-5343e8a65754",
      "event_cluster_id": "a6f8ca4a-31cf-437f-a2eb-06ee3b0285bd"
    },
    {
      "claim_cluster_id": "e10dd96b-b6dd-4c6b-baa2-67b6eea4f84a",
      "event_cluster_id": "4a203e5c-111c-4719-91b2-5d364d288743"
    },
    {
      "claim_cluster_id": "424a981a-fddf-4933-92b1-158cbba9a861",
      "event_cluster_id": "f6b81252-d691-43eb-b603-bbd2ec2ea3c1"
    },
    {
      "claim_cluster_id": "30011e47-1ff9-409e-8099-2eff6ab89e88",
      "event_cluster_id": "2a871f4b-957a-43ae-bf82-09ab2ac57891"
    },
    {
      "claim_cluster_id": "342cdbac-7da2-46b3-80b3-a9b75e8fee10",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "f6a4aea6-92b4-4a70-a984-2326df1ee39e",
      "event_cluster_id": "a362e63a-9f1e-4605-b063-7172229b335a"
    },
    {
      "claim_cluster_id": "3444a924-096b-4eda-877c-4c6412d885cd",
      "event_cluster_id": "054ed505-3504-4e27-9979-055c536c39eb"
    },
    {
      "claim_cluster_id": "6768580d-67cd-4040-b98a-9d8276f6f0bd",
      "event_cluster_id": "42663758-9518-49e1-a45d-11b8ad2a2193"
    },
    {
      "claim_cluster_id": "11d45e31-1956-49e2-b94c-bc4a176c09fc",
      "event_cluster_id": "006e6ccb-eaf9-4a24-8ea9-fbee9be7d468"
    },
    {
      "claim_cluster_id": "36d5c8e6-5870-44de-bee8-1ba3638e2785",
      "event_cluster_id": "4d3fc72a-c96e-4659-afda-27c7ce47c497"
    },
    {
      "claim_cluster_id": "81174c72-fc84-4203-8dcb-b1068c7bd254",
      "event_cluster_id": "4c83d9ff-1e62-4a28-b3d2-a667fb4041d7"
    },
    {
      "claim_cluster_id": "6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5",
      "event_cluster_id": "d7adae26-7c5e-4cae-86db-8ddd899b1a73"
    },
    {
      "claim_cluster_id": "46e0dd28-4bd8-4986-88e7-a2e53ab8f4b8",
      "event_cluster_id": "60f1f675-db08-4cfb-a9e3-20e14baf899f"
    },
    {
      "claim_cluster_id": "10e97fc5-5fa6-457f-aefb-257e90e8124b",
      "event_cluster_id": "dabb30c4-8940-4d2a-81d7-5e54195fcdf5"
    },
    {
      "claim_cluster_id": "97f84153-8f49-432f-a8f7-a4e57fe7f769",
      "event_cluster_id": "389db9cc-996b-4a34-8f9a-361c5c8aa5ee"
    },
    {
      "claim_cluster_id": "86e16ba9-dba8-4cea-a0d4-df8a8a69d565",
      "event_cluster_id": "7e64d534-c786-4ebd-b549-3314cdd361e4"
    },
    {
      "claim_cluster_id": "e8ac4064-b696-4a9d-9c57-bc79d628e859",
      "event_cluster_id": "ead9bd7e-2c4b-46c5-b951-360707780eb3"
    },
    {
      "claim_cluster_id": "9560d5ee-30e3-4941-88b8-e0b5144961cb",
      "event_cluster_id": "f43f98cd-cb16-421c-a639-6c526509bfd7"
    },
    {
      "claim_cluster_id": "8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "c572351c-d373-4e8c-a918-68e53e31b822",
      "event_cluster_id": "81814091-7bc5-423c-85bb-9238ad6a9cae"
    },
    {
      "claim_cluster_id": "7e979f93-4ad2-4933-833d-edddb9f37e0b",
      "event_cluster_id": "ba2e6df3-366f-4f05-b8ae-0693e1f8cec0"
    },
    {
      "claim_cluster_id": "df895ffb-5333-4b2a-9ce5-f1108a894c34",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "7e979f93-4ad2-4933-833d-edddb9f37e0b",
      "event_cluster_id": "e9486241-9c2f-4d3e-8704-e3be044f2405"
    },
    {
      "claim_cluster_id": "67bef4c5-afcc-4a65-9538-ce302f965385",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "6e7164cb-9f1b-4f72-aef4-13243fbf321c",
      "event_cluster_id": "8c3d66ea-c0e3-4dbc-a773-e3cdcd8c311c"
    },
    {
      "claim_cluster_id": "a49a51da-aad1-43de-81b7-51f95b22eabd",
      "event_cluster_id": "0dcdf569-6e39-4d48-a8aa-2b6e3c34a3d5"
    },
    {
      "claim_cluster_id": "3ffaa02c-962d-45fa-a9aa-01f8e41dda01",
      "event_cluster_id": "23f623bb-83de-47ba-a19b-9df053aaf2d2"
    },
    {
      "claim_cluster_id": "af562818-5594-417a-b606-add10573c2db",
      "event_cluster_id": "3a31904f-9e32-44e5-89a1-822aa5467c6f"
    },
    {
      "claim_cluster_id": "041cf2cd-18d4-495c-8ae7-5b69605020ea",
      "event_cluster_id": "976266ce-5c9b-4a82-9062-52ac4f4dcbd6"
    },
    {
      "claim_cluster_id": "199242cb-5b3e-40d9-bf38-e1eddcf574fc",
      "event_cluster_id": "eac2d3f5-7d2a-4cfa-b17e-cac48f4a7268"
    },
    {
      "claim_cluster_id": "16e980af-79a1-4255-8ad0-56ca61ae3b8a",
      "event_cluster_id": "57ad4e9d-2e3b-4f99-a5b5-f89a9fbe7c81"
    },
    {
      "claim_cluster_id": "c6f7c193-f407-447c-a10f-3ea5292ea3e8",
      "event_cluster_id": "3a13abc2-f39c-460b-8768-7ccf1b11b40f"
    },
    {
      "claim_cluster_id": "3239dc2e-a961-4aab-990b-768c092064f8",
      "event_cluster_id": "4b3edb14-747e-4c77-8e76-8b7c1d8c4155"
    },
    {
      "claim_cluster_id": "30bb9166-b600-41f8-a7cf-3befaaa1bcc2",
      "event_cluster_id": "20999f16-0335-45ee-a0fa-171f40827993"
    },
    {
      "claim_cluster_id": "b0f153c6-cc18-4aee-9b69-e8f06c8e3149",
      "event_cluster_id": "e3df2907-4da7-4352-a8ae-dd0543915bd1"
    },
    {
      "claim_cluster_id": "96423d41-ee08-4c5e-bcf0-4dd1b431abc6",
      "event_cluster_id": "1ff366e5-31ba-464c-8544-3d84f99a75c6"
    },
    {
      "claim_cluster_id": "971c6a1a-3e95-4838-8131-b05eb89d55b7",
      "event_cluster_id": "030691e7-b00a-48bd-99cd-b8a82a2565cc"
    },
    {
      "claim_cluster_id": "3e5167ea-d839-4cc5-b193-fda2f9c0b53b",
      "event_cluster_id": "f16b94fa-630f-4218-860c-391c021de7f5"
    },
    {
      "claim_cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
      "event_cluster_id": "36641d64-6f2c-4f28-a210-946f0a644597"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "16e38b6b-7241-4f9f-8554-c33f05a6edb7",
      "event_cluster_id": "e64379e3-7714-4ce4-9ee9-585f6bf488c8"
    },
    {
      "claim_cluster_id": "d01db0e4-579b-46e1-b0a0-4bf5732646a8",
      "event_cluster_id": "f7e1186b-2980-41a7-bab5-cf7ae1ee1caf"
    },
    {
      "claim_cluster_id": "563cdc28-d88f-4781-9ab9-27eadd46ba73",
      "event_cluster_id": "532b749b-85ba-48db-930c-9199fbff3bbe"
    },
    {
      "claim_cluster_id": "a38268fe-ba89-4d63-8481-63c080523a0a",
      "event_cluster_id": "fd231a27-03e0-4839-bed2-513e10b79733"
    },
    {
      "claim_cluster_id": "ea149597-1daf-4627-8587-59eb8a6bde8b",
      "event_cluster_id": "2fc3625d-65ed-4d3b-9894-40d3d2d23ece"
    },
    {
      "claim_cluster_id": "55c660bf-50f6-447e-81a1-ddecdab998ee",
      "event_cluster_id": "490d433f-ce3e-4f27-9543-e9681e6eafc7"
    },
    {
      "claim_cluster_id": "199242cb-5b3e-40d9-bf38-e1eddcf574fc",
      "event_cluster_id": "1f539237-1caf-4525-9adc-af33bb645e44"
    },
    {
      "claim_cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
      "event_cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993"
    },
    {
      "claim_cluster_id": "97f84153-8f49-432f-a8f7-a4e57fe7f769",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "11210f68-2915-41ff-b25a-a55a575f9528",
      "event_cluster_id": "8e3409aa-fad3-40ba-9376-e395c709886e"
    },
    {
      "claim_cluster_id": "a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0",
      "event_cluster_id": "f24d06ae-13b1-4550-a06c-444a9041ab60"
    },
    {
      "claim_cluster_id": "27097c65-59e7-4824-9bbb-c0736b2c9f70",
      "event_cluster_id": "b9804a77-392b-4042-a24f-eda229eba1c8"
    },
    {
      "claim_cluster_id": "32a2eefa-c8c7-482c-839f-be3b15138d40",
      "event_cluster_id": "75649ebd-9ea4-425f-b0b4-b2dc8db1c23c"
    },
    {
      "claim_cluster_id": "199eabc9-e7b3-44cb-a574-bbc02ea956e5",
      "event_cluster_id": "7b54b660-7b67-4765-8335-f1bb9a8cf70a"
    },
    {
      "claim_cluster_id": "b6f111d6-8112-47dc-baeb-43c77c6392ea",
      "event_cluster_id": "afd94974-8e6c-4eb8-a657-4ac5f64e9000"
    },
    {
      "claim_cluster_id": "2f8d9d1d-f145-459e-90bd-ebf833c6fe60",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "6b5b4849-041c-4f1f-a05e-cd4913045e8f",
      "event_cluster_id": "ceeb5cde-733b-478e-9e0a-21930e3f91cd"
    },
    {
      "claim_cluster_id": "1dc1ea0e-ecc0-4a99-a555-3574b46d8688",
      "event_cluster_id": "e8c08050-8918-4c52-bcd3-c5994c5cd40a"
    },
    {
      "claim_cluster_id": "68d51d93-fcbe-411f-8a89-cb79bd347512",
      "event_cluster_id": "98c1c320-efc0-41d6-bc35-eaf849b7cea7"
    },
    {
      "claim_cluster_id": "8d676e91-6fd3-47df-8a59-7b88ff3f09cc",
      "event_cluster_id": "baf69b75-285e-4447-b574-0c5bce010190"
    },
    {
      "claim_cluster_id": "f6f15ea6-27bd-499b-a6fe-74d144b5ac0b",
      "event_cluster_id": "d436d0a6-3e58-4bd3-a6ad-0b596176235b"
    },
    {
      "claim_cluster_id": "36824238-8532-447a-aacf-ef3f59e89c60",
      "event_cluster_id": "f69599a7-433a-4819-a4c2-cea569bc6b06"
    },
    {
      "claim_cluster_id": "8870837d-d287-47f9-8134-1fe8a8f59e88",
      "event_cluster_id": "e17360aa-cb4e-4e41-913f-f3e853c44fd4"
    },
    {
      "claim_cluster_id": "4eb89d26-0914-45a8-8a2e-98708f9a3315",
      "event_cluster_id": "04fe8e71-8c72-481f-a6cf-1722df9454dc"
    },
    {
      "claim_cluster_id": "9c8e3c4f-c6aa-493f-ae68-b49b723b4cde",
      "event_cluster_id": "7c8be876-c0d6-46b2-8e28-be16ba79de4f"
    },
    {
      "claim_cluster_id": "847accaf-332c-4ec2-bd26-cd592d1fa2fc",
      "event_cluster_id": "6324da02-c8ae-4e7d-b1eb-1091e19c88ba"
    },
    {
      "claim_cluster_id": "c21b5cff-dd9b-418d-82f4-ad5049c002d9",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "452c2457-4da2-4edb-a49f-86f139410e4f",
      "event_cluster_id": "b01fa043-31ff-48da-8746-ca50ad89a48a"
    },
    {
      "claim_cluster_id": "da5651eb-e7b2-446c-9fdb-dc89d46a36a7",
      "event_cluster_id": "6e62e8fc-d0f2-48d9-952d-5f14837f0f03"
    },
    {
      "claim_cluster_id": "42139453-8011-41e0-af88-1b45a4865158",
      "event_cluster_id": "d8d70374-6442-49f6-9ba4-aa78644e8a39"
    },
    {
      "claim_cluster_id": "68ff85cf-74e5-4234-a53f-6dba1aacb444",
      "event_cluster_id": "0893d96a-c001-4046-ba27-939b9e1f52d5"
    },
    {
      "claim_cluster_id": "e490aee1-21a0-4624-906c-8f2d51f040e5",
      "event_cluster_id": "d855e2c8-0fb0-4813-99e3-3fa003818f71"
    },
    {
      "claim_cluster_id": "aafcc6bc-c8f9-4a4c-acf7-9628f64db648",
      "event_cluster_id": "f7143daf-c280-489f-9b7a-be507d7d1e7d"
    },
    {
      "claim_cluster_id": "731adffa-9e59-4f19-8d10-ec191098b454",
      "event_cluster_id": "6936f63c-d90c-47ad-bcda-def68b0ec222"
    },
    {
      "claim_cluster_id": "d61fc1c9-1533-4eaf-88f3-8d0340ce2de0",
      "event_cluster_id": "281bccd6-4eea-4bfc-b9dd-b2e9300159fb"
    },
    {
      "claim_cluster_id": "cf6e572b-b045-42a6-b196-8d36d7693937",
      "event_cluster_id": "93849a08-743b-4023-9ccb-ce323519297f"
    },
    {
      "claim_cluster_id": "859c814e-e7af-4708-a58a-9f1f6973974f",
      "event_cluster_id": "1f7a4f93-ef7c-471e-9da0-10305825de04"
    },
    {
      "claim_cluster_id": "623ab1ae-1f19-46fc-b19b-929f64c7b525",
      "event_cluster_id": "a8758a01-da2e-4199-8bb4-bdf40b9dd8e6"
    },
    {
      "claim_cluster_id": "c5855521-5ebf-478e-a7af-b3f07554a912",
      "event_cluster_id": "e4596864-8ee7-4544-832b-f1063fa0c90c"
    },
    {
      "claim_cluster_id": "d8b92399-bf69-4b82-b461-678acbb7e385",
      "event_cluster_id": "d622193d-1629-4f0f-a5cd-b9751e388901"
    },
    {
      "claim_cluster_id": "fc45a344-4cfc-4865-9030-d033f0c8dff3",
      "event_cluster_id": "028c0dd0-ac64-47ea-94f9-5c74b9d66731"
    },
    {
      "claim_cluster_id": "f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1",
      "event_cluster_id": "ff2acca4-5f30-4167-8a23-b96f532a3929"
    },
    {
      "claim_cluster_id": "23af5a3d-cb29-4974-bd99-35e9d9b06fde",
      "event_cluster_id": "82cece60-3255-4d43-a228-e34efd18c27a"
    },
    {
      "claim_cluster_id": "9f76cab0-c9b8-4e12-bd91-cd1c5474c649",
      "event_cluster_id": "1c08ccb0-286c-49ff-a95c-c82f67ced7f2"
    },
    {
      "claim_cluster_id": "fcc58b11-54f2-420b-99e3-8acb8731fd15",
      "event_cluster_id": "7b565f36-8167-44ac-aea6-3371642da65f"
    },
    {
      "claim_cluster_id": "40d2bc92-0cd6-4002-bff9-64332ddd7635",
      "event_cluster_id": "0d667a05-1c8f-4f3d-bb58-e8d67ce23069"
    },
    {
      "claim_cluster_id": "590ca39d-bd4d-431b-829a-90d0f3384aa4",
      "event_cluster_id": "26e8c638-0261-4ee0-9125-edc5ca8d7841"
    },
    {
      "claim_cluster_id": "a38268fe-ba89-4d63-8481-63c080523a0a",
      "event_cluster_id": "4162c749-910d-4283-8cde-a365928f230d"
    },
    {
      "claim_cluster_id": "92b8820a-be27-4c75-96b0-6d6932996a93",
      "event_cluster_id": "ba26379e-e775-463f-9971-b8b46c709801"
    },
    {
      "claim_cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "event_cluster_id": "00b8a8dd-d8e8-40d8-b8f3-1b3a9df2daea"
    },
    {
      "claim_cluster_id": "419a274e-afb4-4935-a491-f22b25792b9a",
      "event_cluster_id": "7186362f-7694-4259-bf65-9f7c8f813207"
    },
    {
      "claim_cluster_id": "fd11e091-21e1-40df-916b-90aba2945065",
      "event_cluster_id": "1bb2fbd1-906a-4d81-b23d-f6c0a4024661"
    },
    {
      "claim_cluster_id": "f50144fc-3b9b-4e34-ac6c-5191d30445d0",
      "event_cluster_id": "94d152a0-b275-42d2-af1e-de4ffe6f8a22"
    },
    {
      "claim_cluster_id": "9ec9965a-96db-46e5-965a-bc307986c26d",
      "event_cluster_id": "a608e3f3-dce6-4fd9-9684-b60e35b55c85"
    },
    {
      "claim_cluster_id": "b63983c2-35fa-4152-8cc2-8380b6cbde79",
      "event_cluster_id": "65ee7ca1-956e-448d-a404-e5c643989efe"
    },
    {
      "claim_cluster_id": "e3548f8e-cc3f-4307-a48a-a45cdf828859",
      "event_cluster_id": "d18315fd-bf62-472b-bd6c-313e812011cc"
    },
    {
      "claim_cluster_id": "d00bd384-4d89-4a56-8487-c419c52438e5",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "bdd5143f-e24a-4ec7-81b7-681d3ac6b3f5",
      "event_cluster_id": "1b9bf573-9c3b-4f5c-a46b-1677c3204c31"
    },
    {
      "claim_cluster_id": "8b124bbc-d0ac-4d8c-bc1d-bbdf5f6ae201",
      "event_cluster_id": "69365007-aabc-4f8e-a4e7-3ac92aef1b47"
    },
    {
      "claim_cluster_id": "70b49961-b72f-4a9a-bed7-51b09a9f1ec7",
      "event_cluster_id": "c0200e7e-79d5-48fa-9957-b064b35b368f"
    },
    {
      "claim_cluster_id": "fc93709e-88fa-4e26-963a-2d3fcd9cde24",
      "event_cluster_id": "f21fe246-03a7-43ce-b3fb-1decc7a9853e"
    },
    {
      "claim_cluster_id": "32902173-339e-4b9f-809d-01ac474ca7aa",
      "event_cluster_id": "c1b67021-ee6c-440d-9e1a-3565b3ab3f41"
    },
    {
      "claim_cluster_id": "35c8d576-e355-4f4b-802d-1d88de41da0b",
      "event_cluster_id": "00b8a8dd-d8e8-40d8-b8f3-1b3a9df2daea"
    },
    {
      "claim_cluster_id": "c8a67d7e-6b5c-49cc-b944-ad699ac9cff0",
      "event_cluster_id": "213f0d3a-e8ca-4bcb-b7c9-7c90117d668c"
    },
    {
      "claim_cluster_id": "aa30bf70-0cba-416d-ab58-48d58cb2a343",
      "event_cluster_id": "4b3edb14-747e-4c77-8e76-8b7c1d8c4155"
    },
    {
      "claim_cluster_id": "bc2e7af6-3507-403a-b41c-f6013dcfcf6c",
      "event_cluster_id": "d9ed1c39-189f-45e7-adb4-c0c7fc2d4155"
    },
    {
      "claim_cluster_id": "029b01a5-6f18-4a7f-96f8-6bde44853032",
      "event_cluster_id": "b670ddd2-4c67-47c8-b6aa-a5edcf7b7b3a"
    },
    {
      "claim_cluster_id": "73ed8dfb-71b9-42f0-9f45-a873045bd275",
      "event_cluster_id": "2d65299b-2b98-4ff0-9197-e120b19ce3bb"
    },
    {
      "claim_cluster_id": "42139453-8011-41e0-af88-1b45a4865158",
      "event_cluster_id": "a5494931-511f-4aa7-86a3-f3bae4df958e"
    },
    {
      "claim_cluster_id": "0649ea17-dc60-458b-988f-5fb62bfa7199",
      "event_cluster_id": "4a709253-d61a-4103-b072-d16f3cb55d28"
    },
    {
      "claim_cluster_id": "c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a",
      "event_cluster_id": "38b77626-e120-4759-a3a5-dc826b3463bb"
    },
    {
      "claim_cluster_id": "149c2ce0-2083-4d57-aa68-de8fbf125008",
      "event_cluster_id": "26e9ba08-6532-4ec2-802f-bd0940d07dcb"
    },
    {
      "claim_cluster_id": "d5458c27-5843-4ff6-b105-7703aeb6f588",
      "event_cluster_id": "f3191f0a-3803-4bca-ad51-304e3f825638"
    },
    {
      "claim_cluster_id": "b58aa973-7c2a-4a42-ac89-2aa7abeea2e5",
      "event_cluster_id": "f7ba632a-cef8-4360-bbef-dd149ddc5163"
    },
    {
      "claim_cluster_id": "5c533a3e-46e0-4800-bdb7-5c1521efbb3d",
      "event_cluster_id": "243170bd-2119-4d61-9620-baad736b6d51"
    },
    {
      "claim_cluster_id": "ef49913c-d983-49cf-b90f-4529857c36a4",
      "event_cluster_id": "95eac10f-08e8-4ebe-913d-90bbcf49cbbc"
    },
    {
      "claim_cluster_id": "63024d1d-9398-49ae-8b27-efbfa0bffb4f",
      "event_cluster_id": "21b62bf3-e16f-411a-a9aa-a2991cb252d2"
    },
    {
      "claim_cluster_id": "a9d64d25-62ff-4c83-a924-9b0477ad4c22",
      "event_cluster_id": "8366909c-b1ee-46fa-ad8d-775e130e5096"
    },
    {
      "claim_cluster_id": "0511fc3f-517e-42e7-84fc-34ea436b847d",
      "event_cluster_id": "6d147aa6-716b-44eb-8f82-ac64993f2df1"
    },
    {
      "claim_cluster_id": "1c5a43cc-bd0f-4446-9eae-4f39a7691fd3",
      "event_cluster_id": "64c57917-e9a2-445d-b946-386aef313815"
    },
    {
      "claim_cluster_id": "496ba3da-7431-46d2-8b63-afbe79f86c65",
      "event_cluster_id": "dd0e35ae-acba-486a-a98c-7ff8e0d969ad"
    },
    {
      "claim_cluster_id": "88f4c27e-7029-43e0-805c-44699284d312",
      "event_cluster_id": "b2f5e997-51a9-4075-b2b0-b908ca91bac7"
    },
    {
      "claim_cluster_id": "b0af2c27-e359-4cad-89ec-4abce503f0fb",
      "event_cluster_id": "babc55aa-4d08-416f-96c5-50bd2182d4f8"
    },
    {
      "claim_cluster_id": "f83f6c15-13c0-41a8-b991-8abeda0466c4",
      "event_cluster_id": "4d323d7a-dea3-4fd2-9928-7ad3b9eb62fb"
    },
    {
      "claim_cluster_id": "de3dfa95-4771-45cc-8a31-d6c35fbb0eb5",
      "event_cluster_id": "fed0576b-522f-4fd4-a6c9-50a73c58d504"
    },
    {
      "claim_cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
      "event_cluster_id": "6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00"
    },
    {
      "claim_cluster_id": "cd099a56-0545-43d7-bbda-54857a323642",
      "event_cluster_id": "46dc68c8-60bf-4c63-8f62-da2eefecf05e"
    },
    {
      "claim_cluster_id": "6547f895-7ab3-43c4-b3b1-d01e17f1e888",
      "event_cluster_id": "829b9804-a574-4cfb-bb97-448e3e369540"
    },
    {
      "claim_cluster_id": "1ba178d9-d925-407c-bb75-60c655774cbf",
      "event_cluster_id": "325144ea-ecb8-45ca-8169-6bfec35e02d6"
    },
    {
      "claim_cluster_id": "cca76b6b-f388-4f7e-8293-b55584460643",
      "event_cluster_id": "f6427727-e128-4eae-8208-67e9a7ed1b14"
    },
    {
      "claim_cluster_id": "d93d391c-6b51-4713-bfdb-30f405cd2357",
      "event_cluster_id": "33fcdb26-eedb-4334-944b-e4ef875270b1"
    },
    {
      "claim_cluster_id": "fece6aa3-8787-449b-8b29-7c6c4bb28cc4",
      "event_cluster_id": "b4673d7c-55f8-410a-a73b-4f4fccae0549"
    },
    {
      "claim_cluster_id": "21228a2d-48c0-43f0-b18d-e85ff94cdb4e",
      "event_cluster_id": "9369f16b-6041-4a52-ab2e-d046a7246adb"
    },
    {
      "claim_cluster_id": "41a55c60-75f3-48f5-817e-bc3dd4fc026d",
      "event_cluster_id": "0fb15e05-a0f9-40af-9d1c-3b5766f5252f"
    },
    {
      "claim_cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "f621aef8-63b8-4a2e-8e04-ca8b7ec1b346",
      "event_cluster_id": "b617ae42-60a1-4bd9-bcd3-a29cc6c02448"
    },
    {
      "claim_cluster_id": "9254d2c4-775d-4f48-975f-879f17b9f193",
      "event_cluster_id": "507a5fb7-2785-473f-8c2e-99215cff28b8"
    },
    {
      "claim_cluster_id": "296dd26b-e540-4c2f-91af-43709d5e7555",
      "event_cluster_id": "995b974f-591b-482e-a707-9ef62e9bcb2f"
    },
    {
      "claim_cluster_id": "7eefde16-5844-4305-a679-da87990a2640",
      "event_cluster_id": "410287df-601d-432b-a55d-63a15a95a255"
    },
    {
      "claim_cluster_id": "6a708ce1-1b6e-4cbf-86c2-55ba9712b9d3",
      "event_cluster_id": "379e9bdd-f97e-4662-8fa6-c65318b2f0d3"
    },
    {
      "claim_cluster_id": "ac35f635-837f-429d-a888-0720cf376532",
      "event_cluster_id": "569a8b8b-9b0e-41ed-a2cc-db56c71f5703"
    },
    {
      "claim_cluster_id": "095169c0-0ce4-4362-b29d-486ce7d2b848",
      "event_cluster_id": "05b40a90-169b-48f1-8cb1-f86fad4e6b0a"
    },
    {
      "claim_cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
      "event_cluster_id": "897c7076-ce98-4405-aaa5-1e883a645242"
    },
    {
      "claim_cluster_id": "bdc594bb-6aa7-4421-82b8-b7df34a7c93e",
      "event_cluster_id": "c4564515-d53f-4e98-999a-f38427deb89e"
    },
    {
      "claim_cluster_id": "36824238-8532-447a-aacf-ef3f59e89c60",
      "event_cluster_id": "19ab8a7a-3e63-46b0-894f-04742e58ad8b"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "a2925234-109d-4c57-aac5-814b5a99a831"
    },
    {
      "claim_cluster_id": "2f43e86f-24fc-4c3c-a77d-c5abbf46ef19",
      "event_cluster_id": "40978309-052c-4c0a-8f09-9f1d51e423d4"
    },
    {
      "claim_cluster_id": "7f1f819a-52dd-40cc-92a1-28526195605d",
      "event_cluster_id": "a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f"
    },
    {
      "claim_cluster_id": "b570ae3c-f72b-47a9-b995-64ca6b5f3ae0",
      "event_cluster_id": "8eb3c499-d3ba-4d18-824d-8a2db9101923"
    },
    {
      "claim_cluster_id": "b2036724-7c6c-4df4-b983-90c324253873",
      "event_cluster_id": "64112ad0-ee1e-4f16-b30c-2adabd7eaabd"
    },
    {
      "claim_cluster_id": "8fa6723f-9341-42e1-b24f-456c511e2eec",
      "event_cluster_id": "fe1c6b54-9f28-4390-8b18-685bcbf44298"
    },
    {
      "claim_cluster_id": "4bec7fa9-99e9-4a5a-aa9f-74f019f54fe8",
      "event_cluster_id": "7d3ca315-e2f1-442e-aa07-daf647abc039"
    },
    {
      "claim_cluster_id": "9560d5ee-30e3-4941-88b8-e0b5144961cb",
      "event_cluster_id": "3f77000e-b7d1-457b-963f-2743a0bda688"
    },
    {
      "claim_cluster_id": "a4e781c0-f96b-465a-94d9-bc076c57b2b1",
      "event_cluster_id": "60da7061-2845-47bf-80c5-d5e550633128"
    },
    {
      "claim_cluster_id": "bb72233d-9eb6-4e80-89c4-220c7a06b310",
      "event_cluster_id": "8a726a08-8358-4b34-876f-420532834600"
    },
    {
      "claim_cluster_id": "4958a7ec-0cd2-487f-a59b-9bc34843a2b7",
      "event_cluster_id": "984977b5-907e-47e8-b70e-4d24066b2265"
    },
    {
      "claim_cluster_id": "53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c",
      "event_cluster_id": "309e6017-5ba6-4aa5-918a-e978302b6d2d"
    },
    {
      "claim_cluster_id": "7698cb38-d25f-4849-ba30-99dd8e321533",
      "event_cluster_id": "074c64eb-8566-4f36-bf3a-fc5995c21e65"
    },
    {
      "claim_cluster_id": "3e775727-96fa-467d-a309-22a5101e04e9",
      "event_cluster_id": "cdc110ac-1c3e-4435-8e2b-221f6de6a9c7"
    },
    {
      "claim_cluster_id": "09f8ca5f-e359-4e32-b6bf-f706de588232",
      "event_cluster_id": "c974679a-a285-4dfd-882e-18a49abd08e5"
    },
    {
      "claim_cluster_id": "e65823f0-739f-4ed0-bd57-83b926046577",
      "event_cluster_id": "696331dc-98cc-442f-bc75-87b9c239a45d"
    },
    {
      "claim_cluster_id": "6a2f7e2f-c113-4c0f-aa04-a2e337901c37",
      "event_cluster_id": "a7c4ae5e-cf5f-4676-a2e4-88e256aaf381"
    },
    {
      "claim_cluster_id": "268e1143-4495-4247-af6b-b6f6f368f74f",
      "event_cluster_id": "652f545a-2cde-41d4-9382-f23ab9d1b406"
    },
    {
      "claim_cluster_id": "0acd3055-185c-4d22-ad5f-a587ee5adc40",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "3e304d73-a8bf-4d4a-8525-85d6c447ae6b",
      "event_cluster_id": "3e466027-ffe7-4ec1-877e-eae7c5a1c2c5"
    },
    {
      "claim_cluster_id": "3aa4fde2-05d2-4c91-b69f-d61ecc64ca82",
      "event_cluster_id": "a486e470-c569-4ed1-8cc9-0f9109ad027d"
    },
    {
      "claim_cluster_id": "60bb3151-34af-4d7b-9c68-da27390075bc",
      "event_cluster_id": "9c99fda8-d219-4855-bf41-fafffb61b05a"
    },
    {
      "claim_cluster_id": "0a0082f4-5a11-4bce-aa5d-1877fddb104d",
      "event_cluster_id": "ef3db80b-5215-490d-a636-85e6bcbe9e93"
    },
    {
      "claim_cluster_id": "6d37cc6e-940b-4af5-bb44-d183921f0d01",
      "event_cluster_id": "1a4ac437-0820-43b9-93ff-945d37e52289"
    },
    {
      "claim_cluster_id": "300fdda9-fd92-4984-a9e6-86c9522fb6d4",
      "event_cluster_id": "ad3d7029-44b1-4600-b68e-2dca24cb3b72"
    },
    {
      "claim_cluster_id": "32902173-339e-4b9f-809d-01ac474ca7aa",
      "event_cluster_id": "d990ed81-4fe6-482e-9afb-51f8ad32db00"
    },
    {
      "claim_cluster_id": "4bec7fa9-99e9-4a5a-aa9f-74f019f54fe8",
      "event_cluster_id": "6b8874c6-0560-4ffd-876b-6651821a5f10"
    },
    {
      "claim_cluster_id": "b0f153c6-cc18-4aee-9b69-e8f06c8e3149",
      "event_cluster_id": "2f956586-babe-4398-aff8-0787b3e3a21b"
    },
    {
      "claim_cluster_id": "fbdddb76-bee9-4e1c-9f2e-03126700cbd1",
      "event_cluster_id": "0534bd48-c558-48f7-8bed-cd770b8d24ee"
    },
    {
      "claim_cluster_id": "6a4e66c3-1fd2-46be-9e31-fecdcd545826",
      "event_cluster_id": "e130a374-b2e7-4d68-8a8e-32dcab17656b"
    },
    {
      "claim_cluster_id": "1e227a80-8d1d-4484-9608-82719d3b526e",
      "event_cluster_id": "f0d97c3a-c630-45ac-8106-3c433d45bb57"
    },
    {
      "claim_cluster_id": "49b52e42-84db-4d97-b9a4-ffd3211b536e",
      "event_cluster_id": "acdd7a89-aa71-4db5-beb7-130a3813dd88"
    },
    {
      "claim_cluster_id": "57bfc89a-d981-44e9-a425-3364b9a5bc24",
      "event_cluster_id": "f1b261ff-b08d-4eda-9ef1-3dbeca804b57"
    },
    {
      "claim_cluster_id": "2b897077-ab7f-4c6d-8c0e-a3493d4e615a",
      "event_cluster_id": "9b4d29fb-4c29-4c0d-a4b1-3620ce290719"
    },
    {
      "claim_cluster_id": "c9534331-e465-4cc5-951b-fa24c4cd75bf",
      "event_cluster_id": "21533f1c-ae42-4579-91e2-803b34beb003"
    },
    {
      "claim_cluster_id": "93c53898-2dc6-423b-a4d6-b61dd90c6d6c",
      "event_cluster_id": "5ed59d44-85f1-4b54-af2c-2965549e9825"
    },
    {
      "claim_cluster_id": "d392695f-75b7-4bbc-a991-2b3edbf01567",
      "event_cluster_id": "1847bb18-db3f-4048-bbaa-0206cb032b77"
    },
    {
      "claim_cluster_id": "03b72068-02c5-403e-b844-88e40b030a18",
      "event_cluster_id": "3ac894a5-bf0c-462e-b5eb-494aa29af425"
    },
    {
      "claim_cluster_id": "b471f42f-4da7-4b5a-a11e-18deef221da8",
      "event_cluster_id": "b0e81eaa-8bd7-4fe8-bd62-e10ea003f63f"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "fe1f6ba0-f663-4ffd-9fda-c7a1f4f8e99d"
    },
    {
      "claim_cluster_id": "e7def08b-a4be-4464-b5ad-7e8f1dfa8752",
      "event_cluster_id": "66380cec-1745-4f20-be6e-01fcad9e1602"
    },
    {
      "claim_cluster_id": "596489a9-6207-48fb-8cf4-2972a01326d9",
      "event_cluster_id": "ceb785f5-a630-41a5-8352-bf1ef25b04f9"
    },
    {
      "claim_cluster_id": "51ff5b38-5ae5-4505-adc2-291731599e68",
      "event_cluster_id": "ae8f14c1-199b-4891-807b-1b7d4b91ad58"
    },
    {
      "claim_cluster_id": "b6fc681b-92ac-49a5-8881-3c1a5122bc59",
      "event_cluster_id": "1843ffaa-26d8-4da2-944c-1a88ec1c3413"
    },
    {
      "claim_cluster_id": "5d21e7b3-dd0e-453e-8871-eb57102f00e7",
      "event_cluster_id": "146f4299-6935-41c6-a1f2-cdd4079712f3"
    },
    {
      "claim_cluster_id": "e7def08b-a4be-4464-b5ad-7e8f1dfa8752",
      "event_cluster_id": "ad513fe4-8bef-4ca7-984b-94ef0cbb53d7"
    },
    {
      "claim_cluster_id": "25cbeeac-8021-4680-b7db-f334ae985da7",
      "event_cluster_id": "45a4a2a8-b9e2-4fb3-a00b-44192e1fb005"
    },
    {
      "claim_cluster_id": "e7a774aa-82c9-41a0-9af6-f4f143016a1f",
      "event_cluster_id": "976b60d5-b934-4def-acec-d66f7c1f4346"
    },
    {
      "claim_cluster_id": "6ca40c20-bd2c-4fa0-af88-bbe3820f05e6",
      "event_cluster_id": "9297f5a6-da64-4942-8c55-fea3e2f0fc25"
    },
    {
      "claim_cluster_id": "a8c4b29d-3d45-4e5e-b6ef-06f93957d16a",
      "event_cluster_id": "07ba7d5a-bc3c-4f63-a8e0-6487f494c700"
    },
    {
      "claim_cluster_id": "31bf6722-ac5c-4597-8c42-50efe5c5aceb",
      "event_cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee"
    },
    {
      "claim_cluster_id": "995a6788-c0da-4f2f-a729-9d6b9bf65efc",
      "event_cluster_id": "753b53ca-12e6-424b-989a-e076a991708d"
    },
    {
      "claim_cluster_id": "149c2ce0-2083-4d57-aa68-de8fbf125008",
      "event_cluster_id": "5bae13a5-6b81-425d-a9bb-49850203205e"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "448377aa-104a-47c8-b987-d7ae3a311686"
    },
    {
      "claim_cluster_id": "b9cdce3c-8c52-4df4-89e7-a4bcf232dbef",
      "event_cluster_id": "9cf8c4fc-8448-4503-a774-71dc4b331a69"
    },
    {
      "claim_cluster_id": "346be717-a4b3-4210-bff0-be972806b6a4",
      "event_cluster_id": "083a8283-1aa3-4b94-9026-bbd5c3a07cbe"
    },
    {
      "claim_cluster_id": "edd65f26-0117-4202-bd31-c3f265210b5e",
      "event_cluster_id": "ab8af083-dfdc-4c18-95cd-32d551c130c1"
    },
    {
      "claim_cluster_id": "d1f2b2ed-be0f-44a4-a171-4b848f482ca9",
      "event_cluster_id": "b23ac12f-f63d-4693-a840-84942ee3fea1"
    },
    {
      "claim_cluster_id": "b7bef44a-7480-409a-8790-0a70b42045ee",
      "event_cluster_id": "e1b47a9d-415d-4c0a-a801-d747a6f31d9a"
    },
    {
      "claim_cluster_id": "856ae956-c845-42c3-8716-9e150f646a11",
      "event_cluster_id": "4c6fd3f2-5818-45f3-b8d8-85a9b9075f57"
    },
    {
      "claim_cluster_id": "267d2942-984a-4564-b33c-69e9db79a066",
      "event_cluster_id": "a28a5ed3-bc11-405d-9242-8b1a5ce91c01"
    },
    {
      "claim_cluster_id": "6436c54d-cea9-4b06-8f6e-d82ef558f6c5",
      "event_cluster_id": "b6b9e4e5-62b3-48a5-a508-9b40663b3e4f"
    },
    {
      "claim_cluster_id": "dde390b5-1a05-447f-86aa-a25992be6bfd",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "2fe8d49f-63a1-4171-af68-9824e47b825c",
      "event_cluster_id": "3de68a28-505a-4c32-bcec-da26bd58e42c"
    },
    {
      "claim_cluster_id": "99d9484d-46ae-4ca2-98a1-dd3e0aeee99d",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "3d8a0674-b5ba-4875-8267-9c46797d5ef5",
      "event_cluster_id": "dbc38a4c-6662-4d84-ac44-e5687dc9ef37"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "ebaf2aaf-acc5-40a1-b99f-157e33f793e4"
    },
    {
      "claim_cluster_id": "0c685bcc-0513-4b5c-8ba7-c302c985ff66",
      "event_cluster_id": "bdc4ffb8-404a-4799-a92b-88d77e6c445d"
    },
    {
      "claim_cluster_id": "3f043499-266e-455f-a558-699fac541c36",
      "event_cluster_id": "38a91236-7bbc-4335-9d5a-a470b70f608c"
    },
    {
      "claim_cluster_id": "824d7e98-fb11-413b-adeb-b8d12c8fb785",
      "event_cluster_id": "04e5de16-d046-4bc2-878e-0b328f3385ed"
    },
    {
      "claim_cluster_id": "3afb5a7e-c2f9-4fc4-a379-b0fb650f805a",
      "event_cluster_id": "f9f6b7b6-ec7e-4aa5-91d2-9d2cf4d35a54"
    },
    {
      "claim_cluster_id": "6a4e66c3-1fd2-46be-9e31-fecdcd545826",
      "event_cluster_id": "eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"
    },
    {
      "claim_cluster_id": "77de10dc-6dcd-4902-a9d2-f5cf9384d343",
      "event_cluster_id": "ecf87520-6110-4dbb-8897-a76147b7c3f7"
    },
    {
      "claim_cluster_id": "0a173478-bf00-4e1f-be9a-c8305b945d9d",
      "event_cluster_id": "e6294e0b-891d-4ba7-af93-8aa8ed47eeab"
    },
    {
      "claim_cluster_id": "e495e756-f14b-4c10-8358-f906f837fdac",
      "event_cluster_id": "ef161e9b-6253-45b0-9c42-d8e3db87f120"
    },
    {
      "claim_cluster_id": "d9f5972a-ff26-4242-938a-7c9615591c15",
      "event_cluster_id": "a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f"
    },
    {
      "claim_cluster_id": "f92684c8-da9a-477a-ba9a-9eb41a6f9f90",
      "event_cluster_id": "9a404aa7-ec0d-4ed0-88e9-60d78850dee6"
    },
    {
      "claim_cluster_id": "4496a4b9-1070-44a0-89bc-e244c8a53dab",
      "event_cluster_id": "efe98b1b-e1ed-468a-9652-7acc5550430a"
    },
    {
      "claim_cluster_id": "8143472f-9ddf-4467-8402-c46a70ccaf1e",
      "event_cluster_id": "69fc2536-52ab-49eb-8743-9e6f9bfcc4f5"
    },
    {
      "claim_cluster_id": "192dfe82-fc68-4d4d-ae38-d6077567ed10",
      "event_cluster_id": "3eb4bc87-51f4-4c2e-990b-944e8a053ab0"
    },
    {
      "claim_cluster_id": "6436c54d-cea9-4b06-8f6e-d82ef558f6c5",
      "event_cluster_id": "7c3d2190-bdc7-4187-b1eb-1c6bf0944191"
    },
    {
      "claim_cluster_id": "2f6021e2-bde5-4c10-ae2b-194bf6a93505",
      "event_cluster_id": "640f326d-efe1-4293-bfc4-0c4c7b9185f3"
    },
    {
      "claim_cluster_id": "b6ac4f42-6e4c-4395-a71a-c8beca5b5336",
      "event_cluster_id": "09202e6f-2182-42ac-8af6-6622f1cfeb68"
    },
    {
      "claim_cluster_id": "c62acce0-70f2-44c3-9131-cec3cdb1f20f",
      "event_cluster_id": "33942929-a46c-44b5-a491-297910f07b91"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "8c441ed7-3996-46c2-abdc-191f54206cf6"
    },
    {
      "claim_cluster_id": "af3aa521-118c-415e-b54b-524628af7168",
      "event_cluster_id": "22523c97-d6bf-448a-b10a-ccd7fd668e2c"
    },
    {
      "claim_cluster_id": "3e200fec-9dad-4a2e-a5e4-655848ec7983",
      "event_cluster_id": "d64cb1f8-2dc5-4222-88a6-8bc5208a2f30"
    },
    {
      "claim_cluster_id": "5d276603-9c3a-417d-bd11-e8b613249dd5",
      "event_cluster_id": "bdc4ffb8-404a-4799-a92b-88d77e6c445d"
    },
    {
      "claim_cluster_id": "be29b74d-f560-4279-9339-cf00d4dac2b0",
      "event_cluster_id": "fc19cd3a-f641-4b19-a6bd-bcbcbc1d7fe6"
    },
    {
      "claim_cluster_id": "8f2a4264-d263-4757-889e-c18e3e101875",
      "event_cluster_id": "182a4780-6c12-4ebc-96a7-e01af3d000d2"
    },
    {
      "claim_cluster_id": "aa458090-4ea3-4829-9f88-662eb71a8370",
      "event_cluster_id": "4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c"
    },
    {
      "claim_cluster_id": "f3cb984c-8736-4ad2-8cd8-5ca9f90033d5",
      "event_cluster_id": "d30fd077-478d-4784-a1a9-ce89125fa303"
    },
    {
      "claim_cluster_id": "74c84f9c-121d-41ed-8a45-f4cdf85eb02c",
      "event_cluster_id": "d116bd42-a280-499e-95f9-862eab4e8043"
    },
    {
      "claim_cluster_id": "74f0249d-eead-4904-bdd3-cd8cfbdb6b82",
      "event_cluster_id": "7cd46da8-e046-45f9-87aa-b04395bcb25f"
    },
    {
      "claim_cluster_id": "cf53004b-b29d-4fe7-a412-14956f8d2a9a",
      "event_cluster_id": "5d2a23b8-6ca9-4894-b0bc-a3b5c15dbf42"
    },
    {
      "claim_cluster_id": "00e6b319-ea09-4ee6-8be1-7f243156f545",
      "event_cluster_id": "c112d6c9-6b2d-48f6-ae9b-5380b20f2025"
    },
    {
      "claim_cluster_id": "c065f08a-341f-4084-99ca-ceef465c2c9a",
      "event_cluster_id": "7e17abde-ea9a-4656-9558-6e168a28baae"
    },
    {
      "claim_cluster_id": "7f43c7d3-2a4b-493c-b3f0-a53355ae39a3",
      "event_cluster_id": "85f720a8-0b31-4d1b-a866-8a5f552a25e1"
    },
    {
      "claim_cluster_id": "329c69a1-8578-4615-a95d-4068857af2c9",
      "event_cluster_id": "45a4a2a8-b9e2-4fb3-a00b-44192e1fb005"
    },
    {
      "claim_cluster_id": "da4bd748-3c84-4017-a93a-8247224fc32f",
      "event_cluster_id": "028ee870-e258-43cd-99d3-f13e457b70d7"
    },
    {
      "claim_cluster_id": "27fad854-f733-4ec5-8acb-b36e0c043d26",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "aaa5b32a-96ba-4450-b886-70f714b65bf2",
      "event_cluster_id": "d83800f4-0756-4306-86c9-259b547db8df"
    },
    {
      "claim_cluster_id": "cbd140c9-7dba-47e8-97c2-10198c9c38d7",
      "event_cluster_id": "14087e7a-3bac-4d48-a154-8c1e158e6c14"
    },
    {
      "claim_cluster_id": "73a6792a-38f3-4e05-a1bc-e5dc764c0b4d",
      "event_cluster_id": "f98db0f7-3865-4f81-b4c0-e009394ed065"
    },
    {
      "claim_cluster_id": "a536505f-e31a-400e-a4a5-1f74a9e29e7d",
      "event_cluster_id": "3a46ccfd-5379-4ef0-aa09-8a1b6a5f409e"
    },
    {
      "claim_cluster_id": "a98eba10-9612-466e-bbba-6161ced90ab9",
      "event_cluster_id": "b687420f-e058-48a2-8c4c-4bc6f35624c2"
    },
    {
      "claim_cluster_id": "1aadbdec-7f0b-43f3-98a7-709a1bcb5807",
      "event_cluster_id": "d5742cb8-e264-4816-b45a-8b7710ea66b3"
    },
    {
      "claim_cluster_id": "300fdda9-fd92-4984-a9e6-86c9522fb6d4",
      "event_cluster_id": "b523b8ba-6f7b-4630-8308-edf6d80a7a18"
    },
    {
      "claim_cluster_id": "2aeb94af-8d5b-40ce-b754-91495083b2a1",
      "event_cluster_id": "e79e7825-9f83-4c5b-92dd-af1bdccc56ef"
    },
    {
      "claim_cluster_id": "5b2c4526-459d-4b6f-8f31-bd40fccf12ff",
      "event_cluster_id": "95cf8fc0-eadb-4c70-8762-0c3f65726aa4"
    },
    {
      "claim_cluster_id": "a764eb56-b1bb-470b-bb17-4bd9f5369b4b",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "64a10d09-a49c-4bf3-80db-a2cb3188afbc",
      "event_cluster_id": "e4e83b34-5f5f-4d12-be7d-278344e0b336"
    },
    {
      "claim_cluster_id": "980136c6-363f-4cda-bc50-cca417518993",
      "event_cluster_id": "b978e9a0-f48b-432c-b14c-50e4efff007d"
    },
    {
      "claim_cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
      "event_cluster_id": "f7dce48b-908d-410d-ae3b-0711d8dd8a49"
    },
    {
      "claim_cluster_id": "15516ad5-b153-4147-8246-ecae0ddbf175",
      "event_cluster_id": "7e64d534-c786-4ebd-b549-3314cdd361e4"
    },
    {
      "claim_cluster_id": "fbea59dc-8fdc-4fcf-ac76-32627af107ae",
      "event_cluster_id": "3d7436aa-4609-467d-a098-e24702a617e8"
    },
    {
      "claim_cluster_id": "b60b834e-1991-44ea-a53f-68d101a440a4",
      "event_cluster_id": "f04b87e3-ae1b-4e57-8c7a-f468d2163699"
    },
    {
      "claim_cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
      "event_cluster_id": "1f539237-1caf-4525-9adc-af33bb645e44"
    },
    {
      "claim_cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
      "event_cluster_id": "f7cbf601-ad96-47af-b877-ba63e1376028"
    },
    {
      "claim_cluster_id": "caa1a8ea-e71f-480b-808e-8ce18b47a5eb",
      "event_cluster_id": "184f7da5-f557-4593-8954-67601ea3d345"
    },
    {
      "claim_cluster_id": "21c7b1a1-7d0b-407c-9669-93e385d68711",
      "event_cluster_id": "86571ae0-c94d-4246-a1b9-4b9547fc239a"
    },
    {
      "claim_cluster_id": "f210a15e-3afd-4f52-8da2-de7a59e25377",
      "event_cluster_id": "be39314b-1ba0-4fb9-b326-3f0e244710fc"
    },
    {
      "claim_cluster_id": "db0a8d4e-9354-4c38-bb13-56ae176ed70b",
      "event_cluster_id": "2fb5602e-e1ec-4e01-ab46-f8e35a0df948"
    },
    {
      "claim_cluster_id": "77b557e0-b37f-4548-adca-2c9da9e04106",
      "event_cluster_id": "ad32e47f-d132-47f0-8dd9-2751c477fa34"
    },
    {
      "claim_cluster_id": "a9555cd5-7b65-4e84-9f89-ed03117c7e50",
      "event_cluster_id": "baac2920-a8d6-4667-acc5-460b63889a7e"
    },
    {
      "claim_cluster_id": "4a3bc772-20e9-4711-acc4-eb16f1a71bea",
      "event_cluster_id": "8e8986ad-07fc-46e6-a980-933b8035ee58"
    },
    {
      "claim_cluster_id": "c91afcbe-198a-44cd-83c8-42c89811dab9",
      "event_cluster_id": "5cf04f55-a643-43d4-8d14-b18769ab1e2a"
    },
    {
      "claim_cluster_id": "f8e7dcff-d078-4ce8-9ad3-495ed7c19774",
      "event_cluster_id": "9964a330-c7c3-4cd3-bf33-0b48084f4337"
    },
    {
      "claim_cluster_id": "0511fc3f-517e-42e7-84fc-34ea436b847d",
      "event_cluster_id": "b4a2abb1-9a33-4e4b-a995-84324638b8d0"
    },
    {
      "claim_cluster_id": "21240c8f-29c6-42ef-b002-a537a743739b",
      "event_cluster_id": "d0b9d362-84b5-4285-90de-b70dc7fdf9db"
    },
    {
      "claim_cluster_id": "dea6592f-a2fb-4ea8-b832-4f7df984c163",
      "event_cluster_id": "9b2ccd60-9fd2-4e0d-8e91-bb564023a0ec"
    },
    {
      "claim_cluster_id": "f1535355-abab-40c3-b4e5-ea2b4fe4994b",
      "event_cluster_id": "ca8ae13a-f4c2-40ca-adf9-58a7907b79bb"
    },
    {
      "claim_cluster_id": "ee3408ae-2ea4-4661-a58b-6e825aa4a0ff",
      "event_cluster_id": "2dbe786d-9065-4e0b-93e2-135a2fc6f7f3"
    },
    {
      "claim_cluster_id": "ee3408ae-2ea4-4661-a58b-6e825aa4a0ff",
      "event_cluster_id": "8affed0e-1741-45ae-9282-db13ed25555e"
    },
    {
      "claim_cluster_id": "f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1",
      "event_cluster_id": "017489d6-d7b2-4b12-8669-3769c4704bdd"
    },
    {
      "claim_cluster_id": "3c28af07-0879-4e0d-a892-8c0d97f3e49a",
      "event_cluster_id": "1519b279-d6f7-427b-b68e-0ca8ed827547"
    },
    {
      "claim_cluster_id": "9dae5050-ee2d-4e3c-8dd3-b9ea85a53752",
      "event_cluster_id": "0c73bba4-2142-4833-ab2a-f7dd03c24dac"
    },
    {
      "claim_cluster_id": "29223456-9a08-4f68-9ce7-d62d961fb6aa",
      "event_cluster_id": "a83597bc-3768-4ee3-a01e-2fac92f73ab7"
    },
    {
      "claim_cluster_id": "31cda056-0942-4d05-8579-66ba52eb0c7b",
      "event_cluster_id": "e0a8946b-f177-4ac9-88a3-5799d558da5c"
    },
    {
      "claim_cluster_id": "de700722-a9e2-4659-a181-3fb83efdd41f",
      "event_cluster_id": "9d12c49f-ea33-4a41-83e1-0a953c37fd5e"
    },
    {
      "claim_cluster_id": "619d0e6c-df2c-4164-aaac-ccaba7c311a6",
      "event_cluster_id": "92a82b98-f457-4ad6-9e23-e80c7e1d25f5"
    },
    {
      "claim_cluster_id": "f4f13b9b-3296-4913-8eea-62ce1becaa2c",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "0d0fd5f0-0301-424f-b0b1-a60ab6ca045f",
      "event_cluster_id": "776ed0c0-bfbb-420d-8369-ebf0e4544c64"
    },
    {
      "claim_cluster_id": "c2ba86a6-df2c-40b6-bf30-1269c5ac3702",
      "event_cluster_id": "473550dc-4370-4fcb-8c1a-760765586a92"
    },
    {
      "claim_cluster_id": "ea149597-1daf-4627-8587-59eb8a6bde8b",
      "event_cluster_id": "08a5fea6-9542-4505-b3ba-04e342c44cbf"
    },
    {
      "claim_cluster_id": "6a4e66c3-1fd2-46be-9e31-fecdcd545826",
      "event_cluster_id": "545232cb-5fc2-43ad-859e-11784f675852"
    },
    {
      "claim_cluster_id": "0c6c9e5b-f8cc-4939-8319-4baf55259b87",
      "event_cluster_id": "acd745c5-1bfe-4e37-a6d1-38b30d091ba1"
    },
    {
      "claim_cluster_id": "654ddafb-5d45-4313-9cd4-f144aab1e464",
      "event_cluster_id": "7da5e969-ac3d-4ab8-86be-3712be90baa2"
    },
    {
      "claim_cluster_id": "934665b5-3969-4817-9dd5-47b732fdd380",
      "event_cluster_id": "78e60a12-a4a3-4c5d-805d-471d75987612"
    },
    {
      "claim_cluster_id": "3aa4fde2-05d2-4c91-b69f-d61ecc64ca82",
      "event_cluster_id": "f38958f6-adfc-406e-ab46-296dedeeb781"
    },
    {
      "claim_cluster_id": "05302999-a145-4cb2-83a6-b2cda0247938",
      "event_cluster_id": "4129284c-60dc-471f-99d0-fbb5e6ca7277"
    },
    {
      "claim_cluster_id": "2105abe4-014b-48d8-a8a2-6e113ac81f52",
      "event_cluster_id": "46812bda-c4dc-4bd2-a7c0-e250a28da359"
    },
    {
      "claim_cluster_id": "af51e97e-2570-48ba-a0bd-ab0668831da9",
      "event_cluster_id": "f9647705-1fb0-4b23-8449-1d162afd7139"
    },
    {
      "claim_cluster_id": "0addd203-38b6-4e2c-8fed-432e5b8aac5a",
      "event_cluster_id": "fc22f23f-3e70-4f58-9556-2d3e03c04167"
    },
    {
      "claim_cluster_id": "10bff7af-7766-4fc3-b86a-eaf53dd132e9",
      "event_cluster_id": "d74329dc-5b82-41ba-94bd-2cdd8306d3ee"
    },
    {
      "claim_cluster_id": "4572f15a-5436-48cf-a1f9-d3e141616965",
      "event_cluster_id": "a6c32f96-492e-46e5-b580-0804b089cb50"
    },
    {
      "claim_cluster_id": "45339238-abb3-494b-a7ba-d3cde2ab18d9",
      "event_cluster_id": "5bbc7620-dddd-48b2-ab59-dca397c2985e"
    },
    {
      "claim_cluster_id": "98a97f12-7d1b-49e9-8178-578b2d656f88",
      "event_cluster_id": "eac47a08-6ad5-4405-8bfb-82ab701b0507"
    },
    {
      "claim_cluster_id": "d4c6919b-eb92-4688-a3f3-bcffc0362115",
      "event_cluster_id": "1f60ebbf-51df-4e3e-95f0-d6e32c7fc5d9"
    },
    {
      "claim_cluster_id": "258085e5-fc49-48d1-b3f4-3f9862c3ba91",
      "event_cluster_id": "ecb6a08c-9197-401c-afbc-cd0ee3d88f04"
    },
    {
      "claim_cluster_id": "f465e3b9-9784-4302-b258-d34ad0adf726",
      "event_cluster_id": "3a4ae54e-e7b7-47e9-984e-62601ed45ab4"
    },
    {
      "claim_cluster_id": "e7def08b-a4be-4464-b5ad-7e8f1dfa8752",
      "event_cluster_id": "d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"
    },
    {
      "claim_cluster_id": "2ea5d498-58e2-44a4-a51a-95bda7047686",
      "event_cluster_id": "e4e6149d-8b97-4295-847d-c2c2c5acb8ee"
    },
    {
      "claim_cluster_id": "d935874a-c33c-4b74-9137-99d8fd9fc1f8",
      "event_cluster_id": "06370214-3027-49a1-988e-c5188868372e"
    },
    {
      "claim_cluster_id": "c4bd1c97-a831-4763-9c03-6a3cf69f7caa",
      "event_cluster_id": "24c54796-afba-46ba-9bb2-8854f3d0747a"
    },
    {
      "claim_cluster_id": "69c28a9e-902d-4ac0-9540-ae2854dbb59f",
      "event_cluster_id": "439aa0a6-6e46-43ae-ba81-fc975c6669e1"
    },
    {
      "claim_cluster_id": "6950bc54-67bb-4e8e-b8cd-afd5c7d79d00",
      "event_cluster_id": "1bb2fbd1-906a-4d81-b23d-f6c0a4024661"
    },
    {
      "claim_cluster_id": "48f8d3d4-cbd2-44f5-81bc-3adadbe6b6e7",
      "event_cluster_id": "1f558072-4f79-45c5-acb2-7e178149e980"
    },
    {
      "claim_cluster_id": "3aa4fde2-05d2-4c91-b69f-d61ecc64ca82",
      "event_cluster_id": "deae8114-2508-4864-a544-401d4150e26c"
    },
    {
      "claim_cluster_id": "d281c55d-162e-4c45-bdc4-8fddc9bff858",
      "event_cluster_id": "f7dce48b-908d-410d-ae3b-0711d8dd8a49"
    },
    {
      "claim_cluster_id": "e88c49ad-3df2-4059-82e4-46d0f3b59757",
      "event_cluster_id": "ebcf5883-5a67-45cd-af26-c257a5d38512"
    },
    {
      "claim_cluster_id": "a615f0ed-7c6c-41b5-95d0-49cb25bb9feb",
      "event_cluster_id": "08d6975b-643a-4b0e-a8cb-576006cbf125"
    },
    {
      "claim_cluster_id": "58a7d973-9fa3-4047-a219-579a31c4561b",
      "event_cluster_id": "dbe1780e-f93d-4eae-8780-d2a73e00ae56"
    },
    {
      "claim_cluster_id": "695b3abb-f469-4406-b1ea-91e5eba8aa09",
      "event_cluster_id": "c5d49178-7807-406f-89c6-f05965bb7e2e"
    },
    {
      "claim_cluster_id": "0d813aeb-360a-48ec-afeb-778e533504c7",
      "event_cluster_id": "68c5326d-ab98-438e-abd1-0e7a9ca85a98"
    },
    {
      "claim_cluster_id": "ad83e0a6-e572-4332-8ef0-01e05cdfa760",
      "event_cluster_id": "66406d6a-fd8e-4e61-aeac-decbaba1818b"
    },
    {
      "claim_cluster_id": "83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "11210f68-2915-41ff-b25a-a55a575f9528",
      "event_cluster_id": "d214ab5c-324d-4152-a542-c58284f4ca22"
    },
    {
      "claim_cluster_id": "f5514b1c-3b40-41b8-9290-039c2c94a3e7",
      "event_cluster_id": "2bec49d1-2f19-441e-9c0b-01eed5568c41"
    },
    {
      "claim_cluster_id": "b459615c-cbbe-438d-9dbf-cc3051ba017f",
      "event_cluster_id": "0313a78d-59e1-4fe7-8d40-5db79d99214e"
    },
    {
      "claim_cluster_id": "be44c17b-cb3f-4a06-af5b-de816dfb4f56",
      "event_cluster_id": "2490af01-fba6-4168-9f21-fb760726b38d"
    },
    {
      "claim_cluster_id": "91ed355a-9103-4819-9a78-2425f91b042a",
      "event_cluster_id": "36641d64-6f2c-4f28-a210-946f0a644597"
    },
    {
      "claim_cluster_id": "854e712a-9c33-4e4e-be9f-d9dd40fa0112",
      "event_cluster_id": "e8e30d44-65d0-4e66-baf3-7e0ae3df4a05"
    },
    {
      "claim_cluster_id": "f3288e7a-a54c-44d1-8307-67aafb47c852",
      "event_cluster_id": "f51a6ac2-4516-4b4c-9fdb-e7e4932f790d"
    },
    {
      "claim_cluster_id": "b686bd17-fb36-4b7b-9caf-084f8d91c149",
      "event_cluster_id": "0033e72b-385a-41ce-8ba3-fd98c6521d05"
    },
    {
      "claim_cluster_id": "3be4473d-cbba-49ee-93e6-36d5bcd0dc0a",
      "event_cluster_id": "5243db0f-4bbb-47bb-9e93-e78de6804d5c"
    },
    {
      "claim_cluster_id": "dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e",
      "event_cluster_id": "77e0e128-878a-417f-8723-91873f114032"
    },
    {
      "claim_cluster_id": "9a73096a-390b-4f9e-a044-22f30734ce69",
      "event_cluster_id": "36c07d65-523d-4b69-bf8b-7f1ec91d6954"
    },
    {
      "claim_cluster_id": "b3de51b2-92ca-4cb1-b45e-50a0188ca28f",
      "event_cluster_id": "1e5040f4-1599-4a16-abf2-bb352e20053c"
    },
    {
      "claim_cluster_id": "285cd62d-96d8-4ff1-af84-3fd22f7b4f51",
      "event_cluster_id": "54af5dc3-58d2-4d68-acb1-aa5f30ea62f0"
    },
    {
      "claim_cluster_id": "9be076b9-65b6-4c8e-b3d7-1df3c547c0fc",
      "event_cluster_id": "a0fb845d-3984-4109-ad59-e77cf57e7687"
    },
    {
      "claim_cluster_id": "5b6da2ab-36ee-4cfe-968a-ce42565405bc",
      "event_cluster_id": "cfa7b687-2383-40f8-9684-b8b6e91149cc"
    },
    {
      "claim_cluster_id": "df13c28d-11fd-4cdc-a0c7-5076d0c46483",
      "event_cluster_id": "f2b7ea2e-02cf-4061-b076-60c350522e8d"
    },
    {
      "claim_cluster_id": "eb38bdfb-232f-4460-8d60-fc8806237786",
      "event_cluster_id": "e8299254-b0bc-4a3f-86b2-fedfa746efb0"
    },
    {
      "claim_cluster_id": "56e6ff33-547f-4d6b-a7a7-e1266368fdd7",
      "event_cluster_id": "314510db-f67d-4268-b068-13a87261ae5b"
    },
    {
      "claim_cluster_id": "666873ec-e76e-4f8a-8d96-7a31c5084ac4",
      "event_cluster_id": "e92990e4-6de9-4c7c-9c4a-006af1a579b1"
    },
    {
      "claim_cluster_id": "71f12e75-d3eb-42eb-93dd-fc62f2343321",
      "event_cluster_id": "c36b66d4-db22-4344-899e-be0f938cf47b"
    },
    {
      "claim_cluster_id": "f6f15ea6-27bd-499b-a6fe-74d144b5ac0b",
      "event_cluster_id": "4d88384e-f212-4bd5-8d08-7d715e173b10"
    },
    {
      "claim_cluster_id": "c065f08a-341f-4084-99ca-ceef465c2c9a",
      "event_cluster_id": "eba7ffd7-9740-4070-bc0f-3ac660c28939"
    },
    {
      "claim_cluster_id": "dfcf5731-89c0-4af2-a475-d7087b733644",
      "event_cluster_id": "ba26379e-e775-463f-9971-b8b46c709801"
    },
    {
      "claim_cluster_id": "dbd98860-9de1-4289-bb60-99171790c782",
      "event_cluster_id": "3c952e11-fec7-43b5-87d0-197de2b823da"
    },
    {
      "claim_cluster_id": "d935874a-c33c-4b74-9137-99d8fd9fc1f8",
      "event_cluster_id": "ab1bcfd5-bef2-4f73-aff0-790c6f681ce4"
    },
    {
      "claim_cluster_id": "bd06a127-0f18-48fa-b6d0-ff607d111775",
      "event_cluster_id": "6e64c34e-113d-43d7-87a6-90c61d4d3f67"
    },
    {
      "claim_cluster_id": "8d565c91-b887-465d-a08e-aff09b1e9e5b",
      "event_cluster_id": "88fa31fb-364c-47f5-bac4-4ecea848d93a"
    },
    {
      "claim_cluster_id": "14c9c1ef-f94d-48f3-87f5-028b0baa8869",
      "event_cluster_id": "ed76bc08-55bf-40dd-b156-814a949b24dd"
    },
    {
      "claim_cluster_id": "f83c19b1-e59e-4712-8a86-4c8c86ee0e2b",
      "event_cluster_id": "3cd947fb-d46a-4f38-9705-3c1f8700f549"
    },
    {
      "claim_cluster_id": "8aec1af3-93d7-45b8-8844-62e8b3ac6198",
      "event_cluster_id": "da0d09cf-ea98-4fb9-b2a8-2ae9009e9f87"
    },
    {
      "claim_cluster_id": "26461fc6-994b-44dd-97c8-95b6341a4a6a",
      "event_cluster_id": "bd48a2e4-20c5-4fa2-90a9-0725e3288c94"
    },
    {
      "claim_cluster_id": "6442657f-3626-4ac3-8a02-28b3c72e00ba",
      "event_cluster_id": "70bf9f45-ce2c-4053-918f-69d225a10029"
    },
    {
      "claim_cluster_id": "7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1",
      "event_cluster_id": "ebca8a8b-8a95-480f-8cf1-c34e09e5822c"
    },
    {
      "claim_cluster_id": "5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9",
      "event_cluster_id": "2fd5c32c-ec83-4d86-8836-741ba8422357"
    },
    {
      "claim_cluster_id": "1f8ce922-0e37-4ccb-b586-67da18764d96",
      "event_cluster_id": "6f960627-d475-4f28-8eb0-dcceb972aad4"
    },
    {
      "claim_cluster_id": "db81e344-8970-492b-8ff5-c4f2bdbaa947",
      "event_cluster_id": "900b62cf-2f7f-4c8d-9d94-4cbb68246f3f"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5"
    },
    {
      "claim_cluster_id": "b39e93e4-b791-4b1e-963b-d8f068ff0b1d",
      "event_cluster_id": "7cd46da8-e046-45f9-87aa-b04395bcb25f"
    },
    {
      "claim_cluster_id": "e2621663-e9d9-45c1-9069-fa9d94c82303",
      "event_cluster_id": "867c6623-6254-4965-b302-1483ede252cc"
    },
    {
      "claim_cluster_id": "3b1f0ed9-3201-46c5-93e3-016f26c4d261",
      "event_cluster_id": "48e9dba9-1fa3-402e-ae73-202c64781781"
    },
    {
      "claim_cluster_id": "489cefd4-e6ef-4f49-8a70-8d8f7bc512bd",
      "event_cluster_id": "8eba8ddc-43e0-42e3-8917-7f76c17baf39"
    },
    {
      "claim_cluster_id": "fcc1829e-1835-42a8-bf49-00b5c2d30892",
      "event_cluster_id": "ac7c5639-803c-4c6d-b9be-69ecbea167de"
    },
    {
      "claim_cluster_id": "d01db0e4-579b-46e1-b0a0-4bf5732646a8",
      "event_cluster_id": "f48f090b-b925-4ff6-946c-dfbb77137193"
    },
    {
      "claim_cluster_id": "23bf4739-72bc-492b-9320-78f2bdc83074",
      "event_cluster_id": "94362393-c674-46bc-9e3a-666f4bf5a507"
    },
    {
      "claim_cluster_id": "c076834e-92b4-4b02-8416-1f251021c0cd",
      "event_cluster_id": "821d5bc2-820d-42b9-a931-b0991cb2d55a"
    },
    {
      "claim_cluster_id": "ff70f7bd-e1b1-44ea-8b32-024f3d1917ed",
      "event_cluster_id": "42817958-19f1-419d-a3c6-d4ed59f438b6"
    },
    {
      "claim_cluster_id": "ebf0120f-ec3a-4a71-bd2b-88f212264387",
      "event_cluster_id": "2f0fefda-5b83-4f80-8b8a-97c292bbda20"
    },
    {
      "claim_cluster_id": "ab72f353-1b68-44ce-979f-a10883b99605",
      "event_cluster_id": "2cf37935-88f0-4aab-94bf-6c7a6da78e48"
    },
    {
      "claim_cluster_id": "5c0df4bf-ba62-40d1-a306-8313dfe790e6",
      "event_cluster_id": "b448b340-9010-448c-b955-573b9913feb0"
    },
    {
      "claim_cluster_id": "edbdc807-7fba-426c-a271-726e1f090eaf",
      "event_cluster_id": "72cb3acd-6792-42e7-917e-0a257b0b418a"
    },
    {
      "claim_cluster_id": "51ff5b38-5ae5-4505-adc2-291731599e68",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "71522ed0-7107-4dfb-8b87-e633332c4e3f",
      "event_cluster_id": "49c9cf48-a13c-439b-9db3-4000e6bfc74f"
    },
    {
      "claim_cluster_id": "e968bf8c-b2a8-4330-bf71-9cab4f6826a5",
      "event_cluster_id": "3bff863b-ef2c-4985-ab4b-24af72e149e9"
    },
    {
      "claim_cluster_id": "55bc595b-aea0-4d83-938e-9ae3ab116813",
      "event_cluster_id": "a8a5c0a8-339b-46a8-844d-e6af4072cfdd"
    },
    {
      "claim_cluster_id": "81062452-735a-45ec-ae26-d06b90c45ed4",
      "event_cluster_id": "8a1cf3e4-81f5-4680-a43b-353cdda171be"
    },
    {
      "claim_cluster_id": "aeb0341a-ad2c-4ec1-b689-ecd5b9a2b868",
      "event_cluster_id": "46a652d6-7e4e-45bf-93da-8368a900beab"
    },
    {
      "claim_cluster_id": "290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45",
      "event_cluster_id": "42c9725b-d681-410b-871b-771e74124bd4"
    },
    {
      "claim_cluster_id": "c7c24801-e07d-4e78-8de0-4a42e8b64272",
      "event_cluster_id": "8649324d-646d-4eb1-97c6-070697056cd2"
    },
    {
      "claim_cluster_id": "55bc595b-aea0-4d83-938e-9ae3ab116813",
      "event_cluster_id": "5bae13a5-6b81-425d-a9bb-49850203205e"
    },
    {
      "claim_cluster_id": "4a05fcea-c8cb-4b88-bb80-cab978e72560",
      "event_cluster_id": "a36c95c0-8daf-40fc-856f-176637a22c4c"
    },
    {
      "claim_cluster_id": "e21ec8bb-ddf8-4115-9765-9a2f72eed10d",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "3d2576b2-1572-432b-98fe-db8e768274d5",
      "event_cluster_id": "a9c08567-c779-4007-8ddb-2cc8e3429124"
    },
    {
      "claim_cluster_id": "5d8d730b-6674-4d5b-8f99-6c8e240e9080",
      "event_cluster_id": "36641d64-6f2c-4f28-a210-946f0a644597"
    },
    {
      "claim_cluster_id": "6d2792d9-4dcf-4980-9870-d295c7f8e2c0",
      "event_cluster_id": "d485a542-5dc8-49cc-9ed2-7c434144d575"
    },
    {
      "claim_cluster_id": "6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5",
      "event_cluster_id": "e6a8f39a-ea50-45d0-aa2c-f24fddc8d1e3"
    },
    {
      "claim_cluster_id": "059205f2-0c13-465b-ba40-83a1ffcbcaa3",
      "event_cluster_id": "d4448dff-7650-4f4b-b38f-b00c5af8c2b3"
    },
    {
      "claim_cluster_id": "18108091-50d0-4bb5-a06f-5f2734380aef",
      "event_cluster_id": "c44517b3-ae07-46af-8dc8-9946743528e1"
    },
    {
      "claim_cluster_id": "db81e344-8970-492b-8ff5-c4f2bdbaa947",
      "event_cluster_id": "db2c7499-73dd-49a7-b315-23a9a2089f45"
    },
    {
      "claim_cluster_id": "1991b6cd-3baa-475c-add7-d4b101a0de09",
      "event_cluster_id": "fca8c069-2da0-43e8-8cac-08662970bcda"
    },
    {
      "claim_cluster_id": "7b68c402-465e-4abb-ac74-c3e397c8afdd",
      "event_cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"
    },
    {
      "claim_cluster_id": "6b000975-482c-4a87-97ba-4b7f79318bd6",
      "event_cluster_id": "3391436d-d1cd-41e7-87fc-ba5f4f2496cc"
    },
    {
      "claim_cluster_id": "88a5288e-7f93-4e9a-8960-db23a08024fc",
      "event_cluster_id": "5b67eeb9-9da5-4079-bb66-f861e834a37c"
    },
    {
      "claim_cluster_id": "5a861756-5d94-444c-84a0-fab63d482e8c",
      "event_cluster_id": "f65ebec2-0122-4441-975a-e196ab928bdb"
    },
    {
      "claim_cluster_id": "b0b4f902-9c94-4b57-b853-99cb04209992",
      "event_cluster_id": "d0668eff-8d5e-4aa1-a4e9-eab28ee44705"
    },
    {
      "claim_cluster_id": "2ed3c98f-2c08-4da6-97f9-38e8a951f08e",
      "event_cluster_id": "16aa2006-ba94-49b3-a83c-9dc2e8c8bf21"
    },
    {
      "claim_cluster_id": "818b32ce-b83e-40a4-b06b-dd4e2c09af00",
      "event_cluster_id": "201e4820-096b-4a76-8f83-d96f22acc64b"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "3bab816b-4cb9-4b5f-bccb-c8cacf2b36ae"
    },
    {
      "claim_cluster_id": "e8c5e2f3-c4c1-4992-a125-b40d6d98bace",
      "event_cluster_id": "93302bc5-2c4d-4a14-9964-fc677c0db641"
    },
    {
      "claim_cluster_id": "e11231dd-53ef-41bf-966c-4a202aa2895c",
      "event_cluster_id": "dbe1780e-f93d-4eae-8780-d2a73e00ae56"
    },
    {
      "claim_cluster_id": "93fddae5-a739-409c-a087-9a562d010a0e",
      "event_cluster_id": "e285d3b2-02ce-4dd4-ad86-ac99b2199a66"
    },
    {
      "claim_cluster_id": "e59930cd-f28a-4a44-8feb-24e860e36480",
      "event_cluster_id": "eeeaa7c5-23d3-447d-ace4-2782329b8bb9"
    },
    {
      "claim_cluster_id": "5288ae46-832e-4436-95ed-05106d5e8d73",
      "event_cluster_id": "93f5bdee-4d35-454b-8f1b-0b318e24a68d"
    },
    {
      "claim_cluster_id": "83ec8695-6d93-432e-a8be-81705e2e2a54",
      "event_cluster_id": "6f7f68fd-a840-40e2-a600-b19e0677f9c8"
    },
    {
      "claim_cluster_id": "21c7b1a1-7d0b-407c-9669-93e385d68711",
      "event_cluster_id": "592ed206-56a1-4eac-9ef2-85b6be103dc1"
    },
    {
      "claim_cluster_id": "0c6c9e5b-f8cc-4939-8319-4baf55259b87",
      "event_cluster_id": "9096c294-fd2c-4311-a357-8c17726796f2"
    },
    {
      "claim_cluster_id": "41a156b3-5c3d-4d82-b8e4-7ad88953f690",
      "event_cluster_id": "41026f02-6a91-44fd-aeaf-33bceaabf234"
    },
    {
      "claim_cluster_id": "ab8de566-e0cc-475b-b056-6b27916b484d",
      "event_cluster_id": "4ae526b6-129a-4522-b79c-5fa5e53d2329"
    },
    {
      "claim_cluster_id": "2b9508d5-4552-4994-840b-08ab461e29c3",
      "event_cluster_id": "21f0a219-a107-4e6e-aa28-e010ad5aec66"
    },
    {
      "claim_cluster_id": "d42df985-9fff-4c49-bac2-4cb2fef7ac9d",
      "event_cluster_id": "aacd7f08-5036-4563-9193-ec61d4e0ea80"
    },
    {
      "claim_cluster_id": "df17af70-aa4f-46d9-b191-eb3b4eeac1ef",
      "event_cluster_id": "ed212b87-d906-4b97-806f-edc87a49ab9e"
    },
    {
      "claim_cluster_id": "183db562-aea1-4c36-b76a-f0deea54c6a4",
      "event_cluster_id": "ea56561a-6c42-424b-a439-8949e0922884"
    },
    {
      "claim_cluster_id": "c7c24801-e07d-4e78-8de0-4a42e8b64272",
      "event_cluster_id": "32697b9c-6810-416a-bedc-25a1c14600c3"
    },
    {
      "claim_cluster_id": "ee3408ae-2ea4-4661-a58b-6e825aa4a0ff",
      "event_cluster_id": "dfa3481f-adba-4f59-b051-83a57da84830"
    },
    {
      "claim_cluster_id": "9af9ad02-7803-4d3d-9d58-fdfc300bef96",
      "event_cluster_id": "252647f3-b2d0-4fb9-8a73-8d20e5a61e96"
    },
    {
      "claim_cluster_id": "18d83743-88ff-4a61-999f-d69912fd6589",
      "event_cluster_id": "dd335f66-9180-429a-8e21-b0e59da84aa2"
    },
    {
      "claim_cluster_id": "162b03a4-86a7-4adf-9f73-3093aecba542",
      "event_cluster_id": "4018b382-2692-4cbc-af34-c3f4f61413b4"
    },
    {
      "claim_cluster_id": "435bc534-7da4-4fec-82cf-af0f2a0a282a",
      "event_cluster_id": "76455b31-1fcc-4337-adc1-b2686dd2563d"
    },
    {
      "claim_cluster_id": "2f43e86f-24fc-4c3c-a77d-c5abbf46ef19",
      "event_cluster_id": "94a48846-dd13-4363-a56c-c51f47f2440a"
    },
    {
      "claim_cluster_id": "388f4cb2-36f0-4395-889f-3dc07bb54aff",
      "event_cluster_id": "b3bb12a8-9e61-4051-99f7-b8946e7edc6e"
    },
    {
      "claim_cluster_id": "df13c28d-11fd-4cdc-a0c7-5076d0c46483",
      "event_cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee"
    },
    {
      "claim_cluster_id": "daf0b3a1-53f1-4b47-955e-785030ee3839",
      "event_cluster_id": "446a7c12-73f1-49f5-944a-5a0119281e12"
    },
    {
      "claim_cluster_id": "3ffaa02c-962d-45fa-a9aa-01f8e41dda01",
      "event_cluster_id": "eb068512-28d0-4bb0-bf5d-a6b05ec0d3dc"
    },
    {
      "claim_cluster_id": "ca0d3bae-6f1d-4857-b362-c7e7718bca04",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "3045aa88-88d8-4410-9d93-f305adb15fd3",
      "event_cluster_id": "3d26e147-f4b2-4b1e-ba9b-bf45396f5e59"
    },
    {
      "claim_cluster_id": "138e6c92-a8bd-4f22-8e72-b320bdcf0b62",
      "event_cluster_id": "3cb65e99-ccac-4aa2-91a0-7af465ad385d"
    },
    {
      "claim_cluster_id": "92df4e35-804e-4b67-b2a3-fbb89ed1961f",
      "event_cluster_id": "aeb82733-bdb6-43c5-a151-fceb87e14ebf"
    },
    {
      "claim_cluster_id": "86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5",
      "event_cluster_id": "91a2ed36-3e87-4baf-9999-c65078a62cbd"
    },
    {
      "claim_cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
      "event_cluster_id": "be379179-357e-431a-afc7-707de2663f0c"
    },
    {
      "claim_cluster_id": "e6867616-fb8f-44d6-8b92-f5cca8ca9e6a",
      "event_cluster_id": "3f285813-2863-43e8-b0ba-5a13b63cb515"
    },
    {
      "claim_cluster_id": "3c4e2f0e-5b8e-45e9-84a7-c71071caeba0",
      "event_cluster_id": "ab327c16-f48a-42a2-adc9-ef76eb93901e"
    },
    {
      "claim_cluster_id": "89a7a448-be37-40e3-973f-79b15dac979d",
      "event_cluster_id": "21b385c4-010f-457b-bf2e-d3d6a55a5ca1"
    },
    {
      "claim_cluster_id": "9ef27775-8065-4722-bd90-8a9ae4a3c250",
      "event_cluster_id": "050d87c2-4ac3-4e0e-8673-b4a44b43bac0"
    },
    {
      "claim_cluster_id": "e9c84dbc-30d1-4e60-bbc8-700057190615",
      "event_cluster_id": "4cdadb3d-d6d7-4b33-b2c9-1974e780d726"
    },
    {
      "claim_cluster_id": "1ec4a683-16aa-481b-9033-75779c52f6c1",
      "event_cluster_id": "b51f7dc2-d0c0-43ca-aba0-033ca0100d18"
    },
    {
      "claim_cluster_id": "b4ecc989-8236-436c-a361-fdaa1e9413ad",
      "event_cluster_id": "821b8f2f-ed67-40fb-ac0f-fb14c5b4d7bf"
    },
    {
      "claim_cluster_id": "a83fedfc-0f0a-49b0-9dae-3932f2ba6983",
      "event_cluster_id": "acad8d82-630a-486f-9b73-624703b74a12"
    },
    {
      "claim_cluster_id": "0acd3055-185c-4d22-ad5f-a587ee5adc40",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "67c32fef-bbe8-4245-9a91-7d8aee491367",
      "event_cluster_id": "ffdeea6b-2666-497f-8afc-18b1b72c39c8"
    },
    {
      "claim_cluster_id": "818b32ce-b83e-40a4-b06b-dd4e2c09af00",
      "event_cluster_id": "5b4f8322-7c02-4a35-a585-89dc98ced769"
    },
    {
      "claim_cluster_id": "ba205832-fc5f-46fb-90ac-d89622b9cebf",
      "event_cluster_id": "ff80368b-8a04-48e8-a451-431808c81ba2"
    },
    {
      "claim_cluster_id": "b9a17741-2ab3-4713-9777-efc674860d38",
      "event_cluster_id": "268b0686-4ead-44df-9f34-76aeb864e839"
    },
    {
      "claim_cluster_id": "94e768ad-42fa-42f8-83fa-89a3705b92a2",
      "event_cluster_id": "421f3ec9-adff-4513-86c4-d1e8d810a087"
    },
    {
      "claim_cluster_id": "7bf63345-7700-41f7-861e-b298dc68ad2d",
      "event_cluster_id": "6da8eb62-757c-4652-8389-b32015cb40a9"
    },
    {
      "claim_cluster_id": "4f4a8dcc-ad59-4dfb-b222-e025fb0c418e",
      "event_cluster_id": "8351f868-a72b-47b0-8a87-867df6862124"
    },
    {
      "claim_cluster_id": "8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0",
      "event_cluster_id": "9b0314ac-478d-4c92-b0c0-490018094349"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "011aa847-d3e3-4d34-bf5e-378f39ba8a3c"
    },
    {
      "claim_cluster_id": "17c8775c-7a3a-4607-aa7f-5b24078a17f8",
      "event_cluster_id": "d0dc34ca-6f25-427d-a56e-1d4f3210e605"
    },
    {
      "claim_cluster_id": "e60065d4-ae50-40b0-8e77-8c2ad3e36235",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "88d87950-d2a5-4729-bb7a-8215d26b8898",
      "event_cluster_id": "f7cbf601-ad96-47af-b877-ba63e1376028"
    },
    {
      "claim_cluster_id": "1e9c3202-7611-4885-bb24-d9dd05b7eed3",
      "event_cluster_id": "308a615f-ca1b-4ef9-9f68-b4e3d4d08711"
    },
    {
      "claim_cluster_id": "8c61663d-a5f4-43e3-9ca6-42de906f614c",
      "event_cluster_id": "2dfb4996-f1b5-47a1-93fd-431ef2467700"
    },
    {
      "claim_cluster_id": "d012c47c-3d49-4f8a-9fcf-db101ff82249",
      "event_cluster_id": "4b3edb14-747e-4c77-8e76-8b7c1d8c4155"
    },
    {
      "claim_cluster_id": "da4807bf-cc54-48c7-b3ca-69cd854da837",
      "event_cluster_id": "608932d5-1e12-46e3-a718-377dfac71e8d"
    },
    {
      "claim_cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
      "event_cluster_id": "356ce4de-dd2a-4caf-bb6c-703dee1f13f4"
    },
    {
      "claim_cluster_id": "b9a17741-2ab3-4713-9777-efc674860d38",
      "event_cluster_id": "e500e465-a022-48fb-afd5-82c02df96bbc"
    },
    {
      "claim_cluster_id": "eb646312-9617-4ab9-b534-22cc250a28b0",
      "event_cluster_id": "a5e2f736-5d7e-4b45-8724-dcdb3a0aecd0"
    },
    {
      "claim_cluster_id": "3720666b-a4ac-4b21-9f19-2a86f32551a0",
      "event_cluster_id": "7534b1ef-c71f-474a-a574-a2a3d535cd1b"
    },
    {
      "claim_cluster_id": "bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb",
      "event_cluster_id": "ccdc4717-b37b-4b1b-94a7-20dfafa305fe"
    },
    {
      "claim_cluster_id": "847accaf-332c-4ec2-bd26-cd592d1fa2fc",
      "event_cluster_id": "fe93734b-6e24-497d-aea9-a8d5b75d7f64"
    },
    {
      "claim_cluster_id": "5aeba902-7d47-4eaa-a3d1-ebbbb2d456c7",
      "event_cluster_id": "21b4b954-5140-43e2-bd9b-c8ab79b3e70c"
    },
    {
      "claim_cluster_id": "0df84ab3-1fc9-4f33-8710-bd9c228e4c70",
      "event_cluster_id": "6e176932-b450-49d2-bc88-60ebe982b797"
    },
    {
      "claim_cluster_id": "e8d873fb-d6bf-4c6b-9328-dabcc490fe91",
      "event_cluster_id": "6f7f68fd-a840-40e2-a600-b19e0677f9c8"
    },
    {
      "claim_cluster_id": "12efff4b-e0b1-447e-aeb7-828004c5cfde",
      "event_cluster_id": "217bc58f-d97f-49d7-9c91-2a55c225a54a"
    },
    {
      "claim_cluster_id": "ea149597-1daf-4627-8587-59eb8a6bde8b",
      "event_cluster_id": "06d90458-c93e-4ddc-a393-97e8e0d06f91"
    },
    {
      "claim_cluster_id": "70b45d78-dfac-4810-b7f6-abeea55c435f",
      "event_cluster_id": "cb189bb7-f2fd-4426-9c9b-411ad929bddd"
    },
    {
      "claim_cluster_id": "aed74a8c-a339-4a19-a144-bb62990f8e50",
      "event_cluster_id": "20324583-738f-4b71-89a8-1820cc1a827e"
    },
    {
      "claim_cluster_id": "fdae240e-8bc7-467c-b880-f3913e28e6ce",
      "event_cluster_id": "03481317-8100-4f6a-8ba8-a8c9a52c0e90"
    },
    {
      "claim_cluster_id": "aa30bf70-0cba-416d-ab58-48d58cb2a343",
      "event_cluster_id": "19380a4c-de83-43a7-ae00-058986b5206e"
    },
    {
      "claim_cluster_id": "a7043201-daf7-4ddc-86e1-fe3a850942e2",
      "event_cluster_id": "9bfc8129-531e-4c98-b3c5-a6aa21e4674c"
    },
    {
      "claim_cluster_id": "e7139494-8034-460e-8501-83d621dafede",
      "event_cluster_id": "2e4d3514-9265-4850-95e7-fe8c0be93a5f"
    },
    {
      "claim_cluster_id": "5b34f4e8-867e-44ea-b5c2-c5295a09dd5e",
      "event_cluster_id": "bf671abc-cf54-41ee-b308-c02abd68d48b"
    },
    {
      "claim_cluster_id": "d622247c-7345-4e31-99b0-dfafa4dc550f",
      "event_cluster_id": "2a187430-0a71-47a9-918a-414338300232"
    },
    {
      "claim_cluster_id": "6bcd764d-320f-4851-ad8b-859177f022bf",
      "event_cluster_id": "96a7a0f7-738c-489b-9ddb-d5c4dba8d9f6"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "36d66c66-9c93-4123-875e-3e9fbe514722"
    },
    {
      "claim_cluster_id": "587bb9b0-b0dd-47bf-9ce3-29231f30f4a3",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "5b52495b-d578-4d45-975c-d2e0417f4501",
      "event_cluster_id": "092693ec-ddb5-4cdf-be96-1d6ac20b489b"
    },
    {
      "claim_cluster_id": "83f1a13d-8feb-41d6-b7a5-6ac32e77b4a2",
      "event_cluster_id": "f21aa624-4667-4f48-bb4c-1942acec5158"
    },
    {
      "claim_cluster_id": "15f89230-b855-41bc-bc6f-7a68ea38aff0",
      "event_cluster_id": "7b0bfb4f-e506-40fa-b633-0da23dace3d6"
    },
    {
      "claim_cluster_id": "f0e862e5-92ba-499e-8f7b-4935ce01c5fd",
      "event_cluster_id": "25e8666d-6596-4996-8765-9de5aa51e568"
    },
    {
      "claim_cluster_id": "e40e6c83-dc7c-44e8-8637-389476dedd00",
      "event_cluster_id": "c66e7d20-399b-4cfc-80f9-620801afd3f6"
    },
    {
      "claim_cluster_id": "d92f99b3-bdef-4ca3-95aa-e303f2451b97",
      "event_cluster_id": "11c3011e-be2e-490b-b73b-6b530385f70c"
    },
    {
      "claim_cluster_id": "6670d6b8-9c36-4849-b28c-4959087df8d4",
      "event_cluster_id": "827f6b49-228f-4d42-afa2-d86a5b588a72"
    },
    {
      "claim_cluster_id": "4958a7ec-0cd2-487f-a59b-9bc34843a2b7",
      "event_cluster_id": "e1b119bd-f317-4a5f-8c26-1f7c12a78710"
    },
    {
      "claim_cluster_id": "a5a6c59f-7670-4f97-9c2b-c94700d73131",
      "event_cluster_id": "81d59e77-2bcf-4755-b211-fc910c424229"
    },
    {
      "claim_cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
      "event_cluster_id": "ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"
    },
    {
      "claim_cluster_id": "9bcb7463-7e6a-4bab-b398-5dd6ead423be",
      "event_cluster_id": "9ac8d542-8a25-4298-bb19-b93232c0319a"
    },
    {
      "claim_cluster_id": "0bc36847-debb-43d3-bab5-e1a736194eac",
      "event_cluster_id": "c0322634-7754-4f2b-b97d-7786687b4f39"
    },
    {
      "claim_cluster_id": "13672f1a-e63c-4ec7-9f85-d3ed61ff60fa",
      "event_cluster_id": "ad25bdfe-5d0f-4c75-8f1b-cb123f11cb06"
    },
    {
      "claim_cluster_id": "a92d1a1e-f967-4044-9d5c-136fd4264137",
      "event_cluster_id": "b07254f1-f996-464b-a61c-6949e39dcdb5"
    },
    {
      "claim_cluster_id": "b5600099-12c0-41c7-bfb6-4b6bb66dc0dd",
      "event_cluster_id": "1743784f-0949-4ddb-93e5-a1fd3954d25b"
    },
    {
      "claim_cluster_id": "41a55c60-75f3-48f5-817e-bc3dd4fc026d",
      "event_cluster_id": "c3a6bce1-7cb7-4d0d-a994-69caef25a8d5"
    },
    {
      "claim_cluster_id": "d07c5569-3547-4153-bb09-72f6d513ab57",
      "event_cluster_id": "1e56067f-4831-446b-a37b-b3b5e1d7166f"
    },
    {
      "claim_cluster_id": "0c6c9e5b-f8cc-4939-8319-4baf55259b87",
      "event_cluster_id": "c3b690f0-82c8-4db2-ba3e-5e52a89ca594"
    },
    {
      "claim_cluster_id": "76bc71d7-2c17-42b9-974c-d517911bab56",
      "event_cluster_id": "c96cd646-4254-4e40-a0db-aa3d02c5b208"
    },
    {
      "claim_cluster_id": "f367b654-8f0a-4a4d-816e-54c86d7f13ae",
      "event_cluster_id": "446a7c12-73f1-49f5-944a-5a0119281e12"
    },
    {
      "claim_cluster_id": "004d8db2-6d73-4ac4-955b-6d04e88a0716",
      "event_cluster_id": "edbf2785-2875-4f94-8c61-364dee3abf1f"
    },
    {
      "claim_cluster_id": "5765d283-f56d-43cd-b120-e8f9048e2325",
      "event_cluster_id": "b95118e4-bfa9-41d0-884f-00c06ed87e30"
    },
    {
      "claim_cluster_id": "dc8d69ed-9d9d-4c04-a104-2c89e796edf3",
      "event_cluster_id": "62f74a8d-c7b3-449b-9454-ae631aea88c2"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "f2b7ea2e-02cf-4061-b076-60c350522e8d"
    },
    {
      "claim_cluster_id": "0bc36847-debb-43d3-bab5-e1a736194eac",
      "event_cluster_id": "3a723b11-9c69-4419-ba9d-ccab21e2fc24"
    },
    {
      "claim_cluster_id": "3630ee9d-368f-4623-9704-06881bdf9264",
      "event_cluster_id": "4b3edb14-747e-4c77-8e76-8b7c1d8c4155"
    },
    {
      "claim_cluster_id": "6f847ace-00e0-4009-b5e9-3729f7a9e244",
      "event_cluster_id": "f50c160a-60a4-4be2-9f62-bc773e7ba48f"
    },
    {
      "claim_cluster_id": "a0c8c3de-8102-4a9b-b20a-80ade6132b4e",
      "event_cluster_id": "36b35892-f11e-4f98-83df-979e347100dc"
    },
    {
      "claim_cluster_id": "bcc58315-e1c3-44d9-8dc7-b3967b315e01",
      "event_cluster_id": "a0a19a10-55fb-482a-b96b-5df57df087a3"
    },
    {
      "claim_cluster_id": "c782b8c2-e8a6-49c0-98b9-40619e415dcd",
      "event_cluster_id": "65f75788-4ff6-47c1-8a6e-6bb7cdd19537"
    },
    {
      "claim_cluster_id": "8f15ddff-3bc7-4fbd-9371-1a897f8b9078",
      "event_cluster_id": "25a5b743-428c-47c7-abea-0b994fd987b8"
    },
    {
      "claim_cluster_id": "916339bd-3e65-4fc3-be04-12020f45e716",
      "event_cluster_id": "5b003616-1a21-4fdb-b479-c710fbcc5926"
    },
    {
      "claim_cluster_id": "ce0417d2-5817-45d3-a01f-447b8d6d19ff",
      "event_cluster_id": "c2e5bef0-900b-4168-ac2b-5a5465221f87"
    },
    {
      "claim_cluster_id": "fbea59dc-8fdc-4fcf-ac76-32627af107ae",
      "event_cluster_id": "658c3b98-6196-42b5-b086-e8814a2a7b5e"
    },
    {
      "claim_cluster_id": "59f595d5-6ff2-4686-81ce-6150bd29db9d",
      "event_cluster_id": "2a0edc6f-16ff-496d-b79c-24bffd830324"
    },
    {
      "claim_cluster_id": "679dc735-ea4b-4b4e-88e2-45d26bcc5b41",
      "event_cluster_id": "7564aa71-23fc-4383-a2a0-0245e543e0fe"
    },
    {
      "claim_cluster_id": "efcbf9db-15ac-473b-a9a9-0988dcab89df",
      "event_cluster_id": "b175f6e9-a72d-4057-b833-76aad93255ef"
    },
    {
      "claim_cluster_id": "24d4d508-a837-441b-b87c-de6ead3d7582",
      "event_cluster_id": "615eb8c6-f4dc-46f8-a203-a52e0d6c79f7"
    },
    {
      "claim_cluster_id": "095169c0-0ce4-4362-b29d-486ce7d2b848",
      "event_cluster_id": "f551f1f0-32f5-4ff3-b5c9-5aab61bb1bd6"
    },
    {
      "claim_cluster_id": "ff92e2cd-b51d-4aba-9214-602e53d602c6",
      "event_cluster_id": "b4f7c43a-b96f-4977-a6a9-ad07015e8976"
    },
    {
      "claim_cluster_id": "4496a4b9-1070-44a0-89bc-e244c8a53dab",
      "event_cluster_id": "347d475b-a5aa-4035-8032-84126946c0db"
    },
    {
      "claim_cluster_id": "5a8284e8-a150-41dc-8ee7-edbc3da33af5",
      "event_cluster_id": "2f7d7b19-3996-4824-8b2e-60b30c5d543d"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "c09c5abe-d2d4-4b78-b32f-49fbbd5778a7"
    },
    {
      "claim_cluster_id": "5a089986-6a82-42ed-90a9-302a1ce45000",
      "event_cluster_id": "7b83d10a-e2be-4730-b52d-6f8b8b917c91"
    },
    {
      "claim_cluster_id": "a34f85b1-92bb-47d3-b089-7365f6b9f51f",
      "event_cluster_id": "cba3863d-9ffc-4647-831b-d4da84c689e3"
    },
    {
      "claim_cluster_id": "61d63dd9-934f-4808-b6ab-ed734f2474b3",
      "event_cluster_id": "43836beb-3651-49f1-a0f8-ad3c4daaab70"
    },
    {
      "claim_cluster_id": "7a66905d-c83d-454d-9b6f-176a36e4d7b3",
      "event_cluster_id": "e294ae03-93b8-4461-85ca-920f88826e8a"
    },
    {
      "claim_cluster_id": "9867a541-4a4c-449d-a4af-a0263f8d23fb",
      "event_cluster_id": "2a6f5cd6-ea11-4cf4-9d3b-fd691e67f194"
    },
    {
      "claim_cluster_id": "4572f15a-5436-48cf-a1f9-d3e141616965",
      "event_cluster_id": "4edf6538-801f-49f6-932e-65747f37810f"
    },
    {
      "claim_cluster_id": "9ce1a265-b79e-4040-a0e8-f1a6fbb59f67",
      "event_cluster_id": "cdc110ac-1c3e-4435-8e2b-221f6de6a9c7"
    },
    {
      "claim_cluster_id": "e633b9f2-d6c2-4c51-83af-0aed2e577009",
      "event_cluster_id": "9c028d31-caed-4945-8a22-834a8ca119bc"
    },
    {
      "claim_cluster_id": "02c78b1c-dd55-4ba6-a345-d21fd27d3214",
      "event_cluster_id": "398bd69e-f1d9-412f-8469-51469e37a88e"
    },
    {
      "claim_cluster_id": "62fc9d37-f7e6-43e7-a681-3c5679294ee9",
      "event_cluster_id": "e00b6e6b-19c3-46b7-8ed7-41551b5be8f8"
    },
    {
      "claim_cluster_id": "92df4e35-804e-4b67-b2a3-fbb89ed1961f",
      "event_cluster_id": "ff17e739-87dd-44ff-b5d0-44c22b4a7bb5"
    },
    {
      "claim_cluster_id": "a7436ce6-07d0-45e0-8628-2de252e4cb46",
      "event_cluster_id": "beec5e0e-fafa-473c-9a37-0736cf0853e3"
    },
    {
      "claim_cluster_id": "8e782418-3f83-48d1-a7d0-6c3daf34ed25",
      "event_cluster_id": "38e4e6a9-dd51-45eb-8aed-8f44b62fdfe6"
    },
    {
      "claim_cluster_id": "bfd3bb04-3c5a-410a-b26b-81f569186264",
      "event_cluster_id": "75366cd6-61ed-4e55-93f0-d40cb0af777b"
    },
    {
      "claim_cluster_id": "a34f85b1-92bb-47d3-b089-7365f6b9f51f",
      "event_cluster_id": "005d39b6-0b0e-4011-aaca-d596411fa607"
    },
    {
      "claim_cluster_id": "e11a5f48-4afa-40b5-8724-9f7420d483fe",
      "event_cluster_id": "fca8c069-2da0-43e8-8cac-08662970bcda"
    },
    {
      "claim_cluster_id": "da1326c3-fa76-400d-b44c-881f6493a085",
      "event_cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810"
    },
    {
      "claim_cluster_id": "af562818-5594-417a-b606-add10573c2db",
      "event_cluster_id": "632ca25c-c259-4da1-adb8-67921865876c"
    },
    {
      "claim_cluster_id": "ac5cef85-9755-4d73-a0c9-3b2d779220c4",
      "event_cluster_id": "abef27a8-3e24-43c9-9823-523dd607d49a"
    },
    {
      "claim_cluster_id": "fc45a344-4cfc-4865-9030-d033f0c8dff3",
      "event_cluster_id": "d140ee70-1c2e-44c9-b163-573b275b6b17"
    },
    {
      "claim_cluster_id": "d7623a03-cd91-4c2e-b68a-db4e5ad54fa8",
      "event_cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993"
    },
    {
      "claim_cluster_id": "5e7e70f4-b130-467a-9df9-f6078877ed61",
      "event_cluster_id": "50450ae6-8d18-4a4d-9adf-9937e9748bba"
    },
    {
      "claim_cluster_id": "8ac7a573-0e67-4913-bd5a-4320d5df2ecd",
      "event_cluster_id": "9d45e016-7740-4b71-ac88-57c1dbc80615"
    },
    {
      "claim_cluster_id": "afdf0794-a58d-44cd-b1d0-aec7b0adc12c",
      "event_cluster_id": "2007b8f4-ae8f-43aa-a61a-6788fb1351fe"
    },
    {
      "claim_cluster_id": "04c0a28d-e066-4279-bfee-f4757f197d7a",
      "event_cluster_id": "30b7b8ee-8417-4cde-bc24-2f6b158ce6a0"
    },
    {
      "claim_cluster_id": "18daf39a-f6c9-4439-8592-186d1ea3c4b4",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "9993ea09-c44e-4372-864a-21c7f72c7eef"
    },
    {
      "claim_cluster_id": "40d2bc92-0cd6-4002-bff9-64332ddd7635",
      "event_cluster_id": "755be0e1-62e3-46db-9545-f7f494e88efd"
    },
    {
      "claim_cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
      "event_cluster_id": "41aaee2b-0ddb-4eee-87a5-d0d95635a46f"
    },
    {
      "claim_cluster_id": "2c61e4c1-c73f-4292-be06-e4f072faf26c",
      "event_cluster_id": "dc7ff2aa-1921-42d9-9518-a57c8197d5cd"
    },
    {
      "claim_cluster_id": "5fec9a51-560a-4b1e-ab7c-cafcf47ba675",
      "event_cluster_id": "6965d206-c7e5-406f-98ef-d70ab17200e5"
    },
    {
      "claim_cluster_id": "30f557eb-c83e-4cb4-b405-ec14f06f223d",
      "event_cluster_id": "fb4930fb-4b1e-4086-912b-c760c3b7850c"
    },
    {
      "claim_cluster_id": "b0b4f902-9c94-4b57-b853-99cb04209992",
      "event_cluster_id": "7d6c6e4a-50bd-4afe-bb2e-cfcdaf7a206e"
    },
    {
      "claim_cluster_id": "b3de51b2-92ca-4cb1-b45e-50a0188ca28f",
      "event_cluster_id": "f0140bf6-12ff-43a0-8d3c-60ad6ec418af"
    },
    {
      "claim_cluster_id": "ab1e12a7-1d17-4758-97dc-5a8b5a8834bc",
      "event_cluster_id": "771d6319-42e1-412d-8b6c-733124c3c173"
    },
    {
      "claim_cluster_id": "da3ee5ab-4748-4fea-9d14-3bdfe78a1c62",
      "event_cluster_id": "a4f03b54-99da-409b-9d0f-4576a28453ea"
    },
    {
      "claim_cluster_id": "b0c0fbc8-3a87-4290-a45f-69e062e04cee",
      "event_cluster_id": "adb05a60-b0e1-4623-b55a-6fea056e1f65"
    },
    {
      "claim_cluster_id": "06af9b74-e018-4919-8256-29acfecc76d7",
      "event_cluster_id": "707d96d6-8c9c-44bd-a592-b72a5c0a0e76"
    },
    {
      "claim_cluster_id": "0119782a-5d22-485c-b58b-6c82b20e788c",
      "event_cluster_id": "4550eb60-072c-4e27-8e64-8c04270738c8"
    },
    {
      "claim_cluster_id": "18413d30-3282-4a19-9301-8b0c9a57c941",
      "event_cluster_id": "3fb778a0-a02e-44fb-a706-5b4689fd37e9"
    },
    {
      "claim_cluster_id": "34d9abee-6356-4941-91bd-4961dca2eec1",
      "event_cluster_id": "4b93a421-107c-4185-912b-a73d039895b4"
    },
    {
      "claim_cluster_id": "f65b5094-1e51-442e-b444-de0d25f1fea0",
      "event_cluster_id": "7dbbaf50-ba32-48e6-b203-1b81e86a3004"
    },
    {
      "claim_cluster_id": "a5124b94-6b98-447d-9c53-5100339210c5",
      "event_cluster_id": "5ad7a663-479d-4397-bbe4-c19607b95013"
    },
    {
      "claim_cluster_id": "1eb307cf-2274-463b-9ab8-19aee3397703",
      "event_cluster_id": "02ef40eb-a1c1-4bb1-9831-77fc91e127be"
    },
    {
      "claim_cluster_id": "38c71e65-4039-4578-b30f-f1a4d6dd193f",
      "event_cluster_id": "b43cd636-593a-444c-9022-279eedcd0450"
    },
    {
      "claim_cluster_id": "a75c6491-7fc4-4904-9a47-b176fcc90a36",
      "event_cluster_id": "a70c5cd3-da81-4d6c-8001-3956de0c9692"
    },
    {
      "claim_cluster_id": "7b6f6e44-c4b3-44b4-af65-8b15cce351d4",
      "event_cluster_id": "89a78cfb-c5b4-41b1-8a6d-eaa2669e99d8"
    },
    {
      "claim_cluster_id": "95b38f6d-19e7-4fa7-a9de-ee665de84018",
      "event_cluster_id": "47eacbaf-94c8-4453-9ff4-4a4d77904c0c"
    },
    {
      "claim_cluster_id": "a1632082-229c-4e1d-b6b1-8334d7ed7db2",
      "event_cluster_id": "5045a380-d054-4bd0-b13d-e42a8ff24888"
    },
    {
      "claim_cluster_id": "f4638fa7-3292-4d44-b3f1-771aa65146b0",
      "event_cluster_id": "c7968790-1b36-4325-9e94-aa1c52a513a9"
    },
    {
      "claim_cluster_id": "68152d77-1b3b-45af-8c06-88cf78f6a175",
      "event_cluster_id": "2f4e138b-a8ca-4c68-be26-24de0c3b0489"
    },
    {
      "claim_cluster_id": "8fa6723f-9341-42e1-b24f-456c511e2eec",
      "event_cluster_id": "8922c103-923c-4f13-93a5-f90c7607556f"
    },
    {
      "claim_cluster_id": "ed1ca8c0-7841-4109-ada2-99053838abfe",
      "event_cluster_id": "3050de99-7b86-4c4e-a101-b10c8a674e17"
    },
    {
      "claim_cluster_id": "03db723a-dcac-4e7f-b456-18c0fdfdba8d",
      "event_cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee"
    },
    {
      "claim_cluster_id": "f83c19b1-e59e-4712-8a86-4c8c86ee0e2b",
      "event_cluster_id": "f3c400dc-7cb4-4e82-a493-b5e485fbdb96"
    },
    {
      "claim_cluster_id": "712f7b26-cec5-48c3-8025-43c35dea8246",
      "event_cluster_id": "557fbe6b-8c80-48fe-945d-5c4d06e53e9a"
    },
    {
      "claim_cluster_id": "0728a108-719d-49e5-9d88-9c4bc35fe771",
      "event_cluster_id": "15441f0b-d588-4f74-9e0c-951884dd5f0a"
    },
    {
      "claim_cluster_id": "31d339ae-2342-44f9-a909-e299d2c4eccd",
      "event_cluster_id": "5f181f74-d991-4908-aaf7-6917a17dca75"
    },
    {
      "claim_cluster_id": "3b3a75fc-8d67-4d12-8788-a11705a7cca1",
      "event_cluster_id": "0cacd6f0-a483-4fb9-8635-2cc0f4273b40"
    },
    {
      "claim_cluster_id": "94076701-ef33-45db-95b9-6fd0d66deba4",
      "event_cluster_id": "31aa44e4-52ff-4a6d-a593-c7d1153c5dc2"
    },
    {
      "claim_cluster_id": "6695efed-b1b5-4469-a01b-a370dfb9c522",
      "event_cluster_id": "e5a54fcb-cbc0-4fb7-bfbf-7530efd090da"
    },
    {
      "claim_cluster_id": "61d63dd9-934f-4808-b6ab-ed734f2474b3",
      "event_cluster_id": "612db375-37db-450a-9941-cc2bdb1c5d4b"
    },
    {
      "claim_cluster_id": "ab24b6cb-fc70-48c9-8ee3-224b83a66b11",
      "event_cluster_id": "e13e1cb5-f52c-406f-a55a-701cb19f5226"
    },
    {
      "claim_cluster_id": "2972b17d-9533-46fe-a896-a36d50916446",
      "event_cluster_id": "1826eb0d-42e5-4b20-8a46-72b9e26a1dc6"
    },
    {
      "claim_cluster_id": "712f7b26-cec5-48c3-8025-43c35dea8246",
      "event_cluster_id": "cfcddae8-7e4d-4fb6-8a06-45fdad19422f"
    },
    {
      "claim_cluster_id": "10e97fc5-5fa6-457f-aefb-257e90e8124b",
      "event_cluster_id": "5ccc3e3f-7dc2-4f92-90f5-ef2c18f982fb"
    },
    {
      "claim_cluster_id": "bf01755f-02c0-4092-8a9f-ea50ff0a213d",
      "event_cluster_id": "04e520d6-ffc4-485d-b6f9-73b32b9e56e3"
    },
    {
      "claim_cluster_id": "a34f85b1-92bb-47d3-b089-7365f6b9f51f",
      "event_cluster_id": "1c223a5c-b5aa-49ca-99af-333b89e0351d"
    },
    {
      "claim_cluster_id": "19ec7067-1e85-4e98-adf9-a107366a808b",
      "event_cluster_id": "6cd72072-03f7-4b6f-a5d4-4465c298c295"
    },
    {
      "claim_cluster_id": "8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6",
      "event_cluster_id": "ecaaad84-7e56-4f5a-84d0-609fbf620112"
    },
    {
      "claim_cluster_id": "655e754e-33e7-4bf2-aabe-264f18d499a4",
      "event_cluster_id": "9964a330-c7c3-4cd3-bf33-0b48084f4337"
    },
    {
      "claim_cluster_id": "0950755f-651f-455e-a7d5-47091afd7de2",
      "event_cluster_id": "d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"
    },
    {
      "claim_cluster_id": "de4bbbfe-ba23-4e75-bdd5-72e767837661",
      "event_cluster_id": "5fc56973-0e2c-4845-a192-e7e5c5265d9b"
    },
    {
      "claim_cluster_id": "ea3c1b05-c987-4377-9e48-b92ea47cc764",
      "event_cluster_id": "2529c3a6-becd-4a5a-81a7-ccc8f9b32cae"
    },
    {
      "claim_cluster_id": "510b63b0-aea2-446d-8868-5c88431cc9fe",
      "event_cluster_id": "991ffbe8-307f-44da-878c-ba99ad7d9638"
    },
    {
      "claim_cluster_id": "478db2a7-a90d-4fbf-8954-0416daa97dcb",
      "event_cluster_id": "90bfcfdf-2a27-494a-a983-e0be2f5b4a32"
    },
    {
      "claim_cluster_id": "63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7",
      "event_cluster_id": "eebab277-5cd3-4cfd-9fb6-1c0154222c56"
    },
    {
      "claim_cluster_id": "e1572e16-5f85-4ebb-a6fe-2ab18bee1c48",
      "event_cluster_id": "a6896ca9-8851-4af3-bc86-04c953eef0ce"
    },
    {
      "claim_cluster_id": "3bebcbeb-75f9-4e80-89da-65943e0843a7",
      "event_cluster_id": "82261ab3-3caf-4c24-ac0e-14c29ebf6f44"
    },
    {
      "claim_cluster_id": "da1326c3-fa76-400d-b44c-881f6493a085",
      "event_cluster_id": "3cb0e39c-2e4c-43dd-b51c-bd5e065c7bd5"
    },
    {
      "claim_cluster_id": "df17af70-aa4f-46d9-b191-eb3b4eeac1ef",
      "event_cluster_id": "7c711c42-89fa-4d59-a561-9de6228e491d"
    },
    {
      "claim_cluster_id": "ac926db6-b36c-4519-9b56-13482c4acbd7",
      "event_cluster_id": "d735477d-2ee7-4e51-9aba-37176b8e5505"
    },
    {
      "claim_cluster_id": "71f12e75-d3eb-42eb-93dd-fc62f2343321",
      "event_cluster_id": "91a2ed36-3e87-4baf-9999-c65078a62cbd"
    },
    {
      "claim_cluster_id": "eb82caa7-6ef5-4182-a16e-ed0091be45ae",
      "event_cluster_id": "3092d2a7-23cc-41c3-b8bd-3096963a1b79"
    },
    {
      "claim_cluster_id": "f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab",
      "event_cluster_id": "bfccbfa0-4d21-4c95-88ca-a83d95def684"
    },
    {
      "claim_cluster_id": "a3dda742-6a6a-4de7-ad48-8075110e3b35",
      "event_cluster_id": "b0fdd1fd-fb84-40ca-af9a-591f59bfb795"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee"
    },
    {
      "claim_cluster_id": "00e4e855-edbf-4846-a824-47a6b221930a",
      "event_cluster_id": "b454bfa6-3d84-4f22-a166-5f84ce0bf756"
    },
    {
      "claim_cluster_id": "df5b4e50-7d1b-4d7e-ae01-046530298250",
      "event_cluster_id": "f4253f2e-cf0c-4fcc-9979-cb25e723158b"
    },
    {
      "claim_cluster_id": "10f0700e-3ce2-47c7-8783-a4d08ef48748",
      "event_cluster_id": "673690cb-9b1b-4465-841b-31fb50a8d527"
    },
    {
      "claim_cluster_id": "e8d873fb-d6bf-4c6b-9328-dabcc490fe91",
      "event_cluster_id": "4703becb-493e-4c1f-aff3-21e217d2c90f"
    },
    {
      "claim_cluster_id": "cb25f623-bfdb-42c7-9873-fa48f80feade",
      "event_cluster_id": "83ccf0a7-79d9-408a-a448-eb83f5e7d0d2"
    },
    {
      "claim_cluster_id": "9e906023-8a3d-4a63-9309-18e9ee1c3641",
      "event_cluster_id": "3d43abac-8178-4ce6-a910-10e135a5266f"
    },
    {
      "claim_cluster_id": "1809291b-a942-475c-989f-c974b3ec75b6",
      "event_cluster_id": "fad57477-d03d-4801-aeb1-50224d171446"
    },
    {
      "claim_cluster_id": "62e8f214-855a-45b7-8de5-a667d22dd7f0",
      "event_cluster_id": "8d52f35b-3806-4a30-b931-3dfcb56775fd"
    },
    {
      "claim_cluster_id": "cd4e973d-ac94-4c83-952d-356fab535a21",
      "event_cluster_id": "25458cd1-1938-4e91-a3e1-aa6eb25c1608"
    },
    {
      "claim_cluster_id": "453d17a8-fa49-49dd-82fd-7c3661e026b6",
      "event_cluster_id": "f2060e6b-7cd9-444e-9e39-3784e110a3b5"
    },
    {
      "claim_cluster_id": "a94e5bcb-b502-4cb7-a23d-3a1e29ce963a",
      "event_cluster_id": "4c464446-66cf-4c9f-b4d9-3d5598eb4a8c"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "38841999-14cb-43f3-a2d5-27d9791973f6",
      "event_cluster_id": "5a9d340b-259a-49d7-894d-4e9c6dec6a07"
    },
    {
      "claim_cluster_id": "5272bbda-d47a-4619-a956-853dc9c29d18",
      "event_cluster_id": "7dfc83e7-a64c-4018-a3c6-9d9e19ffc362"
    },
    {
      "claim_cluster_id": "86944fd0-c689-49c4-894c-bd247f4057bb",
      "event_cluster_id": "65143df4-6c29-4538-b9c3-4cba1c56a8eb"
    },
    {
      "claim_cluster_id": "e8d873fb-d6bf-4c6b-9328-dabcc490fe91",
      "event_cluster_id": "b996a367-b4a5-4361-bd3d-e0e97f9ed9ca"
    },
    {
      "claim_cluster_id": "bf01755f-02c0-4092-8a9f-ea50ff0a213d",
      "event_cluster_id": "15b25c11-ec21-460c-ad6a-670c9cb77249"
    },
    {
      "claim_cluster_id": "141b690c-587b-4b7b-9ad4-7b1b333f6cd8",
      "event_cluster_id": "deecc1db-c201-4092-b4f0-f1a952dbcc16"
    },
    {
      "claim_cluster_id": "b9eca2e7-5401-453f-8490-81ec97719e08",
      "event_cluster_id": "cc658fb1-6da2-4d31-8ee4-f6cd436408af"
    },
    {
      "claim_cluster_id": "a5124b94-6b98-447d-9c53-5100339210c5",
      "event_cluster_id": "dfe9b2aa-c1a4-44e1-97cf-0e0d2107befb"
    },
    {
      "claim_cluster_id": "a03d3de9-e5ad-47e0-9374-17e6c1998859",
      "event_cluster_id": "8be17819-9c73-4351-af94-f5573c4b0d17"
    },
    {
      "claim_cluster_id": "62bf43d6-ee9a-4f43-a89d-18b4cdd7fdd3",
      "event_cluster_id": "61d385a5-d13c-453b-af42-53ad07fd1c25"
    },
    {
      "claim_cluster_id": "aa7a9a4f-e437-468a-8a0c-4d2441978380",
      "event_cluster_id": "7bcdf864-ee5d-4016-9651-b86043d6e5f0"
    },
    {
      "claim_cluster_id": "6019fc4d-e3c3-4367-8970-ef89e2860014",
      "event_cluster_id": "65b2891f-5d2c-4752-ad93-3b8790a22071"
    },
    {
      "claim_cluster_id": "da4e5cde-efc2-4363-87b4-b9935cc2b21d",
      "event_cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810"
    },
    {
      "claim_cluster_id": "a288cd72-4282-4ba7-b449-a353419578cd",
      "event_cluster_id": "6ad9a81e-b42d-45d2-9083-3274cf3a2137"
    },
    {
      "claim_cluster_id": "09a468db-6b0d-4230-a370-cfd6ba61219e",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab",
      "event_cluster_id": "213e0c4f-0911-44fc-89bf-cf985adbc12e"
    },
    {
      "claim_cluster_id": "0179bab7-45d2-4b90-aa4d-c6afb970dbc5",
      "event_cluster_id": "82ba7adb-7963-4264-baad-21315bacde1d"
    },
    {
      "claim_cluster_id": "b61ba5b2-e28d-4cea-b7a2-78bed070aeca",
      "event_cluster_id": "8610e15b-1046-4caf-b039-527168f31d6b"
    },
    {
      "claim_cluster_id": "8d8dbda6-96b3-4738-b7a8-777f920a39be",
      "event_cluster_id": "d1f35128-46aa-4b3e-8942-ed03c647bdc7"
    },
    {
      "claim_cluster_id": "aa30bf70-0cba-416d-ab58-48d58cb2a343",
      "event_cluster_id": "3909ddcb-f2e7-47b0-849d-f54906120921"
    },
    {
      "claim_cluster_id": "e836e40b-bdcd-4eeb-bbb2-df3b385c12c6",
      "event_cluster_id": "905316e3-c2fa-42ca-821c-e5be344dac59"
    },
    {
      "claim_cluster_id": "c6c8d065-8cfe-4224-9bcc-58df52f1a712",
      "event_cluster_id": "8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35"
    },
    {
      "claim_cluster_id": "f4d9e677-79ed-4c5c-84a1-d127898975a0",
      "event_cluster_id": "bd7f57f5-8509-4e66-a8cb-a0ca1f9115a2"
    },
    {
      "claim_cluster_id": "1d4acd59-7bc7-421b-87d6-c6dcd6e61497",
      "event_cluster_id": "e2805f19-13f7-489e-ba06-5921751ad393"
    },
    {
      "claim_cluster_id": "f65b5094-1e51-442e-b444-de0d25f1fea0",
      "event_cluster_id": "ecc3ed38-6dd1-41d0-88a5-4aaeb65a608e"
    },
    {
      "claim_cluster_id": "affa89a3-9b82-426c-9616-b589325af10c",
      "event_cluster_id": "c95c962f-c479-4151-9149-d13898c2a6b3"
    },
    {
      "claim_cluster_id": "4572f15a-5436-48cf-a1f9-d3e141616965",
      "event_cluster_id": "e8809e83-36ee-4437-9f9a-9028a358d36b"
    },
    {
      "claim_cluster_id": "5b52495b-d578-4d45-975c-d2e0417f4501",
      "event_cluster_id": "388a333e-2008-4c61-8154-a9e224b365b3"
    },
    {
      "claim_cluster_id": "74ac8dc6-1d9b-435b-bae9-36745f271604",
      "event_cluster_id": "5b21b1b3-5d6d-4813-8da8-9dbf1ce6934a"
    },
    {
      "claim_cluster_id": "88d87950-d2a5-4729-bb7a-8215d26b8898",
      "event_cluster_id": "11d3cdd7-b203-4792-91e4-e32314bbcbc2"
    },
    {
      "claim_cluster_id": "f10a7215-4011-4959-9b86-e9f3848b78fb",
      "event_cluster_id": "d73adbe1-7dcc-4345-a67c-e7d102fbc24d"
    },
    {
      "claim_cluster_id": "ab9886f5-759f-416b-88de-b9f771cf04e1",
      "event_cluster_id": "3efed4d3-9a2c-4fa8-bf3a-fb69d88128e8"
    },
    {
      "claim_cluster_id": "d622247c-7345-4e31-99b0-dfafa4dc550f",
      "event_cluster_id": "b4df60de-0b59-4910-b93a-2f4eaa711964"
    },
    {
      "claim_cluster_id": "89b28f7e-be14-417b-aeba-019498e50195",
      "event_cluster_id": "0ebcd390-0474-4d90-81dc-d03c9dac78e4"
    },
    {
      "claim_cluster_id": "2fc8ee47-5c74-46a4-91ea-72f94f9e2c27",
      "event_cluster_id": "7a0376f1-1a7b-4181-a413-d3bc6cd70242"
    },
    {
      "claim_cluster_id": "8c2b4e21-c9ea-4127-9440-e983688f714d",
      "event_cluster_id": "6c48832c-2b96-4ee8-9b48-4611e67b38f0"
    },
    {
      "claim_cluster_id": "e6bef1f7-9387-45ab-918c-0df479862034",
      "event_cluster_id": "3a18182f-409d-4665-970b-231ce6a7c108"
    },
    {
      "claim_cluster_id": "d637ae20-ea81-4c6e-85e0-ffbd0f9a76b5",
      "event_cluster_id": "715be432-cabb-4dfb-94ca-fb3947c60120"
    },
    {
      "claim_cluster_id": "38841999-14cb-43f3-a2d5-27d9791973f6",
      "event_cluster_id": "a9a48f40-5af3-4e72-b9f7-5b25295964a4"
    },
    {
      "claim_cluster_id": "26461fc6-994b-44dd-97c8-95b6341a4a6a",
      "event_cluster_id": "c99367c6-2c05-4a14-b047-7f8ff36ff133"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "109daecb-5285-41a5-9427-7fd6ab199a14"
    },
    {
      "claim_cluster_id": "d88ab7ef-052f-4839-b4dc-054794d4d289",
      "event_cluster_id": "5c607d5b-9632-4ec1-9939-05955e158cfd"
    },
    {
      "claim_cluster_id": "1809291b-a942-475c-989f-c974b3ec75b6",
      "event_cluster_id": "ce085679-ae85-409d-b3f3-afb9e8562a5b"
    },
    {
      "claim_cluster_id": "00e4e855-edbf-4846-a824-47a6b221930a",
      "event_cluster_id": "781b12f4-b179-4668-8b0e-ea2f1da17240"
    },
    {
      "claim_cluster_id": "df895ffb-5333-4b2a-9ce5-f1108a894c34",
      "event_cluster_id": "57d96007-f80d-4110-8583-3e280492b584"
    },
    {
      "claim_cluster_id": "b835c70a-6e2a-4461-9396-aa47cc9d876c",
      "event_cluster_id": "fca5231f-5992-4d7b-ae79-0b5b3aa11fb8"
    },
    {
      "claim_cluster_id": "39f6fc8d-27a2-4261-870e-362c0315c46f",
      "event_cluster_id": "2c6352c1-d120-47aa-8825-a58359bc7c7c"
    },
    {
      "claim_cluster_id": "f9a4fce8-b5c8-4697-808a-9ac08e5be52f",
      "event_cluster_id": "781b12f4-b179-4668-8b0e-ea2f1da17240"
    },
    {
      "claim_cluster_id": "ff47f0b3-49ae-48d8-b9cf-5707589bed0f",
      "event_cluster_id": "a0aa3975-d232-4eed-a961-eca71bc27015"
    },
    {
      "claim_cluster_id": "4370b159-681b-41a0-8da8-22c407b09da9",
      "event_cluster_id": "1310ff3c-798d-4934-989d-8b8e4e0530a4"
    },
    {
      "claim_cluster_id": "3afb5a7e-c2f9-4fc4-a379-b0fb650f805a",
      "event_cluster_id": "077c9500-5508-46b9-9207-39c50c9150fb"
    },
    {
      "claim_cluster_id": "62bf43d6-ee9a-4f43-a89d-18b4cdd7fdd3",
      "event_cluster_id": "ed17271a-9f56-4fda-b3f2-e8dbe7b55084"
    },
    {
      "claim_cluster_id": "96b44dc8-1893-429c-83b5-6d58cef5fa9d",
      "event_cluster_id": "4eaf7a96-0e00-419f-b612-d0f41e00fc2d"
    },
    {
      "claim_cluster_id": "fe5b3c77-4467-4eae-82f8-8e1dd2f75d5b",
      "event_cluster_id": "69cf6d84-6886-4dc2-b36b-3239cc3450b1"
    },
    {
      "claim_cluster_id": "5aeba902-7d47-4eaa-a3d1-ebbbb2d456c7",
      "event_cluster_id": "4d4b5f03-b89d-479d-93c3-2c3c9a038d46"
    },
    {
      "claim_cluster_id": "34e53235-60e8-4299-9389-633db39ab300",
      "event_cluster_id": "ce9cb999-3c9f-480e-9d89-8702d1c44875"
    },
    {
      "claim_cluster_id": "b1827766-8909-4c0a-8a55-23a0b5e81d4e",
      "event_cluster_id": "654fa001-54fb-4d51-b87a-8207c38aeb88"
    },
    {
      "claim_cluster_id": "95690f3e-4515-4810-858c-28b7d1da49a5",
      "event_cluster_id": "2b8e0512-59eb-40b2-a0fe-0c0765fe2a41"
    },
    {
      "claim_cluster_id": "17c8775c-7a3a-4607-aa7f-5b24078a17f8",
      "event_cluster_id": "f996f072-3b37-4e7f-900c-1cc05e40fa72"
    },
    {
      "claim_cluster_id": "b65de138-2e69-44b3-acdb-00d152bc8245",
      "event_cluster_id": "cc8b239f-30da-4a67-b3e7-b923954bf5fc"
    },
    {
      "claim_cluster_id": "509e1b1d-c464-406d-8d4e-6ab2f46f2324",
      "event_cluster_id": "7bd17062-e906-485a-b7b6-75d95fcf30ef"
    },
    {
      "claim_cluster_id": "a3891be3-55f1-4794-b99d-304a26e4b465",
      "event_cluster_id": "91533351-01ef-434b-b8d2-ca94698271b1"
    },
    {
      "claim_cluster_id": "aeb0341a-ad2c-4ec1-b689-ecd5b9a2b868",
      "event_cluster_id": "1782182b-9c5f-4a6f-b547-bd10fc2d3b84"
    },
    {
      "claim_cluster_id": "df895ffb-5333-4b2a-9ce5-f1108a894c34",
      "event_cluster_id": "729cc7ae-ca2f-4e76-9131-41ad0335ecdf"
    },
    {
      "claim_cluster_id": "947a0b8b-01e0-44c9-8ebc-c9da3eecde20",
      "event_cluster_id": "bd7f57f5-8509-4e66-a8cb-a0ca1f9115a2"
    },
    {
      "claim_cluster_id": "6826010f-2a38-48a2-a358-b062edaa9ed4",
      "event_cluster_id": "4edafa37-461a-4e41-b730-dd41cc60940c"
    },
    {
      "claim_cluster_id": "a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4",
      "event_cluster_id": "9d847e57-5fc5-4cc4-8919-603e5c8d93d2"
    },
    {
      "claim_cluster_id": "5dac5b6d-e9df-41db-9225-7e413ca3cacb",
      "event_cluster_id": "7e70d266-a12a-4562-93b6-0506f079359f"
    },
    {
      "claim_cluster_id": "1d8a91a4-e2e3-49c2-838b-462dda682ab0",
      "event_cluster_id": "88f7cf16-b8a2-4b9c-98ee-aad660820b7c"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "0e36f836-fa5b-40df-8bd7-860b08ef47db"
    },
    {
      "claim_cluster_id": "f621aef8-63b8-4a2e-8e04-ca8b7ec1b346",
      "event_cluster_id": "31016415-1e0c-4bc5-8f2a-e27a8e5ff775"
    },
    {
      "claim_cluster_id": "40db941d-31ac-4f8f-a268-d60a6c9bd055",
      "event_cluster_id": "e01a8825-f8eb-425d-b928-eda6b3f57929"
    },
    {
      "claim_cluster_id": "98bac582-09cd-476d-9519-fe434dffcb9a",
      "event_cluster_id": "d6164d22-4f2e-407f-abd5-0ff84a88c4a3"
    },
    {
      "claim_cluster_id": "0b87672f-54fc-4c20-8d98-e54ab45bc52d",
      "event_cluster_id": "5bb4fd2c-606b-4f16-9ca5-b9abb9dd5181"
    },
    {
      "claim_cluster_id": "868aacb9-ea8e-4ec3-a074-1e7f56bab03f",
      "event_cluster_id": "82ba7adb-7963-4264-baad-21315bacde1d"
    },
    {
      "claim_cluster_id": "1e8d5556-2c0c-4097-b606-9907a5dd2afc",
      "event_cluster_id": "f239b4c3-e0cf-4725-9d59-2b1e32a9ad39"
    },
    {
      "claim_cluster_id": "f9ff85c1-1de5-47fa-b9f9-f7450f5b0b3d",
      "event_cluster_id": "087b9c92-fa35-4283-96fb-8d9c5297eb2d"
    },
    {
      "claim_cluster_id": "57eb29a4-6d1b-4f98-a507-b97e4235688c",
      "event_cluster_id": "89863001-f3cc-4b83-a5ba-601a96690a75"
    },
    {
      "claim_cluster_id": "77ce5be7-73f4-4876-9446-d5aec1b02a1c",
      "event_cluster_id": "499c9d29-7269-44cb-a1ca-192dc37f8892"
    },
    {
      "claim_cluster_id": "388f4cb2-36f0-4395-889f-3dc07bb54aff",
      "event_cluster_id": "2cf37935-88f0-4aab-94bf-6c7a6da78e48"
    },
    {
      "claim_cluster_id": "24d4d508-a837-441b-b87c-de6ead3d7582",
      "event_cluster_id": "94b72832-2531-4bc1-ae04-872ab9df9981"
    },
    {
      "claim_cluster_id": "2cf125de-8cd0-4d04-8bbd-f0bf7f8ae187",
      "event_cluster_id": "1a1ebb66-c1bd-4b57-a87b-865e10a35768"
    },
    {
      "claim_cluster_id": "58a60e5c-9e5a-48ce-a07c-a7168b46ba2f",
      "event_cluster_id": "745dc0ba-2e08-4d11-9168-0c12ad0b99a5"
    },
    {
      "claim_cluster_id": "ccf91c48-303e-4d94-8263-0e8c6de64e17",
      "event_cluster_id": "8b829799-1488-4866-83fa-531278dceac5"
    },
    {
      "claim_cluster_id": "b3b1fd7c-7ffb-411d-b821-50b6108ebae7",
      "event_cluster_id": "4dd4cfc3-9e42-4844-9174-8c971ece9bc4"
    },
    {
      "claim_cluster_id": "6670d6b8-9c36-4849-b28c-4959087df8d4",
      "event_cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993"
    },
    {
      "claim_cluster_id": "b7e4eaa1-1521-4096-9aa4-af78b70dfeb5",
      "event_cluster_id": "3ea76b8e-7bc3-4056-b872-c2ebb28f696a"
    },
    {
      "claim_cluster_id": "9ade6dc5-62e9-44b7-84fc-ef5e0c8fe1bd",
      "event_cluster_id": "a18cfe43-57c6-4582-9892-e05c06ecdee6"
    },
    {
      "claim_cluster_id": "b54e5664-a40b-4682-b959-bcfb59ddd4b0",
      "event_cluster_id": "2006ffe8-e5ea-49eb-8208-12ce96b310e4"
    },
    {
      "claim_cluster_id": "1746dc9d-7bd5-45f4-a86e-d7bc4c937633",
      "event_cluster_id": "0d8c9f9c-0b32-4507-8989-0e2529da4ed4"
    },
    {
      "claim_cluster_id": "0605c233-63ed-4bdf-a0fe-665556a34a75",
      "event_cluster_id": "a25c3ac7-1dad-4c90-b412-99d2bc775053"
    },
    {
      "claim_cluster_id": "5a861756-5d94-444c-84a0-fab63d482e8c",
      "event_cluster_id": "bb4b93c0-732a-485f-b2ae-0ba6433c139f"
    },
    {
      "claim_cluster_id": "7a1e52a1-bd32-491f-a249-5ec36a49aa78",
      "event_cluster_id": "a8cc6e44-ab60-4366-aa46-06f9a46a5810"
    },
    {
      "claim_cluster_id": "a162a552-43bd-43b6-925a-ac7f9fbf4734",
      "event_cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810"
    },
    {
      "claim_cluster_id": "6302b733-5c75-40a5-a618-05d435c65be2",
      "event_cluster_id": "35d3e890-e939-41bb-b28b-3ee99ba1783a"
    },
    {
      "claim_cluster_id": "b36a42d8-1bb3-483d-b77f-bd28630b0e30",
      "event_cluster_id": "e113cbe4-9797-46e8-ab87-8e31da3f22de"
    },
    {
      "claim_cluster_id": "10bf083b-35c8-4b77-a2d9-e4cb3813d9fb",
      "event_cluster_id": "7893a531-ebf0-48fb-8b91-b2f1e4865517"
    },
    {
      "claim_cluster_id": "15f89230-b855-41bc-bc6f-7a68ea38aff0",
      "event_cluster_id": "0af6351b-04c5-4f0a-8360-02d15acb3d1c"
    },
    {
      "claim_cluster_id": "02c9b472-905f-4c41-8570-811b8d821196",
      "event_cluster_id": "1af06082-428a-4dc1-a3c0-4aa29b512806"
    },
    {
      "claim_cluster_id": "6d37cc6e-940b-4af5-bb44-d183921f0d01",
      "event_cluster_id": "0f38c468-09df-4db1-af76-875811609b3a"
    },
    {
      "claim_cluster_id": "194a083f-fee7-4bf0-b198-fa40c8bdfe21",
      "event_cluster_id": "2cca833d-ae9d-45ac-9501-885a938605a6"
    },
    {
      "claim_cluster_id": "3c1f9759-2361-48c2-bc4a-c58a3d11b76f",
      "event_cluster_id": "70ea1622-08ba-432f-a3ce-0079b309daee"
    },
    {
      "claim_cluster_id": "8db03bdc-0c69-45b1-8ccb-309f57132adb",
      "event_cluster_id": "da1ad06e-43a1-466f-9487-046d8d125726"
    },
    {
      "claim_cluster_id": "03db723a-dcac-4e7f-b456-18c0fdfdba8d",
      "event_cluster_id": "e81e68ae-4e8a-4aef-a358-1455ad08bdc4"
    },
    {
      "claim_cluster_id": "8165992e-6782-4b62-b794-6309bbfbaf5c",
      "event_cluster_id": "174ff9ad-6286-41da-ad67-0696f7875e1b"
    },
    {
      "claim_cluster_id": "f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1",
      "event_cluster_id": "c368702b-96c0-4866-81f4-7cb0750c1bcd"
    },
    {
      "claim_cluster_id": "6fa7c53c-2f06-41c6-acf2-531da6482f4e",
      "event_cluster_id": "e9b17550-2314-4f27-8f49-a28182e8193b"
    },
    {
      "claim_cluster_id": "0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879",
      "event_cluster_id": "2c68a882-a903-4629-aeb4-3d0034f94771"
    },
    {
      "claim_cluster_id": "a24c9e44-7dfe-4825-ab38-82d2ff8a84cc",
      "event_cluster_id": "70d7ea19-ed43-41ec-a695-147f9057dd3c"
    },
    {
      "claim_cluster_id": "187eb2a5-5a75-4a22-8ebb-7b83bc1068a8",
      "event_cluster_id": "2bdcdf0c-04af-47ca-abf1-8573ce94795d"
    },
    {
      "claim_cluster_id": "f1afc4d0-4eaa-40ab-99e6-20e11c550ccb",
      "event_cluster_id": "5fc56973-0e2c-4845-a192-e7e5c5265d9b"
    },
    {
      "claim_cluster_id": "30f557eb-c83e-4cb4-b405-ec14f06f223d",
      "event_cluster_id": "270b9be6-37c3-4ab7-9763-57943d7a38b9"
    },
    {
      "claim_cluster_id": "62ff82d6-7a81-4618-a5c7-dad49908ecf4",
      "event_cluster_id": "7bd17062-e906-485a-b7b6-75d95fcf30ef"
    },
    {
      "claim_cluster_id": "5a33a893-0ae3-4e2b-9f4c-02de9772f96c",
      "event_cluster_id": "252647f3-b2d0-4fb9-8a73-8d20e5a61e96"
    },
    {
      "claim_cluster_id": "5bc0db5b-3192-42d4-a343-00cfcacc4499",
      "event_cluster_id": "51cbaa1d-e1b7-494b-ab8c-dca8a0d96a68"
    },
    {
      "claim_cluster_id": "881a8788-562f-4bf2-a8b1-590419007a87",
      "event_cluster_id": "67eaacee-8b2a-42e6-980c-72585c0bb525"
    },
    {
      "claim_cluster_id": "a9b66749-8bb9-4643-bb36-488cbf77974b",
      "event_cluster_id": "6985cd83-55db-4a59-b823-aed3b2386ee8"
    },
    {
      "claim_cluster_id": "9571d5a8-94c8-43e8-bdfc-93e045f2bdd4",
      "event_cluster_id": "d8cf9191-20ce-4f00-be96-f15ca59147ae"
    },
    {
      "claim_cluster_id": "4c8ca22f-065e-4c2a-bc2a-950d315204b8",
      "event_cluster_id": "2e75fb89-d4ec-437b-bb34-741837209437"
    },
    {
      "claim_cluster_id": "86d26636-5c9c-416b-94e0-e2a89a9628c3",
      "event_cluster_id": "aee60c89-f292-46d6-9573-19871764aa64"
    },
    {
      "claim_cluster_id": "3aa4fde2-05d2-4c91-b69f-d61ecc64ca82",
      "event_cluster_id": "17c72ecc-bde7-4838-bd7c-6c235f6a23e1"
    },
    {
      "claim_cluster_id": "d7524d60-e45b-419a-8a13-87cf67bfd8e5",
      "event_cluster_id": "2bd1f4b8-00be-4a69-ba1f-d23c0361c606"
    },
    {
      "claim_cluster_id": "428a1c85-5fee-4a1d-bbe0-9e71872e75e9",
      "event_cluster_id": "70408cf7-1954-491d-98bc-f78c50c03508"
    },
    {
      "claim_cluster_id": "d42f0707-162e-449e-86fe-0dd5e2885a21",
      "event_cluster_id": "b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb"
    },
    {
      "claim_cluster_id": "d4c6919b-eb92-4688-a3f3-bcffc0362115",
      "event_cluster_id": "1dcb2d84-ef9e-498b-a03a-7740ad5e2f55"
    },
    {
      "claim_cluster_id": "a3657e1e-0716-4d64-9a9e-572ba20604c2",
      "event_cluster_id": "57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"
    },
    {
      "claim_cluster_id": "3c4e2f0e-5b8e-45e9-84a7-c71071caeba0",
      "event_cluster_id": "0d24f0d8-e472-465e-a47b-526385fc7554"
    },
    {
      "claim_cluster_id": "fff4a6ed-31c6-43f6-93ef-bd50b7133298",
      "event_cluster_id": "4d8ae235-419c-4dbe-90f4-1201d0ccbf9d"
    },
    {
      "claim_cluster_id": "2adce5ae-1669-4c77-b898-ed9abf7276da",
      "event_cluster_id": "3a1850b4-8745-4145-98c4-7563773130a2"
    },
    {
      "claim_cluster_id": "07fa2c87-6f80-4d1c-a60a-bb0d6e0e303a",
      "event_cluster_id": "0a3f5bd0-94f4-48e7-84b4-d317e0edec75"
    },
    {
      "claim_cluster_id": "de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe",
      "event_cluster_id": "213244f7-7bbf-4ff3-935f-65e545a0abda"
    },
    {
      "claim_cluster_id": "32a2eefa-c8c7-482c-839f-be3b15138d40",
      "event_cluster_id": "3a29dca6-ced7-43ed-9cff-367044251da1"
    },
    {
      "claim_cluster_id": "23dcfd5c-77ee-4590-92a1-d00d1da215c4",
      "event_cluster_id": "cecf5ab1-6a32-4285-b19c-a1e9eb89d592"
    },
    {
      "claim_cluster_id": "98f59c42-164f-4444-8ecb-92a7e7c88a99",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "856ae956-c845-42c3-8716-9e150f646a11",
      "event_cluster_id": "9427cf91-1580-41ef-aaf0-2efa82b46d41"
    },
    {
      "claim_cluster_id": "820cd21b-12a7-4c4e-a98c-55a81599d692",
      "event_cluster_id": "dfc393f7-ef26-4ee1-ba36-c3a68f72795f"
    },
    {
      "claim_cluster_id": "574866ae-31fe-4cc6-8d31-fe21c9fdd682",
      "event_cluster_id": "a8cf67a0-14e4-4562-b59f-46b2a6b2b98a"
    },
    {
      "claim_cluster_id": "574866ae-31fe-4cc6-8d31-fe21c9fdd682",
      "event_cluster_id": "fd964b79-d3b5-4267-ab70-39cd4b799f57"
    },
    {
      "claim_cluster_id": "8c61663d-a5f4-43e3-9ca6-42de906f614c",
      "event_cluster_id": "8254f8c1-33e3-4176-8b1d-232b3b4367f4"
    },
    {
      "claim_cluster_id": "1fc4c0cc-9a41-4ae8-9970-3b340b704e77",
      "event_cluster_id": "e5eb9c21-045d-4a8f-b07b-6af55af6d48c"
    },
    {
      "claim_cluster_id": "5d21e7b3-dd0e-453e-8871-eb57102f00e7",
      "event_cluster_id": "5a3236fa-e7d1-4fa1-bcc8-0cc89c18d852"
    },
    {
      "claim_cluster_id": "461bd859-868b-47e1-abbb-db550a7eb628",
      "event_cluster_id": "8363a6a5-6462-4ebe-b358-821cefa34494"
    },
    {
      "claim_cluster_id": "e8b8352a-472f-4b00-9dae-87cd809f920e",
      "event_cluster_id": "35a90496-100d-4386-a3d0-578c543e7dd4"
    },
    {
      "claim_cluster_id": "565749fa-0214-435c-be6b-1a2ffed6aba1",
      "event_cluster_id": "a04779f3-83fb-4f0a-a9f8-fc91c7dd0fc4"
    },
    {
      "claim_cluster_id": "d755be56-db7e-4317-8d05-387807a1a892",
      "event_cluster_id": "4a8a1810-6ec2-40d6-8159-dfec11d084c9"
    },
    {
      "claim_cluster_id": "d0f7b20c-2bcb-454b-bc64-6c984732d241",
      "event_cluster_id": "468199d3-d972-44c7-826d-cc58f22c25eb"
    },
    {
      "claim_cluster_id": "4767808d-19a9-4e75-b8a7-7421cf37c72f",
      "event_cluster_id": "77fd60bb-096a-4b70-a630-b56ef3e8f647"
    },
    {
      "claim_cluster_id": "5d30cac5-2629-4bf5-9665-20ae87c1ec22",
      "event_cluster_id": "8d9c34af-fae3-4e38-87d1-1e67774753aa"
    },
    {
      "claim_cluster_id": "6a0b2cf5-23aa-458f-9dc9-7fde872ec6fc",
      "event_cluster_id": "7cb43f88-bfec-484a-965c-af899d9b8682"
    },
    {
      "claim_cluster_id": "bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a",
      "event_cluster_id": "89b14a97-e8c8-4e40-b25a-0dd26956ea7b"
    },
    {
      "claim_cluster_id": "89b28f7e-be14-417b-aeba-019498e50195",
      "event_cluster_id": "2f282f8f-f24b-4f4b-aa36-e5da41c21657"
    },
    {
      "claim_cluster_id": "8e9b5986-8277-45da-82c2-ab199cd3287f",
      "event_cluster_id": "9add2c84-55b8-4f75-bec3-d9a47e379ce8"
    },
    {
      "claim_cluster_id": "2105abe4-014b-48d8-a8a2-6e113ac81f52",
      "event_cluster_id": "8c441ed7-3996-46c2-abdc-191f54206cf6"
    },
    {
      "claim_cluster_id": "838b4697-b296-48c1-b248-3458bd1a5a35",
      "event_cluster_id": "30f5c3ba-9f54-4691-8863-1e644c87fbf8"
    },
    {
      "claim_cluster_id": "d089f75e-69ee-4713-8c0e-27843b110a2a",
      "event_cluster_id": "6e3b5d0b-67db-4d14-8384-2b3799aec6bd"
    },
    {
      "claim_cluster_id": "369b1cc5-aae5-4361-aabf-b1ef5c5350f8",
      "event_cluster_id": "7180dea2-3c60-4f47-892a-7e623057b51b"
    },
    {
      "claim_cluster_id": "41a156b3-5c3d-4d82-b8e4-7ad88953f690",
      "event_cluster_id": "662ce9d8-6ef2-47db-949f-92c2e48c1777"
    },
    {
      "claim_cluster_id": "a288cd72-4282-4ba7-b449-a353419578cd",
      "event_cluster_id": "0e8414db-df98-41e4-b595-a6e3b96bc6df"
    },
    {
      "claim_cluster_id": "56d92634-56f1-4385-a700-927cf573e5bc",
      "event_cluster_id": "8bade7cf-2f71-4a8c-ac8b-47b2764dd430"
    },
    {
      "claim_cluster_id": "41dd785c-3146-4243-8bbd-56211fadb273",
      "event_cluster_id": "36641d64-6f2c-4f28-a210-946f0a644597"
    },
    {
      "claim_cluster_id": "b693d408-b0fd-49d2-8eea-39016ff5fda7",
      "event_cluster_id": "66bbc9b1-3580-4b34-9ccc-f5983ea5120d"
    },
    {
      "claim_cluster_id": "af3aa521-118c-415e-b54b-524628af7168",
      "event_cluster_id": "147ac41a-7de3-4c4a-9213-48dfc49549a9"
    },
    {
      "claim_cluster_id": "3505030f-425f-4631-b164-fc25bf6fbe55",
      "event_cluster_id": "ab906a52-8ac1-4094-852d-28e22d75048c"
    },
    {
      "claim_cluster_id": "30011e47-1ff9-409e-8099-2eff6ab89e88",
      "event_cluster_id": "dba5927e-43c7-4d0e-9ca1-e78a9cdb024a"
    },
    {
      "claim_cluster_id": "059205f2-0c13-465b-ba40-83a1ffcbcaa3",
      "event_cluster_id": "55dcf158-5a10-408c-b74c-c53a42b859a3"
    },
    {
      "claim_cluster_id": "838b4697-b296-48c1-b248-3458bd1a5a35",
      "event_cluster_id": "5de51773-6a23-4bab-8c30-a41d42c69aaf"
    },
    {
      "claim_cluster_id": "0c685bcc-0513-4b5c-8ba7-c302c985ff66",
      "event_cluster_id": "d30fd077-478d-4784-a1a9-ce89125fa303"
    },
    {
      "claim_cluster_id": "3be4473d-cbba-49ee-93e6-36d5bcd0dc0a",
      "event_cluster_id": "6c709b7a-7374-4394-a975-41a7ad1dae38"
    },
    {
      "claim_cluster_id": "43beda49-4348-4ff0-94eb-8102078e161d",
      "event_cluster_id": "57d96007-f80d-4110-8583-3e280492b584"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "02063354-1cf2-4e4e-a749-ce91914994ae"
    },
    {
      "claim_cluster_id": "f58ca21a-7af7-4062-9509-f6480d8a6390",
      "event_cluster_id": "bac748cb-b035-4e91-bb5a-ab935807284d"
    },
    {
      "claim_cluster_id": "2052af74-0bc8-401c-a911-035e4f5f65d2",
      "event_cluster_id": "0978a576-627e-40f6-a382-f39885473545"
    },
    {
      "claim_cluster_id": "2a265a62-6ee2-460d-b6fd-ab72b8f23578",
      "event_cluster_id": "41ecf095-1caf-4be8-93aa-128fb386e8aa"
    },
    {
      "claim_cluster_id": "44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b",
      "event_cluster_id": "bcc8a49a-201a-439b-bf04-a72b13e50b57"
    },
    {
      "claim_cluster_id": "dac4f0e5-e31b-44cc-a055-3ac65eec9d11",
      "event_cluster_id": "b49995a8-19fd-4ac2-ad8e-2c1b565ef509"
    },
    {
      "claim_cluster_id": "9cc8f400-4462-4501-9bf3-f6cf35f7a110",
      "event_cluster_id": "2a893b9d-8c8b-4435-a26b-4a75f061537a"
    },
    {
      "claim_cluster_id": "ef502c1a-5f03-41b4-be90-14e6e1785625",
      "event_cluster_id": "517bce1b-0646-49a8-83b6-634d844a1495"
    },
    {
      "claim_cluster_id": "3b17ca99-a0cf-4b4c-a71f-c0181125d3ce",
      "event_cluster_id": "0ae66dca-634f-424b-80e9-5fc4b2615b98"
    },
    {
      "claim_cluster_id": "ee431334-0b63-4389-8c3c-60633233fd26",
      "event_cluster_id": "a75f7771-ca28-43b6-99aa-f4f9b0398268"
    },
    {
      "claim_cluster_id": "6670d6b8-9c36-4849-b28c-4959087df8d4",
      "event_cluster_id": "c6262c2d-c819-43cf-9414-2109754b60a0"
    },
    {
      "claim_cluster_id": "b61ba5b2-e28d-4cea-b7a2-78bed070aeca",
      "event_cluster_id": "b73efc0f-5d42-47ce-a8ed-e5aac2d0dd90"
    },
    {
      "claim_cluster_id": "5c533a3e-46e0-4800-bdb7-5c1521efbb3d",
      "event_cluster_id": "23f70c38-36fb-46d7-8b29-eb7e9349960a"
    },
    {
      "claim_cluster_id": "346f630a-2d46-4e8a-80ef-67a96ebf81ef",
      "event_cluster_id": "c5a49990-0bec-49b9-8797-00d71805007a"
    },
    {
      "claim_cluster_id": "6b512fcc-e6a2-414b-8a86-90a11b76795a",
      "event_cluster_id": "095f5894-d729-421f-8a47-470e675d8afa"
    },
    {
      "claim_cluster_id": "20b239ec-b263-4052-a330-5aad8ed1209b",
      "event_cluster_id": "c4e46a56-8890-41d4-ba88-174baf1248f9"
    },
    {
      "claim_cluster_id": "3d9bd6b9-ad1e-4d65-b911-715849482ace",
      "event_cluster_id": "f6d37781-75af-4b37-a9b4-49dbc27efba1"
    },
    {
      "claim_cluster_id": "30fdf9bb-e9b5-47e5-a899-e176ffa77eac",
      "event_cluster_id": "00d660d9-94af-474c-8e79-c16ac62cbef7"
    },
    {
      "claim_cluster_id": "a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4",
      "event_cluster_id": "4dd58e9c-790c-4f52-9fba-7f267f15da6d"
    },
    {
      "claim_cluster_id": "673d8d19-d059-4065-9b0d-82b1376c6c55",
      "event_cluster_id": "97cdd3f9-b13e-4b85-9e62-c48c3b34bca9"
    },
    {
      "claim_cluster_id": "b1951710-a9b4-42e8-b9e1-6ca4e5f12a31",
      "event_cluster_id": "a47f9935-dbc9-43e1-b673-236035daf9b2"
    },
    {
      "claim_cluster_id": "7a8e190a-4532-4e4a-b5bb-60a049f869c1",
      "event_cluster_id": "943f941b-168f-4ff6-86c1-d9d6b4c6fa28"
    },
    {
      "claim_cluster_id": "eb82caa7-6ef5-4182-a16e-ed0091be45ae",
      "event_cluster_id": "0d16b859-0b48-4545-ad3d-19b0d4601fe2"
    },
    {
      "claim_cluster_id": "017c8345-ee2f-4b6f-8701-6def5bbd5082",
      "event_cluster_id": "c98e55d1-dacb-46cd-b78b-7ec41169fc51"
    },
    {
      "claim_cluster_id": "21361eee-5fe8-48f0-a512-8a8c4752daae",
      "event_cluster_id": "ed8ee9d8-3361-4c66-86fb-3b0c6210300d"
    },
    {
      "claim_cluster_id": "db268f9a-c3a8-4e79-a3b0-df934c32f645",
      "event_cluster_id": "d2f70202-2b46-45a9-9905-a0ccfee90661"
    },
    {
      "claim_cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
      "event_cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0"
    },
    {
      "claim_cluster_id": "30fdf9bb-e9b5-47e5-a899-e176ffa77eac",
      "event_cluster_id": "1da8672c-062d-456c-b508-fef471a32245"
    },
    {
      "claim_cluster_id": "6c53a575-96c0-4b04-a196-adb1bbc90de7",
      "event_cluster_id": "b996a367-b4a5-4361-bd3d-e0e97f9ed9ca"
    },
    {
      "claim_cluster_id": "c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e",
      "event_cluster_id": "36641d64-6f2c-4f28-a210-946f0a644597"
    },
    {
      "claim_cluster_id": "0f1cacf9-3df0-4d00-8952-b3fa5195f1fb",
      "event_cluster_id": "75ec5d34-37c4-464a-bbb5-d624ce06eeb5"
    },
    {
      "claim_cluster_id": "0c6c9e5b-f8cc-4939-8319-4baf55259b87",
      "event_cluster_id": "89cee3a2-4f95-4473-859f-f9c42c415bf7"
    },
    {
      "claim_cluster_id": "e9caf6d9-2282-4c7e-9cd5-97529119edff",
      "event_cluster_id": "11ad6c89-9a64-4385-9a81-dfa3787cc401"
    },
    {
      "claim_cluster_id": "bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "00e4e855-edbf-4846-a824-47a6b221930a",
      "event_cluster_id": "a1084837-f12e-45c4-9bfb-1677ce1c51ad"
    },
    {
      "claim_cluster_id": "b5600099-12c0-41c7-bfb6-4b6bb66dc0dd",
      "event_cluster_id": "d33cb6f1-20b6-4555-be5a-7f0455de9471"
    },
    {
      "claim_cluster_id": "4acf918c-0778-4ee4-b773-26139df2ea2e",
      "event_cluster_id": "c0d885cd-8830-4032-af1c-4955d65db09a"
    },
    {
      "claim_cluster_id": "70534501-50ea-4dc4-9324-20539116bcb4",
      "event_cluster_id": "75c3bddb-8c4a-4274-ab4c-3cc28aeb2126"
    },
    {
      "claim_cluster_id": "7b68c402-465e-4abb-ac74-c3e397c8afdd",
      "event_cluster_id": "59a2b2e2-fda5-435b-a046-bc1854ba1410"
    },
    {
      "claim_cluster_id": "8499f04a-3cd9-4588-b8dd-3abc1c538bcf",
      "event_cluster_id": "7e9c2165-775e-4ecd-9551-bc96f366f674"
    },
    {
      "claim_cluster_id": "268e1143-4495-4247-af6b-b6f6f368f74f",
      "event_cluster_id": "ec4ecacf-5ed7-4202-a803-a46089704d53"
    },
    {
      "claim_cluster_id": "9f4b1362-f866-4431-983b-c739ed7f376e",
      "event_cluster_id": "6f086810-1930-4192-ad91-ce3f0eefd1aa"
    },
    {
      "claim_cluster_id": "0c63b123-d884-4e43-b541-3b36f23f2e96",
      "event_cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"
    },
    {
      "claim_cluster_id": "02c78b1c-dd55-4ba6-a345-d21fd27d3214",
      "event_cluster_id": "ac2593ad-b73a-4ed3-b199-eed400affdc8"
    },
    {
      "claim_cluster_id": "6d2fdf64-8424-4971-a998-3fe674aff124",
      "event_cluster_id": "028ee870-e258-43cd-99d3-f13e457b70d7"
    },
    {
      "claim_cluster_id": "8140cb8c-a254-4493-b790-598f4ef3676f",
      "event_cluster_id": "efe98b1b-e1ed-468a-9652-7acc5550430a"
    },
    {
      "claim_cluster_id": "69517d67-11aa-4671-bb8a-815c7995a3b7",
      "event_cluster_id": "0abb1373-3acc-4d19-880c-819af07a267f"
    },
    {
      "claim_cluster_id": "2bc0b07d-c668-4651-b1c3-1844786b5acb",
      "event_cluster_id": "a9c08567-c779-4007-8ddb-2cc8e3429124"
    },
    {
      "claim_cluster_id": "9562ace0-b924-497a-a3ab-5d483c835c5a",
      "event_cluster_id": "1f91813e-722c-47f3-81f9-6d98fd8c6b7d"
    },
    {
      "claim_cluster_id": "dcf5235c-74f7-409c-bb59-9454cc01feed",
      "event_cluster_id": "1118439e-1d54-4e33-bac7-0813c7dbb103"
    },
    {
      "claim_cluster_id": "6926f592-0807-43c3-9eb1-74f903b009ff",
      "event_cluster_id": "05b6ff5d-2ddf-4b71-b6f6-98defb612c16"
    },
    {
      "claim_cluster_id": "3444a924-096b-4eda-877c-4c6412d885cd",
      "event_cluster_id": "692b8f3b-7c78-4cbb-b4e5-764b2d4124bb"
    },
    {
      "claim_cluster_id": "2790abdc-e882-4d8a-90ac-fbfc5b896052",
      "event_cluster_id": "fd3d778c-3ff6-495b-bf3c-b5711ab1a974"
    },
    {
      "claim_cluster_id": "40860ef8-1ebc-45f7-84a0-735bcdaf070c",
      "event_cluster_id": "4d8a4d68-4905-4d57-b3f8-91de6feb19b0"
    },
    {
      "claim_cluster_id": "c7bb1d74-7395-4554-a7ef-ec1f5c743579",
      "event_cluster_id": "903140f6-5deb-4b0a-b645-3ff3ded85a2c"
    },
    {
      "claim_cluster_id": "43784351-864b-42c8-bac5-2de22a3743c2",
      "event_cluster_id": "b5d6d05a-3d31-4ce5-aa84-cf94365c8485"
    },
    {
      "claim_cluster_id": "d5458c27-5843-4ff6-b105-7703aeb6f588",
      "event_cluster_id": "8b0583af-b0d6-4ff0-b992-807e026b5368"
    },
    {
      "claim_cluster_id": "dc8d69ed-9d9d-4c04-a104-2c89e796edf3",
      "event_cluster_id": "923c46a3-c0b6-4907-a189-66afd503c6b7"
    },
    {
      "claim_cluster_id": "253e2fef-8100-4235-899c-96e9877535d1",
      "event_cluster_id": "05f00def-a8b8-4cdc-94a6-9ead4bc629d3"
    },
    {
      "claim_cluster_id": "74f7c7d8-aba9-45e9-a386-fbb258dd884d",
      "event_cluster_id": "2f4e138b-a8ca-4c68-be26-24de0c3b0489"
    },
    {
      "claim_cluster_id": "e1ed1afc-85b6-4c69-a063-e486d1e3670f",
      "event_cluster_id": "2311e718-cd29-45c2-b4e7-6c01097b3aea"
    },
    {
      "claim_cluster_id": "0c63b123-d884-4e43-b541-3b36f23f2e96",
      "event_cluster_id": "f5af21c1-57be-4378-ab8c-5400cfed6bff"
    },
    {
      "claim_cluster_id": "8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0",
      "event_cluster_id": "5e0be9c9-87ac-49bb-a807-6e19f719434d"
    },
    {
      "claim_cluster_id": "09060ad9-5546-4c31-ae6b-321cd8a78d5b",
      "event_cluster_id": "9a0e60e0-9d22-43df-bc7c-6bb5028125f2"
    },
    {
      "claim_cluster_id": "4ac1da2e-cd03-4a11-b440-f62dc8f73aad",
      "event_cluster_id": "997b033a-0811-49fe-bc36-8ee742156833"
    },
    {
      "claim_cluster_id": "dcf5235c-74f7-409c-bb59-9454cc01feed",
      "event_cluster_id": "bf711cc9-463c-4a50-a300-d24703735ee6"
    },
    {
      "claim_cluster_id": "70b45d78-dfac-4810-b7f6-abeea55c435f",
      "event_cluster_id": "5c1805d7-899d-486a-b79f-793a9703c022"
    },
    {
      "claim_cluster_id": "51207b82-ee2c-47cd-adf4-cdd41f93d43d",
      "event_cluster_id": "4c5edc98-f936-4e09-a25f-11ad3a0a3ce0"
    },
    {
      "claim_cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "3b793f1b-9892-4efb-9252-e394792997b5",
      "event_cluster_id": "71a8fcbe-7e01-4380-bb3a-befa2ea629f1"
    },
    {
      "claim_cluster_id": "945e1233-33d5-4259-ad28-2899aa78e0e9",
      "event_cluster_id": "c368702b-96c0-4866-81f4-7cb0750c1bcd"
    },
    {
      "claim_cluster_id": "68152d77-1b3b-45af-8c06-88cf78f6a175",
      "event_cluster_id": "af90686d-77e8-4713-873e-8c63e5dbe370"
    },
    {
      "claim_cluster_id": "e455cd44-cd3c-4e6c-a847-ff250278123c",
      "event_cluster_id": "8d63a231-4f96-4fb0-aa81-938182c806dd"
    },
    {
      "claim_cluster_id": "df5b4e50-7d1b-4d7e-ae01-046530298250",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "185ce1be-2776-4956-849c-f83438c57def",
      "event_cluster_id": "546a15bc-833d-4e92-8945-cbee19b7d4ca"
    },
    {
      "claim_cluster_id": "fc45a344-4cfc-4865-9030-d033f0c8dff3",
      "event_cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0"
    },
    {
      "claim_cluster_id": "67c32fef-bbe8-4245-9a91-7d8aee491367",
      "event_cluster_id": "ebb2f2f8-c476-4b98-bd7c-c0a3ef8345f6"
    },
    {
      "claim_cluster_id": "da4e5cde-efc2-4363-87b4-b9935cc2b21d",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
      "event_cluster_id": "7c8877ae-f397-490e-9778-67a6e91ebe1c"
    },
    {
      "claim_cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
      "event_cluster_id": "b97c97e0-114f-4fea-812a-38dca08108e6"
    },
    {
      "claim_cluster_id": "131fc120-2488-4970-ac79-410004aa6030",
      "event_cluster_id": "ec9bc095-279f-474f-9706-4d758de892be"
    },
    {
      "claim_cluster_id": "a8177a52-bb93-4070-be93-33bdb7e54f7f",
      "event_cluster_id": "5bae13a5-6b81-425d-a9bb-49850203205e"
    },
    {
      "claim_cluster_id": "03b72068-02c5-403e-b844-88e40b030a18",
      "event_cluster_id": "9f713e34-d77c-4dee-b4cc-dc4204b450f3"
    },
    {
      "claim_cluster_id": "8ac816b2-de5c-4294-a968-e6279613b1d8",
      "event_cluster_id": "dd63046f-83c4-4d5e-867a-2f14376d2ce2"
    },
    {
      "claim_cluster_id": "729e67ef-32fc-4882-8297-9f443b6f2589",
      "event_cluster_id": "89133653-febf-4b4b-840d-0cb05ed61f86"
    },
    {
      "claim_cluster_id": "56d92634-56f1-4385-a700-927cf573e5bc",
      "event_cluster_id": "0c8a0c77-de1d-4094-93a5-9ea4a0ec06b4"
    },
    {
      "claim_cluster_id": "b8299ae1-9e2e-465d-af82-b9354f3e9c44",
      "event_cluster_id": "3a1c15cf-9c77-4bd8-9e70-266829c039f2"
    },
    {
      "claim_cluster_id": "d8515ae8-12a5-4f84-b01f-bc10b41b19e0",
      "event_cluster_id": "83bfa8ce-e39f-4c0f-b6f0-a55302bf1e3d"
    },
    {
      "claim_cluster_id": "8bc3dd02-5989-4bb6-8266-c27296d666f8",
      "event_cluster_id": "b2e518c2-bee5-4258-9f37-d52e83d13a76"
    },
    {
      "claim_cluster_id": "aa7a9a4f-e437-468a-8a0c-4d2441978380",
      "event_cluster_id": "6310600c-941f-4d69-826e-9f6645778d3e"
    },
    {
      "claim_cluster_id": "30ae8997-b16b-4477-bfec-33c1a345955b",
      "event_cluster_id": "34cd8ac5-1cee-4a93-bb46-48f954524f09"
    },
    {
      "claim_cluster_id": "14b46c0a-7b16-4722-b599-90d7d69970a1",
      "event_cluster_id": "4941b2f5-904f-4963-b690-18f3bf3075c7"
    },
    {
      "claim_cluster_id": "a536505f-e31a-400e-a4a5-1f74a9e29e7d",
      "event_cluster_id": "64ce313a-9f62-48b5-ac72-4f4f23b43da9"
    },
    {
      "claim_cluster_id": "58a7d973-9fa3-4047-a219-579a31c4561b",
      "event_cluster_id": "b5f5c5e5-6c1a-4551-a786-04806a60e9b1"
    },
    {
      "claim_cluster_id": "9a34d174-5513-4924-bed6-11de3ec56881",
      "event_cluster_id": "c97fb561-3217-4665-93fe-191384f9c143"
    },
    {
      "claim_cluster_id": "2669ad24-9832-49ab-a24d-8ef6f0986ed6",
      "event_cluster_id": "5535ff65-262d-4c0d-a8e9-0c0a87d3ccdf"
    },
    {
      "claim_cluster_id": "a9096ed8-3c07-4fd9-a21c-9fdb59fe1353",
      "event_cluster_id": "4bc67839-1a76-467a-8232-39c9eb846df7"
    },
    {
      "claim_cluster_id": "8b2d10cc-94ea-4d53-a196-ecebccd79020",
      "event_cluster_id": "ddc509de-3359-4d1f-94b5-786fbe3bdc35"
    },
    {
      "claim_cluster_id": "5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4",
      "event_cluster_id": "5edd87a6-3d98-4e7d-9e60-b94920fc071d"
    },
    {
      "claim_cluster_id": "258085e5-fc49-48d1-b3f4-3f9862c3ba91",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "69c28a9e-902d-4ac0-9540-ae2854dbb59f",
      "event_cluster_id": "da473e07-5f99-4854-b0f9-aaba62b413c0"
    },
    {
      "claim_cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
      "event_cluster_id": "983a818a-ed6d-40ec-af64-8e28da7e1bbd"
    },
    {
      "claim_cluster_id": "7fb4d786-0c9f-4d33-a3fb-8326f548d1e1",
      "event_cluster_id": "38be1a05-48d2-4f48-88ba-580b1bbdcf47"
    },
    {
      "claim_cluster_id": "078f370f-a761-435a-a7fd-aae948eb479b",
      "event_cluster_id": "e2349307-7610-418e-8e9d-d6184ecce651"
    },
    {
      "claim_cluster_id": "87e51e32-d441-41a9-8026-a751a57b0ed2",
      "event_cluster_id": "5256265d-d143-4d8d-91b5-fc2bd6f31e20"
    },
    {
      "claim_cluster_id": "ced45aa6-b370-4a79-b76b-674fcd6c0668",
      "event_cluster_id": "8c588fd7-3da5-41c8-be96-210ededa9175"
    },
    {
      "claim_cluster_id": "ac1f3497-64d3-4909-9d61-789e683556a9",
      "event_cluster_id": "b4f7c43a-b96f-4977-a6a9-ad07015e8976"
    },
    {
      "claim_cluster_id": "3428edf1-36a0-4018-889a-63913498a6c3",
      "event_cluster_id": "cc554329-dead-4eef-88f0-c2d38423ce88"
    },
    {
      "claim_cluster_id": "a7436ce6-07d0-45e0-8628-2de252e4cb46",
      "event_cluster_id": "c537edf5-ee14-4fb6-9cf6-9d972fbc67cb"
    },
    {
      "claim_cluster_id": "eee91c5f-8ac6-4779-af53-8a01aa4eaa03",
      "event_cluster_id": "2f0a7237-fd9a-4068-942a-5cae35e4e123"
    },
    {
      "claim_cluster_id": "860407b5-0931-4ba2-9dbd-a0078e94e9c6",
      "event_cluster_id": "68995fc4-d783-494b-a9d8-283e32c04543"
    },
    {
      "claim_cluster_id": "5240d9cd-db46-4ffc-ae97-0e3a2b73b3fe",
      "event_cluster_id": "fc3a7125-d930-4cc4-ae3e-0da6ebe44d84"
    },
    {
      "claim_cluster_id": "63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7",
      "event_cluster_id": "9be2ee3c-9f9c-4f35-baba-22913c8be73a"
    },
    {
      "claim_cluster_id": "a316407d-a413-48ec-95c7-f1a3c83da782",
      "event_cluster_id": "6707f20d-c9f4-42bc-ba94-e97c87eae6e1"
    },
    {
      "claim_cluster_id": "adcb219f-1d0a-4b1b-924d-ded66e2d2c1c",
      "event_cluster_id": "8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35"
    },
    {
      "claim_cluster_id": "507dd458-2eaf-480a-89be-7acf52e56a97",
      "event_cluster_id": "55c3e6f5-571c-4234-bde1-164fbe090fa3"
    },
    {
      "claim_cluster_id": "f7811e36-516c-4780-b025-c2c198f87bba",
      "event_cluster_id": "306af663-29dc-401c-bb87-b5eb6547c25e"
    },
    {
      "claim_cluster_id": "dec098ce-5baa-400b-a766-6543ab0afe00",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "f61b95fd-4ab1-43f9-b2f8-53b5afb90d43",
      "event_cluster_id": "cb2e6a9c-ffbe-4a9d-a4eb-32e21489b61a"
    },
    {
      "claim_cluster_id": "fbea59dc-8fdc-4fcf-ac76-32627af107ae",
      "event_cluster_id": "309e6017-5ba6-4aa5-918a-e978302b6d2d"
    },
    {
      "claim_cluster_id": "63bcdf8d-5d7d-43eb-b5b5-735ed74b200a",
      "event_cluster_id": "6988ebca-b8d5-4719-a15d-b25c13a58367"
    },
    {
      "claim_cluster_id": "4ea56329-d3e1-48ab-835d-a5cbc403dcf0",
      "event_cluster_id": "57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"
    },
    {
      "claim_cluster_id": "637d133e-6c19-4fa2-b174-de1d016bd9bc",
      "event_cluster_id": "ebdd6e62-4f71-4eeb-b5bb-afa4c515a612"
    },
    {
      "claim_cluster_id": "10bf083b-35c8-4b77-a2d9-e4cb3813d9fb",
      "event_cluster_id": "43f42741-0a89-4a0f-bdee-4f8b6bc2f468"
    },
    {
      "claim_cluster_id": "de7a466b-9657-42fc-adc1-63e65b4ec1ea",
      "event_cluster_id": "1f87ca5e-f76a-465d-9deb-690952b6b443"
    },
    {
      "claim_cluster_id": "99f11e8b-4375-4ee6-8be9-78b8355c6e63",
      "event_cluster_id": "60a99f19-657e-458b-aa53-ca2a6063f380"
    },
    {
      "claim_cluster_id": "4f4a8dcc-ad59-4dfb-b222-e025fb0c418e",
      "event_cluster_id": "1f539237-1caf-4525-9adc-af33bb645e44"
    },
    {
      "claim_cluster_id": "21ae851f-14b0-4e6c-8bf6-1ff87dabd880",
      "event_cluster_id": "028454b9-ae0f-4b68-8959-098c138f4548"
    },
    {
      "claim_cluster_id": "a15b31ed-89e7-4c30-9559-8eac356b32e1",
      "event_cluster_id": "fa02e97b-06d3-4b6b-83c2-ad956c6a8f2a"
    },
    {
      "claim_cluster_id": "6d2fdf64-8424-4971-a998-3fe674aff124",
      "event_cluster_id": "98c5d764-86f9-4cd2-ac58-1dae1f5811e9"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "5787a927-39a0-4bb7-92d5-230091f48a3e"
    },
    {
      "claim_cluster_id": "44a47e28-efc2-4e0c-b9c2-18a93b3b20be",
      "event_cluster_id": "92111d3f-ebb0-4617-aa4c-9df22ddccd03"
    },
    {
      "claim_cluster_id": "e1f9f42d-4c64-42c8-80ee-89170b717dbd",
      "event_cluster_id": "7c8be876-c0d6-46b2-8e28-be16ba79de4f"
    },
    {
      "claim_cluster_id": "5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4",
      "event_cluster_id": "24f76117-6d13-47b7-8b5c-41608f921324"
    },
    {
      "claim_cluster_id": "e21b1b35-31f0-4c02-9069-b35c0b38b172",
      "event_cluster_id": "499883aa-4d50-44a0-85ba-67de7dd41a9e"
    },
    {
      "claim_cluster_id": "13fc2321-1fdf-40d3-8576-3d7e5eb9e53d",
      "event_cluster_id": "3e481577-f346-4d0d-88ef-e1132e39baa4"
    },
    {
      "claim_cluster_id": "260b5cb2-3dad-42a1-a677-cfe24a203765",
      "event_cluster_id": "2d5f7bd3-4c30-4ae5-a057-0f3e35a0cb68"
    },
    {
      "claim_cluster_id": "ef74ac2b-9f0b-4cf7-9e95-c36f4d327f7c",
      "event_cluster_id": "36d66c66-9c93-4123-875e-3e9fbe514722"
    },
    {
      "claim_cluster_id": "45339238-abb3-494b-a7ba-d3cde2ab18d9",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "051c1a4e-08fc-4a09-9e34-8d3d8d646136",
      "event_cluster_id": "31c80f95-812a-49ce-aa97-208d1f8f4713"
    },
    {
      "claim_cluster_id": "99f11e8b-4375-4ee6-8be9-78b8355c6e63",
      "event_cluster_id": "3c02cb9f-d868-4d95-a235-953e540c09c9"
    },
    {
      "claim_cluster_id": "066ea292-674c-44ee-8c3c-799b0ecf024c",
      "event_cluster_id": "3fab82c9-6db0-4a96-9fa3-7e0add6da8ba"
    },
    {
      "claim_cluster_id": "57cf4546-a43b-4620-acde-18ad68b95dcc",
      "event_cluster_id": "fa5edee7-14cd-46f2-b781-a5794e463daa"
    },
    {
      "claim_cluster_id": "70898fa9-9960-49d5-b422-3f77d073d86b",
      "event_cluster_id": "8191e288-4dd0-423e-bf77-953449ad8b80"
    },
    {
      "claim_cluster_id": "1f8ce922-0e37-4ccb-b586-67da18764d96",
      "event_cluster_id": "72084673-8080-44fd-8f5b-97507abf262b"
    },
    {
      "claim_cluster_id": "59d7630c-86a6-4185-b052-67ad13c627a8",
      "event_cluster_id": "9e250f91-2983-4cf6-9b29-817f4271a911"
    },
    {
      "claim_cluster_id": "b39e93e4-b791-4b1e-963b-d8f068ff0b1d",
      "event_cluster_id": "890e1bc7-85dc-4ae9-985a-8f81d088f89a"
    },
    {
      "claim_cluster_id": "e126486d-8b99-4425-b6a3-54724b486b78",
      "event_cluster_id": "abea76a9-3994-48b0-b3bb-df2d7f55ad12"
    },
    {
      "claim_cluster_id": "fcc58b11-54f2-420b-99e3-8acb8731fd15",
      "event_cluster_id": "7deb6d52-1ec6-4691-a2b6-0e60470c80a3"
    },
    {
      "claim_cluster_id": "be467aaa-b350-4a63-875e-7aa61c3d868a",
      "event_cluster_id": "5a50b06e-be6d-445e-97b7-86a315a41b46"
    },
    {
      "claim_cluster_id": "56e6ff33-547f-4d6b-a7a7-e1266368fdd7",
      "event_cluster_id": "95caea6a-ff66-40ac-9167-0fca6baadbff"
    },
    {
      "claim_cluster_id": "e3e8a87e-df24-4ad1-b44d-15176f0a0f6f",
      "event_cluster_id": "1fb31a41-f917-4cde-9190-f353f630be9a"
    },
    {
      "claim_cluster_id": "43beda49-4348-4ff0-94eb-8102078e161d",
      "event_cluster_id": "db2b5d72-303d-4743-8188-e92d23a86e05"
    },
    {
      "claim_cluster_id": "42734325-e832-49e4-b0f3-d3af89abdf66",
      "event_cluster_id": "e0c1caae-a4c5-46c2-a58a-61bf54ce7094"
    },
    {
      "claim_cluster_id": "258085e5-fc49-48d1-b3f4-3f9862c3ba91",
      "event_cluster_id": "f9e1ae92-90cd-4553-9870-a06691bcf1d5"
    },
    {
      "claim_cluster_id": "289e5c59-c24f-465d-931a-b56b54bc982f",
      "event_cluster_id": "9f2f375c-af55-44d4-8d17-dfc761b029ac"
    },
    {
      "claim_cluster_id": "89b28f7e-be14-417b-aeba-019498e50195",
      "event_cluster_id": "733fc34a-7676-43b2-bd68-29d000ed566d"
    },
    {
      "claim_cluster_id": "05302999-a145-4cb2-83a6-b2cda0247938",
      "event_cluster_id": "8bd4a872-0209-415e-a7b8-b4acaf26a95b"
    },
    {
      "claim_cluster_id": "a7d034a7-5705-462b-af06-b9277d91c75a",
      "event_cluster_id": "1a1de2a4-159f-4a0d-8a46-97165bf27583"
    },
    {
      "claim_cluster_id": "489bde91-1bfc-48d6-aae7-de380d23d205",
      "event_cluster_id": "2d972490-4937-489e-9570-c5d28d63e725"
    },
    {
      "claim_cluster_id": "9f0480ce-b886-46fa-98f0-af8144766c6c",
      "event_cluster_id": "7c25f378-94ec-4e09-b534-e05191ebdf2b"
    },
    {
      "claim_cluster_id": "c831921a-fda1-47ba-83e1-1042bd97f245",
      "event_cluster_id": "6d5fe755-2873-4033-93ec-3d174da34a66"
    },
    {
      "claim_cluster_id": "b9eca2e7-5401-453f-8490-81ec97719e08",
      "event_cluster_id": "a6590632-faef-4956-b655-28617cdf7601"
    },
    {
      "claim_cluster_id": "0d0fd5f0-0301-424f-b0b1-a60ab6ca045f",
      "event_cluster_id": "efecc9d7-3e88-45ed-b11f-77af1e65000e"
    },
    {
      "claim_cluster_id": "f8755b86-ae98-461e-a3ac-2bd5b6ec4310",
      "event_cluster_id": "21e6b94f-0371-4a78-aa0e-8082ef7b0068"
    },
    {
      "claim_cluster_id": "5edd935c-f1a4-4a6b-86a0-37894c0716f8",
      "event_cluster_id": "95bbf098-c966-4fbc-93df-23d227e7ee92"
    },
    {
      "claim_cluster_id": "d0f7b20c-2bcb-454b-bc64-6c984732d241",
      "event_cluster_id": "4e53d403-5bf1-47ce-a5d9-ecd50db35ad9"
    },
    {
      "claim_cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
      "event_cluster_id": "48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"
    },
    {
      "claim_cluster_id": "d5dab78c-a52b-4ef8-8000-44988a029a7c",
      "event_cluster_id": "798603bf-ed29-47ab-b596-b02a192b8a20"
    },
    {
      "claim_cluster_id": "8e782418-3f83-48d1-a7d0-6c3daf34ed25",
      "event_cluster_id": "2962a54a-b1d0-48df-9318-1e0f945ac7d0"
    },
    {
      "claim_cluster_id": "9adce26b-ced3-4b3b-ac9a-24b78e98224d",
      "event_cluster_id": "6190dfba-afce-482c-ab6b-30cfbc88a521"
    },
    {
      "claim_cluster_id": "6f847ace-00e0-4009-b5e9-3729f7a9e244",
      "event_cluster_id": "e8195223-1d62-4704-93af-859b0cc35da8"
    },
    {
      "claim_cluster_id": "21228a2d-48c0-43f0-b18d-e85ff94cdb4e",
      "event_cluster_id": "3f32031e-6be6-43ce-bffb-40370a2c9f89"
    },
    {
      "claim_cluster_id": "5ec8ba1f-609d-4689-8317-8045f6c09e77",
      "event_cluster_id": "16d77388-3cab-4281-9420-51dc93557442"
    },
    {
      "claim_cluster_id": "09060ad9-5546-4c31-ae6b-321cd8a78d5b",
      "event_cluster_id": "e294ae03-93b8-4461-85ca-920f88826e8a"
    },
    {
      "claim_cluster_id": "5acf0ec4-be26-4926-a6a6-508ec71aaa6e",
      "event_cluster_id": "21435744-bfd5-457c-9149-a1cc5945dbec"
    },
    {
      "claim_cluster_id": "194a083f-fee7-4bf0-b198-fa40c8bdfe21",
      "event_cluster_id": "4a10d70f-5f46-496e-a6f4-0b982956d03f"
    },
    {
      "claim_cluster_id": "30ae8997-b16b-4477-bfec-33c1a345955b",
      "event_cluster_id": "add377ce-a507-4594-9a7c-9c1c608ed972"
    },
    {
      "claim_cluster_id": "af3f95a3-d597-4371-bf7f-e4f5d91a9b73",
      "event_cluster_id": "2d61e1a4-f82f-42d3-8440-ae35b51fa374"
    },
    {
      "claim_cluster_id": "9b14cd61-494b-4ae7-a7c2-3720adae8787",
      "event_cluster_id": "50cf17ff-24f7-4dfd-958b-756aec4fd4e0"
    },
    {
      "claim_cluster_id": "40739d2a-a8c2-4f74-ad24-d1d6db92d225",
      "event_cluster_id": "69dae690-93b2-445c-aba3-76b5fc2d7711"
    },
    {
      "claim_cluster_id": "6eb67c15-59c3-481b-bf8b-2e464b0775ec",
      "event_cluster_id": "725d8a20-a3a3-4517-9549-74f8eede8ff7"
    },
    {
      "claim_cluster_id": "9f76cab0-c9b8-4e12-bd91-cd1c5474c649",
      "event_cluster_id": "c97fb561-3217-4665-93fe-191384f9c143"
    },
    {
      "claim_cluster_id": "3b17ca99-a0cf-4b4c-a71f-c0181125d3ce",
      "event_cluster_id": "12975b02-1543-4e2e-83d5-f31f56ef1664"
    },
    {
      "claim_cluster_id": "369b1cc5-aae5-4361-aabf-b1ef5c5350f8",
      "event_cluster_id": "4606c4da-4d5c-4ad6-8119-d1b70a950373"
    },
    {
      "claim_cluster_id": "eb38bdfb-232f-4460-8d60-fc8806237786",
      "event_cluster_id": "6a7bb883-6ee7-43ec-b992-6e755312804e"
    },
    {
      "claim_cluster_id": "840a2e45-449a-4234-be31-852cc48c1642",
      "event_cluster_id": "9c904ce8-82eb-4f73-b9ea-f510b0249486"
    },
    {
      "claim_cluster_id": "38c71e65-4039-4578-b30f-f1a4d6dd193f",
      "event_cluster_id": "a300ef79-1ea5-4eb4-b149-74426ea09a66"
    },
    {
      "claim_cluster_id": "ac5cef85-9755-4d73-a0c9-3b2d779220c4",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "162b03a4-86a7-4adf-9f73-3093aecba542",
      "event_cluster_id": "e50f2f1a-20bb-46bb-82c9-6def0deadc19"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "41895296-6f09-4b44-a2d4-3d90f2e03b81"
    },
    {
      "claim_cluster_id": "ef13681f-975e-44f8-8e95-a6963670af11",
      "event_cluster_id": "2e0416ba-2a52-4d60-ab33-cf2ac09ef620"
    },
    {
      "claim_cluster_id": "5b52495b-d578-4d45-975c-d2e0417f4501",
      "event_cluster_id": "53ab10ad-1f0b-48bb-90af-3977fee7f1cb"
    },
    {
      "claim_cluster_id": "97f84153-8f49-432f-a8f7-a4e57fe7f769",
      "event_cluster_id": "59ac47e6-50e9-4884-a676-2542dc8e0aa3"
    },
    {
      "claim_cluster_id": "bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75",
      "event_cluster_id": "fd5ddb7c-f743-498e-b007-014e9c97bbc8"
    },
    {
      "claim_cluster_id": "0d0fd5f0-0301-424f-b0b1-a60ab6ca045f",
      "event_cluster_id": "f78fd02c-7e3c-43a4-8429-a28909b13242"
    },
    {
      "claim_cluster_id": "bc2e7af6-3507-403a-b41c-f6013dcfcf6c",
      "event_cluster_id": "afe97367-2dde-46dd-9395-2e46792da8d8"
    },
    {
      "claim_cluster_id": "362947dd-8703-496a-89bc-c395dcec13b9",
      "event_cluster_id": "758b1960-78c3-42a0-8a1a-c0d1f47c547d"
    },
    {
      "claim_cluster_id": "cbb443ee-8a98-4074-9a33-690c1a4267b8",
      "event_cluster_id": "ef5dda09-a763-4471-8324-78da714107dc"
    },
    {
      "claim_cluster_id": "8ae88722-b8db-4d5b-b13e-130f65630e05",
      "event_cluster_id": "45f9b0ec-ee3d-4cf9-bf46-990d297136a8"
    },
    {
      "claim_cluster_id": "78cbe3d8-37f7-4a89-956e-f6dab20ad8d1",
      "event_cluster_id": "e34b1053-1f91-4dd8-9190-a7ed9dea81f8"
    },
    {
      "claim_cluster_id": "60b71403-253c-4f7c-b96e-fb2306a7cebf",
      "event_cluster_id": "95799deb-0b6c-4eb9-bc15-24b196417c4d"
    },
    {
      "claim_cluster_id": "d0f7b20c-2bcb-454b-bc64-6c984732d241",
      "event_cluster_id": "0e976646-d8b3-435d-b262-71720e81ac06"
    },
    {
      "claim_cluster_id": "df13c28d-11fd-4cdc-a0c7-5076d0c46483",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "9adce26b-ced3-4b3b-ac9a-24b78e98224d",
      "event_cluster_id": "7dfb31d5-ddb8-4d40-bb81-cb884f7a73bd"
    },
    {
      "claim_cluster_id": "3ffaa02c-962d-45fa-a9aa-01f8e41dda01",
      "event_cluster_id": "cc95457a-219b-4008-9216-67e0ee2bc74c"
    },
    {
      "claim_cluster_id": "947b44c6-b504-4d59-ad29-0dd1f0776154",
      "event_cluster_id": "819f43eb-3e2d-4107-9997-bfc9d26133c5"
    },
    {
      "claim_cluster_id": "70898fa9-9960-49d5-b422-3f77d073d86b",
      "event_cluster_id": "35b669fa-cc15-4619-8262-2bd41f0ca610"
    },
    {
      "claim_cluster_id": "36824238-8532-447a-aacf-ef3f59e89c60",
      "event_cluster_id": "76435864-5754-43fe-ba96-2ebbad51c5b7"
    },
    {
      "claim_cluster_id": "87e51e32-d441-41a9-8026-a751a57b0ed2",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "73ed8dfb-71b9-42f0-9f45-a873045bd275",
      "event_cluster_id": "5eac68c0-2a04-4e6c-af79-6d253e14522a"
    },
    {
      "claim_cluster_id": "7c3b0d63-9fd5-46b2-943f-8bc9d4005fc6",
      "event_cluster_id": "d494f4b2-e7a8-444d-9de4-a124202cacaf"
    },
    {
      "claim_cluster_id": "237a5318-2edd-4ffc-869f-c0fed9502097",
      "event_cluster_id": "f3191f0a-3803-4bca-ad51-304e3f825638"
    },
    {
      "claim_cluster_id": "210242d8-e5cc-4762-9912-b262084ebeb4",
      "event_cluster_id": "00d660d9-94af-474c-8e79-c16ac62cbef7"
    },
    {
      "claim_cluster_id": "a9096ed8-3c07-4fd9-a21c-9fdb59fe1353",
      "event_cluster_id": "ebe02d8b-ea82-4232-851f-f5ea26e54e8f"
    },
    {
      "claim_cluster_id": "7b08a98a-0129-4cec-b114-1fff26d56746",
      "event_cluster_id": "1936e9be-7524-40a3-aeef-be93dc5f5e4c"
    },
    {
      "claim_cluster_id": "a2f18fa4-3554-4400-be7d-a33cb07dfa44",
      "event_cluster_id": "b40d77a1-3074-4669-a3a8-f64b6de7cd03"
    },
    {
      "claim_cluster_id": "c39e0166-c55b-4f71-8bb5-e23985802606",
      "event_cluster_id": "38653b72-3e71-45be-a6f6-9c4e86755c1b"
    },
    {
      "claim_cluster_id": "e6bef1f7-9387-45ab-918c-0df479862034",
      "event_cluster_id": "0c50a72f-e964-4690-a33f-e878b2e74702"
    },
    {
      "claim_cluster_id": "a03d3de9-e5ad-47e0-9374-17e6c1998859",
      "event_cluster_id": "fe0af648-ca07-4de6-9db2-4c1067118254"
    },
    {
      "claim_cluster_id": "3fc70d09-8a93-4a60-b903-b03cd4187227",
      "event_cluster_id": "49b71ab3-8ddf-486a-9781-e873ef1c9042"
    },
    {
      "claim_cluster_id": "a9096ed8-3c07-4fd9-a21c-9fdb59fe1353",
      "event_cluster_id": "4cb50541-3268-48df-a49c-2b4593404e93"
    },
    {
      "claim_cluster_id": "4acf918c-0778-4ee4-b773-26139df2ea2e",
      "event_cluster_id": "1e13c242-ece9-4014-9237-1eaa4afdacf0"
    },
    {
      "claim_cluster_id": "97d6f1ef-2f69-4bd7-b5ce-8c3dd359bfcb",
      "event_cluster_id": "c00c750e-a740-40f2-8fc7-77d5f6c8fe81"
    },
    {
      "claim_cluster_id": "7ac1c88c-d620-4c32-9f9d-5a780231627e",
      "event_cluster_id": "1fb14eaa-5808-4fba-b78b-8331f9693364"
    },
    {
      "claim_cluster_id": "90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410",
      "event_cluster_id": "37c144c2-5b3d-4b37-81ec-b6ea11090b3a"
    },
    {
      "claim_cluster_id": "a0aafb48-1cc4-47f3-9cc7-073b87c64efc",
      "event_cluster_id": "3e87c12e-871b-4773-8173-d484141c190e"
    },
    {
      "claim_cluster_id": "6826010f-2a38-48a2-a358-b062edaa9ed4",
      "event_cluster_id": "6694e203-070f-4cf7-a327-66b5e005a5e4"
    },
    {
      "claim_cluster_id": "7325cc3b-df7f-4451-948f-1ce21f12d10f",
      "event_cluster_id": "248cf9f0-85b2-4eae-9028-789470700e69"
    },
    {
      "claim_cluster_id": "58a60e5c-9e5a-48ce-a07c-a7168b46ba2f",
      "event_cluster_id": "f10864eb-56bf-40a9-9f67-5dfe4ef70806"
    },
    {
      "claim_cluster_id": "bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb",
      "event_cluster_id": "36641d64-6f2c-4f28-a210-946f0a644597"
    },
    {
      "claim_cluster_id": "cdd48d7f-71ad-45d9-b5c0-d84849f26b67",
      "event_cluster_id": "4da675eb-3ccd-4c4a-852a-837897424712"
    },
    {
      "claim_cluster_id": "f0190a02-daf5-48b7-8174-720b52c75550",
      "event_cluster_id": "96226cbe-6ce7-473a-a2c5-bcfa1fa15be9"
    },
    {
      "claim_cluster_id": "fd11e091-21e1-40df-916b-90aba2945065",
      "event_cluster_id": "ee6ffddc-d717-4a7b-a161-3d1bdc24c500"
    },
    {
      "claim_cluster_id": "e205a390-4f4b-4898-961e-ef5a0bf3f3d0",
      "event_cluster_id": "7688d917-39a4-49c8-8503-8ffed77c6807"
    },
    {
      "claim_cluster_id": "12c3a33b-fd70-46a3-a74c-86b922244369",
      "event_cluster_id": "ef77006d-68d7-4c27-ae83-cb85890ca2b1"
    },
    {
      "claim_cluster_id": "f44705d5-ac0c-43e4-b025-c68545daa916",
      "event_cluster_id": "3dfd5a3b-6011-45c7-8661-03086fa25dc5"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "e17360aa-cb4e-4e41-913f-f3e853c44fd4"
    },
    {
      "claim_cluster_id": "cba79c22-94bf-4911-a28d-ebd794325eaa",
      "event_cluster_id": "7fb1b61e-8a8c-43db-8218-8780b6b4a6d9"
    },
    {
      "claim_cluster_id": "6d2792d9-4dcf-4980-9870-d295c7f8e2c0",
      "event_cluster_id": "9bee1f85-c3a5-40f1-a8e3-aded362e94b6"
    },
    {
      "claim_cluster_id": "9fa27866-4911-4f0d-8135-cff4b7e597db",
      "event_cluster_id": "87ccb180-4860-4e8d-af6f-a3acda89b6bf"
    },
    {
      "claim_cluster_id": "b180d822-88c1-4c5f-a386-c975497c4a85",
      "event_cluster_id": "06f12bc8-88d8-4040-ac0a-c4dcaae5b13c"
    },
    {
      "claim_cluster_id": "5a089986-6a82-42ed-90a9-302a1ce45000",
      "event_cluster_id": "ddf6b14e-3ad2-41ab-97d2-c4b22e5b751d"
    },
    {
      "claim_cluster_id": "2669ad24-9832-49ab-a24d-8ef6f0986ed6",
      "event_cluster_id": "2253ac9a-3adc-46d3-a973-f064ce69f740"
    },
    {
      "claim_cluster_id": "2e1084b1-c7f9-4543-8153-a6c840adb565",
      "event_cluster_id": "49e33122-7ceb-4265-b315-038b5cf4ba76"
    },
    {
      "claim_cluster_id": "5c0df4bf-ba62-40d1-a306-8313dfe790e6",
      "event_cluster_id": "90c48754-a318-4dba-916a-e40680d8ea62"
    },
    {
      "claim_cluster_id": "c6d29068-aaee-4cd5-94e1-e4e031d50401",
      "event_cluster_id": "d565264f-4050-472d-a250-87b812ab31fd"
    },
    {
      "claim_cluster_id": "d2231d7f-5f03-4e76-b0ae-753fd54f4960",
      "event_cluster_id": "4a7864ed-3fb7-4536-8df0-aadd1c453c8f"
    },
    {
      "claim_cluster_id": "1ec4a683-16aa-481b-9033-75779c52f6c1",
      "event_cluster_id": "442c376e-0da2-4461-a8fe-6d964ea3c00b"
    },
    {
      "claim_cluster_id": "c64abad7-175d-470b-9931-9259e05b39f5",
      "event_cluster_id": "eac2d3f5-7d2a-4cfa-b17e-cac48f4a7268"
    },
    {
      "claim_cluster_id": "ef57a08c-bb40-48bb-8784-c240ed933462",
      "event_cluster_id": "56b88351-b9dd-4f7a-84e1-7a2151d08fc3"
    },
    {
      "claim_cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
      "event_cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee"
    },
    {
      "claim_cluster_id": "d42f0707-162e-449e-86fe-0dd5e2885a21",
      "event_cluster_id": "4d62f2bf-06ba-4e7d-b665-78a194b70483"
    },
    {
      "claim_cluster_id": "a1f0e0be-a8bf-4895-ad2d-4f83a0d63930",
      "event_cluster_id": "80ee24ce-2b7b-4d6f-9630-2bec3ade3b3e"
    },
    {
      "claim_cluster_id": "10f0700e-3ce2-47c7-8783-a4d08ef48748",
      "event_cluster_id": "6ad8a14d-0296-478c-a06f-959ddf23a8b3"
    },
    {
      "claim_cluster_id": "7325cc3b-df7f-4451-948f-1ce21f12d10f",
      "event_cluster_id": "af90686d-77e8-4713-873e-8c63e5dbe370"
    },
    {
      "claim_cluster_id": "4fc703c8-a28e-4bc3-ba13-2190c2afdda4",
      "event_cluster_id": "df289945-6d20-4db8-b12c-27190f4319e3"
    },
    {
      "claim_cluster_id": "c8c0e353-5277-4897-8ef8-4773b9d6e6cb",
      "event_cluster_id": "7690b51f-82d1-4577-be9d-58b4d7bf11b2"
    },
    {
      "claim_cluster_id": "1a660b55-5f53-4246-a227-98df9e4e2ac4",
      "event_cluster_id": "287c467e-feff-43ca-835b-d713c03d0418"
    },
    {
      "claim_cluster_id": "4a3bc772-20e9-4711-acc4-eb16f1a71bea",
      "event_cluster_id": "66885820-7ee2-45b0-bbbf-efce4343c472"
    },
    {
      "claim_cluster_id": "aafb6f56-e150-4de6-8f24-4e8fe467b23f",
      "event_cluster_id": "91fe8e01-c220-435f-b390-7c4a84da3d33"
    },
    {
      "claim_cluster_id": "44f7e426-bb87-4dd0-bf0c-80fb71c61eac",
      "event_cluster_id": "fa7c00de-2843-41e3-9b90-64fc233c087b"
    },
    {
      "claim_cluster_id": "c6d29068-aaee-4cd5-94e1-e4e031d50401",
      "event_cluster_id": "8d301f71-3fd8-4bb2-b685-2bfee512c9e8"
    },
    {
      "claim_cluster_id": "60b71403-253c-4f7c-b96e-fb2306a7cebf",
      "event_cluster_id": "924eda57-f860-4947-b8f8-b55352cbd0d8"
    },
    {
      "claim_cluster_id": "601320a2-3fca-41ef-9387-a64a4c0b5cee",
      "event_cluster_id": "84787050-e169-47c8-98ae-7a849294a5a9"
    },
    {
      "claim_cluster_id": "16e980af-79a1-4255-8ad0-56ca61ae3b8a",
      "event_cluster_id": "3b0ef1f4-8ed3-49f5-bef1-e5534eb3da65"
    },
    {
      "claim_cluster_id": "493568a9-0e32-4b19-a041-15396f7c15b4",
      "event_cluster_id": "ec8073ca-bd09-4811-94f5-faa29b947d90"
    },
    {
      "claim_cluster_id": "4767808d-19a9-4e75-b8a7-7421cf37c72f",
      "event_cluster_id": "690dcbae-7356-41d9-9b3d-b2f6f77db887"
    },
    {
      "claim_cluster_id": "adfa00d7-81da-47be-a9ec-4b8dfb8ee34a",
      "event_cluster_id": "91653172-78c7-443d-8db0-081fac7b81c6"
    },
    {
      "claim_cluster_id": "64b06601-97a9-452d-80ca-13c5f92ae356",
      "event_cluster_id": "702c96ce-c667-4d06-adc3-0067ef68ea50"
    },
    {
      "claim_cluster_id": "668dd84f-417c-4a0b-ac12-78d246a5f46e",
      "event_cluster_id": "7b19db75-3bd2-47e5-a306-0a2f241eda0e"
    },
    {
      "claim_cluster_id": "03ac5e38-07fa-4023-b9bd-bdfc9810ba0c",
      "event_cluster_id": "28e348f7-86c8-4ff9-8b99-eb8b6c73b1bf"
    },
    {
      "claim_cluster_id": "62d8fa29-aaab-4f66-9532-5fb34686e56f",
      "event_cluster_id": "2fd99adc-b7aa-49ec-b4ae-d4607788e329"
    },
    {
      "claim_cluster_id": "5833eaa5-8c9c-42b9-bd12-8cdf781ec725",
      "event_cluster_id": "b6f1959a-3736-48e6-bdb9-c384c993515b"
    },
    {
      "claim_cluster_id": "1ec4a683-16aa-481b-9033-75779c52f6c1",
      "event_cluster_id": "261a6bc9-08bd-454b-9fec-f9f4a0fe9250"
    },
    {
      "claim_cluster_id": "10f0700e-3ce2-47c7-8783-a4d08ef48748",
      "event_cluster_id": "878945ad-a11c-4c5d-8d89-5e5ce4911878"
    },
    {
      "claim_cluster_id": "53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c",
      "event_cluster_id": "afcde980-e0c6-457d-998d-0d7991b35017"
    },
    {
      "claim_cluster_id": "f92684c8-da9a-477a-ba9a-9eb41a6f9f90",
      "event_cluster_id": "4ee7469c-41d2-49f4-8462-c59869db80dd"
    },
    {
      "claim_cluster_id": "d0137977-4815-4376-8c2f-58b223088e62",
      "event_cluster_id": "8b701600-84ba-4ca4-8c27-5ea0e1457d2b"
    },
    {
      "claim_cluster_id": "adfa00d7-81da-47be-a9ec-4b8dfb8ee34a",
      "event_cluster_id": "5ce12af0-2b76-4e71-8a73-442efc1d859d"
    },
    {
      "claim_cluster_id": "29223456-9a08-4f68-9ce7-d62d961fb6aa",
      "event_cluster_id": "2ff54a92-503d-42da-bdb7-6138f7c69fb1"
    },
    {
      "claim_cluster_id": "576d103a-5318-4b16-9313-434ff03a385d",
      "event_cluster_id": "999e57b5-71fd-4f69-ac79-5d89ae8e3c67"
    },
    {
      "claim_cluster_id": "33fe2055-c6c1-46ed-8871-fc741999d32b",
      "event_cluster_id": "9d7867d5-5ab5-4b0e-9556-f3f45feb0160"
    },
    {
      "claim_cluster_id": "9cc8f400-4462-4501-9bf3-f6cf35f7a110",
      "event_cluster_id": "c6dfc604-6d8c-4b88-816b-1b53975cd28d"
    },
    {
      "claim_cluster_id": "729e67ef-32fc-4882-8297-9f443b6f2589",
      "event_cluster_id": "ef9e5931-dbe9-4ba1-af73-3f6fcb8ed6f7"
    },
    {
      "claim_cluster_id": "f309b6e7-458c-4f62-9d98-f12cb2e89c08",
      "event_cluster_id": "315e3fc3-9356-409c-9b82-9011a9ad2a72"
    },
    {
      "claim_cluster_id": "e9c84dbc-30d1-4e60-bbc8-700057190615",
      "event_cluster_id": "7679c732-4d78-416d-a31b-b4d49c72f3ed"
    },
    {
      "claim_cluster_id": "b433d9b9-0986-4c75-baab-f74fc73be2ca",
      "event_cluster_id": "07ffad90-34a3-4066-8c33-1761dfb6597a"
    },
    {
      "claim_cluster_id": "5d65069d-5cc8-4da8-8b8d-bbd1528688e7",
      "event_cluster_id": "c545f601-c30b-46cc-a181-949b8540bd95"
    },
    {
      "claim_cluster_id": "29790db2-2536-415f-822b-9a4c1f1f8a3c",
      "event_cluster_id": "c5a49990-0bec-49b9-8797-00d71805007a"
    },
    {
      "claim_cluster_id": "4dbd9499-a86a-4c48-b218-1b0a93aa0331",
      "event_cluster_id": "959de586-d5e2-49e4-92ad-27165bbe0cb1"
    },
    {
      "claim_cluster_id": "2d998acd-2150-418c-b2e7-db6c334526be",
      "event_cluster_id": "178f9d9a-267a-4abb-8f58-8a32bd23bb57"
    },
    {
      "claim_cluster_id": "752a6b2b-a9aa-4a80-b345-6a1e96c0ac0c",
      "event_cluster_id": "b45560d5-3144-4d83-a41f-025765799050"
    },
    {
      "claim_cluster_id": "25d9faf4-4231-47e1-9e78-17114da0186c",
      "event_cluster_id": "5fca9556-7877-4bc1-82fb-6f88c867de71"
    },
    {
      "claim_cluster_id": "54d52770-613a-47b1-aa64-0743cb644791",
      "event_cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"
    },
    {
      "claim_cluster_id": "bf01755f-02c0-4092-8a9f-ea50ff0a213d",
      "event_cluster_id": "768c2664-8354-4bfc-8b47-96eb4e08e0ee"
    },
    {
      "claim_cluster_id": "170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c",
      "event_cluster_id": "70a4982e-a051-4993-8a45-818426e08af0"
    },
    {
      "claim_cluster_id": "804db45c-717d-4c1d-9494-73592da3dad8",
      "event_cluster_id": "2d3a5941-caeb-4957-af01-00f1d2fdf8e4"
    },
    {
      "claim_cluster_id": "f50144fc-3b9b-4e34-ac6c-5191d30445d0",
      "event_cluster_id": "93f03d20-e5b7-41c5-976e-5122f884847a"
    },
    {
      "claim_cluster_id": "5521d112-0a05-4e5a-881c-de705171fc9a",
      "event_cluster_id": "b6ada6e3-1455-491d-948b-45a74b134fab"
    },
    {
      "claim_cluster_id": "2f43e86f-24fc-4c3c-a77d-c5abbf46ef19",
      "event_cluster_id": "e0a1afab-5142-40ca-ad10-35061b0289f8"
    },
    {
      "claim_cluster_id": "88d87950-d2a5-4729-bb7a-8215d26b8898",
      "event_cluster_id": "39f63165-e875-40a7-84ed-ae42699b5d21"
    },
    {
      "claim_cluster_id": "199242cb-5b3e-40d9-bf38-e1eddcf574fc",
      "event_cluster_id": "7c8877ae-f397-490e-9778-67a6e91ebe1c"
    },
    {
      "claim_cluster_id": "9ee9fc47-27b6-4828-a30b-bd52c92ccfae",
      "event_cluster_id": "222d1da7-5333-49e1-a4ec-9ca508fd278c"
    },
    {
      "claim_cluster_id": "be9b7361-8150-4e4b-9111-bac990c11d3d",
      "event_cluster_id": "050d87c2-4ac3-4e0e-8673-b4a44b43bac0"
    },
    {
      "claim_cluster_id": "dc8d69ed-9d9d-4c04-a104-2c89e796edf3",
      "event_cluster_id": "61eb35de-336f-40f6-88fb-ed35c226eeeb"
    },
    {
      "claim_cluster_id": "df846784-b644-4d2f-a077-f42db08f73a6",
      "event_cluster_id": "a4e389ba-b81a-45e6-ab4f-901841ef5d44"
    },
    {
      "claim_cluster_id": "329c69a1-8578-4615-a95d-4068857af2c9",
      "event_cluster_id": "aac0ba40-d82f-4ba8-91e4-f92c6960338d"
    },
    {
      "claim_cluster_id": "f3cb984c-8736-4ad2-8cd8-5ca9f90033d5",
      "event_cluster_id": "f8140231-b4f8-4a5a-801c-39c992ba46a9"
    },
    {
      "claim_cluster_id": "de7a466b-9657-42fc-adc1-63e65b4ec1ea",
      "event_cluster_id": "9f5a552b-da22-4595-b590-da914506237b"
    },
    {
      "claim_cluster_id": "338d5a8d-64c7-4bed-a37e-208196096015",
      "event_cluster_id": "c527d2cd-0df5-4184-a0f7-17002b9cf18b"
    },
    {
      "claim_cluster_id": "32c3480d-0d09-459f-9f53-79a49ae3f52b",
      "event_cluster_id": "2cfd963e-dc73-4d82-9776-ae618471ae77"
    },
    {
      "claim_cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "event_cluster_id": "a8f0c75d-6044-4b26-b4bc-0408c1bf6a2f"
    },
    {
      "claim_cluster_id": "07438861-a868-47ed-8a1a-288138dc65c0",
      "event_cluster_id": "41895296-6f09-4b44-a2d4-3d90f2e03b81"
    },
    {
      "claim_cluster_id": "a5706e56-c643-44be-8e44-3c19fd9dcc29",
      "event_cluster_id": "a5e788fc-37bf-43d2-97b2-732f917263ab"
    },
    {
      "claim_cluster_id": "c7c25534-0ffc-4f97-99d9-6bf3f3de9b03",
      "event_cluster_id": "3d5e9384-ac3e-4f4c-a500-50dfd267dfa4"
    },
    {
      "claim_cluster_id": "6832730a-f3c3-49e8-8c1f-45ff7dac590c",
      "event_cluster_id": "39d6e082-ff74-4db5-9429-ae565700afa5"
    },
    {
      "claim_cluster_id": "428d818b-c2cf-41c7-bcd8-3f5cb0b144ef",
      "event_cluster_id": "87581b6b-a1c8-4620-9246-61483cbbfb0d"
    },
    {
      "claim_cluster_id": "c1308dd1-2ebf-4164-b9e3-2284bbfb088b",
      "event_cluster_id": "d30fd077-478d-4784-a1a9-ce89125fa303"
    },
    {
      "claim_cluster_id": "662000fc-1ecb-4634-b4e8-efc53b2b3287",
      "event_cluster_id": "a8fe9f9c-6b4f-45e8-a4dc-fab2a57284cf"
    },
    {
      "claim_cluster_id": "2a22127e-779b-461a-a858-c6dc0fc34ff0",
      "event_cluster_id": "125babf5-bc0d-45cd-ad83-2a6b21a3e2c7"
    },
    {
      "claim_cluster_id": "843bcba9-c863-41a3-a76f-01fd61d56529",
      "event_cluster_id": "776c4ee1-eeec-4f70-91d9-12fdaa179052"
    },
    {
      "claim_cluster_id": "e1ed1afc-85b6-4c69-a063-e486d1e3670f",
      "event_cluster_id": "33b85444-739a-48a4-ba4a-144d6f0bde74"
    },
    {
      "claim_cluster_id": "095169c0-0ce4-4362-b29d-486ce7d2b848",
      "event_cluster_id": "afd1f695-ea2e-42a9-8e8b-7c38a970fbb5"
    },
    {
      "claim_cluster_id": "58f1ee6c-cb8a-434d-b4d0-2f32913f3f4e",
      "event_cluster_id": "072b9770-c37e-4414-a35e-af21470d2ffc"
    },
    {
      "claim_cluster_id": "18413d30-3282-4a19-9301-8b0c9a57c941",
      "event_cluster_id": "731fbc17-b401-45f0-a173-ab4385d11eac"
    },
    {
      "claim_cluster_id": "c6541e86-8e1b-4bd0-926a-c380aa103aa6",
      "event_cluster_id": "090c138f-cca2-4b65-9a79-43955026e502"
    },
    {
      "claim_cluster_id": "d93d391c-6b51-4713-bfdb-30f405cd2357",
      "event_cluster_id": "f2d4f2cd-14c3-4d0d-9c96-d0df234f7a5c"
    },
    {
      "claim_cluster_id": "17c8775c-7a3a-4607-aa7f-5b24078a17f8",
      "event_cluster_id": "21a0cca0-78e3-4e0b-95d4-e1b42b08be47"
    },
    {
      "claim_cluster_id": "971c6a1a-3e95-4838-8131-b05eb89d55b7",
      "event_cluster_id": "6bbdc559-2725-4b4d-bee7-05ff3de480c4"
    },
    {
      "claim_cluster_id": "0792eb98-3885-48f3-bc43-bf2a8c746720",
      "event_cluster_id": "4e34cec9-0108-4167-8bfb-d0fceb099fab"
    },
    {
      "claim_cluster_id": "de7a466b-9657-42fc-adc1-63e65b4ec1ea",
      "event_cluster_id": "9e2dd54a-2362-436b-857d-0266fa2b8211"
    },
    {
      "claim_cluster_id": "20d6183f-1c47-41c9-bd8d-d5a8b68eff2e",
      "event_cluster_id": "23c989ae-ea8a-4829-80ac-944f7f9327cf"
    },
    {
      "claim_cluster_id": "d65c0d37-123c-4e39-9b2d-386613952a30",
      "event_cluster_id": "e4c9c7c5-e3e0-45e8-9f4d-644aa55e2107"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "43836beb-3651-49f1-a0f8-ad3c4daaab70"
    },
    {
      "claim_cluster_id": "63024d1d-9398-49ae-8b27-efbfa0bffb4f",
      "event_cluster_id": "7bd525d0-ac48-4787-9774-a8b37c4ff4a9"
    },
    {
      "claim_cluster_id": "5995c9ca-98e0-418d-a93b-a662311da0c9",
      "event_cluster_id": "5b28f584-d6d3-4f8c-b812-407015e7b243"
    },
    {
      "claim_cluster_id": "187eb2a5-5a75-4a22-8ebb-7b83bc1068a8",
      "event_cluster_id": "36d66c66-9c93-4123-875e-3e9fbe514722"
    },
    {
      "claim_cluster_id": "b686bd17-fb36-4b7b-9caf-084f8d91c149",
      "event_cluster_id": "76ddd218-4f5f-4047-8ee4-faeb581b90a7"
    },
    {
      "claim_cluster_id": "009e9d6b-ab96-416d-b96e-b7eaada086cf",
      "event_cluster_id": "3a4ae54e-e7b7-47e9-984e-62601ed45ab4"
    },
    {
      "claim_cluster_id": "dbd98860-9de1-4289-bb60-99171790c782",
      "event_cluster_id": "5716770d-1472-4c8b-9408-d81e71966a7e"
    },
    {
      "claim_cluster_id": "d1f2b2ed-be0f-44a4-a171-4b848f482ca9",
      "event_cluster_id": "bd99a1f5-0df7-4f4c-90f0-16afb1a5c96f"
    },
    {
      "claim_cluster_id": "fd11e091-21e1-40df-916b-90aba2945065",
      "event_cluster_id": "61b4a043-a586-425e-a2f1-9e0b66e038e5"
    },
    {
      "claim_cluster_id": "15516ad5-b153-4147-8246-ecae0ddbf175",
      "event_cluster_id": "af07ce28-0024-41ac-b51c-01e4bbf2c507"
    },
    {
      "claim_cluster_id": "8f07bc53-1683-4b3a-b1de-2e1c15c0e13c",
      "event_cluster_id": "8a4a4131-add5-4367-8ccd-215684fa73dc"
    },
    {
      "claim_cluster_id": "7b08a98a-0129-4cec-b114-1fff26d56746",
      "event_cluster_id": "a222cb65-167b-49af-b5d2-9f2a8169e28d"
    },
    {
      "claim_cluster_id": "3e5167ea-d839-4cc5-b193-fda2f9c0b53b",
      "event_cluster_id": "800ccc5c-7e0c-49e0-a72a-3cfe964493e5"
    },
    {
      "claim_cluster_id": "df5cc82a-7ab7-41f6-8eae-c3445a8c7a05",
      "event_cluster_id": "352c9b63-ad06-4659-b8a6-286e7a80ff49"
    },
    {
      "claim_cluster_id": "f66864ea-bc5a-4c3b-ba81-6aa44dc35cb3",
      "event_cluster_id": "fd0c8abe-7ca4-4c28-8c57-cd7f45e50fde"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "30a748c7-0edb-4c1b-9472-d1b4ca3f8032"
    },
    {
      "claim_cluster_id": "c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a",
      "event_cluster_id": "9c71282b-fc72-4fb3-b7f8-7ff433782d1d"
    },
    {
      "claim_cluster_id": "30f8d995-4c8b-4d55-9cc0-91236f828d24",
      "event_cluster_id": "154780a4-c583-40d6-b0cd-5a3d8a1994cb"
    },
    {
      "claim_cluster_id": "80ee7cf5-20b3-4f27-9dd1-9ddac8a8c921",
      "event_cluster_id": "1380f196-a8b4-4593-b276-1ee4b9b19dc0"
    },
    {
      "claim_cluster_id": "c91afcbe-198a-44cd-83c8-42c89811dab9",
      "event_cluster_id": "15826810-2be6-4996-948b-869e0ec64e02"
    },
    {
      "claim_cluster_id": "5b52495b-d578-4d45-975c-d2e0417f4501",
      "event_cluster_id": "553f1291-956b-45d5-9567-97bf2439ca2b"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87"
    },
    {
      "claim_cluster_id": "ceabee0f-bc28-4b8e-8445-fc63ff551472",
      "event_cluster_id": "9dbb5109-6fdf-484b-92c1-ec8b1bba2a62"
    },
    {
      "claim_cluster_id": "0119782a-5d22-485c-b58b-6c82b20e788c",
      "event_cluster_id": "2f8e7728-120e-46dc-8103-038ff1bcf8a0"
    },
    {
      "claim_cluster_id": "e31510b5-776d-40cf-9a10-afb0bb1a3f0b",
      "event_cluster_id": "bc3b9d73-137b-4059-890e-e7cbbf0bd7b2"
    },
    {
      "claim_cluster_id": "262772f6-e21d-4ca8-a80f-06c1518ea90e",
      "event_cluster_id": "3ddf92d1-7fbd-4c44-857f-573095c914df"
    },
    {
      "claim_cluster_id": "55a6c384-27dd-4299-b28d-d3dcd1dd5947",
      "event_cluster_id": "eb0d5379-1fcc-4fd5-a65b-238e9b2fe3a4"
    },
    {
      "claim_cluster_id": "13672f1a-e63c-4ec7-9f85-d3ed61ff60fa",
      "event_cluster_id": "c1018981-9883-4b7e-8f5e-7f4837994e54"
    },
    {
      "claim_cluster_id": "8f5c67fb-16a9-42c0-8cf3-1bc2d8d1a576",
      "event_cluster_id": "2a74c891-6384-471e-8d99-df457b1baa82"
    },
    {
      "claim_cluster_id": "a3cec669-c5d7-49cf-9b41-ed9298b7642a",
      "event_cluster_id": "07b11e06-46ec-45e9-8f01-bc31083fd0de"
    },
    {
      "claim_cluster_id": "af2dae39-7b57-4e0d-909b-c39b56de0088",
      "event_cluster_id": "e9eacbea-e948-4bff-8064-db4af871a9d3"
    },
    {
      "claim_cluster_id": "3b1f0ed9-3201-46c5-93e3-016f26c4d261",
      "event_cluster_id": "f39cf9c7-18fb-4728-b88a-0bd586522d02"
    },
    {
      "claim_cluster_id": "197fe725-a0a9-40f8-a6e9-956dd052b066",
      "event_cluster_id": "290a2df9-939f-4569-965e-7d206087ead6"
    },
    {
      "claim_cluster_id": "6677095f-eafc-4bbb-8dde-f914b5103e89",
      "event_cluster_id": "ea5f2b05-0096-4117-a2fa-b72e433c4955"
    },
    {
      "claim_cluster_id": "56d92634-56f1-4385-a700-927cf573e5bc",
      "event_cluster_id": "4c1d018f-90d0-4f64-b7e5-c3877ba4474a"
    },
    {
      "claim_cluster_id": "3543d3e3-081b-448e-9ec9-915bf37d6255",
      "event_cluster_id": "06d0d746-6c6d-457b-ab07-13b3cadf3286"
    },
    {
      "claim_cluster_id": "5d65069d-5cc8-4da8-8b8d-bbd1528688e7",
      "event_cluster_id": "00682147-64d4-4c37-88ac-2b9c31d6d40d"
    },
    {
      "claim_cluster_id": "c13b80fa-280b-4c54-8a38-1ddd943c4782",
      "event_cluster_id": "7011451c-4136-49ed-9d09-6db32baccfc3"
    },
    {
      "claim_cluster_id": "21240c8f-29c6-42ef-b002-a537a743739b",
      "event_cluster_id": "fd853489-07e0-4489-8d20-abb8f80a4213"
    },
    {
      "claim_cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
      "event_cluster_id": "e5a713cd-2a21-42c0-89a2-7795a4250823"
    },
    {
      "claim_cluster_id": "89aabd59-2b1d-4122-9c03-b5ffeee5a650",
      "event_cluster_id": "a0d0eaf1-4a40-484e-a752-fdb85cffa308"
    },
    {
      "claim_cluster_id": "70898fa9-9960-49d5-b422-3f77d073d86b",
      "event_cluster_id": "16a78e87-1a7e-47fe-92e8-e8466b7bd20f"
    },
    {
      "claim_cluster_id": "b61ba5b2-e28d-4cea-b7a2-78bed070aeca",
      "event_cluster_id": "096792cf-02d2-44be-b8c2-c02b17ea6cb5"
    },
    {
      "claim_cluster_id": "4ece2a70-3ab9-4be4-bb31-9931add16159",
      "event_cluster_id": "0cda4135-c24b-4433-a2d2-edf8bce6961a"
    },
    {
      "claim_cluster_id": "a020fdcd-2c2c-4311-bbc5-883c8bcd23ae",
      "event_cluster_id": "376cbd95-afac-43da-8c2a-b0756127f429"
    },
    {
      "claim_cluster_id": "ea149597-1daf-4627-8587-59eb8a6bde8b",
      "event_cluster_id": "6eae9125-d91f-4554-8584-e619f1d7940e"
    },
    {
      "claim_cluster_id": "64b06601-97a9-452d-80ca-13c5f92ae356",
      "event_cluster_id": "72796cab-1adb-4917-9d03-40c3dc952598"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "fdb454eb-b6d8-4e69-94d9-d465733df395"
    },
    {
      "claim_cluster_id": "c13b80fa-280b-4c54-8a38-1ddd943c4782",
      "event_cluster_id": "7e1892c9-2b80-4467-8d86-e0034e324987"
    },
    {
      "claim_cluster_id": "4c8ca22f-065e-4c2a-bc2a-950d315204b8",
      "event_cluster_id": "1618106d-1c52-48f7-9d0e-a09294ca1167"
    },
    {
      "claim_cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
      "event_cluster_id": "9419d9bb-572a-4e79-aef7-f69f5e25eaa2"
    },
    {
      "claim_cluster_id": "5acf0ec4-be26-4926-a6a6-508ec71aaa6e",
      "event_cluster_id": "4d12b965-7c97-4994-9361-6f5f0b2c17ee"
    },
    {
      "claim_cluster_id": "20ab2459-a6a0-4e45-aef0-5b2d6b529a0e",
      "event_cluster_id": "41895296-6f09-4b44-a2d4-3d90f2e03b81"
    },
    {
      "claim_cluster_id": "452c2457-4da2-4edb-a49f-86f139410e4f",
      "event_cluster_id": "e7ad9ef4-67e0-4758-9909-6db3f8c0c4b5"
    },
    {
      "claim_cluster_id": "eb38bdfb-232f-4460-8d60-fc8806237786",
      "event_cluster_id": "49884f4f-86a8-42d4-b8a9-af42d91f50a2"
    },
    {
      "claim_cluster_id": "eeb1b170-89e2-4e28-b446-c1ba6d5ba1e3",
      "event_cluster_id": "f2e7e2a5-1bc4-443d-b76a-ecb8995fbae8"
    },
    {
      "claim_cluster_id": "b3de51b2-92ca-4cb1-b45e-50a0188ca28f",
      "event_cluster_id": "7a4c0ada-5901-4c50-be04-047c13f1ba31"
    },
    {
      "claim_cluster_id": "18108091-50d0-4bb5-a06f-5f2734380aef",
      "event_cluster_id": "3cee1037-34a3-4502-8ebe-36a15c95ec82"
    },
    {
      "claim_cluster_id": "f10a7215-4011-4959-9b86-e9f3848b78fb",
      "event_cluster_id": "6150a21f-6d1d-4554-8cbb-b01623349756"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "e17360aa-cb4e-4e41-913f-f3e853c44fd4"
    },
    {
      "claim_cluster_id": "05638bd6-42ef-4049-b6f6-4a5478e7b8a5",
      "event_cluster_id": "7a09649a-0d1c-4211-a9ef-65dbb223fc3d"
    },
    {
      "claim_cluster_id": "5d65069d-5cc8-4da8-8b8d-bbd1528688e7",
      "event_cluster_id": "8602d3ff-0dd5-4315-8d50-17cd0d22f5ac"
    },
    {
      "claim_cluster_id": "52105c27-d937-4970-9bad-c139e21a6205",
      "event_cluster_id": "4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"
    },
    {
      "claim_cluster_id": "8f5c67fb-16a9-42c0-8cf3-1bc2d8d1a576",
      "event_cluster_id": "473de348-b521-4729-af95-a1929f5cfcf4"
    },
    {
      "claim_cluster_id": "12e02de9-758e-49f6-b31c-fe52770a7aa7",
      "event_cluster_id": "6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00"
    },
    {
      "claim_cluster_id": "9ee9fc47-27b6-4828-a30b-bd52c92ccfae",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "95b3c4c9-cd4a-4cfa-9eab-9df18c6c5d95",
      "event_cluster_id": "9a0ba2bb-c790-4711-b8e3-9a7c3fc3165b"
    },
    {
      "claim_cluster_id": "0d813aeb-360a-48ec-afeb-778e533504c7",
      "event_cluster_id": "fbff695d-2102-476c-be9c-1ec2e2a34e99"
    },
    {
      "claim_cluster_id": "7e98dc53-abf7-4bf8-8ac7-3c9623f6d068",
      "event_cluster_id": "b56f25e8-34c3-4cf5-b21e-1b0f46545150"
    },
    {
      "claim_cluster_id": "ff47f0b3-49ae-48d8-b9cf-5707589bed0f",
      "event_cluster_id": "169e370f-8381-43b0-8425-6e6dcf0bee77"
    },
    {
      "claim_cluster_id": "4ac1da2e-cd03-4a11-b440-f62dc8f73aad",
      "event_cluster_id": "7690b51f-82d1-4577-be9d-58b4d7bf11b2"
    },
    {
      "claim_cluster_id": "a219ce5b-2b81-445f-a63d-19aecc15acb1",
      "event_cluster_id": "15f10d86-dc7c-499e-a621-4444d739de34"
    },
    {
      "claim_cluster_id": "9ef9c32c-d40a-4d36-a3db-c01367d4c96e",
      "event_cluster_id": "16220929-8aa1-45e6-9f5e-8401f7ed50de"
    },
    {
      "claim_cluster_id": "5b2c4526-459d-4b6f-8f31-bd40fccf12ff",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "125b87a9-62f3-402f-a1ad-6a9130845e80",
      "event_cluster_id": "0fd165fb-7316-456d-917e-cb976d5b4983"
    },
    {
      "claim_cluster_id": "34d9abee-6356-4941-91bd-4961dca2eec1",
      "event_cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"
    },
    {
      "claim_cluster_id": "e35fb8e9-42cf-4ef0-a512-d7be06ad99e3",
      "event_cluster_id": "add56d26-1f85-486a-b862-703a0d62439d"
    },
    {
      "claim_cluster_id": "bdc594bb-6aa7-4421-82b8-b7df34a7c93e",
      "event_cluster_id": "61b4a043-a586-425e-a2f1-9e0b66e038e5"
    },
    {
      "claim_cluster_id": "f0190a02-daf5-48b7-8174-720b52c75550",
      "event_cluster_id": "4f2403b6-f02f-46f5-a51a-edcea5995adb"
    },
    {
      "claim_cluster_id": "a0f8e5d7-b3ae-4af7-8eb1-d7fefd231acc",
      "event_cluster_id": "ed839aef-f33d-482b-b6ad-3c8a3947da24"
    },
    {
      "claim_cluster_id": "cc0b4f6a-9515-47dc-b1fc-eea9be8d97fb",
      "event_cluster_id": "60b00870-1636-4edd-b3bc-90daaa615659"
    },
    {
      "claim_cluster_id": "e6759e4c-f697-49ce-a969-2f596e5c4293",
      "event_cluster_id": "fba25849-5030-47b7-9871-3584f06bc4e7"
    },
    {
      "claim_cluster_id": "65cd54b0-2f90-4b59-a573-5917ec27f9bb",
      "event_cluster_id": "6d1416a4-5911-49a5-a8dd-0b4e7d18279a"
    },
    {
      "claim_cluster_id": "5aad8736-b18a-4e21-930e-320f4faaed1c",
      "event_cluster_id": "94e66aa3-5079-4e1d-bdc8-702db352aa56"
    },
    {
      "claim_cluster_id": "e7def08b-a4be-4464-b5ad-7e8f1dfa8752",
      "event_cluster_id": "52bfe357-189c-4c8a-a4ee-372f061bfc2c"
    },
    {
      "claim_cluster_id": "d92f99b3-bdef-4ca3-95aa-e303f2451b97",
      "event_cluster_id": "210b8b9f-5f46-4fbd-8a43-aa4d24350d2d"
    },
    {
      "claim_cluster_id": "ff47f0b3-49ae-48d8-b9cf-5707589bed0f",
      "event_cluster_id": "fc91cfeb-b23d-4b4c-816a-7fa7dfbf9e8e"
    },
    {
      "claim_cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
      "event_cluster_id": "43836beb-3651-49f1-a0f8-ad3c4daaab70"
    },
    {
      "claim_cluster_id": "03105f5f-d65d-4408-8071-b314d86ce573",
      "event_cluster_id": "c9299dd8-c218-46f0-b151-8c752a7421c0"
    },
    {
      "claim_cluster_id": "6436c54d-cea9-4b06-8f6e-d82ef558f6c5",
      "event_cluster_id": "6b03b394-3970-4d06-bfbc-01183e585200"
    },
    {
      "claim_cluster_id": "a15b31ed-89e7-4c30-9559-8eac356b32e1",
      "event_cluster_id": "3fceb0c7-e424-40ef-bf39-fd06469e3042"
    },
    {
      "claim_cluster_id": "40860ef8-1ebc-45f7-84a0-735bcdaf070c",
      "event_cluster_id": "9b321e6e-fd77-47ca-b965-6aceb0683d37"
    },
    {
      "claim_cluster_id": "db268f9a-c3a8-4e79-a3b0-df934c32f645",
      "event_cluster_id": "13d74323-84c7-4461-a516-d07ee1ee8c43"
    },
    {
      "claim_cluster_id": "8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9",
      "event_cluster_id": "bd8d969e-3ce0-4ae8-b478-e7f5690a2b2c"
    },
    {
      "claim_cluster_id": "04fd43b1-9ee7-43b3-b1fc-e9fca576658d",
      "event_cluster_id": "e6120475-8d62-4b1d-84b3-4c53f22ff855"
    },
    {
      "claim_cluster_id": "8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0",
      "event_cluster_id": "bc3b9d73-137b-4059-890e-e7cbbf0bd7b2"
    },
    {
      "claim_cluster_id": "eee91c5f-8ac6-4779-af53-8a01aa4eaa03",
      "event_cluster_id": "e5554b00-9db0-47c0-964c-03cd848dbfe3"
    },
    {
      "claim_cluster_id": "170ecf0a-6b0e-4e0f-887c-c0f76cd83d5c",
      "event_cluster_id": "f7cbf601-ad96-47af-b877-ba63e1376028"
    },
    {
      "claim_cluster_id": "9ba4f992-6e11-40b2-8501-4e04321822e6",
      "event_cluster_id": "eaa2dbb7-40c0-4ebf-a0b3-5deddf646a17"
    },
    {
      "claim_cluster_id": "97037755-caf6-49ed-8d7a-bb7c0d42bf8c",
      "event_cluster_id": "f3668774-884d-4b84-a93b-1c5ea3e64309"
    },
    {
      "claim_cluster_id": "97b36cda-ba8c-4a83-864b-060595445ba9",
      "event_cluster_id": "ebecceb7-8e8e-4359-8ae4-54572c43828e"
    },
    {
      "claim_cluster_id": "f15167ff-a614-4854-ae28-529950f00bdc",
      "event_cluster_id": "89ee63c1-fb19-4aa6-ab9c-62e22a3b7244"
    },
    {
      "claim_cluster_id": "916339bd-3e65-4fc3-be04-12020f45e716",
      "event_cluster_id": "62e37c68-3e37-4c4f-b64e-4d353bb38fcd"
    },
    {
      "claim_cluster_id": "1a968bfe-5bc1-4f49-8a3c-fc2e0fdbf254",
      "event_cluster_id": "9cb21d08-8a84-4302-8619-2f374e19a897"
    },
    {
      "claim_cluster_id": "fc45a344-4cfc-4865-9030-d033f0c8dff3",
      "event_cluster_id": "29fa8f23-676f-4f6e-888b-58fd11dbd236"
    },
    {
      "claim_cluster_id": "b3413e76-c570-4047-aa2b-63946d5b2c25",
      "event_cluster_id": "2e3c3c0c-9c80-46be-8b29-ebed3dc26978"
    },
    {
      "claim_cluster_id": "2ab59d09-09ca-4583-9e99-8189ce8c9335",
      "event_cluster_id": "e113cbe4-9797-46e8-ab87-8e31da3f22de"
    },
    {
      "claim_cluster_id": "f5514b1c-3b40-41b8-9290-039c2c94a3e7",
      "event_cluster_id": "e91640d2-fa8e-426c-a0fb-7b9789e054bf"
    },
    {
      "claim_cluster_id": "29149f19-2cff-4344-bb10-8e0506dbc049",
      "event_cluster_id": "0807cdb8-6ddb-4585-ad14-90359bbf1c37"
    },
    {
      "claim_cluster_id": "3b48df52-c3ed-4c3d-8f61-54ae3d11e9b1",
      "event_cluster_id": "05babc1d-7e43-4754-b561-cd3371da4717"
    },
    {
      "claim_cluster_id": "b2568d68-53d4-487c-b724-0456b247a886",
      "event_cluster_id": "b8cb289e-e370-4b8e-aa6d-b4c268c9566e"
    },
    {
      "claim_cluster_id": "64b06601-97a9-452d-80ca-13c5f92ae356",
      "event_cluster_id": "2bcfeb62-5d3f-441a-a60f-796550a52e9a"
    },
    {
      "claim_cluster_id": "9ce1a265-b79e-4040-a0e8-f1a6fbb59f67",
      "event_cluster_id": "5ab902d4-7128-4b95-a738-a425f46dd496"
    },
    {
      "claim_cluster_id": "7eefde16-5844-4305-a679-da87990a2640",
      "event_cluster_id": "b419eced-65f4-49b5-ac60-2638f9c27f53"
    },
    {
      "claim_cluster_id": "5d8d730b-6674-4d5b-8f99-6c8e240e9080",
      "event_cluster_id": "5a4d2a32-bac0-4370-915e-eb0f49138ccd"
    },
    {
      "claim_cluster_id": "6aa59122-6821-4e76-8afb-2ad2b679a5aa",
      "event_cluster_id": "60f1920a-6809-46d7-8c57-4dab4cfa8642"
    },
    {
      "claim_cluster_id": "56d92634-56f1-4385-a700-927cf573e5bc",
      "event_cluster_id": "eb435255-a9dd-404d-b762-acfa5ea790a6"
    },
    {
      "claim_cluster_id": "35ee8064-f9ff-4496-b4db-ba79f7f24de2",
      "event_cluster_id": "2598e9eb-952c-4ac9-abb5-957f4bef45b1"
    },
    {
      "claim_cluster_id": "099db03e-baa7-498b-864d-6a091534741b",
      "event_cluster_id": "ff5b2600-1cea-4a76-a9a5-9e02ca367e1c"
    },
    {
      "claim_cluster_id": "8499f04a-3cd9-4588-b8dd-3abc1c538bcf",
      "event_cluster_id": "5b750f94-6101-4383-bd0d-c980ad3ff8c2"
    },
    {
      "claim_cluster_id": "dce81269-fe31-49af-8310-17a573139956",
      "event_cluster_id": "99cf328e-cb8c-4fbf-b5e7-b5b12080a8e0"
    },
    {
      "claim_cluster_id": "bdc594bb-6aa7-4421-82b8-b7df34a7c93e",
      "event_cluster_id": "1ff366e5-31ba-464c-8544-3d84f99a75c6"
    },
    {
      "claim_cluster_id": "7faff4ee-fc9e-4ba2-8e8e-36906d88936d",
      "event_cluster_id": "971dde28-a3c6-404b-8a02-b24390ab3750"
    },
    {
      "claim_cluster_id": "84a6bd0b-f777-46d5-bcae-3f166d028b6a",
      "event_cluster_id": "81c0ca50-4b77-426d-ae3a-c52b1a992539"
    },
    {
      "claim_cluster_id": "de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe",
      "event_cluster_id": "092404d0-7d21-433f-bfca-9a5d34d17b3b"
    },
    {
      "claim_cluster_id": "b08cba5b-cde3-4318-9ea2-b4cf4efed9c3",
      "event_cluster_id": "4b3edb14-747e-4c77-8e76-8b7c1d8c4155"
    },
    {
      "claim_cluster_id": "285cd62d-96d8-4ff1-af84-3fd22f7b4f51",
      "event_cluster_id": "0640a339-12f8-4d3e-8416-49b84425cfca"
    },
    {
      "claim_cluster_id": "f465e3b9-9784-4302-b258-d34ad0adf726",
      "event_cluster_id": "b69dac95-ca24-49e5-b472-f36e5a0721b8"
    },
    {
      "claim_cluster_id": "b4c1b467-58b1-4e2c-a735-234cba24891c",
      "event_cluster_id": "dddeb5a3-e00c-4234-b929-096fb52ccab4"
    },
    {
      "claim_cluster_id": "edbdc807-7fba-426c-a271-726e1f090eaf",
      "event_cluster_id": "2258427e-082d-4938-9009-29d50fe17645"
    },
    {
      "claim_cluster_id": "4ea56329-d3e1-48ab-835d-a5cbc403dcf0",
      "event_cluster_id": "725d8a20-a3a3-4517-9549-74f8eede8ff7"
    },
    {
      "claim_cluster_id": "fbdddb76-bee9-4e1c-9f2e-03126700cbd1",
      "event_cluster_id": "e77e1981-0ac9-43e4-bf55-8efb11926415"
    },
    {
      "claim_cluster_id": "3e30f911-bb0c-48a0-8ffb-4be6bf3fe64d",
      "event_cluster_id": "747b93ff-87de-4a18-a76c-e68485fa2bed"
    },
    {
      "claim_cluster_id": "dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e",
      "event_cluster_id": "8a4a4131-add5-4367-8ccd-215684fa73dc"
    },
    {
      "claim_cluster_id": "e60065d4-ae50-40b0-8e77-8c2ad3e36235",
      "event_cluster_id": "2420d848-9bcf-484f-a278-33ad97459cda"
    },
    {
      "claim_cluster_id": "7698cb38-d25f-4849-ba30-99dd8e321533",
      "event_cluster_id": "9d377c51-15d9-43e8-b309-1b51ed3849a9"
    },
    {
      "claim_cluster_id": "11b24695-ec58-4b46-8411-89fe4137f816",
      "event_cluster_id": "6d5e0026-09e5-4a7b-b48d-75b8d03130d8"
    },
    {
      "claim_cluster_id": "635833cc-6550-4cab-b41a-e51cbfca373a",
      "event_cluster_id": "4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c"
    },
    {
      "claim_cluster_id": "187eb2a5-5a75-4a22-8ebb-7b83bc1068a8",
      "event_cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee"
    },
    {
      "claim_cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "6826010f-2a38-48a2-a358-b062edaa9ed4",
      "event_cluster_id": "29eddc16-8def-4acb-9488-5c09c0cd7216"
    },
    {
      "claim_cluster_id": "da8da9c4-b0b1-404e-a289-e106bb2bfbb3",
      "event_cluster_id": "1fdd9b57-6c44-4ffe-9d2d-90b7efd6fa20"
    },
    {
      "claim_cluster_id": "29c942d6-0549-4857-889a-2fc5fd4cf362",
      "event_cluster_id": "2f690c44-ca18-4a31-a2b5-68ac60208360"
    },
    {
      "claim_cluster_id": "36d5c8e6-5870-44de-bee8-1ba3638e2785",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "6f3f0719-064d-478a-ae5f-d9aca0368d4e",
      "event_cluster_id": "976b0673-ef25-484d-9be8-afb6c791a214"
    },
    {
      "claim_cluster_id": "94076701-ef33-45db-95b9-6fd0d66deba4",
      "event_cluster_id": "e7ba1693-6646-480a-91d9-2e51aafb0261"
    },
    {
      "claim_cluster_id": "9fc7edf3-7209-4828-92b3-8d6dafded201",
      "event_cluster_id": "7b83d10a-e2be-4730-b52d-6f8b8b917c91"
    },
    {
      "claim_cluster_id": "881a8788-562f-4bf2-a8b1-590419007a87",
      "event_cluster_id": "8812088d-8004-44b8-9f99-4965a38e2031"
    },
    {
      "claim_cluster_id": "60a1acab-79cf-438f-96de-dbff294bd2e7",
      "event_cluster_id": "9b7a4b49-e4e5-49c9-a089-9e908e59efcc"
    },
    {
      "claim_cluster_id": "88b5488c-d8fa-4baf-af94-ea104e983a2a",
      "event_cluster_id": "cb16ac50-aed8-4a03-a5d3-3ad483937d48"
    },
    {
      "claim_cluster_id": "8f381ec8-c658-466c-973c-6cace2609d01",
      "event_cluster_id": "f2217761-bf63-4a79-b438-adbd2534e4d4"
    },
    {
      "claim_cluster_id": "8610b5a0-f4b4-403e-94e5-57543da5eb32",
      "event_cluster_id": "9d38e0bf-2876-4c73-84e8-54044be3ef3d"
    },
    {
      "claim_cluster_id": "64b06601-97a9-452d-80ca-13c5f92ae356",
      "event_cluster_id": "bda677c6-ab51-41f9-b0f0-3abc1ddda687"
    },
    {
      "claim_cluster_id": "5a8c09d4-337f-442b-8464-f2be567010bf",
      "event_cluster_id": "59e2af7d-1c61-4602-808b-5369f9854fc9"
    },
    {
      "claim_cluster_id": "e2f88c16-103f-497d-a88a-e63349d63a62",
      "event_cluster_id": "1288dccd-1b4b-44a8-94be-08411cd2073d"
    },
    {
      "claim_cluster_id": "4a2e9d4b-d2bf-4512-a149-283851028578",
      "event_cluster_id": "7e336202-10f1-4b91-9736-78eda34d2dbf"
    },
    {
      "claim_cluster_id": "ceabee0f-bc28-4b8e-8445-fc63ff551472",
      "event_cluster_id": "c2686424-538a-4d1b-80b6-8a6f5e252d7c"
    },
    {
      "claim_cluster_id": "6670d6b8-9c36-4849-b28c-4959087df8d4",
      "event_cluster_id": "1fb65a9b-f85e-4764-8dae-68053166a895"
    },
    {
      "claim_cluster_id": "d935874a-c33c-4b74-9137-99d8fd9fc1f8",
      "event_cluster_id": "29244a34-6c97-4370-9081-3f30eca9f0d9"
    },
    {
      "claim_cluster_id": "9621dd39-ccb5-4e12-9287-8a404c57bba0",
      "event_cluster_id": "0ba7abed-e798-4cd4-b041-3026081313b7"
    },
    {
      "claim_cluster_id": "dfe5555f-7179-45b9-9f7a-919fa1cc1569",
      "event_cluster_id": "d770e161-8ec1-425e-95c8-277c26523ee9"
    },
    {
      "claim_cluster_id": "3d2576b2-1572-432b-98fe-db8e768274d5",
      "event_cluster_id": "29c9c847-8482-467d-b041-65b225a57d48"
    },
    {
      "claim_cluster_id": "995a6788-c0da-4f2f-a729-9d6b9bf65efc",
      "event_cluster_id": "ab120ec9-7f69-4d7e-880b-eb52320c48cd"
    },
    {
      "claim_cluster_id": "3c4b8a98-54ef-4e72-a175-6c00ff85db75",
      "event_cluster_id": "708bf439-5986-4d45-983d-18029794b540"
    },
    {
      "claim_cluster_id": "125b87a9-62f3-402f-a1ad-6a9130845e80",
      "event_cluster_id": "26032edd-a722-4f79-a364-7bd2114c1626"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "5062ec52-04a9-40ad-82e8-e7b18ce41e9a"
    },
    {
      "claim_cluster_id": "2a9019de-d820-4155-a78b-fc972ec57552",
      "event_cluster_id": "4c6cef5a-0fb7-4222-87ca-9b217e095be3"
    },
    {
      "claim_cluster_id": "6a2f7e2f-c113-4c0f-aa04-a2e337901c37",
      "event_cluster_id": "b94a7962-9c49-4a90-a9cb-480e580b3877"
    },
    {
      "claim_cluster_id": "623ab1ae-1f19-46fc-b19b-929f64c7b525",
      "event_cluster_id": "05e83588-8d3e-4daa-9f6b-b9faf4c1da93"
    },
    {
      "claim_cluster_id": "100519ae-c1d6-4f8e-bcef-2f36e907e789",
      "event_cluster_id": "532f519a-d7c1-4910-afdd-938e13222189"
    },
    {
      "claim_cluster_id": "4ea56329-d3e1-48ab-835d-a5cbc403dcf0",
      "event_cluster_id": "c7d67f17-53ce-45fd-95d4-ee1ed41ef6c6"
    },
    {
      "claim_cluster_id": "4eb34d6f-2849-4a6f-9012-a59681fdeeff",
      "event_cluster_id": "3c66cbc4-f759-4da9-9813-b36b4c322970"
    },
    {
      "claim_cluster_id": "9d2cc997-e857-4b80-a227-cc6a1c61d16d",
      "event_cluster_id": "49b36199-c1c8-43a9-b1e6-9f3f63fb03d2"
    },
    {
      "claim_cluster_id": "57bfc89a-d981-44e9-a425-3364b9a5bc24",
      "event_cluster_id": "ae87ce9d-8fb9-4394-9afe-202f1ec14722"
    },
    {
      "claim_cluster_id": "43fa6264-b651-4eef-9023-b4483c40f5ce",
      "event_cluster_id": "83f0ad4a-11d4-48a9-95b9-150f72ff58b7"
    },
    {
      "claim_cluster_id": "4496a4b9-1070-44a0-89bc-e244c8a53dab",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "3579f3e6-5ab6-488d-a555-602383a4e3bf",
      "event_cluster_id": "f79fc6d6-3df1-4383-96eb-f3d73361c492"
    },
    {
      "claim_cluster_id": "3c925ff8-1b8c-47f3-b741-4544a596eae9",
      "event_cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87"
    },
    {
      "claim_cluster_id": "109acea7-1d98-4f39-a38c-6bb5919965c9",
      "event_cluster_id": "986a6ea4-399c-4998-bc4e-699677ef9178"
    },
    {
      "claim_cluster_id": "8f9f1940-08f3-4a29-938e-790645f67487",
      "event_cluster_id": "71cbbb7d-55a3-4b3d-a593-9d2df11352a4"
    },
    {
      "claim_cluster_id": "b65de138-2e69-44b3-acdb-00d152bc8245",
      "event_cluster_id": "80759b38-0166-40f3-aa37-31d3150e1679"
    },
    {
      "claim_cluster_id": "24f6a0c0-6612-4488-bc48-40d12340ab22",
      "event_cluster_id": "4197fab6-cdc4-4d7f-986d-0c9c57282306"
    },
    {
      "claim_cluster_id": "9abd543e-88ed-4716-b3f4-c8fea9769bf2",
      "event_cluster_id": "1e37f73d-f086-437d-9d39-f33d1960b443"
    },
    {
      "claim_cluster_id": "2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37",
      "event_cluster_id": "836ea24a-dc8d-4499-b021-d9c9b600cc60"
    },
    {
      "claim_cluster_id": "59d689c2-02ce-4e0f-83b7-9747d98bb8fb",
      "event_cluster_id": "114c895c-17f1-417b-8a4e-f626b06562d8"
    },
    {
      "claim_cluster_id": "40a361aa-d57e-4e3c-9740-34505f34913c",
      "event_cluster_id": "885d31c0-aa76-425b-b76c-0ebfaadd310b"
    },
    {
      "claim_cluster_id": "bf01755f-02c0-4092-8a9f-ea50ff0a213d",
      "event_cluster_id": "a2b34554-85cc-4429-8668-e4a20bf0d860"
    },
    {
      "claim_cluster_id": "1c24fe42-ed01-4d5e-85a3-6011ab09ff6f",
      "event_cluster_id": "aa05692d-a142-425a-b2a4-b94b0045a440"
    },
    {
      "claim_cluster_id": "bdc594bb-6aa7-4421-82b8-b7df34a7c93e",
      "event_cluster_id": "06451ed7-032d-45e3-9726-f485fc31a739"
    },
    {
      "claim_cluster_id": "2a1de060-abb4-43d9-a91c-f13c074e7031",
      "event_cluster_id": "2a09de37-e0d8-48a4-b6d1-8773f6d954be"
    },
    {
      "claim_cluster_id": "7b76e5cb-748d-468e-9baa-d34773d5f24e",
      "event_cluster_id": "02b14d03-5d87-4a88-8655-66e1b5dd7380"
    },
    {
      "claim_cluster_id": "05638bd6-42ef-4049-b6f6-4a5478e7b8a5",
      "event_cluster_id": "0656118b-9248-4fe1-a608-3abb014d1738"
    },
    {
      "claim_cluster_id": "668dd84f-417c-4a0b-ac12-78d246a5f46e",
      "event_cluster_id": "0368ead8-8d25-41a1-9249-88baff9335b0"
    },
    {
      "claim_cluster_id": "0b400fd1-082b-403b-9ea9-8d3710e7cc9f",
      "event_cluster_id": "62babf7f-7431-44e7-bf3a-2b3d26f92e86"
    },
    {
      "claim_cluster_id": "144a5089-d891-40d6-b31c-9c5381bee1d5",
      "event_cluster_id": "f5bf5358-6837-4934-ac62-9ad98735b162"
    },
    {
      "claim_cluster_id": "20ab2459-a6a0-4e45-aef0-5b2d6b529a0e",
      "event_cluster_id": "b2e1f729-9431-42cc-affc-159e60e3c7e6"
    },
    {
      "claim_cluster_id": "19dc451c-d076-4677-8e6a-44a760f27332",
      "event_cluster_id": "713029fb-6b38-4883-a995-a264b7e6024e"
    },
    {
      "claim_cluster_id": "40d2bc92-0cd6-4002-bff9-64332ddd7635",
      "event_cluster_id": "0f364498-4c31-43db-a10b-2fd4536b05a1"
    },
    {
      "claim_cluster_id": "400218af-6cc1-4f06-8e3d-7804bde6ad17",
      "event_cluster_id": "1ed52c55-1d90-4460-9e88-861e6d435eee"
    },
    {
      "claim_cluster_id": "c298484d-a7d5-4e80-ac66-217221dc6d85",
      "event_cluster_id": "360f1793-af7a-40dd-84eb-5e978218de67"
    },
    {
      "claim_cluster_id": "8ae88722-b8db-4d5b-b13e-130f65630e05",
      "event_cluster_id": "57033778-ccb4-4eeb-beda-4c41cf31fd86"
    },
    {
      "claim_cluster_id": "8e7a25f4-c25d-43c4-890a-4d8d8364c5bf",
      "event_cluster_id": "e4b7f8f2-bf69-40ad-a14f-a4a477fe73df"
    },
    {
      "claim_cluster_id": "b54e5664-a40b-4682-b959-bcfb59ddd4b0",
      "event_cluster_id": "7e9bdb50-a12f-4215-9c08-0927124e5707"
    },
    {
      "claim_cluster_id": "7353e857-402f-4705-bd75-9efa4acaaedb",
      "event_cluster_id": "6d2c68aa-e5f1-4199-8a32-52bb8d80e934"
    },
    {
      "claim_cluster_id": "a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4",
      "event_cluster_id": "ddc5dfbd-77e6-466c-a4ac-12178d35c42e"
    },
    {
      "claim_cluster_id": "0792eb98-3885-48f3-bc43-bf2a8c746720",
      "event_cluster_id": "88bd5511-0bcd-4336-b0a1-fbafb00aadc9"
    },
    {
      "claim_cluster_id": "11210f68-2915-41ff-b25a-a55a575f9528",
      "event_cluster_id": "401a2d7b-5531-4488-bec8-d0c22a8122a3"
    },
    {
      "claim_cluster_id": "0f1cacf9-3df0-4d00-8952-b3fa5195f1fb",
      "event_cluster_id": "45a4a2a8-b9e2-4fb3-a00b-44192e1fb005"
    },
    {
      "claim_cluster_id": "623ab1ae-1f19-46fc-b19b-929f64c7b525",
      "event_cluster_id": "ce538c96-9586-4a44-b4ec-f9e46a72b4b0"
    },
    {
      "claim_cluster_id": "87e51e32-d441-41a9-8026-a751a57b0ed2",
      "event_cluster_id": "cd8525ab-90a4-434a-bf10-f887240219f2"
    },
    {
      "claim_cluster_id": "38f73b32-c8c6-49f9-8452-aefe0c4fa642",
      "event_cluster_id": "1afcda67-b75d-4fbc-802a-288b7fcc1fcf"
    },
    {
      "claim_cluster_id": "6b22978f-c41a-4fd1-ac4e-29deafe60573",
      "event_cluster_id": "e8352caf-0212-486c-8732-e56619b31e7c"
    },
    {
      "claim_cluster_id": "38c3007b-05b7-481e-b44e-c09d28628f5e",
      "event_cluster_id": "dbf3b7bb-6fb1-4da2-9ead-1fea65aeaf76"
    },
    {
      "claim_cluster_id": "d3bded76-52fd-4f86-982f-558582eed404",
      "event_cluster_id": "cd745d99-6d4d-4cbd-964c-839c80021692"
    },
    {
      "claim_cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
      "event_cluster_id": "7f953e81-8c8d-4f0d-9b98-873627d95104"
    },
    {
      "claim_cluster_id": "f3288e7a-a54c-44d1-8307-67aafb47c852",
      "event_cluster_id": "ce5f39de-c868-4feb-8d91-20b21e8b8ded"
    },
    {
      "claim_cluster_id": "aa179085-85ff-43d4-ba04-8a3f88267ae8",
      "event_cluster_id": "479e911e-126f-4188-8866-356ae46aef5b"
    },
    {
      "claim_cluster_id": "673d8d19-d059-4065-9b0d-82b1376c6c55",
      "event_cluster_id": "43cf9cfc-c9db-41b9-a566-9bec2d970db4"
    },
    {
      "claim_cluster_id": "29790db2-2536-415f-822b-9a4c1f1f8a3c",
      "event_cluster_id": "7370dfbb-74ea-4d34-82b7-9398b71ecd5a"
    },
    {
      "claim_cluster_id": "54e59784-1db4-41f0-a651-2d5e2138670a",
      "event_cluster_id": "722dcdeb-8c69-4fc9-878a-87c7aaade27b"
    },
    {
      "claim_cluster_id": "fe10e346-5245-4859-9317-c6ffae804527",
      "event_cluster_id": "779beaba-8043-4ec4-ab6b-1cb654ad8ccd"
    },
    {
      "claim_cluster_id": "b473cdd9-7369-4866-a926-04d86eb03c52",
      "event_cluster_id": "a99c031d-3fd7-4e53-9585-fd9ad40ad4d1"
    },
    {
      "claim_cluster_id": "e9b05837-7f42-4f2f-bc7d-dca62a93d724",
      "event_cluster_id": "4823b0d5-067d-49e8-9415-62a09183548f"
    },
    {
      "claim_cluster_id": "8b198c30-0c8c-4abd-b13a-0e55963e8bb8",
      "event_cluster_id": "367c1ab5-4267-4b68-a2ed-2893d2797c11"
    },
    {
      "claim_cluster_id": "00e4e855-edbf-4846-a824-47a6b221930a",
      "event_cluster_id": "61608de3-ac5a-4b10-bba7-1b5580f57caa"
    },
    {
      "claim_cluster_id": "c153b607-ea7e-4a94-8f50-d29611d77fe7",
      "event_cluster_id": "ec333963-a3e0-433d-a595-145497c56ca9"
    },
    {
      "claim_cluster_id": "ebf0120f-ec3a-4a71-bd2b-88f212264387",
      "event_cluster_id": "7fd887a5-caaf-4dd7-967d-5f621c88bae6"
    },
    {
      "claim_cluster_id": "6b22978f-c41a-4fd1-ac4e-29deafe60573",
      "event_cluster_id": "8a1337a6-24c6-4382-8169-4bec0e1a4fab"
    },
    {
      "claim_cluster_id": "6547f895-7ab3-43c4-b3b1-d01e17f1e888",
      "event_cluster_id": "34aab7b4-5379-4f38-9914-ae9a14a7914c"
    },
    {
      "claim_cluster_id": "a1a796af-13af-4bb2-ad74-b64193c2de86",
      "event_cluster_id": "c768dbef-cff9-45a6-9583-58c568197a94"
    },
    {
      "claim_cluster_id": "c6d29068-aaee-4cd5-94e1-e4e031d50401",
      "event_cluster_id": "235b76d8-eadf-4d03-98a8-4198401ca562"
    },
    {
      "claim_cluster_id": "93d1eed5-3c1d-4407-adac-a9d52f51c6e8",
      "event_cluster_id": "53ac9504-7af3-4a7a-b7c0-a75d3fd36831"
    },
    {
      "claim_cluster_id": "93d03ec0-ac83-451a-87b2-a95e3d58859f",
      "event_cluster_id": "a5c724f6-7c96-401f-918f-4b43072ac6cc"
    },
    {
      "claim_cluster_id": "cd4aea0c-c90e-430b-95f8-4bff425c022e",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "e71ece34-2a4e-4762-87c7-693bfadf879f",
      "event_cluster_id": "58062111-7e54-418d-9733-f5233a5838b1"
    },
    {
      "claim_cluster_id": "98dac116-c6f6-46b8-945d-1ffe5cc5db7d",
      "event_cluster_id": "db91eebc-901f-4800-8b70-2d11c9945ab2"
    },
    {
      "claim_cluster_id": "7b83d3ee-13b2-47c1-ab89-4f78258a986b",
      "event_cluster_id": "6c7b148b-0647-4c2a-ac9a-6341501bc035"
    },
    {
      "claim_cluster_id": "e126486d-8b99-4425-b6a3-54724b486b78",
      "event_cluster_id": "93f5bdee-4d35-454b-8f1b-0b318e24a68d"
    },
    {
      "claim_cluster_id": "94e768ad-42fa-42f8-83fa-89a3705b92a2",
      "event_cluster_id": "cfcddae8-7e4d-4fb6-8a06-45fdad19422f"
    },
    {
      "claim_cluster_id": "c3f83d4c-9f83-4fe3-befa-1e9b93dee510",
      "event_cluster_id": "446a7c12-73f1-49f5-944a-5a0119281e12"
    },
    {
      "claim_cluster_id": "300fdda9-fd92-4984-a9e6-86c9522fb6d4",
      "event_cluster_id": "e4b34178-e71f-4443-adb8-d0d805a5c827"
    },
    {
      "claim_cluster_id": "1e227a80-8d1d-4484-9608-82719d3b526e",
      "event_cluster_id": "b98bf259-2428-4cda-a309-5be4fdb0c3ef"
    },
    {
      "claim_cluster_id": "f46bebef-6c63-4778-a5c7-e0d7b893e969",
      "event_cluster_id": "fc7e97b6-8dfc-454f-b469-c14bd479fe70"
    },
    {
      "claim_cluster_id": "eb2e33e5-165b-4a02-aa96-d53bcd386da0",
      "event_cluster_id": "67a5aa36-56f0-43ce-bcd7-a10ff634cd7e"
    },
    {
      "claim_cluster_id": "9d2cc997-e857-4b80-a227-cc6a1c61d16d",
      "event_cluster_id": "de6de235-4f06-4b1a-9079-19678104136f"
    },
    {
      "claim_cluster_id": "b4295bad-3940-4b00-ac2b-862c41b5597c",
      "event_cluster_id": "b3a5dd46-4aa3-4884-9a77-ee986170d8d0"
    },
    {
      "claim_cluster_id": "c81b3fac-f8f7-4824-a157-6d31dd48689f",
      "event_cluster_id": "d6e4581d-8b56-4f44-aadb-7c57a4d3eb29"
    },
    {
      "claim_cluster_id": "b98bb0fa-4594-47af-9069-f482aaa8d7c4",
      "event_cluster_id": "48704c98-ccd1-4907-aeb2-d6276a1025d7"
    },
    {
      "claim_cluster_id": "346f630a-2d46-4e8a-80ef-67a96ebf81ef",
      "event_cluster_id": "011aa847-d3e3-4d34-bf5e-378f39ba8a3c"
    },
    {
      "claim_cluster_id": "194a083f-fee7-4bf0-b198-fa40c8bdfe21",
      "event_cluster_id": "b6c6623b-ece7-4fbe-8627-8db59a5e3dc8"
    },
    {
      "claim_cluster_id": "2846d44d-8ccd-40e0-8486-7b360ffa4608",
      "event_cluster_id": "e5391c1d-dcc6-47a7-9d8e-10697d160138"
    },
    {
      "claim_cluster_id": "f9a4fce8-b5c8-4697-808a-9ac08e5be52f",
      "event_cluster_id": "ebcc0902-6e47-4925-9d19-ac06d520106b"
    },
    {
      "claim_cluster_id": "4736fddc-4878-48ef-a211-f6b0740cc434",
      "event_cluster_id": "044cb84d-c3b3-4798-aaea-5e325bcd65af"
    },
    {
      "claim_cluster_id": "90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410",
      "event_cluster_id": "0d8dd84c-b6a6-4b66-80f5-c84acd03da41"
    },
    {
      "claim_cluster_id": "d81a20c0-6869-45f5-b75d-d3dcf313d9ed",
      "event_cluster_id": "178a55a6-f879-45f8-85be-38fbb568a251"
    },
    {
      "claim_cluster_id": "bd06a127-0f18-48fa-b6d0-ff607d111775",
      "event_cluster_id": "4b5a21e3-57c3-4239-8ed1-85b9925a8673"
    },
    {
      "claim_cluster_id": "9723a8c8-8969-4471-bc9d-732ca83fc5b6",
      "event_cluster_id": "ea70a7dd-0151-4733-b8dd-c6143a306c66"
    },
    {
      "claim_cluster_id": "9dae5050-ee2d-4e3c-8dd3-b9ea85a53752",
      "event_cluster_id": "793d367c-aa36-4def-8927-25ed78dc0d58"
    },
    {
      "claim_cluster_id": "16e980af-79a1-4255-8ad0-56ca61ae3b8a",
      "event_cluster_id": "35e49ef4-8290-45fe-a6cc-bdd77af41ebf"
    },
    {
      "claim_cluster_id": "73a6792a-38f3-4e05-a1bc-e5dc764c0b4d",
      "event_cluster_id": "43320422-2afc-457d-a5b5-902abc100632"
    },
    {
      "claim_cluster_id": "585ea825-312e-47cf-9ba6-332afbfb9ed5",
      "event_cluster_id": "24ff5666-c9a9-45c1-a6b9-bf154f310b8b"
    },
    {
      "claim_cluster_id": "4892691c-c25d-434c-bfaf-8b1764a0e393",
      "event_cluster_id": "c84778ea-ef3a-409f-9105-f5f4a9c3f19d"
    },
    {
      "claim_cluster_id": "40739d2a-a8c2-4f74-ad24-d1d6db92d225",
      "event_cluster_id": "e24b1f85-4581-4a8b-9bbd-39a7582f7249"
    },
    {
      "claim_cluster_id": "ff47f0b3-49ae-48d8-b9cf-5707589bed0f",
      "event_cluster_id": "8621b776-3006-4d9b-93a8-f14394cb2f9a"
    },
    {
      "claim_cluster_id": "b0f153c6-cc18-4aee-9b69-e8f06c8e3149",
      "event_cluster_id": "ef77006d-68d7-4c27-ae83-cb85890ca2b1"
    },
    {
      "claim_cluster_id": "03db723a-dcac-4e7f-b456-18c0fdfdba8d",
      "event_cluster_id": "d882f953-ff9f-4410-820f-ffce8c5ec321"
    },
    {
      "claim_cluster_id": "4736fddc-4878-48ef-a211-f6b0740cc434",
      "event_cluster_id": "95efba0b-bc1c-48bf-8e7f-8321983dc081"
    },
    {
      "claim_cluster_id": "d11c600b-0ae3-4e55-8d1a-58fd9d0f71dc",
      "event_cluster_id": "8e9141e0-2f9d-4d0a-920e-7ed046dbbcec"
    },
    {
      "claim_cluster_id": "68d51d93-fcbe-411f-8a89-cb79bd347512",
      "event_cluster_id": "e550706a-507b-4244-b8a2-1df630cff9aa"
    },
    {
      "claim_cluster_id": "89c49eca-c41a-43b9-88d5-85536edafaa8",
      "event_cluster_id": "99785983-351c-4201-b7c5-88255cfce2ce"
    },
    {
      "claim_cluster_id": "8f2a4264-d263-4757-889e-c18e3e101875",
      "event_cluster_id": "7c8be876-c0d6-46b2-8e28-be16ba79de4f"
    },
    {
      "claim_cluster_id": "af144d2c-f8aa-40f2-9250-f41cd71f8fd9",
      "event_cluster_id": "28b18897-b522-4746-b010-473d38b5a261"
    },
    {
      "claim_cluster_id": "67bef4c5-afcc-4a65-9538-ce302f965385",
      "event_cluster_id": "ed8ee9d8-3361-4c66-86fb-3b0c6210300d"
    },
    {
      "claim_cluster_id": "0bc36847-debb-43d3-bab5-e1a736194eac",
      "event_cluster_id": "af90686d-77e8-4713-873e-8c63e5dbe370"
    },
    {
      "claim_cluster_id": "2c61e4c1-c73f-4292-be06-e4f072faf26c",
      "event_cluster_id": "94df14e2-7e46-450f-90de-ca92085eab78"
    },
    {
      "claim_cluster_id": "fdb63c1f-d931-4ed0-b2b4-c60113cb73c4",
      "event_cluster_id": "d013c87c-7dd2-4021-97c9-a4069e2ad7f2"
    },
    {
      "claim_cluster_id": "8c61663d-a5f4-43e3-9ca6-42de906f614c",
      "event_cluster_id": "b366766f-15ce-4857-abc5-dda97885eda4"
    },
    {
      "claim_cluster_id": "c0707d1f-d796-4de7-994b-fd76b5d9d3dd",
      "event_cluster_id": "d169380d-3c63-4800-8f8c-5deedf749ffe"
    },
    {
      "claim_cluster_id": "93eceb5b-454d-4e3d-b632-57c5588aea34",
      "event_cluster_id": "b6c2d87e-7d9e-4ac3-a24f-6f394e994f13"
    },
    {
      "claim_cluster_id": "aaa5b32a-96ba-4450-b886-70f714b65bf2",
      "event_cluster_id": "ea73cbad-05bd-4c4c-8cae-169119be8355"
    },
    {
      "claim_cluster_id": "ecc32ba8-bd1c-43c6-8192-e0502c1f14b7",
      "event_cluster_id": "3c66cbc4-f759-4da9-9813-b36b4c322970"
    },
    {
      "claim_cluster_id": "8ae7ec4c-38f4-4117-962e-b6f044038377",
      "event_cluster_id": "11c149bd-c47a-4b6a-887d-8baf2ffc4481"
    },
    {
      "claim_cluster_id": "cc0b4f6a-9515-47dc-b1fc-eea9be8d97fb",
      "event_cluster_id": "02036fb0-ba58-45fa-b4ad-534e30796546"
    },
    {
      "claim_cluster_id": "d61fc1c9-1533-4eaf-88f3-8d0340ce2de0",
      "event_cluster_id": "c355c9c0-a133-4a94-b40c-10d91addc7eb"
    },
    {
      "claim_cluster_id": "a15b31ed-89e7-4c30-9559-8eac356b32e1",
      "event_cluster_id": "f0a2a4b5-aeb4-45ae-835f-525f0fd65d67"
    },
    {
      "claim_cluster_id": "2a1de060-abb4-43d9-a91c-f13c074e7031",
      "event_cluster_id": "57d96007-f80d-4110-8583-3e280492b584"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "9af9ad02-7803-4d3d-9d58-fdfc300bef96",
      "event_cluster_id": "6e64c34e-113d-43d7-87a6-90c61d4d3f67"
    },
    {
      "claim_cluster_id": "7353e857-402f-4705-bd75-9efa4acaaedb",
      "event_cluster_id": "8cceec53-f974-47da-b9c4-5af02c151d1d"
    },
    {
      "claim_cluster_id": "9562ace0-b924-497a-a3ab-5d483c835c5a",
      "event_cluster_id": "5f674ba0-ccc9-4a42-8c81-55a71cb30d68"
    },
    {
      "claim_cluster_id": "31bf6722-ac5c-4597-8c42-50efe5c5aceb",
      "event_cluster_id": "3594d516-c429-465e-9ac8-b4d9801acd0d"
    },
    {
      "claim_cluster_id": "7b0fb73a-9488-43a9-80ee-d1864bcbae49",
      "event_cluster_id": "51648166-6ec3-46d9-a3d1-905adbb2ede9"
    },
    {
      "claim_cluster_id": "99df608a-defa-4cea-b8ef-86519fa0e08a",
      "event_cluster_id": "d9f5ad2b-430e-4145-acd5-2d92262e0952"
    },
    {
      "claim_cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
      "event_cluster_id": "4fc147e3-0b67-422d-b442-9aed1bd9ffee"
    },
    {
      "claim_cluster_id": "a0aafb48-1cc4-47f3-9cc7-073b87c64efc",
      "event_cluster_id": "a1c1162e-c36a-46e0-95af-7c5c08d5e6ff"
    },
    {
      "claim_cluster_id": "0f3e5cb9-90ce-423e-bbb3-4a331e7ddd35",
      "event_cluster_id": "1abde06f-fea9-40fc-b58c-ddb744004d48"
    },
    {
      "claim_cluster_id": "2105abe4-014b-48d8-a8a2-6e113ac81f52",
      "event_cluster_id": "6cadfbb6-c995-4a61-9bf9-357705f879c1"
    },
    {
      "claim_cluster_id": "4a05fcea-c8cb-4b88-bb80-cab978e72560",
      "event_cluster_id": "29696d33-676a-411b-9f2f-5aad8a647ed0"
    },
    {
      "claim_cluster_id": "199242cb-5b3e-40d9-bf38-e1eddcf574fc",
      "event_cluster_id": "114c895c-17f1-417b-8a4e-f626b06562d8"
    },
    {
      "claim_cluster_id": "cdb08998-bbe0-4530-9534-7744fb962961",
      "event_cluster_id": "aeb7fb87-5c7f-4917-b661-3fe948376ad9"
    },
    {
      "claim_cluster_id": "ec67de7a-3e2b-4e45-9df6-6bb76aa7ed80",
      "event_cluster_id": "5eaafca6-4075-4128-8780-266e84f06a62"
    },
    {
      "claim_cluster_id": "a2f18fa4-3554-4400-be7d-a33cb07dfa44",
      "event_cluster_id": "c178db65-d340-471f-b632-8b8dad1a5b51"
    },
    {
      "claim_cluster_id": "976d7c8a-cb17-41e5-9407-5cd8c141bb84",
      "event_cluster_id": "3ea2f80e-f4b6-4835-b337-64fb3587f6b9"
    },
    {
      "claim_cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
      "event_cluster_id": "e6120475-8d62-4b1d-84b3-4c53f22ff855"
    },
    {
      "claim_cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "1d8a91a4-e2e3-49c2-838b-462dda682ab0",
      "event_cluster_id": "92fc4500-350f-4d12-9690-7e529074f891"
    },
    {
      "claim_cluster_id": "f58e8498-102b-4b72-96b4-c6d5b3fb97a9",
      "event_cluster_id": "693353d7-9dc6-4a72-be1a-08fb1957eb6c"
    },
    {
      "claim_cluster_id": "c2f5da6f-3ff0-489c-8ce8-384ee3d82e6a",
      "event_cluster_id": "a16d38f8-25ac-46b8-94d9-38eb77cacdcf"
    },
    {
      "claim_cluster_id": "4770d222-ba7d-4bbe-8acd-294b0fe141f8",
      "event_cluster_id": "ccd75d9c-f680-4c7d-a6c6-f684f0c4b09f"
    },
    {
      "claim_cluster_id": "59f595d5-6ff2-4686-81ce-6150bd29db9d",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "d8b92399-bf69-4b82-b461-678acbb7e385",
      "event_cluster_id": "cb346877-50ff-42c0-97e6-7abb95523efb"
    },
    {
      "claim_cluster_id": "a4400c47-658a-4ca0-9b29-fa8384838731",
      "event_cluster_id": "c367dcdd-b30e-4731-8d62-e633357c9a70"
    },
    {
      "claim_cluster_id": "dcadf3a6-188b-4a08-881c-e1acb19f186a",
      "event_cluster_id": "8b23f6cd-4b58-4e69-9587-6944141b8e4e"
    },
    {
      "claim_cluster_id": "43784351-864b-42c8-bac5-2de22a3743c2",
      "event_cluster_id": "75482488-ef21-4630-bf12-4747cdb69136"
    },
    {
      "claim_cluster_id": "54c90db1-79c2-4dc0-b9f0-9cd9022a857f",
      "event_cluster_id": "63114462-4942-4f84-9437-7c2bd611b2f3"
    },
    {
      "claim_cluster_id": "fdae240e-8bc7-467c-b880-f3913e28e6ce",
      "event_cluster_id": "10f7e4c6-143d-4ada-adc6-a0d81c4f5272"
    },
    {
      "claim_cluster_id": "8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9",
      "event_cluster_id": "5d455dbc-1091-4f62-8c3e-fdf2d7c2080e"
    },
    {
      "claim_cluster_id": "a03aac32-b760-4f2a-8ae0-1194424402ab",
      "event_cluster_id": "2f690c44-ca18-4a31-a2b5-68ac60208360"
    },
    {
      "claim_cluster_id": "8d565c91-b887-465d-a08e-aff09b1e9e5b",
      "event_cluster_id": "bb551e75-48fa-42c3-a108-cb4b1462b529"
    },
    {
      "claim_cluster_id": "0649ea17-dc60-458b-988f-5fb62bfa7199",
      "event_cluster_id": "309e6017-5ba6-4aa5-918a-e978302b6d2d"
    },
    {
      "claim_cluster_id": "c438220c-6784-49f7-a890-f0ef46c3304b",
      "event_cluster_id": "b2825dcc-d8ef-4d2e-bf5e-a9bc43fa0aaa"
    },
    {
      "claim_cluster_id": "6d2143f7-a494-4413-af4e-40c695a4a5e3",
      "event_cluster_id": "da81244a-ef78-429d-9f3d-b08a5c21a084"
    },
    {
      "claim_cluster_id": "a38268fe-ba89-4d63-8481-63c080523a0a",
      "event_cluster_id": "c53a9c23-c3a5-4b85-9f93-40e51b50505c"
    },
    {
      "claim_cluster_id": "e4ac4a3c-288d-4beb-9f3a-d8f26ff2f9c7",
      "event_cluster_id": "ee253c9f-7d80-4f50-99f1-722670916f95"
    },
    {
      "claim_cluster_id": "86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "07b6bde9-eeca-4fea-b3c2-39093320ea05",
      "event_cluster_id": "f083dfd3-1f0b-4469-b557-e14ab47deef4"
    },
    {
      "claim_cluster_id": "3b48df52-c3ed-4c3d-8f61-54ae3d11e9b1",
      "event_cluster_id": "11663b2b-28c7-494e-973e-2fc5dca8374b"
    },
    {
      "claim_cluster_id": "7b23c8f0-7f79-4c82-ac44-60b02a4ff1cd",
      "event_cluster_id": "3304ef73-a023-4ec9-bf07-27f713496a6e"
    },
    {
      "claim_cluster_id": "fb518ec1-f92f-4616-8a47-9c0563a7f0fa",
      "event_cluster_id": "b02a0b69-fccb-4794-8e75-23dec5c20147"
    },
    {
      "claim_cluster_id": "39f6fc8d-27a2-4261-870e-362c0315c46f",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "a92df9a8-beac-475c-a620-574a5351def4",
      "event_cluster_id": "9a9a24a1-0774-457a-a9c9-ecf8d207a6ef"
    },
    {
      "claim_cluster_id": "b4de3a2a-395f-4d49-9f4e-abbd190c57b5",
      "event_cluster_id": "6e905ee5-7953-41bc-bbb1-d9109f51ccff"
    },
    {
      "claim_cluster_id": "f679dcc1-fbec-4813-8cbd-bf97a313606d",
      "event_cluster_id": "eebd5cfb-feb1-4a5e-af2c-b6604b0d1aba"
    },
    {
      "claim_cluster_id": "2f4a7179-3f3f-4eb6-8891-8b8d39467620",
      "event_cluster_id": "d46df71d-8407-4df2-8b9c-164a3f2cc00f"
    },
    {
      "claim_cluster_id": "7e4a12f6-fe24-48f6-993c-d7197eb9c44e",
      "event_cluster_id": "1b781e70-c91d-4aef-8e8b-426c2c695555"
    },
    {
      "claim_cluster_id": "101b3e01-9e80-483b-82e6-39667fb77d18",
      "event_cluster_id": "efecc9d7-3e88-45ed-b11f-77af1e65000e"
    },
    {
      "claim_cluster_id": "7e98dc53-abf7-4bf8-8ac7-3c9623f6d068",
      "event_cluster_id": "2c62c383-cda1-4d02-9286-63fc5fe04c15"
    },
    {
      "claim_cluster_id": "20d6183f-1c47-41c9-bd8d-d5a8b68eff2e",
      "event_cluster_id": "b73efc0f-5d42-47ce-a8ed-e5aac2d0dd90"
    },
    {
      "claim_cluster_id": "58655fd4-e92f-4f77-b848-bd4849b75655",
      "event_cluster_id": "3c7a34af-192b-4878-baca-1d31c499b7da"
    },
    {
      "claim_cluster_id": "f2363c7c-72d1-4e3a-b724-27c1d218c5fc",
      "event_cluster_id": "9d8ee527-fdd4-4b2b-bd2c-0ad4ce6caf15"
    },
    {
      "claim_cluster_id": "29e9fc0f-b1d3-428d-985b-aead08ce4e3c",
      "event_cluster_id": "62318edf-fc49-441d-85dd-789c9859f09c"
    },
    {
      "claim_cluster_id": "93f3d467-50ce-4038-8205-5814ad28dd43",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "9aca5dda-f273-4941-9e97-91832c08621e",
      "event_cluster_id": "9bc46e61-887b-42f5-8f08-16b384ac7b26"
    },
    {
      "claim_cluster_id": "de700722-a9e2-4659-a181-3fb83efdd41f",
      "event_cluster_id": "e10e77d8-6d39-499c-97ff-017e9cdbf650"
    },
    {
      "claim_cluster_id": "735fb4c9-5d71-4b3e-b247-9bafaa632b98",
      "event_cluster_id": "6fdbee19-d8a2-452a-bbea-e0fcfc3c5b00"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "827f6b49-228f-4d42-afa2-d86a5b588a72"
    },
    {
      "claim_cluster_id": "262772f6-e21d-4ca8-a80f-06c1518ea90e",
      "event_cluster_id": "f5211fb7-fcad-4978-ad00-c77df1404c5e"
    },
    {
      "claim_cluster_id": "5521d112-0a05-4e5a-881c-de705171fc9a",
      "event_cluster_id": "a13ff8f2-81e7-4186-a169-3843a9ddc359"
    },
    {
      "claim_cluster_id": "3b17ca99-a0cf-4b4c-a71f-c0181125d3ce",
      "event_cluster_id": "4ea67e25-b76d-482e-ba32-1243cadbf594"
    },
    {
      "claim_cluster_id": "c56c08cf-6265-4f43-9208-61aa17304ed8",
      "event_cluster_id": "c9770c33-6591-4102-923f-7ca010384410"
    },
    {
      "claim_cluster_id": "290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45",
      "event_cluster_id": "1e88b8f2-56ce-4d36-b086-ab1c91d0ff73"
    },
    {
      "claim_cluster_id": "bf01755f-02c0-4092-8a9f-ea50ff0a213d",
      "event_cluster_id": "65ce1b56-2de9-4e86-a4bc-a0777c097c60"
    },
    {
      "claim_cluster_id": "818b32ce-b83e-40a4-b06b-dd4e2c09af00",
      "event_cluster_id": "3bf8a3ce-dee2-499e-bfb9-1c559ad0291c"
    },
    {
      "claim_cluster_id": "f6541b8c-4e86-4aff-8593-e4f14f2ecc27",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "a031766e-aaad-4e78-b0e4-bd1cf2fc1a66",
      "event_cluster_id": "bb78b3cf-3fee-4d7e-b532-1ccb52ef3013"
    },
    {
      "claim_cluster_id": "be29b74d-f560-4279-9339-cf00d4dac2b0",
      "event_cluster_id": "9b558396-1afa-47bd-8065-f4f35e900fa5"
    },
    {
      "claim_cluster_id": "e0a9ff6c-3760-4c9a-a79f-78340ef165ed",
      "event_cluster_id": "6d58a40e-4432-43bc-9a0f-20467f608aca"
    },
    {
      "claim_cluster_id": "5518570b-ceeb-400e-8720-a531292d57ce",
      "event_cluster_id": "0ba56805-c27f-4d6b-bb0f-6903b4c54c1a"
    },
    {
      "claim_cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
      "event_cluster_id": "c5ac1407-521f-4465-8124-83f30e719068"
    },
    {
      "claim_cluster_id": "2ed3c98f-2c08-4da6-97f9-38e8a951f08e",
      "event_cluster_id": "b243dfe5-ad7c-4377-9402-0fc9aefe73cc"
    },
    {
      "claim_cluster_id": "07438861-a868-47ed-8a1a-288138dc65c0",
      "event_cluster_id": "e30d6b86-658d-4082-9c3e-5cf88f347945"
    },
    {
      "claim_cluster_id": "03b72068-02c5-403e-b844-88e40b030a18",
      "event_cluster_id": "185df82d-71c3-4fa5-ab56-a142dce4a50f"
    },
    {
      "claim_cluster_id": "ee1d7c5b-4d98-426c-bf43-b5350f89e9dc",
      "event_cluster_id": "c4fe585b-23d9-4a10-a6b1-a3c43c70fda5"
    },
    {
      "claim_cluster_id": "6a714a6e-4cc1-4629-9f0b-f9a9a37c2ce5",
      "event_cluster_id": "59c32196-c345-4e2c-9ab5-46cd4d040be1"
    },
    {
      "claim_cluster_id": "41b1a4cf-dc12-4277-ac68-40ba76c05f8c",
      "event_cluster_id": "02eef8bd-0b3d-4ee2-ac5e-9d2a9e96e5e4"
    },
    {
      "claim_cluster_id": "88a5288e-7f93-4e9a-8960-db23a08024fc",
      "event_cluster_id": "b9239d36-ef30-4a43-92f9-8fe391efcc3e"
    },
    {
      "claim_cluster_id": "a055cbcf-5c3c-4cd0-bba6-d78a753ee5d0",
      "event_cluster_id": "20dbcfed-6463-4ba7-98e9-93b565b2719b"
    },
    {
      "claim_cluster_id": "8b93bbca-8559-4acc-9d3e-382347cd5269",
      "event_cluster_id": "b7612309-cc53-44f3-9740-76cdf065b6eb"
    },
    {
      "claim_cluster_id": "35d18d7f-0f7d-4654-8e65-f6b4bcac032a",
      "event_cluster_id": "e17360aa-cb4e-4e41-913f-f3e853c44fd4"
    },
    {
      "claim_cluster_id": "7e98dc53-abf7-4bf8-8ac7-3c9623f6d068",
      "event_cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"
    },
    {
      "claim_cluster_id": "4a2e9d4b-d2bf-4512-a149-283851028578",
      "event_cluster_id": "4a075bc4-4bea-4ec1-8783-33d17452523a"
    },
    {
      "claim_cluster_id": "8ef65ecd-3750-4a43-89ce-d81b333f2e1c",
      "event_cluster_id": "49883883-56ad-4f95-b0d0-b90bb6b04064"
    },
    {
      "claim_cluster_id": "1ef5190b-3eed-45b4-b04e-14655cb38618",
      "event_cluster_id": "6c30eaa7-fa21-463e-8143-13ed2522dbff"
    },
    {
      "claim_cluster_id": "d8c4ecf1-bb1b-4da0-8a1b-b80059b7063b",
      "event_cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"
    },
    {
      "claim_cluster_id": "73ed8dfb-71b9-42f0-9f45-a873045bd275",
      "event_cluster_id": "71624d95-aa07-4fb2-8217-706e01ae4a63"
    },
    {
      "claim_cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "3c4b8a98-54ef-4e72-a175-6c00ff85db75",
      "event_cluster_id": "6207c1fd-d86c-4598-b9ed-72232636a976"
    },
    {
      "claim_cluster_id": "b8299ae1-9e2e-465d-af82-b9354f3e9c44",
      "event_cluster_id": "1bfa372d-748e-4dfa-a2d8-05a78385d36f"
    },
    {
      "claim_cluster_id": "baa116d7-3e4a-4d22-809b-fdab138f8d83",
      "event_cluster_id": "920d6e80-3d5e-4fd9-ac7b-57d21a7433b5"
    },
    {
      "claim_cluster_id": "6832730a-f3c3-49e8-8c1f-45ff7dac590c",
      "event_cluster_id": "062e5bd8-abe2-403a-b6a1-7c176aafd049"
    },
    {
      "claim_cluster_id": "f83f6c15-13c0-41a8-b991-8abeda0466c4",
      "event_cluster_id": "f21f5e02-c7d3-439c-a7ce-450375c434a9"
    },
    {
      "claim_cluster_id": "19d43c44-0b32-47ac-85c1-a05682078f22",
      "event_cluster_id": "b32443a3-fa40-4637-9b55-e58ec8393ffe"
    },
    {
      "claim_cluster_id": "40db941d-31ac-4f8f-a268-d60a6c9bd055",
      "event_cluster_id": "94d152a0-b275-42d2-af1e-de4ffe6f8a22"
    },
    {
      "claim_cluster_id": "8f381ec8-c658-466c-973c-6cace2609d01",
      "event_cluster_id": "621f1c2a-981d-47da-bf43-de2d73f4a594"
    },
    {
      "claim_cluster_id": "de4bbbfe-ba23-4e75-bdd5-72e767837661",
      "event_cluster_id": "fb3fc0aa-b013-4537-9abd-dcd64258a72b"
    },
    {
      "claim_cluster_id": "9f57df89-5e8e-4a14-b028-a41d27973fb5",
      "event_cluster_id": "1755b95e-bb0b-46e8-acd8-b7de1925ed67"
    },
    {
      "claim_cluster_id": "39f6fc8d-27a2-4261-870e-362c0315c46f",
      "event_cluster_id": "6d9d5966-6987-45bd-9e4b-02623878d470"
    },
    {
      "claim_cluster_id": "f9e580f2-a45e-455c-a4fc-189d643f07ef",
      "event_cluster_id": "4c34b512-0945-4457-90fe-e5531faf594d"
    },
    {
      "claim_cluster_id": "ccf91c48-303e-4d94-8263-0e8c6de64e17",
      "event_cluster_id": "a7fc7029-8fcf-4676-9e1a-d0be462bdd41"
    },
    {
      "claim_cluster_id": "9fc7f408-c42c-485e-91c2-a72960ff3158",
      "event_cluster_id": "5fee0957-a733-4e61-bf4b-0025d615e97b"
    },
    {
      "claim_cluster_id": "017c8345-ee2f-4b6f-8701-6def5bbd5082",
      "event_cluster_id": "b250fbe4-52ac-446e-8f1f-52af6aaeb77c"
    },
    {
      "claim_cluster_id": "487393b6-56b8-4c3f-bdb3-88dbd2ac69d5",
      "event_cluster_id": "a808e761-ea60-4cbe-9954-1bbb279e628e"
    },
    {
      "claim_cluster_id": "88b5488c-d8fa-4baf-af94-ea104e983a2a",
      "event_cluster_id": "04e4f581-e2f4-41e4-90d7-172e50ff3c74"
    },
    {
      "claim_cluster_id": "2fc0be9d-df8b-440d-a58e-2ec4422f1712",
      "event_cluster_id": "975e2d06-2cf2-4b51-9705-f9ba57cf3e1e"
    },
    {
      "claim_cluster_id": "e455cd44-cd3c-4e6c-a847-ff250278123c",
      "event_cluster_id": "1acc8146-9053-485f-9f26-6af5d30d0040"
    },
    {
      "claim_cluster_id": "73ed8dfb-71b9-42f0-9f45-a873045bd275",
      "event_cluster_id": "09a67b60-49c6-4757-b8ff-5613fc63f6fe"
    },
    {
      "claim_cluster_id": "a9f88531-6abb-40c2-bba6-de053eb80cb0",
      "event_cluster_id": "fd9d96be-26f0-47fc-a5ef-aa9e5e5ddf13"
    },
    {
      "claim_cluster_id": "73aeb014-9fc7-4042-b2b1-7016c4fa8dd2",
      "event_cluster_id": "6659a589-3901-4e01-8d7f-eb3e9f204a10"
    },
    {
      "claim_cluster_id": "8ff59597-495c-4ba5-b797-afb88f6bfce0",
      "event_cluster_id": "b3940e35-7d56-462c-b357-ee3bc8987319"
    },
    {
      "claim_cluster_id": "9ef27775-8065-4722-bd90-8a9ae4a3c250",
      "event_cluster_id": "7a87a2e6-b475-458d-ad14-3c21326625db"
    },
    {
      "claim_cluster_id": "0605c233-63ed-4bdf-a0fe-665556a34a75",
      "event_cluster_id": "ce593693-b91d-49af-acbe-d62e8f2dfd88"
    },
    {
      "claim_cluster_id": "d93d391c-6b51-4713-bfdb-30f405cd2357",
      "event_cluster_id": "a0f403d2-a7ff-4e00-84e6-2783bef20b8e"
    },
    {
      "claim_cluster_id": "5a6c75cb-74c4-45e2-b8d3-dd1dbdb1dae1",
      "event_cluster_id": "5b07fdf4-9b41-49e1-b97c-866f63e0da14"
    },
    {
      "claim_cluster_id": "c7c24801-e07d-4e78-8de0-4a42e8b64272",
      "event_cluster_id": "1754af66-54e2-4f11-bdb1-7f116f325d12"
    },
    {
      "claim_cluster_id": "b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4",
      "event_cluster_id": "7c24e460-dec0-43da-b3ab-9acc84d4caeb"
    },
    {
      "claim_cluster_id": "e1ed1afc-85b6-4c69-a063-e486d1e3670f",
      "event_cluster_id": "908547be-87be-4e95-b368-a0acc7033e35"
    },
    {
      "claim_cluster_id": "7b83d3ee-13b2-47c1-ab89-4f78258a986b",
      "event_cluster_id": "976b0673-ef25-484d-9be8-afb6c791a214"
    },
    {
      "claim_cluster_id": "12efff4b-e0b1-447e-aeb7-828004c5cfde",
      "event_cluster_id": "83859ac4-ebe8-4ffc-91d6-38d67b7686ab"
    },
    {
      "claim_cluster_id": "35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60",
      "event_cluster_id": "963c86c9-b5f1-4cd9-ac43-10cc5c0f5aa1"
    },
    {
      "claim_cluster_id": "c0414ded-b694-4e4a-b7f8-d2835618be1b",
      "event_cluster_id": "1f13dc99-3c84-426e-b6fa-781deb8b786d"
    },
    {
      "claim_cluster_id": "95b38f6d-19e7-4fa7-a9de-ee665de84018",
      "event_cluster_id": "ceaf3416-5958-472f-8b27-d2e81ab1489c"
    },
    {
      "claim_cluster_id": "d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9",
      "event_cluster_id": "4941aadf-8564-4b71-b807-8b98a3bc3396"
    },
    {
      "claim_cluster_id": "aa458090-4ea3-4829-9f88-662eb71a8370",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "91ed355a-9103-4819-9a78-2425f91b042a",
      "event_cluster_id": "c60d6252-d9ce-42b9-bf38-6fcee80b74b2"
    },
    {
      "claim_cluster_id": "5b7e1f2c-86a3-4e27-9c3e-c974a8d33606",
      "event_cluster_id": "56a7af82-50cb-4d0f-a5ea-28ea4cda014a"
    },
    {
      "claim_cluster_id": "5d276603-9c3a-417d-bd11-e8b613249dd5",
      "event_cluster_id": "c19838ee-ef85-408d-84a0-c28811354698"
    },
    {
      "claim_cluster_id": "76ba9e0c-8b5a-4b06-92f8-9ce9caa47714",
      "event_cluster_id": "743f75a0-41d3-441e-9941-3043106cc340"
    },
    {
      "claim_cluster_id": "95690f3e-4515-4810-858c-28b7d1da49a5",
      "event_cluster_id": "41d3a2f3-d7a3-4115-95f4-0cf0a84449a0"
    },
    {
      "claim_cluster_id": "ed50b251-f205-4952-987b-aed1c0461840",
      "event_cluster_id": "ebf11375-1fd2-4e33-a82e-1889d6d8f85a"
    },
    {
      "claim_cluster_id": "59f595d5-6ff2-4686-81ce-6150bd29db9d",
      "event_cluster_id": "c0ac6691-abf2-4873-a338-41a4997bcb24"
    },
    {
      "claim_cluster_id": "ccd217d6-af54-4ddb-bc5c-7413749df148",
      "event_cluster_id": "52dfdf47-104c-4ec5-bdb3-4d6a07a83d5c"
    },
    {
      "claim_cluster_id": "25d9faf4-4231-47e1-9e78-17114da0186c",
      "event_cluster_id": "a04d6dcd-d345-4928-a6be-52f446062bc1"
    },
    {
      "claim_cluster_id": "ebf0120f-ec3a-4a71-bd2b-88f212264387",
      "event_cluster_id": "7dae31f7-fc93-4b4e-bd3c-7a87267ee2bd"
    },
    {
      "claim_cluster_id": "da1326c3-fa76-400d-b44c-881f6493a085",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "b3cc2793-d201-47e1-8b0f-b8bc6fd1bbe4",
      "event_cluster_id": "b7f11387-382d-4aee-bfa5-1f8b22da06c2"
    },
    {
      "claim_cluster_id": "88b5488c-d8fa-4baf-af94-ea104e983a2a",
      "event_cluster_id": "5e11f88d-24a6-418c-854d-c6d0fb898c80"
    },
    {
      "claim_cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "c0414ded-b694-4e4a-b7f8-d2835618be1b",
      "event_cluster_id": "0621c61e-ad6e-41cd-8ff0-a60a7aa48a28"
    },
    {
      "claim_cluster_id": "7e979f93-4ad2-4933-833d-edddb9f37e0b",
      "event_cluster_id": "9add2c84-55b8-4f75-bec3-d9a47e379ce8"
    },
    {
      "claim_cluster_id": "dde1cfea-875f-4bd7-a73a-639065b04c0c",
      "event_cluster_id": "da41eb4a-56e1-401f-8c36-73d853bb3de7"
    },
    {
      "claim_cluster_id": "f597184d-050f-4a51-9461-70b55cf2b05c",
      "event_cluster_id": "c2e5bef0-900b-4168-ac2b-5a5465221f87"
    },
    {
      "claim_cluster_id": "9ba4f992-6e11-40b2-8501-4e04321822e6",
      "event_cluster_id": "4f77ad08-1df2-43ea-b042-db804953dbcf"
    },
    {
      "claim_cluster_id": "2846d44d-8ccd-40e0-8486-7b360ffa4608",
      "event_cluster_id": "ba69550c-4232-407b-a518-7595f5dc57c8"
    },
    {
      "claim_cluster_id": "68357dc5-3396-4365-90bb-f3b36dcbd7e4",
      "event_cluster_id": "791db8c8-66c8-425a-80e1-d5e8778fe4a4"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "92ec2cbf-b9b0-4664-a8a7-ef9ea075d88c"
    },
    {
      "claim_cluster_id": "a9f88531-6abb-40c2-bba6-de053eb80cb0",
      "event_cluster_id": "f3191f0a-3803-4bca-ad51-304e3f825638"
    },
    {
      "claim_cluster_id": "b471f42f-4da7-4b5a-a11e-18deef221da8",
      "event_cluster_id": "6220afcf-2f7d-4d0b-9949-c9eea0785c4f"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee"
    },
    {
      "claim_cluster_id": "70898fa9-9960-49d5-b422-3f77d073d86b",
      "event_cluster_id": "8451ff8b-752e-4535-872c-ebc9efc7b9cd"
    },
    {
      "claim_cluster_id": "b58aa973-7c2a-4a42-ac89-2aa7abeea2e5",
      "event_cluster_id": "f44a9570-1523-4d3e-9b69-1e328e9b2946"
    },
    {
      "claim_cluster_id": "4a3bc772-20e9-4711-acc4-eb16f1a71bea",
      "event_cluster_id": "1dd3a1e1-df59-4ade-b082-02235345034a"
    },
    {
      "claim_cluster_id": "59d7630c-86a6-4185-b052-67ad13c627a8",
      "event_cluster_id": "7c8be876-c0d6-46b2-8e28-be16ba79de4f"
    },
    {
      "claim_cluster_id": "12c3a33b-fd70-46a3-a74c-86b922244369",
      "event_cluster_id": "f86db310-987e-41a6-a2fc-6f6bb14b7072"
    },
    {
      "claim_cluster_id": "5c0df4bf-ba62-40d1-a306-8313dfe790e6",
      "event_cluster_id": "1dfcd0b1-4fc7-4be1-9e3b-b39ce16325cb"
    },
    {
      "claim_cluster_id": "d00bd384-4d89-4a56-8487-c419c52438e5",
      "event_cluster_id": "a5da6c97-e954-417b-b043-c6eda504cf34"
    },
    {
      "claim_cluster_id": "f9e580f2-a45e-455c-a4fc-189d643f07ef",
      "event_cluster_id": "e113cbe4-9797-46e8-ab87-8e31da3f22de"
    },
    {
      "claim_cluster_id": "9ca308d7-59f5-4df0-a87b-383b8575c88a",
      "event_cluster_id": "41c769d8-9945-446f-ae71-144928242d0e"
    },
    {
      "claim_cluster_id": "96a4146b-b919-413a-b5a7-7801adae1906",
      "event_cluster_id": "61f48759-d4cb-40cb-8dc9-13b564dd8c1b"
    },
    {
      "claim_cluster_id": "6cade303-8a3e-4226-b5e8-0d3b189187cb",
      "event_cluster_id": "67731679-09bb-4b58-92bb-6990e6c5fa20"
    },
    {
      "claim_cluster_id": "51f92102-4c83-4bf3-8e2d-cf88f9368a7f",
      "event_cluster_id": "0e12a592-3820-4db2-a037-30590707df57"
    },
    {
      "claim_cluster_id": "71755eb8-e7df-4bfc-b448-f56fe2b8b242",
      "event_cluster_id": "cc9b53cb-83c0-4db5-a0d0-5708d4af2a1e"
    },
    {
      "claim_cluster_id": "17036568-8b0d-4108-9a16-98a16980ae3f",
      "event_cluster_id": "7c8877ae-f397-490e-9778-67a6e91ebe1c"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "64c8d619-fdbf-4e87-a23c-9bfa4369bc15"
    },
    {
      "claim_cluster_id": "dfe5555f-7179-45b9-9f7a-919fa1cc1569",
      "event_cluster_id": "b627252e-5ed6-4562-833d-dbc3b3ef2c2f"
    },
    {
      "claim_cluster_id": "5c0df4bf-ba62-40d1-a306-8313dfe790e6",
      "event_cluster_id": "c75b3de8-57fe-4dc6-8aeb-f6022f783cc3"
    },
    {
      "claim_cluster_id": "8e7a25f4-c25d-43c4-890a-4d8d8364c5bf",
      "event_cluster_id": "dcc8df2e-a077-47fc-8960-d90fac2ea1d8"
    },
    {
      "claim_cluster_id": "40a361aa-d57e-4e3c-9740-34505f34913c",
      "event_cluster_id": "f49b5f7f-d1d1-43b6-ba5c-a712f59a657a"
    },
    {
      "claim_cluster_id": "542e81d5-bf51-451b-bb6a-204f6c8da58e",
      "event_cluster_id": "4f70ac27-41cb-48d8-871e-5b61b1c5a657"
    },
    {
      "claim_cluster_id": "19d43c44-0b32-47ac-85c1-a05682078f22",
      "event_cluster_id": "efe98b1b-e1ed-468a-9652-7acc5550430a"
    },
    {
      "claim_cluster_id": "6019fc4d-e3c3-4367-8970-ef89e2860014",
      "event_cluster_id": "95421986-cc6a-44ab-acd6-4d39bccc24ca"
    },
    {
      "claim_cluster_id": "6f7b1c88-304f-4cf4-ba94-d6268fa5ae40",
      "event_cluster_id": "47332eaf-fc3b-42ad-bec7-2e81a4ab08e7"
    },
    {
      "claim_cluster_id": "6ac8924b-24d0-446a-8ffc-cf862b415737",
      "event_cluster_id": "fd30a023-a95b-44f7-ae05-f93dd9a3dd06"
    },
    {
      "claim_cluster_id": "baef4ffa-45e6-4649-9ab7-8c1b3621d2d6",
      "event_cluster_id": "23adce5a-77c2-4c07-98b6-ac6909360e17"
    },
    {
      "claim_cluster_id": "b44cd59b-4971-4182-8766-9ffcf4ae83ce",
      "event_cluster_id": "ab906a52-8ac1-4094-852d-28e22d75048c"
    },
    {
      "claim_cluster_id": "a2a57731-90ff-4a12-a08f-721a9dfc0b06",
      "event_cluster_id": "85060527-feb7-4312-ad1a-ebd52c170e8b"
    },
    {
      "claim_cluster_id": "80ee7cf5-20b3-4f27-9dd1-9ddac8a8c921",
      "event_cluster_id": "c44f1953-a41f-47e0-ba2d-7e2e1a5e8ffd"
    },
    {
      "claim_cluster_id": "4f0d57c0-3de2-45f7-85a5-01cd50cac457",
      "event_cluster_id": "20bc1b1d-621a-4c85-b194-0b79b56d7c82"
    },
    {
      "claim_cluster_id": "585ea825-312e-47cf-9ba6-332afbfb9ed5",
      "event_cluster_id": "c4b95ac5-8bd7-40cd-a7c2-2a05463c8dc3"
    },
    {
      "claim_cluster_id": "a92d1a1e-f967-4044-9d5c-136fd4264137",
      "event_cluster_id": "baac9deb-4b05-423b-be76-a9a8e41c6cea"
    },
    {
      "claim_cluster_id": "5dac5b6d-e9df-41db-9225-7e413ca3cacb",
      "event_cluster_id": "46d65520-43a8-4278-8ef5-8956356cec61"
    },
    {
      "claim_cluster_id": "17224e3f-1dd8-4970-a1c1-0cff20d6f438",
      "event_cluster_id": "c2e5bef0-900b-4168-ac2b-5a5465221f87"
    },
    {
      "claim_cluster_id": "84a0c048-8b19-4f73-b588-caa191d08d54",
      "event_cluster_id": "a327718c-a538-4929-8a9a-932fc2ef4a9a"
    },
    {
      "claim_cluster_id": "31bf6722-ac5c-4597-8c42-50efe5c5aceb",
      "event_cluster_id": "6d28f7f0-c971-4fc7-ba26-4c3da49fc8c8"
    },
    {
      "claim_cluster_id": "dfe5555f-7179-45b9-9f7a-919fa1cc1569",
      "event_cluster_id": "91237aa3-bf57-4535-84ed-6b39c0f1b3fc"
    },
    {
      "claim_cluster_id": "b213b3ba-db75-4c42-89bd-97de55c18b3e",
      "event_cluster_id": "ab894abd-2889-40e1-91c4-3fbdf2be7626"
    },
    {
      "claim_cluster_id": "009e9d6b-ab96-416d-b96e-b7eaada086cf",
      "event_cluster_id": "f996f072-3b37-4e7f-900c-1cc05e40fa72"
    },
    {
      "claim_cluster_id": "16e38b6b-7241-4f9f-8554-c33f05a6edb7",
      "event_cluster_id": "55bf2e02-8b8e-4a6c-b132-fd70d3faa280"
    },
    {
      "claim_cluster_id": "253e2fef-8100-4235-899c-96e9877535d1",
      "event_cluster_id": "632f52ad-dbbd-4d7f-af13-93bbeaa37163"
    },
    {
      "claim_cluster_id": "7b83d3ee-13b2-47c1-ab89-4f78258a986b",
      "event_cluster_id": "a41257e1-1e51-49b3-bf04-5fbb3ef2f25b"
    },
    {
      "claim_cluster_id": "5c533a3e-46e0-4800-bdb7-5c1521efbb3d",
      "event_cluster_id": "f2c3cbb3-1d32-4569-9d6e-97148e1d73ef"
    },
    {
      "claim_cluster_id": "970c1f51-0eea-45a8-842e-874c83ffa389",
      "event_cluster_id": "6d2a3a04-ff69-40ca-9d0c-a4d79e8318bd"
    },
    {
      "claim_cluster_id": "3579f3e6-5ab6-488d-a555-602383a4e3bf",
      "event_cluster_id": "84d8eefe-324c-44a5-b6d1-c374c46cc323"
    },
    {
      "claim_cluster_id": "7e4a12f6-fe24-48f6-993c-d7197eb9c44e",
      "event_cluster_id": "0a39d2f3-be07-4455-859e-2055e083eec6"
    },
    {
      "claim_cluster_id": "3c1f9759-2361-48c2-bc4a-c58a3d11b76f",
      "event_cluster_id": "58f3dc82-7967-4488-b9f2-9a804334fb7a"
    },
    {
      "claim_cluster_id": "d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9",
      "event_cluster_id": "465bda3c-33ed-4e06-86ec-cc6c1d50e27d"
    },
    {
      "claim_cluster_id": "d7623a03-cd91-4c2e-b68a-db4e5ad54fa8",
      "event_cluster_id": "ceb2f368-5934-45f6-bda4-01a19f923b7e"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "53d674a1-75eb-4a57-96a7-960a78dc2faf"
    },
    {
      "claim_cluster_id": "1e13a15e-d3c1-4581-b460-13b01ca9aa54",
      "event_cluster_id": "7c8be876-c0d6-46b2-8e28-be16ba79de4f"
    },
    {
      "claim_cluster_id": "bd9462e2-36b0-48f7-92f9-c83dd2ee5550",
      "event_cluster_id": "edcb6d77-94bd-47fa-ac30-bd310a6e83e6"
    },
    {
      "claim_cluster_id": "791c0550-4877-4364-97d4-01b5b8435b0f",
      "event_cluster_id": "afb76d5a-b98d-4292-ba1f-8d4ecc4a368a"
    },
    {
      "claim_cluster_id": "58c4dc89-fa0e-45c9-8892-01fb55da5607",
      "event_cluster_id": "d0699d4c-25e1-439a-a44a-9bca30bebb35"
    },
    {
      "claim_cluster_id": "481f70cc-e9a5-439c-8065-a4dc8e63bd0b",
      "event_cluster_id": "e9e815cd-7183-4b06-a964-9cfc2d25bfab"
    },
    {
      "claim_cluster_id": "6663d8fb-8d11-459b-85ff-7054f5d07b06",
      "event_cluster_id": "e113cbe4-9797-46e8-ab87-8e31da3f22de"
    },
    {
      "claim_cluster_id": "b471f42f-4da7-4b5a-a11e-18deef221da8",
      "event_cluster_id": "e30d449c-eb81-4d62-9149-9437a1a2c593"
    },
    {
      "claim_cluster_id": "0ea60366-ef97-44ac-91be-b38d55efb0c3",
      "event_cluster_id": "7690b51f-82d1-4577-be9d-58b4d7bf11b2"
    },
    {
      "claim_cluster_id": "0a27f80b-b648-4764-8688-fd889dc32a39",
      "event_cluster_id": "07db44cf-3ab0-45c7-b71b-6366e225a76c"
    },
    {
      "claim_cluster_id": "a63004c7-9e1f-4600-bae4-f70655f0094e",
      "event_cluster_id": "1961443c-3bca-4540-a19e-508d4a0fa916"
    },
    {
      "claim_cluster_id": "7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1",
      "event_cluster_id": "3c077d24-2d6b-4d5c-a441-5e0080a81669"
    },
    {
      "claim_cluster_id": "ab1f8fac-3632-4188-90ae-a2c911b8425d",
      "event_cluster_id": "cbeb70b1-aecc-4170-98d8-bc70bbb4a2f1"
    },
    {
      "claim_cluster_id": "02c9b472-905f-4c41-8570-811b8d821196",
      "event_cluster_id": "9c08b4e1-94e3-4cf2-b505-4d6b5137534f"
    },
    {
      "claim_cluster_id": "bbf49577-7eda-4f96-83ed-753d3b9cc708",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "18f586c2-7862-4f1e-9fbe-94bf4981c3c4",
      "event_cluster_id": "b8e61f96-24fd-4f99-870f-bc308a6c4198"
    },
    {
      "claim_cluster_id": "7dc48717-c562-4f7c-bcb3-b4a13374cc42",
      "event_cluster_id": "414991c8-a3c9-4951-a5c6-7c03fe71ba09"
    },
    {
      "claim_cluster_id": "fcb57169-c911-45f8-98e1-10aa6c573c38",
      "event_cluster_id": "eb814822-d982-4fcd-a462-4fccf70598c6"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "f0764df3-3340-4405-ac6d-daef15a6934d"
    },
    {
      "claim_cluster_id": "5e7e70f4-b130-467a-9df9-f6078877ed61",
      "event_cluster_id": "4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"
    },
    {
      "claim_cluster_id": "f1afc4d0-4eaa-40ab-99e6-20e11c550ccb",
      "event_cluster_id": "fb3fc0aa-b013-4537-9abd-dcd64258a72b"
    },
    {
      "claim_cluster_id": "e35fb8e9-42cf-4ef0-a512-d7be06ad99e3",
      "event_cluster_id": "f16a1de1-a4da-445c-ac5b-035b9edb7fc3"
    },
    {
      "claim_cluster_id": "6f3f0719-064d-478a-ae5f-d9aca0368d4e",
      "event_cluster_id": "0e248889-43a9-4087-a6b0-f1d7854daf2c"
    },
    {
      "claim_cluster_id": "6a65158f-b873-42cb-b0bd-0cb1b60a0d86",
      "event_cluster_id": "6272f62e-bf00-43bc-ba48-d3f7c9c3ae02"
    },
    {
      "claim_cluster_id": "c155f6c2-50ad-4998-b29d-ef85effa1839",
      "event_cluster_id": "06512aa8-6f14-4dbc-8b0f-4ea2e772ba31"
    },
    {
      "claim_cluster_id": "da4807bf-cc54-48c7-b3ca-69cd854da837",
      "event_cluster_id": "dec5b760-e9f3-4528-b5d8-c2638f4598ab"
    },
    {
      "claim_cluster_id": "14b46c0a-7b16-4722-b599-90d7d69970a1",
      "event_cluster_id": "d7761b4c-72e0-44cd-b341-d16d8d7d63d7"
    },
    {
      "claim_cluster_id": "947a0b8b-01e0-44c9-8ebc-c9da3eecde20",
      "event_cluster_id": "cba3863d-9ffc-4647-831b-d4da84c689e3"
    },
    {
      "claim_cluster_id": "2f3c2293-d820-4cb3-836f-6df8faee07a8",
      "event_cluster_id": "3dfdc081-40e4-4a34-81ac-79b539cfc98e"
    },
    {
      "claim_cluster_id": "8610b5a0-f4b4-403e-94e5-57543da5eb32",
      "event_cluster_id": "6f48a68c-7726-4316-a5e6-f406ee7e1e95"
    },
    {
      "claim_cluster_id": "35ee8064-f9ff-4496-b4db-ba79f7f24de2",
      "event_cluster_id": "2bacbc25-5943-4519-8b3a-2027cce6b51b"
    },
    {
      "claim_cluster_id": "f4638fa7-3292-4d44-b3f1-771aa65146b0",
      "event_cluster_id": "63114462-4942-4f84-9437-7c2bd611b2f3"
    },
    {
      "claim_cluster_id": "cb25f623-bfdb-42c7-9873-fa48f80feade",
      "event_cluster_id": "9766dff3-64a6-4901-a68a-2702c328c3ac"
    },
    {
      "claim_cluster_id": "43b3601d-6d6e-43a4-8cdc-72cf4aa80640",
      "event_cluster_id": "1a1de2a4-159f-4a0d-8a46-97165bf27583"
    },
    {
      "claim_cluster_id": "b693d408-b0fd-49d2-8eea-39016ff5fda7",
      "event_cluster_id": "07a40f3e-ce43-455d-8cb0-e9110e244817"
    },
    {
      "claim_cluster_id": "1a968bfe-5bc1-4f49-8a3c-fc2e0fdbf254",
      "event_cluster_id": "0c50a72f-e964-4690-a33f-e878b2e74702"
    },
    {
      "claim_cluster_id": "90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410",
      "event_cluster_id": "bcc8a49a-201a-439b-bf04-a72b13e50b57"
    },
    {
      "claim_cluster_id": "a9f88531-6abb-40c2-bba6-de053eb80cb0",
      "event_cluster_id": "f7dce48b-908d-410d-ae3b-0711d8dd8a49"
    },
    {
      "claim_cluster_id": "237a5318-2edd-4ffc-869f-c0fed9502097",
      "event_cluster_id": "dffdac1b-ba6f-48b2-97f4-02cb8656a37e"
    },
    {
      "claim_cluster_id": "44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b",
      "event_cluster_id": "af07ce28-0024-41ac-b51c-01e4bbf2c507"
    },
    {
      "claim_cluster_id": "bdc594bb-6aa7-4421-82b8-b7df34a7c93e",
      "event_cluster_id": "d2b6a98f-1634-4f3b-a41d-9b64375eff6e"
    },
    {
      "claim_cluster_id": "41683dea-1259-4e44-9283-e6286d675c48",
      "event_cluster_id": "2dda2c1f-f0ae-49cc-b0e1-89a7a1ccbeaf"
    },
    {
      "claim_cluster_id": "2b3c747b-9f75-4697-a22b-426999d9c671",
      "event_cluster_id": "12d14e7e-4e0e-4f5f-8c1e-b4a56335bf02"
    },
    {
      "claim_cluster_id": "dcbf5711-b1d2-4a7c-96f6-e8916f52c752",
      "event_cluster_id": "02063354-1cf2-4e4e-a749-ce91914994ae"
    },
    {
      "claim_cluster_id": "9c9d4ed6-a861-4706-aee3-f148f1769c86",
      "event_cluster_id": "8a222396-efb3-4d74-bc35-db09fb52168f"
    },
    {
      "claim_cluster_id": "3c4b8a98-54ef-4e72-a175-6c00ff85db75",
      "event_cluster_id": "3092d2a7-23cc-41c3-b8bd-3096963a1b79"
    },
    {
      "claim_cluster_id": "09e579b4-c608-4bc3-a02e-890bc6f5969d",
      "event_cluster_id": "0dde3660-e0d6-4644-aa81-6e184dc6e068"
    },
    {
      "claim_cluster_id": "70b49961-b72f-4a9a-bed7-51b09a9f1ec7",
      "event_cluster_id": "1b496ec2-f55a-4ab3-bead-1b1953daed07"
    },
    {
      "claim_cluster_id": "59d689c2-02ce-4e0f-83b7-9747d98bb8fb",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "af26e832-f248-48e8-93f5-fdb54d01a56f",
      "event_cluster_id": "f37c17ce-c0f0-4c37-a425-7857fc4bf5bd"
    },
    {
      "claim_cluster_id": "9dae5050-ee2d-4e3c-8dd3-b9ea85a53752",
      "event_cluster_id": "24f4b8ea-3738-41ba-bfa8-f9286f4d2dc5"
    },
    {
      "claim_cluster_id": "2996196c-7b75-44d2-aa5b-560b18ce2763",
      "event_cluster_id": "56a71fc3-1754-4e95-b0fd-27485ee352e9"
    },
    {
      "claim_cluster_id": "e632bc78-90b4-46bf-a31b-df8259ac6d90",
      "event_cluster_id": "a174fdfb-5e90-4340-85c5-f1498bd04f82"
    },
    {
      "claim_cluster_id": "637d133e-6c19-4fa2-b174-de1d016bd9bc",
      "event_cluster_id": "7a87a2e6-b475-458d-ad14-3c21326625db"
    },
    {
      "claim_cluster_id": "09f8ca5f-e359-4e32-b6bf-f706de588232",
      "event_cluster_id": "b73efc0f-5d42-47ce-a8ed-e5aac2d0dd90"
    },
    {
      "claim_cluster_id": "efb94acb-755c-41bd-b1f3-cb170deb0266",
      "event_cluster_id": "57759056-0fd7-4dee-8b4f-b560736eb4f0"
    },
    {
      "claim_cluster_id": "06af9b74-e018-4919-8256-29acfecc76d7",
      "event_cluster_id": "14b94d56-73bd-4f9f-9a3d-89c9827b210d"
    },
    {
      "claim_cluster_id": "dfd9bb6d-a08b-428d-8e19-e9eebd219088",
      "event_cluster_id": "df416ca2-a7ac-4dad-9783-c3e29d3f4084"
    },
    {
      "claim_cluster_id": "666eb0cd-c596-43b7-a4bb-b7f35efd20da",
      "event_cluster_id": "54ebfb05-46bf-4d56-ade3-1d656b85cfb2"
    },
    {
      "claim_cluster_id": "30011e47-1ff9-409e-8099-2eff6ab89e88",
      "event_cluster_id": "0b6f158d-8877-48ca-80e8-7a4602b55765"
    },
    {
      "claim_cluster_id": "803c450b-2260-49a5-af48-6296f17fca97",
      "event_cluster_id": "49e46347-a3d3-4b80-a516-3dc4bfcbd3b7"
    },
    {
      "claim_cluster_id": "30f8d995-4c8b-4d55-9cc0-91236f828d24",
      "event_cluster_id": "30d502a9-a0ce-4646-9e1c-b03b47f8dd5b"
    },
    {
      "claim_cluster_id": "9621dd39-ccb5-4e12-9287-8a404c57bba0",
      "event_cluster_id": "5af9294b-b226-4926-b1d8-cd8badc5e35b"
    },
    {
      "claim_cluster_id": "a74a2d72-1d86-4264-9389-b4fe594a7218",
      "event_cluster_id": "45aa87a3-e21a-4aa8-8a63-439b67ce1a6b"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "7afd3ded-a43a-4c9d-b365-6656ecd89e6f",
      "event_cluster_id": "f7be2595-331e-49c2-b3a3-087ec837250b"
    },
    {
      "claim_cluster_id": "335213da-43c0-415b-b902-6fbd946881b7",
      "event_cluster_id": "03d03c63-2946-42c4-9a55-b127fdc45b21"
    },
    {
      "claim_cluster_id": "de116a88-705c-434f-9f3a-1fdabb457723",
      "event_cluster_id": "0a78e568-4aaf-4a3c-a4c0-d484ec60f776"
    },
    {
      "claim_cluster_id": "596489a9-6207-48fb-8cf4-2972a01326d9",
      "event_cluster_id": "8498dac7-1f62-4d7f-a27c-61f5ecb321c3"
    },
    {
      "claim_cluster_id": "e9caf6d9-2282-4c7e-9cd5-97529119edff",
      "event_cluster_id": "ff3032ee-a77e-4fe7-a5a1-205c35f0948e"
    },
    {
      "claim_cluster_id": "e5b48b2a-7f34-4409-a282-031c21d5b9f9",
      "event_cluster_id": "8059d799-8a2c-4df4-b587-415d278d1563"
    },
    {
      "claim_cluster_id": "9cc8f400-4462-4501-9bf3-f6cf35f7a110",
      "event_cluster_id": "6658a062-982d-4300-bd7b-0596611a3512"
    },
    {
      "claim_cluster_id": "a7d034a7-5705-462b-af06-b9277d91c75a",
      "event_cluster_id": "920bd1eb-f625-4f7e-981d-fa931240bd9e"
    },
    {
      "claim_cluster_id": "51f92102-4c83-4bf3-8e2d-cf88f9368a7f",
      "event_cluster_id": "4823b0d5-067d-49e8-9415-62a09183548f"
    },
    {
      "claim_cluster_id": "fc93709e-88fa-4e26-963a-2d3fcd9cde24",
      "event_cluster_id": "2760cb6d-72ed-43f8-94f6-443f59d74437"
    },
    {
      "claim_cluster_id": "b3dddca5-c2cb-4bb6-a964-c4a7328e5b0d",
      "event_cluster_id": "8628cfa7-1952-4304-94e8-eca8c125fadb"
    },
    {
      "claim_cluster_id": "e8b8352a-472f-4b00-9dae-87cd809f920e",
      "event_cluster_id": "a2a4882d-9cb0-4b1a-8852-37a056ca2ca7"
    },
    {
      "claim_cluster_id": "a3891be3-55f1-4794-b99d-304a26e4b465",
      "event_cluster_id": "72297da3-3cc9-4cb4-a16b-56592581749c"
    },
    {
      "claim_cluster_id": "9254d2c4-775d-4f48-975f-879f17b9f193",
      "event_cluster_id": "b46172e4-32c8-4e9a-a7a9-95ade2786490"
    },
    {
      "claim_cluster_id": "3fd55ffb-10d4-4e70-9352-8bd5b0751ffd",
      "event_cluster_id": "1e3fd423-7c99-4849-95a3-92cb0dc03a82"
    },
    {
      "claim_cluster_id": "29d5756f-2c13-4cfb-b4e4-f439665752b9",
      "event_cluster_id": "820ef425-062e-4d05-87b0-a9e96fa7de31"
    },
    {
      "claim_cluster_id": "f58e8498-102b-4b72-96b4-c6d5b3fb97a9",
      "event_cluster_id": "6ad0010a-5d1b-4773-9ca4-976c212e4238"
    },
    {
      "claim_cluster_id": "5272bbda-d47a-4619-a956-853dc9c29d18",
      "event_cluster_id": "03b5f25b-079d-4d84-920e-062e0a19a251"
    },
    {
      "claim_cluster_id": "539a56ca-1f06-469d-a675-be2a20f5e808",
      "event_cluster_id": "280b825c-cdaa-4737-977a-cbd99f073e0b"
    },
    {
      "claim_cluster_id": "1993c1c6-e677-4697-9e0d-f4c2332e53fe",
      "event_cluster_id": "0786cda2-1538-4e16-9f54-d0704127539a"
    },
    {
      "claim_cluster_id": "80ee7cf5-20b3-4f27-9dd1-9ddac8a8c921",
      "event_cluster_id": "908eb720-8ab4-48f5-a6b7-fd316c77c27a"
    },
    {
      "claim_cluster_id": "e3e4b634-fa33-47d8-9f29-eefdbb263769",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "0f1cacf9-3df0-4d00-8952-b3fa5195f1fb",
      "event_cluster_id": "af509b02-6699-4697-8018-d3a627ada0fd"
    },
    {
      "claim_cluster_id": "6ac8924b-24d0-446a-8ffc-cf862b415737",
      "event_cluster_id": "9e8db3b9-526d-441d-81c7-ae6c80c59a34"
    },
    {
      "claim_cluster_id": "2aeb94af-8d5b-40ce-b754-91495083b2a1",
      "event_cluster_id": "83103bb6-3126-4ae8-b437-2a2305839cc6"
    },
    {
      "claim_cluster_id": "eb646312-9617-4ab9-b534-22cc250a28b0",
      "event_cluster_id": "ec93d3e9-0b7e-4779-b3cc-e888f246dd46"
    },
    {
      "claim_cluster_id": "d669c1ac-c710-4975-98db-1c778f28ee4c",
      "event_cluster_id": "c9760dda-4208-40ee-a4e1-20fd95324ecd"
    },
    {
      "claim_cluster_id": "b473cdd9-7369-4866-a926-04d86eb03c52",
      "event_cluster_id": "54db3169-8794-4675-bba8-d68dda1009e7"
    },
    {
      "claim_cluster_id": "5d2ff6eb-cad6-467b-869b-d4782bae2371",
      "event_cluster_id": "a9a77b18-5285-4973-8fbb-79f6651b38ea"
    },
    {
      "claim_cluster_id": "0bb1f8c0-08c1-4f63-b6c8-052a5bad160c",
      "event_cluster_id": "029ce0da-0ea0-4431-a895-310ff5fa4a56"
    },
    {
      "claim_cluster_id": "f83c19b1-e59e-4712-8a86-4c8c86ee0e2b",
      "event_cluster_id": "4d4b5f03-b89d-479d-93c3-2c3c9a038d46"
    },
    {
      "claim_cluster_id": "5a8284e8-a150-41dc-8ee7-edbc3da33af5",
      "event_cluster_id": "6ff6589f-46b8-4e3d-bfc9-65288f58e33b"
    },
    {
      "claim_cluster_id": "9aca5dda-f273-4941-9e97-91832c08621e",
      "event_cluster_id": "daeaa2d2-9b6b-4a15-baa5-d0940fc45a77"
    },
    {
      "claim_cluster_id": "6f548f26-3ad4-4adb-80dc-c3f3104f0d7f",
      "event_cluster_id": "270b9be6-37c3-4ab7-9763-57943d7a38b9"
    },
    {
      "claim_cluster_id": "df895ffb-5333-4b2a-9ce5-f1108a894c34",
      "event_cluster_id": "03a036cd-d590-425f-afe9-9b90c0baa4ee"
    },
    {
      "claim_cluster_id": "2a0a6106-78d5-46ad-ad52-e0296bf7134a",
      "event_cluster_id": "4cf9c43c-ceb0-4f7f-b2aa-9d4cf2879568"
    },
    {
      "claim_cluster_id": "283a7466-09a4-4b67-abff-ca96f1d8ade9",
      "event_cluster_id": "b8695913-835b-4b14-be2f-fd0c828a71a6"
    },
    {
      "claim_cluster_id": "ed1ca8c0-7841-4109-ada2-99053838abfe",
      "event_cluster_id": "53c8b8a1-19e0-48b3-8c8f-f90de56c4785"
    },
    {
      "claim_cluster_id": "91ed355a-9103-4819-9a78-2425f91b042a",
      "event_cluster_id": "1ce4d643-96d1-4472-9df9-18efdd477875"
    },
    {
      "claim_cluster_id": "11210f68-2915-41ff-b25a-a55a575f9528",
      "event_cluster_id": "f3c363f3-4590-4428-9518-ecaf53bfcf69"
    },
    {
      "claim_cluster_id": "81174c72-fc84-4203-8dcb-b1068c7bd254",
      "event_cluster_id": "88a95916-de94-4c29-849b-89f8018ddf03"
    },
    {
      "claim_cluster_id": "b0c0fbc8-3a87-4290-a45f-69e062e04cee",
      "event_cluster_id": "19360eb5-62d9-45d5-b2f6-b66b7fee7414"
    },
    {
      "claim_cluster_id": "1e256780-a5db-4471-b8f2-5390a4dea1fb",
      "event_cluster_id": "414a7988-da74-41bb-927b-725b66698cd7"
    },
    {
      "claim_cluster_id": "95b38f6d-19e7-4fa7-a9de-ee665de84018",
      "event_cluster_id": "1de0370a-30b3-4cf4-8852-224e559b9061"
    },
    {
      "claim_cluster_id": "731ff8b9-92a5-4277-aa76-33602d261e5e",
      "event_cluster_id": "7db7f2ba-600c-4f51-9a31-321197123c7d"
    },
    {
      "claim_cluster_id": "a1ac0514-0dd2-43ae-9f2d-5939e791e058",
      "event_cluster_id": "b03fae7d-ee9e-4f46-b206-fa4dec1a6c69"
    },
    {
      "claim_cluster_id": "06f782f7-82f3-4b4d-a941-de5952ae3f6b",
      "event_cluster_id": "f26edbd7-0fe4-4992-ad9b-b42b469ca47d"
    },
    {
      "claim_cluster_id": "f9f12741-3c28-4281-83bb-68cf30392853",
      "event_cluster_id": "f067ac83-ba02-48cb-bb4d-1822eee31ec2"
    },
    {
      "claim_cluster_id": "db07f4e5-716a-41e4-989c-98ced62f8fd5",
      "event_cluster_id": "3c9a1b13-b4b6-4090-861e-e35159e61286"
    },
    {
      "claim_cluster_id": "04e64305-3df2-47b4-83e6-266ff2241406",
      "event_cluster_id": "de0d9b6c-1e5a-4ebd-af0a-cb9e36b1417c"
    },
    {
      "claim_cluster_id": "680a1621-579c-4ffb-aa4c-f56de5d6dfe7",
      "event_cluster_id": "a1bd8b84-b3b2-4726-a7b0-fe007bb23321"
    },
    {
      "claim_cluster_id": "69517d67-11aa-4671-bb8a-815c7995a3b7",
      "event_cluster_id": "75b0c0a9-3733-4700-8094-3d9376dffa97"
    },
    {
      "claim_cluster_id": "8bbb9fde-a60f-4687-9398-276e5d036952",
      "event_cluster_id": "b1c829c5-5bbf-4809-a139-ca7f221f5d55"
    },
    {
      "claim_cluster_id": "7b08a98a-0129-4cec-b114-1fff26d56746",
      "event_cluster_id": "a8b81223-8089-44d9-8780-1c910b2a64e2"
    },
    {
      "claim_cluster_id": "f597184d-050f-4a51-9461-70b55cf2b05c",
      "event_cluster_id": "d895f911-9139-47dd-8018-79b66f8588dd"
    },
    {
      "claim_cluster_id": "2cb357c3-3958-45ce-bb44-f76facb84ed9",
      "event_cluster_id": "5d0d552f-6139-4148-bf05-7e9c5a14274a"
    },
    {
      "claim_cluster_id": "17224e3f-1dd8-4970-a1c1-0cff20d6f438",
      "event_cluster_id": "41b103ed-acbb-4350-80df-1fd2deb0346c"
    },
    {
      "claim_cluster_id": "5d2ff6eb-cad6-467b-869b-d4782bae2371",
      "event_cluster_id": "5e785b56-6a28-4603-b028-fed3f12f5778"
    },
    {
      "claim_cluster_id": "d7623a03-cd91-4c2e-b68a-db4e5ad54fa8",
      "event_cluster_id": "2d39c2e2-591e-4b57-a739-0d6203a1a49f"
    },
    {
      "claim_cluster_id": "4f4a8dcc-ad59-4dfb-b222-e025fb0c418e",
      "event_cluster_id": "4b0f28fc-31f1-4217-b54f-8f9b8bb0dd43"
    },
    {
      "claim_cluster_id": "aafb6f56-e150-4de6-8f24-4e8fe467b23f",
      "event_cluster_id": "f71ba398-a895-4de0-a397-50ea9f685ae0"
    },
    {
      "claim_cluster_id": "a6ed0ce8-662a-4b6a-bb37-1ea2a020377f",
      "event_cluster_id": "72084673-8080-44fd-8f5b-97507abf262b"
    },
    {
      "claim_cluster_id": "673d8d19-d059-4065-9b0d-82b1376c6c55",
      "event_cluster_id": "91ce6b29-5884-4f1a-9443-ad0d26809886"
    },
    {
      "claim_cluster_id": "3fd55ffb-10d4-4e70-9352-8bd5b0751ffd",
      "event_cluster_id": "50df15a2-0759-4dd5-ad88-d8f125de1938"
    },
    {
      "claim_cluster_id": "76e2cae3-f195-4448-9b25-588665927aca",
      "event_cluster_id": "f75aca31-160c-495b-9583-b8cf66c2600b"
    },
    {
      "claim_cluster_id": "5ca8fadf-8b8c-4ad1-a5d4-cb44a1752ee9",
      "event_cluster_id": "e9cee2c7-a58e-4a2b-a37b-7da09539aea3"
    },
    {
      "claim_cluster_id": "93c53898-2dc6-423b-a4d6-b61dd90c6d6c",
      "event_cluster_id": "3706e344-49f2-43a5-a708-cb9ca4fbc648"
    },
    {
      "claim_cluster_id": "16e38b6b-7241-4f9f-8554-c33f05a6edb7",
      "event_cluster_id": "4a618a75-71e5-4836-8396-68e00d05b814"
    },
    {
      "claim_cluster_id": "1a660b55-5f53-4246-a227-98df9e4e2ac4",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "990306d6-263b-4984-88f5-4be9fc326334",
      "event_cluster_id": "6e37aa31-587a-4adf-8952-da7c9df371fd"
    },
    {
      "claim_cluster_id": "187eb2a5-5a75-4a22-8ebb-7b83bc1068a8",
      "event_cluster_id": "43836beb-3651-49f1-a0f8-ad3c4daaab70"
    },
    {
      "claim_cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
      "event_cluster_id": "41b103ed-acbb-4350-80df-1fd2deb0346c"
    },
    {
      "claim_cluster_id": "4f28eb95-dbc1-4a88-9ad2-cd53edd38fd5",
      "event_cluster_id": "e0c47150-6ad9-45b1-bceb-7ca3ac1805f1"
    },
    {
      "claim_cluster_id": "095169c0-0ce4-4362-b29d-486ce7d2b848",
      "event_cluster_id": "81215e4f-490f-4619-8a72-2aa513e8e164"
    },
    {
      "claim_cluster_id": "1b257e2e-69fd-4bc5-b57c-e7f5b2178161",
      "event_cluster_id": "31e15131-0797-4dd4-9297-5c40959ea3ba"
    },
    {
      "claim_cluster_id": "199242cb-5b3e-40d9-bf38-e1eddcf574fc",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "199242cb-5b3e-40d9-bf38-e1eddcf574fc",
      "event_cluster_id": "af40ab83-4c48-4ac1-af3a-242491a35af4"
    },
    {
      "claim_cluster_id": "d012c47c-3d49-4f8a-9fcf-db101ff82249",
      "event_cluster_id": "825bdd3b-f63b-4beb-b324-b276b6d235f7"
    },
    {
      "claim_cluster_id": "3356bac0-8ec4-475b-81a7-e146187a74ba",
      "event_cluster_id": "544fb937-88d2-4ddb-9c06-1ae58af8be2b"
    },
    {
      "claim_cluster_id": "dcadf3a6-188b-4a08-881c-e1acb19f186a",
      "event_cluster_id": "6b4e3603-7ed8-4a6d-b270-0425352e67bb"
    },
    {
      "claim_cluster_id": "f3288e7a-a54c-44d1-8307-67aafb47c852",
      "event_cluster_id": "4da30c02-5a8f-4e15-af9d-b0a7ede85a55"
    },
    {
      "claim_cluster_id": "06b8ffc7-c987-44a2-a2cb-8721e54e7da6",
      "event_cluster_id": "b2946046-f947-49a1-8176-588a2c66f974"
    },
    {
      "claim_cluster_id": "9c9d4ed6-a861-4706-aee3-f148f1769c86",
      "event_cluster_id": "7013bebd-c68a-4b31-9e63-8c86c5d8c784"
    },
    {
      "claim_cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "30f8d995-4c8b-4d55-9cc0-91236f828d24",
      "event_cluster_id": "cfcddae8-7e4d-4fb6-8a06-45fdad19422f"
    },
    {
      "claim_cluster_id": "3720666b-a4ac-4b21-9f19-2a86f32551a0",
      "event_cluster_id": "babe889e-ec1c-438e-aff1-7ca2b0c30aa9"
    },
    {
      "claim_cluster_id": "3c4e2f0e-5b8e-45e9-84a7-c71071caeba0",
      "event_cluster_id": "8aa22381-c7a3-4609-b694-2961fd740fc7"
    },
    {
      "claim_cluster_id": "5d8d730b-6674-4d5b-8f99-6c8e240e9080",
      "event_cluster_id": "1ce4d643-96d1-4472-9df9-18efdd477875"
    },
    {
      "claim_cluster_id": "acca2114-d8e0-468a-8116-8a8e6ac23e1b",
      "event_cluster_id": "ecd748e3-d837-4992-8ea5-50edc6e9e5f6"
    },
    {
      "claim_cluster_id": "970cf87e-f96a-4a62-8043-264e8de25eb5",
      "event_cluster_id": "1b1d9a06-de42-4de4-8ba5-73d34f084424"
    },
    {
      "claim_cluster_id": "9723a8c8-8969-4471-bc9d-732ca83fc5b6",
      "event_cluster_id": "7a0376f1-1a7b-4181-a413-d3bc6cd70242"
    },
    {
      "claim_cluster_id": "0c685bcc-0513-4b5c-8ba7-c302c985ff66",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "f1afc4d0-4eaa-40ab-99e6-20e11c550ccb",
      "event_cluster_id": "ccfbe60c-5479-4640-b831-00bbb4cb4ec1"
    },
    {
      "claim_cluster_id": "61784f3e-1c50-4b37-9db4-0fd1ec458127",
      "event_cluster_id": "595a5404-b726-44ba-919a-07c9e6bedb55"
    },
    {
      "claim_cluster_id": "860407b5-0931-4ba2-9dbd-a0078e94e9c6",
      "event_cluster_id": "84f58721-c200-46df-b038-aa93f32b79c6"
    },
    {
      "claim_cluster_id": "d9f4e411-98bf-48bc-a372-2ef5b6cd17d9",
      "event_cluster_id": "5b53e66c-0bb9-49bd-b149-91ceadd51fb9"
    },
    {
      "claim_cluster_id": "b7bef44a-7480-409a-8790-0a70b42045ee",
      "event_cluster_id": "2aafed04-d3d3-4ae0-9825-6d6db215ea71"
    },
    {
      "claim_cluster_id": "6c511b67-edc9-413f-96b2-94d272eb11e9",
      "event_cluster_id": "6f7f68fd-a840-40e2-a600-b19e0677f9c8"
    },
    {
      "claim_cluster_id": "dd658abf-fc5a-4105-b976-357ecd016b6e",
      "event_cluster_id": "1d63f5ab-d2ec-4979-b939-ba16ea5a94d7"
    },
    {
      "claim_cluster_id": "aed74a8c-a339-4a19-a144-bb62990f8e50",
      "event_cluster_id": "d976c975-a582-4fc7-bfd4-75e1c6617efb"
    },
    {
      "claim_cluster_id": "ecf280bd-73fc-4028-90b4-eae0d740ef40",
      "event_cluster_id": "7222826f-77d1-45bf-82db-ad09c33129da"
    },
    {
      "claim_cluster_id": "2105abe4-014b-48d8-a8a2-6e113ac81f52",
      "event_cluster_id": "fd853489-07e0-4489-8d20-abb8f80a4213"
    },
    {
      "claim_cluster_id": "33c9ef05-1d84-4ad3-be17-1fea5c70facc",
      "event_cluster_id": "52a2820c-2844-4d7a-9571-36ea2c51015e"
    },
    {
      "claim_cluster_id": "dfe5555f-7179-45b9-9f7a-919fa1cc1569",
      "event_cluster_id": "85b491d8-b806-4e3f-b616-3cfa5f5fa60f"
    },
    {
      "claim_cluster_id": "f9e580f2-a45e-455c-a4fc-189d643f07ef",
      "event_cluster_id": "67882453-39e8-4614-ad83-1b5cd199486b"
    },
    {
      "claim_cluster_id": "88f4c27e-7029-43e0-805c-44699284d312",
      "event_cluster_id": "2ddd688c-7c02-487e-a8aa-11d74ae8915d"
    },
    {
      "claim_cluster_id": "e632bc78-90b4-46bf-a31b-df8259ac6d90",
      "event_cluster_id": "bc3b9d73-137b-4059-890e-e7cbbf0bd7b2"
    },
    {
      "claim_cluster_id": "565acc40-efdc-4957-85fb-8602f0587aa9",
      "event_cluster_id": "869b1f78-45f1-4c63-bfd1-5c2de5bf6e7f"
    },
    {
      "claim_cluster_id": "54e59784-1db4-41f0-a651-2d5e2138670a",
      "event_cluster_id": "10d03545-859a-4c3f-b85f-14e8f49d3ac5"
    },
    {
      "claim_cluster_id": "97b87ffd-da0c-47fa-86ae-0eedf718bf3e",
      "event_cluster_id": "1b1dc316-6caa-4e05-8920-919dfeb09b67"
    },
    {
      "claim_cluster_id": "4f4a8dcc-ad59-4dfb-b222-e025fb0c418e",
      "event_cluster_id": "11423356-cdd9-4f07-af4c-408d43e6e2c4"
    },
    {
      "claim_cluster_id": "731ff8b9-92a5-4277-aa76-33602d261e5e",
      "event_cluster_id": "bfeab18a-6cab-4e4c-ab1a-32ad52ac07e1"
    },
    {
      "claim_cluster_id": "42139453-8011-41e0-af88-1b45a4865158",
      "event_cluster_id": "5379b888-9bc6-45e3-b445-a1f1b5983b84"
    },
    {
      "claim_cluster_id": "dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e",
      "event_cluster_id": "dd4670c3-7e44-4c76-a7d9-373ad6cb6c50"
    },
    {
      "claim_cluster_id": "23bf4739-72bc-492b-9320-78f2bdc83074",
      "event_cluster_id": "21ef710d-94c3-43ee-b3be-224e0c033195"
    },
    {
      "claim_cluster_id": "33d1d4f9-5c45-44c0-8055-973e47d10907",
      "event_cluster_id": "0947f9bf-7d2a-4b27-95a6-09e765742c84"
    },
    {
      "claim_cluster_id": "59f4b586-ede4-4464-af30-2858db5799e0",
      "event_cluster_id": "689d132a-4055-4564-beb7-4778d700e367"
    },
    {
      "claim_cluster_id": "f58ca21a-7af7-4062-9509-f6480d8a6390",
      "event_cluster_id": "c0ac6691-abf2-4873-a338-41a4997bcb24"
    },
    {
      "claim_cluster_id": "6a4e66c3-1fd2-46be-9e31-fecdcd545826",
      "event_cluster_id": "872f71be-bb1a-40a1-8078-ee9f850ec42d"
    },
    {
      "claim_cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
      "event_cluster_id": "1ccdbc51-34c0-42ae-b81a-03edbb3df6d6"
    },
    {
      "claim_cluster_id": "c8a67d7e-6b5c-49cc-b944-ad699ac9cff0",
      "event_cluster_id": "a22f4cef-ff1f-4c32-aa22-6cedb760ab4f"
    },
    {
      "claim_cluster_id": "6985338a-f2b9-47d5-b9ae-563c0a87748d",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "5d8dea5a-b22d-41be-9ea5-91141c9a7614",
      "event_cluster_id": "447c6034-ca16-41e8-ae39-d9800adee825"
    },
    {
      "claim_cluster_id": "35c8d576-e355-4f4b-802d-1d88de41da0b",
      "event_cluster_id": "8269010c-d30d-4a8f-9628-b930192a8751"
    },
    {
      "claim_cluster_id": "f10deefc-8ed5-4516-8cc2-3ba87195eac0",
      "event_cluster_id": "eeba7376-7fac-451b-96dc-72a9f7c32f92"
    },
    {
      "claim_cluster_id": "13dd3c2f-f547-4b94-b763-665ce078453e",
      "event_cluster_id": "b7375a29-4c73-4062-a85e-7e1c1f79300d"
    },
    {
      "claim_cluster_id": "4acf918c-0778-4ee4-b773-26139df2ea2e",
      "event_cluster_id": "93c79f3e-8eab-4299-bf58-7b2b18493bd8"
    },
    {
      "claim_cluster_id": "dfa47852-ac3f-4b74-bc17-22923a395552",
      "event_cluster_id": "8d1da449-ead9-4d20-b9d7-330964de7727"
    },
    {
      "claim_cluster_id": "d089f75e-69ee-4713-8c0e-27843b110a2a",
      "event_cluster_id": "6d7e8844-23f0-4293-9d61-855d04598239"
    },
    {
      "claim_cluster_id": "04c0a28d-e066-4279-bfee-f4757f197d7a",
      "event_cluster_id": "fedc3a0d-9f9d-4e04-81a3-669b447f0bcb"
    },
    {
      "claim_cluster_id": "82430ac1-c5b1-4777-ac21-a40819c2ad02",
      "event_cluster_id": "4e1f9c12-6559-421b-814d-33b10f78b8a6"
    },
    {
      "claim_cluster_id": "21c7b1a1-7d0b-407c-9669-93e385d68711",
      "event_cluster_id": "5ccc3e3f-7dc2-4f92-90f5-ef2c18f982fb"
    },
    {
      "claim_cluster_id": "7123d027-fb9c-44c1-becb-087b98c76740",
      "event_cluster_id": "4f9d6840-2d0d-40e2-b786-9827419e3e78"
    },
    {
      "claim_cluster_id": "ced45aa6-b370-4a79-b76b-674fcd6c0668",
      "event_cluster_id": "30adcb64-6b84-4937-a83e-146b8ce17e82"
    },
    {
      "claim_cluster_id": "ab9886f5-759f-416b-88de-b9f771cf04e1",
      "event_cluster_id": "0c515019-d4d8-4fdc-91ce-bd3ef7e8e081"
    },
    {
      "claim_cluster_id": "1c5a60ba-15c1-4cc2-b60f-b6a9d3303da1",
      "event_cluster_id": "5450c124-f70b-4739-a4ce-8408866030e3"
    },
    {
      "claim_cluster_id": "3f043499-266e-455f-a558-699fac541c36",
      "event_cluster_id": "d88b95f4-1e38-4dd6-b178-e63adfad4ea7"
    },
    {
      "claim_cluster_id": "553489d8-ac8a-4e20-ab65-673fb4e17c1e",
      "event_cluster_id": "599b237d-3afe-449d-8cd9-becd796f27c7"
    },
    {
      "claim_cluster_id": "afebac7c-8f71-44cd-beec-d242a1b97e86",
      "event_cluster_id": "c981e733-ddfe-483b-a14f-615fd62cec72"
    },
    {
      "claim_cluster_id": "b63983c2-35fa-4152-8cc2-8380b6cbde79",
      "event_cluster_id": "4e53dc9a-0b46-4ddf-8ff5-f5172619e371"
    },
    {
      "claim_cluster_id": "391ac4c5-638b-42bc-b8d7-1972d56df43e",
      "event_cluster_id": "7d6c6e4a-50bd-4afe-bb2e-cfcdaf7a206e"
    },
    {
      "claim_cluster_id": "87e51e32-d441-41a9-8026-a751a57b0ed2",
      "event_cluster_id": "5ec2fd93-7d1f-4121-8e63-fe69b1d0ab98"
    },
    {
      "claim_cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
      "event_cluster_id": "3a13abc2-f39c-460b-8768-7ccf1b11b40f"
    },
    {
      "claim_cluster_id": "c043e411-6d15-46a6-be1e-7a8a943cc43f",
      "event_cluster_id": "0486b789-e813-4404-9c89-b8c77f623251"
    },
    {
      "claim_cluster_id": "796ddc52-9094-4fcb-af10-9fa6a06448ba",
      "event_cluster_id": "80a198cc-8757-4f4b-9e5f-ba483e92361e"
    },
    {
      "claim_cluster_id": "970cf87e-f96a-4a62-8043-264e8de25eb5",
      "event_cluster_id": "df1455dc-0c9e-4e83-b885-6c9b28b69dbc"
    },
    {
      "claim_cluster_id": "48e347cb-8237-47af-9eab-b23191638cd0",
      "event_cluster_id": "eca77987-6ebf-478d-b553-30ae00ed1856"
    },
    {
      "claim_cluster_id": "5284ded1-5c85-415c-af66-ad36ef47b3e7",
      "event_cluster_id": "83df36bd-a3ff-43cc-b6fd-c979f5dfd9da"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "62c5acb9-493e-43c7-9647-7858b2ea0c50"
    },
    {
      "claim_cluster_id": "acca2114-d8e0-468a-8116-8a8e6ac23e1b",
      "event_cluster_id": "85949bd1-40e8-47bc-acf7-cb049a4e425e"
    },
    {
      "claim_cluster_id": "62ddd106-9df1-47e7-9e5a-9c12a19f488c",
      "event_cluster_id": "e7e91720-5f86-4e9b-b765-89e7169207fb"
    },
    {
      "claim_cluster_id": "b58aa973-7c2a-4a42-ac89-2aa7abeea2e5",
      "event_cluster_id": "7f8a206d-56f9-43fd-80ec-c184e678a121"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "81165fd5-dea5-41f8-ac75-66b97e1cca44"
    },
    {
      "claim_cluster_id": "e10dd96b-b6dd-4c6b-baa2-67b6eea4f84a",
      "event_cluster_id": "efe0fef4-f04e-4e85-bb20-f40d0e8f6c06"
    },
    {
      "claim_cluster_id": "260b5cb2-3dad-42a1-a677-cfe24a203765",
      "event_cluster_id": "b25f50a2-6e79-4624-b63a-fcc433c2ee8b"
    },
    {
      "claim_cluster_id": "be4a2385-74e7-4ed5-8c71-c890af870db7",
      "event_cluster_id": "d6713b0d-513a-4166-b2c8-1c6b4cde08b8"
    },
    {
      "claim_cluster_id": "5b7e1f2c-86a3-4e27-9c3e-c974a8d33606",
      "event_cluster_id": "bb551e75-48fa-42c3-a108-cb4b1462b529"
    },
    {
      "claim_cluster_id": "b36a42d8-1bb3-483d-b77f-bd28630b0e30",
      "event_cluster_id": "9f888081-86ee-47a5-ac83-e1aec7d1b080"
    },
    {
      "claim_cluster_id": "125b87a9-62f3-402f-a1ad-6a9130845e80",
      "event_cluster_id": "ff4b91c6-36e8-4903-a2ad-89bb3665e4d5"
    },
    {
      "claim_cluster_id": "15516ad5-b153-4147-8246-ecae0ddbf175",
      "event_cluster_id": "82ba7adb-7963-4264-baad-21315bacde1d"
    },
    {
      "claim_cluster_id": "4767808d-19a9-4e75-b8a7-7421cf37c72f",
      "event_cluster_id": "626e9a9b-6995-4100-8ffb-53ed10359203"
    },
    {
      "claim_cluster_id": "acca2114-d8e0-468a-8116-8a8e6ac23e1b",
      "event_cluster_id": "2f4e138b-a8ca-4c68-be26-24de0c3b0489"
    },
    {
      "claim_cluster_id": "6677095f-eafc-4bbb-8dde-f914b5103e89",
      "event_cluster_id": "45d7d6d0-989e-40f5-9e35-4f603b15d08b"
    },
    {
      "claim_cluster_id": "ab8de566-e0cc-475b-b056-6b27916b484d",
      "event_cluster_id": "35008b59-14cd-4674-801b-6fc7e159bf31"
    },
    {
      "claim_cluster_id": "8c2b4e21-c9ea-4127-9440-e983688f714d",
      "event_cluster_id": "3c66cbc4-f759-4da9-9813-b36b4c322970"
    },
    {
      "claim_cluster_id": "5f5fe60b-6bf8-4f80-be3b-0dcf885c1171",
      "event_cluster_id": "6ea5c303-0018-42cb-9161-d7d2a76673ac"
    },
    {
      "claim_cluster_id": "43784351-864b-42c8-bac5-2de22a3743c2",
      "event_cluster_id": "a1c1162e-c36a-46e0-95af-7c5c08d5e6ff"
    },
    {
      "claim_cluster_id": "d1c29947-a7e4-41cf-9656-837e51b2de11",
      "event_cluster_id": "54d73329-0451-4bab-a86d-4ce16b809e91"
    },
    {
      "claim_cluster_id": "0a3a7c87-61b9-4961-a698-61129e827319",
      "event_cluster_id": "2fe604c5-b4d8-4806-815f-c3f9be0582ed"
    },
    {
      "claim_cluster_id": "144a5089-d891-40d6-b31c-9c5381bee1d5",
      "event_cluster_id": "0795fae9-e716-4cba-98f8-5f27537dcd6b"
    },
    {
      "claim_cluster_id": "2ab59d09-09ca-4583-9e99-8189ce8c9335",
      "event_cluster_id": "635850fb-0b7d-4148-aae4-786dbec7ebb9"
    },
    {
      "claim_cluster_id": "5b28f56e-4dc0-41d8-b963-a4fc04cbaf08",
      "event_cluster_id": "558a2b97-08fd-422a-b638-0c14ba645eaf"
    },
    {
      "claim_cluster_id": "df5cc82a-7ab7-41f6-8eae-c3445a8c7a05",
      "event_cluster_id": "a2e35d24-76f3-4ea6-99d1-6a5176010a02"
    },
    {
      "claim_cluster_id": "585ea825-312e-47cf-9ba6-332afbfb9ed5",
      "event_cluster_id": "888e25a1-a330-4c04-b43d-60fcd67cb2eb"
    },
    {
      "claim_cluster_id": "d7e9e6ed-b598-46a7-b7ea-6197df41d3ad",
      "event_cluster_id": "9103d8ef-aca0-41e2-a089-fa1568b1c90f"
    },
    {
      "claim_cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
      "event_cluster_id": "011aa847-d3e3-4d34-bf5e-378f39ba8a3c"
    },
    {
      "claim_cluster_id": "53a06fbe-813d-46c8-a459-0b312bf0c503",
      "event_cluster_id": "5cee41d6-0e60-41c4-b25d-8f1605700435"
    },
    {
      "claim_cluster_id": "d1f2b2ed-be0f-44a4-a171-4b848f482ca9",
      "event_cluster_id": "0f5915ad-4edd-49f6-8855-92a02e00debd"
    },
    {
      "claim_cluster_id": "8ac7a573-0e67-4913-bd5a-4320d5df2ecd",
      "event_cluster_id": "94fcf1c1-17a1-4318-9032-ad180a9a74cc"
    },
    {
      "claim_cluster_id": "041cf2cd-18d4-495c-8ae7-5b69605020ea",
      "event_cluster_id": "213314ea-c0f8-4a72-832f-5b10a8bbeab5"
    },
    {
      "claim_cluster_id": "20b239ec-b263-4052-a330-5aad8ed1209b",
      "event_cluster_id": "2b8a30d5-2b80-47ce-adf4-0612b97c7289"
    },
    {
      "claim_cluster_id": "b0f153c6-cc18-4aee-9b69-e8f06c8e3149",
      "event_cluster_id": "3a1c123d-a3bb-42e2-911f-77ddeb67d2ee"
    },
    {
      "claim_cluster_id": "3fd55ffb-10d4-4e70-9352-8bd5b0751ffd",
      "event_cluster_id": "c9c64be3-e960-4772-bfe7-2c746234f3c3"
    },
    {
      "claim_cluster_id": "21745bb5-f9bc-46bd-a9de-95338ba8c016",
      "event_cluster_id": "4bf58da8-6849-40b7-a8ec-ddb3570d0f67"
    },
    {
      "claim_cluster_id": "1ba178d9-d925-407c-bb75-60c655774cbf",
      "event_cluster_id": "0dbd4f26-ef42-4c5e-a16b-4529c5e0d566"
    },
    {
      "claim_cluster_id": "7ad2c49a-5636-41a0-bf37-19bfc98916c1",
      "event_cluster_id": "265b7995-86ea-4269-bc72-cf439682655b"
    },
    {
      "claim_cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "event_cluster_id": "da81244a-ef78-429d-9f3d-b08a5c21a084"
    },
    {
      "claim_cluster_id": "a84f79d2-3818-45bb-9cd9-eb739e78bee2",
      "event_cluster_id": "094959dd-ba14-4dbb-83c9-b7363a4aff97"
    },
    {
      "claim_cluster_id": "c076834e-92b4-4b02-8416-1f251021c0cd",
      "event_cluster_id": "53949001-7a01-495c-8cfe-7d81bd307f6f"
    },
    {
      "claim_cluster_id": "6c41ffdc-392b-45d6-b68e-a4cccabb1714",
      "event_cluster_id": "6a38e03b-c385-4edf-9cff-c8c006c566e3"
    },
    {
      "claim_cluster_id": "011b48fb-6ec4-41cc-bd4d-394e371c18cb",
      "event_cluster_id": "0587530d-6a6d-4aa0-9e34-087698c923aa"
    },
    {
      "claim_cluster_id": "b7768432-bcaf-4a4c-9bb2-1a6e02c6a003",
      "event_cluster_id": "44317cdd-77fe-42f4-b1db-9819636d2f58"
    },
    {
      "claim_cluster_id": "99df608a-defa-4cea-b8ef-86519fa0e08a",
      "event_cluster_id": "1ee9efa3-f349-4351-93b7-a5f37a7326be"
    },
    {
      "claim_cluster_id": "1b257e2e-69fd-4bc5-b57c-e7f5b2178161",
      "event_cluster_id": "91a65b39-ae74-4a8d-812e-5ba1c8563d2e"
    },
    {
      "claim_cluster_id": "13dd3c2f-f547-4b94-b763-665ce078453e",
      "event_cluster_id": "b07254f1-f996-464b-a61c-6949e39dcdb5"
    },
    {
      "claim_cluster_id": "e88c49ad-3df2-4059-82e4-46d0f3b59757",
      "event_cluster_id": "075ee2c5-b49b-44c4-9646-461463ce6ff8"
    },
    {
      "claim_cluster_id": "100519ae-c1d6-4f8e-bcef-2f36e907e789",
      "event_cluster_id": "58d169af-1f4c-430e-875d-88f013ef1388"
    },
    {
      "claim_cluster_id": "428d818b-c2cf-41c7-bcd8-3f5cb0b144ef",
      "event_cluster_id": "8a11cb2d-17fc-4106-aa7c-42847d3ac867"
    },
    {
      "claim_cluster_id": "71522ed0-7107-4dfb-8b87-e633332c4e3f",
      "event_cluster_id": "347d7cc9-3711-496c-bdf7-6c0c22b3750a"
    },
    {
      "claim_cluster_id": "af562818-5594-417a-b606-add10573c2db",
      "event_cluster_id": "874c8d94-d252-41b3-bbae-89e33a5eba13"
    },
    {
      "claim_cluster_id": "38146e96-2791-4b11-ad91-87648834294e",
      "event_cluster_id": "0ab67aa0-2db3-4a91-9f5f-2305bd1d90bb"
    },
    {
      "claim_cluster_id": "df5cc82a-7ab7-41f6-8eae-c3445a8c7a05",
      "event_cluster_id": "5b55251a-6617-459a-a1fb-c10dc23dfbc7"
    },
    {
      "claim_cluster_id": "7c3b0d63-9fd5-46b2-943f-8bc9d4005fc6",
      "event_cluster_id": "31416837-c17d-49fc-a841-b231a9f41ff6"
    },
    {
      "claim_cluster_id": "2cf125de-8cd0-4d04-8bbd-f0bf7f8ae187",
      "event_cluster_id": "60679d50-135f-43b4-962e-903dca327357"
    },
    {
      "claim_cluster_id": "947756fe-ff59-4dbf-90dc-9c0bdf20ace0",
      "event_cluster_id": "3f0053e9-5dcd-46d0-a2b7-d6cbd40dc3ff"
    },
    {
      "claim_cluster_id": "8143472f-9ddf-4467-8402-c46a70ccaf1e",
      "event_cluster_id": "c4336836-69fe-4478-ae05-a9b8308b5fd7"
    },
    {
      "claim_cluster_id": "496ba3da-7431-46d2-8b63-afbe79f86c65",
      "event_cluster_id": "b3995a19-7531-42df-8c11-d55b2b796806"
    },
    {
      "claim_cluster_id": "bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75",
      "event_cluster_id": "7a0efb78-9055-433c-904f-79dc94ad2203"
    },
    {
      "claim_cluster_id": "5e7dc7b3-d63c-422e-b9f1-4393a2cdefd4",
      "event_cluster_id": "4e101b24-e99b-4526-bcbc-e5ddeec46f80"
    },
    {
      "claim_cluster_id": "da8da9c4-b0b1-404e-a289-e106bb2bfbb3",
      "event_cluster_id": "7cd85d56-7567-4824-894e-168d86ff8ac7"
    },
    {
      "claim_cluster_id": "6fa7c53c-2f06-41c6-acf2-531da6482f4e",
      "event_cluster_id": "10224329-dea4-42e7-8db6-693c6ba2c28f"
    },
    {
      "claim_cluster_id": "171a2f66-23cb-47e8-a645-32fd4f7a8de7",
      "event_cluster_id": "522766f6-ebcb-4a4a-8452-2b5650a5db3e"
    },
    {
      "claim_cluster_id": "95f30627-ec05-45c4-9f6e-28dd5c31e412",
      "event_cluster_id": "104c0221-a4dc-4285-9360-e1a7135d6b23"
    },
    {
      "claim_cluster_id": "976d7c8a-cb17-41e5-9407-5cd8c141bb84",
      "event_cluster_id": "3871454f-b8ca-4976-ba58-fba8307b403e"
    },
    {
      "claim_cluster_id": "35c8d576-e355-4f4b-802d-1d88de41da0b",
      "event_cluster_id": "46ef864f-186e-4179-bb52-04fed8b2c978"
    },
    {
      "claim_cluster_id": "738e60fd-1e3d-4820-98bf-d6bd9e7a3172",
      "event_cluster_id": "f10864eb-56bf-40a9-9f67-5dfe4ef70806"
    },
    {
      "claim_cluster_id": "3c9c2d2f-29ac-414f-a514-d694db25f871",
      "event_cluster_id": "add8105a-2d0f-4f9d-9f00-f11f0673121c"
    },
    {
      "claim_cluster_id": "b6f111d6-8112-47dc-baeb-43c77c6392ea",
      "event_cluster_id": "7b8193fc-3e2e-459f-9d2c-f5d5c9d7a1b0"
    },
    {
      "claim_cluster_id": "de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe",
      "event_cluster_id": "125a4bc0-e32c-4a8b-80fc-60d23537d495"
    },
    {
      "claim_cluster_id": "e8e14c71-2e64-412a-8769-000c5cda92ce",
      "event_cluster_id": "5afcd855-48b3-4e16-bfa6-1ae369574bba"
    },
    {
      "claim_cluster_id": "dcf5235c-74f7-409c-bb59-9454cc01feed",
      "event_cluster_id": "9babf1db-b81e-42d8-a506-b9ddc52bfb22"
    },
    {
      "claim_cluster_id": "54c46b5a-065c-41a2-90e0-3fac031eb853",
      "event_cluster_id": "532bc570-7cab-4e65-8d14-b6e22f9fc1d9"
    },
    {
      "claim_cluster_id": "868aacb9-ea8e-4ec3-a074-1e7f56bab03f",
      "event_cluster_id": "212b2ba7-fb93-422b-bfc0-bda99de8b498"
    },
    {
      "claim_cluster_id": "3c9c2d2f-29ac-414f-a514-d694db25f871",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "df846784-b644-4d2f-a077-f42db08f73a6",
      "event_cluster_id": "89769c6a-9183-49cc-94f1-4adf24a43953"
    },
    {
      "claim_cluster_id": "3d647896-bc7f-4815-a99e-768cb2498250",
      "event_cluster_id": "4b012ae0-8a3f-4446-8ab7-f0572ce911e0"
    },
    {
      "claim_cluster_id": "88f4c27e-7029-43e0-805c-44699284d312",
      "event_cluster_id": "a9a9b1b1-c494-4c16-84ad-397e74093b98"
    },
    {
      "claim_cluster_id": "a9f88531-6abb-40c2-bba6-de053eb80cb0",
      "event_cluster_id": "c7c8c6d3-cdc9-47d7-8f45-165280d3560a"
    },
    {
      "claim_cluster_id": "80abc80a-d540-4e4d-aa41-272690066eb0",
      "event_cluster_id": "0e839111-b99e-4caa-8ece-e80f0ea67970"
    },
    {
      "claim_cluster_id": "4d4a5a78-bde2-4ed8-943c-811738978e0d",
      "event_cluster_id": "6f7f68fd-a840-40e2-a600-b19e0677f9c8"
    },
    {
      "claim_cluster_id": "492eadfb-99f3-4bc3-a9af-afa12d93eb99",
      "event_cluster_id": "bfcfc457-5e16-4c1c-83da-c1f90a8c2bc4"
    },
    {
      "claim_cluster_id": "41683dea-1259-4e44-9283-e6286d675c48",
      "event_cluster_id": "a7e685cc-6af8-4b3d-9fec-fcb894e900d3"
    },
    {
      "claim_cluster_id": "c7b90480-a4e5-4b5f-b840-fe13ad140b52",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "dea6592f-a2fb-4ea8-b832-4f7df984c163",
      "event_cluster_id": "8985495d-c23b-4b4d-8af8-d412abf8767b"
    },
    {
      "claim_cluster_id": "b54e5664-a40b-4682-b959-bcfb59ddd4b0",
      "event_cluster_id": "4294101c-07cb-4434-a277-aca60564390c"
    },
    {
      "claim_cluster_id": "dcf2ee53-8023-43ee-94fe-0207a7fb5133",
      "event_cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87"
    },
    {
      "claim_cluster_id": "2ea5d498-58e2-44a4-a51a-95bda7047686",
      "event_cluster_id": "e4596864-8ee7-4544-832b-f1063fa0c90c"
    },
    {
      "claim_cluster_id": "0b87672f-54fc-4c20-8d98-e54ab45bc52d",
      "event_cluster_id": "14b94d56-73bd-4f9f-9a3d-89c9827b210d"
    },
    {
      "claim_cluster_id": "41a156b3-5c3d-4d82-b8e4-7ad88953f690",
      "event_cluster_id": "193b523c-c283-41d2-a3f3-b37ed50ae40d"
    },
    {
      "claim_cluster_id": "149c2ce0-2083-4d57-aa68-de8fbf125008",
      "event_cluster_id": "f54fdd0e-ba75-4fde-af1b-64b83311ab6e"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "1c5a43cc-bd0f-4446-9eae-4f39a7691fd3",
      "event_cluster_id": "5d6a4e52-504f-48f8-b46b-8c506a9ab7ad"
    },
    {
      "claim_cluster_id": "37c89569-0090-439b-961a-5b1d66deea87",
      "event_cluster_id": "635850fb-0b7d-4148-aae4-786dbec7ebb9"
    },
    {
      "claim_cluster_id": "7d04ad0f-dee5-48f3-910e-0b2281b15f1e",
      "event_cluster_id": "ac17d012-fb03-4978-afab-d0ee9527705d"
    },
    {
      "claim_cluster_id": "aea747b1-1cb4-4b3d-94df-5c33181b0976",
      "event_cluster_id": "b7c9de19-8b29-40c8-92af-4119566c8604"
    },
    {
      "claim_cluster_id": "06ceeed7-8a02-425d-9be1-3881dcb38762",
      "event_cluster_id": "ac48c971-5c1c-4044-bc6f-2141fc11a1f0"
    },
    {
      "claim_cluster_id": "3c1f9759-2361-48c2-bc4a-c58a3d11b76f",
      "event_cluster_id": "5f26f77b-0214-4097-94f1-7873a36d7969"
    },
    {
      "claim_cluster_id": "ca129396-101c-429f-8530-fe05aaa1c7cf",
      "event_cluster_id": "f44c0680-07c7-4ea0-8054-7643f1b8eafd"
    },
    {
      "claim_cluster_id": "6f548f26-3ad4-4adb-80dc-c3f3104f0d7f",
      "event_cluster_id": "768c2664-8354-4bfc-8b47-96eb4e08e0ee"
    },
    {
      "claim_cluster_id": "ee1d7c5b-4d98-426c-bf43-b5350f89e9dc",
      "event_cluster_id": "341ca13e-66ab-4ded-b14a-e2210febdc82"
    },
    {
      "claim_cluster_id": "45339238-abb3-494b-a7ba-d3cde2ab18d9",
      "event_cluster_id": "3c5a3b02-4d06-4799-a8fe-9f59c0de51d9"
    },
    {
      "claim_cluster_id": "45d5305e-53a9-4659-a1a0-2bf0495c5055",
      "event_cluster_id": "e50f2f1a-20bb-46bb-82c9-6def0deadc19"
    },
    {
      "claim_cluster_id": "4bcae16d-fb51-4ba8-8381-37355e0e9f18",
      "event_cluster_id": "0016bf55-313e-4918-9759-9210715148d1"
    },
    {
      "claim_cluster_id": "06f782f7-82f3-4b4d-a941-de5952ae3f6b",
      "event_cluster_id": "320a3067-75cf-4293-9d53-8dd1f312af23"
    },
    {
      "claim_cluster_id": "95f30627-ec05-45c4-9f6e-28dd5c31e412",
      "event_cluster_id": "67ac99c8-c0bb-4383-9849-47ca12ce4b47"
    },
    {
      "claim_cluster_id": "9ec9965a-96db-46e5-965a-bc307986c26d",
      "event_cluster_id": "25f83819-e436-47d4-a6ab-ce489fc70293"
    },
    {
      "claim_cluster_id": "100519ae-c1d6-4f8e-bcef-2f36e907e789",
      "event_cluster_id": "909c2544-65ad-4eae-8bbb-f43d077750aa"
    },
    {
      "claim_cluster_id": "51ff5b38-5ae5-4505-adc2-291731599e68",
      "event_cluster_id": "09f4e973-2393-41aa-bdcb-ccd0efbed300"
    },
    {
      "claim_cluster_id": "b180d822-88c1-4c5f-a386-c975497c4a85",
      "event_cluster_id": "f1c3e82c-0769-48c5-9831-5c2bc8453631"
    },
    {
      "claim_cluster_id": "b2a26561-1192-4739-962b-b9df80083243",
      "event_cluster_id": "3fe0d18a-cf4e-4f24-a77f-892271df6bae"
    },
    {
      "claim_cluster_id": "4bcae16d-fb51-4ba8-8381-37355e0e9f18",
      "event_cluster_id": "fd17e83e-78c7-4b20-8834-c8e041abcbf4"
    },
    {
      "claim_cluster_id": "f4d9e677-79ed-4c5c-84a1-d127898975a0",
      "event_cluster_id": "652f545a-2cde-41d4-9382-f23ab9d1b406"
    },
    {
      "claim_cluster_id": "5833eaa5-8c9c-42b9-bd12-8cdf781ec725",
      "event_cluster_id": "e197be16-bc11-494c-aa3f-5b8f744ffb1a"
    },
    {
      "claim_cluster_id": "29149f19-2cff-4344-bb10-8e0506dbc049",
      "event_cluster_id": "467eec25-d0de-412a-9f09-8a0db03d60ae"
    },
    {
      "claim_cluster_id": "74c84f9c-121d-41ed-8a45-f4cdf85eb02c",
      "event_cluster_id": "b83a1d17-db6c-42cd-8ccd-d99d30b78f59"
    },
    {
      "claim_cluster_id": "f2b2e8c7-6437-43ee-a47e-1c3a44cd6c34",
      "event_cluster_id": "36133231-d5e7-4a50-b9f0-6f646f403eb7"
    },
    {
      "claim_cluster_id": "f4638fa7-3292-4d44-b3f1-771aa65146b0",
      "event_cluster_id": "01d5ac9b-578e-460b-921d-2d1cc5ecad34"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "db855b90-bd37-485e-bb72-492eed958963"
    },
    {
      "claim_cluster_id": "bd50210c-37cf-46e2-9d31-0c6a6dd06e70",
      "event_cluster_id": "fef26a04-5ec2-47de-9b9c-92eaaae9e544"
    },
    {
      "claim_cluster_id": "00386fb1-3dcc-4b4e-b74b-bc14dbc4e260",
      "event_cluster_id": "af07ce28-0024-41ac-b51c-01e4bbf2c507"
    },
    {
      "claim_cluster_id": "f2363c7c-72d1-4e3a-b724-27c1d218c5fc",
      "event_cluster_id": "eafeed04-4e89-4efc-a2ef-31ce78091f99"
    },
    {
      "claim_cluster_id": "dec098ce-5baa-400b-a766-6543ab0afe00",
      "event_cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810"
    },
    {
      "claim_cluster_id": "8806403a-c610-4055-9744-edc72cda745d",
      "event_cluster_id": "f97c3788-df6a-4dd4-b544-6d0397d5953e"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "4958a7ec-0cd2-487f-a59b-9bc34843a2b7",
      "event_cluster_id": "083a8283-1aa3-4b94-9026-bbd5c3a07cbe"
    },
    {
      "claim_cluster_id": "30011e47-1ff9-409e-8099-2eff6ab89e88",
      "event_cluster_id": "130b5f11-d69b-4e29-8d13-05a09ea6b8ad"
    },
    {
      "claim_cluster_id": "a4400c47-658a-4ca0-9b29-fa8384838731",
      "event_cluster_id": "815f7381-c3c0-4b84-8b7d-44fda735e36e"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "c9ef551f-21d7-4986-8f7f-14a67206ac95"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "e4596864-8ee7-4544-832b-f1063fa0c90c"
    },
    {
      "claim_cluster_id": "9f4b1362-f866-4431-983b-c739ed7f376e",
      "event_cluster_id": "0bbfb864-d9fa-40cd-982d-22d96033b7a3"
    },
    {
      "claim_cluster_id": "f8e7dcff-d078-4ce8-9ad3-495ed7c19774",
      "event_cluster_id": "5f181f74-d991-4908-aaf7-6917a17dca75"
    },
    {
      "claim_cluster_id": "55a53a4b-b30c-483d-9f7b-8c999d5c2f62",
      "event_cluster_id": "1bece78f-f648-4fbc-85c0-722698749525"
    },
    {
      "claim_cluster_id": "40db941d-31ac-4f8f-a268-d60a6c9bd055",
      "event_cluster_id": "21f0a219-a107-4e6e-aa28-e010ad5aec66"
    },
    {
      "claim_cluster_id": "100519ae-c1d6-4f8e-bcef-2f36e907e789",
      "event_cluster_id": "44a25f49-5174-4a81-bbe3-8d614f9c4116"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "202ead36-85d6-41b8-a59e-b60cf6559899",
      "event_cluster_id": "fea07608-613d-4c2c-b77c-a335119ce351"
    },
    {
      "claim_cluster_id": "dac4f0e5-e31b-44cc-a055-3ac65eec9d11",
      "event_cluster_id": "f60ced9d-709d-49cc-bda8-183a3ced98f4"
    },
    {
      "claim_cluster_id": "f87de08e-1790-487e-a827-12378ebf4309",
      "event_cluster_id": "964aba3e-f62e-4ef6-b8f3-99237adf29ba"
    },
    {
      "claim_cluster_id": "1a660b55-5f53-4246-a227-98df9e4e2ac4",
      "event_cluster_id": "1502dc4e-242e-4ce0-baf9-c0d4847d8993"
    },
    {
      "claim_cluster_id": "1c5a43cc-bd0f-4446-9eae-4f39a7691fd3",
      "event_cluster_id": "ed1adfd2-5ca7-48e4-ae90-60f2fca59b2a"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"
    },
    {
      "claim_cluster_id": "a65b71fa-08aa-4b20-91e3-c9e898591f07",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "601320a2-3fca-41ef-9387-a64a4c0b5cee",
      "event_cluster_id": "3b5c9589-43fb-428f-a24d-ff67c6ec3e67"
    },
    {
      "claim_cluster_id": "585ea825-312e-47cf-9ba6-332afbfb9ed5",
      "event_cluster_id": "4f34e75a-3485-4e52-8dc7-20e80c772c83"
    },
    {
      "claim_cluster_id": "369b1cc5-aae5-4361-aabf-b1ef5c5350f8",
      "event_cluster_id": "5534af16-de3c-4c33-b0b7-ecff69356f24"
    },
    {
      "claim_cluster_id": "70898fa9-9960-49d5-b422-3f77d073d86b",
      "event_cluster_id": "bc29966a-d588-4e80-8feb-dd96bcffea23"
    },
    {
      "claim_cluster_id": "284e7f1a-ee5c-4c83-986e-6b13c6c2e6b5",
      "event_cluster_id": "2e8ade9c-f86a-44fa-88a9-a501aee7cc66"
    },
    {
      "claim_cluster_id": "070a19a3-da4f-4314-9f9a-9f32850f97f0",
      "event_cluster_id": "e86a3db7-1b97-499b-90f0-337a1d71a604"
    },
    {
      "claim_cluster_id": "3579f3e6-5ab6-488d-a555-602383a4e3bf",
      "event_cluster_id": "7e03d5b5-4b07-4e72-b62b-55465d7f9333"
    },
    {
      "claim_cluster_id": "555fa82e-54c2-4aba-bcc8-bcfe1ec2186c",
      "event_cluster_id": "0ae66dca-634f-424b-80e9-5fc4b2615b98"
    },
    {
      "claim_cluster_id": "0a0082f4-5a11-4bce-aa5d-1877fddb104d",
      "event_cluster_id": "82b56123-1ab0-4271-8360-fac7c8b1d118"
    },
    {
      "claim_cluster_id": "f570b12b-c8a8-4d99-9575-a11a563abe1c",
      "event_cluster_id": "a16d38f8-25ac-46b8-94d9-38eb77cacdcf"
    },
    {
      "claim_cluster_id": "8457d857-0fdc-43af-97c5-93e3a3631f90",
      "event_cluster_id": "b98b439c-bc5f-48c4-9882-c02eb0d9e36c"
    },
    {
      "claim_cluster_id": "2e1084b1-c7f9-4543-8153-a6c840adb565",
      "event_cluster_id": "adde58fd-6daf-4b35-b4c1-a6e18d15a403"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "e4c393f3-a213-40f3-ae1e-bc16b0f13a4f"
    },
    {
      "claim_cluster_id": "00c920c5-f4fa-404a-9d1e-12f311ed5e11",
      "event_cluster_id": "979b7171-b50b-4784-a226-a93eb757dfb4"
    },
    {
      "claim_cluster_id": "6c947694-8652-4e58-b4d1-40be43d3a77b",
      "event_cluster_id": "733bc88b-24fe-4115-bf99-e05181e2177b"
    },
    {
      "claim_cluster_id": "62f1a663-dd6b-40a0-81fa-7660c589c0df",
      "event_cluster_id": "6f5bbb87-6b1b-44e1-b1a8-1e74525f3d78"
    },
    {
      "claim_cluster_id": "2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37",
      "event_cluster_id": "fec39a26-1bf2-4183-bcb5-a33cc47fe4d3"
    },
    {
      "claim_cluster_id": "98f59c42-164f-4444-8ecb-92a7e7c88a99",
      "event_cluster_id": "d140ee70-1c2e-44c9-b163-573b275b6b17"
    },
    {
      "claim_cluster_id": "06af9b74-e018-4919-8256-29acfecc76d7",
      "event_cluster_id": "3449416a-5af1-418f-857a-770f02267ee7"
    },
    {
      "claim_cluster_id": "9860031c-3ecb-400d-a847-e88ace1049f2",
      "event_cluster_id": "69365007-aabc-4f8e-a4e7-3ac92aef1b47"
    },
    {
      "claim_cluster_id": "b2871022-57c5-48f7-adcd-caeceec2edeb",
      "event_cluster_id": "f3b31658-0ebb-4d41-9f46-459b160be01d"
    },
    {
      "claim_cluster_id": "0a1db453-23bf-4b25-a04b-c4f13d273e88",
      "event_cluster_id": "269675ca-916b-4267-8970-bb97e2010767"
    },
    {
      "claim_cluster_id": "10bf083b-35c8-4b77-a2d9-e4cb3813d9fb",
      "event_cluster_id": "06234dad-1957-47b0-bd01-974e9b80e07e"
    },
    {
      "claim_cluster_id": "03ac5e38-07fa-4023-b9bd-bdfc9810ba0c",
      "event_cluster_id": "21ef96d9-9c60-4110-9606-ce33a7d0a4f1"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "3e87987a-c8cd-4616-922a-e297f103d0fa"
    },
    {
      "claim_cluster_id": "c3f83d4c-9f83-4fe3-befa-1e9b93dee510",
      "event_cluster_id": "3c66cbc4-f759-4da9-9813-b36b4c322970"
    },
    {
      "claim_cluster_id": "e0d3c894-0bdd-4f66-b7b2-a6bada2f1b37",
      "event_cluster_id": "c5169cd7-a9a1-476b-8658-0fe7fd1f0d44"
    },
    {
      "claim_cluster_id": "149c2ce0-2083-4d57-aa68-de8fbf125008",
      "event_cluster_id": "d2b4f80e-7d68-4944-98c8-306c2b192c15"
    },
    {
      "claim_cluster_id": "1993c1c6-e677-4697-9e0d-f4c2332e53fe",
      "event_cluster_id": "08cb653c-495a-4846-800e-e87a07c472be"
    },
    {
      "claim_cluster_id": "9cc8f400-4462-4501-9bf3-f6cf35f7a110",
      "event_cluster_id": "f643a51f-99d3-4180-8b6e-ad534e8f3dbe"
    },
    {
      "claim_cluster_id": "2b3c747b-9f75-4697-a22b-426999d9c671",
      "event_cluster_id": "8985495d-c23b-4b4d-8af8-d412abf8767b"
    },
    {
      "claim_cluster_id": "96b36beb-a890-402f-9101-7aa7236863f1",
      "event_cluster_id": "4da30c02-5a8f-4e15-af9d-b0a7ede85a55"
    },
    {
      "claim_cluster_id": "ed50b251-f205-4952-987b-aed1c0461840",
      "event_cluster_id": "27c83a03-3f6f-4152-a678-12dc8e5912da"
    },
    {
      "claim_cluster_id": "86944fd0-c689-49c4-894c-bd247f4057bb",
      "event_cluster_id": "dad9620e-fc93-4bb0-adf4-d1ba1da4f381"
    },
    {
      "claim_cluster_id": "555fa82e-54c2-4aba-bcc8-bcfe1ec2186c",
      "event_cluster_id": "62c364ef-d86a-4575-aa30-edbcabb6f794"
    },
    {
      "claim_cluster_id": "19dc451c-d076-4677-8e6a-44a760f27332",
      "event_cluster_id": "198dc8a2-e334-4b48-8e21-1b19bd36b74b"
    },
    {
      "claim_cluster_id": "ccf91c48-303e-4d94-8263-0e8c6de64e17",
      "event_cluster_id": "f7bc5745-3844-4596-a6d1-1d8cba63f4b6"
    },
    {
      "claim_cluster_id": "fa530a1e-4be0-417c-bd45-2254a93d2324",
      "event_cluster_id": "1caeaded-5769-4cdd-b16d-b85f9a51e31c"
    },
    {
      "claim_cluster_id": "71f31aff-9c20-4fff-82ff-b0bb971b0134",
      "event_cluster_id": "a3e7173c-3ffd-4346-9259-1d6261818acc"
    },
    {
      "claim_cluster_id": "11b24695-ec58-4b46-8411-89fe4137f816",
      "event_cluster_id": "7ccbb20b-c467-4a12-8d6c-4afcbbe94813"
    },
    {
      "claim_cluster_id": "b7768432-bcaf-4a4c-9bb2-1a6e02c6a003",
      "event_cluster_id": "a8cfe9e0-0ef9-4b98-a9d6-504f670dd69d"
    },
    {
      "claim_cluster_id": "74f0249d-eead-4904-bdd3-cd8cfbdb6b82",
      "event_cluster_id": "69acedef-de24-45bd-8d64-3a2e3c997d87"
    },
    {
      "claim_cluster_id": "bbe5f850-80f5-4350-8e67-5ae43cf720e4",
      "event_cluster_id": "3f98fdac-3f62-464c-bf56-dd3d2e686963"
    },
    {
      "claim_cluster_id": "7c8b94c0-08bd-43e2-9b5a-418ff416c274",
      "event_cluster_id": "82a5c9f7-4f90-429a-b7a6-559b1c83bc8c"
    },
    {
      "claim_cluster_id": "f570b12b-c8a8-4d99-9575-a11a563abe1c",
      "event_cluster_id": "f996f072-3b37-4e7f-900c-1cc05e40fa72"
    },
    {
      "claim_cluster_id": "a03d3de9-e5ad-47e0-9374-17e6c1998859",
      "event_cluster_id": "54567e29-4033-493e-869f-078ef9153910"
    },
    {
      "claim_cluster_id": "d8f02a31-c29f-429d-b5f0-720768af0f52",
      "event_cluster_id": "e8d1e306-3805-48a6-8fe7-8350cb762a36"
    },
    {
      "claim_cluster_id": "957456fe-cb84-4fb9-bc2f-3e775154a824",
      "event_cluster_id": "655ccaf5-6cf6-444d-a7a8-cb79a1480f69"
    },
    {
      "claim_cluster_id": "a316407d-a413-48ec-95c7-f1a3c83da782",
      "event_cluster_id": "42b0a0ff-74f3-41bf-9d03-2adc79284ead"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "b41760af-aaf8-4d45-b87f-633ebbf009f9"
    },
    {
      "claim_cluster_id": "7faff4ee-fc9e-4ba2-8e8e-36906d88936d",
      "event_cluster_id": "a3f777dd-158e-459c-ae69-5df160dfccf8"
    },
    {
      "claim_cluster_id": "e8d873fb-d6bf-4c6b-9328-dabcc490fe91",
      "event_cluster_id": "3d7436aa-4609-467d-a098-e24702a617e8"
    },
    {
      "claim_cluster_id": "a90d4523-8e1f-4287-ae0c-72459f7c14c3",
      "event_cluster_id": "0e83eeb4-b212-4ca1-a4ab-db7a128c6db1"
    },
    {
      "claim_cluster_id": "9ba84133-d9e2-4da7-8e9b-aeda3ebd4295",
      "event_cluster_id": "2d485df8-2925-4317-a6b0-216006ba9fa5"
    },
    {
      "claim_cluster_id": "131fc120-2488-4970-ac79-410004aa6030",
      "event_cluster_id": "16245af2-3fab-438a-9670-b11a52942486"
    },
    {
      "claim_cluster_id": "f61b95fd-4ab1-43f9-b2f8-53b5afb90d43",
      "event_cluster_id": "04c31a7d-6c2e-4822-91ce-feccb61d28bf"
    },
    {
      "claim_cluster_id": "192dfe82-fc68-4d4d-ae38-d6077567ed10",
      "event_cluster_id": "c49a8079-c568-4dfa-a64f-74a395498785"
    },
    {
      "claim_cluster_id": "a3657e1e-0716-4d64-9a9e-572ba20604c2",
      "event_cluster_id": "6e309345-7a1d-497c-b9aa-287116558129"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "0368ead8-8d25-41a1-9249-88baff9335b0"
    },
    {
      "claim_cluster_id": "958b1512-4a3e-4d41-927e-a3072dd9e9ef",
      "event_cluster_id": "dec6b876-cff7-439a-bac8-9b6a2c289ef2"
    },
    {
      "claim_cluster_id": "869cd99e-564a-4420-981f-b385e7b7bceb",
      "event_cluster_id": "68995fc4-d783-494b-a9d8-283e32c04543"
    },
    {
      "claim_cluster_id": "63bcdf8d-5d7d-43eb-b5b5-735ed74b200a",
      "event_cluster_id": "c7bbd075-2e34-4018-bab2-225944afb981"
    },
    {
      "claim_cluster_id": "71b86c5b-0ae0-46d5-a172-4da94679db3d",
      "event_cluster_id": "4a315717-0c5d-48f0-b376-1a12c3498c7c"
    },
    {
      "claim_cluster_id": "d5dab78c-a52b-4ef8-8000-44988a029a7c",
      "event_cluster_id": "34dc1cb7-40ca-44c8-a250-8a0dace843a0"
    },
    {
      "claim_cluster_id": "b693d408-b0fd-49d2-8eea-39016ff5fda7",
      "event_cluster_id": "56c30444-c8fe-46f9-af30-b0924f71761d"
    },
    {
      "claim_cluster_id": "af26e832-f248-48e8-93f5-fdb54d01a56f",
      "event_cluster_id": "f5769a88-6f55-4990-ae69-e5747ba1c948"
    },
    {
      "claim_cluster_id": "35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60",
      "event_cluster_id": "b8f6ce4f-4115-477a-9fac-602b955a0de8"
    },
    {
      "claim_cluster_id": "e60b32d7-dd12-4868-82cb-0b73bd6ac71a",
      "event_cluster_id": "dbe1780e-f93d-4eae-8780-d2a73e00ae56"
    },
    {
      "claim_cluster_id": "0d813aeb-360a-48ec-afeb-778e533504c7",
      "event_cluster_id": "8af38eb1-9c6b-4cd9-9f2c-55e927900928"
    },
    {
      "claim_cluster_id": "5ac433e4-bd1e-455d-8c24-e981eb354d77",
      "event_cluster_id": "d7c36f98-9955-4c57-9dda-97bd7a1b6e4f"
    },
    {
      "claim_cluster_id": "c0414ded-b694-4e4a-b7f8-d2835618be1b",
      "event_cluster_id": "d5b448d9-eec8-4c71-b5f7-f99ea16eb286"
    },
    {
      "claim_cluster_id": "56d92634-56f1-4385-a700-927cf573e5bc",
      "event_cluster_id": "010bfb3a-2b97-43f6-870c-f3dfb129b9df"
    },
    {
      "claim_cluster_id": "a222dd36-fddd-41d8-956d-d735c7c4c6bb",
      "event_cluster_id": "7690b51f-82d1-4577-be9d-58b4d7bf11b2"
    },
    {
      "claim_cluster_id": "335213da-43c0-415b-b902-6fbd946881b7",
      "event_cluster_id": "a80f445d-229b-4be7-a694-df00afa0ebff"
    },
    {
      "claim_cluster_id": "4fc00d95-d399-4677-9437-13f7e6f573c4",
      "event_cluster_id": "a5739240-460a-4fd1-b5eb-223091bc040a"
    },
    {
      "claim_cluster_id": "6719c4cd-0e09-4c15-af9e-7f2bffedb3e3",
      "event_cluster_id": "fffc483f-c841-4109-b9e1-d2ab5730fe2b"
    },
    {
      "claim_cluster_id": "04fa98cf-7cbb-4ec9-b84f-6d1c0570075e",
      "event_cluster_id": "659e57e4-8954-498d-b047-7eb33a601210"
    },
    {
      "claim_cluster_id": "2a0a6106-78d5-46ad-ad52-e0296bf7134a",
      "event_cluster_id": "72a5de9f-6386-4a16-880d-e374cb327abe"
    },
    {
      "claim_cluster_id": "bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a",
      "event_cluster_id": "2981a7a3-8893-4aea-93c8-d180660c675f"
    },
    {
      "claim_cluster_id": "6dd833f9-26f5-4505-8729-234f3f5eeeb4",
      "event_cluster_id": "74b5a9f8-d64b-4e6b-9562-84c68b5337c2"
    },
    {
      "claim_cluster_id": "d17d8e48-7844-4b9c-9bc0-e31d87299aef",
      "event_cluster_id": "367c1ab5-4267-4b68-a2ed-2893d2797c11"
    },
    {
      "claim_cluster_id": "4afb1f4b-4686-4338-bf49-bdd4d2091f0a",
      "event_cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5"
    },
    {
      "claim_cluster_id": "2fc8ee47-5c74-46a4-91ea-72f94f9e2c27",
      "event_cluster_id": "01bab4ca-5ac0-4d57-8f20-7bea2afbd031"
    },
    {
      "claim_cluster_id": "95469f31-02a2-4069-8577-33c92dddd21d",
      "event_cluster_id": "5241cd80-7c22-4aa4-92c3-aaf01b6a8d68"
    },
    {
      "claim_cluster_id": "81174c72-fc84-4203-8dcb-b1068c7bd254",
      "event_cluster_id": "11ad6c89-9a64-4385-9a81-dfa3787cc401"
    },
    {
      "claim_cluster_id": "a789dff6-b07a-42f9-812b-05be84eb01d1",
      "event_cluster_id": "ea917d1e-f3f8-41ef-93c6-2a9bfc99aac6"
    },
    {
      "claim_cluster_id": "46a0b407-50f8-4cc9-968a-6955a0540862",
      "event_cluster_id": "ecec86b9-e0c2-4698-b5d8-0631850621a9"
    },
    {
      "claim_cluster_id": "9c9d4ed6-a861-4706-aee3-f148f1769c86",
      "event_cluster_id": "79a31826-be43-4bb3-80ca-3a1482a7949f"
    },
    {
      "claim_cluster_id": "4a042392-1467-4ea4-a1a6-548cd972a82d",
      "event_cluster_id": "9674610b-7b1f-4315-90d0-0aac1ad7fa99"
    },
    {
      "claim_cluster_id": "a72e319a-9e87-40b0-a2c4-a95e4857ac8d",
      "event_cluster_id": "eea0fa94-e771-4e8e-a675-3b0499fa98b9"
    },
    {
      "claim_cluster_id": "947a0b8b-01e0-44c9-8ebc-c9da3eecde20",
      "event_cluster_id": "b454bfa6-3d84-4f22-a166-5f84ce0bf756"
    },
    {
      "claim_cluster_id": "4bda17b5-0897-437b-9ad7-ab5783ada079",
      "event_cluster_id": "7869af70-2ee4-4af6-b749-30538201cdc4"
    },
    {
      "claim_cluster_id": "d42df985-9fff-4c49-bac2-4cb2fef7ac9d",
      "event_cluster_id": "00d660d9-94af-474c-8e79-c16ac62cbef7"
    },
    {
      "claim_cluster_id": "6abe1bb1-d30a-40e6-8fb2-f7c5a02ae16a",
      "event_cluster_id": "203f76bb-0a3d-4ccd-8cba-09629dfeec98"
    },
    {
      "claim_cluster_id": "4370b159-681b-41a0-8da8-22c407b09da9",
      "event_cluster_id": "a7acdb17-a586-4af4-bbd7-68b913003d4e"
    },
    {
      "claim_cluster_id": "02c78b1c-dd55-4ba6-a345-d21fd27d3214",
      "event_cluster_id": "1d2ddf8d-adbb-42d0-bc0a-c14744855316"
    },
    {
      "claim_cluster_id": "1e8d5556-2c0c-4097-b606-9907a5dd2afc",
      "event_cluster_id": "c7c8c6d3-cdc9-47d7-8f45-165280d3560a"
    },
    {
      "claim_cluster_id": "53ddceb6-33d2-42fd-849a-253f21907d2a",
      "event_cluster_id": "ea5e4d14-d784-48f0-ab38-f454314db96b"
    },
    {
      "claim_cluster_id": "daf0b3a1-53f1-4b47-955e-785030ee3839",
      "event_cluster_id": "7d0b4f2d-8055-491e-a0df-31787da0b9a8"
    },
    {
      "claim_cluster_id": "bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c",
      "event_cluster_id": "1faa9d4d-1b1c-4e6c-9fd5-22f9b057a61b"
    },
    {
      "claim_cluster_id": "9352b2a0-83e7-4ffa-ae39-61c24aa700b8",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "2706ec99-75d3-433d-ab95-f5c524eb1832",
      "event_cluster_id": "73900380-dcd7-40a9-bff7-af4dd25e907d"
    },
    {
      "claim_cluster_id": "31d339ae-2342-44f9-a909-e299d2c4eccd",
      "event_cluster_id": "7690b51f-82d1-4577-be9d-58b4d7bf11b2"
    },
    {
      "claim_cluster_id": "057bcb05-f915-40a6-9a44-d57aa6602574",
      "event_cluster_id": "54390be0-8660-4904-8b7d-c97b603bc1ce"
    },
    {
      "claim_cluster_id": "029b01a5-6f18-4a7f-96f8-6bde44853032",
      "event_cluster_id": "07b11e06-46ec-45e9-8f01-bc31083fd0de"
    },
    {
      "claim_cluster_id": "7c8b94c0-08bd-43e2-9b5a-418ff416c274",
      "event_cluster_id": "53c60ecd-a401-4cd8-a176-63a07a0b82bf"
    },
    {
      "claim_cluster_id": "712f7b26-cec5-48c3-8025-43c35dea8246",
      "event_cluster_id": "3a4ae54e-e7b7-47e9-984e-62601ed45ab4"
    },
    {
      "claim_cluster_id": "acca2114-d8e0-468a-8116-8a8e6ac23e1b",
      "event_cluster_id": "d7fa6886-1236-4402-9039-11c8f678ba45"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "a63f5d9a-cff2-4275-97b2-48d300df1ba7"
    },
    {
      "claim_cluster_id": "a5124b94-6b98-447d-9c53-5100339210c5",
      "event_cluster_id": "758c5e50-7f9a-4e26-9df7-02c7b0095788"
    },
    {
      "claim_cluster_id": "df5b4e50-7d1b-4d7e-ae01-046530298250",
      "event_cluster_id": "75a5f06e-b690-4ab1-b016-65c86c1b4940"
    },
    {
      "claim_cluster_id": "68ff85cf-74e5-4234-a53f-6dba1aacb444",
      "event_cluster_id": "bb5356e7-f071-485f-8695-919ba1db8606"
    },
    {
      "claim_cluster_id": "9fc65438-2baa-4ecf-a802-ddd71c4ed907",
      "event_cluster_id": "833754ff-abfd-4996-b62a-92904373fd3b"
    },
    {
      "claim_cluster_id": "756b0f02-73cb-49a8-bdd7-27690bdeb637",
      "event_cluster_id": "01f44311-0ef8-48af-a616-086ce88e4356"
    },
    {
      "claim_cluster_id": "098acc21-62ca-42b4-8206-4df179ae28c3",
      "event_cluster_id": "a5739240-460a-4fd1-b5eb-223091bc040a"
    },
    {
      "claim_cluster_id": "76a80e87-389e-4e6e-9595-1b220839fd20",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "c831921a-fda1-47ba-83e1-1042bd97f245",
      "event_cluster_id": "48bb955f-2782-4b10-b519-1e1e1206fc7f"
    },
    {
      "claim_cluster_id": "7bf63345-7700-41f7-861e-b298dc68ad2d",
      "event_cluster_id": "4b572207-fd2c-4388-8ae9-d177ee557903"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5"
    },
    {
      "claim_cluster_id": "5238def0-ccfb-4f27-b836-f20f9b7dd70b",
      "event_cluster_id": "8a0c3eda-5944-48c4-883c-6f01e773d494"
    },
    {
      "claim_cluster_id": "54c90db1-79c2-4dc0-b9f0-9cd9022a857f",
      "event_cluster_id": "4fa8e557-bb3e-4afa-89cd-33ec7b315e73"
    },
    {
      "claim_cluster_id": "f14e0258-b8de-48c8-96bd-31550d005b4b",
      "event_cluster_id": "6272f62e-bf00-43bc-ba48-d3f7c9c3ae02"
    },
    {
      "claim_cluster_id": "c721dd3f-abaa-46f4-b0b3-0998badfc28c",
      "event_cluster_id": "d2698d5d-a9c7-4753-8264-b469e84de09c"
    },
    {
      "claim_cluster_id": "995a6788-c0da-4f2f-a729-9d6b9bf65efc",
      "event_cluster_id": "626e9a9b-6995-4100-8ffb-53ed10359203"
    },
    {
      "claim_cluster_id": "32f9804d-d015-4846-99e2-90dd09953704",
      "event_cluster_id": "2b3f127f-efff-44cc-83bb-012f860b4fc1"
    },
    {
      "claim_cluster_id": "199242cb-5b3e-40d9-bf38-e1eddcf574fc",
      "event_cluster_id": "7301fbf5-a19c-4247-aac6-e3d55981cf96"
    },
    {
      "claim_cluster_id": "4c9a1f90-fd90-464e-8a7b-831a736d5b19",
      "event_cluster_id": "678b3718-1825-40ce-8b76-3f1e30facae7"
    },
    {
      "claim_cluster_id": "b1bbc4cc-bc3b-4f57-bced-c8d0267cbdb4",
      "event_cluster_id": "9c86d7d6-beed-46e5-8bf4-a9b09bb7cc58"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "e0932d8f-119b-4dcd-8100-b5fb6b62417a"
    },
    {
      "claim_cluster_id": "a023722f-ed95-4d7c-9c3d-0d405ad7a2c4",
      "event_cluster_id": "43cb3cb0-9dc6-46db-91b7-d99bcaa7a443"
    },
    {
      "claim_cluster_id": "97b36cda-ba8c-4a83-864b-060595445ba9",
      "event_cluster_id": "163f1d1d-a78f-492c-b769-5b6a7b1465fa"
    },
    {
      "claim_cluster_id": "b40ccc38-63a5-4a58-8bbb-6242768fb158",
      "event_cluster_id": "6f4705cb-b438-4a8d-84e2-59fd3445f3af"
    },
    {
      "claim_cluster_id": "d669c1ac-c710-4975-98db-1c778f28ee4c",
      "event_cluster_id": "7a0376f1-1a7b-4181-a413-d3bc6cd70242"
    },
    {
      "claim_cluster_id": "489bde91-1bfc-48d6-aae7-de380d23d205",
      "event_cluster_id": "6fad579f-d261-4337-bd5f-1776b8d945c8"
    },
    {
      "claim_cluster_id": "4de7b868-bb12-43db-9bc6-efbf0705904a",
      "event_cluster_id": "2a58b8a4-48d6-4d79-a6a6-51d7d778b6e1"
    },
    {
      "claim_cluster_id": "b523cd60-7c0d-4c50-b41c-3522aed9c4b1",
      "event_cluster_id": "1616bd8d-8966-4c95-b316-b97e2fb92058"
    },
    {
      "claim_cluster_id": "89aabd59-2b1d-4122-9c03-b5ffeee5a650",
      "event_cluster_id": "926c487a-2b3f-41e8-acd8-d984df721c84"
    },
    {
      "claim_cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "event_cluster_id": "0d1a4169-975f-49a7-9f31-390c351eb65a"
    },
    {
      "claim_cluster_id": "fbc30c99-229d-49c2-8ecb-ce9a62431408",
      "event_cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5"
    },
    {
      "claim_cluster_id": "4a91c427-d613-4080-adab-a06fc13d13ac",
      "event_cluster_id": "b985b53e-1d8b-45e2-8b3f-823f5bdb2380"
    },
    {
      "claim_cluster_id": "289e5c59-c24f-465d-931a-b56b54bc982f",
      "event_cluster_id": "0d5b0cde-5145-4f38-a41d-e29b3956da5e"
    },
    {
      "claim_cluster_id": "435bc534-7da4-4fec-82cf-af0f2a0a282a",
      "event_cluster_id": "1e5faa7b-e696-49d7-be88-e86b8468f738"
    },
    {
      "claim_cluster_id": "f50144fc-3b9b-4e34-ac6c-5191d30445d0",
      "event_cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87"
    },
    {
      "claim_cluster_id": "e1f9f42d-4c64-42c8-80ee-89170b717dbd",
      "event_cluster_id": "6acfc858-1016-4e78-a1e1-7d809680381e"
    },
    {
      "claim_cluster_id": "1c24fe42-ed01-4d5e-85a3-6011ab09ff6f",
      "event_cluster_id": "928155fe-b009-4dae-a22f-c56106f4b853"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "a3015153-afe6-4168-9a99-d14bbbdd401f"
    },
    {
      "claim_cluster_id": "9769a072-502e-4c26-bce2-57d4532d25f3",
      "event_cluster_id": "d3c16aa9-3593-44e3-b641-54f418736f76"
    },
    {
      "claim_cluster_id": "07ec2e30-02bb-47d3-9b4c-32b7c841fb33",
      "event_cluster_id": "31a83c0d-3856-4e30-82d4-769416b594bd"
    },
    {
      "claim_cluster_id": "81062452-735a-45ec-ae26-d06b90c45ed4",
      "event_cluster_id": "18e3c7ef-4d72-40ea-ad9e-2d600cc1b21e"
    },
    {
      "claim_cluster_id": "f833277e-e62d-4240-a8fa-fd6d79db3c79",
      "event_cluster_id": "7815f5ae-d441-4f71-b0e2-771810097e05"
    },
    {
      "claim_cluster_id": "3a7c04bf-2c54-4817-990d-55771d584811",
      "event_cluster_id": "3b570036-015c-4669-a1c7-9124e256f407"
    },
    {
      "claim_cluster_id": "6103c4f7-8bea-436e-90d7-0ed75fe275c5",
      "event_cluster_id": "69bdd771-bee0-4047-b696-6cda0e3de3f2"
    },
    {
      "claim_cluster_id": "e15501de-8202-4040-803d-8b5cbf6cf53e",
      "event_cluster_id": "56d99389-f62b-41f0-b4bc-d85869083e3e"
    },
    {
      "claim_cluster_id": "62d8fa29-aaab-4f66-9532-5fb34686e56f",
      "event_cluster_id": "f5bdb13c-8dca-44f0-8aa1-f75785f668e5"
    },
    {
      "claim_cluster_id": "fcd78a45-418d-433f-807b-b94b3ba2cade",
      "event_cluster_id": "c8744ddc-73ca-4b76-bc5b-2e4d00f4bba9"
    },
    {
      "claim_cluster_id": "43b3601d-6d6e-43a4-8cdc-72cf4aa80640",
      "event_cluster_id": "f1b5fe76-d258-4eb9-9621-ec9dac4e7f52"
    },
    {
      "claim_cluster_id": "340bfd8b-2131-4805-ab13-01e1c97ec008",
      "event_cluster_id": "9e59aa88-1912-40bc-b111-4817591aae4d"
    },
    {
      "claim_cluster_id": "f7f1bbb8-f068-46fa-acbf-d579d1b4e308",
      "event_cluster_id": "52457cd6-b07c-4e34-b96e-c3d2ac06f2d5"
    },
    {
      "claim_cluster_id": "f210a15e-3afd-4f52-8da2-de7a59e25377",
      "event_cluster_id": "0e68f81d-43a7-45ed-8f07-1f52cfdcdd62"
    },
    {
      "claim_cluster_id": "7afb7680-3722-423f-b129-7076bfb88092",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e",
      "event_cluster_id": "1ce4d643-96d1-4472-9df9-18efdd477875"
    },
    {
      "claim_cluster_id": "f679dcc1-fbec-4813-8cbd-bf97a313606d",
      "event_cluster_id": "40467831-07ba-4c26-8f13-029707ea2660"
    },
    {
      "claim_cluster_id": "6dc49cf5-bbfe-4cdb-aa3e-bd6aa990f0c1",
      "event_cluster_id": "0c3b0687-d7a3-4aac-ace5-4b4027adcc13"
    },
    {
      "claim_cluster_id": "187eb2a5-5a75-4a22-8ebb-7b83bc1068a8",
      "event_cluster_id": "02063354-1cf2-4e4e-a749-ce91914994ae"
    },
    {
      "claim_cluster_id": "83965363-a851-4083-ae10-33f90da464da",
      "event_cluster_id": "3b56c579-39c7-4dab-b918-56f22f3eec67"
    },
    {
      "claim_cluster_id": "2ae32cd7-45dd-4ab2-9e15-2b8794fa2e37",
      "event_cluster_id": "428b927b-4796-43a8-8135-01b21725b127"
    },
    {
      "claim_cluster_id": "43c40092-a570-4909-9a7c-2090f95182b4",
      "event_cluster_id": "d2dbc116-d919-422e-b972-f5d26fbf7db6"
    },
    {
      "claim_cluster_id": "71cd6d97-dc20-4f7e-b7c6-5d5b5186e201",
      "event_cluster_id": "325bf549-47cd-452f-95f4-f8b56d9739b0"
    },
    {
      "claim_cluster_id": "fe10e346-5245-4859-9317-c6ffae804527",
      "event_cluster_id": "1a36fb41-5917-46f9-abb2-91e9032c6071"
    },
    {
      "claim_cluster_id": "c56c08cf-6265-4f43-9208-61aa17304ed8",
      "event_cluster_id": "27cb0d3d-03d0-4c0b-8af4-dae39953059e"
    },
    {
      "claim_cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "event_cluster_id": "84a0d215-8113-4569-a05e-d15e5c91d360"
    },
    {
      "claim_cluster_id": "81d9d830-fe0d-4e6e-bc5b-8d4c5f74f4e0",
      "event_cluster_id": "6ca3fb21-cb25-40c5-9b5e-3ce14f640344"
    },
    {
      "claim_cluster_id": "7ef8f454-db4c-44bc-85a5-523eff6a595c",
      "event_cluster_id": "ccd39f23-25f5-4e91-a253-3e3574d7d504"
    },
    {
      "claim_cluster_id": "dec098ce-5baa-400b-a766-6543ab0afe00",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "f83f6c15-13c0-41a8-b991-8abeda0466c4",
      "event_cluster_id": "ae7124a9-0441-414c-a93e-4e31fac08e18"
    },
    {
      "claim_cluster_id": "3b48df52-c3ed-4c3d-8f61-54ae3d11e9b1",
      "event_cluster_id": "159512ee-03be-4a2a-b7f9-1691ffdb67cc"
    },
    {
      "claim_cluster_id": "1fc4c0cc-9a41-4ae8-9970-3b340b704e77",
      "event_cluster_id": "7e03d5b5-4b07-4e72-b62b-55465d7f9333"
    },
    {
      "claim_cluster_id": "90ae2f24-9cb0-4989-b1ef-bb4aeb9b9410",
      "event_cluster_id": "5e83ce8b-b525-4867-8caf-5b4d780a4a6c"
    },
    {
      "claim_cluster_id": "8f381ec8-c658-466c-973c-6cace2609d01",
      "event_cluster_id": "2b2067b5-dfbb-4340-b88b-e5f769120fc0"
    },
    {
      "claim_cluster_id": "e35fb8e9-42cf-4ef0-a512-d7be06ad99e3",
      "event_cluster_id": "92c29e5b-570e-405e-92f0-4969ddf38528"
    },
    {
      "claim_cluster_id": "f0be01ea-d71b-4521-a52b-360c419bf286",
      "event_cluster_id": "c711195e-092a-41ee-984d-299705596d70"
    },
    {
      "claim_cluster_id": "5f5fe60b-6bf8-4f80-be3b-0dcf885c1171",
      "event_cluster_id": "bf5c16e4-64dc-4dad-a15b-31db258dc134"
    },
    {
      "claim_cluster_id": "06f782f7-82f3-4b4d-a941-de5952ae3f6b",
      "event_cluster_id": "d47510b3-4df0-487a-a8c5-1177c915ed1b"
    },
    {
      "claim_cluster_id": "16e980af-79a1-4255-8ad0-56ca61ae3b8a",
      "event_cluster_id": "b4515840-1ee4-450a-89e4-256ed3a5260d"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "9a26c9bd-36a9-4c64-8680-f0a2265878f1"
    },
    {
      "claim_cluster_id": "d8515ae8-12a5-4f84-b01f-bc10b41b19e0",
      "event_cluster_id": "31d03aa7-f36f-4c28-8ed1-5c9c9c77acf6"
    },
    {
      "claim_cluster_id": "860407b5-0931-4ba2-9dbd-a0078e94e9c6",
      "event_cluster_id": "c7898fe7-8ae8-4977-88ae-a56e6d146778"
    },
    {
      "claim_cluster_id": "be4a2385-74e7-4ed5-8c71-c890af870db7",
      "event_cluster_id": "9f734692-8c1b-45a5-98e1-623a0369fed0"
    },
    {
      "claim_cluster_id": "b5be89cf-6e40-4238-b7c0-13411fa17ce6",
      "event_cluster_id": "f5cb17c5-09b2-438a-8af3-1ddc4e587641"
    },
    {
      "claim_cluster_id": "6a4e66c3-1fd2-46be-9e31-fecdcd545826",
      "event_cluster_id": "98c5d764-86f9-4cd2-ac58-1dae1f5811e9"
    },
    {
      "claim_cluster_id": "bbf49577-7eda-4f96-83ed-753d3b9cc708",
      "event_cluster_id": "6e881517-8e9f-47bf-854c-c29084f1a26d"
    },
    {
      "claim_cluster_id": "eb4aeb04-6d38-4eed-9989-773ac30f14e1",
      "event_cluster_id": "8842f019-f536-48be-a730-88d7032d791e"
    },
    {
      "claim_cluster_id": "ecc32ba8-bd1c-43c6-8192-e0502c1f14b7",
      "event_cluster_id": "d7ed508d-e43b-4e54-a0c0-6807c3338527"
    },
    {
      "claim_cluster_id": "a7436ce6-07d0-45e0-8628-2de252e4cb46",
      "event_cluster_id": "d7c2bd39-22ec-4271-8c63-6ddb8efeced9"
    },
    {
      "claim_cluster_id": "187eb2a5-5a75-4a22-8ebb-7b83bc1068a8",
      "event_cluster_id": "d56cc903-0bed-4718-9fc5-602c188caa16"
    },
    {
      "claim_cluster_id": "13db6364-301c-4a4a-b13f-69262abf41bd",
      "event_cluster_id": "ed0d704f-d33f-473d-9c87-1978cd551cbc"
    },
    {
      "claim_cluster_id": "930ae324-24b9-4353-aa17-35d5e069f64f",
      "event_cluster_id": "19f144a9-ec9c-4a9b-89c7-b1ca850240da"
    },
    {
      "claim_cluster_id": "6695efed-b1b5-4469-a01b-a370dfb9c522",
      "event_cluster_id": "efe98b1b-e1ed-468a-9652-7acc5550430a"
    },
    {
      "claim_cluster_id": "6f9a5f86-ba12-43df-aa33-746615605f47",
      "event_cluster_id": "dd01fe5a-45fc-4f73-94e4-2d244f396aa4"
    },
    {
      "claim_cluster_id": "89cac161-a6f0-4315-a880-1662cae50313",
      "event_cluster_id": "ebf11375-1fd2-4e33-a82e-1889d6d8f85a"
    },
    {
      "claim_cluster_id": "de6ada25-e81a-4f5a-97f6-0053df68ea0b",
      "event_cluster_id": "9179b891-9dc1-45be-ab4c-6b2e9fbc156a"
    },
    {
      "claim_cluster_id": "40db941d-31ac-4f8f-a268-d60a6c9bd055",
      "event_cluster_id": "c7ac427c-82e0-477a-a03d-4c9be54cce85"
    },
    {
      "claim_cluster_id": "61784f3e-1c50-4b37-9db4-0fd1ec458127",
      "event_cluster_id": "0fae2f14-66ec-4594-b5a0-1588a0fa8339"
    },
    {
      "claim_cluster_id": "ad4fa6da-197e-4295-b610-c2f934cdd3ea",
      "event_cluster_id": "d811e7ed-7bb2-4a03-a5a1-75a044ab14eb"
    },
    {
      "claim_cluster_id": "71f12e75-d3eb-42eb-93dd-fc62f2343321",
      "event_cluster_id": "4c81571d-8516-4f35-b047-353d1a6e0a6a"
    },
    {
      "claim_cluster_id": "644ce0a3-b992-4dbe-be7f-558277802f15",
      "event_cluster_id": "9e47c442-5161-41a4-b305-ebf54f272e75"
    },
    {
      "claim_cluster_id": "aafb6f56-e150-4de6-8f24-4e8fe467b23f",
      "event_cluster_id": "daa3efba-7375-4b5d-bf2a-6a5216d25c83"
    },
    {
      "claim_cluster_id": "14d8e253-98cf-4b3d-83df-8665b7ba0f5e",
      "event_cluster_id": "4eb605cc-1913-4af0-aeb3-6e1b6f05c980"
    },
    {
      "claim_cluster_id": "9d400cbf-08ea-4c02-941a-80cd2d3e517a",
      "event_cluster_id": "44d2e850-7a7c-430d-95ed-40c5cabf8096"
    },
    {
      "claim_cluster_id": "07b6bde9-eeca-4fea-b3c2-39093320ea05",
      "event_cluster_id": "8f6347b0-b76f-45e2-b8d8-b8a8c9dc9e26"
    },
    {
      "claim_cluster_id": "9fa27866-4911-4f0d-8135-cff4b7e597db",
      "event_cluster_id": "3c66cbc4-f759-4da9-9813-b36b4c322970"
    },
    {
      "claim_cluster_id": "1da96a0b-d833-4078-afdc-5a85d522b86d",
      "event_cluster_id": "bbc6fef6-c552-409d-9152-d8abd3a15ae3"
    },
    {
      "claim_cluster_id": "6f7b1c88-304f-4cf4-ba94-d6268fa5ae40",
      "event_cluster_id": "c23b1bec-a608-4fc1-a229-2a8f9b59a27a"
    },
    {
      "claim_cluster_id": "19d43c44-0b32-47ac-85c1-a05682078f22",
      "event_cluster_id": "909c2544-65ad-4eae-8bbb-f43d077750aa"
    },
    {
      "claim_cluster_id": "b36a42d8-1bb3-483d-b77f-bd28630b0e30",
      "event_cluster_id": "642bde4d-512c-4efe-a811-93209336bdce"
    },
    {
      "claim_cluster_id": "565749fa-0214-435c-be6b-1a2ffed6aba1",
      "event_cluster_id": "0005306c-9f05-4c24-afc9-11ea1bc90d4d"
    },
    {
      "claim_cluster_id": "c81b3fac-f8f7-4824-a157-6d31dd48689f",
      "event_cluster_id": "4061c2fc-ed9c-4f22-92dd-291aa2df6a90"
    },
    {
      "claim_cluster_id": "c6f7c193-f407-447c-a10f-3ea5292ea3e8",
      "event_cluster_id": "d21c817e-4d9f-4479-93a3-693ea677e1ba"
    },
    {
      "claim_cluster_id": "62e8f214-855a-45b7-8de5-a667d22dd7f0",
      "event_cluster_id": "065f4f08-9205-4dff-8de0-542c6bb45da9"
    },
    {
      "claim_cluster_id": "2c72a6d8-6edd-4d3a-9563-d326950bc8da",
      "event_cluster_id": "edab64d5-5e0e-4c94-9892-79b39580b98e"
    },
    {
      "claim_cluster_id": "f83f6c15-13c0-41a8-b991-8abeda0466c4",
      "event_cluster_id": "b6472eb8-adb5-40da-b075-e00e04ed2920"
    },
    {
      "claim_cluster_id": "f7f1bbb8-f068-46fa-acbf-d579d1b4e308",
      "event_cluster_id": "89deb9da-1363-4a27-b0dc-19089a829274"
    },
    {
      "claim_cluster_id": "9cfc641f-8857-445d-a3fd-0b6e7a1c0cf7",
      "event_cluster_id": "51c88d49-73a0-41fe-a608-ab3aabe81173"
    },
    {
      "claim_cluster_id": "c64abad7-175d-470b-9931-9259e05b39f5",
      "event_cluster_id": "1ce4d643-96d1-4472-9df9-18efdd477875"
    },
    {
      "claim_cluster_id": "619d0e6c-df2c-4164-aaac-ccaba7c311a6",
      "event_cluster_id": "ab96918c-daa5-4c62-989d-c9617e4f6b5e"
    },
    {
      "claim_cluster_id": "f96fdbdd-0664-4366-b80c-72a8405c4f44",
      "event_cluster_id": "030634a5-ed95-477b-876c-290912b18446"
    },
    {
      "claim_cluster_id": "bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb",
      "event_cluster_id": "b1ff5878-d5c7-449a-8d9c-3d51c6aa3edb"
    },
    {
      "claim_cluster_id": "e7def08b-a4be-4464-b5ad-7e8f1dfa8752",
      "event_cluster_id": "26b806a5-30f6-4312-bfd4-c6984e3b4d30"
    },
    {
      "claim_cluster_id": "a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4",
      "event_cluster_id": "1eb47b4d-d60c-4050-a6b7-0d4e6f499f8e"
    },
    {
      "claim_cluster_id": "ce07721b-5347-4d52-81aa-7a7c68338485",
      "event_cluster_id": "4b93a421-107c-4185-912b-a73d039895b4"
    },
    {
      "claim_cluster_id": "8d8dbda6-96b3-4738-b7a8-777f920a39be",
      "event_cluster_id": "801c5c4b-a47b-4b2c-ae4b-a35937597f3d"
    },
    {
      "claim_cluster_id": "afdf0794-a58d-44cd-b1d0-aec7b0adc12c",
      "event_cluster_id": "90ab0ebb-511c-4032-8a6b-928969e4d009"
    },
    {
      "claim_cluster_id": "c07ab2cc-cb47-49ae-9148-a023065f7018",
      "event_cluster_id": "178a55a6-f879-45f8-85be-38fbb568a251"
    },
    {
      "claim_cluster_id": "8cb34140-24ef-4173-9390-c1f84800160e",
      "event_cluster_id": "4da18b15-13e1-4abd-966a-5a691b26fe59"
    },
    {
      "claim_cluster_id": "a75c6491-7fc4-4904-9a47-b176fcc90a36",
      "event_cluster_id": "fc3e8d2c-52bf-485a-a373-7853e3f353ec"
    },
    {
      "claim_cluster_id": "62bf1a53-b840-4c52-b1a8-6f2e98e4c3d2",
      "event_cluster_id": "c9e1ed1d-b28e-452c-9f9c-c8e37181b84d"
    },
    {
      "claim_cluster_id": "655e754e-33e7-4bf2-aabe-264f18d499a4",
      "event_cluster_id": "731d7658-b5f1-4356-b7c0-c3b8c97cac8d"
    },
    {
      "claim_cluster_id": "b471f42f-4da7-4b5a-a11e-18deef221da8",
      "event_cluster_id": "a49c6bf6-4bdf-4111-8400-ae8603304250"
    },
    {
      "claim_cluster_id": "dcc40b89-996b-46da-af7f-ec64a05c6ee5",
      "event_cluster_id": "6bd1a1b9-8c5b-4543-9007-11872574ea9a"
    },
    {
      "claim_cluster_id": "5bc0db5b-3192-42d4-a343-00cfcacc4499",
      "event_cluster_id": "ed5e7bda-f24a-4769-86cb-26613eecfebd"
    },
    {
      "claim_cluster_id": "371b7329-3c6e-4297-b746-d77ae2db1f6f",
      "event_cluster_id": "660ce2a3-2e3d-4961-a97c-865ff4c461f6"
    },
    {
      "claim_cluster_id": "2a9019de-d820-4155-a78b-fc972ec57552",
      "event_cluster_id": "a29f6f46-43ef-4252-a308-d9b452074037"
    },
    {
      "claim_cluster_id": "e1c12b4b-138d-4ddc-9b6c-49a0a9de18b9",
      "event_cluster_id": "fef7b3de-7af1-40a4-a0ec-544cb6b0b0ff"
    },
    {
      "claim_cluster_id": "48358541-e77a-4c9f-81e2-7af006f34920",
      "event_cluster_id": "b93f0980-3e05-4353-b9af-768e6f562f26"
    },
    {
      "claim_cluster_id": "c721dd3f-abaa-46f4-b0b3-0998badfc28c",
      "event_cluster_id": "7d0b4f2d-8055-491e-a0df-31787da0b9a8"
    },
    {
      "claim_cluster_id": "53a5cd16-ea33-4c3e-8f8f-0d495c63c479",
      "event_cluster_id": "1e5040f4-1599-4a16-abf2-bb352e20053c"
    },
    {
      "claim_cluster_id": "f50144fc-3b9b-4e34-ac6c-5191d30445d0",
      "event_cluster_id": "7ae0d854-6d40-40af-a578-9fbba79fb394"
    },
    {
      "claim_cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "event_cluster_id": "4c9bd8ca-0977-4844-9921-072e396e0fac"
    },
    {
      "claim_cluster_id": "4a2e9d4b-d2bf-4512-a149-283851028578",
      "event_cluster_id": "2ed0e84f-d233-4164-b228-6208473d317d"
    },
    {
      "claim_cluster_id": "94076701-ef33-45db-95b9-6fd0d66deba4",
      "event_cluster_id": "82abb955-d502-4dd6-84e4-ff5a58485230"
    },
    {
      "claim_cluster_id": "3e30f911-bb0c-48a0-8ffb-4be6bf3fe64d",
      "event_cluster_id": "7303fe0f-e412-4fb9-accf-41194e4059f2"
    },
    {
      "claim_cluster_id": "c83250c9-87a2-4ec5-822a-e2413ca91c91",
      "event_cluster_id": "9324a7f5-d024-4c3e-9141-5fa03af67754"
    },
    {
      "claim_cluster_id": "990306d6-263b-4984-88f5-4be9fc326334",
      "event_cluster_id": "c29a246e-69bc-464d-a998-2ee789508141"
    },
    {
      "claim_cluster_id": "9ef9c32c-d40a-4d36-a3db-c01367d4c96e",
      "event_cluster_id": "d191d96a-6233-4306-907d-1beabb6fc9c7"
    },
    {
      "claim_cluster_id": "26461fc6-994b-44dd-97c8-95b6341a4a6a",
      "event_cluster_id": "5c683e3b-456e-40af-9840-3af3a5900ece"
    },
    {
      "claim_cluster_id": "8ff59597-495c-4ba5-b797-afb88f6bfce0",
      "event_cluster_id": "ef96e980-1163-49a7-829e-855a0719a797"
    },
    {
      "claim_cluster_id": "9ef9c32c-d40a-4d36-a3db-c01367d4c96e",
      "event_cluster_id": "7ae0d854-6d40-40af-a578-9fbba79fb394"
    },
    {
      "claim_cluster_id": "666873ec-e76e-4f8a-8d96-7a31c5084ac4",
      "event_cluster_id": "30a2e818-400c-4443-9905-7ab130b7ac97"
    },
    {
      "claim_cluster_id": "f65b5094-1e51-442e-b444-de0d25f1fea0",
      "event_cluster_id": "87f98626-d2f4-4a84-8a1b-fba4417798d7"
    },
    {
      "claim_cluster_id": "103c6b31-e860-4fde-bc3f-de3b1bf5f689",
      "event_cluster_id": "0b109e58-1cde-4c32-aed4-12ba82ed273a"
    },
    {
      "claim_cluster_id": "9a73096a-390b-4f9e-a044-22f30734ce69",
      "event_cluster_id": "46233164-6ed4-4e93-aaed-ca823711dcc5"
    },
    {
      "claim_cluster_id": "10cadbd2-7261-4295-9f88-df0f9a246b5b",
      "event_cluster_id": "d21b19ea-6813-4e8b-8df5-e67ed7dfc0f9"
    },
    {
      "claim_cluster_id": "e935bf33-7d4f-4ee6-8636-94e91a064afd",
      "event_cluster_id": "d789b1ed-51e0-4f7f-953e-3eaabc59ca49"
    },
    {
      "claim_cluster_id": "fc45a344-4cfc-4865-9030-d033f0c8dff3",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "98a97f12-7d1b-49e9-8178-578b2d656f88",
      "event_cluster_id": "67852dd4-618d-4a28-8987-e12077575820"
    },
    {
      "claim_cluster_id": "a031766e-aaad-4e78-b0e4-bd1cf2fc1a66",
      "event_cluster_id": "8a7264fa-6b7e-44f6-b1f1-5b3267bbd42d"
    },
    {
      "claim_cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "event_cluster_id": "ee0681d9-e912-4091-8f01-0d69df3bcbee"
    },
    {
      "claim_cluster_id": "ed42b61a-7c55-44a7-aac6-78560e6e139e",
      "event_cluster_id": "4dc97343-8657-4d38-b2b2-1129b6d10818"
    },
    {
      "claim_cluster_id": "1da5d8fa-d5b3-4c58-9989-3b5775687e42",
      "event_cluster_id": "0ae66dca-634f-424b-80e9-5fc4b2615b98"
    },
    {
      "claim_cluster_id": "d281c55d-162e-4c45-bdc4-8fddc9bff858",
      "event_cluster_id": "8ea45448-137b-4d92-9e93-e6f5676fad3b"
    },
    {
      "claim_cluster_id": "078f370f-a761-435a-a7fd-aae948eb479b",
      "event_cluster_id": "1b56d151-49c8-4483-a185-2c0622a64692"
    },
    {
      "claim_cluster_id": "13b8e657-b1a1-46e6-ace5-fc6a57928a32",
      "event_cluster_id": "fe1c6b54-9f28-4390-8b18-685bcbf44298"
    },
    {
      "claim_cluster_id": "5fec9a51-560a-4b1e-ab7c-cafcf47ba675",
      "event_cluster_id": "c9eb6d86-6b17-4232-b3a7-29de5feb80b0"
    },
    {
      "claim_cluster_id": "60a1acab-79cf-438f-96de-dbff294bd2e7",
      "event_cluster_id": "6e64c34e-113d-43d7-87a6-90c61d4d3f67"
    },
    {
      "claim_cluster_id": "9254d2c4-775d-4f48-975f-879f17b9f193",
      "event_cluster_id": "e5320752-1012-4ce5-880c-e80ddb6ab4ee"
    },
    {
      "claim_cluster_id": "50dbe9fb-6818-4777-990a-3ab01ab3659e",
      "event_cluster_id": "3e87987a-c8cd-4616-922a-e297f103d0fa"
    },
    {
      "claim_cluster_id": "93fddae5-a739-409c-a087-9a562d010a0e",
      "event_cluster_id": "5e115001-bb2f-45b1-be83-78b8766bff77"
    },
    {
      "claim_cluster_id": "5518570b-ceeb-400e-8720-a531292d57ce",
      "event_cluster_id": "0630459a-a055-49c4-959a-918cdf49936f"
    },
    {
      "claim_cluster_id": "983e06bd-8aef-468f-888f-6f39b0353693",
      "event_cluster_id": "4df09684-8f05-4939-a1b1-6f51c32b4b06"
    },
    {
      "claim_cluster_id": "86e5843a-553f-41b4-aec2-73c2638e9bca",
      "event_cluster_id": "02ce3ced-8a21-496b-a44b-583010f8f279"
    },
    {
      "claim_cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "event_cluster_id": "50cf77d2-56a8-4588-8c16-f417874c0063"
    },
    {
      "claim_cluster_id": "a3463468-dce8-4063-85c5-ecdc64691fed",
      "event_cluster_id": "c974a5fd-a8a2-42a7-88dd-b3f3e7fd1ad6"
    },
    {
      "claim_cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
      "event_cluster_id": "4785bab4-a99a-4e40-9619-5133dfc2b141"
    },
    {
      "claim_cluster_id": "489cefd4-e6ef-4f49-8a70-8d8f7bc512bd",
      "event_cluster_id": "0dde3660-e0d6-4644-aa81-6e184dc6e068"
    },
    {
      "claim_cluster_id": "f83f6c15-13c0-41a8-b991-8abeda0466c4",
      "event_cluster_id": "99042c58-6307-43ca-ac61-061cf8a5ba75"
    },
    {
      "claim_cluster_id": "acc5b6d2-0057-4a25-83c7-3d3bbd4031e9",
      "event_cluster_id": "47544927-be6e-4238-bfa2-7d12e902c9e4"
    },
    {
      "claim_cluster_id": "8d676e91-6fd3-47df-8a59-7b88ff3f09cc",
      "event_cluster_id": "6fd0cd66-7572-4a5e-b9bd-53c174988cbc"
    },
    {
      "claim_cluster_id": "6926f592-0807-43c3-9eb1-74f903b009ff",
      "event_cluster_id": "eb8c09b3-c22e-4c14-a55e-41e86bc54809"
    },
    {
      "claim_cluster_id": "84a0c048-8b19-4f73-b588-caa191d08d54",
      "event_cluster_id": "c8fcfafc-5e25-4d83-82fb-dad89f0cb085"
    },
    {
      "claim_cluster_id": "5c533a3e-46e0-4800-bdb7-5c1521efbb3d",
      "event_cluster_id": "fe288be5-fdf6-4f12-bacd-523a94599a41"
    },
    {
      "claim_cluster_id": "f34bb19c-ce14-42ca-a94c-f9bd2e0a2fa1",
      "event_cluster_id": "7645928f-b607-4113-a8d9-4afacf4bc042"
    },
    {
      "claim_cluster_id": "dcf5235c-74f7-409c-bb59-9454cc01feed",
      "event_cluster_id": "cd4a5f4f-0722-49d0-a0a8-588c6f486479"
    },
    {
      "claim_cluster_id": "1dc1ea0e-ecc0-4a99-a555-3574b46d8688",
      "event_cluster_id": "bf10b6e6-7de4-499b-bb6d-a9e69524994d"
    },
    {
      "claim_cluster_id": "f10deefc-8ed5-4516-8cc2-3ba87195eac0",
      "event_cluster_id": "6c18a3ce-fe35-45a7-99c1-4b725342cc8f"
    },
    {
      "claim_cluster_id": "82430ac1-c5b1-4777-ac21-a40819c2ad02",
      "event_cluster_id": "b8594232-f9f8-428c-83d8-cd858f613031"
    },
    {
      "claim_cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "event_cluster_id": "d5f8926c-cfe4-4355-8a20-781d575d7616"
    },
    {
      "claim_cluster_id": "e6cb9f82-faa2-423b-984b-e379572890e7",
      "event_cluster_id": "6e377c9a-0767-453d-bf0f-0a832d805a7b"
    },
    {
      "claim_cluster_id": "8e782418-3f83-48d1-a7d0-6c3daf34ed25",
      "event_cluster_id": "1be22971-e6b7-4f57-b7f5-9c6d0cc3afbb"
    },
    {
      "claim_cluster_id": "f83f6c15-13c0-41a8-b991-8abeda0466c4",
      "event_cluster_id": "da057e1c-8692-4118-a2c6-f3b0fa767931"
    },
    {
      "claim_cluster_id": "ed1fef35-ea22-4436-b53a-1dc1f0380298",
      "event_cluster_id": "17e1ec75-19f3-468b-a8ac-9a834a96fe02"
    },
    {
      "claim_cluster_id": "253e2fef-8100-4235-899c-96e9877535d1",
      "event_cluster_id": "49c4c056-d70c-4a38-9178-06a4f74c1135"
    },
    {
      "claim_cluster_id": "42d845ed-aaed-4d48-a0e4-2928cc3ba602",
      "event_cluster_id": "676e3412-2df4-4d29-844b-686d41a53c1e"
    },
    {
      "claim_cluster_id": "0119782a-5d22-485c-b58b-6c82b20e788c",
      "event_cluster_id": "788ae773-424f-4215-9262-5847e02b117b"
    },
    {
      "claim_cluster_id": "ca0d3bae-6f1d-4857-b362-c7e7718bca04",
      "event_cluster_id": "45c15578-ca19-42ef-8fc5-04e77034e4c3"
    },
    {
      "claim_cluster_id": "13b8e657-b1a1-46e6-ace5-fc6a57928a32",
      "event_cluster_id": "6e17469d-ab2f-4f85-99c5-d4389227a162"
    },
    {
      "claim_cluster_id": "95f30627-ec05-45c4-9f6e-28dd5c31e412",
      "event_cluster_id": "0ab26e4b-97a4-402f-89ba-c8bf505907da"
    },
    {
      "claim_cluster_id": "be9b7361-8150-4e4b-9111-bac990c11d3d",
      "event_cluster_id": "382c8bbe-8826-4b13-8317-0d73ee7eee77"
    },
    {
      "claim_cluster_id": "ab2c49a9-2278-4839-bbdd-9674c0825abf",
      "event_cluster_id": "32bd49c6-94f8-4c4c-b45a-7a8a4f01eb08"
    },
    {
      "claim_cluster_id": "7b23c8f0-7f79-4c82-ac44-60b02a4ff1cd",
      "event_cluster_id": "d41f0247-c996-4fca-bb9a-db10717ce822"
    },
    {
      "claim_cluster_id": "da1326c3-fa76-400d-b44c-881f6493a085",
      "event_cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0"
    },
    {
      "claim_cluster_id": "e2dae5ce-65e5-4bf8-ac38-f452e98e9363",
      "event_cluster_id": "31531356-3930-43a1-9c28-b7ad9753b67e"
    },
    {
      "claim_cluster_id": "237a5318-2edd-4ffc-869f-c0fed9502097",
      "event_cluster_id": "56c21a67-f093-4d7b-81de-a41cb3a3c896"
    },
    {
      "claim_cluster_id": "58cd12d0-b190-4e1f-826a-20e181a5c137",
      "event_cluster_id": "89092280-296c-4fb1-844a-03436e7b7c26"
    },
    {
      "claim_cluster_id": "1da5d8fa-d5b3-4c58-9989-3b5775687e42",
      "event_cluster_id": "62c364ef-d86a-4575-aa30-edbcabb6f794"
    },
    {
      "claim_cluster_id": "5b7e1f2c-86a3-4e27-9c3e-c974a8d33606",
      "event_cluster_id": "31e7b652-307d-4f5d-a4a6-215892b2e421"
    },
    {
      "claim_cluster_id": "29e9fc0f-b1d3-428d-985b-aead08ce4e3c",
      "event_cluster_id": "9de91220-8362-4c94-b430-300c675c23e5"
    },
    {
      "claim_cluster_id": "407486e4-c133-4139-9739-41644f65fa24",
      "event_cluster_id": "664cfcc2-edf1-43a6-a432-be97b535188e"
    },
    {
      "claim_cluster_id": "a0d964f3-2911-42e0-a686-2f4aa48a2f24",
      "event_cluster_id": "33378b17-6e0e-486d-a122-a219ecc02e56"
    },
    {
      "claim_cluster_id": "c4bd1c97-a831-4763-9c03-6a3cf69f7caa",
      "event_cluster_id": "676e190d-f7b8-4cab-bf36-934dddda11c8"
    },
    {
      "claim_cluster_id": "1a247a51-e7fa-46f4-b0b3-659a03d784c6",
      "event_cluster_id": "199fa239-0e31-40e8-a4f6-178a14d58cc8"
    },
    {
      "claim_cluster_id": "ae58d35c-53bd-40b8-b6d5-7fe4e15e229a",
      "event_cluster_id": "388b5477-b8ee-43a6-9b4b-3bf87541cc1a"
    },
    {
      "claim_cluster_id": "ab24b6cb-fc70-48c9-8ee3-224b83a66b11",
      "event_cluster_id": "d1102194-5143-42ba-aac4-2f29e4d13736"
    },
    {
      "claim_cluster_id": "2a265a62-6ee2-460d-b6fd-ab72b8f23578",
      "event_cluster_id": "ca0536ea-7533-4baf-adac-d1ee11b1604e"
    },
    {
      "claim_cluster_id": "c3f83d4c-9f83-4fe3-befa-1e9b93dee510",
      "event_cluster_id": "05021641-3e64-47c1-b3de-9319980f7bf2"
    },
    {
      "claim_cluster_id": "5765d283-f56d-43cd-b120-e8f9048e2325",
      "event_cluster_id": "cfe9cc78-dae7-4fb3-9619-c934beac1286"
    },
    {
      "claim_cluster_id": "00a040a7-5456-47e8-b780-a67388e64219",
      "event_cluster_id": "ddc5360a-1ac4-443b-9995-2e77ae3fa0fc"
    },
    {
      "claim_cluster_id": "14a12b13-500d-4488-86b9-0f65fe548f9c",
      "event_cluster_id": "e342f418-21fb-447a-a1a2-0cf67132d420"
    },
    {
      "claim_cluster_id": "b61ba5b2-e28d-4cea-b7a2-78bed070aeca",
      "event_cluster_id": "28aa9b69-c31d-45de-bec6-3308b64b4f24"
    },
    {
      "claim_cluster_id": "3bda7498-8cf1-4495-9ee2-307193fe0c3e",
      "event_cluster_id": "82a95bd3-d7e2-43e8-9d25-fbbc664ac7bc"
    },
    {
      "claim_cluster_id": "a6ed0ce8-662a-4b6a-bb37-1ea2a020377f",
      "event_cluster_id": "58160b77-275a-49fd-b4ad-b9a4e0aa40ef"
    },
    {
      "claim_cluster_id": "ecc32ba8-bd1c-43c6-8192-e0502c1f14b7",
      "event_cluster_id": "f2d1742c-c9b1-44f7-a4e6-abf20a37a569"
    },
    {
      "claim_cluster_id": "8d565c91-b887-465d-a08e-aff09b1e9e5b",
      "event_cluster_id": "0c639465-7159-40b2-869b-06840b83505a"
    },
    {
      "claim_cluster_id": "f8755b86-ae98-461e-a3ac-2bd5b6ec4310",
      "event_cluster_id": "baae4a32-5168-4c2e-a607-5bdb0996a9ff"
    },
    {
      "claim_cluster_id": "27fad854-f733-4ec5-8acb-b36e0c043d26",
      "event_cluster_id": "57d96007-f80d-4110-8583-3e280492b584"
    },
    {
      "claim_cluster_id": "583320d2-3b7c-4cef-9dd1-9eeedce9bc81",
      "event_cluster_id": "e95e8766-3999-437a-8b4f-72bf3c33a6a7"
    },
    {
      "claim_cluster_id": "95b428d7-1d28-45e2-a9a0-dd59bb6a0176",
      "event_cluster_id": "87ccb180-4860-4e8d-af6f-a3acda89b6bf"
    },
    {
      "claim_cluster_id": "af26e832-f248-48e8-93f5-fdb54d01a56f",
      "event_cluster_id": "00c62945-b485-438a-9d05-87baa1d3d907"
    },
    {
      "claim_cluster_id": "f10a7215-4011-4959-9b86-e9f3848b78fb",
      "event_cluster_id": "983a818a-ed6d-40ec-af64-8e28da7e1bbd"
    },
    {
      "claim_cluster_id": "91b0db25-32e4-4e5d-a32d-911732cbec28",
      "event_cluster_id": "236dacbe-2c11-46fc-a4a4-42464ed6f51d"
    },
    {
      "claim_cluster_id": "5a8284e8-a150-41dc-8ee7-edbc3da33af5",
      "event_cluster_id": "4f0e7f6a-d847-4db7-a78d-684ba6b33ce7"
    },
    {
      "claim_cluster_id": "5d65069d-5cc8-4da8-8b8d-bbd1528688e7",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "493568a9-0e32-4b19-a041-15396f7c15b4",
      "event_cluster_id": "524147a4-6ced-4285-aba9-4ef213b856f6"
    },
    {
      "claim_cluster_id": "c0e66b49-a2c1-49ba-be78-c28aff5c60cb",
      "event_cluster_id": "7050bafb-b05d-4691-a1ac-89175bc41e54"
    },
    {
      "claim_cluster_id": "9723a8c8-8969-4471-bc9d-732ca83fc5b6",
      "event_cluster_id": "497c65a0-d076-4ce0-b5c7-b89152ec15dc"
    },
    {
      "claim_cluster_id": "ad83e0a6-e572-4332-8ef0-01e05cdfa760",
      "event_cluster_id": "40ef8151-52fc-4fac-bd6f-6b5534d3b754"
    },
    {
      "claim_cluster_id": "7dc48717-c562-4f7c-bcb3-b4a13374cc42",
      "event_cluster_id": "e914c276-a8b7-4441-a77d-8a5108addc86"
    },
    {
      "claim_cluster_id": "7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1",
      "event_cluster_id": "cc789a67-807e-4a18-9da3-ebd2233fa4d4"
    },
    {
      "claim_cluster_id": "a031766e-aaad-4e78-b0e4-bd1cf2fc1a66",
      "event_cluster_id": "be6b5f43-b5a5-43db-8bdd-0c041f0efa31"
    },
    {
      "claim_cluster_id": "2a250092-9fac-4905-871e-1b18221951a9",
      "event_cluster_id": "88abea30-b9d6-421a-b97f-a1fffe603d2d"
    },
    {
      "claim_cluster_id": "e9b05837-7f42-4f2f-bc7d-dca62a93d724",
      "event_cluster_id": "eac477f8-1470-4d66-9ef8-e279e7d85edf"
    },
    {
      "claim_cluster_id": "07fa2c87-6f80-4d1c-a60a-bb0d6e0e303a",
      "event_cluster_id": "f5c9b8a2-ba8a-4c9d-96f7-5fdcef771d06"
    },
    {
      "claim_cluster_id": "b1951710-a9b4-42e8-b9e1-6ca4e5f12a31",
      "event_cluster_id": "044fadd9-8b2a-4a97-a501-b787a29d182f"
    },
    {
      "claim_cluster_id": "0c6c9e5b-f8cc-4939-8319-4baf55259b87",
      "event_cluster_id": "344f18e9-fdfb-4043-b1ff-09516022ac50"
    },
    {
      "claim_cluster_id": "12c3a33b-fd70-46a3-a74c-86b922244369",
      "event_cluster_id": "4b71faa1-0e61-40c5-8cb8-3bb8d0e09fb6"
    },
    {
      "claim_cluster_id": "36d5c8e6-5870-44de-bee8-1ba3638e2785",
      "event_cluster_id": "44663aba-7a2e-4439-ac72-295c1b77f6ca"
    },
    {
      "claim_cluster_id": "957456fe-cb84-4fb9-bc2f-3e775154a824",
      "event_cluster_id": "a74b8cc1-b628-4659-9793-8906816c7cde"
    },
    {
      "claim_cluster_id": "06b8ffc7-c987-44a2-a2cb-8721e54e7da6",
      "event_cluster_id": "9a7cfd6f-8532-4052-b526-1e4576483709"
    },
    {
      "claim_cluster_id": "a83fedfc-0f0a-49b0-9dae-3932f2ba6983",
      "event_cluster_id": "c74eddc6-9017-4628-9942-40823cd7e30e"
    },
    {
      "claim_cluster_id": "8e9b5986-8277-45da-82c2-ab199cd3287f",
      "event_cluster_id": "3cd947fb-d46a-4f38-9705-3c1f8700f549"
    },
    {
      "claim_cluster_id": "cc0b4f6a-9515-47dc-b1fc-eea9be8d97fb",
      "event_cluster_id": "e1f28336-0647-4e38-a5b1-a20d710717c4"
    },
    {
      "claim_cluster_id": "20b239ec-b263-4052-a330-5aad8ed1209b",
      "event_cluster_id": "b558144e-22bc-4f5e-83f4-cf10e626dc01"
    },
    {
      "claim_cluster_id": "ca0d3bae-6f1d-4857-b362-c7e7718bca04",
      "event_cluster_id": "1eec17fb-077b-4de8-a9a2-2c4b4ccfcec3"
    },
    {
      "claim_cluster_id": "fca1885c-50ee-44f0-87aa-917cc35fd733",
      "event_cluster_id": "c77f0d47-36a0-4f9d-86dc-1f10b0aee675"
    },
    {
      "claim_cluster_id": "7b4d9f3b-78aa-4507-8228-424f51cb5289",
      "event_cluster_id": "ea0293f2-f4d0-4ae5-968c-0648ac0ad125"
    },
    {
      "claim_cluster_id": "27f40e5e-f571-4385-aef9-fcc4114989bc",
      "event_cluster_id": "0c6f8f11-1c81-417d-bf01-df519f70e0fa"
    },
    {
      "claim_cluster_id": "d66fbbdf-0d3b-4c16-8077-654078280a83",
      "event_cluster_id": "5c983b2a-2571-47de-87cb-902a1970e0f2"
    },
    {
      "claim_cluster_id": "9352b2a0-83e7-4ffa-ae39-61c24aa700b8",
      "event_cluster_id": "e47c3423-cbb6-4c9a-9b29-21416d12aba7"
    },
    {
      "claim_cluster_id": "210242d8-e5cc-4762-9912-b262084ebeb4",
      "event_cluster_id": "2947fe08-3f19-4a83-826c-8d5e7d1e3368"
    },
    {
      "claim_cluster_id": "9fc7f408-c42c-485e-91c2-a72960ff3158",
      "event_cluster_id": "58d2f307-4ee3-44ad-a765-c7a292798624"
    },
    {
      "claim_cluster_id": "7cff4302-4ea6-4196-96e5-448a227d2f09",
      "event_cluster_id": "09414a95-a2b4-4ce4-a1a3-6b7980ec2cb5"
    },
    {
      "claim_cluster_id": "7f1f819a-52dd-40cc-92a1-28526195605d",
      "event_cluster_id": "0fa8aef0-deff-4ac5-a935-94011ed8be80"
    },
    {
      "claim_cluster_id": "3d1eca97-f0cc-4fa8-9ff8-7ec9ee2b27e4",
      "event_cluster_id": "77810a86-21b7-4267-8df5-dbf7f241aa35"
    },
    {
      "claim_cluster_id": "5edd935c-f1a4-4a6b-86a0-37894c0716f8",
      "event_cluster_id": "3f6252b1-52a5-4e4b-a596-99c6a237551b"
    },
    {
      "claim_cluster_id": "04fa98cf-7cbb-4ec9-b84f-6d1c0570075e",
      "event_cluster_id": "3d7cf308-ff2c-4ac9-a835-6773cc669257"
    },
    {
      "claim_cluster_id": "666873ec-e76e-4f8a-8d96-7a31c5084ac4",
      "event_cluster_id": "6fa6425c-c799-413f-9698-b7928b5c5770"
    },
    {
      "claim_cluster_id": "d00bd384-4d89-4a56-8487-c419c52438e5",
      "event_cluster_id": "128ade3d-bda4-4b71-b956-463eb584089c"
    },
    {
      "claim_cluster_id": "42b71be4-55d8-4880-8083-4a89c8557de9",
      "event_cluster_id": "57c95e6d-bb6f-4da0-b18e-99b9d5c69c0c"
    },
    {
      "claim_cluster_id": "76a80e87-389e-4e6e-9595-1b220839fd20",
      "event_cluster_id": "fc5c504b-230e-408e-a170-afd09cbd04d4"
    },
    {
      "claim_cluster_id": "4feed713-e2b7-4de9-a6e7-cb0e0ca52183",
      "event_cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5"
    },
    {
      "claim_cluster_id": "15516ad5-b153-4147-8246-ecae0ddbf175",
      "event_cluster_id": "31c69d86-6651-4ebe-ab2e-087bf7193e24"
    },
    {
      "claim_cluster_id": "4a91c427-d613-4080-adab-a06fc13d13ac",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "63a98b92-1b5c-46a7-aee1-7e52dd3a8fa7",
      "event_cluster_id": "bfefe16b-a245-4367-989a-c541df49bc59"
    },
    {
      "claim_cluster_id": "f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab",
      "event_cluster_id": "ca0d7a2a-b8d2-4968-874b-aa3379e0dafa"
    },
    {
      "claim_cluster_id": "5d30cac5-2629-4bf5-9665-20ae87c1ec22",
      "event_cluster_id": "a2a4403f-1592-434f-a0f9-d248d1684f8d"
    },
    {
      "claim_cluster_id": "152e2cd2-1d15-4787-b90e-76e34ac56ace",
      "event_cluster_id": "99bc4095-29c0-47b3-81af-1811b5d01f5f"
    },
    {
      "claim_cluster_id": "44dc0e24-3f3d-4f0d-a714-abc9a3dbd30b",
      "event_cluster_id": "b9cc9dc2-9dcc-4730-b5fd-d7d5a7f9e126"
    },
    {
      "claim_cluster_id": "c83250c9-87a2-4ec5-822a-e2413ca91c91",
      "event_cluster_id": "1a416b07-503e-4fc8-8b1f-de51772ab7ee"
    },
    {
      "claim_cluster_id": "510b63b0-aea2-446d-8868-5c88431cc9fe",
      "event_cluster_id": "6ce879b9-5872-4b84-9034-d22bedf950a0"
    },
    {
      "claim_cluster_id": "ed1ca8c0-7841-4109-ada2-99053838abfe",
      "event_cluster_id": "54276cd3-4620-48dd-898d-2aae66e353c4"
    },
    {
      "claim_cluster_id": "be44c17b-cb3f-4a06-af5b-de816dfb4f56",
      "event_cluster_id": "d48087d5-c16e-458f-9f3a-c0c434d8a01c"
    },
    {
      "claim_cluster_id": "7742ec5a-27ab-42d2-9779-df7d73a0cec4",
      "event_cluster_id": "128ade3d-bda4-4b71-b956-463eb584089c"
    },
    {
      "claim_cluster_id": "c3f83d4c-9f83-4fe3-befa-1e9b93dee510",
      "event_cluster_id": "49b2d0f6-e7d1-4326-9bb2-ec42779a8e4a"
    },
    {
      "claim_cluster_id": "ac35f635-837f-429d-a888-0720cf376532",
      "event_cluster_id": "8c65cc84-ce1a-4345-89d7-20ee4e2bcf15"
    },
    {
      "claim_cluster_id": "5d2ff6eb-cad6-467b-869b-d4782bae2371",
      "event_cluster_id": "c5169cd7-a9a1-476b-8658-0fe7fd1f0d44"
    },
    {
      "claim_cluster_id": "29149f19-2cff-4344-bb10-8e0506dbc049",
      "event_cluster_id": "8a4a4131-add5-4367-8ccd-215684fa73dc"
    },
    {
      "claim_cluster_id": "734aba7a-e1ac-4a78-a926-3957017f7843",
      "event_cluster_id": "4f2403b6-f02f-46f5-a51a-edcea5995adb"
    },
    {
      "claim_cluster_id": "3d2576b2-1572-432b-98fe-db8e768274d5",
      "event_cluster_id": "dfebeea4-e8fe-4891-915f-29504d1d80da"
    },
    {
      "claim_cluster_id": "869cd99e-564a-4420-981f-b385e7b7bceb",
      "event_cluster_id": "16e3503e-05e1-4d3f-9a7c-01b21a85311a"
    },
    {
      "claim_cluster_id": "84019696-e95b-4f09-b37b-dd61ce673e9c",
      "event_cluster_id": "2032d3f2-f2a7-4cd8-9f0f-0fb6fbfe2fc9"
    },
    {
      "claim_cluster_id": "b6f111d6-8112-47dc-baeb-43c77c6392ea",
      "event_cluster_id": "1379aa81-833f-453a-8fb7-08ae39840196"
    },
    {
      "claim_cluster_id": "818b32ce-b83e-40a4-b06b-dd4e2c09af00",
      "event_cluster_id": "bca53d12-fc37-4cd1-9c2a-d9e494bc9ea8"
    },
    {
      "claim_cluster_id": "adcb219f-1d0a-4b1b-924d-ded66e2d2c1c",
      "event_cluster_id": "66034097-f5ff-415b-b7cc-7775692bf89e"
    },
    {
      "claim_cluster_id": "da4bd748-3c84-4017-a93a-8247224fc32f",
      "event_cluster_id": "cebd1d98-7547-4761-a012-89e58bf86f29"
    },
    {
      "claim_cluster_id": "bfd3bb04-3c5a-410a-b26b-81f569186264",
      "event_cluster_id": "fae4a05b-8c8a-4da0-ae56-97672bb4bbb7"
    },
    {
      "claim_cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "event_cluster_id": "2d87e550-62a5-4ab5-8323-4c18213fedcd"
    },
    {
      "claim_cluster_id": "6103c4f7-8bea-436e-90d7-0ed75fe275c5",
      "event_cluster_id": "0e1517ba-8541-4c30-8eb8-cab31577fd7c"
    },
    {
      "claim_cluster_id": "df5b4e50-7d1b-4d7e-ae01-046530298250",
      "event_cluster_id": "f8d1571f-9c56-4682-8574-cd3b32ed6cc6"
    },
    {
      "claim_cluster_id": "2adce5ae-1669-4c77-b898-ed9abf7276da",
      "event_cluster_id": "cb26f67e-804c-4c0f-8dea-81103afdf8ce"
    },
    {
      "claim_cluster_id": "bcfb33c7-5d6f-4ac3-8bf2-12b8b332bf75",
      "event_cluster_id": "4ea6057d-751f-45d1-801b-72130ecef337"
    },
    {
      "claim_cluster_id": "dcf2ee53-8023-43ee-94fe-0207a7fb5133",
      "event_cluster_id": "fddafbe9-dffd-4341-9619-bfc6fc256b34"
    },
    {
      "claim_cluster_id": "20b239ec-b263-4052-a330-5aad8ed1209b",
      "event_cluster_id": "cd8e42cd-c833-432a-b12d-6040bca4f918"
    },
    {
      "claim_cluster_id": "e31510b5-776d-40cf-9a10-afb0bb1a3f0b",
      "event_cluster_id": "84ba9e08-7f87-4e91-abf6-4415ddb9a231"
    },
    {
      "claim_cluster_id": "66914632-689c-4d05-b834-b8904eae50cd",
      "event_cluster_id": "0dcdf569-6e39-4d48-a8aa-2b6e3c34a3d5"
    },
    {
      "claim_cluster_id": "109acea7-1d98-4f39-a38c-6bb5919965c9",
      "event_cluster_id": "967e4599-c3e1-4e81-bc7f-40bf2be021b8"
    },
    {
      "claim_cluster_id": "f2b2e8c7-6437-43ee-a47e-1c3a44cd6c34",
      "event_cluster_id": "a67a8b34-7ebc-467d-82f6-99ed35126409"
    },
    {
      "claim_cluster_id": "0aa10a76-1680-4566-9d3a-ebaa3e486aaa",
      "event_cluster_id": "2aa6b6de-5e53-433f-9477-ca28d007cfea"
    },
    {
      "claim_cluster_id": "dfcf5731-89c0-4af2-a475-d7087b733644",
      "event_cluster_id": "e73cd951-c537-451f-a279-08d6827059e5"
    },
    {
      "claim_cluster_id": "b98bb0fa-4594-47af-9069-f482aaa8d7c4",
      "event_cluster_id": "4b5e2cb0-217a-4cdc-81e2-027874f8da18"
    },
    {
      "claim_cluster_id": "f6f15ea6-27bd-499b-a6fe-74d144b5ac0b",
      "event_cluster_id": "f5b9ae68-f130-44e1-85ad-1d8a741fcea1"
    },
    {
      "claim_cluster_id": "c198c115-5575-4cd0-82cc-408f1b46a7a2",
      "event_cluster_id": "abe48ef5-28d3-473b-b5c1-22f7c985121d"
    },
    {
      "claim_cluster_id": "35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60",
      "event_cluster_id": "d020ba2c-1e1a-4bee-8860-bc381620b119"
    },
    {
      "claim_cluster_id": "7ac1c88c-d620-4c32-9f9d-5a780231627e",
      "event_cluster_id": "4f70f4f5-9340-4c71-bf68-5b20071ff5b8"
    },
    {
      "claim_cluster_id": "6e7164cb-9f1b-4f72-aef4-13243fbf321c",
      "event_cluster_id": "17aac7a0-8d3b-4164-8981-530ac6354022"
    },
    {
      "claim_cluster_id": "af183b48-72bf-4947-8e38-5272b737f76b",
      "event_cluster_id": "13bc9125-818a-4eff-a1c9-96bf89586d78"
    },
    {
      "claim_cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
      "event_cluster_id": "086034d9-cc70-4cb5-b461-137099358741"
    },
    {
      "claim_cluster_id": "a789dff6-b07a-42f9-812b-05be84eb01d1",
      "event_cluster_id": "ce789309-8080-466e-a3b3-2975047285af"
    },
    {
      "claim_cluster_id": "b686bd17-fb36-4b7b-9caf-084f8d91c149",
      "event_cluster_id": "1bbcbe31-d9c2-415e-aa16-c9d78fd6946a"
    },
    {
      "claim_cluster_id": "c66251b2-ab53-4ca9-91b8-4229e4242200",
      "event_cluster_id": "add21509-fc05-4fe6-a953-c98cc222477e"
    },
    {
      "claim_cluster_id": "9b129e4b-0540-473c-90ae-ff21e622eb3c",
      "event_cluster_id": "c6d45751-df96-42cb-a762-00ec73441fe2"
    },
    {
      "claim_cluster_id": "81174c72-fc84-4203-8dcb-b1068c7bd254",
      "event_cluster_id": "8d628785-9843-475a-bf8c-f7eff1bc8e38"
    },
    {
      "claim_cluster_id": "05302999-a145-4cb2-83a6-b2cda0247938",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "c21b5cff-dd9b-418d-82f4-ad5049c002d9",
      "event_cluster_id": "a63f5d9a-cff2-4275-97b2-48d300df1ba7"
    },
    {
      "claim_cluster_id": "a3dda742-6a6a-4de7-ad48-8075110e3b35",
      "event_cluster_id": "5c60b7c2-773f-4fa5-90cf-1511916b711a"
    },
    {
      "claim_cluster_id": "c5ae1de6-d99b-4163-b6d2-69f5a4a22e4e",
      "event_cluster_id": "4ae526b6-129a-4522-b79c-5fa5e53d2329"
    },
    {
      "claim_cluster_id": "6b12e24b-6d9d-4b0e-a169-260972b9ab69",
      "event_cluster_id": "b76141ff-47b5-4e35-911a-5ea99a13c31e"
    },
    {
      "claim_cluster_id": "9fc65438-2baa-4ecf-a802-ddd71c4ed907",
      "event_cluster_id": "5bde126a-9b98-4602-8531-f11f0ccfd92e"
    },
    {
      "claim_cluster_id": "2ac509be-786d-4ed0-abcc-15ecf7e6c4ff",
      "event_cluster_id": "d748d1bd-38e3-44b3-b268-429f4615acee"
    },
    {
      "claim_cluster_id": "7cff4302-4ea6-4196-96e5-448a227d2f09",
      "event_cluster_id": "58160b77-275a-49fd-b4ad-b9a4e0aa40ef"
    },
    {
      "claim_cluster_id": "5a8c09d4-337f-442b-8464-f2be567010bf",
      "event_cluster_id": "2d8f3813-2525-407f-8769-b0281d589d42"
    },
    {
      "claim_cluster_id": "e2f88c16-103f-497d-a88a-e63349d63a62",
      "event_cluster_id": "7c8877ae-f397-490e-9778-67a6e91ebe1c"
    },
    {
      "claim_cluster_id": "b1827766-8909-4c0a-8a55-23a0b5e81d4e",
      "event_cluster_id": "02ee18ae-cb4c-43b0-8eeb-127e5d8f1ac9"
    },
    {
      "claim_cluster_id": "c2c441c7-f2bd-4b4f-baf1-ba82eaa0b970",
      "event_cluster_id": "bfddf849-1008-4d2d-bfce-830b42f8a421"
    },
    {
      "claim_cluster_id": "ce0417d2-5817-45d3-a01f-447b8d6d19ff",
      "event_cluster_id": "21360818-47b1-476a-88aa-682feb18a966"
    },
    {
      "claim_cluster_id": "e7a774aa-82c9-41a0-9af6-f4f143016a1f",
      "event_cluster_id": "13765e0a-ad43-430b-8852-bfa85832f876"
    },
    {
      "claim_cluster_id": "b2a7204e-e5ad-4d5f-8464-67520217c392",
      "event_cluster_id": "7261d8c0-d619-4bef-bf36-5ab83467a9cd"
    },
    {
      "claim_cluster_id": "31d339ae-2342-44f9-a909-e299d2c4eccd",
      "event_cluster_id": "0b719ed0-60f8-42bb-9426-ff2a477557b7"
    },
    {
      "claim_cluster_id": "f8755b86-ae98-461e-a3ac-2bd5b6ec4310",
      "event_cluster_id": "e71c3cd6-157e-4870-8807-668962f49dc4"
    },
    {
      "claim_cluster_id": "0f9ce830-116e-4bca-9110-b7d8c9c20025",
      "event_cluster_id": "9cb96178-90d1-49cc-8907-eb63419e86be"
    },
    {
      "claim_cluster_id": "99f11e8b-4375-4ee6-8be9-78b8355c6e63",
      "event_cluster_id": "314e86f6-17d6-477f-8886-75643cc5dcde"
    },
    {
      "claim_cluster_id": "d42df985-9fff-4c49-bac2-4cb2fef7ac9d",
      "event_cluster_id": "5530b92f-dd56-42af-8c16-6aabb4ffa553"
    },
    {
      "claim_cluster_id": "c572351c-d373-4e8c-a918-68e53e31b822",
      "event_cluster_id": "3b11f37a-b3dd-481f-b924-f2c0105eea68"
    },
    {
      "claim_cluster_id": "bd13c9c1-afe0-4a04-acc3-453f611b1f14",
      "event_cluster_id": "8a312b2a-4e43-4814-85a4-51669e80ab52"
    },
    {
      "claim_cluster_id": "b3d00803-b5be-4264-bbda-b09db5ed3a9b",
      "event_cluster_id": "6b078586-a71f-43ea-9363-faa3caa5fe58"
    },
    {
      "claim_cluster_id": "89aabd59-2b1d-4122-9c03-b5ffeee5a650",
      "event_cluster_id": "164a85e9-df51-43f2-948d-bd9852808931"
    },
    {
      "claim_cluster_id": "a83fedfc-0f0a-49b0-9dae-3932f2ba6983",
      "event_cluster_id": "a24aba28-4a37-469a-9d41-dfd554a4594a"
    },
    {
      "claim_cluster_id": "25a85f3d-1037-40c8-8b96-32b80bedc5b2",
      "event_cluster_id": "3f7e49c1-3bca-42b1-a2c6-b96fb1443ba2"
    },
    {
      "claim_cluster_id": "6442657f-3626-4ac3-8a02-28b3c72e00ba",
      "event_cluster_id": "7860ac7c-a8a6-4b0d-8952-927a859be338"
    },
    {
      "claim_cluster_id": "29f9cc11-a80b-4066-9284-acd0b0746933",
      "event_cluster_id": "58a5d45d-929c-4882-97bc-6346fc773e3e"
    },
    {
      "claim_cluster_id": "99df608a-defa-4cea-b8ef-86519fa0e08a",
      "event_cluster_id": "18fb4791-02de-4e42-aeab-ba0112d12563"
    },
    {
      "claim_cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
      "event_cluster_id": "b6224aea-5841-4609-ba8b-ccc207ec597f"
    },
    {
      "claim_cluster_id": "a98eba10-9612-466e-bbba-6161ced90ab9",
      "event_cluster_id": "c7ff0720-041e-4548-8592-cfa24a2712c7"
    },
    {
      "claim_cluster_id": "5677f10d-93dc-4b72-b95a-8bc4291ec487",
      "event_cluster_id": "fdb454eb-b6d8-4e69-94d9-d465733df395"
    },
    {
      "claim_cluster_id": "0f1cacf9-3df0-4d00-8952-b3fa5195f1fb",
      "event_cluster_id": "42322612-a5c4-4a48-abca-12e69bf326a1"
    },
    {
      "claim_cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
      "event_cluster_id": "4b93a421-107c-4185-912b-a73d039895b4"
    },
    {
      "claim_cluster_id": "be467aaa-b350-4a63-875e-7aa61c3d868a",
      "event_cluster_id": "73a3ba73-472c-4953-bc98-ef9a9d43fb52"
    },
    {
      "claim_cluster_id": "2972b17d-9533-46fe-a896-a36d50916446",
      "event_cluster_id": "4f2403b6-f02f-46f5-a51a-edcea5995adb"
    },
    {
      "claim_cluster_id": "ddf6dff1-95bb-49d1-93d2-18eeac6d22bc",
      "event_cluster_id": "6d63d484-2e34-41a3-8d3d-7c1693933482"
    },
    {
      "claim_cluster_id": "6a4e66c3-1fd2-46be-9e31-fecdcd545826",
      "event_cluster_id": "cd8525ab-90a4-434a-bf10-f887240219f2"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "f54e9fc4-9854-41c6-aa04-dba66f36cc19"
    },
    {
      "claim_cluster_id": "984e2a37-4883-4da4-8899-a3cc19bba978",
      "event_cluster_id": "626701fe-ae3d-403d-9681-7d335f03c82a"
    },
    {
      "claim_cluster_id": "18f586c2-7862-4f1e-9fbe-94bf4981c3c4",
      "event_cluster_id": "fe4e513d-3365-4bb1-b29c-ae02d053a2e1"
    },
    {
      "claim_cluster_id": "24daffdf-e642-42fa-ac82-39c90e12f420",
      "event_cluster_id": "244850ce-669b-481d-b002-ad90cb2a1ad2"
    },
    {
      "claim_cluster_id": "a84f79d2-3818-45bb-9cd9-eb739e78bee2",
      "event_cluster_id": "da3e8993-13d7-42de-887c-a22169a3cf16"
    },
    {
      "claim_cluster_id": "fbdddb76-bee9-4e1c-9f2e-03126700cbd1",
      "event_cluster_id": "c20e1db7-e918-4c20-9b2a-23168ba5d1b5"
    },
    {
      "claim_cluster_id": "38146e96-2791-4b11-ad91-87648834294e",
      "event_cluster_id": "1a1de2a4-159f-4a0d-8a46-97165bf27583"
    },
    {
      "claim_cluster_id": "1da96a0b-d833-4078-afdc-5a85d522b86d",
      "event_cluster_id": "7e3014ad-3100-4bc7-8edd-4e32af49ff75"
    },
    {
      "claim_cluster_id": "3444a924-096b-4eda-877c-4c6412d885cd",
      "event_cluster_id": "ec3b133b-630e-4f2b-834a-c8cbcc0a0e64"
    },
    {
      "claim_cluster_id": "369b1cc5-aae5-4361-aabf-b1ef5c5350f8",
      "event_cluster_id": "151926b8-a45a-4f2f-9fc4-2a654d1c3ebc"
    },
    {
      "claim_cluster_id": "984e2a37-4883-4da4-8899-a3cc19bba978",
      "event_cluster_id": "ade1903f-a52a-4bb6-9a56-0c62e47b69bb"
    },
    {
      "claim_cluster_id": "58cd12d0-b190-4e1f-826a-20e181a5c137",
      "event_cluster_id": "4ff57c09-958e-4a30-b35f-893da7a68a0a"
    },
    {
      "claim_cluster_id": "24daffdf-e642-42fa-ac82-39c90e12f420",
      "event_cluster_id": "ee3497a5-19ab-4376-a948-4abe0f0d9b83"
    },
    {
      "claim_cluster_id": "004d8db2-6d73-4ac4-955b-6d04e88a0716",
      "event_cluster_id": "d13901ad-61f1-4fb1-ba52-f79a1d3671b7"
    },
    {
      "claim_cluster_id": "9ee9fc47-27b6-4828-a30b-bd52c92ccfae",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "d42df985-9fff-4c49-bac2-4cb2fef7ac9d",
      "event_cluster_id": "c6d9c90d-92a1-44da-a5cd-12164b95f4d8"
    },
    {
      "claim_cluster_id": "51f92102-4c83-4bf3-8e2d-cf88f9368a7f",
      "event_cluster_id": "af0e1c10-c1e8-4d6e-955d-02d943d24f8d"
    },
    {
      "claim_cluster_id": "9ee9fc47-27b6-4828-a30b-bd52c92ccfae",
      "event_cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"
    },
    {
      "claim_cluster_id": "ddf6dff1-95bb-49d1-93d2-18eeac6d22bc",
      "event_cluster_id": "6f13f345-1f63-46f8-86e1-7e1ec801fbcc"
    },
    {
      "claim_cluster_id": "af562818-5594-417a-b606-add10573c2db",
      "event_cluster_id": "323f50ac-8539-481b-b9dd-0528780df63d"
    },
    {
      "claim_cluster_id": "363f13f4-3f3c-4a28-a39a-e89279a7c9ad",
      "event_cluster_id": "5bee647b-e5d6-4ab0-b317-a48d3ac0cc11"
    },
    {
      "claim_cluster_id": "58c4dc89-fa0e-45c9-8892-01fb55da5607",
      "event_cluster_id": "465883de-cd6a-47dc-b0f3-f22e0ff902ba"
    },
    {
      "claim_cluster_id": "df895ffb-5333-4b2a-9ce5-f1108a894c34",
      "event_cluster_id": "67cff5df-1bcb-4edc-af42-99ff9df792c5"
    },
    {
      "claim_cluster_id": "44f7e426-bb87-4dd0-bf0c-80fb71c61eac",
      "event_cluster_id": "b6807769-e83f-4f7f-b7a3-1a4b782749ea"
    },
    {
      "claim_cluster_id": "51eec710-c7a6-436a-b700-e76c7c02bc82",
      "event_cluster_id": "eac07e3f-8adb-430d-96eb-dece778680b6"
    },
    {
      "claim_cluster_id": "840a2e45-449a-4234-be31-852cc48c1642",
      "event_cluster_id": "418909cf-6842-4d61-99c3-ee63c7926d9b"
    },
    {
      "claim_cluster_id": "35d18d7f-0f7d-4654-8e65-f6b4bcac032a",
      "event_cluster_id": "4b93a421-107c-4185-912b-a73d039895b4"
    },
    {
      "claim_cluster_id": "623ab1ae-1f19-46fc-b19b-929f64c7b525",
      "event_cluster_id": "358c0eb2-869f-46fb-bab5-4fbe8881d4e8"
    },
    {
      "claim_cluster_id": "6abe1bb1-d30a-40e6-8fb2-f7c5a02ae16a",
      "event_cluster_id": "5970978a-16bb-49ab-af47-a2c975a2cb17"
    },
    {
      "claim_cluster_id": "f83f6c15-13c0-41a8-b991-8abeda0466c4",
      "event_cluster_id": "38e3f6d2-565c-42d3-b90a-be4665a0d1bc"
    },
    {
      "claim_cluster_id": "c2c441c7-f2bd-4b4f-baf1-ba82eaa0b970",
      "event_cluster_id": "989dfd54-88d2-416d-a172-4c7b7a520121"
    },
    {
      "claim_cluster_id": "391ac4c5-638b-42bc-b8d7-1972d56df43e",
      "event_cluster_id": "08168b1f-73c6-4a8d-80e5-08594ac2f44e"
    },
    {
      "claim_cluster_id": "346f630a-2d46-4e8a-80ef-67a96ebf81ef",
      "event_cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993"
    },
    {
      "claim_cluster_id": "c782b8c2-e8a6-49c0-98b9-40619e415dcd",
      "event_cluster_id": "d769b36d-aea1-4403-834b-b416d2db1047"
    },
    {
      "claim_cluster_id": "b93f59d3-e54a-4700-86ef-b20c995b73b6",
      "event_cluster_id": "6511d484-25a2-4b72-9c08-df0d1ad4f8b5"
    },
    {
      "claim_cluster_id": "17224e3f-1dd8-4970-a1c1-0cff20d6f438",
      "event_cluster_id": "540c45cf-a148-4629-8716-b1631ea44e45"
    },
    {
      "claim_cluster_id": "a7043201-daf7-4ddc-86e1-fe3a850942e2",
      "event_cluster_id": "27494d31-7904-40f7-8554-6f6c04a0e92b"
    },
    {
      "claim_cluster_id": "62ddd106-9df1-47e7-9e5a-9c12a19f488c",
      "event_cluster_id": "c1501799-71e8-405f-bf26-2801ae66dcf6"
    },
    {
      "claim_cluster_id": "32a2eefa-c8c7-482c-839f-be3b15138d40",
      "event_cluster_id": "83c177c0-ee20-4679-ad20-0c32e24ff101"
    },
    {
      "claim_cluster_id": "55a53a4b-b30c-483d-9f7b-8c999d5c2f62",
      "event_cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5"
    },
    {
      "claim_cluster_id": "26461fc6-994b-44dd-97c8-95b6341a4a6a",
      "event_cluster_id": "27a6bdbf-c139-4b94-baa7-3715f52da9db"
    },
    {
      "claim_cluster_id": "ab1f8fac-3632-4188-90ae-a2c911b8425d",
      "event_cluster_id": "5a9d340b-259a-49d7-894d-4e9c6dec6a07"
    },
    {
      "claim_cluster_id": "59d689c2-02ce-4e0f-83b7-9747d98bb8fb",
      "event_cluster_id": "921fce8d-f4e2-4dbe-b940-66b148c09f17"
    },
    {
      "claim_cluster_id": "7ebece62-a589-49b3-b28f-b8f565ab7327",
      "event_cluster_id": "228f2026-3094-45be-9c29-b363d30f00b6"
    },
    {
      "claim_cluster_id": "f04728cc-e827-402c-9a97-187311920a0c",
      "event_cluster_id": "fd0c3806-b445-4899-9ddd-fa029d0bc38e"
    },
    {
      "claim_cluster_id": "b8299ae1-9e2e-465d-af82-b9354f3e9c44",
      "event_cluster_id": "4ce3dea7-0e2a-40e4-9e4a-2c61943d61e2"
    },
    {
      "claim_cluster_id": "18f586c2-7862-4f1e-9fbe-94bf4981c3c4",
      "event_cluster_id": "47b5e189-9eaf-4e69-b28f-1f2681036c7f"
    },
    {
      "claim_cluster_id": "26852476-f26f-4f97-92bf-7cc2d9373f4e",
      "event_cluster_id": "8dafb957-e3d4-421d-a897-aa9e9def3c15"
    },
    {
      "claim_cluster_id": "e416c5ec-262b-4531-adef-7197fba310f0",
      "event_cluster_id": "39e358aa-4f67-47f5-a3b2-dea997ca44d0"
    },
    {
      "claim_cluster_id": "6a2ad136-bcb6-47c4-8c1f-40e9c58978da",
      "event_cluster_id": "efbd6030-d54d-4409-900a-396adc8a9b7e"
    },
    {
      "claim_cluster_id": "ff92e2cd-b51d-4aba-9214-602e53d602c6",
      "event_cluster_id": "5bae13a5-6b81-425d-a9bb-49850203205e"
    },
    {
      "claim_cluster_id": "363f13f4-3f3c-4a28-a39a-e89279a7c9ad",
      "event_cluster_id": "2ca744d4-a598-4453-abb6-08ac069370e3"
    },
    {
      "claim_cluster_id": "9be076b9-65b6-4c8e-b3d7-1df3c547c0fc",
      "event_cluster_id": "f0e4e625-f14f-486a-a02f-d6cf2c5a6b4f"
    },
    {
      "claim_cluster_id": "d935874a-c33c-4b74-9137-99d8fd9fc1f8",
      "event_cluster_id": "1faa9d4d-1b1c-4e6c-9fd5-22f9b057a61b"
    },
    {
      "claim_cluster_id": "5aad8736-b18a-4e21-930e-320f4faaed1c",
      "event_cluster_id": "48eb1f9d-0125-4436-9ad0-db6bbdc685bf"
    },
    {
      "claim_cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "event_cluster_id": "0450eb4e-f8b9-4b39-9c27-c75e30610c21"
    },
    {
      "claim_cluster_id": "199eabc9-e7b3-44cb-a574-bbc02ea956e5",
      "event_cluster_id": "f71cbd0f-7a85-414d-845f-e4694c67d02e"
    },
    {
      "claim_cluster_id": "db7cc474-d6ec-47a2-b50b-7ed4c500c50a",
      "event_cluster_id": "b29c3ed7-bdfb-48eb-87a7-3e6d5f2cf585"
    },
    {
      "claim_cluster_id": "3b1f0ed9-3201-46c5-93e3-016f26c4d261",
      "event_cluster_id": "d0dc34ca-6f25-427d-a56e-1d4f3210e605"
    },
    {
      "claim_cluster_id": "31bf6722-ac5c-4597-8c42-50efe5c5aceb",
      "event_cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993"
    },
    {
      "claim_cluster_id": "2ed3c98f-2c08-4da6-97f9-38e8a951f08e",
      "event_cluster_id": "35e5848e-7f2d-49f3-b00e-f1ac80fdf555"
    },
    {
      "claim_cluster_id": "673d8d19-d059-4065-9b0d-82b1376c6c55",
      "event_cluster_id": "3dba838d-2eca-4f65-941b-d8fa64a15014"
    },
    {
      "claim_cluster_id": "f7811e36-516c-4780-b025-c2c198f87bba",
      "event_cluster_id": "debb5df0-b239-4824-9667-dfdfbc4323cd"
    },
    {
      "claim_cluster_id": "93fddae5-a739-409c-a087-9a562d010a0e",
      "event_cluster_id": "b95f4f5f-4d51-43a4-8c27-5ed3609dc286"
    },
    {
      "claim_cluster_id": "0d0fd5f0-0301-424f-b0b1-a60ab6ca045f",
      "event_cluster_id": "b93f0980-3e05-4353-b9af-768e6f562f26"
    },
    {
      "claim_cluster_id": "e3a511f9-2169-4202-9c42-1e7416ce517d",
      "event_cluster_id": "8179c546-cd47-4baf-897a-a15a8afbb9e6"
    },
    {
      "claim_cluster_id": "74ac8dc6-1d9b-435b-bae9-36745f271604",
      "event_cluster_id": "d32f3312-d003-4447-b89b-9a6dbdae0450"
    },
    {
      "claim_cluster_id": "8610b5a0-f4b4-403e-94e5-57543da5eb32",
      "event_cluster_id": "49bf0c40-75dc-453d-aa4a-9a6c01b9dda1"
    },
    {
      "claim_cluster_id": "76bc71d7-2c17-42b9-974c-d517911bab56",
      "event_cluster_id": "d0ed171a-d118-47d4-ad40-05768ad6c3f9"
    },
    {
      "claim_cluster_id": "8a3175b7-b295-45aa-8bbc-c3d6d75486fa",
      "event_cluster_id": "4c5edc98-f936-4e09-a25f-11ad3a0a3ce0"
    },
    {
      "claim_cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "event_cluster_id": "836422b4-fd08-4384-b536-467195ee18cb"
    },
    {
      "claim_cluster_id": "ed3519a5-2328-44c8-be3b-f36796b25965",
      "event_cluster_id": "3a31c97f-6174-468b-bab1-90d8acc21560"
    },
    {
      "claim_cluster_id": "04fd43b1-9ee7-43b3-b1fc-e9fca576658d",
      "event_cluster_id": "391672fd-aef8-4243-932a-77e726662902"
    },
    {
      "claim_cluster_id": "a74a2d72-1d86-4264-9389-b4fe594a7218",
      "event_cluster_id": "e7164e50-d6db-4c47-8686-c55d8dcb20f7"
    },
    {
      "claim_cluster_id": "2d998acd-2150-418c-b2e7-db6c334526be",
      "event_cluster_id": "a3cbf831-a6f7-4981-a61a-3f2e1d67806a"
    },
    {
      "claim_cluster_id": "7a8e190a-4532-4e4a-b5bb-60a049f869c1",
      "event_cluster_id": "b2ed7816-e1d7-4d6f-8594-001922474b2c"
    },
    {
      "claim_cluster_id": "fc45a344-4cfc-4865-9030-d033f0c8dff3",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "5518570b-ceeb-400e-8720-a531292d57ce",
      "event_cluster_id": "7cee2601-5005-4b9d-948b-2e69bb408fa6"
    },
    {
      "claim_cluster_id": "db268f9a-c3a8-4e79-a3b0-df934c32f645",
      "event_cluster_id": "ff3032ee-a77e-4fe7-a5a1-205c35f0948e"
    },
    {
      "claim_cluster_id": "d71b34b2-fb3e-4ce8-8b20-4e5bd486e9ce",
      "event_cluster_id": "444282c8-5a59-483a-aa4f-acbf1655f118"
    },
    {
      "claim_cluster_id": "6103c4f7-8bea-436e-90d7-0ed75fe275c5",
      "event_cluster_id": "1e79f665-5f29-410f-a52e-7981ca5d8478"
    },
    {
      "claim_cluster_id": "601320a2-3fca-41ef-9387-a64a4c0b5cee",
      "event_cluster_id": "6195dc7b-895b-4134-9995-738fed6389e2"
    },
    {
      "claim_cluster_id": "c6a49139-3f4b-48cf-8d38-e5b344108df3",
      "event_cluster_id": "ac8a01c8-dc87-4d9e-80a6-4614b1d6d5e6"
    },
    {
      "claim_cluster_id": "859c814e-e7af-4708-a58a-9f1f6973974f",
      "event_cluster_id": "7707109b-cc58-416a-9a9e-b9207b14baa6"
    },
    {
      "claim_cluster_id": "53df1164-9fc1-49f7-bdf4-7db4b3b7ec7c",
      "event_cluster_id": "50312364-9e82-4970-9daa-1275d0caaa37"
    },
    {
      "claim_cluster_id": "6f7b1c88-304f-4cf4-ba94-d6268fa5ae40",
      "event_cluster_id": "b7659926-8b67-4333-bd9e-74433a7b83a8"
    },
    {
      "claim_cluster_id": "cd099a56-0545-43d7-bbda-54857a323642",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "e633b9f2-d6c2-4c51-83af-0aed2e577009",
      "event_cluster_id": "a9463f3d-e047-45f9-b0f1-8dca29a15e51"
    },
    {
      "claim_cluster_id": "5d65069d-5cc8-4da8-8b8d-bbd1528688e7",
      "event_cluster_id": "bf3cbbb2-0711-45ee-a625-a3ccf159845b"
    },
    {
      "claim_cluster_id": "78cbe3d8-37f7-4a89-956e-f6dab20ad8d1",
      "event_cluster_id": "058f52a9-8a35-4f4c-823b-efe94ad1ee22"
    },
    {
      "claim_cluster_id": "d392695f-75b7-4bbc-a991-2b3edbf01567",
      "event_cluster_id": "75e6960d-da7a-4d2f-8605-a94c9d2036f7"
    },
    {
      "claim_cluster_id": "cd099a56-0545-43d7-bbda-54857a323642",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "97fd88d2-827f-418a-aa85-784dc98e83f5",
      "event_cluster_id": "88b529dd-6a84-4eea-a385-80a5f7c68b68"
    },
    {
      "claim_cluster_id": "52105c27-d937-4970-9bad-c139e21a6205",
      "event_cluster_id": "a28a5ed3-bc11-405d-9242-8b1a5ce91c01"
    },
    {
      "claim_cluster_id": "886176d6-1057-4021-8312-570a3e3f4e10",
      "event_cluster_id": "51ad5e06-f7b5-461b-bde3-00f8284ec903"
    },
    {
      "claim_cluster_id": "185ce1be-2776-4956-849c-f83438c57def",
      "event_cluster_id": "f45f3567-6577-44bd-b711-4eefb24f7df6"
    },
    {
      "claim_cluster_id": "738e60fd-1e3d-4820-98bf-d6bd9e7a3172",
      "event_cluster_id": "35f50160-5841-4836-b319-b5806e73bdd7"
    },
    {
      "claim_cluster_id": "3d647896-bc7f-4815-a99e-768cb2498250",
      "event_cluster_id": "8711a577-7906-443a-8adc-19d760bca08d"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "148cbdc2-efc0-4f16-b29a-724816c7ee5d"
    },
    {
      "claim_cluster_id": "61de2e2b-d2da-472d-882f-2c0c14730fee",
      "event_cluster_id": "6da8eb62-757c-4652-8389-b32015cb40a9"
    },
    {
      "claim_cluster_id": "eb38bdfb-232f-4460-8d60-fc8806237786",
      "event_cluster_id": "ef5b3681-b75b-471a-b383-e605cb2d8a70"
    },
    {
      "claim_cluster_id": "1dc0ed5e-e098-401c-9b18-3dd42ba6b01f",
      "event_cluster_id": "ea812d6b-ff93-45c5-87c2-85077592798a"
    },
    {
      "claim_cluster_id": "45339238-abb3-494b-a7ba-d3cde2ab18d9",
      "event_cluster_id": "3789471e-0775-4ba6-92d1-141ca5051de5"
    },
    {
      "claim_cluster_id": "2996196c-7b75-44d2-aa5b-560b18ce2763",
      "event_cluster_id": "64cf5e07-c73c-4733-9b23-8f12213cc336"
    },
    {
      "claim_cluster_id": "055b1edf-5e4a-4fd8-b913-a9d1df63a85a",
      "event_cluster_id": "13c0f70a-404a-4747-9850-32c93df93caa"
    },
    {
      "claim_cluster_id": "86e5843a-553f-41b4-aec2-73c2638e9bca",
      "event_cluster_id": "2b3c9191-0f03-44e0-8e0e-82a5f8121907"
    },
    {
      "claim_cluster_id": "77b557e0-b37f-4548-adca-2c9da9e04106",
      "event_cluster_id": "f9fcbf4e-cb96-4f3c-bad3-73737cdc4b3c"
    },
    {
      "claim_cluster_id": "8ef65ecd-3750-4a43-89ce-d81b333f2e1c",
      "event_cluster_id": "45d7d6d0-989e-40f5-9e35-4f603b15d08b"
    },
    {
      "claim_cluster_id": "6ac8924b-24d0-446a-8ffc-cf862b415737",
      "event_cluster_id": "57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"
    },
    {
      "claim_cluster_id": "a2a57731-90ff-4a12-a08f-721a9dfc0b06",
      "event_cluster_id": "127eab3b-6cf7-495a-80f3-a2735d4d1bcc"
    },
    {
      "claim_cluster_id": "d9f4e411-98bf-48bc-a372-2ef5b6cd17d9",
      "event_cluster_id": "4f0f5e9d-5d96-4785-be2a-db5660d98439"
    },
    {
      "claim_cluster_id": "0c685bcc-0513-4b5c-8ba7-c302c985ff66",
      "event_cluster_id": "e136ae61-7689-4d72-a14e-2120e6260be2"
    },
    {
      "claim_cluster_id": "aed74a8c-a339-4a19-a144-bb62990f8e50",
      "event_cluster_id": "7ecaa8a7-76e8-4332-a41f-2c347237e2a6"
    },
    {
      "claim_cluster_id": "2bc0b07d-c668-4651-b1c3-1844786b5acb",
      "event_cluster_id": "f44c0680-07c7-4ea0-8054-7643f1b8eafd"
    },
    {
      "claim_cluster_id": "daa86fb1-df31-4a23-a926-1b9981f8df40",
      "event_cluster_id": "ea4d2231-ca8e-420c-8296-8d5576ce43ba"
    },
    {
      "claim_cluster_id": "19d43c44-0b32-47ac-85c1-a05682078f22",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "d1fdd2b8-bcf5-4bcf-83b0-10345f3c68a9",
      "event_cluster_id": "3a6ab8c1-b7af-4dae-9216-d55e6233e2d8"
    },
    {
      "claim_cluster_id": "2c2bd0f0-92f2-446c-bfc2-4cf2ec4f5ece",
      "event_cluster_id": "f4412fc5-966c-440c-829a-8ca0977913f0"
    },
    {
      "claim_cluster_id": "c6541e86-8e1b-4bd0-926a-c380aa103aa6",
      "event_cluster_id": "25a18cdf-150a-41da-b8d4-e997a6088c8a"
    },
    {
      "claim_cluster_id": "6b000975-482c-4a87-97ba-4b7f79318bd6",
      "event_cluster_id": "7f8ccaf9-3143-4e85-8fba-3e95d1568fc9"
    },
    {
      "claim_cluster_id": "186330e2-1680-455d-ad21-27f2e0125a31",
      "event_cluster_id": "5a26984c-e60b-4dac-8536-2c84c78b7c2a"
    },
    {
      "claim_cluster_id": "487393b6-56b8-4c3f-bdb3-88dbd2ac69d5",
      "event_cluster_id": "9f9c5798-7130-4fb5-8328-ae0dad688f2e"
    },
    {
      "claim_cluster_id": "bcfd3520-6b2d-41d7-83ee-cfbd1d569332",
      "event_cluster_id": "8e38f27f-adac-4956-8ff8-f509c611ee94"
    },
    {
      "claim_cluster_id": "7938e6ef-80ff-4f50-b301-1e5bfc0774b3",
      "event_cluster_id": "1f6ddbe7-8535-46e4-9237-74c4562367e1"
    },
    {
      "claim_cluster_id": "f65b5094-1e51-442e-b444-de0d25f1fea0",
      "event_cluster_id": "d98e592a-9240-4307-b377-0c2f380a6db0"
    },
    {
      "claim_cluster_id": "cca76b6b-f388-4f7e-8293-b55584460643",
      "event_cluster_id": "dfbec97c-7720-466c-b25a-2051f356476a"
    },
    {
      "claim_cluster_id": "2fe8d49f-63a1-4171-af68-9824e47b825c",
      "event_cluster_id": "59a61072-395d-4f52-9f54-81f2c2e5b76c"
    },
    {
      "claim_cluster_id": "c55d7e50-ed13-4f98-a396-412d6e19decf",
      "event_cluster_id": "ef0e0cc6-010e-482e-ad0b-63895cd13988"
    },
    {
      "claim_cluster_id": "76cf3691-7d2d-4e3e-a789-a9c5c731de64",
      "event_cluster_id": "9d8cb077-725c-42df-adf9-cc02faf7d3d4"
    },
    {
      "claim_cluster_id": "bf1e5943-1881-4795-9e54-b7177a49b67f",
      "event_cluster_id": "eec253c7-dea4-4bc8-94cd-e84946c84d8f"
    },
    {
      "claim_cluster_id": "20ab2459-a6a0-4e45-aef0-5b2d6b529a0e",
      "event_cluster_id": "7690b51f-82d1-4577-be9d-58b4d7bf11b2"
    },
    {
      "claim_cluster_id": "bbcbfb2f-3902-4f48-8b2d-1caa5e0d948c",
      "event_cluster_id": "016e2f4b-e8bd-4271-a6d5-2bf7dc3d49bc"
    },
    {
      "claim_cluster_id": "f50144fc-3b9b-4e34-ac6c-5191d30445d0",
      "event_cluster_id": "9ee44494-957f-41e5-a680-3bacf709709f"
    },
    {
      "claim_cluster_id": "19581d0c-22b5-4ff0-8a68-de86fb01009c",
      "event_cluster_id": "1e2e215d-02f8-41f2-bb72-8bb5cf8991d4"
    },
    {
      "claim_cluster_id": "f21a34f1-8f4b-45c1-80d1-4a2fc8e55091",
      "event_cluster_id": "cef3ea24-b5a3-4eec-87c9-03935082f43c"
    },
    {
      "claim_cluster_id": "7b83d3ee-13b2-47c1-ab89-4f78258a986b",
      "event_cluster_id": "876dc47c-c65a-4a65-a882-eeeb837080aa"
    },
    {
      "claim_cluster_id": "b471f42f-4da7-4b5a-a11e-18deef221da8",
      "event_cluster_id": "a4d91f10-cd48-4917-90ab-b14ea36168d9"
    },
    {
      "claim_cluster_id": "77b557e0-b37f-4548-adca-2c9da9e04106",
      "event_cluster_id": "9041e9b2-f334-48f3-86f9-79b1ba825b51"
    },
    {
      "claim_cluster_id": "099db03e-baa7-498b-864d-6a091534741b",
      "event_cluster_id": "f51ef59b-4e02-42dc-84d5-932727f453f6"
    },
    {
      "claim_cluster_id": "0c6c9e5b-f8cc-4939-8319-4baf55259b87",
      "event_cluster_id": "63282497-1e0a-4af5-b5c7-65b6b20ab63f"
    },
    {
      "claim_cluster_id": "8afc9e85-7241-4e3e-a1d2-c084e17d6f92",
      "event_cluster_id": "b50d8113-2ba3-4857-a6f8-d3c42cda7690"
    },
    {
      "claim_cluster_id": "cd4aea0c-c90e-430b-95f8-4bff425c022e",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "bba39c5a-fa92-4d86-80be-58952de97f7e",
      "event_cluster_id": "33ed63b5-316c-47cd-80fa-2cb71259f8eb"
    },
    {
      "claim_cluster_id": "ac1f3497-64d3-4909-9d61-789e683556a9",
      "event_cluster_id": "83f7014a-9a88-48b8-b5ab-b83620e2b1f6"
    },
    {
      "claim_cluster_id": "057bcb05-f915-40a6-9a44-d57aa6602574",
      "event_cluster_id": "beafc838-f8fb-4f24-b442-c5d64c7e1a7b"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0"
    },
    {
      "claim_cluster_id": "970cf87e-f96a-4a62-8043-264e8de25eb5",
      "event_cluster_id": "f1490876-f9ef-4974-a23e-79abce4ea951"
    },
    {
      "claim_cluster_id": "b2ec8ccd-aef2-476a-b259-768aae14f39e",
      "event_cluster_id": "3f91e02f-ab23-4d35-ac70-4b14b0545030"
    },
    {
      "claim_cluster_id": "18413d30-3282-4a19-9301-8b0c9a57c941",
      "event_cluster_id": "263a8eb3-52c7-4ff6-ae64-6807df428530"
    },
    {
      "claim_cluster_id": "3bda7498-8cf1-4495-9ee2-307193fe0c3e",
      "event_cluster_id": "a335ca71-7c72-419b-8877-46ce4e71837d"
    },
    {
      "claim_cluster_id": "b65c1ae7-fe21-4ae4-9c7e-84c247b4a89b",
      "event_cluster_id": "d4e2bc2e-5c21-4fa6-b48d-9b09603ae727"
    },
    {
      "claim_cluster_id": "fc0f4ff8-8147-4b0b-be66-dcae01810fe6",
      "event_cluster_id": "605d1ffa-cf79-43de-a146-0eef92de2043"
    },
    {
      "claim_cluster_id": "e632bc78-90b4-46bf-a31b-df8259ac6d90",
      "event_cluster_id": "59906f79-e6e8-4390-a382-ef5bd2f7fff2"
    },
    {
      "claim_cluster_id": "da4807bf-cc54-48c7-b3ca-69cd854da837",
      "event_cluster_id": "ce2d06aa-e26f-4ec8-8402-545cc5537de0"
    },
    {
      "claim_cluster_id": "38c3007b-05b7-481e-b44e-c09d28628f5e",
      "event_cluster_id": "f6501847-7e90-4499-a97a-f42ac5217bb6"
    },
    {
      "claim_cluster_id": "21c7b1a1-7d0b-407c-9669-93e385d68711",
      "event_cluster_id": "776ff44d-f39f-4f47-8ef5-a991b2a74ced"
    },
    {
      "claim_cluster_id": "0fc290f7-6cc3-4b1a-8b3b-cd5b7f6f9879",
      "event_cluster_id": "011aa847-d3e3-4d34-bf5e-378f39ba8a3c"
    },
    {
      "claim_cluster_id": "149c2ce0-2083-4d57-aa68-de8fbf125008",
      "event_cluster_id": "b3d06a2c-7adf-4967-b1b6-b69e35711ca0"
    },
    {
      "claim_cluster_id": "3e1e4180-7726-4298-9f55-4348fcd7185f",
      "event_cluster_id": "64d2c311-675b-43df-a715-09bca5e25a05"
    },
    {
      "claim_cluster_id": "0f1cacf9-3df0-4d00-8952-b3fa5195f1fb",
      "event_cluster_id": "bc2af5c9-9ff9-4d76-920f-873d731b0a39"
    },
    {
      "claim_cluster_id": "e1f9f354-866e-470a-a516-a1c53f268840",
      "event_cluster_id": "978700a4-02ac-4150-9d93-a90e4ee05431"
    },
    {
      "claim_cluster_id": "25a85f3d-1037-40c8-8b96-32b80bedc5b2",
      "event_cluster_id": "38bfd344-45fc-4c0a-8605-6354b8f22cb4"
    },
    {
      "claim_cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
      "event_cluster_id": "cec3a521-c732-4e0b-8192-f6efa6c46d10"
    },
    {
      "claim_cluster_id": "3543d3e3-081b-448e-9ec9-915bf37d6255",
      "event_cluster_id": "55f690c0-9fbb-459a-ab42-db16e202e04f"
    },
    {
      "claim_cluster_id": "a0f8e5d7-b3ae-4af7-8eb1-d7fefd231acc",
      "event_cluster_id": "d227604b-5869-4f99-9132-b0eb536e0289"
    },
    {
      "claim_cluster_id": "6a2ad136-bcb6-47c4-8c1f-40e9c58978da",
      "event_cluster_id": "2e2cbe02-9179-4ff7-9128-2042160eb4d1"
    },
    {
      "claim_cluster_id": "34e53235-60e8-4299-9389-633db39ab300",
      "event_cluster_id": "2d4166ac-3dc3-45f4-a803-c8d77cddc0db"
    },
    {
      "claim_cluster_id": "73c5657f-c795-4df0-b889-73c2f356f79a",
      "event_cluster_id": "06e477a1-87e5-42ae-a235-8227d3b39fe3"
    },
    {
      "claim_cluster_id": "a0aafb48-1cc4-47f3-9cc7-073b87c64efc",
      "event_cluster_id": "6e5ac655-6dc6-4a9e-915a-357b2296a7b0"
    },
    {
      "claim_cluster_id": "dfcf5731-89c0-4af2-a475-d7087b733644",
      "event_cluster_id": "07ba7d5a-bc3c-4f63-a8e0-6487f494c700"
    },
    {
      "claim_cluster_id": "5284ded1-5c85-415c-af66-ad36ef47b3e7",
      "event_cluster_id": "ede13164-94fe-4382-9f88-120091c29cbc"
    },
    {
      "claim_cluster_id": "2e1084b1-c7f9-4543-8153-a6c840adb565",
      "event_cluster_id": "270b9be6-37c3-4ab7-9763-57943d7a38b9"
    },
    {
      "claim_cluster_id": "0acd3055-185c-4d22-ad5f-a587ee5adc40",
      "event_cluster_id": "69dda1ad-6a94-49a1-b2c4-c261984302cc"
    },
    {
      "claim_cluster_id": "93f3d467-50ce-4038-8205-5814ad28dd43",
      "event_cluster_id": "8ab4584b-29ff-4c6c-b1fe-8e8438c3dfaf"
    },
    {
      "claim_cluster_id": "09e579b4-c608-4bc3-a02e-890bc6f5969d",
      "event_cluster_id": "5f1df598-4786-4f75-aed1-8eb66dff4278"
    },
    {
      "claim_cluster_id": "c29b208b-6490-4cf8-b641-83fe57eafe9a",
      "event_cluster_id": "fffc483f-c841-4109-b9e1-d2ab5730fe2b"
    },
    {
      "claim_cluster_id": "19ec7067-1e85-4e98-adf9-a107366a808b",
      "event_cluster_id": "28c6e890-bb36-4eff-b0b6-22f2850f023d"
    },
    {
      "claim_cluster_id": "f34203f2-30b3-4686-b2f0-e124d8a67272",
      "event_cluster_id": "cfd4b520-a181-4698-846e-ff280ba11189"
    },
    {
      "claim_cluster_id": "dffcbb9d-5ee2-41aa-b433-81d56d1d9d1e",
      "event_cluster_id": "d415aa76-63ab-4b87-94b6-7d753e952a6a"
    },
    {
      "claim_cluster_id": "f9a4fce8-b5c8-4697-808a-9ac08e5be52f",
      "event_cluster_id": "f86db310-987e-41a6-a2fc-6f6bb14b7072"
    },
    {
      "claim_cluster_id": "af3f95a3-d597-4371-bf7f-e4f5d91a9b73",
      "event_cluster_id": "c183c1f7-56d7-457d-9d98-1df02c7330bd"
    },
    {
      "claim_cluster_id": "5197019b-eb26-4b32-8e4f-5890ab4e562a",
      "event_cluster_id": "828fd8b5-ddaf-4d75-8787-c4afd6bebc90"
    },
    {
      "claim_cluster_id": "dcadf3a6-188b-4a08-881c-e1acb19f186a",
      "event_cluster_id": "78e9a9c1-3b66-422f-8fa2-16501c3ff20e"
    },
    {
      "claim_cluster_id": "2996196c-7b75-44d2-aa5b-560b18ce2763",
      "event_cluster_id": "162d37ea-ce13-4d19-9a98-bb0e66720cc0"
    },
    {
      "claim_cluster_id": "a0b96ee6-2ea9-4035-b542-1107b0662e77",
      "event_cluster_id": "1aacc2c6-cd51-47e7-bc26-be760d557e3c"
    },
    {
      "claim_cluster_id": "7e91dc42-693c-4620-b472-dae427b9fe8d",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "f1afc4d0-4eaa-40ab-99e6-20e11c550ccb",
      "event_cluster_id": "209b24c3-c157-4c8e-9d85-993e19c6b8bb"
    },
    {
      "claim_cluster_id": "d4dddb84-da14-4d5c-ac75-d999175b9558",
      "event_cluster_id": "56c5d781-120e-4c38-ba12-676cecb63cc8"
    },
    {
      "claim_cluster_id": "7940ac84-eeae-4d7a-9072-fc2e9ac63265",
      "event_cluster_id": "9162951c-ce7d-463b-9880-335cc6cb0f80"
    },
    {
      "claim_cluster_id": "d7e9e6ed-b598-46a7-b7ea-6197df41d3ad",
      "event_cluster_id": "40f8706e-4783-4eef-bf10-d2f20bfb78bb"
    },
    {
      "claim_cluster_id": "b4de3a2a-395f-4d49-9f4e-abbd190c57b5",
      "event_cluster_id": "338b82e5-bda1-47c8-a375-1c6600743697"
    },
    {
      "claim_cluster_id": "25a85f3d-1037-40c8-8b96-32b80bedc5b2",
      "event_cluster_id": "36ad2a89-3229-40ad-9f6f-f2c33f4ebacd"
    },
    {
      "claim_cluster_id": "b4c1b467-58b1-4e2c-a735-234cba24891c",
      "event_cluster_id": "efe98b1b-e1ed-468a-9652-7acc5550430a"
    },
    {
      "claim_cluster_id": "de116a88-705c-434f-9f3a-1fdabb457723",
      "event_cluster_id": "fc29eab9-06ef-4c87-8c16-ab4eb87c1683"
    },
    {
      "claim_cluster_id": "8ef65ecd-3750-4a43-89ce-d81b333f2e1c",
      "event_cluster_id": "b695ff3b-957e-42cc-9bb5-c2dd8be994ea"
    },
    {
      "claim_cluster_id": "9c9d4ed6-a861-4706-aee3-f148f1769c86",
      "event_cluster_id": "349cfacb-551c-400e-8c1e-7b08765e6799"
    },
    {
      "claim_cluster_id": "20c941a8-b922-48e3-8e56-e49e1a524fd9",
      "event_cluster_id": "6e64c34e-113d-43d7-87a6-90c61d4d3f67"
    },
    {
      "claim_cluster_id": "26852476-f26f-4f97-92bf-7cc2d9373f4e",
      "event_cluster_id": "7234c7f2-ec56-436a-abe4-d72c2e651247"
    },
    {
      "claim_cluster_id": "25d9faf4-4231-47e1-9e78-17114da0186c",
      "event_cluster_id": "3e2b1f73-9c36-499a-910a-db947f38acee"
    },
    {
      "claim_cluster_id": "67c03f1c-cee9-4493-b4e6-4ff1b7971966",
      "event_cluster_id": "7b4ecda5-4408-4ecd-a695-939e312b6ac7"
    },
    {
      "claim_cluster_id": "126818cf-8924-40eb-8cb3-edad41027c0e",
      "event_cluster_id": "3feb2513-5eb4-45bb-8249-92697ca5ccbf"
    },
    {
      "claim_cluster_id": "27097c65-59e7-4824-9bbb-c0736b2c9f70",
      "event_cluster_id": "b8f6ce4f-4115-477a-9fac-602b955a0de8"
    },
    {
      "claim_cluster_id": "f1461740-3766-4178-84e8-17d9b70838ae",
      "event_cluster_id": "4fd88af5-5edc-4995-92ea-057702ca240a"
    },
    {
      "claim_cluster_id": "5dde6d54-8ecf-4f66-96dd-406048082082",
      "event_cluster_id": "00c86245-5e91-487e-8809-1bcfd15888ae"
    },
    {
      "claim_cluster_id": "a49a51da-aad1-43de-81b7-51f95b22eabd",
      "event_cluster_id": "1282bd1b-6e16-4c06-9f2c-9c9344b54fd8"
    },
    {
      "claim_cluster_id": "71b86c5b-0ae0-46d5-a172-4da94679db3d",
      "event_cluster_id": "d339acab-2e15-4ce1-8cff-20a1b2fc2811"
    },
    {
      "claim_cluster_id": "eb7fddda-fe98-408c-a2d5-471f6b5aac76",
      "event_cluster_id": "a29634dd-4c74-4380-8358-51cf5a9cb73c"
    },
    {
      "claim_cluster_id": "ebf0120f-ec3a-4a71-bd2b-88f212264387",
      "event_cluster_id": "5dad5c87-4292-488c-b998-f9a86f6c59b2"
    },
    {
      "claim_cluster_id": "93c53898-2dc6-423b-a4d6-b61dd90c6d6c",
      "event_cluster_id": "e828a029-7aa6-4aae-b53b-df9804b3b858"
    },
    {
      "claim_cluster_id": "6a4e66c3-1fd2-46be-9e31-fecdcd545826",
      "event_cluster_id": "8c70df97-1c82-4e7f-b23d-acbf2024c8f6"
    },
    {
      "claim_cluster_id": "2846d44d-8ccd-40e0-8486-7b360ffa4608",
      "event_cluster_id": "079b8e0f-e8e1-4996-9f11-531830a5cd53"
    },
    {
      "claim_cluster_id": "da2845de-4e1b-492a-a6b0-06fd4584650e",
      "event_cluster_id": "9fb69606-a3db-4d92-926c-b003f3516e43"
    },
    {
      "claim_cluster_id": "2e1084b1-c7f9-4543-8153-a6c840adb565",
      "event_cluster_id": "99d24268-130c-4375-a4e7-e999f58720e8"
    },
    {
      "claim_cluster_id": "deb1b19f-f313-46a8-8e93-d75203af3775",
      "event_cluster_id": "13bb7753-ee8b-4817-baa5-471bea919fc8"
    },
    {
      "claim_cluster_id": "b3d00803-b5be-4264-bbda-b09db5ed3a9b",
      "event_cluster_id": "8340119a-3207-4843-be46-581bcbb33e2b"
    },
    {
      "claim_cluster_id": "92ea76c7-4dfb-45af-849a-ece7083099c6",
      "event_cluster_id": "21b4b954-5140-43e2-bd9b-c8ab79b3e70c"
    },
    {
      "claim_cluster_id": "6b512fcc-e6a2-414b-8a86-90a11b76795a",
      "event_cluster_id": "57a9720a-c11c-4e38-b871-7e3861e5df17"
    },
    {
      "claim_cluster_id": "99f11e8b-4375-4ee6-8be9-78b8355c6e63",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "a72e319a-9e87-40b0-a2c4-a95e4857ac8d",
      "event_cluster_id": "73bf3278-1769-4596-8d67-3c3249542c2c"
    },
    {
      "claim_cluster_id": "a6c6cdde-b7da-4e49-88cc-f029f6af6192",
      "event_cluster_id": "6adcd904-be39-467c-bbbe-a9cce702dbdb"
    },
    {
      "claim_cluster_id": "212176d0-9b06-497d-a8bf-0b53076513ff",
      "event_cluster_id": "db558738-31a9-49b8-a8b4-9d79818e6da2"
    },
    {
      "claim_cluster_id": "b213b3ba-db75-4c42-89bd-97de55c18b3e",
      "event_cluster_id": "3cf933e5-8422-4f09-a822-8ef8b6385700"
    },
    {
      "claim_cluster_id": "ad4fa6da-197e-4295-b610-c2f934cdd3ea",
      "event_cluster_id": "8f6bdb99-b1de-47a0-840e-33678f79a92b"
    },
    {
      "claim_cluster_id": "72cf96af-c05b-405d-a5e3-785cb1c6c70e",
      "event_cluster_id": "80c4a4ac-f4f0-46b7-a4e0-1dc67ab16883"
    },
    {
      "claim_cluster_id": "71755eb8-e7df-4bfc-b448-f56fe2b8b242",
      "event_cluster_id": "d488f4da-dea7-4960-b3a2-50c35254e3ba"
    },
    {
      "claim_cluster_id": "952d3c78-e97c-4ff6-a488-1e2f6353d3c9",
      "event_cluster_id": "813768d2-b0f6-4924-af6d-45e5c38606af"
    },
    {
      "claim_cluster_id": "67077d98-dd63-4eb1-bfae-12ca20649195",
      "event_cluster_id": "f43f98cd-cb16-421c-a639-6c526509bfd7"
    },
    {
      "claim_cluster_id": "fcc58b11-54f2-420b-99e3-8acb8731fd15",
      "event_cluster_id": "506ae2d6-92b1-4fbe-9d47-e321f93374d4"
    },
    {
      "claim_cluster_id": "453d17a8-fa49-49dd-82fd-7c3661e026b6",
      "event_cluster_id": "0d94dbde-ff2c-4ec4-88f7-65580876f8ea"
    },
    {
      "claim_cluster_id": "b180d822-88c1-4c5f-a386-c975497c4a85",
      "event_cluster_id": "82b01c38-1855-48d6-8ce7-6d564382bd37"
    },
    {
      "claim_cluster_id": "98dac116-c6f6-46b8-945d-1ffe5cc5db7d",
      "event_cluster_id": "21d0c066-9264-468d-b96a-f5f007531508"
    },
    {
      "claim_cluster_id": "a5706e56-c643-44be-8e44-3c19fd9dcc29",
      "event_cluster_id": "4b93a421-107c-4185-912b-a73d039895b4"
    },
    {
      "claim_cluster_id": "b44cd59b-4971-4182-8766-9ffcf4ae83ce",
      "event_cluster_id": "2f690c44-ca18-4a31-a2b5-68ac60208360"
    },
    {
      "claim_cluster_id": "6dc49cf5-bbfe-4cdb-aa3e-bd6aa990f0c1",
      "event_cluster_id": "f8fb699e-3174-4e1f-8079-1bb9372cf5ca"
    },
    {
      "claim_cluster_id": "68ff85cf-74e5-4234-a53f-6dba1aacb444",
      "event_cluster_id": "6ca62e87-83be-4fb7-8924-3312fe9948b1"
    },
    {
      "claim_cluster_id": "dfd567bb-1650-495c-ac2d-4d240d441b79",
      "event_cluster_id": "8258ee8e-37a7-4d85-b65c-6247bdf08da7"
    },
    {
      "claim_cluster_id": "5e7e70f4-b130-467a-9df9-f6078877ed61",
      "event_cluster_id": "933ba991-e63b-4909-90b5-fbeb9eeea4c4"
    },
    {
      "claim_cluster_id": "c14aacf1-2f99-4e9a-ba35-1511bf4fd104",
      "event_cluster_id": "6bf71f87-f205-4f8b-8249-8d960a41d7cc"
    },
    {
      "claim_cluster_id": "6abe1bb1-d30a-40e6-8fb2-f7c5a02ae16a",
      "event_cluster_id": "44c9e76f-0fa5-4a17-a780-5705bb58dc3f"
    },
    {
      "claim_cluster_id": "7b68c402-465e-4abb-ac74-c3e397c8afdd",
      "event_cluster_id": "050d87c2-4ac3-4e0e-8673-b4a44b43bac0"
    },
    {
      "claim_cluster_id": "563cdc28-d88f-4781-9ab9-27eadd46ba73",
      "event_cluster_id": "55299e01-297a-4bb3-aad3-784bd43284fb"
    },
    {
      "claim_cluster_id": "e968bf8c-b2a8-4330-bf71-9cab4f6826a5",
      "event_cluster_id": "03ab33c5-869c-44e7-85ff-a26adc857fce"
    },
    {
      "claim_cluster_id": "98bac582-09cd-476d-9519-fe434dffcb9a",
      "event_cluster_id": "4d98cb2c-2f46-419d-a007-1ffd1128c767"
    },
    {
      "claim_cluster_id": "796ddc52-9094-4fcb-af10-9fa6a06448ba",
      "event_cluster_id": "ba39c004-53dc-4528-9f07-025d10ba4bfc"
    },
    {
      "claim_cluster_id": "5833eaa5-8c9c-42b9-bd12-8cdf781ec725",
      "event_cluster_id": "da81244a-ef78-429d-9f3d-b08a5c21a084"
    },
    {
      "claim_cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
      "event_cluster_id": "cd8525ab-90a4-434a-bf10-f887240219f2"
    },
    {
      "claim_cluster_id": "60b71403-253c-4f7c-b96e-fb2306a7cebf",
      "event_cluster_id": "14a0f558-9894-4d04-9b27-d9a6b3531c2c"
    },
    {
      "claim_cluster_id": "452c2457-4da2-4edb-a49f-86f139410e4f",
      "event_cluster_id": "50c706cf-6243-4e9d-81ec-789d3dbecc99"
    },
    {
      "claim_cluster_id": "68152d77-1b3b-45af-8c06-88cf78f6a175",
      "event_cluster_id": "2ca6b1f5-ce3d-4e72-98a8-f750a42081ac"
    },
    {
      "claim_cluster_id": "e455cd44-cd3c-4e6c-a847-ff250278123c",
      "event_cluster_id": "3775dc56-2d8e-428a-9c60-ba993c0f4ba7"
    },
    {
      "claim_cluster_id": "c39e0166-c55b-4f71-8bb5-e23985802606",
      "event_cluster_id": "d3326047-f19e-4b54-a0ed-a16bb5dfd0de"
    },
    {
      "claim_cluster_id": "22874c8a-79fa-491a-a46f-cd92202bb1de",
      "event_cluster_id": "9efa7058-0848-446b-a53c-deef9f0ad8fe"
    },
    {
      "claim_cluster_id": "c13b80fa-280b-4c54-8a38-1ddd943c4782",
      "event_cluster_id": "34a1b7dd-030b-404f-82f6-074c42d07051"
    },
    {
      "claim_cluster_id": "30ae8997-b16b-4477-bfec-33c1a345955b",
      "event_cluster_id": "3b22f285-4b36-49a0-9e8d-cceb33235419"
    },
    {
      "claim_cluster_id": "a6c6cdde-b7da-4e49-88cc-f029f6af6192",
      "event_cluster_id": "dbe0f86a-aebe-4564-9503-5702cd51713e"
    },
    {
      "claim_cluster_id": "5b6da2ab-36ee-4cfe-968a-ce42565405bc",
      "event_cluster_id": "bfcb4fd5-03ad-4398-a7b4-f52617946935"
    },
    {
      "claim_cluster_id": "c21b5cff-dd9b-418d-82f4-ad5049c002d9",
      "event_cluster_id": "4c76d4e3-5632-4224-a22f-bc4b4614bcbb"
    },
    {
      "claim_cluster_id": "dfa47852-ac3f-4b74-bc17-22923a395552",
      "event_cluster_id": "0ca4759c-9c4f-421f-b2d0-dbefe4601911"
    },
    {
      "claim_cluster_id": "8944c246-4c2f-439b-bc21-590da536eede",
      "event_cluster_id": "c40cc82c-67d0-418e-9ae2-4c1dfebaaa5a"
    },
    {
      "claim_cluster_id": "ef502c1a-5f03-41b4-be90-14e6e1785625",
      "event_cluster_id": "1171e42a-be23-408d-8491-47db819af91c"
    },
    {
      "claim_cluster_id": "e31510b5-776d-40cf-9a10-afb0bb1a3f0b",
      "event_cluster_id": "bf617b93-4dcc-4186-81d8-7cd9fc2d425a"
    },
    {
      "claim_cluster_id": "9ef27775-8065-4722-bd90-8a9ae4a3c250",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "21956ecc-f782-4f55-8347-f78333fc6d97",
      "event_cluster_id": "071edf6a-a71e-44b7-923a-bff12eb8ede8"
    },
    {
      "claim_cluster_id": "35dd5b6f-5d4b-4d3f-89d2-8b94cb646f60",
      "event_cluster_id": "02d5b346-4337-43cf-8a61-4391e125d41b"
    },
    {
      "claim_cluster_id": "dfcf5731-89c0-4af2-a475-d7087b733644",
      "event_cluster_id": "9cc8799b-e620-4e1a-8846-51eed506e0de"
    },
    {
      "claim_cluster_id": "5d30cac5-2629-4bf5-9665-20ae87c1ec22",
      "event_cluster_id": "57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"
    },
    {
      "claim_cluster_id": "de3dfa95-4771-45cc-8a31-d6c35fbb0eb5",
      "event_cluster_id": "56cddc1e-640e-4fd4-873b-51796886ff3a"
    },
    {
      "claim_cluster_id": "7e4a12f6-fe24-48f6-993c-d7197eb9c44e",
      "event_cluster_id": "8456fa39-debe-4543-9e31-bac207d1861c"
    },
    {
      "claim_cluster_id": "b523cd60-7c0d-4c50-b41c-3522aed9c4b1",
      "event_cluster_id": "ce875605-9657-4d10-9c03-b203782b40e2"
    },
    {
      "claim_cluster_id": "bf1e9c00-6f00-48d6-9611-285baac7022b",
      "event_cluster_id": "af7abfea-8aa3-4fe8-a9f8-4a548d23e03a"
    },
    {
      "claim_cluster_id": "26852476-f26f-4f97-92bf-7cc2d9373f4e",
      "event_cluster_id": "e493e014-2ee0-4066-9764-e3019f7467b2"
    },
    {
      "claim_cluster_id": "542e81d5-bf51-451b-bb6a-204f6c8da58e",
      "event_cluster_id": "36abfac2-7b3e-427a-a2be-ce55f5472e15"
    },
    {
      "claim_cluster_id": "6547f895-7ab3-43c4-b3b1-d01e17f1e888",
      "event_cluster_id": "40ab9766-1c85-4b8a-bb1d-2effee6c9d18"
    },
    {
      "claim_cluster_id": "5a8284e8-a150-41dc-8ee7-edbc3da33af5",
      "event_cluster_id": "530c303c-a794-4be5-bbc2-ff618ab75d38"
    },
    {
      "claim_cluster_id": "5d4f6733-5fbd-48ce-8468-590ebda279c7",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "adcb219f-1d0a-4b1b-924d-ded66e2d2c1c",
      "event_cluster_id": "b997c44d-2fc1-4d45-8a7a-f72d1b5a079d"
    },
    {
      "claim_cluster_id": "87e51e32-d441-41a9-8026-a751a57b0ed2",
      "event_cluster_id": "b3b646eb-c723-4a14-ac13-d0b7985ef11c"
    },
    {
      "claim_cluster_id": "41dd785c-3146-4243-8bbd-56211fadb273",
      "event_cluster_id": "503b13e8-42e4-48e4-8ace-47ca9e49140f"
    },
    {
      "claim_cluster_id": "2052af74-0bc8-401c-a911-035e4f5f65d2",
      "event_cluster_id": "db101c75-2320-4597-b222-b7197dc49dc4"
    },
    {
      "claim_cluster_id": "dcbf5711-b1d2-4a7c-96f6-e8916f52c752",
      "event_cluster_id": "c5a49990-0bec-49b9-8797-00d71805007a"
    },
    {
      "claim_cluster_id": "487393b6-56b8-4c3f-bdb3-88dbd2ac69d5",
      "event_cluster_id": "862e3561-6a46-4a47-8035-363b4e2c1786"
    },
    {
      "claim_cluster_id": "b2871022-57c5-48f7-adcd-caeceec2edeb",
      "event_cluster_id": "d2b35337-7985-4ff0-934f-fef44d781bab"
    },
    {
      "claim_cluster_id": "73ed8dfb-71b9-42f0-9f45-a873045bd275",
      "event_cluster_id": "3ba005de-dec0-4cc4-8a3c-a3679d6f072a"
    },
    {
      "claim_cluster_id": "c3c1a73e-287c-4b15-879c-42467ebdfb38",
      "event_cluster_id": "fe1c6b54-9f28-4390-8b18-685bcbf44298"
    },
    {
      "claim_cluster_id": "5d21e7b3-dd0e-453e-8871-eb57102f00e7",
      "event_cluster_id": "e53e2876-2718-4f35-b4a4-ab220a980fd2"
    },
    {
      "claim_cluster_id": "89aabd59-2b1d-4122-9c03-b5ffeee5a650",
      "event_cluster_id": "c0afded3-b33f-49c5-9160-e59e42832c59"
    },
    {
      "claim_cluster_id": "6c947694-8652-4e58-b4d1-40be43d3a77b",
      "event_cluster_id": "ae87ce9d-8fb9-4394-9afe-202f1ec14722"
    },
    {
      "claim_cluster_id": "de73aada-5f8d-4c83-9e0c-5c7ab1aa4dbe",
      "event_cluster_id": "f55b7553-3d55-4096-859e-954de960f09c"
    },
    {
      "claim_cluster_id": "f465e3b9-9784-4302-b258-d34ad0adf726",
      "event_cluster_id": "fe967f6f-e1e9-4e86-aa0a-8f6a9f4b7b6f"
    },
    {
      "claim_cluster_id": "bf3a902c-c644-4da4-8d4f-8ccf8bbcec56",
      "event_cluster_id": "6212a7fd-0f42-4186-898e-6bca1d985ded"
    },
    {
      "claim_cluster_id": "a65b71fa-08aa-4b20-91e3-c9e898591f07",
      "event_cluster_id": "7c1469be-22eb-4ba2-a540-efc0b0d4e00e"
    },
    {
      "claim_cluster_id": "6a8ee3bf-31a7-42b7-b481-4b21e09f4484",
      "event_cluster_id": "6d1416a4-5911-49a5-a8dd-0b4e7d18279a"
    },
    {
      "claim_cluster_id": "b7e4eaa1-1521-4096-9aa4-af78b70dfeb5",
      "event_cluster_id": "b1babe59-a6e4-4d3d-9c56-c6ce7d8d64c4"
    },
    {
      "claim_cluster_id": "dc73c39b-d234-4200-a04f-dc1af208480d",
      "event_cluster_id": "7d7dd851-9e80-401e-86ac-20fbd4d71580"
    },
    {
      "claim_cluster_id": "9e906023-8a3d-4a63-9309-18e9ee1c3641",
      "event_cluster_id": "ee6ffddc-d717-4a7b-a161-3d1bdc24c500"
    },
    {
      "claim_cluster_id": "5a33a893-0ae3-4e2b-9f4c-02de9772f96c",
      "event_cluster_id": "3c9a1b13-b4b6-4090-861e-e35159e61286"
    },
    {
      "claim_cluster_id": "f58ca21a-7af7-4062-9509-f6480d8a6390",
      "event_cluster_id": "c0713b5c-a570-4865-83c9-eb36c347abcf"
    },
    {
      "claim_cluster_id": "712f7b26-cec5-48c3-8025-43c35dea8246",
      "event_cluster_id": "11415296-938e-40a3-84ae-06be10542d39"
    },
    {
      "claim_cluster_id": "830f6edd-9e60-427e-9ff4-9fac93a52411",
      "event_cluster_id": "3195f0c6-475f-480b-9f8a-4aa8231b8b3c"
    },
    {
      "claim_cluster_id": "89cac161-a6f0-4315-a880-1662cae50313",
      "event_cluster_id": "caa057e8-994e-43b8-803e-0ea0aeab7ec7"
    },
    {
      "claim_cluster_id": "ab72f353-1b68-44ce-979f-a10883b99605",
      "event_cluster_id": "18485212-7b1e-457d-88c0-98b9b231ec0b"
    },
    {
      "claim_cluster_id": "62d8fa29-aaab-4f66-9532-5fb34686e56f",
      "event_cluster_id": "0b109e58-1cde-4c32-aed4-12ba82ed273a"
    },
    {
      "claim_cluster_id": "29790db2-2536-415f-822b-9a4c1f1f8a3c",
      "event_cluster_id": "c9b82e27-7ad0-442f-96dc-21665bfad993"
    },
    {
      "claim_cluster_id": "635833cc-6550-4cab-b41a-e51cbfca373a",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "9571d5a8-94c8-43e8-bdfc-93e045f2bdd4",
      "event_cluster_id": "808de745-ec3f-47f3-84ca-5bbec4878cae"
    },
    {
      "claim_cluster_id": "489bde91-1bfc-48d6-aae7-de380d23d205",
      "event_cluster_id": "e0cfcc7e-1525-454e-82eb-71402504ae5b"
    },
    {
      "claim_cluster_id": "12efff4b-e0b1-447e-aeb7-828004c5cfde",
      "event_cluster_id": "6d1416a4-5911-49a5-a8dd-0b4e7d18279a"
    },
    {
      "claim_cluster_id": "de3dfa95-4771-45cc-8a31-d6c35fbb0eb5",
      "event_cluster_id": "f7cb56d3-2935-41a4-86b7-c9fe57c869f7"
    },
    {
      "claim_cluster_id": "c9534331-e465-4cc5-951b-fa24c4cd75bf",
      "event_cluster_id": "4f2789db-45a0-4f05-86be-a25e7794e0d7"
    },
    {
      "claim_cluster_id": "9d400cbf-08ea-4c02-941a-80cd2d3e517a",
      "event_cluster_id": "b85d6c69-8e92-437b-87b3-200c9509883f"
    },
    {
      "claim_cluster_id": "7ae548ab-8f8f-4668-ba05-a2abf4b89759",
      "event_cluster_id": "e0017f41-b71f-4659-b94d-36fcb62cb736"
    },
    {
      "claim_cluster_id": "e61d6703-69dd-4dea-8318-f7e671e98045",
      "event_cluster_id": "ed912a16-7c22-4013-aecd-05fbaf2f3003"
    },
    {
      "claim_cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
      "event_cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0"
    },
    {
      "claim_cluster_id": "1ba178d9-d925-407c-bb75-60c655774cbf",
      "event_cluster_id": "138ee12c-cc52-4ab9-bc9d-3ad91e9008d8"
    },
    {
      "claim_cluster_id": "9d400cbf-08ea-4c02-941a-80cd2d3e517a",
      "event_cluster_id": "974fea38-71aa-4887-8998-28e03cf7c1b0"
    },
    {
      "claim_cluster_id": "847accaf-332c-4ec2-bd26-cd592d1fa2fc",
      "event_cluster_id": "242e079a-1694-45b6-93b7-7c7320473a25"
    },
    {
      "claim_cluster_id": "c6541e86-8e1b-4bd0-926a-c380aa103aa6",
      "event_cluster_id": "8b1384fb-f659-4943-948b-d2766f5d5af0"
    },
    {
      "claim_cluster_id": "679dc735-ea4b-4b4e-88e2-45d26bcc5b41",
      "event_cluster_id": "c623ca23-8a98-4b0e-b365-eb9b3c1cdd86"
    },
    {
      "claim_cluster_id": "54c90db1-79c2-4dc0-b9f0-9cd9022a857f",
      "event_cluster_id": "f55b7553-3d55-4096-859e-954de960f09c"
    },
    {
      "claim_cluster_id": "f6a8a8da-c935-4c40-b9c2-79c93b84b629",
      "event_cluster_id": "129ac9af-1e7f-4d17-aba1-4c71a6061174"
    },
    {
      "claim_cluster_id": "9fa27866-4911-4f0d-8135-cff4b7e597db",
      "event_cluster_id": "ac3c4bde-8539-4baa-8848-6a9242884e47"
    },
    {
      "claim_cluster_id": "c153b607-ea7e-4a94-8f50-d29611d77fe7",
      "event_cluster_id": "b6c807dd-0cb5-4622-8a2e-ef610ded44e5"
    },
    {
      "claim_cluster_id": "c6592686-c5bc-45c2-8341-7823b2936bde",
      "event_cluster_id": "c08c0c57-ea8b-4938-93c9-7d2934450835"
    },
    {
      "claim_cluster_id": "13b8e657-b1a1-46e6-ace5-fc6a57928a32",
      "event_cluster_id": "64ce313a-9f62-48b5-ac72-4f4f23b43da9"
    },
    {
      "claim_cluster_id": "f9479c00-8b23-4d34-9b9b-bb89fe1cb0ab",
      "event_cluster_id": "9d75c554-9eb9-4082-9c04-6fe3e303845e"
    },
    {
      "claim_cluster_id": "e6867616-fb8f-44d6-8b92-f5cca8ca9e6a",
      "event_cluster_id": "9da22551-1ead-40c0-8c8c-078150bb5988"
    },
    {
      "claim_cluster_id": "b9198f54-dcf7-43b1-9ba8-28ae1ef79e83",
      "event_cluster_id": "afa6f32e-961f-4c79-a6ff-7629b5b32022"
    },
    {
      "claim_cluster_id": "c8d061af-6686-4c3f-a2d9-0d23ccbd3f19",
      "event_cluster_id": "d8ef4018-d9a3-42e2-a7c5-aef1d93ff0d6"
    },
    {
      "claim_cluster_id": "10cadbd2-7261-4295-9f88-df0f9a246b5b",
      "event_cluster_id": "e72c5c13-765f-4dae-aecd-48d78cd16ece"
    },
    {
      "claim_cluster_id": "2b9508d5-4552-4994-840b-08ab461e29c3",
      "event_cluster_id": "07b11e06-46ec-45e9-8f01-bc31083fd0de"
    },
    {
      "claim_cluster_id": "98a97f12-7d1b-49e9-8178-578b2d656f88",
      "event_cluster_id": "1d45606c-718c-493d-8ad2-e61d4af0180a"
    },
    {
      "claim_cluster_id": "eb2e33e5-165b-4a02-aa96-d53bcd386da0",
      "event_cluster_id": "a44b23b8-a3e3-493e-b038-fc26f5c96d31"
    },
    {
      "claim_cluster_id": "c6aa0cad-31b1-4d56-9f83-938881501dbd",
      "event_cluster_id": "fb360de4-aab2-45d9-8f25-8bdd44c0ce45"
    },
    {
      "claim_cluster_id": "77ce5be7-73f4-4876-9446-d5aec1b02a1c",
      "event_cluster_id": "0a14d3f0-c71b-44cd-8eea-7fc2fbc8fa38"
    },
    {
      "claim_cluster_id": "93fddae5-a739-409c-a087-9a562d010a0e",
      "event_cluster_id": "ae87ce9d-8fb9-4394-9afe-202f1ec14722"
    },
    {
      "claim_cluster_id": "8ae7ec4c-38f4-4117-962e-b6f044038377",
      "event_cluster_id": "227d1df9-e404-4f53-b880-3d4e96ed3405"
    },
    {
      "claim_cluster_id": "da5651eb-e7b2-446c-9fdb-dc89d46a36a7",
      "event_cluster_id": "aeb63f4c-fb27-45bb-903e-d98ab93f7138"
    },
    {
      "claim_cluster_id": "54c90db1-79c2-4dc0-b9f0-9cd9022a857f",
      "event_cluster_id": "d19dc1b6-21b1-49bc-aaf1-fb24f7c66396"
    },
    {
      "claim_cluster_id": "e17e07df-4805-4514-b3fc-c16cda9269a3",
      "event_cluster_id": "4a783d2e-0380-4a57-9e6f-4b34c23f0ad1"
    },
    {
      "claim_cluster_id": "59f4b586-ede4-4464-af30-2858db5799e0",
      "event_cluster_id": "14619d00-6463-4ba9-8ab1-f0816bb06540"
    },
    {
      "claim_cluster_id": "aea747b1-1cb4-4b3d-94df-5c33181b0976",
      "event_cluster_id": "138a4a3b-db1f-4c6f-b320-65bc4e554e6f"
    },
    {
      "claim_cluster_id": "029b01a5-6f18-4a7f-96f8-6bde44853032",
      "event_cluster_id": "6f908336-dbeb-4b80-ae57-9e0431081831"
    },
    {
      "claim_cluster_id": "18daf39a-f6c9-4439-8592-186d1ea3c4b4",
      "event_cluster_id": "fcfd6d39-3e11-43c7-ac1f-026d265beb4f"
    },
    {
      "claim_cluster_id": "041cf2cd-18d4-495c-8ae7-5b69605020ea",
      "event_cluster_id": "549c4c7b-f978-4fb0-adc2-18a978338670"
    },
    {
      "claim_cluster_id": "607ccd27-4dff-4901-8aad-e4dab1d3448a",
      "event_cluster_id": "846c89d6-71e0-4858-9977-96bc0a6497b3"
    },
    {
      "claim_cluster_id": "5a8284e8-a150-41dc-8ee7-edbc3da33af5",
      "event_cluster_id": "cd8525ab-90a4-434a-bf10-f887240219f2"
    },
    {
      "claim_cluster_id": "8e9b5986-8277-45da-82c2-ab199cd3287f",
      "event_cluster_id": "3d7436aa-4609-467d-a098-e24702a617e8"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "6a3f5b65-ac92-4e63-91ac-fe203f06931f"
    },
    {
      "claim_cluster_id": "637d133e-6c19-4fa2-b174-de1d016bd9bc",
      "event_cluster_id": "04568cc7-5dd8-42b7-8a07-715cdd043c03"
    },
    {
      "claim_cluster_id": "b2036724-7c6c-4df4-b983-90c324253873",
      "event_cluster_id": "9f415e0a-a04a-4d8b-b01c-2d2cc94bb46b"
    },
    {
      "claim_cluster_id": "86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5",
      "event_cluster_id": "2e75fb89-d4ec-437b-bb34-741837209437"
    },
    {
      "claim_cluster_id": "2cd7a2ea-67d1-4d2a-8944-a71778dc20d7",
      "event_cluster_id": "28afb978-f67f-4533-930c-c708e5d2a810"
    },
    {
      "claim_cluster_id": "5238def0-ccfb-4f27-b836-f20f9b7dd70b",
      "event_cluster_id": "707b49ca-9999-4b93-b6af-d31c32d2cafb"
    },
    {
      "claim_cluster_id": "5a8c09d4-337f-442b-8464-f2be567010bf",
      "event_cluster_id": "f3191f0a-3803-4bca-ad51-304e3f825638"
    },
    {
      "claim_cluster_id": "ed1fef35-ea22-4436-b53a-1dc1f0380298",
      "event_cluster_id": "7b3392aa-9600-4d0a-9098-a43e48acd086"
    },
    {
      "claim_cluster_id": "d9f5972a-ff26-4242-938a-7c9615591c15",
      "event_cluster_id": "f8a7db64-2922-40e3-9fc7-9a7934487f7f"
    },
    {
      "claim_cluster_id": "8ae7ec4c-38f4-4117-962e-b6f044038377",
      "event_cluster_id": "e9cf68ba-8958-4444-b683-81cefe80ccd2"
    },
    {
      "claim_cluster_id": "542e81d5-bf51-451b-bb6a-204f6c8da58e",
      "event_cluster_id": "abbb0c2a-4609-4a58-819a-928af8ad2bfc"
    },
    {
      "claim_cluster_id": "b60b834e-1991-44ea-a53f-68d101a440a4",
      "event_cluster_id": "0d187a90-37da-4e4b-a2f0-e217ce5cbf79"
    },
    {
      "claim_cluster_id": "86fac771-eb74-4809-8f31-be78d543ad7a",
      "event_cluster_id": "cc163006-eb32-4037-8b14-d4cea8207017"
    },
    {
      "claim_cluster_id": "ed1ca8c0-7841-4109-ada2-99053838abfe",
      "event_cluster_id": "1ac6b5e1-dffe-48e8-ab2a-c58a20b3c8dd"
    },
    {
      "claim_cluster_id": "e21b1b35-31f0-4c02-9069-b35c0b38b172",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "c198c115-5575-4cd0-82cc-408f1b46a7a2",
      "event_cluster_id": "015ba6d4-e890-401b-9586-28896557504b"
    },
    {
      "claim_cluster_id": "db07f4e5-716a-41e4-989c-98ced62f8fd5",
      "event_cluster_id": "36d66c66-9c93-4123-875e-3e9fbe514722"
    },
    {
      "claim_cluster_id": "d00bd384-4d89-4a56-8487-c419c52438e5",
      "event_cluster_id": "72084673-8080-44fd-8f5b-97507abf262b"
    },
    {
      "claim_cluster_id": "435bc534-7da4-4fec-82cf-af0f2a0a282a",
      "event_cluster_id": "b2b76ff9-4063-44de-a3e0-0b0a58a3a46a"
    },
    {
      "claim_cluster_id": "71b86c5b-0ae0-46d5-a172-4da94679db3d",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "f44705d5-ac0c-43e4-b025-c68545daa916",
      "event_cluster_id": "67852dd4-618d-4a28-8987-e12077575820"
    },
    {
      "claim_cluster_id": "7b4d9f3b-78aa-4507-8228-424f51cb5289",
      "event_cluster_id": "5bcb47eb-6ba9-4c85-9880-f3ab015417ea"
    },
    {
      "claim_cluster_id": "850a1f31-fc4f-4578-baa4-da3b7a35e30a",
      "event_cluster_id": "d623d9ee-820d-4287-a726-51fa68088d0a"
    },
    {
      "claim_cluster_id": "7f1f819a-52dd-40cc-92a1-28526195605d",
      "event_cluster_id": "ce4675a2-eebc-4f4f-bcc2-33cbe65f4024"
    },
    {
      "claim_cluster_id": "d935874a-c33c-4b74-9137-99d8fd9fc1f8",
      "event_cluster_id": "a258e4b2-c3eb-4705-92c4-2f0c1074629b"
    },
    {
      "claim_cluster_id": "df5b4e50-7d1b-4d7e-ae01-046530298250",
      "event_cluster_id": "15bdefb4-3c81-4573-bb02-e7a3789e75e2"
    },
    {
      "claim_cluster_id": "4157a1dd-b3d1-4769-8ef9-bd2189b4146b",
      "event_cluster_id": "22a6dab9-0118-488c-a537-5d58e3ff3a75"
    },
    {
      "claim_cluster_id": "97037755-caf6-49ed-8d7a-bb7c0d42bf8c",
      "event_cluster_id": "e12f223e-9c33-4c5f-9e5c-badae44a41f7"
    },
    {
      "claim_cluster_id": "2972b17d-9533-46fe-a896-a36d50916446",
      "event_cluster_id": "4fe1a1d1-0c63-4497-8366-24cf2914a93f"
    },
    {
      "claim_cluster_id": "09a468db-6b0d-4230-a370-cfd6ba61219e",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "990306d6-263b-4984-88f5-4be9fc326334",
      "event_cluster_id": "6cf1f120-eb6b-4ef5-8ea8-be39f36cebee"
    },
    {
      "claim_cluster_id": "1746dc9d-7bd5-45f4-a86e-d7bc4c937633",
      "event_cluster_id": "6c980521-41af-4980-91ad-a696c286064c"
    },
    {
      "claim_cluster_id": "83965363-a851-4083-ae10-33f90da464da",
      "event_cluster_id": "0be4cdd7-0577-44ad-9263-d020c0d38b8c"
    },
    {
      "claim_cluster_id": "76ba9e0c-8b5a-4b06-92f8-9ce9caa47714",
      "event_cluster_id": "21e6b94f-0371-4a78-aa0e-8082ef7b0068"
    },
    {
      "claim_cluster_id": "70b45d78-dfac-4810-b7f6-abeea55c435f",
      "event_cluster_id": "7ce03874-cd65-4bdc-9ec5-e264566fa468"
    },
    {
      "claim_cluster_id": "a764eb56-b1bb-470b-bb17-4bd9f5369b4b",
      "event_cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87"
    },
    {
      "claim_cluster_id": "a7436ce6-07d0-45e0-8628-2de252e4cb46",
      "event_cluster_id": "8e8f1a63-a25f-436d-856a-cda548ff35df"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "3e318927-1041-4535-a22e-049f32238ea2"
    },
    {
      "claim_cluster_id": "138e6c92-a8bd-4f22-8e72-b320bdcf0b62",
      "event_cluster_id": "77183e66-d172-4f0f-b205-95c246afc00a"
    },
    {
      "claim_cluster_id": "88f4c27e-7029-43e0-805c-44699284d312",
      "event_cluster_id": "126a3f86-7f2c-4e93-8c54-043a34be7761"
    },
    {
      "claim_cluster_id": "f387c566-78b4-4549-b5d3-12ab9f1a83af",
      "event_cluster_id": "5ff5f55b-42b2-4238-8f0e-2306bf47cc82"
    },
    {
      "claim_cluster_id": "e633b9f2-d6c2-4c51-83af-0aed2e577009",
      "event_cluster_id": "b1eea9c0-c6c8-4d17-a1f4-b1ddcc163363"
    },
    {
      "claim_cluster_id": "1405f96f-07a0-4454-a7cb-365f38772605",
      "event_cluster_id": "a130a6d0-55d6-47e5-9fb3-2d64b90c9bf0"
    },
    {
      "claim_cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "event_cluster_id": "3871454f-b8ca-4976-ba58-fba8307b403e"
    },
    {
      "claim_cluster_id": "dfd9bb6d-a08b-428d-8e19-e9eebd219088",
      "event_cluster_id": "55dd7d4d-d0df-496a-b949-1f305611420e"
    },
    {
      "claim_cluster_id": "f10a7215-4011-4959-9b86-e9f3848b78fb",
      "event_cluster_id": "f5af21c1-57be-4378-ab8c-5400cfed6bff"
    },
    {
      "claim_cluster_id": "ddf6dff1-95bb-49d1-93d2-18eeac6d22bc",
      "event_cluster_id": "e0993394-090d-4043-91c6-3b265e1bac79"
    },
    {
      "claim_cluster_id": "4e78b61e-317a-4417-b42d-464646384193",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "f6f15ea6-27bd-499b-a6fe-74d144b5ac0b",
      "event_cluster_id": "19c1333f-bc11-4412-9e3b-c195d71596c2"
    },
    {
      "claim_cluster_id": "9254d2c4-775d-4f48-975f-879f17b9f193",
      "event_cluster_id": "3a63a5d8-fef0-44dd-9aaa-21b0ee109283"
    },
    {
      "claim_cluster_id": "0c685bcc-0513-4b5c-8ba7-c302c985ff66",
      "event_cluster_id": "43836beb-3651-49f1-a0f8-ad3c4daaab70"
    },
    {
      "claim_cluster_id": "d65c0d37-123c-4e39-9b2d-386613952a30",
      "event_cluster_id": "60bb0c9e-70a1-4ee7-b0be-a6fdab4ba548"
    },
    {
      "claim_cluster_id": "c5855521-5ebf-478e-a7af-b3f07554a912",
      "event_cluster_id": "0d3f46d1-7a84-428a-aa26-c10a575083b5"
    },
    {
      "claim_cluster_id": "e58c74de-137e-4144-8780-c4e86fcc480a",
      "event_cluster_id": "f03d0193-877c-43d8-81d9-6519c6ca169a"
    },
    {
      "claim_cluster_id": "29223456-9a08-4f68-9ce7-d62d961fb6aa",
      "event_cluster_id": "897c7076-ce98-4405-aaa5-1e883a645242"
    },
    {
      "claim_cluster_id": "0a1db453-23bf-4b25-a04b-c4f13d273e88",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "a38268fe-ba89-4d63-8481-63c080523a0a",
      "event_cluster_id": "5008f252-8b6e-4832-ae6f-1940fe20e4de"
    },
    {
      "claim_cluster_id": "e20ec3dc-5039-4e9b-be7d-622592bf425d",
      "event_cluster_id": "74542328-97a3-4775-a89c-6406225efc20"
    },
    {
      "claim_cluster_id": "23dcfd5c-77ee-4590-92a1-d00d1da215c4",
      "event_cluster_id": "ff15e2e2-1cc8-45e2-9674-8847b94be12b"
    },
    {
      "claim_cluster_id": "14b46c0a-7b16-4722-b599-90d7d69970a1",
      "event_cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"
    },
    {
      "claim_cluster_id": "f9c87407-e574-417b-a567-8221daa6ee9c",
      "event_cluster_id": "17d6daaf-12c7-4c0b-88cb-bf8161dd5be6"
    },
    {
      "claim_cluster_id": "29149f19-2cff-4344-bb10-8e0506dbc049",
      "event_cluster_id": "b05a0ac1-6107-4a11-aa69-1115d8b00d86"
    },
    {
      "claim_cluster_id": "fce83401-10d4-4ac6-b19b-510657c941dc",
      "event_cluster_id": "015317d7-08c9-4925-98a2-39e2a1fa7c6d"
    },
    {
      "claim_cluster_id": "487393b6-56b8-4c3f-bdb3-88dbd2ac69d5",
      "event_cluster_id": "5e59f3a9-c776-4791-b6c4-d58d75f185a7"
    },
    {
      "claim_cluster_id": "011b48fb-6ec4-41cc-bd4d-394e371c18cb",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "d8483e15-c78b-44e2-8070-c109cff73a66",
      "event_cluster_id": "e450bc0b-1319-494c-b418-fa5dced99fad"
    },
    {
      "claim_cluster_id": "5863948c-f84b-495d-bfa9-facccb6313d4",
      "event_cluster_id": "756be7cc-dc0e-4799-bd5e-990554a6844d"
    },
    {
      "claim_cluster_id": "ad83e0a6-e572-4332-8ef0-01e05cdfa760",
      "event_cluster_id": "b8e4cc10-e335-4506-831c-61365dc19547"
    },
    {
      "claim_cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
      "event_cluster_id": "9087a989-a032-4a4f-877e-3dd17a8e6902"
    },
    {
      "claim_cluster_id": "29780617-dcdc-405a-a7d2-26d05fd8f9d4",
      "event_cluster_id": "5a419c79-66fe-4be4-a3c1-02415535b5e5"
    },
    {
      "claim_cluster_id": "b471f42f-4da7-4b5a-a11e-18deef221da8",
      "event_cluster_id": "07b11e06-46ec-45e9-8f01-bc31083fd0de"
    },
    {
      "claim_cluster_id": "5a089986-6a82-42ed-90a9-302a1ce45000",
      "event_cluster_id": "d5b4afb5-46e3-4fab-9511-72f4984164cb"
    },
    {
      "claim_cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "event_cluster_id": "84ba9e08-7f87-4e91-abf6-4415ddb9a231"
    },
    {
      "claim_cluster_id": "58f1ee6c-cb8a-434d-b4d0-2f32913f3f4e",
      "event_cluster_id": "ee0b2c4e-ce44-4f3d-90ff-fd0a1c204fa5"
    },
    {
      "claim_cluster_id": "a6d92a93-8990-407f-a2ca-8786c79330ee",
      "event_cluster_id": "763eccef-6999-42f0-bf57-610e354559e9"
    },
    {
      "claim_cluster_id": "5b2c4526-459d-4b6f-8f31-bd40fccf12ff",
      "event_cluster_id": "d2f70202-2b46-45a9-9905-a0ccfee90661"
    },
    {
      "claim_cluster_id": "767386e5-6b6b-4b02-8200-421222dc2720",
      "event_cluster_id": "60cef9d1-8d47-44f3-9820-0cdbe57600fb"
    },
    {
      "claim_cluster_id": "f46bebef-6c63-4778-a5c7-e0d7b893e969",
      "event_cluster_id": "31310d54-1285-4857-b35a-cbc2a3d3bfc2"
    },
    {
      "claim_cluster_id": "8b798ea6-1045-45b9-a2f6-023a84ae6ad3",
      "event_cluster_id": "8b3eb310-4541-41ce-8ebd-0c1cfe7b2a0d"
    },
    {
      "claim_cluster_id": "dfa47852-ac3f-4b74-bc17-22923a395552",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "0f388428-daa1-4ce6-a7b1-8c553ad3896d",
      "event_cluster_id": "708ac391-bd79-4343-a52b-53252ffe59cb"
    },
    {
      "claim_cluster_id": "06ceeed7-8a02-425d-9be1-3881dcb38762",
      "event_cluster_id": "dd07650f-5b24-4fc1-a78a-9b6fc6589ccf"
    },
    {
      "claim_cluster_id": "f0e862e5-92ba-499e-8f7b-4935ce01c5fd",
      "event_cluster_id": "43836beb-3651-49f1-a0f8-ad3c4daaab70"
    },
    {
      "claim_cluster_id": "1e9c3202-7611-4885-bb24-d9dd05b7eed3",
      "event_cluster_id": "ebe02d8b-ea82-4232-851f-f5ea26e54e8f"
    },
    {
      "claim_cluster_id": "017c8345-ee2f-4b6f-8701-6def5bbd5082",
      "event_cluster_id": "c55fe718-0683-4449-8b87-8d1de09aac69"
    },
    {
      "claim_cluster_id": "5d8d730b-6674-4d5b-8f99-6c8e240e9080",
      "event_cluster_id": "abf9a23b-ae17-4adc-8775-9b47f6861ebe"
    },
    {
      "claim_cluster_id": "a34f85b1-92bb-47d3-b089-7365f6b9f51f",
      "event_cluster_id": "2f03e50c-f48e-4212-9d22-0ac755bb8fe3"
    },
    {
      "claim_cluster_id": "f6a4aea6-92b4-4a70-a984-2326df1ee39e",
      "event_cluster_id": "6c41a4c1-08f4-483e-b095-97806b1140bf"
    },
    {
      "claim_cluster_id": "d089f75e-69ee-4713-8c0e-27843b110a2a",
      "event_cluster_id": "5a9d340b-259a-49d7-894d-4e9c6dec6a07"
    },
    {
      "claim_cluster_id": "579db367-74ad-4432-9888-8af443f74bd8",
      "event_cluster_id": "c99367c6-2c05-4a14-b047-7f8ff36ff133"
    },
    {
      "claim_cluster_id": "796ddc52-9094-4fcb-af10-9fa6a06448ba",
      "event_cluster_id": "0ebcd390-0474-4d90-81dc-d03c9dac78e4"
    },
    {
      "claim_cluster_id": "8ac816b2-de5c-4294-a968-e6279613b1d8",
      "event_cluster_id": "66034097-f5ff-415b-b7cc-7775692bf89e"
    },
    {
      "claim_cluster_id": "a03d3de9-e5ad-47e0-9374-17e6c1998859",
      "event_cluster_id": "337fae10-d08a-4844-b763-fc332cdde523"
    },
    {
      "claim_cluster_id": "8aec1af3-93d7-45b8-8844-62e8b3ac6198",
      "event_cluster_id": "e2995c43-c086-47bc-aceb-1e2374b7e24a"
    },
    {
      "claim_cluster_id": "192dfe82-fc68-4d4d-ae38-d6077567ed10",
      "event_cluster_id": "5c4c352e-d04c-4f9a-889b-492cb2fb067c"
    },
    {
      "claim_cluster_id": "e7def08b-a4be-4464-b5ad-7e8f1dfa8752",
      "event_cluster_id": "651043d1-0d9f-42ac-bcb3-c7e39b7939ec"
    },
    {
      "claim_cluster_id": "338d5a8d-64c7-4bed-a37e-208196096015",
      "event_cluster_id": "11663b2b-28c7-494e-973e-2fc5dca8374b"
    },
    {
      "claim_cluster_id": "1aadbdec-7f0b-43f3-98a7-709a1bcb5807",
      "event_cluster_id": "9f3b49b5-fd07-4adf-8183-7615100c8917"
    },
    {
      "claim_cluster_id": "8a0c21a3-b47c-4676-b965-59f7699171ec",
      "event_cluster_id": "3c66cbc4-f759-4da9-9813-b36b4c322970"
    },
    {
      "claim_cluster_id": "8b798ea6-1045-45b9-a2f6-023a84ae6ad3",
      "event_cluster_id": "ed912a16-7c22-4013-aecd-05fbaf2f3003"
    },
    {
      "claim_cluster_id": "a74a2d72-1d86-4264-9389-b4fe594a7218",
      "event_cluster_id": "6195dc7b-895b-4134-9995-738fed6389e2"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "abea76a9-3994-48b0-b3bb-df2d7f55ad12"
    },
    {
      "claim_cluster_id": "dcf5235c-74f7-409c-bb59-9454cc01feed",
      "event_cluster_id": "0ba7abed-e798-4cd4-b041-3026081313b7"
    },
    {
      "claim_cluster_id": "342cdbac-7da2-46b3-80b3-a9b75e8fee10",
      "event_cluster_id": "2dbc4a6b-98c2-45e2-be58-a00cfa47819c"
    },
    {
      "claim_cluster_id": "9254d2c4-775d-4f48-975f-879f17b9f193",
      "event_cluster_id": "66095ea1-59d7-4068-855b-70fe6ff9d81b"
    },
    {
      "claim_cluster_id": "dfea6d47-10c8-4540-8a78-5667ac532c10",
      "event_cluster_id": "ad2e25ad-1bb4-4fa6-8af1-bce0c9f8c697"
    },
    {
      "claim_cluster_id": "cb25f623-bfdb-42c7-9873-fa48f80feade",
      "event_cluster_id": "60bb0c9e-70a1-4ee7-b0be-a6fdab4ba548"
    },
    {
      "claim_cluster_id": "2cb357c3-3958-45ce-bb44-f76facb84ed9",
      "event_cluster_id": "97cdd3f9-b13e-4b85-9e62-c48c3b34bca9"
    },
    {
      "claim_cluster_id": "1d4acd59-7bc7-421b-87d6-c6dcd6e61497",
      "event_cluster_id": "b27be68c-0a41-440c-9295-b88b093fc572"
    },
    {
      "claim_cluster_id": "e65823f0-739f-4ed0-bd57-83b926046577",
      "event_cluster_id": "7e3a0dda-730a-409c-87a4-d60847af0bea"
    },
    {
      "claim_cluster_id": "91b0db25-32e4-4e5d-a32d-911732cbec28",
      "event_cluster_id": "23236a04-b4c7-41b8-81ee-60c41aaa7835"
    },
    {
      "claim_cluster_id": "53ddceb6-33d2-42fd-849a-253f21907d2a",
      "event_cluster_id": "0060e859-7676-43d1-9a21-c2ddc4f18fbb"
    },
    {
      "claim_cluster_id": "9560d5ee-30e3-4941-88b8-e0b5144961cb",
      "event_cluster_id": "03329c55-b9c0-4585-b5b1-817ec3b57899"
    },
    {
      "claim_cluster_id": "4fc00d95-d399-4677-9437-13f7e6f573c4",
      "event_cluster_id": "49c9cf48-a13c-439b-9db3-4000e6bfc74f"
    },
    {
      "claim_cluster_id": "e935bf33-7d4f-4ee6-8636-94e91a064afd",
      "event_cluster_id": "f70debef-4097-402b-81f2-0ddc396e0729"
    },
    {
      "claim_cluster_id": "e2621663-e9d9-45c1-9069-fa9d94c82303",
      "event_cluster_id": "323ed409-a965-47fb-afbb-d0b2c3bbefa4"
    },
    {
      "claim_cluster_id": "a9b66749-8bb9-4643-bb36-488cbf77974b",
      "event_cluster_id": "ae4c214d-3e4b-416f-8e83-fe80cc92e55e"
    },
    {
      "claim_cluster_id": "a0c8c3de-8102-4a9b-b20a-80ade6132b4e",
      "event_cluster_id": "b4d7baf4-91b3-4011-b5b5-664a10258241"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "c17fb294-56ef-42a8-aa4a-cafb4005de0f"
    },
    {
      "claim_cluster_id": "290bbe27-4d2b-4cc8-afca-2ec5fcb7fa45",
      "event_cluster_id": "63959dc1-33f1-448d-b73f-370297a47c55"
    },
    {
      "claim_cluster_id": "61784f3e-1c50-4b37-9db4-0fd1ec458127",
      "event_cluster_id": "8880a6e5-1a6a-4f2d-8ae9-3f7729adcb35"
    },
    {
      "claim_cluster_id": "4958a7ec-0cd2-487f-a59b-9bc34843a2b7",
      "event_cluster_id": "d56cee1a-0acc-4d28-9308-a2519fc04041"
    },
    {
      "claim_cluster_id": "0bc36847-debb-43d3-bab5-e1a736194eac",
      "event_cluster_id": "4d35ec7a-3721-4f70-b323-8070302a4c95"
    },
    {
      "claim_cluster_id": "1f1f405f-6b99-4de2-b4fa-1bd105b3c577",
      "event_cluster_id": "3b00f0b1-76ec-42b4-8949-3a408087b558"
    },
    {
      "claim_cluster_id": "ce07721b-5347-4d52-81aa-7a7c68338485",
      "event_cluster_id": "4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c"
    },
    {
      "claim_cluster_id": "2c351118-b702-46fc-bce1-27477e956eb0",
      "event_cluster_id": "34ebf375-c746-4b55-870a-320a9407196d"
    },
    {
      "claim_cluster_id": "b6e9f077-b94a-483e-a60f-d0f3f875ea60",
      "event_cluster_id": "1e4d6697-c15f-4888-819c-dc2c8687c928"
    },
    {
      "claim_cluster_id": "f1afc4d0-4eaa-40ab-99e6-20e11c550ccb",
      "event_cluster_id": "b6fed6af-5368-4204-a338-2997b148a384"
    },
    {
      "claim_cluster_id": "62fc9d37-f7e6-43e7-a681-3c5679294ee9",
      "event_cluster_id": "fdc8411e-7a17-4fc6-bef2-367c46894068"
    },
    {
      "claim_cluster_id": "b93f59d3-e54a-4700-86ef-b20c995b73b6",
      "event_cluster_id": "8b267081-f50e-4410-bb56-f7281271aae7"
    },
    {
      "claim_cluster_id": "839faa06-15df-459d-8f1d-015981c670e0",
      "event_cluster_id": "4da30c02-5a8f-4e15-af9d-b0a7ede85a55"
    },
    {
      "claim_cluster_id": "a9096ed8-3c07-4fd9-a21c-9fdb59fe1353",
      "event_cluster_id": "a5ce0433-5607-4061-b0d6-334f9dea23ec"
    },
    {
      "claim_cluster_id": "a8c4b29d-3d45-4e5e-b6ef-06f93957d16a",
      "event_cluster_id": "b92e2016-2cf5-4f68-ae85-5c01d12bbd49"
    },
    {
      "claim_cluster_id": "54e59784-1db4-41f0-a651-2d5e2138670a",
      "event_cluster_id": "1a1fe423-28a9-476d-a154-c1e0960501dc"
    },
    {
      "claim_cluster_id": "5833eaa5-8c9c-42b9-bd12-8cdf781ec725",
      "event_cluster_id": "9e950aab-bcb8-467d-b56c-2d0bc86754ee"
    },
    {
      "claim_cluster_id": "7cff4302-4ea6-4196-96e5-448a227d2f09",
      "event_cluster_id": "3f77000e-b7d1-457b-963f-2743a0bda688"
    },
    {
      "claim_cluster_id": "dac4f0e5-e31b-44cc-a055-3ac65eec9d11",
      "event_cluster_id": "17e824c4-f35e-49c3-9ffd-3049f0003451"
    },
    {
      "claim_cluster_id": "27097c65-59e7-4824-9bbb-c0736b2c9f70",
      "event_cluster_id": "60a5fa4a-02a4-4e44-b778-ab28e2e5eb27"
    },
    {
      "claim_cluster_id": "ed3519a5-2328-44c8-be3b-f36796b25965",
      "event_cluster_id": "c9780602-10a7-414d-9965-0df44aadba9b"
    },
    {
      "claim_cluster_id": "6cade303-8a3e-4226-b5e8-0d3b189187cb",
      "event_cluster_id": "635850fb-0b7d-4148-aae4-786dbec7ebb9"
    },
    {
      "claim_cluster_id": "976d7c8a-cb17-41e5-9407-5cd8c141bb84",
      "event_cluster_id": "7a9ddc4d-79e3-45ee-a4d8-9a05a9685354"
    },
    {
      "claim_cluster_id": "8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6",
      "event_cluster_id": "a1c74ee2-0da5-4362-bf0c-2f7caddeae61"
    },
    {
      "claim_cluster_id": "ac4174c2-4597-4a76-ac06-95cefda372c9",
      "event_cluster_id": "6e8c4432-d4c6-4fcd-9e26-cf2164b211ae"
    },
    {
      "claim_cluster_id": "9352b2a0-83e7-4ffa-ae39-61c24aa700b8",
      "event_cluster_id": "c1036fd0-74b9-4ac8-a4d8-2710377e38ff"
    },
    {
      "claim_cluster_id": "7f180ad9-d196-4c1e-8dc6-209c613a3fa3",
      "event_cluster_id": "0fa7a4b5-a1c3-4039-a50d-a01dc2e3920a"
    },
    {
      "claim_cluster_id": "391ac4c5-638b-42bc-b8d7-1972d56df43e",
      "event_cluster_id": "f44c0c51-4b5f-47de-9ff7-9cd4c4c2b58a"
    },
    {
      "claim_cluster_id": "ceabee0f-bc28-4b8e-8445-fc63ff551472",
      "event_cluster_id": "86a1cb16-ab28-4b30-be94-ef12abdf7cfc"
    },
    {
      "claim_cluster_id": "cd1cad7d-4c68-4a07-b4fd-c8e01c9f94cb",
      "event_cluster_id": "e95aa789-4bbc-4c2d-aa4e-ab829c64ed4e"
    },
    {
      "claim_cluster_id": "c721dd3f-abaa-46f4-b0b3-0998badfc28c",
      "event_cluster_id": "6d0ecf89-9eab-4b55-8c05-ab0885982adf"
    },
    {
      "claim_cluster_id": "a94e5bcb-b502-4cb7-a23d-3a1e29ce963a",
      "event_cluster_id": "3044ed83-9d35-4f0f-9d53-c999faefc097"
    },
    {
      "claim_cluster_id": "6aa59122-6821-4e76-8afb-2ad2b679a5aa",
      "event_cluster_id": "028c83e2-81b7-4016-ad11-5ab7dddf6569"
    },
    {
      "claim_cluster_id": "97fd88d2-827f-418a-aa85-784dc98e83f5",
      "event_cluster_id": "37a15ab9-c9e5-493e-bc55-f1d64743861b"
    },
    {
      "claim_cluster_id": "1da96a0b-d833-4078-afdc-5a85d522b86d",
      "event_cluster_id": "773c7be2-511f-4315-b512-fcfb831f2cc3"
    },
    {
      "claim_cluster_id": "44f7e426-bb87-4dd0-bf0c-80fb71c61eac",
      "event_cluster_id": "a9c08567-c779-4007-8ddb-2cc8e3429124"
    },
    {
      "claim_cluster_id": "5a8c09d4-337f-442b-8464-f2be567010bf",
      "event_cluster_id": "dae1826c-9197-4507-aadd-a2ba9a01285b"
    },
    {
      "claim_cluster_id": "d11c600b-0ae3-4e55-8d1a-58fd9d0f71dc",
      "event_cluster_id": "ab8af083-dfdc-4c18-95cd-32d551c130c1"
    },
    {
      "claim_cluster_id": "09f8ca5f-e359-4e32-b6bf-f706de588232",
      "event_cluster_id": "b0ba837e-7026-4676-894c-bd729208b8f0"
    },
    {
      "claim_cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "event_cluster_id": "a71276bb-c498-4f7f-840a-9e20eea63e3d"
    },
    {
      "claim_cluster_id": "e968bf8c-b2a8-4330-bf71-9cab4f6826a5",
      "event_cluster_id": "a9876e6a-52b6-4181-945b-9e745a17434b"
    },
    {
      "claim_cluster_id": "078f370f-a761-435a-a7fd-aae948eb479b",
      "event_cluster_id": "442c0a4f-c382-4b95-be13-3c18f2d71210"
    },
    {
      "claim_cluster_id": "f92684c8-da9a-477a-ba9a-9eb41a6f9f90",
      "event_cluster_id": "985e777f-c3e3-42f1-b650-98ac19e7f7b5"
    },
    {
      "claim_cluster_id": "76e2cae3-f195-4448-9b25-588665927aca",
      "event_cluster_id": "485753eb-23f4-446f-a237-3a4fc59f9bd1"
    },
    {
      "claim_cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "event_cluster_id": "6eb6f4d9-183a-4612-a4f7-dd59bbc26512"
    },
    {
      "claim_cluster_id": "00386fb1-3dcc-4b4e-b74b-bc14dbc4e260",
      "event_cluster_id": "a5cfe32e-2f16-4644-a4e9-767621b4c4a7"
    },
    {
      "claim_cluster_id": "7f43c7d3-2a4b-493c-b3f0-a53355ae39a3",
      "event_cluster_id": "4551b9a3-cfb2-4080-a1f5-d94f9554a9e1"
    },
    {
      "claim_cluster_id": "57eb29a4-6d1b-4f98-a507-b97e4235688c",
      "event_cluster_id": "29912b0c-71dc-4757-ad86-50cb8c825cd7"
    },
    {
      "claim_cluster_id": "43784351-864b-42c8-bac5-2de22a3743c2",
      "event_cluster_id": "8c73e80e-645f-41d1-b314-c8d7737bd33f"
    },
    {
      "claim_cluster_id": "86e5843a-553f-41b4-aec2-73c2638e9bca",
      "event_cluster_id": "dd21a7e1-c272-4900-8da2-788f661f4b0b"
    },
    {
      "claim_cluster_id": "0cffe066-8740-4f3f-9c12-d03f093733d5",
      "event_cluster_id": "80f966d4-497a-4e7a-b9e2-4d30faf7da72"
    },
    {
      "claim_cluster_id": "8f15ddff-3bc7-4fbd-9371-1a897f8b9078",
      "event_cluster_id": "c79e73ba-e1da-436e-8dc9-c8818873c182"
    },
    {
      "claim_cluster_id": "8140cb8c-a254-4493-b790-598f4ef3676f",
      "event_cluster_id": "57d96007-f80d-4110-8583-3e280492b584"
    },
    {
      "claim_cluster_id": "a63004c7-9e1f-4600-bae4-f70655f0094e",
      "event_cluster_id": "ad63a5c7-e4a9-4703-80f2-827fc6b1bf0d"
    },
    {
      "claim_cluster_id": "89b28f7e-be14-417b-aeba-019498e50195",
      "event_cluster_id": "8693ba93-793a-4911-b2e4-5cb419139802"
    },
    {
      "claim_cluster_id": "ee3408ae-2ea4-4661-a58b-6e825aa4a0ff",
      "event_cluster_id": "c6829bdd-21da-4a4f-9d8a-98920160c65d"
    },
    {
      "claim_cluster_id": "d3bded76-52fd-4f86-982f-558582eed404",
      "event_cluster_id": "cd8525ab-90a4-434a-bf10-f887240219f2"
    },
    {
      "claim_cluster_id": "6b512fcc-e6a2-414b-8a86-90a11b76795a",
      "event_cluster_id": "04b6753c-ecde-472f-9566-0e86e4ac2a52"
    },
    {
      "claim_cluster_id": "d8c4ecf1-bb1b-4da0-8a1b-b80059b7063b",
      "event_cluster_id": "3092d2a7-23cc-41c3-b8bd-3096963a1b79"
    },
    {
      "claim_cluster_id": "c78cce84-ea53-4b86-8393-67ca74594e0c",
      "event_cluster_id": "0e6b6876-fb14-4627-9900-55ce513c116c"
    },
    {
      "claim_cluster_id": "4effafac-8e45-4dfc-8f71-d8c9b1e37d7b",
      "event_cluster_id": "e74b075b-e6e4-4efc-b7ef-f8a74fd509a0"
    },
    {
      "claim_cluster_id": "24a2e46d-b5a2-4677-a613-c39e311e8f1d",
      "event_cluster_id": "b270ac4b-0013-48c8-8b62-49d992310a4e"
    },
    {
      "claim_cluster_id": "f4f83538-936e-4149-94c2-66b6b2ac2571",
      "event_cluster_id": "c849043f-d317-458e-b56e-651b8d73a135"
    },
    {
      "claim_cluster_id": "2951f722-7d9f-4f1b-b69b-0dfe73efebd5",
      "event_cluster_id": "e7ad9ef4-67e0-4758-9909-6db3f8c0c4b5"
    },
    {
      "claim_cluster_id": "478db2a7-a90d-4fbf-8954-0416daa97dcb",
      "event_cluster_id": "64ce313a-9f62-48b5-ac72-4f4f23b43da9"
    },
    {
      "claim_cluster_id": "ab1f8fac-3632-4188-90ae-a2c911b8425d",
      "event_cluster_id": "96c115c1-f9f9-479d-9ecc-98da549128b0"
    },
    {
      "claim_cluster_id": "86d26636-5c9c-416b-94e0-e2a89a9628c3",
      "event_cluster_id": "87e0267f-e999-4f76-8883-d246a2dc113c"
    },
    {
      "claim_cluster_id": "83392417-156e-4467-96c4-b7a769a50f3f",
      "event_cluster_id": "cfe9cc78-dae7-4fb3-9619-c934beac1286"
    },
    {
      "claim_cluster_id": "afebac7c-8f71-44cd-beec-d242a1b97e86",
      "event_cluster_id": "8f5bfc0f-9b63-4126-aa4e-caf3448c019e"
    },
    {
      "claim_cluster_id": "cb25f623-bfdb-42c7-9873-fa48f80feade",
      "event_cluster_id": "0257bfac-c84e-478c-a7f4-6a03847d3df0"
    },
    {
      "claim_cluster_id": "1f956691-257e-4b52-8536-1a80ad662f9b",
      "event_cluster_id": "76d75a5b-4dc1-4bbe-8b14-04af1d297ada"
    },
    {
      "claim_cluster_id": "aeb0341a-ad2c-4ec1-b689-ecd5b9a2b868",
      "event_cluster_id": "e5b92c5d-257a-4d84-a804-3e2462bb2954"
    },
    {
      "claim_cluster_id": "61c8550e-839e-4f39-803d-72ebbfa747a7",
      "event_cluster_id": "29cd39ea-ce90-496a-a9f1-6917924ac984"
    },
    {
      "claim_cluster_id": "edd65f26-0117-4202-bd31-c3f265210b5e",
      "event_cluster_id": "8e9141e0-2f9d-4d0a-920e-7ed046dbbcec"
    },
    {
      "claim_cluster_id": "69517d67-11aa-4671-bb8a-815c7995a3b7",
      "event_cluster_id": "63223fc3-b9f1-47b4-9d17-af262f481c02"
    },
    {
      "claim_cluster_id": "141b690c-587b-4b7b-9ad4-7b1b333f6cd8",
      "event_cluster_id": "96ab7552-d195-40c5-b31e-9af997302842"
    },
    {
      "claim_cluster_id": "9ec9965a-96db-46e5-965a-bc307986c26d",
      "event_cluster_id": "a174fdfb-5e90-4340-85c5-f1498bd04f82"
    },
    {
      "claim_cluster_id": "392d337b-80a2-4413-8e08-b0007e5c9b50",
      "event_cluster_id": "c0bc02e5-e391-4352-8bc3-69ffab45a6e1"
    },
    {
      "claim_cluster_id": "a90d4523-8e1f-4287-ae0c-72459f7c14c3",
      "event_cluster_id": "0ed6d266-01da-4d89-816e-946754d220ce"
    },
    {
      "claim_cluster_id": "36ece2d2-4cdb-4985-90ab-a6751ad5b290",
      "event_cluster_id": "409928b1-cabb-476d-812a-3340869af622"
    },
    {
      "claim_cluster_id": "4d4a5a78-bde2-4ed8-943c-811738978e0d",
      "event_cluster_id": "ef1b2d86-739d-4342-9581-88b77e5ebe93"
    },
    {
      "claim_cluster_id": "45339238-abb3-494b-a7ba-d3cde2ab18d9",
      "event_cluster_id": "ee18dcc9-53ec-41c1-9074-bb4cbe5ff92b"
    },
    {
      "claim_cluster_id": "95f30627-ec05-45c4-9f6e-28dd5c31e412",
      "event_cluster_id": "7767473b-b833-4047-b346-9abf204211fd"
    },
    {
      "claim_cluster_id": "a0b96ee6-2ea9-4035-b542-1107b0662e77",
      "event_cluster_id": "e1bd1fc6-e475-4d2c-871d-d09149cf8937"
    },
    {
      "claim_cluster_id": "e7def08b-a4be-4464-b5ad-7e8f1dfa8752",
      "event_cluster_id": "08d6975b-643a-4b0e-a8cb-576006cbf125"
    },
    {
      "claim_cluster_id": "492eadfb-99f3-4bc3-a9af-afa12d93eb99",
      "event_cluster_id": "418497da-ff5e-45fe-b7d6-b0ab00e9f812"
    },
    {
      "claim_cluster_id": "bb382092-b4e0-4652-830e-be1eeb609ad0",
      "event_cluster_id": "49f74be2-2b75-49a2-9647-991264918ba3"
    },
    {
      "claim_cluster_id": "f4d9e677-79ed-4c5c-84a1-d127898975a0",
      "event_cluster_id": "3aad1795-c40d-46c7-abc6-a9e8928bc743"
    },
    {
      "claim_cluster_id": "7966aa4e-476b-473f-85ad-b267835811ed",
      "event_cluster_id": "65f95c9d-be3f-40b0-b287-d80a74be8b4f"
    },
    {
      "claim_cluster_id": "d5458c27-5843-4ff6-b105-7703aeb6f588",
      "event_cluster_id": "8b4dea1f-81ef-489e-9aba-a19d5e926009"
    },
    {
      "claim_cluster_id": "c64abad7-175d-470b-9931-9259e05b39f5",
      "event_cluster_id": "5a9d340b-259a-49d7-894d-4e9c6dec6a07"
    },
    {
      "claim_cluster_id": "af26e832-f248-48e8-93f5-fdb54d01a56f",
      "event_cluster_id": "fe7c0aa8-6a9f-47ad-ae53-9de7a81cea64"
    },
    {
      "claim_cluster_id": "7e245bdc-e727-4627-a96b-f1db937337df",
      "event_cluster_id": "1179f0df-1a7a-4032-9a7e-362081c484c8"
    },
    {
      "claim_cluster_id": "d6ec7b4a-689f-48d4-bb2a-ff95c991125c",
      "event_cluster_id": "49c9cf48-a13c-439b-9db3-4000e6bfc74f"
    },
    {
      "claim_cluster_id": "f90167d0-30b7-4246-8eb8-7c564be9c434",
      "event_cluster_id": "9da8623f-1bd2-4a8e-be97-3ec68da5904b"
    },
    {
      "claim_cluster_id": "2cd7a2ea-67d1-4d2a-8944-a71778dc20d7",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "11210f68-2915-41ff-b25a-a55a575f9528",
      "event_cluster_id": "6cba2b8f-402d-49a5-b1eb-4024641b28c9"
    },
    {
      "claim_cluster_id": "186330e2-1680-455d-ad21-27f2e0125a31",
      "event_cluster_id": "d345d980-af47-4c52-856b-f3fba326963f"
    },
    {
      "claim_cluster_id": "5833eaa5-8c9c-42b9-bd12-8cdf781ec725",
      "event_cluster_id": "beafc838-f8fb-4f24-b442-c5d64c7e1a7b"
    },
    {
      "claim_cluster_id": "579069a3-1a62-4c32-8658-b35e45309ccb",
      "event_cluster_id": "5f698021-f0a7-4748-8344-6112bbe0b66e"
    },
    {
      "claim_cluster_id": "f8ceed1b-ae48-442b-9e71-03f2203d7e38",
      "event_cluster_id": "014863d4-ae1c-4c35-8738-d91dc371f2a4"
    },
    {
      "claim_cluster_id": "029b01a5-6f18-4a7f-96f8-6bde44853032",
      "event_cluster_id": "df8da41a-f9cc-4448-aae3-112ed4b0b247"
    },
    {
      "claim_cluster_id": "c8a67d7e-6b5c-49cc-b944-ad699ac9cff0",
      "event_cluster_id": "8a30c746-b21f-4f8b-b1ab-389110f61293"
    },
    {
      "claim_cluster_id": "791c0550-4877-4364-97d4-01b5b8435b0f",
      "event_cluster_id": "65c4b6f4-f33a-4b23-a073-15587ff25d75"
    },
    {
      "claim_cluster_id": "4eb34d6f-2849-4a6f-9012-a59681fdeeff",
      "event_cluster_id": "87ccb180-4860-4e8d-af6f-a3acda89b6bf"
    },
    {
      "claim_cluster_id": "b54e5664-a40b-4682-b959-bcfb59ddd4b0",
      "event_cluster_id": "2fb74668-36fe-4d43-9c95-f7bf88e2f60c"
    },
    {
      "claim_cluster_id": "284e7f1a-ee5c-4c83-986e-6b13c6c2e6b5",
      "event_cluster_id": "b2d9b3c8-468a-4cb2-9381-64f806a79262"
    },
    {
      "claim_cluster_id": "bd9462e2-36b0-48f7-92f9-c83dd2ee5550",
      "event_cluster_id": "48f8cfb0-8d27-4a6d-8530-ed9a63c77de6"
    },
    {
      "claim_cluster_id": "adfa00d7-81da-47be-a9ec-4b8dfb8ee34a",
      "event_cluster_id": "abbea790-2006-423f-9f7d-2f67dda5b47d"
    },
    {
      "claim_cluster_id": "1a968bfe-5bc1-4f49-8a3c-fc2e0fdbf254",
      "event_cluster_id": "cdc110ac-1c3e-4435-8e2b-221f6de6a9c7"
    },
    {
      "claim_cluster_id": "5677f10d-93dc-4b72-b95a-8bc4291ec487",
      "event_cluster_id": "b38c991a-b869-4a3d-9864-3fdbb089a284"
    },
    {
      "claim_cluster_id": "d6d20ec3-ee81-4cbc-8cc9-9bd366cd24db",
      "event_cluster_id": "f44c0680-07c7-4ea0-8054-7643f1b8eafd"
    },
    {
      "claim_cluster_id": "2fdb1c74-dc8a-4068-93d3-ff9e7c3e4528",
      "event_cluster_id": "a99e560b-cb11-48f1-ac8e-d85b9a82ba77"
    },
    {
      "claim_cluster_id": "ff70f7bd-e1b1-44ea-8b32-024f3d1917ed",
      "event_cluster_id": "33e00989-9970-4b46-a3f1-4c221fc84217"
    },
    {
      "claim_cluster_id": "0a3a7c87-61b9-4961-a698-61129e827319",
      "event_cluster_id": "be6d3887-f154-45dd-b994-3e262cd683ab"
    },
    {
      "claim_cluster_id": "d1f2b2ed-be0f-44a4-a171-4b848f482ca9",
      "event_cluster_id": "c724c59d-be1d-40e0-8e89-b56ec9ff6193"
    },
    {
      "claim_cluster_id": "186330e2-1680-455d-ad21-27f2e0125a31",
      "event_cluster_id": "cda7a1d3-b038-4c3b-864e-35781faec81a"
    },
    {
      "claim_cluster_id": "980136c6-363f-4cda-bc50-cca417518993",
      "event_cluster_id": "04568cc7-5dd8-42b7-8a07-715cdd043c03"
    },
    {
      "claim_cluster_id": "e633b9f2-d6c2-4c51-83af-0aed2e577009",
      "event_cluster_id": "7ba2e807-ddc2-4313-891b-359c6bfa546b"
    },
    {
      "claim_cluster_id": "efb200e1-1771-49d7-a8fb-d8bd8317e7a0",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "6b22978f-c41a-4fd1-ac4e-29deafe60573",
      "event_cluster_id": "c160d7d3-0687-4ba7-86ad-32e9cddeaf56"
    },
    {
      "claim_cluster_id": "5b79e5f7-f49f-4b4e-b9a7-5554797ebbeb",
      "event_cluster_id": "89bc3f77-435c-48cc-9674-3f733858f60d"
    },
    {
      "claim_cluster_id": "4892691c-c25d-434c-bfaf-8b1764a0e393",
      "event_cluster_id": "07b11e06-46ec-45e9-8f01-bc31083fd0de"
    },
    {
      "claim_cluster_id": "d9f390bf-adde-404e-a2f9-1fc28cc17576",
      "event_cluster_id": "4b93a421-107c-4185-912b-a73d039895b4"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "70862016-3977-4b4b-9e68-43859faa28ba"
    },
    {
      "claim_cluster_id": "9d2cc997-e857-4b80-a227-cc6a1c61d16d",
      "event_cluster_id": "ddf8f300-b701-4129-bf0a-f30da96bc031"
    },
    {
      "claim_cluster_id": "a49a51da-aad1-43de-81b7-51f95b22eabd",
      "event_cluster_id": "5279c839-650e-45b8-a4b4-5af5d5649ea3"
    },
    {
      "claim_cluster_id": "fdae240e-8bc7-467c-b880-f3913e28e6ce",
      "event_cluster_id": "5605c591-48df-4465-a293-86fc68f1944a"
    },
    {
      "claim_cluster_id": "1e227a80-8d1d-4484-9608-82719d3b526e",
      "event_cluster_id": "335924d4-8c81-4bf0-8e93-746bc3bcb081"
    },
    {
      "claim_cluster_id": "5518570b-ceeb-400e-8720-a531292d57ce",
      "event_cluster_id": "e52a7c45-1c0e-4caf-a481-c7da67d6803c"
    },
    {
      "claim_cluster_id": "71522ed0-7107-4dfb-8b87-e633332c4e3f",
      "event_cluster_id": "a58a3450-f18a-4787-a5ff-ce87f4539ba9"
    },
    {
      "claim_cluster_id": "7187c5ae-6f6b-4c6a-af65-98db1f5251db",
      "event_cluster_id": "b38033d5-5b50-487f-be85-35eacb567316"
    },
    {
      "claim_cluster_id": "ddf6dff1-95bb-49d1-93d2-18eeac6d22bc",
      "event_cluster_id": "827901e2-9d83-4ed3-ac71-af38455fbc22"
    },
    {
      "claim_cluster_id": "e3e4b634-fa33-47d8-9f29-eefdbb263769",
      "event_cluster_id": "9e771d92-eea3-45ec-b1c4-e7bba0011301"
    },
    {
      "claim_cluster_id": "9b129e4b-0540-473c-90ae-ff21e622eb3c",
      "event_cluster_id": "7fe9b7f3-5fcc-469d-bfc5-789d2c7ecb0c"
    },
    {
      "claim_cluster_id": "4767808d-19a9-4e75-b8a7-7421cf37c72f",
      "event_cluster_id": "40265b93-5ea0-4bd6-8b7d-972baab54b70"
    },
    {
      "claim_cluster_id": "a3272ef4-947f-46a0-b484-adddd74b2e08",
      "event_cluster_id": "4cdfe663-949e-4463-904d-7ad58162fcfa"
    },
    {
      "claim_cluster_id": "1a660b55-5f53-4246-a227-98df9e4e2ac4",
      "event_cluster_id": "9b321e6e-fd77-47ca-b965-6aceb0683d37"
    },
    {
      "claim_cluster_id": "7b49f746-2118-4c08-9ef0-985906af7b07",
      "event_cluster_id": "e72c5c13-765f-4dae-aecd-48d78cd16ece"
    },
    {
      "claim_cluster_id": "5a33a893-0ae3-4e2b-9f4c-02de9772f96c",
      "event_cluster_id": "92352325-85b6-4726-9aed-67119e9599f9"
    },
    {
      "claim_cluster_id": "644ce0a3-b992-4dbe-be7f-558277802f15",
      "event_cluster_id": "a65da1cd-8a4f-401e-8439-da2c5c03bd1b"
    },
    {
      "claim_cluster_id": "19d43c44-0b32-47ac-85c1-a05682078f22",
      "event_cluster_id": "cf0c77f3-683e-467a-b83c-95b78a12d867"
    },
    {
      "claim_cluster_id": "4afb1f4b-4686-4338-bf49-bdd4d2091f0a",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "da33144e-1465-4006-aabf-42e89071cdf4",
      "event_cluster_id": "9687983c-2f58-4f1f-9d09-86f19210af37"
    },
    {
      "claim_cluster_id": "5cf9fbcc-d33b-4ff7-b888-4b9e4e5ca4e1",
      "event_cluster_id": "11663b2b-28c7-494e-973e-2fc5dca8374b"
    },
    {
      "claim_cluster_id": "fde51b3d-8646-4df9-926d-484efbe86dc8",
      "event_cluster_id": "0ecff957-070a-4e14-9ee5-9c4a7435ec3e"
    },
    {
      "claim_cluster_id": "7eefde16-5844-4305-a679-da87990a2640",
      "event_cluster_id": "93067eb9-0c23-4760-88de-71a2925db3fb"
    },
    {
      "claim_cluster_id": "24f6a0c0-6612-4488-bc48-40d12340ab22",
      "event_cluster_id": "4bacc8d6-9346-41d5-8d0a-b2a14974c1c3"
    },
    {
      "claim_cluster_id": "10e97fc5-5fa6-457f-aefb-257e90e8124b",
      "event_cluster_id": "b5f72321-d879-4344-b131-82dc3d0c1704"
    },
    {
      "claim_cluster_id": "86a3a8f6-21a0-4e49-9c79-4c9d0cd896c5",
      "event_cluster_id": "4175d453-3f8e-438a-adde-113f24ef2a95"
    },
    {
      "claim_cluster_id": "1993c1c6-e677-4697-9e0d-f4c2332e53fe",
      "event_cluster_id": "41e9c8c9-45c4-4590-9393-a3b2281304ab"
    },
    {
      "claim_cluster_id": "a222dd36-fddd-41d8-956d-d735c7c4c6bb",
      "event_cluster_id": "db23d549-f792-47f2-bc74-2fff4db9d0ef"
    },
    {
      "claim_cluster_id": "0a173478-bf00-4e1f-be9a-c8305b945d9d",
      "event_cluster_id": "04568cc7-5dd8-42b7-8a07-715cdd043c03"
    },
    {
      "claim_cluster_id": "a38268fe-ba89-4d63-8481-63c080523a0a",
      "event_cluster_id": "0c639465-7159-40b2-869b-06840b83505a"
    },
    {
      "claim_cluster_id": "af51e97e-2570-48ba-a0bd-ab0668831da9",
      "event_cluster_id": "63ec2628-3b3a-4ba2-959d-d95266568ef5"
    },
    {
      "claim_cluster_id": "1e099dec-1be9-48be-a1bc-00d89e3cc02f",
      "event_cluster_id": "003a7d07-44de-4091-ae03-27e916ffcfa5"
    },
    {
      "claim_cluster_id": "bdd5143f-e24a-4ec7-81b7-681d3ac6b3f5",
      "event_cluster_id": "27391c49-b3b4-4f4d-98c5-cbe7a8ecbb05"
    },
    {
      "claim_cluster_id": "b39e93e4-b791-4b1e-963b-d8f068ff0b1d",
      "event_cluster_id": "4cbf95dd-29fa-442e-b9e9-93eb4878a93e"
    },
    {
      "claim_cluster_id": "ced45aa6-b370-4a79-b76b-674fcd6c0668",
      "event_cluster_id": "81d7440a-8ada-45a3-8b2c-8318c7034ac9"
    },
    {
      "claim_cluster_id": "ae58d35c-53bd-40b8-b6d5-7fe4e15e229a",
      "event_cluster_id": "e12630d6-f5b6-4dae-9bf0-63dd6b0528b1"
    },
    {
      "claim_cluster_id": "a7867a02-8602-4251-af70-d100ee635a74",
      "event_cluster_id": "04568cc7-5dd8-42b7-8a07-715cdd043c03"
    },
    {
      "claim_cluster_id": "c831921a-fda1-47ba-83e1-1042bd97f245",
      "event_cluster_id": "8621b776-3006-4d9b-93a8-f14394cb2f9a"
    },
    {
      "claim_cluster_id": "b2a26561-1192-4739-962b-b9df80083243",
      "event_cluster_id": "3aabf3aa-c1eb-4474-a134-a2e2ec8c19f6"
    },
    {
      "claim_cluster_id": "f9e580f2-a45e-455c-a4fc-189d643f07ef",
      "event_cluster_id": "a9a6169f-2727-47ff-8df7-1f0dc7eaba02"
    },
    {
      "claim_cluster_id": "07ec2e30-02bb-47d3-9b4c-32b7c841fb33",
      "event_cluster_id": "c623ca23-8a98-4b0e-b365-eb9b3c1cdd86"
    },
    {
      "claim_cluster_id": "1dd25bce-7fe6-46d2-9e28-e803262696c4",
      "event_cluster_id": "24c54796-afba-46ba-9bb2-8854f3d0747a"
    },
    {
      "claim_cluster_id": "2846d44d-8ccd-40e0-8486-7b360ffa4608",
      "event_cluster_id": "98561354-101e-4568-a2cb-77ee7e2819a1"
    },
    {
      "claim_cluster_id": "17312825-7f0f-4a66-81df-09fa5dfc119d",
      "event_cluster_id": "f7cbf601-ad96-47af-b877-ba63e1376028"
    },
    {
      "claim_cluster_id": "a6ed0ce8-662a-4b6a-bb37-1ea2a020377f",
      "event_cluster_id": "269ffe65-bf3c-4500-8f51-b6ef7e6175ed"
    },
    {
      "claim_cluster_id": "bbc740aa-eaf8-4e17-8ac4-4a0e0630c8cb",
      "event_cluster_id": "4a717901-15d3-4fa4-8697-e234613c348b"
    },
    {
      "claim_cluster_id": "419a274e-afb4-4935-a491-f22b25792b9a",
      "event_cluster_id": "5d32a56f-b7fc-4a53-885f-d83367218f7c"
    },
    {
      "claim_cluster_id": "695b3abb-f469-4406-b1ea-91e5eba8aa09",
      "event_cluster_id": "639a3221-3088-4eab-a13f-8485c80e01c5"
    },
    {
      "claim_cluster_id": "a73a6a4d-badd-44ae-bad7-f4b5ff5b95b4",
      "event_cluster_id": "04b259ed-8fea-44d2-9f92-3e357be663b0"
    },
    {
      "claim_cluster_id": "ab1842ba-5e92-4ba8-ab55-1241a116a859",
      "event_cluster_id": "2bf4835a-c2d9-4984-a011-415e8a457306"
    },
    {
      "claim_cluster_id": "9f57df89-5e8e-4a14-b028-a41d27973fb5",
      "event_cluster_id": "db101c75-2320-4597-b222-b7197dc49dc4"
    },
    {
      "claim_cluster_id": "f96fdbdd-0664-4366-b80c-72a8405c4f44",
      "event_cluster_id": "6aece148-00ae-441a-a570-cbee981c2154"
    },
    {
      "claim_cluster_id": "f61b95fd-4ab1-43f9-b2f8-53b5afb90d43",
      "event_cluster_id": "1fb31a41-f917-4cde-9190-f353f630be9a"
    },
    {
      "claim_cluster_id": "2b3c747b-9f75-4697-a22b-426999d9c671",
      "event_cluster_id": "356f0068-5f51-4299-8ed5-ccb151ae18bd"
    },
    {
      "claim_cluster_id": "2ac509be-786d-4ed0-abcc-15ecf7e6c4ff",
      "event_cluster_id": "7c34b0bc-12f1-458e-bef9-fafbba595b37"
    },
    {
      "claim_cluster_id": "64a10d09-a49c-4bf3-80db-a2cb3188afbc",
      "event_cluster_id": "93758357-874e-446c-984f-888b0a1aee47"
    },
    {
      "claim_cluster_id": "ed1fef35-ea22-4436-b53a-1dc1f0380298",
      "event_cluster_id": "93fda361-8597-486d-ac5b-c68926f25316"
    },
    {
      "claim_cluster_id": "91b0db25-32e4-4e5d-a32d-911732cbec28",
      "event_cluster_id": "4f9e8ff6-b5d4-43cf-8ca3-6775ebba3b38"
    },
    {
      "claim_cluster_id": "1bf7e0a5-55b7-4089-89cc-831b1626c195",
      "event_cluster_id": "90113fae-adfb-4eea-83c3-93afc851a256"
    },
    {
      "claim_cluster_id": "0f9ce830-116e-4bca-9110-b7d8c9c20025",
      "event_cluster_id": "2723b56b-92db-42cf-852c-6b9603282fde"
    },
    {
      "claim_cluster_id": "7924e4aa-9f0c-4bcf-8c0f-de382c8d6001",
      "event_cluster_id": "3fd5b7b8-68be-4404-8df3-9480731b7b5a"
    },
    {
      "claim_cluster_id": "8005aabd-f7d5-481c-b9d5-9e8d7ebacbd7",
      "event_cluster_id": "909f6739-4757-4400-a81c-4fdb3bbaad77"
    },
    {
      "claim_cluster_id": "ee1d7c5b-4d98-426c-bf43-b5350f89e9dc",
      "event_cluster_id": "c6804538-62b8-4db5-a60b-8ce1803df0aa"
    },
    {
      "claim_cluster_id": "9ec9965a-96db-46e5-965a-bc307986c26d",
      "event_cluster_id": "b5bf06a7-be5d-46a5-9294-d73dcb529f87"
    },
    {
      "claim_cluster_id": "ddbead60-bd17-4686-9b96-467aebde36fa",
      "event_cluster_id": "7050c8c6-a172-4da4-a04e-a8f348b2d49c"
    },
    {
      "claim_cluster_id": "db608ced-e4c3-4573-8b19-bacdf06c1585",
      "event_cluster_id": "19de02b2-6078-4f7b-9502-207e4c4f5e72"
    },
    {
      "claim_cluster_id": "d1f2b2ed-be0f-44a4-a171-4b848f482ca9",
      "event_cluster_id": "cfc7b0c0-e0dc-44d8-bb40-008b16bc6352"
    },
    {
      "claim_cluster_id": "391ac4c5-638b-42bc-b8d7-1972d56df43e",
      "event_cluster_id": "62c55243-573a-47e9-9c3f-afe131b6a01d"
    },
    {
      "claim_cluster_id": "93d03ec0-ac83-451a-87b2-a95e3d58859f",
      "event_cluster_id": "d67d9854-246c-464b-b04d-764da1ea0a72"
    },
    {
      "claim_cluster_id": "9fc7f408-c42c-485e-91c2-a72960ff3158",
      "event_cluster_id": "d6e4581d-8b56-4f44-aadb-7c57a4d3eb29"
    },
    {
      "claim_cluster_id": "1d3c5fb8-134e-4cb9-8e15-b1a4488a82ec",
      "event_cluster_id": "adb13810-0226-4fb2-9c77-e2af38089b83"
    },
    {
      "claim_cluster_id": "2bb3dd08-3d90-4e2f-a0e2-ecef371c599f",
      "event_cluster_id": "1a427c1e-6df0-4798-aa10-9a17d3c392c0"
    },
    {
      "claim_cluster_id": "f51d817f-9949-43cb-b16a-bfdefff947f1",
      "event_cluster_id": "08e45a86-d42e-4e87-9b56-30c3cd685d1d"
    },
    {
      "claim_cluster_id": "c81b3fac-f8f7-4824-a157-6d31dd48689f",
      "event_cluster_id": "3775dc56-2d8e-428a-9c60-ba993c0f4ba7"
    },
    {
      "claim_cluster_id": "5240d9cd-db46-4ffc-ae97-0e3a2b73b3fe",
      "event_cluster_id": "1c46973d-d9e6-4d0a-bc0b-63d9b4862b8d"
    },
    {
      "claim_cluster_id": "93f3d467-50ce-4038-8205-5814ad28dd43",
      "event_cluster_id": "73d00199-db31-4e40-9741-09d6ba45a825"
    },
    {
      "claim_cluster_id": "c83250c9-87a2-4ec5-822a-e2413ca91c91",
      "event_cluster_id": "03b2228f-a968-4a30-82e2-cd3ee126f59d"
    },
    {
      "claim_cluster_id": "3ae89f52-245d-458f-80e9-2534c0d80104",
      "event_cluster_id": "853910fb-7ee6-4070-a774-47b5fca3aae1"
    },
    {
      "claim_cluster_id": "c66251b2-ab53-4ca9-91b8-4229e4242200",
      "event_cluster_id": "af6d1e09-650d-4e43-84a3-10adfa5661af"
    },
    {
      "claim_cluster_id": "f3328626-3764-43c0-a7df-3730b34ea1fd",
      "event_cluster_id": "52b6d3e6-8588-4bb5-9bb9-34f52aa88349"
    },
    {
      "claim_cluster_id": "1a807d7d-9b68-443c-ad9d-52b339476997",
      "event_cluster_id": "558a2b97-08fd-422a-b638-0c14ba645eaf"
    },
    {
      "claim_cluster_id": "1ba178d9-d925-407c-bb75-60c655774cbf",
      "event_cluster_id": "0b109e58-1cde-4c32-aed4-12ba82ed273a"
    },
    {
      "claim_cluster_id": "847accaf-332c-4ec2-bd26-cd592d1fa2fc",
      "event_cluster_id": "baae4a32-5168-4c2e-a607-5bdb0996a9ff"
    },
    {
      "claim_cluster_id": "86e5843a-553f-41b4-aec2-73c2638e9bca",
      "event_cluster_id": "35f50160-5841-4836-b319-b5806e73bdd7"
    },
    {
      "claim_cluster_id": "d1c29947-a7e4-41cf-9656-837e51b2de11",
      "event_cluster_id": "ab04829a-0137-4a23-b438-5c3602157062"
    },
    {
      "claim_cluster_id": "734aba7a-e1ac-4a78-a926-3957017f7843",
      "event_cluster_id": "2f4e138b-a8ca-4c68-be26-24de0c3b0489"
    },
    {
      "claim_cluster_id": "5fec9a51-560a-4b1e-ab7c-cafcf47ba675",
      "event_cluster_id": "0bc0d2a3-3712-46e5-ad94-41178e22eb84"
    },
    {
      "claim_cluster_id": "c62acce0-70f2-44c3-9131-cec3cdb1f20f",
      "event_cluster_id": "3f3bad08-f439-4b69-b562-c041c5e9279a"
    },
    {
      "claim_cluster_id": "3c9c2d2f-29ac-414f-a514-d694db25f871",
      "event_cluster_id": "39cdd570-e38f-4085-a380-81de86fef8c0"
    },
    {
      "claim_cluster_id": "0d796efc-696b-45a8-bfd5-83987987e1ff",
      "event_cluster_id": "5014ba85-27bc-43f2-9c05-0160a5aa15c8"
    },
    {
      "claim_cluster_id": "8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0",
      "event_cluster_id": "0867ca4e-1775-4423-92bf-6fc8d1d9c0e3"
    },
    {
      "claim_cluster_id": "92aaa874-7a2f-4c08-bbfd-f1a7d3aa6923",
      "event_cluster_id": "acf3ef41-5374-4f21-834c-c4a11d955ee1"
    },
    {
      "claim_cluster_id": "83965363-a851-4083-ae10-33f90da464da",
      "event_cluster_id": "05ef45a3-5005-462b-9419-1640ee24156a"
    },
    {
      "claim_cluster_id": "868aacb9-ea8e-4ec3-a074-1e7f56bab03f",
      "event_cluster_id": "c99367c6-2c05-4a14-b047-7f8ff36ff133"
    },
    {
      "claim_cluster_id": "e8d873fb-d6bf-4c6b-9328-dabcc490fe91",
      "event_cluster_id": "6272f62e-bf00-43bc-ba48-d3f7c9c3ae02"
    },
    {
      "claim_cluster_id": "3e1e4180-7726-4298-9f55-4348fcd7185f",
      "event_cluster_id": "7dae31f7-fc93-4b4e-bd3c-7a87267ee2bd"
    },
    {
      "claim_cluster_id": "2a265a62-6ee2-460d-b6fd-ab72b8f23578",
      "event_cluster_id": "d58b9b87-81e0-4589-8f81-7f8c5e6a86d0"
    },
    {
      "claim_cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
      "event_cluster_id": "c3affceb-2e1f-45a4-b7f3-9c91184bd8cc"
    },
    {
      "claim_cluster_id": "d717bbe6-a62d-46c1-8d61-866b7d90a851",
      "event_cluster_id": "e5a54fcb-cbc0-4fb7-bfbf-7530efd090da"
    },
    {
      "claim_cluster_id": "8ef65ecd-3750-4a43-89ce-d81b333f2e1c",
      "event_cluster_id": "20d38dd5-1da5-4494-8238-6be550e715af"
    },
    {
      "claim_cluster_id": "5238def0-ccfb-4f27-b836-f20f9b7dd70b",
      "event_cluster_id": "ef92d248-d529-47e5-9160-de6bb70cfa68"
    },
    {
      "claim_cluster_id": "f3c74d17-b66b-49d5-9e91-ad7f843bbd39",
      "event_cluster_id": "2ed0e84f-d233-4164-b228-6208473d317d"
    },
    {
      "claim_cluster_id": "83ec8695-6d93-432e-a8be-81705e2e2a54",
      "event_cluster_id": "b7624371-4e42-4625-b287-29a35994c39a"
    },
    {
      "claim_cluster_id": "71baf4d7-69f3-4524-9166-04fc35b4043a",
      "event_cluster_id": "3ef30c78-2900-4b45-bca9-f6701289533c"
    },
    {
      "claim_cluster_id": "0c6c9e5b-f8cc-4939-8319-4baf55259b87",
      "event_cluster_id": "0761665f-c4f6-45c8-aeaf-2676ae75e917"
    },
    {
      "claim_cluster_id": "1ff73cd5-87d3-47be-9b40-e0da957f6ed3",
      "event_cluster_id": "651043d1-0d9f-42ac-bcb3-c7e39b7939ec"
    },
    {
      "claim_cluster_id": "cbd140c9-7dba-47e8-97c2-10198c9c38d7",
      "event_cluster_id": "82a95bd3-d7e2-43e8-9d25-fbbc664ac7bc"
    },
    {
      "claim_cluster_id": "2fc8ee47-5c74-46a4-91ea-72f94f9e2c27",
      "event_cluster_id": "c91f4478-001c-4706-a4cf-7da14de01daa"
    },
    {
      "claim_cluster_id": "d1f2b2ed-be0f-44a4-a171-4b848f482ca9",
      "event_cluster_id": "0228c164-28e2-4e5a-b2e8-2f3ba9a5fbf3"
    },
    {
      "claim_cluster_id": "ab378ec8-ca7a-473f-b276-44d546196e26",
      "event_cluster_id": "596b866e-0c38-462e-b0b0-eee502c092aa"
    },
    {
      "claim_cluster_id": "9d6f335e-c5fe-40ff-9edc-7ee5892fafaf",
      "event_cluster_id": "7e3a3ea2-4cff-4725-a3fd-ab0dbda0e13b"
    },
    {
      "claim_cluster_id": "a34f85b1-92bb-47d3-b089-7365f6b9f51f",
      "event_cluster_id": "91e856d9-7ba0-4d4e-ae44-31db4386dcaa"
    },
    {
      "claim_cluster_id": "0bb1f8c0-08c1-4f63-b6c8-052a5bad160c",
      "event_cluster_id": "35dec8e7-d2c1-441c-82d1-0fb7c4ff2ec4"
    },
    {
      "claim_cluster_id": "e8898157-febc-4868-87fa-8effb0a882e8",
      "event_cluster_id": "709632d6-c88d-494b-82c2-d5300f49d1cc"
    },
    {
      "claim_cluster_id": "7eefde16-5844-4305-a679-da87990a2640",
      "event_cluster_id": "f1e47970-325f-4291-8d1a-b29229c84e05"
    },
    {
      "claim_cluster_id": "ca0d3bae-6f1d-4857-b362-c7e7718bca04",
      "event_cluster_id": "7675ffec-ff62-4c58-a805-c5097a8fcd7e"
    },
    {
      "claim_cluster_id": "12c3a33b-fd70-46a3-a74c-86b922244369",
      "event_cluster_id": "3989418a-395d-4448-a748-f8cca55ad517"
    },
    {
      "claim_cluster_id": "a7b8095f-b682-4ca2-98b3-5d738490e008",
      "event_cluster_id": "676d848e-4839-407b-95b6-13d5d472f0e1"
    },
    {
      "claim_cluster_id": "da4e5cde-efc2-4363-87b4-b9935cc2b21d",
      "event_cluster_id": "a63f5d9a-cff2-4275-97b2-48d300df1ba7"
    },
    {
      "claim_cluster_id": "a5a6c59f-7670-4f97-9c2b-c94700d73131",
      "event_cluster_id": "25621853-a487-4563-8dfb-51e9404f5430"
    },
    {
      "claim_cluster_id": "00e4e855-edbf-4846-a824-47a6b221930a",
      "event_cluster_id": "c95d237e-c855-46b9-95fd-6b8f66d537c6"
    },
    {
      "claim_cluster_id": "da4807bf-cc54-48c7-b3ca-69cd854da837",
      "event_cluster_id": "fdc48ebe-c88c-4c2e-883d-95e1b09e9ec8"
    },
    {
      "claim_cluster_id": "7b83d3ee-13b2-47c1-ab89-4f78258a986b",
      "event_cluster_id": "0a6e93a7-4ca1-4ae8-937a-93b0852204d1"
    },
    {
      "claim_cluster_id": "d8b92399-bf69-4b82-b461-678acbb7e385",
      "event_cluster_id": "f3191f0a-3803-4bca-ad51-304e3f825638"
    },
    {
      "claim_cluster_id": "e9dd9d87-b75e-47a9-883f-9edb14ac1be2",
      "event_cluster_id": "3e66d569-f8f4-40ce-8d13-9d469cc2e340"
    },
    {
      "claim_cluster_id": "40c73517-1c90-43a5-bf9c-4b7cd5dc13c4",
      "event_cluster_id": "d94f565d-7abc-403c-b060-eaad0916c690"
    },
    {
      "claim_cluster_id": "ebf0120f-ec3a-4a71-bd2b-88f212264387",
      "event_cluster_id": "7e91212d-531e-468a-b19b-7f7bff3fda9d"
    },
    {
      "claim_cluster_id": "f22241ff-9c0f-458f-8a33-ea6c83aaafe6",
      "event_cluster_id": "65e251ce-15b5-4f60-b87b-ef28a1709b53"
    },
    {
      "claim_cluster_id": "5677f10d-93dc-4b72-b95a-8bc4291ec487",
      "event_cluster_id": "14aa16f3-35fc-4a1e-a17f-37a33c485e0a"
    },
    {
      "claim_cluster_id": "5e43acaf-f806-47d1-be89-f2ab3ad82bd7",
      "event_cluster_id": "a7ec7df3-d64e-4466-8dc5-ac899f0c0d28"
    },
    {
      "claim_cluster_id": "2e1084b1-c7f9-4543-8153-a6c840adb565",
      "event_cluster_id": "27cb0d3d-03d0-4c0b-8af4-dae39953059e"
    },
    {
      "claim_cluster_id": "f3328626-3764-43c0-a7df-3730b34ea1fd",
      "event_cluster_id": "1f48fb6b-ea22-46f3-a429-4b537e306680"
    },
    {
      "claim_cluster_id": "ed3519a5-2328-44c8-be3b-f36796b25965",
      "event_cluster_id": "7c8877ae-f397-490e-9778-67a6e91ebe1c"
    },
    {
      "claim_cluster_id": "4e78b61e-317a-4417-b42d-464646384193",
      "event_cluster_id": "cd51f6af-e3ac-4df3-b356-fdbeb2599d37"
    },
    {
      "claim_cluster_id": "0f3e5cb9-90ce-423e-bbb3-4a331e7ddd35",
      "event_cluster_id": "914330e6-94a6-406b-a8f3-ed188765a7fb"
    },
    {
      "claim_cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "event_cluster_id": "50647687-d65a-47e2-b9a1-a4bddf5f53cc"
    },
    {
      "claim_cluster_id": "0511fc3f-517e-42e7-84fc-34ea436b847d",
      "event_cluster_id": "291420ab-2571-4d49-863c-5554d504b9b7"
    },
    {
      "claim_cluster_id": "623ab1ae-1f19-46fc-b19b-929f64c7b525",
      "event_cluster_id": "b2f25ba2-9f04-4c71-9e8b-d9b021ed7e8a"
    },
    {
      "claim_cluster_id": "197fe725-a0a9-40f8-a6e9-956dd052b066",
      "event_cluster_id": "44955a88-3ba0-46cf-ac7e-906798513ae4"
    },
    {
      "claim_cluster_id": "d8515ae8-12a5-4f84-b01f-bc10b41b19e0",
      "event_cluster_id": "780710ee-898c-4548-a5aa-7eb3c45e169a"
    },
    {
      "claim_cluster_id": "693ef972-4622-4c6c-9268-e5c6a072dd31",
      "event_cluster_id": "d3262128-2dca-4e39-baaf-d15bcec2979d"
    },
    {
      "claim_cluster_id": "5d4f6733-5fbd-48ce-8468-590ebda279c7",
      "event_cluster_id": "7a2f4f21-3ae3-4d01-b8e3-e3fd8670db5a"
    },
    {
      "claim_cluster_id": "1f8ce922-0e37-4ccb-b586-67da18764d96",
      "event_cluster_id": "27a5d354-dacf-469b-b094-7b2ad6fec31b"
    },
    {
      "claim_cluster_id": "06b2f52b-0581-493e-b81d-57ece9f33f27",
      "event_cluster_id": "8e5823ae-a392-4999-814a-2dee24b2385d"
    },
    {
      "claim_cluster_id": "34e53235-60e8-4299-9389-633db39ab300",
      "event_cluster_id": "4e138416-b193-43f0-bd9a-8249fe6a1748"
    },
    {
      "claim_cluster_id": "2b9508d5-4552-4994-840b-08ab461e29c3",
      "event_cluster_id": "078eb0c7-fae2-4ffa-b527-48c6683af72e"
    },
    {
      "claim_cluster_id": "55a53a4b-b30c-483d-9f7b-8c999d5c2f62",
      "event_cluster_id": "46812bda-c4dc-4bd2-a7c0-e250a28da359"
    },
    {
      "claim_cluster_id": "c7d861d7-3b33-4585-89d3-87c9dcbcd126",
      "event_cluster_id": "6ff7ccd9-f022-43dd-91cb-c864da8c63c2"
    },
    {
      "claim_cluster_id": "ade8c501-ccec-40ec-b096-cd50cd90be07",
      "event_cluster_id": "c570bea5-83d0-40f8-b228-3cf401722ac2"
    },
    {
      "claim_cluster_id": "a222dd36-fddd-41d8-956d-d735c7c4c6bb",
      "event_cluster_id": "2f8dc773-32fe-42ed-a085-3a10ca61c22d"
    },
    {
      "claim_cluster_id": "30bb9166-b600-41f8-a7cf-3befaaa1bcc2",
      "event_cluster_id": "bba407f7-696a-4116-b4f2-8e58c881a810"
    },
    {
      "claim_cluster_id": "0950755f-651f-455e-a7d5-47091afd7de2",
      "event_cluster_id": "a28912c7-742b-4153-9606-e82158276aad"
    },
    {
      "claim_cluster_id": "e88c49ad-3df2-4059-82e4-46d0f3b59757",
      "event_cluster_id": "aead4c3f-44a7-4ce8-91b4-79e0aadcc982"
    },
    {
      "claim_cluster_id": "9fc7edf3-7209-4828-92b3-8d6dafded201",
      "event_cluster_id": "2f4e138b-a8ca-4c68-be26-24de0c3b0489"
    },
    {
      "claim_cluster_id": "e20ec3dc-5039-4e9b-be7d-622592bf425d",
      "event_cluster_id": "74eb8465-812a-44ef-8d54-8544ae40c871"
    },
    {
      "claim_cluster_id": "bbf7e3f8-0935-42e4-be8f-f83ab82b1a5a",
      "event_cluster_id": "a8f2c86c-3f8d-4f00-beaf-d0d6fffceae8"
    },
    {
      "claim_cluster_id": "c9534331-e465-4cc5-951b-fa24c4cd75bf",
      "event_cluster_id": "f18636a0-1641-41b0-92a8-1218e6cdd54a"
    },
    {
      "claim_cluster_id": "9ee9fc47-27b6-4828-a30b-bd52c92ccfae",
      "event_cluster_id": "a63f5d9a-cff2-4275-97b2-48d300df1ba7"
    },
    {
      "claim_cluster_id": "68357dc5-3396-4365-90bb-f3b36dcbd7e4",
      "event_cluster_id": "43fafa8a-6241-480f-aa40-04f420f4ea5e"
    },
    {
      "claim_cluster_id": "8d8dbda6-96b3-4738-b7a8-777f920a39be",
      "event_cluster_id": "fa02e97b-06d3-4b6b-83c2-ad956c6a8f2a"
    },
    {
      "claim_cluster_id": "ed42b61a-7c55-44a7-aac6-78560e6e139e",
      "event_cluster_id": "27b6b422-e78d-44a0-8d01-c53970357062"
    },
    {
      "claim_cluster_id": "3fc70d09-8a93-4a60-b903-b03cd4187227",
      "event_cluster_id": "e9f5a5d3-fb2d-448b-ab54-b718baa4bcab"
    },
    {
      "claim_cluster_id": "8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9",
      "event_cluster_id": "ec68f63c-4291-4d49-8068-2a2cf1250591"
    },
    {
      "claim_cluster_id": "e0d4056d-6cdc-4a90-ba78-5aecf0b2092e",
      "event_cluster_id": "d5f8926c-cfe4-4355-8a20-781d575d7616"
    },
    {
      "claim_cluster_id": "6695efed-b1b5-4469-a01b-a370dfb9c522",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "585ea825-312e-47cf-9ba6-332afbfb9ed5",
      "event_cluster_id": "0400977a-dea9-4fe6-a6a6-61f4575e07a9"
    },
    {
      "claim_cluster_id": "843bcba9-c863-41a3-a76f-01fd61d56529",
      "event_cluster_id": "db3b032b-6eb1-469a-8fea-f26d907c46cc"
    },
    {
      "claim_cluster_id": "b473cdd9-7369-4866-a926-04d86eb03c52",
      "event_cluster_id": "b105a78c-297b-4eaf-9891-43407b9d8073"
    },
    {
      "claim_cluster_id": "d7623a03-cd91-4c2e-b68a-db4e5ad54fa8",
      "event_cluster_id": "5f8e4ee6-3418-4c1b-b296-a4a89ae25c1b"
    },
    {
      "claim_cluster_id": "05302999-a145-4cb2-83a6-b2cda0247938",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "0686ff31-e224-48f2-ad84-a11eff3d54be",
      "event_cluster_id": "cd8525ab-90a4-434a-bf10-f887240219f2"
    },
    {
      "claim_cluster_id": "45d5305e-53a9-4659-a1a0-2bf0495c5055",
      "event_cluster_id": "d6c8b67e-0b10-44df-8f54-3d630f15c443"
    },
    {
      "claim_cluster_id": "74ac8dc6-1d9b-435b-bae9-36745f271604",
      "event_cluster_id": "9bdfdf22-7c63-4c9e-aaa0-b66cd67a0424"
    },
    {
      "claim_cluster_id": "09e579b4-c608-4bc3-a02e-890bc6f5969d",
      "event_cluster_id": "6aa1529b-b06b-446b-af24-0e7a95f9cc1a"
    },
    {
      "claim_cluster_id": "29d5756f-2c13-4cfb-b4e4-f439665752b9",
      "event_cluster_id": "7cf8a49b-ec7b-4a56-af2a-3a198e9863e9"
    },
    {
      "claim_cluster_id": "ab24b6cb-fc70-48c9-8ee3-224b83a66b11",
      "event_cluster_id": "08d02125-b1b5-40ee-8104-05de8b37f965"
    },
    {
      "claim_cluster_id": "87e51e32-d441-41a9-8026-a751a57b0ed2",
      "event_cluster_id": "335924d4-8c81-4bf0-8e93-746bc3bcb081"
    },
    {
      "claim_cluster_id": "a3cec669-c5d7-49cf-9b41-ed9298b7642a",
      "event_cluster_id": "3bbfdf4b-7f9b-4300-9c99-cecf5843d988"
    },
    {
      "claim_cluster_id": "95f30627-ec05-45c4-9f6e-28dd5c31e412",
      "event_cluster_id": "cdf7dd0c-6255-42a0-bfbe-5e3b3bbee744"
    },
    {
      "claim_cluster_id": "7bf63345-7700-41f7-861e-b298dc68ad2d",
      "event_cluster_id": "20d38dd5-1da5-4494-8238-6be550e715af"
    },
    {
      "claim_cluster_id": "35ee8064-f9ff-4496-b4db-ba79f7f24de2",
      "event_cluster_id": "3777e13c-2b9f-4604-9213-bea685bd3add"
    },
    {
      "claim_cluster_id": "ab378ec8-ca7a-473f-b276-44d546196e26",
      "event_cluster_id": "58160b77-275a-49fd-b4ad-b9a4e0aa40ef"
    },
    {
      "claim_cluster_id": "8b9bfa02-ad08-43cb-8fde-4c8e8a7538e9",
      "event_cluster_id": "05374434-df8d-4b22-b660-0ddc27139765"
    },
    {
      "claim_cluster_id": "88f4c27e-7029-43e0-805c-44699284d312",
      "event_cluster_id": "4efb4906-b539-4d71-8685-b4bd14aad476"
    },
    {
      "claim_cluster_id": "3e1e4180-7726-4298-9f55-4348fcd7185f",
      "event_cluster_id": "8ee8c1bb-0d20-4333-9bfd-60f5cae2d370"
    },
    {
      "claim_cluster_id": "c62acce0-70f2-44c3-9131-cec3cdb1f20f",
      "event_cluster_id": "ab143717-868d-4925-a6b6-6698ea0e9c74"
    },
    {
      "claim_cluster_id": "ca129396-101c-429f-8530-fe05aaa1c7cf",
      "event_cluster_id": "57a7f42b-2dcf-44e0-9ea2-209e7a77b9d9"
    },
    {
      "claim_cluster_id": "186330e2-1680-455d-ad21-27f2e0125a31",
      "event_cluster_id": "7c3363eb-6e57-40c6-934c-69f3d1e89801"
    },
    {
      "claim_cluster_id": "8a0c21a3-b47c-4676-b965-59f7699171ec",
      "event_cluster_id": "a7539db4-dfef-469c-b96d-9b13762fd242"
    },
    {
      "claim_cluster_id": "8cd21a65-53a7-4164-afb0-f8d7a3ca3ca6",
      "event_cluster_id": "1118439e-1d54-4e33-bac7-0813c7dbb103"
    },
    {
      "claim_cluster_id": "f61b95fd-4ab1-43f9-b2f8-53b5afb90d43",
      "event_cluster_id": "9b965f11-f5af-4e06-af27-db2a333f5008"
    },
    {
      "claim_cluster_id": "510b63b0-aea2-446d-8868-5c88431cc9fe",
      "event_cluster_id": "b995b076-2b5f-4341-abf4-0732ccee4318"
    },
    {
      "claim_cluster_id": "e35fb8e9-42cf-4ef0-a512-d7be06ad99e3",
      "event_cluster_id": "97ff7137-390e-43dc-9ab5-05c730068c02"
    },
    {
      "claim_cluster_id": "a8c4b29d-3d45-4e5e-b6ef-06f93957d16a",
      "event_cluster_id": "15b6ae6c-1463-4a8d-9552-d2739588b3e7"
    },
    {
      "claim_cluster_id": "8ef65ecd-3750-4a43-89ce-d81b333f2e1c",
      "event_cluster_id": "816b9948-b1f0-46c8-b6a3-18e652cd3289"
    },
    {
      "claim_cluster_id": "5272bbda-d47a-4619-a956-853dc9c29d18",
      "event_cluster_id": "d80ef34a-3b0a-4891-bbe5-d2c01cec1b04"
    },
    {
      "claim_cluster_id": "45d5305e-53a9-4659-a1a0-2bf0495c5055",
      "event_cluster_id": "164a85e9-df51-43f2-948d-bd9852808931"
    },
    {
      "claim_cluster_id": "1a660b55-5f53-4246-a227-98df9e4e2ac4",
      "event_cluster_id": "c6d9c90d-92a1-44da-a5cd-12164b95f4d8"
    },
    {
      "claim_cluster_id": "ed7e3755-29e6-4b64-b965-226f2c61a6d0",
      "event_cluster_id": "b3562e1f-34d6-4a29-b778-8824a2d004a7"
    },
    {
      "claim_cluster_id": "ad83e0a6-e572-4332-8ef0-01e05cdfa760",
      "event_cluster_id": "7eafb3e8-a45a-4448-82d1-c800c85a832e"
    },
    {
      "claim_cluster_id": "e21ec8bb-ddf8-4115-9765-9a2f72eed10d",
      "event_cluster_id": "728de5c6-3345-44e8-91f4-5ab1fb0c6670"
    },
    {
      "claim_cluster_id": "7966aa4e-476b-473f-85ad-b267835811ed",
      "event_cluster_id": "a722bc41-1d66-412e-b713-184ed31bb855"
    },
    {
      "claim_cluster_id": "8f9f1940-08f3-4a29-938e-790645f67487",
      "event_cluster_id": "923eb3f0-4a80-4604-845d-2264e5473406"
    },
    {
      "claim_cluster_id": "b6ac4f42-6e4c-4395-a71a-c8beca5b5336",
      "event_cluster_id": "2ed0e84f-d233-4164-b228-6208473d317d"
    },
    {
      "claim_cluster_id": "752a6b2b-a9aa-4a80-b345-6a1e96c0ac0c",
      "event_cluster_id": "344ea9a5-7537-47d1-9d63-57fb7fadc321"
    },
    {
      "claim_cluster_id": "beba9a76-4058-465a-8f4e-bc79ccf7a03f",
      "event_cluster_id": "d9a77a4d-52c1-4a0d-b32b-684c4aa1d380"
    },
    {
      "claim_cluster_id": "9867a541-4a4c-449d-a4af-a0263f8d23fb",
      "event_cluster_id": "fbce63cc-2f89-4118-a74f-d93b0d57a756"
    },
    {
      "claim_cluster_id": "2052af74-0bc8-401c-a911-035e4f5f65d2",
      "event_cluster_id": "4ab5e1f1-d0b4-460e-98c6-70b27ad80057"
    },
    {
      "claim_cluster_id": "48358541-e77a-4c9f-81e2-7af006f34920",
      "event_cluster_id": "2d8d907a-2ce9-4878-ba6b-55a8ba564f43"
    },
    {
      "claim_cluster_id": "c298484d-a7d5-4e80-ac66-217221dc6d85",
      "event_cluster_id": "9964a330-c7c3-4cd3-bf33-0b48084f4337"
    },
    {
      "claim_cluster_id": "c1308dd1-2ebf-4164-b9e3-2284bbfb088b",
      "event_cluster_id": "fc72359d-8e34-4b21-8fce-8279f0329c9c"
    },
    {
      "claim_cluster_id": "ca129396-101c-429f-8530-fe05aaa1c7cf",
      "event_cluster_id": "60d688f1-af0a-4245-9b4c-47a36b4f063c"
    },
    {
      "claim_cluster_id": "791c0550-4877-4364-97d4-01b5b8435b0f",
      "event_cluster_id": "2b4c9e75-4679-4e5b-8a08-08bb2c621974"
    },
    {
      "claim_cluster_id": "0f3e5cb9-90ce-423e-bbb3-4a331e7ddd35",
      "event_cluster_id": "182eb8ff-4f9c-4649-b5f9-31b5022006bd"
    },
    {
      "claim_cluster_id": "07f06451-8b9c-4bc8-9f61-1661511a83c3",
      "event_cluster_id": "add21509-fc05-4fe6-a953-c98cc222477e"
    },
    {
      "claim_cluster_id": "df895ffb-5333-4b2a-9ce5-f1108a894c34",
      "event_cluster_id": "e81e68ae-4e8a-4aef-a358-1455ad08bdc4"
    },
    {
      "claim_cluster_id": "5c533a3e-46e0-4800-bdb7-5c1521efbb3d",
      "event_cluster_id": "5eed6894-bd6e-4276-a4e0-693ad381c55c"
    },
    {
      "claim_cluster_id": "7a19ea0d-56c4-4a0e-97b2-22abda1aaaf1",
      "event_cluster_id": "22b52102-7c44-49d2-93e5-9785e4c6b4d0"
    },
    {
      "claim_cluster_id": "c7b90480-a4e5-4b5f-b840-fe13ad140b52",
      "event_cluster_id": "1e061f92-2688-4d15-8cdc-93767b97df6b"
    },
    {
      "claim_cluster_id": "6b22978f-c41a-4fd1-ac4e-29deafe60573",
      "event_cluster_id": "eb796d64-358d-4578-ad2f-2c3665e77d5e"
    },
    {
      "claim_cluster_id": "64b06601-97a9-452d-80ca-13c5f92ae356",
      "event_cluster_id": "0d311305-9085-42d3-8548-48b9fa06ff66"
    },
    {
      "claim_cluster_id": "04fd43b1-9ee7-43b3-b1fc-e9fca576658d",
      "event_cluster_id": "14b07b58-6d89-4f8a-8ddc-8c0a902ee333"
    },
    {
      "claim_cluster_id": "b0071c15-10b9-4a75-8b7f-486b9f2c04d1",
      "event_cluster_id": "cc939ca4-cdd3-4b86-b937-1aee89162501"
    },
    {
      "claim_cluster_id": "3e19b24f-ae64-464a-8536-97bf58aecdc0",
      "event_cluster_id": "b32b2c04-03a9-4e04-93d0-499cf1aa4cc2"
    },
    {
      "claim_cluster_id": "4908cf56-f8a6-4b01-88c6-2c59a4acac65",
      "event_cluster_id": "f3a349ff-3152-4d09-b280-f92890a46edf"
    },
    {
      "claim_cluster_id": "d63b1ded-8126-4556-8052-238b4f8872c9",
      "event_cluster_id": "56102e40-6707-4ea5-b706-a21ac4c3fa0a"
    },
    {
      "claim_cluster_id": "43784351-864b-42c8-bac5-2de22a3743c2",
      "event_cluster_id": "d6c38bd4-e404-4cb6-beee-cca25c7586ab"
    },
    {
      "claim_cluster_id": "2c72a6d8-6edd-4d3a-9563-d326950bc8da",
      "event_cluster_id": "2d202c5c-9305-4705-93d0-1781607fb294"
    },
    {
      "claim_cluster_id": "1e256780-a5db-4471-b8f2-5390a4dea1fb",
      "event_cluster_id": "73478ef3-3b02-4aa4-bc0d-55174048efc5"
    },
    {
      "claim_cluster_id": "8806403a-c610-4055-9744-edc72cda745d",
      "event_cluster_id": "669c3dae-6d04-400f-a1f0-a3b10120d902"
    },
    {
      "claim_cluster_id": "06b8ffc7-c987-44a2-a2cb-8721e54e7da6",
      "event_cluster_id": "4b3edb14-747e-4c77-8e76-8b7c1d8c4155"
    },
    {
      "claim_cluster_id": "6b22978f-c41a-4fd1-ac4e-29deafe60573",
      "event_cluster_id": "f564df6d-d60b-407b-b65a-d63d691e5edc"
    },
    {
      "claim_cluster_id": "57bfc89a-d981-44e9-a425-3364b9a5bc24",
      "event_cluster_id": "c4a1de41-721e-4875-aa51-4449e3df85ed"
    },
    {
      "claim_cluster_id": "407486e4-c133-4139-9739-41644f65fa24",
      "event_cluster_id": "30b7ce37-8fca-4fe2-b499-bda00e36d905"
    },
    {
      "claim_cluster_id": "55bc595b-aea0-4d83-938e-9ae3ab116813",
      "event_cluster_id": "23e0381e-2d65-4ba4-b3df-e26366f32cbc"
    },
    {
      "claim_cluster_id": "4d26523d-9b0e-4ea3-b0c0-0a6dc6281f23",
      "event_cluster_id": "ed8ee9d8-3361-4c66-86fb-3b0c6210300d"
    },
    {
      "claim_cluster_id": "b4295bad-3940-4b00-ac2b-862c41b5597c",
      "event_cluster_id": "100607e4-097e-42a6-9233-9486abc1cf03"
    },
    {
      "claim_cluster_id": "7187c5ae-6f6b-4c6a-af65-98db1f5251db",
      "event_cluster_id": "11da9fb2-c834-4c00-97b5-9d0eb78a5f81"
    },
    {
      "claim_cluster_id": "066e0772-a7cc-411e-9810-7c9b5b3dd73f",
      "event_cluster_id": "9f64a0ee-1ff6-468b-9bf7-001ce2c6ea58"
    },
    {
      "claim_cluster_id": "b835c70a-6e2a-4461-9396-aa47cc9d876c",
      "event_cluster_id": "985525fb-882c-4e38-8f11-fa12ae906da0"
    },
    {
      "claim_cluster_id": "7afd3ded-a43a-4c9d-b365-6656ecd89e6f",
      "event_cluster_id": "eda41dea-1eaf-4dc5-ae84-f7a6a29eea13"
    },
    {
      "claim_cluster_id": "e968bf8c-b2a8-4330-bf71-9cab4f6826a5",
      "event_cluster_id": "9bfae508-3289-4175-a44f-b761d47a58ba"
    },
    {
      "claim_cluster_id": "5b79e5f7-f49f-4b4e-b9a7-5554797ebbeb",
      "event_cluster_id": "31b9f704-925c-4bf2-9f0b-e88e81f1b10a"
    },
    {
      "claim_cluster_id": "8bf1bcf6-951c-4e29-9359-e8cd5a8ca3b0",
      "event_cluster_id": "9bba558d-53eb-42ad-851e-623ab4e32bc6"
    },
    {
      "claim_cluster_id": "b8299ae1-9e2e-465d-af82-b9354f3e9c44",
      "event_cluster_id": "f8ebc28b-35f4-46bd-95af-d6b109203645"
    },
    {
      "claim_cluster_id": "81fee6b1-629b-42a7-9a8d-c4a3008f59e3",
      "event_cluster_id": "7370dfbb-74ea-4d34-82b7-9398b71ecd5a"
    },
    {
      "claim_cluster_id": "0acd3055-185c-4d22-ad5f-a587ee5adc40",
      "event_cluster_id": "4e19d3ba-e1e5-4cca-bd19-4ed9b55c567c"
    },
    {
      "claim_cluster_id": "5d276603-9c3a-417d-bd11-e8b613249dd5",
      "event_cluster_id": "dbe1780e-f93d-4eae-8780-d2a73e00ae56"
    },
    {
      "claim_cluster_id": "53963e43-0740-4b21-afdf-6b0bd3da400f",
      "event_cluster_id": "7d4d7620-64de-4dcb-824e-188535febe26"
    },
    {
      "claim_cluster_id": "5ac433e4-bd1e-455d-8c24-e981eb354d77",
      "event_cluster_id": "8628cfa7-1952-4304-94e8-eca8c125fadb"
    }
  ]
}